/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(1947);
	module.exports = __webpack_require__(490);


/***/ },
/* 1 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(94);


/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SvgIcon = __webpack_require__(850);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SvgIcon2.default;

/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shouldUpdate = __webpack_require__(1981);
	
	var _shouldUpdate2 = _interopRequireDefault(_shouldUpdate);
	
	var _shallowEqual = __webpack_require__(68);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _setDisplayName = __webpack_require__(432);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(433);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pure = function pure(BaseComponent) {
	  var hoc = (0, _shouldUpdate2.default)(function (props, nextProps) {
	    return !(0, _shallowEqual2.default)(props, nextProps);
	  });
	
	  if (false) {
	    return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'pure'))(hoc(BaseComponent));
	  }
	
	  return hoc(BaseComponent);
	};
	
	exports.default = pure;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
	    Symbol.for &&
	    Symbol.for('react.element')) ||
	    0xeac7;
	
	  var isValidElement = function(object) {
	    return typeof object === 'object' &&
	      object !== null &&
	      object.$$typeof === REACT_ELEMENT_TYPE;
	  };
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(isValidElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(1849)();
	}


/***/ },
/* 5 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(162);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(510), __esModule: true };

/***/ },
/* 8 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _setPrototypeOf = __webpack_require__(493);
	
	var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);
	
	var _create = __webpack_require__(492);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _typeof2 = __webpack_require__(69);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
	  }
	
	  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      enumerable: false,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
	};

/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _typeof2 = __webpack_require__(69);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (self, call) {
	  if (!self) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
	};

/***/ },
/* 10 */
/***/ function(module, exports) {

	module.exports = function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	  return target;
	};


/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _assign = __webpack_require__(253);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _assign2.default || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};

/***/ },
/* 12 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	exports.default = function (obj, keys) {
	  var target = {};
	
	  for (var i in obj) {
	    if (keys.indexOf(i) >= 0) continue;
	    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
	    target[i] = obj[i];
	  }
	
	  return target;
	};

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var validateFormat = function validateFormat(format) {};
	
	if (false) {
	  validateFormat = function validateFormat(format) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  };
	}
	
	function invariant(condition, format, a, b, c, d, e, f) {
	  validateFormat(format);
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(format.replace(/%s/g, function () {
	        return args[argIndex++];
	      }));
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	}
	
	module.exports = invariant;

/***/ },
/* 14 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  easeOutFunction: 'cubic-bezier(0.23, 1, 0.32, 1)',
	  easeInOutFunction: 'cubic-bezier(0.445, 0.05, 0.55, 0.95)',
	
	  easeOut: function easeOut(duration, property, delay, easeFunction) {
	    easeFunction = easeFunction || this.easeOutFunction;
	
	    if (property && Object.prototype.toString.call(property) === '[object Array]') {
	      var transitions = '';
	      for (var i = 0; i < property.length; i++) {
	        if (transitions) transitions += ',';
	        transitions += this.create(duration, property[i], delay, easeFunction);
	      }
	
	      return transitions;
	    } else {
	      return this.create(duration, property, delay, easeFunction);
	    }
	  },
	  create: function create(duration, property, delay, easeFunction) {
	    duration = duration || '450ms';
	    property = property || 'all';
	    delay = delay || '0ms';
	    easeFunction = easeFunction || 'linear';
	
	    return property + ' ' + duration + ' ' + easeFunction + ' ' + delay;
	  }
	};

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2014-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = function() {};
	
	if (false) {
	  warning = function(condition, format, args) {
	    var len = arguments.length;
	    args = new Array(len > 2 ? len - 2 : 0);
	    for (var key = 2; key < len; key++) {
	      args[key - 2] = arguments[key];
	    }
	    if (format === undefined) {
	      throw new Error(
	        '`warning(condition, format, ...args)` requires a warning ' +
	        'message argument'
	      );
	    }
	
	    if (format.length < 10 || (/^[s\W]*$/).test(format)) {
	      throw new Error(
	        'The warning format should be able to uniquely identify this ' +
	        'warning. Please, use a more descriptive format than: ' + format
	      );
	    }
	
	    if (!condition) {
	      var argIndex = 0;
	      var message = 'Warning: ' +
	        format.replace(/%s/g, function() {
	          return args[argIndex++];
	        });
	      if (typeof console !== 'undefined') {
	        console.error(message);
	      }
	      try {
	        // This error was thrown as a convenience so that you can use this stack
	        // to find the callsite that caused this warning to fire.
	        throw new Error(message);
	      } catch(x) {}
	    }
	  };
	}
	
	module.exports = warning;


/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var warning = emptyFunction;
	
	if (false) {
	  var printWarning = function printWarning(format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.error(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  warning = function warning(condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	
	    if (format.indexOf('Failed Composite propType: ') === 0) {
	      return; // Ignore CompositeComponent proptype check.
	    }
	
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = warning;

/***/ },
/* 17 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	'use strict';
	
	/**
	 * WARNING: DO NOT manually require this module.
	 * This is a replacement for `invariant(...)` used by the error code system
	 * and will _only_ be required by the corresponding babel pass.
	 * It always throws.
	 */
	
	function reactProdInvariant(code) {
	  var argCount = arguments.length - 1;
	
	  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;
	
	  for (var argIdx = 0; argIdx < argCount; argIdx++) {
	    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
	  }
	
	  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';
	
	  var error = new Error(message);
	  error.name = 'Invariant Violation';
	  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame
	
	  throw error;
	}
	
	module.exports = reactProdInvariant;

/***/ },
/* 18 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = __webpack_require__(1866);


/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var DOMProperty = __webpack_require__(89);
	var ReactDOMComponentFlags = __webpack_require__(397);
	
	var invariant = __webpack_require__(13);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var Flags = ReactDOMComponentFlags;
	
	var internalInstanceKey = '__reactInternalInstance$' + Math.random().toString(36).slice(2);
	
	/**
	 * Check if a given node should be cached.
	 */
	function shouldPrecacheNode(node, nodeID) {
	  return node.nodeType === 1 && node.getAttribute(ATTR_NAME) === String(nodeID) || node.nodeType === 8 && node.nodeValue === ' react-text: ' + nodeID + ' ' || node.nodeType === 8 && node.nodeValue === ' react-empty: ' + nodeID + ' ';
	}
	
	/**
	 * Drill down (through composites and empty components) until we get a host or
	 * host text component.
	 *
	 * This is pretty polymorphic but unavoidable with the current structure we have
	 * for `_renderedChildren`.
	 */
	function getRenderedHostOrTextFromComponent(component) {
	  var rendered;
	  while (rendered = component._renderedComponent) {
	    component = rendered;
	  }
	  return component;
	}
	
	/**
	 * Populate `_hostNode` on the rendered host/text component with the given
	 * DOM node. The passed `inst` can be a composite.
	 */
	function precacheNode(inst, node) {
	  var hostInst = getRenderedHostOrTextFromComponent(inst);
	  hostInst._hostNode = node;
	  node[internalInstanceKey] = hostInst;
	}
	
	function uncacheNode(inst) {
	  var node = inst._hostNode;
	  if (node) {
	    delete node[internalInstanceKey];
	    inst._hostNode = null;
	  }
	}
	
	/**
	 * Populate `_hostNode` on each child of `inst`, assuming that the children
	 * match up with the DOM (element) children of `node`.
	 *
	 * We cache entire levels at once to avoid an n^2 problem where we access the
	 * children of a node sequentially and have to walk from the start to our target
	 * node every time.
	 *
	 * Since we update `_renderedChildren` and the actual DOM at (slightly)
	 * different times, we could race here and see a newer `_renderedChildren` than
	 * the DOM nodes we see. To avoid this, ReactMultiChild calls
	 * `prepareToManageChildren` before we change `_renderedChildren`, at which
	 * time the container's child nodes are always cached (until it unmounts).
	 */
	function precacheChildNodes(inst, node) {
	  if (inst._flags & Flags.hasCachedChildNodes) {
	    return;
	  }
	  var children = inst._renderedChildren;
	  var childNode = node.firstChild;
	  outer: for (var name in children) {
	    if (!children.hasOwnProperty(name)) {
	      continue;
	    }
	    var childInst = children[name];
	    var childID = getRenderedHostOrTextFromComponent(childInst)._domID;
	    if (childID === 0) {
	      // We're currently unmounting this child in ReactMultiChild; skip it.
	      continue;
	    }
	    // We assume the child nodes are in the same order as the child instances.
	    for (; childNode !== null; childNode = childNode.nextSibling) {
	      if (shouldPrecacheNode(childNode, childID)) {
	        precacheNode(childInst, childNode);
	        continue outer;
	      }
	    }
	    // We reached the end of the DOM children without finding an ID match.
	     true ?  false ? invariant(false, 'Unable to find element with ID %s.', childID) : _prodInvariant('32', childID) : void 0;
	  }
	  inst._flags |= Flags.hasCachedChildNodes;
	}
	
	/**
	 * Given a DOM node, return the closest ReactDOMComponent or
	 * ReactDOMTextComponent instance ancestor.
	 */
	function getClosestInstanceFromNode(node) {
	  if (node[internalInstanceKey]) {
	    return node[internalInstanceKey];
	  }
	
	  // Walk up the tree until we find an ancestor whose instance we have cached.
	  var parents = [];
	  while (!node[internalInstanceKey]) {
	    parents.push(node);
	    if (node.parentNode) {
	      node = node.parentNode;
	    } else {
	      // Top of the tree. This node must not be part of a React tree (or is
	      // unmounted, potentially).
	      return null;
	    }
	  }
	
	  var closest;
	  var inst;
	  for (; node && (inst = node[internalInstanceKey]); node = parents.pop()) {
	    closest = inst;
	    if (parents.length) {
	      precacheChildNodes(inst, node);
	    }
	  }
	
	  return closest;
	}
	
	/**
	 * Given a DOM node, return the ReactDOMComponent or ReactDOMTextComponent
	 * instance, or null if the node was not rendered by this React.
	 */
	function getInstanceFromNode(node) {
	  var inst = getClosestInstanceFromNode(node);
	  if (inst != null && inst._hostNode === node) {
	    return inst;
	  } else {
	    return null;
	  }
	}
	
	/**
	 * Given a ReactDOMComponent or ReactDOMTextComponent, return the corresponding
	 * DOM node.
	 */
	function getNodeFromInstance(inst) {
	  // Without this first invariant, passing a non-DOM-component triggers the next
	  // invariant for a missing parent, which is super confusing.
	  !(inst._hostNode !== undefined) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  if (inst._hostNode) {
	    return inst._hostNode;
	  }
	
	  // Walk up the tree until we find an ancestor whose DOM node we have cached.
	  var parents = [];
	  while (!inst._hostNode) {
	    parents.push(inst);
	    !inst._hostParent ?  false ? invariant(false, 'React DOM tree root should always have a node reference.') : _prodInvariant('34') : void 0;
	    inst = inst._hostParent;
	  }
	
	  // Now parents contains each ancestor that does *not* have a cached native
	  // node, and `inst` is the deepest ancestor that does.
	  for (; parents.length; inst = parents.pop()) {
	    precacheChildNodes(inst, inst._hostNode);
	  }
	
	  return inst._hostNode;
	}
	
	var ReactDOMComponentTree = {
	  getClosestInstanceFromNode: getClosestInstanceFromNode,
	  getInstanceFromNode: getInstanceFromNode,
	  getNodeFromInstance: getNodeFromInstance,
	  precacheChildNodes: precacheChildNodes,
	  precacheNode: precacheNode,
	  uncacheNode: uncacheNode
	};
	
	module.exports = ReactDOMComponentTree;

/***/ },
/* 21 */
/***/ function(module, exports) {

	var core = module.exports = { version: '2.5.3' };
	if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ },
/* 22 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	/**
	 * Simple, lightweight module assisting with the detection and context of
	 * Worker. Helps avoid circular dependencies and allows code to reason about
	 * whether or not they are in a Worker, even if they never include the main
	 * `ReactWorker` dependency.
	 */
	var ExecutionEnvironment = {
	
	  canUseDOM: canUseDOM,
	
	  canUseWorkers: typeof Worker !== 'undefined',
	
	  canUseEventListeners: canUseDOM && !!(window.addEventListener || window.attachEvent),
	
	  canUseViewport: canUseDOM && !!window.screen,
	
	  isInWorker: !canUseDOM // For now, this is true - might change in the future.
	
	};
	
	module.exports = ExecutionEnvironment;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Paper = __webpack_require__(829);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Paper2.default;

/***/ },
/* 24 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	function makeEmptyFunction(arg) {
	  return function () {
	    return arg;
	  };
	}
	
	/**
	 * This function accepts and discards inputs; it has no side effects. This is
	 * primarily useful idiomatically for overridable function endpoints which
	 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
	 */
	var emptyFunction = function emptyFunction() {};
	
	emptyFunction.thatReturns = makeEmptyFunction;
	emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
	emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
	emptyFunction.thatReturnsNull = makeEmptyFunction(null);
	emptyFunction.thatReturnsThis = function () {
	  return this;
	};
	emptyFunction.thatReturnsArgument = function (arg) {
	  return arg;
	};
	
	module.exports = emptyFunction;

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var horizontal = _propTypes2.default.oneOf(['left', 'middle', 'right']);
	var vertical = _propTypes2.default.oneOf(['top', 'center', 'bottom']);
	
	exports.default = {
	
	  corners: _propTypes2.default.oneOf(['bottom-left', 'bottom-right', 'top-left', 'top-right']),
	
	  horizontal: horizontal,
	
	  vertical: vertical,
	
	  origin: _propTypes2.default.shape({
	    horizontal: horizontal,
	    vertical: vertical
	  }),
	
	  cornersAndCenter: _propTypes2.default.oneOf(['bottom-center', 'bottom-left', 'bottom-right', 'top-center', 'top-left', 'top-right']),
	
	  stringOrNumber: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	
	  zDepth: _propTypes2.default.oneOf([0, 1, 2, 3, 4, 5])
	
	};

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.connect = exports.connectAdvanced = exports.createProvider = exports.Provider = undefined;
	
	var _Provider = __webpack_require__(1918);
	
	var _Provider2 = _interopRequireDefault(_Provider);
	
	var _connectAdvanced = __webpack_require__(414);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _connect = __webpack_require__(1919);
	
	var _connect2 = _interopRequireDefault(_connect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Provider = _Provider2.default;
	exports.createProvider = _Provider.createProvider;
	exports.connectAdvanced = _connectAdvanced2.default;
	exports.connect = _connect2.default;

/***/ },
/* 27 */
/***/ function(module, exports) {

	// Source: http://jsfiddle.net/vWx8V/
	// http://stackoverflow.com/questions/5603195/full-list-of-javascript-keycodes
	
	/**
	 * Conenience method returns corresponding value for given keyName or keyCode.
	 *
	 * @param {Mixed} keyCode {Number} or keyName {String}
	 * @return {Mixed}
	 * @api public
	 */
	
	exports = module.exports = function(searchInput) {
	  // Keyboard Events
	  if (searchInput && 'object' === typeof searchInput) {
	    var hasKeyCode = searchInput.which || searchInput.keyCode || searchInput.charCode
	    if (hasKeyCode) searchInput = hasKeyCode
	  }
	
	  // Numbers
	  if ('number' === typeof searchInput) return names[searchInput]
	
	  // Everything else (cast to string)
	  var search = String(searchInput)
	
	  // check codes
	  var foundNamedKey = codes[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // check aliases
	  var foundNamedKey = aliases[search.toLowerCase()]
	  if (foundNamedKey) return foundNamedKey
	
	  // weird character?
	  if (search.length === 1) return search.charCodeAt(0)
	
	  return undefined
	}
	
	/**
	 * Get by name
	 *
	 *   exports.code['enter'] // => 13
	 */
	
	var codes = exports.code = exports.codes = {
	  'backspace': 8,
	  'tab': 9,
	  'enter': 13,
	  'shift': 16,
	  'ctrl': 17,
	  'alt': 18,
	  'pause/break': 19,
	  'caps lock': 20,
	  'esc': 27,
	  'space': 32,
	  'page up': 33,
	  'page down': 34,
	  'end': 35,
	  'home': 36,
	  'left': 37,
	  'up': 38,
	  'right': 39,
	  'down': 40,
	  'insert': 45,
	  'delete': 46,
	  'command': 91,
	  'left command': 91,
	  'right command': 93,
	  'numpad *': 106,
	  'numpad +': 107,
	  'numpad -': 109,
	  'numpad .': 110,
	  'numpad /': 111,
	  'num lock': 144,
	  'scroll lock': 145,
	  'my computer': 182,
	  'my calculator': 183,
	  ';': 186,
	  '=': 187,
	  ',': 188,
	  '-': 189,
	  '.': 190,
	  '/': 191,
	  '`': 192,
	  '[': 219,
	  '\\': 220,
	  ']': 221,
	  "'": 222
	}
	
	// Helper aliases
	
	var aliases = exports.aliases = {
	  'windows': 91,
	  '⇧': 16,
	  '⌥': 18,
	  '⌃': 17,
	  '⌘': 91,
	  'ctl': 17,
	  'control': 17,
	  'option': 18,
	  'pause': 19,
	  'break': 19,
	  'caps': 20,
	  'return': 13,
	  'escape': 27,
	  'spc': 32,
	  'pgup': 33,
	  'pgdn': 34,
	  'ins': 45,
	  'del': 46,
	  'cmd': 91
	}
	
	
	/*!
	 * Programatically add the following
	 */
	
	// lower case chars
	for (i = 97; i < 123; i++) codes[String.fromCharCode(i)] = i - 32
	
	// numbers
	for (var i = 48; i < 58; i++) codes[i - 48] = i
	
	// function keys
	for (i = 1; i < 13; i++) codes['f'+i] = i + 111
	
	// numpad keys
	for (i = 0; i < 10; i++) codes['numpad '+i] = i + 96
	
	/**
	 * Get by code
	 *
	 *   exports.name[13] // => 'Enter'
	 */
	
	var names = exports.names = exports.title = {} // title for backward compat
	
	// Create reverse mapping
	for (i in codes) names[codes[i]] = i
	
	// Add aliases
	for (var alias in aliases) {
	  codes[alias] = aliases[alias]
	}


/***/ },
/* 28 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	module.exports = isArray;


/***/ },
/* 29 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return value != null && (type == 'object' || type == 'function');
	}
	
	module.exports = isObject;


/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(301),
	    baseKeys = __webpack_require__(670),
	    isArrayLike = __webpack_require__(110);
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	module.exports = keys;


/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	var arrayLikeKeys = __webpack_require__(301),
	    baseKeysIn = __webpack_require__(671),
	    isArrayLike = __webpack_require__(110);
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = keysIn;


/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var store = __webpack_require__(176)('wks');
	var uid = __webpack_require__(127);
	var Symbol = __webpack_require__(48).Symbol;
	var USE_SYMBOL = typeof Symbol == 'function';
	
	var $exports = module.exports = function (name) {
	  return store[name] || (store[name] =
	    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
	};
	
	$exports.store = store;


/***/ },
/* 33 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * @license
	 * Lodash <https://lodash.com/>
	 * Copyright JS Foundation and other contributors <https://js.foundation/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	;(function() {
	
	  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
	  var undefined;
	
	  /** Used as the semantic version number. */
	  var VERSION = '4.17.4';
	
	  /** Used as the size to enable large array optimizations. */
	  var LARGE_ARRAY_SIZE = 200;
	
	  /** Error message constants. */
	  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
	      FUNC_ERROR_TEXT = 'Expected a function';
	
	  /** Used to stand-in for `undefined` hash values. */
	  var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	  /** Used as the maximum memoize cache size. */
	  var MAX_MEMOIZE_SIZE = 500;
	
	  /** Used as the internal argument placeholder. */
	  var PLACEHOLDER = '__lodash_placeholder__';
	
	  /** Used to compose bitmasks for cloning. */
	  var CLONE_DEEP_FLAG = 1,
	      CLONE_FLAT_FLAG = 2,
	      CLONE_SYMBOLS_FLAG = 4;
	
	  /** Used to compose bitmasks for value comparisons. */
	  var COMPARE_PARTIAL_FLAG = 1,
	      COMPARE_UNORDERED_FLAG = 2;
	
	  /** Used to compose bitmasks for function metadata. */
	  var WRAP_BIND_FLAG = 1,
	      WRAP_BIND_KEY_FLAG = 2,
	      WRAP_CURRY_BOUND_FLAG = 4,
	      WRAP_CURRY_FLAG = 8,
	      WRAP_CURRY_RIGHT_FLAG = 16,
	      WRAP_PARTIAL_FLAG = 32,
	      WRAP_PARTIAL_RIGHT_FLAG = 64,
	      WRAP_ARY_FLAG = 128,
	      WRAP_REARG_FLAG = 256,
	      WRAP_FLIP_FLAG = 512;
	
	  /** Used as default options for `_.truncate`. */
	  var DEFAULT_TRUNC_LENGTH = 30,
	      DEFAULT_TRUNC_OMISSION = '...';
	
	  /** Used to detect hot functions by number of calls within a span of milliseconds. */
	  var HOT_COUNT = 800,
	      HOT_SPAN = 16;
	
	  /** Used to indicate the type of lazy iteratees. */
	  var LAZY_FILTER_FLAG = 1,
	      LAZY_MAP_FLAG = 2,
	      LAZY_WHILE_FLAG = 3;
	
	  /** Used as references for various `Number` constants. */
	  var INFINITY = 1 / 0,
	      MAX_SAFE_INTEGER = 9007199254740991,
	      MAX_INTEGER = 1.7976931348623157e+308,
	      NAN = 0 / 0;
	
	  /** Used as references for the maximum length and index of an array. */
	  var MAX_ARRAY_LENGTH = 4294967295,
	      MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
	      HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;
	
	  /** Used to associate wrap methods with their bit flags. */
	  var wrapFlags = [
	    ['ary', WRAP_ARY_FLAG],
	    ['bind', WRAP_BIND_FLAG],
	    ['bindKey', WRAP_BIND_KEY_FLAG],
	    ['curry', WRAP_CURRY_FLAG],
	    ['curryRight', WRAP_CURRY_RIGHT_FLAG],
	    ['flip', WRAP_FLIP_FLAG],
	    ['partial', WRAP_PARTIAL_FLAG],
	    ['partialRight', WRAP_PARTIAL_RIGHT_FLAG],
	    ['rearg', WRAP_REARG_FLAG]
	  ];
	
	  /** `Object#toString` result references. */
	  var argsTag = '[object Arguments]',
	      arrayTag = '[object Array]',
	      asyncTag = '[object AsyncFunction]',
	      boolTag = '[object Boolean]',
	      dateTag = '[object Date]',
	      domExcTag = '[object DOMException]',
	      errorTag = '[object Error]',
	      funcTag = '[object Function]',
	      genTag = '[object GeneratorFunction]',
	      mapTag = '[object Map]',
	      numberTag = '[object Number]',
	      nullTag = '[object Null]',
	      objectTag = '[object Object]',
	      promiseTag = '[object Promise]',
	      proxyTag = '[object Proxy]',
	      regexpTag = '[object RegExp]',
	      setTag = '[object Set]',
	      stringTag = '[object String]',
	      symbolTag = '[object Symbol]',
	      undefinedTag = '[object Undefined]',
	      weakMapTag = '[object WeakMap]',
	      weakSetTag = '[object WeakSet]';
	
	  var arrayBufferTag = '[object ArrayBuffer]',
	      dataViewTag = '[object DataView]',
	      float32Tag = '[object Float32Array]',
	      float64Tag = '[object Float64Array]',
	      int8Tag = '[object Int8Array]',
	      int16Tag = '[object Int16Array]',
	      int32Tag = '[object Int32Array]',
	      uint8Tag = '[object Uint8Array]',
	      uint8ClampedTag = '[object Uint8ClampedArray]',
	      uint16Tag = '[object Uint16Array]',
	      uint32Tag = '[object Uint32Array]';
	
	  /** Used to match empty string literals in compiled template source. */
	  var reEmptyStringLeading = /\b__p \+= '';/g,
	      reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
	      reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;
	
	  /** Used to match HTML entities and HTML characters. */
	  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
	      reUnescapedHtml = /[&<>"']/g,
	      reHasEscapedHtml = RegExp(reEscapedHtml.source),
	      reHasUnescapedHtml = RegExp(reUnescapedHtml.source);
	
	  /** Used to match template delimiters. */
	  var reEscape = /<%-([\s\S]+?)%>/g,
	      reEvaluate = /<%([\s\S]+?)%>/g,
	      reInterpolate = /<%=([\s\S]+?)%>/g;
	
	  /** Used to match property names within property paths. */
	  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	      reIsPlainProp = /^\w*$/,
	      reLeadingDot = /^\./,
	      rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	  /**
	   * Used to match `RegExp`
	   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	   */
	  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
	      reHasRegExpChar = RegExp(reRegExpChar.source);
	
	  /** Used to match leading and trailing whitespace. */
	  var reTrim = /^\s+|\s+$/g,
	      reTrimStart = /^\s+/,
	      reTrimEnd = /\s+$/;
	
	  /** Used to match wrap detail comments. */
	  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	      reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	      reSplitDetails = /,? & /;
	
	  /** Used to match words composed of alphanumeric characters. */
	  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;
	
	  /** Used to match backslashes in property paths. */
	  var reEscapeChar = /\\(\\)?/g;
	
	  /**
	   * Used to match
	   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
	   */
	  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;
	
	  /** Used to match `RegExp` flags from their coerced string values. */
	  var reFlags = /\w*$/;
	
	  /** Used to detect bad signed hexadecimal string values. */
	  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	  /** Used to detect binary string values. */
	  var reIsBinary = /^0b[01]+$/i;
	
	  /** Used to detect host constructors (Safari). */
	  var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	  /** Used to detect octal string values. */
	  var reIsOctal = /^0o[0-7]+$/i;
	
	  /** Used to detect unsigned integer values. */
	  var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	  /** Used to match Latin Unicode letters (excluding mathematical operators). */
	  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;
	
	  /** Used to ensure capturing order of template delimiters. */
	  var reNoMatch = /($^)/;
	
	  /** Used to match unescaped characters in compiled string literals. */
	  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;
	
	  /** Used to compose unicode character classes. */
	  var rsAstralRange = '\\ud800-\\udfff',
	      rsComboMarksRange = '\\u0300-\\u036f',
	      reComboHalfMarksRange = '\\ufe20-\\ufe2f',
	      rsComboSymbolsRange = '\\u20d0-\\u20ff',
	      rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
	      rsDingbatRange = '\\u2700-\\u27bf',
	      rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
	      rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
	      rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
	      rsPunctuationRange = '\\u2000-\\u206f',
	      rsSpaceRange = ' \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000',
	      rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
	      rsVarRange = '\\ufe0e\\ufe0f',
	      rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;
	
	  /** Used to compose unicode capture groups. */
	  var rsApos = "['\u2019]",
	      rsAstral = '[' + rsAstralRange + ']',
	      rsBreak = '[' + rsBreakRange + ']',
	      rsCombo = '[' + rsComboRange + ']',
	      rsDigits = '\\d+',
	      rsDingbat = '[' + rsDingbatRange + ']',
	      rsLower = '[' + rsLowerRange + ']',
	      rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
	      rsFitz = '\\ud83c[\\udffb-\\udfff]',
	      rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
	      rsNonAstral = '[^' + rsAstralRange + ']',
	      rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
	      rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
	      rsUpper = '[' + rsUpperRange + ']',
	      rsZWJ = '\\u200d';
	
	  /** Used to compose unicode regexes. */
	  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
	      rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
	      rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
	      rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
	      reOptMod = rsModifier + '?',
	      rsOptVar = '[' + rsVarRange + ']?',
	      rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
	      rsOrdLower = '\\d*(?:(?:1st|2nd|3rd|(?![123])\\dth)\\b)',
	      rsOrdUpper = '\\d*(?:(?:1ST|2ND|3RD|(?![123])\\dTH)\\b)',
	      rsSeq = rsOptVar + reOptMod + rsOptJoin,
	      rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
	      rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';
	
	  /** Used to match apostrophes. */
	  var reApos = RegExp(rsApos, 'g');
	
	  /**
	   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
	   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
	   */
	  var reComboMark = RegExp(rsCombo, 'g');
	
	  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
	  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');
	
	  /** Used to match complex or compound words. */
	  var reUnicodeWord = RegExp([
	    rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')',
	    rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')',
	    rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower,
	    rsUpper + '+' + rsOptContrUpper,
	    rsOrdUpper,
	    rsOrdLower,
	    rsDigits,
	    rsEmoji
	  ].join('|'), 'g');
	
	  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
	  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');
	
	  /** Used to detect strings that need a more robust regexp to match words. */
	  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2,}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;
	
	  /** Used to assign default `context` object properties. */
	  var contextProps = [
	    'Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array',
	    'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object',
	    'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array',
	    'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap',
	    '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'
	  ];
	
	  /** Used to make template sourceURLs easier to identify. */
	  var templateCounter = -1;
	
	  /** Used to identify `toStringTag` values of typed arrays. */
	  var typedArrayTags = {};
	  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	  typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	  typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	  typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	  typedArrayTags[uint32Tag] = true;
	  typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	  typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	  typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	  typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	  typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	  typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	  typedArrayTags[setTag] = typedArrayTags[stringTag] =
	  typedArrayTags[weakMapTag] = false;
	
	  /** Used to identify `toStringTag` values supported by `_.clone`. */
	  var cloneableTags = {};
	  cloneableTags[argsTag] = cloneableTags[arrayTag] =
	  cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	  cloneableTags[boolTag] = cloneableTags[dateTag] =
	  cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	  cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	  cloneableTags[int32Tag] = cloneableTags[mapTag] =
	  cloneableTags[numberTag] = cloneableTags[objectTag] =
	  cloneableTags[regexpTag] = cloneableTags[setTag] =
	  cloneableTags[stringTag] = cloneableTags[symbolTag] =
	  cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	  cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	  cloneableTags[errorTag] = cloneableTags[funcTag] =
	  cloneableTags[weakMapTag] = false;
	
	  /** Used to map Latin Unicode letters to basic Latin letters. */
	  var deburredLetters = {
	    // Latin-1 Supplement block.
	    '\xc0': 'A',  '\xc1': 'A', '\xc2': 'A', '\xc3': 'A', '\xc4': 'A', '\xc5': 'A',
	    '\xe0': 'a',  '\xe1': 'a', '\xe2': 'a', '\xe3': 'a', '\xe4': 'a', '\xe5': 'a',
	    '\xc7': 'C',  '\xe7': 'c',
	    '\xd0': 'D',  '\xf0': 'd',
	    '\xc8': 'E',  '\xc9': 'E', '\xca': 'E', '\xcb': 'E',
	    '\xe8': 'e',  '\xe9': 'e', '\xea': 'e', '\xeb': 'e',
	    '\xcc': 'I',  '\xcd': 'I', '\xce': 'I', '\xcf': 'I',
	    '\xec': 'i',  '\xed': 'i', '\xee': 'i', '\xef': 'i',
	    '\xd1': 'N',  '\xf1': 'n',
	    '\xd2': 'O',  '\xd3': 'O', '\xd4': 'O', '\xd5': 'O', '\xd6': 'O', '\xd8': 'O',
	    '\xf2': 'o',  '\xf3': 'o', '\xf4': 'o', '\xf5': 'o', '\xf6': 'o', '\xf8': 'o',
	    '\xd9': 'U',  '\xda': 'U', '\xdb': 'U', '\xdc': 'U',
	    '\xf9': 'u',  '\xfa': 'u', '\xfb': 'u', '\xfc': 'u',
	    '\xdd': 'Y',  '\xfd': 'y', '\xff': 'y',
	    '\xc6': 'Ae', '\xe6': 'ae',
	    '\xde': 'Th', '\xfe': 'th',
	    '\xdf': 'ss',
	    // Latin Extended-A block.
	    '\u0100': 'A',  '\u0102': 'A', '\u0104': 'A',
	    '\u0101': 'a',  '\u0103': 'a', '\u0105': 'a',
	    '\u0106': 'C',  '\u0108': 'C', '\u010a': 'C', '\u010c': 'C',
	    '\u0107': 'c',  '\u0109': 'c', '\u010b': 'c', '\u010d': 'c',
	    '\u010e': 'D',  '\u0110': 'D', '\u010f': 'd', '\u0111': 'd',
	    '\u0112': 'E',  '\u0114': 'E', '\u0116': 'E', '\u0118': 'E', '\u011a': 'E',
	    '\u0113': 'e',  '\u0115': 'e', '\u0117': 'e', '\u0119': 'e', '\u011b': 'e',
	    '\u011c': 'G',  '\u011e': 'G', '\u0120': 'G', '\u0122': 'G',
	    '\u011d': 'g',  '\u011f': 'g', '\u0121': 'g', '\u0123': 'g',
	    '\u0124': 'H',  '\u0126': 'H', '\u0125': 'h', '\u0127': 'h',
	    '\u0128': 'I',  '\u012a': 'I', '\u012c': 'I', '\u012e': 'I', '\u0130': 'I',
	    '\u0129': 'i',  '\u012b': 'i', '\u012d': 'i', '\u012f': 'i', '\u0131': 'i',
	    '\u0134': 'J',  '\u0135': 'j',
	    '\u0136': 'K',  '\u0137': 'k', '\u0138': 'k',
	    '\u0139': 'L',  '\u013b': 'L', '\u013d': 'L', '\u013f': 'L', '\u0141': 'L',
	    '\u013a': 'l',  '\u013c': 'l', '\u013e': 'l', '\u0140': 'l', '\u0142': 'l',
	    '\u0143': 'N',  '\u0145': 'N', '\u0147': 'N', '\u014a': 'N',
	    '\u0144': 'n',  '\u0146': 'n', '\u0148': 'n', '\u014b': 'n',
	    '\u014c': 'O',  '\u014e': 'O', '\u0150': 'O',
	    '\u014d': 'o',  '\u014f': 'o', '\u0151': 'o',
	    '\u0154': 'R',  '\u0156': 'R', '\u0158': 'R',
	    '\u0155': 'r',  '\u0157': 'r', '\u0159': 'r',
	    '\u015a': 'S',  '\u015c': 'S', '\u015e': 'S', '\u0160': 'S',
	    '\u015b': 's',  '\u015d': 's', '\u015f': 's', '\u0161': 's',
	    '\u0162': 'T',  '\u0164': 'T', '\u0166': 'T',
	    '\u0163': 't',  '\u0165': 't', '\u0167': 't',
	    '\u0168': 'U',  '\u016a': 'U', '\u016c': 'U', '\u016e': 'U', '\u0170': 'U', '\u0172': 'U',
	    '\u0169': 'u',  '\u016b': 'u', '\u016d': 'u', '\u016f': 'u', '\u0171': 'u', '\u0173': 'u',
	    '\u0174': 'W',  '\u0175': 'w',
	    '\u0176': 'Y',  '\u0177': 'y', '\u0178': 'Y',
	    '\u0179': 'Z',  '\u017b': 'Z', '\u017d': 'Z',
	    '\u017a': 'z',  '\u017c': 'z', '\u017e': 'z',
	    '\u0132': 'IJ', '\u0133': 'ij',
	    '\u0152': 'Oe', '\u0153': 'oe',
	    '\u0149': "'n", '\u017f': 's'
	  };
	
	  /** Used to map characters to HTML entities. */
	  var htmlEscapes = {
	    '&': '&amp;',
	    '<': '&lt;',
	    '>': '&gt;',
	    '"': '&quot;',
	    "'": '&#39;'
	  };
	
	  /** Used to map HTML entities to characters. */
	  var htmlUnescapes = {
	    '&amp;': '&',
	    '&lt;': '<',
	    '&gt;': '>',
	    '&quot;': '"',
	    '&#39;': "'"
	  };
	
	  /** Used to escape characters for inclusion in compiled string literals. */
	  var stringEscapes = {
	    '\\': '\\',
	    "'": "'",
	    '\n': 'n',
	    '\r': 'r',
	    '\u2028': 'u2028',
	    '\u2029': 'u2029'
	  };
	
	  /** Built-in method references without a dependency on `root`. */
	  var freeParseFloat = parseFloat,
	      freeParseInt = parseInt;
	
	  /** Detect free variable `global` from Node.js. */
	  var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	  /** Detect free variable `self`. */
	  var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	  /** Used as a reference to the global object. */
	  var root = freeGlobal || freeSelf || Function('return this')();
	
	  /** Detect free variable `exports`. */
	  var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	  /** Detect free variable `module`. */
	  var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	  /** Detect the popular CommonJS extension `module.exports`. */
	  var moduleExports = freeModule && freeModule.exports === freeExports;
	
	  /** Detect free variable `process` from Node.js. */
	  var freeProcess = moduleExports && freeGlobal.process;
	
	  /** Used to access faster Node.js helpers. */
	  var nodeUtil = (function() {
	    try {
	      return freeProcess && freeProcess.binding && freeProcess.binding('util');
	    } catch (e) {}
	  }());
	
	  /* Node.js helper references. */
	  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
	      nodeIsDate = nodeUtil && nodeUtil.isDate,
	      nodeIsMap = nodeUtil && nodeUtil.isMap,
	      nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
	      nodeIsSet = nodeUtil && nodeUtil.isSet,
	      nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Adds the key-value `pair` to `map`.
	   *
	   * @private
	   * @param {Object} map The map to modify.
	   * @param {Array} pair The key-value pair to add.
	   * @returns {Object} Returns `map`.
	   */
	  function addMapEntry(map, pair) {
	    // Don't return `map.set` because it's not chainable in IE 11.
	    map.set(pair[0], pair[1]);
	    return map;
	  }
	
	  /**
	   * Adds `value` to `set`.
	   *
	   * @private
	   * @param {Object} set The set to modify.
	   * @param {*} value The value to add.
	   * @returns {Object} Returns `set`.
	   */
	  function addSetEntry(set, value) {
	    // Don't return `set.add` because it's not chainable in IE 11.
	    set.add(value);
	    return set;
	  }
	
	  /**
	   * A faster alternative to `Function#apply`, this function invokes `func`
	   * with the `this` binding of `thisArg` and the arguments of `args`.
	   *
	   * @private
	   * @param {Function} func The function to invoke.
	   * @param {*} thisArg The `this` binding of `func`.
	   * @param {Array} args The arguments to invoke `func` with.
	   * @returns {*} Returns the result of `func`.
	   */
	  function apply(func, thisArg, args) {
	    switch (args.length) {
	      case 0: return func.call(thisArg);
	      case 1: return func.call(thisArg, args[0]);
	      case 2: return func.call(thisArg, args[0], args[1]);
	      case 3: return func.call(thisArg, args[0], args[1], args[2]);
	    }
	    return func.apply(thisArg, args);
	  }
	
	  /**
	   * A specialized version of `baseAggregator` for arrays.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} setter The function to set `accumulator` values.
	   * @param {Function} iteratee The iteratee to transform keys.
	   * @param {Object} accumulator The initial aggregated object.
	   * @returns {Function} Returns `accumulator`.
	   */
	  function arrayAggregator(array, setter, iteratee, accumulator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      var value = array[index];
	      setter(accumulator, value, iteratee(value), array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.forEach` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEach(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (iteratee(array[index], index, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.forEachRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayEachRight(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	
	    while (length--) {
	      if (iteratee(array[length], length, array) === false) {
	        break;
	      }
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.every` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if all elements pass the predicate check,
	   *  else `false`.
	   */
	  function arrayEvery(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (!predicate(array[index], index, array)) {
	        return false;
	      }
	    }
	    return true;
	  }
	
	  /**
	   * A specialized version of `_.filter` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {Array} Returns the new filtered array.
	   */
	  function arrayFilter(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (predicate(value, index, array)) {
	        result[resIndex++] = value;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.includes` for arrays without support for
	   * specifying an index to search from.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludes(array, value) {
	    var length = array == null ? 0 : array.length;
	    return !!length && baseIndexOf(array, value, 0) > -1;
	  }
	
	  /**
	   * This function is like `arrayIncludes` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} [array] The array to inspect.
	   * @param {*} target The value to search for.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {boolean} Returns `true` if `target` is found, else `false`.
	   */
	  function arrayIncludesWith(array, value, comparator) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (comparator(value, array[index])) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * A specialized version of `_.map` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the new mapped array.
	   */
	  function arrayMap(array, iteratee) {
	    var index = -1,
	        length = array == null ? 0 : array.length,
	        result = Array(length);
	
	    while (++index < length) {
	      result[index] = iteratee(array[index], index, array);
	    }
	    return result;
	  }
	
	  /**
	   * Appends the elements of `values` to `array`.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {Array} values The values to append.
	   * @returns {Array} Returns `array`.
	   */
	  function arrayPush(array, values) {
	    var index = -1,
	        length = values.length,
	        offset = array.length;
	
	    while (++index < length) {
	      array[offset + index] = values[index];
	    }
	    return array;
	  }
	
	  /**
	   * A specialized version of `_.reduce` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the first element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduce(array, iteratee, accumulator, initAccum) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    if (initAccum && length) {
	      accumulator = array[++index];
	    }
	    while (++index < length) {
	      accumulator = iteratee(accumulator, array[index], index, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.reduceRight` for arrays without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} [accumulator] The initial value.
	   * @param {boolean} [initAccum] Specify using the last element of `array` as
	   *  the initial value.
	   * @returns {*} Returns the accumulated value.
	   */
	  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
	    var length = array == null ? 0 : array.length;
	    if (initAccum && length) {
	      accumulator = array[--length];
	    }
	    while (length--) {
	      accumulator = iteratee(accumulator, array[length], length, array);
	    }
	    return accumulator;
	  }
	
	  /**
	   * A specialized version of `_.some` for arrays without support for iteratee
	   * shorthands.
	   *
	   * @private
	   * @param {Array} [array] The array to iterate over.
	   * @param {Function} predicate The function invoked per iteration.
	   * @returns {boolean} Returns `true` if any element passes the predicate check,
	   *  else `false`.
	   */
	  function arraySome(array, predicate) {
	    var index = -1,
	        length = array == null ? 0 : array.length;
	
	    while (++index < length) {
	      if (predicate(array[index], index, array)) {
	        return true;
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Gets the size of an ASCII `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  var asciiSize = baseProperty('length');
	
	  /**
	   * Converts an ASCII `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function asciiToArray(string) {
	    return string.split('');
	  }
	
	  /**
	   * Splits an ASCII `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function asciiWords(string) {
	    return string.match(reAsciiWord) || [];
	  }
	
	  /**
	   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	   * without support for iteratee shorthands, which iterates over `collection`
	   * using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the found element or its key, else `undefined`.
	   */
	  function baseFindKey(collection, predicate, eachFunc) {
	    var result;
	    eachFunc(collection, function(value, key, collection) {
	      if (predicate(value, key, collection)) {
	        result = key;
	        return false;
	      }
	    });
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.findIndex` and `_.findLastIndex` without
	   * support for iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {Function} predicate The function invoked per iteration.
	   * @param {number} fromIndex The index to search from.
	   * @param {boolean} [fromRight] Specify iterating from right to left.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseFindIndex(array, predicate, fromIndex, fromRight) {
	    var length = array.length,
	        index = fromIndex + (fromRight ? 1 : -1);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (predicate(array[index], index, array)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOf(array, value, fromIndex) {
	    return value === value
	      ? strictIndexOf(array, value, fromIndex)
	      : baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	
	  /**
	   * This function is like `baseIndexOf` except that it accepts a comparator.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @param {Function} comparator The comparator invoked per element.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function baseIndexOfWith(array, value, fromIndex, comparator) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (comparator(array[index], value)) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * The base implementation of `_.isNaN` without support for number objects.
	   *
	   * @private
	   * @param {*} value The value to check.
	   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	   */
	  function baseIsNaN(value) {
	    return value !== value;
	  }
	
	  /**
	   * The base implementation of `_.mean` and `_.meanBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the mean.
	   */
	  function baseMean(array, iteratee) {
	    var length = array == null ? 0 : array.length;
	    return length ? (baseSum(array, iteratee) / length) : NAN;
	  }
	
	  /**
	   * The base implementation of `_.property` without support for deep paths.
	   *
	   * @private
	   * @param {string} key The key of the property to get.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function baseProperty(key) {
	    return function(object) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.propertyOf` without support for deep paths.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @returns {Function} Returns the new accessor function.
	   */
	  function basePropertyOf(object) {
	    return function(key) {
	      return object == null ? undefined : object[key];
	    };
	  }
	
	  /**
	   * The base implementation of `_.reduce` and `_.reduceRight`, without support
	   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	   *
	   * @private
	   * @param {Array|Object} collection The collection to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @param {*} accumulator The initial value.
	   * @param {boolean} initAccum Specify using the first or last element of
	   *  `collection` as the initial value.
	   * @param {Function} eachFunc The function to iterate over `collection`.
	   * @returns {*} Returns the accumulated value.
	   */
	  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	    eachFunc(collection, function(value, index, collection) {
	      accumulator = initAccum
	        ? (initAccum = false, value)
	        : iteratee(accumulator, value, index, collection);
	    });
	    return accumulator;
	  }
	
	  /**
	   * The base implementation of `_.sortBy` which uses `comparer` to define the
	   * sort order of `array` and replaces criteria objects with their corresponding
	   * values.
	   *
	   * @private
	   * @param {Array} array The array to sort.
	   * @param {Function} comparer The function to define sort order.
	   * @returns {Array} Returns `array`.
	   */
	  function baseSortBy(array, comparer) {
	    var length = array.length;
	
	    array.sort(comparer);
	    while (length--) {
	      array[length] = array[length].value;
	    }
	    return array;
	  }
	
	  /**
	   * The base implementation of `_.sum` and `_.sumBy` without support for
	   * iteratee shorthands.
	   *
	   * @private
	   * @param {Array} array The array to iterate over.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {number} Returns the sum.
	   */
	  function baseSum(array, iteratee) {
	    var result,
	        index = -1,
	        length = array.length;
	
	    while (++index < length) {
	      var current = iteratee(array[index]);
	      if (current !== undefined) {
	        result = result === undefined ? current : (result + current);
	      }
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.times` without support for iteratee shorthands
	   * or max array length checks.
	   *
	   * @private
	   * @param {number} n The number of times to invoke `iteratee`.
	   * @param {Function} iteratee The function invoked per iteration.
	   * @returns {Array} Returns the array of results.
	   */
	  function baseTimes(n, iteratee) {
	    var index = -1,
	        result = Array(n);
	
	    while (++index < n) {
	      result[index] = iteratee(index);
	    }
	    return result;
	  }
	
	  /**
	   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	   * of key-value pairs for `object` corresponding to the property names of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the key-value pairs.
	   */
	  function baseToPairs(object, props) {
	    return arrayMap(props, function(key) {
	      return [key, object[key]];
	    });
	  }
	
	  /**
	   * The base implementation of `_.unary` without support for storing metadata.
	   *
	   * @private
	   * @param {Function} func The function to cap arguments for.
	   * @returns {Function} Returns the new capped function.
	   */
	  function baseUnary(func) {
	    return function(value) {
	      return func(value);
	    };
	  }
	
	  /**
	   * The base implementation of `_.values` and `_.valuesIn` which creates an
	   * array of `object` property values corresponding to the property names
	   * of `props`.
	   *
	   * @private
	   * @param {Object} object The object to query.
	   * @param {Array} props The property names to get values for.
	   * @returns {Object} Returns the array of property values.
	   */
	  function baseValues(object, props) {
	    return arrayMap(props, function(key) {
	      return object[key];
	    });
	  }
	
	  /**
	   * Checks if a `cache` value for `key` exists.
	   *
	   * @private
	   * @param {Object} cache The cache to query.
	   * @param {string} key The key of the entry to check.
	   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	   */
	  function cacheHas(cache, key) {
	    return cache.has(key);
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the first unmatched string symbol.
	   */
	  function charsStartIndex(strSymbols, chrSymbols) {
	    var index = -1,
	        length = strSymbols.length;
	
	    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
	   * that is not found in the character symbols.
	   *
	   * @private
	   * @param {Array} strSymbols The string symbols to inspect.
	   * @param {Array} chrSymbols The character symbols to find.
	   * @returns {number} Returns the index of the last unmatched string symbol.
	   */
	  function charsEndIndex(strSymbols, chrSymbols) {
	    var index = strSymbols.length;
	
	    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
	    return index;
	  }
	
	  /**
	   * Gets the number of `placeholder` occurrences in `array`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} placeholder The placeholder to search for.
	   * @returns {number} Returns the placeholder count.
	   */
	  function countHolders(array, placeholder) {
	    var length = array.length,
	        result = 0;
	
	    while (length--) {
	      if (array[length] === placeholder) {
	        ++result;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
	   * letters to basic Latin letters.
	   *
	   * @private
	   * @param {string} letter The matched letter to deburr.
	   * @returns {string} Returns the deburred letter.
	   */
	  var deburrLetter = basePropertyOf(deburredLetters);
	
	  /**
	   * Used by `_.escape` to convert characters to HTML entities.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  var escapeHtmlChar = basePropertyOf(htmlEscapes);
	
	  /**
	   * Used by `_.template` to escape characters for inclusion in compiled string literals.
	   *
	   * @private
	   * @param {string} chr The matched character to escape.
	   * @returns {string} Returns the escaped character.
	   */
	  function escapeStringChar(chr) {
	    return '\\' + stringEscapes[chr];
	  }
	
	  /**
	   * Gets the value at `key` of `object`.
	   *
	   * @private
	   * @param {Object} [object] The object to query.
	   * @param {string} key The key of the property to get.
	   * @returns {*} Returns the property value.
	   */
	  function getValue(object, key) {
	    return object == null ? undefined : object[key];
	  }
	
	  /**
	   * Checks if `string` contains Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
	   */
	  function hasUnicode(string) {
	    return reHasUnicode.test(string);
	  }
	
	  /**
	   * Checks if `string` contains a word composed of Unicode symbols.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {boolean} Returns `true` if a word is found, else `false`.
	   */
	  function hasUnicodeWord(string) {
	    return reHasUnicodeWord.test(string);
	  }
	
	  /**
	   * Converts `iterator` to an array.
	   *
	   * @private
	   * @param {Object} iterator The iterator to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function iteratorToArray(iterator) {
	    var data,
	        result = [];
	
	    while (!(data = iterator.next()).done) {
	      result.push(data.value);
	    }
	    return result;
	  }
	
	  /**
	   * Converts `map` to its key-value pairs.
	   *
	   * @private
	   * @param {Object} map The map to convert.
	   * @returns {Array} Returns the key-value pairs.
	   */
	  function mapToArray(map) {
	    var index = -1,
	        result = Array(map.size);
	
	    map.forEach(function(value, key) {
	      result[++index] = [key, value];
	    });
	    return result;
	  }
	
	  /**
	   * Creates a unary function that invokes `func` with its argument transformed.
	   *
	   * @private
	   * @param {Function} func The function to wrap.
	   * @param {Function} transform The argument transform.
	   * @returns {Function} Returns the new function.
	   */
	  function overArg(func, transform) {
	    return function(arg) {
	      return func(transform(arg));
	    };
	  }
	
	  /**
	   * Replaces all `placeholder` elements in `array` with an internal placeholder
	   * and returns an array of their indexes.
	   *
	   * @private
	   * @param {Array} array The array to modify.
	   * @param {*} placeholder The placeholder to replace.
	   * @returns {Array} Returns the new array of placeholder indexes.
	   */
	  function replaceHolders(array, placeholder) {
	    var index = -1,
	        length = array.length,
	        resIndex = 0,
	        result = [];
	
	    while (++index < length) {
	      var value = array[index];
	      if (value === placeholder || value === PLACEHOLDER) {
	        array[index] = PLACEHOLDER;
	        result[resIndex++] = index;
	      }
	    }
	    return result;
	  }
	
	  /**
	   * Converts `set` to an array of its values.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the values.
	   */
	  function setToArray(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = value;
	    });
	    return result;
	  }
	
	  /**
	   * Converts `set` to its value-value pairs.
	   *
	   * @private
	   * @param {Object} set The set to convert.
	   * @returns {Array} Returns the value-value pairs.
	   */
	  function setToPairs(set) {
	    var index = -1,
	        result = Array(set.size);
	
	    set.forEach(function(value) {
	      result[++index] = [value, value];
	    });
	    return result;
	  }
	
	  /**
	   * A specialized version of `_.indexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictIndexOf(array, value, fromIndex) {
	    var index = fromIndex - 1,
	        length = array.length;
	
	    while (++index < length) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return -1;
	  }
	
	  /**
	   * A specialized version of `_.lastIndexOf` which performs strict equality
	   * comparisons of values, i.e. `===`.
	   *
	   * @private
	   * @param {Array} array The array to inspect.
	   * @param {*} value The value to search for.
	   * @param {number} fromIndex The index to search from.
	   * @returns {number} Returns the index of the matched value, else `-1`.
	   */
	  function strictLastIndexOf(array, value, fromIndex) {
	    var index = fromIndex + 1;
	    while (index--) {
	      if (array[index] === value) {
	        return index;
	      }
	    }
	    return index;
	  }
	
	  /**
	   * Gets the number of symbols in `string`.
	   *
	   * @private
	   * @param {string} string The string to inspect.
	   * @returns {number} Returns the string size.
	   */
	  function stringSize(string) {
	    return hasUnicode(string)
	      ? unicodeSize(string)
	      : asciiSize(string);
	  }
	
	  /**
	   * Converts `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function stringToArray(string) {
	    return hasUnicode(string)
	      ? unicodeToArray(string)
	      : asciiToArray(string);
	  }
	
	  /**
	   * Used by `_.unescape` to convert HTML entities to characters.
	   *
	   * @private
	   * @param {string} chr The matched character to unescape.
	   * @returns {string} Returns the unescaped character.
	   */
	  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);
	
	  /**
	   * Gets the size of a Unicode `string`.
	   *
	   * @private
	   * @param {string} string The string inspect.
	   * @returns {number} Returns the string size.
	   */
	  function unicodeSize(string) {
	    var result = reUnicode.lastIndex = 0;
	    while (reUnicode.test(string)) {
	      ++result;
	    }
	    return result;
	  }
	
	  /**
	   * Converts a Unicode `string` to an array.
	   *
	   * @private
	   * @param {string} string The string to convert.
	   * @returns {Array} Returns the converted array.
	   */
	  function unicodeToArray(string) {
	    return string.match(reUnicode) || [];
	  }
	
	  /**
	   * Splits a Unicode `string` into an array of its words.
	   *
	   * @private
	   * @param {string} The string to inspect.
	   * @returns {Array} Returns the words of `string`.
	   */
	  function unicodeWords(string) {
	    return string.match(reUnicodeWord) || [];
	  }
	
	  /*--------------------------------------------------------------------------*/
	
	  /**
	   * Create a new pristine `lodash` function using the `context` object.
	   *
	   * @static
	   * @memberOf _
	   * @since 1.1.0
	   * @category Util
	   * @param {Object} [context=root] The context object.
	   * @returns {Function} Returns a new `lodash` function.
	   * @example
	   *
	   * _.mixin({ 'foo': _.constant('foo') });
	   *
	   * var lodash = _.runInContext();
	   * lodash.mixin({ 'bar': lodash.constant('bar') });
	   *
	   * _.isFunction(_.foo);
	   * // => true
	   * _.isFunction(_.bar);
	   * // => false
	   *
	   * lodash.isFunction(lodash.foo);
	   * // => false
	   * lodash.isFunction(lodash.bar);
	   * // => true
	   *
	   * // Create a suped-up `defer` in Node.js.
	   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
	   */
	  var runInContext = (function runInContext(context) {
	    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));
	
	    /** Built-in constructor references. */
	    var Array = context.Array,
	        Date = context.Date,
	        Error = context.Error,
	        Function = context.Function,
	        Math = context.Math,
	        Object = context.Object,
	        RegExp = context.RegExp,
	        String = context.String,
	        TypeError = context.TypeError;
	
	    /** Used for built-in method references. */
	    var arrayProto = Array.prototype,
	        funcProto = Function.prototype,
	        objectProto = Object.prototype;
	
	    /** Used to detect overreaching core-js shims. */
	    var coreJsData = context['__core-js_shared__'];
	
	    /** Used to resolve the decompiled source of functions. */
	    var funcToString = funcProto.toString;
	
	    /** Used to check objects for own properties. */
	    var hasOwnProperty = objectProto.hasOwnProperty;
	
	    /** Used to generate unique IDs. */
	    var idCounter = 0;
	
	    /** Used to detect methods masquerading as native. */
	    var maskSrcKey = (function() {
	      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	      return uid ? ('Symbol(src)_1.' + uid) : '';
	    }());
	
	    /**
	     * Used to resolve the
	     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	     * of values.
	     */
	    var nativeObjectToString = objectProto.toString;
	
	    /** Used to infer the `Object` constructor. */
	    var objectCtorString = funcToString.call(Object);
	
	    /** Used to restore the original `_` reference in `_.noConflict`. */
	    var oldDash = root._;
	
	    /** Used to detect if a method is native. */
	    var reIsNative = RegExp('^' +
	      funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	      .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	    );
	
	    /** Built-in value references. */
	    var Buffer = moduleExports ? context.Buffer : undefined,
	        Symbol = context.Symbol,
	        Uint8Array = context.Uint8Array,
	        allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
	        getPrototype = overArg(Object.getPrototypeOf, Object),
	        objectCreate = Object.create,
	        propertyIsEnumerable = objectProto.propertyIsEnumerable,
	        splice = arrayProto.splice,
	        spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined,
	        symIterator = Symbol ? Symbol.iterator : undefined,
	        symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	    var defineProperty = (function() {
	      try {
	        var func = getNative(Object, 'defineProperty');
	        func({}, '', {});
	        return func;
	      } catch (e) {}
	    }());
	
	    /** Mocked built-ins. */
	    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
	        ctxNow = Date && Date.now !== root.Date.now && Date.now,
	        ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;
	
	    /* Built-in method references for those with the same name as other `lodash` methods. */
	    var nativeCeil = Math.ceil,
	        nativeFloor = Math.floor,
	        nativeGetSymbols = Object.getOwnPropertySymbols,
	        nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	        nativeIsFinite = context.isFinite,
	        nativeJoin = arrayProto.join,
	        nativeKeys = overArg(Object.keys, Object),
	        nativeMax = Math.max,
	        nativeMin = Math.min,
	        nativeNow = Date.now,
	        nativeParseInt = context.parseInt,
	        nativeRandom = Math.random,
	        nativeReverse = arrayProto.reverse;
	
	    /* Built-in method references that are verified to be native. */
	    var DataView = getNative(context, 'DataView'),
	        Map = getNative(context, 'Map'),
	        Promise = getNative(context, 'Promise'),
	        Set = getNative(context, 'Set'),
	        WeakMap = getNative(context, 'WeakMap'),
	        nativeCreate = getNative(Object, 'create');
	
	    /** Used to store function metadata. */
	    var metaMap = WeakMap && new WeakMap;
	
	    /** Used to lookup unminified function names. */
	    var realNames = {};
	
	    /** Used to detect maps, sets, and weakmaps. */
	    var dataViewCtorString = toSource(DataView),
	        mapCtorString = toSource(Map),
	        promiseCtorString = toSource(Promise),
	        setCtorString = toSource(Set),
	        weakMapCtorString = toSource(WeakMap);
	
	    /** Used to convert symbols to primitives and strings. */
	    var symbolProto = Symbol ? Symbol.prototype : undefined,
	        symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	        symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` object which wraps `value` to enable implicit method
	     * chain sequences. Methods that operate on and return arrays, collections,
	     * and functions can be chained together. Methods that retrieve a single value
	     * or may return a primitive value will automatically end the chain sequence
	     * and return the unwrapped value. Otherwise, the value must be unwrapped
	     * with `_#value`.
	     *
	     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
	     * enabled using `_.chain`.
	     *
	     * The execution of chained methods is lazy, that is, it's deferred until
	     * `_#value` is implicitly or explicitly called.
	     *
	     * Lazy evaluation allows several methods to support shortcut fusion.
	     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
	     * the creation of intermediate arrays and can greatly reduce the number of
	     * iteratee executions. Sections of a chain sequence qualify for shortcut
	     * fusion if the section is applied to an array and iteratees accept only
	     * one argument. The heuristic for whether a section qualifies for shortcut
	     * fusion is subject to change.
	     *
	     * Chaining is supported in custom builds as long as the `_#value` method is
	     * directly or indirectly included in the build.
	     *
	     * In addition to lodash methods, wrappers have `Array` and `String` methods.
	     *
	     * The wrapper `Array` methods are:
	     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
	     *
	     * The wrapper `String` methods are:
	     * `replace` and `split`
	     *
	     * The wrapper methods that support shortcut fusion are:
	     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
	     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
	     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
	     *
	     * The chainable wrapper methods are:
	     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
	     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
	     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
	     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
	     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
	     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
	     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
	     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
	     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
	     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
	     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
	     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
	     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
	     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
	     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
	     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
	     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
	     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
	     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
	     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
	     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
	     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
	     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
	     * `zipObject`, `zipObjectDeep`, and `zipWith`
	     *
	     * The wrapper methods that are **not** chainable by default are:
	     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
	     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
	     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
	     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
	     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
	     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
	     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
	     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
	     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
	     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
	     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
	     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
	     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
	     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
	     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
	     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
	     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
	     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
	     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
	     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
	     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
	     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
	     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
	     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
	     * `upperFirst`, `value`, and `words`
	     *
	     * @name _
	     * @constructor
	     * @category Seq
	     * @param {*} value The value to wrap in a `lodash` instance.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2, 3]);
	     *
	     * // Returns an unwrapped value.
	     * wrapped.reduce(_.add);
	     * // => 6
	     *
	     * // Returns a wrapped value.
	     * var squares = wrapped.map(square);
	     *
	     * _.isArray(squares);
	     * // => false
	     *
	     * _.isArray(squares.value());
	     * // => true
	     */
	    function lodash(value) {
	      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
	        if (value instanceof LodashWrapper) {
	          return value;
	        }
	        if (hasOwnProperty.call(value, '__wrapped__')) {
	          return wrapperClone(value);
	        }
	      }
	      return new LodashWrapper(value);
	    }
	
	    /**
	     * The base implementation of `_.create` without support for assigning
	     * properties to the created object.
	     *
	     * @private
	     * @param {Object} proto The object to inherit from.
	     * @returns {Object} Returns the new object.
	     */
	    var baseCreate = (function() {
	      function object() {}
	      return function(proto) {
	        if (!isObject(proto)) {
	          return {};
	        }
	        if (objectCreate) {
	          return objectCreate(proto);
	        }
	        object.prototype = proto;
	        var result = new object;
	        object.prototype = undefined;
	        return result;
	      };
	    }());
	
	    /**
	     * The function whose prototype chain sequence wrappers inherit from.
	     *
	     * @private
	     */
	    function baseLodash() {
	      // No operation performed.
	    }
	
	    /**
	     * The base constructor for creating `lodash` wrapper objects.
	     *
	     * @private
	     * @param {*} value The value to wrap.
	     * @param {boolean} [chainAll] Enable explicit method chain sequences.
	     */
	    function LodashWrapper(value, chainAll) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__chain__ = !!chainAll;
	      this.__index__ = 0;
	      this.__values__ = undefined;
	    }
	
	    /**
	     * By default, the template delimiters used by lodash are like those in
	     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
	     * following template settings to use alternative delimiters.
	     *
	     * @static
	     * @memberOf _
	     * @type {Object}
	     */
	    lodash.templateSettings = {
	
	      /**
	       * Used to detect `data` property values to be HTML-escaped.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'escape': reEscape,
	
	      /**
	       * Used to detect code to be evaluated.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'evaluate': reEvaluate,
	
	      /**
	       * Used to detect `data` property values to inject.
	       *
	       * @memberOf _.templateSettings
	       * @type {RegExp}
	       */
	      'interpolate': reInterpolate,
	
	      /**
	       * Used to reference the data object in the template text.
	       *
	       * @memberOf _.templateSettings
	       * @type {string}
	       */
	      'variable': '',
	
	      /**
	       * Used to import variables into the compiled template.
	       *
	       * @memberOf _.templateSettings
	       * @type {Object}
	       */
	      'imports': {
	
	        /**
	         * A reference to the `lodash` function.
	         *
	         * @memberOf _.templateSettings.imports
	         * @type {Function}
	         */
	        '_': lodash
	      }
	    };
	
	    // Ensure wrappers are instances of `baseLodash`.
	    lodash.prototype = baseLodash.prototype;
	    lodash.prototype.constructor = lodash;
	
	    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
	    LodashWrapper.prototype.constructor = LodashWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
	     *
	     * @private
	     * @constructor
	     * @param {*} value The value to wrap.
	     */
	    function LazyWrapper(value) {
	      this.__wrapped__ = value;
	      this.__actions__ = [];
	      this.__dir__ = 1;
	      this.__filtered__ = false;
	      this.__iteratees__ = [];
	      this.__takeCount__ = MAX_ARRAY_LENGTH;
	      this.__views__ = [];
	    }
	
	    /**
	     * Creates a clone of the lazy wrapper object.
	     *
	     * @private
	     * @name clone
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the cloned `LazyWrapper` object.
	     */
	    function lazyClone() {
	      var result = new LazyWrapper(this.__wrapped__);
	      result.__actions__ = copyArray(this.__actions__);
	      result.__dir__ = this.__dir__;
	      result.__filtered__ = this.__filtered__;
	      result.__iteratees__ = copyArray(this.__iteratees__);
	      result.__takeCount__ = this.__takeCount__;
	      result.__views__ = copyArray(this.__views__);
	      return result;
	    }
	
	    /**
	     * Reverses the direction of lazy iteration.
	     *
	     * @private
	     * @name reverse
	     * @memberOf LazyWrapper
	     * @returns {Object} Returns the new reversed `LazyWrapper` object.
	     */
	    function lazyReverse() {
	      if (this.__filtered__) {
	        var result = new LazyWrapper(this);
	        result.__dir__ = -1;
	        result.__filtered__ = true;
	      } else {
	        result = this.clone();
	        result.__dir__ *= -1;
	      }
	      return result;
	    }
	
	    /**
	     * Extracts the unwrapped value from its lazy wrapper.
	     *
	     * @private
	     * @name value
	     * @memberOf LazyWrapper
	     * @returns {*} Returns the unwrapped value.
	     */
	    function lazyValue() {
	      var array = this.__wrapped__.value(),
	          dir = this.__dir__,
	          isArr = isArray(array),
	          isRight = dir < 0,
	          arrLength = isArr ? array.length : 0,
	          view = getView(0, arrLength, this.__views__),
	          start = view.start,
	          end = view.end,
	          length = end - start,
	          index = isRight ? end : (start - 1),
	          iteratees = this.__iteratees__,
	          iterLength = iteratees.length,
	          resIndex = 0,
	          takeCount = nativeMin(length, this.__takeCount__);
	
	      if (!isArr || (!isRight && arrLength == length && takeCount == length)) {
	        return baseWrapperValue(array, this.__actions__);
	      }
	      var result = [];
	
	      outer:
	      while (length-- && resIndex < takeCount) {
	        index += dir;
	
	        var iterIndex = -1,
	            value = array[index];
	
	        while (++iterIndex < iterLength) {
	          var data = iteratees[iterIndex],
	              iteratee = data.iteratee,
	              type = data.type,
	              computed = iteratee(value);
	
	          if (type == LAZY_MAP_FLAG) {
	            value = computed;
	          } else if (!computed) {
	            if (type == LAZY_FILTER_FLAG) {
	              continue outer;
	            } else {
	              break outer;
	            }
	          }
	        }
	        result[resIndex++] = value;
	      }
	      return result;
	    }
	
	    // Ensure `LazyWrapper` is an instance of `baseLodash`.
	    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
	    LazyWrapper.prototype.constructor = LazyWrapper;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a hash object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Hash(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the hash.
	     *
	     * @private
	     * @name clear
	     * @memberOf Hash
	     */
	    function hashClear() {
	      this.__data__ = nativeCreate ? nativeCreate(null) : {};
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the hash.
	     *
	     * @private
	     * @name delete
	     * @memberOf Hash
	     * @param {Object} hash The hash to modify.
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function hashDelete(key) {
	      var result = this.has(key) && delete this.__data__[key];
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the hash value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Hash
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function hashGet(key) {
	      var data = this.__data__;
	      if (nativeCreate) {
	        var result = data[key];
	        return result === HASH_UNDEFINED ? undefined : result;
	      }
	      return hasOwnProperty.call(data, key) ? data[key] : undefined;
	    }
	
	    /**
	     * Checks if a hash value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Hash
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function hashHas(key) {
	      var data = this.__data__;
	      return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	    }
	
	    /**
	     * Sets the hash `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Hash
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the hash instance.
	     */
	    function hashSet(key, value) {
	      var data = this.__data__;
	      this.size += this.has(key) ? 0 : 1;
	      data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	      return this;
	    }
	
	    // Add methods to `Hash`.
	    Hash.prototype.clear = hashClear;
	    Hash.prototype['delete'] = hashDelete;
	    Hash.prototype.get = hashGet;
	    Hash.prototype.has = hashHas;
	    Hash.prototype.set = hashSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an list cache object.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function ListCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the list cache.
	     *
	     * @private
	     * @name clear
	     * @memberOf ListCache
	     */
	    function listCacheClear() {
	      this.__data__ = [];
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the list cache.
	     *
	     * @private
	     * @name delete
	     * @memberOf ListCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function listCacheDelete(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        return false;
	      }
	      var lastIndex = data.length - 1;
	      if (index == lastIndex) {
	        data.pop();
	      } else {
	        splice.call(data, index, 1);
	      }
	      --this.size;
	      return true;
	    }
	
	    /**
	     * Gets the list cache value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf ListCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function listCacheGet(key) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      return index < 0 ? undefined : data[index][1];
	    }
	
	    /**
	     * Checks if a list cache value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf ListCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function listCacheHas(key) {
	      return assocIndexOf(this.__data__, key) > -1;
	    }
	
	    /**
	     * Sets the list cache `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf ListCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the list cache instance.
	     */
	    function listCacheSet(key, value) {
	      var data = this.__data__,
	          index = assocIndexOf(data, key);
	
	      if (index < 0) {
	        ++this.size;
	        data.push([key, value]);
	      } else {
	        data[index][1] = value;
	      }
	      return this;
	    }
	
	    // Add methods to `ListCache`.
	    ListCache.prototype.clear = listCacheClear;
	    ListCache.prototype['delete'] = listCacheDelete;
	    ListCache.prototype.get = listCacheGet;
	    ListCache.prototype.has = listCacheHas;
	    ListCache.prototype.set = listCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a map cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function MapCache(entries) {
	      var index = -1,
	          length = entries == null ? 0 : entries.length;
	
	      this.clear();
	      while (++index < length) {
	        var entry = entries[index];
	        this.set(entry[0], entry[1]);
	      }
	    }
	
	    /**
	     * Removes all key-value entries from the map.
	     *
	     * @private
	     * @name clear
	     * @memberOf MapCache
	     */
	    function mapCacheClear() {
	      this.size = 0;
	      this.__data__ = {
	        'hash': new Hash,
	        'map': new (Map || ListCache),
	        'string': new Hash
	      };
	    }
	
	    /**
	     * Removes `key` and its value from the map.
	     *
	     * @private
	     * @name delete
	     * @memberOf MapCache
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function mapCacheDelete(key) {
	      var result = getMapData(this, key)['delete'](key);
	      this.size -= result ? 1 : 0;
	      return result;
	    }
	
	    /**
	     * Gets the map value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf MapCache
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function mapCacheGet(key) {
	      return getMapData(this, key).get(key);
	    }
	
	    /**
	     * Checks if a map value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf MapCache
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function mapCacheHas(key) {
	      return getMapData(this, key).has(key);
	    }
	
	    /**
	     * Sets the map `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf MapCache
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the map cache instance.
	     */
	    function mapCacheSet(key, value) {
	      var data = getMapData(this, key),
	          size = data.size;
	
	      data.set(key, value);
	      this.size += data.size == size ? 0 : 1;
	      return this;
	    }
	
	    // Add methods to `MapCache`.
	    MapCache.prototype.clear = mapCacheClear;
	    MapCache.prototype['delete'] = mapCacheDelete;
	    MapCache.prototype.get = mapCacheGet;
	    MapCache.prototype.has = mapCacheHas;
	    MapCache.prototype.set = mapCacheSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     *
	     * Creates an array cache object to store unique values.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [values] The values to cache.
	     */
	    function SetCache(values) {
	      var index = -1,
	          length = values == null ? 0 : values.length;
	
	      this.__data__ = new MapCache;
	      while (++index < length) {
	        this.add(values[index]);
	      }
	    }
	
	    /**
	     * Adds `value` to the array cache.
	     *
	     * @private
	     * @name add
	     * @memberOf SetCache
	     * @alias push
	     * @param {*} value The value to cache.
	     * @returns {Object} Returns the cache instance.
	     */
	    function setCacheAdd(value) {
	      this.__data__.set(value, HASH_UNDEFINED);
	      return this;
	    }
	
	    /**
	     * Checks if `value` is in the array cache.
	     *
	     * @private
	     * @name has
	     * @memberOf SetCache
	     * @param {*} value The value to search for.
	     * @returns {number} Returns `true` if `value` is found, else `false`.
	     */
	    function setCacheHas(value) {
	      return this.__data__.has(value);
	    }
	
	    // Add methods to `SetCache`.
	    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	    SetCache.prototype.has = setCacheHas;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a stack cache object to store key-value pairs.
	     *
	     * @private
	     * @constructor
	     * @param {Array} [entries] The key-value pairs to cache.
	     */
	    function Stack(entries) {
	      var data = this.__data__ = new ListCache(entries);
	      this.size = data.size;
	    }
	
	    /**
	     * Removes all key-value entries from the stack.
	     *
	     * @private
	     * @name clear
	     * @memberOf Stack
	     */
	    function stackClear() {
	      this.__data__ = new ListCache;
	      this.size = 0;
	    }
	
	    /**
	     * Removes `key` and its value from the stack.
	     *
	     * @private
	     * @name delete
	     * @memberOf Stack
	     * @param {string} key The key of the value to remove.
	     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	     */
	    function stackDelete(key) {
	      var data = this.__data__,
	          result = data['delete'](key);
	
	      this.size = data.size;
	      return result;
	    }
	
	    /**
	     * Gets the stack value for `key`.
	     *
	     * @private
	     * @name get
	     * @memberOf Stack
	     * @param {string} key The key of the value to get.
	     * @returns {*} Returns the entry value.
	     */
	    function stackGet(key) {
	      return this.__data__.get(key);
	    }
	
	    /**
	     * Checks if a stack value for `key` exists.
	     *
	     * @private
	     * @name has
	     * @memberOf Stack
	     * @param {string} key The key of the entry to check.
	     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	     */
	    function stackHas(key) {
	      return this.__data__.has(key);
	    }
	
	    /**
	     * Sets the stack `key` to `value`.
	     *
	     * @private
	     * @name set
	     * @memberOf Stack
	     * @param {string} key The key of the value to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns the stack cache instance.
	     */
	    function stackSet(key, value) {
	      var data = this.__data__;
	      if (data instanceof ListCache) {
	        var pairs = data.__data__;
	        if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	          pairs.push([key, value]);
	          this.size = ++data.size;
	          return this;
	        }
	        data = this.__data__ = new MapCache(pairs);
	      }
	      data.set(key, value);
	      this.size = data.size;
	      return this;
	    }
	
	    // Add methods to `Stack`.
	    Stack.prototype.clear = stackClear;
	    Stack.prototype['delete'] = stackDelete;
	    Stack.prototype.get = stackGet;
	    Stack.prototype.has = stackHas;
	    Stack.prototype.set = stackSet;
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of the enumerable property names of the array-like `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @param {boolean} inherited Specify returning inherited property names.
	     * @returns {Array} Returns the array of property names.
	     */
	    function arrayLikeKeys(value, inherited) {
	      var isArr = isArray(value),
	          isArg = !isArr && isArguments(value),
	          isBuff = !isArr && !isArg && isBuffer(value),
	          isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	          skipIndexes = isArr || isArg || isBuff || isType,
	          result = skipIndexes ? baseTimes(value.length, String) : [],
	          length = result.length;
	
	      for (var key in value) {
	        if ((inherited || hasOwnProperty.call(value, key)) &&
	            !(skipIndexes && (
	               // Safari 9 has enumerable `arguments.length` in strict mode.
	               key == 'length' ||
	               // Node.js 0.10 has enumerable non-index properties on buffers.
	               (isBuff && (key == 'offset' || key == 'parent')) ||
	               // PhantomJS 2 has enumerable non-index properties on typed arrays.
	               (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	               // Skip index properties.
	               isIndex(key, length)
	            ))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `_.sample` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @returns {*} Returns the random element.
	     */
	    function arraySample(array) {
	      var length = array.length;
	      return length ? array[baseRandom(0, length - 1)] : undefined;
	    }
	
	    /**
	     * A specialized version of `_.sampleSize` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function arraySampleSize(array, n) {
	      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * A specialized version of `_.shuffle` for arrays.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function arrayShuffle(array) {
	      return shuffleSelf(copyArray(array));
	    }
	
	    /**
	     * This function is like `assignValue` except that it doesn't assign
	     * `undefined` values.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignMergeValue(object, key, value) {
	      if ((value !== undefined && !eq(object[key], value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Assigns `value` to `key` of `object` if the existing value is not equivalent
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function assignValue(object, key, value) {
	      var objValue = object[key];
	      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	          (value === undefined && !(key in object))) {
	        baseAssignValue(object, key, value);
	      }
	    }
	
	    /**
	     * Gets the index at which the `key` is found in `array` of key-value pairs.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {*} key The key to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     */
	    function assocIndexOf(array, key) {
	      var length = array.length;
	      while (length--) {
	        if (eq(array[length][0], key)) {
	          return length;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * Aggregates elements of `collection` on `accumulator` with keys transformed
	     * by `iteratee` and values set by `setter`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform keys.
	     * @param {Object} accumulator The initial aggregated object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseAggregator(collection, setter, iteratee, accumulator) {
	      baseEach(collection, function(value, key, collection) {
	        setter(accumulator, value, iteratee(value), collection);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.assign` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssign(object, source) {
	      return object && copyObject(source, keys(source), object);
	    }
	
	    /**
	     * The base implementation of `_.assignIn` without support for multiple sources
	     * or `customizer` functions.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @returns {Object} Returns `object`.
	     */
	    function baseAssignIn(object, source) {
	      return object && copyObject(source, keysIn(source), object);
	    }
	
	    /**
	     * The base implementation of `assignValue` and `assignMergeValue` without
	     * value checks.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {string} key The key of the property to assign.
	     * @param {*} value The value to assign.
	     */
	    function baseAssignValue(object, key, value) {
	      if (key == '__proto__' && defineProperty) {
	        defineProperty(object, key, {
	          'configurable': true,
	          'enumerable': true,
	          'value': value,
	          'writable': true
	        });
	      } else {
	        object[key] = value;
	      }
	    }
	
	    /**
	     * The base implementation of `_.at` without support for individual paths.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Array} Returns the picked elements.
	     */
	    function baseAt(object, paths) {
	      var index = -1,
	          length = paths.length,
	          result = Array(length),
	          skip = object == null;
	
	      while (++index < length) {
	        result[index] = skip ? undefined : get(object, paths[index]);
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.clamp` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     */
	    function baseClamp(number, lower, upper) {
	      if (number === number) {
	        if (upper !== undefined) {
	          number = number <= upper ? number : upper;
	        }
	        if (lower !== undefined) {
	          number = number >= lower ? number : lower;
	        }
	      }
	      return number;
	    }
	
	    /**
	     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	     * traversed objects.
	     *
	     * @private
	     * @param {*} value The value to clone.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Deep clone
	     *  2 - Flatten inherited properties
	     *  4 - Clone symbols
	     * @param {Function} [customizer] The function to customize cloning.
	     * @param {string} [key] The key of `value`.
	     * @param {Object} [object] The parent object of `value`.
	     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	     * @returns {*} Returns the cloned value.
	     */
	    function baseClone(value, bitmask, customizer, key, object, stack) {
	      var result,
	          isDeep = bitmask & CLONE_DEEP_FLAG,
	          isFlat = bitmask & CLONE_FLAT_FLAG,
	          isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	      if (customizer) {
	        result = object ? customizer(value, key, object, stack) : customizer(value);
	      }
	      if (result !== undefined) {
	        return result;
	      }
	      if (!isObject(value)) {
	        return value;
	      }
	      var isArr = isArray(value);
	      if (isArr) {
	        result = initCloneArray(value);
	        if (!isDeep) {
	          return copyArray(value, result);
	        }
	      } else {
	        var tag = getTag(value),
	            isFunc = tag == funcTag || tag == genTag;
	
	        if (isBuffer(value)) {
	          return cloneBuffer(value, isDeep);
	        }
	        if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	          result = (isFlat || isFunc) ? {} : initCloneObject(value);
	          if (!isDeep) {
	            return isFlat
	              ? copySymbolsIn(value, baseAssignIn(result, value))
	              : copySymbols(value, baseAssign(result, value));
	          }
	        } else {
	          if (!cloneableTags[tag]) {
	            return object ? value : {};
	          }
	          result = initCloneByTag(value, tag, baseClone, isDeep);
	        }
	      }
	      // Check for circular references and return its corresponding clone.
	      stack || (stack = new Stack);
	      var stacked = stack.get(value);
	      if (stacked) {
	        return stacked;
	      }
	      stack.set(value, result);
	
	      var keysFunc = isFull
	        ? (isFlat ? getAllKeysIn : getAllKeys)
	        : (isFlat ? keysIn : keys);
	
	      var props = isArr ? undefined : keysFunc(value);
	      arrayEach(props || value, function(subValue, key) {
	        if (props) {
	          key = subValue;
	          subValue = value[key];
	        }
	        // Recursively populate clone (susceptible to call stack limits).
	        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.conforms` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseConforms(source) {
	      var props = keys(source);
	      return function(object) {
	        return baseConformsTo(object, source, props);
	      };
	    }
	
	    /**
	     * The base implementation of `_.conformsTo` which accepts `props` to check.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     */
	    function baseConformsTo(object, source, props) {
	      var length = props.length;
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (length--) {
	        var key = props[length],
	            predicate = source[key],
	            value = object[key];
	
	        if ((value === undefined && !(key in object)) || !predicate(value)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.delay` and `_.defer` which accepts `args`
	     * to provide to `func`.
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {Array} args The arguments to provide to `func`.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    function baseDelay(func, wait, args) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return setTimeout(function() { func.apply(undefined, args); }, wait);
	    }
	
	    /**
	     * The base implementation of methods like `_.difference` without support
	     * for excluding multiple arrays or iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Array} values The values to exclude.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     */
	    function baseDifference(array, values, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          isCommon = true,
	          length = array.length,
	          result = [],
	          valuesLength = values.length;
	
	      if (!length) {
	        return result;
	      }
	      if (iteratee) {
	        values = arrayMap(values, baseUnary(iteratee));
	      }
	      if (comparator) {
	        includes = arrayIncludesWith;
	        isCommon = false;
	      }
	      else if (values.length >= LARGE_ARRAY_SIZE) {
	        includes = cacheHas;
	        isCommon = false;
	        values = new SetCache(values);
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee == null ? value : iteratee(value);
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var valuesIndex = valuesLength;
	          while (valuesIndex--) {
	            if (values[valuesIndex] === computed) {
	              continue outer;
	            }
	          }
	          result.push(value);
	        }
	        else if (!includes(values, computed, comparator)) {
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.forEach` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEach = createBaseEach(baseForOwn);
	
	    /**
	     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     */
	    var baseEachRight = createBaseEach(baseForOwnRight, true);
	
	    /**
	     * The base implementation of `_.every` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`
	     */
	    function baseEvery(collection, predicate) {
	      var result = true;
	      baseEach(collection, function(value, index, collection) {
	        result = !!predicate(value, index, collection);
	        return result;
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of methods like `_.max` and `_.min` which accepts a
	     * `comparator` to determine the extremum value.
	     *
	     * @private
	     * @param {Array} array The array to iterate over.
	     * @param {Function} iteratee The iteratee invoked per iteration.
	     * @param {Function} comparator The comparator used to compare values.
	     * @returns {*} Returns the extremum value.
	     */
	    function baseExtremum(array, iteratee, comparator) {
	      var index = -1,
	          length = array.length;
	
	      while (++index < length) {
	        var value = array[index],
	            current = iteratee(value);
	
	        if (current != null && (computed === undefined
	              ? (current === current && !isSymbol(current))
	              : comparator(current, computed)
	            )) {
	          var computed = current,
	              result = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.fill` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     */
	    function baseFill(array, value, start, end) {
	      var length = array.length;
	
	      start = toInteger(start);
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = (end === undefined || end > length) ? length : toInteger(end);
	      if (end < 0) {
	        end += length;
	      }
	      end = start > end ? 0 : toLength(end);
	      while (start < end) {
	        array[start++] = value;
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.filter` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     */
	    function baseFilter(collection, predicate) {
	      var result = [];
	      baseEach(collection, function(value, index, collection) {
	        if (predicate(value, index, collection)) {
	          result.push(value);
	        }
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.flatten` with support for restricting flattening.
	     *
	     * @private
	     * @param {Array} array The array to flatten.
	     * @param {number} depth The maximum recursion depth.
	     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	     * @param {Array} [result=[]] The initial result value.
	     * @returns {Array} Returns the new flattened array.
	     */
	    function baseFlatten(array, depth, predicate, isStrict, result) {
	      var index = -1,
	          length = array.length;
	
	      predicate || (predicate = isFlattenable);
	      result || (result = []);
	
	      while (++index < length) {
	        var value = array[index];
	        if (depth > 0 && predicate(value)) {
	          if (depth > 1) {
	            // Recursively flatten arrays (susceptible to call stack limits).
	            baseFlatten(value, depth - 1, predicate, isStrict, result);
	          } else {
	            arrayPush(result, value);
	          }
	        } else if (!isStrict) {
	          result[result.length] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `baseForOwn` which iterates over `object`
	     * properties returned by `keysFunc` and invokes `iteratee` for each property.
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseFor = createBaseFor();
	
	    /**
	     * This function is like `baseFor` except that it iterates over properties
	     * in the opposite order.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @returns {Object} Returns `object`.
	     */
	    var baseForRight = createBaseFor(true);
	
	    /**
	     * The base implementation of `_.forOwn` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwn(object, iteratee) {
	      return object && baseFor(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     */
	    function baseForOwnRight(object, iteratee) {
	      return object && baseForRight(object, iteratee, keys);
	    }
	
	    /**
	     * The base implementation of `_.functions` which creates an array of
	     * `object` function property names filtered from `props`.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Array} props The property names to filter.
	     * @returns {Array} Returns the function names.
	     */
	    function baseFunctions(object, props) {
	      return arrayFilter(props, function(key) {
	        return isFunction(object[key]);
	      });
	    }
	
	    /**
	     * The base implementation of `_.get` without support for default values.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseGet(object, path) {
	      path = castPath(path, object);
	
	      var index = 0,
	          length = path.length;
	
	      while (object != null && index < length) {
	        object = object[toKey(path[index++])];
	      }
	      return (index && index == length) ? object : undefined;
	    }
	
	    /**
	     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Function} keysFunc The function to get the keys of `object`.
	     * @param {Function} symbolsFunc The function to get the symbols of `object`.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	      var result = keysFunc(object);
	      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	    }
	
	    /**
	     * The base implementation of `getTag` without fallbacks for buggy environments.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    function baseGetTag(value) {
	      if (value == null) {
	        return value === undefined ? undefinedTag : nullTag;
	      }
	      return (symToStringTag && symToStringTag in Object(value))
	        ? getRawTag(value)
	        : objectToString(value);
	    }
	
	    /**
	     * The base implementation of `_.gt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     */
	    function baseGt(value, other) {
	      return value > other;
	    }
	
	    /**
	     * The base implementation of `_.has` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHas(object, key) {
	      return object != null && hasOwnProperty.call(object, key);
	    }
	
	    /**
	     * The base implementation of `_.hasIn` without support for deep paths.
	     *
	     * @private
	     * @param {Object} [object] The object to query.
	     * @param {Array|string} key The key to check.
	     * @returns {boolean} Returns `true` if `key` exists, else `false`.
	     */
	    function baseHasIn(object, key) {
	      return object != null && key in Object(object);
	    }
	
	    /**
	     * The base implementation of `_.inRange` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {number} number The number to check.
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     */
	    function baseInRange(number, start, end) {
	      return number >= nativeMin(start, end) && number < nativeMax(start, end);
	    }
	
	    /**
	     * The base implementation of methods like `_.intersection`, without support
	     * for iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of shared values.
	     */
	    function baseIntersection(arrays, iteratee, comparator) {
	      var includes = comparator ? arrayIncludesWith : arrayIncludes,
	          length = arrays[0].length,
	          othLength = arrays.length,
	          othIndex = othLength,
	          caches = Array(othLength),
	          maxLength = Infinity,
	          result = [];
	
	      while (othIndex--) {
	        var array = arrays[othIndex];
	        if (othIndex && iteratee) {
	          array = arrayMap(array, baseUnary(iteratee));
	        }
	        maxLength = nativeMin(array.length, maxLength);
	        caches[othIndex] = !comparator && (iteratee || (length >= 120 && array.length >= 120))
	          ? new SetCache(othIndex && array)
	          : undefined;
	      }
	      array = arrays[0];
	
	      var index = -1,
	          seen = caches[0];
	
	      outer:
	      while (++index < length && result.length < maxLength) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (!(seen
	              ? cacheHas(seen, computed)
	              : includes(result, computed, comparator)
	            )) {
	          othIndex = othLength;
	          while (--othIndex) {
	            var cache = caches[othIndex];
	            if (!(cache
	                  ? cacheHas(cache, computed)
	                  : includes(arrays[othIndex], computed, comparator))
	                ) {
	              continue outer;
	            }
	          }
	          if (seen) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.invert` and `_.invertBy` which inverts
	     * `object` with values transformed by `iteratee` and set by `setter`.
	     *
	     * @private
	     * @param {Object} object The object to iterate over.
	     * @param {Function} setter The function to set `accumulator` values.
	     * @param {Function} iteratee The iteratee to transform values.
	     * @param {Object} accumulator The initial inverted object.
	     * @returns {Function} Returns `accumulator`.
	     */
	    function baseInverter(object, setter, iteratee, accumulator) {
	      baseForOwn(object, function(value, key, object) {
	        setter(accumulator, iteratee(value), key, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * The base implementation of `_.invoke` without support for individual
	     * method arguments.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {Array} args The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     */
	    function baseInvoke(object, path, args) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      var func = object == null ? object : object[toKey(last(path))];
	      return func == null ? undefined : apply(func, object, args);
	    }
	
	    /**
	     * The base implementation of `_.isArguments`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     */
	    function baseIsArguments(value) {
	      return isObjectLike(value) && baseGetTag(value) == argsTag;
	    }
	
	    /**
	     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     */
	    function baseIsArrayBuffer(value) {
	      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
	    }
	
	    /**
	     * The base implementation of `_.isDate` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     */
	    function baseIsDate(value) {
	      return isObjectLike(value) && baseGetTag(value) == dateTag;
	    }
	
	    /**
	     * The base implementation of `_.isEqual` which supports partial comparisons
	     * and tracks traversed objects.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {boolean} bitmask The bitmask flags.
	     *  1 - Unordered comparison
	     *  2 - Partial comparison
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     */
	    function baseIsEqual(value, other, bitmask, customizer, stack) {
	      if (value === other) {
	        return true;
	      }
	      if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	        return value !== value && other !== other;
	      }
	      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	    }
	
	    /**
	     * A specialized version of `baseIsEqual` for arrays and objects which performs
	     * deep comparisons and tracks traversed objects enabling objects with circular
	     * references to be compared.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	      var objIsArr = isArray(object),
	          othIsArr = isArray(other),
	          objTag = objIsArr ? arrayTag : getTag(object),
	          othTag = othIsArr ? arrayTag : getTag(other);
	
	      objTag = objTag == argsTag ? objectTag : objTag;
	      othTag = othTag == argsTag ? objectTag : othTag;
	
	      var objIsObj = objTag == objectTag,
	          othIsObj = othTag == objectTag,
	          isSameTag = objTag == othTag;
	
	      if (isSameTag && isBuffer(object)) {
	        if (!isBuffer(other)) {
	          return false;
	        }
	        objIsArr = true;
	        objIsObj = false;
	      }
	      if (isSameTag && !objIsObj) {
	        stack || (stack = new Stack);
	        return (objIsArr || isTypedArray(object))
	          ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	          : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	      }
	      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	            othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	        if (objIsWrapped || othIsWrapped) {
	          var objUnwrapped = objIsWrapped ? object.value() : object,
	              othUnwrapped = othIsWrapped ? other.value() : other;
	
	          stack || (stack = new Stack);
	          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	        }
	      }
	      if (!isSameTag) {
	        return false;
	      }
	      stack || (stack = new Stack);
	      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	    }
	
	    /**
	     * The base implementation of `_.isMap` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     */
	    function baseIsMap(value) {
	      return isObjectLike(value) && getTag(value) == mapTag;
	    }
	
	    /**
	     * The base implementation of `_.isMatch` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Array} matchData The property names, values, and compare flags to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     */
	    function baseIsMatch(object, source, matchData, customizer) {
	      var index = matchData.length,
	          length = index,
	          noCustomizer = !customizer;
	
	      if (object == null) {
	        return !length;
	      }
	      object = Object(object);
	      while (index--) {
	        var data = matchData[index];
	        if ((noCustomizer && data[2])
	              ? data[1] !== object[data[0]]
	              : !(data[0] in object)
	            ) {
	          return false;
	        }
	      }
	      while (++index < length) {
	        data = matchData[index];
	        var key = data[0],
	            objValue = object[key],
	            srcValue = data[1];
	
	        if (noCustomizer && data[2]) {
	          if (objValue === undefined && !(key in object)) {
	            return false;
	          }
	        } else {
	          var stack = new Stack;
	          if (customizer) {
	            var result = customizer(objValue, srcValue, key, object, source, stack);
	          }
	          if (!(result === undefined
	                ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	                : result
	              )) {
	            return false;
	          }
	        }
	      }
	      return true;
	    }
	
	    /**
	     * The base implementation of `_.isNative` without bad shim checks.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     */
	    function baseIsNative(value) {
	      if (!isObject(value) || isMasked(value)) {
	        return false;
	      }
	      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	      return pattern.test(toSource(value));
	    }
	
	    /**
	     * The base implementation of `_.isRegExp` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     */
	    function baseIsRegExp(value) {
	      return isObjectLike(value) && baseGetTag(value) == regexpTag;
	    }
	
	    /**
	     * The base implementation of `_.isSet` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     */
	    function baseIsSet(value) {
	      return isObjectLike(value) && getTag(value) == setTag;
	    }
	
	    /**
	     * The base implementation of `_.isTypedArray` without Node.js optimizations.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     */
	    function baseIsTypedArray(value) {
	      return isObjectLike(value) &&
	        isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	    }
	
	    /**
	     * The base implementation of `_.iteratee`.
	     *
	     * @private
	     * @param {*} [value=_.identity] The value to convert to an iteratee.
	     * @returns {Function} Returns the iteratee.
	     */
	    function baseIteratee(value) {
	      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	      if (typeof value == 'function') {
	        return value;
	      }
	      if (value == null) {
	        return identity;
	      }
	      if (typeof value == 'object') {
	        return isArray(value)
	          ? baseMatchesProperty(value[0], value[1])
	          : baseMatches(value);
	      }
	      return property(value);
	    }
	
	    /**
	     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeys(object) {
	      if (!isPrototype(object)) {
	        return nativeKeys(object);
	      }
	      var result = [];
	      for (var key in Object(object)) {
	        if (hasOwnProperty.call(object, key) && key != 'constructor') {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function baseKeysIn(object) {
	      if (!isObject(object)) {
	        return nativeKeysIn(object);
	      }
	      var isProto = isPrototype(object),
	          result = [];
	
	      for (var key in object) {
	        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.lt` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     */
	    function baseLt(value, other) {
	      return value < other;
	    }
	
	    /**
	     * The base implementation of `_.map` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} iteratee The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     */
	    function baseMap(collection, iteratee) {
	      var index = -1,
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value, key, collection) {
	        result[++index] = iteratee(value, key, collection);
	      });
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.matches` which doesn't clone `source`.
	     *
	     * @private
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatches(source) {
	      var matchData = getMatchData(source);
	      if (matchData.length == 1 && matchData[0][2]) {
	        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	      }
	      return function(object) {
	        return object === source || baseIsMatch(object, source, matchData);
	      };
	    }
	
	    /**
	     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	     *
	     * @private
	     * @param {string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function baseMatchesProperty(path, srcValue) {
	      if (isKey(path) && isStrictComparable(srcValue)) {
	        return matchesStrictComparable(toKey(path), srcValue);
	      }
	      return function(object) {
	        var objValue = get(object, path);
	        return (objValue === undefined && objValue === srcValue)
	          ? hasIn(object, path)
	          : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	      };
	    }
	
	    /**
	     * The base implementation of `_.merge` without support for multiple sources.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} [customizer] The function to customize merged values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMerge(object, source, srcIndex, customizer, stack) {
	      if (object === source) {
	        return;
	      }
	      baseFor(source, function(srcValue, key) {
	        if (isObject(srcValue)) {
	          stack || (stack = new Stack);
	          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	        }
	        else {
	          var newValue = customizer
	            ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	            : undefined;
	
	          if (newValue === undefined) {
	            newValue = srcValue;
	          }
	          assignMergeValue(object, key, newValue);
	        }
	      }, keysIn);
	    }
	
	    /**
	     * A specialized version of `baseMerge` for arrays and objects which performs
	     * deep merges and tracks traversed objects enabling objects with circular
	     * references to be merged.
	     *
	     * @private
	     * @param {Object} object The destination object.
	     * @param {Object} source The source object.
	     * @param {string} key The key of the value to merge.
	     * @param {number} srcIndex The index of `source`.
	     * @param {Function} mergeFunc The function to merge values.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     */
	    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	      var objValue = object[key],
	          srcValue = source[key],
	          stacked = stack.get(srcValue);
	
	      if (stacked) {
	        assignMergeValue(object, key, stacked);
	        return;
	      }
	      var newValue = customizer
	        ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      var isCommon = newValue === undefined;
	
	      if (isCommon) {
	        var isArr = isArray(srcValue),
	            isBuff = !isArr && isBuffer(srcValue),
	            isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	        newValue = srcValue;
	        if (isArr || isBuff || isTyped) {
	          if (isArray(objValue)) {
	            newValue = objValue;
	          }
	          else if (isArrayLikeObject(objValue)) {
	            newValue = copyArray(objValue);
	          }
	          else if (isBuff) {
	            isCommon = false;
	            newValue = cloneBuffer(srcValue, true);
	          }
	          else if (isTyped) {
	            isCommon = false;
	            newValue = cloneTypedArray(srcValue, true);
	          }
	          else {
	            newValue = [];
	          }
	        }
	        else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	          newValue = objValue;
	          if (isArguments(objValue)) {
	            newValue = toPlainObject(objValue);
	          }
	          else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	            newValue = initCloneObject(srcValue);
	          }
	        }
	        else {
	          isCommon = false;
	        }
	      }
	      if (isCommon) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, newValue);
	        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	        stack['delete'](srcValue);
	      }
	      assignMergeValue(object, key, newValue);
	    }
	
	    /**
	     * The base implementation of `_.nth` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {number} n The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     */
	    function baseNth(array, n) {
	      var length = array.length;
	      if (!length) {
	        return;
	      }
	      n += n < 0 ? length : 0;
	      return isIndex(n, length) ? array[n] : undefined;
	    }
	
	    /**
	     * The base implementation of `_.orderBy` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
	     * @param {string[]} orders The sort orders of `iteratees`.
	     * @returns {Array} Returns the new sorted array.
	     */
	    function baseOrderBy(collection, iteratees, orders) {
	      var index = -1;
	      iteratees = arrayMap(iteratees.length ? iteratees : [identity], baseUnary(getIteratee()));
	
	      var result = baseMap(collection, function(value, key, collection) {
	        var criteria = arrayMap(iteratees, function(iteratee) {
	          return iteratee(value);
	        });
	        return { 'criteria': criteria, 'index': ++index, 'value': value };
	      });
	
	      return baseSortBy(result, function(object, other) {
	        return compareMultiple(object, other, orders);
	      });
	    }
	
	    /**
	     * The base implementation of `_.pick` without support for individual
	     * property identifiers.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @returns {Object} Returns the new object.
	     */
	    function basePick(object, paths) {
	      return basePickBy(object, paths, function(value, path) {
	        return hasIn(object, path);
	      });
	    }
	
	    /**
	     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Object} object The source object.
	     * @param {string[]} paths The property paths to pick.
	     * @param {Function} predicate The function invoked per property.
	     * @returns {Object} Returns the new object.
	     */
	    function basePickBy(object, paths, predicate) {
	      var index = -1,
	          length = paths.length,
	          result = {};
	
	      while (++index < length) {
	        var path = paths[index],
	            value = baseGet(object, path);
	
	        if (predicate(value, path)) {
	          baseSet(result, castPath(path, object), value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseProperty` which supports deep paths.
	     *
	     * @private
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     */
	    function basePropertyDeep(path) {
	      return function(object) {
	        return baseGet(object, path);
	      };
	    }
	
	    /**
	     * The base implementation of `_.pullAllBy` without support for iteratee
	     * shorthands.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAll(array, values, iteratee, comparator) {
	      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
	          index = -1,
	          length = values.length,
	          seen = array;
	
	      if (array === values) {
	        values = copyArray(values);
	      }
	      if (iteratee) {
	        seen = arrayMap(array, baseUnary(iteratee));
	      }
	      while (++index < length) {
	        var fromIndex = 0,
	            value = values[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
	          if (seen !== array) {
	            splice.call(seen, fromIndex, 1);
	          }
	          splice.call(array, fromIndex, 1);
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.pullAt` without support for individual
	     * indexes or capturing the removed elements.
	     *
	     * @private
	     * @param {Array} array The array to modify.
	     * @param {number[]} indexes The indexes of elements to remove.
	     * @returns {Array} Returns `array`.
	     */
	    function basePullAt(array, indexes) {
	      var length = array ? indexes.length : 0,
	          lastIndex = length - 1;
	
	      while (length--) {
	        var index = indexes[length];
	        if (length == lastIndex || index !== previous) {
	          var previous = index;
	          if (isIndex(index)) {
	            splice.call(array, index, 1);
	          } else {
	            baseUnset(array, index);
	          }
	        }
	      }
	      return array;
	    }
	
	    /**
	     * The base implementation of `_.random` without support for returning
	     * floating-point numbers.
	     *
	     * @private
	     * @param {number} lower The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the random number.
	     */
	    function baseRandom(lower, upper) {
	      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
	    }
	
	    /**
	     * The base implementation of `_.range` and `_.rangeRight` which doesn't
	     * coerce arguments.
	     *
	     * @private
	     * @param {number} start The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} step The value to increment or decrement by.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the range of numbers.
	     */
	    function baseRange(start, end, step, fromRight) {
	      var index = -1,
	          length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
	          result = Array(length);
	
	      while (length--) {
	        result[fromRight ? length : ++index] = start;
	        start += step;
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.repeat` which doesn't coerce arguments.
	     *
	     * @private
	     * @param {string} string The string to repeat.
	     * @param {number} n The number of times to repeat the string.
	     * @returns {string} Returns the repeated string.
	     */
	    function baseRepeat(string, n) {
	      var result = '';
	      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
	        return result;
	      }
	      // Leverage the exponentiation by squaring algorithm for a faster repeat.
	      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
	      do {
	        if (n % 2) {
	          result += string;
	        }
	        n = nativeFloor(n / 2);
	        if (n) {
	          string += string;
	        }
	      } while (n);
	
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     */
	    function baseRest(func, start) {
	      return setToString(overRest(func, start, identity), func + '');
	    }
	
	    /**
	     * The base implementation of `_.sample`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     */
	    function baseSample(collection) {
	      return arraySample(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.sampleSize` without param guards.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} n The number of elements to sample.
	     * @returns {Array} Returns the random elements.
	     */
	    function baseSampleSize(collection, n) {
	      var array = values(collection);
	      return shuffleSelf(array, baseClamp(n, 0, array.length));
	    }
	
	    /**
	     * The base implementation of `_.set`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseSet(object, path, value, customizer) {
	      if (!isObject(object)) {
	        return object;
	      }
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          lastIndex = length - 1,
	          nested = object;
	
	      while (nested != null && ++index < length) {
	        var key = toKey(path[index]),
	            newValue = value;
	
	        if (index != lastIndex) {
	          var objValue = nested[key];
	          newValue = customizer ? customizer(objValue, key, nested) : undefined;
	          if (newValue === undefined) {
	            newValue = isObject(objValue)
	              ? objValue
	              : (isIndex(path[index + 1]) ? [] : {});
	          }
	        }
	        assignValue(nested, key, newValue);
	        nested = nested[key];
	      }
	      return object;
	    }
	
	    /**
	     * The base implementation of `setData` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetData = !metaMap ? identity : function(func, data) {
	      metaMap.set(func, data);
	      return func;
	    };
	
	    /**
	     * The base implementation of `setToString` without support for hot loop shorting.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var baseSetToString = !defineProperty ? identity : function(func, string) {
	      return defineProperty(func, 'toString', {
	        'configurable': true,
	        'enumerable': false,
	        'value': constant(string),
	        'writable': true
	      });
	    };
	
	    /**
	     * The base implementation of `_.shuffle`.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     */
	    function baseShuffle(collection) {
	      return shuffleSelf(values(collection));
	    }
	
	    /**
	     * The base implementation of `_.slice` without an iteratee call guard.
	     *
	     * @private
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseSlice(array, start, end) {
	      var index = -1,
	          length = array.length;
	
	      if (start < 0) {
	        start = -start > length ? 0 : (length + start);
	      }
	      end = end > length ? length : end;
	      if (end < 0) {
	        end += length;
	      }
	      length = start > end ? 0 : ((end - start) >>> 0);
	      start >>>= 0;
	
	      var result = Array(length);
	      while (++index < length) {
	        result[index] = array[index + start];
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.some` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} predicate The function invoked per iteration.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     */
	    function baseSome(collection, predicate) {
	      var result;
	
	      baseEach(collection, function(value, index, collection) {
	        result = predicate(value, index, collection);
	        return !result;
	      });
	      return !!result;
	    }
	
	    /**
	     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
	     * performs a binary search of `array` to determine the index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndex(array, value, retHighest) {
	      var low = 0,
	          high = array == null ? low : array.length;
	
	      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
	        while (low < high) {
	          var mid = (low + high) >>> 1,
	              computed = array[mid];
	
	          if (computed !== null && !isSymbol(computed) &&
	              (retHighest ? (computed <= value) : (computed < value))) {
	            low = mid + 1;
	          } else {
	            high = mid;
	          }
	        }
	        return high;
	      }
	      return baseSortedIndexBy(array, value, identity, retHighest);
	    }
	
	    /**
	     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
	     * which invokes `iteratee` for `value` and each element of `array` to compute
	     * their sort ranking. The iteratee is invoked with one argument; (value).
	     *
	     * @private
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} iteratee The iteratee invoked per element.
	     * @param {boolean} [retHighest] Specify returning the highest qualified index.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     */
	    function baseSortedIndexBy(array, value, iteratee, retHighest) {
	      value = iteratee(value);
	
	      var low = 0,
	          high = array == null ? 0 : array.length,
	          valIsNaN = value !== value,
	          valIsNull = value === null,
	          valIsSymbol = isSymbol(value),
	          valIsUndefined = value === undefined;
	
	      while (low < high) {
	        var mid = nativeFloor((low + high) / 2),
	            computed = iteratee(array[mid]),
	            othIsDefined = computed !== undefined,
	            othIsNull = computed === null,
	            othIsReflexive = computed === computed,
	            othIsSymbol = isSymbol(computed);
	
	        if (valIsNaN) {
	          var setLow = retHighest || othIsReflexive;
	        } else if (valIsUndefined) {
	          setLow = othIsReflexive && (retHighest || othIsDefined);
	        } else if (valIsNull) {
	          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
	        } else if (valIsSymbol) {
	          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
	        } else if (othIsNull || othIsSymbol) {
	          setLow = false;
	        } else {
	          setLow = retHighest ? (computed <= value) : (computed < value);
	        }
	        if (setLow) {
	          low = mid + 1;
	        } else {
	          high = mid;
	        }
	      }
	      return nativeMin(high, MAX_ARRAY_INDEX);
	    }
	
	    /**
	     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
	     * support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseSortedUniq(array, iteratee) {
	      var index = -1,
	          length = array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        if (!index || !eq(computed, seen)) {
	          var seen = computed;
	          result[resIndex++] = value === 0 ? 0 : value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.toNumber` which doesn't ensure correct
	     * conversions of binary, hexadecimal, or octal string values.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     */
	    function baseToNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      return +value;
	    }
	
	    /**
	     * The base implementation of `_.toString` which doesn't convert nullish
	     * values to empty strings.
	     *
	     * @private
	     * @param {*} value The value to process.
	     * @returns {string} Returns the string.
	     */
	    function baseToString(value) {
	      // Exit early for strings to avoid a performance hit in some environments.
	      if (typeof value == 'string') {
	        return value;
	      }
	      if (isArray(value)) {
	        // Recursively convert values (susceptible to call stack limits).
	        return arrayMap(value, baseToString) + '';
	      }
	      if (isSymbol(value)) {
	        return symbolToString ? symbolToString.call(value) : '';
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     */
	    function baseUniq(array, iteratee, comparator) {
	      var index = -1,
	          includes = arrayIncludes,
	          length = array.length,
	          isCommon = true,
	          result = [],
	          seen = result;
	
	      if (comparator) {
	        isCommon = false;
	        includes = arrayIncludesWith;
	      }
	      else if (length >= LARGE_ARRAY_SIZE) {
	        var set = iteratee ? null : createSet(array);
	        if (set) {
	          return setToArray(set);
	        }
	        isCommon = false;
	        includes = cacheHas;
	        seen = new SetCache;
	      }
	      else {
	        seen = iteratee ? [] : result;
	      }
	      outer:
	      while (++index < length) {
	        var value = array[index],
	            computed = iteratee ? iteratee(value) : value;
	
	        value = (comparator || value !== 0) ? value : 0;
	        if (isCommon && computed === computed) {
	          var seenIndex = seen.length;
	          while (seenIndex--) {
	            if (seen[seenIndex] === computed) {
	              continue outer;
	            }
	          }
	          if (iteratee) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	        else if (!includes(seen, computed, comparator)) {
	          if (seen !== result) {
	            seen.push(computed);
	          }
	          result.push(value);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * The base implementation of `_.unset`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The property path to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     */
	    function baseUnset(object, path) {
	      path = castPath(path, object);
	      object = parent(object, path);
	      return object == null || delete object[toKey(last(path))];
	    }
	
	    /**
	     * The base implementation of `_.update`.
	     *
	     * @private
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to update.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize path creation.
	     * @returns {Object} Returns `object`.
	     */
	    function baseUpdate(object, path, updater, customizer) {
	      return baseSet(object, path, updater(baseGet(object, path)), customizer);
	    }
	
	    /**
	     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
	     * without support for iteratee shorthands.
	     *
	     * @private
	     * @param {Array} array The array to query.
	     * @param {Function} predicate The function invoked per iteration.
	     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function baseWhile(array, predicate, isDrop, fromRight) {
	      var length = array.length,
	          index = fromRight ? length : -1;
	
	      while ((fromRight ? index-- : ++index < length) &&
	        predicate(array[index], index, array)) {}
	
	      return isDrop
	        ? baseSlice(array, (fromRight ? 0 : index), (fromRight ? index + 1 : length))
	        : baseSlice(array, (fromRight ? index + 1 : 0), (fromRight ? length : index));
	    }
	
	    /**
	     * The base implementation of `wrapperValue` which returns the result of
	     * performing a sequence of actions on the unwrapped `value`, where each
	     * successive action is supplied the return value of the previous.
	     *
	     * @private
	     * @param {*} value The unwrapped value.
	     * @param {Array} actions Actions to perform to resolve the unwrapped value.
	     * @returns {*} Returns the resolved value.
	     */
	    function baseWrapperValue(value, actions) {
	      var result = value;
	      if (result instanceof LazyWrapper) {
	        result = result.value();
	      }
	      return arrayReduce(actions, function(result, action) {
	        return action.func.apply(action.thisArg, arrayPush([result], action.args));
	      }, result);
	    }
	
	    /**
	     * The base implementation of methods like `_.xor`, without support for
	     * iteratee shorthands, that accepts an array of arrays to inspect.
	     *
	     * @private
	     * @param {Array} arrays The arrays to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of values.
	     */
	    function baseXor(arrays, iteratee, comparator) {
	      var length = arrays.length;
	      if (length < 2) {
	        return length ? baseUniq(arrays[0]) : [];
	      }
	      var index = -1,
	          result = Array(length);
	
	      while (++index < length) {
	        var array = arrays[index],
	            othIndex = -1;
	
	        while (++othIndex < length) {
	          if (othIndex != index) {
	            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
	          }
	        }
	      }
	      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
	    }
	
	    /**
	     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
	     *
	     * @private
	     * @param {Array} props The property identifiers.
	     * @param {Array} values The property values.
	     * @param {Function} assignFunc The function to assign values.
	     * @returns {Object} Returns the new object.
	     */
	    function baseZipObject(props, values, assignFunc) {
	      var index = -1,
	          length = props.length,
	          valsLength = values.length,
	          result = {};
	
	      while (++index < length) {
	        var value = index < valsLength ? values[index] : undefined;
	        assignFunc(result, props[index], value);
	      }
	      return result;
	    }
	
	    /**
	     * Casts `value` to an empty array if it's not an array like object.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Array|Object} Returns the cast array-like object.
	     */
	    function castArrayLikeObject(value) {
	      return isArrayLikeObject(value) ? value : [];
	    }
	
	    /**
	     * Casts `value` to `identity` if it's not a function.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {Function} Returns cast function.
	     */
	    function castFunction(value) {
	      return typeof value == 'function' ? value : identity;
	    }
	
	    /**
	     * Casts `value` to a path array if it's not one.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {Array} Returns the cast property path array.
	     */
	    function castPath(value, object) {
	      if (isArray(value)) {
	        return value;
	      }
	      return isKey(value, object) ? [value] : stringToPath(toString(value));
	    }
	
	    /**
	     * A `baseRest` alias which can be replaced with `identity` by module
	     * replacement plugins.
	     *
	     * @private
	     * @type {Function}
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    var castRest = baseRest;
	
	    /**
	     * Casts `array` to a slice if it's needed.
	     *
	     * @private
	     * @param {Array} array The array to inspect.
	     * @param {number} start The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the cast slice.
	     */
	    function castSlice(array, start, end) {
	      var length = array.length;
	      end = end === undefined ? length : end;
	      return (!start && end >= length) ? array : baseSlice(array, start, end);
	    }
	
	    /**
	     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
	     *
	     * @private
	     * @param {number|Object} id The timer id or timeout object of the timer to clear.
	     */
	    var clearTimeout = ctxClearTimeout || function(id) {
	      return root.clearTimeout(id);
	    };
	
	    /**
	     * Creates a clone of  `buffer`.
	     *
	     * @private
	     * @param {Buffer} buffer The buffer to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Buffer} Returns the cloned buffer.
	     */
	    function cloneBuffer(buffer, isDeep) {
	      if (isDeep) {
	        return buffer.slice();
	      }
	      var length = buffer.length,
	          result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	      buffer.copy(result);
	      return result;
	    }
	
	    /**
	     * Creates a clone of `arrayBuffer`.
	     *
	     * @private
	     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	     * @returns {ArrayBuffer} Returns the cloned array buffer.
	     */
	    function cloneArrayBuffer(arrayBuffer) {
	      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	      return result;
	    }
	
	    /**
	     * Creates a clone of `dataView`.
	     *
	     * @private
	     * @param {Object} dataView The data view to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned data view.
	     */
	    function cloneDataView(dataView, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	    }
	
	    /**
	     * Creates a clone of `map`.
	     *
	     * @private
	     * @param {Object} map The map to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned map.
	     */
	    function cloneMap(map, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	      return arrayReduce(array, addMapEntry, new map.constructor);
	    }
	
	    /**
	     * Creates a clone of `regexp`.
	     *
	     * @private
	     * @param {Object} regexp The regexp to clone.
	     * @returns {Object} Returns the cloned regexp.
	     */
	    function cloneRegExp(regexp) {
	      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	      result.lastIndex = regexp.lastIndex;
	      return result;
	    }
	
	    /**
	     * Creates a clone of `set`.
	     *
	     * @private
	     * @param {Object} set The set to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned set.
	     */
	    function cloneSet(set, isDeep, cloneFunc) {
	      var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	      return arrayReduce(array, addSetEntry, new set.constructor);
	    }
	
	    /**
	     * Creates a clone of the `symbol` object.
	     *
	     * @private
	     * @param {Object} symbol The symbol object to clone.
	     * @returns {Object} Returns the cloned symbol object.
	     */
	    function cloneSymbol(symbol) {
	      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	    }
	
	    /**
	     * Creates a clone of `typedArray`.
	     *
	     * @private
	     * @param {Object} typedArray The typed array to clone.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the cloned typed array.
	     */
	    function cloneTypedArray(typedArray, isDeep) {
	      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	    }
	
	    /**
	     * Compares values to sort them in ascending order.
	     *
	     * @private
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {number} Returns the sort order indicator for `value`.
	     */
	    function compareAscending(value, other) {
	      if (value !== other) {
	        var valIsDefined = value !== undefined,
	            valIsNull = value === null,
	            valIsReflexive = value === value,
	            valIsSymbol = isSymbol(value);
	
	        var othIsDefined = other !== undefined,
	            othIsNull = other === null,
	            othIsReflexive = other === other,
	            othIsSymbol = isSymbol(other);
	
	        if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
	            (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
	            (valIsNull && othIsDefined && othIsReflexive) ||
	            (!valIsDefined && othIsReflexive) ||
	            !valIsReflexive) {
	          return 1;
	        }
	        if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
	            (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
	            (othIsNull && valIsDefined && valIsReflexive) ||
	            (!othIsDefined && valIsReflexive) ||
	            !othIsReflexive) {
	          return -1;
	        }
	      }
	      return 0;
	    }
	
	    /**
	     * Used by `_.orderBy` to compare multiple properties of a value to another
	     * and stable sort them.
	     *
	     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
	     * specify an order of "desc" for descending or "asc" for ascending sort order
	     * of corresponding values.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {boolean[]|string[]} orders The order to sort by for each property.
	     * @returns {number} Returns the sort order indicator for `object`.
	     */
	    function compareMultiple(object, other, orders) {
	      var index = -1,
	          objCriteria = object.criteria,
	          othCriteria = other.criteria,
	          length = objCriteria.length,
	          ordersLength = orders.length;
	
	      while (++index < length) {
	        var result = compareAscending(objCriteria[index], othCriteria[index]);
	        if (result) {
	          if (index >= ordersLength) {
	            return result;
	          }
	          var order = orders[index];
	          return result * (order == 'desc' ? -1 : 1);
	        }
	      }
	      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
	      // that causes it, under certain circumstances, to provide the same value for
	      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
	      // for more details.
	      //
	      // This also ensures a stable sort in V8 and other engines.
	      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
	      return object.index - other.index;
	    }
	
	    /**
	     * Creates an array that is the composition of partially applied arguments,
	     * placeholders, and provided arguments into a single array of arguments.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to prepend to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgs(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersLength = holders.length,
	          leftIndex = -1,
	          leftLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(leftLength + rangeLength),
	          isUncurried = !isCurried;
	
	      while (++leftIndex < leftLength) {
	        result[leftIndex] = partials[leftIndex];
	      }
	      while (++argsIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[holders[argsIndex]] = args[argsIndex];
	        }
	      }
	      while (rangeLength--) {
	        result[leftIndex++] = args[argsIndex++];
	      }
	      return result;
	    }
	
	    /**
	     * This function is like `composeArgs` except that the arguments composition
	     * is tailored for `_.partialRight`.
	     *
	     * @private
	     * @param {Array} args The provided arguments.
	     * @param {Array} partials The arguments to append to those provided.
	     * @param {Array} holders The `partials` placeholder indexes.
	     * @params {boolean} [isCurried] Specify composing for a curried function.
	     * @returns {Array} Returns the new array of composed arguments.
	     */
	    function composeArgsRight(args, partials, holders, isCurried) {
	      var argsIndex = -1,
	          argsLength = args.length,
	          holdersIndex = -1,
	          holdersLength = holders.length,
	          rightIndex = -1,
	          rightLength = partials.length,
	          rangeLength = nativeMax(argsLength - holdersLength, 0),
	          result = Array(rangeLength + rightLength),
	          isUncurried = !isCurried;
	
	      while (++argsIndex < rangeLength) {
	        result[argsIndex] = args[argsIndex];
	      }
	      var offset = argsIndex;
	      while (++rightIndex < rightLength) {
	        result[offset + rightIndex] = partials[rightIndex];
	      }
	      while (++holdersIndex < holdersLength) {
	        if (isUncurried || argsIndex < argsLength) {
	          result[offset + holders[holdersIndex]] = args[argsIndex++];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Copies the values of `source` to `array`.
	     *
	     * @private
	     * @param {Array} source The array to copy values from.
	     * @param {Array} [array=[]] The array to copy values to.
	     * @returns {Array} Returns `array`.
	     */
	    function copyArray(source, array) {
	      var index = -1,
	          length = source.length;
	
	      array || (array = Array(length));
	      while (++index < length) {
	        array[index] = source[index];
	      }
	      return array;
	    }
	
	    /**
	     * Copies properties of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy properties from.
	     * @param {Array} props The property identifiers to copy.
	     * @param {Object} [object={}] The object to copy properties to.
	     * @param {Function} [customizer] The function to customize copied values.
	     * @returns {Object} Returns `object`.
	     */
	    function copyObject(source, props, object, customizer) {
	      var isNew = !object;
	      object || (object = {});
	
	      var index = -1,
	          length = props.length;
	
	      while (++index < length) {
	        var key = props[index];
	
	        var newValue = customizer
	          ? customizer(object[key], source[key], key, object, source)
	          : undefined;
	
	        if (newValue === undefined) {
	          newValue = source[key];
	        }
	        if (isNew) {
	          baseAssignValue(object, key, newValue);
	        } else {
	          assignValue(object, key, newValue);
	        }
	      }
	      return object;
	    }
	
	    /**
	     * Copies own symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbols(source, object) {
	      return copyObject(source, getSymbols(source), object);
	    }
	
	    /**
	     * Copies own and inherited symbols of `source` to `object`.
	     *
	     * @private
	     * @param {Object} source The object to copy symbols from.
	     * @param {Object} [object={}] The object to copy symbols to.
	     * @returns {Object} Returns `object`.
	     */
	    function copySymbolsIn(source, object) {
	      return copyObject(source, getSymbolsIn(source), object);
	    }
	
	    /**
	     * Creates a function like `_.groupBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} [initializer] The accumulator object initializer.
	     * @returns {Function} Returns the new aggregator function.
	     */
	    function createAggregator(setter, initializer) {
	      return function(collection, iteratee) {
	        var func = isArray(collection) ? arrayAggregator : baseAggregator,
	            accumulator = initializer ? initializer() : {};
	
	        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
	      };
	    }
	
	    /**
	     * Creates a function like `_.assign`.
	     *
	     * @private
	     * @param {Function} assigner The function to assign values.
	     * @returns {Function} Returns the new assigner function.
	     */
	    function createAssigner(assigner) {
	      return baseRest(function(object, sources) {
	        var index = -1,
	            length = sources.length,
	            customizer = length > 1 ? sources[length - 1] : undefined,
	            guard = length > 2 ? sources[2] : undefined;
	
	        customizer = (assigner.length > 3 && typeof customizer == 'function')
	          ? (length--, customizer)
	          : undefined;
	
	        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	          customizer = length < 3 ? undefined : customizer;
	          length = 1;
	        }
	        object = Object(object);
	        while (++index < length) {
	          var source = sources[index];
	          if (source) {
	            assigner(object, source, index, customizer);
	          }
	        }
	        return object;
	      });
	    }
	
	    /**
	     * Creates a `baseEach` or `baseEachRight` function.
	     *
	     * @private
	     * @param {Function} eachFunc The function to iterate over a collection.
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseEach(eachFunc, fromRight) {
	      return function(collection, iteratee) {
	        if (collection == null) {
	          return collection;
	        }
	        if (!isArrayLike(collection)) {
	          return eachFunc(collection, iteratee);
	        }
	        var length = collection.length,
	            index = fromRight ? length : -1,
	            iterable = Object(collection);
	
	        while ((fromRight ? index-- : ++index < length)) {
	          if (iteratee(iterable[index], index, iterable) === false) {
	            break;
	          }
	        }
	        return collection;
	      };
	    }
	
	    /**
	     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new base function.
	     */
	    function createBaseFor(fromRight) {
	      return function(object, iteratee, keysFunc) {
	        var index = -1,
	            iterable = Object(object),
	            props = keysFunc(object),
	            length = props.length;
	
	        while (length--) {
	          var key = props[fromRight ? length : ++index];
	          if (iteratee(iterable[key], key, iterable) === false) {
	            break;
	          }
	        }
	        return object;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the optional `this`
	     * binding of `thisArg`.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createBind(func, bitmask, thisArg) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return fn.apply(isBind ? thisArg : this, arguments);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.lowerFirst`.
	     *
	     * @private
	     * @param {string} methodName The name of the `String` case method to use.
	     * @returns {Function} Returns the new case function.
	     */
	    function createCaseFirst(methodName) {
	      return function(string) {
	        string = toString(string);
	
	        var strSymbols = hasUnicode(string)
	          ? stringToArray(string)
	          : undefined;
	
	        var chr = strSymbols
	          ? strSymbols[0]
	          : string.charAt(0);
	
	        var trailing = strSymbols
	          ? castSlice(strSymbols, 1).join('')
	          : string.slice(1);
	
	        return chr[methodName]() + trailing;
	      };
	    }
	
	    /**
	     * Creates a function like `_.camelCase`.
	     *
	     * @private
	     * @param {Function} callback The function to combine each word.
	     * @returns {Function} Returns the new compounder function.
	     */
	    function createCompounder(callback) {
	      return function(string) {
	        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
	      };
	    }
	
	    /**
	     * Creates a function that produces an instance of `Ctor` regardless of
	     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	     *
	     * @private
	     * @param {Function} Ctor The constructor to wrap.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCtor(Ctor) {
	      return function() {
	        // Use a `switch` statement to work with class constructors. See
	        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	        // for more details.
	        var args = arguments;
	        switch (args.length) {
	          case 0: return new Ctor;
	          case 1: return new Ctor(args[0]);
	          case 2: return new Ctor(args[0], args[1]);
	          case 3: return new Ctor(args[0], args[1], args[2]);
	          case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	          case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	          case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	          case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	        }
	        var thisBinding = baseCreate(Ctor.prototype),
	            result = Ctor.apply(thisBinding, args);
	
	        // Mimic the constructor's `return` behavior.
	        // See https://es5.github.io/#x13.2.2 for more details.
	        return isObject(result) ? result : thisBinding;
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to enable currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {number} arity The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createCurry(func, bitmask, arity) {
	      var Ctor = createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length,
	            placeholder = getHolder(wrapper);
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	          ? []
	          : replaceHolders(args, placeholder);
	
	        length -= holders.length;
	        if (length < arity) {
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, undefined,
	            args, holders, undefined, undefined, arity - length);
	        }
	        var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	        return apply(fn, this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.find` or `_.findLast` function.
	     *
	     * @private
	     * @param {Function} findIndexFunc The function to find the collection index.
	     * @returns {Function} Returns the new find function.
	     */
	    function createFind(findIndexFunc) {
	      return function(collection, predicate, fromIndex) {
	        var iterable = Object(collection);
	        if (!isArrayLike(collection)) {
	          var iteratee = getIteratee(predicate, 3);
	          collection = keys(collection);
	          predicate = function(key) { return iteratee(iterable[key], key, iterable); };
	        }
	        var index = findIndexFunc(collection, predicate, fromIndex);
	        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
	      };
	    }
	
	    /**
	     * Creates a `_.flow` or `_.flowRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new flow function.
	     */
	    function createFlow(fromRight) {
	      return flatRest(function(funcs) {
	        var length = funcs.length,
	            index = length,
	            prereq = LodashWrapper.prototype.thru;
	
	        if (fromRight) {
	          funcs.reverse();
	        }
	        while (index--) {
	          var func = funcs[index];
	          if (typeof func != 'function') {
	            throw new TypeError(FUNC_ERROR_TEXT);
	          }
	          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
	            var wrapper = new LodashWrapper([], true);
	          }
	        }
	        index = wrapper ? index : length;
	        while (++index < length) {
	          func = funcs[index];
	
	          var funcName = getFuncName(func),
	              data = funcName == 'wrapper' ? getData(func) : undefined;
	
	          if (data && isLaziable(data[0]) &&
	                data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) &&
	                !data[4].length && data[9] == 1
	              ) {
	            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
	          } else {
	            wrapper = (func.length == 1 && isLaziable(func))
	              ? wrapper[funcName]()
	              : wrapper.thru(func);
	          }
	        }
	        return function() {
	          var args = arguments,
	              value = args[0];
	
	          if (wrapper && args.length == 1 && isArray(value)) {
	            return wrapper.plant(value).value();
	          }
	          var index = 0,
	              result = length ? funcs[index].apply(this, args) : value;
	
	          while (++index < length) {
	            result = funcs[index].call(this, result);
	          }
	          return result;
	        };
	      });
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with optional `this`
	     * binding of `thisArg`, partial application, and currying.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [partialsRight] The arguments to append to those provided
	     *  to the new function.
	     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	      var isAry = bitmask & WRAP_ARY_FLAG,
	          isBind = bitmask & WRAP_BIND_FLAG,
	          isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
	          isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
	          isFlip = bitmask & WRAP_FLIP_FLAG,
	          Ctor = isBindKey ? undefined : createCtor(func);
	
	      function wrapper() {
	        var length = arguments.length,
	            args = Array(length),
	            index = length;
	
	        while (index--) {
	          args[index] = arguments[index];
	        }
	        if (isCurried) {
	          var placeholder = getHolder(wrapper),
	              holdersCount = countHolders(args, placeholder);
	        }
	        if (partials) {
	          args = composeArgs(args, partials, holders, isCurried);
	        }
	        if (partialsRight) {
	          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	        }
	        length -= holdersCount;
	        if (isCurried && length < arity) {
	          var newHolders = replaceHolders(args, placeholder);
	          return createRecurry(
	            func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	            args, newHolders, argPos, ary, arity - length
	          );
	        }
	        var thisBinding = isBind ? thisArg : this,
	            fn = isBindKey ? thisBinding[func] : func;
	
	        length = args.length;
	        if (argPos) {
	          args = reorder(args, argPos);
	        } else if (isFlip && length > 1) {
	          args.reverse();
	        }
	        if (isAry && ary < length) {
	          args.length = ary;
	        }
	        if (this && this !== root && this instanceof wrapper) {
	          fn = Ctor || createCtor(fn);
	        }
	        return fn.apply(thisBinding, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a function like `_.invertBy`.
	     *
	     * @private
	     * @param {Function} setter The function to set accumulator values.
	     * @param {Function} toIteratee The function to resolve iteratees.
	     * @returns {Function} Returns the new inverter function.
	     */
	    function createInverter(setter, toIteratee) {
	      return function(object, iteratee) {
	        return baseInverter(object, setter, toIteratee(iteratee), {});
	      };
	    }
	
	    /**
	     * Creates a function that performs a mathematical operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @param {number} [defaultValue] The value used for `undefined` arguments.
	     * @returns {Function} Returns the new mathematical operation function.
	     */
	    function createMathOperation(operator, defaultValue) {
	      return function(value, other) {
	        var result;
	        if (value === undefined && other === undefined) {
	          return defaultValue;
	        }
	        if (value !== undefined) {
	          result = value;
	        }
	        if (other !== undefined) {
	          if (result === undefined) {
	            return other;
	          }
	          if (typeof value == 'string' || typeof other == 'string') {
	            value = baseToString(value);
	            other = baseToString(other);
	          } else {
	            value = baseToNumber(value);
	            other = baseToNumber(other);
	          }
	          result = operator(value, other);
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function like `_.over`.
	     *
	     * @private
	     * @param {Function} arrayFunc The function to iterate over iteratees.
	     * @returns {Function} Returns the new over function.
	     */
	    function createOver(arrayFunc) {
	      return flatRest(function(iteratees) {
	        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
	        return baseRest(function(args) {
	          var thisArg = this;
	          return arrayFunc(iteratees, function(iteratee) {
	            return apply(iteratee, thisArg, args);
	          });
	        });
	      });
	    }
	
	    /**
	     * Creates the padding for `string` based on `length`. The `chars` string
	     * is truncated if the number of characters exceeds `length`.
	     *
	     * @private
	     * @param {number} length The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padding for `string`.
	     */
	    function createPadding(length, chars) {
	      chars = chars === undefined ? ' ' : baseToString(chars);
	
	      var charsLength = chars.length;
	      if (charsLength < 2) {
	        return charsLength ? baseRepeat(chars, length) : chars;
	      }
	      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
	      return hasUnicode(chars)
	        ? castSlice(stringToArray(result), 0, length).join('')
	        : result.slice(0, length);
	    }
	
	    /**
	     * Creates a function that wraps `func` to invoke it with the `this` binding
	     * of `thisArg` and `partials` prepended to the arguments it receives.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {Array} partials The arguments to prepend to those provided to
	     *  the new function.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createPartial(func, bitmask, thisArg, partials) {
	      var isBind = bitmask & WRAP_BIND_FLAG,
	          Ctor = createCtor(func);
	
	      function wrapper() {
	        var argsIndex = -1,
	            argsLength = arguments.length,
	            leftIndex = -1,
	            leftLength = partials.length,
	            args = Array(leftLength + argsLength),
	            fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	        while (++leftIndex < leftLength) {
	          args[leftIndex] = partials[leftIndex];
	        }
	        while (argsLength--) {
	          args[leftIndex++] = arguments[++argsIndex];
	        }
	        return apply(fn, isBind ? thisArg : this, args);
	      }
	      return wrapper;
	    }
	
	    /**
	     * Creates a `_.range` or `_.rangeRight` function.
	     *
	     * @private
	     * @param {boolean} [fromRight] Specify iterating from right to left.
	     * @returns {Function} Returns the new range function.
	     */
	    function createRange(fromRight) {
	      return function(start, end, step) {
	        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
	          end = step = undefined;
	        }
	        // Ensure the sign of `-0` is preserved.
	        start = toFinite(start);
	        if (end === undefined) {
	          end = start;
	          start = 0;
	        } else {
	          end = toFinite(end);
	        }
	        step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
	        return baseRange(start, end, step, fromRight);
	      };
	    }
	
	    /**
	     * Creates a function that performs a relational operation on two values.
	     *
	     * @private
	     * @param {Function} operator The function to perform the operation.
	     * @returns {Function} Returns the new relational operation function.
	     */
	    function createRelationalOperation(operator) {
	      return function(value, other) {
	        if (!(typeof value == 'string' && typeof other == 'string')) {
	          value = toNumber(value);
	          other = toNumber(other);
	        }
	        return operator(value, other);
	      };
	    }
	
	    /**
	     * Creates a function that wraps `func` to continue currying.
	     *
	     * @private
	     * @param {Function} func The function to wrap.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @param {Function} wrapFunc The function to create the `func` wrapper.
	     * @param {*} placeholder The placeholder value.
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to prepend to those provided to
	     *  the new function.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	      var isCurry = bitmask & WRAP_CURRY_FLAG,
	          newHolders = isCurry ? holders : undefined,
	          newHoldersRight = isCurry ? undefined : holders,
	          newPartials = isCurry ? partials : undefined,
	          newPartialsRight = isCurry ? undefined : partials;
	
	      bitmask |= (isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG);
	      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
	
	      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
	        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
	      }
	      var newData = [
	        func, bitmask, thisArg, newPartials, newHolders, newPartialsRight,
	        newHoldersRight, argPos, ary, arity
	      ];
	
	      var result = wrapFunc.apply(undefined, newData);
	      if (isLaziable(func)) {
	        setData(result, newData);
	      }
	      result.placeholder = placeholder;
	      return setWrapToString(result, func, bitmask);
	    }
	
	    /**
	     * Creates a function like `_.round`.
	     *
	     * @private
	     * @param {string} methodName The name of the `Math` method to use when rounding.
	     * @returns {Function} Returns the new round function.
	     */
	    function createRound(methodName) {
	      var func = Math[methodName];
	      return function(number, precision) {
	        number = toNumber(number);
	        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
	        if (precision) {
	          // Shift with exponential notation to avoid floating-point issues.
	          // See [MDN](https://mdn.io/round#Examples) for more details.
	          var pair = (toString(number) + 'e').split('e'),
	              value = func(pair[0] + 'e' + (+pair[1] + precision));
	
	          pair = (toString(value) + 'e').split('e');
	          return +(pair[0] + 'e' + (+pair[1] - precision));
	        }
	        return func(number);
	      };
	    }
	
	    /**
	     * Creates a set object of `values`.
	     *
	     * @private
	     * @param {Array} values The values to add to the set.
	     * @returns {Object} Returns the new set.
	     */
	    var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
	      return new Set(values);
	    };
	
	    /**
	     * Creates a `_.toPairs` or `_.toPairsIn` function.
	     *
	     * @private
	     * @param {Function} keysFunc The function to get the keys of a given object.
	     * @returns {Function} Returns the new pairs function.
	     */
	    function createToPairs(keysFunc) {
	      return function(object) {
	        var tag = getTag(object);
	        if (tag == mapTag) {
	          return mapToArray(object);
	        }
	        if (tag == setTag) {
	          return setToPairs(object);
	        }
	        return baseToPairs(object, keysFunc(object));
	      };
	    }
	
	    /**
	     * Creates a function that either curries or invokes `func` with optional
	     * `this` binding and partially applied arguments.
	     *
	     * @private
	     * @param {Function|string} func The function or method name to wrap.
	     * @param {number} bitmask The bitmask flags.
	     *    1 - `_.bind`
	     *    2 - `_.bindKey`
	     *    4 - `_.curry` or `_.curryRight` of a bound function
	     *    8 - `_.curry`
	     *   16 - `_.curryRight`
	     *   32 - `_.partial`
	     *   64 - `_.partialRight`
	     *  128 - `_.rearg`
	     *  256 - `_.ary`
	     *  512 - `_.flip`
	     * @param {*} [thisArg] The `this` binding of `func`.
	     * @param {Array} [partials] The arguments to be partially applied.
	     * @param {Array} [holders] The `partials` placeholder indexes.
	     * @param {Array} [argPos] The argument positions of the new function.
	     * @param {number} [ary] The arity cap of `func`.
	     * @param {number} [arity] The arity of `func`.
	     * @returns {Function} Returns the new wrapped function.
	     */
	    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
	      if (!isBindKey && typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var length = partials ? partials.length : 0;
	      if (!length) {
	        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
	        partials = holders = undefined;
	      }
	      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	      arity = arity === undefined ? arity : toInteger(arity);
	      length -= holders ? holders.length : 0;
	
	      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
	        var partialsRight = partials,
	            holdersRight = holders;
	
	        partials = holders = undefined;
	      }
	      var data = isBindKey ? undefined : getData(func);
	
	      var newData = [
	        func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	        argPos, ary, arity
	      ];
	
	      if (data) {
	        mergeData(newData, data);
	      }
	      func = newData[0];
	      bitmask = newData[1];
	      thisArg = newData[2];
	      partials = newData[3];
	      holders = newData[4];
	      arity = newData[9] = newData[9] === undefined
	        ? (isBindKey ? 0 : func.length)
	        : nativeMax(newData[9] - length, 0);
	
	      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
	        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
	      }
	      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
	        var result = createBind(func, bitmask, thisArg);
	      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
	        result = createCurry(func, bitmask, arity);
	      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
	        result = createPartial(func, bitmask, thisArg, partials);
	      } else {
	        result = createHybrid.apply(undefined, newData);
	      }
	      var setter = data ? baseSetData : setData;
	      return setWrapToString(setter(result, newData), func, bitmask);
	    }
	
	    /**
	     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	     * of source objects to the destination object for all destination properties
	     * that resolve to `undefined`.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to assign.
	     * @param {Object} object The parent object of `objValue`.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsAssignIn(objValue, srcValue, key, object) {
	      if (objValue === undefined ||
	          (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	        return srcValue;
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	     * objects into destination objects that are passed thru.
	     *
	     * @private
	     * @param {*} objValue The destination value.
	     * @param {*} srcValue The source value.
	     * @param {string} key The key of the property to merge.
	     * @param {Object} object The parent object of `objValue`.
	     * @param {Object} source The parent object of `srcValue`.
	     * @param {Object} [stack] Tracks traversed source values and their merged
	     *  counterparts.
	     * @returns {*} Returns the value to assign.
	     */
	    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	      if (isObject(objValue) && isObject(srcValue)) {
	        // Recursively merge objects and arrays (susceptible to call stack limits).
	        stack.set(srcValue, objValue);
	        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	        stack['delete'](srcValue);
	      }
	      return objValue;
	    }
	
	    /**
	     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	     * objects.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @param {string} key The key of the property to inspect.
	     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	     */
	    function customOmitClone(value) {
	      return isPlainObject(value) ? undefined : value;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for arrays with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Array} array The array to compare.
	     * @param {Array} other The other array to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `array` and `other` objects.
	     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	     */
	    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          arrLength = array.length,
	          othLength = other.length;
	
	      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(array);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var index = -1,
	          result = true,
	          seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	      stack.set(array, other);
	      stack.set(other, array);
	
	      // Ignore non-index properties.
	      while (++index < arrLength) {
	        var arrValue = array[index],
	            othValue = other[index];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, arrValue, index, other, array, stack)
	            : customizer(arrValue, othValue, index, array, other, stack);
	        }
	        if (compared !== undefined) {
	          if (compared) {
	            continue;
	          }
	          result = false;
	          break;
	        }
	        // Recursively compare arrays (susceptible to call stack limits).
	        if (seen) {
	          if (!arraySome(other, function(othValue, othIndex) {
	                if (!cacheHas(seen, othIndex) &&
	                    (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	                  return seen.push(othIndex);
	                }
	              })) {
	            result = false;
	            break;
	          }
	        } else if (!(
	              arrValue === othValue ||
	                equalFunc(arrValue, othValue, bitmask, customizer, stack)
	            )) {
	          result = false;
	          break;
	        }
	      }
	      stack['delete'](array);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for comparing objects of
	     * the same `toStringTag`.
	     *
	     * **Note:** This function only supports comparing values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {string} tag The `toStringTag` of the objects to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	      switch (tag) {
	        case dataViewTag:
	          if ((object.byteLength != other.byteLength) ||
	              (object.byteOffset != other.byteOffset)) {
	            return false;
	          }
	          object = object.buffer;
	          other = other.buffer;
	
	        case arrayBufferTag:
	          if ((object.byteLength != other.byteLength) ||
	              !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	            return false;
	          }
	          return true;
	
	        case boolTag:
	        case dateTag:
	        case numberTag:
	          // Coerce booleans to `1` or `0` and dates to milliseconds.
	          // Invalid dates are coerced to `NaN`.
	          return eq(+object, +other);
	
	        case errorTag:
	          return object.name == other.name && object.message == other.message;
	
	        case regexpTag:
	        case stringTag:
	          // Coerce regexes to strings and treat strings, primitives and objects,
	          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	          // for more details.
	          return object == (other + '');
	
	        case mapTag:
	          var convert = mapToArray;
	
	        case setTag:
	          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	          convert || (convert = setToArray);
	
	          if (object.size != other.size && !isPartial) {
	            return false;
	          }
	          // Assume cyclic values are equal.
	          var stacked = stack.get(object);
	          if (stacked) {
	            return stacked == other;
	          }
	          bitmask |= COMPARE_UNORDERED_FLAG;
	
	          // Recursively compare objects (susceptible to call stack limits).
	          stack.set(object, other);
	          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	          stack['delete'](object);
	          return result;
	
	        case symbolTag:
	          if (symbolValueOf) {
	            return symbolValueOf.call(object) == symbolValueOf.call(other);
	          }
	      }
	      return false;
	    }
	
	    /**
	     * A specialized version of `baseIsEqualDeep` for objects with support for
	     * partial deep comparisons.
	     *
	     * @private
	     * @param {Object} object The object to compare.
	     * @param {Object} other The other object to compare.
	     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	     * @param {Function} customizer The function to customize comparisons.
	     * @param {Function} equalFunc The function to determine equivalents of values.
	     * @param {Object} stack Tracks traversed `object` and `other` objects.
	     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	     */
	    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	          objProps = getAllKeys(object),
	          objLength = objProps.length,
	          othProps = getAllKeys(other),
	          othLength = othProps.length;
	
	      if (objLength != othLength && !isPartial) {
	        return false;
	      }
	      var index = objLength;
	      while (index--) {
	        var key = objProps[index];
	        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	          return false;
	        }
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked && stack.get(other)) {
	        return stacked == other;
	      }
	      var result = true;
	      stack.set(object, other);
	      stack.set(other, object);
	
	      var skipCtor = isPartial;
	      while (++index < objLength) {
	        key = objProps[index];
	        var objValue = object[key],
	            othValue = other[key];
	
	        if (customizer) {
	          var compared = isPartial
	            ? customizer(othValue, objValue, key, other, object, stack)
	            : customizer(objValue, othValue, key, object, other, stack);
	        }
	        // Recursively compare objects (susceptible to call stack limits).
	        if (!(compared === undefined
	              ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	              : compared
	            )) {
	          result = false;
	          break;
	        }
	        skipCtor || (skipCtor = key == 'constructor');
	      }
	      if (result && !skipCtor) {
	        var objCtor = object.constructor,
	            othCtor = other.constructor;
	
	        // Non `Object` object instances with different constructors are not equal.
	        if (objCtor != othCtor &&
	            ('constructor' in object && 'constructor' in other) &&
	            !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	              typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	          result = false;
	        }
	      }
	      stack['delete'](object);
	      stack['delete'](other);
	      return result;
	    }
	
	    /**
	     * A specialized version of `baseRest` which flattens the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @returns {Function} Returns the new function.
	     */
	    function flatRest(func) {
	      return setToString(overRest(func, undefined, flatten), func + '');
	    }
	
	    /**
	     * Creates an array of own enumerable property names and symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeys(object) {
	      return baseGetAllKeys(object, keys, getSymbols);
	    }
	
	    /**
	     * Creates an array of own and inherited enumerable property names and
	     * symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names and symbols.
	     */
	    function getAllKeysIn(object) {
	      return baseGetAllKeys(object, keysIn, getSymbolsIn);
	    }
	
	    /**
	     * Gets metadata for `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {*} Returns the metadata for `func`.
	     */
	    var getData = !metaMap ? noop : function(func) {
	      return metaMap.get(func);
	    };
	
	    /**
	     * Gets the name of `func`.
	     *
	     * @private
	     * @param {Function} func The function to query.
	     * @returns {string} Returns the function name.
	     */
	    function getFuncName(func) {
	      var result = (func.name + ''),
	          array = realNames[result],
	          length = hasOwnProperty.call(realNames, result) ? array.length : 0;
	
	      while (length--) {
	        var data = array[length],
	            otherFunc = data.func;
	        if (otherFunc == null || otherFunc == func) {
	          return data.name;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Gets the argument placeholder value for `func`.
	     *
	     * @private
	     * @param {Function} func The function to inspect.
	     * @returns {*} Returns the placeholder value.
	     */
	    function getHolder(func) {
	      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
	      return object.placeholder;
	    }
	
	    /**
	     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
	     * this function returns the custom method, otherwise it returns `baseIteratee`.
	     * If arguments are provided, the chosen function is invoked with them and
	     * its result is returned.
	     *
	     * @private
	     * @param {*} [value] The value to convert to an iteratee.
	     * @param {number} [arity] The arity of the created iteratee.
	     * @returns {Function} Returns the chosen function or its result.
	     */
	    function getIteratee() {
	      var result = lodash.iteratee || iteratee;
	      result = result === iteratee ? baseIteratee : result;
	      return arguments.length ? result(arguments[0], arguments[1]) : result;
	    }
	
	    /**
	     * Gets the data for `map`.
	     *
	     * @private
	     * @param {Object} map The map to query.
	     * @param {string} key The reference key.
	     * @returns {*} Returns the map data.
	     */
	    function getMapData(map, key) {
	      var data = map.__data__;
	      return isKeyable(key)
	        ? data[typeof key == 'string' ? 'string' : 'hash']
	        : data.map;
	    }
	
	    /**
	     * Gets the property names, values, and compare flags of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the match data of `object`.
	     */
	    function getMatchData(object) {
	      var result = keys(object),
	          length = result.length;
	
	      while (length--) {
	        var key = result[length],
	            value = object[key];
	
	        result[length] = [key, value, isStrictComparable(value)];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the native function at `key` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {string} key The key of the method to get.
	     * @returns {*} Returns the function if it's native, else `undefined`.
	     */
	    function getNative(object, key) {
	      var value = getValue(object, key);
	      return baseIsNative(value) ? value : undefined;
	    }
	
	    /**
	     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the raw `toStringTag`.
	     */
	    function getRawTag(value) {
	      var isOwn = hasOwnProperty.call(value, symToStringTag),
	          tag = value[symToStringTag];
	
	      try {
	        value[symToStringTag] = undefined;
	        var unmasked = true;
	      } catch (e) {}
	
	      var result = nativeObjectToString.call(value);
	      if (unmasked) {
	        if (isOwn) {
	          value[symToStringTag] = tag;
	        } else {
	          delete value[symToStringTag];
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array of the own enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	      if (object == null) {
	        return [];
	      }
	      object = Object(object);
	      return arrayFilter(nativeGetSymbols(object), function(symbol) {
	        return propertyIsEnumerable.call(object, symbol);
	      });
	    };
	
	    /**
	     * Creates an array of the own and inherited enumerable symbols of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of symbols.
	     */
	    var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	      var result = [];
	      while (object) {
	        arrayPush(result, getSymbols(object));
	        object = getPrototype(object);
	      }
	      return result;
	    };
	
	    /**
	     * Gets the `toStringTag` of `value`.
	     *
	     * @private
	     * @param {*} value The value to query.
	     * @returns {string} Returns the `toStringTag`.
	     */
	    var getTag = baseGetTag;
	
	    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	    if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	        (Map && getTag(new Map) != mapTag) ||
	        (Promise && getTag(Promise.resolve()) != promiseTag) ||
	        (Set && getTag(new Set) != setTag) ||
	        (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	      getTag = function(value) {
	        var result = baseGetTag(value),
	            Ctor = result == objectTag ? value.constructor : undefined,
	            ctorString = Ctor ? toSource(Ctor) : '';
	
	        if (ctorString) {
	          switch (ctorString) {
	            case dataViewCtorString: return dataViewTag;
	            case mapCtorString: return mapTag;
	            case promiseCtorString: return promiseTag;
	            case setCtorString: return setTag;
	            case weakMapCtorString: return weakMapTag;
	          }
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Gets the view, applying any `transforms` to the `start` and `end` positions.
	     *
	     * @private
	     * @param {number} start The start of the view.
	     * @param {number} end The end of the view.
	     * @param {Array} transforms The transformations to apply to the view.
	     * @returns {Object} Returns an object containing the `start` and `end`
	     *  positions of the view.
	     */
	    function getView(start, end, transforms) {
	      var index = -1,
	          length = transforms.length;
	
	      while (++index < length) {
	        var data = transforms[index],
	            size = data.size;
	
	        switch (data.type) {
	          case 'drop':      start += size; break;
	          case 'dropRight': end -= size; break;
	          case 'take':      end = nativeMin(end, start + size); break;
	          case 'takeRight': start = nativeMax(start, end - size); break;
	        }
	      }
	      return { 'start': start, 'end': end };
	    }
	
	    /**
	     * Extracts wrapper details from the `source` body comment.
	     *
	     * @private
	     * @param {string} source The source to inspect.
	     * @returns {Array} Returns the wrapper details.
	     */
	    function getWrapDetails(source) {
	      var match = source.match(reWrapDetails);
	      return match ? match[1].split(reSplitDetails) : [];
	    }
	
	    /**
	     * Checks if `path` exists on `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @param {Function} hasFunc The function to check properties.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     */
	    function hasPath(object, path, hasFunc) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length,
	          result = false;
	
	      while (++index < length) {
	        var key = toKey(path[index]);
	        if (!(result = object != null && hasFunc(object, key))) {
	          break;
	        }
	        object = object[key];
	      }
	      if (result || ++index != length) {
	        return result;
	      }
	      length = object == null ? 0 : object.length;
	      return !!length && isLength(length) && isIndex(key, length) &&
	        (isArray(object) || isArguments(object));
	    }
	
	    /**
	     * Initializes an array clone.
	     *
	     * @private
	     * @param {Array} array The array to clone.
	     * @returns {Array} Returns the initialized clone.
	     */
	    function initCloneArray(array) {
	      var length = array.length,
	          result = array.constructor(length);
	
	      // Add properties assigned by `RegExp#exec`.
	      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	        result.index = array.index;
	        result.input = array.input;
	      }
	      return result;
	    }
	
	    /**
	     * Initializes an object clone.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneObject(object) {
	      return (typeof object.constructor == 'function' && !isPrototype(object))
	        ? baseCreate(getPrototype(object))
	        : {};
	    }
	
	    /**
	     * Initializes an object clone based on its `toStringTag`.
	     *
	     * **Note:** This function only supports cloning values with tags of
	     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	     *
	     * @private
	     * @param {Object} object The object to clone.
	     * @param {string} tag The `toStringTag` of the object to clone.
	     * @param {Function} cloneFunc The function to clone values.
	     * @param {boolean} [isDeep] Specify a deep clone.
	     * @returns {Object} Returns the initialized clone.
	     */
	    function initCloneByTag(object, tag, cloneFunc, isDeep) {
	      var Ctor = object.constructor;
	      switch (tag) {
	        case arrayBufferTag:
	          return cloneArrayBuffer(object);
	
	        case boolTag:
	        case dateTag:
	          return new Ctor(+object);
	
	        case dataViewTag:
	          return cloneDataView(object, isDeep);
	
	        case float32Tag: case float64Tag:
	        case int8Tag: case int16Tag: case int32Tag:
	        case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	          return cloneTypedArray(object, isDeep);
	
	        case mapTag:
	          return cloneMap(object, isDeep, cloneFunc);
	
	        case numberTag:
	        case stringTag:
	          return new Ctor(object);
	
	        case regexpTag:
	          return cloneRegExp(object);
	
	        case setTag:
	          return cloneSet(object, isDeep, cloneFunc);
	
	        case symbolTag:
	          return cloneSymbol(object);
	      }
	    }
	
	    /**
	     * Inserts wrapper `details` in a comment at the top of the `source` body.
	     *
	     * @private
	     * @param {string} source The source to modify.
	     * @returns {Array} details The details to insert.
	     * @returns {string} Returns the modified source.
	     */
	    function insertWrapDetails(source, details) {
	      var length = details.length;
	      if (!length) {
	        return source;
	      }
	      var lastIndex = length - 1;
	      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	      details = details.join(length > 2 ? ', ' : ' ');
	      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	    }
	
	    /**
	     * Checks if `value` is a flattenable `arguments` object or array.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	     */
	    function isFlattenable(value) {
	      return isArray(value) || isArguments(value) ||
	        !!(spreadableSymbol && value && value[spreadableSymbol]);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like index.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	     */
	    function isIndex(value, length) {
	      length = length == null ? MAX_SAFE_INTEGER : length;
	      return !!length &&
	        (typeof value == 'number' || reIsUint.test(value)) &&
	        (value > -1 && value % 1 == 0 && value < length);
	    }
	
	    /**
	     * Checks if the given arguments are from an iteratee call.
	     *
	     * @private
	     * @param {*} value The potential iteratee value argument.
	     * @param {*} index The potential iteratee index or key argument.
	     * @param {*} object The potential iteratee object argument.
	     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	     *  else `false`.
	     */
	    function isIterateeCall(value, index, object) {
	      if (!isObject(object)) {
	        return false;
	      }
	      var type = typeof index;
	      if (type == 'number'
	            ? (isArrayLike(object) && isIndex(index, object.length))
	            : (type == 'string' && index in object)
	          ) {
	        return eq(object[index], value);
	      }
	      return false;
	    }
	
	    /**
	     * Checks if `value` is a property name and not a property path.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @param {Object} [object] The object to query keys on.
	     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	     */
	    function isKey(value, object) {
	      if (isArray(value)) {
	        return false;
	      }
	      var type = typeof value;
	      if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	          value == null || isSymbol(value)) {
	        return true;
	      }
	      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	        (object != null && value in Object(object));
	    }
	
	    /**
	     * Checks if `value` is suitable for use as unique object key.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	     */
	    function isKeyable(value) {
	      var type = typeof value;
	      return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	        ? (value !== '__proto__')
	        : (value === null);
	    }
	
	    /**
	     * Checks if `func` has a lazy counterpart.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
	     *  else `false`.
	     */
	    function isLaziable(func) {
	      var funcName = getFuncName(func),
	          other = lodash[funcName];
	
	      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
	        return false;
	      }
	      if (func === other) {
	        return true;
	      }
	      var data = getData(other);
	      return !!data && func === data[0];
	    }
	
	    /**
	     * Checks if `func` has its source masked.
	     *
	     * @private
	     * @param {Function} func The function to check.
	     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	     */
	    function isMasked(func) {
	      return !!maskSrcKey && (maskSrcKey in func);
	    }
	
	    /**
	     * Checks if `func` is capable of being masked.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
	     */
	    var isMaskable = coreJsData ? isFunction : stubFalse;
	
	    /**
	     * Checks if `value` is likely a prototype object.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	     */
	    function isPrototype(value) {
	      var Ctor = value && value.constructor,
	          proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	      return value === proto;
	    }
	
	    /**
	     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` if suitable for strict
	     *  equality comparisons, else `false`.
	     */
	    function isStrictComparable(value) {
	      return value === value && !isObject(value);
	    }
	
	    /**
	     * A specialized version of `matchesProperty` for source values suitable
	     * for strict equality comparisons, i.e. `===`.
	     *
	     * @private
	     * @param {string} key The key of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     */
	    function matchesStrictComparable(key, srcValue) {
	      return function(object) {
	        if (object == null) {
	          return false;
	        }
	        return object[key] === srcValue &&
	          (srcValue !== undefined || (key in Object(object)));
	      };
	    }
	
	    /**
	     * A specialized version of `_.memoize` which clears the memoized function's
	     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	     *
	     * @private
	     * @param {Function} func The function to have its output memoized.
	     * @returns {Function} Returns the new memoized function.
	     */
	    function memoizeCapped(func) {
	      var result = memoize(func, function(key) {
	        if (cache.size === MAX_MEMOIZE_SIZE) {
	          cache.clear();
	        }
	        return key;
	      });
	
	      var cache = result.cache;
	      return result;
	    }
	
	    /**
	     * Merges the function metadata of `source` into `data`.
	     *
	     * Merging metadata reduces the number of wrappers used to invoke a function.
	     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
	     * may be applied regardless of execution order. Methods like `_.ary` and
	     * `_.rearg` modify function arguments, making the order in which they are
	     * executed important, preventing the merging of metadata. However, we make
	     * an exception for a safe combined case where curried functions have `_.ary`
	     * and or `_.rearg` applied.
	     *
	     * @private
	     * @param {Array} data The destination metadata.
	     * @param {Array} source The source metadata.
	     * @returns {Array} Returns `data`.
	     */
	    function mergeData(data, source) {
	      var bitmask = data[1],
	          srcBitmask = source[1],
	          newBitmask = bitmask | srcBitmask,
	          isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
	
	      var isCombo =
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_CURRY_FLAG)) ||
	        ((srcBitmask == WRAP_ARY_FLAG) && (bitmask == WRAP_REARG_FLAG) && (data[7].length <= source[8])) ||
	        ((srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG)) && (source[7].length <= source[8]) && (bitmask == WRAP_CURRY_FLAG));
	
	      // Exit early if metadata can't be merged.
	      if (!(isCommon || isCombo)) {
	        return data;
	      }
	      // Use source `thisArg` if available.
	      if (srcBitmask & WRAP_BIND_FLAG) {
	        data[2] = source[2];
	        // Set when currying a bound function.
	        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
	      }
	      // Compose partial arguments.
	      var value = source[3];
	      if (value) {
	        var partials = data[3];
	        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
	        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
	      }
	      // Compose partial right arguments.
	      value = source[5];
	      if (value) {
	        partials = data[5];
	        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
	        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
	      }
	      // Use source `argPos` if available.
	      value = source[7];
	      if (value) {
	        data[7] = value;
	      }
	      // Use source `ary` if it's smaller.
	      if (srcBitmask & WRAP_ARY_FLAG) {
	        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
	      }
	      // Use source `arity` if one is not provided.
	      if (data[9] == null) {
	        data[9] = source[9];
	      }
	      // Use source `func` and merge bitmasks.
	      data[0] = source[0];
	      data[1] = newBitmask;
	
	      return data;
	    }
	
	    /**
	     * This function is like
	     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * except that it includes inherited enumerable properties.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     */
	    function nativeKeysIn(object) {
	      var result = [];
	      if (object != null) {
	        for (var key in Object(object)) {
	          result.push(key);
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a string using `Object.prototype.toString`.
	     *
	     * @private
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     */
	    function objectToString(value) {
	      return nativeObjectToString.call(value);
	    }
	
	    /**
	     * A specialized version of `baseRest` which transforms the rest array.
	     *
	     * @private
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @param {Function} transform The rest array transform.
	     * @returns {Function} Returns the new function.
	     */
	    function overRest(func, start, transform) {
	      start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	      return function() {
	        var args = arguments,
	            index = -1,
	            length = nativeMax(args.length - start, 0),
	            array = Array(length);
	
	        while (++index < length) {
	          array[index] = args[start + index];
	        }
	        index = -1;
	        var otherArgs = Array(start + 1);
	        while (++index < start) {
	          otherArgs[index] = args[index];
	        }
	        otherArgs[start] = transform(array);
	        return apply(func, this, otherArgs);
	      };
	    }
	
	    /**
	     * Gets the parent value at `path` of `object`.
	     *
	     * @private
	     * @param {Object} object The object to query.
	     * @param {Array} path The path to get the parent value of.
	     * @returns {*} Returns the parent value.
	     */
	    function parent(object, path) {
	      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	    }
	
	    /**
	     * Reorder `array` according to the specified indexes where the element at
	     * the first index is assigned as the first element, the element at
	     * the second index is assigned as the second element, and so on.
	     *
	     * @private
	     * @param {Array} array The array to reorder.
	     * @param {Array} indexes The arranged array indexes.
	     * @returns {Array} Returns `array`.
	     */
	    function reorder(array, indexes) {
	      var arrLength = array.length,
	          length = nativeMin(indexes.length, arrLength),
	          oldArray = copyArray(array);
	
	      while (length--) {
	        var index = indexes[length];
	        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	      }
	      return array;
	    }
	
	    /**
	     * Sets metadata for `func`.
	     *
	     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
	     * period of time, it will trip its breaker and transition to an identity
	     * function to avoid garbage collection pauses in V8. See
	     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
	     * for more details.
	     *
	     * @private
	     * @param {Function} func The function to associate metadata with.
	     * @param {*} data The metadata.
	     * @returns {Function} Returns `func`.
	     */
	    var setData = shortOut(baseSetData);
	
	    /**
	     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
	     *
	     * @private
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @returns {number|Object} Returns the timer id or timeout object.
	     */
	    var setTimeout = ctxSetTimeout || function(func, wait) {
	      return root.setTimeout(func, wait);
	    };
	
	    /**
	     * Sets the `toString` method of `func` to return `string`.
	     *
	     * @private
	     * @param {Function} func The function to modify.
	     * @param {Function} string The `toString` result.
	     * @returns {Function} Returns `func`.
	     */
	    var setToString = shortOut(baseSetToString);
	
	    /**
	     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	     * with wrapper details in a comment at the top of the source body.
	     *
	     * @private
	     * @param {Function} wrapper The function to modify.
	     * @param {Function} reference The reference function.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Function} Returns `wrapper`.
	     */
	    function setWrapToString(wrapper, reference, bitmask) {
	      var source = (reference + '');
	      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
	    }
	
	    /**
	     * Creates a function that'll short out and invoke `identity` instead
	     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	     * milliseconds.
	     *
	     * @private
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new shortable function.
	     */
	    function shortOut(func) {
	      var count = 0,
	          lastCalled = 0;
	
	      return function() {
	        var stamp = nativeNow(),
	            remaining = HOT_SPAN - (stamp - lastCalled);
	
	        lastCalled = stamp;
	        if (remaining > 0) {
	          if (++count >= HOT_COUNT) {
	            return arguments[0];
	          }
	        } else {
	          count = 0;
	        }
	        return func.apply(undefined, arguments);
	      };
	    }
	
	    /**
	     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
	     *
	     * @private
	     * @param {Array} array The array to shuffle.
	     * @param {number} [size=array.length] The size of `array`.
	     * @returns {Array} Returns `array`.
	     */
	    function shuffleSelf(array, size) {
	      var index = -1,
	          length = array.length,
	          lastIndex = length - 1;
	
	      size = size === undefined ? length : size;
	      while (++index < size) {
	        var rand = baseRandom(index, lastIndex),
	            value = array[rand];
	
	        array[rand] = array[index];
	        array[index] = value;
	      }
	      array.length = size;
	      return array;
	    }
	
	    /**
	     * Converts `string` to a property path array.
	     *
	     * @private
	     * @param {string} string The string to convert.
	     * @returns {Array} Returns the property path array.
	     */
	    var stringToPath = memoizeCapped(function(string) {
	      var result = [];
	      if (reLeadingDot.test(string)) {
	        result.push('');
	      }
	      string.replace(rePropName, function(match, number, quote, string) {
	        result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	      });
	      return result;
	    });
	
	    /**
	     * Converts `value` to a string key if it's not a string or symbol.
	     *
	     * @private
	     * @param {*} value The value to inspect.
	     * @returns {string|symbol} Returns the key.
	     */
	    function toKey(value) {
	      if (typeof value == 'string' || isSymbol(value)) {
	        return value;
	      }
	      var result = (value + '');
	      return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	    }
	
	    /**
	     * Converts `func` to its source code.
	     *
	     * @private
	     * @param {Function} func The function to convert.
	     * @returns {string} Returns the source code.
	     */
	    function toSource(func) {
	      if (func != null) {
	        try {
	          return funcToString.call(func);
	        } catch (e) {}
	        try {
	          return (func + '');
	        } catch (e) {}
	      }
	      return '';
	    }
	
	    /**
	     * Updates wrapper `details` based on `bitmask` flags.
	     *
	     * @private
	     * @returns {Array} details The details to modify.
	     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	     * @returns {Array} Returns `details`.
	     */
	    function updateWrapDetails(details, bitmask) {
	      arrayEach(wrapFlags, function(pair) {
	        var value = '_.' + pair[0];
	        if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	          details.push(value);
	        }
	      });
	      return details.sort();
	    }
	
	    /**
	     * Creates a clone of `wrapper`.
	     *
	     * @private
	     * @param {Object} wrapper The wrapper to clone.
	     * @returns {Object} Returns the cloned wrapper.
	     */
	    function wrapperClone(wrapper) {
	      if (wrapper instanceof LazyWrapper) {
	        return wrapper.clone();
	      }
	      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
	      result.__actions__ = copyArray(wrapper.__actions__);
	      result.__index__  = wrapper.__index__;
	      result.__values__ = wrapper.__values__;
	      return result;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an array of elements split into groups the length of `size`.
	     * If `array` can't be split evenly, the final chunk will be the remaining
	     * elements.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to process.
	     * @param {number} [size=1] The length of each chunk
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the new array of chunks.
	     * @example
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 2);
	     * // => [['a', 'b'], ['c', 'd']]
	     *
	     * _.chunk(['a', 'b', 'c', 'd'], 3);
	     * // => [['a', 'b', 'c'], ['d']]
	     */
	    function chunk(array, size, guard) {
	      if ((guard ? isIterateeCall(array, size, guard) : size === undefined)) {
	        size = 1;
	      } else {
	        size = nativeMax(toInteger(size), 0);
	      }
	      var length = array == null ? 0 : array.length;
	      if (!length || size < 1) {
	        return [];
	      }
	      var index = 0,
	          resIndex = 0,
	          result = Array(nativeCeil(length / size));
	
	      while (index < length) {
	        result[resIndex++] = baseSlice(array, index, (index += size));
	      }
	      return result;
	    }
	
	    /**
	     * Creates an array with all falsey values removed. The values `false`, `null`,
	     * `0`, `""`, `undefined`, and `NaN` are falsey.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to compact.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.compact([0, 1, false, 2, '', 3]);
	     * // => [1, 2, 3]
	     */
	    function compact(array) {
	      var index = -1,
	          length = array == null ? 0 : array.length,
	          resIndex = 0,
	          result = [];
	
	      while (++index < length) {
	        var value = array[index];
	        if (value) {
	          result[resIndex++] = value;
	        }
	      }
	      return result;
	    }
	
	    /**
	     * Creates a new array concatenating `array` with any additional arrays
	     * and/or values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to concatenate.
	     * @param {...*} [values] The values to concatenate.
	     * @returns {Array} Returns the new concatenated array.
	     * @example
	     *
	     * var array = [1];
	     * var other = _.concat(array, 2, [3], [[4]]);
	     *
	     * console.log(other);
	     * // => [1, 2, 3, [4]]
	     *
	     * console.log(array);
	     * // => [1]
	     */
	    function concat() {
	      var length = arguments.length;
	      if (!length) {
	        return [];
	      }
	      var args = Array(length - 1),
	          array = arguments[0],
	          index = length;
	
	      while (index--) {
	        args[index - 1] = arguments[index];
	      }
	      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
	    }
	
	    /**
	     * Creates an array of `array` values not included in the other given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * **Note:** Unlike `_.pullAll`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.without, _.xor
	     * @example
	     *
	     * _.difference([2, 1], [2, 3]);
	     * // => [1]
	     */
	    var difference = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `iteratee` which
	     * is invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var differenceBy = baseRest(function(array, values) {
	      var iteratee = last(values);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.difference` except that it accepts `comparator`
	     * which is invoked to compare elements of `array` to `values`. The order and
	     * references of result values are determined by the first array. The comparator
	     * is invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...Array} [values] The values to exclude.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     *
	     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }]
	     */
	    var differenceWith = baseRest(function(array, values) {
	      var comparator = last(values);
	      if (isArrayLikeObject(comparator)) {
	        comparator = undefined;
	      }
	      return isArrayLikeObject(array)
	        ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.drop([1, 2, 3]);
	     * // => [2, 3]
	     *
	     * _.drop([1, 2, 3], 2);
	     * // => [3]
	     *
	     * _.drop([1, 2, 3], 5);
	     * // => []
	     *
	     * _.drop([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function drop(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements dropped from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to drop.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.dropRight([1, 2, 3]);
	     * // => [1, 2]
	     *
	     * _.dropRight([1, 2, 3], 2);
	     * // => [1]
	     *
	     * _.dropRight([1, 2, 3], 5);
	     * // => []
	     *
	     * _.dropRight([1, 2, 3], 0);
	     * // => [1, 2, 3]
	     */
	    function dropRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the end.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.dropRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropRightWhile(users, ['active', false]);
	     * // => objects for ['barney']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropRightWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` excluding elements dropped from the beginning.
	     * Elements are dropped until `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.dropWhile(users, function(o) { return !o.active; });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.dropWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.dropWhile(users, ['active', false]);
	     * // => objects for ['pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.dropWhile(users, 'active');
	     * // => objects for ['barney', 'fred', 'pebbles']
	     */
	    function dropWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), true)
	        : [];
	    }
	
	    /**
	     * Fills elements of `array` with `value` from `start` up to, but not
	     * including, `end`.
	     *
	     * **Note:** This method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Array
	     * @param {Array} array The array to fill.
	     * @param {*} value The value to fill `array` with.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.fill(array, 'a');
	     * console.log(array);
	     * // => ['a', 'a', 'a']
	     *
	     * _.fill(Array(3), 2);
	     * // => [2, 2, 2]
	     *
	     * _.fill([4, 6, 8, 10], '*', 1, 3);
	     * // => [4, '*', '*', 10]
	     */
	    function fill(array, value, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
	        start = 0;
	        end = length;
	      }
	      return baseFill(array, value, start, end);
	    }
	
	    /**
	     * This method is like `_.find` except that it returns the index of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.findIndex(users, function(o) { return o.user == 'barney'; });
	     * // => 0
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findIndex(users, { 'user': 'fred', 'active': false });
	     * // => 1
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findIndex(users, ['active', false]);
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findIndex(users, 'active');
	     * // => 2
	     */
	    function findIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index);
	    }
	
	    /**
	     * This method is like `_.findIndex` except that it iterates over elements
	     * of `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the found element, else `-1`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
	     * // => 2
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
	     * // => 0
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastIndex(users, ['active', false]);
	     * // => 2
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastIndex(users, 'active');
	     * // => 0
	     */
	    function findLastIndex(array, predicate, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length - 1;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = fromIndex < 0
	          ? nativeMax(length + index, 0)
	          : nativeMin(index, length - 1);
	      }
	      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
	    }
	
	    /**
	     * Flattens `array` a single level deep.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flatten([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, [3, [4]], 5]
	     */
	    function flatten(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, 1) : [];
	    }
	
	    /**
	     * Recursively flattens `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * _.flattenDeep([1, [2, [3, [4]], 5]]);
	     * // => [1, 2, 3, 4, 5]
	     */
	    function flattenDeep(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseFlatten(array, INFINITY) : [];
	    }
	
	    /**
	     * Recursively flatten `array` up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Array
	     * @param {Array} array The array to flatten.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * var array = [1, [2, [3, [4]], 5]];
	     *
	     * _.flattenDepth(array, 1);
	     * // => [1, 2, [3, [4]], 5]
	     *
	     * _.flattenDepth(array, 2);
	     * // => [1, 2, 3, [4], 5]
	     */
	    function flattenDepth(array, depth) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(array, depth);
	    }
	
	    /**
	     * The inverse of `_.toPairs`; this method returns an object composed
	     * from key-value `pairs`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} pairs The key-value pairs.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.fromPairs([['a', 1], ['b', 2]]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function fromPairs(pairs) {
	      var index = -1,
	          length = pairs == null ? 0 : pairs.length,
	          result = {};
	
	      while (++index < length) {
	        var pair = pairs[index];
	        result[pair[0]] = pair[1];
	      }
	      return result;
	    }
	
	    /**
	     * Gets the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias first
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the first element of `array`.
	     * @example
	     *
	     * _.head([1, 2, 3]);
	     * // => 1
	     *
	     * _.head([]);
	     * // => undefined
	     */
	    function head(array) {
	      return (array && array.length) ? array[0] : undefined;
	    }
	
	    /**
	     * Gets the index at which the first occurrence of `value` is found in `array`
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. If `fromIndex` is negative, it's used as the
	     * offset from the end of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.indexOf([1, 2, 1, 2], 2);
	     * // => 1
	     *
	     * // Search from the `fromIndex`.
	     * _.indexOf([1, 2, 1, 2], 2, 2);
	     * // => 3
	     */
	    function indexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = fromIndex == null ? 0 : toInteger(fromIndex);
	      if (index < 0) {
	        index = nativeMax(length + index, 0);
	      }
	      return baseIndexOf(array, value, index);
	    }
	
	    /**
	     * Gets all but the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.initial([1, 2, 3]);
	     * // => [1, 2]
	     */
	    function initial(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 0, -1) : [];
	    }
	
	    /**
	     * Creates an array of unique values that are included in all given arrays
	     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons. The order and references of result values are
	     * determined by the first array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersection([2, 1], [2, 3]);
	     * // => [2]
	     */
	    var intersection = baseRest(function(arrays) {
	      var mapped = arrayMap(arrays, castArrayLikeObject);
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped)
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `iteratee`
	     * which is invoked for each element of each `arrays` to generate the criterion
	     * by which they're compared. The order and references of result values are
	     * determined by the first array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [2.1]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }]
	     */
	    var intersectionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      if (iteratee === last(mapped)) {
	        iteratee = undefined;
	      } else {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, getIteratee(iteratee, 2))
	        : [];
	    });
	
	    /**
	     * This method is like `_.intersection` except that it accepts `comparator`
	     * which is invoked to compare elements of `arrays`. The order and references
	     * of result values are determined by the first array. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of intersecting values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.intersectionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }]
	     */
	    var intersectionWith = baseRest(function(arrays) {
	      var comparator = last(arrays),
	          mapped = arrayMap(arrays, castArrayLikeObject);
	
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      if (comparator) {
	        mapped.pop();
	      }
	      return (mapped.length && mapped[0] === arrays[0])
	        ? baseIntersection(mapped, undefined, comparator)
	        : [];
	    });
	
	    /**
	     * Converts all elements in `array` into a string separated by `separator`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to convert.
	     * @param {string} [separator=','] The element separator.
	     * @returns {string} Returns the joined string.
	     * @example
	     *
	     * _.join(['a', 'b', 'c'], '~');
	     * // => 'a~b~c'
	     */
	    function join(array, separator) {
	      return array == null ? '' : nativeJoin.call(array, separator);
	    }
	
	    /**
	     * Gets the last element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {*} Returns the last element of `array`.
	     * @example
	     *
	     * _.last([1, 2, 3]);
	     * // => 3
	     */
	    function last(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? array[length - 1] : undefined;
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it iterates over elements of
	     * `array` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=array.length-1] The index to search from.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.lastIndexOf([1, 2, 1, 2], 2);
	     * // => 3
	     *
	     * // Search from the `fromIndex`.
	     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
	     * // => 1
	     */
	    function lastIndexOf(array, value, fromIndex) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return -1;
	      }
	      var index = length;
	      if (fromIndex !== undefined) {
	        index = toInteger(fromIndex);
	        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
	      }
	      return value === value
	        ? strictLastIndexOf(array, value, index)
	        : baseFindIndex(array, baseIsNaN, index, true);
	    }
	
	    /**
	     * Gets the element at index `n` of `array`. If `n` is negative, the nth
	     * element from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.11.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=0] The index of the element to return.
	     * @returns {*} Returns the nth element of `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     *
	     * _.nth(array, 1);
	     * // => 'b'
	     *
	     * _.nth(array, -2);
	     * // => 'c';
	     */
	    function nth(array, n) {
	      return (array && array.length) ? baseNth(array, toInteger(n)) : undefined;
	    }
	
	    /**
	     * Removes all given values from `array` using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
	     * to remove elements from an array by predicate.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...*} [values] The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pull(array, 'a', 'c');
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    var pull = baseRest(pullAll);
	
	    /**
	     * This method is like `_.pull` except that it accepts an array of values to remove.
	     *
	     * **Note:** Unlike `_.difference`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
	     *
	     * _.pullAll(array, ['a', 'c']);
	     * console.log(array);
	     * // => ['b', 'b']
	     */
	    function pullAll(array, values) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values)
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `iteratee` which is
	     * invoked for each element of `array` and `values` to generate the criterion
	     * by which they're compared. The iteratee is invoked with one argument: (value).
	     *
	     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
	     *
	     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
	     * console.log(array);
	     * // => [{ 'x': 2 }]
	     */
	    function pullAllBy(array, values, iteratee) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, getIteratee(iteratee, 2))
	        : array;
	    }
	
	    /**
	     * This method is like `_.pullAll` except that it accepts `comparator` which
	     * is invoked to compare elements of `array` to `values`. The comparator is
	     * invoked with two arguments: (arrVal, othVal).
	     *
	     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Array} values The values to remove.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
	     *
	     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
	     * console.log(array);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
	     */
	    function pullAllWith(array, values, comparator) {
	      return (array && array.length && values && values.length)
	        ? basePullAll(array, values, undefined, comparator)
	        : array;
	    }
	
	    /**
	     * Removes elements from `array` corresponding to `indexes` and returns an
	     * array of removed elements.
	     *
	     * **Note:** Unlike `_.at`, this method mutates `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = ['a', 'b', 'c', 'd'];
	     * var pulled = _.pullAt(array, [1, 3]);
	     *
	     * console.log(array);
	     * // => ['a', 'c']
	     *
	     * console.log(pulled);
	     * // => ['b', 'd']
	     */
	    var pullAt = flatRest(function(array, indexes) {
	      var length = array == null ? 0 : array.length,
	          result = baseAt(array, indexes);
	
	      basePullAt(array, arrayMap(indexes, function(index) {
	        return isIndex(index, length) ? +index : index;
	      }).sort(compareAscending));
	
	      return result;
	    });
	
	    /**
	     * Removes all elements from `array` that `predicate` returns truthy for
	     * and returns an array of the removed elements. The predicate is invoked
	     * with three arguments: (value, index, array).
	     *
	     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
	     * to pull elements from an array by value.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new array of removed elements.
	     * @example
	     *
	     * var array = [1, 2, 3, 4];
	     * var evens = _.remove(array, function(n) {
	     *   return n % 2 == 0;
	     * });
	     *
	     * console.log(array);
	     * // => [1, 3]
	     *
	     * console.log(evens);
	     * // => [2, 4]
	     */
	    function remove(array, predicate) {
	      var result = [];
	      if (!(array && array.length)) {
	        return result;
	      }
	      var index = -1,
	          indexes = [],
	          length = array.length;
	
	      predicate = getIteratee(predicate, 3);
	      while (++index < length) {
	        var value = array[index];
	        if (predicate(value, index, array)) {
	          result.push(value);
	          indexes.push(index);
	        }
	      }
	      basePullAt(array, indexes);
	      return result;
	    }
	
	    /**
	     * Reverses `array` so that the first element becomes the last, the second
	     * element becomes the second to last, and so on.
	     *
	     * **Note:** This method mutates `array` and is based on
	     * [`Array#reverse`](https://mdn.io/Array/reverse).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to modify.
	     * @returns {Array} Returns `array`.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _.reverse(array);
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function reverse(array) {
	      return array == null ? array : nativeReverse.call(array);
	    }
	
	    /**
	     * Creates a slice of `array` from `start` up to, but not including, `end`.
	     *
	     * **Note:** This method is used instead of
	     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
	     * returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to slice.
	     * @param {number} [start=0] The start position.
	     * @param {number} [end=array.length] The end position.
	     * @returns {Array} Returns the slice of `array`.
	     */
	    function slice(array, start, end) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
	        start = 0;
	        end = length;
	      }
	      else {
	        start = start == null ? 0 : toInteger(start);
	        end = end === undefined ? length : toInteger(end);
	      }
	      return baseSlice(array, start, end);
	    }
	
	    /**
	     * Uses a binary search to determine the lowest index at which `value`
	     * should be inserted into `array` in order to maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedIndex([30, 50], 40);
	     * // => 1
	     */
	    function sortedIndex(array, value) {
	      return baseSortedIndex(array, value);
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 0
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 0
	     */
	    function sortedIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * This method is like `_.indexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 1
	     */
	    function sortedIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value);
	        if (index < length && eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.sortedIndex` except that it returns the highest
	     * index at which `value` should be inserted into `array` in order to
	     * maintain its sort order.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
	     * // => 4
	     */
	    function sortedLastIndex(array, value) {
	      return baseSortedIndex(array, value, true);
	    }
	
	    /**
	     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
	     * which is invoked for `value` and each element of `array` to compute their
	     * sort ranking. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The sorted array to inspect.
	     * @param {*} value The value to evaluate.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the index at which `value` should be inserted
	     *  into `array`.
	     * @example
	     *
	     * var objects = [{ 'x': 4 }, { 'x': 5 }];
	     *
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
	     * // => 1
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
	     * // => 1
	     */
	    function sortedLastIndexBy(array, value, iteratee) {
	      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
	    }
	
	    /**
	     * This method is like `_.lastIndexOf` except that it performs a binary
	     * search on a sorted `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {*} value The value to search for.
	     * @returns {number} Returns the index of the matched value, else `-1`.
	     * @example
	     *
	     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
	     * // => 3
	     */
	    function sortedLastIndexOf(array, value) {
	      var length = array == null ? 0 : array.length;
	      if (length) {
	        var index = baseSortedIndex(array, value, true) - 1;
	        if (eq(array[index], value)) {
	          return index;
	        }
	      }
	      return -1;
	    }
	
	    /**
	     * This method is like `_.uniq` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniq([1, 1, 2]);
	     * // => [1, 2]
	     */
	    function sortedUniq(array) {
	      return (array && array.length)
	        ? baseSortedUniq(array)
	        : [];
	    }
	
	    /**
	     * This method is like `_.uniqBy` except that it's designed and optimized
	     * for sorted arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
	     * // => [1.1, 2.3]
	     */
	    function sortedUniqBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSortedUniq(array, getIteratee(iteratee, 2))
	        : [];
	    }
	
	    /**
	     * Gets all but the first element of `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.tail([1, 2, 3]);
	     * // => [2, 3]
	     */
	    function tail(array) {
	      var length = array == null ? 0 : array.length;
	      return length ? baseSlice(array, 1, length) : [];
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the beginning.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.take([1, 2, 3]);
	     * // => [1]
	     *
	     * _.take([1, 2, 3], 2);
	     * // => [1, 2]
	     *
	     * _.take([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.take([1, 2, 3], 0);
	     * // => []
	     */
	    function take(array, n, guard) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      return baseSlice(array, 0, n < 0 ? 0 : n);
	    }
	
	    /**
	     * Creates a slice of `array` with `n` elements taken from the end.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {number} [n=1] The number of elements to take.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * _.takeRight([1, 2, 3]);
	     * // => [3]
	     *
	     * _.takeRight([1, 2, 3], 2);
	     * // => [2, 3]
	     *
	     * _.takeRight([1, 2, 3], 5);
	     * // => [1, 2, 3]
	     *
	     * _.takeRight([1, 2, 3], 0);
	     * // => []
	     */
	    function takeRight(array, n, guard) {
	      var length = array == null ? 0 : array.length;
	      if (!length) {
	        return [];
	      }
	      n = (guard || n === undefined) ? 1 : toInteger(n);
	      n = length - n;
	      return baseSlice(array, n < 0 ? 0 : n, length);
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the end. Elements are
	     * taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': true },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': false }
	     * ];
	     *
	     * _.takeRightWhile(users, function(o) { return !o.active; });
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
	     * // => objects for ['pebbles']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeRightWhile(users, ['active', false]);
	     * // => objects for ['fred', 'pebbles']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeRightWhile(users, 'active');
	     * // => []
	     */
	    function takeRightWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3), false, true)
	        : [];
	    }
	
	    /**
	     * Creates a slice of `array` with elements taken from the beginning. Elements
	     * are taken until `predicate` returns falsey. The predicate is invoked with
	     * three arguments: (value, index, array).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Array
	     * @param {Array} array The array to query.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the slice of `array`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'active': false },
	     *   { 'user': 'fred',    'active': false },
	     *   { 'user': 'pebbles', 'active': true }
	     * ];
	     *
	     * _.takeWhile(users, function(o) { return !o.active; });
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.takeWhile(users, { 'user': 'barney', 'active': false });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.takeWhile(users, ['active', false]);
	     * // => objects for ['barney', 'fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.takeWhile(users, 'active');
	     * // => []
	     */
	    function takeWhile(array, predicate) {
	      return (array && array.length)
	        ? baseWhile(array, getIteratee(predicate, 3))
	        : [];
	    }
	
	    /**
	     * Creates an array of unique values, in order, from all given arrays using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.union([2], [1, 2]);
	     * // => [2, 1]
	     */
	    var union = baseRest(function(arrays) {
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which uniqueness is computed. Result values are chosen from the first
	     * array in which the value occurs. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    var unionBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.union` except that it accepts `comparator` which
	     * is invoked to compare elements of `arrays`. Result values are chosen from
	     * the first array in which the value occurs. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of combined values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.unionWith(objects, others, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var unionWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
	    });
	
	    /**
	     * Creates a duplicate-free version of an array, using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons, in which only the first occurrence of each element
	     * is kept. The order of result values is determined by the order they occur
	     * in the array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniq([2, 1, 2]);
	     * // => [2, 1]
	     */
	    function uniq(array) {
	      return (array && array.length) ? baseUniq(array) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * uniqueness is computed. The order of result values is determined by the
	     * order they occur in the array. The iteratee is invoked with one argument:
	     * (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
	     * // => [2.1, 1.2]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 1 }, { 'x': 2 }]
	     */
	    function uniqBy(array, iteratee) {
	      return (array && array.length) ? baseUniq(array, getIteratee(iteratee, 2)) : [];
	    }
	
	    /**
	     * This method is like `_.uniq` except that it accepts `comparator` which
	     * is invoked to compare elements of `array`. The order of result values is
	     * determined by the order they occur in the array.The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new duplicate free array.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.uniqWith(objects, _.isEqual);
	     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
	     */
	    function uniqWith(array, comparator) {
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return (array && array.length) ? baseUniq(array, undefined, comparator) : [];
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts an array of grouped
	     * elements and creates an array regrouping the elements to their pre-zip
	     * configuration.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.2.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     *
	     * _.unzip(zipped);
	     * // => [['a', 'b'], [1, 2], [true, false]]
	     */
	    function unzip(array) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var length = 0;
	      array = arrayFilter(array, function(group) {
	        if (isArrayLikeObject(group)) {
	          length = nativeMax(group.length, length);
	          return true;
	        }
	      });
	      return baseTimes(length, function(index) {
	        return arrayMap(array, baseProperty(index));
	      });
	    }
	
	    /**
	     * This method is like `_.unzip` except that it accepts `iteratee` to specify
	     * how regrouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {Array} array The array of grouped elements to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  regrouped values.
	     * @returns {Array} Returns the new array of regrouped elements.
	     * @example
	     *
	     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
	     * // => [[1, 10, 100], [2, 20, 200]]
	     *
	     * _.unzipWith(zipped, _.add);
	     * // => [3, 30, 300]
	     */
	    function unzipWith(array, iteratee) {
	      if (!(array && array.length)) {
	        return [];
	      }
	      var result = unzip(array);
	      if (iteratee == null) {
	        return result;
	      }
	      return arrayMap(result, function(group) {
	        return apply(iteratee, undefined, group);
	      });
	    }
	
	    /**
	     * Creates an array excluding all given values using
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * for equality comparisons.
	     *
	     * **Note:** Unlike `_.pull`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {Array} array The array to inspect.
	     * @param {...*} [values] The values to exclude.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.xor
	     * @example
	     *
	     * _.without([2, 1, 2, 3], 1, 2);
	     * // => [3]
	     */
	    var without = baseRest(function(array, values) {
	      return isArrayLikeObject(array)
	        ? baseDifference(array, values)
	        : [];
	    });
	
	    /**
	     * Creates an array of unique values that is the
	     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
	     * of the given arrays. The order of result values is determined by the order
	     * they occur in the arrays.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @returns {Array} Returns the new array of filtered values.
	     * @see _.difference, _.without
	     * @example
	     *
	     * _.xor([2, 1], [2, 3]);
	     * // => [1, 3]
	     */
	    var xor = baseRest(function(arrays) {
	      return baseXor(arrayFilter(arrays, isArrayLikeObject));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `iteratee` which is
	     * invoked for each element of each `arrays` to generate the criterion by
	     * which by which they're compared. The order of result values is determined
	     * by the order they occur in the arrays. The iteratee is invoked with one
	     * argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
	     * // => [1.2, 3.4]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
	     * // => [{ 'x': 2 }]
	     */
	    var xorBy = baseRest(function(arrays) {
	      var iteratee = last(arrays);
	      if (isArrayLikeObject(iteratee)) {
	        iteratee = undefined;
	      }
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
	    });
	
	    /**
	     * This method is like `_.xor` except that it accepts `comparator` which is
	     * invoked to compare elements of `arrays`. The order of result values is
	     * determined by the order they occur in the arrays. The comparator is invoked
	     * with two arguments: (arrVal, othVal).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to inspect.
	     * @param {Function} [comparator] The comparator invoked per element.
	     * @returns {Array} Returns the new array of filtered values.
	     * @example
	     *
	     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
	     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
	     *
	     * _.xorWith(objects, others, _.isEqual);
	     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
	     */
	    var xorWith = baseRest(function(arrays) {
	      var comparator = last(arrays);
	      comparator = typeof comparator == 'function' ? comparator : undefined;
	      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
	    });
	
	    /**
	     * Creates an array of grouped elements, the first of which contains the
	     * first elements of the given arrays, the second of which contains the
	     * second elements of the given arrays, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zip(['a', 'b'], [1, 2], [true, false]);
	     * // => [['a', 1, true], ['b', 2, false]]
	     */
	    var zip = baseRest(unzip);
	
	    /**
	     * This method is like `_.fromPairs` except that it accepts two arrays,
	     * one of property identifiers and one of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.4.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObject(['a', 'b'], [1, 2]);
	     * // => { 'a': 1, 'b': 2 }
	     */
	    function zipObject(props, values) {
	      return baseZipObject(props || [], values || [], assignValue);
	    }
	
	    /**
	     * This method is like `_.zipObject` except that it supports property paths.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Array
	     * @param {Array} [props=[]] The property identifiers.
	     * @param {Array} [values=[]] The property values.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
	     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
	     */
	    function zipObjectDeep(props, values) {
	      return baseZipObject(props || [], values || [], baseSet);
	    }
	
	    /**
	     * This method is like `_.zip` except that it accepts `iteratee` to specify
	     * how grouped values should be combined. The iteratee is invoked with the
	     * elements of each group: (...group).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Array
	     * @param {...Array} [arrays] The arrays to process.
	     * @param {Function} [iteratee=_.identity] The function to combine
	     *  grouped values.
	     * @returns {Array} Returns the new array of grouped elements.
	     * @example
	     *
	     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
	     *   return a + b + c;
	     * });
	     * // => [111, 222]
	     */
	    var zipWith = baseRest(function(arrays) {
	      var length = arrays.length,
	          iteratee = length > 1 ? arrays[length - 1] : undefined;
	
	      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
	      return unzipWith(arrays, iteratee);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
	     * chain sequences enabled. The result of such sequences must be unwrapped
	     * with `_#value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Seq
	     * @param {*} value The value to wrap.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36 },
	     *   { 'user': 'fred',    'age': 40 },
	     *   { 'user': 'pebbles', 'age': 1 }
	     * ];
	     *
	     * var youngest = _
	     *   .chain(users)
	     *   .sortBy('age')
	     *   .map(function(o) {
	     *     return o.user + ' is ' + o.age;
	     *   })
	     *   .head()
	     *   .value();
	     * // => 'pebbles is 1'
	     */
	    function chain(value) {
	      var result = lodash(value);
	      result.__chain__ = true;
	      return result;
	    }
	
	    /**
	     * This method invokes `interceptor` and returns `value`. The interceptor
	     * is invoked with one argument; (value). The purpose of this method is to
	     * "tap into" a method chain sequence in order to modify intermediate results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * _([1, 2, 3])
	     *  .tap(function(array) {
	     *    // Mutate input array.
	     *    array.pop();
	     *  })
	     *  .reverse()
	     *  .value();
	     * // => [2, 1]
	     */
	    function tap(value, interceptor) {
	      interceptor(value);
	      return value;
	    }
	
	    /**
	     * This method is like `_.tap` except that it returns the result of `interceptor`.
	     * The purpose of this method is to "pass thru" values replacing intermediate
	     * results in a method chain sequence.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Seq
	     * @param {*} value The value to provide to `interceptor`.
	     * @param {Function} interceptor The function to invoke.
	     * @returns {*} Returns the result of `interceptor`.
	     * @example
	     *
	     * _('  abc  ')
	     *  .chain()
	     *  .trim()
	     *  .thru(function(value) {
	     *    return [value];
	     *  })
	     *  .value();
	     * // => ['abc']
	     */
	    function thru(value, interceptor) {
	      return interceptor(value);
	    }
	
	    /**
	     * This method is the wrapper version of `_.at`.
	     *
	     * @name at
	     * @memberOf _
	     * @since 1.0.0
	     * @category Seq
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _(object).at(['a[0].b.c', 'a[1]']).value();
	     * // => [3, 4]
	     */
	    var wrapperAt = flatRest(function(paths) {
	      var length = paths.length,
	          start = length ? paths[0] : 0,
	          value = this.__wrapped__,
	          interceptor = function(object) { return baseAt(object, paths); };
	
	      if (length > 1 || this.__actions__.length ||
	          !(value instanceof LazyWrapper) || !isIndex(start)) {
	        return this.thru(interceptor);
	      }
	      value = value.slice(start, +start + (length ? 1 : 0));
	      value.__actions__.push({
	        'func': thru,
	        'args': [interceptor],
	        'thisArg': undefined
	      });
	      return new LodashWrapper(value, this.__chain__).thru(function(array) {
	        if (length && !array.length) {
	          array.push(undefined);
	        }
	        return array;
	      });
	    });
	
	    /**
	     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
	     *
	     * @name chain
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 }
	     * ];
	     *
	     * // A sequence without explicit chaining.
	     * _(users).head();
	     * // => { 'user': 'barney', 'age': 36 }
	     *
	     * // A sequence with explicit chaining.
	     * _(users)
	     *   .chain()
	     *   .head()
	     *   .pick('user')
	     *   .value();
	     * // => { 'user': 'barney' }
	     */
	    function wrapperChain() {
	      return chain(this);
	    }
	
	    /**
	     * Executes the chain sequence and returns the wrapped result.
	     *
	     * @name commit
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2];
	     * var wrapped = _(array).push(3);
	     *
	     * console.log(array);
	     * // => [1, 2]
	     *
	     * wrapped = wrapped.commit();
	     * console.log(array);
	     * // => [1, 2, 3]
	     *
	     * wrapped.last();
	     * // => 3
	     *
	     * console.log(array);
	     * // => [1, 2, 3]
	     */
	    function wrapperCommit() {
	      return new LodashWrapper(this.value(), this.__chain__);
	    }
	
	    /**
	     * Gets the next value on a wrapped object following the
	     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
	     *
	     * @name next
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the next iterator value.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 1 }
	     *
	     * wrapped.next();
	     * // => { 'done': false, 'value': 2 }
	     *
	     * wrapped.next();
	     * // => { 'done': true, 'value': undefined }
	     */
	    function wrapperNext() {
	      if (this.__values__ === undefined) {
	        this.__values__ = toArray(this.value());
	      }
	      var done = this.__index__ >= this.__values__.length,
	          value = done ? undefined : this.__values__[this.__index__++];
	
	      return { 'done': done, 'value': value };
	    }
	
	    /**
	     * Enables the wrapper to be iterable.
	     *
	     * @name Symbol.iterator
	     * @memberOf _
	     * @since 4.0.0
	     * @category Seq
	     * @returns {Object} Returns the wrapper object.
	     * @example
	     *
	     * var wrapped = _([1, 2]);
	     *
	     * wrapped[Symbol.iterator]() === wrapped;
	     * // => true
	     *
	     * Array.from(wrapped);
	     * // => [1, 2]
	     */
	    function wrapperToIterator() {
	      return this;
	    }
	
	    /**
	     * Creates a clone of the chain sequence planting `value` as the wrapped value.
	     *
	     * @name plant
	     * @memberOf _
	     * @since 3.2.0
	     * @category Seq
	     * @param {*} value The value to plant.
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var wrapped = _([1, 2]).map(square);
	     * var other = wrapped.plant([3, 4]);
	     *
	     * other.value();
	     * // => [9, 16]
	     *
	     * wrapped.value();
	     * // => [1, 4]
	     */
	    function wrapperPlant(value) {
	      var result,
	          parent = this;
	
	      while (parent instanceof baseLodash) {
	        var clone = wrapperClone(parent);
	        clone.__index__ = 0;
	        clone.__values__ = undefined;
	        if (result) {
	          previous.__wrapped__ = clone;
	        } else {
	          result = clone;
	        }
	        var previous = clone;
	        parent = parent.__wrapped__;
	      }
	      previous.__wrapped__ = value;
	      return result;
	    }
	
	    /**
	     * This method is the wrapper version of `_.reverse`.
	     *
	     * **Note:** This method mutates the wrapped array.
	     *
	     * @name reverse
	     * @memberOf _
	     * @since 0.1.0
	     * @category Seq
	     * @returns {Object} Returns the new `lodash` wrapper instance.
	     * @example
	     *
	     * var array = [1, 2, 3];
	     *
	     * _(array).reverse().value()
	     * // => [3, 2, 1]
	     *
	     * console.log(array);
	     * // => [3, 2, 1]
	     */
	    function wrapperReverse() {
	      var value = this.__wrapped__;
	      if (value instanceof LazyWrapper) {
	        var wrapped = value;
	        if (this.__actions__.length) {
	          wrapped = new LazyWrapper(this);
	        }
	        wrapped = wrapped.reverse();
	        wrapped.__actions__.push({
	          'func': thru,
	          'args': [reverse],
	          'thisArg': undefined
	        });
	        return new LodashWrapper(wrapped, this.__chain__);
	      }
	      return this.thru(reverse);
	    }
	
	    /**
	     * Executes the chain sequence to resolve the unwrapped value.
	     *
	     * @name value
	     * @memberOf _
	     * @since 0.1.0
	     * @alias toJSON, valueOf
	     * @category Seq
	     * @returns {*} Returns the resolved unwrapped value.
	     * @example
	     *
	     * _([1, 2, 3]).value();
	     * // => [1, 2, 3]
	     */
	    function wrapperValue() {
	      return baseWrapperValue(this.__wrapped__, this.__actions__);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the number of times the key was returned by `iteratee`. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.countBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': 1, '6': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.countBy(['one', 'two', 'three'], 'length');
	     * // => { '3': 2, '5': 1 }
	     */
	    var countBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        ++result[key];
	      } else {
	        baseAssignValue(result, key, 1);
	      }
	    });
	
	    /**
	     * Checks if `predicate` returns truthy for **all** elements of `collection`.
	     * Iteration is stopped once `predicate` returns falsey. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * **Note:** This method returns `true` for
	     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
	     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
	     * elements of empty collections.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if all elements pass the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.every([true, 1, null, 'yes'], Boolean);
	     * // => false
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.every(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.every(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.every(users, 'active');
	     * // => false
	     */
	    function every(collection, predicate, guard) {
	      var func = isArray(collection) ? arrayEvery : baseEvery;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning an array of all elements
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * **Note:** Unlike `_.remove`, this method returns a new array.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.reject
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * _.filter(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, { 'age': 36, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.filter(users, 'active');
	     * // => objects for ['barney']
	     */
	    function filter(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Iterates over elements of `collection`, returning the first element
	     * `predicate` returns truthy for. The predicate is invoked with three
	     * arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': true },
	     *   { 'user': 'fred',    'age': 40, 'active': false },
	     *   { 'user': 'pebbles', 'age': 1,  'active': true }
	     * ];
	     *
	     * _.find(users, function(o) { return o.age < 40; });
	     * // => object for 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.find(users, { 'age': 1, 'active': true });
	     * // => object for 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.find(users, ['active', false]);
	     * // => object for 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.find(users, 'active');
	     * // => object for 'barney'
	     */
	    var find = createFind(findIndex);
	
	    /**
	     * This method is like `_.find` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param {number} [fromIndex=collection.length-1] The index to search from.
	     * @returns {*} Returns the matched element, else `undefined`.
	     * @example
	     *
	     * _.findLast([1, 2, 3, 4], function(n) {
	     *   return n % 2 == 1;
	     * });
	     * // => 3
	     */
	    var findLast = createFind(findLastIndex);
	
	    /**
	     * Creates a flattened array of values by running each element in `collection`
	     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
	     * with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [n, n];
	     * }
	     *
	     * _.flatMap([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMap(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), 1);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDeep([1, 2], duplicate);
	     * // => [1, 1, 2, 2]
	     */
	    function flatMapDeep(collection, iteratee) {
	      return baseFlatten(map(collection, iteratee), INFINITY);
	    }
	
	    /**
	     * This method is like `_.flatMap` except that it recursively flattens the
	     * mapped results up to `depth` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {number} [depth=1] The maximum recursion depth.
	     * @returns {Array} Returns the new flattened array.
	     * @example
	     *
	     * function duplicate(n) {
	     *   return [[[n, n]]];
	     * }
	     *
	     * _.flatMapDepth([1, 2], duplicate, 2);
	     * // => [[1, 1], [2, 2]]
	     */
	    function flatMapDepth(collection, iteratee, depth) {
	      depth = depth === undefined ? 1 : toInteger(depth);
	      return baseFlatten(map(collection, iteratee), depth);
	    }
	
	    /**
	     * Iterates over elements of `collection` and invokes `iteratee` for each element.
	     * The iteratee is invoked with three arguments: (value, index|key, collection).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * **Note:** As with other "Collections" methods, objects with a "length"
	     * property are iterated like arrays. To avoid this behavior use `_.forIn`
	     * or `_.forOwn` for object iteration.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @alias each
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEachRight
	     * @example
	     *
	     * _.forEach([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `1` then `2`.
	     *
	     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forEach(collection, iteratee) {
	      var func = isArray(collection) ? arrayEach : baseEach;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forEach` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @alias eachRight
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array|Object} Returns `collection`.
	     * @see _.forEach
	     * @example
	     *
	     * _.forEachRight([1, 2], function(value) {
	     *   console.log(value);
	     * });
	     * // => Logs `2` then `1`.
	     */
	    function forEachRight(collection, iteratee) {
	      var func = isArray(collection) ? arrayEachRight : baseEachRight;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The order of grouped values
	     * is determined by the order they occur in `collection`. The corresponding
	     * value of each key is an array of elements responsible for generating the
	     * key. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
	     * // => { '4': [4.2], '6': [6.1, 6.3] }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.groupBy(['one', 'two', 'three'], 'length');
	     * // => { '3': ['one', 'two'], '5': ['three'] }
	     */
	    var groupBy = createAggregator(function(result, value, key) {
	      if (hasOwnProperty.call(result, key)) {
	        result[key].push(value);
	      } else {
	        baseAssignValue(result, key, [value]);
	      }
	    });
	
	    /**
	     * Checks if `value` is in `collection`. If `collection` is a string, it's
	     * checked for a substring of `value`, otherwise
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * is used for equality comparisons. If `fromIndex` is negative, it's used as
	     * the offset from the end of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @param {*} value The value to search for.
	     * @param {number} [fromIndex=0] The index to search from.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {boolean} Returns `true` if `value` is found, else `false`.
	     * @example
	     *
	     * _.includes([1, 2, 3], 1);
	     * // => true
	     *
	     * _.includes([1, 2, 3], 1, 2);
	     * // => false
	     *
	     * _.includes({ 'a': 1, 'b': 2 }, 1);
	     * // => true
	     *
	     * _.includes('abcd', 'bc');
	     * // => true
	     */
	    function includes(collection, value, fromIndex, guard) {
	      collection = isArrayLike(collection) ? collection : values(collection);
	      fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;
	
	      var length = collection.length;
	      if (fromIndex < 0) {
	        fromIndex = nativeMax(length + fromIndex, 0);
	      }
	      return isString(collection)
	        ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
	        : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
	    }
	
	    /**
	     * Invokes the method at `path` of each element in `collection`, returning
	     * an array of the results of each invoked method. Any additional arguments
	     * are provided to each invoked method. If `path` is a function, it's invoked
	     * for, and `this` bound to, each element in `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array|Function|string} path The path of the method to invoke or
	     *  the function invoked per iteration.
	     * @param {...*} [args] The arguments to invoke each method with.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
	     * // => [[1, 5, 7], [1, 2, 3]]
	     *
	     * _.invokeMap([123, 456], String.prototype.split, '');
	     * // => [['1', '2', '3'], ['4', '5', '6']]
	     */
	    var invokeMap = baseRest(function(collection, path, args) {
	      var index = -1,
	          isFunc = typeof path == 'function',
	          result = isArrayLike(collection) ? Array(collection.length) : [];
	
	      baseEach(collection, function(value) {
	        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
	      });
	      return result;
	    });
	
	    /**
	     * Creates an object composed of keys generated from the results of running
	     * each element of `collection` thru `iteratee`. The corresponding value of
	     * each key is the last element responsible for generating the key. The
	     * iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
	     * @returns {Object} Returns the composed aggregate object.
	     * @example
	     *
	     * var array = [
	     *   { 'dir': 'left', 'code': 97 },
	     *   { 'dir': 'right', 'code': 100 }
	     * ];
	     *
	     * _.keyBy(array, function(o) {
	     *   return String.fromCharCode(o.code);
	     * });
	     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
	     *
	     * _.keyBy(array, 'dir');
	     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
	     */
	    var keyBy = createAggregator(function(result, value, key) {
	      baseAssignValue(result, key, value);
	    });
	
	    /**
	     * Creates an array of values by running each element in `collection` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	     *
	     * The guarded methods are:
	     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new mapped array.
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * _.map([4, 8], square);
	     * // => [16, 64]
	     *
	     * _.map({ 'a': 4, 'b': 8 }, square);
	     * // => [16, 64] (iteration order is not guaranteed)
	     *
	     * var users = [
	     *   { 'user': 'barney' },
	     *   { 'user': 'fred' }
	     * ];
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, 'user');
	     * // => ['barney', 'fred']
	     */
	    function map(collection, iteratee) {
	      var func = isArray(collection) ? arrayMap : baseMap;
	      return func(collection, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.sortBy` except that it allows specifying the sort
	     * orders of the iteratees to sort by. If `orders` is unspecified, all values
	     * are sorted in ascending order. Otherwise, specify an order of "desc" for
	     * descending or "asc" for ascending sort order of corresponding values.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @param {string[]} [orders] The sort orders of `iteratees`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 34 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 36 }
	     * ];
	     *
	     * // Sort by `user` in ascending order and by `age` in descending order.
	     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     */
	    function orderBy(collection, iteratees, orders, guard) {
	      if (collection == null) {
	        return [];
	      }
	      if (!isArray(iteratees)) {
	        iteratees = iteratees == null ? [] : [iteratees];
	      }
	      orders = guard ? undefined : orders;
	      if (!isArray(orders)) {
	        orders = orders == null ? [] : [orders];
	      }
	      return baseOrderBy(collection, iteratees, orders);
	    }
	
	    /**
	     * Creates an array of elements split into two groups, the first of which
	     * contains elements `predicate` returns truthy for, the second of which
	     * contains elements `predicate` returns falsey for. The predicate is
	     * invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of grouped elements.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney',  'age': 36, 'active': false },
	     *   { 'user': 'fred',    'age': 40, 'active': true },
	     *   { 'user': 'pebbles', 'age': 1,  'active': false }
	     * ];
	     *
	     * _.partition(users, function(o) { return o.active; });
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.partition(users, { 'age': 1, 'active': false });
	     * // => objects for [['pebbles'], ['barney', 'fred']]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.partition(users, ['active', false]);
	     * // => objects for [['barney', 'pebbles'], ['fred']]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.partition(users, 'active');
	     * // => objects for [['fred'], ['barney', 'pebbles']]
	     */
	    var partition = createAggregator(function(result, value, key) {
	      result[key ? 0 : 1].push(value);
	    }, function() { return [[], []]; });
	
	    /**
	     * Reduces `collection` to a value which is the accumulated result of running
	     * each element in `collection` thru `iteratee`, where each successive
	     * invocation is supplied the return value of the previous. If `accumulator`
	     * is not given, the first element of `collection` is used as the initial
	     * value. The iteratee is invoked with four arguments:
	     * (accumulator, value, index|key, collection).
	     *
	     * Many lodash methods are guarded to work as iteratees for methods like
	     * `_.reduce`, `_.reduceRight`, and `_.transform`.
	     *
	     * The guarded methods are:
	     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	     * and `sortBy`
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduceRight
	     * @example
	     *
	     * _.reduce([1, 2], function(sum, n) {
	     *   return sum + n;
	     * }, 0);
	     * // => 3
	     *
	     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     *   return result;
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	     */
	    function reduce(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduce : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	    }
	
	    /**
	     * This method is like `_.reduce` except that it iterates over elements of
	     * `collection` from right to left.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The initial value.
	     * @returns {*} Returns the accumulated value.
	     * @see _.reduce
	     * @example
	     *
	     * var array = [[0, 1], [2, 3], [4, 5]];
	     *
	     * _.reduceRight(array, function(flattened, other) {
	     *   return flattened.concat(other);
	     * }, []);
	     * // => [4, 5, 2, 3, 0, 1]
	     */
	    function reduceRight(collection, iteratee, accumulator) {
	      var func = isArray(collection) ? arrayReduceRight : baseReduce,
	          initAccum = arguments.length < 3;
	
	      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
	    }
	
	    /**
	     * The opposite of `_.filter`; this method returns the elements of `collection`
	     * that `predicate` does **not** return truthy for.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the new filtered array.
	     * @see _.filter
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': false },
	     *   { 'user': 'fred',   'age': 40, 'active': true }
	     * ];
	     *
	     * _.reject(users, function(o) { return !o.active; });
	     * // => objects for ['fred']
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.reject(users, { 'age': 40, 'active': true });
	     * // => objects for ['barney']
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.reject(users, ['active', false]);
	     * // => objects for ['fred']
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.reject(users, 'active');
	     * // => objects for ['barney']
	     */
	    function reject(collection, predicate) {
	      var func = isArray(collection) ? arrayFilter : baseFilter;
	      return func(collection, negate(getIteratee(predicate, 3)));
	    }
	
	    /**
	     * Gets a random element from `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @returns {*} Returns the random element.
	     * @example
	     *
	     * _.sample([1, 2, 3, 4]);
	     * // => 2
	     */
	    function sample(collection) {
	      var func = isArray(collection) ? arraySample : baseSample;
	      return func(collection);
	    }
	
	    /**
	     * Gets `n` random elements at unique keys from `collection` up to the
	     * size of `collection`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to sample.
	     * @param {number} [n=1] The number of elements to sample.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the random elements.
	     * @example
	     *
	     * _.sampleSize([1, 2, 3], 2);
	     * // => [3, 1]
	     *
	     * _.sampleSize([1, 2, 3], 4);
	     * // => [2, 3, 1]
	     */
	    function sampleSize(collection, n, guard) {
	      if ((guard ? isIterateeCall(collection, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
	      return func(collection, n);
	    }
	
	    /**
	     * Creates an array of shuffled values, using a version of the
	     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to shuffle.
	     * @returns {Array} Returns the new shuffled array.
	     * @example
	     *
	     * _.shuffle([1, 2, 3, 4]);
	     * // => [4, 1, 3, 2]
	     */
	    function shuffle(collection) {
	      var func = isArray(collection) ? arrayShuffle : baseShuffle;
	      return func(collection);
	    }
	
	    /**
	     * Gets the size of `collection` by returning its length for array-like
	     * values or the number of own enumerable string keyed properties for objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object|string} collection The collection to inspect.
	     * @returns {number} Returns the collection size.
	     * @example
	     *
	     * _.size([1, 2, 3]);
	     * // => 3
	     *
	     * _.size({ 'a': 1, 'b': 2 });
	     * // => 2
	     *
	     * _.size('pebbles');
	     * // => 7
	     */
	    function size(collection) {
	      if (collection == null) {
	        return 0;
	      }
	      if (isArrayLike(collection)) {
	        return isString(collection) ? stringSize(collection) : collection.length;
	      }
	      var tag = getTag(collection);
	      if (tag == mapTag || tag == setTag) {
	        return collection.size;
	      }
	      return baseKeys(collection).length;
	    }
	
	    /**
	     * Checks if `predicate` returns truthy for **any** element of `collection`.
	     * Iteration is stopped once `predicate` returns truthy. The predicate is
	     * invoked with three arguments: (value, index|key, collection).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {boolean} Returns `true` if any element passes the predicate check,
	     *  else `false`.
	     * @example
	     *
	     * _.some([null, 0, 'yes', false], Boolean);
	     * // => true
	     *
	     * var users = [
	     *   { 'user': 'barney', 'active': true },
	     *   { 'user': 'fred',   'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.some(users, { 'user': 'barney', 'active': false });
	     * // => false
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.some(users, ['active', false]);
	     * // => true
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.some(users, 'active');
	     * // => true
	     */
	    function some(collection, predicate, guard) {
	      var func = isArray(collection) ? arraySome : baseSome;
	      if (guard && isIterateeCall(collection, predicate, guard)) {
	        predicate = undefined;
	      }
	      return func(collection, getIteratee(predicate, 3));
	    }
	
	    /**
	     * Creates an array of elements, sorted in ascending order by the results of
	     * running each element in a collection thru each iteratee. This method
	     * performs a stable sort, that is, it preserves the original sort order of
	     * equal elements. The iteratees are invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Collection
	     * @param {Array|Object} collection The collection to iterate over.
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to sort by.
	     * @returns {Array} Returns the new sorted array.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'fred',   'age': 48 },
	     *   { 'user': 'barney', 'age': 36 },
	     *   { 'user': 'fred',   'age': 40 },
	     *   { 'user': 'barney', 'age': 34 }
	     * ];
	     *
	     * _.sortBy(users, [function(o) { return o.user; }]);
	     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
	     *
	     * _.sortBy(users, ['user', 'age']);
	     * // => objects for [['barney', 34], ['barney', 36], ['fred', 40], ['fred', 48]]
	     */
	    var sortBy = baseRest(function(collection, iteratees) {
	      if (collection == null) {
	        return [];
	      }
	      var length = iteratees.length;
	      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
	        iteratees = [];
	      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
	        iteratees = [iteratees[0]];
	      }
	      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
	    });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Gets the timestamp of the number of milliseconds that have elapsed since
	     * the Unix epoch (1 January 1970 00:00:00 UTC).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Date
	     * @returns {number} Returns the timestamp.
	     * @example
	     *
	     * _.defer(function(stamp) {
	     *   console.log(_.now() - stamp);
	     * }, _.now());
	     * // => Logs the number of milliseconds it took for the deferred invocation.
	     */
	    var now = ctxNow || function() {
	      return root.Date.now();
	    };
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The opposite of `_.before`; this method creates a function that invokes
	     * `func` once it's called `n` or more times.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {number} n The number of calls before `func` is invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var saves = ['profile', 'settings'];
	     *
	     * var done = _.after(saves.length, function() {
	     *   console.log('done saving!');
	     * });
	     *
	     * _.forEach(saves, function(type) {
	     *   asyncSave({ 'type': type, 'complete': done });
	     * });
	     * // => Logs 'done saving!' after the two async saves have completed.
	     */
	    function after(n, func) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n < 1) {
	          return func.apply(this, arguments);
	        }
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func`, with up to `n` arguments,
	     * ignoring any additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @param {number} [n=func.length] The arity cap.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
	     * // => [6, 8, 10]
	     */
	    function ary(func, n, guard) {
	      n = guard ? undefined : n;
	      n = (func && n == null) ? func.length : n;
	      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
	    }
	
	    /**
	     * Creates a function that invokes `func`, with the `this` binding and arguments
	     * of the created function, while it's called less than `n` times. Subsequent
	     * calls to the created function return the result of the last `func` invocation.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {number} n The number of calls at which `func` is no longer invoked.
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * jQuery(element).on('click', _.before(5, addContactToList));
	     * // => Allows adding up to 4 contacts to the list.
	     */
	    function before(n, func) {
	      var result;
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      n = toInteger(n);
	      return function() {
	        if (--n > 0) {
	          result = func.apply(this, arguments);
	        }
	        if (n <= 1) {
	          func = undefined;
	        }
	        return result;
	      };
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of `thisArg`
	     * and `partials` prepended to the arguments it receives.
	     *
	     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	     * property of bound functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to bind.
	     * @param {*} thisArg The `this` binding of `func`.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * function greet(greeting, punctuation) {
	     *   return greeting + ' ' + this.user + punctuation;
	     * }
	     *
	     * var object = { 'user': 'fred' };
	     *
	     * var bound = _.bind(greet, object, 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bind(greet, object, _, '!');
	     * bound('hi');
	     * // => 'hi fred!'
	     */
	    var bind = baseRest(function(func, thisArg, partials) {
	      var bitmask = WRAP_BIND_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bind));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(func, bitmask, thisArg, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes the method at `object[key]` with `partials`
	     * prepended to the arguments it receives.
	     *
	     * This method differs from `_.bind` by allowing bound functions to reference
	     * methods that may be redefined or don't yet exist. See
	     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
	     * for more details.
	     *
	     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Function
	     * @param {Object} object The object to invoke the method on.
	     * @param {string} key The key of the method.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new bound function.
	     * @example
	     *
	     * var object = {
	     *   'user': 'fred',
	     *   'greet': function(greeting, punctuation) {
	     *     return greeting + ' ' + this.user + punctuation;
	     *   }
	     * };
	     *
	     * var bound = _.bindKey(object, 'greet', 'hi');
	     * bound('!');
	     * // => 'hi fred!'
	     *
	     * object.greet = function(greeting, punctuation) {
	     *   return greeting + 'ya ' + this.user + punctuation;
	     * };
	     *
	     * bound('!');
	     * // => 'hiya fred!'
	     *
	     * // Bound with placeholders.
	     * var bound = _.bindKey(object, 'greet', _, '!');
	     * bound('hi');
	     * // => 'hiya fred!'
	     */
	    var bindKey = baseRest(function(object, key, partials) {
	      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
	      if (partials.length) {
	        var holders = replaceHolders(partials, getHolder(bindKey));
	        bitmask |= WRAP_PARTIAL_FLAG;
	      }
	      return createWrap(key, bitmask, object, partials, holders);
	    });
	
	    /**
	     * Creates a function that accepts arguments of `func` and either invokes
	     * `func` returning its result, if at least `arity` number of arguments have
	     * been provided, or returns a function that accepts the remaining `func`
	     * arguments, and so on. The arity of `func` may be specified if `func.length`
	     * is not sufficient.
	     *
	     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
	     * may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curry(abc);
	     *
	     * curried(1)(2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2)(3);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(1)(_, 3)(2);
	     * // => [1, 2, 3]
	     */
	    function curry(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curry.placeholder;
	      return result;
	    }
	
	    /**
	     * This method is like `_.curry` except that arguments are applied to `func`
	     * in the manner of `_.partialRight` instead of `_.partial`.
	     *
	     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for provided arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of curried functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to curry.
	     * @param {number} [arity=func.length] The arity of `func`.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the new curried function.
	     * @example
	     *
	     * var abc = function(a, b, c) {
	     *   return [a, b, c];
	     * };
	     *
	     * var curried = _.curryRight(abc);
	     *
	     * curried(3)(2)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(2, 3)(1);
	     * // => [1, 2, 3]
	     *
	     * curried(1, 2, 3);
	     * // => [1, 2, 3]
	     *
	     * // Curried with placeholders.
	     * curried(3)(1, _)(2);
	     * // => [1, 2, 3]
	     */
	    function curryRight(func, arity, guard) {
	      arity = guard ? undefined : arity;
	      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
	      result.placeholder = curryRight.placeholder;
	      return result;
	    }
	
	    /**
	     * Creates a debounced function that delays invoking `func` until after `wait`
	     * milliseconds have elapsed since the last time the debounced function was
	     * invoked. The debounced function comes with a `cancel` method to cancel
	     * delayed `func` invocations and a `flush` method to immediately invoke them.
	     * Provide `options` to indicate whether `func` should be invoked on the
	     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	     * with the last arguments provided to the debounced function. Subsequent
	     * calls to the debounced function return the result of the last `func`
	     * invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the debounced function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.debounce` and `_.throttle`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to debounce.
	     * @param {number} [wait=0] The number of milliseconds to delay.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=false]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {number} [options.maxWait]
	     *  The maximum time `func` is allowed to be delayed before it's invoked.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new debounced function.
	     * @example
	     *
	     * // Avoid costly calculations while the window size is in flux.
	     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	     *
	     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	     * jQuery(element).on('click', _.debounce(sendMail, 300, {
	     *   'leading': true,
	     *   'trailing': false
	     * }));
	     *
	     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	     * var source = new EventSource('/stream');
	     * jQuery(source).on('message', debounced);
	     *
	     * // Cancel the trailing debounced invocation.
	     * jQuery(window).on('popstate', debounced.cancel);
	     */
	    function debounce(func, wait, options) {
	      var lastArgs,
	          lastThis,
	          maxWait,
	          result,
	          timerId,
	          lastCallTime,
	          lastInvokeTime = 0,
	          leading = false,
	          maxing = false,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      wait = toNumber(wait) || 0;
	      if (isObject(options)) {
	        leading = !!options.leading;
	        maxing = 'maxWait' in options;
	        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	
	      function invokeFunc(time) {
	        var args = lastArgs,
	            thisArg = lastThis;
	
	        lastArgs = lastThis = undefined;
	        lastInvokeTime = time;
	        result = func.apply(thisArg, args);
	        return result;
	      }
	
	      function leadingEdge(time) {
	        // Reset any `maxWait` timer.
	        lastInvokeTime = time;
	        // Start the timer for the trailing edge.
	        timerId = setTimeout(timerExpired, wait);
	        // Invoke the leading edge.
	        return leading ? invokeFunc(time) : result;
	      }
	
	      function remainingWait(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime,
	            result = wait - timeSinceLastCall;
	
	        return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	      }
	
	      function shouldInvoke(time) {
	        var timeSinceLastCall = time - lastCallTime,
	            timeSinceLastInvoke = time - lastInvokeTime;
	
	        // Either this is the first call, activity has stopped and we're at the
	        // trailing edge, the system time has gone backwards and we're treating
	        // it as the trailing edge, or we've hit the `maxWait` limit.
	        return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	          (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	      }
	
	      function timerExpired() {
	        var time = now();
	        if (shouldInvoke(time)) {
	          return trailingEdge(time);
	        }
	        // Restart the timer.
	        timerId = setTimeout(timerExpired, remainingWait(time));
	      }
	
	      function trailingEdge(time) {
	        timerId = undefined;
	
	        // Only invoke if we have `lastArgs` which means `func` has been
	        // debounced at least once.
	        if (trailing && lastArgs) {
	          return invokeFunc(time);
	        }
	        lastArgs = lastThis = undefined;
	        return result;
	      }
	
	      function cancel() {
	        if (timerId !== undefined) {
	          clearTimeout(timerId);
	        }
	        lastInvokeTime = 0;
	        lastArgs = lastCallTime = lastThis = timerId = undefined;
	      }
	
	      function flush() {
	        return timerId === undefined ? result : trailingEdge(now());
	      }
	
	      function debounced() {
	        var time = now(),
	            isInvoking = shouldInvoke(time);
	
	        lastArgs = arguments;
	        lastThis = this;
	        lastCallTime = time;
	
	        if (isInvoking) {
	          if (timerId === undefined) {
	            return leadingEdge(lastCallTime);
	          }
	          if (maxing) {
	            // Handle invocations in a tight loop.
	            timerId = setTimeout(timerExpired, wait);
	            return invokeFunc(lastCallTime);
	          }
	        }
	        if (timerId === undefined) {
	          timerId = setTimeout(timerExpired, wait);
	        }
	        return result;
	      }
	      debounced.cancel = cancel;
	      debounced.flush = flush;
	      return debounced;
	    }
	
	    /**
	     * Defers invoking the `func` until the current call stack has cleared. Any
	     * additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to defer.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.defer(function(text) {
	     *   console.log(text);
	     * }, 'deferred');
	     * // => Logs 'deferred' after one millisecond.
	     */
	    var defer = baseRest(function(func, args) {
	      return baseDelay(func, 1, args);
	    });
	
	    /**
	     * Invokes `func` after `wait` milliseconds. Any additional arguments are
	     * provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to delay.
	     * @param {number} wait The number of milliseconds to delay invocation.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {number} Returns the timer id.
	     * @example
	     *
	     * _.delay(function(text) {
	     *   console.log(text);
	     * }, 1000, 'later');
	     * // => Logs 'later' after one second.
	     */
	    var delay = baseRest(function(func, wait, args) {
	      return baseDelay(func, toNumber(wait) || 0, args);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments reversed.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to flip arguments for.
	     * @returns {Function} Returns the new flipped function.
	     * @example
	     *
	     * var flipped = _.flip(function() {
	     *   return _.toArray(arguments);
	     * });
	     *
	     * flipped('a', 'b', 'c', 'd');
	     * // => ['d', 'c', 'b', 'a']
	     */
	    function flip(func) {
	      return createWrap(func, WRAP_FLIP_FLAG);
	    }
	
	    /**
	     * Creates a function that memoizes the result of `func`. If `resolver` is
	     * provided, it determines the cache key for storing the result based on the
	     * arguments provided to the memoized function. By default, the first argument
	     * provided to the memoized function is used as the map cache key. The `func`
	     * is invoked with the `this` binding of the memoized function.
	     *
	     * **Note:** The cache is exposed as the `cache` property on the memoized
	     * function. Its creation may be customized by replacing the `_.memoize.Cache`
	     * constructor with one whose instances implement the
	     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to have its output memoized.
	     * @param {Function} [resolver] The function to resolve the cache key.
	     * @returns {Function} Returns the new memoized function.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     * var other = { 'c': 3, 'd': 4 };
	     *
	     * var values = _.memoize(_.values);
	     * values(object);
	     * // => [1, 2]
	     *
	     * values(other);
	     * // => [3, 4]
	     *
	     * object.a = 2;
	     * values(object);
	     * // => [1, 2]
	     *
	     * // Modify the result cache.
	     * values.cache.set(object, ['a', 'b']);
	     * values(object);
	     * // => ['a', 'b']
	     *
	     * // Replace `_.memoize.Cache`.
	     * _.memoize.Cache = WeakMap;
	     */
	    function memoize(func, resolver) {
	      if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      var memoized = function() {
	        var args = arguments,
	            key = resolver ? resolver.apply(this, args) : args[0],
	            cache = memoized.cache;
	
	        if (cache.has(key)) {
	          return cache.get(key);
	        }
	        var result = func.apply(this, args);
	        memoized.cache = cache.set(key, result) || cache;
	        return result;
	      };
	      memoized.cache = new (memoize.Cache || MapCache);
	      return memoized;
	    }
	
	    // Expose `MapCache`.
	    memoize.Cache = MapCache;
	
	    /**
	     * Creates a function that negates the result of the predicate `func`. The
	     * `func` predicate is invoked with the `this` binding and arguments of the
	     * created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} predicate The predicate to negate.
	     * @returns {Function} Returns the new negated function.
	     * @example
	     *
	     * function isEven(n) {
	     *   return n % 2 == 0;
	     * }
	     *
	     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	     * // => [1, 3, 5]
	     */
	    function negate(predicate) {
	      if (typeof predicate != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      return function() {
	        var args = arguments;
	        switch (args.length) {
	          case 0: return !predicate.call(this);
	          case 1: return !predicate.call(this, args[0]);
	          case 2: return !predicate.call(this, args[0], args[1]);
	          case 3: return !predicate.call(this, args[0], args[1], args[2]);
	        }
	        return !predicate.apply(this, args);
	      };
	    }
	
	    /**
	     * Creates a function that is restricted to invoking `func` once. Repeat calls
	     * to the function return the value of the first invocation. The `func` is
	     * invoked with the `this` binding and arguments of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to restrict.
	     * @returns {Function} Returns the new restricted function.
	     * @example
	     *
	     * var initialize = _.once(createApplication);
	     * initialize();
	     * initialize();
	     * // => `createApplication` is invoked once
	     */
	    function once(func) {
	      return before(2, func);
	    }
	
	    /**
	     * Creates a function that invokes `func` with its arguments transformed.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Function
	     * @param {Function} func The function to wrap.
	     * @param {...(Function|Function[])} [transforms=[_.identity]]
	     *  The argument transforms.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * function doubled(n) {
	     *   return n * 2;
	     * }
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var func = _.overArgs(function(x, y) {
	     *   return [x, y];
	     * }, [square, doubled]);
	     *
	     * func(9, 3);
	     * // => [81, 6]
	     *
	     * func(10, 5);
	     * // => [100, 10]
	     */
	    var overArgs = castRest(function(func, transforms) {
	      transforms = (transforms.length == 1 && isArray(transforms[0]))
	        ? arrayMap(transforms[0], baseUnary(getIteratee()))
	        : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
	
	      var funcsLength = transforms.length;
	      return baseRest(function(args) {
	        var index = -1,
	            length = nativeMin(args.length, funcsLength);
	
	        while (++index < length) {
	          args[index] = transforms[index].call(this, args[index]);
	        }
	        return apply(func, this, args);
	      });
	    });
	
	    /**
	     * Creates a function that invokes `func` with `partials` prepended to the
	     * arguments it receives. This method is like `_.bind` except it does **not**
	     * alter the `this` binding.
	     *
	     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.2.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var sayHelloTo = _.partial(greet, 'hello');
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     *
	     * // Partially applied with placeholders.
	     * var greetFred = _.partial(greet, _, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     */
	    var partial = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partial));
	      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * This method is like `_.partial` except that partially applied arguments
	     * are appended to the arguments it receives.
	     *
	     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
	     * builds, may be used as a placeholder for partially applied arguments.
	     *
	     * **Note:** This method doesn't set the "length" property of partially
	     * applied functions.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Function
	     * @param {Function} func The function to partially apply arguments to.
	     * @param {...*} [partials] The arguments to be partially applied.
	     * @returns {Function} Returns the new partially applied function.
	     * @example
	     *
	     * function greet(greeting, name) {
	     *   return greeting + ' ' + name;
	     * }
	     *
	     * var greetFred = _.partialRight(greet, 'fred');
	     * greetFred('hi');
	     * // => 'hi fred'
	     *
	     * // Partially applied with placeholders.
	     * var sayHelloTo = _.partialRight(greet, 'hello', _);
	     * sayHelloTo('fred');
	     * // => 'hello fred'
	     */
	    var partialRight = baseRest(function(func, partials) {
	      var holders = replaceHolders(partials, getHolder(partialRight));
	      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
	    });
	
	    /**
	     * Creates a function that invokes `func` with arguments arranged according
	     * to the specified `indexes` where the argument value at the first index is
	     * provided as the first argument, the argument value at the second index is
	     * provided as the second argument, and so on.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Function
	     * @param {Function} func The function to rearrange arguments for.
	     * @param {...(number|number[])} indexes The arranged argument indexes.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var rearged = _.rearg(function(a, b, c) {
	     *   return [a, b, c];
	     * }, [2, 0, 1]);
	     *
	     * rearged('b', 'c', 'a')
	     * // => ['a', 'b', 'c']
	     */
	    var rearg = flatRest(function(func, indexes) {
	      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
	    });
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * created function and arguments from `start` and beyond provided as
	     * an array.
	     *
	     * **Note:** This method is based on the
	     * [rest parameter](https://mdn.io/rest_parameters).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to apply a rest parameter to.
	     * @param {number} [start=func.length-1] The start position of the rest parameter.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.rest(function(what, names) {
	     *   return what + ' ' + _.initial(names).join(', ') +
	     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
	     * });
	     *
	     * say('hello', 'fred', 'barney', 'pebbles');
	     * // => 'hello fred, barney, & pebbles'
	     */
	    function rest(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start === undefined ? start : toInteger(start);
	      return baseRest(func, start);
	    }
	
	    /**
	     * Creates a function that invokes `func` with the `this` binding of the
	     * create function and an array of arguments much like
	     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
	     *
	     * **Note:** This method is based on the
	     * [spread operator](https://mdn.io/spread_operator).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Function
	     * @param {Function} func The function to spread arguments over.
	     * @param {number} [start=0] The start position of the spread.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var say = _.spread(function(who, what) {
	     *   return who + ' says ' + what;
	     * });
	     *
	     * say(['fred', 'hello']);
	     * // => 'fred says hello'
	     *
	     * var numbers = Promise.all([
	     *   Promise.resolve(40),
	     *   Promise.resolve(36)
	     * ]);
	     *
	     * numbers.then(_.spread(function(x, y) {
	     *   return x + y;
	     * }));
	     * // => a Promise of 76
	     */
	    function spread(func, start) {
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      start = start == null ? 0 : nativeMax(toInteger(start), 0);
	      return baseRest(function(args) {
	        var array = args[start],
	            otherArgs = castSlice(args, 0, start);
	
	        if (array) {
	          arrayPush(otherArgs, array);
	        }
	        return apply(func, this, otherArgs);
	      });
	    }
	
	    /**
	     * Creates a throttled function that only invokes `func` at most once per
	     * every `wait` milliseconds. The throttled function comes with a `cancel`
	     * method to cancel delayed `func` invocations and a `flush` method to
	     * immediately invoke them. Provide `options` to indicate whether `func`
	     * should be invoked on the leading and/or trailing edge of the `wait`
	     * timeout. The `func` is invoked with the last arguments provided to the
	     * throttled function. Subsequent calls to the throttled function return the
	     * result of the last `func` invocation.
	     *
	     * **Note:** If `leading` and `trailing` options are `true`, `func` is
	     * invoked on the trailing edge of the timeout only if the throttled function
	     * is invoked more than once during the `wait` timeout.
	     *
	     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	     *
	     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	     * for details over the differences between `_.throttle` and `_.debounce`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {Function} func The function to throttle.
	     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.leading=true]
	     *  Specify invoking on the leading edge of the timeout.
	     * @param {boolean} [options.trailing=true]
	     *  Specify invoking on the trailing edge of the timeout.
	     * @returns {Function} Returns the new throttled function.
	     * @example
	     *
	     * // Avoid excessively updating the position while scrolling.
	     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	     *
	     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	     * jQuery(element).on('click', throttled);
	     *
	     * // Cancel the trailing throttled invocation.
	     * jQuery(window).on('popstate', throttled.cancel);
	     */
	    function throttle(func, wait, options) {
	      var leading = true,
	          trailing = true;
	
	      if (typeof func != 'function') {
	        throw new TypeError(FUNC_ERROR_TEXT);
	      }
	      if (isObject(options)) {
	        leading = 'leading' in options ? !!options.leading : leading;
	        trailing = 'trailing' in options ? !!options.trailing : trailing;
	      }
	      return debounce(func, wait, {
	        'leading': leading,
	        'maxWait': wait,
	        'trailing': trailing
	      });
	    }
	
	    /**
	     * Creates a function that accepts up to one argument, ignoring any
	     * additional arguments.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Function
	     * @param {Function} func The function to cap arguments for.
	     * @returns {Function} Returns the new capped function.
	     * @example
	     *
	     * _.map(['6', '8', '10'], _.unary(parseInt));
	     * // => [6, 8, 10]
	     */
	    function unary(func) {
	      return ary(func, 1);
	    }
	
	    /**
	     * Creates a function that provides `value` to `wrapper` as its first
	     * argument. Any additional arguments provided to the function are appended
	     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
	     * binding of the created function.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Function
	     * @param {*} value The value to wrap.
	     * @param {Function} [wrapper=identity] The wrapper function.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var p = _.wrap(_.escape, function(func, text) {
	     *   return '<p>' + func(text) + '</p>';
	     * });
	     *
	     * p('fred, barney, & pebbles');
	     * // => '<p>fred, barney, &amp; pebbles</p>'
	     */
	    function wrap(value, wrapper) {
	      return partial(castFunction(wrapper), value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Casts `value` as an array if it's not one.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.4.0
	     * @category Lang
	     * @param {*} value The value to inspect.
	     * @returns {Array} Returns the cast array.
	     * @example
	     *
	     * _.castArray(1);
	     * // => [1]
	     *
	     * _.castArray({ 'a': 1 });
	     * // => [{ 'a': 1 }]
	     *
	     * _.castArray('abc');
	     * // => ['abc']
	     *
	     * _.castArray(null);
	     * // => [null]
	     *
	     * _.castArray(undefined);
	     * // => [undefined]
	     *
	     * _.castArray();
	     * // => []
	     *
	     * var array = [1, 2, 3];
	     * console.log(_.castArray(array) === array);
	     * // => true
	     */
	    function castArray() {
	      if (!arguments.length) {
	        return [];
	      }
	      var value = arguments[0];
	      return isArray(value) ? value : [value];
	    }
	
	    /**
	     * Creates a shallow clone of `value`.
	     *
	     * **Note:** This method is loosely based on the
	     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
	     * and supports cloning arrays, array buffers, booleans, date objects, maps,
	     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
	     * arrays. The own enumerable properties of `arguments` objects are cloned
	     * as plain objects. An empty object is returned for uncloneable values such
	     * as error objects, functions, DOM nodes, and WeakMaps.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeep
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var shallow = _.clone(objects);
	     * console.log(shallow[0] === objects[0]);
	     * // => true
	     */
	    function clone(value) {
	      return baseClone(value, CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.clone` except that it accepts `customizer` which
	     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
	     * cloning is handled by the method instead. The `customizer` is invoked with
	     * up to four arguments; (value [, index|key, object, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the cloned value.
	     * @see _.cloneDeepWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(false);
	     *   }
	     * }
	     *
	     * var el = _.cloneWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 0
	     */
	    function cloneWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * This method is like `_.clone` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.clone
	     * @example
	     *
	     * var objects = [{ 'a': 1 }, { 'b': 2 }];
	     *
	     * var deep = _.cloneDeep(objects);
	     * console.log(deep[0] === objects[0]);
	     * // => false
	     */
	    function cloneDeep(value) {
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
	    }
	
	    /**
	     * This method is like `_.cloneWith` except that it recursively clones `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to recursively clone.
	     * @param {Function} [customizer] The function to customize cloning.
	     * @returns {*} Returns the deep cloned value.
	     * @see _.cloneWith
	     * @example
	     *
	     * function customizer(value) {
	     *   if (_.isElement(value)) {
	     *     return value.cloneNode(true);
	     *   }
	     * }
	     *
	     * var el = _.cloneDeepWith(document.body, customizer);
	     *
	     * console.log(el === document.body);
	     * // => false
	     * console.log(el.nodeName);
	     * // => 'BODY'
	     * console.log(el.childNodes.length);
	     * // => 20
	     */
	    function cloneDeepWith(value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
	    }
	
	    /**
	     * Checks if `object` conforms to `source` by invoking the predicate
	     * properties of `source` with the corresponding property values of `object`.
	     *
	     * **Note:** This method is equivalent to `_.conforms` when `source` is
	     * partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
	     * // => true
	     *
	     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
	     * // => false
	     */
	    function conformsTo(object, source) {
	      return source == null || baseConformsTo(object, source, keys(source));
	    }
	
	    /**
	     * Performs a
	     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	     * comparison between two values to determine if they are equivalent.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.eq(object, object);
	     * // => true
	     *
	     * _.eq(object, other);
	     * // => false
	     *
	     * _.eq('a', 'a');
	     * // => true
	     *
	     * _.eq('a', Object('a'));
	     * // => false
	     *
	     * _.eq(NaN, NaN);
	     * // => true
	     */
	    function eq(value, other) {
	      return value === other || (value !== value && other !== other);
	    }
	
	    /**
	     * Checks if `value` is greater than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than `other`,
	     *  else `false`.
	     * @see _.lt
	     * @example
	     *
	     * _.gt(3, 1);
	     * // => true
	     *
	     * _.gt(3, 3);
	     * // => false
	     *
	     * _.gt(1, 3);
	     * // => false
	     */
	    var gt = createRelationalOperation(baseGt);
	
	    /**
	     * Checks if `value` is greater than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is greater than or equal to
	     *  `other`, else `false`.
	     * @see _.lte
	     * @example
	     *
	     * _.gte(3, 1);
	     * // => true
	     *
	     * _.gte(3, 3);
	     * // => true
	     *
	     * _.gte(1, 3);
	     * // => false
	     */
	    var gte = createRelationalOperation(function(value, other) {
	      return value >= other;
	    });
	
	    /**
	     * Checks if `value` is likely an `arguments` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArguments(function() { return arguments; }());
	     * // => true
	     *
	     * _.isArguments([1, 2, 3]);
	     * // => false
	     */
	    var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	        !propertyIsEnumerable.call(value, 'callee');
	    };
	
	    /**
	     * Checks if `value` is classified as an `Array` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	     * @example
	     *
	     * _.isArray([1, 2, 3]);
	     * // => true
	     *
	     * _.isArray(document.body.children);
	     * // => false
	     *
	     * _.isArray('abc');
	     * // => false
	     *
	     * _.isArray(_.noop);
	     * // => false
	     */
	    var isArray = Array.isArray;
	
	    /**
	     * Checks if `value` is classified as an `ArrayBuffer` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
	     * @example
	     *
	     * _.isArrayBuffer(new ArrayBuffer(2));
	     * // => true
	     *
	     * _.isArrayBuffer(new Array(2));
	     * // => false
	     */
	    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;
	
	    /**
	     * Checks if `value` is array-like. A value is considered array-like if it's
	     * not a function and has a `value.length` that's an integer greater than or
	     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	     * @example
	     *
	     * _.isArrayLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLike(document.body.children);
	     * // => true
	     *
	     * _.isArrayLike('abc');
	     * // => true
	     *
	     * _.isArrayLike(_.noop);
	     * // => false
	     */
	    function isArrayLike(value) {
	      return value != null && isLength(value.length) && !isFunction(value);
	    }
	
	    /**
	     * This method is like `_.isArrayLike` except that it also checks if `value`
	     * is an object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an array-like object,
	     *  else `false`.
	     * @example
	     *
	     * _.isArrayLikeObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isArrayLikeObject(document.body.children);
	     * // => true
	     *
	     * _.isArrayLikeObject('abc');
	     * // => false
	     *
	     * _.isArrayLikeObject(_.noop);
	     * // => false
	     */
	    function isArrayLikeObject(value) {
	      return isObjectLike(value) && isArrayLike(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a boolean primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
	     * @example
	     *
	     * _.isBoolean(false);
	     * // => true
	     *
	     * _.isBoolean(null);
	     * // => false
	     */
	    function isBoolean(value) {
	      return value === true || value === false ||
	        (isObjectLike(value) && baseGetTag(value) == boolTag);
	    }
	
	    /**
	     * Checks if `value` is a buffer.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	     * @example
	     *
	     * _.isBuffer(new Buffer(2));
	     * // => true
	     *
	     * _.isBuffer(new Uint8Array(2));
	     * // => false
	     */
	    var isBuffer = nativeIsBuffer || stubFalse;
	
	    /**
	     * Checks if `value` is classified as a `Date` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
	     * @example
	     *
	     * _.isDate(new Date);
	     * // => true
	     *
	     * _.isDate('Mon April 23 2012');
	     * // => false
	     */
	    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;
	
	    /**
	     * Checks if `value` is likely a DOM element.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
	     * @example
	     *
	     * _.isElement(document.body);
	     * // => true
	     *
	     * _.isElement('<body>');
	     * // => false
	     */
	    function isElement(value) {
	      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
	    }
	
	    /**
	     * Checks if `value` is an empty object, collection, map, or set.
	     *
	     * Objects are considered empty if they have no own enumerable string keyed
	     * properties.
	     *
	     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
	     * jQuery-like collections are considered empty if they have a `length` of `0`.
	     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
	     * @example
	     *
	     * _.isEmpty(null);
	     * // => true
	     *
	     * _.isEmpty(true);
	     * // => true
	     *
	     * _.isEmpty(1);
	     * // => true
	     *
	     * _.isEmpty([1, 2, 3]);
	     * // => false
	     *
	     * _.isEmpty({ 'a': 1 });
	     * // => false
	     */
	    function isEmpty(value) {
	      if (value == null) {
	        return true;
	      }
	      if (isArrayLike(value) &&
	          (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
	            isBuffer(value) || isTypedArray(value) || isArguments(value))) {
	        return !value.length;
	      }
	      var tag = getTag(value);
	      if (tag == mapTag || tag == setTag) {
	        return !value.size;
	      }
	      if (isPrototype(value)) {
	        return !baseKeys(value).length;
	      }
	      for (var key in value) {
	        if (hasOwnProperty.call(value, key)) {
	          return false;
	        }
	      }
	      return true;
	    }
	
	    /**
	     * Performs a deep comparison between two values to determine if they are
	     * equivalent.
	     *
	     * **Note:** This method supports comparing arrays, array buffers, booleans,
	     * date objects, error objects, maps, numbers, `Object` objects, regexes,
	     * sets, strings, symbols, and typed arrays. `Object` objects are compared
	     * by their own, not inherited, enumerable properties. Functions and DOM
	     * nodes are compared by strict equality, i.e. `===`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     * var other = { 'a': 1 };
	     *
	     * _.isEqual(object, other);
	     * // => true
	     *
	     * object === other;
	     * // => false
	     */
	    function isEqual(value, other) {
	      return baseIsEqual(value, other);
	    }
	
	    /**
	     * This method is like `_.isEqual` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with up to
	     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, othValue) {
	     *   if (isGreeting(objValue) && isGreeting(othValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var array = ['hello', 'goodbye'];
	     * var other = ['hi', 'goodbye'];
	     *
	     * _.isEqualWith(array, other, customizer);
	     * // => true
	     */
	    function isEqualWith(value, other, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      var result = customizer ? customizer(value, other) : undefined;
	      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
	    }
	
	    /**
	     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
	     * `SyntaxError`, `TypeError`, or `URIError` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
	     * @example
	     *
	     * _.isError(new Error);
	     * // => true
	     *
	     * _.isError(Error);
	     * // => false
	     */
	    function isError(value) {
	      if (!isObjectLike(value)) {
	        return false;
	      }
	      var tag = baseGetTag(value);
	      return tag == errorTag || tag == domExcTag ||
	        (typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value));
	    }
	
	    /**
	     * Checks if `value` is a finite primitive number.
	     *
	     * **Note:** This method is based on
	     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
	     * @example
	     *
	     * _.isFinite(3);
	     * // => true
	     *
	     * _.isFinite(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isFinite(Infinity);
	     * // => false
	     *
	     * _.isFinite('3');
	     * // => false
	     */
	    function isFinite(value) {
	      return typeof value == 'number' && nativeIsFinite(value);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Function` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	     * @example
	     *
	     * _.isFunction(_);
	     * // => true
	     *
	     * _.isFunction(/abc/);
	     * // => false
	     */
	    function isFunction(value) {
	      if (!isObject(value)) {
	        return false;
	      }
	      // The use of `Object#toString` avoids issues with the `typeof` operator
	      // in Safari 9 which returns 'object' for typed arrays and other constructors.
	      var tag = baseGetTag(value);
	      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	    }
	
	    /**
	     * Checks if `value` is an integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
	     * @example
	     *
	     * _.isInteger(3);
	     * // => true
	     *
	     * _.isInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isInteger(Infinity);
	     * // => false
	     *
	     * _.isInteger('3');
	     * // => false
	     */
	    function isInteger(value) {
	      return typeof value == 'number' && value == toInteger(value);
	    }
	
	    /**
	     * Checks if `value` is a valid array-like length.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	     * @example
	     *
	     * _.isLength(3);
	     * // => true
	     *
	     * _.isLength(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isLength(Infinity);
	     * // => false
	     *
	     * _.isLength('3');
	     * // => false
	     */
	    function isLength(value) {
	      return typeof value == 'number' &&
	        value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is the
	     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	     * @example
	     *
	     * _.isObject({});
	     * // => true
	     *
	     * _.isObject([1, 2, 3]);
	     * // => true
	     *
	     * _.isObject(_.noop);
	     * // => true
	     *
	     * _.isObject(null);
	     * // => false
	     */
	    function isObject(value) {
	      var type = typeof value;
	      return value != null && (type == 'object' || type == 'function');
	    }
	
	    /**
	     * Checks if `value` is object-like. A value is object-like if it's not `null`
	     * and has a `typeof` result of "object".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	     * @example
	     *
	     * _.isObjectLike({});
	     * // => true
	     *
	     * _.isObjectLike([1, 2, 3]);
	     * // => true
	     *
	     * _.isObjectLike(_.noop);
	     * // => false
	     *
	     * _.isObjectLike(null);
	     * // => false
	     */
	    function isObjectLike(value) {
	      return value != null && typeof value == 'object';
	    }
	
	    /**
	     * Checks if `value` is classified as a `Map` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
	     * @example
	     *
	     * _.isMap(new Map);
	     * // => true
	     *
	     * _.isMap(new WeakMap);
	     * // => false
	     */
	    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;
	
	    /**
	     * Performs a partial deep comparison between `object` and `source` to
	     * determine if `object` contains equivalent property values.
	     *
	     * **Note:** This method is equivalent to `_.matches` when `source` is
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2 };
	     *
	     * _.isMatch(object, { 'b': 2 });
	     * // => true
	     *
	     * _.isMatch(object, { 'b': 1 });
	     * // => false
	     */
	    function isMatch(object, source) {
	      return object === source || baseIsMatch(object, source, getMatchData(source));
	    }
	
	    /**
	     * This method is like `_.isMatch` except that it accepts `customizer` which
	     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
	     * are handled by the method instead. The `customizer` is invoked with five
	     * arguments: (objValue, srcValue, index|key, object, source).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {Object} object The object to inspect.
	     * @param {Object} source The object of property values to match.
	     * @param {Function} [customizer] The function to customize comparisons.
	     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	     * @example
	     *
	     * function isGreeting(value) {
	     *   return /^h(?:i|ello)$/.test(value);
	     * }
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
	     *     return true;
	     *   }
	     * }
	     *
	     * var object = { 'greeting': 'hello' };
	     * var source = { 'greeting': 'hi' };
	     *
	     * _.isMatchWith(object, source, customizer);
	     * // => true
	     */
	    function isMatchWith(object, source, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return baseIsMatch(object, source, getMatchData(source), customizer);
	    }
	
	    /**
	     * Checks if `value` is `NaN`.
	     *
	     * **Note:** This method is based on
	     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
	     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
	     * `undefined` and other non-number values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	     * @example
	     *
	     * _.isNaN(NaN);
	     * // => true
	     *
	     * _.isNaN(new Number(NaN));
	     * // => true
	     *
	     * isNaN(undefined);
	     * // => true
	     *
	     * _.isNaN(undefined);
	     * // => false
	     */
	    function isNaN(value) {
	      // An `NaN` primitive is the only value that is not equal to itself.
	      // Perform the `toStringTag` check first to avoid errors with some
	      // ActiveX objects in IE.
	      return isNumber(value) && value != +value;
	    }
	
	    /**
	     * Checks if `value` is a pristine native function.
	     *
	     * **Note:** This method can't reliably detect native functions in the presence
	     * of the core-js package because core-js circumvents this kind of detection.
	     * Despite multiple requests, the core-js maintainer has made it clear: any
	     * attempt to fix the detection will be obstructed. As a result, we're left
	     * with little choice but to throw an error. Unfortunately, this also affects
	     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
	     * which rely on core-js.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a native function,
	     *  else `false`.
	     * @example
	     *
	     * _.isNative(Array.prototype.push);
	     * // => true
	     *
	     * _.isNative(_);
	     * // => false
	     */
	    function isNative(value) {
	      if (isMaskable(value)) {
	        throw new Error(CORE_ERROR_TEXT);
	      }
	      return baseIsNative(value);
	    }
	
	    /**
	     * Checks if `value` is `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
	     * @example
	     *
	     * _.isNull(null);
	     * // => true
	     *
	     * _.isNull(void 0);
	     * // => false
	     */
	    function isNull(value) {
	      return value === null;
	    }
	
	    /**
	     * Checks if `value` is `null` or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
	     * @example
	     *
	     * _.isNil(null);
	     * // => true
	     *
	     * _.isNil(void 0);
	     * // => true
	     *
	     * _.isNil(NaN);
	     * // => false
	     */
	    function isNil(value) {
	      return value == null;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Number` primitive or object.
	     *
	     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
	     * classified as numbers, use the `_.isFinite` method.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
	     * @example
	     *
	     * _.isNumber(3);
	     * // => true
	     *
	     * _.isNumber(Number.MIN_VALUE);
	     * // => true
	     *
	     * _.isNumber(Infinity);
	     * // => true
	     *
	     * _.isNumber('3');
	     * // => false
	     */
	    function isNumber(value) {
	      return typeof value == 'number' ||
	        (isObjectLike(value) && baseGetTag(value) == numberTag);
	    }
	
	    /**
	     * Checks if `value` is a plain object, that is, an object created by the
	     * `Object` constructor or one with a `[[Prototype]]` of `null`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.8.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * _.isPlainObject(new Foo);
	     * // => false
	     *
	     * _.isPlainObject([1, 2, 3]);
	     * // => false
	     *
	     * _.isPlainObject({ 'x': 0, 'y': 0 });
	     * // => true
	     *
	     * _.isPlainObject(Object.create(null));
	     * // => true
	     */
	    function isPlainObject(value) {
	      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	        return false;
	      }
	      var proto = getPrototype(value);
	      if (proto === null) {
	        return true;
	      }
	      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	      return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	        funcToString.call(Ctor) == objectCtorString;
	    }
	
	    /**
	     * Checks if `value` is classified as a `RegExp` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.1.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
	     * @example
	     *
	     * _.isRegExp(/abc/);
	     * // => true
	     *
	     * _.isRegExp('/abc/');
	     * // => false
	     */
	    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;
	
	    /**
	     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
	     * double precision number which isn't the result of a rounded unsafe integer.
	     *
	     * **Note:** This method is based on
	     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
	     * @example
	     *
	     * _.isSafeInteger(3);
	     * // => true
	     *
	     * _.isSafeInteger(Number.MIN_VALUE);
	     * // => false
	     *
	     * _.isSafeInteger(Infinity);
	     * // => false
	     *
	     * _.isSafeInteger('3');
	     * // => false
	     */
	    function isSafeInteger(value) {
	      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
	    }
	
	    /**
	     * Checks if `value` is classified as a `Set` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
	     * @example
	     *
	     * _.isSet(new Set);
	     * // => true
	     *
	     * _.isSet(new WeakSet);
	     * // => false
	     */
	    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;
	
	    /**
	     * Checks if `value` is classified as a `String` primitive or object.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
	     * @example
	     *
	     * _.isString('abc');
	     * // => true
	     *
	     * _.isString(1);
	     * // => false
	     */
	    function isString(value) {
	      return typeof value == 'string' ||
	        (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a `Symbol` primitive or object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	     * @example
	     *
	     * _.isSymbol(Symbol.iterator);
	     * // => true
	     *
	     * _.isSymbol('abc');
	     * // => false
	     */
	    function isSymbol(value) {
	      return typeof value == 'symbol' ||
	        (isObjectLike(value) && baseGetTag(value) == symbolTag);
	    }
	
	    /**
	     * Checks if `value` is classified as a typed array.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	     * @example
	     *
	     * _.isTypedArray(new Uint8Array);
	     * // => true
	     *
	     * _.isTypedArray([]);
	     * // => false
	     */
	    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	    /**
	     * Checks if `value` is `undefined`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
	     * @example
	     *
	     * _.isUndefined(void 0);
	     * // => true
	     *
	     * _.isUndefined(null);
	     * // => false
	     */
	    function isUndefined(value) {
	      return value === undefined;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakMap` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
	     * @example
	     *
	     * _.isWeakMap(new WeakMap);
	     * // => true
	     *
	     * _.isWeakMap(new Map);
	     * // => false
	     */
	    function isWeakMap(value) {
	      return isObjectLike(value) && getTag(value) == weakMapTag;
	    }
	
	    /**
	     * Checks if `value` is classified as a `WeakSet` object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.3.0
	     * @category Lang
	     * @param {*} value The value to check.
	     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
	     * @example
	     *
	     * _.isWeakSet(new WeakSet);
	     * // => true
	     *
	     * _.isWeakSet(new Set);
	     * // => false
	     */
	    function isWeakSet(value) {
	      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
	    }
	
	    /**
	     * Checks if `value` is less than `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than `other`,
	     *  else `false`.
	     * @see _.gt
	     * @example
	     *
	     * _.lt(1, 3);
	     * // => true
	     *
	     * _.lt(3, 3);
	     * // => false
	     *
	     * _.lt(3, 1);
	     * // => false
	     */
	    var lt = createRelationalOperation(baseLt);
	
	    /**
	     * Checks if `value` is less than or equal to `other`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.9.0
	     * @category Lang
	     * @param {*} value The value to compare.
	     * @param {*} other The other value to compare.
	     * @returns {boolean} Returns `true` if `value` is less than or equal to
	     *  `other`, else `false`.
	     * @see _.gte
	     * @example
	     *
	     * _.lte(1, 3);
	     * // => true
	     *
	     * _.lte(3, 3);
	     * // => true
	     *
	     * _.lte(3, 1);
	     * // => false
	     */
	    var lte = createRelationalOperation(function(value, other) {
	      return value <= other;
	    });
	
	    /**
	     * Converts `value` to an array.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the converted array.
	     * @example
	     *
	     * _.toArray({ 'a': 1, 'b': 2 });
	     * // => [1, 2]
	     *
	     * _.toArray('abc');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toArray(1);
	     * // => []
	     *
	     * _.toArray(null);
	     * // => []
	     */
	    function toArray(value) {
	      if (!value) {
	        return [];
	      }
	      if (isArrayLike(value)) {
	        return isString(value) ? stringToArray(value) : copyArray(value);
	      }
	      if (symIterator && value[symIterator]) {
	        return iteratorToArray(value[symIterator]());
	      }
	      var tag = getTag(value),
	          func = tag == mapTag ? mapToArray : (tag == setTag ? setToArray : values);
	
	      return func(value);
	    }
	
	    /**
	     * Converts `value` to a finite number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.12.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted number.
	     * @example
	     *
	     * _.toFinite(3.2);
	     * // => 3.2
	     *
	     * _.toFinite(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toFinite(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toFinite('3.2');
	     * // => 3.2
	     */
	    function toFinite(value) {
	      if (!value) {
	        return value === 0 ? value : 0;
	      }
	      value = toNumber(value);
	      if (value === INFINITY || value === -INFINITY) {
	        var sign = (value < 0 ? -1 : 1);
	        return sign * MAX_INTEGER;
	      }
	      return value === value ? value : 0;
	    }
	
	    /**
	     * Converts `value` to an integer.
	     *
	     * **Note:** This method is loosely based on
	     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toInteger(3.2);
	     * // => 3
	     *
	     * _.toInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toInteger(Infinity);
	     * // => 1.7976931348623157e+308
	     *
	     * _.toInteger('3.2');
	     * // => 3
	     */
	    function toInteger(value) {
	      var result = toFinite(value),
	          remainder = result % 1;
	
	      return result === result ? (remainder ? result - remainder : result) : 0;
	    }
	
	    /**
	     * Converts `value` to an integer suitable for use as the length of an
	     * array-like object.
	     *
	     * **Note:** This method is based on
	     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toLength(3.2);
	     * // => 3
	     *
	     * _.toLength(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toLength(Infinity);
	     * // => 4294967295
	     *
	     * _.toLength('3.2');
	     * // => 3
	     */
	    function toLength(value) {
	      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
	    }
	
	    /**
	     * Converts `value` to a number.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to process.
	     * @returns {number} Returns the number.
	     * @example
	     *
	     * _.toNumber(3.2);
	     * // => 3.2
	     *
	     * _.toNumber(Number.MIN_VALUE);
	     * // => 5e-324
	     *
	     * _.toNumber(Infinity);
	     * // => Infinity
	     *
	     * _.toNumber('3.2');
	     * // => 3.2
	     */
	    function toNumber(value) {
	      if (typeof value == 'number') {
	        return value;
	      }
	      if (isSymbol(value)) {
	        return NAN;
	      }
	      if (isObject(value)) {
	        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	        value = isObject(other) ? (other + '') : other;
	      }
	      if (typeof value != 'string') {
	        return value === 0 ? value : +value;
	      }
	      value = value.replace(reTrim, '');
	      var isBinary = reIsBinary.test(value);
	      return (isBinary || reIsOctal.test(value))
	        ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	        : (reIsBadHex.test(value) ? NAN : +value);
	    }
	
	    /**
	     * Converts `value` to a plain object flattening inherited enumerable string
	     * keyed properties of `value` to own properties of the plain object.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {Object} Returns the converted plain object.
	     * @example
	     *
	     * function Foo() {
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.assign({ 'a': 1 }, new Foo);
	     * // => { 'a': 1, 'b': 2 }
	     *
	     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	     * // => { 'a': 1, 'b': 2, 'c': 3 }
	     */
	    function toPlainObject(value) {
	      return copyObject(value, keysIn(value));
	    }
	
	    /**
	     * Converts `value` to a safe integer. A safe integer can be compared and
	     * represented correctly.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.toSafeInteger(3.2);
	     * // => 3
	     *
	     * _.toSafeInteger(Number.MIN_VALUE);
	     * // => 0
	     *
	     * _.toSafeInteger(Infinity);
	     * // => 9007199254740991
	     *
	     * _.toSafeInteger('3.2');
	     * // => 3
	     */
	    function toSafeInteger(value) {
	      return value
	        ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER)
	        : (value === 0 ? value : 0);
	    }
	
	    /**
	     * Converts `value` to a string. An empty string is returned for `null`
	     * and `undefined` values. The sign of `-0` is preserved.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Lang
	     * @param {*} value The value to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.toString(null);
	     * // => ''
	     *
	     * _.toString(-0);
	     * // => '-0'
	     *
	     * _.toString([1, 2, 3]);
	     * // => '1,2,3'
	     */
	    function toString(value) {
	      return value == null ? '' : baseToString(value);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Assigns own enumerable string keyed properties of source objects to the
	     * destination object. Source objects are applied from left to right.
	     * Subsequent sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object` and is loosely based on
	     * [`Object.assign`](https://mdn.io/Object/assign).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assignIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assign({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var assign = createAssigner(function(object, source) {
	      if (isPrototype(source) || isArrayLike(source)) {
	        copyObject(source, keys(source), object);
	        return;
	      }
	      for (var key in source) {
	        if (hasOwnProperty.call(source, key)) {
	          assignValue(object, key, source[key]);
	        }
	      }
	    });
	
	    /**
	     * This method is like `_.assign` except that it iterates over own and
	     * inherited source properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extend
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.assign
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     * }
	     *
	     * function Bar() {
	     *   this.c = 3;
	     * }
	     *
	     * Foo.prototype.b = 2;
	     * Bar.prototype.d = 4;
	     *
	     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	     */
	    var assignIn = createAssigner(function(object, source) {
	      copyObject(source, keysIn(source), object);
	    });
	
	    /**
	     * This method is like `_.assignIn` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias extendWith
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignInWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keysIn(source), object, customizer);
	    });
	
	    /**
	     * This method is like `_.assign` except that it accepts `customizer`
	     * which is invoked to produce the assigned values. If `customizer` returns
	     * `undefined`, assignment is handled by the method instead. The `customizer`
	     * is invoked with five arguments: (objValue, srcValue, key, object, source).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @see _.assignInWith
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   return _.isUndefined(objValue) ? srcValue : objValue;
	     * }
	     *
	     * var defaults = _.partialRight(_.assignWith, customizer);
	     *
	     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	      copyObject(source, keys(source), object, customizer);
	    });
	
	    /**
	     * Creates an array of values corresponding to `paths` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Array} Returns the picked values.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	     *
	     * _.at(object, ['a[0].b.c', 'a[1]']);
	     * // => [3, 4]
	     */
	    var at = flatRest(baseAt);
	
	    /**
	     * Creates an object that inherits from the `prototype` object. If a
	     * `properties` object is given, its own enumerable string keyed properties
	     * are assigned to the created object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Object
	     * @param {Object} prototype The object to inherit from.
	     * @param {Object} [properties] The properties to assign to the object.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * function Shape() {
	     *   this.x = 0;
	     *   this.y = 0;
	     * }
	     *
	     * function Circle() {
	     *   Shape.call(this);
	     * }
	     *
	     * Circle.prototype = _.create(Shape.prototype, {
	     *   'constructor': Circle
	     * });
	     *
	     * var circle = new Circle;
	     * circle instanceof Circle;
	     * // => true
	     *
	     * circle instanceof Shape;
	     * // => true
	     */
	    function create(prototype, properties) {
	      var result = baseCreate(prototype);
	      return properties == null ? result : baseAssign(result, properties);
	    }
	
	    /**
	     * Assigns own and inherited enumerable string keyed properties of source
	     * objects to the destination object for all destination properties that
	     * resolve to `undefined`. Source objects are applied from left to right.
	     * Once a property is set, additional values of the same property are ignored.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaultsDeep
	     * @example
	     *
	     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	     * // => { 'a': 1, 'b': 2 }
	     */
	    var defaults = baseRest(function(args) {
	      args.push(undefined, customDefaultsAssignIn);
	      return apply(assignInWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.defaults` except that it recursively assigns
	     * default properties.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @see _.defaults
	     * @example
	     *
	     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	     * // => { 'a': { 'b': 2, 'c': 3 } }
	     */
	    var defaultsDeep = baseRest(function(args) {
	      args.push(undefined, customDefaultsMerge);
	      return apply(mergeWith, undefined, args);
	    });
	
	    /**
	     * This method is like `_.find` except that it returns the key of the first
	     * element `predicate` returns truthy for instead of the element itself.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findKey(users, function(o) { return o.age < 40; });
	     * // => 'barney' (iteration order is not guaranteed)
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findKey(users, { 'age': 1, 'active': true });
	     * // => 'pebbles'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findKey(users, 'active');
	     * // => 'barney'
	     */
	    function findKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
	    }
	
	    /**
	     * This method is like `_.findKey` except that it iterates over elements of
	     * a collection in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @param {Function} [predicate=_.identity] The function invoked per iteration.
	     * @returns {string|undefined} Returns the key of the matched element,
	     *  else `undefined`.
	     * @example
	     *
	     * var users = {
	     *   'barney':  { 'age': 36, 'active': true },
	     *   'fred':    { 'age': 40, 'active': false },
	     *   'pebbles': { 'age': 1,  'active': true }
	     * };
	     *
	     * _.findLastKey(users, function(o) { return o.age < 40; });
	     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.findLastKey(users, { 'age': 36, 'active': true });
	     * // => 'barney'
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.findLastKey(users, ['active', false]);
	     * // => 'fred'
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.findLastKey(users, 'active');
	     * // => 'pebbles'
	     */
	    function findLastKey(object, predicate) {
	      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
	    }
	
	    /**
	     * Iterates over own and inherited enumerable string keyed properties of an
	     * object and invokes `iteratee` for each property. The iteratee is invoked
	     * with three arguments: (value, key, object). Iteratee functions may exit
	     * iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forInRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forIn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	     */
	    function forIn(object, iteratee) {
	      return object == null
	        ? object
	        : baseFor(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * This method is like `_.forIn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forInRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	     */
	    function forInRight(object, iteratee) {
	      return object == null
	        ? object
	        : baseForRight(object, getIteratee(iteratee, 3), keysIn);
	    }
	
	    /**
	     * Iterates over own enumerable string keyed properties of an object and
	     * invokes `iteratee` for each property. The iteratee is invoked with three
	     * arguments: (value, key, object). Iteratee functions may exit iteration
	     * early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwnRight
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwn(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	     */
	    function forOwn(object, iteratee) {
	      return object && baseForOwn(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * This method is like `_.forOwn` except that it iterates over properties of
	     * `object` in the opposite order.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.0.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns `object`.
	     * @see _.forOwn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.forOwnRight(new Foo, function(value, key) {
	     *   console.log(key);
	     * });
	     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	     */
	    function forOwnRight(object, iteratee) {
	      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
	    }
	
	    /**
	     * Creates an array of function property names from own enumerable properties
	     * of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functionsIn
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functions(new Foo);
	     * // => ['a', 'b']
	     */
	    function functions(object) {
	      return object == null ? [] : baseFunctions(object, keys(object));
	    }
	
	    /**
	     * Creates an array of function property names from own and inherited
	     * enumerable properties of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to inspect.
	     * @returns {Array} Returns the function names.
	     * @see _.functions
	     * @example
	     *
	     * function Foo() {
	     *   this.a = _.constant('a');
	     *   this.b = _.constant('b');
	     * }
	     *
	     * Foo.prototype.c = _.constant('c');
	     *
	     * _.functionsIn(new Foo);
	     * // => ['a', 'b', 'c']
	     */
	    function functionsIn(object) {
	      return object == null ? [] : baseFunctions(object, keysIn(object));
	    }
	
	    /**
	     * Gets the value at `path` of `object`. If the resolved value is
	     * `undefined`, the `defaultValue` is returned in its place.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.get(object, 'a[0].b.c');
	     * // => 3
	     *
	     * _.get(object, ['a', '0', 'b', 'c']);
	     * // => 3
	     *
	     * _.get(object, 'a.b.c', 'default');
	     * // => 'default'
	     */
	    function get(object, path, defaultValue) {
	      var result = object == null ? undefined : baseGet(object, path);
	      return result === undefined ? defaultValue : result;
	    }
	
	    /**
	     * Checks if `path` is a direct property of `object`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = { 'a': { 'b': 2 } };
	     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.has(object, 'a');
	     * // => true
	     *
	     * _.has(object, 'a.b');
	     * // => true
	     *
	     * _.has(object, ['a', 'b']);
	     * // => true
	     *
	     * _.has(other, 'a');
	     * // => false
	     */
	    function has(object, path) {
	      return object != null && hasPath(object, path, baseHas);
	    }
	
	    /**
	     * Checks if `path` is a direct or inherited property of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path to check.
	     * @returns {boolean} Returns `true` if `path` exists, else `false`.
	     * @example
	     *
	     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	     *
	     * _.hasIn(object, 'a');
	     * // => true
	     *
	     * _.hasIn(object, 'a.b');
	     * // => true
	     *
	     * _.hasIn(object, ['a', 'b']);
	     * // => true
	     *
	     * _.hasIn(object, 'b');
	     * // => false
	     */
	    function hasIn(object, path) {
	      return object != null && hasPath(object, path, baseHasIn);
	    }
	
	    /**
	     * Creates an object composed of the inverted keys and values of `object`.
	     * If `object` contains duplicate values, subsequent values overwrite
	     * property assignments of previous values.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invert(object);
	     * // => { '1': 'c', '2': 'b' }
	     */
	    var invert = createInverter(function(result, value, key) {
	      result[value] = key;
	    }, constant(identity));
	
	    /**
	     * This method is like `_.invert` except that the inverted object is generated
	     * from the results of running each element of `object` thru `iteratee`. The
	     * corresponding inverted value of each inverted key is an array of keys
	     * responsible for generating the inverted value. The iteratee is invoked
	     * with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.1.0
	     * @category Object
	     * @param {Object} object The object to invert.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {Object} Returns the new inverted object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': 2, 'c': 1 };
	     *
	     * _.invertBy(object);
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     *
	     * _.invertBy(object, function(value) {
	     *   return 'group' + value;
	     * });
	     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	     */
	    var invertBy = createInverter(function(result, value, key) {
	      if (hasOwnProperty.call(result, value)) {
	        result[value].push(key);
	      } else {
	        result[value] = [key];
	      }
	    }, getIteratee);
	
	    /**
	     * Invokes the method at `path` of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {*} Returns the result of the invoked method.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	     *
	     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	     * // => [2, 3]
	     */
	    var invoke = baseRest(baseInvoke);
	
	    /**
	     * Creates an array of the own enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects. See the
	     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	     * for more details.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keys(new Foo);
	     * // => ['a', 'b'] (iteration order is not guaranteed)
	     *
	     * _.keys('hi');
	     * // => ['0', '1']
	     */
	    function keys(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable property names of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property names.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.keysIn(new Foo);
	     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	     */
	    function keysIn(object) {
	      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	    }
	
	    /**
	     * The opposite of `_.mapValues`; this method creates an object with the
	     * same values as `object` and keys generated by running each own enumerable
	     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	     * with three arguments: (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.8.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapValues
	     * @example
	     *
	     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	     *   return key + value;
	     * });
	     * // => { 'a1': 1, 'b2': 2 }
	     */
	    function mapKeys(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, iteratee(value, key, object), value);
	      });
	      return result;
	    }
	
	    /**
	     * Creates an object with the same keys as `object` and values generated
	     * by running each own enumerable string keyed property of `object` thru
	     * `iteratee`. The iteratee is invoked with three arguments:
	     * (value, key, object).
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Object} Returns the new mapped object.
	     * @see _.mapKeys
	     * @example
	     *
	     * var users = {
	     *   'fred':    { 'user': 'fred',    'age': 40 },
	     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	     * };
	     *
	     * _.mapValues(users, function(o) { return o.age; });
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.mapValues(users, 'age');
	     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	     */
	    function mapValues(object, iteratee) {
	      var result = {};
	      iteratee = getIteratee(iteratee, 3);
	
	      baseForOwn(object, function(value, key, object) {
	        baseAssignValue(result, key, iteratee(value, key, object));
	      });
	      return result;
	    }
	
	    /**
	     * This method is like `_.assign` except that it recursively merges own and
	     * inherited enumerable string keyed properties of source objects into the
	     * destination object. Source properties that resolve to `undefined` are
	     * skipped if a destination value exists. Array and plain object properties
	     * are merged recursively. Other objects and value types are overridden by
	     * assignment. Source objects are applied from left to right. Subsequent
	     * sources overwrite property assignments of previous sources.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.5.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} [sources] The source objects.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {
	     *   'a': [{ 'b': 2 }, { 'd': 4 }]
	     * };
	     *
	     * var other = {
	     *   'a': [{ 'c': 3 }, { 'e': 5 }]
	     * };
	     *
	     * _.merge(object, other);
	     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	     */
	    var merge = createAssigner(function(object, source, srcIndex) {
	      baseMerge(object, source, srcIndex);
	    });
	
	    /**
	     * This method is like `_.merge` except that it accepts `customizer` which
	     * is invoked to produce the merged values of the destination and source
	     * properties. If `customizer` returns `undefined`, merging is handled by the
	     * method instead. The `customizer` is invoked with six arguments:
	     * (objValue, srcValue, key, object, source, stack).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The destination object.
	     * @param {...Object} sources The source objects.
	     * @param {Function} customizer The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * function customizer(objValue, srcValue) {
	     *   if (_.isArray(objValue)) {
	     *     return objValue.concat(srcValue);
	     *   }
	     * }
	     *
	     * var object = { 'a': [1], 'b': [2] };
	     * var other = { 'a': [3], 'b': [4] };
	     *
	     * _.mergeWith(object, other, customizer);
	     * // => { 'a': [1, 3], 'b': [2, 4] }
	     */
	    var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	      baseMerge(object, source, srcIndex, customizer);
	    });
	
	    /**
	     * The opposite of `_.pick`; this method creates an object composed of the
	     * own and inherited enumerable property paths of `object` that are not omitted.
	     *
	     * **Note:** This method is considerably slower than `_.pick`.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to omit.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omit(object, ['a', 'c']);
	     * // => { 'b': '2' }
	     */
	    var omit = flatRest(function(object, paths) {
	      var result = {};
	      if (object == null) {
	        return result;
	      }
	      var isDeep = false;
	      paths = arrayMap(paths, function(path) {
	        path = castPath(path, object);
	        isDeep || (isDeep = path.length > 1);
	        return path;
	      });
	      copyObject(object, getAllKeysIn(object), result);
	      if (isDeep) {
	        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	      }
	      var length = paths.length;
	      while (length--) {
	        baseUnset(result, paths[length]);
	      }
	      return result;
	    });
	
	    /**
	     * The opposite of `_.pickBy`; this method creates an object composed of
	     * the own and inherited enumerable string keyed properties of `object` that
	     * `predicate` doesn't return truthy for. The predicate is invoked with two
	     * arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.omitBy(object, _.isNumber);
	     * // => { 'b': '2' }
	     */
	    function omitBy(object, predicate) {
	      return pickBy(object, negate(getIteratee(predicate)));
	    }
	
	    /**
	     * Creates an object composed of the picked `object` properties.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {...(string|string[])} [paths] The property paths to pick.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pick(object, ['a', 'c']);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    var pick = flatRest(function(object, paths) {
	      return object == null ? {} : basePick(object, paths);
	    });
	
	    /**
	     * Creates an object composed of the `object` properties `predicate` returns
	     * truthy for. The predicate is invoked with two arguments: (value, key).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The source object.
	     * @param {Function} [predicate=_.identity] The function invoked per property.
	     * @returns {Object} Returns the new object.
	     * @example
	     *
	     * var object = { 'a': 1, 'b': '2', 'c': 3 };
	     *
	     * _.pickBy(object, _.isNumber);
	     * // => { 'a': 1, 'c': 3 }
	     */
	    function pickBy(object, predicate) {
	      if (object == null) {
	        return {};
	      }
	      var props = arrayMap(getAllKeysIn(object), function(prop) {
	        return [prop];
	      });
	      predicate = getIteratee(predicate);
	      return basePickBy(object, props, function(value, path) {
	        return predicate(value, path[0]);
	      });
	    }
	
	    /**
	     * This method is like `_.get` except that if the resolved value is a
	     * function it's invoked with the `this` binding of its parent object and
	     * its result is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @param {Array|string} path The path of the property to resolve.
	     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	     *
	     * _.result(object, 'a[0].b.c1');
	     * // => 3
	     *
	     * _.result(object, 'a[0].b.c2');
	     * // => 4
	     *
	     * _.result(object, 'a[0].b.c3', 'default');
	     * // => 'default'
	     *
	     * _.result(object, 'a[0].b.c3', _.constant('default'));
	     * // => 'default'
	     */
	    function result(object, path, defaultValue) {
	      path = castPath(path, object);
	
	      var index = -1,
	          length = path.length;
	
	      // Ensure the loop is entered when path is empty.
	      if (!length) {
	        length = 1;
	        object = undefined;
	      }
	      while (++index < length) {
	        var value = object == null ? undefined : object[toKey(path[index])];
	        if (value === undefined) {
	          index = length;
	          value = defaultValue;
	        }
	        object = isFunction(value) ? value.call(object) : value;
	      }
	      return object;
	    }
	
	    /**
	     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	     * it's created. Arrays are created for missing index properties while objects
	     * are created for all other missing properties. Use `_.setWith` to customize
	     * `path` creation.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.set(object, 'a[0].b.c', 4);
	     * console.log(object.a[0].b.c);
	     * // => 4
	     *
	     * _.set(object, ['x', '0', 'y', 'z'], 5);
	     * console.log(object.x[0].y.z);
	     * // => 5
	     */
	    function set(object, path, value) {
	      return object == null ? object : baseSet(object, path, value);
	    }
	
	    /**
	     * This method is like `_.set` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {*} value The value to set.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.setWith(object, '[0][1]', 'a', Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function setWith(object, path, value, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseSet(object, path, value, customizer);
	    }
	
	    /**
	     * Creates an array of own enumerable string keyed-value pairs for `object`
	     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	     * entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entries
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairs(new Foo);
	     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	     */
	    var toPairs = createToPairs(keys);
	
	    /**
	     * Creates an array of own and inherited enumerable string keyed-value pairs
	     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	     * or set, its entries are returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @alias entriesIn
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the key-value pairs.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.toPairsIn(new Foo);
	     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	     */
	    var toPairsIn = createToPairs(keysIn);
	
	    /**
	     * An alternative to `_.reduce`; this method transforms `object` to a new
	     * `accumulator` object which is the result of running each of its own
	     * enumerable string keyed properties thru `iteratee`, with each invocation
	     * potentially mutating the `accumulator` object. If `accumulator` is not
	     * provided, a new object with the same `[[Prototype]]` will be used. The
	     * iteratee is invoked with four arguments: (accumulator, value, key, object).
	     * Iteratee functions may exit iteration early by explicitly returning `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.3.0
	     * @category Object
	     * @param {Object} object The object to iterate over.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @param {*} [accumulator] The custom accumulator value.
	     * @returns {*} Returns the accumulated value.
	     * @example
	     *
	     * _.transform([2, 3, 4], function(result, n) {
	     *   result.push(n *= n);
	     *   return n % 2 == 0;
	     * }, []);
	     * // => [4, 9]
	     *
	     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	     *   (result[value] || (result[value] = [])).push(key);
	     * }, {});
	     * // => { '1': ['a', 'c'], '2': ['b'] }
	     */
	    function transform(object, iteratee, accumulator) {
	      var isArr = isArray(object),
	          isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	      iteratee = getIteratee(iteratee, 4);
	      if (accumulator == null) {
	        var Ctor = object && object.constructor;
	        if (isArrLike) {
	          accumulator = isArr ? new Ctor : [];
	        }
	        else if (isObject(object)) {
	          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	        }
	        else {
	          accumulator = {};
	        }
	      }
	      (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	        return iteratee(accumulator, value, index, object);
	      });
	      return accumulator;
	    }
	
	    /**
	     * Removes the property at `path` of `object`.
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to unset.
	     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	     * _.unset(object, 'a[0].b.c');
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     *
	     * _.unset(object, ['a', '0', 'b', 'c']);
	     * // => true
	     *
	     * console.log(object);
	     * // => { 'a': [{ 'b': {} }] };
	     */
	    function unset(object, path) {
	      return object == null ? true : baseUnset(object, path);
	    }
	
	    /**
	     * This method is like `_.set` except that accepts `updater` to produce the
	     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	     * is invoked with one argument: (value).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	     *
	     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	     * console.log(object.a[0].b.c);
	     * // => 9
	     *
	     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	     * console.log(object.x[0].y.z);
	     * // => 0
	     */
	    function update(object, path, updater) {
	      return object == null ? object : baseUpdate(object, path, castFunction(updater));
	    }
	
	    /**
	     * This method is like `_.update` except that it accepts `customizer` which is
	     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	     * path creation is handled by the method instead. The `customizer` is invoked
	     * with three arguments: (nsValue, key, nsObject).
	     *
	     * **Note:** This method mutates `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.6.0
	     * @category Object
	     * @param {Object} object The object to modify.
	     * @param {Array|string} path The path of the property to set.
	     * @param {Function} updater The function to produce the updated value.
	     * @param {Function} [customizer] The function to customize assigned values.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var object = {};
	     *
	     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	     * // => { '0': { '1': 'a' } }
	     */
	    function updateWith(object, path, updater, customizer) {
	      customizer = typeof customizer == 'function' ? customizer : undefined;
	      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	    }
	
	    /**
	     * Creates an array of the own enumerable string keyed property values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.values(new Foo);
	     * // => [1, 2] (iteration order is not guaranteed)
	     *
	     * _.values('hi');
	     * // => ['h', 'i']
	     */
	    function values(object) {
	      return object == null ? [] : baseValues(object, keys(object));
	    }
	
	    /**
	     * Creates an array of the own and inherited enumerable string keyed property
	     * values of `object`.
	     *
	     * **Note:** Non-object values are coerced to objects.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Object
	     * @param {Object} object The object to query.
	     * @returns {Array} Returns the array of property values.
	     * @example
	     *
	     * function Foo() {
	     *   this.a = 1;
	     *   this.b = 2;
	     * }
	     *
	     * Foo.prototype.c = 3;
	     *
	     * _.valuesIn(new Foo);
	     * // => [1, 2, 3] (iteration order is not guaranteed)
	     */
	    function valuesIn(object) {
	      return object == null ? [] : baseValues(object, keysIn(object));
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Clamps `number` within the inclusive `lower` and `upper` bounds.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Number
	     * @param {number} number The number to clamp.
	     * @param {number} [lower] The lower bound.
	     * @param {number} upper The upper bound.
	     * @returns {number} Returns the clamped number.
	     * @example
	     *
	     * _.clamp(-10, -5, 5);
	     * // => -5
	     *
	     * _.clamp(10, -5, 5);
	     * // => 5
	     */
	    function clamp(number, lower, upper) {
	      if (upper === undefined) {
	        upper = lower;
	        lower = undefined;
	      }
	      if (upper !== undefined) {
	        upper = toNumber(upper);
	        upper = upper === upper ? upper : 0;
	      }
	      if (lower !== undefined) {
	        lower = toNumber(lower);
	        lower = lower === lower ? lower : 0;
	      }
	      return baseClamp(toNumber(number), lower, upper);
	    }
	
	    /**
	     * Checks if `n` is between `start` and up to, but not including, `end`. If
	     * `end` is not specified, it's set to `start` with `start` then set to `0`.
	     * If `start` is greater than `end` the params are swapped to support
	     * negative ranges.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.3.0
	     * @category Number
	     * @param {number} number The number to check.
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
	     * @see _.range, _.rangeRight
	     * @example
	     *
	     * _.inRange(3, 2, 4);
	     * // => true
	     *
	     * _.inRange(4, 8);
	     * // => true
	     *
	     * _.inRange(4, 2);
	     * // => false
	     *
	     * _.inRange(2, 2);
	     * // => false
	     *
	     * _.inRange(1.2, 2);
	     * // => true
	     *
	     * _.inRange(5.2, 4);
	     * // => false
	     *
	     * _.inRange(-3, -2, -6);
	     * // => true
	     */
	    function inRange(number, start, end) {
	      start = toFinite(start);
	      if (end === undefined) {
	        end = start;
	        start = 0;
	      } else {
	        end = toFinite(end);
	      }
	      number = toNumber(number);
	      return baseInRange(number, start, end);
	    }
	
	    /**
	     * Produces a random number between the inclusive `lower` and `upper` bounds.
	     * If only one argument is provided a number between `0` and the given number
	     * is returned. If `floating` is `true`, or either `lower` or `upper` are
	     * floats, a floating-point number is returned instead of an integer.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @memberOf _
	     * @since 0.7.0
	     * @category Number
	     * @param {number} [lower=0] The lower bound.
	     * @param {number} [upper=1] The upper bound.
	     * @param {boolean} [floating] Specify returning a floating-point number.
	     * @returns {number} Returns the random number.
	     * @example
	     *
	     * _.random(0, 5);
	     * // => an integer between 0 and 5
	     *
	     * _.random(5);
	     * // => also an integer between 0 and 5
	     *
	     * _.random(5, true);
	     * // => a floating-point number between 0 and 5
	     *
	     * _.random(1.2, 5.2);
	     * // => a floating-point number between 1.2 and 5.2
	     */
	    function random(lower, upper, floating) {
	      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
	        upper = floating = undefined;
	      }
	      if (floating === undefined) {
	        if (typeof upper == 'boolean') {
	          floating = upper;
	          upper = undefined;
	        }
	        else if (typeof lower == 'boolean') {
	          floating = lower;
	          lower = undefined;
	        }
	      }
	      if (lower === undefined && upper === undefined) {
	        lower = 0;
	        upper = 1;
	      }
	      else {
	        lower = toFinite(lower);
	        if (upper === undefined) {
	          upper = lower;
	          lower = 0;
	        } else {
	          upper = toFinite(upper);
	        }
	      }
	      if (lower > upper) {
	        var temp = lower;
	        lower = upper;
	        upper = temp;
	      }
	      if (floating || lower % 1 || upper % 1) {
	        var rand = nativeRandom();
	        return nativeMin(lower + (rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1)))), upper);
	      }
	      return baseRandom(lower, upper);
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the camel cased string.
	     * @example
	     *
	     * _.camelCase('Foo Bar');
	     * // => 'fooBar'
	     *
	     * _.camelCase('--foo-bar--');
	     * // => 'fooBar'
	     *
	     * _.camelCase('__FOO_BAR__');
	     * // => 'fooBar'
	     */
	    var camelCase = createCompounder(function(result, word, index) {
	      word = word.toLowerCase();
	      return result + (index ? capitalize(word) : word);
	    });
	
	    /**
	     * Converts the first character of `string` to upper case and the remaining
	     * to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to capitalize.
	     * @returns {string} Returns the capitalized string.
	     * @example
	     *
	     * _.capitalize('FRED');
	     * // => 'Fred'
	     */
	    function capitalize(string) {
	      return upperFirst(toString(string).toLowerCase());
	    }
	
	    /**
	     * Deburrs `string` by converting
	     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
	     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
	     * letters to basic Latin letters and removing
	     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to deburr.
	     * @returns {string} Returns the deburred string.
	     * @example
	     *
	     * _.deburr('déjà vu');
	     * // => 'deja vu'
	     */
	    function deburr(string) {
	      string = toString(string);
	      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
	    }
	
	    /**
	     * Checks if `string` ends with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=string.length] The position to search up to.
	     * @returns {boolean} Returns `true` if `string` ends with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.endsWith('abc', 'c');
	     * // => true
	     *
	     * _.endsWith('abc', 'b');
	     * // => false
	     *
	     * _.endsWith('abc', 'b', 2);
	     * // => true
	     */
	    function endsWith(string, target, position) {
	      string = toString(string);
	      target = baseToString(target);
	
	      var length = string.length;
	      position = position === undefined
	        ? length
	        : baseClamp(toInteger(position), 0, length);
	
	      var end = position;
	      position -= target.length;
	      return position >= 0 && string.slice(position, end) == target;
	    }
	
	    /**
	     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
	     * corresponding HTML entities.
	     *
	     * **Note:** No other characters are escaped. To escape additional
	     * characters use a third-party library like [_he_](https://mths.be/he).
	     *
	     * Though the ">" character is escaped for symmetry, characters like
	     * ">" and "/" don't need escaping in HTML and have no special meaning
	     * unless they're part of a tag or unquoted attribute value. See
	     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
	     * (under "semi-related fun fact") for more details.
	     *
	     * When working with HTML you should always
	     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
	     * XSS vectors.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escape('fred, barney, & pebbles');
	     * // => 'fred, barney, &amp; pebbles'
	     */
	    function escape(string) {
	      string = toString(string);
	      return (string && reHasUnescapedHtml.test(string))
	        ? string.replace(reUnescapedHtml, escapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
	     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to escape.
	     * @returns {string} Returns the escaped string.
	     * @example
	     *
	     * _.escapeRegExp('[lodash](https://lodash.com/)');
	     * // => '\[lodash\]\(https://lodash\.com/\)'
	     */
	    function escapeRegExp(string) {
	      string = toString(string);
	      return (string && reHasRegExpChar.test(string))
	        ? string.replace(reRegExpChar, '\\$&')
	        : string;
	    }
	
	    /**
	     * Converts `string` to
	     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the kebab cased string.
	     * @example
	     *
	     * _.kebabCase('Foo Bar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('fooBar');
	     * // => 'foo-bar'
	     *
	     * _.kebabCase('__FOO_BAR__');
	     * // => 'foo-bar'
	     */
	    var kebabCase = createCompounder(function(result, word, index) {
	      return result + (index ? '-' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts `string`, as space separated words, to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.lowerCase('--Foo-Bar--');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('fooBar');
	     * // => 'foo bar'
	     *
	     * _.lowerCase('__FOO_BAR__');
	     * // => 'foo bar'
	     */
	    var lowerCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Converts the first character of `string` to lower case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.lowerFirst('Fred');
	     * // => 'fred'
	     *
	     * _.lowerFirst('FRED');
	     * // => 'fRED'
	     */
	    var lowerFirst = createCaseFirst('toLowerCase');
	
	    /**
	     * Pads `string` on the left and right sides if it's shorter than `length`.
	     * Padding characters are truncated if they can't be evenly divided by `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.pad('abc', 8);
	     * // => '  abc   '
	     *
	     * _.pad('abc', 8, '_-');
	     * // => '_-abc_-_'
	     *
	     * _.pad('abc', 3);
	     * // => 'abc'
	     */
	    function pad(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      if (!length || strLength >= length) {
	        return string;
	      }
	      var mid = (length - strLength) / 2;
	      return (
	        createPadding(nativeFloor(mid), chars) +
	        string +
	        createPadding(nativeCeil(mid), chars)
	      );
	    }
	
	    /**
	     * Pads `string` on the right side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padEnd('abc', 6);
	     * // => 'abc   '
	     *
	     * _.padEnd('abc', 6, '_-');
	     * // => 'abc_-_'
	     *
	     * _.padEnd('abc', 3);
	     * // => 'abc'
	     */
	    function padEnd(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (string + createPadding(length - strLength, chars))
	        : string;
	    }
	
	    /**
	     * Pads `string` on the left side if it's shorter than `length`. Padding
	     * characters are truncated if they exceed `length`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to pad.
	     * @param {number} [length=0] The padding length.
	     * @param {string} [chars=' '] The string used as padding.
	     * @returns {string} Returns the padded string.
	     * @example
	     *
	     * _.padStart('abc', 6);
	     * // => '   abc'
	     *
	     * _.padStart('abc', 6, '_-');
	     * // => '_-_abc'
	     *
	     * _.padStart('abc', 3);
	     * // => 'abc'
	     */
	    function padStart(string, length, chars) {
	      string = toString(string);
	      length = toInteger(length);
	
	      var strLength = length ? stringSize(string) : 0;
	      return (length && strLength < length)
	        ? (createPadding(length - strLength, chars) + string)
	        : string;
	    }
	
	    /**
	     * Converts `string` to an integer of the specified radix. If `radix` is
	     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
	     * hexadecimal, in which case a `radix` of `16` is used.
	     *
	     * **Note:** This method aligns with the
	     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
	     *
	     * @static
	     * @memberOf _
	     * @since 1.1.0
	     * @category String
	     * @param {string} string The string to convert.
	     * @param {number} [radix=10] The radix to interpret `value` by.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {number} Returns the converted integer.
	     * @example
	     *
	     * _.parseInt('08');
	     * // => 8
	     *
	     * _.map(['6', '08', '10'], _.parseInt);
	     * // => [6, 8, 10]
	     */
	    function parseInt(string, radix, guard) {
	      if (guard || radix == null) {
	        radix = 0;
	      } else if (radix) {
	        radix = +radix;
	      }
	      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
	    }
	
	    /**
	     * Repeats the given string `n` times.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to repeat.
	     * @param {number} [n=1] The number of times to repeat the string.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the repeated string.
	     * @example
	     *
	     * _.repeat('*', 3);
	     * // => '***'
	     *
	     * _.repeat('abc', 2);
	     * // => 'abcabc'
	     *
	     * _.repeat('abc', 0);
	     * // => ''
	     */
	    function repeat(string, n, guard) {
	      if ((guard ? isIterateeCall(string, n, guard) : n === undefined)) {
	        n = 1;
	      } else {
	        n = toInteger(n);
	      }
	      return baseRepeat(toString(string), n);
	    }
	
	    /**
	     * Replaces matches for `pattern` in `string` with `replacement`.
	     *
	     * **Note:** This method is based on
	     * [`String#replace`](https://mdn.io/String/replace).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to modify.
	     * @param {RegExp|string} pattern The pattern to replace.
	     * @param {Function|string} replacement The match replacement.
	     * @returns {string} Returns the modified string.
	     * @example
	     *
	     * _.replace('Hi Fred', 'Fred', 'Barney');
	     * // => 'Hi Barney'
	     */
	    function replace() {
	      var args = arguments,
	          string = toString(args[0]);
	
	      return args.length < 3 ? string : string.replace(args[1], args[2]);
	    }
	
	    /**
	     * Converts `string` to
	     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the snake cased string.
	     * @example
	     *
	     * _.snakeCase('Foo Bar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('fooBar');
	     * // => 'foo_bar'
	     *
	     * _.snakeCase('--FOO-BAR--');
	     * // => 'foo_bar'
	     */
	    var snakeCase = createCompounder(function(result, word, index) {
	      return result + (index ? '_' : '') + word.toLowerCase();
	    });
	
	    /**
	     * Splits `string` by `separator`.
	     *
	     * **Note:** This method is based on
	     * [`String#split`](https://mdn.io/String/split).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to split.
	     * @param {RegExp|string} separator The separator pattern to split by.
	     * @param {number} [limit] The length to truncate results to.
	     * @returns {Array} Returns the string segments.
	     * @example
	     *
	     * _.split('a-b-c', '-', 2);
	     * // => ['a', 'b']
	     */
	    function split(string, separator, limit) {
	      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
	        separator = limit = undefined;
	      }
	      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
	      if (!limit) {
	        return [];
	      }
	      string = toString(string);
	      if (string && (
	            typeof separator == 'string' ||
	            (separator != null && !isRegExp(separator))
	          )) {
	        separator = baseToString(separator);
	        if (!separator && hasUnicode(string)) {
	          return castSlice(stringToArray(string), 0, limit);
	        }
	      }
	      return string.split(separator, limit);
	    }
	
	    /**
	     * Converts `string` to
	     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
	     *
	     * @static
	     * @memberOf _
	     * @since 3.1.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the start cased string.
	     * @example
	     *
	     * _.startCase('--foo-bar--');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('fooBar');
	     * // => 'Foo Bar'
	     *
	     * _.startCase('__FOO_BAR__');
	     * // => 'FOO BAR'
	     */
	    var startCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + upperFirst(word);
	    });
	
	    /**
	     * Checks if `string` starts with the given target string.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {string} [target] The string to search for.
	     * @param {number} [position=0] The position to search from.
	     * @returns {boolean} Returns `true` if `string` starts with `target`,
	     *  else `false`.
	     * @example
	     *
	     * _.startsWith('abc', 'a');
	     * // => true
	     *
	     * _.startsWith('abc', 'b');
	     * // => false
	     *
	     * _.startsWith('abc', 'b', 1);
	     * // => true
	     */
	    function startsWith(string, target, position) {
	      string = toString(string);
	      position = position == null
	        ? 0
	        : baseClamp(toInteger(position), 0, string.length);
	
	      target = baseToString(target);
	      return string.slice(position, position + target.length) == target;
	    }
	
	    /**
	     * Creates a compiled template function that can interpolate data properties
	     * in "interpolate" delimiters, HTML-escape interpolated data properties in
	     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
	     * properties may be accessed as free variables in the template. If a setting
	     * object is given, it takes precedence over `_.templateSettings` values.
	     *
	     * **Note:** In the development build `_.template` utilizes
	     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
	     * for easier debugging.
	     *
	     * For more information on precompiling templates see
	     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
	     *
	     * For more information on Chrome extension sandboxes see
	     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category String
	     * @param {string} [string=''] The template string.
	     * @param {Object} [options={}] The options object.
	     * @param {RegExp} [options.escape=_.templateSettings.escape]
	     *  The HTML "escape" delimiter.
	     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
	     *  The "evaluate" delimiter.
	     * @param {Object} [options.imports=_.templateSettings.imports]
	     *  An object to import into the template as free variables.
	     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
	     *  The "interpolate" delimiter.
	     * @param {string} [options.sourceURL='lodash.templateSources[n]']
	     *  The sourceURL of the compiled template.
	     * @param {string} [options.variable='obj']
	     *  The data object variable name.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Function} Returns the compiled template function.
	     * @example
	     *
	     * // Use the "interpolate" delimiter to create a compiled template.
	     * var compiled = _.template('hello <%= user %>!');
	     * compiled({ 'user': 'fred' });
	     * // => 'hello fred!'
	     *
	     * // Use the HTML "escape" delimiter to escape data property values.
	     * var compiled = _.template('<b><%- value %></b>');
	     * compiled({ 'value': '<script>' });
	     * // => '<b>&lt;script&gt;</b>'
	     *
	     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
	     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the internal `print` function in "evaluate" delimiters.
	     * var compiled = _.template('<% print("hello " + user); %>!');
	     * compiled({ 'user': 'barney' });
	     * // => 'hello barney!'
	     *
	     * // Use the ES template literal delimiter as an "interpolate" delimiter.
	     * // Disable support by replacing the "interpolate" delimiter.
	     * var compiled = _.template('hello ${ user }!');
	     * compiled({ 'user': 'pebbles' });
	     * // => 'hello pebbles!'
	     *
	     * // Use backslashes to treat delimiters as plain text.
	     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
	     * compiled({ 'value': 'ignored' });
	     * // => '<%- value %>'
	     *
	     * // Use the `imports` option to import `jQuery` as `jq`.
	     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
	     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
	     * compiled({ 'users': ['fred', 'barney'] });
	     * // => '<li>fred</li><li>barney</li>'
	     *
	     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
	     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
	     * compiled(data);
	     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
	     *
	     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
	     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
	     * compiled.source;
	     * // => function(data) {
	     * //   var __t, __p = '';
	     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
	     * //   return __p;
	     * // }
	     *
	     * // Use custom template delimiters.
	     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
	     * var compiled = _.template('hello {{ user }}!');
	     * compiled({ 'user': 'mustache' });
	     * // => 'hello mustache!'
	     *
	     * // Use the `source` property to inline compiled templates for meaningful
	     * // line numbers in error messages and stack traces.
	     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
	     *   var JST = {\
	     *     "main": ' + _.template(mainText).source + '\
	     *   };\
	     * ');
	     */
	    function template(string, options, guard) {
	      // Based on John Resig's `tmpl` implementation
	      // (http://ejohn.org/blog/javascript-micro-templating/)
	      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
	      var settings = lodash.templateSettings;
	
	      if (guard && isIterateeCall(string, options, guard)) {
	        options = undefined;
	      }
	      string = toString(string);
	      options = assignInWith({}, options, settings, customDefaultsAssignIn);
	
	      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
	          importsKeys = keys(imports),
	          importsValues = baseValues(imports, importsKeys);
	
	      var isEscaping,
	          isEvaluating,
	          index = 0,
	          interpolate = options.interpolate || reNoMatch,
	          source = "__p += '";
	
	      // Compile the regexp to match each delimiter.
	      var reDelimiters = RegExp(
	        (options.escape || reNoMatch).source + '|' +
	        interpolate.source + '|' +
	        (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' +
	        (options.evaluate || reNoMatch).source + '|$'
	      , 'g');
	
	      // Use a sourceURL for easier debugging.
	      var sourceURL = '//# sourceURL=' +
	        ('sourceURL' in options
	          ? options.sourceURL
	          : ('lodash.templateSources[' + (++templateCounter) + ']')
	        ) + '\n';
	
	      string.replace(reDelimiters, function(match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
	        interpolateValue || (interpolateValue = esTemplateValue);
	
	        // Escape characters that can't be included in string literals.
	        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);
	
	        // Replace delimiters with snippets.
	        if (escapeValue) {
	          isEscaping = true;
	          source += "' +\n__e(" + escapeValue + ") +\n'";
	        }
	        if (evaluateValue) {
	          isEvaluating = true;
	          source += "';\n" + evaluateValue + ";\n__p += '";
	        }
	        if (interpolateValue) {
	          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
	        }
	        index = offset + match.length;
	
	        // The JS engine embedded in Adobe products needs `match` returned in
	        // order to produce the correct `offset` value.
	        return match;
	      });
	
	      source += "';\n";
	
	      // If `variable` is not specified wrap a with-statement around the generated
	      // code to add the data object to the top of the scope chain.
	      var variable = options.variable;
	      if (!variable) {
	        source = 'with (obj) {\n' + source + '\n}\n';
	      }
	      // Cleanup code by stripping empty strings.
	      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source)
	        .replace(reEmptyStringMiddle, '$1')
	        .replace(reEmptyStringTrailing, '$1;');
	
	      // Frame code as the function body.
	      source = 'function(' + (variable || 'obj') + ') {\n' +
	        (variable
	          ? ''
	          : 'obj || (obj = {});\n'
	        ) +
	        "var __t, __p = ''" +
	        (isEscaping
	           ? ', __e = _.escape'
	           : ''
	        ) +
	        (isEvaluating
	          ? ', __j = Array.prototype.join;\n' +
	            "function print() { __p += __j.call(arguments, '') }\n"
	          : ';\n'
	        ) +
	        source +
	        'return __p\n}';
	
	      var result = attempt(function() {
	        return Function(importsKeys, sourceURL + 'return ' + source)
	          .apply(undefined, importsValues);
	      });
	
	      // Provide the compiled function's source by its `toString` method or
	      // the `source` property as a convenience for inlining compiled templates.
	      result.source = source;
	      if (isError(result)) {
	        throw result;
	      }
	      return result;
	    }
	
	    /**
	     * Converts `string`, as a whole, to lower case just like
	     * [String#toLowerCase](https://mdn.io/toLowerCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the lower cased string.
	     * @example
	     *
	     * _.toLower('--Foo-Bar--');
	     * // => '--foo-bar--'
	     *
	     * _.toLower('fooBar');
	     * // => 'foobar'
	     *
	     * _.toLower('__FOO_BAR__');
	     * // => '__foo_bar__'
	     */
	    function toLower(value) {
	      return toString(value).toLowerCase();
	    }
	
	    /**
	     * Converts `string`, as a whole, to upper case just like
	     * [String#toUpperCase](https://mdn.io/toUpperCase).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.toUpper('--foo-bar--');
	     * // => '--FOO-BAR--'
	     *
	     * _.toUpper('fooBar');
	     * // => 'FOOBAR'
	     *
	     * _.toUpper('__foo_bar__');
	     * // => '__FOO_BAR__'
	     */
	    function toUpper(value) {
	      return toString(value).toUpperCase();
	    }
	
	    /**
	     * Removes leading and trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trim('  abc  ');
	     * // => 'abc'
	     *
	     * _.trim('-_-abc-_-', '_-');
	     * // => 'abc'
	     *
	     * _.map(['  foo  ', '  bar  '], _.trim);
	     * // => ['foo', 'bar']
	     */
	    function trim(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrim, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          chrSymbols = stringToArray(chars),
	          start = charsStartIndex(strSymbols, chrSymbols),
	          end = charsEndIndex(strSymbols, chrSymbols) + 1;
	
	      return castSlice(strSymbols, start, end).join('');
	    }
	
	    /**
	     * Removes trailing whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimEnd('  abc  ');
	     * // => '  abc'
	     *
	     * _.trimEnd('-_-abc-_-', '_-');
	     * // => '-_-abc'
	     */
	    function trimEnd(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimEnd, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
	
	      return castSlice(strSymbols, 0, end).join('');
	    }
	
	    /**
	     * Removes leading whitespace or specified characters from `string`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to trim.
	     * @param {string} [chars=whitespace] The characters to trim.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {string} Returns the trimmed string.
	     * @example
	     *
	     * _.trimStart('  abc  ');
	     * // => 'abc  '
	     *
	     * _.trimStart('-_-abc-_-', '_-');
	     * // => 'abc-_-'
	     */
	    function trimStart(string, chars, guard) {
	      string = toString(string);
	      if (string && (guard || chars === undefined)) {
	        return string.replace(reTrimStart, '');
	      }
	      if (!string || !(chars = baseToString(chars))) {
	        return string;
	      }
	      var strSymbols = stringToArray(string),
	          start = charsStartIndex(strSymbols, stringToArray(chars));
	
	      return castSlice(strSymbols, start).join('');
	    }
	
	    /**
	     * Truncates `string` if it's longer than the given maximum string length.
	     * The last characters of the truncated string are replaced with the omission
	     * string which defaults to "...".
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to truncate.
	     * @param {Object} [options={}] The options object.
	     * @param {number} [options.length=30] The maximum string length.
	     * @param {string} [options.omission='...'] The string to indicate text is omitted.
	     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
	     * @returns {string} Returns the truncated string.
	     * @example
	     *
	     * _.truncate('hi-diddly-ho there, neighborino');
	     * // => 'hi-diddly-ho there, neighbo...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': ' '
	     * });
	     * // => 'hi-diddly-ho there,...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'length': 24,
	     *   'separator': /,? +/
	     * });
	     * // => 'hi-diddly-ho there...'
	     *
	     * _.truncate('hi-diddly-ho there, neighborino', {
	     *   'omission': ' [...]'
	     * });
	     * // => 'hi-diddly-ho there, neig [...]'
	     */
	    function truncate(string, options) {
	      var length = DEFAULT_TRUNC_LENGTH,
	          omission = DEFAULT_TRUNC_OMISSION;
	
	      if (isObject(options)) {
	        var separator = 'separator' in options ? options.separator : separator;
	        length = 'length' in options ? toInteger(options.length) : length;
	        omission = 'omission' in options ? baseToString(options.omission) : omission;
	      }
	      string = toString(string);
	
	      var strLength = string.length;
	      if (hasUnicode(string)) {
	        var strSymbols = stringToArray(string);
	        strLength = strSymbols.length;
	      }
	      if (length >= strLength) {
	        return string;
	      }
	      var end = length - stringSize(omission);
	      if (end < 1) {
	        return omission;
	      }
	      var result = strSymbols
	        ? castSlice(strSymbols, 0, end).join('')
	        : string.slice(0, end);
	
	      if (separator === undefined) {
	        return result + omission;
	      }
	      if (strSymbols) {
	        end += (result.length - end);
	      }
	      if (isRegExp(separator)) {
	        if (string.slice(end).search(separator)) {
	          var match,
	              substring = result;
	
	          if (!separator.global) {
	            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
	          }
	          separator.lastIndex = 0;
	          while ((match = separator.exec(substring))) {
	            var newEnd = match.index;
	          }
	          result = result.slice(0, newEnd === undefined ? end : newEnd);
	        }
	      } else if (string.indexOf(baseToString(separator), end) != end) {
	        var index = result.lastIndexOf(separator);
	        if (index > -1) {
	          result = result.slice(0, index);
	        }
	      }
	      return result + omission;
	    }
	
	    /**
	     * The inverse of `_.escape`; this method converts the HTML entities
	     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
	     * their corresponding characters.
	     *
	     * **Note:** No other HTML entities are unescaped. To unescape additional
	     * HTML entities use a third-party library like [_he_](https://mths.be/he).
	     *
	     * @static
	     * @memberOf _
	     * @since 0.6.0
	     * @category String
	     * @param {string} [string=''] The string to unescape.
	     * @returns {string} Returns the unescaped string.
	     * @example
	     *
	     * _.unescape('fred, barney, &amp; pebbles');
	     * // => 'fred, barney, & pebbles'
	     */
	    function unescape(string) {
	      string = toString(string);
	      return (string && reHasEscapedHtml.test(string))
	        ? string.replace(reEscapedHtml, unescapeHtmlChar)
	        : string;
	    }
	
	    /**
	     * Converts `string`, as space separated words, to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the upper cased string.
	     * @example
	     *
	     * _.upperCase('--foo-bar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('fooBar');
	     * // => 'FOO BAR'
	     *
	     * _.upperCase('__foo_bar__');
	     * // => 'FOO BAR'
	     */
	    var upperCase = createCompounder(function(result, word, index) {
	      return result + (index ? ' ' : '') + word.toUpperCase();
	    });
	
	    /**
	     * Converts the first character of `string` to upper case.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category String
	     * @param {string} [string=''] The string to convert.
	     * @returns {string} Returns the converted string.
	     * @example
	     *
	     * _.upperFirst('fred');
	     * // => 'Fred'
	     *
	     * _.upperFirst('FRED');
	     * // => 'FRED'
	     */
	    var upperFirst = createCaseFirst('toUpperCase');
	
	    /**
	     * Splits `string` into an array of its words.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category String
	     * @param {string} [string=''] The string to inspect.
	     * @param {RegExp|string} [pattern] The pattern to match words.
	     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	     * @returns {Array} Returns the words of `string`.
	     * @example
	     *
	     * _.words('fred, barney, & pebbles');
	     * // => ['fred', 'barney', 'pebbles']
	     *
	     * _.words('fred, barney, & pebbles', /[^, ]+/g);
	     * // => ['fred', 'barney', '&', 'pebbles']
	     */
	    function words(string, pattern, guard) {
	      string = toString(string);
	      pattern = guard ? undefined : pattern;
	
	      if (pattern === undefined) {
	        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
	      }
	      return string.match(pattern) || [];
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Attempts to invoke `func`, returning either the result or the caught error
	     * object. Any additional arguments are provided to `func` when it's invoked.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Function} func The function to attempt.
	     * @param {...*} [args] The arguments to invoke `func` with.
	     * @returns {*} Returns the `func` result or error object.
	     * @example
	     *
	     * // Avoid throwing errors for invalid selectors.
	     * var elements = _.attempt(function(selector) {
	     *   return document.querySelectorAll(selector);
	     * }, '>_>');
	     *
	     * if (_.isError(elements)) {
	     *   elements = [];
	     * }
	     */
	    var attempt = baseRest(function(func, args) {
	      try {
	        return apply(func, undefined, args);
	      } catch (e) {
	        return isError(e) ? e : new Error(e);
	      }
	    });
	
	    /**
	     * Binds methods of an object to the object itself, overwriting the existing
	     * method.
	     *
	     * **Note:** This method doesn't set the "length" property of bound functions.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Object} object The object to bind and assign the bound methods to.
	     * @param {...(string|string[])} methodNames The object method names to bind.
	     * @returns {Object} Returns `object`.
	     * @example
	     *
	     * var view = {
	     *   'label': 'docs',
	     *   'click': function() {
	     *     console.log('clicked ' + this.label);
	     *   }
	     * };
	     *
	     * _.bindAll(view, ['click']);
	     * jQuery(element).on('click', view.click);
	     * // => Logs 'clicked docs' when clicked.
	     */
	    var bindAll = flatRest(function(object, methodNames) {
	      arrayEach(methodNames, function(key) {
	        key = toKey(key);
	        baseAssignValue(object, key, bind(object[key], object));
	      });
	      return object;
	    });
	
	    /**
	     * Creates a function that iterates over `pairs` and invokes the corresponding
	     * function of the first predicate to return truthy. The predicate-function
	     * pairs are invoked with the `this` binding and arguments of the created
	     * function.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Array} pairs The predicate-function pairs.
	     * @returns {Function} Returns the new composite function.
	     * @example
	     *
	     * var func = _.cond([
	     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
	     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
	     *   [_.stubTrue,                      _.constant('no match')]
	     * ]);
	     *
	     * func({ 'a': 1, 'b': 2 });
	     * // => 'matches A'
	     *
	     * func({ 'a': 0, 'b': 1 });
	     * // => 'matches B'
	     *
	     * func({ 'a': '1', 'b': '2' });
	     * // => 'no match'
	     */
	    function cond(pairs) {
	      var length = pairs == null ? 0 : pairs.length,
	          toIteratee = getIteratee();
	
	      pairs = !length ? [] : arrayMap(pairs, function(pair) {
	        if (typeof pair[1] != 'function') {
	          throw new TypeError(FUNC_ERROR_TEXT);
	        }
	        return [toIteratee(pair[0]), pair[1]];
	      });
	
	      return baseRest(function(args) {
	        var index = -1;
	        while (++index < length) {
	          var pair = pairs[index];
	          if (apply(pair[0], this, args)) {
	            return apply(pair[1], this, args);
	          }
	        }
	      });
	    }
	
	    /**
	     * Creates a function that invokes the predicate properties of `source` with
	     * the corresponding property values of a given object, returning `true` if
	     * all predicates return truthy, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.conformsTo` with
	     * `source` partially applied.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {Object} source The object of property predicates to conform to.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 2, 'b': 1 },
	     *   { 'a': 1, 'b': 2 }
	     * ];
	     *
	     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
	     * // => [{ 'a': 1, 'b': 2 }]
	     */
	    function conforms(source) {
	      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that returns `value`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {*} value The value to return from the new function.
	     * @returns {Function} Returns the new constant function.
	     * @example
	     *
	     * var objects = _.times(2, _.constant({ 'a': 1 }));
	     *
	     * console.log(objects);
	     * // => [{ 'a': 1 }, { 'a': 1 }]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => true
	     */
	    function constant(value) {
	      return function() {
	        return value;
	      };
	    }
	
	    /**
	     * Checks `value` to determine whether a default value should be returned in
	     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
	     * or `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.14.0
	     * @category Util
	     * @param {*} value The value to check.
	     * @param {*} defaultValue The default value.
	     * @returns {*} Returns the resolved value.
	     * @example
	     *
	     * _.defaultTo(1, 10);
	     * // => 1
	     *
	     * _.defaultTo(undefined, 10);
	     * // => 10
	     */
	    function defaultTo(value, defaultValue) {
	      return (value == null || value !== value) ? defaultValue : value;
	    }
	
	    /**
	     * Creates a function that returns the result of invoking the given functions
	     * with the `this` binding of the created function, where each successive
	     * invocation is supplied the return value of the previous.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flowRight
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flow([_.add, square]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flow = createFlow();
	
	    /**
	     * This method is like `_.flow` except that it creates a function that
	     * invokes the given functions from right to left.
	     *
	     * @static
	     * @since 3.0.0
	     * @memberOf _
	     * @category Util
	     * @param {...(Function|Function[])} [funcs] The functions to invoke.
	     * @returns {Function} Returns the new composite function.
	     * @see _.flow
	     * @example
	     *
	     * function square(n) {
	     *   return n * n;
	     * }
	     *
	     * var addSquare = _.flowRight([square, _.add]);
	     * addSquare(1, 2);
	     * // => 9
	     */
	    var flowRight = createFlow(true);
	
	    /**
	     * This method returns the first argument it receives.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {*} value Any value.
	     * @returns {*} Returns `value`.
	     * @example
	     *
	     * var object = { 'a': 1 };
	     *
	     * console.log(_.identity(object) === object);
	     * // => true
	     */
	    function identity(value) {
	      return value;
	    }
	
	    /**
	     * Creates a function that invokes `func` with the arguments of the created
	     * function. If `func` is a property name, the created function returns the
	     * property value for a given element. If `func` is an array or object, the
	     * created function returns `true` for elements that contain the equivalent
	     * source properties, otherwise it returns `false`.
	     *
	     * @static
	     * @since 4.0.0
	     * @memberOf _
	     * @category Util
	     * @param {*} [func=_.identity] The value to convert to a callback.
	     * @returns {Function} Returns the callback.
	     * @example
	     *
	     * var users = [
	     *   { 'user': 'barney', 'age': 36, 'active': true },
	     *   { 'user': 'fred',   'age': 40, 'active': false }
	     * ];
	     *
	     * // The `_.matches` iteratee shorthand.
	     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
	     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
	     *
	     * // The `_.matchesProperty` iteratee shorthand.
	     * _.filter(users, _.iteratee(['user', 'fred']));
	     * // => [{ 'user': 'fred', 'age': 40 }]
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.map(users, _.iteratee('user'));
	     * // => ['barney', 'fred']
	     *
	     * // Create custom iteratee shorthands.
	     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
	     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
	     *     return func.test(string);
	     *   };
	     * });
	     *
	     * _.filter(['abc', 'def'], /ef/);
	     * // => ['def']
	     */
	    function iteratee(func) {
	      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between a given
	     * object and `source`, returning `true` if the given object has equivalent
	     * property values, else `false`.
	     *
	     * **Note:** The created function is equivalent to `_.isMatch` with `source`
	     * partially applied.
	     *
	     * Partial comparisons will match empty array and empty object `source`
	     * values against any array or object value, respectively. See `_.isEqual`
	     * for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} source The object of property values to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
	     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
	     */
	    function matches(source) {
	      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that performs a partial deep comparison between the
	     * value at `path` of a given object to `srcValue`, returning `true` if the
	     * object value is equivalent, else `false`.
	     *
	     * **Note:** Partial comparisons will match empty array and empty object
	     * `srcValue` values against any array or object value, respectively. See
	     * `_.isEqual` for a list of supported value comparisons.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.2.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @param {*} srcValue The value to match.
	     * @returns {Function} Returns the new spec function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': 1, 'b': 2, 'c': 3 },
	     *   { 'a': 4, 'b': 5, 'c': 6 }
	     * ];
	     *
	     * _.find(objects, _.matchesProperty('a', 4));
	     * // => { 'a': 4, 'b': 5, 'c': 6 }
	     */
	    function matchesProperty(path, srcValue) {
	      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
	    }
	
	    /**
	     * Creates a function that invokes the method at `path` of a given object.
	     * Any additional arguments are provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Array|string} path The path of the method to invoke.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': _.constant(2) } },
	     *   { 'a': { 'b': _.constant(1) } }
	     * ];
	     *
	     * _.map(objects, _.method('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(objects, _.method(['a', 'b']));
	     * // => [2, 1]
	     */
	    var method = baseRest(function(path, args) {
	      return function(object) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * The opposite of `_.method`; this method creates a function that invokes
	     * the method at a given path of `object`. Any additional arguments are
	     * provided to the invoked method.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.7.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @param {...*} [args] The arguments to invoke the method with.
	     * @returns {Function} Returns the new invoker function.
	     * @example
	     *
	     * var array = _.times(3, _.constant),
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
	     * // => [2, 0]
	     */
	    var methodOf = baseRest(function(object, args) {
	      return function(path) {
	        return baseInvoke(object, path, args);
	      };
	    });
	
	    /**
	     * Adds all own enumerable string keyed function properties of a source
	     * object to the destination object. If `object` is a function, then methods
	     * are added to its prototype as well.
	     *
	     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
	     * avoid conflicts caused by modifying the original.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {Function|Object} [object=lodash] The destination object.
	     * @param {Object} source The object of functions to add.
	     * @param {Object} [options={}] The options object.
	     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
	     * @returns {Function|Object} Returns `object`.
	     * @example
	     *
	     * function vowels(string) {
	     *   return _.filter(string, function(v) {
	     *     return /[aeiou]/i.test(v);
	     *   });
	     * }
	     *
	     * _.mixin({ 'vowels': vowels });
	     * _.vowels('fred');
	     * // => ['e']
	     *
	     * _('fred').vowels().value();
	     * // => ['e']
	     *
	     * _.mixin({ 'vowels': vowels }, { 'chain': false });
	     * _('fred').vowels();
	     * // => ['e']
	     */
	    function mixin(object, source, options) {
	      var props = keys(source),
	          methodNames = baseFunctions(source, props);
	
	      if (options == null &&
	          !(isObject(source) && (methodNames.length || !props.length))) {
	        options = source;
	        source = object;
	        object = this;
	        methodNames = baseFunctions(source, keys(source));
	      }
	      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
	          isFunc = isFunction(object);
	
	      arrayEach(methodNames, function(methodName) {
	        var func = source[methodName];
	        object[methodName] = func;
	        if (isFunc) {
	          object.prototype[methodName] = function() {
	            var chainAll = this.__chain__;
	            if (chain || chainAll) {
	              var result = object(this.__wrapped__),
	                  actions = result.__actions__ = copyArray(this.__actions__);
	
	              actions.push({ 'func': func, 'args': arguments, 'thisArg': object });
	              result.__chain__ = chainAll;
	              return result;
	            }
	            return func.apply(object, arrayPush([this.value()], arguments));
	          };
	        }
	      });
	
	      return object;
	    }
	
	    /**
	     * Reverts the `_` variable to its previous value and returns a reference to
	     * the `lodash` function.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @returns {Function} Returns the `lodash` function.
	     * @example
	     *
	     * var lodash = _.noConflict();
	     */
	    function noConflict() {
	      if (root._ === this) {
	        root._ = oldDash;
	      }
	      return this;
	    }
	
	    /**
	     * This method returns `undefined`.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.3.0
	     * @category Util
	     * @example
	     *
	     * _.times(2, _.noop);
	     * // => [undefined, undefined]
	     */
	    function noop() {
	      // No operation performed.
	    }
	
	    /**
	     * Creates a function that gets the argument at index `n`. If `n` is negative,
	     * the nth argument from the end is returned.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [n=0] The index of the argument to return.
	     * @returns {Function} Returns the new pass-thru function.
	     * @example
	     *
	     * var func = _.nthArg(1);
	     * func('a', 'b', 'c', 'd');
	     * // => 'b'
	     *
	     * var func = _.nthArg(-2);
	     * func('a', 'b', 'c', 'd');
	     * // => 'c'
	     */
	    function nthArg(n) {
	      n = toInteger(n);
	      return baseRest(function(args) {
	        return baseNth(args, n);
	      });
	    }
	
	    /**
	     * Creates a function that invokes `iteratees` with the arguments it receives
	     * and returns their results.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [iteratees=[_.identity]]
	     *  The iteratees to invoke.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.over([Math.max, Math.min]);
	     *
	     * func(1, 2, 3, 4);
	     * // => [4, 1]
	     */
	    var over = createOver(arrayMap);
	
	    /**
	     * Creates a function that checks if **all** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overEvery([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => false
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overEvery = createOver(arrayEvery);
	
	    /**
	     * Creates a function that checks if **any** of the `predicates` return
	     * truthy when invoked with the arguments it receives.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {...(Function|Function[])} [predicates=[_.identity]]
	     *  The predicates to check.
	     * @returns {Function} Returns the new function.
	     * @example
	     *
	     * var func = _.overSome([Boolean, isFinite]);
	     *
	     * func('1');
	     * // => true
	     *
	     * func(null);
	     * // => true
	     *
	     * func(NaN);
	     * // => false
	     */
	    var overSome = createOver(arraySome);
	
	    /**
	     * Creates a function that returns the value at `path` of a given object.
	     *
	     * @static
	     * @memberOf _
	     * @since 2.4.0
	     * @category Util
	     * @param {Array|string} path The path of the property to get.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var objects = [
	     *   { 'a': { 'b': 2 } },
	     *   { 'a': { 'b': 1 } }
	     * ];
	     *
	     * _.map(objects, _.property('a.b'));
	     * // => [2, 1]
	     *
	     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	     * // => [1, 2]
	     */
	    function property(path) {
	      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	    }
	
	    /**
	     * The opposite of `_.property`; this method creates a function that returns
	     * the value at a given path of `object`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.0.0
	     * @category Util
	     * @param {Object} object The object to query.
	     * @returns {Function} Returns the new accessor function.
	     * @example
	     *
	     * var array = [0, 1, 2],
	     *     object = { 'a': array, 'b': array, 'c': array };
	     *
	     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
	     * // => [2, 0]
	     *
	     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
	     * // => [2, 0]
	     */
	    function propertyOf(object) {
	      return function(path) {
	        return object == null ? undefined : baseGet(object, path);
	      };
	    }
	
	    /**
	     * Creates an array of numbers (positive and/or negative) progressing from
	     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
	     * `start` is specified without an `end` or `step`. If `end` is not specified,
	     * it's set to `start` with `start` then set to `0`.
	     *
	     * **Note:** JavaScript follows the IEEE-754 standard for resolving
	     * floating-point values which can produce unexpected results.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.rangeRight
	     * @example
	     *
	     * _.range(4);
	     * // => [0, 1, 2, 3]
	     *
	     * _.range(-4);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 5);
	     * // => [1, 2, 3, 4]
	     *
	     * _.range(0, 20, 5);
	     * // => [0, 5, 10, 15]
	     *
	     * _.range(0, -4, -1);
	     * // => [0, -1, -2, -3]
	     *
	     * _.range(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.range(0);
	     * // => []
	     */
	    var range = createRange();
	
	    /**
	     * This method is like `_.range` except that it populates values in
	     * descending order.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {number} [start=0] The start of the range.
	     * @param {number} end The end of the range.
	     * @param {number} [step=1] The value to increment or decrement by.
	     * @returns {Array} Returns the range of numbers.
	     * @see _.inRange, _.range
	     * @example
	     *
	     * _.rangeRight(4);
	     * // => [3, 2, 1, 0]
	     *
	     * _.rangeRight(-4);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 5);
	     * // => [4, 3, 2, 1]
	     *
	     * _.rangeRight(0, 20, 5);
	     * // => [15, 10, 5, 0]
	     *
	     * _.rangeRight(0, -4, -1);
	     * // => [-3, -2, -1, 0]
	     *
	     * _.rangeRight(1, 4, 0);
	     * // => [1, 1, 1]
	     *
	     * _.rangeRight(0);
	     * // => []
	     */
	    var rangeRight = createRange(true);
	
	    /**
	     * This method returns a new empty array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Array} Returns the new empty array.
	     * @example
	     *
	     * var arrays = _.times(2, _.stubArray);
	     *
	     * console.log(arrays);
	     * // => [[], []]
	     *
	     * console.log(arrays[0] === arrays[1]);
	     * // => false
	     */
	    function stubArray() {
	      return [];
	    }
	
	    /**
	     * This method returns `false`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `false`.
	     * @example
	     *
	     * _.times(2, _.stubFalse);
	     * // => [false, false]
	     */
	    function stubFalse() {
	      return false;
	    }
	
	    /**
	     * This method returns a new empty object.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {Object} Returns the new empty object.
	     * @example
	     *
	     * var objects = _.times(2, _.stubObject);
	     *
	     * console.log(objects);
	     * // => [{}, {}]
	     *
	     * console.log(objects[0] === objects[1]);
	     * // => false
	     */
	    function stubObject() {
	      return {};
	    }
	
	    /**
	     * This method returns an empty string.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {string} Returns the empty string.
	     * @example
	     *
	     * _.times(2, _.stubString);
	     * // => ['', '']
	     */
	    function stubString() {
	      return '';
	    }
	
	    /**
	     * This method returns `true`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.13.0
	     * @category Util
	     * @returns {boolean} Returns `true`.
	     * @example
	     *
	     * _.times(2, _.stubTrue);
	     * // => [true, true]
	     */
	    function stubTrue() {
	      return true;
	    }
	
	    /**
	     * Invokes the iteratee `n` times, returning an array of the results of
	     * each invocation. The iteratee is invoked with one argument; (index).
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {number} n The number of times to invoke `iteratee`.
	     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	     * @returns {Array} Returns the array of results.
	     * @example
	     *
	     * _.times(3, String);
	     * // => ['0', '1', '2']
	     *
	     *  _.times(4, _.constant(0));
	     * // => [0, 0, 0, 0]
	     */
	    function times(n, iteratee) {
	      n = toInteger(n);
	      if (n < 1 || n > MAX_SAFE_INTEGER) {
	        return [];
	      }
	      var index = MAX_ARRAY_LENGTH,
	          length = nativeMin(n, MAX_ARRAY_LENGTH);
	
	      iteratee = getIteratee(iteratee);
	      n -= MAX_ARRAY_LENGTH;
	
	      var result = baseTimes(length, iteratee);
	      while (++index < n) {
	        iteratee(index);
	      }
	      return result;
	    }
	
	    /**
	     * Converts `value` to a property path array.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Util
	     * @param {*} value The value to convert.
	     * @returns {Array} Returns the new property path array.
	     * @example
	     *
	     * _.toPath('a.b.c');
	     * // => ['a', 'b', 'c']
	     *
	     * _.toPath('a[0].b.c');
	     * // => ['a', '0', 'b', 'c']
	     */
	    function toPath(value) {
	      if (isArray(value)) {
	        return arrayMap(value, toKey);
	      }
	      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
	    }
	
	    /**
	     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Util
	     * @param {string} [prefix=''] The value to prefix the ID with.
	     * @returns {string} Returns the unique ID.
	     * @example
	     *
	     * _.uniqueId('contact_');
	     * // => 'contact_104'
	     *
	     * _.uniqueId();
	     * // => '105'
	     */
	    function uniqueId(prefix) {
	      var id = ++idCounter;
	      return toString(prefix) + id;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * Adds two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {number} augend The first number in an addition.
	     * @param {number} addend The second number in an addition.
	     * @returns {number} Returns the total.
	     * @example
	     *
	     * _.add(6, 4);
	     * // => 10
	     */
	    var add = createMathOperation(function(augend, addend) {
	      return augend + addend;
	    }, 0);
	
	    /**
	     * Computes `number` rounded up to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round up.
	     * @param {number} [precision=0] The precision to round up to.
	     * @returns {number} Returns the rounded up number.
	     * @example
	     *
	     * _.ceil(4.006);
	     * // => 5
	     *
	     * _.ceil(6.004, 2);
	     * // => 6.01
	     *
	     * _.ceil(6040, -2);
	     * // => 6100
	     */
	    var ceil = createRound('ceil');
	
	    /**
	     * Divide two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} dividend The first number in a division.
	     * @param {number} divisor The second number in a division.
	     * @returns {number} Returns the quotient.
	     * @example
	     *
	     * _.divide(6, 4);
	     * // => 1.5
	     */
	    var divide = createMathOperation(function(dividend, divisor) {
	      return dividend / divisor;
	    }, 1);
	
	    /**
	     * Computes `number` rounded down to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round down.
	     * @param {number} [precision=0] The precision to round down to.
	     * @returns {number} Returns the rounded down number.
	     * @example
	     *
	     * _.floor(4.006);
	     * // => 4
	     *
	     * _.floor(0.046, 2);
	     * // => 0.04
	     *
	     * _.floor(4060, -2);
	     * // => 4000
	     */
	    var floor = createRound('floor');
	
	    /**
	     * Computes the maximum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * _.max([4, 2, 8, 6]);
	     * // => 8
	     *
	     * _.max([]);
	     * // => undefined
	     */
	    function max(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseGt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.max` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the maximum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.maxBy(objects, function(o) { return o.n; });
	     * // => { 'n': 2 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.maxBy(objects, 'n');
	     * // => { 'n': 2 }
	     */
	    function maxBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseGt)
	        : undefined;
	    }
	
	    /**
	     * Computes the mean of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * _.mean([4, 2, 8, 6]);
	     * // => 5
	     */
	    function mean(array) {
	      return baseMean(array, identity);
	    }
	
	    /**
	     * This method is like `_.mean` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be averaged.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the mean.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.meanBy(objects, function(o) { return o.n; });
	     * // => 5
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.meanBy(objects, 'n');
	     * // => 5
	     */
	    function meanBy(array, iteratee) {
	      return baseMean(array, getIteratee(iteratee, 2));
	    }
	
	    /**
	     * Computes the minimum value of `array`. If `array` is empty or falsey,
	     * `undefined` is returned.
	     *
	     * @static
	     * @since 0.1.0
	     * @memberOf _
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * _.min([4, 2, 8, 6]);
	     * // => 2
	     *
	     * _.min([]);
	     * // => undefined
	     */
	    function min(array) {
	      return (array && array.length)
	        ? baseExtremum(array, identity, baseLt)
	        : undefined;
	    }
	
	    /**
	     * This method is like `_.min` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the criterion by which
	     * the value is ranked. The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {*} Returns the minimum value.
	     * @example
	     *
	     * var objects = [{ 'n': 1 }, { 'n': 2 }];
	     *
	     * _.minBy(objects, function(o) { return o.n; });
	     * // => { 'n': 1 }
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.minBy(objects, 'n');
	     * // => { 'n': 1 }
	     */
	    function minBy(array, iteratee) {
	      return (array && array.length)
	        ? baseExtremum(array, getIteratee(iteratee, 2), baseLt)
	        : undefined;
	    }
	
	    /**
	     * Multiply two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.7.0
	     * @category Math
	     * @param {number} multiplier The first number in a multiplication.
	     * @param {number} multiplicand The second number in a multiplication.
	     * @returns {number} Returns the product.
	     * @example
	     *
	     * _.multiply(6, 4);
	     * // => 24
	     */
	    var multiply = createMathOperation(function(multiplier, multiplicand) {
	      return multiplier * multiplicand;
	    }, 1);
	
	    /**
	     * Computes `number` rounded to `precision`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.10.0
	     * @category Math
	     * @param {number} number The number to round.
	     * @param {number} [precision=0] The precision to round to.
	     * @returns {number} Returns the rounded number.
	     * @example
	     *
	     * _.round(4.006);
	     * // => 4
	     *
	     * _.round(4.006, 2);
	     * // => 4.01
	     *
	     * _.round(4060, -2);
	     * // => 4100
	     */
	    var round = createRound('round');
	
	    /**
	     * Subtract two numbers.
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {number} minuend The first number in a subtraction.
	     * @param {number} subtrahend The second number in a subtraction.
	     * @returns {number} Returns the difference.
	     * @example
	     *
	     * _.subtract(6, 4);
	     * // => 2
	     */
	    var subtract = createMathOperation(function(minuend, subtrahend) {
	      return minuend - subtrahend;
	    }, 0);
	
	    /**
	     * Computes the sum of the values in `array`.
	     *
	     * @static
	     * @memberOf _
	     * @since 3.4.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * _.sum([4, 2, 8, 6]);
	     * // => 20
	     */
	    function sum(array) {
	      return (array && array.length)
	        ? baseSum(array, identity)
	        : 0;
	    }
	
	    /**
	     * This method is like `_.sum` except that it accepts `iteratee` which is
	     * invoked for each element in `array` to generate the value to be summed.
	     * The iteratee is invoked with one argument: (value).
	     *
	     * @static
	     * @memberOf _
	     * @since 4.0.0
	     * @category Math
	     * @param {Array} array The array to iterate over.
	     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	     * @returns {number} Returns the sum.
	     * @example
	     *
	     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
	     *
	     * _.sumBy(objects, function(o) { return o.n; });
	     * // => 20
	     *
	     * // The `_.property` iteratee shorthand.
	     * _.sumBy(objects, 'n');
	     * // => 20
	     */
	    function sumBy(array, iteratee) {
	      return (array && array.length)
	        ? baseSum(array, getIteratee(iteratee, 2))
	        : 0;
	    }
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return wrapped values in chain sequences.
	    lodash.after = after;
	    lodash.ary = ary;
	    lodash.assign = assign;
	    lodash.assignIn = assignIn;
	    lodash.assignInWith = assignInWith;
	    lodash.assignWith = assignWith;
	    lodash.at = at;
	    lodash.before = before;
	    lodash.bind = bind;
	    lodash.bindAll = bindAll;
	    lodash.bindKey = bindKey;
	    lodash.castArray = castArray;
	    lodash.chain = chain;
	    lodash.chunk = chunk;
	    lodash.compact = compact;
	    lodash.concat = concat;
	    lodash.cond = cond;
	    lodash.conforms = conforms;
	    lodash.constant = constant;
	    lodash.countBy = countBy;
	    lodash.create = create;
	    lodash.curry = curry;
	    lodash.curryRight = curryRight;
	    lodash.debounce = debounce;
	    lodash.defaults = defaults;
	    lodash.defaultsDeep = defaultsDeep;
	    lodash.defer = defer;
	    lodash.delay = delay;
	    lodash.difference = difference;
	    lodash.differenceBy = differenceBy;
	    lodash.differenceWith = differenceWith;
	    lodash.drop = drop;
	    lodash.dropRight = dropRight;
	    lodash.dropRightWhile = dropRightWhile;
	    lodash.dropWhile = dropWhile;
	    lodash.fill = fill;
	    lodash.filter = filter;
	    lodash.flatMap = flatMap;
	    lodash.flatMapDeep = flatMapDeep;
	    lodash.flatMapDepth = flatMapDepth;
	    lodash.flatten = flatten;
	    lodash.flattenDeep = flattenDeep;
	    lodash.flattenDepth = flattenDepth;
	    lodash.flip = flip;
	    lodash.flow = flow;
	    lodash.flowRight = flowRight;
	    lodash.fromPairs = fromPairs;
	    lodash.functions = functions;
	    lodash.functionsIn = functionsIn;
	    lodash.groupBy = groupBy;
	    lodash.initial = initial;
	    lodash.intersection = intersection;
	    lodash.intersectionBy = intersectionBy;
	    lodash.intersectionWith = intersectionWith;
	    lodash.invert = invert;
	    lodash.invertBy = invertBy;
	    lodash.invokeMap = invokeMap;
	    lodash.iteratee = iteratee;
	    lodash.keyBy = keyBy;
	    lodash.keys = keys;
	    lodash.keysIn = keysIn;
	    lodash.map = map;
	    lodash.mapKeys = mapKeys;
	    lodash.mapValues = mapValues;
	    lodash.matches = matches;
	    lodash.matchesProperty = matchesProperty;
	    lodash.memoize = memoize;
	    lodash.merge = merge;
	    lodash.mergeWith = mergeWith;
	    lodash.method = method;
	    lodash.methodOf = methodOf;
	    lodash.mixin = mixin;
	    lodash.negate = negate;
	    lodash.nthArg = nthArg;
	    lodash.omit = omit;
	    lodash.omitBy = omitBy;
	    lodash.once = once;
	    lodash.orderBy = orderBy;
	    lodash.over = over;
	    lodash.overArgs = overArgs;
	    lodash.overEvery = overEvery;
	    lodash.overSome = overSome;
	    lodash.partial = partial;
	    lodash.partialRight = partialRight;
	    lodash.partition = partition;
	    lodash.pick = pick;
	    lodash.pickBy = pickBy;
	    lodash.property = property;
	    lodash.propertyOf = propertyOf;
	    lodash.pull = pull;
	    lodash.pullAll = pullAll;
	    lodash.pullAllBy = pullAllBy;
	    lodash.pullAllWith = pullAllWith;
	    lodash.pullAt = pullAt;
	    lodash.range = range;
	    lodash.rangeRight = rangeRight;
	    lodash.rearg = rearg;
	    lodash.reject = reject;
	    lodash.remove = remove;
	    lodash.rest = rest;
	    lodash.reverse = reverse;
	    lodash.sampleSize = sampleSize;
	    lodash.set = set;
	    lodash.setWith = setWith;
	    lodash.shuffle = shuffle;
	    lodash.slice = slice;
	    lodash.sortBy = sortBy;
	    lodash.sortedUniq = sortedUniq;
	    lodash.sortedUniqBy = sortedUniqBy;
	    lodash.split = split;
	    lodash.spread = spread;
	    lodash.tail = tail;
	    lodash.take = take;
	    lodash.takeRight = takeRight;
	    lodash.takeRightWhile = takeRightWhile;
	    lodash.takeWhile = takeWhile;
	    lodash.tap = tap;
	    lodash.throttle = throttle;
	    lodash.thru = thru;
	    lodash.toArray = toArray;
	    lodash.toPairs = toPairs;
	    lodash.toPairsIn = toPairsIn;
	    lodash.toPath = toPath;
	    lodash.toPlainObject = toPlainObject;
	    lodash.transform = transform;
	    lodash.unary = unary;
	    lodash.union = union;
	    lodash.unionBy = unionBy;
	    lodash.unionWith = unionWith;
	    lodash.uniq = uniq;
	    lodash.uniqBy = uniqBy;
	    lodash.uniqWith = uniqWith;
	    lodash.unset = unset;
	    lodash.unzip = unzip;
	    lodash.unzipWith = unzipWith;
	    lodash.update = update;
	    lodash.updateWith = updateWith;
	    lodash.values = values;
	    lodash.valuesIn = valuesIn;
	    lodash.without = without;
	    lodash.words = words;
	    lodash.wrap = wrap;
	    lodash.xor = xor;
	    lodash.xorBy = xorBy;
	    lodash.xorWith = xorWith;
	    lodash.zip = zip;
	    lodash.zipObject = zipObject;
	    lodash.zipObjectDeep = zipObjectDeep;
	    lodash.zipWith = zipWith;
	
	    // Add aliases.
	    lodash.entries = toPairs;
	    lodash.entriesIn = toPairsIn;
	    lodash.extend = assignIn;
	    lodash.extendWith = assignInWith;
	
	    // Add methods to `lodash.prototype`.
	    mixin(lodash, lodash);
	
	    /*------------------------------------------------------------------------*/
	
	    // Add methods that return unwrapped values in chain sequences.
	    lodash.add = add;
	    lodash.attempt = attempt;
	    lodash.camelCase = camelCase;
	    lodash.capitalize = capitalize;
	    lodash.ceil = ceil;
	    lodash.clamp = clamp;
	    lodash.clone = clone;
	    lodash.cloneDeep = cloneDeep;
	    lodash.cloneDeepWith = cloneDeepWith;
	    lodash.cloneWith = cloneWith;
	    lodash.conformsTo = conformsTo;
	    lodash.deburr = deburr;
	    lodash.defaultTo = defaultTo;
	    lodash.divide = divide;
	    lodash.endsWith = endsWith;
	    lodash.eq = eq;
	    lodash.escape = escape;
	    lodash.escapeRegExp = escapeRegExp;
	    lodash.every = every;
	    lodash.find = find;
	    lodash.findIndex = findIndex;
	    lodash.findKey = findKey;
	    lodash.findLast = findLast;
	    lodash.findLastIndex = findLastIndex;
	    lodash.findLastKey = findLastKey;
	    lodash.floor = floor;
	    lodash.forEach = forEach;
	    lodash.forEachRight = forEachRight;
	    lodash.forIn = forIn;
	    lodash.forInRight = forInRight;
	    lodash.forOwn = forOwn;
	    lodash.forOwnRight = forOwnRight;
	    lodash.get = get;
	    lodash.gt = gt;
	    lodash.gte = gte;
	    lodash.has = has;
	    lodash.hasIn = hasIn;
	    lodash.head = head;
	    lodash.identity = identity;
	    lodash.includes = includes;
	    lodash.indexOf = indexOf;
	    lodash.inRange = inRange;
	    lodash.invoke = invoke;
	    lodash.isArguments = isArguments;
	    lodash.isArray = isArray;
	    lodash.isArrayBuffer = isArrayBuffer;
	    lodash.isArrayLike = isArrayLike;
	    lodash.isArrayLikeObject = isArrayLikeObject;
	    lodash.isBoolean = isBoolean;
	    lodash.isBuffer = isBuffer;
	    lodash.isDate = isDate;
	    lodash.isElement = isElement;
	    lodash.isEmpty = isEmpty;
	    lodash.isEqual = isEqual;
	    lodash.isEqualWith = isEqualWith;
	    lodash.isError = isError;
	    lodash.isFinite = isFinite;
	    lodash.isFunction = isFunction;
	    lodash.isInteger = isInteger;
	    lodash.isLength = isLength;
	    lodash.isMap = isMap;
	    lodash.isMatch = isMatch;
	    lodash.isMatchWith = isMatchWith;
	    lodash.isNaN = isNaN;
	    lodash.isNative = isNative;
	    lodash.isNil = isNil;
	    lodash.isNull = isNull;
	    lodash.isNumber = isNumber;
	    lodash.isObject = isObject;
	    lodash.isObjectLike = isObjectLike;
	    lodash.isPlainObject = isPlainObject;
	    lodash.isRegExp = isRegExp;
	    lodash.isSafeInteger = isSafeInteger;
	    lodash.isSet = isSet;
	    lodash.isString = isString;
	    lodash.isSymbol = isSymbol;
	    lodash.isTypedArray = isTypedArray;
	    lodash.isUndefined = isUndefined;
	    lodash.isWeakMap = isWeakMap;
	    lodash.isWeakSet = isWeakSet;
	    lodash.join = join;
	    lodash.kebabCase = kebabCase;
	    lodash.last = last;
	    lodash.lastIndexOf = lastIndexOf;
	    lodash.lowerCase = lowerCase;
	    lodash.lowerFirst = lowerFirst;
	    lodash.lt = lt;
	    lodash.lte = lte;
	    lodash.max = max;
	    lodash.maxBy = maxBy;
	    lodash.mean = mean;
	    lodash.meanBy = meanBy;
	    lodash.min = min;
	    lodash.minBy = minBy;
	    lodash.stubArray = stubArray;
	    lodash.stubFalse = stubFalse;
	    lodash.stubObject = stubObject;
	    lodash.stubString = stubString;
	    lodash.stubTrue = stubTrue;
	    lodash.multiply = multiply;
	    lodash.nth = nth;
	    lodash.noConflict = noConflict;
	    lodash.noop = noop;
	    lodash.now = now;
	    lodash.pad = pad;
	    lodash.padEnd = padEnd;
	    lodash.padStart = padStart;
	    lodash.parseInt = parseInt;
	    lodash.random = random;
	    lodash.reduce = reduce;
	    lodash.reduceRight = reduceRight;
	    lodash.repeat = repeat;
	    lodash.replace = replace;
	    lodash.result = result;
	    lodash.round = round;
	    lodash.runInContext = runInContext;
	    lodash.sample = sample;
	    lodash.size = size;
	    lodash.snakeCase = snakeCase;
	    lodash.some = some;
	    lodash.sortedIndex = sortedIndex;
	    lodash.sortedIndexBy = sortedIndexBy;
	    lodash.sortedIndexOf = sortedIndexOf;
	    lodash.sortedLastIndex = sortedLastIndex;
	    lodash.sortedLastIndexBy = sortedLastIndexBy;
	    lodash.sortedLastIndexOf = sortedLastIndexOf;
	    lodash.startCase = startCase;
	    lodash.startsWith = startsWith;
	    lodash.subtract = subtract;
	    lodash.sum = sum;
	    lodash.sumBy = sumBy;
	    lodash.template = template;
	    lodash.times = times;
	    lodash.toFinite = toFinite;
	    lodash.toInteger = toInteger;
	    lodash.toLength = toLength;
	    lodash.toLower = toLower;
	    lodash.toNumber = toNumber;
	    lodash.toSafeInteger = toSafeInteger;
	    lodash.toString = toString;
	    lodash.toUpper = toUpper;
	    lodash.trim = trim;
	    lodash.trimEnd = trimEnd;
	    lodash.trimStart = trimStart;
	    lodash.truncate = truncate;
	    lodash.unescape = unescape;
	    lodash.uniqueId = uniqueId;
	    lodash.upperCase = upperCase;
	    lodash.upperFirst = upperFirst;
	
	    // Add aliases.
	    lodash.each = forEach;
	    lodash.eachRight = forEachRight;
	    lodash.first = head;
	
	    mixin(lodash, (function() {
	      var source = {};
	      baseForOwn(lodash, function(func, methodName) {
	        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
	          source[methodName] = func;
	        }
	      });
	      return source;
	    }()), { 'chain': false });
	
	    /*------------------------------------------------------------------------*/
	
	    /**
	     * The semantic version number.
	     *
	     * @static
	     * @memberOf _
	     * @type {string}
	     */
	    lodash.VERSION = VERSION;
	
	    // Assign default placeholders.
	    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function(methodName) {
	      lodash[methodName].placeholder = lodash;
	    });
	
	    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
	    arrayEach(['drop', 'take'], function(methodName, index) {
	      LazyWrapper.prototype[methodName] = function(n) {
	        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
	
	        var result = (this.__filtered__ && !index)
	          ? new LazyWrapper(this)
	          : this.clone();
	
	        if (result.__filtered__) {
	          result.__takeCount__ = nativeMin(n, result.__takeCount__);
	        } else {
	          result.__views__.push({
	            'size': nativeMin(n, MAX_ARRAY_LENGTH),
	            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
	          });
	        }
	        return result;
	      };
	
	      LazyWrapper.prototype[methodName + 'Right'] = function(n) {
	        return this.reverse()[methodName](n).reverse();
	      };
	    });
	
	    // Add `LazyWrapper` methods that accept an `iteratee` value.
	    arrayEach(['filter', 'map', 'takeWhile'], function(methodName, index) {
	      var type = index + 1,
	          isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
	
	      LazyWrapper.prototype[methodName] = function(iteratee) {
	        var result = this.clone();
	        result.__iteratees__.push({
	          'iteratee': getIteratee(iteratee, 3),
	          'type': type
	        });
	        result.__filtered__ = result.__filtered__ || isFilter;
	        return result;
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.head` and `_.last`.
	    arrayEach(['head', 'last'], function(methodName, index) {
	      var takeName = 'take' + (index ? 'Right' : '');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this[takeName](1).value()[0];
	      };
	    });
	
	    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
	    arrayEach(['initial', 'tail'], function(methodName, index) {
	      var dropName = 'drop' + (index ? '' : 'Right');
	
	      LazyWrapper.prototype[methodName] = function() {
	        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
	      };
	    });
	
	    LazyWrapper.prototype.compact = function() {
	      return this.filter(identity);
	    };
	
	    LazyWrapper.prototype.find = function(predicate) {
	      return this.filter(predicate).head();
	    };
	
	    LazyWrapper.prototype.findLast = function(predicate) {
	      return this.reverse().find(predicate);
	    };
	
	    LazyWrapper.prototype.invokeMap = baseRest(function(path, args) {
	      if (typeof path == 'function') {
	        return new LazyWrapper(this);
	      }
	      return this.map(function(value) {
	        return baseInvoke(value, path, args);
	      });
	    });
	
	    LazyWrapper.prototype.reject = function(predicate) {
	      return this.filter(negate(getIteratee(predicate)));
	    };
	
	    LazyWrapper.prototype.slice = function(start, end) {
	      start = toInteger(start);
	
	      var result = this;
	      if (result.__filtered__ && (start > 0 || end < 0)) {
	        return new LazyWrapper(result);
	      }
	      if (start < 0) {
	        result = result.takeRight(-start);
	      } else if (start) {
	        result = result.drop(start);
	      }
	      if (end !== undefined) {
	        end = toInteger(end);
	        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
	      }
	      return result;
	    };
	
	    LazyWrapper.prototype.takeRightWhile = function(predicate) {
	      return this.reverse().takeWhile(predicate).reverse();
	    };
	
	    LazyWrapper.prototype.toArray = function() {
	      return this.take(MAX_ARRAY_LENGTH);
	    };
	
	    // Add `LazyWrapper` methods to `lodash.prototype`.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
	          isTaker = /^(?:head|last)$/.test(methodName),
	          lodashFunc = lodash[isTaker ? ('take' + (methodName == 'last' ? 'Right' : '')) : methodName],
	          retUnwrapped = isTaker || /^find/.test(methodName);
	
	      if (!lodashFunc) {
	        return;
	      }
	      lodash.prototype[methodName] = function() {
	        var value = this.__wrapped__,
	            args = isTaker ? [1] : arguments,
	            isLazy = value instanceof LazyWrapper,
	            iteratee = args[0],
	            useLazy = isLazy || isArray(value);
	
	        var interceptor = function(value) {
	          var result = lodashFunc.apply(lodash, arrayPush([value], args));
	          return (isTaker && chainAll) ? result[0] : result;
	        };
	
	        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
	          // Avoid lazy use if the iteratee has a "length" value other than `1`.
	          isLazy = useLazy = false;
	        }
	        var chainAll = this.__chain__,
	            isHybrid = !!this.__actions__.length,
	            isUnwrapped = retUnwrapped && !chainAll,
	            onlyLazy = isLazy && !isHybrid;
	
	        if (!retUnwrapped && useLazy) {
	          value = onlyLazy ? value : new LazyWrapper(this);
	          var result = func.apply(value, args);
	          result.__actions__.push({ 'func': thru, 'args': [interceptor], 'thisArg': undefined });
	          return new LodashWrapper(result, chainAll);
	        }
	        if (isUnwrapped && onlyLazy) {
	          return func.apply(this, args);
	        }
	        result = this.thru(interceptor);
	        return isUnwrapped ? (isTaker ? result.value()[0] : result.value()) : result;
	      };
	    });
	
	    // Add `Array` methods to `lodash.prototype`.
	    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function(methodName) {
	      var func = arrayProto[methodName],
	          chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
	          retUnwrapped = /^(?:pop|shift)$/.test(methodName);
	
	      lodash.prototype[methodName] = function() {
	        var args = arguments;
	        if (retUnwrapped && !this.__chain__) {
	          var value = this.value();
	          return func.apply(isArray(value) ? value : [], args);
	        }
	        return this[chainName](function(value) {
	          return func.apply(isArray(value) ? value : [], args);
	        });
	      };
	    });
	
	    // Map minified method names to their real names.
	    baseForOwn(LazyWrapper.prototype, function(func, methodName) {
	      var lodashFunc = lodash[methodName];
	      if (lodashFunc) {
	        var key = (lodashFunc.name + ''),
	            names = realNames[key] || (realNames[key] = []);
	
	        names.push({ 'name': methodName, 'func': lodashFunc });
	      }
	    });
	
	    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
	      'name': 'wrapper',
	      'func': undefined
	    }];
	
	    // Add methods to `LazyWrapper`.
	    LazyWrapper.prototype.clone = lazyClone;
	    LazyWrapper.prototype.reverse = lazyReverse;
	    LazyWrapper.prototype.value = lazyValue;
	
	    // Add chain sequence methods to the `lodash` wrapper.
	    lodash.prototype.at = wrapperAt;
	    lodash.prototype.chain = wrapperChain;
	    lodash.prototype.commit = wrapperCommit;
	    lodash.prototype.next = wrapperNext;
	    lodash.prototype.plant = wrapperPlant;
	    lodash.prototype.reverse = wrapperReverse;
	    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;
	
	    // Add lazy aliases.
	    lodash.prototype.first = lodash.prototype.head;
	
	    if (symIterator) {
	      lodash.prototype[symIterator] = wrapperToIterator;
	    }
	    return lodash;
	  });
	
	  /*--------------------------------------------------------------------------*/
	
	  // Export lodash.
	  var _ = runInContext();
	
	  // Some AMD build optimizers, like r.js, check for condition patterns like:
	  if (true) {
	    // Expose Lodash on the global object to prevent errors when Lodash is
	    // loaded by a script tag in the presence of an AMD loader.
	    // See http://requirejs.org/docs/errors.html#mismatch for more details.
	    // Use `_.noConflict` to remove Lodash from the global object.
	    root._ = _;
	
	    // Define as an anonymous module so, through path mapping, it can be
	    // referenced as the "underscore" module.
	    !(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
	      return _;
	    }.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	  }
	  // Check for `exports` after `define` in case a build optimizer adds it.
	  else if (freeModule) {
	    // Export for Node.js.
	    (freeModule.exports = _)._ = _;
	    // Export for CommonJS support.
	    freeExports._ = _;
	  }
	  else {
	    // Export to the global object.
	    root._ = _;
	  }
	}.call(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)(module)))

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = exports.Toggle = exports.TimePicker = exports.TextField = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = exports.Tab = exports.Tabs = exports.Snackbar = exports.Stepper = exports.StepLabel = exports.StepContent = exports.StepButton = exports.Step = exports.SvgIcon = exports.Subheader = exports.Slider = exports.SelectField = exports.RefreshIndicator = exports.RaisedButton = exports.RadioButtonGroup = exports.RadioButton = exports.Popover = exports.Paper = exports.MuiThemeProvider = exports.MenuItem = exports.Menu = exports.makeSelectable = exports.ListItem = exports.List = exports.LinearProgress = exports.IconMenu = exports.IconButton = exports.GridTile = exports.GridList = exports.FontIcon = exports.FloatingActionButton = exports.FlatButton = exports.DropDownMenu = exports.Drawer = exports.Divider = exports.Dialog = exports.DatePicker = exports.CircularProgress = exports.Chip = exports.Checkbox = exports.CardText = exports.CardTitle = exports.CardMedia = exports.CardHeader = exports.CardActions = exports.Card = exports.BottomNavigationItem = exports.BottomNavigation = exports.Badge = exports.Avatar = exports.AutoComplete = exports.AppBar = undefined;
	
	var _AppBar2 = __webpack_require__(783);
	
	var _AppBar3 = _interopRequireDefault(_AppBar2);
	
	var _AutoComplete2 = __webpack_require__(785);
	
	var _AutoComplete3 = _interopRequireDefault(_AutoComplete2);
	
	var _Avatar2 = __webpack_require__(344);
	
	var _Avatar3 = _interopRequireDefault(_Avatar2);
	
	var _Badge2 = __webpack_require__(788);
	
	var _Badge3 = _interopRequireDefault(_Badge2);
	
	var _BottomNavigation2 = __webpack_require__(790);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(345);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	var _Card2 = __webpack_require__(792);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardActions2 = __webpack_require__(346);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardHeader2 = __webpack_require__(348);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardMedia2 = __webpack_require__(349);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardTitle2 = __webpack_require__(351);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardText2 = __webpack_require__(350);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _Checkbox2 = __webpack_require__(211);
	
	var _Checkbox3 = _interopRequireDefault(_Checkbox2);
	
	var _Chip2 = __webpack_require__(795);
	
	var _Chip3 = _interopRequireDefault(_Chip2);
	
	var _CircularProgress2 = __webpack_require__(797);
	
	var _CircularProgress3 = _interopRequireDefault(_CircularProgress2);
	
	var _DatePicker2 = __webpack_require__(808);
	
	var _DatePicker3 = _interopRequireDefault(_DatePicker2);
	
	var _Dialog2 = __webpack_require__(212);
	
	var _Dialog3 = _interopRequireDefault(_Dialog2);
	
	var _Divider2 = __webpack_require__(352);
	
	var _Divider3 = _interopRequireDefault(_Divider2);
	
	var _Drawer2 = __webpack_require__(812);
	
	var _Drawer3 = _interopRequireDefault(_Drawer2);
	
	var _DropDownMenu2 = __webpack_require__(353);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _FlatButton2 = __webpack_require__(148);
	
	var _FlatButton3 = _interopRequireDefault(_FlatButton2);
	
	var _FloatingActionButton2 = __webpack_require__(817);
	
	var _FloatingActionButton3 = _interopRequireDefault(_FloatingActionButton2);
	
	var _FontIcon2 = __webpack_require__(213);
	
	var _FontIcon3 = _interopRequireDefault(_FontIcon2);
	
	var _GridList2 = __webpack_require__(820);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(354);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	var _IconButton2 = __webpack_require__(86);
	
	var _IconButton3 = _interopRequireDefault(_IconButton2);
	
	var _IconMenu2 = __webpack_require__(823);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _LinearProgress2 = __webpack_require__(825);
	
	var _LinearProgress3 = _interopRequireDefault(_LinearProgress2);
	
	var _List2 = __webpack_require__(827);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(215);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(355);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	var _Menu2 = __webpack_require__(356);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(217);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	var _MuiThemeProvider2 = __webpack_require__(882);
	
	var _MuiThemeProvider3 = _interopRequireDefault(_MuiThemeProvider2);
	
	var _Paper2 = __webpack_require__(23);
	
	var _Paper3 = _interopRequireDefault(_Paper2);
	
	var _Popover2 = __webpack_require__(831);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _RadioButton2 = __webpack_require__(832);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(358);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	var _RaisedButton2 = __webpack_require__(834);
	
	var _RaisedButton3 = _interopRequireDefault(_RaisedButton2);
	
	var _RefreshIndicator2 = __webpack_require__(836);
	
	var _RefreshIndicator3 = _interopRequireDefault(_RefreshIndicator2);
	
	var _SelectField2 = __webpack_require__(838);
	
	var _SelectField3 = _interopRequireDefault(_SelectField2);
	
	var _Slider2 = __webpack_require__(840);
	
	var _Slider3 = _interopRequireDefault(_Slider2);
	
	var _Subheader2 = __webpack_require__(360);
	
	var _Subheader3 = _interopRequireDefault(_Subheader2);
	
	var _SvgIcon2 = __webpack_require__(2);
	
	var _SvgIcon3 = _interopRequireDefault(_SvgIcon2);
	
	var _Step2 = __webpack_require__(844);
	
	var _Step3 = _interopRequireDefault(_Step2);
	
	var _StepButton2 = __webpack_require__(845);
	
	var _StepButton3 = _interopRequireDefault(_StepButton2);
	
	var _StepContent2 = __webpack_require__(847);
	
	var _StepContent3 = _interopRequireDefault(_StepContent2);
	
	var _StepLabel2 = __webpack_require__(359);
	
	var _StepLabel3 = _interopRequireDefault(_StepLabel2);
	
	var _Stepper2 = __webpack_require__(848);
	
	var _Stepper3 = _interopRequireDefault(_Stepper2);
	
	var _Snackbar2 = __webpack_require__(843);
	
	var _Snackbar3 = _interopRequireDefault(_Snackbar2);
	
	var _Tabs2 = __webpack_require__(856);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	var _Tab2 = __webpack_require__(365);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Table2 = __webpack_require__(852);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(361);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(362);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(363);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(219);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(364);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(150);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	var _TextField2 = __webpack_require__(115);
	
	var _TextField3 = _interopRequireDefault(_TextField2);
	
	var _TimePicker2 = __webpack_require__(868);
	
	var _TimePicker3 = _interopRequireDefault(_TimePicker2);
	
	var _Toggle2 = __webpack_require__(870);
	
	var _Toggle3 = _interopRequireDefault(_Toggle2);
	
	var _Toolbar2 = __webpack_require__(872);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(368);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(369);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(370);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.AppBar = _AppBar3.default;
	exports.AutoComplete = _AutoComplete3.default;
	exports.Avatar = _Avatar3.default;
	exports.Badge = _Badge3.default;
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.Card = _Card3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardText = _CardText3.default;
	exports.Checkbox = _Checkbox3.default;
	exports.Chip = _Chip3.default;
	exports.CircularProgress = _CircularProgress3.default;
	exports.DatePicker = _DatePicker3.default;
	exports.Dialog = _Dialog3.default;
	exports.Divider = _Divider3.default;
	exports.Drawer = _Drawer3.default;
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.FlatButton = _FlatButton3.default;
	exports.FloatingActionButton = _FloatingActionButton3.default;
	exports.FontIcon = _FontIcon3.default;
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.IconButton = _IconButton3.default;
	exports.IconMenu = _IconMenu3.default;
	exports.LinearProgress = _LinearProgress3.default;
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.MuiThemeProvider = _MuiThemeProvider3.default;
	exports.Paper = _Paper3.default;
	exports.Popover = _Popover3.default;
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.RaisedButton = _RaisedButton3.default;
	exports.RefreshIndicator = _RefreshIndicator3.default;
	exports.SelectField = _SelectField3.default;
	exports.Slider = _Slider3.default;
	exports.Subheader = _Subheader3.default;
	exports.SvgIcon = _SvgIcon3.default;
	exports.Step = _Step3.default;
	exports.StepButton = _StepButton3.default;
	exports.StepContent = _StepContent3.default;
	exports.StepLabel = _StepLabel3.default;
	exports.Stepper = _Stepper3.default;
	exports.Snackbar = _Snackbar3.default;
	exports.Tabs = _Tabs3.default;
	exports.Tab = _Tab3.default;
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.TextField = _TextField3.default;
	exports.TimePicker = _TimePicker3.default;
	exports.Toggle = _Toggle3.default;
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _childUtils = __webpack_require__(117);
	
	var _events = __webpack_require__(152);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _FocusRipple = __webpack_require__(222);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(374);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styleInjected = false;
	var listening = false;
	var tabPressed = false;
	
	function injectStyle() {
	  if (!styleInjected) {
	    // Remove inner padding and border in Firefox 4+.
	    var style = document.createElement('style');
	    style.innerHTML = '\n      button::-moz-focus-inner,\n      input::-moz-focus-inner {\n        border: 0;\n        padding: 0;\n      }\n    ';
	
	    document.body.appendChild(style);
	    styleInjected = true;
	  }
	}
	
	function listenForTabPresses() {
	  if (!listening) {
	    _events2.default.on(window, 'keydown', function (event) {
	      tabPressed = (0, _keycode2.default)(event) === 'tab';
	    });
	    listening = true;
	  }
	}
	
	var EnhancedButton = function (_Component) {
	  (0, _inherits3.default)(EnhancedButton, _Component);
	
	  function EnhancedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedButton.__proto__ || (0, _getPrototypeOf2.default)(EnhancedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleKeyDown = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'enter' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	        if ((0, _keycode2.default)(event) === 'esc' && _this.state.isKeyboardFocused) {
	          _this.removeKeyboardFocus(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleKeyUp = function (event) {
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        if ((0, _keycode2.default)(event) === 'space' && _this.state.isKeyboardFocused) {
	          _this.handleTouchTap(event);
	        }
	      }
	      _this.props.onKeyUp(event);
	    }, _this.handleBlur = function (event) {
	      _this.cancelFocusTimeout();
	      _this.removeKeyboardFocus(event);
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (event) event.persist();
	      if (!_this.props.disabled && !_this.props.disableKeyboardFocus) {
	        // setTimeout is needed because the focus event fires first
	        // Wait so that we can capture if this was a keyboard focus
	        // or touch focus
	        _this.focusTimeout = setTimeout(function () {
	          if (tabPressed) {
	            _this.setKeyboardFocus(event);
	            tabPressed = false;
	          }
	        }, 150);
	
	        _this.props.onFocus(event);
	      }
	    }, _this.handleClick = function (event) {
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.props.onClick(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      _this.cancelFocusTimeout();
	      if (!_this.props.disabled) {
	        tabPressed = false;
	        _this.removeKeyboardFocus(event);
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          disabled = _props.disabled,
	          disableKeyboardFocus = _props.disableKeyboardFocus,
	          keyboardFocused = _props.keyboardFocused;
	
	      if (!disabled && keyboardFocused && !disableKeyboardFocus) {
	        this.setState({ isKeyboardFocused: true });
	      }
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      injectStyle();
	      listenForTabPresses();
	      if (this.state.isKeyboardFocused) {
	        this.button.focus();
	        this.props.onKeyboardFocus(null, true);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if ((nextProps.disabled || nextProps.disableKeyboardFocus) && this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        if (nextProps.onKeyboardFocus) {
	          nextProps.onKeyboardFocus(null, false);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	      }
	    }
	  }, {
	    key: 'isKeyboardFocused',
	    value: function isKeyboardFocused() {
	      return this.state.isKeyboardFocused;
	    }
	  }, {
	    key: 'removeKeyboardFocus',
	    value: function removeKeyboardFocus(event) {
	      if (this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: false });
	        this.props.onKeyboardFocus(event, false);
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus(event) {
	      if (!this.state.isKeyboardFocused) {
	        this.setState({ isKeyboardFocused: true });
	        this.props.onKeyboardFocus(event, true);
	      }
	    }
	  }, {
	    key: 'cancelFocusTimeout',
	    value: function cancelFocusTimeout() {
	      if (this.focusTimeout) {
	        clearTimeout(this.focusTimeout);
	        this.focusTimeout = null;
	      }
	    }
	  }, {
	    key: 'createButtonChildren',
	    value: function createButtonChildren() {
	      var _props2 = this.props,
	          centerRipple = _props2.centerRipple,
	          children = _props2.children,
	          disabled = _props2.disabled,
	          disableFocusRipple = _props2.disableFocusRipple,
	          disableKeyboardFocus = _props2.disableKeyboardFocus,
	          disableTouchRipple = _props2.disableTouchRipple,
	          focusRippleColor = _props2.focusRippleColor,
	          focusRippleOpacity = _props2.focusRippleOpacity,
	          touchRippleColor = _props2.touchRippleColor,
	          touchRippleOpacity = _props2.touchRippleOpacity;
	      var isKeyboardFocused = this.state.isKeyboardFocused;
	
	      // Focus Ripple
	
	      var focusRipple = isKeyboardFocused && !disabled && !disableFocusRipple && !disableKeyboardFocus ? _react2.default.createElement(_FocusRipple2.default, {
	        color: focusRippleColor,
	        opacity: focusRippleOpacity,
	        show: isKeyboardFocused
	      }) : undefined;
	
	      // Touch Ripple
	      var touchRipple = !disabled && !disableTouchRipple ? _react2.default.createElement(
	        _TouchRipple2.default,
	        {
	          centerRipple: centerRipple,
	          color: touchRippleColor,
	          opacity: touchRippleOpacity
	        },
	        children
	      ) : undefined;
	
	      return (0, _childUtils.createChildFragment)({
	        focusRipple: focusRipple,
	        touchRipple: touchRipple,
	        children: touchRipple ? undefined : children
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          centerRipple = _props3.centerRipple,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          disableTouchRipple = _props3.disableTouchRipple,
	          focusRippleColor = _props3.focusRippleColor,
	          focusRippleOpacity = _props3.focusRippleOpacity,
	          href = _props3.href,
	          keyboardFocused = _props3.keyboardFocused,
	          touchRippleColor = _props3.touchRippleColor,
	          touchRippleOpacity = _props3.touchRippleOpacity,
	          onBlur = _props3.onBlur,
	          onClick = _props3.onClick,
	          onFocus = _props3.onFocus,
	          onKeyUp = _props3.onKeyUp,
	          onKeyDown = _props3.onKeyDown,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          onTouchTap = _props3.onTouchTap,
	          style = _props3.style,
	          tabIndex = _props3.tabIndex,
	          type = _props3.type,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['centerRipple', 'children', 'containerElement', 'disabled', 'disableFocusRipple', 'disableKeyboardFocus', 'disableTouchRipple', 'focusRippleColor', 'focusRippleOpacity', 'href', 'keyboardFocused', 'touchRippleColor', 'touchRippleOpacity', 'onBlur', 'onClick', 'onFocus', 'onKeyUp', 'onKeyDown', 'onKeyboardFocus', 'onTouchTap', 'style', 'tabIndex', 'type']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          enhancedButton = _context$muiTheme.enhancedButton;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        border: 10,
	        boxSizing: 'border-box',
	        display: 'inline-block',
	        fontFamily: this.context.muiTheme.baseTheme.fontFamily,
	        WebkitTapHighlightColor: enhancedButton.tapHighlightColor, // Remove mobile color flashing (deprecated)
	        cursor: disabled ? 'default' : 'pointer',
	        textDecoration: 'none',
	        margin: 0,
	        padding: 0,
	        outline: 'none',
	        fontSize: 'inherit',
	        fontWeight: 'inherit',
	        position: 'relative', // This is needed so that ripples do not bleed past border radius.
	        verticalAlign: href ? 'middle' : null,
	        zIndex: 1 }, style);
	
	      // Passing both background:none & backgroundColor can break due to object iteration order
	      if (!mergedStyles.backgroundColor && !mergedStyles.background) {
	        mergedStyles.background = 'none';
	      }
	
	      if (disabled && href) {
	        return _react2.default.createElement(
	          'span',
	          (0, _extends3.default)({}, other, {
	            style: mergedStyles
	          }),
	          children
	        );
	      }
	
	      var buttonProps = (0, _extends3.default)({}, other, {
	        style: prepareStyles(mergedStyles),
	        ref: function ref(node) {
	          return _this2.button = node;
	        },
	        disabled: disabled,
	        href: href,
	        onBlur: this.handleBlur,
	        onClick: this.handleClick,
	        onFocus: this.handleFocus,
	        onKeyUp: this.handleKeyUp,
	        onKeyDown: this.handleKeyDown,
	        onTouchTap: this.handleTouchTap,
	        tabIndex: disabled || disableKeyboardFocus ? -1 : tabIndex
	      });
	
	      var buttonChildren = this.createButtonChildren();
	
	      if (_react2.default.isValidElement(containerElement)) {
	        return _react2.default.cloneElement(containerElement, buttonProps, buttonChildren);
	      }
	
	      if (!href && containerElement === 'button') {
	        buttonProps.type = type;
	      }
	
	      return _react2.default.createElement(href ? 'a' : containerElement, buttonProps, buttonChildren);
	    }
	  }]);
	  return EnhancedButton;
	}(_react.Component);
	
	EnhancedButton.defaultProps = {
	  containerElement: 'button',
	  onBlur: function onBlur() {},
	  onClick: function onClick() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyUp: function onKeyUp() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onTouchTap: function onTouchTap() {},
	  tabIndex: 0,
	  type: 'button'
	};
	EnhancedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? EnhancedButton.propTypes = {
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  disableFocusRipple: _propTypes2.default.bool,
	  disableKeyboardFocus: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  focusRippleColor: _propTypes2.default.string,
	  focusRippleOpacity: _propTypes2.default.number,
	  href: _propTypes2.default.string,
	  keyboardFocused: _propTypes2.default.bool,
	  onBlur: _propTypes2.default.func,
	  onClick: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onKeyDown: _propTypes2.default.func,
	  onKeyUp: _propTypes2.default.func,
	  onKeyboardFocus: _propTypes2.default.func,
	  onTouchTap: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  tabIndex: _propTypes2.default.number,
	  touchRippleColor: _propTypes2.default.string,
	  touchRippleOpacity: _propTypes2.default.number,
	  type: _propTypes2.default.string
	} : void 0;
	exports.default = EnhancedButton;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// Trust the developer to only use ReactInstrumentation with a __DEV__ check
	
	var debugTool = null;
	
	if (false) {
	  var ReactDebugTool = require('./ReactDebugTool');
	  debugTool = ReactDebugTool;
	}
	
	module.exports = { debugTool: debugTool };

/***/ },
/* 37 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 38 */
/***/ function(module, exports) {

	if (typeof Object.create === 'function') {
	  // implementation from standard node.js 'util' module
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    ctor.prototype = Object.create(superCtor.prototype, {
	      constructor: {
	        value: ctor,
	        enumerable: false,
	        writable: true,
	        configurable: true
	      }
	    });
	  };
	} else {
	  // old school shim for old browsers
	  module.exports = function inherits(ctor, superCtor) {
	    ctor.super_ = superCtor
	    var TempCtor = function () {}
	    TempCtor.prototype = superCtor.prototype
	    ctor.prototype = new TempCtor()
	    ctor.prototype.constructor = ctor
	  }
	}


/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2015, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	
	'use strict';
	
	/**
	 * Use invariant() to assert state which your program assumes to be true.
	 *
	 * Provide sprintf-style format (only %s is supported) and arguments
	 * to provide information about what broke and what you were
	 * expecting.
	 *
	 * The invariant message will be stripped in production, but the invariant
	 * will remain to ensure logic does not differ in production.
	 */
	
	var invariant = function(condition, format, a, b, c, d, e, f) {
	  if (false) {
	    if (format === undefined) {
	      throw new Error('invariant requires an error message argument');
	    }
	  }
	
	  if (!condition) {
	    var error;
	    if (format === undefined) {
	      error = new Error(
	        'Minified exception occurred; use the non-minified dev environment ' +
	        'for the full error message and additional helpful warnings.'
	      );
	    } else {
	      var args = [a, b, c, d, e, f];
	      var argIndex = 0;
	      error = new Error(
	        format.replace(/%s/g, function() { return args[argIndex++]; })
	      );
	      error.name = 'Invariant Violation';
	    }
	
	    error.framesToPop = 1; // we don't care about invariant's own frame
	    throw error;
	  }
	};
	
	module.exports = invariant;


/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(137),
	    baseAssignValue = __webpack_require__(107);
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  var isNew = !object;
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    if (newValue === undefined) {
	      newValue = source[key];
	    }
	    if (isNew) {
	      baseAssignValue(object, key, newValue);
	    } else {
	      assignValue(object, key, newValue);
	    }
	  }
	  return object;
	}
	
	module.exports = copyObject;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	var freeGlobal = __webpack_require__(323);
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	module.exports = root;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var CallbackQueue = __webpack_require__(395);
	var PooledClass = __webpack_require__(66);
	var ReactFeatureFlags = __webpack_require__(400);
	var ReactReconciler = __webpack_require__(92);
	var Transaction = __webpack_require__(157);
	
	var invariant = __webpack_require__(13);
	
	var dirtyComponents = [];
	var updateBatchNumber = 0;
	var asapCallbackQueue = CallbackQueue.getPooled();
	var asapEnqueued = false;
	
	var batchingStrategy = null;
	
	function ensureInjected() {
	  !(ReactUpdates.ReactReconcileTransaction && batchingStrategy) ?  false ? invariant(false, 'ReactUpdates: must inject a reconcile transaction class and batching strategy') : _prodInvariant('123') : void 0;
	}
	
	var NESTED_UPDATES = {
	  initialize: function () {
	    this.dirtyComponentsLength = dirtyComponents.length;
	  },
	  close: function () {
	    if (this.dirtyComponentsLength !== dirtyComponents.length) {
	      // Additional updates were enqueued by componentDidUpdate handlers or
	      // similar; before our own UPDATE_QUEUEING wrapper closes, we want to run
	      // these new updates so that if A's componentDidUpdate calls setState on
	      // B, B will update before the callback A's updater provided when calling
	      // setState.
	      dirtyComponents.splice(0, this.dirtyComponentsLength);
	      flushBatchedUpdates();
	    } else {
	      dirtyComponents.length = 0;
	    }
	  }
	};
	
	var UPDATE_QUEUEING = {
	  initialize: function () {
	    this.callbackQueue.reset();
	  },
	  close: function () {
	    this.callbackQueue.notifyAll();
	  }
	};
	
	var TRANSACTION_WRAPPERS = [NESTED_UPDATES, UPDATE_QUEUEING];
	
	function ReactUpdatesFlushTransaction() {
	  this.reinitializeTransaction();
	  this.dirtyComponentsLength = null;
	  this.callbackQueue = CallbackQueue.getPooled();
	  this.reconcileTransaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */true);
	}
	
	_assign(ReactUpdatesFlushTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  destructor: function () {
	    this.dirtyComponentsLength = null;
	    CallbackQueue.release(this.callbackQueue);
	    this.callbackQueue = null;
	    ReactUpdates.ReactReconcileTransaction.release(this.reconcileTransaction);
	    this.reconcileTransaction = null;
	  },
	
	  perform: function (method, scope, a) {
	    // Essentially calls `this.reconcileTransaction.perform(method, scope, a)`
	    // with this transaction's wrappers around it.
	    return Transaction.perform.call(this, this.reconcileTransaction.perform, this.reconcileTransaction, method, scope, a);
	  }
	});
	
	PooledClass.addPoolingTo(ReactUpdatesFlushTransaction);
	
	function batchedUpdates(callback, a, b, c, d, e) {
	  ensureInjected();
	  return batchingStrategy.batchedUpdates(callback, a, b, c, d, e);
	}
	
	/**
	 * Array comparator for ReactComponents by mount ordering.
	 *
	 * @param {ReactComponent} c1 first component you're comparing
	 * @param {ReactComponent} c2 second component you're comparing
	 * @return {number} Return value usable by Array.prototype.sort().
	 */
	function mountOrderComparator(c1, c2) {
	  return c1._mountOrder - c2._mountOrder;
	}
	
	function runBatchedUpdates(transaction) {
	  var len = transaction.dirtyComponentsLength;
	  !(len === dirtyComponents.length) ?  false ? invariant(false, 'Expected flush transaction\'s stored dirty-components length (%s) to match dirty-components array length (%s).', len, dirtyComponents.length) : _prodInvariant('124', len, dirtyComponents.length) : void 0;
	
	  // Since reconciling a component higher in the owner hierarchy usually (not
	  // always -- see shouldComponentUpdate()) will reconcile children, reconcile
	  // them before their children by sorting the array.
	  dirtyComponents.sort(mountOrderComparator);
	
	  // Any updates enqueued while reconciling must be performed after this entire
	  // batch. Otherwise, if dirtyComponents is [A, B] where A has children B and
	  // C, B could update twice in a single batch if C's render enqueues an update
	  // to B (since B would have already updated, we should skip it, and the only
	  // way we can know to do so is by checking the batch counter).
	  updateBatchNumber++;
	
	  for (var i = 0; i < len; i++) {
	    // If a component is unmounted before pending changes apply, it will still
	    // be here, but we assume that it has cleared its _pendingCallbacks and
	    // that performUpdateIfNecessary is a noop.
	    var component = dirtyComponents[i];
	
	    // If performUpdateIfNecessary happens to enqueue any new updates, we
	    // shouldn't execute the callbacks until the next render happens, so
	    // stash the callbacks first
	    var callbacks = component._pendingCallbacks;
	    component._pendingCallbacks = null;
	
	    var markerName;
	    if (ReactFeatureFlags.logTopLevelRenders) {
	      var namedComponent = component;
	      // Duck type TopLevelWrapper. This is probably always true.
	      if (component._currentElement.type.isReactTopLevelWrapper) {
	        namedComponent = component._renderedComponent;
	      }
	      markerName = 'React update: ' + namedComponent.getName();
	      console.time(markerName);
	    }
	
	    ReactReconciler.performUpdateIfNecessary(component, transaction.reconcileTransaction, updateBatchNumber);
	
	    if (markerName) {
	      console.timeEnd(markerName);
	    }
	
	    if (callbacks) {
	      for (var j = 0; j < callbacks.length; j++) {
	        transaction.callbackQueue.enqueue(callbacks[j], component.getPublicInstance());
	      }
	    }
	  }
	}
	
	var flushBatchedUpdates = function () {
	  // ReactUpdatesFlushTransaction's wrappers will clear the dirtyComponents
	  // array and perform any updates enqueued by mount-ready handlers (i.e.,
	  // componentDidUpdate) but we need to check here too in order to catch
	  // updates enqueued by setState callbacks and asap calls.
	  while (dirtyComponents.length || asapEnqueued) {
	    if (dirtyComponents.length) {
	      var transaction = ReactUpdatesFlushTransaction.getPooled();
	      transaction.perform(runBatchedUpdates, null, transaction);
	      ReactUpdatesFlushTransaction.release(transaction);
	    }
	
	    if (asapEnqueued) {
	      asapEnqueued = false;
	      var queue = asapCallbackQueue;
	      asapCallbackQueue = CallbackQueue.getPooled();
	      queue.notifyAll();
	      CallbackQueue.release(queue);
	    }
	  }
	};
	
	/**
	 * Mark a component as needing a rerender, adding an optional callback to a
	 * list of functions which will be executed once the rerender occurs.
	 */
	function enqueueUpdate(component) {
	  ensureInjected();
	
	  // Various parts of our code (such as ReactCompositeComponent's
	  // _renderValidatedComponent) assume that calls to render aren't nested;
	  // verify that that's the case. (This is called by each top-level update
	  // function, like setState, forceUpdate, etc.; creation and
	  // destruction of top-level components is guarded in ReactMount.)
	
	  if (!batchingStrategy.isBatchingUpdates) {
	    batchingStrategy.batchedUpdates(enqueueUpdate, component);
	    return;
	  }
	
	  dirtyComponents.push(component);
	  if (component._updateBatchNumber == null) {
	    component._updateBatchNumber = updateBatchNumber + 1;
	  }
	}
	
	/**
	 * Enqueue a callback to be run at the end of the current batching cycle. Throws
	 * if no updates are currently being performed.
	 */
	function asap(callback, context) {
	  invariant(batchingStrategy.isBatchingUpdates, "ReactUpdates.asap: Can't enqueue an asap callback in a context where" + 'updates are not being batched.');
	  asapCallbackQueue.enqueue(callback, context);
	  asapEnqueued = true;
	}
	
	var ReactUpdatesInjection = {
	  injectReconcileTransaction: function (ReconcileTransaction) {
	    !ReconcileTransaction ?  false ? invariant(false, 'ReactUpdates: must provide a reconcile transaction class') : _prodInvariant('126') : void 0;
	    ReactUpdates.ReactReconcileTransaction = ReconcileTransaction;
	  },
	
	  injectBatchingStrategy: function (_batchingStrategy) {
	    !_batchingStrategy ?  false ? invariant(false, 'ReactUpdates: must provide a batching strategy') : _prodInvariant('127') : void 0;
	    !(typeof _batchingStrategy.batchedUpdates === 'function') ?  false ? invariant(false, 'ReactUpdates: must provide a batchedUpdates() function') : _prodInvariant('128') : void 0;
	    !(typeof _batchingStrategy.isBatchingUpdates === 'boolean') ?  false ? invariant(false, 'ReactUpdates: must provide an isBatchingUpdates boolean attribute') : _prodInvariant('129') : void 0;
	    batchingStrategy = _batchingStrategy;
	  }
	};
	
	var ReactUpdates = {
	  /**
	   * React references `ReactReconcileTransaction` using this property in order
	   * to allow dependency injection.
	   *
	   * @internal
	   */
	  ReactReconcileTransaction: null,
	
	  batchedUpdates: batchedUpdates,
	  enqueueUpdate: enqueueUpdate,
	  flushBatchedUpdates: flushBatchedUpdates,
	  injection: ReactUpdatesInjection,
	  asap: asap
	};
	
	module.exports = ReactUpdates;

/***/ },
/* 43 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(66);
	
	var emptyFunction = __webpack_require__(24);
	var warning = __webpack_require__(16);
	
	var didWarnForAddedNewProperty = false;
	var isProxySupported = typeof Proxy === 'function';
	
	var shouldBeReleasedProperties = ['dispatchConfig', '_targetInst', 'nativeEvent', 'isDefaultPrevented', 'isPropagationStopped', '_dispatchListeners', '_dispatchInstances'];
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var EventInterface = {
	  type: null,
	  target: null,
	  // currentTarget is set when dispatching; no use in copying it here
	  currentTarget: emptyFunction.thatReturnsNull,
	  eventPhase: null,
	  bubbles: null,
	  cancelable: null,
	  timeStamp: function (event) {
	    return event.timeStamp || Date.now();
	  },
	  defaultPrevented: null,
	  isTrusted: null
	};
	
	/**
	 * Synthetic events are dispatched by event plugins, typically in response to a
	 * top-level event delegation handler.
	 *
	 * These systems should generally use pooling to reduce the frequency of garbage
	 * collection. The system should check `isPersistent` to determine whether the
	 * event should be released into the pool after being dispatched. Users that
	 * need a persisted event should invoke `persist`.
	 *
	 * Synthetic events (and subclasses) implement the DOM Level 3 Events API by
	 * normalizing browser quirks. Subclasses do not necessarily have to implement a
	 * DOM interface; custom application-specific events can also subclass this.
	 *
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {*} targetInst Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @param {DOMEventTarget} nativeEventTarget Target node.
	 */
	function SyntheticEvent(dispatchConfig, targetInst, nativeEvent, nativeEventTarget) {
	  if (false) {
	    // these have a getter/setter for warnings
	    delete this.nativeEvent;
	    delete this.preventDefault;
	    delete this.stopPropagation;
	  }
	
	  this.dispatchConfig = dispatchConfig;
	  this._targetInst = targetInst;
	  this.nativeEvent = nativeEvent;
	
	  var Interface = this.constructor.Interface;
	  for (var propName in Interface) {
	    if (!Interface.hasOwnProperty(propName)) {
	      continue;
	    }
	    if (false) {
	      delete this[propName]; // this has a getter/setter for warnings
	    }
	    var normalize = Interface[propName];
	    if (normalize) {
	      this[propName] = normalize(nativeEvent);
	    } else {
	      if (propName === 'target') {
	        this.target = nativeEventTarget;
	      } else {
	        this[propName] = nativeEvent[propName];
	      }
	    }
	  }
	
	  var defaultPrevented = nativeEvent.defaultPrevented != null ? nativeEvent.defaultPrevented : nativeEvent.returnValue === false;
	  if (defaultPrevented) {
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  } else {
	    this.isDefaultPrevented = emptyFunction.thatReturnsFalse;
	  }
	  this.isPropagationStopped = emptyFunction.thatReturnsFalse;
	  return this;
	}
	
	_assign(SyntheticEvent.prototype, {
	  preventDefault: function () {
	    this.defaultPrevented = true;
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.preventDefault) {
	      event.preventDefault();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.returnValue !== 'unknown') {
	      event.returnValue = false;
	    }
	    this.isDefaultPrevented = emptyFunction.thatReturnsTrue;
	  },
	
	  stopPropagation: function () {
	    var event = this.nativeEvent;
	    if (!event) {
	      return;
	    }
	
	    if (event.stopPropagation) {
	      event.stopPropagation();
	      // eslint-disable-next-line valid-typeof
	    } else if (typeof event.cancelBubble !== 'unknown') {
	      // The ChangeEventPlugin registers a "propertychange" event for
	      // IE. This event does not support bubbling or cancelling, and
	      // any references to cancelBubble throw "Member not found".  A
	      // typeof check of "unknown" circumvents this issue (and is also
	      // IE specific).
	      event.cancelBubble = true;
	    }
	
	    this.isPropagationStopped = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * We release all dispatched `SyntheticEvent`s after each event loop, adding
	   * them back into the pool. This allows a way to hold onto a reference that
	   * won't be added back into the pool.
	   */
	  persist: function () {
	    this.isPersistent = emptyFunction.thatReturnsTrue;
	  },
	
	  /**
	   * Checks if this event should be released back into the pool.
	   *
	   * @return {boolean} True if this should not be released, false otherwise.
	   */
	  isPersistent: emptyFunction.thatReturnsFalse,
	
	  /**
	   * `PooledClass` looks for `destructor` on each instance it releases.
	   */
	  destructor: function () {
	    var Interface = this.constructor.Interface;
	    for (var propName in Interface) {
	      if (false) {
	        Object.defineProperty(this, propName, getPooledWarningPropertyDefinition(propName, Interface[propName]));
	      } else {
	        this[propName] = null;
	      }
	    }
	    for (var i = 0; i < shouldBeReleasedProperties.length; i++) {
	      this[shouldBeReleasedProperties[i]] = null;
	    }
	    if (false) {
	      Object.defineProperty(this, 'nativeEvent', getPooledWarningPropertyDefinition('nativeEvent', null));
	      Object.defineProperty(this, 'preventDefault', getPooledWarningPropertyDefinition('preventDefault', emptyFunction));
	      Object.defineProperty(this, 'stopPropagation', getPooledWarningPropertyDefinition('stopPropagation', emptyFunction));
	    }
	  }
	});
	
	SyntheticEvent.Interface = EventInterface;
	
	/**
	 * Helper to reduce boilerplate when creating subclasses.
	 *
	 * @param {function} Class
	 * @param {?object} Interface
	 */
	SyntheticEvent.augmentClass = function (Class, Interface) {
	  var Super = this;
	
	  var E = function () {};
	  E.prototype = Super.prototype;
	  var prototype = new E();
	
	  _assign(prototype, Class.prototype);
	  Class.prototype = prototype;
	  Class.prototype.constructor = Class;
	
	  Class.Interface = _assign({}, Super.Interface, Interface);
	  Class.augmentClass = Super.augmentClass;
	
	  PooledClass.addPoolingTo(Class, PooledClass.fourArgumentPooler);
	};
	
	/** Proxying after everything set on SyntheticEvent
	  * to resolve Proxy issue on some WebKit browsers
	  * in which some Event properties are set to undefined (GH#10010)
	  */
	if (false) {
	  if (isProxySupported) {
	    /*eslint-disable no-func-assign */
	    SyntheticEvent = new Proxy(SyntheticEvent, {
	      construct: function (target, args) {
	        return this.apply(target, Object.create(target.prototype), args);
	      },
	      apply: function (constructor, that, args) {
	        return new Proxy(constructor.apply(that, args), {
	          set: function (target, prop, value) {
	            if (prop !== 'isPersistent' && !target.constructor.Interface.hasOwnProperty(prop) && shouldBeReleasedProperties.indexOf(prop) === -1) {
	              process.env.NODE_ENV !== 'production' ? warning(didWarnForAddedNewProperty || target.isPersistent(), "This synthetic event is reused for performance reasons. If you're " + "seeing this, you're adding a new property in the synthetic event object. " + 'The property is never released. See ' + 'https://fb.me/react-event-pooling for more information.') : void 0;
	              didWarnForAddedNewProperty = true;
	            }
	            target[prop] = value;
	            return true;
	          }
	        });
	      }
	    });
	    /*eslint-enable no-func-assign */
	  }
	}
	
	PooledClass.addPoolingTo(SyntheticEvent, PooledClass.fourArgumentPooler);
	
	module.exports = SyntheticEvent;
	
	/**
	  * Helper to nullify syntheticEvent instance properties when destructing
	  *
	  * @param {object} SyntheticEvent
	  * @param {String} propName
	  * @return {object} defineProperty object
	  */
	function getPooledWarningPropertyDefinition(propName, getVal) {
	  var isFunction = typeof getVal === 'function';
	  return {
	    configurable: true,
	    set: set,
	    get: get
	  };
	
	  function set(val) {
	    var action = isFunction ? 'setting the method' : 'setting the property';
	    warn(action, 'This is effectively a no-op');
	    return val;
	  }
	
	  function get() {
	    var action = isFunction ? 'accessing the method' : 'accessing the property';
	    var result = isFunction ? 'This is a no-op function' : 'This is set to null';
	    warn(action, result);
	    return getVal;
	  }
	
	  function warn(action, result) {
	    var warningCondition = false;
	     false ? warning(warningCondition, "This synthetic event is reused for performance reasons. If you're seeing this, " + "you're %s `%s` on a released/nullified synthetic event. %s. " + 'If you must keep the original synthetic event around, use event.persist(). ' + 'See https://fb.me/react-event-pooling for more information.', action, propName, result) : void 0;
	  }
	}

/***/ },
/* 44 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _typeof2 = __webpack_require__(69);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _keys = __webpack_require__(163);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _assign = __webpack_require__(253);
	
	var _assign2 = _interopRequireDefault(_assign);
	
	exports.withOptions = withOptions;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _shallowEqual = __webpack_require__(105);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _supports = __webpack_require__(1917);
	
	var supports = _interopRequireWildcard(_supports);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var defaultEventOptions = {
	  capture: false,
	  passive: false
	};
	/* eslint-disable prefer-spread */
	
	function mergeDefaultEventOptions(options) {
	  return (0, _assign2.default)({}, defaultEventOptions, options);
	}
	
	function getEventListenerArgs(eventName, callback, options) {
	  var args = [eventName, callback];
	  args.push(supports.passiveOption ? options : options.capture);
	  return args;
	}
	
	function on(target, eventName, callback, options) {
	  if (supports.addEventListener) {
	    target.addEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.attachEvent) {
	    // IE8+ Support
	    target.attachEvent('on' + eventName, function () {
	      callback.call(target);
	    });
	  }
	}
	
	function off(target, eventName, callback, options) {
	  if (supports.removeEventListener) {
	    target.removeEventListener.apply(target, getEventListenerArgs(eventName, callback, options));
	  } else if (supports.detachEvent) {
	    // IE8+ Support
	    target.detachEvent('on' + eventName, callback);
	  }
	}
	
	function forEachListener(props, iteratee) {
	  var children = props.children,
	      target = props.target,
	      eventProps = (0, _objectWithoutProperties3.default)(props, ['children', 'target']);
	
	
	  (0, _keys2.default)(eventProps).forEach(function (name) {
	    if (name.substring(0, 2) !== 'on') {
	      return;
	    }
	
	    var prop = eventProps[name];
	    var type = typeof prop === 'undefined' ? 'undefined' : (0, _typeof3.default)(prop);
	    var isObject = type === 'object';
	    var isFunction = type === 'function';
	
	    if (!isObject && !isFunction) {
	      return;
	    }
	
	    var capture = name.substr(-7).toLowerCase() === 'capture';
	    var eventName = name.substring(2).toLowerCase();
	    eventName = capture ? eventName.substring(0, eventName.length - 7) : eventName;
	
	    if (isObject) {
	      iteratee(eventName, prop.handler, prop.options);
	    } else {
	      iteratee(eventName, prop, mergeDefaultEventOptions({ capture: capture }));
	    }
	  });
	}
	
	function withOptions(handler, options) {
	   false ? (0, _warning2.default)(options, 'react-event-listener: Should be specified options in withOptions.') : void 0;
	
	  return {
	    handler: handler,
	    options: mergeDefaultEventOptions(options)
	  };
	}
	
	var EventListener = function (_Component) {
	  (0, _inherits3.default)(EventListener, _Component);
	
	  function EventListener() {
	    (0, _classCallCheck3.default)(this, EventListener);
	    return (0, _possibleConstructorReturn3.default)(this, (EventListener.__proto__ || (0, _getPrototypeOf2.default)(EventListener)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(EventListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.addListeners();
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUpdate',
	    value: function componentWillUpdate() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.addListeners();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.removeListeners();
	    }
	  }, {
	    key: 'addListeners',
	    value: function addListeners() {
	      this.applyListeners(on);
	    }
	  }, {
	    key: 'removeListeners',
	    value: function removeListeners() {
	      this.applyListeners(off);
	    }
	  }, {
	    key: 'applyListeners',
	    value: function applyListeners(onOrOff) {
	      var target = this.props.target;
	
	
	      if (target) {
	        var element = target;
	
	        if (typeof target === 'string') {
	          element = window[target];
	        }
	
	        forEachListener(this.props, onOrOff.bind(null, element));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children || null;
	    }
	  }]);
	  return EventListener;
	}(_react.Component);
	
	 false ? EventListener.propTypes = {
	  /**
	   * You can provide a single child too.
	   */
	  children: _propTypes2.default.element,
	  /**
	   * The DOM target to listen to.
	   */
	  target: _propTypes2.default.oneOfType([_propTypes2.default.object, _propTypes2.default.string]).isRequired
	} : void 0;
	exports.default = EventListener;

/***/ },
/* 45 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Keeps track of the current owner.
	 *
	 * The current owner is the component who should own any components that are
	 * currently being constructed.
	 */
	var ReactCurrentOwner = {
	  /**
	   * @internal
	   * @type {ReactComponent}
	   */
	  current: null
	};
	
	module.exports = ReactCurrentOwner;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _jss = __webpack_require__(622);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 17/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Returns a style element
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Useful info for dev:
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - Outlook styles support: https://msdn.microsoft.com/en-us/library/aa338201(v=office.12).aspx#Word2007MailHTMLandCSS_Full
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - Mailchimp reset: https://templates.mailchimp.com/development/css/reset-styles/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - Mailchimp style support list: https://templates.mailchimp.com/resources/email-client-css-support/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - HTML 4 spec: https://www.w3.org/TR/REC-html40/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - Generic css reset: http://cssreset.com/scripts/eric-meyer-reset-css/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - Inherited CSS properties: http://stackoverflow.com/questions/5612302/which-css-properties-are-inherited
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Dependency info
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - Juice style inliner: https://github.com/Automattic/juice
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - Juice test sandbox: http://automattic.github.io/juice/
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * - JSS js stylesheet generator: https://www.npmjs.com/package/jss
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var StyleItem = function (_Component) {
	  _inherits(StyleItem, _Component);
	
	  function StyleItem() {
	    _classCallCheck(this, StyleItem);
	
	    return _possibleConstructorReturn(this, (StyleItem.__proto__ || Object.getPrototypeOf(StyleItem)).apply(this, arguments));
	  }
	
	  _createClass(StyleItem, [{
	    key: 'render',
	    value: function render() {
	      // Use JSS to calculate the styles
	      if (!this.props.styleObject) return null;
	
	      var jss = (0, _jss.create)();
	      var selectorPrefix = this.props.selectorPrefix;
	      jss.setup({
	        generateClassName: function generateClassName(rule) {
	          //Split multiple, insert prefix
	          return rule.name.split(",").map(function (item, index) {
	            return (index > 0 ? "." : "") + selectorPrefix + item.trim();
	          }).join(", ");
	        }
	      });
	
	      var sheet = jss.createStyleSheet(this.props.styleObject);
	      var sheetText = sheet.toString();
	      return sheetText.length > 0 && _react2.default.createElement(
	        'style',
	        null,
	        sheetText
	      );
	    }
	  }]);
	
	  return StyleItem;
	}(_react.Component);
	
	exports.default = StyleItem;

/***/ },
/* 47 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(48);
	var core = __webpack_require__(21);
	var ctx = __webpack_require__(168);
	var hide = __webpack_require__(71);
	var PROTOTYPE = 'prototype';
	
	var $export = function (type, name, source) {
	  var IS_FORCED = type & $export.F;
	  var IS_GLOBAL = type & $export.G;
	  var IS_STATIC = type & $export.S;
	  var IS_PROTO = type & $export.P;
	  var IS_BIND = type & $export.B;
	  var IS_WRAP = type & $export.W;
	  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
	  var expProto = exports[PROTOTYPE];
	  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
	  var key, own, out;
	  if (IS_GLOBAL) source = name;
	  for (key in source) {
	    // contains in native
	    own = !IS_FORCED && target && target[key] !== undefined;
	    if (own && key in exports) continue;
	    // export native or passed
	    out = own ? target[key] : source[key];
	    // prevent global pollution for namespaces
	    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
	    // bind timers to global for call from export context
	    : IS_BIND && own ? ctx(out, global)
	    // wrap global constructors for prevent change them in library
	    : IS_WRAP && target[key] == out ? (function (C) {
	      var F = function (a, b, c) {
	        if (this instanceof C) {
	          switch (arguments.length) {
	            case 0: return new C();
	            case 1: return new C(a);
	            case 2: return new C(a, b);
	          } return new C(a, b, c);
	        } return C.apply(this, arguments);
	      };
	      F[PROTOTYPE] = C[PROTOTYPE];
	      return F;
	    // make static versions for prototype methods
	    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
	    if (IS_PROTO) {
	      (exports.virtual || (exports.virtual = {}))[key] = out;
	      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
	      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
	    }
	  }
	};
	// type bitmap
	$export.F = 1;   // forced
	$export.G = 2;   // global
	$export.S = 4;   // static
	$export.P = 8;   // proto
	$export.B = 16;  // bind
	$export.W = 32;  // wrap
	$export.U = 64;  // safe
	$export.R = 128; // real proto method for `library`
	module.exports = $export;


/***/ },
/* 48 */
/***/ function(module, exports) {

	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var global = module.exports = typeof window != 'undefined' && window.Math == Math
	  ? window : typeof self != 'undefined' && self.Math == Math ? self
	  // eslint-disable-next-line no-new-func
	  : Function('return this')();
	if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(58);
	var IE8_DOM_DEFINE = __webpack_require__(258);
	var toPrimitive = __webpack_require__(178);
	var dP = Object.defineProperty;
	
	exports.f = __webpack_require__(59) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	  anObject(O);
	  P = toPrimitive(P, true);
	  anObject(Attributes);
	  if (IE8_DOM_DEFINE) try {
	    return dP(O, P, Attributes);
	  } catch (e) { /* empty */ }
	  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	  if ('value' in Attributes) O[P] = Attributes.value;
	  return O;
	};


/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	var baseMatches = __webpack_require__(672),
	    baseMatchesProperty = __webpack_require__(673),
	    identity = __webpack_require__(109),
	    isArray = __webpack_require__(28),
	    property = __webpack_require__(769);
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	module.exports = baseIteratee;


/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(28),
	    isKey = __webpack_require__(204),
	    stringToPath = __webpack_require__(736),
	    toString = __webpack_require__(775);
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value, object) {
	  if (isArray(value)) {
	    return value;
	  }
	  return isKey(value, object) ? [value] : stringToPath(toString(value));
	}
	
	module.exports = castPath;


/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	var isSymbol = __webpack_require__(210);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = toKey;


/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.convertColorToString = convertColorToString;
	exports.convertHexToRGB = convertHexToRGB;
	exports.decomposeColor = decomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value, min, max) {
	  if (value < min) {
	    return min;
	  }
	  if (value > max) {
	    return max;
	  }
	  return value;
	}
	
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of, 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	function convertColorToString(color) {
	  var type = color.type,
	      values = color.values;
	
	
	  if (type.indexOf('rgb') > -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    for (var i = 0; i < 3; i++) {
	      values[i] = parseInt(values[i]);
	    }
	  }
	
	  var colorString = void 0;
	
	  if (type.indexOf('hsl') > -1) {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + '%, ' + values[2] + '%';
	  } else {
	    colorString = color.type + '(' + values[0] + ', ' + values[1] + ', ' + values[2];
	  }
	
	  if (values.length === 4) {
	    colorString += ', ' + color.values[3] + ')';
	  } else {
	    colorString += ')';
	  }
	
	  return colorString;
	}
	
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 *  @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 *  @returns {string} A CSS rgb color string
	 */
	function convertHexToRGB(color) {
	  if (color.length === 4) {
	    var extendedColor = '#';
	    for (var i = 1; i < color.length; i++) {
	      extendedColor += color.charAt(i) + color.charAt(i);
	    }
	    color = extendedColor;
	  }
	
	  var values = {
	    r: parseInt(color.substr(1, 2), 16),
	    g: parseInt(color.substr(3, 2), 16),
	    b: parseInt(color.substr(5, 2), 16)
	  };
	
	  return 'rgb(' + values.r + ', ' + values.g + ', ' + values.b + ')';
	}
	
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values and color names.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {{type: string, values: number[]}} A MUI color object
	 */
	function decomposeColor(color) {
	  if (color.charAt(0) === '#') {
	    return decomposeColor(convertHexToRGB(color));
	  }
	
	  var marker = color.indexOf('(');
	
	   false ? (0, _warning2.default)(marker !== -1, 'Material-UI: The ' + color + ' color was not parsed correctly,\n  because it has an unsupported format (color name or RGB %). This may cause issues in component rendering.') : void 0;
	
	  var type = color.substring(0, marker);
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	
	  return { type: type, values: values };
	}
	
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21 with 2 digit precision.
	 */
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  var contrastRatio = (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	
	  return Number(contrastRatio.toFixed(2)); // Truncate at two digits
	}
	
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/WAI/GL/wiki/Relative_luminance
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	function getLuminance(color) {
	  color = decomposeColor(color);
	
	  if (color.type.indexOf('rgb') > -1) {
	    var rgb = color.values.map(function (val) {
	      val /= 255; // normalized
	      return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	    });
	    return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3)); // Truncate at 3 digits
	  } else if (color.type.indexOf('hsl') > -1) {
	    return color.values[2] / 100;
	  }
	}
	
	/**
	 * Darken or lighten a colour, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value, 0, 1);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	  color.values[3] = value;
	
	  return convertColorToString(color);
	}
	
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	  return convertColorToString(color);
	}
	
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient, 0, 1);
	
	  if (color.type.indexOf('hsl') > -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') > -1) {
	    for (var i = 0; i < 3; i++) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return convertColorToString(color);
	}

/***/ },
/* 54 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createContentItem = createContentItem;
	exports.deleteContentItem = deleteContentItem;
	exports.orphanContentItem = orphanContentItem;
	exports.restoreOrphanedContentItem = restoreOrphanedContentItem;
	exports.moveContentItem = moveContentItem;
	exports.updateContentItem = updateContentItem;
	exports.hideContentItem = hideContentItem;
	exports.setContentItems = setContentItems;
	/**
	 * Created by daniel on 23/04/17.
	 */
	
	var CREATE_CONTENT_ITEM = exports.CREATE_CONTENT_ITEM = "CREATE_CONTENT_ITEM";
	var DELETE_CONTENT_ITEM = exports.DELETE_CONTENT_ITEM = "DELETE_CONTENT_ITEM";
	var ORPHAN_CONTENT_ITEM = exports.ORPHAN_CONTENT_ITEM = "ORPHAN_CONTENT_ITEM";
	var RESTORE_ORPHANED_CONTENT_ITEM = exports.RESTORE_ORPHANED_CONTENT_ITEM = "RESTORE_ORPHANED_CONTENT_ITEM";
	var MOVE_CONTENT_ITEM = exports.MOVE_CONTENT_ITEM = "MOVE_CONTENT_ITEM";
	var UPDATE_CONTENT_ITEM = exports.UPDATE_CONTENT_ITEM = "UPDATE_CONTENT_ITEM";
	var HIDE_CONTENT_ITEM = exports.HIDE_CONTENT_ITEM = "HIDE_CONTENT_ITEM";
	var SET_CONTENT_ITEMS = exports.SET_CONTENT_ITEMS = "SET_CONTENT_ITEMS";
	
	/** Create a new content item
	 * @param contentParentId
	 * @param relativeToContentId
	 * @param configId
	 * @param contentDefs
	 * @param moveBelow
	 * @return {{type: string, contentParentId: *, relativeToContentId: *, configId: *, contentDefs: *}}
	 */
	function createContentItem(contentParentId, relativeToContentId, configId, contentDefs, moveBelow) {
	  return {
	    type: CREATE_CONTENT_ITEM,
	    contentParentId: contentParentId,
	    relativeToContentId: relativeToContentId,
	    configId: configId,
	    contentDefs: contentDefs,
	    moveBelow: moveBelow
	  };
	}
	
	function deleteContentItem(contentId) {
	  return {
	    type: DELETE_CONTENT_ITEM,
	    contentId: contentId
	  };
	}
	
	function orphanContentItem(contentId) {
	  return {
	    type: ORPHAN_CONTENT_ITEM,
	    contentId: contentId
	  };
	}
	
	function restoreOrphanedContentItem(contentId) {
	  return {
	    type: RESTORE_ORPHANED_CONTENT_ITEM,
	    contentId: contentId
	  };
	}
	
	/**
	 * Moves the specified item to the specified parent, above the specified child.
	 *
	 * @param {string} contentId
	 * @param {string} contentParentId
	 * @param {string} relativeToContentId
	 * @param {boolean} moveBelow
	 */
	function moveContentItem(contentId, contentParentId, relativeToContentId, moveBelow) {
	  return {
	    type: MOVE_CONTENT_ITEM,
	    contentId: contentId,
	    contentParentId: contentParentId,
	    relativeToContentId: relativeToContentId,
	    moveBelow: moveBelow
	  };
	}
	/**
	 * Lazily updates stored state of item. Only updates is data changed, and does not save anything
	 * matching its default value.
	 *
	 * @param {string} contentId
	 * @param {Object} newProps Subset of item props. Will be merged into oldProps below.
	 * @param {Object} oldProps Current calculated props prior to the change.
	 * @param {Object} defaultProps
	 * @returns {{type: string, itemId: *, newProps: *, oldProps: *, defaultProps: *}}
	 */
	function updateContentItem(contentId, newProps, oldProps, defaultProps) {
	  return {
	    type: UPDATE_CONTENT_ITEM,
	    contentId: contentId,
	    newProps: newProps,
	    oldProps: oldProps,
	    defaultProps: defaultProps
	  };
	}
	
	/**
	 * Toggle visibility of a content item
	 * @param contentId
	 * @param {boolean} contentHidden
	 * @return {{type: string, hideItem: boolean}}
	 */
	function hideContentItem(contentId, contentHidden) {
	  return {
	    type: HIDE_CONTENT_ITEM,
	    contentId: contentId,
	    contentHidden: contentHidden
	  };
	}
	
	/**
	 * Set the current contentItem state - used to initialise the editor
	 * @param {Array} content
	 * @returns {{type: string, content: *}}
	 */
	function setContentItems(content) {
	  return {
	    type: SET_CONTENT_ITEMS,
	    content: content
	  };
	}

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getContentState = exports.hasHiddenAncestor = exports.getRootItem = exports.getContentItemChildren = exports.getContentItems = exports.getContentItem = undefined;
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var cleanse = function cleanse(item) {
	  return item === undefined ? undefined : JSON.parse(JSON.stringify(item));
	};
	
	/**
	 * Get the full content item for this ID
	 * @param {string} state
	 * @param {string} contentId
	 * @returns {ContentDefinition}
	 */
	/**
	 * Created by daniel on 23/04/17.
	 */
	var getContentItem = exports.getContentItem = function getContentItem(state, contentId) {
	  var content = cleanse(_.head(_.filter(state.editor.content.present, { contentId: contentId })));
	  if (!content) return undefined;
	  var contentDef = cleanse(_.head(_.filter(state.editor.config.contentDefinitions, { configId: content.configId })));
	  return Object.assign({}, contentDef, content);
	};
	
	//TODO refactor other getters to use this function
	/**
	 * Return all content items matching the given predicate
	 * @param {string} state
	 * @param {Object} predicate - A subset of a content definition to match
	 * @returns {Array.<ContentDefinition>}
	 */
	var getContentItems = exports.getContentItems = function getContentItems(state, predicate) {
	
	  // Set sortorders
	  var content = cleanse(state.editor.content.present);
	
	  var sortIndex = 0;
	  function setSortIndex(item) {
	    item.sortIndex = sortIndex;
	    sortIndex++;
	    var children = _.filter(content, { contentParentId: item.contentId });
	
	    //if (children.length > 0) {
	    children.map(setSortIndex);
	    //}
	  }
	
	  _.filter(content, { contentIsRoot: true }).map(setSortIndex);
	
	  var contentArray = _.sortBy(_.filter(content, predicate), ['sortIndex']);
	
	  return contentArray ? contentArray.map(function (child) {
	    return getContentItem(state, child.contentId);
	  }) : [];
	};
	
	/**
	 * Get the full child content item(s) for this ID
	 * @param state
	 * @param contentId
	 * @returns {Array.<ContentDefinition>}
	 */
	var getContentItemChildren = exports.getContentItemChildren = function getContentItemChildren(state, contentId) {
	  var childArray = cleanse(_.filter(state.editor.content.present, { contentParentId: contentId }));
	  return childArray ? childArray.map(function (child) {
	    return getContentItem(state, child.contentId);
	  }) : [];
	};
	
	/**
	 * Get the template root node
	 * @param state
	 * @returns {ContentDefinition}
	 */
	var getRootItem = exports.getRootItem = function getRootItem(state) {
	  var root = cleanse(_.head(_.filter(state.editor.content.present, { contentIsRoot: true })));
	  return root ? getContentItem(state, root.contentId) : undefined;
	};
	
	/**
	 * Determines whether any of a content items ancestors are hidden
	 * @param state
	 * @param contentId
	 * @return {boolean}
	 */
	var hasHiddenAncestor = exports.hasHiddenAncestor = function hasHiddenAncestor(state, contentId) {
	  var item = getContentItem(state, contentId);
	  if (!item.contentParentId) return false;
	
	  var itemParent = getContentItem(state, item.contentParentId);
	  if (itemParent.contentHidden) {
	    return true;
	  } else {
	    return hasHiddenAncestor(state, itemParent.contentId);
	  }
	};
	
	/**
	 * Get the current state of the editor - typically used for saving as template / email
	 * @param state
	 * @returns {Array}
	 */
	var getContentState = exports.getContentState = function getContentState(state) {
	  return state.editor.content.present;
	};

/***/ },
/* 56 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setUiHoveredContentItem = setUiHoveredContentItem;
	exports.setUiSelectedContentItem = setUiSelectedContentItem;
	exports.setUiDraggedContentItem = setUiDraggedContentItem;
	exports.setUiDropzoneCoords = setUiDropzoneCoords;
	exports.setUiToolboxVisibility = setUiToolboxVisibility;
	exports.setUiToolboxPinned = setUiToolboxPinned;
	exports.setUiToolboxActiveTab = setUiToolboxActiveTab;
	/**
	 * Created by daniel on 23/04/17.
	 */
	
	var SET_UI_HOVERED_CONTENT_ITEM = exports.SET_UI_HOVERED_CONTENT_ITEM = "UI_HOVERED_CONTENT_ITEM";
	var SET_UI_SELECTED_CONTENT_ITEM = exports.SET_UI_SELECTED_CONTENT_ITEM = "UI_SELECTED_CONTENT_ITEM";
	var SET_UI_DRAGGED_CONTENT_ITEM = exports.SET_UI_DRAGGED_CONTENT_ITEM = "SET_UI_DRAGGED_CONTENT_ITEM";
	var SET_UI_DROPZONE_COORDS = exports.SET_UI_DROPZONE_COORDS = "SET_UI_DROPZONE_COORDS";
	var SET_UI_TOOLBOX_VISIBILITY = exports.SET_UI_TOOLBOX_VISIBILITY = "SET_UI_TOOLBOX_VISIBILITY";
	var SET_UI_TOOLBOX_PINNED = exports.SET_UI_TOOLBOX_PINNED = "SET_UI_TOOLBOX_PINNED";
	var SET_UI_TOOLBOX_ACTIVETAB = exports.SET_UI_TOOLBOX_ACTIVETAB = "SET_UI_TOOLBOX_ACTIVETAB";
	
	function setUiHoveredContentItem(contentId) {
	  return {
	    type: SET_UI_HOVERED_CONTENT_ITEM,
	    contentId: contentId
	  };
	}
	
	function setUiSelectedContentItem(contentId) {
	  return {
	    type: SET_UI_SELECTED_CONTENT_ITEM,
	    contentId: contentId
	  };
	}
	
	/**
	 * Set the current element being dragged
	 * @param {ContentDefinition} contentItem
	 * @return {{type: string, contentItem: *}}
	 */
	function setUiDraggedContentItem(contentItem) {
	  return {
	    type: SET_UI_DRAGGED_CONTENT_ITEM,
	    contentItem: contentItem
	  };
	}
	
	function setUiDropzoneCoords(coords) {
	  return {
	    type: SET_UI_DROPZONE_COORDS,
	    coords: coords
	  };
	}
	
	function setUiToolboxVisibility(visible) {
	  return {
	    type: SET_UI_TOOLBOX_VISIBILITY,
	    visible: visible
	  };
	}
	function setUiToolboxPinned(pinned) {
	  return {
	    type: SET_UI_TOOLBOX_PINNED,
	    pinned: pinned
	  };
	}
	
	function setUiToolboxActiveTab(tab) {
	  return {
	    type: SET_UI_TOOLBOX_ACTIVETAB,
	    tab: tab
	  };
	}

/***/ },
/* 57 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by daniel on 23/04/17.
	 */
	
	var getUiHoveredItem = exports.getUiHoveredItem = function getUiHoveredItem(state) {
	  return state.editor.ui.hoveredItem;
	};
	var getUiSelectedItem = exports.getUiSelectedItem = function getUiSelectedItem(state) {
	  return state.editor.ui.selectedItem;
	};
	var getUiItemCoords = exports.getUiItemCoords = function getUiItemCoords(itemId, relativeTo) {
	  var item = document.getElementById(itemId);
	  if (!item) return null;
	  var thisRect = item.getBoundingClientRect();
	
	  var relative = document.getElementById(relativeTo);
	  if (!relative) return null;
	  var relativeRect = relative.getBoundingClientRect();
	  return {
	    top: thisRect.top - relativeRect.top,
	    right: thisRect.right - relativeRect.left,
	    bottom: thisRect.bottom - relativeRect.top,
	    left: thisRect.left - relativeRect.left,
	    width: thisRect.right - thisRect.left,
	    height: thisRect.bottom - thisRect.top
	  };
	};
	/**
	 *
	 * @param state
	 * @returns {ContentDefinition|null}
	 */
	var getUiDraggedItem = exports.getUiDraggedItem = function getUiDraggedItem(state) {
	  return state.editor.ui.draggedItem;
	};
	var getUiDropzoneCoords = exports.getUiDropzoneCoords = function getUiDropzoneCoords(state) {
	  return state.editor.ui.dropzoneCoords;
	};
	var getUiToolboxVisibility = exports.getUiToolboxVisibility = function getUiToolboxVisibility(state) {
	  return state.editor.ui.toolboxVisible;
	};
	var getUiToolboxPinned = exports.getUiToolboxPinned = function getUiToolboxPinned(state) {
	  return state.editor.ui.toolboxPinned;
	};
	
	var getUiToolboxActiveTab = exports.getUiToolboxActiveTab = function getUiToolboxActiveTab(state) {
	  return state.editor.ui.toolboxTab;
	};

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72);
	module.exports = function (it) {
	  if (!isObject(it)) throw TypeError(it + ' is not an object!');
	  return it;
	};


/***/ },
/* 59 */
/***/ function(module, exports, __webpack_require__) {

	// Thank's IE8 for his funny defineProperty
	module.exports = !__webpack_require__(70)(function () {
	  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 60 */
/***/ function(module, exports) {

	var hasOwnProperty = {}.hasOwnProperty;
	module.exports = function (it, key) {
	  return hasOwnProperty.call(it, key);
	};


/***/ },
/* 61 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsNative = __webpack_require__(668),
	    getValue = __webpack_require__(700);
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	module.exports = getNative;


/***/ },
/* 62 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return value != null && typeof value == 'object';
	}
	
	module.exports = isObjectLike;


/***/ },
/* 63 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var red50 = exports.red50 = '#ffebee';
	var red100 = exports.red100 = '#ffcdd2';
	var red200 = exports.red200 = '#ef9a9a';
	var red300 = exports.red300 = '#e57373';
	var red400 = exports.red400 = '#ef5350';
	var red500 = exports.red500 = '#f44336';
	var red600 = exports.red600 = '#e53935';
	var red700 = exports.red700 = '#d32f2f';
	var red800 = exports.red800 = '#c62828';
	var red900 = exports.red900 = '#b71c1c';
	var redA100 = exports.redA100 = '#ff8a80';
	var redA200 = exports.redA200 = '#ff5252';
	var redA400 = exports.redA400 = '#ff1744';
	var redA700 = exports.redA700 = '#d50000';
	
	var pink50 = exports.pink50 = '#fce4ec';
	var pink100 = exports.pink100 = '#f8bbd0';
	var pink200 = exports.pink200 = '#f48fb1';
	var pink300 = exports.pink300 = '#f06292';
	var pink400 = exports.pink400 = '#ec407a';
	var pink500 = exports.pink500 = '#e91e63';
	var pink600 = exports.pink600 = '#d81b60';
	var pink700 = exports.pink700 = '#c2185b';
	var pink800 = exports.pink800 = '#ad1457';
	var pink900 = exports.pink900 = '#880e4f';
	var pinkA100 = exports.pinkA100 = '#ff80ab';
	var pinkA200 = exports.pinkA200 = '#ff4081';
	var pinkA400 = exports.pinkA400 = '#f50057';
	var pinkA700 = exports.pinkA700 = '#c51162';
	
	var purple50 = exports.purple50 = '#f3e5f5';
	var purple100 = exports.purple100 = '#e1bee7';
	var purple200 = exports.purple200 = '#ce93d8';
	var purple300 = exports.purple300 = '#ba68c8';
	var purple400 = exports.purple400 = '#ab47bc';
	var purple500 = exports.purple500 = '#9c27b0';
	var purple600 = exports.purple600 = '#8e24aa';
	var purple700 = exports.purple700 = '#7b1fa2';
	var purple800 = exports.purple800 = '#6a1b9a';
	var purple900 = exports.purple900 = '#4a148c';
	var purpleA100 = exports.purpleA100 = '#ea80fc';
	var purpleA200 = exports.purpleA200 = '#e040fb';
	var purpleA400 = exports.purpleA400 = '#d500f9';
	var purpleA700 = exports.purpleA700 = '#aa00ff';
	
	var deepPurple50 = exports.deepPurple50 = '#ede7f6';
	var deepPurple100 = exports.deepPurple100 = '#d1c4e9';
	var deepPurple200 = exports.deepPurple200 = '#b39ddb';
	var deepPurple300 = exports.deepPurple300 = '#9575cd';
	var deepPurple400 = exports.deepPurple400 = '#7e57c2';
	var deepPurple500 = exports.deepPurple500 = '#673ab7';
	var deepPurple600 = exports.deepPurple600 = '#5e35b1';
	var deepPurple700 = exports.deepPurple700 = '#512da8';
	var deepPurple800 = exports.deepPurple800 = '#4527a0';
	var deepPurple900 = exports.deepPurple900 = '#311b92';
	var deepPurpleA100 = exports.deepPurpleA100 = '#b388ff';
	var deepPurpleA200 = exports.deepPurpleA200 = '#7c4dff';
	var deepPurpleA400 = exports.deepPurpleA400 = '#651fff';
	var deepPurpleA700 = exports.deepPurpleA700 = '#6200ea';
	
	var indigo50 = exports.indigo50 = '#e8eaf6';
	var indigo100 = exports.indigo100 = '#c5cae9';
	var indigo200 = exports.indigo200 = '#9fa8da';
	var indigo300 = exports.indigo300 = '#7986cb';
	var indigo400 = exports.indigo400 = '#5c6bc0';
	var indigo500 = exports.indigo500 = '#3f51b5';
	var indigo600 = exports.indigo600 = '#3949ab';
	var indigo700 = exports.indigo700 = '#303f9f';
	var indigo800 = exports.indigo800 = '#283593';
	var indigo900 = exports.indigo900 = '#1a237e';
	var indigoA100 = exports.indigoA100 = '#8c9eff';
	var indigoA200 = exports.indigoA200 = '#536dfe';
	var indigoA400 = exports.indigoA400 = '#3d5afe';
	var indigoA700 = exports.indigoA700 = '#304ffe';
	
	var blue50 = exports.blue50 = '#e3f2fd';
	var blue100 = exports.blue100 = '#bbdefb';
	var blue200 = exports.blue200 = '#90caf9';
	var blue300 = exports.blue300 = '#64b5f6';
	var blue400 = exports.blue400 = '#42a5f5';
	var blue500 = exports.blue500 = '#2196f3';
	var blue600 = exports.blue600 = '#1e88e5';
	var blue700 = exports.blue700 = '#1976d2';
	var blue800 = exports.blue800 = '#1565c0';
	var blue900 = exports.blue900 = '#0d47a1';
	var blueA100 = exports.blueA100 = '#82b1ff';
	var blueA200 = exports.blueA200 = '#448aff';
	var blueA400 = exports.blueA400 = '#2979ff';
	var blueA700 = exports.blueA700 = '#2962ff';
	
	var lightBlue50 = exports.lightBlue50 = '#e1f5fe';
	var lightBlue100 = exports.lightBlue100 = '#b3e5fc';
	var lightBlue200 = exports.lightBlue200 = '#81d4fa';
	var lightBlue300 = exports.lightBlue300 = '#4fc3f7';
	var lightBlue400 = exports.lightBlue400 = '#29b6f6';
	var lightBlue500 = exports.lightBlue500 = '#03a9f4';
	var lightBlue600 = exports.lightBlue600 = '#039be5';
	var lightBlue700 = exports.lightBlue700 = '#0288d1';
	var lightBlue800 = exports.lightBlue800 = '#0277bd';
	var lightBlue900 = exports.lightBlue900 = '#01579b';
	var lightBlueA100 = exports.lightBlueA100 = '#80d8ff';
	var lightBlueA200 = exports.lightBlueA200 = '#40c4ff';
	var lightBlueA400 = exports.lightBlueA400 = '#00b0ff';
	var lightBlueA700 = exports.lightBlueA700 = '#0091ea';
	
	var cyan50 = exports.cyan50 = '#e0f7fa';
	var cyan100 = exports.cyan100 = '#b2ebf2';
	var cyan200 = exports.cyan200 = '#80deea';
	var cyan300 = exports.cyan300 = '#4dd0e1';
	var cyan400 = exports.cyan400 = '#26c6da';
	var cyan500 = exports.cyan500 = '#00bcd4';
	var cyan600 = exports.cyan600 = '#00acc1';
	var cyan700 = exports.cyan700 = '#0097a7';
	var cyan800 = exports.cyan800 = '#00838f';
	var cyan900 = exports.cyan900 = '#006064';
	var cyanA100 = exports.cyanA100 = '#84ffff';
	var cyanA200 = exports.cyanA200 = '#18ffff';
	var cyanA400 = exports.cyanA400 = '#00e5ff';
	var cyanA700 = exports.cyanA700 = '#00b8d4';
	
	var teal50 = exports.teal50 = '#e0f2f1';
	var teal100 = exports.teal100 = '#b2dfdb';
	var teal200 = exports.teal200 = '#80cbc4';
	var teal300 = exports.teal300 = '#4db6ac';
	var teal400 = exports.teal400 = '#26a69a';
	var teal500 = exports.teal500 = '#009688';
	var teal600 = exports.teal600 = '#00897b';
	var teal700 = exports.teal700 = '#00796b';
	var teal800 = exports.teal800 = '#00695c';
	var teal900 = exports.teal900 = '#004d40';
	var tealA100 = exports.tealA100 = '#a7ffeb';
	var tealA200 = exports.tealA200 = '#64ffda';
	var tealA400 = exports.tealA400 = '#1de9b6';
	var tealA700 = exports.tealA700 = '#00bfa5';
	
	var green50 = exports.green50 = '#e8f5e9';
	var green100 = exports.green100 = '#c8e6c9';
	var green200 = exports.green200 = '#a5d6a7';
	var green300 = exports.green300 = '#81c784';
	var green400 = exports.green400 = '#66bb6a';
	var green500 = exports.green500 = '#4caf50';
	var green600 = exports.green600 = '#43a047';
	var green700 = exports.green700 = '#388e3c';
	var green800 = exports.green800 = '#2e7d32';
	var green900 = exports.green900 = '#1b5e20';
	var greenA100 = exports.greenA100 = '#b9f6ca';
	var greenA200 = exports.greenA200 = '#69f0ae';
	var greenA400 = exports.greenA400 = '#00e676';
	var greenA700 = exports.greenA700 = '#00c853';
	
	var lightGreen50 = exports.lightGreen50 = '#f1f8e9';
	var lightGreen100 = exports.lightGreen100 = '#dcedc8';
	var lightGreen200 = exports.lightGreen200 = '#c5e1a5';
	var lightGreen300 = exports.lightGreen300 = '#aed581';
	var lightGreen400 = exports.lightGreen400 = '#9ccc65';
	var lightGreen500 = exports.lightGreen500 = '#8bc34a';
	var lightGreen600 = exports.lightGreen600 = '#7cb342';
	var lightGreen700 = exports.lightGreen700 = '#689f38';
	var lightGreen800 = exports.lightGreen800 = '#558b2f';
	var lightGreen900 = exports.lightGreen900 = '#33691e';
	var lightGreenA100 = exports.lightGreenA100 = '#ccff90';
	var lightGreenA200 = exports.lightGreenA200 = '#b2ff59';
	var lightGreenA400 = exports.lightGreenA400 = '#76ff03';
	var lightGreenA700 = exports.lightGreenA700 = '#64dd17';
	
	var lime50 = exports.lime50 = '#f9fbe7';
	var lime100 = exports.lime100 = '#f0f4c3';
	var lime200 = exports.lime200 = '#e6ee9c';
	var lime300 = exports.lime300 = '#dce775';
	var lime400 = exports.lime400 = '#d4e157';
	var lime500 = exports.lime500 = '#cddc39';
	var lime600 = exports.lime600 = '#c0ca33';
	var lime700 = exports.lime700 = '#afb42b';
	var lime800 = exports.lime800 = '#9e9d24';
	var lime900 = exports.lime900 = '#827717';
	var limeA100 = exports.limeA100 = '#f4ff81';
	var limeA200 = exports.limeA200 = '#eeff41';
	var limeA400 = exports.limeA400 = '#c6ff00';
	var limeA700 = exports.limeA700 = '#aeea00';
	
	var yellow50 = exports.yellow50 = '#fffde7';
	var yellow100 = exports.yellow100 = '#fff9c4';
	var yellow200 = exports.yellow200 = '#fff59d';
	var yellow300 = exports.yellow300 = '#fff176';
	var yellow400 = exports.yellow400 = '#ffee58';
	var yellow500 = exports.yellow500 = '#ffeb3b';
	var yellow600 = exports.yellow600 = '#fdd835';
	var yellow700 = exports.yellow700 = '#fbc02d';
	var yellow800 = exports.yellow800 = '#f9a825';
	var yellow900 = exports.yellow900 = '#f57f17';
	var yellowA100 = exports.yellowA100 = '#ffff8d';
	var yellowA200 = exports.yellowA200 = '#ffff00';
	var yellowA400 = exports.yellowA400 = '#ffea00';
	var yellowA700 = exports.yellowA700 = '#ffd600';
	
	var amber50 = exports.amber50 = '#fff8e1';
	var amber100 = exports.amber100 = '#ffecb3';
	var amber200 = exports.amber200 = '#ffe082';
	var amber300 = exports.amber300 = '#ffd54f';
	var amber400 = exports.amber400 = '#ffca28';
	var amber500 = exports.amber500 = '#ffc107';
	var amber600 = exports.amber600 = '#ffb300';
	var amber700 = exports.amber700 = '#ffa000';
	var amber800 = exports.amber800 = '#ff8f00';
	var amber900 = exports.amber900 = '#ff6f00';
	var amberA100 = exports.amberA100 = '#ffe57f';
	var amberA200 = exports.amberA200 = '#ffd740';
	var amberA400 = exports.amberA400 = '#ffc400';
	var amberA700 = exports.amberA700 = '#ffab00';
	
	var orange50 = exports.orange50 = '#fff3e0';
	var orange100 = exports.orange100 = '#ffe0b2';
	var orange200 = exports.orange200 = '#ffcc80';
	var orange300 = exports.orange300 = '#ffb74d';
	var orange400 = exports.orange400 = '#ffa726';
	var orange500 = exports.orange500 = '#ff9800';
	var orange600 = exports.orange600 = '#fb8c00';
	var orange700 = exports.orange700 = '#f57c00';
	var orange800 = exports.orange800 = '#ef6c00';
	var orange900 = exports.orange900 = '#e65100';
	var orangeA100 = exports.orangeA100 = '#ffd180';
	var orangeA200 = exports.orangeA200 = '#ffab40';
	var orangeA400 = exports.orangeA400 = '#ff9100';
	var orangeA700 = exports.orangeA700 = '#ff6d00';
	
	var deepOrange50 = exports.deepOrange50 = '#fbe9e7';
	var deepOrange100 = exports.deepOrange100 = '#ffccbc';
	var deepOrange200 = exports.deepOrange200 = '#ffab91';
	var deepOrange300 = exports.deepOrange300 = '#ff8a65';
	var deepOrange400 = exports.deepOrange400 = '#ff7043';
	var deepOrange500 = exports.deepOrange500 = '#ff5722';
	var deepOrange600 = exports.deepOrange600 = '#f4511e';
	var deepOrange700 = exports.deepOrange700 = '#e64a19';
	var deepOrange800 = exports.deepOrange800 = '#d84315';
	var deepOrange900 = exports.deepOrange900 = '#bf360c';
	var deepOrangeA100 = exports.deepOrangeA100 = '#ff9e80';
	var deepOrangeA200 = exports.deepOrangeA200 = '#ff6e40';
	var deepOrangeA400 = exports.deepOrangeA400 = '#ff3d00';
	var deepOrangeA700 = exports.deepOrangeA700 = '#dd2c00';
	
	var brown50 = exports.brown50 = '#efebe9';
	var brown100 = exports.brown100 = '#d7ccc8';
	var brown200 = exports.brown200 = '#bcaaa4';
	var brown300 = exports.brown300 = '#a1887f';
	var brown400 = exports.brown400 = '#8d6e63';
	var brown500 = exports.brown500 = '#795548';
	var brown600 = exports.brown600 = '#6d4c41';
	var brown700 = exports.brown700 = '#5d4037';
	var brown800 = exports.brown800 = '#4e342e';
	var brown900 = exports.brown900 = '#3e2723';
	
	var blueGrey50 = exports.blueGrey50 = '#eceff1';
	var blueGrey100 = exports.blueGrey100 = '#cfd8dc';
	var blueGrey200 = exports.blueGrey200 = '#b0bec5';
	var blueGrey300 = exports.blueGrey300 = '#90a4ae';
	var blueGrey400 = exports.blueGrey400 = '#78909c';
	var blueGrey500 = exports.blueGrey500 = '#607d8b';
	var blueGrey600 = exports.blueGrey600 = '#546e7a';
	var blueGrey700 = exports.blueGrey700 = '#455a64';
	var blueGrey800 = exports.blueGrey800 = '#37474f';
	var blueGrey900 = exports.blueGrey900 = '#263238';
	
	var grey50 = exports.grey50 = '#fafafa';
	var grey100 = exports.grey100 = '#f5f5f5';
	var grey200 = exports.grey200 = '#eeeeee';
	var grey300 = exports.grey300 = '#e0e0e0';
	var grey400 = exports.grey400 = '#bdbdbd';
	var grey500 = exports.grey500 = '#9e9e9e';
	var grey600 = exports.grey600 = '#757575';
	var grey700 = exports.grey700 = '#616161';
	var grey800 = exports.grey800 = '#424242';
	var grey900 = exports.grey900 = '#212121';
	
	var black = exports.black = '#000000';
	var white = exports.white = '#ffffff';
	
	var transparent = exports.transparent = 'rgba(0, 0, 0, 0)';
	var fullBlack = exports.fullBlack = 'rgba(0, 0, 0, 1)';
	var darkBlack = exports.darkBlack = 'rgba(0, 0, 0, 0.87)';
	var lightBlack = exports.lightBlack = 'rgba(0, 0, 0, 0.54)';
	var minBlack = exports.minBlack = 'rgba(0, 0, 0, 0.26)';
	var faintBlack = exports.faintBlack = 'rgba(0, 0, 0, 0.12)';
	var fullWhite = exports.fullWhite = 'rgba(255, 255, 255, 1)';
	var darkWhite = exports.darkWhite = 'rgba(255, 255, 255, 0.87)';
	var lightWhite = exports.lightWhite = 'rgba(255, 255, 255, 0.54)';

/***/ },
/* 64 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  set: function set(style, key, value) {
	    style[key] = value;
	  }
	};

/***/ },
/* 65 */
/***/ function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ },
/* 66 */
[2035, 17],
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a duplex stream is just a stream that is both readable and writable.
	// Since JS doesn't have multiple prototypal inheritance, this class
	// prototypally inherits from Readable, and then parasitically from
	// Writable.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(153);
	/*</replacement>*/
	
	/*<replacement>*/
	var objectKeys = Object.keys || function (obj) {
	  var keys = [];
	  for (var key in obj) {
	    keys.push(key);
	  }return keys;
	};
	/*</replacement>*/
	
	module.exports = Duplex;
	
	/*<replacement>*/
	var util = __webpack_require__(103);
	util.inherits = __webpack_require__(38);
	/*</replacement>*/
	
	var Readable = __webpack_require__(428);
	var Writable = __webpack_require__(245);
	
	util.inherits(Duplex, Readable);
	
	var keys = objectKeys(Writable.prototype);
	for (var v = 0; v < keys.length; v++) {
	  var method = keys[v];
	  if (!Duplex.prototype[method]) Duplex.prototype[method] = Writable.prototype[method];
	}
	
	function Duplex(options) {
	  if (!(this instanceof Duplex)) return new Duplex(options);
	
	  Readable.call(this, options);
	  Writable.call(this, options);
	
	  if (options && options.readable === false) this.readable = false;
	
	  if (options && options.writable === false) this.writable = false;
	
	  this.allowHalfOpen = true;
	  if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
	
	  this.once('end', onend);
	}
	
	// the no-half-open enforcer
	function onend() {
	  // if we allow half-open state, or if the writable side ended,
	  // then we're ok.
	  if (this.allowHalfOpen || this._writableState.ended) return;
	
	  // no more data can be written.
	  // But allow more writes to happen in this tick.
	  processNextTick(onEndNT, this);
	}
	
	function onEndNT(self) {
	  self.end();
	}
	
	Object.defineProperty(Duplex.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed && this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (this._readableState === undefined || this._writableState === undefined) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	    this._writableState.destroyed = value;
	  }
	});
	
	Duplex.prototype._destroy = function (err, cb) {
	  this.push(null);
	  this.end();
	
	  processNextTick(cb, err);
	};
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _shallowEqual = __webpack_require__(105);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _shallowEqual2.default;

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _iterator = __webpack_require__(495);
	
	var _iterator2 = _interopRequireDefault(_iterator);
	
	var _symbol = __webpack_require__(494);
	
	var _symbol2 = _interopRequireDefault(_symbol);
	
	var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
	  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
	} : function (obj) {
	  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
	};

/***/ },
/* 70 */
/***/ function(module, exports) {

	module.exports = function (exec) {
	  try {
	    return !!exec();
	  } catch (e) {
	    return true;
	  }
	};


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(49);
	var createDesc = __webpack_require__(101);
	module.exports = __webpack_require__(59) ? function (object, key, value) {
	  return dP.f(object, key, createDesc(1, value));
	} : function (object, key, value) {
	  object[key] = value;
	  return object;
	};


/***/ },
/* 72 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  return typeof it === 'object' ? it !== null : typeof it === 'function';
	};


/***/ },
/* 73 */
/***/ function(module, exports) {

	module.exports = {};


/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	// to indexed object, toObject with fallback for non-array-like ES3 strings
	var IObject = __webpack_require__(259);
	var defined = __webpack_require__(169);
	module.exports = function (it) {
	  return IObject(defined(it));
	};


/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	var DomUtils = module.exports;
	
	[
		__webpack_require__(560),
		__webpack_require__(561),
		__webpack_require__(558),
		__webpack_require__(559),
		__webpack_require__(557),
		__webpack_require__(556)
	].forEach(function(ext){
		Object.keys(ext).forEach(function(key){
			DomUtils[key] = ext[key].bind(DomUtils);
		});
	});


/***/ },
/* 76 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var addLeadingSlash = exports.addLeadingSlash = function addLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path : '/' + path;
	};
	
	var stripLeadingSlash = exports.stripLeadingSlash = function stripLeadingSlash(path) {
	  return path.charAt(0) === '/' ? path.substr(1) : path;
	};
	
	var hasBasename = exports.hasBasename = function hasBasename(path, prefix) {
	  return new RegExp('^' + prefix + '(\\/|\\?|#|$)', 'i').test(path);
	};
	
	var stripBasename = exports.stripBasename = function stripBasename(path, prefix) {
	  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
	};
	
	var stripTrailingSlash = exports.stripTrailingSlash = function stripTrailingSlash(path) {
	  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
	};
	
	var parsePath = exports.parsePath = function parsePath(path) {
	  var pathname = path || '/';
	  var search = '';
	  var hash = '';
	
	  var hashIndex = pathname.indexOf('#');
	  if (hashIndex !== -1) {
	    hash = pathname.substr(hashIndex);
	    pathname = pathname.substr(0, hashIndex);
	  }
	
	  var searchIndex = pathname.indexOf('?');
	  if (searchIndex !== -1) {
	    search = pathname.substr(searchIndex);
	    pathname = pathname.substr(0, searchIndex);
	  }
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var createPath = exports.createPath = function createPath(location) {
	  var pathname = location.pathname,
	      search = location.search,
	      hash = location.hash;
	
	
	  var path = pathname || '/';
	
	  if (search && search !== '?') path += search.charAt(0) === '?' ? search : '?' + search;
	
	  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : '#' + hash;
	
	  return path;
	};

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	var Parser = __webpack_require__(281),
	    DomHandler = __webpack_require__(554);
	
	function defineProp(name, value){
		delete module.exports[name];
		module.exports[name] = value;
		return value;
	}
	
	module.exports = {
		Parser: Parser,
		Tokenizer: __webpack_require__(282),
		ElementType: __webpack_require__(104),
		DomHandler: DomHandler,
		get FeedHandler(){
			return defineProp("FeedHandler", __webpack_require__(588));
		},
		get Stream(){
			return defineProp("Stream", __webpack_require__(590));
		},
		get WritableStream(){
			return defineProp("WritableStream", __webpack_require__(283));
		},
		get ProxyHandler(){
			return defineProp("ProxyHandler", __webpack_require__(589));
		},
		get DomUtils(){
			return defineProp("DomUtils", __webpack_require__(75));
		},
		get CollectingHandler(){
			return defineProp("CollectingHandler", __webpack_require__(587));
		},
		// For legacy support
		DefaultHandler: DomHandler,
		get RssHandler(){
			return defineProp("RssHandler", this.FeedHandler);
		},
		//helper methods
		parseDOM: function(data, options){
			var handler = new DomHandler(options);
			new Parser(handler, options).end(data);
			return handler.dom;
		},
		parseFeed: function(feed, options){
			var handler = new module.exports.FeedHandler(options);
			new Parser(handler, options).end(feed);
			return handler.dom;
		},
		createDomStream: function(cb, options, elementCb){
			var handler = new DomHandler(cb, options, elementCb);
			return new Parser(handler, options);
		},
		// List of all events that the parser emits
		EVENTS: { /* Format: eventname: number of arguments */
			attribute: 2,
			cdatastart: 0,
			cdataend: 0,
			text: 1,
			processinginstruction: 2,
			comment: 1,
			commentend: 0,
			closetag: 1,
			opentag: 2,
			opentagname: 1,
			error: 1,
			end: 0
		}
	};


/***/ },
/* 78 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedValue;
	function getPrefixedValue(prefixedValue, value, keepUnprefixed) {
	  if (keepUnprefixed) {
	    return [prefixedValue, value];
	  }
	  return prefixedValue;
	}
	module.exports = exports["default"];

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(41);
	
	/** Built-in value references. */
	var Symbol = root.Symbol;
	
	module.exports = Symbol;


/***/ },
/* 80 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(197),
	    keys = __webpack_require__(30);
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	module.exports = baseForOwn;


/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(79),
	    getRawTag = __webpack_require__(699),
	    objectToString = __webpack_require__(726);
	
	/** `Object#toString` result references. */
	var nullTag = '[object Null]',
	    undefinedTag = '[object Undefined]';
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * The base implementation of `getTag` without fallbacks for buggy environments.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  if (value == null) {
	    return value === undefined ? undefinedTag : nullTag;
	  }
	  return (symToStringTag && symToStringTag in Object(value))
	    ? getRawTag(value)
	    : objectToString(value);
	}
	
	module.exports = baseGetTag;


/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(109);
	
	/**
	 * Casts `value` to `identity` if it's not a function.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Function} Returns cast function.
	 */
	function castFunction(value) {
	  return typeof value == 'function' ? value : identity;
	}
	
	module.exports = castFunction;


/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	var baseRest = __webpack_require__(139),
	    isIterateeCall = __webpack_require__(709);
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	module.exports = createAssigner;


/***/ },
/* 84 */
/***/ function(module, exports) {

	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	module.exports = eq;


/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(81),
	    isObject = __webpack_require__(29);
	
	/** `Object#toString` result references. */
	var asyncTag = '[object AsyncFunction]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    proxyTag = '[object Proxy]';
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  if (!isObject(value)) {
	    return false;
	  }
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 9 which returns 'object' for typed arrays and other constructors.
	  var tag = baseGetTag(value);
	  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
	}
	
	module.exports = isFunction;


/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _IconButton = __webpack_require__(821);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _IconButton2.default;

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(44);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _RenderToLayer = __webpack_require__(372);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _lodash = __webpack_require__(647);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _PopoverAnimationDefault = __webpack_require__(830);
	
	var _PopoverAnimationDefault2 = _interopRequireDefault(_PopoverAnimationDefault);
	
	var _iOSHelpers = __webpack_require__(1839);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'none'
	  }
	};
	
	var Popover = function (_Component) {
	  (0, _inherits3.default)(Popover, _Component);
	
	  function Popover(props, context) {
	    (0, _classCallCheck3.default)(this, Popover);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Popover.__proto__ || (0, _getPrototypeOf2.default)(Popover)).call(this, props, context));
	
	    _this.timeout = null;
	
	    _this.renderLayer = function () {
	      var _this$props = _this.props,
	          animated = _this$props.animated,
	          animation = _this$props.animation,
	          anchorEl = _this$props.anchorEl,
	          anchorOrigin = _this$props.anchorOrigin,
	          autoCloseWhenOffScreen = _this$props.autoCloseWhenOffScreen,
	          canAutoPosition = _this$props.canAutoPosition,
	          children = _this$props.children,
	          onRequestClose = _this$props.onRequestClose,
	          style = _this$props.style,
	          targetOrigin = _this$props.targetOrigin,
	          useLayerForClickAway = _this$props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_this$props, ['animated', 'animation', 'anchorEl', 'anchorOrigin', 'autoCloseWhenOffScreen', 'canAutoPosition', 'children', 'onRequestClose', 'style', 'targetOrigin', 'useLayerForClickAway']);
	
	
	      var styleRoot = style;
	
	      if (!animated) {
	        styleRoot = {
	          position: 'fixed',
	          zIndex: _this.context.muiTheme.zIndex.popover
	        };
	
	        if (!_this.state.open) {
	          return null;
	        }
	
	        return _react2.default.createElement(
	          _Paper2.default,
	          (0, _extends3.default)({ style: (0, _simpleAssign2.default)(styleRoot, style) }, other),
	          children
	        );
	      }
	
	      var Animation = animation || _PopoverAnimationDefault2.default;
	
	      return _react2.default.createElement(
	        Animation,
	        (0, _extends3.default)({
	          targetOrigin: targetOrigin,
	          style: styleRoot
	        }, other, {
	          open: _this.state.open && !_this.state.closing
	        }),
	        children
	      );
	    };
	
	    _this.componentClickAway = function (event) {
	      event.preventDefault();
	      _this.requestClose('clickAway');
	    };
	
	    _this.setPlacement = function (scrolling) {
	      if (!_this.state.open) {
	        return;
	      }
	
	      if (!_this.refs.layer.getLayer()) {
	        return;
	      }
	
	      var targetEl = _this.refs.layer.getLayer().children[0];
	      if (!targetEl) {
	        return;
	      }
	
	      var _this$props2 = _this.props,
	          targetOrigin = _this$props2.targetOrigin,
	          anchorOrigin = _this$props2.anchorOrigin;
	
	      var anchorEl = _this.props.anchorEl || _this.anchorEl;
	
	      var anchor = _this.getAnchorPosition(anchorEl);
	      var target = _this.getTargetPosition(targetEl);
	
	      var targetPosition = {
	        top: anchor[anchorOrigin.vertical] - target[targetOrigin.vertical],
	        left: anchor[anchorOrigin.horizontal] - target[targetOrigin.horizontal]
	      };
	
	      if (scrolling && _this.props.autoCloseWhenOffScreen) {
	        _this.autoCloseWhenOffScreen(anchor);
	      }
	
	      if (_this.props.canAutoPosition) {
	        target = _this.getTargetPosition(targetEl); // update as height may have changed
	        targetPosition = _this.applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition);
	      }
	
	      targetEl.style.top = Math.max(0, targetPosition.top) + 'px';
	      targetEl.style.left = Math.max(0, targetPosition.left) + 'px';
	      targetEl.style.maxHeight = window.innerHeight + 'px';
	    };
	
	    _this.handleResize = (0, _lodash2.default)(_this.setPlacement, 100);
	    _this.handleScroll = (0, _lodash2.default)(_this.setPlacement.bind(_this, true), 50);
	
	    _this.state = {
	      open: props.open,
	      closing: false
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(Popover, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (nextProps.open === this.props.open) {
	        return;
	      }
	
	      if (nextProps.open) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	        this.anchorEl = nextProps.anchorEl || this.props.anchorEl;
	        this.setState({
	          open: true,
	          closing: false
	        });
	      } else {
	        if (nextProps.animated) {
	          if (this.timeout !== null) return;
	          this.setState({ closing: true });
	          this.timeout = setTimeout(function () {
	            _this2.setState({
	              open: false
	            }, function () {
	              _this2.timeout = null;
	            });
	          }, 500);
	        } else {
	          this.setState({
	            open: false
	          });
	        }
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setPlacement();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.handleResize.cancel();
	      this.handleScroll.cancel();
	
	      if (this.timeout) {
	        clearTimeout(this.timeout);
	        this.timeout = null;
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(reason) {
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(reason);
	      }
	    }
	  }, {
	    key: 'getAnchorPosition',
	    value: function getAnchorPosition(el) {
	      if (!el) {
	        el = _reactDom2.default.findDOMNode(this);
	      }
	
	      var rect = el.getBoundingClientRect();
	      var a = {
	        top: rect.top,
	        left: rect.left,
	        width: el.offsetWidth,
	        height: el.offsetHeight
	      };
	
	      a.right = rect.right || a.left + a.width;
	
	      // The fixed positioning isn't respected on iOS when an input is focused.
	      // We need to compute the position from the top of the page and not the viewport.
	      if ((0, _iOSHelpers.isIOS)() && document.activeElement.tagName === 'INPUT') {
	        a.bottom = (0, _iOSHelpers.getOffsetTop)(el) + a.height;
	      } else {
	        a.bottom = rect.bottom || a.top + a.height;
	      }
	      a.middle = a.left + (a.right - a.left) / 2;
	      a.center = a.top + (a.bottom - a.top) / 2;
	
	      return a;
	    }
	  }, {
	    key: 'getTargetPosition',
	    value: function getTargetPosition(targetEl) {
	      return {
	        top: 0,
	        center: targetEl.offsetHeight / 2,
	        bottom: targetEl.offsetHeight,
	        left: 0,
	        middle: targetEl.offsetWidth / 2,
	        right: targetEl.offsetWidth
	      };
	    }
	  }, {
	    key: 'autoCloseWhenOffScreen',
	    value: function autoCloseWhenOffScreen(anchorPosition) {
	      if (anchorPosition.top < 0 || anchorPosition.top > window.innerHeight || anchorPosition.left < 0 || anchorPosition.left > window.innerWidth) {
	        this.requestClose('offScreen');
	      }
	    }
	  }, {
	    key: 'getOverlapMode',
	    value: function getOverlapMode(anchor, target, median) {
	      if ([anchor, target].indexOf(median) >= 0) return 'auto';
	      if (anchor === target) return 'inclusive';
	      return 'exclusive';
	    }
	  }, {
	    key: 'getPositions',
	    value: function getPositions(anchor, target) {
	      var a = (0, _extends3.default)({}, anchor);
	      var t = (0, _extends3.default)({}, target);
	
	      var positions = {
	        x: ['left', 'right'].filter(function (p) {
	          return p !== t.horizontal;
	        }),
	        y: ['top', 'bottom'].filter(function (p) {
	          return p !== t.vertical;
	        })
	      };
	
	      var overlap = {
	        x: this.getOverlapMode(a.horizontal, t.horizontal, 'middle'),
	        y: this.getOverlapMode(a.vertical, t.vertical, 'center')
	      };
	
	      positions.x.splice(overlap.x === 'auto' ? 0 : 1, 0, 'middle');
	      positions.y.splice(overlap.y === 'auto' ? 0 : 1, 0, 'center');
	
	      if (overlap.y !== 'auto') {
	        a.vertical = a.vertical === 'top' ? 'bottom' : 'top';
	        if (overlap.y === 'inclusive') {
	          t.vertical = t.vertical;
	        }
	      }
	
	      if (overlap.x !== 'auto') {
	        a.horizontal = a.horizontal === 'left' ? 'right' : 'left';
	        if (overlap.y === 'inclusive') {
	          t.horizontal = t.horizontal;
	        }
	      }
	
	      return {
	        positions: positions,
	        anchorPos: a
	      };
	    }
	  }, {
	    key: 'applyAutoPositionIfNeeded',
	    value: function applyAutoPositionIfNeeded(anchor, target, targetOrigin, anchorOrigin, targetPosition) {
	      var _getPositions = this.getPositions(anchorOrigin, targetOrigin),
	          positions = _getPositions.positions,
	          anchorPos = _getPositions.anchorPos;
	
	      if (targetPosition.top < 0 || targetPosition.top + target.bottom > window.innerHeight) {
	        var newTop = anchor[anchorPos.vertical] - target[positions.y[0]];
	        if (newTop + target.bottom <= window.innerHeight) {
	          targetPosition.top = Math.max(0, newTop);
	        } else {
	          newTop = anchor[anchorPos.vertical] - target[positions.y[1]];
	          if (newTop + target.bottom <= window.innerHeight) {
	            targetPosition.top = Math.max(0, newTop);
	          }
	        }
	      }
	
	      if (targetPosition.left < 0 || targetPosition.left + target.right > window.innerWidth) {
	        var newLeft = anchor[anchorPos.horizontal] - target[positions.x[0]];
	        if (newLeft + target.right <= window.innerWidth) {
	          targetPosition.left = Math.max(0, newLeft);
	        } else {
	          newLeft = anchor[anchorPos.horizontal] - target[positions.x[1]];
	          if (newLeft + target.right <= window.innerWidth) {
	            targetPosition.left = Math.max(0, newLeft);
	          }
	        }
	      }
	
	      return targetPosition;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onScroll: this.handleScroll,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(_RenderToLayer2.default, {
	          ref: 'layer',
	          open: this.state.open,
	          componentClickAway: this.componentClickAway,
	          useLayerForClickAway: this.props.useLayerForClickAway,
	          render: this.renderLayer
	        })
	      );
	    }
	  }]);
	  return Popover;
	}(_react.Component);
	
	Popover.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  autoCloseWhenOffScreen: true,
	  canAutoPosition: true,
	  onRequestClose: function onRequestClose() {},
	  open: false,
	  style: {
	    overflowY: 'auto'
	  },
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  useLayerForClickAway: true,
	  zDepth: 1
	};
	Popover.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Popover.propTypes = {
	  /**
	   * This is the DOM element that will be used to set the position of the
	   * popover.
	   */
	  anchorEl: _propTypes2.default.object,
	  /**
	   * This is the point on the anchor where the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it is added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * If true, the popover will hide when the anchor is scrolled off the screen.
	   */
	  autoCloseWhenOffScreen: _propTypes2.default.bool,
	  /**
	   * If true, the popover (potentially) ignores `targetOrigin`
	   * and `anchorOrigin` to make itself fit on screen,
	   * which is useful for mobile devices.
	   */
	  canAutoPosition: _propTypes2.default.bool,
	  /**
	   * The content of the popover.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Callback function fired when the popover is requested to be closed.
	   *
	   * @param {string} reason The reason for the close request. Possibles values
	   * are 'clickAway' and 'offScreen'.
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * If true, the popover is visible.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying
	   * elements, and trigger an `onRequestClose('clickAway')` call.
	   */
	  useLayerForClickAway: _propTypes2.default.bool,
	  /**
	   * The zDepth of the popover.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : void 0;
	exports.default = Popover;

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = __webpack_require__(226);
	var setInnerHTML = __webpack_require__(159);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(234);
	var setTextContent = __webpack_require__(412);
	
	var ELEMENT_NODE_TYPE = 1;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	/**
	 * In IE (8-11) and Edge, appending nodes with no children is dramatically
	 * faster than appending a full subtree, so we essentially queue up the
	 * .appendChild calls here and apply them so each node is added to its parent
	 * before any children are added.
	 *
	 * In other browsers, doing so is slower or neutral compared to the other order
	 * (in Firefox, twice as slow) so we only do this inversion in IE.
	 *
	 * See https://github.com/spicyj/innerhtml-vs-createelement-vs-clonenode.
	 */
	var enableLazy = typeof document !== 'undefined' && typeof document.documentMode === 'number' || typeof navigator !== 'undefined' && typeof navigator.userAgent === 'string' && /\bEdge\/\d/.test(navigator.userAgent);
	
	function insertTreeChildren(tree) {
	  if (!enableLazy) {
	    return;
	  }
	  var node = tree.node;
	  var children = tree.children;
	  if (children.length) {
	    for (var i = 0; i < children.length; i++) {
	      insertTreeBefore(node, children[i], null);
	    }
	  } else if (tree.html != null) {
	    setInnerHTML(node, tree.html);
	  } else if (tree.text != null) {
	    setTextContent(node, tree.text);
	  }
	}
	
	var insertTreeBefore = createMicrosoftUnsafeLocalFunction(function (parentNode, tree, referenceNode) {
	  // DocumentFragments aren't actually part of the DOM after insertion so
	  // appending children won't update the DOM. We need to ensure the fragment
	  // is properly populated first, breaking out of our lazy approach for just
	  // this level. Also, some <object> plugins (like Flash Player) will read
	  // <param> nodes immediately upon insertion into the DOM, so <object>
	  // must also be populated prior to insertion into the DOM.
	  if (tree.node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE || tree.node.nodeType === ELEMENT_NODE_TYPE && tree.node.nodeName.toLowerCase() === 'object' && (tree.node.namespaceURI == null || tree.node.namespaceURI === DOMNamespaces.html)) {
	    insertTreeChildren(tree);
	    parentNode.insertBefore(tree.node, referenceNode);
	  } else {
	    parentNode.insertBefore(tree.node, referenceNode);
	    insertTreeChildren(tree);
	  }
	});
	
	function replaceChildWithTree(oldNode, newTree) {
	  oldNode.parentNode.replaceChild(newTree.node, oldNode);
	  insertTreeChildren(newTree);
	}
	
	function queueChild(parentTree, childTree) {
	  if (enableLazy) {
	    parentTree.children.push(childTree);
	  } else {
	    parentTree.node.appendChild(childTree.node);
	  }
	}
	
	function queueHTML(tree, html) {
	  if (enableLazy) {
	    tree.html = html;
	  } else {
	    setInnerHTML(tree.node, html);
	  }
	}
	
	function queueText(tree, text) {
	  if (enableLazy) {
	    tree.text = text;
	  } else {
	    setTextContent(tree.node, text);
	  }
	}
	
	function toString() {
	  return this.node.nodeName;
	}
	
	function DOMLazyTree(node) {
	  return {
	    node: node,
	    children: [],
	    html: null,
	    text: null,
	    toString: toString
	  };
	}
	
	DOMLazyTree.insertTreeBefore = insertTreeBefore;
	DOMLazyTree.replaceChildWithTree = replaceChildWithTree;
	DOMLazyTree.queueChild = queueChild;
	DOMLazyTree.queueHTML = queueHTML;
	DOMLazyTree.queueText = queueText;
	
	module.exports = DOMLazyTree;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(13);
	
	function checkMask(value, bitmask) {
	  return (value & bitmask) === bitmask;
	}
	
	var DOMPropertyInjection = {
	  /**
	   * Mapping from normalized, camelcased property names to a configuration that
	   * specifies how the associated DOM property should be accessed or rendered.
	   */
	  MUST_USE_PROPERTY: 0x1,
	  HAS_BOOLEAN_VALUE: 0x4,
	  HAS_NUMERIC_VALUE: 0x8,
	  HAS_POSITIVE_NUMERIC_VALUE: 0x10 | 0x8,
	  HAS_OVERLOADED_BOOLEAN_VALUE: 0x20,
	
	  /**
	   * Inject some specialized knowledge about the DOM. This takes a config object
	   * with the following properties:
	   *
	   * isCustomAttribute: function that given an attribute name will return true
	   * if it can be inserted into the DOM verbatim. Useful for data-* or aria-*
	   * attributes where it's impossible to enumerate all of the possible
	   * attribute names,
	   *
	   * Properties: object mapping DOM property name to one of the
	   * DOMPropertyInjection constants or null. If your attribute isn't in here,
	   * it won't get written to the DOM.
	   *
	   * DOMAttributeNames: object mapping React attribute name to the DOM
	   * attribute name. Attribute names not specified use the **lowercase**
	   * normalized name.
	   *
	   * DOMAttributeNamespaces: object mapping React attribute name to the DOM
	   * attribute namespace URL. (Attribute names not specified use no namespace.)
	   *
	   * DOMPropertyNames: similar to DOMAttributeNames but for DOM properties.
	   * Property names not specified use the normalized name.
	   *
	   * DOMMutationMethods: Properties that require special mutation methods. If
	   * `value` is undefined, the mutation method should unset the property.
	   *
	   * @param {object} domPropertyConfig the config as described above.
	   */
	  injectDOMPropertyConfig: function (domPropertyConfig) {
	    var Injection = DOMPropertyInjection;
	    var Properties = domPropertyConfig.Properties || {};
	    var DOMAttributeNamespaces = domPropertyConfig.DOMAttributeNamespaces || {};
	    var DOMAttributeNames = domPropertyConfig.DOMAttributeNames || {};
	    var DOMPropertyNames = domPropertyConfig.DOMPropertyNames || {};
	    var DOMMutationMethods = domPropertyConfig.DOMMutationMethods || {};
	
	    if (domPropertyConfig.isCustomAttribute) {
	      DOMProperty._isCustomAttributeFunctions.push(domPropertyConfig.isCustomAttribute);
	    }
	
	    for (var propName in Properties) {
	      !!DOMProperty.properties.hasOwnProperty(propName) ?  false ? invariant(false, 'injectDOMPropertyConfig(...): You\'re trying to inject DOM property \'%s\' which has already been injected. You may be accidentally injecting the same DOM property config twice, or you may be injecting two configs that have conflicting property names.', propName) : _prodInvariant('48', propName) : void 0;
	
	      var lowerCased = propName.toLowerCase();
	      var propConfig = Properties[propName];
	
	      var propertyInfo = {
	        attributeName: lowerCased,
	        attributeNamespace: null,
	        propertyName: propName,
	        mutationMethod: null,
	
	        mustUseProperty: checkMask(propConfig, Injection.MUST_USE_PROPERTY),
	        hasBooleanValue: checkMask(propConfig, Injection.HAS_BOOLEAN_VALUE),
	        hasNumericValue: checkMask(propConfig, Injection.HAS_NUMERIC_VALUE),
	        hasPositiveNumericValue: checkMask(propConfig, Injection.HAS_POSITIVE_NUMERIC_VALUE),
	        hasOverloadedBooleanValue: checkMask(propConfig, Injection.HAS_OVERLOADED_BOOLEAN_VALUE)
	      };
	      !(propertyInfo.hasBooleanValue + propertyInfo.hasNumericValue + propertyInfo.hasOverloadedBooleanValue <= 1) ?  false ? invariant(false, 'DOMProperty: Value can be one of boolean, overloaded boolean, or numeric value, but not a combination: %s', propName) : _prodInvariant('50', propName) : void 0;
	
	      if (false) {
	        DOMProperty.getPossibleStandardName[lowerCased] = propName;
	      }
	
	      if (DOMAttributeNames.hasOwnProperty(propName)) {
	        var attributeName = DOMAttributeNames[propName];
	        propertyInfo.attributeName = attributeName;
	        if (false) {
	          DOMProperty.getPossibleStandardName[attributeName] = propName;
	        }
	      }
	
	      if (DOMAttributeNamespaces.hasOwnProperty(propName)) {
	        propertyInfo.attributeNamespace = DOMAttributeNamespaces[propName];
	      }
	
	      if (DOMPropertyNames.hasOwnProperty(propName)) {
	        propertyInfo.propertyName = DOMPropertyNames[propName];
	      }
	
	      if (DOMMutationMethods.hasOwnProperty(propName)) {
	        propertyInfo.mutationMethod = DOMMutationMethods[propName];
	      }
	
	      DOMProperty.properties[propName] = propertyInfo;
	    }
	  }
	};
	
	/* eslint-disable max-len */
	var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
	/* eslint-enable max-len */
	
	/**
	 * DOMProperty exports lookup objects that can be used like functions:
	 *
	 *   > DOMProperty.isValid['id']
	 *   true
	 *   > DOMProperty.isValid['foobar']
	 *   undefined
	 *
	 * Although this may be confusing, it performs better in general.
	 *
	 * @see http://jsperf.com/key-exists
	 * @see http://jsperf.com/key-missing
	 */
	var DOMProperty = {
	  ID_ATTRIBUTE_NAME: 'data-reactid',
	  ROOT_ATTRIBUTE_NAME: 'data-reactroot',
	
	  ATTRIBUTE_NAME_START_CHAR: ATTRIBUTE_NAME_START_CHAR,
	  ATTRIBUTE_NAME_CHAR: ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040',
	
	  /**
	   * Map from property "standard name" to an object with info about how to set
	   * the property in the DOM. Each object contains:
	   *
	   * attributeName:
	   *   Used when rendering markup or with `*Attribute()`.
	   * attributeNamespace
	   * propertyName:
	   *   Used on DOM node instances. (This includes properties that mutate due to
	   *   external factors.)
	   * mutationMethod:
	   *   If non-null, used instead of the property or `setAttribute()` after
	   *   initial render.
	   * mustUseProperty:
	   *   Whether the property must be accessed and mutated as an object property.
	   * hasBooleanValue:
	   *   Whether the property should be removed when set to a falsey value.
	   * hasNumericValue:
	   *   Whether the property must be numeric or parse as a numeric and should be
	   *   removed when set to a falsey value.
	   * hasPositiveNumericValue:
	   *   Whether the property must be positive numeric or parse as a positive
	   *   numeric and should be removed when set to a falsey value.
	   * hasOverloadedBooleanValue:
	   *   Whether the property can be used as a flag as well as with a value.
	   *   Removed when strictly equal to false; present without a value when
	   *   strictly equal to true; present with a value otherwise.
	   */
	  properties: {},
	
	  /**
	   * Mapping from lowercase property names to the properly cased version, used
	   * to warn in the case of missing properties. Available only in __DEV__.
	   *
	   * autofocus is predefined, because adding it to the property whitelist
	   * causes unintended side effects.
	   *
	   * @type {Object}
	   */
	  getPossibleStandardName:  false ? { autofocus: 'autoFocus' } : null,
	
	  /**
	   * All of the isCustomAttribute() functions that have been injected.
	   */
	  _isCustomAttributeFunctions: [],
	
	  /**
	   * Checks whether a property name is a custom attribute.
	   * @method
	   */
	  isCustomAttribute: function (attributeName) {
	    for (var i = 0; i < DOMProperty._isCustomAttributeFunctions.length; i++) {
	      var isCustomAttributeFn = DOMProperty._isCustomAttributeFunctions[i];
	      if (isCustomAttributeFn(attributeName)) {
	        return true;
	      }
	    }
	    return false;
	  },
	
	  injection: DOMPropertyInjection
	};
	
	module.exports = DOMProperty;

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var EventPluginRegistry = __webpack_require__(227);
	var EventPluginUtils = __webpack_require__(154);
	var ReactErrorUtils = __webpack_require__(231);
	
	var accumulateInto = __webpack_require__(405);
	var forEachAccumulated = __webpack_require__(406);
	var invariant = __webpack_require__(13);
	
	/**
	 * Internal store for event listeners
	 */
	var listenerBank = {};
	
	/**
	 * Internal queue of events that have accumulated their dispatches and are
	 * waiting to have their dispatches executed.
	 */
	var eventQueue = null;
	
	/**
	 * Dispatches an event and releases it back into the pool, unless persistent.
	 *
	 * @param {?object} event Synthetic event to be dispatched.
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @private
	 */
	var executeDispatchesAndRelease = function (event, simulated) {
	  if (event) {
	    EventPluginUtils.executeDispatchesInOrder(event, simulated);
	
	    if (!event.isPersistent()) {
	      event.constructor.release(event);
	    }
	  }
	};
	var executeDispatchesAndReleaseSimulated = function (e) {
	  return executeDispatchesAndRelease(e, true);
	};
	var executeDispatchesAndReleaseTopLevel = function (e) {
	  return executeDispatchesAndRelease(e, false);
	};
	
	var getDictionaryKey = function (inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	};
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	function shouldPreventMouseEvent(name, type, props) {
	  switch (name) {
	    case 'onClick':
	    case 'onClickCapture':
	    case 'onDoubleClick':
	    case 'onDoubleClickCapture':
	    case 'onMouseDown':
	    case 'onMouseDownCapture':
	    case 'onMouseMove':
	    case 'onMouseMoveCapture':
	    case 'onMouseUp':
	    case 'onMouseUpCapture':
	      return !!(props.disabled && isInteractive(type));
	    default:
	      return false;
	  }
	}
	
	/**
	 * This is a unified interface for event plugins to be installed and configured.
	 *
	 * Event plugins can implement the following properties:
	 *
	 *   `extractEvents` {function(string, DOMEventTarget, string, object): *}
	 *     Required. When a top-level event is fired, this method is expected to
	 *     extract synthetic events that will in turn be queued and dispatched.
	 *
	 *   `eventTypes` {object}
	 *     Optional, plugins that fire events must publish a mapping of registration
	 *     names that are used to register listeners. Values of this mapping must
	 *     be objects that contain `registrationName` or `phasedRegistrationNames`.
	 *
	 *   `executeDispatch` {function(object, function, string)}
	 *     Optional, allows plugins to override how an event gets dispatched. By
	 *     default, the listener is simply invoked.
	 *
	 * Each plugin that is injected into `EventsPluginHub` is immediately operable.
	 *
	 * @public
	 */
	var EventPluginHub = {
	  /**
	   * Methods for injecting dependencies.
	   */
	  injection: {
	    /**
	     * @param {array} InjectedEventPluginOrder
	     * @public
	     */
	    injectEventPluginOrder: EventPluginRegistry.injectEventPluginOrder,
	
	    /**
	     * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	     */
	    injectEventPluginsByName: EventPluginRegistry.injectEventPluginsByName
	  },
	
	  /**
	   * Stores `listener` at `listenerBank[registrationName][key]`. Is idempotent.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {function} listener The callback to store.
	   */
	  putListener: function (inst, registrationName, listener) {
	    !(typeof listener === 'function') ?  false ? invariant(false, 'Expected %s listener to be a function, instead got type %s', registrationName, typeof listener) : _prodInvariant('94', registrationName, typeof listener) : void 0;
	
	    var key = getDictionaryKey(inst);
	    var bankForRegistrationName = listenerBank[registrationName] || (listenerBank[registrationName] = {});
	    bankForRegistrationName[key] = listener;
	
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.didPutListener) {
	      PluginModule.didPutListener(inst, registrationName, listener);
	    }
	  },
	
	  /**
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @return {?function} The stored callback.
	   */
	  getListener: function (inst, registrationName) {
	    // TODO: shouldPreventMouseEvent is DOM-specific and definitely should not
	    // live here; needs to be moved to a better place soon
	    var bankForRegistrationName = listenerBank[registrationName];
	    if (shouldPreventMouseEvent(registrationName, inst._currentElement.type, inst._currentElement.props)) {
	      return null;
	    }
	    var key = getDictionaryKey(inst);
	    return bankForRegistrationName && bankForRegistrationName[key];
	  },
	
	  /**
	   * Deletes a listener from the registration bank.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   */
	  deleteListener: function (inst, registrationName) {
	    var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	    if (PluginModule && PluginModule.willDeleteListener) {
	      PluginModule.willDeleteListener(inst, registrationName);
	    }
	
	    var bankForRegistrationName = listenerBank[registrationName];
	    // TODO: This should never be null -- when is it?
	    if (bankForRegistrationName) {
	      var key = getDictionaryKey(inst);
	      delete bankForRegistrationName[key];
	    }
	  },
	
	  /**
	   * Deletes all listeners for the DOM element with the supplied ID.
	   *
	   * @param {object} inst The instance, which is the source of events.
	   */
	  deleteAllListeners: function (inst) {
	    var key = getDictionaryKey(inst);
	    for (var registrationName in listenerBank) {
	      if (!listenerBank.hasOwnProperty(registrationName)) {
	        continue;
	      }
	
	      if (!listenerBank[registrationName][key]) {
	        continue;
	      }
	
	      var PluginModule = EventPluginRegistry.registrationNameModules[registrationName];
	      if (PluginModule && PluginModule.willDeleteListener) {
	        PluginModule.willDeleteListener(inst, registrationName);
	      }
	
	      delete listenerBank[registrationName][key];
	    }
	  },
	
	  /**
	   * Allows registered plugins an opportunity to extract events from top-level
	   * native browser events.
	   *
	   * @return {*} An accumulation of synthetic events.
	   * @internal
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events;
	    var plugins = EventPluginRegistry.plugins;
	    for (var i = 0; i < plugins.length; i++) {
	      // Not every plugin in the ordering may be loaded at runtime.
	      var possiblePlugin = plugins[i];
	      if (possiblePlugin) {
	        var extractedEvents = possiblePlugin.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	        if (extractedEvents) {
	          events = accumulateInto(events, extractedEvents);
	        }
	      }
	    }
	    return events;
	  },
	
	  /**
	   * Enqueues a synthetic event that should be dispatched when
	   * `processEventQueue` is invoked.
	   *
	   * @param {*} events An accumulation of synthetic events.
	   * @internal
	   */
	  enqueueEvents: function (events) {
	    if (events) {
	      eventQueue = accumulateInto(eventQueue, events);
	    }
	  },
	
	  /**
	   * Dispatches all synthetic events on the event queue.
	   *
	   * @internal
	   */
	  processEventQueue: function (simulated) {
	    // Set `eventQueue` to null before processing it so that we can tell if more
	    // events get enqueued while processing.
	    var processingEventQueue = eventQueue;
	    eventQueue = null;
	    if (simulated) {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseSimulated);
	    } else {
	      forEachAccumulated(processingEventQueue, executeDispatchesAndReleaseTopLevel);
	    }
	    !!eventQueue ?  false ? invariant(false, 'processEventQueue(): Additional events were enqueued while processing an event queue. Support for this has not yet been implemented.') : _prodInvariant('95') : void 0;
	    // This would be a good time to rethrow if any of the event handlers threw.
	    ReactErrorUtils.rethrowCaughtError();
	  },
	
	  /**
	   * These are needed for tests only. Do not use!
	   */
	  __purge: function () {
	    listenerBank = {};
	  },
	
	  __getListenerBank: function () {
	    return listenerBank;
	  }
	};
	
	module.exports = EventPluginHub;

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(90);
	var EventPluginUtils = __webpack_require__(154);
	
	var accumulateInto = __webpack_require__(405);
	var forEachAccumulated = __webpack_require__(406);
	var warning = __webpack_require__(16);
	
	var getListener = EventPluginHub.getListener;
	
	/**
	 * Some event types have a notion of different registration names for different
	 * "phases" of propagation. This finds listeners by a given phase.
	 */
	function listenerAtPhase(inst, event, propagationPhase) {
	  var registrationName = event.dispatchConfig.phasedRegistrationNames[propagationPhase];
	  return getListener(inst, registrationName);
	}
	
	/**
	 * Tags a `SyntheticEvent` with dispatched listeners. Creating this function
	 * here, allows us to not have to bind or create functions for each event.
	 * Mutating the event's members allows us to not have to create a wrapping
	 * "dispatch" object that pairs the event with the listener.
	 */
	function accumulateDirectionalDispatches(inst, phase, event) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(inst, 'Dispatching inst must not be null') : void 0;
	  }
	  var listener = listenerAtPhase(inst, event, phase);
	  if (listener) {
	    event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	    event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	  }
	}
	
	/**
	 * Collect dispatches (must be entirely collected before dispatching - see unit
	 * tests). Lazily allocate the array to conserve memory.  We must loop through
	 * each event and perform the traversal for each one. We cannot perform a
	 * single traversal for the entire collection of events because each event may
	 * have a different target.
	 */
	function accumulateTwoPhaseDispatchesSingle(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    EventPluginUtils.traverseTwoPhase(event._targetInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Same as `accumulateTwoPhaseDispatchesSingle`, but skips over the targetID.
	 */
	function accumulateTwoPhaseDispatchesSingleSkipTarget(event) {
	  if (event && event.dispatchConfig.phasedRegistrationNames) {
	    var targetInst = event._targetInst;
	    var parentInst = targetInst ? EventPluginUtils.getParentInstance(targetInst) : null;
	    EventPluginUtils.traverseTwoPhase(parentInst, accumulateDirectionalDispatches, event);
	  }
	}
	
	/**
	 * Accumulates without regard to direction, does not look for phased
	 * registration names. Same as `accumulateDirectDispatchesSingle` but without
	 * requiring that the `dispatchMarker` be the same as the dispatched ID.
	 */
	function accumulateDispatches(inst, ignoredDirection, event) {
	  if (event && event.dispatchConfig.registrationName) {
	    var registrationName = event.dispatchConfig.registrationName;
	    var listener = getListener(inst, registrationName);
	    if (listener) {
	      event._dispatchListeners = accumulateInto(event._dispatchListeners, listener);
	      event._dispatchInstances = accumulateInto(event._dispatchInstances, inst);
	    }
	  }
	}
	
	/**
	 * Accumulates dispatches on an `SyntheticEvent`, but only for the
	 * `dispatchMarker`.
	 * @param {SyntheticEvent} event
	 */
	function accumulateDirectDispatchesSingle(event) {
	  if (event && event.dispatchConfig.registrationName) {
	    accumulateDispatches(event._targetInst, null, event);
	  }
	}
	
	function accumulateTwoPhaseDispatches(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingle);
	}
	
	function accumulateTwoPhaseDispatchesSkipTarget(events) {
	  forEachAccumulated(events, accumulateTwoPhaseDispatchesSingleSkipTarget);
	}
	
	function accumulateEnterLeaveDispatches(leave, enter, from, to) {
	  EventPluginUtils.traverseEnterLeave(from, to, accumulateDispatches, leave, enter);
	}
	
	function accumulateDirectDispatches(events) {
	  forEachAccumulated(events, accumulateDirectDispatchesSingle);
	}
	
	/**
	 * A small set of propagation patterns, each of which will accept a small amount
	 * of information, and generate a set of "dispatch ready event objects" - which
	 * are sets of events that have already been annotated with a set of dispatched
	 * listener functions/ids. The API is designed this way to discourage these
	 * propagation strategies from actually executing the dispatches, since we
	 * always want to collect the entire set of dispatches before executing event a
	 * single one.
	 *
	 * @constructor EventPropagators
	 */
	var EventPropagators = {
	  accumulateTwoPhaseDispatches: accumulateTwoPhaseDispatches,
	  accumulateTwoPhaseDispatchesSkipTarget: accumulateTwoPhaseDispatchesSkipTarget,
	  accumulateDirectDispatches: accumulateDirectDispatches,
	  accumulateEnterLeaveDispatches: accumulateEnterLeaveDispatches
	};
	
	module.exports = EventPropagators;

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactRef = __webpack_require__(1889);
	var ReactInstrumentation = __webpack_require__(36);
	
	var warning = __webpack_require__(16);
	
	/**
	 * Helper to call ReactRef.attachRefs with this composite component, split out
	 * to avoid allocations in the transaction mount-ready queue.
	 */
	function attachRefs() {
	  ReactRef.attachRefs(this, this._currentElement);
	}
	
	var ReactReconciler = {
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} the containing host component instance
	   * @param {?object} info about the host container
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (internalInstance, transaction, hostParent, hostContainerInfo, context, parentDebugID) // 0 in production and for roots
	  {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeMountComponent(internalInstance._debugID, internalInstance._currentElement, parentDebugID);
	      }
	    }
	    var markup = internalInstance.mountComponent(transaction, hostParent, hostContainerInfo, context, parentDebugID);
	    if (internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onMountComponent(internalInstance._debugID);
	      }
	    }
	    return markup;
	  },
	
	  /**
	   * Returns a value that can be passed to
	   * ReactComponentEnvironment.replaceNodeWithMarkup.
	   */
	  getHostNode: function (internalInstance) {
	    return internalInstance.getHostNode();
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (internalInstance, safely) {
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUnmountComponent(internalInstance._debugID);
	      }
	    }
	    ReactRef.detachRefs(internalInstance, internalInstance._currentElement);
	    internalInstance.unmountComponent(safely);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUnmountComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Update a component using a new element.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @internal
	   */
	  receiveComponent: function (internalInstance, nextElement, transaction, context) {
	    var prevElement = internalInstance._currentElement;
	
	    if (nextElement === prevElement && context === internalInstance._context) {
	      // Since elements are immutable after the owner is rendered,
	      // we can do a cheap identity compare here to determine if this is a
	      // superfluous reconcile. It's possible for state to be mutable but such
	      // change should trigger an update of the owner which would recreate
	      // the element. We explicitly check for the existence of an owner since
	      // it's possible for an element created outside a composite to be
	      // deeply mutated and reused.
	
	      // TODO: Bailing out early is just a perf optimization right?
	      // TODO: Removing the return statement should affect correctness?
	      return;
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, nextElement);
	      }
	    }
	
	    var refsChanged = ReactRef.shouldUpdateRefs(prevElement, nextElement);
	
	    if (refsChanged) {
	      ReactRef.detachRefs(internalInstance, prevElement);
	    }
	
	    internalInstance.receiveComponent(nextElement, transaction, context);
	
	    if (refsChanged && internalInstance._currentElement && internalInstance._currentElement.ref != null) {
	      transaction.getReactMountReady().enqueue(attachRefs, internalInstance);
	    }
	
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  },
	
	  /**
	   * Flush any dirty changes in a component.
	   *
	   * @param {ReactComponent} internalInstance
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (internalInstance, transaction, updateBatchNumber) {
	    if (internalInstance._updateBatchNumber !== updateBatchNumber) {
	      // The component's enqueued batch number should always be the current
	      // batch or the following one.
	       false ? warning(internalInstance._updateBatchNumber == null || internalInstance._updateBatchNumber === updateBatchNumber + 1, 'performUpdateIfNecessary: Unexpected batch number (current %s, ' + 'pending %s)', updateBatchNumber, internalInstance._updateBatchNumber) : void 0;
	      return;
	    }
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onBeforeUpdateComponent(internalInstance._debugID, internalInstance._currentElement);
	      }
	    }
	    internalInstance.performUpdateIfNecessary(transaction);
	    if (false) {
	      if (internalInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onUpdateComponent(internalInstance._debugID);
	      }
	    }
	  }
	};
	
	module.exports = ReactReconciler;

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	var getEventTarget = __webpack_require__(237);
	
	/**
	 * @interface UIEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var UIEventInterface = {
	  view: function (event) {
	    if (event.view) {
	      return event.view;
	    }
	
	    var target = getEventTarget(event);
	    if (target.window === target) {
	      // target is a window object
	      return target;
	    }
	
	    var doc = target.ownerDocument;
	    // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	    if (doc) {
	      return doc.defaultView || doc.parentWindow;
	    } else {
	      return window;
	    }
	  },
	  detail: function (event) {
	    return event.detail || 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticUIEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticUIEvent, UIEventInterface);
	
	module.exports = SyntheticUIEvent;

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactBaseClasses = __webpack_require__(423);
	var ReactChildren = __webpack_require__(1959);
	var ReactDOMFactories = __webpack_require__(1960);
	var ReactElement = __webpack_require__(95);
	var ReactPropTypes = __webpack_require__(1961);
	var ReactVersion = __webpack_require__(1962);
	
	var createReactClass = __webpack_require__(1963);
	var onlyChild = __webpack_require__(1967);
	
	var createElement = ReactElement.createElement;
	var createFactory = ReactElement.createFactory;
	var cloneElement = ReactElement.cloneElement;
	
	if (false) {
	  var lowPriorityWarning = require('./lowPriorityWarning');
	  var canDefineProperty = require('./canDefineProperty');
	  var ReactElementValidator = require('./ReactElementValidator');
	  var didWarnPropTypesDeprecated = false;
	  createElement = ReactElementValidator.createElement;
	  createFactory = ReactElementValidator.createFactory;
	  cloneElement = ReactElementValidator.cloneElement;
	}
	
	var __spread = _assign;
	var createMixin = function (mixin) {
	  return mixin;
	};
	
	if (false) {
	  var warnedForSpread = false;
	  var warnedForCreateMixin = false;
	  __spread = function () {
	    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
	    warnedForSpread = true;
	    return _assign.apply(null, arguments);
	  };
	
	  createMixin = function (mixin) {
	    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
	    warnedForCreateMixin = true;
	    return mixin;
	  };
	}
	
	var React = {
	  // Modern
	
	  Children: {
	    map: ReactChildren.map,
	    forEach: ReactChildren.forEach,
	    count: ReactChildren.count,
	    toArray: ReactChildren.toArray,
	    only: onlyChild
	  },
	
	  Component: ReactBaseClasses.Component,
	  PureComponent: ReactBaseClasses.PureComponent,
	
	  createElement: createElement,
	  cloneElement: cloneElement,
	  isValidElement: ReactElement.isValidElement,
	
	  // Classic
	
	  PropTypes: ReactPropTypes,
	  createClass: createReactClass,
	  createFactory: createFactory,
	  createMixin: createMixin,
	
	  // This looks DOM specific but these are actually isomorphic helpers
	  // since they are just generating DOM strings.
	  DOM: ReactDOMFactories,
	
	  version: ReactVersion,
	
	  // Deprecated hook for JSX spread, don't use this for anything.
	  __spread: __spread
	};
	
	if (false) {
	  var warnedForCreateClass = false;
	  if (canDefineProperty) {
	    Object.defineProperty(React, 'PropTypes', {
	      get: function () {
	        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
	        didWarnPropTypesDeprecated = true;
	        return ReactPropTypes;
	      }
	    });
	
	    Object.defineProperty(React, 'createClass', {
	      get: function () {
	        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
	        warnedForCreateClass = true;
	        return createReactClass;
	      }
	    });
	  }
	
	  // React.DOM factories are deprecated. Wrap these methods so that
	  // invocations of the React.DOM namespace and alert users to switch
	  // to the `react-dom-factories` package.
	  React.DOM = {};
	  var warnedForFactories = false;
	  Object.keys(ReactDOMFactories).forEach(function (factory) {
	    React.DOM[factory] = function () {
	      if (!warnedForFactories) {
	        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
	        warnedForFactories = true;
	      }
	      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
	    };
	  });
	}
	
	module.exports = React;

/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactCurrentOwner = __webpack_require__(45);
	
	var warning = __webpack_require__(16);
	var canDefineProperty = __webpack_require__(427);
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	var REACT_ELEMENT_TYPE = __webpack_require__(425);
	
	var RESERVED_PROPS = {
	  key: true,
	  ref: true,
	  __self: true,
	  __source: true
	};
	
	var specialPropKeyWarningShown, specialPropRefWarningShown;
	
	function hasValidRef(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'ref')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.ref !== undefined;
	}
	
	function hasValidKey(config) {
	  if (false) {
	    if (hasOwnProperty.call(config, 'key')) {
	      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
	      if (getter && getter.isReactWarning) {
	        return false;
	      }
	    }
	  }
	  return config.key !== undefined;
	}
	
	function defineKeyPropWarningGetter(props, displayName) {
	  var warnAboutAccessingKey = function () {
	    if (!specialPropKeyWarningShown) {
	      specialPropKeyWarningShown = true;
	       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingKey.isReactWarning = true;
	  Object.defineProperty(props, 'key', {
	    get: warnAboutAccessingKey,
	    configurable: true
	  });
	}
	
	function defineRefPropWarningGetter(props, displayName) {
	  var warnAboutAccessingRef = function () {
	    if (!specialPropRefWarningShown) {
	      specialPropRefWarningShown = true;
	       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
	    }
	  };
	  warnAboutAccessingRef.isReactWarning = true;
	  Object.defineProperty(props, 'ref', {
	    get: warnAboutAccessingRef,
	    configurable: true
	  });
	}
	
	/**
	 * Factory method to create a new React element. This no longer adheres to
	 * the class pattern, so do not use new to call it. Also, no instanceof check
	 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
	 * if something is a React Element.
	 *
	 * @param {*} type
	 * @param {*} key
	 * @param {string|object} ref
	 * @param {*} self A *temporary* helper to detect places where `this` is
	 * different from the `owner` when React.createElement is called, so that we
	 * can warn. We want to get rid of owner and replace string `ref`s with arrow
	 * functions, and as long as `this` and owner are the same, there will be no
	 * change in behavior.
	 * @param {*} source An annotation object (added by a transpiler or otherwise)
	 * indicating filename, line number, and/or other information.
	 * @param {*} owner
	 * @param {*} props
	 * @internal
	 */
	var ReactElement = function (type, key, ref, self, source, owner, props) {
	  var element = {
	    // This tag allow us to uniquely identify this as a React Element
	    $$typeof: REACT_ELEMENT_TYPE,
	
	    // Built-in properties that belong on the element
	    type: type,
	    key: key,
	    ref: ref,
	    props: props,
	
	    // Record the component responsible for creating this element.
	    _owner: owner
	  };
	
	  if (false) {
	    // The validation flag is currently mutative. We put it on
	    // an external backing store so that we can freeze the whole object.
	    // This can be replaced with a WeakMap once they are implemented in
	    // commonly used development environments.
	    element._store = {};
	
	    // To make comparing ReactElements easier for testing purposes, we make
	    // the validation flag non-enumerable (where possible, which should
	    // include every environment we run tests in), so the test framework
	    // ignores it.
	    if (canDefineProperty) {
	      Object.defineProperty(element._store, 'validated', {
	        configurable: false,
	        enumerable: false,
	        writable: true,
	        value: false
	      });
	      // self and source are DEV only properties.
	      Object.defineProperty(element, '_self', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: self
	      });
	      // Two elements created in two different places should be considered
	      // equal for testing purposes and therefore we hide it from enumeration.
	      Object.defineProperty(element, '_source', {
	        configurable: false,
	        enumerable: false,
	        writable: false,
	        value: source
	      });
	    } else {
	      element._store.validated = false;
	      element._self = self;
	      element._source = source;
	    }
	    if (Object.freeze) {
	      Object.freeze(element.props);
	      Object.freeze(element);
	    }
	  }
	
	  return element;
	};
	
	/**
	 * Create and return a new ReactElement of the given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
	 */
	ReactElement.createElement = function (type, config, children) {
	  var propName;
	
	  // Reserved names are extracted
	  var props = {};
	
	  var key = null;
	  var ref = null;
	  var self = null;
	  var source = null;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      ref = config.ref;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    self = config.__self === undefined ? null : config.__self;
	    source = config.__source === undefined ? null : config.__source;
	    // Remaining properties are added to a new props object
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        props[propName] = config[propName];
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    if (false) {
	      if (Object.freeze) {
	        Object.freeze(childArray);
	      }
	    }
	    props.children = childArray;
	  }
	
	  // Resolve default props
	  if (type && type.defaultProps) {
	    var defaultProps = type.defaultProps;
	    for (propName in defaultProps) {
	      if (props[propName] === undefined) {
	        props[propName] = defaultProps[propName];
	      }
	    }
	  }
	  if (false) {
	    if (key || ref) {
	      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
	        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
	        if (key) {
	          defineKeyPropWarningGetter(props, displayName);
	        }
	        if (ref) {
	          defineRefPropWarningGetter(props, displayName);
	        }
	      }
	    }
	  }
	  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
	};
	
	/**
	 * Return a function that produces ReactElements of a given type.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
	 */
	ReactElement.createFactory = function (type) {
	  var factory = ReactElement.createElement.bind(null, type);
	  // Expose the type on the factory and the prototype so that it can be
	  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
	  // This should not be named `constructor` since this may not be the function
	  // that created the element, and it may not even be a constructor.
	  // Legacy hook TODO: Warn if this is accessed
	  factory.type = type;
	  return factory;
	};
	
	ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
	  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);
	
	  return newElement;
	};
	
	/**
	 * Clone and return a new ReactElement using element as the starting point.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
	 */
	ReactElement.cloneElement = function (element, config, children) {
	  var propName;
	
	  // Original props are copied
	  var props = _assign({}, element.props);
	
	  // Reserved names are extracted
	  var key = element.key;
	  var ref = element.ref;
	  // Self is preserved since the owner is preserved.
	  var self = element._self;
	  // Source is preserved since cloneElement is unlikely to be targeted by a
	  // transpiler, and the original source is probably a better indicator of the
	  // true owner.
	  var source = element._source;
	
	  // Owner will be preserved, unless ref is overridden
	  var owner = element._owner;
	
	  if (config != null) {
	    if (hasValidRef(config)) {
	      // Silently steal the ref from the parent.
	      ref = config.ref;
	      owner = ReactCurrentOwner.current;
	    }
	    if (hasValidKey(config)) {
	      key = '' + config.key;
	    }
	
	    // Remaining properties override existing props
	    var defaultProps;
	    if (element.type && element.type.defaultProps) {
	      defaultProps = element.type.defaultProps;
	    }
	    for (propName in config) {
	      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
	        if (config[propName] === undefined && defaultProps !== undefined) {
	          // Resolve default props
	          props[propName] = defaultProps[propName];
	        } else {
	          props[propName] = config[propName];
	        }
	      }
	    }
	  }
	
	  // Children can be more than one argument, and those are transferred onto
	  // the newly allocated props object.
	  var childrenLength = arguments.length - 2;
	  if (childrenLength === 1) {
	    props.children = children;
	  } else if (childrenLength > 1) {
	    var childArray = Array(childrenLength);
	    for (var i = 0; i < childrenLength; i++) {
	      childArray[i] = arguments[i + 2];
	    }
	    props.children = childArray;
	  }
	
	  return ReactElement(element.type, key, ref, self, source, owner, props);
	};
	
	/**
	 * Verifies the object is a ReactElement.
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid component.
	 * @final
	 */
	ReactElement.isValidElement = function (object) {
	  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
	};
	
	module.exports = ReactElement;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by DSadler on 18/04/2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var dropZoneStyle = {
	  //backgroundColor: "#ffffff",
	  borderWidth: "5px",
	  borderStyle: "double",
	  borderColor: "#c0c0c0",
	  color: "#c0c0c0",
	  fontSize: "40px",
	  height: "130px",
	  lineHeight: "130px",
	  textAlign: "center",
	  verticalAlign: "middle",
	  width: "calc(100% - 10px)"
	};
	
	var DropZone = function (_Component) {
	  _inherits(DropZone, _Component);
	
	  function DropZone(props) {
	    _classCallCheck(this, DropZone);
	
	    var _this = _possibleConstructorReturn(this, (DropZone.__proto__ || Object.getPrototypeOf(DropZone)).call(this, props));
	
	    _this.state = {
	      style: dropZoneStyle
	    };
	    return _this;
	  }
	
	  _createClass(DropZone, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        {
	          className: "placeholder",
	          style: this.state.style
	        },
	        this.props.text
	      );
	    }
	  }]);
	
	  return DropZone;
	}(_react.Component);
	
	exports.default = DropZone;

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(251);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  } else {
	    return (0, _from2.default)(arr);
	  }
	};

/***/ },
/* 98 */
/***/ function(module, exports) {

	module.exports = {
		trueFunc: function trueFunc(){
			return true;
		},
		falseFunc: function falseFunc(){
			return false;
		}
	};

/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(125),
	    render = __webpack_require__(184);
	
	/**
	 * HTML Tags
	 */
	
	var tags = { tag: true, script: true, style: true };
	
	/**
	 * Check if the DOM element is a tag
	 *
	 * isTag(type) includes <script> and <style> tags
	 */
	
	exports.isTag = function(type) {
	  if (type.type) type = type.type;
	  return tags[type] || false;
	};
	
	/**
	 * Convert a string to camel case notation.
	 * @param  {String} str String to be converted.
	 * @return {String}     String in camel case notation.
	 */
	
	exports.camelCase = function(str) {
	  return str.replace(/[_.-](\w|$)/g, function(_, x) {
	    return x.toUpperCase();
	  });
	};
	
	/**
	 * Convert a string from camel case to "CSS case", where word boundaries are
	 * described by hyphens ("-") and all characters are lower-case.
	 * @param  {String} str String to be converted.
	 * @return {string}     String in "CSS case".
	 */
	exports.cssCase = function(str) {
	  return str.replace(/[A-Z]/g, '-$&').toLowerCase();
	};
	
	/**
	 * Iterate over each DOM element without creating intermediary Cheerio instances.
	 *
	 * This is indented for use internally to avoid otherwise unnecessary memory pressure introduced
	 * by _make.
	 */
	
	exports.domEach = function(cheerio, fn) {
	  var i = 0, len = cheerio.length;
	  while (i < len && fn.call(cheerio, i, cheerio[i]) !== false) ++i;
	  return cheerio;
	};
	
	/**
	 * Create a deep copy of the given DOM structure by first rendering it to a
	 * string and then parsing the resultant markup.
	 *
	 * @argument {Object} dom - The htmlparser2-compliant DOM structure
	 * @argument {Object} options - The parsing/rendering options
	 */
	exports.cloneDom = function(dom, options) {
	  return parse(render(dom, options), options).children;
	};
	
	/*
	 * A simple way to check for HTML strings or ID strings
	 */
	
	var quickExpr = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
	
	/*
	 * Check if string is HTML
	 */
	exports.isHtml = function(str) {
	  // Faster than running regex, if str starts with `<` and ends with `>`, assume it's HTML
	  if (str.charAt(0) === '<' && str.charAt(str.length - 1) === '>' && str.length >= 3) return true;
	
	  // Run the regex
	  var match = quickExpr.exec(str);
	  return !!(match && match[1]);
	};


/***/ },
/* 100 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 / 15.2.3.14 Object.keys(O)
	var $keys = __webpack_require__(264);
	var enumBugKeys = __webpack_require__(170);
	
	module.exports = Object.keys || function keys(O) {
	  return $keys(O, enumBugKeys);
	};


/***/ },
/* 101 */
/***/ function(module, exports) {

	module.exports = function (bitmap, value) {
	  return {
	    enumerable: !(bitmap & 1),
	    configurable: !(bitmap & 2),
	    writable: !(bitmap & 4),
	    value: value
	  };
	};


/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.13 ToObject(argument)
	var defined = __webpack_require__(169);
	module.exports = function (it) {
	  return Object(defined(it));
	};


/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// NOTE: These type checking functions intentionally don't use `instanceof`
	// because it is fragile and can be easily faked with `Object.create()`.
	
	function isArray(arg) {
	  if (Array.isArray) {
	    return Array.isArray(arg);
	  }
	  return objectToString(arg) === '[object Array]';
	}
	exports.isArray = isArray;
	
	function isBoolean(arg) {
	  return typeof arg === 'boolean';
	}
	exports.isBoolean = isBoolean;
	
	function isNull(arg) {
	  return arg === null;
	}
	exports.isNull = isNull;
	
	function isNullOrUndefined(arg) {
	  return arg == null;
	}
	exports.isNullOrUndefined = isNullOrUndefined;
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	exports.isNumber = isNumber;
	
	function isString(arg) {
	  return typeof arg === 'string';
	}
	exports.isString = isString;
	
	function isSymbol(arg) {
	  return typeof arg === 'symbol';
	}
	exports.isSymbol = isSymbol;
	
	function isUndefined(arg) {
	  return arg === void 0;
	}
	exports.isUndefined = isUndefined;
	
	function isRegExp(re) {
	  return objectToString(re) === '[object RegExp]';
	}
	exports.isRegExp = isRegExp;
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	exports.isObject = isObject;
	
	function isDate(d) {
	  return objectToString(d) === '[object Date]';
	}
	exports.isDate = isDate;
	
	function isError(e) {
	  return (objectToString(e) === '[object Error]' || e instanceof Error);
	}
	exports.isError = isError;
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	exports.isFunction = isFunction;
	
	function isPrimitive(arg) {
	  return arg === null ||
	         typeof arg === 'boolean' ||
	         typeof arg === 'number' ||
	         typeof arg === 'string' ||
	         typeof arg === 'symbol' ||  // ES6 symbol
	         typeof arg === 'undefined';
	}
	exports.isPrimitive = isPrimitive;
	
	exports.isBuffer = Buffer.isBuffer;
	
	function objectToString(o) {
	  return Object.prototype.toString.call(o);
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123).Buffer))

/***/ },
/* 104 */
/***/ function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
		Doctype: "doctype",
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};


/***/ },
/* 105 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 * 
	 */
	
	/*eslint-disable no-self-compare */
	
	'use strict';
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	/**
	 * inlined Object.is polyfill to avoid requiring consumers ship their own
	 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	 */
	function is(x, y) {
	  // SameValue algorithm
	  if (x === y) {
	    // Steps 1-5, 7-10
	    // Steps 6.b-6.e: +0 != -0
	    // Added the nonzero y check to make Flow happy, but it is redundant
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    // Step 6.a: NaN == NaN
	    return x !== x && y !== y;
	  }
	}
	
	/**
	 * Performs equality by iterating through keys on an object and returning false
	 * when any key has values which are not strictly equal between the arguments.
	 * Returns true when the values of all keys are strictly equal.
	 */
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) {
	    return true;
	  }
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) {
	    return false;
	  }
	
	  // Test for A's keys different from B.
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwnProperty.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}
	
	module.exports = shallowEqual;

/***/ },
/* 106 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	module.exports = arrayMap;


/***/ },
/* 107 */
/***/ function(module, exports, __webpack_require__) {

	var defineProperty = __webpack_require__(321);
	
	/**
	 * The base implementation of `assignValue` and `assignMergeValue` without
	 * value checks.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function baseAssignValue(object, key, value) {
	  if (key == '__proto__' && defineProperty) {
	    defineProperty(object, key, {
	      'configurable': true,
	      'enumerable': true,
	      'value': value,
	      'writable': true
	    });
	  } else {
	    object[key] = value;
	  }
	}
	
	module.exports = baseAssignValue;


/***/ },
/* 108 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(51),
	    toKey = __webpack_require__(52);
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = castPath(path, object);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	module.exports = baseGet;


/***/ },
/* 109 */
/***/ function(module, exports) {

	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = identity;


/***/ },
/* 110 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(85),
	    isLength = __webpack_require__(209);
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	module.exports = isArrayLike;


/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(41),
	    stubFalse = __webpack_require__(773);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	module.exports = isBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)(module)))

/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(81),
	    getPrototype = __webpack_require__(142),
	    isObjectLike = __webpack_require__(62);
	
	/** `Object#toString` result references. */
	var objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
	    funcToString.call(Ctor) == objectCtorString;
	}
	
	module.exports = isPlainObject;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	  'assign': __webpack_require__(737),
	  'assignIn': __webpack_require__(336),
	  'assignInWith': __webpack_require__(206),
	  'assignWith': __webpack_require__(738),
	  'at': __webpack_require__(739),
	  'create': __webpack_require__(740),
	  'defaults': __webpack_require__(741),
	  'defaultsDeep': __webpack_require__(742),
	  'entries': __webpack_require__(743),
	  'entriesIn': __webpack_require__(744),
	  'extend': __webpack_require__(745),
	  'extendWith': __webpack_require__(746),
	  'findKey': __webpack_require__(747),
	  'findLastKey': __webpack_require__(748),
	  'forIn': __webpack_require__(750),
	  'forInRight': __webpack_require__(751),
	  'forOwn': __webpack_require__(752),
	  'forOwnRight': __webpack_require__(753),
	  'functions': __webpack_require__(754),
	  'functionsIn': __webpack_require__(755),
	  'get': __webpack_require__(207),
	  'has': __webpack_require__(756),
	  'hasIn': __webpack_require__(208),
	  'invert': __webpack_require__(757),
	  'invertBy': __webpack_require__(758),
	  'invoke': __webpack_require__(759),
	  'keys': __webpack_require__(30),
	  'keysIn': __webpack_require__(31),
	  'mapKeys': __webpack_require__(761),
	  'mapValues': __webpack_require__(762),
	  'merge': __webpack_require__(764),
	  'mergeWith': __webpack_require__(339),
	  'omit': __webpack_require__(766),
	  'omitBy': __webpack_require__(767),
	  'pick': __webpack_require__(768),
	  'pickBy': __webpack_require__(340),
	  'result': __webpack_require__(770),
	  'set': __webpack_require__(771),
	  'setWith': __webpack_require__(772),
	  'toPairs': __webpack_require__(342),
	  'toPairsIn': __webpack_require__(343),
	  'transform': __webpack_require__(776),
	  'unset': __webpack_require__(777),
	  'update': __webpack_require__(778),
	  'updateWith': __webpack_require__(779),
	  'values': __webpack_require__(780),
	  'valuesIn': __webpack_require__(781)
	};


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.defaultUtils = undefined;
	exports.dateTimeFormat = dateTimeFormat;
	exports.getYear = getYear;
	exports.setYear = setYear;
	exports.addDays = addDays;
	exports.addMonths = addMonths;
	exports.addYears = addYears;
	exports.cloneDate = cloneDate;
	exports.cloneAsDate = cloneAsDate;
	exports.getDaysInMonth = getDaysInMonth;
	exports.getFirstDayOfMonth = getFirstDayOfMonth;
	exports.getFirstDayOfWeek = getFirstDayOfWeek;
	exports.getWeekArray = getWeekArray;
	exports.localizedWeekday = localizedWeekday;
	exports.formatIso = formatIso;
	exports.isEqualDate = isEqualDate;
	exports.isBeforeDate = isBeforeDate;
	exports.isAfterDate = isAfterDate;
	exports.isBetweenDates = isBetweenDates;
	exports.monthDiff = monthDiff;
	exports.yearDiff = yearDiff;
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dayAbbreviation = ['S', 'M', 'T', 'W', 'T', 'F', 'S'];
	var dayList = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
	var monthList = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
	var monthLongList = ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
	
	function dateTimeFormat(locale, options) {
	   false ? (0, _warning2.default)(locale === 'en-US', 'Material-UI: The ' + locale + ' locale is not supported by the built-in DateTimeFormat.\n  Use the `DateTimeFormat` prop to supply an alternative implementation.') : void 0;
	
	  this.format = function (date) {
	    if (options.month === 'short' && options.weekday === 'short' && options.day === '2-digit') {
	      return dayList[date.getDay()] + ', ' + monthList[date.getMonth()] + ' ' + date.getDate();
	    } else if (options.year === 'numeric' && options.month === 'numeric' && options.day === 'numeric') {
	      return date.getMonth() + 1 + '/' + date.getDate() + '/' + date.getFullYear();
	    } else if (options.year === 'numeric' && options.month === 'long') {
	      return monthLongList[date.getMonth()] + ' ' + date.getFullYear();
	    } else if (options.weekday === 'narrow') {
	      return dayAbbreviation[date.getDay()];
	    } else if (options.year === 'numeric') {
	      return date.getFullYear().toString();
	    } else if (options.day === 'numeric') {
	      return date.getDate();
	    } else {
	       false ? (0, _warning2.default)(false, 'Material-UI: Wrong usage of DateTimeFormat') : void 0;
	    }
	  };
	}
	
	function getYear(d) {
	  return d.getFullYear();
	}
	
	function setYear(d, year) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(year);
	  return newDate;
	}
	
	function addDays(d, days) {
	  var newDate = cloneDate(d);
	  newDate.setDate(d.getDate() + days);
	  return newDate;
	}
	
	function addMonths(d, months) {
	  var newDate = cloneDate(d);
	  newDate.setMonth(d.getMonth() + months);
	  return newDate;
	}
	
	function addYears(d, years) {
	  var newDate = cloneDate(d);
	  newDate.setFullYear(d.getFullYear() + years);
	  return newDate;
	}
	
	function cloneDate(d) {
	  return new Date(d.getTime());
	}
	
	function cloneAsDate(d) {
	  var clonedDate = cloneDate(d);
	  clonedDate.setHours(0, 0, 0, 0);
	  return clonedDate;
	}
	
	function getDaysInMonth(d) {
	  var resultDate = getFirstDayOfMonth(d);
	
	  resultDate.setMonth(resultDate.getMonth() + 1);
	  resultDate.setDate(resultDate.getDate() - 1);
	
	  return resultDate.getDate();
	}
	
	function getFirstDayOfMonth(d) {
	  return new Date(d.getFullYear(), d.getMonth(), 1);
	}
	
	function getFirstDayOfWeek() {
	  var now = new Date();
	  return new Date(now.setDate(now.getDate() - now.getDay()));
	}
	
	function getWeekArray(d, firstDayOfWeek) {
	  var dayArray = [];
	  var daysInMonth = getDaysInMonth(d);
	  var weekArray = [];
	  var week = [];
	
	  for (var i = 1; i <= daysInMonth; i++) {
	    dayArray.push(new Date(d.getFullYear(), d.getMonth(), i));
	  }
	
	  var addWeek = function addWeek(week) {
	    var emptyDays = 7 - week.length;
	    for (var _i = 0; _i < emptyDays; ++_i) {
	      week[weekArray.length ? 'push' : 'unshift'](null);
	    }
	    weekArray.push(week);
	  };
	
	  dayArray.forEach(function (day) {
	    if (week.length > 0 && day.getDay() === firstDayOfWeek) {
	      addWeek(week);
	      week = [];
	    }
	    week.push(day);
	    if (dayArray.indexOf(day) === dayArray.length - 1) {
	      addWeek(week);
	    }
	  });
	
	  return weekArray;
	}
	
	function localizedWeekday(DateTimeFormat, locale, day, firstDayOfWeek) {
	  var weekdayFormatter = new DateTimeFormat(locale, { weekday: 'narrow' });
	  var firstDayDate = getFirstDayOfWeek();
	
	  return weekdayFormatter.format(addDays(firstDayDate, day + firstDayOfWeek));
	}
	
	// Convert date to ISO 8601 (YYYY-MM-DD) date string, accounting for current timezone
	function formatIso(date) {
	  return new Date(date.toDateString() + ' 12:00:00 +0000').toISOString().substring(0, 10);
	}
	
	function isEqualDate(d1, d2) {
	  return d1 && d2 && d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
	}
	
	function isBeforeDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() < date2.getTime();
	}
	
	function isAfterDate(d1, d2) {
	  var date1 = cloneAsDate(d1);
	  var date2 = cloneAsDate(d2);
	
	  return date1.getTime() > date2.getTime();
	}
	
	function isBetweenDates(dateToCheck, startDate, endDate) {
	  return !isBeforeDate(dateToCheck, startDate) && !isAfterDate(dateToCheck, endDate);
	}
	
	function monthDiff(d1, d2) {
	  var m = void 0;
	  m = (d1.getFullYear() - d2.getFullYear()) * 12;
	  m += d1.getMonth();
	  m -= d2.getMonth();
	  return m;
	}
	
	function yearDiff(d1, d2) {
	  return ~~(monthDiff(d1, d2) / 12);
	}
	
	var defaultUtils = exports.defaultUtils = {
	  getYear: getYear,
	  setYear: setYear,
	  addDays: addDays,
	  addMonths: addMonths,
	  addYears: addYears,
	  getFirstDayOfMonth: getFirstDayOfMonth,
	  getWeekArray: getWeekArray,
	  monthDiff: monthDiff
	};

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TextField = __webpack_require__(858);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TextField2.default;

/***/ },
/* 116 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.addHours = addHours;
	exports.addMinutes = addMinutes;
	exports.addSeconds = addSeconds;
	exports.formatTime = formatTime;
	exports.rad2deg = rad2deg;
	exports.getTouchEventOffsetValues = getTouchEventOffsetValues;
	exports.isInner = isInner;
	function addHours(d, hours) {
	  var newDate = clone(d);
	  newDate.setHours(d.getHours() + hours);
	  return newDate;
	}
	
	function addMinutes(d, minutes) {
	  var newDate = clone(d);
	  newDate.setMinutes(d.getMinutes() + minutes);
	  return newDate;
	}
	
	function addSeconds(d, seconds) {
	  var newDate = clone(d);
	  newDate.setSeconds(d.getMinutes() + seconds);
	  return newDate;
	}
	
	function clone(d) {
	  return new Date(d.getTime());
	}
	
	/**
	 * @param date [Date] A Date object.
	 * @param format [String] One of 'ampm', '24hr', defaults to 'ampm'.
	 * @param pedantic [Boolean] Check time-picker/time-picker.jsx file.
	 *
	 * @return String A string representing the formatted time.
	 */
	function formatTime(date) {
	  var format = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'ampm';
	  var pedantic = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  if (!date) return '';
	  var hours = date.getHours();
	  var mins = date.getMinutes().toString();
	
	  if (format === 'ampm') {
	    var isAM = hours < 12;
	    hours = hours % 12;
	    var additional = isAM ? ' am' : ' pm';
	    hours = (hours || 12).toString();
	
	    if (mins.length < 2) mins = '0' + mins;
	
	    if (pedantic) {
	      // Treat midday/midnight specially http://www.nist.gov/pml/div688/times.cfm
	      if (hours === '12' && mins === '00') {
	        return additional === ' pm' ? '12 noon' : '12 midnight';
	      }
	    }
	
	    return hours + (mins === '00' ? '' : ':' + mins) + additional;
	  }
	
	  hours = hours.toString();
	
	  if (hours.length < 2) hours = '0' + hours;
	  if (mins.length < 2) mins = '0' + mins;
	
	  return hours + ':' + mins;
	}
	
	function rad2deg(rad) {
	  return rad * 57.29577951308232;
	}
	
	function getTouchEventOffsetValues(event) {
	  var el = event.target;
	  var boundingRect = el.getBoundingClientRect();
	
	  return {
	    offsetX: event.clientX - boundingRect.left,
	    offsetY: event.clientY - boundingRect.top
	  };
	}
	
	function isInner(props) {
	  if (props.type !== 'hour') {
	    return false;
	  }
	  return props.value < 1 || props.value > 12;
	}

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createChildFragment = createChildFragment;
	exports.extendChildren = extendChildren;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactAddonsCreateFragment = __webpack_require__(1851);
	
	var _reactAddonsCreateFragment2 = _interopRequireDefault(_reactAddonsCreateFragment);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createChildFragment(fragments) {
	  var newFragments = {};
	  var validChildrenCount = 0;
	  var firstKey = void 0;
	
	  // Only create non-empty key fragments
	  for (var key in fragments) {
	    var currentChild = fragments[key];
	
	    if (currentChild) {
	      if (validChildrenCount === 0) firstKey = key;
	      newFragments[key] = currentChild;
	      validChildrenCount++;
	    }
	  }
	
	  if (validChildrenCount === 0) return undefined;
	  if (validChildrenCount === 1) return newFragments[firstKey];
	  return (0, _reactAddonsCreateFragment2.default)(newFragments);
	}
	
	function extendChildren(children, extendedProps, extendedChildren) {
	  return _react2.default.Children.map(children, function (child) {
	    if (!_react2.default.isValidElement(child)) {
	      return child;
	    }
	
	    var newProps = typeof extendedProps === 'function' ? extendedProps(child) : extendedProps;
	
	    var newChildren = typeof extendedChildren === 'function' ? extendedChildren(child) : extendedChildren ? extendedChildren : child.props.children;
	
	    return _react2.default.cloneElement(child, newProps, newChildren);
	  });
	}

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	module.exports = __webpack_require__(1955);


/***/ },
/* 119 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `ReactInstanceMap` maintains a mapping from a public facing stateful
	 * instance (key) and the internal representation (value). This allows public
	 * methods to accept the user facing instance as an argument and map them back
	 * to internal methods.
	 */
	
	// TODO: Replace this with ES6: var ReactInstanceMap = new Map();
	
	var ReactInstanceMap = {
	  /**
	   * This API should be called `delete` but we'd have to make sure to always
	   * transform these to strings for IE support. When this transform is fully
	   * supported we can rename it.
	   */
	  remove: function (key) {
	    key._reactInternalInstance = undefined;
	  },
	
	  get: function (key) {
	    return key._reactInternalInstance;
	  },
	
	  has: function (key) {
	    return key._reactInternalInstance !== undefined;
	  },
	
	  set: function (key, value) {
	    key._reactInternalInstance = value;
	  }
	};
	
	module.exports = ReactInstanceMap;

/***/ },
/* 120 */
17,
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.compose = exports.applyMiddleware = exports.bindActionCreators = exports.combineReducers = exports.createStore = undefined;
	
	var _createStore = __webpack_require__(438);
	
	var _createStore2 = _interopRequireDefault(_createStore);
	
	var _combineReducers = __webpack_require__(1988);
	
	var _combineReducers2 = _interopRequireDefault(_combineReducers);
	
	var _bindActionCreators = __webpack_require__(1987);
	
	var _bindActionCreators2 = _interopRequireDefault(_bindActionCreators);
	
	var _applyMiddleware = __webpack_require__(1986);
	
	var _applyMiddleware2 = _interopRequireDefault(_applyMiddleware);
	
	var _compose = __webpack_require__(437);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _warning = __webpack_require__(439);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/*
	* This is a dummy function to check if the function name has been altered by minification.
	* If the function has been minified and NODE_ENV !== 'production', warn the user.
	*/
	function isCrushed() {}
	
	if (false) {
	  (0, _warning2['default'])('You are currently using minified code outside of NODE_ENV === \'production\'. ' + 'This means that you are running a slower development build of Redux. ' + 'You can use loose-envify (https://github.com/zertosh/loose-envify) for browserify ' + 'or DefinePlugin for webpack (http://stackoverflow.com/questions/30030031) ' + 'to ensure you have the correct code for your production build.');
	}
	
	exports.createStore = _createStore2['default'];
	exports.combineReducers = _combineReducers2['default'];
	exports.bindActionCreators = _bindActionCreators2['default'];
	exports.applyMiddleware = _applyMiddleware2['default'];
	exports.compose = _compose2['default'];

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getColours = exports.getContentDefinition = exports.getContentDefinitions = exports.getContentItemDefCategories = undefined;
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var cleanse = function cleanse(item) {
	  return item === undefined ? undefined : JSON.parse(JSON.stringify(item));
	};
	
	/**
	 * Returns the current set of item definition categories
	 * @param state
	 * @returns {Object.<ContentCategoryName>}
	 */
	/**
	 * Created by daniel on 23/04/17.
	 */
	var getContentItemDefCategories = exports.getContentItemDefCategories = function getContentItemDefCategories(state) {
	  return cleanse(state.editor.config.contentDefinitionCategories);
	};
	
	/**
	 * Returns all of the current set of content definitions
	 * @param state
	 * @returns {Array.<ContentDefinition>}
	 */
	var getContentDefinitions = exports.getContentDefinitions = function getContentDefinitions(state) {
	  return cleanse(state.editor.config.contentDefinitions);
	};
	
	/**
	 * Returns a single content item definition
	 * @param state
	 * @param configId
	 * @returns {ContentDefinition}
	 */
	var getContentDefinition = exports.getContentDefinition = function getContentDefinition(state, configId) {
	  return cleanse(_.head(_.filter(state.editor.config.contentDefinitions, { configId: configId })));
	};
	
	var getColours = exports.getColours = function getColours(state) {
	  return cleanse(state.editor.config.colors);
	};

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/*!
	 * The buffer module from node.js, for the browser.
	 *
	 * @author   Feross Aboukhadijeh <feross@feross.org> <http://feross.org>
	 * @license  MIT
	 */
	/* eslint-disable no-proto */
	
	'use strict'
	
	var base64 = __webpack_require__(496)
	var ieee754 = __webpack_require__(592)
	var isArray = __webpack_require__(287)
	
	exports.Buffer = Buffer
	exports.SlowBuffer = SlowBuffer
	exports.INSPECT_MAX_BYTES = 50
	
	/**
	 * If `Buffer.TYPED_ARRAY_SUPPORT`:
	 *   === true    Use Uint8Array implementation (fastest)
	 *   === false   Use Object implementation (most compatible, even IE6)
	 *
	 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
	 * Opera 11.6+, iOS 4.2+.
	 *
	 * Due to various browser bugs, sometimes the Object implementation will be used even
	 * when the browser supports typed arrays.
	 *
	 * Note:
	 *
	 *   - Firefox 4-29 lacks support for adding new properties to `Uint8Array` instances,
	 *     See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438.
	 *
	 *   - Chrome 9-10 is missing the `TypedArray.prototype.subarray` function.
	 *
	 *   - IE10 has a broken `TypedArray.prototype.subarray` function which returns arrays of
	 *     incorrect length in some situations.
	
	 * We detect these buggy browsers and set `Buffer.TYPED_ARRAY_SUPPORT` to `false` so they
	 * get the Object implementation, which is slower but behaves correctly.
	 */
	Buffer.TYPED_ARRAY_SUPPORT = global.TYPED_ARRAY_SUPPORT !== undefined
	  ? global.TYPED_ARRAY_SUPPORT
	  : typedArraySupport()
	
	/*
	 * Export kMaxLength after typed array support is determined.
	 */
	exports.kMaxLength = kMaxLength()
	
	function typedArraySupport () {
	  try {
	    var arr = new Uint8Array(1)
	    arr.__proto__ = {__proto__: Uint8Array.prototype, foo: function () { return 42 }}
	    return arr.foo() === 42 && // typed array instances can be augmented
	        typeof arr.subarray === 'function' && // chrome 9-10 lack `subarray`
	        arr.subarray(1, 1).byteLength === 0 // ie10 has broken `subarray`
	  } catch (e) {
	    return false
	  }
	}
	
	function kMaxLength () {
	  return Buffer.TYPED_ARRAY_SUPPORT
	    ? 0x7fffffff
	    : 0x3fffffff
	}
	
	function createBuffer (that, length) {
	  if (kMaxLength() < length) {
	    throw new RangeError('Invalid typed array length')
	  }
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = new Uint8Array(length)
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    if (that === null) {
	      that = new Buffer(length)
	    }
	    that.length = length
	  }
	
	  return that
	}
	
	/**
	 * The Buffer constructor returns instances of `Uint8Array` that have their
	 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
	 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
	 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
	 * returns a single octet.
	 *
	 * The `Uint8Array` prototype remains unmodified.
	 */
	
	function Buffer (arg, encodingOrOffset, length) {
	  if (!Buffer.TYPED_ARRAY_SUPPORT && !(this instanceof Buffer)) {
	    return new Buffer(arg, encodingOrOffset, length)
	  }
	
	  // Common case.
	  if (typeof arg === 'number') {
	    if (typeof encodingOrOffset === 'string') {
	      throw new Error(
	        'If encoding is specified then the first argument must be a string'
	      )
	    }
	    return allocUnsafe(this, arg)
	  }
	  return from(this, arg, encodingOrOffset, length)
	}
	
	Buffer.poolSize = 8192 // not used by this implementation
	
	// TODO: Legacy, not needed anymore. Remove in next major version.
	Buffer._augment = function (arr) {
	  arr.__proto__ = Buffer.prototype
	  return arr
	}
	
	function from (that, value, encodingOrOffset, length) {
	  if (typeof value === 'number') {
	    throw new TypeError('"value" argument must not be a number')
	  }
	
	  if (typeof ArrayBuffer !== 'undefined' && value instanceof ArrayBuffer) {
	    return fromArrayBuffer(that, value, encodingOrOffset, length)
	  }
	
	  if (typeof value === 'string') {
	    return fromString(that, value, encodingOrOffset)
	  }
	
	  return fromObject(that, value)
	}
	
	/**
	 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
	 * if value is a number.
	 * Buffer.from(str[, encoding])
	 * Buffer.from(array)
	 * Buffer.from(buffer)
	 * Buffer.from(arrayBuffer[, byteOffset[, length]])
	 **/
	Buffer.from = function (value, encodingOrOffset, length) {
	  return from(null, value, encodingOrOffset, length)
	}
	
	if (Buffer.TYPED_ARRAY_SUPPORT) {
	  Buffer.prototype.__proto__ = Uint8Array.prototype
	  Buffer.__proto__ = Uint8Array
	  if (typeof Symbol !== 'undefined' && Symbol.species &&
	      Buffer[Symbol.species] === Buffer) {
	    // Fix subarray() in ES2016. See: https://github.com/feross/buffer/pull/97
	    Object.defineProperty(Buffer, Symbol.species, {
	      value: null,
	      configurable: true
	    })
	  }
	}
	
	function assertSize (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('"size" argument must be a number')
	  } else if (size < 0) {
	    throw new RangeError('"size" argument must not be negative')
	  }
	}
	
	function alloc (that, size, fill, encoding) {
	  assertSize(size)
	  if (size <= 0) {
	    return createBuffer(that, size)
	  }
	  if (fill !== undefined) {
	    // Only pay attention to encoding if it's a string. This
	    // prevents accidentally sending in a number that would
	    // be interpretted as a start offset.
	    return typeof encoding === 'string'
	      ? createBuffer(that, size).fill(fill, encoding)
	      : createBuffer(that, size).fill(fill)
	  }
	  return createBuffer(that, size)
	}
	
	/**
	 * Creates a new filled Buffer instance.
	 * alloc(size[, fill[, encoding]])
	 **/
	Buffer.alloc = function (size, fill, encoding) {
	  return alloc(null, size, fill, encoding)
	}
	
	function allocUnsafe (that, size) {
	  assertSize(size)
	  that = createBuffer(that, size < 0 ? 0 : checked(size) | 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) {
	    for (var i = 0; i < size; ++i) {
	      that[i] = 0
	    }
	  }
	  return that
	}
	
	/**
	 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
	 * */
	Buffer.allocUnsafe = function (size) {
	  return allocUnsafe(null, size)
	}
	/**
	 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
	 */
	Buffer.allocUnsafeSlow = function (size) {
	  return allocUnsafe(null, size)
	}
	
	function fromString (that, string, encoding) {
	  if (typeof encoding !== 'string' || encoding === '') {
	    encoding = 'utf8'
	  }
	
	  if (!Buffer.isEncoding(encoding)) {
	    throw new TypeError('"encoding" must be a valid string encoding')
	  }
	
	  var length = byteLength(string, encoding) | 0
	  that = createBuffer(that, length)
	
	  var actual = that.write(string, encoding)
	
	  if (actual !== length) {
	    // Writing a hex string, for example, that contains invalid characters will
	    // cause everything after the first invalid character to be ignored. (e.g.
	    // 'abxxcd' will be treated as 'ab')
	    that = that.slice(0, actual)
	  }
	
	  return that
	}
	
	function fromArrayLike (that, array) {
	  var length = array.length < 0 ? 0 : checked(array.length) | 0
	  that = createBuffer(that, length)
	  for (var i = 0; i < length; i += 1) {
	    that[i] = array[i] & 255
	  }
	  return that
	}
	
	function fromArrayBuffer (that, array, byteOffset, length) {
	  array.byteLength // this throws if `array` is not a valid ArrayBuffer
	
	  if (byteOffset < 0 || array.byteLength < byteOffset) {
	    throw new RangeError('\'offset\' is out of bounds')
	  }
	
	  if (array.byteLength < byteOffset + (length || 0)) {
	    throw new RangeError('\'length\' is out of bounds')
	  }
	
	  if (byteOffset === undefined && length === undefined) {
	    array = new Uint8Array(array)
	  } else if (length === undefined) {
	    array = new Uint8Array(array, byteOffset)
	  } else {
	    array = new Uint8Array(array, byteOffset, length)
	  }
	
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    // Return an augmented `Uint8Array` instance, for best performance
	    that = array
	    that.__proto__ = Buffer.prototype
	  } else {
	    // Fallback: Return an object instance of the Buffer class
	    that = fromArrayLike(that, array)
	  }
	  return that
	}
	
	function fromObject (that, obj) {
	  if (Buffer.isBuffer(obj)) {
	    var len = checked(obj.length) | 0
	    that = createBuffer(that, len)
	
	    if (that.length === 0) {
	      return that
	    }
	
	    obj.copy(that, 0, 0, len)
	    return that
	  }
	
	  if (obj) {
	    if ((typeof ArrayBuffer !== 'undefined' &&
	        obj.buffer instanceof ArrayBuffer) || 'length' in obj) {
	      if (typeof obj.length !== 'number' || isnan(obj.length)) {
	        return createBuffer(that, 0)
	      }
	      return fromArrayLike(that, obj)
	    }
	
	    if (obj.type === 'Buffer' && isArray(obj.data)) {
	      return fromArrayLike(that, obj.data)
	    }
	  }
	
	  throw new TypeError('First argument must be a string, Buffer, ArrayBuffer, Array, or array-like object.')
	}
	
	function checked (length) {
	  // Note: cannot use `length < kMaxLength()` here because that fails when
	  // length is NaN (which is otherwise coerced to zero.)
	  if (length >= kMaxLength()) {
	    throw new RangeError('Attempt to allocate Buffer larger than maximum ' +
	                         'size: 0x' + kMaxLength().toString(16) + ' bytes')
	  }
	  return length | 0
	}
	
	function SlowBuffer (length) {
	  if (+length != length) { // eslint-disable-line eqeqeq
	    length = 0
	  }
	  return Buffer.alloc(+length)
	}
	
	Buffer.isBuffer = function isBuffer (b) {
	  return !!(b != null && b._isBuffer)
	}
	
	Buffer.compare = function compare (a, b) {
	  if (!Buffer.isBuffer(a) || !Buffer.isBuffer(b)) {
	    throw new TypeError('Arguments must be Buffers')
	  }
	
	  if (a === b) return 0
	
	  var x = a.length
	  var y = b.length
	
	  for (var i = 0, len = Math.min(x, y); i < len; ++i) {
	    if (a[i] !== b[i]) {
	      x = a[i]
	      y = b[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	Buffer.isEncoding = function isEncoding (encoding) {
	  switch (String(encoding).toLowerCase()) {
	    case 'hex':
	    case 'utf8':
	    case 'utf-8':
	    case 'ascii':
	    case 'latin1':
	    case 'binary':
	    case 'base64':
	    case 'ucs2':
	    case 'ucs-2':
	    case 'utf16le':
	    case 'utf-16le':
	      return true
	    default:
	      return false
	  }
	}
	
	Buffer.concat = function concat (list, length) {
	  if (!isArray(list)) {
	    throw new TypeError('"list" argument must be an Array of Buffers')
	  }
	
	  if (list.length === 0) {
	    return Buffer.alloc(0)
	  }
	
	  var i
	  if (length === undefined) {
	    length = 0
	    for (i = 0; i < list.length; ++i) {
	      length += list[i].length
	    }
	  }
	
	  var buffer = Buffer.allocUnsafe(length)
	  var pos = 0
	  for (i = 0; i < list.length; ++i) {
	    var buf = list[i]
	    if (!Buffer.isBuffer(buf)) {
	      throw new TypeError('"list" argument must be an Array of Buffers')
	    }
	    buf.copy(buffer, pos)
	    pos += buf.length
	  }
	  return buffer
	}
	
	function byteLength (string, encoding) {
	  if (Buffer.isBuffer(string)) {
	    return string.length
	  }
	  if (typeof ArrayBuffer !== 'undefined' && typeof ArrayBuffer.isView === 'function' &&
	      (ArrayBuffer.isView(string) || string instanceof ArrayBuffer)) {
	    return string.byteLength
	  }
	  if (typeof string !== 'string') {
	    string = '' + string
	  }
	
	  var len = string.length
	  if (len === 0) return 0
	
	  // Use a for loop to avoid recursion
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'ascii':
	      case 'latin1':
	      case 'binary':
	        return len
	      case 'utf8':
	      case 'utf-8':
	      case undefined:
	        return utf8ToBytes(string).length
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return len * 2
	      case 'hex':
	        return len >>> 1
	      case 'base64':
	        return base64ToBytes(string).length
	      default:
	        if (loweredCase) return utf8ToBytes(string).length // assume utf8
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	Buffer.byteLength = byteLength
	
	function slowToString (encoding, start, end) {
	  var loweredCase = false
	
	  // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
	  // property of a typed array.
	
	  // This behaves neither like String nor Uint8Array in that we set start/end
	  // to their upper/lower bounds if the value passed is out of range.
	  // undefined is handled specially as per ECMA-262 6th Edition,
	  // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
	  if (start === undefined || start < 0) {
	    start = 0
	  }
	  // Return early if start > this.length. Done here to prevent potential uint32
	  // coercion fail below.
	  if (start > this.length) {
	    return ''
	  }
	
	  if (end === undefined || end > this.length) {
	    end = this.length
	  }
	
	  if (end <= 0) {
	    return ''
	  }
	
	  // Force coersion to uint32. This will also coerce falsey/NaN values to 0.
	  end >>>= 0
	  start >>>= 0
	
	  if (end <= start) {
	    return ''
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  while (true) {
	    switch (encoding) {
	      case 'hex':
	        return hexSlice(this, start, end)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Slice(this, start, end)
	
	      case 'ascii':
	        return asciiSlice(this, start, end)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Slice(this, start, end)
	
	      case 'base64':
	        return base64Slice(this, start, end)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return utf16leSlice(this, start, end)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = (encoding + '').toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	// The property is used by `Buffer.isBuffer` and `is-buffer` (in Safari 5-7) to detect
	// Buffer instances.
	Buffer.prototype._isBuffer = true
	
	function swap (b, n, m) {
	  var i = b[n]
	  b[n] = b[m]
	  b[m] = i
	}
	
	Buffer.prototype.swap16 = function swap16 () {
	  var len = this.length
	  if (len % 2 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 16-bits')
	  }
	  for (var i = 0; i < len; i += 2) {
	    swap(this, i, i + 1)
	  }
	  return this
	}
	
	Buffer.prototype.swap32 = function swap32 () {
	  var len = this.length
	  if (len % 4 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 32-bits')
	  }
	  for (var i = 0; i < len; i += 4) {
	    swap(this, i, i + 3)
	    swap(this, i + 1, i + 2)
	  }
	  return this
	}
	
	Buffer.prototype.swap64 = function swap64 () {
	  var len = this.length
	  if (len % 8 !== 0) {
	    throw new RangeError('Buffer size must be a multiple of 64-bits')
	  }
	  for (var i = 0; i < len; i += 8) {
	    swap(this, i, i + 7)
	    swap(this, i + 1, i + 6)
	    swap(this, i + 2, i + 5)
	    swap(this, i + 3, i + 4)
	  }
	  return this
	}
	
	Buffer.prototype.toString = function toString () {
	  var length = this.length | 0
	  if (length === 0) return ''
	  if (arguments.length === 0) return utf8Slice(this, 0, length)
	  return slowToString.apply(this, arguments)
	}
	
	Buffer.prototype.equals = function equals (b) {
	  if (!Buffer.isBuffer(b)) throw new TypeError('Argument must be a Buffer')
	  if (this === b) return true
	  return Buffer.compare(this, b) === 0
	}
	
	Buffer.prototype.inspect = function inspect () {
	  var str = ''
	  var max = exports.INSPECT_MAX_BYTES
	  if (this.length > 0) {
	    str = this.toString('hex', 0, max).match(/.{2}/g).join(' ')
	    if (this.length > max) str += ' ... '
	  }
	  return '<Buffer ' + str + '>'
	}
	
	Buffer.prototype.compare = function compare (target, start, end, thisStart, thisEnd) {
	  if (!Buffer.isBuffer(target)) {
	    throw new TypeError('Argument must be a Buffer')
	  }
	
	  if (start === undefined) {
	    start = 0
	  }
	  if (end === undefined) {
	    end = target ? target.length : 0
	  }
	  if (thisStart === undefined) {
	    thisStart = 0
	  }
	  if (thisEnd === undefined) {
	    thisEnd = this.length
	  }
	
	  if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) {
	    throw new RangeError('out of range index')
	  }
	
	  if (thisStart >= thisEnd && start >= end) {
	    return 0
	  }
	  if (thisStart >= thisEnd) {
	    return -1
	  }
	  if (start >= end) {
	    return 1
	  }
	
	  start >>>= 0
	  end >>>= 0
	  thisStart >>>= 0
	  thisEnd >>>= 0
	
	  if (this === target) return 0
	
	  var x = thisEnd - thisStart
	  var y = end - start
	  var len = Math.min(x, y)
	
	  var thisCopy = this.slice(thisStart, thisEnd)
	  var targetCopy = target.slice(start, end)
	
	  for (var i = 0; i < len; ++i) {
	    if (thisCopy[i] !== targetCopy[i]) {
	      x = thisCopy[i]
	      y = targetCopy[i]
	      break
	    }
	  }
	
	  if (x < y) return -1
	  if (y < x) return 1
	  return 0
	}
	
	// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
	// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
	//
	// Arguments:
	// - buffer - a Buffer to search
	// - val - a string, Buffer, or number
	// - byteOffset - an index into `buffer`; will be clamped to an int32
	// - encoding - an optional encoding, relevant is val is a string
	// - dir - true for indexOf, false for lastIndexOf
	function bidirectionalIndexOf (buffer, val, byteOffset, encoding, dir) {
	  // Empty buffer means no match
	  if (buffer.length === 0) return -1
	
	  // Normalize byteOffset
	  if (typeof byteOffset === 'string') {
	    encoding = byteOffset
	    byteOffset = 0
	  } else if (byteOffset > 0x7fffffff) {
	    byteOffset = 0x7fffffff
	  } else if (byteOffset < -0x80000000) {
	    byteOffset = -0x80000000
	  }
	  byteOffset = +byteOffset  // Coerce to Number.
	  if (isNaN(byteOffset)) {
	    // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
	    byteOffset = dir ? 0 : (buffer.length - 1)
	  }
	
	  // Normalize byteOffset: negative offsets start from the end of the buffer
	  if (byteOffset < 0) byteOffset = buffer.length + byteOffset
	  if (byteOffset >= buffer.length) {
	    if (dir) return -1
	    else byteOffset = buffer.length - 1
	  } else if (byteOffset < 0) {
	    if (dir) byteOffset = 0
	    else return -1
	  }
	
	  // Normalize val
	  if (typeof val === 'string') {
	    val = Buffer.from(val, encoding)
	  }
	
	  // Finally, search either indexOf (if dir is true) or lastIndexOf
	  if (Buffer.isBuffer(val)) {
	    // Special case: looking for empty string/buffer always fails
	    if (val.length === 0) {
	      return -1
	    }
	    return arrayIndexOf(buffer, val, byteOffset, encoding, dir)
	  } else if (typeof val === 'number') {
	    val = val & 0xFF // Search for a byte value [0-255]
	    if (Buffer.TYPED_ARRAY_SUPPORT &&
	        typeof Uint8Array.prototype.indexOf === 'function') {
	      if (dir) {
	        return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset)
	      } else {
	        return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset)
	      }
	    }
	    return arrayIndexOf(buffer, [ val ], byteOffset, encoding, dir)
	  }
	
	  throw new TypeError('val must be string, number or Buffer')
	}
	
	function arrayIndexOf (arr, val, byteOffset, encoding, dir) {
	  var indexSize = 1
	  var arrLength = arr.length
	  var valLength = val.length
	
	  if (encoding !== undefined) {
	    encoding = String(encoding).toLowerCase()
	    if (encoding === 'ucs2' || encoding === 'ucs-2' ||
	        encoding === 'utf16le' || encoding === 'utf-16le') {
	      if (arr.length < 2 || val.length < 2) {
	        return -1
	      }
	      indexSize = 2
	      arrLength /= 2
	      valLength /= 2
	      byteOffset /= 2
	    }
	  }
	
	  function read (buf, i) {
	    if (indexSize === 1) {
	      return buf[i]
	    } else {
	      return buf.readUInt16BE(i * indexSize)
	    }
	  }
	
	  var i
	  if (dir) {
	    var foundIndex = -1
	    for (i = byteOffset; i < arrLength; i++) {
	      if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
	        if (foundIndex === -1) foundIndex = i
	        if (i - foundIndex + 1 === valLength) return foundIndex * indexSize
	      } else {
	        if (foundIndex !== -1) i -= i - foundIndex
	        foundIndex = -1
	      }
	    }
	  } else {
	    if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength
	    for (i = byteOffset; i >= 0; i--) {
	      var found = true
	      for (var j = 0; j < valLength; j++) {
	        if (read(arr, i + j) !== read(val, j)) {
	          found = false
	          break
	        }
	      }
	      if (found) return i
	    }
	  }
	
	  return -1
	}
	
	Buffer.prototype.includes = function includes (val, byteOffset, encoding) {
	  return this.indexOf(val, byteOffset, encoding) !== -1
	}
	
	Buffer.prototype.indexOf = function indexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, true)
	}
	
	Buffer.prototype.lastIndexOf = function lastIndexOf (val, byteOffset, encoding) {
	  return bidirectionalIndexOf(this, val, byteOffset, encoding, false)
	}
	
	function hexWrite (buf, string, offset, length) {
	  offset = Number(offset) || 0
	  var remaining = buf.length - offset
	  if (!length) {
	    length = remaining
	  } else {
	    length = Number(length)
	    if (length > remaining) {
	      length = remaining
	    }
	  }
	
	  // must be an even number of digits
	  var strLen = string.length
	  if (strLen % 2 !== 0) throw new TypeError('Invalid hex string')
	
	  if (length > strLen / 2) {
	    length = strLen / 2
	  }
	  for (var i = 0; i < length; ++i) {
	    var parsed = parseInt(string.substr(i * 2, 2), 16)
	    if (isNaN(parsed)) return i
	    buf[offset + i] = parsed
	  }
	  return i
	}
	
	function utf8Write (buf, string, offset, length) {
	  return blitBuffer(utf8ToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	function asciiWrite (buf, string, offset, length) {
	  return blitBuffer(asciiToBytes(string), buf, offset, length)
	}
	
	function latin1Write (buf, string, offset, length) {
	  return asciiWrite(buf, string, offset, length)
	}
	
	function base64Write (buf, string, offset, length) {
	  return blitBuffer(base64ToBytes(string), buf, offset, length)
	}
	
	function ucs2Write (buf, string, offset, length) {
	  return blitBuffer(utf16leToBytes(string, buf.length - offset), buf, offset, length)
	}
	
	Buffer.prototype.write = function write (string, offset, length, encoding) {
	  // Buffer#write(string)
	  if (offset === undefined) {
	    encoding = 'utf8'
	    length = this.length
	    offset = 0
	  // Buffer#write(string, encoding)
	  } else if (length === undefined && typeof offset === 'string') {
	    encoding = offset
	    length = this.length
	    offset = 0
	  // Buffer#write(string, offset[, length][, encoding])
	  } else if (isFinite(offset)) {
	    offset = offset | 0
	    if (isFinite(length)) {
	      length = length | 0
	      if (encoding === undefined) encoding = 'utf8'
	    } else {
	      encoding = length
	      length = undefined
	    }
	  // legacy write(string, encoding, offset, length) - remove in v0.13
	  } else {
	    throw new Error(
	      'Buffer.write(string, encoding, offset[, length]) is no longer supported'
	    )
	  }
	
	  var remaining = this.length - offset
	  if (length === undefined || length > remaining) length = remaining
	
	  if ((string.length > 0 && (length < 0 || offset < 0)) || offset > this.length) {
	    throw new RangeError('Attempt to write outside buffer bounds')
	  }
	
	  if (!encoding) encoding = 'utf8'
	
	  var loweredCase = false
	  for (;;) {
	    switch (encoding) {
	      case 'hex':
	        return hexWrite(this, string, offset, length)
	
	      case 'utf8':
	      case 'utf-8':
	        return utf8Write(this, string, offset, length)
	
	      case 'ascii':
	        return asciiWrite(this, string, offset, length)
	
	      case 'latin1':
	      case 'binary':
	        return latin1Write(this, string, offset, length)
	
	      case 'base64':
	        // Warning: maxLength not taken into account in base64Write
	        return base64Write(this, string, offset, length)
	
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return ucs2Write(this, string, offset, length)
	
	      default:
	        if (loweredCase) throw new TypeError('Unknown encoding: ' + encoding)
	        encoding = ('' + encoding).toLowerCase()
	        loweredCase = true
	    }
	  }
	}
	
	Buffer.prototype.toJSON = function toJSON () {
	  return {
	    type: 'Buffer',
	    data: Array.prototype.slice.call(this._arr || this, 0)
	  }
	}
	
	function base64Slice (buf, start, end) {
	  if (start === 0 && end === buf.length) {
	    return base64.fromByteArray(buf)
	  } else {
	    return base64.fromByteArray(buf.slice(start, end))
	  }
	}
	
	function utf8Slice (buf, start, end) {
	  end = Math.min(buf.length, end)
	  var res = []
	
	  var i = start
	  while (i < end) {
	    var firstByte = buf[i]
	    var codePoint = null
	    var bytesPerSequence = (firstByte > 0xEF) ? 4
	      : (firstByte > 0xDF) ? 3
	      : (firstByte > 0xBF) ? 2
	      : 1
	
	    if (i + bytesPerSequence <= end) {
	      var secondByte, thirdByte, fourthByte, tempCodePoint
	
	      switch (bytesPerSequence) {
	        case 1:
	          if (firstByte < 0x80) {
	            codePoint = firstByte
	          }
	          break
	        case 2:
	          secondByte = buf[i + 1]
	          if ((secondByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0x1F) << 0x6 | (secondByte & 0x3F)
	            if (tempCodePoint > 0x7F) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 3:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | (thirdByte & 0x3F)
	            if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) {
	              codePoint = tempCodePoint
	            }
	          }
	          break
	        case 4:
	          secondByte = buf[i + 1]
	          thirdByte = buf[i + 2]
	          fourthByte = buf[i + 3]
	          if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
	            tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | (fourthByte & 0x3F)
	            if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) {
	              codePoint = tempCodePoint
	            }
	          }
	      }
	    }
	
	    if (codePoint === null) {
	      // we did not generate a valid codePoint so insert a
	      // replacement char (U+FFFD) and advance only 1 byte
	      codePoint = 0xFFFD
	      bytesPerSequence = 1
	    } else if (codePoint > 0xFFFF) {
	      // encode to utf16 (surrogate pair dance)
	      codePoint -= 0x10000
	      res.push(codePoint >>> 10 & 0x3FF | 0xD800)
	      codePoint = 0xDC00 | codePoint & 0x3FF
	    }
	
	    res.push(codePoint)
	    i += bytesPerSequence
	  }
	
	  return decodeCodePointsArray(res)
	}
	
	// Based on http://stackoverflow.com/a/22747272/680742, the browser with
	// the lowest limit is Chrome, with 0x10000 args.
	// We go 1 magnitude less, for safety
	var MAX_ARGUMENTS_LENGTH = 0x1000
	
	function decodeCodePointsArray (codePoints) {
	  var len = codePoints.length
	  if (len <= MAX_ARGUMENTS_LENGTH) {
	    return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
	  }
	
	  // Decode in chunks to avoid "call stack size exceeded".
	  var res = ''
	  var i = 0
	  while (i < len) {
	    res += String.fromCharCode.apply(
	      String,
	      codePoints.slice(i, i += MAX_ARGUMENTS_LENGTH)
	    )
	  }
	  return res
	}
	
	function asciiSlice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i] & 0x7F)
	  }
	  return ret
	}
	
	function latin1Slice (buf, start, end) {
	  var ret = ''
	  end = Math.min(buf.length, end)
	
	  for (var i = start; i < end; ++i) {
	    ret += String.fromCharCode(buf[i])
	  }
	  return ret
	}
	
	function hexSlice (buf, start, end) {
	  var len = buf.length
	
	  if (!start || start < 0) start = 0
	  if (!end || end < 0 || end > len) end = len
	
	  var out = ''
	  for (var i = start; i < end; ++i) {
	    out += toHex(buf[i])
	  }
	  return out
	}
	
	function utf16leSlice (buf, start, end) {
	  var bytes = buf.slice(start, end)
	  var res = ''
	  for (var i = 0; i < bytes.length; i += 2) {
	    res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256)
	  }
	  return res
	}
	
	Buffer.prototype.slice = function slice (start, end) {
	  var len = this.length
	  start = ~~start
	  end = end === undefined ? len : ~~end
	
	  if (start < 0) {
	    start += len
	    if (start < 0) start = 0
	  } else if (start > len) {
	    start = len
	  }
	
	  if (end < 0) {
	    end += len
	    if (end < 0) end = 0
	  } else if (end > len) {
	    end = len
	  }
	
	  if (end < start) end = start
	
	  var newBuf
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    newBuf = this.subarray(start, end)
	    newBuf.__proto__ = Buffer.prototype
	  } else {
	    var sliceLen = end - start
	    newBuf = new Buffer(sliceLen, undefined)
	    for (var i = 0; i < sliceLen; ++i) {
	      newBuf[i] = this[i + start]
	    }
	  }
	
	  return newBuf
	}
	
	/*
	 * Need to make sure that buffer isn't trying to write out of bounds.
	 */
	function checkOffset (offset, ext, length) {
	  if ((offset % 1) !== 0 || offset < 0) throw new RangeError('offset is not uint')
	  if (offset + ext > length) throw new RangeError('Trying to access beyond buffer length')
	}
	
	Buffer.prototype.readUIntLE = function readUIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUIntBE = function readUIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    checkOffset(offset, byteLength, this.length)
	  }
	
	  var val = this[offset + --byteLength]
	  var mul = 1
	  while (byteLength > 0 && (mul *= 0x100)) {
	    val += this[offset + --byteLength] * mul
	  }
	
	  return val
	}
	
	Buffer.prototype.readUInt8 = function readUInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  return this[offset]
	}
	
	Buffer.prototype.readUInt16LE = function readUInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return this[offset] | (this[offset + 1] << 8)
	}
	
	Buffer.prototype.readUInt16BE = function readUInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  return (this[offset] << 8) | this[offset + 1]
	}
	
	Buffer.prototype.readUInt32LE = function readUInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return ((this[offset]) |
	      (this[offset + 1] << 8) |
	      (this[offset + 2] << 16)) +
	      (this[offset + 3] * 0x1000000)
	}
	
	Buffer.prototype.readUInt32BE = function readUInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] * 0x1000000) +
	    ((this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    this[offset + 3])
	}
	
	Buffer.prototype.readIntLE = function readIntLE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var val = this[offset]
	  var mul = 1
	  var i = 0
	  while (++i < byteLength && (mul *= 0x100)) {
	    val += this[offset + i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readIntBE = function readIntBE (offset, byteLength, noAssert) {
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) checkOffset(offset, byteLength, this.length)
	
	  var i = byteLength
	  var mul = 1
	  var val = this[offset + --i]
	  while (i > 0 && (mul *= 0x100)) {
	    val += this[offset + --i] * mul
	  }
	  mul *= 0x80
	
	  if (val >= mul) val -= Math.pow(2, 8 * byteLength)
	
	  return val
	}
	
	Buffer.prototype.readInt8 = function readInt8 (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 1, this.length)
	  if (!(this[offset] & 0x80)) return (this[offset])
	  return ((0xff - this[offset] + 1) * -1)
	}
	
	Buffer.prototype.readInt16LE = function readInt16LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset] | (this[offset + 1] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt16BE = function readInt16BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 2, this.length)
	  var val = this[offset + 1] | (this[offset] << 8)
	  return (val & 0x8000) ? val | 0xFFFF0000 : val
	}
	
	Buffer.prototype.readInt32LE = function readInt32LE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset]) |
	    (this[offset + 1] << 8) |
	    (this[offset + 2] << 16) |
	    (this[offset + 3] << 24)
	}
	
	Buffer.prototype.readInt32BE = function readInt32BE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	
	  return (this[offset] << 24) |
	    (this[offset + 1] << 16) |
	    (this[offset + 2] << 8) |
	    (this[offset + 3])
	}
	
	Buffer.prototype.readFloatLE = function readFloatLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, true, 23, 4)
	}
	
	Buffer.prototype.readFloatBE = function readFloatBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 4, this.length)
	  return ieee754.read(this, offset, false, 23, 4)
	}
	
	Buffer.prototype.readDoubleLE = function readDoubleLE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, true, 52, 8)
	}
	
	Buffer.prototype.readDoubleBE = function readDoubleBE (offset, noAssert) {
	  if (!noAssert) checkOffset(offset, 8, this.length)
	  return ieee754.read(this, offset, false, 52, 8)
	}
	
	function checkInt (buf, value, offset, ext, max, min) {
	  if (!Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance')
	  if (value > max || value < min) throw new RangeError('"value" argument is out of bounds')
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	}
	
	Buffer.prototype.writeUIntLE = function writeUIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var mul = 1
	  var i = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUIntBE = function writeUIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  byteLength = byteLength | 0
	  if (!noAssert) {
	    var maxBytes = Math.pow(2, 8 * byteLength) - 1
	    checkInt(this, value, offset, byteLength, maxBytes, 0)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    this[offset + i] = (value / mul) & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeUInt8 = function writeUInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0xff, 0)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	function objectWriteUInt16 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 2); i < j; ++i) {
	    buf[offset + i] = (value & (0xff << (8 * (littleEndian ? i : 1 - i)))) >>>
	      (littleEndian ? i : 1 - i) * 8
	  }
	}
	
	Buffer.prototype.writeUInt16LE = function writeUInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeUInt16BE = function writeUInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0xffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	function objectWriteUInt32 (buf, value, offset, littleEndian) {
	  if (value < 0) value = 0xffffffff + value + 1
	  for (var i = 0, j = Math.min(buf.length - offset, 4); i < j; ++i) {
	    buf[offset + i] = (value >>> (littleEndian ? i : 3 - i) * 8) & 0xff
	  }
	}
	
	Buffer.prototype.writeUInt32LE = function writeUInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset + 3] = (value >>> 24)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 1] = (value >>> 8)
	    this[offset] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeUInt32BE = function writeUInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0xffffffff, 0)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeIntLE = function writeIntLE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = 0
	  var mul = 1
	  var sub = 0
	  this[offset] = value & 0xFF
	  while (++i < byteLength && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeIntBE = function writeIntBE (value, offset, byteLength, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) {
	    var limit = Math.pow(2, 8 * byteLength - 1)
	
	    checkInt(this, value, offset, byteLength, limit - 1, -limit)
	  }
	
	  var i = byteLength - 1
	  var mul = 1
	  var sub = 0
	  this[offset + i] = value & 0xFF
	  while (--i >= 0 && (mul *= 0x100)) {
	    if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) {
	      sub = 1
	    }
	    this[offset + i] = ((value / mul) >> 0) - sub & 0xFF
	  }
	
	  return offset + byteLength
	}
	
	Buffer.prototype.writeInt8 = function writeInt8 (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 1, 0x7f, -0x80)
	  if (!Buffer.TYPED_ARRAY_SUPPORT) value = Math.floor(value)
	  if (value < 0) value = 0xff + value + 1
	  this[offset] = (value & 0xff)
	  return offset + 1
	}
	
	Buffer.prototype.writeInt16LE = function writeInt16LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	  } else {
	    objectWriteUInt16(this, value, offset, true)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt16BE = function writeInt16BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 2, 0x7fff, -0x8000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 8)
	    this[offset + 1] = (value & 0xff)
	  } else {
	    objectWriteUInt16(this, value, offset, false)
	  }
	  return offset + 2
	}
	
	Buffer.prototype.writeInt32LE = function writeInt32LE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value & 0xff)
	    this[offset + 1] = (value >>> 8)
	    this[offset + 2] = (value >>> 16)
	    this[offset + 3] = (value >>> 24)
	  } else {
	    objectWriteUInt32(this, value, offset, true)
	  }
	  return offset + 4
	}
	
	Buffer.prototype.writeInt32BE = function writeInt32BE (value, offset, noAssert) {
	  value = +value
	  offset = offset | 0
	  if (!noAssert) checkInt(this, value, offset, 4, 0x7fffffff, -0x80000000)
	  if (value < 0) value = 0xffffffff + value + 1
	  if (Buffer.TYPED_ARRAY_SUPPORT) {
	    this[offset] = (value >>> 24)
	    this[offset + 1] = (value >>> 16)
	    this[offset + 2] = (value >>> 8)
	    this[offset + 3] = (value & 0xff)
	  } else {
	    objectWriteUInt32(this, value, offset, false)
	  }
	  return offset + 4
	}
	
	function checkIEEE754 (buf, value, offset, ext, max, min) {
	  if (offset + ext > buf.length) throw new RangeError('Index out of range')
	  if (offset < 0) throw new RangeError('Index out of range')
	}
	
	function writeFloat (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -3.4028234663852886e+38)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 23, 4)
	  return offset + 4
	}
	
	Buffer.prototype.writeFloatLE = function writeFloatLE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeFloatBE = function writeFloatBE (value, offset, noAssert) {
	  return writeFloat(this, value, offset, false, noAssert)
	}
	
	function writeDouble (buf, value, offset, littleEndian, noAssert) {
	  if (!noAssert) {
	    checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -1.7976931348623157E+308)
	  }
	  ieee754.write(buf, value, offset, littleEndian, 52, 8)
	  return offset + 8
	}
	
	Buffer.prototype.writeDoubleLE = function writeDoubleLE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, true, noAssert)
	}
	
	Buffer.prototype.writeDoubleBE = function writeDoubleBE (value, offset, noAssert) {
	  return writeDouble(this, value, offset, false, noAssert)
	}
	
	// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
	Buffer.prototype.copy = function copy (target, targetStart, start, end) {
	  if (!start) start = 0
	  if (!end && end !== 0) end = this.length
	  if (targetStart >= target.length) targetStart = target.length
	  if (!targetStart) targetStart = 0
	  if (end > 0 && end < start) end = start
	
	  // Copy 0 bytes; we're done
	  if (end === start) return 0
	  if (target.length === 0 || this.length === 0) return 0
	
	  // Fatal error conditions
	  if (targetStart < 0) {
	    throw new RangeError('targetStart out of bounds')
	  }
	  if (start < 0 || start >= this.length) throw new RangeError('sourceStart out of bounds')
	  if (end < 0) throw new RangeError('sourceEnd out of bounds')
	
	  // Are we oob?
	  if (end > this.length) end = this.length
	  if (target.length - targetStart < end - start) {
	    end = target.length - targetStart + start
	  }
	
	  var len = end - start
	  var i
	
	  if (this === target && start < targetStart && targetStart < end) {
	    // descending copy from end
	    for (i = len - 1; i >= 0; --i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else if (len < 1000 || !Buffer.TYPED_ARRAY_SUPPORT) {
	    // ascending copy from start
	    for (i = 0; i < len; ++i) {
	      target[i + targetStart] = this[i + start]
	    }
	  } else {
	    Uint8Array.prototype.set.call(
	      target,
	      this.subarray(start, start + len),
	      targetStart
	    )
	  }
	
	  return len
	}
	
	// Usage:
	//    buffer.fill(number[, offset[, end]])
	//    buffer.fill(buffer[, offset[, end]])
	//    buffer.fill(string[, offset[, end]][, encoding])
	Buffer.prototype.fill = function fill (val, start, end, encoding) {
	  // Handle string cases:
	  if (typeof val === 'string') {
	    if (typeof start === 'string') {
	      encoding = start
	      start = 0
	      end = this.length
	    } else if (typeof end === 'string') {
	      encoding = end
	      end = this.length
	    }
	    if (val.length === 1) {
	      var code = val.charCodeAt(0)
	      if (code < 256) {
	        val = code
	      }
	    }
	    if (encoding !== undefined && typeof encoding !== 'string') {
	      throw new TypeError('encoding must be a string')
	    }
	    if (typeof encoding === 'string' && !Buffer.isEncoding(encoding)) {
	      throw new TypeError('Unknown encoding: ' + encoding)
	    }
	  } else if (typeof val === 'number') {
	    val = val & 255
	  }
	
	  // Invalid ranges are not set to a default, so can range check early.
	  if (start < 0 || this.length < start || this.length < end) {
	    throw new RangeError('Out of range index')
	  }
	
	  if (end <= start) {
	    return this
	  }
	
	  start = start >>> 0
	  end = end === undefined ? this.length : end >>> 0
	
	  if (!val) val = 0
	
	  var i
	  if (typeof val === 'number') {
	    for (i = start; i < end; ++i) {
	      this[i] = val
	    }
	  } else {
	    var bytes = Buffer.isBuffer(val)
	      ? val
	      : utf8ToBytes(new Buffer(val, encoding).toString())
	    var len = bytes.length
	    for (i = 0; i < end - start; ++i) {
	      this[i + start] = bytes[i % len]
	    }
	  }
	
	  return this
	}
	
	// HELPER FUNCTIONS
	// ================
	
	var INVALID_BASE64_RE = /[^+\/0-9A-Za-z-_]/g
	
	function base64clean (str) {
	  // Node strips out invalid characters like \n and \t from the string, base64-js does not
	  str = stringtrim(str).replace(INVALID_BASE64_RE, '')
	  // Node converts strings with length < 2 to ''
	  if (str.length < 2) return ''
	  // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
	  while (str.length % 4 !== 0) {
	    str = str + '='
	  }
	  return str
	}
	
	function stringtrim (str) {
	  if (str.trim) return str.trim()
	  return str.replace(/^\s+|\s+$/g, '')
	}
	
	function toHex (n) {
	  if (n < 16) return '0' + n.toString(16)
	  return n.toString(16)
	}
	
	function utf8ToBytes (string, units) {
	  units = units || Infinity
	  var codePoint
	  var length = string.length
	  var leadSurrogate = null
	  var bytes = []
	
	  for (var i = 0; i < length; ++i) {
	    codePoint = string.charCodeAt(i)
	
	    // is surrogate component
	    if (codePoint > 0xD7FF && codePoint < 0xE000) {
	      // last char was a lead
	      if (!leadSurrogate) {
	        // no lead yet
	        if (codePoint > 0xDBFF) {
	          // unexpected trail
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        } else if (i + 1 === length) {
	          // unpaired lead
	          if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	          continue
	        }
	
	        // valid lead
	        leadSurrogate = codePoint
	
	        continue
	      }
	
	      // 2 leads in a row
	      if (codePoint < 0xDC00) {
	        if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	        leadSurrogate = codePoint
	        continue
	      }
	
	      // valid surrogate pair
	      codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000
	    } else if (leadSurrogate) {
	      // valid bmp char, but last char was a lead
	      if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD)
	    }
	
	    leadSurrogate = null
	
	    // encode utf8
	    if (codePoint < 0x80) {
	      if ((units -= 1) < 0) break
	      bytes.push(codePoint)
	    } else if (codePoint < 0x800) {
	      if ((units -= 2) < 0) break
	      bytes.push(
	        codePoint >> 0x6 | 0xC0,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x10000) {
	      if ((units -= 3) < 0) break
	      bytes.push(
	        codePoint >> 0xC | 0xE0,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else if (codePoint < 0x110000) {
	      if ((units -= 4) < 0) break
	      bytes.push(
	        codePoint >> 0x12 | 0xF0,
	        codePoint >> 0xC & 0x3F | 0x80,
	        codePoint >> 0x6 & 0x3F | 0x80,
	        codePoint & 0x3F | 0x80
	      )
	    } else {
	      throw new Error('Invalid code point')
	    }
	  }
	
	  return bytes
	}
	
	function asciiToBytes (str) {
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    // Node's code seems to be doing this and not & 0x7F..
	    byteArray.push(str.charCodeAt(i) & 0xFF)
	  }
	  return byteArray
	}
	
	function utf16leToBytes (str, units) {
	  var c, hi, lo
	  var byteArray = []
	  for (var i = 0; i < str.length; ++i) {
	    if ((units -= 2) < 0) break
	
	    c = str.charCodeAt(i)
	    hi = c >> 8
	    lo = c % 256
	    byteArray.push(lo)
	    byteArray.push(hi)
	  }
	
	  return byteArray
	}
	
	function base64ToBytes (str) {
	  return base64.toByteArray(base64clean(str))
	}
	
	function blitBuffer (src, dst, offset, length) {
	  for (var i = 0; i < length; ++i) {
	    if ((i + offset >= dst.length) || (i >= src.length)) break
	    dst[i + offset] = src[i]
	  }
	  return i
	}
	
	function isnan (val) {
	  return val !== val // eslint-disable-line no-self-compare
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Export cheerio (with )
	 */
	
	exports = module.exports = __webpack_require__(165);
	
	/*
	  Export the version
	*/
	
	exports.version = __webpack_require__(613).version;


/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(Buffer) {/*
	  Module Dependencies
	*/
	var htmlparser = __webpack_require__(77);
	
	/*
	  Parser
	*/
	exports = module.exports = function(content, options) {
	  var dom = exports.evaluate(content, options),
	      // Generic root element
	      root = exports.evaluate('<root></root>', options)[0];
	
	  root.type = 'root';
	
	  // Update the dom using the root
	  exports.update(dom, root);
	
	  return root;
	};
	
	exports.evaluate = function(content, options) {
	  // options = options || $.fn.options;
	
	  var dom;
	
	  if (typeof content === 'string' || Buffer.isBuffer(content)) {
	    dom = htmlparser.parseDOM(content, options);
	  } else {
	    dom = content;
	  }
	
	  return dom;
	};
	
	/*
	  Update the dom structure, for one changed layer
	*/
	exports.update = function(arr, parent) {
	  // normalize
	  if (!Array.isArray(arr)) arr = [arr];
	
	  // Update parent
	  if (parent) {
	    parent.children = arr;
	  } else {
	    parent = null;
	  }
	
	  // Update neighbors
	  for (var i = 0; i < arr.length; i++) {
	    var node = arr[i];
	
	    // Cleanly remove existing nodes from their previous structures.
	    var oldParent = node.parent || node.root,
	        oldSiblings = oldParent && oldParent.children;
	    if (oldSiblings && oldSiblings !== arr) {
	      oldSiblings.splice(oldSiblings.indexOf(node), 1);
	      if (node.prev) {
	        node.prev.next = node.next;
	      }
	      if (node.next) {
	        node.next.prev = node.prev;
	      }
	    }
	
	    if (parent) {
	      node.prev = arr[i - 1] || null;
	      node.next = arr[i + 1] || null;
	    } else {
	      node.prev = node.next = null;
	    }
	
	    if (parent && parent.type === 'root') {
	      node.root = parent;
	      node.parent = null;
	    } else {
	      node.root = null;
	      node.parent = parent;
	    }
	  }
	
	  return parent;
	};
	
	// module.exports = $.extend(exports);
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(123).Buffer))

/***/ },
/* 126 */
/***/ function(module, exports) {

	exports.f = {}.propertyIsEnumerable;


/***/ },
/* 127 */
/***/ function(module, exports) {

	var id = 0;
	var px = Math.random();
	module.exports = function (key) {
	  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	};


/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $at = __webpack_require__(532)(true);
	
	// 21.1.3.27 String.prototype[@@iterator]()
	__webpack_require__(260)(String, 'String', function (iterated) {
	  this._t = String(iterated); // target
	  this._i = 0;                // next index
	// 21.1.5.2.1 %StringIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var index = this._i;
	  var point;
	  if (index >= O.length) return { value: undefined, done: true };
	  point = $at(O, index);
	  this._i += point.length;
	  return { value: point, done: false };
	});


/***/ },
/* 129 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyObject = {};
	
	if (false) {
	  Object.freeze(emptyObject);
	}
	
	module.exports = emptyObject;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.locationsAreEqual = exports.createLocation = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _resolvePathname = __webpack_require__(1989);
	
	var _resolvePathname2 = _interopRequireDefault(_resolvePathname);
	
	var _valueEqual = __webpack_require__(2031);
	
	var _valueEqual2 = _interopRequireDefault(_valueEqual);
	
	var _PathUtils = __webpack_require__(76);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createLocation = exports.createLocation = function createLocation(path, state, key, currentLocation) {
	  var location = void 0;
	  if (typeof path === 'string') {
	    // Two-arg form: push(path, state)
	    location = (0, _PathUtils.parsePath)(path);
	    location.state = state;
	  } else {
	    // One-arg form: push(location)
	    location = _extends({}, path);
	
	    if (location.pathname === undefined) location.pathname = '';
	
	    if (location.search) {
	      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
	    } else {
	      location.search = '';
	    }
	
	    if (location.hash) {
	      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
	    } else {
	      location.hash = '';
	    }
	
	    if (state !== undefined && location.state === undefined) location.state = state;
	  }
	
	  try {
	    location.pathname = decodeURI(location.pathname);
	  } catch (e) {
	    if (e instanceof URIError) {
	      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
	    } else {
	      throw e;
	    }
	  }
	
	  if (key) location.key = key;
	
	  if (currentLocation) {
	    // Resolve incomplete/relative pathname relative to current location.
	    if (!location.pathname) {
	      location.pathname = currentLocation.pathname;
	    } else if (location.pathname.charAt(0) !== '/') {
	      location.pathname = (0, _resolvePathname2.default)(location.pathname, currentLocation.pathname);
	    }
	  } else {
	    // When there is no prior location and pathname is empty, set it to /
	    if (!location.pathname) {
	      location.pathname = '/';
	    }
	  }
	
	  return location;
	};
	
	var locationsAreEqual = exports.locationsAreEqual = function locationsAreEqual(a, b) {
	  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && (0, _valueEqual2.default)(a.state, b.state);
	};

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _createRule = __webpack_require__(291);
	
	var _createRule2 = _interopRequireDefault(_createRule);
	
	var _updateRule = __webpack_require__(634);
	
	var _updateRule2 = _interopRequireDefault(_updateRule);
	
	var _linkRule = __webpack_require__(293);
	
	var _linkRule2 = _interopRequireDefault(_linkRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Contains rules objects and allows adding/removing etc.
	 * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	 */
	var RulesContainer = function () {
	
	  // Original styles object.
	  function RulesContainer(options) {
	    _classCallCheck(this, RulesContainer);
	
	    this.map = Object.create(null);
	    this.raw = Object.create(null
	
	    // Used to ensure correct rules order.
	    );
	    this.index = [];
	
	    this.options = options;
	    this.classes = options.classes;
	  }
	
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	
	
	  _createClass(RulesContainer, [{
	    key: 'add',
	    value: function add(name, decl, options) {
	      var _options = this.options,
	          parent = _options.parent,
	          sheet = _options.sheet,
	          jss = _options.jss,
	          Renderer = _options.Renderer,
	          generateClassName = _options.generateClassName;
	
	
	      options = _extends({
	        classes: this.classes,
	        parent: parent,
	        sheet: sheet,
	        jss: jss,
	        Renderer: Renderer,
	        generateClassName: generateClassName
	      }, options);
	
	      if (!options.className) options.className = this.classes[name];
	
	      this.raw[name] = decl;
	
	      var rule = (0, _createRule2['default'])(name, decl, options);
	      this.register(rule);
	
	      var index = options.index === undefined ? this.index.length : options.index;
	      this.index.splice(index, 0, rule);
	
	      return rule;
	    }
	
	    /**
	     * Get a rule.
	     */
	
	  }, {
	    key: 'get',
	    value: function get(name) {
	      return this.map[name];
	    }
	
	    /**
	     * Delete a rule.
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(rule) {
	      this.unregister(rule);
	      this.index.splice(this.indexOf(rule), 1);
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.index.indexOf(rule);
	    }
	
	    /**
	     * Run `onProcessRule()` plugins on every rule.
	     */
	
	  }, {
	    key: 'process',
	    value: function process() {
	      var plugins = this.options.jss.plugins;
	      // We need to clone array because if we modify the index somewhere else during a loop
	      // we end up with very hard-to-track-down side effects.
	
	      this.index.slice(0).forEach(plugins.onProcessRule, plugins);
	    }
	
	    /**
	     * Register a rule in `.map` and `.classes` maps.
	     */
	
	  }, {
	    key: 'register',
	    value: function register(rule) {
	      if (rule.name) this.map[rule.name] = rule;
	      if (rule.className && rule.name) this.classes[rule.name] = rule.className;
	      if (rule.selector) this.map[rule.selector] = rule;
	    }
	
	    /**
	     * Unregister a rule.
	     */
	
	  }, {
	    key: 'unregister',
	    value: function unregister(rule) {
	      if (rule.name) {
	        delete this.map[rule.name];
	        delete this.classes[rule.name];
	      }
	      delete this.map[rule.selector];
	    }
	
	    /**
	     * Update the function values with a new data.
	     */
	
	  }, {
	    key: 'update',
	    value: function update(name, data) {
	      if (typeof name === 'string') {
	        (0, _updateRule2['default'])(this.get(name), data, RulesContainer);
	        return;
	      }
	
	      for (var index = 0; index < this.index.length; index++) {
	        (0, _updateRule2['default'])(this.index[index], name, RulesContainer);
	      }
	    }
	
	    /**
	     * Link renderable rules with CSSRuleList.
	     */
	
	  }, {
	    key: 'link',
	    value: function link(cssRules) {
	      for (var i = 0; i < cssRules.length; i++) {
	        var cssRule = cssRules[i];
	        var rule = this.get(this.options.sheet.renderer.getSelector(cssRule));
	        if (rule) (0, _linkRule2['default'])(rule, cssRule);
	      }
	    }
	
	    /**
	     * Convert rules to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      var str = '';
	
	      for (var index = 0; index < this.index.length; index++) {
	        var rule = this.index[index];
	        var css = rule.toString(options
	
	        // No need to render an empty rule.
	        );if (!css) continue;
	
	        if (str) str += '\n';
	        str += css;
	      }
	
	      return str;
	    }
	  }]);
	
	  return RulesContainer;
	}();
	
	exports['default'] = RulesContainer;

/***/ },
/* 133 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Iterates over elements of `collection` and invokes `iteratee` for each element.
	 * The iteratee is invoked with three arguments: (value, index|key, collection).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * **Note:** As with other "Collections" methods, objects with a "length"
	 * property are iterated like arrays. To avoid this behavior use `_.forIn`
	 * or `_.forOwn` for object iteration.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @alias each
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 * @see _.forEachRight
	 * @example
	 *
	 * _([1, 2]).forEach(function(value) {
	 *   console.log(value);
	 * });
	 * // => Logs `1` then `2`.
	 *
	 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forEach(collection, iteratee) {
	  var func = isArray(collection) ? arrayEach : baseEach;
	  return func(collection, typeof iteratee == 'function' ? iteratee : identity);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	module.exports = forEach;


/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	var listCacheClear = __webpack_require__(712),
	    listCacheDelete = __webpack_require__(713),
	    listCacheGet = __webpack_require__(714),
	    listCacheHas = __webpack_require__(715),
	    listCacheSet = __webpack_require__(716);
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	module.exports = ListCache;


/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(134),
	    stackClear = __webpack_require__(731),
	    stackDelete = __webpack_require__(732),
	    stackGet = __webpack_require__(733),
	    stackHas = __webpack_require__(734),
	    stackSet = __webpack_require__(735);
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  var data = this.__data__ = new ListCache(entries);
	  this.size = data.size;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	module.exports = Stack;


/***/ },
/* 136 */
/***/ function(module, exports) {

	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	module.exports = apply;


/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(107),
	    eq = __webpack_require__(84);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignValue;


/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(84);
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	module.exports = assocIndexOf;


/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	var identity = __webpack_require__(109),
	    overRest = __webpack_require__(331),
	    setToString = __webpack_require__(334);
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  return setToString(overRest(func, start, identity), func + '');
	}
	
	module.exports = baseRest;


/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(137),
	    castPath = __webpack_require__(51),
	    isIndex = __webpack_require__(143),
	    isObject = __webpack_require__(29),
	    toKey = __webpack_require__(52);
	
	/**
	 * The base implementation of `_.set`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseSet(object, path, value, customizer) {
	  if (!isObject(object)) {
	    return object;
	  }
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      lastIndex = length - 1,
	      nested = object;
	
	  while (nested != null && ++index < length) {
	    var key = toKey(path[index]),
	        newValue = value;
	
	    if (index != lastIndex) {
	      var objValue = nested[key];
	      newValue = customizer ? customizer(objValue, key, nested) : undefined;
	      if (newValue === undefined) {
	        newValue = isObject(objValue)
	          ? objValue
	          : (isIndex(path[index + 1]) ? [] : {});
	      }
	    }
	    assignValue(nested, key, newValue);
	    nested = nested[key];
	  }
	  return object;
	}
	
	module.exports = baseSet;


/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	var isKeyable = __webpack_require__(710);
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	module.exports = getMapData;


/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(330);
	
	/** Built-in value references. */
	var getPrototype = overArg(Object.getPrototypeOf, Object);
	
	module.exports = getPrototype;


/***/ },
/* 143 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	module.exports = isIndex;


/***/ },
/* 144 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	module.exports = isPrototype;


/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(61);
	
	/* Built-in method references that are verified to be native. */
	var nativeCreate = getNative(Object, 'create');
	
	module.exports = nativeCreate;


/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsArguments = __webpack_require__(665),
	    isObjectLike = __webpack_require__(62);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
	  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
	    !propertyIsEnumerable.call(value, 'callee');
	};
	
	module.exports = isArguments;


/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsTypedArray = __webpack_require__(669),
	    baseUnary = __webpack_require__(683),
	    nodeUtil = __webpack_require__(725);
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	module.exports = isTypedArray;


/***/ },
/* 148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FlatButton = __webpack_require__(814);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FlatButton2.default;

/***/ },
/* 149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _toArray2 = __webpack_require__(255);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(68);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _ClickAwayListener = __webpack_require__(220);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _List = __webpack_require__(214);
	
	var _List2 = _interopRequireDefault(_List);
	
	var _menuUtils = __webpack_require__(828);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var desktop = props.desktop,
	      maxHeight = props.maxHeight,
	      width = props.width;
	  var muiTheme = context.muiTheme;
	
	
	  var styles = {
	    root: {
	      // Nested div bacause the List scales x faster than it scales y
	      zIndex: muiTheme.zIndex.menu,
	      maxHeight: maxHeight,
	      overflowY: maxHeight ? 'auto' : null
	    },
	    divider: {
	      marginTop: 7,
	      marginBottom: 8
	    },
	    list: {
	      display: 'table-cell',
	      paddingBottom: desktop ? 16 : 8,
	      paddingTop: desktop ? 16 : 8,
	      userSelect: 'none',
	      width: width
	    },
	    selectedMenuItem: {
	      color: muiTheme.menuItem.selectedTextColor
	    }
	  };
	
	  return styles;
	}
	
	var Menu = function (_Component) {
	  (0, _inherits3.default)(Menu, _Component);
	
	  function Menu(props, context) {
	    (0, _classCallCheck3.default)(this, Menu);
	
	    var _this = (0, _possibleConstructorReturn3.default)(this, (Menu.__proto__ || (0, _getPrototypeOf2.default)(Menu)).call(this, props, context));
	
	    _initialiseProps.call(_this);
	
	    var filteredChildren = _this.getFilteredChildren(props.children);
	    var selectedIndex = _this.getSelectedIndex(props, filteredChildren);
	
	    var newFocusIndex = props.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	    if (newFocusIndex !== -1 && props.onMenuItemFocusChange) {
	      props.onMenuItemFocusChange(null, newFocusIndex);
	    }
	    _this.state = {
	      focusIndex: newFocusIndex,
	      isKeyboardFocused: props.initiallyKeyboardFocused,
	      keyWidth: props.desktop ? 64 : 56
	    };
	
	    _this.hotKeyHolder = new _menuUtils.HotKeyHolder();
	    return _this;
	  }
	
	  (0, _createClass3.default)(Menu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      this.setScollPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var filteredChildren = this.getFilteredChildren(nextProps.children);
	      var selectedIndex = this.getSelectedIndex(nextProps, filteredChildren);
	
	      var newFocusIndex = nextProps.disableAutoFocus ? -1 : selectedIndex >= 0 ? selectedIndex : 0;
	      if (newFocusIndex !== this.state.focusIndex && this.props.onMenuItemFocusChange) {
	        this.props.onMenuItemFocusChange(null, newFocusIndex);
	      }
	      this.setState({
	        focusIndex: newFocusIndex,
	        keyWidth: nextProps.desktop ? 64 : 56
	      });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.autoWidth) this.setWidth();
	    }
	  }, {
	    key: 'getValueLink',
	
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'setKeyboardFocused',
	    value: function setKeyboardFocused(keyboardFocused) {
	      this.setState({
	        isKeyboardFocused: keyboardFocused
	      });
	    }
	  }, {
	    key: 'getFilteredChildren',
	    value: function getFilteredChildren(children) {
	      var filteredChildren = [];
	      _react2.default.Children.forEach(children, function (child) {
	        if (child) {
	          filteredChildren.push(child);
	        }
	      });
	      return filteredChildren;
	    }
	  }, {
	    key: 'cloneMenuItem',
	    value: function cloneMenuItem(child, childIndex, styles, index) {
	      var _this2 = this;
	
	      var childIsDisabled = child.props.disabled;
	
	      var selectedChildStyles = {};
	      if (!childIsDisabled) {
	        var selected = this.isChildSelected(child, this.props);
	
	        if (selected) {
	          (0, _simpleAssign2.default)(selectedChildStyles, styles.selectedMenuItem, this.props.selectedMenuItemStyle);
	        }
	      }
	      var mergedChildStyles = (0, _simpleAssign2.default)({}, child.props.style, this.props.menuItemStyle, selectedChildStyles);
	
	      var extraProps = {
	        desktop: this.props.desktop,
	        style: mergedChildStyles
	      };
	      if (!childIsDisabled) {
	        var isFocused = childIndex === this.state.focusIndex;
	        var focusState = 'none';
	        if (isFocused) {
	          focusState = this.state.isKeyboardFocused ? 'keyboard-focused' : 'focused';
	        }
	
	        (0, _simpleAssign2.default)(extraProps, {
	          focusState: focusState,
	          onTouchTap: function onTouchTap(event) {
	            _this2.handleMenuItemTouchTap(event, child, index);
	            if (child.props.onTouchTap) child.props.onTouchTap(event);
	          },
	          ref: isFocused ? 'focusedMenuItem' : null
	        });
	      }
	      return _react2.default.cloneElement(child, extraProps);
	    }
	  }, {
	    key: 'decrementKeyboardFocusIndex',
	    value: function decrementKeyboardFocusIndex(event) {
	      var index = this.state.focusIndex;
	
	      index--;
	      if (index < 0) index = 0;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'getMenuItemCount',
	    value: function getMenuItemCount(filteredChildren) {
	      var menuItemCount = 0;
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	        var childIsDisabled = child.props.disabled;
	        if (!childIsADivider && !childIsDisabled) menuItemCount++;
	      });
	      return menuItemCount;
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props, filteredChildren) {
	      var _this3 = this;
	
	      var selectedIndex = -1;
	      var menuItemIndex = 0;
	
	      filteredChildren.forEach(function (child) {
	        var childIsADivider = child.type && child.type.muiName === 'Divider';
	
	        if (_this3.isChildSelected(child, props)) selectedIndex = menuItemIndex;
	        if (!childIsADivider) menuItemIndex++;
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'setFocusIndexStartsWith',
	    value: function setFocusIndexStartsWith(event, keys) {
	      var foundIndex = -1;
	      _react2.default.Children.forEach(this.props.children, function (child, index) {
	        if (foundIndex >= 0) {
	          return;
	        }
	        var primaryText = child.props.primaryText;
	
	        if (typeof primaryText === 'string' && new RegExp('^' + keys, 'i').test(primaryText)) {
	          foundIndex = index;
	        }
	      });
	      if (foundIndex >= 0) {
	        this.setFocusIndex(event, foundIndex, true);
	        return true;
	      }
	      return false;
	    }
	  }, {
	    key: 'handleMenuItemTouchTap',
	    value: function handleMenuItemTouchTap(event, item, index) {
	      var children = this.props.children;
	      var multiple = this.props.multiple;
	      var valueLink = this.getValueLink(this.props);
	      var menuValue = valueLink.value;
	      var itemValue = item.props.value;
	      var focusIndex = _react2.default.isValidElement(children) ? 0 : children.indexOf(item);
	
	      this.setFocusIndex(event, focusIndex, false);
	
	      if (multiple) {
	        menuValue = menuValue || [];
	
	        var itemIndex = menuValue.indexOf(itemValue);
	
	        var _menuValue = menuValue,
	            _menuValue2 = (0, _toArray3.default)(_menuValue),
	            newMenuValue = _menuValue2.slice(0);
	
	        if (itemIndex === -1) {
	          newMenuValue.push(itemValue);
	        } else {
	          newMenuValue.splice(itemIndex, 1);
	        }
	
	        valueLink.requestChange(event, newMenuValue);
	      } else if (!multiple && itemValue !== menuValue) {
	        valueLink.requestChange(event, itemValue);
	      }
	
	      this.props.onItemTouchTap(event, item, index);
	    }
	  }, {
	    key: 'incrementKeyboardFocusIndex',
	    value: function incrementKeyboardFocusIndex(event, filteredChildren) {
	      var index = this.state.focusIndex;
	      var maxIndex = this.getMenuItemCount(filteredChildren) - 1;
	
	      index++;
	      if (index > maxIndex) index = maxIndex;
	
	      this.setFocusIndex(event, index, true);
	    }
	  }, {
	    key: 'isChildSelected',
	    value: function isChildSelected(child, props) {
	      var menuValue = this.getValueLink(props).value;
	      var childValue = child.props.value;
	
	      if (props.multiple) {
	        return menuValue && menuValue.length && menuValue.indexOf(childValue) !== -1;
	      } else {
	        return child.props.hasOwnProperty('value') && menuValue === childValue;
	      }
	    }
	  }, {
	    key: 'setFocusIndex',
	    value: function setFocusIndex(event, newIndex, isKeyboardFocused) {
	      if (this.props.onMenuItemFocusChange) {
	        // Do this even if `newIndex === this.state.focusIndex` to allow users
	        // to detect up-arrow on the first MenuItem or down-arrow on the last.
	        this.props.onMenuItemFocusChange(event, newIndex);
	      }
	      this.setState({
	        focusIndex: newIndex,
	        isKeyboardFocused: isKeyboardFocused
	      });
	    }
	  }, {
	    key: 'setScollPosition',
	    value: function setScollPosition() {
	      var desktop = this.props.desktop;
	      var focusedMenuItem = this.refs.focusedMenuItem;
	      var menuItemHeight = desktop ? 32 : 48;
	
	      if (focusedMenuItem) {
	        var selectedOffSet = _reactDom2.default.findDOMNode(focusedMenuItem).offsetTop;
	
	        // Make the focused item be the 2nd item in the list the user sees
	        var scrollTop = selectedOffSet - menuItemHeight;
	        if (scrollTop < menuItemHeight) scrollTop = 0;
	
	        _reactDom2.default.findDOMNode(this.refs.scrollContainer).scrollTop = scrollTop;
	      }
	    }
	  }, {
	    key: 'cancelScrollEvent',
	    value: function cancelScrollEvent(event) {
	      event.stopPropagation();
	      event.preventDefault();
	      return false;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = _reactDom2.default.findDOMNode(this);
	      var listEl = _reactDom2.default.findDOMNode(this.refs.list);
	      var elWidth = el.offsetWidth;
	      var keyWidth = this.state.keyWidth;
	      var minWidth = keyWidth * 1.5;
	      var keyIncrements = elWidth / keyWidth;
	      var newWidth = void 0;
	
	      keyIncrements = keyIncrements <= 1.5 ? 1.5 : Math.ceil(keyIncrements);
	      newWidth = keyIncrements * keyWidth;
	
	      if (newWidth < minWidth) newWidth = minWidth;
	
	      el.style.width = newWidth + 'px';
	      listEl.style.width = newWidth + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          children = _props.children,
	          desktop = _props.desktop,
	          disableAutoFocus = _props.disableAutoFocus,
	          initiallyKeyboardFocused = _props.initiallyKeyboardFocused,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          multiple = _props.multiple,
	          onItemTouchTap = _props.onItemTouchTap,
	          onEscKeyDown = _props.onEscKeyDown,
	          onMenuItemFocusChange = _props.onMenuItemFocusChange,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          menuItemStyle = _props.menuItemStyle,
	          style = _props.style,
	          value = _props.value,
	          valueLink = _props.valueLink,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'children', 'desktop', 'disableAutoFocus', 'initiallyKeyboardFocused', 'listStyle', 'maxHeight', 'multiple', 'onItemTouchTap', 'onEscKeyDown', 'onMenuItemFocusChange', 'selectedMenuItemStyle', 'menuItemStyle', 'style', 'value', 'valueLink', 'width']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedListStyles = (0, _simpleAssign2.default)(styles.list, listStyle);
	
	      var filteredChildren = this.getFilteredChildren(children);
	
	      var menuItemIndex = 0;
	      var newChildren = _react2.default.Children.map(filteredChildren, function (child, index) {
	        var childIsDisabled = child.props.disabled;
	        var childName = child.type ? child.type.muiName : '';
	        var newChild = child;
	
	        switch (childName) {
	          case 'MenuItem':
	            newChild = _this4.cloneMenuItem(child, menuItemIndex, styles, index);
	            break;
	
	          case 'Divider':
	            newChild = _react2.default.cloneElement(child, {
	              style: (0, _simpleAssign2.default)({}, styles.divider, child.props.style)
	            });
	            break;
	        }
	
	        if (childName === 'MenuItem' && !childIsDisabled) {
	          menuItemIndex++;
	        }
	
	        return newChild;
	      });
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'div',
	          {
	            onKeyDown: this.handleKeyDown,
	            onWheel: this.handleOnWheel,
	            style: prepareStyles(mergedRootStyles),
	            ref: 'scrollContainer',
	            role: 'presentation'
	          },
	          _react2.default.createElement(
	            _List2.default,
	            (0, _extends3.default)({}, other, {
	              ref: 'list',
	              style: mergedListStyles,
	              role: 'menu'
	            }),
	            newChildren
	          )
	        )
	      );
	    }
	  }]);
	  return Menu;
	}(_react.Component);
	
	Menu.defaultProps = {
	  autoWidth: true,
	  desktop: false,
	  disableAutoFocus: false,
	  initiallyKeyboardFocused: false,
	  maxHeight: null,
	  multiple: false,
	  onChange: function onChange() {},
	  onEscKeyDown: function onEscKeyDown() {},
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyDown: function onKeyDown() {}
	};
	Menu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	var _initialiseProps = function _initialiseProps() {
	  var _this5 = this;
	
	  this.handleClickAway = function (event) {
	    if (event.defaultPrevented) {
	      return;
	    }
	
	    _this5.setFocusIndex(event, -1, false);
	  };
	
	  this.handleKeyDown = function (event) {
	    var filteredChildren = _this5.getFilteredChildren(_this5.props.children);
	    var key = (0, _keycode2.default)(event);
	    switch (key) {
	      case 'down':
	        event.preventDefault();
	        _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        break;
	      case 'esc':
	        _this5.props.onEscKeyDown(event);
	        break;
	      case 'tab':
	        event.preventDefault();
	        if (event.shiftKey) {
	          _this5.decrementKeyboardFocusIndex(event);
	        } else {
	          _this5.incrementKeyboardFocusIndex(event, filteredChildren);
	        }
	        break;
	      case 'up':
	        event.preventDefault();
	        _this5.decrementKeyboardFocusIndex(event);
	        break;
	      default:
	        if (key && key.length === 1) {
	          var hotKeys = _this5.hotKeyHolder.append(key);
	          if (_this5.setFocusIndexStartsWith(event, hotKeys)) {
	            event.preventDefault();
	          }
	        }
	    }
	    _this5.props.onKeyDown(event);
	  };
	
	  this.handleOnWheel = function (event) {
	    var scrollContainer = _this5.refs.scrollContainer;
	    // Only scroll lock if the the Menu is scrollable.
	    if (scrollContainer.scrollHeight <= scrollContainer.clientHeight) return;
	
	    var scrollTop = scrollContainer.scrollTop,
	        scrollHeight = scrollContainer.scrollHeight,
	        clientHeight = scrollContainer.clientHeight;
	
	    var wheelDelta = event.deltaY;
	    var isDeltaPositive = wheelDelta > 0;
	
	    if (isDeltaPositive && wheelDelta > scrollHeight - clientHeight - scrollTop) {
	      scrollContainer.scrollTop = scrollHeight;
	      return _this5.cancelScrollEvent(event);
	    } else if (!isDeltaPositive && -wheelDelta > scrollTop) {
	      scrollContainer.scrollTop = 0;
	      return _this5.cancelScrollEvent(event);
	    }
	  };
	};
	
	 false ? Menu.propTypes = {
	  /**
	   * If true, the width of the menu will be set automatically
	   * according to the widths of its children,
	   * using proper keyline increments (64px for desktop,
	   * 56px otherwise).
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The content of the menu. This is usually used to pass `MenuItem`
	   * elements.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the menu item will render with compact desktop styles.
	   */
	  desktop: _propTypes2.default.bool,
	  /**
	   * If true, the menu will not be auto-focused.
	   */
	  disableAutoFocus: _propTypes2.default.bool,
	  /**
	   * If true, the menu will be keyboard-focused initially.
	   */
	  initiallyKeyboardFocused: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The maximum height of the menu in pixels. If specified,
	   * the menu will be scrollable if it is taller than the provided
	   * height.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item with `value` not
	   * equal to the current `value` of the menu is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {any}  value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is focused and the *Esc* key
	   * is pressed.
	   *
	   * @param {object} event `keydown` event targeting the menu.
	   */
	  onEscKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   * @param {object} menuItem The menu item.
	   * @param {number} index The index of the menu item.
	   */
	  onItemTouchTap: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function fired when the focus on a `MenuItem` is changed.
	   * There will be some "duplicate" changes reported if two different
	   * focusing event happen, for example if a `MenuItem` is focused via
	   * the keyboard and then it is clicked on.
	   *
	   * @param {object} event The event that triggered the focus change.
	   * The event can be null since the focus can be changed for non-event
	   * reasons such as prop changes.
	   * @param {number} newFocusIndex The index of the newly focused
	   * `MenuItem` or `-1` if focus was lost.
	   */
	  onMenuItemFocusChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   * This component also supports valueLink.
	   */
	  value: _propTypes2.default.any,
	  /**
	   * ValueLink for the menu's `value`.
	   */
	  valueLink: _propTypes2.default.object,
	  /**
	   * The width of the menu. If not specified, the menu's width
	   * will be set according to the widths of its children, using
	   * proper keyline increments (64px for desktop, 56px otherwise).
	   */
	  width: _propTypes4.default.stringOrNumber
	} : void 0;
	exports.default = Menu;

/***/ },
/* 150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableRowColumn = context.muiTheme.tableRowColumn;
	
	
	  var styles = {
	    root: {
	      paddingLeft: tableRowColumn.spacing,
	      paddingRight: tableRowColumn.spacing,
	      height: tableRowColumn.height,
	      textAlign: 'left',
	      fontSize: 13,
	      overflow: 'hidden',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis'
	    }
	  };
	
	  if (_react2.default.Children.count(props.children) === 1 && !isNaN(props.children)) {
	    styles.textAlign = 'right';
	  }
	
	  return styles;
	}
	
	var TableRowColumn = function (_Component) {
	  (0, _inherits3.default)(TableRowColumn, _Component);
	
	  function TableRowColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRowColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRowColumn.__proto__ || (0, _getPrototypeOf2.default)(TableRowColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _this.onMouseEnter = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onHover) {
	          _this.props.onHover(event, _this.props.columnNumber);
	        }
	      }
	    }, _this.onMouseLeave = function (event) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onHoverExit) {
	          _this.props.onHoverExit(event, _this.props.columnNumber);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRowColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onClick: this.onClick,
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave
	      };
	
	      return _react2.default.createElement(
	        'td',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        children
	      );
	    }
	  }]);
	  return TableRowColumn;
	}(_react.Component);
	
	TableRowColumn.defaultProps = {
	  hoverable: false
	};
	TableRowColumn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TableRowColumn.propTypes = {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * @ignore
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _propTypes2.default.number,
	  /**
	   * @ignore
	   * If true, this column responds to hover events.
	   */
	  hoverable: _propTypes2.default.bool,
	  /** @ignore */
	  onClick: _propTypes2.default.func,
	  /** @ignore */
	  onHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Callback function for hover exit event.
	   */
	  onHoverExit: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = TableRowColumn;

/***/ },
/* 151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ToggleStar = exports.ToggleStarHalf = exports.ToggleStarBorder = exports.ToggleRadioButtonUnchecked = exports.ToggleRadioButtonChecked = exports.ToggleIndeterminateCheckBox = exports.ToggleCheckBox = exports.ToggleCheckBoxOutlineBlank = exports.SocialWhatshot = exports.SocialShare = exports.SocialSentimentVerySatisfied = exports.SocialSentimentVeryDissatisfied = exports.SocialSentimentSatisfied = exports.SocialSentimentNeutral = exports.SocialSentimentDissatisfied = exports.SocialSchool = exports.SocialPublic = exports.SocialPoll = exports.SocialPlusOne = exports.SocialPerson = exports.SocialPersonOutline = exports.SocialPersonAdd = exports.SocialPeople = exports.SocialPeopleOutline = exports.SocialPartyMode = exports.SocialPages = exports.SocialNotifications = exports.SocialNotificationsPaused = exports.SocialNotificationsOff = exports.SocialNotificationsNone = exports.SocialNotificationsActive = exports.SocialMood = exports.SocialMoodBad = exports.SocialLocationCity = exports.SocialGroup = exports.SocialGroupAdd = exports.SocialDomain = exports.SocialCake = exports.PlacesSpa = exports.PlacesSmokingRooms = exports.PlacesSmokeFree = exports.PlacesRvHookup = exports.PlacesRoomService = exports.PlacesPool = exports.PlacesKitchen = exports.PlacesHotTub = exports.PlacesGolfCourse = exports.PlacesFreeBreakfast = exports.PlacesFitnessCenter = exports.PlacesChildFriendly = exports.PlacesChildCare = exports.PlacesCasino = exports.PlacesBusinessCenter = exports.PlacesBeachAccess = exports.PlacesAllInclusive = exports.PlacesAirportShuttle = exports.PlacesAcUnit = exports.NotificationWifi = exports.NotificationWc = exports.NotificationVpnLock = exports.NotificationVoiceChat = undefined;
	exports.NotificationVibration = exports.NotificationTimeToLeave = exports.NotificationTapAndPlay = exports.NotificationSystemUpdate = exports.NotificationSync = exports.NotificationSyncProblem = exports.NotificationSyncDisabled = exports.NotificationSms = exports.NotificationSmsFailed = exports.NotificationSimCardAlert = exports.NotificationSdCard = exports.NotificationRvHookup = exports.NotificationPriorityHigh = exports.NotificationPower = exports.NotificationPhonePaused = exports.NotificationPhoneMissed = exports.NotificationPhoneLocked = exports.NotificationPhoneInTalk = exports.NotificationPhoneForwarded = exports.NotificationPhoneBluetoothSpeaker = exports.NotificationPersonalVideo = exports.NotificationOndemandVideo = exports.NotificationNoEncryption = exports.NotificationNetworkLocked = exports.NotificationNetworkCheck = exports.NotificationMore = exports.NotificationMms = exports.NotificationLiveTv = exports.NotificationFolderSpecial = exports.NotificationEventNote = exports.NotificationEventBusy = exports.NotificationEventAvailable = exports.NotificationEnhancedEncryption = exports.NotificationDriveEta = exports.NotificationDoNotDisturb = exports.NotificationDoNotDisturbOn = exports.NotificationDoNotDisturbOff = exports.NotificationDoNotDisturbAlt = exports.NotificationDiscFull = exports.NotificationConfirmationNumber = exports.NotificationBluetoothAudio = exports.NotificationAirlineSeatReclineNormal = exports.NotificationAirlineSeatReclineExtra = exports.NotificationAirlineSeatLegroomReduced = exports.NotificationAirlineSeatLegroomNormal = exports.NotificationAirlineSeatLegroomExtra = exports.NotificationAirlineSeatIndividualSuite = exports.NotificationAirlineSeatFlat = exports.NotificationAirlineSeatFlatAngled = exports.NotificationAdb = exports.NavigationArrowDropRight = exports.NavigationUnfoldMore = exports.NavigationUnfoldLess = exports.NavigationSubdirectoryArrowRight = exports.NavigationSubdirectoryArrowLeft = exports.NavigationRefresh = exports.NavigationMoreVert = exports.NavigationMoreHoriz = exports.NavigationMenu = exports.NavigationLastPage = exports.NavigationFullscreen = exports.NavigationFullscreenExit = exports.NavigationFirstPage = exports.NavigationExpandMore = exports.NavigationExpandLess = exports.NavigationClose = exports.NavigationChevronRight = exports.NavigationChevronLeft = exports.NavigationCheck = exports.NavigationCancel = exports.NavigationArrowUpward = exports.NavigationArrowForward = exports.NavigationArrowDropUp = exports.NavigationArrowDropDown = exports.NavigationArrowDropDownCircle = exports.NavigationArrowDownward = exports.NavigationArrowBack = exports.NavigationApps = exports.MapsZoomOutMap = exports.MapsTransferWithinAStation = exports.MapsTram = exports.MapsTrain = exports.MapsTraffic = exports.MapsTerrain = exports.MapsSubway = exports.MapsStreetview = exports.MapsStoreMallDirectory = exports.MapsSatellite = exports.MapsRestaurant = exports.MapsRestaurantMenu = exports.MapsRateReview = exports.MapsPlace = exports.MapsPinDrop = exports.MapsPersonPin = exports.MapsPersonPinCircle = exports.MapsNearMe = exports.MapsNavigation = exports.MapsMyLocation = exports.MapsMap = exports.MapsLocalTaxi = undefined;
	exports.MapsLocalShipping = exports.MapsLocalSee = exports.MapsLocalPrintshop = exports.MapsLocalPostOffice = exports.MapsLocalPlay = exports.MapsLocalPizza = exports.MapsLocalPhone = exports.MapsLocalPharmacy = exports.MapsLocalParking = exports.MapsLocalOffer = exports.MapsLocalMovies = exports.MapsLocalMall = exports.MapsLocalLibrary = exports.MapsLocalLaundryService = exports.MapsLocalHotel = exports.MapsLocalHospital = exports.MapsLocalGroceryStore = exports.MapsLocalGasStation = exports.MapsLocalFlorist = exports.MapsLocalDrink = exports.MapsLocalDining = exports.MapsLocalConvenienceStore = exports.MapsLocalCarWash = exports.MapsLocalCafe = exports.MapsLocalBar = exports.MapsLocalAtm = exports.MapsLocalAirport = exports.MapsLocalActivity = exports.MapsLayers = exports.MapsLayersClear = exports.MapsHotel = exports.MapsFlight = exports.MapsEvStation = exports.MapsEditLocation = exports.MapsDirections = exports.MapsDirectionsWalk = exports.MapsDirectionsTransit = exports.MapsDirectionsSubway = exports.MapsDirectionsRun = exports.MapsDirectionsRailway = exports.MapsDirectionsCar = exports.MapsDirectionsBus = exports.MapsDirectionsBoat = exports.MapsDirectionsBike = exports.MapsBeenhere = exports.MapsAddLocation = exports.ImageWbSunny = exports.ImageWbIridescent = exports.ImageWbIncandescent = exports.ImageWbCloudy = exports.ImageWbAuto = exports.ImageVignette = exports.ImageViewCompact = exports.ImageViewComfy = exports.ImageTune = exports.ImageTransform = exports.ImageTonality = exports.ImageTimer = exports.ImageTimerOff = exports.ImageTimer3 = exports.ImageTimer10 = exports.ImageTimelapse = exports.ImageTexture = exports.ImageTagFaces = exports.ImageSwitchVideo = exports.ImageSwitchCamera = exports.ImageStyle = exports.ImageStraighten = exports.ImageSlideshow = exports.ImageRotateRight = exports.ImageRotateLeft = exports.ImageRotate90DegreesCcw = exports.ImageRemoveRedEye = exports.ImagePortrait = exports.ImagePictureAsPdf = exports.ImagePhoto = exports.ImagePhotoSizeSelectSmall = exports.ImagePhotoSizeSelectLarge = exports.ImagePhotoSizeSelectActual = exports.ImagePhotoLibrary = exports.ImagePhotoFilter = exports.ImagePhotoCamera = exports.ImagePhotoAlbum = exports.ImagePanorama = exports.ImagePanoramaWideAngle = exports.ImagePanoramaVertical = exports.ImagePanoramaHorizontal = exports.ImagePanoramaFishEye = exports.ImagePalette = exports.ImageNavigateNext = exports.ImageNavigateBefore = exports.ImageNature = exports.ImageNaturePeople = exports.ImageMusicNote = exports.ImageMovieFilter = exports.ImageMovieCreation = exports.ImageMonochromePhotos = exports.ImageLoupe = exports.ImageLooks = exports.ImageLooksTwo = undefined;
	exports.ImageLooksOne = exports.ImageLooks6 = exports.ImageLooks5 = exports.ImageLooks4 = exports.ImageLooks3 = exports.ImageLinkedCamera = exports.ImageLens = exports.ImageLeakRemove = exports.ImageLeakAdd = exports.ImageLandscape = exports.ImageIso = exports.ImageImage = exports.ImageImageAspectRatio = exports.ImageHealing = exports.ImageHdrWeak = exports.ImageHdrStrong = exports.ImageHdrOn = exports.ImageHdrOff = exports.ImageGridOn = exports.ImageGridOff = exports.ImageGrain = exports.ImageGradient = exports.ImageFlip = exports.ImageFlashOn = exports.ImageFlashOff = exports.ImageFlashAuto = exports.ImageFlare = exports.ImageFilter = exports.ImageFilterVintage = exports.ImageFilterTiltShift = exports.ImageFilterNone = exports.ImageFilterHdr = exports.ImageFilterFrames = exports.ImageFilterDrama = exports.ImageFilterCenterFocus = exports.ImageFilterBAndW = exports.ImageFilter9 = exports.ImageFilter9Plus = exports.ImageFilter8 = exports.ImageFilter7 = exports.ImageFilter6 = exports.ImageFilter5 = exports.ImageFilter4 = exports.ImageFilter3 = exports.ImageFilter2 = exports.ImageFilter1 = exports.ImageExposure = exports.ImageExposureZero = exports.ImageExposurePlus2 = exports.ImageExposurePlus1 = exports.ImageExposureNeg2 = exports.ImageExposureNeg1 = exports.ImageEdit = exports.ImageDetails = exports.ImageDehaze = exports.ImageCrop = exports.ImageCropSquare = exports.ImageCropRotate = exports.ImageCropPortrait = exports.ImageCropOriginal = exports.ImageCropLandscape = exports.ImageCropFree = exports.ImageCropDin = exports.ImageCrop75 = exports.ImageCrop54 = exports.ImageCrop32 = exports.ImageCrop169 = exports.ImageControlPoint = exports.ImageControlPointDuplicate = exports.ImageCompare = exports.ImageColorize = exports.ImageColorLens = exports.ImageCollections = exports.ImageCollectionsBookmark = exports.ImageCenterFocusWeak = exports.ImageCenterFocusStrong = exports.ImageCamera = exports.ImageCameraRoll = exports.ImageCameraRear = exports.ImageCameraFront = exports.ImageCameraAlt = exports.ImageBurstMode = exports.ImageBrush = exports.ImageBrokenImage = exports.ImageBrightness7 = exports.ImageBrightness6 = exports.ImageBrightness5 = exports.ImageBrightness4 = exports.ImageBrightness3 = exports.ImageBrightness2 = exports.ImageBrightness1 = exports.ImageBlurOn = exports.ImageBlurOff = exports.ImageBlurLinear = exports.ImageBlurCircular = exports.ImageAudiotrack = exports.ImageAssistant = exports.ImageAssistantPhoto = exports.ImageAdjust = exports.ImageAddToPhotos = undefined;
	exports.ImageAddAPhoto = exports.HardwareWatch = exports.HardwareVideogameAsset = exports.HardwareTv = exports.HardwareToys = exports.HardwareTablet = exports.HardwareTabletMac = exports.HardwareTabletAndroid = exports.HardwareSpeaker = exports.HardwareSpeakerGroup = exports.HardwareSmartphone = exports.HardwareSimCard = exports.HardwareSecurity = exports.HardwareScanner = exports.HardwareRouter = exports.HardwarePowerInput = exports.HardwarePhonelink = exports.HardwarePhonelinkOff = exports.HardwarePhoneIphone = exports.HardwarePhoneAndroid = exports.HardwareMouse = exports.HardwareMemory = exports.HardwareLaptop = exports.HardwareLaptopWindows = exports.HardwareLaptopMac = exports.HardwareLaptopChromebook = exports.HardwareKeyboard = exports.HardwareKeyboardVoice = exports.HardwareKeyboardTab = exports.HardwareKeyboardReturn = exports.HardwareKeyboardHide = exports.HardwareKeyboardCapslock = exports.HardwareKeyboardBackspace = exports.HardwareKeyboardArrowUp = exports.HardwareKeyboardArrowRight = exports.HardwareKeyboardArrowLeft = exports.HardwareKeyboardArrowDown = exports.HardwareHeadset = exports.HardwareHeadsetMic = exports.HardwareGamepad = exports.HardwareDock = exports.HardwareDevicesOther = exports.HardwareDeviceHub = exports.HardwareDeveloperBoard = exports.HardwareDesktopWindows = exports.HardwareDesktopMac = exports.HardwareComputer = exports.HardwareCast = exports.HardwareCastConnected = exports.FileFolder = exports.FileFolderShared = exports.FileFolderOpen = exports.FileFileUpload = exports.FileFileDownload = exports.FileCreateNewFolder = exports.FileCloud = exports.FileCloudUpload = exports.FileCloudQueue = exports.FileCloudOff = exports.FileCloudDownload = exports.FileCloudDone = exports.FileCloudCircle = exports.FileAttachment = exports.EditorWrapText = exports.EditorVerticalAlignTop = exports.EditorVerticalAlignCenter = exports.EditorVerticalAlignBottom = exports.EditorTitle = exports.EditorTextFields = exports.EditorStrikethroughS = exports.EditorSpaceBar = exports.EditorShowChart = exports.EditorShortText = exports.EditorPublish = exports.EditorPieChart = exports.EditorPieChartOutlined = exports.EditorMultilineChart = exports.EditorMoneyOff = exports.EditorMonetizationOn = exports.EditorModeEdit = exports.EditorModeComment = exports.EditorMergeType = exports.EditorLinearScale = exports.EditorInsertPhoto = exports.EditorInsertLink = exports.EditorInsertInvitation = exports.EditorInsertEmoticon = exports.EditorInsertDriveFile = exports.EditorInsertComment = exports.EditorInsertChart = exports.EditorHighlight = exports.EditorFunctions = exports.EditorFormatUnderlined = exports.EditorFormatTextdirectionRToL = exports.EditorFormatTextdirectionLToR = exports.EditorFormatStrikethrough = exports.EditorFormatSize = exports.EditorFormatShapes = exports.EditorFormatQuote = exports.EditorFormatPaint = undefined;
	exports.EditorFormatListNumbered = exports.EditorFormatListBulleted = exports.EditorFormatLineSpacing = exports.EditorFormatItalic = exports.EditorFormatIndentIncrease = exports.EditorFormatIndentDecrease = exports.EditorFormatColorText = exports.EditorFormatColorReset = exports.EditorFormatColorFill = exports.EditorFormatClear = exports.EditorFormatBold = exports.EditorFormatAlignRight = exports.EditorFormatAlignLeft = exports.EditorFormatAlignJustify = exports.EditorFormatAlignCenter = exports.EditorDragHandle = exports.EditorBubbleChart = exports.EditorBorderVertical = exports.EditorBorderTop = exports.EditorBorderStyle = exports.EditorBorderRight = exports.EditorBorderOuter = exports.EditorBorderLeft = exports.EditorBorderInner = exports.EditorBorderHorizontal = exports.EditorBorderColor = exports.EditorBorderClear = exports.EditorBorderBottom = exports.EditorBorderAll = exports.EditorAttachMoney = exports.EditorAttachFile = exports.DeviceWifiTethering = exports.DeviceWifiLock = exports.DeviceWidgets = exports.DeviceWallpaper = exports.DeviceUsb = exports.DeviceStorage = exports.DeviceSignalWifiOff = exports.DeviceSignalWifi4Bar = exports.DeviceSignalWifi4BarLock = exports.DeviceSignalWifi3Bar = exports.DeviceSignalWifi3BarLock = exports.DeviceSignalWifi2Bar = exports.DeviceSignalWifi2BarLock = exports.DeviceSignalWifi1Bar = exports.DeviceSignalWifi1BarLock = exports.DeviceSignalWifi0Bar = exports.DeviceSignalCellularOff = exports.DeviceSignalCellularNull = exports.DeviceSignalCellularNoSim = exports.DeviceSignalCellularConnectedNoInternet4Bar = exports.DeviceSignalCellularConnectedNoInternet3Bar = exports.DeviceSignalCellularConnectedNoInternet2Bar = exports.DeviceSignalCellularConnectedNoInternet1Bar = exports.DeviceSignalCellularConnectedNoInternet0Bar = exports.DeviceSignalCellular4Bar = exports.DeviceSignalCellular3Bar = exports.DeviceSignalCellular2Bar = exports.DeviceSignalCellular1Bar = exports.DeviceSignalCellular0Bar = exports.DeviceSettingsSystemDaydream = exports.DeviceSdStorage = exports.DeviceScreenRotation = exports.DeviceScreenLockRotation = exports.DeviceScreenLockPortrait = exports.DeviceScreenLockLandscape = exports.DeviceNfc = exports.DeviceNetworkWifi = exports.DeviceNetworkCell = exports.DeviceLocationSearching = exports.DeviceLocationDisabled = exports.DeviceGraphicEq = exports.DeviceGpsOff = exports.DeviceGpsNotFixed = exports.DeviceGpsFixed = exports.DeviceDvr = exports.DeviceDevices = exports.DeviceDeveloperMode = exports.DeviceDataUsage = exports.DeviceBrightnessMedium = exports.DeviceBrightnessLow = exports.DeviceBrightnessHigh = exports.DeviceBrightnessAuto = exports.DeviceBluetooth = exports.DeviceBluetoothSearching = exports.DeviceBluetoothDisabled = exports.DeviceBluetoothConnected = exports.DeviceBatteryUnknown = exports.DeviceBatteryStd = exports.DeviceBatteryFull = exports.DeviceBatteryChargingFull = exports.DeviceBatteryCharging90 = exports.DeviceBatteryCharging80 = exports.DeviceBatteryCharging60 = exports.DeviceBatteryCharging50 = exports.DeviceBatteryCharging30 = exports.DeviceBatteryCharging20 = exports.DeviceBatteryAlert = exports.DeviceBattery90 = exports.DeviceBattery80 = undefined;
	exports.DeviceBattery60 = exports.DeviceBattery50 = exports.DeviceBattery30 = exports.DeviceBattery20 = exports.DeviceAirplanemodeInactive = exports.DeviceAirplanemodeActive = exports.DeviceAddAlarm = exports.DeviceAccessTime = exports.DeviceAccessAlarms = exports.DeviceAccessAlarm = exports.ContentWeekend = exports.ContentUndo = exports.ContentUnarchive = exports.ContentTextFormat = exports.ContentSort = exports.ContentSend = exports.ContentSelectAll = exports.ContentSave = exports.ContentReport = exports.ContentReply = exports.ContentReplyAll = exports.ContentRemove = exports.ContentRemoveCircle = exports.ContentRemoveCircleOutline = exports.ContentRedo = exports.ContentNextWeek = exports.ContentMoveToInbox = exports.ContentMarkunread = exports.ContentMail = exports.ContentLowPriority = exports.ContentLink = exports.ContentInbox = exports.ContentGesture = exports.ContentForward = exports.ContentFontDownload = exports.ContentFlag = exports.ContentFilterList = exports.ContentDrafts = exports.ContentDeleteSweep = exports.ContentCreate = exports.ContentContentPaste = exports.ContentContentCut = exports.ContentContentCopy = exports.ContentClear = exports.ContentBlock = exports.ContentBackspace = exports.ContentArchive = exports.ContentAdd = exports.ContentAddCircle = exports.ContentAddCircleOutline = exports.ContentAddBox = exports.CommunicationVpnKey = exports.CommunicationVoicemail = exports.CommunicationTextsms = exports.CommunicationSwapCalls = exports.CommunicationStopScreenShare = exports.CommunicationStayPrimaryPortrait = exports.CommunicationStayPrimaryLandscape = exports.CommunicationStayCurrentPortrait = exports.CommunicationStayCurrentLandscape = exports.CommunicationSpeakerPhone = exports.CommunicationScreenShare = exports.CommunicationRssFeed = exports.CommunicationRingVolume = exports.CommunicationPresentToAll = exports.CommunicationPortableWifiOff = exports.CommunicationPhonelinkSetup = exports.CommunicationPhonelinkRing = exports.CommunicationPhonelinkLock = exports.CommunicationPhonelinkErase = exports.CommunicationPhone = exports.CommunicationNoSim = exports.CommunicationMessage = exports.CommunicationMailOutline = exports.CommunicationLocationOn = exports.CommunicationLocationOff = exports.CommunicationLiveHelp = exports.CommunicationInvertColorsOff = exports.CommunicationImportExport = exports.CommunicationImportContacts = exports.CommunicationForum = exports.CommunicationEmail = exports.CommunicationDialpad = exports.CommunicationDialerSip = exports.CommunicationContacts = exports.CommunicationContactPhone = exports.CommunicationContactMail = exports.CommunicationComment = exports.CommunicationClearAll = exports.CommunicationChat = exports.CommunicationChatBubble = exports.CommunicationChatBubbleOutline = exports.CommunicationCall = exports.CommunicationCallSplit = exports.CommunicationCallReceived = exports.CommunicationCallMissed = exports.CommunicationCallMissedOutgoing = exports.CommunicationCallMerge = exports.CommunicationCallMade = exports.CommunicationCallEnd = undefined;
	exports.CommunicationBusiness = exports.AvWeb = exports.AvWebAsset = exports.AvVolumeUp = exports.AvVolumeOff = exports.AvVolumeMute = exports.AvVolumeDown = exports.AvVideocam = exports.AvVideocamOff = exports.AvVideoLibrary = exports.AvVideoLabel = exports.AvVideoCall = exports.AvSurroundSound = exports.AvSubtitles = exports.AvSubscriptions = exports.AvStop = exports.AvSortByAlpha = exports.AvSnooze = exports.AvSlowMotionVideo = exports.AvSkipPrevious = exports.AvSkipNext = exports.AvShuffle = exports.AvReplay = exports.AvReplay5 = exports.AvReplay30 = exports.AvReplay10 = exports.AvRepeat = exports.AvRepeatOne = exports.AvRemoveFromQueue = exports.AvRecentActors = exports.AvRadio = exports.AvQueue = exports.AvQueuePlayNext = exports.AvQueueMusic = exports.AvPlaylistPlay = exports.AvPlaylistAdd = exports.AvPlaylistAddCheck = exports.AvPlayCircleOutline = exports.AvPlayCircleFilled = exports.AvPlayArrow = exports.AvPause = exports.AvPauseCircleOutline = exports.AvPauseCircleFilled = exports.AvNote = exports.AvNotInterested = exports.AvNewReleases = exports.AvMusicVideo = exports.AvMovie = exports.AvMic = exports.AvMicOff = exports.AvMicNone = exports.AvLoop = exports.AvLibraryMusic = exports.AvLibraryBooks = exports.AvLibraryAdd = exports.AvHighQuality = exports.AvHearing = exports.AvHd = exports.AvGames = exports.AvForward5 = exports.AvForward30 = exports.AvForward10 = exports.AvFiberSmartRecord = exports.AvFiberPin = exports.AvFiberNew = exports.AvFiberManualRecord = exports.AvFiberDvr = exports.AvFeaturedVideo = exports.AvFeaturedPlayList = exports.AvFastRewind = exports.AvFastForward = exports.AvExplicit = exports.AvEqualizer = exports.AvClosedCaption = exports.AvCallToAction = exports.AvBrandingWatermark = exports.AvAvTimer = exports.AvArtTrack = exports.AvAlbum = exports.AvAirplay = exports.AvAddToQueue = exports.AlertWarning = exports.AlertError = exports.AlertErrorOutline = exports.AlertAddAlert = exports.ActionZoomOut = exports.ActionZoomIn = exports.ActionYoutubeSearchedFor = exports.ActionWork = exports.ActionWatchLater = exports.ActionVisibility = exports.ActionVisibilityOff = exports.ActionViewWeek = exports.ActionViewStream = exports.ActionViewQuilt = exports.ActionViewModule = exports.ActionViewList = exports.ActionViewHeadline = exports.ActionViewDay = exports.ActionViewColumn = undefined;
	exports.ActionViewCarousel = exports.ActionViewArray = exports.ActionViewAgenda = exports.ActionVerifiedUser = exports.ActionUpdate = exports.ActionTurnedIn = exports.ActionTurnedInNot = exports.ActionTrendingUp = exports.ActionTrendingFlat = exports.ActionTrendingDown = exports.ActionTranslate = exports.ActionTrackChanges = exports.ActionTouchApp = exports.ActionToll = exports.ActionToday = exports.ActionToc = exports.ActionTimeline = exports.ActionThumbsUpDown = exports.ActionThumbUp = exports.ActionThumbDown = exports.ActionThreeDRotation = exports.ActionTheaters = exports.ActionTab = exports.ActionTabUnselected = exports.ActionSystemUpdateAlt = exports.ActionSwapVerticalCircle = exports.ActionSwapVert = exports.ActionSwapHoriz = exports.ActionSupervisorAccount = exports.ActionSubject = exports.ActionStore = exports.ActionStars = exports.ActionSpellcheck = exports.ActionSpeakerNotes = exports.ActionSpeakerNotesOff = exports.ActionShoppingCart = exports.ActionShoppingBasket = exports.ActionShop = exports.ActionShopTwo = exports.ActionSettings = exports.ActionSettingsVoice = exports.ActionSettingsRemote = exports.ActionSettingsPower = exports.ActionSettingsPhone = exports.ActionSettingsOverscan = exports.ActionSettingsInputSvideo = exports.ActionSettingsInputHdmi = exports.ActionSettingsInputComposite = exports.ActionSettingsInputComponent = exports.ActionSettingsInputAntenna = exports.ActionSettingsEthernet = exports.ActionSettingsCell = exports.ActionSettingsBrightness = exports.ActionSettingsBluetooth = exports.ActionSettingsBackupRestore = exports.ActionSettingsApplications = exports.ActionSearch = exports.ActionSchedule = exports.ActionRowing = exports.ActionRoundedCorner = exports.ActionRoom = exports.ActionRestore = exports.ActionRestorePage = exports.ActionReportProblem = exports.ActionReorder = exports.ActionRemoveShoppingCart = exports.ActionRedeem = exports.ActionRecordVoiceOver = exports.ActionReceipt = exports.ActionQuestionAnswer = exports.ActionQueryBuilder = exports.ActionPrint = exports.ActionPregnantWoman = exports.ActionPowerSettingsNew = exports.ActionPolymer = exports.ActionPlayForWork = exports.ActionPictureInPicture = exports.ActionPictureInPictureAlt = exports.ActionPets = exports.ActionPermScanWifi = exports.ActionPermPhoneMsg = exports.ActionPermMedia = exports.ActionPermIdentity = exports.ActionPermDeviceInformation = exports.ActionPermDataSetting = exports.ActionPermContactCalendar = exports.ActionPermCameraMic = exports.ActionPayment = exports.ActionPanTool = exports.ActionPageview = exports.ActionOpenWith = exports.ActionOpenInNew = exports.ActionOpenInBrowser = exports.ActionOpacity = exports.ActionOfflinePin = exports.ActionNoteAdd = exports.ActionMotorcycle = exports.ActionMarkunreadMailbox = exports.ActionLoyalty = exports.ActionLock = undefined;
	exports.ActionLockOutline = exports.ActionLockOpen = exports.ActionList = exports.ActionLineWeight = exports.ActionLineStyle = exports.ActionLightbulbOutline = exports.ActionLaunch = exports.ActionLanguage = exports.ActionLabel = exports.ActionLabelOutline = exports.ActionInvertColors = exports.ActionInput = exports.ActionInfo = exports.ActionInfoOutline = exports.ActionImportantDevices = exports.ActionHttps = exports.ActionHttp = exports.ActionHourglassFull = exports.ActionHourglassEmpty = exports.ActionHome = exports.ActionHistory = exports.ActionHighlightOff = exports.ActionHelp = exports.ActionHelpOutline = exports.ActionGroupWork = exports.ActionGrade = exports.ActionGif = exports.ActionGetApp = exports.ActionGavel = exports.ActionGTranslate = exports.ActionFlipToFront = exports.ActionFlipToBack = exports.ActionFlightTakeoff = exports.ActionFlightLand = exports.ActionFingerprint = exports.ActionFindReplace = exports.ActionFindInPage = exports.ActionFeedback = exports.ActionFavorite = exports.ActionFavoriteBorder = exports.ActionFace = exports.ActionExtension = exports.ActionExplore = exports.ActionExitToApp = exports.ActionEvent = exports.ActionEventSeat = exports.ActionEuroSymbol = exports.ActionEject = exports.ActionDonutSmall = exports.ActionDonutLarge = exports.ActionDone = exports.ActionDoneAll = exports.ActionDns = exports.ActionDescription = exports.ActionDelete = exports.ActionDeleteForever = exports.ActionDateRange = exports.ActionDashboard = exports.ActionCreditCard = exports.ActionCopyright = exports.ActionCompareArrows = exports.ActionCode = exports.ActionClass = exports.ActionChromeReaderMode = exports.ActionCheckCircle = exports.ActionChangeHistory = exports.ActionCardTravel = exports.ActionCardMembership = exports.ActionCardGiftcard = exports.ActionCameraEnhance = exports.ActionCached = exports.ActionBuild = exports.ActionBugReport = exports.ActionBookmark = exports.ActionBookmarkBorder = exports.ActionBook = exports.ActionBackup = exports.ActionAutorenew = exports.ActionAssignment = exports.ActionAssignmentTurnedIn = exports.ActionAssignmentReturned = exports.ActionAssignmentReturn = exports.ActionAssignmentLate = exports.ActionAssignmentInd = exports.ActionAssessment = exports.ActionAspectRatio = exports.ActionAnnouncement = exports.ActionAndroid = exports.ActionAllOut = exports.ActionAlarm = exports.ActionAlarmOn = exports.ActionAlarmOff = exports.ActionAlarmAdd = exports.ActionAddShoppingCart = exports.ActionAccountCircle = exports.ActionAccountBox = exports.ActionAccountBalance = exports.ActionAccountBalanceWallet = exports.ActionAccessible = exports.ActionAccessibility = undefined;
	
	var _accessibility = __webpack_require__(888);
	
	var _accessibility2 = _interopRequireDefault(_accessibility);
	
	var _accessible = __webpack_require__(889);
	
	var _accessible2 = _interopRequireDefault(_accessible);
	
	var _accountBalanceWallet = __webpack_require__(890);
	
	var _accountBalanceWallet2 = _interopRequireDefault(_accountBalanceWallet);
	
	var _accountBalance = __webpack_require__(891);
	
	var _accountBalance2 = _interopRequireDefault(_accountBalance);
	
	var _accountBox = __webpack_require__(892);
	
	var _accountBox2 = _interopRequireDefault(_accountBox);
	
	var _accountCircle = __webpack_require__(893);
	
	var _accountCircle2 = _interopRequireDefault(_accountCircle);
	
	var _addShoppingCart = __webpack_require__(894);
	
	var _addShoppingCart2 = _interopRequireDefault(_addShoppingCart);
	
	var _alarmAdd = __webpack_require__(895);
	
	var _alarmAdd2 = _interopRequireDefault(_alarmAdd);
	
	var _alarmOff = __webpack_require__(896);
	
	var _alarmOff2 = _interopRequireDefault(_alarmOff);
	
	var _alarmOn = __webpack_require__(897);
	
	var _alarmOn2 = _interopRequireDefault(_alarmOn);
	
	var _alarm = __webpack_require__(898);
	
	var _alarm2 = _interopRequireDefault(_alarm);
	
	var _allOut = __webpack_require__(899);
	
	var _allOut2 = _interopRequireDefault(_allOut);
	
	var _android = __webpack_require__(900);
	
	var _android2 = _interopRequireDefault(_android);
	
	var _announcement = __webpack_require__(901);
	
	var _announcement2 = _interopRequireDefault(_announcement);
	
	var _aspectRatio = __webpack_require__(902);
	
	var _aspectRatio2 = _interopRequireDefault(_aspectRatio);
	
	var _assessment = __webpack_require__(903);
	
	var _assessment2 = _interopRequireDefault(_assessment);
	
	var _assignmentInd = __webpack_require__(904);
	
	var _assignmentInd2 = _interopRequireDefault(_assignmentInd);
	
	var _assignmentLate = __webpack_require__(905);
	
	var _assignmentLate2 = _interopRequireDefault(_assignmentLate);
	
	var _assignmentReturn = __webpack_require__(906);
	
	var _assignmentReturn2 = _interopRequireDefault(_assignmentReturn);
	
	var _assignmentReturned = __webpack_require__(907);
	
	var _assignmentReturned2 = _interopRequireDefault(_assignmentReturned);
	
	var _assignmentTurnedIn = __webpack_require__(908);
	
	var _assignmentTurnedIn2 = _interopRequireDefault(_assignmentTurnedIn);
	
	var _assignment = __webpack_require__(909);
	
	var _assignment2 = _interopRequireDefault(_assignment);
	
	var _autorenew = __webpack_require__(910);
	
	var _autorenew2 = _interopRequireDefault(_autorenew);
	
	var _backup = __webpack_require__(911);
	
	var _backup2 = _interopRequireDefault(_backup);
	
	var _book = __webpack_require__(912);
	
	var _book2 = _interopRequireDefault(_book);
	
	var _bookmarkBorder = __webpack_require__(913);
	
	var _bookmarkBorder2 = _interopRequireDefault(_bookmarkBorder);
	
	var _bookmark = __webpack_require__(914);
	
	var _bookmark2 = _interopRequireDefault(_bookmark);
	
	var _bugReport = __webpack_require__(915);
	
	var _bugReport2 = _interopRequireDefault(_bugReport);
	
	var _build = __webpack_require__(916);
	
	var _build2 = _interopRequireDefault(_build);
	
	var _cached = __webpack_require__(917);
	
	var _cached2 = _interopRequireDefault(_cached);
	
	var _cameraEnhance = __webpack_require__(918);
	
	var _cameraEnhance2 = _interopRequireDefault(_cameraEnhance);
	
	var _cardGiftcard = __webpack_require__(919);
	
	var _cardGiftcard2 = _interopRequireDefault(_cardGiftcard);
	
	var _cardMembership = __webpack_require__(920);
	
	var _cardMembership2 = _interopRequireDefault(_cardMembership);
	
	var _cardTravel = __webpack_require__(921);
	
	var _cardTravel2 = _interopRequireDefault(_cardTravel);
	
	var _changeHistory = __webpack_require__(922);
	
	var _changeHistory2 = _interopRequireDefault(_changeHistory);
	
	var _checkCircle = __webpack_require__(375);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _chromeReaderMode = __webpack_require__(923);
	
	var _chromeReaderMode2 = _interopRequireDefault(_chromeReaderMode);
	
	var _class = __webpack_require__(924);
	
	var _class2 = _interopRequireDefault(_class);
	
	var _code = __webpack_require__(925);
	
	var _code2 = _interopRequireDefault(_code);
	
	var _compareArrows = __webpack_require__(926);
	
	var _compareArrows2 = _interopRequireDefault(_compareArrows);
	
	var _copyright = __webpack_require__(927);
	
	var _copyright2 = _interopRequireDefault(_copyright);
	
	var _creditCard = __webpack_require__(928);
	
	var _creditCard2 = _interopRequireDefault(_creditCard);
	
	var _dashboard = __webpack_require__(929);
	
	var _dashboard2 = _interopRequireDefault(_dashboard);
	
	var _dateRange = __webpack_require__(930);
	
	var _dateRange2 = _interopRequireDefault(_dateRange);
	
	var _deleteForever = __webpack_require__(931);
	
	var _deleteForever2 = _interopRequireDefault(_deleteForever);
	
	var _delete = __webpack_require__(932);
	
	var _delete2 = _interopRequireDefault(_delete);
	
	var _description = __webpack_require__(933);
	
	var _description2 = _interopRequireDefault(_description);
	
	var _dns = __webpack_require__(934);
	
	var _dns2 = _interopRequireDefault(_dns);
	
	var _doneAll = __webpack_require__(935);
	
	var _doneAll2 = _interopRequireDefault(_doneAll);
	
	var _done = __webpack_require__(936);
	
	var _done2 = _interopRequireDefault(_done);
	
	var _donutLarge = __webpack_require__(937);
	
	var _donutLarge2 = _interopRequireDefault(_donutLarge);
	
	var _donutSmall = __webpack_require__(938);
	
	var _donutSmall2 = _interopRequireDefault(_donutSmall);
	
	var _eject = __webpack_require__(939);
	
	var _eject2 = _interopRequireDefault(_eject);
	
	var _euroSymbol = __webpack_require__(940);
	
	var _euroSymbol2 = _interopRequireDefault(_euroSymbol);
	
	var _eventSeat = __webpack_require__(941);
	
	var _eventSeat2 = _interopRequireDefault(_eventSeat);
	
	var _event = __webpack_require__(942);
	
	var _event2 = _interopRequireDefault(_event);
	
	var _exitToApp = __webpack_require__(943);
	
	var _exitToApp2 = _interopRequireDefault(_exitToApp);
	
	var _explore = __webpack_require__(944);
	
	var _explore2 = _interopRequireDefault(_explore);
	
	var _extension = __webpack_require__(945);
	
	var _extension2 = _interopRequireDefault(_extension);
	
	var _face = __webpack_require__(946);
	
	var _face2 = _interopRequireDefault(_face);
	
	var _favoriteBorder = __webpack_require__(947);
	
	var _favoriteBorder2 = _interopRequireDefault(_favoriteBorder);
	
	var _favorite = __webpack_require__(948);
	
	var _favorite2 = _interopRequireDefault(_favorite);
	
	var _feedback = __webpack_require__(949);
	
	var _feedback2 = _interopRequireDefault(_feedback);
	
	var _findInPage = __webpack_require__(950);
	
	var _findInPage2 = _interopRequireDefault(_findInPage);
	
	var _findReplace = __webpack_require__(951);
	
	var _findReplace2 = _interopRequireDefault(_findReplace);
	
	var _fingerprint = __webpack_require__(952);
	
	var _fingerprint2 = _interopRequireDefault(_fingerprint);
	
	var _flightLand = __webpack_require__(953);
	
	var _flightLand2 = _interopRequireDefault(_flightLand);
	
	var _flightTakeoff = __webpack_require__(954);
	
	var _flightTakeoff2 = _interopRequireDefault(_flightTakeoff);
	
	var _flipToBack = __webpack_require__(955);
	
	var _flipToBack2 = _interopRequireDefault(_flipToBack);
	
	var _flipToFront = __webpack_require__(956);
	
	var _flipToFront2 = _interopRequireDefault(_flipToFront);
	
	var _gTranslate = __webpack_require__(957);
	
	var _gTranslate2 = _interopRequireDefault(_gTranslate);
	
	var _gavel = __webpack_require__(958);
	
	var _gavel2 = _interopRequireDefault(_gavel);
	
	var _getApp = __webpack_require__(959);
	
	var _getApp2 = _interopRequireDefault(_getApp);
	
	var _gif = __webpack_require__(960);
	
	var _gif2 = _interopRequireDefault(_gif);
	
	var _grade = __webpack_require__(961);
	
	var _grade2 = _interopRequireDefault(_grade);
	
	var _groupWork = __webpack_require__(962);
	
	var _groupWork2 = _interopRequireDefault(_groupWork);
	
	var _helpOutline = __webpack_require__(963);
	
	var _helpOutline2 = _interopRequireDefault(_helpOutline);
	
	var _help = __webpack_require__(964);
	
	var _help2 = _interopRequireDefault(_help);
	
	var _highlightOff = __webpack_require__(965);
	
	var _highlightOff2 = _interopRequireDefault(_highlightOff);
	
	var _history = __webpack_require__(966);
	
	var _history2 = _interopRequireDefault(_history);
	
	var _home = __webpack_require__(967);
	
	var _home2 = _interopRequireDefault(_home);
	
	var _hourglassEmpty = __webpack_require__(968);
	
	var _hourglassEmpty2 = _interopRequireDefault(_hourglassEmpty);
	
	var _hourglassFull = __webpack_require__(969);
	
	var _hourglassFull2 = _interopRequireDefault(_hourglassFull);
	
	var _http = __webpack_require__(970);
	
	var _http2 = _interopRequireDefault(_http);
	
	var _https = __webpack_require__(971);
	
	var _https2 = _interopRequireDefault(_https);
	
	var _importantDevices = __webpack_require__(972);
	
	var _importantDevices2 = _interopRequireDefault(_importantDevices);
	
	var _infoOutline = __webpack_require__(973);
	
	var _infoOutline2 = _interopRequireDefault(_infoOutline);
	
	var _info = __webpack_require__(974);
	
	var _info2 = _interopRequireDefault(_info);
	
	var _input = __webpack_require__(975);
	
	var _input2 = _interopRequireDefault(_input);
	
	var _invertColors = __webpack_require__(976);
	
	var _invertColors2 = _interopRequireDefault(_invertColors);
	
	var _labelOutline = __webpack_require__(977);
	
	var _labelOutline2 = _interopRequireDefault(_labelOutline);
	
	var _label = __webpack_require__(978);
	
	var _label2 = _interopRequireDefault(_label);
	
	var _language = __webpack_require__(979);
	
	var _language2 = _interopRequireDefault(_language);
	
	var _launch = __webpack_require__(980);
	
	var _launch2 = _interopRequireDefault(_launch);
	
	var _lightbulbOutline = __webpack_require__(981);
	
	var _lightbulbOutline2 = _interopRequireDefault(_lightbulbOutline);
	
	var _lineStyle = __webpack_require__(982);
	
	var _lineStyle2 = _interopRequireDefault(_lineStyle);
	
	var _lineWeight = __webpack_require__(983);
	
	var _lineWeight2 = _interopRequireDefault(_lineWeight);
	
	var _list = __webpack_require__(984);
	
	var _list2 = _interopRequireDefault(_list);
	
	var _lockOpen = __webpack_require__(985);
	
	var _lockOpen2 = _interopRequireDefault(_lockOpen);
	
	var _lockOutline = __webpack_require__(986);
	
	var _lockOutline2 = _interopRequireDefault(_lockOutline);
	
	var _lock = __webpack_require__(987);
	
	var _lock2 = _interopRequireDefault(_lock);
	
	var _loyalty = __webpack_require__(988);
	
	var _loyalty2 = _interopRequireDefault(_loyalty);
	
	var _markunreadMailbox = __webpack_require__(989);
	
	var _markunreadMailbox2 = _interopRequireDefault(_markunreadMailbox);
	
	var _motorcycle = __webpack_require__(990);
	
	var _motorcycle2 = _interopRequireDefault(_motorcycle);
	
	var _noteAdd = __webpack_require__(991);
	
	var _noteAdd2 = _interopRequireDefault(_noteAdd);
	
	var _offlinePin = __webpack_require__(992);
	
	var _offlinePin2 = _interopRequireDefault(_offlinePin);
	
	var _opacity = __webpack_require__(993);
	
	var _opacity2 = _interopRequireDefault(_opacity);
	
	var _openInBrowser = __webpack_require__(994);
	
	var _openInBrowser2 = _interopRequireDefault(_openInBrowser);
	
	var _openInNew = __webpack_require__(995);
	
	var _openInNew2 = _interopRequireDefault(_openInNew);
	
	var _openWith = __webpack_require__(996);
	
	var _openWith2 = _interopRequireDefault(_openWith);
	
	var _pageview = __webpack_require__(997);
	
	var _pageview2 = _interopRequireDefault(_pageview);
	
	var _panTool = __webpack_require__(998);
	
	var _panTool2 = _interopRequireDefault(_panTool);
	
	var _payment = __webpack_require__(999);
	
	var _payment2 = _interopRequireDefault(_payment);
	
	var _permCameraMic = __webpack_require__(1000);
	
	var _permCameraMic2 = _interopRequireDefault(_permCameraMic);
	
	var _permContactCalendar = __webpack_require__(1001);
	
	var _permContactCalendar2 = _interopRequireDefault(_permContactCalendar);
	
	var _permDataSetting = __webpack_require__(1002);
	
	var _permDataSetting2 = _interopRequireDefault(_permDataSetting);
	
	var _permDeviceInformation = __webpack_require__(1003);
	
	var _permDeviceInformation2 = _interopRequireDefault(_permDeviceInformation);
	
	var _permIdentity = __webpack_require__(1004);
	
	var _permIdentity2 = _interopRequireDefault(_permIdentity);
	
	var _permMedia = __webpack_require__(1005);
	
	var _permMedia2 = _interopRequireDefault(_permMedia);
	
	var _permPhoneMsg = __webpack_require__(1006);
	
	var _permPhoneMsg2 = _interopRequireDefault(_permPhoneMsg);
	
	var _permScanWifi = __webpack_require__(1007);
	
	var _permScanWifi2 = _interopRequireDefault(_permScanWifi);
	
	var _pets = __webpack_require__(1008);
	
	var _pets2 = _interopRequireDefault(_pets);
	
	var _pictureInPictureAlt = __webpack_require__(1009);
	
	var _pictureInPictureAlt2 = _interopRequireDefault(_pictureInPictureAlt);
	
	var _pictureInPicture = __webpack_require__(1010);
	
	var _pictureInPicture2 = _interopRequireDefault(_pictureInPicture);
	
	var _playForWork = __webpack_require__(1011);
	
	var _playForWork2 = _interopRequireDefault(_playForWork);
	
	var _polymer = __webpack_require__(1012);
	
	var _polymer2 = _interopRequireDefault(_polymer);
	
	var _powerSettingsNew = __webpack_require__(1013);
	
	var _powerSettingsNew2 = _interopRequireDefault(_powerSettingsNew);
	
	var _pregnantWoman = __webpack_require__(1014);
	
	var _pregnantWoman2 = _interopRequireDefault(_pregnantWoman);
	
	var _print = __webpack_require__(1015);
	
	var _print2 = _interopRequireDefault(_print);
	
	var _queryBuilder = __webpack_require__(1016);
	
	var _queryBuilder2 = _interopRequireDefault(_queryBuilder);
	
	var _questionAnswer = __webpack_require__(1017);
	
	var _questionAnswer2 = _interopRequireDefault(_questionAnswer);
	
	var _receipt = __webpack_require__(1018);
	
	var _receipt2 = _interopRequireDefault(_receipt);
	
	var _recordVoiceOver = __webpack_require__(1019);
	
	var _recordVoiceOver2 = _interopRequireDefault(_recordVoiceOver);
	
	var _redeem = __webpack_require__(1020);
	
	var _redeem2 = _interopRequireDefault(_redeem);
	
	var _removeShoppingCart = __webpack_require__(1021);
	
	var _removeShoppingCart2 = _interopRequireDefault(_removeShoppingCart);
	
	var _reorder = __webpack_require__(1022);
	
	var _reorder2 = _interopRequireDefault(_reorder);
	
	var _reportProblem = __webpack_require__(1023);
	
	var _reportProblem2 = _interopRequireDefault(_reportProblem);
	
	var _restorePage = __webpack_require__(1024);
	
	var _restorePage2 = _interopRequireDefault(_restorePage);
	
	var _restore = __webpack_require__(1025);
	
	var _restore2 = _interopRequireDefault(_restore);
	
	var _room = __webpack_require__(1026);
	
	var _room2 = _interopRequireDefault(_room);
	
	var _roundedCorner = __webpack_require__(1027);
	
	var _roundedCorner2 = _interopRequireDefault(_roundedCorner);
	
	var _rowing = __webpack_require__(1028);
	
	var _rowing2 = _interopRequireDefault(_rowing);
	
	var _schedule = __webpack_require__(1029);
	
	var _schedule2 = _interopRequireDefault(_schedule);
	
	var _search = __webpack_require__(1030);
	
	var _search2 = _interopRequireDefault(_search);
	
	var _settingsApplications = __webpack_require__(1031);
	
	var _settingsApplications2 = _interopRequireDefault(_settingsApplications);
	
	var _settingsBackupRestore = __webpack_require__(1032);
	
	var _settingsBackupRestore2 = _interopRequireDefault(_settingsBackupRestore);
	
	var _settingsBluetooth = __webpack_require__(1033);
	
	var _settingsBluetooth2 = _interopRequireDefault(_settingsBluetooth);
	
	var _settingsBrightness = __webpack_require__(1034);
	
	var _settingsBrightness2 = _interopRequireDefault(_settingsBrightness);
	
	var _settingsCell = __webpack_require__(1035);
	
	var _settingsCell2 = _interopRequireDefault(_settingsCell);
	
	var _settingsEthernet = __webpack_require__(1036);
	
	var _settingsEthernet2 = _interopRequireDefault(_settingsEthernet);
	
	var _settingsInputAntenna = __webpack_require__(1037);
	
	var _settingsInputAntenna2 = _interopRequireDefault(_settingsInputAntenna);
	
	var _settingsInputComponent = __webpack_require__(1038);
	
	var _settingsInputComponent2 = _interopRequireDefault(_settingsInputComponent);
	
	var _settingsInputComposite = __webpack_require__(1039);
	
	var _settingsInputComposite2 = _interopRequireDefault(_settingsInputComposite);
	
	var _settingsInputHdmi = __webpack_require__(1040);
	
	var _settingsInputHdmi2 = _interopRequireDefault(_settingsInputHdmi);
	
	var _settingsInputSvideo = __webpack_require__(1041);
	
	var _settingsInputSvideo2 = _interopRequireDefault(_settingsInputSvideo);
	
	var _settingsOverscan = __webpack_require__(1042);
	
	var _settingsOverscan2 = _interopRequireDefault(_settingsOverscan);
	
	var _settingsPhone = __webpack_require__(1043);
	
	var _settingsPhone2 = _interopRequireDefault(_settingsPhone);
	
	var _settingsPower = __webpack_require__(1044);
	
	var _settingsPower2 = _interopRequireDefault(_settingsPower);
	
	var _settingsRemote = __webpack_require__(1045);
	
	var _settingsRemote2 = _interopRequireDefault(_settingsRemote);
	
	var _settingsVoice = __webpack_require__(1046);
	
	var _settingsVoice2 = _interopRequireDefault(_settingsVoice);
	
	var _settings = __webpack_require__(1047);
	
	var _settings2 = _interopRequireDefault(_settings);
	
	var _shopTwo = __webpack_require__(1048);
	
	var _shopTwo2 = _interopRequireDefault(_shopTwo);
	
	var _shop = __webpack_require__(1049);
	
	var _shop2 = _interopRequireDefault(_shop);
	
	var _shoppingBasket = __webpack_require__(1050);
	
	var _shoppingBasket2 = _interopRequireDefault(_shoppingBasket);
	
	var _shoppingCart = __webpack_require__(1051);
	
	var _shoppingCart2 = _interopRequireDefault(_shoppingCart);
	
	var _speakerNotesOff = __webpack_require__(1052);
	
	var _speakerNotesOff2 = _interopRequireDefault(_speakerNotesOff);
	
	var _speakerNotes = __webpack_require__(1053);
	
	var _speakerNotes2 = _interopRequireDefault(_speakerNotes);
	
	var _spellcheck = __webpack_require__(1054);
	
	var _spellcheck2 = _interopRequireDefault(_spellcheck);
	
	var _stars = __webpack_require__(1055);
	
	var _stars2 = _interopRequireDefault(_stars);
	
	var _store = __webpack_require__(1056);
	
	var _store2 = _interopRequireDefault(_store);
	
	var _subject = __webpack_require__(1057);
	
	var _subject2 = _interopRequireDefault(_subject);
	
	var _supervisorAccount = __webpack_require__(1058);
	
	var _supervisorAccount2 = _interopRequireDefault(_supervisorAccount);
	
	var _swapHoriz = __webpack_require__(1059);
	
	var _swapHoriz2 = _interopRequireDefault(_swapHoriz);
	
	var _swapVert = __webpack_require__(1060);
	
	var _swapVert2 = _interopRequireDefault(_swapVert);
	
	var _swapVerticalCircle = __webpack_require__(1061);
	
	var _swapVerticalCircle2 = _interopRequireDefault(_swapVerticalCircle);
	
	var _systemUpdateAlt = __webpack_require__(1062);
	
	var _systemUpdateAlt2 = _interopRequireDefault(_systemUpdateAlt);
	
	var _tabUnselected = __webpack_require__(1063);
	
	var _tabUnselected2 = _interopRequireDefault(_tabUnselected);
	
	var _tab = __webpack_require__(1064);
	
	var _tab2 = _interopRequireDefault(_tab);
	
	var _theaters = __webpack_require__(1065);
	
	var _theaters2 = _interopRequireDefault(_theaters);
	
	var _threeDRotation = __webpack_require__(1066);
	
	var _threeDRotation2 = _interopRequireDefault(_threeDRotation);
	
	var _thumbDown = __webpack_require__(1067);
	
	var _thumbDown2 = _interopRequireDefault(_thumbDown);
	
	var _thumbUp = __webpack_require__(1068);
	
	var _thumbUp2 = _interopRequireDefault(_thumbUp);
	
	var _thumbsUpDown = __webpack_require__(1069);
	
	var _thumbsUpDown2 = _interopRequireDefault(_thumbsUpDown);
	
	var _timeline = __webpack_require__(1070);
	
	var _timeline2 = _interopRequireDefault(_timeline);
	
	var _toc = __webpack_require__(1071);
	
	var _toc2 = _interopRequireDefault(_toc);
	
	var _today = __webpack_require__(1072);
	
	var _today2 = _interopRequireDefault(_today);
	
	var _toll = __webpack_require__(1073);
	
	var _toll2 = _interopRequireDefault(_toll);
	
	var _touchApp = __webpack_require__(1074);
	
	var _touchApp2 = _interopRequireDefault(_touchApp);
	
	var _trackChanges = __webpack_require__(1075);
	
	var _trackChanges2 = _interopRequireDefault(_trackChanges);
	
	var _translate = __webpack_require__(1076);
	
	var _translate2 = _interopRequireDefault(_translate);
	
	var _trendingDown = __webpack_require__(1077);
	
	var _trendingDown2 = _interopRequireDefault(_trendingDown);
	
	var _trendingFlat = __webpack_require__(1078);
	
	var _trendingFlat2 = _interopRequireDefault(_trendingFlat);
	
	var _trendingUp = __webpack_require__(1079);
	
	var _trendingUp2 = _interopRequireDefault(_trendingUp);
	
	var _turnedInNot = __webpack_require__(1080);
	
	var _turnedInNot2 = _interopRequireDefault(_turnedInNot);
	
	var _turnedIn = __webpack_require__(1081);
	
	var _turnedIn2 = _interopRequireDefault(_turnedIn);
	
	var _update = __webpack_require__(1082);
	
	var _update2 = _interopRequireDefault(_update);
	
	var _verifiedUser = __webpack_require__(1083);
	
	var _verifiedUser2 = _interopRequireDefault(_verifiedUser);
	
	var _viewAgenda = __webpack_require__(1084);
	
	var _viewAgenda2 = _interopRequireDefault(_viewAgenda);
	
	var _viewArray = __webpack_require__(1085);
	
	var _viewArray2 = _interopRequireDefault(_viewArray);
	
	var _viewCarousel = __webpack_require__(1086);
	
	var _viewCarousel2 = _interopRequireDefault(_viewCarousel);
	
	var _viewColumn = __webpack_require__(1087);
	
	var _viewColumn2 = _interopRequireDefault(_viewColumn);
	
	var _viewDay = __webpack_require__(1088);
	
	var _viewDay2 = _interopRequireDefault(_viewDay);
	
	var _viewHeadline = __webpack_require__(1089);
	
	var _viewHeadline2 = _interopRequireDefault(_viewHeadline);
	
	var _viewList = __webpack_require__(1090);
	
	var _viewList2 = _interopRequireDefault(_viewList);
	
	var _viewModule = __webpack_require__(1091);
	
	var _viewModule2 = _interopRequireDefault(_viewModule);
	
	var _viewQuilt = __webpack_require__(1092);
	
	var _viewQuilt2 = _interopRequireDefault(_viewQuilt);
	
	var _viewStream = __webpack_require__(1093);
	
	var _viewStream2 = _interopRequireDefault(_viewStream);
	
	var _viewWeek = __webpack_require__(1094);
	
	var _viewWeek2 = _interopRequireDefault(_viewWeek);
	
	var _visibilityOff = __webpack_require__(1095);
	
	var _visibilityOff2 = _interopRequireDefault(_visibilityOff);
	
	var _visibility = __webpack_require__(1096);
	
	var _visibility2 = _interopRequireDefault(_visibility);
	
	var _watchLater = __webpack_require__(1097);
	
	var _watchLater2 = _interopRequireDefault(_watchLater);
	
	var _work = __webpack_require__(1098);
	
	var _work2 = _interopRequireDefault(_work);
	
	var _youtubeSearchedFor = __webpack_require__(1099);
	
	var _youtubeSearchedFor2 = _interopRequireDefault(_youtubeSearchedFor);
	
	var _zoomIn = __webpack_require__(1100);
	
	var _zoomIn2 = _interopRequireDefault(_zoomIn);
	
	var _zoomOut = __webpack_require__(1101);
	
	var _zoomOut2 = _interopRequireDefault(_zoomOut);
	
	var _addAlert = __webpack_require__(1102);
	
	var _addAlert2 = _interopRequireDefault(_addAlert);
	
	var _errorOutline = __webpack_require__(1103);
	
	var _errorOutline2 = _interopRequireDefault(_errorOutline);
	
	var _error = __webpack_require__(1104);
	
	var _error2 = _interopRequireDefault(_error);
	
	var _warning = __webpack_require__(1105);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _addToQueue = __webpack_require__(1106);
	
	var _addToQueue2 = _interopRequireDefault(_addToQueue);
	
	var _airplay = __webpack_require__(1107);
	
	var _airplay2 = _interopRequireDefault(_airplay);
	
	var _album = __webpack_require__(1108);
	
	var _album2 = _interopRequireDefault(_album);
	
	var _artTrack = __webpack_require__(1109);
	
	var _artTrack2 = _interopRequireDefault(_artTrack);
	
	var _avTimer = __webpack_require__(1110);
	
	var _avTimer2 = _interopRequireDefault(_avTimer);
	
	var _brandingWatermark = __webpack_require__(1111);
	
	var _brandingWatermark2 = _interopRequireDefault(_brandingWatermark);
	
	var _callToAction = __webpack_require__(1112);
	
	var _callToAction2 = _interopRequireDefault(_callToAction);
	
	var _closedCaption = __webpack_require__(1113);
	
	var _closedCaption2 = _interopRequireDefault(_closedCaption);
	
	var _equalizer = __webpack_require__(1114);
	
	var _equalizer2 = _interopRequireDefault(_equalizer);
	
	var _explicit = __webpack_require__(1115);
	
	var _explicit2 = _interopRequireDefault(_explicit);
	
	var _fastForward = __webpack_require__(1116);
	
	var _fastForward2 = _interopRequireDefault(_fastForward);
	
	var _fastRewind = __webpack_require__(1117);
	
	var _fastRewind2 = _interopRequireDefault(_fastRewind);
	
	var _featuredPlayList = __webpack_require__(1118);
	
	var _featuredPlayList2 = _interopRequireDefault(_featuredPlayList);
	
	var _featuredVideo = __webpack_require__(1119);
	
	var _featuredVideo2 = _interopRequireDefault(_featuredVideo);
	
	var _fiberDvr = __webpack_require__(1120);
	
	var _fiberDvr2 = _interopRequireDefault(_fiberDvr);
	
	var _fiberManualRecord = __webpack_require__(1121);
	
	var _fiberManualRecord2 = _interopRequireDefault(_fiberManualRecord);
	
	var _fiberNew = __webpack_require__(1122);
	
	var _fiberNew2 = _interopRequireDefault(_fiberNew);
	
	var _fiberPin = __webpack_require__(1123);
	
	var _fiberPin2 = _interopRequireDefault(_fiberPin);
	
	var _fiberSmartRecord = __webpack_require__(1124);
	
	var _fiberSmartRecord2 = _interopRequireDefault(_fiberSmartRecord);
	
	var _forward = __webpack_require__(1125);
	
	var _forward2 = _interopRequireDefault(_forward);
	
	var _forward3 = __webpack_require__(1126);
	
	var _forward4 = _interopRequireDefault(_forward3);
	
	var _forward5 = __webpack_require__(1127);
	
	var _forward6 = _interopRequireDefault(_forward5);
	
	var _games = __webpack_require__(1128);
	
	var _games2 = _interopRequireDefault(_games);
	
	var _hd = __webpack_require__(1129);
	
	var _hd2 = _interopRequireDefault(_hd);
	
	var _hearing = __webpack_require__(1130);
	
	var _hearing2 = _interopRequireDefault(_hearing);
	
	var _highQuality = __webpack_require__(1131);
	
	var _highQuality2 = _interopRequireDefault(_highQuality);
	
	var _libraryAdd = __webpack_require__(1132);
	
	var _libraryAdd2 = _interopRequireDefault(_libraryAdd);
	
	var _libraryBooks = __webpack_require__(1133);
	
	var _libraryBooks2 = _interopRequireDefault(_libraryBooks);
	
	var _libraryMusic = __webpack_require__(1134);
	
	var _libraryMusic2 = _interopRequireDefault(_libraryMusic);
	
	var _loop = __webpack_require__(1135);
	
	var _loop2 = _interopRequireDefault(_loop);
	
	var _micNone = __webpack_require__(1136);
	
	var _micNone2 = _interopRequireDefault(_micNone);
	
	var _micOff = __webpack_require__(1137);
	
	var _micOff2 = _interopRequireDefault(_micOff);
	
	var _mic = __webpack_require__(1138);
	
	var _mic2 = _interopRequireDefault(_mic);
	
	var _movie = __webpack_require__(1139);
	
	var _movie2 = _interopRequireDefault(_movie);
	
	var _musicVideo = __webpack_require__(1140);
	
	var _musicVideo2 = _interopRequireDefault(_musicVideo);
	
	var _newReleases = __webpack_require__(1141);
	
	var _newReleases2 = _interopRequireDefault(_newReleases);
	
	var _notInterested = __webpack_require__(1142);
	
	var _notInterested2 = _interopRequireDefault(_notInterested);
	
	var _note = __webpack_require__(1143);
	
	var _note2 = _interopRequireDefault(_note);
	
	var _pauseCircleFilled = __webpack_require__(1144);
	
	var _pauseCircleFilled2 = _interopRequireDefault(_pauseCircleFilled);
	
	var _pauseCircleOutline = __webpack_require__(1145);
	
	var _pauseCircleOutline2 = _interopRequireDefault(_pauseCircleOutline);
	
	var _pause = __webpack_require__(1146);
	
	var _pause2 = _interopRequireDefault(_pause);
	
	var _playArrow = __webpack_require__(1147);
	
	var _playArrow2 = _interopRequireDefault(_playArrow);
	
	var _playCircleFilled = __webpack_require__(1148);
	
	var _playCircleFilled2 = _interopRequireDefault(_playCircleFilled);
	
	var _playCircleOutline = __webpack_require__(1149);
	
	var _playCircleOutline2 = _interopRequireDefault(_playCircleOutline);
	
	var _playlistAddCheck = __webpack_require__(1150);
	
	var _playlistAddCheck2 = _interopRequireDefault(_playlistAddCheck);
	
	var _playlistAdd = __webpack_require__(1151);
	
	var _playlistAdd2 = _interopRequireDefault(_playlistAdd);
	
	var _playlistPlay = __webpack_require__(1152);
	
	var _playlistPlay2 = _interopRequireDefault(_playlistPlay);
	
	var _queueMusic = __webpack_require__(1153);
	
	var _queueMusic2 = _interopRequireDefault(_queueMusic);
	
	var _queuePlayNext = __webpack_require__(1154);
	
	var _queuePlayNext2 = _interopRequireDefault(_queuePlayNext);
	
	var _queue = __webpack_require__(1155);
	
	var _queue2 = _interopRequireDefault(_queue);
	
	var _radio = __webpack_require__(1156);
	
	var _radio2 = _interopRequireDefault(_radio);
	
	var _recentActors = __webpack_require__(1157);
	
	var _recentActors2 = _interopRequireDefault(_recentActors);
	
	var _removeFromQueue = __webpack_require__(1158);
	
	var _removeFromQueue2 = _interopRequireDefault(_removeFromQueue);
	
	var _repeatOne = __webpack_require__(1159);
	
	var _repeatOne2 = _interopRequireDefault(_repeatOne);
	
	var _repeat = __webpack_require__(1160);
	
	var _repeat2 = _interopRequireDefault(_repeat);
	
	var _replay = __webpack_require__(1161);
	
	var _replay2 = _interopRequireDefault(_replay);
	
	var _replay3 = __webpack_require__(1162);
	
	var _replay4 = _interopRequireDefault(_replay3);
	
	var _replay5 = __webpack_require__(1163);
	
	var _replay6 = _interopRequireDefault(_replay5);
	
	var _replay7 = __webpack_require__(1164);
	
	var _replay8 = _interopRequireDefault(_replay7);
	
	var _shuffle = __webpack_require__(1165);
	
	var _shuffle2 = _interopRequireDefault(_shuffle);
	
	var _skipNext = __webpack_require__(1166);
	
	var _skipNext2 = _interopRequireDefault(_skipNext);
	
	var _skipPrevious = __webpack_require__(1167);
	
	var _skipPrevious2 = _interopRequireDefault(_skipPrevious);
	
	var _slowMotionVideo = __webpack_require__(1168);
	
	var _slowMotionVideo2 = _interopRequireDefault(_slowMotionVideo);
	
	var _snooze = __webpack_require__(1169);
	
	var _snooze2 = _interopRequireDefault(_snooze);
	
	var _sortByAlpha = __webpack_require__(1170);
	
	var _sortByAlpha2 = _interopRequireDefault(_sortByAlpha);
	
	var _stop = __webpack_require__(1171);
	
	var _stop2 = _interopRequireDefault(_stop);
	
	var _subscriptions = __webpack_require__(1172);
	
	var _subscriptions2 = _interopRequireDefault(_subscriptions);
	
	var _subtitles = __webpack_require__(1173);
	
	var _subtitles2 = _interopRequireDefault(_subtitles);
	
	var _surroundSound = __webpack_require__(1174);
	
	var _surroundSound2 = _interopRequireDefault(_surroundSound);
	
	var _videoCall = __webpack_require__(1175);
	
	var _videoCall2 = _interopRequireDefault(_videoCall);
	
	var _videoLabel = __webpack_require__(1176);
	
	var _videoLabel2 = _interopRequireDefault(_videoLabel);
	
	var _videoLibrary = __webpack_require__(1177);
	
	var _videoLibrary2 = _interopRequireDefault(_videoLibrary);
	
	var _videocamOff = __webpack_require__(1178);
	
	var _videocamOff2 = _interopRequireDefault(_videocamOff);
	
	var _videocam = __webpack_require__(1179);
	
	var _videocam2 = _interopRequireDefault(_videocam);
	
	var _volumeDown = __webpack_require__(1180);
	
	var _volumeDown2 = _interopRequireDefault(_volumeDown);
	
	var _volumeMute = __webpack_require__(1181);
	
	var _volumeMute2 = _interopRequireDefault(_volumeMute);
	
	var _volumeOff = __webpack_require__(1182);
	
	var _volumeOff2 = _interopRequireDefault(_volumeOff);
	
	var _volumeUp = __webpack_require__(1183);
	
	var _volumeUp2 = _interopRequireDefault(_volumeUp);
	
	var _webAsset = __webpack_require__(1184);
	
	var _webAsset2 = _interopRequireDefault(_webAsset);
	
	var _web = __webpack_require__(1185);
	
	var _web2 = _interopRequireDefault(_web);
	
	var _business = __webpack_require__(1186);
	
	var _business2 = _interopRequireDefault(_business);
	
	var _callEnd = __webpack_require__(1187);
	
	var _callEnd2 = _interopRequireDefault(_callEnd);
	
	var _callMade = __webpack_require__(1188);
	
	var _callMade2 = _interopRequireDefault(_callMade);
	
	var _callMerge = __webpack_require__(1189);
	
	var _callMerge2 = _interopRequireDefault(_callMerge);
	
	var _callMissedOutgoing = __webpack_require__(1190);
	
	var _callMissedOutgoing2 = _interopRequireDefault(_callMissedOutgoing);
	
	var _callMissed = __webpack_require__(1191);
	
	var _callMissed2 = _interopRequireDefault(_callMissed);
	
	var _callReceived = __webpack_require__(1192);
	
	var _callReceived2 = _interopRequireDefault(_callReceived);
	
	var _callSplit = __webpack_require__(1193);
	
	var _callSplit2 = _interopRequireDefault(_callSplit);
	
	var _call = __webpack_require__(1194);
	
	var _call2 = _interopRequireDefault(_call);
	
	var _chatBubbleOutline = __webpack_require__(1195);
	
	var _chatBubbleOutline2 = _interopRequireDefault(_chatBubbleOutline);
	
	var _chatBubble = __webpack_require__(1196);
	
	var _chatBubble2 = _interopRequireDefault(_chatBubble);
	
	var _chat = __webpack_require__(1197);
	
	var _chat2 = _interopRequireDefault(_chat);
	
	var _clearAll = __webpack_require__(1198);
	
	var _clearAll2 = _interopRequireDefault(_clearAll);
	
	var _comment = __webpack_require__(1199);
	
	var _comment2 = _interopRequireDefault(_comment);
	
	var _contactMail = __webpack_require__(1200);
	
	var _contactMail2 = _interopRequireDefault(_contactMail);
	
	var _contactPhone = __webpack_require__(1201);
	
	var _contactPhone2 = _interopRequireDefault(_contactPhone);
	
	var _contacts = __webpack_require__(1202);
	
	var _contacts2 = _interopRequireDefault(_contacts);
	
	var _dialerSip = __webpack_require__(1203);
	
	var _dialerSip2 = _interopRequireDefault(_dialerSip);
	
	var _dialpad = __webpack_require__(1204);
	
	var _dialpad2 = _interopRequireDefault(_dialpad);
	
	var _email = __webpack_require__(1205);
	
	var _email2 = _interopRequireDefault(_email);
	
	var _forum = __webpack_require__(1206);
	
	var _forum2 = _interopRequireDefault(_forum);
	
	var _importContacts = __webpack_require__(1207);
	
	var _importContacts2 = _interopRequireDefault(_importContacts);
	
	var _importExport = __webpack_require__(1208);
	
	var _importExport2 = _interopRequireDefault(_importExport);
	
	var _invertColorsOff = __webpack_require__(1209);
	
	var _invertColorsOff2 = _interopRequireDefault(_invertColorsOff);
	
	var _liveHelp = __webpack_require__(1210);
	
	var _liveHelp2 = _interopRequireDefault(_liveHelp);
	
	var _locationOff = __webpack_require__(1211);
	
	var _locationOff2 = _interopRequireDefault(_locationOff);
	
	var _locationOn = __webpack_require__(1212);
	
	var _locationOn2 = _interopRequireDefault(_locationOn);
	
	var _mailOutline = __webpack_require__(1213);
	
	var _mailOutline2 = _interopRequireDefault(_mailOutline);
	
	var _message = __webpack_require__(1214);
	
	var _message2 = _interopRequireDefault(_message);
	
	var _noSim = __webpack_require__(1215);
	
	var _noSim2 = _interopRequireDefault(_noSim);
	
	var _phone = __webpack_require__(1216);
	
	var _phone2 = _interopRequireDefault(_phone);
	
	var _phonelinkErase = __webpack_require__(1217);
	
	var _phonelinkErase2 = _interopRequireDefault(_phonelinkErase);
	
	var _phonelinkLock = __webpack_require__(1218);
	
	var _phonelinkLock2 = _interopRequireDefault(_phonelinkLock);
	
	var _phonelinkRing = __webpack_require__(1219);
	
	var _phonelinkRing2 = _interopRequireDefault(_phonelinkRing);
	
	var _phonelinkSetup = __webpack_require__(1220);
	
	var _phonelinkSetup2 = _interopRequireDefault(_phonelinkSetup);
	
	var _portableWifiOff = __webpack_require__(1221);
	
	var _portableWifiOff2 = _interopRequireDefault(_portableWifiOff);
	
	var _presentToAll = __webpack_require__(1222);
	
	var _presentToAll2 = _interopRequireDefault(_presentToAll);
	
	var _ringVolume = __webpack_require__(1223);
	
	var _ringVolume2 = _interopRequireDefault(_ringVolume);
	
	var _rssFeed = __webpack_require__(1224);
	
	var _rssFeed2 = _interopRequireDefault(_rssFeed);
	
	var _screenShare = __webpack_require__(1225);
	
	var _screenShare2 = _interopRequireDefault(_screenShare);
	
	var _speakerPhone = __webpack_require__(1226);
	
	var _speakerPhone2 = _interopRequireDefault(_speakerPhone);
	
	var _stayCurrentLandscape = __webpack_require__(1227);
	
	var _stayCurrentLandscape2 = _interopRequireDefault(_stayCurrentLandscape);
	
	var _stayCurrentPortrait = __webpack_require__(1228);
	
	var _stayCurrentPortrait2 = _interopRequireDefault(_stayCurrentPortrait);
	
	var _stayPrimaryLandscape = __webpack_require__(1229);
	
	var _stayPrimaryLandscape2 = _interopRequireDefault(_stayPrimaryLandscape);
	
	var _stayPrimaryPortrait = __webpack_require__(1230);
	
	var _stayPrimaryPortrait2 = _interopRequireDefault(_stayPrimaryPortrait);
	
	var _stopScreenShare = __webpack_require__(1231);
	
	var _stopScreenShare2 = _interopRequireDefault(_stopScreenShare);
	
	var _swapCalls = __webpack_require__(1232);
	
	var _swapCalls2 = _interopRequireDefault(_swapCalls);
	
	var _textsms = __webpack_require__(1233);
	
	var _textsms2 = _interopRequireDefault(_textsms);
	
	var _voicemail = __webpack_require__(1234);
	
	var _voicemail2 = _interopRequireDefault(_voicemail);
	
	var _vpnKey = __webpack_require__(1235);
	
	var _vpnKey2 = _interopRequireDefault(_vpnKey);
	
	var _addBox = __webpack_require__(1236);
	
	var _addBox2 = _interopRequireDefault(_addBox);
	
	var _addCircleOutline = __webpack_require__(1237);
	
	var _addCircleOutline2 = _interopRequireDefault(_addCircleOutline);
	
	var _addCircle = __webpack_require__(1238);
	
	var _addCircle2 = _interopRequireDefault(_addCircle);
	
	var _add = __webpack_require__(1239);
	
	var _add2 = _interopRequireDefault(_add);
	
	var _archive = __webpack_require__(1240);
	
	var _archive2 = _interopRequireDefault(_archive);
	
	var _backspace = __webpack_require__(1241);
	
	var _backspace2 = _interopRequireDefault(_backspace);
	
	var _block = __webpack_require__(1242);
	
	var _block2 = _interopRequireDefault(_block);
	
	var _clear = __webpack_require__(1243);
	
	var _clear2 = _interopRequireDefault(_clear);
	
	var _contentCopy = __webpack_require__(1244);
	
	var _contentCopy2 = _interopRequireDefault(_contentCopy);
	
	var _contentCut = __webpack_require__(1245);
	
	var _contentCut2 = _interopRequireDefault(_contentCut);
	
	var _contentPaste = __webpack_require__(1246);
	
	var _contentPaste2 = _interopRequireDefault(_contentPaste);
	
	var _create = __webpack_require__(1247);
	
	var _create2 = _interopRequireDefault(_create);
	
	var _deleteSweep = __webpack_require__(1248);
	
	var _deleteSweep2 = _interopRequireDefault(_deleteSweep);
	
	var _drafts = __webpack_require__(1249);
	
	var _drafts2 = _interopRequireDefault(_drafts);
	
	var _filterList = __webpack_require__(1250);
	
	var _filterList2 = _interopRequireDefault(_filterList);
	
	var _flag = __webpack_require__(1251);
	
	var _flag2 = _interopRequireDefault(_flag);
	
	var _fontDownload = __webpack_require__(1252);
	
	var _fontDownload2 = _interopRequireDefault(_fontDownload);
	
	var _forward7 = __webpack_require__(1253);
	
	var _forward8 = _interopRequireDefault(_forward7);
	
	var _gesture = __webpack_require__(1254);
	
	var _gesture2 = _interopRequireDefault(_gesture);
	
	var _inbox = __webpack_require__(1255);
	
	var _inbox2 = _interopRequireDefault(_inbox);
	
	var _link = __webpack_require__(1256);
	
	var _link2 = _interopRequireDefault(_link);
	
	var _lowPriority = __webpack_require__(1257);
	
	var _lowPriority2 = _interopRequireDefault(_lowPriority);
	
	var _mail = __webpack_require__(1258);
	
	var _mail2 = _interopRequireDefault(_mail);
	
	var _markunread = __webpack_require__(1259);
	
	var _markunread2 = _interopRequireDefault(_markunread);
	
	var _moveToInbox = __webpack_require__(1260);
	
	var _moveToInbox2 = _interopRequireDefault(_moveToInbox);
	
	var _nextWeek = __webpack_require__(1261);
	
	var _nextWeek2 = _interopRequireDefault(_nextWeek);
	
	var _redo = __webpack_require__(1262);
	
	var _redo2 = _interopRequireDefault(_redo);
	
	var _removeCircleOutline = __webpack_require__(1263);
	
	var _removeCircleOutline2 = _interopRequireDefault(_removeCircleOutline);
	
	var _removeCircle = __webpack_require__(1264);
	
	var _removeCircle2 = _interopRequireDefault(_removeCircle);
	
	var _remove = __webpack_require__(1265);
	
	var _remove2 = _interopRequireDefault(_remove);
	
	var _replyAll = __webpack_require__(1266);
	
	var _replyAll2 = _interopRequireDefault(_replyAll);
	
	var _reply = __webpack_require__(1267);
	
	var _reply2 = _interopRequireDefault(_reply);
	
	var _report = __webpack_require__(1268);
	
	var _report2 = _interopRequireDefault(_report);
	
	var _save = __webpack_require__(1269);
	
	var _save2 = _interopRequireDefault(_save);
	
	var _selectAll = __webpack_require__(1270);
	
	var _selectAll2 = _interopRequireDefault(_selectAll);
	
	var _send = __webpack_require__(1271);
	
	var _send2 = _interopRequireDefault(_send);
	
	var _sort = __webpack_require__(1272);
	
	var _sort2 = _interopRequireDefault(_sort);
	
	var _textFormat = __webpack_require__(1273);
	
	var _textFormat2 = _interopRequireDefault(_textFormat);
	
	var _unarchive = __webpack_require__(1274);
	
	var _unarchive2 = _interopRequireDefault(_unarchive);
	
	var _undo = __webpack_require__(1275);
	
	var _undo2 = _interopRequireDefault(_undo);
	
	var _weekend = __webpack_require__(1276);
	
	var _weekend2 = _interopRequireDefault(_weekend);
	
	var _accessAlarm = __webpack_require__(1277);
	
	var _accessAlarm2 = _interopRequireDefault(_accessAlarm);
	
	var _accessAlarms = __webpack_require__(1278);
	
	var _accessAlarms2 = _interopRequireDefault(_accessAlarms);
	
	var _accessTime = __webpack_require__(1279);
	
	var _accessTime2 = _interopRequireDefault(_accessTime);
	
	var _addAlarm = __webpack_require__(1280);
	
	var _addAlarm2 = _interopRequireDefault(_addAlarm);
	
	var _airplanemodeActive = __webpack_require__(1281);
	
	var _airplanemodeActive2 = _interopRequireDefault(_airplanemodeActive);
	
	var _airplanemodeInactive = __webpack_require__(1282);
	
	var _airplanemodeInactive2 = _interopRequireDefault(_airplanemodeInactive);
	
	var _battery = __webpack_require__(1283);
	
	var _battery2 = _interopRequireDefault(_battery);
	
	var _battery3 = __webpack_require__(1284);
	
	var _battery4 = _interopRequireDefault(_battery3);
	
	var _battery5 = __webpack_require__(1285);
	
	var _battery6 = _interopRequireDefault(_battery5);
	
	var _battery7 = __webpack_require__(1286);
	
	var _battery8 = _interopRequireDefault(_battery7);
	
	var _battery9 = __webpack_require__(1287);
	
	var _battery10 = _interopRequireDefault(_battery9);
	
	var _battery11 = __webpack_require__(1288);
	
	var _battery12 = _interopRequireDefault(_battery11);
	
	var _batteryAlert = __webpack_require__(1289);
	
	var _batteryAlert2 = _interopRequireDefault(_batteryAlert);
	
	var _batteryCharging = __webpack_require__(1290);
	
	var _batteryCharging2 = _interopRequireDefault(_batteryCharging);
	
	var _batteryCharging3 = __webpack_require__(1291);
	
	var _batteryCharging4 = _interopRequireDefault(_batteryCharging3);
	
	var _batteryCharging5 = __webpack_require__(1292);
	
	var _batteryCharging6 = _interopRequireDefault(_batteryCharging5);
	
	var _batteryCharging7 = __webpack_require__(1293);
	
	var _batteryCharging8 = _interopRequireDefault(_batteryCharging7);
	
	var _batteryCharging9 = __webpack_require__(1294);
	
	var _batteryCharging10 = _interopRequireDefault(_batteryCharging9);
	
	var _batteryCharging11 = __webpack_require__(1295);
	
	var _batteryCharging12 = _interopRequireDefault(_batteryCharging11);
	
	var _batteryChargingFull = __webpack_require__(1296);
	
	var _batteryChargingFull2 = _interopRequireDefault(_batteryChargingFull);
	
	var _batteryFull = __webpack_require__(1297);
	
	var _batteryFull2 = _interopRequireDefault(_batteryFull);
	
	var _batteryStd = __webpack_require__(1298);
	
	var _batteryStd2 = _interopRequireDefault(_batteryStd);
	
	var _batteryUnknown = __webpack_require__(1299);
	
	var _batteryUnknown2 = _interopRequireDefault(_batteryUnknown);
	
	var _bluetoothConnected = __webpack_require__(1300);
	
	var _bluetoothConnected2 = _interopRequireDefault(_bluetoothConnected);
	
	var _bluetoothDisabled = __webpack_require__(1301);
	
	var _bluetoothDisabled2 = _interopRequireDefault(_bluetoothDisabled);
	
	var _bluetoothSearching = __webpack_require__(1302);
	
	var _bluetoothSearching2 = _interopRequireDefault(_bluetoothSearching);
	
	var _bluetooth = __webpack_require__(1303);
	
	var _bluetooth2 = _interopRequireDefault(_bluetooth);
	
	var _brightnessAuto = __webpack_require__(1304);
	
	var _brightnessAuto2 = _interopRequireDefault(_brightnessAuto);
	
	var _brightnessHigh = __webpack_require__(1305);
	
	var _brightnessHigh2 = _interopRequireDefault(_brightnessHigh);
	
	var _brightnessLow = __webpack_require__(1306);
	
	var _brightnessLow2 = _interopRequireDefault(_brightnessLow);
	
	var _brightnessMedium = __webpack_require__(1307);
	
	var _brightnessMedium2 = _interopRequireDefault(_brightnessMedium);
	
	var _dataUsage = __webpack_require__(1308);
	
	var _dataUsage2 = _interopRequireDefault(_dataUsage);
	
	var _developerMode = __webpack_require__(1309);
	
	var _developerMode2 = _interopRequireDefault(_developerMode);
	
	var _devices = __webpack_require__(1310);
	
	var _devices2 = _interopRequireDefault(_devices);
	
	var _dvr = __webpack_require__(1311);
	
	var _dvr2 = _interopRequireDefault(_dvr);
	
	var _gpsFixed = __webpack_require__(1312);
	
	var _gpsFixed2 = _interopRequireDefault(_gpsFixed);
	
	var _gpsNotFixed = __webpack_require__(1313);
	
	var _gpsNotFixed2 = _interopRequireDefault(_gpsNotFixed);
	
	var _gpsOff = __webpack_require__(1314);
	
	var _gpsOff2 = _interopRequireDefault(_gpsOff);
	
	var _graphicEq = __webpack_require__(1315);
	
	var _graphicEq2 = _interopRequireDefault(_graphicEq);
	
	var _locationDisabled = __webpack_require__(1316);
	
	var _locationDisabled2 = _interopRequireDefault(_locationDisabled);
	
	var _locationSearching = __webpack_require__(1317);
	
	var _locationSearching2 = _interopRequireDefault(_locationSearching);
	
	var _networkCell = __webpack_require__(1318);
	
	var _networkCell2 = _interopRequireDefault(_networkCell);
	
	var _networkWifi = __webpack_require__(1319);
	
	var _networkWifi2 = _interopRequireDefault(_networkWifi);
	
	var _nfc = __webpack_require__(1320);
	
	var _nfc2 = _interopRequireDefault(_nfc);
	
	var _screenLockLandscape = __webpack_require__(1321);
	
	var _screenLockLandscape2 = _interopRequireDefault(_screenLockLandscape);
	
	var _screenLockPortrait = __webpack_require__(1322);
	
	var _screenLockPortrait2 = _interopRequireDefault(_screenLockPortrait);
	
	var _screenLockRotation = __webpack_require__(1323);
	
	var _screenLockRotation2 = _interopRequireDefault(_screenLockRotation);
	
	var _screenRotation = __webpack_require__(1324);
	
	var _screenRotation2 = _interopRequireDefault(_screenRotation);
	
	var _sdStorage = __webpack_require__(1325);
	
	var _sdStorage2 = _interopRequireDefault(_sdStorage);
	
	var _settingsSystemDaydream = __webpack_require__(1326);
	
	var _settingsSystemDaydream2 = _interopRequireDefault(_settingsSystemDaydream);
	
	var _signalCellular0Bar = __webpack_require__(1327);
	
	var _signalCellular0Bar2 = _interopRequireDefault(_signalCellular0Bar);
	
	var _signalCellular1Bar = __webpack_require__(1328);
	
	var _signalCellular1Bar2 = _interopRequireDefault(_signalCellular1Bar);
	
	var _signalCellular2Bar = __webpack_require__(1329);
	
	var _signalCellular2Bar2 = _interopRequireDefault(_signalCellular2Bar);
	
	var _signalCellular3Bar = __webpack_require__(1330);
	
	var _signalCellular3Bar2 = _interopRequireDefault(_signalCellular3Bar);
	
	var _signalCellular4Bar = __webpack_require__(1331);
	
	var _signalCellular4Bar2 = _interopRequireDefault(_signalCellular4Bar);
	
	var _signalCellularConnectedNoInternet0Bar = __webpack_require__(1332);
	
	var _signalCellularConnectedNoInternet0Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet0Bar);
	
	var _signalCellularConnectedNoInternet1Bar = __webpack_require__(1333);
	
	var _signalCellularConnectedNoInternet1Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet1Bar);
	
	var _signalCellularConnectedNoInternet2Bar = __webpack_require__(1334);
	
	var _signalCellularConnectedNoInternet2Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet2Bar);
	
	var _signalCellularConnectedNoInternet3Bar = __webpack_require__(1335);
	
	var _signalCellularConnectedNoInternet3Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet3Bar);
	
	var _signalCellularConnectedNoInternet4Bar = __webpack_require__(1336);
	
	var _signalCellularConnectedNoInternet4Bar2 = _interopRequireDefault(_signalCellularConnectedNoInternet4Bar);
	
	var _signalCellularNoSim = __webpack_require__(1337);
	
	var _signalCellularNoSim2 = _interopRequireDefault(_signalCellularNoSim);
	
	var _signalCellularNull = __webpack_require__(1338);
	
	var _signalCellularNull2 = _interopRequireDefault(_signalCellularNull);
	
	var _signalCellularOff = __webpack_require__(1339);
	
	var _signalCellularOff2 = _interopRequireDefault(_signalCellularOff);
	
	var _signalWifi0Bar = __webpack_require__(1340);
	
	var _signalWifi0Bar2 = _interopRequireDefault(_signalWifi0Bar);
	
	var _signalWifi1BarLock = __webpack_require__(1341);
	
	var _signalWifi1BarLock2 = _interopRequireDefault(_signalWifi1BarLock);
	
	var _signalWifi1Bar = __webpack_require__(1342);
	
	var _signalWifi1Bar2 = _interopRequireDefault(_signalWifi1Bar);
	
	var _signalWifi2BarLock = __webpack_require__(1343);
	
	var _signalWifi2BarLock2 = _interopRequireDefault(_signalWifi2BarLock);
	
	var _signalWifi2Bar = __webpack_require__(1344);
	
	var _signalWifi2Bar2 = _interopRequireDefault(_signalWifi2Bar);
	
	var _signalWifi3BarLock = __webpack_require__(1345);
	
	var _signalWifi3BarLock2 = _interopRequireDefault(_signalWifi3BarLock);
	
	var _signalWifi3Bar = __webpack_require__(1346);
	
	var _signalWifi3Bar2 = _interopRequireDefault(_signalWifi3Bar);
	
	var _signalWifi4BarLock = __webpack_require__(1347);
	
	var _signalWifi4BarLock2 = _interopRequireDefault(_signalWifi4BarLock);
	
	var _signalWifi4Bar = __webpack_require__(1348);
	
	var _signalWifi4Bar2 = _interopRequireDefault(_signalWifi4Bar);
	
	var _signalWifiOff = __webpack_require__(1349);
	
	var _signalWifiOff2 = _interopRequireDefault(_signalWifiOff);
	
	var _storage = __webpack_require__(1350);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	var _usb = __webpack_require__(1351);
	
	var _usb2 = _interopRequireDefault(_usb);
	
	var _wallpaper = __webpack_require__(1352);
	
	var _wallpaper2 = _interopRequireDefault(_wallpaper);
	
	var _widgets = __webpack_require__(1353);
	
	var _widgets2 = _interopRequireDefault(_widgets);
	
	var _wifiLock = __webpack_require__(1354);
	
	var _wifiLock2 = _interopRequireDefault(_wifiLock);
	
	var _wifiTethering = __webpack_require__(1355);
	
	var _wifiTethering2 = _interopRequireDefault(_wifiTethering);
	
	var _attachFile = __webpack_require__(1356);
	
	var _attachFile2 = _interopRequireDefault(_attachFile);
	
	var _attachMoney = __webpack_require__(1357);
	
	var _attachMoney2 = _interopRequireDefault(_attachMoney);
	
	var _borderAll = __webpack_require__(1358);
	
	var _borderAll2 = _interopRequireDefault(_borderAll);
	
	var _borderBottom = __webpack_require__(1359);
	
	var _borderBottom2 = _interopRequireDefault(_borderBottom);
	
	var _borderClear = __webpack_require__(1360);
	
	var _borderClear2 = _interopRequireDefault(_borderClear);
	
	var _borderColor = __webpack_require__(1361);
	
	var _borderColor2 = _interopRequireDefault(_borderColor);
	
	var _borderHorizontal = __webpack_require__(1362);
	
	var _borderHorizontal2 = _interopRequireDefault(_borderHorizontal);
	
	var _borderInner = __webpack_require__(1363);
	
	var _borderInner2 = _interopRequireDefault(_borderInner);
	
	var _borderLeft = __webpack_require__(1364);
	
	var _borderLeft2 = _interopRequireDefault(_borderLeft);
	
	var _borderOuter = __webpack_require__(1365);
	
	var _borderOuter2 = _interopRequireDefault(_borderOuter);
	
	var _borderRight = __webpack_require__(1366);
	
	var _borderRight2 = _interopRequireDefault(_borderRight);
	
	var _borderStyle = __webpack_require__(1367);
	
	var _borderStyle2 = _interopRequireDefault(_borderStyle);
	
	var _borderTop = __webpack_require__(1368);
	
	var _borderTop2 = _interopRequireDefault(_borderTop);
	
	var _borderVertical = __webpack_require__(1369);
	
	var _borderVertical2 = _interopRequireDefault(_borderVertical);
	
	var _bubbleChart = __webpack_require__(1370);
	
	var _bubbleChart2 = _interopRequireDefault(_bubbleChart);
	
	var _dragHandle = __webpack_require__(1371);
	
	var _dragHandle2 = _interopRequireDefault(_dragHandle);
	
	var _formatAlignCenter = __webpack_require__(1372);
	
	var _formatAlignCenter2 = _interopRequireDefault(_formatAlignCenter);
	
	var _formatAlignJustify = __webpack_require__(1373);
	
	var _formatAlignJustify2 = _interopRequireDefault(_formatAlignJustify);
	
	var _formatAlignLeft = __webpack_require__(1374);
	
	var _formatAlignLeft2 = _interopRequireDefault(_formatAlignLeft);
	
	var _formatAlignRight = __webpack_require__(1375);
	
	var _formatAlignRight2 = _interopRequireDefault(_formatAlignRight);
	
	var _formatBold = __webpack_require__(1376);
	
	var _formatBold2 = _interopRequireDefault(_formatBold);
	
	var _formatClear = __webpack_require__(1377);
	
	var _formatClear2 = _interopRequireDefault(_formatClear);
	
	var _formatColorFill = __webpack_require__(1378);
	
	var _formatColorFill2 = _interopRequireDefault(_formatColorFill);
	
	var _formatColorReset = __webpack_require__(1379);
	
	var _formatColorReset2 = _interopRequireDefault(_formatColorReset);
	
	var _formatColorText = __webpack_require__(1380);
	
	var _formatColorText2 = _interopRequireDefault(_formatColorText);
	
	var _formatIndentDecrease = __webpack_require__(1381);
	
	var _formatIndentDecrease2 = _interopRequireDefault(_formatIndentDecrease);
	
	var _formatIndentIncrease = __webpack_require__(1382);
	
	var _formatIndentIncrease2 = _interopRequireDefault(_formatIndentIncrease);
	
	var _formatItalic = __webpack_require__(1383);
	
	var _formatItalic2 = _interopRequireDefault(_formatItalic);
	
	var _formatLineSpacing = __webpack_require__(1384);
	
	var _formatLineSpacing2 = _interopRequireDefault(_formatLineSpacing);
	
	var _formatListBulleted = __webpack_require__(1385);
	
	var _formatListBulleted2 = _interopRequireDefault(_formatListBulleted);
	
	var _formatListNumbered = __webpack_require__(1386);
	
	var _formatListNumbered2 = _interopRequireDefault(_formatListNumbered);
	
	var _formatPaint = __webpack_require__(1387);
	
	var _formatPaint2 = _interopRequireDefault(_formatPaint);
	
	var _formatQuote = __webpack_require__(1388);
	
	var _formatQuote2 = _interopRequireDefault(_formatQuote);
	
	var _formatShapes = __webpack_require__(1389);
	
	var _formatShapes2 = _interopRequireDefault(_formatShapes);
	
	var _formatSize = __webpack_require__(1390);
	
	var _formatSize2 = _interopRequireDefault(_formatSize);
	
	var _formatStrikethrough = __webpack_require__(1391);
	
	var _formatStrikethrough2 = _interopRequireDefault(_formatStrikethrough);
	
	var _formatTextdirectionLToR = __webpack_require__(1392);
	
	var _formatTextdirectionLToR2 = _interopRequireDefault(_formatTextdirectionLToR);
	
	var _formatTextdirectionRToL = __webpack_require__(1393);
	
	var _formatTextdirectionRToL2 = _interopRequireDefault(_formatTextdirectionRToL);
	
	var _formatUnderlined = __webpack_require__(1394);
	
	var _formatUnderlined2 = _interopRequireDefault(_formatUnderlined);
	
	var _functions = __webpack_require__(1395);
	
	var _functions2 = _interopRequireDefault(_functions);
	
	var _highlight = __webpack_require__(1396);
	
	var _highlight2 = _interopRequireDefault(_highlight);
	
	var _insertChart = __webpack_require__(1397);
	
	var _insertChart2 = _interopRequireDefault(_insertChart);
	
	var _insertComment = __webpack_require__(1398);
	
	var _insertComment2 = _interopRequireDefault(_insertComment);
	
	var _insertDriveFile = __webpack_require__(1399);
	
	var _insertDriveFile2 = _interopRequireDefault(_insertDriveFile);
	
	var _insertEmoticon = __webpack_require__(1400);
	
	var _insertEmoticon2 = _interopRequireDefault(_insertEmoticon);
	
	var _insertInvitation = __webpack_require__(1401);
	
	var _insertInvitation2 = _interopRequireDefault(_insertInvitation);
	
	var _insertLink = __webpack_require__(1402);
	
	var _insertLink2 = _interopRequireDefault(_insertLink);
	
	var _insertPhoto = __webpack_require__(1403);
	
	var _insertPhoto2 = _interopRequireDefault(_insertPhoto);
	
	var _linearScale = __webpack_require__(1404);
	
	var _linearScale2 = _interopRequireDefault(_linearScale);
	
	var _mergeType = __webpack_require__(1405);
	
	var _mergeType2 = _interopRequireDefault(_mergeType);
	
	var _modeComment = __webpack_require__(1406);
	
	var _modeComment2 = _interopRequireDefault(_modeComment);
	
	var _modeEdit = __webpack_require__(1407);
	
	var _modeEdit2 = _interopRequireDefault(_modeEdit);
	
	var _monetizationOn = __webpack_require__(1408);
	
	var _monetizationOn2 = _interopRequireDefault(_monetizationOn);
	
	var _moneyOff = __webpack_require__(1409);
	
	var _moneyOff2 = _interopRequireDefault(_moneyOff);
	
	var _multilineChart = __webpack_require__(1410);
	
	var _multilineChart2 = _interopRequireDefault(_multilineChart);
	
	var _pieChartOutlined = __webpack_require__(1411);
	
	var _pieChartOutlined2 = _interopRequireDefault(_pieChartOutlined);
	
	var _pieChart = __webpack_require__(1412);
	
	var _pieChart2 = _interopRequireDefault(_pieChart);
	
	var _publish = __webpack_require__(1413);
	
	var _publish2 = _interopRequireDefault(_publish);
	
	var _shortText = __webpack_require__(1414);
	
	var _shortText2 = _interopRequireDefault(_shortText);
	
	var _showChart = __webpack_require__(1415);
	
	var _showChart2 = _interopRequireDefault(_showChart);
	
	var _spaceBar = __webpack_require__(1416);
	
	var _spaceBar2 = _interopRequireDefault(_spaceBar);
	
	var _strikethroughS = __webpack_require__(1417);
	
	var _strikethroughS2 = _interopRequireDefault(_strikethroughS);
	
	var _textFields = __webpack_require__(1418);
	
	var _textFields2 = _interopRequireDefault(_textFields);
	
	var _title = __webpack_require__(1419);
	
	var _title2 = _interopRequireDefault(_title);
	
	var _verticalAlignBottom = __webpack_require__(1420);
	
	var _verticalAlignBottom2 = _interopRequireDefault(_verticalAlignBottom);
	
	var _verticalAlignCenter = __webpack_require__(1421);
	
	var _verticalAlignCenter2 = _interopRequireDefault(_verticalAlignCenter);
	
	var _verticalAlignTop = __webpack_require__(1422);
	
	var _verticalAlignTop2 = _interopRequireDefault(_verticalAlignTop);
	
	var _wrapText = __webpack_require__(1423);
	
	var _wrapText2 = _interopRequireDefault(_wrapText);
	
	var _attachment = __webpack_require__(1424);
	
	var _attachment2 = _interopRequireDefault(_attachment);
	
	var _cloudCircle = __webpack_require__(1425);
	
	var _cloudCircle2 = _interopRequireDefault(_cloudCircle);
	
	var _cloudDone = __webpack_require__(1426);
	
	var _cloudDone2 = _interopRequireDefault(_cloudDone);
	
	var _cloudDownload = __webpack_require__(1427);
	
	var _cloudDownload2 = _interopRequireDefault(_cloudDownload);
	
	var _cloudOff = __webpack_require__(1428);
	
	var _cloudOff2 = _interopRequireDefault(_cloudOff);
	
	var _cloudQueue = __webpack_require__(1429);
	
	var _cloudQueue2 = _interopRequireDefault(_cloudQueue);
	
	var _cloudUpload = __webpack_require__(1430);
	
	var _cloudUpload2 = _interopRequireDefault(_cloudUpload);
	
	var _cloud = __webpack_require__(1431);
	
	var _cloud2 = _interopRequireDefault(_cloud);
	
	var _createNewFolder = __webpack_require__(1432);
	
	var _createNewFolder2 = _interopRequireDefault(_createNewFolder);
	
	var _fileDownload = __webpack_require__(1433);
	
	var _fileDownload2 = _interopRequireDefault(_fileDownload);
	
	var _fileUpload = __webpack_require__(1434);
	
	var _fileUpload2 = _interopRequireDefault(_fileUpload);
	
	var _folderOpen = __webpack_require__(1435);
	
	var _folderOpen2 = _interopRequireDefault(_folderOpen);
	
	var _folderShared = __webpack_require__(1436);
	
	var _folderShared2 = _interopRequireDefault(_folderShared);
	
	var _folder = __webpack_require__(1437);
	
	var _folder2 = _interopRequireDefault(_folder);
	
	var _castConnected = __webpack_require__(1438);
	
	var _castConnected2 = _interopRequireDefault(_castConnected);
	
	var _cast = __webpack_require__(1439);
	
	var _cast2 = _interopRequireDefault(_cast);
	
	var _computer = __webpack_require__(1440);
	
	var _computer2 = _interopRequireDefault(_computer);
	
	var _desktopMac = __webpack_require__(1441);
	
	var _desktopMac2 = _interopRequireDefault(_desktopMac);
	
	var _desktopWindows = __webpack_require__(1442);
	
	var _desktopWindows2 = _interopRequireDefault(_desktopWindows);
	
	var _developerBoard = __webpack_require__(1443);
	
	var _developerBoard2 = _interopRequireDefault(_developerBoard);
	
	var _deviceHub = __webpack_require__(1444);
	
	var _deviceHub2 = _interopRequireDefault(_deviceHub);
	
	var _devicesOther = __webpack_require__(1445);
	
	var _devicesOther2 = _interopRequireDefault(_devicesOther);
	
	var _dock = __webpack_require__(1446);
	
	var _dock2 = _interopRequireDefault(_dock);
	
	var _gamepad = __webpack_require__(1447);
	
	var _gamepad2 = _interopRequireDefault(_gamepad);
	
	var _headsetMic = __webpack_require__(1448);
	
	var _headsetMic2 = _interopRequireDefault(_headsetMic);
	
	var _headset = __webpack_require__(1449);
	
	var _headset2 = _interopRequireDefault(_headset);
	
	var _keyboardArrowDown = __webpack_require__(376);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _keyboardArrowLeft = __webpack_require__(1450);
	
	var _keyboardArrowLeft2 = _interopRequireDefault(_keyboardArrowLeft);
	
	var _keyboardArrowRight = __webpack_require__(1451);
	
	var _keyboardArrowRight2 = _interopRequireDefault(_keyboardArrowRight);
	
	var _keyboardArrowUp = __webpack_require__(377);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardBackspace = __webpack_require__(1452);
	
	var _keyboardBackspace2 = _interopRequireDefault(_keyboardBackspace);
	
	var _keyboardCapslock = __webpack_require__(1453);
	
	var _keyboardCapslock2 = _interopRequireDefault(_keyboardCapslock);
	
	var _keyboardHide = __webpack_require__(1454);
	
	var _keyboardHide2 = _interopRequireDefault(_keyboardHide);
	
	var _keyboardReturn = __webpack_require__(1455);
	
	var _keyboardReturn2 = _interopRequireDefault(_keyboardReturn);
	
	var _keyboardTab = __webpack_require__(1456);
	
	var _keyboardTab2 = _interopRequireDefault(_keyboardTab);
	
	var _keyboardVoice = __webpack_require__(1457);
	
	var _keyboardVoice2 = _interopRequireDefault(_keyboardVoice);
	
	var _keyboard = __webpack_require__(1458);
	
	var _keyboard2 = _interopRequireDefault(_keyboard);
	
	var _laptopChromebook = __webpack_require__(1459);
	
	var _laptopChromebook2 = _interopRequireDefault(_laptopChromebook);
	
	var _laptopMac = __webpack_require__(1460);
	
	var _laptopMac2 = _interopRequireDefault(_laptopMac);
	
	var _laptopWindows = __webpack_require__(1461);
	
	var _laptopWindows2 = _interopRequireDefault(_laptopWindows);
	
	var _laptop = __webpack_require__(1462);
	
	var _laptop2 = _interopRequireDefault(_laptop);
	
	var _memory = __webpack_require__(1463);
	
	var _memory2 = _interopRequireDefault(_memory);
	
	var _mouse = __webpack_require__(1464);
	
	var _mouse2 = _interopRequireDefault(_mouse);
	
	var _phoneAndroid = __webpack_require__(1465);
	
	var _phoneAndroid2 = _interopRequireDefault(_phoneAndroid);
	
	var _phoneIphone = __webpack_require__(1466);
	
	var _phoneIphone2 = _interopRequireDefault(_phoneIphone);
	
	var _phonelinkOff = __webpack_require__(1467);
	
	var _phonelinkOff2 = _interopRequireDefault(_phonelinkOff);
	
	var _phonelink = __webpack_require__(1468);
	
	var _phonelink2 = _interopRequireDefault(_phonelink);
	
	var _powerInput = __webpack_require__(1469);
	
	var _powerInput2 = _interopRequireDefault(_powerInput);
	
	var _router = __webpack_require__(1470);
	
	var _router2 = _interopRequireDefault(_router);
	
	var _scanner = __webpack_require__(1471);
	
	var _scanner2 = _interopRequireDefault(_scanner);
	
	var _security = __webpack_require__(1472);
	
	var _security2 = _interopRequireDefault(_security);
	
	var _simCard = __webpack_require__(1473);
	
	var _simCard2 = _interopRequireDefault(_simCard);
	
	var _smartphone = __webpack_require__(1474);
	
	var _smartphone2 = _interopRequireDefault(_smartphone);
	
	var _speakerGroup = __webpack_require__(1475);
	
	var _speakerGroup2 = _interopRequireDefault(_speakerGroup);
	
	var _speaker = __webpack_require__(1476);
	
	var _speaker2 = _interopRequireDefault(_speaker);
	
	var _tabletAndroid = __webpack_require__(1477);
	
	var _tabletAndroid2 = _interopRequireDefault(_tabletAndroid);
	
	var _tabletMac = __webpack_require__(1478);
	
	var _tabletMac2 = _interopRequireDefault(_tabletMac);
	
	var _tablet = __webpack_require__(1479);
	
	var _tablet2 = _interopRequireDefault(_tablet);
	
	var _toys = __webpack_require__(1480);
	
	var _toys2 = _interopRequireDefault(_toys);
	
	var _tv = __webpack_require__(1481);
	
	var _tv2 = _interopRequireDefault(_tv);
	
	var _videogameAsset = __webpack_require__(1482);
	
	var _videogameAsset2 = _interopRequireDefault(_videogameAsset);
	
	var _watch = __webpack_require__(1483);
	
	var _watch2 = _interopRequireDefault(_watch);
	
	var _addAPhoto = __webpack_require__(1484);
	
	var _addAPhoto2 = _interopRequireDefault(_addAPhoto);
	
	var _addToPhotos = __webpack_require__(1485);
	
	var _addToPhotos2 = _interopRequireDefault(_addToPhotos);
	
	var _adjust = __webpack_require__(1486);
	
	var _adjust2 = _interopRequireDefault(_adjust);
	
	var _assistantPhoto = __webpack_require__(1487);
	
	var _assistantPhoto2 = _interopRequireDefault(_assistantPhoto);
	
	var _assistant = __webpack_require__(1488);
	
	var _assistant2 = _interopRequireDefault(_assistant);
	
	var _audiotrack = __webpack_require__(1489);
	
	var _audiotrack2 = _interopRequireDefault(_audiotrack);
	
	var _blurCircular = __webpack_require__(1490);
	
	var _blurCircular2 = _interopRequireDefault(_blurCircular);
	
	var _blurLinear = __webpack_require__(1491);
	
	var _blurLinear2 = _interopRequireDefault(_blurLinear);
	
	var _blurOff = __webpack_require__(1492);
	
	var _blurOff2 = _interopRequireDefault(_blurOff);
	
	var _blurOn = __webpack_require__(1493);
	
	var _blurOn2 = _interopRequireDefault(_blurOn);
	
	var _brightness = __webpack_require__(1494);
	
	var _brightness2 = _interopRequireDefault(_brightness);
	
	var _brightness3 = __webpack_require__(1495);
	
	var _brightness4 = _interopRequireDefault(_brightness3);
	
	var _brightness5 = __webpack_require__(1496);
	
	var _brightness6 = _interopRequireDefault(_brightness5);
	
	var _brightness7 = __webpack_require__(1497);
	
	var _brightness8 = _interopRequireDefault(_brightness7);
	
	var _brightness9 = __webpack_require__(1498);
	
	var _brightness10 = _interopRequireDefault(_brightness9);
	
	var _brightness11 = __webpack_require__(1499);
	
	var _brightness12 = _interopRequireDefault(_brightness11);
	
	var _brightness13 = __webpack_require__(1500);
	
	var _brightness14 = _interopRequireDefault(_brightness13);
	
	var _brokenImage = __webpack_require__(1501);
	
	var _brokenImage2 = _interopRequireDefault(_brokenImage);
	
	var _brush = __webpack_require__(1502);
	
	var _brush2 = _interopRequireDefault(_brush);
	
	var _burstMode = __webpack_require__(1503);
	
	var _burstMode2 = _interopRequireDefault(_burstMode);
	
	var _cameraAlt = __webpack_require__(1504);
	
	var _cameraAlt2 = _interopRequireDefault(_cameraAlt);
	
	var _cameraFront = __webpack_require__(1505);
	
	var _cameraFront2 = _interopRequireDefault(_cameraFront);
	
	var _cameraRear = __webpack_require__(1506);
	
	var _cameraRear2 = _interopRequireDefault(_cameraRear);
	
	var _cameraRoll = __webpack_require__(1507);
	
	var _cameraRoll2 = _interopRequireDefault(_cameraRoll);
	
	var _camera = __webpack_require__(1508);
	
	var _camera2 = _interopRequireDefault(_camera);
	
	var _centerFocusStrong = __webpack_require__(1509);
	
	var _centerFocusStrong2 = _interopRequireDefault(_centerFocusStrong);
	
	var _centerFocusWeak = __webpack_require__(1510);
	
	var _centerFocusWeak2 = _interopRequireDefault(_centerFocusWeak);
	
	var _collectionsBookmark = __webpack_require__(1511);
	
	var _collectionsBookmark2 = _interopRequireDefault(_collectionsBookmark);
	
	var _collections = __webpack_require__(1512);
	
	var _collections2 = _interopRequireDefault(_collections);
	
	var _colorLens = __webpack_require__(1513);
	
	var _colorLens2 = _interopRequireDefault(_colorLens);
	
	var _colorize = __webpack_require__(1514);
	
	var _colorize2 = _interopRequireDefault(_colorize);
	
	var _compare = __webpack_require__(1515);
	
	var _compare2 = _interopRequireDefault(_compare);
	
	var _controlPointDuplicate = __webpack_require__(1516);
	
	var _controlPointDuplicate2 = _interopRequireDefault(_controlPointDuplicate);
	
	var _controlPoint = __webpack_require__(1517);
	
	var _controlPoint2 = _interopRequireDefault(_controlPoint);
	
	var _crop = __webpack_require__(1518);
	
	var _crop2 = _interopRequireDefault(_crop);
	
	var _crop3 = __webpack_require__(1519);
	
	var _crop4 = _interopRequireDefault(_crop3);
	
	var _crop5 = __webpack_require__(1520);
	
	var _crop6 = _interopRequireDefault(_crop5);
	
	var _crop7 = __webpack_require__(1521);
	
	var _crop8 = _interopRequireDefault(_crop7);
	
	var _cropDin = __webpack_require__(1522);
	
	var _cropDin2 = _interopRequireDefault(_cropDin);
	
	var _cropFree = __webpack_require__(1523);
	
	var _cropFree2 = _interopRequireDefault(_cropFree);
	
	var _cropLandscape = __webpack_require__(1524);
	
	var _cropLandscape2 = _interopRequireDefault(_cropLandscape);
	
	var _cropOriginal = __webpack_require__(1525);
	
	var _cropOriginal2 = _interopRequireDefault(_cropOriginal);
	
	var _cropPortrait = __webpack_require__(1526);
	
	var _cropPortrait2 = _interopRequireDefault(_cropPortrait);
	
	var _cropRotate = __webpack_require__(1527);
	
	var _cropRotate2 = _interopRequireDefault(_cropRotate);
	
	var _cropSquare = __webpack_require__(1528);
	
	var _cropSquare2 = _interopRequireDefault(_cropSquare);
	
	var _crop9 = __webpack_require__(1529);
	
	var _crop10 = _interopRequireDefault(_crop9);
	
	var _dehaze = __webpack_require__(1530);
	
	var _dehaze2 = _interopRequireDefault(_dehaze);
	
	var _details = __webpack_require__(1531);
	
	var _details2 = _interopRequireDefault(_details);
	
	var _edit = __webpack_require__(1532);
	
	var _edit2 = _interopRequireDefault(_edit);
	
	var _exposureNeg = __webpack_require__(1533);
	
	var _exposureNeg2 = _interopRequireDefault(_exposureNeg);
	
	var _exposureNeg3 = __webpack_require__(1534);
	
	var _exposureNeg4 = _interopRequireDefault(_exposureNeg3);
	
	var _exposurePlus = __webpack_require__(1535);
	
	var _exposurePlus2 = _interopRequireDefault(_exposurePlus);
	
	var _exposurePlus3 = __webpack_require__(1536);
	
	var _exposurePlus4 = _interopRequireDefault(_exposurePlus3);
	
	var _exposureZero = __webpack_require__(1537);
	
	var _exposureZero2 = _interopRequireDefault(_exposureZero);
	
	var _exposure = __webpack_require__(1538);
	
	var _exposure2 = _interopRequireDefault(_exposure);
	
	var _filter = __webpack_require__(1539);
	
	var _filter2 = _interopRequireDefault(_filter);
	
	var _filter3 = __webpack_require__(1540);
	
	var _filter4 = _interopRequireDefault(_filter3);
	
	var _filter5 = __webpack_require__(1541);
	
	var _filter6 = _interopRequireDefault(_filter5);
	
	var _filter7 = __webpack_require__(1542);
	
	var _filter8 = _interopRequireDefault(_filter7);
	
	var _filter9 = __webpack_require__(1543);
	
	var _filter10 = _interopRequireDefault(_filter9);
	
	var _filter11 = __webpack_require__(1544);
	
	var _filter12 = _interopRequireDefault(_filter11);
	
	var _filter13 = __webpack_require__(1545);
	
	var _filter14 = _interopRequireDefault(_filter13);
	
	var _filter15 = __webpack_require__(1546);
	
	var _filter16 = _interopRequireDefault(_filter15);
	
	var _filter9Plus = __webpack_require__(1547);
	
	var _filter9Plus2 = _interopRequireDefault(_filter9Plus);
	
	var _filter17 = __webpack_require__(1548);
	
	var _filter18 = _interopRequireDefault(_filter17);
	
	var _filterBAndW = __webpack_require__(1549);
	
	var _filterBAndW2 = _interopRequireDefault(_filterBAndW);
	
	var _filterCenterFocus = __webpack_require__(1550);
	
	var _filterCenterFocus2 = _interopRequireDefault(_filterCenterFocus);
	
	var _filterDrama = __webpack_require__(1551);
	
	var _filterDrama2 = _interopRequireDefault(_filterDrama);
	
	var _filterFrames = __webpack_require__(1552);
	
	var _filterFrames2 = _interopRequireDefault(_filterFrames);
	
	var _filterHdr = __webpack_require__(1553);
	
	var _filterHdr2 = _interopRequireDefault(_filterHdr);
	
	var _filterNone = __webpack_require__(1554);
	
	var _filterNone2 = _interopRequireDefault(_filterNone);
	
	var _filterTiltShift = __webpack_require__(1555);
	
	var _filterTiltShift2 = _interopRequireDefault(_filterTiltShift);
	
	var _filterVintage = __webpack_require__(1556);
	
	var _filterVintage2 = _interopRequireDefault(_filterVintage);
	
	var _filter19 = __webpack_require__(1557);
	
	var _filter20 = _interopRequireDefault(_filter19);
	
	var _flare = __webpack_require__(1558);
	
	var _flare2 = _interopRequireDefault(_flare);
	
	var _flashAuto = __webpack_require__(1559);
	
	var _flashAuto2 = _interopRequireDefault(_flashAuto);
	
	var _flashOff = __webpack_require__(1560);
	
	var _flashOff2 = _interopRequireDefault(_flashOff);
	
	var _flashOn = __webpack_require__(1561);
	
	var _flashOn2 = _interopRequireDefault(_flashOn);
	
	var _flip = __webpack_require__(1562);
	
	var _flip2 = _interopRequireDefault(_flip);
	
	var _gradient = __webpack_require__(1563);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _grain = __webpack_require__(1564);
	
	var _grain2 = _interopRequireDefault(_grain);
	
	var _gridOff = __webpack_require__(1565);
	
	var _gridOff2 = _interopRequireDefault(_gridOff);
	
	var _gridOn = __webpack_require__(1566);
	
	var _gridOn2 = _interopRequireDefault(_gridOn);
	
	var _hdrOff = __webpack_require__(1567);
	
	var _hdrOff2 = _interopRequireDefault(_hdrOff);
	
	var _hdrOn = __webpack_require__(1568);
	
	var _hdrOn2 = _interopRequireDefault(_hdrOn);
	
	var _hdrStrong = __webpack_require__(1569);
	
	var _hdrStrong2 = _interopRequireDefault(_hdrStrong);
	
	var _hdrWeak = __webpack_require__(1570);
	
	var _hdrWeak2 = _interopRequireDefault(_hdrWeak);
	
	var _healing = __webpack_require__(1571);
	
	var _healing2 = _interopRequireDefault(_healing);
	
	var _imageAspectRatio = __webpack_require__(1572);
	
	var _imageAspectRatio2 = _interopRequireDefault(_imageAspectRatio);
	
	var _image = __webpack_require__(1573);
	
	var _image2 = _interopRequireDefault(_image);
	
	var _iso = __webpack_require__(1574);
	
	var _iso2 = _interopRequireDefault(_iso);
	
	var _landscape = __webpack_require__(1575);
	
	var _landscape2 = _interopRequireDefault(_landscape);
	
	var _leakAdd = __webpack_require__(1576);
	
	var _leakAdd2 = _interopRequireDefault(_leakAdd);
	
	var _leakRemove = __webpack_require__(1577);
	
	var _leakRemove2 = _interopRequireDefault(_leakRemove);
	
	var _lens = __webpack_require__(1578);
	
	var _lens2 = _interopRequireDefault(_lens);
	
	var _linkedCamera = __webpack_require__(1579);
	
	var _linkedCamera2 = _interopRequireDefault(_linkedCamera);
	
	var _looks = __webpack_require__(1580);
	
	var _looks2 = _interopRequireDefault(_looks);
	
	var _looks3 = __webpack_require__(1581);
	
	var _looks4 = _interopRequireDefault(_looks3);
	
	var _looks5 = __webpack_require__(1582);
	
	var _looks6 = _interopRequireDefault(_looks5);
	
	var _looks7 = __webpack_require__(1583);
	
	var _looks8 = _interopRequireDefault(_looks7);
	
	var _looksOne = __webpack_require__(1584);
	
	var _looksOne2 = _interopRequireDefault(_looksOne);
	
	var _looksTwo = __webpack_require__(1585);
	
	var _looksTwo2 = _interopRequireDefault(_looksTwo);
	
	var _looks9 = __webpack_require__(1586);
	
	var _looks10 = _interopRequireDefault(_looks9);
	
	var _loupe = __webpack_require__(1587);
	
	var _loupe2 = _interopRequireDefault(_loupe);
	
	var _monochromePhotos = __webpack_require__(1588);
	
	var _monochromePhotos2 = _interopRequireDefault(_monochromePhotos);
	
	var _movieCreation = __webpack_require__(1589);
	
	var _movieCreation2 = _interopRequireDefault(_movieCreation);
	
	var _movieFilter = __webpack_require__(1590);
	
	var _movieFilter2 = _interopRequireDefault(_movieFilter);
	
	var _musicNote = __webpack_require__(1591);
	
	var _musicNote2 = _interopRequireDefault(_musicNote);
	
	var _naturePeople = __webpack_require__(1592);
	
	var _naturePeople2 = _interopRequireDefault(_naturePeople);
	
	var _nature = __webpack_require__(1593);
	
	var _nature2 = _interopRequireDefault(_nature);
	
	var _navigateBefore = __webpack_require__(1594);
	
	var _navigateBefore2 = _interopRequireDefault(_navigateBefore);
	
	var _navigateNext = __webpack_require__(1595);
	
	var _navigateNext2 = _interopRequireDefault(_navigateNext);
	
	var _palette = __webpack_require__(1596);
	
	var _palette2 = _interopRequireDefault(_palette);
	
	var _panoramaFishEye = __webpack_require__(1597);
	
	var _panoramaFishEye2 = _interopRequireDefault(_panoramaFishEye);
	
	var _panoramaHorizontal = __webpack_require__(1598);
	
	var _panoramaHorizontal2 = _interopRequireDefault(_panoramaHorizontal);
	
	var _panoramaVertical = __webpack_require__(1599);
	
	var _panoramaVertical2 = _interopRequireDefault(_panoramaVertical);
	
	var _panoramaWideAngle = __webpack_require__(1600);
	
	var _panoramaWideAngle2 = _interopRequireDefault(_panoramaWideAngle);
	
	var _panorama = __webpack_require__(1601);
	
	var _panorama2 = _interopRequireDefault(_panorama);
	
	var _photoAlbum = __webpack_require__(1602);
	
	var _photoAlbum2 = _interopRequireDefault(_photoAlbum);
	
	var _photoCamera = __webpack_require__(1603);
	
	var _photoCamera2 = _interopRequireDefault(_photoCamera);
	
	var _photoFilter = __webpack_require__(1604);
	
	var _photoFilter2 = _interopRequireDefault(_photoFilter);
	
	var _photoLibrary = __webpack_require__(1605);
	
	var _photoLibrary2 = _interopRequireDefault(_photoLibrary);
	
	var _photoSizeSelectActual = __webpack_require__(1606);
	
	var _photoSizeSelectActual2 = _interopRequireDefault(_photoSizeSelectActual);
	
	var _photoSizeSelectLarge = __webpack_require__(1607);
	
	var _photoSizeSelectLarge2 = _interopRequireDefault(_photoSizeSelectLarge);
	
	var _photoSizeSelectSmall = __webpack_require__(1608);
	
	var _photoSizeSelectSmall2 = _interopRequireDefault(_photoSizeSelectSmall);
	
	var _photo = __webpack_require__(1609);
	
	var _photo2 = _interopRequireDefault(_photo);
	
	var _pictureAsPdf = __webpack_require__(1610);
	
	var _pictureAsPdf2 = _interopRequireDefault(_pictureAsPdf);
	
	var _portrait = __webpack_require__(1611);
	
	var _portrait2 = _interopRequireDefault(_portrait);
	
	var _removeRedEye = __webpack_require__(1612);
	
	var _removeRedEye2 = _interopRequireDefault(_removeRedEye);
	
	var _rotate90DegreesCcw = __webpack_require__(1613);
	
	var _rotate90DegreesCcw2 = _interopRequireDefault(_rotate90DegreesCcw);
	
	var _rotateLeft = __webpack_require__(1614);
	
	var _rotateLeft2 = _interopRequireDefault(_rotateLeft);
	
	var _rotateRight = __webpack_require__(1615);
	
	var _rotateRight2 = _interopRequireDefault(_rotateRight);
	
	var _slideshow = __webpack_require__(1616);
	
	var _slideshow2 = _interopRequireDefault(_slideshow);
	
	var _straighten = __webpack_require__(1617);
	
	var _straighten2 = _interopRequireDefault(_straighten);
	
	var _style = __webpack_require__(1618);
	
	var _style2 = _interopRequireDefault(_style);
	
	var _switchCamera = __webpack_require__(1619);
	
	var _switchCamera2 = _interopRequireDefault(_switchCamera);
	
	var _switchVideo = __webpack_require__(1620);
	
	var _switchVideo2 = _interopRequireDefault(_switchVideo);
	
	var _tagFaces = __webpack_require__(1621);
	
	var _tagFaces2 = _interopRequireDefault(_tagFaces);
	
	var _texture = __webpack_require__(1622);
	
	var _texture2 = _interopRequireDefault(_texture);
	
	var _timelapse = __webpack_require__(1623);
	
	var _timelapse2 = _interopRequireDefault(_timelapse);
	
	var _timer = __webpack_require__(1624);
	
	var _timer2 = _interopRequireDefault(_timer);
	
	var _timer3 = __webpack_require__(1625);
	
	var _timer4 = _interopRequireDefault(_timer3);
	
	var _timerOff = __webpack_require__(1626);
	
	var _timerOff2 = _interopRequireDefault(_timerOff);
	
	var _timer5 = __webpack_require__(1627);
	
	var _timer6 = _interopRequireDefault(_timer5);
	
	var _tonality = __webpack_require__(1628);
	
	var _tonality2 = _interopRequireDefault(_tonality);
	
	var _transform = __webpack_require__(1629);
	
	var _transform2 = _interopRequireDefault(_transform);
	
	var _tune = __webpack_require__(1630);
	
	var _tune2 = _interopRequireDefault(_tune);
	
	var _viewComfy = __webpack_require__(1631);
	
	var _viewComfy2 = _interopRequireDefault(_viewComfy);
	
	var _viewCompact = __webpack_require__(1632);
	
	var _viewCompact2 = _interopRequireDefault(_viewCompact);
	
	var _vignette = __webpack_require__(1633);
	
	var _vignette2 = _interopRequireDefault(_vignette);
	
	var _wbAuto = __webpack_require__(1634);
	
	var _wbAuto2 = _interopRequireDefault(_wbAuto);
	
	var _wbCloudy = __webpack_require__(1635);
	
	var _wbCloudy2 = _interopRequireDefault(_wbCloudy);
	
	var _wbIncandescent = __webpack_require__(1636);
	
	var _wbIncandescent2 = _interopRequireDefault(_wbIncandescent);
	
	var _wbIridescent = __webpack_require__(1637);
	
	var _wbIridescent2 = _interopRequireDefault(_wbIridescent);
	
	var _wbSunny = __webpack_require__(1638);
	
	var _wbSunny2 = _interopRequireDefault(_wbSunny);
	
	var _addLocation = __webpack_require__(1639);
	
	var _addLocation2 = _interopRequireDefault(_addLocation);
	
	var _beenhere = __webpack_require__(1640);
	
	var _beenhere2 = _interopRequireDefault(_beenhere);
	
	var _directionsBike = __webpack_require__(1641);
	
	var _directionsBike2 = _interopRequireDefault(_directionsBike);
	
	var _directionsBoat = __webpack_require__(1642);
	
	var _directionsBoat2 = _interopRequireDefault(_directionsBoat);
	
	var _directionsBus = __webpack_require__(1643);
	
	var _directionsBus2 = _interopRequireDefault(_directionsBus);
	
	var _directionsCar = __webpack_require__(1644);
	
	var _directionsCar2 = _interopRequireDefault(_directionsCar);
	
	var _directionsRailway = __webpack_require__(1645);
	
	var _directionsRailway2 = _interopRequireDefault(_directionsRailway);
	
	var _directionsRun = __webpack_require__(1646);
	
	var _directionsRun2 = _interopRequireDefault(_directionsRun);
	
	var _directionsSubway = __webpack_require__(1647);
	
	var _directionsSubway2 = _interopRequireDefault(_directionsSubway);
	
	var _directionsTransit = __webpack_require__(1648);
	
	var _directionsTransit2 = _interopRequireDefault(_directionsTransit);
	
	var _directionsWalk = __webpack_require__(1649);
	
	var _directionsWalk2 = _interopRequireDefault(_directionsWalk);
	
	var _directions = __webpack_require__(1650);
	
	var _directions2 = _interopRequireDefault(_directions);
	
	var _editLocation = __webpack_require__(1651);
	
	var _editLocation2 = _interopRequireDefault(_editLocation);
	
	var _evStation = __webpack_require__(1652);
	
	var _evStation2 = _interopRequireDefault(_evStation);
	
	var _flight = __webpack_require__(1653);
	
	var _flight2 = _interopRequireDefault(_flight);
	
	var _hotel = __webpack_require__(1654);
	
	var _hotel2 = _interopRequireDefault(_hotel);
	
	var _layersClear = __webpack_require__(1655);
	
	var _layersClear2 = _interopRequireDefault(_layersClear);
	
	var _layers = __webpack_require__(1656);
	
	var _layers2 = _interopRequireDefault(_layers);
	
	var _localActivity = __webpack_require__(1657);
	
	var _localActivity2 = _interopRequireDefault(_localActivity);
	
	var _localAirport = __webpack_require__(1658);
	
	var _localAirport2 = _interopRequireDefault(_localAirport);
	
	var _localAtm = __webpack_require__(1659);
	
	var _localAtm2 = _interopRequireDefault(_localAtm);
	
	var _localBar = __webpack_require__(1660);
	
	var _localBar2 = _interopRequireDefault(_localBar);
	
	var _localCafe = __webpack_require__(1661);
	
	var _localCafe2 = _interopRequireDefault(_localCafe);
	
	var _localCarWash = __webpack_require__(1662);
	
	var _localCarWash2 = _interopRequireDefault(_localCarWash);
	
	var _localConvenienceStore = __webpack_require__(1663);
	
	var _localConvenienceStore2 = _interopRequireDefault(_localConvenienceStore);
	
	var _localDining = __webpack_require__(1664);
	
	var _localDining2 = _interopRequireDefault(_localDining);
	
	var _localDrink = __webpack_require__(1665);
	
	var _localDrink2 = _interopRequireDefault(_localDrink);
	
	var _localFlorist = __webpack_require__(1666);
	
	var _localFlorist2 = _interopRequireDefault(_localFlorist);
	
	var _localGasStation = __webpack_require__(1667);
	
	var _localGasStation2 = _interopRequireDefault(_localGasStation);
	
	var _localGroceryStore = __webpack_require__(1668);
	
	var _localGroceryStore2 = _interopRequireDefault(_localGroceryStore);
	
	var _localHospital = __webpack_require__(1669);
	
	var _localHospital2 = _interopRequireDefault(_localHospital);
	
	var _localHotel = __webpack_require__(1670);
	
	var _localHotel2 = _interopRequireDefault(_localHotel);
	
	var _localLaundryService = __webpack_require__(1671);
	
	var _localLaundryService2 = _interopRequireDefault(_localLaundryService);
	
	var _localLibrary = __webpack_require__(1672);
	
	var _localLibrary2 = _interopRequireDefault(_localLibrary);
	
	var _localMall = __webpack_require__(1673);
	
	var _localMall2 = _interopRequireDefault(_localMall);
	
	var _localMovies = __webpack_require__(1674);
	
	var _localMovies2 = _interopRequireDefault(_localMovies);
	
	var _localOffer = __webpack_require__(1675);
	
	var _localOffer2 = _interopRequireDefault(_localOffer);
	
	var _localParking = __webpack_require__(1676);
	
	var _localParking2 = _interopRequireDefault(_localParking);
	
	var _localPharmacy = __webpack_require__(1677);
	
	var _localPharmacy2 = _interopRequireDefault(_localPharmacy);
	
	var _localPhone = __webpack_require__(1678);
	
	var _localPhone2 = _interopRequireDefault(_localPhone);
	
	var _localPizza = __webpack_require__(1679);
	
	var _localPizza2 = _interopRequireDefault(_localPizza);
	
	var _localPlay = __webpack_require__(1680);
	
	var _localPlay2 = _interopRequireDefault(_localPlay);
	
	var _localPostOffice = __webpack_require__(1681);
	
	var _localPostOffice2 = _interopRequireDefault(_localPostOffice);
	
	var _localPrintshop = __webpack_require__(1682);
	
	var _localPrintshop2 = _interopRequireDefault(_localPrintshop);
	
	var _localSee = __webpack_require__(1683);
	
	var _localSee2 = _interopRequireDefault(_localSee);
	
	var _localShipping = __webpack_require__(1684);
	
	var _localShipping2 = _interopRequireDefault(_localShipping);
	
	var _localTaxi = __webpack_require__(1685);
	
	var _localTaxi2 = _interopRequireDefault(_localTaxi);
	
	var _map = __webpack_require__(1686);
	
	var _map2 = _interopRequireDefault(_map);
	
	var _myLocation = __webpack_require__(1687);
	
	var _myLocation2 = _interopRequireDefault(_myLocation);
	
	var _navigation = __webpack_require__(1688);
	
	var _navigation2 = _interopRequireDefault(_navigation);
	
	var _nearMe = __webpack_require__(1689);
	
	var _nearMe2 = _interopRequireDefault(_nearMe);
	
	var _personPinCircle = __webpack_require__(1690);
	
	var _personPinCircle2 = _interopRequireDefault(_personPinCircle);
	
	var _personPin = __webpack_require__(1691);
	
	var _personPin2 = _interopRequireDefault(_personPin);
	
	var _pinDrop = __webpack_require__(1692);
	
	var _pinDrop2 = _interopRequireDefault(_pinDrop);
	
	var _place = __webpack_require__(1693);
	
	var _place2 = _interopRequireDefault(_place);
	
	var _rateReview = __webpack_require__(1694);
	
	var _rateReview2 = _interopRequireDefault(_rateReview);
	
	var _restaurantMenu = __webpack_require__(1695);
	
	var _restaurantMenu2 = _interopRequireDefault(_restaurantMenu);
	
	var _restaurant = __webpack_require__(1696);
	
	var _restaurant2 = _interopRequireDefault(_restaurant);
	
	var _satellite = __webpack_require__(1697);
	
	var _satellite2 = _interopRequireDefault(_satellite);
	
	var _storeMallDirectory = __webpack_require__(1698);
	
	var _storeMallDirectory2 = _interopRequireDefault(_storeMallDirectory);
	
	var _streetview = __webpack_require__(1699);
	
	var _streetview2 = _interopRequireDefault(_streetview);
	
	var _subway = __webpack_require__(1700);
	
	var _subway2 = _interopRequireDefault(_subway);
	
	var _terrain = __webpack_require__(1701);
	
	var _terrain2 = _interopRequireDefault(_terrain);
	
	var _traffic = __webpack_require__(1702);
	
	var _traffic2 = _interopRequireDefault(_traffic);
	
	var _train = __webpack_require__(1703);
	
	var _train2 = _interopRequireDefault(_train);
	
	var _tram = __webpack_require__(1704);
	
	var _tram2 = _interopRequireDefault(_tram);
	
	var _transferWithinAStation = __webpack_require__(1705);
	
	var _transferWithinAStation2 = _interopRequireDefault(_transferWithinAStation);
	
	var _zoomOutMap = __webpack_require__(1706);
	
	var _zoomOutMap2 = _interopRequireDefault(_zoomOutMap);
	
	var _apps = __webpack_require__(1708);
	
	var _apps2 = _interopRequireDefault(_apps);
	
	var _arrowBack = __webpack_require__(1709);
	
	var _arrowBack2 = _interopRequireDefault(_arrowBack);
	
	var _arrowDownward = __webpack_require__(1710);
	
	var _arrowDownward2 = _interopRequireDefault(_arrowDownward);
	
	var _arrowDropDownCircle = __webpack_require__(1711);
	
	var _arrowDropDownCircle2 = _interopRequireDefault(_arrowDropDownCircle);
	
	var _arrowDropDown = __webpack_require__(378);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _arrowDropUp = __webpack_require__(1712);
	
	var _arrowDropUp2 = _interopRequireDefault(_arrowDropUp);
	
	var _arrowForward = __webpack_require__(1713);
	
	var _arrowForward2 = _interopRequireDefault(_arrowForward);
	
	var _arrowUpward = __webpack_require__(1714);
	
	var _arrowUpward2 = _interopRequireDefault(_arrowUpward);
	
	var _cancel = __webpack_require__(379);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	var _check = __webpack_require__(380);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _chevronLeft = __webpack_require__(381);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(382);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _close = __webpack_require__(1715);
	
	var _close2 = _interopRequireDefault(_close);
	
	var _expandLess = __webpack_require__(383);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(384);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _firstPage = __webpack_require__(1716);
	
	var _firstPage2 = _interopRequireDefault(_firstPage);
	
	var _fullscreenExit = __webpack_require__(1717);
	
	var _fullscreenExit2 = _interopRequireDefault(_fullscreenExit);
	
	var _fullscreen = __webpack_require__(1718);
	
	var _fullscreen2 = _interopRequireDefault(_fullscreen);
	
	var _lastPage = __webpack_require__(1719);
	
	var _lastPage2 = _interopRequireDefault(_lastPage);
	
	var _menu = __webpack_require__(385);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _moreHoriz = __webpack_require__(1720);
	
	var _moreHoriz2 = _interopRequireDefault(_moreHoriz);
	
	var _moreVert = __webpack_require__(1721);
	
	var _moreVert2 = _interopRequireDefault(_moreVert);
	
	var _refresh = __webpack_require__(1722);
	
	var _refresh2 = _interopRequireDefault(_refresh);
	
	var _subdirectoryArrowLeft = __webpack_require__(1723);
	
	var _subdirectoryArrowLeft2 = _interopRequireDefault(_subdirectoryArrowLeft);
	
	var _subdirectoryArrowRight = __webpack_require__(1724);
	
	var _subdirectoryArrowRight2 = _interopRequireDefault(_subdirectoryArrowRight);
	
	var _unfoldLess = __webpack_require__(1725);
	
	var _unfoldLess2 = _interopRequireDefault(_unfoldLess);
	
	var _unfoldMore = __webpack_require__(1726);
	
	var _unfoldMore2 = _interopRequireDefault(_unfoldMore);
	
	var _navigationArrowDropRight = __webpack_require__(1707);
	
	var _navigationArrowDropRight2 = _interopRequireDefault(_navigationArrowDropRight);
	
	var _adb = __webpack_require__(1727);
	
	var _adb2 = _interopRequireDefault(_adb);
	
	var _airlineSeatFlatAngled = __webpack_require__(1728);
	
	var _airlineSeatFlatAngled2 = _interopRequireDefault(_airlineSeatFlatAngled);
	
	var _airlineSeatFlat = __webpack_require__(1729);
	
	var _airlineSeatFlat2 = _interopRequireDefault(_airlineSeatFlat);
	
	var _airlineSeatIndividualSuite = __webpack_require__(1730);
	
	var _airlineSeatIndividualSuite2 = _interopRequireDefault(_airlineSeatIndividualSuite);
	
	var _airlineSeatLegroomExtra = __webpack_require__(1731);
	
	var _airlineSeatLegroomExtra2 = _interopRequireDefault(_airlineSeatLegroomExtra);
	
	var _airlineSeatLegroomNormal = __webpack_require__(1732);
	
	var _airlineSeatLegroomNormal2 = _interopRequireDefault(_airlineSeatLegroomNormal);
	
	var _airlineSeatLegroomReduced = __webpack_require__(1733);
	
	var _airlineSeatLegroomReduced2 = _interopRequireDefault(_airlineSeatLegroomReduced);
	
	var _airlineSeatReclineExtra = __webpack_require__(1734);
	
	var _airlineSeatReclineExtra2 = _interopRequireDefault(_airlineSeatReclineExtra);
	
	var _airlineSeatReclineNormal = __webpack_require__(1735);
	
	var _airlineSeatReclineNormal2 = _interopRequireDefault(_airlineSeatReclineNormal);
	
	var _bluetoothAudio = __webpack_require__(1736);
	
	var _bluetoothAudio2 = _interopRequireDefault(_bluetoothAudio);
	
	var _confirmationNumber = __webpack_require__(1737);
	
	var _confirmationNumber2 = _interopRequireDefault(_confirmationNumber);
	
	var _discFull = __webpack_require__(1738);
	
	var _discFull2 = _interopRequireDefault(_discFull);
	
	var _doNotDisturbAlt = __webpack_require__(1739);
	
	var _doNotDisturbAlt2 = _interopRequireDefault(_doNotDisturbAlt);
	
	var _doNotDisturbOff = __webpack_require__(1740);
	
	var _doNotDisturbOff2 = _interopRequireDefault(_doNotDisturbOff);
	
	var _doNotDisturbOn = __webpack_require__(1741);
	
	var _doNotDisturbOn2 = _interopRequireDefault(_doNotDisturbOn);
	
	var _doNotDisturb = __webpack_require__(1742);
	
	var _doNotDisturb2 = _interopRequireDefault(_doNotDisturb);
	
	var _driveEta = __webpack_require__(1743);
	
	var _driveEta2 = _interopRequireDefault(_driveEta);
	
	var _enhancedEncryption = __webpack_require__(1744);
	
	var _enhancedEncryption2 = _interopRequireDefault(_enhancedEncryption);
	
	var _eventAvailable = __webpack_require__(1745);
	
	var _eventAvailable2 = _interopRequireDefault(_eventAvailable);
	
	var _eventBusy = __webpack_require__(1746);
	
	var _eventBusy2 = _interopRequireDefault(_eventBusy);
	
	var _eventNote = __webpack_require__(1747);
	
	var _eventNote2 = _interopRequireDefault(_eventNote);
	
	var _folderSpecial = __webpack_require__(1748);
	
	var _folderSpecial2 = _interopRequireDefault(_folderSpecial);
	
	var _liveTv = __webpack_require__(1749);
	
	var _liveTv2 = _interopRequireDefault(_liveTv);
	
	var _mms = __webpack_require__(1750);
	
	var _mms2 = _interopRequireDefault(_mms);
	
	var _more = __webpack_require__(1751);
	
	var _more2 = _interopRequireDefault(_more);
	
	var _networkCheck = __webpack_require__(1752);
	
	var _networkCheck2 = _interopRequireDefault(_networkCheck);
	
	var _networkLocked = __webpack_require__(1753);
	
	var _networkLocked2 = _interopRequireDefault(_networkLocked);
	
	var _noEncryption = __webpack_require__(1754);
	
	var _noEncryption2 = _interopRequireDefault(_noEncryption);
	
	var _ondemandVideo = __webpack_require__(1755);
	
	var _ondemandVideo2 = _interopRequireDefault(_ondemandVideo);
	
	var _personalVideo = __webpack_require__(1756);
	
	var _personalVideo2 = _interopRequireDefault(_personalVideo);
	
	var _phoneBluetoothSpeaker = __webpack_require__(1757);
	
	var _phoneBluetoothSpeaker2 = _interopRequireDefault(_phoneBluetoothSpeaker);
	
	var _phoneForwarded = __webpack_require__(1758);
	
	var _phoneForwarded2 = _interopRequireDefault(_phoneForwarded);
	
	var _phoneInTalk = __webpack_require__(1759);
	
	var _phoneInTalk2 = _interopRequireDefault(_phoneInTalk);
	
	var _phoneLocked = __webpack_require__(1760);
	
	var _phoneLocked2 = _interopRequireDefault(_phoneLocked);
	
	var _phoneMissed = __webpack_require__(1761);
	
	var _phoneMissed2 = _interopRequireDefault(_phoneMissed);
	
	var _phonePaused = __webpack_require__(1762);
	
	var _phonePaused2 = _interopRequireDefault(_phonePaused);
	
	var _power = __webpack_require__(1763);
	
	var _power2 = _interopRequireDefault(_power);
	
	var _priorityHigh = __webpack_require__(1764);
	
	var _priorityHigh2 = _interopRequireDefault(_priorityHigh);
	
	var _rvHookup = __webpack_require__(1765);
	
	var _rvHookup2 = _interopRequireDefault(_rvHookup);
	
	var _sdCard = __webpack_require__(1766);
	
	var _sdCard2 = _interopRequireDefault(_sdCard);
	
	var _simCardAlert = __webpack_require__(1767);
	
	var _simCardAlert2 = _interopRequireDefault(_simCardAlert);
	
	var _smsFailed = __webpack_require__(1768);
	
	var _smsFailed2 = _interopRequireDefault(_smsFailed);
	
	var _sms = __webpack_require__(1769);
	
	var _sms2 = _interopRequireDefault(_sms);
	
	var _syncDisabled = __webpack_require__(1770);
	
	var _syncDisabled2 = _interopRequireDefault(_syncDisabled);
	
	var _syncProblem = __webpack_require__(1771);
	
	var _syncProblem2 = _interopRequireDefault(_syncProblem);
	
	var _sync = __webpack_require__(1772);
	
	var _sync2 = _interopRequireDefault(_sync);
	
	var _systemUpdate = __webpack_require__(1773);
	
	var _systemUpdate2 = _interopRequireDefault(_systemUpdate);
	
	var _tapAndPlay = __webpack_require__(1774);
	
	var _tapAndPlay2 = _interopRequireDefault(_tapAndPlay);
	
	var _timeToLeave = __webpack_require__(1775);
	
	var _timeToLeave2 = _interopRequireDefault(_timeToLeave);
	
	var _vibration = __webpack_require__(1776);
	
	var _vibration2 = _interopRequireDefault(_vibration);
	
	var _voiceChat = __webpack_require__(1777);
	
	var _voiceChat2 = _interopRequireDefault(_voiceChat);
	
	var _vpnLock = __webpack_require__(1778);
	
	var _vpnLock2 = _interopRequireDefault(_vpnLock);
	
	var _wc = __webpack_require__(1779);
	
	var _wc2 = _interopRequireDefault(_wc);
	
	var _wifi = __webpack_require__(1780);
	
	var _wifi2 = _interopRequireDefault(_wifi);
	
	var _acUnit = __webpack_require__(1781);
	
	var _acUnit2 = _interopRequireDefault(_acUnit);
	
	var _airportShuttle = __webpack_require__(1782);
	
	var _airportShuttle2 = _interopRequireDefault(_airportShuttle);
	
	var _allInclusive = __webpack_require__(1783);
	
	var _allInclusive2 = _interopRequireDefault(_allInclusive);
	
	var _beachAccess = __webpack_require__(1784);
	
	var _beachAccess2 = _interopRequireDefault(_beachAccess);
	
	var _businessCenter = __webpack_require__(1785);
	
	var _businessCenter2 = _interopRequireDefault(_businessCenter);
	
	var _casino = __webpack_require__(1786);
	
	var _casino2 = _interopRequireDefault(_casino);
	
	var _childCare = __webpack_require__(1787);
	
	var _childCare2 = _interopRequireDefault(_childCare);
	
	var _childFriendly = __webpack_require__(1788);
	
	var _childFriendly2 = _interopRequireDefault(_childFriendly);
	
	var _fitnessCenter = __webpack_require__(1789);
	
	var _fitnessCenter2 = _interopRequireDefault(_fitnessCenter);
	
	var _freeBreakfast = __webpack_require__(1790);
	
	var _freeBreakfast2 = _interopRequireDefault(_freeBreakfast);
	
	var _golfCourse = __webpack_require__(1791);
	
	var _golfCourse2 = _interopRequireDefault(_golfCourse);
	
	var _hotTub = __webpack_require__(1792);
	
	var _hotTub2 = _interopRequireDefault(_hotTub);
	
	var _kitchen = __webpack_require__(1793);
	
	var _kitchen2 = _interopRequireDefault(_kitchen);
	
	var _pool = __webpack_require__(1794);
	
	var _pool2 = _interopRequireDefault(_pool);
	
	var _roomService = __webpack_require__(1795);
	
	var _roomService2 = _interopRequireDefault(_roomService);
	
	var _rvHookup3 = __webpack_require__(1796);
	
	var _rvHookup4 = _interopRequireDefault(_rvHookup3);
	
	var _smokeFree = __webpack_require__(1797);
	
	var _smokeFree2 = _interopRequireDefault(_smokeFree);
	
	var _smokingRooms = __webpack_require__(1798);
	
	var _smokingRooms2 = _interopRequireDefault(_smokingRooms);
	
	var _spa = __webpack_require__(1799);
	
	var _spa2 = _interopRequireDefault(_spa);
	
	var _cake = __webpack_require__(1800);
	
	var _cake2 = _interopRequireDefault(_cake);
	
	var _domain = __webpack_require__(1801);
	
	var _domain2 = _interopRequireDefault(_domain);
	
	var _groupAdd = __webpack_require__(1802);
	
	var _groupAdd2 = _interopRequireDefault(_groupAdd);
	
	var _group = __webpack_require__(1803);
	
	var _group2 = _interopRequireDefault(_group);
	
	var _locationCity = __webpack_require__(1804);
	
	var _locationCity2 = _interopRequireDefault(_locationCity);
	
	var _moodBad = __webpack_require__(1805);
	
	var _moodBad2 = _interopRequireDefault(_moodBad);
	
	var _mood = __webpack_require__(1806);
	
	var _mood2 = _interopRequireDefault(_mood);
	
	var _notificationsActive = __webpack_require__(1807);
	
	var _notificationsActive2 = _interopRequireDefault(_notificationsActive);
	
	var _notificationsNone = __webpack_require__(1808);
	
	var _notificationsNone2 = _interopRequireDefault(_notificationsNone);
	
	var _notificationsOff = __webpack_require__(1809);
	
	var _notificationsOff2 = _interopRequireDefault(_notificationsOff);
	
	var _notificationsPaused = __webpack_require__(1810);
	
	var _notificationsPaused2 = _interopRequireDefault(_notificationsPaused);
	
	var _notifications = __webpack_require__(1811);
	
	var _notifications2 = _interopRequireDefault(_notifications);
	
	var _pages = __webpack_require__(1812);
	
	var _pages2 = _interopRequireDefault(_pages);
	
	var _partyMode = __webpack_require__(1813);
	
	var _partyMode2 = _interopRequireDefault(_partyMode);
	
	var _peopleOutline = __webpack_require__(1814);
	
	var _peopleOutline2 = _interopRequireDefault(_peopleOutline);
	
	var _people = __webpack_require__(1815);
	
	var _people2 = _interopRequireDefault(_people);
	
	var _personAdd = __webpack_require__(1816);
	
	var _personAdd2 = _interopRequireDefault(_personAdd);
	
	var _personOutline = __webpack_require__(1817);
	
	var _personOutline2 = _interopRequireDefault(_personOutline);
	
	var _person = __webpack_require__(1818);
	
	var _person2 = _interopRequireDefault(_person);
	
	var _plusOne = __webpack_require__(1819);
	
	var _plusOne2 = _interopRequireDefault(_plusOne);
	
	var _poll = __webpack_require__(1820);
	
	var _poll2 = _interopRequireDefault(_poll);
	
	var _public = __webpack_require__(1821);
	
	var _public2 = _interopRequireDefault(_public);
	
	var _school = __webpack_require__(1822);
	
	var _school2 = _interopRequireDefault(_school);
	
	var _sentimentDissatisfied = __webpack_require__(1823);
	
	var _sentimentDissatisfied2 = _interopRequireDefault(_sentimentDissatisfied);
	
	var _sentimentNeutral = __webpack_require__(1824);
	
	var _sentimentNeutral2 = _interopRequireDefault(_sentimentNeutral);
	
	var _sentimentSatisfied = __webpack_require__(1825);
	
	var _sentimentSatisfied2 = _interopRequireDefault(_sentimentSatisfied);
	
	var _sentimentVeryDissatisfied = __webpack_require__(1826);
	
	var _sentimentVeryDissatisfied2 = _interopRequireDefault(_sentimentVeryDissatisfied);
	
	var _sentimentVerySatisfied = __webpack_require__(1827);
	
	var _sentimentVerySatisfied2 = _interopRequireDefault(_sentimentVerySatisfied);
	
	var _share = __webpack_require__(1828);
	
	var _share2 = _interopRequireDefault(_share);
	
	var _whatshot = __webpack_require__(1829);
	
	var _whatshot2 = _interopRequireDefault(_whatshot);
	
	var _checkBoxOutlineBlank = __webpack_require__(386);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(387);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	var _indeterminateCheckBox = __webpack_require__(1830);
	
	var _indeterminateCheckBox2 = _interopRequireDefault(_indeterminateCheckBox);
	
	var _radioButtonChecked = __webpack_require__(388);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	var _radioButtonUnchecked = __webpack_require__(389);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _starBorder = __webpack_require__(1831);
	
	var _starBorder2 = _interopRequireDefault(_starBorder);
	
	var _starHalf = __webpack_require__(1832);
	
	var _starHalf2 = _interopRequireDefault(_starHalf);
	
	var _star = __webpack_require__(1833);
	
	var _star2 = _interopRequireDefault(_star);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.ActionAccessibility = _accessibility2.default;
	exports.ActionAccessible = _accessible2.default;
	exports.ActionAccountBalanceWallet = _accountBalanceWallet2.default;
	exports.ActionAccountBalance = _accountBalance2.default;
	exports.ActionAccountBox = _accountBox2.default;
	exports.ActionAccountCircle = _accountCircle2.default;
	exports.ActionAddShoppingCart = _addShoppingCart2.default;
	exports.ActionAlarmAdd = _alarmAdd2.default;
	exports.ActionAlarmOff = _alarmOff2.default;
	exports.ActionAlarmOn = _alarmOn2.default;
	exports.ActionAlarm = _alarm2.default;
	exports.ActionAllOut = _allOut2.default;
	exports.ActionAndroid = _android2.default;
	exports.ActionAnnouncement = _announcement2.default;
	exports.ActionAspectRatio = _aspectRatio2.default;
	exports.ActionAssessment = _assessment2.default;
	exports.ActionAssignmentInd = _assignmentInd2.default;
	exports.ActionAssignmentLate = _assignmentLate2.default;
	exports.ActionAssignmentReturn = _assignmentReturn2.default;
	exports.ActionAssignmentReturned = _assignmentReturned2.default;
	exports.ActionAssignmentTurnedIn = _assignmentTurnedIn2.default;
	exports.ActionAssignment = _assignment2.default;
	exports.ActionAutorenew = _autorenew2.default;
	exports.ActionBackup = _backup2.default;
	exports.ActionBook = _book2.default;
	exports.ActionBookmarkBorder = _bookmarkBorder2.default;
	exports.ActionBookmark = _bookmark2.default;
	exports.ActionBugReport = _bugReport2.default;
	exports.ActionBuild = _build2.default;
	exports.ActionCached = _cached2.default;
	exports.ActionCameraEnhance = _cameraEnhance2.default;
	exports.ActionCardGiftcard = _cardGiftcard2.default;
	exports.ActionCardMembership = _cardMembership2.default;
	exports.ActionCardTravel = _cardTravel2.default;
	exports.ActionChangeHistory = _changeHistory2.default;
	exports.ActionCheckCircle = _checkCircle2.default;
	exports.ActionChromeReaderMode = _chromeReaderMode2.default;
	exports.ActionClass = _class2.default;
	exports.ActionCode = _code2.default;
	exports.ActionCompareArrows = _compareArrows2.default;
	exports.ActionCopyright = _copyright2.default;
	exports.ActionCreditCard = _creditCard2.default;
	exports.ActionDashboard = _dashboard2.default;
	exports.ActionDateRange = _dateRange2.default;
	exports.ActionDeleteForever = _deleteForever2.default;
	exports.ActionDelete = _delete2.default;
	exports.ActionDescription = _description2.default;
	exports.ActionDns = _dns2.default;
	exports.ActionDoneAll = _doneAll2.default;
	exports.ActionDone = _done2.default;
	exports.ActionDonutLarge = _donutLarge2.default;
	exports.ActionDonutSmall = _donutSmall2.default;
	exports.ActionEject = _eject2.default;
	exports.ActionEuroSymbol = _euroSymbol2.default;
	exports.ActionEventSeat = _eventSeat2.default;
	exports.ActionEvent = _event2.default;
	exports.ActionExitToApp = _exitToApp2.default;
	exports.ActionExplore = _explore2.default;
	exports.ActionExtension = _extension2.default;
	exports.ActionFace = _face2.default;
	exports.ActionFavoriteBorder = _favoriteBorder2.default;
	exports.ActionFavorite = _favorite2.default;
	exports.ActionFeedback = _feedback2.default;
	exports.ActionFindInPage = _findInPage2.default;
	exports.ActionFindReplace = _findReplace2.default;
	exports.ActionFingerprint = _fingerprint2.default;
	exports.ActionFlightLand = _flightLand2.default;
	exports.ActionFlightTakeoff = _flightTakeoff2.default;
	exports.ActionFlipToBack = _flipToBack2.default;
	exports.ActionFlipToFront = _flipToFront2.default;
	exports.ActionGTranslate = _gTranslate2.default;
	exports.ActionGavel = _gavel2.default;
	exports.ActionGetApp = _getApp2.default;
	exports.ActionGif = _gif2.default;
	exports.ActionGrade = _grade2.default;
	exports.ActionGroupWork = _groupWork2.default;
	exports.ActionHelpOutline = _helpOutline2.default;
	exports.ActionHelp = _help2.default;
	exports.ActionHighlightOff = _highlightOff2.default;
	exports.ActionHistory = _history2.default;
	exports.ActionHome = _home2.default;
	exports.ActionHourglassEmpty = _hourglassEmpty2.default;
	exports.ActionHourglassFull = _hourglassFull2.default;
	exports.ActionHttp = _http2.default;
	exports.ActionHttps = _https2.default;
	exports.ActionImportantDevices = _importantDevices2.default;
	exports.ActionInfoOutline = _infoOutline2.default;
	exports.ActionInfo = _info2.default;
	exports.ActionInput = _input2.default;
	exports.ActionInvertColors = _invertColors2.default;
	exports.ActionLabelOutline = _labelOutline2.default;
	exports.ActionLabel = _label2.default;
	exports.ActionLanguage = _language2.default;
	exports.ActionLaunch = _launch2.default;
	exports.ActionLightbulbOutline = _lightbulbOutline2.default;
	exports.ActionLineStyle = _lineStyle2.default;
	exports.ActionLineWeight = _lineWeight2.default;
	exports.ActionList = _list2.default;
	exports.ActionLockOpen = _lockOpen2.default;
	exports.ActionLockOutline = _lockOutline2.default;
	exports.ActionLock = _lock2.default;
	exports.ActionLoyalty = _loyalty2.default;
	exports.ActionMarkunreadMailbox = _markunreadMailbox2.default;
	exports.ActionMotorcycle = _motorcycle2.default;
	exports.ActionNoteAdd = _noteAdd2.default;
	exports.ActionOfflinePin = _offlinePin2.default;
	exports.ActionOpacity = _opacity2.default;
	exports.ActionOpenInBrowser = _openInBrowser2.default;
	exports.ActionOpenInNew = _openInNew2.default;
	exports.ActionOpenWith = _openWith2.default;
	exports.ActionPageview = _pageview2.default;
	exports.ActionPanTool = _panTool2.default;
	exports.ActionPayment = _payment2.default;
	exports.ActionPermCameraMic = _permCameraMic2.default;
	exports.ActionPermContactCalendar = _permContactCalendar2.default;
	exports.ActionPermDataSetting = _permDataSetting2.default;
	exports.ActionPermDeviceInformation = _permDeviceInformation2.default;
	exports.ActionPermIdentity = _permIdentity2.default;
	exports.ActionPermMedia = _permMedia2.default;
	exports.ActionPermPhoneMsg = _permPhoneMsg2.default;
	exports.ActionPermScanWifi = _permScanWifi2.default;
	exports.ActionPets = _pets2.default;
	exports.ActionPictureInPictureAlt = _pictureInPictureAlt2.default;
	exports.ActionPictureInPicture = _pictureInPicture2.default;
	exports.ActionPlayForWork = _playForWork2.default;
	exports.ActionPolymer = _polymer2.default;
	exports.ActionPowerSettingsNew = _powerSettingsNew2.default;
	exports.ActionPregnantWoman = _pregnantWoman2.default;
	exports.ActionPrint = _print2.default;
	exports.ActionQueryBuilder = _queryBuilder2.default;
	exports.ActionQuestionAnswer = _questionAnswer2.default;
	exports.ActionReceipt = _receipt2.default;
	exports.ActionRecordVoiceOver = _recordVoiceOver2.default;
	exports.ActionRedeem = _redeem2.default;
	exports.ActionRemoveShoppingCart = _removeShoppingCart2.default;
	exports.ActionReorder = _reorder2.default;
	exports.ActionReportProblem = _reportProblem2.default;
	exports.ActionRestorePage = _restorePage2.default;
	exports.ActionRestore = _restore2.default;
	exports.ActionRoom = _room2.default;
	exports.ActionRoundedCorner = _roundedCorner2.default;
	exports.ActionRowing = _rowing2.default;
	exports.ActionSchedule = _schedule2.default;
	exports.ActionSearch = _search2.default;
	exports.ActionSettingsApplications = _settingsApplications2.default;
	exports.ActionSettingsBackupRestore = _settingsBackupRestore2.default;
	exports.ActionSettingsBluetooth = _settingsBluetooth2.default;
	exports.ActionSettingsBrightness = _settingsBrightness2.default;
	exports.ActionSettingsCell = _settingsCell2.default;
	exports.ActionSettingsEthernet = _settingsEthernet2.default;
	exports.ActionSettingsInputAntenna = _settingsInputAntenna2.default;
	exports.ActionSettingsInputComponent = _settingsInputComponent2.default;
	exports.ActionSettingsInputComposite = _settingsInputComposite2.default;
	exports.ActionSettingsInputHdmi = _settingsInputHdmi2.default;
	exports.ActionSettingsInputSvideo = _settingsInputSvideo2.default;
	exports.ActionSettingsOverscan = _settingsOverscan2.default;
	exports.ActionSettingsPhone = _settingsPhone2.default;
	exports.ActionSettingsPower = _settingsPower2.default;
	exports.ActionSettingsRemote = _settingsRemote2.default;
	exports.ActionSettingsVoice = _settingsVoice2.default;
	exports.ActionSettings = _settings2.default;
	exports.ActionShopTwo = _shopTwo2.default;
	exports.ActionShop = _shop2.default;
	exports.ActionShoppingBasket = _shoppingBasket2.default;
	exports.ActionShoppingCart = _shoppingCart2.default;
	exports.ActionSpeakerNotesOff = _speakerNotesOff2.default;
	exports.ActionSpeakerNotes = _speakerNotes2.default;
	exports.ActionSpellcheck = _spellcheck2.default;
	exports.ActionStars = _stars2.default;
	exports.ActionStore = _store2.default;
	exports.ActionSubject = _subject2.default;
	exports.ActionSupervisorAccount = _supervisorAccount2.default;
	exports.ActionSwapHoriz = _swapHoriz2.default;
	exports.ActionSwapVert = _swapVert2.default;
	exports.ActionSwapVerticalCircle = _swapVerticalCircle2.default;
	exports.ActionSystemUpdateAlt = _systemUpdateAlt2.default;
	exports.ActionTabUnselected = _tabUnselected2.default;
	exports.ActionTab = _tab2.default;
	exports.ActionTheaters = _theaters2.default;
	exports.ActionThreeDRotation = _threeDRotation2.default;
	exports.ActionThumbDown = _thumbDown2.default;
	exports.ActionThumbUp = _thumbUp2.default;
	exports.ActionThumbsUpDown = _thumbsUpDown2.default;
	exports.ActionTimeline = _timeline2.default;
	exports.ActionToc = _toc2.default;
	exports.ActionToday = _today2.default;
	exports.ActionToll = _toll2.default;
	exports.ActionTouchApp = _touchApp2.default;
	exports.ActionTrackChanges = _trackChanges2.default;
	exports.ActionTranslate = _translate2.default;
	exports.ActionTrendingDown = _trendingDown2.default;
	exports.ActionTrendingFlat = _trendingFlat2.default;
	exports.ActionTrendingUp = _trendingUp2.default;
	exports.ActionTurnedInNot = _turnedInNot2.default;
	exports.ActionTurnedIn = _turnedIn2.default;
	exports.ActionUpdate = _update2.default;
	exports.ActionVerifiedUser = _verifiedUser2.default;
	exports.ActionViewAgenda = _viewAgenda2.default;
	exports.ActionViewArray = _viewArray2.default;
	exports.ActionViewCarousel = _viewCarousel2.default;
	exports.ActionViewColumn = _viewColumn2.default;
	exports.ActionViewDay = _viewDay2.default;
	exports.ActionViewHeadline = _viewHeadline2.default;
	exports.ActionViewList = _viewList2.default;
	exports.ActionViewModule = _viewModule2.default;
	exports.ActionViewQuilt = _viewQuilt2.default;
	exports.ActionViewStream = _viewStream2.default;
	exports.ActionViewWeek = _viewWeek2.default;
	exports.ActionVisibilityOff = _visibilityOff2.default;
	exports.ActionVisibility = _visibility2.default;
	exports.ActionWatchLater = _watchLater2.default;
	exports.ActionWork = _work2.default;
	exports.ActionYoutubeSearchedFor = _youtubeSearchedFor2.default;
	exports.ActionZoomIn = _zoomIn2.default;
	exports.ActionZoomOut = _zoomOut2.default;
	exports.AlertAddAlert = _addAlert2.default;
	exports.AlertErrorOutline = _errorOutline2.default;
	exports.AlertError = _error2.default;
	exports.AlertWarning = _warning2.default;
	exports.AvAddToQueue = _addToQueue2.default;
	exports.AvAirplay = _airplay2.default;
	exports.AvAlbum = _album2.default;
	exports.AvArtTrack = _artTrack2.default;
	exports.AvAvTimer = _avTimer2.default;
	exports.AvBrandingWatermark = _brandingWatermark2.default;
	exports.AvCallToAction = _callToAction2.default;
	exports.AvClosedCaption = _closedCaption2.default;
	exports.AvEqualizer = _equalizer2.default;
	exports.AvExplicit = _explicit2.default;
	exports.AvFastForward = _fastForward2.default;
	exports.AvFastRewind = _fastRewind2.default;
	exports.AvFeaturedPlayList = _featuredPlayList2.default;
	exports.AvFeaturedVideo = _featuredVideo2.default;
	exports.AvFiberDvr = _fiberDvr2.default;
	exports.AvFiberManualRecord = _fiberManualRecord2.default;
	exports.AvFiberNew = _fiberNew2.default;
	exports.AvFiberPin = _fiberPin2.default;
	exports.AvFiberSmartRecord = _fiberSmartRecord2.default;
	exports.AvForward10 = _forward2.default;
	exports.AvForward30 = _forward4.default;
	exports.AvForward5 = _forward6.default;
	exports.AvGames = _games2.default;
	exports.AvHd = _hd2.default;
	exports.AvHearing = _hearing2.default;
	exports.AvHighQuality = _highQuality2.default;
	exports.AvLibraryAdd = _libraryAdd2.default;
	exports.AvLibraryBooks = _libraryBooks2.default;
	exports.AvLibraryMusic = _libraryMusic2.default;
	exports.AvLoop = _loop2.default;
	exports.AvMicNone = _micNone2.default;
	exports.AvMicOff = _micOff2.default;
	exports.AvMic = _mic2.default;
	exports.AvMovie = _movie2.default;
	exports.AvMusicVideo = _musicVideo2.default;
	exports.AvNewReleases = _newReleases2.default;
	exports.AvNotInterested = _notInterested2.default;
	exports.AvNote = _note2.default;
	exports.AvPauseCircleFilled = _pauseCircleFilled2.default;
	exports.AvPauseCircleOutline = _pauseCircleOutline2.default;
	exports.AvPause = _pause2.default;
	exports.AvPlayArrow = _playArrow2.default;
	exports.AvPlayCircleFilled = _playCircleFilled2.default;
	exports.AvPlayCircleOutline = _playCircleOutline2.default;
	exports.AvPlaylistAddCheck = _playlistAddCheck2.default;
	exports.AvPlaylistAdd = _playlistAdd2.default;
	exports.AvPlaylistPlay = _playlistPlay2.default;
	exports.AvQueueMusic = _queueMusic2.default;
	exports.AvQueuePlayNext = _queuePlayNext2.default;
	exports.AvQueue = _queue2.default;
	exports.AvRadio = _radio2.default;
	exports.AvRecentActors = _recentActors2.default;
	exports.AvRemoveFromQueue = _removeFromQueue2.default;
	exports.AvRepeatOne = _repeatOne2.default;
	exports.AvRepeat = _repeat2.default;
	exports.AvReplay10 = _replay2.default;
	exports.AvReplay30 = _replay4.default;
	exports.AvReplay5 = _replay6.default;
	exports.AvReplay = _replay8.default;
	exports.AvShuffle = _shuffle2.default;
	exports.AvSkipNext = _skipNext2.default;
	exports.AvSkipPrevious = _skipPrevious2.default;
	exports.AvSlowMotionVideo = _slowMotionVideo2.default;
	exports.AvSnooze = _snooze2.default;
	exports.AvSortByAlpha = _sortByAlpha2.default;
	exports.AvStop = _stop2.default;
	exports.AvSubscriptions = _subscriptions2.default;
	exports.AvSubtitles = _subtitles2.default;
	exports.AvSurroundSound = _surroundSound2.default;
	exports.AvVideoCall = _videoCall2.default;
	exports.AvVideoLabel = _videoLabel2.default;
	exports.AvVideoLibrary = _videoLibrary2.default;
	exports.AvVideocamOff = _videocamOff2.default;
	exports.AvVideocam = _videocam2.default;
	exports.AvVolumeDown = _volumeDown2.default;
	exports.AvVolumeMute = _volumeMute2.default;
	exports.AvVolumeOff = _volumeOff2.default;
	exports.AvVolumeUp = _volumeUp2.default;
	exports.AvWebAsset = _webAsset2.default;
	exports.AvWeb = _web2.default;
	exports.CommunicationBusiness = _business2.default;
	exports.CommunicationCallEnd = _callEnd2.default;
	exports.CommunicationCallMade = _callMade2.default;
	exports.CommunicationCallMerge = _callMerge2.default;
	exports.CommunicationCallMissedOutgoing = _callMissedOutgoing2.default;
	exports.CommunicationCallMissed = _callMissed2.default;
	exports.CommunicationCallReceived = _callReceived2.default;
	exports.CommunicationCallSplit = _callSplit2.default;
	exports.CommunicationCall = _call2.default;
	exports.CommunicationChatBubbleOutline = _chatBubbleOutline2.default;
	exports.CommunicationChatBubble = _chatBubble2.default;
	exports.CommunicationChat = _chat2.default;
	exports.CommunicationClearAll = _clearAll2.default;
	exports.CommunicationComment = _comment2.default;
	exports.CommunicationContactMail = _contactMail2.default;
	exports.CommunicationContactPhone = _contactPhone2.default;
	exports.CommunicationContacts = _contacts2.default;
	exports.CommunicationDialerSip = _dialerSip2.default;
	exports.CommunicationDialpad = _dialpad2.default;
	exports.CommunicationEmail = _email2.default;
	exports.CommunicationForum = _forum2.default;
	exports.CommunicationImportContacts = _importContacts2.default;
	exports.CommunicationImportExport = _importExport2.default;
	exports.CommunicationInvertColorsOff = _invertColorsOff2.default;
	exports.CommunicationLiveHelp = _liveHelp2.default;
	exports.CommunicationLocationOff = _locationOff2.default;
	exports.CommunicationLocationOn = _locationOn2.default;
	exports.CommunicationMailOutline = _mailOutline2.default;
	exports.CommunicationMessage = _message2.default;
	exports.CommunicationNoSim = _noSim2.default;
	exports.CommunicationPhone = _phone2.default;
	exports.CommunicationPhonelinkErase = _phonelinkErase2.default;
	exports.CommunicationPhonelinkLock = _phonelinkLock2.default;
	exports.CommunicationPhonelinkRing = _phonelinkRing2.default;
	exports.CommunicationPhonelinkSetup = _phonelinkSetup2.default;
	exports.CommunicationPortableWifiOff = _portableWifiOff2.default;
	exports.CommunicationPresentToAll = _presentToAll2.default;
	exports.CommunicationRingVolume = _ringVolume2.default;
	exports.CommunicationRssFeed = _rssFeed2.default;
	exports.CommunicationScreenShare = _screenShare2.default;
	exports.CommunicationSpeakerPhone = _speakerPhone2.default;
	exports.CommunicationStayCurrentLandscape = _stayCurrentLandscape2.default;
	exports.CommunicationStayCurrentPortrait = _stayCurrentPortrait2.default;
	exports.CommunicationStayPrimaryLandscape = _stayPrimaryLandscape2.default;
	exports.CommunicationStayPrimaryPortrait = _stayPrimaryPortrait2.default;
	exports.CommunicationStopScreenShare = _stopScreenShare2.default;
	exports.CommunicationSwapCalls = _swapCalls2.default;
	exports.CommunicationTextsms = _textsms2.default;
	exports.CommunicationVoicemail = _voicemail2.default;
	exports.CommunicationVpnKey = _vpnKey2.default;
	exports.ContentAddBox = _addBox2.default;
	exports.ContentAddCircleOutline = _addCircleOutline2.default;
	exports.ContentAddCircle = _addCircle2.default;
	exports.ContentAdd = _add2.default;
	exports.ContentArchive = _archive2.default;
	exports.ContentBackspace = _backspace2.default;
	exports.ContentBlock = _block2.default;
	exports.ContentClear = _clear2.default;
	exports.ContentContentCopy = _contentCopy2.default;
	exports.ContentContentCut = _contentCut2.default;
	exports.ContentContentPaste = _contentPaste2.default;
	exports.ContentCreate = _create2.default;
	exports.ContentDeleteSweep = _deleteSweep2.default;
	exports.ContentDrafts = _drafts2.default;
	exports.ContentFilterList = _filterList2.default;
	exports.ContentFlag = _flag2.default;
	exports.ContentFontDownload = _fontDownload2.default;
	exports.ContentForward = _forward8.default;
	exports.ContentGesture = _gesture2.default;
	exports.ContentInbox = _inbox2.default;
	exports.ContentLink = _link2.default;
	exports.ContentLowPriority = _lowPriority2.default;
	exports.ContentMail = _mail2.default;
	exports.ContentMarkunread = _markunread2.default;
	exports.ContentMoveToInbox = _moveToInbox2.default;
	exports.ContentNextWeek = _nextWeek2.default;
	exports.ContentRedo = _redo2.default;
	exports.ContentRemoveCircleOutline = _removeCircleOutline2.default;
	exports.ContentRemoveCircle = _removeCircle2.default;
	exports.ContentRemove = _remove2.default;
	exports.ContentReplyAll = _replyAll2.default;
	exports.ContentReply = _reply2.default;
	exports.ContentReport = _report2.default;
	exports.ContentSave = _save2.default;
	exports.ContentSelectAll = _selectAll2.default;
	exports.ContentSend = _send2.default;
	exports.ContentSort = _sort2.default;
	exports.ContentTextFormat = _textFormat2.default;
	exports.ContentUnarchive = _unarchive2.default;
	exports.ContentUndo = _undo2.default;
	exports.ContentWeekend = _weekend2.default;
	exports.DeviceAccessAlarm = _accessAlarm2.default;
	exports.DeviceAccessAlarms = _accessAlarms2.default;
	exports.DeviceAccessTime = _accessTime2.default;
	exports.DeviceAddAlarm = _addAlarm2.default;
	exports.DeviceAirplanemodeActive = _airplanemodeActive2.default;
	exports.DeviceAirplanemodeInactive = _airplanemodeInactive2.default;
	exports.DeviceBattery20 = _battery2.default;
	exports.DeviceBattery30 = _battery4.default;
	exports.DeviceBattery50 = _battery6.default;
	exports.DeviceBattery60 = _battery8.default;
	exports.DeviceBattery80 = _battery10.default;
	exports.DeviceBattery90 = _battery12.default;
	exports.DeviceBatteryAlert = _batteryAlert2.default;
	exports.DeviceBatteryCharging20 = _batteryCharging2.default;
	exports.DeviceBatteryCharging30 = _batteryCharging4.default;
	exports.DeviceBatteryCharging50 = _batteryCharging6.default;
	exports.DeviceBatteryCharging60 = _batteryCharging8.default;
	exports.DeviceBatteryCharging80 = _batteryCharging10.default;
	exports.DeviceBatteryCharging90 = _batteryCharging12.default;
	exports.DeviceBatteryChargingFull = _batteryChargingFull2.default;
	exports.DeviceBatteryFull = _batteryFull2.default;
	exports.DeviceBatteryStd = _batteryStd2.default;
	exports.DeviceBatteryUnknown = _batteryUnknown2.default;
	exports.DeviceBluetoothConnected = _bluetoothConnected2.default;
	exports.DeviceBluetoothDisabled = _bluetoothDisabled2.default;
	exports.DeviceBluetoothSearching = _bluetoothSearching2.default;
	exports.DeviceBluetooth = _bluetooth2.default;
	exports.DeviceBrightnessAuto = _brightnessAuto2.default;
	exports.DeviceBrightnessHigh = _brightnessHigh2.default;
	exports.DeviceBrightnessLow = _brightnessLow2.default;
	exports.DeviceBrightnessMedium = _brightnessMedium2.default;
	exports.DeviceDataUsage = _dataUsage2.default;
	exports.DeviceDeveloperMode = _developerMode2.default;
	exports.DeviceDevices = _devices2.default;
	exports.DeviceDvr = _dvr2.default;
	exports.DeviceGpsFixed = _gpsFixed2.default;
	exports.DeviceGpsNotFixed = _gpsNotFixed2.default;
	exports.DeviceGpsOff = _gpsOff2.default;
	exports.DeviceGraphicEq = _graphicEq2.default;
	exports.DeviceLocationDisabled = _locationDisabled2.default;
	exports.DeviceLocationSearching = _locationSearching2.default;
	exports.DeviceNetworkCell = _networkCell2.default;
	exports.DeviceNetworkWifi = _networkWifi2.default;
	exports.DeviceNfc = _nfc2.default;
	exports.DeviceScreenLockLandscape = _screenLockLandscape2.default;
	exports.DeviceScreenLockPortrait = _screenLockPortrait2.default;
	exports.DeviceScreenLockRotation = _screenLockRotation2.default;
	exports.DeviceScreenRotation = _screenRotation2.default;
	exports.DeviceSdStorage = _sdStorage2.default;
	exports.DeviceSettingsSystemDaydream = _settingsSystemDaydream2.default;
	exports.DeviceSignalCellular0Bar = _signalCellular0Bar2.default;
	exports.DeviceSignalCellular1Bar = _signalCellular1Bar2.default;
	exports.DeviceSignalCellular2Bar = _signalCellular2Bar2.default;
	exports.DeviceSignalCellular3Bar = _signalCellular3Bar2.default;
	exports.DeviceSignalCellular4Bar = _signalCellular4Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet0Bar = _signalCellularConnectedNoInternet0Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet1Bar = _signalCellularConnectedNoInternet1Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet2Bar = _signalCellularConnectedNoInternet2Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet3Bar = _signalCellularConnectedNoInternet3Bar2.default;
	exports.DeviceSignalCellularConnectedNoInternet4Bar = _signalCellularConnectedNoInternet4Bar2.default;
	exports.DeviceSignalCellularNoSim = _signalCellularNoSim2.default;
	exports.DeviceSignalCellularNull = _signalCellularNull2.default;
	exports.DeviceSignalCellularOff = _signalCellularOff2.default;
	exports.DeviceSignalWifi0Bar = _signalWifi0Bar2.default;
	exports.DeviceSignalWifi1BarLock = _signalWifi1BarLock2.default;
	exports.DeviceSignalWifi1Bar = _signalWifi1Bar2.default;
	exports.DeviceSignalWifi2BarLock = _signalWifi2BarLock2.default;
	exports.DeviceSignalWifi2Bar = _signalWifi2Bar2.default;
	exports.DeviceSignalWifi3BarLock = _signalWifi3BarLock2.default;
	exports.DeviceSignalWifi3Bar = _signalWifi3Bar2.default;
	exports.DeviceSignalWifi4BarLock = _signalWifi4BarLock2.default;
	exports.DeviceSignalWifi4Bar = _signalWifi4Bar2.default;
	exports.DeviceSignalWifiOff = _signalWifiOff2.default;
	exports.DeviceStorage = _storage2.default;
	exports.DeviceUsb = _usb2.default;
	exports.DeviceWallpaper = _wallpaper2.default;
	exports.DeviceWidgets = _widgets2.default;
	exports.DeviceWifiLock = _wifiLock2.default;
	exports.DeviceWifiTethering = _wifiTethering2.default;
	exports.EditorAttachFile = _attachFile2.default;
	exports.EditorAttachMoney = _attachMoney2.default;
	exports.EditorBorderAll = _borderAll2.default;
	exports.EditorBorderBottom = _borderBottom2.default;
	exports.EditorBorderClear = _borderClear2.default;
	exports.EditorBorderColor = _borderColor2.default;
	exports.EditorBorderHorizontal = _borderHorizontal2.default;
	exports.EditorBorderInner = _borderInner2.default;
	exports.EditorBorderLeft = _borderLeft2.default;
	exports.EditorBorderOuter = _borderOuter2.default;
	exports.EditorBorderRight = _borderRight2.default;
	exports.EditorBorderStyle = _borderStyle2.default;
	exports.EditorBorderTop = _borderTop2.default;
	exports.EditorBorderVertical = _borderVertical2.default;
	exports.EditorBubbleChart = _bubbleChart2.default;
	exports.EditorDragHandle = _dragHandle2.default;
	exports.EditorFormatAlignCenter = _formatAlignCenter2.default;
	exports.EditorFormatAlignJustify = _formatAlignJustify2.default;
	exports.EditorFormatAlignLeft = _formatAlignLeft2.default;
	exports.EditorFormatAlignRight = _formatAlignRight2.default;
	exports.EditorFormatBold = _formatBold2.default;
	exports.EditorFormatClear = _formatClear2.default;
	exports.EditorFormatColorFill = _formatColorFill2.default;
	exports.EditorFormatColorReset = _formatColorReset2.default;
	exports.EditorFormatColorText = _formatColorText2.default;
	exports.EditorFormatIndentDecrease = _formatIndentDecrease2.default;
	exports.EditorFormatIndentIncrease = _formatIndentIncrease2.default;
	exports.EditorFormatItalic = _formatItalic2.default;
	exports.EditorFormatLineSpacing = _formatLineSpacing2.default;
	exports.EditorFormatListBulleted = _formatListBulleted2.default;
	exports.EditorFormatListNumbered = _formatListNumbered2.default;
	exports.EditorFormatPaint = _formatPaint2.default;
	exports.EditorFormatQuote = _formatQuote2.default;
	exports.EditorFormatShapes = _formatShapes2.default;
	exports.EditorFormatSize = _formatSize2.default;
	exports.EditorFormatStrikethrough = _formatStrikethrough2.default;
	exports.EditorFormatTextdirectionLToR = _formatTextdirectionLToR2.default;
	exports.EditorFormatTextdirectionRToL = _formatTextdirectionRToL2.default;
	exports.EditorFormatUnderlined = _formatUnderlined2.default;
	exports.EditorFunctions = _functions2.default;
	exports.EditorHighlight = _highlight2.default;
	exports.EditorInsertChart = _insertChart2.default;
	exports.EditorInsertComment = _insertComment2.default;
	exports.EditorInsertDriveFile = _insertDriveFile2.default;
	exports.EditorInsertEmoticon = _insertEmoticon2.default;
	exports.EditorInsertInvitation = _insertInvitation2.default;
	exports.EditorInsertLink = _insertLink2.default;
	exports.EditorInsertPhoto = _insertPhoto2.default;
	exports.EditorLinearScale = _linearScale2.default;
	exports.EditorMergeType = _mergeType2.default;
	exports.EditorModeComment = _modeComment2.default;
	exports.EditorModeEdit = _modeEdit2.default;
	exports.EditorMonetizationOn = _monetizationOn2.default;
	exports.EditorMoneyOff = _moneyOff2.default;
	exports.EditorMultilineChart = _multilineChart2.default;
	exports.EditorPieChartOutlined = _pieChartOutlined2.default;
	exports.EditorPieChart = _pieChart2.default;
	exports.EditorPublish = _publish2.default;
	exports.EditorShortText = _shortText2.default;
	exports.EditorShowChart = _showChart2.default;
	exports.EditorSpaceBar = _spaceBar2.default;
	exports.EditorStrikethroughS = _strikethroughS2.default;
	exports.EditorTextFields = _textFields2.default;
	exports.EditorTitle = _title2.default;
	exports.EditorVerticalAlignBottom = _verticalAlignBottom2.default;
	exports.EditorVerticalAlignCenter = _verticalAlignCenter2.default;
	exports.EditorVerticalAlignTop = _verticalAlignTop2.default;
	exports.EditorWrapText = _wrapText2.default;
	exports.FileAttachment = _attachment2.default;
	exports.FileCloudCircle = _cloudCircle2.default;
	exports.FileCloudDone = _cloudDone2.default;
	exports.FileCloudDownload = _cloudDownload2.default;
	exports.FileCloudOff = _cloudOff2.default;
	exports.FileCloudQueue = _cloudQueue2.default;
	exports.FileCloudUpload = _cloudUpload2.default;
	exports.FileCloud = _cloud2.default;
	exports.FileCreateNewFolder = _createNewFolder2.default;
	exports.FileFileDownload = _fileDownload2.default;
	exports.FileFileUpload = _fileUpload2.default;
	exports.FileFolderOpen = _folderOpen2.default;
	exports.FileFolderShared = _folderShared2.default;
	exports.FileFolder = _folder2.default;
	exports.HardwareCastConnected = _castConnected2.default;
	exports.HardwareCast = _cast2.default;
	exports.HardwareComputer = _computer2.default;
	exports.HardwareDesktopMac = _desktopMac2.default;
	exports.HardwareDesktopWindows = _desktopWindows2.default;
	exports.HardwareDeveloperBoard = _developerBoard2.default;
	exports.HardwareDeviceHub = _deviceHub2.default;
	exports.HardwareDevicesOther = _devicesOther2.default;
	exports.HardwareDock = _dock2.default;
	exports.HardwareGamepad = _gamepad2.default;
	exports.HardwareHeadsetMic = _headsetMic2.default;
	exports.HardwareHeadset = _headset2.default;
	exports.HardwareKeyboardArrowDown = _keyboardArrowDown2.default;
	exports.HardwareKeyboardArrowLeft = _keyboardArrowLeft2.default;
	exports.HardwareKeyboardArrowRight = _keyboardArrowRight2.default;
	exports.HardwareKeyboardArrowUp = _keyboardArrowUp2.default;
	exports.HardwareKeyboardBackspace = _keyboardBackspace2.default;
	exports.HardwareKeyboardCapslock = _keyboardCapslock2.default;
	exports.HardwareKeyboardHide = _keyboardHide2.default;
	exports.HardwareKeyboardReturn = _keyboardReturn2.default;
	exports.HardwareKeyboardTab = _keyboardTab2.default;
	exports.HardwareKeyboardVoice = _keyboardVoice2.default;
	exports.HardwareKeyboard = _keyboard2.default;
	exports.HardwareLaptopChromebook = _laptopChromebook2.default;
	exports.HardwareLaptopMac = _laptopMac2.default;
	exports.HardwareLaptopWindows = _laptopWindows2.default;
	exports.HardwareLaptop = _laptop2.default;
	exports.HardwareMemory = _memory2.default;
	exports.HardwareMouse = _mouse2.default;
	exports.HardwarePhoneAndroid = _phoneAndroid2.default;
	exports.HardwarePhoneIphone = _phoneIphone2.default;
	exports.HardwarePhonelinkOff = _phonelinkOff2.default;
	exports.HardwarePhonelink = _phonelink2.default;
	exports.HardwarePowerInput = _powerInput2.default;
	exports.HardwareRouter = _router2.default;
	exports.HardwareScanner = _scanner2.default;
	exports.HardwareSecurity = _security2.default;
	exports.HardwareSimCard = _simCard2.default;
	exports.HardwareSmartphone = _smartphone2.default;
	exports.HardwareSpeakerGroup = _speakerGroup2.default;
	exports.HardwareSpeaker = _speaker2.default;
	exports.HardwareTabletAndroid = _tabletAndroid2.default;
	exports.HardwareTabletMac = _tabletMac2.default;
	exports.HardwareTablet = _tablet2.default;
	exports.HardwareToys = _toys2.default;
	exports.HardwareTv = _tv2.default;
	exports.HardwareVideogameAsset = _videogameAsset2.default;
	exports.HardwareWatch = _watch2.default;
	exports.ImageAddAPhoto = _addAPhoto2.default;
	exports.ImageAddToPhotos = _addToPhotos2.default;
	exports.ImageAdjust = _adjust2.default;
	exports.ImageAssistantPhoto = _assistantPhoto2.default;
	exports.ImageAssistant = _assistant2.default;
	exports.ImageAudiotrack = _audiotrack2.default;
	exports.ImageBlurCircular = _blurCircular2.default;
	exports.ImageBlurLinear = _blurLinear2.default;
	exports.ImageBlurOff = _blurOff2.default;
	exports.ImageBlurOn = _blurOn2.default;
	exports.ImageBrightness1 = _brightness2.default;
	exports.ImageBrightness2 = _brightness4.default;
	exports.ImageBrightness3 = _brightness6.default;
	exports.ImageBrightness4 = _brightness8.default;
	exports.ImageBrightness5 = _brightness10.default;
	exports.ImageBrightness6 = _brightness12.default;
	exports.ImageBrightness7 = _brightness14.default;
	exports.ImageBrokenImage = _brokenImage2.default;
	exports.ImageBrush = _brush2.default;
	exports.ImageBurstMode = _burstMode2.default;
	exports.ImageCameraAlt = _cameraAlt2.default;
	exports.ImageCameraFront = _cameraFront2.default;
	exports.ImageCameraRear = _cameraRear2.default;
	exports.ImageCameraRoll = _cameraRoll2.default;
	exports.ImageCamera = _camera2.default;
	exports.ImageCenterFocusStrong = _centerFocusStrong2.default;
	exports.ImageCenterFocusWeak = _centerFocusWeak2.default;
	exports.ImageCollectionsBookmark = _collectionsBookmark2.default;
	exports.ImageCollections = _collections2.default;
	exports.ImageColorLens = _colorLens2.default;
	exports.ImageColorize = _colorize2.default;
	exports.ImageCompare = _compare2.default;
	exports.ImageControlPointDuplicate = _controlPointDuplicate2.default;
	exports.ImageControlPoint = _controlPoint2.default;
	exports.ImageCrop169 = _crop2.default;
	exports.ImageCrop32 = _crop4.default;
	exports.ImageCrop54 = _crop6.default;
	exports.ImageCrop75 = _crop8.default;
	exports.ImageCropDin = _cropDin2.default;
	exports.ImageCropFree = _cropFree2.default;
	exports.ImageCropLandscape = _cropLandscape2.default;
	exports.ImageCropOriginal = _cropOriginal2.default;
	exports.ImageCropPortrait = _cropPortrait2.default;
	exports.ImageCropRotate = _cropRotate2.default;
	exports.ImageCropSquare = _cropSquare2.default;
	exports.ImageCrop = _crop10.default;
	exports.ImageDehaze = _dehaze2.default;
	exports.ImageDetails = _details2.default;
	exports.ImageEdit = _edit2.default;
	exports.ImageExposureNeg1 = _exposureNeg2.default;
	exports.ImageExposureNeg2 = _exposureNeg4.default;
	exports.ImageExposurePlus1 = _exposurePlus2.default;
	exports.ImageExposurePlus2 = _exposurePlus4.default;
	exports.ImageExposureZero = _exposureZero2.default;
	exports.ImageExposure = _exposure2.default;
	exports.ImageFilter1 = _filter2.default;
	exports.ImageFilter2 = _filter4.default;
	exports.ImageFilter3 = _filter6.default;
	exports.ImageFilter4 = _filter8.default;
	exports.ImageFilter5 = _filter10.default;
	exports.ImageFilter6 = _filter12.default;
	exports.ImageFilter7 = _filter14.default;
	exports.ImageFilter8 = _filter16.default;
	exports.ImageFilter9Plus = _filter9Plus2.default;
	exports.ImageFilter9 = _filter18.default;
	exports.ImageFilterBAndW = _filterBAndW2.default;
	exports.ImageFilterCenterFocus = _filterCenterFocus2.default;
	exports.ImageFilterDrama = _filterDrama2.default;
	exports.ImageFilterFrames = _filterFrames2.default;
	exports.ImageFilterHdr = _filterHdr2.default;
	exports.ImageFilterNone = _filterNone2.default;
	exports.ImageFilterTiltShift = _filterTiltShift2.default;
	exports.ImageFilterVintage = _filterVintage2.default;
	exports.ImageFilter = _filter20.default;
	exports.ImageFlare = _flare2.default;
	exports.ImageFlashAuto = _flashAuto2.default;
	exports.ImageFlashOff = _flashOff2.default;
	exports.ImageFlashOn = _flashOn2.default;
	exports.ImageFlip = _flip2.default;
	exports.ImageGradient = _gradient2.default;
	exports.ImageGrain = _grain2.default;
	exports.ImageGridOff = _gridOff2.default;
	exports.ImageGridOn = _gridOn2.default;
	exports.ImageHdrOff = _hdrOff2.default;
	exports.ImageHdrOn = _hdrOn2.default;
	exports.ImageHdrStrong = _hdrStrong2.default;
	exports.ImageHdrWeak = _hdrWeak2.default;
	exports.ImageHealing = _healing2.default;
	exports.ImageImageAspectRatio = _imageAspectRatio2.default;
	exports.ImageImage = _image2.default;
	exports.ImageIso = _iso2.default;
	exports.ImageLandscape = _landscape2.default;
	exports.ImageLeakAdd = _leakAdd2.default;
	exports.ImageLeakRemove = _leakRemove2.default;
	exports.ImageLens = _lens2.default;
	exports.ImageLinkedCamera = _linkedCamera2.default;
	exports.ImageLooks3 = _looks2.default;
	exports.ImageLooks4 = _looks4.default;
	exports.ImageLooks5 = _looks6.default;
	exports.ImageLooks6 = _looks8.default;
	exports.ImageLooksOne = _looksOne2.default;
	exports.ImageLooksTwo = _looksTwo2.default;
	exports.ImageLooks = _looks10.default;
	exports.ImageLoupe = _loupe2.default;
	exports.ImageMonochromePhotos = _monochromePhotos2.default;
	exports.ImageMovieCreation = _movieCreation2.default;
	exports.ImageMovieFilter = _movieFilter2.default;
	exports.ImageMusicNote = _musicNote2.default;
	exports.ImageNaturePeople = _naturePeople2.default;
	exports.ImageNature = _nature2.default;
	exports.ImageNavigateBefore = _navigateBefore2.default;
	exports.ImageNavigateNext = _navigateNext2.default;
	exports.ImagePalette = _palette2.default;
	exports.ImagePanoramaFishEye = _panoramaFishEye2.default;
	exports.ImagePanoramaHorizontal = _panoramaHorizontal2.default;
	exports.ImagePanoramaVertical = _panoramaVertical2.default;
	exports.ImagePanoramaWideAngle = _panoramaWideAngle2.default;
	exports.ImagePanorama = _panorama2.default;
	exports.ImagePhotoAlbum = _photoAlbum2.default;
	exports.ImagePhotoCamera = _photoCamera2.default;
	exports.ImagePhotoFilter = _photoFilter2.default;
	exports.ImagePhotoLibrary = _photoLibrary2.default;
	exports.ImagePhotoSizeSelectActual = _photoSizeSelectActual2.default;
	exports.ImagePhotoSizeSelectLarge = _photoSizeSelectLarge2.default;
	exports.ImagePhotoSizeSelectSmall = _photoSizeSelectSmall2.default;
	exports.ImagePhoto = _photo2.default;
	exports.ImagePictureAsPdf = _pictureAsPdf2.default;
	exports.ImagePortrait = _portrait2.default;
	exports.ImageRemoveRedEye = _removeRedEye2.default;
	exports.ImageRotate90DegreesCcw = _rotate90DegreesCcw2.default;
	exports.ImageRotateLeft = _rotateLeft2.default;
	exports.ImageRotateRight = _rotateRight2.default;
	exports.ImageSlideshow = _slideshow2.default;
	exports.ImageStraighten = _straighten2.default;
	exports.ImageStyle = _style2.default;
	exports.ImageSwitchCamera = _switchCamera2.default;
	exports.ImageSwitchVideo = _switchVideo2.default;
	exports.ImageTagFaces = _tagFaces2.default;
	exports.ImageTexture = _texture2.default;
	exports.ImageTimelapse = _timelapse2.default;
	exports.ImageTimer10 = _timer2.default;
	exports.ImageTimer3 = _timer4.default;
	exports.ImageTimerOff = _timerOff2.default;
	exports.ImageTimer = _timer6.default;
	exports.ImageTonality = _tonality2.default;
	exports.ImageTransform = _transform2.default;
	exports.ImageTune = _tune2.default;
	exports.ImageViewComfy = _viewComfy2.default;
	exports.ImageViewCompact = _viewCompact2.default;
	exports.ImageVignette = _vignette2.default;
	exports.ImageWbAuto = _wbAuto2.default;
	exports.ImageWbCloudy = _wbCloudy2.default;
	exports.ImageWbIncandescent = _wbIncandescent2.default;
	exports.ImageWbIridescent = _wbIridescent2.default;
	exports.ImageWbSunny = _wbSunny2.default;
	exports.MapsAddLocation = _addLocation2.default;
	exports.MapsBeenhere = _beenhere2.default;
	exports.MapsDirectionsBike = _directionsBike2.default;
	exports.MapsDirectionsBoat = _directionsBoat2.default;
	exports.MapsDirectionsBus = _directionsBus2.default;
	exports.MapsDirectionsCar = _directionsCar2.default;
	exports.MapsDirectionsRailway = _directionsRailway2.default;
	exports.MapsDirectionsRun = _directionsRun2.default;
	exports.MapsDirectionsSubway = _directionsSubway2.default;
	exports.MapsDirectionsTransit = _directionsTransit2.default;
	exports.MapsDirectionsWalk = _directionsWalk2.default;
	exports.MapsDirections = _directions2.default;
	exports.MapsEditLocation = _editLocation2.default;
	exports.MapsEvStation = _evStation2.default;
	exports.MapsFlight = _flight2.default;
	exports.MapsHotel = _hotel2.default;
	exports.MapsLayersClear = _layersClear2.default;
	exports.MapsLayers = _layers2.default;
	exports.MapsLocalActivity = _localActivity2.default;
	exports.MapsLocalAirport = _localAirport2.default;
	exports.MapsLocalAtm = _localAtm2.default;
	exports.MapsLocalBar = _localBar2.default;
	exports.MapsLocalCafe = _localCafe2.default;
	exports.MapsLocalCarWash = _localCarWash2.default;
	exports.MapsLocalConvenienceStore = _localConvenienceStore2.default;
	exports.MapsLocalDining = _localDining2.default;
	exports.MapsLocalDrink = _localDrink2.default;
	exports.MapsLocalFlorist = _localFlorist2.default;
	exports.MapsLocalGasStation = _localGasStation2.default;
	exports.MapsLocalGroceryStore = _localGroceryStore2.default;
	exports.MapsLocalHospital = _localHospital2.default;
	exports.MapsLocalHotel = _localHotel2.default;
	exports.MapsLocalLaundryService = _localLaundryService2.default;
	exports.MapsLocalLibrary = _localLibrary2.default;
	exports.MapsLocalMall = _localMall2.default;
	exports.MapsLocalMovies = _localMovies2.default;
	exports.MapsLocalOffer = _localOffer2.default;
	exports.MapsLocalParking = _localParking2.default;
	exports.MapsLocalPharmacy = _localPharmacy2.default;
	exports.MapsLocalPhone = _localPhone2.default;
	exports.MapsLocalPizza = _localPizza2.default;
	exports.MapsLocalPlay = _localPlay2.default;
	exports.MapsLocalPostOffice = _localPostOffice2.default;
	exports.MapsLocalPrintshop = _localPrintshop2.default;
	exports.MapsLocalSee = _localSee2.default;
	exports.MapsLocalShipping = _localShipping2.default;
	exports.MapsLocalTaxi = _localTaxi2.default;
	exports.MapsMap = _map2.default;
	exports.MapsMyLocation = _myLocation2.default;
	exports.MapsNavigation = _navigation2.default;
	exports.MapsNearMe = _nearMe2.default;
	exports.MapsPersonPinCircle = _personPinCircle2.default;
	exports.MapsPersonPin = _personPin2.default;
	exports.MapsPinDrop = _pinDrop2.default;
	exports.MapsPlace = _place2.default;
	exports.MapsRateReview = _rateReview2.default;
	exports.MapsRestaurantMenu = _restaurantMenu2.default;
	exports.MapsRestaurant = _restaurant2.default;
	exports.MapsSatellite = _satellite2.default;
	exports.MapsStoreMallDirectory = _storeMallDirectory2.default;
	exports.MapsStreetview = _streetview2.default;
	exports.MapsSubway = _subway2.default;
	exports.MapsTerrain = _terrain2.default;
	exports.MapsTraffic = _traffic2.default;
	exports.MapsTrain = _train2.default;
	exports.MapsTram = _tram2.default;
	exports.MapsTransferWithinAStation = _transferWithinAStation2.default;
	exports.MapsZoomOutMap = _zoomOutMap2.default;
	exports.NavigationApps = _apps2.default;
	exports.NavigationArrowBack = _arrowBack2.default;
	exports.NavigationArrowDownward = _arrowDownward2.default;
	exports.NavigationArrowDropDownCircle = _arrowDropDownCircle2.default;
	exports.NavigationArrowDropDown = _arrowDropDown2.default;
	exports.NavigationArrowDropUp = _arrowDropUp2.default;
	exports.NavigationArrowForward = _arrowForward2.default;
	exports.NavigationArrowUpward = _arrowUpward2.default;
	exports.NavigationCancel = _cancel2.default;
	exports.NavigationCheck = _check2.default;
	exports.NavigationChevronLeft = _chevronLeft2.default;
	exports.NavigationChevronRight = _chevronRight2.default;
	exports.NavigationClose = _close2.default;
	exports.NavigationExpandLess = _expandLess2.default;
	exports.NavigationExpandMore = _expandMore2.default;
	exports.NavigationFirstPage = _firstPage2.default;
	exports.NavigationFullscreenExit = _fullscreenExit2.default;
	exports.NavigationFullscreen = _fullscreen2.default;
	exports.NavigationLastPage = _lastPage2.default;
	exports.NavigationMenu = _menu2.default;
	exports.NavigationMoreHoriz = _moreHoriz2.default;
	exports.NavigationMoreVert = _moreVert2.default;
	exports.NavigationRefresh = _refresh2.default;
	exports.NavigationSubdirectoryArrowLeft = _subdirectoryArrowLeft2.default;
	exports.NavigationSubdirectoryArrowRight = _subdirectoryArrowRight2.default;
	exports.NavigationUnfoldLess = _unfoldLess2.default;
	exports.NavigationUnfoldMore = _unfoldMore2.default;
	exports.NavigationArrowDropRight = _navigationArrowDropRight2.default;
	exports.NotificationAdb = _adb2.default;
	exports.NotificationAirlineSeatFlatAngled = _airlineSeatFlatAngled2.default;
	exports.NotificationAirlineSeatFlat = _airlineSeatFlat2.default;
	exports.NotificationAirlineSeatIndividualSuite = _airlineSeatIndividualSuite2.default;
	exports.NotificationAirlineSeatLegroomExtra = _airlineSeatLegroomExtra2.default;
	exports.NotificationAirlineSeatLegroomNormal = _airlineSeatLegroomNormal2.default;
	exports.NotificationAirlineSeatLegroomReduced = _airlineSeatLegroomReduced2.default;
	exports.NotificationAirlineSeatReclineExtra = _airlineSeatReclineExtra2.default;
	exports.NotificationAirlineSeatReclineNormal = _airlineSeatReclineNormal2.default;
	exports.NotificationBluetoothAudio = _bluetoothAudio2.default;
	exports.NotificationConfirmationNumber = _confirmationNumber2.default;
	exports.NotificationDiscFull = _discFull2.default;
	exports.NotificationDoNotDisturbAlt = _doNotDisturbAlt2.default;
	exports.NotificationDoNotDisturbOff = _doNotDisturbOff2.default;
	exports.NotificationDoNotDisturbOn = _doNotDisturbOn2.default;
	exports.NotificationDoNotDisturb = _doNotDisturb2.default;
	exports.NotificationDriveEta = _driveEta2.default;
	exports.NotificationEnhancedEncryption = _enhancedEncryption2.default;
	exports.NotificationEventAvailable = _eventAvailable2.default;
	exports.NotificationEventBusy = _eventBusy2.default;
	exports.NotificationEventNote = _eventNote2.default;
	exports.NotificationFolderSpecial = _folderSpecial2.default;
	exports.NotificationLiveTv = _liveTv2.default;
	exports.NotificationMms = _mms2.default;
	exports.NotificationMore = _more2.default;
	exports.NotificationNetworkCheck = _networkCheck2.default;
	exports.NotificationNetworkLocked = _networkLocked2.default;
	exports.NotificationNoEncryption = _noEncryption2.default;
	exports.NotificationOndemandVideo = _ondemandVideo2.default;
	exports.NotificationPersonalVideo = _personalVideo2.default;
	exports.NotificationPhoneBluetoothSpeaker = _phoneBluetoothSpeaker2.default;
	exports.NotificationPhoneForwarded = _phoneForwarded2.default;
	exports.NotificationPhoneInTalk = _phoneInTalk2.default;
	exports.NotificationPhoneLocked = _phoneLocked2.default;
	exports.NotificationPhoneMissed = _phoneMissed2.default;
	exports.NotificationPhonePaused = _phonePaused2.default;
	exports.NotificationPower = _power2.default;
	exports.NotificationPriorityHigh = _priorityHigh2.default;
	exports.NotificationRvHookup = _rvHookup2.default;
	exports.NotificationSdCard = _sdCard2.default;
	exports.NotificationSimCardAlert = _simCardAlert2.default;
	exports.NotificationSmsFailed = _smsFailed2.default;
	exports.NotificationSms = _sms2.default;
	exports.NotificationSyncDisabled = _syncDisabled2.default;
	exports.NotificationSyncProblem = _syncProblem2.default;
	exports.NotificationSync = _sync2.default;
	exports.NotificationSystemUpdate = _systemUpdate2.default;
	exports.NotificationTapAndPlay = _tapAndPlay2.default;
	exports.NotificationTimeToLeave = _timeToLeave2.default;
	exports.NotificationVibration = _vibration2.default;
	exports.NotificationVoiceChat = _voiceChat2.default;
	exports.NotificationVpnLock = _vpnLock2.default;
	exports.NotificationWc = _wc2.default;
	exports.NotificationWifi = _wifi2.default;
	exports.PlacesAcUnit = _acUnit2.default;
	exports.PlacesAirportShuttle = _airportShuttle2.default;
	exports.PlacesAllInclusive = _allInclusive2.default;
	exports.PlacesBeachAccess = _beachAccess2.default;
	exports.PlacesBusinessCenter = _businessCenter2.default;
	exports.PlacesCasino = _casino2.default;
	exports.PlacesChildCare = _childCare2.default;
	exports.PlacesChildFriendly = _childFriendly2.default;
	exports.PlacesFitnessCenter = _fitnessCenter2.default;
	exports.PlacesFreeBreakfast = _freeBreakfast2.default;
	exports.PlacesGolfCourse = _golfCourse2.default;
	exports.PlacesHotTub = _hotTub2.default;
	exports.PlacesKitchen = _kitchen2.default;
	exports.PlacesPool = _pool2.default;
	exports.PlacesRoomService = _roomService2.default;
	exports.PlacesRvHookup = _rvHookup4.default;
	exports.PlacesSmokeFree = _smokeFree2.default;
	exports.PlacesSmokingRooms = _smokingRooms2.default;
	exports.PlacesSpa = _spa2.default;
	exports.SocialCake = _cake2.default;
	exports.SocialDomain = _domain2.default;
	exports.SocialGroupAdd = _groupAdd2.default;
	exports.SocialGroup = _group2.default;
	exports.SocialLocationCity = _locationCity2.default;
	exports.SocialMoodBad = _moodBad2.default;
	exports.SocialMood = _mood2.default;
	exports.SocialNotificationsActive = _notificationsActive2.default;
	exports.SocialNotificationsNone = _notificationsNone2.default;
	exports.SocialNotificationsOff = _notificationsOff2.default;
	exports.SocialNotificationsPaused = _notificationsPaused2.default;
	exports.SocialNotifications = _notifications2.default;
	exports.SocialPages = _pages2.default;
	exports.SocialPartyMode = _partyMode2.default;
	exports.SocialPeopleOutline = _peopleOutline2.default;
	exports.SocialPeople = _people2.default;
	exports.SocialPersonAdd = _personAdd2.default;
	exports.SocialPersonOutline = _personOutline2.default;
	exports.SocialPerson = _person2.default;
	exports.SocialPlusOne = _plusOne2.default;
	exports.SocialPoll = _poll2.default;
	exports.SocialPublic = _public2.default;
	exports.SocialSchool = _school2.default;
	exports.SocialSentimentDissatisfied = _sentimentDissatisfied2.default;
	exports.SocialSentimentNeutral = _sentimentNeutral2.default;
	exports.SocialSentimentSatisfied = _sentimentSatisfied2.default;
	exports.SocialSentimentVeryDissatisfied = _sentimentVeryDissatisfied2.default;
	exports.SocialSentimentVerySatisfied = _sentimentVerySatisfied2.default;
	exports.SocialShare = _share2.default;
	exports.SocialWhatshot = _whatshot2.default;
	exports.ToggleCheckBoxOutlineBlank = _checkBoxOutlineBlank2.default;
	exports.ToggleCheckBox = _checkBox2.default;
	exports.ToggleIndeterminateCheckBox = _indeterminateCheckBox2.default;
	exports.ToggleRadioButtonChecked = _radioButtonChecked2.default;
	exports.ToggleRadioButtonUnchecked = _radioButtonUnchecked2.default;
	exports.ToggleStarBorder = _starBorder2.default;
	exports.ToggleStarHalf = _starHalf2.default;
	exports.ToggleStar = _star2.default;

/***/ },
/* 152 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  once: function once(el, type, callback) {
	    var typeArray = type ? type.split(' ') : [];
	    var recursiveFunction = function recursiveFunction(event) {
	      event.target.removeEventListener(event.type, recursiveFunction);
	      return callback(event);
	    };
	
	    for (var i = typeArray.length - 1; i >= 0; i--) {
	      this.on(el, typeArray[i], recursiveFunction);
	    }
	  },
	  on: function on(el, type, callback) {
	    if (el.addEventListener) {
	      el.addEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.attachEvent('on' + type, function () {
	        callback.call(el);
	      });
	    }
	  },
	  off: function off(el, type, callback) {
	    if (el.removeEventListener) {
	      el.removeEventListener(type, callback);
	    } else {
	      // IE8+ Support
	      el.detachEvent('on' + type, callback);
	    }
	  },
	  isKeyboard: function isKeyboard(event) {
	    return ['keydown', 'keypress', 'keyup'].indexOf(event.type) !== -1;
	  }
	};

/***/ },
/* 153 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {'use strict';
	
	if (!process.version ||
	    process.version.indexOf('v0.') === 0 ||
	    process.version.indexOf('v1.') === 0 && process.version.indexOf('v1.8.') !== 0) {
	  module.exports = nextTick;
	} else {
	  module.exports = process.nextTick;
	}
	
	function nextTick(fn, arg1, arg2, arg3) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('"callback" argument must be a function');
	  }
	  var len = arguments.length;
	  var args, i;
	  switch (len) {
	  case 0:
	  case 1:
	    return process.nextTick(fn);
	  case 2:
	    return process.nextTick(function afterTickOne() {
	      fn.call(null, arg1);
	    });
	  case 3:
	    return process.nextTick(function afterTickTwo() {
	      fn.call(null, arg1, arg2);
	    });
	  case 4:
	    return process.nextTick(function afterTickThree() {
	      fn.call(null, arg1, arg2, arg3);
	    });
	  default:
	    args = new Array(len - 1);
	    i = 0;
	    while (i < args.length) {
	      args[i++] = arguments[i];
	    }
	    return process.nextTick(function afterTick() {
	      fn.apply(null, args);
	    });
	  }
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ },
/* 154 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactErrorUtils = __webpack_require__(231);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(16);
	
	/**
	 * Injected dependencies:
	 */
	
	/**
	 * - `ComponentTree`: [required] Module that can convert between React instances
	 *   and actual node references.
	 */
	var ComponentTree;
	var TreeTraversal;
	var injection = {
	  injectComponentTree: function (Injected) {
	    ComponentTree = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.getNodeFromInstance && Injected.getInstanceFromNode, 'EventPluginUtils.injection.injectComponentTree(...): Injected ' + 'module is missing getNodeFromInstance or getInstanceFromNode.') : void 0;
	    }
	  },
	  injectTreeTraversal: function (Injected) {
	    TreeTraversal = Injected;
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(Injected && Injected.isAncestor && Injected.getLowestCommonAncestor, 'EventPluginUtils.injection.injectTreeTraversal(...): Injected ' + 'module is missing isAncestor or getLowestCommonAncestor.') : void 0;
	    }
	  }
	};
	
	function isEndish(topLevelType) {
	  return topLevelType === 'topMouseUp' || topLevelType === 'topTouchEnd' || topLevelType === 'topTouchCancel';
	}
	
	function isMoveish(topLevelType) {
	  return topLevelType === 'topMouseMove' || topLevelType === 'topTouchMove';
	}
	function isStartish(topLevelType) {
	  return topLevelType === 'topMouseDown' || topLevelType === 'topTouchStart';
	}
	
	var validateEventDispatches;
	if (false) {
	  validateEventDispatches = function (event) {
	    var dispatchListeners = event._dispatchListeners;
	    var dispatchInstances = event._dispatchInstances;
	
	    var listenersIsArr = Array.isArray(dispatchListeners);
	    var listenersLen = listenersIsArr ? dispatchListeners.length : dispatchListeners ? 1 : 0;
	
	    var instancesIsArr = Array.isArray(dispatchInstances);
	    var instancesLen = instancesIsArr ? dispatchInstances.length : dispatchInstances ? 1 : 0;
	
	    process.env.NODE_ENV !== 'production' ? warning(instancesIsArr === listenersIsArr && instancesLen === listenersLen, 'EventPluginUtils: Invalid `event`.') : void 0;
	  };
	}
	
	/**
	 * Dispatch the event to the listener.
	 * @param {SyntheticEvent} event SyntheticEvent to handle
	 * @param {boolean} simulated If the event is simulated (changes exn behavior)
	 * @param {function} listener Application-level callback
	 * @param {*} inst Internal component instance
	 */
	function executeDispatch(event, simulated, listener, inst) {
	  var type = event.type || 'unknown-event';
	  event.currentTarget = EventPluginUtils.getNodeFromInstance(inst);
	  if (simulated) {
	    ReactErrorUtils.invokeGuardedCallbackWithCatch(type, listener, event);
	  } else {
	    ReactErrorUtils.invokeGuardedCallback(type, listener, event);
	  }
	  event.currentTarget = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches.
	 */
	function executeDispatchesInOrder(event, simulated) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      executeDispatch(event, simulated, dispatchListeners[i], dispatchInstances[i]);
	    }
	  } else if (dispatchListeners) {
	    executeDispatch(event, simulated, dispatchListeners, dispatchInstances);
	  }
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	}
	
	/**
	 * Standard/simple iteration through an event's collected dispatches, but stops
	 * at the first dispatch execution returning true, and returns that id.
	 *
	 * @return {?string} id of the first dispatch execution who's listener returns
	 * true, or null if no listener returned true.
	 */
	function executeDispatchesInOrderStopAtTrueImpl(event) {
	  var dispatchListeners = event._dispatchListeners;
	  var dispatchInstances = event._dispatchInstances;
	  if (false) {
	    validateEventDispatches(event);
	  }
	  if (Array.isArray(dispatchListeners)) {
	    for (var i = 0; i < dispatchListeners.length; i++) {
	      if (event.isPropagationStopped()) {
	        break;
	      }
	      // Listeners and Instances are two parallel arrays that are always in sync.
	      if (dispatchListeners[i](event, dispatchInstances[i])) {
	        return dispatchInstances[i];
	      }
	    }
	  } else if (dispatchListeners) {
	    if (dispatchListeners(event, dispatchInstances)) {
	      return dispatchInstances;
	    }
	  }
	  return null;
	}
	
	/**
	 * @see executeDispatchesInOrderStopAtTrueImpl
	 */
	function executeDispatchesInOrderStopAtTrue(event) {
	  var ret = executeDispatchesInOrderStopAtTrueImpl(event);
	  event._dispatchInstances = null;
	  event._dispatchListeners = null;
	  return ret;
	}
	
	/**
	 * Execution of a "direct" dispatch - there must be at most one dispatch
	 * accumulated on the event or it is considered an error. It doesn't really make
	 * sense for an event with multiple dispatches (bubbled) to keep track of the
	 * return values at each dispatch execution, but it does tend to make sense when
	 * dealing with "direct" dispatches.
	 *
	 * @return {*} The return value of executing the single dispatch.
	 */
	function executeDirectDispatch(event) {
	  if (false) {
	    validateEventDispatches(event);
	  }
	  var dispatchListener = event._dispatchListeners;
	  var dispatchInstance = event._dispatchInstances;
	  !!Array.isArray(dispatchListener) ?  false ? invariant(false, 'executeDirectDispatch(...): Invalid `event`.') : _prodInvariant('103') : void 0;
	  event.currentTarget = dispatchListener ? EventPluginUtils.getNodeFromInstance(dispatchInstance) : null;
	  var res = dispatchListener ? dispatchListener(event) : null;
	  event.currentTarget = null;
	  event._dispatchListeners = null;
	  event._dispatchInstances = null;
	  return res;
	}
	
	/**
	 * @param {SyntheticEvent} event
	 * @return {boolean} True iff number of dispatches accumulated is greater than 0.
	 */
	function hasDispatches(event) {
	  return !!event._dispatchListeners;
	}
	
	/**
	 * General utilities that are useful in creating custom Event Plugins.
	 */
	var EventPluginUtils = {
	  isEndish: isEndish,
	  isMoveish: isMoveish,
	  isStartish: isStartish,
	
	  executeDirectDispatch: executeDirectDispatch,
	  executeDispatchesInOrder: executeDispatchesInOrder,
	  executeDispatchesInOrderStopAtTrue: executeDispatchesInOrderStopAtTrue,
	  hasDispatches: hasDispatches,
	
	  getInstanceFromNode: function (node) {
	    return ComponentTree.getInstanceFromNode(node);
	  },
	  getNodeFromInstance: function (node) {
	    return ComponentTree.getNodeFromInstance(node);
	  },
	  isAncestor: function (a, b) {
	    return TreeTraversal.isAncestor(a, b);
	  },
	  getLowestCommonAncestor: function (a, b) {
	    return TreeTraversal.getLowestCommonAncestor(a, b);
	  },
	  getParentInstance: function (inst) {
	    return TreeTraversal.getParentInstance(inst);
	  },
	  traverseTwoPhase: function (target, fn, arg) {
	    return TreeTraversal.traverseTwoPhase(target, fn, arg);
	  },
	  traverseEnterLeave: function (from, to, fn, argFrom, argTo) {
	    return TreeTraversal.traverseEnterLeave(from, to, fn, argFrom, argTo);
	  },
	
	  injection: injection
	};
	
	module.exports = EventPluginUtils;

/***/ },
/* 155 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var EventPluginRegistry = __webpack_require__(227);
	var ReactEventEmitterMixin = __webpack_require__(1881);
	var ViewportMetrics = __webpack_require__(233);
	
	var getVendorPrefixedEventName = __webpack_require__(1913);
	var isEventSupported = __webpack_require__(238);
	
	/**
	 * Summary of `ReactBrowserEventEmitter` event handling:
	 *
	 *  - Top-level delegation is used to trap most native browser events. This
	 *    may only occur in the main thread and is the responsibility of
	 *    ReactEventListener, which is injected and can therefore support pluggable
	 *    event sources. This is the only work that occurs in the main thread.
	 *
	 *  - We normalize and de-duplicate events to account for browser quirks. This
	 *    may be done in the worker thread.
	 *
	 *  - Forward these native events (with the associated top-level type used to
	 *    trap it) to `EventPluginHub`, which in turn will ask plugins if they want
	 *    to extract any synthetic events.
	 *
	 *  - The `EventPluginHub` will then process each event by annotating them with
	 *    "dispatches", a sequence of listeners and IDs that care about that event.
	 *
	 *  - The `EventPluginHub` then dispatches the events.
	 *
	 * Overview of React and the event system:
	 *
	 * +------------+    .
	 * |    DOM     |    .
	 * +------------+    .
	 *       |           .
	 *       v           .
	 * +------------+    .
	 * | ReactEvent |    .
	 * |  Listener  |    .
	 * +------------+    .                         +-----------+
	 *       |           .               +--------+|SimpleEvent|
	 *       |           .               |         |Plugin     |
	 * +-----|------+    .               v         +-----------+
	 * |     |      |    .    +--------------+                    +------------+
	 * |     +-----------.--->|EventPluginHub|                    |    Event   |
	 * |            |    .    |              |     +-----------+  | Propagators|
	 * | ReactEvent |    .    |              |     |TapEvent   |  |------------|
	 * |  Emitter   |    .    |              |<---+|Plugin     |  |other plugin|
	 * |            |    .    |              |     +-----------+  |  utilities |
	 * |     +-----------.--->|              |                    +------------+
	 * |     |      |    .    +--------------+
	 * +-----|------+    .                ^        +-----------+
	 *       |           .                |        |Enter/Leave|
	 *       +           .                +-------+|Plugin     |
	 * +-------------+   .                         +-----------+
	 * | application |   .
	 * |-------------|   .
	 * |             |   .
	 * |             |   .
	 * +-------------+   .
	 *                   .
	 *    React Core     .  General Purpose Event Plugin System
	 */
	
	var hasEventPageXY;
	var alreadyListeningTo = {};
	var isMonitoringScrollValue = false;
	var reactTopListenersCounter = 0;
	
	// For events like 'submit' which don't consistently bubble (which we trap at a
	// lower node than `document`), binding at `document` would cause duplicate
	// events so we don't include them here
	var topEventMapping = {
	  topAbort: 'abort',
	  topAnimationEnd: getVendorPrefixedEventName('animationend') || 'animationend',
	  topAnimationIteration: getVendorPrefixedEventName('animationiteration') || 'animationiteration',
	  topAnimationStart: getVendorPrefixedEventName('animationstart') || 'animationstart',
	  topBlur: 'blur',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topChange: 'change',
	  topClick: 'click',
	  topCompositionEnd: 'compositionend',
	  topCompositionStart: 'compositionstart',
	  topCompositionUpdate: 'compositionupdate',
	  topContextMenu: 'contextmenu',
	  topCopy: 'copy',
	  topCut: 'cut',
	  topDoubleClick: 'dblclick',
	  topDrag: 'drag',
	  topDragEnd: 'dragend',
	  topDragEnter: 'dragenter',
	  topDragExit: 'dragexit',
	  topDragLeave: 'dragleave',
	  topDragOver: 'dragover',
	  topDragStart: 'dragstart',
	  topDrop: 'drop',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topFocus: 'focus',
	  topInput: 'input',
	  topKeyDown: 'keydown',
	  topKeyPress: 'keypress',
	  topKeyUp: 'keyup',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topMouseDown: 'mousedown',
	  topMouseMove: 'mousemove',
	  topMouseOut: 'mouseout',
	  topMouseOver: 'mouseover',
	  topMouseUp: 'mouseup',
	  topPaste: 'paste',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topScroll: 'scroll',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topSelectionChange: 'selectionchange',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTextInput: 'textInput',
	  topTimeUpdate: 'timeupdate',
	  topTouchCancel: 'touchcancel',
	  topTouchEnd: 'touchend',
	  topTouchMove: 'touchmove',
	  topTouchStart: 'touchstart',
	  topTransitionEnd: getVendorPrefixedEventName('transitionend') || 'transitionend',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting',
	  topWheel: 'wheel'
	};
	
	/**
	 * To ensure no conflicts with other potential React instances on the page
	 */
	var topListenersIDKey = '_reactListenersID' + String(Math.random()).slice(2);
	
	function getListeningForDocument(mountAt) {
	  // In IE8, `mountAt` is a host object and doesn't have `hasOwnProperty`
	  // directly.
	  if (!Object.prototype.hasOwnProperty.call(mountAt, topListenersIDKey)) {
	    mountAt[topListenersIDKey] = reactTopListenersCounter++;
	    alreadyListeningTo[mountAt[topListenersIDKey]] = {};
	  }
	  return alreadyListeningTo[mountAt[topListenersIDKey]];
	}
	
	/**
	 * `ReactBrowserEventEmitter` is used to attach top-level event listeners. For
	 * example:
	 *
	 *   EventPluginHub.putListener('myID', 'onClick', myFunction);
	 *
	 * This would allocate a "registration" of `('onClick', myFunction)` on 'myID'.
	 *
	 * @internal
	 */
	var ReactBrowserEventEmitter = _assign({}, ReactEventEmitterMixin, {
	  /**
	   * Injectable event backend
	   */
	  ReactEventListener: null,
	
	  injection: {
	    /**
	     * @param {object} ReactEventListener
	     */
	    injectReactEventListener: function (ReactEventListener) {
	      ReactEventListener.setHandleTopLevel(ReactBrowserEventEmitter.handleTopLevel);
	      ReactBrowserEventEmitter.ReactEventListener = ReactEventListener;
	    }
	  },
	
	  /**
	   * Sets whether or not any created callbacks should be enabled.
	   *
	   * @param {boolean} enabled True if callbacks should be enabled.
	   */
	  setEnabled: function (enabled) {
	    if (ReactBrowserEventEmitter.ReactEventListener) {
	      ReactBrowserEventEmitter.ReactEventListener.setEnabled(enabled);
	    }
	  },
	
	  /**
	   * @return {boolean} True if callbacks are enabled.
	   */
	  isEnabled: function () {
	    return !!(ReactBrowserEventEmitter.ReactEventListener && ReactBrowserEventEmitter.ReactEventListener.isEnabled());
	  },
	
	  /**
	   * We listen for bubbled touch events on the document object.
	   *
	   * Firefox v8.01 (and possibly others) exhibited strange behavior when
	   * mounting `onmousemove` events at some node that was not the document
	   * element. The symptoms were that if your mouse is not moving over something
	   * contained within that mount point (for example on the background) the
	   * top-level listeners for `onmousemove` won't be called. However, if you
	   * register the `mousemove` on the document object, then it will of course
	   * catch all `mousemove`s. This along with iOS quirks, justifies restricting
	   * top-level listeners to the document object only, at least for these
	   * movement types of events and possibly all events.
	   *
	   * @see http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	   *
	   * Also, `keyup`/`keypress`/`keydown` do not bubble to the window on IE, but
	   * they bubble to document.
	   *
	   * @param {string} registrationName Name of listener (e.g. `onClick`).
	   * @param {object} contentDocumentHandle Document which owns the container
	   */
	  listenTo: function (registrationName, contentDocumentHandle) {
	    var mountAt = contentDocumentHandle;
	    var isListening = getListeningForDocument(mountAt);
	    var dependencies = EventPluginRegistry.registrationNameDependencies[registrationName];
	
	    for (var i = 0; i < dependencies.length; i++) {
	      var dependency = dependencies[i];
	      if (!(isListening.hasOwnProperty(dependency) && isListening[dependency])) {
	        if (dependency === 'topWheel') {
	          if (isEventSupported('wheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'wheel', mountAt);
	          } else if (isEventSupported('mousewheel')) {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'mousewheel', mountAt);
	          } else {
	            // Firefox needs to capture a different mouse scroll event.
	            // @see http://www.quirksmode.org/dom/events/tests/scroll.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topWheel', 'DOMMouseScroll', mountAt);
	          }
	        } else if (dependency === 'topScroll') {
	          if (isEventSupported('scroll', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topScroll', 'scroll', mountAt);
	          } else {
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topScroll', 'scroll', ReactBrowserEventEmitter.ReactEventListener.WINDOW_HANDLE);
	          }
	        } else if (dependency === 'topFocus' || dependency === 'topBlur') {
	          if (isEventSupported('focus', true)) {
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topFocus', 'focus', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent('topBlur', 'blur', mountAt);
	          } else if (isEventSupported('focusin')) {
	            // IE has `focusin` and `focusout` events which bubble.
	            // @see http://www.quirksmode.org/blog/archives/2008/04/delegating_the.html
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topFocus', 'focusin', mountAt);
	            ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent('topBlur', 'focusout', mountAt);
	          }
	
	          // to make sure blur and focus event listeners are only attached once
	          isListening.topBlur = true;
	          isListening.topFocus = true;
	        } else if (topEventMapping.hasOwnProperty(dependency)) {
	          ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(dependency, topEventMapping[dependency], mountAt);
	        }
	
	        isListening[dependency] = true;
	      }
	    }
	  },
	
	  trapBubbledEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapBubbledEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  trapCapturedEvent: function (topLevelType, handlerBaseName, handle) {
	    return ReactBrowserEventEmitter.ReactEventListener.trapCapturedEvent(topLevelType, handlerBaseName, handle);
	  },
	
	  /**
	   * Protect against document.createEvent() returning null
	   * Some popup blocker extensions appear to do this:
	   * https://github.com/facebook/react/issues/6887
	   */
	  supportsEventPageXY: function () {
	    if (!document.createEvent) {
	      return false;
	    }
	    var ev = document.createEvent('MouseEvent');
	    return ev != null && 'pageX' in ev;
	  },
	
	  /**
	   * Listens to window scroll and resize events. We cache scroll values so that
	   * application code can access them without triggering reflows.
	   *
	   * ViewportMetrics is only used by SyntheticMouse/TouchEvent and only when
	   * pageX/pageY isn't supported (legacy browsers).
	   *
	   * NOTE: Scroll events do not bubble.
	   *
	   * @see http://www.quirksmode.org/dom/events/scroll.html
	   */
	  ensureScrollValueMonitoring: function () {
	    if (hasEventPageXY === undefined) {
	      hasEventPageXY = ReactBrowserEventEmitter.supportsEventPageXY();
	    }
	    if (!hasEventPageXY && !isMonitoringScrollValue) {
	      var refresh = ViewportMetrics.refreshScrollValues;
	      ReactBrowserEventEmitter.ReactEventListener.monitorScrollValue(refresh);
	      isMonitoringScrollValue = true;
	    }
	  }
	});
	
	module.exports = ReactBrowserEventEmitter;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(93);
	var ViewportMetrics = __webpack_require__(233);
	
	var getEventModifierState = __webpack_require__(236);
	
	/**
	 * @interface MouseEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var MouseEventInterface = {
	  screenX: null,
	  screenY: null,
	  clientX: null,
	  clientY: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  getModifierState: getEventModifierState,
	  button: function (event) {
	    // Webkit, Firefox, IE9+
	    // which:  1 2 3
	    // button: 0 1 2 (standard)
	    var button = event.button;
	    if ('which' in event) {
	      return button;
	    }
	    // IE<9
	    // which:  undefined
	    // button: 0 0 0
	    // button: 1 4 2 (onmouseup)
	    return button === 2 ? 2 : button === 4 ? 1 : 0;
	  },
	  buttons: null,
	  relatedTarget: function (event) {
	    return event.relatedTarget || (event.fromElement === event.srcElement ? event.toElement : event.fromElement);
	  },
	  // "Proprietary" Interface.
	  pageX: function (event) {
	    return 'pageX' in event ? event.pageX : event.clientX + ViewportMetrics.currentScrollLeft;
	  },
	  pageY: function (event) {
	    return 'pageY' in event ? event.pageY : event.clientY + ViewportMetrics.currentScrollTop;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticMouseEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticMouseEvent, MouseEventInterface);
	
	module.exports = SyntheticMouseEvent;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(13);
	
	var OBSERVED_ERROR = {};
	
	/**
	 * `Transaction` creates a black box that is able to wrap any method such that
	 * certain invariants are maintained before and after the method is invoked
	 * (Even if an exception is thrown while invoking the wrapped method). Whoever
	 * instantiates a transaction can provide enforcers of the invariants at
	 * creation time. The `Transaction` class itself will supply one additional
	 * automatic invariant for you - the invariant that any transaction instance
	 * should not be run while it is already being run. You would typically create a
	 * single instance of a `Transaction` for reuse multiple times, that potentially
	 * is used to wrap several different methods. Wrappers are extremely simple -
	 * they only require implementing two methods.
	 *
	 * <pre>
	 *                       wrappers (injected at creation time)
	 *                                      +        +
	 *                                      |        |
	 *                    +-----------------|--------|--------------+
	 *                    |                 v        |              |
	 *                    |      +---------------+   |              |
	 *                    |   +--|    wrapper1   |---|----+         |
	 *                    |   |  +---------------+   v    |         |
	 *                    |   |          +-------------+  |         |
	 *                    |   |     +----|   wrapper2  |--------+   |
	 *                    |   |     |    +-------------+  |     |   |
	 *                    |   |     |                     |     |   |
	 *                    |   v     v                     v     v   | wrapper
	 *                    | +---+ +---+   +---------+   +---+ +---+ | invariants
	 * perform(anyMethod) | |   | |   |   |         |   |   | |   | | maintained
	 * +----------------->|-|---|-|---|-->|anyMethod|---|---|-|---|-|-------->
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | |   | |   |   |         |   |   | |   | |
	 *                    | +---+ +---+   +---------+   +---+ +---+ |
	 *                    |  initialize                    close    |
	 *                    +-----------------------------------------+
	 * </pre>
	 *
	 * Use cases:
	 * - Preserving the input selection ranges before/after reconciliation.
	 *   Restoring selection even in the event of an unexpected error.
	 * - Deactivating events while rearranging the DOM, preventing blurs/focuses,
	 *   while guaranteeing that afterwards, the event system is reactivated.
	 * - Flushing a queue of collected DOM mutations to the main UI thread after a
	 *   reconciliation takes place in a worker thread.
	 * - Invoking any collected `componentDidUpdate` callbacks after rendering new
	 *   content.
	 * - (Future use case): Wrapping particular flushes of the `ReactWorker` queue
	 *   to preserve the `scrollTop` (an automatic scroll aware DOM).
	 * - (Future use case): Layout calculations before and after DOM updates.
	 *
	 * Transactional plugin API:
	 * - A module that has an `initialize` method that returns any precomputation.
	 * - and a `close` method that accepts the precomputation. `close` is invoked
	 *   when the wrapped process is completed, or has failed.
	 *
	 * @param {Array<TransactionalWrapper>} transactionWrapper Wrapper modules
	 * that implement `initialize` and `close`.
	 * @return {Transaction} Single transaction for reuse in thread.
	 *
	 * @class Transaction
	 */
	var TransactionImpl = {
	  /**
	   * Sets up this instance so that it is prepared for collecting metrics. Does
	   * so such that this setup method may be used on an instance that is already
	   * initialized, in a way that does not consume additional memory upon reuse.
	   * That can be useful if you decide to make your subclass of this mixin a
	   * "PooledClass".
	   */
	  reinitializeTransaction: function () {
	    this.transactionWrappers = this.getTransactionWrappers();
	    if (this.wrapperInitData) {
	      this.wrapperInitData.length = 0;
	    } else {
	      this.wrapperInitData = [];
	    }
	    this._isInTransaction = false;
	  },
	
	  _isInTransaction: false,
	
	  /**
	   * @abstract
	   * @return {Array<TransactionWrapper>} Array of transaction wrappers.
	   */
	  getTransactionWrappers: null,
	
	  isInTransaction: function () {
	    return !!this._isInTransaction;
	  },
	
	  /* eslint-disable space-before-function-paren */
	
	  /**
	   * Executes the function within a safety window. Use this for the top level
	   * methods that result in large amounts of computation/mutations that would
	   * need to be safety checked. The optional arguments helps prevent the need
	   * to bind in many cases.
	   *
	   * @param {function} method Member of scope to call.
	   * @param {Object} scope Scope to invoke from.
	   * @param {Object?=} a Argument to pass to the method.
	   * @param {Object?=} b Argument to pass to the method.
	   * @param {Object?=} c Argument to pass to the method.
	   * @param {Object?=} d Argument to pass to the method.
	   * @param {Object?=} e Argument to pass to the method.
	   * @param {Object?=} f Argument to pass to the method.
	   *
	   * @return {*} Return value from `method`.
	   */
	  perform: function (method, scope, a, b, c, d, e, f) {
	    /* eslint-enable space-before-function-paren */
	    !!this.isInTransaction() ?  false ? invariant(false, 'Transaction.perform(...): Cannot initialize a transaction when there is already an outstanding transaction.') : _prodInvariant('27') : void 0;
	    var errorThrown;
	    var ret;
	    try {
	      this._isInTransaction = true;
	      // Catching errors makes debugging more difficult, so we start with
	      // errorThrown set to true before setting it to false after calling
	      // close -- if it's still set to true in the finally block, it means
	      // one of these calls threw.
	      errorThrown = true;
	      this.initializeAll(0);
	      ret = method.call(scope, a, b, c, d, e, f);
	      errorThrown = false;
	    } finally {
	      try {
	        if (errorThrown) {
	          // If `method` throws, prefer to show that stack trace over any thrown
	          // by invoking `closeAll`.
	          try {
	            this.closeAll(0);
	          } catch (err) {}
	        } else {
	          // Since `method` didn't throw, we don't want to silence the exception
	          // here.
	          this.closeAll(0);
	        }
	      } finally {
	        this._isInTransaction = false;
	      }
	    }
	    return ret;
	  },
	
	  initializeAll: function (startIndex) {
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      try {
	        // Catching errors makes debugging more difficult, so we start with the
	        // OBSERVED_ERROR state before overwriting it with the real return value
	        // of initialize -- if it's still set to OBSERVED_ERROR in the finally
	        // block, it means wrapper.initialize threw.
	        this.wrapperInitData[i] = OBSERVED_ERROR;
	        this.wrapperInitData[i] = wrapper.initialize ? wrapper.initialize.call(this) : null;
	      } finally {
	        if (this.wrapperInitData[i] === OBSERVED_ERROR) {
	          // The initializer for wrapper i threw an error; initialize the
	          // remaining wrappers but silence any exceptions from them to ensure
	          // that the first error is the one to bubble up.
	          try {
	            this.initializeAll(i + 1);
	          } catch (err) {}
	        }
	      }
	    }
	  },
	
	  /**
	   * Invokes each of `this.transactionWrappers.close[i]` functions, passing into
	   * them the respective return values of `this.transactionWrappers.init[i]`
	   * (`close`rs that correspond to initializers that failed will not be
	   * invoked).
	   */
	  closeAll: function (startIndex) {
	    !this.isInTransaction() ?  false ? invariant(false, 'Transaction.closeAll(): Cannot close transaction when none are open.') : _prodInvariant('28') : void 0;
	    var transactionWrappers = this.transactionWrappers;
	    for (var i = startIndex; i < transactionWrappers.length; i++) {
	      var wrapper = transactionWrappers[i];
	      var initData = this.wrapperInitData[i];
	      var errorThrown;
	      try {
	        // Catching errors makes debugging more difficult, so we start with
	        // errorThrown set to true before setting it to false after calling
	        // close -- if it's still set to true in the finally block, it means
	        // wrapper.close threw.
	        errorThrown = true;
	        if (initData !== OBSERVED_ERROR && wrapper.close) {
	          wrapper.close.call(this, initData);
	        }
	        errorThrown = false;
	      } finally {
	        if (errorThrown) {
	          // The closer for wrapper i threw an error; close the remaining
	          // wrappers but silence any exceptions from them to ensure that the
	          // first error is the one to bubble up.
	          try {
	            this.closeAll(i + 1);
	          } catch (e) {}
	        }
	      }
	    }
	    this.wrapperInitData.length = 0;
	  }
	};
	
	module.exports = TransactionImpl;

/***/ },
/* 158 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * Based on the escape-html library, which is used under the MIT License below:
	 *
	 * Copyright (c) 2012-2013 TJ Holowaychuk
	 * Copyright (c) 2015 Andreas Lubbe
	 * Copyright (c) 2015 Tiancheng "Timothy" Gu
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining
	 * a copy of this software and associated documentation files (the
	 * 'Software'), to deal in the Software without restriction, including
	 * without limitation the rights to use, copy, modify, merge, publish,
	 * distribute, sublicense, and/or sell copies of the Software, and to
	 * permit persons to whom the Software is furnished to do so, subject to
	 * the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be
	 * included in all copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED 'AS IS', WITHOUT WARRANTY OF ANY KIND,
	 * EXPRESS OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	 * MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT.
	 * IN NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY
	 * CLAIM, DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT,
	 * TORT OR OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE
	 * SOFTWARE OR THE USE OR OTHER DEALINGS IN THE SOFTWARE.
	 *
	 */
	
	'use strict';
	
	// code copied and modified from escape-html
	/**
	 * Module variables.
	 * @private
	 */
	
	var matchHtmlRegExp = /["'&<>]/;
	
	/**
	 * Escape special characters in the given string of html.
	 *
	 * @param  {string} string The string to escape for inserting into HTML
	 * @return {string}
	 * @public
	 */
	
	function escapeHtml(string) {
	  var str = '' + string;
	  var match = matchHtmlRegExp.exec(str);
	
	  if (!match) {
	    return str;
	  }
	
	  var escape;
	  var html = '';
	  var index = 0;
	  var lastIndex = 0;
	
	  for (index = match.index; index < str.length; index++) {
	    switch (str.charCodeAt(index)) {
	      case 34:
	        // "
	        escape = '&quot;';
	        break;
	      case 38:
	        // &
	        escape = '&amp;';
	        break;
	      case 39:
	        // '
	        escape = '&#x27;'; // modified from escape-html; used to be '&#39'
	        break;
	      case 60:
	        // <
	        escape = '&lt;';
	        break;
	      case 62:
	        // >
	        escape = '&gt;';
	        break;
	      default:
	        continue;
	    }
	
	    if (lastIndex !== index) {
	      html += str.substring(lastIndex, index);
	    }
	
	    lastIndex = index + 1;
	    html += escape;
	  }
	
	  return lastIndex !== index ? html + str.substring(lastIndex, index) : html;
	}
	// end code copied and modified from escape-html
	
	/**
	 * Escapes text to prevent scripting attacks.
	 *
	 * @param {*} text Text value to escape.
	 * @return {string} An escaped string.
	 */
	function escapeTextContentForBrowser(text) {
	  if (typeof text === 'boolean' || typeof text === 'number') {
	    // this shortcircuit helps perf for types that we know will never have
	    // special characters, especially given that this function is used often
	    // for numeric dom ids.
	    return '' + text;
	  }
	  return escapeHtml(text);
	}
	
	module.exports = escapeTextContentForBrowser;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	var DOMNamespaces = __webpack_require__(226);
	
	var WHITESPACE_TEST = /^[ \r\n\t\f]/;
	var NONVISIBLE_TEST = /<(!--|link|noscript|meta|script|style)[ \r\n\t\f\/>]/;
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(234);
	
	// SVG temp container for IE lacking innerHTML
	var reusableSVGContainer;
	
	/**
	 * Set the innerHTML property of a node, ensuring that whitespace is preserved
	 * even in IE8.
	 *
	 * @param {DOMElement} node
	 * @param {string} html
	 * @internal
	 */
	var setInnerHTML = createMicrosoftUnsafeLocalFunction(function (node, html) {
	  // IE does not have innerHTML for SVG nodes, so instead we inject the
	  // new markup in a temp node and then move the child nodes across into
	  // the target node
	  if (node.namespaceURI === DOMNamespaces.svg && !('innerHTML' in node)) {
	    reusableSVGContainer = reusableSVGContainer || document.createElement('div');
	    reusableSVGContainer.innerHTML = '<svg>' + html + '</svg>';
	    var svgNode = reusableSVGContainer.firstChild;
	    while (svgNode.firstChild) {
	      node.appendChild(svgNode.firstChild);
	    }
	  } else {
	    node.innerHTML = html;
	  }
	});
	
	if (ExecutionEnvironment.canUseDOM) {
	  // IE8: When updating a just created node with innerHTML only leading
	  // whitespace is removed. When updating an existing node with innerHTML
	  // whitespace in root TextNodes is also collapsed.
	  // @see quirksmode.org/bugreports/archives/2004/11/innerhtml_and_t.html
	
	  // Feature detection; only IE8 is known to behave improperly like this.
	  var testElement = document.createElement('div');
	  testElement.innerHTML = ' ';
	  if (testElement.innerHTML === '') {
	    setInnerHTML = function (node, html) {
	      // Magic theory: IE8 supposedly differentiates between added and updated
	      // nodes when processing innerHTML, innerHTML on updated nodes suffers
	      // from worse whitespace behavior. Re-adding a node like this triggers
	      // the initial and more favorable whitespace behavior.
	      // TODO: What to do on a detached node?
	      if (node.parentNode) {
	        node.parentNode.replaceChild(node, node);
	      }
	
	      // We also implement a workaround for non-visible tags disappearing into
	      // thin air on IE8, this only happens if there is no visible text
	      // in-front of the non-visible tags. Piggyback on the whitespace fix
	      // and simply check if any non-visible tags appear in the source.
	      if (WHITESPACE_TEST.test(html) || html[0] === '<' && NONVISIBLE_TEST.test(html)) {
	        // Recover leading whitespace by temporarily prepending any character.
	        // \uFEFF has the potential advantage of being zero-width/invisible.
	        // UglifyJS drops U+FEFF chars when parsing, so use String.fromCharCode
	        // in hopes that this is preserved even if "\uFEFF" is transformed to
	        // the actual Unicode character (by Babel, for example).
	        // https://github.com/mishoo/UglifyJS2/blob/v2.4.20/lib/parse.js#L216
	        node.innerHTML = String.fromCharCode(0xfeff) + html;
	
	        // deleteData leaves an empty `TextNode` which offsets the index of all
	        // children. Definitely want to avoid this.
	        var textNode = node.firstChild;
	        if (textNode.data.length === 1) {
	          node.removeChild(textNode);
	        } else {
	          textNode.deleteData(0, 1);
	        }
	      } else {
	        node.innerHTML = html;
	      }
	    };
	  }
	  testElement = null;
	}
	
	module.exports = setInnerHTML;

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	/* eslint-disable node/no-deprecated-api */
	var buffer = __webpack_require__(123)
	var Buffer = buffer.Buffer
	
	// alternative to using Object.keys for old browsers
	function copyProps (src, dst) {
	  for (var key in src) {
	    dst[key] = src[key]
	  }
	}
	if (Buffer.from && Buffer.alloc && Buffer.allocUnsafe && Buffer.allocUnsafeSlow) {
	  module.exports = buffer
	} else {
	  // Copy properties from require('buffer')
	  copyProps(buffer, exports)
	  exports.Buffer = SafeBuffer
	}
	
	function SafeBuffer (arg, encodingOrOffset, length) {
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	// Copy static methods from Buffer
	copyProps(Buffer, SafeBuffer)
	
	SafeBuffer.from = function (arg, encodingOrOffset, length) {
	  if (typeof arg === 'number') {
	    throw new TypeError('Argument must not be a number')
	  }
	  return Buffer(arg, encodingOrOffset, length)
	}
	
	SafeBuffer.alloc = function (size, fill, encoding) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  var buf = Buffer(size)
	  if (fill !== undefined) {
	    if (typeof encoding === 'string') {
	      buf.fill(fill, encoding)
	    } else {
	      buf.fill(fill)
	    }
	  } else {
	    buf.fill(0)
	  }
	  return buf
	}
	
	SafeBuffer.allocUnsafe = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return Buffer(size)
	}
	
	SafeBuffer.allocUnsafeSlow = function (size) {
	  if (typeof size !== 'number') {
	    throw new TypeError('Argument must be a number')
	  }
	  return buffer.SlowBuffer(size)
	}


/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomFromSeed = __webpack_require__(1997);
	
	var ORIGINAL = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ_-';
	var alphabet;
	var previousSeed;
	
	var shuffled;
	
	function reset() {
	    shuffled = false;
	}
	
	function setCharacters(_alphabet_) {
	    if (!_alphabet_) {
	        if (alphabet !== ORIGINAL) {
	            alphabet = ORIGINAL;
	            reset();
	        }
	        return;
	    }
	
	    if (_alphabet_ === alphabet) {
	        return;
	    }
	
	    if (_alphabet_.length !== ORIGINAL.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. You submitted ' + _alphabet_.length + ' characters: ' + _alphabet_);
	    }
	
	    var unique = _alphabet_.split('').filter(function(item, ind, arr){
	       return ind !== arr.lastIndexOf(item);
	    });
	
	    if (unique.length) {
	        throw new Error('Custom alphabet for shortid must be ' + ORIGINAL.length + ' unique characters. These characters were not unique: ' + unique.join(', '));
	    }
	
	    alphabet = _alphabet_;
	    reset();
	}
	
	function characters(_alphabet_) {
	    setCharacters(_alphabet_);
	    return alphabet;
	}
	
	function setSeed(seed) {
	    randomFromSeed.seed(seed);
	    if (previousSeed !== seed) {
	        reset();
	        previousSeed = seed;
	    }
	}
	
	function shuffle() {
	    if (!alphabet) {
	        setCharacters(ORIGINAL);
	    }
	
	    var sourceArray = alphabet.split('');
	    var targetArray = [];
	    var r = randomFromSeed.nextValue();
	    var characterIndex;
	
	    while (sourceArray.length > 0) {
	        r = randomFromSeed.nextValue();
	        characterIndex = Math.floor(r * sourceArray.length);
	        targetArray.push(sourceArray.splice(characterIndex, 1)[0]);
	    }
	    return targetArray.join('');
	}
	
	function getShuffled() {
	    if (shuffled) {
	        return shuffled;
	    }
	    shuffled = shuffle();
	    return shuffled;
	}
	
	/**
	 * lookup shuffled letter
	 * @param index
	 * @returns {string}
	 */
	function lookup(index) {
	    var alphabetShuffled = getShuffled();
	    return alphabetShuffled[index];
	}
	
	module.exports = {
	    characters: characters,
	    seed: setSeed,
	    lookup: lookup,
	    shuffled: getShuffled
	};


/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(509), __esModule: true };

/***/ },
/* 163 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(511), __esModule: true };

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _isIterable2 = __webpack_require__(491);
	
	var _isIterable3 = _interopRequireDefault(_isIterable2);
	
	var _getIterator2 = __webpack_require__(252);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function () {
	  function sliceIterator(arr, i) {
	    var _arr = [];
	    var _n = true;
	    var _d = false;
	    var _e = undefined;
	
	    try {
	      for (var _i = (0, _getIterator3.default)(arr), _s; !(_n = (_s = _i.next()).done); _n = true) {
	        _arr.push(_s.value);
	
	        if (i && _arr.length === i) break;
	      }
	    } catch (err) {
	      _d = true;
	      _e = err;
	    } finally {
	      try {
	        if (!_n && _i["return"]) _i["return"]();
	      } finally {
	        if (_d) throw _e;
	      }
	    }
	
	    return _arr;
	  }
	
	  return function (arr, i) {
	    if (Array.isArray(arr)) {
	      return arr;
	    } else if ((0, _isIterable3.default)(Object(arr))) {
	      return sliceIterator(arr, i);
	    } else {
	      throw new TypeError("Invalid attempt to destructure non-iterable instance");
	    }
	  };
	}();

/***/ },
/* 165 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	
	var parse = __webpack_require__(125),
	    isHtml = __webpack_require__(99).isHtml,
	    _ = {
	      extend: __webpack_require__(295),
	      bind: __webpack_require__(192),
	      forEach: __webpack_require__(133),
	      defaults: __webpack_require__(296)
	    };
	
	/*
	 * The API
	 */
	
	var api = [
	  __webpack_require__(499),
	  __webpack_require__(503),
	  __webpack_require__(502),
	  __webpack_require__(500),
	  __webpack_require__(501)
	];
	
	/*
	 * Instance of cheerio
	 */
	
	var Cheerio = module.exports = function(selector, context, root, options) {
	  if (!(this instanceof Cheerio)) return new Cheerio(selector, context, root, options);
	
	  this.options = _.defaults(options || {}, this.options);
	
	  // $(), $(null), $(undefined), $(false)
	  if (!selector) return this;
	
	  if (root) {
	    if (typeof root === 'string') root = parse(root, this.options);
	    this._root = Cheerio.call(this, root);
	  }
	
	  // $($)
	  if (selector.cheerio) return selector;
	
	  // $(dom)
	  if (isNode(selector))
	    selector = [selector];
	
	  // $([dom])
	  if (Array.isArray(selector)) {
	    _.forEach(selector, _.bind(function(elem, idx) {
	      this[idx] = elem;
	    }, this));
	    this.length = selector.length;
	    return this;
	  }
	
	  // $(<html>)
	  if (typeof selector === 'string' && isHtml(selector)) {
	    return Cheerio.call(this, parse(selector, this.options).children);
	  }
	
	  // If we don't have a context, maybe we have a root, from loading
	  if (!context) {
	    context = this._root;
	  } else if (typeof context === 'string') {
	    if (isHtml(context)) {
	      // $('li', '<ul>...</ul>')
	      context = parse(context, this.options);
	      context = Cheerio.call(this, context);
	    } else {
	      // $('li', 'ul')
	      selector = [context, selector].join(' ');
	      context = this._root;
	    }
	  // $('li', node), $('li', [nodes])
	  } else if (!context.cheerio) {
	    context = Cheerio.call(this, context);
	  }
	
	  // If we still don't have a context, return
	  if (!context) return this;
	
	  // #id, .class, tag
	  return context.find(selector);
	};
	
	/**
	 * Mix in `static`
	 */
	
	_.extend(Cheerio, __webpack_require__(166));
	
	/*
	 * Set a signature of the object
	 */
	
	Cheerio.prototype.cheerio = '[cheerio object]';
	
	/*
	 * Cheerio default options
	 */
	
	Cheerio.prototype.options = {
	  withDomLvl1: true,
	  normalizeWhitespace: false,
	  xmlMode: false,
	  decodeEntities: true
	};
	
	/*
	 * Make cheerio an array-like object
	 */
	
	Cheerio.prototype.length = 0;
	Cheerio.prototype.splice = Array.prototype.splice;
	
	/*
	 * Make a cheerio object
	 *
	 * @api private
	 */
	
	Cheerio.prototype._make = function(dom, context) {
	  var cheerio = new this.constructor(dom, context, this._root, this.options);
	  cheerio.prevObject = this;
	  return cheerio;
	};
	
	/**
	 * Turn a cheerio object into an array
	 */
	
	Cheerio.prototype.toArray = function() {
	  return this.get();
	};
	
	/**
	 * Plug in the API
	 */
	api.forEach(function(mod) {
	  _.extend(Cheerio.prototype, mod);
	});
	
	var isNode = function(obj) {
	  return obj.name || obj.type === 'text' || obj.type === 'comment';
	};


/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Module dependencies
	 */
	
	var serialize = __webpack_require__(184),
	    select = __webpack_require__(270),
	    parse = __webpack_require__(125),
	    _ = {
	      merge: __webpack_require__(297),
	      defaults: __webpack_require__(296)
	    };
	
	/**
	 * $.load(str)
	 */
	
	exports.load = function(content, options) {
	  var Cheerio = __webpack_require__(165);
	
	  options = _.defaults(options || {}, Cheerio.prototype.options);
	
	  var root = parse(content, options);
	
	  var initialize = function(selector, context, r, opts) {
	    if (!(this instanceof initialize)) {
	      return new initialize(selector, context, r, opts);
	    }
	    opts = _.defaults(opts || {}, options);
	    return Cheerio.call(this, selector, context, r || root, opts);
	  };
	
	  // Ensure that selections created by the "loaded" `initialize` function are
	  // true Cheerio instances.
	  initialize.prototype = Object.create(Cheerio.prototype);
	  initialize.prototype.constructor = initialize;
	
	  // Mimic jQuery's prototype alias for plugin authors.
	  initialize.fn = initialize.prototype;
	
	  // Keep a reference to the top-level scope so we can chain methods that implicitly
	  // resolve selectors; e.g. $("<span>").(".bar"), which otherwise loses ._root
	  initialize.prototype._originalRoot = root;
	
	  // Add in the static methods
	  _.merge(initialize, exports);
	
	  // Add in the root
	  initialize._root = root;
	  // store options
	  initialize._options = options;
	
	  return initialize;
	};
	
	/*
	* Helper function
	*/
	
	function render(that, dom, options) {
	  if (!dom) {
	    if (that._root && that._root.children) {
	      dom = that._root.children;
	    } else {
	      return '';
	    }
	  } else if (typeof dom === 'string') {
	    dom = select(dom, that._root, options);
	  }
	
	  return serialize(dom, options);
	}
	
	/**
	 * $.html([selector | dom], [options])
	 */
	
	exports.html = function(dom, options) {
	  var Cheerio = __webpack_require__(165);
	
	  // be flexible about parameters, sometimes we call html(),
	  // with options as only parameter
	  // check dom argument for dom element specific properties
	  // assume there is no 'length' or 'type' properties in the options object
	  if (Object.prototype.toString.call(dom) === '[object Object]' && !options && !('length' in dom) && !('type' in dom))
	  {
	    options = dom;
	    dom = undefined;
	  }
	
	  // sometimes $.html() used without preloading html
	  // so fallback non existing options to the default ones
	  options = _.defaults(options || {}, this._options, Cheerio.prototype.options);
	
	  return render(this, dom, options);
	};
	
	/**
	 * $.xml([selector | dom])
	 */
	
	exports.xml = function(dom) {
	  var options = _.defaults({xmlMode: true}, this._options);
	
	  return render(this, dom, options);
	};
	
	/**
	 * $.text(dom)
	 */
	
	exports.text = function(elems) {
	  if (!elems) {
	    elems = this.root();
	  }
	
	  var ret = '',
	      len = elems.length,
	      elem;
	
	  for (var i = 0; i < len; i++) {
	    elem = elems[i];
	    if (elem.type === 'text') ret += elem.data;
	    else if (elem.children && elem.type !== 'comment') {
	      ret += exports.text(elem.children);
	    }
	  }
	
	  return ret;
	};
	
	/**
	 * $.parseHTML(data [, context ] [, keepScripts ])
	 * Parses a string into an array of DOM nodes. The `context` argument has no
	 * meaning for Cheerio, but it is maintained for API compatibility with jQuery.
	 */
	exports.parseHTML = function(data, context, keepScripts) {
	  var parsed;
	
	  if (!data || typeof data !== 'string') {
	    return null;
	  }
	
	  if (typeof context === 'boolean') {
	    keepScripts = context;
	  }
	
	  parsed = this.load(data);
	  if (!keepScripts) {
	    parsed('script').remove();
	  }
	
	  // The `children` array is used by Cheerio internally to group elements that
	  // share the same parents. When nodes created through `parseHTML` are
	  // inserted into previously-existing DOM structures, they will be removed
	  // from the `children` array. The results of `parseHTML` should remain
	  // constant across these operations, so a shallow copy should be returned.
	  return parsed.root()[0].children.slice();
	};
	
	/**
	 * $.root()
	 */
	exports.root = function() {
	  return this(this._root);
	};
	
	/**
	 * $.contains()
	 */
	exports.contains = function(container, contained) {
	
	  // According to the jQuery API, an element does not "contain" itself
	  if (contained === container) {
	    return false;
	  }
	
	  // Step up the descendants, stopping when the root element is reached
	  // (signaled by `.parent` returning a reference to the same object)
	  while (contained && contained !== contained.parent) {
	    contained = contained.parent;
	    if (contained === container) {
	      return true;
	    }
	  }
	
	  return false;
	};


/***/ },
/* 167 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = function (it) {
	  return toString.call(it).slice(8, -1);
	};


/***/ },
/* 168 */
/***/ function(module, exports, __webpack_require__) {

	// optional / simple context binding
	var aFunction = __webpack_require__(515);
	module.exports = function (fn, that, length) {
	  aFunction(fn);
	  if (that === undefined) return fn;
	  switch (length) {
	    case 1: return function (a) {
	      return fn.call(that, a);
	    };
	    case 2: return function (a, b) {
	      return fn.call(that, a, b);
	    };
	    case 3: return function (a, b, c) {
	      return fn.call(that, a, b, c);
	    };
	  }
	  return function (/* ...args */) {
	    return fn.apply(that, arguments);
	  };
	};


/***/ },
/* 169 */
/***/ function(module, exports) {

	// 7.2.1 RequireObjectCoercible(argument)
	module.exports = function (it) {
	  if (it == undefined) throw TypeError("Can't call method on  " + it);
	  return it;
	};


/***/ },
/* 170 */
/***/ function(module, exports) {

	// IE 8- don't enum bug keys
	module.exports = (
	  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
	).split(',');


/***/ },
/* 171 */
/***/ function(module, exports) {

	module.exports = true;


/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	var anObject = __webpack_require__(58);
	var dPs = __webpack_require__(529);
	var enumBugKeys = __webpack_require__(170);
	var IE_PROTO = __webpack_require__(175)('IE_PROTO');
	var Empty = function () { /* empty */ };
	var PROTOTYPE = 'prototype';
	
	// Create object with fake `null` prototype: use iframe Object with cleared prototype
	var createDict = function () {
	  // Thrash, waste and sodomy: IE GC bug
	  var iframe = __webpack_require__(257)('iframe');
	  var i = enumBugKeys.length;
	  var lt = '<';
	  var gt = '>';
	  var iframeDocument;
	  iframe.style.display = 'none';
	  __webpack_require__(520).appendChild(iframe);
	  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	  // createDict = iframe.contentWindow.Object;
	  // html.removeChild(iframe);
	  iframeDocument = iframe.contentWindow.document;
	  iframeDocument.open();
	  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	  iframeDocument.close();
	  createDict = iframeDocument.F;
	  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
	  return createDict();
	};
	
	module.exports = Object.create || function create(O, Properties) {
	  var result;
	  if (O !== null) {
	    Empty[PROTOTYPE] = anObject(O);
	    result = new Empty();
	    Empty[PROTOTYPE] = null;
	    // add "__proto__" for Object.getPrototypeOf polyfill
	    result[IE_PROTO] = O;
	  } else result = createDict();
	  return Properties === undefined ? result : dPs(result, Properties);
	};


/***/ },
/* 173 */
/***/ function(module, exports) {

	exports.f = Object.getOwnPropertySymbols;


/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	var def = __webpack_require__(49).f;
	var has = __webpack_require__(60);
	var TAG = __webpack_require__(32)('toStringTag');
	
	module.exports = function (it, tag, stat) {
	  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	};


/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	var shared = __webpack_require__(176)('keys');
	var uid = __webpack_require__(127);
	module.exports = function (key) {
	  return shared[key] || (shared[key] = uid(key));
	};


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(48);
	var SHARED = '__core-js_shared__';
	var store = global[SHARED] || (global[SHARED] = {});
	module.exports = function (key) {
	  return store[key] || (store[key] = {});
	};


/***/ },
/* 177 */
/***/ function(module, exports) {

	// 7.1.4 ToInteger
	var ceil = Math.ceil;
	var floor = Math.floor;
	module.exports = function (it) {
	  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	};


/***/ },
/* 178 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.1 ToPrimitive(input [, PreferredType])
	var isObject = __webpack_require__(72);
	// instead of the ES6 spec version, we didn't implement @@toPrimitive case
	// and the second argument - flag - preferred type is a string
	module.exports = function (it, S) {
	  if (!isObject(it)) return it;
	  var fn, val;
	  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	  throw TypeError("Can't convert object to primitive value");
	};


/***/ },
/* 179 */
/***/ function(module, exports, __webpack_require__) {

	var global = __webpack_require__(48);
	var core = __webpack_require__(21);
	var LIBRARY = __webpack_require__(171);
	var wksExt = __webpack_require__(180);
	var defineProperty = __webpack_require__(49).f;
	module.exports = function (name) {
	  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	};


/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	exports.f = __webpack_require__(32);


/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(537);
	var global = __webpack_require__(48);
	var hide = __webpack_require__(71);
	var Iterators = __webpack_require__(73);
	var TO_STRING_TAG = __webpack_require__(32)('toStringTag');
	
	var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
	  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
	  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
	  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
	  'TextTrackList,TouchList').split(',');
	
	for (var i = 0; i < DOMIterables.length; i++) {
	  var NAME = DOMIterables[i];
	  var Collection = global[NAME];
	  var proto = Collection && Collection.prototype;
	  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	  Iterators[NAME] = Iterators.Array;
	}


/***/ },
/* 182 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isPrefixedValue;
	var regex = /-webkit-|-moz-|-ms-/;
	
	function isPrefixedValue(value) {
	  return typeof value === 'string' && regex.test(value);
	}
	module.exports = exports['default'];

/***/ },
/* 183 */
/***/ function(module, exports, __webpack_require__) {

	/*
		pseudo selectors
	
		---
	
		they are available in two forms:
		* filters called when the selector
		  is compiled and return a function
		  that needs to return next()
		* pseudos get called on execution
		  they need to return a boolean
	*/
	
	var DomUtils    = __webpack_require__(75),
	    isTag       = DomUtils.isTag,
	    getText     = DomUtils.getText,
	    getParent   = DomUtils.getParent,
	    getChildren = DomUtils.getChildren,
	    getSiblings = DomUtils.getSiblings,
	    hasAttrib   = DomUtils.hasAttrib,
	    getName     = DomUtils.getName,
	    getAttribute= DomUtils.getAttributeValue,
	    getNCheck   = __webpack_require__(1846),
	    checkAttrib = __webpack_require__(271).rules.equals,
	    BaseFuncs   = __webpack_require__(98),
	    trueFunc    = BaseFuncs.trueFunc,
	    falseFunc   = BaseFuncs.falseFunc;
	
	//helper methods
	function getFirstElement(elems){
		for(var i = 0; elems && i < elems.length; i++){
			if(isTag(elems[i])) return elems[i];
		}
	}
	
	function getAttribFunc(name, value){
		var data = {name: name, value: value};
		return function attribFunc(next){
			return checkAttrib(next, data);
		};
	}
	
	function getChildFunc(next){
		return function(elem){
			return !!getParent(elem) && next(elem);
		};
	}
	
	var filters = {
		contains: function(next, text){
			return function contains(elem){
				return next(elem) && getText(elem).indexOf(text) >= 0;
			};
		},
		icontains: function(next, text){
			var itext = text.toLowerCase();
			return function icontains(elem){
				return next(elem) &&
					getText(elem).toLowerCase().indexOf(itext) >= 0;
			};
		},
	
		//location specific methods
		"nth-child": function(next, rule){
			var func = getNCheck(rule);
	
			if(func === falseFunc) return func;
			if(func === trueFunc)  return getChildFunc(next);
	
			return function nthChild(elem){
				var siblings = getSiblings(elem);
	
				for(var i = 0, pos = 0; i < siblings.length; i++){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						else pos++;
					}
				}
	
				return func(pos) && next(elem);
			};
		},
		"nth-last-child": function(next, rule){
			var func = getNCheck(rule);
	
			if(func === falseFunc) return func;
			if(func === trueFunc)  return getChildFunc(next);
	
			return function nthLastChild(elem){
				var siblings = getSiblings(elem);
	
				for(var pos = 0, i = siblings.length - 1; i >= 0; i--){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						else pos++;
					}
				}
	
				return func(pos) && next(elem);
			};
		},
		"nth-of-type": function(next, rule){
			var func = getNCheck(rule);
	
			if(func === falseFunc) return func;
			if(func === trueFunc)  return getChildFunc(next);
	
			return function nthOfType(elem){
				var siblings = getSiblings(elem);
	
				for(var pos = 0, i = 0; i < siblings.length; i++){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						if(getName(siblings[i]) === getName(elem)) pos++;
					}
				}
	
				return func(pos) && next(elem);
			};
		},
		"nth-last-of-type": function(next, rule){
			var func = getNCheck(rule);
	
			if(func === falseFunc) return func;
			if(func === trueFunc)  return getChildFunc(next);
	
			return function nthLastOfType(elem){
				var siblings = getSiblings(elem);
	
				for(var pos = 0, i = siblings.length - 1; i >= 0; i--){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						if(getName(siblings[i]) === getName(elem)) pos++;
					}
				}
	
				return func(pos) && next(elem);
			};
		},
	
	    //TODO determine the actual root element
	    root: function(next){
	        return function(elem){
	            return !getParent(elem) && next(elem);
	        };
	    },
	
	    scope: function(next, rule, options, context){
	        if(!context || context.length === 0){
	            //equivalent to :root
	            return filters.root(next);
	        }
	
	        if(context.length === 1){
	            //NOTE: can't be unpacked, as :has uses this for side-effects
	            return function(elem){
	                return context[0] === elem && next(elem);
	            };
	        }
	
	        return function(elem){
	            return context.indexOf(elem) >= 0 && next(elem);
	        };
	    },
	
		//jQuery extensions (others follow as pseudos)
		checkbox: getAttribFunc("type", "checkbox"),
		file: getAttribFunc("type", "file"),
		password: getAttribFunc("type", "password"),
		radio: getAttribFunc("type", "radio"),
		reset: getAttribFunc("type", "reset"),
		image: getAttribFunc("type", "image"),
		submit: getAttribFunc("type", "submit")
	};
	
	//while filters are precompiled, pseudos get called when they are needed
	var pseudos = {
		empty: function(elem){
			return !getChildren(elem).some(function(elem){
				return isTag(elem) || elem.type === "text";
			});
		},
	
		"first-child": function(elem){
			return getFirstElement(getSiblings(elem)) === elem;
		},
		"last-child": function(elem){
			var siblings = getSiblings(elem);
	
			for(var i = siblings.length - 1; i >= 0; i--){
				if(siblings[i] === elem) return true;
				if(isTag(siblings[i])) break;
			}
	
			return false;
		},
		"first-of-type": function(elem){
			var siblings = getSiblings(elem);
	
			for(var i = 0; i < siblings.length; i++){
				if(isTag(siblings[i])){
					if(siblings[i] === elem) return true;
					if(getName(siblings[i]) === getName(elem)) break;
				}
			}
	
			return false;
		},
		"last-of-type": function(elem){
			var siblings = getSiblings(elem);
	
			for(var i = siblings.length-1; i >= 0; i--){
				if(isTag(siblings[i])){
					if(siblings[i] === elem) return true;
					if(getName(siblings[i]) === getName(elem)) break;
				}
			}
	
			return false;
		},
		"only-of-type": function(elem){
			var siblings = getSiblings(elem);
	
			for(var i = 0, j = siblings.length; i < j; i++){
				if(isTag(siblings[i])){
					if(siblings[i] === elem) continue;
					if(getName(siblings[i]) === getName(elem)) return false;
				}
			}
	
			return true;
		},
		"only-child": function(elem){
			var siblings = getSiblings(elem);
	
			for(var i = 0; i < siblings.length; i++){
				if(isTag(siblings[i]) && siblings[i] !== elem) return false;
			}
	
			return true;
		},
	
		//:matches(a, area, link)[href]
		link: function(elem){
			return hasAttrib(elem, "href");
		},
		visited: falseFunc, //seems to be a valid implementation
		//TODO: :any-link once the name is finalized (as an alias of :link)
	
		//forms
		//to consider: :target
	
		//:matches([selected], select:not([multiple]):not(> option[selected]) > option:first-of-type)
		selected: function(elem){
			if(hasAttrib(elem, "selected")) return true;
			else if(getName(elem) !== "option") return false;
	
			//the first <option> in a <select> is also selected
			var parent = getParent(elem);
	
			if(
				!parent ||
				getName(parent) !== "select" ||
				hasAttrib(parent, "multiple")
			) return false;
	
			var siblings = getChildren(parent),
				sawElem  = false;
	
			for(var i = 0; i < siblings.length; i++){
				if(isTag(siblings[i])){
					if(siblings[i] === elem){
						sawElem = true;
					} else if(!sawElem){
						return false;
					} else if(hasAttrib(siblings[i], "selected")){
						return false;
					}
				}
			}
	
			return sawElem;
		},
		//https://html.spec.whatwg.org/multipage/scripting.html#disabled-elements
		//:matches(
		//  :matches(button, input, select, textarea, menuitem, optgroup, option)[disabled],
		//  optgroup[disabled] > option),
		// fieldset[disabled] * //TODO not child of first <legend>
		//)
		disabled: function(elem){
			return hasAttrib(elem, "disabled");
		},
		enabled: function(elem){
			return !hasAttrib(elem, "disabled");
		},
		//:matches(:matches(:radio, :checkbox)[checked], :selected) (TODO menuitem)
		checked: function(elem){
			return hasAttrib(elem, "checked") || pseudos.selected(elem);
		},
		//:matches(input, select, textarea)[required]
		required: function(elem){
			return hasAttrib(elem, "required");
		},
		//:matches(input, select, textarea):not([required])
		optional: function(elem){
			return !hasAttrib(elem, "required");
		},
	
		//jQuery extensions
	
		//:not(:empty)
		parent: function(elem){
			return !pseudos.empty(elem);
		},
		//:matches(h1, h2, h3, h4, h5, h6)
		header: function(elem){
			var name = getName(elem);
			return name === "h1" ||
			       name === "h2" ||
			       name === "h3" ||
			       name === "h4" ||
			       name === "h5" ||
			       name === "h6";
		},
	
		//:matches(button, input[type=button])
		button: function(elem){
			var name = getName(elem);
			return name === "button" ||
			       name === "input" &&
			       getAttribute(elem, "type") === "button";
		},
		//:matches(input, textarea, select, button)
		input: function(elem){
			var name = getName(elem);
			return name === "input" ||
			       name === "textarea" ||
			       name === "select" ||
			       name === "button";
		},
		//input:matches(:not([type!='']), [type='text' i])
		text: function(elem){
			var attr;
			return getName(elem) === "input" && (
				!(attr = getAttribute(elem, "type")) ||
				attr.toLowerCase() === "text"
			);
		}
	};
	
	function verifyArgs(func, name, subselect){
		if(subselect === null){
			if(func.length > 1 && name !== "scope"){
				throw new SyntaxError("pseudo-selector :" + name + " requires an argument");
			}
		} else {
			if(func.length === 1){
				throw new SyntaxError("pseudo-selector :" + name + " doesn't have any arguments");
			}
		}
	}
	
	//FIXME this feels hacky
	var re_CSS3 = /^(?:(?:nth|last|first|only)-(?:child|of-type)|root|empty|(?:en|dis)abled|checked|not)$/;
	
	module.exports = {
		compile: function(next, data, options, context){
			var name = data.name,
				subselect = data.data;
	
			if(options && options.strict && !re_CSS3.test(name)){
				throw SyntaxError(":" + name + " isn't part of CSS3");
			}
	
			if(typeof filters[name] === "function"){
				verifyArgs(filters[name], name,  subselect);
				return filters[name](next, subselect, options, context);
			} else if(typeof pseudos[name] === "function"){
				var func = pseudos[name];
				verifyArgs(func, name, subselect);
	
				if(next === trueFunc) return func;
	
				return function pseudoArgs(elem){
					return func(elem, subselect) && next(elem);
				};
			} else {
				throw new SyntaxError("unmatched pseudo-class :" + name);
			}
		},
		filters: filters,
		pseudos: pseudos
	};


/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	/*
	  Module dependencies
	*/
	var ElementType = __webpack_require__(553);
	var entities = __webpack_require__(562);
	
	/*
	  Boolean Attributes
	*/
	var booleanAttributes = {
	  __proto__: null,
	  allowfullscreen: true,
	  async: true,
	  autofocus: true,
	  autoplay: true,
	  checked: true,
	  controls: true,
	  default: true,
	  defer: true,
	  disabled: true,
	  hidden: true,
	  ismap: true,
	  loop: true,
	  multiple: true,
	  muted: true,
	  open: true,
	  readonly: true,
	  required: true,
	  reversed: true,
	  scoped: true,
	  seamless: true,
	  selected: true,
	  typemustmatch: true
	};
	
	var unencodedElements = {
	  __proto__: null,
	  style: true,
	  script: true,
	  xmp: true,
	  iframe: true,
	  noembed: true,
	  noframes: true,
	  plaintext: true,
	  noscript: true
	};
	
	/*
	  Format attributes
	*/
	function formatAttrs(attributes, opts) {
	  if (!attributes) return;
	
	  var output = '',
	      value;
	
	  // Loop through the attributes
	  for (var key in attributes) {
	    value = attributes[key];
	    if (output) {
	      output += ' ';
	    }
	
	    if (!value && booleanAttributes[key]) {
	      output += key;
	    } else {
	      output += key + '="' + (opts.decodeEntities ? entities.encodeXML(value) : value) + '"';
	    }
	  }
	
	  return output;
	}
	
	/*
	  Self-enclosing tags (stolen from node-htmlparser)
	*/
	var singleTag = {
	  __proto__: null,
	  area: true,
	  base: true,
	  basefont: true,
	  br: true,
	  col: true,
	  command: true,
	  embed: true,
	  frame: true,
	  hr: true,
	  img: true,
	  input: true,
	  isindex: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true,
	};
	
	
	var render = module.exports = function(dom, opts) {
	  if (!Array.isArray(dom) && !dom.cheerio) dom = [dom];
	  opts = opts || {};
	
	  var output = '';
	
	  for(var i = 0; i < dom.length; i++){
	    var elem = dom[i];
	
	    if (elem.type === 'root')
	      output += render(elem.children, opts);
	    else if (ElementType.isTag(elem))
	      output += renderTag(elem, opts);
	    else if (elem.type === ElementType.Directive)
	      output += renderDirective(elem);
	    else if (elem.type === ElementType.Comment)
	      output += renderComment(elem);
	    else if (elem.type === ElementType.CDATA)
	      output += renderCdata(elem);
	    else
	      output += renderText(elem, opts);
	  }
	
	  return output;
	};
	
	function renderTag(elem, opts) {
	  // Handle SVG
	  if (elem.name === "svg") opts = {decodeEntities: opts.decodeEntities, xmlMode: true};
	
	  var tag = '<' + elem.name,
	      attribs = formatAttrs(elem.attribs, opts);
	
	  if (attribs) {
	    tag += ' ' + attribs;
	  }
	
	  if (
	    opts.xmlMode
	    && (!elem.children || elem.children.length === 0)
	  ) {
	    tag += '/>';
	  } else {
	    tag += '>';
	    if (elem.children) {
	      tag += render(elem.children, opts);
	    }
	
	    if (!singleTag[elem.name] || opts.xmlMode) {
	      tag += '</' + elem.name + '>';
	    }
	  }
	
	  return tag;
	}
	
	function renderDirective(elem) {
	  return '<' + elem.data + '>';
	}
	
	function renderText(elem, opts) {
	  var data = elem.data || '';
	
	  // if entities weren't decoded, no need to encode them back
	  if (opts.decodeEntities && !(elem.parent && elem.parent.name in unencodedElements)) {
	    data = entities.encodeXML(data);
	  }
	
	  return data;
	}
	
	function renderCdata(elem) {
	  return '<![CDATA[' + elem.children[0].data + ']]>';
	}
	
	function renderComment(elem) {
	  return '<!--' + elem.data + '-->';
	}


/***/ },
/* 185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createTransitionManager = function createTransitionManager() {
	  var prompt = null;
	
	  var setPrompt = function setPrompt(nextPrompt) {
	    (0, _warning2.default)(prompt == null, 'A history supports only one prompt at a time');
	
	    prompt = nextPrompt;
	
	    return function () {
	      if (prompt === nextPrompt) prompt = null;
	    };
	  };
	
	  var confirmTransitionTo = function confirmTransitionTo(location, action, getUserConfirmation, callback) {
	    // TODO: If another transition starts while we're still confirming
	    // the previous one, we may end up in a weird state. Figure out the
	    // best way to handle this.
	    if (prompt != null) {
	      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;
	
	      if (typeof result === 'string') {
	        if (typeof getUserConfirmation === 'function') {
	          getUserConfirmation(result, callback);
	        } else {
	          (0, _warning2.default)(false, 'A history needs a getUserConfirmation function in order to use a prompt message');
	
	          callback(true);
	        }
	      } else {
	        // Return false from a transition hook to cancel the transition.
	        callback(result !== false);
	      }
	    } else {
	      callback(true);
	    }
	  };
	
	  var listeners = [];
	
	  var appendListener = function appendListener(fn) {
	    var isActive = true;
	
	    var listener = function listener() {
	      if (isActive) fn.apply(undefined, arguments);
	    };
	
	    listeners.push(listener);
	
	    return function () {
	      isActive = false;
	      listeners = listeners.filter(function (item) {
	        return item !== listener;
	      });
	    };
	  };
	
	  var notifyListeners = function notifyListeners() {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    listeners.forEach(function (listener) {
	      return listener.apply(undefined, args);
	    });
	  };
	
	  return {
	    setPrompt: setPrompt,
	    confirmTransitionTo: confirmTransitionTo,
	    appendListener: appendListener,
	    notifyListeners: notifyListeners
	  };
	};
	
	exports.default = createTransitionManager;

/***/ },
/* 186 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalizeString;
	function capitalizeString(str) {
	  return str.charAt(0).toUpperCase() + str.slice(1);
	}
	module.exports = exports["default"];

/***/ },
/* 187 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Abreve": "Ă",
		"abreve": "ă",
		"ac": "∾",
		"acd": "∿",
		"acE": "∾̳",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"Acy": "А",
		"acy": "а",
		"AElig": "Æ",
		"aelig": "æ",
		"af": "⁡",
		"Afr": "𝔄",
		"afr": "𝔞",
		"Agrave": "À",
		"agrave": "à",
		"alefsym": "ℵ",
		"aleph": "ℵ",
		"Alpha": "Α",
		"alpha": "α",
		"Amacr": "Ā",
		"amacr": "ā",
		"amalg": "⨿",
		"amp": "&",
		"AMP": "&",
		"andand": "⩕",
		"And": "⩓",
		"and": "∧",
		"andd": "⩜",
		"andslope": "⩘",
		"andv": "⩚",
		"ang": "∠",
		"ange": "⦤",
		"angle": "∠",
		"angmsdaa": "⦨",
		"angmsdab": "⦩",
		"angmsdac": "⦪",
		"angmsdad": "⦫",
		"angmsdae": "⦬",
		"angmsdaf": "⦭",
		"angmsdag": "⦮",
		"angmsdah": "⦯",
		"angmsd": "∡",
		"angrt": "∟",
		"angrtvb": "⊾",
		"angrtvbd": "⦝",
		"angsph": "∢",
		"angst": "Å",
		"angzarr": "⍼",
		"Aogon": "Ą",
		"aogon": "ą",
		"Aopf": "𝔸",
		"aopf": "𝕒",
		"apacir": "⩯",
		"ap": "≈",
		"apE": "⩰",
		"ape": "≊",
		"apid": "≋",
		"apos": "'",
		"ApplyFunction": "⁡",
		"approx": "≈",
		"approxeq": "≊",
		"Aring": "Å",
		"aring": "å",
		"Ascr": "𝒜",
		"ascr": "𝒶",
		"Assign": "≔",
		"ast": "*",
		"asymp": "≈",
		"asympeq": "≍",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"awconint": "∳",
		"awint": "⨑",
		"backcong": "≌",
		"backepsilon": "϶",
		"backprime": "‵",
		"backsim": "∽",
		"backsimeq": "⋍",
		"Backslash": "∖",
		"Barv": "⫧",
		"barvee": "⊽",
		"barwed": "⌅",
		"Barwed": "⌆",
		"barwedge": "⌅",
		"bbrk": "⎵",
		"bbrktbrk": "⎶",
		"bcong": "≌",
		"Bcy": "Б",
		"bcy": "б",
		"bdquo": "„",
		"becaus": "∵",
		"because": "∵",
		"Because": "∵",
		"bemptyv": "⦰",
		"bepsi": "϶",
		"bernou": "ℬ",
		"Bernoullis": "ℬ",
		"Beta": "Β",
		"beta": "β",
		"beth": "ℶ",
		"between": "≬",
		"Bfr": "𝔅",
		"bfr": "𝔟",
		"bigcap": "⋂",
		"bigcirc": "◯",
		"bigcup": "⋃",
		"bigodot": "⨀",
		"bigoplus": "⨁",
		"bigotimes": "⨂",
		"bigsqcup": "⨆",
		"bigstar": "★",
		"bigtriangledown": "▽",
		"bigtriangleup": "△",
		"biguplus": "⨄",
		"bigvee": "⋁",
		"bigwedge": "⋀",
		"bkarow": "⤍",
		"blacklozenge": "⧫",
		"blacksquare": "▪",
		"blacktriangle": "▴",
		"blacktriangledown": "▾",
		"blacktriangleleft": "◂",
		"blacktriangleright": "▸",
		"blank": "␣",
		"blk12": "▒",
		"blk14": "░",
		"blk34": "▓",
		"block": "█",
		"bne": "=⃥",
		"bnequiv": "≡⃥",
		"bNot": "⫭",
		"bnot": "⌐",
		"Bopf": "𝔹",
		"bopf": "𝕓",
		"bot": "⊥",
		"bottom": "⊥",
		"bowtie": "⋈",
		"boxbox": "⧉",
		"boxdl": "┐",
		"boxdL": "╕",
		"boxDl": "╖",
		"boxDL": "╗",
		"boxdr": "┌",
		"boxdR": "╒",
		"boxDr": "╓",
		"boxDR": "╔",
		"boxh": "─",
		"boxH": "═",
		"boxhd": "┬",
		"boxHd": "╤",
		"boxhD": "╥",
		"boxHD": "╦",
		"boxhu": "┴",
		"boxHu": "╧",
		"boxhU": "╨",
		"boxHU": "╩",
		"boxminus": "⊟",
		"boxplus": "⊞",
		"boxtimes": "⊠",
		"boxul": "┘",
		"boxuL": "╛",
		"boxUl": "╜",
		"boxUL": "╝",
		"boxur": "└",
		"boxuR": "╘",
		"boxUr": "╙",
		"boxUR": "╚",
		"boxv": "│",
		"boxV": "║",
		"boxvh": "┼",
		"boxvH": "╪",
		"boxVh": "╫",
		"boxVH": "╬",
		"boxvl": "┤",
		"boxvL": "╡",
		"boxVl": "╢",
		"boxVL": "╣",
		"boxvr": "├",
		"boxvR": "╞",
		"boxVr": "╟",
		"boxVR": "╠",
		"bprime": "‵",
		"breve": "˘",
		"Breve": "˘",
		"brvbar": "¦",
		"bscr": "𝒷",
		"Bscr": "ℬ",
		"bsemi": "⁏",
		"bsim": "∽",
		"bsime": "⋍",
		"bsolb": "⧅",
		"bsol": "\\",
		"bsolhsub": "⟈",
		"bull": "•",
		"bullet": "•",
		"bump": "≎",
		"bumpE": "⪮",
		"bumpe": "≏",
		"Bumpeq": "≎",
		"bumpeq": "≏",
		"Cacute": "Ć",
		"cacute": "ć",
		"capand": "⩄",
		"capbrcup": "⩉",
		"capcap": "⩋",
		"cap": "∩",
		"Cap": "⋒",
		"capcup": "⩇",
		"capdot": "⩀",
		"CapitalDifferentialD": "ⅅ",
		"caps": "∩︀",
		"caret": "⁁",
		"caron": "ˇ",
		"Cayleys": "ℭ",
		"ccaps": "⩍",
		"Ccaron": "Č",
		"ccaron": "č",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"Ccirc": "Ĉ",
		"ccirc": "ĉ",
		"Cconint": "∰",
		"ccups": "⩌",
		"ccupssm": "⩐",
		"Cdot": "Ċ",
		"cdot": "ċ",
		"cedil": "¸",
		"Cedilla": "¸",
		"cemptyv": "⦲",
		"cent": "¢",
		"centerdot": "·",
		"CenterDot": "·",
		"cfr": "𝔠",
		"Cfr": "ℭ",
		"CHcy": "Ч",
		"chcy": "ч",
		"check": "✓",
		"checkmark": "✓",
		"Chi": "Χ",
		"chi": "χ",
		"circ": "ˆ",
		"circeq": "≗",
		"circlearrowleft": "↺",
		"circlearrowright": "↻",
		"circledast": "⊛",
		"circledcirc": "⊚",
		"circleddash": "⊝",
		"CircleDot": "⊙",
		"circledR": "®",
		"circledS": "Ⓢ",
		"CircleMinus": "⊖",
		"CirclePlus": "⊕",
		"CircleTimes": "⊗",
		"cir": "○",
		"cirE": "⧃",
		"cire": "≗",
		"cirfnint": "⨐",
		"cirmid": "⫯",
		"cirscir": "⧂",
		"ClockwiseContourIntegral": "∲",
		"CloseCurlyDoubleQuote": "”",
		"CloseCurlyQuote": "’",
		"clubs": "♣",
		"clubsuit": "♣",
		"colon": ":",
		"Colon": "∷",
		"Colone": "⩴",
		"colone": "≔",
		"coloneq": "≔",
		"comma": ",",
		"commat": "@",
		"comp": "∁",
		"compfn": "∘",
		"complement": "∁",
		"complexes": "ℂ",
		"cong": "≅",
		"congdot": "⩭",
		"Congruent": "≡",
		"conint": "∮",
		"Conint": "∯",
		"ContourIntegral": "∮",
		"copf": "𝕔",
		"Copf": "ℂ",
		"coprod": "∐",
		"Coproduct": "∐",
		"copy": "©",
		"COPY": "©",
		"copysr": "℗",
		"CounterClockwiseContourIntegral": "∳",
		"crarr": "↵",
		"cross": "✗",
		"Cross": "⨯",
		"Cscr": "𝒞",
		"cscr": "𝒸",
		"csub": "⫏",
		"csube": "⫑",
		"csup": "⫐",
		"csupe": "⫒",
		"ctdot": "⋯",
		"cudarrl": "⤸",
		"cudarrr": "⤵",
		"cuepr": "⋞",
		"cuesc": "⋟",
		"cularr": "↶",
		"cularrp": "⤽",
		"cupbrcap": "⩈",
		"cupcap": "⩆",
		"CupCap": "≍",
		"cup": "∪",
		"Cup": "⋓",
		"cupcup": "⩊",
		"cupdot": "⊍",
		"cupor": "⩅",
		"cups": "∪︀",
		"curarr": "↷",
		"curarrm": "⤼",
		"curlyeqprec": "⋞",
		"curlyeqsucc": "⋟",
		"curlyvee": "⋎",
		"curlywedge": "⋏",
		"curren": "¤",
		"curvearrowleft": "↶",
		"curvearrowright": "↷",
		"cuvee": "⋎",
		"cuwed": "⋏",
		"cwconint": "∲",
		"cwint": "∱",
		"cylcty": "⌭",
		"dagger": "†",
		"Dagger": "‡",
		"daleth": "ℸ",
		"darr": "↓",
		"Darr": "↡",
		"dArr": "⇓",
		"dash": "‐",
		"Dashv": "⫤",
		"dashv": "⊣",
		"dbkarow": "⤏",
		"dblac": "˝",
		"Dcaron": "Ď",
		"dcaron": "ď",
		"Dcy": "Д",
		"dcy": "д",
		"ddagger": "‡",
		"ddarr": "⇊",
		"DD": "ⅅ",
		"dd": "ⅆ",
		"DDotrahd": "⤑",
		"ddotseq": "⩷",
		"deg": "°",
		"Del": "∇",
		"Delta": "Δ",
		"delta": "δ",
		"demptyv": "⦱",
		"dfisht": "⥿",
		"Dfr": "𝔇",
		"dfr": "𝔡",
		"dHar": "⥥",
		"dharl": "⇃",
		"dharr": "⇂",
		"DiacriticalAcute": "´",
		"DiacriticalDot": "˙",
		"DiacriticalDoubleAcute": "˝",
		"DiacriticalGrave": "`",
		"DiacriticalTilde": "˜",
		"diam": "⋄",
		"diamond": "⋄",
		"Diamond": "⋄",
		"diamondsuit": "♦",
		"diams": "♦",
		"die": "¨",
		"DifferentialD": "ⅆ",
		"digamma": "ϝ",
		"disin": "⋲",
		"div": "÷",
		"divide": "÷",
		"divideontimes": "⋇",
		"divonx": "⋇",
		"DJcy": "Ђ",
		"djcy": "ђ",
		"dlcorn": "⌞",
		"dlcrop": "⌍",
		"dollar": "$",
		"Dopf": "𝔻",
		"dopf": "𝕕",
		"Dot": "¨",
		"dot": "˙",
		"DotDot": "⃜",
		"doteq": "≐",
		"doteqdot": "≑",
		"DotEqual": "≐",
		"dotminus": "∸",
		"dotplus": "∔",
		"dotsquare": "⊡",
		"doublebarwedge": "⌆",
		"DoubleContourIntegral": "∯",
		"DoubleDot": "¨",
		"DoubleDownArrow": "⇓",
		"DoubleLeftArrow": "⇐",
		"DoubleLeftRightArrow": "⇔",
		"DoubleLeftTee": "⫤",
		"DoubleLongLeftArrow": "⟸",
		"DoubleLongLeftRightArrow": "⟺",
		"DoubleLongRightArrow": "⟹",
		"DoubleRightArrow": "⇒",
		"DoubleRightTee": "⊨",
		"DoubleUpArrow": "⇑",
		"DoubleUpDownArrow": "⇕",
		"DoubleVerticalBar": "∥",
		"DownArrowBar": "⤓",
		"downarrow": "↓",
		"DownArrow": "↓",
		"Downarrow": "⇓",
		"DownArrowUpArrow": "⇵",
		"DownBreve": "̑",
		"downdownarrows": "⇊",
		"downharpoonleft": "⇃",
		"downharpoonright": "⇂",
		"DownLeftRightVector": "⥐",
		"DownLeftTeeVector": "⥞",
		"DownLeftVectorBar": "⥖",
		"DownLeftVector": "↽",
		"DownRightTeeVector": "⥟",
		"DownRightVectorBar": "⥗",
		"DownRightVector": "⇁",
		"DownTeeArrow": "↧",
		"DownTee": "⊤",
		"drbkarow": "⤐",
		"drcorn": "⌟",
		"drcrop": "⌌",
		"Dscr": "𝒟",
		"dscr": "𝒹",
		"DScy": "Ѕ",
		"dscy": "ѕ",
		"dsol": "⧶",
		"Dstrok": "Đ",
		"dstrok": "đ",
		"dtdot": "⋱",
		"dtri": "▿",
		"dtrif": "▾",
		"duarr": "⇵",
		"duhar": "⥯",
		"dwangle": "⦦",
		"DZcy": "Џ",
		"dzcy": "џ",
		"dzigrarr": "⟿",
		"Eacute": "É",
		"eacute": "é",
		"easter": "⩮",
		"Ecaron": "Ě",
		"ecaron": "ě",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"ecir": "≖",
		"ecolon": "≕",
		"Ecy": "Э",
		"ecy": "э",
		"eDDot": "⩷",
		"Edot": "Ė",
		"edot": "ė",
		"eDot": "≑",
		"ee": "ⅇ",
		"efDot": "≒",
		"Efr": "𝔈",
		"efr": "𝔢",
		"eg": "⪚",
		"Egrave": "È",
		"egrave": "è",
		"egs": "⪖",
		"egsdot": "⪘",
		"el": "⪙",
		"Element": "∈",
		"elinters": "⏧",
		"ell": "ℓ",
		"els": "⪕",
		"elsdot": "⪗",
		"Emacr": "Ē",
		"emacr": "ē",
		"empty": "∅",
		"emptyset": "∅",
		"EmptySmallSquare": "◻",
		"emptyv": "∅",
		"EmptyVerySmallSquare": "▫",
		"emsp13": " ",
		"emsp14": " ",
		"emsp": " ",
		"ENG": "Ŋ",
		"eng": "ŋ",
		"ensp": " ",
		"Eogon": "Ę",
		"eogon": "ę",
		"Eopf": "𝔼",
		"eopf": "𝕖",
		"epar": "⋕",
		"eparsl": "⧣",
		"eplus": "⩱",
		"epsi": "ε",
		"Epsilon": "Ε",
		"epsilon": "ε",
		"epsiv": "ϵ",
		"eqcirc": "≖",
		"eqcolon": "≕",
		"eqsim": "≂",
		"eqslantgtr": "⪖",
		"eqslantless": "⪕",
		"Equal": "⩵",
		"equals": "=",
		"EqualTilde": "≂",
		"equest": "≟",
		"Equilibrium": "⇌",
		"equiv": "≡",
		"equivDD": "⩸",
		"eqvparsl": "⧥",
		"erarr": "⥱",
		"erDot": "≓",
		"escr": "ℯ",
		"Escr": "ℰ",
		"esdot": "≐",
		"Esim": "⩳",
		"esim": "≂",
		"Eta": "Η",
		"eta": "η",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"euro": "€",
		"excl": "!",
		"exist": "∃",
		"Exists": "∃",
		"expectation": "ℰ",
		"exponentiale": "ⅇ",
		"ExponentialE": "ⅇ",
		"fallingdotseq": "≒",
		"Fcy": "Ф",
		"fcy": "ф",
		"female": "♀",
		"ffilig": "ﬃ",
		"fflig": "ﬀ",
		"ffllig": "ﬄ",
		"Ffr": "𝔉",
		"ffr": "𝔣",
		"filig": "ﬁ",
		"FilledSmallSquare": "◼",
		"FilledVerySmallSquare": "▪",
		"fjlig": "fj",
		"flat": "♭",
		"fllig": "ﬂ",
		"fltns": "▱",
		"fnof": "ƒ",
		"Fopf": "𝔽",
		"fopf": "𝕗",
		"forall": "∀",
		"ForAll": "∀",
		"fork": "⋔",
		"forkv": "⫙",
		"Fouriertrf": "ℱ",
		"fpartint": "⨍",
		"frac12": "½",
		"frac13": "⅓",
		"frac14": "¼",
		"frac15": "⅕",
		"frac16": "⅙",
		"frac18": "⅛",
		"frac23": "⅔",
		"frac25": "⅖",
		"frac34": "¾",
		"frac35": "⅗",
		"frac38": "⅜",
		"frac45": "⅘",
		"frac56": "⅚",
		"frac58": "⅝",
		"frac78": "⅞",
		"frasl": "⁄",
		"frown": "⌢",
		"fscr": "𝒻",
		"Fscr": "ℱ",
		"gacute": "ǵ",
		"Gamma": "Γ",
		"gamma": "γ",
		"Gammad": "Ϝ",
		"gammad": "ϝ",
		"gap": "⪆",
		"Gbreve": "Ğ",
		"gbreve": "ğ",
		"Gcedil": "Ģ",
		"Gcirc": "Ĝ",
		"gcirc": "ĝ",
		"Gcy": "Г",
		"gcy": "г",
		"Gdot": "Ġ",
		"gdot": "ġ",
		"ge": "≥",
		"gE": "≧",
		"gEl": "⪌",
		"gel": "⋛",
		"geq": "≥",
		"geqq": "≧",
		"geqslant": "⩾",
		"gescc": "⪩",
		"ges": "⩾",
		"gesdot": "⪀",
		"gesdoto": "⪂",
		"gesdotol": "⪄",
		"gesl": "⋛︀",
		"gesles": "⪔",
		"Gfr": "𝔊",
		"gfr": "𝔤",
		"gg": "≫",
		"Gg": "⋙",
		"ggg": "⋙",
		"gimel": "ℷ",
		"GJcy": "Ѓ",
		"gjcy": "ѓ",
		"gla": "⪥",
		"gl": "≷",
		"glE": "⪒",
		"glj": "⪤",
		"gnap": "⪊",
		"gnapprox": "⪊",
		"gne": "⪈",
		"gnE": "≩",
		"gneq": "⪈",
		"gneqq": "≩",
		"gnsim": "⋧",
		"Gopf": "𝔾",
		"gopf": "𝕘",
		"grave": "`",
		"GreaterEqual": "≥",
		"GreaterEqualLess": "⋛",
		"GreaterFullEqual": "≧",
		"GreaterGreater": "⪢",
		"GreaterLess": "≷",
		"GreaterSlantEqual": "⩾",
		"GreaterTilde": "≳",
		"Gscr": "𝒢",
		"gscr": "ℊ",
		"gsim": "≳",
		"gsime": "⪎",
		"gsiml": "⪐",
		"gtcc": "⪧",
		"gtcir": "⩺",
		"gt": ">",
		"GT": ">",
		"Gt": "≫",
		"gtdot": "⋗",
		"gtlPar": "⦕",
		"gtquest": "⩼",
		"gtrapprox": "⪆",
		"gtrarr": "⥸",
		"gtrdot": "⋗",
		"gtreqless": "⋛",
		"gtreqqless": "⪌",
		"gtrless": "≷",
		"gtrsim": "≳",
		"gvertneqq": "≩︀",
		"gvnE": "≩︀",
		"Hacek": "ˇ",
		"hairsp": " ",
		"half": "½",
		"hamilt": "ℋ",
		"HARDcy": "Ъ",
		"hardcy": "ъ",
		"harrcir": "⥈",
		"harr": "↔",
		"hArr": "⇔",
		"harrw": "↭",
		"Hat": "^",
		"hbar": "ℏ",
		"Hcirc": "Ĥ",
		"hcirc": "ĥ",
		"hearts": "♥",
		"heartsuit": "♥",
		"hellip": "…",
		"hercon": "⊹",
		"hfr": "𝔥",
		"Hfr": "ℌ",
		"HilbertSpace": "ℋ",
		"hksearow": "⤥",
		"hkswarow": "⤦",
		"hoarr": "⇿",
		"homtht": "∻",
		"hookleftarrow": "↩",
		"hookrightarrow": "↪",
		"hopf": "𝕙",
		"Hopf": "ℍ",
		"horbar": "―",
		"HorizontalLine": "─",
		"hscr": "𝒽",
		"Hscr": "ℋ",
		"hslash": "ℏ",
		"Hstrok": "Ħ",
		"hstrok": "ħ",
		"HumpDownHump": "≎",
		"HumpEqual": "≏",
		"hybull": "⁃",
		"hyphen": "‐",
		"Iacute": "Í",
		"iacute": "í",
		"ic": "⁣",
		"Icirc": "Î",
		"icirc": "î",
		"Icy": "И",
		"icy": "и",
		"Idot": "İ",
		"IEcy": "Е",
		"iecy": "е",
		"iexcl": "¡",
		"iff": "⇔",
		"ifr": "𝔦",
		"Ifr": "ℑ",
		"Igrave": "Ì",
		"igrave": "ì",
		"ii": "ⅈ",
		"iiiint": "⨌",
		"iiint": "∭",
		"iinfin": "⧜",
		"iiota": "℩",
		"IJlig": "Ĳ",
		"ijlig": "ĳ",
		"Imacr": "Ī",
		"imacr": "ī",
		"image": "ℑ",
		"ImaginaryI": "ⅈ",
		"imagline": "ℐ",
		"imagpart": "ℑ",
		"imath": "ı",
		"Im": "ℑ",
		"imof": "⊷",
		"imped": "Ƶ",
		"Implies": "⇒",
		"incare": "℅",
		"in": "∈",
		"infin": "∞",
		"infintie": "⧝",
		"inodot": "ı",
		"intcal": "⊺",
		"int": "∫",
		"Int": "∬",
		"integers": "ℤ",
		"Integral": "∫",
		"intercal": "⊺",
		"Intersection": "⋂",
		"intlarhk": "⨗",
		"intprod": "⨼",
		"InvisibleComma": "⁣",
		"InvisibleTimes": "⁢",
		"IOcy": "Ё",
		"iocy": "ё",
		"Iogon": "Į",
		"iogon": "į",
		"Iopf": "𝕀",
		"iopf": "𝕚",
		"Iota": "Ι",
		"iota": "ι",
		"iprod": "⨼",
		"iquest": "¿",
		"iscr": "𝒾",
		"Iscr": "ℐ",
		"isin": "∈",
		"isindot": "⋵",
		"isinE": "⋹",
		"isins": "⋴",
		"isinsv": "⋳",
		"isinv": "∈",
		"it": "⁢",
		"Itilde": "Ĩ",
		"itilde": "ĩ",
		"Iukcy": "І",
		"iukcy": "і",
		"Iuml": "Ï",
		"iuml": "ï",
		"Jcirc": "Ĵ",
		"jcirc": "ĵ",
		"Jcy": "Й",
		"jcy": "й",
		"Jfr": "𝔍",
		"jfr": "𝔧",
		"jmath": "ȷ",
		"Jopf": "𝕁",
		"jopf": "𝕛",
		"Jscr": "𝒥",
		"jscr": "𝒿",
		"Jsercy": "Ј",
		"jsercy": "ј",
		"Jukcy": "Є",
		"jukcy": "є",
		"Kappa": "Κ",
		"kappa": "κ",
		"kappav": "ϰ",
		"Kcedil": "Ķ",
		"kcedil": "ķ",
		"Kcy": "К",
		"kcy": "к",
		"Kfr": "𝔎",
		"kfr": "𝔨",
		"kgreen": "ĸ",
		"KHcy": "Х",
		"khcy": "х",
		"KJcy": "Ќ",
		"kjcy": "ќ",
		"Kopf": "𝕂",
		"kopf": "𝕜",
		"Kscr": "𝒦",
		"kscr": "𝓀",
		"lAarr": "⇚",
		"Lacute": "Ĺ",
		"lacute": "ĺ",
		"laemptyv": "⦴",
		"lagran": "ℒ",
		"Lambda": "Λ",
		"lambda": "λ",
		"lang": "⟨",
		"Lang": "⟪",
		"langd": "⦑",
		"langle": "⟨",
		"lap": "⪅",
		"Laplacetrf": "ℒ",
		"laquo": "«",
		"larrb": "⇤",
		"larrbfs": "⤟",
		"larr": "←",
		"Larr": "↞",
		"lArr": "⇐",
		"larrfs": "⤝",
		"larrhk": "↩",
		"larrlp": "↫",
		"larrpl": "⤹",
		"larrsim": "⥳",
		"larrtl": "↢",
		"latail": "⤙",
		"lAtail": "⤛",
		"lat": "⪫",
		"late": "⪭",
		"lates": "⪭︀",
		"lbarr": "⤌",
		"lBarr": "⤎",
		"lbbrk": "❲",
		"lbrace": "{",
		"lbrack": "[",
		"lbrke": "⦋",
		"lbrksld": "⦏",
		"lbrkslu": "⦍",
		"Lcaron": "Ľ",
		"lcaron": "ľ",
		"Lcedil": "Ļ",
		"lcedil": "ļ",
		"lceil": "⌈",
		"lcub": "{",
		"Lcy": "Л",
		"lcy": "л",
		"ldca": "⤶",
		"ldquo": "“",
		"ldquor": "„",
		"ldrdhar": "⥧",
		"ldrushar": "⥋",
		"ldsh": "↲",
		"le": "≤",
		"lE": "≦",
		"LeftAngleBracket": "⟨",
		"LeftArrowBar": "⇤",
		"leftarrow": "←",
		"LeftArrow": "←",
		"Leftarrow": "⇐",
		"LeftArrowRightArrow": "⇆",
		"leftarrowtail": "↢",
		"LeftCeiling": "⌈",
		"LeftDoubleBracket": "⟦",
		"LeftDownTeeVector": "⥡",
		"LeftDownVectorBar": "⥙",
		"LeftDownVector": "⇃",
		"LeftFloor": "⌊",
		"leftharpoondown": "↽",
		"leftharpoonup": "↼",
		"leftleftarrows": "⇇",
		"leftrightarrow": "↔",
		"LeftRightArrow": "↔",
		"Leftrightarrow": "⇔",
		"leftrightarrows": "⇆",
		"leftrightharpoons": "⇋",
		"leftrightsquigarrow": "↭",
		"LeftRightVector": "⥎",
		"LeftTeeArrow": "↤",
		"LeftTee": "⊣",
		"LeftTeeVector": "⥚",
		"leftthreetimes": "⋋",
		"LeftTriangleBar": "⧏",
		"LeftTriangle": "⊲",
		"LeftTriangleEqual": "⊴",
		"LeftUpDownVector": "⥑",
		"LeftUpTeeVector": "⥠",
		"LeftUpVectorBar": "⥘",
		"LeftUpVector": "↿",
		"LeftVectorBar": "⥒",
		"LeftVector": "↼",
		"lEg": "⪋",
		"leg": "⋚",
		"leq": "≤",
		"leqq": "≦",
		"leqslant": "⩽",
		"lescc": "⪨",
		"les": "⩽",
		"lesdot": "⩿",
		"lesdoto": "⪁",
		"lesdotor": "⪃",
		"lesg": "⋚︀",
		"lesges": "⪓",
		"lessapprox": "⪅",
		"lessdot": "⋖",
		"lesseqgtr": "⋚",
		"lesseqqgtr": "⪋",
		"LessEqualGreater": "⋚",
		"LessFullEqual": "≦",
		"LessGreater": "≶",
		"lessgtr": "≶",
		"LessLess": "⪡",
		"lesssim": "≲",
		"LessSlantEqual": "⩽",
		"LessTilde": "≲",
		"lfisht": "⥼",
		"lfloor": "⌊",
		"Lfr": "𝔏",
		"lfr": "𝔩",
		"lg": "≶",
		"lgE": "⪑",
		"lHar": "⥢",
		"lhard": "↽",
		"lharu": "↼",
		"lharul": "⥪",
		"lhblk": "▄",
		"LJcy": "Љ",
		"ljcy": "љ",
		"llarr": "⇇",
		"ll": "≪",
		"Ll": "⋘",
		"llcorner": "⌞",
		"Lleftarrow": "⇚",
		"llhard": "⥫",
		"lltri": "◺",
		"Lmidot": "Ŀ",
		"lmidot": "ŀ",
		"lmoustache": "⎰",
		"lmoust": "⎰",
		"lnap": "⪉",
		"lnapprox": "⪉",
		"lne": "⪇",
		"lnE": "≨",
		"lneq": "⪇",
		"lneqq": "≨",
		"lnsim": "⋦",
		"loang": "⟬",
		"loarr": "⇽",
		"lobrk": "⟦",
		"longleftarrow": "⟵",
		"LongLeftArrow": "⟵",
		"Longleftarrow": "⟸",
		"longleftrightarrow": "⟷",
		"LongLeftRightArrow": "⟷",
		"Longleftrightarrow": "⟺",
		"longmapsto": "⟼",
		"longrightarrow": "⟶",
		"LongRightArrow": "⟶",
		"Longrightarrow": "⟹",
		"looparrowleft": "↫",
		"looparrowright": "↬",
		"lopar": "⦅",
		"Lopf": "𝕃",
		"lopf": "𝕝",
		"loplus": "⨭",
		"lotimes": "⨴",
		"lowast": "∗",
		"lowbar": "_",
		"LowerLeftArrow": "↙",
		"LowerRightArrow": "↘",
		"loz": "◊",
		"lozenge": "◊",
		"lozf": "⧫",
		"lpar": "(",
		"lparlt": "⦓",
		"lrarr": "⇆",
		"lrcorner": "⌟",
		"lrhar": "⇋",
		"lrhard": "⥭",
		"lrm": "‎",
		"lrtri": "⊿",
		"lsaquo": "‹",
		"lscr": "𝓁",
		"Lscr": "ℒ",
		"lsh": "↰",
		"Lsh": "↰",
		"lsim": "≲",
		"lsime": "⪍",
		"lsimg": "⪏",
		"lsqb": "[",
		"lsquo": "‘",
		"lsquor": "‚",
		"Lstrok": "Ł",
		"lstrok": "ł",
		"ltcc": "⪦",
		"ltcir": "⩹",
		"lt": "<",
		"LT": "<",
		"Lt": "≪",
		"ltdot": "⋖",
		"lthree": "⋋",
		"ltimes": "⋉",
		"ltlarr": "⥶",
		"ltquest": "⩻",
		"ltri": "◃",
		"ltrie": "⊴",
		"ltrif": "◂",
		"ltrPar": "⦖",
		"lurdshar": "⥊",
		"luruhar": "⥦",
		"lvertneqq": "≨︀",
		"lvnE": "≨︀",
		"macr": "¯",
		"male": "♂",
		"malt": "✠",
		"maltese": "✠",
		"Map": "⤅",
		"map": "↦",
		"mapsto": "↦",
		"mapstodown": "↧",
		"mapstoleft": "↤",
		"mapstoup": "↥",
		"marker": "▮",
		"mcomma": "⨩",
		"Mcy": "М",
		"mcy": "м",
		"mdash": "—",
		"mDDot": "∺",
		"measuredangle": "∡",
		"MediumSpace": " ",
		"Mellintrf": "ℳ",
		"Mfr": "𝔐",
		"mfr": "𝔪",
		"mho": "℧",
		"micro": "µ",
		"midast": "*",
		"midcir": "⫰",
		"mid": "∣",
		"middot": "·",
		"minusb": "⊟",
		"minus": "−",
		"minusd": "∸",
		"minusdu": "⨪",
		"MinusPlus": "∓",
		"mlcp": "⫛",
		"mldr": "…",
		"mnplus": "∓",
		"models": "⊧",
		"Mopf": "𝕄",
		"mopf": "𝕞",
		"mp": "∓",
		"mscr": "𝓂",
		"Mscr": "ℳ",
		"mstpos": "∾",
		"Mu": "Μ",
		"mu": "μ",
		"multimap": "⊸",
		"mumap": "⊸",
		"nabla": "∇",
		"Nacute": "Ń",
		"nacute": "ń",
		"nang": "∠⃒",
		"nap": "≉",
		"napE": "⩰̸",
		"napid": "≋̸",
		"napos": "ŉ",
		"napprox": "≉",
		"natural": "♮",
		"naturals": "ℕ",
		"natur": "♮",
		"nbsp": " ",
		"nbump": "≎̸",
		"nbumpe": "≏̸",
		"ncap": "⩃",
		"Ncaron": "Ň",
		"ncaron": "ň",
		"Ncedil": "Ņ",
		"ncedil": "ņ",
		"ncong": "≇",
		"ncongdot": "⩭̸",
		"ncup": "⩂",
		"Ncy": "Н",
		"ncy": "н",
		"ndash": "–",
		"nearhk": "⤤",
		"nearr": "↗",
		"neArr": "⇗",
		"nearrow": "↗",
		"ne": "≠",
		"nedot": "≐̸",
		"NegativeMediumSpace": "​",
		"NegativeThickSpace": "​",
		"NegativeThinSpace": "​",
		"NegativeVeryThinSpace": "​",
		"nequiv": "≢",
		"nesear": "⤨",
		"nesim": "≂̸",
		"NestedGreaterGreater": "≫",
		"NestedLessLess": "≪",
		"NewLine": "\n",
		"nexist": "∄",
		"nexists": "∄",
		"Nfr": "𝔑",
		"nfr": "𝔫",
		"ngE": "≧̸",
		"nge": "≱",
		"ngeq": "≱",
		"ngeqq": "≧̸",
		"ngeqslant": "⩾̸",
		"nges": "⩾̸",
		"nGg": "⋙̸",
		"ngsim": "≵",
		"nGt": "≫⃒",
		"ngt": "≯",
		"ngtr": "≯",
		"nGtv": "≫̸",
		"nharr": "↮",
		"nhArr": "⇎",
		"nhpar": "⫲",
		"ni": "∋",
		"nis": "⋼",
		"nisd": "⋺",
		"niv": "∋",
		"NJcy": "Њ",
		"njcy": "њ",
		"nlarr": "↚",
		"nlArr": "⇍",
		"nldr": "‥",
		"nlE": "≦̸",
		"nle": "≰",
		"nleftarrow": "↚",
		"nLeftarrow": "⇍",
		"nleftrightarrow": "↮",
		"nLeftrightarrow": "⇎",
		"nleq": "≰",
		"nleqq": "≦̸",
		"nleqslant": "⩽̸",
		"nles": "⩽̸",
		"nless": "≮",
		"nLl": "⋘̸",
		"nlsim": "≴",
		"nLt": "≪⃒",
		"nlt": "≮",
		"nltri": "⋪",
		"nltrie": "⋬",
		"nLtv": "≪̸",
		"nmid": "∤",
		"NoBreak": "⁠",
		"NonBreakingSpace": " ",
		"nopf": "𝕟",
		"Nopf": "ℕ",
		"Not": "⫬",
		"not": "¬",
		"NotCongruent": "≢",
		"NotCupCap": "≭",
		"NotDoubleVerticalBar": "∦",
		"NotElement": "∉",
		"NotEqual": "≠",
		"NotEqualTilde": "≂̸",
		"NotExists": "∄",
		"NotGreater": "≯",
		"NotGreaterEqual": "≱",
		"NotGreaterFullEqual": "≧̸",
		"NotGreaterGreater": "≫̸",
		"NotGreaterLess": "≹",
		"NotGreaterSlantEqual": "⩾̸",
		"NotGreaterTilde": "≵",
		"NotHumpDownHump": "≎̸",
		"NotHumpEqual": "≏̸",
		"notin": "∉",
		"notindot": "⋵̸",
		"notinE": "⋹̸",
		"notinva": "∉",
		"notinvb": "⋷",
		"notinvc": "⋶",
		"NotLeftTriangleBar": "⧏̸",
		"NotLeftTriangle": "⋪",
		"NotLeftTriangleEqual": "⋬",
		"NotLess": "≮",
		"NotLessEqual": "≰",
		"NotLessGreater": "≸",
		"NotLessLess": "≪̸",
		"NotLessSlantEqual": "⩽̸",
		"NotLessTilde": "≴",
		"NotNestedGreaterGreater": "⪢̸",
		"NotNestedLessLess": "⪡̸",
		"notni": "∌",
		"notniva": "∌",
		"notnivb": "⋾",
		"notnivc": "⋽",
		"NotPrecedes": "⊀",
		"NotPrecedesEqual": "⪯̸",
		"NotPrecedesSlantEqual": "⋠",
		"NotReverseElement": "∌",
		"NotRightTriangleBar": "⧐̸",
		"NotRightTriangle": "⋫",
		"NotRightTriangleEqual": "⋭",
		"NotSquareSubset": "⊏̸",
		"NotSquareSubsetEqual": "⋢",
		"NotSquareSuperset": "⊐̸",
		"NotSquareSupersetEqual": "⋣",
		"NotSubset": "⊂⃒",
		"NotSubsetEqual": "⊈",
		"NotSucceeds": "⊁",
		"NotSucceedsEqual": "⪰̸",
		"NotSucceedsSlantEqual": "⋡",
		"NotSucceedsTilde": "≿̸",
		"NotSuperset": "⊃⃒",
		"NotSupersetEqual": "⊉",
		"NotTilde": "≁",
		"NotTildeEqual": "≄",
		"NotTildeFullEqual": "≇",
		"NotTildeTilde": "≉",
		"NotVerticalBar": "∤",
		"nparallel": "∦",
		"npar": "∦",
		"nparsl": "⫽⃥",
		"npart": "∂̸",
		"npolint": "⨔",
		"npr": "⊀",
		"nprcue": "⋠",
		"nprec": "⊀",
		"npreceq": "⪯̸",
		"npre": "⪯̸",
		"nrarrc": "⤳̸",
		"nrarr": "↛",
		"nrArr": "⇏",
		"nrarrw": "↝̸",
		"nrightarrow": "↛",
		"nRightarrow": "⇏",
		"nrtri": "⋫",
		"nrtrie": "⋭",
		"nsc": "⊁",
		"nsccue": "⋡",
		"nsce": "⪰̸",
		"Nscr": "𝒩",
		"nscr": "𝓃",
		"nshortmid": "∤",
		"nshortparallel": "∦",
		"nsim": "≁",
		"nsime": "≄",
		"nsimeq": "≄",
		"nsmid": "∤",
		"nspar": "∦",
		"nsqsube": "⋢",
		"nsqsupe": "⋣",
		"nsub": "⊄",
		"nsubE": "⫅̸",
		"nsube": "⊈",
		"nsubset": "⊂⃒",
		"nsubseteq": "⊈",
		"nsubseteqq": "⫅̸",
		"nsucc": "⊁",
		"nsucceq": "⪰̸",
		"nsup": "⊅",
		"nsupE": "⫆̸",
		"nsupe": "⊉",
		"nsupset": "⊃⃒",
		"nsupseteq": "⊉",
		"nsupseteqq": "⫆̸",
		"ntgl": "≹",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"ntlg": "≸",
		"ntriangleleft": "⋪",
		"ntrianglelefteq": "⋬",
		"ntriangleright": "⋫",
		"ntrianglerighteq": "⋭",
		"Nu": "Ν",
		"nu": "ν",
		"num": "#",
		"numero": "№",
		"numsp": " ",
		"nvap": "≍⃒",
		"nvdash": "⊬",
		"nvDash": "⊭",
		"nVdash": "⊮",
		"nVDash": "⊯",
		"nvge": "≥⃒",
		"nvgt": ">⃒",
		"nvHarr": "⤄",
		"nvinfin": "⧞",
		"nvlArr": "⤂",
		"nvle": "≤⃒",
		"nvlt": "<⃒",
		"nvltrie": "⊴⃒",
		"nvrArr": "⤃",
		"nvrtrie": "⊵⃒",
		"nvsim": "∼⃒",
		"nwarhk": "⤣",
		"nwarr": "↖",
		"nwArr": "⇖",
		"nwarrow": "↖",
		"nwnear": "⤧",
		"Oacute": "Ó",
		"oacute": "ó",
		"oast": "⊛",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"ocir": "⊚",
		"Ocy": "О",
		"ocy": "о",
		"odash": "⊝",
		"Odblac": "Ő",
		"odblac": "ő",
		"odiv": "⨸",
		"odot": "⊙",
		"odsold": "⦼",
		"OElig": "Œ",
		"oelig": "œ",
		"ofcir": "⦿",
		"Ofr": "𝔒",
		"ofr": "𝔬",
		"ogon": "˛",
		"Ograve": "Ò",
		"ograve": "ò",
		"ogt": "⧁",
		"ohbar": "⦵",
		"ohm": "Ω",
		"oint": "∮",
		"olarr": "↺",
		"olcir": "⦾",
		"olcross": "⦻",
		"oline": "‾",
		"olt": "⧀",
		"Omacr": "Ō",
		"omacr": "ō",
		"Omega": "Ω",
		"omega": "ω",
		"Omicron": "Ο",
		"omicron": "ο",
		"omid": "⦶",
		"ominus": "⊖",
		"Oopf": "𝕆",
		"oopf": "𝕠",
		"opar": "⦷",
		"OpenCurlyDoubleQuote": "“",
		"OpenCurlyQuote": "‘",
		"operp": "⦹",
		"oplus": "⊕",
		"orarr": "↻",
		"Or": "⩔",
		"or": "∨",
		"ord": "⩝",
		"order": "ℴ",
		"orderof": "ℴ",
		"ordf": "ª",
		"ordm": "º",
		"origof": "⊶",
		"oror": "⩖",
		"orslope": "⩗",
		"orv": "⩛",
		"oS": "Ⓢ",
		"Oscr": "𝒪",
		"oscr": "ℴ",
		"Oslash": "Ø",
		"oslash": "ø",
		"osol": "⊘",
		"Otilde": "Õ",
		"otilde": "õ",
		"otimesas": "⨶",
		"Otimes": "⨷",
		"otimes": "⊗",
		"Ouml": "Ö",
		"ouml": "ö",
		"ovbar": "⌽",
		"OverBar": "‾",
		"OverBrace": "⏞",
		"OverBracket": "⎴",
		"OverParenthesis": "⏜",
		"para": "¶",
		"parallel": "∥",
		"par": "∥",
		"parsim": "⫳",
		"parsl": "⫽",
		"part": "∂",
		"PartialD": "∂",
		"Pcy": "П",
		"pcy": "п",
		"percnt": "%",
		"period": ".",
		"permil": "‰",
		"perp": "⊥",
		"pertenk": "‱",
		"Pfr": "𝔓",
		"pfr": "𝔭",
		"Phi": "Φ",
		"phi": "φ",
		"phiv": "ϕ",
		"phmmat": "ℳ",
		"phone": "☎",
		"Pi": "Π",
		"pi": "π",
		"pitchfork": "⋔",
		"piv": "ϖ",
		"planck": "ℏ",
		"planckh": "ℎ",
		"plankv": "ℏ",
		"plusacir": "⨣",
		"plusb": "⊞",
		"pluscir": "⨢",
		"plus": "+",
		"plusdo": "∔",
		"plusdu": "⨥",
		"pluse": "⩲",
		"PlusMinus": "±",
		"plusmn": "±",
		"plussim": "⨦",
		"plustwo": "⨧",
		"pm": "±",
		"Poincareplane": "ℌ",
		"pointint": "⨕",
		"popf": "𝕡",
		"Popf": "ℙ",
		"pound": "£",
		"prap": "⪷",
		"Pr": "⪻",
		"pr": "≺",
		"prcue": "≼",
		"precapprox": "⪷",
		"prec": "≺",
		"preccurlyeq": "≼",
		"Precedes": "≺",
		"PrecedesEqual": "⪯",
		"PrecedesSlantEqual": "≼",
		"PrecedesTilde": "≾",
		"preceq": "⪯",
		"precnapprox": "⪹",
		"precneqq": "⪵",
		"precnsim": "⋨",
		"pre": "⪯",
		"prE": "⪳",
		"precsim": "≾",
		"prime": "′",
		"Prime": "″",
		"primes": "ℙ",
		"prnap": "⪹",
		"prnE": "⪵",
		"prnsim": "⋨",
		"prod": "∏",
		"Product": "∏",
		"profalar": "⌮",
		"profline": "⌒",
		"profsurf": "⌓",
		"prop": "∝",
		"Proportional": "∝",
		"Proportion": "∷",
		"propto": "∝",
		"prsim": "≾",
		"prurel": "⊰",
		"Pscr": "𝒫",
		"pscr": "𝓅",
		"Psi": "Ψ",
		"psi": "ψ",
		"puncsp": " ",
		"Qfr": "𝔔",
		"qfr": "𝔮",
		"qint": "⨌",
		"qopf": "𝕢",
		"Qopf": "ℚ",
		"qprime": "⁗",
		"Qscr": "𝒬",
		"qscr": "𝓆",
		"quaternions": "ℍ",
		"quatint": "⨖",
		"quest": "?",
		"questeq": "≟",
		"quot": "\"",
		"QUOT": "\"",
		"rAarr": "⇛",
		"race": "∽̱",
		"Racute": "Ŕ",
		"racute": "ŕ",
		"radic": "√",
		"raemptyv": "⦳",
		"rang": "⟩",
		"Rang": "⟫",
		"rangd": "⦒",
		"range": "⦥",
		"rangle": "⟩",
		"raquo": "»",
		"rarrap": "⥵",
		"rarrb": "⇥",
		"rarrbfs": "⤠",
		"rarrc": "⤳",
		"rarr": "→",
		"Rarr": "↠",
		"rArr": "⇒",
		"rarrfs": "⤞",
		"rarrhk": "↪",
		"rarrlp": "↬",
		"rarrpl": "⥅",
		"rarrsim": "⥴",
		"Rarrtl": "⤖",
		"rarrtl": "↣",
		"rarrw": "↝",
		"ratail": "⤚",
		"rAtail": "⤜",
		"ratio": "∶",
		"rationals": "ℚ",
		"rbarr": "⤍",
		"rBarr": "⤏",
		"RBarr": "⤐",
		"rbbrk": "❳",
		"rbrace": "}",
		"rbrack": "]",
		"rbrke": "⦌",
		"rbrksld": "⦎",
		"rbrkslu": "⦐",
		"Rcaron": "Ř",
		"rcaron": "ř",
		"Rcedil": "Ŗ",
		"rcedil": "ŗ",
		"rceil": "⌉",
		"rcub": "}",
		"Rcy": "Р",
		"rcy": "р",
		"rdca": "⤷",
		"rdldhar": "⥩",
		"rdquo": "”",
		"rdquor": "”",
		"rdsh": "↳",
		"real": "ℜ",
		"realine": "ℛ",
		"realpart": "ℜ",
		"reals": "ℝ",
		"Re": "ℜ",
		"rect": "▭",
		"reg": "®",
		"REG": "®",
		"ReverseElement": "∋",
		"ReverseEquilibrium": "⇋",
		"ReverseUpEquilibrium": "⥯",
		"rfisht": "⥽",
		"rfloor": "⌋",
		"rfr": "𝔯",
		"Rfr": "ℜ",
		"rHar": "⥤",
		"rhard": "⇁",
		"rharu": "⇀",
		"rharul": "⥬",
		"Rho": "Ρ",
		"rho": "ρ",
		"rhov": "ϱ",
		"RightAngleBracket": "⟩",
		"RightArrowBar": "⇥",
		"rightarrow": "→",
		"RightArrow": "→",
		"Rightarrow": "⇒",
		"RightArrowLeftArrow": "⇄",
		"rightarrowtail": "↣",
		"RightCeiling": "⌉",
		"RightDoubleBracket": "⟧",
		"RightDownTeeVector": "⥝",
		"RightDownVectorBar": "⥕",
		"RightDownVector": "⇂",
		"RightFloor": "⌋",
		"rightharpoondown": "⇁",
		"rightharpoonup": "⇀",
		"rightleftarrows": "⇄",
		"rightleftharpoons": "⇌",
		"rightrightarrows": "⇉",
		"rightsquigarrow": "↝",
		"RightTeeArrow": "↦",
		"RightTee": "⊢",
		"RightTeeVector": "⥛",
		"rightthreetimes": "⋌",
		"RightTriangleBar": "⧐",
		"RightTriangle": "⊳",
		"RightTriangleEqual": "⊵",
		"RightUpDownVector": "⥏",
		"RightUpTeeVector": "⥜",
		"RightUpVectorBar": "⥔",
		"RightUpVector": "↾",
		"RightVectorBar": "⥓",
		"RightVector": "⇀",
		"ring": "˚",
		"risingdotseq": "≓",
		"rlarr": "⇄",
		"rlhar": "⇌",
		"rlm": "‏",
		"rmoustache": "⎱",
		"rmoust": "⎱",
		"rnmid": "⫮",
		"roang": "⟭",
		"roarr": "⇾",
		"robrk": "⟧",
		"ropar": "⦆",
		"ropf": "𝕣",
		"Ropf": "ℝ",
		"roplus": "⨮",
		"rotimes": "⨵",
		"RoundImplies": "⥰",
		"rpar": ")",
		"rpargt": "⦔",
		"rppolint": "⨒",
		"rrarr": "⇉",
		"Rrightarrow": "⇛",
		"rsaquo": "›",
		"rscr": "𝓇",
		"Rscr": "ℛ",
		"rsh": "↱",
		"Rsh": "↱",
		"rsqb": "]",
		"rsquo": "’",
		"rsquor": "’",
		"rthree": "⋌",
		"rtimes": "⋊",
		"rtri": "▹",
		"rtrie": "⊵",
		"rtrif": "▸",
		"rtriltri": "⧎",
		"RuleDelayed": "⧴",
		"ruluhar": "⥨",
		"rx": "℞",
		"Sacute": "Ś",
		"sacute": "ś",
		"sbquo": "‚",
		"scap": "⪸",
		"Scaron": "Š",
		"scaron": "š",
		"Sc": "⪼",
		"sc": "≻",
		"sccue": "≽",
		"sce": "⪰",
		"scE": "⪴",
		"Scedil": "Ş",
		"scedil": "ş",
		"Scirc": "Ŝ",
		"scirc": "ŝ",
		"scnap": "⪺",
		"scnE": "⪶",
		"scnsim": "⋩",
		"scpolint": "⨓",
		"scsim": "≿",
		"Scy": "С",
		"scy": "с",
		"sdotb": "⊡",
		"sdot": "⋅",
		"sdote": "⩦",
		"searhk": "⤥",
		"searr": "↘",
		"seArr": "⇘",
		"searrow": "↘",
		"sect": "§",
		"semi": ";",
		"seswar": "⤩",
		"setminus": "∖",
		"setmn": "∖",
		"sext": "✶",
		"Sfr": "𝔖",
		"sfr": "𝔰",
		"sfrown": "⌢",
		"sharp": "♯",
		"SHCHcy": "Щ",
		"shchcy": "щ",
		"SHcy": "Ш",
		"shcy": "ш",
		"ShortDownArrow": "↓",
		"ShortLeftArrow": "←",
		"shortmid": "∣",
		"shortparallel": "∥",
		"ShortRightArrow": "→",
		"ShortUpArrow": "↑",
		"shy": "­",
		"Sigma": "Σ",
		"sigma": "σ",
		"sigmaf": "ς",
		"sigmav": "ς",
		"sim": "∼",
		"simdot": "⩪",
		"sime": "≃",
		"simeq": "≃",
		"simg": "⪞",
		"simgE": "⪠",
		"siml": "⪝",
		"simlE": "⪟",
		"simne": "≆",
		"simplus": "⨤",
		"simrarr": "⥲",
		"slarr": "←",
		"SmallCircle": "∘",
		"smallsetminus": "∖",
		"smashp": "⨳",
		"smeparsl": "⧤",
		"smid": "∣",
		"smile": "⌣",
		"smt": "⪪",
		"smte": "⪬",
		"smtes": "⪬︀",
		"SOFTcy": "Ь",
		"softcy": "ь",
		"solbar": "⌿",
		"solb": "⧄",
		"sol": "/",
		"Sopf": "𝕊",
		"sopf": "𝕤",
		"spades": "♠",
		"spadesuit": "♠",
		"spar": "∥",
		"sqcap": "⊓",
		"sqcaps": "⊓︀",
		"sqcup": "⊔",
		"sqcups": "⊔︀",
		"Sqrt": "√",
		"sqsub": "⊏",
		"sqsube": "⊑",
		"sqsubset": "⊏",
		"sqsubseteq": "⊑",
		"sqsup": "⊐",
		"sqsupe": "⊒",
		"sqsupset": "⊐",
		"sqsupseteq": "⊒",
		"square": "□",
		"Square": "□",
		"SquareIntersection": "⊓",
		"SquareSubset": "⊏",
		"SquareSubsetEqual": "⊑",
		"SquareSuperset": "⊐",
		"SquareSupersetEqual": "⊒",
		"SquareUnion": "⊔",
		"squarf": "▪",
		"squ": "□",
		"squf": "▪",
		"srarr": "→",
		"Sscr": "𝒮",
		"sscr": "𝓈",
		"ssetmn": "∖",
		"ssmile": "⌣",
		"sstarf": "⋆",
		"Star": "⋆",
		"star": "☆",
		"starf": "★",
		"straightepsilon": "ϵ",
		"straightphi": "ϕ",
		"strns": "¯",
		"sub": "⊂",
		"Sub": "⋐",
		"subdot": "⪽",
		"subE": "⫅",
		"sube": "⊆",
		"subedot": "⫃",
		"submult": "⫁",
		"subnE": "⫋",
		"subne": "⊊",
		"subplus": "⪿",
		"subrarr": "⥹",
		"subset": "⊂",
		"Subset": "⋐",
		"subseteq": "⊆",
		"subseteqq": "⫅",
		"SubsetEqual": "⊆",
		"subsetneq": "⊊",
		"subsetneqq": "⫋",
		"subsim": "⫇",
		"subsub": "⫕",
		"subsup": "⫓",
		"succapprox": "⪸",
		"succ": "≻",
		"succcurlyeq": "≽",
		"Succeeds": "≻",
		"SucceedsEqual": "⪰",
		"SucceedsSlantEqual": "≽",
		"SucceedsTilde": "≿",
		"succeq": "⪰",
		"succnapprox": "⪺",
		"succneqq": "⪶",
		"succnsim": "⋩",
		"succsim": "≿",
		"SuchThat": "∋",
		"sum": "∑",
		"Sum": "∑",
		"sung": "♪",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"sup": "⊃",
		"Sup": "⋑",
		"supdot": "⪾",
		"supdsub": "⫘",
		"supE": "⫆",
		"supe": "⊇",
		"supedot": "⫄",
		"Superset": "⊃",
		"SupersetEqual": "⊇",
		"suphsol": "⟉",
		"suphsub": "⫗",
		"suplarr": "⥻",
		"supmult": "⫂",
		"supnE": "⫌",
		"supne": "⊋",
		"supplus": "⫀",
		"supset": "⊃",
		"Supset": "⋑",
		"supseteq": "⊇",
		"supseteqq": "⫆",
		"supsetneq": "⊋",
		"supsetneqq": "⫌",
		"supsim": "⫈",
		"supsub": "⫔",
		"supsup": "⫖",
		"swarhk": "⤦",
		"swarr": "↙",
		"swArr": "⇙",
		"swarrow": "↙",
		"swnwar": "⤪",
		"szlig": "ß",
		"Tab": "\t",
		"target": "⌖",
		"Tau": "Τ",
		"tau": "τ",
		"tbrk": "⎴",
		"Tcaron": "Ť",
		"tcaron": "ť",
		"Tcedil": "Ţ",
		"tcedil": "ţ",
		"Tcy": "Т",
		"tcy": "т",
		"tdot": "⃛",
		"telrec": "⌕",
		"Tfr": "𝔗",
		"tfr": "𝔱",
		"there4": "∴",
		"therefore": "∴",
		"Therefore": "∴",
		"Theta": "Θ",
		"theta": "θ",
		"thetasym": "ϑ",
		"thetav": "ϑ",
		"thickapprox": "≈",
		"thicksim": "∼",
		"ThickSpace": "  ",
		"ThinSpace": " ",
		"thinsp": " ",
		"thkap": "≈",
		"thksim": "∼",
		"THORN": "Þ",
		"thorn": "þ",
		"tilde": "˜",
		"Tilde": "∼",
		"TildeEqual": "≃",
		"TildeFullEqual": "≅",
		"TildeTilde": "≈",
		"timesbar": "⨱",
		"timesb": "⊠",
		"times": "×",
		"timesd": "⨰",
		"tint": "∭",
		"toea": "⤨",
		"topbot": "⌶",
		"topcir": "⫱",
		"top": "⊤",
		"Topf": "𝕋",
		"topf": "𝕥",
		"topfork": "⫚",
		"tosa": "⤩",
		"tprime": "‴",
		"trade": "™",
		"TRADE": "™",
		"triangle": "▵",
		"triangledown": "▿",
		"triangleleft": "◃",
		"trianglelefteq": "⊴",
		"triangleq": "≜",
		"triangleright": "▹",
		"trianglerighteq": "⊵",
		"tridot": "◬",
		"trie": "≜",
		"triminus": "⨺",
		"TripleDot": "⃛",
		"triplus": "⨹",
		"trisb": "⧍",
		"tritime": "⨻",
		"trpezium": "⏢",
		"Tscr": "𝒯",
		"tscr": "𝓉",
		"TScy": "Ц",
		"tscy": "ц",
		"TSHcy": "Ћ",
		"tshcy": "ћ",
		"Tstrok": "Ŧ",
		"tstrok": "ŧ",
		"twixt": "≬",
		"twoheadleftarrow": "↞",
		"twoheadrightarrow": "↠",
		"Uacute": "Ú",
		"uacute": "ú",
		"uarr": "↑",
		"Uarr": "↟",
		"uArr": "⇑",
		"Uarrocir": "⥉",
		"Ubrcy": "Ў",
		"ubrcy": "ў",
		"Ubreve": "Ŭ",
		"ubreve": "ŭ",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ucy": "У",
		"ucy": "у",
		"udarr": "⇅",
		"Udblac": "Ű",
		"udblac": "ű",
		"udhar": "⥮",
		"ufisht": "⥾",
		"Ufr": "𝔘",
		"ufr": "𝔲",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uHar": "⥣",
		"uharl": "↿",
		"uharr": "↾",
		"uhblk": "▀",
		"ulcorn": "⌜",
		"ulcorner": "⌜",
		"ulcrop": "⌏",
		"ultri": "◸",
		"Umacr": "Ū",
		"umacr": "ū",
		"uml": "¨",
		"UnderBar": "_",
		"UnderBrace": "⏟",
		"UnderBracket": "⎵",
		"UnderParenthesis": "⏝",
		"Union": "⋃",
		"UnionPlus": "⊎",
		"Uogon": "Ų",
		"uogon": "ų",
		"Uopf": "𝕌",
		"uopf": "𝕦",
		"UpArrowBar": "⤒",
		"uparrow": "↑",
		"UpArrow": "↑",
		"Uparrow": "⇑",
		"UpArrowDownArrow": "⇅",
		"updownarrow": "↕",
		"UpDownArrow": "↕",
		"Updownarrow": "⇕",
		"UpEquilibrium": "⥮",
		"upharpoonleft": "↿",
		"upharpoonright": "↾",
		"uplus": "⊎",
		"UpperLeftArrow": "↖",
		"UpperRightArrow": "↗",
		"upsi": "υ",
		"Upsi": "ϒ",
		"upsih": "ϒ",
		"Upsilon": "Υ",
		"upsilon": "υ",
		"UpTeeArrow": "↥",
		"UpTee": "⊥",
		"upuparrows": "⇈",
		"urcorn": "⌝",
		"urcorner": "⌝",
		"urcrop": "⌎",
		"Uring": "Ů",
		"uring": "ů",
		"urtri": "◹",
		"Uscr": "𝒰",
		"uscr": "𝓊",
		"utdot": "⋰",
		"Utilde": "Ũ",
		"utilde": "ũ",
		"utri": "▵",
		"utrif": "▴",
		"uuarr": "⇈",
		"Uuml": "Ü",
		"uuml": "ü",
		"uwangle": "⦧",
		"vangrt": "⦜",
		"varepsilon": "ϵ",
		"varkappa": "ϰ",
		"varnothing": "∅",
		"varphi": "ϕ",
		"varpi": "ϖ",
		"varpropto": "∝",
		"varr": "↕",
		"vArr": "⇕",
		"varrho": "ϱ",
		"varsigma": "ς",
		"varsubsetneq": "⊊︀",
		"varsubsetneqq": "⫋︀",
		"varsupsetneq": "⊋︀",
		"varsupsetneqq": "⫌︀",
		"vartheta": "ϑ",
		"vartriangleleft": "⊲",
		"vartriangleright": "⊳",
		"vBar": "⫨",
		"Vbar": "⫫",
		"vBarv": "⫩",
		"Vcy": "В",
		"vcy": "в",
		"vdash": "⊢",
		"vDash": "⊨",
		"Vdash": "⊩",
		"VDash": "⊫",
		"Vdashl": "⫦",
		"veebar": "⊻",
		"vee": "∨",
		"Vee": "⋁",
		"veeeq": "≚",
		"vellip": "⋮",
		"verbar": "|",
		"Verbar": "‖",
		"vert": "|",
		"Vert": "‖",
		"VerticalBar": "∣",
		"VerticalLine": "|",
		"VerticalSeparator": "❘",
		"VerticalTilde": "≀",
		"VeryThinSpace": " ",
		"Vfr": "𝔙",
		"vfr": "𝔳",
		"vltri": "⊲",
		"vnsub": "⊂⃒",
		"vnsup": "⊃⃒",
		"Vopf": "𝕍",
		"vopf": "𝕧",
		"vprop": "∝",
		"vrtri": "⊳",
		"Vscr": "𝒱",
		"vscr": "𝓋",
		"vsubnE": "⫋︀",
		"vsubne": "⊊︀",
		"vsupnE": "⫌︀",
		"vsupne": "⊋︀",
		"Vvdash": "⊪",
		"vzigzag": "⦚",
		"Wcirc": "Ŵ",
		"wcirc": "ŵ",
		"wedbar": "⩟",
		"wedge": "∧",
		"Wedge": "⋀",
		"wedgeq": "≙",
		"weierp": "℘",
		"Wfr": "𝔚",
		"wfr": "𝔴",
		"Wopf": "𝕎",
		"wopf": "𝕨",
		"wp": "℘",
		"wr": "≀",
		"wreath": "≀",
		"Wscr": "𝒲",
		"wscr": "𝓌",
		"xcap": "⋂",
		"xcirc": "◯",
		"xcup": "⋃",
		"xdtri": "▽",
		"Xfr": "𝔛",
		"xfr": "𝔵",
		"xharr": "⟷",
		"xhArr": "⟺",
		"Xi": "Ξ",
		"xi": "ξ",
		"xlarr": "⟵",
		"xlArr": "⟸",
		"xmap": "⟼",
		"xnis": "⋻",
		"xodot": "⨀",
		"Xopf": "𝕏",
		"xopf": "𝕩",
		"xoplus": "⨁",
		"xotime": "⨂",
		"xrarr": "⟶",
		"xrArr": "⟹",
		"Xscr": "𝒳",
		"xscr": "𝓍",
		"xsqcup": "⨆",
		"xuplus": "⨄",
		"xutri": "△",
		"xvee": "⋁",
		"xwedge": "⋀",
		"Yacute": "Ý",
		"yacute": "ý",
		"YAcy": "Я",
		"yacy": "я",
		"Ycirc": "Ŷ",
		"ycirc": "ŷ",
		"Ycy": "Ы",
		"ycy": "ы",
		"yen": "¥",
		"Yfr": "𝔜",
		"yfr": "𝔶",
		"YIcy": "Ї",
		"yicy": "ї",
		"Yopf": "𝕐",
		"yopf": "𝕪",
		"Yscr": "𝒴",
		"yscr": "𝓎",
		"YUcy": "Ю",
		"yucy": "ю",
		"yuml": "ÿ",
		"Yuml": "Ÿ",
		"Zacute": "Ź",
		"zacute": "ź",
		"Zcaron": "Ž",
		"zcaron": "ž",
		"Zcy": "З",
		"zcy": "з",
		"Zdot": "Ż",
		"zdot": "ż",
		"zeetrf": "ℨ",
		"ZeroWidthSpace": "​",
		"Zeta": "Ζ",
		"zeta": "ζ",
		"zfr": "𝔷",
		"Zfr": "ℨ",
		"ZHcy": "Ж",
		"zhcy": "ж",
		"zigrarr": "⇝",
		"zopf": "𝕫",
		"Zopf": "ℤ",
		"Zscr": "𝒵",
		"zscr": "𝓏",
		"zwj": "‍",
		"zwnj": "‌"
	};

/***/ },
/* 188 */
/***/ function(module, exports) {

	module.exports = {
		"amp": "&",
		"apos": "'",
		"gt": ">",
		"lt": "<",
		"quot": "\""
	};

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SheetsRegistry = __webpack_require__(290);
	
	var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	exports['default'] = new _SheetsRegistry2['default']();

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toCss;
	
	var _toCssValue = __webpack_require__(294);
	
	var _toCssValue2 = _interopRequireDefault(_toCssValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	function indentStr(str, indent) {
	  var result = '';
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }return result + str;
	}
	
	/**
	 * Converts a Rule to CSS string.
	 */
	
	function toCss(selector, style) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	  var result = '';
	
	  if (!style) return result;
	
	  var _options$indent = options.indent,
	      indent = _options$indent === undefined ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	
	
	  indent++;
	
	  // Apply fallbacks first.
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	        for (var prop in fallback) {
	          var value = fallback[prop];
	          if (value != null) {
	            result += '\n' + indentStr(prop + ': ' + (0, _toCssValue2['default'])(value) + ';', indent);
	          }
	        }
	      }
	    }
	    // Object syntax {fallbacks: {prop: value}}
	    else {
	        for (var _prop in fallbacks) {
	          var _value = fallbacks[_prop];
	          if (_value != null) {
	            result += '\n' + indentStr(_prop + ': ' + (0, _toCssValue2['default'])(_value) + ';', indent);
	          }
	        }
	      }
	  }
	
	  var hasFunctionValue = false;
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	    if (typeof _value2 === 'function') {
	      _value2 = style['$' + _prop2];
	      hasFunctionValue = true;
	    }
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      result += '\n' + indentStr(_prop2 + ': ' + (0, _toCssValue2['default'])(_value2) + ';', indent);
	    }
	  }
	
	  if (!result && !hasFunctionValue) return result;
	
	  indent--;
	  result = indentStr(selector + ' {' + result + '\n', indent) + indentStr('}', indent);
	
	  return result;
	}

/***/ },
/* 191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	
	var mensch = __webpack_require__(1842);
	var own = {}.hasOwnProperty;
	var Selector = __webpack_require__(639);
	var Property = __webpack_require__(638);
	
	exports.Selector = Selector;
	exports.Property = Property;
	
	/**
	 * Returns an array of the selectors.
	 *
	 * @license Sizzle CSS Selector Engine - MIT
	 * @param {String} selectorText from mensch
	 * @api public
	 */
	
	exports.extract = function extract(selectorText) {
	  var attr = 0;
	  var sels = [];
	  var sel = '';
	
	  for (var i = 0, l = selectorText.length; i < l; i++) {
	    var c = selectorText.charAt(i);
	
	    if (attr) {
	      if (']' === c || ')' === c) { attr--; }
	      sel += c;
	    } else {
	      if (',' === c) {
	        sels.push(sel);
	        sel = '';
	      } else {
	        if ('[' === c || '(' === c) { attr++; }
	        if (sel.length || (c !== ',' && c !== '\n' && c !== ' ')) { sel += c; }
	      }
	    }
	  }
	
	  if (sel.length) {
	    sels.push(sel);
	  }
	
	  return sels;
	};
	
	/**
	 * Returns a parse tree for a CSS source.
	 * If it encounters multiple selectors separated by a comma, it splits the
	 * tree.
	 *
	 * @param {String} css source
	 * @api public
	 */
	
	exports.parseCSS = function(css) {
	  var parsed = mensch.parse(css, {position: true, comments: true});
	  var rules = typeof parsed.stylesheet != 'undefined' && parsed.stylesheet.rules ? parsed.stylesheet.rules : [];
	  var ret = [];
	
	  for (var i = 0, l = rules.length; i < l; i++) {
	    if (rules[i].type == 'rule') {
	      var rule = rules[i];
	      var selectors = rule.selectors;
	
	      for (var ii = 0, ll = selectors.length; ii < ll; ii++) {
	        ret.push([selectors[ii], rule.declarations]);
	      }
	    }
	  }
	
	  return ret;
	};
	
	/**
	 * Returns preserved text for a CSS source.
	 *
	 * @param {String} css source
	 * @param {Object} options
	 * @api public
	 */
	
	exports.getPreservedText = function(css, options) {
	  var parsed = mensch.parse(css, {position: true, comments: true});
	  var rules = typeof parsed.stylesheet != 'undefined' && parsed.stylesheet.rules ? parsed.stylesheet.rules : [];
	  var preserved = [];
	  var lastStart = null;
	
	  for (var i = rules.length - 1; i >= 0; i--) {
	    if ((options.fontFaces && rules[i].type === 'font-face') ||
	        (options.mediaQueries && rules[i].type === 'media')) {
	      preserved.unshift(
	        mensch.stringify(
	          { stylesheet: { rules: [ rules[i] ] }},
	          { comments: false, indentation: '  ' }
	        )
	      );
	    }
	    lastStart = rules[i].position.start;
	  }
	
	  if (preserved.length === 0) {
	    return false;
	  }
	  return '\n' + preserved.join('\n') + '\n';
	};
	
	exports.normalizeLineEndings = function(text) {
	  return text.replace(/\r\n/g, '\n').replace(/\n/g, '\r\n');
	};
	
	
	/**
	 * Compares two specificity vectors, returning the winning one.
	 *
	 * @param {Array} vector a
	 * @param {Array} vector b
	 * @return {Array}
	 * @api public
	 */
	
	exports.compareFunc = function(a, b) {
	  var min = Math.min(a.length, b.length);
	  for (var i = 0; i < min; i++) {
	    if (a[i] === b[i]) { continue; }
	    if (a[i] > b[i]) { return 1; }
	    return -1;
	  }
	
	  return a.length - b.length;
	};
	
	exports.compare = function(a, b) {
	  return exports.compareFunc(a, b) == 1 ? a : b;
	};
	
	exports.extend = function(obj, src) {
	  for (var key in src) {
	    if (own.call(src, key)) {
	      obj[key] = src[key];
	    }
	  }
	  return obj;
	};
	
	exports.getDefaultOptions = function(options) {
	  var result = exports.extend({
	    extraCss: '',
	    insertPreservedExtraCss: true,
	    applyStyleTags: true,
	    removeStyleTags: true,
	    preserveMediaQueries: true,
	    preserveFontFaces: true,
	    applyWidthAttributes: true,
	    applyHeightAttributes: true,
	    applyAttributesTableElements: true,
	    url: ''
	  }, options);
	
	  result.webResources = result.webResources || {};
	
	  return result;
	};


/***/ },
/* 192 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as the internal argument placeholder. */
	var PLACEHOLDER = '__lodash_placeholder__';
	
	/** Used to compose bitmasks for function metadata. */
	var BIND_FLAG = 1,
	    BIND_KEY_FLAG = 2,
	    CURRY_BOUND_FLAG = 4,
	    CURRY_FLAG = 8,
	    CURRY_RIGHT_FLAG = 16,
	    PARTIAL_FLAG = 32,
	    PARTIAL_RIGHT_FLAG = 64,
	    ARY_FLAG = 128,
	    REARG_FLAG = 256,
	    FLIP_FLAG = 512;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991,
	    MAX_INTEGER = 1.7976931348623157e+308,
	    NAN = 0 / 0;
	
	/** Used to associate wrap methods with their bit flags. */
	var wrapFlags = [
	  ['ary', ARY_FLAG],
	  ['bind', BIND_FLAG],
	  ['bindKey', BIND_KEY_FLAG],
	  ['curry', CURRY_FLAG],
	  ['curryRight', CURRY_RIGHT_FLAG],
	  ['flip', FLIP_FLAG],
	  ['partial', PARTIAL_FLAG],
	  ['partialRight', PARTIAL_RIGHT_FLAG],
	  ['rearg', REARG_FLAG]
	];
	
	/** `Object#toString` result references. */
	var funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to match wrap detail comments. */
	var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
	    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
	    reSplitDetails = /,? & /;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.includes` for arrays without support for
	 * specifying an index to search from.
	 *
	 * @private
	 * @param {Array} [array] The array to inspect.
	 * @param {*} target The value to search for.
	 * @returns {boolean} Returns `true` if `target` is found, else `false`.
	 */
	function arrayIncludes(array, value) {
	  var length = array ? array.length : 0;
	  return !!length && baseIndexOf(array, value, 0) > -1;
	}
	
	/**
	 * The base implementation of `_.findIndex` and `_.findLastIndex` without
	 * support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {number} fromIndex The index to search from.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseFindIndex(array, predicate, fromIndex, fromRight) {
	  var length = array.length,
	      index = fromIndex + (fromRight ? 1 : -1);
	
	  while ((fromRight ? index-- : ++index < length)) {
	    if (predicate(array[index], index, array)) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} value The value to search for.
	 * @param {number} fromIndex The index to search from.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function baseIndexOf(array, value, fromIndex) {
	  if (value !== value) {
	    return baseFindIndex(array, baseIsNaN, fromIndex);
	  }
	  var index = fromIndex - 1,
	      length = array.length;
	
	  while (++index < length) {
	    if (array[index] === value) {
	      return index;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.isNaN` without support for number objects.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
	 */
	function baseIsNaN(value) {
	  return value !== value;
	}
	
	/**
	 * Gets the number of `placeholder` occurrences in `array`.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} placeholder The placeholder to search for.
	 * @returns {number} Returns the placeholder count.
	 */
	function countHolders(array, placeholder) {
	  var length = array.length,
	      result = 0;
	
	  while (length--) {
	    if (array[length] === placeholder) {
	      result++;
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Replaces all `placeholder` elements in `array` with an internal placeholder
	 * and returns an array of their indexes.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {*} placeholder The placeholder to replace.
	 * @returns {Array} Returns the new array of placeholder indexes.
	 */
	function replaceHolders(array, placeholder) {
	  var index = -1,
	      length = array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (value === placeholder || value === PLACEHOLDER) {
	      array[index] = PLACEHOLDER;
	      result[resIndex++] = index;
	    }
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/* Used to set `toString` methods. */
	var defineProperty = (function() {
	  var func = getNative(Object, 'defineProperty'),
	      name = getNative.name;
	
	  return (name && name.length > 2) ? func : undefined;
	}());
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates an array that is the composition of partially applied arguments,
	 * placeholders, and provided arguments into a single array of arguments.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to prepend to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgs(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersLength = holders.length,
	      leftIndex = -1,
	      leftLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(leftLength + rangeLength),
	      isUncurried = !isCurried;
	
	  while (++leftIndex < leftLength) {
	    result[leftIndex] = partials[leftIndex];
	  }
	  while (++argsIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[holders[argsIndex]] = args[argsIndex];
	    }
	  }
	  while (rangeLength--) {
	    result[leftIndex++] = args[argsIndex++];
	  }
	  return result;
	}
	
	/**
	 * This function is like `composeArgs` except that the arguments composition
	 * is tailored for `_.partialRight`.
	 *
	 * @private
	 * @param {Array} args The provided arguments.
	 * @param {Array} partials The arguments to append to those provided.
	 * @param {Array} holders The `partials` placeholder indexes.
	 * @params {boolean} [isCurried] Specify composing for a curried function.
	 * @returns {Array} Returns the new array of composed arguments.
	 */
	function composeArgsRight(args, partials, holders, isCurried) {
	  var argsIndex = -1,
	      argsLength = args.length,
	      holdersIndex = -1,
	      holdersLength = holders.length,
	      rightIndex = -1,
	      rightLength = partials.length,
	      rangeLength = nativeMax(argsLength - holdersLength, 0),
	      result = Array(rangeLength + rightLength),
	      isUncurried = !isCurried;
	
	  while (++argsIndex < rangeLength) {
	    result[argsIndex] = args[argsIndex];
	  }
	  var offset = argsIndex;
	  while (++rightIndex < rightLength) {
	    result[offset + rightIndex] = partials[rightIndex];
	  }
	  while (++holdersIndex < holdersLength) {
	    if (isUncurried || argsIndex < argsLength) {
	      result[offset + holders[holdersIndex]] = args[argsIndex++];
	    }
	  }
	  return result;
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with the optional `this`
	 * binding of `thisArg`.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createBind(func, bitmask, thisArg) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return fn.apply(isBind ? thisArg : this, arguments);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that produces an instance of `Ctor` regardless of
	 * whether it was invoked as part of a `new` expression or by `call` or `apply`.
	 *
	 * @private
	 * @param {Function} Ctor The constructor to wrap.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCtor(Ctor) {
	  return function() {
	    // Use a `switch` statement to work with class constructors. See
	    // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
	    // for more details.
	    var args = arguments;
	    switch (args.length) {
	      case 0: return new Ctor;
	      case 1: return new Ctor(args[0]);
	      case 2: return new Ctor(args[0], args[1]);
	      case 3: return new Ctor(args[0], args[1], args[2]);
	      case 4: return new Ctor(args[0], args[1], args[2], args[3]);
	      case 5: return new Ctor(args[0], args[1], args[2], args[3], args[4]);
	      case 6: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
	      case 7: return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
	    }
	    var thisBinding = baseCreate(Ctor.prototype),
	        result = Ctor.apply(thisBinding, args);
	
	    // Mimic the constructor's `return` behavior.
	    // See https://es5.github.io/#x13.2.2 for more details.
	    return isObject(result) ? result : thisBinding;
	  };
	}
	
	/**
	 * Creates a function that wraps `func` to enable currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {number} arity The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createCurry(func, bitmask, arity) {
	  var Ctor = createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length,
	        placeholder = getHolder(wrapper);
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    var holders = (length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder)
	      ? []
	      : replaceHolders(args, placeholder);
	
	    length -= holders.length;
	    if (length < arity) {
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, undefined,
	        args, holders, undefined, undefined, arity - length);
	    }
	    var fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	    return apply(fn, this, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with optional `this`
	 * binding of `thisArg`, partial application, and currying.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [partialsRight] The arguments to append to those provided
	 *  to the new function.
	 * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
	  var isAry = bitmask & ARY_FLAG,
	      isBind = bitmask & BIND_FLAG,
	      isBindKey = bitmask & BIND_KEY_FLAG,
	      isCurried = bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG),
	      isFlip = bitmask & FLIP_FLAG,
	      Ctor = isBindKey ? undefined : createCtor(func);
	
	  function wrapper() {
	    var length = arguments.length,
	        args = Array(length),
	        index = length;
	
	    while (index--) {
	      args[index] = arguments[index];
	    }
	    if (isCurried) {
	      var placeholder = getHolder(wrapper),
	          holdersCount = countHolders(args, placeholder);
	    }
	    if (partials) {
	      args = composeArgs(args, partials, holders, isCurried);
	    }
	    if (partialsRight) {
	      args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
	    }
	    length -= holdersCount;
	    if (isCurried && length < arity) {
	      var newHolders = replaceHolders(args, placeholder);
	      return createRecurry(
	        func, bitmask, createHybrid, wrapper.placeholder, thisArg,
	        args, newHolders, argPos, ary, arity - length
	      );
	    }
	    var thisBinding = isBind ? thisArg : this,
	        fn = isBindKey ? thisBinding[func] : func;
	
	    length = args.length;
	    if (argPos) {
	      args = reorder(args, argPos);
	    } else if (isFlip && length > 1) {
	      args.reverse();
	    }
	    if (isAry && ary < length) {
	      args.length = ary;
	    }
	    if (this && this !== root && this instanceof wrapper) {
	      fn = Ctor || createCtor(fn);
	    }
	    return fn.apply(thisBinding, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to invoke it with the `this` binding
	 * of `thisArg` and `partials` prepended to the arguments it receives.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} partials The arguments to prepend to those provided to
	 *  the new function.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createPartial(func, bitmask, thisArg, partials) {
	  var isBind = bitmask & BIND_FLAG,
	      Ctor = createCtor(func);
	
	  function wrapper() {
	    var argsIndex = -1,
	        argsLength = arguments.length,
	        leftIndex = -1,
	        leftLength = partials.length,
	        args = Array(leftLength + argsLength),
	        fn = (this && this !== root && this instanceof wrapper) ? Ctor : func;
	
	    while (++leftIndex < leftLength) {
	      args[leftIndex] = partials[leftIndex];
	    }
	    while (argsLength--) {
	      args[leftIndex++] = arguments[++argsIndex];
	    }
	    return apply(fn, isBind ? thisArg : this, args);
	  }
	  return wrapper;
	}
	
	/**
	 * Creates a function that wraps `func` to continue currying.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @param {Function} wrapFunc The function to create the `func` wrapper.
	 * @param {*} placeholder The placeholder value.
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to prepend to those provided to
	 *  the new function.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
	  var isCurry = bitmask & CURRY_FLAG,
	      newHolders = isCurry ? holders : undefined,
	      newHoldersRight = isCurry ? undefined : holders,
	      newPartials = isCurry ? partials : undefined,
	      newPartialsRight = isCurry ? undefined : partials;
	
	  bitmask |= (isCurry ? PARTIAL_FLAG : PARTIAL_RIGHT_FLAG);
	  bitmask &= ~(isCurry ? PARTIAL_RIGHT_FLAG : PARTIAL_FLAG);
	
	  if (!(bitmask & CURRY_BOUND_FLAG)) {
	    bitmask &= ~(BIND_FLAG | BIND_KEY_FLAG);
	  }
	
	  var result = wrapFunc(func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity);
	  result.placeholder = placeholder;
	  return setWrapToString(result, func, bitmask);
	}
	
	/**
	 * Creates a function that either curries or invokes `func` with optional
	 * `this` binding and partially applied arguments.
	 *
	 * @private
	 * @param {Function|string} func The function or method name to wrap.
	 * @param {number} bitmask The bitmask flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - `_.bind`
	 *     2 - `_.bindKey`
	 *     4 - `_.curry` or `_.curryRight` of a bound function
	 *     8 - `_.curry`
	 *    16 - `_.curryRight`
	 *    32 - `_.partial`
	 *    64 - `_.partialRight`
	 *   128 - `_.rearg`
	 *   256 - `_.ary`
	 *   512 - `_.flip`
	 * @param {*} [thisArg] The `this` binding of `func`.
	 * @param {Array} [partials] The arguments to be partially applied.
	 * @param {Array} [holders] The `partials` placeholder indexes.
	 * @param {Array} [argPos] The argument positions of the new function.
	 * @param {number} [ary] The arity cap of `func`.
	 * @param {number} [arity] The arity of `func`.
	 * @returns {Function} Returns the new wrapped function.
	 */
	function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
	  var isBindKey = bitmask & BIND_KEY_FLAG;
	  if (!isBindKey && typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var length = partials ? partials.length : 0;
	  if (!length) {
	    bitmask &= ~(PARTIAL_FLAG | PARTIAL_RIGHT_FLAG);
	    partials = holders = undefined;
	  }
	  ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
	  arity = arity === undefined ? arity : toInteger(arity);
	  length -= holders ? holders.length : 0;
	
	  if (bitmask & PARTIAL_RIGHT_FLAG) {
	    var partialsRight = partials,
	        holdersRight = holders;
	
	    partials = holders = undefined;
	  }
	
	  var newData = [
	    func, bitmask, thisArg, partials, holders, partialsRight, holdersRight,
	    argPos, ary, arity
	  ];
	
	  func = newData[0];
	  bitmask = newData[1];
	  thisArg = newData[2];
	  partials = newData[3];
	  holders = newData[4];
	  arity = newData[9] = newData[9] == null
	    ? (isBindKey ? 0 : func.length)
	    : nativeMax(newData[9] - length, 0);
	
	  if (!arity && bitmask & (CURRY_FLAG | CURRY_RIGHT_FLAG)) {
	    bitmask &= ~(CURRY_FLAG | CURRY_RIGHT_FLAG);
	  }
	  if (!bitmask || bitmask == BIND_FLAG) {
	    var result = createBind(func, bitmask, thisArg);
	  } else if (bitmask == CURRY_FLAG || bitmask == CURRY_RIGHT_FLAG) {
	    result = createCurry(func, bitmask, arity);
	  } else if ((bitmask == PARTIAL_FLAG || bitmask == (BIND_FLAG | PARTIAL_FLAG)) && !holders.length) {
	    result = createPartial(func, bitmask, thisArg, partials);
	  } else {
	    result = createHybrid.apply(undefined, newData);
	  }
	  return setWrapToString(result, func, bitmask);
	}
	
	/**
	 * Gets the argument placeholder value for `func`.
	 *
	 * @private
	 * @param {Function} func The function to inspect.
	 * @returns {*} Returns the placeholder value.
	 */
	function getHolder(func) {
	  var object = func;
	  return object.placeholder;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Extracts wrapper details from the `source` body comment.
	 *
	 * @private
	 * @param {string} source The source to inspect.
	 * @returns {Array} Returns the wrapper details.
	 */
	function getWrapDetails(source) {
	  var match = source.match(reWrapDetails);
	  return match ? match[1].split(reSplitDetails) : [];
	}
	
	/**
	 * Inserts wrapper `details` in a comment at the top of the `source` body.
	 *
	 * @private
	 * @param {string} source The source to modify.
	 * @returns {Array} details The details to insert.
	 * @returns {string} Returns the modified source.
	 */
	function insertWrapDetails(source, details) {
	  var length = details.length,
	      lastIndex = length - 1;
	
	  details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
	  details = details.join(length > 2 ? ', ' : ' ');
	  return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Reorder `array` according to the specified indexes where the element at
	 * the first index is assigned as the first element, the element at
	 * the second index is assigned as the second element, and so on.
	 *
	 * @private
	 * @param {Array} array The array to reorder.
	 * @param {Array} indexes The arranged array indexes.
	 * @returns {Array} Returns `array`.
	 */
	function reorder(array, indexes) {
	  var arrLength = array.length,
	      length = nativeMin(indexes.length, arrLength),
	      oldArray = copyArray(array);
	
	  while (length--) {
	    var index = indexes[length];
	    array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
	  }
	  return array;
	}
	
	/**
	 * Sets the `toString` method of `wrapper` to mimic the source of `reference`
	 * with wrapper details in a comment at the top of the source body.
	 *
	 * @private
	 * @param {Function} wrapper The function to modify.
	 * @param {Function} reference The reference function.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Function} Returns `wrapper`.
	 */
	var setWrapToString = !defineProperty ? identity : function(wrapper, reference, bitmask) {
	  var source = (reference + '');
	  return defineProperty(wrapper, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)))
	  });
	};
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Updates wrapper `details` based on `bitmask` flags.
	 *
	 * @private
	 * @returns {Array} details The details to modify.
	 * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
	 * @returns {Array} Returns `details`.
	 */
	function updateWrapDetails(details, bitmask) {
	  arrayEach(wrapFlags, function(pair) {
	    var value = '_.' + pair[0];
	    if ((bitmask & pair[1]) && !arrayIncludes(details, value)) {
	      details.push(value);
	    }
	  });
	  return details.sort();
	}
	
	/**
	 * Creates a function that invokes `func` with the `this` binding of `thisArg`
	 * and `partials` prepended to the arguments it receives.
	 *
	 * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
	 * may be used as a placeholder for partially applied arguments.
	 *
	 * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
	 * property of bound functions.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to bind.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {...*} [partials] The arguments to be partially applied.
	 * @returns {Function} Returns the new bound function.
	 * @example
	 *
	 * function greet(greeting, punctuation) {
	 *   return greeting + ' ' + this.user + punctuation;
	 * }
	 *
	 * var object = { 'user': 'fred' };
	 *
	 * var bound = _.bind(greet, object, 'hi');
	 * bound('!');
	 * // => 'hi fred!'
	 *
	 * // Bound with placeholders.
	 * var bound = _.bind(greet, object, _, '!');
	 * bound('hi');
	 * // => 'hi fred!'
	 */
	var bind = baseRest(function(func, thisArg, partials) {
	  var bitmask = BIND_FLAG;
	  if (partials.length) {
	    var holders = replaceHolders(partials, getHolder(bind));
	    bitmask |= PARTIAL_FLAG;
	  }
	  return createWrap(func, bitmask, thisArg, partials, holders);
	});
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a finite number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.12.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted number.
	 * @example
	 *
	 * _.toFinite(3.2);
	 * // => 3.2
	 *
	 * _.toFinite(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toFinite(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toFinite('3.2');
	 * // => 3.2
	 */
	function toFinite(value) {
	  if (!value) {
	    return value === 0 ? value : 0;
	  }
	  value = toNumber(value);
	  if (value === INFINITY || value === -INFINITY) {
	    var sign = (value < 0 ? -1 : 1);
	    return sign * MAX_INTEGER;
	  }
	  return value === value ? value : 0;
	}
	
	/**
	 * Converts `value` to an integer.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {number} Returns the converted integer.
	 * @example
	 *
	 * _.toInteger(3.2);
	 * // => 3
	 *
	 * _.toInteger(Number.MIN_VALUE);
	 * // => 0
	 *
	 * _.toInteger(Infinity);
	 * // => 1.7976931348623157e+308
	 *
	 * _.toInteger('3.2');
	 * // => 3
	 */
	function toInteger(value) {
	  var result = toFinite(value),
	      remainder = result % 1;
	
	  return result === result ? (remainder ? result - remainder : result) : 0;
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	// Assign default placeholders.
	bind.placeholder = {};
	
	module.exports = bind;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(61),
	    root = __webpack_require__(41);
	
	/* Built-in method references that are verified to be native. */
	var Map = getNative(root, 'Map');
	
	module.exports = Map;


/***/ },
/* 194 */
/***/ function(module, exports, __webpack_require__) {

	var mapCacheClear = __webpack_require__(717),
	    mapCacheDelete = __webpack_require__(718),
	    mapCacheGet = __webpack_require__(719),
	    mapCacheHas = __webpack_require__(720),
	    mapCacheSet = __webpack_require__(721);
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	module.exports = MapCache;


/***/ },
/* 195 */
/***/ function(module, exports) {

	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	module.exports = arrayPush;


/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(29);
	
	/** Built-in value references. */
	var objectCreate = Object.create;
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} proto The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	var baseCreate = (function() {
	  function object() {}
	  return function(proto) {
	    if (!isObject(proto)) {
	      return {};
	    }
	    if (objectCreate) {
	      return objectCreate(proto);
	    }
	    object.prototype = proto;
	    var result = new object;
	    object.prototype = undefined;
	    return result;
	  };
	}());
	
	module.exports = baseCreate;


/***/ },
/* 197 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(318);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	module.exports = baseFor;


/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(135),
	    assignMergeValue = __webpack_require__(303),
	    baseFor = __webpack_require__(197),
	    baseMergeDeep = __webpack_require__(674),
	    isObject = __webpack_require__(29),
	    keysIn = __webpack_require__(31);
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  baseFor(source, function(srcValue, key) {
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  }, keysIn);
	}
	
	module.exports = baseMerge;


/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	var Uint8Array = __webpack_require__(298);
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	module.exports = cloneArrayBuffer;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	var flatten = __webpack_require__(749),
	    overRest = __webpack_require__(331),
	    setToString = __webpack_require__(334);
	
	/**
	 * A specialized version of `baseRest` which flattens the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @returns {Function} Returns the new function.
	 */
	function flatRest(func) {
	  return setToString(overRest(func, undefined, flatten), func + '');
	}
	
	module.exports = flatRest;


/***/ },
/* 201 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(309),
	    getSymbolsIn = __webpack_require__(325),
	    keysIn = __webpack_require__(31);
	
	/**
	 * Creates an array of own and inherited enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeysIn(object) {
	  return baseGetAllKeys(object, keysIn, getSymbolsIn);
	}
	
	module.exports = getAllKeysIn;


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(300),
	    stubArray = __webpack_require__(341);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
	  if (object == null) {
	    return [];
	  }
	  object = Object(object);
	  return arrayFilter(nativeGetSymbols(object), function(symbol) {
	    return propertyIsEnumerable.call(object, symbol);
	  });
	};
	
	module.exports = getSymbols;


/***/ },
/* 203 */
/***/ function(module, exports, __webpack_require__) {

	var DataView = __webpack_require__(648),
	    Map = __webpack_require__(193),
	    Promise = __webpack_require__(650),
	    Set = __webpack_require__(651),
	    WeakMap = __webpack_require__(653),
	    baseGetTag = __webpack_require__(81),
	    toSource = __webpack_require__(335);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    setTag = '[object Set]',
	    weakMapTag = '[object WeakMap]';
	
	var dataViewTag = '[object DataView]';
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = baseGetTag(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : '';
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	module.exports = getTag;


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	var isArray = __webpack_require__(28),
	    isSymbol = __webpack_require__(210);
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/;
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	module.exports = isKey;


/***/ },
/* 205 */
/***/ function(module, exports) {

	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	module.exports = mapToArray;


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    createAssigner = __webpack_require__(83),
	    keysIn = __webpack_require__(31);
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	module.exports = assignInWith;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(108);
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	module.exports = get;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	var baseHasIn = __webpack_require__(662),
	    hasPath = __webpack_require__(326);
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	module.exports = hasIn;


/***/ },
/* 209 */
/***/ function(module, exports) {

	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	module.exports = isLength;


/***/ },
/* 210 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(81),
	    isObjectLike = __webpack_require__(62);
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && baseGetTag(value) == symbolTag);
	}
	
	module.exports = isSymbol;


/***/ },
/* 211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Checkbox = __webpack_require__(793);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Checkbox2.default;

/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Dialog = __webpack_require__(809);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Dialog2.default;

/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FontIcon = __webpack_require__(818);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FontIcon2.default;

/***/ },
/* 214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Subheader = __webpack_require__(360);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var List = function (_Component) {
	  (0, _inherits3.default)(List, _Component);
	
	  function List() {
	    (0, _classCallCheck3.default)(this, List);
	    return (0, _possibleConstructorReturn3.default)(this, (List.__proto__ || (0, _getPrototypeOf2.default)(List)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(List, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var hasSubheader = false;
	
	      var firstChild = _react.Children.toArray(children)[0];
	      if ((0, _react.isValidElement)(firstChild) && firstChild.type === _Subheader2.default) {
	        hasSubheader = true;
	      }
	
	      var styles = {
	        root: {
	          padding: (hasSubheader ? 0 : 8) + 'px 0px 8px 0px'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return List;
	}(_react.Component);
	
	List.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? List.propTypes = {
	  /**
	   * These are usually `ListItem`s that are passed to
	   * be part of the list.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = List;

/***/ },
/* 215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(68);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _colorManipulator = __webpack_require__(53);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _IconButton = __webpack_require__(86);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _expandLess = __webpack_require__(383);
	
	var _expandLess2 = _interopRequireDefault(_expandLess);
	
	var _expandMore = __webpack_require__(384);
	
	var _expandMore2 = _interopRequireDefault(_expandMore);
	
	var _NestedList = __webpack_require__(826);
	
	var _NestedList2 = _interopRequireDefault(_NestedList);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var insetChildren = props.insetChildren,
	      leftAvatar = props.leftAvatar,
	      leftCheckbox = props.leftCheckbox,
	      leftIcon = props.leftIcon,
	      nestedLevel = props.nestedLevel,
	      rightAvatar = props.rightAvatar,
	      rightIcon = props.rightIcon,
	      rightIconButton = props.rightIconButton,
	      rightToggle = props.rightToggle,
	      secondaryText = props.secondaryText,
	      secondaryTextLines = props.secondaryTextLines;
	  var muiTheme = context.muiTheme;
	  var listItem = muiTheme.listItem;
	
	
	  var textColor = muiTheme.baseTheme.palette.textColor;
	  var hoverColor = props.hoverColor || (0, _colorManipulator.fade)(textColor, 0.1);
	  var singleAvatar = !secondaryText && (leftAvatar || rightAvatar);
	  var singleNoAvatar = !secondaryText && !(leftAvatar || rightAvatar);
	  var twoLine = secondaryText && secondaryTextLines === 1;
	  var threeLine = secondaryText && secondaryTextLines > 1;
	
	  var isKeyboardFocused = (props.isKeyboardFocused !== undefined ? props : state).isKeyboardFocused;
	
	  var styles = {
	    root: {
	      backgroundColor: (isKeyboardFocused || state.hovered) && !state.rightIconButtonHovered && !state.rightIconButtonKeyboardFocused ? hoverColor : null,
	      color: textColor,
	      display: 'block',
	      fontSize: 16,
	      lineHeight: '16px',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	
	    // This inner div is needed so that ripples will span the entire container
	    innerDiv: {
	      marginLeft: nestedLevel * listItem.nestedLevelDepth,
	      paddingLeft: leftIcon || leftAvatar || leftCheckbox || insetChildren ? 72 : 16,
	      paddingRight: rightIcon || rightAvatar || rightIconButton ? 56 : rightToggle ? 72 : 16,
	      paddingBottom: singleAvatar ? 20 : 16,
	      paddingTop: singleNoAvatar || threeLine ? 16 : 20,
	      position: 'relative'
	    },
	
	    icons: {
	      height: 24,
	      width: 24,
	      display: 'block',
	      position: 'absolute',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      margin: 12
	    },
	
	    leftIcon: {
	      left: 4
	    },
	
	    rightIcon: {
	      right: 4
	    },
	
	    avatars: {
	      position: 'absolute',
	      top: singleAvatar ? 8 : 16
	    },
	
	    label: {
	      cursor: 'pointer'
	    },
	
	    leftAvatar: {
	      left: 16
	    },
	
	    rightAvatar: {
	      right: 16
	    },
	
	    leftCheckbox: {
	      position: 'absolute',
	      display: 'block',
	      width: 24,
	      top: twoLine ? 24 : singleAvatar ? 16 : 12,
	      left: 16
	    },
	
	    primaryText: {},
	
	    rightIconButton: {
	      position: 'absolute',
	      display: 'block',
	      top: twoLine ? 12 : singleAvatar ? 4 : 0,
	      right: 4
	    },
	
	    rightToggle: {
	      position: 'absolute',
	      display: 'block',
	      width: 54,
	      top: twoLine ? 25 : singleAvatar ? 17 : 13,
	      right: 8
	    },
	
	    secondaryText: {
	      fontSize: 14,
	      lineHeight: threeLine ? '18px' : '16px',
	      height: threeLine ? 36 : 16,
	      margin: 0,
	      marginTop: 4,
	      color: listItem.secondaryTextColor,
	
	      // needed for 2 and 3 line ellipsis
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: threeLine ? null : 'nowrap',
	      display: threeLine ? '-webkit-box' : null,
	      WebkitLineClamp: threeLine ? 2 : null,
	      WebkitBoxOrient: threeLine ? 'vertical' : null
	    }
	  };
	
	  return styles;
	}
	
	var ListItem = function (_Component) {
	  (0, _inherits3.default)(ListItem, _Component);
	
	  function ListItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ListItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ListItem.__proto__ || (0, _getPrototypeOf2.default)(ListItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      open: false,
	      rightIconButtonHovered: false,
	      rightIconButtonKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleNestedListToggle = function (event) {
	      event.stopPropagation();
	
	      if (_this.props.open === null) {
	        _this.setState({ open: !_this.state.open }, function () {
	          _this.props.onNestedListToggle(_this);
	        });
	      } else {
	        // Exposing `this` in the callback is quite a bad API.
	        // I'm doing a one level deep clone to expose a fake state.open.
	        _this.props.onNestedListToggle((0, _extends3.default)({}, _this, {
	          state: {
	            open: !_this.state.open
	          }
	        }));
	      }
	    }, _this.handleRightIconButtonKeyboardFocus = function (event, isKeyboardFocused) {
	      if (isKeyboardFocused) {
	        _this.setState({
	          isKeyboardFocused: false,
	          rightIconButtonKeyboardFocused: isKeyboardFocused
	        });
	      }
	
	      var iconButton = _this.props.rightIconButton;
	
	      if (iconButton && iconButton.props.onKeyboardFocus) iconButton.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleRightIconButtonMouseLeave = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: false });
	      if (iconButton && iconButton.props.onMouseLeave) iconButton.props.onMouseLeave(event);
	    }, _this.handleRightIconButtonMouseEnter = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      _this.setState({ rightIconButtonHovered: true });
	      if (iconButton && iconButton.props.onMouseEnter) iconButton.props.onMouseEnter(event);
	    }, _this.handleRightIconButtonMouseUp = function (event) {
	      var iconButton = _this.props.rightIconButton;
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onMouseUp) iconButton.props.onMouseUp(event);
	    }, _this.handleRightIconButtonTouchTap = function (event) {
	      var iconButton = _this.props.rightIconButton;
	
	      // Stop the event from bubbling up to the list-item
	      event.stopPropagation();
	      if (iconButton && iconButton.props.onTouchTap) iconButton.props.onTouchTap(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchEnd(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ListItem, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open === null ? this.props.initiallyOpen === true : this.props.open
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.open !== null) this.setState({ open: nextProps.open });
	      if (nextProps.disabled && this.state.hovered) this.setState({ hovered: false });
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	
	    // This method is needed by the `MenuItem` component.
	
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState(focusState) {
	      if (this.button) {
	        var buttonEl = _reactDom2.default.findDOMNode(this.button);
	
	        switch (focusState) {
	          case 'none':
	            buttonEl.blur();
	            break;
	          case 'focused':
	            buttonEl.focus();
	            break;
	          case 'keyboard-focused':
	            this.button.setKeyboardFocus();
	            buttonEl.focus();
	            break;
	        }
	      }
	    }
	  }, {
	    key: 'createDisabledElement',
	    value: function createDisabledElement(styles, contentChildren, additionalProps) {
	      var _props = this.props,
	          innerDivStyle = _props.innerDivStyle,
	          style = _props.style;
	
	
	      var mergedDivStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedDivStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createLabelElement',
	    value: function createLabelElement(styles, contentChildren, additionalProps) {
	      var _props2 = this.props,
	          innerDivStyle = _props2.innerDivStyle,
	          style = _props2.style;
	
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({}, styles.root, styles.innerDiv, innerDivStyle, styles.label, style);
	
	      return _react2.default.createElement(
	        'label',
	        (0, _extends3.default)({}, additionalProps, {
	          style: this.context.muiTheme.prepareStyles(mergedLabelStyles)
	        }),
	        contentChildren
	      );
	    }
	  }, {
	    key: 'createTextElement',
	    value: function createTextElement(styles, data, key) {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      if (_react2.default.isValidElement(data)) {
	        var style = (0, _simpleAssign2.default)({}, styles, data.props.style);
	        if (typeof data.type === 'string') {
	          // if element is a native dom node
	          style = prepareStyles(style);
	        }
	        return _react2.default.cloneElement(data, {
	          key: key,
	          style: style
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { key: key, style: prepareStyles(styles) },
	        data
	      );
	    }
	  }, {
	    key: 'pushElement',
	    value: function pushElement(children, element, baseStyles, additionalProps) {
	      if (element) {
	        var styles = (0, _simpleAssign2.default)({}, baseStyles, element.props.style);
	        children.push(_react2.default.cloneElement(element, (0, _extends3.default)({
	          key: children.length,
	          style: styles
	        }, additionalProps)));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props3 = this.props,
	          autoGenerateNestedIndicator = _props3.autoGenerateNestedIndicator,
	          children = _props3.children,
	          containerElement = _props3.containerElement,
	          disabled = _props3.disabled,
	          disableKeyboardFocus = _props3.disableKeyboardFocus,
	          hoverColor = _props3.hoverColor,
	          initiallyOpen = _props3.initiallyOpen,
	          innerDivStyle = _props3.innerDivStyle,
	          insetChildren = _props3.insetChildren,
	          leftAvatar = _props3.leftAvatar,
	          leftCheckbox = _props3.leftCheckbox,
	          leftIcon = _props3.leftIcon,
	          nestedItems = _props3.nestedItems,
	          nestedLevel = _props3.nestedLevel,
	          nestedListStyle = _props3.nestedListStyle,
	          onKeyboardFocus = _props3.onKeyboardFocus,
	          isKeyboardFocused = _props3.isKeyboardFocused,
	          onMouseEnter = _props3.onMouseEnter,
	          onMouseLeave = _props3.onMouseLeave,
	          onNestedListToggle = _props3.onNestedListToggle,
	          onTouchStart = _props3.onTouchStart,
	          onTouchTap = _props3.onTouchTap,
	          rightAvatar = _props3.rightAvatar,
	          rightIcon = _props3.rightIcon,
	          rightIconButton = _props3.rightIconButton,
	          rightToggle = _props3.rightToggle,
	          primaryText = _props3.primaryText,
	          primaryTogglesNestedList = _props3.primaryTogglesNestedList,
	          secondaryText = _props3.secondaryText,
	          secondaryTextLines = _props3.secondaryTextLines,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['autoGenerateNestedIndicator', 'children', 'containerElement', 'disabled', 'disableKeyboardFocus', 'hoverColor', 'initiallyOpen', 'innerDivStyle', 'insetChildren', 'leftAvatar', 'leftCheckbox', 'leftIcon', 'nestedItems', 'nestedLevel', 'nestedListStyle', 'onKeyboardFocus', 'isKeyboardFocused', 'onMouseEnter', 'onMouseLeave', 'onNestedListToggle', 'onTouchStart', 'onTouchTap', 'rightAvatar', 'rightIcon', 'rightIconButton', 'rightToggle', 'primaryText', 'primaryTogglesNestedList', 'secondaryText', 'secondaryTextLines', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var contentChildren = [children];
	
	      if (leftIcon) {
	        var additionalProps = {
	          color: leftIcon.props.color || this.context.muiTheme.listItem.leftIconColor
	        };
	        this.pushElement(contentChildren, leftIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.leftIcon), additionalProps);
	      }
	
	      if (rightIcon) {
	        var _additionalProps = {
	          color: rightIcon.props.color || this.context.muiTheme.listItem.rightIconColor
	        };
	        this.pushElement(contentChildren, rightIcon, (0, _simpleAssign2.default)({}, styles.icons, styles.rightIcon), _additionalProps);
	      }
	
	      if (leftAvatar) {
	        this.pushElement(contentChildren, leftAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.leftAvatar));
	      }
	
	      if (rightAvatar) {
	        this.pushElement(contentChildren, rightAvatar, (0, _simpleAssign2.default)({}, styles.avatars, styles.rightAvatar));
	      }
	
	      if (leftCheckbox) {
	        this.pushElement(contentChildren, leftCheckbox, (0, _simpleAssign2.default)({}, styles.leftCheckbox));
	      }
	
	      // RightIconButtonElement
	      var hasNestListItems = nestedItems.length;
	      var hasRightElement = rightAvatar || rightIcon || rightIconButton || rightToggle;
	      var needsNestedIndicator = hasNestListItems && autoGenerateNestedIndicator && !hasRightElement;
	
	      if (rightIconButton || needsNestedIndicator) {
	        var rightIconButtonElement = rightIconButton;
	        var rightIconButtonHandlers = {
	          onKeyboardFocus: this.handleRightIconButtonKeyboardFocus,
	          onMouseEnter: this.handleRightIconButtonMouseEnter,
	          onMouseLeave: this.handleRightIconButtonMouseLeave,
	          onTouchTap: this.handleRightIconButtonTouchTap,
	          onMouseDown: this.handleRightIconButtonMouseUp,
	          onMouseUp: this.handleRightIconButtonMouseUp
	        };
	
	        // Create a nested list indicator icon if we don't have an icon on the right
	        if (needsNestedIndicator) {
	          rightIconButtonElement = this.state.open ? _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandLess2.default, null)
	          ) : _react2.default.createElement(
	            _IconButton2.default,
	            null,
	            _react2.default.createElement(_expandMore2.default, null)
	          );
	          rightIconButtonHandlers.onTouchTap = this.handleNestedListToggle;
	        }
	
	        this.pushElement(contentChildren, rightIconButtonElement, (0, _simpleAssign2.default)({}, styles.rightIconButton), rightIconButtonHandlers);
	      }
	
	      if (rightToggle) {
	        this.pushElement(contentChildren, rightToggle, (0, _simpleAssign2.default)({}, styles.rightToggle));
	      }
	
	      if (primaryText) {
	        var primaryTextElement = this.createTextElement(styles.primaryText, primaryText, 'primaryText');
	        contentChildren.push(primaryTextElement);
	      }
	
	      if (secondaryText) {
	        var secondaryTextElement = this.createTextElement(styles.secondaryText, secondaryText, 'secondaryText');
	        contentChildren.push(secondaryTextElement);
	      }
	
	      var nestedList = nestedItems.length ? _react2.default.createElement(
	        _NestedList2.default,
	        { nestedLevel: nestedLevel, open: this.state.open, style: nestedListStyle },
	        nestedItems
	      ) : undefined;
	
	      var simpleLabel = !primaryTogglesNestedList && (leftCheckbox || rightToggle);
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        simpleLabel ? this.createLabelElement(styles, contentChildren, other) : disabled ? this.createDisabledElement(styles, contentChildren, other) : _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({
	            containerElement: containerElement
	          }, other, {
	            disableKeyboardFocus: disableKeyboardFocus || this.state.rightIconButtonKeyboardFocused,
	            onKeyboardFocus: this.handleKeyboardFocus,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseEnter: this.handleMouseEnter,
	            onTouchStart: this.handleTouchStart,
	            onTouchEnd: this.handleTouchEnd,
	            onTouchTap: primaryTogglesNestedList ? this.handleNestedListToggle : onTouchTap,
	            ref: function ref(node) {
	              return _this2.button = node;
	            },
	            style: (0, _simpleAssign2.default)({}, styles.root, style)
	          }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.innerDiv, innerDivStyle)) },
	            contentChildren
	          )
	        ),
	        nestedList
	      );
	    }
	  }]);
	  return ListItem;
	}(_react.Component);
	
	ListItem.muiName = 'ListItem';
	ListItem.defaultProps = {
	  autoGenerateNestedIndicator: true,
	  containerElement: 'span',
	  disableKeyboardFocus: false,
	  disabled: false,
	  initiallyOpen: false,
	  insetChildren: false,
	  nestedItems: [],
	  nestedLevel: 0,
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onNestedListToggle: function onNestedListToggle() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {},
	  open: null,
	  primaryTogglesNestedList: false,
	  secondaryTextLines: 1
	};
	ListItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ListItem.propTypes = {
	  /**
	   * If true, generate a nested-list-indicator icon when nested list
	   * items are detected. Note that an indicator will not be created
	   * if a `rightIcon` or `rightIconButton` has been provided to
	   * the element.
	   */
	  autoGenerateNestedIndicator: _propTypes2.default.bool,
	  /**
	   * Children passed into the `ListItem`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The element to use as the container for the ListItem. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * ListItem in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element will not be able to be focused by the keyboard.
	   */
	  disableKeyboardFocus: _propTypes2.default.bool,
	  /**
	   * If true, the element will not be clickable
	   * and will not display hover effects.
	   * This is automatically disabled if either `leftCheckbox`
	   * or `rightToggle` is set.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	  * Override the hover background color.
	  */
	  hoverColor: _propTypes2.default.string,
	  /**
	   * If true, the nested `ListItem`s are initially displayed.
	   */
	  initiallyOpen: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the inner div element.
	   */
	  innerDivStyle: _propTypes2.default.object,
	  /**
	   * If true, the children will be indented by 72px.
	   * This is useful if there is no left avatar or left icon.
	   */
	  insetChildren: _propTypes2.default.bool,
	  /**
	   * Use to control if the list item should render as keyboard focused.  If
	   * undefined (default), this will be automatically managed.  If provided,
	   * it will change the components style.  Note that this will not change the
	   * actual focus - and should only be used when you want to simulate
	   * keyboard focus (eg. in a rich text input autocomplete).
	   */
	  isKeyboardFocused: _propTypes2.default.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the left side.
	   */
	  leftAvatar: _propTypes2.default.element,
	  /**
	   * This is the `Checkbox` element to be displayed on the left side.
	   */
	  leftCheckbox: _propTypes2.default.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _propTypes2.default.element,
	  /**
	   * An array of `ListItem`s to nest underneath the current `ListItem`.
	   */
	  nestedItems: _propTypes2.default.arrayOf(_propTypes2.default.element),
	  /**
	   * Controls how deep a `ListItem` appears.
	   * This property is automatically managed, so modify at your own risk.
	   */
	  nestedLevel: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the nested items' `NestedList`.
	   */
	  nestedListStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the `ListItem` is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `ListItem`.
	   * @param {boolean} isKeyboardFocused If true, the `ListItem` is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Callbak function fired when the `ListItem` toggles its nested list.
	   *
	   * @param {object} listItem The `ListItem`.
	   */
	  onNestedListToggle: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /** @ignore */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * Control toggle state of nested list.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * This is the block element that contains the primary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  primaryText: _propTypes2.default.node,
	  /**
	   * If true, clicking or tapping the primary text of the `ListItem`
	   * toggles the nested list.
	   */
	  primaryTogglesNestedList: _propTypes2.default.bool,
	  /**
	   * This is the `Avatar` element to be displayed on the right side.
	   */
	  rightAvatar: _propTypes2.default.element,
	  /**
	   * This is the `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _propTypes2.default.element,
	  /**
	   * This is the `IconButton` to be displayed on the right side.
	   * Hovering over this button will remove the `ListItem` hover.
	   * Also, clicking on this button will not trigger a
	   * ripple on the `ListItem`; the event will be stopped and prevented
	   * from bubbling up to cause a `ListItem` click.
	   */
	  rightIconButton: _propTypes2.default.element,
	  /**
	   * This is the `Toggle` element to display on the right side.
	   */
	  rightToggle: _propTypes2.default.element,
	  /**
	   * This is the block element that contains the secondary text.
	   * If a string is passed in, a div tag will be rendered.
	   */
	  secondaryText: _propTypes2.default.node,
	  /**
	   * Can be 1 or 2. This is the number of secondary
	   * text lines before ellipsis will show.
	   */
	  secondaryTextLines: _propTypes2.default.oneOf([1, 2]),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = ListItem;

/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(68);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _Popover = __webpack_require__(87);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _check = __webpack_require__(380);
	
	var _check2 = _interopRequireDefault(_check);
	
	var _ListItem = __webpack_require__(215);
	
	var _ListItem2 = _interopRequireDefault(_ListItem);
	
	var _Menu = __webpack_require__(149);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var nestedMenuStyle = {
	  position: 'relative'
	};
	
	function getStyles(props, context) {
	  var disabledColor = context.muiTheme.baseTheme.palette.disabledColor;
	  var textColor = context.muiTheme.baseTheme.palette.textColor;
	  var indent = props.desktop ? 64 : 72;
	  var sidePadding = props.desktop ? 24 : 16;
	
	  var styles = {
	    root: {
	      color: props.disabled ? disabledColor : textColor,
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      minHeight: props.desktop ? '32px' : '48px',
	      lineHeight: props.desktop ? '32px' : '48px',
	      fontSize: props.desktop ? 15 : 16,
	      whiteSpace: 'nowrap'
	    },
	
	    innerDivStyle: {
	      paddingLeft: props.leftIcon || props.insetChildren || props.checked ? indent : sidePadding,
	      paddingRight: props.rightIcon ? indent : sidePadding,
	      paddingBottom: 0,
	      paddingTop: 0
	    },
	
	    secondaryText: {
	      float: 'right'
	    },
	
	    leftIconDesktop: {
	      margin: 0,
	      left: 24,
	      top: 4
	    },
	
	    rightIconDesktop: {
	      margin: 0,
	      right: 24,
	      top: 4,
	      fill: context.muiTheme.menuItem.rightIconDesktopFill
	    }
	  };
	
	  return styles;
	}
	
	var MenuItem = function (_Component) {
	  (0, _inherits3.default)(MenuItem, _Component);
	
	  function MenuItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, MenuItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = MenuItem.__proto__ || (0, _getPrototypeOf2.default)(MenuItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.cloneMenuItem = function (item) {
	      return _react2.default.cloneElement(item, {
	        onTouchTap: function onTouchTap(event) {
	          if (!item.props.menuItems) {
	            _this.handleRequestClose();
	          }
	
	          if (item.props.onTouchTap) {
	            item.props.onTouchTap(event);
	          }
	        }
	      });
	    }, _this.handleTouchTap = function (event) {
	      event.preventDefault();
	
	      _this.setState({
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this)
	      });
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _this.handleRequestClose = function () {
	      _this.setState({
	        open: false,
	        anchorEl: null
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(MenuItem, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.state.open && nextProps.focusState === 'none') {
	        this.handleRequestClose();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.applyFocusState();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      if (this.state.open) {
	        this.setState({
	          open: false
	        });
	      }
	    }
	  }, {
	    key: 'applyFocusState',
	    value: function applyFocusState() {
	      this.refs.listItem.applyFocusState(this.props.focusState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checked = _props.checked,
	          children = _props.children,
	          desktop = _props.desktop,
	          disabled = _props.disabled,
	          focusState = _props.focusState,
	          innerDivStyle = _props.innerDivStyle,
	          insetChildren = _props.insetChildren,
	          leftIcon = _props.leftIcon,
	          menuItems = _props.menuItems,
	          rightIcon = _props.rightIcon,
	          secondaryText = _props.secondaryText,
	          style = _props.style,
	          animation = _props.animation,
	          anchorOrigin = _props.anchorOrigin,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checked', 'children', 'desktop', 'disabled', 'focusState', 'innerDivStyle', 'insetChildren', 'leftIcon', 'menuItems', 'rightIcon', 'secondaryText', 'style', 'animation', 'anchorOrigin', 'value']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedInnerDivStyles = (0, _simpleAssign2.default)(styles.innerDivStyle, innerDivStyle);
	
	      // Left Icon
	      var leftIconElement = leftIcon ? leftIcon : checked ? _react2.default.createElement(_check2.default, null) : null;
	      if (leftIconElement) {
	        var mergedLeftIconStyles = desktop ? (0, _simpleAssign2.default)(styles.leftIconDesktop, leftIconElement.props.style) : leftIconElement.props.style;
	        leftIconElement = _react2.default.cloneElement(leftIconElement, { style: mergedLeftIconStyles });
	      }
	
	      // Right Icon
	      var rightIconElement = void 0;
	      if (rightIcon) {
	        var mergedRightIconStyles = desktop ? (0, _simpleAssign2.default)(styles.rightIconDesktop, rightIcon.props.style) : rightIcon.props.style;
	        rightIconElement = _react2.default.cloneElement(rightIcon, { style: mergedRightIconStyles });
	      }
	
	      // Secondary Text
	      var secondaryTextElement = void 0;
	      if (secondaryText) {
	        var secondaryTextIsAnElement = _react2.default.isValidElement(secondaryText);
	        var mergedSecondaryTextStyles = secondaryTextIsAnElement ? (0, _simpleAssign2.default)(styles.secondaryText, secondaryText.props.style) : null;
	
	        secondaryTextElement = secondaryTextIsAnElement ? _react2.default.cloneElement(secondaryText, { style: mergedSecondaryTextStyles }) : _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.secondaryText) },
	          secondaryText
	        );
	      }
	      var childMenuPopover = void 0;
	      if (menuItems) {
	        childMenuPopover = _react2.default.createElement(
	          _Popover2.default,
	          {
	            animation: animation,
	            anchorOrigin: anchorOrigin,
	            anchorEl: this.state.anchorEl,
	            open: this.state.open,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            { desktop: desktop, disabled: disabled, style: nestedMenuStyle },
	            _react2.default.Children.map(menuItems, this.cloneMenuItem)
	          )
	        );
	        other.onTouchTap = this.handleTouchTap;
	      }
	
	      return _react2.default.createElement(
	        _ListItem2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          hoverColor: this.context.muiTheme.menuItem.hoverColor,
	          innerDivStyle: mergedInnerDivStyles,
	          insetChildren: insetChildren,
	          leftIcon: leftIconElement,
	          ref: 'listItem',
	          rightIcon: rightIconElement,
	          role: 'menuitem',
	          style: mergedRootStyles
	        }),
	        children,
	        secondaryTextElement,
	        childMenuPopover
	      );
	    }
	  }]);
	  return MenuItem;
	}(_react.Component);
	
	MenuItem.muiName = 'MenuItem';
	MenuItem.defaultProps = {
	  anchorOrigin: { horizontal: 'right', vertical: 'top' },
	  checked: false,
	  desktop: false,
	  disabled: false,
	  focusState: 'none',
	  insetChildren: false
	};
	MenuItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? MenuItem.propTypes = {
	  /**
	   * Location of the anchor for the popover of nested `MenuItem`
	   * elements.
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * If true, a left check mark will be rendered.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * Elements passed as children to the underlying `ListItem`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   * If true, the menu item will render with compact desktop
	   * styles.
	   */
	  desktop: _propTypes2.default.bool,
	  /**
	   * If true, the menu item will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The focus state of the menu item. This prop is used to set the focus
	   * state of the underlying `ListItem`.
	   */
	  focusState: _propTypes2.default.oneOf(['none', 'focused', 'keyboard-focused']),
	  /**
	   * Override the inline-styles of the inner div.
	   */
	  innerDivStyle: _propTypes2.default.object,
	  /**
	   * If true, the children will be indented.
	   * This is only needed when there is no `leftIcon`.
	   */
	  insetChildren: _propTypes2.default.bool,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the left side.
	   */
	  leftIcon: _propTypes2.default.element,
	  /**
	   * `MenuItem` elements to nest within the menu item.
	   */
	  menuItems: _propTypes2.default.node,
	  /**
	   * Callback function fired when the menu item is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the menu item.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * Can be used to render primary text within the menu item.
	   */
	  primaryText: _propTypes2.default.node,
	  /**
	   * The `SvgIcon` or `FontIcon` to be displayed on the right side.
	   */
	  rightIcon: _propTypes2.default.element,
	  /**
	   * Can be used to render secondary text within the menu item.
	   */
	  secondaryText: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The value of the menu item.
	   */
	  value: _propTypes2.default.any
	} : void 0;
	exports.default = MenuItem;

/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _MenuItem = __webpack_require__(216);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MenuItem2.default;

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('450ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    }
	  };
	}
	
	var PopoverAnimationVertical = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationVertical, _Component);
	
	  function PopoverAnimationVertical() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationVertical);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationVertical.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationVertical)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationVertical, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        this.props.children
	      );
	    }
	  }]);
	  return PopoverAnimationVertical;
	}(_react.Component);
	
	PopoverAnimationVertical.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationVertical.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? PopoverAnimationVertical.propTypes = {
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  targetOrigin: _propTypes4.default.origin.isRequired,
	  zDepth: _propTypes4.default.zDepth
	} : void 0;
	exports.default = PopoverAnimationVertical;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Tooltip = __webpack_require__(373);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeaderColumn = context.muiTheme.tableHeaderColumn;
	
	
	  return {
	    root: {
	      fontWeight: 'normal',
	      fontSize: 12,
	      paddingLeft: tableHeaderColumn.spacing,
	      paddingRight: tableHeaderColumn.spacing,
	      height: tableHeaderColumn.height,
	      textAlign: 'left',
	      whiteSpace: 'nowrap',
	      textOverflow: 'ellipsis',
	      color: tableHeaderColumn.textColor,
	      position: 'relative'
	    },
	    tooltip: {
	      boxSizing: 'border-box',
	      marginTop: tableHeaderColumn.height / 2
	    }
	  };
	}
	
	var TableHeaderColumn = function (_Component) {
	  (0, _inherits3.default)(TableHeaderColumn, _Component);
	
	  function TableHeaderColumn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeaderColumn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeaderColumn.__proto__ || (0, _getPrototypeOf2.default)(TableHeaderColumn)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onMouseEnter = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: true });
	      }
	    }, _this.onMouseLeave = function () {
	      if (_this.props.tooltip !== undefined) {
	        _this.setState({ hovered: false });
	      }
	    }, _this.onClick = function (event) {
	      if (_this.props.onClick) {
	        _this.props.onClick(event, _this.props.columnNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeaderColumn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          columnNumber = _props.columnNumber,
	          hoverable = _props.hoverable,
	          onClick = _props.onClick,
	          onHover = _props.onHover,
	          onHoverExit = _props.onHoverExit,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipStyle = _props.tooltipStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'columnNumber', 'hoverable', 'onClick', 'onHover', 'onHoverExit', 'style', 'tooltip', 'tooltipStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var handlers = {
	        onMouseEnter: this.onMouseEnter,
	        onMouseLeave: this.onMouseLeave,
	        onClick: this.onClick
	      };
	
	      var tooltipNode = void 0;
	
	      if (tooltip !== undefined) {
	        tooltipNode = _react2.default.createElement(_Tooltip2.default, {
	          label: tooltip,
	          show: this.state.hovered,
	          style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyle)
	        });
	      }
	
	      return _react2.default.createElement(
	        'th',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, handlers, other),
	        tooltipNode,
	        children
	      );
	    }
	  }]);
	  return TableHeaderColumn;
	}(_react.Component);
	
	TableHeaderColumn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TableHeaderColumn.propTypes = {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Number to identify the header row. This property
	   * is automatically populated when used with TableHeader.
	   */
	  columnNumber: _propTypes2.default.number,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  hoverable: _propTypes2.default.bool,
	  /** @ignore */
	  onClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Not used here but we need to remove it from the root element.
	   */
	  onHoverExit: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The string to supply to the tooltip. If not
	   * string is supplied no tooltip will be shown.
	   */
	  tooltip: _propTypes2.default.string,
	  /**
	   * Additional styling that can be applied to the tooltip.
	   */
	  tooltipStyle: _propTypes2.default.object
	} : void 0;
	exports.default = TableHeaderColumn;

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(152);
	
	var _events2 = _interopRequireDefault(_events);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isDescendant = function isDescendant(el, target) {
	  if (target !== null) {
	    return el === target || isDescendant(el, target.parentNode);
	  }
	  return false;
	};
	
	var clickAwayEvents = ['mouseup', 'touchend'];
	var bind = function bind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.on(document, event, callback);
	  });
	};
	var unbind = function unbind(callback) {
	  return clickAwayEvents.forEach(function (event) {
	    return _events2.default.off(document, event, callback);
	  });
	};
	
	var ClickAwayListener = function (_Component) {
	  (0, _inherits3.default)(ClickAwayListener, _Component);
	
	  function ClickAwayListener() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClickAwayListener);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClickAwayListener.__proto__ || (0, _getPrototypeOf2.default)(ClickAwayListener)).call.apply(_ref, [this].concat(args))), _this), _this.handleClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      // IE11 support, which trigger the handleClickAway even after the unbind
	      if (_this.isCurrentlyMounted) {
	        var el = _reactDom2.default.findDOMNode(_this);
	
	        if (document.documentElement.contains(event.target) && !isDescendant(el, event.target)) {
	          _this.props.onClickAway(event);
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClickAwayListener, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.isCurrentlyMounted = true;
	      if (this.props.onClickAway) {
	        bind(this.handleClickAway);
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (prevProps.onClickAway !== this.props.onClickAway) {
	        unbind(this.handleClickAway);
	        if (this.props.onClickAway) {
	          bind(this.handleClickAway);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.isCurrentlyMounted = false;
	      unbind(this.handleClickAway);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return ClickAwayListener;
	}(_react.Component);
	
	 false ? ClickAwayListener.propTypes = {
	  children: _propTypes2.default.element,
	  onClickAway: _propTypes2.default.func
	} : void 0;
	exports.default = ClickAwayListener;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(44);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(222);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _TouchRipple = __webpack_require__(374);
	
	var _TouchRipple2 = _interopRequireDefault(_TouchRipple);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      cursor: props.disabled ? 'not-allowed' : 'pointer',
	      position: 'relative',
	      overflow: 'visible',
	      display: 'table',
	      height: 'auto',
	      width: '100%'
	    },
	    input: {
	      position: 'absolute',
	      cursor: 'inherit',
	      pointerEvents: 'all',
	      opacity: 0,
	      width: '100%',
	      height: '100%',
	      zIndex: 2,
	      left: 0,
	      boxSizing: 'border-box',
	      padding: 0,
	      margin: 0
	    },
	    controls: {
	      display: 'flex',
	      width: '100%',
	      height: '100%'
	    },
	    label: {
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      width: 'calc(100% - 60px)',
	      lineHeight: '24px',
	      color: baseTheme.palette.textColor,
	      fontFamily: baseTheme.fontFamily
	    },
	    wrap: {
	      transition: _transitions2.default.easeOut(),
	      float: 'left',
	      position: 'relative',
	      display: 'block',
	      flexShrink: 0,
	      width: 60 - baseTheme.spacing.desktopGutterLess,
	      marginRight: props.labelPosition === 'right' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginLeft: props.labelPosition === 'left' ? baseTheme.spacing.desktopGutterLess : 0
	    },
	    ripple: {
	      color: props.rippleColor || baseTheme.palette.primary1Color,
	      height: '200%',
	      width: '200%',
	      top: -12,
	      left: -12
	    }
	  };
	}
	
	var EnhancedSwitch = function (_Component) {
	  (0, _inherits3.default)(EnhancedSwitch, _Component);
	
	  function EnhancedSwitch() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedSwitch);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedSwitch.__proto__ || (0, _getPrototypeOf2.default)(EnhancedSwitch)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isKeyboardFocused: false
	    }, _this.handleChange = function (event) {
	      _this.tabPressed = false;
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      var isInputChecked = _this.refs.checkbox.checked;
	
	      if (!_this.props.hasOwnProperty('checked') && _this.props.onParentShouldUpdate) {
	        _this.props.onParentShouldUpdate(isInputChecked);
	      }
	
	      if (_this.props.onSwitch) {
	        _this.props.onSwitch(event, isInputChecked);
	      }
	    }, _this.handleKeyDown = function (event) {
	      var code = (0, _keycode2.default)(event);
	
	      if (code === 'tab') {
	        _this.tabPressed = true;
	      }
	      if (_this.state.isKeyboardFocused && code === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.isKeyboardFocused && (0, _keycode2.default)(event) === 'space') {
	        _this.handleChange(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.refs.touchRipple.start(event);
	      }
	    }, _this.handleMouseUp = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleMouseLeave = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleTouchStart = function (event) {
	      _this.refs.touchRipple.start(event);
	    }, _this.handleTouchEnd = function () {
	      _this.refs.touchRipple.end();
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        isKeyboardFocused: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      // setTimeout is needed becuase the focus event fires first
	      // Wait so that we can capture if this was a keyboard focus
	      // or touch focus
	      setTimeout(function () {
	        if (_this.tabPressed) {
	          _this.setState({
	            isKeyboardFocused: true
	          });
	        }
	      }, 150);
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedSwitch, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var inputNode = this.refs.checkbox;
	      if ((!this.props.switched || inputNode.checked !== this.props.switched) && this.props.onParentShouldUpdate) {
	        this.props.onParentShouldUpdate(inputNode.checked);
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var hasCheckedProp = nextProps.hasOwnProperty('checked');
	      var hasNewDefaultProp = nextProps.hasOwnProperty('defaultChecked') && nextProps.defaultChecked !== this.props.defaultChecked;
	
	      if (hasCheckedProp || hasNewDefaultProp) {
	        var switched = nextProps.checked || nextProps.defaultChecked || false;
	
	        this.setState({
	          switched: switched
	        });
	
	        if (this.props.onParentShouldUpdate && switched !== this.props.switched) {
	          this.props.onParentShouldUpdate(switched);
	        }
	      }
	    }
	  }, {
	    key: 'isSwitched',
	    value: function isSwitched() {
	      return this.refs.checkbox.checked;
	    }
	
	    // no callback here because there is no event
	
	  }, {
	    key: 'setSwitched',
	    value: function setSwitched(newSwitchedValue) {
	      if (!this.props.hasOwnProperty('checked') || this.props.checked === false) {
	        if (this.props.onParentShouldUpdate) {
	          this.props.onParentShouldUpdate(newSwitchedValue);
	        }
	        this.refs.checkbox.checked = newSwitchedValue;
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot call set method while checked is defined as a property.') : void 0;
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.checkbox.value;
	    }
	
	    // Checkbox inputs only use SPACE to change their state. Using ENTER will
	    // update the ui but not the input.
	
	
	    /**
	     * Because both the ripples and the checkbox input cannot share pointer
	     * events, the checkbox input takes control of pointer events and calls
	     * ripple animations manually.
	     */
	
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          name = _props.name,
	          value = _props.value,
	          iconStyle = _props.iconStyle,
	          inputStyle = _props.inputStyle,
	          inputType = _props.inputType,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onSwitch = _props.onSwitch,
	          onBlur = _props.onBlur,
	          onFocus = _props.onFocus,
	          onMouseUp = _props.onMouseUp,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          onTouchEnd = _props.onTouchEnd,
	          onParentShouldUpdate = _props.onParentShouldUpdate,
	          disabled = _props.disabled,
	          disableTouchRipple = _props.disableTouchRipple,
	          disableFocusRipple = _props.disableFocusRipple,
	          className = _props.className,
	          rippleColor = _props.rippleColor,
	          rippleStyle = _props.rippleStyle,
	          style = _props.style,
	          switched = _props.switched,
	          switchElement = _props.switchElement,
	          thumbStyle = _props.thumbStyle,
	          trackStyle = _props.trackStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['name', 'value', 'iconStyle', 'inputStyle', 'inputType', 'label', 'labelStyle', 'labelPosition', 'onSwitch', 'onBlur', 'onFocus', 'onMouseUp', 'onMouseDown', 'onMouseLeave', 'onTouchStart', 'onTouchEnd', 'onParentShouldUpdate', 'disabled', 'disableTouchRipple', 'disableFocusRipple', 'className', 'rippleColor', 'rippleStyle', 'style', 'switched', 'switchElement', 'thumbStyle', 'trackStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var wrapStyles = (0, _simpleAssign2.default)(styles.wrap, iconStyle);
	      var mergedRippleStyle = (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	      if (thumbStyle) {
	        wrapStyles.marginLeft /= 2;
	        wrapStyles.marginRight /= 2;
	      }
	
	      var labelElement = label && _react2.default.createElement(
	        'label',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var showTouchRipple = !disabled && !disableTouchRipple;
	      var showFocusRipple = !disabled && !disableFocusRipple;
	
	      var touchRipple = _react2.default.createElement(_TouchRipple2.default, {
	        ref: 'touchRipple',
	        key: 'touchRipple',
	        style: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        centerRipple: true
	      });
	
	      var focusRipple = _react2.default.createElement(_FocusRipple2.default, {
	        key: 'focusRipple',
	        innerStyle: mergedRippleStyle,
	        color: mergedRippleStyle.color,
	        muiTheme: this.context.muiTheme,
	        show: this.state.isKeyboardFocused
	      });
	
	      var ripples = [showTouchRipple ? touchRipple : null, showFocusRipple ? focusRipple : null];
	
	      var inputElement = _react2.default.createElement('input', (0, _extends3.default)({}, other, {
	        ref: 'checkbox',
	        type: inputType,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.input, inputStyle)),
	        name: name,
	        value: value,
	        disabled: disabled,
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onChange: this.handleChange,
	        onMouseUp: showTouchRipple && this.handleMouseUp,
	        onMouseDown: showTouchRipple && this.handleMouseDown,
	        onMouseLeave: showTouchRipple && this.handleMouseLeave,
	        onTouchStart: showTouchRipple && this.handleTouchStart,
	        onTouchEnd: showTouchRipple && this.handleTouchEnd
	      }));
	
	      // If toggle component (indicated by whether the style includes thumb) manually lay out
	      // elements in order to nest ripple elements
	      var switchOrThumbElement = !thumbStyle ? _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        switchElement,
	        ripples
	      ) : _react2.default.createElement(
	        'div',
	        { style: prepareStyles(wrapStyles) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, trackStyle)) }),
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: thumbStyle, zDepth: 1, circle: true },
	          ' ',
	          ripples,
	          ' '
	        )
	      );
	
	      var elementsInOrder = labelPosition === 'right' ? _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        switchOrThumbElement,
	        labelElement
	      ) : _react2.default.createElement(
	        'div',
	        { style: styles.controls },
	        labelElement,
	        switchOrThumbElement
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'root', className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleKeyDown,
	          onKeyUp: this.handleKeyUp
	        }),
	        inputElement,
	        elementsInOrder
	      );
	    }
	  }]);
	  return EnhancedSwitch;
	}(_react.Component);
	
	EnhancedSwitch.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? EnhancedSwitch.propTypes = {
	  checked: _propTypes2.default.bool,
	  className: _propTypes2.default.string,
	  defaultChecked: _propTypes2.default.bool,
	  disableFocusRipple: _propTypes2.default.bool,
	  disableTouchRipple: _propTypes2.default.bool,
	  disabled: _propTypes2.default.bool,
	  iconStyle: _propTypes2.default.object,
	  inputStyle: _propTypes2.default.object,
	  inputType: _propTypes2.default.string.isRequired,
	  label: _propTypes2.default.node,
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  labelStyle: _propTypes2.default.object,
	  name: _propTypes2.default.string,
	  onBlur: _propTypes2.default.func,
	  onFocus: _propTypes2.default.func,
	  onMouseDown: _propTypes2.default.func,
	  onMouseLeave: _propTypes2.default.func,
	  onMouseUp: _propTypes2.default.func,
	  onParentShouldUpdate: _propTypes2.default.func,
	  onSwitch: _propTypes2.default.func,
	  onTouchEnd: _propTypes2.default.func,
	  onTouchStart: _propTypes2.default.func,
	  rippleColor: _propTypes2.default.string,
	  rippleStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  switchElement: _propTypes2.default.element.isRequired,
	  switched: _propTypes2.default.bool.isRequired,
	  thumbStyle: _propTypes2.default.object,
	  trackStyle: _propTypes2.default.object,
	  value: _propTypes2.default.any
	} : void 0;
	exports.default = EnhancedSwitch;

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(68);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(64);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ScaleIn = __webpack_require__(879);
	
	var _ScaleIn2 = _interopRequireDefault(_ScaleIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var pulsateDuration = 750;
	
	var FocusRipple = function (_Component) {
	  (0, _inherits3.default)(FocusRipple, _Component);
	
	  function FocusRipple() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FocusRipple);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FocusRipple.__proto__ || (0, _getPrototypeOf2.default)(FocusRipple)).call.apply(_ref, [this].concat(args))), _this), _this.pulsate = function () {
	      var innerCircle = _reactDom2.default.findDOMNode(_this.refs.innerCircle);
	      if (!innerCircle) return;
	
	      var startScale = 'scale(1)';
	      var endScale = 'scale(0.85)';
	      var currentScale = innerCircle.style.transform || startScale;
	      var nextScale = currentScale === startScale ? endScale : startScale;
	
	      _autoPrefix2.default.set(innerCircle.style, 'transform', nextScale);
	      _this.timeout = setTimeout(_this.pulsate, pulsateDuration);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FocusRipple, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      if (this.props.show) {
	        this.setRippleSize();
	        this.pulsate();
	      } else {
	        if (this.timeout) clearTimeout(this.timeout);
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timeout);
	    }
	  }, {
	    key: 'getRippleElement',
	    value: function getRippleElement(props) {
	      var color = props.color,
	          innerStyle = props.innerStyle,
	          opacity = props.opacity;
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          ripple = _context$muiTheme.ripple;
	
	
	      var innerStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        opacity: opacity ? opacity : 0.16,
	        backgroundColor: color || ripple.color,
	        transition: _transitions2.default.easeOut(pulsateDuration + 'ms', 'transform', null, _transitions2.default.easeInOutFunction)
	      }, innerStyle);
	
	      return _react2.default.createElement('div', { ref: 'innerCircle', style: prepareStyles((0, _simpleAssign2.default)({}, innerStyles)) });
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var el = _reactDom2.default.findDOMNode(this.refs.innerCircle);
	      var height = el.offsetHeight;
	      var width = el.offsetWidth;
	      var size = Math.max(height, width);
	
	      var oldTop = 0;
	      // For browsers that don't support endsWith()
	      if (el.style.top.indexOf('px', el.style.top.length - 2) !== -1) {
	        oldTop = parseInt(el.style.top);
	      }
	      el.style.height = size + 'px';
	      el.style.top = height / 2 - size / 2 + oldTop + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          show = _props.show,
	          style = _props.style;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        height: '100%',
	        width: '100%',
	        position: 'absolute',
	        top: 0,
	        left: 0
	      }, style);
	
	      var ripple = show ? this.getRippleElement(this.props) : null;
	
	      return _react2.default.createElement(
	        _ScaleIn2.default,
	        {
	          maxScale: 0.85,
	          style: mergedRootStyles
	        },
	        ripple
	      );
	    }
	  }]);
	  return FocusRipple;
	}(_react.Component);
	
	FocusRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? FocusRipple.propTypes = {
	  color: _propTypes2.default.string,
	  innerStyle: _propTypes2.default.object,
	  opacity: _propTypes2.default.number,
	  show: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = FocusRipple;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsTransitionGroup = __webpack_require__(118);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _SlideInChild = __webpack_require__(881);
	
	var _SlideInChild2 = _interopRequireDefault(_SlideInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideIn = function (_Component) {
	  (0, _inherits3.default)(SlideIn, _Component);
	
	  function SlideIn() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SlideIn);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SlideIn.__proto__ || (0, _getPrototypeOf2.default)(SlideIn)).call.apply(_ref, [this].concat(args))), _this), _this.getLeaveDirection = function () {
	      return _this.props.direction;
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SlideIn, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          direction = _props.direction,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['enterDelay', 'children', 'childStyle', 'direction', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _SlideInChild2.default,
	          {
	            key: child.key,
	            direction: direction,
	            enterDelay: enterDelay,
	            getLeaveDirection: _this2.getLeaveDirection,
	            style: childStyle
	          },
	          child
	        );
	      }, this);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return SlideIn;
	}(_react.Component);
	
	SlideIn.defaultProps = {
	  enterDelay: 0,
	  direction: 'left'
	};
	SlideIn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? SlideIn.propTypes = {
	  childStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  direction: _propTypes2.default.oneOf(['left', 'right', 'up', 'down']),
	  enterDelay: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = SlideIn;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {exports = module.exports = debug;
	
	function debug(label) {
	  return _debug.bind(null, label);
	}
	
	function _debug(label) {
	  var args = [].slice.call(arguments, 1);
	  args.unshift('[' + label + ']');
	  process.stderr.write(args.join(' ') + '\n');
	}
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMLazyTree = __webpack_require__(88);
	var Danger = __webpack_require__(1857);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInstrumentation = __webpack_require__(36);
	
	var createMicrosoftUnsafeLocalFunction = __webpack_require__(234);
	var setInnerHTML = __webpack_require__(159);
	var setTextContent = __webpack_require__(412);
	
	function getNodeAfter(parentNode, node) {
	  // Special case for text components, which return [open, close] comments
	  // from getHostNode.
	  if (Array.isArray(node)) {
	    node = node[1];
	  }
	  return node ? node.nextSibling : parentNode.firstChild;
	}
	
	/**
	 * Inserts `childNode` as a child of `parentNode` at the `index`.
	 *
	 * @param {DOMElement} parentNode Parent node in which to insert.
	 * @param {DOMElement} childNode Child node to insert.
	 * @param {number} index Index at which to insert the child.
	 * @internal
	 */
	var insertChildAt = createMicrosoftUnsafeLocalFunction(function (parentNode, childNode, referenceNode) {
	  // We rely exclusively on `insertBefore(node, null)` instead of also using
	  // `appendChild(node)`. (Using `undefined` is not allowed by all browsers so
	  // we are careful to use `null`.)
	  parentNode.insertBefore(childNode, referenceNode);
	});
	
	function insertLazyTreeChildAt(parentNode, childTree, referenceNode) {
	  DOMLazyTree.insertTreeBefore(parentNode, childTree, referenceNode);
	}
	
	function moveChild(parentNode, childNode, referenceNode) {
	  if (Array.isArray(childNode)) {
	    moveDelimitedText(parentNode, childNode[0], childNode[1], referenceNode);
	  } else {
	    insertChildAt(parentNode, childNode, referenceNode);
	  }
	}
	
	function removeChild(parentNode, childNode) {
	  if (Array.isArray(childNode)) {
	    var closingComment = childNode[1];
	    childNode = childNode[0];
	    removeDelimitedText(parentNode, childNode, closingComment);
	    parentNode.removeChild(closingComment);
	  }
	  parentNode.removeChild(childNode);
	}
	
	function moveDelimitedText(parentNode, openingComment, closingComment, referenceNode) {
	  var node = openingComment;
	  while (true) {
	    var nextNode = node.nextSibling;
	    insertChildAt(parentNode, node, referenceNode);
	    if (node === closingComment) {
	      break;
	    }
	    node = nextNode;
	  }
	}
	
	function removeDelimitedText(parentNode, startNode, closingComment) {
	  while (true) {
	    var node = startNode.nextSibling;
	    if (node === closingComment) {
	      // The closing comment is removed by ReactMultiChild.
	      break;
	    } else {
	      parentNode.removeChild(node);
	    }
	  }
	}
	
	function replaceDelimitedText(openingComment, closingComment, stringText) {
	  var parentNode = openingComment.parentNode;
	  var nodeAfterComment = openingComment.nextSibling;
	  if (nodeAfterComment === closingComment) {
	    // There are no text nodes between the opening and closing comments; insert
	    // a new one if stringText isn't empty.
	    if (stringText) {
	      insertChildAt(parentNode, document.createTextNode(stringText), nodeAfterComment);
	    }
	  } else {
	    if (stringText) {
	      // Set the text content of the first node after the opening comment, and
	      // remove all following nodes up until the closing comment.
	      setTextContent(nodeAfterComment, stringText);
	      removeDelimitedText(parentNode, nodeAfterComment, closingComment);
	    } else {
	      removeDelimitedText(parentNode, openingComment, closingComment);
	    }
	  }
	
	  if (false) {
	    ReactInstrumentation.debugTool.onHostOperation({
	      instanceID: ReactDOMComponentTree.getInstanceFromNode(openingComment)._debugID,
	      type: 'replace text',
	      payload: stringText
	    });
	  }
	}
	
	var dangerouslyReplaceNodeWithMarkup = Danger.dangerouslyReplaceNodeWithMarkup;
	if (false) {
	  dangerouslyReplaceNodeWithMarkup = function (oldChild, markup, prevInstance) {
	    Danger.dangerouslyReplaceNodeWithMarkup(oldChild, markup);
	    if (prevInstance._debugID !== 0) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: prevInstance._debugID,
	        type: 'replace with',
	        payload: markup.toString()
	      });
	    } else {
	      var nextInstance = ReactDOMComponentTree.getInstanceFromNode(markup.node);
	      if (nextInstance._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: nextInstance._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  };
	}
	
	/**
	 * Operations for updating with DOM children.
	 */
	var DOMChildrenOperations = {
	  dangerouslyReplaceNodeWithMarkup: dangerouslyReplaceNodeWithMarkup,
	
	  replaceDelimitedText: replaceDelimitedText,
	
	  /**
	   * Updates a component's children by processing a series of updates. The
	   * update configurations are each expected to have a `parentNode` property.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  processUpdates: function (parentNode, updates) {
	    if (false) {
	      var parentNodeDebugID = ReactDOMComponentTree.getInstanceFromNode(parentNode)._debugID;
	    }
	
	    for (var k = 0; k < updates.length; k++) {
	      var update = updates[k];
	      switch (update.type) {
	        case 'INSERT_MARKUP':
	          insertLazyTreeChildAt(parentNode, update.content, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'insert child',
	              payload: {
	                toIndex: update.toIndex,
	                content: update.content.toString()
	              }
	            });
	          }
	          break;
	        case 'MOVE_EXISTING':
	          moveChild(parentNode, update.fromNode, getNodeAfter(parentNode, update.afterNode));
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'move child',
	              payload: { fromIndex: update.fromIndex, toIndex: update.toIndex }
	            });
	          }
	          break;
	        case 'SET_MARKUP':
	          setInnerHTML(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace children',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'TEXT_CONTENT':
	          setTextContent(parentNode, update.content);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'replace text',
	              payload: update.content.toString()
	            });
	          }
	          break;
	        case 'REMOVE_NODE':
	          removeChild(parentNode, update.fromNode);
	          if (false) {
	            ReactInstrumentation.debugTool.onHostOperation({
	              instanceID: parentNodeDebugID,
	              type: 'remove child',
	              payload: { fromIndex: update.fromIndex }
	            });
	          }
	          break;
	      }
	    }
	  }
	};
	
	module.exports = DOMChildrenOperations;

/***/ },
/* 226 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMNamespaces = {
	  html: 'http://www.w3.org/1999/xhtml',
	  mathml: 'http://www.w3.org/1998/Math/MathML',
	  svg: 'http://www.w3.org/2000/svg'
	};
	
	module.exports = DOMNamespaces;

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Injectable ordering of event plugins.
	 */
	var eventPluginOrder = null;
	
	/**
	 * Injectable mapping from names to event plugin modules.
	 */
	var namesToPlugins = {};
	
	/**
	 * Recomputes the plugin list using the injected plugins and plugin ordering.
	 *
	 * @private
	 */
	function recomputePluginOrdering() {
	  if (!eventPluginOrder) {
	    // Wait until an `eventPluginOrder` is injected.
	    return;
	  }
	  for (var pluginName in namesToPlugins) {
	    var pluginModule = namesToPlugins[pluginName];
	    var pluginIndex = eventPluginOrder.indexOf(pluginName);
	    !(pluginIndex > -1) ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugins that do not exist in the plugin ordering, `%s`.', pluginName) : _prodInvariant('96', pluginName) : void 0;
	    if (EventPluginRegistry.plugins[pluginIndex]) {
	      continue;
	    }
	    !pluginModule.extractEvents ?  false ? invariant(false, 'EventPluginRegistry: Event plugins must implement an `extractEvents` method, but `%s` does not.', pluginName) : _prodInvariant('97', pluginName) : void 0;
	    EventPluginRegistry.plugins[pluginIndex] = pluginModule;
	    var publishedEvents = pluginModule.eventTypes;
	    for (var eventName in publishedEvents) {
	      !publishEventForPlugin(publishedEvents[eventName], pluginModule, eventName) ?  false ? invariant(false, 'EventPluginRegistry: Failed to publish event `%s` for plugin `%s`.', eventName, pluginName) : _prodInvariant('98', eventName, pluginName) : void 0;
	    }
	  }
	}
	
	/**
	 * Publishes an event so that it can be dispatched by the supplied plugin.
	 *
	 * @param {object} dispatchConfig Dispatch configuration for the event.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @return {boolean} True if the event was successfully published.
	 * @private
	 */
	function publishEventForPlugin(dispatchConfig, pluginModule, eventName) {
	  !!EventPluginRegistry.eventNameDispatchConfigs.hasOwnProperty(eventName) ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same event name, `%s`.', eventName) : _prodInvariant('99', eventName) : void 0;
	  EventPluginRegistry.eventNameDispatchConfigs[eventName] = dispatchConfig;
	
	  var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	  if (phasedRegistrationNames) {
	    for (var phaseName in phasedRegistrationNames) {
	      if (phasedRegistrationNames.hasOwnProperty(phaseName)) {
	        var phasedRegistrationName = phasedRegistrationNames[phaseName];
	        publishRegistrationName(phasedRegistrationName, pluginModule, eventName);
	      }
	    }
	    return true;
	  } else if (dispatchConfig.registrationName) {
	    publishRegistrationName(dispatchConfig.registrationName, pluginModule, eventName);
	    return true;
	  }
	  return false;
	}
	
	/**
	 * Publishes a registration name that is used to identify dispatched events and
	 * can be used with `EventPluginHub.putListener` to register listeners.
	 *
	 * @param {string} registrationName Registration name to add.
	 * @param {object} PluginModule Plugin publishing the event.
	 * @private
	 */
	function publishRegistrationName(registrationName, pluginModule, eventName) {
	  !!EventPluginRegistry.registrationNameModules[registrationName] ?  false ? invariant(false, 'EventPluginHub: More than one plugin attempted to publish the same registration name, `%s`.', registrationName) : _prodInvariant('100', registrationName) : void 0;
	  EventPluginRegistry.registrationNameModules[registrationName] = pluginModule;
	  EventPluginRegistry.registrationNameDependencies[registrationName] = pluginModule.eventTypes[eventName].dependencies;
	
	  if (false) {
	    var lowerCasedName = registrationName.toLowerCase();
	    EventPluginRegistry.possibleRegistrationNames[lowerCasedName] = registrationName;
	
	    if (registrationName === 'onDoubleClick') {
	      EventPluginRegistry.possibleRegistrationNames.ondblclick = registrationName;
	    }
	  }
	}
	
	/**
	 * Registers plugins so that they can extract and dispatch events.
	 *
	 * @see {EventPluginHub}
	 */
	var EventPluginRegistry = {
	  /**
	   * Ordered list of injected plugins.
	   */
	  plugins: [],
	
	  /**
	   * Mapping from event name to dispatch config
	   */
	  eventNameDispatchConfigs: {},
	
	  /**
	   * Mapping from registration name to plugin module
	   */
	  registrationNameModules: {},
	
	  /**
	   * Mapping from registration name to event name
	   */
	  registrationNameDependencies: {},
	
	  /**
	   * Mapping from lowercase registration names to the properly cased version,
	   * used to warn in the case of missing event handlers. Available
	   * only in __DEV__.
	   * @type {Object}
	   */
	  possibleRegistrationNames:  false ? {} : null,
	  // Trust the developer to only use possibleRegistrationNames in __DEV__
	
	  /**
	   * Injects an ordering of plugins (by plugin name). This allows the ordering
	   * to be decoupled from injection of the actual plugins so that ordering is
	   * always deterministic regardless of packaging, on-the-fly injection, etc.
	   *
	   * @param {array} InjectedEventPluginOrder
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginOrder}
	   */
	  injectEventPluginOrder: function (injectedEventPluginOrder) {
	    !!eventPluginOrder ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject event plugin ordering more than once. You are likely trying to load more than one copy of React.') : _prodInvariant('101') : void 0;
	    // Clone the ordering so it cannot be dynamically mutated.
	    eventPluginOrder = Array.prototype.slice.call(injectedEventPluginOrder);
	    recomputePluginOrdering();
	  },
	
	  /**
	   * Injects plugins to be used by `EventPluginHub`. The plugin names must be
	   * in the ordering injected by `injectEventPluginOrder`.
	   *
	   * Plugins can be injected as part of page initialization or on-the-fly.
	   *
	   * @param {object} injectedNamesToPlugins Map from names to plugin modules.
	   * @internal
	   * @see {EventPluginHub.injection.injectEventPluginsByName}
	   */
	  injectEventPluginsByName: function (injectedNamesToPlugins) {
	    var isOrderingDirty = false;
	    for (var pluginName in injectedNamesToPlugins) {
	      if (!injectedNamesToPlugins.hasOwnProperty(pluginName)) {
	        continue;
	      }
	      var pluginModule = injectedNamesToPlugins[pluginName];
	      if (!namesToPlugins.hasOwnProperty(pluginName) || namesToPlugins[pluginName] !== pluginModule) {
	        !!namesToPlugins[pluginName] ?  false ? invariant(false, 'EventPluginRegistry: Cannot inject two different event plugins using the same name, `%s`.', pluginName) : _prodInvariant('102', pluginName) : void 0;
	        namesToPlugins[pluginName] = pluginModule;
	        isOrderingDirty = true;
	      }
	    }
	    if (isOrderingDirty) {
	      recomputePluginOrdering();
	    }
	  },
	
	  /**
	   * Looks up the plugin for the supplied event.
	   *
	   * @param {object} event A synthetic event.
	   * @return {?object} The plugin that created the supplied event.
	   * @internal
	   */
	  getPluginModuleForEvent: function (event) {
	    var dispatchConfig = event.dispatchConfig;
	    if (dispatchConfig.registrationName) {
	      return EventPluginRegistry.registrationNameModules[dispatchConfig.registrationName] || null;
	    }
	    if (dispatchConfig.phasedRegistrationNames !== undefined) {
	      // pulling phasedRegistrationNames out of dispatchConfig helps Flow see
	      // that it is not undefined.
	      var phasedRegistrationNames = dispatchConfig.phasedRegistrationNames;
	
	      for (var phase in phasedRegistrationNames) {
	        if (!phasedRegistrationNames.hasOwnProperty(phase)) {
	          continue;
	        }
	        var pluginModule = EventPluginRegistry.registrationNameModules[phasedRegistrationNames[phase]];
	        if (pluginModule) {
	          return pluginModule;
	        }
	      }
	    }
	    return null;
	  },
	
	  /**
	   * Exposed for unit testing.
	   * @private
	   */
	  _resetEventPlugins: function () {
	    eventPluginOrder = null;
	    for (var pluginName in namesToPlugins) {
	      if (namesToPlugins.hasOwnProperty(pluginName)) {
	        delete namesToPlugins[pluginName];
	      }
	    }
	    EventPluginRegistry.plugins.length = 0;
	
	    var eventNameDispatchConfigs = EventPluginRegistry.eventNameDispatchConfigs;
	    for (var eventName in eventNameDispatchConfigs) {
	      if (eventNameDispatchConfigs.hasOwnProperty(eventName)) {
	        delete eventNameDispatchConfigs[eventName];
	      }
	    }
	
	    var registrationNameModules = EventPluginRegistry.registrationNameModules;
	    for (var registrationName in registrationNameModules) {
	      if (registrationNameModules.hasOwnProperty(registrationName)) {
	        delete registrationNameModules[registrationName];
	      }
	    }
	
	    if (false) {
	      var possibleRegistrationNames = EventPluginRegistry.possibleRegistrationNames;
	      for (var lowerCasedName in possibleRegistrationNames) {
	        if (possibleRegistrationNames.hasOwnProperty(lowerCasedName)) {
	          delete possibleRegistrationNames[lowerCasedName];
	        }
	      }
	    }
	  }
	};
	
	module.exports = EventPluginRegistry;

/***/ },
/* 228 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * Escape and wrap key so it is safe to use as a reactid
	 *
	 * @param {string} key to be escaped.
	 * @return {string} the escaped key.
	 */
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function (match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	/**
	 * Unescape and unwrap key for human-readable display
	 *
	 * @param {string} key to unescape.
	 * @return {string} the unescaped key.
	 */
	function unescape(key) {
	  var unescapeRegex = /(=0|=2)/g;
	  var unescaperLookup = {
	    '=0': '=',
	    '=2': ':'
	  };
	  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);
	
	  return ('' + keySubstring).replace(unescapeRegex, function (match) {
	    return unescaperLookup[match];
	  });
	}
	
	var KeyEscapeUtils = {
	  escape: escape,
	  unescape: unescape
	};
	
	module.exports = KeyEscapeUtils;

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactPropTypesSecret = __webpack_require__(1887);
	var propTypesFactory = __webpack_require__(392);
	
	var React = __webpack_require__(94);
	var PropTypes = propTypesFactory(React.isValidElement);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(16);
	
	var hasReadOnlyValue = {
	  button: true,
	  checkbox: true,
	  image: true,
	  hidden: true,
	  radio: true,
	  reset: true,
	  submit: true
	};
	
	function _assertSingleLink(inputProps) {
	  !(inputProps.checkedLink == null || inputProps.valueLink == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a valueLink. If you want to use checkedLink, you probably don\'t want to use valueLink and vice versa.') : _prodInvariant('87') : void 0;
	}
	function _assertValueLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.value == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a valueLink and a value or onChange event. If you want to use value or onChange, you probably don\'t want to use valueLink.') : _prodInvariant('88') : void 0;
	}
	
	function _assertCheckedLink(inputProps) {
	  _assertSingleLink(inputProps);
	  !(inputProps.checked == null && inputProps.onChange == null) ?  false ? invariant(false, 'Cannot provide a checkedLink and a checked property or onChange event. If you want to use checked or onChange, you probably don\'t want to use checkedLink') : _prodInvariant('89') : void 0;
	}
	
	var propTypes = {
	  value: function (props, propName, componentName) {
	    if (!props[propName] || hasReadOnlyValue[props.type] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `value` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultValue`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  checked: function (props, propName, componentName) {
	    if (!props[propName] || props.onChange || props.readOnly || props.disabled) {
	      return null;
	    }
	    return new Error('You provided a `checked` prop to a form field without an ' + '`onChange` handler. This will render a read-only field. If ' + 'the field should be mutable use `defaultChecked`. Otherwise, ' + 'set either `onChange` or `readOnly`.');
	  },
	  onChange: PropTypes.func
	};
	
	var loggedTypeFailures = {};
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Provide a linked `value` attribute for controlled forms. You should not use
	 * this outside of the ReactDOM controlled form components.
	 */
	var LinkedValueUtils = {
	  checkPropTypes: function (tagName, props, owner) {
	    for (var propName in propTypes) {
	      if (propTypes.hasOwnProperty(propName)) {
	        var error = propTypes[propName](props, propName, tagName, 'prop', null, ReactPropTypesSecret);
	      }
	      if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	        // Only monitor this failure once because there tends to be a lot of the
	        // same error.
	        loggedTypeFailures[error.message] = true;
	
	        var addendum = getDeclarationErrorAddendum(owner);
	         false ? warning(false, 'Failed form propType: %s%s', error.message, addendum) : void 0;
	      }
	    }
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current value of the input either from value prop or link.
	   */
	  getValue: function (inputProps) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.value;
	    }
	    return inputProps.value;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @return {*} current checked status of the input either from checked prop
	   *             or link.
	   */
	  getChecked: function (inputProps) {
	    if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.value;
	    }
	    return inputProps.checked;
	  },
	
	  /**
	   * @param {object} inputProps Props for form component
	   * @param {SyntheticEvent} event change event to handle
	   */
	  executeOnChange: function (inputProps, event) {
	    if (inputProps.valueLink) {
	      _assertValueLink(inputProps);
	      return inputProps.valueLink.requestChange(event.target.value);
	    } else if (inputProps.checkedLink) {
	      _assertCheckedLink(inputProps);
	      return inputProps.checkedLink.requestChange(event.target.checked);
	    } else if (inputProps.onChange) {
	      return inputProps.onChange.call(undefined, event);
	    }
	  }
	};
	
	module.exports = LinkedValueUtils;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(13);
	
	var injected = false;
	
	var ReactComponentEnvironment = {
	  /**
	   * Optionally injectable hook for swapping out mount images in the middle of
	   * the tree.
	   */
	  replaceNodeWithMarkup: null,
	
	  /**
	   * Optionally injectable hook for processing a queue of child updates. Will
	   * later move into MultiChildComponents.
	   */
	  processChildrenUpdates: null,
	
	  injection: {
	    injectEnvironment: function (environment) {
	      !!injected ?  false ? invariant(false, 'ReactCompositeComponent: injectEnvironment() can only be called once.') : _prodInvariant('104') : void 0;
	      ReactComponentEnvironment.replaceNodeWithMarkup = environment.replaceNodeWithMarkup;
	      ReactComponentEnvironment.processChildrenUpdates = environment.processChildrenUpdates;
	      injected = true;
	    }
	  }
	};
	
	module.exports = ReactComponentEnvironment;

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var caughtError = null;
	
	/**
	 * Call a function while guarding against errors that happens within it.
	 *
	 * @param {String} name of the guard to use for logging or debugging
	 * @param {Function} func The function to invoke
	 * @param {*} a First argument
	 * @param {*} b Second argument
	 */
	function invokeGuardedCallback(name, func, a) {
	  try {
	    func(a);
	  } catch (x) {
	    if (caughtError === null) {
	      caughtError = x;
	    }
	  }
	}
	
	var ReactErrorUtils = {
	  invokeGuardedCallback: invokeGuardedCallback,
	
	  /**
	   * Invoked by ReactTestUtils.Simulate so that any errors thrown by the event
	   * handler are sure to be rethrown by rethrowCaughtError.
	   */
	  invokeGuardedCallbackWithCatch: invokeGuardedCallback,
	
	  /**
	   * During execution of guarded functions we will capture the first error which
	   * we will rethrow to be handled by the top level error handler.
	   */
	  rethrowCaughtError: function () {
	    if (caughtError) {
	      var error = caughtError;
	      caughtError = null;
	      throw error;
	    }
	  }
	};
	
	if (false) {
	  /**
	   * To help development we can get better devtools integration by simulating a
	   * real browser event.
	   */
	  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function' && typeof document !== 'undefined' && typeof document.createEvent === 'function') {
	    var fakeNode = document.createElement('react');
	    ReactErrorUtils.invokeGuardedCallback = function (name, func, a) {
	      var boundFunc = function () {
	        func(a);
	      };
	      var evtType = 'react-' + name;
	      fakeNode.addEventListener(evtType, boundFunc, false);
	      var evt = document.createEvent('Event');
	      evt.initEvent(evtType, false, false);
	      fakeNode.dispatchEvent(evt);
	      fakeNode.removeEventListener(evtType, boundFunc, false);
	    };
	  }
	}
	
	module.exports = ReactErrorUtils;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactCurrentOwner = __webpack_require__(45);
	var ReactInstanceMap = __webpack_require__(119);
	var ReactInstrumentation = __webpack_require__(36);
	var ReactUpdates = __webpack_require__(42);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(16);
	
	function enqueueUpdate(internalInstance) {
	  ReactUpdates.enqueueUpdate(internalInstance);
	}
	
	function formatUnexpectedArgument(arg) {
	  var type = typeof arg;
	  if (type !== 'object') {
	    return type;
	  }
	  var displayName = arg.constructor && arg.constructor.name || type;
	  var keys = Object.keys(arg);
	  if (keys.length > 0 && keys.length < 20) {
	    return displayName + ' (keys: ' + keys.join(', ') + ')';
	  }
	  return displayName;
	}
	
	function getInternalInstanceReadyForUpdate(publicInstance, callerName) {
	  var internalInstance = ReactInstanceMap.get(publicInstance);
	  if (!internalInstance) {
	    if (false) {
	      var ctor = publicInstance.constructor;
	      // Only warn when we have a callerName. Otherwise we should be silent.
	      // We're probably calling from enqueueCallback. We don't want to warn
	      // there because we already warned for the corresponding lifecycle method.
	      process.env.NODE_ENV !== 'production' ? warning(!callerName, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, ctor && (ctor.displayName || ctor.name) || 'ReactClass') : void 0;
	    }
	    return null;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(ReactCurrentOwner.current == null, '%s(...): Cannot update during an existing state transition (such as ' + "within `render` or another component's constructor). Render methods " + 'should be a pure function of props and state; constructor ' + 'side-effects are an anti-pattern, but can be moved to ' + '`componentWillMount`.', callerName) : void 0;
	  }
	
	  return internalInstance;
	}
	
	/**
	 * ReactUpdateQueue allows for state updates to be scheduled into a later
	 * reconciliation step.
	 */
	var ReactUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    if (false) {
	      var owner = ReactCurrentOwner.current;
	      if (owner !== null) {
	        process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing isMounted inside its render() function. ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	        owner._warnedAboutRefsInRender = true;
	      }
	    }
	    var internalInstance = ReactInstanceMap.get(publicInstance);
	    if (internalInstance) {
	      // During componentWillMount and render this will still be null but after
	      // that will always render to something. At least for now. So we can use
	      // this hack.
	      return !!internalInstance._renderedComponent;
	    } else {
	      return false;
	    }
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @param {string} callerName Name of the calling function in the public API.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback, callerName) {
	    ReactUpdateQueue.validateCallback(callback, callerName);
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance);
	
	    // Previously we would throw an error if we didn't have an internal
	    // instance. Since we want to make it a no-op instead, we mirror the same
	    // behavior we have in other enqueue* methods.
	    // We also need to ignore callbacks in componentWillMount. See
	    // enqueueUpdates.
	    if (!internalInstance) {
	      return null;
	    }
	
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    // TODO: The callback here is ignored when setState is called from
	    // componentWillMount. Either fix it or disallow doing so completely in
	    // favor of getInitialState. Alternatively, we can disallow
	    // componentWillMount during server-side rendering.
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueCallbackInternal: function (internalInstance, callback) {
	    if (internalInstance._pendingCallbacks) {
	      internalInstance._pendingCallbacks.push(callback);
	    } else {
	      internalInstance._pendingCallbacks = [callback];
	    }
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'forceUpdate');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingForceUpdate = true;
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState, callback) {
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'replaceState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    internalInstance._pendingStateQueue = [completeState];
	    internalInstance._pendingReplaceState = true;
	
	    // Future-proof 15.5
	    if (callback !== undefined && callback !== null) {
	      ReactUpdateQueue.validateCallback(callback, 'replaceState');
	      if (internalInstance._pendingCallbacks) {
	        internalInstance._pendingCallbacks.push(callback);
	      } else {
	        internalInstance._pendingCallbacks = [callback];
	      }
	    }
	
	    enqueueUpdate(internalInstance);
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    if (false) {
	      ReactInstrumentation.debugTool.onSetState();
	      process.env.NODE_ENV !== 'production' ? warning(partialState != null, 'setState(...): You passed an undefined or null state object; ' + 'instead, use forceUpdate().') : void 0;
	    }
	
	    var internalInstance = getInternalInstanceReadyForUpdate(publicInstance, 'setState');
	
	    if (!internalInstance) {
	      return;
	    }
	
	    var queue = internalInstance._pendingStateQueue || (internalInstance._pendingStateQueue = []);
	    queue.push(partialState);
	
	    enqueueUpdate(internalInstance);
	  },
	
	  enqueueElementInternal: function (internalInstance, nextElement, nextContext) {
	    internalInstance._pendingElement = nextElement;
	    // TODO: introduce _pendingContext instead of setting it directly.
	    internalInstance._context = nextContext;
	    enqueueUpdate(internalInstance);
	  },
	
	  validateCallback: function (callback, callerName) {
	    !(!callback || typeof callback === 'function') ?  false ? invariant(false, '%s(...): Expected the last optional `callback` argument to be a function. Instead received: %s.', callerName, formatUnexpectedArgument(callback)) : _prodInvariant('122', callerName, formatUnexpectedArgument(callback)) : void 0;
	  }
	};
	
	module.exports = ReactUpdateQueue;

/***/ },
/* 233 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ViewportMetrics = {
	  currentScrollLeft: 0,
	
	  currentScrollTop: 0,
	
	  refreshScrollValues: function (scrollPosition) {
	    ViewportMetrics.currentScrollLeft = scrollPosition.x;
	    ViewportMetrics.currentScrollTop = scrollPosition.y;
	  }
	};
	
	module.exports = ViewportMetrics;

/***/ },
/* 234 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals MSApp */
	
	'use strict';
	
	/**
	 * Create a function which has 'unsafe' privileges (required by windows8 apps)
	 */
	
	var createMicrosoftUnsafeLocalFunction = function (func) {
	  if (typeof MSApp !== 'undefined' && MSApp.execUnsafeLocalFunction) {
	    return function (arg0, arg1, arg2, arg3) {
	      MSApp.execUnsafeLocalFunction(function () {
	        return func(arg0, arg1, arg2, arg3);
	      });
	    };
	  } else {
	    return func;
	  }
	};
	
	module.exports = createMicrosoftUnsafeLocalFunction;

/***/ },
/* 235 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * `charCode` represents the actual "character code" and is safe to use with
	 * `String.fromCharCode`. As such, only keys that correspond to printable
	 * characters produce a valid `charCode`, the only exception to this is Enter.
	 * The Tab-key is considered non-printable and does not have a `charCode`,
	 * presumably because it does not produce a tab-character in browsers.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {number} Normalized `charCode` property.
	 */
	
	function getEventCharCode(nativeEvent) {
	  var charCode;
	  var keyCode = nativeEvent.keyCode;
	
	  if ('charCode' in nativeEvent) {
	    charCode = nativeEvent.charCode;
	
	    // FF does not set `charCode` for the Enter-key, check against `keyCode`.
	    if (charCode === 0 && keyCode === 13) {
	      charCode = 13;
	    }
	  } else {
	    // IE8 does not implement `charCode`, but `keyCode` has the correct value.
	    charCode = keyCode;
	  }
	
	  // Some non-printable keys are reported in `charCode`/`keyCode`, discard them.
	  // Must not discard the (non-)printable Enter-key.
	  if (charCode >= 32 || charCode === 13) {
	    return charCode;
	  }
	
	  return 0;
	}
	
	module.exports = getEventCharCode;

/***/ },
/* 236 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Translation from modifier key to the associated property in the event.
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#keys-Modifiers
	 */
	
	var modifierKeyToProp = {
	  Alt: 'altKey',
	  Control: 'ctrlKey',
	  Meta: 'metaKey',
	  Shift: 'shiftKey'
	};
	
	// IE8 does not implement getModifierState so we simply map it to the only
	// modifier keys exposed by the event itself, does not support Lock-keys.
	// Currently, all major browsers except Chrome seems to support Lock-keys.
	function modifierStateGetter(keyArg) {
	  var syntheticEvent = this;
	  var nativeEvent = syntheticEvent.nativeEvent;
	  if (nativeEvent.getModifierState) {
	    return nativeEvent.getModifierState(keyArg);
	  }
	  var keyProp = modifierKeyToProp[keyArg];
	  return keyProp ? !!nativeEvent[keyProp] : false;
	}
	
	function getEventModifierState(nativeEvent) {
	  return modifierStateGetter;
	}
	
	module.exports = getEventModifierState;

/***/ },
/* 237 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Gets the target node from a native browser event by accounting for
	 * inconsistencies in browser DOM APIs.
	 *
	 * @param {object} nativeEvent Native browser event.
	 * @return {DOMEventTarget} Target node.
	 */
	
	function getEventTarget(nativeEvent) {
	  var target = nativeEvent.target || nativeEvent.srcElement || window;
	
	  // Normalize SVG <use> element events #4963
	  if (target.correspondingUseElement) {
	    target = target.correspondingUseElement;
	  }
	
	  // Safari may fire events on text nodes (Node.TEXT_NODE is 3).
	  // @see http://www.quirksmode.org/js/events_properties.html
	  return target.nodeType === 3 ? target.parentNode : target;
	}
	
	module.exports = getEventTarget;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	var useHasFeature;
	if (ExecutionEnvironment.canUseDOM) {
	  useHasFeature = document.implementation && document.implementation.hasFeature &&
	  // always returns true in newer browsers as per the standard.
	  // @see http://dom.spec.whatwg.org/#dom-domimplementation-hasfeature
	  document.implementation.hasFeature('', '') !== true;
	}
	
	/**
	 * Checks if an event is supported in the current execution environment.
	 *
	 * NOTE: This will not work correctly for non-generic events such as `change`,
	 * `reset`, `load`, `error`, and `select`.
	 *
	 * Borrows from Modernizr.
	 *
	 * @param {string} eventNameSuffix Event name, e.g. "click".
	 * @param {?boolean} capture Check if the capture phase is supported.
	 * @return {boolean} True if the event is supported.
	 * @internal
	 * @license Modernizr 3.0.0pre (Custom Build) | MIT
	 */
	function isEventSupported(eventNameSuffix, capture) {
	  if (!ExecutionEnvironment.canUseDOM || capture && !('addEventListener' in document)) {
	    return false;
	  }
	
	  var eventName = 'on' + eventNameSuffix;
	  var isSupported = eventName in document;
	
	  if (!isSupported) {
	    var element = document.createElement('div');
	    element.setAttribute(eventName, 'return;');
	    isSupported = typeof element[eventName] === 'function';
	  }
	
	  if (!isSupported && useHasFeature && eventNameSuffix === 'wheel') {
	    // This is the only way to test support for the `wheel` event in IE9+.
	    isSupported = document.implementation.hasFeature('Events.wheel', '3.0');
	  }
	
	  return isSupported;
	}
	
	module.exports = isEventSupported;

/***/ },
/* 239 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given a `prevElement` and `nextElement`, determines if the existing
	 * instance should be updated as opposed to being destroyed or replaced by a new
	 * instance. Both arguments are elements. This ensures that this logic can
	 * operate on stateless trees without any backing instance.
	 *
	 * @param {?object} prevElement
	 * @param {?object} nextElement
	 * @return {boolean} True if the existing instance should be updated.
	 * @protected
	 */
	
	function shouldUpdateReactComponent(prevElement, nextElement) {
	  var prevEmpty = prevElement === null || prevElement === false;
	  var nextEmpty = nextElement === null || nextElement === false;
	  if (prevEmpty || nextEmpty) {
	    return prevEmpty === nextEmpty;
	  }
	
	  var prevType = typeof prevElement;
	  var nextType = typeof nextElement;
	  if (prevType === 'string' || prevType === 'number') {
	    return nextType === 'string' || nextType === 'number';
	  } else {
	    return nextType === 'object' && prevElement.type === nextElement.type && prevElement.key === nextElement.key;
	  }
	}
	
	module.exports = shouldUpdateReactComponent;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var emptyFunction = __webpack_require__(24);
	var warning = __webpack_require__(16);
	
	var validateDOMNesting = emptyFunction;
	
	if (false) {
	  // This validation code was written based on the HTML5 parsing spec:
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  //
	  // Note: this does not catch all invalid nesting, nor does it try to (as it's
	  // not clear what practical benefit doing so provides); instead, we warn only
	  // for cases where the parser will give a parse tree differing from what React
	  // intended. For example, <b><div></div></b> is invalid but we don't warn
	  // because it still parses correctly; we do warn for other cases like nested
	  // <p> tags where the beginning of the second element implicitly closes the
	  // first, causing a confusing mess.
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#special
	  var specialTags = ['address', 'applet', 'area', 'article', 'aside', 'base', 'basefont', 'bgsound', 'blockquote', 'body', 'br', 'button', 'caption', 'center', 'col', 'colgroup', 'dd', 'details', 'dir', 'div', 'dl', 'dt', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'frame', 'frameset', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'iframe', 'img', 'input', 'isindex', 'li', 'link', 'listing', 'main', 'marquee', 'menu', 'menuitem', 'meta', 'nav', 'noembed', 'noframes', 'noscript', 'object', 'ol', 'p', 'param', 'plaintext', 'pre', 'script', 'section', 'select', 'source', 'style', 'summary', 'table', 'tbody', 'td', 'template', 'textarea', 'tfoot', 'th', 'thead', 'title', 'tr', 'track', 'ul', 'wbr', 'xmp'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-scope
	  var inScopeTags = ['applet', 'caption', 'html', 'table', 'td', 'th', 'marquee', 'object', 'template',
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#html-integration-point
	  // TODO: Distinguish by namespace here -- for <title>, including it here
	  // errs on the side of fewer warnings
	  'foreignObject', 'desc', 'title'];
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#has-an-element-in-button-scope
	  var buttonScopeTags = inScopeTags.concat(['button']);
	
	  // https://html.spec.whatwg.org/multipage/syntax.html#generate-implied-end-tags
	  var impliedEndTags = ['dd', 'dt', 'li', 'option', 'optgroup', 'p', 'rp', 'rt'];
	
	  var emptyAncestorInfo = {
	    current: null,
	
	    formTag: null,
	    aTagInScope: null,
	    buttonTagInScope: null,
	    nobrTagInScope: null,
	    pTagInButtonScope: null,
	
	    listItemTagAutoclosing: null,
	    dlItemTagAutoclosing: null
	  };
	
	  var updatedAncestorInfo = function (oldInfo, tag, instance) {
	    var ancestorInfo = _assign({}, oldInfo || emptyAncestorInfo);
	    var info = { tag: tag, instance: instance };
	
	    if (inScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.aTagInScope = null;
	      ancestorInfo.buttonTagInScope = null;
	      ancestorInfo.nobrTagInScope = null;
	    }
	    if (buttonScopeTags.indexOf(tag) !== -1) {
	      ancestorInfo.pTagInButtonScope = null;
	    }
	
	    // See rules for 'li', 'dd', 'dt' start tags in
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    if (specialTags.indexOf(tag) !== -1 && tag !== 'address' && tag !== 'div' && tag !== 'p') {
	      ancestorInfo.listItemTagAutoclosing = null;
	      ancestorInfo.dlItemTagAutoclosing = null;
	    }
	
	    ancestorInfo.current = info;
	
	    if (tag === 'form') {
	      ancestorInfo.formTag = info;
	    }
	    if (tag === 'a') {
	      ancestorInfo.aTagInScope = info;
	    }
	    if (tag === 'button') {
	      ancestorInfo.buttonTagInScope = info;
	    }
	    if (tag === 'nobr') {
	      ancestorInfo.nobrTagInScope = info;
	    }
	    if (tag === 'p') {
	      ancestorInfo.pTagInButtonScope = info;
	    }
	    if (tag === 'li') {
	      ancestorInfo.listItemTagAutoclosing = info;
	    }
	    if (tag === 'dd' || tag === 'dt') {
	      ancestorInfo.dlItemTagAutoclosing = info;
	    }
	
	    return ancestorInfo;
	  };
	
	  /**
	   * Returns whether
	   */
	  var isTagValidWithParent = function (tag, parentTag) {
	    // First, let's check if we're in an unusual parsing mode...
	    switch (parentTag) {
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inselect
	      case 'select':
	        return tag === 'option' || tag === 'optgroup' || tag === '#text';
	      case 'optgroup':
	        return tag === 'option' || tag === '#text';
	      // Strictly speaking, seeing an <option> doesn't mean we're in a <select>
	      // but
	      case 'option':
	        return tag === '#text';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intd
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incaption
	      // No special behavior since these rules fall back to "in body" mode for
	      // all except special table nodes which cause bad parsing behavior anyway.
	
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intr
	      case 'tr':
	        return tag === 'th' || tag === 'td' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intbody
	      case 'tbody':
	      case 'thead':
	      case 'tfoot':
	        return tag === 'tr' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-incolgroup
	      case 'colgroup':
	        return tag === 'col' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-intable
	      case 'table':
	        return tag === 'caption' || tag === 'colgroup' || tag === 'tbody' || tag === 'tfoot' || tag === 'thead' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inhead
	      case 'head':
	        return tag === 'base' || tag === 'basefont' || tag === 'bgsound' || tag === 'link' || tag === 'meta' || tag === 'title' || tag === 'noscript' || tag === 'noframes' || tag === 'style' || tag === 'script' || tag === 'template';
	      // https://html.spec.whatwg.org/multipage/semantics.html#the-html-element
	      case 'html':
	        return tag === 'head' || tag === 'body';
	      case '#document':
	        return tag === 'html';
	    }
	
	    // Probably in the "in body" parsing mode, so we outlaw only tag combos
	    // where the parsing rules cause implicit opens or closes to be added.
	    // https://html.spec.whatwg.org/multipage/syntax.html#parsing-main-inbody
	    switch (tag) {
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return parentTag !== 'h1' && parentTag !== 'h2' && parentTag !== 'h3' && parentTag !== 'h4' && parentTag !== 'h5' && parentTag !== 'h6';
	
	      case 'rp':
	      case 'rt':
	        return impliedEndTags.indexOf(parentTag) === -1;
	
	      case 'body':
	      case 'caption':
	      case 'col':
	      case 'colgroup':
	      case 'frame':
	      case 'head':
	      case 'html':
	      case 'tbody':
	      case 'td':
	      case 'tfoot':
	      case 'th':
	      case 'thead':
	      case 'tr':
	        // These tags are only valid with a few parents that have special child
	        // parsing rules -- if we're down here, then none of those matched and
	        // so we allow it only if we don't know what the parent is, as all other
	        // cases are invalid.
	        return parentTag == null;
	    }
	
	    return true;
	  };
	
	  /**
	   * Returns whether
	   */
	  var findInvalidAncestorForTag = function (tag, ancestorInfo) {
	    switch (tag) {
	      case 'address':
	      case 'article':
	      case 'aside':
	      case 'blockquote':
	      case 'center':
	      case 'details':
	      case 'dialog':
	      case 'dir':
	      case 'div':
	      case 'dl':
	      case 'fieldset':
	      case 'figcaption':
	      case 'figure':
	      case 'footer':
	      case 'header':
	      case 'hgroup':
	      case 'main':
	      case 'menu':
	      case 'nav':
	      case 'ol':
	      case 'p':
	      case 'section':
	      case 'summary':
	      case 'ul':
	      case 'pre':
	      case 'listing':
	      case 'table':
	      case 'hr':
	      case 'xmp':
	      case 'h1':
	      case 'h2':
	      case 'h3':
	      case 'h4':
	      case 'h5':
	      case 'h6':
	        return ancestorInfo.pTagInButtonScope;
	
	      case 'form':
	        return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
	
	      case 'li':
	        return ancestorInfo.listItemTagAutoclosing;
	
	      case 'dd':
	      case 'dt':
	        return ancestorInfo.dlItemTagAutoclosing;
	
	      case 'button':
	        return ancestorInfo.buttonTagInScope;
	
	      case 'a':
	        // Spec says something about storing a list of markers, but it sounds
	        // equivalent to this check.
	        return ancestorInfo.aTagInScope;
	
	      case 'nobr':
	        return ancestorInfo.nobrTagInScope;
	    }
	
	    return null;
	  };
	
	  /**
	   * Given a ReactCompositeComponent instance, return a list of its recursive
	   * owners, starting at the root and ending with the instance itself.
	   */
	  var findOwnerStack = function (instance) {
	    if (!instance) {
	      return [];
	    }
	
	    var stack = [];
	    do {
	      stack.push(instance);
	    } while (instance = instance._currentElement._owner);
	    stack.reverse();
	    return stack;
	  };
	
	  var didWarn = {};
	
	  validateDOMNesting = function (childTag, childText, childInstance, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	
	    if (childText != null) {
	      process.env.NODE_ENV !== 'production' ? warning(childTag == null, 'validateDOMNesting: when childText is passed, childTag should be null') : void 0;
	      childTag = '#text';
	    }
	
	    var invalidParent = isTagValidWithParent(childTag, parentTag) ? null : parentInfo;
	    var invalidAncestor = invalidParent ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
	    var problematic = invalidParent || invalidAncestor;
	
	    if (problematic) {
	      var ancestorTag = problematic.tag;
	      var ancestorInstance = problematic.instance;
	
	      var childOwner = childInstance && childInstance._currentElement._owner;
	      var ancestorOwner = ancestorInstance && ancestorInstance._currentElement._owner;
	
	      var childOwners = findOwnerStack(childOwner);
	      var ancestorOwners = findOwnerStack(ancestorOwner);
	
	      var minStackLen = Math.min(childOwners.length, ancestorOwners.length);
	      var i;
	
	      var deepestCommon = -1;
	      for (i = 0; i < minStackLen; i++) {
	        if (childOwners[i] === ancestorOwners[i]) {
	          deepestCommon = i;
	        } else {
	          break;
	        }
	      }
	
	      var UNKNOWN = '(unknown)';
	      var childOwnerNames = childOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ancestorOwnerNames = ancestorOwners.slice(deepestCommon + 1).map(function (inst) {
	        return inst.getName() || UNKNOWN;
	      });
	      var ownerInfo = [].concat(
	      // If the parent and child instances have a common owner ancestor, start
	      // with that -- otherwise we just start with the parent's owners.
	      deepestCommon !== -1 ? childOwners[deepestCommon].getName() || UNKNOWN : [], ancestorOwnerNames, ancestorTag,
	      // If we're warning about an invalid (non-parent) ancestry, add '...'
	      invalidAncestor ? ['...'] : [], childOwnerNames, childTag).join(' > ');
	
	      var warnKey = !!invalidParent + '|' + childTag + '|' + ancestorTag + '|' + ownerInfo;
	      if (didWarn[warnKey]) {
	        return;
	      }
	      didWarn[warnKey] = true;
	
	      var tagDisplayName = childTag;
	      var whitespaceInfo = '';
	      if (childTag === '#text') {
	        if (/\S/.test(childText)) {
	          tagDisplayName = 'Text nodes';
	        } else {
	          tagDisplayName = 'Whitespace text nodes';
	          whitespaceInfo = " Make sure you don't have any extra whitespace between tags on " + 'each line of your source code.';
	        }
	      } else {
	        tagDisplayName = '<' + childTag + '>';
	      }
	
	      if (invalidParent) {
	        var info = '';
	        if (ancestorTag === 'table' && childTag === 'tr') {
	          info += ' Add a <tbody> to your code to match the DOM tree generated by ' + 'the browser.';
	        }
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a child of <%s>.%s ' + 'See %s.%s', tagDisplayName, ancestorTag, whitespaceInfo, ownerInfo, info) : void 0;
	      } else {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'validateDOMNesting(...): %s cannot appear as a descendant of ' + '<%s>. See %s.', tagDisplayName, ancestorTag, ownerInfo) : void 0;
	      }
	    }
	  };
	
	  validateDOMNesting.updatedAncestorInfo = updatedAncestorInfo;
	
	  // For testing
	  validateDOMNesting.isTagValidInContext = function (tag, ancestorInfo) {
	    ancestorInfo = ancestorInfo || emptyAncestorInfo;
	    var parentInfo = ancestorInfo.current;
	    var parentTag = parentInfo && parentInfo.tag;
	    return isTagValidWithParent(tag, parentTag) && !findInvalidAncestorForTag(tag, ancestorInfo);
	  };
	}
	
	module.exports = validateDOMNesting;

/***/ },
/* 241 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Router = __webpack_require__(243);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Router2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for putting history on context.
	 */
	var Router = function (_React$Component) {
	  _inherits(Router, _React$Component);
	
	  function Router() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Router);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props.history.location.pathname)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Router.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        history: this.props.history,
	        route: {
	          location: this.props.history.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Router.prototype.computeMatch = function computeMatch(pathname) {
	    return {
	      path: '/',
	      url: '/',
	      params: {},
	      isExact: pathname === '/'
	    };
	  };
	
	  Router.prototype.componentWillMount = function componentWillMount() {
	    var _this2 = this;
	
	    var _props = this.props,
	        children = _props.children,
	        history = _props.history;
	
	
	    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, 'A <Router> may have only one child element');
	
	    // Do this here so we can setState when a <Redirect> changes the
	    // location in componentWillMount. This happens e.g. when doing
	    // server rendering using a <StaticRouter>.
	    this.unlisten = history.listen(function () {
	      _this2.setState({
	        match: _this2.computeMatch(history.location.pathname)
	      });
	    });
	  };
	
	  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(this.props.history === nextProps.history, 'You cannot change <Router history>');
	  };
	
	  Router.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.unlisten();
	  };
	
	  Router.prototype.render = function render() {
	    var children = this.props.children;
	
	    return children ? _react2.default.Children.only(children) : null;
	  };
	
	  return Router;
	}(_react2.default.Component);
	
	Router.propTypes = {
	  history: _propTypes2.default.object.isRequired,
	  children: _propTypes2.default.node
	};
	Router.contextTypes = {
	  router: _propTypes2.default.object
	};
	Router.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Router;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _pathToRegexp = __webpack_require__(1945);
	
	var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var patternCache = {};
	var cacheLimit = 10000;
	var cacheCount = 0;
	
	var compilePath = function compilePath(pattern, options) {
	  var cacheKey = '' + options.end + options.strict + options.sensitive;
	  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});
	
	  if (cache[pattern]) return cache[pattern];
	
	  var keys = [];
	  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
	  var compiledPattern = { re: re, keys: keys };
	
	  if (cacheCount < cacheLimit) {
	    cache[pattern] = compiledPattern;
	    cacheCount++;
	  }
	
	  return compiledPattern;
	};
	
	/**
	 * Public API for matching a URL pathname to a path pattern.
	 */
	var matchPath = function matchPath(pathname) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  if (typeof options === 'string') options = { path: options };
	
	  var _options = options,
	      _options$path = _options.path,
	      path = _options$path === undefined ? '/' : _options$path,
	      _options$exact = _options.exact,
	      exact = _options$exact === undefined ? false : _options$exact,
	      _options$strict = _options.strict,
	      strict = _options$strict === undefined ? false : _options$strict,
	      _options$sensitive = _options.sensitive,
	      sensitive = _options$sensitive === undefined ? false : _options$sensitive;
	
	  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
	      re = _compilePath.re,
	      keys = _compilePath.keys;
	
	  var match = re.exec(pathname);
	
	  if (!match) return null;
	
	  var url = match[0],
	      values = match.slice(1);
	
	  var isExact = pathname === url;
	
	  if (exact && !isExact) return null;
	
	  return {
	    path: path, // the path pattern used to match
	    url: path === '/' && url === '' ? '/' : url, // the matched portion of the URL
	    isExact: isExact, // whether or not we matched exactly
	    params: keys.reduce(function (memo, key, index) {
	      memo[key.name] = values[index];
	      return memo;
	    }, {})
	  };
	};
	
	exports.default = matchPath;

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process, setImmediate, global) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// A bit simpler than readable streams.
	// Implement an async ._write(chunk, encoding, cb), and it'll handle all
	// the drain event emission and buffering.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(153);
	/*</replacement>*/
	
	module.exports = Writable;
	
	/* <replacement> */
	function WriteReq(chunk, encoding, cb) {
	  this.chunk = chunk;
	  this.encoding = encoding;
	  this.callback = cb;
	  this.next = null;
	}
	
	// It seems a linked list but it is not
	// there will be only 2 of these for each stream
	function CorkedRequest(state) {
	  var _this = this;
	
	  this.next = null;
	  this.entry = null;
	  this.finish = function () {
	    onCorkedFinish(_this, state);
	  };
	}
	/* </replacement> */
	
	/*<replacement>*/
	var asyncWrite = !process.browser && ['v0.10', 'v0.9.'].indexOf(process.version.slice(0, 5)) > -1 ? setImmediate : processNextTick;
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Writable.WritableState = WritableState;
	
	/*<replacement>*/
	var util = __webpack_require__(103);
	util.inherits = __webpack_require__(38);
	/*</replacement>*/
	
	/*<replacement>*/
	var internalUtil = {
	  deprecate: __webpack_require__(2030)
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(431);
	/*</replacement>*/
	
	/*<replacement>*/
	var Buffer = __webpack_require__(160).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/
	
	var destroyImpl = __webpack_require__(430);
	
	util.inherits(Writable, Stream);
	
	function nop() {}
	
	function WritableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(67);
	
	  options = options || {};
	
	  // object stream flag to indicate whether or not this stream
	  // contains buffers or objects.
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
	
	  // the point at which write() starts returning false
	  // Note: 0 is a valid value, means that we always return false if
	  // the entire buffer is not flushed immediately on write()
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // if _final has been called
	  this.finalCalled = false;
	
	  // drain event flag.
	  this.needDrain = false;
	  // at the start of calling end()
	  this.ending = false;
	  // when end() has been called, and returned
	  this.ended = false;
	  // when 'finish' is emitted
	  this.finished = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // should we decode strings into buffers before passing to _write?
	  // this is here so that some node-core streams can optimize string
	  // handling at a lower level.
	  var noDecode = options.decodeStrings === false;
	  this.decodeStrings = !noDecode;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // not an actual buffer we keep track of, but a measurement
	  // of how much we're waiting to get pushed to some underlying
	  // socket or file.
	  this.length = 0;
	
	  // a flag to see when we're in the middle of a write.
	  this.writing = false;
	
	  // when true all writes will be buffered until .uncork() call
	  this.corked = 0;
	
	  // a flag to be able to tell if the onwrite cb is called immediately,
	  // or on a later tick.  We set this to true at first, because any
	  // actions that shouldn't happen until "later" should generally also
	  // not happen before the first write call.
	  this.sync = true;
	
	  // a flag to know if we're processing previously buffered items, which
	  // may call the _write() callback in the same tick, so that we don't
	  // end up in an overlapped onwrite situation.
	  this.bufferProcessing = false;
	
	  // the callback that's passed to _write(chunk,cb)
	  this.onwrite = function (er) {
	    onwrite(stream, er);
	  };
	
	  // the callback that the user supplies to write(chunk,encoding,cb)
	  this.writecb = null;
	
	  // the amount that is being written when _write is called.
	  this.writelen = 0;
	
	  this.bufferedRequest = null;
	  this.lastBufferedRequest = null;
	
	  // number of pending user-supplied write callbacks
	  // this must be 0 before 'finish' can be emitted
	  this.pendingcb = 0;
	
	  // emit prefinish if the only thing we're waiting for is _write cbs
	  // This is relevant for synchronous Transform streams
	  this.prefinished = false;
	
	  // True if the error was already emitted and should not be thrown again
	  this.errorEmitted = false;
	
	  // count buffered requests
	  this.bufferedRequestCount = 0;
	
	  // allocate the first CorkedRequest, there is always
	  // one allocated and free to use, and we maintain at most two
	  this.corkedRequestsFree = new CorkedRequest(this);
	}
	
	WritableState.prototype.getBuffer = function getBuffer() {
	  var current = this.bufferedRequest;
	  var out = [];
	  while (current) {
	    out.push(current);
	    current = current.next;
	  }
	  return out;
	};
	
	(function () {
	  try {
	    Object.defineProperty(WritableState.prototype, 'buffer', {
	      get: internalUtil.deprecate(function () {
	        return this.getBuffer();
	      }, '_writableState.buffer is deprecated. Use _writableState.getBuffer ' + 'instead.', 'DEP0003')
	    });
	  } catch (_) {}
	})();
	
	// Test _writableState for inheritance to account for Duplex streams,
	// whose prototype chain only points to Readable.
	var realHasInstance;
	if (typeof Symbol === 'function' && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === 'function') {
	  realHasInstance = Function.prototype[Symbol.hasInstance];
	  Object.defineProperty(Writable, Symbol.hasInstance, {
	    value: function (object) {
	      if (realHasInstance.call(this, object)) return true;
	
	      return object && object._writableState instanceof WritableState;
	    }
	  });
	} else {
	  realHasInstance = function (object) {
	    return object instanceof this;
	  };
	}
	
	function Writable(options) {
	  Duplex = Duplex || __webpack_require__(67);
	
	  // Writable ctor is applied to Duplexes, too.
	  // `realHasInstance` is necessary because using plain `instanceof`
	  // would return false, as no `_writableState` property is attached.
	
	  // Trying to use the custom `instanceof` for Writable here will also break the
	  // Node.js LazyTransform implementation, which has a non-trivial getter for
	  // `_writableState` that would lead to infinite recursion.
	  if (!realHasInstance.call(Writable, this) && !(this instanceof Duplex)) {
	    return new Writable(options);
	  }
	
	  this._writableState = new WritableState(options, this);
	
	  // legacy.
	  this.writable = true;
	
	  if (options) {
	    if (typeof options.write === 'function') this._write = options.write;
	
	    if (typeof options.writev === 'function') this._writev = options.writev;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	
	    if (typeof options.final === 'function') this._final = options.final;
	  }
	
	  Stream.call(this);
	}
	
	// Otherwise people can pipe Writable streams, which is just wrong.
	Writable.prototype.pipe = function () {
	  this.emit('error', new Error('Cannot pipe, not readable'));
	};
	
	function writeAfterEnd(stream, cb) {
	  var er = new Error('write after end');
	  // TODO: defer error events consistently everywhere, not just the cb
	  stream.emit('error', er);
	  processNextTick(cb, er);
	}
	
	// Checks that a user-supplied chunk is valid, especially for the particular
	// mode the stream is in. Currently this means that `null` is never accepted
	// and undefined/non-string values are only allowed in object mode.
	function validChunk(stream, state, chunk, cb) {
	  var valid = true;
	  var er = false;
	
	  if (chunk === null) {
	    er = new TypeError('May not write null values to stream');
	  } else if (typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  if (er) {
	    stream.emit('error', er);
	    processNextTick(cb, er);
	    valid = false;
	  }
	  return valid;
	}
	
	Writable.prototype.write = function (chunk, encoding, cb) {
	  var state = this._writableState;
	  var ret = false;
	  var isBuf = _isUint8Array(chunk) && !state.objectMode;
	
	  if (isBuf && !Buffer.isBuffer(chunk)) {
	    chunk = _uint8ArrayToBuffer(chunk);
	  }
	
	  if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (isBuf) encoding = 'buffer';else if (!encoding) encoding = state.defaultEncoding;
	
	  if (typeof cb !== 'function') cb = nop;
	
	  if (state.ended) writeAfterEnd(this, cb);else if (isBuf || validChunk(this, state, chunk, cb)) {
	    state.pendingcb++;
	    ret = writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
	  }
	
	  return ret;
	};
	
	Writable.prototype.cork = function () {
	  var state = this._writableState;
	
	  state.corked++;
	};
	
	Writable.prototype.uncork = function () {
	  var state = this._writableState;
	
	  if (state.corked) {
	    state.corked--;
	
	    if (!state.writing && !state.corked && !state.finished && !state.bufferProcessing && state.bufferedRequest) clearBuffer(this, state);
	  }
	};
	
	Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
	  // node::ParseEncoding() requires lower case.
	  if (typeof encoding === 'string') encoding = encoding.toLowerCase();
	  if (!(['hex', 'utf8', 'utf-8', 'ascii', 'binary', 'base64', 'ucs2', 'ucs-2', 'utf16le', 'utf-16le', 'raw'].indexOf((encoding + '').toLowerCase()) > -1)) throw new TypeError('Unknown encoding: ' + encoding);
	  this._writableState.defaultEncoding = encoding;
	  return this;
	};
	
	function decodeChunk(state, chunk, encoding) {
	  if (!state.objectMode && state.decodeStrings !== false && typeof chunk === 'string') {
	    chunk = Buffer.from(chunk, encoding);
	  }
	  return chunk;
	}
	
	// if we're already writing something, then just put this
	// in the queue, and wait our turn.  Otherwise, call _write
	// If we return false, then we need a drain event, so set that flag.
	function writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
	  if (!isBuf) {
	    var newChunk = decodeChunk(state, chunk, encoding);
	    if (chunk !== newChunk) {
	      isBuf = true;
	      encoding = 'buffer';
	      chunk = newChunk;
	    }
	  }
	  var len = state.objectMode ? 1 : chunk.length;
	
	  state.length += len;
	
	  var ret = state.length < state.highWaterMark;
	  // we must ensure that previous needDrain will not be reset to false.
	  if (!ret) state.needDrain = true;
	
	  if (state.writing || state.corked) {
	    var last = state.lastBufferedRequest;
	    state.lastBufferedRequest = {
	      chunk: chunk,
	      encoding: encoding,
	      isBuf: isBuf,
	      callback: cb,
	      next: null
	    };
	    if (last) {
	      last.next = state.lastBufferedRequest;
	    } else {
	      state.bufferedRequest = state.lastBufferedRequest;
	    }
	    state.bufferedRequestCount += 1;
	  } else {
	    doWrite(stream, state, false, len, chunk, encoding, cb);
	  }
	
	  return ret;
	}
	
	function doWrite(stream, state, writev, len, chunk, encoding, cb) {
	  state.writelen = len;
	  state.writecb = cb;
	  state.writing = true;
	  state.sync = true;
	  if (writev) stream._writev(chunk, state.onwrite);else stream._write(chunk, encoding, state.onwrite);
	  state.sync = false;
	}
	
	function onwriteError(stream, state, sync, er, cb) {
	  --state.pendingcb;
	
	  if (sync) {
	    // defer the callback if we are being called synchronously
	    // to avoid piling up things on the stack
	    processNextTick(cb, er);
	    // this can emit finish, and it will always happen
	    // after error
	    processNextTick(finishMaybe, stream, state);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	  } else {
	    // the caller expect this to happen before if
	    // it is async
	    cb(er);
	    stream._writableState.errorEmitted = true;
	    stream.emit('error', er);
	    // this can emit finish, but finish must
	    // always follow error
	    finishMaybe(stream, state);
	  }
	}
	
	function onwriteStateUpdate(state) {
	  state.writing = false;
	  state.writecb = null;
	  state.length -= state.writelen;
	  state.writelen = 0;
	}
	
	function onwrite(stream, er) {
	  var state = stream._writableState;
	  var sync = state.sync;
	  var cb = state.writecb;
	
	  onwriteStateUpdate(state);
	
	  if (er) onwriteError(stream, state, sync, er, cb);else {
	    // Check if we're actually ready to finish, but don't emit yet
	    var finished = needFinish(state);
	
	    if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) {
	      clearBuffer(stream, state);
	    }
	
	    if (sync) {
	      /*<replacement>*/
	      asyncWrite(afterWrite, stream, state, finished, cb);
	      /*</replacement>*/
	    } else {
	      afterWrite(stream, state, finished, cb);
	    }
	  }
	}
	
	function afterWrite(stream, state, finished, cb) {
	  if (!finished) onwriteDrain(stream, state);
	  state.pendingcb--;
	  cb();
	  finishMaybe(stream, state);
	}
	
	// Must force callback to be called on nextTick, so that we don't
	// emit 'drain' before the write() consumer gets the 'false' return
	// value, and has a chance to attach a 'drain' listener.
	function onwriteDrain(stream, state) {
	  if (state.length === 0 && state.needDrain) {
	    state.needDrain = false;
	    stream.emit('drain');
	  }
	}
	
	// if there's something in the buffer waiting, then process it
	function clearBuffer(stream, state) {
	  state.bufferProcessing = true;
	  var entry = state.bufferedRequest;
	
	  if (stream._writev && entry && entry.next) {
	    // Fast case, write everything using _writev()
	    var l = state.bufferedRequestCount;
	    var buffer = new Array(l);
	    var holder = state.corkedRequestsFree;
	    holder.entry = entry;
	
	    var count = 0;
	    var allBuffers = true;
	    while (entry) {
	      buffer[count] = entry;
	      if (!entry.isBuf) allBuffers = false;
	      entry = entry.next;
	      count += 1;
	    }
	    buffer.allBuffers = allBuffers;
	
	    doWrite(stream, state, true, state.length, buffer, '', holder.finish);
	
	    // doWrite is almost always async, defer these to save a bit of time
	    // as the hot path ends with doWrite
	    state.pendingcb++;
	    state.lastBufferedRequest = null;
	    if (holder.next) {
	      state.corkedRequestsFree = holder.next;
	      holder.next = null;
	    } else {
	      state.corkedRequestsFree = new CorkedRequest(state);
	    }
	  } else {
	    // Slow case, write chunks one-by-one
	    while (entry) {
	      var chunk = entry.chunk;
	      var encoding = entry.encoding;
	      var cb = entry.callback;
	      var len = state.objectMode ? 1 : chunk.length;
	
	      doWrite(stream, state, false, len, chunk, encoding, cb);
	      entry = entry.next;
	      // if we didn't call the onwrite immediately, then
	      // it means that we need to wait until it does.
	      // also, that means that the chunk and cb are currently
	      // being processed, so move the buffer counter past them.
	      if (state.writing) {
	        break;
	      }
	    }
	
	    if (entry === null) state.lastBufferedRequest = null;
	  }
	
	  state.bufferedRequestCount = 0;
	  state.bufferedRequest = entry;
	  state.bufferProcessing = false;
	}
	
	Writable.prototype._write = function (chunk, encoding, cb) {
	  cb(new Error('_write() is not implemented'));
	};
	
	Writable.prototype._writev = null;
	
	Writable.prototype.end = function (chunk, encoding, cb) {
	  var state = this._writableState;
	
	  if (typeof chunk === 'function') {
	    cb = chunk;
	    chunk = null;
	    encoding = null;
	  } else if (typeof encoding === 'function') {
	    cb = encoding;
	    encoding = null;
	  }
	
	  if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
	
	  // .end() fully uncorks
	  if (state.corked) {
	    state.corked = 1;
	    this.uncork();
	  }
	
	  // ignore unnecessary end() calls.
	  if (!state.ending && !state.finished) endWritable(this, state, cb);
	};
	
	function needFinish(state) {
	  return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
	}
	function callFinal(stream, state) {
	  stream._final(function (err) {
	    state.pendingcb--;
	    if (err) {
	      stream.emit('error', err);
	    }
	    state.prefinished = true;
	    stream.emit('prefinish');
	    finishMaybe(stream, state);
	  });
	}
	function prefinish(stream, state) {
	  if (!state.prefinished && !state.finalCalled) {
	    if (typeof stream._final === 'function') {
	      state.pendingcb++;
	      state.finalCalled = true;
	      processNextTick(callFinal, stream, state);
	    } else {
	      state.prefinished = true;
	      stream.emit('prefinish');
	    }
	  }
	}
	
	function finishMaybe(stream, state) {
	  var need = needFinish(state);
	  if (need) {
	    prefinish(stream, state);
	    if (state.pendingcb === 0) {
	      state.finished = true;
	      stream.emit('finish');
	    }
	  }
	  return need;
	}
	
	function endWritable(stream, state, cb) {
	  state.ending = true;
	  finishMaybe(stream, state);
	  if (cb) {
	    if (state.finished) processNextTick(cb);else stream.once('finish', cb);
	  }
	  state.ended = true;
	  stream.writable = false;
	}
	
	function onCorkedFinish(corkReq, state, err) {
	  var entry = corkReq.entry;
	  corkReq.entry = null;
	  while (entry) {
	    var cb = entry.callback;
	    state.pendingcb--;
	    cb(err);
	    entry = entry.next;
	  }
	  if (state.corkedRequestsFree) {
	    state.corkedRequestsFree.next = corkReq;
	  } else {
	    state.corkedRequestsFree = corkReq;
	  }
	}
	
	Object.defineProperty(Writable.prototype, 'destroyed', {
	  get: function () {
	    if (this._writableState === undefined) {
	      return false;
	    }
	    return this._writableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._writableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._writableState.destroyed = value;
	  }
	});
	
	Writable.prototype.destroy = destroyImpl.destroy;
	Writable.prototype._undestroy = destroyImpl.undestroy;
	Writable.prototype._destroy = function (err, cb) {
	  this.end();
	  cb(err);
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65), __webpack_require__(441).setImmediate, (function() { return this; }())))

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	exports = module.exports = __webpack_require__(428);
	exports.Stream = exports;
	exports.Readable = exports;
	exports.Writable = __webpack_require__(245);
	exports.Duplex = __webpack_require__(67);
	exports.Transform = __webpack_require__(429);
	exports.PassThrough = __webpack_require__(1970);


/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Buffer = __webpack_require__(160).Buffer;
	
	var isEncoding = Buffer.isEncoding || function (encoding) {
	  encoding = '' + encoding;
	  switch (encoding && encoding.toLowerCase()) {
	    case 'hex':case 'utf8':case 'utf-8':case 'ascii':case 'binary':case 'base64':case 'ucs2':case 'ucs-2':case 'utf16le':case 'utf-16le':case 'raw':
	      return true;
	    default:
	      return false;
	  }
	};
	
	function _normalizeEncoding(enc) {
	  if (!enc) return 'utf8';
	  var retried;
	  while (true) {
	    switch (enc) {
	      case 'utf8':
	      case 'utf-8':
	        return 'utf8';
	      case 'ucs2':
	      case 'ucs-2':
	      case 'utf16le':
	      case 'utf-16le':
	        return 'utf16le';
	      case 'latin1':
	      case 'binary':
	        return 'latin1';
	      case 'base64':
	      case 'ascii':
	      case 'hex':
	        return enc;
	      default:
	        if (retried) return; // undefined
	        enc = ('' + enc).toLowerCase();
	        retried = true;
	    }
	  }
	};
	
	// Do not cache `Buffer.isEncoding` when checking encoding names as some
	// modules monkey-patch it to support additional encodings
	function normalizeEncoding(enc) {
	  var nenc = _normalizeEncoding(enc);
	  if (typeof nenc !== 'string' && (Buffer.isEncoding === isEncoding || !isEncoding(enc))) throw new Error('Unknown encoding: ' + enc);
	  return nenc || enc;
	}
	
	// StringDecoder provides an interface for efficiently splitting a series of
	// buffers into a series of JS strings without breaking apart multi-byte
	// characters.
	exports.StringDecoder = StringDecoder;
	function StringDecoder(encoding) {
	  this.encoding = normalizeEncoding(encoding);
	  var nb;
	  switch (this.encoding) {
	    case 'utf16le':
	      this.text = utf16Text;
	      this.end = utf16End;
	      nb = 4;
	      break;
	    case 'utf8':
	      this.fillLast = utf8FillLast;
	      nb = 4;
	      break;
	    case 'base64':
	      this.text = base64Text;
	      this.end = base64End;
	      nb = 3;
	      break;
	    default:
	      this.write = simpleWrite;
	      this.end = simpleEnd;
	      return;
	  }
	  this.lastNeed = 0;
	  this.lastTotal = 0;
	  this.lastChar = Buffer.allocUnsafe(nb);
	}
	
	StringDecoder.prototype.write = function (buf) {
	  if (buf.length === 0) return '';
	  var r;
	  var i;
	  if (this.lastNeed) {
	    r = this.fillLast(buf);
	    if (r === undefined) return '';
	    i = this.lastNeed;
	    this.lastNeed = 0;
	  } else {
	    i = 0;
	  }
	  if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
	  return r || '';
	};
	
	StringDecoder.prototype.end = utf8End;
	
	// Returns only complete characters in a Buffer
	StringDecoder.prototype.text = utf8Text;
	
	// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
	StringDecoder.prototype.fillLast = function (buf) {
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
	  this.lastNeed -= buf.length;
	};
	
	// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
	// continuation byte.
	function utf8CheckByte(byte) {
	  if (byte <= 0x7F) return 0;else if (byte >> 5 === 0x06) return 2;else if (byte >> 4 === 0x0E) return 3;else if (byte >> 3 === 0x1E) return 4;
	  return -1;
	}
	
	// Checks at most 3 bytes at the end of a Buffer in order to detect an
	// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
	// needed to complete the UTF-8 character (if applicable) are returned.
	function utf8CheckIncomplete(self, buf, i) {
	  var j = buf.length - 1;
	  if (j < i) return 0;
	  var nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 1;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) self.lastNeed = nb - 2;
	    return nb;
	  }
	  if (--j < i) return 0;
	  nb = utf8CheckByte(buf[j]);
	  if (nb >= 0) {
	    if (nb > 0) {
	      if (nb === 2) nb = 0;else self.lastNeed = nb - 3;
	    }
	    return nb;
	  }
	  return 0;
	}
	
	// Validates as many continuation bytes for a multi-byte UTF-8 character as
	// needed or are available. If we see a non-continuation byte where we expect
	// one, we "replace" the validated continuation bytes we've seen so far with
	// UTF-8 replacement characters ('\ufffd'), to match v8's UTF-8 decoding
	// behavior. The continuation byte check is included three times in the case
	// where all of the continuation bytes for a character exist in the same buffer.
	// It is also done this way as a slight performance increase instead of using a
	// loop.
	function utf8CheckExtraBytes(self, buf, p) {
	  if ((buf[0] & 0xC0) !== 0x80) {
	    self.lastNeed = 0;
	    return '\ufffd'.repeat(p);
	  }
	  if (self.lastNeed > 1 && buf.length > 1) {
	    if ((buf[1] & 0xC0) !== 0x80) {
	      self.lastNeed = 1;
	      return '\ufffd'.repeat(p + 1);
	    }
	    if (self.lastNeed > 2 && buf.length > 2) {
	      if ((buf[2] & 0xC0) !== 0x80) {
	        self.lastNeed = 2;
	        return '\ufffd'.repeat(p + 2);
	      }
	    }
	  }
	}
	
	// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
	function utf8FillLast(buf) {
	  var p = this.lastTotal - this.lastNeed;
	  var r = utf8CheckExtraBytes(this, buf, p);
	  if (r !== undefined) return r;
	  if (this.lastNeed <= buf.length) {
	    buf.copy(this.lastChar, p, 0, this.lastNeed);
	    return this.lastChar.toString(this.encoding, 0, this.lastTotal);
	  }
	  buf.copy(this.lastChar, p, 0, buf.length);
	  this.lastNeed -= buf.length;
	}
	
	// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
	// partial character, the character's bytes are buffered until the required
	// number of bytes are available.
	function utf8Text(buf, i) {
	  var total = utf8CheckIncomplete(this, buf, i);
	  if (!this.lastNeed) return buf.toString('utf8', i);
	  this.lastTotal = total;
	  var end = buf.length - (total - this.lastNeed);
	  buf.copy(this.lastChar, 0, end);
	  return buf.toString('utf8', i, end);
	}
	
	// For UTF-8, a replacement character for each buffered byte of a (partial)
	// character needs to be added to the output.
	function utf8End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + '\ufffd'.repeat(this.lastTotal - this.lastNeed);
	  return r;
	}
	
	// UTF-16LE typically needs two bytes per character, but even if we have an even
	// number of bytes available, we need to check if we end on a leading/high
	// surrogate. In that case, we need to wait for the next two bytes in order to
	// decode the last character properly.
	function utf16Text(buf, i) {
	  if ((buf.length - i) % 2 === 0) {
	    var r = buf.toString('utf16le', i);
	    if (r) {
	      var c = r.charCodeAt(r.length - 1);
	      if (c >= 0xD800 && c <= 0xDBFF) {
	        this.lastNeed = 2;
	        this.lastTotal = 4;
	        this.lastChar[0] = buf[buf.length - 2];
	        this.lastChar[1] = buf[buf.length - 1];
	        return r.slice(0, -1);
	      }
	    }
	    return r;
	  }
	  this.lastNeed = 1;
	  this.lastTotal = 2;
	  this.lastChar[0] = buf[buf.length - 1];
	  return buf.toString('utf16le', i, buf.length - 1);
	}
	
	// For UTF-16LE we do not explicitly append special replacement characters if we
	// end on a partial character, we simply let v8 handle that.
	function utf16End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) {
	    var end = this.lastTotal - this.lastNeed;
	    return r + this.lastChar.toString('utf16le', 0, end);
	  }
	  return r;
	}
	
	function base64Text(buf, i) {
	  var n = (buf.length - i) % 3;
	  if (n === 0) return buf.toString('base64', i);
	  this.lastNeed = 3 - n;
	  this.lastTotal = 3;
	  if (n === 1) {
	    this.lastChar[0] = buf[buf.length - 1];
	  } else {
	    this.lastChar[0] = buf[buf.length - 2];
	    this.lastChar[1] = buf[buf.length - 1];
	  }
	  return buf.toString('base64', i, buf.length - n);
	}
	
	function base64End(buf) {
	  var r = buf && buf.length ? this.write(buf) : '';
	  if (this.lastNeed) return r + this.lastChar.toString('base64', 0, 3 - this.lastNeed);
	  return r;
	}
	
	// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
	function simpleWrite(buf) {
	  return buf.toString(this.encoding);
	}
	
	function simpleEnd(buf) {
	  return buf && buf.length ? this.write(buf) : '';
	}

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(26);
	
	var _index = __webpack_require__(453);
	
	var _ContentContainer = __webpack_require__(248);
	
	var _ContentContainer2 = _interopRequireDefault(_ContentContainer);
	
	var _actions = __webpack_require__(56);
	
	var _selectors = __webpack_require__(55);
	
	var _selectors2 = __webpack_require__(57);
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _dragDropDefinitions = __webpack_require__(250);
	
	var _selectors3 = __webpack_require__(122);
	
	__webpack_require__(567);
	
	var _actions2 = __webpack_require__(54);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 16/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Decides which component should be rendered and passes appropriate props
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Does all necessary calculations, state management, and event management.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Expects own component info to be passed as props - either on creation or by redux
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ContentContainer = function (_Component) {
	  _inherits(ContentContainer, _Component);
	
	  function ContentContainer(props) {
	    _classCallCheck(this, ContentContainer);
	
	    var _this = _possibleConstructorReturn(this, (ContentContainer.__proto__ || Object.getPrototypeOf(ContentContainer)).call(this, props));
	
	    _this.state = Object.assign({}, _this.calculateState(props), {
	      highlight: false
	    });
	
	    _this.handleMouseOver = _this.handleMouseOver.bind(_this);
	    _this.handleMouseOut = _this.handleMouseOut.bind(_this);
	    _this.handleOnClick = _this.handleOnClick.bind(_this);
	    _this.handleDragOver = _this.handleDragOver.bind(_this);
	    _this.handleDrop = _this.handleDrop.bind(_this);
	    _this.handleDragStart = _this.handleDragStart.bind(_this);
	    _this.handleDragEnd = _this.handleDragEnd.bind(_this);
	    _this.handleUpdate = _this.handleUpdate.bind(_this);
	    _this.handleUpdateContentFrame = _this.handleUpdateContentFrame.bind(_this);
	    _this.componentWillReceiveProps = _this.componentWillReceiveProps.bind(_this);
	    _this.calculateState = _this.calculateState.bind(_this);
	    return _this;
	  }
	
	  _createClass(ContentContainer, [{
	    key: "handleMouseOver",
	    value: function handleMouseOver(e) {
	      e.preventDefault();
	      if (this.props.selectedItem) {
	        e.stopPropagation();
	        return false;
	      }
	      if (this.state.hoverable) {
	        e.stopPropagation();
	        this.setState({ hovered: true });
	      }
	    }
	  }, {
	    key: "handleMouseOut",
	    value: function handleMouseOut(e) {
	      e.preventDefault();
	      //e.stopPropagation();
	      this.setState({ hovered: false });
	    }
	  }, {
	    key: "handleOnClick",
	    value: function handleOnClick(e) {
	      e.preventDefault();
	      if (this.props.selectedItem) {
	        e.stopPropagation();
	        return false;
	      }
	
	      if (this.state.selectable) {
	        e.stopPropagation();
	        this.handleUpdateContentFrame();
	      }
	    }
	  }, {
	    key: "handleDragOver",
	    value: function handleDragOver(e) {
	      // Determine whether we will accept this drag - if yes stop propagation, otherwise let it continue down
	      // Let bubble through if not this one
	
	      if (this.props.selectedItem) {
	        e.stopPropagation();
	        return false;
	      }
	
	      if (this.state.acceptDragSelf || this.state.acceptDragParent) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        // Work out correct drag cursor - either "copy" or "move"
	        if (e.ctrlKey) {
	          e.dataTransfer.dropEffect = "copy";
	        } else {
	          e.dataTransfer.dropEffect = "move";
	        }
	
	        // Work out cursor location on target
	        var thisRect = e.currentTarget.getBoundingClientRect();
	        var editorRect = document.getElementById("canvas-element").getBoundingClientRect();
	        var pointerPosition = {
	          x: (e.clientX - thisRect.left) / (thisRect.right - thisRect.left),
	          y: (e.clientY - thisRect.top) / (thisRect.bottom - thisRect.top)
	        };
	        var loc = {
	          x: pointerPosition.x > 0.5 ? "right" : "left",
	          y: pointerPosition.y > 0.5 ? "bottom" : "top"
	        };
	
	        var highlight = void 0; // all,top, right, bottom, left
	
	        // Cell-type elements need listing here
	        var isCell = this.props.myProps.configPrimitive === _index.TEMPLATE_COMPONENTS.CELL_ITEM.id || this.props.myProps.configPrimitive === _index.TEMPLATE_COMPONENTS.RICH_TEXT.id || this.props.myProps.configPrimitive === _index.TEMPLATE_COMPONENTS.IMAGE_ITEM.id || this.props.myProps.configPrimitive === _index.TEMPLATE_COMPONENTS.TOC_ITEM.id || this.props.myProps.configPrimitive === _index.TEMPLATE_COMPONENTS.COLUMN.id;
	
	        // Is it going to this or the the parent?
	        // Does this element already have children?
	        if (this.state.acceptDragSelf) {
	          if (this.props.childProps.length === 0) {
	            highlight = "all";
	          } else {
	            highlight = isCell ? "right" : "bottom";
	          }
	        } else if (this.state.acceptDragParent) {
	          // need to know where in element to go
	          if (isCell) {
	            // Need to look left / right
	            highlight = loc.x;
	          } else {
	            // Need to look up / down
	            highlight = loc.y;
	          }
	        }
	
	        var highlightMatchState = _.isEqual(this.state.highlight, highlight);
	        if (!highlightMatchState) this.setState({ highlight: highlight });
	
	        var highlightFrame = void 0;
	
	        switch (highlight) {
	          case "all":
	            highlightFrame = {
	              top: thisRect.top - editorRect.top,
	              left: thisRect.left - editorRect.left,
	              width: thisRect.right - thisRect.left,
	              height: thisRect.bottom - thisRect.top
	            };
	            break;
	          case "top":
	            highlightFrame = {
	              top: thisRect.top - editorRect.top - 20,
	              left: thisRect.left - editorRect.left - 20,
	              width: thisRect.right - thisRect.left + 40,
	              height: 40
	            };
	            break;
	          case "right":
	            highlightFrame = {
	              top: thisRect.top - editorRect.top - 20,
	              left: thisRect.right - editorRect.left - 20,
	              width: 40,
	              height: thisRect.bottom - thisRect.top + 40
	            };
	            break;
	          case "bottom":
	            highlightFrame = {
	              top: thisRect.bottom - editorRect.top - 20,
	              left: thisRect.left - editorRect.left - 20,
	              width: thisRect.right - thisRect.left + 40,
	              height: 40
	            };
	            break;
	          case "left":
	            highlightFrame = {
	              top: thisRect.top - editorRect.top - 20,
	              left: thisRect.left - editorRect.left - 20,
	              width: 40,
	              height: thisRect.bottom - thisRect.top + 40
	            };
	            break;
	          default:
	        }
	        highlightFrame.top += 56;
	        var currentFrame = this.props.dropzoneCoords;
	        var matches = _.isEqual(currentFrame, highlightFrame);
	        if (!matches) this.props.dispatch((0, _actions.setUiDropzoneCoords)(highlightFrame));
	      }
	    }
	  }, {
	    key: "handleDrop",
	    value: function handleDrop(e) {
	
	      if (this.props.selectedItem) {
	        e.stopPropagation();
	        return false;
	      }
	      // Handle the drop when it happens, assuming we want it
	      //console.log("dropped");
	      var type = e.dataTransfer.getData(_dragDropDefinitions.DATA_TRANSFER_TYPE.DRAG_TYPE);
	
	      if (this.state.acceptDragSelf) {
	        e.preventDefault();
	        e.stopPropagation();
	
	        // TODO enable duplication with CTRL key
	        // Just append it - simple
	        if (type === _dragDropDefinitions.DRAG_TYPE.MOVING_ITEM) {
	          // Update item parent to this
	          this.props.dispatch((0, _actions2.moveContentItem)(this.props.currentDrag.contentId, this.props.myProps.contentId));
	        } else {
	          // Create new here
	          this.props.dispatch(this.props.createItem(this.props.myProps.contentId, null, this.props.currentDrag.configId));
	        }
	
	        this.props.dispatch((0, _actions.setUiDraggedContentItem)(null));
	        this.props.dispatch((0, _actions.setUiDropzoneCoords)(null));
	      } else if (this.state.acceptDragParent) {
	        e.stopPropagation();
	        e.stopPropagation();
	        if (type === _dragDropDefinitions.DRAG_TYPE.MOVING_ITEM) {
	          // Update item parent to this
	          if (this.state.highlight === "left" || this.state.highlight === "top") {
	            this.props.dispatch((0, _actions2.moveContentItem)(this.props.currentDrag.contentId, this.props.myProps.contentParentId, this.props.myProps.contentId, false));
	          } else if (this.state.highlight === "right" || this.state.highlight === "bottom") {
	            this.props.dispatch((0, _actions2.moveContentItem)(this.props.currentDrag.contentId, this.props.myProps.contentParentId, this.props.myProps.contentId, true));
	          }
	        } else {
	          // Create new here
	          if (this.state.highlight === "left" || this.state.highlight === "top") {
	            this.props.dispatch(this.props.createItem(this.props.myProps.contentParentId, this.props.myProps.contentId, this.props.currentDrag.configId, false));
	          } else if (this.state.highlight === "right" || this.state.highlight === "bottom") {
	            this.props.dispatch(this.props.createItem(this.props.myProps.contentParentId, this.props.myProps.contentId, this.props.currentDrag.configId, true));
	          }
	        }
	
	        this.props.dispatch((0, _actions.setUiDraggedContentItem)(null));
	        this.props.dispatch((0, _actions.setUiDropzoneCoords)(null));
	      }
	
	      //this.props.dispatch(createContentItem(this.props.id, null, e.dataTransfer.getData("editor/itemDefId"), getContentDefinitions(this.props.state)));
	    }
	  }, {
	    key: "handleDragStart",
	    value: function handleDragStart(e) {
	      if (this.props.selectedItem) {
	        e.stopPropagation();
	        e.preventDefault();
	        return false;
	      }
	      if (this.state.draggable) {
	        e.stopPropagation();
	        this.props.dispatch((0, _actions.setUiSelectedContentItem)(null));
	        this.props.dispatch((0, _actions.setUiDraggedContentItem)(this.props.myProps));
	        e.dataTransfer.setData(_dragDropDefinitions.DATA_TRANSFER_TYPE.DRAG_TYPE, _dragDropDefinitions.DRAG_TYPE.MOVING_ITEM);
	      } else {
	        e.preventDefault();
	        return false;
	      }
	    }
	  }, {
	    key: "handleDragEnd",
	    value: function handleDragEnd(e) {
	      if (this.props.selectedItem) {
	        e.stopPropagation();
	        return false;
	      }
	      e.stopPropagation();
	      e.preventDefault();
	    }
	  }, {
	    key: "handleUpdate",
	    value: function handleUpdate(content) {
	      this.props.dispatch((0, _actions2.updateContentItem)(this.props.myProps.contentId, content, this.props.myProps, this.props.getConfig(this.props.myProps.configId)));
	    }
	  }, {
	    key: "handleUpdateContentFrame",
	    value: function handleUpdateContentFrame() {
	      var matches = _.isEqual(this.props.selectedItem, { contentId: this.props.myProps.contentId });
	      if (!matches) {
	        this.props.dispatch((0, _actions.setUiSelectedContentItem)(this.props.myProps.contentId));
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      // Work out current interactivity
	      var newState = this.calculateState(nextProps);
	      var matches = _.isMatch(this.state, newState);
	      if (!matches) this.setState(Object.assign({}, newState));
	    }
	  }, {
	    key: "calculateState",
	    value: function calculateState(props) {
	      var me = props.myProps;
	      var parent = props.parentProps;
	
	      // Work out if selectable
	      var selectable = !props.hiddenAncestor && !me.editorLocked && me.editorSelectable;
	      // Work out if hoverable
	      var needsHover = me.editorSelectable || me.editorDraggable;
	      var hoverable = !props.hiddenAncestor && !me.editorLocked && !props.selectedItem && needsHover;
	      // Work out if already hovered
	      var hovered = props.isHovered;
	      // Work out if draggable
	      var draggable = !props.hiddenAncestor && !me.editorLocked && me.editorDraggable;
	      // Work out if can be a drag target
	      var dragTarget = !props.hiddenAncestor && !me.editorLocked && !me.contentHidden && me.editorDragTarget;
	      var parentDragTarget = parent ? !parent.editorLocked && !parent.contentHidden && parent.editorDragTarget : false;
	
	      // Work out if we accept the current drag object
	      var dragging = false;
	      var acceptDragSelf = false;
	      var acceptDragParent = false;
	
	      if (props.currentDrag) {
	
	        var cd = props.currentDrag;
	        //Is it me?
	        if (cd.contentId === me.contentId) {
	          dragging = true;
	        }
	
	        if (dragTarget) {
	          props.currentDrag.editorAllowedParents.map(function (rule) {
	            acceptDragSelf = acceptDragSelf || _.isMatch(me, rule);
	            return true;
	          });
	        }
	        if (parentDragTarget) {
	          props.currentDrag.editorAllowedParents.map(function (rule) {
	            acceptDragParent = acceptDragParent || _.isMatch(parent, rule);
	            return true;
	          });
	        }
	      }
	
	      return {
	        selectable: selectable,
	        hoverable: hoverable,
	        hovered: hovered,
	        draggable: draggable,
	        dragTarget: dragTarget,
	        parentDragTarget: parentDragTarget,
	        dragging: dragging,
	        acceptDragSelf: acceptDragSelf,
	        acceptDragParent: acceptDragParent
	      };
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      // Build children
	      var itemChildren = this.props.childProps;
	      var children = [];
	      if (itemChildren.length > 0) {
	        children = itemChildren.map(function (item) {
	          return _react2.default.createElement(_ContentContainer2.default, { contentId: item.contentId, key: item.contentId });
	        });
	      }
	
	      // Assign events
	      var eventHandlers = {
	        onClick: this.handleOnClick,
	        onMouseOver: this.handleMouseOver,
	        onMouseOut: this.handleMouseOut,
	        onDragStart: this.handleDragStart,
	        onDragEnd: this.handleDragEnd,
	        onDrop: this.handleDrop,
	        onDragOver: this.handleDragOver
	      };
	
	      // Choose correct style
	      var additionalClasses = [];
	
	      if (this.state.dragging) {
	        additionalClasses.push("editor-dragged");
	      }
	      if (this.state.hovered) {
	        additionalClasses.push("editor-hovered");
	      }
	      if (this.props.myProps.contentHidden) {
	        additionalClasses.push("editor-hidden");
	      }
	
	      var calcProps = Object.assign({}, this.props.myProps, {
	        viewClass: this.props.myProps.viewClass + " " + additionalClasses.join(" "),
	        viewAttributes: Object.assign({}, this.props.myProps.viewAttributes, {
	          draggable: this.state.draggable,
	          id: this.props.myProps.contentId
	        }),
	        children: children,
	        eventHandlers: eventHandlers,
	        updateContent: this.handleUpdate,
	        currentlySelected: this.props.selectedItem && this.props.selectedItem.contentId === this.props.myProps.contentId,
	        updateContentFrame: this.handleUpdateContentFrame
	      });
	
	      // Find the correct constructor
	      if (!calcProps.configPrimitive) return null;
	      var primitives = _index.TEMPLATE_COMPONENTS; // Webpack doesn't import otherwise
	      var component = primitives[calcProps.configPrimitive].component;
	
	      return _react2.default.createElement(component, calcProps);
	    }
	  }]);
	
	  return ContentContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state, ownProps) {
	  // Get own props, child props and parent props
	  var myProps = (0, _selectors.getContentItem)(state, ownProps.contentId);
	  //TODO see if we can trim down how much is requested here - are IDs enough?
	  var childProps = (0, _selectors.getContentItemChildren)(state, ownProps.contentId);
	  var parentProps = (0, _selectors.getContentItem)(state, myProps.contentParentId);
	
	  var isHovered = (0, _selectors2.getUiHoveredItem)(state) === ownProps.contentId;
	  var selectedItem = (0, _selectors2.getUiSelectedItem)(state);
	
	  var getConfig = function getConfig(configId) {
	    return (0, _selectors3.getContentDefinition)(state, configId);
	  };
	  var currentDrag = (0, _selectors2.getUiDraggedItem)(state);
	  var dropzoneCoords = (0, _selectors2.getUiDropzoneCoords)(state);
	
	  var createItem = function createItem(contentParentId, relativeToContentId, configId, moveBelow) {
	    return (0, _actions2.createContentItem)(contentParentId, relativeToContentId, configId, (0, _selectors3.getContentDefinitions)(state), moveBelow);
	  };
	
	  var hiddenAncestor = (0, _selectors.hasHiddenAncestor)(state, ownProps.contentId);
	
	  return {
	    myProps: myProps,
	    childProps: childProps,
	    parentProps: parentProps,
	    isHovered: isHovered,
	    selectedItem: selectedItem,
	    currentDrag: currentDrag,
	    dropzoneCoords: dropzoneCoords,
	    getConfig: getConfig,
	    createItem: createItem,
	    hiddenAncestor: hiddenAncestor
	  };
	};
	
	var mapDispatchToProps = function mapDispatchToProps(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContentContainer);

/***/ },
/* 249 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by daniel on 25/04/17.
	 */
	
	/**
	 * A content definition category
	 * @typedef {string} ContentCategoryName
	 *
	 */
	
	/**
	 * An object containing valid content category types
	 * @type {Object.<ContentCategoryName>}
	 */
	var CONTENT_DEFINITION_CATEGORIES = exports.CONTENT_DEFINITION_CATEGORIES = function () {
	  /**
	   * @type {ContentCategoryName}
	   */
	  var STRUCTURAL_COMPONENTS = "Structural Components";
	  /**
	   * @type {ContentCategoryName}
	   */
	  var STANDARD_COMPONENTS = "Standard Components";
	  /**
	   * @type {ContentCategoryName}
	   */
	  var DYNAMIC_COMPONENT = "Dynamic Components";
	  /**
	   * @type {ContentCategoryName}
	   */
	  var CUSTOM_COMPONENTS = "Custom Components";
	
	  return {
	    STRUCTURAL_COMPONENTS: STRUCTURAL_COMPONENTS,
	    STANDARD_COMPONENTS: STANDARD_COMPONENTS,
	    DYNAMIC_COMPONENT: DYNAMIC_COMPONENT,
	    CUSTOM_COMPONENTS: CUSTOM_COMPONENTS
	  };
	}();
	
	/**
	 * @typedef {Object} TemplateColor
	 * @property {string} name - Name of the colour
	 * @property {string} color - Hexadecimal representation of this colour. Note US spelling.
	 *
	 */
	
	/**
	 * An array containing valid colours used in the template
	 * @type {Array.<TemplateColor>}
	 */
	var COLORS = exports.COLORS = function () {
	
	  return [{
	    name: "abiMidnightBlue",
	    color: "#230052"
	  }, {
	    name: "abiPurple",
	    color: "#7f58a5"
	  }, {
	    name: "abiBlue",
	    color: "#6e9bb0"
	  }, {
	    name: "abiRed",
	    color: "#ce0c4e"
	  }, {
	    name: "abiOrange",
	    color: "#f26334"
	  }, {
	    name: "abiGreen",
	    color: "#a8ad2c"
	  }, {
	    name: "black",
	    color: "#231f20"
	  }, {
	    name: "grey",
	    color: "#939596"
	  }, {
	    name: "aqua",
	    color: "#53c0a5"
	  }, {
	    name: "stone",
	    color: "#c59872"
	  }, {
	    name: "mauve",
	    color: "#7f2c72"
	  }, {
	    name: "yellow",
	    color: "#fcb316"
	  }];
	}();
	
	/**
	 * A content item definition
	 * @typedef {Object} ContentDefinition
	 *
	 * @property {string} contentId
	 * @property {string} contentIsRoot
	 * @property {string} contentParentId
	 * @property {string} contentOldParentId
	 * @property {string} contentName
	 * @property {string} contentContent
	 * @property {boolean} contentHidden
	 *
	 * @property {string} configId
	 * @property {string} configName
	 * @property {string} configDescription
	 * @property {ContentCategoryName} configCategory
	 * @property {String} configPrimitive
	 * @property {Array} configChildren
	 *
	 * @property {string} viewClass
	 * @property {Object} viewAttributes
	 * @property {Object} viewCss
	 *
	 * @property {string} styleWidth
	 * @property {string} styleBackgroundColour
	 * @property {string} styleTextColour
	 * @property {string} styleTextAlignment
	 *
	 * @property {Array.<Object>} editorAllowedParents
	 * @property {boolean} editorLocked
	 * @property {boolean} editorSelectable
	 * @property {boolean} editorDraggable
	 * @property {boolean} editorDragTarget
	 * @property {boolean} editorHideable
	 * @property {boolean} editorCloneable
	 * @property {boolean} editorDeletable
	 * @property {boolean} editorEditable
	 * @property {boolean} editorSaveable
	 *
	 */
	
	/**
	 * A base definition to subclass in exported variants
	 * @type {ContentDefinition}
	 */
	var BASE_DEFINITION = exports.BASE_DEFINITION = {
	  styleWidth: "",
	  styleHeight: "",
	  stylePadding: "",
	  styleBackgroundColour: "",
	  styleTextColour: "",
	  styleTextAlignment: "",
	
	  contentHidden: false,
	  contentId: "",
	  contentIsRoot: false,
	  contentParentId: "",
	  contentOldParentId: "",
	  contentName: "",
	  contentContent: "",
	
	  configId: "BASE_DEFINITION",
	  configName: "Base definition",
	  configDescription: "This is the base definition. It should be used a template for other definitions.",
	  configCategory: CONTENT_DEFINITION_CATEGORIES.STRUCTURAL_COMPONENTS,
	  configPrimitive: "",
	  configChildren: "",
	
	  viewClass: "",
	  viewAttributes: {},
	  viewCss: {},
	
	  editorAllowedParents: [],
	  editorLocked: false,
	  editorSelectable: true,
	  editorDraggable: true,
	  editorDragTarget: true,
	  editorHideable: true,
	  editorCloneable: true,
	  editorDeletable: true,
	  editorEditable: true,
	  editorSaveable: true
	};

/***/ },
/* 250 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by DSadler on 25/04/2017.
	 */
	
	// Defines the structure of drag and drop events
	
	// 3 types - new items, moving existing in editor or saving as a component -- may add more later to deal with image uploads etc
	
	// In both cases communicate the item definition ID as well as the content ID (which may be null)
	
	var DRAG_TYPE = exports.DRAG_TYPE = {
	  NEW_ITEM: "NEW_ITEM",
	  MOVING_ITEM: "MOVING_ITEM"
	};
	
	var DATA_TRANSFER_TYPE = exports.DATA_TRANSFER_TYPE = {
	  DRAG_TYPE: "editor/dragType",
	  CONTENT_ID: "editor/contentId",
	  CONFIG_ID: "editor/configId"
	};
	
	// Two levels to accepting a drop - the onhover and then on drop events. Determine whether to allow
	// transfer at top, then

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(504), __esModule: true };

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(505), __esModule: true };

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(507), __esModule: true };

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _defineProperty = __webpack_require__(162);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (obj, key, value) {
	  if (key in obj) {
	    (0, _defineProperty2.default)(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	
	var _from = __webpack_require__(251);
	
	var _from2 = _interopRequireDefault(_from);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (arr) {
	  return Array.isArray(arr) ? arr : (0, _from2.default)(arr);
	};

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	// getting tag from 19.1.3.6 Object.prototype.toString()
	var cof = __webpack_require__(167);
	var TAG = __webpack_require__(32)('toStringTag');
	// ES3 wrong here
	var ARG = cof(function () { return arguments; }()) == 'Arguments';
	
	// fallback for IE11 Script Access Denied error
	var tryGet = function (it, key) {
	  try {
	    return it[key];
	  } catch (e) { /* empty */ }
	};
	
	module.exports = function (it) {
	  var O, T, B;
	  return it === undefined ? 'Undefined' : it === null ? 'Null'
	    // @@toStringTag case
	    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	    // builtinTag case
	    : ARG ? cof(O)
	    // ES3 arguments fallback
	    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	};


/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(72);
	var document = __webpack_require__(48).document;
	// typeof document.createElement is 'object' in old IE
	var is = isObject(document) && isObject(document.createElement);
	module.exports = function (it) {
	  return is ? document.createElement(it) : {};
	};


/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = !__webpack_require__(59) && !__webpack_require__(70)(function () {
	  return Object.defineProperty(__webpack_require__(257)('div'), 'a', { get: function () { return 7; } }).a != 7;
	});


/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for non-array-like ES3 and non-enumerable old V8 strings
	var cof = __webpack_require__(167);
	// eslint-disable-next-line no-prototype-builtins
	module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	  return cof(it) == 'String' ? it.split('') : Object(it);
	};


/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var LIBRARY = __webpack_require__(171);
	var $export = __webpack_require__(47);
	var redefine = __webpack_require__(266);
	var hide = __webpack_require__(71);
	var has = __webpack_require__(60);
	var Iterators = __webpack_require__(73);
	var $iterCreate = __webpack_require__(524);
	var setToStringTag = __webpack_require__(174);
	var getPrototypeOf = __webpack_require__(263);
	var ITERATOR = __webpack_require__(32)('iterator');
	var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
	var FF_ITERATOR = '@@iterator';
	var KEYS = 'keys';
	var VALUES = 'values';
	
	var returnThis = function () { return this; };
	
	module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	  $iterCreate(Constructor, NAME, next);
	  var getMethod = function (kind) {
	    if (!BUGGY && kind in proto) return proto[kind];
	    switch (kind) {
	      case KEYS: return function keys() { return new Constructor(this, kind); };
	      case VALUES: return function values() { return new Constructor(this, kind); };
	    } return function entries() { return new Constructor(this, kind); };
	  };
	  var TAG = NAME + ' Iterator';
	  var DEF_VALUES = DEFAULT == VALUES;
	  var VALUES_BUG = false;
	  var proto = Base.prototype;
	  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
	  var $default = (!BUGGY && $native) || getMethod(DEFAULT);
	  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
	  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
	  var methods, key, IteratorPrototype;
	  // Fix native
	  if ($anyNative) {
	    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
	      // Set @@toStringTag to native iterators
	      setToStringTag(IteratorPrototype, TAG, true);
	      // fix for some old engines
	      if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	    }
	  }
	  // fix Array#{values, @@iterator}.name in V8 / FF
	  if (DEF_VALUES && $native && $native.name !== VALUES) {
	    VALUES_BUG = true;
	    $default = function values() { return $native.call(this); };
	  }
	  // Define iterator
	  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	    hide(proto, ITERATOR, $default);
	  }
	  // Plug for library
	  Iterators[NAME] = $default;
	  Iterators[TAG] = returnThis;
	  if (DEFAULT) {
	    methods = {
	      values: DEF_VALUES ? $default : getMethod(VALUES),
	      keys: IS_SET ? $default : getMethod(KEYS),
	      entries: $entries
	    };
	    if (FORCED) for (key in methods) {
	      if (!(key in proto)) redefine(proto, key, methods[key]);
	    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	  }
	  return methods;
	};


/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	var pIE = __webpack_require__(126);
	var createDesc = __webpack_require__(101);
	var toIObject = __webpack_require__(74);
	var toPrimitive = __webpack_require__(178);
	var has = __webpack_require__(60);
	var IE8_DOM_DEFINE = __webpack_require__(258);
	var gOPD = Object.getOwnPropertyDescriptor;
	
	exports.f = __webpack_require__(59) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	  O = toIObject(O);
	  P = toPrimitive(P, true);
	  if (IE8_DOM_DEFINE) try {
	    return gOPD(O, P);
	  } catch (e) { /* empty */ }
	  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	};


/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	var $keys = __webpack_require__(264);
	var hiddenKeys = __webpack_require__(170).concat('length', 'prototype');
	
	exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	  return $keys(O, hiddenKeys);
	};


/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	var has = __webpack_require__(60);
	var toObject = __webpack_require__(102);
	var IE_PROTO = __webpack_require__(175)('IE_PROTO');
	var ObjectProto = Object.prototype;
	
	module.exports = Object.getPrototypeOf || function (O) {
	  O = toObject(O);
	  if (has(O, IE_PROTO)) return O[IE_PROTO];
	  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	    return O.constructor.prototype;
	  } return O instanceof Object ? ObjectProto : null;
	};


/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	var has = __webpack_require__(60);
	var toIObject = __webpack_require__(74);
	var arrayIndexOf = __webpack_require__(517)(false);
	var IE_PROTO = __webpack_require__(175)('IE_PROTO');
	
	module.exports = function (object, names) {
	  var O = toIObject(object);
	  var i = 0;
	  var result = [];
	  var key;
	  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
	  // Don't enum bug & hidden keys
	  while (names.length > i) if (has(O, key = names[i++])) {
	    ~arrayIndexOf(result, key) || result.push(key);
	  }
	  return result;
	};


/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	// most Object methods by ES6 should accept primitives
	var $export = __webpack_require__(47);
	var core = __webpack_require__(21);
	var fails = __webpack_require__(70);
	module.exports = function (KEY, exec) {
	  var fn = (core.Object || {})[KEY] || Object[KEY];
	  var exp = {};
	  exp[KEY] = exec(fn);
	  $export($export.S + $export.F * fails(function () { fn(1); }), 'Object', exp);
	};


/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(71);


/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	// 7.1.15 ToLength
	var toInteger = __webpack_require__(177);
	var min = Math.min;
	module.exports = function (it) {
	  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	};


/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(256);
	var ITERATOR = __webpack_require__(32)('iterator');
	var Iterators = __webpack_require__(73);
	module.exports = __webpack_require__(21).getIteratorMethod = function (it) {
	  if (it != undefined) return it[ITERATOR]
	    || it['@@iterator']
	    || Iterators[classof(it)];
	};


/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = hyphenateProperty;
	
	var _hyphenateStyleName = __webpack_require__(591);
	
	var _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function hyphenateProperty(property) {
	  return (0, _hyphenateStyleName2.default)(property);
	}
	module.exports = exports['default'];

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	module.exports = CSSselect;
	
	var Pseudos       = __webpack_require__(183),
	    DomUtils      = __webpack_require__(75),
	    findOne       = DomUtils.findOne,
	    findAll       = DomUtils.findAll,
	    getChildren   = DomUtils.getChildren,
	    removeSubsets = DomUtils.removeSubsets,
	    falseFunc     = __webpack_require__(98).falseFunc,
	    compile       = __webpack_require__(549),
	    compileUnsafe = compile.compileUnsafe,
	    compileToken  = compile.compileToken;
	
	function getSelectorFunc(searchFunc){
		return function select(query, elems, options){
	        if(typeof query !== "function") query = compileUnsafe(query, options, elems);
	        if(!Array.isArray(elems)) elems = getChildren(elems);
			else elems = removeSubsets(elems);
			return searchFunc(query, elems);
		};
	}
	
	var selectAll = getSelectorFunc(function selectAll(query, elems){
		return (query === falseFunc || !elems || elems.length === 0) ? [] : findAll(query, elems);
	});
	
	var selectOne = getSelectorFunc(function selectOne(query, elems){
		return (query === falseFunc || !elems || elems.length === 0) ? null : findOne(query, elems);
	});
	
	function is(elem, query, options){
		return (typeof query === "function" ? query : compile(query, options))(elem);
	}
	
	/*
		the exported interface
	*/
	function CSSselect(query, elems, options){
		return selectAll(query, elems, options);
	}
	
	CSSselect.compile = compile;
	CSSselect.filters = Pseudos.filters;
	CSSselect.pseudos = Pseudos.pseudos;
	
	CSSselect.selectAll = selectAll;
	CSSselect.selectOne = selectOne;
	
	CSSselect.is = is;
	
	//legacy methods (might be removed)
	CSSselect.parse = compile;
	CSSselect.iterate = selectAll;
	
	//hooks
	CSSselect._compileUnsafe = compileUnsafe;
	CSSselect._compileToken = compileToken;


/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	var DomUtils  = __webpack_require__(75),
	    hasAttrib = DomUtils.hasAttrib,
	    getAttributeValue = DomUtils.getAttributeValue,
	    falseFunc = __webpack_require__(98).falseFunc;
	
	//https://github.com/slevithan/XRegExp/blob/master/src/xregexp.js#L469
	var reChars = /[-[\]{}()*+?.,\\^$|#\s]/g;
	
	/*
		attribute selectors
	*/
	
	var attributeRules = {
		__proto__: null,
		equals: function(next, data){
			var name  = data.name,
			    value = data.value;
	
			if(data.ignoreCase){
				value = value.toLowerCase();
	
				return function equalsIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null && attr.toLowerCase() === value && next(elem);
				};
			}
	
			return function equals(elem){
				return getAttributeValue(elem, name) === value && next(elem);
			};
		},
		hyphen: function(next, data){
			var name  = data.name,
			    value = data.value,
			    len = value.length;
	
			if(data.ignoreCase){
				value = value.toLowerCase();
	
				return function hyphenIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null &&
							(attr.length === len || attr.charAt(len) === "-") &&
							attr.substr(0, len).toLowerCase() === value &&
							next(elem);
				};
			}
	
			return function hyphen(elem){
				var attr = getAttributeValue(elem, name);
				return attr != null &&
						attr.substr(0, len) === value &&
						(attr.length === len || attr.charAt(len) === "-") &&
						next(elem);
			};
		},
		element: function(next, data){
			var name = data.name,
			    value = data.value;
	
			if(/\s/.test(value)){
				return falseFunc;
			}
	
			value = value.replace(reChars, "\\$&");
	
			var pattern = "(?:^|\\s)" + value + "(?:$|\\s)",
			    flags = data.ignoreCase ? "i" : "",
			    regex = new RegExp(pattern, flags);
	
			return function element(elem){
				var attr = getAttributeValue(elem, name);
				return attr != null && regex.test(attr) && next(elem);
			};
		},
		exists: function(next, data){
			var name = data.name;
			return function exists(elem){
				return hasAttrib(elem, name) && next(elem);
			};
		},
		start: function(next, data){
			var name  = data.name,
			    value = data.value,
			    len = value.length;
	
			if(len === 0){
				return falseFunc;
			}
			
			if(data.ignoreCase){
				value = value.toLowerCase();
	
				return function startIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null && attr.substr(0, len).toLowerCase() === value && next(elem);
				};
			}
	
			return function start(elem){
				var attr = getAttributeValue(elem, name);
				return attr != null && attr.substr(0, len) === value && next(elem);
			};
		},
		end: function(next, data){
			var name  = data.name,
			    value = data.value,
			    len   = -value.length;
	
			if(len === 0){
				return falseFunc;
			}
	
			if(data.ignoreCase){
				value = value.toLowerCase();
	
				return function endIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null && attr.substr(len).toLowerCase() === value && next(elem);
				};
			}
	
			return function end(elem){
				var attr = getAttributeValue(elem, name);
				return attr != null && attr.substr(len) === value && next(elem);
			};
		},
		any: function(next, data){
			var name  = data.name,
			    value = data.value;
	
			if(value === ""){
				return falseFunc;
			}
	
			if(data.ignoreCase){
				var regex = new RegExp(value.replace(reChars, "\\$&"), "i");
	
				return function anyIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null && regex.test(attr) && next(elem);
				};
			}
	
			return function any(elem){
				var attr = getAttributeValue(elem, name);
				return attr != null && attr.indexOf(value) >= 0 && next(elem);
			};
		},
		not: function(next, data){
			var name  = data.name,
			    value = data.value;
	
			if(value === ""){
				return function notEmpty(elem){
					return !!getAttributeValue(elem, name) && next(elem);
				};
			} else if(data.ignoreCase){
				value = value.toLowerCase();
	
				return function notIC(elem){
					var attr = getAttributeValue(elem, name);
					return attr != null && attr.toLowerCase() !== value && next(elem);
				};
			}
	
			return function not(elem){
				return getAttributeValue(elem, name) !== value && next(elem);
			};
		}
	};
	
	module.exports = {
		compile: function(next, data, options){
			if(options && options.strict && (
				data.ignoreCase || data.action === "not"
			)) throw SyntaxError("Unsupported attribute selector");
			return attributeRules[data.action](next, data);
		},
		rules: attributeRules
	};


/***/ },
/* 272 */
/***/ function(module, exports) {

	// This object will be used as the prototype for Nodes when creating a
	// DOM-Level-1-compliant structure.
	var NodePrototype = module.exports = {
		get firstChild() {
			var children = this.children;
			return children && children[0] || null;
		},
		get lastChild() {
			var children = this.children;
			return children && children[children.length - 1] || null;
		},
		get nodeType() {
			return nodeTypes[this.type] || nodeTypes.element;
		}
	};
	
	var domLvl1 = {
		tagName: "name",
		childNodes: "children",
		parentNode: "parent",
		previousSibling: "prev",
		nextSibling: "next",
		nodeValue: "data"
	};
	
	var nodeTypes = {
		element: 1,
		text: 3,
		cdata: 4,
		comment: 8
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(NodePrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	var decodeMap = __webpack_require__(614);
	
	module.exports = decodeCodePoint;
	
	// modified version of https://github.com/mathiasbynens/he/blob/master/src/he.js#L94-L119
	function decodeCodePoint(codePoint){
	
		if((codePoint >= 0xD800 && codePoint <= 0xDFFF) || codePoint > 0x10FFFF){
			return "\uFFFD";
		}
	
		if(codePoint in decodeMap){
			codePoint = decodeMap[codePoint];
		}
	
		var output = "";
	
		if(codePoint > 0xFFFF){
			codePoint -= 0x10000;
			output += String.fromCharCode(codePoint >>> 10 & 0x3FF | 0xD800);
			codePoint = 0xDC00 | codePoint & 0x3FF;
		}
	
		output += String.fromCharCode(codePoint);
		return output;
	}


/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var emptyFunction = __webpack_require__(24);
	
	/**
	 * Upstream version of event listener. Does not take into account specific
	 * nature of platform.
	 */
	var EventListener = {
	  /**
	   * Listen to DOM events during the bubble phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  listen: function listen(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, false);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, false);
	        }
	      };
	    } else if (target.attachEvent) {
	      target.attachEvent('on' + eventType, callback);
	      return {
	        remove: function remove() {
	          target.detachEvent('on' + eventType, callback);
	        }
	      };
	    }
	  },
	
	  /**
	   * Listen to DOM events during the capture phase.
	   *
	   * @param {DOMEventTarget} target DOM element to register listener on.
	   * @param {string} eventType Event type, e.g. 'click' or 'mouseover'.
	   * @param {function} callback Callback function.
	   * @return {object} Object with a `remove` method.
	   */
	  capture: function capture(target, eventType, callback) {
	    if (target.addEventListener) {
	      target.addEventListener(eventType, callback, true);
	      return {
	        remove: function remove() {
	          target.removeEventListener(eventType, callback, true);
	        }
	      };
	    } else {
	      if (false) {
	        console.error('Attempted to listen to events during the capture phase on a ' + 'browser that does not support the capture phase. Your application ' + 'will not receive some events.');
	      }
	      return {
	        remove: emptyFunction
	      };
	    }
	  },
	
	  registerDefault: function registerDefault() {}
	};
	
	module.exports = EventListener;

/***/ },
/* 275 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * @param {DOMElement} node input/textarea to focus
	 */
	
	function focusNode(node) {
	  // IE8 can throw "Can't move focus to the control because it is invisible,
	  // not enabled, or of a type that does not accept the focus." for all kinds of
	  // reasons that are too expensive and fragile to test.
	  try {
	    node.focus();
	  } catch (e) {}
	}
	
	module.exports = focusNode;

/***/ },
/* 276 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/* eslint-disable fb-www/typeof-undefined */
	
	/**
	 * Same as document.activeElement but wraps in a try-catch block. In IE it is
	 * not safe to call document.activeElement if there is nothing focused.
	 *
	 * The activeElement will be null only if the document or document body is not
	 * yet defined.
	 *
	 * @param {?DOMDocument} doc Defaults to current document.
	 * @return {?DOMElement}
	 */
	function getActiveElement(doc) /*?DOMElement*/{
	  doc = doc || (typeof document !== 'undefined' ? document : undefined);
	  if (typeof doc === 'undefined') {
	    return null;
	  }
	  try {
	    return doc.activeElement || doc.body;
	  } catch (e) {
	    return doc.body;
	  }
	}
	
	module.exports = getActiveElement;

/***/ },
/* 277 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = function addEventListener(node, event, listener) {
	  return node.addEventListener ? node.addEventListener(event, listener, false) : node.attachEvent('on' + event, listener);
	};
	
	var removeEventListener = exports.removeEventListener = function removeEventListener(node, event, listener) {
	  return node.removeEventListener ? node.removeEventListener(event, listener, false) : node.detachEvent('on' + event, listener);
	};
	
	var getConfirmation = exports.getConfirmation = function getConfirmation(message, callback) {
	  return callback(window.confirm(message));
	}; // eslint-disable-line no-alert
	
	/**
	 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
	 *
	 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
	 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
	 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
	 */
	var supportsHistory = exports.supportsHistory = function supportsHistory() {
	  var ua = window.navigator.userAgent;
	
	  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
	
	  return window.history && 'pushState' in window.history;
	};
	
	/**
	 * Returns true if browser fires popstate on hash change.
	 * IE10 and IE11 do not.
	 */
	var supportsPopStateOnHashChange = exports.supportsPopStateOnHashChange = function supportsPopStateOnHashChange() {
	  return window.navigator.userAgent.indexOf('Trident') === -1;
	};
	
	/**
	 * Returns false if using go(n) with hash history causes a full page reload.
	 */
	var supportsGoWithoutReloadUsingHash = exports.supportsGoWithoutReloadUsingHash = function supportsGoWithoutReloadUsingHash() {
	  return window.navigator.userAgent.indexOf('Firefox') === -1;
	};
	
	/**
	 * Returns true if a given popstate event is an extraneous WebKit event.
	 * Accounts for the fact that Chrome on iOS fires real popstate events
	 * containing undefined state when pressing the back button.
	 */
	var isExtraneousPopstateEvent = exports.isExtraneousPopstateEvent = function isExtraneousPopstateEvent(event) {
	  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
	};

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(131);
	
	var _PathUtils = __webpack_require__(76);
	
	var _createTransitionManager = __webpack_require__(185);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PopStateEvent = 'popstate';
	var HashChangeEvent = 'hashchange';
	
	var getHistoryState = function getHistoryState() {
	  try {
	    return window.history.state || {};
	  } catch (e) {
	    // IE 11 sometimes throws when accessing window.history.state
	    // See https://github.com/ReactTraining/history/pull/289
	    return {};
	  }
	};
	
	/**
	 * Creates a history object that uses the HTML5 history API including
	 * pushState, replaceState, and the popstate event.
	 */
	var createBrowserHistory = function createBrowserHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Browser history needs a DOM');
	
	  var globalHistory = window.history;
	  var canUseHistory = (0, _DOMUtils.supportsHistory)();
	  var needsHashChangeListener = !(0, _DOMUtils.supportsPopStateOnHashChange)();
	
	  var _props$forceRefresh = props.forceRefresh,
	      forceRefresh = _props$forceRefresh === undefined ? false : _props$forceRefresh,
	      _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var getDOMLocation = function getDOMLocation(historyState) {
	    var _ref = historyState || {},
	        key = _ref.key,
	        state = _ref.state;
	
	    var _window$location = window.location,
	        pathname = _window$location.pathname,
	        search = _window$location.search,
	        hash = _window$location.hash;
	
	
	    var path = pathname + search + hash;
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path, state, key);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var handlePopState = function handlePopState(event) {
	    // Ignore extraneous popstate events in WebKit.
	    if ((0, _DOMUtils.isExtraneousPopstateEvent)(event)) return;
	
	    handlePop(getDOMLocation(event.state));
	  };
	
	  var handleHashChange = function handleHashChange() {
	    handlePop(getDOMLocation(getHistoryState()));
	  };
	
	  var forceNextPop = false;
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of keys we've seen in sessionStorage.
	    // Instead, we just default to 0 for keys we don't know.
	
	    var toIndex = allKeys.indexOf(toLocation.key);
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allKeys.indexOf(fromLocation.key);
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  var initialLocation = getDOMLocation(getHistoryState());
	  var allKeys = [initialLocation.key];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return basename + (0, _PathUtils.createPath)(location);
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.pushState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.href = href;
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	          var nextKeys = allKeys.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	          nextKeys.push(location.key);
	          allKeys = nextKeys;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history');
	
	        window.location.href = href;
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var href = createHref(location);
	      var key = location.key,
	          state = location.state;
	
	
	      if (canUseHistory) {
	        globalHistory.replaceState({ key: key, state: state }, null, href);
	
	        if (forceRefresh) {
	          window.location.replace(href);
	        } else {
	          var prevIndex = allKeys.indexOf(history.location.key);
	
	          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
	
	          setState({ action: action, location: location });
	        }
	      } else {
	        (0, _warning2.default)(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history');
	
	        window.location.replace(href);
	      }
	    });
	  };
	
	  var go = function go(n) {
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, PopStateEvent, handlePopState);
	
	      if (needsHashChangeListener) (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createBrowserHistory;

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _LocationUtils = __webpack_require__(131);
	
	var _PathUtils = __webpack_require__(76);
	
	var _createTransitionManager = __webpack_require__(185);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	var _DOMUtils = __webpack_require__(277);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HashChangeEvent = 'hashchange';
	
	var HashPathCoders = {
	  hashbang: {
	    encodePath: function encodePath(path) {
	      return path.charAt(0) === '!' ? path : '!/' + (0, _PathUtils.stripLeadingSlash)(path);
	    },
	    decodePath: function decodePath(path) {
	      return path.charAt(0) === '!' ? path.substr(1) : path;
	    }
	  },
	  noslash: {
	    encodePath: _PathUtils.stripLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  },
	  slash: {
	    encodePath: _PathUtils.addLeadingSlash,
	    decodePath: _PathUtils.addLeadingSlash
	  }
	};
	
	var getHashPath = function getHashPath() {
	  // We can't use window.location.hash here because it's not
	  // consistent across browsers - Firefox will pre-decode it!
	  var href = window.location.href;
	  var hashIndex = href.indexOf('#');
	  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
	};
	
	var pushHashPath = function pushHashPath(path) {
	  return window.location.hash = path;
	};
	
	var replaceHashPath = function replaceHashPath(path) {
	  var hashIndex = window.location.href.indexOf('#');
	
	  window.location.replace(window.location.href.slice(0, hashIndex >= 0 ? hashIndex : 0) + '#' + path);
	};
	
	var createHashHistory = function createHashHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  (0, _invariant2.default)(_DOMUtils.canUseDOM, 'Hash history needs a DOM');
	
	  var globalHistory = window.history;
	  var canGoWithoutReload = (0, _DOMUtils.supportsGoWithoutReloadUsingHash)();
	
	  var _props$getUserConfirm = props.getUserConfirmation,
	      getUserConfirmation = _props$getUserConfirm === undefined ? _DOMUtils.getConfirmation : _props$getUserConfirm,
	      _props$hashType = props.hashType,
	      hashType = _props$hashType === undefined ? 'slash' : _props$hashType;
	
	  var basename = props.basename ? (0, _PathUtils.stripTrailingSlash)((0, _PathUtils.addLeadingSlash)(props.basename)) : '';
	
	  var _HashPathCoders$hashT = HashPathCoders[hashType],
	      encodePath = _HashPathCoders$hashT.encodePath,
	      decodePath = _HashPathCoders$hashT.decodePath;
	
	
	  var getDOMLocation = function getDOMLocation() {
	    var path = decodePath(getHashPath());
	
	    (0, _warning2.default)(!basename || (0, _PathUtils.hasBasename)(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".');
	
	    if (basename) path = (0, _PathUtils.stripBasename)(path, basename);
	
	    return (0, _LocationUtils.createLocation)(path);
	  };
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = globalHistory.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var forceNextPop = false;
	  var ignorePath = null;
	
	  var handleHashChange = function handleHashChange() {
	    var path = getHashPath();
	    var encodedPath = encodePath(path);
	
	    if (path !== encodedPath) {
	      // Ensure we always have a properly-encoded hash.
	      replaceHashPath(encodedPath);
	    } else {
	      var location = getDOMLocation();
	      var prevLocation = history.location;
	
	      if (!forceNextPop && (0, _LocationUtils.locationsAreEqual)(prevLocation, location)) return; // A hashchange doesn't always == location change.
	
	      if (ignorePath === (0, _PathUtils.createPath)(location)) return; // Ignore this change; we already setState in push/replace.
	
	      ignorePath = null;
	
	      handlePop(location);
	    }
	  };
	
	  var handlePop = function handlePop(location) {
	    if (forceNextPop) {
	      forceNextPop = false;
	      setState();
	    } else {
	      var action = 'POP';
	
	      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	        if (ok) {
	          setState({ action: action, location: location });
	        } else {
	          revertPop(location);
	        }
	      });
	    }
	  };
	
	  var revertPop = function revertPop(fromLocation) {
	    var toLocation = history.location;
	
	    // TODO: We could probably make this more reliable by
	    // keeping a list of paths we've seen in sessionStorage.
	    // Instead, we just default to 0 for paths we don't know.
	
	    var toIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(toLocation));
	
	    if (toIndex === -1) toIndex = 0;
	
	    var fromIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(fromLocation));
	
	    if (fromIndex === -1) fromIndex = 0;
	
	    var delta = toIndex - fromIndex;
	
	    if (delta) {
	      forceNextPop = true;
	      go(delta);
	    }
	  };
	
	  // Ensure the hash is encoded properly before doing anything else.
	  var path = getHashPath();
	  var encodedPath = encodePath(path);
	
	  if (path !== encodedPath) replaceHashPath(encodedPath);
	
	  var initialLocation = getDOMLocation();
	  var allPaths = [(0, _PathUtils.createPath)(initialLocation)];
	
	  // Public interface
	
	  var createHref = function createHref(location) {
	    return '#' + encodePath(basename + (0, _PathUtils.createPath)(location));
	  };
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot push state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a PUSH, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        pushHashPath(encodedPath);
	
	        var prevIndex = allPaths.lastIndexOf((0, _PathUtils.createPath)(history.location));
	        var nextPaths = allPaths.slice(0, prevIndex === -1 ? 0 : prevIndex + 1);
	
	        nextPaths.push(path);
	        allPaths = nextPaths;
	
	        setState({ action: action, location: location });
	      } else {
	        (0, _warning2.default)(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack');
	
	        setState();
	      }
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(state === undefined, 'Hash history cannot replace state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, undefined, undefined, history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var path = (0, _PathUtils.createPath)(location);
	      var encodedPath = encodePath(basename + path);
	      var hashChanged = getHashPath() !== encodedPath;
	
	      if (hashChanged) {
	        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
	        // rather setState here and ignore the hashchange. The caveat here
	        // is that other hash histories in the page will consider it a POP.
	        ignorePath = path;
	        replaceHashPath(encodedPath);
	      }
	
	      var prevIndex = allPaths.indexOf((0, _PathUtils.createPath)(history.location));
	
	      if (prevIndex !== -1) allPaths[prevIndex] = path;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    (0, _warning2.default)(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser');
	
	    globalHistory.go(n);
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var listenerCount = 0;
	
	  var checkDOMListeners = function checkDOMListeners(delta) {
	    listenerCount += delta;
	
	    if (listenerCount === 1) {
	      (0, _DOMUtils.addEventListener)(window, HashChangeEvent, handleHashChange);
	    } else if (listenerCount === 0) {
	      (0, _DOMUtils.removeEventListener)(window, HashChangeEvent, handleHashChange);
	    }
	  };
	
	  var isBlocked = false;
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	    var unblock = transitionManager.setPrompt(prompt);
	
	    if (!isBlocked) {
	      checkDOMListeners(1);
	      isBlocked = true;
	    }
	
	    return function () {
	      if (isBlocked) {
	        isBlocked = false;
	        checkDOMListeners(-1);
	      }
	
	      return unblock();
	    };
	  };
	
	  var listen = function listen(listener) {
	    var unlisten = transitionManager.appendListener(listener);
	    checkDOMListeners(1);
	
	    return function () {
	      checkDOMListeners(-1);
	      unlisten();
	    };
	  };
	
	  var history = {
	    length: globalHistory.length,
	    action: 'POP',
	    location: initialLocation,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createHashHistory;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _PathUtils = __webpack_require__(76);
	
	var _LocationUtils = __webpack_require__(131);
	
	var _createTransitionManager = __webpack_require__(185);
	
	var _createTransitionManager2 = _interopRequireDefault(_createTransitionManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var clamp = function clamp(n, lowerBound, upperBound) {
	  return Math.min(Math.max(n, lowerBound), upperBound);
	};
	
	/**
	 * Creates a history object that stores locations in memory.
	 */
	var createMemoryHistory = function createMemoryHistory() {
	  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var getUserConfirmation = props.getUserConfirmation,
	      _props$initialEntries = props.initialEntries,
	      initialEntries = _props$initialEntries === undefined ? ['/'] : _props$initialEntries,
	      _props$initialIndex = props.initialIndex,
	      initialIndex = _props$initialIndex === undefined ? 0 : _props$initialIndex,
	      _props$keyLength = props.keyLength,
	      keyLength = _props$keyLength === undefined ? 6 : _props$keyLength;
	
	
	  var transitionManager = (0, _createTransitionManager2.default)();
	
	  var setState = function setState(nextState) {
	    _extends(history, nextState);
	
	    history.length = history.entries.length;
	
	    transitionManager.notifyListeners(history.location, history.action);
	  };
	
	  var createKey = function createKey() {
	    return Math.random().toString(36).substr(2, keyLength);
	  };
	
	  var index = clamp(initialIndex, 0, initialEntries.length - 1);
	  var entries = initialEntries.map(function (entry) {
	    return typeof entry === 'string' ? (0, _LocationUtils.createLocation)(entry, undefined, createKey()) : (0, _LocationUtils.createLocation)(entry, undefined, entry.key || createKey());
	  });
	
	  // Public interface
	
	  var createHref = _PathUtils.createPath;
	
	  var push = function push(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'PUSH';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      var prevIndex = history.index;
	      var nextIndex = prevIndex + 1;
	
	      var nextEntries = history.entries.slice(0);
	      if (nextEntries.length > nextIndex) {
	        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
	      } else {
	        nextEntries.push(location);
	      }
	
	      setState({
	        action: action,
	        location: location,
	        index: nextIndex,
	        entries: nextEntries
	      });
	    });
	  };
	
	  var replace = function replace(path, state) {
	    (0, _warning2.default)(!((typeof path === 'undefined' ? 'undefined' : _typeof(path)) === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored');
	
	    var action = 'REPLACE';
	    var location = (0, _LocationUtils.createLocation)(path, state, createKey(), history.location);
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (!ok) return;
	
	      history.entries[history.index] = location;
	
	      setState({ action: action, location: location });
	    });
	  };
	
	  var go = function go(n) {
	    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
	
	    var action = 'POP';
	    var location = history.entries[nextIndex];
	
	    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
	      if (ok) {
	        setState({
	          action: action,
	          location: location,
	          index: nextIndex
	        });
	      } else {
	        // Mimic the behavior of DOM histories by
	        // causing a render after a cancelled POP.
	        setState();
	      }
	    });
	  };
	
	  var goBack = function goBack() {
	    return go(-1);
	  };
	
	  var goForward = function goForward() {
	    return go(1);
	  };
	
	  var canGo = function canGo(n) {
	    var nextIndex = history.index + n;
	    return nextIndex >= 0 && nextIndex < history.entries.length;
	  };
	
	  var block = function block() {
	    var prompt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	    return transitionManager.setPrompt(prompt);
	  };
	
	  var listen = function listen(listener) {
	    return transitionManager.appendListener(listener);
	  };
	
	  var history = {
	    length: entries.length,
	    action: 'POP',
	    location: entries[index],
	    index: index,
	    entries: entries,
	    createHref: createHref,
	    push: push,
	    replace: replace,
	    go: go,
	    goBack: goBack,
	    goForward: goForward,
	    canGo: canGo,
	    block: block,
	    listen: listen
	  };
	
	  return history;
	};
	
	exports.default = createMemoryHistory;

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	var Tokenizer = __webpack_require__(282);
	
	/*
		Options:
	
		xmlMode: Disables the special behavior for script/style tags (false by default)
		lowerCaseAttributeNames: call .toLowerCase for each attribute name (true if xmlMode is `false`)
		lowerCaseTags: call .toLowerCase for each tag name (true if xmlMode is `false`)
	*/
	
	/*
		Callbacks:
	
		oncdataend,
		oncdatastart,
		onclosetag,
		oncomment,
		oncommentend,
		onerror,
		onopentag,
		onprocessinginstruction,
		onreset,
		ontext
	*/
	
	var formTags = {
		input: true,
		option: true,
		optgroup: true,
		select: true,
		button: true,
		datalist: true,
		textarea: true
	};
	
	var openImpliesClose = {
		tr      : { tr:true, th:true, td:true },
		th      : { th:true },
		td      : { thead:true, th:true, td:true },
		body    : { head:true, link:true, script:true },
		li      : { li:true },
		p       : { p:true },
		h1      : { p:true },
		h2      : { p:true },
		h3      : { p:true },
		h4      : { p:true },
		h5      : { p:true },
		h6      : { p:true },
		select  : formTags,
		input   : formTags,
		output  : formTags,
		button  : formTags,
		datalist: formTags,
		textarea: formTags,
		option  : { option:true },
		optgroup: { optgroup:true }
	};
	
	var voidElements = {
		__proto__: null,
		area: true,
		base: true,
		basefont: true,
		br: true,
		col: true,
		command: true,
		embed: true,
		frame: true,
		hr: true,
		img: true,
		input: true,
		isindex: true,
		keygen: true,
		link: true,
		meta: true,
		param: true,
		source: true,
		track: true,
		wbr: true,
	
		//common self closing svg elements
		path: true,
		circle: true,
		ellipse: true,
		line: true,
		rect: true,
		use: true,
		stop: true,
		polyline: true,
		polygon: true
	};
	
	var re_nameEnd = /\s|\//;
	
	function Parser(cbs, options){
		this._options = options || {};
		this._cbs = cbs || {};
	
		this._tagname = "";
		this._attribname = "";
		this._attribvalue = "";
		this._attribs = null;
		this._stack = [];
	
		this.startIndex = 0;
		this.endIndex = null;
	
		this._lowerCaseTagNames = "lowerCaseTags" in this._options ?
										!!this._options.lowerCaseTags :
										!this._options.xmlMode;
		this._lowerCaseAttributeNames = "lowerCaseAttributeNames" in this._options ?
										!!this._options.lowerCaseAttributeNames :
										!this._options.xmlMode;
	
		if(this._options.Tokenizer) {
			Tokenizer = this._options.Tokenizer;
		}
		this._tokenizer = new Tokenizer(this._options, this);
	
		if(this._cbs.onparserinit) this._cbs.onparserinit(this);
	}
	
	__webpack_require__(38)(Parser, __webpack_require__(129).EventEmitter);
	
	Parser.prototype._updatePosition = function(initialOffset){
		if(this.endIndex === null){
			if(this._tokenizer._sectionStart <= initialOffset){
				this.startIndex = 0;
			} else {
				this.startIndex = this._tokenizer._sectionStart - initialOffset;
			}
		}
		else this.startIndex = this.endIndex + 1;
		this.endIndex = this._tokenizer.getAbsoluteIndex();
	};
	
	//Tokenizer event handlers
	Parser.prototype.ontext = function(data){
		this._updatePosition(1);
		this.endIndex--;
	
		if(this._cbs.ontext) this._cbs.ontext(data);
	};
	
	Parser.prototype.onopentagname = function(name){
		if(this._lowerCaseTagNames){
			name = name.toLowerCase();
		}
	
		this._tagname = name;
	
		if(!this._options.xmlMode && name in openImpliesClose) {
			for(
				var el;
				(el = this._stack[this._stack.length - 1]) in openImpliesClose[name];
				this.onclosetag(el)
			);
		}
	
		if(this._options.xmlMode || !(name in voidElements)){
			this._stack.push(name);
		}
	
		if(this._cbs.onopentagname) this._cbs.onopentagname(name);
		if(this._cbs.onopentag) this._attribs = {};
	};
	
	Parser.prototype.onopentagend = function(){
		this._updatePosition(1);
	
		if(this._attribs){
			if(this._cbs.onopentag) this._cbs.onopentag(this._tagname, this._attribs);
			this._attribs = null;
		}
	
		if(!this._options.xmlMode && this._cbs.onclosetag && this._tagname in voidElements){
			this._cbs.onclosetag(this._tagname);
		}
	
		this._tagname = "";
	};
	
	Parser.prototype.onclosetag = function(name){
		this._updatePosition(1);
	
		if(this._lowerCaseTagNames){
			name = name.toLowerCase();
		}
	
		if(this._stack.length && (!(name in voidElements) || this._options.xmlMode)){
			var pos = this._stack.lastIndexOf(name);
			if(pos !== -1){
				if(this._cbs.onclosetag){
					pos = this._stack.length - pos;
					while(pos--) this._cbs.onclosetag(this._stack.pop());
				}
				else this._stack.length = pos;
			} else if(name === "p" && !this._options.xmlMode){
				this.onopentagname(name);
				this._closeCurrentTag();
			}
		} else if(!this._options.xmlMode && (name === "br" || name === "p")){
			this.onopentagname(name);
			this._closeCurrentTag();
		}
	};
	
	Parser.prototype.onselfclosingtag = function(){
		if(this._options.xmlMode || this._options.recognizeSelfClosing){
			this._closeCurrentTag();
		} else {
			this.onopentagend();
		}
	};
	
	Parser.prototype._closeCurrentTag = function(){
		var name = this._tagname;
	
		this.onopentagend();
	
		//self-closing tags will be on the top of the stack
		//(cheaper check than in onclosetag)
		if(this._stack[this._stack.length - 1] === name){
			if(this._cbs.onclosetag){
				this._cbs.onclosetag(name);
			}
			this._stack.pop();
		}
	};
	
	Parser.prototype.onattribname = function(name){
		if(this._lowerCaseAttributeNames){
			name = name.toLowerCase();
		}
		this._attribname = name;
	};
	
	Parser.prototype.onattribdata = function(value){
		this._attribvalue += value;
	};
	
	Parser.prototype.onattribend = function(){
		if(this._cbs.onattribute) this._cbs.onattribute(this._attribname, this._attribvalue);
		if(
			this._attribs &&
			!Object.prototype.hasOwnProperty.call(this._attribs, this._attribname)
		){
			this._attribs[this._attribname] = this._attribvalue;
		}
		this._attribname = "";
		this._attribvalue = "";
	};
	
	Parser.prototype._getInstructionName = function(value){
		var idx = value.search(re_nameEnd),
		    name = idx < 0 ? value : value.substr(0, idx);
	
		if(this._lowerCaseTagNames){
			name = name.toLowerCase();
		}
	
		return name;
	};
	
	Parser.prototype.ondeclaration = function(value){
		if(this._cbs.onprocessinginstruction){
			var name = this._getInstructionName(value);
			this._cbs.onprocessinginstruction("!" + name, "!" + value);
		}
	};
	
	Parser.prototype.onprocessinginstruction = function(value){
		if(this._cbs.onprocessinginstruction){
			var name = this._getInstructionName(value);
			this._cbs.onprocessinginstruction("?" + name, "?" + value);
		}
	};
	
	Parser.prototype.oncomment = function(value){
		this._updatePosition(4);
	
		if(this._cbs.oncomment) this._cbs.oncomment(value);
		if(this._cbs.oncommentend) this._cbs.oncommentend();
	};
	
	Parser.prototype.oncdata = function(value){
		this._updatePosition(1);
	
		if(this._options.xmlMode || this._options.recognizeCDATA){
			if(this._cbs.oncdatastart) this._cbs.oncdatastart();
			if(this._cbs.ontext) this._cbs.ontext(value);
			if(this._cbs.oncdataend) this._cbs.oncdataend();
		} else {
			this.oncomment("[CDATA[" + value + "]]");
		}
	};
	
	Parser.prototype.onerror = function(err){
		if(this._cbs.onerror) this._cbs.onerror(err);
	};
	
	Parser.prototype.onend = function(){
		if(this._cbs.onclosetag){
			for(
				var i = this._stack.length;
				i > 0;
				this._cbs.onclosetag(this._stack[--i])
			);
		}
		if(this._cbs.onend) this._cbs.onend();
	};
	
	
	//Resets the parser to a blank state, ready to parse a new HTML document
	Parser.prototype.reset = function(){
		if(this._cbs.onreset) this._cbs.onreset();
		this._tokenizer.reset();
	
		this._tagname = "";
		this._attribname = "";
		this._attribs = null;
		this._stack = [];
	
		if(this._cbs.onparserinit) this._cbs.onparserinit(this);
	};
	
	//Parses a complete HTML document and pushes it to the handler
	Parser.prototype.parseComplete = function(data){
		this.reset();
		this.end(data);
	};
	
	Parser.prototype.write = function(chunk){
		this._tokenizer.write(chunk);
	};
	
	Parser.prototype.end = function(chunk){
		this._tokenizer.end(chunk);
	};
	
	Parser.prototype.pause = function(){
		this._tokenizer.pause();
	};
	
	Parser.prototype.resume = function(){
		this._tokenizer.resume();
	};
	
	//alias for backwards compat
	Parser.prototype.parseChunk = Parser.prototype.write;
	Parser.prototype.done = Parser.prototype.end;
	
	module.exports = Parser;


/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Tokenizer;
	
	var decodeCodePoint = __webpack_require__(273),
	    entityMap = __webpack_require__(187),
	    legacyMap = __webpack_require__(289),
	    xmlMap    = __webpack_require__(188),
	
	    i = 0,
	
	    TEXT                      = i++,
	    BEFORE_TAG_NAME           = i++, //after <
	    IN_TAG_NAME               = i++,
	    IN_SELF_CLOSING_TAG       = i++,
	    BEFORE_CLOSING_TAG_NAME   = i++,
	    IN_CLOSING_TAG_NAME       = i++,
	    AFTER_CLOSING_TAG_NAME    = i++,
	
	    //attributes
	    BEFORE_ATTRIBUTE_NAME     = i++,
	    IN_ATTRIBUTE_NAME         = i++,
	    AFTER_ATTRIBUTE_NAME      = i++,
	    BEFORE_ATTRIBUTE_VALUE    = i++,
	    IN_ATTRIBUTE_VALUE_DQ     = i++, // "
	    IN_ATTRIBUTE_VALUE_SQ     = i++, // '
	    IN_ATTRIBUTE_VALUE_NQ     = i++,
	
	    //declarations
	    BEFORE_DECLARATION        = i++, // !
	    IN_DECLARATION            = i++,
	
	    //processing instructions
	    IN_PROCESSING_INSTRUCTION = i++, // ?
	
	    //comments
	    BEFORE_COMMENT            = i++,
	    IN_COMMENT                = i++,
	    AFTER_COMMENT_1           = i++,
	    AFTER_COMMENT_2           = i++,
	
	    //cdata
	    BEFORE_CDATA_1            = i++, // [
	    BEFORE_CDATA_2            = i++, // C
	    BEFORE_CDATA_3            = i++, // D
	    BEFORE_CDATA_4            = i++, // A
	    BEFORE_CDATA_5            = i++, // T
	    BEFORE_CDATA_6            = i++, // A
	    IN_CDATA                  = i++, // [
	    AFTER_CDATA_1             = i++, // ]
	    AFTER_CDATA_2             = i++, // ]
	
	    //special tags
	    BEFORE_SPECIAL            = i++, //S
	    BEFORE_SPECIAL_END        = i++,   //S
	
	    BEFORE_SCRIPT_1           = i++, //C
	    BEFORE_SCRIPT_2           = i++, //R
	    BEFORE_SCRIPT_3           = i++, //I
	    BEFORE_SCRIPT_4           = i++, //P
	    BEFORE_SCRIPT_5           = i++, //T
	    AFTER_SCRIPT_1            = i++, //C
	    AFTER_SCRIPT_2            = i++, //R
	    AFTER_SCRIPT_3            = i++, //I
	    AFTER_SCRIPT_4            = i++, //P
	    AFTER_SCRIPT_5            = i++, //T
	
	    BEFORE_STYLE_1            = i++, //T
	    BEFORE_STYLE_2            = i++, //Y
	    BEFORE_STYLE_3            = i++, //L
	    BEFORE_STYLE_4            = i++, //E
	    AFTER_STYLE_1             = i++, //T
	    AFTER_STYLE_2             = i++, //Y
	    AFTER_STYLE_3             = i++, //L
	    AFTER_STYLE_4             = i++, //E
	
	    BEFORE_ENTITY             = i++, //&
	    BEFORE_NUMERIC_ENTITY     = i++, //#
	    IN_NAMED_ENTITY           = i++,
	    IN_NUMERIC_ENTITY         = i++,
	    IN_HEX_ENTITY             = i++, //X
	
	    j = 0,
	
	    SPECIAL_NONE              = j++,
	    SPECIAL_SCRIPT            = j++,
	    SPECIAL_STYLE             = j++;
	
	function whitespace(c){
		return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function characterState(char, SUCCESS){
		return function(c){
			if(c === char) this._state = SUCCESS;
		};
	}
	
	function ifElseState(upper, SUCCESS, FAILURE){
		var lower = upper.toLowerCase();
	
		if(upper === lower){
			return function(c){
				if(c === lower){
					this._state = SUCCESS;
				} else {
					this._state = FAILURE;
					this._index--;
				}
			};
		} else {
			return function(c){
				if(c === lower || c === upper){
					this._state = SUCCESS;
				} else {
					this._state = FAILURE;
					this._index--;
				}
			};
		}
	}
	
	function consumeSpecialNameChar(upper, NEXT_STATE){
		var lower = upper.toLowerCase();
	
		return function(c){
			if(c === lower || c === upper){
				this._state = NEXT_STATE;
			} else {
				this._state = IN_TAG_NAME;
				this._index--; //consume the token again
			}
		};
	}
	
	function Tokenizer(options, cbs){
		this._state = TEXT;
		this._buffer = "";
		this._sectionStart = 0;
		this._index = 0;
		this._bufferOffset = 0; //chars removed from _buffer
		this._baseState = TEXT;
		this._special = SPECIAL_NONE;
		this._cbs = cbs;
		this._running = true;
		this._ended = false;
		this._xmlMode = !!(options && options.xmlMode);
		this._decodeEntities = !!(options && options.decodeEntities);
	}
	
	Tokenizer.prototype._stateText = function(c){
		if(c === "<"){
			if(this._index > this._sectionStart){
				this._cbs.ontext(this._getSection());
			}
			this._state = BEFORE_TAG_NAME;
			this._sectionStart = this._index;
		} else if(this._decodeEntities && this._special === SPECIAL_NONE && c === "&"){
			if(this._index > this._sectionStart){
				this._cbs.ontext(this._getSection());
			}
			this._baseState = TEXT;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateBeforeTagName = function(c){
		if(c === "/"){
			this._state = BEFORE_CLOSING_TAG_NAME;
		} else if(c === "<"){
			this._cbs.ontext(this._getSection());
			this._sectionStart = this._index;
		} else if(c === ">" || this._special !== SPECIAL_NONE || whitespace(c)) {
			this._state = TEXT;
		} else if(c === "!"){
			this._state = BEFORE_DECLARATION;
			this._sectionStart = this._index + 1;
		} else if(c === "?"){
			this._state = IN_PROCESSING_INSTRUCTION;
			this._sectionStart = this._index + 1;
		} else {
			this._state = (!this._xmlMode && (c === "s" || c === "S")) ?
							BEFORE_SPECIAL : IN_TAG_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInTagName = function(c){
		if(c === "/" || c === ">" || whitespace(c)){
			this._emitToken("onopentagname");
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateBeforeCloseingTagName = function(c){
		if(whitespace(c));
		else if(c === ">"){
			this._state = TEXT;
		} else if(this._special !== SPECIAL_NONE){
			if(c === "s" || c === "S"){
				this._state = BEFORE_SPECIAL_END;
			} else {
				this._state = TEXT;
				this._index--;
			}
		} else {
			this._state = IN_CLOSING_TAG_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInCloseingTagName = function(c){
		if(c === ">" || whitespace(c)){
			this._emitToken("onclosetag");
			this._state = AFTER_CLOSING_TAG_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateAfterCloseingTagName = function(c){
		//skip everything until ">"
		if(c === ">"){
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		}
	};
	
	Tokenizer.prototype._stateBeforeAttributeName = function(c){
		if(c === ">"){
			this._cbs.onopentagend();
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(c === "/"){
			this._state = IN_SELF_CLOSING_TAG;
		} else if(!whitespace(c)){
			this._state = IN_ATTRIBUTE_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInSelfClosingTag = function(c){
		if(c === ">"){
			this._cbs.onselfclosingtag();
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(!whitespace(c)){
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateInAttributeName = function(c){
		if(c === "=" || c === "/" || c === ">" || whitespace(c)){
			this._cbs.onattribname(this._getSection());
			this._sectionStart = -1;
			this._state = AFTER_ATTRIBUTE_NAME;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateAfterAttributeName = function(c){
		if(c === "="){
			this._state = BEFORE_ATTRIBUTE_VALUE;
		} else if(c === "/" || c === ">"){
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		} else if(!whitespace(c)){
			this._cbs.onattribend();
			this._state = IN_ATTRIBUTE_NAME;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateBeforeAttributeValue = function(c){
		if(c === "\""){
			this._state = IN_ATTRIBUTE_VALUE_DQ;
			this._sectionStart = this._index + 1;
		} else if(c === "'"){
			this._state = IN_ATTRIBUTE_VALUE_SQ;
			this._sectionStart = this._index + 1;
		} else if(!whitespace(c)){
			this._state = IN_ATTRIBUTE_VALUE_NQ;
			this._sectionStart = this._index;
			this._index--; //reconsume token
		}
	};
	
	Tokenizer.prototype._stateInAttributeValueDoubleQuotes = function(c){
		if(c === "\""){
			this._emitToken("onattribdata");
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
		} else if(this._decodeEntities && c === "&"){
			this._emitToken("onattribdata");
			this._baseState = this._state;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInAttributeValueSingleQuotes = function(c){
		if(c === "'"){
			this._emitToken("onattribdata");
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
		} else if(this._decodeEntities && c === "&"){
			this._emitToken("onattribdata");
			this._baseState = this._state;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateInAttributeValueNoQuotes = function(c){
		if(whitespace(c) || c === ">"){
			this._emitToken("onattribdata");
			this._cbs.onattribend();
			this._state = BEFORE_ATTRIBUTE_NAME;
			this._index--;
		} else if(this._decodeEntities && c === "&"){
			this._emitToken("onattribdata");
			this._baseState = this._state;
			this._state = BEFORE_ENTITY;
			this._sectionStart = this._index;
		}
	};
	
	Tokenizer.prototype._stateBeforeDeclaration = function(c){
		this._state = c === "[" ? BEFORE_CDATA_1 :
						c === "-" ? BEFORE_COMMENT :
							IN_DECLARATION;
	};
	
	Tokenizer.prototype._stateInDeclaration = function(c){
		if(c === ">"){
			this._cbs.ondeclaration(this._getSection());
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		}
	};
	
	Tokenizer.prototype._stateInProcessingInstruction = function(c){
		if(c === ">"){
			this._cbs.onprocessinginstruction(this._getSection());
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		}
	};
	
	Tokenizer.prototype._stateBeforeComment = function(c){
		if(c === "-"){
			this._state = IN_COMMENT;
			this._sectionStart = this._index + 1;
		} else {
			this._state = IN_DECLARATION;
		}
	};
	
	Tokenizer.prototype._stateInComment = function(c){
		if(c === "-") this._state = AFTER_COMMENT_1;
	};
	
	Tokenizer.prototype._stateAfterComment1 = function(c){
		if(c === "-"){
			this._state = AFTER_COMMENT_2;
		} else {
			this._state = IN_COMMENT;
		}
	};
	
	Tokenizer.prototype._stateAfterComment2 = function(c){
		if(c === ">"){
			//remove 2 trailing chars
			this._cbs.oncomment(this._buffer.substring(this._sectionStart, this._index - 2));
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(c !== "-"){
			this._state = IN_COMMENT;
		}
		// else: stay in AFTER_COMMENT_2 (`--->`)
	};
	
	Tokenizer.prototype._stateBeforeCdata1 = ifElseState("C", BEFORE_CDATA_2, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata2 = ifElseState("D", BEFORE_CDATA_3, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata3 = ifElseState("A", BEFORE_CDATA_4, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata4 = ifElseState("T", BEFORE_CDATA_5, IN_DECLARATION);
	Tokenizer.prototype._stateBeforeCdata5 = ifElseState("A", BEFORE_CDATA_6, IN_DECLARATION);
	
	Tokenizer.prototype._stateBeforeCdata6 = function(c){
		if(c === "["){
			this._state = IN_CDATA;
			this._sectionStart = this._index + 1;
		} else {
			this._state = IN_DECLARATION;
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateInCdata = function(c){
		if(c === "]") this._state = AFTER_CDATA_1;
	};
	
	Tokenizer.prototype._stateAfterCdata1 = characterState("]", AFTER_CDATA_2);
	
	Tokenizer.prototype._stateAfterCdata2 = function(c){
		if(c === ">"){
			//remove 2 trailing chars
			this._cbs.oncdata(this._buffer.substring(this._sectionStart, this._index - 2));
			this._state = TEXT;
			this._sectionStart = this._index + 1;
		} else if(c !== "]") {
			this._state = IN_CDATA;
		}
		//else: stay in AFTER_CDATA_2 (`]]]>`)
	};
	
	Tokenizer.prototype._stateBeforeSpecial = function(c){
		if(c === "c" || c === "C"){
			this._state = BEFORE_SCRIPT_1;
		} else if(c === "t" || c === "T"){
			this._state = BEFORE_STYLE_1;
		} else {
			this._state = IN_TAG_NAME;
			this._index--; //consume the token again
		}
	};
	
	Tokenizer.prototype._stateBeforeSpecialEnd = function(c){
		if(this._special === SPECIAL_SCRIPT && (c === "c" || c === "C")){
			this._state = AFTER_SCRIPT_1;
		} else if(this._special === SPECIAL_STYLE && (c === "t" || c === "T")){
			this._state = AFTER_STYLE_1;
		}
		else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeScript1 = consumeSpecialNameChar("R", BEFORE_SCRIPT_2);
	Tokenizer.prototype._stateBeforeScript2 = consumeSpecialNameChar("I", BEFORE_SCRIPT_3);
	Tokenizer.prototype._stateBeforeScript3 = consumeSpecialNameChar("P", BEFORE_SCRIPT_4);
	Tokenizer.prototype._stateBeforeScript4 = consumeSpecialNameChar("T", BEFORE_SCRIPT_5);
	
	Tokenizer.prototype._stateBeforeScript5 = function(c){
		if(c === "/" || c === ">" || whitespace(c)){
			this._special = SPECIAL_SCRIPT;
		}
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterScript1 = ifElseState("R", AFTER_SCRIPT_2, TEXT);
	Tokenizer.prototype._stateAfterScript2 = ifElseState("I", AFTER_SCRIPT_3, TEXT);
	Tokenizer.prototype._stateAfterScript3 = ifElseState("P", AFTER_SCRIPT_4, TEXT);
	Tokenizer.prototype._stateAfterScript4 = ifElseState("T", AFTER_SCRIPT_5, TEXT);
	
	Tokenizer.prototype._stateAfterScript5 = function(c){
		if(c === ">" || whitespace(c)){
			this._special = SPECIAL_NONE;
			this._state = IN_CLOSING_TAG_NAME;
			this._sectionStart = this._index - 6;
			this._index--; //reconsume the token
		}
		else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeStyle1 = consumeSpecialNameChar("Y", BEFORE_STYLE_2);
	Tokenizer.prototype._stateBeforeStyle2 = consumeSpecialNameChar("L", BEFORE_STYLE_3);
	Tokenizer.prototype._stateBeforeStyle3 = consumeSpecialNameChar("E", BEFORE_STYLE_4);
	
	Tokenizer.prototype._stateBeforeStyle4 = function(c){
		if(c === "/" || c === ">" || whitespace(c)){
			this._special = SPECIAL_STYLE;
		}
		this._state = IN_TAG_NAME;
		this._index--; //consume the token again
	};
	
	Tokenizer.prototype._stateAfterStyle1 = ifElseState("Y", AFTER_STYLE_2, TEXT);
	Tokenizer.prototype._stateAfterStyle2 = ifElseState("L", AFTER_STYLE_3, TEXT);
	Tokenizer.prototype._stateAfterStyle3 = ifElseState("E", AFTER_STYLE_4, TEXT);
	
	Tokenizer.prototype._stateAfterStyle4 = function(c){
		if(c === ">" || whitespace(c)){
			this._special = SPECIAL_NONE;
			this._state = IN_CLOSING_TAG_NAME;
			this._sectionStart = this._index - 5;
			this._index--; //reconsume the token
		}
		else this._state = TEXT;
	};
	
	Tokenizer.prototype._stateBeforeEntity = ifElseState("#", BEFORE_NUMERIC_ENTITY, IN_NAMED_ENTITY);
	Tokenizer.prototype._stateBeforeNumericEntity = ifElseState("X", IN_HEX_ENTITY, IN_NUMERIC_ENTITY);
	
	//for entities terminated with a semicolon
	Tokenizer.prototype._parseNamedEntityStrict = function(){
		//offset = 1
		if(this._sectionStart + 1 < this._index){
			var entity = this._buffer.substring(this._sectionStart + 1, this._index),
			    map = this._xmlMode ? xmlMap : entityMap;
	
			if(map.hasOwnProperty(entity)){
				this._emitPartial(map[entity]);
				this._sectionStart = this._index + 1;
			}
		}
	};
	
	
	//parses legacy entities (without trailing semicolon)
	Tokenizer.prototype._parseLegacyEntity = function(){
		var start = this._sectionStart + 1,
		    limit = this._index - start;
	
		if(limit > 6) limit = 6; //the max length of legacy entities is 6
	
		while(limit >= 2){ //the min length of legacy entities is 2
			var entity = this._buffer.substr(start, limit);
	
			if(legacyMap.hasOwnProperty(entity)){
				this._emitPartial(legacyMap[entity]);
				this._sectionStart += limit + 1;
				return;
			} else {
				limit--;
			}
		}
	};
	
	Tokenizer.prototype._stateInNamedEntity = function(c){
		if(c === ";"){
			this._parseNamedEntityStrict();
			if(this._sectionStart + 1 < this._index && !this._xmlMode){
				this._parseLegacyEntity();
			}
			this._state = this._baseState;
		} else if((c < "a" || c > "z") && (c < "A" || c > "Z") && (c < "0" || c > "9")){
			if(this._xmlMode);
			else if(this._sectionStart + 1 === this._index);
			else if(this._baseState !== TEXT){
				if(c !== "="){
					this._parseNamedEntityStrict();
				}
			} else {
				this._parseLegacyEntity();
			}
	
			this._state = this._baseState;
			this._index--;
		}
	};
	
	Tokenizer.prototype._decodeNumericEntity = function(offset, base){
		var sectionStart = this._sectionStart + offset;
	
		if(sectionStart !== this._index){
			//parse entity
			var entity = this._buffer.substring(sectionStart, this._index);
			var parsed = parseInt(entity, base);
	
			this._emitPartial(decodeCodePoint(parsed));
			this._sectionStart = this._index;
		} else {
			this._sectionStart--;
		}
	
		this._state = this._baseState;
	};
	
	Tokenizer.prototype._stateInNumericEntity = function(c){
		if(c === ";"){
			this._decodeNumericEntity(2, 10);
			this._sectionStart++;
		} else if(c < "0" || c > "9"){
			if(!this._xmlMode){
				this._decodeNumericEntity(2, 10);
			} else {
				this._state = this._baseState;
			}
			this._index--;
		}
	};
	
	Tokenizer.prototype._stateInHexEntity = function(c){
		if(c === ";"){
			this._decodeNumericEntity(3, 16);
			this._sectionStart++;
		} else if((c < "a" || c > "f") && (c < "A" || c > "F") && (c < "0" || c > "9")){
			if(!this._xmlMode){
				this._decodeNumericEntity(3, 16);
			} else {
				this._state = this._baseState;
			}
			this._index--;
		}
	};
	
	Tokenizer.prototype._cleanup = function (){
		if(this._sectionStart < 0){
			this._buffer = "";
			this._bufferOffset += this._index;
			this._index = 0;
		} else if(this._running){
			if(this._state === TEXT){
				if(this._sectionStart !== this._index){
					this._cbs.ontext(this._buffer.substr(this._sectionStart));
				}
				this._buffer = "";
				this._bufferOffset += this._index;
				this._index = 0;
			} else if(this._sectionStart === this._index){
				//the section just started
				this._buffer = "";
				this._bufferOffset += this._index;
				this._index = 0;
			} else {
				//remove everything unnecessary
				this._buffer = this._buffer.substr(this._sectionStart);
				this._index -= this._sectionStart;
				this._bufferOffset += this._sectionStart;
			}
	
			this._sectionStart = 0;
		}
	};
	
	//TODO make events conditional
	Tokenizer.prototype.write = function(chunk){
		if(this._ended) this._cbs.onerror(Error(".write() after done!"));
	
		this._buffer += chunk;
		this._parse();
	};
	
	Tokenizer.prototype._parse = function(){
		while(this._index < this._buffer.length && this._running){
			var c = this._buffer.charAt(this._index);
			if(this._state === TEXT) {
				this._stateText(c);
			} else if(this._state === BEFORE_TAG_NAME){
				this._stateBeforeTagName(c);
			} else if(this._state === IN_TAG_NAME) {
				this._stateInTagName(c);
			} else if(this._state === BEFORE_CLOSING_TAG_NAME){
				this._stateBeforeCloseingTagName(c);
			} else if(this._state === IN_CLOSING_TAG_NAME){
				this._stateInCloseingTagName(c);
			} else if(this._state === AFTER_CLOSING_TAG_NAME){
				this._stateAfterCloseingTagName(c);
			} else if(this._state === IN_SELF_CLOSING_TAG){
				this._stateInSelfClosingTag(c);
			}
	
			/*
			*	attributes
			*/
			else if(this._state === BEFORE_ATTRIBUTE_NAME){
				this._stateBeforeAttributeName(c);
			} else if(this._state === IN_ATTRIBUTE_NAME){
				this._stateInAttributeName(c);
			} else if(this._state === AFTER_ATTRIBUTE_NAME){
				this._stateAfterAttributeName(c);
			} else if(this._state === BEFORE_ATTRIBUTE_VALUE){
				this._stateBeforeAttributeValue(c);
			} else if(this._state === IN_ATTRIBUTE_VALUE_DQ){
				this._stateInAttributeValueDoubleQuotes(c);
			} else if(this._state === IN_ATTRIBUTE_VALUE_SQ){
				this._stateInAttributeValueSingleQuotes(c);
			} else if(this._state === IN_ATTRIBUTE_VALUE_NQ){
				this._stateInAttributeValueNoQuotes(c);
			}
	
			/*
			*	declarations
			*/
			else if(this._state === BEFORE_DECLARATION){
				this._stateBeforeDeclaration(c);
			} else if(this._state === IN_DECLARATION){
				this._stateInDeclaration(c);
			}
	
			/*
			*	processing instructions
			*/
			else if(this._state === IN_PROCESSING_INSTRUCTION){
				this._stateInProcessingInstruction(c);
			}
	
			/*
			*	comments
			*/
			else if(this._state === BEFORE_COMMENT){
				this._stateBeforeComment(c);
			} else if(this._state === IN_COMMENT){
				this._stateInComment(c);
			} else if(this._state === AFTER_COMMENT_1){
				this._stateAfterComment1(c);
			} else if(this._state === AFTER_COMMENT_2){
				this._stateAfterComment2(c);
			}
	
			/*
			*	cdata
			*/
			else if(this._state === BEFORE_CDATA_1){
				this._stateBeforeCdata1(c);
			} else if(this._state === BEFORE_CDATA_2){
				this._stateBeforeCdata2(c);
			} else if(this._state === BEFORE_CDATA_3){
				this._stateBeforeCdata3(c);
			} else if(this._state === BEFORE_CDATA_4){
				this._stateBeforeCdata4(c);
			} else if(this._state === BEFORE_CDATA_5){
				this._stateBeforeCdata5(c);
			} else if(this._state === BEFORE_CDATA_6){
				this._stateBeforeCdata6(c);
			} else if(this._state === IN_CDATA){
				this._stateInCdata(c);
			} else if(this._state === AFTER_CDATA_1){
				this._stateAfterCdata1(c);
			} else if(this._state === AFTER_CDATA_2){
				this._stateAfterCdata2(c);
			}
	
			/*
			* special tags
			*/
			else if(this._state === BEFORE_SPECIAL){
				this._stateBeforeSpecial(c);
			} else if(this._state === BEFORE_SPECIAL_END){
				this._stateBeforeSpecialEnd(c);
			}
	
			/*
			* script
			*/
			else if(this._state === BEFORE_SCRIPT_1){
				this._stateBeforeScript1(c);
			} else if(this._state === BEFORE_SCRIPT_2){
				this._stateBeforeScript2(c);
			} else if(this._state === BEFORE_SCRIPT_3){
				this._stateBeforeScript3(c);
			} else if(this._state === BEFORE_SCRIPT_4){
				this._stateBeforeScript4(c);
			} else if(this._state === BEFORE_SCRIPT_5){
				this._stateBeforeScript5(c);
			}
	
			else if(this._state === AFTER_SCRIPT_1){
				this._stateAfterScript1(c);
			} else if(this._state === AFTER_SCRIPT_2){
				this._stateAfterScript2(c);
			} else if(this._state === AFTER_SCRIPT_3){
				this._stateAfterScript3(c);
			} else if(this._state === AFTER_SCRIPT_4){
				this._stateAfterScript4(c);
			} else if(this._state === AFTER_SCRIPT_5){
				this._stateAfterScript5(c);
			}
	
			/*
			* style
			*/
			else if(this._state === BEFORE_STYLE_1){
				this._stateBeforeStyle1(c);
			} else if(this._state === BEFORE_STYLE_2){
				this._stateBeforeStyle2(c);
			} else if(this._state === BEFORE_STYLE_3){
				this._stateBeforeStyle3(c);
			} else if(this._state === BEFORE_STYLE_4){
				this._stateBeforeStyle4(c);
			}
	
			else if(this._state === AFTER_STYLE_1){
				this._stateAfterStyle1(c);
			} else if(this._state === AFTER_STYLE_2){
				this._stateAfterStyle2(c);
			} else if(this._state === AFTER_STYLE_3){
				this._stateAfterStyle3(c);
			} else if(this._state === AFTER_STYLE_4){
				this._stateAfterStyle4(c);
			}
	
			/*
			* entities
			*/
			else if(this._state === BEFORE_ENTITY){
				this._stateBeforeEntity(c);
			} else if(this._state === BEFORE_NUMERIC_ENTITY){
				this._stateBeforeNumericEntity(c);
			} else if(this._state === IN_NAMED_ENTITY){
				this._stateInNamedEntity(c);
			} else if(this._state === IN_NUMERIC_ENTITY){
				this._stateInNumericEntity(c);
			} else if(this._state === IN_HEX_ENTITY){
				this._stateInHexEntity(c);
			}
	
			else {
				this._cbs.onerror(Error("unknown _state"), this._state);
			}
	
			this._index++;
		}
	
		this._cleanup();
	};
	
	Tokenizer.prototype.pause = function(){
		this._running = false;
	};
	Tokenizer.prototype.resume = function(){
		this._running = true;
	
		if(this._index < this._buffer.length){
			this._parse();
		}
		if(this._ended){
			this._finish();
		}
	};
	
	Tokenizer.prototype.end = function(chunk){
		if(this._ended) this._cbs.onerror(Error(".end() after done!"));
		if(chunk) this.write(chunk);
	
		this._ended = true;
	
		if(this._running) this._finish();
	};
	
	Tokenizer.prototype._finish = function(){
		//if there is remaining data, emit it in a reasonable way
		if(this._sectionStart < this._index){
			this._handleTrailingData();
		}
	
		this._cbs.onend();
	};
	
	Tokenizer.prototype._handleTrailingData = function(){
		var data = this._buffer.substr(this._sectionStart);
	
		if(this._state === IN_CDATA || this._state === AFTER_CDATA_1 || this._state === AFTER_CDATA_2){
			this._cbs.oncdata(data);
		} else if(this._state === IN_COMMENT || this._state === AFTER_COMMENT_1 || this._state === AFTER_COMMENT_2){
			this._cbs.oncomment(data);
		} else if(this._state === IN_NAMED_ENTITY && !this._xmlMode){
			this._parseLegacyEntity();
			if(this._sectionStart < this._index){
				this._state = this._baseState;
				this._handleTrailingData();
			}
		} else if(this._state === IN_NUMERIC_ENTITY && !this._xmlMode){
			this._decodeNumericEntity(2, 10);
			if(this._sectionStart < this._index){
				this._state = this._baseState;
				this._handleTrailingData();
			}
		} else if(this._state === IN_HEX_ENTITY && !this._xmlMode){
			this._decodeNumericEntity(3, 16);
			if(this._sectionStart < this._index){
				this._state = this._baseState;
				this._handleTrailingData();
			}
		} else if(
			this._state !== IN_TAG_NAME &&
			this._state !== BEFORE_ATTRIBUTE_NAME &&
			this._state !== BEFORE_ATTRIBUTE_VALUE &&
			this._state !== AFTER_ATTRIBUTE_NAME &&
			this._state !== IN_ATTRIBUTE_NAME &&
			this._state !== IN_ATTRIBUTE_VALUE_SQ &&
			this._state !== IN_ATTRIBUTE_VALUE_DQ &&
			this._state !== IN_ATTRIBUTE_VALUE_NQ &&
			this._state !== IN_CLOSING_TAG_NAME
		){
			this._cbs.ontext(data);
		}
		//else, ignore remaining data
		//TODO add a way to remove current tag
	};
	
	Tokenizer.prototype.reset = function(){
		Tokenizer.call(this, {xmlMode: this._xmlMode, decodeEntities: this._decodeEntities}, this._cbs);
	};
	
	Tokenizer.prototype.getAbsoluteIndex = function(){
		return this._bufferOffset + this._index;
	};
	
	Tokenizer.prototype._getSection = function(){
		return this._buffer.substring(this._sectionStart, this._index);
	};
	
	Tokenizer.prototype._emitToken = function(name){
		this._cbs[name](this._getSection());
		this._sectionStart = -1;
	};
	
	Tokenizer.prototype._emitPartial = function(value){
		if(this._baseState !== TEXT){
			this._cbs.onattribdata(value); //TODO implement the new event
		} else {
			this._cbs.ontext(value);
		}
	};


/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(281),
	    WritableStream = __webpack_require__(2000).Writable || __webpack_require__(2033).Writable,
	    StringDecoder = __webpack_require__(247).StringDecoder,
	    Buffer = __webpack_require__(123).Buffer;
	
	function Stream(cbs, options){
		var parser = this._parser = new Parser(cbs, options);
		var decoder = this._decoder = new StringDecoder();
	
		WritableStream.call(this, {decodeStrings: false});
	
		this.once("finish", function(){
			parser.end(decoder.end());
		});
	}
	
	__webpack_require__(38)(Stream, WritableStream);
	
	WritableStream.prototype._write = function(chunk, encoding, cb){
		if(chunk instanceof Buffer) chunk = this._decoder.write(chunk);
		this._parser.write(chunk);
		cb();
	};

/***/ },
/* 284 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = addNewValuesOnly;
	function addIfNew(list, value) {
	  if (list.indexOf(value) === -1) {
	    list.push(value);
	  }
	}
	
	function addNewValuesOnly(list, values) {
	  if (Array.isArray(values)) {
	    for (var i = 0, len = values.length; i < len; ++i) {
	      addIfNew(list, values[i]);
	    }
	  } else {
	    addIfNew(list, values);
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 285 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isObject;
	function isObject(value) {
	  return value instanceof Object && !Array.isArray(value);
	}
	module.exports = exports["default"];

/***/ },
/* 286 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixValue;
	function prefixValue(plugins, property, value, style, metaData) {
	  for (var i = 0, len = plugins.length; i < len; ++i) {
	    var processedValue = plugins[i](property, value, style, metaData);
	
	    // we can stop processing if a value is returned
	    // as all plugin criteria are unique
	    if (processedValue) {
	      return processedValue;
	    }
	  }
	}
	module.exports = exports["default"];

/***/ },
/* 287 */
/***/ function(module, exports) {

	var toString = {}.toString;
	
	module.exports = Array.isArray || function (arr) {
	  return toString.call(arr) == '[object Array]';
	};


/***/ },
/* 288 */
/***/ function(module, exports) {

	module.exports = {
		"universal": 50,
		"tag": 30,
		"attribute": 1,
		"pseudo": 0,
		"descendant": -1,
		"child": -1,
		"parent": -1,
		"sibling": -1,
		"adjacent": -1
	};

/***/ },
/* 289 */
/***/ function(module, exports) {

	module.exports = {
		"Aacute": "Á",
		"aacute": "á",
		"Acirc": "Â",
		"acirc": "â",
		"acute": "´",
		"AElig": "Æ",
		"aelig": "æ",
		"Agrave": "À",
		"agrave": "à",
		"amp": "&",
		"AMP": "&",
		"Aring": "Å",
		"aring": "å",
		"Atilde": "Ã",
		"atilde": "ã",
		"Auml": "Ä",
		"auml": "ä",
		"brvbar": "¦",
		"Ccedil": "Ç",
		"ccedil": "ç",
		"cedil": "¸",
		"cent": "¢",
		"copy": "©",
		"COPY": "©",
		"curren": "¤",
		"deg": "°",
		"divide": "÷",
		"Eacute": "É",
		"eacute": "é",
		"Ecirc": "Ê",
		"ecirc": "ê",
		"Egrave": "È",
		"egrave": "è",
		"ETH": "Ð",
		"eth": "ð",
		"Euml": "Ë",
		"euml": "ë",
		"frac12": "½",
		"frac14": "¼",
		"frac34": "¾",
		"gt": ">",
		"GT": ">",
		"Iacute": "Í",
		"iacute": "í",
		"Icirc": "Î",
		"icirc": "î",
		"iexcl": "¡",
		"Igrave": "Ì",
		"igrave": "ì",
		"iquest": "¿",
		"Iuml": "Ï",
		"iuml": "ï",
		"laquo": "«",
		"lt": "<",
		"LT": "<",
		"macr": "¯",
		"micro": "µ",
		"middot": "·",
		"nbsp": " ",
		"not": "¬",
		"Ntilde": "Ñ",
		"ntilde": "ñ",
		"Oacute": "Ó",
		"oacute": "ó",
		"Ocirc": "Ô",
		"ocirc": "ô",
		"Ograve": "Ò",
		"ograve": "ò",
		"ordf": "ª",
		"ordm": "º",
		"Oslash": "Ø",
		"oslash": "ø",
		"Otilde": "Õ",
		"otilde": "õ",
		"Ouml": "Ö",
		"ouml": "ö",
		"para": "¶",
		"plusmn": "±",
		"pound": "£",
		"quot": "\"",
		"QUOT": "\"",
		"raquo": "»",
		"reg": "®",
		"REG": "®",
		"sect": "§",
		"shy": "­",
		"sup1": "¹",
		"sup2": "²",
		"sup3": "³",
		"szlig": "ß",
		"THORN": "Þ",
		"thorn": "þ",
		"times": "×",
		"Uacute": "Ú",
		"uacute": "ú",
		"Ucirc": "Û",
		"ucirc": "û",
		"Ugrave": "Ù",
		"ugrave": "ù",
		"uml": "¨",
		"Uuml": "Ü",
		"uuml": "ü",
		"Yacute": "Ý",
		"yacute": "ý",
		"yen": "¥",
		"yuml": "ÿ"
	};

/***/ },
/* 290 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Sheets registry to access them all at one place.
	 */
	var SheetsRegistry = function () {
	  function SheetsRegistry() {
	    _classCallCheck(this, SheetsRegistry);
	
	    this.registry = [];
	  }
	
	  _createClass(SheetsRegistry, [{
	    key: 'add',
	
	
	    /**
	     * Register a Style Sheet.
	     */
	    value: function add(sheet) {
	      var registry = this.registry;
	      var index = sheet.options.index;
	
	
	      if (registry.indexOf(sheet) !== -1) return;
	
	      if (registry.length === 0 || index >= this.index) {
	        registry.push(sheet);
	        return;
	      }
	
	      // Find a position.
	      for (var i = 0; i < registry.length; i++) {
	        if (registry[i].options.index > index) {
	          registry.splice(i, 0, sheet);
	          return;
	        }
	      }
	    }
	
	    /**
	     * Reset the registry.
	     */
	
	  }, {
	    key: 'reset',
	    value: function reset() {
	      this.registry = [];
	    }
	
	    /**
	     * Remove a Style Sheet.
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(sheet) {
	      var index = this.registry.indexOf(sheet);
	      this.registry.splice(index, 1);
	    }
	
	    /**
	     * Convert all attached sheets to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      return this.registry.filter(function (sheet) {
	        return sheet.attached;
	      }).map(function (sheet) {
	        return sheet.toString(options);
	      }).join('\n');
	    }
	  }, {
	    key: 'index',
	
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	exports['default'] = SheetsRegistry;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = createRule;
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _RegularRule = __webpack_require__(626);
	
	var _RegularRule2 = _interopRequireDefault(_RegularRule);
	
	var _cloneStyle = __webpack_require__(630);
	
	var _cloneStyle2 = _interopRequireDefault(_cloneStyle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Create a rule instance.
	 */
	function createRule(name, decl, options) {
	  var jss = options.jss;
	
	  var declCopy = (0, _cloneStyle2['default'])(decl);
	
	  if (jss) {
	    var rule = jss.plugins.onCreateRule(name, declCopy, options);
	    if (rule) return rule;
	  }
	
	  // It is an at-rule and it has no instance.
	  if (name && name[0] === '@') {
	    (0, _warning2['default'])(false, '[JSS] Unknown at-rule %s', name);
	  }
	
	  return new _RegularRule2['default'](name, declCopy, options);
	}

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = findRenderer;
	
	var _isInBrowser = __webpack_require__(612);
	
	var _isInBrowser2 = _interopRequireDefault(_isInBrowser);
	
	var _DomRenderer = __webpack_require__(620);
	
	var _DomRenderer2 = _interopRequireDefault(_DomRenderer);
	
	var _VirtualRenderer = __webpack_require__(621);
	
	var _VirtualRenderer2 = _interopRequireDefault(_VirtualRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Find proper renderer.
	 * Option `virtual` is used to force use of VirtualRenderer even if DOM is
	 * detected, used for testing only.
	 */
	function findRenderer() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	  if (options.Renderer) return options.Renderer;
	  var useVirtual = options.virtual || !_isInBrowser2['default'];
	  return useVirtual ? _VirtualRenderer2['default'] : _DomRenderer2['default'];
	}

/***/ },
/* 293 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports["default"] = linkRule;
	/**
	 * Link rule with CSSStyleRule and nested rules with corresponding nested cssRules if both exists.
	 */
	function linkRule(rule, cssRule) {
	  rule.renderable = cssRule;
	  if (rule.rules && cssRule.cssRules) rule.rules.link(cssRule.cssRules);
	}

/***/ },
/* 294 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = toCssValue;
	var joinWithSpace = function joinWithSpace(value) {
	  return value.join(' '
	
	  /**
	   * Converts array values to string.
	   *
	   * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	   * `border: ['1px', '2px']` > `border: 1px, 2px;`
	   */
	  );
	};function toCssValue(value) {
	  if (!Array.isArray(value)) return value;
	
	  // Support space separated values.
	  if (Array.isArray(value[0])) {
	    return toCssValue(value.map(joinWithSpace));
	  }
	
	  return value.join(', ');
	}

/***/ },
/* 295 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = assignIn;


/***/ },
/* 296 */
/***/ function(module, exports) {

	/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var propertyIsEnumerable = objectProto.propertyIsEnumerable;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function assignInDefaults(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * This method is like `_.assignIn` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extendWith
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignInWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignInWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keysIn(source), object, customizer);
	});
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(args) {
	  args.push(undefined, assignInDefaults);
	  return apply(assignInWith, undefined, args);
	});
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	module.exports = defaults;


/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to infer the `Object` constructor. */
	var objectCtorString = funcToString.call(Object);
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    getPrototype = overArg(Object.getPrototypeOf, Object),
	    objectCreate = Object.create,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols,
	    nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
	    nativeKeys = overArg(Object.keys, Object),
	    nativeMax = Math.max;
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (typeof key == 'number' && value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Assigns `value` to `key` of `object` if the existing value is not equivalent
	 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * for equality comparisons.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignValue(object, key, value) {
	  var objValue = object[key];
	  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
	      (value === undefined && !(key in object))) {
	    object[key] = value;
	  }
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @param {boolean} [isFull] Specify a clone including symbols.
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, isDeep, isFull, customizer, key, object, stack) {
	  var result;
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      if (isHostObject(value)) {
	        return object ? value : {};
	      }
	      result = initCloneObject(isFunc ? {} : value);
	      if (!isDeep) {
	        return copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  if (!isArr) {
	    var props = isFull ? getAllKeys(value) : keys(value);
	  }
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, isDeep, isFull, customizer, key, value, stack));
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.create` without support for assigning
	 * properties to the created object.
	 *
	 * @private
	 * @param {Object} prototype The object to inherit from.
	 * @returns {Object} Returns the new object.
	 */
	function baseCreate(proto) {
	  return isObject(proto) ? objectCreate(proto) : {};
	}
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.merge` without support for multiple sources.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} [customizer] The function to customize merged values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMerge(object, source, srcIndex, customizer, stack) {
	  if (object === source) {
	    return;
	  }
	  if (!(isArray(source) || isTypedArray(source))) {
	    var props = baseKeysIn(source);
	  }
	  arrayEach(props || source, function(srcValue, key) {
	    if (props) {
	      key = srcValue;
	      srcValue = source[key];
	    }
	    if (isObject(srcValue)) {
	      stack || (stack = new Stack);
	      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
	    }
	    else {
	      var newValue = customizer
	        ? customizer(object[key], srcValue, (key + ''), object, source, stack)
	        : undefined;
	
	      if (newValue === undefined) {
	        newValue = srcValue;
	      }
	      assignMergeValue(object, key, newValue);
	    }
	  });
	}
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    newValue = srcValue;
	    if (isArray(srcValue) || isTypedArray(srcValue)) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        isCommon = false;
	        newValue = baseClone(srcValue, true);
	      }
	      else {
	        newValue = objValue;
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var result = new buffer.constructor(buffer.length);
	  buffer.copy(result);
	  return result;
	}
	
	/**
	 * Creates a clone of `arrayBuffer`.
	 *
	 * @private
	 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
	 * @returns {ArrayBuffer} Returns the cloned array buffer.
	 */
	function cloneArrayBuffer(arrayBuffer) {
	  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
	  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
	  return result;
	}
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), true) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), true) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	/**
	 * Copies properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy properties from.
	 * @param {Array} props The property identifiers to copy.
	 * @param {Object} [object={}] The object to copy properties to.
	 * @param {Function} [customizer] The function to customize copied values.
	 * @returns {Object} Returns `object`.
	 */
	function copyObject(source, props, object, customizer) {
	  object || (object = {});
	
	  var index = -1,
	      length = props.length;
	
	  while (++index < length) {
	    var key = props[index];
	
	    var newValue = customizer
	      ? customizer(object[key], source[key], key, object, source)
	      : undefined;
	
	    assignValue(object, key, newValue === undefined ? source[key] : newValue);
	  }
	  return object;
	}
	
	/**
	 * Copies own symbol properties of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	/**
	 * Creates a function like `_.assign`.
	 *
	 * @private
	 * @param {Function} assigner The function to assign values.
	 * @returns {Function} Returns the new assigner function.
	 */
	function createAssigner(assigner) {
	  return baseRest(function(object, sources) {
	    var index = -1,
	        length = sources.length,
	        customizer = length > 1 ? sources[length - 1] : undefined,
	        guard = length > 2 ? sources[2] : undefined;
	
	    customizer = (assigner.length > 3 && typeof customizer == 'function')
	      ? (length--, customizer)
	      : undefined;
	
	    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
	      customizer = length < 3 ? undefined : customizer;
	      length = 1;
	    }
	    object = Object(object);
	    while (++index < length) {
	      var source = sources[index];
	      if (source) {
	        assigner(object, source, index, customizer);
	      }
	    }
	    return object;
	  });
	}
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Creates an array of the own enumerable symbol properties of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbols = nativeGetSymbols ? overArg(nativeGetSymbols, Object) : stubArray;
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is a buffer.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.3.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
	 * @example
	 *
	 * _.isBuffer(new Buffer(2));
	 * // => true
	 *
	 * _.isBuffer(new Uint8Array(2));
	 * // => false
	 */
	var isBuffer = nativeIsBuffer || stubFalse;
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is a plain object, that is, an object created by the
	 * `Object` constructor or one with a `[[Prototype]]` of `null`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.8.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * _.isPlainObject(new Foo);
	 * // => false
	 *
	 * _.isPlainObject([1, 2, 3]);
	 * // => false
	 *
	 * _.isPlainObject({ 'x': 0, 'y': 0 });
	 * // => true
	 *
	 * _.isPlainObject(Object.create(null));
	 * // => true
	 */
	function isPlainObject(value) {
	  if (!isObjectLike(value) ||
	      objectToString.call(value) != objectTag || isHostObject(value)) {
	    return false;
	  }
	  var proto = getPrototype(value);
	  if (proto === null) {
	    return true;
	  }
	  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
	  return (typeof Ctor == 'function' &&
	    Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * Creates an array of the own and inherited enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keysIn(new Foo);
	 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
	 */
	function keysIn(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
	}
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = merge;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)(module)))

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(41);
	
	/** Built-in value references. */
	var Uint8Array = root.Uint8Array;
	
	module.exports = Uint8Array;


/***/ },
/* 299 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.forEach` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns `array`.
	 */
	function arrayEach(array, iteratee) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (iteratee(array[index], index, array) === false) {
	      break;
	    }
	  }
	  return array;
	}
	
	module.exports = arrayEach;


/***/ },
/* 300 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = arrayFilter;


/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	var baseTimes = __webpack_require__(680),
	    isArguments = __webpack_require__(146),
	    isArray = __webpack_require__(28),
	    isBuffer = __webpack_require__(111),
	    isIndex = __webpack_require__(143),
	    isTypedArray = __webpack_require__(147);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  var isArr = isArray(value),
	      isArg = !isArr && isArguments(value),
	      isBuff = !isArr && !isArg && isBuffer(value),
	      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
	      skipIndexes = isArr || isArg || isBuff || isType,
	      result = skipIndexes ? baseTimes(value.length, String) : [],
	      length = result.length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (
	           // Safari 9 has enumerable `arguments.length` in strict mode.
	           key == 'length' ||
	           // Node.js 0.10 has enumerable non-index properties on buffers.
	           (isBuff && (key == 'offset' || key == 'parent')) ||
	           // PhantomJS 2 has enumerable non-index properties on typed arrays.
	           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
	           // Skip index properties.
	           isIndex(key, length)
	        ))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = arrayLikeKeys;


/***/ },
/* 302 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	module.exports = arrayReduce;


/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(107),
	    eq = __webpack_require__(84);
	
	/**
	 * This function is like `assignValue` except that it doesn't assign
	 * `undefined` values.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {string} key The key of the property to assign.
	 * @param {*} value The value to assign.
	 */
	function assignMergeValue(object, key, value) {
	  if ((value !== undefined && !eq(object[key], value)) ||
	      (value === undefined && !(key in object))) {
	    baseAssignValue(object, key, value);
	  }
	}
	
	module.exports = assignMergeValue;


/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    keys = __webpack_require__(30);
	
	/**
	 * The base implementation of `_.assign` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssign(object, source) {
	  return object && copyObject(source, keys(source), object);
	}
	
	module.exports = baseAssign;


/***/ },
/* 305 */
/***/ function(module, exports) {

	/**
	 * The base implementation of methods like `_.findKey` and `_.findLastKey`,
	 * without support for iteratee shorthands, which iterates over `collection`
	 * using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to inspect.
	 * @param {Function} predicate The function invoked per iteration.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the found element or its key, else `undefined`.
	 */
	function baseFindKey(collection, predicate, eachFunc) {
	  var result;
	  eachFunc(collection, function(value, key, collection) {
	    if (predicate(value, key, collection)) {
	      result = key;
	      return false;
	    }
	  });
	  return result;
	}
	
	module.exports = baseFindKey;


/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	var baseForRight = __webpack_require__(307),
	    keys = __webpack_require__(30);
	
	/**
	 * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwnRight(object, iteratee) {
	  return object && baseForRight(object, iteratee, keys);
	}
	
	module.exports = baseForOwnRight;


/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	var createBaseFor = __webpack_require__(318);
	
	/**
	 * This function is like `baseFor` except that it iterates over properties
	 * in the opposite order.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseForRight = createBaseFor(true);
	
	module.exports = baseForRight;


/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	var arrayFilter = __webpack_require__(300),
	    isFunction = __webpack_require__(85);
	
	/**
	 * The base implementation of `_.functions` which creates an array of
	 * `object` function property names filtered from `props`.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Array} props The property names to filter.
	 * @returns {Array} Returns the function names.
	 */
	function baseFunctions(object, props) {
	  return arrayFilter(props, function(key) {
	    return isFunction(object[key]);
	  });
	}
	
	module.exports = baseFunctions;


/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(195),
	    isArray = __webpack_require__(28);
	
	/**
	 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
	 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
	 * symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @param {Function} symbolsFunc The function to get the symbols of `object`.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function baseGetAllKeys(object, keysFunc, symbolsFunc) {
	  var result = keysFunc(object);
	  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
	}
	
	module.exports = baseGetAllKeys;


/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqualDeep = __webpack_require__(666),
	    isObjectLike = __webpack_require__(62);
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Unordered comparison
	 *  2 - Partial comparison
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, bitmask, customizer, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
	}
	
	module.exports = baseIsEqual;


/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(108),
	    baseSet = __webpack_require__(140),
	    castPath = __webpack_require__(51);
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, paths, predicate) {
	  var index = -1,
	      length = paths.length,
	      result = {};
	
	  while (++index < length) {
	    var path = paths[index],
	        value = baseGet(object, path);
	
	    if (predicate(value, path)) {
	      baseSet(result, castPath(path, object), value);
	    }
	  }
	  return result;
	}
	
	module.exports = basePickBy;


/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(51),
	    last = __webpack_require__(338),
	    parent = __webpack_require__(332),
	    toKey = __webpack_require__(52);
	
	/**
	 * The base implementation of `_.unset`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The property path to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 */
	function baseUnset(object, path) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  return object == null || delete object[toKey(last(path))];
	}
	
	module.exports = baseUnset;


/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(108),
	    baseSet = __webpack_require__(140);
	
	/**
	 * The base implementation of `_.update`.
	 *
	 * @private
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to update.
	 * @param {Function} updater The function to produce the updated value.
	 * @param {Function} [customizer] The function to customize path creation.
	 * @returns {Object} Returns `object`.
	 */
	function baseUpdate(object, path, updater, customizer) {
	  return baseSet(object, path, updater(baseGet(object, path)), customizer);
	}
	
	module.exports = baseUpdate;


/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(106);
	
	/**
	 * The base implementation of `_.values` and `_.valuesIn` which creates an
	 * array of `object` property values corresponding to the property names
	 * of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the array of property values.
	 */
	function baseValues(object, props) {
	  return arrayMap(props, function(key) {
	    return object[key];
	  });
	}
	
	module.exports = baseValues;


/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(41);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Built-in value references. */
	var Buffer = moduleExports ? root.Buffer : undefined,
	    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;
	
	/**
	 * Creates a clone of  `buffer`.
	 *
	 * @private
	 * @param {Buffer} buffer The buffer to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Buffer} Returns the cloned buffer.
	 */
	function cloneBuffer(buffer, isDeep) {
	  if (isDeep) {
	    return buffer.slice();
	  }
	  var length = buffer.length,
	      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
	
	  buffer.copy(result);
	  return result;
	}
	
	module.exports = cloneBuffer;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)(module)))

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(199);
	
	/**
	 * Creates a clone of `typedArray`.
	 *
	 * @private
	 * @param {Object} typedArray The typed array to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned typed array.
	 */
	function cloneTypedArray(typedArray, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
	  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
	}
	
	module.exports = cloneTypedArray;


/***/ },
/* 317 */
/***/ function(module, exports) {

	/**
	 * Copies the values of `source` to `array`.
	 *
	 * @private
	 * @param {Array} source The array to copy values from.
	 * @param {Array} [array=[]] The array to copy values to.
	 * @returns {Array} Returns `array`.
	 */
	function copyArray(source, array) {
	  var index = -1,
	      length = source.length;
	
	  array || (array = Array(length));
	  while (++index < length) {
	    array[index] = source[index];
	  }
	  return array;
	}
	
	module.exports = copyArray;


/***/ },
/* 318 */
/***/ function(module, exports) {

	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	module.exports = createBaseFor;


/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	var baseInverter = __webpack_require__(663);
	
	/**
	 * Creates a function like `_.invertBy`.
	 *
	 * @private
	 * @param {Function} setter The function to set accumulator values.
	 * @param {Function} toIteratee The function to resolve iteratees.
	 * @returns {Function} Returns the new inverter function.
	 */
	function createInverter(setter, toIteratee) {
	  return function(object, iteratee) {
	    return baseInverter(object, setter, toIteratee(iteratee), {});
	  };
	}
	
	module.exports = createInverter;


/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	var baseToPairs = __webpack_require__(681),
	    getTag = __webpack_require__(203),
	    mapToArray = __webpack_require__(205),
	    setToPairs = __webpack_require__(729);
	
	/** `Object#toString` result references. */
	var mapTag = '[object Map]',
	    setTag = '[object Set]';
	
	/**
	 * Creates a `_.toPairs` or `_.toPairsIn` function.
	 *
	 * @private
	 * @param {Function} keysFunc The function to get the keys of a given object.
	 * @returns {Function} Returns the new pairs function.
	 */
	function createToPairs(keysFunc) {
	  return function(object) {
	    var tag = getTag(object);
	    if (tag == mapTag) {
	      return mapToArray(object);
	    }
	    if (tag == setTag) {
	      return setToPairs(object);
	    }
	    return baseToPairs(object, keysFunc(object));
	  };
	}
	
	module.exports = createToPairs;


/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(61);
	
	var defineProperty = (function() {
	  try {
	    var func = getNative(Object, 'defineProperty');
	    func({}, '', {});
	    return func;
	  } catch (e) {}
	}());
	
	module.exports = defineProperty;


/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	var SetCache = __webpack_require__(652),
	    arraySome = __webpack_require__(656),
	    cacheHas = __webpack_require__(684);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!cacheHas(seen, othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
	              return seen.push(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, bitmask, customizer, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalArrays;


/***/ },
/* 323 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	module.exports = freeGlobal;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetAllKeys = __webpack_require__(309),
	    getSymbols = __webpack_require__(202),
	    keys = __webpack_require__(30);
	
	/**
	 * Creates an array of own enumerable property names and symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names and symbols.
	 */
	function getAllKeys(object) {
	  return baseGetAllKeys(object, keys, getSymbols);
	}
	
	module.exports = getAllKeys;


/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(195),
	    getPrototype = __webpack_require__(142),
	    getSymbols = __webpack_require__(202),
	    stubArray = __webpack_require__(341);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeGetSymbols = Object.getOwnPropertySymbols;
	
	/**
	 * Creates an array of the own and inherited enumerable symbols of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of symbols.
	 */
	var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
	  var result = [];
	  while (object) {
	    arrayPush(result, getSymbols(object));
	    object = getPrototype(object);
	  }
	  return result;
	};
	
	module.exports = getSymbolsIn;


/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(51),
	    isArguments = __webpack_require__(146),
	    isArray = __webpack_require__(28),
	    isIndex = __webpack_require__(143),
	    isLength = __webpack_require__(209),
	    toKey = __webpack_require__(52);
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length,
	      result = false;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result || ++index != length) {
	    return result;
	  }
	  length = object == null ? 0 : object.length;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	module.exports = hasPath;


/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	var baseCreate = __webpack_require__(196),
	    getPrototype = __webpack_require__(142),
	    isPrototype = __webpack_require__(144);
	
	/**
	 * Initializes an object clone.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneObject(object) {
	  return (typeof object.constructor == 'function' && !isPrototype(object))
	    ? baseCreate(getPrototype(object))
	    : {};
	}
	
	module.exports = initCloneObject;


/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(29);
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	module.exports = isStrictComparable;


/***/ },
/* 329 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	module.exports = matchesStrictComparable;


/***/ },
/* 330 */
/***/ function(module, exports) {

	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	module.exports = overArg;


/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(136);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * A specialized version of `baseRest` which transforms the rest array.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @param {Function} transform The rest array transform.
	 * @returns {Function} Returns the new function.
	 */
	function overRest(func, start, transform) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = transform(array);
	    return apply(func, this, otherArgs);
	  };
	}
	
	module.exports = overRest;


/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(108),
	    baseSlice = __webpack_require__(679);
	
	/**
	 * Gets the parent value at `path` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} path The path to get the parent value of.
	 * @returns {*} Returns the parent value.
	 */
	function parent(object, path) {
	  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
	}
	
	module.exports = parent;


/***/ },
/* 333 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	module.exports = setToArray;


/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	var baseSetToString = __webpack_require__(678),
	    shortOut = __webpack_require__(730);
	
	/**
	 * Sets the `toString` method of `func` to return `string`.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var setToString = shortOut(baseSetToString);
	
	module.exports = setToString;


/***/ },
/* 335 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var funcProto = Function.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to convert.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	module.exports = toSource;


/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    createAssigner = __webpack_require__(83),
	    keysIn = __webpack_require__(31);
	
	/**
	 * This method is like `_.assign` except that it iterates over own and
	 * inherited source properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias extend
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assign
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assignIn({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
	 */
	var assignIn = createAssigner(function(object, source) {
	  copyObject(source, keysIn(source), object);
	});
	
	module.exports = assignIn;


/***/ },
/* 337 */
/***/ function(module, exports) {

	/**
	 * Creates a function that returns `value`.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {*} value The value to return from the new function.
	 * @returns {Function} Returns the new constant function.
	 * @example
	 *
	 * var objects = _.times(2, _.constant({ 'a': 1 }));
	 *
	 * console.log(objects);
	 * // => [{ 'a': 1 }, { 'a': 1 }]
	 *
	 * console.log(objects[0] === objects[1]);
	 * // => true
	 */
	function constant(value) {
	  return function() {
	    return value;
	  };
	}
	
	module.exports = constant;


/***/ },
/* 338 */
/***/ function(module, exports) {

	/**
	 * Gets the last element of `array`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to query.
	 * @returns {*} Returns the last element of `array`.
	 * @example
	 *
	 * _.last([1, 2, 3]);
	 * // => 3
	 */
	function last(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? array[length - 1] : undefined;
	}
	
	module.exports = last;


/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(198),
	    createAssigner = __webpack_require__(83);
	
	/**
	 * This method is like `_.merge` except that it accepts `customizer` which
	 * is invoked to produce the merged values of the destination and source
	 * properties. If `customizer` returns `undefined`, merging is handled by the
	 * method instead. The `customizer` is invoked with six arguments:
	 * (objValue, srcValue, key, object, source, stack).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} customizer The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   if (_.isArray(objValue)) {
	 *     return objValue.concat(srcValue);
	 *   }
	 * }
	 *
	 * var object = { 'a': [1], 'b': [2] };
	 * var other = { 'a': [3], 'b': [4] };
	 *
	 * _.mergeWith(object, other, customizer);
	 * // => { 'a': [1, 3], 'b': [2, 4] }
	 */
	var mergeWith = createAssigner(function(object, source, srcIndex, customizer) {
	  baseMerge(object, source, srcIndex, customizer);
	});
	
	module.exports = mergeWith;


/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(106),
	    baseIteratee = __webpack_require__(50),
	    basePickBy = __webpack_require__(311),
	    getAllKeysIn = __webpack_require__(201);
	
	/**
	 * Creates an object composed of the `object` properties `predicate` returns
	 * truthy for. The predicate is invoked with two arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pickBy(object, _.isNumber);
	 * // => { 'a': 1, 'c': 3 }
	 */
	function pickBy(object, predicate) {
	  if (object == null) {
	    return {};
	  }
	  var props = arrayMap(getAllKeysIn(object), function(prop) {
	    return [prop];
	  });
	  predicate = baseIteratee(predicate);
	  return basePickBy(object, props, function(value, path) {
	    return predicate(value, path[0]);
	  });
	}
	
	module.exports = pickBy;


/***/ },
/* 341 */
/***/ function(module, exports) {

	/**
	 * This method returns a new empty array.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {Array} Returns the new empty array.
	 * @example
	 *
	 * var arrays = _.times(2, _.stubArray);
	 *
	 * console.log(arrays);
	 * // => [[], []]
	 *
	 * console.log(arrays[0] === arrays[1]);
	 * // => false
	 */
	function stubArray() {
	  return [];
	}
	
	module.exports = stubArray;


/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	var createToPairs = __webpack_require__(320),
	    keys = __webpack_require__(30);
	
	/**
	 * Creates an array of own enumerable string keyed-value pairs for `object`
	 * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
	 * entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entries
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairs(new Foo);
	 * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
	 */
	var toPairs = createToPairs(keys);
	
	module.exports = toPairs;


/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	var createToPairs = __webpack_require__(320),
	    keysIn = __webpack_require__(31);
	
	/**
	 * Creates an array of own and inherited enumerable string keyed-value pairs
	 * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
	 * or set, its entries are returned.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @alias entriesIn
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the key-value pairs.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.toPairsIn(new Foo);
	 * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
	 */
	var toPairsIn = createToPairs(keysIn);
	
	module.exports = toPairsIn;


/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Avatar = __webpack_require__(786);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Avatar2.default;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var selected = props.selected;
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var color = selected ? bottomNavigation.selectedColor : bottomNavigation.unselectedColor;
	
	  var styles = {
	    root: {
	      transition: 'padding-top 0.3s',
	      paddingTop: selected ? 6 : 8,
	      paddingBottom: 10,
	      paddingLeft: 12,
	      paddingRight: 12,
	      minWidth: 80,
	      maxWidth: 168
	    },
	    label: {
	      fontSize: selected ? bottomNavigation.selectedFontSize : bottomNavigation.unselectedFontSize,
	      transition: 'color 0.3s, font-size 0.3s',
	      color: color
	    },
	    icon: {
	      display: 'block',
	      /**
	       * Used to ensure SVG icons are centered
	       */
	      width: '100%'
	    },
	    iconColor: color
	  };
	
	  return styles;
	}
	
	var BottomNavigationItem = function BottomNavigationItem(props, context) {
	  var label = props.label,
	      icon = props.icon,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['label', 'icon', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var styledIcon = (0, _react.cloneElement)(icon, {
	    style: (0, _simpleAssign2.default)({}, styles.icon, icon.props.style),
	    color: icon.props.color || styles.iconColor
	  });
	
	  return _react2.default.createElement(
	    _EnhancedButton2.default,
	    (0, _extends3.default)({}, other, { style: (0, _simpleAssign2.default)({}, styles.root, style) }),
	    styledIcon,
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles(styles.label) },
	      label
	    )
	  );
	};
	
	 false ? BottomNavigationItem.propTypes = {
	  /**
	   * Set the icon representing the view for this item.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Set the label describing the view for this item.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	
	BottomNavigationItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = BottomNavigationItem;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      padding: 8,
	      position: 'relative'
	    },
	    action: {
	      marginRight: 8
	    }
	  };
	}
	
	var CardActions = function (_Component) {
	  (0, _inherits3.default)(CardActions, _Component);
	
	  function CardActions() {
	    (0, _classCallCheck3.default)(this, CardActions);
	    return (0, _possibleConstructorReturn3.default)(this, (CardActions.__proto__ || (0, _getPrototypeOf2.default)(CardActions)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardActions, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            style: (0, _simpleAssign2.default)({}, styles.action, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        styledChildren
	      );
	    }
	  }]);
	  return CardActions;
	}(_react.Component);
	
	CardActions.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? CardActions.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Action.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = CardActions;

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keyboardArrowUp = __webpack_require__(377);
	
	var _keyboardArrowUp2 = _interopRequireDefault(_keyboardArrowUp);
	
	var _keyboardArrowDown = __webpack_require__(376);
	
	var _keyboardArrowDown2 = _interopRequireDefault(_keyboardArrowDown);
	
	var _IconButton = __webpack_require__(86);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles() {
	  return {
	    root: {
	      top: 0,
	      bottom: 0,
	      right: 4,
	      margin: 'auto',
	      position: 'absolute'
	    }
	  };
	}
	
	var CardExpandable = function (_Component) {
	  (0, _inherits3.default)(CardExpandable, _Component);
	
	  function CardExpandable() {
	    (0, _classCallCheck3.default)(this, CardExpandable);
	    return (0, _possibleConstructorReturn3.default)(this, (CardExpandable.__proto__ || (0, _getPrototypeOf2.default)(CardExpandable)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardExpandable, [{
	    key: 'render',
	    value: function render() {
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _IconButton2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          onTouchTap: this.props.onExpanding
	        },
	        this.props.expanded ? this.props.openIcon : this.props.closeIcon
	      );
	    }
	  }]);
	  return CardExpandable;
	}(_react.Component);
	
	CardExpandable.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	CardExpandable.defaultProps = {
	  closeIcon: _react2.default.createElement(_keyboardArrowDown2.default, null),
	  openIcon: _react2.default.createElement(_keyboardArrowUp2.default, null)
	};
	 false ? CardExpandable.propTypes = {
	  closeIcon: _propTypes2.default.node,
	  expanded: _propTypes2.default.bool,
	  onExpanding: _propTypes2.default.func.isRequired,
	  openIcon: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = CardExpandable;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Avatar = __webpack_require__(344);
	
	var _Avatar2 = _interopRequireDefault(_Avatar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontWeight: card.fontWeight,
	      boxSizing: 'border-box',
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    text: {
	      display: 'inline-block',
	      verticalAlign: 'top',
	      whiteSpace: 'normal',
	      paddingRight: '90px'
	    },
	    avatar: {
	      marginRight: 16
	    },
	    title: {
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      fontSize: 15
	    },
	    subtitle: {
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block',
	      fontSize: 14
	    }
	  };
	}
	
	var CardHeader = function (_Component) {
	  (0, _inherits3.default)(CardHeader, _Component);
	
	  function CardHeader() {
	    (0, _classCallCheck3.default)(this, CardHeader);
	    return (0, _possibleConstructorReturn3.default)(this, (CardHeader.__proto__ || (0, _getPrototypeOf2.default)(CardHeader)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardHeader, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          avatarProp = _props.avatar,
	          children = _props.children,
	          closeIcon = _props.closeIcon,
	          expandable = _props.expandable,
	          openIcon = _props.openIcon,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          textStyle = _props.textStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'avatar', 'children', 'closeIcon', 'expandable', 'openIcon', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'textStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var avatar = avatarProp;
	
	      if ((0, _react.isValidElement)(avatarProp)) {
	        avatar = _react2.default.cloneElement(avatar, {
	          style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style)
	        });
	      } else if (avatar !== null) {
	        avatar = _react2.default.createElement(_Avatar2.default, { src: avatarProp, style: styles.avatar });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        avatar,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.text, textStyle)) },
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	            title
	          ),
	          _react2.default.createElement(
	            'span',
	            { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	            subtitle
	          )
	        ),
	        children
	      );
	    }
	  }]);
	  return CardHeader;
	}(_react.Component);
	
	CardHeader.muiName = 'CardHeader';
	CardHeader.defaultProps = {
	  avatar: null
	};
	CardHeader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? CardHeader.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * This is the [Avatar](/#/components/avatar) element to be displayed on the Card Header.
	   * If `avatar` is an `Avatar` or other element, it will be rendered.
	   * If `avatar` is a string, it will be used as the image `src` for an `Avatar`.
	   */
	  avatar: _propTypes2.default.node,
	  /**
	   * Can be used to render elements inside the Card Header.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Can be used to pass a closeIcon if you don't like the default expandable close Icon.
	   */
	  closeIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Can be used to pass a openIcon if you don't like the default expandable open Icon.
	   */
	  openIcon: _propTypes2.default.node,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Can be used to render a subtitle in Card Header.
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the text.
	   */
	  textStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render a title in Card Header.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _propTypes2.default.object
	} : void 0;
	exports.default = CardHeader;

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardMedia = context.muiTheme.cardMedia;
	
	
	  return {
	    root: {
	      position: 'relative'
	    },
	    overlayContainer: {
	      position: 'absolute',
	      top: 0,
	      bottom: 0,
	      right: 0,
	      left: 0
	    },
	    overlay: {
	      height: '100%',
	      position: 'relative'
	    },
	    overlayContent: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      left: 0,
	      paddingTop: 8,
	      background: cardMedia.overlayContentBackground
	    },
	    media: {},
	    mediaChild: {
	      verticalAlign: 'top',
	      maxWidth: '100%',
	      minWidth: '100%',
	      width: '100%'
	    }
	  };
	}
	
	var CardMedia = function (_Component) {
	  (0, _inherits3.default)(CardMedia, _Component);
	
	  function CardMedia() {
	    (0, _classCallCheck3.default)(this, CardMedia);
	    return (0, _possibleConstructorReturn3.default)(this, (CardMedia.__proto__ || (0, _getPrototypeOf2.default)(CardMedia)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardMedia, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          mediaStyle = _props.mediaStyle,
	          overlay = _props.overlay,
	          overlayContainerStyle = _props.overlayContainerStyle,
	          overlayContentStyle = _props.overlayContentStyle,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'mediaStyle', 'overlay', 'overlayContainerStyle', 'overlayContentStyle', 'overlayStyle', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var extendedMediaStyle = (0, _simpleAssign2.default)(styles.media, mediaStyle);
	      var extendedOverlayContainerStyle = (0, _simpleAssign2.default)(styles.overlayContainer, overlayContainerStyle);
	      var extendedOverlayContentStyle = (0, _simpleAssign2.default)(styles.overlayContent, overlayContentStyle);
	      var extendedOverlayStyle = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      var titleColor = this.context.muiTheme.cardMedia.titleColor;
	      var subtitleColor = this.context.muiTheme.cardMedia.subtitleColor;
	      var color = this.context.muiTheme.cardMedia.color;
	
	      var styledChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.cloneElement(child, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.mediaChild, child.props.style))
	        });
	      });
	
	      var overlayChildren = _react2.default.Children.map(overlay, function (child) {
	        if (child.type.muiName === 'CardHeader' || child.type.muiName === 'CardTitle') {
	          return _react2.default.cloneElement(child, {
	            titleColor: titleColor,
	            subtitleColor: subtitleColor
	          });
	        } else if (child.type.muiName === 'CardText') {
	          return _react2.default.cloneElement(child, {
	            color: color
	          });
	        } else {
	          return child;
	        }
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedMediaStyle) },
	          styledChildren
	        ),
	        overlay ? _react2.default.createElement(
	          'div',
	          { style: prepareStyles(extendedOverlayContainerStyle) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(extendedOverlayStyle) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(extendedOverlayContentStyle) },
	              overlayChildren
	            )
	          )
	        ) : ''
	      );
	    }
	  }]);
	  return CardMedia;
	}(_react.Component);
	
	CardMedia.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? CardMedia.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Media.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the Card Media.
	   */
	  mediaStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render overlay element in Card Media.
	   */
	  overlay: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the overlay container.
	   */
	  overlayContainerStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the overlay content.
	   */
	  overlayContentStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the overlay element.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = CardMedia;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var cardText = context.muiTheme.cardText;
	
	
	  return {
	    root: {
	      padding: 16,
	      fontSize: 14,
	      color: props.color || cardText.textColor
	    }
	  };
	}
	
	var CardText = function (_Component) {
	  (0, _inherits3.default)(CardText, _Component);
	
	  function CardText() {
	    (0, _classCallCheck3.default)(this, CardText);
	    return (0, _possibleConstructorReturn3.default)(this, (CardText.__proto__ || (0, _getPrototypeOf2.default)(CardText)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardText, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          color = _props.color,
	          expandable = _props.expandable,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'color', 'expandable', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)(styles.root, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        children
	      );
	    }
	  }]);
	  return CardText;
	}(_react.Component);
	
	CardText.muiName = 'CardText';
	CardText.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? CardText.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Text.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the CardText color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = CardText;

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var card = context.muiTheme.card;
	
	
	  return {
	    root: {
	      padding: 16,
	      position: 'relative'
	    },
	    title: {
	      fontSize: 24,
	      color: props.titleColor || card.titleColor,
	      display: 'block',
	      lineHeight: '36px'
	    },
	    subtitle: {
	      fontSize: 14,
	      color: props.subtitleColor || card.subtitleColor,
	      display: 'block'
	    }
	  };
	}
	
	var CardTitle = function (_Component) {
	  (0, _inherits3.default)(CardTitle, _Component);
	
	  function CardTitle() {
	    (0, _classCallCheck3.default)(this, CardTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (CardTitle.__proto__ || (0, _getPrototypeOf2.default)(CardTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CardTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          actAsExpander = _props.actAsExpander,
	          children = _props.children,
	          expandable = _props.expandable,
	          showExpandableButton = _props.showExpandableButton,
	          style = _props.style,
	          subtitle = _props.subtitle,
	          subtitleColor = _props.subtitleColor,
	          subtitleStyle = _props.subtitleStyle,
	          title = _props.title,
	          titleColor = _props.titleColor,
	          titleStyle = _props.titleStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['actAsExpander', 'children', 'expandable', 'showExpandableButton', 'style', 'subtitle', 'subtitleColor', 'subtitleStyle', 'title', 'titleColor', 'titleStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var rootStyle = (0, _simpleAssign2.default)({}, styles.root, style);
	      var extendedTitleStyle = (0, _simpleAssign2.default)({}, styles.title, titleStyle);
	      var extendedSubtitleStyle = (0, _simpleAssign2.default)({}, styles.subtitle, subtitleStyle);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(rootStyle) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedTitleStyle) },
	          title
	        ),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(extendedSubtitleStyle) },
	          subtitle
	        ),
	        children
	      );
	    }
	  }]);
	  return CardTitle;
	}(_react.Component);
	
	CardTitle.muiName = 'CardTitle';
	CardTitle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? CardTitle.propTypes = {
	  /**
	   * If true, a click on this card component expands the card.
	   */
	  actAsExpander: _propTypes2.default.bool,
	  /**
	   * Can be used to render elements inside the Card Title.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, this card component is expandable.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * If true, this card component will include a button to expand the card.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Can be used to render a subtitle in the Card Title.
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the subtitle color.
	   */
	  subtitleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the subtitle.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Can be used to render a title in the Card Title.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the title color.
	   */
	  titleColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the title.
	   */
	  titleStyle: _propTypes2.default.object
	} : void 0;
	exports.default = CardTitle;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Divider = __webpack_require__(810);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Divider2.default;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.DropDownMenu = undefined;
	
	var _DropDownMenu2 = __webpack_require__(813);
	
	var _DropDownMenu3 = _interopRequireDefault(_DropDownMenu2);
	
	var _MenuItem2 = __webpack_require__(216);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.DropDownMenu = _DropDownMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _DropDownMenu3.default;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(254);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _titleBar;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      gridTile = _context$muiTheme.gridTile;
	
	
	  var actionPos = props.actionIcon && props.actionPosition;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'block',
	      height: '100%',
	      overflow: 'hidden'
	    },
	    titleBar: (_titleBar = {
	      position: 'absolute',
	      left: 0,
	      right: 0
	    }, (0, _defineProperty3.default)(_titleBar, props.titlePosition, 0), (0, _defineProperty3.default)(_titleBar, 'height', props.subtitle ? 68 : 48), (0, _defineProperty3.default)(_titleBar, 'background', props.titleBackground), (0, _defineProperty3.default)(_titleBar, 'display', 'flex'), (0, _defineProperty3.default)(_titleBar, 'alignItems', 'center'), _titleBar),
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: actionPos !== 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      marginRight: actionPos === 'left' ? baseTheme.spacing.desktopGutterLess : 0,
	      color: gridTile.textColor,
	      overflow: 'hidden'
	    },
	    title: {
	      fontSize: '16px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    subtitle: {
	      fontSize: '12px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	    actionIcon: {
	      order: actionPos === 'left' ? -1 : 1
	    },
	    childImg: {
	      height: '100%',
	      transform: 'translateX(-50%)',
	      position: 'relative',
	      left: '50%'
	    }
	  };
	  return styles;
	}
	
	var GridTile = function (_Component) {
	  (0, _inherits3.default)(GridTile, _Component);
	
	  function GridTile() {
	    (0, _classCallCheck3.default)(this, GridTile);
	    return (0, _possibleConstructorReturn3.default)(this, (GridTile.__proto__ || (0, _getPrototypeOf2.default)(GridTile)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridTile, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.ensureImageCover();
	    }
	  }, {
	    key: 'ensureImageCover',
	    value: function ensureImageCover() {
	      var _this2 = this;
	
	      var imgEl = this.refs.img;
	
	      if (imgEl) {
	        var fit = function fit() {
	          if (imgEl.offsetWidth < imgEl.parentNode.offsetWidth) {
	            var isRtl = _this2.context.muiTheme.isRtl;
	
	            imgEl.style.height = 'auto';
	            if (isRtl) {
	              imgEl.style.right = '0';
	            } else {
	              imgEl.style.left = '0';
	            }
	            imgEl.style.width = '100%';
	            imgEl.style.top = '50%';
	            imgEl.style.transform = imgEl.style.WebkitTransform = 'translateY(-50%)';
	          }
	          imgEl.removeEventListener('load', fit);
	          imgEl = null; // prevent closure memory leak
	        };
	        if (imgEl.complete) {
	          fit();
	        } else {
	          imgEl.addEventListener('load', fit);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          subtitle = _props.subtitle,
	          titlePosition = _props.titlePosition,
	          titleBackground = _props.titleBackground,
	          titleStyle = _props.titleStyle,
	          subtitleStyle = _props.subtitleStyle,
	          actionIcon = _props.actionIcon,
	          actionPosition = _props.actionPosition,
	          style = _props.style,
	          children = _props.children,
	          containerElement = _props.containerElement,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'subtitle', 'titlePosition', 'titleBackground', 'titleStyle', 'subtitleStyle', 'actionIcon', 'actionPosition', 'style', 'children', 'containerElement']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var titleBar = null;
	
	      if (title) {
	        titleBar = _react2.default.createElement(
	          'div',
	          { key: 'titlebar', style: prepareStyles(styles.titleBar) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.titleWrap) },
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.title, titleStyle)) },
	              title
	            ),
	            subtitle ? _react2.default.createElement(
	              'div',
	              { style: prepareStyles((0, _simpleAssign2.default)(styles.subtitle, subtitleStyle)) },
	              subtitle
	            ) : null
	          ),
	          actionIcon ? _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.actionIcon) },
	            actionIcon
	          ) : null
	        );
	      }
	
	      var newChildren = children;
	
	      // if there is a single image passed as children
	      // clone it and add our styles
	      if (_react2.default.Children.count(children) === 1) {
	        newChildren = _react2.default.Children.map(children, function (child) {
	          if (child.type === 'img') {
	            return _react2.default.cloneElement(child, {
	              key: 'img',
	              ref: 'img',
	              style: prepareStyles((0, _simpleAssign2.default)({}, styles.childImg, child.props.style))
	            });
	          } else {
	            return child;
	          }
	        });
	      }
	
	      var containerProps = (0, _extends3.default)({
	        style: prepareStyles(mergedRootStyles)
	      }, other);
	
	      return _react2.default.isValidElement(containerElement) ? _react2.default.cloneElement(containerElement, containerProps, [newChildren, titleBar]) : _react2.default.createElement(containerElement, containerProps, [newChildren, titleBar]);
	    }
	  }]);
	  return GridTile;
	}(_react.Component);
	
	GridTile.defaultProps = {
	  titlePosition: 'bottom',
	  titleBackground: 'rgba(0, 0, 0, 0.4)',
	  actionPosition: 'right',
	  cols: 1,
	  rows: 1,
	  containerElement: 'div'
	};
	GridTile.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? GridTile.propTypes = {
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes2.default.element,
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in whichcase GridTile takes care of making the image "cover" available space
	   * (similar to background-size: cover or to object-fit:cover).
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes2.default.number,
	  /**
	   * Either a string used as tag name for the tile root element, or a ReactElement.
	   * This is useful when you have, for example, a custom implementation of
	   * a navigation link (that knows about your routes) and you want to use it as the primary tile action.
	   * In case you pass a ReactElement, please ensure that it passes all props,
	   * accepts styles overrides and render it's children.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the subtitle element.
	   */
	  subtitleStyle: _propTypes2.default.object,
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Style used for title bar background.
	   * Useful for setting custom gradients for example
	   */
	  titleBackground: _propTypes2.default.string,
	  /**
	   * Position of the title bar (container of title, subtitle and action icon).
	   */
	  titlePosition: _propTypes2.default.oneOf(['top', 'bottom']),
	  /**
	   * Override the inline-styles of the title element.
	   */
	  titleStyle: _propTypes2.default.object
	} : void 0;
	exports.default = GridTile;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.makeSelectable = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _colorManipulator = __webpack_require__(53);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var makeSelectable = function makeSelectable(MyComponent) {
	  var _class, _temp2;
	
	  return _temp2 = _class = function (_Component) {
	    (0, _inherits3.default)(_class, _Component);
	
	    function _class() {
	      var _ref;
	
	      var _temp, _this, _ret;
	
	      (0, _classCallCheck3.default)(this, _class);
	
	      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	        args[_key] = arguments[_key];
	      }
	
	      return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = _class.__proto__ || (0, _getPrototypeOf2.default)(_class)).call.apply(_ref, [this].concat(args))), _this), _this.hasSelectedDescendant = function (previousValue, child) {
	        if (_react2.default.isValidElement(child) && child.props.nestedItems && child.props.nestedItems.length > 0) {
	          return child.props.nestedItems.reduce(_this.hasSelectedDescendant, previousValue);
	        }
	        return previousValue || _this.isChildSelected(child, _this.props);
	      }, _this.handleItemTouchTap = function (event, item) {
	        var itemValue = item.props.value;
	
	        if (itemValue !== _this.props.value) {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, itemValue);
	          }
	        }
	      }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	    }
	
	    (0, _createClass3.default)(_class, [{
	      key: 'extendChild',
	      value: function extendChild(child, styles, selectedItemStyle) {
	        var _this2 = this;
	
	        if (child && child.type && child.type.muiName === 'ListItem') {
	          var selected = this.isChildSelected(child, this.props);
	          var selectedChildrenStyles = void 0;
	          if (selected) {
	            selectedChildrenStyles = (0, _simpleAssign2.default)({}, styles, selectedItemStyle);
	          }
	
	          var mergedChildrenStyles = (0, _simpleAssign2.default)({}, child.props.style, selectedChildrenStyles);
	
	          this.keyIndex += 1;
	
	          return _react2.default.cloneElement(child, {
	            onTouchTap: function onTouchTap(event) {
	              _this2.handleItemTouchTap(event, child);
	              if (child.props.onTouchTap) {
	                child.props.onTouchTap(event);
	              }
	            },
	            key: this.keyIndex,
	            style: mergedChildrenStyles,
	            nestedItems: child.props.nestedItems.map(function (child) {
	              return _this2.extendChild(child, styles, selectedItemStyle);
	            }),
	            initiallyOpen: this.isInitiallyOpen(child)
	          });
	        } else {
	          return child;
	        }
	      }
	    }, {
	      key: 'isInitiallyOpen',
	      value: function isInitiallyOpen(child) {
	        if (child.props.initiallyOpen) {
	          return child.props.initiallyOpen;
	        }
	        return this.hasSelectedDescendant(false, child);
	      }
	    }, {
	      key: 'isChildSelected',
	      value: function isChildSelected(child, props) {
	        return props.value === child.props.value;
	      }
	    }, {
	      key: 'render',
	      value: function render() {
	        var _this3 = this;
	
	        var _props = this.props,
	            children = _props.children,
	            selectedItemStyle = _props.selectedItemStyle,
	            other = (0, _objectWithoutProperties3.default)(_props, ['children', 'selectedItemStyle']);
	
	
	        this.keyIndex = 0;
	        var styles = {};
	
	        if (!selectedItemStyle) {
	          var textColor = this.context.muiTheme.baseTheme.palette.textColor;
	          styles.backgroundColor = (0, _colorManipulator.fade)(textColor, 0.2);
	        }
	
	        return _react2.default.createElement(
	          MyComponent,
	          (0, _extends3.default)({}, other, this.state),
	          _react.Children.map(children, function (child) {
	            return _this3.extendChild(child, styles, selectedItemStyle);
	          })
	        );
	      }
	    }]);
	    return _class;
	  }(_react.Component), _class.propTypes = {
	    children: _propTypes2.default.node,
	    onChange: _propTypes2.default.func,
	    selectedItemStyle: _propTypes2.default.object,
	    value: _propTypes2.default.any
	  }, _class.contextTypes = {
	    muiTheme: _propTypes2.default.object.isRequired
	  }, _temp2;
	};
	
	exports.makeSelectable = makeSelectable;
	exports.default = makeSelectable;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.Menu = undefined;
	
	var _Menu2 = __webpack_require__(149);
	
	var _Menu3 = _interopRequireDefault(_Menu2);
	
	var _MenuItem2 = __webpack_require__(217);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Menu = _Menu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _Menu3.default;

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedSwitch = __webpack_require__(221);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _radioButtonUnchecked = __webpack_require__(389);
	
	var _radioButtonUnchecked2 = _interopRequireDefault(_radioButtonUnchecked);
	
	var _radioButtonChecked = __webpack_require__(388);
	
	var _radioButtonChecked2 = _interopRequireDefault(_radioButtonChecked);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var radioButton = context.muiTheme.radioButton;
	
	
	  return {
	    icon: {
	      height: radioButton.size,
	      width: radioButton.size
	    },
	    target: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(1)',
	      fill: radioButton.borderColor
	    },
	    fill: {
	      position: 'absolute',
	      opacity: 1,
	      transform: 'scale(0)',
	      transformOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut(),
	      fill: radioButton.checkedColor
	    },
	    targetWhenChecked: {
	      opacity: 0,
	      transform: 'scale(0)'
	    },
	    fillWhenChecked: {
	      opacity: 1,
	      transform: 'scale(1)'
	    },
	    targetWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    fillWhenDisabled: {
	      fill: radioButton.disabledColor
	    },
	    label: {
	      color: props.disabled ? radioButton.labelDisabledColor : radioButton.labelColor
	    },
	    ripple: {
	      color: props.checked ? radioButton.checkedColor : radioButton.borderColor
	    }
	  };
	}
	
	var RadioButton = function (_Component) {
	  (0, _inherits3.default)(RadioButton, _Component);
	
	  function RadioButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButton.__proto__ || (0, _getPrototypeOf2.default)(RadioButton)).call.apply(_ref, [this].concat(args))), _this), _this.handleSwitch = function (event) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, _this.props.value);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // Only called when selected, not when unselected.
	
	
	  (0, _createClass3.default)(RadioButton, [{
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	
	    // Use RadioButtonGroup.setSelectedValue(newSelectionValue) to set a
	    // RadioButton's checked value.
	
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.refs.enhancedSwitch.getValue();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          checkedIcon = _props.checkedIcon,
	          checked = _props.checked,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          onCheck = _props.onCheck,
	          uncheckedIcon = _props.uncheckedIcon,
	          disabled = _props.disabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['checkedIcon', 'checked', 'iconStyle', 'labelStyle', 'labelPosition', 'onCheck', 'uncheckedIcon', 'disabled']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var uncheckedStyles = (0, _simpleAssign2.default)(styles.target, checked && styles.targetWhenChecked, iconStyle, disabled && styles.targetWhenDisabled);
	
	      var checkedStyles = (0, _simpleAssign2.default)(styles.fill, checked && styles.fillWhenChecked, iconStyle, disabled && styles.fillWhenDisabled);
	
	      var uncheckedElement = _react2.default.isValidElement(uncheckedIcon) ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(uncheckedStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonUnchecked2.default, { style: uncheckedStyles });
	
	      var checkedElement = _react2.default.isValidElement(checkedIcon) ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkedStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_radioButtonChecked2.default, { style: checkedStyles });
	
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	      var mergedLabelStyle = (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, {
	        ref: 'enhancedSwitch',
	        inputType: 'radio',
	        checked: checked,
	        switched: checked,
	        disabled: disabled,
	        rippleColor: styles.ripple.color,
	        iconStyle: mergedIconStyle,
	        labelStyle: mergedLabelStyle,
	        labelPosition: labelPosition,
	        onSwitch: this.handleSwitch,
	        switchElement: _react2.default.createElement(
	          'div',
	          null,
	          uncheckedElement,
	          checkedElement
	        )
	      }));
	    }
	  }]);
	  return RadioButton;
	}(_react.Component);
	
	RadioButton.defaultProps = {
	  checked: false,
	  disabled: false,
	  labelPosition: 'right'
	};
	RadioButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? RadioButton.propTypes = {
	  /**
	   * @ignore
	   * checked if true
	   * Used internally by `RadioButtonGroup`.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * The icon element to show when the radio button is checked.
	   */
	  checkedIcon: _propTypes2.default.element,
	  /**
	   * If true, the radio button is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Used internally by `RadioButtonGroup`. Use the `labelPosition` property of `RadioButtonGroup` instead.
	   * Where the label will be placed next to the radio button.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Override the inline-styles of the label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Callback function fired when the radio button is checked. Note that this
	   * function will not be called if the radio button is part of a
	   * radio button group: in this case, use the `onChange` property of
	   * `RadioButtonGroup`.
	   *
	   * @param {object} event `change` event targeting the element.
	   * @param {string} value The element's `value`.
	   */
	  onCheck: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The icon element to show when the radio button is unchecked.
	   */
	  uncheckedIcon: _propTypes2.default.element,
	  /**
	   * The value of the radio button.
	   */
	  value: _propTypes2.default.any
	} : void 0;
	exports.default = RadioButton;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _RadioButton = __webpack_require__(357);
	
	var _RadioButton2 = _interopRequireDefault(_RadioButton);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var RadioButtonGroup = function (_Component) {
	  (0, _inherits3.default)(RadioButtonGroup, _Component);
	
	  function RadioButtonGroup() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RadioButtonGroup);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RadioButtonGroup.__proto__ || (0, _getPrototypeOf2.default)(RadioButtonGroup)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      numberCheckedRadioButtons: 0,
	      selected: ''
	    }, _this.handleChange = function (event, newSelection) {
	      _this.updateRadioButtons(newSelection);
	
	      // Successful update
	      if (_this.state.numberCheckedRadioButtons === 0) {
	        if (_this.props.onChange) _this.props.onChange(event, newSelection);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RadioButtonGroup, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var cnt = 0;
	      var selected = '';
	      var _props = this.props,
	          valueSelected = _props.valueSelected,
	          defaultSelected = _props.defaultSelected;
	
	      if (valueSelected !== undefined) {
	        selected = valueSelected;
	      } else if (defaultSelected !== undefined) {
	        selected = defaultSelected;
	      }
	
	      _react2.default.Children.forEach(this.props.children, function (option) {
	        if (_this2.hasCheckAttribute(option)) cnt++;
	      }, this);
	
	      this.setState({
	        numberCheckedRadioButtons: cnt,
	        selected: selected
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.hasOwnProperty('valueSelected')) {
	        this.setState({
	          selected: nextProps.valueSelected
	        });
	      }
	    }
	  }, {
	    key: 'hasCheckAttribute',
	    value: function hasCheckAttribute(radioButton) {
	      return radioButton.props.hasOwnProperty('checked') && radioButton.props.checked;
	    }
	  }, {
	    key: 'updateRadioButtons',
	    value: function updateRadioButtons(newSelection) {
	      if (this.state.numberCheckedRadioButtons === 0) {
	        this.setState({ selected: newSelection });
	      } else {
	         false ? (0, _warning2.default)(false, 'Material-UI: Cannot select a different radio button while another radio button\n        has the \'checked\' property set to true.') : void 0;
	      }
	    }
	  }, {
	    key: 'getSelectedValue',
	    value: function getSelectedValue() {
	      return this.state.selected;
	    }
	  }, {
	    key: 'setSelectedValue',
	    value: function setSelectedValue(newSelectionValue) {
	      this.updateRadioButtons(newSelectionValue);
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	      this.setSelectedValue('');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var options = _react2.default.Children.map(this.props.children, function (option) {
	        var _option$props = option.props,
	            name = _option$props.name,
	            value = _option$props.value,
	            label = _option$props.label,
	            onCheck = _option$props.onCheck,
	            other = (0, _objectWithoutProperties3.default)(_option$props, ['name', 'value', 'label', 'onCheck']);
	
	
	        return _react2.default.createElement(_RadioButton2.default, (0, _extends3.default)({}, other, {
	          ref: option.props.value,
	          name: _this3.props.name,
	          key: option.props.value,
	          value: option.props.value,
	          label: option.props.label,
	          labelPosition: _this3.props.labelPosition,
	          onCheck: _this3.handleChange,
	          checked: option.props.value === _this3.state.selected
	        }));
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        {
	          style: prepareStyles((0, _simpleAssign2.default)({}, this.props.style)),
	          className: this.props.className
	        },
	        options
	      );
	    }
	  }]);
	  return RadioButtonGroup;
	}(_react.Component);
	
	RadioButtonGroup.defaultProps = {
	  style: {}
	};
	RadioButtonGroup.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? RadioButtonGroup.propTypes = {
	  /**
	   * Should be used to pass `RadioButton` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The `value` property of the radio button that will be
	   * selected by default. This takes precedence over the `checked` property
	   * of the `RadioButton` elements.
	   */
	  defaultSelected: _propTypes2.default.any,
	  /**
	   * Where the label will be placed for all child radio buttons.
	   * This takes precedence over the `labelPosition` property of the
	   * `RadioButton` elements.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * The name that will be applied to all child radio buttons.
	   */
	  name: _propTypes2.default.string.isRequired,
	  /**
	   * Callback function that is fired when a radio button has
	   * been checked.
	   *
	   * @param {object} event `change` event targeting the selected
	   * radio button.
	   * @param {*} value The `value` of the selected radio button.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The `value` of the currently selected radio button.
	   */
	  valueSelected: _propTypes2.default.any
	} : void 0;
	exports.default = RadioButtonGroup;

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _typeof2 = __webpack_require__(69);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _checkCircle = __webpack_require__(375);
	
	var _checkCircle2 = _interopRequireDefault(_checkCircle);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var active = _ref.active,
	      completed = _ref.completed,
	      disabled = _ref.disabled;
	  var muiTheme = _ref2.muiTheme,
	      stepper = _ref2.stepper;
	  var _muiTheme$stepper = muiTheme.stepper,
	      textColor = _muiTheme$stepper.textColor,
	      disabledTextColor = _muiTheme$stepper.disabledTextColor,
	      iconColor = _muiTheme$stepper.iconColor,
	      inactiveIconColor = _muiTheme$stepper.inactiveIconColor;
	  var baseTheme = muiTheme.baseTheme;
	  var orientation = stepper.orientation;
	
	
	  var styles = {
	    root: {
	      height: orientation === 'horizontal' ? 72 : 64,
	      color: textColor,
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: 14,
	      paddingLeft: 14,
	      paddingRight: 14
	    },
	    icon: {
	      color: iconColor,
	      display: 'block',
	      fontSize: 24,
	      width: 24,
	      height: 24
	    },
	    iconContainer: {
	      paddingRight: 8
	    }
	  };
	
	  if (active) {
	    styles.root.fontWeight = 500;
	  }
	
	  if (!completed && !active) {
	    styles.icon.color = inactiveIconColor;
	  }
	
	  if (disabled) {
	    styles.icon.color = inactiveIconColor;
	    styles.root.color = disabledTextColor;
	    styles.root.cursor = 'not-allowed';
	  }
	
	  return styles;
	};
	
	var renderIcon = function renderIcon(completed, icon, styles) {
	  var iconType = typeof icon === 'undefined' ? 'undefined' : (0, _typeof3.default)(icon);
	
	  if (iconType === 'number' || iconType === 'string') {
	    if (completed) {
	      return _react2.default.createElement(_checkCircle2.default, {
	        color: styles.icon.color,
	        style: styles.icon
	      });
	    }
	
	    return _react2.default.createElement(
	      _SvgIcon2.default,
	      { color: styles.icon.color, style: styles.icon },
	      _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' }),
	      _react2.default.createElement(
	        'text',
	        {
	          x: '12',
	          y: '16',
	          textAnchor: 'middle',
	          fontSize: '12',
	          fill: '#fff'
	        },
	        icon
	      )
	    );
	  }
	
	  return icon;
	};
	
	var StepLabel = function StepLabel(props, context) {
	  var active = props.active,
	      children = props.children,
	      completed = props.completed,
	      userIcon = props.icon,
	      iconContainerStyle = props.iconContainerStyle,
	      last = props.last,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['active', 'children', 'completed', 'icon', 'iconContainerStyle', 'last', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	  var icon = renderIcon(completed, userIcon, styles);
	
	  return _react2.default.createElement(
	    'span',
	    (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	    icon && _react2.default.createElement(
	      'span',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.iconContainer, iconContainerStyle)) },
	      icon
	    ),
	    children
	  );
	};
	
	StepLabel.muiName = 'StepLabel';
	
	 false ? StepLabel.propTypes = {
	  /**
	   * Sets active styling. Overrides disabled coloring.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * The label text node
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Sets completed styling. Overrides disabled coloring.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Sets disabled styling.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	
	StepLabel.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	
	exports.default = StepLabel;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Subheader = __webpack_require__(849);
	
	var _Subheader2 = _interopRequireDefault(_Subheader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Subheader2.default;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getIterator2 = __webpack_require__(252);
	
	var _getIterator3 = _interopRequireDefault(_getIterator2);
	
	var _toConsumableArray2 = __webpack_require__(97);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _typeof2 = __webpack_require__(69);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Checkbox = __webpack_require__(211);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableRowColumn = __webpack_require__(150);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	var _ClickAwayListener = __webpack_require__(220);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TableBody = function (_Component) {
	  (0, _inherits3.default)(TableBody, _Component);
	
	  function TableBody() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableBody);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableBody.__proto__ || (0, _getPrototypeOf2.default)(TableBody)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedRows: []
	    }, _this.handleClickAway = function () {
	      if (_this.props.deselectOnClickaway && _this.state.selectedRows.length) {
	        _this.setState({
	          selectedRows: []
	        });
	        if (_this.props.onRowSelection) {
	          _this.props.onRowSelection([]);
	        }
	      }
	    }, _this.onRowClick = function (event, rowNumber) {
	      event.stopPropagation();
	
	      if (_this.props.selectable) {
	        // Prevent text selection while selecting rows.
	        window.getSelection().removeAllRanges();
	        _this.processRowSelection(event, rowNumber);
	      }
	    }, _this.onCellClick = function (event, rowNumber, columnNumber) {
	      event.stopPropagation();
	      if (_this.props.onCellClick) {
	        _this.props.onCellClick(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	    }, _this.onCellHover = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHover) {
	        _this.props.onCellHover(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHover(event, rowNumber);
	    }, _this.onCellHoverExit = function (event, rowNumber, columnNumber) {
	      if (_this.props.onCellHoverExit) {
	        _this.props.onCellHoverExit(rowNumber, _this.getColumnId(columnNumber), event);
	      }
	      _this.onRowHoverExit(event, rowNumber);
	    }, _this.onRowHover = function (event, rowNumber) {
	      if (_this.props.onRowHover) {
	        _this.props.onRowHover(rowNumber);
	      }
	    }, _this.onRowHoverExit = function (event, rowNumber) {
	      if (_this.props.onRowHoverExit) {
	        _this.props.onRowHoverExit(rowNumber);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableBody, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({ selectedRows: this.calculatePreselectedRows(this.props) });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.allRowsSelected !== nextProps.allRowsSelected) {
	        if (!nextProps.allRowsSelected) {
	          this.setState({
	            selectedRows: []
	          });
	        } else {
	          this.setState({
	            selectedRows: this.calculatePreselectedRows(nextProps)
	          });
	        }
	      }
	    }
	  }, {
	    key: 'createRows',
	    value: function createRows() {
	      var _this2 = this;
	
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var rowNumber = 0;
	      var handlers = {
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowClick: this.onRowClick
	      };
	
	      return _react2.default.Children.map(this.props.children, function (child) {
	        if (_react2.default.isValidElement(child)) {
	          var props = {
	            hoverable: _this2.props.showRowHover,
	            selected: _this2.isRowSelected(rowNumber),
	            striped: _this2.props.stripedRows && rowNumber % 2 === 0,
	            rowNumber: rowNumber++
	          };
	
	          if (rowNumber === numChildren) {
	            props.displayBorder = false;
	          }
	
	          var children = [_this2.createRowCheckboxColumn(props)];
	
	          _react2.default.Children.forEach(child.props.children, function (child) {
	            children.push(child);
	          });
	
	          return _react2.default.cloneElement(child, (0, _extends3.default)({}, props, handlers), children);
	        }
	      });
	    }
	  }, {
	    key: 'createRowCheckboxColumn',
	    value: function createRowCheckboxColumn(rowProps) {
	      if (!this.props.displayRowCheckbox) {
	        return null;
	      }
	
	      var key = rowProps.rowNumber + '-cb';
	      var disabled = !this.props.selectable;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        ref: 'rowSelectCB',
	        name: key,
	        value: 'selected',
	        disabled: disabled,
	        checked: rowProps.selected
	      });
	
	      return _react2.default.createElement(
	        _TableRowColumn2.default,
	        {
	          key: key,
	          columnNumber: 0,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'calculatePreselectedRows',
	    value: function calculatePreselectedRows(props) {
	      // Determine what rows are 'pre-selected'.
	      var preSelectedRows = [];
	
	      if (props.selectable && props.preScanRows) {
	        var index = 0;
	        _react2.default.Children.forEach(props.children, function (child) {
	          if (_react2.default.isValidElement(child)) {
	            if (child.props.selected && (preSelectedRows.length === 0 || props.multiSelectable)) {
	              preSelectedRows.push(index);
	            }
	
	            index++;
	          }
	        });
	      }
	
	      return preSelectedRows;
	    }
	  }, {
	    key: 'isRowSelected',
	    value: function isRowSelected(rowNumber) {
	      if (this.props.allRowsSelected) {
	        return true;
	      }
	
	      for (var i = 0; i < this.state.selectedRows.length; i++) {
	        var selection = this.state.selectedRows[i];
	
	        if ((typeof selection === 'undefined' ? 'undefined' : (0, _typeof3.default)(selection)) === 'object') {
	          if (this.isValueInRange(rowNumber, selection)) return true;
	        } else {
	          if (selection === rowNumber) return true;
	        }
	      }
	
	      return false;
	    }
	  }, {
	    key: 'isValueInRange',
	    value: function isValueInRange(value, range) {
	      if (!range) return false;
	
	      if (range.start <= value && value <= range.end || range.end <= value && value <= range.start) {
	        return true;
	      }
	
	      return false;
	    }
	  }, {
	    key: 'processRowSelection',
	    value: function processRowSelection(event, rowNumber) {
	      var selectedRows = this.state.selectedRows;
	
	      if (event.shiftKey && this.props.multiSelectable && selectedRows.length) {
	        var lastIndex = selectedRows.length - 1;
	        var lastSelection = selectedRows[lastIndex];
	
	        if ((typeof lastSelection === 'undefined' ? 'undefined' : (0, _typeof3.default)(lastSelection)) === 'object') {
	          lastSelection.end = rowNumber;
	        } else {
	          selectedRows.splice(lastIndex, 1, { start: lastSelection, end: rowNumber });
	        }
	      } else if ((event.ctrlKey && !event.metaKey || event.metaKey && !event.ctrlKey) && this.props.multiSelectable) {
	        var idx = selectedRows.indexOf(rowNumber);
	        if (idx < 0) {
	          var foundRange = false;
	          for (var i = 0; i < selectedRows.length; i++) {
	            var range = selectedRows[i];
	            if ((typeof range === 'undefined' ? 'undefined' : (0, _typeof3.default)(range)) !== 'object') continue;
	
	            if (this.isValueInRange(rowNumber, range)) {
	              var _selectedRows;
	
	              foundRange = true;
	              var values = this.splitRange(range, rowNumber);
	              (_selectedRows = selectedRows).splice.apply(_selectedRows, [i, 1].concat((0, _toConsumableArray3.default)(values)));
	            }
	          }
	
	          if (!foundRange) selectedRows.push(rowNumber);
	        } else {
	          selectedRows.splice(idx, 1);
	        }
	      } else {
	        if (selectedRows.length === 1 && selectedRows[0] === rowNumber) {
	          selectedRows = [];
	        } else {
	          selectedRows = [rowNumber];
	        }
	      }
	
	      this.setState({ selectedRows: selectedRows });
	      if (this.props.onRowSelection) this.props.onRowSelection(this.flattenRanges(selectedRows));
	    }
	  }, {
	    key: 'splitRange',
	    value: function splitRange(range, splitPoint) {
	      var splitValues = [];
	      var startOffset = range.start - splitPoint;
	      var endOffset = range.end - splitPoint;
	
	      // Process start half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, startOffset)));
	
	      // Process end half
	      splitValues.push.apply(splitValues, (0, _toConsumableArray3.default)(this.genRangeOfValues(splitPoint, endOffset)));
	
	      return splitValues;
	    }
	  }, {
	    key: 'genRangeOfValues',
	    value: function genRangeOfValues(start, offset) {
	      var values = [];
	      var dir = offset > 0 ? -1 : 1; // This forces offset to approach 0 from either direction.
	      while (offset !== 0) {
	        values.push(start + offset);
	        offset += dir;
	      }
	
	      return values;
	    }
	  }, {
	    key: 'flattenRanges',
	    value: function flattenRanges(selectedRows) {
	      var rows = [];
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = (0, _getIterator3.default)(selectedRows), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var selection = _step.value;
	
	          if ((typeof selection === 'undefined' ? 'undefined' : (0, _typeof3.default)(selection)) === 'object') {
	            var values = this.genRangeOfValues(selection.end, selection.start - selection.end);
	            rows.push.apply(rows, [selection.end].concat((0, _toConsumableArray3.default)(values)));
	          } else {
	            rows.push(selection);
	          }
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return rows.sort();
	    }
	  }, {
	    key: 'getColumnId',
	    value: function getColumnId(columnNumber) {
	      var columnId = columnNumber;
	      if (this.props.displayRowCheckbox) {
	        columnId--;
	      }
	
	      return columnId;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: this.handleClickAway },
	        _react2.default.createElement(
	          'tbody',
	          { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	          this.createRows()
	        )
	      );
	    }
	  }]);
	  return TableBody;
	}(_react.Component);
	
	TableBody.muiName = 'TableBody';
	TableBody.defaultProps = {
	  allRowsSelected: false,
	  deselectOnClickaway: true,
	  displayRowCheckbox: true,
	  multiSelectable: false,
	  preScanRows: true,
	  selectable: true,
	  style: {}
	};
	TableBody.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TableBody.propTypes = {
	  /**
	   * @ignore
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _propTypes2.default.bool,
	  /**
	   * Children passed to table body.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Controls whether or not to deselect all selected
	   * rows after clicking outside the table.
	   */
	  deselectOnClickaway: _propTypes2.default.bool,
	  /**
	   * Controls the display of the row checkbox. The default value is true.
	   */
	  displayRowCheckbox: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Callback function for when a cell is clicked.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered. rowNumber
	   * is the row number of the hovered row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer
	   * hovered. rowNumber is the row number of the row
	   * that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a row is selected. selectedRows is an
	   * array of all row selections. IF all rows have been selected,
	   * the string "all" will be returned instead to indicate that
	   * all rows have been selected.
	   */
	  onRowSelection: _propTypes2.default.func,
	  /**
	   * Controls whether or not the rows are pre-scanned to determine
	   * initial state. If your table has a large number of rows and
	   * you are experiencing a delay in rendering, turn off this property.
	   */
	  preScanRows: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * If true, table rows can be selected. If multiple
	   * row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * If true, table rows will be highlighted when
	   * the cursor is hovering over the row. The default
	   * value is false.
	   */
	  showRowHover: _propTypes2.default.bool,
	  /**
	   * If true, every other table row starting
	   * with the first row will be striped. The default value is false.
	   */
	  stripedRows: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = TableBody;

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _toConsumableArray2 = __webpack_require__(97);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TableRowColumn = __webpack_require__(150);
	
	var _TableRowColumn2 = _interopRequireDefault(_TableRowColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableFooter = context.muiTheme.tableFooter;
	
	
	  return {
	    cell: {
	      borderTop: '1px solid ' + tableFooter.borderColor,
	      verticalAlign: 'bottom',
	      padding: 20,
	      textAlign: 'left',
	      whiteSpace: 'nowrap'
	    }
	  };
	}
	
	var TableFooter = function (_Component) {
	  (0, _inherits3.default)(TableFooter, _Component);
	
	  function TableFooter() {
	    (0, _classCallCheck3.default)(this, TableFooter);
	    return (0, _possibleConstructorReturn3.default)(this, (TableFooter.__proto__ || (0, _getPrototypeOf2.default)(TableFooter)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(TableFooter, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          adjustForCheckbox = _props.adjustForCheckbox,
	          children = _props.children,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['adjustForCheckbox', 'children', 'className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var footerRows = _react2.default.Children.map(children, function (child, rowNumber) {
	        var newChildProps = {
	          displayBorder: false,
	          key: 'f-' + rowNumber,
	          rowNumber: rowNumber,
	          style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	        };
	
	        var newDescendants = void 0;
	
	        if (adjustForCheckbox) {
	          newDescendants = [_react2.default.createElement(_TableRowColumn2.default, { key: 'fpcb' + rowNumber, style: { width: 24 } })].concat((0, _toConsumableArray3.default)(_react2.default.Children.toArray(child.props.children)));
	        } else {
	          newDescendants = child.props.children;
	        }
	
	        return _react2.default.cloneElement(child, newChildProps, newDescendants);
	      });
	
	      return _react2.default.createElement(
	        'tfoot',
	        (0, _extends3.default)({ className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        footerRows
	      );
	    }
	  }]);
	  return TableFooter;
	}(_react.Component);
	
	TableFooter.muiName = 'TableFooter';
	TableFooter.defaultProps = {
	  adjustForCheckbox: true,
	  style: {}
	};
	TableFooter.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TableFooter.propTypes = {
	  /**
	   * @ignore
	   * Controls whether or not header rows should be adjusted
	   * for a checkbox column. If the select all checkbox is true,
	   * this property will not influence the number of columns.
	   * This is mainly useful for "super header" rows so that
	   * the checkbox column does not create an offset that needs
	   * to be accounted for manually.
	   */
	  adjustForCheckbox: _propTypes2.default.bool,
	  /**
	   * Children passed to table footer.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = TableFooter;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Checkbox = __webpack_require__(211);
	
	var _Checkbox2 = _interopRequireDefault(_Checkbox);
	
	var _TableHeaderColumn = __webpack_require__(219);
	
	var _TableHeaderColumn2 = _interopRequireDefault(_TableHeaderColumn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tableHeader = context.muiTheme.tableHeader;
	
	
	  return {
	    root: {
	      borderBottom: '1px solid ' + tableHeader.borderColor
	    }
	  };
	}
	
	var TableHeader = function (_Component) {
	  (0, _inherits3.default)(TableHeader, _Component);
	
	  function TableHeader() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableHeader);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableHeader.__proto__ || (0, _getPrototypeOf2.default)(TableHeader)).call.apply(_ref, [this].concat(args))), _this), _this.handleCheckAll = function (event, checked) {
	      if (_this.props.onSelectAll) {
	        _this.props.onSelectAll(checked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableHeader, [{
	    key: 'createSuperHeaderRows',
	    value: function createSuperHeaderRows() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      if (numChildren === 1) return undefined;
	
	      var superHeaders = [];
	      for (var index = 0; index < numChildren - 1; index++) {
	        var child = this.props.children[index];
	
	        if (!_react2.default.isValidElement(child)) continue;
	
	        var props = {
	          key: 'sh' + index,
	          rowNumber: index
	        };
	        superHeaders.push(this.createSuperHeaderRow(child, props));
	      }
	
	      if (superHeaders.length) return superHeaders;
	    }
	  }, {
	    key: 'createSuperHeaderRow',
	    value: function createSuperHeaderRow(child, props) {
	      var children = [];
	      if (this.props.adjustForCheckbox) {
	        children.push(this.getCheckboxPlaceholder(props));
	      }
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'createBaseHeaderRow',
	    value: function createBaseHeaderRow() {
	      var numChildren = _react2.default.Children.count(this.props.children);
	      var child = numChildren === 1 ? this.props.children : this.props.children[numChildren - 1];
	      var props = {
	        key: 'h' + numChildren,
	        rowNumber: numChildren
	      };
	
	      var children = [this.getSelectAllCheckboxColumn(props)];
	      _react2.default.Children.forEach(child.props.children, function (child) {
	        children.push(child);
	      });
	
	      return _react2.default.cloneElement(child, props, children);
	    }
	  }, {
	    key: 'getCheckboxPlaceholder',
	    value: function getCheckboxPlaceholder(props) {
	      if (!this.props.adjustForCheckbox) return null;
	
	      var disabled = !this.props.enableSelectAll;
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(_TableHeaderColumn2.default, {
	        key: key,
	        style: {
	          width: 24,
	          cursor: disabled ? 'not-allowed' : 'inherit'
	        }
	      });
	    }
	  }, {
	    key: 'getSelectAllCheckboxColumn',
	    value: function getSelectAllCheckboxColumn(props) {
	      if (!this.props.displaySelectAll) return this.getCheckboxPlaceholder(props);
	
	      var disabled = !this.props.enableSelectAll;
	      var checkbox = _react2.default.createElement(_Checkbox2.default, {
	        key: 'selectallcb',
	        name: 'selectallcb',
	        value: 'selected',
	        disabled: disabled,
	        checked: this.props.selectAllSelected,
	        onCheck: this.handleCheckAll
	      });
	
	      var key = 'hpcb' + props.rowNumber;
	      return _react2.default.createElement(
	        _TableHeaderColumn2.default,
	        {
	          key: key,
	          style: {
	            width: 24,
	            cursor: disabled ? 'not-allowed' : 'inherit'
	          }
	        },
	        checkbox
	      );
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var superHeaderRows = this.createSuperHeaderRows();
	      var baseHeaderRow = this.createBaseHeaderRow();
	
	      return _react2.default.createElement(
	        'thead',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        superHeaderRows,
	        baseHeaderRow
	      );
	    }
	  }]);
	  return TableHeader;
	}(_react.Component);
	
	TableHeader.muiName = 'TableHeader';
	TableHeader.defaultProps = {
	  adjustForCheckbox: true,
	  displaySelectAll: true,
	  enableSelectAll: true,
	  selectAllSelected: false
	};
	TableHeader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TableHeader.propTypes = {
	  /**
	   * Controls whether or not header rows should be
	   * adjusted for a checkbox column. If the select all
	   * checkbox is true, this property will not influence
	   * the number of columns. This is mainly useful for
	   * "super header" rows so that the checkbox column
	   * does not create an offset that needs to be accounted
	   * for manually.
	   */
	  adjustForCheckbox: _propTypes2.default.bool,
	  /**
	   * Children passed to table header.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Controls whether or not the select all checkbox is displayed.
	   */
	  displaySelectAll: _propTypes2.default.bool,
	  /**
	   * If set to true, the select all button will be interactable.
	   * If set to false, the button will not be interactable.
	   * To hide the checkbox, set displaySelectAll to false.
	   */
	  enableSelectAll: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Callback when select all has been checked.
	   */
	  onSelectAll: _propTypes2.default.func,
	  /**
	   * @ignore
	   * True when select all has been checked.
	   */
	  selectAllSelected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = TableHeader;

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var tableRow = context.muiTheme.tableRow;
	
	
	  var cellBgColor = 'inherit';
	  if (props.hovered || state.hovered) {
	    cellBgColor = tableRow.hoverColor;
	  } else if (props.selected) {
	    cellBgColor = tableRow.selectedColor;
	  } else if (props.striped) {
	    cellBgColor = tableRow.stripeColor;
	  }
	
	  return {
	    root: {
	      borderBottom: props.displayBorder && '1px solid ' + tableRow.borderColor,
	      color: tableRow.textColor,
	      height: tableRow.height
	    },
	    cell: {
	      backgroundColor: cellBgColor
	    }
	  };
	}
	
	var TableRow = function (_Component) {
	  (0, _inherits3.default)(TableRow, _Component);
	
	  function TableRow() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TableRow);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TableRow.__proto__ || (0, _getPrototypeOf2.default)(TableRow)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.onCellClick = function (event, columnIndex) {
	      if (_this.props.selectable && _this.props.onCellClick) {
	        _this.props.onCellClick(event, _this.props.rowNumber, columnIndex);
	      }
	      event.ctrlKey = true;
	      _this.onRowClick(event);
	    }, _this.onCellHover = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: true });
	        if (_this.props.onCellHover) _this.props.onCellHover(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHover(event);
	      }
	    }, _this.onCellHoverExit = function (event, columnIndex) {
	      if (_this.props.hoverable) {
	        _this.setState({ hovered: false });
	        if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(event, _this.props.rowNumber, columnIndex);
	        _this.onRowHoverExit(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TableRow, [{
	    key: 'onRowClick',
	    value: function onRowClick(event) {
	      if (this.props.selectable && this.props.onRowClick) this.props.onRowClick(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'onRowHover',
	    value: function onRowHover(event) {
	      if (this.props.onRowHover) this.props.onRowHover(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'onRowHoverExit',
	    value: function onRowHoverExit(event) {
	      if (this.props.onRowHoverExit) this.props.onRowHoverExit(event, this.props.rowNumber);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          className = _props.className,
	          displayBorder = _props.displayBorder,
	          hoverable = _props.hoverable,
	          hovered = _props.hovered,
	          onCellClick = _props.onCellClick,
	          onCellHover = _props.onCellHover,
	          onCellHoverExit = _props.onCellHoverExit,
	          onRowClick = _props.onRowClick,
	          onRowHover = _props.onRowHover,
	          onRowHoverExit = _props.onRowHoverExit,
	          rowNumber = _props.rowNumber,
	          selectable = _props.selectable,
	          selected = _props.selected,
	          striped = _props.striped,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'displayBorder', 'hoverable', 'hovered', 'onCellClick', 'onCellHover', 'onCellHoverExit', 'onRowClick', 'onRowHover', 'onRowHoverExit', 'rowNumber', 'selectable', 'selected', 'striped', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var rowColumns = _react2.default.Children.map(this.props.children, function (child, columnNumber) {
	        if (_react2.default.isValidElement(child)) {
	          return _react2.default.cloneElement(child, {
	            columnNumber: columnNumber,
	            hoverable: _this2.props.hoverable,
	            key: _this2.props.rowNumber + '-' + columnNumber,
	            onClick: _this2.onCellClick,
	            onHover: _this2.onCellHover,
	            onHoverExit: _this2.onCellHoverExit,
	            style: (0, _simpleAssign2.default)({}, styles.cell, child.props.style)
	          });
	        }
	      });
	
	      return _react2.default.createElement(
	        'tr',
	        (0, _extends3.default)({
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other),
	        rowColumns
	      );
	    }
	  }]);
	  return TableRow;
	}(_react.Component);
	
	TableRow.defaultProps = {
	  displayBorder: true,
	  hoverable: false,
	  hovered: false,
	  selectable: true,
	  selected: false,
	  striped: false
	};
	TableRow.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TableRow.propTypes = {
	  /**
	   * Children passed to table row.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, row border will be displayed for the row.
	   * If false, no border will be drawn.
	   */
	  displayBorder: _propTypes2.default.bool,
	  /**
	   * Controls whether or not the row responds to hover events.
	   */
	  hoverable: _propTypes2.default.bool,
	  /**
	   * Controls whether or not the row should be rendered as being
	   * hovered. This property is evaluated in addition to this.state.hovered
	   * and can be used to synchronize the hovered state with some other
	   * external events.
	   */
	  hovered: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when row is clicked.
	   */
	  onRowClick: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * Number to identify the row. This property is
	   * automatically populated when used with the TableBody component.
	   */
	  rowNumber: _propTypes2.default.number,
	  /**
	   * If true, table rows can be selected. If multiple row
	   * selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * Indicates that a particular row is selected.
	   * This property can be used to programmatically select rows.
	   */
	  selected: _propTypes2.default.bool,
	  /**
	   * Indicates whether or not the row is striped.
	   */
	  striped: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = TableRow;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    root: {
	      color: props.selected ? tabs.selectedTextColor : tabs.textColor,
	      fontWeight: 500,
	      fontSize: 14,
	      width: props.width,
	      textTransform: 'uppercase',
	      padding: 0
	    },
	    button: {
	      display: 'flex',
	      flexDirection: 'column',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: props.label && props.icon ? 72 : 48
	    }
	  };
	}
	
	var Tab = function (_Component) {
	  (0, _inherits3.default)(Tab, _Component);
	
	  function Tab() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tab);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tab.__proto__ || (0, _getPrototypeOf2.default)(Tab)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(_this.props.value, event, _this);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tab, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          icon = _props.icon,
	          index = _props.index,
	          onActive = _props.onActive,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          label = _props.label,
	          buttonStyle = _props.buttonStyle,
	          style = _props.style,
	          value = _props.value,
	          width = _props.width,
	          other = (0, _objectWithoutProperties3.default)(_props, ['icon', 'index', 'onActive', 'onTouchTap', 'selected', 'label', 'buttonStyle', 'style', 'value', 'width']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (icon && _react2.default.isValidElement(icon)) {
	        var iconProps = {
	          style: {
	            fontSize: 24,
	            color: styles.root.color,
	            marginBottom: label ? 5 : 0
	          }
	        };
	        // If it's svg icon set color via props
	        if (icon.type.muiName !== 'FontIcon') {
	          iconProps.color = styles.root.color;
	        }
	        iconElement = _react2.default.cloneElement(icon, iconProps);
	      }
	
	      var rippleOpacity = 0.3;
	      var rippleColor = this.context.muiTheme.tabs.selectedTextColor;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          focusRippleColor: rippleColor,
	          touchRippleColor: rippleColor,
	          focusRippleOpacity: rippleOpacity,
	          touchRippleOpacity: rippleOpacity,
	          onTouchTap: this.handleTouchTap
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: (0, _simpleAssign2.default)(styles.button, buttonStyle) },
	          iconElement,
	          label
	        )
	      );
	    }
	  }]);
	  return Tab;
	}(_react.Component);
	
	Tab.muiName = 'Tab';
	Tab.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Tab.propTypes = {
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _propTypes2.default.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Sets the icon of the tab, you can pass `FontIcon` or `SvgIcon` elements.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  index: _propTypes2.default.any,
	  /**
	   * Sets the text value of the tab item to the string specified.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Fired when the active tab changes by touch or tap.
	   * Use this event to specify any functionality when an active tab changes.
	   * For example - we are using this to route to home when the third tab becomes active.
	   * This function will always recieve the active tab as it\'s first argument.
	   */
	  onActive: _propTypes2.default.func,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Defines if the current tab is selected or not.
	   * The Tabs component is responsible for setting this property.
	   */
	  selected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * If value prop passed to Tabs component, this value prop is also required.
	   * It assigns a value to the tab so that it can be selected by the Tabs.
	   */
	  value: _propTypes2.default.any,
	  /**
	   * @ignore
	   * This property is overriden by the Tabs component.
	   */
	  width: _propTypes2.default.string
	} : void 0;
	exports.default = Tab;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _slicedToArray2 = __webpack_require__(164);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _timeUtils = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var styles = {
	    root: {
	      directionInvariant: true,
	      display: 'inline-block',
	      position: 'absolute',
	      width: 32,
	      height: 32,
	      borderRadius: '100%',
	      left: 'calc(50% - 16px)',
	      top: 10,
	      textAlign: 'center',
	      paddingTop: 5,
	      userSelect: 'none', /* Chrome all / Safari all */
	      fontSize: '1.1em',
	      pointerEvents: 'none',
	      boxSizing: 'border-box'
	    }
	  };
	
	  var muiTheme = context.muiTheme;
	
	
	  var pos = props.value;
	
	  if (props.type === 'hour') {
	    pos %= 12;
	  } else {
	    pos = pos / 5;
	  }
	
	  var positions = [[0, 5], [54.5, 16.6], [94.4, 59.5], [109, 114], [94.4, 168.5], [54.5, 208.4], [0, 223], [-54.5, 208.4], [-94.4, 168.5], [-109, 114], [-94.4, 59.5], [-54.5, 19.6]];
	
	  var innerPositions = [[0, 40], [36.9, 49.9], [64, 77], [74, 114], [64, 151], [37, 178], [0, 188], [-37, 178], [-64, 151], [-74, 114], [-64, 77], [-37, 50]];
	
	  if (props.isSelected) {
	    styles.root.backgroundColor = muiTheme.timePicker.accentColor;
	    styles.root.color = muiTheme.timePicker.selectTextColor;
	  }
	
	  var transformPos = positions[pos];
	
	  if ((0, _timeUtils.isInner)(props)) {
	    styles.root.width = 28;
	    styles.root.height = 28;
	    styles.root.left = 'calc(50% - 14px)';
	    transformPos = innerPositions[pos];
	  }
	
	  var _transformPos = transformPos,
	      _transformPos2 = (0, _slicedToArray3.default)(_transformPos, 2),
	      x = _transformPos2[0],
	      y = _transformPos2[1];
	
	  styles.root.transform = 'translate(' + x + 'px, ' + y + 'px)';
	
	  return styles;
	}
	
	var ClockNumber = function (_Component) {
	  (0, _inherits3.default)(ClockNumber, _Component);
	
	  function ClockNumber() {
	    (0, _classCallCheck3.default)(this, ClockNumber);
	    return (0, _possibleConstructorReturn3.default)(this, (ClockNumber.__proto__ || (0, _getPrototypeOf2.default)(ClockNumber)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ClockNumber, [{
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var clockNumber = this.props.value === 0 ? '00' : this.props.value;
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles(styles.root) },
	        clockNumber
	      );
	    }
	  }]);
	  return ClockNumber;
	}(_react.Component);
	
	ClockNumber.defaultProps = {
	  value: 0,
	  type: 'minute',
	  isSelected: false
	};
	ClockNumber.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ClockNumber.propTypes = {
	  isSelected: _propTypes2.default.bool,
	  onSelected: _propTypes2.default.func,
	  type: _propTypes2.default.oneOf(['hour', 'minute']),
	  value: _propTypes2.default.number
	} : void 0;
	exports.default = ClockNumber;

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _timeUtils = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calcAngle(value, base) {
	  value %= base;
	  var angle = 360 / base * value;
	  return angle;
	}
	
	function getStyles(props, context, state) {
	  var hasSelected = props.hasSelected,
	      type = props.type,
	      value = props.value;
	  var inner = state.inner;
	  var timePicker = context.muiTheme.timePicker;
	
	  var angle = type === 'hour' ? calcAngle(value, 12) : calcAngle(value, 60);
	
	  var styles = {
	    root: {
	      height: inner ? '30%' : '40%',
	      background: timePicker.accentColor,
	      width: 2,
	      left: 'calc(50% - 1px)',
	      position: 'absolute',
	      bottom: '50%',
	      transformOrigin: 'bottom',
	      pointerEvents: 'none',
	      transform: 'rotateZ(' + angle + 'deg)'
	    },
	    mark: {
	      boxSizing: 'content-box',
	      background: timePicker.selectTextColor,
	      border: '4px solid ' + timePicker.accentColor,
	      display: hasSelected && 'none',
	      width: 7,
	      height: 7,
	      position: 'absolute',
	      top: -5,
	      left: -6,
	      borderRadius: '100%'
	    }
	  };
	
	  return styles;
	}
	
	var ClockPointer = function (_Component) {
	  (0, _inherits3.default)(ClockPointer, _Component);
	
	  function ClockPointer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockPointer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockPointer.__proto__ || (0, _getPrototypeOf2.default)(ClockPointer)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      inner: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockPointer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(this.props)
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        inner: (0, _timeUtils.isInner)(nextProps)
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      if (this.props.value === null) {
	        return _react2.default.createElement('span', null);
	      }
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement('div', { style: prepareStyles(styles.mark) })
	      );
	    }
	  }]);
	  return ClockPointer;
	}(_react.Component);
	
	ClockPointer.defaultProps = {
	  hasSelected: false,
	  value: null,
	  type: 'minute'
	};
	ClockPointer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ClockPointer.propTypes = {
	  hasSelected: _propTypes2.default.bool,
	  type: _propTypes2.default.oneOf(['hour', 'minute']),
	  value: _propTypes2.default.number
	} : void 0;
	exports.default = ClockPointer;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var firstChild = props.firstChild,
	      lastChild = props.lastChild;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  var marginHorizontal = baseTheme.spacing.desktopGutter;
	  var marginVertical = (toolbar.height - button.height) / 2;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      marginLeft: firstChild ? -marginHorizontal : undefined,
	      marginRight: lastChild ? -marginHorizontal : undefined,
	      display: 'flex',
	      justifyContent: 'space-between',
	      alignItems: 'center'
	    },
	    dropDownMenu: {
	      root: {
	        color: toolbar.color, // removes hover color change, we want to keep it
	        marginRight: baseTheme.spacing.desktopGutter,
	        flex: 1,
	        whiteSpace: 'nowrap'
	      },
	      controlBg: {
	        backgroundColor: toolbar.menuHoverColor,
	        borderRadius: 0
	      },
	      underline: {
	        display: 'none'
	      }
	    },
	    button: {
	      margin: marginVertical + 'px ' + marginHorizontal + 'px',
	      position: 'relative'
	    },
	    icon: {
	      root: {
	        cursor: 'pointer',
	        lineHeight: toolbar.height + 'px',
	        paddingLeft: baseTheme.spacing.desktopGutter
	      }
	    },
	    span: {
	      color: toolbar.iconColor,
	      lineHeight: toolbar.height + 'px'
	    }
	  };
	
	  return styles;
	}
	
	var ToolbarGroup = function (_Component) {
	  (0, _inherits3.default)(ToolbarGroup, _Component);
	
	  function ToolbarGroup() {
	    (0, _classCallCheck3.default)(this, ToolbarGroup);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarGroup.__proto__ || (0, _getPrototypeOf2.default)(ToolbarGroup)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarGroup, [{
	    key: 'handleMouseLeaveFontIcon',
	    value: function handleMouseLeaveFontIcon(style) {
	      return function (event) {
	        event.target.style.zIndex = 'auto';
	        event.target.style.color = style.root.color;
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          firstChild = _props.firstChild,
	          lastChild = _props.lastChild,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'firstChild', 'lastChild', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (!currentChild) {
	          return null;
	        }
	        if (!currentChild.type) {
	          return currentChild;
	        }
	        switch (currentChild.type.muiName) {
	          case 'DropDownMenu':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.dropDownMenu.root, currentChild.props.style),
	              underlineStyle: styles.dropDownMenu.underline
	            });
	          case 'RaisedButton':
	          case 'FlatButton':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.button, currentChild.props.style)
	            });
	          case 'FontIcon':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.icon.root, currentChild.props.style),
	              color: currentChild.props.color || _this2.context.muiTheme.toolbar.iconColor,
	              hoverColor: currentChild.props.hoverColor || _this2.context.muiTheme.toolbar.hoverColor
	            });
	          case 'ToolbarSeparator':
	          case 'ToolbarTitle':
	            return _react2.default.cloneElement(currentChild, {
	              style: (0, _simpleAssign2.default)({}, styles.span, currentChild.props.style)
	            });
	          default:
	            return currentChild;
	        }
	      }, this);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        newChildren
	      );
	    }
	  }]);
	  return ToolbarGroup;
	}(_react.Component);
	
	ToolbarGroup.defaultProps = {
	  firstChild: false,
	  lastChild: false
	};
	ToolbarGroup.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ToolbarGroup.propTypes = {
	  /**
	   * Can be any node or number of nodes.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the first child of `Toolbar`
	   * to prevent setting the left gap.
	   */
	  firstChild: _propTypes2.default.bool,
	  /**
	   * Set this to true for if the `ToolbarGroup` is the last child of `Toolbar`
	   * to prevent setting the right gap.
	   */
	  lastChild: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = ToolbarGroup;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      backgroundColor: toolbar.separatorColor,
	      display: 'block',
	      height: baseTheme.spacing.desktopGutterMore,
	      marginLeft: baseTheme.spacing.desktopGutter,
	      width: 1
	    }
	  };
	}
	
	var ToolbarSeparator = function (_Component) {
	  (0, _inherits3.default)(ToolbarSeparator, _Component);
	
	  function ToolbarSeparator() {
	    (0, _classCallCheck3.default)(this, ToolbarSeparator);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarSeparator.__proto__ || (0, _getPrototypeOf2.default)(ToolbarSeparator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarSeparator, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['className', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }));
	    }
	  }]);
	  return ToolbarSeparator;
	}(_react.Component);
	
	ToolbarSeparator.muiName = 'ToolbarSeparator';
	ToolbarSeparator.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ToolbarSeparator.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = ToolbarSeparator;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      lineHeight: toolbar.height + 'px',
	      fontSize: toolbar.titleFontSize,
	      fontFamily: baseTheme.fontFamily,
	      position: 'relative',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    }
	  };
	}
	
	var ToolbarTitle = function (_Component) {
	  (0, _inherits3.default)(ToolbarTitle, _Component);
	
	  function ToolbarTitle() {
	    (0, _classCallCheck3.default)(this, ToolbarTitle);
	    return (0, _possibleConstructorReturn3.default)(this, (ToolbarTitle.__proto__ || (0, _getPrototypeOf2.default)(ToolbarTitle)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ToolbarTitle, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          text = _props.text,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'text']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style))
	        }, other),
	        text
	      );
	    }
	  }]);
	  return ToolbarTitle;
	}(_react.Component);
	
	ToolbarTitle.muiName = 'ToolbarTitle';
	ToolbarTitle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ToolbarTitle.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The text to be displayed.
	   */
	  text: _propTypes2.default.node
	} : void 0;
	exports.default = ToolbarTitle;

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _AutoLockScrolling = __webpack_require__(873);
	
	var _AutoLockScrolling2 = _interopRequireDefault(_AutoLockScrolling);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var overlay = context.muiTheme.overlay;
	
	
	  var style = {
	    root: {
	      position: 'fixed',
	      height: '100%',
	      width: '100%',
	      top: 0,
	      left: '-100%',
	      opacity: 0,
	      backgroundColor: overlay.backgroundColor,
	      WebkitTapHighlightColor: 'rgba(0, 0, 0, 0)', // Remove mobile color flashing (deprecated)
	
	      // Two ways to promote overlay to its own render layer
	      willChange: 'opacity',
	      transform: 'translateZ(0)',
	
	      transition: props.transitionEnabled && _transitions2.default.easeOut('0ms', 'left', '400ms') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    }
	  };
	
	  if (props.show) {
	    (0, _simpleAssign2.default)(style.root, {
	      left: 0,
	      opacity: 1,
	      transition: _transitions2.default.easeOut('0ms', 'left') + ', ' + _transitions2.default.easeOut('400ms', 'opacity')
	    });
	  }
	
	  return style;
	}
	
	var Overlay = function (_Component) {
	  (0, _inherits3.default)(Overlay, _Component);
	
	  function Overlay() {
	    (0, _classCallCheck3.default)(this, Overlay);
	    return (0, _possibleConstructorReturn3.default)(this, (Overlay.__proto__ || (0, _getPrototypeOf2.default)(Overlay)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Overlay, [{
	    key: 'setOpacity',
	    value: function setOpacity(opacity) {
	      this.refs.overlay.style.opacity = opacity;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoLockScrolling = _props.autoLockScrolling,
	          show = _props.show,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoLockScrolling', 'show', 'style', 'transitionEnabled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'overlay', style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        autoLockScrolling && _react2.default.createElement(_AutoLockScrolling2.default, { lock: show })
	      );
	    }
	  }]);
	  return Overlay;
	}(_react.Component);
	
	Overlay.defaultProps = {
	  autoLockScrolling: true,
	  style: {},
	  transitionEnabled: true
	};
	Overlay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Overlay.propTypes = {
	  autoLockScrolling: _propTypes2.default.bool,
	  show: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  transitionEnabled: _propTypes2.default.bool
	} : void 0;
	exports.default = Overlay;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _dom = __webpack_require__(390);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// heavily inspired by https://github.com/Khan/react-components/blob/master/js/layered-component-mixin.jsx
	var RenderToLayer = function (_Component) {
	  (0, _inherits3.default)(RenderToLayer, _Component);
	
	  function RenderToLayer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RenderToLayer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RenderToLayer.__proto__ || (0, _getPrototypeOf2.default)(RenderToLayer)).call.apply(_ref, [this].concat(args))), _this), _this.onClickAway = function (event) {
	      if (event.defaultPrevented) {
	        return;
	      }
	
	      if (!_this.props.componentClickAway) {
	        return;
	      }
	
	      if (!_this.props.open) {
	        return;
	      }
	
	      var el = _this.layer;
	      if (event.target !== el && event.target === window || document.documentElement.contains(event.target) && !_dom2.default.isDescendant(el, event.target)) {
	        _this.props.componentClickAway(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RenderToLayer, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.renderLayer();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.unrenderLayer();
	    }
	  }, {
	    key: 'getLayer',
	    value: function getLayer() {
	      return this.layer;
	    }
	  }, {
	    key: 'unrenderLayer',
	    value: function unrenderLayer() {
	      if (!this.layer) {
	        return;
	      }
	
	      if (this.props.useLayerForClickAway) {
	        this.layer.style.position = 'relative';
	        this.layer.removeEventListener('touchstart', this.onClickAway);
	        this.layer.removeEventListener('click', this.onClickAway);
	      } else {
	        window.removeEventListener('touchstart', this.onClickAway);
	        window.removeEventListener('click', this.onClickAway);
	      }
	
	      (0, _reactDom.unmountComponentAtNode)(this.layer);
	      document.body.removeChild(this.layer);
	      this.layer = null;
	    }
	
	    /**
	     * By calling this method in componentDidMount() and
	     * componentDidUpdate(), you're effectively creating a "wormhole" that
	     * funnels React's hierarchical updates through to a DOM node on an
	     * entirely different part of the page.
	     */
	
	  }, {
	    key: 'renderLayer',
	    value: function renderLayer() {
	      var _this2 = this;
	
	      var _props = this.props,
	          open = _props.open,
	          render = _props.render;
	
	
	      if (open) {
	        if (!this.layer) {
	          this.layer = document.createElement('div');
	          document.body.appendChild(this.layer);
	
	          if (this.props.useLayerForClickAway) {
	            this.layer.addEventListener('touchstart', this.onClickAway);
	            this.layer.addEventListener('click', this.onClickAway);
	            this.layer.style.position = 'fixed';
	            this.layer.style.top = 0;
	            this.layer.style.bottom = 0;
	            this.layer.style.left = 0;
	            this.layer.style.right = 0;
	            this.layer.style.zIndex = this.context.muiTheme.zIndex.layer;
	          } else {
	            setTimeout(function () {
	              window.addEventListener('touchstart', _this2.onClickAway);
	              window.addEventListener('click', _this2.onClickAway);
	            }, 0);
	          }
	        }
	
	        var layerElement = render();
	        this.layerElement = (0, _reactDom.unstable_renderSubtreeIntoContainer)(this, layerElement, this.layer);
	      } else {
	        this.unrenderLayer();
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return RenderToLayer;
	}(_react.Component);
	
	RenderToLayer.defaultProps = {
	  useLayerForClickAway: true
	};
	RenderToLayer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? RenderToLayer.propTypes = {
	  componentClickAway: _propTypes2.default.func,
	  open: _propTypes2.default.bool.isRequired,
	  render: _propTypes2.default.func.isRequired,
	  useLayerForClickAway: _propTypes2.default.bool
	} : void 0;
	exports.default = RenderToLayer;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var verticalPosition = props.verticalPosition;
	  var horizontalPosition = props.horizontalPosition;
	  var touchMarginOffset = props.touch ? 10 : 0;
	  var touchOffsetTop = props.touch ? -20 : -10;
	  var offset = verticalPosition === 'bottom' ? 14 + touchMarginOffset : -14 - touchMarginOffset;
	
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      zIndex = _context$muiTheme.zIndex,
	      tooltip = _context$muiTheme.tooltip,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'absolute',
	      fontFamily: baseTheme.fontFamily,
	      fontSize: '10px',
	      lineHeight: '22px',
	      padding: '0 8px',
	      zIndex: zIndex.tooltip,
	      color: tooltip.color,
	      overflow: 'hidden',
	      top: -10000,
	      borderRadius: borderRadius,
	      userSelect: 'none',
	      opacity: 0,
	      right: horizontalPosition === 'left' ? 12 : null,
	      left: horizontalPosition === 'center' ? (state.offsetWidth - 48) / 2 * -1 : horizontalPosition === 'right' ? 12 : null,
	      transition: _transitions2.default.easeOut('0ms', 'top', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    label: {
	      position: 'relative',
	      whiteSpace: 'nowrap'
	    },
	    ripple: {
	      position: 'absolute',
	      left: horizontalPosition === 'center' ? '50%' : horizontalPosition === 'left' ? '100%' : '0%',
	      top: verticalPosition === 'bottom' ? 0 : '100%',
	      transform: 'translate(-50%, -50%)',
	      borderRadius: '50%',
	      backgroundColor: 'transparent',
	      transition: _transitions2.default.easeOut('0ms', 'width', '450ms') + ', ' + _transitions2.default.easeOut('0ms', 'height', '450ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    },
	    rootWhenShown: {
	      top: verticalPosition === 'top' ? touchOffsetTop : 36,
	      opacity: 0.9,
	      transform: 'translate(0px, ' + offset + 'px)',
	      transition: _transitions2.default.easeOut('0ms', 'top', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'transform', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'opacity', '0ms')
	    },
	    rootWhenTouched: {
	      fontSize: '14px',
	      lineHeight: '32px',
	      padding: '0 16px'
	    },
	    rippleWhenShown: {
	      backgroundColor: tooltip.rippleBackgroundColor,
	      transition: _transitions2.default.easeOut('450ms', 'width', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'height', '0ms') + ', ' + _transitions2.default.easeOut('450ms', 'backgroundColor', '0ms')
	    }
	  };
	
	  return styles;
	}
	
	var Tooltip = function (_Component) {
	  (0, _inherits3.default)(Tooltip, _Component);
	
	  function Tooltip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tooltip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tooltip.__proto__ || (0, _getPrototypeOf2.default)(Tooltip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      offsetWidth: null
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tooltip, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setRippleSize();
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      this.setTooltipPosition();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.setRippleSize();
	    }
	  }, {
	    key: 'setRippleSize',
	    value: function setRippleSize() {
	      var ripple = this.refs.ripple;
	      var tooltip = this.refs.tooltip;
	      var tooltipWidth = parseInt(tooltip.offsetWidth, 10) / (this.props.horizontalPosition === 'center' ? 2 : 1);
	      var tooltipHeight = parseInt(tooltip.offsetHeight, 10);
	
	      var rippleDiameter = Math.ceil(Math.sqrt(Math.pow(tooltipHeight, 2) + Math.pow(tooltipWidth, 2)) * 2);
	      if (this.props.show) {
	        ripple.style.height = rippleDiameter + 'px';
	        ripple.style.width = rippleDiameter + 'px';
	      } else {
	        ripple.style.width = '0px';
	        ripple.style.height = '0px';
	      }
	    }
	  }, {
	    key: 'setTooltipPosition',
	    value: function setTooltipPosition() {
	      this.setState({ offsetWidth: this.refs.tooltip.offsetWidth });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          horizontalPosition = _props.horizontalPosition,
	          label = _props.label,
	          show = _props.show,
	          touch = _props.touch,
	          verticalPosition = _props.verticalPosition,
	          other = (0, _objectWithoutProperties3.default)(_props, ['horizontalPosition', 'label', 'show', 'touch', 'verticalPosition']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: 'tooltip',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, this.props.show && styles.rootWhenShown, this.props.touch && styles.rootWhenTouched, this.props.style))
	        }),
	        _react2.default.createElement('div', {
	          ref: 'ripple',
	          style: prepareStyles((0, _simpleAssign2.default)(styles.ripple, this.props.show && styles.rippleWhenShown))
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          label
	        )
	      );
	    }
	  }]);
	  return Tooltip;
	}(_react.Component);
	
	Tooltip.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Tooltip.propTypes = {
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  horizontalPosition: _propTypes2.default.oneOf(['left', 'right', 'center']),
	  label: _propTypes2.default.node.isRequired,
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  touch: _propTypes2.default.bool,
	  verticalPosition: _propTypes2.default.oneOf(['top', 'bottom'])
	} : void 0;
	exports.default = Tooltip;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(97);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toArray2 = __webpack_require__(255);
	
	var _toArray3 = _interopRequireDefault(_toArray2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactAddonsTransitionGroup = __webpack_require__(118);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _dom = __webpack_require__(390);
	
	var _dom2 = _interopRequireDefault(_dom);
	
	var _CircleRipple = __webpack_require__(875);
	
	var _CircleRipple2 = _interopRequireDefault(_CircleRipple);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Remove the first element of the array
	var shift = function shift(_ref) {
	  var _ref2 = (0, _toArray3.default)(_ref),
	      newArray = _ref2.slice(1);
	
	  return newArray;
	};
	
	var TouchRipple = function (_Component) {
	  (0, _inherits3.default)(TouchRipple, _Component);
	
	  function TouchRipple(props, context) {
	    (0, _classCallCheck3.default)(this, TouchRipple);
	
	    // Touch start produces a mouse down event for compat reasons. To avoid
	    // showing ripples twice we skip showing a ripple for the first mouse down
	    // after a touch start. Note we don't store ignoreNextMouseDown in this.state
	    // to avoid re-rendering when we change it.
	    var _this = (0, _possibleConstructorReturn3.default)(this, (TouchRipple.__proto__ || (0, _getPrototypeOf2.default)(TouchRipple)).call(this, props, context));
	
	    _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.start(event, false);
	      }
	    };
	
	    _this.handleMouseUp = function () {
	      _this.end();
	    };
	
	    _this.handleMouseLeave = function () {
	      _this.end();
	    };
	
	    _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      // If the user is swiping (not just tapping), save the position so we can
	      // abort ripples if the user appears to be scrolling.
	      if (_this.props.abortOnScroll && event.touches) {
	        _this.startListeningForScrollAbort(event);
	        _this.startTime = Date.now();
	      }
	      _this.start(event, true);
	    };
	
	    _this.handleTouchEnd = function () {
	      _this.end();
	    };
	
	    _this.handleTouchMove = function (event) {
	      // Stop trying to abort if we're already 300ms into the animation
	      var timeSinceStart = Math.abs(Date.now() - _this.startTime);
	      if (timeSinceStart > 300) {
	        _this.stopListeningForScrollAbort();
	        return;
	      }
	
	      // If the user is scrolling...
	      var deltaY = Math.abs(event.touches[0].clientY - _this.firstTouchY);
	      var deltaX = Math.abs(event.touches[0].clientX - _this.firstTouchX);
	      // Call it a scroll after an arbitrary 6px (feels reasonable in testing)
	      if (deltaY > 6 || deltaX > 6) {
	        var currentRipples = _this.state.ripples;
	        var ripple = currentRipples[0];
	        // This clone will replace the ripple in ReactTransitionGroup with a
	        // version that will disappear immediately when removed from the DOM
	        var abortedRipple = _react2.default.cloneElement(ripple, { aborted: true });
	        // Remove the old ripple and replace it with the new updated one
	        currentRipples = shift(currentRipples);
	        currentRipples = [].concat((0, _toConsumableArray3.default)(currentRipples), [abortedRipple]);
	        _this.setState({ ripples: currentRipples }, function () {
	          // Call end after we've set the ripple to abort otherwise the setState
	          // in end() merges with this and the ripple abort fails
	          _this.end();
	        });
	      }
	    };
	
	    _this.ignoreNextMouseDown = false;
	
	    _this.state = {
	      // This prop allows us to only render the ReactTransitionGroup
	      // on the first click of the component, making the inital render faster.
	      hasRipples: false,
	      nextKey: 0,
	      ripples: []
	    };
	    return _this;
	  }
	
	  (0, _createClass3.default)(TouchRipple, [{
	    key: 'start',
	    value: function start(event, isRippleTouchGenerated) {
	      var theme = this.context.muiTheme.ripple;
	
	      if (this.ignoreNextMouseDown && !isRippleTouchGenerated) {
	        this.ignoreNextMouseDown = false;
	        return;
	      }
	
	      var ripples = this.state.ripples;
	
	      // Add a ripple to the ripples array
	      ripples = [].concat((0, _toConsumableArray3.default)(ripples), [_react2.default.createElement(_CircleRipple2.default, {
	        key: this.state.nextKey,
	        style: !this.props.centerRipple ? this.getRippleStyle(event) : {},
	        color: this.props.color || theme.color,
	        opacity: this.props.opacity,
	        touchGenerated: isRippleTouchGenerated
	      })]);
	
	      this.ignoreNextMouseDown = isRippleTouchGenerated;
	      this.setState({
	        hasRipples: true,
	        nextKey: this.state.nextKey + 1,
	        ripples: ripples
	      });
	    }
	  }, {
	    key: 'end',
	    value: function end() {
	      var currentRipples = this.state.ripples;
	      this.setState({
	        ripples: shift(currentRipples)
	      });
	      if (this.props.abortOnScroll) {
	        this.stopListeningForScrollAbort();
	      }
	    }
	
	    // Check if the user seems to be scrolling and abort the animation if so
	
	  }, {
	    key: 'startListeningForScrollAbort',
	    value: function startListeningForScrollAbort(event) {
	      this.firstTouchY = event.touches[0].clientY;
	      this.firstTouchX = event.touches[0].clientX;
	      // Note that when scolling Chrome throttles this event to every 200ms
	      // Also note we don't listen for scroll events directly as there's no general
	      // way to cover cases like scrolling within containers on the page
	      document.body.addEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'stopListeningForScrollAbort',
	    value: function stopListeningForScrollAbort() {
	      document.body.removeEventListener('touchmove', this.handleTouchMove);
	    }
	  }, {
	    key: 'getRippleStyle',
	    value: function getRippleStyle(event) {
	      var el = _reactDom2.default.findDOMNode(this);
	      var elHeight = el.offsetHeight;
	      var elWidth = el.offsetWidth;
	      var offset = _dom2.default.offset(el);
	      var isTouchEvent = event.touches && event.touches.length;
	      var pageX = isTouchEvent ? event.touches[0].pageX : event.pageX;
	      var pageY = isTouchEvent ? event.touches[0].pageY : event.pageY;
	      var pointerX = pageX - offset.left;
	      var pointerY = pageY - offset.top;
	      var topLeftDiag = this.calcDiag(pointerX, pointerY);
	      var topRightDiag = this.calcDiag(elWidth - pointerX, pointerY);
	      var botRightDiag = this.calcDiag(elWidth - pointerX, elHeight - pointerY);
	      var botLeftDiag = this.calcDiag(pointerX, elHeight - pointerY);
	      var rippleRadius = Math.max(topLeftDiag, topRightDiag, botRightDiag, botLeftDiag);
	      var rippleSize = rippleRadius * 2;
	      var left = pointerX - rippleRadius;
	      var top = pointerY - rippleRadius;
	
	      return {
	        directionInvariant: true,
	        height: rippleSize,
	        width: rippleSize,
	        top: top,
	        left: left
	      };
	    }
	  }, {
	    key: 'calcDiag',
	    value: function calcDiag(a, b) {
	      return Math.sqrt(a * a + b * b);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          style = _props.style;
	      var _state = this.state,
	          hasRipples = _state.hasRipples,
	          ripples = _state.ripples;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var rippleGroup = void 0;
	
	      if (hasRipples) {
	        var mergedStyles = (0, _simpleAssign2.default)({
	          height: '100%',
	          width: '100%',
	          position: 'absolute',
	          top: 0,
	          left: 0,
	          overflow: 'hidden',
	          pointerEvents: 'none'
	        }, style);
	
	        rippleGroup = _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          { style: prepareStyles(mergedStyles) },
	          ripples
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          onMouseUp: this.handleMouseUp,
	          onMouseDown: this.handleMouseDown,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart,
	          onTouchEnd: this.handleTouchEnd
	        },
	        rippleGroup,
	        children
	      );
	    }
	  }]);
	  return TouchRipple;
	}(_react.Component);
	
	TouchRipple.defaultProps = {
	  abortOnScroll: true
	};
	TouchRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TouchRipple.propTypes = {
	  abortOnScroll: _propTypes2.default.bool,
	  centerRipple: _propTypes2.default.bool,
	  children: _propTypes2.default.node,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = TouchRipple;

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCheckCircle = function ActionCheckCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ActionCheckCircle = (0, _pure2.default)(ActionCheckCircle);
	ActionCheckCircle.displayName = 'ActionCheckCircle';
	ActionCheckCircle.muiName = 'SvgIcon';
	
	exports.default = ActionCheckCircle;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowDown = function HardwareKeyboardArrowDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 7.84L12 12.42l4.59-4.58L18 9.25l-6 6-6-6z' })
	  );
	};
	HardwareKeyboardArrowDown = (0, _pure2.default)(HardwareKeyboardArrowDown);
	HardwareKeyboardArrowDown.displayName = 'HardwareKeyboardArrowDown';
	HardwareKeyboardArrowDown.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowDown;

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowUp = function HardwareKeyboardArrowUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 15.41L12 10.83l4.59 4.58L18 14l-6-6-6 6z' })
	  );
	};
	HardwareKeyboardArrowUp = (0, _pure2.default)(HardwareKeyboardArrowUp);
	HardwareKeyboardArrowUp.displayName = 'HardwareKeyboardArrowUp';
	HardwareKeyboardArrowUp.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowUp;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDown = function NavigationArrowDropDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 10l5 5 5-5z' })
	  );
	};
	NavigationArrowDropDown = (0, _pure2.default)(NavigationArrowDropDown);
	NavigationArrowDropDown.displayName = 'NavigationArrowDropDown';
	NavigationArrowDropDown.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDown;

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCancel = function NavigationCancel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z' })
	  );
	};
	NavigationCancel = (0, _pure2.default)(NavigationCancel);
	NavigationCancel.displayName = 'NavigationCancel';
	NavigationCancel.muiName = 'SvgIcon';
	
	exports.default = NavigationCancel;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationCheck = function NavigationCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z' })
	  );
	};
	NavigationCheck = (0, _pure2.default)(NavigationCheck);
	NavigationCheck.displayName = 'NavigationCheck';
	NavigationCheck.muiName = 'SvgIcon';
	
	exports.default = NavigationCheck;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronLeft = function NavigationChevronLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	NavigationChevronLeft = (0, _pure2.default)(NavigationChevronLeft);
	NavigationChevronLeft.displayName = 'NavigationChevronLeft';
	NavigationChevronLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronLeft;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationChevronRight = function NavigationChevronRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	NavigationChevronRight = (0, _pure2.default)(NavigationChevronRight);
	NavigationChevronRight.displayName = 'NavigationChevronRight';
	NavigationChevronRight.muiName = 'SvgIcon';
	
	exports.default = NavigationChevronRight;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandLess = function NavigationExpandLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8l-6 6 1.41 1.41L12 10.83l4.59 4.58L18 14z' })
	  );
	};
	NavigationExpandLess = (0, _pure2.default)(NavigationExpandLess);
	NavigationExpandLess.displayName = 'NavigationExpandLess';
	NavigationExpandLess.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandLess;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationExpandMore = function NavigationExpandMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.59 8.59L12 13.17 7.41 8.59 6 10l6 6 6-6z' })
	  );
	};
	NavigationExpandMore = (0, _pure2.default)(NavigationExpandMore);
	NavigationExpandMore.displayName = 'NavigationExpandMore';
	NavigationExpandMore.muiName = 'SvgIcon';
	
	exports.default = NavigationExpandMore;

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMenu = function NavigationMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z' })
	  );
	};
	NavigationMenu = (0, _pure2.default)(NavigationMenu);
	NavigationMenu.displayName = 'NavigationMenu';
	NavigationMenu.muiName = 'SvgIcon';
	
	exports.default = NavigationMenu;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBoxOutlineBlank = function ToggleCheckBoxOutlineBlank(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ToggleCheckBoxOutlineBlank = (0, _pure2.default)(ToggleCheckBoxOutlineBlank);
	ToggleCheckBoxOutlineBlank.displayName = 'ToggleCheckBoxOutlineBlank';
	ToggleCheckBoxOutlineBlank.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBoxOutlineBlank;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleCheckBox = function ToggleCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z' })
	  );
	};
	ToggleCheckBox = (0, _pure2.default)(ToggleCheckBox);
	ToggleCheckBox.displayName = 'ToggleCheckBox';
	ToggleCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleCheckBox;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonChecked = function ToggleRadioButtonChecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonChecked = (0, _pure2.default)(ToggleRadioButtonChecked);
	ToggleRadioButtonChecked.displayName = 'ToggleRadioButtonChecked';
	ToggleRadioButtonChecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonChecked;

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleRadioButtonUnchecked = function ToggleRadioButtonUnchecked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ToggleRadioButtonUnchecked = (0, _pure2.default)(ToggleRadioButtonUnchecked);
	ToggleRadioButtonUnchecked.displayName = 'ToggleRadioButtonUnchecked';
	ToggleRadioButtonUnchecked.muiName = 'SvgIcon';
	
	exports.default = ToggleRadioButtonUnchecked;

/***/ },
/* 390 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  isDescendant: function isDescendant(parent, child) {
	    var node = child.parentNode;
	
	    while (node !== null) {
	      if (node === parent) return true;
	      node = node.parentNode;
	    }
	
	    return false;
	  },
	  offset: function offset(el) {
	    var rect = el.getBoundingClientRect();
	    return {
	      top: rect.top + document.body.scrollTop,
	      left: rect.left + document.body.scrollLeft
	    };
	  }
	};

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	var DEBUG = false; // `true` to print debugging info.
	var TIMER = false; // `true` to time calls to `lex()` and print the results.
	
	var debug = __webpack_require__(224)('lex');
	
	exports = module.exports = lex;
	
	/**
	 * Convert a CSS string into an array of lexical tokens.
	 *
	 * @param {String} css CSS
	 * @returns {Array} lexical tokens
	 */
	function lex(css) {
	  var start; // Debug timer start.
	
	  var buffer = '';      // Character accumulator
	  var ch;               // Current character
	  var column = 0;       // Current source column number
	  var cursor = -1;      // Current source cursor position
	  var depth = 0;        // Current nesting depth
	  var line = 1;         // Current source line number
	  var state = 'before-selector'; // Current state
	  var stack = [state];  // State stack
	  var token = {};       // Current token
	  var tokens = [];      // Token accumulator
	
	  // Supported @-rules, in roughly descending order of usage probability.
	  var atRules = [
	    'media',
	    'keyframes',
	    { name: '-webkit-keyframes', type: 'keyframes', prefix: '-webkit-' },
	    { name: '-moz-keyframes', type: 'keyframes', prefix: '-moz-' },
	    { name: '-ms-keyframes', type: 'keyframes', prefix: '-ms-' },
	    { name: '-o-keyframes', type: 'keyframes', prefix: '-o-' },
	    'font-face',
	    { name: 'import', state: 'before-at-value' },
	    { name: 'charset', state: 'before-at-value' },
	    'supports',
	    'viewport',
	    { name: 'namespace', state: 'before-at-value' },
	    'document',
	    { name: '-moz-document', type: 'document', prefix: '-moz-' },
	    'page'
	  ];
	
	  // -- Functions ------------------------------------------------------------
	
	  /**
	   * Advance the character cursor and return the next character.
	   *
	   * @returns {String} The next character.
	   */
	  function getCh() {
	    skip();
	    return css[cursor];
	  }
	
	  /**
	   * Return the state at the given index in the stack.
	   * The stack is LIFO so indexing is from the right.
	   *
	   * @param {Number} [index=0] Index to return.
	   * @returns {String} state
	   */
	  function getState(index) {
	    return index ? stack[stack.length - 1 - index] : state;
	  }
	
	  /**
	   * Look ahead for a string beginning from the next position. The string
	   * being looked for must start at the next position.
	   *
	   * @param {String} str The string to look for.
	   * @returns {Boolean} Whether the string was found.
	   */
	  function isNextString(str) {
	    var start = cursor + 1;
	    return (str === css.slice(start, start + str.length));
	  }
	
	  /**
	   * Find the start position of a substring beginning from the next
	   * position. The string being looked for may begin anywhere.
	   *
	   * @param {String} str The substring to look for.
	   * @returns {Number|false} The position, or `false` if not found.
	   */
	  function find(str) {
	    var pos = css.slice(cursor).indexOf(str);
	
	    return pos > 0 ? pos : false;
	  }
	
	  /**
	   * Determine whether a character is next.
	   *
	   * @param {String} ch Character.
	   * @returns {Boolean} Whether the character is next.
	   */
	  function isNextChar(ch) {
	    return ch === peek(1);
	  }
	
	  /**
	   * Return the character at the given cursor offset. The offset is relative
	   * to the cursor, so negative values move backwards.
	   *
	   * @param {Number} [offset=1] Cursor offset.
	   * @returns {String} Character.
	   */
	  function peek(offset) {
	    return css[cursor + (offset || 1)];
	  }
	
	  /**
	   * Remove the current state from the stack and set the new current state.
	   *
	   * @returns {String} The removed state.
	   */
	  function popState() {
	    var removed = stack.pop();
	    state = stack[stack.length - 1];
	
	    return removed;
	  }
	
	  /**
	   * Set the current state and add it to the stack.
	   *
	   * @param {String} newState The new state.
	   * @returns {Number} The new stack length.
	   */
	  function pushState(newState) {
	    state = newState;
	    stack.push(state);
	
	    return stack.length;
	  }
	
	  /**
	   * Replace the current state with a new state.
	   *
	   * @param {String} newState The new state.
	   * @returns {String} The replaced state.
	   */
	  function replaceState(newState) {
	    var previousState = state;
	    stack[stack.length - 1] = state = newState;
	
	    return previousState;
	  }
	
	  /**
	   * Move the character cursor. Positive numbers move the cursor forward.
	   * Negative numbers are not supported!
	   *
	   * @param {Number} [n=1] Number of characters to skip.
	   */
	  function skip(n) {
	    if ((n || 1) == 1) {
	      if (css[cursor] == '\n') {
	        line++;
	        column = 1;
	      } else {
	        column++;
	      }
	      cursor++;
	    } else {
	      var skipStr = css.slice(cursor, cursor + n).split('\n');
	      if (skipStr.length > 1) {
	        line += skipStr.length - 1;
	        column = 1;
	      }
	      column += skipStr[skipStr.length - 1].length;
	      cursor = cursor + n;
	    }
	  }
	
	  /**
	   * Add the current token to the pile and reset the buffer.
	   */
	  function addToken() {
	    token.end = {
	      line: line,
	      col: column
	    };
	
	    DEBUG && debug('addToken:', JSON.stringify(token, null, 2));
	
	    tokens.push(token);
	
	    buffer = '';
	    token = {};
	  }
	
	  /**
	   * Set the current token.
	   *
	   * @param {String} type Token type.
	   */
	  function initializeToken(type) {
	    token = {
	      type: type,
	      start: {
	        line: line,
	        col : column
	      }
	    };
	  }
	
	  // -- Main Loop ------------------------------------------------------------
	
	  /*
	  The main loop is a state machine that reads in one character at a time,
	  and determines what to do based on the current state and character.
	  This is implemented as a series of nested `switch` statements and the
	  case orders have been mildly optimized based on rough probabilities
	  calculated by processing a small sample of real-world CSS.
	
	  Further optimization (such as a dispatch table) shouldn't be necessary
	  since the total number of cases is very low.
	  */
	
	  TIMER && (start = Date.now());
	
	  while (ch = getCh()) {
	    DEBUG && debug(ch, getState());
	
	    // column += 1;
	
	    switch (ch) {
	    // Space
	    case ' ':
	      switch (getState()) {
	      case 'selector':
	      case 'value':
	      case 'value-paren':
	      case 'at-group':
	      case 'at-value':
	      case 'comment':
	      case 'double-string':
	      case 'single-string':
	        buffer += ch;
	        break;
	      }
	      break;
	
	    // Newline or tab
	    case '\n':
	    case '\t':
	    case '\r':
	    case '\f':
	      switch (getState()) {
	      case 'value':
	      case 'value-paren':
	      case 'at-group':
	      case 'comment':
	      case 'single-string':
	      case 'double-string':
	      case 'selector':
	        buffer += ch;
	        break;
	
	      case 'at-value':
	        // Tokenize an @-rule if a semi-colon was omitted.
	        if ('\n' === ch) {
	          token.value = buffer.trim();
	          addToken();
	          popState();
	        }
	        break;
	      }
	
	      // if ('\n' === ch) {
	      //   column = 0;
	      //   line += 1;
	      // }
	      break;
	
	    case ':':
	      switch (getState()) {
	      case 'name':
	        token.name = buffer.trim();
	        buffer = '';
	
	        replaceState('before-value');
	        break;
	
	      case 'before-selector':
	        buffer += ch;
	
	        initializeToken('selector');
	        pushState('selector');
	        break;
	
	      case 'before-value':
	        replaceState('value');
	        buffer += ch;
	        break;
	
	      default:
	        buffer += ch;
	        break;
	      }
	      break;
	
	    case ';':
	      switch (getState()) {
	      case 'name':
	      case 'before-value':
	      case 'value':
	        // Tokenize a declaration
	        // if value is empty skip the declaration
	        if (buffer.trim().length > 0) {
	          token.value = buffer.trim(),
	          addToken();
	        }
	        replaceState('before-name');
	        break;
	
	      case 'value-paren':
	        // Insignificant semi-colon
	        buffer += ch;
	        break;
	
	      case 'at-value':
	        // Tokenize an @-rule
	        token.value = buffer.trim();
	        addToken();
	        popState();
	        break;
	
	      case 'before-name':
	        // Extraneous semi-colon
	        break;
	
	      default:
	        buffer += ch;
	        break;
	      }
	      break;
	
	    case '{':
	      switch (getState()) {
	      case 'selector':
	        // If the sequence is `\{` then assume that the brace should be escaped.
	        if (peek(-1) === '\\') {
	            buffer += ch;
	            break;
	        }
	
	        // Tokenize a selector
	        token.text = buffer.trim();
	        addToken();
	        replaceState('before-name');
	        depth = depth + 1;
	        break;
	
	      case 'at-group':
	        // Tokenize an @-group
	        token.name = buffer.trim();
	
	        // XXX: @-rules are starting to get hairy
	        switch (token.type) {
	        case 'font-face':
	        case 'viewport' :
	        case 'page'     :
	          pushState('before-name');
	          break;
	
	        default:
	          pushState('before-selector');
	        }
	
	        addToken();
	        depth = depth + 1;
	        break;
	
	      case 'name':
	      case 'at-rule':
	        // Tokenize a declaration or an @-rule
	        token.name = buffer.trim();
	        addToken();
	        pushState('before-name');
	        depth = depth + 1;
	        break;
	
	      case 'comment':
	      case 'double-string':
	      case 'single-string':
	        // Ignore braces in comments and strings
	        buffer += ch;
	        break;
	      case 'before-value':
	        replaceState('value');
	        buffer += ch;
	        break;
	      }
	
	      break;
	
	    case '}':
	      switch (getState()) {
	      case 'before-name':
	      case 'name':
	      case 'before-value':
	      case 'value':
	        // If the buffer contains anything, it is a value
	        if (buffer) {
	          token.value = buffer.trim();
	        }
	
	        // If the current token has a name and a value it should be tokenized.
	        if (token.name && token.value) {
	          addToken();
	        }
	
	        // Leave the block
	        initializeToken('end');
	        addToken();
	        popState();
	
	        // We might need to leave again.
	        // XXX: What about 3 levels deep?
	        if ('at-group' === getState()) {
	          initializeToken('at-group-end');
	          addToken();
	          popState();
	        }
	        
	        if (depth > 0) {
	          depth = depth - 1;
	        }
	
	        break;
	
	      case 'at-group':
	      case 'before-selector':
	      case 'selector':
	        // If the sequence is `\}` then assume that the brace should be escaped.
	        if (peek(-1) === '\\') {
	            buffer += ch;
	            break;
	        }
	
	        if (depth > 0) {
	          // Leave block if in an at-group
	          if ('at-group' === getState(1)) {
	            initializeToken('at-group-end');
	            addToken();
	          }
	        }
	
	        if (depth > 1) {
	          popState();
	        }
	
	        if (depth > 0) {
	          depth = depth - 1;
	        }
	        break;
	
	      case 'double-string':
	      case 'single-string':
	      case 'comment':
	        // Ignore braces in comments and strings.
	        buffer += ch;
	        break;
	      }
	
	      break;
	
	    // Strings
	    case '"':
	    case "'":
	      switch (getState()) {
	      case 'double-string':
	        if ('"' === ch && '\\' !== peek(-1)) {
	          popState();
	        }
	        break;
	
	      case 'single-string':
	        if ("'" === ch && '\\' !== peek(-1)) {
	          popState();
	        }
	        break;
	
	      case 'before-at-value':
	        replaceState('at-value');
	        pushState('"' === ch ? 'double-string' : 'single-string');
	        break;
	
	      case 'before-value':
	        replaceState('value');
	        pushState('"' === ch ? 'double-string' : 'single-string');
	        break;
	
	      case 'comment':
	        // Ignore strings within comments.
	        break;
	
	      default:
	        if ('\\' !== peek(-1)) {
	          pushState('"' === ch ? 'double-string' : 'single-string');
	        }
	      }
	
	      buffer += ch;
	      break;
	
	    // Comments
	    case '/':
	      switch (getState()) {
	      case 'comment':
	      case 'double-string':
	      case 'single-string':
	        // Ignore
	        buffer += ch;
	        break;
	
	      case 'before-value':
	      case 'selector':
	      case 'name':
	      case 'value':
	        if (isNextChar('*')) {
	          // Ignore comments in selectors, properties and values. They are
	          // difficult to represent in the AST.
	          var pos = find('*/');
	
	          if (pos) {
	            skip(pos + 1);
	          }
	        } else {
	          if (getState() == 'before-value') replaceState('value');
	          buffer += ch;
	        }
	        break;
	
	      default:
	        if (isNextChar('*')) {
	          // Create a comment token
	          initializeToken('comment');
	          pushState('comment');
	          skip();
	        }
	        else {
	          buffer += ch;
	        }
	        break;
	      }
	      break;
	
	    // Comment end or universal selector
	    case '*':
	      switch (getState()) {
	      case 'comment':
	        if (isNextChar('/')) {
	          // Tokenize a comment
	          token.text = buffer; // Don't trim()!
	          skip();
	          addToken();
	          popState();
	        }
	        else {
	          buffer += ch;
	        }
	        break;
	
	      case 'before-selector':
	        buffer += ch;
	        initializeToken('selector');
	        pushState('selector');
	        break;
	
	      case 'before-value':
	        replaceState('value');
	        buffer += ch;
	        break;
	
	      default:
	        buffer += ch;
	      }
	      break;
	
	    // @-rules
	    case '@':
	      switch (getState()) {
	      case 'comment':
	      case 'double-string':
	      case 'single-string':
	        buffer += ch;
	        break;
	      case 'before-value':
	        replaceState('value');
	        buffer += ch;
	        break;
	
	      default:
	        // Iterate over the supported @-rules and attempt to tokenize one.
	        var tokenized = false;
	        var name;
	        var rule;
	
	        for (var j = 0, len = atRules.length; !tokenized && j < len; ++j) {
	          rule = atRules[j];
	          name = rule.name || rule;
	
	          if (!isNextString(name)) { continue; }
	
	          tokenized = true;
	
	          initializeToken(name);
	          pushState(rule.state || 'at-group');
	          skip(name.length);
	
	          if (rule.prefix) {
	            token.prefix = rule.prefix;
	          }
	
	          if (rule.type) {
	            token.type = rule.type;
	          }
	        }
	
	        if (!tokenized) {
	          // Keep on truckin' America!
	          buffer += ch;
	        }
	        break;
	      }
	      break;
	
	    // Parentheses are tracked to disambiguate semi-colons, such as within a
	    // data URI.
	    case '(':
	      switch (getState()) {
	      case 'value':
	        pushState('value-paren');
	        break;
	      case 'before-value':
	        replaceState('value');
	        break;
	      }
	
	      buffer += ch;
	      break;
	
	    case ')':
	      switch (getState()) {
	      case 'value-paren':
	        popState();
	        break;
	      case 'before-value':
	        replaceState('value');
	        break;
	      }
	
	      buffer += ch;
	      break;
	
	    default:
	      switch (getState()) {
	      case 'before-selector':
	        initializeToken('selector');
	        pushState('selector');
	        break;
	
	      case 'before-name':
	        initializeToken('property');
	        replaceState('name');
	        break;
	
	      case 'before-value':
	        replaceState('value');
	        break;
	
	      case 'before-at-value':
	        replaceState('at-value');
	        break;
	      }
	
	      buffer += ch;
	      break;
	    }
	  }
	
	  TIMER && debug('ran in', (Date.now() - start) + 'ms');
	
	  return tokens;
	}


/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	// React 15.5 references this module, and assumes PropTypes are still callable in production.
	// Therefore we re-export development-only version with all the PropTypes checks here.
	// However if one is migrating to the `prop-types` npm library, they will go through the
	// `index.js` entry point, and it will branch depending on the environment.
	var factory = __webpack_require__(1850);
	module.exports = function(isValidElement) {
	  // It is still allowed in 15.5.
	  var throwOnDirectAccess = false;
	  return factory(isValidElement, throwOnDirectAccess);
	};


/***/ },
/* 393 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 394 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * CSS properties which accept numbers but are not in units of "px".
	 */
	
	var isUnitlessNumber = {
	  animationIterationCount: true,
	  borderImageOutset: true,
	  borderImageSlice: true,
	  borderImageWidth: true,
	  boxFlex: true,
	  boxFlexGroup: true,
	  boxOrdinalGroup: true,
	  columnCount: true,
	  columns: true,
	  flex: true,
	  flexGrow: true,
	  flexPositive: true,
	  flexShrink: true,
	  flexNegative: true,
	  flexOrder: true,
	  gridRow: true,
	  gridRowEnd: true,
	  gridRowSpan: true,
	  gridRowStart: true,
	  gridColumn: true,
	  gridColumnEnd: true,
	  gridColumnSpan: true,
	  gridColumnStart: true,
	  fontWeight: true,
	  lineClamp: true,
	  lineHeight: true,
	  opacity: true,
	  order: true,
	  orphans: true,
	  tabSize: true,
	  widows: true,
	  zIndex: true,
	  zoom: true,
	
	  // SVG-related properties
	  fillOpacity: true,
	  floodOpacity: true,
	  stopOpacity: true,
	  strokeDasharray: true,
	  strokeDashoffset: true,
	  strokeMiterlimit: true,
	  strokeOpacity: true,
	  strokeWidth: true
	};
	
	/**
	 * @param {string} prefix vendor-specific prefix, eg: Webkit
	 * @param {string} key style name, eg: transitionDuration
	 * @return {string} style name prefixed with `prefix`, properly camelCased, eg:
	 * WebkitTransitionDuration
	 */
	function prefixKey(prefix, key) {
	  return prefix + key.charAt(0).toUpperCase() + key.substring(1);
	}
	
	/**
	 * Support style names that may come passed in prefixed by adding permutations
	 * of vendor prefixes.
	 */
	var prefixes = ['Webkit', 'ms', 'Moz', 'O'];
	
	// Using Object.keys here, or else the vanilla for-in loop makes IE8 go into an
	// infinite loop, because it iterates over the newly added props too.
	Object.keys(isUnitlessNumber).forEach(function (prop) {
	  prefixes.forEach(function (prefix) {
	    isUnitlessNumber[prefixKey(prefix, prop)] = isUnitlessNumber[prop];
	  });
	});
	
	/**
	 * Most style properties can be unset by doing .style[prop] = '' but IE8
	 * doesn't like doing that with shorthand properties so for the properties that
	 * IE8 breaks on, which are listed here, we instead unset each of the
	 * individual properties. See http://bugs.jquery.com/ticket/12385.
	 * The 4-value 'clock' properties like margin, padding, border-width seem to
	 * behave without any problems. Curiously, list-style works too without any
	 * special prodding.
	 */
	var shorthandPropertyExpansions = {
	  background: {
	    backgroundAttachment: true,
	    backgroundColor: true,
	    backgroundImage: true,
	    backgroundPositionX: true,
	    backgroundPositionY: true,
	    backgroundRepeat: true
	  },
	  backgroundPosition: {
	    backgroundPositionX: true,
	    backgroundPositionY: true
	  },
	  border: {
	    borderWidth: true,
	    borderStyle: true,
	    borderColor: true
	  },
	  borderBottom: {
	    borderBottomWidth: true,
	    borderBottomStyle: true,
	    borderBottomColor: true
	  },
	  borderLeft: {
	    borderLeftWidth: true,
	    borderLeftStyle: true,
	    borderLeftColor: true
	  },
	  borderRight: {
	    borderRightWidth: true,
	    borderRightStyle: true,
	    borderRightColor: true
	  },
	  borderTop: {
	    borderTopWidth: true,
	    borderTopStyle: true,
	    borderTopColor: true
	  },
	  font: {
	    fontStyle: true,
	    fontVariant: true,
	    fontWeight: true,
	    fontSize: true,
	    lineHeight: true,
	    fontFamily: true
	  },
	  outline: {
	    outlineWidth: true,
	    outlineStyle: true,
	    outlineColor: true
	  }
	};
	
	var CSSProperty = {
	  isUnitlessNumber: isUnitlessNumber,
	  shorthandPropertyExpansions: shorthandPropertyExpansions
	};
	
	module.exports = CSSProperty;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PooledClass = __webpack_require__(66);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * A specialized pseudo-event module to help keep track of components waiting to
	 * be notified when their DOM representations are available for use.
	 *
	 * This implements `PooledClass`, so you should never need to instantiate this.
	 * Instead, use `CallbackQueue.getPooled()`.
	 *
	 * @class ReactMountReady
	 * @implements PooledClass
	 * @internal
	 */
	
	var CallbackQueue = function () {
	  function CallbackQueue(arg) {
	    _classCallCheck(this, CallbackQueue);
	
	    this._callbacks = null;
	    this._contexts = null;
	    this._arg = arg;
	  }
	
	  /**
	   * Enqueues a callback to be invoked when `notifyAll` is invoked.
	   *
	   * @param {function} callback Invoked when `notifyAll` is invoked.
	   * @param {?object} context Context to call `callback` with.
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.enqueue = function enqueue(callback, context) {
	    this._callbacks = this._callbacks || [];
	    this._callbacks.push(callback);
	    this._contexts = this._contexts || [];
	    this._contexts.push(context);
	  };
	
	  /**
	   * Invokes all enqueued callbacks and clears the queue. This is invoked after
	   * the DOM representation of a component has been created or updated.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.notifyAll = function notifyAll() {
	    var callbacks = this._callbacks;
	    var contexts = this._contexts;
	    var arg = this._arg;
	    if (callbacks && contexts) {
	      !(callbacks.length === contexts.length) ?  false ? invariant(false, 'Mismatched list of contexts in callback queue') : _prodInvariant('24') : void 0;
	      this._callbacks = null;
	      this._contexts = null;
	      for (var i = 0; i < callbacks.length; i++) {
	        callbacks[i].call(contexts[i], arg);
	      }
	      callbacks.length = 0;
	      contexts.length = 0;
	    }
	  };
	
	  CallbackQueue.prototype.checkpoint = function checkpoint() {
	    return this._callbacks ? this._callbacks.length : 0;
	  };
	
	  CallbackQueue.prototype.rollback = function rollback(len) {
	    if (this._callbacks && this._contexts) {
	      this._callbacks.length = len;
	      this._contexts.length = len;
	    }
	  };
	
	  /**
	   * Resets the internal queue.
	   *
	   * @internal
	   */
	
	
	  CallbackQueue.prototype.reset = function reset() {
	    this._callbacks = null;
	    this._contexts = null;
	  };
	
	  /**
	   * `PooledClass` looks for this.
	   */
	
	
	  CallbackQueue.prototype.destructor = function destructor() {
	    this.reset();
	  };
	
	  return CallbackQueue;
	}();
	
	module.exports = PooledClass.addPoolingTo(CallbackQueue);

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(89);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInstrumentation = __webpack_require__(36);
	
	var quoteAttributeValueForBrowser = __webpack_require__(1914);
	var warning = __webpack_require__(16);
	
	var VALID_ATTRIBUTE_NAME_REGEX = new RegExp('^[' + DOMProperty.ATTRIBUTE_NAME_START_CHAR + '][' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$');
	var illegalAttributeNameCache = {};
	var validatedAttributeNameCache = {};
	
	function isAttributeNameSafe(attributeName) {
	  if (validatedAttributeNameCache.hasOwnProperty(attributeName)) {
	    return true;
	  }
	  if (illegalAttributeNameCache.hasOwnProperty(attributeName)) {
	    return false;
	  }
	  if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) {
	    validatedAttributeNameCache[attributeName] = true;
	    return true;
	  }
	  illegalAttributeNameCache[attributeName] = true;
	   false ? warning(false, 'Invalid attribute name: `%s`', attributeName) : void 0;
	  return false;
	}
	
	function shouldIgnoreValue(propertyInfo, value) {
	  return value == null || propertyInfo.hasBooleanValue && !value || propertyInfo.hasNumericValue && isNaN(value) || propertyInfo.hasPositiveNumericValue && value < 1 || propertyInfo.hasOverloadedBooleanValue && value === false;
	}
	
	/**
	 * Operations for dealing with DOM properties.
	 */
	var DOMPropertyOperations = {
	  /**
	   * Creates markup for the ID property.
	   *
	   * @param {string} id Unescaped ID.
	   * @return {string} Markup string.
	   */
	  createMarkupForID: function (id) {
	    return DOMProperty.ID_ATTRIBUTE_NAME + '=' + quoteAttributeValueForBrowser(id);
	  },
	
	  setAttributeForID: function (node, id) {
	    node.setAttribute(DOMProperty.ID_ATTRIBUTE_NAME, id);
	  },
	
	  createMarkupForRoot: function () {
	    return DOMProperty.ROOT_ATTRIBUTE_NAME + '=""';
	  },
	
	  setAttributeForRoot: function (node) {
	    node.setAttribute(DOMProperty.ROOT_ATTRIBUTE_NAME, '');
	  },
	
	  /**
	   * Creates markup for a property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {?string} Markup string, or null if the property was invalid.
	   */
	  createMarkupForProperty: function (name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      if (shouldIgnoreValue(propertyInfo, value)) {
	        return '';
	      }
	      var attributeName = propertyInfo.attributeName;
	      if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	        return attributeName + '=""';
	      }
	      return attributeName + '=' + quoteAttributeValueForBrowser(value);
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      if (value == null) {
	        return '';
	      }
	      return name + '=' + quoteAttributeValueForBrowser(value);
	    }
	    return null;
	  },
	
	  /**
	   * Creates markup for a custom property.
	   *
	   * @param {string} name
	   * @param {*} value
	   * @return {string} Markup string, or empty string if the property was invalid.
	   */
	  createMarkupForCustomAttribute: function (name, value) {
	    if (!isAttributeNameSafe(name) || value == null) {
	      return '';
	    }
	    return name + '=' + quoteAttributeValueForBrowser(value);
	  },
	
	  /**
	   * Sets the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   * @param {*} value
	   */
	  setValueForProperty: function (node, name, value) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, value);
	      } else if (shouldIgnoreValue(propertyInfo, value)) {
	        this.deleteValueForProperty(node, name);
	        return;
	      } else if (propertyInfo.mustUseProperty) {
	        // Contrary to `setAttribute`, object properties are properly
	        // `toString`ed by IE8/9.
	        node[propertyInfo.propertyName] = value;
	      } else {
	        var attributeName = propertyInfo.attributeName;
	        var namespace = propertyInfo.attributeNamespace;
	        // `setAttribute` with objects becomes only `[object]` in IE8/9,
	        // ('' + value) makes it output the correct toString()-value.
	        if (namespace) {
	          node.setAttributeNS(namespace, attributeName, '' + value);
	        } else if (propertyInfo.hasBooleanValue || propertyInfo.hasOverloadedBooleanValue && value === true) {
	          node.setAttribute(attributeName, '');
	        } else {
	          node.setAttribute(attributeName, '' + value);
	        }
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      DOMPropertyOperations.setValueForAttribute(node, name, value);
	      return;
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  setValueForAttribute: function (node, name, value) {
	    if (!isAttributeNameSafe(name)) {
	      return;
	    }
	    if (value == null) {
	      node.removeAttribute(name);
	    } else {
	      node.setAttribute(name, '' + value);
	    }
	
	    if (false) {
	      var payload = {};
	      payload[name] = value;
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'update attribute',
	        payload: payload
	      });
	    }
	  },
	
	  /**
	   * Deletes an attributes from a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForAttribute: function (node, name) {
	    node.removeAttribute(name);
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  },
	
	  /**
	   * Deletes the value for a property on a node.
	   *
	   * @param {DOMElement} node
	   * @param {string} name
	   */
	  deleteValueForProperty: function (node, name) {
	    var propertyInfo = DOMProperty.properties.hasOwnProperty(name) ? DOMProperty.properties[name] : null;
	    if (propertyInfo) {
	      var mutationMethod = propertyInfo.mutationMethod;
	      if (mutationMethod) {
	        mutationMethod(node, undefined);
	      } else if (propertyInfo.mustUseProperty) {
	        var propName = propertyInfo.propertyName;
	        if (propertyInfo.hasBooleanValue) {
	          node[propName] = false;
	        } else {
	          node[propName] = '';
	        }
	      } else {
	        node.removeAttribute(propertyInfo.attributeName);
	      }
	    } else if (DOMProperty.isCustomAttribute(name)) {
	      node.removeAttribute(name);
	    }
	
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: ReactDOMComponentTree.getInstanceFromNode(node)._debugID,
	        type: 'remove attribute',
	        payload: name
	      });
	    }
	  }
	};
	
	module.exports = DOMPropertyOperations;

/***/ },
/* 397 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentFlags = {
	  hasCachedChildNodes: 1 << 0
	};
	
	module.exports = ReactDOMComponentFlags;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var LinkedValueUtils = __webpack_require__(229);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(42);
	
	var warning = __webpack_require__(16);
	
	var didWarnValueLink = false;
	var didWarnValueDefaultValue = false;
	
	function updateOptionsIfPendingUpdateAndMounted() {
	  if (this._rootNodeID && this._wrapperState.pendingUpdate) {
	    this._wrapperState.pendingUpdate = false;
	
	    var props = this._currentElement.props;
	    var value = LinkedValueUtils.getValue(props);
	
	    if (value != null) {
	      updateOptions(this, Boolean(props.multiple), value);
	    }
	  }
	}
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	var valuePropNames = ['value', 'defaultValue'];
	
	/**
	 * Validation function for `value` and `defaultValue`.
	 * @private
	 */
	function checkSelectPropTypes(inst, props) {
	  var owner = inst._currentElement._owner;
	  LinkedValueUtils.checkPropTypes('select', props, owner);
	
	  if (props.valueLink !== undefined && !didWarnValueLink) {
	     false ? warning(false, '`valueLink` prop on `select` is deprecated; set `value` and `onChange` instead.') : void 0;
	    didWarnValueLink = true;
	  }
	
	  for (var i = 0; i < valuePropNames.length; i++) {
	    var propName = valuePropNames[i];
	    if (props[propName] == null) {
	      continue;
	    }
	    var isArray = Array.isArray(props[propName]);
	    if (props.multiple && !isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be an array if ' + '`multiple` is true.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    } else if (!props.multiple && isArray) {
	       false ? warning(false, 'The `%s` prop supplied to <select> must be a scalar ' + 'value if `multiple` is false.%s', propName, getDeclarationErrorAddendum(owner)) : void 0;
	    }
	  }
	}
	
	/**
	 * @param {ReactDOMComponent} inst
	 * @param {boolean} multiple
	 * @param {*} propValue A stringable (with `multiple`, a list of stringables).
	 * @private
	 */
	function updateOptions(inst, multiple, propValue) {
	  var selectedValue, i;
	  var options = ReactDOMComponentTree.getNodeFromInstance(inst).options;
	
	  if (multiple) {
	    selectedValue = {};
	    for (i = 0; i < propValue.length; i++) {
	      selectedValue['' + propValue[i]] = true;
	    }
	    for (i = 0; i < options.length; i++) {
	      var selected = selectedValue.hasOwnProperty(options[i].value);
	      if (options[i].selected !== selected) {
	        options[i].selected = selected;
	      }
	    }
	  } else {
	    // Do not set `select.value` as exact behavior isn't consistent across all
	    // browsers for all cases.
	    selectedValue = '' + propValue;
	    for (i = 0; i < options.length; i++) {
	      if (options[i].value === selectedValue) {
	        options[i].selected = true;
	        return;
	      }
	    }
	    if (options.length) {
	      options[0].selected = true;
	    }
	  }
	}
	
	/**
	 * Implements a <select> host component that allows optionally setting the
	 * props `value` and `defaultValue`. If `multiple` is false, the prop must be a
	 * stringable. If `multiple` is true, the prop must be an array of stringables.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that change the
	 * selected option will trigger updates to the rendered options.
	 *
	 * If it is supplied (and not null/undefined), the rendered options will not
	 * update in response to user actions. Instead, the `value` prop must change in
	 * order for the rendered options to update.
	 *
	 * If `defaultValue` is provided, any options with the supplied values will be
	 * selected.
	 */
	var ReactDOMSelect = {
	  getHostProps: function (inst, props) {
	    return _assign({}, props, {
	      onChange: inst._wrapperState.onChange,
	      value: undefined
	    });
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      checkSelectPropTypes(inst, props);
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    inst._wrapperState = {
	      pendingUpdate: false,
	      initialValue: value != null ? value : props.defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      wasMultiple: Boolean(props.multiple)
	    };
	
	    if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	       false ? warning(false, 'Select elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled select ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	      didWarnValueDefaultValue = true;
	    }
	  },
	
	  getSelectValueContext: function (inst) {
	    // ReactDOMOption looks at this initial value so the initial generated
	    // markup has correct `selected` attributes
	    return inst._wrapperState.initialValue;
	  },
	
	  postUpdateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // After the initial mount, we control selected-ness manually so don't pass
	    // this value down
	    inst._wrapperState.initialValue = undefined;
	
	    var wasMultiple = inst._wrapperState.wasMultiple;
	    inst._wrapperState.wasMultiple = Boolean(props.multiple);
	
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      inst._wrapperState.pendingUpdate = false;
	      updateOptions(inst, Boolean(props.multiple), value);
	    } else if (wasMultiple !== Boolean(props.multiple)) {
	      // For simplicity, reapply `defaultValue` if `multiple` is toggled.
	      if (props.defaultValue != null) {
	        updateOptions(inst, Boolean(props.multiple), props.defaultValue);
	      } else {
	        // Revert the select back to its default unselected state.
	        updateOptions(inst, Boolean(props.multiple), props.multiple ? [] : '');
	      }
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  if (this._rootNodeID) {
	    this._wrapperState.pendingUpdate = true;
	  }
	  ReactUpdates.asap(updateOptionsIfPendingUpdateAndMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMSelect;

/***/ },
/* 399 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var emptyComponentFactory;
	
	var ReactEmptyComponentInjection = {
	  injectEmptyComponentFactory: function (factory) {
	    emptyComponentFactory = factory;
	  }
	};
	
	var ReactEmptyComponent = {
	  create: function (instantiate) {
	    return emptyComponentFactory(instantiate);
	  }
	};
	
	ReactEmptyComponent.injection = ReactEmptyComponentInjection;
	
	module.exports = ReactEmptyComponent;

/***/ },
/* 400 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactFeatureFlags = {
	  // When true, call console.time() before and .timeEnd() after each top-level
	  // render (both initial renders and updates). Useful when looking at prod-mode
	  // timeline profiles in Chrome, for example.
	  logTopLevelRenders: false
	};
	
	module.exports = ReactFeatureFlags;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(13);
	
	var genericComponentClass = null;
	var textComponentClass = null;
	
	var ReactHostComponentInjection = {
	  // This accepts a class that receives the tag string. This is a catch all
	  // that can render any kind of tag.
	  injectGenericComponentClass: function (componentClass) {
	    genericComponentClass = componentClass;
	  },
	  // This accepts a text component class that takes the text string to be
	  // rendered as props.
	  injectTextComponentClass: function (componentClass) {
	    textComponentClass = componentClass;
	  }
	};
	
	/**
	 * Get a host internal component class for a specific tag.
	 *
	 * @param {ReactElement} element The element to create.
	 * @return {function} The internal class constructor function.
	 */
	function createInternalComponent(element) {
	  !genericComponentClass ?  false ? invariant(false, 'There is no registered component for the tag %s', element.type) : _prodInvariant('111', element.type) : void 0;
	  return new genericComponentClass(element);
	}
	
	/**
	 * @param {ReactText} text
	 * @return {ReactComponent}
	 */
	function createInstanceForText(text) {
	  return new textComponentClass(text);
	}
	
	/**
	 * @param {ReactComponent} component
	 * @return {boolean}
	 */
	function isTextComponent(component) {
	  return component instanceof textComponentClass;
	}
	
	var ReactHostComponent = {
	  createInternalComponent: createInternalComponent,
	  createInstanceForText: createInstanceForText,
	  isTextComponent: isTextComponent,
	  injection: ReactHostComponentInjection
	};
	
	module.exports = ReactHostComponent;

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMSelection = __webpack_require__(1874);
	
	var containsNode = __webpack_require__(575);
	var focusNode = __webpack_require__(275);
	var getActiveElement = __webpack_require__(276);
	
	function isInDocument(node) {
	  return containsNode(document.documentElement, node);
	}
	
	/**
	 * @ReactInputSelection: React input selection module. Based on Selection.js,
	 * but modified to be suitable for react and has a couple of bug fixes (doesn't
	 * assume buttons have range selections allowed).
	 * Input selection module for React.
	 */
	var ReactInputSelection = {
	  hasSelectionCapabilities: function (elem) {
	    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	    return nodeName && (nodeName === 'input' && elem.type === 'text' || nodeName === 'textarea' || elem.contentEditable === 'true');
	  },
	
	  getSelectionInformation: function () {
	    var focusedElem = getActiveElement();
	    return {
	      focusedElem: focusedElem,
	      selectionRange: ReactInputSelection.hasSelectionCapabilities(focusedElem) ? ReactInputSelection.getSelection(focusedElem) : null
	    };
	  },
	
	  /**
	   * @restoreSelection: If any selection information was potentially lost,
	   * restore it. This is useful when performing operations that could remove dom
	   * nodes and place them back in, resulting in focus being lost.
	   */
	  restoreSelection: function (priorSelectionInformation) {
	    var curFocusedElem = getActiveElement();
	    var priorFocusedElem = priorSelectionInformation.focusedElem;
	    var priorSelectionRange = priorSelectionInformation.selectionRange;
	    if (curFocusedElem !== priorFocusedElem && isInDocument(priorFocusedElem)) {
	      if (ReactInputSelection.hasSelectionCapabilities(priorFocusedElem)) {
	        ReactInputSelection.setSelection(priorFocusedElem, priorSelectionRange);
	      }
	      focusNode(priorFocusedElem);
	    }
	  },
	
	  /**
	   * @getSelection: Gets the selection bounds of a focused textarea, input or
	   * contentEditable node.
	   * -@input: Look up selection bounds of this input
	   * -@return {start: selectionStart, end: selectionEnd}
	   */
	  getSelection: function (input) {
	    var selection;
	
	    if ('selectionStart' in input) {
	      // Modern browser with input or textarea.
	      selection = {
	        start: input.selectionStart,
	        end: input.selectionEnd
	      };
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      // IE8 input.
	      var range = document.selection.createRange();
	      // There can only be one selection per document in IE, so it must
	      // be in our element.
	      if (range.parentElement() === input) {
	        selection = {
	          start: -range.moveStart('character', -input.value.length),
	          end: -range.moveEnd('character', -input.value.length)
	        };
	      }
	    } else {
	      // Content editable or old IE textarea.
	      selection = ReactDOMSelection.getOffsets(input);
	    }
	
	    return selection || { start: 0, end: 0 };
	  },
	
	  /**
	   * @setSelection: Sets the selection bounds of a textarea or input and focuses
	   * the input.
	   * -@input     Set selection bounds of this input or textarea
	   * -@offsets   Object of same form that is returned from get*
	   */
	  setSelection: function (input, offsets) {
	    var start = offsets.start;
	    var end = offsets.end;
	    if (end === undefined) {
	      end = start;
	    }
	
	    if ('selectionStart' in input) {
	      input.selectionStart = start;
	      input.selectionEnd = Math.min(end, input.value.length);
	    } else if (document.selection && input.nodeName && input.nodeName.toLowerCase() === 'input') {
	      var range = input.createTextRange();
	      range.collapse(true);
	      range.moveStart('character', start);
	      range.moveEnd('character', end - start);
	      range.select();
	    } else {
	      ReactDOMSelection.setOffsets(input, offsets);
	    }
	  }
	};
	
	module.exports = ReactInputSelection;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var DOMLazyTree = __webpack_require__(88);
	var DOMProperty = __webpack_require__(89);
	var React = __webpack_require__(94);
	var ReactBrowserEventEmitter = __webpack_require__(155);
	var ReactCurrentOwner = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMContainerInfo = __webpack_require__(1868);
	var ReactDOMFeatureFlags = __webpack_require__(1870);
	var ReactFeatureFlags = __webpack_require__(400);
	var ReactInstanceMap = __webpack_require__(119);
	var ReactInstrumentation = __webpack_require__(36);
	var ReactMarkupChecksum = __webpack_require__(1884);
	var ReactReconciler = __webpack_require__(92);
	var ReactUpdateQueue = __webpack_require__(232);
	var ReactUpdates = __webpack_require__(42);
	
	var emptyObject = __webpack_require__(130);
	var instantiateReactComponent = __webpack_require__(410);
	var invariant = __webpack_require__(13);
	var setInnerHTML = __webpack_require__(159);
	var shouldUpdateReactComponent = __webpack_require__(239);
	var warning = __webpack_require__(16);
	
	var ATTR_NAME = DOMProperty.ID_ATTRIBUTE_NAME;
	var ROOT_ATTR_NAME = DOMProperty.ROOT_ATTRIBUTE_NAME;
	
	var ELEMENT_NODE_TYPE = 1;
	var DOC_NODE_TYPE = 9;
	var DOCUMENT_FRAGMENT_NODE_TYPE = 11;
	
	var instancesByReactRootID = {};
	
	/**
	 * Finds the index of the first character
	 * that's not common between the two given strings.
	 *
	 * @return {number} the index of the character where the strings diverge
	 */
	function firstDifferenceIndex(string1, string2) {
	  var minLen = Math.min(string1.length, string2.length);
	  for (var i = 0; i < minLen; i++) {
	    if (string1.charAt(i) !== string2.charAt(i)) {
	      return i;
	    }
	  }
	  return string1.length === string2.length ? -1 : minLen;
	}
	
	/**
	 * @param {DOMElement|DOMDocument} container DOM element that may contain
	 * a React component
	 * @return {?*} DOM element that may have the reactRoot ID, or null.
	 */
	function getReactRootElementInContainer(container) {
	  if (!container) {
	    return null;
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    return container.documentElement;
	  } else {
	    return container.firstChild;
	  }
	}
	
	function internalGetID(node) {
	  // If node is something like a window, document, or text node, none of
	  // which support attributes or a .getAttribute method, gracefully return
	  // the empty string, as if the attribute were missing.
	  return node.getAttribute && node.getAttribute(ATTR_NAME) || '';
	}
	
	/**
	 * Mounts this component and inserts it into the DOM.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {ReactReconcileTransaction} transaction
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function mountComponentIntoNode(wrapperInstance, container, transaction, shouldReuseMarkup, context) {
	  var markerName;
	  if (ReactFeatureFlags.logTopLevelRenders) {
	    var wrappedElement = wrapperInstance._currentElement.props.child;
	    var type = wrappedElement.type;
	    markerName = 'React mount: ' + (typeof type === 'string' ? type : type.displayName || type.name);
	    console.time(markerName);
	  }
	
	  var markup = ReactReconciler.mountComponent(wrapperInstance, transaction, null, ReactDOMContainerInfo(wrapperInstance, container), context, 0 /* parentDebugID */
	  );
	
	  if (markerName) {
	    console.timeEnd(markerName);
	  }
	
	  wrapperInstance._renderedComponent._topLevelWrapper = wrapperInstance;
	  ReactMount._mountImageIntoNode(markup, container, wrapperInstance, shouldReuseMarkup, transaction);
	}
	
	/**
	 * Batched mount.
	 *
	 * @param {ReactComponent} componentInstance The instance to mount.
	 * @param {DOMElement} container DOM element to mount into.
	 * @param {boolean} shouldReuseMarkup If true, do not insert markup
	 */
	function batchedMountComponentIntoNode(componentInstance, container, shouldReuseMarkup, context) {
	  var transaction = ReactUpdates.ReactReconcileTransaction.getPooled(
	  /* useCreateElement */
	  !shouldReuseMarkup && ReactDOMFeatureFlags.useCreateElement);
	  transaction.perform(mountComponentIntoNode, null, componentInstance, container, transaction, shouldReuseMarkup, context);
	  ReactUpdates.ReactReconcileTransaction.release(transaction);
	}
	
	/**
	 * Unmounts a component and removes it from the DOM.
	 *
	 * @param {ReactComponent} instance React component instance.
	 * @param {DOMElement} container DOM element to unmount from.
	 * @final
	 * @internal
	 * @see {ReactMount.unmountComponentAtNode}
	 */
	function unmountComponentFromNode(instance, container, safely) {
	  if (false) {
	    ReactInstrumentation.debugTool.onBeginFlush();
	  }
	  ReactReconciler.unmountComponent(instance, safely);
	  if (false) {
	    ReactInstrumentation.debugTool.onEndFlush();
	  }
	
	  if (container.nodeType === DOC_NODE_TYPE) {
	    container = container.documentElement;
	  }
	
	  // http://jsperf.com/emptying-a-node
	  while (container.lastChild) {
	    container.removeChild(container.lastChild);
	  }
	}
	
	/**
	 * True if the supplied DOM node has a direct React-rendered child that is
	 * not a React root element. Useful for warning in `render`,
	 * `unmountComponentAtNode`, etc.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM element contains a direct child that was
	 * rendered by React but is not a root element.
	 * @internal
	 */
	function hasNonRootReactChild(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  if (rootEl) {
	    var inst = ReactDOMComponentTree.getInstanceFromNode(rootEl);
	    return !!(inst && inst._hostParent);
	  }
	}
	
	/**
	 * True if the supplied DOM node is a React DOM element and
	 * it has been rendered by another copy of React.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM has been rendered by another copy of React
	 * @internal
	 */
	function nodeIsRenderedByOtherInstance(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  return !!(rootEl && isReactNode(rootEl) && !ReactDOMComponentTree.getInstanceFromNode(rootEl));
	}
	
	/**
	 * True if the supplied DOM node is a valid node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid DOM node.
	 * @internal
	 */
	function isValidContainer(node) {
	  return !!(node && (node.nodeType === ELEMENT_NODE_TYPE || node.nodeType === DOC_NODE_TYPE || node.nodeType === DOCUMENT_FRAGMENT_NODE_TYPE));
	}
	
	/**
	 * True if the supplied DOM node is a valid React node element.
	 *
	 * @param {?DOMElement} node The candidate DOM node.
	 * @return {boolean} True if the DOM is a valid React DOM node.
	 * @internal
	 */
	function isReactNode(node) {
	  return isValidContainer(node) && (node.hasAttribute(ROOT_ATTR_NAME) || node.hasAttribute(ATTR_NAME));
	}
	
	function getHostRootInstanceInContainer(container) {
	  var rootEl = getReactRootElementInContainer(container);
	  var prevHostInstance = rootEl && ReactDOMComponentTree.getInstanceFromNode(rootEl);
	  return prevHostInstance && !prevHostInstance._hostParent ? prevHostInstance : null;
	}
	
	function getTopLevelWrapperInContainer(container) {
	  var root = getHostRootInstanceInContainer(container);
	  return root ? root._hostContainerInfo._topLevelWrapper : null;
	}
	
	/**
	 * Temporary (?) hack so that we can store all top-level pending updates on
	 * composites instead of having to worry about different types of components
	 * here.
	 */
	var topLevelRootCounter = 1;
	var TopLevelWrapper = function () {
	  this.rootID = topLevelRootCounter++;
	};
	TopLevelWrapper.prototype.isReactComponent = {};
	if (false) {
	  TopLevelWrapper.displayName = 'TopLevelWrapper';
	}
	TopLevelWrapper.prototype.render = function () {
	  return this.props.child;
	};
	TopLevelWrapper.isReactTopLevelWrapper = true;
	
	/**
	 * Mounting is the process of initializing a React component by creating its
	 * representative DOM elements and inserting them into a supplied `container`.
	 * Any prior content inside `container` is destroyed in the process.
	 *
	 *   ReactMount.render(
	 *     component,
	 *     document.getElementById('container')
	 *   );
	 *
	 *   <div id="container">                   <-- Supplied `container`.
	 *     <div data-reactid=".3">              <-- Rendered reactRoot of React
	 *       // ...                                 component.
	 *     </div>
	 *   </div>
	 *
	 * Inside of `container`, the first element rendered is the "reactRoot".
	 */
	var ReactMount = {
	  TopLevelWrapper: TopLevelWrapper,
	
	  /**
	   * Used by devtools. The keys are not important.
	   */
	  _instancesByReactRootID: instancesByReactRootID,
	
	  /**
	   * This is a hook provided to support rendering React components while
	   * ensuring that the apparent scroll position of its `container` does not
	   * change.
	   *
	   * @param {DOMElement} container The `container` being rendered into.
	   * @param {function} renderCallback This must be called once to do the render.
	   */
	  scrollMonitor: function (container, renderCallback) {
	    renderCallback();
	  },
	
	  /**
	   * Take a component that's already mounted into the DOM and replace its props
	   * @param {ReactComponent} prevComponent component instance already in the DOM
	   * @param {ReactElement} nextElement component instance to render
	   * @param {DOMElement} container container to render into
	   * @param {?function} callback function triggered on completion
	   */
	  _updateRootComponent: function (prevComponent, nextElement, nextContext, container, callback) {
	    ReactMount.scrollMonitor(container, function () {
	      ReactUpdateQueue.enqueueElementInternal(prevComponent, nextElement, nextContext);
	      if (callback) {
	        ReactUpdateQueue.enqueueCallbackInternal(prevComponent, callback);
	      }
	    });
	
	    return prevComponent;
	  },
	
	  /**
	   * Render a new component into the DOM. Hooked by hooks!
	   *
	   * @param {ReactElement} nextElement element to render
	   * @param {DOMElement} container container to render into
	   * @param {boolean} shouldReuseMarkup if we should skip the markup insertion
	   * @return {ReactComponent} nextComponent
	   */
	  _renderNewRootComponent: function (nextElement, container, shouldReuseMarkup, context) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case.
	     false ? warning(ReactCurrentOwner.current == null, '_renderNewRootComponent(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from ' + 'render is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, '_registerComponent(...): Target container is not a DOM element.') : _prodInvariant('37') : void 0;
	
	    ReactBrowserEventEmitter.ensureScrollValueMonitoring();
	    var componentInstance = instantiateReactComponent(nextElement, false);
	
	    // The initial render is synchronous but any updates that happen during
	    // rendering, in componentWillMount or componentDidMount, will be batched
	    // according to the current batching strategy.
	
	    ReactUpdates.batchedUpdates(batchedMountComponentIntoNode, componentInstance, container, shouldReuseMarkup, context);
	
	    var wrapperID = componentInstance._instance.rootID;
	    instancesByReactRootID[wrapperID] = componentInstance;
	
	    return componentInstance;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactComponent} parentComponent The conceptual parent of this render tree.
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    !(parentComponent != null && ReactInstanceMap.has(parentComponent)) ?  false ? invariant(false, 'parentComponent must be a valid React Component') : _prodInvariant('38') : void 0;
	    return ReactMount._renderSubtreeIntoContainer(parentComponent, nextElement, container, callback);
	  },
	
	  _renderSubtreeIntoContainer: function (parentComponent, nextElement, container, callback) {
	    ReactUpdateQueue.validateCallback(callback, 'ReactDOM.render');
	    !React.isValidElement(nextElement) ?  false ? invariant(false, 'ReactDOM.render(): Invalid component element.%s', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : // Check if it quacks like an element
	    nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : _prodInvariant('39', typeof nextElement === 'string' ? " Instead of passing a string like 'div', pass " + "React.createElement('div') or <div />." : typeof nextElement === 'function' ? ' Instead of passing a class like Foo, pass ' + 'React.createElement(Foo) or <Foo />.' : nextElement != null && nextElement.props !== undefined ? ' This may be caused by unintentionally loading two independent ' + 'copies of React.' : '') : void 0;
	
	     false ? warning(!container || !container.tagName || container.tagName.toUpperCase() !== 'BODY', 'render(): Rendering components directly into document.body is ' + 'discouraged, since its children are often manipulated by third-party ' + 'scripts and browser extensions. This may lead to subtle ' + 'reconciliation issues. Try rendering into a container element created ' + 'for your app.') : void 0;
	
	    var nextWrappedElement = React.createElement(TopLevelWrapper, {
	      child: nextElement
	    });
	
	    var nextContext;
	    if (parentComponent) {
	      var parentInst = ReactInstanceMap.get(parentComponent);
	      nextContext = parentInst._processChildContext(parentInst._context);
	    } else {
	      nextContext = emptyObject;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	
	    if (prevComponent) {
	      var prevWrappedElement = prevComponent._currentElement;
	      var prevElement = prevWrappedElement.props.child;
	      if (shouldUpdateReactComponent(prevElement, nextElement)) {
	        var publicInst = prevComponent._renderedComponent.getPublicInstance();
	        var updatedCallback = callback && function () {
	          callback.call(publicInst);
	        };
	        ReactMount._updateRootComponent(prevComponent, nextWrappedElement, nextContext, container, updatedCallback);
	        return publicInst;
	      } else {
	        ReactMount.unmountComponentAtNode(container);
	      }
	    }
	
	    var reactRootElement = getReactRootElementInContainer(container);
	    var containerHasReactMarkup = reactRootElement && !!internalGetID(reactRootElement);
	    var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, 'render(...): Replacing React-rendered children with a new root ' + 'component. If you intended to update the children of this node, ' + 'you should instead have the existing children update their state ' + 'and render the new components instead of calling ReactDOM.render.') : void 0;
	
	      if (!containerHasReactMarkup || reactRootElement.nextSibling) {
	        var rootElementSibling = reactRootElement;
	        while (rootElementSibling) {
	          if (internalGetID(rootElementSibling)) {
	            process.env.NODE_ENV !== 'production' ? warning(false, 'render(): Target node has markup rendered by React, but there ' + 'are unrelated nodes as well. This is most commonly caused by ' + 'white-space inserted around server-rendered markup.') : void 0;
	            break;
	          }
	          rootElementSibling = rootElementSibling.nextSibling;
	        }
	      }
	    }
	
	    var shouldReuseMarkup = containerHasReactMarkup && !prevComponent && !containerHasNonRootReactChild;
	    var component = ReactMount._renderNewRootComponent(nextWrappedElement, container, shouldReuseMarkup, nextContext)._renderedComponent.getPublicInstance();
	    if (callback) {
	      callback.call(component);
	    }
	    return component;
	  },
	
	  /**
	   * Renders a React component into the DOM in the supplied `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.render
	   *
	   * If the React component was previously rendered into `container`, this will
	   * perform an update on it and only mutate the DOM as necessary to reflect the
	   * latest React component.
	   *
	   * @param {ReactElement} nextElement Component element to render.
	   * @param {DOMElement} container DOM element to render into.
	   * @param {?function} callback function triggered on completion
	   * @return {ReactComponent} Component instance rendered in `container`.
	   */
	  render: function (nextElement, container, callback) {
	    return ReactMount._renderSubtreeIntoContainer(null, nextElement, container, callback);
	  },
	
	  /**
	   * Unmounts and destroys the React component rendered in the `container`.
	   * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.unmountcomponentatnode
	   *
	   * @param {DOMElement} container DOM element containing a React component.
	   * @return {boolean} True if a component was found in and unmounted from
	   *                   `container`
	   */
	  unmountComponentAtNode: function (container) {
	    // Various parts of our code (such as ReactCompositeComponent's
	    // _renderValidatedComponent) assume that calls to render aren't nested;
	    // verify that that's the case. (Strictly speaking, unmounting won't cause a
	    // render but we still don't expect to be in a render call here.)
	     false ? warning(ReactCurrentOwner.current == null, 'unmountComponentAtNode(): Render methods should be a pure function ' + 'of props and state; triggering nested component updates from render ' + 'is not allowed. If necessary, trigger nested updates in ' + 'componentDidUpdate. Check the render method of %s.', ReactCurrentOwner.current && ReactCurrentOwner.current.getName() || 'ReactCompositeComponent') : void 0;
	
	    !isValidContainer(container) ?  false ? invariant(false, 'unmountComponentAtNode(...): Target container is not a DOM element.') : _prodInvariant('40') : void 0;
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(!nodeIsRenderedByOtherInstance(container), "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by another copy of React.') : void 0;
	    }
	
	    var prevComponent = getTopLevelWrapperInContainer(container);
	    if (!prevComponent) {
	      // Check if the node being unmounted was rendered by React, but isn't a
	      // root node.
	      var containerHasNonRootReactChild = hasNonRootReactChild(container);
	
	      // Check if the container itself is a React root node.
	      var isContainerReactRoot = container.nodeType === 1 && container.hasAttribute(ROOT_ATTR_NAME);
	
	      if (false) {
	        process.env.NODE_ENV !== 'production' ? warning(!containerHasNonRootReactChild, "unmountComponentAtNode(): The node you're attempting to unmount " + 'was rendered by React and is not a top-level container. %s', isContainerReactRoot ? 'You may have accidentally passed in a React root node instead ' + 'of its container.' : 'Instead, have the parent component update its state and ' + 'rerender in order to remove this component.') : void 0;
	      }
	
	      return false;
	    }
	    delete instancesByReactRootID[prevComponent._instance.rootID];
	    ReactUpdates.batchedUpdates(unmountComponentFromNode, prevComponent, container, false);
	    return true;
	  },
	
	  _mountImageIntoNode: function (markup, container, instance, shouldReuseMarkup, transaction) {
	    !isValidContainer(container) ?  false ? invariant(false, 'mountComponentIntoNode(...): Target container is not valid.') : _prodInvariant('41') : void 0;
	
	    if (shouldReuseMarkup) {
	      var rootElement = getReactRootElementInContainer(container);
	      if (ReactMarkupChecksum.canReuseMarkup(markup, rootElement)) {
	        ReactDOMComponentTree.precacheNode(instance, rootElement);
	        return;
	      } else {
	        var checksum = rootElement.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	        rootElement.removeAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	
	        var rootMarkup = rootElement.outerHTML;
	        rootElement.setAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME, checksum);
	
	        var normalizedMarkup = markup;
	        if (false) {
	          // because rootMarkup is retrieved from the DOM, various normalizations
	          // will have occurred which will not be present in `markup`. Here,
	          // insert markup into a <div> or <iframe> depending on the container
	          // type to perform the same normalizations before comparing.
	          var normalizer;
	          if (container.nodeType === ELEMENT_NODE_TYPE) {
	            normalizer = document.createElement('div');
	            normalizer.innerHTML = markup;
	            normalizedMarkup = normalizer.innerHTML;
	          } else {
	            normalizer = document.createElement('iframe');
	            document.body.appendChild(normalizer);
	            normalizer.contentDocument.write(markup);
	            normalizedMarkup = normalizer.contentDocument.documentElement.outerHTML;
	            document.body.removeChild(normalizer);
	          }
	        }
	
	        var diffIndex = firstDifferenceIndex(normalizedMarkup, rootMarkup);
	        var difference = ' (client) ' + normalizedMarkup.substring(diffIndex - 20, diffIndex + 20) + '\n (server) ' + rootMarkup.substring(diffIndex - 20, diffIndex + 20);
	
	        !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document using server rendering but the checksum was invalid. This usually means you rendered a different component type or props on the client from the one on the server, or your render() methods are impure. React cannot handle this case due to cross-browser quirks by rendering at the document root. You should look for environment dependent code in your components and ensure the props are the same client and server side:\n%s', difference) : _prodInvariant('42', difference) : void 0;
	
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'React attempted to reuse markup in a container but the ' + 'checksum was invalid. This generally means that you are ' + 'using server rendering and the markup generated on the ' + 'server was not what the client was expecting. React injected ' + 'new markup to compensate which works but you have lost many ' + 'of the benefits of server rendering. Instead, figure out ' + 'why the markup being generated is different on the client ' + 'or server:\n%s', difference) : void 0;
	        }
	      }
	    }
	
	    !(container.nodeType !== DOC_NODE_TYPE) ?  false ? invariant(false, 'You\'re trying to render a component to the document but you didn\'t use server rendering. We can\'t do this without using server rendering due to cross-browser quirks. See ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('43') : void 0;
	
	    if (transaction.useCreateElement) {
	      while (container.lastChild) {
	        container.removeChild(container.lastChild);
	      }
	      DOMLazyTree.insertTreeBefore(container, markup, null);
	    } else {
	      setInnerHTML(container, markup);
	      ReactDOMComponentTree.precacheNode(instance, container.firstChild);
	    }
	
	    if (false) {
	      var hostNode = ReactDOMComponentTree.getInstanceFromNode(container.firstChild);
	      if (hostNode._debugID !== 0) {
	        ReactInstrumentation.debugTool.onHostOperation({
	          instanceID: hostNode._debugID,
	          type: 'mount',
	          payload: markup.toString()
	        });
	      }
	    }
	  }
	};
	
	module.exports = ReactMount;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var React = __webpack_require__(94);
	
	var invariant = __webpack_require__(13);
	
	var ReactNodeTypes = {
	  HOST: 0,
	  COMPOSITE: 1,
	  EMPTY: 2,
	
	  getType: function (node) {
	    if (node === null || node === false) {
	      return ReactNodeTypes.EMPTY;
	    } else if (React.isValidElement(node)) {
	      if (typeof node.type === 'function') {
	        return ReactNodeTypes.COMPOSITE;
	      } else {
	        return ReactNodeTypes.HOST;
	      }
	    }
	     true ?  false ? invariant(false, 'Unexpected node: %s', node) : _prodInvariant('26', node) : void 0;
	  }
	};
	
	module.exports = ReactNodeTypes;

/***/ },
/* 405 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Accumulates items that must not be null or undefined into the first one. This
	 * is used to conserve memory by avoiding array allocations, and thus sacrifices
	 * API cleanness. Since `current` can be null before being passed in and not
	 * null after this function, make sure to assign it back to `current`:
	 *
	 * `a = accumulateInto(a, b);`
	 *
	 * This API should be sparingly used. Try `accumulate` for something cleaner.
	 *
	 * @return {*|array<*>} An accumulation of items.
	 */
	
	function accumulateInto(current, next) {
	  !(next != null) ?  false ? invariant(false, 'accumulateInto(...): Accumulated items must not be null or undefined.') : _prodInvariant('30') : void 0;
	
	  if (current == null) {
	    return next;
	  }
	
	  // Both are not empty. Warning: Never call x.concat(y) when you are not
	  // certain that x is an Array (x could be a string with concat method).
	  if (Array.isArray(current)) {
	    if (Array.isArray(next)) {
	      current.push.apply(current, next);
	      return current;
	    }
	    current.push(next);
	    return current;
	  }
	
	  if (Array.isArray(next)) {
	    // A bit too dangerous to mutate `next`.
	    return [current].concat(next);
	  }
	
	  return [current, next];
	}
	
	module.exports = accumulateInto;

/***/ },
/* 406 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @param {array} arr an "accumulation" of items which is either an Array or
	 * a single item. Useful when paired with the `accumulate` module. This is a
	 * simple utility that allows us to reason about a collection of items, but
	 * handling the case when there is exactly one item (and we do not need to
	 * allocate an array).
	 */
	
	function forEachAccumulated(arr, cb, scope) {
	  if (Array.isArray(arr)) {
	    arr.forEach(cb, scope);
	  } else if (arr) {
	    cb.call(scope, arr);
	  }
	}
	
	module.exports = forEachAccumulated;

/***/ },
/* 407 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactNodeTypes = __webpack_require__(404);
	
	function getHostComponentFromComposite(inst) {
	  var type;
	
	  while ((type = inst._renderedNodeType) === ReactNodeTypes.COMPOSITE) {
	    inst = inst._renderedComponent;
	  }
	
	  if (type === ReactNodeTypes.HOST) {
	    return inst._renderedComponent;
	  } else if (type === ReactNodeTypes.EMPTY) {
	    return null;
	  }
	}
	
	module.exports = getHostComponentFromComposite;

/***/ },
/* 408 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	var contentKey = null;
	
	/**
	 * Gets the key used to access text content on a DOM node.
	 *
	 * @return {?string} Key used to access text content.
	 * @internal
	 */
	function getTextContentAccessor() {
	  if (!contentKey && ExecutionEnvironment.canUseDOM) {
	    // Prefer textContent to innerText because many browsers support both but
	    // SVG <text> elements don't support innerText even when <div> does.
	    contentKey = 'textContent' in document.documentElement ? 'textContent' : 'innerText';
	  }
	  return contentKey;
	}
	
	module.exports = getTextContentAccessor;

/***/ },
/* 409 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(20);
	
	function isCheckable(elem) {
	  var type = elem.type;
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (type === 'checkbox' || type === 'radio');
	}
	
	function getTracker(inst) {
	  return inst._wrapperState.valueTracker;
	}
	
	function attachTracker(inst, tracker) {
	  inst._wrapperState.valueTracker = tracker;
	}
	
	function detachTracker(inst) {
	  inst._wrapperState.valueTracker = null;
	}
	
	function getValueFromNode(node) {
	  var value;
	  if (node) {
	    value = isCheckable(node) ? '' + node.checked : node.value;
	  }
	  return value;
	}
	
	var inputValueTracking = {
	  // exposed for testing
	  _getTrackerFromNode: function (node) {
	    return getTracker(ReactDOMComponentTree.getInstanceFromNode(node));
	  },
	
	
	  track: function (inst) {
	    if (getTracker(inst)) {
	      return;
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var valueField = isCheckable(node) ? 'checked' : 'value';
	    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
	
	    var currentValue = '' + node[valueField];
	
	    // if someone has already defined a value or Safari, then bail
	    // and don't track value will cause over reporting of changes,
	    // but it's better then a hard failure
	    // (needed for certain tests that spyOn input values and Safari)
	    if (node.hasOwnProperty(valueField) || typeof descriptor.get !== 'function' || typeof descriptor.set !== 'function') {
	      return;
	    }
	
	    Object.defineProperty(node, valueField, {
	      enumerable: descriptor.enumerable,
	      configurable: true,
	      get: function () {
	        return descriptor.get.call(this);
	      },
	      set: function (value) {
	        currentValue = '' + value;
	        descriptor.set.call(this, value);
	      }
	    });
	
	    attachTracker(inst, {
	      getValue: function () {
	        return currentValue;
	      },
	      setValue: function (value) {
	        currentValue = '' + value;
	      },
	      stopTracking: function () {
	        detachTracker(inst);
	        delete node[valueField];
	      }
	    });
	  },
	
	  updateValueIfChanged: function (inst) {
	    if (!inst) {
	      return false;
	    }
	    var tracker = getTracker(inst);
	
	    if (!tracker) {
	      inputValueTracking.track(inst);
	      return true;
	    }
	
	    var lastValue = tracker.getValue();
	    var nextValue = getValueFromNode(ReactDOMComponentTree.getNodeFromInstance(inst));
	
	    if (nextValue !== lastValue) {
	      tracker.setValue(nextValue);
	      return true;
	    }
	
	    return false;
	  },
	  stopTracking: function (inst) {
	    var tracker = getTracker(inst);
	    if (tracker) {
	      tracker.stopTracking();
	    }
	  }
	};
	
	module.exports = inputValueTracking;

/***/ },
/* 410 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var ReactCompositeComponent = __webpack_require__(1865);
	var ReactEmptyComponent = __webpack_require__(399);
	var ReactHostComponent = __webpack_require__(401);
	
	var getNextDebugID = __webpack_require__(1965);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(16);
	
	// To avoid a cyclic dependency, we create the final class in this module
	var ReactCompositeComponentWrapper = function (element) {
	  this.construct(element);
	};
	
	function getDeclarationErrorAddendum(owner) {
	  if (owner) {
	    var name = owner.getName();
	    if (name) {
	      return ' Check the render method of `' + name + '`.';
	    }
	  }
	  return '';
	}
	
	/**
	 * Check if the type reference is a known internal type. I.e. not a user
	 * provided composite type.
	 *
	 * @param {function} type
	 * @return {boolean} Returns true if this is a valid internal type.
	 */
	function isInternalComponentType(type) {
	  return typeof type === 'function' && typeof type.prototype !== 'undefined' && typeof type.prototype.mountComponent === 'function' && typeof type.prototype.receiveComponent === 'function';
	}
	
	/**
	 * Given a ReactNode, create an instance that will actually be mounted.
	 *
	 * @param {ReactNode} node
	 * @param {boolean} shouldHaveDebugID
	 * @return {object} A new instance of the element's constructor.
	 * @protected
	 */
	function instantiateReactComponent(node, shouldHaveDebugID) {
	  var instance;
	
	  if (node === null || node === false) {
	    instance = ReactEmptyComponent.create(instantiateReactComponent);
	  } else if (typeof node === 'object') {
	    var element = node;
	    var type = element.type;
	    if (typeof type !== 'function' && typeof type !== 'string') {
	      var info = '';
	      if (false) {
	        if (type === undefined || typeof type === 'object' && type !== null && Object.keys(type).length === 0) {
	          info += ' You likely forgot to export your component from the file ' + "it's defined in.";
	        }
	      }
	      info += getDeclarationErrorAddendum(element._owner);
	       true ?  false ? invariant(false, 'Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s', type == null ? type : typeof type, info) : _prodInvariant('130', type == null ? type : typeof type, info) : void 0;
	    }
	
	    // Special case string values
	    if (typeof element.type === 'string') {
	      instance = ReactHostComponent.createInternalComponent(element);
	    } else if (isInternalComponentType(element.type)) {
	      // This is temporarily available for custom components that are not string
	      // representations. I.e. ART. Once those are updated to use the string
	      // representation, we can drop this code path.
	      instance = new element.type(element);
	
	      // We renamed this. Allow the old name for compat. :(
	      if (!instance.getHostNode) {
	        instance.getHostNode = instance.getNativeNode;
	      }
	    } else {
	      instance = new ReactCompositeComponentWrapper(element);
	    }
	  } else if (typeof node === 'string' || typeof node === 'number') {
	    instance = ReactHostComponent.createInstanceForText(node);
	  } else {
	     true ?  false ? invariant(false, 'Encountered invalid React node of type %s', typeof node) : _prodInvariant('131', typeof node) : void 0;
	  }
	
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(typeof instance.mountComponent === 'function' && typeof instance.receiveComponent === 'function' && typeof instance.getHostNode === 'function' && typeof instance.unmountComponent === 'function', 'Only React Components can be mounted.') : void 0;
	  }
	
	  // These two fields are used by the DOM and ART diffing algorithms
	  // respectively. Instead of using expandos on components, we should be
	  // storing the state needed by the diffing algorithms elsewhere.
	  instance._mountIndex = 0;
	  instance._mountImage = null;
	
	  if (false) {
	    instance._debugID = shouldHaveDebugID ? getNextDebugID() : 0;
	  }
	
	  // Internal instances should fully constructed at this point, so they should
	  // not get any new fields added to them at this point.
	  if (false) {
	    if (Object.preventExtensions) {
	      Object.preventExtensions(instance);
	    }
	  }
	
	  return instance;
	}
	
	_assign(ReactCompositeComponentWrapper.prototype, ReactCompositeComponent, {
	  _instantiateReactComponent: instantiateReactComponent
	});
	
	module.exports = instantiateReactComponent;

/***/ },
/* 411 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/**
	 * @see http://www.whatwg.org/specs/web-apps/current-work/multipage/the-input-element.html#input-type-attr-summary
	 */
	
	var supportedInputTypes = {
	  color: true,
	  date: true,
	  datetime: true,
	  'datetime-local': true,
	  email: true,
	  month: true,
	  number: true,
	  password: true,
	  range: true,
	  search: true,
	  tel: true,
	  text: true,
	  time: true,
	  url: true,
	  week: true
	};
	
	function isTextInputElement(elem) {
	  var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
	
	  if (nodeName === 'input') {
	    return !!supportedInputTypes[elem.type];
	  }
	
	  if (nodeName === 'textarea') {
	    return true;
	  }
	
	  return false;
	}
	
	module.exports = isTextInputElement;

/***/ },
/* 412 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	var escapeTextContentForBrowser = __webpack_require__(158);
	var setInnerHTML = __webpack_require__(159);
	
	/**
	 * Set the textContent property of a node, ensuring that whitespace is preserved
	 * even in IE8. innerText is a poor substitute for textContent and, among many
	 * issues, inserts <br> instead of the literal newline chars. innerHTML behaves
	 * as it should.
	 *
	 * @param {DOMElement} node
	 * @param {string} text
	 * @internal
	 */
	var setTextContent = function (node, text) {
	  if (text) {
	    var firstChild = node.firstChild;
	
	    if (firstChild && firstChild === node.lastChild && firstChild.nodeType === 3) {
	      firstChild.nodeValue = text;
	      return;
	    }
	  }
	  node.textContent = text;
	};
	
	if (ExecutionEnvironment.canUseDOM) {
	  if (!('textContent' in document.documentElement)) {
	    setTextContent = function (node, text) {
	      if (node.nodeType === 3) {
	        node.nodeValue = text;
	        return;
	      }
	      setInnerHTML(node, escapeTextContentForBrowser(text));
	    };
	  }
	}
	
	module.exports = setTextContent;

/***/ },
/* 413 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactCurrentOwner = __webpack_require__(45);
	var REACT_ELEMENT_TYPE = __webpack_require__(1880);
	
	var getIteratorFn = __webpack_require__(1911);
	var invariant = __webpack_require__(13);
	var KeyEscapeUtils = __webpack_require__(228);
	var warning = __webpack_require__(16);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = connectAdvanced;
	
	var _hoistNonReactStatics = __webpack_require__(1927);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _Subscription = __webpack_require__(1925);
	
	var _Subscription2 = _interopRequireDefault(_Subscription);
	
	var _PropTypes = __webpack_require__(416);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	var hotReloadingVersion = 0;
	var dummyState = {};
	function noop() {}
	function makeSelectorStateful(sourceSelector, store) {
	  // wrap the selector in an object that tracks its results between runs.
	  var selector = {
	    run: function runComponentSelector(props) {
	      try {
	        var nextProps = sourceSelector(store.getState(), props);
	        if (nextProps !== selector.props || selector.error) {
	          selector.shouldComponentUpdate = true;
	          selector.props = nextProps;
	          selector.error = null;
	        }
	      } catch (error) {
	        selector.shouldComponentUpdate = true;
	        selector.error = error;
	      }
	    }
	  };
	
	  return selector;
	}
	
	function connectAdvanced(
	/*
	  selectorFactory is a func that is responsible for returning the selector function used to
	  compute new props from state, props, and dispatch. For example:
	     export default connectAdvanced((dispatch, options) => (state, props) => ({
	      thing: state.things[props.thingId],
	      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
	    }))(YourComponent)
	   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
	  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
	  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
	   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
	  props. Do not use connectAdvanced directly without memoizing results between calls to your
	  selector, otherwise the Connect component will re-render on every state or props change.
	*/
	selectorFactory) {
	  var _contextTypes, _childContextTypes;
	
	  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
	      _ref$getDisplayName = _ref.getDisplayName,
	      getDisplayName = _ref$getDisplayName === undefined ? function (name) {
	    return 'ConnectAdvanced(' + name + ')';
	  } : _ref$getDisplayName,
	      _ref$methodName = _ref.methodName,
	      methodName = _ref$methodName === undefined ? 'connectAdvanced' : _ref$methodName,
	      _ref$renderCountProp = _ref.renderCountProp,
	      renderCountProp = _ref$renderCountProp === undefined ? undefined : _ref$renderCountProp,
	      _ref$shouldHandleStat = _ref.shouldHandleStateChanges,
	      shouldHandleStateChanges = _ref$shouldHandleStat === undefined ? true : _ref$shouldHandleStat,
	      _ref$storeKey = _ref.storeKey,
	      storeKey = _ref$storeKey === undefined ? 'store' : _ref$storeKey,
	      _ref$withRef = _ref.withRef,
	      withRef = _ref$withRef === undefined ? false : _ref$withRef,
	      connectOptions = _objectWithoutProperties(_ref, ['getDisplayName', 'methodName', 'renderCountProp', 'shouldHandleStateChanges', 'storeKey', 'withRef']);
	
	  var subscriptionKey = storeKey + 'Subscription';
	  var version = hotReloadingVersion++;
	
	  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = _PropTypes.storeShape, _contextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _contextTypes);
	  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = _PropTypes.subscriptionShape, _childContextTypes);
	
	  return function wrapWithConnect(WrappedComponent) {
	    (0, _invariant2.default)(typeof WrappedComponent == 'function', 'You must pass a component to the function returned by ' + ('connect. Instead received ' + JSON.stringify(WrappedComponent)));
	
	    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
	
	    var displayName = getDisplayName(wrappedComponentName);
	
	    var selectorFactoryOptions = _extends({}, connectOptions, {
	      getDisplayName: getDisplayName,
	      methodName: methodName,
	      renderCountProp: renderCountProp,
	      shouldHandleStateChanges: shouldHandleStateChanges,
	      storeKey: storeKey,
	      withRef: withRef,
	      displayName: displayName,
	      wrappedComponentName: wrappedComponentName,
	      WrappedComponent: WrappedComponent
	    });
	
	    var Connect = function (_Component) {
	      _inherits(Connect, _Component);
	
	      function Connect(props, context) {
	        _classCallCheck(this, Connect);
	
	        var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	        _this.version = version;
	        _this.state = {};
	        _this.renderCount = 0;
	        _this.store = props[storeKey] || context[storeKey];
	        _this.propsMode = Boolean(props[storeKey]);
	        _this.setWrappedInstance = _this.setWrappedInstance.bind(_this);
	
	        (0, _invariant2.default)(_this.store, 'Could not find "' + storeKey + '" in either the context or props of ' + ('"' + displayName + '". Either wrap the root component in a <Provider>, ') + ('or explicitly pass "' + storeKey + '" as a prop to "' + displayName + '".'));
	
	        _this.initSelector();
	        _this.initSubscription();
	        return _this;
	      }
	
	      Connect.prototype.getChildContext = function getChildContext() {
	        var _ref2;
	
	        // If this component received store from props, its subscription should be transparent
	        // to any descendants receiving store+subscription from context; it passes along
	        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
	        // Connect to control ordering of notifications to flow top-down.
	        var subscription = this.propsMode ? null : this.subscription;
	        return _ref2 = {}, _ref2[subscriptionKey] = subscription || this.context[subscriptionKey], _ref2;
	      };
	
	      Connect.prototype.componentDidMount = function componentDidMount() {
	        if (!shouldHandleStateChanges) return;
	
	        // componentWillMount fires during server side rendering, but componentDidMount and
	        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
	        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
	        // To handle the case where a child component may have triggered a state change by
	        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
	        // re-render.
	        this.subscription.trySubscribe();
	        this.selector.run(this.props);
	        if (this.selector.shouldComponentUpdate) this.forceUpdate();
	      };
	
	      Connect.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	        this.selector.run(nextProps);
	      };
	
	      Connect.prototype.shouldComponentUpdate = function shouldComponentUpdate() {
	        return this.selector.shouldComponentUpdate;
	      };
	
	      Connect.prototype.componentWillUnmount = function componentWillUnmount() {
	        if (this.subscription) this.subscription.tryUnsubscribe();
	        this.subscription = null;
	        this.notifyNestedSubs = noop;
	        this.store = null;
	        this.selector.run = noop;
	        this.selector.shouldComponentUpdate = false;
	      };
	
	      Connect.prototype.getWrappedInstance = function getWrappedInstance() {
	        (0, _invariant2.default)(withRef, 'To access the wrapped instance, you need to specify ' + ('{ withRef: true } in the options argument of the ' + methodName + '() call.'));
	        return this.wrappedInstance;
	      };
	
	      Connect.prototype.setWrappedInstance = function setWrappedInstance(ref) {
	        this.wrappedInstance = ref;
	      };
	
	      Connect.prototype.initSelector = function initSelector() {
	        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
	        this.selector = makeSelectorStateful(sourceSelector, this.store);
	        this.selector.run(this.props);
	      };
	
	      Connect.prototype.initSubscription = function initSubscription() {
	        if (!shouldHandleStateChanges) return;
	
	        // parentSub's source should match where store came from: props vs. context. A component
	        // connected to the store via props shouldn't use subscription from context, or vice versa.
	        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
	        this.subscription = new _Subscription2.default(this.store, parentSub, this.onStateChange.bind(this));
	
	        // `notifyNestedSubs` is duplicated to handle the case where the component is  unmounted in
	        // the middle of the notification loop, where `this.subscription` will then be null. An
	        // extra null check every change can be avoided by copying the method onto `this` and then
	        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
	        // listeners logic is changed to not call listeners that have been unsubscribed in the
	        // middle of the notification loop.
	        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
	      };
	
	      Connect.prototype.onStateChange = function onStateChange() {
	        this.selector.run(this.props);
	
	        if (!this.selector.shouldComponentUpdate) {
	          this.notifyNestedSubs();
	        } else {
	          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
	          this.setState(dummyState);
	        }
	      };
	
	      Connect.prototype.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
	        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
	        // needs to notify nested subs. Once called, it unimplements itself until further state
	        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
	        // a boolean check every time avoids an extra method call most of the time, resulting
	        // in some perf boost.
	        this.componentDidUpdate = undefined;
	        this.notifyNestedSubs();
	      };
	
	      Connect.prototype.isSubscribed = function isSubscribed() {
	        return Boolean(this.subscription) && this.subscription.isSubscribed();
	      };
	
	      Connect.prototype.addExtraProps = function addExtraProps(props) {
	        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props;
	        // make a shallow copy so that fields added don't leak to the original selector.
	        // this is especially important for 'ref' since that's a reference back to the component
	        // instance. a singleton memoized selector would then be holding a reference to the
	        // instance, preventing the instance from being garbage collected, and that would be bad
	        var withExtras = _extends({}, props);
	        if (withRef) withExtras.ref = this.setWrappedInstance;
	        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
	        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
	        return withExtras;
	      };
	
	      Connect.prototype.render = function render() {
	        var selector = this.selector;
	        selector.shouldComponentUpdate = false;
	
	        if (selector.error) {
	          throw selector.error;
	        } else {
	          return (0, _react.createElement)(WrappedComponent, this.addExtraProps(selector.props));
	        }
	      };
	
	      return Connect;
	    }(_react.Component);
	
	    Connect.WrappedComponent = WrappedComponent;
	    Connect.displayName = displayName;
	    Connect.childContextTypes = childContextTypes;
	    Connect.contextTypes = contextTypes;
	    Connect.propTypes = contextTypes;
	
	    if (false) {
	      Connect.prototype.componentWillUpdate = function componentWillUpdate() {
	        var _this2 = this;
	
	        // We are hot reloading!
	        if (this.version !== version) {
	          this.version = version;
	          this.initSelector();
	
	          // If any connected descendants don't hot reload (and resubscribe in the process), their
	          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
	          // listeners, this does mean that the old versions of connected descendants will still be
	          // notified of state changes; however, their onStateChange function is a no-op so this
	          // isn't a huge deal.
	          var oldListeners = [];
	
	          if (this.subscription) {
	            oldListeners = this.subscription.listeners.get();
	            this.subscription.tryUnsubscribe();
	          }
	          this.initSubscription();
	          if (shouldHandleStateChanges) {
	            this.subscription.trySubscribe();
	            oldListeners.forEach(function (listener) {
	              return _this2.subscription.listeners.subscribe(listener);
	            });
	          }
	        }
	      };
	    }
	
	    return (0, _hoistNonReactStatics2.default)(Connect, WrappedComponent);
	  };
	}

/***/ },
/* 415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.wrapMapToPropsConstant = wrapMapToPropsConstant;
	exports.getDependsOnOwnProps = getDependsOnOwnProps;
	exports.wrapMapToPropsFunc = wrapMapToPropsFunc;
	
	var _verifyPlainObject = __webpack_require__(417);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function wrapMapToPropsConstant(getConstant) {
	  return function initConstantSelector(dispatch, options) {
	    var constant = getConstant(dispatch, options);
	
	    function constantSelector() {
	      return constant;
	    }
	    constantSelector.dependsOnOwnProps = false;
	    return constantSelector;
	  };
	}
	
	// dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
	// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
	// whether mapToProps needs to be invoked when props have changed.
	// 
	// A length of one signals that mapToProps does not depend on props from the parent component.
	// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
	// therefore not reporting its length accurately..
	function getDependsOnOwnProps(mapToProps) {
	  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
	}
	
	// Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
	// this function wraps mapToProps in a proxy function which does several things:
	// 
	//  * Detects whether the mapToProps function being called depends on props, which
	//    is used by selectorFactory to decide if it should reinvoke on props changes.
	//    
	//  * On first call, handles mapToProps if returns another function, and treats that
	//    new function as the true mapToProps for subsequent calls.
	//    
	//  * On first call, verifies the first result is a plain object, in order to warn
	//    the developer that their mapToProps function is not returning a valid result.
	//    
	function wrapMapToPropsFunc(mapToProps, methodName) {
	  return function initProxySelector(dispatch, _ref) {
	    var displayName = _ref.displayName;
	
	    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
	      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
	    };
	
	    // allow detectFactoryAndVerify to get ownProps
	    proxy.dependsOnOwnProps = true;
	
	    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
	      proxy.mapToProps = mapToProps;
	      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
	      var props = proxy(stateOrDispatch, ownProps);
	
	      if (typeof props === 'function') {
	        proxy.mapToProps = props;
	        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
	        props = proxy(stateOrDispatch, ownProps);
	      }
	
	      if (false) (0, _verifyPlainObject2.default)(props, displayName, methodName);
	
	      return props;
	    };
	
	    return proxy;
	  };
	}

/***/ },
/* 416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.storeShape = exports.subscriptionShape = undefined;
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var subscriptionShape = exports.subscriptionShape = _propTypes2.default.shape({
	  trySubscribe: _propTypes2.default.func.isRequired,
	  tryUnsubscribe: _propTypes2.default.func.isRequired,
	  notifyNestedSubs: _propTypes2.default.func.isRequired,
	  isSubscribed: _propTypes2.default.func.isRequired
	});
	
	var storeShape = exports.storeShape = _propTypes2.default.shape({
	  subscribe: _propTypes2.default.func.isRequired,
	  dispatch: _propTypes2.default.func.isRequired,
	  getState: _propTypes2.default.func.isRequired
	});

/***/ },
/* 417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifyPlainObject;
	
	var _isPlainObject = __webpack_require__(112);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verifyPlainObject(value, displayName, methodName) {
	  if (!(0, _isPlainObject2.default)(value)) {
	    (0, _warning2.default)(methodName + '() in ' + displayName + ' must return a plain object. Instead received ' + value + '.');
	  }
	}

/***/ },
/* 418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isModifiedEvent = function isModifiedEvent(event) {
	  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
	};
	
	/**
	 * The public API for rendering a history-aware <a>.
	 */
	
	var Link = function (_React$Component) {
	  _inherits(Link, _React$Component);
	
	  function Link() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Link);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
	      if (_this.props.onClick) _this.props.onClick(event);
	
	      if (!event.defaultPrevented && // onClick prevented default
	      event.button === 0 && // ignore right clicks
	      !_this.props.target && // let browser handle "target=_blank" etc.
	      !isModifiedEvent(event) // ignore clicks with modifier keys
	      ) {
	          event.preventDefault();
	
	          var history = _this.context.router.history;
	          var _this$props = _this.props,
	              replace = _this$props.replace,
	              to = _this$props.to;
	
	
	          if (replace) {
	            history.replace(to);
	          } else {
	            history.push(to);
	          }
	        }
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Link.prototype.render = function render() {
	    var _props = this.props,
	        replace = _props.replace,
	        to = _props.to,
	        innerRef = _props.innerRef,
	        props = _objectWithoutProperties(_props, ['replace', 'to', 'innerRef']); // eslint-disable-line no-unused-vars
	
	    (0, _invariant2.default)(this.context.router, 'You should not use <Link> outside a <Router>');
	
	    var href = this.context.router.history.createHref(typeof to === 'string' ? { pathname: to } : to);
	
	    return _react2.default.createElement('a', _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
	  };
	
	  return Link;
	}(_react2.default.Component);
	
	Link.propTypes = {
	  onClick: _propTypes2.default.func,
	  target: _propTypes2.default.string,
	  replace: _propTypes2.default.bool,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired,
	  innerRef: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.func])
	};
	Link.defaultProps = {
	  replace: false
	};
	Link.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired,
	      createHref: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Link;

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Route = __webpack_require__(421);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Route2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.withRouter = exports.matchPath = exports.Switch = exports.StaticRouter = exports.Router = exports.Route = exports.Redirect = exports.Prompt = exports.NavLink = exports.MemoryRouter = exports.Link = exports.HashRouter = exports.BrowserRouter = undefined;
	
	var _BrowserRouter2 = __webpack_require__(1928);
	
	var _BrowserRouter3 = _interopRequireDefault(_BrowserRouter2);
	
	var _HashRouter2 = __webpack_require__(1929);
	
	var _HashRouter3 = _interopRequireDefault(_HashRouter2);
	
	var _Link2 = __webpack_require__(418);
	
	var _Link3 = _interopRequireDefault(_Link2);
	
	var _MemoryRouter2 = __webpack_require__(1930);
	
	var _MemoryRouter3 = _interopRequireDefault(_MemoryRouter2);
	
	var _NavLink2 = __webpack_require__(1931);
	
	var _NavLink3 = _interopRequireDefault(_NavLink2);
	
	var _Prompt2 = __webpack_require__(1932);
	
	var _Prompt3 = _interopRequireDefault(_Prompt2);
	
	var _Redirect2 = __webpack_require__(1933);
	
	var _Redirect3 = _interopRequireDefault(_Redirect2);
	
	var _Route2 = __webpack_require__(419);
	
	var _Route3 = _interopRequireDefault(_Route2);
	
	var _Router2 = __webpack_require__(242);
	
	var _Router3 = _interopRequireDefault(_Router2);
	
	var _StaticRouter2 = __webpack_require__(1934);
	
	var _StaticRouter3 = _interopRequireDefault(_StaticRouter2);
	
	var _Switch2 = __webpack_require__(1935);
	
	var _Switch3 = _interopRequireDefault(_Switch2);
	
	var _matchPath2 = __webpack_require__(1936);
	
	var _matchPath3 = _interopRequireDefault(_matchPath2);
	
	var _withRouter2 = __webpack_require__(1937);
	
	var _withRouter3 = _interopRequireDefault(_withRouter2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BrowserRouter = _BrowserRouter3.default;
	exports.HashRouter = _HashRouter3.default;
	exports.Link = _Link3.default;
	exports.MemoryRouter = _MemoryRouter3.default;
	exports.NavLink = _NavLink3.default;
	exports.Prompt = _Prompt3.default;
	exports.Redirect = _Redirect3.default;
	exports.Route = _Route3.default;
	exports.Router = _Router3.default;
	exports.StaticRouter = _StaticRouter3.default;
	exports.Switch = _Switch3.default;
	exports.matchPath = _matchPath3.default;
	exports.withRouter = _withRouter3.default;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _matchPath = __webpack_require__(244);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var isEmptyChildren = function isEmptyChildren(children) {
	  return _react2.default.Children.count(children) === 0;
	};
	
	/**
	 * The public API for matching a single path and rendering.
	 */
	
	var Route = function (_React$Component) {
	  _inherits(Route, _React$Component);
	
	  function Route() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, Route);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
	      match: _this.computeMatch(_this.props, _this.context.router)
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  Route.prototype.getChildContext = function getChildContext() {
	    return {
	      router: _extends({}, this.context.router, {
	        route: {
	          location: this.props.location || this.context.router.route.location,
	          match: this.state.match
	        }
	      })
	    };
	  };
	
	  Route.prototype.computeMatch = function computeMatch(_ref, router) {
	    var computedMatch = _ref.computedMatch,
	        location = _ref.location,
	        path = _ref.path,
	        strict = _ref.strict,
	        exact = _ref.exact,
	        sensitive = _ref.sensitive;
	
	    if (computedMatch) return computedMatch; // <Switch> already computed the match for us
	
	    (0, _invariant2.default)(router, 'You should not use <Route> or withRouter() outside a <Router>');
	
	    var route = router.route;
	
	    var pathname = (location || route.location).pathname;
	
	    return path ? (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }) : route.match;
	  };
	
	  Route.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!(this.props.component && this.props.render), 'You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored');
	
	    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored');
	
	    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), 'You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored');
	  };
	
	  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	
	    this.setState({
	      match: this.computeMatch(nextProps, nextContext.router)
	    });
	  };
	
	  Route.prototype.render = function render() {
	    var match = this.state.match;
	    var _props = this.props,
	        children = _props.children,
	        component = _props.component,
	        render = _props.render;
	    var _context$router = this.context.router,
	        history = _context$router.history,
	        route = _context$router.route,
	        staticContext = _context$router.staticContext;
	
	    var location = this.props.location || route.location;
	    var props = { match: match, location: location, history: history, staticContext: staticContext };
	
	    return component ? // component prop gets first priority, only called if there's a match
	    match ? _react2.default.createElement(component, props) : null : render ? // render prop is next, only called if there's a match
	    match ? render(props) : null : children ? // children come last, always called
	    typeof children === 'function' ? children(props) : !isEmptyChildren(children) ? _react2.default.Children.only(children) : null : null;
	  };
	
	  return Route;
	}(_react2.default.Component);
	
	Route.propTypes = {
	  computedMatch: _propTypes2.default.object, // private, from <Switch>
	  path: _propTypes2.default.string,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  sensitive: _propTypes2.default.bool,
	  component: _propTypes2.default.func,
	  render: _propTypes2.default.func,
	  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
	  location: _propTypes2.default.object
	};
	Route.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.object.isRequired,
	    route: _propTypes2.default.object.isRequired,
	    staticContext: _propTypes2.default.object
	  })
	};
	Route.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = Route;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(442);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(120),
	    _assign = __webpack_require__(18);
	
	var ReactNoopUpdateQueue = __webpack_require__(426);
	
	var canDefineProperty = __webpack_require__(427);
	var emptyObject = __webpack_require__(130);
	var invariant = __webpack_require__(13);
	var lowPriorityWarning = __webpack_require__(1966);
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactComponent(props, context, updater) {
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	ReactComponent.prototype.isReactComponent = {};
	
	/**
	 * Sets a subset of the state. Always use this to mutate
	 * state. You should treat `this.state` as immutable.
	 *
	 * There is no guarantee that `this.state` will be immediately updated, so
	 * accessing `this.state` after calling this method may return the old value.
	 *
	 * There is no guarantee that calls to `setState` will run synchronously,
	 * as they may eventually be batched together.  You can provide an optional
	 * callback that will be executed when the call to setState is actually
	 * completed.
	 *
	 * When a function is provided to setState, it will be called at some point in
	 * the future (not synchronously). It will be called with the up to date
	 * component arguments (state, props, context). These values can be different
	 * from this.* because your function may be called after receiveProps but before
	 * shouldComponentUpdate, and this new state, props, and context will not yet be
	 * assigned to this.
	 *
	 * @param {object|function} partialState Next partial state or function to
	 *        produce next partial state to be merged with current state.
	 * @param {?function} callback Called after state is updated.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.setState = function (partialState, callback) {
	  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
	  this.updater.enqueueSetState(this, partialState);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'setState');
	  }
	};
	
	/**
	 * Forces an update. This should only be invoked when it is known with
	 * certainty that we are **not** in a DOM transaction.
	 *
	 * You may want to call this when you know that some deeper aspect of the
	 * component's state has changed but `setState` was not called.
	 *
	 * This will not invoke `shouldComponentUpdate`, but it will invoke
	 * `componentWillUpdate` and `componentDidUpdate`.
	 *
	 * @param {?function} callback Called after update is complete.
	 * @final
	 * @protected
	 */
	ReactComponent.prototype.forceUpdate = function (callback) {
	  this.updater.enqueueForceUpdate(this);
	  if (callback) {
	    this.updater.enqueueCallback(this, callback, 'forceUpdate');
	  }
	};
	
	/**
	 * Deprecated APIs. These APIs used to exist on classic React classes but since
	 * we would like to deprecate them, we're not going to move them over to this
	 * modern base class. Instead, we define a getter that warns if it's accessed.
	 */
	if (false) {
	  var deprecatedAPIs = {
	    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
	    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
	  };
	  var defineDeprecationWarning = function (methodName, info) {
	    if (canDefineProperty) {
	      Object.defineProperty(ReactComponent.prototype, methodName, {
	        get: function () {
	          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
	          return undefined;
	        }
	      });
	    }
	  };
	  for (var fnName in deprecatedAPIs) {
	    if (deprecatedAPIs.hasOwnProperty(fnName)) {
	      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
	    }
	  }
	}
	
	/**
	 * Base class helpers for the updating state of a component.
	 */
	function ReactPureComponent(props, context, updater) {
	  // Duplicated from ReactComponent.
	  this.props = props;
	  this.context = context;
	  this.refs = emptyObject;
	  // We initialize the default updater but the real one gets injected by the
	  // renderer.
	  this.updater = updater || ReactNoopUpdateQueue;
	}
	
	function ComponentDummy() {}
	ComponentDummy.prototype = ReactComponent.prototype;
	ReactPureComponent.prototype = new ComponentDummy();
	ReactPureComponent.prototype.constructor = ReactPureComponent;
	// Avoid an extra prototype jump for these methods.
	_assign(ReactPureComponent.prototype, ReactComponent.prototype);
	ReactPureComponent.prototype.isPureReactComponent = true;
	
	module.exports = {
	  Component: ReactComponent,
	  PureComponent: ReactPureComponent
	};

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2016-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(120);
	
	var ReactCurrentOwner = __webpack_require__(45);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(16);
	
	function isNative(fn) {
	  // Based on isNative() from Lodash
	  var funcToString = Function.prototype.toString;
	  var hasOwnProperty = Object.prototype.hasOwnProperty;
	  var reIsNative = RegExp('^' + funcToString
	  // Take an example native function source for comparison
	  .call(hasOwnProperty
	  // Strip regex characters so we can use it for regex
	  ).replace(/[\\^$.*+?()[\]{}|]/g, '\\$&'
	  // Remove hasOwnProperty from the template to make it generic
	  ).replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
	  try {
	    var source = funcToString.call(fn);
	    return reIsNative.test(source);
	  } catch (err) {
	    return false;
	  }
	}
	
	var canUseCollections =
	// Array.from
	typeof Array.from === 'function' &&
	// Map
	typeof Map === 'function' && isNative(Map) &&
	// Map.prototype.keys
	Map.prototype != null && typeof Map.prototype.keys === 'function' && isNative(Map.prototype.keys) &&
	// Set
	typeof Set === 'function' && isNative(Set) &&
	// Set.prototype.keys
	Set.prototype != null && typeof Set.prototype.keys === 'function' && isNative(Set.prototype.keys);
	
	var setItem;
	var getItem;
	var removeItem;
	var getItemIDs;
	var addRoot;
	var removeRoot;
	var getRootIDs;
	
	if (canUseCollections) {
	  var itemMap = new Map();
	  var rootIDSet = new Set();
	
	  setItem = function (id, item) {
	    itemMap.set(id, item);
	  };
	  getItem = function (id) {
	    return itemMap.get(id);
	  };
	  removeItem = function (id) {
	    itemMap['delete'](id);
	  };
	  getItemIDs = function () {
	    return Array.from(itemMap.keys());
	  };
	
	  addRoot = function (id) {
	    rootIDSet.add(id);
	  };
	  removeRoot = function (id) {
	    rootIDSet['delete'](id);
	  };
	  getRootIDs = function () {
	    return Array.from(rootIDSet.keys());
	  };
	} else {
	  var itemByKey = {};
	  var rootByKey = {};
	
	  // Use non-numeric keys to prevent V8 performance issues:
	  // https://github.com/facebook/react/pull/7232
	  var getKeyFromID = function (id) {
	    return '.' + id;
	  };
	  var getIDFromKey = function (key) {
	    return parseInt(key.substr(1), 10);
	  };
	
	  setItem = function (id, item) {
	    var key = getKeyFromID(id);
	    itemByKey[key] = item;
	  };
	  getItem = function (id) {
	    var key = getKeyFromID(id);
	    return itemByKey[key];
	  };
	  removeItem = function (id) {
	    var key = getKeyFromID(id);
	    delete itemByKey[key];
	  };
	  getItemIDs = function () {
	    return Object.keys(itemByKey).map(getIDFromKey);
	  };
	
	  addRoot = function (id) {
	    var key = getKeyFromID(id);
	    rootByKey[key] = true;
	  };
	  removeRoot = function (id) {
	    var key = getKeyFromID(id);
	    delete rootByKey[key];
	  };
	  getRootIDs = function () {
	    return Object.keys(rootByKey).map(getIDFromKey);
	  };
	}
	
	var unmountedIDs = [];
	
	function purgeDeep(id) {
	  var item = getItem(id);
	  if (item) {
	    var childIDs = item.childIDs;
	
	    removeItem(id);
	    childIDs.forEach(purgeDeep);
	  }
	}
	
	function describeComponentFrame(name, source, ownerName) {
	  return '\n    in ' + (name || 'Unknown') + (source ? ' (at ' + source.fileName.replace(/^.*[\\\/]/, '') + ':' + source.lineNumber + ')' : ownerName ? ' (created by ' + ownerName + ')' : '');
	}
	
	function getDisplayName(element) {
	  if (element == null) {
	    return '#empty';
	  } else if (typeof element === 'string' || typeof element === 'number') {
	    return '#text';
	  } else if (typeof element.type === 'string') {
	    return element.type;
	  } else {
	    return element.type.displayName || element.type.name || 'Unknown';
	  }
	}
	
	function describeID(id) {
	  var name = ReactComponentTreeHook.getDisplayName(id);
	  var element = ReactComponentTreeHook.getElement(id);
	  var ownerID = ReactComponentTreeHook.getOwnerID(id);
	  var ownerName;
	  if (ownerID) {
	    ownerName = ReactComponentTreeHook.getDisplayName(ownerID);
	  }
	   false ? warning(element, 'ReactComponentTreeHook: Missing React element for debugID %s when ' + 'building stack', id) : void 0;
	  return describeComponentFrame(name, element && element._source, ownerName);
	}
	
	var ReactComponentTreeHook = {
	  onSetChildren: function (id, nextChildIDs) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.childIDs = nextChildIDs;
	
	    for (var i = 0; i < nextChildIDs.length; i++) {
	      var nextChildID = nextChildIDs[i];
	      var nextChild = getItem(nextChildID);
	      !nextChild ?  false ? invariant(false, 'Expected hook events to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('140') : void 0;
	      !(nextChild.childIDs != null || typeof nextChild.element !== 'object' || nextChild.element == null) ?  false ? invariant(false, 'Expected onSetChildren() to fire for a container child before its parent includes it in onSetChildren().') : _prodInvariant('141') : void 0;
	      !nextChild.isMounted ?  false ? invariant(false, 'Expected onMountComponent() to fire for the child before its parent includes it in onSetChildren().') : _prodInvariant('71') : void 0;
	      if (nextChild.parentID == null) {
	        nextChild.parentID = id;
	        // TODO: This shouldn't be necessary but mounting a new root during in
	        // componentWillMount currently causes not-yet-mounted components to
	        // be purged from our tree data so their parent id is missing.
	      }
	      !(nextChild.parentID === id) ?  false ? invariant(false, 'Expected onBeforeMountComponent() parent and onSetChildren() to be consistent (%s has parents %s and %s).', nextChildID, nextChild.parentID, id) : _prodInvariant('142', nextChildID, nextChild.parentID, id) : void 0;
	    }
	  },
	  onBeforeMountComponent: function (id, element, parentID) {
	    var item = {
	      element: element,
	      parentID: parentID,
	      text: null,
	      childIDs: [],
	      isMounted: false,
	      updateCount: 0
	    };
	    setItem(id, item);
	  },
	  onBeforeUpdateComponent: function (id, element) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.element = element;
	  },
	  onMountComponent: function (id) {
	    var item = getItem(id);
	    !item ?  false ? invariant(false, 'Item must have been set') : _prodInvariant('144') : void 0;
	    item.isMounted = true;
	    var isRoot = item.parentID === 0;
	    if (isRoot) {
	      addRoot(id);
	    }
	  },
	  onUpdateComponent: function (id) {
	    var item = getItem(id);
	    if (!item || !item.isMounted) {
	      // We may end up here as a result of setState() in componentWillUnmount().
	      // In this case, ignore the element.
	      return;
	    }
	    item.updateCount++;
	  },
	  onUnmountComponent: function (id) {
	    var item = getItem(id);
	    if (item) {
	      // We need to check if it exists.
	      // `item` might not exist if it is inside an error boundary, and a sibling
	      // error boundary child threw while mounting. Then this instance never
	      // got a chance to mount, but it still gets an unmounting event during
	      // the error boundary cleanup.
	      item.isMounted = false;
	      var isRoot = item.parentID === 0;
	      if (isRoot) {
	        removeRoot(id);
	      }
	    }
	    unmountedIDs.push(id);
	  },
	  purgeUnmountedComponents: function () {
	    if (ReactComponentTreeHook._preventPurging) {
	      // Should only be used for testing.
	      return;
	    }
	
	    for (var i = 0; i < unmountedIDs.length; i++) {
	      var id = unmountedIDs[i];
	      purgeDeep(id);
	    }
	    unmountedIDs.length = 0;
	  },
	  isMounted: function (id) {
	    var item = getItem(id);
	    return item ? item.isMounted : false;
	  },
	  getCurrentStackAddendum: function (topElement) {
	    var info = '';
	    if (topElement) {
	      var name = getDisplayName(topElement);
	      var owner = topElement._owner;
	      info += describeComponentFrame(name, topElement._source, owner && owner.getName());
	    }
	
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    info += ReactComponentTreeHook.getStackAddendumByID(id);
	    return info;
	  },
	  getStackAddendumByID: function (id) {
	    var info = '';
	    while (id) {
	      info += describeID(id);
	      id = ReactComponentTreeHook.getParentID(id);
	    }
	    return info;
	  },
	  getChildIDs: function (id) {
	    var item = getItem(id);
	    return item ? item.childIDs : [];
	  },
	  getDisplayName: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element) {
	      return null;
	    }
	    return getDisplayName(element);
	  },
	  getElement: function (id) {
	    var item = getItem(id);
	    return item ? item.element : null;
	  },
	  getOwnerID: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (!element || !element._owner) {
	      return null;
	    }
	    return element._owner._debugID;
	  },
	  getParentID: function (id) {
	    var item = getItem(id);
	    return item ? item.parentID : null;
	  },
	  getSource: function (id) {
	    var item = getItem(id);
	    var element = item ? item.element : null;
	    var source = element != null ? element._source : null;
	    return source;
	  },
	  getText: function (id) {
	    var element = ReactComponentTreeHook.getElement(id);
	    if (typeof element === 'string') {
	      return element;
	    } else if (typeof element === 'number') {
	      return '' + element;
	    } else {
	      return null;
	    }
	  },
	  getUpdateCount: function (id) {
	    var item = getItem(id);
	    return item ? item.updateCount : 0;
	  },
	
	
	  getRootIDs: getRootIDs,
	  getRegisteredIDs: getItemIDs,
	
	  pushNonStandardWarningStack: function (isCreatingElement, currentSource) {
	    if (typeof console.reactStack !== 'function') {
	      return;
	    }
	
	    var stack = [];
	    var currentOwner = ReactCurrentOwner.current;
	    var id = currentOwner && currentOwner._debugID;
	
	    try {
	      if (isCreatingElement) {
	        stack.push({
	          name: id ? ReactComponentTreeHook.getDisplayName(id) : null,
	          fileName: currentSource ? currentSource.fileName : null,
	          lineNumber: currentSource ? currentSource.lineNumber : null
	        });
	      }
	
	      while (id) {
	        var element = ReactComponentTreeHook.getElement(id);
	        var parentID = ReactComponentTreeHook.getParentID(id);
	        var ownerID = ReactComponentTreeHook.getOwnerID(id);
	        var ownerName = ownerID ? ReactComponentTreeHook.getDisplayName(ownerID) : null;
	        var source = element && element._source;
	        stack.push({
	          name: ownerName,
	          fileName: source ? source.fileName : null,
	          lineNumber: source ? source.lineNumber : null
	        });
	        id = parentID;
	      }
	    } catch (err) {
	      // Internal state is messed up.
	      // Stop building the stack (it's just a nice to have).
	    }
	
	    console.reactStack(stack);
	  },
	  popNonStandardWarningStack: function () {
	    if (typeof console.reactStackEnd !== 'function') {
	      return;
	    }
	    console.reactStackEnd();
	  }
	};
	
	module.exports = ReactComponentTreeHook;

/***/ },
/* 425 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	// The Symbol used to tag the ReactElement type. If there is no native Symbol
	// nor polyfill, then a plain number is used for performance.
	
	var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;
	
	module.exports = REACT_ELEMENT_TYPE;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var warning = __webpack_require__(16);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the abstract API for an update queue.
	 */
	var ReactNoopUpdateQueue = {
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	  isMounted: function (publicInstance) {
	    return false;
	  },
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	  enqueueCallback: function (publicInstance, callback) {},
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	  enqueueForceUpdate: function (publicInstance) {
	    warnNoop(publicInstance, 'forceUpdate');
	  },
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} completeState Next state.
	   * @internal
	   */
	  enqueueReplaceState: function (publicInstance, completeState) {
	    warnNoop(publicInstance, 'replaceState');
	  },
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object} partialState Next partial state to be merged with state.
	   * @internal
	   */
	  enqueueSetState: function (publicInstance, partialState) {
	    warnNoop(publicInstance, 'setState');
	  }
	};
	
	module.exports = ReactNoopUpdateQueue;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var canDefineProperty = false;
	if (false) {
	  try {
	    // $FlowFixMe https://github.com/facebook/flow/issues/285
	    Object.defineProperty({}, 'x', { get: function () {} });
	    canDefineProperty = true;
	  } catch (x) {
	    // IE will fail on defineProperty
	  }
	}
	
	module.exports = canDefineProperty;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(153);
	/*</replacement>*/
	
	module.exports = Readable;
	
	/*<replacement>*/
	var isArray = __webpack_require__(287);
	/*</replacement>*/
	
	/*<replacement>*/
	var Duplex;
	/*</replacement>*/
	
	Readable.ReadableState = ReadableState;
	
	/*<replacement>*/
	var EE = __webpack_require__(129).EventEmitter;
	
	var EElistenerCount = function (emitter, type) {
	  return emitter.listeners(type).length;
	};
	/*</replacement>*/
	
	/*<replacement>*/
	var Stream = __webpack_require__(431);
	/*</replacement>*/
	
	// TODO(bmeurer): Change this back to const once hole checks are
	// properly optimized away early in Ignition+TurboFan.
	/*<replacement>*/
	var Buffer = __webpack_require__(160).Buffer;
	var OurUint8Array = global.Uint8Array || function () {};
	function _uint8ArrayToBuffer(chunk) {
	  return Buffer.from(chunk);
	}
	function _isUint8Array(obj) {
	  return Buffer.isBuffer(obj) || obj instanceof OurUint8Array;
	}
	/*</replacement>*/
	
	/*<replacement>*/
	var util = __webpack_require__(103);
	util.inherits = __webpack_require__(38);
	/*</replacement>*/
	
	/*<replacement>*/
	var debugUtil = __webpack_require__(2034);
	var debug = void 0;
	if (debugUtil && debugUtil.debuglog) {
	  debug = debugUtil.debuglog('stream');
	} else {
	  debug = function () {};
	}
	/*</replacement>*/
	
	var BufferList = __webpack_require__(1971);
	var destroyImpl = __webpack_require__(430);
	var StringDecoder;
	
	util.inherits(Readable, Stream);
	
	var kProxyEvents = ['error', 'close', 'destroy', 'pause', 'resume'];
	
	function prependListener(emitter, event, fn) {
	  // Sadly this is not cacheable as some libraries bundle their own
	  // event emitter implementation with them.
	  if (typeof emitter.prependListener === 'function') {
	    return emitter.prependListener(event, fn);
	  } else {
	    // This is a hack to make sure that our error handler is attached before any
	    // userland ones.  NEVER DO THIS. This is here only because this code needs
	    // to continue to work with older versions of Node.js that do not include
	    // the prependListener() method. The goal is to eventually remove this hack.
	    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);else if (isArray(emitter._events[event])) emitter._events[event].unshift(fn);else emitter._events[event] = [fn, emitter._events[event]];
	  }
	}
	
	function ReadableState(options, stream) {
	  Duplex = Duplex || __webpack_require__(67);
	
	  options = options || {};
	
	  // object stream flag. Used to make read(n) ignore n and to
	  // make all the buffer merging and length checks go away
	  this.objectMode = !!options.objectMode;
	
	  if (stream instanceof Duplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
	
	  // the point at which it stops calling _read() to fill the buffer
	  // Note: 0 is a valid value, means "don't call _read preemptively ever"
	  var hwm = options.highWaterMark;
	  var defaultHwm = this.objectMode ? 16 : 16 * 1024;
	  this.highWaterMark = hwm || hwm === 0 ? hwm : defaultHwm;
	
	  // cast to ints.
	  this.highWaterMark = Math.floor(this.highWaterMark);
	
	  // A linked list is used to store data chunks instead of an array because the
	  // linked list can remove elements from the beginning faster than
	  // array.shift()
	  this.buffer = new BufferList();
	  this.length = 0;
	  this.pipes = null;
	  this.pipesCount = 0;
	  this.flowing = null;
	  this.ended = false;
	  this.endEmitted = false;
	  this.reading = false;
	
	  // a flag to be able to tell if the event 'readable'/'data' is emitted
	  // immediately, or on a later tick.  We set this to true at first, because
	  // any actions that shouldn't happen until "later" should generally also
	  // not happen before the first read call.
	  this.sync = true;
	
	  // whenever we return null, then we set a flag to say
	  // that we're awaiting a 'readable' event emission.
	  this.needReadable = false;
	  this.emittedReadable = false;
	  this.readableListening = false;
	  this.resumeScheduled = false;
	
	  // has it been destroyed
	  this.destroyed = false;
	
	  // Crypto is kind of old and crusty.  Historically, its default string
	  // encoding is 'binary' so we have to make this configurable.
	  // Everything else in the universe uses 'utf8', though.
	  this.defaultEncoding = options.defaultEncoding || 'utf8';
	
	  // the number of writers that are awaiting a drain event in .pipe()s
	  this.awaitDrain = 0;
	
	  // if true, a maybeReadMore has been scheduled
	  this.readingMore = false;
	
	  this.decoder = null;
	  this.encoding = null;
	  if (options.encoding) {
	    if (!StringDecoder) StringDecoder = __webpack_require__(247).StringDecoder;
	    this.decoder = new StringDecoder(options.encoding);
	    this.encoding = options.encoding;
	  }
	}
	
	function Readable(options) {
	  Duplex = Duplex || __webpack_require__(67);
	
	  if (!(this instanceof Readable)) return new Readable(options);
	
	  this._readableState = new ReadableState(options, this);
	
	  // legacy
	  this.readable = true;
	
	  if (options) {
	    if (typeof options.read === 'function') this._read = options.read;
	
	    if (typeof options.destroy === 'function') this._destroy = options.destroy;
	  }
	
	  Stream.call(this);
	}
	
	Object.defineProperty(Readable.prototype, 'destroyed', {
	  get: function () {
	    if (this._readableState === undefined) {
	      return false;
	    }
	    return this._readableState.destroyed;
	  },
	  set: function (value) {
	    // we ignore the value if the stream
	    // has not been initialized yet
	    if (!this._readableState) {
	      return;
	    }
	
	    // backward compatibility, the user is explicitly
	    // managing destroyed
	    this._readableState.destroyed = value;
	  }
	});
	
	Readable.prototype.destroy = destroyImpl.destroy;
	Readable.prototype._undestroy = destroyImpl.undestroy;
	Readable.prototype._destroy = function (err, cb) {
	  this.push(null);
	  cb(err);
	};
	
	// Manually shove something into the read() buffer.
	// This returns true if the highWaterMark has not been hit yet,
	// similar to how Writable.write() returns true if you should
	// write() some more.
	Readable.prototype.push = function (chunk, encoding) {
	  var state = this._readableState;
	  var skipChunkCheck;
	
	  if (!state.objectMode) {
	    if (typeof chunk === 'string') {
	      encoding = encoding || state.defaultEncoding;
	      if (encoding !== state.encoding) {
	        chunk = Buffer.from(chunk, encoding);
	        encoding = '';
	      }
	      skipChunkCheck = true;
	    }
	  } else {
	    skipChunkCheck = true;
	  }
	
	  return readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
	};
	
	// Unshift should *always* be something directly out of read()
	Readable.prototype.unshift = function (chunk) {
	  return readableAddChunk(this, chunk, null, true, false);
	};
	
	function readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
	  var state = stream._readableState;
	  if (chunk === null) {
	    state.reading = false;
	    onEofChunk(stream, state);
	  } else {
	    var er;
	    if (!skipChunkCheck) er = chunkInvalid(state, chunk);
	    if (er) {
	      stream.emit('error', er);
	    } else if (state.objectMode || chunk && chunk.length > 0) {
	      if (typeof chunk !== 'string' && !state.objectMode && Object.getPrototypeOf(chunk) !== Buffer.prototype) {
	        chunk = _uint8ArrayToBuffer(chunk);
	      }
	
	      if (addToFront) {
	        if (state.endEmitted) stream.emit('error', new Error('stream.unshift() after end event'));else addChunk(stream, state, chunk, true);
	      } else if (state.ended) {
	        stream.emit('error', new Error('stream.push() after EOF'));
	      } else {
	        state.reading = false;
	        if (state.decoder && !encoding) {
	          chunk = state.decoder.write(chunk);
	          if (state.objectMode || chunk.length !== 0) addChunk(stream, state, chunk, false);else maybeReadMore(stream, state);
	        } else {
	          addChunk(stream, state, chunk, false);
	        }
	      }
	    } else if (!addToFront) {
	      state.reading = false;
	    }
	  }
	
	  return needMoreData(state);
	}
	
	function addChunk(stream, state, chunk, addToFront) {
	  if (state.flowing && state.length === 0 && !state.sync) {
	    stream.emit('data', chunk);
	    stream.read(0);
	  } else {
	    // update the buffer info.
	    state.length += state.objectMode ? 1 : chunk.length;
	    if (addToFront) state.buffer.unshift(chunk);else state.buffer.push(chunk);
	
	    if (state.needReadable) emitReadable(stream);
	  }
	  maybeReadMore(stream, state);
	}
	
	function chunkInvalid(state, chunk) {
	  var er;
	  if (!_isUint8Array(chunk) && typeof chunk !== 'string' && chunk !== undefined && !state.objectMode) {
	    er = new TypeError('Invalid non-string/buffer chunk');
	  }
	  return er;
	}
	
	// if it's past the high water mark, we can push in some more.
	// Also, if we have no data yet, we can stand some
	// more bytes.  This is to work around cases where hwm=0,
	// such as the repl.  Also, if the push() triggered a
	// readable event, and the user called read(largeNumber) such that
	// needReadable was set, then we ought to push more, so that another
	// 'readable' event will be triggered.
	function needMoreData(state) {
	  return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
	}
	
	Readable.prototype.isPaused = function () {
	  return this._readableState.flowing === false;
	};
	
	// backwards compatibility.
	Readable.prototype.setEncoding = function (enc) {
	  if (!StringDecoder) StringDecoder = __webpack_require__(247).StringDecoder;
	  this._readableState.decoder = new StringDecoder(enc);
	  this._readableState.encoding = enc;
	  return this;
	};
	
	// Don't raise the hwm > 8MB
	var MAX_HWM = 0x800000;
	function computeNewHighWaterMark(n) {
	  if (n >= MAX_HWM) {
	    n = MAX_HWM;
	  } else {
	    // Get the next highest power of 2 to prevent increasing hwm excessively in
	    // tiny amounts
	    n--;
	    n |= n >>> 1;
	    n |= n >>> 2;
	    n |= n >>> 4;
	    n |= n >>> 8;
	    n |= n >>> 16;
	    n++;
	  }
	  return n;
	}
	
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function howMuchToRead(n, state) {
	  if (n <= 0 || state.length === 0 && state.ended) return 0;
	  if (state.objectMode) return 1;
	  if (n !== n) {
	    // Only flow one buffer at a time
	    if (state.flowing && state.length) return state.buffer.head.data.length;else return state.length;
	  }
	  // If we're asking for more than the current hwm, then raise the hwm.
	  if (n > state.highWaterMark) state.highWaterMark = computeNewHighWaterMark(n);
	  if (n <= state.length) return n;
	  // Don't have enough
	  if (!state.ended) {
	    state.needReadable = true;
	    return 0;
	  }
	  return state.length;
	}
	
	// you can override either this method, or the async _read(n) below.
	Readable.prototype.read = function (n) {
	  debug('read', n);
	  n = parseInt(n, 10);
	  var state = this._readableState;
	  var nOrig = n;
	
	  if (n !== 0) state.emittedReadable = false;
	
	  // if we're doing read(0) to trigger a readable event, but we
	  // already have a bunch of data in the buffer, then just trigger
	  // the 'readable' event and move on.
	  if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
	    debug('read: emitReadable', state.length, state.ended);
	    if (state.length === 0 && state.ended) endReadable(this);else emitReadable(this);
	    return null;
	  }
	
	  n = howMuchToRead(n, state);
	
	  // if we've ended, and we're now clear, then finish it up.
	  if (n === 0 && state.ended) {
	    if (state.length === 0) endReadable(this);
	    return null;
	  }
	
	  // All the actual chunk generation logic needs to be
	  // *below* the call to _read.  The reason is that in certain
	  // synthetic stream cases, such as passthrough streams, _read
	  // may be a completely synchronous operation which may change
	  // the state of the read buffer, providing enough data when
	  // before there was *not* enough.
	  //
	  // So, the steps are:
	  // 1. Figure out what the state of things will be after we do
	  // a read from the buffer.
	  //
	  // 2. If that resulting state will trigger a _read, then call _read.
	  // Note that this may be asynchronous, or synchronous.  Yes, it is
	  // deeply ugly to write APIs this way, but that still doesn't mean
	  // that the Readable class should behave improperly, as streams are
	  // designed to be sync/async agnostic.
	  // Take note if the _read call is sync or async (ie, if the read call
	  // has returned yet), so that we know whether or not it's safe to emit
	  // 'readable' etc.
	  //
	  // 3. Actually pull the requested chunks out of the buffer and return.
	
	  // if we need a readable event, then we need to do some reading.
	  var doRead = state.needReadable;
	  debug('need readable', doRead);
	
	  // if we currently have less than the highWaterMark, then also read some
	  if (state.length === 0 || state.length - n < state.highWaterMark) {
	    doRead = true;
	    debug('length less than watermark', doRead);
	  }
	
	  // however, if we've ended, then there's no point, and if we're already
	  // reading, then it's unnecessary.
	  if (state.ended || state.reading) {
	    doRead = false;
	    debug('reading or ended', doRead);
	  } else if (doRead) {
	    debug('do read');
	    state.reading = true;
	    state.sync = true;
	    // if the length is currently zero, then we *need* a readable event.
	    if (state.length === 0) state.needReadable = true;
	    // call internal read method
	    this._read(state.highWaterMark);
	    state.sync = false;
	    // If _read pushed data synchronously, then `reading` will be false,
	    // and we need to re-evaluate how much data we can return to the user.
	    if (!state.reading) n = howMuchToRead(nOrig, state);
	  }
	
	  var ret;
	  if (n > 0) ret = fromList(n, state);else ret = null;
	
	  if (ret === null) {
	    state.needReadable = true;
	    n = 0;
	  } else {
	    state.length -= n;
	  }
	
	  if (state.length === 0) {
	    // If we have nothing in the buffer, then we want to know
	    // as soon as we *do* get something into the buffer.
	    if (!state.ended) state.needReadable = true;
	
	    // If we tried to read() past the EOF, then emit end on the next tick.
	    if (nOrig !== n && state.ended) endReadable(this);
	  }
	
	  if (ret !== null) this.emit('data', ret);
	
	  return ret;
	};
	
	function onEofChunk(stream, state) {
	  if (state.ended) return;
	  if (state.decoder) {
	    var chunk = state.decoder.end();
	    if (chunk && chunk.length) {
	      state.buffer.push(chunk);
	      state.length += state.objectMode ? 1 : chunk.length;
	    }
	  }
	  state.ended = true;
	
	  // emit 'readable' now to make sure it gets picked up.
	  emitReadable(stream);
	}
	
	// Don't emit readable right away in sync mode, because this can trigger
	// another read() call => stack overflow.  This way, it might trigger
	// a nextTick recursion warning, but that's not so bad.
	function emitReadable(stream) {
	  var state = stream._readableState;
	  state.needReadable = false;
	  if (!state.emittedReadable) {
	    debug('emitReadable', state.flowing);
	    state.emittedReadable = true;
	    if (state.sync) processNextTick(emitReadable_, stream);else emitReadable_(stream);
	  }
	}
	
	function emitReadable_(stream) {
	  debug('emit readable');
	  stream.emit('readable');
	  flow(stream);
	}
	
	// at this point, the user has presumably seen the 'readable' event,
	// and called read() to consume some data.  that may have triggered
	// in turn another _read(n) call, in which case reading = true if
	// it's in progress.
	// However, if we're not ended, or reading, and the length < hwm,
	// then go ahead and try to read some more preemptively.
	function maybeReadMore(stream, state) {
	  if (!state.readingMore) {
	    state.readingMore = true;
	    processNextTick(maybeReadMore_, stream, state);
	  }
	}
	
	function maybeReadMore_(stream, state) {
	  var len = state.length;
	  while (!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark) {
	    debug('maybeReadMore read 0');
	    stream.read(0);
	    if (len === state.length)
	      // didn't get any data, stop spinning.
	      break;else len = state.length;
	  }
	  state.readingMore = false;
	}
	
	// abstract method.  to be overridden in specific implementation classes.
	// call cb(er, data) where data is <= n in length.
	// for virtual (non-string, non-buffer) streams, "length" is somewhat
	// arbitrary, and perhaps not very meaningful.
	Readable.prototype._read = function (n) {
	  this.emit('error', new Error('_read() is not implemented'));
	};
	
	Readable.prototype.pipe = function (dest, pipeOpts) {
	  var src = this;
	  var state = this._readableState;
	
	  switch (state.pipesCount) {
	    case 0:
	      state.pipes = dest;
	      break;
	    case 1:
	      state.pipes = [state.pipes, dest];
	      break;
	    default:
	      state.pipes.push(dest);
	      break;
	  }
	  state.pipesCount += 1;
	  debug('pipe count=%d opts=%j', state.pipesCount, pipeOpts);
	
	  var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== process.stdout && dest !== process.stderr;
	
	  var endFn = doEnd ? onend : unpipe;
	  if (state.endEmitted) processNextTick(endFn);else src.once('end', endFn);
	
	  dest.on('unpipe', onunpipe);
	  function onunpipe(readable, unpipeInfo) {
	    debug('onunpipe');
	    if (readable === src) {
	      if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
	        unpipeInfo.hasUnpiped = true;
	        cleanup();
	      }
	    }
	  }
	
	  function onend() {
	    debug('onend');
	    dest.end();
	  }
	
	  // when the dest drains, it reduces the awaitDrain counter
	  // on the source.  This would be more elegant with a .once()
	  // handler in flow(), but adding and removing repeatedly is
	  // too slow.
	  var ondrain = pipeOnDrain(src);
	  dest.on('drain', ondrain);
	
	  var cleanedUp = false;
	  function cleanup() {
	    debug('cleanup');
	    // cleanup event handlers once the pipe is broken
	    dest.removeListener('close', onclose);
	    dest.removeListener('finish', onfinish);
	    dest.removeListener('drain', ondrain);
	    dest.removeListener('error', onerror);
	    dest.removeListener('unpipe', onunpipe);
	    src.removeListener('end', onend);
	    src.removeListener('end', unpipe);
	    src.removeListener('data', ondata);
	
	    cleanedUp = true;
	
	    // if the reader is waiting for a drain event from this
	    // specific writer, then it would cause it to never start
	    // flowing again.
	    // So, if this is awaiting a drain, then we just call it now.
	    // If we don't know, then assume that we are waiting for one.
	    if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
	  }
	
	  // If the user pushes more data while we're writing to dest then we'll end up
	  // in ondata again. However, we only want to increase awaitDrain once because
	  // dest will only emit one 'drain' event for the multiple writes.
	  // => Introduce a guard on increasing awaitDrain.
	  var increasedAwaitDrain = false;
	  src.on('data', ondata);
	  function ondata(chunk) {
	    debug('ondata');
	    increasedAwaitDrain = false;
	    var ret = dest.write(chunk);
	    if (false === ret && !increasedAwaitDrain) {
	      // If the user unpiped during `dest.write()`, it is possible
	      // to get stuck in a permanently paused state if that write
	      // also returned false.
	      // => Check whether `dest` is still a piping destination.
	      if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
	        debug('false write response, pause', src._readableState.awaitDrain);
	        src._readableState.awaitDrain++;
	        increasedAwaitDrain = true;
	      }
	      src.pause();
	    }
	  }
	
	  // if the dest has an error, then stop piping into it.
	  // however, don't suppress the throwing behavior for this.
	  function onerror(er) {
	    debug('onerror', er);
	    unpipe();
	    dest.removeListener('error', onerror);
	    if (EElistenerCount(dest, 'error') === 0) dest.emit('error', er);
	  }
	
	  // Make sure our error handler is attached before userland ones.
	  prependListener(dest, 'error', onerror);
	
	  // Both close and finish should trigger unpipe, but only once.
	  function onclose() {
	    dest.removeListener('finish', onfinish);
	    unpipe();
	  }
	  dest.once('close', onclose);
	  function onfinish() {
	    debug('onfinish');
	    dest.removeListener('close', onclose);
	    unpipe();
	  }
	  dest.once('finish', onfinish);
	
	  function unpipe() {
	    debug('unpipe');
	    src.unpipe(dest);
	  }
	
	  // tell the dest that it's being piped to
	  dest.emit('pipe', src);
	
	  // start the flow if it hasn't been started already.
	  if (!state.flowing) {
	    debug('pipe resume');
	    src.resume();
	  }
	
	  return dest;
	};
	
	function pipeOnDrain(src) {
	  return function () {
	    var state = src._readableState;
	    debug('pipeOnDrain', state.awaitDrain);
	    if (state.awaitDrain) state.awaitDrain--;
	    if (state.awaitDrain === 0 && EElistenerCount(src, 'data')) {
	      state.flowing = true;
	      flow(src);
	    }
	  };
	}
	
	Readable.prototype.unpipe = function (dest) {
	  var state = this._readableState;
	  var unpipeInfo = { hasUnpiped: false };
	
	  // if we're not piping anywhere, then do nothing.
	  if (state.pipesCount === 0) return this;
	
	  // just one destination.  most common case.
	  if (state.pipesCount === 1) {
	    // passed in one, but it's not the right one.
	    if (dest && dest !== state.pipes) return this;
	
	    if (!dest) dest = state.pipes;
	
	    // got a match.
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	    if (dest) dest.emit('unpipe', this, unpipeInfo);
	    return this;
	  }
	
	  // slow case. multiple pipe destinations.
	
	  if (!dest) {
	    // remove all.
	    var dests = state.pipes;
	    var len = state.pipesCount;
	    state.pipes = null;
	    state.pipesCount = 0;
	    state.flowing = false;
	
	    for (var i = 0; i < len; i++) {
	      dests[i].emit('unpipe', this, unpipeInfo);
	    }return this;
	  }
	
	  // try to find the right one.
	  var index = indexOf(state.pipes, dest);
	  if (index === -1) return this;
	
	  state.pipes.splice(index, 1);
	  state.pipesCount -= 1;
	  if (state.pipesCount === 1) state.pipes = state.pipes[0];
	
	  dest.emit('unpipe', this, unpipeInfo);
	
	  return this;
	};
	
	// set up data events if they are asked for
	// Ensure readable listeners eventually get something
	Readable.prototype.on = function (ev, fn) {
	  var res = Stream.prototype.on.call(this, ev, fn);
	
	  if (ev === 'data') {
	    // Start flowing on next tick if stream isn't explicitly paused
	    if (this._readableState.flowing !== false) this.resume();
	  } else if (ev === 'readable') {
	    var state = this._readableState;
	    if (!state.endEmitted && !state.readableListening) {
	      state.readableListening = state.needReadable = true;
	      state.emittedReadable = false;
	      if (!state.reading) {
	        processNextTick(nReadingNextTick, this);
	      } else if (state.length) {
	        emitReadable(this);
	      }
	    }
	  }
	
	  return res;
	};
	Readable.prototype.addListener = Readable.prototype.on;
	
	function nReadingNextTick(self) {
	  debug('readable nexttick read 0');
	  self.read(0);
	}
	
	// pause() and resume() are remnants of the legacy readable stream API
	// If the user uses them, then switch into old mode.
	Readable.prototype.resume = function () {
	  var state = this._readableState;
	  if (!state.flowing) {
	    debug('resume');
	    state.flowing = true;
	    resume(this, state);
	  }
	  return this;
	};
	
	function resume(stream, state) {
	  if (!state.resumeScheduled) {
	    state.resumeScheduled = true;
	    processNextTick(resume_, stream, state);
	  }
	}
	
	function resume_(stream, state) {
	  if (!state.reading) {
	    debug('resume read 0');
	    stream.read(0);
	  }
	
	  state.resumeScheduled = false;
	  state.awaitDrain = 0;
	  stream.emit('resume');
	  flow(stream);
	  if (state.flowing && !state.reading) stream.read(0);
	}
	
	Readable.prototype.pause = function () {
	  debug('call pause flowing=%j', this._readableState.flowing);
	  if (false !== this._readableState.flowing) {
	    debug('pause');
	    this._readableState.flowing = false;
	    this.emit('pause');
	  }
	  return this;
	};
	
	function flow(stream) {
	  var state = stream._readableState;
	  debug('flow', state.flowing);
	  while (state.flowing && stream.read() !== null) {}
	}
	
	// wrap an old-style stream as the async data source.
	// This is *not* part of the readable stream interface.
	// It is an ugly unfortunate mess of history.
	Readable.prototype.wrap = function (stream) {
	  var state = this._readableState;
	  var paused = false;
	
	  var self = this;
	  stream.on('end', function () {
	    debug('wrapped end');
	    if (state.decoder && !state.ended) {
	      var chunk = state.decoder.end();
	      if (chunk && chunk.length) self.push(chunk);
	    }
	
	    self.push(null);
	  });
	
	  stream.on('data', function (chunk) {
	    debug('wrapped data');
	    if (state.decoder) chunk = state.decoder.write(chunk);
	
	    // don't skip over falsy values in objectMode
	    if (state.objectMode && (chunk === null || chunk === undefined)) return;else if (!state.objectMode && (!chunk || !chunk.length)) return;
	
	    var ret = self.push(chunk);
	    if (!ret) {
	      paused = true;
	      stream.pause();
	    }
	  });
	
	  // proxy all the other methods.
	  // important when wrapping filters and duplexes.
	  for (var i in stream) {
	    if (this[i] === undefined && typeof stream[i] === 'function') {
	      this[i] = function (method) {
	        return function () {
	          return stream[method].apply(stream, arguments);
	        };
	      }(i);
	    }
	  }
	
	  // proxy certain important events.
	  for (var n = 0; n < kProxyEvents.length; n++) {
	    stream.on(kProxyEvents[n], self.emit.bind(self, kProxyEvents[n]));
	  }
	
	  // when we try to consume some more bytes, simply unpause the
	  // underlying stream.
	  self._read = function (n) {
	    debug('wrapped _read', n);
	    if (paused) {
	      paused = false;
	      stream.resume();
	    }
	  };
	
	  return self;
	};
	
	// exposed for testing purposes only.
	Readable._fromList = fromList;
	
	// Pluck off n bytes from an array of buffers.
	// Length is the combined lengths of all the buffers in the list.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromList(n, state) {
	  // nothing buffered
	  if (state.length === 0) return null;
	
	  var ret;
	  if (state.objectMode) ret = state.buffer.shift();else if (!n || n >= state.length) {
	    // read it all, truncate the list
	    if (state.decoder) ret = state.buffer.join('');else if (state.buffer.length === 1) ret = state.buffer.head.data;else ret = state.buffer.concat(state.length);
	    state.buffer.clear();
	  } else {
	    // read part of list
	    ret = fromListPartial(n, state.buffer, state.decoder);
	  }
	
	  return ret;
	}
	
	// Extracts only enough buffered data to satisfy the amount requested.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function fromListPartial(n, list, hasStrings) {
	  var ret;
	  if (n < list.head.data.length) {
	    // slice is the same for buffers and strings
	    ret = list.head.data.slice(0, n);
	    list.head.data = list.head.data.slice(n);
	  } else if (n === list.head.data.length) {
	    // first chunk is a perfect match
	    ret = list.shift();
	  } else {
	    // result spans more than one buffer
	    ret = hasStrings ? copyFromBufferString(n, list) : copyFromBuffer(n, list);
	  }
	  return ret;
	}
	
	// Copies a specified amount of characters from the list of buffered data
	// chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBufferString(n, list) {
	  var p = list.head;
	  var c = 1;
	  var ret = p.data;
	  n -= ret.length;
	  while (p = p.next) {
	    var str = p.data;
	    var nb = n > str.length ? str.length : n;
	    if (nb === str.length) ret += str;else ret += str.slice(0, n);
	    n -= nb;
	    if (n === 0) {
	      if (nb === str.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = str.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	// Copies a specified amount of bytes from the list of buffered data chunks.
	// This function is designed to be inlinable, so please take care when making
	// changes to the function body.
	function copyFromBuffer(n, list) {
	  var ret = Buffer.allocUnsafe(n);
	  var p = list.head;
	  var c = 1;
	  p.data.copy(ret);
	  n -= p.data.length;
	  while (p = p.next) {
	    var buf = p.data;
	    var nb = n > buf.length ? buf.length : n;
	    buf.copy(ret, ret.length - n, 0, nb);
	    n -= nb;
	    if (n === 0) {
	      if (nb === buf.length) {
	        ++c;
	        if (p.next) list.head = p.next;else list.head = list.tail = null;
	      } else {
	        list.head = p;
	        p.data = buf.slice(nb);
	      }
	      break;
	    }
	    ++c;
	  }
	  list.length -= c;
	  return ret;
	}
	
	function endReadable(stream) {
	  var state = stream._readableState;
	
	  // If we get here before consuming all the bytes, then that is a
	  // bug in node.  Should never happen.
	  if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
	
	  if (!state.endEmitted) {
	    state.ended = true;
	    processNextTick(endReadableNT, state, stream);
	  }
	}
	
	function endReadableNT(state, stream) {
	  // Check that we didn't get one last unshift.
	  if (!state.endEmitted && state.length === 0) {
	    state.endEmitted = true;
	    stream.readable = false;
	    stream.emit('end');
	  }
	}
	
	function forEach(xs, f) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    f(xs[i], i);
	  }
	}
	
	function indexOf(xs, x) {
	  for (var i = 0, l = xs.length; i < l; i++) {
	    if (xs[i] === x) return i;
	  }
	  return -1;
	}
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(65)))

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a transform stream is a readable/writable stream where you do
	// something with the data.  Sometimes it's called a "filter",
	// but that's not a great name for it, since that implies a thing where
	// some bits pass through, and others are simply ignored.  (That would
	// be a valid example of a transform, of course.)
	//
	// While the output is causally related to the input, it's not a
	// necessarily symmetric or synchronous transformation.  For example,
	// a zlib stream might take multiple plain-text writes(), and then
	// emit a single compressed chunk some time in the future.
	//
	// Here's how this works:
	//
	// The Transform stream has all the aspects of the readable and writable
	// stream classes.  When you write(chunk), that calls _write(chunk,cb)
	// internally, and returns false if there's a lot of pending writes
	// buffered up.  When you call read(), that calls _read(n) until
	// there's enough pending readable data buffered up.
	//
	// In a transform stream, the written data is placed in a buffer.  When
	// _read(n) is called, it transforms the queued up data, calling the
	// buffered _write cb's as it consumes chunks.  If consuming a single
	// written chunk would result in multiple output chunks, then the first
	// outputted bit calls the readcb, and subsequent chunks just go into
	// the read buffer, and will cause it to emit 'readable' if necessary.
	//
	// This way, back-pressure is actually determined by the reading side,
	// since _read has to be called to start processing a new chunk.  However,
	// a pathological inflate type of transform can cause excessive buffering
	// here.  For example, imagine a stream where every byte of input is
	// interpreted as an integer from 0-255, and then results in that many
	// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
	// 1kb of data being output.  In this case, you could write a very small
	// amount of input, and end up with a very large amount of output.  In
	// such a pathological inflating mechanism, there'd be no way to tell
	// the system to stop doing the transform.  A single 4MB write could
	// cause the system to run out of memory.
	//
	// However, even in such a pathological case, only a single written chunk
	// would be consumed, and then the rest would wait (un-transformed) until
	// the results of the previous transformed chunk were consumed.
	
	'use strict';
	
	module.exports = Transform;
	
	var Duplex = __webpack_require__(67);
	
	/*<replacement>*/
	var util = __webpack_require__(103);
	util.inherits = __webpack_require__(38);
	/*</replacement>*/
	
	util.inherits(Transform, Duplex);
	
	function TransformState(stream) {
	  this.afterTransform = function (er, data) {
	    return afterTransform(stream, er, data);
	  };
	
	  this.needTransform = false;
	  this.transforming = false;
	  this.writecb = null;
	  this.writechunk = null;
	  this.writeencoding = null;
	}
	
	function afterTransform(stream, er, data) {
	  var ts = stream._transformState;
	  ts.transforming = false;
	
	  var cb = ts.writecb;
	
	  if (!cb) {
	    return stream.emit('error', new Error('write callback called multiple times'));
	  }
	
	  ts.writechunk = null;
	  ts.writecb = null;
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  cb(er);
	
	  var rs = stream._readableState;
	  rs.reading = false;
	  if (rs.needReadable || rs.length < rs.highWaterMark) {
	    stream._read(rs.highWaterMark);
	  }
	}
	
	function Transform(options) {
	  if (!(this instanceof Transform)) return new Transform(options);
	
	  Duplex.call(this, options);
	
	  this._transformState = new TransformState(this);
	
	  var stream = this;
	
	  // start out asking for a readable event once data is transformed.
	  this._readableState.needReadable = true;
	
	  // we have implemented the _read method, and done the other things
	  // that Readable wants before the first _read call, so unset the
	  // sync guard flag.
	  this._readableState.sync = false;
	
	  if (options) {
	    if (typeof options.transform === 'function') this._transform = options.transform;
	
	    if (typeof options.flush === 'function') this._flush = options.flush;
	  }
	
	  // When the writable side finishes, then flush out anything remaining.
	  this.once('prefinish', function () {
	    if (typeof this._flush === 'function') this._flush(function (er, data) {
	      done(stream, er, data);
	    });else done(stream);
	  });
	}
	
	Transform.prototype.push = function (chunk, encoding) {
	  this._transformState.needTransform = false;
	  return Duplex.prototype.push.call(this, chunk, encoding);
	};
	
	// This is the part where you do stuff!
	// override this function in implementation classes.
	// 'chunk' is an input chunk.
	//
	// Call `push(newChunk)` to pass along transformed output
	// to the readable side.  You may call 'push' zero or more times.
	//
	// Call `cb(err)` when you are done with this chunk.  If you pass
	// an error, then that'll put the hurt on the whole operation.  If you
	// never call cb(), then you'll never get another chunk.
	Transform.prototype._transform = function (chunk, encoding, cb) {
	  throw new Error('_transform() is not implemented');
	};
	
	Transform.prototype._write = function (chunk, encoding, cb) {
	  var ts = this._transformState;
	  ts.writecb = cb;
	  ts.writechunk = chunk;
	  ts.writeencoding = encoding;
	  if (!ts.transforming) {
	    var rs = this._readableState;
	    if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
	  }
	};
	
	// Doesn't matter what the args are here.
	// _transform does all the work.
	// That we got here means that the readable side wants more data.
	Transform.prototype._read = function (n) {
	  var ts = this._transformState;
	
	  if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
	    ts.transforming = true;
	    this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
	  } else {
	    // mark that we need a transform, so that any data that comes in
	    // will get processed, now that we've asked for it.
	    ts.needTransform = true;
	  }
	};
	
	Transform.prototype._destroy = function (err, cb) {
	  var _this = this;
	
	  Duplex.prototype._destroy.call(this, err, function (err2) {
	    cb(err2);
	    _this.emit('close');
	  });
	};
	
	function done(stream, er, data) {
	  if (er) return stream.emit('error', er);
	
	  if (data !== null && data !== undefined) stream.push(data);
	
	  // if there's nothing in the write buffer, then that means
	  // that nothing more will ever be provided
	  var ws = stream._writableState;
	  var ts = stream._transformState;
	
	  if (ws.length) throw new Error('Calling transform done when ws.length != 0');
	
	  if (ts.transforming) throw new Error('Calling transform done when still transforming');
	
	  return stream.push(null);
	}

/***/ },
/* 430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	var processNextTick = __webpack_require__(153);
	/*</replacement>*/
	
	// undocumented cb() API, needed for core, not for public API
	function destroy(err, cb) {
	  var _this = this;
	
	  var readableDestroyed = this._readableState && this._readableState.destroyed;
	  var writableDestroyed = this._writableState && this._writableState.destroyed;
	
	  if (readableDestroyed || writableDestroyed) {
	    if (cb) {
	      cb(err);
	    } else if (err && (!this._writableState || !this._writableState.errorEmitted)) {
	      processNextTick(emitErrorNT, this, err);
	    }
	    return;
	  }
	
	  // we set destroyed to true before firing error callbacks in order
	  // to make it re-entrance safe in case destroy() is called within callbacks
	
	  if (this._readableState) {
	    this._readableState.destroyed = true;
	  }
	
	  // if this is a duplex stream mark the writable part as destroyed as well
	  if (this._writableState) {
	    this._writableState.destroyed = true;
	  }
	
	  this._destroy(err || null, function (err) {
	    if (!cb && err) {
	      processNextTick(emitErrorNT, _this, err);
	      if (_this._writableState) {
	        _this._writableState.errorEmitted = true;
	      }
	    } else if (cb) {
	      cb(err);
	    }
	  });
	}
	
	function undestroy() {
	  if (this._readableState) {
	    this._readableState.destroyed = false;
	    this._readableState.reading = false;
	    this._readableState.ended = false;
	    this._readableState.endEmitted = false;
	  }
	
	  if (this._writableState) {
	    this._writableState.destroyed = false;
	    this._writableState.ended = false;
	    this._writableState.ending = false;
	    this._writableState.finished = false;
	    this._writableState.errorEmitted = false;
	  }
	}
	
	function emitErrorNT(self, err) {
	  self.emit('error', err);
	}
	
	module.exports = {
	  destroy: destroy,
	  undestroy: undestroy
	};

/***/ },
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(129).EventEmitter;


/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _setStatic = __webpack_require__(1980);
	
	var _setStatic2 = _interopRequireDefault(_setStatic);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var setDisplayName = function setDisplayName(displayName) {
	  return (0, _setStatic2.default)('displayName', displayName);
	};
	
	exports.default = setDisplayName;

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _getDisplayName = __webpack_require__(1977);
	
	var _getDisplayName2 = _interopRequireDefault(_getDisplayName);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var wrapDisplayName = function wrapDisplayName(BaseComponent, hocName) {
	  return hocName + '(' + (0, _getDisplayName2.default)(BaseComponent) + ')';
	};
	
	exports.default = wrapDisplayName;

/***/ },
/* 434 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var ActionTypes = exports.ActionTypes = {
	  UNDO: '@@redux-undo/UNDO',
	  REDO: '@@redux-undo/REDO',
	  JUMP_TO_FUTURE: '@@redux-undo/JUMP_TO_FUTURE',
	  JUMP_TO_PAST: '@@redux-undo/JUMP_TO_PAST',
	  JUMP: '@@redux-undo/JUMP',
	  CLEAR_HISTORY: '@@redux-undo/CLEAR_HISTORY'
	};
	
	var ActionCreators = exports.ActionCreators = {
	  undo: function undo() {
	    return { type: ActionTypes.UNDO };
	  },
	  redo: function redo() {
	    return { type: ActionTypes.REDO };
	  },
	  jumpToFuture: function jumpToFuture(index) {
	    return { type: ActionTypes.JUMP_TO_FUTURE, index: index };
	  },
	  jumpToPast: function jumpToPast(index) {
	    return { type: ActionTypes.JUMP_TO_PAST, index: index };
	  },
	  jump: function jump(index) {
	    return { type: ActionTypes.JUMP, index: index };
	  },
	  clearHistory: function clearHistory() {
	    return { type: ActionTypes.CLEAR_HISTORY };
	  }
	};

/***/ },
/* 435 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseActions = parseActions;
	exports.isHistory = isHistory;
	exports.distinctState = distinctState;
	exports.includeAction = includeAction;
	exports.excludeAction = excludeAction;
	exports.combineFilters = combineFilters;
	exports.groupByActionTypes = groupByActionTypes;
	exports.newHistory = newHistory;
	// parseActions helper: takes a string (or array)
	//                      and makes it an array if it isn't yet
	function parseActions(rawActions) {
	  var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
	
	  if (Array.isArray(rawActions)) {
	    return rawActions;
	  } else if (typeof rawActions === 'string') {
	    return [rawActions];
	  }
	  return defaultValue;
	}
	
	// isHistory helper: check for a valid history object
	function isHistory(history) {
	  return typeof history.present !== 'undefined' && typeof history.future !== 'undefined' && typeof history.past !== 'undefined' && Array.isArray(history.future) && Array.isArray(history.past);
	}
	
	// distinctState helper: deprecated, does nothing in latest beta
	/* istanbul ignore next */
	function distinctState() {
	  console.warn('distinctState is deprecated in beta4 and newer. ' + 'The distinctState behavior is now default, which means only ' + 'actions resulting in a new state are recorded. ' + 'See https://github.com/omnidan/redux-undo#filtering-actions ' + 'for more details.');
	  return function () {
	    return true;
	  };
	}
	
	// includeAction helper: whitelist actions to be added to the history
	function includeAction(rawActions) {
	  var actions = parseActions(rawActions);
	  return function (action) {
	    return actions.indexOf(action.type) >= 0;
	  };
	}
	
	// excludeAction helper: blacklist actions from being added to the history
	function excludeAction(rawActions) {
	  var actions = parseActions(rawActions);
	  return function (action) {
	    return actions.indexOf(action.type) < 0;
	  };
	}
	
	// combineFilters helper: combine multiple filters to one
	function combineFilters() {
	  for (var _len = arguments.length, filters = Array(_len), _key = 0; _key < _len; _key++) {
	    filters[_key] = arguments[_key];
	  }
	
	  return filters.reduce(function (prev, curr) {
	    return function (action, currentState, previousHistory) {
	      return prev(action, currentState, previousHistory) && curr(action, currentState, previousHistory);
	    };
	  }, function () {
	    return true;
	  });
	}
	
	function groupByActionTypes(rawActions) {
	  var actions = parseActions(rawActions);
	  return function (action) {
	    return actions.indexOf(action.type) >= 0 ? action.type : null;
	  };
	}
	
	function newHistory(past, present, future) {
	  var group = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  return {
	    past: past,
	    present: present,
	    future: future,
	    group: group,
	    _latestUnfiltered: present,
	    index: past.length,
	    limit: past.length + future.length + 1
	  };
	}

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _actions = __webpack_require__(434);
	
	Object.defineProperty(exports, 'ActionTypes', {
	  enumerable: true,
	  get: function get() {
	    return _actions.ActionTypes;
	  }
	});
	Object.defineProperty(exports, 'ActionCreators', {
	  enumerable: true,
	  get: function get() {
	    return _actions.ActionCreators;
	  }
	});
	
	var _helpers = __webpack_require__(435);
	
	Object.defineProperty(exports, 'parseActions', {
	  enumerable: true,
	  get: function get() {
	    return _helpers.parseActions;
	  }
	});
	Object.defineProperty(exports, 'isHistory', {
	  enumerable: true,
	  get: function get() {
	    return _helpers.isHistory;
	  }
	});
	Object.defineProperty(exports, 'distinctState', {
	  enumerable: true,
	  get: function get() {
	    return _helpers.distinctState;
	  }
	});
	Object.defineProperty(exports, 'includeAction', {
	  enumerable: true,
	  get: function get() {
	    return _helpers.includeAction;
	  }
	});
	Object.defineProperty(exports, 'excludeAction', {
	  enumerable: true,
	  get: function get() {
	    return _helpers.excludeAction;
	  }
	});
	Object.defineProperty(exports, 'combineFilters', {
	  enumerable: true,
	  get: function get() {
	    return _helpers.combineFilters;
	  }
	});
	Object.defineProperty(exports, 'groupByActionTypes', {
	  enumerable: true,
	  get: function get() {
	    return _helpers.groupByActionTypes;
	  }
	});
	Object.defineProperty(exports, 'newHistory', {
	  enumerable: true,
	  get: function get() {
	    return _helpers.newHistory;
	  }
	});
	
	var _reducer = __webpack_require__(1985);
	
	Object.defineProperty(exports, 'default', {
	  enumerable: true,
	  get: function get() {
	    return _interopRequireDefault(_reducer).default;
	  }
	});
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 437 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports["default"] = compose;
	/**
	 * Composes single-argument functions from right to left. The rightmost
	 * function can take multiple arguments as it provides the signature for
	 * the resulting composite function.
	 *
	 * @param {...Function} funcs The functions to compose.
	 * @returns {Function} A function obtained by composing the argument functions
	 * from right to left. For example, compose(f, g, h) is identical to doing
	 * (...args) => f(g(h(...args))).
	 */
	
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.ActionTypes = undefined;
	exports['default'] = createStore;
	
	var _isPlainObject = __webpack_require__(112);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _symbolObservable = __webpack_require__(2001);
	
	var _symbolObservable2 = _interopRequireDefault(_symbolObservable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * These are private action types reserved by Redux.
	 * For any unknown actions, you must return the current state.
	 * If the current state is undefined, you must return the initial state.
	 * Do not reference these action types directly in your code.
	 */
	var ActionTypes = exports.ActionTypes = {
	  INIT: '@@redux/INIT'
	
	  /**
	   * Creates a Redux store that holds the state tree.
	   * The only way to change the data in the store is to call `dispatch()` on it.
	   *
	   * There should only be a single store in your app. To specify how different
	   * parts of the state tree respond to actions, you may combine several reducers
	   * into a single reducer function by using `combineReducers`.
	   *
	   * @param {Function} reducer A function that returns the next state tree, given
	   * the current state tree and the action to handle.
	   *
	   * @param {any} [preloadedState] The initial state. You may optionally specify it
	   * to hydrate the state from the server in universal apps, or to restore a
	   * previously serialized user session.
	   * If you use `combineReducers` to produce the root reducer function, this must be
	   * an object with the same shape as `combineReducers` keys.
	   *
	   * @param {Function} [enhancer] The store enhancer. You may optionally specify it
	   * to enhance the store with third-party capabilities such as middleware,
	   * time travel, persistence, etc. The only store enhancer that ships with Redux
	   * is `applyMiddleware()`.
	   *
	   * @returns {Store} A Redux store that lets you read the state, dispatch actions
	   * and subscribe to changes.
	   */
	};function createStore(reducer, preloadedState, enhancer) {
	  var _ref2;
	
	  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
	    enhancer = preloadedState;
	    preloadedState = undefined;
	  }
	
	  if (typeof enhancer !== 'undefined') {
	    if (typeof enhancer !== 'function') {
	      throw new Error('Expected the enhancer to be a function.');
	    }
	
	    return enhancer(createStore)(reducer, preloadedState);
	  }
	
	  if (typeof reducer !== 'function') {
	    throw new Error('Expected the reducer to be a function.');
	  }
	
	  var currentReducer = reducer;
	  var currentState = preloadedState;
	  var currentListeners = [];
	  var nextListeners = currentListeners;
	  var isDispatching = false;
	
	  function ensureCanMutateNextListeners() {
	    if (nextListeners === currentListeners) {
	      nextListeners = currentListeners.slice();
	    }
	  }
	
	  /**
	   * Reads the state tree managed by the store.
	   *
	   * @returns {any} The current state tree of your application.
	   */
	  function getState() {
	    return currentState;
	  }
	
	  /**
	   * Adds a change listener. It will be called any time an action is dispatched,
	   * and some part of the state tree may potentially have changed. You may then
	   * call `getState()` to read the current state tree inside the callback.
	   *
	   * You may call `dispatch()` from a change listener, with the following
	   * caveats:
	   *
	   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
	   * If you subscribe or unsubscribe while the listeners are being invoked, this
	   * will not have any effect on the `dispatch()` that is currently in progress.
	   * However, the next `dispatch()` call, whether nested or not, will use a more
	   * recent snapshot of the subscription list.
	   *
	   * 2. The listener should not expect to see all state changes, as the state
	   * might have been updated multiple times during a nested `dispatch()` before
	   * the listener is called. It is, however, guaranteed that all subscribers
	   * registered before the `dispatch()` started will be called with the latest
	   * state by the time it exits.
	   *
	   * @param {Function} listener A callback to be invoked on every dispatch.
	   * @returns {Function} A function to remove this change listener.
	   */
	  function subscribe(listener) {
	    if (typeof listener !== 'function') {
	      throw new Error('Expected listener to be a function.');
	    }
	
	    var isSubscribed = true;
	
	    ensureCanMutateNextListeners();
	    nextListeners.push(listener);
	
	    return function unsubscribe() {
	      if (!isSubscribed) {
	        return;
	      }
	
	      isSubscribed = false;
	
	      ensureCanMutateNextListeners();
	      var index = nextListeners.indexOf(listener);
	      nextListeners.splice(index, 1);
	    };
	  }
	
	  /**
	   * Dispatches an action. It is the only way to trigger a state change.
	   *
	   * The `reducer` function, used to create the store, will be called with the
	   * current state tree and the given `action`. Its return value will
	   * be considered the **next** state of the tree, and the change listeners
	   * will be notified.
	   *
	   * The base implementation only supports plain object actions. If you want to
	   * dispatch a Promise, an Observable, a thunk, or something else, you need to
	   * wrap your store creating function into the corresponding middleware. For
	   * example, see the documentation for the `redux-thunk` package. Even the
	   * middleware will eventually dispatch plain object actions using this method.
	   *
	   * @param {Object} action A plain object representing “what changed”. It is
	   * a good idea to keep actions serializable so you can record and replay user
	   * sessions, or use the time travelling `redux-devtools`. An action must have
	   * a `type` property which may not be `undefined`. It is a good idea to use
	   * string constants for action types.
	   *
	   * @returns {Object} For convenience, the same action object you dispatched.
	   *
	   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
	   * return something else (for example, a Promise you can await).
	   */
	  function dispatch(action) {
	    if (!(0, _isPlainObject2['default'])(action)) {
	      throw new Error('Actions must be plain objects. ' + 'Use custom middleware for async actions.');
	    }
	
	    if (typeof action.type === 'undefined') {
	      throw new Error('Actions may not have an undefined "type" property. ' + 'Have you misspelled a constant?');
	    }
	
	    if (isDispatching) {
	      throw new Error('Reducers may not dispatch actions.');
	    }
	
	    try {
	      isDispatching = true;
	      currentState = currentReducer(currentState, action);
	    } finally {
	      isDispatching = false;
	    }
	
	    var listeners = currentListeners = nextListeners;
	    for (var i = 0; i < listeners.length; i++) {
	      var listener = listeners[i];
	      listener();
	    }
	
	    return action;
	  }
	
	  /**
	   * Replaces the reducer currently used by the store to calculate the state.
	   *
	   * You might need this if your app implements code splitting and you want to
	   * load some of the reducers dynamically. You might also need this if you
	   * implement a hot reloading mechanism for Redux.
	   *
	   * @param {Function} nextReducer The reducer for the store to use instead.
	   * @returns {void}
	   */
	  function replaceReducer(nextReducer) {
	    if (typeof nextReducer !== 'function') {
	      throw new Error('Expected the nextReducer to be a function.');
	    }
	
	    currentReducer = nextReducer;
	    dispatch({ type: ActionTypes.INIT });
	  }
	
	  /**
	   * Interoperability point for observable/reactive libraries.
	   * @returns {observable} A minimal observable of state changes.
	   * For more information, see the observable proposal:
	   * https://github.com/tc39/proposal-observable
	   */
	  function observable() {
	    var _ref;
	
	    var outerSubscribe = subscribe;
	    return _ref = {
	      /**
	       * The minimal observable subscription method.
	       * @param {Object} observer Any object that can be used as an observer.
	       * The observer object should have a `next` method.
	       * @returns {subscription} An object with an `unsubscribe` method that can
	       * be used to unsubscribe the observable from the store, and prevent further
	       * emission of values from the observable.
	       */
	      subscribe: function subscribe(observer) {
	        if (typeof observer !== 'object') {
	          throw new TypeError('Expected the observer to be an object.');
	        }
	
	        function observeState() {
	          if (observer.next) {
	            observer.next(getState());
	          }
	        }
	
	        observeState();
	        var unsubscribe = outerSubscribe(observeState);
	        return { unsubscribe: unsubscribe };
	      }
	    }, _ref[_symbolObservable2['default']] = function () {
	      return this;
	    }, _ref;
	  }
	
	  // When a store is created, an "INIT" action is dispatched so that every
	  // reducer returns their initial state. This effectively populates
	  // the initial state tree.
	  dispatch({ type: ActionTypes.INIT });
	
	  return _ref2 = {
	    dispatch: dispatch,
	    subscribe: subscribe,
	    getState: getState,
	    replaceReducer: replaceReducer
	  }, _ref2[_symbolObservable2['default']] = observable, _ref2;
	}

/***/ },
/* 439 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = warning;
	/**
	 * Prints a warning in the console if it exists.
	 *
	 * @param {String} message The warning message.
	 * @returns {void}
	 */
	function warning(message) {
	  /* eslint-disable no-console */
	  if (typeof console !== 'undefined' && typeof console.error === 'function') {
	    console.error(message);
	  }
	  /* eslint-enable no-console */
	  try {
	    // This error was thrown as a convenience so that if you enable
	    // "break on all exceptions" in your console,
	    // it would pause the execution at this line.
	    throw new Error(message);
	    /* eslint-disable no-empty */
	  } catch (e) {}
	  /* eslint-enable no-empty */
	}

/***/ },
/* 440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var randomByte = __webpack_require__(1996);
	
	function encode(lookup, number) {
	    var loopCounter = 0;
	    var done;
	
	    var str = '';
	
	    while (!done) {
	        str = str + lookup( ( (number >> (4 * loopCounter)) & 0x0f ) | randomByte() );
	        done = number < (Math.pow(16, loopCounter + 1 ) );
	        loopCounter++;
	    }
	    return str;
	}
	
	module.exports = encode;


/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, window, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, window, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(window, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(1990);
	exports.setImmediate = setImmediate;
	exports.clearImmediate = clearImmediate;


/***/ },
/* 442 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(565);
	
	var _reactRouterDom = __webpack_require__(420);
	
	var _reactTapEventPlugin = __webpack_require__(1954);
	
	var _reactTapEventPlugin2 = _interopRequireDefault(_reactTapEventPlugin);
	
	var _Homepage = __webpack_require__(478);
	
	var _Homepage2 = _interopRequireDefault(_Homepage);
	
	var _Editor = __webpack_require__(470);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	var _redux = __webpack_require__(121);
	
	var _reduxDevtoolsExtension = __webpack_require__(1983);
	
	var _reactRedux = __webpack_require__(26);
	
	var _state = __webpack_require__(486);
	
	var _materialUi = __webpack_require__(34);
	
	var _LeftNav = __webpack_require__(480);
	
	var _LeftNav2 = _interopRequireDefault(_LeftNav);
	
	var _index = __webpack_require__(151);
	
	var _colors = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Provides the basic app state and routing
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var store = (0, _redux.createStore)(_state.reduxStore, (0, _reduxDevtoolsExtension.devToolsEnhancer)());
	(0, _reactTapEventPlugin2.default)();
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App(props) {
	    _classCallCheck(this, App);
	
	    var _this = _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).call(this, props));
	
	    console.log(({"NODE_ENV":"production","PUBLIC_URL":""}));
	    _this.state = {
	      navigationVisible: false,
	      navigationPinned: false,
	      appTitle: "Homepage"
	    };
	
	    _this.handleNavigationVisibility = _this.handleNavigationVisibility.bind(_this);
	    _this.handleToggleNavigation = _this.handleToggleNavigation.bind(_this);
	    return _this;
	  }
	
	  _createClass(App, [{
	    key: 'handleNavigationVisibility',
	    value: function handleNavigationVisibility(show) {
	      this.setState({ navigationVisible: show });
	    }
	  }, {
	    key: 'handleToggleNavigation',
	    value: function handleToggleNavigation() {
	      this.setState({ navigationVisible: !this.state.navigationVisible });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _reactRedux.Provider,
	        { store: store },
	        _react2.default.createElement(
	          _reactRouterDom.BrowserRouter,
	          null,
	          _react2.default.createElement(
	            _materialUi.MuiThemeProvider,
	            null,
	            _react2.default.createElement(
	              'div',
	              null,
	              _react2.default.createElement(_materialUi.AppBar, {
	                iconElementLeft: _react2.default.createElement(
	                  _materialUi.IconButton,
	                  { onTouchTap: this.handleToggleNavigation },
	                  _react2.default.createElement(_index.NavigationMenu, null)
	                )
	                // title={this.state.appTitle}
	                , style: {
	                  position: "fixed",
	                  top: 0,
	                  boxShadow: "none",
	                  backgroundColor: _colors.blue500
	                }
	              }),
	              _react2.default.createElement(_LeftNav2.default, {
	                pinned: this.state.navigationPinned,
	                open: this.state.navigationVisible,
	                handleChange: this.handleNavigationVisibility
	              }),
	              _react2.default.createElement(
	                'div',
	                {
	                  style: {
	                    height: "calc(100vh - 64px)",
	                    width: this.state.navigationPinned && this.state.navigationVisible ? "calc(100vw - 256px)" : "100vw",
	                    top: "64px",
	                    position: "fixed",
	                    transform: this.state.navigationPinned && this.state.navigationVisible ? "translate(256px, 0px)" : "translate(0px, 0px)",
	                    transition: "width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, transform 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms"
	                  }
	                },
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', render: function render(match) {
	                    return _react2.default.createElement(_Homepage2.default, { route: match, toggleNavigation: _this2.handleToggleNavigation });
	                  } }),
	                _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/editor', render: function render(match) {
	                    return _react2.default.createElement(_Editor2.default, { route: match, toggleNavigation: _this2.handleToggleNavigation });
	                  } }),
	                _react2.default.createElement(_reactRouterDom.Route, { path: '/editor/:mode/:type/:id', render: function render(match) {
	                    return _react2.default.createElement(_Editor2.default, { route: match, toggleNavigation: _this2.handleToggleNavigation });
	                  } })
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _CanvasContainer = __webpack_require__(455);
	
	var _CanvasContainer2 = _interopRequireDefault(_CanvasContainer);
	
	var _reactRedux = __webpack_require__(26);
	
	var _actions = __webpack_require__(56);
	
	var _ToolBoxContainer = __webpack_require__(469);
	
	var _ToolBoxContainer2 = _interopRequireDefault(_ToolBoxContainer);
	
	var _selectors = __webpack_require__(57);
	
	__webpack_require__(566);
	
	var _materialUi = __webpack_require__(34);
	
	var _reduxUndo = __webpack_require__(436);
	
	var _ExportDialogContainer = __webpack_require__(461);
	
	var _ExportDialogContainer2 = _interopRequireDefault(_ExportDialogContainer);
	
	var _actions2 = __webpack_require__(54);
	
	var _selectors2 = __webpack_require__(122);
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _selectors3 = __webpack_require__(489);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 11/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Editor = function (_Component) {
	  _inherits(Editor, _Component);
	
	  function Editor(props) {
	    _classCallCheck(this, Editor);
	
	    var _this = _possibleConstructorReturn(this, (Editor.__proto__ || Object.getPrototypeOf(Editor)).call(this, props));
	
	    _this.state = { exportDialogOpen: false };
	    console.log("editor-created");
	
	    _this.handleOnClick = _this.handleOnClick.bind(_this);
	    _this.handleDragOver = _this.handleDragOver.bind(_this);
	    _this.handleExportDialogVisibility = _this.handleExportDialogVisibility.bind(_this);
	    _this.componentDidMount = _this.componentDidMount.bind(_this);
	    return _this;
	  }
	
	  _createClass(Editor, [{
	    key: 'handleOnClick',
	    value: function handleOnClick(e) {
	      e.preventDefault();
	      e.stopPropagation();
	      this.props.selectedItem && this.props.clearSelectedItem();
	    }
	  }, {
	    key: 'handleDragOver',
	    value: function handleDragOver(e) {
	      if (this.props.dropzoneCoords) this.props.clearDropzoneCoords();
	      e.stopPropagation();
	    }
	  }, {
	    key: 'handleExportDialogVisibility',
	    value: function handleExportDialogVisibility(visible) {
	      this.setState({ exportDialogOpen: visible });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      console.log("editor-mounted");
	
	      // Work out which template to set the state to, if any
	      var routeParams = this.props.route.match.params;
	      if (_.isEmpty(routeParams)) {
	        // Create an empty element
	        this.props.dispatch((0, _actions2.setContentItems)([]));
	        this.props.dispatch((0, _actions2.createContentItem)(null, null, "ROOT_ITEM", (0, _selectors2.getContentDefinitions)(this.props.state)));
	      } else {
	        // Load the appropriate template
	        var template = _.head((0, _selectors3.getTemplateItems)(this.props.state, { templateId: routeParams.id }));
	        this.props.dispatch((0, _actions2.setContentItems)(template.templateContent));
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        'div',
	        { id: 'editor-container',
	          onClick: this.handleOnClick,
	          onDragOver: this.handleDragOver,
	          style: {
	            height: "calc(100% - 56px)",
	            width: this.props.toolboxPinned && this.props.toolBoxVisible ? "calc(100% - 600px" : "100%",
	            //transition: "width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
	            overflowY: "scroll",
	            paddingTop: "56px",
	            position: "relative"
	          } },
	        _react2.default.createElement(_ToolBoxContainer2.default, null),
	        _react2.default.createElement(
	          _materialUi.Toolbar,
	          { style: {
	              position: "fixed",
	              top: 0,
	              width: this.props.toolboxPinned && this.props.toolBoxVisible ? "calc(100% - 600px" : "100%",
	              transition: "width 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms",
	              zIndex: 1000
	            } },
	          _react2.default.createElement(
	            _materialUi.ToolbarGroup,
	            { firstChild: true },
	            _react2.default.createElement(
	              _materialUi.IconButton,
	              { tooltip: 'Undo', iconClassName: 'material-icons', disabled: !this.props.canUndo, onTouchTap: this.props.onUndo },
	              'undo'
	            ),
	            _react2.default.createElement(
	              _materialUi.IconButton,
	              { tooltip: 'Redo', iconClassName: 'material-icons', disabled: !this.props.canRedo, onTouchTap: this.props.onRedo },
	              'redo'
	            ),
	            _react2.default.createElement(_materialUi.ToolbarSeparator, null),
	            _react2.default.createElement(
	              _materialUi.IconButton,
	              { tooltip: 'Export Data', iconClassName: 'material-icons', onTouchTap: function onTouchTap() {
	                  return _this2.handleExportDialogVisibility(true);
	                } },
	              'file_download'
	            )
	          ),
	          _react2.default.createElement(_materialUi.ToolbarGroup, {
	            style: {
	              width: "500px",
	              position: "absolute",
	              left: "calc(50% - 260px)"
	            }
	          }),
	          _react2.default.createElement(
	            _materialUi.ToolbarGroup,
	            { lastChild: true },
	            _react2.default.createElement(
	              _materialUi.IconButton,
	              {
	                tooltip: this.props.toolBoxVisible ? "Close Toolbox" : "Open Toolbox",
	                iconClassName: 'material-icons',
	                iconStyle: {
	                  transform: this.props.toolBoxVisible ? "rotate(180deg)" : ""
	                },
	                onTouchTap: this.props.toolBoxVisible ? this.props.closeToolbox : this.props.openToolbox },
	              'chevron_left'
	            )
	          )
	        ),
	        _react2.default.createElement(_CanvasContainer2.default, null),
	        _react2.default.createElement(_ExportDialogContainer2.default, {
	          open: this.state.exportDialogOpen,
	          handleVisibility: this.handleExportDialogVisibility
	        })
	      );
	    }
	  }]);
	
	  return Editor;
	}(_react.Component);
	
	function mapStateToProps(state, ownProps) {
	  return {
	    canUndo: state.editor.content.past.length > 0,
	    canRedo: state.editor.content.future.length > 0,
	    toolBoxVisible: (0, _selectors.getUiToolboxVisibility)(state),
	    toolboxPinned: (0, _selectors.getUiToolboxPinned)(state),
	    selectedItem: (0, _selectors.getUiSelectedItem)(state),
	    dropzoneCoords: (0, _selectors.getUiDropzoneCoords)(state),
	    state: state,
	    ownProps: ownProps
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    onUndo: function onUndo() {
	      return dispatch(_reduxUndo.ActionCreators.undo());
	    },
	    onRedo: function onRedo() {
	      return dispatch(_reduxUndo.ActionCreators.redo());
	    },
	    clearSelectedItem: function clearSelectedItem() {
	      return dispatch((0, _actions.setUiSelectedContentItem)(null));
	    },
	    clearDropzoneCoords: function clearDropzoneCoords() {
	      return dispatch((0, _actions.setUiDropzoneCoords)(null));
	    },
	    openToolbox: function openToolbox() {
	      return dispatch((0, _actions.setUiToolboxVisibility)(true));
	    },
	    closeToolbox: function closeToolbox() {
	      return dispatch((0, _actions.setUiToolboxVisibility)(false));
	    },
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(Editor);

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleItem = __webpack_require__(46);
	
	var _StyleItem2 = _interopRequireDefault(_StyleItem);
	
	var _DropZone = __webpack_require__(96);
	
	var _DropZone2 = _interopRequireDefault(_DropZone);
	
	var _object = __webpack_require__(113);
	
	var _ = _interopRequireWildcard(_object);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 17/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Acts as a host for user-defined content. Manages editor lifecycle.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Can only be placed in RowItem components.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var CellItem = function (_Component) {
	  _inherits(CellItem, _Component);
	
	  function CellItem() {
	    _classCallCheck(this, CellItem);
	
	    return _possibleConstructorReturn(this, (CellItem.__proto__ || Object.getPrototypeOf(CellItem)).apply(this, arguments));
	  }
	
	  _createClass(CellItem, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "td",
	        Object.assign({
	          id: this.props.contentId,
	          className: [this.props.contentId, this.props.viewClass].join(" ").trim(),
	          ref: function ref(node) {
	            _.toPairs(_this2.props.viewAttributes).map(function (item) {
	              return node && node.setAttribute(item[0], item[1]);
	            });
	          }
	        }, this.props.eventHandlers, {
	          style: {
	            width: this.props.styleWidth,
	            height: this.props.styleHeight,
	            padding: this.props.stylePadding,
	            backgroundColor: this.props.styleBackgroundColour,
	            color: this.props.styleTextColour,
	            textAlign: this.props.styleTextAlignment
	          }
	        }),
	        _react2.default.createElement(_StyleItem2.default, { selectorPrefix: this.props.contentId + " ", styleObject: this.props.viewCss }),
	        this.props.children.length > 0 ? this.props.children : _react2.default.createElement(_DropZone2.default, { text: this.props.configName })
	      );
	    }
	  }]);
	
	  return CellItem;
	}(_react.Component);
	
	exports.default = CellItem;

/***/ },
/* 446 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleItem = __webpack_require__(46);
	
	var _StyleItem2 = _interopRequireDefault(_StyleItem);
	
	var _DropZone = __webpack_require__(96);
	
	var _DropZone2 = _interopRequireDefault(_DropZone);
	
	var _object = __webpack_require__(113);
	
	var _ = _interopRequireWildcard(_object);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 17/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Acts as a host for user-defined content. Manages editor lifecycle.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Can only be placed in RowItem components.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Column = function (_Component) {
	  _inherits(Column, _Component);
	
	  function Column() {
	    _classCallCheck(this, Column);
	
	    return _possibleConstructorReturn(this, (Column.__proto__ || Object.getPrototypeOf(Column)).apply(this, arguments));
	  }
	
	  _createClass(Column, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "td",
	        Object.assign({
	          id: this.props.contentId,
	          className: [this.props.contentId, this.props.viewClass].join(" ").trim(),
	          ref: function ref(node) {
	            _.toPairs(_this2.props.viewAttributes).map(function (item) {
	              return node && node.setAttribute(item[0], item[1]);
	            });
	          }
	        }, this.props.eventHandlers, {
	          style: {
	            width: this.props.styleWidth,
	            height: this.props.styleHeight,
	            backgroundColor: this.props.styleBackgroundColour,
	            color: this.props.styleTextColour,
	            textAlign: this.props.styleTextAlignment
	          }
	        }),
	        _react2.default.createElement(_StyleItem2.default, { selectorPrefix: this.props.contentId + " ", styleObject: this.props.viewCss }),
	        _react2.default.createElement(
	          "table",
	          {
	            ref: function ref(node) {
	              var attrs = {
	                border: 0,
	                cellpadding: 0,
	                cellspacing: 0
	              };
	              _.toPairs(attrs).map(function (item) {
	                return node && node.setAttribute(item[0], item[1]);
	              });
	            },
	            style: {
	              width: "100%",
	              height: this.props.styleHeight,
	              backgroundColor: this.props.styleBackgroundColour,
	              color: this.props.styleTextColour,
	              textAlign: this.props.styleTextAlignment
	            }
	          },
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              {
	                ref: function ref(node) {
	                  var attrs = {
	                    align: "center",
	                    valign: "top"
	                  };
	                  _.toPairs(attrs).map(function (item) {
	                    return node && node.setAttribute(item[0], item[1]);
	                  });
	                }
	              },
	              _react2.default.createElement(
	                "td",
	                {
	                  ref: function ref(node) {
	                    var attrs = {
	                      align: "center",
	                      valign: "top"
	                    };
	                    _.toPairs(attrs).map(function (item) {
	                      return node && node.setAttribute(item[0], item[1]);
	                    });
	                  },
	                  style: {
	                    padding: this.props.stylePadding
	                  }
	                },
	                _react2.default.createElement(
	                  "table",
	                  {
	                    ref: function ref(node) {
	                      var attrs = {
	                        border: 0,
	                        cellpadding: 0,
	                        cellspacing: 0
	                      };
	                      _.toPairs(attrs).map(function (item) {
	                        return node && node.setAttribute(item[0], item[1]);
	                      });
	                    } },
	                  _react2.default.createElement(
	                    "tbody",
	                    null,
	                    this.props.children.length > 0 ? this.props.children : _react2.default.createElement(
	                      "tr",
	                      null,
	                      _react2.default.createElement(
	                        "td",
	                        null,
	                        _react2.default.createElement(_DropZone2.default, { text: this.props.configName })
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Column;
	}(_react.Component);
	
	exports.default = Column;

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _StyleItem = __webpack_require__(46);
	
	var _StyleItem2 = _interopRequireDefault(_StyleItem);
	
	var _ImageBrowser = __webpack_require__(479);
	
	var _ImageBrowser2 = _interopRequireDefault(_ImageBrowser);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by DSadler on 02/05/2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	//import placeHolder from './placeholder.png'
	
	
	// Gets around create-react-app converting <10K files to data URI 
	var placeHolder = ("") + "/img/placeholder.png";
	
	var ImageItem = function (_Component) {
	  _inherits(ImageItem, _Component);
	
	  function ImageItem(props) {
	    _classCallCheck(this, ImageItem);
	
	    var _this = _possibleConstructorReturn(this, (ImageItem.__proto__ || Object.getPrototypeOf(ImageItem)).call(this, props));
	
	    _this.state = {
	      imagePickerOpen: false
	    };
	    return _this;
	  }
	
	  _createClass(ImageItem, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var _props$contentContent = this.props.contentContent,
	          imageUrl = _props$contentContent.imageUrl,
	          imageAlt = _props$contentContent.imageAlt,
	          imageLink = _props$contentContent.imageLink;
	
	
	      var imgArgs = [this.props.styleWidth ? "width=" + _.parseInt(this.props.styleWidth) + "&" : null, this.props.styleHeight ? "height=" + _.parseInt(this.props.styleHeight) + "&" : null, "mode=crop&anchor=middlecenter&upscale=false"].join("");
	
	      var imgSrc = imageUrl ? imageUrl + "?" + imgArgs : placeHolder;
	
	      var image = _react2.default.createElement("img", {
	        src: imgSrc,
	        onClick: function onClick() {
	          return _this2.props.currentlySelected && _this2.setState({ imagePickerOpen: true });
	        },
	        style: {
	          width: imageUrl ? this.props.styleWidth : 100,
	          height: imageUrl ? this.props.styleHeight : 100,
	          cursor: this.props.currentlySelected ? "pointer" : null
	        },
	        alt: imageAlt || ""
	      });
	
	      return _react2.default.createElement(
	        "td",
	        Object.assign({
	          id: this.props.contentId,
	          className: [this.props.contentId, this.props.viewClass].join(" ").trim(),
	          ref: function ref(node) {
	            _.toPairs(_this2.props.viewAttributes).map(function (item) {
	              return node && node.setAttribute(item[0], item[1]);
	            });
	          }
	        }, this.props.eventHandlers, {
	          style: {
	            width: this.props.styleWidth,
	            height: this.props.styleHeight,
	            backgroundColor: this.props.styleBackgroundColour,
	            color: this.props.styleTextColour,
	            textAlign: this.props.styleTextAlignment
	          }
	        }),
	        _react2.default.createElement(_StyleItem2.default, { selectorPrefix: this.props.contentId + " ", styleObject: this.props.viewCss }),
	        this.props.currentlySelected && _react2.default.createElement(_ImageBrowser2.default, {
	          open: this.state.imagePickerOpen,
	          currentImage: this.props.contentContent,
	          callback: function callback(image) {
	            _this2.setState({ imagePickerOpen: false });
	            if (image) {
	              _this2.props.updateContent({ contentContent: image });
	            }
	            console.log(image);
	          }
	        }),
	        imageLink && _react2.default.createElement(
	          "a",
	          { href: imageLink },
	          image
	        ),
	        !imageLink && image
	      );
	    }
	  }]);
	
	  return ImageItem;
	}(_react.Component);
	
	exports.default = ImageItem;

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleItem = __webpack_require__(46);
	
	var _StyleItem2 = _interopRequireDefault(_StyleItem);
	
	var _DropZone = __webpack_require__(96);
	
	var _DropZone2 = _interopRequireDefault(_DropZone);
	
	var _object = __webpack_require__(113);
	
	var _ = _interopRequireWildcard(_object);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 17/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Component acts as a host for TableItems or BlockItems
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Can only be placed inside TableItems
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Generally I don't screw with the styles on these. Only alignment needs dealing with.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var MainRowItem = function (_Component) {
	  _inherits(MainRowItem, _Component);
	
	  function MainRowItem() {
	    _classCallCheck(this, MainRowItem);
	
	    return _possibleConstructorReturn(this, (MainRowItem.__proto__ || Object.getPrototypeOf(MainRowItem)).apply(this, arguments));
	  }
	
	  _createClass(MainRowItem, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "tr",
	        Object.assign({
	          id: this.props.contentId,
	          className: [this.props.contentId, this.props.viewClass].join(" ").trim(),
	          ref: function ref(node) {
	            var attrs = {
	              align: "center",
	              valign: "top",
	              draggable: true
	            };
	            _.toPairs(attrs).map(function (item) {
	              return node && node.setAttribute(item[0], item[1]);
	            });
	          }
	        }, this.props.eventHandlers),
	        _react2.default.createElement(_StyleItem2.default, { selectorPrefix: this.props.contentId + " ", styleObject: this.props.viewCss }),
	        _react2.default.createElement(
	          "td",
	          {
	            ref: function ref(node) {
	              var attrs = {
	                align: "center",
	                valign: "top"
	              };
	              _.toPairs(attrs).map(function (item) {
	                return node && node.setAttribute(item[0], item[1]);
	              });
	            }
	          },
	          _react2.default.createElement(
	            "table",
	            {
	              className: "full-width",
	              ref: function ref(node) {
	                var attrs = {
	                  border: 0,
	                  cellpadding: 0,
	                  cellspacing: 0
	                };
	                _.toPairs(attrs).map(function (item) {
	                  return node && node.setAttribute(item[0], item[1]);
	                });
	              }
	            },
	            _react2.default.createElement(
	              "tbody",
	              null,
	              _react2.default.createElement(
	                "tr",
	                {
	                  ref: function ref(node) {
	                    var attrs = {
	                      align: "center",
	                      valign: "top"
	                    };
	                    _.toPairs(attrs).map(function (item) {
	                      return node && node.setAttribute(item[0], item[1]);
	                    });
	                  }
	                },
	                _react2.default.createElement(
	                  "td",
	                  {
	                    ref: function ref(node) {
	                      var attrs = {
	                        align: "center",
	                        valign: "top"
	                      };
	                      _.toPairs(attrs).map(function (item) {
	                        return node && node.setAttribute(item[0], item[1]);
	                      });
	                    }
	                  },
	                  _react2.default.createElement(
	                    "table",
	                    {
	                      className: "section-content-container",
	                      ref: function ref(node) {
	                        var attrs = {
	                          border: 0,
	                          cellpadding: 0,
	                          cellspacing: 0
	                        };
	                        _.toPairs(attrs).map(function (item) {
	                          return node && node.setAttribute(item[0], item[1]);
	                        });
	                      },
	                      style: {
	                        width: this.props.styleWidth,
	                        height: this.props.styleHeight,
	                        padding: this.props.stylePadding,
	                        backgroundColor: this.props.styleBackgroundColour,
	                        color: this.props.styleTextColour,
	                        textAlign: this.props.styleTextAlignment
	                      }
	                    },
	                    _react2.default.createElement(
	                      "tbody",
	                      null,
	                      _react2.default.createElement(
	                        "tr",
	                        {
	                          ref: function ref(node) {
	                            var attrs = {
	                              align: "center",
	                              valign: "top"
	                            };
	                            _.toPairs(attrs).map(function (item) {
	                              return node && node.setAttribute(item[0], item[1]);
	                            });
	                          }
	                        },
	                        this.props.children.length > 0 ? this.props.children : _react2.default.createElement(
	                          "td",
	                          null,
	                          _react2.default.createElement(_DropZone2.default, { text: this.props.configName })
	                        )
	                      )
	                    )
	                  )
	                )
	              )
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return MainRowItem;
	}(_react.Component);
	
	exports.default = MainRowItem;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _StyleItem = __webpack_require__(46);
	
	var _StyleItem2 = _interopRequireDefault(_StyleItem);
	
	var _tinymce = __webpack_require__(2029);
	
	var _tinymce2 = _interopRequireDefault(_tinymce);
	
	__webpack_require__(2028);
	
	__webpack_require__(2012);
	
	__webpack_require__(2018);
	
	__webpack_require__(2006);
	
	__webpack_require__(2022);
	
	__webpack_require__(2020);
	
	__webpack_require__(2004);
	
	__webpack_require__(2008);
	
	__webpack_require__(2010);
	
	__webpack_require__(2016);
	
	__webpack_require__(2026);
	
	__webpack_require__(2014);
	
	__webpack_require__(2024);
	
	var _cheerio = __webpack_require__(124);
	
	var _cheerio2 = _interopRequireDefault(_cheerio);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by DSadler on 27/04/2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var RichText = function (_Component) {
	  _inherits(RichText, _Component);
	
	  function RichText(props) {
	    _classCallCheck(this, RichText);
	
	    var _this = _possibleConstructorReturn(this, (RichText.__proto__ || Object.getPrototypeOf(RichText)).call(this, props));
	
	    _this.state = {
	      editor: null,
	      visibilityToggled: false
	    };
	    _this.initEditor = _this.initEditor.bind(_this);
	    _this.destroyEditor = _this.destroyEditor.bind(_this);
	    _this.saveContent = _this.saveContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(RichText, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      // If we're selected then enable the editor
	      if (this.props.currentlySelected) {
	        this.initEditor();
	      }
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate() {
	      // If we're selected and the editor is not active then enable the editor
	      if (this.props.currentlySelected && !this.state.editor) {
	        this.initEditor();
	      }
	
	      // If we're not selected and the editor is ACTIVE, save content and destroy the editor
	      if (this.state.editor && !this.props.currentlySelected) {
	        this.saveContent();
	        this.destroyEditor();
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      // If the editor is active destroy it
	      if (this.state.editor) {
	        this.destroyEditor();
	      }
	    }
	  }, {
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      var visibilityToggled = nextProps.contentHidden !== this.props.contentHidden;
	      this.setState({ visibilityToggled: visibilityToggled });
	    }
	  }, {
	    key: "shouldComponentUpdate",
	    value: function shouldComponentUpdate(nextProps, nextState) {
	      var editing = nextProps.currentlySelected && nextState.editor;
	      if (editing && !nextState.visibilityToggled) {
	        //console.log("Skipped update");
	        return false;
	      }
	      return true;
	    }
	  }, {
	    key: "initEditor",
	    value: function initEditor() {
	      var component = this;
	      var config = {};
	      switch (component.props.configEditorType) {
	        case "basic":
	          config = {
	            menubar: false,
	            toolbar: false,
	            plugins: 'paste',
	            external_plugins: {
	              paste: "/tinymce/plugins/paste/plugin.min.js"
	            },
	            paste_word_valid_elements: 'b,strong,em,i,u,strike',
	            paste_preprocess: function paste_preprocess(plugin, args) {
	              debugger;
	              var html = _cheerio2.default.load(args.content);
	              args.content = html.text();
	            }
	          };
	          break;
	        case "full":
	        default:
	          config = {
	            menubar: false,
	            toolbar: ["bold italic underline strikethrough forecolor | ", "alignleft aligncenter alignright alignjustify alignnone | ", "link unlink anchor template |", "paste |", "numlist bullist | subscript superscript | hr charmap removeformat |", "code"].join(),
	            plugins: 'code link paste lists advlist autolink charmap hr textcolor colorpicker template',
	            /*           external_plugins: {
	                        code: "/tinymce/plugins/code/plugin.min.js",
	                        link: "/tinymce/plugins/link/plugin.min.js",
	                        anchor: "/tinymce/plugins/anchor/plugin.min.js",
	                        paste: "/tinymce/plugins/paste/plugin.min.js",
	                        lists: "/tinymce/plugins/lists/plugin.min.js",
	                        advlist: "/tinymce/plugins/advlist/plugin.min.js",
	                        autolink: "/tinymce/plugins/autolink/plugin.min.js",
	                        charmap: "/tinymce/plugins/charmap/plugin.min.js",
	                        hr: "/tinymce/plugins/hr/plugin.min.js",
	                      }, */
	            paste_word_valid_elements: 'h2,h3,h4,h5,h6,p,span,b,strong,em,i,u,strike,sub,sup,ul,ol,li,a[href],hr',
	            textcolor_cols: "6",
	            textcolor_rows: "2",
	            textcolor_map: ["230052", "blue", "7f58A5", "purple", "6e9bb0", "lblue", "ce124e", "red", "f26334", "orange", "a8ad2c", "green", "231f20", "black", "939596", "grey", "53c0a5", "aqua", "c59872", "brown", "7f2c72", "mauve", "fcb316", "yellow"],
	            /* eslint-disable no-template-curly-in-string */
	            templates: [{ title: 'Firstname merge tag', description: 'Insert the Clickdimensions merge tag for contact firstname.', content: '${Recipient.contact.firstname}' }, { title: 'Lastname merge tag', description: 'Insert the Clickdimensions merge tag for contact lastname.', content: '${Recipient.contact.lastname}' }, { title: 'Fullname merge tag', description: 'Insert the Clickdimensions merge tag for contact fullname.', content: '${Recipient.contact.fullname}' }, { title: 'Custom salutation merge tag', description: 'Insert the Clickdimensions merge tag for a custom salutation.', content: '${Recipient.contact.abi_customsalutation}' }, { title: 'Employer name merge tag', description: 'Insert the Clickdimensions merge tag for the contact\'s employer.', content: '${Recipient.contact.parentcustomerid}' }, { title: 'View email online link', description: 'Insert a link to view this email in a web browser.', content: 'Click <a href="${Gears.microsite()}">here</a> to open this email in your browser.' }, { title: 'Unsubscribe link', description: 'Insert a link to unsubscribe from all ABI emails.', content: 'Click <a href="${Gears.unsubscribe()}">here</a> to unsubscribe from all ABI newsletters.' }, { title: 'Manage subscriptions link', description: 'Insert a link to the "My Account" area of the website.', content: 'Manage your ABI subscription preferences <a href="https://www.abi.org.uk/account/">here</a>.' }]
	            /* eslint-enable no-template-curly-in-string */
	          };
	      }
	
	      _tinymce2.default.init(Object.assign({}, config, {
	        selector: "." + this.props.contentId + ".editable",
	        inline: true,
	        forced_root_block: this.props.configEditorRoot,
	        browser_spellcheck: true,
	        skin_url: '/tinymce/skins/lightgray',
	        init_instance_callback: function init_instance_callback(editor) {
	          // Flag that we're editing
	          component.setState({ editor: editor });
	
	          // Save regularly
	          editor.on('Change', function (e) {
	            component.saveContent(true);
	            component.props.updateContentFrame(component.myNode);
	            /*console.log('Editor contents was changed.');*/
	          });
	          // Save regularly
	          editor.on('KeyDown', function (e) {
	            component.props.updateContentFrame(component.myNode);
	            console.log('Key down.');
	            //console.log(e);
	          });
	
	          component.props.updateContentFrame(component.myNode);
	          // Update the frame on everything
	        }
	      }));
	    }
	  }, {
	    key: "destroyEditor",
	    value: function destroyEditor() {
	      // Commit the contents of the editor to the dom, then kill the editor
	      _tinymce2.default.remove(this.state.editor);
	      this.setState({ editor: null });
	    }
	  }, {
	    key: "saveContent",
	    value: function saveContent(raw) {
	      // Save the current contents of the editor cell to the state
	      if (raw) {
	        this.props.updateContent({ contentContent: document.getElementsByClassName(this.props.contentId + " editable")[0].innerHTML });
	      } else {
	        this.props.updateContent({ contentContent: this.state.editor.getContent() });
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "td",
	        Object.assign({
	          id: this.props.contentId,
	          className: [this.props.contentId, this.props.viewClass].join(" ").trim(),
	          ref: function ref(node) {
	            _this2.myNode = node;
	            node && node.setAttribute("draggable", _this2.props.viewAttributes.draggable);
	            node && node.setAttribute("id", _this2.props.viewAttributes.id);
	          }
	        }, this.props.eventHandlers, {
	          style: {
	            width: this.props.styleWidth,
	            height: this.props.styleHeight,
	            backgroundColor: this.props.styleBackgroundColour,
	            color: this.props.styleTextColour,
	            textAlign: this.props.styleTextAlignment
	          }
	        }),
	        _react2.default.createElement(_StyleItem2.default, { selectorPrefix: this.props.contentId + " ", styleObject: this.props.viewCss }),
	        this.props.children,
	        _react2.default.createElement("a", { name: this.props.contentId }),
	        _react2.default.createElement(
	          "table",
	          {
	            className: "wrapper-table",
	            ref: function ref(node) {
	              _.toPairs(_this2.props.viewAttributes.table).map(function (item) {
	                return node && node.setAttribute(item[0], item[1]);
	              });
	            },
	            style: {
	              width: this.props.styleWidth,
	              height: this.props.styleHeight,
	              backgroundColor: this.props.styleBackgroundColour,
	              color: this.props.styleTextColour,
	              textAlign: this.props.styleTextAlignment
	            }
	          },
	          _react2.default.createElement(
	            "tbody",
	            null,
	            _react2.default.createElement(
	              "tr",
	              null,
	              _react2.default.createElement("td", {
	                className: [this.props.contentId, this.props.viewClass].join(" ").trim() + " editable",
	                ref: function ref(node) {
	                  _.toPairs(_this2.props.viewAttributes.td).map(function (item) {
	                    return node && node.setAttribute(item[0], item[1]);
	                  });
	                },
	                style: {
	                  padding: this.props.stylePadding, //Only applied here
	                  backgroundColor: this.props.styleBackgroundColour,
	                  color: this.props.styleTextColour,
	                  textAlign: this.props.styleTextAlignment
	                },
	                dangerouslySetInnerHTML: { __html: this.props.contentContent } })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return RichText;
	}(_react.Component);
	
	exports.default = RichText;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleItem = __webpack_require__(46);
	
	var _StyleItem2 = _interopRequireDefault(_StyleItem);
	
	var _DropZone = __webpack_require__(96);
	
	var _DropZone2 = _interopRequireDefault(_DropZone);
	
	var _object = __webpack_require__(113);
	
	var _ = _interopRequireWildcard(_object);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 17/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Component acts as a host for TableItems or BlockItems
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Can only be placed inside TableItems
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Generally I don't screw with the styles on these. Only alignment needs dealing with.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var RowItem = function (_Component) {
	  _inherits(RowItem, _Component);
	
	  function RowItem() {
	    _classCallCheck(this, RowItem);
	
	    return _possibleConstructorReturn(this, (RowItem.__proto__ || Object.getPrototypeOf(RowItem)).apply(this, arguments));
	  }
	
	  _createClass(RowItem, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "tr",
	        Object.assign({
	          id: this.props.contentId,
	          className: [this.props.contentId, this.props.viewClass].join(" ").trim(),
	          ref: function ref(node) {
	            _.toPairs(_this2.props.viewAttributes).map(function (item) {
	              return node && node.setAttribute(item[0], item[1]);
	            });
	          }
	        }, this.props.eventHandlers, {
	          style: {
	            width: this.props.styleWidth,
	            height: this.props.styleHeight,
	            padding: this.props.stylePadding,
	            backgroundColor: this.props.styleBackgroundColour,
	            color: this.props.styleTextColour,
	            textAlign: this.props.styleTextAlignment
	          }
	        }),
	        _react2.default.createElement(_StyleItem2.default, { selectorPrefix: this.props.contentId + " ", styleObject: this.props.viewCss }),
	        this.props.children.length > 0 ? this.props.children : _react2.default.createElement(
	          "td",
	          null,
	          _react2.default.createElement(_DropZone2.default, { text: this.props.configName })
	        )
	      );
	    }
	  }]);
	
	  return RowItem;
	}(_react.Component);
	
	exports.default = RowItem;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _StyleItem = __webpack_require__(46);
	
	var _StyleItem2 = _interopRequireDefault(_StyleItem);
	
	var _DropZone = __webpack_require__(96);
	
	var _DropZone2 = _interopRequireDefault(_DropZone);
	
	var _object = __webpack_require__(113);
	
	var _ = _interopRequireWildcard(_object);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 16/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * This component acts as a host for other rows.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Can only be placed in CellItems (apart from root item)
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var TableItem = function (_Component) {
	  _inherits(TableItem, _Component);
	
	  function TableItem() {
	    _classCallCheck(this, TableItem);
	
	    return _possibleConstructorReturn(this, (TableItem.__proto__ || Object.getPrototypeOf(TableItem)).apply(this, arguments));
	  }
	
	  _createClass(TableItem, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "table",
	        Object.assign({
	          id: this.props.contentId,
	          className: [this.props.contentId, this.props.viewClass].join(" ").trim(),
	          ref: function ref(node) {
	            _.toPairs(_this2.props.viewAttributes).map(function (item) {
	              return node && node.setAttribute(item[0], item[1]);
	            });
	          }
	        }, this.props.eventHandlers, {
	          style: {
	            width: this.props.styleWidth,
	            height: this.props.styleHeight,
	            padding: this.props.stylePadding,
	            backgroundColor: this.props.styleBackgroundColour,
	            color: this.props.styleTextColour,
	            textAlign: this.props.styleTextAlignment
	          }
	        }),
	        _react2.default.createElement(_StyleItem2.default, { selectorPrefix: this.props.contentId + " ", styleObject: this.props.viewCss }),
	        _react2.default.createElement(
	          "tbody",
	          null,
	          this.props.children.length > 0 ? this.props.children : _react2.default.createElement(
	            "tr",
	            null,
	            _react2.default.createElement(
	              "td",
	              null,
	              _react2.default.createElement(_DropZone2.default, { text: this.props.configName })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return TableItem;
	}(_react.Component);
	
	exports.default = TableItem;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _StyleItem = __webpack_require__(46);
	
	var _StyleItem2 = _interopRequireDefault(_StyleItem);
	
	var _selectors = __webpack_require__(55);
	
	var _reactRedux = __webpack_require__(26);
	
	var _cheerio = __webpack_require__(124);
	
	var _cheerio2 = _interopRequireDefault(_cheerio);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by DSadler on 02/05/2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var TocItem = function (_Component) {
	  _inherits(TocItem, _Component);
	
	  function TocItem() {
	    _classCallCheck(this, TocItem);
	
	    return _possibleConstructorReturn(this, (TocItem.__proto__ || Object.getPrototypeOf(TocItem)).apply(this, arguments));
	  }
	
	  _createClass(TocItem, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      // Construct links
	      var links = this.props.headers.map(function (item, key, array) {
	        var element = _cheerio2.default.load(item.contentContent);
	        return _react2.default.createElement(
	          "p",
	          { key: item.contentId },
	          _react2.default.createElement(
	            "a",
	            {
	              href: "#" + item.contentId
	            },
	            element.text()
	          ),
	          key < array.length - 1 && _react2.default.createElement("br", null)
	        );
	      });
	
	      return _react2.default.createElement(
	        "td",
	        Object.assign({
	          id: this.props.contentId,
	          className: [this.props.contentId, this.props.viewClass].join(" ").trim(),
	          ref: function ref(node) {
	            _.toPairs(_this2.props.viewAttributes).map(function (item) {
	              return node && node.setAttribute(item[0], item[1]);
	            });
	          }
	        }, this.props.eventHandlers, {
	          style: {
	            width: this.props.styleWidth,
	            height: this.props.styleHeight,
	            padding: this.props.stylePadding,
	            backgroundColor: this.props.styleBackgroundColour,
	            color: this.props.styleTextColour,
	            textAlign: this.props.styleTextAlignment
	          }
	        }),
	        _react2.default.createElement(_StyleItem2.default, { selectorPrefix: this.props.contentId + " ", styleObject: this.props.viewCss }),
	        links.map(function (item) {
	          return item;
	        })
	      );
	    }
	  }]);
	
	  return TocItem;
	}(_react.Component);
	
	function mapStateToProps(state, ownprops) {
	  return Object.assign({}, ownprops, {
	    headers: (0, _selectors.getContentItems)(state, { configId: "SECTION_HEADER" })
	  });
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(TocItem);

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.Column = exports.MainRow = exports.TocItem = exports.ImageItem = exports.RichText = exports.TableItem = exports.RowItem = exports.CellItem = exports.TEMPLATE_COMPONENTS = undefined;
	
	var _CellItem = __webpack_require__(445);
	
	var _CellItem2 = _interopRequireDefault(_CellItem);
	
	var _RowItem = __webpack_require__(450);
	
	var _RowItem2 = _interopRequireDefault(_RowItem);
	
	var _TableItem = __webpack_require__(451);
	
	var _TableItem2 = _interopRequireDefault(_TableItem);
	
	var _RichText = __webpack_require__(449);
	
	var _RichText2 = _interopRequireDefault(_RichText);
	
	var _ImageItem = __webpack_require__(447);
	
	var _ImageItem2 = _interopRequireDefault(_ImageItem);
	
	var _TocItem = __webpack_require__(452);
	
	var _TocItem2 = _interopRequireDefault(_TocItem);
	
	var _MainRow = __webpack_require__(448);
	
	var _MainRow2 = _interopRequireDefault(_MainRow);
	
	var _Column = __webpack_require__(446);
	
	var _Column2 = _interopRequireDefault(_Column);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by daniel on 23/04/17.
	 */
	
	var TEMPLATE_COMPONENTS = {
	  CELL_ITEM: {
	    id: "CELL_ITEM",
	    component: _CellItem2.default
	  },
	  ROW_ITEM: {
	    id: "ROW_ITEM",
	    component: _RowItem2.default
	  },
	  TABLE_ITEM: {
	    id: "TABLE_ITEM",
	    component: _TableItem2.default
	  },
	  RICH_TEXT: {
	    id: "RICH_TEXT",
	    component: _RichText2.default
	  },
	  IMAGE_ITEM: {
	    id: "IMAGE_ITEM",
	    component: _ImageItem2.default
	  },
	  TOC_ITEM: {
	    id: "TOC_ITEM",
	    component: _TocItem2.default
	  },
	  MAIN_ROW: {
	    id: "MAIN_ROW",
	    component: _MainRow2.default
	  },
	  COLUMN: {
	    id: "COLUMN",
	    component: _Column2.default
	  }
	};
	
	exports.TEMPLATE_COMPONENTS = TEMPLATE_COMPONENTS;
	exports.CellItem = _CellItem2.default;
	exports.RowItem = _RowItem2.default;
	exports.TableItem = _TableItem2.default;
	exports.RichText = _RichText2.default;
	exports.ImageItem = _ImageItem2.default;
	exports.TocItem = _TocItem2.default;
	exports.MainRow = _MainRow2.default;
	exports.Column = _Column2.default;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _ContentFrameContainer = __webpack_require__(457);
	
	var _ContentFrameContainer2 = _interopRequireDefault(_ContentFrameContainer);
	
	var _DropZoneFrameContainer = __webpack_require__(459);
	
	var _DropZoneFrameContainer2 = _interopRequireDefault(_DropZoneFrameContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 11/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var paperStyle = {
	  //minHeight: 400,
	  width: "90vw",
	  maxWidth: "800px",
	  marginLeft: 'auto',
	  marginRight: 'auto'
	  //paddingTop: "3vw",
	};
	
	var Canvas = function (_Component) {
	  _inherits(Canvas, _Component);
	
	  function Canvas() {
	    _classCallCheck(this, Canvas);
	
	    return _possibleConstructorReturn(this, (Canvas.__proto__ || Object.getPrototypeOf(Canvas)).apply(this, arguments));
	  }
	
	  _createClass(Canvas, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { id: 'canvas-element', style: { width: "100%", padding: "20px 0" } },
	        _react2.default.createElement(
	          _Paper2.default,
	          { style: paperStyle, zDepth: 2 },
	          this.props.children
	        ),
	        _react2.default.createElement(_ContentFrameContainer2.default, null),
	        _react2.default.createElement(_DropZoneFrameContainer2.default, null)
	      );
	    }
	  }]);
	
	  return Canvas;
	}(_react.Component);
	
	exports.default = Canvas;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(26);
	
	var _Canvas = __webpack_require__(454);
	
	var _Canvas2 = _interopRequireDefault(_Canvas);
	
	var _ContentContainer = __webpack_require__(248);
	
	var _ContentContainer2 = _interopRequireDefault(_ContentContainer);
	
	var _selectors = __webpack_require__(55);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 11/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var CanvasContainer = function (_Component) {
	  _inherits(CanvasContainer, _Component);
	
	  function CanvasContainer(props) {
	    _classCallCheck(this, CanvasContainer);
	
	    var _this = _possibleConstructorReturn(this, (CanvasContainer.__proto__ || Object.getPrototypeOf(CanvasContainer)).call(this, props));
	
	    if (!_this.props.rootItem) {
	      //this.props.dispatch(createContentItem(null, null, "ROOT_ITEM", getContentDefinitions(this.props.state)));
	    }
	    return _this;
	  }
	  // Find the active states root element and render this to the canvas
	
	
	  _createClass(CanvasContainer, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        _Canvas2.default,
	        null,
	        this.props.rootItem && _react2.default.createElement(_ContentContainer2.default, { contentId: this.props.rootItem.contentId, key: this.props.rootItem.contentId })
	      );
	    }
	  }]);
	
	  return CanvasContainer;
	}(_react.Component);
	
	var mapStateToProps = function mapStateToProps(state) {
	  var rootItem = (0, _selectors.getRootItem)(state);
	  return {
	    rootItem: rootItem,
	    state: state
	  };
	};
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(CanvasContainer);

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(34);
	
	var _colors = __webpack_require__(63);
	
	var _index = __webpack_require__(151);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 22/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ContentFrame = function (_Component) {
	  _inherits(ContentFrame, _Component);
	
	  function ContentFrame() {
	    _classCallCheck(this, ContentFrame);
	
	    return _possibleConstructorReturn(this, (ContentFrame.__proto__ || Object.getPrototypeOf(ContentFrame)).apply(this, arguments));
	  }
	
	  _createClass(ContentFrame, [{
	    key: "render",
	    value: function render() {
	      var itemBounds = this.props.position;
	      if (!itemBounds) return null;
	      var tooHigh = itemBounds.top - 56 < 56;
	      // 56 offset
	      var contentFrameStyle = {
	        position: "absolute",
	        top: tooHigh ? itemBounds.top + 46 : itemBounds.top,
	        left: itemBounds.left - 10,
	        width: itemBounds.width,
	        height: itemBounds.height + 46,
	        borderColor: _colors.yellow500,
	        borderStyle: "solid",
	        borderWidth: "10px",
	        pointerEvents: "none",
	        boxShadow: "rgba(0, 0, 0, 0.156863) 0px 3px 10px, rgba(0, 0, 0, 0.227451) 0px 3px 10px",
	        zIndex: 10
	      };
	
	      var toolbarStyles = {
	        backgroundColor: _colors.yellow500,
	        pointerEvents: "auto",
	        bottom: tooHigh ? 0 : undefined,
	        top: tooHigh ? undefined : 0,
	        marginTop: tooHigh ? 0 : -10,
	        marginBottom: tooHigh ? -10 : 0,
	        width: "100%",
	        position: "absolute"
	      };
	
	      var infoButton = _react2.default.createElement(
	        _materialUi.IconButton,
	        {
	          tooltip: this.props.title,
	          tooltipPosition: "top-center"
	        },
	        _react2.default.createElement(_index.ActionSettings, null)
	      );
	
	      var hideButton = _react2.default.createElement(
	        _materialUi.IconButton,
	        {
	          onTouchTap: this.props.hideItem,
	          tooltip: "Hide item",
	          tooltipPosition: "top-center"
	        },
	        _react2.default.createElement(_index.ActionVisibilityOff, null)
	      );
	
	      var showButton = _react2.default.createElement(
	        _materialUi.IconButton,
	        {
	          onTouchTap: this.props.showItem,
	          tooltip: "Unhide item",
	          tooltipPosition: "top-center"
	        },
	        _react2.default.createElement(_index.ActionVisibility, null)
	      );
	
	      var deleteButton = _react2.default.createElement(
	        _materialUi.IconButton,
	        {
	          onTouchTap: this.props.delete,
	          tooltip: "Delete item",
	          tooltipPosition: "top-center"
	        },
	        _react2.default.createElement(_index.ActionDelete, null)
	      );
	
	      var closeButton = _react2.default.createElement(
	        _materialUi.IconButton,
	        {
	          onTouchTap: this.props.closeFrame,
	          tooltip: "Close content frame",
	          tooltipPosition: "top-center"
	        },
	        _react2.default.createElement(_index.NavigationClose, null)
	      );
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          "div",
	          { style: contentFrameStyle },
	          _react2.default.createElement(
	            _materialUi.Toolbar,
	            {
	              style: toolbarStyles,
	              onClick: function onClick(e) {
	                return e.stopPropagation();
	              },
	              onDragStart: function onDragStart(e) {
	                e.stopPropagation();
	                e.preventDefault();
	                return false;
	              }
	            },
	            _react2.default.createElement(
	              _materialUi.ToolbarGroup,
	              { firstChild: true },
	              infoButton,
	              this.props.hideable && this.props.hidden && showButton,
	              this.props.hideable && !this.props.hidden && hideButton
	            ),
	            _react2.default.createElement(
	              _materialUi.ToolbarGroup,
	              { lastChild: true },
	              this.props.canDelete && deleteButton,
	              closeButton
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ContentFrame;
	}(_react.Component);
	
	exports.default = ContentFrame;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ContentFrame = __webpack_require__(456);
	
	var _ContentFrame2 = _interopRequireDefault(_ContentFrame);
	
	var _reactRedux = __webpack_require__(26);
	
	var _selectors = __webpack_require__(57);
	
	var _selectors2 = __webpack_require__(55);
	
	var _actions = __webpack_require__(54);
	
	var _actions2 = __webpack_require__(56);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 22/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ContentFrameContainer = function (_Component) {
	  _inherits(ContentFrameContainer, _Component);
	
	  function ContentFrameContainer(props) {
	    _classCallCheck(this, ContentFrameContainer);
	
	    var _this = _possibleConstructorReturn(this, (ContentFrameContainer.__proto__ || Object.getPrototypeOf(ContentFrameContainer)).call(this, props));
	
	    _this.handleDelete = _this.handleDelete.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	    _this.handleHideItem = _this.handleHideItem.bind(_this);
	    _this.handleShowItem = _this.handleShowItem.bind(_this);
	    return _this;
	  }
	
	  _createClass(ContentFrameContainer, [{
	    key: "handleDelete",
	    value: function handleDelete() {
	      //TODO implement the recycle bin
	      //this.props.dispatch(orphanContentItem(this.props.selectedItem.contentId));
	      this.props.dispatch((0, _actions.deleteContentItem)(this.props.selectedItem.contentId));
	      this.props.dispatch((0, _actions2.setUiSelectedContentItem)(null));
	    }
	  }, {
	    key: "handleClose",
	    value: function handleClose() {
	      this.props.dispatch((0, _actions2.setUiSelectedContentItem)(null));
	    }
	  }, {
	    key: "handleHideItem",
	    value: function handleHideItem() {
	      this.props.dispatch((0, _actions.hideContentItem)(this.props.selectedItemProps.contentId, true));
	    }
	  }, {
	    key: "handleShowItem",
	    value: function handleShowItem() {
	      this.props.dispatch((0, _actions.hideContentItem)(this.props.selectedItemProps.contentId, false));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      if (!this.props.selectedItem) return null;
	      var name = this.props.selectedItemProps.contentName ? this.props.selectedItemProps.contentName : this.props.selectedItemProps.configName;
	      return _react2.default.createElement(_ContentFrame2.default, {
	        position: this.props.selectedItemCoords,
	        title: name,
	        hideable: this.props.selectedItemProps.editorHideable,
	        hidden: this.props.selectedItemProps.contentHidden,
	        showItem: this.handleShowItem,
	        hideItem: this.handleHideItem,
	        canDelete: this.props.selectedItemProps.editorDeletable,
	        "delete": this.handleDelete,
	        closeFrame: this.handleClose
	      });
	    }
	  }]);
	
	  return ContentFrameContainer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var selectedItem = (0, _selectors.getUiSelectedItem)(state);
	  var selectedItemProps = selectedItem && (0, _selectors2.getContentItem)(state, selectedItem.contentId);
	  var selectedItemCoords = selectedItem && (0, _selectors.getUiItemCoords)(selectedItem.contentId, "canvas-element");
	
	  return {
	    selectedItem: selectedItem,
	    selectedItemProps: selectedItemProps,
	    selectedItemCoords: selectedItemCoords
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ContentFrameContainer);

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(568);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 27/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var DropZoneFrame = function (_Component) {
	  _inherits(DropZoneFrame, _Component);
	
	  function DropZoneFrame() {
	    _classCallCheck(this, DropZoneFrame);
	
	    return _possibleConstructorReturn(this, (DropZoneFrame.__proto__ || Object.getPrototypeOf(DropZoneFrame)).apply(this, arguments));
	  }
	
	  _createClass(DropZoneFrame, [{
	    key: 'render',
	    value: function render() {
	      var style = Object.assign({
	        position: "absolute"
	      }, this.props.coords, {
	        zIndex: 10
	      });
	
	      return _react2.default.createElement('div', {
	        className: 'editor-dropzone-frame',
	        style: style });
	    }
	  }]);
	
	  return DropZoneFrame;
	}(_react.Component);
	
	exports.default = DropZoneFrame;

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _DropZoneFrame = __webpack_require__(458);
	
	var _DropZoneFrame2 = _interopRequireDefault(_DropZoneFrame);
	
	var _selectors = __webpack_require__(57);
	
	var _reactRedux = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 27/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var DropZoneFrameContainer = function (_Component) {
	  _inherits(DropZoneFrameContainer, _Component);
	
	  function DropZoneFrameContainer() {
	    _classCallCheck(this, DropZoneFrameContainer);
	
	    return _possibleConstructorReturn(this, (DropZoneFrameContainer.__proto__ || Object.getPrototypeOf(DropZoneFrameContainer)).apply(this, arguments));
	  }
	
	  _createClass(DropZoneFrameContainer, [{
	    key: "render",
	    value: function render() {
	      return this.props.coords && _react2.default.createElement(_DropZoneFrame2.default, { coords: this.props.coords });
	    }
	  }]);
	
	  return DropZoneFrameContainer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var item = (0, _selectors.getUiDraggedItem)(state);
	  var coords = (0, _selectors.getUiDropzoneCoords)(state);
	
	  return {
	    item: item,
	    coords: coords
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(DropZoneFrameContainer);

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(34);
	
	__webpack_require__(569);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 02/05/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ExportDialog = function (_Component) {
	  _inherits(ExportDialog, _Component);
	
	  function ExportDialog(props) {
	    _classCallCheck(this, ExportDialog);
	
	    var _this = _possibleConstructorReturn(this, (ExportDialog.__proto__ || Object.getPrototypeOf(ExportDialog)).call(this, props));
	
	    _this.state = {
	      importJson: ""
	    };
	    _this.handleOnClick = _this.handleOnClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExportDialog, [{
	    key: "handleOnClick",
	    value: function handleOnClick(e) {
	      if (document.selection) {
	        var range = document.body.createTextRange();
	        range.moveToElementText(e.currentTarget);
	        range.select();
	      } else if (window.getSelection) {
	        var _range = document.createRange();
	        _range.selectNodeContents(e.currentTarget);
	        window.getSelection().removeAllRanges();
	        window.getSelection().addRange(_range);
	      }
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var importable = void 0;
	      var importMessage = void 0;
	      try {
	        JSON.parse(this.state.importJson);
	        importable = true;
	        importMessage = "Click to import this saved template";
	      } catch (e) {
	        importable = false;
	        importMessage = "Import text error:\n" + e.message;
	      }
	      var html = "";
	
	      if (this.props.open) {
	        html = this.props.getHtml();
	      }
	
	      return _react2.default.createElement(
	        _materialUi.Dialog,
	        {
	          open: this.props.open,
	          actions: _react2.default.createElement(_materialUi.RaisedButton, {
	            label: "Done",
	            onTouchTap: function onTouchTap() {
	              return _this2.props.visibility(false);
	            }
	          }),
	          title: "Import and export"
	        },
	        _react2.default.createElement(
	          _materialUi.Tabs,
	          {
	            contentContainerStyle: {
	              maxHeight: "50vh",
	              padding: "20px",
	              overflowY: "auto"
	            }
	          },
	          _react2.default.createElement(
	            _materialUi.Tab,
	            { label: "Export HTML" },
	            "Warnings:",
	            _react2.default.createElement(
	              "div",
	              {
	                className: "code-lines"
	              },
	              this.props.open && html.warnings ? html.warnings.split("\n").map(function (item, index) {
	                return [_react2.default.createElement(
	                  "code",
	                  { key: index },
	                  item
	                ), _react2.default.createElement("br", null)];
	              }) : _react2.default.createElement(
	                "code",
	                null,
	                "None"
	              )
	            ),
	            "Processed:",
	            _react2.default.createElement(
	              "div",
	              {
	                className: "code-lines",
	                onClick: this.handleOnClick
	              },
	              this.props.open && html.inlined.split("\n").map(function (item, index) {
	                return [_react2.default.createElement(
	                  "code",
	                  { key: index },
	                  item
	                ), _react2.default.createElement("br", null)];
	              })
	            ),
	            "Original:",
	            _react2.default.createElement(
	              "div",
	              {
	                className: "code-lines",
	                onClick: this.handleOnClick
	              },
	              this.props.open && html.original.split("\n").map(function (item, index) {
	                return [_react2.default.createElement(
	                  "code",
	                  { key: index },
	                  item
	                ), _react2.default.createElement("br", null)];
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _materialUi.Tab,
	            { label: "Export Template JSON" },
	            "This can be loaded into a different editor instance.",
	            _react2.default.createElement(
	              "div",
	              {
	                className: "code-lines",
	                onClick: this.handleOnClick
	              },
	              this.props.open && JSON.stringify(this.props.currentState, null, '  ').split("\n").map(function (item, index) {
	                return [_react2.default.createElement(
	                  "code",
	                  { key: index },
	                  item
	                ), _react2.default.createElement("br", null)];
	              })
	            )
	          ),
	          _react2.default.createElement(
	            _materialUi.Tab,
	            { label: "Import Template JSON" },
	            _react2.default.createElement(_materialUi.TextField, {
	              hintText: "Paste JSON here",
	              floatingLabelText: "Paste JSON here",
	              multiLine: true,
	              value: this.state.importJson,
	              fullWidth: true,
	              onChange: function onChange(e, val) {
	                return _this2.setState({ importJson: val });
	              }
	            }),
	            _react2.default.createElement(
	              "p",
	              { style: { color: importable ? "green" : "red" } },
	              importMessage
	            ),
	            _react2.default.createElement(_materialUi.RaisedButton, {
	              label: "Import",
	              disabled: !importable,
	              onTouchTap: function onTouchTap() {
	                return _this2.props.importContent(JSON.parse(_this2.state.importJson));
	              }
	            })
	          )
	        )
	      );
	    }
	  }]);
	
	  return ExportDialog;
	}(_react.Component);
	
	exports.default = ExportDialog;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ExportDialog = __webpack_require__(460);
	
	var _ExportDialog2 = _interopRequireDefault(_ExportDialog);
	
	var _reactRedux = __webpack_require__(26);
	
	var _cheerio = __webpack_require__(124);
	
	var _cheerio2 = _interopRequireDefault(_cheerio);
	
	var _client = __webpack_require__(635);
	
	var _client2 = _interopRequireDefault(_client);
	
	var _selectors = __webpack_require__(55);
	
	var _actions = __webpack_require__(54);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 02/05/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ExportDialogContainer = function (_Component) {
	  _inherits(ExportDialogContainer, _Component);
	
	  function ExportDialogContainer(props) {
	    _classCallCheck(this, ExportDialogContainer);
	
	    var _this = _possibleConstructorReturn(this, (ExportDialogContainer.__proto__ || Object.getPrototypeOf(ExportDialogContainer)).call(this, props));
	
	    _this.handleRenderExport = _this.handleRenderExport.bind(_this);
	    _this.handleImportContent = _this.handleImportContent.bind(_this);
	    return _this;
	  }
	
	  _createClass(ExportDialogContainer, [{
	    key: "handleRenderExport",
	    value: function handleRenderExport() {
	      // Looks for root item, throws it into cheerio, inlines styles with
	      //debugger;
	      var root = document.getElementsByClassName("root-table")[0];
	      var content = root.outerHTML;
	
	      // Remove redundant react comments
	      var cleanContent = content.replace(/(<!--\sreact-empty:\s){1}([0-9]){1,5}(\s-->){1}/g, "");
	
	      var inlinedContent = _client2.default.juiceDocument(_cheerio2.default.load(cleanContent));
	
	      // Remove hidden / placeholder elements
	      inlinedContent(".editor-hidden").remove();
	      inlinedContent(".placeholder").remove();
	
	      var removableTags = {
	        table: "table",
	        tbody: "tbody",
	        tr: "tr",
	        td: "td"
	      };
	
	      // Remove redundant cells / rows
	      function killEmpty(cheerioNode) {
	        // Run on children if any
	        var children = cheerioNode.children();
	        children.each(function (i, o) {
	          if (o.tagName in removableTags) {
	            killEmpty(inlinedContent(o));
	          }
	        });
	
	        // Should we delete?
	        if (cheerioNode.contents().length === 0) {
	          cheerioNode.remove();
	          console.log("Removed empty " + cheerioNode.get(0).tagName);
	        }
	      }
	
	      killEmpty(inlinedContent(".root-table"));
	
	      // Remove unnecessary attributes
	      inlinedContent("*[draggable]").attr("draggable", null);
	
	      // Extract text
	      var html = inlinedContent.html();
	
	      // Determine the template BG colour
	      var bgcolor = this.props.rootItem.templateSettings.backgroundColor;
	
	      // Prepend header and footer
	      var withHeaderFooter = '<!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.1//EN" "http://www.w3.org/TR/xhtml11/DTD/xhtml11.dtd">\n' + '<html xmlns="http://www.w3.org/1999/xhtml">\n' + '<head>\n' + '<meta http-equiv="content-type" content="text/html; charset=utf-8" />\n' + '<style type="text/css">div, p, a, li, td { -webkit-text-size-adjust:none; }</style> \n' + '</head>\n' + ("<body style=\"background-color:" + bgcolor + ";\">\n") + html + '\n</body>\n</html>';
	
	      //debugger;
	      // Removes newlines from document
	      withHeaderFooter = withHeaderFooter.replace(/[\n\r]/g, "");
	      //withHeaderFooter = withHeaderFooter.replace(/(.{77})/g, "$1\n");
	      //withHeaderFooter = withHeaderFooter.replace(/(<(?:head|body|table|tbody|tr|td|ol|ul|li|br|p|h[1-6]|\/p|\/td)[^<]*>)/g, "$1\n");
	      //withHeaderFooter = withHeaderFooter.replace(/(<.*?>)/g, "$1\n");
	      //withHeaderFooter = withHeaderFooter.replace(/(<\/?(?:[^<]*>))/g, "$1\n");
	
	
	      // Define Regex objects
	      //let tagRegex = /<\/?[a-zA-Z]+[^>]*?(?:\s*\/)?>/g;
	      var tagRegex = /(<\/?(?:head|body|table|tbody|tr|td|ol|ul|li|br|p|h[1-6])[^<]*>)/g;
	      var attrRegex = /\s+[^\t\n\f />"'=]+="[^"]*"/g;
	
	      withHeaderFooter = withHeaderFooter.replace(tagRegex, function (match) {
	        return match.replace(attrRegex, function (match) {
	          return "\n" + match;
	        }) + "\n";
	      });
	
	      var warnings = "";
	
	      var urlSpaceRegex = /href=(".+(\s|%20)")/;
	
	      var lines = withHeaderFooter.split("\n");
	      for (var i = 0; i < lines.length; i++) {
	        // Determine max line lengths
	        if (lines[i].length > 1000) {
	          warnings += "Line " + (i + 1) + " is longer than 1000 characters.\n";
	        }
	
	        // Find any hyperlinks with a trailing space
	        var testUrlSpaceRegex = urlSpaceRegex.test(lines[i]);
	        if (testUrlSpaceRegex) {
	          var execUrlSpaceRegex = urlSpaceRegex.exec(lines[i]);
	          warnings += "Line " + (i + 1) + ":" + execUrlSpaceRegex.index + ": URL contains trailing whitespace: " + execUrlSpaceRegex[1] + "\n";
	        }
	      }
	
	      return {
	        original: content,
	        inlined: withHeaderFooter,
	        warnings: warnings
	      };
	    }
	  }, {
	    key: "handleImportContent",
	    value: function handleImportContent(content) {
	      this.props.dispatch((0, _actions.setContentItems)(content));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_ExportDialog2.default, {
	        open: this.props.open,
	        visibility: this.props.handleVis,
	        getHtml: this.handleRenderExport,
	        currentState: this.props.currentState,
	        importContent: this.handleImportContent
	      });
	    }
	  }]);
	
	  return ExportDialogContainer;
	}(_react.Component);
	
	function mapStateToExports(state, ownProps) {
	  return {
	    open: ownProps.open,
	    handleVis: ownProps.handleVisibility,
	    currentState: (0, _selectors.getContentState)(state),
	    rootItem: (0, _selectors.getRootItem)(state),
	    state: state
	  };
	}
	
	function mapDispatchToExports(dispatch) {
	  return {
	    dispatch: dispatch
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToExports, mapDispatchToExports)(ExportDialogContainer);

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	var _materialUi = __webpack_require__(34);
	
	var _index = __webpack_require__(151);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by DSadler on 25/04/2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var BuildingBlocks = function (_Component) {
	  _inherits(BuildingBlocks, _Component);
	
	  function BuildingBlocks() {
	    _classCallCheck(this, BuildingBlocks);
	
	    return _possibleConstructorReturn(this, (BuildingBlocks.__proto__ || Object.getPrototypeOf(BuildingBlocks)).apply(this, arguments));
	  }
	
	  _createClass(BuildingBlocks, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var grids = _.map(this.props.contentItemDefCategories, function (configCategory) {
	        var gridItems = _.reject(_.filter(_this2.props.contentItemDefs, { configCategory: configCategory }), { toolboxHide: true });
	        return _react2.default.createElement(
	          _materialUi.GridList,
	          { cols: 4, key: configCategory },
	          _react2.default.createElement(
	            _materialUi.Subheader,
	            null,
	            configCategory
	          ),
	          gridItems.map(function (o) {
	            return _react2.default.createElement(
	              _materialUi.GridTile,
	              {
	                key: o.configId,
	                draggable: true,
	                title: o.configName,
	                onDragStart: function onDragStart(e) {
	                  _this2.props.handleDrag(e, o);
	                },
	                onDragEnd: _this2.props.handleDragEnd
	              },
	              _react2.default.createElement(_index.DeviceWidgets, {
	                style: { width: "100%", height: "100%", color: "grey" }
	              })
	            );
	          })
	        );
	      });
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        grids.map(function (o) {
	          return o;
	        })
	      );
	    }
	  }]);
	
	  return BuildingBlocks;
	}(_react.Component);
	
	exports.default = BuildingBlocks;

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _BuildingBlocks = __webpack_require__(462);
	
	var _BuildingBlocks2 = _interopRequireDefault(_BuildingBlocks);
	
	var _selectors = __webpack_require__(122);
	
	var _reactRedux = __webpack_require__(26);
	
	var _actions = __webpack_require__(56);
	
	var _dragDropDefinitions = __webpack_require__(250);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by DSadler on 25/04/2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var BuildingBlocksContainer = function (_Component) {
	  _inherits(BuildingBlocksContainer, _Component);
	
	  function BuildingBlocksContainer(props) {
	    _classCallCheck(this, BuildingBlocksContainer);
	
	    var _this = _possibleConstructorReturn(this, (BuildingBlocksContainer.__proto__ || Object.getPrototypeOf(BuildingBlocksContainer)).call(this, props));
	
	    _this.handleDrag = _this.handleDrag.bind(_this);
	    _this.handleDragEnd = _this.handleDragEnd.bind(_this);
	    return _this;
	  }
	
	  _createClass(BuildingBlocksContainer, [{
	    key: "handleDrag",
	    value: function handleDrag(e, contentConfig) {
	      e.stopPropagation();
	      //e.preventDefault();
	      this.props.dispatch((0, _actions.setUiSelectedContentItem)(null));
	      this.props.dispatch((0, _actions.setUiDraggedContentItem)(contentConfig));
	      e.dataTransfer.setData(_dragDropDefinitions.DATA_TRANSFER_TYPE.DRAG_TYPE, _dragDropDefinitions.DRAG_TYPE.NEW_ITEM);
	    }
	  }, {
	    key: "handleDragEnd",
	    value: function handleDragEnd(e) {
	      e.stopPropagation();
	      e.preventDefault();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_BuildingBlocks2.default, {
	        contentItemDefs: this.props.contentItemDefs,
	        contentItemDefCategories: this.props.contentItemDefCategories,
	        handleDrag: this.handleDrag,
	        handleDragEnd: this.handleDragEnd
	      });
	    }
	  }]);
	
	  return BuildingBlocksContainer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var contentItemDefs = (0, _selectors.getContentDefinitions)(state);
	  var contentItemDefCategories = (0, _selectors.getContentItemDefCategories)(state);
	  return {
	    contentItemDefs: contentItemDefs,
	    contentItemDefCategories: contentItemDefCategories
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(BuildingBlocksContainer);

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(34);
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 01/05/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ComponentSettings = function (_Component) {
	  _inherits(ComponentSettings, _Component);
	
	  function ComponentSettings(props) {
	    _classCallCheck(this, ComponentSettings);
	
	    var _this = _possibleConstructorReturn(this, (ComponentSettings.__proto__ || Object.getPrototypeOf(ComponentSettings)).call(this, props));
	
	    _this.state = Object.assign({}, props.currentItem);
	    return _this;
	  }
	
	  _createClass(ComponentSettings, [{
	    key: "componentWillReceiveProps",
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState(Object.assign({}, nextProps.currentItem));
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      if (!this.props.currentItem) {
	        return _react2.default.createElement(
	          "div",
	          { style: {
	              width: "100%",
	              textAlign: "center",
	              paddingTop: "50px"
	            } },
	          "Select an item to edit its properties."
	        );
	      }
	
	      var makeToggle = function makeToggle(value, key) {
	        return _react2.default.createElement(_materialUi.Toggle, {
	          key: key,
	          style: { width: "100%" },
	          label: _.upperFirst(_.lowerCase(key)),
	          labelPosition: "right",
	          toggled: value,
	          onClick: function onClick(e) {
	            var o = {};
	            o[key] = !value;
	            _this2.props.update(o);
	          }
	        });
	      };
	
	      var makeText = function makeText(value, key) {
	        return _react2.default.createElement(_materialUi.TextField, {
	          key: key,
	          style: { width: "100%" },
	          multiLine: true
	          //disabled={key.search(/config.+/) >= 0}
	          , floatingLabelText: _.upperFirst(_.lowerCase(key)),
	          value: _.isString(value) ? value : JSON.stringify(value, null, '\t'),
	          onChange: function onChange(e) {
	            var o = {};
	            o[key] = _.isString(value) ? e.currentTarget.value : JSON.parse(e.currentTarget.value);
	            _this2.props.update(o);
	          }
	        });
	      };
	
	      var contentControls = [];
	      _.forOwn(this.props.currentItem, function (value, key) {
	        if (true) {
	          if (_.isBoolean(value)) {
	            contentControls.push(makeToggle(value, key));
	          } else {
	            contentControls.push(makeText(value, key));
	          }
	        }
	      });
	
	      var _props$currentItemDef = this.props.currentItemDefaults,
	          contentId = _props$currentItemDef.contentId,
	          contentParentId = _props$currentItemDef.contentParentId,
	          defaults = _objectWithoutProperties(_props$currentItemDef, ["contentId", "contentParentId"]);
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(_materialUi.RaisedButton, {
	          label: "Reset item configuration",
	          secondary: true,
	          onClick: function onClick(e) {
	            _this2.props.update(defaults);
	          }
	        }),
	        contentControls.map(function (item) {
	          return item;
	        })
	      );
	    }
	  }]);
	
	  return ComponentSettings;
	}(_react.Component);
	
	exports.default = ComponentSettings;

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ComponentSettings = __webpack_require__(464);
	
	var _ComponentSettings2 = _interopRequireDefault(_ComponentSettings);
	
	var _actions = __webpack_require__(54);
	
	var _selectors = __webpack_require__(122);
	
	var _selectors2 = __webpack_require__(55);
	
	var _selectors3 = __webpack_require__(57);
	
	var _reactRedux = __webpack_require__(26);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 01/05/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var ComponentSettingsContainer = function (_Component) {
	  _inherits(ComponentSettingsContainer, _Component);
	
	  function ComponentSettingsContainer(props) {
	    _classCallCheck(this, ComponentSettingsContainer);
	
	    var _this = _possibleConstructorReturn(this, (ComponentSettingsContainer.__proto__ || Object.getPrototypeOf(ComponentSettingsContainer)).call(this, props));
	
	    _this.handleUpdateComponent = _this.handleUpdateComponent.bind(_this);
	    return _this;
	  }
	
	  _createClass(ComponentSettingsContainer, [{
	    key: "handleUpdateComponent",
	    value: function handleUpdateComponent(updates) {
	      if (!this.props.currentItemProps) return;
	      this.props.updateItem(this.props.currentItemProps.contentId, updates, this.props.currentItemProps, this.props.currentItemDefaults);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_ComponentSettings2.default, {
	        currentItem: this.props.currentItemProps ? Object.assign({}, this.props.currentItemDefaults, this.props.currentItemProps) : null,
	        update: this.handleUpdateComponent,
	        currentItemDefaults: this.props.currentItemDefaults
	      });
	    }
	  }]);
	
	  return ComponentSettingsContainer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var currentItem = (0, _selectors3.getUiSelectedItem)(state);
	  var currentItemProps = currentItem ? (0, _selectors2.getContentItem)(state, currentItem.contentId) : null;
	  var currentItemDefaults = currentItemProps ? (0, _selectors.getContentDefinition)(state, currentItemProps.configId) : null;
	  return {
	    currentItemProps: currentItemProps,
	    currentItemDefaults: currentItemDefaults
	  };
	}
	function mapDispatchToProps(dispatch) {
	  return {
	    updateItem: function updateItem(contentId, newProps, oldProps, defaultProps) {
	      return dispatch((0, _actions.updateContentItem)(contentId, newProps, oldProps, defaultProps));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ComponentSettingsContainer);

/***/ },
/* 466 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(34);
	
	var _colors = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 01/05/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var Hierarchy = function (_Component) {
	  _inherits(Hierarchy, _Component);
	
	  function Hierarchy() {
	    _classCallCheck(this, Hierarchy);
	
	    return _possibleConstructorReturn(this, (Hierarchy.__proto__ || Object.getPrototypeOf(Hierarchy)).apply(this, arguments));
	  }
	
	  _createClass(Hierarchy, [{
	    key: "render",
	    value: function render() {
	
	      // Build the list items
	      var props = this.props;
	      function buildListItems(contentItem) {
	        return _react2.default.createElement(_materialUi.ListItem, {
	          key: contentItem.contentId,
	          primaryText: contentItem.contentName ? contentItem.contentName : contentItem.configName,
	          secondaryText: _react2.default.createElement(
	            "div",
	            null,
	            "Type: ",
	            contentItem.configId,
	            _react2.default.createElement("br", null),
	            "ID: ",
	            contentItem.contentId
	          ),
	          secondaryTextLines: 2,
	          open: true
	          //onMouseEnter={() => props.hover(contentItem.contentId)}
	          //onMouseLeave={() => props.hover(null)}
	          , onClick: function onClick() {
	            return props.selected(contentItem.contentId);
	          },
	          nestedItems: contentItem.childItems.map(buildListItems),
	          innerDivStyle: {
	            backgroundColor: props.selectedItem && contentItem.contentId === props.selectedItem.contentId ? _colors.yellow500 : "transparent",
	            padding: "5px 16px 5px"
	          }
	        });
	      }
	
	      return _react2.default.createElement(
	        "div",
	        null,
	        _react2.default.createElement(
	          _materialUi.List,
	          null,
	          buildListItems(this.props.tree)
	        )
	      );
	    }
	  }]);
	
	  return Hierarchy;
	}(_react.Component);
	
	exports.default = Hierarchy;

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRedux = __webpack_require__(26);
	
	var _selectors = __webpack_require__(55);
	
	var _Hierarchy = __webpack_require__(466);
	
	var _Hierarchy2 = _interopRequireDefault(_Hierarchy);
	
	var _actions = __webpack_require__(56);
	
	var _selectors2 = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 01/05/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	var HierarchyContainer = function (_Component) {
	  _inherits(HierarchyContainer, _Component);
	
	  function HierarchyContainer() {
	    _classCallCheck(this, HierarchyContainer);
	
	    return _possibleConstructorReturn(this, (HierarchyContainer.__proto__ || Object.getPrototypeOf(HierarchyContainer)).apply(this, arguments));
	  }
	
	  _createClass(HierarchyContainer, [{
	    key: "render",
	    value: function render() {
	      if (!this.props.contentTree) {
	        return false;
	      }
	      return _react2.default.createElement(_Hierarchy2.default, {
	        tree: this.props.contentTree,
	        hover: this.props.setHover,
	        selected: this.props.setSelected,
	        selectedItem: this.props.selectedItem
	      });
	    }
	  }]);
	
	  return HierarchyContainer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  // Build hierarchy as simple object
	  var root = (0, _selectors.getRootItem)(state);
	  function addChildren(item) {
	    item.childItems = (0, _selectors.getContentItemChildren)(state, item.contentId).map(addChildren);
	    return item;
	  }
	  return {
	    selectedItem: (0, _selectors2.getUiSelectedItem)(state),
	    contentTree: root ? addChildren(root) : null
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return {
	    setHover: function setHover(contentId) {
	      return dispatch((0, _actions.setUiHoveredContentItem)(contentId));
	    },
	    setSelected: function setSelected(contentId) {
	      return dispatch((0, _actions.setUiSelectedContentItem)(contentId));
	    }
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(HierarchyContainer);

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(34);
	
	var _BuildingBlocksContainer = __webpack_require__(463);
	
	var _BuildingBlocksContainer2 = _interopRequireDefault(_BuildingBlocksContainer);
	
	var _ComponentSettingsContainer = __webpack_require__(465);
	
	var _ComponentSettingsContainer2 = _interopRequireDefault(_ComponentSettingsContainer);
	
	var _HierarchyContainer = __webpack_require__(467);
	
	var _HierarchyContainer2 = _interopRequireDefault(_HierarchyContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by DSadler on 25/04/2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var tabStyles = {
	  padding: "20px",
	  height: "calc(100vh - 120px - 40px - 48px)",
	  overflowY: "scroll"
	};
	
	var ToolBox = function (_Component) {
	  _inherits(ToolBox, _Component);
	
	  function ToolBox() {
	    _classCallCheck(this, ToolBox);
	
	    return _possibleConstructorReturn(this, (ToolBox.__proto__ || Object.getPrototypeOf(ToolBox)).apply(this, arguments));
	  }
	
	  _createClass(ToolBox, [{
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(
	        "div",
	        {
	          onClick: this.props.click },
	        _react2.default.createElement(
	          _materialUi.Drawer,
	          {
	            width: 600,
	            openSecondary: true,
	            open: this.props.visible,
	            containerStyle: { top: "0px" }
	          },
	          _react2.default.createElement(
	            _materialUi.Toolbar,
	            null,
	            _react2.default.createElement(
	              _materialUi.ToolbarGroup,
	              { firstChild: true },
	              _react2.default.createElement(
	                _materialUi.IconButton,
	                { tooltip: "Close", iconClassName: "material-icons", onTouchTap: this.props.hide },
	                "close"
	              ),
	              _react2.default.createElement(
	                _materialUi.IconButton,
	                {
	                  tooltip: this.props.pinned ? "Unpin" : "Pin",
	                  iconClassName: "material-icons",
	                  onTouchTap: this.props.pinned ? this.props.unpin : this.props.pin
	                },
	                "place"
	              )
	            )
	          ),
	          _react2.default.createElement(
	            _materialUi.Tabs,
	            {
	              contentContainerStyle: tabStyles,
	              value: this.props.tab,
	              onChange: this.props.changeTab
	            },
	            _react2.default.createElement(
	              _materialUi.Tab,
	              { label: "Building Blocks", value: 0 },
	              "These components can be used to build a template. Drag them into the editor to use them!",
	              _react2.default.createElement(_BuildingBlocksContainer2.default, null)
	            ),
	            _react2.default.createElement(
	              _materialUi.Tab,
	              { label: "Component Settings", value: 1 },
	              "Edit detailed settings for a component below. These settings can easily break stuff so be careful.",
	              _react2.default.createElement(_ComponentSettingsContainer2.default, null)
	            ),
	            _react2.default.createElement(
	              _materialUi.Tab,
	              { label: "Hierarchy", value: 2 },
	              _react2.default.createElement(_HierarchyContainer2.default, null)
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ToolBox;
	}(_react.Component);
	
	exports.default = ToolBox;

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _ToolBox = __webpack_require__(468);
	
	var _ToolBox2 = _interopRequireDefault(_ToolBox);
	
	var _reactRedux = __webpack_require__(26);
	
	var _actions = __webpack_require__(56);
	
	var _selectors = __webpack_require__(57);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by DSadler on 25/04/2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var ToolBoxContainer = function (_Component) {
	  _inherits(ToolBoxContainer, _Component);
	
	  function ToolBoxContainer(props) {
	    _classCallCheck(this, ToolBoxContainer);
	
	    var _this = _possibleConstructorReturn(this, (ToolBoxContainer.__proto__ || Object.getPrototypeOf(ToolBoxContainer)).call(this, props));
	
	    _this.handleOpen = _this.handleOpen.bind(_this);
	    _this.handleClose = _this.handleClose.bind(_this);
	    _this.handlePin = _this.handlePin.bind(_this);
	    _this.handleUnpin = _this.handleUnpin.bind(_this);
	    _this.handleChangeTab = _this.handleChangeTab.bind(_this);
	    _this.handleOnClick = _this.handleOnClick.bind(_this);
	    return _this;
	  }
	
	  _createClass(ToolBoxContainer, [{
	    key: "handleOpen",
	    value: function handleOpen() {
	      this.props.dispatch((0, _actions.setUiToolboxVisibility)(true));
	    }
	  }, {
	    key: "handleClose",
	    value: function handleClose() {
	      this.props.dispatch((0, _actions.setUiToolboxVisibility)(false));
	    }
	  }, {
	    key: "handlePin",
	    value: function handlePin() {
	      this.props.dispatch((0, _actions.setUiToolboxPinned)(true));
	    }
	  }, {
	    key: "handleUnpin",
	    value: function handleUnpin() {
	      this.props.dispatch((0, _actions.setUiToolboxPinned)(false));
	    }
	  }, {
	    key: "handleChangeTab",
	    value: function handleChangeTab(tab) {
	      this.props.dispatch((0, _actions.setUiToolboxActiveTab)(tab));
	    }
	  }, {
	    key: "handleOnClick",
	    value: function handleOnClick(e) {
	      e.preventDefault();
	      e.stopPropagation();
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return _react2.default.createElement(_ToolBox2.default, {
	        visible: this.props.toolbarVisible,
	        pinned: this.props.toolbarPinned,
	        tab: this.props.activeTab,
	        changeTab: this.handleChangeTab,
	        show: this.handleOpen,
	        hide: this.handleClose,
	        pin: this.handlePin,
	        unpin: this.handleUnpin,
	        click: this.handleOnClick
	      });
	    }
	  }]);
	
	  return ToolBoxContainer;
	}(_react.Component);
	
	function mapStateToProps(state) {
	  var toolbarVisible = (0, _selectors.getUiToolboxVisibility)(state);
	  var toolbarPinned = (0, _selectors.getUiToolboxPinned)(state);
	  var activeTab = (0, _selectors.getUiToolboxActiveTab)(state);
	
	  return {
	    toolbarVisible: toolbarVisible,
	    toolbarPinned: toolbarPinned,
	    activeTab: activeTab
	  };
	}
	
	function mapDispatchToProps(dispatch) {
	  return { dispatch: dispatch };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(ToolBoxContainer);

/***/ },
/* 470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Editor = __webpack_require__(444);
	
	var _Editor2 = _interopRequireDefault(_Editor);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Editor2.default; /**
	                                     * Created by DSadler on 12/04/2017.
	                                     */

/***/ },
/* 471 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.configSetContentDefinitions = configSetContentDefinitions;
	exports.configResetContentDefinitions = configResetContentDefinitions;
	/**
	 * Created by daniel on 23/04/17.
	 */
	
	var CONFIG_SET_CONTENT_DEFINITIONS = exports.CONFIG_SET_CONTENT_DEFINITIONS = "CONFIG_SET_CONTENT_DEFINITIONS";
	var CONFIG_RESET_CONTENT_DEFINITIONS = exports.CONFIG_RESET_CONTENT_DEFINITIONS = "CONFIG_RESET_CONTENT_DEFINITIONS";
	
	function configSetContentDefinitions(contentDefinitions) {
	  return {
	    type: CONFIG_SET_CONTENT_DEFINITIONS,
	    contentDefinitions: contentDefinitions
	  };
	}
	
	function configResetContentDefinitions() {
	  return {
	    type: CONFIG_RESET_CONTENT_DEFINITIONS
	  };
	}

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CONTENT_DEFINITIONS = undefined;
	
	var _constants = __webpack_require__(249);
	
	/**
	 * Created by DSadler on 19/04/2017.
	 */
	
	/* Define content component types */
	var CONTENT_TYPES = {
	  CELL_ITEM: "CELL_ITEM",
	  ROW_ITEM: "ROW_ITEM",
	  TABLE_ITEM: "TABLE_ITEM",
	  RICH_TEXT: "RICH_TEXT",
	  IMAGE_ITEM: "IMAGE_ITEM",
	  TOC_ITEM: "TOC_ITEM",
	  MAIN_ROW: "MAIN_ROW",
	  COLUMN: "COLUMN"
	};
	
	/* eslint-disable no-unused-vars */
	/**
	 * Created by DSadler on 20/04/2017.
	 *
	 * This file sets the base definitions for content items. These include all of the UI information to show these in the
	 * interface, as well as the base style definitions to create the elements. These also provide part of the default
	 * information for elements to fall back on if reset. Primitive components are not opinionated - they will do exactly
	 * what they are told. Therefore base styles and resets must be set correctly here.
	 *
	 * Resetting a components' styles will make it revert to its item definition. These can be overridden using JSON in the
	 * the editor, however this is an additive merge (not replacement), so that defaults can still exist.
	 *
	 * Composite elements can also be defined here, by nesting child elements. Note that these child elements must each
	 * correspond to an item definition, because these composites are just a way of creating multiple items at once.
	 *
	 * The initial state here is defined using javascript to make cross-linking easier; obviously not possible in JSON.
	 *
	 * Definition hierarchy:
	 *
	 * Primitive component -> Item definition -> Item state
	 *
	 * Components calculate their state in this order. State always wins, and merges are not destructive - passing null
	 * does not wipe a property, you need to pass an empty item to overwrite.
	 *
	 */
	
	var COLOURS = {
	  abiMidnightBlue: "#230052",
	  abiPurple: "#7f58a5",
	  abiBlue: "#6e9bb0",
	  abiRed: "#ce0c4e",
	  abiOrange: "#f26334",
	  abiGreen: "#a8ad2c",
	  black: "#231f20",
	  grey: "#939596",
	  aqua: "#53c0a5",
	  stone: "#c59872",
	  mauve: "#7f2c72",
	  yellow: "#fcb316"
	};
	
	var FONTS = {
	  core: "arial, sans-serif",
	  accent: "times new roman, serif"
	};
	
	var FONT_SIZES = {
	  headings: "26px",
	  body: "12px",
	  small: "10px"
	};
	
	var LINE_HEIGHTS = {
	  headings: "34px",
	  body: "18px",
	  small: "normal"
	};
	/* eslint-enable no-unused-vars */
	
	/**
	 * The default built-in content definitions
	 * @type {Array.<ContentDefinition>}
	 */
	var CONTENT_DEFINITIONS = function () {
	
	  /**** Primitive Definitions ****/
	
	  var TABLE_ITEM = Object.assign({}, _constants.BASE_DEFINITION, {
	    configId: "TABLE_ITEM",
	    configName: "Table",
	    configDescription: "A basic unstyled table, for containing rows. Will collapse to the size of the smallest element.",
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.STRUCTURAL_COMPONENTS,
	    configPrimitive: CONTENT_TYPES.TABLE_ITEM,
	    editorAllowedParents: [{
	      configPrimitive: CONTENT_TYPES.CELL_ITEM
	    }],
	    viewAttributes: {
	      "border": 0,
	      "cellPadding": 0,
	      "cellSpacing": 0
	    },
	    viewClass: "table-item"
	  });
	
	  var ROW_ITEM = Object.assign({}, _constants.BASE_DEFINITION, {
	    configId: "ROW_ITEM",
	    configName: "Row",
	    configDescription: "A basic unstyled row container, should be placed in a table item.",
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.STRUCTURAL_COMPONENTS,
	    configPrimitive: CONTENT_TYPES.ROW_ITEM,
	    editorAllowedParents: [{
	      configPrimitive: CONTENT_TYPES.TABLE_ITEM
	    }, {
	      configId: "COLUMN"
	    }],
	    viewAttributes: {
	      align: "center",
	      valign: "top"
	    },
	    viewClass: "row-item"
	    //styleTextAlignment: "center",
	  });
	
	  var CELL_ITEM = Object.assign({}, _constants.BASE_DEFINITION, {
	    configId: "CELL_ITEM",
	    configName: "Cell",
	    configDescription: "A basic unstyled content cell, should be placed in a table row.",
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.STRUCTURAL_COMPONENTS,
	    configPrimitive: CONTENT_TYPES.CELL_ITEM,
	    viewAttributes: {
	      valign: "top",
	      align: "center"
	    },
	    viewClass: "cell-item",
	    editorAllowedParents: [{
	      configPrimitive: CONTENT_TYPES.ROW_ITEM
	    }, {
	      configPrimitive: CONTENT_TYPES.MAIN_ROW
	    }]
	  });
	
	  var IMAGE_ITEM = Object.assign({}, _constants.BASE_DEFINITION, {
	    configId: "IMAGE_ITEM",
	    configName: "Image",
	    configDescription: "A single image, selectable from the image library or setting manually",
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.STANDARD_COMPONENTS,
	    configPrimitive: CONTENT_TYPES.IMAGE_ITEM,
	    editorAllowedParents: [{
	      configPrimitive: CONTENT_TYPES.ROW_ITEM
	    }, {
	      configPrimitive: CONTENT_TYPES.MAIN_ROW
	    }],
	    viewClass: "image-item",
	    contentContent: {},
	    styleAltText: "",
	    stylePadding: "Not supported on images - nest the item in a table"
	  });
	
	  var RICH_TEXT = Object.assign({}, CELL_ITEM, {
	    configId: "RICH_TEXT",
	    configName: "Text",
	    configDescription: "A rich text component for arbitrary content.",
	    contentContent: "<p>Click here to enter text.</p>",
	    configPrimitive: CONTENT_TYPES.RICH_TEXT,
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.STANDARD_COMPONENTS,
	    viewAttributes: {
	      table: {
	        borderSpacing: 0
	      },
	      td: {
	        valign: "top"
	      }
	    },
	    viewClass: "rich-text",
	    configEditorType: "full",
	    configEditorRoot: "p"
	  });
	
	  var TOC_ITEM = Object.assign({}, CELL_ITEM, {
	    configId: "TOC_ITEM",
	    configName: "ToC",
	    configDescription: "A dynamic table of contents element",
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.DYNAMIC_COMPONENT,
	    configPrimitive: CONTENT_TYPES.TOC_ITEM,
	    viewClass: "toc-item",
	    viewCss: {
	      "p": {
	        "margin": "0 0 5px 0",
	        "font-size": "12px"
	      }
	    }
	  });
	
	  /**** Abstracted Elements ****/
	
	  // The root item controls most of the default styles.
	  var ROOT_ITEM = Object.assign({}, TABLE_ITEM, {
	    toolboxHide: true,
	    configId: "ROOT_ITEM",
	    configName: "Template root element",
	    configDescription: "This is the root element of the template. There should only be one, so don't try to copy it!",
	    editorAllowedParents: [],
	    contentIsRoot: true,
	    editorSelectable: true,
	    editorDraggable: false,
	    editorDragTarget: true,
	    editorHideable: false,
	    editorCloneable: false,
	    editorDeletable: false,
	    editorSaveable: false,
	    templateSettings: {
	      backgroundColor: "#eeeeee"
	    },
	    viewClass: TABLE_ITEM.viewCss + " root-table",
	    viewCss: {
	      " ": {
	        "Margin": "0",
	        "border-spacing": "0",
	        "font-family": "arial, sans-serif",
	        "font-size": "14px",
	        "line-height": "18px",
	        "color": "#231f20",
	        "background-color": "#eeeeee",
	        "width": "100%",
	        "height": "100%",
	        "border-width": 0
	      },
	      // Basic elements
	      "table, tr, td": {
	        "font-family": "arial, sans-serif",
	        "font-size": "14px",
	        "line-height": "18px",
	        "color": "#231f20"
	      },
	      "table": {
	        "border-spacing": 0,
	        "border-collapse": "collapse",
	        "width": "100%"
	      },
	      "td": {
	        "padding-top": 0,
	        "padding-right": 0,
	        "padding-bottom": 0,
	        "padding-left": 0
	      },
	      "tr": {},
	      "a[href]": {
	        "color": "#7f58a5",
	        "text-decoration": "underline"
	      },
	      // Reset margins
	      "h1, h2, h3, h4, h5, h6, p, ul, ol, li, hr": {
	        "Margin-top": 0,
	        "Margin-right": 0,
	        "Margin-bottom": "5px",
	        "Margin-left": 0
	      },
	      // Headers
	      "h1, h2, h3, h4, h5, h6": {
	        "font-weight": "normal",
	        "font-size": "18px",
	        "line-height": "24px"
	        //"color": "#7f58a5",
	      },
	      "h1": {
	        "font-size": "26px",
	        "line-height": "36px"
	        //"color": "#ffffff"
	      },
	      "h2": {
	        "font-size": "24px"
	        //"line-height": "34px",
	      },
	      // Regular content
	      "p, ul, ol": {
	        "Margin-bottom": "20px"
	      },
	      "p:last-of-type": {
	        "Margin-bottom": 0
	      },
	      "hr": {
	        "color": "#000000"
	      },
	      // Hacks
	      "img": {
	        "display": "block",
	        "margin-top": 0,
	        "margin-right": 0,
	        "margin-bottom": 0,
	        "margin-left": 0,
	        "padding-top": 0,
	        "padding-right": 0,
	        "padding-bottom": 0,
	        "padding-left": 0
	      },
	      "ul": { "list-style-type": "disc" },
	      "ul > li > ul": { "list-style-type": "circle" },
	      "ul > li > ul > li > ul": { "list-style-type": "square" },
	
	      "ol": { "list-style-type": "disc" },
	      "ol > li > ol": { "list-style-type": "circle" },
	      "ol > li > ol > li > ol": { "list-style-type": "square" },
	
	      "li": { "margin-left": "25px" },
	      "li > ul, li > ol": { "margin-bottom": "5px" },
	
	      "p a": {
	        "Margin": "inherit",
	        "Margin-left": 0,
	        "Margin-right": 0
	      },
	
	      "strong, b": { "font-weight": "bold" },
	      "em, i": { "font-style": "italic" },
	      "u": { "text-decoration": "underline" },
	      "s": { "text-decoration": "line-through" },
	
	      "sup, sub": { "font-size": "0.8em" },
	      "sup": { "vertical-align": "super" },
	      "sub": { "vertical-align": "sub" },
	
	      // Editor elements
	      ".full-width": {
	        "width": "100%"
	      },
	      ".small": {
	        "font-size": "10px",
	        "line-height": "11px"
	      },
	      ".editable": {
	        "text-align": "left",
	        "padding-top": "10px",
	        "padding-right": "20px",
	        "padding-bottom": "10px",
	        "padding-left": "20px"
	      },
	      ".editable *": {
	        "padding-top": 0,
	        "padding-right": 0,
	        "padding-bottom": 0,
	        "padding-left": 0
	      },
	      ".section-content-container": {
	        "width": "620px",
	        "background-color": "#ffffff"
	      }
	    }
	  });
	
	  var SECTION = Object.assign({}, _constants.BASE_DEFINITION, {
	    configId: "SECTION",
	    configName: "Section",
	    configDescription: "A basic content section.",
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.STRUCTURAL_COMPONENTS,
	    configPrimitive: CONTENT_TYPES.MAIN_ROW,
	    editorAllowedParents: [{
	      configId: "ROOT_ITEM"
	    }],
	    viewClass: "main-row"
	  });
	
	  var COLUMN = Object.assign({}, _constants.BASE_DEFINITION, {
	    configId: "COLUMN",
	    configName: "Column",
	    configDescription: "A single content column - only necessary for multiple nested rows.",
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.STRUCTURAL_COMPONENTS,
	    configPrimitive: CONTENT_TYPES.COLUMN,
	    editorAllowedParents: [{
	      configId: "SECTION"
	    }],
	    viewClass: "content-column"
	  });
	
	  var MAIN_ROW = Object.assign({}, ROW_ITEM, {
	    toolboxHide: true,
	    configId: "MAIN_ROW",
	    configName: "Template section",
	    configDescription: "A main section for the template. Automatically generates several subcomponents.",
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.STANDARD_COMPONENTS,
	    editorAllowedParents: [{
	      configId: "ROOT_ITEM"
	    }],
	    viewClass: "main-row",
	    editorDragTarget: false,
	    configChildren: [{
	      configId: "CELL_ITEM",
	      editorLocked: true,
	      configChildren: [{
	        configId: "TABLE_ITEM",
	        viewClass: "full-width",
	        editorLocked: true,
	        configChildren: [{
	          configId: "ROW_ITEM",
	          editorLocked: true,
	          configChildren: [{
	            configId: "CELL_ITEM",
	            editorLocked: true,
	            configChildren: [{
	              configId: "TABLE_ITEM",
	              styleWidth: "620px",
	              styleBackgroundColour: "#ffffff",
	              editorLocked: true,
	              configChildren: [{
	                configId: "ROW_ITEM",
	                editorSelectable: false,
	                editorDraggable: false,
	                editorHideable: false,
	                editorCloneable: false,
	                editorDeletable: false,
	                editorEditable: false,
	                editorSaveable: false
	              }]
	            }]
	          }]
	        }]
	      }]
	    }]
	  });
	
	  var SECTION_HEADER = Object.assign({}, RICH_TEXT, {
	    configId: "SECTION_HEADER",
	    configName: "Header",
	    configDescription: "A simple header to place at the top of each section",
	    configEditorType: "basic",
	    configEditorRoot: "h2",
	    contentContent: "<h2>Header Text</h2>",
	    styleTextColour: "#6e9bb0",
	    viewClass: RICH_TEXT.viewClass + " section-header"
	  });
	
	  var AUTHOR_BLOCK = Object.assign({}, CELL_ITEM, {
	    configId: "AUTHOR_BLOCK",
	    configName: "Author",
	    configDescription: "A block to display the author of this email",
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.STANDARD_COMPONENTS,
	    stylePadding: "20px",
	    viewCss: {
	      "p": {
	        "font-size": "12px"
	      }
	    },
	    viewClass: CELL_ITEM.viewClass + " author-block",
	    configChildren: [{
	      configId: "TABLE_ITEM",
	      editorLocked: true,
	      configChildren: [{
	        configId: "ROW_ITEM",
	        editorLocked: true,
	        configChildren: [{
	          configId: "IMAGE_ITEM",
	          editorLocked: false,
	          editorDraggable: false,
	          styleTextAlignment: "left",
	          styleWidth: "120px",
	          configChildren: []
	        }]
	      }, {
	        configId: "ROW_ITEM",
	        editorLocked: true,
	        configChildren: [{
	          configId: "RICH_TEXT",
	          editorLocked: false,
	          editorDraggable: false,
	          contentContent: "<p><strong>Author</strong><br/>Job Title</p>",
	          stylePadding: "5px 0",
	          configChildren: []
	        }]
	      }]
	    }]
	  });
	
	  var TEAM_MEMBER_ITEM = Object.assign({}, CELL_ITEM, {
	    configId: "TEAM_MEMBER_ITEM",
	    configName: "Team Member",
	    configDescription: "A block to display a team member",
	    configCategory: _constants.CONTENT_DEFINITION_CATEGORIES.STANDARD_COMPONENTS,
	    stylePadding: "20px",
	    viewCss: {
	      "p": {
	        "font-size": "12px"
	      }
	    },
	    viewClass: CELL_ITEM.viewClass + " team-member-item",
	    configChildren: [{
	      configId: "TABLE_ITEM",
	      editorLocked: true,
	      styleWidth: "160px",
	      configChildren: [{
	        configId: "ROW_ITEM",
	        editorLocked: true,
	        configChildren: [{
	          configId: "IMAGE_ITEM",
	          editorLocked: false,
	          editorDraggable: false,
	          styleWidth: "120px",
	          configChildren: []
	        }]
	      }, {
	        configId: "ROW_ITEM",
	        editorLocked: true,
	        configChildren: [{
	          configId: "RICH_TEXT",
	          editorLocked: false,
	          editorDraggable: false,
	          styleTextAlignment: "center",
	          contentContent: "<p><strong>Author</strong><br/>Job Title<br/><a href='mailto:email@abi.org.uk'>email@abi.org.uk</a></p>",
	          stylePadding: "5px 0",
	          configChildren: []
	        }]
	      }]
	    }]
	  });
	
	  return [TABLE_ITEM, ROW_ITEM, CELL_ITEM, IMAGE_ITEM, ROOT_ITEM, MAIN_ROW, RICH_TEXT, SECTION_HEADER, TOC_ITEM, AUTHOR_BLOCK, TEAM_MEMBER_ITEM, SECTION, COLUMN];
	}();
	
	exports.CONTENT_DEFINITIONS = CONTENT_DEFINITIONS;

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.config = config;
	
	var _actions = __webpack_require__(471);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _itemDefinitions = __webpack_require__(472);
	
	var _constants = __webpack_require__(249);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function contentDefinitions(stateContentDefinitions, action) {
	  debugger;
	  switch (action.type) {
	    case actions.CONFIG_SET_CONTENT_DEFINITIONS:
	      return action.contentDefinitions;
	    case actions.CONFIG_RESET_CONTENT_DEFINITIONS:
	      return _itemDefinitions.CONTENT_DEFINITIONS;
	    default:
	      return stateContentDefinitions;
	  }
	} /**
	   * Created by daniel on 23/04/17.
	   */
	
	function config() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
	    contentDefinitions: _itemDefinitions.CONTENT_DEFINITIONS,
	    contentDefinitionCategories: _constants.CONTENT_DEFINITION_CATEGORIES,
	    colors: _constants.COLORS
	  };
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.CONFIG_SET_CONTENT_DEFINITIONS:
	    case actions.CONFIG_RESET_CONTENT_DEFINITIONS:
	      return Object.assign({}, state, { contentDefinitions: contentDefinitions(state.contentDefinitions, action) });
	    default:
	      return state;
	  }
	}

/***/ },
/* 474 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.content = content;
	
	var _actions = __webpack_require__(54);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _shortid = __webpack_require__(1991);
	
	var shortid = _interopRequireWildcard(_shortid);
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; } /**
	                                                                                                                                                                                                                              * Created by daniel on 23/04/17.
	                                                                                                                                                                                                                              */
	
	function modifyItem(contentItem, action) {
	  switch (action.type) {
	    case actions.ORPHAN_CONTENT_ITEM:
	      // Just null the contentItem's parentId, recording the old one
	      contentItem.contentOldParentId = contentItem.contentParentId;
	      contentItem.contentParentId = null;
	      return contentItem;
	
	    case actions.RESTORE_ORPHANED_CONTENT_ITEM:
	      contentItem.contentParentId = contentItem.contentOldParentId;
	      contentItem.contentOldParentId = null;
	      return contentItem;
	
	    case actions.UPDATE_CONTENT_ITEM:
	      return function (contentItem, _ref) {
	        var newProps = _ref.newProps,
	            oldProps = _ref.oldProps,
	            defaultProps = _ref.defaultProps;
	
	        // Easy bit - check if any change at all.
	        if (JSON.stringify(oldProps) === JSON.stringify(newProps)) return contentItem;
	
	        // Construct a new item by comparing new state to defaults
	        var newState = Object.assign({}, oldProps, newProps);
	        var newItem = {};
	        _.forOwn(defaultProps, function (val, key) {
	          if (!_.has(newState, key)) return;
	          var equal = _.isEqual(newState[key], val);
	          if (equal && key !== "contentId" && key !== "contentIsRoot" && key !== "contentParentId" && key !== "configId") return;
	          newItem[key] = newState[key];
	        });
	        // Add back in bare minimum props and return
	        return newItem;
	      }(contentItem, action);
	
	    case actions.HIDE_CONTENT_ITEM:
	      return function (contentItem, _ref2) {
	        var contentHidden = _ref2.contentHidden;
	
	        return Object.assign({}, contentItem, {
	          contentHidden: contentHidden
	        });
	      }(contentItem, action);
	    default:
	      return contentItem;
	  }
	}
	
	function content() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  // State is the content array
	  var contentArr = JSON.parse(JSON.stringify(state)); // Make sure we don't mutate anything.
	
	  switch (action.type) {
	    case actions.CREATE_CONTENT_ITEM:
	      var makeItem = function makeItem(content, config, contentParentId, relativeToContentId, moveBelow) {
	        var template = _.head(_.filter(action.contentDefs, { configId: config.configId }));
	        // merge with passed def so we retain children (if any). Passed def overrides template.
	        //let mergedTemplate = {...template, ...config};
	        var mergedTemplate = _.defaultsDeep(JSON.parse(JSON.stringify(config)), template);
	
	        var configChildren = config.configChildren,
	            configChildless = _objectWithoutProperties(config, ["configChildren"]);
	
	        var item = Object.assign({}, configChildless, {
	          contentId: shortid.generate(),
	          contentIsRoot: mergedTemplate.contentIsRoot,
	          contentParentId: contentParentId,
	          configId: config.configId
	        });
	        if (relativeToContentId) {
	          if (!moveBelow) {
	            var _target = _.findIndex(content, { contentId: relativeToContentId });
	            var top = content.slice(0, _target);
	            var bottom = content.slice(_target);
	            content = top.concat([item], bottom);
	          } else if (moveBelow) {
	            var _target2 = _.findIndex(content, { contentId: relativeToContentId });
	            var _top = content.slice(0, _target2 + 1);
	            var _bottom = content.slice(_target2 + 1);
	            content = _top.concat([item], _bottom);
	          }
	        } else {
	          content.push(item);
	        }
	
	        if (mergedTemplate.configChildren) {
	          mergedTemplate.configChildren.map(function (child) {
	            // These are always produced in order, so leave aboveContentId blank
	            return makeItem(content, child, item.contentId);
	          });
	        }
	        return content;
	      };
	
	      return makeItem(contentArr, { configId: action.configId }, action.contentParentId, action.relativeToContentId, action.moveBelow);
	
	    case actions.ORPHAN_CONTENT_ITEM:
	    case actions.RESTORE_ORPHANED_CONTENT_ITEM:
	    case actions.UPDATE_CONTENT_ITEM:
	    case actions.HIDE_CONTENT_ITEM:
	      var itemKey = _.findIndex(contentArr, { contentId: action.contentId });
	      contentArr[itemKey] = modifyItem(contentArr[itemKey], action);
	      return contentArr;
	
	    case actions.DELETE_CONTENT_ITEM:
	      var deleteItem = function deleteItem(contentId) {
	        _.remove(contentArr, { contentId: contentId });
	        var children = _.filter(contentArr, { contentParentId: contentId });
	        children.map(function (o) {
	          return deleteItem(o.contentId);
	        });
	      };
	
	      deleteItem(action.contentId);
	      return contentArr;
	
	    case actions.MOVE_CONTENT_ITEM:
	      return function (content, _ref3) {
	        var contentId = _ref3.contentId,
	            contentParentId = _ref3.contentParentId,
	            relativeToContentId = _ref3.relativeToContentId,
	            moveBelow = _ref3.moveBelow;
	
	        var item = _.head(_.remove(content, { contentId: contentId }));
	        if (contentParentId) {
	          item.contentParentId = contentParentId;
	        }
	
	        if (relativeToContentId && !moveBelow) {
	          var _target3 = _.findIndex(content, { contentId: relativeToContentId });
	          var top = content.slice(0, _target3);
	          var bottom = content.slice(_target3);
	          content = top.concat([item], bottom);
	        } else if (relativeToContentId && moveBelow) {
	          var _target4 = _.findIndex(content, { contentId: relativeToContentId });
	          var _top2 = content.slice(0, _target4 + 1);
	          var _bottom2 = content.slice(_target4 + 1);
	          content = _top2.concat([item], _bottom2);
	        } else {
	          content.push(item);
	        }
	        return content;
	      }(contentArr, action);
	
	    case actions.SET_CONTENT_ITEMS:
	      return action.content;
	    default:
	      return contentArr;
	  }
	}

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.editor = undefined;
	
	var _redux = __webpack_require__(121);
	
	var _reducers = __webpack_require__(473);
	
	var _reducers2 = __webpack_require__(476);
	
	var _reducers3 = __webpack_require__(474);
	
	var _reduxUndo = __webpack_require__(436);
	
	var _reduxUndo2 = _interopRequireDefault(_reduxUndo);
	
	var _actions = __webpack_require__(54);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Created by daniel on 16/04/17.
	 */
	
	var editor = exports.editor = (0, _redux.combineReducers)({
	  content: (0, _reduxUndo2.default)(_reducers3.content, {
	    filter: (0, _reduxUndo.includeAction)([actions.CREATE_CONTENT_ITEM, actions.CREATE_CONTENT_ITEM, actions.DELETE_CONTENT_ITEM, actions.ORPHAN_CONTENT_ITEM, actions.RESTORE_ORPHANED_CONTENT_ITEM, actions.MOVE_CONTENT_ITEM, actions.UPDATE_CONTENT_ITEM, actions.HIDE_CONTENT_ITEM, actions.SET_CONTENT_ITEMS])
	  }),
	  ui: _reducers2.ui,
	  config: _reducers.config
	});

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ui = ui;
	
	var _actions = __webpack_require__(56);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var initialState = {
	  hoveredItem: null,
	  selectedItem: null,
	  draggedItem: null,
	  dropzoneCoords: null,
	  toolboxVisible: true,
	  toolboxPinned: true,
	  toolboxTab: 0
	}; /**
	    * Created by daniel on 23/04/17.
	    */
	
	function ui() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.SET_UI_HOVERED_CONTENT_ITEM:
	      return Object.assign({}, state, { hoveredItem: action.contentId });
	    case actions.SET_UI_SELECTED_CONTENT_ITEM:
	      var contentId = action.contentId;
	
	      return Object.assign({}, state, { selectedItem: action.contentId ? { contentId: contentId } : null });
	    case actions.SET_UI_DRAGGED_CONTENT_ITEM:
	      return Object.assign({}, state, { draggedItem: action.contentItem });
	    case actions.SET_UI_DROPZONE_COORDS:
	      return Object.assign({}, state, { dropzoneCoords: action.coords });
	    case actions.SET_UI_TOOLBOX_VISIBILITY:
	      return Object.assign({}, state, { toolboxVisible: action.visible });
	    case actions.SET_UI_TOOLBOX_PINNED:
	      return Object.assign({}, state, { toolboxPinned: action.pinned });
	    case actions.SET_UI_TOOLBOX_ACTIVETAB:
	      return Object.assign({}, state, { toolboxTab: action.tab });
	    default:
	      return state;
	  }
	}

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(34);
	
	var _colors = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 11/04/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var Homepage = function (_Component) {
	  _inherits(Homepage, _Component);
	
	  function Homepage() {
	    _classCallCheck(this, Homepage);
	
	    return _possibleConstructorReturn(this, (Homepage.__proto__ || Object.getPrototypeOf(Homepage)).apply(this, arguments));
	  }
	
	  _createClass(Homepage, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        "div",
	        { style: {
	            textAlign: "center",
	            display: "flex",
	            flexDirection: "column",
	            height: "100%"
	          } },
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              width: "100%",
	              //height: "15vh",
	              backgroundColor: _colors.blue500,
	              textAlign: "center"
	              //lineHeight: "calc(15vh - 32px)",
	            }
	          },
	          _react2.default.createElement(
	            "h1",
	            { style: {
	                margin: 0,
	                padding: "0 0 64px 0",
	                fontWeight: "normal",
	                fontSize: "60px",
	                color: "#ffffff"
	              }
	            },
	            "ABI HTML Email Editor"
	          )
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              margin: "0 auto",
	              padding: "32px",
	              fontSize: "40px",
	              color: "#222222"
	            }
	          },
	          "Select a template"
	        ),
	        _react2.default.createElement(
	          "div",
	          {
	            style: {
	              margin: "0 auto",
	              flex: "0 1 auto",
	              overflow: "auto",
	              padding: "0 0 10px 0"
	              //height: "100%"
	              //width: "400px"
	            }
	          },
	          _react2.default.createElement(
	            _materialUi.Paper,
	            {
	              style: {
	                width: "400px",
	                margin: "0 auto"
	              }
	            },
	            _react2.default.createElement(
	              _materialUi.List,
	              null,
	              _react2.default.createElement(_materialUi.ListItem, {
	                primaryText: "Empty Template",
	                secondaryText: "A completely empty editor - good luck!",
	                secondaryTextLines: 2,
	                onTouchTap: function onTouchTap() {
	                  return _this2.props.route.history.push("/editor");
	                }
	              }),
	              _react2.default.createElement(_materialUi.ListItem, {
	                primaryText: "Basic Newsletter",
	                secondaryText: "An empty newsletter template, with slots for the author and team members",
	                secondaryTextLines: 2,
	                onTouchTap: function onTouchTap() {
	                  return _this2.props.route.history.push("/editor/create/template/default");
	                }
	              }),
	              _react2.default.createElement(_materialUi.ListItem, {
	                primaryText: "Events Marketing",
	                secondaryText: "A sample event mailing",
	                secondaryTextLines: 2,
	                onTouchTap: function onTouchTap() {
	                  return _this2.props.route.history.push("/editor/create/template/events");
	                }
	              }),
	              _react2.default.createElement(_materialUi.ListItem, {
	                primaryText: "Events - Keynote Speakers",
	                secondaryText: "Events marketing template for publicising keynote speakers",
	                secondaryTextLines: 2,
	                onTouchTap: function onTouchTap() {
	                  return _this2.props.route.history.push("/editor/create/template/eventskeynote");
	                }
	              }),
	              _react2.default.createElement(_materialUi.ListItem, {
	                primaryText: "Associate Members",
	                secondaryText: "Base associate members' newsletter",
	                secondaryTextLines: 2,
	                onTouchTap: function onTouchTap() {
	                  return _this2.props.route.history.push("/editor/create/template/associatemembers");
	                }
	              }),
	              _react2.default.createElement(_materialUi.ListItem, {
	                primaryText: "Outlook Email",
	                secondaryText: "A plain email imitating a standard Outlook message, with customisable signature",
	                secondaryTextLines: 2,
	                onTouchTap: function onTouchTap() {
	                  return _this2.props.route.history.push("/editor/create/template/plainoutlook");
	                }
	              })
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return Homepage;
	}(_react.Component);
	
	exports.default = Homepage;

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _Homepage = __webpack_require__(477);
	
	var _Homepage2 = _interopRequireDefault(_Homepage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Homepage2.default; /**
	                                       * Created by DSadler on 12/04/2017.
	                                       */

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _selectors = __webpack_require__(485);
	
	var _reactRedux = __webpack_require__(26);
	
	var _materialUi = __webpack_require__(34);
	
	__webpack_require__(570);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by daniel on 02/05/17.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	// Renders a dialog that allows a user to pick an image, and fire a callback
	// Remember to close the dialog in the callback!
	
	var ImageBrowser = function (_Component) {
	  _inherits(ImageBrowser, _Component);
	
	  function ImageBrowser(props) {
	    _classCallCheck(this, ImageBrowser);
	
	    var _this = _possibleConstructorReturn(this, (ImageBrowser.__proto__ || Object.getPrototypeOf(ImageBrowser)).call(this, props));
	
	    _this.state = {
	      selectedPicture: props.currentImage
	    };
	    return _this;
	  }
	
	  _createClass(ImageBrowser, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      var actions = [_react2.default.createElement(_materialUi.FlatButton, {
	        label: "Cancel",
	        primary: true,
	        onTouchTap: function onTouchTap() {
	          return _this2.props.callback(null);
	        }
	      }), _react2.default.createElement(_materialUi.FlatButton, {
	        label: "Choose Picture",
	        primary: true,
	        disabled: !this.state.selectedPicture,
	        onTouchTap: function onTouchTap() {
	          return _this2.props.callback(_this2.state.selectedPicture);
	        }
	      })];
	
	      return _react2.default.createElement(
	        _materialUi.Dialog,
	        {
	          className: "image-browser-dialog",
	          open: this.props.open,
	          title: "Select an image, or input an image URL",
	          modal: true,
	          actions: actions
	        },
	        _react2.default.createElement(
	          _materialUi.GridList,
	          {
	            cols: 3,
	            style: {
	              height: "50vh",
	              overflowY: 'auto',
	              padding: "5px"
	            }
	          },
	          this.props.images.map(function (item) {
	
	            return _react2.default.createElement(
	              _materialUi.GridTile,
	              {
	                className: "grid-item",
	                key: item.imageId,
	                title: item.imageAlt,
	                style: {
	                  cursor: "pointer",
	                  opacity: _this2.state.selectedPicture && _this2.state.selectedPicture.imageUrl && _this2.state.selectedPicture.imageUrl !== item.imageUrl ? 0.5 : 1
	                },
	                onTouchTap: function onTouchTap() {
	                  if (!_this2.state.selectedPicture || _this2.state.selectedPicture.imageUrl !== item.imageUrl) {
	                    _this2.setState({ selectedPicture: item });
	                  } else {
	                    _this2.setState({ selectedPicture: null });
	                  }
	                }
	              },
	              _react2.default.createElement("img", {
	                src: item.imageUrl,
	                alt: item.imageAlt
	              })
	            );
	          })
	        ),
	        _react2.default.createElement(_materialUi.TextField, {
	          floatingLabelText: "Image URL",
	          fullWidth: true,
	          value: this.state.selectedPicture && this.state.selectedPicture.imageUrl ? this.state.selectedPicture.imageUrl : "",
	          onChange: function onChange(e) {
	            _this2.setState({ selectedPicture: Object.assign({}, _this2.state.selectedPicture, { imageUrl: e.target.value }) });
	          }
	        }),
	        _react2.default.createElement(_materialUi.TextField, {
	          floatingLabelText: "Image ALT text",
	          fullWidth: true,
	          value: this.state.selectedPicture && this.state.selectedPicture.imageAlt ? this.state.selectedPicture.imageAlt : "",
	          onChange: function onChange(e) {
	            _this2.setState({ selectedPicture: Object.assign({}, _this2.state.selectedPicture, { imageAlt: e.target.value }) });
	          }
	        }),
	        _react2.default.createElement(_materialUi.TextField, {
	          floatingLabelText: "Image hyperlink",
	          fullWidth: true,
	          value: this.state.selectedPicture && this.state.selectedPicture.imageLink ? this.state.selectedPicture.imageLink : "",
	          onChange: function onChange(e) {
	            _this2.setState({ selectedPicture: Object.assign({}, _this2.state.selectedPicture, { imageLink: e.target.value }) });
	          }
	        })
	      );
	    }
	  }]);
	
	  return ImageBrowser;
	}(_react.Component);
	
	function mapStateToProps(state, ownprops) {
	  return {
	    currentImage: ownprops.currentImage,
	    images: (0, _selectors.getImages)(state),
	    open: ownprops.open,
	    callback: ownprops.callback
	  };
	}
	
	exports.default = (0, _reactRedux.connect)(mapStateToProps)(ImageBrowser);

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _materialUi = __webpack_require__(34);
	
	var _reactRouterDom = __webpack_require__(420);
	
	var _index = __webpack_require__(151);
	
	__webpack_require__(571);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * Created by DSadler on 28/04/2017.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */
	
	
	var LeftNav = function (_Component) {
	  _inherits(LeftNav, _Component);
	
	  function LeftNav() {
	    _classCallCheck(this, LeftNav);
	
	    return _possibleConstructorReturn(this, (LeftNav.__proto__ || Object.getPrototypeOf(LeftNav)).apply(this, arguments));
	  }
	
	  _createClass(LeftNav, [{
	    key: "render",
	    value: function render() {
	      var _this2 = this;
	
	      return _react2.default.createElement(
	        _materialUi.Drawer,
	        {
	          className: "left-nav",
	          docked: this.props.pinned,
	          open: this.props.open,
	          onRequestChange: this.props.handleChange,
	          containerStyle: !this.props.pinned ? null : { top: "64px" }
	        },
	        _react2.default.createElement(
	          _materialUi.List,
	          null,
	          _react2.default.createElement(
	            _materialUi.ListItem,
	            {
	              disabled: true,
	              style: {
	                textAlign: "center",
	                fontWeight: "bold"
	              }
	            },
	            "HTML Email Designer"
	          ),
	          _react2.default.createElement(_materialUi.Divider, null),
	          _react2.default.createElement(
	            _reactRouterDom.NavLink,
	            { to: "/", exact: true },
	            _react2.default.createElement(
	              _materialUi.ListItem,
	              {
	                onTouchTap: function onTouchTap() {
	                  return !_this2.props.pinned && _this2.props.handleChange(false);
	                },
	                leftIcon: _react2.default.createElement(_index.ActionHome, null)
	              },
	              "Homepage"
	            )
	          ),
	          _react2.default.createElement(
	            _reactRouterDom.NavLink,
	            { to: "/editor" },
	            _react2.default.createElement(
	              _materialUi.ListItem,
	              {
	                onTouchTap: function onTouchTap() {
	                  return !_this2.props.pinned && _this2.props.handleChange(false);
	                },
	                leftIcon: _react2.default.createElement(_index.ImageEdit, null)
	              },
	              "Editor"
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return LeftNav;
	}(_react.Component);
	
	exports.default = LeftNav;

/***/ },
/* 481 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createEmail = createEmail;
	exports.updateEmail = updateEmail;
	exports.deleteEmail = deleteEmail;
	exports.setEmails = setEmails;
	/**
	 * Created by DSadler on 02/05/2017.
	 */
	
	/*let emailItem = {
	  emailId: "",
	  emailName: "",
	  emailCategory: "",
	  emailLastEdited: "",
	  emailContent: "",
	};*/
	
	//Created from an email template definition
	var CREATE_EMAIL = exports.CREATE_EMAIL = "CREATE_EMAIL";
	var UPDATE_EMAIL = exports.UPDATE_EMAIL = "UPDATE_EMAIL";
	var DELETE_EMAIL = exports.DELETE_EMAIL = "DELETE_EMAIL";
	var SET_EMAILS = exports.SET_EMAILS = "SET_EMAILS";
	
	// need to know which i'm using, so pass Id on creation
	function createEmail(emailId, emailName, emailCategory, templateItem) {
	  return {
	    type: CREATE_EMAIL,
	    emailId: emailId,
	    emailName: emailName,
	    emailCategory: emailCategory,
	    templateItem: templateItem
	  };
	}
	// need to know which i'm using, so pass Id on creation
	function updateEmail(emailId, emailItem) {
	  return {
	    type: UPDATE_EMAIL,
	    emailId: emailId,
	    emailItem: emailItem
	  };
	}
	// need to know which i'm using, so pass Id on creation
	function deleteEmail(emailId) {
	  return {
	    type: DELETE_EMAIL,
	    emailId: emailId
	  };
	}
	
	function setEmails(emails) {
	  return {
	    type: SET_EMAILS,
	    emails: emails
	  };
	}

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.emails = emails;
	
	var _actions = __webpack_require__(481);
	
	var actions = _interopRequireWildcard(_actions);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function emails() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.CREATE_EMAIL:
	      return state;
	    case actions.UPDATE_EMAIL:
	      return state;
	    case actions.DELETE_EMAIL:
	      return state;
	    case actions.SET_EMAILS:
	      return state;
	    default:
	      return state;
	  }
	} /**
	   * Created by DSadler on 02/05/2017.
	   */

/***/ },
/* 483 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createImage = createImage;
	exports.updateImage = updateImage;
	exports.deleteImage = deleteImage;
	exports.setImages = setImages;
	/**
	 * Created by DSadler on 02/05/2017.
	 */
	
	/*let image = {
	  imageId: "",
	  imageName: "",
	  imageUrl: "",
	  imageCategory: "",
	  imageAdded: "",
	  builtIn: "",
	};*/
	
	var CREATE_IMAGE = exports.CREATE_IMAGE = "CREATE_IMAGE";
	var UPDATE_IMAGE = exports.UPDATE_IMAGE = "UPDATE_IMAGE";
	var DELETE_IMAGE = exports.DELETE_IMAGE = "DELETE_IMAGE";
	var SET_IMAGES = exports.SET_IMAGES = "SET_IMAGES";
	
	function createImage(imageId, imageName, imageCategory, imageUrl) {
	  return {
	    type: CREATE_IMAGE,
	    imageId: imageId,
	    imageName: imageName,
	    imageCategory: imageCategory,
	    imageUrl: imageUrl
	  };
	}
	
	function updateImage(imageId, imageItem) {
	  return {
	    type: UPDATE_IMAGE,
	    imageId: imageId,
	    imageItem: imageItem
	  };
	}
	
	function deleteImage(imageId) {
	  return {
	    type: DELETE_IMAGE,
	    imageId: imageId
	  };
	}
	
	function setImages(images) {
	  return {
	    type: SET_IMAGES,
	    images: images
	  };
	}

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.images = images;
	
	var _actions = __webpack_require__(483);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _initialState = __webpack_require__(615);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Created by DSadler on 02/05/2017.
	 */
	var initialState = _initialState2.default;
	
	function images() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.CREATE_IMAGE:
	      return state;
	    case actions.UPDATE_IMAGE:
	      return state;
	    case actions.DELETE_IMAGE:
	      return state;
	    case actions.SET_IMAGES:
	      return state;
	    default:
	      return state;
	  }
	}

/***/ },
/* 485 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	 * Created by DSadler on 02/05/2017.
	 */
	
	/**
	 * Returns all images saved in the current editor state
	 * @param state
	 * @returns {Array}
	 */
	var getImages = exports.getImages = function getImages(state) {
	  return state.images;
	};

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reduxStore = undefined;
	
	var _reducers = __webpack_require__(475);
	
	var _redux = __webpack_require__(121);
	
	var _reducers2 = __webpack_require__(482);
	
	var _reducers3 = __webpack_require__(484);
	
	var _reducers4 = __webpack_require__(488);
	
	var reduxStore = (0, _redux.combineReducers)({
	  editor: _reducers.editor,
	  emails: _reducers2.emails,
	  images: _reducers3.images,
	  templates: _reducers4.templates
	}); /**
	     * Created by DSadler on 20/04/2017.
	     */
	
	exports.reduxStore = reduxStore;

/***/ },
/* 487 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createTemplate = createTemplate;
	exports.updateTemplate = updateTemplate;
	exports.deleteTemplate = deleteTemplate;
	exports.setTemplates = setTemplates;
	/**
	 * Created by DSadler on 02/05/2017.
	 */
	
	/*let template = {
	  templateId: "",
	  templateName: "",
	  templateCategory: "",
	  templateContent: "",
	  builtIn: "",
	};*/
	
	var CREATE_TEMPLATE = exports.CREATE_TEMPLATE = "CREATE_TEMPLATE";
	var UPDATE_TEMPLATE = exports.UPDATE_TEMPLATE = "UPDATE_TEMPLATE";
	var DELETE_TEMPLATE = exports.DELETE_TEMPLATE = "DELETE_TEMPLATE";
	var SET_TEMPLATES = exports.SET_TEMPLATES = "SET_TEMPLATES";
	
	function createTemplate(id, name, templateCategory, content) {
	  return {
	    type: CREATE_TEMPLATE,
	    id: id,
	    name: name,
	    templateCategory: templateCategory,
	    content: content
	  };
	}
	
	function updateTemplate(templateItem) {
	  return {
	    type: UPDATE_TEMPLATE,
	    templateItem: templateItem
	  };
	}
	
	function deleteTemplate(templateId) {
	  return {
	    type: DELETE_TEMPLATE,
	    templateId: templateId
	  };
	}
	
	function setTemplates(templates) {
	  return {
	    type: SET_TEMPLATES,
	    templates: templates
	  };
	}

/***/ },
/* 488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.templates = templates;
	
	var _actions = __webpack_require__(487);
	
	var actions = _interopRequireWildcard(_actions);
	
	var _initialState = __webpack_require__(616);
	
	var _initialState2 = _interopRequireDefault(_initialState);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	/**
	 * Created by DSadler on 02/05/2017.
	 */
	function templates() {
	  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _initialState2.default;
	  var action = arguments[1];
	
	  switch (action.type) {
	    case actions.CREATE_TEMPLATE:
	      return state;
	    case actions.UPDATE_TEMPLATE:
	      return state;
	    case actions.DELETE_TEMPLATE:
	      return state;
	    case actions.SET_TEMPLATES:
	      return state;
	    default:
	      return state;
	  }
	}

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTemplateItems = undefined;
	
	var _lodash = __webpack_require__(33);
	
	var _ = _interopRequireWildcard(_lodash);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	var cleanse = function cleanse(item) {
	  return item === undefined ? undefined : JSON.parse(JSON.stringify(item));
	}; /**
	    * Created by DSadler on 02/05/2017.
	    */
	var getTemplateItems = exports.getTemplateItems = function getTemplateItems(state, predicate) {
	  return cleanse(_.filter(state.templates, predicate));
	};

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(443);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(572);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(_App2.default, null), document.getElementById('root'));

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(506), __esModule: true };

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(508), __esModule: true };

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(512), __esModule: true };

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(513), __esModule: true };

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = { "default": __webpack_require__(514), __esModule: true };

/***/ },
/* 496 */
/***/ function(module, exports) {

	'use strict'
	
	exports.byteLength = byteLength
	exports.toByteArray = toByteArray
	exports.fromByteArray = fromByteArray
	
	var lookup = []
	var revLookup = []
	var Arr = typeof Uint8Array !== 'undefined' ? Uint8Array : Array
	
	var code = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/'
	for (var i = 0, len = code.length; i < len; ++i) {
	  lookup[i] = code[i]
	  revLookup[code.charCodeAt(i)] = i
	}
	
	revLookup['-'.charCodeAt(0)] = 62
	revLookup['_'.charCodeAt(0)] = 63
	
	function placeHoldersCount (b64) {
	  var len = b64.length
	  if (len % 4 > 0) {
	    throw new Error('Invalid string. Length must be a multiple of 4')
	  }
	
	  // the number of equal signs (place holders)
	  // if there are two placeholders, than the two characters before it
	  // represent one byte
	  // if there is only one, then the three characters before it represent 2 bytes
	  // this is just a cheap hack to not do indexOf twice
	  return b64[len - 2] === '=' ? 2 : b64[len - 1] === '=' ? 1 : 0
	}
	
	function byteLength (b64) {
	  // base64 is 4/3 + up to two characters of the original data
	  return (b64.length * 3 / 4) - placeHoldersCount(b64)
	}
	
	function toByteArray (b64) {
	  var i, l, tmp, placeHolders, arr
	  var len = b64.length
	  placeHolders = placeHoldersCount(b64)
	
	  arr = new Arr((len * 3 / 4) - placeHolders)
	
	  // if there are placeholders, only get up to the last complete 4 chars
	  l = placeHolders > 0 ? len - 4 : len
	
	  var L = 0
	
	  for (i = 0; i < l; i += 4) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 18) | (revLookup[b64.charCodeAt(i + 1)] << 12) | (revLookup[b64.charCodeAt(i + 2)] << 6) | revLookup[b64.charCodeAt(i + 3)]
	    arr[L++] = (tmp >> 16) & 0xFF
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  if (placeHolders === 2) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 2) | (revLookup[b64.charCodeAt(i + 1)] >> 4)
	    arr[L++] = tmp & 0xFF
	  } else if (placeHolders === 1) {
	    tmp = (revLookup[b64.charCodeAt(i)] << 10) | (revLookup[b64.charCodeAt(i + 1)] << 4) | (revLookup[b64.charCodeAt(i + 2)] >> 2)
	    arr[L++] = (tmp >> 8) & 0xFF
	    arr[L++] = tmp & 0xFF
	  }
	
	  return arr
	}
	
	function tripletToBase64 (num) {
	  return lookup[num >> 18 & 0x3F] + lookup[num >> 12 & 0x3F] + lookup[num >> 6 & 0x3F] + lookup[num & 0x3F]
	}
	
	function encodeChunk (uint8, start, end) {
	  var tmp
	  var output = []
	  for (var i = start; i < end; i += 3) {
	    tmp = (uint8[i] << 16) + (uint8[i + 1] << 8) + (uint8[i + 2])
	    output.push(tripletToBase64(tmp))
	  }
	  return output.join('')
	}
	
	function fromByteArray (uint8) {
	  var tmp
	  var len = uint8.length
	  var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
	  var output = ''
	  var parts = []
	  var maxChunkLength = 16383 // must be multiple of 3
	
	  // go through the array every three bytes, we'll deal with trailing stuff later
	  for (var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength) {
	    parts.push(encodeChunk(uint8, i, (i + maxChunkLength) > len2 ? len2 : (i + maxChunkLength)))
	  }
	
	  // pad the end with zeros, but make sure to not forget the extra bytes
	  if (extraBytes === 1) {
	    tmp = uint8[len - 1]
	    output += lookup[tmp >> 2]
	    output += lookup[(tmp << 4) & 0x3F]
	    output += '=='
	  } else if (extraBytes === 2) {
	    tmp = (uint8[len - 2] << 8) + (uint8[len - 1])
	    output += lookup[tmp >> 10]
	    output += lookup[(tmp >> 4) & 0x3F]
	    output += lookup[(tmp << 2) & 0x3F]
	    output += '='
	  }
	
	  parts.push(output)
	
	  return parts.join('')
	}


/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	/*!
	 * Bowser - a browser detector
	 * https://github.com/ded/bowser
	 * MIT License | (c) Dustin Diaz 2015
	 */
	
	!function (root, name, definition) {
	  if (typeof module != 'undefined' && module.exports) module.exports = definition()
	  else if (true) __webpack_require__(2032)(name, definition)
	  else root[name] = definition()
	}(this, 'bowser', function () {
	  /**
	    * See useragents.js for examples of navigator.userAgent
	    */
	
	  var t = true
	
	  function detect(ua) {
	
	    function getFirstMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[1]) || '';
	    }
	
	    function getSecondMatch(regex) {
	      var match = ua.match(regex);
	      return (match && match.length > 1 && match[2]) || '';
	    }
	
	    var iosdevice = getFirstMatch(/(ipod|iphone|ipad)/i).toLowerCase()
	      , likeAndroid = /like android/i.test(ua)
	      , android = !likeAndroid && /android/i.test(ua)
	      , nexusMobile = /nexus\s*[0-6]\s*/i.test(ua)
	      , nexusTablet = !nexusMobile && /nexus\s*[0-9]+/i.test(ua)
	      , chromeos = /CrOS/.test(ua)
	      , silk = /silk/i.test(ua)
	      , sailfish = /sailfish/i.test(ua)
	      , tizen = /tizen/i.test(ua)
	      , webos = /(web|hpw)os/i.test(ua)
	      , windowsphone = /windows phone/i.test(ua)
	      , samsungBrowser = /SamsungBrowser/i.test(ua)
	      , windows = !windowsphone && /windows/i.test(ua)
	      , mac = !iosdevice && !silk && /macintosh/i.test(ua)
	      , linux = !android && !sailfish && !tizen && !webos && /linux/i.test(ua)
	      , edgeVersion = getSecondMatch(/edg([ea]|ios)\/(\d+(\.\d+)?)/i)
	      , versionIdentifier = getFirstMatch(/version\/(\d+(\.\d+)?)/i)
	      , tablet = /tablet/i.test(ua) && !/tablet pc/i.test(ua)
	      , mobile = !tablet && /[^-]mobi/i.test(ua)
	      , xbox = /xbox/i.test(ua)
	      , result
	
	    if (/opera/i.test(ua)) {
	      //  an old Opera
	      result = {
	        name: 'Opera'
	      , opera: t
	      , version: versionIdentifier || getFirstMatch(/(?:opera|opr|opios)[\s\/](\d+(\.\d+)?)/i)
	      }
	    } else if (/opr\/|opios/i.test(ua)) {
	      // a new Opera
	      result = {
	        name: 'Opera'
	        , opera: t
	        , version: getFirstMatch(/(?:opr|opios)[\s\/](\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/SamsungBrowser/i.test(ua)) {
	      result = {
	        name: 'Samsung Internet for Android'
	        , samsungBrowser: t
	        , version: versionIdentifier || getFirstMatch(/(?:SamsungBrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/coast/i.test(ua)) {
	      result = {
	        name: 'Opera Coast'
	        , coast: t
	        , version: versionIdentifier || getFirstMatch(/(?:coast)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/yabrowser/i.test(ua)) {
	      result = {
	        name: 'Yandex Browser'
	      , yandexbrowser: t
	      , version: versionIdentifier || getFirstMatch(/(?:yabrowser)[\s\/](\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/ucbrowser/i.test(ua)) {
	      result = {
	          name: 'UC Browser'
	        , ucbrowser: t
	        , version: getFirstMatch(/(?:ucbrowser)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/mxios/i.test(ua)) {
	      result = {
	        name: 'Maxthon'
	        , maxthon: t
	        , version: getFirstMatch(/(?:mxios)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/epiphany/i.test(ua)) {
	      result = {
	        name: 'Epiphany'
	        , epiphany: t
	        , version: getFirstMatch(/(?:epiphany)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/puffin/i.test(ua)) {
	      result = {
	        name: 'Puffin'
	        , puffin: t
	        , version: getFirstMatch(/(?:puffin)[\s\/](\d+(?:\.\d+)?)/i)
	      }
	    }
	    else if (/sleipnir/i.test(ua)) {
	      result = {
	        name: 'Sleipnir'
	        , sleipnir: t
	        , version: getFirstMatch(/(?:sleipnir)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (/k-meleon/i.test(ua)) {
	      result = {
	        name: 'K-Meleon'
	        , kMeleon: t
	        , version: getFirstMatch(/(?:k-meleon)[\s\/](\d+(?:\.\d+)+)/i)
	      }
	    }
	    else if (windowsphone) {
	      result = {
	        name: 'Windows Phone'
	      , osname: 'Windows Phone'
	      , windowsphone: t
	      }
	      if (edgeVersion) {
	        result.msedge = t
	        result.version = edgeVersion
	      }
	      else {
	        result.msie = t
	        result.version = getFirstMatch(/iemobile\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/msie|trident/i.test(ua)) {
	      result = {
	        name: 'Internet Explorer'
	      , msie: t
	      , version: getFirstMatch(/(?:msie |rv:)(\d+(\.\d+)?)/i)
	      }
	    } else if (chromeos) {
	      result = {
	        name: 'Chrome'
	      , osname: 'Chrome OS'
	      , chromeos: t
	      , chromeBook: t
	      , chrome: t
	      , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    } else if (/edg([ea]|ios)/i.test(ua)) {
	      result = {
	        name: 'Microsoft Edge'
	      , msedge: t
	      , version: edgeVersion
	      }
	    }
	    else if (/vivaldi/i.test(ua)) {
	      result = {
	        name: 'Vivaldi'
	        , vivaldi: t
	        , version: getFirstMatch(/vivaldi\/(\d+(\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (sailfish) {
	      result = {
	        name: 'Sailfish'
	      , osname: 'Sailfish OS'
	      , sailfish: t
	      , version: getFirstMatch(/sailfish\s?browser\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/seamonkey\//i.test(ua)) {
	      result = {
	        name: 'SeaMonkey'
	      , seamonkey: t
	      , version: getFirstMatch(/seamonkey\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/firefox|iceweasel|fxios/i.test(ua)) {
	      result = {
	        name: 'Firefox'
	      , firefox: t
	      , version: getFirstMatch(/(?:firefox|iceweasel|fxios)[ \/](\d+(\.\d+)?)/i)
	      }
	      if (/\((mobile|tablet);[^\)]*rv:[\d\.]+\)/i.test(ua)) {
	        result.firefoxos = t
	        result.osname = 'Firefox OS'
	      }
	    }
	    else if (silk) {
	      result =  {
	        name: 'Amazon Silk'
	      , silk: t
	      , version : getFirstMatch(/silk\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/phantom/i.test(ua)) {
	      result = {
	        name: 'PhantomJS'
	      , phantom: t
	      , version: getFirstMatch(/phantomjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/slimerjs/i.test(ua)) {
	      result = {
	        name: 'SlimerJS'
	        , slimer: t
	        , version: getFirstMatch(/slimerjs\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (/blackberry|\bbb\d+/i.test(ua) || /rim\stablet/i.test(ua)) {
	      result = {
	        name: 'BlackBerry'
	      , osname: 'BlackBerry OS'
	      , blackberry: t
	      , version: versionIdentifier || getFirstMatch(/blackberry[\d]+\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (webos) {
	      result = {
	        name: 'WebOS'
	      , osname: 'WebOS'
	      , webos: t
	      , version: versionIdentifier || getFirstMatch(/w(?:eb)?osbrowser\/(\d+(\.\d+)?)/i)
	      };
	      /touchpad\//i.test(ua) && (result.touchpad = t)
	    }
	    else if (/bada/i.test(ua)) {
	      result = {
	        name: 'Bada'
	      , osname: 'Bada'
	      , bada: t
	      , version: getFirstMatch(/dolfin\/(\d+(\.\d+)?)/i)
	      };
	    }
	    else if (tizen) {
	      result = {
	        name: 'Tizen'
	      , osname: 'Tizen'
	      , tizen: t
	      , version: getFirstMatch(/(?:tizen\s?)?browser\/(\d+(\.\d+)?)/i) || versionIdentifier
	      };
	    }
	    else if (/qupzilla/i.test(ua)) {
	      result = {
	        name: 'QupZilla'
	        , qupzilla: t
	        , version: getFirstMatch(/(?:qupzilla)[\s\/](\d+(?:\.\d+)+)/i) || versionIdentifier
	      }
	    }
	    else if (/chromium/i.test(ua)) {
	      result = {
	        name: 'Chromium'
	        , chromium: t
	        , version: getFirstMatch(/(?:chromium)[\s\/](\d+(?:\.\d+)?)/i) || versionIdentifier
	      }
	    }
	    else if (/chrome|crios|crmo/i.test(ua)) {
	      result = {
	        name: 'Chrome'
	        , chrome: t
	        , version: getFirstMatch(/(?:chrome|crios|crmo)\/(\d+(\.\d+)?)/i)
	      }
	    }
	    else if (android) {
	      result = {
	        name: 'Android'
	        , version: versionIdentifier
	      }
	    }
	    else if (/safari|applewebkit/i.test(ua)) {
	      result = {
	        name: 'Safari'
	      , safari: t
	      }
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if (iosdevice) {
	      result = {
	        name : iosdevice == 'iphone' ? 'iPhone' : iosdevice == 'ipad' ? 'iPad' : 'iPod'
	      }
	      // WTF: version is not part of user agent in web apps
	      if (versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    }
	    else if(/googlebot/i.test(ua)) {
	      result = {
	        name: 'Googlebot'
	      , googlebot: t
	      , version: getFirstMatch(/googlebot\/(\d+(\.\d+))/i) || versionIdentifier
	      }
	    }
	    else {
	      result = {
	        name: getFirstMatch(/^(.*)\/(.*) /),
	        version: getSecondMatch(/^(.*)\/(.*) /)
	     };
	   }
	
	    // set webkit or gecko flag for browsers based on these engines
	    if (!result.msedge && /(apple)?webkit/i.test(ua)) {
	      if (/(apple)?webkit\/537\.36/i.test(ua)) {
	        result.name = result.name || "Blink"
	        result.blink = t
	      } else {
	        result.name = result.name || "Webkit"
	        result.webkit = t
	      }
	      if (!result.version && versionIdentifier) {
	        result.version = versionIdentifier
	      }
	    } else if (!result.opera && /gecko\//i.test(ua)) {
	      result.name = result.name || "Gecko"
	      result.gecko = t
	      result.version = result.version || getFirstMatch(/gecko\/(\d+(\.\d+)?)/i)
	    }
	
	    // set OS flags for platforms that have multiple browsers
	    if (!result.windowsphone && (android || result.silk)) {
	      result.android = t
	      result.osname = 'Android'
	    } else if (!result.windowsphone && iosdevice) {
	      result[iosdevice] = t
	      result.ios = t
	      result.osname = 'iOS'
	    } else if (mac) {
	      result.mac = t
	      result.osname = 'macOS'
	    } else if (xbox) {
	      result.xbox = t
	      result.osname = 'Xbox'
	    } else if (windows) {
	      result.windows = t
	      result.osname = 'Windows'
	    } else if (linux) {
	      result.linux = t
	      result.osname = 'Linux'
	    }
	
	    function getWindowsVersion (s) {
	      switch (s) {
	        case 'NT': return 'NT'
	        case 'XP': return 'XP'
	        case 'NT 5.0': return '2000'
	        case 'NT 5.1': return 'XP'
	        case 'NT 5.2': return '2003'
	        case 'NT 6.0': return 'Vista'
	        case 'NT 6.1': return '7'
	        case 'NT 6.2': return '8'
	        case 'NT 6.3': return '8.1'
	        case 'NT 10.0': return '10'
	        default: return undefined
	      }
	    }
	
	    // OS version extraction
	    var osVersion = '';
	    if (result.windows) {
	      osVersion = getWindowsVersion(getFirstMatch(/Windows ((NT|XP)( \d\d?.\d)?)/i))
	    } else if (result.windowsphone) {
	      osVersion = getFirstMatch(/windows phone (?:os)?\s?(\d+(\.\d+)*)/i);
	    } else if (result.mac) {
	      osVersion = getFirstMatch(/Mac OS X (\d+([_\.\s]\d+)*)/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (iosdevice) {
	      osVersion = getFirstMatch(/os (\d+([_\s]\d+)*) like mac os x/i);
	      osVersion = osVersion.replace(/[_\s]/g, '.');
	    } else if (android) {
	      osVersion = getFirstMatch(/android[ \/-](\d+(\.\d+)*)/i);
	    } else if (result.webos) {
	      osVersion = getFirstMatch(/(?:web|hpw)os\/(\d+(\.\d+)*)/i);
	    } else if (result.blackberry) {
	      osVersion = getFirstMatch(/rim\stablet\sos\s(\d+(\.\d+)*)/i);
	    } else if (result.bada) {
	      osVersion = getFirstMatch(/bada\/(\d+(\.\d+)*)/i);
	    } else if (result.tizen) {
	      osVersion = getFirstMatch(/tizen[\/\s](\d+(\.\d+)*)/i);
	    }
	    if (osVersion) {
	      result.osversion = osVersion;
	    }
	
	    // device type extraction
	    var osMajorVersion = !result.windows && osVersion.split('.')[0];
	    if (
	         tablet
	      || nexusTablet
	      || iosdevice == 'ipad'
	      || (android && (osMajorVersion == 3 || (osMajorVersion >= 4 && !mobile)))
	      || result.silk
	    ) {
	      result.tablet = t
	    } else if (
	         mobile
	      || iosdevice == 'iphone'
	      || iosdevice == 'ipod'
	      || android
	      || nexusMobile
	      || result.blackberry
	      || result.webos
	      || result.bada
	    ) {
	      result.mobile = t
	    }
	
	    // Graded Browser Support
	    // http://developer.yahoo.com/yui/articles/gbs
	    if (result.msedge ||
	        (result.msie && result.version >= 10) ||
	        (result.yandexbrowser && result.version >= 15) ||
			    (result.vivaldi && result.version >= 1.0) ||
	        (result.chrome && result.version >= 20) ||
	        (result.samsungBrowser && result.version >= 4) ||
	        (result.firefox && result.version >= 20.0) ||
	        (result.safari && result.version >= 6) ||
	        (result.opera && result.version >= 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] >= 6) ||
	        (result.blackberry && result.version >= 10.1)
	        || (result.chromium && result.version >= 20)
	        ) {
	      result.a = t;
	    }
	    else if ((result.msie && result.version < 10) ||
	        (result.chrome && result.version < 20) ||
	        (result.firefox && result.version < 20.0) ||
	        (result.safari && result.version < 6) ||
	        (result.opera && result.version < 10.0) ||
	        (result.ios && result.osversion && result.osversion.split(".")[0] < 6)
	        || (result.chromium && result.version < 20)
	        ) {
	      result.c = t
	    } else result.x = t
	
	    return result
	  }
	
	  var bowser = detect(typeof navigator !== 'undefined' ? navigator.userAgent || '' : '')
	
	  bowser.test = function (browserList) {
	    for (var i = 0; i < browserList.length; ++i) {
	      var browserItem = browserList[i];
	      if (typeof browserItem=== 'string') {
	        if (browserItem in bowser) {
	          return true;
	        }
	      }
	    }
	    return false;
	  }
	
	  /**
	   * Get version precisions count
	   *
	   * @example
	   *   getVersionPrecision("1.10.3") // 3
	   *
	   * @param  {string} version
	   * @return {number}
	   */
	  function getVersionPrecision(version) {
	    return version.split(".").length;
	  }
	
	  /**
	   * Array::map polyfill
	   *
	   * @param  {Array} arr
	   * @param  {Function} iterator
	   * @return {Array}
	   */
	  function map(arr, iterator) {
	    var result = [], i;
	    if (Array.prototype.map) {
	      return Array.prototype.map.call(arr, iterator);
	    }
	    for (i = 0; i < arr.length; i++) {
	      result.push(iterator(arr[i]));
	    }
	    return result;
	  }
	
	  /**
	   * Calculate browser version weight
	   *
	   * @example
	   *   compareVersions(['1.10.2.1',  '1.8.2.1.90'])    // 1
	   *   compareVersions(['1.010.2.1', '1.09.2.1.90']);  // 1
	   *   compareVersions(['1.10.2.1',  '1.10.2.1']);     // 0
	   *   compareVersions(['1.10.2.1',  '1.0800.2']);     // -1
	   *
	   * @param  {Array<String>} versions versions to compare
	   * @return {Number} comparison result
	   */
	  function compareVersions(versions) {
	    // 1) get common precision for both versions, for example for "10.0" and "9" it should be 2
	    var precision = Math.max(getVersionPrecision(versions[0]), getVersionPrecision(versions[1]));
	    var chunks = map(versions, function (version) {
	      var delta = precision - getVersionPrecision(version);
	
	      // 2) "9" -> "9.0" (for precision = 2)
	      version = version + new Array(delta + 1).join(".0");
	
	      // 3) "9.0" -> ["000000000"", "000000009"]
	      return map(version.split("."), function (chunk) {
	        return new Array(20 - chunk.length).join("0") + chunk;
	      }).reverse();
	    });
	
	    // iterate in reverse order by reversed chunks array
	    while (--precision >= 0) {
	      // 4) compare: "000000009" > "000000010" = false (but "9" > "10" = true)
	      if (chunks[0][precision] > chunks[1][precision]) {
	        return 1;
	      }
	      else if (chunks[0][precision] === chunks[1][precision]) {
	        if (precision === 0) {
	          // all version chunks are same
	          return 0;
	        }
	      }
	      else {
	        return -1;
	      }
	    }
	  }
	
	  /**
	   * Check if browser is unsupported
	   *
	   * @example
	   *   bowser.isUnsupportedBrowser({
	   *     msie: "10",
	   *     firefox: "23",
	   *     chrome: "29",
	   *     safari: "5.1",
	   *     opera: "16",
	   *     phantom: "534"
	   *   });
	   *
	   * @param  {Object}  minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function isUnsupportedBrowser(minVersions, strictMode, ua) {
	    var _bowser = bowser;
	
	    // make strictMode param optional with ua param usage
	    if (typeof strictMode === 'string') {
	      ua = strictMode;
	      strictMode = void(0);
	    }
	
	    if (strictMode === void(0)) {
	      strictMode = false;
	    }
	    if (ua) {
	      _bowser = detect(ua);
	    }
	
	    var version = "" + _bowser.version;
	    for (var browser in minVersions) {
	      if (minVersions.hasOwnProperty(browser)) {
	        if (_bowser[browser]) {
	          if (typeof minVersions[browser] !== 'string') {
	            throw new Error('Browser version in the minVersion map should be a string: ' + browser + ': ' + String(minVersions));
	          }
	
	          // browser version and min supported version.
	          return compareVersions([version, minVersions[browser]]) < 0;
	        }
	      }
	    }
	
	    return strictMode; // not found
	  }
	
	  /**
	   * Check if browser is supported
	   *
	   * @param  {Object} minVersions map of minimal version to browser
	   * @param  {Boolean} [strictMode = false] flag to return false if browser wasn't found in map
	   * @param  {String}  [ua] user agent string
	   * @return {Boolean}
	   */
	  function check(minVersions, strictMode, ua) {
	    return !isUnsupportedBrowser(minVersions, strictMode, ua);
	  }
	
	  bowser.isUnsupportedBrowser = isUnsupportedBrowser;
	  bowser.compareVersions = compareVersions;
	  bowser.check = check;
	
	  /*
	   * Set our detect method to the main bowser object so we can
	   * reuse it to test other user agents.
	   * This is needed to implement future tests.
	   */
	  bowser._detect = detect;
	
	  /*
	   * Set our detect public method to the main bowser object
	   * This is needed to implement bowser in server side
	   */
	  bowser.detect = detect;
	  return bowser
	});


/***/ },
/* 498 */
/***/ function(module, exports) {

	
	module.exports = function chain(){
	  var len = arguments.length
	  var args = [];
	
	  for (var i = 0; i < len; i++)
	    args[i] = arguments[i]
	
	  args = args.filter(function(fn){ return fn != null })
	
	  if (args.length === 0) return undefined
	  if (args.length === 1) return args[0]
	
	  return args.reduce(function(current, next){
	    return function chainedFunction() {
	      current.apply(this, arguments);
	      next.apply(this, arguments);
	    };
	  })
	}


/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	var $ = __webpack_require__(166),
	    utils = __webpack_require__(99),
	    isTag = utils.isTag,
	    domEach = utils.domEach,
	    hasOwn = Object.prototype.hasOwnProperty,
	    camelCase = utils.camelCase,
	    cssCase = utils.cssCase,
	    rspace = /\s+/,
	    dataAttrPrefix = 'data-',
	    _ = {
	      forEach: __webpack_require__(133),
	      extend: __webpack_require__(295),
	      some: __webpack_require__(646)
	    },
	
	  // Lookup table for coercing string data-* attributes to their corresponding
	  // JavaScript primitives
	  primitives = {
	    null: null,
	    true: true,
	    false: false
	  },
	
	  // Attributes that are booleans
	  rboolean = /^(?:autofocus|autoplay|async|checked|controls|defer|disabled|hidden|loop|multiple|open|readonly|required|scoped|selected)$/i,
	  // Matches strings that look like JSON objects or arrays
	  rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/;
	
	
	var getAttr = function(elem, name) {
	  if (!elem || !isTag(elem)) return;
	
	  if (!elem.attribs) {
	    elem.attribs = {};
	  }
	
	  // Return the entire attribs object if no attribute specified
	  if (!name) {
	    return elem.attribs;
	  }
	
	  if (hasOwn.call(elem.attribs, name)) {
	    // Get the (decoded) attribute
	    return rboolean.test(name) ? name : elem.attribs[name];
	  }
	
	  // Mimic the DOM and return text content as value for `option's`
	  if (elem.name === 'option' && name === 'value') {
	    return $.text(elem.children);
	  }
	
	  // Mimic DOM with default value for radios/checkboxes
	  if (elem.name === 'input' &&
	      (elem.attribs.type === 'radio' || elem.attribs.type === 'checkbox') &&
	      name === 'value') {
	    return 'on';
	  }
	};
	
	var setAttr = function(el, name, value) {
	
	  if (value === null) {
	    removeAttribute(el, name);
	  } else {
	    el.attribs[name] = value+'';
	  }
	};
	
	exports.attr = function(name, value) {
	  // Set the value (with attr map support)
	  if (typeof name === 'object' || value !== undefined) {
	    if (typeof value === 'function') {
	      return domEach(this, function(i, el) {
	        setAttr(el, name, value.call(el, i, el.attribs[name]));
	      });
	    }
	    return domEach(this, function(i, el) {
	      if (!isTag(el)) return;
	
	      if (typeof name === 'object') {
	        _.forEach(name, function(value, name) {
	          setAttr(el, name, value);
	        });
	      } else {
	        setAttr(el, name, value);
	      }
	    });
	  }
	
	  return getAttr(this[0], name);
	};
	
	var getProp = function (el, name) {
	  if (!el || !isTag(el)) return;
	  
	  return el.hasOwnProperty(name)
	      ? el[name]
	      : rboolean.test(name)
	          ? getAttr(el, name) !== undefined
	          : getAttr(el, name);
	};
	
	var setProp = function (el, name, value) {
	  el[name] = rboolean.test(name) ? !!value : value;
	};
	
	exports.prop = function (name, value) {
	  var i = 0,
	      property;
	
	  if (typeof name === 'string' && value === undefined) {
	
	    switch (name) {
	      case 'style':
	        property = this.css();
	
	        _.forEach(property, function (v, p) {
	          property[i++] = p;
	        });
	
	        property.length = i;
	
	        break;
	      case 'tagName':
	      case 'nodeName':
	        property = this[0].name.toUpperCase();
	        break;
	      default:
	        property = getProp(this[0], name);
	    }
	
	    return property;
	  }
	
	  if (typeof name === 'object' || value !== undefined) {
	
	    if (typeof value === 'function') {
	      return domEach(this, function(i, el) {
	        setProp(el, name, value.call(el, i, getProp(el, name)));
	      });
	    }
	
	    return domEach(this, function(i, el) {
	      if (!isTag(el)) return;
	
	      if (typeof name === 'object') {
	
	        _.forEach(name, function(val, name) {
	          setProp(el, name, val);
	        });
	
	      } else {
	        setProp(el, name, value);
	      }
	    });
	
	  }
	};
	
	var setData = function(el, name, value) {
	  if (!el.data) {
	    el.data = {};
	  }
	
	  if (typeof name === 'object') return _.extend(el.data, name);
	  if (typeof name === 'string' && value !== undefined) {
	    el.data[name] = value;
	  } else if (typeof name === 'object') {
	    _.extend(el.data, name);
	  }
	};
	
	// Read the specified attribute from the equivalent HTML5 `data-*` attribute,
	// and (if present) cache the value in the node's internal data store. If no
	// attribute name is specified, read *all* HTML5 `data-*` attributes in this
	// manner.
	var readData = function(el, name) {
	  var readAll = arguments.length === 1;
	  var domNames, domName, jsNames, jsName, value, idx, length;
	
	  if (readAll) {
	    domNames = Object.keys(el.attribs).filter(function(attrName) {
	      return attrName.slice(0, dataAttrPrefix.length) === dataAttrPrefix;
	    });
	    jsNames = domNames.map(function(domName) {
	      return camelCase(domName.slice(dataAttrPrefix.length));
	    });
	  } else {
	    domNames = [dataAttrPrefix + cssCase(name)];
	    jsNames = [name];
	  }
	
	  for (idx = 0, length = domNames.length; idx < length; ++idx) {
	    domName = domNames[idx];
	    jsName = jsNames[idx];
	    if (hasOwn.call(el.attribs, domName)) {
	      value = el.attribs[domName];
	
	      if (hasOwn.call(primitives, value)) {
	        value = primitives[value];
	      } else if (value === String(Number(value))) {
	        value = Number(value);
	      } else if (rbrace.test(value)) {
	        try {
	          value = JSON.parse(value);
	        } catch(e){ }
	      }
	
	      el.data[jsName] = value;
	    }
	  }
	
	  return readAll ? el.data : value;
	};
	
	exports.data = function(name, value) {
	  var elem = this[0];
	
	  if (!elem || !isTag(elem)) return;
	
	  if (!elem.data) {
	    elem.data = {};
	  }
	
	  // Return the entire data object if no data specified
	  if (!name) {
	    return readData(elem);
	  }
	
	  // Set the value (with attr map support)
	  if (typeof name === 'object' || value !== undefined) {
	    domEach(this, function(i, el) {
	      setData(el, name, value);
	    });
	    return this;
	  } else if (hasOwn.call(elem.data, name)) {
	    return elem.data[name];
	  }
	
	  return readData(elem, name);
	};
	
	/**
	 * Get the value of an element
	 */
	
	exports.val = function(value) {
	  var querying = arguments.length === 0,
	      element = this[0];
	
	  if(!element) return;
	
	  switch (element.name) {
	    case 'textarea':
	      return this.text(value);
	    case 'input':
	      switch (this.attr('type')) {
	        case 'radio':
	          if (querying) {
	            return this.attr('value');
	          } else {
	            this.attr('value', value);
	            return this;
	          }
	          break;
	        default:
	          return this.attr('value', value);
	      }
	      return;
	    case 'select':
	      var option = this.find('option:selected'),
	          returnValue;
	      if (option === undefined) return undefined;
	      if (!querying) {
	        if (!this.attr().hasOwnProperty('multiple') && typeof value == 'object') {
	          return this;
	        }
	        if (typeof value != 'object') {
	          value = [value];
	        }
	        this.find('option').removeAttr('selected');
	        for (var i = 0; i < value.length; i++) {
	          this.find('option[value="' + value[i] + '"]').attr('selected', '');
	        }
	        return this;
	      }
	      returnValue = option.attr('value');
	      if (this.attr().hasOwnProperty('multiple')) {
	        returnValue = [];
	        domEach(option, function(i, el) {
	          returnValue.push(getAttr(el, 'value'));
	        });
	      }
	      return returnValue;
	    case 'option':
	      if (!querying) {
	        this.attr('value', value);
	        return this;
	      }
	      return this.attr('value');
	  }
	};
	
	/**
	 * Remove an attribute
	 */
	
	var removeAttribute = function(elem, name) {
	  if (!elem.attribs || !hasOwn.call(elem.attribs, name))
	    return;
	
	  delete elem.attribs[name];
	};
	
	
	exports.removeAttr = function(name) {
	  domEach(this, function(i, elem) {
	    removeAttribute(elem, name);
	  });
	
	  return this;
	};
	
	exports.hasClass = function(className) {
	  return _.some(this, function(elem) {
	    var attrs = elem.attribs,
	        clazz = attrs && attrs['class'],
	        idx = -1,
	        end;
	
	    if (clazz) {
	      while ((idx = clazz.indexOf(className, idx+1)) > -1) {
	        end = idx + className.length;
	
	        if ((idx === 0 || rspace.test(clazz[idx-1]))
	            && (end === clazz.length || rspace.test(clazz[end]))) {
	          return true;
	        }
	      }
	    }
	  });
	};
	
	exports.addClass = function(value) {
	  // Support functions
	  if (typeof value === 'function') {
	    return domEach(this, function(i, el) {
	      var className = el.attribs['class'] || '';
	      exports.addClass.call([el], value.call(el, i, className));
	    });
	  }
	
	  // Return if no value or not a string or function
	  if (!value || typeof value !== 'string') return this;
	
	  var classNames = value.split(rspace),
	      numElements = this.length;
	
	
	  for (var i = 0; i < numElements; i++) {
	    // If selected element isn't a tag, move on
	    if (!isTag(this[i])) continue;
	
	    // If we don't already have classes
	    var className = getAttr(this[i], 'class'),
	        numClasses,
	        setClass;
	
	    if (!className) {
	      setAttr(this[i], 'class', classNames.join(' ').trim());
	    } else {
	      setClass = ' ' + className + ' ';
	      numClasses = classNames.length;
	
	      // Check if class already exists
	      for (var j = 0; j < numClasses; j++) {
	        var appendClass = classNames[j] + ' ';
	        if (setClass.indexOf(' ' + appendClass) < 0)
	          setClass += appendClass;
	      }
	
	      setAttr(this[i], 'class', setClass.trim());
	    }
	  }
	
	  return this;
	};
	
	var splitClass = function(className) {
	  return className ? className.trim().split(rspace) : [];
	};
	
	exports.removeClass = function(value) {
	  var classes,
	      numClasses,
	      removeAll;
	
	  // Handle if value is a function
	  if (typeof value === 'function') {
	    return domEach(this, function(i, el) {
	      exports.removeClass.call(
	        [el], value.call(el, i, el.attribs['class'] || '')
	      );
	    });
	  }
	
	  classes = splitClass(value);
	  numClasses = classes.length;
	  removeAll = arguments.length === 0;
	
	  return domEach(this, function(i, el) {
	    if (!isTag(el)) return;
	
	    if (removeAll) {
	      // Short circuit the remove all case as this is the nice one
	      el.attribs.class = '';
	    } else {
	      var elClasses = splitClass(el.attribs.class),
	          index,
	          changed;
	
	      for (var j = 0; j < numClasses; j++) {
	        index = elClasses.indexOf(classes[j]);
	
	        if (index >= 0) {
	          elClasses.splice(index, 1);
	          changed = true;
	
	          // We have to do another pass to ensure that there are not duplicate
	          // classes listed
	          j--;
	        }
	      }
	      if (changed) {
	        el.attribs.class = elClasses.join(' ');
	      }
	    }
	  });
	};
	
	exports.toggleClass = function(value, stateVal) {
	  // Support functions
	  if (typeof value === 'function') {
	    return domEach(this, function(i, el) {
	      exports.toggleClass.call(
	        [el],
	        value.call(el, i, el.attribs['class'] || '', stateVal),
	        stateVal
	      );
	    });
	  }
	
	  // Return if no value or not a string or function
	  if (!value || typeof value !== 'string') return this;
	
	  var classNames = value.split(rspace),
	    numClasses = classNames.length,
	    state = typeof stateVal === 'boolean' ? stateVal ? 1 : -1 : 0,
	    numElements = this.length,
	    elementClasses,
	    index;
	
	  for (var i = 0; i < numElements; i++) {
	    // If selected element isn't a tag, move on
	    if (!isTag(this[i])) continue;
	
	    elementClasses = splitClass(this[i].attribs.class);
	
	    // Check if class already exists
	    for (var j = 0; j < numClasses; j++) {
	      // Check if the class name is currently defined
	      index = elementClasses.indexOf(classNames[j]);
	
	      // Add if stateValue === true or we are toggling and there is no value
	      if (state >= 0 && index < 0) {
	        elementClasses.push(classNames[j]);
	      } else if (state <= 0 && index >= 0) {
	        // Otherwise remove but only if the item exists
	        elementClasses.splice(index, 1);
	      }
	    }
	
	    this[i].attribs.class = elementClasses.join(' ');
	  }
	
	  return this;
	};
	
	exports.is = function (selector) {
	  if (selector) {
	    return this.filter(selector).length > 0;
	  }
	  return false;
	};
	


/***/ },
/* 500 */
/***/ function(module, exports, __webpack_require__) {

	var domEach = __webpack_require__(99).domEach,
	    _ = {
	      pick: __webpack_require__(643),
	    };
	
	var toString = Object.prototype.toString;
	
	/**
	 * Set / Get css.
	 *
	 * @param {String|Object} prop
	 * @param {String} val
	 * @return {self}
	 * @api public
	 */
	
	exports.css = function(prop, val) {
	  if (arguments.length === 2 ||
	    // When `prop` is a "plain" object
	    (toString.call(prop) === '[object Object]')) {
	    return domEach(this, function(idx, el) {
	      setCss(el, prop, val, idx);
	    });
	  } else {
	    return getCss(this[0], prop);
	  }
	};
	
	/**
	 * Set styles of all elements.
	 *
	 * @param {String|Object} prop
	 * @param {String} val
	 * @param {Number} idx - optional index within the selection
	 * @return {self}
	 * @api private
	 */
	
	function setCss(el, prop, val, idx) {
	  if ('string' == typeof prop) {
	    var styles = getCss(el);
	    if (typeof val === 'function') {
	      val = val.call(el, idx, styles[prop]);
	    }
	
	    if (val === '') {
	      delete styles[prop];
	    } else if (val != null) {
	      styles[prop] = val;
	    }
	
	    el.attribs.style = stringify(styles);
	  } else if ('object' == typeof prop) {
	    Object.keys(prop).forEach(function(k){
	      setCss(el, k, prop[k]);
	    });
	  }
	}
	
	/**
	 * Get parsed styles of the first element.
	 *
	 * @param {String} prop
	 * @return {Object}
	 * @api private
	 */
	
	function getCss(el, prop) {
	  var styles = parse(el.attribs.style);
	  if (typeof prop === 'string') {
	    return styles[prop];
	  } else if (Array.isArray(prop)) {
	    return _.pick(styles, prop);
	  } else {
	    return styles;
	  }
	}
	
	/**
	 * Stringify `obj` to styles.
	 *
	 * @param {Object} obj
	 * @return {Object}
	 * @api private
	 */
	
	function stringify(obj) {
	  return Object.keys(obj || {})
	    .reduce(function(str, prop){
	      return str += ''
	        + (str ? ' ' : '')
	        + prop
	        + ': '
	        + obj[prop]
	        + ';';
	    }, '');
	}
	
	/**
	 * Parse `styles`.
	 *
	 * @param {String} styles
	 * @return {Object}
	 * @api private
	 */
	
	function parse(styles) {
	  styles = (styles || '').trim();
	
	  if (!styles) return {};
	
	  return styles
	    .split(';')
	    .reduce(function(obj, str){
	      var n = str.indexOf(':');
	      // skip if there is no :, or if it is the first/last character
	      if (n < 1 || n === str.length-1) return obj;
	      obj[str.slice(0,n).trim()] = str.slice(n+1).trim();
	      return obj;
	    }, {});
	}


/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/jquery/jquery/blob/2.1.3/src/manipulation/var/rcheckableType.js
	// https://github.com/jquery/jquery/blob/2.1.3/src/serialize.js
	var submittableSelector = 'input,select,textarea,keygen',
	    r20 = /%20/g,
	    rCRLF = /\r?\n/g,
	    _ = {
	      map: __webpack_require__(642)
	    };
	
	exports.serialize = function() {
	  // Convert form elements into name/value objects
	  var arr = this.serializeArray();
	
	  // Serialize each element into a key/value string
	  var retArr = _.map(arr, function(data) {
	    return encodeURIComponent(data.name) + '=' + encodeURIComponent(data.value);
	  });
	
	  // Return the resulting serialization
	  return retArr.join('&').replace(r20, '+');
	};
	
	exports.serializeArray = function() {
	  // Resolve all form elements from either forms or collections of form elements
	  var Cheerio = this.constructor;
	  return this.map(function() {
	      var elem = this;
	      var $elem = Cheerio(elem);
	      if (elem.name === 'form') {
	        return $elem.find(submittableSelector).toArray();
	      } else {
	        return $elem.filter(submittableSelector).toArray();
	      }
	    }).filter(
	        // Verify elements have a name (`attr.name`) and are not disabled (`:disabled`)
	        '[name!=""]:not(:disabled)'
	        // and cannot be clicked (`[type=submit]`) or are used in `x-www-form-urlencoded` (`[type=file]`)
	        + ':not(:submit, :button, :image, :reset, :file)'
	        // and are either checked/don't have a checkable state
	        + ':matches([checked], :not(:checkbox, :radio))'
	    // Convert each of the elements to its value(s)
	    ).map(function(i, elem) {
	      var $elem = Cheerio(elem);
	      var name = $elem.attr('name');
	      var val = $elem.val();
	
	      // If there is no value set (e.g. `undefined`, `null`), then return nothing
	      if (val == null) {
	        return null;
	      } else {
	        // If we have an array of values (e.g. `<select multiple>`), return an array of key/value pairs
	        if (Array.isArray(val)) {
	          return _.map(val, function(val) {
	            // We trim replace any line endings (e.g. `\r` or `\r\n` with `\r\n`) to guarantee consistency across platforms
	            //   These can occur inside of `<textarea>'s`
	            return {name: name, value: val.replace( rCRLF, '\r\n' )};
	          });
	        // Otherwise (e.g. `<input type="text">`, return only one key/value pair
	        } else {
	          return {name: name, value: val.replace( rCRLF, '\r\n' )};
	        }
	      }
	    // Convert our result to an array
	    }).get();
	};


/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(125),
	    $ = __webpack_require__(166),
	    updateDOM = parse.update,
	    evaluate = parse.evaluate,
	    utils = __webpack_require__(99),
	    domEach = utils.domEach,
	    cloneDom = utils.cloneDom,
	    isHtml = utils.isHtml,
	    slice = Array.prototype.slice,
	    _ = {
	      flatten: __webpack_require__(641),
	      bind: __webpack_require__(192),
	      forEach: __webpack_require__(133)
	    };
	
	// Create an array of nodes, recursing into arrays and parsing strings if
	// necessary
	exports._makeDomArray = function makeDomArray(elem, clone) {
	  if (elem == null) {
	    return [];
	  } else if (elem.cheerio) {
	    return clone ? cloneDom(elem.get(), elem.options) : elem.get();
	  } else if (Array.isArray(elem)) {
	    return _.flatten(elem.map(function(el) {
	      return this._makeDomArray(el, clone);
	    }, this));
	  } else if (typeof elem === 'string') {
	    return evaluate(elem, this.options);
	  } else {
	    return clone ? cloneDom([elem]) : [elem];
	  }
	};
	
	var _insert = function(concatenator) {
	  return function() {
	    var elems = slice.call(arguments),
	        lastIdx = this.length - 1;
	
	    return domEach(this, function(i, el) {
	      var dom, domSrc;
	
	      if (typeof elems[0] === 'function') {
	        domSrc = elems[0].call(el, i, $.html(el.children));
	      } else {
	        domSrc = elems;
	      }
	
	      dom = this._makeDomArray(domSrc, i < lastIdx);
	      concatenator(dom, el.children, el);
	    });
	  };
	};
	
	/*
	 * Modify an array in-place, removing some number of elements and adding new
	 * elements directly following them.
	 *
	 * @param {Array} array Target array to splice.
	 * @param {Number} spliceIdx Index at which to begin changing the array.
	 * @param {Number} spliceCount Number of elements to remove from the array.
	 * @param {Array} newElems Elements to insert into the array.
	 *
	 * @api private
	 */
	var uniqueSplice = function(array, spliceIdx, spliceCount, newElems, parent) {
	  var spliceArgs = [spliceIdx, spliceCount].concat(newElems),
	      prev = array[spliceIdx - 1] || null,
	      next = array[spliceIdx] || null;
	  var idx, len, prevIdx, node, oldParent;
	
	  // Before splicing in new elements, ensure they do not already appear in the
	  // current array.
	  for (idx = 0, len = newElems.length; idx < len; ++idx) {
	    node = newElems[idx];
	    oldParent = node.parent || node.root;
	    prevIdx = oldParent && oldParent.children.indexOf(newElems[idx]);
	
	    if (oldParent && prevIdx > -1) {
	      oldParent.children.splice(prevIdx, 1);
	      if (parent === oldParent && spliceIdx > prevIdx) {
	        spliceArgs[0]--;
	      }
	    }
	
	    node.root = null;
	    node.parent = parent;
	
	    if (node.prev) {
	      node.prev.next = node.next || null;
	    }
	
	    if (node.next) {
	      node.next.prev = node.prev || null;
	    }
	
	    node.prev = newElems[idx - 1] || prev;
	    node.next = newElems[idx + 1] || next;
	  }
	
	  if (prev) {
	    prev.next = newElems[0];
	  }
	  if (next) {
	    next.prev = newElems[newElems.length - 1];
	  }
	  return array.splice.apply(array, spliceArgs);
	};
	
	exports.appendTo = function(target) {
	  if (!target.cheerio) {
	    target = this.constructor.call(this.constructor, target, null, this._originalRoot);
	  }
	
	  target.append(this);
	
	  return this;
	};
	
	exports.prependTo = function(target) {
	  if (!target.cheerio) {
	    target = this.constructor.call(this.constructor, target, null, this._originalRoot);
	  }
	
	  target.prepend(this);
	
	  return this;
	};
	
	exports.append = _insert(function(dom, children, parent) {
	  uniqueSplice(children, children.length, 0, dom, parent);
	});
	
	exports.prepend = _insert(function(dom, children, parent) {
	  uniqueSplice(children, 0, 0, dom, parent);
	});
	
	exports.wrap = function(wrapper) {
	  var wrapperFn = typeof wrapper === 'function' && wrapper,
	      lastIdx = this.length - 1;
	
	  _.forEach(this, _.bind(function(el, i) {
	    var parent = el.parent || el.root,
	        siblings = parent.children,
	        dom, index;
	
	    if (!parent) {
	      return;
	    }
	
	    if (wrapperFn) {
	      wrapper = wrapperFn.call(el, i);
	    }
	
	    if (typeof wrapper === 'string' && !isHtml(wrapper)) {
	      wrapper = this.parents().last().find(wrapper).clone();
	    }
	
	    dom = this._makeDomArray(wrapper, i < lastIdx).slice(0, 1);
	    index = siblings.indexOf(el);
	
	    updateDOM([el], dom[0]);
	    // The previous operation removed the current element from the `siblings`
	    // array, so the `dom` array can be inserted without removing any
	    // additional elements.
	    uniqueSplice(siblings, index, 0, dom, parent);
	  }, this));
	
	  return this;
	};
	
	exports.after = function() {
	  var elems = slice.call(arguments),
	      lastIdx = this.length - 1;
	
	  domEach(this, function(i, el) {
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        index = siblings.indexOf(el),
	        domSrc, dom;
	
	    // If not found, move on
	    if (index < 0) return;
	
	    if (typeof elems[0] === 'function') {
	      domSrc = elems[0].call(el, i, $.html(el.children));
	    } else {
	      domSrc = elems;
	    }
	    dom = this._makeDomArray(domSrc, i < lastIdx);
	
	    // Add element after `this` element
	    uniqueSplice(siblings, index + 1, 0, dom, parent);
	  });
	
	  return this;
	};
	
	exports.insertAfter = function(target) {
	  var clones = [],
	      self = this;
	  if (typeof target === 'string') {
	    target = this.constructor.call(this.constructor, target, null, this._originalRoot);
	  }
	  target = this._makeDomArray(target);
	  self.remove();
	  domEach(target, function(i, el) {
	    var clonedSelf = self._makeDomArray(self.clone());
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        index = siblings.indexOf(el);
	
	    // If not found, move on
	    if (index < 0) return;
	
	    // Add cloned `this` element(s) after target element
	    uniqueSplice(siblings, index + 1, 0, clonedSelf, parent);
	    clones.push(clonedSelf);
	  });
	  return this.constructor.call(this.constructor, this._makeDomArray(clones));
	};
	
	exports.before = function() {
	  var elems = slice.call(arguments),
	      lastIdx = this.length - 1;
	
	  domEach(this, function(i, el) {
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        index = siblings.indexOf(el),
	        domSrc, dom;
	
	    // If not found, move on
	    if (index < 0) return;
	
	    if (typeof elems[0] === 'function') {
	      domSrc = elems[0].call(el, i, $.html(el.children));
	    } else {
	      domSrc = elems;
	    }
	
	    dom = this._makeDomArray(domSrc, i < lastIdx);
	
	    // Add element before `el` element
	    uniqueSplice(siblings, index, 0, dom, parent);
	  });
	
	  return this;
	};
	
	exports.insertBefore = function(target) {
	  var clones = [],
	      self = this;
	  if (typeof target === 'string') {
	    target = this.constructor.call(this.constructor, target, null, this._originalRoot);
	  }
	  target = this._makeDomArray(target);
	  self.remove();
	  domEach(target, function(i, el) {
	    var clonedSelf = self._makeDomArray(self.clone());
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        index = siblings.indexOf(el);
	
	    // If not found, move on
	    if (index < 0) return;
	
	    // Add cloned `this` element(s) after target element
	    uniqueSplice(siblings, index, 0, clonedSelf, parent);
	    clones.push(clonedSelf);
	  });
	  return this.constructor.call(this.constructor, this._makeDomArray(clones));
	};
	
	/*
	  remove([selector])
	*/
	exports.remove = function(selector) {
	  var elems = this;
	
	  // Filter if we have selector
	  if (selector)
	    elems = elems.filter(selector);
	
	  domEach(elems, function(i, el) {
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        index = siblings.indexOf(el);
	
	    if (index < 0) return;
	
	    siblings.splice(index, 1);
	    if (el.prev) {
	      el.prev.next = el.next;
	    }
	    if (el.next) {
	      el.next.prev = el.prev;
	    }
	    el.prev = el.next = el.parent = el.root = null;
	  });
	
	  return this;
	};
	
	exports.replaceWith = function(content) {
	  var self = this;
	
	  domEach(this, function(i, el) {
	    var parent = el.parent || el.root;
	    if (!parent) {
	      return;
	    }
	
	    var siblings = parent.children,
	        dom = self._makeDomArray(typeof content === 'function' ? content.call(el, i, el) : content),
	        index;
	
	    // In the case that `dom` contains nodes that already exist in other
	    // structures, ensure those nodes are properly removed.
	    updateDOM(dom, null);
	
	    index = siblings.indexOf(el);
	
	    // Completely remove old element
	    uniqueSplice(siblings, index, 1, dom, parent);
	    el.parent = el.prev = el.next = el.root = null;
	  });
	
	  return this;
	};
	
	exports.empty = function() {
	  domEach(this, function(i, el) {
	    _.forEach(el.children, function(el) {
	      el.next = el.prev = el.parent = null;
	    });
	
	    el.children.length = 0;
	  });
	  return this;
	};
	
	/**
	 * Set/Get the HTML
	 */
	exports.html = function(str) {
	  if (str === undefined) {
	    if (!this[0] || !this[0].children) return null;
	    return $.html(this[0].children, this.options);
	  }
	
	  var opts = this.options;
	
	  domEach(this, function(i, el) {
	    _.forEach(el.children, function(el) {
	      el.next = el.prev = el.parent = null;
	    });
	
	    var content = str.cheerio ? str.clone().get() : evaluate('' + str, opts);
	
	    updateDOM(content, el);
	  });
	
	  return this;
	};
	
	exports.toString = function() {
	  return $.html(this, this.options);
	};
	
	exports.text = function(str) {
	  // If `str` is undefined, act as a "getter"
	  if (str === undefined) {
	    return $.text(this);
	  } else if (typeof str === 'function') {
	    // Function support
	    return domEach(this, function(i, el) {
	      var $el = [el];
	      return exports.text.call($el, str.call(el, i, $.text($el)));
	    });
	  }
	
	  // Append text node to each selected elements
	  domEach(this, function(i, el) {
	    _.forEach(el.children, function(el) {
	      el.next = el.prev = el.parent = null;
	    });
	
	    var elem = {
	      data: '' + str,
	      type: 'text',
	      parent: el,
	      prev: null,
	      next: null,
	      children: []
	    };
	
	    updateDOM(elem, el);
	  });
	
	  return this;
	};
	
	exports.clone = function() {
	  return this._make(cloneDom(this.get(), this.options));
	};


/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var select = __webpack_require__(270),
	    utils = __webpack_require__(99),
	    domEach = utils.domEach,
	    uniqueSort = __webpack_require__(77).DomUtils.uniqueSort,
	    isTag = utils.isTag,
	    _ = {
	      bind: __webpack_require__(192),
	      forEach: __webpack_require__(133),
	      reject: __webpack_require__(645),
	      filter: __webpack_require__(640),
	      reduce: __webpack_require__(644)
	    };
	
	exports.find = function(selectorOrHaystack) {
	  var elems = _.reduce(this, function(memo, elem) {
	    return memo.concat(_.filter(elem.children, isTag));
	  }, []);
	  var contains = this.constructor.contains;
	  var haystack;
	
	  if (selectorOrHaystack && typeof selectorOrHaystack !== 'string') {
	    if (selectorOrHaystack.cheerio) {
	      haystack = selectorOrHaystack.get();
	    } else {
	      haystack = [selectorOrHaystack];
	    }
	
	    return this._make(haystack.filter(function(elem) {
	      var idx, len;
	      for (idx = 0, len = this.length; idx < len; ++idx) {
	        if (contains(this[idx], elem)) {
	          return true;
	        }
	      }
	    }, this));
	  }
	
	  var options = {__proto__: this.options, context: this.toArray()};
	
	  return this._make(select(selectorOrHaystack, elems, options));
	};
	
	// Get the parent of each element in the current set of matched elements,
	// optionally filtered by a selector.
	exports.parent = function(selector) {
	  var set = [];
	
	  domEach(this, function(idx, elem) {
	    var parentElem = elem.parent;
	    if (parentElem && set.indexOf(parentElem) < 0) {
	      set.push(parentElem);
	    }
	  });
	
	  if (arguments.length) {
	    set = exports.filter.call(set, selector, this);
	  }
	
	  return this._make(set);
	};
	
	exports.parents = function(selector) {
	  var parentNodes = [];
	
	  // When multiple DOM elements are in the original set, the resulting set will
	  // be in *reverse* order of the original elements as well, with duplicates
	  // removed.
	  this.get().reverse().forEach(function(elem) {
	    traverseParents(this, elem.parent, selector, Infinity)
	      .forEach(function(node) {
	        if (parentNodes.indexOf(node) === -1) {
	          parentNodes.push(node);
	        }
	      }
	    );
	  }, this);
	
	  return this._make(parentNodes);
	};
	
	exports.parentsUntil = function(selector, filter) {
	  var parentNodes = [], untilNode, untilNodes;
	
	  if (typeof selector === 'string') {
	    untilNode = select(selector, this.parents().toArray(), this.options)[0];
	  } else if (selector && selector.cheerio) {
	    untilNodes = selector.toArray();
	  } else if (selector) {
	    untilNode = selector;
	  }
	
	  // When multiple DOM elements are in the original set, the resulting set will
	  // be in *reverse* order of the original elements as well, with duplicates
	  // removed.
	
	  this.toArray().reverse().forEach(function(elem) {
	    while ((elem = elem.parent)) {
	      if ((untilNode && elem !== untilNode) ||
	        (untilNodes && untilNodes.indexOf(elem) === -1) ||
	        (!untilNode && !untilNodes)) {
	        if (isTag(elem) && parentNodes.indexOf(elem) === -1) { parentNodes.push(elem); }
	      } else {
	        break;
	      }
	    }
	  }, this);
	
	  return this._make(filter ? select(filter, parentNodes, this.options) : parentNodes);
	};
	
	// For each element in the set, get the first element that matches the selector
	// by testing the element itself and traversing up through its ancestors in the
	// DOM tree.
	exports.closest = function(selector) {
	  var set = [];
	
	  if (!selector) {
	    return this._make(set);
	  }
	
	  domEach(this, function(idx, elem) {
	    var closestElem = traverseParents(this, elem, selector, 1)[0];
	
	    // Do not add duplicate elements to the set
	    if (closestElem && set.indexOf(closestElem) < 0) {
	      set.push(closestElem);
	    }
	  }.bind(this));
	
	  return this._make(set);
	};
	
	exports.next = function(selector) {
	  if (!this[0]) { return this; }
	  var elems = [];
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.next)) {
	      if (isTag(elem)) {
	        elems.push(elem);
	        return;
	      }
	    }
	  });
	
	  return selector ?
	    exports.filter.call(elems, selector, this) :
	    this._make(elems);
	};
	
	exports.nextAll = function(selector) {
	  if (!this[0]) { return this; }
	  var elems = [];
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.next)) {
	      if (isTag(elem) && elems.indexOf(elem) === -1) {
	        elems.push(elem);
	      }
	    }
	  });
	
	  return selector ?
	    exports.filter.call(elems, selector, this) :
	    this._make(elems);
	};
	
	exports.nextUntil = function(selector, filterSelector) {
	  if (!this[0]) { return this; }
	  var elems = [], untilNode, untilNodes;
	
	  if (typeof selector === 'string') {
	    untilNode = select(selector, this.nextAll().get(), this.options)[0];
	  } else if (selector && selector.cheerio) {
	    untilNodes = selector.get();
	  } else if (selector) {
	    untilNode = selector;
	  }
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.next)) {
	      if ((untilNode && elem !== untilNode) ||
	        (untilNodes && untilNodes.indexOf(elem) === -1) ||
	        (!untilNode && !untilNodes)) {
	        if (isTag(elem) && elems.indexOf(elem) === -1) {
	          elems.push(elem);
	        }
	      } else {
	        break;
	      }
	    }
	  });
	
	  return filterSelector ?
	    exports.filter.call(elems, filterSelector, this) :
	    this._make(elems);
	};
	
	exports.prev = function(selector) {
	  if (!this[0]) { return this; }
	  var elems = [];
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.prev)) {
	      if (isTag(elem)) {
	        elems.push(elem);
	        return;
	      }
	    }
	  });
	
	  return selector ?
	    exports.filter.call(elems, selector, this) :
	    this._make(elems);
	};
	
	exports.prevAll = function(selector) {
	  if (!this[0]) { return this; }
	  var elems = [];
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.prev)) {
	      if (isTag(elem) && elems.indexOf(elem) === -1) {
	        elems.push(elem);
	      }
	    }
	  });
	
	  return selector ?
	    exports.filter.call(elems, selector, this) :
	    this._make(elems);
	};
	
	exports.prevUntil = function(selector, filterSelector) {
	  if (!this[0]) { return this; }
	  var elems = [], untilNode, untilNodes;
	
	  if (typeof selector === 'string') {
	    untilNode = select(selector, this.prevAll().get(), this.options)[0];
	  } else if (selector && selector.cheerio) {
	    untilNodes = selector.get();
	  } else if (selector) {
	    untilNode = selector;
	  }
	
	  _.forEach(this, function(elem) {
	    while ((elem = elem.prev)) {
	      if ((untilNode && elem !== untilNode) ||
	        (untilNodes && untilNodes.indexOf(elem) === -1) ||
	        (!untilNode && !untilNodes)) {
	        if (isTag(elem) && elems.indexOf(elem) === -1) {
	          elems.push(elem);
	        }
	      } else {
	        break;
	      }
	    }
	  });
	
	  return filterSelector ?
	    exports.filter.call(elems, filterSelector, this) :
	    this._make(elems);
	};
	
	exports.siblings = function(selector) {
	  var parent = this.parent();
	
	  var elems = _.filter(
	    parent ? parent.children() : this.siblingsAndMe(),
	    _.bind(function(elem) { return isTag(elem) && !this.is(elem); }, this)
	  );
	
	  if (selector !== undefined) {
	    return exports.filter.call(elems, selector, this);
	  } else {
	    return this._make(elems);
	  }
	};
	
	exports.children = function(selector) {
	
	  var elems = _.reduce(this, function(memo, elem) {
	    return memo.concat(_.filter(elem.children, isTag));
	  }, []);
	
	  if (selector === undefined) return this._make(elems);
	
	  return exports.filter.call(elems, selector, this);
	};
	
	exports.contents = function() {
	  return this._make(_.reduce(this, function(all, elem) {
	    all.push.apply(all, elem.children);
	    return all;
	  }, []));
	};
	
	exports.each = function(fn) {
	  var i = 0, len = this.length;
	  while (i < len && fn.call(this[i], i, this[i]) !== false) ++i;
	  return this;
	};
	
	exports.map = function(fn) {
	  return this._make(_.reduce(this, function(memo, el, i) {
	    var val = fn.call(el, i, el);
	    return val == null ? memo : memo.concat(val);
	  }, []));
	};
	
	var makeFilterMethod = function(filterFn) {
	  return function(match, container) {
	    var testFn;
	    container = container || this;
	
	    if (typeof match === 'string') {
	      testFn = select.compile(match, container.options);
	    } else if (typeof match === 'function') {
	      testFn = function(el, i) {
	        return match.call(el, i, el);
	      };
	    } else if (match.cheerio) {
	      testFn = match.is.bind(match);
	    } else {
	      testFn = function(el) {
	        return match === el;
	      };
	    }
	
	    return container._make(filterFn(this, testFn));
	  };
	};
	
	exports.filter = makeFilterMethod(_.filter);
	exports.not = makeFilterMethod(_.reject);
	
	exports.has = function(selectorOrHaystack) {
	  var that = this;
	  return exports.filter.call(this, function() {
	    return that._make(this).find(selectorOrHaystack).length > 0;
	  });
	};
	
	exports.first = function() {
	  return this.length > 1 ? this._make(this[0]) : this;
	};
	
	exports.last = function() {
	  return this.length > 1 ? this._make(this[this.length - 1]) : this;
	};
	
	// Reduce the set of matched elements to the one at the specified index.
	exports.eq = function(i) {
	  i = +i;
	
	  // Use the first identity optimization if possible
	  if (i === 0 && this.length <= 1) return this;
	
	  if (i < 0) i = this.length + i;
	  return this[i] ? this._make(this[i]) : this._make([]);
	};
	
	// Retrieve the DOM elements matched by the jQuery object.
	exports.get = function(i) {
	  if (i == null) {
	    return Array.prototype.slice.call(this);
	  } else {
	    return this[i < 0 ? (this.length + i) : i];
	  }
	};
	
	// Search for a given element from among the matched elements.
	exports.index = function(selectorOrNeedle) {
	  var $haystack, needle;
	
	  if (arguments.length === 0) {
	    $haystack = this.parent().children();
	    needle = this[0];
	  } else if (typeof selectorOrNeedle === 'string') {
	    $haystack = this._make(selectorOrNeedle);
	    needle = this[0];
	  } else {
	    $haystack = this;
	    needle = selectorOrNeedle.cheerio ? selectorOrNeedle[0] : selectorOrNeedle;
	  }
	
	  return $haystack.get().indexOf(needle);
	};
	
	exports.slice = function() {
	  return this._make([].slice.apply(this, arguments));
	};
	
	function traverseParents(self, elem, selector, limit) {
	  var elems = [];
	  while (elem && elems.length < limit) {
	    if (!selector || exports.filter.call([elem], selector, self).length) {
	      elems.push(elem);
	    }
	    elem = elem.parent;
	  }
	  return elems;
	}
	
	// End the most recent filtering operation in the current chain and return the
	// set of matched elements to its previous state.
	exports.end = function() {
	  return this.prevObject || this._make([]);
	};
	
	exports.add = function(other, context) {
	  var selection = this._make(other, context);
	  var contents = uniqueSort(selection.get().concat(this.get()));
	
	  for (var i = 0; i < contents.length; ++i) {
	    selection[i] = contents[i];
	  }
	  selection.length = contents.length;
	
	  return selection;
	};
	
	// Add the previous set of elements on the stack to the current set, optionally
	// filtered by a selector.
	exports.addBack = function(selector) {
	  return this.add(
	    arguments.length ? this.prevObject.filter(selector) : this.prevObject
	  );
	};


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(128);
	__webpack_require__(536);
	module.exports = __webpack_require__(21).Array.from;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(181);
	__webpack_require__(128);
	module.exports = __webpack_require__(534);


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(181);
	__webpack_require__(128);
	module.exports = __webpack_require__(535);


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(538);
	module.exports = __webpack_require__(21).Object.assign;


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(539);
	var $Object = __webpack_require__(21).Object;
	module.exports = function create(P, D) {
	  return $Object.create(P, D);
	};


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(540);
	var $Object = __webpack_require__(21).Object;
	module.exports = function defineProperty(it, key, desc) {
	  return $Object.defineProperty(it, key, desc);
	};


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(541);
	module.exports = __webpack_require__(21).Object.getPrototypeOf;


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(542);
	module.exports = __webpack_require__(21).Object.keys;


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(543);
	module.exports = __webpack_require__(21).Object.setPrototypeOf;


/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(545);
	__webpack_require__(544);
	__webpack_require__(546);
	__webpack_require__(547);
	module.exports = __webpack_require__(21).Symbol;


/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(128);
	__webpack_require__(181);
	module.exports = __webpack_require__(180).f('iterator');


/***/ },
/* 515 */
/***/ function(module, exports) {

	module.exports = function (it) {
	  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	  return it;
	};


/***/ },
/* 516 */
/***/ function(module, exports) {

	module.exports = function () { /* empty */ };


/***/ },
/* 517 */
/***/ function(module, exports, __webpack_require__) {

	// false -> Array#indexOf
	// true  -> Array#includes
	var toIObject = __webpack_require__(74);
	var toLength = __webpack_require__(267);
	var toAbsoluteIndex = __webpack_require__(533);
	module.exports = function (IS_INCLUDES) {
	  return function ($this, el, fromIndex) {
	    var O = toIObject($this);
	    var length = toLength(O.length);
	    var index = toAbsoluteIndex(fromIndex, length);
	    var value;
	    // Array#includes uses SameValueZero equality algorithm
	    // eslint-disable-next-line no-self-compare
	    if (IS_INCLUDES && el != el) while (length > index) {
	      value = O[index++];
	      // eslint-disable-next-line no-self-compare
	      if (value != value) return true;
	    // Array#indexOf ignores holes, Array#includes - not
	    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
	      if (O[index] === el) return IS_INCLUDES || index || 0;
	    } return !IS_INCLUDES && -1;
	  };
	};


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var $defineProperty = __webpack_require__(49);
	var createDesc = __webpack_require__(101);
	
	module.exports = function (object, index, value) {
	  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
	  else object[index] = value;
	};


/***/ },
/* 519 */
/***/ function(module, exports, __webpack_require__) {

	// all enumerable object keys, includes symbols
	var getKeys = __webpack_require__(100);
	var gOPS = __webpack_require__(173);
	var pIE = __webpack_require__(126);
	module.exports = function (it) {
	  var result = getKeys(it);
	  var getSymbols = gOPS.f;
	  if (getSymbols) {
	    var symbols = getSymbols(it);
	    var isEnum = pIE.f;
	    var i = 0;
	    var key;
	    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
	  } return result;
	};


/***/ },
/* 520 */
/***/ function(module, exports, __webpack_require__) {

	var document = __webpack_require__(48).document;
	module.exports = document && document.documentElement;


/***/ },
/* 521 */
/***/ function(module, exports, __webpack_require__) {

	// check on default Array iterator
	var Iterators = __webpack_require__(73);
	var ITERATOR = __webpack_require__(32)('iterator');
	var ArrayProto = Array.prototype;
	
	module.exports = function (it) {
	  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	};


/***/ },
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	// 7.2.2 IsArray(argument)
	var cof = __webpack_require__(167);
	module.exports = Array.isArray || function isArray(arg) {
	  return cof(arg) == 'Array';
	};


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	// call something on iterator step with safe closing on error
	var anObject = __webpack_require__(58);
	module.exports = function (iterator, fn, value, entries) {
	  try {
	    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	  // 7.4.6 IteratorClose(iterator, completion)
	  } catch (e) {
	    var ret = iterator['return'];
	    if (ret !== undefined) anObject(ret.call(iterator));
	    throw e;
	  }
	};


/***/ },
/* 524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var create = __webpack_require__(172);
	var descriptor = __webpack_require__(101);
	var setToStringTag = __webpack_require__(174);
	var IteratorPrototype = {};
	
	// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	__webpack_require__(71)(IteratorPrototype, __webpack_require__(32)('iterator'), function () { return this; });
	
	module.exports = function (Constructor, NAME, next) {
	  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	  setToStringTag(Constructor, NAME + ' Iterator');
	};


/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	var ITERATOR = __webpack_require__(32)('iterator');
	var SAFE_CLOSING = false;
	
	try {
	  var riter = [7][ITERATOR]();
	  riter['return'] = function () { SAFE_CLOSING = true; };
	  // eslint-disable-next-line no-throw-literal
	  Array.from(riter, function () { throw 2; });
	} catch (e) { /* empty */ }
	
	module.exports = function (exec, skipClosing) {
	  if (!skipClosing && !SAFE_CLOSING) return false;
	  var safe = false;
	  try {
	    var arr = [7];
	    var iter = arr[ITERATOR]();
	    iter.next = function () { return { done: safe = true }; };
	    arr[ITERATOR] = function () { return iter; };
	    exec(arr);
	  } catch (e) { /* empty */ }
	  return safe;
	};


/***/ },
/* 526 */
/***/ function(module, exports) {

	module.exports = function (done, value) {
	  return { value: value, done: !!done };
	};


/***/ },
/* 527 */
/***/ function(module, exports, __webpack_require__) {

	var META = __webpack_require__(127)('meta');
	var isObject = __webpack_require__(72);
	var has = __webpack_require__(60);
	var setDesc = __webpack_require__(49).f;
	var id = 0;
	var isExtensible = Object.isExtensible || function () {
	  return true;
	};
	var FREEZE = !__webpack_require__(70)(function () {
	  return isExtensible(Object.preventExtensions({}));
	});
	var setMeta = function (it) {
	  setDesc(it, META, { value: {
	    i: 'O' + ++id, // object ID
	    w: {}          // weak collections IDs
	  } });
	};
	var fastKey = function (it, create) {
	  // return primitive with prefix
	  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return 'F';
	    // not necessary to add metadata
	    if (!create) return 'E';
	    // add missing metadata
	    setMeta(it);
	  // return object ID
	  } return it[META].i;
	};
	var getWeak = function (it, create) {
	  if (!has(it, META)) {
	    // can't set metadata to uncaught frozen object
	    if (!isExtensible(it)) return true;
	    // not necessary to add metadata
	    if (!create) return false;
	    // add missing metadata
	    setMeta(it);
	  // return hash weak collections IDs
	  } return it[META].w;
	};
	// add metadata on freeze-family methods calling
	var onFreeze = function (it) {
	  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	  return it;
	};
	var meta = module.exports = {
	  KEY: META,
	  NEED: false,
	  fastKey: fastKey,
	  getWeak: getWeak,
	  onFreeze: onFreeze
	};


/***/ },
/* 528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// 19.1.2.1 Object.assign(target, source, ...)
	var getKeys = __webpack_require__(100);
	var gOPS = __webpack_require__(173);
	var pIE = __webpack_require__(126);
	var toObject = __webpack_require__(102);
	var IObject = __webpack_require__(259);
	var $assign = Object.assign;
	
	// should work with symbols and should have deterministic property order (V8 bug)
	module.exports = !$assign || __webpack_require__(70)(function () {
	  var A = {};
	  var B = {};
	  // eslint-disable-next-line no-undef
	  var S = Symbol();
	  var K = 'abcdefghijklmnopqrst';
	  A[S] = 7;
	  K.split('').forEach(function (k) { B[k] = k; });
	  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
	  var T = toObject(target);
	  var aLen = arguments.length;
	  var index = 1;
	  var getSymbols = gOPS.f;
	  var isEnum = pIE.f;
	  while (aLen > index) {
	    var S = IObject(arguments[index++]);
	    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
	    var length = keys.length;
	    var j = 0;
	    var key;
	    while (length > j) if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	  } return T;
	} : $assign;


/***/ },
/* 529 */
/***/ function(module, exports, __webpack_require__) {

	var dP = __webpack_require__(49);
	var anObject = __webpack_require__(58);
	var getKeys = __webpack_require__(100);
	
	module.exports = __webpack_require__(59) ? Object.defineProperties : function defineProperties(O, Properties) {
	  anObject(O);
	  var keys = getKeys(Properties);
	  var length = keys.length;
	  var i = 0;
	  var P;
	  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
	  return O;
	};


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	var toIObject = __webpack_require__(74);
	var gOPN = __webpack_require__(262).f;
	var toString = {}.toString;
	
	var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
	  ? Object.getOwnPropertyNames(window) : [];
	
	var getWindowNames = function (it) {
	  try {
	    return gOPN(it);
	  } catch (e) {
	    return windowNames.slice();
	  }
	};
	
	module.exports.f = function getOwnPropertyNames(it) {
	  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	};


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	// Works with __proto__ only. Old v8 can't work with null proto objects.
	/* eslint-disable no-proto */
	var isObject = __webpack_require__(72);
	var anObject = __webpack_require__(58);
	var check = function (O, proto) {
	  anObject(O);
	  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	};
	module.exports = {
	  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	    function (test, buggy, set) {
	      try {
	        set = __webpack_require__(168)(Function.call, __webpack_require__(261).f(Object.prototype, '__proto__').set, 2);
	        set(test, []);
	        buggy = !(test instanceof Array);
	      } catch (e) { buggy = true; }
	      return function setPrototypeOf(O, proto) {
	        check(O, proto);
	        if (buggy) O.__proto__ = proto;
	        else set(O, proto);
	        return O;
	      };
	    }({}, false) : undefined),
	  check: check
	};


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(177);
	var defined = __webpack_require__(169);
	// true  -> String#at
	// false -> String#codePointAt
	module.exports = function (TO_STRING) {
	  return function (that, pos) {
	    var s = String(defined(that));
	    var i = toInteger(pos);
	    var l = s.length;
	    var a, b;
	    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	    a = s.charCodeAt(i);
	    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
	      ? TO_STRING ? s.charAt(i) : a
	      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	  };
	};


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	var toInteger = __webpack_require__(177);
	var max = Math.max;
	var min = Math.min;
	module.exports = function (index, length) {
	  index = toInteger(index);
	  return index < 0 ? max(index + length, 0) : min(index, length);
	};


/***/ },
/* 534 */
/***/ function(module, exports, __webpack_require__) {

	var anObject = __webpack_require__(58);
	var get = __webpack_require__(268);
	module.exports = __webpack_require__(21).getIterator = function (it) {
	  var iterFn = get(it);
	  if (typeof iterFn != 'function') throw TypeError(it + ' is not iterable!');
	  return anObject(iterFn.call(it));
	};


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	var classof = __webpack_require__(256);
	var ITERATOR = __webpack_require__(32)('iterator');
	var Iterators = __webpack_require__(73);
	module.exports = __webpack_require__(21).isIterable = function (it) {
	  var O = Object(it);
	  return O[ITERATOR] !== undefined
	    || '@@iterator' in O
	    // eslint-disable-next-line no-prototype-builtins
	    || Iterators.hasOwnProperty(classof(O));
	};


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var ctx = __webpack_require__(168);
	var $export = __webpack_require__(47);
	var toObject = __webpack_require__(102);
	var call = __webpack_require__(523);
	var isArrayIter = __webpack_require__(521);
	var toLength = __webpack_require__(267);
	var createProperty = __webpack_require__(518);
	var getIterFn = __webpack_require__(268);
	
	$export($export.S + $export.F * !__webpack_require__(525)(function (iter) { Array.from(iter); }), 'Array', {
	  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
	    var O = toObject(arrayLike);
	    var C = typeof this == 'function' ? this : Array;
	    var aLen = arguments.length;
	    var mapfn = aLen > 1 ? arguments[1] : undefined;
	    var mapping = mapfn !== undefined;
	    var index = 0;
	    var iterFn = getIterFn(O);
	    var length, result, step, iterator;
	    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	    // if object isn't iterable or it's array with default iterator - use simple case
	    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	      }
	    } else {
	      length = toLength(O.length);
	      for (result = new C(length); length > index; index++) {
	        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	      }
	    }
	    result.length = index;
	    return result;
	  }
	});


/***/ },
/* 537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var addToUnscopables = __webpack_require__(516);
	var step = __webpack_require__(526);
	var Iterators = __webpack_require__(73);
	var toIObject = __webpack_require__(74);
	
	// 22.1.3.4 Array.prototype.entries()
	// 22.1.3.13 Array.prototype.keys()
	// 22.1.3.29 Array.prototype.values()
	// 22.1.3.30 Array.prototype[@@iterator]()
	module.exports = __webpack_require__(260)(Array, 'Array', function (iterated, kind) {
	  this._t = toIObject(iterated); // target
	  this._i = 0;                   // next index
	  this._k = kind;                // kind
	// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	}, function () {
	  var O = this._t;
	  var kind = this._k;
	  var index = this._i++;
	  if (!O || index >= O.length) {
	    this._t = undefined;
	    return step(1);
	  }
	  if (kind == 'keys') return step(0, index);
	  if (kind == 'values') return step(0, O[index]);
	  return step(0, [index, O[index]]);
	}, 'values');
	
	// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	Iterators.Arguments = Iterators.Array;
	
	addToUnscopables('keys');
	addToUnscopables('values');
	addToUnscopables('entries');


/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.1 Object.assign(target, source)
	var $export = __webpack_require__(47);
	
	$export($export.S + $export.F, 'Object', { assign: __webpack_require__(528) });


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(47);
	// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	$export($export.S, 'Object', { create: __webpack_require__(172) });


/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	var $export = __webpack_require__(47);
	// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	$export($export.S + $export.F * !__webpack_require__(59), 'Object', { defineProperty: __webpack_require__(49).f });


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.9 Object.getPrototypeOf(O)
	var toObject = __webpack_require__(102);
	var $getPrototypeOf = __webpack_require__(263);
	
	__webpack_require__(265)('getPrototypeOf', function () {
	  return function getPrototypeOf(it) {
	    return $getPrototypeOf(toObject(it));
	  };
	});


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.2.14 Object.keys(O)
	var toObject = __webpack_require__(102);
	var $keys = __webpack_require__(100);
	
	__webpack_require__(265)('keys', function () {
	  return function keys(it) {
	    return $keys(toObject(it));
	  };
	});


/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	// 19.1.3.19 Object.setPrototypeOf(O, proto)
	var $export = __webpack_require__(47);
	$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(531).set });


/***/ },
/* 544 */
/***/ function(module, exports) {



/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	// ECMAScript 6 symbols shim
	var global = __webpack_require__(48);
	var has = __webpack_require__(60);
	var DESCRIPTORS = __webpack_require__(59);
	var $export = __webpack_require__(47);
	var redefine = __webpack_require__(266);
	var META = __webpack_require__(527).KEY;
	var $fails = __webpack_require__(70);
	var shared = __webpack_require__(176);
	var setToStringTag = __webpack_require__(174);
	var uid = __webpack_require__(127);
	var wks = __webpack_require__(32);
	var wksExt = __webpack_require__(180);
	var wksDefine = __webpack_require__(179);
	var enumKeys = __webpack_require__(519);
	var isArray = __webpack_require__(522);
	var anObject = __webpack_require__(58);
	var isObject = __webpack_require__(72);
	var toIObject = __webpack_require__(74);
	var toPrimitive = __webpack_require__(178);
	var createDesc = __webpack_require__(101);
	var _create = __webpack_require__(172);
	var gOPNExt = __webpack_require__(530);
	var $GOPD = __webpack_require__(261);
	var $DP = __webpack_require__(49);
	var $keys = __webpack_require__(100);
	var gOPD = $GOPD.f;
	var dP = $DP.f;
	var gOPN = gOPNExt.f;
	var $Symbol = global.Symbol;
	var $JSON = global.JSON;
	var _stringify = $JSON && $JSON.stringify;
	var PROTOTYPE = 'prototype';
	var HIDDEN = wks('_hidden');
	var TO_PRIMITIVE = wks('toPrimitive');
	var isEnum = {}.propertyIsEnumerable;
	var SymbolRegistry = shared('symbol-registry');
	var AllSymbols = shared('symbols');
	var OPSymbols = shared('op-symbols');
	var ObjectProto = Object[PROTOTYPE];
	var USE_NATIVE = typeof $Symbol == 'function';
	var QObject = global.QObject;
	// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	var setSymbolDesc = DESCRIPTORS && $fails(function () {
	  return _create(dP({}, 'a', {
	    get: function () { return dP(this, 'a', { value: 7 }).a; }
	  })).a != 7;
	}) ? function (it, key, D) {
	  var protoDesc = gOPD(ObjectProto, key);
	  if (protoDesc) delete ObjectProto[key];
	  dP(it, key, D);
	  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	} : dP;
	
	var wrap = function (tag) {
	  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	  sym._k = tag;
	  return sym;
	};
	
	var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
	  return typeof it == 'symbol';
	} : function (it) {
	  return it instanceof $Symbol;
	};
	
	var $defineProperty = function defineProperty(it, key, D) {
	  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	  anObject(it);
	  key = toPrimitive(key, true);
	  anObject(D);
	  if (has(AllSymbols, key)) {
	    if (!D.enumerable) {
	      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	      it[HIDDEN][key] = true;
	    } else {
	      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	      D = _create(D, { enumerable: createDesc(0, false) });
	    } return setSymbolDesc(it, key, D);
	  } return dP(it, key, D);
	};
	var $defineProperties = function defineProperties(it, P) {
	  anObject(it);
	  var keys = enumKeys(P = toIObject(P));
	  var i = 0;
	  var l = keys.length;
	  var key;
	  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
	  return it;
	};
	var $create = function create(it, P) {
	  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	};
	var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	  var E = isEnum.call(this, key = toPrimitive(key, true));
	  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	};
	var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	  it = toIObject(it);
	  key = toPrimitive(key, true);
	  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	  var D = gOPD(it, key);
	  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	  return D;
	};
	var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	  var names = gOPN(toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	  } return result;
	};
	var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	  var IS_OP = it === ObjectProto;
	  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
	  var result = [];
	  var i = 0;
	  var key;
	  while (names.length > i) {
	    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	  } return result;
	};
	
	// 19.4.1.1 Symbol([description])
	if (!USE_NATIVE) {
	  $Symbol = function Symbol() {
	    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	    var $set = function (value) {
	      if (this === ObjectProto) $set.call(OPSymbols, value);
	      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	      setSymbolDesc(this, tag, createDesc(1, value));
	    };
	    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	    return wrap(tag);
	  };
	  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	    return this._k;
	  });
	
	  $GOPD.f = $getOwnPropertyDescriptor;
	  $DP.f = $defineProperty;
	  __webpack_require__(262).f = gOPNExt.f = $getOwnPropertyNames;
	  __webpack_require__(126).f = $propertyIsEnumerable;
	  __webpack_require__(173).f = $getOwnPropertySymbols;
	
	  if (DESCRIPTORS && !__webpack_require__(171)) {
	    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	  }
	
	  wksExt.f = function (name) {
	    return wrap(wks(name));
	  };
	}
	
	$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	for (var es6Symbols = (
	  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
	).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);
	
	for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);
	
	$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	  // 19.4.2.1 Symbol.for(key)
	  'for': function (key) {
	    return has(SymbolRegistry, key += '')
	      ? SymbolRegistry[key]
	      : SymbolRegistry[key] = $Symbol(key);
	  },
	  // 19.4.2.5 Symbol.keyFor(sym)
	  keyFor: function keyFor(sym) {
	    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
	    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
	  },
	  useSetter: function () { setter = true; },
	  useSimple: function () { setter = false; }
	});
	
	$export($export.S + $export.F * !USE_NATIVE, 'Object', {
	  // 19.1.2.2 Object.create(O [, Properties])
	  create: $create,
	  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	  defineProperty: $defineProperty,
	  // 19.1.2.3 Object.defineProperties(O, Properties)
	  defineProperties: $defineProperties,
	  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	  // 19.1.2.7 Object.getOwnPropertyNames(O)
	  getOwnPropertyNames: $getOwnPropertyNames,
	  // 19.1.2.8 Object.getOwnPropertySymbols(O)
	  getOwnPropertySymbols: $getOwnPropertySymbols
	});
	
	// 24.3.2 JSON.stringify(value [, replacer [, space]])
	$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	  var S = $Symbol();
	  // MS Edge converts symbol values to JSON as {}
	  // WebKit converts symbol values to JSON as null
	  // V8 throws on boxed symbols
	  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	})), 'JSON', {
	  stringify: function stringify(it) {
	    var args = [it];
	    var i = 1;
	    var replacer, $replacer;
	    while (arguments.length > i) args.push(arguments[i++]);
	    $replacer = replacer = args[1];
	    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	    if (!isArray(replacer)) replacer = function (key, value) {
	      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
	      if (!isSymbol(value)) return value;
	    };
	    args[1] = replacer;
	    return _stringify.apply($JSON, args);
	  }
	});
	
	// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(71)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	// 19.4.3.5 Symbol.prototype[@@toStringTag]
	setToStringTag($Symbol, 'Symbol');
	// 20.2.1.9 Math[@@toStringTag]
	setToStringTag(Math, 'Math', true);
	// 24.3.3 JSON[@@toStringTag]
	setToStringTag(global.JSON, 'JSON', true);


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(179)('asyncIterator');


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(179)('observable');


/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var emptyObject = __webpack_require__(130);
	var _invariant = __webpack_require__(13);
	
	if (false) {
	  var warning = require('fbjs/lib/warning');
	}
	
	var MIXINS_KEY = 'mixins';
	
	// Helper function to allow the creation of anonymous functions which do not
	// have .name set to the name of the variable being assigned to.
	function identity(fn) {
	  return fn;
	}
	
	var ReactPropTypeLocationNames;
	if (false) {
	  ReactPropTypeLocationNames = {
	    prop: 'prop',
	    context: 'context',
	    childContext: 'child context'
	  };
	} else {
	  ReactPropTypeLocationNames = {};
	}
	
	function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
	  /**
	   * Policies that describe methods in `ReactClassInterface`.
	   */
	
	  var injectedMixins = [];
	
	  /**
	   * Composite components are higher-level components that compose other composite
	   * or host components.
	   *
	   * To create a new type of `ReactClass`, pass a specification of
	   * your new class to `React.createClass`. The only requirement of your class
	   * specification is that you implement a `render` method.
	   *
	   *   var MyComponent = React.createClass({
	   *     render: function() {
	   *       return <div>Hello World</div>;
	   *     }
	   *   });
	   *
	   * The class specification supports a specific protocol of methods that have
	   * special meaning (e.g. `render`). See `ReactClassInterface` for
	   * more the comprehensive protocol. Any other properties and methods in the
	   * class specification will be available on the prototype.
	   *
	   * @interface ReactClassInterface
	   * @internal
	   */
	  var ReactClassInterface = {
	    /**
	     * An array of Mixin objects to include when defining your component.
	     *
	     * @type {array}
	     * @optional
	     */
	    mixins: 'DEFINE_MANY',
	
	    /**
	     * An object containing properties and methods that should be defined on
	     * the component's constructor instead of its prototype (static methods).
	     *
	     * @type {object}
	     * @optional
	     */
	    statics: 'DEFINE_MANY',
	
	    /**
	     * Definition of prop types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    propTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types for this component.
	     *
	     * @type {object}
	     * @optional
	     */
	    contextTypes: 'DEFINE_MANY',
	
	    /**
	     * Definition of context types this component sets for its children.
	     *
	     * @type {object}
	     * @optional
	     */
	    childContextTypes: 'DEFINE_MANY',
	
	    // ==== Definition methods ====
	
	    /**
	     * Invoked when the component is mounted. Values in the mapping will be set on
	     * `this.props` if that prop is not specified (i.e. using an `in` check).
	     *
	     * This method is invoked before `getInitialState` and therefore cannot rely
	     * on `this.state` or use `this.setState`.
	     *
	     * @return {object}
	     * @optional
	     */
	    getDefaultProps: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Invoked once before the component is mounted. The return value will be used
	     * as the initial value of `this.state`.
	     *
	     *   getInitialState: function() {
	     *     return {
	     *       isOn: false,
	     *       fooBaz: new BazFoo()
	     *     }
	     *   }
	     *
	     * @return {object}
	     * @optional
	     */
	    getInitialState: 'DEFINE_MANY_MERGED',
	
	    /**
	     * @return {object}
	     * @optional
	     */
	    getChildContext: 'DEFINE_MANY_MERGED',
	
	    /**
	     * Uses props from `this.props` and state from `this.state` to render the
	     * structure of the component.
	     *
	     * No guarantees are made about when or how often this method is invoked, so
	     * it must not have side effects.
	     *
	     *   render: function() {
	     *     var name = this.props.name;
	     *     return <div>Hello, {name}!</div>;
	     *   }
	     *
	     * @return {ReactComponent}
	     * @required
	     */
	    render: 'DEFINE_ONCE',
	
	    // ==== Delegate methods ====
	
	    /**
	     * Invoked when the component is initially created and about to be mounted.
	     * This may have side effects, but any external subscriptions or data created
	     * by this method must be cleaned up in `componentWillUnmount`.
	     *
	     * @optional
	     */
	    componentWillMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component has been mounted and has a DOM representation.
	     * However, there is no guarantee that the DOM node is in the document.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been mounted (initialized and rendered) for the first time.
	     *
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidMount: 'DEFINE_MANY',
	
	    /**
	     * Invoked before the component receives new props.
	     *
	     * Use this as an opportunity to react to a prop transition by updating the
	     * state using `this.setState`. Current props are accessed via `this.props`.
	     *
	     *   componentWillReceiveProps: function(nextProps, nextContext) {
	     *     this.setState({
	     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
	     *     });
	     *   }
	     *
	     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
	     * transition may cause a state change, but the opposite is not true. If you
	     * need it, you are probably looking for `componentWillUpdate`.
	     *
	     * @param {object} nextProps
	     * @optional
	     */
	    componentWillReceiveProps: 'DEFINE_MANY',
	
	    /**
	     * Invoked while deciding if the component should be updated as a result of
	     * receiving new props, state and/or context.
	     *
	     * Use this as an opportunity to `return false` when you're certain that the
	     * transition to the new props/state/context will not require a component
	     * update.
	     *
	     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
	     *     return !equal(nextProps, this.props) ||
	     *       !equal(nextState, this.state) ||
	     *       !equal(nextContext, this.context);
	     *   }
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @return {boolean} True if the component should update.
	     * @optional
	     */
	    shouldComponentUpdate: 'DEFINE_ONCE',
	
	    /**
	     * Invoked when the component is about to update due to a transition from
	     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
	     * and `nextContext`.
	     *
	     * Use this as an opportunity to perform preparation before an update occurs.
	     *
	     * NOTE: You **cannot** use `this.setState()` in this method.
	     *
	     * @param {object} nextProps
	     * @param {?object} nextState
	     * @param {?object} nextContext
	     * @param {ReactReconcileTransaction} transaction
	     * @optional
	     */
	    componentWillUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component's DOM representation has been updated.
	     *
	     * Use this as an opportunity to operate on the DOM when the component has
	     * been updated.
	     *
	     * @param {object} prevProps
	     * @param {?object} prevState
	     * @param {?object} prevContext
	     * @param {DOMElement} rootNode DOM element representing the component.
	     * @optional
	     */
	    componentDidUpdate: 'DEFINE_MANY',
	
	    /**
	     * Invoked when the component is about to be removed from its parent and have
	     * its DOM representation destroyed.
	     *
	     * Use this as an opportunity to deallocate any external resources.
	     *
	     * NOTE: There is no `componentDidUnmount` since your component will have been
	     * destroyed by that point.
	     *
	     * @optional
	     */
	    componentWillUnmount: 'DEFINE_MANY',
	
	    // ==== Advanced methods ====
	
	    /**
	     * Updates the component's currently mounted DOM representation.
	     *
	     * By default, this implements React's rendering and reconciliation algorithm.
	     * Sophisticated clients may wish to override this.
	     *
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     * @overridable
	     */
	    updateComponent: 'OVERRIDE_BASE'
	  };
	
	  /**
	   * Mapping from class specification keys to special processing functions.
	   *
	   * Although these are declared like instance properties in the specification
	   * when defining classes using `React.createClass`, they are actually static
	   * and are accessible on the constructor instead of the prototype. Despite
	   * being static, they must be defined outside of the "statics" key under
	   * which all other static methods are defined.
	   */
	  var RESERVED_SPEC_KEYS = {
	    displayName: function(Constructor, displayName) {
	      Constructor.displayName = displayName;
	    },
	    mixins: function(Constructor, mixins) {
	      if (mixins) {
	        for (var i = 0; i < mixins.length; i++) {
	          mixSpecIntoComponent(Constructor, mixins[i]);
	        }
	      }
	    },
	    childContextTypes: function(Constructor, childContextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, childContextTypes, 'childContext');
	      }
	      Constructor.childContextTypes = _assign(
	        {},
	        Constructor.childContextTypes,
	        childContextTypes
	      );
	    },
	    contextTypes: function(Constructor, contextTypes) {
	      if (false) {
	        validateTypeDef(Constructor, contextTypes, 'context');
	      }
	      Constructor.contextTypes = _assign(
	        {},
	        Constructor.contextTypes,
	        contextTypes
	      );
	    },
	    /**
	     * Special case getDefaultProps which should move into statics but requires
	     * automatic merging.
	     */
	    getDefaultProps: function(Constructor, getDefaultProps) {
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps = createMergedResultFunction(
	          Constructor.getDefaultProps,
	          getDefaultProps
	        );
	      } else {
	        Constructor.getDefaultProps = getDefaultProps;
	      }
	    },
	    propTypes: function(Constructor, propTypes) {
	      if (false) {
	        validateTypeDef(Constructor, propTypes, 'prop');
	      }
	      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
	    },
	    statics: function(Constructor, statics) {
	      mixStaticSpecIntoComponent(Constructor, statics);
	    },
	    autobind: function() {}
	  };
	
	  function validateTypeDef(Constructor, typeDef, location) {
	    for (var propName in typeDef) {
	      if (typeDef.hasOwnProperty(propName)) {
	        // use a warning instead of an _invariant so components
	        // don't show up in prod but only in __DEV__
	        if (false) {
	          warning(
	            typeof typeDef[propName] === 'function',
	            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
	              'React.PropTypes.',
	            Constructor.displayName || 'ReactClass',
	            ReactPropTypeLocationNames[location],
	            propName
	          );
	        }
	      }
	    }
	  }
	
	  function validateMethodOverride(isAlreadyDefined, name) {
	    var specPolicy = ReactClassInterface.hasOwnProperty(name)
	      ? ReactClassInterface[name]
	      : null;
	
	    // Disallow overriding of base class methods unless explicitly allowed.
	    if (ReactClassMixin.hasOwnProperty(name)) {
	      _invariant(
	        specPolicy === 'OVERRIDE_BASE',
	        'ReactClassInterface: You are attempting to override ' +
	          '`%s` from your class specification. Ensure that your method names ' +
	          'do not overlap with React methods.',
	        name
	      );
	    }
	
	    // Disallow defining methods more than once unless explicitly allowed.
	    if (isAlreadyDefined) {
	      _invariant(
	        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
	        'ReactClassInterface: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be due ' +
	          'to a mixin.',
	        name
	      );
	    }
	  }
	
	  /**
	   * Mixin helper which handles policy validation and reserved
	   * specification keys when building React classes.
	   */
	  function mixSpecIntoComponent(Constructor, spec) {
	    if (!spec) {
	      if (false) {
	        var typeofSpec = typeof spec;
	        var isMixinValid = typeofSpec === 'object' && spec !== null;
	
	        if (process.env.NODE_ENV !== 'production') {
	          warning(
	            isMixinValid,
	            "%s: You're attempting to include a mixin that is either null " +
	              'or not an object. Check the mixins included by the component, ' +
	              'as well as any mixins they include themselves. ' +
	              'Expected object but got %s.',
	            Constructor.displayName || 'ReactClass',
	            spec === null ? null : typeofSpec
	          );
	        }
	      }
	
	      return;
	    }
	
	    _invariant(
	      typeof spec !== 'function',
	      "ReactClass: You're attempting to " +
	        'use a component class or function as a mixin. Instead, just use a ' +
	        'regular object.'
	    );
	    _invariant(
	      !isValidElement(spec),
	      "ReactClass: You're attempting to " +
	        'use a component as a mixin. Instead, just use a regular object.'
	    );
	
	    var proto = Constructor.prototype;
	    var autoBindPairs = proto.__reactAutoBindPairs;
	
	    // By handling mixins before any other properties, we ensure the same
	    // chaining order is applied to methods with DEFINE_MANY policy, whether
	    // mixins are listed before or after these methods in the spec.
	    if (spec.hasOwnProperty(MIXINS_KEY)) {
	      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
	    }
	
	    for (var name in spec) {
	      if (!spec.hasOwnProperty(name)) {
	        continue;
	      }
	
	      if (name === MIXINS_KEY) {
	        // We have already handled mixins in a special case above.
	        continue;
	      }
	
	      var property = spec[name];
	      var isAlreadyDefined = proto.hasOwnProperty(name);
	      validateMethodOverride(isAlreadyDefined, name);
	
	      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
	        RESERVED_SPEC_KEYS[name](Constructor, property);
	      } else {
	        // Setup methods on prototype:
	        // The following member methods should not be automatically bound:
	        // 1. Expected ReactClass methods (in the "interface").
	        // 2. Overridden methods (that were mixed in).
	        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
	        var isFunction = typeof property === 'function';
	        var shouldAutoBind =
	          isFunction &&
	          !isReactClassMethod &&
	          !isAlreadyDefined &&
	          spec.autobind !== false;
	
	        if (shouldAutoBind) {
	          autoBindPairs.push(name, property);
	          proto[name] = property;
	        } else {
	          if (isAlreadyDefined) {
	            var specPolicy = ReactClassInterface[name];
	
	            // These cases should already be caught by validateMethodOverride.
	            _invariant(
	              isReactClassMethod &&
	                (specPolicy === 'DEFINE_MANY_MERGED' ||
	                  specPolicy === 'DEFINE_MANY'),
	              'ReactClass: Unexpected spec policy %s for key %s ' +
	                'when mixing in component specs.',
	              specPolicy,
	              name
	            );
	
	            // For methods which are defined more than once, call the existing
	            // methods before calling the new property, merging if appropriate.
	            if (specPolicy === 'DEFINE_MANY_MERGED') {
	              proto[name] = createMergedResultFunction(proto[name], property);
	            } else if (specPolicy === 'DEFINE_MANY') {
	              proto[name] = createChainedFunction(proto[name], property);
	            }
	          } else {
	            proto[name] = property;
	            if (false) {
	              // Add verbose displayName to the function, which helps when looking
	              // at profiling tools.
	              if (typeof property === 'function' && spec.displayName) {
	                proto[name].displayName = spec.displayName + '_' + name;
	              }
	            }
	          }
	        }
	      }
	    }
	  }
	
	  function mixStaticSpecIntoComponent(Constructor, statics) {
	    if (!statics) {
	      return;
	    }
	    for (var name in statics) {
	      var property = statics[name];
	      if (!statics.hasOwnProperty(name)) {
	        continue;
	      }
	
	      var isReserved = name in RESERVED_SPEC_KEYS;
	      _invariant(
	        !isReserved,
	        'ReactClass: You are attempting to define a reserved ' +
	          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
	          'as an instance property instead; it will still be accessible on the ' +
	          'constructor.',
	        name
	      );
	
	      var isInherited = name in Constructor;
	      _invariant(
	        !isInherited,
	        'ReactClass: You are attempting to define ' +
	          '`%s` on your component more than once. This conflict may be ' +
	          'due to a mixin.',
	        name
	      );
	      Constructor[name] = property;
	    }
	  }
	
	  /**
	   * Merge two objects, but throw if both contain the same key.
	   *
	   * @param {object} one The first object, which is mutated.
	   * @param {object} two The second object
	   * @return {object} one after it has been mutated to contain everything in two.
	   */
	  function mergeIntoWithNoDuplicateKeys(one, two) {
	    _invariant(
	      one && two && typeof one === 'object' && typeof two === 'object',
	      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
	    );
	
	    for (var key in two) {
	      if (two.hasOwnProperty(key)) {
	        _invariant(
	          one[key] === undefined,
	          'mergeIntoWithNoDuplicateKeys(): ' +
	            'Tried to merge two objects with the same key: `%s`. This conflict ' +
	            'may be due to a mixin; in particular, this may be caused by two ' +
	            'getInitialState() or getDefaultProps() methods returning objects ' +
	            'with clashing keys.',
	          key
	        );
	        one[key] = two[key];
	      }
	    }
	    return one;
	  }
	
	  /**
	   * Creates a function that invokes two functions and merges their return values.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createMergedResultFunction(one, two) {
	    return function mergedResult() {
	      var a = one.apply(this, arguments);
	      var b = two.apply(this, arguments);
	      if (a == null) {
	        return b;
	      } else if (b == null) {
	        return a;
	      }
	      var c = {};
	      mergeIntoWithNoDuplicateKeys(c, a);
	      mergeIntoWithNoDuplicateKeys(c, b);
	      return c;
	    };
	  }
	
	  /**
	   * Creates a function that invokes two functions and ignores their return vales.
	   *
	   * @param {function} one Function to invoke first.
	   * @param {function} two Function to invoke second.
	   * @return {function} Function that invokes the two argument functions.
	   * @private
	   */
	  function createChainedFunction(one, two) {
	    return function chainedFunction() {
	      one.apply(this, arguments);
	      two.apply(this, arguments);
	    };
	  }
	
	  /**
	   * Binds a method to the component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   * @param {function} method Method to be bound.
	   * @return {function} The bound method.
	   */
	  function bindAutoBindMethod(component, method) {
	    var boundMethod = method.bind(component);
	    if (false) {
	      boundMethod.__reactBoundContext = component;
	      boundMethod.__reactBoundMethod = method;
	      boundMethod.__reactBoundArguments = null;
	      var componentName = component.constructor.displayName;
	      var _bind = boundMethod.bind;
	      boundMethod.bind = function(newThis) {
	        for (
	          var _len = arguments.length,
	            args = Array(_len > 1 ? _len - 1 : 0),
	            _key = 1;
	          _key < _len;
	          _key++
	        ) {
	          args[_key - 1] = arguments[_key];
	        }
	
	        // User is trying to bind() an autobound method; we effectively will
	        // ignore the value of "this" that the user is trying to use, so
	        // let's warn.
	        if (newThis !== component && newThis !== null) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): React component methods may only be bound to the ' +
	                'component instance. See %s',
	              componentName
	            );
	          }
	        } else if (!args.length) {
	          if (process.env.NODE_ENV !== 'production') {
	            warning(
	              false,
	              'bind(): You are binding a component method to the component. ' +
	                'React does this for you automatically in a high-performance ' +
	                'way, so you can safely remove this call. See %s',
	              componentName
	            );
	          }
	          return boundMethod;
	        }
	        var reboundMethod = _bind.apply(boundMethod, arguments);
	        reboundMethod.__reactBoundContext = component;
	        reboundMethod.__reactBoundMethod = method;
	        reboundMethod.__reactBoundArguments = args;
	        return reboundMethod;
	      };
	    }
	    return boundMethod;
	  }
	
	  /**
	   * Binds all auto-bound methods in a component.
	   *
	   * @param {object} component Component whose method is going to be bound.
	   */
	  function bindAutoBindMethods(component) {
	    var pairs = component.__reactAutoBindPairs;
	    for (var i = 0; i < pairs.length; i += 2) {
	      var autoBindKey = pairs[i];
	      var method = pairs[i + 1];
	      component[autoBindKey] = bindAutoBindMethod(component, method);
	    }
	  }
	
	  var IsMountedPreMixin = {
	    componentDidMount: function() {
	      this.__isMounted = true;
	    }
	  };
	
	  var IsMountedPostMixin = {
	    componentWillUnmount: function() {
	      this.__isMounted = false;
	    }
	  };
	
	  /**
	   * Add more to the ReactClass base class. These are all legacy features and
	   * therefore not already part of the modern ReactComponent.
	   */
	  var ReactClassMixin = {
	    /**
	     * TODO: This will be deprecated because state should always keep a consistent
	     * type signature and the only use case for this, is to avoid that.
	     */
	    replaceState: function(newState, callback) {
	      this.updater.enqueueReplaceState(this, newState, callback);
	    },
	
	    /**
	     * Checks whether or not this composite component is mounted.
	     * @return {boolean} True if mounted, false otherwise.
	     * @protected
	     * @final
	     */
	    isMounted: function() {
	      if (false) {
	        warning(
	          this.__didWarnIsMounted,
	          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
	            'subscriptions and pending requests in componentWillUnmount to ' +
	            'prevent memory leaks.',
	          (this.constructor && this.constructor.displayName) ||
	            this.name ||
	            'Component'
	        );
	        this.__didWarnIsMounted = true;
	      }
	      return !!this.__isMounted;
	    }
	  };
	
	  var ReactClassComponent = function() {};
	  _assign(
	    ReactClassComponent.prototype,
	    ReactComponent.prototype,
	    ReactClassMixin
	  );
	
	  /**
	   * Creates a composite component class given a class specification.
	   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
	   *
	   * @param {object} spec Class specification (which must define `render`).
	   * @return {function} Component constructor function.
	   * @public
	   */
	  function createClass(spec) {
	    // To keep our warnings more understandable, we'll use a little hack here to
	    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
	    // unnecessarily identify a class without displayName as 'Constructor'.
	    var Constructor = identity(function(props, context, updater) {
	      // This constructor gets overridden by mocks. The argument is used
	      // by mocks to assert on what gets mounted.
	
	      if (false) {
	        warning(
	          this instanceof Constructor,
	          'Something is calling a React component directly. Use a factory or ' +
	            'JSX instead. See: https://fb.me/react-legacyfactory'
	        );
	      }
	
	      // Wire up auto-binding
	      if (this.__reactAutoBindPairs.length) {
	        bindAutoBindMethods(this);
	      }
	
	      this.props = props;
	      this.context = context;
	      this.refs = emptyObject;
	      this.updater = updater || ReactNoopUpdateQueue;
	
	      this.state = null;
	
	      // ReactClasses doesn't have constructors. Instead, they use the
	      // getInitialState and componentWillMount methods for initialization.
	
	      var initialState = this.getInitialState ? this.getInitialState() : null;
	      if (false) {
	        // We allow auto-mocks to proceed as if they're returning null.
	        if (
	          initialState === undefined &&
	          this.getInitialState._isMockFunction
	        ) {
	          // This is probably bad practice. Consider warning here and
	          // deprecating this convenience.
	          initialState = null;
	        }
	      }
	      _invariant(
	        typeof initialState === 'object' && !Array.isArray(initialState),
	        '%s.getInitialState(): must return an object or null',
	        Constructor.displayName || 'ReactCompositeComponent'
	      );
	
	      this.state = initialState;
	    });
	    Constructor.prototype = new ReactClassComponent();
	    Constructor.prototype.constructor = Constructor;
	    Constructor.prototype.__reactAutoBindPairs = [];
	
	    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));
	
	    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
	    mixSpecIntoComponent(Constructor, spec);
	    mixSpecIntoComponent(Constructor, IsMountedPostMixin);
	
	    // Initialize the defaultProps property after all mixins have been merged.
	    if (Constructor.getDefaultProps) {
	      Constructor.defaultProps = Constructor.getDefaultProps();
	    }
	
	    if (false) {
	      // This is a tag to indicate that the use of these method names is ok,
	      // since it's used with createClass. If it's not, then it's likely a
	      // mistake so we'll warn you to use the static property, property
	      // initializer or constructor respectively.
	      if (Constructor.getDefaultProps) {
	        Constructor.getDefaultProps.isReactClassApproved = {};
	      }
	      if (Constructor.prototype.getInitialState) {
	        Constructor.prototype.getInitialState.isReactClassApproved = {};
	      }
	    }
	
	    _invariant(
	      Constructor.prototype.render,
	      'createClass(...): Class specification must implement a `render` method.'
	    );
	
	    if (false) {
	      warning(
	        !Constructor.prototype.componentShouldUpdate,
	        '%s has a method called ' +
	          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
	          'The name is phrased as a question because the function is ' +
	          'expected to return a value.',
	        spec.displayName || 'A component'
	      );
	      warning(
	        !Constructor.prototype.componentWillRecieveProps,
	        '%s has a method called ' +
	          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
	        spec.displayName || 'A component'
	      );
	    }
	
	    // Reduce time spent doing lookups by setting these on the prototype.
	    for (var methodName in ReactClassInterface) {
	      if (!Constructor.prototype[methodName]) {
	        Constructor.prototype[methodName] = null;
	      }
	    }
	
	    return Constructor;
	  }
	
	  return createClass;
	}
	
	module.exports = factory;


/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	/*
		compiles a selector to an executable function
	*/
	
	module.exports = compile;
	module.exports.compileUnsafe = compileUnsafe;
	module.exports.compileToken = compileToken;
	
	var parse       = __webpack_require__(552),
	    DomUtils    = __webpack_require__(75),
	    isTag       = DomUtils.isTag,
	    Rules       = __webpack_require__(550),
	    sortRules   = __webpack_require__(551),
	    BaseFuncs   = __webpack_require__(98),
	    trueFunc    = BaseFuncs.trueFunc,
	    falseFunc   = BaseFuncs.falseFunc,
	    procedure   = __webpack_require__(288);
	
	function compile(selector, options, context){
		var next = compileUnsafe(selector, options, context);
		return wrap(next);
	}
	
	function wrap(next){
		return function base(elem){
			return isTag(elem) && next(elem);
		};
	}
	
	function compileUnsafe(selector, options, context){
		var token = parse(selector, options);
		return compileToken(token, options, context);
	}
	
	function includesScopePseudo(t){
	    return t.type === "pseudo" && (
	        t.name === "scope" || (
	            Array.isArray(t.data) &&
	            t.data.some(function(data){
	                return data.some(includesScopePseudo);
	            })
	        )
	    );
	}
	
	var DESCENDANT_TOKEN = {type: "descendant"},
	    SCOPE_TOKEN = {type: "pseudo", name: "scope"},
	    PLACEHOLDER_ELEMENT = {},
	    getParent = DomUtils.getParent;
	
	//CSS 4 Spec (Draft): 3.3.1. Absolutizing a Scope-relative Selector
	//http://www.w3.org/TR/selectors4/#absolutizing
	function absolutize(token, context){
	    //TODO better check if context is document
	    var hasContext = !!context && !!context.length && context.every(function(e){
	        return e === PLACEHOLDER_ELEMENT || !!getParent(e);
	    });
	
	
	    token.forEach(function(t){
	        if(t.length > 0 && isTraversal(t[0]) && t[0].type !== "descendant"){
	            //don't return in else branch
	        } else if(hasContext && !includesScopePseudo(t)){
	            t.unshift(DESCENDANT_TOKEN);
	        } else {
	            return;
	        }
	
	        t.unshift(SCOPE_TOKEN);
	    });
	}
	
	function compileToken(token, options, context){
	    token = token.filter(function(t){ return t.length > 0; });
	
		token.forEach(sortRules);
	
		var isArrayContext = Array.isArray(context);
	
	    context = (options && options.context) || context;
	
	    if(context && !isArrayContext) context = [context];
	
	    absolutize(token, context);
	
		return token
			.map(function(rules){ return compileRules(rules, options, context, isArrayContext); })
			.reduce(reduceRules, falseFunc);
	}
	
	function isTraversal(t){
		return procedure[t.type] < 0;
	}
	
	function compileRules(rules, options, context, isArrayContext){
		var acceptSelf = (isArrayContext && rules[0].name === "scope" && rules[1].type === "descendant");
		return rules.reduce(function(func, rule, index){
			if(func === falseFunc) return func;
			return Rules[rule.type](func, rule, options, context, acceptSelf && index === 1);
		}, options && options.rootFunc || trueFunc);
	}
	
	function reduceRules(a, b){
		if(b === falseFunc || a === trueFunc){
			return a;
		}
		if(a === falseFunc || b === trueFunc){
			return b;
		}
	
		return function combine(elem){
			return a(elem) || b(elem);
		};
	}
	
	//:not, :has and :matches have to compile selectors
	//doing this in lib/pseudos.js would lead to circular dependencies,
	//so we add them here
	
	var Pseudos     = __webpack_require__(183),
	    filters     = Pseudos.filters,
	    existsOne   = DomUtils.existsOne,
	    isTag       = DomUtils.isTag,
	    getChildren = DomUtils.getChildren;
	
	
	function containsTraversal(t){
		return t.some(isTraversal);
	}
	
	filters.not = function(next, token, options, context){
		var opts = {
		    	xmlMode: !!(options && options.xmlMode),
		    	strict: !!(options && options.strict)
		    };
	
		if(opts.strict){
			if(token.length > 1 || token.some(containsTraversal)){
				throw new SyntaxError("complex selectors in :not aren't allowed in strict mode");
			}
		}
	
	    var func = compileToken(token, opts, context);
	
		if(func === falseFunc) return next;
		if(func === trueFunc)  return falseFunc;
	
		return function(elem){
			return !func(elem) && next(elem);
		};
	};
	
	filters.has = function(next, token, options){
		var opts = {
			xmlMode: !!(options && options.xmlMode),
			strict: !!(options && options.strict)
		};
	
	    //FIXME: Uses an array as a pointer to the current element (side effects)
	    var context = token.some(containsTraversal) ? [PLACEHOLDER_ELEMENT] : null;
	
		var func = compileToken(token, opts, context);
	
		if(func === falseFunc) return falseFunc;
		if(func === trueFunc)  return function(elem){
				return getChildren(elem).some(isTag) && next(elem);
			};
	
		func = wrap(func);
	
	    if(context){
	        return function has(elem){
			return next(elem) && (
	                (context[0] = elem), existsOne(func, getChildren(elem))
	            );
		};
	    }
	
	    return function has(elem){
			return next(elem) && existsOne(func, getChildren(elem));
		};
	};
	
	filters.matches = function(next, token, options, context){
		var opts = {
			xmlMode: !!(options && options.xmlMode),
			strict: !!(options && options.strict),
			rootFunc: next
		};
	
		return compileToken(token, opts, context);
	};


/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	var DomUtils    = __webpack_require__(75),
	    isTag       = DomUtils.isTag,
	    getParent   = DomUtils.getParent,
	    getChildren = DomUtils.getChildren,
	    getSiblings = DomUtils.getSiblings,
	    getName     = DomUtils.getName;
	
	/*
		all available rules
	*/
	module.exports = {
		__proto__: null,
	
		attribute: __webpack_require__(271).compile,
		pseudo: __webpack_require__(183).compile,
	
		//tags
		tag: function(next, data){
			var name = data.name;
			return function tag(elem){
				return getName(elem) === name && next(elem);
			};
		},
	
		//traversal
		descendant: function(next, rule, options, context, acceptSelf){
			return function descendant(elem){
	
				if (acceptSelf && next(elem)) return true;
	
				var found = false;
	
				while(!found && (elem = getParent(elem))){
					found = next(elem);
				}
	
				return found;
			};
		},
		parent: function(next, data, options){
			if(options && options.strict) throw SyntaxError("Parent selector isn't part of CSS3");
	
			return function parent(elem){
				return getChildren(elem).some(test);
			};
	
			function test(elem){
				return isTag(elem) && next(elem);
			}
		},
		child: function(next){
			return function child(elem){
				var parent = getParent(elem);
				return !!parent && next(parent);
			};
		},
		sibling: function(next){
			return function sibling(elem){
				var siblings = getSiblings(elem);
	
				for(var i = 0; i < siblings.length; i++){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						if(next(siblings[i])) return true;
					}
				}
	
				return false;
			};
		},
		adjacent: function(next){
			return function adjacent(elem){
				var siblings = getSiblings(elem),
				    lastElement;
	
				for(var i = 0; i < siblings.length; i++){
					if(isTag(siblings[i])){
						if(siblings[i] === elem) break;
						lastElement = siblings[i];
					}
				}
	
				return !!lastElement && next(lastElement);
			};
		},
		universal: function(next){
			return next;
		}
	};

/***/ },
/* 551 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = sortByProcedure;
	
	/*
		sort the parts of the passed selector,
		as there is potential for optimization
		(some types of selectors are faster than others)
	*/
	
	var procedure = __webpack_require__(288);
	
	var attributes = {
		__proto__: null,
		exists: 10,
		equals: 8,
		not: 7,
		start: 6,
		end: 6,
		any: 5,
		hyphen: 4,
		element: 4
	};
	
	function sortByProcedure(arr){
		var procs = arr.map(getProcedure);
		for(var i = 1; i < arr.length; i++){
			var procNew = procs[i];
	
			if(procNew < 0) continue;
	
			for(var j = i - 1; j >= 0 && procNew < procs[j]; j--){
				var token = arr[j + 1];
				arr[j + 1] = arr[j];
				arr[j] = token;
				procs[j + 1] = procs[j];
				procs[j] = procNew;
			}
		}
	}
	
	function getProcedure(token){
		var proc = procedure[token.type];
	
		if(proc === procedure.attribute){
			proc = attributes[token.action];
	
			if(proc === attributes.equals && token.name === "id"){
				//prefer ID selectors (eg. #ID)
				proc = 9;
			}
	
			if(token.ignoreCase){
				//ignoreCase adds some overhead, prefer "normal" token
				//this is a binary operation, to ensure it's still an int
				proc >>= 1;
			}
		} else if(proc === procedure.pseudo){
			if(!token.data){
				proc = 3;
			} else if(token.name === "has" || token.name === "contains"){
				proc = 0; //expensive in any case
			} else if(token.name === "matches" || token.name === "not"){
				proc = 0;
				for(var i = 0; i < token.data.length; i++){
					//TODO better handling of complex selectors
					if(token.data[i].length !== 1) continue;
					var cur = getProcedure(token.data[i][0]);
					//avoid executing :has or :contains
					if(cur === 0){
						proc = 0;
						break;
					}
					if(cur > proc) proc = cur;
				}
				if(token.data.length > 1 && proc > 0) proc -= 1;
			} else {
				proc = 1;
			}
		}
		return proc;
	}


/***/ },
/* 552 */
/***/ function(module, exports) {

	"use strict";
	
	module.exports = parse;
	
	var re_name = /^(?:\\.|[\w\-\u00c0-\uFFFF])+/,
	    re_escape = /\\([\da-f]{1,6}\s?|(\s)|.)/ig,
	    //modified version of https://github.com/jquery/sizzle/blob/master/src/sizzle.js#L87
	    re_attr = /^\s*((?:\\.|[\w\u00c0-\uFFFF\-])+)\s*(?:(\S?)=\s*(?:(['"])(.*?)\3|(#?(?:\\.|[\w\u00c0-\uFFFF\-])*)|)|)\s*(i)?\]/;
	
	var actionTypes = {
		__proto__: null,
		"undefined": "exists",
		"":  "equals",
		"~": "element",
		"^": "start",
		"$": "end",
		"*": "any",
		"!": "not",
		"|": "hyphen"
	};
	
	var simpleSelectors = {
		__proto__: null,
		">": "child",
		"<": "parent",
		"~": "sibling",
		"+": "adjacent"
	};
	
	var attribSelectors = {
		__proto__: null,
		"#": ["id", "equals"],
		".": ["class", "element"]
	};
	
	//pseudos, whose data-property is parsed as well
	var unpackPseudos = {
		__proto__: null,
		"has": true,
		"not": true,
		"matches": true
	};
	
	var stripQuotesFromPseudos = {
		__proto__: null,
		"contains": true,
		"icontains": true
	};
	
	var quotes = {
		__proto__: null,
		"\"": true,
		"'": true
	};
	
	//unescape function taken from https://github.com/jquery/sizzle/blob/master/src/sizzle.js#L139
	function funescape( _, escaped, escapedWhitespace ) {
		var high = "0x" + escaped - 0x10000;
		// NaN means non-codepoint
		// Support: Firefox
		// Workaround erroneous numeric interpretation of +"0x"
		return high !== high || escapedWhitespace ?
			escaped :
			// BMP codepoint
			high < 0 ?
				String.fromCharCode( high + 0x10000 ) :
				// Supplemental Plane codepoint (surrogate pair)
				String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	}
	
	function unescapeCSS(str){
		return str.replace(re_escape, funescape);
	}
	
	function isWhitespace(c){
		return c === " " || c === "\n" || c === "\t" || c === "\f" || c === "\r";
	}
	
	function parse(selector, options){
		var subselects = [];
	
		selector = parseSelector(subselects, selector + "", options);
	
		if(selector !== ""){
			throw new SyntaxError("Unmatched selector: " + selector);
		}
	
		return subselects;
	}
	
	function parseSelector(subselects, selector, options){
		var tokens = [],
			sawWS = false,
			data, firstChar, name, quot;
	
		function getName(){
			var sub = selector.match(re_name)[0];
			selector = selector.substr(sub.length);
			return unescapeCSS(sub);
		}
	
		function stripWhitespace(start){
			while(isWhitespace(selector.charAt(start))) start++;
			selector = selector.substr(start);
		}
	
		stripWhitespace(0);
	
		while(selector !== ""){
			firstChar = selector.charAt(0);
	
			if(isWhitespace(firstChar)){
				sawWS = true;
				stripWhitespace(1);
			} else if(firstChar in simpleSelectors){
				tokens.push({type: simpleSelectors[firstChar]});
				sawWS = false;
	
				stripWhitespace(1);
			} else if(firstChar === ","){
				if(tokens.length === 0){
					throw new SyntaxError("empty sub-selector");
				}
				subselects.push(tokens);
				tokens = [];
				sawWS = false;
				stripWhitespace(1);
			} else {
				if(sawWS){
					if(tokens.length > 0){
						tokens.push({type: "descendant"});
					}
					sawWS = false;
				}
	
				if(firstChar === "*"){
					selector = selector.substr(1);
					tokens.push({type: "universal"});
				} else if(firstChar in attribSelectors){
					selector = selector.substr(1);
					tokens.push({
						type: "attribute",
						name: attribSelectors[firstChar][0],
						action: attribSelectors[firstChar][1],
						value: getName(),
						ignoreCase: false
					});
				} else if(firstChar === "["){
					selector = selector.substr(1);
					data = selector.match(re_attr);
					if(!data){
						throw new SyntaxError("Malformed attribute selector: " + selector);
					}
					selector = selector.substr(data[0].length);
					name = unescapeCSS(data[1]);
	
					if(
						!options || (
							"lowerCaseAttributeNames" in options ?
								options.lowerCaseAttributeNames :
								!options.xmlMode
						)
					){
						name = name.toLowerCase();
					}
	
					tokens.push({
						type: "attribute",
						name: name,
						action: actionTypes[data[2]],
						value: unescapeCSS(data[4] || data[5] || ""),
						ignoreCase: !!data[6]
					});
	
				} else if(firstChar === ":"){
					if(selector.charAt(1) === ":"){
						selector = selector.substr(2);
						tokens.push({type: "pseudo-element", name: getName().toLowerCase()});
						continue;
					}
	
					selector = selector.substr(1);
	
					name = getName().toLowerCase();
					data = null;
	
					if(selector.charAt(0) === "("){
						if(name in unpackPseudos){
							quot = selector.charAt(1);
							var quoted = quot in quotes;
	
							selector = selector.substr(quoted + 1);
	
							data = [];
							selector = parseSelector(data, selector, options);
	
							if(quoted){
								if(selector.charAt(0) !== quot){
									throw new SyntaxError("unmatched quotes in :" + name);
								} else {
									selector = selector.substr(1);
								}
							}
	
							if(selector.charAt(0) !== ")"){
								throw new SyntaxError("missing closing parenthesis in :" + name + " " + selector);
							}
	
							selector = selector.substr(1);
						} else {
							var pos = 1, counter = 1;
	
							for(; counter > 0 && pos < selector.length; pos++){
								if(selector.charAt(pos) === "(") counter++;
								else if(selector.charAt(pos) === ")") counter--;
							}
	
							if(counter){
								throw new SyntaxError("parenthesis not matched");
							}
	
							data = selector.substr(1, pos - 2);
							selector = selector.substr(pos);
	
							if(name in stripQuotesFromPseudos){
								quot = data.charAt(0);
	
								if(quot === data.slice(-1) && quot in quotes){
									data = data.slice(1, -1);
								}
	
								data = unescapeCSS(data);
							}
						}
					}
	
					tokens.push({type: "pseudo", name: name, data: data});
				} else if(re_name.test(selector)){
					name = getName();
	
					if(!options || ("lowerCaseTags" in options ? options.lowerCaseTags : !options.xmlMode)){
						name = name.toLowerCase();
					}
	
					tokens.push({type: "tag", name: name});
				} else {
					if(tokens.length && tokens[tokens.length - 1].type === "descendant"){
						tokens.pop();
					}
					addToken(subselects, tokens);
					return selector;
				}
			}
		}
	
		addToken(subselects, tokens);
	
		return selector;
	}
	
	function addToken(subselects, tokens){
		if(subselects.length > 0 && tokens.length === 0){
			throw new SyntaxError("empty sub-selector");
		}
	
		subselects.push(tokens);
	}


/***/ },
/* 553 */
/***/ function(module, exports) {

	//Types of elements found in the DOM
	module.exports = {
		Text: "text", //Text
		Directive: "directive", //<? ... ?>
		Comment: "comment", //<!-- ... -->
		Script: "script", //<script> tags
		Style: "style", //<style> tags
		Tag: "tag", //Any tag
		CDATA: "cdata", //<![CDATA[ ... ]]>
	
		isTag: function(elem){
			return elem.type === "tag" || elem.type === "script" || elem.type === "style";
		}
	};

/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(104);
	
	var re_whitespace = /\s+/g;
	var NodePrototype = __webpack_require__(272);
	var ElementPrototype = __webpack_require__(555);
	
	function DomHandler(callback, options, elementCB){
		if(typeof callback === "object"){
			elementCB = options;
			options = callback;
			callback = null;
		} else if(typeof options === "function"){
			elementCB = options;
			options = defaultOpts;
		}
		this._callback = callback;
		this._options = options || defaultOpts;
		this._elementCB = elementCB;
		this.dom = [];
		this._done = false;
		this._tagStack = [];
		this._parser = this._parser || null;
	}
	
	//default options
	var defaultOpts = {
		normalizeWhitespace: false, //Replace all whitespace with single spaces
		withStartIndices: false, //Add startIndex properties to nodes
		withEndIndices: false, //Add endIndex properties to nodes
	};
	
	DomHandler.prototype.onparserinit = function(parser){
		this._parser = parser;
	};
	
	//Resets the handler back to starting state
	DomHandler.prototype.onreset = function(){
		DomHandler.call(this, this._callback, this._options, this._elementCB);
	};
	
	//Signals the handler that parsing is done
	DomHandler.prototype.onend = function(){
		if(this._done) return;
		this._done = true;
		this._parser = null;
		this._handleCallback(null);
	};
	
	DomHandler.prototype._handleCallback =
	DomHandler.prototype.onerror = function(error){
		if(typeof this._callback === "function"){
			this._callback(error, this.dom);
		} else {
			if(error) throw error;
		}
	};
	
	DomHandler.prototype.onclosetag = function(){
		//if(this._tagStack.pop().name !== name) this._handleCallback(Error("Tagname didn't match!"));
		
		var elem = this._tagStack.pop();
	
		if(this._options.withEndIndices){
			elem.endIndex = this._parser.endIndex;
		}
	
		if(this._elementCB) this._elementCB(elem);
	};
	
	DomHandler.prototype._createDomElement = function(properties){
		if (!this._options.withDomLvl1) return properties;
	
		var element;
		if (properties.type === "tag") {
			element = Object.create(ElementPrototype);
		} else {
			element = Object.create(NodePrototype);
		}
	
		for (var key in properties) {
			if (properties.hasOwnProperty(key)) {
				element[key] = properties[key];
			}
		}
	
		return element;
	};
	
	DomHandler.prototype._addDomElement = function(element){
		var parent = this._tagStack[this._tagStack.length - 1];
		var siblings = parent ? parent.children : this.dom;
		var previousSibling = siblings[siblings.length - 1];
	
		element.next = null;
	
		if(this._options.withStartIndices){
			element.startIndex = this._parser.startIndex;
		}
		if(this._options.withEndIndices){
			element.endIndex = this._parser.endIndex;
		}
	
		if(previousSibling){
			element.prev = previousSibling;
			previousSibling.next = element;
		} else {
			element.prev = null;
		}
	
		siblings.push(element);
		element.parent = parent || null;
	};
	
	DomHandler.prototype.onopentag = function(name, attribs){
		var properties = {
			type: name === "script" ? ElementType.Script : name === "style" ? ElementType.Style : ElementType.Tag,
			name: name,
			attribs: attribs,
			children: []
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
	
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.ontext = function(data){
		//the ignoreWhitespace is officially dropped, but for now,
		//it's an alias for normalizeWhitespace
		var normalize = this._options.normalizeWhitespace || this._options.ignoreWhitespace;
	
		var lastTag;
	
		if(!this._tagStack.length && this.dom.length && (lastTag = this.dom[this.dom.length-1]).type === ElementType.Text){
			if(normalize){
				lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
			} else {
				lastTag.data += data;
			}
		} else {
			if(
				this._tagStack.length &&
				(lastTag = this._tagStack[this._tagStack.length - 1]) &&
				(lastTag = lastTag.children[lastTag.children.length - 1]) &&
				lastTag.type === ElementType.Text
			){
				if(normalize){
					lastTag.data = (lastTag.data + data).replace(re_whitespace, " ");
				} else {
					lastTag.data += data;
				}
			} else {
				if(normalize){
					data = data.replace(re_whitespace, " ");
				}
	
				var element = this._createDomElement({
					data: data,
					type: ElementType.Text
				});
	
				this._addDomElement(element);
			}
		}
	};
	
	DomHandler.prototype.oncomment = function(data){
		var lastTag = this._tagStack[this._tagStack.length - 1];
	
		if(lastTag && lastTag.type === ElementType.Comment){
			lastTag.data += data;
			return;
		}
	
		var properties = {
			data: data,
			type: ElementType.Comment
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncdatastart = function(){
		var properties = {
			children: [{
				data: "",
				type: ElementType.Text
			}],
			type: ElementType.CDATA
		};
	
		var element = this._createDomElement(properties);
	
		this._addDomElement(element);
		this._tagStack.push(element);
	};
	
	DomHandler.prototype.oncommentend = DomHandler.prototype.oncdataend = function(){
		this._tagStack.pop();
	};
	
	DomHandler.prototype.onprocessinginstruction = function(name, data){
		var element = this._createDomElement({
			name: name,
			data: data,
			type: ElementType.Directive
		});
	
		this._addDomElement(element);
	};
	
	module.exports = DomHandler;


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	// DOM-Level-1-compliant structure
	var NodePrototype = __webpack_require__(272);
	var ElementPrototype = module.exports = Object.create(NodePrototype);
	
	var domLvl1 = {
		tagName: "name"
	};
	
	Object.keys(domLvl1).forEach(function(key) {
		var shorthand = domLvl1[key];
		Object.defineProperty(ElementPrototype, key, {
			get: function() {
				return this[shorthand] || null;
			},
			set: function(val) {
				this[shorthand] = val;
				return val;
			}
		});
	});


/***/ },
/* 556 */
/***/ function(module, exports) {

	// removeSubsets
	// Given an array of nodes, remove any member that is contained by another.
	exports.removeSubsets = function(nodes) {
		var idx = nodes.length, node, ancestor, replace;
	
		// Check if each node (or one of its ancestors) is already contained in the
		// array.
		while (--idx > -1) {
			node = ancestor = nodes[idx];
	
			// Temporarily remove the node under consideration
			nodes[idx] = null;
			replace = true;
	
			while (ancestor) {
				if (nodes.indexOf(ancestor) > -1) {
					replace = false;
					nodes.splice(idx, 1);
					break;
				}
				ancestor = ancestor.parent;
			}
	
			// If the node has been found to be unique, re-insert it.
			if (replace) {
				nodes[idx] = node;
			}
		}
	
		return nodes;
	};
	
	// Source: http://dom.spec.whatwg.org/#dom-node-comparedocumentposition
	var POSITION = {
		DISCONNECTED: 1,
		PRECEDING: 2,
		FOLLOWING: 4,
		CONTAINS: 8,
		CONTAINED_BY: 16
	};
	
	// Compare the position of one node against another node in any other document.
	// The return value is a bitmask with the following values:
	//
	// document order:
	// > There is an ordering, document order, defined on all the nodes in the
	// > document corresponding to the order in which the first character of the
	// > XML representation of each node occurs in the XML representation of the
	// > document after expansion of general entities. Thus, the document element
	// > node will be the first node. Element nodes occur before their children.
	// > Thus, document order orders element nodes in order of the occurrence of
	// > their start-tag in the XML (after expansion of entities). The attribute
	// > nodes of an element occur after the element and before its children. The
	// > relative order of attribute nodes is implementation-dependent./
	// Source:
	// http://www.w3.org/TR/DOM-Level-3-Core/glossary.html#dt-document-order
	//
	// @argument {Node} nodaA The first node to use in the comparison
	// @argument {Node} nodeB The second node to use in the comparison
	//
	// @return {Number} A bitmask describing the input nodes' relative position.
	//         See http://dom.spec.whatwg.org/#dom-node-comparedocumentposition for
	//         a description of these values.
	var comparePos = exports.compareDocumentPosition = function(nodeA, nodeB) {
		var aParents = [];
		var bParents = [];
		var current, sharedParent, siblings, aSibling, bSibling, idx;
	
		if (nodeA === nodeB) {
			return 0;
		}
	
		current = nodeA;
		while (current) {
			aParents.unshift(current);
			current = current.parent;
		}
		current = nodeB;
		while (current) {
			bParents.unshift(current);
			current = current.parent;
		}
	
		idx = 0;
		while (aParents[idx] === bParents[idx]) {
			idx++;
		}
	
		if (idx === 0) {
			return POSITION.DISCONNECTED;
		}
	
		sharedParent = aParents[idx - 1];
		siblings = sharedParent.children;
		aSibling = aParents[idx];
		bSibling = bParents[idx];
	
		if (siblings.indexOf(aSibling) > siblings.indexOf(bSibling)) {
			if (sharedParent === nodeB) {
				return POSITION.FOLLOWING | POSITION.CONTAINED_BY;
			}
			return POSITION.FOLLOWING;
		} else {
			if (sharedParent === nodeA) {
				return POSITION.PRECEDING | POSITION.CONTAINS;
			}
			return POSITION.PRECEDING;
		}
	};
	
	// Sort an array of nodes based on their relative position in the document and
	// remove any duplicate nodes. If the array contains nodes that do not belong
	// to the same document, sort order is unspecified.
	//
	// @argument {Array} nodes Array of DOM nodes
	//
	// @returns {Array} collection of unique nodes, sorted in document order
	exports.uniqueSort = function(nodes) {
		var idx = nodes.length, node, position;
	
		nodes = nodes.slice();
	
		while (--idx > -1) {
			node = nodes[idx];
			position = nodes.indexOf(node);
			if (position > -1 && position < idx) {
				nodes.splice(idx, 1);
			}
		}
		nodes.sort(function(a, b) {
			var relative = comparePos(a, b);
			if (relative & POSITION.PRECEDING) {
				return -1;
			} else if (relative & POSITION.FOLLOWING) {
				return 1;
			}
			return 0;
		});
	
		return nodes;
	};


/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(104);
	var isTag = exports.isTag = ElementType.isTag;
	
	exports.testElement = function(options, element){
		for(var key in options){
			if(!options.hasOwnProperty(key));
			else if(key === "tag_name"){
				if(!isTag(element) || !options.tag_name(element.name)){
					return false;
				}
			} else if(key === "tag_type"){
				if(!options.tag_type(element.type)) return false;
			} else if(key === "tag_contains"){
				if(isTag(element) || !options.tag_contains(element.data)){
					return false;
				}
			} else if(!element.attribs || !options[key](element.attribs[key])){
				return false;
			}
		}
		return true;
	};
	
	var Checks = {
		tag_name: function(name){
			if(typeof name === "function"){
				return function(elem){ return isTag(elem) && name(elem.name); };
			} else if(name === "*"){
				return isTag;
			} else {
				return function(elem){ return isTag(elem) && elem.name === name; };
			}
		},
		tag_type: function(type){
			if(typeof type === "function"){
				return function(elem){ return type(elem.type); };
			} else {
				return function(elem){ return elem.type === type; };
			}
		},
		tag_contains: function(data){
			if(typeof data === "function"){
				return function(elem){ return !isTag(elem) && data(elem.data); };
			} else {
				return function(elem){ return !isTag(elem) && elem.data === data; };
			}
		}
	};
	
	function getAttribCheck(attrib, value){
		if(typeof value === "function"){
			return function(elem){ return elem.attribs && value(elem.attribs[attrib]); };
		} else {
			return function(elem){ return elem.attribs && elem.attribs[attrib] === value; };
		}
	}
	
	function combineFuncs(a, b){
		return function(elem){
			return a(elem) || b(elem);
		};
	}
	
	exports.getElements = function(options, element, recurse, limit){
		var funcs = Object.keys(options).map(function(key){
			var value = options[key];
			return key in Checks ? Checks[key](value) : getAttribCheck(key, value);
		});
	
		return funcs.length === 0 ? [] : this.filter(
			funcs.reduce(combineFuncs),
			element, recurse, limit
		);
	};
	
	exports.getElementById = function(id, element, recurse){
		if(!Array.isArray(element)) element = [element];
		return this.findOne(getAttribCheck("id", id), element, recurse !== false);
	};
	
	exports.getElementsByTagName = function(name, element, recurse, limit){
		return this.filter(Checks.tag_name(name), element, recurse, limit);
	};
	
	exports.getElementsByTagType = function(type, element, recurse, limit){
		return this.filter(Checks.tag_type(type), element, recurse, limit);
	};


/***/ },
/* 558 */
/***/ function(module, exports) {

	exports.removeElement = function(elem){
		if(elem.prev) elem.prev.next = elem.next;
		if(elem.next) elem.next.prev = elem.prev;
	
		if(elem.parent){
			var childs = elem.parent.children;
			childs.splice(childs.lastIndexOf(elem), 1);
		}
	};
	
	exports.replaceElement = function(elem, replacement){
		var prev = replacement.prev = elem.prev;
		if(prev){
			prev.next = replacement;
		}
	
		var next = replacement.next = elem.next;
		if(next){
			next.prev = replacement;
		}
	
		var parent = replacement.parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs[childs.lastIndexOf(elem)] = replacement;
		}
	};
	
	exports.appendChild = function(elem, child){
		child.parent = elem;
	
		if(elem.children.push(child) !== 1){
			var sibling = elem.children[elem.children.length - 2];
			sibling.next = child;
			child.prev = sibling;
			child.next = null;
		}
	};
	
	exports.append = function(elem, next){
		var parent = elem.parent,
			currNext = elem.next;
	
		next.next = currNext;
		next.prev = elem;
		elem.next = next;
		next.parent = parent;
	
		if(currNext){
			currNext.prev = next;
			if(parent){
				var childs = parent.children;
				childs.splice(childs.lastIndexOf(currNext), 0, next);
			}
		} else if(parent){
			parent.children.push(next);
		}
	};
	
	exports.prepend = function(elem, prev){
		var parent = elem.parent;
		if(parent){
			var childs = parent.children;
			childs.splice(childs.lastIndexOf(elem), 0, prev);
		}
	
		if(elem.prev){
			elem.prev.next = prev;
		}
		
		prev.parent = parent;
		prev.prev = elem.prev;
		prev.next = elem;
		elem.prev = prev;
	};
	
	


/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	var isTag = __webpack_require__(104).isTag;
	
	module.exports = {
		filter: filter,
		find: find,
		findOneChild: findOneChild,
		findOne: findOne,
		existsOne: existsOne,
		findAll: findAll
	};
	
	function filter(test, element, recurse, limit){
		if(!Array.isArray(element)) element = [element];
	
		if(typeof limit !== "number" || !isFinite(limit)){
			limit = Infinity;
		}
		return find(test, element, recurse !== false, limit);
	}
	
	function find(test, elems, recurse, limit){
		var result = [], childs;
	
		for(var i = 0, j = elems.length; i < j; i++){
			if(test(elems[i])){
				result.push(elems[i]);
				if(--limit <= 0) break;
			}
	
			childs = elems[i].children;
			if(recurse && childs && childs.length > 0){
				childs = find(test, childs, recurse, limit);
				result = result.concat(childs);
				limit -= childs.length;
				if(limit <= 0) break;
			}
		}
	
		return result;
	}
	
	function findOneChild(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(test(elems[i])) return elems[i];
		}
	
		return null;
	}
	
	function findOne(test, elems){
		var elem = null;
	
		for(var i = 0, l = elems.length; i < l && !elem; i++){
			if(!isTag(elems[i])){
				continue;
			} else if(test(elems[i])){
				elem = elems[i];
			} else if(elems[i].children.length > 0){
				elem = findOne(test, elems[i].children);
			}
		}
	
		return elem;
	}
	
	function existsOne(test, elems){
		for(var i = 0, l = elems.length; i < l; i++){
			if(
				isTag(elems[i]) && (
					test(elems[i]) || (
						elems[i].children.length > 0 &&
						existsOne(test, elems[i].children)
					)
				)
			){
				return true;
			}
		}
	
		return false;
	}
	
	function findAll(test, elems){
		var result = [];
		for(var i = 0, j = elems.length; i < j; i++){
			if(!isTag(elems[i])) continue;
			if(test(elems[i])) result.push(elems[i]);
	
			if(elems[i].children.length > 0){
				result = result.concat(findAll(test, elems[i].children));
			}
		}
		return result;
	}


/***/ },
/* 560 */
/***/ function(module, exports, __webpack_require__) {

	var ElementType = __webpack_require__(104),
	    getOuterHTML = __webpack_require__(184),
	    isTag = ElementType.isTag;
	
	module.exports = {
		getInnerHTML: getInnerHTML,
		getOuterHTML: getOuterHTML,
		getText: getText
	};
	
	function getInnerHTML(elem, opts){
		return elem.children ? elem.children.map(function(elem){
			return getOuterHTML(elem, opts);
		}).join("") : "";
	}
	
	function getText(elem){
		if(Array.isArray(elem)) return elem.map(getText).join("");
		if(isTag(elem) || elem.type === ElementType.CDATA) return getText(elem.children);
		if(elem.type === ElementType.Text) return elem.data;
		return "";
	}


/***/ },
/* 561 */
/***/ function(module, exports) {

	var getChildren = exports.getChildren = function(elem){
		return elem.children;
	};
	
	var getParent = exports.getParent = function(elem){
		return elem.parent;
	};
	
	exports.getSiblings = function(elem){
		var parent = getParent(elem);
		return parent ? getChildren(parent) : [elem];
	};
	
	exports.getAttributeValue = function(elem, name){
		return elem.attribs && elem.attribs[name];
	};
	
	exports.hasAttrib = function(elem, name){
		return !!elem.attribs && hasOwnProperty.call(elem.attribs, name);
	};
	
	exports.getName = function(elem){
		return elem.name;
	};


/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	var encode = __webpack_require__(564),
	    decode = __webpack_require__(563);
	
	exports.decode = function(data, level){
		return (!level || level <= 0 ? decode.XML : decode.HTML)(data);
	};
	
	exports.decodeStrict = function(data, level){
		return (!level || level <= 0 ? decode.XML : decode.HTMLStrict)(data);
	};
	
	exports.encode = function(data, level){
		return (!level || level <= 0 ? encode.XML : encode.HTML)(data);
	};
	
	exports.encodeXML = encode.XML;
	
	exports.encodeHTML4 =
	exports.encodeHTML5 =
	exports.encodeHTML  = encode.HTML;
	
	exports.decodeXML =
	exports.decodeXMLStrict = decode.XML;
	
	exports.decodeHTML4 =
	exports.decodeHTML5 =
	exports.decodeHTML = decode.HTML;
	
	exports.decodeHTML4Strict =
	exports.decodeHTML5Strict =
	exports.decodeHTMLStrict = decode.HTMLStrict;
	
	exports.escape = encode.escape;


/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	var entityMap = __webpack_require__(187),
	    legacyMap = __webpack_require__(289),
	    xmlMap    = __webpack_require__(188),
	    decodeCodePoint = __webpack_require__(273);
	
	var decodeXMLStrict  = getStrictDecoder(xmlMap),
	    decodeHTMLStrict = getStrictDecoder(entityMap);
	
	function getStrictDecoder(map){
		var keys = Object.keys(map).join("|"),
		    replace = getReplacer(map);
	
		keys += "|#[xX][\\da-fA-F]+|#\\d+";
	
		var re = new RegExp("&(?:" + keys + ");", "g");
	
		return function(str){
			return String(str).replace(re, replace);
		};
	}
	
	var decodeHTML = (function(){
		var legacy = Object.keys(legacyMap)
			.sort(sorter);
	
		var keys = Object.keys(entityMap)
			.sort(sorter);
	
		for(var i = 0, j = 0; i < keys.length; i++){
			if(legacy[j] === keys[i]){
				keys[i] += ";?";
				j++;
			} else {
				keys[i] += ";";
			}
		}
	
		var re = new RegExp("&(?:" + keys.join("|") + "|#[xX][\\da-fA-F]+;?|#\\d+;?)", "g"),
		    replace = getReplacer(entityMap);
	
		function replacer(str){
			if(str.substr(-1) !== ";") str += ";";
			return replace(str);
		}
	
		//TODO consider creating a merged map
		return function(str){
			return String(str).replace(re, replacer);
		};
	}());
	
	function sorter(a, b){
		return a < b ? 1 : -1;
	}
	
	function getReplacer(map){
		return function replace(str){
			if(str.charAt(1) === "#"){
				if(str.charAt(2) === "X" || str.charAt(2) === "x"){
					return decodeCodePoint(parseInt(str.substr(3), 16));
				}
				return decodeCodePoint(parseInt(str.substr(2), 10));
			}
			return map[str.slice(1, -1)];
		};
	}
	
	module.exports = {
		XML: decodeXMLStrict,
		HTML: decodeHTML,
		HTMLStrict: decodeHTMLStrict
	};

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	var inverseXML = getInverseObj(__webpack_require__(188)),
	    xmlReplacer = getInverseReplacer(inverseXML);
	
	exports.XML = getInverse(inverseXML, xmlReplacer);
	
	var inverseHTML = getInverseObj(__webpack_require__(187)),
	    htmlReplacer = getInverseReplacer(inverseHTML);
	
	exports.HTML = getInverse(inverseHTML, htmlReplacer);
	
	function getInverseObj(obj){
		return Object.keys(obj).sort().reduce(function(inverse, name){
			inverse[obj[name]] = "&" + name + ";";
			return inverse;
		}, {});
	}
	
	function getInverseReplacer(inverse){
		var single = [],
		    multiple = [];
	
		Object.keys(inverse).forEach(function(k){
			if(k.length === 1){
				single.push("\\" + k);
			} else {
				multiple.push(k);
			}
		});
	
		//TODO add ranges
		multiple.unshift("[" + single.join("") + "]");
	
		return new RegExp(multiple.join("|"), "g");
	}
	
	var re_nonASCII = /[^\0-\x7F]/g,
	    re_astralSymbols = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
	
	function singleCharReplacer(c){
		return "&#x" + c.charCodeAt(0).toString(16).toUpperCase() + ";";
	}
	
	function astralReplacer(c){
		// http://mathiasbynens.be/notes/javascript-encoding#surrogate-formulae
		var high = c.charCodeAt(0);
		var low  = c.charCodeAt(1);
		var codePoint = (high - 0xD800) * 0x400 + low - 0xDC00 + 0x10000;
		return "&#x" + codePoint.toString(16).toUpperCase() + ";";
	}
	
	function getInverse(inverse, re){
		function func(name){
			return inverse[name];
		}
	
		return function(data){
			return data
					.replace(re, func)
					.replace(re_astralSymbols, astralReplacer)
					.replace(re_nonASCII, singleCharReplacer);
		};
	}
	
	var re_xmlChars = getInverseReplacer(inverseXML);
	
	function escapeXML(data){
		return data
				.replace(re_xmlChars, singleCharReplacer)
				.replace(re_astralSymbols, astralReplacer)
				.replace(re_nonASCII, singleCharReplacer);
	}
	
	exports.escape = escapeXML;


/***/ },
/* 565 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 566 */
565,
/* 567 */
565,
/* 568 */
565,
/* 569 */
565,
/* 570 */
565,
/* 571 */
565,
/* 572 */
565,
/* 573 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _hyphenPattern = /-(.)/g;
	
	/**
	 * Camelcases a hyphenated string, for example:
	 *
	 *   > camelize('background-color')
	 *   < "backgroundColor"
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelize(string) {
	  return string.replace(_hyphenPattern, function (_, character) {
	    return character.toUpperCase();
	  });
	}
	
	module.exports = camelize;

/***/ },
/* 574 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var camelize = __webpack_require__(573);
	
	var msPattern = /^-ms-/;
	
	/**
	 * Camelcases a hyphenated CSS property name, for example:
	 *
	 *   > camelizeStyleName('background-color')
	 *   < "backgroundColor"
	 *   > camelizeStyleName('-moz-transition')
	 *   < "MozTransition"
	 *   > camelizeStyleName('-ms-transition')
	 *   < "msTransition"
	 *
	 * As Andi Smith suggests
	 * (http://www.andismith.com/blog/2012/02/modernizr-prefixed/), an `-ms` prefix
	 * is converted to lowercase `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function camelizeStyleName(string) {
	  return camelize(string.replace(msPattern, 'ms-'));
	}
	
	module.exports = camelizeStyleName;

/***/ },
/* 575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	var isTextNode = __webpack_require__(583);
	
	/*eslint-disable no-bitwise */
	
	/**
	 * Checks if a given DOM node contains or is another DOM node.
	 */
	function containsNode(outerNode, innerNode) {
	  if (!outerNode || !innerNode) {
	    return false;
	  } else if (outerNode === innerNode) {
	    return true;
	  } else if (isTextNode(outerNode)) {
	    return false;
	  } else if (isTextNode(innerNode)) {
	    return containsNode(outerNode, innerNode.parentNode);
	  } else if ('contains' in outerNode) {
	    return outerNode.contains(innerNode);
	  } else if (outerNode.compareDocumentPosition) {
	    return !!(outerNode.compareDocumentPosition(innerNode) & 16);
	  } else {
	    return false;
	  }
	}
	
	module.exports = containsNode;

/***/ },
/* 576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Convert array-like objects to arrays.
	 *
	 * This API assumes the caller knows the contents of the data type. For less
	 * well defined inputs use createArrayFromMixed.
	 *
	 * @param {object|function|filelist} obj
	 * @return {array}
	 */
	function toArray(obj) {
	  var length = obj.length;
	
	  // Some browsers builtin objects can report typeof 'function' (e.g. NodeList
	  // in old versions of Safari).
	  !(!Array.isArray(obj) && (typeof obj === 'object' || typeof obj === 'function')) ?  false ? invariant(false, 'toArray: Array-like object expected') : invariant(false) : void 0;
	
	  !(typeof length === 'number') ?  false ? invariant(false, 'toArray: Object needs a length property') : invariant(false) : void 0;
	
	  !(length === 0 || length - 1 in obj) ?  false ? invariant(false, 'toArray: Object should have keys for indices') : invariant(false) : void 0;
	
	  !(typeof obj.callee !== 'function') ?  false ? invariant(false, 'toArray: Object can\'t be `arguments`. Use rest params ' + '(function(...args) {}) or Array.from() instead.') : invariant(false) : void 0;
	
	  // Old IE doesn't give collections access to hasOwnProperty. Assume inputs
	  // without method will throw during the slice call and skip straight to the
	  // fallback.
	  if (obj.hasOwnProperty) {
	    try {
	      return Array.prototype.slice.call(obj);
	    } catch (e) {
	      // IE < 9 does not support Array#slice on collections objects
	    }
	  }
	
	  // Fall back to copying key by key. This assumes all keys have a value,
	  // so will not preserve sparsely populated inputs.
	  var ret = Array(length);
	  for (var ii = 0; ii < length; ii++) {
	    ret[ii] = obj[ii];
	  }
	  return ret;
	}
	
	/**
	 * Perform a heuristic test to determine if an object is "array-like".
	 *
	 *   A monk asked Joshu, a Zen master, "Has a dog Buddha nature?"
	 *   Joshu replied: "Mu."
	 *
	 * This function determines if its argument has "array nature": it returns
	 * true if the argument is an actual array, an `arguments' object, or an
	 * HTMLCollection (e.g. node.childNodes or node.getElementsByTagName()).
	 *
	 * It will return false for other array-like objects like Filelist.
	 *
	 * @param {*} obj
	 * @return {boolean}
	 */
	function hasArrayNature(obj) {
	  return (
	    // not null/false
	    !!obj && (
	    // arrays are objects, NodeLists are functions in Safari
	    typeof obj == 'object' || typeof obj == 'function') &&
	    // quacks like an array
	    'length' in obj &&
	    // not window
	    !('setInterval' in obj) &&
	    // no DOM node should be considered an array-like
	    // a 'select' element has 'length' and 'item' properties on IE8
	    typeof obj.nodeType != 'number' && (
	    // a real array
	    Array.isArray(obj) ||
	    // arguments
	    'callee' in obj ||
	    // HTMLCollection/NodeList
	    'item' in obj)
	  );
	}
	
	/**
	 * Ensure that the argument is an array by wrapping it in an array if it is not.
	 * Creates a copy of the argument if it is already an array.
	 *
	 * This is mostly useful idiomatically:
	 *
	 *   var createArrayFromMixed = require('createArrayFromMixed');
	 *
	 *   function takesOneOrMoreThings(things) {
	 *     things = createArrayFromMixed(things);
	 *     ...
	 *   }
	 *
	 * This allows you to treat `things' as an array, but accept scalars in the API.
	 *
	 * If you need to convert an array-like object, like `arguments`, into an array
	 * use toArray instead.
	 *
	 * @param {*} obj
	 * @return {array}
	 */
	function createArrayFromMixed(obj) {
	  if (!hasArrayNature(obj)) {
	    return [obj];
	  } else if (Array.isArray(obj)) {
	    return obj.slice();
	  } else {
	    return toArray(obj);
	  }
	}
	
	module.exports = createArrayFromMixed;

/***/ },
/* 577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/*eslint-disable fb-www/unsafe-html*/
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	var createArrayFromMixed = __webpack_require__(576);
	var getMarkupWrap = __webpack_require__(578);
	var invariant = __webpack_require__(13);
	
	/**
	 * Dummy container used to render all markup.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Pattern used by `getNodeName`.
	 */
	var nodeNamePattern = /^\s*<(\w+)/;
	
	/**
	 * Extracts the `nodeName` of the first element in a string of markup.
	 *
	 * @param {string} markup String of markup.
	 * @return {?string} Node name of the supplied markup.
	 */
	function getNodeName(markup) {
	  var nodeNameMatch = markup.match(nodeNamePattern);
	  return nodeNameMatch && nodeNameMatch[1].toLowerCase();
	}
	
	/**
	 * Creates an array containing the nodes rendered from the supplied markup. The
	 * optionally supplied `handleScript` function will be invoked once for each
	 * <script> element that is rendered. If no `handleScript` function is supplied,
	 * an exception is thrown if any <script> elements are rendered.
	 *
	 * @param {string} markup A string of valid HTML markup.
	 * @param {?function} handleScript Invoked once for each rendered <script>.
	 * @return {array<DOMElement|DOMTextNode>} An array of rendered nodes.
	 */
	function createNodesFromMarkup(markup, handleScript) {
	  var node = dummyNode;
	  !!!dummyNode ?  false ? invariant(false, 'createNodesFromMarkup dummy not initialized') : invariant(false) : void 0;
	  var nodeName = getNodeName(markup);
	
	  var wrap = nodeName && getMarkupWrap(nodeName);
	  if (wrap) {
	    node.innerHTML = wrap[1] + markup + wrap[2];
	
	    var wrapDepth = wrap[0];
	    while (wrapDepth--) {
	      node = node.lastChild;
	    }
	  } else {
	    node.innerHTML = markup;
	  }
	
	  var scripts = node.getElementsByTagName('script');
	  if (scripts.length) {
	    !handleScript ?  false ? invariant(false, 'createNodesFromMarkup(...): Unexpected <script> element rendered.') : invariant(false) : void 0;
	    createArrayFromMixed(scripts).forEach(handleScript);
	  }
	
	  var nodes = Array.from(node.childNodes);
	  while (node.lastChild) {
	    node.removeChild(node.lastChild);
	  }
	  return nodes;
	}
	
	module.exports = createNodesFromMarkup;

/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/*eslint-disable fb-www/unsafe-html */
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Dummy container used to detect which wraps are necessary.
	 */
	var dummyNode = ExecutionEnvironment.canUseDOM ? document.createElement('div') : null;
	
	/**
	 * Some browsers cannot use `innerHTML` to render certain elements standalone,
	 * so we wrap them, render the wrapped nodes, then extract the desired node.
	 *
	 * In IE8, certain elements cannot render alone, so wrap all elements ('*').
	 */
	
	var shouldWrap = {};
	
	var selectWrap = [1, '<select multiple="true">', '</select>'];
	var tableWrap = [1, '<table>', '</table>'];
	var trWrap = [3, '<table><tbody><tr>', '</tr></tbody></table>'];
	
	var svgWrap = [1, '<svg xmlns="http://www.w3.org/2000/svg">', '</svg>'];
	
	var markupWrap = {
	  '*': [1, '?<div>', '</div>'],
	
	  'area': [1, '<map>', '</map>'],
	  'col': [2, '<table><tbody></tbody><colgroup>', '</colgroup></table>'],
	  'legend': [1, '<fieldset>', '</fieldset>'],
	  'param': [1, '<object>', '</object>'],
	  'tr': [2, '<table><tbody>', '</tbody></table>'],
	
	  'optgroup': selectWrap,
	  'option': selectWrap,
	
	  'caption': tableWrap,
	  'colgroup': tableWrap,
	  'tbody': tableWrap,
	  'tfoot': tableWrap,
	  'thead': tableWrap,
	
	  'td': trWrap,
	  'th': trWrap
	};
	
	// Initialize the SVG elements since we know they'll always need to be wrapped
	// consistently. If they are created inside a <div> they will be initialized in
	// the wrong namespace (and will not display).
	var svgElements = ['circle', 'clipPath', 'defs', 'ellipse', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'text', 'tspan'];
	svgElements.forEach(function (nodeName) {
	  markupWrap[nodeName] = svgWrap;
	  shouldWrap[nodeName] = true;
	});
	
	/**
	 * Gets the markup wrap configuration for the supplied `nodeName`.
	 *
	 * NOTE: This lazily detects which wraps are necessary for the current browser.
	 *
	 * @param {string} nodeName Lowercase `nodeName`.
	 * @return {?array} Markup wrap configuration, if applicable.
	 */
	function getMarkupWrap(nodeName) {
	  !!!dummyNode ?  false ? invariant(false, 'Markup wrapping node not initialized') : invariant(false) : void 0;
	  if (!markupWrap.hasOwnProperty(nodeName)) {
	    nodeName = '*';
	  }
	  if (!shouldWrap.hasOwnProperty(nodeName)) {
	    if (nodeName === '*') {
	      dummyNode.innerHTML = '<link />';
	    } else {
	      dummyNode.innerHTML = '<' + nodeName + '></' + nodeName + '>';
	    }
	    shouldWrap[nodeName] = !dummyNode.firstChild;
	  }
	  return shouldWrap[nodeName] ? markupWrap[nodeName] : null;
	}
	
	module.exports = getMarkupWrap;

/***/ },
/* 579 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	/**
	 * Gets the scroll position of the supplied element or window.
	 *
	 * The return values are unbounded, unlike `getScrollPosition`. This means they
	 * may be negative or exceed the element boundaries (which is possible using
	 * inertial scrolling).
	 *
	 * @param {DOMWindow|DOMElement} scrollable
	 * @return {object} Map with `x` and `y` keys.
	 */
	
	function getUnboundedScrollPosition(scrollable) {
	  if (scrollable.Window && scrollable instanceof scrollable.Window) {
	    return {
	      x: scrollable.pageXOffset || scrollable.document.documentElement.scrollLeft,
	      y: scrollable.pageYOffset || scrollable.document.documentElement.scrollTop
	    };
	  }
	  return {
	    x: scrollable.scrollLeft,
	    y: scrollable.scrollTop
	  };
	}
	
	module.exports = getUnboundedScrollPosition;

/***/ },
/* 580 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var _uppercasePattern = /([A-Z])/g;
	
	/**
	 * Hyphenates a camelcased string, for example:
	 *
	 *   > hyphenate('backgroundColor')
	 *   < "background-color"
	 *
	 * For CSS style names, use `hyphenateStyleName` instead which works properly
	 * with all vendor prefixes, including `ms`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenate(string) {
	  return string.replace(_uppercasePattern, '-$1').toLowerCase();
	}
	
	module.exports = hyphenate;

/***/ },
/* 581 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	'use strict';
	
	var hyphenate = __webpack_require__(580);
	
	var msPattern = /^ms-/;
	
	/**
	 * Hyphenates a camelcased CSS property name, for example:
	 *
	 *   > hyphenateStyleName('backgroundColor')
	 *   < "background-color"
	 *   > hyphenateStyleName('MozTransition')
	 *   < "-moz-transition"
	 *   > hyphenateStyleName('msTransition')
	 *   < "-ms-transition"
	 *
	 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
	 * is converted to `-ms-`.
	 *
	 * @param {string} string
	 * @return {string}
	 */
	function hyphenateStyleName(string) {
	  return hyphenate(string).replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;

/***/ },
/* 582 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM node.
	 */
	function isNode(object) {
	  var doc = object ? object.ownerDocument || object : document;
	  var defaultView = doc.defaultView || window;
	  return !!(object && (typeof defaultView.Node === 'function' ? object instanceof defaultView.Node : typeof object === 'object' && typeof object.nodeType === 'number' && typeof object.nodeName === 'string'));
	}
	
	module.exports = isNode;

/***/ },
/* 583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * @typechecks
	 */
	
	var isNode = __webpack_require__(582);
	
	/**
	 * @param {*} object The object to check.
	 * @return {boolean} Whether or not the object is a DOM text node.
	 */
	function isTextNode(object) {
	  return isNode(object) && object.nodeType == 3;
	}
	
	module.exports = isTextNode;

/***/ },
/* 584 */
/***/ function(module, exports) {

	"use strict";
	
	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/**
	 * Allows extraction of a minified key. Let's the build system minify keys
	 * without losing the ability to dynamically use key strings as values
	 * themselves. Pass in an object with a single key/val pair and it will return
	 * you the string key of that single record. Suppose you want to grab the
	 * value for a key 'className' inside of an object. Key/val minification may
	 * have aliased that key to be 'xa12'. keyOf({className: null}) will return
	 * 'xa12' in that case. Resolve keys you want to use once at startup time, then
	 * reuse those resolutions.
	 */
	var keyOf = function keyOf(oneKeyObj) {
	  var key;
	  for (key in oneKeyObj) {
	    if (!oneKeyObj.hasOwnProperty(key)) {
	      continue;
	    }
	    return key;
	  }
	  return null;
	};
	
	module.exports = keyOf;

/***/ },
/* 585 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 * @typechecks static-only
	 */
	
	'use strict';
	
	/**
	 * Memoizes the return value of a function that accepts one string argument.
	 */
	
	function memoizeStringOnly(callback) {
	  var cache = {};
	  return function (string) {
	    if (!cache.hasOwnProperty(string)) {
	      cache[string] = callback.call(this, string);
	    }
	    return cache[string];
	  };
	}
	
	module.exports = memoizeStringOnly;

/***/ },
/* 586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createPath = exports.parsePath = exports.locationsAreEqual = exports.createLocation = exports.createMemoryHistory = exports.createHashHistory = exports.createBrowserHistory = undefined;
	
	var _LocationUtils = __webpack_require__(131);
	
	Object.defineProperty(exports, 'createLocation', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.createLocation;
	  }
	});
	Object.defineProperty(exports, 'locationsAreEqual', {
	  enumerable: true,
	  get: function get() {
	    return _LocationUtils.locationsAreEqual;
	  }
	});
	
	var _PathUtils = __webpack_require__(76);
	
	Object.defineProperty(exports, 'parsePath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.parsePath;
	  }
	});
	Object.defineProperty(exports, 'createPath', {
	  enumerable: true,
	  get: function get() {
	    return _PathUtils.createPath;
	  }
	});
	
	var _createBrowserHistory2 = __webpack_require__(278);
	
	var _createBrowserHistory3 = _interopRequireDefault(_createBrowserHistory2);
	
	var _createHashHistory2 = __webpack_require__(279);
	
	var _createHashHistory3 = _interopRequireDefault(_createHashHistory2);
	
	var _createMemoryHistory2 = __webpack_require__(280);
	
	var _createMemoryHistory3 = _interopRequireDefault(_createMemoryHistory2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.createBrowserHistory = _createBrowserHistory3.default;
	exports.createHashHistory = _createHashHistory3.default;
	exports.createMemoryHistory = _createMemoryHistory3.default;

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = CollectingHandler;
	
	function CollectingHandler(cbs){
		this._cbs = cbs || {};
		this.events = [];
	}
	
	var EVENTS = __webpack_require__(77).EVENTS;
	Object.keys(EVENTS).forEach(function(name){
		if(EVENTS[name] === 0){
			name = "on" + name;
			CollectingHandler.prototype[name] = function(){
				this.events.push([name]);
				if(this._cbs[name]) this._cbs[name]();
			};
		} else if(EVENTS[name] === 1){
			name = "on" + name;
			CollectingHandler.prototype[name] = function(a){
				this.events.push([name, a]);
				if(this._cbs[name]) this._cbs[name](a);
			};
		} else if(EVENTS[name] === 2){
			name = "on" + name;
			CollectingHandler.prototype[name] = function(a, b){
				this.events.push([name, a, b]);
				if(this._cbs[name]) this._cbs[name](a, b);
			};
		} else {
			throw Error("wrong number of arguments");
		}
	});
	
	CollectingHandler.prototype.onreset = function(){
		this.events = [];
		if(this._cbs.onreset) this._cbs.onreset();
	};
	
	CollectingHandler.prototype.restart = function(){
		if(this._cbs.onreset) this._cbs.onreset();
	
		for(var i = 0, len = this.events.length; i < len; i++){
			if(this._cbs[this.events[i][0]]){
	
				var num = this.events[i].length;
	
				if(num === 1){
					this._cbs[this.events[i][0]]();
				} else if(num === 2){
					this._cbs[this.events[i][0]](this.events[i][1]);
				} else {
					this._cbs[this.events[i][0]](this.events[i][1], this.events[i][2]);
				}
			}
		}
	};


/***/ },
/* 588 */
/***/ function(module, exports, __webpack_require__) {

	var index = __webpack_require__(77),
	    DomHandler = index.DomHandler,
	    DomUtils = index.DomUtils;
	
	//TODO: make this a streamable handler
	function FeedHandler(callback, options){
		this.init(callback, options);
	}
	
	__webpack_require__(38)(FeedHandler, DomHandler);
	
	FeedHandler.prototype.init = DomHandler;
	
	function getElements(what, where){
		return DomUtils.getElementsByTagName(what, where, true);
	}
	function getOneElement(what, where){
		return DomUtils.getElementsByTagName(what, where, true, 1)[0];
	}
	function fetch(what, where, recurse){
		return DomUtils.getText(
			DomUtils.getElementsByTagName(what, where, recurse, 1)
		).trim();
	}
	
	function addConditionally(obj, prop, what, where, recurse){
		var tmp = fetch(what, where, recurse);
		if(tmp) obj[prop] = tmp;
	}
	
	var isValidFeed = function(value){
		return value === "rss" || value === "feed" || value === "rdf:RDF";
	};
	
	FeedHandler.prototype.onend = function(){
		var feed = {},
		    feedRoot = getOneElement(isValidFeed, this.dom),
		    tmp, childs;
	
		if(feedRoot){
			if(feedRoot.name === "feed"){
				childs = feedRoot.children;
	
				feed.type = "atom";
				addConditionally(feed, "id", "id", childs);
				addConditionally(feed, "title", "title", childs);
				if((tmp = getOneElement("link", childs)) && (tmp = tmp.attribs) && (tmp = tmp.href)) feed.link = tmp;
				addConditionally(feed, "description", "subtitle", childs);
				if((tmp = fetch("updated", childs))) feed.updated = new Date(tmp);
				addConditionally(feed, "author", "email", childs, true);
	
				feed.items = getElements("entry", childs).map(function(item){
					var entry = {}, tmp;
	
					item = item.children;
	
					addConditionally(entry, "id", "id", item);
					addConditionally(entry, "title", "title", item);
					if((tmp = getOneElement("link", item)) && (tmp = tmp.attribs) && (tmp = tmp.href)) entry.link = tmp;
					if((tmp = fetch("summary", item) || fetch("content", item))) entry.description = tmp;
					if((tmp = fetch("updated", item))) entry.pubDate = new Date(tmp);
					return entry;
				});
			} else {
				childs = getOneElement("channel", feedRoot.children).children;
	
				feed.type = feedRoot.name.substr(0, 3);
				feed.id = "";
				addConditionally(feed, "title", "title", childs);
				addConditionally(feed, "link", "link", childs);
				addConditionally(feed, "description", "description", childs);
				if((tmp = fetch("lastBuildDate", childs))) feed.updated = new Date(tmp);
				addConditionally(feed, "author", "managingEditor", childs, true);
	
				feed.items = getElements("item", feedRoot.children).map(function(item){
					var entry = {}, tmp;
	
					item = item.children;
	
					addConditionally(entry, "id", "guid", item);
					addConditionally(entry, "title", "title", item);
					addConditionally(entry, "link", "link", item);
					addConditionally(entry, "description", "description", item);
					if((tmp = fetch("pubDate", item))) entry.pubDate = new Date(tmp);
					return entry;
				});
			}
		}
		this.dom = feed;
		DomHandler.prototype._handleCallback.call(
			this, feedRoot ? null : Error("couldn't find root of feed")
		);
	};
	
	module.exports = FeedHandler;


/***/ },
/* 589 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = ProxyHandler;
	
	function ProxyHandler(cbs){
		this._cbs = cbs || {};
	}
	
	var EVENTS = __webpack_require__(77).EVENTS;
	Object.keys(EVENTS).forEach(function(name){
		if(EVENTS[name] === 0){
			name = "on" + name;
			ProxyHandler.prototype[name] = function(){
				if(this._cbs[name]) this._cbs[name]();
			};
		} else if(EVENTS[name] === 1){
			name = "on" + name;
			ProxyHandler.prototype[name] = function(a){
				if(this._cbs[name]) this._cbs[name](a);
			};
		} else if(EVENTS[name] === 2){
			name = "on" + name;
			ProxyHandler.prototype[name] = function(a, b){
				if(this._cbs[name]) this._cbs[name](a, b);
			};
		} else {
			throw Error("wrong number of arguments");
		}
	});

/***/ },
/* 590 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = Stream;
	
	var Parser = __webpack_require__(283);
	
	function Stream(options){
		Parser.call(this, new Cbs(this), options);
	}
	
	__webpack_require__(38)(Stream, Parser);
	
	Stream.prototype.readable = true;
	
	function Cbs(scope){
		this.scope = scope;
	}
	
	var EVENTS = __webpack_require__(77).EVENTS;
	
	Object.keys(EVENTS).forEach(function(name){
		if(EVENTS[name] === 0){
			Cbs.prototype["on" + name] = function(){
				this.scope.emit(name);
			};
		} else if(EVENTS[name] === 1){
			Cbs.prototype["on" + name] = function(a){
				this.scope.emit(name, a);
			};
		} else if(EVENTS[name] === 2){
			Cbs.prototype["on" + name] = function(a, b){
				this.scope.emit(name, a, b);
			};
		} else {
			throw Error("wrong number of arguments!");
		}
	});

/***/ },
/* 591 */
/***/ function(module, exports) {

	'use strict';
	
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function hyphenateStyleName(string) {
	    return string in cache
	    ? cache[string]
	    : cache[string] = string
	      .replace(uppercasePattern, '-$&')
	      .toLowerCase()
	      .replace(msPattern, '-ms-');
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 592 */
/***/ function(module, exports) {

	exports.read = function (buffer, offset, isLE, mLen, nBytes) {
	  var e, m
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var nBits = -7
	  var i = isLE ? (nBytes - 1) : 0
	  var d = isLE ? -1 : 1
	  var s = buffer[offset + i]
	
	  i += d
	
	  e = s & ((1 << (-nBits)) - 1)
	  s >>= (-nBits)
	  nBits += eLen
	  for (; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  m = e & ((1 << (-nBits)) - 1)
	  e >>= (-nBits)
	  nBits += mLen
	  for (; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8) {}
	
	  if (e === 0) {
	    e = 1 - eBias
	  } else if (e === eMax) {
	    return m ? NaN : ((s ? -1 : 1) * Infinity)
	  } else {
	    m = m + Math.pow(2, mLen)
	    e = e - eBias
	  }
	  return (s ? -1 : 1) * m * Math.pow(2, e - mLen)
	}
	
	exports.write = function (buffer, value, offset, isLE, mLen, nBytes) {
	  var e, m, c
	  var eLen = nBytes * 8 - mLen - 1
	  var eMax = (1 << eLen) - 1
	  var eBias = eMax >> 1
	  var rt = (mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0)
	  var i = isLE ? 0 : (nBytes - 1)
	  var d = isLE ? 1 : -1
	  var s = value < 0 || (value === 0 && 1 / value < 0) ? 1 : 0
	
	  value = Math.abs(value)
	
	  if (isNaN(value) || value === Infinity) {
	    m = isNaN(value) ? 1 : 0
	    e = eMax
	  } else {
	    e = Math.floor(Math.log(value) / Math.LN2)
	    if (value * (c = Math.pow(2, -e)) < 1) {
	      e--
	      c *= 2
	    }
	    if (e + eBias >= 1) {
	      value += rt / c
	    } else {
	      value += rt * Math.pow(2, 1 - eBias)
	    }
	    if (value * c >= 2) {
	      e++
	      c /= 2
	    }
	
	    if (e + eBias >= eMax) {
	      m = 0
	      e = eMax
	    } else if (e + eBias >= 1) {
	      m = (value * c - 1) * Math.pow(2, mLen)
	      e = e + eBias
	    } else {
	      m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen)
	      e = 0
	    }
	  }
	
	  for (; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8) {}
	
	  e = (e << mLen) | m
	  eLen += mLen
	  for (; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8) {}
	
	  buffer[offset + i - d] |= s * 128
	}


/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	exports.default = createPrefixer;
	
	var _getBrowserInformation = __webpack_require__(609);
	
	var _getBrowserInformation2 = _interopRequireDefault(_getBrowserInformation);
	
	var _getPrefixedKeyframes = __webpack_require__(610);
	
	var _getPrefixedKeyframes2 = _interopRequireDefault(_getPrefixedKeyframes);
	
	var _capitalizeString = __webpack_require__(186);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	var _addNewValuesOnly = __webpack_require__(284);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(285);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	var _prefixValue = __webpack_require__(286);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : function (style) {
	    return style;
	  };
	
	  return function () {
	    /**
	    * Instantiante a new prefixer
	    * @param {string} userAgent - userAgent to gather prefix information according to caniuse.com
	    * @param {string} keepUnprefixed - keeps unprefixed properties and values
	    */
	    function Prefixer() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      _classCallCheck(this, Prefixer);
	
	      var defaultUserAgent = typeof navigator !== 'undefined' ? navigator.userAgent : undefined;
	
	      this._userAgent = options.userAgent || defaultUserAgent;
	      this._keepUnprefixed = options.keepUnprefixed || false;
	
	      if (this._userAgent) {
	        this._browserInfo = (0, _getBrowserInformation2.default)(this._userAgent);
	      }
	
	      // Checks if the userAgent was resolved correctly
	      if (this._browserInfo && this._browserInfo.cssPrefix) {
	        this.prefixedKeyframes = (0, _getPrefixedKeyframes2.default)(this._browserInfo.browserName, this._browserInfo.browserVersion, this._browserInfo.cssPrefix);
	      } else {
	        this._useFallback = true;
	        return false;
	      }
	
	      var prefixData = this._browserInfo.browserName && prefixMap[this._browserInfo.browserName];
	      if (prefixData) {
	        this._requiresPrefix = {};
	
	        for (var property in prefixData) {
	          if (prefixData[property] >= this._browserInfo.browserVersion) {
	            this._requiresPrefix[property] = true;
	          }
	        }
	
	        this._hasPropsRequiringPrefix = Object.keys(this._requiresPrefix).length > 0;
	      } else {
	        this._useFallback = true;
	      }
	
	      this._metaData = {
	        browserVersion: this._browserInfo.browserVersion,
	        browserName: this._browserInfo.browserName,
	        cssPrefix: this._browserInfo.cssPrefix,
	        jsPrefix: this._browserInfo.jsPrefix,
	        keepUnprefixed: this._keepUnprefixed,
	        requiresPrefix: this._requiresPrefix
	      };
	    }
	
	    _createClass(Prefixer, [{
	      key: 'prefix',
	      value: function prefix(style) {
	        // use static prefixer as fallback if userAgent can not be resolved
	        if (this._useFallback) {
	          return fallback(style);
	        }
	
	        // only add prefixes if needed
	        if (!this._hasPropsRequiringPrefix) {
	          return style;
	        }
	
	        return this._prefixStyle(style);
	      }
	    }, {
	      key: '_prefixStyle',
	      value: function _prefixStyle(style) {
	        for (var property in style) {
	          var value = style[property];
	
	          // handle nested objects
	          if ((0, _isObject2.default)(value)) {
	            style[property] = this.prefix(value);
	            // handle array values
	          } else if (Array.isArray(value)) {
	            var combinedValue = [];
	
	            for (var i = 0, len = value.length; i < len; ++i) {
	              var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, this._metaData);
	              (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	            }
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (combinedValue.length > 0) {
	              style[property] = combinedValue;
	            }
	          } else {
	            var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, this._metaData);
	
	            // only modify the value if it was touched
	            // by any plugin to prevent unnecessary mutations
	            if (_processedValue) {
	              style[property] = _processedValue;
	            }
	
	            // add prefixes to properties
	            if (this._requiresPrefix.hasOwnProperty(property)) {
	              style[this._browserInfo.jsPrefix + (0, _capitalizeString2.default)(property)] = value;
	              if (!this._keepUnprefixed) {
	                delete style[property];
	              }
	            }
	          }
	        }
	
	        return style;
	      }
	
	      /**
	      * Returns a prefixed version of the style object using all vendor prefixes
	      * @param {Object} styles - Style object that gets prefixed properties added
	      * @returns {Object} - Style object with prefixed properties and values
	      */
	
	    }], [{
	      key: 'prefixAll',
	      value: function prefixAll(styles) {
	        return fallback(styles);
	      }
	    }]);
	
	    return Prefixer;
	  }();
	}
	module.exports = exports['default'];

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _getPrefixedValue = __webpack_require__(78);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function calc(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && value.indexOf('calc(') > -1 && (browserName === 'firefox' && browserVersion < 15 || browserName === 'chrome' && browserVersion < 25 || browserName === 'safari' && browserVersion < 6.1 || browserName === 'ios_saf' && browserVersion < 7)) {
	    return (0, _getPrefixedValue2.default)(value.replace(/calc\(/g, cssPrefix + 'calc('), value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	
	var _getPrefixedValue = __webpack_require__(78);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = {
	  flex: true,
	  'inline-flex': true
	};
	function flex(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (property === 'display' && values[value] && (browserName === 'chrome' && browserVersion < 29 && browserVersion > 20 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 && browserVersion > 6 || browserName === 'opera' && (browserVersion === 15 || browserVersion === 16))) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	
	var _getPrefixedValue = __webpack_require__(78);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  flex: 'flexbox',
	  'inline-flex': 'inline-flexbox'
	};
	
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((alternativeProps.hasOwnProperty(property) || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'ie_mob' || browserName === 'ie') && browserVersion === 10) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	
	var _getPrefixedValue = __webpack_require__(78);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple',
	  flex: 'box',
	  'inline-flex': 'inline-box'
	};
	
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	var otherProps = ['alignContent', 'alignSelf', 'order', 'flexGrow', 'flexShrink', 'flexBasis', 'flexDirection'];
	var properties = Object.keys(alternativeProps).concat(otherProps);
	
	function flexboxOld(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if ((properties.indexOf(property) > -1 || property === 'display' && typeof value === 'string' && value.indexOf('flex') > -1) && (browserName === 'firefox' && browserVersion < 22 || browserName === 'chrome' && browserVersion < 21 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion <= 6.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    delete requiresPrefix[property];
	
	    if (!keepUnprefixed && !Array.isArray(style[property])) {
	      delete style[property];
	    }
	    if (property === 'flexDirection' && typeof value === 'string') {
	      if (value.indexOf('column') > -1) {
	        style.WebkitBoxOrient = 'vertical';
	      } else {
	        style.WebkitBoxOrient = 'horizontal';
	      }
	      if (value.indexOf('reverse') > -1) {
	        style.WebkitBoxDirection = 'reverse';
	      } else {
	        style.WebkitBoxDirection = 'normal';
	      }
	    }
	    if (property === 'display' && alternativeValues.hasOwnProperty(value)) {
	      return (0, _getPrefixedValue2.default)(cssPrefix + alternativeValues[value], value, keepUnprefixed);
	    }
	    if (alternativeProps.hasOwnProperty(property)) {
	      style[alternativeProps[property]] = alternativeValues[value] || value;
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _getPrefixedValue = __webpack_require__(78);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	function gradient(property, value, style, _ref) {
	  var browserName = _ref.browserName,
	      browserVersion = _ref.browserVersion,
	      cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  if (typeof value === 'string' && values.test(value) && (browserName === 'firefox' && browserVersion < 16 || browserName === 'chrome' && browserVersion < 26 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 7 || (browserName === 'opera' || browserName === 'op_mini') && browserVersion < 12.1 || browserName === 'android' && browserVersion < 4.4 || browserName === 'and_uc')) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	
	var _getPrefixedValue = __webpack_require__(78);
	
	var _getPrefixedValue2 = _interopRequireDefault(_getPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	
	  // TODO: chrome & opera support it
	};function sizing(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed;
	
	  // This might change in the future
	  // Keep an eye on it
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return (0, _getPrefixedValue2.default)(cssPrefix + value, value, keepUnprefixed);
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(269);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var requiresPrefixDashCased = void 0;
	
	function transition(property, value, style, _ref) {
	  var cssPrefix = _ref.cssPrefix,
	      keepUnprefixed = _ref.keepUnprefixed,
	      requiresPrefix = _ref.requiresPrefix;
	
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    // memoize the prefix array for later use
	    if (!requiresPrefixDashCased) {
	      requiresPrefixDashCased = Object.keys(requiresPrefix).map(function (prop) {
	        return (0, _hyphenateProperty2.default)(prop);
	      });
	    }
	
	    // only split multi values, not cubic beziers
	    var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	    requiresPrefixDashCased.forEach(function (prop) {
	      multipleValues.forEach(function (val, index) {
	        if (val.indexOf(prop) > -1 && prop !== 'order') {
	          multipleValues[index] = val.replace(prop, cssPrefix + prop) + (keepUnprefixed ? ',' + val : '');
	        }
	      });
	    });
	
	    return multipleValues.join(',');
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPrefixer;
	
	var _prefixProperty = __webpack_require__(611);
	
	var _prefixProperty2 = _interopRequireDefault(_prefixProperty);
	
	var _prefixValue = __webpack_require__(286);
	
	var _prefixValue2 = _interopRequireDefault(_prefixValue);
	
	var _addNewValuesOnly = __webpack_require__(284);
	
	var _addNewValuesOnly2 = _interopRequireDefault(_addNewValuesOnly);
	
	var _isObject = __webpack_require__(285);
	
	var _isObject2 = _interopRequireDefault(_isObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function createPrefixer(_ref) {
	  var prefixMap = _ref.prefixMap,
	      plugins = _ref.plugins;
	
	  function prefixAll(style) {
	    for (var property in style) {
	      var value = style[property];
	
	      // handle nested objects
	      if ((0, _isObject2.default)(value)) {
	        style[property] = prefixAll(value);
	        // handle array values
	      } else if (Array.isArray(value)) {
	        var combinedValue = [];
	
	        for (var i = 0, len = value.length; i < len; ++i) {
	          var processedValue = (0, _prefixValue2.default)(plugins, property, value[i], style, prefixMap);
	          (0, _addNewValuesOnly2.default)(combinedValue, processedValue || value[i]);
	        }
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (combinedValue.length > 0) {
	          style[property] = combinedValue;
	        }
	      } else {
	        var _processedValue = (0, _prefixValue2.default)(plugins, property, value, style, prefixMap);
	
	        // only modify the value if it was touched
	        // by any plugin to prevent unnecessary mutations
	        if (_processedValue) {
	          style[property] = _processedValue;
	        }
	
	        (0, _prefixProperty2.default)(prefixMap, property, style);
	      }
	    }
	
	    return style;
	  }
	
	  return prefixAll;
	}
	module.exports = exports['default'];

/***/ },
/* 602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = calc;
	
	var _isPrefixedValue = __webpack_require__(182);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	function calc(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && value.indexOf('calc(') > -1) {
	    return prefixes.map(function (prefix) {
	      return value.replace(/calc\(/g, prefix + 'calc(');
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 603 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flex;
	var values = {
	  flex: ['-webkit-box', '-moz-box', '-ms-flexbox', '-webkit-flex', 'flex'],
	  'inline-flex': ['-webkit-inline-box', '-moz-inline-box', '-ms-inline-flexbox', '-webkit-inline-flex', 'inline-flex']
	};
	
	function flex(property, value) {
	  if (property === 'display' && values.hasOwnProperty(value)) {
	    return values[value];
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 604 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxIE;
	var alternativeValues = {
	  'space-around': 'distribute',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end'
	};
	var alternativeProps = {
	  alignContent: 'msFlexLinePack',
	  alignSelf: 'msFlexItemAlign',
	  alignItems: 'msFlexAlign',
	  justifyContent: 'msFlexPack',
	  order: 'msFlexOrder',
	  flexGrow: 'msFlexPositive',
	  flexShrink: 'msFlexNegative',
	  flexBasis: 'msFlexPreferredSize'
	};
	
	function flexboxIE(property, value, style) {
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 605 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = flexboxOld;
	var alternativeValues = {
	  'space-around': 'justify',
	  'space-between': 'justify',
	  'flex-start': 'start',
	  'flex-end': 'end',
	  'wrap-reverse': 'multiple',
	  wrap: 'multiple'
	};
	
	var alternativeProps = {
	  alignItems: 'WebkitBoxAlign',
	  justifyContent: 'WebkitBoxPack',
	  flexWrap: 'WebkitBoxLines'
	};
	
	function flexboxOld(property, value, style) {
	  if (property === 'flexDirection' && typeof value === 'string') {
	    if (value.indexOf('column') > -1) {
	      style.WebkitBoxOrient = 'vertical';
	    } else {
	      style.WebkitBoxOrient = 'horizontal';
	    }
	    if (value.indexOf('reverse') > -1) {
	      style.WebkitBoxDirection = 'reverse';
	    } else {
	      style.WebkitBoxDirection = 'normal';
	    }
	  }
	  if (alternativeProps.hasOwnProperty(property)) {
	    style[alternativeProps[property]] = alternativeValues[value] || value;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = gradient;
	
	var _isPrefixedValue = __webpack_require__(182);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var values = /linear-gradient|radial-gradient|repeating-linear-gradient|repeating-radial-gradient/;
	
	function gradient(property, value) {
	  if (typeof value === 'string' && !(0, _isPrefixedValue2.default)(value) && values.test(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 607 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = sizing;
	var prefixes = ['-webkit-', '-moz-', ''];
	
	var properties = {
	  maxHeight: true,
	  maxWidth: true,
	  width: true,
	  height: true,
	  columnWidth: true,
	  minWidth: true,
	  minHeight: true
	};
	var values = {
	  'min-content': true,
	  'max-content': true,
	  'fill-available': true,
	  'fit-content': true,
	  'contain-floats': true
	};
	
	function sizing(property, value) {
	  if (properties.hasOwnProperty(property) && values.hasOwnProperty(value)) {
	    return prefixes.map(function (prefix) {
	      return prefix + value;
	    });
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = transition;
	
	var _hyphenateProperty = __webpack_require__(269);
	
	var _hyphenateProperty2 = _interopRequireDefault(_hyphenateProperty);
	
	var _isPrefixedValue = __webpack_require__(182);
	
	var _isPrefixedValue2 = _interopRequireDefault(_isPrefixedValue);
	
	var _capitalizeString = __webpack_require__(186);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var properties = {
	  transition: true,
	  transitionProperty: true,
	  WebkitTransition: true,
	  WebkitTransitionProperty: true,
	  MozTransition: true,
	  MozTransitionProperty: true
	};
	
	
	var prefixMapping = {
	  Webkit: '-webkit-',
	  Moz: '-moz-',
	  ms: '-ms-'
	};
	
	function prefixValue(value, propertyPrefixMap) {
	  if ((0, _isPrefixedValue2.default)(value)) {
	    return value;
	  }
	
	  // only split multi values, not cubic beziers
	  var multipleValues = value.split(/,(?![^()]*(?:\([^()]*\))?\))/g);
	
	  for (var i = 0, len = multipleValues.length; i < len; ++i) {
	    var singleValue = multipleValues[i];
	    var values = [singleValue];
	    for (var property in propertyPrefixMap) {
	      var dashCaseProperty = (0, _hyphenateProperty2.default)(property);
	
	      if (singleValue.indexOf(dashCaseProperty) > -1 && dashCaseProperty !== 'order') {
	        var prefixes = propertyPrefixMap[property];
	        for (var j = 0, pLen = prefixes.length; j < pLen; ++j) {
	          // join all prefixes and create a new value
	          values.unshift(singleValue.replace(dashCaseProperty, prefixMapping[prefixes[j]] + dashCaseProperty));
	        }
	      }
	    }
	
	    multipleValues[i] = values.join(',');
	  }
	
	  return multipleValues.join(',');
	}
	
	function transition(property, value, style, propertyPrefixMap) {
	  // also check for already prefixed transitions
	  if (typeof value === 'string' && properties.hasOwnProperty(property)) {
	    var outputValue = prefixValue(value, propertyPrefixMap);
	    // if the property is already prefixed
	    var webkitOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-moz-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Webkit') > -1) {
	      return webkitOutput;
	    }
	
	    var mozOutput = outputValue.split(/,(?![^()]*(?:\([^()]*\))?\))/g).filter(function (val) {
	      return !/-webkit-|-ms-/.test(val);
	    }).join(',');
	
	    if (property.indexOf('Moz') > -1) {
	      return mozOutput;
	    }
	
	    style['Webkit' + (0, _capitalizeString2.default)(property)] = webkitOutput;
	    style['Moz' + (0, _capitalizeString2.default)(property)] = mozOutput;
	    return outputValue;
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getBrowserInformation;
	
	var _bowser = __webpack_require__(497);
	
	var _bowser2 = _interopRequireDefault(_bowser);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var prefixByBrowser = {
	  chrome: 'Webkit',
	  safari: 'Webkit',
	  ios: 'Webkit',
	  android: 'Webkit',
	  phantom: 'Webkit',
	  opera: 'Webkit',
	  webos: 'Webkit',
	  blackberry: 'Webkit',
	  bada: 'Webkit',
	  tizen: 'Webkit',
	  chromium: 'Webkit',
	  vivaldi: 'Webkit',
	  firefox: 'Moz',
	  seamoney: 'Moz',
	  sailfish: 'Moz',
	  msie: 'ms',
	  msedge: 'ms'
	};
	
	
	var browserByCanIuseAlias = {
	  chrome: 'chrome',
	  chromium: 'chrome',
	  safari: 'safari',
	  firfox: 'firefox',
	  msedge: 'edge',
	  opera: 'opera',
	  vivaldi: 'opera',
	  msie: 'ie'
	};
	
	function getBrowserName(browserInfo) {
	  if (browserInfo.firefox) {
	    return 'firefox';
	  }
	
	  if (browserInfo.mobile || browserInfo.tablet) {
	    if (browserInfo.ios) {
	      return 'ios_saf';
	    } else if (browserInfo.android) {
	      return 'android';
	    } else if (browserInfo.opera) {
	      return 'op_mini';
	    }
	  }
	
	  for (var browser in browserByCanIuseAlias) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      return browserByCanIuseAlias[browser];
	    }
	  }
	}
	
	/**
	 * Uses bowser to get default browser browserInformation such as version and name
	 * Evaluates bowser browserInfo and adds vendorPrefix browserInformation
	 * @param {string} userAgent - userAgent that gets evaluated
	 */
	function getBrowserInformation(userAgent) {
	  var browserInfo = _bowser2.default._detect(userAgent);
	
	  if (browserInfo.yandexbrowser) {
	    browserInfo = _bowser2.default._detect(userAgent.replace(/YaBrowser\/[0-9.]*/, ''));
	  }
	
	  for (var browser in prefixByBrowser) {
	    if (browserInfo.hasOwnProperty(browser)) {
	      var prefix = prefixByBrowser[browser];
	
	      browserInfo.jsPrefix = prefix;
	      browserInfo.cssPrefix = '-' + prefix.toLowerCase() + '-';
	      break;
	    }
	  }
	
	  browserInfo.browserName = getBrowserName(browserInfo);
	
	  // For cordova IOS 8 the version is missing, set truncated osversion to prevent NaN
	  if (browserInfo.version) {
	    browserInfo.browserVersion = parseFloat(browserInfo.version);
	  } else {
	    browserInfo.browserVersion = parseInt(parseFloat(browserInfo.osversion), 10);
	  }
	
	  browserInfo.osVersion = parseFloat(browserInfo.osversion);
	
	  // iOS forces all browsers to use Safari under the hood
	  // as the Safari version seems to match the iOS version
	  // we just explicitely use the osversion instead
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/72
	  if (browserInfo.browserName === 'ios_saf' && browserInfo.browserVersion > browserInfo.osVersion) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // seperate native android chrome
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/45
	  if (browserInfo.browserName === 'android' && browserInfo.chrome && browserInfo.browserVersion > 37) {
	    browserInfo.browserName = 'and_chr';
	  }
	
	  // For android < 4.4 we want to check the osversion
	  // not the chrome version, see issue #26
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/26
	  if (browserInfo.browserName === 'android' && browserInfo.osVersion < 5) {
	    browserInfo.browserVersion = browserInfo.osVersion;
	  }
	
	  // Samsung browser are basically build on Chrome > 44
	  // https://github.com/rofrischmann/inline-style-prefixer/issues/102
	  if (browserInfo.browserName === 'android' && browserInfo.samsungBrowser) {
	    browserInfo.browserName = 'and_chr';
	    browserInfo.browserVersion = 44;
	  }
	
	  return browserInfo;
	}
	module.exports = exports['default'];

/***/ },
/* 610 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getPrefixedKeyframes;
	function getPrefixedKeyframes(browserName, browserVersion, cssPrefix) {
	  var prefixedKeyframes = 'keyframes';
	
	  if (browserName === 'chrome' && browserVersion < 43 || (browserName === 'safari' || browserName === 'ios_saf') && browserVersion < 9 || browserName === 'opera' && browserVersion < 30 || browserName === 'android' && browserVersion <= 4.4 || browserName === 'and_uc') {
	    return cssPrefix + prefixedKeyframes;
	  }
	  return prefixedKeyframes;
	}
	module.exports = exports['default'];

/***/ },
/* 611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = prefixProperty;
	
	var _capitalizeString = __webpack_require__(186);
	
	var _capitalizeString2 = _interopRequireDefault(_capitalizeString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function prefixProperty(prefixProperties, property, style) {
	  if (prefixProperties.hasOwnProperty(property)) {
	    var requiredPrefixes = prefixProperties[property];
	    for (var i = 0, len = requiredPrefixes.length; i < len; ++i) {
	      style[requiredPrefixes[i] + (0, _capitalizeString2.default)(property)] = style[property];
	    }
	  }
	}
	module.exports = exports['default'];

/***/ },
/* 612 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ },
/* 613 */
/***/ function(module, exports) {

	module.exports = {
		"_args": [
			[
				"cheerio@0.22.0",
				"C:\\local_repos\\abi-rebrand-newsletter-designer"
			]
		],
		"_from": "cheerio@0.22.0",
		"_id": "cheerio@0.22.0",
		"_inBundle": false,
		"_integrity": "sha1-qbqoYKP5tZWmuBsahocxIe06Jp4=",
		"_location": "/cheerio",
		"_phantomChildren": {},
		"_requested": {
			"type": "version",
			"registry": true,
			"raw": "cheerio@0.22.0",
			"name": "cheerio",
			"escapedName": "cheerio",
			"rawSpec": "0.22.0",
			"saveSpec": null,
			"fetchSpec": "0.22.0"
		},
		"_requiredBy": [
			"/",
			"/juice"
		],
		"_resolved": "https://registry.npmjs.org/cheerio/-/cheerio-0.22.0.tgz",
		"_spec": "0.22.0",
		"_where": "C:\\local_repos\\abi-rebrand-newsletter-designer",
		"author": {
			"name": "Matt Mueller",
			"email": "mattmuelle@gmail.com",
			"url": "mat.io"
		},
		"bugs": {
			"url": "https://github.com/cheeriojs/cheerio/issues"
		},
		"dependencies": {
			"css-select": "~1.2.0",
			"dom-serializer": "~0.1.0",
			"entities": "~1.1.1",
			"htmlparser2": "^3.9.1",
			"lodash.assignin": "^4.0.9",
			"lodash.bind": "^4.1.4",
			"lodash.defaults": "^4.0.1",
			"lodash.filter": "^4.4.0",
			"lodash.flatten": "^4.2.0",
			"lodash.foreach": "^4.3.0",
			"lodash.map": "^4.4.0",
			"lodash.merge": "^4.4.0",
			"lodash.pick": "^4.2.1",
			"lodash.reduce": "^4.4.0",
			"lodash.reject": "^4.4.0",
			"lodash.some": "^4.4.0"
		},
		"description": "Tiny, fast, and elegant implementation of core jQuery designed specifically for the server",
		"devDependencies": {
			"benchmark": "^2.1.0",
			"coveralls": "^2.11.9",
			"expect.js": "~0.3.1",
			"istanbul": "^0.4.3",
			"jquery": "^3.0.0",
			"jsdom": "^9.2.1",
			"jshint": "^2.9.2",
			"mocha": "^2.5.3",
			"xyz": "~0.5.0"
		},
		"engines": {
			"node": ">= 0.6"
		},
		"files": [
			"index.js",
			"lib"
		],
		"homepage": "https://github.com/cheeriojs/cheerio#readme",
		"keywords": [
			"htmlparser",
			"jquery",
			"selector",
			"scraper",
			"parser",
			"html"
		],
		"license": "MIT",
		"main": "./index.js",
		"name": "cheerio",
		"repository": {
			"type": "git",
			"url": "git://github.com/cheeriojs/cheerio.git"
		},
		"scripts": {
			"test": "make test"
		},
		"version": "0.22.0"
	};

/***/ },
/* 614 */
/***/ function(module, exports) {

	module.exports = {
		"0": 65533,
		"128": 8364,
		"130": 8218,
		"131": 402,
		"132": 8222,
		"133": 8230,
		"134": 8224,
		"135": 8225,
		"136": 710,
		"137": 8240,
		"138": 352,
		"139": 8249,
		"140": 338,
		"142": 381,
		"145": 8216,
		"146": 8217,
		"147": 8220,
		"148": 8221,
		"149": 8226,
		"150": 8211,
		"151": 8212,
		"152": 732,
		"153": 8482,
		"154": 353,
		"155": 8250,
		"156": 339,
		"158": 382,
		"159": 376
	};

/***/ },
/* 615 */
/***/ function(module, exports) {

	module.exports = [
		{
			"imageId": "M35P",
			"imageAlt": "ABI Logo Light",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
			"imageCategory": "logos",
			"imageAdded": "2017-05-02T19:33:00",
			"builtIn": true
		},
		{
			"imageId": "B419I",
			"imageAlt": "ABI Logo Regular",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_pos_large.png",
			"imageCategory": "logos",
			"imageAdded": "2017-05-02T19:33:00",
			"builtIn": true
		},
		{
			"imageId": "G178Z",
			"imageAlt": "Abigail Cartledge",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AbigailCartledge.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "R465Y",
			"imageAlt": "Adeola Ajayi",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/adeolaajayi.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "Z11R",
			"imageAlt": "Alastair Ross",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlistairROSS.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "L778O",
			"imageAlt": "Alisa Dolgova",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlisaDOLGOVA.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "P164P",
			"imageAlt": "Andrew Carpenter",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AndrewCarpenter.JPG",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "J547W",
			"imageAlt": "Anthony Wright",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/anthonywright.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "E679N",
			"imageAlt": "Audrie Powell",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/audriepowell.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "C374P",
			"imageAlt": "Ben Howarth",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/BenHowarth.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "R714J",
			"imageAlt": "Bob Warren",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/RobertWarren.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "B605K",
			"imageAlt": "Carol Hall",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/CarolHall.JPG",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "U450G",
			"imageAlt": "Charlie Campbell",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/CharlieCAMPBELL.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "K605T",
			"imageAlt": "Chris Armistead",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/ChrisArmistead.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "I981M",
			"imageAlt": "Christopher Darling",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/ChristopherDarling.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "Y936R",
			"imageAlt": "Dan Sadler",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/DanSadler.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "J287B",
			"imageAlt": "David Jordonson",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/DavidJORDORSON.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "N138A",
			"imageAlt": "Debbie Marsh",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/DebbieMarsh.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "O814N",
			"imageAlt": "Denise Brightly",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/DeniseBrightly.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "R37P",
			"imageAlt": "Emma Phillips",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/EmmaPHILLIPS.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "I412M",
			"imageAlt": "Glyn Wilkins",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/GlynWilkins.JPG",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "X166X",
			"imageAlt": "Hugh Savill",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/HughSAVILL.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "A110R",
			"imageAlt": "Huw Evans",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/HuwEvans.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "A130D",
			"imageAlt": "Huw Evans",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/people/abi-staff/current-staff/exec-team/huwevansdgweeklynote.jpg",
			"imageCategory": "people",
			"imageAdded": "2018-06-01T10:06:00",
			"builtIn": true
		},
		{
			"imageId": "A450F",
			"imageAlt": "Jacques Ebosse",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/JacquesEbosse.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "Z961W",
			"imageAlt": "James Dalton",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/james-dalton-picture.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "F265Z",
			"imageAlt": "Julie Geraud",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/JulieGeraud.JPG",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "K406H",
			"imageAlt": "Julie Shah",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/julieshah2.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "R284W",
			"imageAlt": "Kelly Ostler-Coyle",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/KellyOSTLERCOYLE.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-02T19:33:00",
			"builtIn": true
		},
		{
			"imageId": "I275X",
			"imageAlt": "Laura Hughes",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/LauraHUGHES.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "K417D",
			"imageAlt": "Liam Findlay",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/LiamFindlay.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "F672K",
			"imageAlt": "Lottie Dight",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/LottieDight.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "T447W",
			"imageAlt": "Lucy Ashton",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/LucyAshton.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "U434Y",
			"imageAlt": "Malcolm Tarling",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MalcolmTarling.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "P257H",
			"imageAlt": "Mark Allen",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MarkAllen.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "O670F",
			"imageAlt": "Mark Shepherd",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MarkShepherd.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "H391O",
			"imageAlt": "Matt Cullen",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MattCULLEN.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "S610U",
			"imageAlt": "Megan Hawkins",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MeganHawkins.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "Q757U",
			"imageAlt": "Natalie Larnder",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/NatalieLarnder.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "K267I",
			"imageAlt": "Nicola Abbott",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/nicolaabbott.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "H780W",
			"imageAlt": "Omar Ali",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/OmarALI.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "Y356S",
			"imageAlt": "Philippa Handyside",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/PhilippaHandyside.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "M833M",
			"imageAlt": "Raluca Boroianu-Omura",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/RalucaBOROIANUOMURA.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "A836B",
			"imageAlt": "Rob Yuille",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/RobYuille.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "P544G",
			"imageAlt": "Sarah Cordey",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/SarahCORDEY.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "X628L",
			"imageAlt": "Seth Williams",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/SethWILLIAMS.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "E484T",
			"imageAlt": "Stef Kenyon",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/stefkenyon2.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "H347G",
			"imageAlt": "Steven Findlay",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/StevenFINDLAY.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "Y81S",
			"imageAlt": "Taylan Hamit",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/TaylanHamit.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "Y764G",
			"imageAlt": "Victoria French",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/VictoriaFRENCH.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		},
		{
			"imageId": "Z612B",
			"imageAlt": "Yvonne Braun",
			"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/YvonneBraun.jpg",
			"imageCategory": "people",
			"imageAdded": "2017-05-03T13:29:00",
			"builtIn": true
		}
	];

/***/ },
/* 616 */
/***/ function(module, exports) {

	module.exports = [
		{
			"templateId": "default",
			"templateName": "Basic Newsletter",
			"templateCategory": "",
			"templateContent": [
				{
					"configId": "ROOT_ITEM",
					"contentId": "By8akQ1g-",
					"contentIsRoot": true,
					"contentParentId": null
				},
				{
					"configId": "SECTION",
					"contentId": "S1mAJX1eW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"styleBackgroundColour": "#230052",
					"contentId": "S1qUlXylb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"styleBackgroundColour": "#7f58a5",
					"contentId": "HkpPHQkgb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"configId": "SECTION",
					"contentId": "BywsHXJlW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "SkRhSXklW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "HkspHQJeb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "SywTUQyeW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "rJhT8QyxZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "ByxRIQ1x-",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "r1R6U7JeZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "BJW1v7JxZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "HJgxwQ1eW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"styleBackgroundColour": "#230052",
					"contentId": "SyDbv71lW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"configId": "SECTION",
					"contentId": "SycvwXyxb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"contentId": "Hk_Ck7Jg-",
					"contentIsRoot": false,
					"contentParentId": "S1mAJX1eW",
					"contentContent": "<p><strong>Newsletter subject line</strong></p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleTextAlignment": "right",
					"contentId": "Skn01X1eW",
					"contentIsRoot": false,
					"contentParentId": "S1mAJX1eW",
					"contentContent": "<p>Click <a href=\"${Gears.microsite()}\" target=\"_blank\" rel=\"noopener noreferrer\">here</a> if you are having trouble viewing this message.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleWidth": "405px",
					"stylePadding": "20px",
					"contentId": "HknIgmygW",
					"contentIsRoot": false,
					"contentParentId": "S1qUlXylb",
					"configId": "COLUMN"
				},
				{
					"styleWidth": "215px",
					"contentId": "B1TLlQJgb",
					"contentIsRoot": false,
					"contentParentId": "S1qUlXylb",
					"configId": "COLUMN"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rkehlQJeb",
					"contentIsRoot": false,
					"contentParentId": "B1TLlQJgb"
				},
				{
					"contentId": "SJf3gm1lZ",
					"contentIsRoot": false,
					"contentParentId": "rkehlQJeb",
					"contentContent": {
						"imageId": "M671R",
						"imageAlt": "Main Banner",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/banners/abi_banner3735_e-newsletters_v4a.png",
						"imageCategory": "banners",
						"imageAdded": "2017-05-02T19:33:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rJbXEQ1e-",
					"contentIsRoot": false,
					"contentParentId": "HknIgmygW"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "r14QN7Jgb",
					"contentIsRoot": false,
					"contentParentId": "HknIgmygW"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "BJP74m1xZ",
					"contentIsRoot": false,
					"contentParentId": "HknIgmygW"
				},
				{
					"styleWidth": "130px",
					"styleTextAlignment": "left",
					"contentId": "HkQBV7ke-",
					"contentIsRoot": false,
					"contentParentId": "rJbXEQ1e-",
					"contentContent": {
						"imageId": "O351V",
						"imageAlt": "ABI Logo Light",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
						"imageCategory": "logos",
						"imageAdded": "2017-05-02T19:33:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"stylePadding": "10px 0 0",
					"styleTextColour": "#ffffff",
					"contentId": "SywO4XJxb",
					"contentIsRoot": false,
					"contentParentId": "r14QN7Jgb",
					"contentContent": "<h1>Click here to enter text.</h1>",
					"configId": "RICH_TEXT",
					"configEditorRoot": "h1"
				},
				{
					"stylePadding": "0",
					"styleTextColour": "#ffffff",
					"contentId": "H1quN71gb",
					"contentIsRoot": false,
					"contentParentId": "BJP74m1xZ",
					"contentContent": "<p>Newsletter date</p>",
					"configId": "RICH_TEXT"
				},
				{
					"styleTextColour": "#ffffff",
					"contentId": "HJ-_rXJgb",
					"contentIsRoot": false,
					"contentParentId": "HkpPHQkgb",
					"contentContent": "<h3>Click here to enter text.</h3>",
					"configId": "RICH_TEXT",
					"configEditorRoot": "h3"
				},
				{
					"contentId": "HyEaSXye-",
					"contentIsRoot": false,
					"contentParentId": "SkRhSXklW",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "SECTION_HEADER",
					"contentId": "SykCSQygW",
					"contentIsRoot": false,
					"contentParentId": "HkspHQJeb"
				},
				{
					"styleWidth": "50%",
					"contentId": "HkK-UXyeb",
					"contentIsRoot": false,
					"contentParentId": "BywsHXJlW",
					"configId": "COLUMN"
				},
				{
					"styleWidth": "50%",
					"contentId": "r10-U71l-",
					"contentIsRoot": false,
					"contentParentId": "BywsHXJlW",
					"configId": "COLUMN"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "ByfmU7JeZ",
					"contentIsRoot": false,
					"contentParentId": "HkK-UXyeb"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rJSmIXJxb",
					"contentIsRoot": false,
					"contentParentId": "r10-U71l-"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "ByI7U7yeZ",
					"contentIsRoot": false,
					"contentParentId": "r10-U71l-"
				},
				{
					"configId": "AUTHOR_BLOCK",
					"contentId": "ryh7IX1xb",
					"contentIsRoot": false,
					"contentParentId": "ByfmU7JeZ"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"contentId": "r1g3mIQ1xb",
					"contentIsRoot": false,
					"contentParentId": "ryh7IX1xb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SybnX8Xylb",
					"contentIsRoot": false,
					"contentParentId": "r1g3mIQ1xb"
				},
				{
					"configId": "IMAGE_ITEM",
					"editorLocked": false,
					"editorDraggable": false,
					"styleTextAlignment": "left",
					"styleWidth": "120px",
					"contentId": "rJGhm8mJlZ",
					"contentIsRoot": false,
					"contentParentId": "SybnX8Xylb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BkQ3Q87JeW",
					"contentIsRoot": false,
					"contentParentId": "r1g3mIQ1xb"
				},
				{
					"configId": "RICH_TEXT",
					"editorLocked": false,
					"editorDraggable": false,
					"contentContent": "<p><strong>Author</strong><br/>Job Title</p>",
					"stylePadding": "5px 0",
					"contentId": "HJVh7I7JeZ",
					"contentIsRoot": false,
					"contentParentId": "BkQ3Q87JeW"
				},
				{
					"stylePadding": "0 20px 20px",
					"styleTextAlignment": "left",
					"contentId": "HkkVLQyxW",
					"contentIsRoot": false,
					"contentParentId": "ByI7U7yeZ",
					"configId": "TOC_ITEM"
				},
				{
					"stylePadding": "20px 20px 0px",
					"contentId": "SJENLX1lb",
					"contentIsRoot": false,
					"contentParentId": "rJSmIXJxb",
					"contentContent": "<h4>This issue...</h4>",
					"configId": "RICH_TEXT",
					"configEditorRoot": "h4"
				},
				{
					"configId": "SECTION_HEADER",
					"contentId": "r1I0I71g-",
					"contentIsRoot": false,
					"contentParentId": "rJhT8QyxZ"
				},
				{
					"configId": "SECTION_HEADER",
					"contentId": "Hy_CLmyl-",
					"contentIsRoot": false,
					"contentParentId": "r1R6U7JeZ"
				},
				{
					"configId": "RICH_TEXT",
					"contentId": "B19CUQ1xW",
					"contentIsRoot": false,
					"contentParentId": "SywTUQyeW"
				},
				{
					"contentId": "rknAIQJxb",
					"contentIsRoot": false,
					"contentParentId": "ByxRIQ1x-",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "RICH_TEXT",
					"contentId": "rJ71w7yeW",
					"contentIsRoot": false,
					"contentParentId": "BJW1v7JxZ"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "ByTew71x-",
					"contentIsRoot": false,
					"contentParentId": "HJgxwQ1eW"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "Byybv7kxZ",
					"contentIsRoot": false,
					"contentParentId": "HJgxwQ1eW"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "HJZZDXkxZ",
					"contentIsRoot": false,
					"contentParentId": "HJgxwQ1eW"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "rygagPXkeZ",
					"contentIsRoot": false,
					"contentParentId": "ByTew71x-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HkWTgD7Jlb",
					"contentIsRoot": false,
					"contentParentId": "rygagPXkeZ"
				},
				{
					"configId": "IMAGE_ITEM",
					"editorLocked": false,
					"editorDraggable": false,
					"styleWidth": "120px",
					"contentId": "S1fpxDQ1l-",
					"contentIsRoot": false,
					"contentParentId": "HkWTgD7Jlb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "ryX6gPmyeb",
					"contentIsRoot": false,
					"contentParentId": "rygagPXkeZ"
				},
				{
					"configId": "RICH_TEXT",
					"editorLocked": false,
					"editorDraggable": false,
					"styleTextAlignment": "center",
					"contentContent": "<p><strong>Author</strong><br/>Job Title<br/><a href='mailto:email@abi.org.uk'>email@abi.org.uk</a></p>",
					"stylePadding": "5px 0",
					"contentId": "r1N6xv7ylZ",
					"contentIsRoot": false,
					"contentParentId": "ryX6gPmyeb"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "ryxyWvmyeW",
					"contentIsRoot": false,
					"contentParentId": "Byybv7kxZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SybJWwXkx-",
					"contentIsRoot": false,
					"contentParentId": "ryxyWvmyeW"
				},
				{
					"configId": "IMAGE_ITEM",
					"editorLocked": false,
					"editorDraggable": false,
					"styleWidth": "120px",
					"contentId": "rJGy-wQkl-",
					"contentIsRoot": false,
					"contentParentId": "SybJWwXkx-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BkQJZP7ygZ",
					"contentIsRoot": false,
					"contentParentId": "ryxyWvmyeW"
				},
				{
					"configId": "RICH_TEXT",
					"editorLocked": false,
					"editorDraggable": false,
					"styleTextAlignment": "center",
					"contentContent": "<p><strong>Author</strong><br/>Job Title<br/><a href='mailto:email@abi.org.uk'>email@abi.org.uk</a></p>",
					"stylePadding": "5px 0",
					"contentId": "rkEJ-Dmylb",
					"contentIsRoot": false,
					"contentParentId": "BkQJZP7ygZ"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "SkeZWDm1lZ",
					"contentIsRoot": false,
					"contentParentId": "HJZZDXkxZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "Sk-WZDm1eZ",
					"contentIsRoot": false,
					"contentParentId": "SkeZWDm1lZ"
				},
				{
					"configId": "IMAGE_ITEM",
					"editorLocked": false,
					"editorDraggable": false,
					"styleWidth": "120px",
					"contentId": "HJz-WPQkeW",
					"contentIsRoot": false,
					"contentParentId": "Sk-WZDm1eZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "r1QW-wQkgZ",
					"contentIsRoot": false,
					"contentParentId": "SkeZWDm1lZ"
				},
				{
					"configId": "RICH_TEXT",
					"editorLocked": false,
					"editorDraggable": false,
					"styleTextAlignment": "center",
					"contentContent": "<p><strong>Author</strong><br/>Job Title<br/><a href='mailto:email@abi.org.uk'>email@abi.org.uk</a></p>",
					"stylePadding": "5px 0",
					"contentId": "BJEbbDXkl-",
					"contentIsRoot": false,
					"contentParentId": "r1QW-wQkgZ"
				},
				{
					"styleTextColour": "#ffffff",
					"contentId": "B1SMwm1gZ",
					"contentIsRoot": false,
					"contentParentId": "SyDbv71lW",
					"contentContent": "<p>Copyright &copy; 2019 Association of British Insurers, All rights reserved.</p>\n<p>You received this email because you are a past recipient of ABI newsletters. Click <span style=\"color: #ffffff;\"><a style=\"color: #ffffff;\" href=\"https://www.abi.org.uk/privacy-policy/\">here</a> </span>to read our privacy notice.</p>\n<p><strong>Our mailing address is:</strong><br />Association of British Insurers, One America Square, 17 Crosswall, London, EC3N 2LB, United Kingdom</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"contentId": "SJCvPX1l-",
					"contentIsRoot": false,
					"contentParentId": "SycvwXyxb",
					"contentContent": "<p>Manage your ABI subscription preferences <a href=\"https://www.abi.org.uk/account/\">here</a>.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleTextAlignment": "right",
					"contentId": "S1WDiwlLG",
					"contentIsRoot": false,
					"contentParentId": "SycvwXyxb",
					"contentContent": "<p>Click <a href=\"${Gears.unsubscribe()}\">here</a> to unsubscribe from all ABI newsletters.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				}
			],
			"builtIn": true
		},
		{
			"templateId": "events",
			"templateName": "Events Template",
			"templateCategory": "",
			"templateContent": [
				{
					"configId": "ROOT_ITEM",
					"contentId": "By8akQ1g-",
					"contentIsRoot": true,
					"contentParentId": null
				},
				{
					"configId": "SECTION",
					"contentId": "S1mAJX1eW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"styleBackgroundColour": "#230052",
					"contentId": "S1qUlXylb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"contentId": "HkpPHQkgb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"configId": "SECTION",
					"contentId": "SkRhSXklW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "SyKs57Jx-",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "rykDzVJlZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "Bkmwf41xb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"styleBackgroundColour": "#230052",
					"contentId": "SyDbv71lW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"configId": "SECTION",
					"contentId": "SycvwXyxb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"contentId": "Hk_Ck7Jg-",
					"contentIsRoot": false,
					"contentParentId": "S1mAJX1eW",
					"contentContent": "<p><strong>ABI Events</strong></p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleTextAlignment": "right",
					"contentId": "Skn01X1eW",
					"contentIsRoot": false,
					"contentParentId": "S1mAJX1eW",
					"contentContent": "<p>Click <a href=\"${Gears.microsite()}\" target=\"_blank\" rel=\"noopener noreferrer\">here</a> if you are having trouble viewing this message.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleWidth": "405px",
					"stylePadding": "20px",
					"contentId": "HknIgmygW",
					"contentIsRoot": false,
					"contentParentId": "S1qUlXylb",
					"configId": "COLUMN"
				},
				{
					"styleWidth": "215px",
					"contentId": "B1TLlQJgb",
					"contentIsRoot": false,
					"contentParentId": "S1qUlXylb",
					"configId": "COLUMN"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rkehlQJeb",
					"contentIsRoot": false,
					"contentParentId": "B1TLlQJgb"
				},
				{
					"contentId": "SJf3gm1lZ",
					"contentIsRoot": false,
					"contentParentId": "rkehlQJeb",
					"contentContent": {
						"imageId": "M671R",
						"imageAlt": "Main Banner",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/banners/abi_banner3735_e-newsletters_v4a.png",
						"imageCategory": "banners",
						"imageAdded": "2017-05-02T19:33:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rJbXEQ1e-",
					"contentIsRoot": false,
					"contentParentId": "HknIgmygW"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "r14QN7Jgb",
					"contentIsRoot": false,
					"contentParentId": "HknIgmygW"
				},
				{
					"styleWidth": "130px",
					"styleTextAlignment": "left",
					"contentId": "HkQBV7ke-",
					"contentIsRoot": false,
					"contentParentId": "rJbXEQ1e-",
					"contentContent": {
						"imageId": "O351V",
						"imageAlt": "ABI Logo Light",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
						"imageCategory": "logos",
						"imageAdded": "2017-05-02T19:33:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"stylePadding": "10px 0 0",
					"styleTextColour": "#ffffff",
					"contentId": "SywO4XJxb",
					"contentIsRoot": false,
					"contentParentId": "r14QN7Jgb",
					"contentContent": "<h1>ABI Long-Term Savings Conference 2017</h1>",
					"configId": "RICH_TEXT",
					"configEditorRoot": "h1"
				},
				{
					"styleTextAlignment": "center",
					"contentId": "HJ-_rXJgb",
					"contentIsRoot": false,
					"contentParentId": "HkpPHQkgb",
					"contentContent": "<h2>Engaging customers for tomorrow's retirement</h2>",
					"configId": "RICH_TEXT",
					"configEditorRoot": "h2"
				},
				{
					"styleTextColour": "#ffffff",
					"contentId": "B1SMwm1gZ",
					"contentIsRoot": false,
					"contentParentId": "SyDbv71lW",
					"contentContent": "<p>Copyright &copy; 2019 Association of British Insurers, All rights reserved.</p>\n<p>You received this email because you are a past recipient of ABI newsletters. Click <span style=\"color: #ffffff;\"><a style=\"color: #ffffff;\" href=\"https://www.abi.org.uk/privacy-policy/\">here</a> </span>to read our privacy notice.</p>\n<p><strong>Our mailing address is:</strong><br />Association of British Insurers, One America Square, 17 Crosswall, London, EC3N 2LB, United Kingdom</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"contentId": "SJCvPX1l-",
					"contentIsRoot": false,
					"contentParentId": "SycvwXyxb",
					"contentContent": "<p>Manage your ABI subscription preferences <a href=\"https://www.abi.org.uk/account/\">here</a>.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleTextAlignment": "right",
					"contentId": "S1WDiwlLG",
					"contentIsRoot": false,
					"contentParentId": "SycvwXyxb",
					"contentContent": "<p>Click <a href=\"${Gears.unsubscribe()}\">here</a> to unsubscribe from all ABI updates.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleWidth": "60%",
					"contentId": "H1a0_X1x-",
					"contentIsRoot": false,
					"contentParentId": "SkRhSXklW",
					"configId": "COLUMN"
				},
				{
					"styleWidth": "40%",
					"contentId": "HJgytX1xW",
					"contentIsRoot": false,
					"contentParentId": "SkRhSXklW",
					"configId": "COLUMN"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "SkNxKX1lW",
					"contentIsRoot": false,
					"contentParentId": "H1a0_X1x-"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "H1deYm1l-",
					"contentIsRoot": false,
					"contentParentId": "H1a0_X1x-"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "S12eYX1eW",
					"contentIsRoot": false,
					"contentParentId": "H1a0_X1x-"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "BJLzF7ye-",
					"contentIsRoot": false,
					"contentParentId": "H1a0_X1x-"
				},
				{
					"contentId": "r13WtX1lW",
					"contentIsRoot": false,
					"contentParentId": "SkNxKX1lW",
					"contentContent": "<h2>Why Attend?</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "Sy0ZtQylb",
					"contentIsRoot": false,
					"contentParentId": "H1deYm1l-",
					"contentContent": "<ul>\n<li>Hear from the Rt. Hon. Damian Green MP, Secretary of State for Work and Pensions</li>\n<li>Gain insight from senior industry leaders and policy makers on the key issues facing the long-term savings industry.</li>\n<li>Explore what consumer engagement might look like in the future and hear how the regulator intends to enable innovation and protect consumers.</li>\n<li>Take advantage of 4hours worth of CPD with this CII accredited conference.</li>\n</ul>",
					"configId": "RICH_TEXT"
				},
				{
					"contentId": "SJ7GYX1g-",
					"contentIsRoot": false,
					"contentParentId": "S12eYX1eW",
					"contentContent": "<h2>Attendees will gain:</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "B15MY7ylZ",
					"contentIsRoot": false,
					"contentParentId": "BJLzF7ye-",
					"contentContent": "<ul>\n<li>A deeper understanding of next steps for both automatic enrolment and pension freedoms</li>\n<li>A strong overview of how technology can enhance consumer engagement and where the risks lie.</li>\n<li>An understanding of the debates about where responsibility lies for people saving and making retirement choices?</li>\n</ul>\n<p>Speakers will include leading Industry CEO&rsquo;s, Regulators and representatives from Government.&nbsp;</p>\n<ul>\n<li><strong>Rt. Hon. Damian Green MP, </strong>Secretary of State for Work and Pensions</li>\n<li><strong>Andy Briggs</strong>, Chief Executive Officer, UK Insurance, Aviva and ABI Chairman</li>\n<li><strong>John Cridland CBE</strong>, Independent Reviewer of State Pension</li>\n<li><strong>Lesley Titcomb</strong>, Chief Executive, The Pensions Regulator</li>\n<li><strong>Maggie Craig</strong>, Head of Department Pension Policy &amp; Insurance, FCA</li>\n</ul>\n<p><a href=\"https://www.abi.org.uk/events/abi-long-term-savings-conference-2017-engaging-customers-for-tomorrows-retirement/\">Click here</a> to view a full list of confirmed speakers.</p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "ByYPtmJxb",
					"contentIsRoot": false,
					"contentParentId": "HJgytX1xW"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "BkjvFQkx-",
					"contentIsRoot": false,
					"contentParentId": "HJgytX1xW"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "B10vK7ygW",
					"contentIsRoot": false,
					"contentParentId": "HJgytX1xW"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rk-tFm1xZ",
					"contentIsRoot": false,
					"contentParentId": "HJgytX1xW"
				},
				{
					"styleTextAlignment": "center",
					"contentId": "B1Nut7Jl-",
					"contentIsRoot": false,
					"contentParentId": "ByYPtmJxb",
					"contentContent": "<p><strong>Date<br /></strong>4th July 2017</p>\n<p><strong>Timings<br /></strong>11:30 (registration from 10:45) - 17:20 followed by networking drinks</p>\n<p><strong>Venue<br /></strong>ABI, One America Square, 17 Crosswall, London EC3N 2LB</p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "IMAGE_ITEM",
					"contentId": "rk_uKQ1l-",
					"contentIsRoot": false,
					"contentParentId": "BkjvFQkx-"
				},
				{
					"contentId": "HJnuYQ1x-",
					"contentIsRoot": false,
					"contentParentId": "B10vK7ygW",
					"contentContent": "<p><em>\"I was attracted by the typical quality and mix of speakers and wasn&rsquo;t disappointed!</em></p>\n<p><strong><em>Risk Adviser, FCA</em></strong></p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "IMAGE_ITEM",
					"contentId": "ByLFtQkxb",
					"contentIsRoot": false,
					"contentParentId": "rk-tFm1xZ"
				},
				{
					"stylePadding": "20px 0",
					"contentId": "ByoocQ1lZ",
					"contentIsRoot": false,
					"contentParentId": "SyKs57Jx-",
					"configId": "COLUMN"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "S1RsqXyxW",
					"contentIsRoot": false,
					"contentParentId": "ByoocQ1lZ"
				},
				{
					"configId": "IMAGE_ITEM",
					"contentId": "Skx3cmyeZ",
					"contentIsRoot": false,
					"contentParentId": "S1RsqXyxW"
				},
				{
					"configId": "IMAGE_ITEM",
					"contentId": "r1fncXkl-",
					"contentIsRoot": false,
					"contentParentId": "S1RsqXyxW"
				},
				{
					"configId": "IMAGE_ITEM",
					"contentId": "HyE39mJxZ",
					"contentIsRoot": false,
					"contentParentId": "S1RsqXyxW"
				},
				{
					"contentId": "rJOPzNJlZ",
					"contentIsRoot": false,
					"contentParentId": "rykDzVJlZ",
					"contentContent": "<h2>Dates for your diary</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "BycvG4Jl-",
					"contentIsRoot": false,
					"contentParentId": "Bkmwf41xb",
					"contentContent": "<p><strong>29 June 2017 - Windsor</strong> <br /><a href=\"https://www.abi.org.uk/events/international-perspectives-on-international-regulation/\" target=\"_blank\" rel=\"noopener noreferrer\">International Perspectives on International Regulation</a></p>\n<p><strong>4 July 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/abi-long-term-savings-conference-2017-engaging-customers-for-tomorrows-retirement/\" target=\"_blank\" rel=\"noopener noreferrer\">Long-Term Savings Conference 2017: Engaging customers for tomorrow's retirement</a></p>\n<p><strong>12 September 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/ensuring-good-customer-outcomes-in-the-digital-world/\" target=\"_blank\" rel=\"noopener noreferrer\">Ensuring good customer outcomes in the digital world</a></p>\n<p><strong>2 &amp; 3 October 2017 &ndash; Brighton</strong> <br /><a href=\"https://www.abi.org.uk/events/abi-insurance-tax-convention-2017/\" target=\"_blank\" rel=\"noopener noreferrer\">ABI Insurance Tax Convention 2017</a></p>\n<p><strong>19 October 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/insurance-in-the-digital-world-cyber-data-and-technology--from-hype-to-reality/\" target=\"_blank\" rel=\"noopener noreferrer\">Insurance in the digital world: cyber, data and technology &ndash; from hype to reality</a></p>",
					"configId": "RICH_TEXT"
				}
			],
			"builtIn": true
		},
		{
			"templateId": "PA",
			"templateName": "Basic Newsletter",
			"templateCategory": "",
			"templateContent": [
				{
					"configId": "ROOT_ITEM",
					"contentId": "r1hMNj8kb",
					"contentIsRoot": true,
					"contentParentId": null
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "BJ4XVs81-",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "rJE_fwwJb",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "rkUr9oLkb",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "HkcD5iIyZ",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "SJLRcoL1Z",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "BkJ1jsIy-",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "BkBfddvyW",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "HyiGu_DJ-",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "HknIO_w1Z",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "BJA8ddw1b",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "rkliuOv1W",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "SkXiuuPyZ",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "BydkYOD1b",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "rkJwFuDkZ",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "SyCFKuPy-",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "HybctdDJZ",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "Hkw9F_Pyb",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "rkfx9uw1W",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "Hyxv5dPkb",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "B1vDq_wJb",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "HysPq_P1Z",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "r10P9OvJb",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "rJwF5uP1-",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "SJnKcuPJW",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "S1f5q_vkb",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "H1S9qdDyb",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "SJ7Wis81-",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "S1XN-28y-",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "BknKodw1Z",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "rJACk28kb",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "MAIN_ROW",
					"contentId": "r1K82sIJ-",
					"contentIsRoot": false,
					"contentParentId": "r1hMNj8kb"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "B1eN7NoUkb",
					"contentIsRoot": false,
					"contentParentId": "BJ4XVs81-"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "Hy-V7VsI1-",
					"contentIsRoot": false,
					"contentParentId": "B1eN7NoUkb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "H1GNmNoUyZ",
					"contentIsRoot": false,
					"contentParentId": "Hy-V7VsI1-"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "BJ7Nm4jUy-",
					"contentIsRoot": false,
					"contentParentId": "H1GNmNoUyZ"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "BJ4Em4oUk-",
					"contentIsRoot": false,
					"contentParentId": "BJ7Nm4jUy-"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "S1SEmNo8JW",
					"contentIsRoot": false,
					"contentParentId": "BJ4Em4oUk-"
				},
				{
					"contentId": "HJwBEiIy-",
					"contentIsRoot": false,
					"contentParentId": "S1SEmNo8JW",
					"contentContent": "<p>Your monthly update on UK public affairs at the ABI</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"contentId": "r1YSEiIJb",
					"contentIsRoot": false,
					"contentParentId": "S1SEmNo8JW",
					"contentContent": "<p style=\"text-align: right;\">Click <a href=\"${Gears.microsite()}\">here</a> if you are having trouble viewing this message.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "B1U9OiLkZ",
					"contentIsRoot": false,
					"contentParentId": "rks4ujU1Z"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "By_9_sIkW",
					"contentIsRoot": false,
					"contentParentId": "B1U9OiLkZ"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "HyH41zvJW",
					"contentIsRoot": false,
					"contentParentId": "B1U9OiLkZ"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "HJi5OiI1-",
					"contentIsRoot": false,
					"contentParentId": "B1U9OiLkZ"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "S17j_jU1Z",
					"contentIsRoot": false,
					"contentParentId": "B1U9OiLkZ"
				},
				{
					"styleWidth": "130px",
					"styleTextAlignment": "left",
					"contentId": "SJ05_sUk-",
					"contentIsRoot": false,
					"contentParentId": "By_9_sIkW",
					"contentContent": {
						"imageId": "O25N",
						"imageAlt": "ABI Logo Light",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
						"imageCategory": "logos",
						"imageAdded": "2017-05-02T19:33:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"styleAltText": "ABI Logo Light"
				},
				{
					"stylePadding": "0",
					"styleTextColour": "#ffffff",
					"styleTextAlignment": "left",
					"contentId": "ByOXFoIJZ",
					"contentIsRoot": false,
					"contentParentId": "HJi5OiI1-",
					"contentContent": "<h1>&nbsp;</h1>\n<h1>ABI General Election 2017</h1>",
					"configId": "RICH_TEXT",
					"configEditorType": "basic",
					"configEditorRoot": "h1"
				},
				{
					"stylePadding": "0",
					"styleTextColour": "#ffffff",
					"styleTextAlignment": "left",
					"contentId": "H1tYYiIkW",
					"contentIsRoot": false,
					"contentParentId": "S17j_jU1Z",
					"contentContent": "<p>3 May 2017</p>",
					"configId": "RICH_TEXT",
					"configEditorType": "basic"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "r1xIrqiUJW",
					"contentIsRoot": false,
					"contentParentId": "rkUr9oLkb"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "ryZUr5i8kb",
					"contentIsRoot": false,
					"contentParentId": "r1xIrqiUJW"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "ryf8rqj8kW",
					"contentIsRoot": false,
					"contentParentId": "ryZUr5i8kb"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "B1m8r5jUy-",
					"contentIsRoot": false,
					"contentParentId": "ryf8rqj8kW"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "BkE8B5jIkW",
					"contentIsRoot": false,
					"contentParentId": "B1m8r5jUy-"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "BySLS9oI1W",
					"contentIsRoot": false,
					"contentParentId": "BkE8B5jIkW"
				},
				{
					"configId": "AUTHOR_BLOCK",
					"contentId": "r1-mqvDyb",
					"contentIsRoot": false,
					"contentParentId": "BySLS9oI1W"
				},
				{
					"styleWidth": "50%",
					"stylePadding": "20px",
					"contentId": "H19AFrP1W",
					"contentIsRoot": false,
					"contentParentId": "BySLS9oI1W",
					"configId": "CELL_ITEM"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "Syg5vqsU1-",
					"contentIsRoot": false,
					"contentParentId": "HkcD5iIyZ"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "HkW5DcoU1W",
					"contentIsRoot": false,
					"contentParentId": "Syg5vqsU1-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "rkM9DqsLk-",
					"contentIsRoot": false,
					"contentParentId": "HkW5DcoU1W"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HJ7cv5oLkW",
					"contentIsRoot": false,
					"contentParentId": "rkM9DqsLk-"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "ry45PqoIk-",
					"contentIsRoot": false,
					"contentParentId": "HJ7cv5oLkW"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "B1r5wcjLkb",
					"contentIsRoot": false,
					"contentParentId": "ry45PqoIk-"
				},
				{
					"contentId": "SyO3qoLJb",
					"contentIsRoot": false,
					"contentParentId": "B1r5wcjLkb",
					"contentContent": "<p>Good afternoon,</p>\n<p>Welcome to the GE 2017 newsletter from the ABI, with a roundup of the campaign trail from each previous week as we head through the next five weeks of the General Election campaign. If a week was a long time in politics for Harold Wilson in pre-Twitter 1960s Britain, then five weeks could feel like an eternity by modern day standards. The last 12 months have taught us that the political landscape can change in a matter of hours but nevertheless we will keep this note pithy and to the point.&nbsp;</p>\n<p>The political event of the next seven days will, of course, take across the Channel on Sunday &ndash; the 25th President of the French Republic will play an important role in deciding the future of the UK&rsquo;s relationship with the EU. Closer to home, this week sees important local and City mayoral election elections taking place on across Scotland, Wales and England.&nbsp;</p>\n<p>Traditionally at mid-term polls, the governing party is often sent a bloody nose by the electorate but the announcement of the June General Election will mean the hardening of the Conservative vote and frankly the numbers &ndash; polls eh, tsk! &ndash; don&rsquo;t look great for HM Opposition or UKIP in the locals, but maybe Sadiq Khan's success in London can be replicated by Labour in some of the six mayoral votes taking place. Thursday's elections results will form useful data for the parties, as they look to target their efforts in the final month of the election but the most important thing about Thursday will be the political spinning that comes in the wake of it.</p>\n<p>We start our note below with Huw&rsquo;s recent blog below looking at what the General Election could mean for the industry, followed by an assessment of some key legislation &ndash; there is much more below and on our new <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/\">General Election hub</a> which we will be populating on a daily basis as we head towards June 8.&nbsp;</p>\n<p>We&rsquo;ll be back with this note on Monday when we are expecting to see the Conservative Party&rsquo;s 2017 General Election manifesto.</p>\n<p>If you think we can be of help over the next five or six weeks or you have any questions, please don&rsquo;t hesitate to drop us a line.</p>\n<p>Seth</p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "H1l80qoIJW",
					"contentIsRoot": false,
					"contentParentId": "SJLRcoL1Z"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "H1-UCci81Z",
					"contentIsRoot": false,
					"contentParentId": "H1l80qoIJW"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "ryfUA5oUkW",
					"contentIsRoot": false,
					"contentParentId": "H1-UCci81Z"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "ry7ICci81b",
					"contentIsRoot": false,
					"contentParentId": "ryfUA5oUkW"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "HJVUR5o81b",
					"contentIsRoot": false,
					"contentParentId": "ry7ICci81b"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "rkB8AcoL1Z",
					"contentIsRoot": false,
					"contentParentId": "HJVUR5o81b"
				},
				{
					"contentId": "Sy_0cs8Jb",
					"contentIsRoot": false,
					"contentParentId": "rkB8AcoL1Z",
					"contentContent": "<h2>DG General Election Blog - opportunity or obstacle?</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "S1eyyiiIJb",
					"contentIsRoot": false,
					"contentParentId": "BkJ1jsIy-"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "r1Z1JojLk-",
					"contentIsRoot": false,
					"contentParentId": "S1eyyiiIJb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "B1fkkisLJZ",
					"contentIsRoot": false,
					"contentParentId": "r1Z1JojLk-"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HJQyksjIkW",
					"contentIsRoot": false,
					"contentParentId": "B1fkkisLJZ"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "By4k1ji8J-",
					"contentIsRoot": false,
					"contentParentId": "HJQyksjIkW"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "ryB1JssIk-",
					"contentIsRoot": false,
					"contentParentId": "By4k1ji8J-"
				},
				{
					"contentId": "S1ZJsoI1-",
					"contentIsRoot": false,
					"contentParentId": "ryB1JssIk-",
					"contentContent": "<p>Read Huw Evans&rsquo; <a href=\"https://www.abi.org.uk/news/blog-articles/general-election-2017-opportunity-or-obstacle/\">latest blog</a> on the impact of the election for the insurance and long-term savings industry. In the blog Huw argues that whilst the election has caused initial concern in some sectors of the industry, the main impact on much of our work - if the current Government remains in power as the polls indicate &ndash; is delay rather than disruption.</p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "SJgQWoiI1W",
					"contentIsRoot": false,
					"contentParentId": "SJ7Wis81-"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "Sk-mZisUyW",
					"contentIsRoot": false,
					"contentParentId": "SJgQWoiI1W"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SJz7ZosL1W",
					"contentIsRoot": false,
					"contentParentId": "Sk-mZisUyW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "B177bosI1b",
					"contentIsRoot": false,
					"contentParentId": "SJz7ZosL1W"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "SJNQZjoUyZ",
					"contentIsRoot": false,
					"contentParentId": "B177bosI1b"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "B1BX-jiUy-",
					"contentIsRoot": false,
					"contentParentId": "SJNQZjoUyZ"
				},
				{
					"styleTextAlignment": "center",
					"contentId": "HyrZosI1b",
					"contentIsRoot": false,
					"contentParentId": "B1BX-jiUy-",
					"contentContent": "<h2>Meet the Team</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "SJxFLnj8JZ",
					"contentIsRoot": false,
					"contentParentId": "r1K82sIJ-"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "B1Wt8njUy-",
					"contentIsRoot": false,
					"contentParentId": "SJxFLnj8JZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BkGFIno8y-",
					"contentIsRoot": false,
					"contentParentId": "B1Wt8njUy-"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "S1mt8hoI1Z",
					"contentIsRoot": false,
					"contentParentId": "BkGFIno8y-"
				},
				{
					"styleWidth": "620px",
					"contentId": "ryVtU2jUyb",
					"contentIsRoot": false,
					"contentParentId": "S1mt8hoI1Z",
					"configId": "TABLE_ITEM",
					"editorLocked": true
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "BJSYI3sUyW",
					"contentIsRoot": false,
					"contentParentId": "ryVtU2jUyb"
				},
				{
					"contentId": "Bkb_2o8yZ",
					"contentIsRoot": false,
					"contentParentId": "BJSYI3sUyW",
					"contentContent": "<p>If you no longer wish to receive these emails, please <a href=\"${Gears.unsubscribe()}\">unsubscribe</a>.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HJxCRkhUk-",
					"contentIsRoot": false,
					"contentParentId": "rJACk28kb"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "Sy-ARJ2Iyb",
					"contentIsRoot": false,
					"contentParentId": "HJxCRkhUk-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "Hkf0RJhU1W",
					"contentIsRoot": false,
					"contentParentId": "Sy-ARJ2Iyb"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HkmR01n81W",
					"contentIsRoot": false,
					"contentParentId": "Hkf0RJhU1W"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "HkyJxnIkZ",
					"contentIsRoot": false,
					"contentParentId": "HkmR01n81W"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "rkgJ1en8Jb",
					"contentIsRoot": false,
					"contentParentId": "HkyJxnIkZ"
				},
				{
					"styleBackgroundColour": "#2f1a45",
					"styleTextColour": "#ffffff",
					"contentId": "H1yxnsLJZ",
					"contentIsRoot": false,
					"contentParentId": "rkgJ1en8Jb",
					"contentContent": "<p>Copyright &copy; 2019 Association of British Insurers, All rights reserved.</p>\n<p>You received this email because you are a past recipient of ABI newsletters. Click <span style=\"color: #ffffff;\"><a style=\"color: #ffffff;\" href=\"https://www.abi.org.uk/privacy-policy/\">here</a> </span>to read our privacy notice.</p>\n<p><strong>Our mailing address is:</strong><br />Association of British Insurers, One America Square, 17 Crosswall, London, EC3N 2LB, United Kingdom</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "r1gQEWhI1-",
					"contentIsRoot": false,
					"contentParentId": "S1XN-28y-"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "H1bQ4W2Ly-",
					"contentIsRoot": false,
					"contentParentId": "r1gQEWhI1-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SJMX4bnIkZ",
					"contentIsRoot": false,
					"contentParentId": "H1bQ4W2Ly-"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "ByXX4-2Ukb",
					"contentIsRoot": false,
					"contentParentId": "SJMX4bnIkZ"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "ryVXVb281-",
					"contentIsRoot": false,
					"contentParentId": "ByXX4-2Ukb"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "HJS7N-nLkZ",
					"contentIsRoot": false,
					"contentParentId": "ryVXVb281-"
				},
				{
					"stylePadding": "0",
					"contentId": "Bkq41fDJb",
					"contentIsRoot": false,
					"contentParentId": "HyH41zvJW",
					"contentContent": "",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "SJ9ZcHwyZ",
					"contentIsRoot": false,
					"contentParentId": "H19AFrP1W"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "SJ0-crDk-",
					"contentIsRoot": false,
					"contentParentId": "SJ9ZcHwyZ"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "BJMGcrwkW",
					"contentIsRoot": false,
					"contentParentId": "SJ9ZcHwyZ"
				},
				{
					"styleTextAlignment": "left",
					"contentId": "ByLG9rP1Z",
					"contentIsRoot": false,
					"contentParentId": "BJMGcrwkW",
					"configId": "TOC_ITEM"
				},
				{
					"stylePadding": "0",
					"contentId": "S1yXqHDJW",
					"contentIsRoot": false,
					"contentParentId": "SJ0-crDk-",
					"contentContent": "<h4>This issue...</h4>",
					"configId": "RICH_TEXT",
					"configEditorType": "basic",
					"configEditorRoot": "h4"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "rJgVOfDwy-",
					"contentIsRoot": false,
					"contentParentId": "rJE_fwwJb"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "SJbEdzDPyW",
					"contentIsRoot": false,
					"contentParentId": "rJgVOfDwy-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HJfV_zDwkZ",
					"contentIsRoot": false,
					"contentParentId": "SJbEdzDPyW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "H174dfvvkb",
					"contentIsRoot": false,
					"contentParentId": "HJfV_zDwkZ"
				},
				{
					"styleWidth": "620px",
					"styleBackgroundColour": "#2f1a45",
					"contentId": "BkNEdMDvJW",
					"contentIsRoot": false,
					"contentParentId": "H174dfvvkb",
					"configId": "TABLE_ITEM",
					"editorLocked": true
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "H1BEdzwDy-",
					"contentIsRoot": false,
					"contentParentId": "BkNEdMDvJW"
				},
				{
					"styleWidth": "405px",
					"contentId": "Sy5_MwvkZ",
					"contentIsRoot": false,
					"contentParentId": "H1BEdzwDy-",
					"configId": "CELL_ITEM"
				},
				{
					"styleWidth": "215px",
					"contentId": "rkh_GvDJZ",
					"contentIsRoot": false,
					"contentParentId": "H1BEdzwDy-",
					"configId": "CELL_ITEM"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "SJ-6zwDJW",
					"contentIsRoot": false,
					"contentParentId": "Sy5_MwvkZ"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "BJX6zwvkZ",
					"contentIsRoot": false,
					"contentParentId": "SJ-6zwDJW"
				},
				{
					"styleWidth": "365px",
					"stylePadding": "20px",
					"contentId": "rks4ujU1Z",
					"contentIsRoot": false,
					"contentParentId": "BJX6zwvkZ",
					"configId": "CELL_ITEM",
					"viewAttributes": {
						"valign": "middle",
						"align": "center"
					}
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "r1bEXwv1W",
					"contentIsRoot": false,
					"contentParentId": "rkh_GvDJZ"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "SymNQvDJW",
					"contentIsRoot": false,
					"contentParentId": "r1bEXwv1W"
				},
				{
					"styleWidth": "215px",
					"styleHeight": "200px",
					"contentId": "r1tP8sU1W",
					"contentIsRoot": false,
					"contentParentId": "SymNQvDJW",
					"contentContent": {
						"imageId": "R670P",
						"imageAlt": "Main Banner",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/banners/abi_banner3735_e-newsletters_v4a.png",
						"imageCategory": "banners",
						"imageAdded": "2017-05-02T19:33:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"styleAltText": "Main Banner"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"contentId": "Hyg-mcvP1-",
					"contentIsRoot": false,
					"contentParentId": "r1-mqvDyb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "B1b-Q9DDJZ",
					"contentIsRoot": false,
					"contentParentId": "Hyg-mcvP1-"
				},
				{
					"styleWidth": "120px",
					"styleTextAlignment": "left",
					"contentId": "HkMbmcPDJb",
					"contentIsRoot": false,
					"contentParentId": "B1b-Q9DDJZ",
					"contentContent": {
						"imageId": "I831R",
						"imageAlt": "Seth Williams",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/SethWILLIAMS.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BJ7-m5PP1W",
					"contentIsRoot": false,
					"contentParentId": "Hyg-mcvP1-"
				},
				{
					"stylePadding": "5px 0",
					"contentId": "r1EZm9wDy-",
					"contentIsRoot": false,
					"contentParentId": "BJ7-m5PP1W",
					"contentContent": "<p><strong>Seth Williams</strong><br />Assistant Director, Head of Public Affairs, ABI</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "H18m5DDJ-",
					"contentIsRoot": false,
					"contentParentId": "HJS7N-nLkZ"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "rkKm5vwyb",
					"contentIsRoot": false,
					"contentParentId": "HJS7N-nLkZ"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "B1iX9vPJZ",
					"contentIsRoot": false,
					"contentParentId": "HJS7N-nLkZ"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "H1eI7qwDyb",
					"contentIsRoot": false,
					"contentParentId": "H18m5DDJ-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BkbLQqPPkZ",
					"contentIsRoot": false,
					"contentParentId": "H1eI7qwDyb"
				},
				{
					"styleWidth": "120px",
					"contentId": "HJGUXqvD1-",
					"contentIsRoot": false,
					"contentParentId": "BkbLQqPPkZ",
					"contentContent": {
						"imageId": "I831R",
						"imageAlt": "Seth Williams",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/SethWILLIAMS.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "S1QLm5vw1W",
					"contentIsRoot": false,
					"contentParentId": "H1eI7qwDyb"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "ByVI7cwvJW",
					"contentIsRoot": false,
					"contentParentId": "S1QLm5vw1W",
					"contentContent": "<p><strong>Seth Williams</strong><br />Assistant Director, Head of Public Affairs<br /><a href=\"mailto:seth.williams@abi.org.uk\" target=\"_blank\" rel=\"noopener noreferrer\">seth.williams@abi.org.uk</a></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "B1xFm5DvkZ",
					"contentIsRoot": false,
					"contentParentId": "rkKm5vwyb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "ry-Y7qDPkZ",
					"contentIsRoot": false,
					"contentParentId": "B1xFm5DvkZ"
				},
				{
					"styleWidth": "120px",
					"contentId": "S1fFQ5vw1W",
					"contentIsRoot": false,
					"contentParentId": "ry-Y7qDPkZ",
					"contentContent": {
						"imageId": "B492B",
						"imageAlt": "Alastair Ross",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlistairROSS.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HkmYm5Dvyb",
					"contentIsRoot": false,
					"contentParentId": "B1xFm5DvkZ"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "HkVtQ9Dwyb",
					"contentIsRoot": false,
					"contentParentId": "HkmYm5Dvyb",
					"contentContent": "<p><strong>Alastair Ross FCIPR</strong><br />Assistant Director, Head of Public Policy (Scotland, Wales &amp; NI)<br /><a href=\"mailto:alastair.ross@abi.org.uk\" target=\"_blank\" rel=\"noopener noreferrer\">alastair.ross@abi.org.uk</a></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "r1esX5wvk-",
					"contentIsRoot": false,
					"contentParentId": "B1iX9vPJZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SkZj79Pw1b",
					"contentIsRoot": false,
					"contentParentId": "r1esX5wvk-"
				},
				{
					"styleWidth": "120px",
					"contentId": "Byzj7cPDkb",
					"contentIsRoot": false,
					"contentParentId": "SkZj79Pw1b",
					"contentContent": {
						"imageId": "B628T",
						"imageAlt": "Miranda Cochrane",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/MirandaCochrane.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "S1mi79vv1Z",
					"contentIsRoot": false,
					"contentParentId": "r1esX5wvk-"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "By4j79wD1Z",
					"contentIsRoot": false,
					"contentParentId": "S1mi79vv1Z",
					"contentContent": "<p><strong>Miranda Cochrane</strong><br />Public Affairs Manager<br /><a href=\"mailto:miranda.cochrane@abi.org.uk\">miranda.cochrane@abi.org.uk</a></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "ByxHGu_D1-",
					"contentIsRoot": false,
					"contentParentId": "BkBfddvyW"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "BJ-BG__wyb",
					"contentIsRoot": false,
					"contentParentId": "ByxHGu_D1-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "rkMBf_uvkZ",
					"contentIsRoot": false,
					"contentParentId": "BJ-BG__wyb"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HymBM_dvkb",
					"contentIsRoot": false,
					"contentParentId": "rkMBf_uvkZ"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "S1NrGddDJZ",
					"contentIsRoot": false,
					"contentParentId": "HymBM_dvkb"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "BkBBMddPyZ",
					"contentIsRoot": false,
					"contentParentId": "S1NrGddDJZ"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "SJgoGuOw1-",
					"contentIsRoot": false,
					"contentParentId": "HyiGu_DJ-"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "HyZjf_ODyb",
					"contentIsRoot": false,
					"contentParentId": "SJgoGuOw1-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BJGiGOdvk-",
					"contentIsRoot": false,
					"contentParentId": "HyZjf_ODyb"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "SkmoMuODyZ",
					"contentIsRoot": false,
					"contentParentId": "BJGiGOdvk-"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "SJNsMOOPyb",
					"contentIsRoot": false,
					"contentParentId": "SkmoMuODyZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "SkHjMOuvy-",
					"contentIsRoot": false,
					"contentParentId": "SJNsMOOPyb"
				},
				{
					"contentId": "Hyb7uuD1b",
					"contentIsRoot": false,
					"contentParentId": "BkBBMddPyZ",
					"contentContent": "<h2>What does the General Election mean for the legislative agenda?</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "H1ImuOvkZ",
					"contentIsRoot": false,
					"contentParentId": "SkHjMOuvy-",
					"contentContent": "<p>MPs met for the last time in the House of Commons on Thursday 27th April as Parliament prorogued ahead of the General Election.&nbsp;</p>\n<p>The last two weeks prior to prorogation saw a flurry of legislation pushed through for Royal Assent and a frenzy of select committee activity as members and clerks rushed to wrap up inquiries and publish their findings.</p>\n<p>Read our analysis of which Bills made it through the 'wash up', and those which will need to be reintroduced in the next Parliament <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/general-election-impact-on-legislative-agenda/\" target=\"_blank\" rel=\"noopener noreferrer\">here</a>.&nbsp;</p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "Syg28_ODJb",
					"contentIsRoot": false,
					"contentParentId": "HknIO_w1Z"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "HJbnUudvJZ",
					"contentIsRoot": false,
					"contentParentId": "Syg28_ODJb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "rkM38_dD1b",
					"contentIsRoot": false,
					"contentParentId": "HJbnUudvJZ"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "r1Q28_OPyW",
					"contentIsRoot": false,
					"contentParentId": "rkM38_dD1b"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "By4hLddwkW",
					"contentIsRoot": false,
					"contentParentId": "r1Q28_OPyW"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "BJrhI_OD1W",
					"contentIsRoot": false,
					"contentParentId": "By4hLddwkW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "rJl0LduPJW",
					"contentIsRoot": false,
					"contentParentId": "BJA8ddw1b"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "HkW0LOdwyW",
					"contentIsRoot": false,
					"contentParentId": "rJl0LduPJW"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SkGC8uuPk-",
					"contentIsRoot": false,
					"contentParentId": "HkW0LOdwyW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "BJQCUuOvJW",
					"contentIsRoot": false,
					"contentParentId": "SkGC8uuPk-"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "ByVCIuuwk-",
					"contentIsRoot": false,
					"contentParentId": "BJQCUuOvJW"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "rkrR8udvJb",
					"contentIsRoot": false,
					"contentParentId": "ByVCIuuwk-"
				},
				{
					"contentId": "ry9vOdvyb",
					"contentIsRoot": false,
					"contentParentId": "BJrhI_OD1W",
					"contentContent": "<h2>Who's up and who's down</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "By4udOwJ-",
					"contentIsRoot": false,
					"contentParentId": "rkrR8udvJb",
					"contentContent": "<p>Several political heavyweights have announced their retirement from the backbenches since the General Election was announced including Ex-Chancellor George Osborne, who continues his role as adviser at BlackRock as well as taking up a new post as Editor of the Evening Standard, and Andrew Tyrie, the outgoing Conservative Chair of the Treasury Select Committee. Iain Wright, the Labour Chair of the Business, Energy and Industrial Strategy has also announced he will not stand, as has the &nbsp;oldest MP of the 2015-17 Parliament Sir Alan Haselhurst, who is retiring after 40 years of political service.</p>\n<p>You can see the full list of MPs standing down on <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/whos-up-and-whos-down/\" target=\"_blank\" rel=\"noopener noreferrer\">our website</a>, which will be updated throughout the General Election period.</p>\n<p>The final list of election candidates will not be published until after nominations close on 11 May, however many local parties have already chosen their preferred candidate in an effort to get their campaigns off the ground as quickly as possible. We were particularly pleased to see Gillian Keegan, Director of Women2Win and close friend of the ABI, chosen as the Conservative candidate for Andrew Tyrie&rsquo;s constituency Chichester, and Vicky Ford MEP chosen to replace the outgoing Conservative Simon Burns in Chelmsford.</p>\n<p>A number of candidates who lost their seat in 2015 are also staged to make a comeback, including Esther McVey, Chris Williamson, Chris Ruane and Sir Bob Russell. Also looking for a comeback from his defeat in December is Zac Goldmsith who is running against Sarah Olney in Richmond Park.&nbsp;</p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HJeeo_Owy-",
					"contentIsRoot": false,
					"contentParentId": "rkliuOv1W"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "BJZesddDJW",
					"contentIsRoot": false,
					"contentParentId": "HJeeo_Owy-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HkMgsd_vyb",
					"contentIsRoot": false,
					"contentParentId": "BJZesddDJW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HkXgjuuwy-",
					"contentIsRoot": false,
					"contentParentId": "HkMgsd_vyb"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "BJ4xi__vyb",
					"contentIsRoot": false,
					"contentParentId": "HkXgjuuwy-"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "HJHxoO_Dyb",
					"contentIsRoot": false,
					"contentParentId": "BJ4xi__vyb"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "H1eQoOuw1b",
					"contentIsRoot": false,
					"contentParentId": "SkXiuuPyZ"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "rJb7o__wyW",
					"contentIsRoot": false,
					"contentParentId": "H1eQoOuw1b"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "ByzXodODkb",
					"contentIsRoot": false,
					"contentParentId": "rJb7o__wyW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "ryQ7id_Dk-",
					"contentIsRoot": false,
					"contentParentId": "ByzXodODkb"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "rJ47juOwJZ",
					"contentIsRoot": false,
					"contentParentId": "ryQ7id_Dk-"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "BkSXiOOD1Z",
					"contentIsRoot": false,
					"contentParentId": "rJ47juOwJZ"
				},
				{
					"contentId": "ry-T_dvkb",
					"contentIsRoot": false,
					"contentParentId": "HJHxoO_Dyb",
					"contentContent": "<h2>Poll of Polls</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "By96udwk-",
					"contentIsRoot": false,
					"contentParentId": "BkSXiOOD1Z",
					"contentContent": "<p>This time last week saw the Conservatives flying high in the polls, enjoying a 23 point lead over Labour. However day-by-day, or poll-by-poll, Labour&nbsp;appear to be slowly reducing the lead, to a current one of 15 points. A lot of the gains from both parties are coming from the UKIP vote which appears to be crashing - they have lost 4 points in a month and are now struggling at 7%. The Lib Dems are hovering around the 10% mark, decreasing slightly from the 12% that some polls gave them last week.</p>\n<p>How this all translates into seats will be very interesting, some pollsters are predicting up to a 150 seat majority for the Conservative party and if the Lib Dems can concentrate their efforts into specific seats they should be able to make gains as well. While the gap between the Conservatives and Labour is substantial, Labour will be encouraged by their steady increases in the polls and will use this to show that they are not dead and buried.&nbsp;</p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HJeu1YuvyZ",
					"contentIsRoot": false,
					"contentParentId": "BydkYOD1b"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "Sy-_JY_Dy-",
					"contentIsRoot": false,
					"contentParentId": "HJeu1YuvyZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HJfdkFOPkW",
					"contentIsRoot": false,
					"contentParentId": "Sy-_JY_Dy-"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "S1Xdytdvkb",
					"contentIsRoot": false,
					"contentParentId": "HJfdkFOPkW"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "r1V_kK_PJZ",
					"contentIsRoot": false,
					"contentParentId": "S1Xdytdvkb"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "SJrukY_D1b",
					"contentIsRoot": false,
					"contentParentId": "r1V_kK_PJZ"
				},
				{
					"styleWidth": "540\n",
					"contentId": "SyakYODyW",
					"contentIsRoot": false,
					"contentParentId": "SJrukY_D1b",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/poll-of-polls.jpg",
						"imageAlt": "Press Association - Poll of Polls",
						"imageLink": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/poll-of-polls.jpg"
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "rklJPFuwyW",
					"contentIsRoot": false,
					"contentParentId": "rkJwFuDkZ"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "SyWJDF_D1W",
					"contentIsRoot": false,
					"contentParentId": "rklJPFuwyW"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HJzkDYuv1Z",
					"contentIsRoot": false,
					"contentParentId": "SyWJDF_D1W"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HJ71DKdvJ-",
					"contentIsRoot": false,
					"contentParentId": "HJzkDYuv1Z"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "HyEywtuPyb",
					"contentIsRoot": false,
					"contentParentId": "HJ71DKdvJ-"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "SySywKdwkb",
					"contentIsRoot": false,
					"contentParentId": "HyEywtuPyb"
				},
				{
					"contentId": "rymDKdwJZ",
					"contentIsRoot": false,
					"contentParentId": "SySywKdwkb",
					"contentContent": "<p>Image from PA.</p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HJgRttOP1-",
					"contentIsRoot": false,
					"contentParentId": "SyCFKuPy-"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "BkZ0KFuvJ-",
					"contentIsRoot": false,
					"contentParentId": "HJgRttOP1-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "H1GCtF_wk-",
					"contentIsRoot": false,
					"contentParentId": "BkZ0KFuvJ-"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "B1Q0tK_PJb",
					"contentIsRoot": false,
					"contentParentId": "H1GCtF_wk-"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "HkN0FFOwkZ",
					"contentIsRoot": false,
					"contentParentId": "B1Q0tK_PJb"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "rkSCYYOvyW",
					"contentIsRoot": false,
					"contentParentId": "HkN0FFOwkZ"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HJx-qKOwyZ",
					"contentIsRoot": false,
					"contentParentId": "HybctdDJZ"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "SkbW9YOPyb",
					"contentIsRoot": false,
					"contentParentId": "HJx-qKOwyZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "H1fWcFuDJZ",
					"contentIsRoot": false,
					"contentParentId": "SkbW9YOPyb"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "Sk7ZqYOPk-",
					"contentIsRoot": false,
					"contentParentId": "H1fWcFuDJZ"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "ryE-cY_PJb",
					"contentIsRoot": false,
					"contentParentId": "Sk7ZqYOPk-"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "r1BWcYuv1-",
					"contentIsRoot": false,
					"contentParentId": "ryE-cY_PJb"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "ryxP9FuwkW",
					"contentIsRoot": false,
					"contentParentId": "Hkw9F_Pyb"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "SJbvcK_v1-",
					"contentIsRoot": false,
					"contentParentId": "ryxP9FuwkW"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "Hkfv5Fdvk-",
					"contentIsRoot": false,
					"contentParentId": "SJbvcK_v1-"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "SkXP9YuDyb",
					"contentIsRoot": false,
					"contentParentId": "Hkfv5Fdvk-"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "HyVD9Y_DyZ",
					"contentIsRoot": false,
					"contentParentId": "SkXP9YuDyb"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "BkHv5Yuw1b",
					"contentIsRoot": false,
					"contentParentId": "HyVD9Y_DyZ"
				},
				{
					"contentId": "ByMstuD1W",
					"contentIsRoot": false,
					"contentParentId": "rkSCYYOvyW",
					"contentContent": "<h2>Key Battlegrounds</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "B1ZTKOvyb",
					"contentIsRoot": false,
					"contentParentId": "r1BWcYuv1-",
					"contentContent": "<p>The Conservatives are looking to make gains in a&nbsp;number of key target seats in the North of England and Midlands. They will be hoping that the combination of their Northern Powerhouse messaging, a weak Labour party and constituencies which voted by majority for Leave in the EU referendum will help them gain a significant number of seats from the Labour party. The Leave-voting constituency of Halifax is looking most vulnerable with the narrowest Labour majority of just 428 votes.&nbsp;</p>\n<p>Labour will be targeting the seats with the smallest Conservative majorities, hoping that their messages on the NHS and housing gets through to voters. Candidates will also be flying the Labour flag yet many will be representing&nbsp;themselves independently from Jeremy Corbyn and hoping that his poll ratings do not cling to them.&nbsp;</p>\n<p>The Lib Dems, buoyed by their win in Richmond Park at the end of last year by standing on an anti-Brexit platform will be hoping that the momentum carries on long enough for them to gain back some seats which they lost in 2015. The liberal west of England will have several key target seats as well as constituencies which voted Remain in the referendum, such as Lewes, Twickenham and Cambridge.&nbsp;</p>\n<p>With a range of media outfits offering sage advice, this week we bring you the Telegraph's take on target seats for each of the three main parties as well as the result in 2015. Images courtesy of Ashley Kirk at The Telegraph.&nbsp;</p>",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "580px",
					"contentId": "HJiy5uP1W",
					"contentIsRoot": false,
					"contentParentId": "BkHv5Yuw1b",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/election-and-tory.jpg",
						"imageAlt": "Map 2",
						"imageLink": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/election-and-tory.jpg"
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "SJgfe5uDyb",
					"contentIsRoot": false,
					"contentParentId": "rkfx9uw1W"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "H1bfecOvJZ",
					"contentIsRoot": false,
					"contentParentId": "SJgfe5uDyb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BkGfeqdvJ-",
					"contentIsRoot": false,
					"contentParentId": "H1bfecOvJZ"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "BJ7zl5_Pyb",
					"contentIsRoot": false,
					"contentParentId": "BkGfeqdvJ-"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "BJ4zg5OP1-",
					"contentIsRoot": false,
					"contentParentId": "BJ7zl5_Pyb"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "SyHze9_DJ-",
					"contentIsRoot": false,
					"contentParentId": "BJ4zg5OP1-"
				},
				{
					"styleWidth": "580px",
					"contentId": "SJFgqOwkb",
					"contentIsRoot": false,
					"contentParentId": "SyHze9_DJ-",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/lab-and-ld.jpg",
						"imageAlt": "Map 2",
						"imageLink": "https://www.abi.org.uk/globalassets/images/newsletter/single-newsletter/pa/2017/lab-and-ld.jpg"
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "rkxxDquwJb",
					"contentIsRoot": false,
					"contentParentId": "Hyxv5dPkb"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "BkZxD5OD1-",
					"contentIsRoot": false,
					"contentParentId": "rkxxDquwJb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SkfxP9uv1b",
					"contentIsRoot": false,
					"contentParentId": "BkZxD5OD1-"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "BJQlP9uw1W",
					"contentIsRoot": false,
					"contentParentId": "SkfxP9uv1b"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "H1VevqOwkW",
					"contentIsRoot": false,
					"contentParentId": "BJQlP9uw1W"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "BJHxwq_vyZ",
					"contentIsRoot": false,
					"contentParentId": "H1VevqOwkW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "rygDwq_D1-",
					"contentIsRoot": false,
					"contentParentId": "B1vDq_wJb"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "HkbPDq_wk-",
					"contentIsRoot": false,
					"contentParentId": "rygDwq_D1-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "B1GPvcdvk-",
					"contentIsRoot": false,
					"contentParentId": "HkbPDq_wk-"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "rk7wPcuDyW",
					"contentIsRoot": false,
					"contentParentId": "B1GPvcdvk-"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "SkVwD9dPyb",
					"contentIsRoot": false,
					"contentParentId": "rk7wPcuDyW"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "SkHvP5_w1Z",
					"contentIsRoot": false,
					"contentParentId": "SkVwD9dPyb"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HylsD5dDkb",
					"contentIsRoot": false,
					"contentParentId": "HysPq_P1Z"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "SJbow9_vJZ",
					"contentIsRoot": false,
					"contentParentId": "HylsD5dDkb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "r1Msv5dP1-",
					"contentIsRoot": false,
					"contentParentId": "SJbow9_vJZ"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "SJQjP5_DkZ",
					"contentIsRoot": false,
					"contentParentId": "r1Msv5dP1-"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "SyNivqOwkZ",
					"contentIsRoot": false,
					"contentParentId": "SJQjP5_DkZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "H1HjwqdDJW",
					"contentIsRoot": false,
					"contentParentId": "SyNivqOwkZ"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "Bke0w9OvJb",
					"contentIsRoot": false,
					"contentParentId": "r10P9OvJb"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "S1-0Dc_DkZ",
					"contentIsRoot": false,
					"contentParentId": "Bke0w9OvJb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "H1fRD5_PJ-",
					"contentIsRoot": false,
					"contentParentId": "S1-0Dc_DkZ"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "rymRwq_wyb",
					"contentIsRoot": false,
					"contentParentId": "H1fRD5_PJ-"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "Hy4Cw5ODkb",
					"contentIsRoot": false,
					"contentParentId": "rymRwq_wyb"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "BJr0DqdPy-",
					"contentIsRoot": false,
					"contentParentId": "Hy4Cw5ODkb"
				},
				{
					"contentId": "r1HO9ODJ-",
					"contentIsRoot": false,
					"contentParentId": "BJHxwq_vyZ",
					"contentContent": "<h2>The campaign so far...</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "HJtOqdvJZ",
					"contentIsRoot": false,
					"contentParentId": "SkHvP5_w1Z",
					"contentContent": "<p>Last week saw the parties begin the battle for airtime and soundbites while also trying to bury all of the bad publicity that a General Election inevitably brings.&nbsp;</p>\n<p>Read our roundup of tales from the campaign trail on the <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/from-the-campaign-trail/\">General Election Member Hub here.</a></p>",
					"configId": "RICH_TEXT"
				},
				{
					"contentId": "BJ0ucdvyZ",
					"contentIsRoot": false,
					"contentParentId": "H1HjwqdDJW",
					"contentContent": "<h2>Beyond the Westminster Bubble</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "HJ-K5_v1W",
					"contentIsRoot": false,
					"contentParentId": "BJr0DqdPy-",
					"contentContent": "<p>Away from England, Alastair writes about the poll of Conservative success in Wales which has shocked the other parties, the issue of independence rumbling on in Scotland ahead of their local authority elections tomorrow and all of the goings on in Northern Ireland. You can read Alastair's <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/beyond-the-westminster-bubble/\">latest update here.</a></p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "B1ePY5_DJb",
					"contentIsRoot": false,
					"contentParentId": "rJwF5uP1-"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "ry-vt5dPyW",
					"contentIsRoot": false,
					"contentParentId": "B1ePY5_DJb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HkGwK9Ovkb",
					"contentIsRoot": false,
					"contentParentId": "ry-vt5dPyW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "SymwYqODJb",
					"contentIsRoot": false,
					"contentParentId": "HkGwK9Ovkb"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "Hy4PtcOD1Z",
					"contentIsRoot": false,
					"contentParentId": "SymwYqODJb"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "ByHPt9_wJW",
					"contentIsRoot": false,
					"contentParentId": "Hy4PtcOD1Z"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "SJxhY5OwyZ",
					"contentIsRoot": false,
					"contentParentId": "SJnKcuPJW"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "Bk-ntcuw1-",
					"contentIsRoot": false,
					"contentParentId": "SJxhY5OwyZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "Hkf2K9dvJ-",
					"contentIsRoot": false,
					"contentParentId": "Bk-ntcuw1-"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "BJQht5OvkZ",
					"contentIsRoot": false,
					"contentParentId": "Hkf2K9dvJ-"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "rJEnFqODyZ",
					"contentIsRoot": false,
					"contentParentId": "BJQht5OvkZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "BJr3K9OwJZ",
					"contentIsRoot": false,
					"contentParentId": "rJEnFqODyZ"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "HJlzqcOPyb",
					"contentIsRoot": false,
					"contentParentId": "S1f5q_vkb"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "rkWGqcdPyW",
					"contentIsRoot": false,
					"contentParentId": "HJlzqcOPyb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "H1zG99uwJZ",
					"contentIsRoot": false,
					"contentParentId": "rkWGqcdPyW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "rkmz9c_D1b",
					"contentIsRoot": false,
					"contentParentId": "H1zG99uwJZ"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "H1Nz9qOvkW",
					"contentIsRoot": false,
					"contentParentId": "rkmz9c_D1b"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "rkBGqquwkW",
					"contentIsRoot": false,
					"contentParentId": "H1Nz9qOvkW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "ByxBq9_PyZ",
					"contentIsRoot": false,
					"contentParentId": "H1S9qdDyb"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "BkZSqqOwkW",
					"contentIsRoot": false,
					"contentParentId": "ByxBq9_PyZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HyzBc9OvJZ",
					"contentIsRoot": false,
					"contentParentId": "BkZSqqOwkW"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "ryXB5q_v1W",
					"contentIsRoot": false,
					"contentParentId": "HyzBc9OvJZ"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "H1EB59Ov1b",
					"contentIsRoot": false,
					"contentParentId": "ryXB5q_v1W"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "rkHS95_Dkb",
					"contentIsRoot": false,
					"contentParentId": "H1EB59Ov1b"
				},
				{
					"contentId": "HyO99Owkb",
					"contentIsRoot": false,
					"contentParentId": "ByHPt9_wJW",
					"contentContent": "<h2>General Election 2017 member hub</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "HyPj9OPy-",
					"contentIsRoot": false,
					"contentParentId": "BJr3K9OwJZ",
					"contentContent": "<p>To keep members up to date during the pre-election period the ABI has created a <a href=\"https://www.abi.org.uk/members/topics-and-issues/general-election-2017-member-hub/\">General Election 2017</a> member hub on the ABI website. Here you will find updates and analysis on what the election will mean for the UK insurance and long-term savings industry and regular insights on the campaigns from the team at the ABI.</p>",
					"configId": "RICH_TEXT"
				},
				{
					"contentId": "Byx2cdP1-",
					"contentIsRoot": false,
					"contentParentId": "rkBGqquwkW",
					"contentContent": "<h2>Want more? Some key sites for election news</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "rkLhcuPyb",
					"contentIsRoot": false,
					"contentParentId": "rkHS95_Dkb",
					"contentContent": "<p>Conservatives: <a href=\"http://www.conservativehome.com/\">www.conservativehome.com&nbsp;<br /></a>Labour: <a href=\"http://labourlist.org/\">www.labourlist.org&nbsp;<br /></a>Liberal Democrats: <a href=\"http://www.libdemvoice.org/\">http://www.libdemvoice.org/&nbsp;</a></p>\n<p>&nbsp;</p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "Byx3YjOv1-",
					"contentIsRoot": false,
					"contentParentId": "BknKodw1Z"
				},
				{
					"configId": "TABLE_ITEM",
					"viewClass": "full-width",
					"editorLocked": true,
					"contentId": "HJ-2KsODJb",
					"contentIsRoot": false,
					"contentParentId": "Byx3YjOv1-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HkfhFsOwJZ",
					"contentIsRoot": false,
					"contentParentId": "HJ-2KsODJb"
				},
				{
					"configId": "CELL_ITEM",
					"editorLocked": true,
					"contentId": "BJX2Yj_PyZ",
					"contentIsRoot": false,
					"contentParentId": "HkfhFsOwJZ"
				},
				{
					"configId": "TABLE_ITEM",
					"styleWidth": "620px",
					"styleBackgroundColour": "#ffffff",
					"editorLocked": true,
					"contentId": "BJ43FsuDkb",
					"contentIsRoot": false,
					"contentParentId": "BJX2Yj_PyZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorSelectable": false,
					"editorDraggable": false,
					"editorHideable": false,
					"editorCloneable": false,
					"editorDeletable": false,
					"editorEditable": false,
					"editorSaveable": false,
					"contentId": "HyBhKouwkZ",
					"contentIsRoot": false,
					"contentParentId": "BJ43FsuDkb"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "BJZqidDkb",
					"contentIsRoot": false,
					"contentParentId": "HyBhKouwkZ"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "SJI5j_PJZ",
					"contentIsRoot": false,
					"contentParentId": "HyBhKouwkZ"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "Hyq9o_D1-",
					"contentIsRoot": false,
					"contentParentId": "HyBhKouwkZ"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "Syxb5jdDyb",
					"contentIsRoot": false,
					"contentParentId": "BJZqidDkb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "ryWW5jdvJ-",
					"contentIsRoot": false,
					"contentParentId": "Syxb5jdDyb"
				},
				{
					"styleWidth": "120px",
					"styleHeight": "120px",
					"contentId": "HkM-cjOP1W",
					"contentIsRoot": false,
					"contentParentId": "ryWW5jdvJ-",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/stefkenyon2.jpg",
						"imageAlt": "Stef Kenyon"
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HkXbcouPkb",
					"contentIsRoot": false,
					"contentParentId": "Syxb5jdDyb"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "ByEWqiODJZ",
					"contentIsRoot": false,
					"contentParentId": "HkXbcouPkb",
					"contentContent": "<p><strong>Stephanie Kenyon</strong><br />Public Affairs Manager<br /><a href=\"mailto:stephanie.kenyon@abi.org.uk\">stephanie.kenyon@abi.org.uk</a></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "BylLqsdDy-",
					"contentIsRoot": false,
					"contentParentId": "SJI5j_PJZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "Sy-Ici_wJ-",
					"contentIsRoot": false,
					"contentParentId": "BylLqsdDy-"
				},
				{
					"styleWidth": "120px",
					"contentId": "BJM8qouwy-",
					"contentIsRoot": false,
					"contentParentId": "Sy-Ici_wJ-",
					"contentContent": {
						"imageId": "J823W",
						"imageAlt": "Rebecca Gladstone",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/RebeccaGLADSTONE.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "Hy789iOv1W",
					"contentIsRoot": false,
					"contentParentId": "BylLqsdDy-"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "H1NI9jOD1W",
					"contentIsRoot": false,
					"contentParentId": "Hy789iOv1W",
					"contentContent": "<p><strong>Rebecca Gladstone</strong><br />Public Affairs Adviser<br /><a href=\"mailto:Rebecca.Gladstone@abi.org.uk\" target=\"_blank\" rel=\"noopener noreferrer\">Rebecca.Gladstone@abi.org.uk</a></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "Skgqqi_vyb",
					"contentIsRoot": false,
					"contentParentId": "Hyq9o_D1-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "rkbq9juw1W",
					"contentIsRoot": false,
					"contentParentId": "Skgqqi_vyb"
				},
				{
					"styleWidth": "120px",
					"contentId": "B1f99i_wJ-",
					"contentIsRoot": false,
					"contentParentId": "rkbq9juw1W",
					"contentContent": {
						"imageId": "D931X",
						"imageAlt": "Zoe Russell",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/ZoeRussell.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HkX5qiOD1-",
					"contentIsRoot": false,
					"contentParentId": "Skgqqi_vyb"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "HkNcqjOD1-",
					"contentIsRoot": false,
					"contentParentId": "HkX5qiOD1-",
					"contentContent": "<p><strong>Zoe Russell</strong><br />Communications &amp; Public Affairs Assistant<br /><a href=\"mailto:zoe.russell@abi.org.uk\">zoe.russell@abi.org.uk</a></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				}
			],
			"builtIn": true
		},
		{
			"templateId": "associatemembers",
			"templateName": "Associate Members",
			"templateCategory": "",
			"templateContent": [
				{
					"configId": "ROOT_ITEM",
					"contentId": "By8akQ1g-",
					"contentIsRoot": true,
					"contentParentId": null
				},
				{
					"configId": "SECTION",
					"contentId": "S1mAJX1eW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"styleBackgroundColour": "#230052",
					"contentId": "S1qUlXylb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"configId": "SECTION",
					"contentId": "BywsHXJlW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "SkRhSXklW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "HkspHQJeb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "SywTUQyeW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "rJhT8QyxZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "ByxRIQ1x-",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "r1R6U7JeZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "BJW1v7JxZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "SJIX2E4--",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "HkgL24VWZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "HyjzTN4ZW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "Byem6E4WZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "r1SUp44bW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "S1TLaNVW-",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "r11saEV-Z",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "rySi64EWW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "Sk8dyHNbZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "H15ukSV-W",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "BkelgSV-W",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "HyFgxS4bZ",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "ry9-gB4Zb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "HJgxwQ1eW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "rk5QeBN-Z",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "r1FMgr4-Z",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"styleBackgroundColour": "#230052",
					"contentId": "SyDbv71lW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"configId": "SECTION",
					"contentId": "SycvwXyxb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"contentId": "Hk_Ck7Jg-",
					"contentIsRoot": false,
					"contentParentId": "S1mAJX1eW",
					"contentContent": "<p>The ABI's update for Associate Members and Partners</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleTextAlignment": "right",
					"contentId": "Skn01X1eW",
					"contentIsRoot": false,
					"contentParentId": "S1mAJX1eW",
					"contentContent": "<p>Click <a href=\"${Gears.microsite()}\" target=\"_blank\" rel=\"noopener noreferrer\">here</a> if you are having trouble viewing this message.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleWidth": "405px",
					"stylePadding": "20px",
					"contentId": "HknIgmygW",
					"contentIsRoot": false,
					"contentParentId": "S1qUlXylb",
					"configId": "COLUMN"
				},
				{
					"styleWidth": "215px",
					"contentId": "B1TLlQJgb",
					"contentIsRoot": false,
					"contentParentId": "S1qUlXylb",
					"configId": "COLUMN"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rkehlQJeb",
					"contentIsRoot": false,
					"contentParentId": "B1TLlQJgb"
				},
				{
					"contentId": "SJf3gm1lZ",
					"contentIsRoot": false,
					"contentParentId": "rkehlQJeb",
					"contentContent": {
						"imageId": "M671R",
						"imageAlt": "Main Banner",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/banners/abi_banner3735_e-newsletters_v4a.png",
						"imageCategory": "banners",
						"imageAdded": "2017-05-02T19:33:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rJbXEQ1e-",
					"contentIsRoot": false,
					"contentParentId": "HknIgmygW"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "r14QN7Jgb",
					"contentIsRoot": false,
					"contentParentId": "HknIgmygW"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "BJP74m1xZ",
					"contentIsRoot": false,
					"contentParentId": "HknIgmygW"
				},
				{
					"styleWidth": "130px",
					"styleTextAlignment": "left",
					"contentId": "HkQBV7ke-",
					"contentIsRoot": false,
					"contentParentId": "rJbXEQ1e-",
					"contentContent": {
						"imageId": "O351V",
						"imageAlt": "ABI Logo Light",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
						"imageCategory": "logos",
						"imageAdded": "2017-05-02T19:33:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"stylePadding": "10px 0 0",
					"styleTextColour": "#ffffff",
					"contentId": "SywO4XJxb",
					"contentIsRoot": false,
					"contentParentId": "r14QN7Jgb",
					"contentContent": "<h1>ABI Associate Member and Partner Newsletter</h1>",
					"configId": "RICH_TEXT",
					"configEditorRoot": "h1"
				},
				{
					"stylePadding": "0",
					"styleTextColour": "#ffffff",
					"contentId": "H1quN71gb",
					"contentIsRoot": false,
					"contentParentId": "BJP74m1xZ",
					"contentContent": "<p>??? 2017</p>",
					"configId": "RICH_TEXT"
				},
				{
					"contentId": "HyEaSXye-",
					"contentIsRoot": false,
					"contentParentId": "SkRhSXklW",
					"configId": "RICH_TEXT"
				},
				{
					"contentId": "SykCSQygW",
					"contentIsRoot": false,
					"contentParentId": "HkspHQJeb",
					"configId": "SECTION_HEADER"
				},
				{
					"styleWidth": "50%",
					"contentId": "HkK-UXyeb",
					"contentIsRoot": false,
					"contentParentId": "BywsHXJlW",
					"configId": "COLUMN"
				},
				{
					"styleWidth": "50%",
					"contentId": "r10-U71l-",
					"contentIsRoot": false,
					"contentParentId": "BywsHXJlW",
					"configId": "COLUMN"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "ByfmU7JeZ",
					"contentIsRoot": false,
					"contentParentId": "HkK-UXyeb"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rJSmIXJxb",
					"contentIsRoot": false,
					"contentParentId": "r10-U71l-"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "ByI7U7yeZ",
					"contentIsRoot": false,
					"contentParentId": "r10-U71l-"
				},
				{
					"configId": "AUTHOR_BLOCK",
					"contentId": "ryh7IX1xb",
					"contentIsRoot": false,
					"contentParentId": "ByfmU7JeZ"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"contentId": "r1g3mIQ1xb",
					"contentIsRoot": false,
					"contentParentId": "ryh7IX1xb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SybnX8Xylb",
					"contentIsRoot": false,
					"contentParentId": "r1g3mIQ1xb"
				},
				{
					"styleWidth": "120px",
					"styleTextAlignment": "left",
					"contentId": "rJGhm8mJlZ",
					"contentIsRoot": false,
					"contentParentId": "SybnX8Xylb",
					"contentContent": {
						"imageId": "A110R",
						"imageAlt": "Huw Evans",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/HuwEvans.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BkQ3Q87JeW",
					"contentIsRoot": false,
					"contentParentId": "r1g3mIQ1xb"
				},
				{
					"stylePadding": "5px 0",
					"contentId": "HJVh7I7JeZ",
					"contentIsRoot": false,
					"contentParentId": "BkQ3Q87JeW",
					"contentContent": "<p><strong>Huw Evans</strong> <br />Director General, ABI <br /><a href=\"https://twitter.com/huwevans71\">@huwevans71</a></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"stylePadding": "0 20px 20px",
					"styleTextAlignment": "left",
					"contentId": "HkkVLQyxW",
					"contentIsRoot": false,
					"contentParentId": "ByI7U7yeZ",
					"configId": "TOC_ITEM"
				},
				{
					"stylePadding": "20px 20px 10px",
					"contentId": "SJENLX1lb",
					"contentIsRoot": false,
					"contentParentId": "rJSmIXJxb",
					"contentContent": "<h4>This issue...</h4>",
					"configId": "RICH_TEXT",
					"configEditorRoot": "h4"
				},
				{
					"contentId": "r1I0I71g-",
					"contentIsRoot": false,
					"contentParentId": "rJhT8QyxZ",
					"contentContent": "<h2>General Insurance and Health</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"contentId": "Hy_CLmyl-",
					"contentIsRoot": false,
					"contentParentId": "r1R6U7JeZ",
					"contentContent": "<h2>Europe and International Affairs</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"configId": "RICH_TEXT",
					"contentId": "B19CUQ1xW",
					"contentIsRoot": false,
					"contentParentId": "SywTUQyeW"
				},
				{
					"styleWidth": "460px",
					"contentId": "rknAIQJxb",
					"contentIsRoot": false,
					"contentParentId": "ByxRIQ1x-",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "120px",
					"contentId": "HJWkqNEbW",
					"contentIsRoot": false,
					"contentParentId": "ByxRIQ1x-",
					"configId": "AUTHOR_BLOCK"
				},
				{
					"styleWidth": "460px",
					"contentId": "rJ71w7yeW",
					"contentIsRoot": false,
					"contentParentId": "BJW1v7JxZ",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "120px",
					"styleTextAlignment": "Center",
					"contentId": "r1CJ2V4bW",
					"contentIsRoot": false,
					"contentParentId": "BJW1v7JxZ",
					"configId": "AUTHOR_BLOCK"
				},
				{
					"styleWidth": "167px",
					"contentId": "ByTew71x-",
					"contentIsRoot": false,
					"contentParentId": "HJgxwQ1eW",
					"configId": "TEAM_MEMBER_ITEM"
				},
				{
					"styleWidth": "166px",
					"contentId": "Byybv7kxZ",
					"contentIsRoot": false,
					"contentParentId": "HJgxwQ1eW",
					"configId": "TEAM_MEMBER_ITEM"
				},
				{
					"styleWidth": "167px",
					"contentId": "HJZZDXkxZ",
					"contentIsRoot": false,
					"contentParentId": "HJgxwQ1eW",
					"configId": "TEAM_MEMBER_ITEM"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "rygagPXkeZ",
					"contentIsRoot": false,
					"contentParentId": "ByTew71x-"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HkWTgD7Jlb",
					"contentIsRoot": false,
					"contentParentId": "rygagPXkeZ"
				},
				{
					"styleWidth": "120px",
					"contentId": "S1fpxDQ1l-",
					"contentIsRoot": false,
					"contentParentId": "HkWTgD7Jlb",
					"contentContent": {
						"imageId": "A110R",
						"imageAlt": "Huw Evans",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/HuwEvans.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "ryX6gPmyeb",
					"contentIsRoot": false,
					"contentParentId": "rygagPXkeZ"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "r1N6xv7ylZ",
					"contentIsRoot": false,
					"contentParentId": "ryX6gPmyeb",
					"contentContent": "<p><strong>Huw Evans</strong> <br />Director General</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "ryxyWvmyeW",
					"contentIsRoot": false,
					"contentParentId": "Byybv7kxZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SybJWwXkx-",
					"contentIsRoot": false,
					"contentParentId": "ryxyWvmyeW"
				},
				{
					"styleWidth": "120px",
					"contentId": "rJGy-wQkl-",
					"contentIsRoot": false,
					"contentParentId": "SybJWwXkx-",
					"contentContent": {
						"imageId": "Z961W",
						"imageAlt": "James Dalton",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/james-dalton-picture.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BkQJZP7ygZ",
					"contentIsRoot": false,
					"contentParentId": "ryxyWvmyeW"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "rkEJ-Dmylb",
					"contentIsRoot": false,
					"contentParentId": "BkQJZP7ygZ",
					"contentContent": "<p><strong>James Dalton</strong> <br />Director, General Insurance Policy</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "SkeZWDm1lZ",
					"contentIsRoot": false,
					"contentParentId": "HJZZDXkxZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "Sk-WZDm1eZ",
					"contentIsRoot": false,
					"contentParentId": "SkeZWDm1lZ"
				},
				{
					"styleWidth": "120px",
					"styleHeight": "120px",
					"contentId": "HJz-WPQkeW",
					"contentIsRoot": false,
					"contentParentId": "Sk-WZDm1eZ",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/braun-yvonne-150x171.jpg"
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "r1QW-wQkgZ",
					"contentIsRoot": false,
					"contentParentId": "SkeZWDm1lZ"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "BJEbbDXkl-",
					"contentIsRoot": false,
					"contentParentId": "r1QW-wQkgZ",
					"contentContent": "<p><strong>Yvonne Braun</strong> <br />Director of Policy, Long Term Savings and Protection</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"styleTextColour": "#ffffff",
					"contentId": "B1SMwm1gZ",
					"contentIsRoot": false,
					"contentParentId": "SyDbv71lW",
					"contentContent": "<p>Copyright &copy; 2019 Association of British Insurers, All rights reserved.</p>\n<p>You received this email because you are a past recipient of ABI newsletters. Click <span style=\"color: #ffffff;\"><a style=\"color: #ffffff;\" href=\"https://www.abi.org.uk/privacy-policy/\">here</a> </span>to read our privacy notice.</p>\n<p><strong>Our mailing address is:</strong><br />Association of British Insurers, One America Square, 17 Crosswall, London, EC3N 2LB, United Kingdom</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"contentId": "SJCvPX1l-",
					"contentIsRoot": false,
					"contentParentId": "SycvwXyxb",
					"contentContent": "<p>Manage your ABI subscription preferences <a href=\"https://www.abi.org.uk/account/\">here</a>.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleTextAlignment": "right",
					"contentId": "S1WDiwlLG",
					"contentIsRoot": false,
					"contentParentId": "SycvwXyxb",
					"contentContent": "<p>Click <a href=\"${Gears.unsubscribe()}\">here</a> to unsubscribe from all ABI newsletters.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleWidth": "120px",
					"contentId": "HyxWJ5E4-b",
					"contentIsRoot": false,
					"contentParentId": "HJWkqNEbW",
					"configId": "TABLE_ITEM",
					"editorLocked": true
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "ByWZJqEVZ-",
					"contentIsRoot": false,
					"contentParentId": "HyxWJ5E4-b"
				},
				{
					"styleWidth": "120px",
					"contentId": "SJfZ1qE4b-",
					"contentIsRoot": false,
					"contentParentId": "ByWZJqEVZ-",
					"contentContent": {
						"imageId": "Z961W",
						"imageAlt": "James Dalton",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/james-dalton-picture.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BJQbyc44Wb",
					"contentIsRoot": false,
					"contentParentId": "HyxWJ5E4-b"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "H1E-J5V4W-",
					"contentIsRoot": false,
					"contentParentId": "BJQbyc44Wb",
					"contentContent": "<p style=\"text-align: center; margin: 0cm 0cm 7.5pt 0cm;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Arial',sans-serif; color: #505050;\">James Dalton</span></strong></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"styleWidth": "120px",
					"contentId": "Skl0y34EZW",
					"contentIsRoot": false,
					"contentParentId": "r1CJ2V4bW",
					"configId": "TABLE_ITEM",
					"editorLocked": true
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "rJb0J2E4Zb",
					"contentIsRoot": false,
					"contentParentId": "Skl0y34EZW"
				},
				{
					"styleWidth": "120px",
					"contentId": "HyGRJ344WZ",
					"contentIsRoot": false,
					"contentParentId": "rJb0J2E4Zb",
					"contentContent": {
						"imageId": "L778O",
						"imageAlt": "Alisa Dolgova",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlisaDOLGOVA.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "S1X0knNEb-",
					"contentIsRoot": false,
					"contentParentId": "Skl0y34EZW"
				},
				{
					"stylePadding": "5px 0",
					"contentId": "HJNA12N4Zb",
					"contentIsRoot": false,
					"contentParentId": "S1X0knNEb-",
					"contentContent": "<p style=\"text-align: center;\"><strong>Alisa Dolgova&nbsp;</strong></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"contentId": "SJ6rh44-Z",
					"contentIsRoot": false,
					"contentParentId": "SJIX2E4--",
					"contentContent": "<h2>Long term savings and protection</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"styleWidth": "460px",
					"contentId": "r1mU3ENZW",
					"contentIsRoot": false,
					"contentParentId": "HkgL24VWZ",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "120px",
					"contentId": "r1L82V4WZ",
					"contentIsRoot": false,
					"contentParentId": "HkgL24VWZ",
					"configId": "AUTHOR_BLOCK"
				},
				{
					"styleWidth": "120px",
					"contentId": "S1x8IhEE-b",
					"contentIsRoot": false,
					"contentParentId": "r1L82V4WZ",
					"configId": "TABLE_ITEM",
					"editorLocked": true
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SJZUIh4E-b",
					"contentIsRoot": false,
					"contentParentId": "S1x8IhEE-b"
				},
				{
					"styleWidth": "120px",
					"contentId": "H1zIU34EW-",
					"contentIsRoot": false,
					"contentParentId": "SJZUIh4E-b",
					"contentContent": {
						"imageId": "Z612B",
						"imageAlt": "Yvonne Braun",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/braun-yvonne-150x171.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "rym8Un4NW-",
					"contentIsRoot": false,
					"contentParentId": "S1x8IhEE-b"
				},
				{
					"stylePadding": "5px 0",
					"contentId": "SyVUUhVEW-",
					"contentIsRoot": false,
					"contentParentId": "rym8Un4NW-",
					"contentContent": "<p style=\"text-align: center;\"><strong>Yvonne Braun</strong></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"contentId": "BkRfaEEbZ",
					"contentIsRoot": false,
					"contentParentId": "HyjzTN4ZW",
					"contentContent": "<h2>Conduct regulation</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"styleWidth": "460px",
					"contentId": "ByfXTEVZW",
					"contentIsRoot": false,
					"contentParentId": "Byem6E4WZ",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "120px",
					"contentId": "H1HX6E4ZW",
					"contentIsRoot": false,
					"contentParentId": "Byem6E4WZ",
					"configId": "AUTHOR_BLOCK"
				},
				{
					"styleWidth": "120px",
					"contentId": "Sylr76NV--",
					"contentIsRoot": false,
					"contentParentId": "H1HX6E4ZW",
					"configId": "TABLE_ITEM",
					"editorLocked": true
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SJWBm6EEbW",
					"contentIsRoot": false,
					"contentParentId": "Sylr76NV--"
				},
				{
					"styleWidth": "120px",
					"contentId": "H1GrQTVE-Z",
					"contentIsRoot": false,
					"contentParentId": "SJWBm6EEbW",
					"contentContent": {
						"imageId": "P706H",
						"imageAlt": "James Bridge",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/JamesBRIDGE.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "B1mBmaN4ZW",
					"contentIsRoot": false,
					"contentParentId": "Sylr76NV--"
				},
				{
					"stylePadding": "5px 0",
					"contentId": "S14r7TNEZW",
					"contentIsRoot": false,
					"contentParentId": "B1mBmaN4ZW",
					"contentContent": "<p style=\"text-align: center; margin: 0cm 0cm 7.5pt 0cm;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Arial',sans-serif; color: #505050;\">James Bridge&nbsp;</span></strong></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"contentId": "Hk9UT4NW-",
					"contentIsRoot": false,
					"contentParentId": "r1SUp44bW",
					"contentContent": "<h2>Prudential regulation</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"styleWidth": "460px",
					"contentId": "rkyPaVVZb",
					"contentIsRoot": false,
					"contentParentId": "S1TLaNVW-",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "120px",
					"contentId": "BkWD6VVZZ",
					"contentIsRoot": false,
					"contentParentId": "S1TLaNVW-",
					"configId": "AUTHOR_BLOCK"
				},
				{
					"styleWidth": "120px",
					"contentId": "SyxWDpENZW",
					"contentIsRoot": false,
					"contentParentId": "BkWD6VVZZ",
					"configId": "TABLE_ITEM",
					"editorLocked": true
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "S1WWvaNVZZ",
					"contentIsRoot": false,
					"contentParentId": "SyxWDpENZW"
				},
				{
					"styleWidth": "120px",
					"contentId": "BJz-w6NVZb",
					"contentIsRoot": false,
					"contentParentId": "S1WWvaNVZZ",
					"contentContent": {
						"imageId": "H347G",
						"imageAlt": "Steven Findlay",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/StevenFINDLAY.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BJ7ZD6EV--",
					"contentIsRoot": false,
					"contentParentId": "SyxWDpENZW"
				},
				{
					"stylePadding": "5px 0",
					"contentId": "rk4Ww6NNZW",
					"contentIsRoot": false,
					"contentParentId": "BJ7ZD6EV--",
					"contentContent": "<p style=\"text-align: center; margin: 0cm 0cm 7.5pt 0cm;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Arial',sans-serif; color: #505050;\">Steven Findlay&nbsp;</span></strong></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"contentId": "rkMoaVNZZ",
					"contentIsRoot": false,
					"contentParentId": "r11saEV-Z",
					"contentContent": "<h2>Taxation</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"styleWidth": "460px",
					"contentId": "SJl2a4E-W",
					"contentIsRoot": false,
					"contentParentId": "rySi64EWW",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "120px",
					"contentId": "BkX3TVEbb",
					"contentIsRoot": false,
					"contentParentId": "rySi64EWW",
					"configId": "AUTHOR_BLOCK"
				},
				{
					"styleWidth": "120px",
					"contentId": "r1eQ2aVEW-",
					"contentIsRoot": false,
					"contentParentId": "BkX3TVEbb",
					"configId": "TABLE_ITEM",
					"editorLocked": true
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "rJWmnT4EW-",
					"contentIsRoot": false,
					"contentParentId": "r1eQ2aVEW-"
				},
				{
					"styleWidth": "120px",
					"contentId": "BJfQnpVEZb",
					"contentIsRoot": false,
					"contentParentId": "rJWmnT4EW-",
					"contentContent": {
						"imageId": "I91C",
						"imageAlt": "Stephen Pautard",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/StephenPAUTARD.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HkQmhp4E-b",
					"contentIsRoot": false,
					"contentParentId": "r1eQ2aVEW-"
				},
				{
					"stylePadding": "5px 0",
					"contentId": "BkNQ3p44b-",
					"contentIsRoot": false,
					"contentParentId": "HkQmhp4E-b",
					"contentContent": "<p style=\"text-align: center; margin: 0cm 0cm 7.5pt 0cm;\" align=\"center\"><strong><span style=\"font-size: 10.5pt; font-family: 'Arial',sans-serif; color: #505050;\">Stephen Pautard&nbsp;</span></strong></p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"contentId": "rku_krEZZ",
					"contentIsRoot": false,
					"contentParentId": "Sk8dyHNbZ",
					"contentContent": "<h2>Scotland, Wales and Northern Ireland</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"styleWidth": "460px",
					"contentId": "rka_1BVZ-",
					"contentIsRoot": false,
					"contentParentId": "H15ukSV-W",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "120px",
					"contentId": "r102yHN-Z",
					"contentIsRoot": false,
					"contentParentId": "H15ukSV-W",
					"configId": "AUTHOR_BLOCK"
				},
				{
					"styleWidth": "120px",
					"contentId": "H1gCnyBNZ-",
					"contentIsRoot": false,
					"contentParentId": "r102yHN-Z",
					"configId": "TABLE_ITEM",
					"editorLocked": true
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "S1WRh1BNZb",
					"contentIsRoot": false,
					"contentParentId": "H1gCnyBNZ-"
				},
				{
					"styleWidth": "120px",
					"contentId": "HyMAnyBNZb",
					"contentIsRoot": false,
					"contentParentId": "S1WRh1BNZb",
					"contentContent": {
						"imageId": "Z11R",
						"imageAlt": "Alastair Ross",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlistairROSS.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "BJ7R31H4Zb",
					"contentIsRoot": false,
					"contentParentId": "H1gCnyBNZ-"
				},
				{
					"stylePadding": "5px 0",
					"contentId": "HkVA21HVWW",
					"contentIsRoot": false,
					"contentParentId": "BJ7R31H4Zb",
					"contentContent": "<p style=\"text-align: center;\"><strong>Alastair Ross</strong>&nbsp;</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"contentId": "SkLler4b-",
					"contentIsRoot": false,
					"contentParentId": "BkelgSV-W",
					"contentContent": "<h2>Diversity and Inclusion</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"configId": "RICH_TEXT",
					"contentId": "S1helSVZ-",
					"contentIsRoot": false,
					"contentParentId": "HyFgxS4bZ"
				},
				{
					"contentId": "rJ0ZgB4Wb",
					"contentIsRoot": false,
					"contentParentId": "ry9-gB4Zb",
					"contentContent": "<h2>Meet the team</h2>",
					"configId": "SECTION_HEADER"
				},
				{
					"styleWidth": "167px",
					"contentId": "rkpfeSEZZ",
					"contentIsRoot": false,
					"contentParentId": "r1FMgr4-Z",
					"configId": "TEAM_MEMBER_ITEM"
				},
				{
					"styleWidth": "166px",
					"contentId": "ryxmgr4WW",
					"contentIsRoot": false,
					"contentParentId": "r1FMgr4-Z",
					"configId": "TEAM_MEMBER_ITEM"
				},
				{
					"styleWidth": "167px",
					"contentId": "r1MQgrNZZ",
					"contentIsRoot": false,
					"contentParentId": "r1FMgr4-Z",
					"configId": "TEAM_MEMBER_ITEM"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "r1lazgSNZb",
					"contentIsRoot": false,
					"contentParentId": "rkpfeSEZZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "ryWpfxH4ZZ",
					"contentIsRoot": false,
					"contentParentId": "r1lazgSNZb"
				},
				{
					"styleWidth": "120px",
					"contentId": "BJGTfxBEZZ",
					"contentIsRoot": false,
					"contentParentId": "ryWpfxH4ZZ",
					"contentContent": {
						"imageId": "L778O",
						"imageAlt": "Alisa Dolgova",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlisaDOLGOVA.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "Hymafgr4Z-",
					"contentIsRoot": false,
					"contentParentId": "r1lazgSNZb"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "HJE6zxrVWb",
					"contentIsRoot": false,
					"contentParentId": "Hymafgr4Z-",
					"contentContent": "<p><strong>Alisa Dolgova</strong> <br />Interim Assistant Director, Head of European &amp; International Affairs</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "S1gxQxrNbZ",
					"contentIsRoot": false,
					"contentParentId": "ryxmgr4WW"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "B1bgQeSN-W",
					"contentIsRoot": false,
					"contentParentId": "S1gxQxrNbZ"
				},
				{
					"styleWidth": "120px",
					"contentId": "BkzlXeSEZ-",
					"contentIsRoot": false,
					"contentParentId": "B1bgQeSN-W",
					"contentContent": {
						"imageId": "Z11R",
						"imageAlt": "Alastair Ross",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/AlistairROSS.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "rJXe7xr4-W",
					"contentIsRoot": false,
					"contentParentId": "S1gxQxrNbZ"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "HJNx7xHVWW",
					"contentIsRoot": false,
					"contentParentId": "rJXe7xr4-W",
					"contentContent": "<p><strong>Alastair Ross</strong> <br />Assistant Director, Head of Public Policy (Scotland, Wales &amp; NI)</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "SyxMQeSVWZ",
					"contentIsRoot": false,
					"contentParentId": "r1MQgrNZZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HJ-fQgBEbW",
					"contentIsRoot": false,
					"contentParentId": "SyxMQeSVWZ"
				},
				{
					"styleWidth": "120px",
					"contentId": "B1ff7xBEZ-",
					"contentIsRoot": false,
					"contentParentId": "HJ-fQgBEbW",
					"contentContent": {
						"imageId": "F265Z",
						"imageAlt": "Julie Geraud",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/JulieGeraud.JPG",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "H1QzXlBNWW",
					"contentIsRoot": false,
					"contentParentId": "SyxMQeSVWZ"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "BJNGmxBVZ-",
					"contentIsRoot": false,
					"contentParentId": "H1QzXlBNWW",
					"contentContent": "<p><strong>Julie Geraud</strong> <br />Assistant Director, Head of Member Relations, Partnerships and Events</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"styleWidth": "167px",
					"contentId": "rkRmerVZb",
					"contentIsRoot": false,
					"contentParentId": "rk5QeBN-Z",
					"configId": "TEAM_MEMBER_ITEM"
				},
				{
					"styleWidth": "166px",
					"contentId": "r1xEerVbZ",
					"contentIsRoot": false,
					"contentParentId": "rk5QeBN-Z",
					"configId": "TEAM_MEMBER_ITEM"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "HyeAXeB4WW",
					"contentIsRoot": false,
					"contentParentId": "rkRmerVZb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "H1-CmeHV-W",
					"contentIsRoot": false,
					"contentParentId": "HyeAXeB4WW"
				},
				{
					"styleWidth": "120px",
					"contentId": "S1MC7eSEWZ",
					"contentIsRoot": false,
					"contentParentId": "H1-CmeHV-W",
					"contentContent": {
						"imageId": "P706H",
						"imageAlt": "James Bridge",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/JamesBRIDGE.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HkQCmlHVZZ",
					"contentIsRoot": false,
					"contentParentId": "HyeAXeB4WW"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "ry4AQeBVZb",
					"contentIsRoot": false,
					"contentParentId": "HkQCmlHVZZ",
					"contentContent": "<p><strong>James Bridge</strong> <br />Assistant Director, Head of Conduct Regulation</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "B1elVgSEWZ",
					"contentIsRoot": false,
					"contentParentId": "r1xEerVbZ"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "By-lNxrEW-",
					"contentIsRoot": false,
					"contentParentId": "B1elVgSEWZ"
				},
				{
					"styleWidth": "120px",
					"contentId": "r1GgVxSVZZ",
					"contentIsRoot": false,
					"contentParentId": "By-lNxrEW-",
					"contentContent": {
						"imageId": "H347G",
						"imageAlt": "Steven Findlay",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/StevenFINDLAY.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SJQeNlHE-b",
					"contentIsRoot": false,
					"contentParentId": "B1elVgSEWZ"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "SyVlNlHNWb",
					"contentIsRoot": false,
					"contentParentId": "SJQeNlHE-b",
					"contentContent": "<p><strong>Steven Findlay</strong> <br />Assistant Director, Head of Prudential Regulation</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"styleWidth": "167px",
					"contentId": "ryGNgHEWb",
					"contentIsRoot": false,
					"contentParentId": "rk5QeBN-Z",
					"configId": "TEAM_MEMBER_ITEM"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "BJgMNgBEWW",
					"contentIsRoot": false,
					"contentParentId": "ryGNgHEWb"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "H1WM4lBVW-",
					"contentIsRoot": false,
					"contentParentId": "BJgMNgBEWW"
				},
				{
					"styleWidth": "120px",
					"contentId": "rJzf4gHNZW",
					"contentIsRoot": false,
					"contentParentId": "H1WM4lBVW-",
					"contentContent": {
						"imageId": "I91C",
						"imageAlt": "Stephen Pautard",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/sender-photos/fullsize/StephenPAUTARD.jpg",
						"imageCategory": "people",
						"imageAdded": "2017-05-03T13:29:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HyQM4lrVZb",
					"contentIsRoot": false,
					"contentParentId": "BJgMNgBEWW"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "HJNz4eH4-W",
					"contentIsRoot": false,
					"contentParentId": "HyQM4lrVZb",
					"contentContent": "<p><strong>Stephen Pautard</strong> Assistant Director, Head of Taxation</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				}
			],
			"builtIn": true
		},
		{
			"templateId": "eventskeynote",
			"templateName": "Events - Keynote Speakers",
			"templateCategory": "",
			"templateContent": [
				{
					"configId": "ROOT_ITEM",
					"contentId": "By8akQ1g-",
					"contentIsRoot": true,
					"contentParentId": null
				},
				{
					"configId": "SECTION",
					"contentId": "S1mAJX1eW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"styleBackgroundColour": "#230052",
					"contentId": "S1qUlXylb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"contentId": "HkpPHQkgb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"configId": "SECTION",
					"contentId": "rkzNCpEVf",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "BkcY1ANNG",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "Bk8aMxS4G",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "rkpeGxHNz",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "BypOd3TrM",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"configId": "SECTION",
					"contentId": "Bkmwf41xb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"styleBackgroundColour": "#230052",
					"contentId": "SyDbv71lW",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-",
					"configId": "SECTION"
				},
				{
					"configId": "SECTION",
					"contentId": "SycvwXyxb",
					"contentIsRoot": false,
					"contentParentId": "By8akQ1g-"
				},
				{
					"contentId": "Hk_Ck7Jg-",
					"contentIsRoot": false,
					"contentParentId": "S1mAJX1eW",
					"contentContent": "<p>Book your place today</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleTextAlignment": "right",
					"contentId": "Skn01X1eW",
					"contentIsRoot": false,
					"contentParentId": "S1mAJX1eW",
					"contentContent": "<p>Click <a href=\"${Gears.microsite()}\" target=\"_blank\" rel=\"noopener noreferrer\">here</a> if you are having trouble viewing this message.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleWidth": "405px",
					"stylePadding": "20px",
					"contentId": "HknIgmygW",
					"contentIsRoot": false,
					"contentParentId": "S1qUlXylb",
					"configId": "COLUMN"
				},
				{
					"styleWidth": "215px",
					"contentId": "B1TLlQJgb",
					"contentIsRoot": false,
					"contentParentId": "S1qUlXylb",
					"configId": "COLUMN"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rkehlQJeb",
					"contentIsRoot": false,
					"contentParentId": "B1TLlQJgb"
				},
				{
					"contentId": "SJf3gm1lZ",
					"contentIsRoot": false,
					"contentParentId": "rkehlQJeb",
					"contentContent": {
						"imageId": "M671R",
						"imageAlt": "Main Banner",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/banners/abi_banner3735_e-newsletters_v4a.png",
						"imageCategory": "banners",
						"imageAdded": "2017-05-02T19:33:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rJbXEQ1e-",
					"contentIsRoot": false,
					"contentParentId": "HknIgmygW"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "r14QN7Jgb",
					"contentIsRoot": false,
					"contentParentId": "HknIgmygW"
				},
				{
					"styleWidth": "130px",
					"styleTextAlignment": "left",
					"contentId": "HkQBV7ke-",
					"contentIsRoot": false,
					"contentParentId": "rJbXEQ1e-",
					"contentContent": {
						"imageId": "O351V",
						"imageAlt": "ABI Logo Light",
						"imageUrl": "https://www.abi.org.uk/globalassets/images/brand-images/abi_neg_large.png",
						"imageCategory": "logos",
						"imageAdded": "2017-05-02T19:33:00",
						"builtIn": true
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"stylePadding": "10px 0 0",
					"styleTextColour": "#ffffff",
					"contentId": "SywO4XJxb",
					"contentIsRoot": false,
					"contentParentId": "r14QN7Jgb",
					"contentContent": "<h1>Annual Conference 2018</h1>",
					"configId": "RICH_TEXT",
					"configEditorRoot": "h1"
				},
				{
					"styleTextAlignment": "center",
					"contentId": "HJ-_rXJgb",
					"contentIsRoot": false,
					"contentParentId": "HkpPHQkgb",
					"contentContent": "<h2>Keynote speakers&nbsp;</h2>",
					"configId": "RICH_TEXT",
					"configEditorRoot": "h2"
				},
				{
					"styleTextColour": "#ffffff",
					"contentId": "B1SMwm1gZ",
					"contentIsRoot": false,
					"contentParentId": "SyDbv71lW",
					"contentContent": "<p>Copyright &copy;2019 Association of British Insurers, All rights reserved.</p>\n<p>You received this email because you are a past recipient of ABI newsletters. Click <span style=\"color: #ffffff;\"><a style=\"color: #ffffff;\" href=\"https://www.abi.org.uk/privacy-policy/\">here</a> </span>to read our privacy notice.</p>\n<p><strong>Our mailing address is:</strong><br />Association of British Insurers, One America Square, 17 Crosswall, London, EC3N 2LB, United Kingdom</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"contentId": "SJCvPX1l-",
					"contentIsRoot": false,
					"contentParentId": "SycvwXyxb",
					"contentContent": "<p>Manage your ABI subscription preferences <a href=\"https://www.abi.org.uk/account/\">here</a>.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleTextAlignment": "right",
					"contentId": "S1WDiwlLG",
					"contentIsRoot": false,
					"contentParentId": "SycvwXyxb",
					"contentContent": "<p>Click <a href=\"${Gears.unsubscribe()}\">here</a> to unsubscribe from all ABI newsletters.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"contentId": "BycvG4Jl-",
					"contentIsRoot": false,
					"contentParentId": "Bkmwf41xb",
					"contentContent": "<p><strong>4 July 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/abi-long-term-savings-conference-2017-engaging-customers-for-tomorrows-retirement/\" target=\"_blank\" rel=\"noopener noreferrer\">Long-Term Savings Conference 2017: Engaging customers for tomorrow's retirement</a></p>\n<p><strong>12 September 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/ensuring-good-customer-outcomes-in-the-digital-world/\" target=\"_blank\" rel=\"noopener noreferrer\">Ensuring good customer outcomes in the digital world</a></p>\n<p><strong>2 &amp; 3 October 2017 &ndash; Brighton</strong> <br /><a href=\"https://www.abi.org.uk/events/abi-insurance-tax-convention-2017/\" target=\"_blank\" rel=\"noopener noreferrer\">ABI Insurance Tax Convention 2017</a></p>\n<p><strong>19 October 2017 - London</strong> <br /><a href=\"https://www.abi.org.uk/events/insurance-in-the-digital-world-cyber-data-and-technology--from-hype-to-reality/\" target=\"_blank\" rel=\"noopener noreferrer\">Insurance in the digital world: cyber, data and technology &ndash; from hype to reality</a></p>",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "CELL_ITEM",
					"contentId": "S1RVRa4VM",
					"contentIsRoot": false,
					"contentParentId": "rkzNCpEVf"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "HJWBA6ENM",
					"contentIsRoot": false,
					"contentParentId": "S1RVRa4VM"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "ByXr0aE4M",
					"contentIsRoot": false,
					"contentParentId": "HJWBA6ENM"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "ryhSR6E4G",
					"contentIsRoot": false,
					"contentParentId": "ByXr0aE4M"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "BkRSRaNEM",
					"contentIsRoot": false,
					"contentParentId": "ByXr0aE4M"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "Bkl3BCp4Nz",
					"contentIsRoot": false,
					"contentParentId": "ryhSR6E4G"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HJZnBAa44M",
					"contentIsRoot": false,
					"contentParentId": "Bkl3BCp4Nz"
				},
				{
					"styleWidth": "130px",
					"contentId": "ByGnSA6NVz",
					"contentIsRoot": false,
					"contentParentId": "HJZnBAa44M",
					"contentContent": {
						"imageUrl": "",
						"imageAlt": ""
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "r1mnrR6VVz",
					"contentIsRoot": false,
					"contentParentId": "Bkl3BCp4Nz"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "r142SC6VNG",
					"contentIsRoot": false,
					"contentParentId": "r1mnrR6VVz",
					"contentContent": "<p><strong>Rt Hon Nicola Sturgeon MSP</strong><br />First Minister of Scotland</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "Syx0H0TV4f",
					"contentIsRoot": false,
					"contentParentId": "BkRSRaNEM"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "ByWArRTENf",
					"contentIsRoot": false,
					"contentParentId": "Syx0H0TV4f"
				},
				{
					"styleWidth": "150px",
					"contentId": "SyGRSCa4Nz",
					"contentIsRoot": false,
					"contentParentId": "ByWArRTENf",
					"contentContent": {
						"imageUrl": "",
						"imageAlt": ""
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HymRB0p4EM",
					"contentIsRoot": false,
					"contentParentId": "Syx0H0TV4f"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "BJ40r0a4Ez",
					"contentIsRoot": false,
					"contentParentId": "HymRB0p4EM",
					"contentContent": "<p><strong>Sam Woods</strong><br />Chief Executive Officer of the Prudential Regulation Authority</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "CELL_ITEM",
					"contentId": "SJ2FJ0VVM",
					"contentIsRoot": false,
					"contentParentId": "BkcY1ANNG"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "HJ1cJ0EEf",
					"contentIsRoot": false,
					"contentParentId": "SJ2FJ0VVM"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "S1xcJRNEM",
					"contentIsRoot": false,
					"contentParentId": "HJ1cJ0EEf"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "r1z9y04VM",
					"contentIsRoot": false,
					"contentParentId": "S1xcJRNEM"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "Skm9yCENM",
					"contentIsRoot": false,
					"contentParentId": "S1xcJRNEM"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "HJgfqk0VNG",
					"contentIsRoot": false,
					"contentParentId": "r1z9y04VM"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "rkWz9yAVNf",
					"contentIsRoot": false,
					"contentParentId": "HJgfqk0VNG"
				},
				{
					"styleWidth": "120px",
					"contentId": "SkGM5104VG",
					"contentIsRoot": false,
					"contentParentId": "rkWz9yAVNf",
					"contentContent": {
						"imageUrl": "",
						"imageAlt": ""
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "B17G5yA4EG",
					"contentIsRoot": false,
					"contentParentId": "HJgfqk0VNG"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "Hy4Gqy0VNf",
					"contentIsRoot": false,
					"contentParentId": "B17G5yA4EG",
					"contentContent": "<p><strong>Andy Briggs</strong><br />Chief Executive Officer, UK Insurance, Aviva plc and Chair of the ABI</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "rkxmq10ENf",
					"contentIsRoot": false,
					"contentParentId": "Skm9yCENM"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "Hy-Q9J0NVM",
					"contentIsRoot": false,
					"contentParentId": "rkxmq10ENf"
				},
				{
					"styleWidth": "120px",
					"contentId": "H1zQqyAVVM",
					"contentIsRoot": false,
					"contentParentId": "Hy-Q9J0NVM",
					"contentContent": {
						"imageUrl": "",
						"imageAlt": ""
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "HJmXq1C4Vf",
					"contentIsRoot": false,
					"contentParentId": "rkxmq10ENf"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "BkE7qyC4EM",
					"contentIsRoot": false,
					"contentParentId": "HJmXq1C4Vf",
					"contentContent": "<p><strong>Andrew Neil</strong><br />Publisher and Broadcaster</p>",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "CELL_ITEM",
					"contentId": "H1xWzxrNM",
					"contentIsRoot": false,
					"contentParentId": "rkpeGxHNz"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "rk7ZGxB4G",
					"contentIsRoot": false,
					"contentParentId": "H1xWzxrNM"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "H1NZMlHVz",
					"contentIsRoot": false,
					"contentParentId": "rk7ZGxB4G"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "rk9WGlrEG",
					"contentIsRoot": false,
					"contentParentId": "H1NZMlHVz"
				},
				{
					"configId": "TEAM_MEMBER_ITEM",
					"contentId": "SJ2WMlH4f",
					"contentIsRoot": false,
					"contentParentId": "H1NZMlHVz"
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "BkxcZflHEz",
					"contentIsRoot": false,
					"contentParentId": "rk9WGlrEG"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SJZ5bMgHEG",
					"contentIsRoot": false,
					"contentParentId": "BkxcZflHEz"
				},
				{
					"styleWidth": "190",
					"contentId": "rkM5WfeBVz",
					"contentIsRoot": false,
					"contentParentId": "SJZ5bMgHEG",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/events/html-buttons/click-here-to-register.png",
						"imageAlt": "Click here to register",
						"imageLink": "https://www.abi.org.uk/events/annual-conference-2018/"
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "Hy75-MeHNG",
					"contentIsRoot": false,
					"contentParentId": "BkxcZflHEz"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "S1VcZMeBVG",
					"contentIsRoot": false,
					"contentParentId": "Hy75-MeHNG",
					"contentContent": "",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "TABLE_ITEM",
					"editorLocked": true,
					"styleWidth": "160px",
					"contentId": "H1g2bGgr4f",
					"contentIsRoot": false,
					"contentParentId": "SJ2WMlH4f"
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "rk-3-GlSVG",
					"contentIsRoot": false,
					"contentParentId": "H1g2bGgr4f"
				},
				{
					"styleWidth": "200px",
					"contentId": "Bkf3bfgr4z",
					"contentIsRoot": false,
					"contentParentId": "rk-3-GlSVG",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/events/2017/sponsorspartners/kpmg-new-logo.jpg",
						"imageAlt": "KPMG Logo",
						"imageLink": "https://home.kpmg.com/uk/en/home.html"
					},
					"configId": "IMAGE_ITEM",
					"editorDraggable": false
				},
				{
					"configId": "ROW_ITEM",
					"editorLocked": true,
					"contentId": "SyX2-MlrVz",
					"contentIsRoot": false,
					"contentParentId": "H1g2bGgr4f"
				},
				{
					"stylePadding": "5px 0",
					"styleTextAlignment": "center",
					"contentId": "BkV2bzgBEf",
					"contentIsRoot": false,
					"contentParentId": "SyX2-MlrVz",
					"contentContent": "",
					"configId": "RICH_TEXT",
					"editorDraggable": false
				},
				{
					"configId": "CELL_ITEM",
					"contentId": "SJ3aMxHVM",
					"contentIsRoot": false,
					"contentParentId": "Bk8aMxS4G"
				},
				{
					"configId": "COLUMN",
					"contentId": "HJCaMgHNG",
					"contentIsRoot": false,
					"contentParentId": "Bk8aMxS4G"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "By-0fgHEz",
					"contentIsRoot": false,
					"contentParentId": "HJCaMgHNG"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "rJV0zxS4f",
					"contentIsRoot": false,
					"contentParentId": "SJ3aMxHVM"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "ByUAGxBVz",
					"contentIsRoot": false,
					"contentParentId": "rJV0zxS4f"
				},
				{
					"contentId": "Sy0ZtQylb",
					"contentIsRoot": false,
					"contentParentId": "ByUAGxBVz",
					"contentContent": "<p>The ABI Annual Conference 2018 will be the standout insurance event of the year, bringing industry leaders, politicians and regulators together to debate the major issues affecting the insurance and long term savings industry.&nbsp;</p>\n<p>After our sell-out Brexit conference in 2017, don&rsquo;t miss this chance to find out what&rsquo;s next for the insurance industry in 2018 and how it maintains its place as a UK world leader.</p>",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "250",
					"contentId": "ByKNX0VVz",
					"contentIsRoot": false,
					"contentParentId": "By-0fgHEz",
					"contentContent": "<p style=\"text-align: center;\">&nbsp;<strong>Date<br /></strong>27 February 2018</p>\n<p style=\"text-align: center;\"><strong>Timings<br /></strong>08:45&nbsp;(registration from 08:15) - 17:20&nbsp;followed by networking drinks</p>\n<p style=\"text-align: center;\"><strong>Venue<br /></strong>etc Venues, 155 Bishopsgate, London EC2M 3YD</p>",
					"configId": "RICH_TEXT"
				},
				{
					"contentId": "ry_KOnTrz",
					"contentIsRoot": false,
					"contentParentId": "BypOd3TrM",
					"contentContent": "<h2>Dates for your diary</h2>",
					"configId": "SECTION_HEADER"
				}
			],
			"builtIn": true
		},
		{
			"templateId": "plainoutlook",
			"templateName": "Outlook Email",
			"templateCategory": "",
			"templateContent": [
				{
					"contentId": "SyEoshpHG",
					"contentIsRoot": true,
					"contentParentId": null,
					"configId": "ROOT_ITEM",
					"viewCss": {
						" ": {
							"Margin": "0",
							"border-spacing": "0",
							"font-family": "arial, sans-serif",
							"font-size": "14px",
							"line-height": "18px",
							"color": "#231f20",
							"background-color": "#ffffff",
							"width": "100%",
							"height": "100%",
							"border-width": 0
						},
						"table, tr, td": {
							"font-family": "arial, sans-serif",
							"font-size": "14px",
							"line-height": "18px",
							"color": "#231f20"
						},
						"table": {
							"border-spacing": 0,
							"border-collapse": "collapse",
							"width": "100%"
						},
						"td": {
							"padding-top": 0,
							"padding-right": 0,
							"padding-bottom": 0,
							"padding-left": 0
						},
						"tr": {},
						"a[href]": {
							"color": "#7f58a5",
							"text-decoration": "underline"
						},
						"h1, h2, h3, h4, h5, h6, p, ul, ol, li, hr": {
							"Margin-top": 0,
							"Margin-right": 0,
							"Margin-bottom": "5px",
							"Margin-left": 0
						},
						"h1, h2, h3, h4, h5, h6": {
							"font-weight": "normal",
							"font-size": "18px",
							"line-height": "24px"
						},
						"h1": {
							"font-size": "26px",
							"line-height": "36px"
						},
						"h2": {
							"font-size": "24px"
						},
						"p, ul, ol": {
							"Margin-bottom": "10px"
						},
						"p:last-of-type": {
							"Margin-bottom": 0
						},
						"hr": {
							"color": "#000000"
						},
						"img": {
							"display": "block",
							"margin-top": 0,
							"margin-right": 0,
							"margin-bottom": 0,
							"margin-left": 0,
							"padding-top": 0,
							"padding-right": 0,
							"padding-bottom": 0,
							"padding-left": 0
						},
						"ul": {
							"list-style-type": "disc"
						},
						"ul > li > ul": {
							"list-style-type": "circle"
						},
						"ul > li > ul > li > ul": {
							"list-style-type": "square"
						},
						"ol": {
							"list-style-type": "disc"
						},
						"ol > li > ol": {
							"list-style-type": "circle"
						},
						"ol > li > ol > li > ol": {
							"list-style-type": "square"
						},
						"li": {
							"margin-left": "25px"
						},
						"li > ul, li > ol": {
							"margin-bottom": "5px"
						},
						"p a": {
							"Margin": "inherit",
							"Margin-left": 0,
							"Margin-right": 0
						},
						"strong, b": {
							"font-weight": "bold"
						},
						"em, i": {
							"font-style": "italic"
						},
						"u": {
							"text-decoration": "underline"
						},
						"s": {
							"text-decoration": "line-through"
						},
						"sup, sub": {
							"font-size": "0.8em"
						},
						"sup": {
							"vertical-align": "super"
						},
						"sub": {
							"vertical-align": "sub"
						},
						".full-width": {
							"width": "100%"
						},
						".small": {
							"font-size": "10px",
							"line-height": "11px"
						},
						".editable": {
							"text-align": "left",
							"padding-top": "10px",
							"padding-right": "20px",
							"padding-bottom": "10px",
							"padding-left": "20px"
						},
						".editable *": {
							"padding-top": 0,
							"padding-right": 0,
							"padding-bottom": 0,
							"padding-left": 0
						},
						".section-content-container": {
							"width": "100%",
							"background-color": "#ffffff"
						},
						".main-row:last-of-type": {
							"height": "100%"
						}
					},
					"templateSettings": {
						"backgroundColor": "#ffffff"
					}
				},
				{
					"configId": "SECTION",
					"contentId": "H1CslTaHG",
					"contentIsRoot": false,
					"contentParentId": "SyEoshpHG"
				},
				{
					"configId": "SECTION",
					"contentId": "BJQjd06SM",
					"contentIsRoot": false,
					"contentParentId": "SyEoshpHG"
				},
				{
					"configId": "SECTION",
					"contentId": "rk70uATBz",
					"contentIsRoot": false,
					"contentParentId": "SyEoshpHG"
				},
				{
					"contentId": "r1o2Wy0Bz",
					"contentIsRoot": false,
					"contentParentId": "SyEoshpHG",
					"configId": "SECTION",
					"viewAttributes": {
						"height": "100"
					}
				},
				{
					"configId": "SECTION",
					"contentId": "ry939HkLM",
					"contentIsRoot": false,
					"contentParentId": "SyEoshpHG"
				},
				{
					"stylePadding": "5px",
					"contentId": "SJs9FTarz",
					"contentIsRoot": false,
					"contentParentId": "H1CslTaHG",
					"contentContent": "<p>Dear ${Recipient.contact.firstname},</p>\n<p>Here's an email about stuff we thought was important. Read it.</p>\n<p>Many thanks,</p>\n<p>Sender</p>",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "400px",
					"stylePadding": "5px",
					"styleTextColour": "#2c104b",
					"contentId": "HkYsdR6Bz",
					"contentIsRoot": false,
					"contentParentId": "BJQjd06SM",
					"contentContent": "<p><strong>Sender Name</strong><br />Job Title<br />Association of British Insurers</p>",
					"configId": "RICH_TEXT",
					"viewCss": {
						"p": {
							"font-size": "11px",
							"line-height": "13px"
						}
					}
				},
				{
					"styleWidth": "100%",
					"stylePadding": "5px",
					"contentId": "rkLX1m1LM",
					"contentIsRoot": false,
					"contentParentId": "BJQjd06SM",
					"contentContent": "<p>&nbsp; &nbsp;&nbsp;</p>",
					"configId": "RICH_TEXT"
				},
				{
					"styleWidth": "90px",
					"stylePadding": "5px",
					"styleTextColour": "#2c104b",
					"contentId": "Bk5CuCpSf",
					"contentIsRoot": false,
					"contentParentId": "rk70uATBz",
					"contentContent": "<p><strong>Direct Dial:<br />Mobile:<br />Email:</strong></p>",
					"configId": "RICH_TEXT",
					"viewCss": {
						"p": {
							"font-size": "11px",
							"line-height": "13px"
						}
					}
				},
				{
					"stylePadding": "5px",
					"styleTextColour": "#2c104b",
					"contentId": "Hkl9YRTrG",
					"contentIsRoot": false,
					"contentParentId": "rk70uATBz",
					"contentContent": "<p><a href=\"tel:+44(0)2072167###\">+44 (0)207 216 7###&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;[THESE ARE LINKS. MAKE SURE YOU UPDATE THEM]</a><br /><a href=\"tel:+44(0)7777777777\">+44 (0)777 777 7777</a><br /><a href=\"mailto:firstname.lastname@abi.org.uk\" target=\"_blank\" rel=\"noopener\">firstname.lastname@abi.org.uk</a></p>",
					"configId": "RICH_TEXT",
					"viewCss": {
						"p": {
							"font-size": "11px",
							"line-height": "13px"
						},
						"p a[href]": {
							"text-decoration": "none"
						}
					}
				},
				{
					"styleWidth": "120px",
					"stylePadding": "5px",
					"contentId": "H1aa-1CrG",
					"contentIsRoot": false,
					"contentParentId": "r1o2Wy0Bz",
					"configId": "CELL_ITEM",
					"viewAttributes": {
						"valign": "middle",
						"align": "center"
					}
				},
				{
					"styleWidth": "15px",
					"stylePadding": "0 5px",
					"contentId": "H1h0by0HG",
					"contentIsRoot": false,
					"contentParentId": "r1o2Wy0Bz",
					"configId": "CELL_ITEM"
				},
				{
					"styleWidth": "200px",
					"stylePadding": "0 5px",
					"styleTextColour": "#2c104b",
					"contentId": "r1tGi0arG",
					"contentIsRoot": false,
					"contentParentId": "r1o2Wy0Bz",
					"contentContent": "<p>Association of British Insurers <br />​One America Square, 17 Crosswall, <br />​London EC3N 2LB <br />​T: 020 7600 3333 | abi.org.uk</p>",
					"configId": "RICH_TEXT",
					"viewCss": {
						"p": {
							"font-size": "11px",
							"line-height": "13px"
						}
					}
				},
				{
					"styleWidth": "15px",
					"stylePadding": "0 5px",
					"contentId": "Byy1z1AHz",
					"contentIsRoot": false,
					"contentParentId": "r1o2Wy0Bz",
					"configId": "CELL_ITEM"
				},
				{
					"styleWidth": "30px",
					"stylePadding": "0 10px 0 5px",
					"contentId": "H1-1GkCBz",
					"contentIsRoot": false,
					"contentParentId": "r1o2Wy0Bz",
					"configId": "CELL_ITEM",
					"viewAttributes": {
						"valign": "middle",
						"align": "center"
					}
				},
				{
					"styleWidth": "100%",
					"stylePadding": "5px",
					"contentId": "BJ8um1AHM",
					"contentIsRoot": false,
					"contentParentId": "r1o2Wy0Bz",
					"contentContent": "",
					"configId": "RICH_TEXT"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "BypyfJCSG",
					"contentIsRoot": false,
					"contentParentId": "H1aa-1CrG"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "Sk1gfyRSz",
					"contentIsRoot": false,
					"contentParentId": "BypyfJCSG"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "BkfgGkRSG",
					"contentIsRoot": false,
					"contentParentId": "H1h0by0HG"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "BJSeG1ASG",
					"contentIsRoot": false,
					"contentParentId": "BkfgGkRSG"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "rkdlzkCSG",
					"contentIsRoot": false,
					"contentParentId": "Byy1z1AHz"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "H1qlfk0SG",
					"contentIsRoot": false,
					"contentParentId": "rkdlzkCSG"
				},
				{
					"configId": "TABLE_ITEM",
					"contentId": "BJAgG10rG",
					"contentIsRoot": false,
					"contentParentId": "H1-1GkCBz"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "r1bbMJ0Sf",
					"contentIsRoot": false,
					"contentParentId": "BJAgG10rG"
				},
				{
					"configId": "ROW_ITEM",
					"contentId": "rkX-Gk0Bf",
					"contentIsRoot": false,
					"contentParentId": "BJAgG10rG"
				},
				{
					"contentId": "ByhEoApSG",
					"contentIsRoot": false,
					"contentParentId": "r1bbMJ0Sf",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/signaturecontent/twitter.png",
						"imageLink": "https://twitter.com/BritishInsurers"
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"contentId": "BJAVjA6Hf",
					"contentIsRoot": false,
					"contentParentId": "rkX-Gk0Bf",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/signaturecontent/linkedin.png",
						"imageLink": "https://www.linkedin.com/company/association-of-british-insurers"
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"styleHeight": "60",
					"contentId": "r1hWiA6SG",
					"contentIsRoot": false,
					"contentParentId": "H1qlfk0SG",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/signaturecontent/vertical-bar.jpg",
						"imageAlt": "|"
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"styleHeight": "60px",
					"contentId": "H1LWjCarz",
					"contentIsRoot": false,
					"contentParentId": "BJSeG1ASG",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/signaturecontent/vertical-bar.jpg",
						"imageAlt": "|"
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"styleWidth": "120px",
					"contentId": "S1f-oR6rG",
					"contentIsRoot": false,
					"contentParentId": "Sk1gfyRSz",
					"contentContent": {
						"imageUrl": "https://www.abi.org.uk/globalassets/images/newsletter/signaturecontent/abi-logo.jpg",
						"imageAlt": "ABI",
						"imageLink": "https://www.abi.org.uk/"
					},
					"configId": "IMAGE_ITEM"
				},
				{
					"styleWidth": "200px",
					"stylePadding": "5px",
					"contentId": "BJ2rdtlIG",
					"contentIsRoot": false,
					"contentParentId": "ry939HkLM",
					"contentContent": "<p><a href=\"https://www.abi.org.uk/account/\">Manage subscription preferences here</a></p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleWidth": "100px",
					"stylePadding": "5px",
					"contentId": "SypnqSy8z",
					"contentIsRoot": false,
					"contentParentId": "ry939HkLM",
					"contentContent": "<p><a href=\"${Gears.unsubscribe()}\" target=\"_blank\" rel=\"noopener noreferrer\">Unsubscribe here</a>.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleWidth": "250px",
					"stylePadding": "5px",
					"contentId": "Hyn5Q9AJX",
					"contentIsRoot": false,
					"contentParentId": "ry939HkLM",
					"contentContent": "<p>Click <a href=\"https://www.abi.org.uk/privacy-policy/\">here</a> to read our privacy notice.</p>",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				},
				{
					"styleWidth": "100%",
					"stylePadding": "5px",
					"contentId": "SJsq_tgUz",
					"contentIsRoot": false,
					"contentParentId": "ry939HkLM",
					"contentContent": "",
					"configId": "RICH_TEXT",
					"viewClass": "rich-text small"
				}
			],
			"builtIn": true
		}
	];

/***/ },
/* 617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _StyleSheet = __webpack_require__(619);
	
	var _StyleSheet2 = _interopRequireDefault(_StyleSheet);
	
	var _PluginsRegistry = __webpack_require__(618);
	
	var _PluginsRegistry2 = _interopRequireDefault(_PluginsRegistry);
	
	var _plugins = __webpack_require__(629);
	
	var _plugins2 = _interopRequireDefault(_plugins);
	
	var _sheets = __webpack_require__(189);
	
	var _sheets2 = _interopRequireDefault(_sheets);
	
	var _generateClassName = __webpack_require__(632);
	
	var _generateClassName2 = _interopRequireDefault(_generateClassName);
	
	var _createRule2 = __webpack_require__(291);
	
	var _createRule3 = _interopRequireDefault(_createRule2);
	
	var _findRenderer = __webpack_require__(292);
	
	var _findRenderer2 = _interopRequireDefault(_findRenderer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Jss = function () {
	  function Jss(options) {
	    _classCallCheck(this, Jss);
	
	    this.version = "7.1.7";
	    this.plugins = new _PluginsRegistry2['default']();
	
	    // eslint-disable-next-line prefer-spread
	    this.use.apply(this, _plugins2['default']);
	    this.setup(options);
	  }
	
	  _createClass(Jss, [{
	    key: 'setup',
	    value: function setup() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	
	      this.options = _extends({
	        generateClassName: options.generateClassName || _generateClassName2['default'],
	        insertionPoint: options.insertionPoint || 'jss'
	      }, options);
	      // eslint-disable-next-line prefer-spread
	      if (options.plugins) this.use.apply(this, options.plugins);
	      return this;
	    }
	
	    /**
	     * Create a Style Sheet.
	     */
	
	  }, {
	    key: 'createStyleSheet',
	    value: function createStyleSheet(styles) {
	      var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	      var index = options.index;
	      if (typeof index !== 'number') {
	        index = _sheets2['default'].index === 0 ? 0 : _sheets2['default'].index + 1;
	      }
	      var sheet = new _StyleSheet2['default'](styles, _extends({
	        jss: this,
	        generateClassName: this.options.generateClassName,
	        insertionPoint: this.options.insertionPoint
	      }, options, {
	        index: index
	      }));
	      this.plugins.onProcessSheet(sheet);
	      return sheet;
	    }
	
	    /**
	     * Detach the Style Sheet and remove it from the registry.
	     */
	
	  }, {
	    key: 'removeStyleSheet',
	    value: function removeStyleSheet(sheet) {
	      sheet.detach();
	      _sheets2['default'].remove(sheet);
	      return this;
	    }
	
	    /**
	     * Create a rule without a Style Sheet.
	     */
	
	  }, {
	    key: 'createRule',
	    value: function createRule(name) {
	      var style = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	
	      // Enable rule without name for inline styles.
	      if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
	        options = style;
	        style = name;
	        name = undefined;
	      }
	
	      if (!options.classes) options.classes = {};
	      if (!options.jss) options.jss = this;
	      if (!options.Renderer) options.Renderer = (0, _findRenderer2['default'])(options);
	      if (!options.generateClassName) {
	        options.generateClassName = this.options.generateClassName || _generateClassName2['default'];
	      }
	
	      var rule = (0, _createRule3['default'])(name, style, options);
	      this.plugins.onProcessRule(rule);
	
	      return rule;
	    }
	
	    /**
	     * Register plugin. Passed function will be invoked with a rule instance.
	     */
	
	  }, {
	    key: 'use',
	    value: function use() {
	      var _this = this;
	
	      for (var _len = arguments.length, plugins = Array(_len), _key = 0; _key < _len; _key++) {
	        plugins[_key] = arguments[_key];
	      }
	
	      plugins.forEach(function (plugin) {
	        return _this.plugins.use(plugin);
	      });
	      return this;
	    }
	  }]);
	
	  return Jss;
	}();
	
	exports['default'] = Jss;

/***/ },
/* 618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var PluginsRegistry = function () {
	  function PluginsRegistry() {
	    _classCallCheck(this, PluginsRegistry);
	
	    this.hooks = {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: []
	
	      /**
	       * Call `onCreateRule` hooks and return an object if returned by a hook.
	       */
	    };
	  }
	
	  _createClass(PluginsRegistry, [{
	    key: 'onCreateRule',
	    value: function onCreateRule(name, decl, options) {
	      for (var i = 0; i < this.hooks.onCreateRule.length; i++) {
	        var rule = this.hooks.onCreateRule[i](name, decl, options);
	        if (rule) return rule;
	      }
	      return null;
	    }
	
	    /**
	     * Call `onProcessRule` hooks.
	     */
	
	  }, {
	    key: 'onProcessRule',
	    value: function onProcessRule(rule) {
	      if (rule.isProcessed) return;
	      var sheet = rule.options.sheet;
	
	      for (var i = 0; i < this.hooks.onProcessRule.length; i++) {
	        this.hooks.onProcessRule[i](rule, sheet);
	      }
	      if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	      rule.isProcessed = true;
	    }
	
	    /**
	     * Call `onProcessStyle` hooks.
	     */
	
	  }, {
	    key: 'onProcessStyle',
	    value: function onProcessStyle(style, rule, sheet) {
	      for (var i = 0; i < this.hooks.onProcessStyle.length; i++) {
	        rule.style = style = this.hooks.onProcessStyle[i](style, rule, sheet);
	      }
	    }
	
	    /**
	     * Call `onProcessSheet` hooks.
	     */
	
	  }, {
	    key: 'onProcessSheet',
	    value: function onProcessSheet(sheet) {
	      for (var i = 0; i < this.hooks.onProcessSheet.length; i++) {
	        this.hooks.onProcessSheet[i](sheet);
	      }
	    }
	
	    /**
	     * Call `onChangeValue` hooks.
	     */
	
	  }, {
	    key: 'onChangeValue',
	    value: function onChangeValue(value, prop, rule) {
	      var processedValue = value;
	      for (var i = 0; i < this.hooks.onChangeValue.length; i++) {
	        processedValue = this.hooks.onChangeValue[i](processedValue, prop, rule);
	      }
	      return processedValue;
	    }
	
	    /**
	     * Register a plugin.
	     * If function is passed, it is a shortcut for `{onProcessRule}`.
	     */
	
	  }, {
	    key: 'use',
	    value: function use(plugin) {
	      for (var name in plugin) {
	        if (this.hooks[name]) this.hooks[name].push(plugin[name]);else (0, _warning2['default'])(false, '[JSS] Unknown hook "%s".', name);
	      }
	    }
	  }]);
	
	  return PluginsRegistry;
	}();
	
	exports['default'] = PluginsRegistry;

/***/ },
/* 619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _findRenderer = __webpack_require__(292);
	
	var _findRenderer2 = _interopRequireDefault(_findRenderer);
	
	var _linkRule = __webpack_require__(293);
	
	var _linkRule2 = _interopRequireDefault(_linkRule);
	
	var _RulesContainer = __webpack_require__(132);
	
	var _RulesContainer2 = _interopRequireDefault(_RulesContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var StyleSheet = function () {
	  function StyleSheet(styles, options) {
	    _classCallCheck(this, StyleSheet);
	
	    var Renderer = (0, _findRenderer2['default'])(options);
	
	    this.attached = false;
	    this.deployed = false;
	    this.linked = false;
	    this.classes = Object.create(null);
	    this.options = _extends({
	      sheet: this,
	      parent: this,
	      classes: this.classes,
	      Renderer: Renderer
	    }, options);
	    this.renderer = new Renderer(this);
	    this.renderer.createElement();
	    this.rules = new _RulesContainer2['default'](this.options);
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  _createClass(StyleSheet, [{
	    key: 'attach',
	    value: function attach() {
	      if (this.attached) return this;
	      if (!this.deployed) this.deploy();
	      this.renderer.attach();
	      if (!this.linked && this.options.link) this.link();
	      this.attached = true;
	      return this;
	    }
	
	    /**
	     * Remove renderable from render tree.
	     */
	
	  }, {
	    key: 'detach',
	    value: function detach() {
	      if (!this.attached) return this;
	      this.renderer.detach();
	      this.attached = false;
	      return this;
	    }
	
	    /**
	     * Add a rule to the current stylesheet.
	     * Will insert a rule also after the stylesheet has been rendered first time.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, decl, options) {
	      var queue = this.queue;
	
	      // Plugins can create rules.
	      // In order to preserve the right order, we need to queue all `.addRule` calls,
	      // which happen after the first `rules.add()` call.
	
	      if (this.attached && !queue) this.queue = [];
	
	      var rule = this.rules.add(name, decl, options);
	      this.options.jss.plugins.onProcessRule(rule);
	
	      if (this.attached) {
	        if (!this.deployed) return rule;
	        // Don't insert rule directly if there is no stringified version yet.
	        // It will be inserted all together when .attach is called.
	        if (queue) queue.push(rule);else {
	          this.insertRule(rule);
	          if (this.queue) {
	            this.queue.forEach(this.insertRule, this);
	            this.queue = undefined;
	          }
	        }
	        return rule;
	      }
	
	      // We can't add rules to a detached style node.
	      // We will redeploy the sheet once user will attach it.
	      this.deployed = false;
	
	      return rule;
	    }
	
	    /**
	     * Insert rule into the StyleSheet
	     */
	
	  }, {
	    key: 'insertRule',
	    value: function insertRule(rule) {
	      var renderable = this.renderer.insertRule(rule);
	      if (renderable && this.options.link) (0, _linkRule2['default'])(rule, renderable);
	    }
	
	    /**
	     * Create and add rules.
	     * Will render also after Style Sheet was rendered the first time.
	     */
	
	  }, {
	    key: 'addRules',
	    value: function addRules(styles, options) {
	      var added = [];
	      for (var name in styles) {
	        added.push(this.addRule(name, styles[name], options));
	      }
	      return added;
	    }
	
	    /**
	     * Get a rule by name.
	     */
	
	  }, {
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Delete a rule by name.
	     * Returns `true`: if rule has been deleted from the DOM.
	     */
	
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(name) {
	      var rule = this.rules.get(name);
	
	      if (!rule) return false;
	
	      this.rules.remove(rule);
	
	      if (this.attached && rule.renderable) {
	        return this.renderer.deleteRule(rule.renderable);
	      }
	
	      return true;
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Deploy pure CSS string to a renderable.
	     */
	
	  }, {
	    key: 'deploy',
	    value: function deploy() {
	      this.renderer.deploy();
	      this.deployed = true;
	      return this;
	    }
	
	    /**
	     * Link renderable CSS rules from sheet with their corresponding models.
	     */
	
	  }, {
	    key: 'link',
	    value: function link() {
	      var cssRules = this.renderer.getRules
	
	      // Is undefined when VirtualRenderer is used.
	      ();if (cssRules) this.rules.link(cssRules);
	      this.linked = true;
	      return this;
	    }
	
	    /**
	     * Update the function values with a new data.
	     */
	
	  }, {
	    key: 'update',
	    value: function update(name, data) {
	      this.rules.update(name, data);
	      return this;
	    }
	
	    /**
	     * Convert rules to a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      return this.rules.toString(options);
	    }
	  }]);
	
	  return StyleSheet;
	}();
	
	exports['default'] = StyleSheet;

/***/ },
/* 620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _sheets = __webpack_require__(189);
	
	var _sheets2 = _interopRequireDefault(_sheets);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Get a style property.
	 */
	function getStyle(rule, prop) {
	  try {
	    return rule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	}
	
	/**
	 * Set a style property.
	 */
	function setStyle(rule, prop, value) {
	  try {
	    rule.style.setProperty(prop, value);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	  return true;
	}
	
	function extractSelector(cssText) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	  return cssText.substr(from, cssText.indexOf('{') - 1);
	}
	
	var CSSRuleTypes = {
	  STYLE_RULE: 1,
	  KEYFRAMES_RULE: 7
	
	  /**
	   * Get the selector.
	   */
	};function getSelector(rule) {
	  if (rule.type === CSSRuleTypes.STYLE_RULE) return rule.selectorText;
	  if (rule.type === CSSRuleTypes.KEYFRAMES_RULE) {
	    var name = rule.name;
	
	    if (name) return '@keyframes ' + name;
	
	    // There is no rule.name in the following browsers:
	    // - IE 9
	    // - Safari 7.1.8
	    // - Mobile Safari 9.0.0
	    var cssText = rule.cssText;
	
	    return '@' + extractSelector(cssText, cssText.indexOf('keyframes'));
	  }
	
	  return extractSelector(rule.cssText);
	}
	
	/**
	 * Set the selector.
	 */
	function setSelector(rule, selectorText) {
	  rule.selectorText = selectorText;
	
	  // Return false if setter was not successful.
	  // Currently works in chrome only.
	  return rule.selectorText === selectorText;
	}
	
	/**
	 * Gets the `head` element upon the first call and caches it.
	 */
	var getHead = function () {
	  var head = void 0;
	  return function () {
	    if (!head) head = document.head || document.getElementsByTagName('head')[0];
	    return head;
	  };
	}
	
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	();function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find attached sheet with the highest index.
	 */
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find a comment with "jss" inside.
	 */
	function findCommentNode(text) {
	  var head = getHead();
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	  return null;
	}
	
	/**
	 * Find a node before which we can insert the sheet.
	 */
	function findPrevNode(options) {
	  var registry = _sheets2['default'].registry;
	
	
	  if (registry.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry, options);
	    if (sheet) return sheet.renderer.element;
	
	    // Otherwise insert after the last attached.
	    sheet = findHighestSheet(registry, options);
	    if (sheet) return sheet.renderer.element.nextElementSibling;
	  }
	
	  // Try to find a comment placeholder if registry is empty.
	  var comment = findCommentNode(options.insertionPoint);
	  if (comment) return comment.nextSibling;
	  return null;
	}
	
	var DomRenderer = function () {
	  function DomRenderer(sheet) {
	    _classCallCheck(this, DomRenderer);
	
	    this.getStyle = getStyle;
	    this.setStyle = setStyle;
	    this.setSelector = setSelector;
	    this.getSelector = getSelector;
	    this.hasInsertedRules = false;
	
	    this.sheet = sheet;
	    // There is no sheet when the renderer is used from a standalone RegularRule.
	    if (sheet) _sheets2['default'].add(sheet);
	  }
	
	  /**
	   * Create and ref style element.
	   */
	
	
	  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
	
	
	  _createClass(DomRenderer, [{
	    key: 'createElement',
	    value: function createElement() {
	      var _ref = this.sheet ? this.sheet.options : {},
	          media = _ref.media,
	          meta = _ref.meta,
	          element = _ref.element;
	
	      this.element = element || document.createElement('style');
	      this.element.type = 'text/css';
	      this.element.setAttribute('data-jss', '');
	      if (media) this.element.setAttribute('media', media);
	      if (meta) this.element.setAttribute('data-meta', meta);
	    }
	
	    /**
	     * Insert style element into render tree.
	     */
	
	  }, {
	    key: 'attach',
	    value: function attach() {
	      // In the case the element node is external and it is already in the DOM.
	      if (this.element.parentNode || !this.sheet) return;
	
	      // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	      // browsers remove those rules.
	      // TODO figure out if its a bug and if it is known.
	      // Workaround is to redeploy the sheet before attaching as a string.
	      if (this.hasInsertedRules) {
	        this.deploy();
	        this.hasInsertedRules = false;
	      }
	      var prevNode = findPrevNode(this.sheet.options);
	      getHead().insertBefore(this.element, prevNode);
	    }
	
	    /**
	     * Remove style element from render tree.
	     */
	
	  }, {
	    key: 'detach',
	    value: function detach() {
	      this.element.parentNode.removeChild(this.element);
	    }
	
	    /**
	     * Inject CSS string into element.
	     */
	
	  }, {
	    key: 'deploy',
	    value: function deploy() {
	      if (!this.sheet) return;
	      this.element.textContent = '\n' + this.sheet.toString() + '\n';
	    }
	
	    /**
	     * Insert a rule into element.
	     */
	
	  }, {
	    key: 'insertRule',
	    value: function insertRule(rule) {
	      var sheet = this.element.sheet;
	      var cssRules = sheet.cssRules;
	
	      var index = cssRules.length;
	      var str = rule.toString();
	
	      if (!str) return false;
	
	      try {
	        sheet.insertRule(str, index);
	      } catch (err) {
	        (0, _warning2['default'])(false, '[JSS] Can not insert an unsupported rule \n\r%s', rule);
	        return false;
	      }
	
	      this.hasInsertedRules = true;
	
	      return cssRules[index];
	    }
	
	    /**
	     * Delete a rule.
	     */
	
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule(rule) {
	      var sheet = this.element.sheet;
	      var cssRules = sheet.cssRules;
	
	      for (var _index = 0; _index < cssRules.length; _index++) {
	        if (rule === cssRules[_index]) {
	          sheet.deleteRule(_index);
	          return true;
	        }
	      }
	      return false;
	    }
	
	    /**
	     * Get all rules elements.
	     */
	
	  }, {
	    key: 'getRules',
	    value: function getRules() {
	      return this.element.sheet.cssRules;
	    }
	  }]);
	
	  return DomRenderer;
	}();
	
	exports['default'] = DomRenderer;

/***/ },
/* 621 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/* eslint-disable class-methods-use-this */
	
	/**
	 * Rendering backend to do nothing in nodejs.
	 */
	var VirtualRenderer = function () {
	  function VirtualRenderer() {
	    _classCallCheck(this, VirtualRenderer);
	  }
	
	  _createClass(VirtualRenderer, [{
	    key: 'createElement',
	    value: function createElement() {}
	  }, {
	    key: 'setStyle',
	    value: function setStyle() {
	      return true;
	    }
	  }, {
	    key: 'getStyle',
	    value: function getStyle() {
	      return '';
	    }
	  }, {
	    key: 'setSelector',
	    value: function setSelector() {
	      return true;
	    }
	  }, {
	    key: 'getSelector',
	    value: function getSelector() {
	      return '';
	    }
	  }, {
	    key: 'attach',
	    value: function attach() {}
	  }, {
	    key: 'detach',
	    value: function detach() {}
	  }, {
	    key: 'deploy',
	    value: function deploy() {}
	  }, {
	    key: 'insertRule',
	    value: function insertRule() {
	      return true;
	    }
	  }, {
	    key: 'deleteRule',
	    value: function deleteRule() {
	      return true;
	    }
	  }, {
	    key: 'getRules',
	    value: function getRules() {}
	  }]);
	
	  return VirtualRenderer;
	}();
	
	exports['default'] = VirtualRenderer;

/***/ },
/* 622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.create = exports.sheets = exports.RulesContainer = exports.SheetsRegistry = exports.getDynamicStyles = undefined;
	
	var _Jss = __webpack_require__(617);
	
	var _Jss2 = _interopRequireDefault(_Jss);
	
	var _SheetsRegistry = __webpack_require__(290);
	
	var _SheetsRegistry2 = _interopRequireDefault(_SheetsRegistry);
	
	var _RulesContainer = __webpack_require__(132);
	
	var _RulesContainer2 = _interopRequireDefault(_RulesContainer);
	
	var _sheets = __webpack_require__(189);
	
	var _sheets2 = _interopRequireDefault(_sheets);
	
	var _getDynamicStyles = __webpack_require__(633);
	
	var _getDynamicStyles2 = _interopRequireDefault(_getDynamicStyles);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Extracts a styles object with only rules that contain function values.
	 */
	exports.getDynamicStyles = _getDynamicStyles2['default'];
	
	/**
	 * SheetsRegistry for SSR.
	 */
	
	/**
	 * A better abstraction over CSS.
	 *
	 * @copyright Oleg Slobodskoi 2014-present
	 * @website https://github.com/cssinjs/jss
	 * @license MIT
	 */
	
	exports.SheetsRegistry = _SheetsRegistry2['default'];
	
	/**
	 * RulesContainer for plugins.
	 */
	
	exports.RulesContainer = _RulesContainer2['default'];
	
	/**
	 * Default global SheetsRegistry instance.
	 */
	
	exports.sheets = _sheets2['default'];
	
	/**
	 * Creates a new instance of Jss.
	 */
	
	var create = exports.create = function create(options) {
	  return new _Jss2['default'](options);
	};
	
	/**
	 * A global Jss instance.
	 */
	exports['default'] = create();

/***/ },
/* 623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RulesContainer = __webpack_require__(132);
	
	var _RulesContainer2 = _interopRequireDefault(_RulesContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Conditional rule for @media, @supports
	 */
	var ConditionalRule = function () {
	  function ConditionalRule(selector, styles, options) {
	    _classCallCheck(this, ConditionalRule);
	
	    this.type = 'conditional';
	
	    this.selector = selector;
	    this.options = options;
	    this.rules = new _RulesContainer2['default'](_extends({}, options, { parent: this }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Get a rule.
	   */
	
	
	  _createClass(ConditionalRule, [{
	    key: 'getRule',
	    value: function getRule(name) {
	      return this.rules.get(name);
	    }
	
	    /**
	     * Get index of a rule.
	     */
	
	  }, {
	    key: 'indexOf',
	    value: function indexOf(rule) {
	      return this.rules.indexOf(rule);
	    }
	
	    /**
	     * Create and register rule, run plugins.
	     */
	
	  }, {
	    key: 'addRule',
	    value: function addRule(name, style, options) {
	      var rule = this.rules.add(name, style, options);
	      this.options.jss.plugins.onProcessRule(rule);
	      return rule;
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString() {
	      var inner = this.rules.toString({ indent: 1 });
	      return inner ? this.selector + ' {\n' + inner + '\n}' : '';
	    }
	  }]);
	
	  return ConditionalRule;
	}();
	
	exports['default'] = ConditionalRule;

/***/ },
/* 624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toCss = __webpack_require__(190);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var FontFaceRule = function () {
	  function FontFaceRule(selector, style, options) {
	    _classCallCheck(this, FontFaceRule);
	
	    this.type = 'font-face';
	
	    this.selector = selector;
	    this.style = style;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(FontFaceRule, [{
	    key: 'toString',
	    value: function toString() {
	      if (Array.isArray(this.style)) {
	        var str = '';
	        for (var index = 0; index < this.style.length; index++) {
	          str += (0, _toCss2['default'])(this.selector, this.style[index]);
	          if (this.style[index + 1]) str += '\n';
	        }
	        return str;
	      }
	
	      return (0, _toCss2['default'])(this.selector, this.style);
	    }
	  }]);
	
	  return FontFaceRule;
	}();
	
	exports['default'] = FontFaceRule;

/***/ },
/* 625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _RulesContainer = __webpack_require__(132);
	
	var _RulesContainer2 = _interopRequireDefault(_RulesContainer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Rule for @keyframes
	 */
	var KeyframeRule = function () {
	  function KeyframeRule(selector, frames, options) {
	    _classCallCheck(this, KeyframeRule);
	
	    this.type = 'keyframe';
	
	    this.selector = selector;
	    this.options = options;
	    this.rules = new _RulesContainer2['default'](_extends({}, options, { parent: this }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends({}, this.options, {
	        parent: this,
	        className: name,
	        selector: name
	      }));
	    }
	
	    this.rules.process();
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(KeyframeRule, [{
	    key: 'toString',
	    value: function toString() {
	      var inner = this.rules.toString({ indent: 1 });
	      if (inner) inner += '\n';
	      return this.selector + ' {\n' + inner + '}';
	    }
	  }]);
	
	  return KeyframeRule;
	}();
	
	exports['default'] = KeyframeRule;

/***/ },
/* 626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toCss = __webpack_require__(190);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	var _toCssValue = __webpack_require__(294);
	
	var _toCssValue2 = _interopRequireDefault(_toCssValue);
	
	var _findClassNames = __webpack_require__(631);
	
	var _findClassNames2 = _interopRequireDefault(_findClassNames);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var RegularRule = function () {
	
	  /**
	   * We expect `style` to be a plain object.
	   * To avoid original style object mutations, we clone it and hash it
	   * along the way.
	   * It is also the fastetst way.
	   * http://jsperf.com/lodash-deepclone-vs-jquery-extend-deep/6
	   */
	  function RegularRule(name, style, options) {
	    _classCallCheck(this, RegularRule);
	
	    this.type = 'regular';
	    var generateClassName = options.generateClassName,
	        sheet = options.sheet,
	        Renderer = options.Renderer;
	
	    this.name = name;
	    this.className = '';
	    this.options = options;
	    this.style = style;
	    if (options.className) this.className = options.className;else if (generateClassName) this.className = generateClassName(this, sheet);
	    this.selectorText = options.selector || '.' + this.className;
	    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
	  }
	
	  /**
	   * Set selector string.
	   * Attenition: use this with caution. Most browser didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  _createClass(RegularRule, [{
	    key: 'prop',
	
	
	    /**
	     * Get or set a style property.
	     */
	    value: function prop(name, value) {
	      var $name = typeof this.style[name] === 'function' ? '$' + name : name;
	      var currValue = this.style[$name];
	
	      // Its a setter.
	      if (value != null) {
	        // Don't do anything if the value has not changed.
	        if (currValue !== value) {
	          var jss = this.options.jss;
	
	          var newValue = jss ? jss.plugins.onChangeValue(value, name, this) : value;
	          Object.defineProperty(this.style, $name, {
	            value: newValue,
	            writable: true
	          }
	          // Only defined if option linked is true.
	          );if (this.renderable) this.renderer.setStyle(this.renderable, name, newValue);
	        }
	        return this;
	      }
	      // Its a getter, read the value from the DOM if its not cached.
	      if (this.renderable && currValue == null) {
	        currValue = this.renderer.getStyle(this.renderable, name
	        // Cache the value after we have got it from the DOM first time.
	        );this.prop(name, currValue);
	      }
	
	      return this.style[$name];
	    }
	
	    /**
	     * Apply rule to an element inline.
	     */
	
	  }, {
	    key: 'applyTo',
	    value: function applyTo(renderable) {
	      var json = this.toJSON();
	      for (var prop in json) {
	        this.renderer.setStyle(renderable, prop, json[prop]);
	      }return this;
	    }
	
	    /**
	     * Returns JSON representation of the rule.
	     * Fallbacks are not supported.
	     * Useful for inline styles.
	     */
	
	  }, {
	    key: 'toJSON',
	    value: function toJSON() {
	      var json = Object.create(null);
	      for (var prop in this.style) {
	        var value = this.style[prop];
	        var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	        if (type === 'function') json[prop] = this.style['$' + prop];else if (type !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = (0, _toCssValue2['default'])(value);
	      }
	      return json;
	    }
	
	    /**
	     * Generates a CSS string.
	     */
	
	  }, {
	    key: 'toString',
	    value: function toString(options) {
	      return (0, _toCss2['default'])(this.selector, this.style, options);
	    }
	  }, {
	    key: 'selector',
	    set: function set(selector) {
	      var sheet = this.options.sheet;
	
	      // After we modify a selector, ref by old selector needs to be removed.
	
	      if (sheet) sheet.rules.unregister(this);
	
	      this.selectorText = selector;
	      this.className = (0, _findClassNames2['default'])(selector);
	
	      if (!this.renderable) {
	        // Register the rule with new selector.
	        if (sheet) sheet.rules.register(this);
	        return;
	      }
	
	      var changed = this.renderer.setSelector(this.renderable, selector);
	
	      if (changed && sheet) {
	        sheet.rules.register(this);
	        return;
	      }
	
	      // If selector setter is not implemented, rerender the sheet.
	      // We need to delete renderable from the rule, because when sheet.deploy()
	      // calls rule.toString, it will get the old selector.
	      delete this.renderable;
	      if (sheet) {
	        sheet.rules.register(this);
	        sheet.deploy().link();
	      }
	    }
	
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      if (this.renderable) {
	        return this.renderer.getSelector(this.renderable);
	      }
	
	      return this.selectorText;
	    }
	  }]);
	
	  return RegularRule;
	}();
	
	exports['default'] = RegularRule;

/***/ },
/* 627 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var SimpleRule = function () {
	  function SimpleRule(name, value, options) {
	    _classCallCheck(this, SimpleRule);
	
	    this.type = 'simple';
	
	    this.name = name;
	    this.value = value;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(SimpleRule, [{
	    key: 'toString',
	    value: function toString() {
	      if (Array.isArray(this.value)) {
	        var str = '';
	        for (var index = 0; index < this.value.length; index++) {
	          str += this.name + ' ' + this.value[index] + ';';
	          if (this.value[index + 1]) str += '\n';
	        }
	        return str;
	      }
	
	      return this.name + ' ' + this.value + ';';
	    }
	  }]);
	
	  return SimpleRule;
	}();
	
	exports['default'] = SimpleRule;

/***/ },
/* 628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _toCss = __webpack_require__(190);
	
	var _toCss2 = _interopRequireDefault(_toCss);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ViewportRule = function () {
	  function ViewportRule(name, style, options) {
	    _classCallCheck(this, ViewportRule);
	
	    this.type = 'viewport';
	
	    this.name = name;
	    this.style = style;
	    this.options = options;
	  }
	
	  /**
	   * Generates a CSS string.
	   */
	
	
	  _createClass(ViewportRule, [{
	    key: 'toString',
	    value: function toString() {
	      return (0, _toCss2['default'])(this.name, this.style);
	    }
	  }]);
	
	  return ViewportRule;
	}();
	
	exports['default'] = ViewportRule;

/***/ },
/* 629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _SimpleRule = __webpack_require__(627);
	
	var _SimpleRule2 = _interopRequireDefault(_SimpleRule);
	
	var _KeyframeRule = __webpack_require__(625);
	
	var _KeyframeRule2 = _interopRequireDefault(_KeyframeRule);
	
	var _ConditionalRule = __webpack_require__(623);
	
	var _ConditionalRule2 = _interopRequireDefault(_ConditionalRule);
	
	var _FontFaceRule = __webpack_require__(624);
	
	var _FontFaceRule2 = _interopRequireDefault(_FontFaceRule);
	
	var _ViewportRule = __webpack_require__(628);
	
	var _ViewportRule2 = _interopRequireDefault(_ViewportRule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var classes = {
	  '@charset': _SimpleRule2['default'],
	  '@import': _SimpleRule2['default'],
	  '@namespace': _SimpleRule2['default'],
	  '@keyframes': _KeyframeRule2['default'],
	  '@media': _ConditionalRule2['default'],
	  '@supports': _ConditionalRule2['default'],
	  '@font-face': _FontFaceRule2['default'],
	  '@viewport': _ViewportRule2['default'],
	  '@-ms-viewport': _ViewportRule2['default']
	
	  /**
	   * Generate plugins which will register all rules.
	   */
	};
	exports['default'] = Object.keys(classes).map(function (key) {
	  // https://jsperf.com/indexof-vs-substr-vs-regex-at-the-beginning-3
	  var re = new RegExp('^' + key);
	  var onCreateRule = function onCreateRule(name, decl, options) {
	    return re.test(name) ? new classes[key](name, decl, options) : null;
	  };
	  return { onCreateRule: onCreateRule };
	});

/***/ },
/* 630 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = cloneStyle;
	var isArray = Array.isArray;
	function cloneStyle(style) {
	  // Support empty values in case user ends up with them by accident.
	  if (style == null) return style;
	
	  // Support string value for SimpleRule.
	  var typeOfStyle = typeof style === 'undefined' ? 'undefined' : _typeof(style);
	  if (typeOfStyle === 'string' || typeOfStyle === 'number') return style;
	
	  // Support array for FontFaceRule.
	  if (isArray(style)) return style.map(cloneStyle);
	
	  var newStyle = {};
	  for (var name in style) {
	    var value = style[name];
	    if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object') {
	      newStyle[name] = cloneStyle(value);
	      continue;
	    }
	    newStyle[name] = value;
	  }
	
	  return newStyle;
	}

/***/ },
/* 631 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports['default'] = findClassNames;
	var dotsRegExp = /[.]/g;
	var classesRegExp = /[.][^ ,]+/g;
	
	/**
	 * Get class names from a selector.
	 */
	function findClassNames(selector) {
	  var classes = selector.match(classesRegExp);
	
	  if (!classes) return '';
	
	  return classes.join(' ').replace(dotsRegExp, '');
	}

/***/ },
/* 632 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	
	var globalRef = typeof window === 'undefined' ? global : window;
	
	var namespace = '__JSS_VERSION_COUNTER__';
	if (globalRef[namespace] == null) globalRef[namespace] = 0;
	// In case we have more than one JSS version.
	var jssCounter = globalRef[namespace]++;
	var ruleCounter = 0;
	
	/**
	 * Generates unique class names.
	 */
	
	exports['default'] = function (rule) {
	  return (
	    // There is no rule name if `jss.createRule(style)` was used.
	    (rule.name || 'jss') + '-' + jssCounter + '-' + ruleCounter++
	  );
	};
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 633 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	exports['default'] = function (styles) {
	  // eslint-disable-next-line no-shadow
	  function extract(styles) {
	    var to = null;
	
	    for (var key in styles) {
	      var value = styles[key];
	      var type = typeof value === 'undefined' ? 'undefined' : _typeof(value);
	
	      if (type === 'function') {
	        if (!to) to = {};
	        to[key] = value;
	      } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	        var extracted = extract(value);
	        if (extracted) {
	          if (!to) to = {};
	          to[key] = extracted;
	        }
	      }
	    }
	
	    return to;
	  }
	
	  return extract(styles);
	};

/***/ },
/* 634 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports['default'] = function (rule, data, RulesContainer) {
	  if (rule.type === 'regular') {
	    for (var prop in rule.style) {
	      var value = rule.style[prop];
	      if (typeof value === 'function') {
	        rule.prop(prop, value(data));
	      }
	    }
	  } else if (rule.rules instanceof RulesContainer) {
	    rule.rules.update(data);
	  }
	};

/***/ },
/* 635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var cheerio = __webpack_require__(636);
	var makeJuiceClient = __webpack_require__(637);
	
	/**
	 * Note that makeJuiceClient will take a base object (in this case a function) and enhance it
	 * with a lot of useful properties and functions.
	 *
	 * This client adopts cheerio as a DOM parser and adds an "inlineContent" function that let
	 * users to specify the CSS to be inlined instead of extracting it from the html.
	 * 
	 * The weird "makeJuiceClient" behaviour is there in order to keep backward API compatibility.
	 */
	var juiceClient = makeJuiceClient(function(html,options) {
	  return cheerio(html, { xmlMode: options && options.xmlMode}, juiceDocument, [options]);
	});
	
	var juiceDocument = function(html, options) {
	  return juiceClient.juiceDocument(html, options);
	}
	
	juiceClient.inlineContent = function(html, css, options) {
	  return cheerio(html, { xmlMode: options && options.xmlMode}, juiceClient.inlineDocument, [css, options]);
	};
	
	module.exports = juiceClient;


/***/ },
/* 636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * Module dependencies.
	 */
	var cheerio = __webpack_require__(124);
	var utils = __webpack_require__(191);
	
	var cheerioLoad = function(html, options) {
	  options = utils.extend({decodeEntities: false}, options || {});
	  html = encodeEntities(html);
	  return cheerio.load(html,options);
	};
	
	var codeBlockLookup = [];
	
	var encodeCodeBlocks = function(html) {
	  var blocks = module.exports.codeBlocks;
	  Object.keys(blocks).forEach(function(key) {
	    var re = new RegExp(blocks[key].start + '([\\S\\s]*?)' + blocks[key].end, 'g');
	    html = html.replace(re, function(match, subMatch) {
	      codeBlockLookup.push(match); 
	      return 'JUICE_CODE_BLOCK_' + (codeBlockLookup.length - 1) + '_';
	    });
	  });
	  return html;
	};
	
	var decodeCodeBlocks = function(html) {
	  for(var index = 0; index < codeBlockLookup.length; index++) {    
	    var re = new RegExp('JUICE_CODE_BLOCK_' + index + '_(="")?', 'gi');
	    html = html.replace(re, function() {
	      return codeBlockLookup[index];
	    });
	  }
	  return html;
	};
	
	var encodeEntities = function(html) {
	  return encodeCodeBlocks(html);
	};
	
	var decodeEntities = function(html) {
	  return decodeCodeBlocks(html);
	};
	
	/**
	 * Parses the input, calls the callback on the parsed DOM, and generates the output
	 *
	 * @param {String} html input html to be processed
	 * @param {Object} options for the parser
	 * @param {Function} callback to be invoked on the DOM
	 * @param {Array} callbackExtraArguments to be passed to the callback
	 * @return {String} resulting html
	 */
	module.exports = function(html, options, callback, callbackExtraArguments) {
	  var $ = cheerioLoad(html, options);
	  var args = [ $ ];
	  args.push.apply(args, callbackExtraArguments);
	  var doc = callback.apply(undefined, args) || $;
	
	  if (options && options.xmlMode) {
	    return doc.xml();
	  }
	  return decodeEntities(doc.html());
	};
	
	module.exports.codeBlocks = {
	  EJS: { start: '<%', end: '%>' },
	  HBS: { start: '{{', end: '}}' }
	};


/***/ },
/* 637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var utils = __webpack_require__(191);
	
	module.exports = function makeJuiceClient(juiceClient) {
	
	juiceClient.ignoredPseudos = ['hover', 'active', 'focus', 'visited', 'link'];
	juiceClient.widthElements = ['TABLE', 'TD', 'IMG'];
	juiceClient.heightElements = ['TABLE', 'TD', 'IMG'];
	juiceClient.tableElements = ['TABLE', 'TD', 'TH', 'TR', 'TD', 'CAPTION', 'COLGROUP', 'COL', 'THEAD', 'TBODY', 'TFOOT'];
	juiceClient.nonVisualElements = [ 'HEAD', 'TITLE', 'BASE', 'LINK', 'STYLE', 'META', 'SCRIPT', 'NOSCRIPT' ];
	juiceClient.styleToAttribute = {
	  'background-color': 'bgcolor',
	  'background-image': 'background',
	  'text-align': 'align',
	  'vertical-align': 'valign'
	};
	juiceClient.excludedProperties = [];
	
	juiceClient.juiceDocument = juiceDocument;
	juiceClient.inlineDocument = inlineDocument;
	
	function inlineDocument($, css, options) {
	
	  options = options || {};
	  var rules = utils.parseCSS(css);
	  var editedElements = [];
	  var styleAttributeName = 'style';
	
	  if (options.styleAttributeName) {
	    styleAttributeName = options.styleAttributeName;
	  }
	
	  rules.forEach(handleRule);
	  editedElements.forEach(setStyleAttrs);
	
	  if (options.inlinePseudoElements) {
	    editedElements.forEach(inlinePseudoElements);
	  }
	
	  if (options.applyWidthAttributes) {
	    editedElements.forEach(function(el) {
	      setDimensionAttrs(el, 'width');
	    });
	  }
	
	  if (options.applyHeightAttributes) {
	    editedElements.forEach(function(el) {
	      setDimensionAttrs(el, 'height');
	    });
	  }
	
	  if (options.applyAttributesTableElements) {
	    editedElements.forEach(setAttributesOnTableElements);
	  }
	
	  if (options.insertPreservedExtraCss && options.extraCss) {
	    var preservedText = utils.getPreservedText(options.extraCss, {
	      mediaQueries: options.preserveMediaQueries,
	      fontFaces: options.preserveFontFaces
	    });
	    if (preservedText) {
	      var $appendTo = null;
	      if (options.insertPreservedExtraCss !== true) {
	        $appendTo = $(options.insertPreservedExtraCss);
	      } else {
	        $appendTo = $('head');
	        if (!$appendTo.length) { $appendTo = $('body'); }
	        if (!$appendTo.length) { $appendTo = $.root(); }
	      }
	
	      $appendTo.first().append('<style>' + preservedText + '</style>');
	    }
	  }
	
	  function handleRule(rule) {
	    var sel = rule[0];
	    var style = rule[1];
	    var selector = new utils.Selector(sel);
	    var parsedSelector = selector.parsed();
	    var pseudoElementType = getPseudoElementType(parsedSelector);
	
	    // skip rule if the selector has any pseudos which are ignored
	    for (var i = 0; i < parsedSelector.length; ++i) {
	      var subSel = parsedSelector[i];
	      if (subSel.pseudos) {
	        for (var j = 0; j < subSel.pseudos.length; ++j) {
	          var subSelPseudo = subSel.pseudos[j];
	          if (juiceClient.ignoredPseudos.indexOf(subSelPseudo.name) >= 0) {
	            return;
	          }
	        }
	      }
	    }
	
	    if (pseudoElementType) {
	      var last = parsedSelector[parsedSelector.length - 1];
	      var pseudos = last.pseudos;
	      last.pseudos = filterElementPseudos(last.pseudos);
	      sel = parsedSelector.toString();
	      last.pseudos = pseudos;
	    }
	
	    var els;
	    try {
	      els = $(sel);
	    } catch (err) {
	      // skip invalid selector
	      return;
	    }
	
	    els.each(function() {
	      var el = this;
	
	      if (el.name && juiceClient.nonVisualElements.indexOf(el.name.toUpperCase()) >= 0) {
	        return;
	      }
	
	      if (pseudoElementType) {
	        var pseudoElPropName = 'pseudo' + pseudoElementType;
	        var pseudoEl = el[pseudoElPropName];
	        if (!pseudoEl) {
	          pseudoEl = el[pseudoElPropName] = $('<span />').get(0);
	          pseudoEl.pseudoElementType = pseudoElementType;
	          pseudoEl.pseudoElementParent = el;
	          el[pseudoElPropName] = pseudoEl;
	        }
	        el = pseudoEl;
	      }
	
	      if (!el.styleProps) {
	        el.styleProps = {};
	
	        // if the element has inline styles, fake selector with topmost specificity
	        if ($(el).attr(styleAttributeName)) {
	          var cssText = '* { ' + $(el).attr(styleAttributeName) + ' } ';
	          addProps(utils.parseCSS(cssText)[0][1], new utils.Selector('<style>', true));
	        }
	
	        // store reference to an element we need to compile style="" attr for
	        editedElements.push(el);
	      }
	
	      // go through the properties
	      function addProps(style, selector) {
	        for (var i = 0, l = style.length; i < l; i++) {
	          if (style[i].type == 'property') {
	            var name = style[i].name;
	            var value = style[i].value;
	            var important = style[i].value.match(/!important$/) !== null;
	            if (important && !options.preserveImportant) value = value.replace(/\s*!important$/, '');
	            // adds line number and column number for the properties as "additionalPriority" to the
	            // properties because in CSS the position directly affect the priority.
	            var additionalPriority = [style[i].position.start.line, style[i].position.start.col];
	            var prop = new utils.Property(name, value, selector, important ? 2 : 0, additionalPriority);
	            var existing = el.styleProps[name];
	
	            // if property name is not in the excluded properties array
	            if (juiceClient.excludedProperties.indexOf(name) < 0) {
	              if (existing && existing.compare(prop) === prop || !existing) {
	                // deleting a property let us change the order (move it to the end in the setStyleAttrs loop)
	                if (existing && existing.selector !== selector) {
	                  delete el.styleProps[name];
	                } else if (existing) {
	                  // make "prop" a special composed property.
	                  prop.nextProp = existing;
	                }
	
	                el.styleProps[name] = prop;
	              }
	            }
	          }
	        }
	      }
	
	      addProps(style, selector);
	    });
	  }
	
	  function setStyleAttrs(el) {
	    var l = Object.keys(el.styleProps).length;
	    var props = [];
	    // Here we loop each property and make sure to "expand"
	    // linked "nextProp" properties happening when the same property
	    // is declared multiple times in the same selector.
	    Object.keys(el.styleProps).forEach(function(key) {
	      var np = el.styleProps[key];
	      while (typeof np !== 'undefined') {
	        props.push(np);
	        np = np.nextProp;
	      }
	    });
	    // sort properties by their originating selector's specificity so that
	    // props like "padding" and "padding-bottom" are resolved as expected.
	    props.sort(function(a, b) {
	      return a.compareFunc(b);
	    });
	    var string = props
	      .filter(function(prop) {
	        // Content becomes the innerHTML of pseudo elements, not used as a
	        // style property
	        return prop.prop !== 'content';
	      })
	      .map(function(prop) {
	        return prop.prop + ': ' + prop.value.replace(/["]/g, '\'') + ';';
	      })
	      .join(' ');
	    if (string) {
	      $(el).attr(styleAttributeName, string);
	    }
	  }
	
	  function inlinePseudoElements(el) {
	    if (el.pseudoElementType && el.styleProps.content) {
	      var parsed = parseContent(el.styleProps.content.value);
	      if (parsed.img) {
	        el.name = 'img';
	        $(el).attr('src', parsed.img);
	      } else {
	        $(el).text(parsed);
	      }
	      var parent = el.pseudoElementParent;
	      if (el.pseudoElementType === 'before') {
	        $(parent).prepend(el);
	      } else {
	        $(parent).append(el);
	      }
	    }
	  }
	
	  function setDimensionAttrs(el, dimension) {
	    if (!el.name) { return; }
	    var elName = el.name.toUpperCase();
	    if (juiceClient[dimension + 'Elements'].indexOf(elName) > -1) {
	      for (var i in el.styleProps) {
	        if (el.styleProps[i].prop === dimension) {
	          if (el.styleProps[i].value.match(/px/)) {
	            var pxSize = el.styleProps[i].value.replace('px', '');
	            $(el).attr(dimension, pxSize);
	            return;
	          }
	          if (juiceClient.tableElements.indexOf(elName) > -1 && el.styleProps[i].value.match(/\%/)) {
	            $(el).attr(dimension, el.styleProps[i].value);
	            return;
	          }
	        }
	      }
	    }
	  }
	
	  function extractBackgroundUrl(value) {
	    return value.indexOf('url(') !== 0
	      ? value
	      : value.replace(/^url\((["'])?([^"']+)\1\)$/, '$2');
	  }
	
	  function setAttributesOnTableElements(el) {
	    if (!el.name) { return; }
	    var elName = el.name.toUpperCase();
	    var styleProps = Object.keys(juiceClient.styleToAttribute);
	
	    if (juiceClient.tableElements.indexOf(elName) > -1) {
	      for (var i in el.styleProps) {
	        if (styleProps.indexOf(el.styleProps[i].prop) > -1) {
	          var prop = juiceClient.styleToAttribute[el.styleProps[i].prop];
	          var value = el.styleProps[i].value;
	          if (prop === 'background') {
	            value = extractBackgroundUrl(value)
	          }
	          $(el).attr(prop, value);
	        }
	      }
	    }
	  }
	}
	
	function parseContent(content) {
	  if (content === 'none' || content === 'normal') {
	    return '';
	  }
	
	  var imageUrlMatch = content.match(/^\s*url\s*\(\s*(.*?)\s*\)\s*$/i);
	  if (imageUrlMatch) {
	    var url = imageUrlMatch[1].replace(/^['"]|['"]$/g, '');
	    return { img: url };
	  }
	
	  // Naive parsing, assume well-formed value
	  content = content.slice(1, content.length - 1);
	  // Naive unescape, assume no unicode char codes
	  content = content.replace(/\\/g, '');
	  return content;
	}
	
	// Return "before" or "after" if the given selector is a pseudo element (e.g.,
	// a::after).
	function getPseudoElementType(selector) {
	  if (selector.length === 0) {
	    return;
	  }
	
	  var pseudos = selector[selector.length - 1].pseudos;
	  if (!pseudos) {
	    return;
	  }
	
	  for (var i = 0; i < pseudos.length; i++) {
	    if (isPseudoElementName(pseudos[i])) {
	      return pseudos[i].name;
	    }
	  }
	}
	
	function isPseudoElementName(pseudo) {
	  return pseudo.name === 'before' || pseudo.name === 'after';
	}
	
	function filterElementPseudos(pseudos) {
	  return pseudos.filter(function(pseudo) {
	    return !isPseudoElementName(pseudo);
	  });
	}
	
	function juiceDocument($, options) {
	  options = utils.getDefaultOptions(options);
	  var css = extractCssFromDocument($, options);
	  css += '\n' + options.extraCss;
	  inlineDocument($, css, options);
	  return $;
	}
	
	function getStylesData($, options) {
	  var results = [];
	  var stylesList = $('style');
	  var styleDataList, styleData, styleElement;
	  stylesList.each(function() {
	    styleElement = this;
	    styleDataList = styleElement.childNodes;
	    if (styleDataList.length !== 1) {
	      return;
	    }
	    styleData = styleDataList[0].data;
	    if (options.applyStyleTags && $(styleElement).attr('data-embed') === undefined) {
	      results.push(styleData);
	    }
	    if (options.removeStyleTags && $(styleElement).attr('data-embed') === undefined) {
	      var preservedText = utils.getPreservedText(styleElement.childNodes[0].nodeValue, {
	        mediaQueries: options.preserveMediaQueries,
	        fontFaces: options.preserveFontFaces
	      });
	      if (preservedText) {
	        styleElement.childNodes[0].nodeValue = preservedText;
	      } else {
	        $(styleElement).remove();
	      }
	    }
	    $(styleElement).removeAttr('data-embed');
	  });
	  return results;
	}
	
	function extractCssFromDocument($, options) {
	  var results = getStylesData($, options);
	  var css = results.join('\n');
	  return css;
	}
	
	return juiceClient;
	
	};


/***/ },
/* 638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	module.exports = exports = Property;
	
	/**
	 * Module dependencies.
	 */
	
	var utils = __webpack_require__(191);
	
	/**
	 * CSS property constructor.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @param {Selector} selector the property originates from
	 * @param {Integer} priority 0 for normal properties, 2 for !important properties.
	 * @param {Array} additional array of integers representing more detailed priorities (sorting)
	 * @api public
	 */
	
	function Property(prop, value, selector, priority, additionalPriority) {
	  this.prop = prop;
	  this.value = value;
	  this.selector = selector;
	  this.priority = priority || 0;
	  this.additionalPriority = additionalPriority || [];
	}
	
	/**
	 * Compares with another Property based on Selector#specificity.
	 *
	 * @api public
	 */
	
	Property.prototype.compareFunc = function(property) {
	  var a = [];
	  a.push.apply(a, this.selector.specificity());
	  a.push.apply(a, this.additionalPriority);
	  a[0] += this.priority;
	  var b = [];
	  b.push.apply(b, property.selector.specificity());
	  b.push.apply(b, property.additionalPriority);
	  b[0] += property.priority;
	  return utils.compareFunc(a, b);
	};
	
	Property.prototype.compare = function(property) {
	  var winner = this.compareFunc(property);
	  if (winner === 1) {
	    return this;
	  }
	  return property;
	};
	
	
	/**
	 * Returns CSS property
	 *
	 * @api public
	 */
	
	Property.prototype.toString = function() {
	  return this.prop + ': ' + this.value.replace(/['"]+/g, '') + ';';
	};


/***/ },
/* 639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var parser = __webpack_require__(1999);
	
	module.exports = exports = Selector;
	
	/**
	 * CSS selector constructor.
	 *
	 * @param {String} selector text
	 * @param {Array} optionally, precalculated specificity
	 * @api public
	 */
	
	function Selector(text, styleAttribute) {
	  this.text = text;
	  this.spec = undefined;
	  this.styleAttribute = styleAttribute || false;
	}
	
	/**
	 * Get parsed selector.
	 *
	 * @api public
	 */
	
	Selector.prototype.parsed = function() {
	  if (!this.tokens) { this.tokens = parse(this.text); }
	  return this.tokens;
	};
	
	/**
	 * Lazy specificity getter
	 *
	 * @api public
	 */
	
	Selector.prototype.specificity = function() {
	  var styleAttribute = this.styleAttribute;
	  if (!this.spec) { this.spec = specificity(this.text, this.parsed()); }
	  return this.spec;
	
	  function specificity(text, parsed) {
	    var expressions = parsed || parse(text);
	    var spec = [styleAttribute ? 1 : 0, 0, 0, 0];
	    var nots = [];
	
	    for (var i = 0; i < expressions.length; i++) {
	      var expression = expressions[i];
	      var pseudos = expression.pseudos;
	
	      // id awards a point in the second column
	      if (expression.id) { spec[1]++; }
	
	      // classes and attributes award a point each in the third column
	      if (expression.attributes) { spec[2] += expression.attributes.length; }
	      if (expression.classList) { spec[2] += expression.classList.length; }
	
	      // tag awards a point in the fourth column
	      if (expression.tag && expression.tag !== '*') { spec[3]++; }
	
	      // pseudos award a point each in the fourth column
	      if (pseudos) {
	        spec[3] += pseudos.length;
	
	        for (var p = 0; p < pseudos.length; p++) {
	          if (pseudos[p].name === 'not') {
	            nots.push(pseudos[p].value);
	            spec[3]--;
	          }
	        }
	      }
	    }
	
	    for (var ii = nots.length; ii--;) {
	      var not = specificity(nots[ii]);
	      for (var jj = 4; jj--;) { spec[jj] += not[jj]; }
	    }
	
	    return spec;
	  }
	};
	
	/**
	 * Parses a selector and returns the tokens.
	 *
	 * @param {String} selector
	 * @api private.
	 */
	
	function parse(text) {
	  try {
	    return parser(text)[0];
	  } catch (e) {
	    return [];
	  }
	}


/***/ },
/* 640 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Iterates over elements of `collection`, returning an array of all elements
	 * `predicate` returns truthy for. The predicate is invoked with three
	 * arguments: (value, index|key, collection).
	 *
	 * **Note:** Unlike `_.remove`, this method returns a new array.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity]
	 *  The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.reject
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': true },
	 *   { 'user': 'fred',   'age': 40, 'active': false }
	 * ];
	 *
	 * _.filter(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.filter(users, { 'age': 36, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.filter(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.filter(users, 'active');
	 * // => objects for ['barney']
	 */
	function filter(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = filter;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)(module)))

/***/ },
/* 641 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array ? array.length : 0;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	module.exports = flatten;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 642 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.map` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function baseMap(collection, iteratee) {
	  var index = -1,
	      result = isArrayLike(collection) ? Array(collection.length) : [];
	
	  baseEach(collection, function(value, key, collection) {
	    result[++index] = iteratee(value, key, collection);
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Creates an array of values by running each element in `collection` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
	 *
	 * The guarded methods are:
	 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
	 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
	 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
	 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 * @example
	 *
	 * function square(n) {
	 *   return n * n;
	 * }
	 *
	 * _.map([4, 8], square);
	 * // => [16, 64]
	 *
	 * _.map({ 'a': 4, 'b': 8 }, square);
	 * // => [16, 64] (iteration order is not guaranteed)
	 *
	 * var users = [
	 *   { 'user': 'barney' },
	 *   { 'user': 'fred' }
	 * ];
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.map(users, 'user');
	 * // => ['barney', 'fred']
	 */
	function map(collection, iteratee) {
	  var func = isArray(collection) ? arrayMap : baseMap;
	  return func(collection, baseIteratee(iteratee, 3));
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = map;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)(module)))

/***/ },
/* 643 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    symbolTag = '[object Symbol]';
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/**
	 * A faster alternative to `Function#apply`, this function invokes `func`
	 * with the `this` binding of `thisArg` and the arguments of `args`.
	 *
	 * @private
	 * @param {Function} func The function to invoke.
	 * @param {*} thisArg The `this` binding of `func`.
	 * @param {Array} args The arguments to invoke `func` with.
	 * @returns {*} Returns the result of `func`.
	 */
	function apply(func, thisArg, args) {
	  switch (args.length) {
	    case 0: return func.call(thisArg);
	    case 1: return func.call(thisArg, args[0]);
	    case 2: return func.call(thisArg, args[0], args[1]);
	    case 3: return func.call(thisArg, args[0], args[1], args[2]);
	  }
	  return func.apply(thisArg, args);
	}
	
	/**
	 * A specialized version of `_.map` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the new mapped array.
	 */
	function arrayMap(array, iteratee) {
	  var index = -1,
	      length = array ? array.length : 0,
	      result = Array(length);
	
	  while (++index < length) {
	    result[index] = iteratee(array[index], index, array);
	  }
	  return result;
	}
	
	/**
	 * Appends the elements of `values` to `array`.
	 *
	 * @private
	 * @param {Array} array The array to modify.
	 * @param {Array} values The values to append.
	 * @returns {Array} Returns `array`.
	 */
	function arrayPush(array, values) {
	  var index = -1,
	      length = values.length,
	      offset = array.length;
	
	  while (++index < length) {
	    array[offset + index] = values[index];
	  }
	  return array;
	}
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max;
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, props) {
	  object = Object(object);
	  return basePickBy(object, props, function(value, key) {
	    return key in object;
	  });
	}
	
	/**
	 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} props The property identifiers to pick from.
	 * @param {Function} predicate The function invoked per property.
	 * @returns {Object} Returns the new object.
	 */
	function basePickBy(object, props, predicate) {
	  var index = -1,
	      length = props.length,
	      result = {};
	
	  while (++index < length) {
	    var key = props[index],
	        value = object[key];
	
	    if (predicate(value, key)) {
	      result[key] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
	 *
	 * @private
	 * @param {Function} func The function to apply a rest parameter to.
	 * @param {number} [start=func.length-1] The start position of the rest parameter.
	 * @returns {Function} Returns the new function.
	 */
	function baseRest(func, start) {
	  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
	  return function() {
	    var args = arguments,
	        index = -1,
	        length = nativeMax(args.length - start, 0),
	        array = Array(length);
	
	    while (++index < length) {
	      array[index] = args[start + index];
	    }
	    index = -1;
	    var otherArgs = Array(start + 1);
	    while (++index < start) {
	      otherArgs[index] = args[index];
	    }
	    otherArgs[start] = array;
	    return apply(func, this, otherArgs);
	  };
	}
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [props] The property identifiers to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = baseRest(function(object, props) {
	  return object == null ? {} : basePick(object, arrayMap(baseFlatten(props, 1), toKey));
	});
	
	module.exports = pick;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 644 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.reduce` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @param {boolean} [initAccum] Specify using the first element of `array` as
	 *  the initial value.
	 * @returns {*} Returns the accumulated value.
	 */
	function arrayReduce(array, iteratee, accumulator, initAccum) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  if (initAccum && length) {
	    accumulator = array[++index];
	  }
	  while (++index < length) {
	    accumulator = iteratee(accumulator, array[index], index, array);
	  }
	  return accumulator;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.reduce` and `_.reduceRight`, without support
	 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {*} accumulator The initial value.
	 * @param {boolean} initAccum Specify using the first or last element of
	 *  `collection` as the initial value.
	 * @param {Function} eachFunc The function to iterate over `collection`.
	 * @returns {*} Returns the accumulated value.
	 */
	function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
	  eachFunc(collection, function(value, index, collection) {
	    accumulator = initAccum
	      ? (initAccum = false, value)
	      : iteratee(accumulator, value, index, collection);
	  });
	  return accumulator;
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Reduces `collection` to a value which is the accumulated result of running
	 * each element in `collection` thru `iteratee`, where each successive
	 * invocation is supplied the return value of the previous. If `accumulator`
	 * is not given, the first element of `collection` is used as the initial
	 * value. The iteratee is invoked with four arguments:
	 * (accumulator, value, index|key, collection).
	 *
	 * Many lodash methods are guarded to work as iteratees for methods like
	 * `_.reduce`, `_.reduceRight`, and `_.transform`.
	 *
	 * The guarded methods are:
	 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
	 * and `sortBy`
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The initial value.
	 * @returns {*} Returns the accumulated value.
	 * @see _.reduceRight
	 * @example
	 *
	 * _.reduce([1, 2], function(sum, n) {
	 *   return sum + n;
	 * }, 0);
	 * // => 3
	 *
	 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 *   return result;
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
	 */
	function reduce(collection, iteratee, accumulator) {
	  var func = isArray(collection) ? arrayReduce : baseReduce,
	      initAccum = arguments.length < 3;
	
	  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = reduce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)(module)))

/***/ },
/* 645 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.filter` for arrays without support for
	 * iteratee shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function arrayFilter(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0,
	      resIndex = 0,
	      result = [];
	
	  while (++index < length) {
	    var value = array[index];
	    if (predicate(value, index, array)) {
	      result[resIndex++] = value;
	    }
	  }
	  return result;
	}
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `_.filter` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 */
	function baseFilter(collection, predicate) {
	  var result = [];
	  baseEach(collection, function(value, index, collection) {
	    if (predicate(value, index, collection)) {
	      result.push(value);
	    }
	  });
	  return result;
	}
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * The opposite of `_.filter`; this method returns the elements of `collection`
	 * that `predicate` does **not** return truthy for.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {Array} Returns the new filtered array.
	 * @see _.filter
	 * @example
	 *
	 * var users = [
	 *   { 'user': 'barney', 'age': 36, 'active': false },
	 *   { 'user': 'fred',   'age': 40, 'active': true }
	 * ];
	 *
	 * _.reject(users, function(o) { return !o.active; });
	 * // => objects for ['fred']
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.reject(users, { 'age': 40, 'active': true });
	 * // => objects for ['barney']
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.reject(users, ['active', false]);
	 * // => objects for ['fred']
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.reject(users, 'active');
	 * // => objects for ['barney']
	 */
	function reject(collection, predicate) {
	  var func = isArray(collection) ? arrayFilter : baseFilter;
	  return func(collection, negate(baseIteratee(predicate, 3)));
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = reject;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)(module)))

/***/ },
/* 646 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used to compose bitmasks for comparison styles. */
	var UNORDERED_COMPARE_FLAG = 1,
	    PARTIAL_COMPARE_FLAG = 2;
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0,
	    MAX_SAFE_INTEGER = 9007199254740991;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    promiseTag = '[object Promise]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to match property names within property paths. */
	var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
	    reIsPlainProp = /^\w*$/,
	    reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used to detect unsigned integer values. */
	var reIsUint = /^(?:0|[1-9]\d*)$/;
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	/* Node.js helper references. */
	var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;
	
	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array ? array.length : 0;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	/**
	 * Checks if `value` is a host object in IE < 9.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a host object, else `false`.
	 */
	function isHostObject(value) {
	  // Many host objects are `Object` objects that can coerce to strings
	  // despite having improperly defined `toString` methods.
	  var result = false;
	  if (value != null && typeof value.toString != 'function') {
	    try {
	      result = !!(value + '');
	    } catch (e) {}
	  }
	  return result;
	}
	
	/**
	 * Converts `map` to its key-value pairs.
	 *
	 * @private
	 * @param {Object} map The map to convert.
	 * @returns {Array} Returns the key-value pairs.
	 */
	function mapToArray(map) {
	  var index = -1,
	      result = Array(map.size);
	
	  map.forEach(function(value, key) {
	    result[++index] = [key, value];
	  });
	  return result;
	}
	
	/**
	 * Creates a unary function that invokes `func` with its argument transformed.
	 *
	 * @private
	 * @param {Function} func The function to wrap.
	 * @param {Function} transform The argument transform.
	 * @returns {Function} Returns the new function.
	 */
	function overArg(func, transform) {
	  return function(arg) {
	    return func(transform(arg));
	  };
	}
	
	/**
	 * Converts `set` to an array of its values.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the values.
	 */
	function setToArray(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = value;
	  });
	  return result;
	}
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype,
	    funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/** Built-in value references. */
	var Symbol = root.Symbol,
	    Uint8Array = root.Uint8Array,
	    propertyIsEnumerable = objectProto.propertyIsEnumerable,
	    splice = arrayProto.splice;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView'),
	    Map = getNative(root, 'Map'),
	    Promise = getNative(root, 'Promise'),
	    Set = getNative(root, 'Set'),
	    WeakMap = getNative(root, 'WeakMap'),
	    nativeCreate = getNative(Object, 'create');
	
	/** Used to detect maps, sets, and weakmaps. */
	var dataViewCtorString = toSource(DataView),
	    mapCtorString = toSource(Map),
	    promiseCtorString = toSource(Promise),
	    setCtorString = toSource(Set),
	    weakMapCtorString = toSource(WeakMap);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	}
	
	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  return this.has(key) && delete this.__data__[key];
	}
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
	}
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	/**
	 * Creates an list cache object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function ListCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	}
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  return true;
	}
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	// Add methods to `ListCache`.
	ListCache.prototype.clear = listCacheClear;
	ListCache.prototype['delete'] = listCacheDelete;
	ListCache.prototype.get = listCacheGet;
	ListCache.prototype.has = listCacheHas;
	ListCache.prototype.set = listCacheSet;
	
	/**
	 * Creates a map cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function MapCache(entries) {
	  var index = -1,
	      length = entries ? entries.length : 0;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  return getMapData(this, key)['delete'](key);
	}
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  getMapData(this, key).set(key, value);
	  return this;
	}
	
	// Add methods to `MapCache`.
	MapCache.prototype.clear = mapCacheClear;
	MapCache.prototype['delete'] = mapCacheDelete;
	MapCache.prototype.get = mapCacheGet;
	MapCache.prototype.has = mapCacheHas;
	MapCache.prototype.set = mapCacheSet;
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values ? values.length : 0;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	/**
	 * Creates a stack cache object to store key-value pairs.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Stack(entries) {
	  this.__data__ = new ListCache(entries);
	}
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	}
	
	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  return this.__data__['delete'](key);
	}
	
	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var cache = this.__data__;
	  if (cache instanceof ListCache) {
	    var pairs = cache.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      return this;
	    }
	    cache = this.__data__ = new MapCache(pairs);
	  }
	  cache.set(key, value);
	  return this;
	}
	
	// Add methods to `Stack`.
	Stack.prototype.clear = stackClear;
	Stack.prototype['delete'] = stackDelete;
	Stack.prototype.get = stackGet;
	Stack.prototype.has = stackHas;
	Stack.prototype.set = stackSet;
	
	/**
	 * Creates an array of the enumerable property names of the array-like `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @param {boolean} inherited Specify returning inherited property names.
	 * @returns {Array} Returns the array of property names.
	 */
	function arrayLikeKeys(value, inherited) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  // Safari 9 makes `arguments.length` enumerable in strict mode.
	  var result = (isArray(value) || isArguments(value))
	    ? baseTimes(value.length, String)
	    : [];
	
	  var length = result.length,
	      skipIndexes = !!length;
	
	  for (var key in value) {
	    if ((inherited || hasOwnProperty.call(value, key)) &&
	        !(skipIndexes && (key == 'length' || isIndex(key, length)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * Gets the index at which the `key` is found in `array` of key-value pairs.
	 *
	 * @private
	 * @param {Array} array The array to inspect.
	 * @param {*} key The key to search for.
	 * @returns {number} Returns the index of the matched value, else `-1`.
	 */
	function assocIndexOf(array, key) {
	  var length = array.length;
	  while (length--) {
	    if (eq(array[length][0], key)) {
	      return length;
	    }
	  }
	  return -1;
	}
	
	/**
	 * The base implementation of `_.forEach` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array|Object} Returns `collection`.
	 */
	var baseEach = createBaseEach(baseForOwn);
	
	/**
	 * The base implementation of `baseForOwn` which iterates over `object`
	 * properties returned by `keysFunc` and invokes `iteratee` for each property.
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @param {Function} keysFunc The function to get the keys of `object`.
	 * @returns {Object} Returns `object`.
	 */
	var baseFor = createBaseFor();
	
	/**
	 * The base implementation of `_.forOwn` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 */
	function baseForOwn(object, iteratee) {
	  return object && baseFor(object, iteratee, keys);
	}
	
	/**
	 * The base implementation of `_.get` without support for default values.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @returns {*} Returns the resolved value.
	 */
	function baseGet(object, path) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var index = 0,
	      length = path.length;
	
	  while (object != null && index < length) {
	    object = object[toKey(path[index++])];
	  }
	  return (index && index == length) ? object : undefined;
	}
	
	/**
	 * The base implementation of `getTag`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	function baseGetTag(value) {
	  return objectToString.call(value);
	}
	
	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	/**
	 * The base implementation of `_.isEqual` which supports partial comparisons
	 * and tracks traversed objects.
	 *
	 * @private
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {boolean} [bitmask] The bitmask of comparison flags.
	 *  The bitmask may be composed of the following flags:
	 *     1 - Unordered comparison
	 *     2 - Partial comparison
	 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 */
	function baseIsEqual(value, other, customizer, bitmask, stack) {
	  if (value === other) {
	    return true;
	  }
	  if (value == null || other == null || (!isObject(value) && !isObjectLike(other))) {
	    return value !== value && other !== other;
	  }
	  return baseIsEqualDeep(value, other, baseIsEqual, customizer, bitmask, stack);
	}
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @param {number} [bitmask] The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, equalFunc, customizer, bitmask, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = arrayTag,
	      othTag = arrayTag;
	
	  if (!objIsArr) {
	    objTag = getTag(object);
	    objTag = objTag == argsTag ? objectTag : objTag;
	  }
	  if (!othIsArr) {
	    othTag = getTag(other);
	    othTag = othTag == argsTag ? objectTag : othTag;
	  }
	  var objIsObj = objTag == objectTag && !isHostObject(object),
	      othIsObj = othTag == objectTag && !isHostObject(other),
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, equalFunc, customizer, bitmask, stack)
	      : equalByTag(object, other, objTag, equalFunc, customizer, bitmask, stack);
	  }
	  if (!(bitmask & PARTIAL_COMPARE_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, customizer, bitmask, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, equalFunc, customizer, bitmask, stack);
	}
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, customizer, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = (isFunction(value) || isHostObject(value)) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[objectToString.call(value)];
	}
	
	/**
	 * The base implementation of `_.iteratee`.
	 *
	 * @private
	 * @param {*} [value=_.identity] The value to convert to an iteratee.
	 * @returns {Function} Returns the iteratee.
	 */
	function baseIteratee(value) {
	  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
	  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
	  if (typeof value == 'function') {
	    return value;
	  }
	  if (value == null) {
	    return identity;
	  }
	  if (typeof value == 'object') {
	    return isArray(value)
	      ? baseMatchesProperty(value[0], value[1])
	      : baseMatches(value);
	  }
	  return property(value);
	}
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, undefined, UNORDERED_COMPARE_FLAG | PARTIAL_COMPARE_FLAG);
	  };
	}
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	/**
	 * The base implementation of `_.some` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function baseSome(collection, predicate) {
	  var result;
	
	  baseEach(collection, function(value, index, collection) {
	    result = predicate(value, index, collection);
	    return !result;
	  });
	  return !!result;
	}
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Casts `value` to a path array if it's not one.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {Array} Returns the cast property path array.
	 */
	function castPath(value) {
	  return isArray(value) ? value : stringToPath(value);
	}
	
	/**
	 * Creates a `baseEach` or `baseEachRight` function.
	 *
	 * @private
	 * @param {Function} eachFunc The function to iterate over a collection.
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseEach(eachFunc, fromRight) {
	  return function(collection, iteratee) {
	    if (collection == null) {
	      return collection;
	    }
	    if (!isArrayLike(collection)) {
	      return eachFunc(collection, iteratee);
	    }
	    var length = collection.length,
	        index = fromRight ? length : -1,
	        iterable = Object(collection);
	
	    while ((fromRight ? index-- : ++index < length)) {
	      if (iteratee(iterable[index], index, iterable) === false) {
	        break;
	      }
	    }
	    return collection;
	  };
	}
	
	/**
	 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
	 *
	 * @private
	 * @param {boolean} [fromRight] Specify iterating from right to left.
	 * @returns {Function} Returns the new base function.
	 */
	function createBaseFor(fromRight) {
	  return function(object, iteratee, keysFunc) {
	    var index = -1,
	        iterable = Object(object),
	        props = keysFunc(object),
	        length = props.length;
	
	    while (length--) {
	      var key = props[fromRight ? length : ++index];
	      if (iteratee(iterable[key], key, iterable) === false) {
	        break;
	      }
	    }
	    return object;
	  };
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for arrays with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Array} array The array to compare.
	 * @param {Array} other The other array to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `array` and `other` objects.
	 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
	 */
	function equalArrays(array, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      arrLength = array.length,
	      othLength = other.length;
	
	  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
	    return false;
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(array);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var index = -1,
	      result = true,
	      seen = (bitmask & UNORDERED_COMPARE_FLAG) ? new SetCache : undefined;
	
	  stack.set(array, other);
	  stack.set(other, array);
	
	  // Ignore non-index properties.
	  while (++index < arrLength) {
	    var arrValue = array[index],
	        othValue = other[index];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, arrValue, index, other, array, stack)
	        : customizer(arrValue, othValue, index, array, other, stack);
	    }
	    if (compared !== undefined) {
	      if (compared) {
	        continue;
	      }
	      result = false;
	      break;
	    }
	    // Recursively compare arrays (susceptible to call stack limits).
	    if (seen) {
	      if (!arraySome(other, function(othValue, othIndex) {
	            if (!seen.has(othIndex) &&
	                (arrValue === othValue || equalFunc(arrValue, othValue, customizer, bitmask, stack))) {
	              return seen.add(othIndex);
	            }
	          })) {
	        result = false;
	        break;
	      }
	    } else if (!(
	          arrValue === othValue ||
	            equalFunc(arrValue, othValue, customizer, bitmask, stack)
	        )) {
	      result = false;
	      break;
	    }
	  }
	  stack['delete'](array);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, equalFunc, customizer, bitmask, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & PARTIAL_COMPARE_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= UNORDERED_COMPARE_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), equalFunc, customizer, bitmask, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {number} bitmask The bitmask of comparison flags. See `baseIsEqual`
	 *  for more details.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, equalFunc, customizer, bitmask, stack) {
	  var isPartial = bitmask & PARTIAL_COMPARE_FLAG,
	      objProps = keys(object),
	      objLength = objProps.length,
	      othProps = keys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, customizer, bitmask, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	/**
	 * Gets the data for `map`.
	 *
	 * @private
	 * @param {Object} map The map to query.
	 * @param {string} key The reference key.
	 * @returns {*} Returns the map data.
	 */
	function getMapData(map, key) {
	  var data = map.__data__;
	  return isKeyable(key)
	    ? data[typeof key == 'string' ? 'string' : 'hash']
	    : data.map;
	}
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	/**
	 * Gets the native function at `key` of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {string} key The key of the method to get.
	 * @returns {*} Returns the function if it's native, else `undefined`.
	 */
	function getNative(object, key) {
	  var value = getValue(object, key);
	  return baseIsNative(value) ? value : undefined;
	}
	
	/**
	 * Gets the `toStringTag` of `value`.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the `toStringTag`.
	 */
	var getTag = baseGetTag;
	
	// Fallback for data views, maps, sets, and weak maps in IE 11,
	// for data views in Edge < 14, and promises in Node.js.
	if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
	    (Map && getTag(new Map) != mapTag) ||
	    (Promise && getTag(Promise.resolve()) != promiseTag) ||
	    (Set && getTag(new Set) != setTag) ||
	    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
	  getTag = function(value) {
	    var result = objectToString.call(value),
	        Ctor = result == objectTag ? value.constructor : undefined,
	        ctorString = Ctor ? toSource(Ctor) : undefined;
	
	    if (ctorString) {
	      switch (ctorString) {
	        case dataViewCtorString: return dataViewTag;
	        case mapCtorString: return mapTag;
	        case promiseCtorString: return promiseTag;
	        case setCtorString: return setTag;
	        case weakMapCtorString: return weakMapTag;
	      }
	    }
	    return result;
	  };
	}
	
	/**
	 * Checks if `path` exists on `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @param {Function} hasFunc The function to check properties.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 */
	function hasPath(object, path, hasFunc) {
	  path = isKey(path, object) ? [path] : castPath(path);
	
	  var result,
	      index = -1,
	      length = path.length;
	
	  while (++index < length) {
	    var key = toKey(path[index]);
	    if (!(result = object != null && hasFunc(object, key))) {
	      break;
	    }
	    object = object[key];
	  }
	  if (result) {
	    return result;
	  }
	  var length = object ? object.length : 0;
	  return !!length && isLength(length) && isIndex(key, length) &&
	    (isArray(object) || isArguments(object));
	}
	
	/**
	 * Checks if `value` is a valid array-like index.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
	 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
	 */
	function isIndex(value, length) {
	  length = length == null ? MAX_SAFE_INTEGER : length;
	  return !!length &&
	    (typeof value == 'number' || reIsUint.test(value)) &&
	    (value > -1 && value % 1 == 0 && value < length);
	}
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	/**
	 * Checks if `value` is a property name and not a property path.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @param {Object} [object] The object to query keys on.
	 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
	 */
	function isKey(value, object) {
	  if (isArray(value)) {
	    return false;
	  }
	  var type = typeof value;
	  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
	      value == null || isSymbol(value)) {
	    return true;
	  }
	  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
	    (object != null && value in Object(object));
	}
	
	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	/**
	 * Checks if `value` is likely a prototype object.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
	 */
	function isPrototype(value) {
	  var Ctor = value && value.constructor,
	      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;
	
	  return value === proto;
	}
	
	/**
	 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` if suitable for strict
	 *  equality comparisons, else `false`.
	 */
	function isStrictComparable(value) {
	  return value === value && !isObject(value);
	}
	
	/**
	 * A specialized version of `matchesProperty` for source values suitable
	 * for strict equality comparisons, i.e. `===`.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function matchesStrictComparable(key, srcValue) {
	  return function(object) {
	    if (object == null) {
	      return false;
	    }
	    return object[key] === srcValue &&
	      (srcValue !== undefined || (key in Object(object)));
	  };
	}
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoize(function(string) {
	  string = toString(string);
	
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	/**
	 * Converts `value` to a string key if it's not a string or symbol.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @returns {string|symbol} Returns the key.
	 */
	function toKey(value) {
	  if (typeof value == 'string' || isSymbol(value)) {
	    return value;
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	/**
	 * Converts `func` to its source code.
	 *
	 * @private
	 * @param {Function} func The function to process.
	 * @returns {string} Returns the source code.
	 */
	function toSource(func) {
	  if (func != null) {
	    try {
	      return funcToString.call(func);
	    } catch (e) {}
	    try {
	      return (func + '');
	    } catch (e) {}
	  }
	  return '';
	}
	
	/**
	 * Checks if `predicate` returns truthy for **any** element of `collection`.
	 * Iteration is stopped once `predicate` returns truthy. The predicate is
	 * invoked with three arguments: (value, index|key, collection).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Collection
	 * @param {Array|Object} collection The collection to iterate over.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 * @example
	 *
	 * _.some([null, 0, 'yes', false], Boolean);
	 * // => true
	 *
	 * var users = [
	 *   { 'user': 'barney', 'active': true },
	 *   { 'user': 'fred',   'active': false }
	 * ];
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.some(users, { 'user': 'barney', 'active': false });
	 * // => false
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.some(users, ['active', false]);
	 * // => true
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.some(users, 'active');
	 * // => true
	 */
	function some(collection, predicate, guard) {
	  var func = isArray(collection) ? arraySome : baseSome;
	  if (guard && isIterateeCall(collection, predicate, guard)) {
	    predicate = undefined;
	  }
	  return func(collection, baseIteratee(predicate, 3));
	}
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result);
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Assign cache to `_.memoize`.
	memoize.Cache = MapCache;
	
	/**
	 * Performs a
	 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
	 * comparison between two values to determine if they are equivalent.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to compare.
	 * @param {*} other The other value to compare.
	 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 * var other = { 'a': 1 };
	 *
	 * _.eq(object, object);
	 * // => true
	 *
	 * _.eq(object, other);
	 * // => false
	 *
	 * _.eq('a', 'a');
	 * // => true
	 *
	 * _.eq('a', Object('a'));
	 * // => false
	 *
	 * _.eq(NaN, NaN);
	 * // => true
	 */
	function eq(value, other) {
	  return value === other || (value !== value && other !== other);
	}
	
	/**
	 * Checks if `value` is likely an `arguments` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArguments(function() { return arguments; }());
	 * // => true
	 *
	 * _.isArguments([1, 2, 3]);
	 * // => false
	 */
	function isArguments(value) {
	  // Safari 8.1 makes `arguments.callee` enumerable in strict mode.
	  return isArrayLikeObject(value) && hasOwnProperty.call(value, 'callee') &&
	    (!propertyIsEnumerable.call(value, 'callee') || objectToString.call(value) == argsTag);
	}
	
	/**
	 * Checks if `value` is classified as an `Array` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
	 * @example
	 *
	 * _.isArray([1, 2, 3]);
	 * // => true
	 *
	 * _.isArray(document.body.children);
	 * // => false
	 *
	 * _.isArray('abc');
	 * // => false
	 *
	 * _.isArray(_.noop);
	 * // => false
	 */
	var isArray = Array.isArray;
	
	/**
	 * Checks if `value` is array-like. A value is considered array-like if it's
	 * not a function and has a `value.length` that's an integer greater than or
	 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
	 * @example
	 *
	 * _.isArrayLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLike(document.body.children);
	 * // => true
	 *
	 * _.isArrayLike('abc');
	 * // => true
	 *
	 * _.isArrayLike(_.noop);
	 * // => false
	 */
	function isArrayLike(value) {
	  return value != null && isLength(value.length) && !isFunction(value);
	}
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	/**
	 * Checks if `value` is classified as a `Function` object.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
	 * @example
	 *
	 * _.isFunction(_);
	 * // => true
	 *
	 * _.isFunction(/abc/);
	 * // => false
	 */
	function isFunction(value) {
	  // The use of `Object#toString` avoids issues with the `typeof` operator
	  // in Safari 8-9 which returns 'object' for typed array and other constructors.
	  var tag = isObject(value) ? objectToString.call(value) : '';
	  return tag == funcTag || tag == genTag;
	}
	
	/**
	 * Checks if `value` is a valid array-like length.
	 *
	 * **Note:** This method is loosely based on
	 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
	 * @example
	 *
	 * _.isLength(3);
	 * // => true
	 *
	 * _.isLength(Number.MIN_VALUE);
	 * // => false
	 *
	 * _.isLength(Infinity);
	 * // => false
	 *
	 * _.isLength('3');
	 * // => false
	 */
	function isLength(value) {
	  return typeof value == 'number' &&
	    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Checks if `value` is classified as a typed array.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 * @example
	 *
	 * _.isTypedArray(new Uint8Array);
	 * // => true
	 *
	 * _.isTypedArray([]);
	 * // => false
	 */
	var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	/**
	 * Gets the value at `path` of `object`. If the resolved value is
	 * `undefined`, the `defaultValue` is returned in its place.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to get.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.get(object, 'a[0].b.c');
	 * // => 3
	 *
	 * _.get(object, ['a', '0', 'b', 'c']);
	 * // => 3
	 *
	 * _.get(object, 'a.b.c', 'default');
	 * // => 'default'
	 */
	function get(object, path, defaultValue) {
	  var result = object == null ? undefined : baseGet(object, path);
	  return result === undefined ? defaultValue : result;
	}
	
	/**
	 * Checks if `path` is a direct or inherited property of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.hasIn(object, 'a');
	 * // => true
	 *
	 * _.hasIn(object, 'a.b');
	 * // => true
	 *
	 * _.hasIn(object, ['a', 'b']);
	 * // => true
	 *
	 * _.hasIn(object, 'b');
	 * // => false
	 */
	function hasIn(object, path) {
	  return object != null && hasPath(object, path, baseHasIn);
	}
	
	/**
	 * Creates an array of the own enumerable property names of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects. See the
	 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * for more details.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.keys(new Foo);
	 * // => ['a', 'b'] (iteration order is not guaranteed)
	 *
	 * _.keys('hi');
	 * // => ['0', '1']
	 */
	function keys(object) {
	  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
	}
	
	/**
	 * This method returns the first argument it receives.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Util
	 * @param {*} value Any value.
	 * @returns {*} Returns `value`.
	 * @example
	 *
	 * var object = { 'a': 1 };
	 *
	 * console.log(_.identity(object) === object);
	 * // => true
	 */
	function identity(value) {
	  return value;
	}
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = some;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)(module)))

/***/ },
/* 647 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Creates a throttled function that only invokes `func` at most once per
	 * every `wait` milliseconds. The throttled function comes with a `cancel`
	 * method to cancel delayed `func` invocations and a `flush` method to
	 * immediately invoke them. Provide `options` to indicate whether `func`
	 * should be invoked on the leading and/or trailing edge of the `wait`
	 * timeout. The `func` is invoked with the last arguments provided to the
	 * throttled function. Subsequent calls to the throttled function return the
	 * result of the last `func` invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the throttled function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.throttle` and `_.debounce`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to throttle.
	 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=true]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new throttled function.
	 * @example
	 *
	 * // Avoid excessively updating the position while scrolling.
	 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
	 *
	 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
	 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
	 * jQuery(element).on('click', throttled);
	 *
	 * // Cancel the trailing throttled invocation.
	 * jQuery(window).on('popstate', throttled.cancel);
	 */
	function throttle(func, wait, options) {
	  var leading = true,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  if (isObject(options)) {
	    leading = 'leading' in options ? !!options.leading : leading;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	  return debounce(func, wait, {
	    'leading': leading,
	    'maxWait': wait,
	    'trailing': trailing
	  });
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = throttle;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 648 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(61),
	    root = __webpack_require__(41);
	
	/* Built-in method references that are verified to be native. */
	var DataView = getNative(root, 'DataView');
	
	module.exports = DataView;


/***/ },
/* 649 */
/***/ function(module, exports, __webpack_require__) {

	var hashClear = __webpack_require__(701),
	    hashDelete = __webpack_require__(702),
	    hashGet = __webpack_require__(703),
	    hashHas = __webpack_require__(704),
	    hashSet = __webpack_require__(705);
	
	/**
	 * Creates a hash object.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [entries] The key-value pairs to cache.
	 */
	function Hash(entries) {
	  var index = -1,
	      length = entries == null ? 0 : entries.length;
	
	  this.clear();
	  while (++index < length) {
	    var entry = entries[index];
	    this.set(entry[0], entry[1]);
	  }
	}
	
	// Add methods to `Hash`.
	Hash.prototype.clear = hashClear;
	Hash.prototype['delete'] = hashDelete;
	Hash.prototype.get = hashGet;
	Hash.prototype.has = hashHas;
	Hash.prototype.set = hashSet;
	
	module.exports = Hash;


/***/ },
/* 650 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(61),
	    root = __webpack_require__(41);
	
	/* Built-in method references that are verified to be native. */
	var Promise = getNative(root, 'Promise');
	
	module.exports = Promise;


/***/ },
/* 651 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(61),
	    root = __webpack_require__(41);
	
	/* Built-in method references that are verified to be native. */
	var Set = getNative(root, 'Set');
	
	module.exports = Set;


/***/ },
/* 652 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(194),
	    setCacheAdd = __webpack_require__(727),
	    setCacheHas = __webpack_require__(728);
	
	/**
	 *
	 * Creates an array cache object to store unique values.
	 *
	 * @private
	 * @constructor
	 * @param {Array} [values] The values to cache.
	 */
	function SetCache(values) {
	  var index = -1,
	      length = values == null ? 0 : values.length;
	
	  this.__data__ = new MapCache;
	  while (++index < length) {
	    this.add(values[index]);
	  }
	}
	
	// Add methods to `SetCache`.
	SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
	SetCache.prototype.has = setCacheHas;
	
	module.exports = SetCache;


/***/ },
/* 653 */
/***/ function(module, exports, __webpack_require__) {

	var getNative = __webpack_require__(61),
	    root = __webpack_require__(41);
	
	/* Built-in method references that are verified to be native. */
	var WeakMap = getNative(root, 'WeakMap');
	
	module.exports = WeakMap;


/***/ },
/* 654 */
/***/ function(module, exports) {

	/**
	 * Adds the key-value `pair` to `map`.
	 *
	 * @private
	 * @param {Object} map The map to modify.
	 * @param {Array} pair The key-value pair to add.
	 * @returns {Object} Returns `map`.
	 */
	function addMapEntry(map, pair) {
	  // Don't return `map.set` because it's not chainable in IE 11.
	  map.set(pair[0], pair[1]);
	  return map;
	}
	
	module.exports = addMapEntry;


/***/ },
/* 655 */
/***/ function(module, exports) {

	/**
	 * Adds `value` to `set`.
	 *
	 * @private
	 * @param {Object} set The set to modify.
	 * @param {*} value The value to add.
	 * @returns {Object} Returns `set`.
	 */
	function addSetEntry(set, value) {
	  // Don't return `set.add` because it's not chainable in IE 11.
	  set.add(value);
	  return set;
	}
	
	module.exports = addSetEntry;


/***/ },
/* 656 */
/***/ function(module, exports) {

	/**
	 * A specialized version of `_.some` for arrays without support for iteratee
	 * shorthands.
	 *
	 * @private
	 * @param {Array} [array] The array to iterate over.
	 * @param {Function} predicate The function invoked per iteration.
	 * @returns {boolean} Returns `true` if any element passes the predicate check,
	 *  else `false`.
	 */
	function arraySome(array, predicate) {
	  var index = -1,
	      length = array == null ? 0 : array.length;
	
	  while (++index < length) {
	    if (predicate(array[index], index, array)) {
	      return true;
	    }
	  }
	  return false;
	}
	
	module.exports = arraySome;


/***/ },
/* 657 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    keysIn = __webpack_require__(31);
	
	/**
	 * The base implementation of `_.assignIn` without support for multiple sources
	 * or `customizer` functions.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @returns {Object} Returns `object`.
	 */
	function baseAssignIn(object, source) {
	  return object && copyObject(source, keysIn(source), object);
	}
	
	module.exports = baseAssignIn;


/***/ },
/* 658 */
/***/ function(module, exports, __webpack_require__) {

	var get = __webpack_require__(207);
	
	/**
	 * The base implementation of `_.at` without support for individual paths.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Array} Returns the picked elements.
	 */
	function baseAt(object, paths) {
	  var index = -1,
	      length = paths.length,
	      result = Array(length),
	      skip = object == null;
	
	  while (++index < length) {
	    result[index] = skip ? undefined : get(object, paths[index]);
	  }
	  return result;
	}
	
	module.exports = baseAt;


/***/ },
/* 659 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(135),
	    arrayEach = __webpack_require__(299),
	    assignValue = __webpack_require__(137),
	    baseAssign = __webpack_require__(304),
	    baseAssignIn = __webpack_require__(657),
	    cloneBuffer = __webpack_require__(315),
	    copyArray = __webpack_require__(317),
	    copySymbols = __webpack_require__(690),
	    copySymbolsIn = __webpack_require__(691),
	    getAllKeys = __webpack_require__(324),
	    getAllKeysIn = __webpack_require__(201),
	    getTag = __webpack_require__(203),
	    initCloneArray = __webpack_require__(706),
	    initCloneByTag = __webpack_require__(707),
	    initCloneObject = __webpack_require__(327),
	    isArray = __webpack_require__(28),
	    isBuffer = __webpack_require__(111),
	    isObject = __webpack_require__(29),
	    keys = __webpack_require__(30);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    genTag = '[object GeneratorFunction]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values supported by `_.clone`. */
	var cloneableTags = {};
	cloneableTags[argsTag] = cloneableTags[arrayTag] =
	cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
	cloneableTags[boolTag] = cloneableTags[dateTag] =
	cloneableTags[float32Tag] = cloneableTags[float64Tag] =
	cloneableTags[int8Tag] = cloneableTags[int16Tag] =
	cloneableTags[int32Tag] = cloneableTags[mapTag] =
	cloneableTags[numberTag] = cloneableTags[objectTag] =
	cloneableTags[regexpTag] = cloneableTags[setTag] =
	cloneableTags[stringTag] = cloneableTags[symbolTag] =
	cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
	cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
	cloneableTags[errorTag] = cloneableTags[funcTag] =
	cloneableTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
	 * traversed objects.
	 *
	 * @private
	 * @param {*} value The value to clone.
	 * @param {boolean} bitmask The bitmask flags.
	 *  1 - Deep clone
	 *  2 - Flatten inherited properties
	 *  4 - Clone symbols
	 * @param {Function} [customizer] The function to customize cloning.
	 * @param {string} [key] The key of `value`.
	 * @param {Object} [object] The parent object of `value`.
	 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
	 * @returns {*} Returns the cloned value.
	 */
	function baseClone(value, bitmask, customizer, key, object, stack) {
	  var result,
	      isDeep = bitmask & CLONE_DEEP_FLAG,
	      isFlat = bitmask & CLONE_FLAT_FLAG,
	      isFull = bitmask & CLONE_SYMBOLS_FLAG;
	
	  if (customizer) {
	    result = object ? customizer(value, key, object, stack) : customizer(value);
	  }
	  if (result !== undefined) {
	    return result;
	  }
	  if (!isObject(value)) {
	    return value;
	  }
	  var isArr = isArray(value);
	  if (isArr) {
	    result = initCloneArray(value);
	    if (!isDeep) {
	      return copyArray(value, result);
	    }
	  } else {
	    var tag = getTag(value),
	        isFunc = tag == funcTag || tag == genTag;
	
	    if (isBuffer(value)) {
	      return cloneBuffer(value, isDeep);
	    }
	    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
	      result = (isFlat || isFunc) ? {} : initCloneObject(value);
	      if (!isDeep) {
	        return isFlat
	          ? copySymbolsIn(value, baseAssignIn(result, value))
	          : copySymbols(value, baseAssign(result, value));
	      }
	    } else {
	      if (!cloneableTags[tag]) {
	        return object ? value : {};
	      }
	      result = initCloneByTag(value, tag, baseClone, isDeep);
	    }
	  }
	  // Check for circular references and return its corresponding clone.
	  stack || (stack = new Stack);
	  var stacked = stack.get(value);
	  if (stacked) {
	    return stacked;
	  }
	  stack.set(value, result);
	
	  var keysFunc = isFull
	    ? (isFlat ? getAllKeysIn : getAllKeys)
	    : (isFlat ? keysIn : keys);
	
	  var props = isArr ? undefined : keysFunc(value);
	  arrayEach(props || value, function(subValue, key) {
	    if (props) {
	      key = subValue;
	      subValue = value[key];
	    }
	    // Recursively populate clone (susceptible to call stack limits).
	    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
	  });
	  return result;
	}
	
	module.exports = baseClone;


/***/ },
/* 660 */
/***/ function(module, exports, __webpack_require__) {

	var arrayPush = __webpack_require__(195),
	    isFlattenable = __webpack_require__(708);
	
	/**
	 * The base implementation of `_.flatten` with support for restricting flattening.
	 *
	 * @private
	 * @param {Array} array The array to flatten.
	 * @param {number} depth The maximum recursion depth.
	 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
	 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
	 * @param {Array} [result=[]] The initial result value.
	 * @returns {Array} Returns the new flattened array.
	 */
	function baseFlatten(array, depth, predicate, isStrict, result) {
	  var index = -1,
	      length = array.length;
	
	  predicate || (predicate = isFlattenable);
	  result || (result = []);
	
	  while (++index < length) {
	    var value = array[index];
	    if (depth > 0 && predicate(value)) {
	      if (depth > 1) {
	        // Recursively flatten arrays (susceptible to call stack limits).
	        baseFlatten(value, depth - 1, predicate, isStrict, result);
	      } else {
	        arrayPush(result, value);
	      }
	    } else if (!isStrict) {
	      result[result.length] = value;
	    }
	  }
	  return result;
	}
	
	module.exports = baseFlatten;


/***/ },
/* 661 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.has` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHas(object, key) {
	  return object != null && hasOwnProperty.call(object, key);
	}
	
	module.exports = baseHas;


/***/ },
/* 662 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.hasIn` without support for deep paths.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {Array|string} key The key to check.
	 * @returns {boolean} Returns `true` if `key` exists, else `false`.
	 */
	function baseHasIn(object, key) {
	  return object != null && key in Object(object);
	}
	
	module.exports = baseHasIn;


/***/ },
/* 663 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(80);
	
	/**
	 * The base implementation of `_.invert` and `_.invertBy` which inverts
	 * `object` with values transformed by `iteratee` and set by `setter`.
	 *
	 * @private
	 * @param {Object} object The object to iterate over.
	 * @param {Function} setter The function to set `accumulator` values.
	 * @param {Function} iteratee The iteratee to transform values.
	 * @param {Object} accumulator The initial inverted object.
	 * @returns {Function} Returns `accumulator`.
	 */
	function baseInverter(object, setter, iteratee, accumulator) {
	  baseForOwn(object, function(value, key, object) {
	    setter(accumulator, iteratee(value), key, object);
	  });
	  return accumulator;
	}
	
	module.exports = baseInverter;


/***/ },
/* 664 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(136),
	    castPath = __webpack_require__(51),
	    last = __webpack_require__(338),
	    parent = __webpack_require__(332),
	    toKey = __webpack_require__(52);
	
	/**
	 * The base implementation of `_.invoke` without support for individual
	 * method arguments.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {Array} args The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 */
	function baseInvoke(object, path, args) {
	  path = castPath(path, object);
	  object = parent(object, path);
	  var func = object == null ? object : object[toKey(last(path))];
	  return func == null ? undefined : apply(func, object, args);
	}
	
	module.exports = baseInvoke;


/***/ },
/* 665 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(81),
	    isObjectLike = __webpack_require__(62);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]';
	
	/**
	 * The base implementation of `_.isArguments`.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
	 */
	function baseIsArguments(value) {
	  return isObjectLike(value) && baseGetTag(value) == argsTag;
	}
	
	module.exports = baseIsArguments;


/***/ },
/* 666 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(135),
	    equalArrays = __webpack_require__(322),
	    equalByTag = __webpack_require__(696),
	    equalObjects = __webpack_require__(697),
	    getTag = __webpack_require__(203),
	    isArray = __webpack_require__(28),
	    isBuffer = __webpack_require__(111),
	    isTypedArray = __webpack_require__(147);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    objectTag = '[object Object]';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqual` for arrays and objects which performs
	 * deep comparisons and tracks traversed objects enabling objects with circular
	 * references to be compared.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
	  var objIsArr = isArray(object),
	      othIsArr = isArray(other),
	      objTag = objIsArr ? arrayTag : getTag(object),
	      othTag = othIsArr ? arrayTag : getTag(other);
	
	  objTag = objTag == argsTag ? objectTag : objTag;
	  othTag = othTag == argsTag ? objectTag : othTag;
	
	  var objIsObj = objTag == objectTag,
	      othIsObj = othTag == objectTag,
	      isSameTag = objTag == othTag;
	
	  if (isSameTag && isBuffer(object)) {
	    if (!isBuffer(other)) {
	      return false;
	    }
	    objIsArr = true;
	    objIsObj = false;
	  }
	  if (isSameTag && !objIsObj) {
	    stack || (stack = new Stack);
	    return (objIsArr || isTypedArray(object))
	      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
	      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
	  }
	  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
	    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
	        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
	
	    if (objIsWrapped || othIsWrapped) {
	      var objUnwrapped = objIsWrapped ? object.value() : object,
	          othUnwrapped = othIsWrapped ? other.value() : other;
	
	      stack || (stack = new Stack);
	      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
	    }
	  }
	  if (!isSameTag) {
	    return false;
	  }
	  stack || (stack = new Stack);
	  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
	}
	
	module.exports = baseIsEqualDeep;


/***/ },
/* 667 */
/***/ function(module, exports, __webpack_require__) {

	var Stack = __webpack_require__(135),
	    baseIsEqual = __webpack_require__(310);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.isMatch` without support for iteratee shorthands.
	 *
	 * @private
	 * @param {Object} object The object to inspect.
	 * @param {Object} source The object of property values to match.
	 * @param {Array} matchData The property names, values, and compare flags to match.
	 * @param {Function} [customizer] The function to customize comparisons.
	 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
	 */
	function baseIsMatch(object, source, matchData, customizer) {
	  var index = matchData.length,
	      length = index,
	      noCustomizer = !customizer;
	
	  if (object == null) {
	    return !length;
	  }
	  object = Object(object);
	  while (index--) {
	    var data = matchData[index];
	    if ((noCustomizer && data[2])
	          ? data[1] !== object[data[0]]
	          : !(data[0] in object)
	        ) {
	      return false;
	    }
	  }
	  while (++index < length) {
	    data = matchData[index];
	    var key = data[0],
	        objValue = object[key],
	        srcValue = data[1];
	
	    if (noCustomizer && data[2]) {
	      if (objValue === undefined && !(key in object)) {
	        return false;
	      }
	    } else {
	      var stack = new Stack;
	      if (customizer) {
	        var result = customizer(objValue, srcValue, key, object, source, stack);
	      }
	      if (!(result === undefined
	            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
	            : result
	          )) {
	        return false;
	      }
	    }
	  }
	  return true;
	}
	
	module.exports = baseIsMatch;


/***/ },
/* 668 */
/***/ function(module, exports, __webpack_require__) {

	var isFunction = __webpack_require__(85),
	    isMasked = __webpack_require__(711),
	    isObject = __webpack_require__(29),
	    toSource = __webpack_require__(335);
	
	/**
	 * Used to match `RegExp`
	 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
	 */
	var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
	
	/** Used to detect host constructors (Safari). */
	var reIsHostCtor = /^\[object .+?Constructor\]$/;
	
	/** Used for built-in method references. */
	var funcProto = Function.prototype,
	    objectProto = Object.prototype;
	
	/** Used to resolve the decompiled source of functions. */
	var funcToString = funcProto.toString;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/** Used to detect if a method is native. */
	var reIsNative = RegExp('^' +
	  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
	  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
	);
	
	/**
	 * The base implementation of `_.isNative` without bad shim checks.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a native function,
	 *  else `false`.
	 */
	function baseIsNative(value) {
	  if (!isObject(value) || isMasked(value)) {
	    return false;
	  }
	  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
	  return pattern.test(toSource(value));
	}
	
	module.exports = baseIsNative;


/***/ },
/* 669 */
/***/ function(module, exports, __webpack_require__) {

	var baseGetTag = __webpack_require__(81),
	    isLength = __webpack_require__(209),
	    isObjectLike = __webpack_require__(62);
	
	/** `Object#toString` result references. */
	var argsTag = '[object Arguments]',
	    arrayTag = '[object Array]',
	    boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    funcTag = '[object Function]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    objectTag = '[object Object]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    weakMapTag = '[object WeakMap]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/** Used to identify `toStringTag` values of typed arrays. */
	var typedArrayTags = {};
	typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
	typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
	typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
	typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
	typedArrayTags[uint32Tag] = true;
	typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
	typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
	typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
	typedArrayTags[errorTag] = typedArrayTags[funcTag] =
	typedArrayTags[mapTag] = typedArrayTags[numberTag] =
	typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
	typedArrayTags[setTag] = typedArrayTags[stringTag] =
	typedArrayTags[weakMapTag] = false;
	
	/**
	 * The base implementation of `_.isTypedArray` without Node.js optimizations.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
	 */
	function baseIsTypedArray(value) {
	  return isObjectLike(value) &&
	    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
	}
	
	module.exports = baseIsTypedArray;


/***/ },
/* 670 */
/***/ function(module, exports, __webpack_require__) {

	var isPrototype = __webpack_require__(144),
	    nativeKeys = __webpack_require__(723);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeys(object) {
	  if (!isPrototype(object)) {
	    return nativeKeys(object);
	  }
	  var result = [];
	  for (var key in Object(object)) {
	    if (hasOwnProperty.call(object, key) && key != 'constructor') {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeys;


/***/ },
/* 671 */
/***/ function(module, exports, __webpack_require__) {

	var isObject = __webpack_require__(29),
	    isPrototype = __webpack_require__(144),
	    nativeKeysIn = __webpack_require__(724);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function baseKeysIn(object) {
	  if (!isObject(object)) {
	    return nativeKeysIn(object);
	  }
	  var isProto = isPrototype(object),
	      result = [];
	
	  for (var key in object) {
	    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = baseKeysIn;


/***/ },
/* 672 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsMatch = __webpack_require__(667),
	    getMatchData = __webpack_require__(698),
	    matchesStrictComparable = __webpack_require__(329);
	
	/**
	 * The base implementation of `_.matches` which doesn't clone `source`.
	 *
	 * @private
	 * @param {Object} source The object of property values to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatches(source) {
	  var matchData = getMatchData(source);
	  if (matchData.length == 1 && matchData[0][2]) {
	    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
	  }
	  return function(object) {
	    return object === source || baseIsMatch(object, source, matchData);
	  };
	}
	
	module.exports = baseMatches;


/***/ },
/* 673 */
/***/ function(module, exports, __webpack_require__) {

	var baseIsEqual = __webpack_require__(310),
	    get = __webpack_require__(207),
	    hasIn = __webpack_require__(208),
	    isKey = __webpack_require__(204),
	    isStrictComparable = __webpack_require__(328),
	    matchesStrictComparable = __webpack_require__(329),
	    toKey = __webpack_require__(52);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/**
	 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
	 *
	 * @private
	 * @param {string} path The path of the property to get.
	 * @param {*} srcValue The value to match.
	 * @returns {Function} Returns the new spec function.
	 */
	function baseMatchesProperty(path, srcValue) {
	  if (isKey(path) && isStrictComparable(srcValue)) {
	    return matchesStrictComparable(toKey(path), srcValue);
	  }
	  return function(object) {
	    var objValue = get(object, path);
	    return (objValue === undefined && objValue === srcValue)
	      ? hasIn(object, path)
	      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
	  };
	}
	
	module.exports = baseMatchesProperty;


/***/ },
/* 674 */
/***/ function(module, exports, __webpack_require__) {

	var assignMergeValue = __webpack_require__(303),
	    cloneBuffer = __webpack_require__(315),
	    cloneTypedArray = __webpack_require__(316),
	    copyArray = __webpack_require__(317),
	    initCloneObject = __webpack_require__(327),
	    isArguments = __webpack_require__(146),
	    isArray = __webpack_require__(28),
	    isArrayLikeObject = __webpack_require__(760),
	    isBuffer = __webpack_require__(111),
	    isFunction = __webpack_require__(85),
	    isObject = __webpack_require__(29),
	    isPlainObject = __webpack_require__(112),
	    isTypedArray = __webpack_require__(147),
	    toPlainObject = __webpack_require__(774);
	
	/**
	 * A specialized version of `baseMerge` for arrays and objects which performs
	 * deep merges and tracks traversed objects enabling objects with circular
	 * references to be merged.
	 *
	 * @private
	 * @param {Object} object The destination object.
	 * @param {Object} source The source object.
	 * @param {string} key The key of the value to merge.
	 * @param {number} srcIndex The index of `source`.
	 * @param {Function} mergeFunc The function to merge values.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 */
	function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
	  var objValue = object[key],
	      srcValue = source[key],
	      stacked = stack.get(srcValue);
	
	  if (stacked) {
	    assignMergeValue(object, key, stacked);
	    return;
	  }
	  var newValue = customizer
	    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
	    : undefined;
	
	  var isCommon = newValue === undefined;
	
	  if (isCommon) {
	    var isArr = isArray(srcValue),
	        isBuff = !isArr && isBuffer(srcValue),
	        isTyped = !isArr && !isBuff && isTypedArray(srcValue);
	
	    newValue = srcValue;
	    if (isArr || isBuff || isTyped) {
	      if (isArray(objValue)) {
	        newValue = objValue;
	      }
	      else if (isArrayLikeObject(objValue)) {
	        newValue = copyArray(objValue);
	      }
	      else if (isBuff) {
	        isCommon = false;
	        newValue = cloneBuffer(srcValue, true);
	      }
	      else if (isTyped) {
	        isCommon = false;
	        newValue = cloneTypedArray(srcValue, true);
	      }
	      else {
	        newValue = [];
	      }
	    }
	    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
	      newValue = objValue;
	      if (isArguments(objValue)) {
	        newValue = toPlainObject(objValue);
	      }
	      else if (!isObject(objValue) || (srcIndex && isFunction(objValue))) {
	        newValue = initCloneObject(srcValue);
	      }
	    }
	    else {
	      isCommon = false;
	    }
	  }
	  if (isCommon) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, newValue);
	    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
	    stack['delete'](srcValue);
	  }
	  assignMergeValue(object, key, newValue);
	}
	
	module.exports = baseMergeDeep;


/***/ },
/* 675 */
/***/ function(module, exports, __webpack_require__) {

	var basePickBy = __webpack_require__(311),
	    hasIn = __webpack_require__(208);
	
	/**
	 * The base implementation of `_.pick` without support for individual
	 * property identifiers.
	 *
	 * @private
	 * @param {Object} object The source object.
	 * @param {string[]} paths The property paths to pick.
	 * @returns {Object} Returns the new object.
	 */
	function basePick(object, paths) {
	  return basePickBy(object, paths, function(value, path) {
	    return hasIn(object, path);
	  });
	}
	
	module.exports = basePick;


/***/ },
/* 676 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.property` without support for deep paths.
	 *
	 * @private
	 * @param {string} key The key of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function baseProperty(key) {
	  return function(object) {
	    return object == null ? undefined : object[key];
	  };
	}
	
	module.exports = baseProperty;


/***/ },
/* 677 */
/***/ function(module, exports, __webpack_require__) {

	var baseGet = __webpack_require__(108);
	
	/**
	 * A specialized version of `baseProperty` which supports deep paths.
	 *
	 * @private
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 */
	function basePropertyDeep(path) {
	  return function(object) {
	    return baseGet(object, path);
	  };
	}
	
	module.exports = basePropertyDeep;


/***/ },
/* 678 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(337),
	    defineProperty = __webpack_require__(321),
	    identity = __webpack_require__(109);
	
	/**
	 * The base implementation of `setToString` without support for hot loop shorting.
	 *
	 * @private
	 * @param {Function} func The function to modify.
	 * @param {Function} string The `toString` result.
	 * @returns {Function} Returns `func`.
	 */
	var baseSetToString = !defineProperty ? identity : function(func, string) {
	  return defineProperty(func, 'toString', {
	    'configurable': true,
	    'enumerable': false,
	    'value': constant(string),
	    'writable': true
	  });
	};
	
	module.exports = baseSetToString;


/***/ },
/* 679 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.slice` without an iteratee call guard.
	 *
	 * @private
	 * @param {Array} array The array to slice.
	 * @param {number} [start=0] The start position.
	 * @param {number} [end=array.length] The end position.
	 * @returns {Array} Returns the slice of `array`.
	 */
	function baseSlice(array, start, end) {
	  var index = -1,
	      length = array.length;
	
	  if (start < 0) {
	    start = -start > length ? 0 : (length + start);
	  }
	  end = end > length ? length : end;
	  if (end < 0) {
	    end += length;
	  }
	  length = start > end ? 0 : ((end - start) >>> 0);
	  start >>>= 0;
	
	  var result = Array(length);
	  while (++index < length) {
	    result[index] = array[index + start];
	  }
	  return result;
	}
	
	module.exports = baseSlice;


/***/ },
/* 680 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.times` without support for iteratee shorthands
	 * or max array length checks.
	 *
	 * @private
	 * @param {number} n The number of times to invoke `iteratee`.
	 * @param {Function} iteratee The function invoked per iteration.
	 * @returns {Array} Returns the array of results.
	 */
	function baseTimes(n, iteratee) {
	  var index = -1,
	      result = Array(n);
	
	  while (++index < n) {
	    result[index] = iteratee(index);
	  }
	  return result;
	}
	
	module.exports = baseTimes;


/***/ },
/* 681 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(106);
	
	/**
	 * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
	 * of key-value pairs for `object` corresponding to the property names of `props`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @param {Array} props The property names to get values for.
	 * @returns {Object} Returns the key-value pairs.
	 */
	function baseToPairs(object, props) {
	  return arrayMap(props, function(key) {
	    return [key, object[key]];
	  });
	}
	
	module.exports = baseToPairs;


/***/ },
/* 682 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(79),
	    arrayMap = __webpack_require__(106),
	    isArray = __webpack_require__(28),
	    isSymbol = __webpack_require__(210);
	
	/** Used as references for various `Number` constants. */
	var INFINITY = 1 / 0;
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolToString = symbolProto ? symbolProto.toString : undefined;
	
	/**
	 * The base implementation of `_.toString` which doesn't convert nullish
	 * values to empty strings.
	 *
	 * @private
	 * @param {*} value The value to process.
	 * @returns {string} Returns the string.
	 */
	function baseToString(value) {
	  // Exit early for strings to avoid a performance hit in some environments.
	  if (typeof value == 'string') {
	    return value;
	  }
	  if (isArray(value)) {
	    // Recursively convert values (susceptible to call stack limits).
	    return arrayMap(value, baseToString) + '';
	  }
	  if (isSymbol(value)) {
	    return symbolToString ? symbolToString.call(value) : '';
	  }
	  var result = (value + '');
	  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
	}
	
	module.exports = baseToString;


/***/ },
/* 683 */
/***/ function(module, exports) {

	/**
	 * The base implementation of `_.unary` without support for storing metadata.
	 *
	 * @private
	 * @param {Function} func The function to cap arguments for.
	 * @returns {Function} Returns the new capped function.
	 */
	function baseUnary(func) {
	  return function(value) {
	    return func(value);
	  };
	}
	
	module.exports = baseUnary;


/***/ },
/* 684 */
/***/ function(module, exports) {

	/**
	 * Checks if a `cache` value for `key` exists.
	 *
	 * @private
	 * @param {Object} cache The cache to query.
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function cacheHas(cache, key) {
	  return cache.has(key);
	}
	
	module.exports = cacheHas;


/***/ },
/* 685 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(199);
	
	/**
	 * Creates a clone of `dataView`.
	 *
	 * @private
	 * @param {Object} dataView The data view to clone.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned data view.
	 */
	function cloneDataView(dataView, isDeep) {
	  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
	  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
	}
	
	module.exports = cloneDataView;


/***/ },
/* 686 */
/***/ function(module, exports, __webpack_require__) {

	var addMapEntry = __webpack_require__(654),
	    arrayReduce = __webpack_require__(302),
	    mapToArray = __webpack_require__(205);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `map`.
	 *
	 * @private
	 * @param {Object} map The map to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned map.
	 */
	function cloneMap(map, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(mapToArray(map), CLONE_DEEP_FLAG) : mapToArray(map);
	  return arrayReduce(array, addMapEntry, new map.constructor);
	}
	
	module.exports = cloneMap;


/***/ },
/* 687 */
/***/ function(module, exports) {

	/** Used to match `RegExp` flags from their coerced string values. */
	var reFlags = /\w*$/;
	
	/**
	 * Creates a clone of `regexp`.
	 *
	 * @private
	 * @param {Object} regexp The regexp to clone.
	 * @returns {Object} Returns the cloned regexp.
	 */
	function cloneRegExp(regexp) {
	  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
	  result.lastIndex = regexp.lastIndex;
	  return result;
	}
	
	module.exports = cloneRegExp;


/***/ },
/* 688 */
/***/ function(module, exports, __webpack_require__) {

	var addSetEntry = __webpack_require__(655),
	    arrayReduce = __webpack_require__(302),
	    setToArray = __webpack_require__(333);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1;
	
	/**
	 * Creates a clone of `set`.
	 *
	 * @private
	 * @param {Object} set The set to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the cloned set.
	 */
	function cloneSet(set, isDeep, cloneFunc) {
	  var array = isDeep ? cloneFunc(setToArray(set), CLONE_DEEP_FLAG) : setToArray(set);
	  return arrayReduce(array, addSetEntry, new set.constructor);
	}
	
	module.exports = cloneSet;


/***/ },
/* 689 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(79);
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * Creates a clone of the `symbol` object.
	 *
	 * @private
	 * @param {Object} symbol The symbol object to clone.
	 * @returns {Object} Returns the cloned symbol object.
	 */
	function cloneSymbol(symbol) {
	  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
	}
	
	module.exports = cloneSymbol;


/***/ },
/* 690 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    getSymbols = __webpack_require__(202);
	
	/**
	 * Copies own symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbols(source, object) {
	  return copyObject(source, getSymbols(source), object);
	}
	
	module.exports = copySymbols;


/***/ },
/* 691 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    getSymbolsIn = __webpack_require__(325);
	
	/**
	 * Copies own and inherited symbols of `source` to `object`.
	 *
	 * @private
	 * @param {Object} source The object to copy symbols from.
	 * @param {Object} [object={}] The object to copy symbols to.
	 * @returns {Object} Returns `object`.
	 */
	function copySymbolsIn(source, object) {
	  return copyObject(source, getSymbolsIn(source), object);
	}
	
	module.exports = copySymbolsIn;


/***/ },
/* 692 */
/***/ function(module, exports, __webpack_require__) {

	var root = __webpack_require__(41);
	
	/** Used to detect overreaching core-js shims. */
	var coreJsData = root['__core-js_shared__'];
	
	module.exports = coreJsData;


/***/ },
/* 693 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(84);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
	 * of source objects to the destination object for all destination properties
	 * that resolve to `undefined`.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to assign.
	 * @param {Object} object The parent object of `objValue`.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsAssignIn(objValue, srcValue, key, object) {
	  if (objValue === undefined ||
	      (eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key))) {
	    return srcValue;
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsAssignIn;


/***/ },
/* 694 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(198),
	    isObject = __webpack_require__(29);
	
	/**
	 * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
	 * objects into destination objects that are passed thru.
	 *
	 * @private
	 * @param {*} objValue The destination value.
	 * @param {*} srcValue The source value.
	 * @param {string} key The key of the property to merge.
	 * @param {Object} object The parent object of `objValue`.
	 * @param {Object} source The parent object of `srcValue`.
	 * @param {Object} [stack] Tracks traversed source values and their merged
	 *  counterparts.
	 * @returns {*} Returns the value to assign.
	 */
	function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
	  if (isObject(objValue) && isObject(srcValue)) {
	    // Recursively merge objects and arrays (susceptible to call stack limits).
	    stack.set(srcValue, objValue);
	    baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
	    stack['delete'](srcValue);
	  }
	  return objValue;
	}
	
	module.exports = customDefaultsMerge;


/***/ },
/* 695 */
/***/ function(module, exports, __webpack_require__) {

	var isPlainObject = __webpack_require__(112);
	
	/**
	 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
	 * objects.
	 *
	 * @private
	 * @param {*} value The value to inspect.
	 * @param {string} key The key of the property to inspect.
	 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
	 */
	function customOmitClone(value) {
	  return isPlainObject(value) ? undefined : value;
	}
	
	module.exports = customOmitClone;


/***/ },
/* 696 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(79),
	    Uint8Array = __webpack_require__(298),
	    eq = __webpack_require__(84),
	    equalArrays = __webpack_require__(322),
	    mapToArray = __webpack_require__(205),
	    setToArray = __webpack_require__(333);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1,
	    COMPARE_UNORDERED_FLAG = 2;
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    errorTag = '[object Error]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]';
	
	/** Used to convert symbols to primitives and strings. */
	var symbolProto = Symbol ? Symbol.prototype : undefined,
	    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for comparing objects of
	 * the same `toStringTag`.
	 *
	 * **Note:** This function only supports comparing values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {string} tag The `toStringTag` of the objects to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
	  switch (tag) {
	    case dataViewTag:
	      if ((object.byteLength != other.byteLength) ||
	          (object.byteOffset != other.byteOffset)) {
	        return false;
	      }
	      object = object.buffer;
	      other = other.buffer;
	
	    case arrayBufferTag:
	      if ((object.byteLength != other.byteLength) ||
	          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
	        return false;
	      }
	      return true;
	
	    case boolTag:
	    case dateTag:
	    case numberTag:
	      // Coerce booleans to `1` or `0` and dates to milliseconds.
	      // Invalid dates are coerced to `NaN`.
	      return eq(+object, +other);
	
	    case errorTag:
	      return object.name == other.name && object.message == other.message;
	
	    case regexpTag:
	    case stringTag:
	      // Coerce regexes to strings and treat strings, primitives and objects,
	      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
	      // for more details.
	      return object == (other + '');
	
	    case mapTag:
	      var convert = mapToArray;
	
	    case setTag:
	      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
	      convert || (convert = setToArray);
	
	      if (object.size != other.size && !isPartial) {
	        return false;
	      }
	      // Assume cyclic values are equal.
	      var stacked = stack.get(object);
	      if (stacked) {
	        return stacked == other;
	      }
	      bitmask |= COMPARE_UNORDERED_FLAG;
	
	      // Recursively compare objects (susceptible to call stack limits).
	      stack.set(object, other);
	      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
	      stack['delete'](object);
	      return result;
	
	    case symbolTag:
	      if (symbolValueOf) {
	        return symbolValueOf.call(object) == symbolValueOf.call(other);
	      }
	  }
	  return false;
	}
	
	module.exports = equalByTag;


/***/ },
/* 697 */
/***/ function(module, exports, __webpack_require__) {

	var getAllKeys = __webpack_require__(324);
	
	/** Used to compose bitmasks for value comparisons. */
	var COMPARE_PARTIAL_FLAG = 1;
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * A specialized version of `baseIsEqualDeep` for objects with support for
	 * partial deep comparisons.
	 *
	 * @private
	 * @param {Object} object The object to compare.
	 * @param {Object} other The other object to compare.
	 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
	 * @param {Function} customizer The function to customize comparisons.
	 * @param {Function} equalFunc The function to determine equivalents of values.
	 * @param {Object} stack Tracks traversed `object` and `other` objects.
	 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
	 */
	function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
	  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
	      objProps = getAllKeys(object),
	      objLength = objProps.length,
	      othProps = getAllKeys(other),
	      othLength = othProps.length;
	
	  if (objLength != othLength && !isPartial) {
	    return false;
	  }
	  var index = objLength;
	  while (index--) {
	    var key = objProps[index];
	    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
	      return false;
	    }
	  }
	  // Assume cyclic values are equal.
	  var stacked = stack.get(object);
	  if (stacked && stack.get(other)) {
	    return stacked == other;
	  }
	  var result = true;
	  stack.set(object, other);
	  stack.set(other, object);
	
	  var skipCtor = isPartial;
	  while (++index < objLength) {
	    key = objProps[index];
	    var objValue = object[key],
	        othValue = other[key];
	
	    if (customizer) {
	      var compared = isPartial
	        ? customizer(othValue, objValue, key, other, object, stack)
	        : customizer(objValue, othValue, key, object, other, stack);
	    }
	    // Recursively compare objects (susceptible to call stack limits).
	    if (!(compared === undefined
	          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
	          : compared
	        )) {
	      result = false;
	      break;
	    }
	    skipCtor || (skipCtor = key == 'constructor');
	  }
	  if (result && !skipCtor) {
	    var objCtor = object.constructor,
	        othCtor = other.constructor;
	
	    // Non `Object` object instances with different constructors are not equal.
	    if (objCtor != othCtor &&
	        ('constructor' in object && 'constructor' in other) &&
	        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
	          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
	      result = false;
	    }
	  }
	  stack['delete'](object);
	  stack['delete'](other);
	  return result;
	}
	
	module.exports = equalObjects;


/***/ },
/* 698 */
/***/ function(module, exports, __webpack_require__) {

	var isStrictComparable = __webpack_require__(328),
	    keys = __webpack_require__(30);
	
	/**
	 * Gets the property names, values, and compare flags of `object`.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the match data of `object`.
	 */
	function getMatchData(object) {
	  var result = keys(object),
	      length = result.length;
	
	  while (length--) {
	    var key = result[length],
	        value = object[key];
	
	    result[length] = [key, value, isStrictComparable(value)];
	  }
	  return result;
	}
	
	module.exports = getMatchData;


/***/ },
/* 699 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(79);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/** Built-in value references. */
	var symToStringTag = Symbol ? Symbol.toStringTag : undefined;
	
	/**
	 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
	 *
	 * @private
	 * @param {*} value The value to query.
	 * @returns {string} Returns the raw `toStringTag`.
	 */
	function getRawTag(value) {
	  var isOwn = hasOwnProperty.call(value, symToStringTag),
	      tag = value[symToStringTag];
	
	  try {
	    value[symToStringTag] = undefined;
	    var unmasked = true;
	  } catch (e) {}
	
	  var result = nativeObjectToString.call(value);
	  if (unmasked) {
	    if (isOwn) {
	      value[symToStringTag] = tag;
	    } else {
	      delete value[symToStringTag];
	    }
	  }
	  return result;
	}
	
	module.exports = getRawTag;


/***/ },
/* 700 */
/***/ function(module, exports) {

	/**
	 * Gets the value at `key` of `object`.
	 *
	 * @private
	 * @param {Object} [object] The object to query.
	 * @param {string} key The key of the property to get.
	 * @returns {*} Returns the property value.
	 */
	function getValue(object, key) {
	  return object == null ? undefined : object[key];
	}
	
	module.exports = getValue;


/***/ },
/* 701 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(145);
	
	/**
	 * Removes all key-value entries from the hash.
	 *
	 * @private
	 * @name clear
	 * @memberOf Hash
	 */
	function hashClear() {
	  this.__data__ = nativeCreate ? nativeCreate(null) : {};
	  this.size = 0;
	}
	
	module.exports = hashClear;


/***/ },
/* 702 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the hash.
	 *
	 * @private
	 * @name delete
	 * @memberOf Hash
	 * @param {Object} hash The hash to modify.
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function hashDelete(key) {
	  var result = this.has(key) && delete this.__data__[key];
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = hashDelete;


/***/ },
/* 703 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(145);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Gets the hash value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Hash
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function hashGet(key) {
	  var data = this.__data__;
	  if (nativeCreate) {
	    var result = data[key];
	    return result === HASH_UNDEFINED ? undefined : result;
	  }
	  return hasOwnProperty.call(data, key) ? data[key] : undefined;
	}
	
	module.exports = hashGet;


/***/ },
/* 704 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(145);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Checks if a hash value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Hash
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function hashHas(key) {
	  var data = this.__data__;
	  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
	}
	
	module.exports = hashHas;


/***/ },
/* 705 */
/***/ function(module, exports, __webpack_require__) {

	var nativeCreate = __webpack_require__(145);
	
	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Sets the hash `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Hash
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the hash instance.
	 */
	function hashSet(key, value) {
	  var data = this.__data__;
	  this.size += this.has(key) ? 0 : 1;
	  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
	  return this;
	}
	
	module.exports = hashSet;


/***/ },
/* 706 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Initializes an array clone.
	 *
	 * @private
	 * @param {Array} array The array to clone.
	 * @returns {Array} Returns the initialized clone.
	 */
	function initCloneArray(array) {
	  var length = array.length,
	      result = array.constructor(length);
	
	  // Add properties assigned by `RegExp#exec`.
	  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
	    result.index = array.index;
	    result.input = array.input;
	  }
	  return result;
	}
	
	module.exports = initCloneArray;


/***/ },
/* 707 */
/***/ function(module, exports, __webpack_require__) {

	var cloneArrayBuffer = __webpack_require__(199),
	    cloneDataView = __webpack_require__(685),
	    cloneMap = __webpack_require__(686),
	    cloneRegExp = __webpack_require__(687),
	    cloneSet = __webpack_require__(688),
	    cloneSymbol = __webpack_require__(689),
	    cloneTypedArray = __webpack_require__(316);
	
	/** `Object#toString` result references. */
	var boolTag = '[object Boolean]',
	    dateTag = '[object Date]',
	    mapTag = '[object Map]',
	    numberTag = '[object Number]',
	    regexpTag = '[object RegExp]',
	    setTag = '[object Set]',
	    stringTag = '[object String]',
	    symbolTag = '[object Symbol]';
	
	var arrayBufferTag = '[object ArrayBuffer]',
	    dataViewTag = '[object DataView]',
	    float32Tag = '[object Float32Array]',
	    float64Tag = '[object Float64Array]',
	    int8Tag = '[object Int8Array]',
	    int16Tag = '[object Int16Array]',
	    int32Tag = '[object Int32Array]',
	    uint8Tag = '[object Uint8Array]',
	    uint8ClampedTag = '[object Uint8ClampedArray]',
	    uint16Tag = '[object Uint16Array]',
	    uint32Tag = '[object Uint32Array]';
	
	/**
	 * Initializes an object clone based on its `toStringTag`.
	 *
	 * **Note:** This function only supports cloning values with tags of
	 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
	 *
	 * @private
	 * @param {Object} object The object to clone.
	 * @param {string} tag The `toStringTag` of the object to clone.
	 * @param {Function} cloneFunc The function to clone values.
	 * @param {boolean} [isDeep] Specify a deep clone.
	 * @returns {Object} Returns the initialized clone.
	 */
	function initCloneByTag(object, tag, cloneFunc, isDeep) {
	  var Ctor = object.constructor;
	  switch (tag) {
	    case arrayBufferTag:
	      return cloneArrayBuffer(object);
	
	    case boolTag:
	    case dateTag:
	      return new Ctor(+object);
	
	    case dataViewTag:
	      return cloneDataView(object, isDeep);
	
	    case float32Tag: case float64Tag:
	    case int8Tag: case int16Tag: case int32Tag:
	    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
	      return cloneTypedArray(object, isDeep);
	
	    case mapTag:
	      return cloneMap(object, isDeep, cloneFunc);
	
	    case numberTag:
	    case stringTag:
	      return new Ctor(object);
	
	    case regexpTag:
	      return cloneRegExp(object);
	
	    case setTag:
	      return cloneSet(object, isDeep, cloneFunc);
	
	    case symbolTag:
	      return cloneSymbol(object);
	  }
	}
	
	module.exports = initCloneByTag;


/***/ },
/* 708 */
/***/ function(module, exports, __webpack_require__) {

	var Symbol = __webpack_require__(79),
	    isArguments = __webpack_require__(146),
	    isArray = __webpack_require__(28);
	
	/** Built-in value references. */
	var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;
	
	/**
	 * Checks if `value` is a flattenable `arguments` object or array.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
	 */
	function isFlattenable(value) {
	  return isArray(value) || isArguments(value) ||
	    !!(spreadableSymbol && value && value[spreadableSymbol]);
	}
	
	module.exports = isFlattenable;


/***/ },
/* 709 */
/***/ function(module, exports, __webpack_require__) {

	var eq = __webpack_require__(84),
	    isArrayLike = __webpack_require__(110),
	    isIndex = __webpack_require__(143),
	    isObject = __webpack_require__(29);
	
	/**
	 * Checks if the given arguments are from an iteratee call.
	 *
	 * @private
	 * @param {*} value The potential iteratee value argument.
	 * @param {*} index The potential iteratee index or key argument.
	 * @param {*} object The potential iteratee object argument.
	 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
	 *  else `false`.
	 */
	function isIterateeCall(value, index, object) {
	  if (!isObject(object)) {
	    return false;
	  }
	  var type = typeof index;
	  if (type == 'number'
	        ? (isArrayLike(object) && isIndex(index, object.length))
	        : (type == 'string' && index in object)
	      ) {
	    return eq(object[index], value);
	  }
	  return false;
	}
	
	module.exports = isIterateeCall;


/***/ },
/* 710 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is suitable for use as unique object key.
	 *
	 * @private
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
	 */
	function isKeyable(value) {
	  var type = typeof value;
	  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
	    ? (value !== '__proto__')
	    : (value === null);
	}
	
	module.exports = isKeyable;


/***/ },
/* 711 */
/***/ function(module, exports, __webpack_require__) {

	var coreJsData = __webpack_require__(692);
	
	/** Used to detect methods masquerading as native. */
	var maskSrcKey = (function() {
	  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
	  return uid ? ('Symbol(src)_1.' + uid) : '';
	}());
	
	/**
	 * Checks if `func` has its source masked.
	 *
	 * @private
	 * @param {Function} func The function to check.
	 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
	 */
	function isMasked(func) {
	  return !!maskSrcKey && (maskSrcKey in func);
	}
	
	module.exports = isMasked;


/***/ },
/* 712 */
/***/ function(module, exports) {

	/**
	 * Removes all key-value entries from the list cache.
	 *
	 * @private
	 * @name clear
	 * @memberOf ListCache
	 */
	function listCacheClear() {
	  this.__data__ = [];
	  this.size = 0;
	}
	
	module.exports = listCacheClear;


/***/ },
/* 713 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(138);
	
	/** Used for built-in method references. */
	var arrayProto = Array.prototype;
	
	/** Built-in value references. */
	var splice = arrayProto.splice;
	
	/**
	 * Removes `key` and its value from the list cache.
	 *
	 * @private
	 * @name delete
	 * @memberOf ListCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function listCacheDelete(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    return false;
	  }
	  var lastIndex = data.length - 1;
	  if (index == lastIndex) {
	    data.pop();
	  } else {
	    splice.call(data, index, 1);
	  }
	  --this.size;
	  return true;
	}
	
	module.exports = listCacheDelete;


/***/ },
/* 714 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(138);
	
	/**
	 * Gets the list cache value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf ListCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function listCacheGet(key) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  return index < 0 ? undefined : data[index][1];
	}
	
	module.exports = listCacheGet;


/***/ },
/* 715 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(138);
	
	/**
	 * Checks if a list cache value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf ListCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function listCacheHas(key) {
	  return assocIndexOf(this.__data__, key) > -1;
	}
	
	module.exports = listCacheHas;


/***/ },
/* 716 */
/***/ function(module, exports, __webpack_require__) {

	var assocIndexOf = __webpack_require__(138);
	
	/**
	 * Sets the list cache `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf ListCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the list cache instance.
	 */
	function listCacheSet(key, value) {
	  var data = this.__data__,
	      index = assocIndexOf(data, key);
	
	  if (index < 0) {
	    ++this.size;
	    data.push([key, value]);
	  } else {
	    data[index][1] = value;
	  }
	  return this;
	}
	
	module.exports = listCacheSet;


/***/ },
/* 717 */
/***/ function(module, exports, __webpack_require__) {

	var Hash = __webpack_require__(649),
	    ListCache = __webpack_require__(134),
	    Map = __webpack_require__(193);
	
	/**
	 * Removes all key-value entries from the map.
	 *
	 * @private
	 * @name clear
	 * @memberOf MapCache
	 */
	function mapCacheClear() {
	  this.size = 0;
	  this.__data__ = {
	    'hash': new Hash,
	    'map': new (Map || ListCache),
	    'string': new Hash
	  };
	}
	
	module.exports = mapCacheClear;


/***/ },
/* 718 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(141);
	
	/**
	 * Removes `key` and its value from the map.
	 *
	 * @private
	 * @name delete
	 * @memberOf MapCache
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function mapCacheDelete(key) {
	  var result = getMapData(this, key)['delete'](key);
	  this.size -= result ? 1 : 0;
	  return result;
	}
	
	module.exports = mapCacheDelete;


/***/ },
/* 719 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(141);
	
	/**
	 * Gets the map value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf MapCache
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function mapCacheGet(key) {
	  return getMapData(this, key).get(key);
	}
	
	module.exports = mapCacheGet;


/***/ },
/* 720 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(141);
	
	/**
	 * Checks if a map value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf MapCache
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function mapCacheHas(key) {
	  return getMapData(this, key).has(key);
	}
	
	module.exports = mapCacheHas;


/***/ },
/* 721 */
/***/ function(module, exports, __webpack_require__) {

	var getMapData = __webpack_require__(141);
	
	/**
	 * Sets the map `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf MapCache
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the map cache instance.
	 */
	function mapCacheSet(key, value) {
	  var data = getMapData(this, key),
	      size = data.size;
	
	  data.set(key, value);
	  this.size += data.size == size ? 0 : 1;
	  return this;
	}
	
	module.exports = mapCacheSet;


/***/ },
/* 722 */
/***/ function(module, exports, __webpack_require__) {

	var memoize = __webpack_require__(763);
	
	/** Used as the maximum memoize cache size. */
	var MAX_MEMOIZE_SIZE = 500;
	
	/**
	 * A specialized version of `_.memoize` which clears the memoized function's
	 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
	 *
	 * @private
	 * @param {Function} func The function to have its output memoized.
	 * @returns {Function} Returns the new memoized function.
	 */
	function memoizeCapped(func) {
	  var result = memoize(func, function(key) {
	    if (cache.size === MAX_MEMOIZE_SIZE) {
	      cache.clear();
	    }
	    return key;
	  });
	
	  var cache = result.cache;
	  return result;
	}
	
	module.exports = memoizeCapped;


/***/ },
/* 723 */
/***/ function(module, exports, __webpack_require__) {

	var overArg = __webpack_require__(330);
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeKeys = overArg(Object.keys, Object);
	
	module.exports = nativeKeys;


/***/ },
/* 724 */
/***/ function(module, exports) {

	/**
	 * This function is like
	 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
	 * except that it includes inherited enumerable properties.
	 *
	 * @private
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property names.
	 */
	function nativeKeysIn(object) {
	  var result = [];
	  if (object != null) {
	    for (var key in Object(object)) {
	      result.push(key);
	    }
	  }
	  return result;
	}
	
	module.exports = nativeKeysIn;


/***/ },
/* 725 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(323);
	
	/** Detect free variable `exports`. */
	var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;
	
	/** Detect free variable `module`. */
	var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;
	
	/** Detect the popular CommonJS extension `module.exports`. */
	var moduleExports = freeModule && freeModule.exports === freeExports;
	
	/** Detect free variable `process` from Node.js. */
	var freeProcess = moduleExports && freeGlobal.process;
	
	/** Used to access faster Node.js helpers. */
	var nodeUtil = (function() {
	  try {
	    return freeProcess && freeProcess.binding && freeProcess.binding('util');
	  } catch (e) {}
	}());
	
	module.exports = nodeUtil;
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(37)(module)))

/***/ },
/* 726 */
/***/ function(module, exports) {

	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var nativeObjectToString = objectProto.toString;
	
	/**
	 * Converts `value` to a string using `Object.prototype.toString`.
	 *
	 * @private
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 */
	function objectToString(value) {
	  return nativeObjectToString.call(value);
	}
	
	module.exports = objectToString;


/***/ },
/* 727 */
/***/ function(module, exports) {

	/** Used to stand-in for `undefined` hash values. */
	var HASH_UNDEFINED = '__lodash_hash_undefined__';
	
	/**
	 * Adds `value` to the array cache.
	 *
	 * @private
	 * @name add
	 * @memberOf SetCache
	 * @alias push
	 * @param {*} value The value to cache.
	 * @returns {Object} Returns the cache instance.
	 */
	function setCacheAdd(value) {
	  this.__data__.set(value, HASH_UNDEFINED);
	  return this;
	}
	
	module.exports = setCacheAdd;


/***/ },
/* 728 */
/***/ function(module, exports) {

	/**
	 * Checks if `value` is in the array cache.
	 *
	 * @private
	 * @name has
	 * @memberOf SetCache
	 * @param {*} value The value to search for.
	 * @returns {number} Returns `true` if `value` is found, else `false`.
	 */
	function setCacheHas(value) {
	  return this.__data__.has(value);
	}
	
	module.exports = setCacheHas;


/***/ },
/* 729 */
/***/ function(module, exports) {

	/**
	 * Converts `set` to its value-value pairs.
	 *
	 * @private
	 * @param {Object} set The set to convert.
	 * @returns {Array} Returns the value-value pairs.
	 */
	function setToPairs(set) {
	  var index = -1,
	      result = Array(set.size);
	
	  set.forEach(function(value) {
	    result[++index] = [value, value];
	  });
	  return result;
	}
	
	module.exports = setToPairs;


/***/ },
/* 730 */
/***/ function(module, exports) {

	/** Used to detect hot functions by number of calls within a span of milliseconds. */
	var HOT_COUNT = 800,
	    HOT_SPAN = 16;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeNow = Date.now;
	
	/**
	 * Creates a function that'll short out and invoke `identity` instead
	 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
	 * milliseconds.
	 *
	 * @private
	 * @param {Function} func The function to restrict.
	 * @returns {Function} Returns the new shortable function.
	 */
	function shortOut(func) {
	  var count = 0,
	      lastCalled = 0;
	
	  return function() {
	    var stamp = nativeNow(),
	        remaining = HOT_SPAN - (stamp - lastCalled);
	
	    lastCalled = stamp;
	    if (remaining > 0) {
	      if (++count >= HOT_COUNT) {
	        return arguments[0];
	      }
	    } else {
	      count = 0;
	    }
	    return func.apply(undefined, arguments);
	  };
	}
	
	module.exports = shortOut;


/***/ },
/* 731 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(134);
	
	/**
	 * Removes all key-value entries from the stack.
	 *
	 * @private
	 * @name clear
	 * @memberOf Stack
	 */
	function stackClear() {
	  this.__data__ = new ListCache;
	  this.size = 0;
	}
	
	module.exports = stackClear;


/***/ },
/* 732 */
/***/ function(module, exports) {

	/**
	 * Removes `key` and its value from the stack.
	 *
	 * @private
	 * @name delete
	 * @memberOf Stack
	 * @param {string} key The key of the value to remove.
	 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
	 */
	function stackDelete(key) {
	  var data = this.__data__,
	      result = data['delete'](key);
	
	  this.size = data.size;
	  return result;
	}
	
	module.exports = stackDelete;


/***/ },
/* 733 */
/***/ function(module, exports) {

	/**
	 * Gets the stack value for `key`.
	 *
	 * @private
	 * @name get
	 * @memberOf Stack
	 * @param {string} key The key of the value to get.
	 * @returns {*} Returns the entry value.
	 */
	function stackGet(key) {
	  return this.__data__.get(key);
	}
	
	module.exports = stackGet;


/***/ },
/* 734 */
/***/ function(module, exports) {

	/**
	 * Checks if a stack value for `key` exists.
	 *
	 * @private
	 * @name has
	 * @memberOf Stack
	 * @param {string} key The key of the entry to check.
	 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
	 */
	function stackHas(key) {
	  return this.__data__.has(key);
	}
	
	module.exports = stackHas;


/***/ },
/* 735 */
/***/ function(module, exports, __webpack_require__) {

	var ListCache = __webpack_require__(134),
	    Map = __webpack_require__(193),
	    MapCache = __webpack_require__(194);
	
	/** Used as the size to enable large array optimizations. */
	var LARGE_ARRAY_SIZE = 200;
	
	/**
	 * Sets the stack `key` to `value`.
	 *
	 * @private
	 * @name set
	 * @memberOf Stack
	 * @param {string} key The key of the value to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns the stack cache instance.
	 */
	function stackSet(key, value) {
	  var data = this.__data__;
	  if (data instanceof ListCache) {
	    var pairs = data.__data__;
	    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
	      pairs.push([key, value]);
	      this.size = ++data.size;
	      return this;
	    }
	    data = this.__data__ = new MapCache(pairs);
	  }
	  data.set(key, value);
	  this.size = data.size;
	  return this;
	}
	
	module.exports = stackSet;


/***/ },
/* 736 */
/***/ function(module, exports, __webpack_require__) {

	var memoizeCapped = __webpack_require__(722);
	
	/** Used to match property names within property paths. */
	var reLeadingDot = /^\./,
	    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
	
	/** Used to match backslashes in property paths. */
	var reEscapeChar = /\\(\\)?/g;
	
	/**
	 * Converts `string` to a property path array.
	 *
	 * @private
	 * @param {string} string The string to convert.
	 * @returns {Array} Returns the property path array.
	 */
	var stringToPath = memoizeCapped(function(string) {
	  var result = [];
	  if (reLeadingDot.test(string)) {
	    result.push('');
	  }
	  string.replace(rePropName, function(match, number, quote, string) {
	    result.push(quote ? string.replace(reEscapeChar, '$1') : (number || match));
	  });
	  return result;
	});
	
	module.exports = stringToPath;


/***/ },
/* 737 */
/***/ function(module, exports, __webpack_require__) {

	var assignValue = __webpack_require__(137),
	    copyObject = __webpack_require__(40),
	    createAssigner = __webpack_require__(83),
	    isArrayLike = __webpack_require__(110),
	    isPrototype = __webpack_require__(144),
	    keys = __webpack_require__(30);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * Assigns own enumerable string keyed properties of source objects to the
	 * destination object. Source objects are applied from left to right.
	 * Subsequent sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object` and is loosely based on
	 * [`Object.assign`](https://mdn.io/Object/assign).
	 *
	 * @static
	 * @memberOf _
	 * @since 0.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.assignIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 * }
	 *
	 * function Bar() {
	 *   this.c = 3;
	 * }
	 *
	 * Foo.prototype.b = 2;
	 * Bar.prototype.d = 4;
	 *
	 * _.assign({ 'a': 0 }, new Foo, new Bar);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var assign = createAssigner(function(object, source) {
	  if (isPrototype(source) || isArrayLike(source)) {
	    copyObject(source, keys(source), object);
	    return;
	  }
	  for (var key in source) {
	    if (hasOwnProperty.call(source, key)) {
	      assignValue(object, key, source[key]);
	    }
	  }
	});
	
	module.exports = assign;


/***/ },
/* 738 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    createAssigner = __webpack_require__(83),
	    keys = __webpack_require__(30);
	
	/**
	 * This method is like `_.assign` except that it accepts `customizer`
	 * which is invoked to produce the assigned values. If `customizer` returns
	 * `undefined`, assignment is handled by the method instead. The `customizer`
	 * is invoked with five arguments: (objValue, srcValue, key, object, source).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} sources The source objects.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @see _.assignInWith
	 * @example
	 *
	 * function customizer(objValue, srcValue) {
	 *   return _.isUndefined(objValue) ? srcValue : objValue;
	 * }
	 *
	 * var defaults = _.partialRight(_.assignWith, customizer);
	 *
	 * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var assignWith = createAssigner(function(object, source, srcIndex, customizer) {
	  copyObject(source, keys(source), object, customizer);
	});
	
	module.exports = assignWith;


/***/ },
/* 739 */
/***/ function(module, exports, __webpack_require__) {

	var baseAt = __webpack_require__(658),
	    flatRest = __webpack_require__(200);
	
	/**
	 * Creates an array of values corresponding to `paths` of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.0.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Array} Returns the picked values.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
	 *
	 * _.at(object, ['a[0].b.c', 'a[1]']);
	 * // => [3, 4]
	 */
	var at = flatRest(baseAt);
	
	module.exports = at;


/***/ },
/* 740 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssign = __webpack_require__(304),
	    baseCreate = __webpack_require__(196);
	
	/**
	 * Creates an object that inherits from the `prototype` object. If a
	 * `properties` object is given, its own enumerable string keyed properties
	 * are assigned to the created object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.3.0
	 * @category Object
	 * @param {Object} prototype The object to inherit from.
	 * @param {Object} [properties] The properties to assign to the object.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * function Shape() {
	 *   this.x = 0;
	 *   this.y = 0;
	 * }
	 *
	 * function Circle() {
	 *   Shape.call(this);
	 * }
	 *
	 * Circle.prototype = _.create(Shape.prototype, {
	 *   'constructor': Circle
	 * });
	 *
	 * var circle = new Circle;
	 * circle instanceof Circle;
	 * // => true
	 *
	 * circle instanceof Shape;
	 * // => true
	 */
	function create(prototype, properties) {
	  var result = baseCreate(prototype);
	  return properties == null ? result : baseAssign(result, properties);
	}
	
	module.exports = create;


/***/ },
/* 741 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(136),
	    assignInWith = __webpack_require__(206),
	    baseRest = __webpack_require__(139),
	    customDefaultsAssignIn = __webpack_require__(693);
	
	/**
	 * Assigns own and inherited enumerable string keyed properties of source
	 * objects to the destination object for all destination properties that
	 * resolve to `undefined`. Source objects are applied from left to right.
	 * Once a property is set, additional values of the same property are ignored.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaultsDeep
	 * @example
	 *
	 * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
	 * // => { 'a': 1, 'b': 2 }
	 */
	var defaults = baseRest(function(args) {
	  args.push(undefined, customDefaultsAssignIn);
	  return apply(assignInWith, undefined, args);
	});
	
	module.exports = defaults;


/***/ },
/* 742 */
/***/ function(module, exports, __webpack_require__) {

	var apply = __webpack_require__(136),
	    baseRest = __webpack_require__(139),
	    customDefaultsMerge = __webpack_require__(694),
	    mergeWith = __webpack_require__(339);
	
	/**
	 * This method is like `_.defaults` except that it recursively assigns
	 * default properties.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.10.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @see _.defaults
	 * @example
	 *
	 * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
	 * // => { 'a': { 'b': 2, 'c': 3 } }
	 */
	var defaultsDeep = baseRest(function(args) {
	  args.push(undefined, customDefaultsMerge);
	  return apply(mergeWith, undefined, args);
	});
	
	module.exports = defaultsDeep;


/***/ },
/* 743 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(342);


/***/ },
/* 744 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(343);


/***/ },
/* 745 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(336);


/***/ },
/* 746 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(206);


/***/ },
/* 747 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindKey = __webpack_require__(305),
	    baseForOwn = __webpack_require__(80),
	    baseIteratee = __webpack_require__(50);
	
	/**
	 * This method is like `_.find` except that it returns the key of the first
	 * element `predicate` returns truthy for instead of the element itself.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.1.0
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {string|undefined} Returns the key of the matched element,
	 *  else `undefined`.
	 * @example
	 *
	 * var users = {
	 *   'barney':  { 'age': 36, 'active': true },
	 *   'fred':    { 'age': 40, 'active': false },
	 *   'pebbles': { 'age': 1,  'active': true }
	 * };
	 *
	 * _.findKey(users, function(o) { return o.age < 40; });
	 * // => 'barney' (iteration order is not guaranteed)
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findKey(users, { 'age': 1, 'active': true });
	 * // => 'pebbles'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findKey(users, ['active', false]);
	 * // => 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findKey(users, 'active');
	 * // => 'barney'
	 */
	function findKey(object, predicate) {
	  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwn);
	}
	
	module.exports = findKey;


/***/ },
/* 748 */
/***/ function(module, exports, __webpack_require__) {

	var baseFindKey = __webpack_require__(305),
	    baseForOwnRight = __webpack_require__(306),
	    baseIteratee = __webpack_require__(50);
	
	/**
	 * This method is like `_.findKey` except that it iterates over elements of
	 * a collection in the opposite order.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @param {Function} [predicate=_.identity] The function invoked per iteration.
	 * @returns {string|undefined} Returns the key of the matched element,
	 *  else `undefined`.
	 * @example
	 *
	 * var users = {
	 *   'barney':  { 'age': 36, 'active': true },
	 *   'fred':    { 'age': 40, 'active': false },
	 *   'pebbles': { 'age': 1,  'active': true }
	 * };
	 *
	 * _.findLastKey(users, function(o) { return o.age < 40; });
	 * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
	 *
	 * // The `_.matches` iteratee shorthand.
	 * _.findLastKey(users, { 'age': 36, 'active': true });
	 * // => 'barney'
	 *
	 * // The `_.matchesProperty` iteratee shorthand.
	 * _.findLastKey(users, ['active', false]);
	 * // => 'fred'
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.findLastKey(users, 'active');
	 * // => 'pebbles'
	 */
	function findLastKey(object, predicate) {
	  return baseFindKey(object, baseIteratee(predicate, 3), baseForOwnRight);
	}
	
	module.exports = findLastKey;


/***/ },
/* 749 */
/***/ function(module, exports, __webpack_require__) {

	var baseFlatten = __webpack_require__(660);
	
	/**
	 * Flattens `array` a single level deep.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Array
	 * @param {Array} array The array to flatten.
	 * @returns {Array} Returns the new flattened array.
	 * @example
	 *
	 * _.flatten([1, [2, [3, [4]], 5]]);
	 * // => [1, 2, [3, [4]], 5]
	 */
	function flatten(array) {
	  var length = array == null ? 0 : array.length;
	  return length ? baseFlatten(array, 1) : [];
	}
	
	module.exports = flatten;


/***/ },
/* 750 */
/***/ function(module, exports, __webpack_require__) {

	var baseFor = __webpack_require__(197),
	    castFunction = __webpack_require__(82),
	    keysIn = __webpack_require__(31);
	
	/**
	 * Iterates over own and inherited enumerable string keyed properties of an
	 * object and invokes `iteratee` for each property. The iteratee is invoked
	 * with three arguments: (value, key, object). Iteratee functions may exit
	 * iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forInRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forIn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
	 */
	function forIn(object, iteratee) {
	  return object == null
	    ? object
	    : baseFor(object, castFunction(iteratee), keysIn);
	}
	
	module.exports = forIn;


/***/ },
/* 751 */
/***/ function(module, exports, __webpack_require__) {

	var baseForRight = __webpack_require__(307),
	    castFunction = __webpack_require__(82),
	    keysIn = __webpack_require__(31);
	
	/**
	 * This method is like `_.forIn` except that it iterates over properties of
	 * `object` in the opposite order.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forInRight(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
	 */
	function forInRight(object, iteratee) {
	  return object == null
	    ? object
	    : baseForRight(object, castFunction(iteratee), keysIn);
	}
	
	module.exports = forInRight;


/***/ },
/* 752 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwn = __webpack_require__(80),
	    castFunction = __webpack_require__(82);
	
	/**
	 * Iterates over own enumerable string keyed properties of an object and
	 * invokes `iteratee` for each property. The iteratee is invoked with three
	 * arguments: (value, key, object). Iteratee functions may exit iteration
	 * early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwnRight
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwn(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
	 */
	function forOwn(object, iteratee) {
	  return object && baseForOwn(object, castFunction(iteratee));
	}
	
	module.exports = forOwn;


/***/ },
/* 753 */
/***/ function(module, exports, __webpack_require__) {

	var baseForOwnRight = __webpack_require__(306),
	    castFunction = __webpack_require__(82);
	
	/**
	 * This method is like `_.forOwn` except that it iterates over properties of
	 * `object` in the opposite order.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.0.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns `object`.
	 * @see _.forOwn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.forOwnRight(new Foo, function(value, key) {
	 *   console.log(key);
	 * });
	 * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
	 */
	function forOwnRight(object, iteratee) {
	  return object && baseForOwnRight(object, castFunction(iteratee));
	}
	
	module.exports = forOwnRight;


/***/ },
/* 754 */
/***/ function(module, exports, __webpack_require__) {

	var baseFunctions = __webpack_require__(308),
	    keys = __webpack_require__(30);
	
	/**
	 * Creates an array of function property names from own enumerable properties
	 * of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the function names.
	 * @see _.functionsIn
	 * @example
	 *
	 * function Foo() {
	 *   this.a = _.constant('a');
	 *   this.b = _.constant('b');
	 * }
	 *
	 * Foo.prototype.c = _.constant('c');
	 *
	 * _.functions(new Foo);
	 * // => ['a', 'b']
	 */
	function functions(object) {
	  return object == null ? [] : baseFunctions(object, keys(object));
	}
	
	module.exports = functions;


/***/ },
/* 755 */
/***/ function(module, exports, __webpack_require__) {

	var baseFunctions = __webpack_require__(308),
	    keysIn = __webpack_require__(31);
	
	/**
	 * Creates an array of function property names from own and inherited
	 * enumerable properties of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to inspect.
	 * @returns {Array} Returns the function names.
	 * @see _.functions
	 * @example
	 *
	 * function Foo() {
	 *   this.a = _.constant('a');
	 *   this.b = _.constant('b');
	 * }
	 *
	 * Foo.prototype.c = _.constant('c');
	 *
	 * _.functionsIn(new Foo);
	 * // => ['a', 'b', 'c']
	 */
	function functionsIn(object) {
	  return object == null ? [] : baseFunctions(object, keysIn(object));
	}
	
	module.exports = functionsIn;


/***/ },
/* 756 */
/***/ function(module, exports, __webpack_require__) {

	var baseHas = __webpack_require__(661),
	    hasPath = __webpack_require__(326);
	
	/**
	 * Checks if `path` is a direct property of `object`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path to check.
	 * @returns {boolean} Returns `true` if `path` exists, else `false`.
	 * @example
	 *
	 * var object = { 'a': { 'b': 2 } };
	 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
	 *
	 * _.has(object, 'a');
	 * // => true
	 *
	 * _.has(object, 'a.b');
	 * // => true
	 *
	 * _.has(object, ['a', 'b']);
	 * // => true
	 *
	 * _.has(other, 'a');
	 * // => false
	 */
	function has(object, path) {
	  return object != null && hasPath(object, path, baseHas);
	}
	
	module.exports = has;


/***/ },
/* 757 */
/***/ function(module, exports, __webpack_require__) {

	var constant = __webpack_require__(337),
	    createInverter = __webpack_require__(319),
	    identity = __webpack_require__(109);
	
	/**
	 * Creates an object composed of the inverted keys and values of `object`.
	 * If `object` contains duplicate values, subsequent values overwrite
	 * property assignments of previous values.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.7.0
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invert(object);
	 * // => { '1': 'c', '2': 'b' }
	 */
	var invert = createInverter(function(result, value, key) {
	  result[value] = key;
	}, constant(identity));
	
	module.exports = invert;


/***/ },
/* 758 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(50),
	    createInverter = __webpack_require__(319);
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/** Used to check objects for own properties. */
	var hasOwnProperty = objectProto.hasOwnProperty;
	
	/**
	 * This method is like `_.invert` except that the inverted object is generated
	 * from the results of running each element of `object` thru `iteratee`. The
	 * corresponding inverted value of each inverted key is an array of keys
	 * responsible for generating the inverted value. The iteratee is invoked
	 * with one argument: (value).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.1.0
	 * @category Object
	 * @param {Object} object The object to invert.
	 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
	 * @returns {Object} Returns the new inverted object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2, 'c': 1 };
	 *
	 * _.invertBy(object);
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 *
	 * _.invertBy(object, function(value) {
	 *   return 'group' + value;
	 * });
	 * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
	 */
	var invertBy = createInverter(function(result, value, key) {
	  if (hasOwnProperty.call(result, value)) {
	    result[value].push(key);
	  } else {
	    result[value] = [key];
	  }
	}, baseIteratee);
	
	module.exports = invertBy;


/***/ },
/* 759 */
/***/ function(module, exports, __webpack_require__) {

	var baseInvoke = __webpack_require__(664),
	    baseRest = __webpack_require__(139);
	
	/**
	 * Invokes the method at `path` of `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the method to invoke.
	 * @param {...*} [args] The arguments to invoke the method with.
	 * @returns {*} Returns the result of the invoked method.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
	 *
	 * _.invoke(object, 'a[0].b.c.slice', 1, 3);
	 * // => [2, 3]
	 */
	var invoke = baseRest(baseInvoke);
	
	module.exports = invoke;


/***/ },
/* 760 */
/***/ function(module, exports, __webpack_require__) {

	var isArrayLike = __webpack_require__(110),
	    isObjectLike = __webpack_require__(62);
	
	/**
	 * This method is like `_.isArrayLike` except that it also checks if `value`
	 * is an object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an array-like object,
	 *  else `false`.
	 * @example
	 *
	 * _.isArrayLikeObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isArrayLikeObject(document.body.children);
	 * // => true
	 *
	 * _.isArrayLikeObject('abc');
	 * // => false
	 *
	 * _.isArrayLikeObject(_.noop);
	 * // => false
	 */
	function isArrayLikeObject(value) {
	  return isObjectLike(value) && isArrayLike(value);
	}
	
	module.exports = isArrayLikeObject;


/***/ },
/* 761 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(107),
	    baseForOwn = __webpack_require__(80),
	    baseIteratee = __webpack_require__(50);
	
	/**
	 * The opposite of `_.mapValues`; this method creates an object with the
	 * same values as `object` and keys generated by running each own enumerable
	 * string keyed property of `object` thru `iteratee`. The iteratee is invoked
	 * with three arguments: (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 3.8.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapValues
	 * @example
	 *
	 * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
	 *   return key + value;
	 * });
	 * // => { 'a1': 1, 'b2': 2 }
	 */
	function mapKeys(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, iteratee(value, key, object), value);
	  });
	  return result;
	}
	
	module.exports = mapKeys;


/***/ },
/* 762 */
/***/ function(module, exports, __webpack_require__) {

	var baseAssignValue = __webpack_require__(107),
	    baseForOwn = __webpack_require__(80),
	    baseIteratee = __webpack_require__(50);
	
	/**
	 * Creates an object with the same keys as `object` and values generated
	 * by running each own enumerable string keyed property of `object` thru
	 * `iteratee`. The iteratee is invoked with three arguments:
	 * (value, key, object).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @returns {Object} Returns the new mapped object.
	 * @see _.mapKeys
	 * @example
	 *
	 * var users = {
	 *   'fred':    { 'user': 'fred',    'age': 40 },
	 *   'pebbles': { 'user': 'pebbles', 'age': 1 }
	 * };
	 *
	 * _.mapValues(users, function(o) { return o.age; });
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 *
	 * // The `_.property` iteratee shorthand.
	 * _.mapValues(users, 'age');
	 * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
	 */
	function mapValues(object, iteratee) {
	  var result = {};
	  iteratee = baseIteratee(iteratee, 3);
	
	  baseForOwn(object, function(value, key, object) {
	    baseAssignValue(result, key, iteratee(value, key, object));
	  });
	  return result;
	}
	
	module.exports = mapValues;


/***/ },
/* 763 */
/***/ function(module, exports, __webpack_require__) {

	var MapCache = __webpack_require__(194);
	
	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that memoizes the result of `func`. If `resolver` is
	 * provided, it determines the cache key for storing the result based on the
	 * arguments provided to the memoized function. By default, the first argument
	 * provided to the memoized function is used as the map cache key. The `func`
	 * is invoked with the `this` binding of the memoized function.
	 *
	 * **Note:** The cache is exposed as the `cache` property on the memoized
	 * function. Its creation may be customized by replacing the `_.memoize.Cache`
	 * constructor with one whose instances implement the
	 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
	 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to have its output memoized.
	 * @param {Function} [resolver] The function to resolve the cache key.
	 * @returns {Function} Returns the new memoized function.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': 2 };
	 * var other = { 'c': 3, 'd': 4 };
	 *
	 * var values = _.memoize(_.values);
	 * values(object);
	 * // => [1, 2]
	 *
	 * values(other);
	 * // => [3, 4]
	 *
	 * object.a = 2;
	 * values(object);
	 * // => [1, 2]
	 *
	 * // Modify the result cache.
	 * values.cache.set(object, ['a', 'b']);
	 * values(object);
	 * // => ['a', 'b']
	 *
	 * // Replace `_.memoize.Cache`.
	 * _.memoize.Cache = WeakMap;
	 */
	function memoize(func, resolver) {
	  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  var memoized = function() {
	    var args = arguments,
	        key = resolver ? resolver.apply(this, args) : args[0],
	        cache = memoized.cache;
	
	    if (cache.has(key)) {
	      return cache.get(key);
	    }
	    var result = func.apply(this, args);
	    memoized.cache = cache.set(key, result) || cache;
	    return result;
	  };
	  memoized.cache = new (memoize.Cache || MapCache);
	  return memoized;
	}
	
	// Expose `MapCache`.
	memoize.Cache = MapCache;
	
	module.exports = memoize;


/***/ },
/* 764 */
/***/ function(module, exports, __webpack_require__) {

	var baseMerge = __webpack_require__(198),
	    createAssigner = __webpack_require__(83);
	
	/**
	 * This method is like `_.assign` except that it recursively merges own and
	 * inherited enumerable string keyed properties of source objects into the
	 * destination object. Source properties that resolve to `undefined` are
	 * skipped if a destination value exists. Array and plain object properties
	 * are merged recursively. Other objects and value types are overridden by
	 * assignment. Source objects are applied from left to right. Subsequent
	 * sources overwrite property assignments of previous sources.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.5.0
	 * @category Object
	 * @param {Object} object The destination object.
	 * @param {...Object} [sources] The source objects.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {
	 *   'a': [{ 'b': 2 }, { 'd': 4 }]
	 * };
	 *
	 * var other = {
	 *   'a': [{ 'c': 3 }, { 'e': 5 }]
	 * };
	 *
	 * _.merge(object, other);
	 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
	 */
	var merge = createAssigner(function(object, source, srcIndex) {
	  baseMerge(object, source, srcIndex);
	});
	
	module.exports = merge;


/***/ },
/* 765 */
/***/ function(module, exports) {

	/** Error message constants. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/**
	 * Creates a function that negates the result of the predicate `func`. The
	 * `func` predicate is invoked with the `this` binding and arguments of the
	 * created function.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Function
	 * @param {Function} predicate The predicate to negate.
	 * @returns {Function} Returns the new negated function.
	 * @example
	 *
	 * function isEven(n) {
	 *   return n % 2 == 0;
	 * }
	 *
	 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
	 * // => [1, 3, 5]
	 */
	function negate(predicate) {
	  if (typeof predicate != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  return function() {
	    var args = arguments;
	    switch (args.length) {
	      case 0: return !predicate.call(this);
	      case 1: return !predicate.call(this, args[0]);
	      case 2: return !predicate.call(this, args[0], args[1]);
	      case 3: return !predicate.call(this, args[0], args[1], args[2]);
	    }
	    return !predicate.apply(this, args);
	  };
	}
	
	module.exports = negate;


/***/ },
/* 766 */
/***/ function(module, exports, __webpack_require__) {

	var arrayMap = __webpack_require__(106),
	    baseClone = __webpack_require__(659),
	    baseUnset = __webpack_require__(312),
	    castPath = __webpack_require__(51),
	    copyObject = __webpack_require__(40),
	    customOmitClone = __webpack_require__(695),
	    flatRest = __webpack_require__(200),
	    getAllKeysIn = __webpack_require__(201);
	
	/** Used to compose bitmasks for cloning. */
	var CLONE_DEEP_FLAG = 1,
	    CLONE_FLAT_FLAG = 2,
	    CLONE_SYMBOLS_FLAG = 4;
	
	/**
	 * The opposite of `_.pick`; this method creates an object composed of the
	 * own and inherited enumerable property paths of `object` that are not omitted.
	 *
	 * **Note:** This method is considerably slower than `_.pick`.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to omit.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omit(object, ['a', 'c']);
	 * // => { 'b': '2' }
	 */
	var omit = flatRest(function(object, paths) {
	  var result = {};
	  if (object == null) {
	    return result;
	  }
	  var isDeep = false;
	  paths = arrayMap(paths, function(path) {
	    path = castPath(path, object);
	    isDeep || (isDeep = path.length > 1);
	    return path;
	  });
	  copyObject(object, getAllKeysIn(object), result);
	  if (isDeep) {
	    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
	  }
	  var length = paths.length;
	  while (length--) {
	    baseUnset(result, paths[length]);
	  }
	  return result;
	});
	
	module.exports = omit;


/***/ },
/* 767 */
/***/ function(module, exports, __webpack_require__) {

	var baseIteratee = __webpack_require__(50),
	    negate = __webpack_require__(765),
	    pickBy = __webpack_require__(340);
	
	/**
	 * The opposite of `_.pickBy`; this method creates an object composed of
	 * the own and inherited enumerable string keyed properties of `object` that
	 * `predicate` doesn't return truthy for. The predicate is invoked with two
	 * arguments: (value, key).
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {Function} [predicate=_.identity] The function invoked per property.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.omitBy(object, _.isNumber);
	 * // => { 'b': '2' }
	 */
	function omitBy(object, predicate) {
	  return pickBy(object, negate(baseIteratee(predicate)));
	}
	
	module.exports = omitBy;


/***/ },
/* 768 */
/***/ function(module, exports, __webpack_require__) {

	var basePick = __webpack_require__(675),
	    flatRest = __webpack_require__(200);
	
	/**
	 * Creates an object composed of the picked `object` properties.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The source object.
	 * @param {...(string|string[])} [paths] The property paths to pick.
	 * @returns {Object} Returns the new object.
	 * @example
	 *
	 * var object = { 'a': 1, 'b': '2', 'c': 3 };
	 *
	 * _.pick(object, ['a', 'c']);
	 * // => { 'a': 1, 'c': 3 }
	 */
	var pick = flatRest(function(object, paths) {
	  return object == null ? {} : basePick(object, paths);
	});
	
	module.exports = pick;


/***/ },
/* 769 */
/***/ function(module, exports, __webpack_require__) {

	var baseProperty = __webpack_require__(676),
	    basePropertyDeep = __webpack_require__(677),
	    isKey = __webpack_require__(204),
	    toKey = __webpack_require__(52);
	
	/**
	 * Creates a function that returns the value at `path` of a given object.
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Util
	 * @param {Array|string} path The path of the property to get.
	 * @returns {Function} Returns the new accessor function.
	 * @example
	 *
	 * var objects = [
	 *   { 'a': { 'b': 2 } },
	 *   { 'a': { 'b': 1 } }
	 * ];
	 *
	 * _.map(objects, _.property('a.b'));
	 * // => [2, 1]
	 *
	 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
	 * // => [1, 2]
	 */
	function property(path) {
	  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
	}
	
	module.exports = property;


/***/ },
/* 770 */
/***/ function(module, exports, __webpack_require__) {

	var castPath = __webpack_require__(51),
	    isFunction = __webpack_require__(85),
	    toKey = __webpack_require__(52);
	
	/**
	 * This method is like `_.get` except that if the resolved value is a
	 * function it's invoked with the `this` binding of its parent object and
	 * its result is returned.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @param {Array|string} path The path of the property to resolve.
	 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
	 * @returns {*} Returns the resolved value.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
	 *
	 * _.result(object, 'a[0].b.c1');
	 * // => 3
	 *
	 * _.result(object, 'a[0].b.c2');
	 * // => 4
	 *
	 * _.result(object, 'a[0].b.c3', 'default');
	 * // => 'default'
	 *
	 * _.result(object, 'a[0].b.c3', _.constant('default'));
	 * // => 'default'
	 */
	function result(object, path, defaultValue) {
	  path = castPath(path, object);
	
	  var index = -1,
	      length = path.length;
	
	  // Ensure the loop is entered when path is empty.
	  if (!length) {
	    length = 1;
	    object = undefined;
	  }
	  while (++index < length) {
	    var value = object == null ? undefined : object[toKey(path[index])];
	    if (value === undefined) {
	      index = length;
	      value = defaultValue;
	    }
	    object = isFunction(value) ? value.call(object) : value;
	  }
	  return object;
	}
	
	module.exports = result;


/***/ },
/* 771 */
/***/ function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(140);
	
	/**
	 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
	 * it's created. Arrays are created for missing index properties while objects
	 * are created for all other missing properties. Use `_.setWith` to customize
	 * `path` creation.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.7.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.set(object, 'a[0].b.c', 4);
	 * console.log(object.a[0].b.c);
	 * // => 4
	 *
	 * _.set(object, ['x', '0', 'y', 'z'], 5);
	 * console.log(object.x[0].y.z);
	 * // => 5
	 */
	function set(object, path, value) {
	  return object == null ? object : baseSet(object, path, value);
	}
	
	module.exports = set;


/***/ },
/* 772 */
/***/ function(module, exports, __webpack_require__) {

	var baseSet = __webpack_require__(140);
	
	/**
	 * This method is like `_.set` except that it accepts `customizer` which is
	 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	 * path creation is handled by the method instead. The `customizer` is invoked
	 * with three arguments: (nsValue, key, nsObject).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {*} value The value to set.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {};
	 *
	 * _.setWith(object, '[0][1]', 'a', Object);
	 * // => { '0': { '1': 'a' } }
	 */
	function setWith(object, path, value, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return object == null ? object : baseSet(object, path, value, customizer);
	}
	
	module.exports = setWith;


/***/ },
/* 773 */
/***/ function(module, exports) {

	/**
	 * This method returns `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.13.0
	 * @category Util
	 * @returns {boolean} Returns `false`.
	 * @example
	 *
	 * _.times(2, _.stubFalse);
	 * // => [false, false]
	 */
	function stubFalse() {
	  return false;
	}
	
	module.exports = stubFalse;


/***/ },
/* 774 */
/***/ function(module, exports, __webpack_require__) {

	var copyObject = __webpack_require__(40),
	    keysIn = __webpack_require__(31);
	
	/**
	 * Converts `value` to a plain object flattening inherited enumerable string
	 * keyed properties of `value` to own properties of the plain object.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {Object} Returns the converted plain object.
	 * @example
	 *
	 * function Foo() {
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.assign({ 'a': 1 }, new Foo);
	 * // => { 'a': 1, 'b': 2 }
	 *
	 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
	 * // => { 'a': 1, 'b': 2, 'c': 3 }
	 */
	function toPlainObject(value) {
	  return copyObject(value, keysIn(value));
	}
	
	module.exports = toPlainObject;


/***/ },
/* 775 */
/***/ function(module, exports, __webpack_require__) {

	var baseToString = __webpack_require__(682);
	
	/**
	 * Converts `value` to a string. An empty string is returned for `null`
	 * and `undefined` values. The sign of `-0` is preserved.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to convert.
	 * @returns {string} Returns the converted string.
	 * @example
	 *
	 * _.toString(null);
	 * // => ''
	 *
	 * _.toString(-0);
	 * // => '-0'
	 *
	 * _.toString([1, 2, 3]);
	 * // => '1,2,3'
	 */
	function toString(value) {
	  return value == null ? '' : baseToString(value);
	}
	
	module.exports = toString;


/***/ },
/* 776 */
/***/ function(module, exports, __webpack_require__) {

	var arrayEach = __webpack_require__(299),
	    baseCreate = __webpack_require__(196),
	    baseForOwn = __webpack_require__(80),
	    baseIteratee = __webpack_require__(50),
	    getPrototype = __webpack_require__(142),
	    isArray = __webpack_require__(28),
	    isBuffer = __webpack_require__(111),
	    isFunction = __webpack_require__(85),
	    isObject = __webpack_require__(29),
	    isTypedArray = __webpack_require__(147);
	
	/**
	 * An alternative to `_.reduce`; this method transforms `object` to a new
	 * `accumulator` object which is the result of running each of its own
	 * enumerable string keyed properties thru `iteratee`, with each invocation
	 * potentially mutating the `accumulator` object. If `accumulator` is not
	 * provided, a new object with the same `[[Prototype]]` will be used. The
	 * iteratee is invoked with four arguments: (accumulator, value, key, object).
	 * Iteratee functions may exit iteration early by explicitly returning `false`.
	 *
	 * @static
	 * @memberOf _
	 * @since 1.3.0
	 * @category Object
	 * @param {Object} object The object to iterate over.
	 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
	 * @param {*} [accumulator] The custom accumulator value.
	 * @returns {*} Returns the accumulated value.
	 * @example
	 *
	 * _.transform([2, 3, 4], function(result, n) {
	 *   result.push(n *= n);
	 *   return n % 2 == 0;
	 * }, []);
	 * // => [4, 9]
	 *
	 * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
	 *   (result[value] || (result[value] = [])).push(key);
	 * }, {});
	 * // => { '1': ['a', 'c'], '2': ['b'] }
	 */
	function transform(object, iteratee, accumulator) {
	  var isArr = isArray(object),
	      isArrLike = isArr || isBuffer(object) || isTypedArray(object);
	
	  iteratee = baseIteratee(iteratee, 4);
	  if (accumulator == null) {
	    var Ctor = object && object.constructor;
	    if (isArrLike) {
	      accumulator = isArr ? new Ctor : [];
	    }
	    else if (isObject(object)) {
	      accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
	    }
	    else {
	      accumulator = {};
	    }
	  }
	  (isArrLike ? arrayEach : baseForOwn)(object, function(value, index, object) {
	    return iteratee(accumulator, value, index, object);
	  });
	  return accumulator;
	}
	
	module.exports = transform;


/***/ },
/* 777 */
/***/ function(module, exports, __webpack_require__) {

	var baseUnset = __webpack_require__(312);
	
	/**
	 * Removes the property at `path` of `object`.
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to unset.
	 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 7 } }] };
	 * _.unset(object, 'a[0].b.c');
	 * // => true
	 *
	 * console.log(object);
	 * // => { 'a': [{ 'b': {} }] };
	 *
	 * _.unset(object, ['a', '0', 'b', 'c']);
	 * // => true
	 *
	 * console.log(object);
	 * // => { 'a': [{ 'b': {} }] };
	 */
	function unset(object, path) {
	  return object == null ? true : baseUnset(object, path);
	}
	
	module.exports = unset;


/***/ },
/* 778 */
/***/ function(module, exports, __webpack_require__) {

	var baseUpdate = __webpack_require__(313),
	    castFunction = __webpack_require__(82);
	
	/**
	 * This method is like `_.set` except that accepts `updater` to produce the
	 * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
	 * is invoked with one argument: (value).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.6.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {Function} updater The function to produce the updated value.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
	 *
	 * _.update(object, 'a[0].b.c', function(n) { return n * n; });
	 * console.log(object.a[0].b.c);
	 * // => 9
	 *
	 * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
	 * console.log(object.x[0].y.z);
	 * // => 0
	 */
	function update(object, path, updater) {
	  return object == null ? object : baseUpdate(object, path, castFunction(updater));
	}
	
	module.exports = update;


/***/ },
/* 779 */
/***/ function(module, exports, __webpack_require__) {

	var baseUpdate = __webpack_require__(313),
	    castFunction = __webpack_require__(82);
	
	/**
	 * This method is like `_.update` except that it accepts `customizer` which is
	 * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
	 * path creation is handled by the method instead. The `customizer` is invoked
	 * with three arguments: (nsValue, key, nsObject).
	 *
	 * **Note:** This method mutates `object`.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.6.0
	 * @category Object
	 * @param {Object} object The object to modify.
	 * @param {Array|string} path The path of the property to set.
	 * @param {Function} updater The function to produce the updated value.
	 * @param {Function} [customizer] The function to customize assigned values.
	 * @returns {Object} Returns `object`.
	 * @example
	 *
	 * var object = {};
	 *
	 * _.updateWith(object, '[0][1]', _.constant('a'), Object);
	 * // => { '0': { '1': 'a' } }
	 */
	function updateWith(object, path, updater, customizer) {
	  customizer = typeof customizer == 'function' ? customizer : undefined;
	  return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
	}
	
	module.exports = updateWith;


/***/ },
/* 780 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(314),
	    keys = __webpack_require__(30);
	
	/**
	 * Creates an array of the own enumerable string keyed property values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @since 0.1.0
	 * @memberOf _
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.values(new Foo);
	 * // => [1, 2] (iteration order is not guaranteed)
	 *
	 * _.values('hi');
	 * // => ['h', 'i']
	 */
	function values(object) {
	  return object == null ? [] : baseValues(object, keys(object));
	}
	
	module.exports = values;


/***/ },
/* 781 */
/***/ function(module, exports, __webpack_require__) {

	var baseValues = __webpack_require__(314),
	    keysIn = __webpack_require__(31);
	
	/**
	 * Creates an array of the own and inherited enumerable string keyed property
	 * values of `object`.
	 *
	 * **Note:** Non-object values are coerced to objects.
	 *
	 * @static
	 * @memberOf _
	 * @since 3.0.0
	 * @category Object
	 * @param {Object} object The object to query.
	 * @returns {Array} Returns the array of property values.
	 * @example
	 *
	 * function Foo() {
	 *   this.a = 1;
	 *   this.b = 2;
	 * }
	 *
	 * Foo.prototype.c = 3;
	 *
	 * _.valuesIn(new Foo);
	 * // => [1, 2, 3] (iteration order is not guaranteed)
	 */
	function valuesIn(object) {
	  return object == null ? [] : baseValues(object, keysIn(object));
	}
	
	module.exports = valuesIn;


/***/ },
/* 782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _keys = __webpack_require__(163);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.getStyles = getStyles;
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconButton = __webpack_require__(86);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _menu = __webpack_require__(385);
	
	var _menu2 = _interopRequireDefault(_menu);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      appBar = _context$muiTheme.appBar,
	      iconButtonSize = _context$muiTheme.button.iconButtonSize,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var flatButtonSize = 36;
	
	  var styles = {
	    root: {
	      position: 'relative',
	      zIndex: zIndex.appBar,
	      width: '100%',
	      display: 'flex',
	      backgroundColor: appBar.color,
	      paddingLeft: appBar.padding,
	      paddingRight: appBar.padding
	    },
	    title: {
	      whiteSpace: 'nowrap',
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      margin: 0,
	      paddingTop: 0,
	      letterSpacing: 0,
	      fontSize: 24,
	      fontWeight: appBar.titleFontWeight,
	      color: appBar.textColor,
	      height: appBar.height,
	      lineHeight: appBar.height + 'px'
	    },
	    mainElement: {
	      boxFlex: 1,
	      flex: '1'
	    },
	    iconButtonStyle: {
	      marginTop: (appBar.height - iconButtonSize) / 2,
	      marginRight: 8,
	      marginLeft: -16
	    },
	    iconButtonIconStyle: {
	      fill: appBar.textColor,
	      color: appBar.textColor
	    },
	    flatButton: {
	      color: appBar.textColor,
	      marginTop: (iconButtonSize - flatButtonSize) / 2 + 1
	    }
	  };
	
	  return styles;
	}
	
	var AppBar = function (_Component) {
	  (0, _inherits3.default)(AppBar, _Component);
	
	  function AppBar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AppBar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AppBar.__proto__ || (0, _getPrototypeOf2.default)(AppBar)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapLeftIconButton = function (event) {
	      if (_this.props.onLeftIconButtonTouchTap) {
	        _this.props.onLeftIconButtonTouchTap(event);
	      }
	    }, _this.handleTouchTapRightIconButton = function (event) {
	      if (_this.props.onRightIconButtonTouchTap) {
	        _this.props.onRightIconButtonTouchTap(event);
	      }
	    }, _this.handleTitleTouchTap = function (event) {
	      if (_this.props.onTitleTouchTap) {
	        _this.props.onTitleTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AppBar, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconElementLeft || !this.props.iconClassNameLeft, 'Material-UI: Properties iconElementLeft\n      and iconClassNameLeft cannot be simultaneously defined. Please use one or the other.') : void 0;
	
	       false ? (0, _warning2.default)(!this.props.iconElementRight || !this.props.iconClassNameRight, 'Material-UI: Properties iconElementRight\n      and iconClassNameRight cannot be simultaneously defined. Please use one or the other.') : void 0;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          title = _props.title,
	          titleStyle = _props.titleStyle,
	          iconStyleLeft = _props.iconStyleLeft,
	          iconStyleRight = _props.iconStyleRight,
	          onTitleTouchTap = _props.onTitleTouchTap,
	          showMenuIconButton = _props.showMenuIconButton,
	          iconElementLeft = _props.iconElementLeft,
	          iconElementRight = _props.iconElementRight,
	          iconClassNameLeft = _props.iconClassNameLeft,
	          iconClassNameRight = _props.iconClassNameRight,
	          onLeftIconButtonTouchTap = _props.onLeftIconButtonTouchTap,
	          onRightIconButtonTouchTap = _props.onRightIconButtonTouchTap,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['title', 'titleStyle', 'iconStyleLeft', 'iconStyleRight', 'onTitleTouchTap', 'showMenuIconButton', 'iconElementLeft', 'iconElementRight', 'iconClassNameLeft', 'iconClassNameRight', 'onLeftIconButtonTouchTap', 'onRightIconButtonTouchTap', 'className', 'style', 'zDepth', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var menuElementLeft = void 0;
	      var menuElementRight = void 0;
	
	      // If the title is a string, wrap in an h1 tag.
	      // If not, wrap in a div tag.
	      var titleComponent = typeof title === 'string' || title instanceof String ? 'h1' : 'div';
	
	      var titleElement = _react2.default.createElement(titleComponent, {
	        onTouchTap: this.handleTitleTouchTap,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.title, styles.mainElement, titleStyle))
	      }, title);
	
	      var iconLeftStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, iconStyleLeft);
	
	      if (showMenuIconButton) {
	        if (iconElementLeft) {
	          var iconElementLeftProps = {};
	
	          if (iconElementLeft.type.muiName === 'IconButton') {
	            var iconElemLeftChildren = iconElementLeft.props.children;
	            var iconButtonIconStyle = !(iconElemLeftChildren && iconElemLeftChildren.props && iconElemLeftChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementLeftProps.iconStyle = (0, _simpleAssign2.default)({}, iconButtonIconStyle, iconElementLeft.props.iconStyle);
	          }
	
	          if (!iconElementLeft.props.onTouchTap && this.props.onLeftIconButtonTouchTap) {
	            iconElementLeftProps.onTouchTap = this.handleTouchTapLeftIconButton;
	          }
	
	          menuElementLeft = _react2.default.createElement(
	            'div',
	            { style: prepareStyles(iconLeftStyle) },
	            (0, _keys2.default)(iconElementLeftProps).length > 0 ? (0, _react.cloneElement)(iconElementLeft, iconElementLeftProps) : iconElementLeft
	          );
	        } else {
	          menuElementLeft = _react2.default.createElement(
	            _IconButton2.default,
	            {
	              style: iconLeftStyle,
	              iconStyle: styles.iconButtonIconStyle,
	              iconClassName: iconClassNameLeft,
	              onTouchTap: this.handleTouchTapLeftIconButton
	            },
	            iconClassNameLeft ? '' : _react2.default.createElement(_menu2.default, { style: (0, _simpleAssign2.default)({}, styles.iconButtonIconStyle) })
	          );
	        }
	      }
	
	      var iconRightStyle = (0, _simpleAssign2.default)({}, styles.iconButtonStyle, {
	        marginRight: -16,
	        marginLeft: 'auto'
	      }, iconStyleRight);
	
	      if (iconElementRight) {
	        var iconElementRightProps = {};
	
	        switch (iconElementRight.type.muiName) {
	          case 'IconMenu':
	          case 'IconButton':
	            var iconElemRightChildren = iconElementRight.props.children;
	            var _iconButtonIconStyle = !(iconElemRightChildren && iconElemRightChildren.props && iconElemRightChildren.props.color) ? styles.iconButtonIconStyle : null;
	
	            iconElementRightProps.iconStyle = (0, _simpleAssign2.default)({}, _iconButtonIconStyle, iconElementRight.props.iconStyle);
	            break;
	
	          case 'FlatButton':
	            iconElementRightProps.style = (0, _simpleAssign2.default)({}, styles.flatButton, iconElementRight.props.style);
	            break;
	
	          default:
	        }
	
	        if (!iconElementRight.props.onTouchTap && this.props.onRightIconButtonTouchTap) {
	          iconElementRightProps.onTouchTap = this.handleTouchTapRightIconButton;
	        }
	
	        menuElementRight = _react2.default.createElement(
	          'div',
	          { style: prepareStyles(iconRightStyle) },
	          (0, _keys2.default)(iconElementRightProps).length > 0 ? (0, _react.cloneElement)(iconElementRight, iconElementRightProps) : iconElementRight
	        );
	      } else if (iconClassNameRight) {
	        menuElementRight = _react2.default.createElement(_IconButton2.default, {
	          style: iconRightStyle,
	          iconStyle: styles.iconButtonIconStyle,
	          iconClassName: iconClassNameRight,
	          onTouchTap: this.handleTouchTapRightIconButton
	        });
	      }
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, {
	          rounded: false,
	          className: className,
	          style: (0, _simpleAssign2.default)({}, styles.root, style),
	          zDepth: zDepth
	        }),
	        menuElementLeft,
	        titleElement,
	        menuElementRight,
	        children
	      );
	    }
	  }]);
	  return AppBar;
	}(_react.Component);
	
	AppBar.muiName = 'AppBar';
	AppBar.defaultProps = {
	  showMenuIconButton: true,
	  title: '',
	  zDepth: 1
	};
	AppBar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? AppBar.propTypes = {
	  /**
	   * Can be used to render a tab inside an app bar for instance.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Applied to the app bar's root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The classname of the icon on the left of the app bar.
	   * If you are using a stylesheet for your icons, enter the class name for the icon to be used here.
	   */
	  iconClassNameLeft: _propTypes2.default.string,
	  /**
	   * Similiar to the iconClassNameLeft prop except that
	   * it applies to the icon displayed on the right of the app bar.
	   */
	  iconClassNameRight: _propTypes2.default.string,
	  /**
	   * The custom element to be displayed on the left side of the
	   * app bar such as an SvgIcon.
	   */
	  iconElementLeft: _propTypes2.default.element,
	  /**
	   * Similiar to the iconElementLeft prop except that this element is displayed on the right of the app bar.
	   */
	  iconElementRight: _propTypes2.default.element,
	  /**
	   * Override the inline-styles of the element displayed on the left side of the app bar.
	   */
	  iconStyleLeft: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the element displayed on the right side of the app bar.
	   */
	  iconStyleRight: _propTypes2.default.object,
	  /**
	   * Callback function for when the left icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the left `IconButton`.
	   */
	  onLeftIconButtonTouchTap: _propTypes2.default.func,
	  /**
	   * Callback function for when the right icon is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the right `IconButton`.
	   */
	  onRightIconButtonTouchTap: _propTypes2.default.func,
	  /**
	   * Callback function for when the title text is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the `title` node.
	   */
	  onTitleTouchTap: _propTypes2.default.func,
	  /**
	   * Determines whether or not to display the Menu icon next to the title.
	   * Setting this prop to false will hide the icon.
	   */
	  showMenuIconButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The title to display on the app bar.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the app bar's title element.
	   */
	  titleStyle: _propTypes2.default.object,
	  /**
	   * The zDepth of the component.
	   * The shadow of the app bar is also dependent on this property.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : void 0;
	exports.default = AppBar;

/***/ },
/* 783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AppBar = __webpack_require__(782);
	
	var _AppBar2 = _interopRequireDefault(_AppBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AppBar2.default;

/***/ },
/* 784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _typeof2 = __webpack_require__(69);
	
	var _typeof3 = _interopRequireDefault(_typeof2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _TextField = __webpack_require__(115);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Menu = __webpack_require__(356);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _MenuItem = __webpack_require__(217);
	
	var _MenuItem2 = _interopRequireDefault(_MenuItem);
	
	var _Divider = __webpack_require__(352);
	
	var _Divider2 = _interopRequireDefault(_Divider);
	
	var _Popover = __webpack_require__(87);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var anchorEl = state.anchorEl;
	  var fullWidth = props.fullWidth;
	
	
	  var styles = {
	    root: {
	      display: 'inline-block',
	      position: 'relative',
	      width: fullWidth ? '100%' : 256
	    },
	    menu: {
	      width: '100%'
	    },
	    list: {
	      display: 'block',
	      width: fullWidth ? '100%' : 256
	    },
	    innerDiv: {
	      overflow: 'hidden'
	    }
	  };
	
	  if (anchorEl && fullWidth) {
	    styles.popover = {
	      width: anchorEl.clientWidth
	    };
	  }
	
	  return styles;
	}
	
	var AutoComplete = function (_Component) {
	  (0, _inherits3.default)(AutoComplete, _Component);
	
	  function AutoComplete() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoComplete);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoComplete.__proto__ || (0, _getPrototypeOf2.default)(AutoComplete)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      anchorEl: null,
	      focusTextField: true,
	      open: false,
	      searchText: undefined
	    }, _this.handleRequestClose = function () {
	      // Only take into account the Popover clickAway when we are
	      // not focusing the TextField.
	      if (!_this.state.focusTextField) {
	        _this.close();
	      }
	    }, _this.handleMouseDown = function (event) {
	      // Keep the TextField focused
	      event.preventDefault();
	    }, _this.handleItemTouchTap = function (event, child) {
	      var dataSource = _this.props.dataSource;
	
	      var index = parseInt(child.key, 10);
	      var chosenRequest = dataSource[index];
	      var searchText = _this.chosenRequestText(chosenRequest);
	
	      _this.setState({
	        searchText: searchText
	      }, function () {
	        _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'touchTap'
	        });
	
	        _this.timerTouchTapCloseId = setTimeout(function () {
	          _this.timerTouchTapCloseId = null;
	          _this.close();
	          _this.props.onNewRequest(chosenRequest, index);
	        }, _this.props.menuCloseDelay);
	      });
	    }, _this.chosenRequestText = function (chosenRequest) {
	      if (typeof chosenRequest === 'string') {
	        return chosenRequest;
	      } else {
	        return chosenRequest[_this.props.dataSourceConfig.text];
	      }
	    }, _this.handleEscKeyDown = function () {
	      _this.close();
	    }, _this.handleKeyDown = function (event) {
	      if (_this.props.onKeyDown) _this.props.onKeyDown(event);
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.close();
	          var searchText = _this.state.searchText;
	          if (searchText !== '') {
	            _this.props.onNewRequest(searchText, -1);
	          }
	          break;
	
	        case 'esc':
	          _this.close();
	          break;
	
	        case 'down':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            focusTextField: false,
	            anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	          });
	          break;
	
	        default:
	          break;
	      }
	    }, _this.handleChange = function (event) {
	      var searchText = event.target.value;
	
	      // Make sure that we have a new searchText.
	      // Fix an issue with a Cordova Webview
	      if (searchText === _this.state.searchText) {
	        return;
	      }
	
	      _this.setState({
	        searchText: searchText,
	        open: true,
	        anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	      }, function () {
	        _this.props.onUpdateInput(searchText, _this.props.dataSource, {
	          source: 'change'
	        });
	      });
	    }, _this.handleBlur = function (event) {
	      if (_this.state.focusTextField && _this.timerTouchTapCloseId === null) {
	        _this.timerBlurClose = setTimeout(function () {
	          _this.close();
	        }, 0);
	      }
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      if (!_this.state.open && _this.props.openOnFocus) {
	        _this.setState({
	          open: true,
	          anchorEl: _reactDom2.default.findDOMNode(_this.refs.searchTextField)
	        });
	      }
	
	      _this.setState({
	        focusTextField: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoComplete, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.requestsList = [];
	      this.setState({
	        open: this.props.open,
	        searchText: this.props.searchText
	      });
	      this.timerTouchTapCloseId = null;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.searchText !== nextProps.searchText) {
	        this.setState({
	          searchText: nextProps.searchText
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerTouchTapCloseId);
	      clearTimeout(this.timerBlurClose);
	    }
	  }, {
	    key: 'close',
	    value: function close() {
	      this.setState({
	        open: false,
	        anchorEl: null
	      });
	
	      if (this.props.onClose) {
	        this.props.onClose();
	      }
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      this.refs.searchTextField.blur();
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.refs.searchTextField.focus();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          animated = _props.animated,
	          animation = _props.animation,
	          dataSource = _props.dataSource,
	          dataSourceConfig = _props.dataSourceConfig,
	          disableFocusRipple = _props.disableFocusRipple,
	          errorStyle = _props.errorStyle,
	          floatingLabelText = _props.floatingLabelText,
	          filter = _props.filter,
	          fullWidth = _props.fullWidth,
	          style = _props.style,
	          hintText = _props.hintText,
	          maxSearchResults = _props.maxSearchResults,
	          menuCloseDelay = _props.menuCloseDelay,
	          textFieldStyle = _props.textFieldStyle,
	          menuStyle = _props.menuStyle,
	          menuProps = _props.menuProps,
	          listStyle = _props.listStyle,
	          targetOrigin = _props.targetOrigin,
	          onBlur = _props.onBlur,
	          onClose = _props.onClose,
	          onFocus = _props.onFocus,
	          onKeyDown = _props.onKeyDown,
	          onNewRequest = _props.onNewRequest,
	          onUpdateInput = _props.onUpdateInput,
	          openOnFocus = _props.openOnFocus,
	          popoverProps = _props.popoverProps,
	          searchTextProp = _props.searchText,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'animated', 'animation', 'dataSource', 'dataSourceConfig', 'disableFocusRipple', 'errorStyle', 'floatingLabelText', 'filter', 'fullWidth', 'style', 'hintText', 'maxSearchResults', 'menuCloseDelay', 'textFieldStyle', 'menuStyle', 'menuProps', 'listStyle', 'targetOrigin', 'onBlur', 'onClose', 'onFocus', 'onKeyDown', 'onNewRequest', 'onUpdateInput', 'openOnFocus', 'popoverProps', 'searchText']);
	
	      var _ref2 = popoverProps || {},
	          popoverStyle = _ref2.style,
	          popoverOther = (0, _objectWithoutProperties3.default)(_ref2, ['style']);
	
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl,
	          searchText = _state.searchText,
	          focusTextField = _state.focusTextField;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var requestsList = [];
	
	      dataSource.every(function (item, index) {
	        switch (typeof item === 'undefined' ? 'undefined' : (0, _typeof3.default)(item)) {
	          case 'string':
	            if (filter(searchText, item, item)) {
	              requestsList.push({
	                text: item,
	                value: _react2.default.createElement(_MenuItem2.default, {
	                  innerDivStyle: styles.innerDiv,
	                  value: item,
	                  primaryText: item,
	                  disableFocusRipple: disableFocusRipple,
	                  key: index
	                })
	              });
	            }
	            break;
	
	          case 'object':
	            if (item && typeof item[_this2.props.dataSourceConfig.text] === 'string') {
	              var itemText = item[_this2.props.dataSourceConfig.text];
	              if (!_this2.props.filter(searchText, itemText, item)) break;
	
	              var itemValue = item[_this2.props.dataSourceConfig.value];
	              if (itemValue.type && (itemValue.type.muiName === _MenuItem2.default.muiName || itemValue.type.muiName === _Divider2.default.muiName)) {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.cloneElement(itemValue, {
	                    key: index,
	                    disableFocusRipple: disableFocusRipple
	                  })
	                });
	              } else {
	                requestsList.push({
	                  text: itemText,
	                  value: _react2.default.createElement(_MenuItem2.default, {
	                    innerDivStyle: styles.innerDiv,
	                    primaryText: itemText,
	                    disableFocusRipple: disableFocusRipple,
	                    key: index
	                  })
	                });
	              }
	            }
	            break;
	
	          default:
	          // Do nothing
	        }
	
	        return !(maxSearchResults && maxSearchResults > 0 && requestsList.length === maxSearchResults);
	      });
	
	      this.requestsList = requestsList;
	
	      var menu = open && requestsList.length > 0 && _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({
	          ref: 'menu',
	          autoWidth: false,
	          disableAutoFocus: focusTextField,
	          onEscKeyDown: this.handleEscKeyDown,
	          initiallyKeyboardFocused: true,
	          onItemTouchTap: this.handleItemTouchTap,
	          onMouseDown: this.handleMouseDown,
	          style: (0, _simpleAssign2.default)(styles.menu, menuStyle),
	          listStyle: (0, _simpleAssign2.default)(styles.list, listStyle)
	        }, menuProps),
	        requestsList.map(function (i) {
	          return i.value;
	        })
	      );
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({
	          ref: 'searchTextField',
	          autoComplete: 'off',
	          value: searchText,
	          onChange: this.handleChange,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onKeyDown: this.handleKeyDown,
	          floatingLabelText: floatingLabelText,
	          hintText: hintText,
	          fullWidth: fullWidth,
	          multiLine: false,
	          errorStyle: errorStyle,
	          style: textFieldStyle
	        }, other)),
	        _react2.default.createElement(
	          _Popover2.default,
	          (0, _extends3.default)({
	            style: (0, _simpleAssign2.default)({}, styles.popover, popoverStyle),
	            canAutoPosition: false,
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            useLayerForClickAway: false,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation
	          }, popoverOther),
	          menu
	        )
	      );
	    }
	  }]);
	  return AutoComplete;
	}(_react.Component);
	
	AutoComplete.defaultProps = {
	  anchorOrigin: {
	    vertical: 'bottom',
	    horizontal: 'left'
	  },
	  animated: true,
	  dataSourceConfig: {
	    text: 'text',
	    value: 'value'
	  },
	  disableFocusRipple: true,
	  filter: function filter(searchText, key) {
	    return searchText !== '' && key.indexOf(searchText) !== -1;
	  },
	  fullWidth: false,
	  open: false,
	  openOnFocus: false,
	  onUpdateInput: function onUpdateInput() {},
	  onNewRequest: function onNewRequest() {},
	  searchText: '',
	  menuCloseDelay: 300,
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	AutoComplete.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? AutoComplete.propTypes = {
	  /**
	   * Location of the anchor for the auto complete.
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the auto complete is animated as it is toggled.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * Array of strings or nodes used to populate the list.
	   */
	  dataSource: _propTypes2.default.array.isRequired,
	  /**
	   * Config for objects list dataSource.
	   *
	   * @typedef {Object} dataSourceConfig
	   *
	   * @property {string} text `dataSource` element key used to find a string to be matched for search
	   * and shown as a `TextField` input value after choosing the result.
	   * @property {string} value `dataSource` element key used to find a string to be shown in search results.
	   */
	  dataSourceConfig: _propTypes2.default.object,
	  /**
	   * Disables focus ripple when true.
	   */
	  disableFocusRipple: _propTypes2.default.bool,
	  /**
	   * Override style prop for error.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * Callback function used to filter the auto complete.
	   *
	   * @param {string} searchText The text to search for within `dataSource`.
	   * @param {string} key `dataSource` element, or `text` property on that element if it's not a string.
	   * @returns {boolean} `true` indicates the auto complete list will include `key` when the input is `searchText`.
	   */
	  filter: _propTypes2.default.func,
	  /**
	   * The content to use for adding floating label element.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the field receives the property `width: 100%`.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * Override style for list.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The max number of search results to be shown.
	   * By default it shows all the items which matches filter.
	   */
	  maxSearchResults: _propTypes2.default.number,
	  /**
	   * Delay for closing time of the menu.
	   */
	  menuCloseDelay: _propTypes2.default.number,
	  /**
	   * Props to be passed to menu.
	   */
	  menuProps: _propTypes2.default.object,
	  /**
	   * Override style for menu.
	   */
	  menuStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when a list item is selected, or enter is pressed in the `TextField`.
	   *
	   * @param {string} chosenRequest Either the `TextField` input value, if enter is pressed in the `TextField`,
	   * or the text value of the corresponding list item that was selected.
	   * @param {number} index The index in `dataSource` of the list item selected, or `-1` if enter is pressed in the
	   * `TextField`.
	   */
	  onNewRequest: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the user updates the `TextField`.
	   *
	   * @param {string} searchText The auto-complete's `searchText` value.
	   * @param {array} dataSource The auto-complete's `dataSource` array.
	   * @param {object} params Additional information linked the update.
	   */
	  onUpdateInput: _propTypes2.default.func,
	  /**
	   * Auto complete menu is open if true.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * If true, the list item is showed when a focus event triggers.
	   */
	  openOnFocus: _propTypes2.default.bool,
	  /**
	   * Props to be passed to popover.
	   */
	  popoverProps: _propTypes2.default.object,
	  /**
	   * Text being input to auto complete.
	   */
	  searchText: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Origin for location of target.
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Override the inline-styles of AutoComplete's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object
	} : void 0;
	
	
	AutoComplete.levenshteinDistance = function (searchText, key) {
	  var current = [];
	  var prev = void 0;
	  var value = void 0;
	
	  for (var i = 0; i <= key.length; i++) {
	    for (var j = 0; j <= searchText.length; j++) {
	      if (i && j) {
	        if (searchText.charAt(j - 1) === key.charAt(i - 1)) value = prev;else value = Math.min(current[j], current[j - 1], prev) + 1;
	      } else {
	        value = i + j;
	      }
	      prev = current[j];
	      current[j] = value;
	    }
	  }
	  return current.pop();
	};
	
	AutoComplete.noFilter = function () {
	  return true;
	};
	
	AutoComplete.defaultFilter = AutoComplete.caseSensitiveFilter = function (searchText, key) {
	  return searchText !== '' && key.indexOf(searchText) !== -1;
	};
	
	AutoComplete.caseInsensitiveFilter = function (searchText, key) {
	  return key.toLowerCase().indexOf(searchText.toLowerCase()) !== -1;
	};
	
	AutoComplete.levenshteinDistanceFilter = function (distanceLessThan) {
	  if (distanceLessThan === undefined) {
	    return AutoComplete.levenshteinDistance;
	  } else if (typeof distanceLessThan !== 'number') {
	    throw 'Error: AutoComplete.levenshteinDistanceFilter is a filter generator, not a filter!';
	  }
	
	  return function (s, k) {
	    return AutoComplete.levenshteinDistance(s, k) < distanceLessThan;
	  };
	};
	
	AutoComplete.fuzzyFilter = function (searchText, key) {
	  var compareString = key.toLowerCase();
	  searchText = searchText.toLowerCase();
	
	  var searchTextIndex = 0;
	  for (var index = 0; index < key.length; index++) {
	    if (compareString[index] === searchText[searchTextIndex]) {
	      searchTextIndex += 1;
	    }
	  }
	
	  return searchTextIndex === searchText.length;
	};
	
	AutoComplete.Item = _MenuItem2.default;
	AutoComplete.Divider = _Divider2.default;
	
	exports.default = AutoComplete;

/***/ },
/* 785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _AutoComplete = __webpack_require__(784);
	
	var _AutoComplete2 = _interopRequireDefault(_AutoComplete);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _AutoComplete2.default;

/***/ },
/* 786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var backgroundColor = props.backgroundColor,
	      color = props.color,
	      size = props.size;
	  var avatar = context.muiTheme.avatar;
	
	
	  var styles = {
	    root: {
	      color: color || avatar.color,
	      backgroundColor: backgroundColor || avatar.backgroundColor,
	      userSelect: 'none',
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      fontSize: size / 2,
	      borderRadius: '50%',
	      height: size,
	      width: size
	    },
	    icon: {
	      color: color || avatar.color,
	      width: size * 0.6,
	      height: size * 0.6,
	      fontSize: size * 0.6,
	      margin: size * 0.2
	    }
	  };
	
	  return styles;
	}
	
	var Avatar = function (_Component) {
	  (0, _inherits3.default)(Avatar, _Component);
	
	  function Avatar() {
	    (0, _classCallCheck3.default)(this, Avatar);
	    return (0, _possibleConstructorReturn3.default)(this, (Avatar.__proto__ || (0, _getPrototypeOf2.default)(Avatar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Avatar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          icon = _props.icon,
	          src = _props.src,
	          style = _props.style,
	          className = _props.className,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'icon', 'src', 'style', 'className']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      if (src) {
	        return _react2.default.createElement('img', (0, _extends3.default)({
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }, other, {
	          src: src,
	          className: className
	        }));
	      } else {
	        return _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, {
	            style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)),
	            className: className
	          }),
	          icon && _react2.default.cloneElement(icon, {
	            color: styles.icon.color,
	            style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	          }),
	          this.props.children
	        );
	      }
	    }
	  }]);
	  return Avatar;
	}(_react.Component);
	
	Avatar.muiName = 'Avatar';
	Avatar.defaultProps = {
	  size: 40
	};
	Avatar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Avatar.propTypes = {
	  /**
	   * The backgroundColor of the avatar. Does not apply to image avatars.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Can be used, for instance, to render a letter inside the avatar.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root `div` or `img` element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The icon or letter's color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the SvgIcon or FontIcon to be used inside the avatar.
	   */
	  icon: _propTypes2.default.element,
	  /**
	   * This is the size of the avatar in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * If passed in, this component will render an img element. Otherwise, a div will be rendered.
	   */
	  src: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = Avatar;

/***/ },
/* 787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var primary = props.primary,
	      secondary = props.secondary;
	  var badge = context.muiTheme.badge;
	
	
	  var badgeBackgroundColor = void 0;
	  var badgeTextColor = void 0;
	
	  if (primary) {
	    badgeBackgroundColor = badge.primaryColor;
	    badgeTextColor = badge.primaryTextColor;
	  } else if (secondary) {
	    badgeBackgroundColor = badge.secondaryColor;
	    badgeTextColor = badge.secondaryTextColor;
	  } else {
	    badgeBackgroundColor = badge.color;
	    badgeTextColor = badge.textColor;
	  }
	
	  var radius = 12;
	  var radius2x = Math.floor(2 * radius);
	
	  return {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      padding: radius2x + 'px ' + radius2x + 'px ' + radius + 'px ' + radius + 'px'
	    },
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      fontWeight: badge.fontWeight,
	      fontSize: radius,
	      width: radius2x,
	      height: radius2x,
	      borderRadius: '50%',
	      backgroundColor: badgeBackgroundColor,
	      color: badgeTextColor
	    }
	  };
	}
	
	var Badge = function (_Component) {
	  (0, _inherits3.default)(Badge, _Component);
	
	  function Badge() {
	    (0, _classCallCheck3.default)(this, Badge);
	    return (0, _possibleConstructorReturn3.default)(this, (Badge.__proto__ || (0, _getPrototypeOf2.default)(Badge)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Badge, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          badgeContent = _props.badgeContent,
	          badgeStyle = _props.badgeStyle,
	          children = _props.children,
	          primary = _props.primary,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['badgeContent', 'badgeStyle', 'children', 'primary', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, styles.badge, badgeStyle)) },
	          badgeContent
	        )
	      );
	    }
	  }]);
	  return Badge;
	}(_react.Component);
	
	Badge.defaultProps = {
	  primary: false,
	  secondary: false
	};
	Badge.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Badge.propTypes = {
	  /**
	   * This is the content rendered within the badge.
	   */
	  badgeContent: _propTypes2.default.node.isRequired,
	  /**
	   * Override the inline-styles of the badge element.
	   */
	  badgeStyle: _propTypes2.default.object,
	  /**
	   * The badge will be added relativelty to this node.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the badge will use the primary badge colors.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * If true, the badge will use the secondary badge colors.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = Badge;

/***/ },
/* 788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Badge = __webpack_require__(787);
	
	var _Badge2 = _interopRequireDefault(_Badge);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Badge2.default;

/***/ },
/* 789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var bottomNavigation = context.muiTheme.bottomNavigation;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      width: '100%',
	      display: 'flex',
	      justifyContent: 'center',
	      backgroundColor: bottomNavigation.backgroundColor,
	      height: bottomNavigation.height
	    },
	    item: {
	      flex: '1'
	    }
	  };
	
	  return styles;
	}
	
	var BottomNavigation = function BottomNavigation(props, context) {
	  var children = props.children,
	      style = props.style,
	      selectedIndex = props.selectedIndex,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'style', 'selectedIndex']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var preparedChildren = _react.Children.map(children, function (child, index) {
	    return (0, _react.cloneElement)(child, {
	      style: (0, _simpleAssign2.default)({}, styles.item, child.props.style),
	      selected: index === selectedIndex
	    });
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	    preparedChildren
	  );
	};
	
	 false ? BottomNavigation.propTypes = {
	  /**
	   * The `BottomNavigationItem`s to populate the element with.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The index of the currently selected navigation item.
	   */
	  selectedIndex: _propTypes2.default.number,
	  /**
	   * @ignore
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	
	BottomNavigation.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = BottomNavigation;

/***/ },
/* 790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.BottomNavigationItem = exports.BottomNavigation = undefined;
	
	var _BottomNavigation2 = __webpack_require__(789);
	
	var _BottomNavigation3 = _interopRequireDefault(_BottomNavigation2);
	
	var _BottomNavigationItem2 = __webpack_require__(345);
	
	var _BottomNavigationItem3 = _interopRequireDefault(_BottomNavigationItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.BottomNavigation = _BottomNavigation3.default;
	exports.BottomNavigationItem = _BottomNavigationItem3.default;
	exports.default = _BottomNavigation3.default;

/***/ },
/* 791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _CardExpandable = __webpack_require__(347);
	
	var _CardExpandable2 = _interopRequireDefault(_CardExpandable);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Card = function (_Component) {
	  (0, _inherits3.default)(Card, _Component);
	
	  function Card() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Card);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Card.__proto__ || (0, _getPrototypeOf2.default)(Card)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      expanded: null
	    }, _this.handleExpanding = function (event) {
	      event.preventDefault();
	      var newExpandedState = !_this.state.expanded;
	      // no automatic state update when the component is controlled
	      if (_this.props.expanded === null) {
	        _this.setState({ expanded: newExpandedState });
	      }
	      if (_this.props.onExpandChange) {
	        _this.props.onExpandChange(newExpandedState);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Card, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        expanded: this.props.expanded === null ? this.props.initiallyExpanded === true : this.props.expanded
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // update the state when the component is controlled.
	      if (nextProps.expanded !== null) this.setState({ expanded: nextProps.expanded });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          style = _props.style,
	          containerStyle = _props.containerStyle,
	          children = _props.children,
	          expandable = _props.expandable,
	          expandedProp = _props.expanded,
	          initiallyExpanded = _props.initiallyExpanded,
	          onExpandChange = _props.onExpandChange,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'containerStyle', 'children', 'expandable', 'expanded', 'initiallyExpanded', 'onExpandChange']);
	
	
	      var lastElement = void 0;
	      var expanded = this.state.expanded;
	      var newChildren = _react2.default.Children.map(children, function (currentChild) {
	        var doClone = false;
	        var newChild = undefined;
	        var newProps = {};
	        var element = currentChild;
	        if (!currentChild || !currentChild.props) {
	          return null;
	        }
	        if (expanded === false && currentChild.props.expandable === true) return;
	        if (currentChild.props.actAsExpander === true) {
	          doClone = true;
	          newProps.onTouchTap = _this2.handleExpanding;
	          newProps.style = (0, _simpleAssign2.default)({ cursor: 'pointer' }, currentChild.props.style);
	        }
	        if (currentChild.props.showExpandableButton === true) {
	          doClone = true;
	          newChild = _react2.default.createElement(_CardExpandable2.default, {
	            closeIcon: currentChild.props.closeIcon,
	            expanded: expanded,
	            onExpanding: _this2.handleExpanding,
	            openIcon: currentChild.props.openIcon
	          });
	        }
	        if (doClone) {
	          element = _react2.default.cloneElement(currentChild, newProps, currentChild.props.children, newChild);
	        }
	        lastElement = element;
	        return element;
	      }, this);
	
	      // If the last element is text or a title we should add
	      // 8px padding to the bottom of the card
	      var addBottomPadding = lastElement && (lastElement.type.muiName === 'CardText' || lastElement.type.muiName === 'CardTitle');
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        zIndex: 1
	      }, style);
	      var containerMergedStyles = (0, _simpleAssign2.default)({
	        paddingBottom: addBottomPadding ? 8 : 0
	      }, containerStyle);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({}, other, { style: mergedStyles }),
	        _react2.default.createElement(
	          'div',
	          { style: containerMergedStyles },
	          newChildren
	        )
	      );
	    }
	  }]);
	  return Card;
	}(_react.Component);
	
	Card.defaultProps = {
	  expandable: false,
	  expanded: null,
	  initiallyExpanded: false
	};
	 false ? Card.propTypes = {
	  /**
	   * Can be used to render elements inside the Card.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If true, this card component is expandable. Can be set on any child of the `Card` component.
	   */
	  expandable: _propTypes2.default.bool,
	  /**
	   * Whether this card is expanded.
	   * If `true` or `false` the component is controlled.
	   * if `null` the component is uncontrolled.
	   */
	  expanded: _propTypes2.default.bool,
	  /**
	   * Whether this card is initially expanded.
	   */
	  initiallyExpanded: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `expandable` state of the card has changed.
	   *
	   * @param {boolean} newExpandedState Represents the new `expanded` state of the card.
	   */
	  onExpandChange: _propTypes2.default.func,
	  /**
	   * If true, this card component will include a button to expand the card. `CardTitle`,
	   * `CardHeader` and `CardActions` implement `showExpandableButton`. Any child component
	   * of `Card` can implements `showExpandableButton` or forwards the property to a child
	   * component supporting it.
	   */
	  showExpandableButton: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = Card;

/***/ },
/* 792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.CardExpandable = exports.CardActions = exports.CardText = exports.CardMedia = exports.CardTitle = exports.CardHeader = exports.Card = undefined;
	
	var _Card2 = __webpack_require__(791);
	
	var _Card3 = _interopRequireDefault(_Card2);
	
	var _CardHeader2 = __webpack_require__(348);
	
	var _CardHeader3 = _interopRequireDefault(_CardHeader2);
	
	var _CardTitle2 = __webpack_require__(351);
	
	var _CardTitle3 = _interopRequireDefault(_CardTitle2);
	
	var _CardMedia2 = __webpack_require__(349);
	
	var _CardMedia3 = _interopRequireDefault(_CardMedia2);
	
	var _CardText2 = __webpack_require__(350);
	
	var _CardText3 = _interopRequireDefault(_CardText2);
	
	var _CardActions2 = __webpack_require__(346);
	
	var _CardActions3 = _interopRequireDefault(_CardActions2);
	
	var _CardExpandable2 = __webpack_require__(347);
	
	var _CardExpandable3 = _interopRequireDefault(_CardExpandable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Card = _Card3.default;
	exports.CardHeader = _CardHeader3.default;
	exports.CardTitle = _CardTitle3.default;
	exports.CardMedia = _CardMedia3.default;
	exports.CardText = _CardText3.default;
	exports.CardActions = _CardActions3.default;
	exports.CardExpandable = _CardExpandable3.default;
	exports.default = _Card3.default;

/***/ },
/* 793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedSwitch = __webpack_require__(221);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _checkBoxOutlineBlank = __webpack_require__(386);
	
	var _checkBoxOutlineBlank2 = _interopRequireDefault(_checkBoxOutlineBlank);
	
	var _checkBox = __webpack_require__(387);
	
	var _checkBox2 = _interopRequireDefault(_checkBox);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var checkbox = context.muiTheme.checkbox;
	
	  var checkboxSize = 24;
	
	  return {
	    icon: {
	      height: checkboxSize,
	      width: checkboxSize
	    },
	    check: {
	      position: 'absolute',
	      opacity: 0,
	      transform: 'scale(0)',
	      transitionOrigin: '50% 50%',
	      transition: _transitions2.default.easeOut('450ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('0ms', 'transform', '450ms'),
	      fill: checkbox.checkedColor
	    },
	    checkWhenSwitched: {
	      opacity: 1,
	      transform: 'scale(1)',
	      transition: _transitions2.default.easeOut('0ms', 'opacity', '0ms') + ', ' + _transitions2.default.easeOut('800ms', 'transform', '0ms')
	    },
	    checkWhenDisabled: {
	      fill: checkbox.disabledColor
	    },
	    box: {
	      position: 'absolute',
	      opacity: 1,
	      fill: checkbox.boxColor,
	      transition: _transitions2.default.easeOut('1000ms', 'opacity', '200ms')
	    },
	    boxWhenSwitched: {
	      opacity: 0,
	      transition: _transitions2.default.easeOut('650ms', 'opacity', '150ms'),
	      fill: checkbox.checkedColor
	    },
	    boxWhenDisabled: {
	      fill: props.checked ? 'transparent' : checkbox.disabledColor
	    },
	    label: {
	      color: props.disabled ? checkbox.labelDisabledColor : checkbox.labelColor
	    }
	  };
	}
	
	var Checkbox = function (_Component) {
	  (0, _inherits3.default)(Checkbox, _Component);
	
	  function Checkbox() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Checkbox);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Checkbox.__proto__ || (0, _getPrototypeOf2.default)(Checkbox)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleCheck = function (event, isInputChecked) {
	      if (_this.props.onCheck) {
	        _this.props.onCheck(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Checkbox, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          checked = _props.checked,
	          defaultChecked = _props.defaultChecked,
	          valueLink = _props.valueLink;
	
	
	      if (checked || defaultChecked || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.checked !== nextProps.checked) {
	        this.setState({
	          switched: nextProps.checked
	        });
	      }
	    }
	  }, {
	    key: 'isChecked',
	    value: function isChecked() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setChecked',
	    value: function setChecked(newCheckedValue) {
	      this.refs.enhancedSwitch.setSwitched(newCheckedValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          iconStyle = _props2.iconStyle,
	          onCheck = _props2.onCheck,
	          checkedIcon = _props2.checkedIcon,
	          uncheckedIcon = _props2.uncheckedIcon,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['iconStyle', 'onCheck', 'checkedIcon', 'uncheckedIcon']);
	
	      var styles = getStyles(this.props, this.context);
	      var boxStyles = (0, _simpleAssign2.default)(styles.box, this.state.switched && styles.boxWhenSwitched, iconStyle, this.props.disabled && styles.boxWhenDisabled);
	      var checkStyles = (0, _simpleAssign2.default)(styles.check, this.state.switched && styles.checkWhenSwitched, iconStyle, this.props.disabled && styles.checkWhenDisabled);
	
	      var checkedElement = checkedIcon ? _react2.default.cloneElement(checkedIcon, {
	        style: (0, _simpleAssign2.default)(checkStyles, checkedIcon.props.style)
	      }) : _react2.default.createElement(_checkBox2.default, {
	        style: checkStyles
	      });
	
	      var unCheckedElement = uncheckedIcon ? _react2.default.cloneElement(uncheckedIcon, {
	        style: (0, _simpleAssign2.default)(boxStyles, uncheckedIcon.props.style)
	      }) : _react2.default.createElement(_checkBoxOutlineBlank2.default, {
	        style: boxStyles
	      });
	
	      var checkboxElement = _react2.default.createElement(
	        'div',
	        null,
	        unCheckedElement,
	        checkedElement
	      );
	
	      var rippleColor = this.state.switched ? checkStyles.fill : boxStyles.fill;
	      var mergedIconStyle = (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	      var labelStyle = (0, _simpleAssign2.default)(styles.label, this.props.labelStyle);
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switched: this.state.switched,
	        switchElement: checkboxElement,
	        rippleColor: rippleColor,
	        iconStyle: mergedIconStyle,
	        onSwitch: this.handleCheck,
	        labelStyle: labelStyle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Checkbox;
	}(_react.Component);
	
	Checkbox.defaultProps = {
	  labelPosition: 'right',
	  disabled: false
	};
	Checkbox.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Checkbox.propTypes = {
	  /**
	   * Checkbox is checked if true.
	   */
	  checked: _propTypes2.default.bool,
	  /**
	   * The SvgIcon to use for the checked state.
	   * This is useful to create icon toggles.
	   */
	  checkedIcon: _propTypes2.default.element,
	  /**
	   * The default state of our checkbox component.
	   * **Warning:** This cannot be used in conjunction with `checked`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultChecked: _propTypes2.default.bool,
	  /**
	   * Disabled if true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * Where the label will be placed next to the checkbox.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Checkbox element label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function that is fired when the checkbox is checked.
	   *
	   * @param {object} event `change` event targeting the underlying checkbox `input`.
	   * @param {boolean} isInputChecked The `checked` value of the underlying checkbox `input`.
	   */
	  onCheck: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The SvgIcon to use for the unchecked state.
	   * This is useful to create icon toggles.
	   */
	  uncheckedIcon: _propTypes2.default.element,
	  /**
	   * ValueLink for when using controlled checkbox.
	   */
	  valueLink: _propTypes2.default.object
	} : void 0;
	exports.default = Checkbox;

/***/ },
/* 794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _colorManipulator = __webpack_require__(53);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _cancel = __webpack_require__(379);
	
	var _cancel2 = _interopRequireDefault(_cancel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var chip = context.muiTheme.chip;
	
	
	  var backgroundColor = props.backgroundColor || chip.backgroundColor;
	  var focusColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.08);
	  var pressedColor = (0, _colorManipulator.emphasize)(backgroundColor, 0.12);
	
	  return {
	    avatar: {
	      marginRight: -4
	    },
	    deleteIcon: {
	      color: state.deleteHovered ? (0, _colorManipulator.fade)(chip.deleteIconColor, 0.4) : chip.deleteIconColor,
	      cursor: 'pointer',
	      margin: '4px 4px 0px -8px'
	    },
	    label: {
	      color: props.labelColor || chip.textColor,
	      fontSize: chip.fontSize,
	      fontWeight: chip.fontWeight,
	      lineHeight: '32px',
	      paddingLeft: 12,
	      paddingRight: 12,
	      userSelect: 'none',
	      whiteSpace: 'nowrap'
	    },
	    root: {
	      backgroundColor: state.clicked ? pressedColor : state.focused || state.hovered ? focusColor : backgroundColor,
	      borderRadius: 16,
	      boxShadow: state.clicked ? chip.shadow : null,
	      cursor: props.onTouchTap ? 'pointer' : 'default',
	      display: 'flex',
	      whiteSpace: 'nowrap',
	      width: 'fit-content'
	    }
	  };
	}
	
	var Chip = function (_Component) {
	  (0, _inherits3.default)(Chip, _Component);
	
	  function Chip() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Chip);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Chip.__proto__ || (0, _getPrototypeOf2.default)(Chip)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      clicked: false,
	      deleteHovered: false,
	      focused: false,
	      hovered: false
	    }, _this.handleBlur = function (event) {
	      _this.setState({ clicked: false, focused: false });
	      _this.props.onBlur(event);
	    }, _this.handleFocus = function (event) {
	      if (_this.props.onTouchTap || _this.props.onRequestDelete) {
	        _this.setState({ focused: true });
	      }
	      _this.props.onFocus(event);
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused) {
	        _this.handleFocus();
	        _this.props.onFocus(event);
	      } else {
	        _this.handleBlur();
	      }
	
	      _this.props.onKeyboardFocus(event, keyboardFocused);
	    }, _this.handleKeyDown = function (event) {
	      if ((0, _keycode2.default)(event) === 'backspace') {
	        event.preventDefault();
	        if (_this.props.onRequestDelete) {
	          _this.props.onRequestDelete(event);
	        }
	      }
	      _this.props.onKeyDown(event);
	    }, _this.handleMouseDown = function (event) {
	      // Only listen to left clicks
	      if (event.button === 0) {
	        event.stopPropagation();
	        if (_this.props.onTouchTap) {
	          _this.setState({ clicked: true });
	        }
	      }
	      _this.props.onMouseDown(event);
	    }, _this.handleMouseEnter = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.setState({ hovered: true });
	      }
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseEnterDeleteIcon = function () {
	      _this.setState({ deleteHovered: true });
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({
	        clicked: false,
	        hovered: false
	      });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseLeaveDeleteIcon = function () {
	      _this.setState({ deleteHovered: false });
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onMouseUp(event);
	    }, _this.handleTouchTapDeleteIcon = function (event) {
	      // Stop the event from bubbling up to the `Chip`
	      event.stopPropagation();
	      _this.props.onRequestDelete(event);
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({ clicked: false });
	      _this.props.onTouchEnd(event);
	    }, _this.handleTouchStart = function (event) {
	      event.stopPropagation();
	      if (_this.props.onTouchTap) {
	        _this.setState({ clicked: true });
	      }
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Chip, [{
	    key: 'render',
	    value: function render() {
	      var buttonEventHandlers = {
	        onBlur: this.handleBlur,
	        onFocus: this.handleFocus,
	        onKeyDown: this.handleKeyDown,
	        onMouseDown: this.handleMouseDown,
	        onMouseEnter: this.handleMouseEnter,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseUp: this.handleMouseUp,
	        onTouchEnd: this.handleTouchEnd,
	        onTouchStart: this.handleTouchStart,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var _props = this.props,
	          childrenProp = _props.children,
	          containerElement = _props.containerElement,
	          style = _props.style,
	          className = _props.className,
	          labelStyle = _props.labelStyle,
	          labelColor = _props.labelColor,
	          backgroundColor = _props.backgroundColor,
	          onRequestDelete = _props.onRequestDelete,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'containerElement', 'style', 'className', 'labelStyle', 'labelColor', 'backgroundColor', 'onRequestDelete']);
	
	
	      var deletable = this.props.onRequestDelete;
	      var avatar = null;
	
	      var deleteIcon = deletable ? _react2.default.createElement(_cancel2.default, {
	        color: styles.deleteIcon.color,
	        style: styles.deleteIcon,
	        onTouchTap: this.handleTouchTapDeleteIcon,
	        onMouseEnter: this.handleMouseEnterDeleteIcon,
	        onMouseLeave: this.handleMouseLeaveDeleteIcon
	      }) : null;
	
	      var children = childrenProp;
	      var childCount = _react2.default.Children.count(children);
	
	      // If the first child is an avatar, extract it and style it
	      if (childCount > 1) {
	        children = _react2.default.Children.toArray(children);
	
	        if (_react2.default.isValidElement(children[0]) && children[0].type.muiName === 'Avatar') {
	          avatar = children.shift();
	
	          avatar = _react2.default.cloneElement(avatar, {
	            style: (0, _simpleAssign2.default)(styles.avatar, avatar.props.style),
	            size: 32
	          });
	        }
	      }
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, buttonEventHandlers, {
	          className: className,
	          containerElement: containerElement,
	          disableTouchRipple: true,
	          disableFocusRipple: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }),
	        avatar,
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	          children
	        ),
	        deleteIcon
	      );
	    }
	  }]);
	  return Chip;
	}(_react.Component);
	
	Chip.defaultProps = {
	  containerElement: 'div', // Firefox doesn't support nested buttons
	  onBlur: function onBlur() {},
	  onFocus: function onFocus() {},
	  onKeyDown: function onKeyDown() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseUp: function onMouseUp() {},
	  onTouchEnd: function onTouchEnd() {},
	  onTouchStart: function onTouchStart() {}
	};
	Chip.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
	 false ? Chip.propTypes = {
	  /**
	   * Override the background color of the chip.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Used to render elements inside the Chip.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * CSS `className` of the root element.
	   */
	  className: _propTypes2.default.node,
	  /**
	   * The element to use as the container for the Chip. Either a string to
	   * use a DOM element or a ReactElement.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * Override the label color.
	   */
	  labelColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /** @ignore */
	  onKeyDown: _propTypes2.default.func,
	  /** @ignore */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * Callback function fired when the delete icon is clicked. If set, the delete icon will be shown.
	   * @param {object} event `touchTap` event targeting the element.
	   */
	  onRequestDelete: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `Chip` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the element.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = Chip;

/***/ },
/* 795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Chip = __webpack_require__(794);
	
	var _Chip2 = _interopRequireDefault(_Chip);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Chip2.default;

/***/ },
/* 796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autoPrefix = __webpack_require__(64);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  return clampedValue / (max - min);
	}
	
	function getArcLength(fraction, props) {
	  return fraction * Math.PI * (props.size - props.thickness);
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      size = props.size,
	      value = props.value;
	  var palette = context.muiTheme.baseTheme.palette;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      display: 'inline-block',
	      width: size,
	      height: size
	    },
	    wrapper: {
	      width: size,
	      height: size,
	      display: 'inline-block',
	      transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	      transitionTimingFunction: 'linear'
	    },
	    svg: {
	      width: size,
	      height: size,
	      position: 'relative'
	    },
	    path: {
	      stroke: props.color || palette.primary1Color,
	      strokeLinecap: 'round',
	      transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	    }
	  };
	
	  if (props.mode === 'determinate') {
	    var relVal = getRelativeValue(value, min, max);
	    styles.path.transition = _transitions2.default.create('all', '0.3s', null, 'linear');
	    styles.path.strokeDasharray = getArcLength(relVal, props) + ', ' + getArcLength(1, props);
	  }
	
	  return styles;
	}
	
	var CircularProgress = function (_Component) {
	  (0, _inherits3.default)(CircularProgress, _Component);
	
	  function CircularProgress() {
	    (0, _classCallCheck3.default)(this, CircularProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (CircularProgress.__proto__ || (0, _getPrototypeOf2.default)(CircularProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircularProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path) {
	      var _this2 = this;
	
	      var step = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      step %= 3;
	
	      if (step === 0) {
	        path.style.strokeDasharray = getArcLength(0, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = 0;
	        path.style.transitionDuration = '0ms';
	      } else if (step === 1) {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-0.3, this.props);
	        path.style.transitionDuration = '750ms';
	      } else {
	        path.style.strokeDasharray = getArcLength(0.7, this.props) + ', ' + getArcLength(1, this.props);
	        path.style.strokeDashoffset = getArcLength(-1, this.props);
	        path.style.transitionDuration = '850ms';
	      }
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, step + 1);
	      }, step ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          innerStyle = _props.innerStyle,
	          size = _props.size,
	          thickness = _props.thickness,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'innerStyle', 'size', 'thickness']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper', style: prepareStyles((0, _simpleAssign2.default)(styles.wrapper, innerStyle)) },
	          _react2.default.createElement(
	            'svg',
	            {
	              viewBox: '0 0 ' + size + ' ' + size,
	              style: prepareStyles(styles.svg)
	            },
	            _react2.default.createElement('circle', {
	              ref: 'path',
	              style: prepareStyles(styles.path),
	              cx: size / 2,
	              cy: size / 2,
	              r: (size - thickness) / 2,
	              fill: 'none',
	              strokeWidth: thickness,
	              strokeMiterlimit: '20'
	            })
	          )
	        )
	      );
	    }
	  }]);
	  return CircularProgress;
	}(_react.Component);
	
	CircularProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100,
	  size: 40,
	  thickness: 3.5
	};
	CircularProgress.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? CircularProgress.propTypes = {
	  /**
	   * Override the progress's color.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * Style for inner wrapper div.
	   */
	  innerStyle: _propTypes2.default.object,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _propTypes2.default.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _propTypes2.default.number,
	  /**
	   * The mode of show your progress, indeterminate
	   * for when there is no value for progress.
	   */
	  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	  /**
	   * The diameter of the progress in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Stroke width in pixels.
	   */
	  thickness: _propTypes2.default.number,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _propTypes2.default.number
	} : void 0;
	exports.default = CircularProgress;

/***/ },
/* 797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _CircularProgress = __webpack_require__(796);
	
	var _CircularProgress2 = _interopRequireDefault(_CircularProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _CircularProgress2.default;

/***/ },
/* 798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _toConsumableArray2 = __webpack_require__(97);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(44);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _CalendarActionButtons = __webpack_require__(799);
	
	var _CalendarActionButtons2 = _interopRequireDefault(_CalendarActionButtons);
	
	var _CalendarMonth = __webpack_require__(800);
	
	var _CalendarMonth2 = _interopRequireDefault(_CalendarMonth);
	
	var _CalendarYear = __webpack_require__(802);
	
	var _CalendarYear2 = _interopRequireDefault(_CalendarYear);
	
	var _CalendarToolbar = __webpack_require__(801);
	
	var _CalendarToolbar2 = _interopRequireDefault(_CalendarToolbar);
	
	var _DateDisplay = __webpack_require__(803);
	
	var _DateDisplay2 = _interopRequireDefault(_DateDisplay);
	
	var _SlideIn = __webpack_require__(223);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	var _dateUtils = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var daysArray = [].concat((0, _toConsumableArray3.default)(Array(7)));
	
	var Calendar = function (_Component) {
	  (0, _inherits3.default)(Calendar, _Component);
	
	  function Calendar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Calendar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Calendar.__proto__ || (0, _getPrototypeOf2.default)(Calendar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      displayDate: undefined,
	      displayMonthDay: true,
	      selectedDate: undefined,
	      transitionDirection: 'left',
	      transitionEnter: true
	    }, _this.handleTouchTapDay = function (event, date) {
	      _this.setSelectedDate(date);
	      if (_this.props.onTouchTapDay) _this.props.onTouchTapDay(event, date);
	    }, _this.handleMonthChange = function (months) {
	      _this.setState({
	        transitionDirection: months >= 0 ? 'left' : 'right',
	        displayDate: _this.props.utils.addMonths(_this.state.displayDate, months)
	      });
	    }, _this.handleTouchTapYear = function (event, year) {
	      _this.setSelectedDate(_this.props.utils.setYear(_this.state.selectedDate, year), event);
	      _this.handleTouchTapDateDisplayMonthDay();
	    }, _this.handleTouchTapDateDisplayMonthDay = function () {
	      _this.setState({
	        displayMonthDay: true
	      });
	    }, _this.handleTouchTapDateDisplayYear = function () {
	      _this.setState({
	        displayMonthDay: false
	      });
	    }, _this.handleWindowKeyDown = function (event) {
	      if (_this.props.open) {
	        switch ((0, _keycode2.default)(event)) {
	          case 'up':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-7);
	            }
	            break;
	
	          case 'down':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(7);
	            }
	            break;
	
	          case 'right':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(1);
	            } else {
	              _this.addSelectedDays(1);
	            }
	            break;
	
	          case 'left':
	            if (event.altKey && event.shiftKey) {
	              _this.addSelectedYears(-1);
	            } else if (event.shiftKey) {
	              _this.addSelectedMonths(-1);
	            } else {
	              _this.addSelectedDays(-1);
	            }
	            break;
	        }
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Calendar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        displayDate: this.props.utils.getFirstDayOfMonth(this.props.initialDate),
	        selectedDate: this.props.initialDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.initialDate !== this.props.initialDate) {
	        var date = nextProps.initialDate || new Date();
	        this.setState({
	          displayDate: this.props.utils.getFirstDayOfMonth(date),
	          selectedDate: date
	        });
	      }
	    }
	  }, {
	    key: 'getMinDate',
	    value: function getMinDate() {
	      return this.props.minDate || this.props.utils.addYears(new Date(), -100);
	    }
	  }, {
	    key: 'getMaxDate',
	    value: function getMaxDate() {
	      return this.props.maxDate || this.props.utils.addYears(new Date(), 100);
	    }
	  }, {
	    key: 'getSelectedDate',
	    value: function getSelectedDate() {
	      return this.state.selectedDate;
	    }
	  }, {
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      if (!this.state.displayMonthDay) {
	        return false;
	      }
	
	      return this.refs.calendar.isSelectedDateDisabled();
	    }
	  }, {
	    key: 'addSelectedDays',
	    value: function addSelectedDays(days) {
	      this.setSelectedDate(this.props.utils.addDays(this.state.selectedDate, days));
	    }
	  }, {
	    key: 'addSelectedMonths',
	    value: function addSelectedMonths(months) {
	      this.setSelectedDate(this.props.utils.addMonths(this.state.selectedDate, months));
	    }
	  }, {
	    key: 'addSelectedYears',
	    value: function addSelectedYears(years) {
	      this.setSelectedDate(this.props.utils.addYears(this.state.selectedDate, years));
	    }
	  }, {
	    key: 'setDisplayDate',
	    value: function setDisplayDate(date, newSelectedDate) {
	      var newDisplayDate = this.props.utils.getFirstDayOfMonth(date);
	      var direction = newDisplayDate > this.state.displayDate ? 'left' : 'right';
	
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setState({
	          displayDate: newDisplayDate,
	          transitionDirection: direction,
	          selectedDate: newSelectedDate || this.state.selectedDate
	        });
	      }
	    }
	  }, {
	    key: 'setSelectedDate',
	    value: function setSelectedDate(date) {
	      var adjustedDate = date;
	      var minDate = this.getMinDate();
	      var maxDate = this.getMaxDate();
	      if ((0, _dateUtils.isBeforeDate)(date, minDate)) {
	        adjustedDate = minDate;
	      } else if ((0, _dateUtils.isAfterDate)(date, maxDate)) {
	        adjustedDate = maxDate;
	      }
	
	      var newDisplayDate = this.props.utils.getFirstDayOfMonth(adjustedDate);
	      if (newDisplayDate !== this.state.displayDate) {
	        this.setDisplayDate(newDisplayDate, adjustedDate);
	      } else {
	        this.setState({
	          selectedDate: adjustedDate
	        });
	      }
	    }
	  }, {
	    key: 'getToolbarInteractions',
	    value: function getToolbarInteractions() {
	      return {
	        prevMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMinDate()) > 0,
	        nextMonth: this.props.utils.monthDiff(this.state.displayDate, this.getMaxDate()) < 0
	      };
	    }
	  }, {
	    key: 'yearSelector',
	    value: function yearSelector() {
	      if (!this.props.disableYearSelection) {
	        return _react2.default.createElement(_CalendarYear2.default, {
	          key: 'years',
	          DateTimeFormat: this.props.DateTimeFormat,
	          locale: this.props.locale,
	          onTouchTapYear: this.handleTouchTapYear,
	          selectedDate: this.state.selectedDate,
	          minDate: this.getMinDate(),
	          maxDate: this.getMaxDate(),
	          utils: this.props.utils
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var hideCalendarDate = this.props.hideCalendarDate;
	
	      var toolbarInteractions = this.getToolbarInteractions();
	      var isLandscape = this.props.mode === 'landscape';
	      var calendarTextColor = this.context.muiTheme.datePicker.calendarTextColor;
	
	
	      var styles = {
	        root: {
	          color: calendarTextColor,
	          userSelect: 'none',
	          width: !hideCalendarDate && isLandscape ? 479 : 310
	        },
	        calendar: {
	          display: 'flex',
	          flexDirection: 'column'
	        },
	        calendarContainer: {
	          display: 'flex',
	          alignContent: 'space-between',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          fontSize: 12,
	          fontWeight: 400,
	          padding: '0px 8px',
	          transition: _transitions2.default.easeOut()
	        },
	        yearContainer: {
	          display: 'flex',
	          justifyContent: 'space-between',
	          flexDirection: 'column',
	          height: 272,
	          marginTop: 10,
	          overflow: 'hidden',
	          width: 310
	        },
	        weekTitle: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'space-between',
	          fontWeight: '500',
	          height: 20,
	          lineHeight: '15px',
	          opacity: '0.5',
	          textAlign: 'center'
	        },
	        weekTitleDay: {
	          width: 42
	        },
	        transitionSlide: {
	          height: 214
	        }
	      };
	
	      var weekTitleDayStyle = prepareStyles(styles.weekTitleDay);
	
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          DateTimeFormat = _props.DateTimeFormat,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          okLabel = _props.okLabel,
	          onTouchTapCancel = _props.onTouchTapCancel,
	          onTouchTapOk = _props.onTouchTapOk,
	          utils = _props.utils;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyDown: this.handleWindowKeyDown
	        }),
	        !hideCalendarDate && _react2.default.createElement(_DateDisplay2.default, {
	          DateTimeFormat: DateTimeFormat,
	          disableYearSelection: this.props.disableYearSelection,
	          onTouchTapMonthDay: this.handleTouchTapDateDisplayMonthDay,
	          onTouchTapYear: this.handleTouchTapDateDisplayYear,
	          locale: locale,
	          monthDaySelected: this.state.displayMonthDay,
	          mode: this.props.mode,
	          selectedDate: this.state.selectedDate
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.calendar) },
	          this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.calendarContainer) },
	            _react2.default.createElement(_CalendarToolbar2.default, {
	              DateTimeFormat: DateTimeFormat,
	              locale: locale,
	              displayDate: this.state.displayDate,
	              onMonthChange: this.handleMonthChange,
	              prevMonth: toolbarInteractions.prevMonth,
	              nextMonth: toolbarInteractions.nextMonth
	            }),
	            _react2.default.createElement(
	              'div',
	              { style: prepareStyles(styles.weekTitle) },
	              daysArray.map(function (event, i) {
	                return _react2.default.createElement(
	                  'span',
	                  { key: i, style: weekTitleDayStyle },
	                  (0, _dateUtils.localizedWeekday)(DateTimeFormat, locale, i, firstDayOfWeek)
	                );
	              })
	            ),
	            _react2.default.createElement(
	              _SlideIn2.default,
	              { direction: this.state.transitionDirection, style: styles.transitionSlide },
	              _react2.default.createElement(_CalendarMonth2.default, {
	                DateTimeFormat: DateTimeFormat,
	                locale: locale,
	                displayDate: this.state.displayDate,
	                firstDayOfWeek: this.props.firstDayOfWeek,
	                key: this.state.displayDate.toDateString(),
	                minDate: this.getMinDate(),
	                maxDate: this.getMaxDate(),
	                onTouchTapDay: this.handleTouchTapDay,
	                ref: 'calendar',
	                selectedDate: this.state.selectedDate,
	                shouldDisableDate: this.props.shouldDisableDate,
	                utils: utils
	              })
	            )
	          ),
	          !this.state.displayMonthDay && _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.yearContainer) },
	            this.yearSelector()
	          ),
	          okLabel && _react2.default.createElement(_CalendarActionButtons2.default, {
	            autoOk: this.props.autoOk,
	            cancelLabel: cancelLabel,
	            okLabel: okLabel,
	            onTouchTapCancel: onTouchTapCancel,
	            onTouchTapOk: onTouchTapOk
	          })
	        )
	      );
	    }
	  }]);
	  return Calendar;
	}(_react.Component);
	
	Calendar.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  disableYearSelection: false,
	  initialDate: new Date(),
	  locale: 'en-US',
	  utils: _dateUtils.defaultUtils
	};
	Calendar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Calendar.propTypes = {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  disableYearSelection: _propTypes2.default.bool,
	  firstDayOfWeek: _propTypes2.default.number,
	  hideCalendarDate: _propTypes2.default.bool,
	  initialDate: _propTypes2.default.object,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  okLabel: _propTypes2.default.node,
	  onTouchTapCancel: _propTypes2.default.func,
	  onTouchTapDay: _propTypes2.default.func,
	  onTouchTapOk: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  shouldDisableDate: _propTypes2.default.func,
	  utils: _propTypes2.default.object
	} : void 0;
	exports.default = Calendar;

/***/ },
/* 799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _FlatButton = __webpack_require__(148);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarActionButton = function (_Component) {
	  (0, _inherits3.default)(CalendarActionButton, _Component);
	
	  function CalendarActionButton() {
	    (0, _classCallCheck3.default)(this, CalendarActionButton);
	    return (0, _possibleConstructorReturn3.default)(this, (CalendarActionButton.__proto__ || (0, _getPrototypeOf2.default)(CalendarActionButton)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CalendarActionButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cancelLabel = _props.cancelLabel,
	          okLabel = _props.okLabel;
	
	
	      var styles = {
	        root: {
	          display: 'flex',
	          flexDirection: 'row',
	          justifyContent: 'flex-end',
	          margin: 0,
	          maxHeight: 48,
	          padding: 0
	        },
	        flatButtons: {
	          fontsize: 14,
	          margin: '4px 8px 8px 0px',
	          maxHeight: 36,
	          minWidth: 64,
	          padding: 0
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(_FlatButton2.default, {
	          label: cancelLabel,
	          onTouchTap: this.props.onTouchTapCancel,
	          primary: true,
	          style: styles.flatButtons
	        }),
	        !this.props.autoOk && _react2.default.createElement(_FlatButton2.default, {
	          disabled: this.refs.calendar !== undefined && this.refs.calendar.isSelectedDateDisabled(),
	          label: okLabel,
	          onTouchTap: this.props.onTouchTapOk,
	          primary: true,
	          style: styles.flatButtons
	        })
	      );
	    }
	  }]);
	  return CalendarActionButton;
	}(_react.Component);
	
	 false ? CalendarActionButton.propTypes = {
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  okLabel: _propTypes2.default.node,
	  onTouchTapCancel: _propTypes2.default.func,
	  onTouchTapOk: _propTypes2.default.func
	} : void 0;
	exports.default = CalendarActionButton;

/***/ },
/* 800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateUtils = __webpack_require__(114);
	
	var _DayButton = __webpack_require__(806);
	
	var _DayButton2 = _interopRequireDefault(_DayButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    justifyContent: 'flex-start',
	    fontWeight: 400,
	    height: 228,
	    lineHeight: 2,
	    position: 'relative',
	    textAlign: 'center',
	    MozPaddingStart: 0
	  },
	  week: {
	    display: 'flex',
	    flexDirection: 'row',
	    justifyContent: 'space-around',
	    height: 34,
	    marginBottom: 2
	  }
	};
	
	var CalendarMonth = function (_Component) {
	  (0, _inherits3.default)(CalendarMonth, _Component);
	
	  function CalendarMonth() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarMonth);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarMonth.__proto__ || (0, _getPrototypeOf2.default)(CalendarMonth)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapDay = function (event, date) {
	      if (_this.props.onTouchTapDay) {
	        _this.props.onTouchTapDay(event, date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarMonth, [{
	    key: 'isSelectedDateDisabled',
	    value: function isSelectedDateDisabled() {
	      return this.selectedDateDisabled;
	    }
	  }, {
	    key: 'shouldDisableDate',
	    value: function shouldDisableDate(day) {
	      if (day === null) return false;
	      var disabled = !(0, _dateUtils.isBetweenDates)(day, this.props.minDate, this.props.maxDate);
	      if (!disabled && this.props.shouldDisableDate) disabled = this.props.shouldDisableDate(day);
	
	      return disabled;
	    }
	  }, {
	    key: 'getWeekElements',
	    value: function getWeekElements() {
	      var _this2 = this;
	
	      var weekArray = this.props.utils.getWeekArray(this.props.displayDate, this.props.firstDayOfWeek);
	
	      return weekArray.map(function (week, i) {
	        return _react2.default.createElement(
	          'div',
	          { key: i, style: styles.week },
	          _this2.getDayElements(week, i)
	        );
	      }, this);
	    }
	  }, {
	    key: 'getDayElements',
	    value: function getDayElements(week, i) {
	      var _this3 = this;
	
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          selectedDate = _props.selectedDate;
	
	
	      return week.map(function (day, j) {
	        var isSameDate = (0, _dateUtils.isEqualDate)(selectedDate, day);
	        var disabled = _this3.shouldDisableDate(day);
	        var selected = !disabled && isSameDate;
	
	        if (isSameDate) {
	          _this3.selectedDateDisabled = disabled;
	        }
	
	        return _react2.default.createElement(_DayButton2.default, {
	          DateTimeFormat: DateTimeFormat,
	          locale: locale,
	          date: day,
	          disabled: disabled,
	          key: 'db' + (i + j),
	          onTouchTap: _this3.handleTouchTapDay,
	          selected: selected
	        });
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        this.getWeekElements()
	      );
	    }
	  }]);
	  return CalendarMonth;
	}(_react.Component);
	
	 false ? CalendarMonth.propTypes = {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  autoOk: _propTypes2.default.bool,
	  displayDate: _propTypes2.default.object.isRequired,
	  firstDayOfWeek: _propTypes2.default.number,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  onTouchTapDay: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  shouldDisableDate: _propTypes2.default.func,
	  utils: _propTypes2.default.object.isRequired
	} : void 0;
	exports.default = CalendarMonth;

/***/ },
/* 801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _IconButton = __webpack_require__(86);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _chevronLeft = __webpack_require__(381);
	
	var _chevronLeft2 = _interopRequireDefault(_chevronLeft);
	
	var _chevronRight = __webpack_require__(382);
	
	var _chevronRight2 = _interopRequireDefault(_chevronRight);
	
	var _SlideIn = __webpack_require__(223);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  root: {
	    display: 'flex',
	    justifyContent: 'space-between',
	    backgroundColor: 'inherit',
	    height: 48
	  },
	  titleDiv: {
	    fontSize: 14,
	    fontWeight: '500',
	    textAlign: 'center',
	    width: '100%'
	  },
	  titleText: {
	    height: 'inherit',
	    paddingTop: 12
	  }
	};
	
	var CalendarToolbar = function (_Component) {
	  (0, _inherits3.default)(CalendarToolbar, _Component);
	
	  function CalendarToolbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarToolbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarToolbar.__proto__ || (0, _getPrototypeOf2.default)(CalendarToolbar)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _this.handleTouchTapPrevMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(-1);
	      }
	    }, _this.handleTouchTapNextMonth = function () {
	      if (_this.props.onMonthChange) {
	        _this.props.onMonthChange(1);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarToolbar, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.displayDate !== this.props.displayDate) {
	        var direction = nextProps.displayDate > this.props.displayDate ? 'left' : 'right';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          displayDate = _props.displayDate;
	
	
	      var dateTimeFormatted = new DateTimeFormat(locale, {
	        month: 'long',
	        year: 'numeric'
	      }).format(displayDate);
	
	      return _react2.default.createElement(
	        'div',
	        { style: styles.root },
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.prevMonth,
	            onTouchTap: this.handleTouchTapPrevMonth
	          },
	          _react2.default.createElement(_chevronLeft2.default, null)
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          {
	            direction: this.state.transitionDirection,
	            style: styles.titleDiv
	          },
	          _react2.default.createElement(
	            'div',
	            { key: dateTimeFormatted, style: styles.titleText },
	            dateTimeFormatted
	          )
	        ),
	        _react2.default.createElement(
	          _IconButton2.default,
	          {
	            disabled: !this.props.nextMonth,
	            onTouchTap: this.handleTouchTapNextMonth
	          },
	          _react2.default.createElement(_chevronRight2.default, null)
	        )
	      );
	    }
	  }]);
	  return CalendarToolbar;
	}(_react.Component);
	
	CalendarToolbar.defaultProps = {
	  nextMonth: true,
	  prevMonth: true
	};
	 false ? CalendarToolbar.propTypes = {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  displayDate: _propTypes2.default.object.isRequired,
	  locale: _propTypes2.default.string.isRequired,
	  nextMonth: _propTypes2.default.bool,
	  onMonthChange: _propTypes2.default.func,
	  prevMonth: _propTypes2.default.bool
	} : void 0;
	exports.default = CalendarToolbar;

/***/ },
/* 802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _YearButton = __webpack_require__(807);
	
	var _YearButton2 = _interopRequireDefault(_YearButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CalendarYear = function (_Component) {
	  (0, _inherits3.default)(CalendarYear, _Component);
	
	  function CalendarYear() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, CalendarYear);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = CalendarYear.__proto__ || (0, _getPrototypeOf2.default)(CalendarYear)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapYear = function (event, year) {
	      if (_this.props.onTouchTapYear) {
	        _this.props.onTouchTapYear(event, year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(CalendarYear, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.scrollToSelectedYear();
	    }
	  }, {
	    key: 'getYears',
	    value: function getYears() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          locale = _props.locale,
	          minDate = _props.minDate,
	          maxDate = _props.maxDate,
	          selectedDate = _props.selectedDate,
	          utils = _props.utils;
	
	
	      var minYear = utils.getYear(minDate);
	      var maxYear = utils.getYear(maxDate);
	      var years = [];
	
	      for (var year = minYear; year <= maxYear; year++) {
	        var selected = utils.getYear(selectedDate) === year;
	        var selectedProps = {};
	        if (selected) {
	          selectedProps.ref = 'selectedYearButton';
	        }
	
	        var yearFormated = new DateTimeFormat(locale, {
	          year: 'numeric'
	        }).format(utils.setYear(selectedDate, year));
	
	        var yearButton = _react2.default.createElement(
	          _YearButton2.default,
	          (0, _extends3.default)({
	            key: 'yb' + year,
	            onTouchTap: this.handleTouchTapYear,
	            selected: selected,
	            year: year,
	            utils: utils
	          }, selectedProps),
	          yearFormated
	        );
	
	        years.push(yearButton);
	      }
	
	      return years;
	    }
	  }, {
	    key: 'scrollToSelectedYear',
	    value: function scrollToSelectedYear() {
	      if (this.refs.selectedYearButton === undefined) {
	        return;
	      }
	
	      var container = _reactDom2.default.findDOMNode(this);
	      var yearButtonNode = _reactDom2.default.findDOMNode(this.refs.selectedYearButton);
	
	      var containerHeight = container.clientHeight;
	      var yearButtonNodeHeight = yearButtonNode.clientHeight || 32;
	
	      var scrollYOffset = yearButtonNode.offsetTop + yearButtonNodeHeight / 2 - containerHeight / 2;
	      container.scrollTop = scrollYOffset;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          calendarYearBackgroundColor = _context$muiTheme.datePicker.calendarYearBackgroundColor;
	
	
	      var styles = {
	        root: {
	          backgroundColor: calendarYearBackgroundColor,
	          height: 'inherit',
	          lineHeight: '35px',
	          overflowX: 'hidden',
	          overflowY: 'scroll',
	          position: 'relative'
	        },
	        child: {
	          display: 'flex',
	          flexDirection: 'column',
	          justifyContent: 'center',
	          minHeight: '100%'
	        }
	      };
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.child) },
	          this.getYears()
	        )
	      );
	    }
	  }]);
	  return CalendarYear;
	}(_react.Component);
	
	CalendarYear.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? CalendarYear.propTypes = {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  locale: _propTypes2.default.string.isRequired,
	  maxDate: _propTypes2.default.object.isRequired,
	  minDate: _propTypes2.default.object.isRequired,
	  onTouchTapYear: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  utils: _propTypes2.default.object.isRequired,
	  wordings: _propTypes2.default.object
	} : void 0;
	exports.default = CalendarYear;

/***/ },
/* 803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _SlideIn = __webpack_require__(223);
	
	var _SlideIn2 = _interopRequireDefault(_SlideIn);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var datePicker = context.muiTheme.datePicker;
	  var selectedYear = state.selectedYear;
	
	  var isLandscape = props.mode === 'landscape';
	
	  var styles = {
	    root: {
	      width: isLandscape ? 165 : '100%',
	      height: isLandscape ? 330 : 'auto',
	      float: isLandscape ? 'left' : 'none',
	      fontWeight: 700,
	      display: 'inline-block',
	      backgroundColor: datePicker.selectColor,
	      borderTopLeftRadius: 2,
	      borderTopRightRadius: isLandscape ? 0 : 2,
	      borderBottomLeftRadius: isLandscape ? 2 : 0,
	      color: datePicker.textColor,
	      padding: 20,
	      boxSizing: 'border-box'
	    },
	    monthDay: {
	      display: 'block',
	      fontSize: 36,
	      lineHeight: '36px',
	      height: props.mode === 'landscape' ? '100%' : 38,
	      opacity: selectedYear ? 0.7 : 1,
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      fontWeight: '500'
	    },
	    monthDayTitle: {
	      cursor: !selectedYear ? 'default' : 'pointer',
	      width: '100%',
	      display: 'block'
	    },
	    year: {
	      margin: 0,
	      fontSize: 16,
	      fontWeight: '500',
	      lineHeight: '16px',
	      height: 16,
	      opacity: selectedYear ? 1 : 0.7,
	      transition: _transitions2.default.easeOut(),
	      marginBottom: 10
	    },
	    yearTitle: {
	      cursor: props.disableYearSelection ? 'not-allowed' : !selectedYear ? 'pointer' : 'default'
	    }
	  };
	
	  return styles;
	}
	
	var DateDisplay = function (_Component) {
	  (0, _inherits3.default)(DateDisplay, _Component);
	
	  function DateDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DateDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DateDisplay.__proto__ || (0, _getPrototypeOf2.default)(DateDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedYear: false,
	      transitionDirection: 'up'
	    }, _this.handleTouchTapMonthDay = function () {
	      if (_this.props.onTouchTapMonthDay && _this.state.selectedYear) {
	        _this.props.onTouchTapMonthDay();
	      }
	
	      _this.setState({ selectedYear: false });
	    }, _this.handleTouchTapYear = function () {
	      if (_this.props.onTouchTapYear && !_this.props.disableYearSelection && !_this.state.selectedYear) {
	        _this.props.onTouchTapYear();
	      }
	
	      if (!_this.props.disableYearSelection) {
	        _this.setState({ selectedYear: true });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DateDisplay, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (!this.props.monthDaySelected) {
	        this.setState({ selectedYear: true });
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedDate !== this.props.selectedDate) {
	        var direction = nextProps.selectedDate > this.props.selectedDate ? 'up' : 'down';
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	
	      if (nextProps.monthDaySelected !== undefined) {
	        this.setState({
	          selectedYear: !nextProps.monthDaySelected
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          disableYearSelection = _props.disableYearSelection,
	          locale = _props.locale,
	          mode = _props.mode,
	          monthDaySelected = _props.monthDaySelected,
	          onTouchTapMonthDay = _props.onTouchTapMonthDay,
	          onTouchTapYear = _props.onTouchTapYear,
	          selectedDate = _props.selectedDate,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'disableYearSelection', 'locale', 'mode', 'monthDaySelected', 'onTouchTapMonthDay', 'onTouchTapYear', 'selectedDate', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var year = new DateTimeFormat(locale, {
	        year: 'numeric'
	      }).format(selectedDate);
	
	      var dateTime = new DateTimeFormat(locale, {
	        month: 'short',
	        weekday: 'short',
	        day: '2-digit'
	      }).format(selectedDate);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root, style) }),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.year, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            { key: year, style: styles.yearTitle, onTouchTap: this.handleTouchTapYear },
	            year
	          )
	        ),
	        _react2.default.createElement(
	          _SlideIn2.default,
	          { style: styles.monthDay, direction: this.state.transitionDirection },
	          _react2.default.createElement(
	            'div',
	            {
	              key: dateTime,
	              onTouchTap: this.handleTouchTapMonthDay,
	              style: styles.monthDayTitle
	            },
	            dateTime
	          )
	        )
	      );
	    }
	  }]);
	  return DateDisplay;
	}(_react.Component);
	
	DateDisplay.defaultProps = {
	  disableYearSelection: false,
	  monthDaySelected: true
	};
	DateDisplay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? DateDisplay.propTypes = {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  disableYearSelection: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  monthDaySelected: _propTypes2.default.bool,
	  onTouchTapMonthDay: _propTypes2.default.func,
	  onTouchTapYear: _propTypes2.default.func,
	  selectedDate: _propTypes2.default.object.isRequired,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = DateDisplay;

/***/ },
/* 804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _dateUtils = __webpack_require__(114);
	
	var _DatePickerDialog = __webpack_require__(805);
	
	var _DatePickerDialog2 = _interopRequireDefault(_DatePickerDialog);
	
	var _TextField = __webpack_require__(115);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePicker = function (_Component) {
	  (0, _inherits3.default)(DatePicker, _Component);
	
	  function DatePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePicker.__proto__ || (0, _getPrototypeOf2.default)(DatePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      date: undefined
	    }, _this.handleAccept = function (date) {
	      if (!_this.isControlled()) {
	        _this.setState({
	          date: date
	        });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(null, date);
	      }
	    }, _this.handleFocus = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	
	      if (!_this.props.disabled) {
	        setTimeout(function () {
	          _this.openDialog();
	        }, 0);
	      }
	    }, _this.formatDate = function (date) {
	      if (_this.props.locale) {
	        var DateTimeFormat = _this.props.DateTimeFormat || _dateUtils.dateTimeFormat;
	        return new DateTimeFormat(_this.props.locale, {
	          day: 'numeric',
	          month: 'numeric',
	          year: 'numeric'
	        }).format(date);
	      } else {
	        return (0, _dateUtils.formatIso)(date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        date: this.isControlled() ? this.getControlledDate() : this.props.defaultDate
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.isControlled()) {
	        var newDate = this.getControlledDate(nextProps);
	        if (!(0, _dateUtils.isEqualDate)(this.state.date, newDate)) {
	          this.setState({
	            date: newDate
	          });
	        }
	      }
	    }
	  }, {
	    key: 'getDate',
	    value: function getDate() {
	      return this.state.date;
	    }
	
	    /**
	     * Open the date-picker dialog programmatically from a parent.
	     */
	
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      /**
	       * if the date is not selected then set it to new date
	       * (get the current system date while doing so)
	       * else set it to the currently selected date
	       */
	      if (this.state.date !== undefined) {
	        this.setState({
	          dialogDate: this.getDate()
	        }, this.refs.dialogWindow.show);
	      } else {
	        this.setState({
	          dialogDate: new Date()
	        }, this.refs.dialogWindow.show);
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'getControlledDate',
	    value: function getControlledDate() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      if (props.value instanceof Date) {
	        return props.value;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          className = _props.className,
	          container = _props.container,
	          defaultDate = _props.defaultDate,
	          dialogContainerStyle = _props.dialogContainerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          formatDateProp = _props.formatDate,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onDismiss = _props.onDismiss,
	          onFocus = _props.onFocus,
	          onShow = _props.onShow,
	          onTouchTap = _props.onTouchTap,
	          shouldDisableDate = _props.shouldDisableDate,
	          hideCalendarDate = _props.hideCalendarDate,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'className', 'container', 'defaultDate', 'dialogContainerStyle', 'disableYearSelection', 'firstDayOfWeek', 'formatDate', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onDismiss', 'onFocus', 'onShow', 'onTouchTap', 'shouldDisableDate', 'hideCalendarDate', 'style', 'textFieldStyle', 'utils']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var formatDate = formatDateProp || this.formatDate;
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          onFocus: this.handleFocus,
	          onTouchTap: this.handleTouchTap,
	          ref: 'input',
	          style: textFieldStyle,
	          value: this.state.date ? formatDate(this.state.date) : ''
	        })),
	        _react2.default.createElement(_DatePickerDialog2.default, {
	          DateTimeFormat: DateTimeFormat,
	          autoOk: autoOk,
	          cancelLabel: cancelLabel,
	          container: container,
	          containerStyle: dialogContainerStyle,
	          disableYearSelection: disableYearSelection,
	          firstDayOfWeek: firstDayOfWeek,
	          initialDate: this.state.dialogDate,
	          locale: locale,
	          maxDate: maxDate,
	          minDate: minDate,
	          mode: mode,
	          okLabel: okLabel,
	          onAccept: this.handleAccept,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          ref: 'dialogWindow',
	          shouldDisableDate: shouldDisableDate,
	          hideCalendarDate: hideCalendarDate,
	          utils: utils
	        })
	      );
	    }
	  }]);
	  return DatePicker;
	}(_react.Component);
	
	DatePicker.defaultProps = {
	  autoOk: false,
	  container: 'dialog',
	  disabled: false,
	  disableYearSelection: false,
	  firstDayOfWeek: 1,
	  hideCalendarDate: false,
	  style: {}
	};
	DatePicker.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? DatePicker.propTypes = {
	  /**
	   * Constructor for date formatting for the specified `locale`.
	   * The constructor must follow this specification: ECMAScript Internationalization API 1.0 (ECMA-402).
	   * `Intl.DateTimeFormat` is supported by most modern browsers, see http://caniuse.com/#search=intl,
	   * otherwise https://github.com/andyearnshaw/Intl.js is a good polyfill.
	   *
	   * By default, a built-in `DateTimeFormat` is used which supports the 'en-US' `locale`.
	   */
	  DateTimeFormat: _propTypes2.default.func,
	  /**
	   * If true, automatically accept and close the picker on select a date.
	   */
	  autoOk: _propTypes2.default.bool,
	  /**
	   * Override the default text of the 'Cancel' button.
	   */
	  cancelLabel: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Used to control how the Date Picker will be displayed when the input field is focused.
	   * `dialog` (default) displays the DatePicker as a dialog with a modal.
	   * `inline` displays the DatePicker below the input field (similar to auto complete).
	   */
	  container: _propTypes2.default.oneOf(['dialog', 'inline']),
	  /**
	   * This is the initial date value of the component.
	   * If either `value` or `valueLink` is provided they will override this
	   * prop with `value` taking precedence.
	   */
	  defaultDate: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of DatePickerDialog's Container element.
	   */
	  dialogContainerStyle: _propTypes2.default.object,
	  /**
	   * Disables the year selection in the date picker.
	   */
	  disableYearSelection: _propTypes2.default.bool,
	  /**
	   * Disables the DatePicker.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Used to change the first day of week. It varies from
	   * Saturday to Monday between different locales.
	   * The allowed range is 0 (Sunday) to 6 (Saturday).
	   * The default is `1`, Monday, as per ISO 8601.
	   */
	  firstDayOfWeek: _propTypes2.default.number,
	  /**
	   * This function is called to format the date displayed in the input field, and should return a string.
	   * By default if no `locale` and `DateTimeFormat` is provided date objects are formatted to ISO 8601 YYYY-MM-DD.
	   *
	   * @param {object} date Date object to be formatted.
	   * @returns {any} The formatted date.
	   */
	  formatDate: _propTypes2.default.func,
	  /**
	   * Hide date display
	   */
	  hideCalendarDate: _propTypes2.default.bool,
	  /**
	   * Locale used for formatting the `DatePicker` date strings. Other than for 'en-US', you
	   * must provide a `DateTimeFormat` that supports the chosen `locale`.
	   */
	  locale: _propTypes2.default.string,
	  /**
	   * The ending of a range of valid dates. The range includes the endDate.
	   * The default value is current date + 100 years.
	   */
	  maxDate: _propTypes2.default.object,
	  /**
	   * The beginning of a range of valid dates. The range includes the startDate.
	   * The default value is current date - 100 years.
	   */
	  minDate: _propTypes2.default.object,
	  /**
	   * Tells the component to display the picker in portrait or landscape mode.
	   */
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  /**
	   * Override the default text of the 'OK' button.
	   */
	  okLabel: _propTypes2.default.node,
	  /**
	   * Callback function that is fired when the date value changes.
	   *
	   * @param {null} null Since there is no particular event associated with the change,
	   * the first argument will always be null.
	   * @param {object} date The new date.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is dismissed.
	   */
	  onDismiss: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's `TextField` gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the Date Picker's dialog is shown.
	   */
	  onShow: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when a touch tap event occurs on the Date Picker's `TextField`.
	   *
	   * @param {object} event TouchTap event targeting the `TextField`.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * Callback function used to determine if a day's entry should be disabled on the calendar.
	   *
	   * @param {object} day Date object of a day.
	   * @returns {boolean} Indicates whether the day should be disabled.
	   */
	  shouldDisableDate: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of DatePicker's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object,
	  /**
	   * This object should contain methods needed to build the calendar system.
	   *
	   * Useful for building a custom calendar system. Refer to the
	   * [source code](https://github.com/callemall/material-ui/blob/master/src/DatePicker/dateUtils.js)
	   * and an [example implementation](https://github.com/alitaheri/material-ui-persian-date-picker-utils)
	   * for more information.
	   */
	  utils: _propTypes2.default.object,
	  /**
	   * Sets the date for the Date Picker programmatically.
	   */
	  value: _propTypes2.default.object
	} : void 0;
	exports.default = DatePicker;

/***/ },
/* 805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(44);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Calendar = __webpack_require__(798);
	
	var _Calendar2 = _interopRequireDefault(_Calendar);
	
	var _Dialog = __webpack_require__(212);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _Popover = __webpack_require__(87);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(218);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _dateUtils = __webpack_require__(114);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DatePickerDialog = function (_Component) {
	  (0, _inherits3.default)(DatePickerDialog, _Component);
	
	  function DatePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DatePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DatePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(DatePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.show = function () {
	      if (_this.props.onShow && !_this.state.open) {
	        _this.props.onShow();
	      }
	
	      _this.setState({
	        open: true
	      });
	    }, _this.dismiss = function () {
	      if (_this.props.onDismiss && _this.state.open) {
	        _this.props.onDismiss();
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleTouchTapDay = function () {
	      if (_this.props.autoOk) {
	        setTimeout(_this.handleTouchTapOk, 300);
	      }
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOk = function () {
	      if (_this.props.onAccept && !_this.refs.calendar.isSelectedDateDisabled()) {
	        _this.props.onAccept(_this.refs.calendar.getSelectedDate());
	      }
	
	      _this.setState({
	        open: false
	      });
	    }, _this.handleWindowKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOk();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DatePickerDialog, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          container = _props.container,
	          containerStyle = _props.containerStyle,
	          disableYearSelection = _props.disableYearSelection,
	          initialDate = _props.initialDate,
	          firstDayOfWeek = _props.firstDayOfWeek,
	          locale = _props.locale,
	          maxDate = _props.maxDate,
	          minDate = _props.minDate,
	          mode = _props.mode,
	          okLabel = _props.okLabel,
	          onAccept = _props.onAccept,
	          onDismiss = _props.onDismiss,
	          onShow = _props.onShow,
	          shouldDisableDate = _props.shouldDisableDate,
	          hideCalendarDate = _props.hideCalendarDate,
	          style = _props.style,
	          animation = _props.animation,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'autoOk', 'cancelLabel', 'container', 'containerStyle', 'disableYearSelection', 'initialDate', 'firstDayOfWeek', 'locale', 'maxDate', 'minDate', 'mode', 'okLabel', 'onAccept', 'onDismiss', 'onShow', 'shouldDisableDate', 'hideCalendarDate', 'style', 'animation', 'utils']);
	      var open = this.state.open;
	
	
	      var styles = {
	        dialogContent: {
	          width: !hideCalendarDate && mode === 'landscape' ? 479 : 310
	        },
	        dialogBodyContent: {
	          padding: 0,
	          minHeight: hideCalendarDate || mode === 'landscape' ? 330 : 434,
	          minWidth: hideCalendarDate || mode !== 'landscape' ? 310 : 479
	        }
	      };
	
	      var Container = container === 'inline' ? _Popover2.default : _Dialog2.default;
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { ref: 'root' }),
	        _react2.default.createElement(
	          Container,
	          {
	            anchorEl: this.refs.root // For Popover
	            , animation: animation || _PopoverAnimationVertical2.default // For Popover
	            , bodyStyle: styles.dialogBodyContent,
	            contentStyle: styles.dialogContent,
	            ref: 'dialog',
	            repositionOnUpdate: true,
	            open: open,
	            onRequestClose: this.handleRequestClose,
	            style: (0, _simpleAssign2.default)(styles.dialogBodyContent, containerStyle)
	          },
	          _react2.default.createElement(_reactEventListener2.default, {
	            target: 'window',
	            onKeyUp: this.handleWindowKeyUp
	          }),
	          _react2.default.createElement(_Calendar2.default, {
	            autoOk: autoOk,
	            DateTimeFormat: DateTimeFormat,
	            cancelLabel: cancelLabel,
	            disableYearSelection: disableYearSelection,
	            firstDayOfWeek: firstDayOfWeek,
	            initialDate: initialDate,
	            locale: locale,
	            onTouchTapDay: this.handleTouchTapDay,
	            maxDate: maxDate,
	            minDate: minDate,
	            mode: mode,
	            open: open,
	            ref: 'calendar',
	            onTouchTapCancel: this.handleTouchTapCancel,
	            onTouchTapOk: this.handleTouchTapOk,
	            okLabel: okLabel,
	            shouldDisableDate: shouldDisableDate,
	            hideCalendarDate: hideCalendarDate,
	            utils: utils
	          })
	        )
	      );
	    }
	  }]);
	  return DatePickerDialog;
	}(_react.Component);
	
	DatePickerDialog.defaultProps = {
	  DateTimeFormat: _dateUtils.dateTimeFormat,
	  cancelLabel: 'Cancel',
	  container: 'dialog',
	  locale: 'en-US',
	  okLabel: 'OK'
	};
	DatePickerDialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? DatePickerDialog.propTypes = {
	  DateTimeFormat: _propTypes2.default.func,
	  animation: _propTypes2.default.func,
	  autoOk: _propTypes2.default.bool,
	  cancelLabel: _propTypes2.default.node,
	  container: _propTypes2.default.oneOf(['dialog', 'inline']),
	  containerStyle: _propTypes2.default.object,
	  disableYearSelection: _propTypes2.default.bool,
	  firstDayOfWeek: _propTypes2.default.number,
	  hideCalendarDate: _propTypes2.default.bool,
	  initialDate: _propTypes2.default.object,
	  locale: _propTypes2.default.string,
	  maxDate: _propTypes2.default.object,
	  minDate: _propTypes2.default.object,
	  mode: _propTypes2.default.oneOf(['portrait', 'landscape']),
	  okLabel: _propTypes2.default.node,
	  onAccept: _propTypes2.default.func,
	  onDismiss: _propTypes2.default.func,
	  onShow: _propTypes2.default.func,
	  open: _propTypes2.default.bool,
	  shouldDisableDate: _propTypes2.default.func,
	  style: _propTypes2.default.object,
	  utils: _propTypes2.default.object
	} : void 0;
	exports.default = DatePickerDialog;

/***/ },
/* 806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _dateUtils = __webpack_require__(114);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var date = props.date,
	      disabled = props.disabled,
	      selected = props.selected;
	  var hover = state.hover;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	
	
	  var labelColor = baseTheme.palette.textColor;
	  var buttonStateOpacity = 0;
	  var buttonStateTransform = 'scale(0)';
	
	  if (hover || selected) {
	    labelColor = datePicker.selectTextColor;
	    buttonStateOpacity = selected ? 1 : 0.6;
	    buttonStateTransform = 'scale(1)';
	  } else if ((0, _dateUtils.isEqualDate)(date, new Date())) {
	    labelColor = datePicker.color;
	  }
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      fontWeight: '400',
	      opacity: disabled && '0.4',
	      padding: '4px 0px',
	      position: 'relative',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      width: 42
	    },
	    label: {
	      color: labelColor,
	      fontWeight: '400',
	      position: 'relative'
	    },
	    buttonState: {
	      backgroundColor: datePicker.selectColor,
	      borderRadius: '50%',
	      height: 34,
	      left: 4,
	      opacity: buttonStateOpacity,
	      position: 'absolute',
	      top: 0,
	      transform: buttonStateTransform,
	      transition: _transitions2.default.easeOut(),
	      width: 34
	    }
	  };
	}
	
	var DayButton = function (_Component) {
	  (0, _inherits3.default)(DayButton, _Component);
	
	  function DayButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DayButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DayButton.__proto__ || (0, _getPrototypeOf2.default)(DayButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: true });
	      }
	    }, _this.handleMouseLeave = function () {
	      if (!_this.props.disabled) {
	        _this.setState({ hover: false });
	      }
	    }, _this.handleTouchTap = function (event) {
	      if (!_this.props.disabled && _this.props.onTouchTap) {
	        _this.props.onTouchTap(event, _this.props.date);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (!_this.props.disabled && _this.props.onKeyboardFocus) {
	        _this.props.onKeyboardFocus(event, keyboardFocused, _this.props.date);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(DayButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          DateTimeFormat = _props.DateTimeFormat,
	          date = _props.date,
	          disabled = _props.disabled,
	          locale = _props.locale,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          other = (0, _objectWithoutProperties3.default)(_props, ['DateTimeFormat', 'date', 'disabled', 'locale', 'onTouchTap', 'selected']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return date ? _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchTap: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement('div', { style: prepareStyles(styles.buttonState) }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          new DateTimeFormat(locale, {
	            day: 'numeric'
	          }).format(date)
	        )
	      ) : _react2.default.createElement('span', { style: prepareStyles(styles.root) });
	    }
	  }]);
	  return DayButton;
	}(_react.Component);
	
	DayButton.defaultProps = {
	  selected: false,
	  disabled: false
	};
	DayButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? DayButton.propTypes = {
	  DateTimeFormat: _propTypes2.default.func.isRequired,
	  date: _propTypes2.default.object,
	  disabled: _propTypes2.default.bool,
	  locale: _propTypes2.default.string.isRequired,
	  onKeyboardFocus: _propTypes2.default.func,
	  onTouchTap: _propTypes2.default.func,
	  selected: _propTypes2.default.bool
	} : void 0;
	exports.default = DayButton;

/***/ },
/* 807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var selected = props.selected,
	      year = props.year,
	      utils = props.utils;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      datePicker = _context$muiTheme.datePicker;
	  var hover = state.hover;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      color: year === utils.getYear(new Date()) && datePicker.color,
	      display: 'block',
	      fontSize: 14,
	      margin: '0 auto',
	      position: 'relative',
	      textAlign: 'center',
	      lineHeight: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    label: {
	      alignSelf: 'center',
	      color: hover || selected ? datePicker.color : baseTheme.palette.textColor,
	      fontSize: selected ? 26 : 17,
	      fontWeight: hover ? 450 : selected ? 500 : 400,
	      position: 'relative',
	      top: -1
	    }
	  };
	}
	
	var YearButton = function (_Component) {
	  (0, _inherits3.default)(YearButton, _Component);
	
	  function YearButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, YearButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = YearButton.__proto__ || (0, _getPrototypeOf2.default)(YearButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hover: false
	    }, _this.handleMouseEnter = function () {
	      _this.setState({ hover: true });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({ hover: false });
	    }, _this.handleTouchTap = function (event) {
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event, _this.props.year);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(YearButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          onTouchTap = _props.onTouchTap,
	          selected = _props.selected,
	          year = _props.year,
	          utils = _props.utils,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'onTouchTap', 'selected', 'year', 'utils']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disableFocusRipple: true,
	          disableTouchRipple: true,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchTap: this.handleTouchTap,
	          style: styles.root
	        }),
	        _react2.default.createElement(
	          'span',
	          { style: prepareStyles(styles.label) },
	          children
	        )
	      );
	    }
	  }]);
	  return YearButton;
	}(_react.Component);
	
	YearButton.defaultProps = {
	  selected: false
	};
	YearButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? YearButton.propTypes = {
	  children: _propTypes2.default.node.isRequired,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  onTouchTap: _propTypes2.default.func,
	  selected: _propTypes2.default.bool,
	  utils: _propTypes2.default.object.isRequired,
	  year: _propTypes2.default.number.isRequired
	} : void 0;
	exports.default = YearButton;

/***/ },
/* 808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _DatePicker = __webpack_require__(804);
	
	var _DatePicker2 = _interopRequireDefault(_DatePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _DatePicker2.default;

/***/ },
/* 809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(44);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(371);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _RenderToLayer = __webpack_require__(372);
	
	var _RenderToLayer2 = _interopRequireDefault(_RenderToLayer);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _reactAddonsTransitionGroup = __webpack_require__(118);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TransitionItem = function (_Component) {
	  (0, _inherits3.default)(TransitionItem, _Component);
	
	  function TransitionItem() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TransitionItem);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TransitionItem.__proto__ || (0, _getPrototypeOf2.default)(TransitionItem)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      style: {}
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TransitionItem, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimeout);
	      clearTimeout(this.leaveTimeout);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.componentWillAppear(callback);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      var spacing = this.context.muiTheme.baseTheme.spacing;
	
	      this.setState({
	        style: {
	          opacity: 1,
	          transform: 'translate(0, ' + spacing.desktopKeylineIncrement + 'px)'
	        }
	      });
	
	      this.enterTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      this.setState({
	        style: {
	          opacity: 0,
	          transform: 'translate(0, 0)'
	        }
	      });
	
	      this.leaveTimeout = setTimeout(callback, 450); // matches transition duration
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          children = _props.children,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'children']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, this.state.style, style)) }),
	        children
	      );
	    }
	  }]);
	  return TransitionItem;
	}(_react.Component);
	
	TransitionItem.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TransitionItem.propTypes = {
	  children: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : void 0;
	
	
	function getStyles(props, context) {
	  var autoScrollBodyContent = props.autoScrollBodyContent,
	      open = props.open;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      spacing = _context$muiTheme$bas.spacing,
	      palette = _context$muiTheme$bas.palette,
	      dialog = _context$muiTheme.dialog,
	      zIndex = _context$muiTheme.zIndex;
	
	
	  var gutter = spacing.desktopGutter;
	  var borderScroll = '1px solid ' + palette.borderColor;
	
	  return {
	    root: {
	      position: 'fixed',
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      zIndex: zIndex.dialog,
	      top: 0,
	      left: open ? 0 : -10000,
	      width: '100%',
	      height: '100%',
	      transition: open ? _transitions2.default.easeOut('0ms', 'left', '0ms') : _transitions2.default.easeOut('0ms', 'left', '450ms')
	    },
	    content: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      transition: _transitions2.default.easeOut(),
	      position: 'relative',
	      width: '75%',
	      maxWidth: spacing.desktopKeylineIncrement * 12,
	      margin: '0 auto',
	      zIndex: zIndex.dialog
	    },
	    actionsContainer: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      padding: 8,
	      width: '100%',
	      textAlign: 'right',
	      marginTop: autoScrollBodyContent ? -1 : 0,
	      borderTop: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    overlay: {
	      zIndex: zIndex.dialogOverlay
	    },
	    title: {
	      margin: 0,
	      padding: gutter + 'px ' + gutter + 'px 20px ' + gutter + 'px',
	      color: palette.textColor,
	      fontSize: dialog.titleFontSize,
	      lineHeight: '32px',
	      fontWeight: 400,
	      marginBottom: autoScrollBodyContent ? -1 : 0,
	      borderBottom: autoScrollBodyContent ? borderScroll : 'none'
	    },
	    body: {
	      fontSize: dialog.bodyFontSize,
	      color: dialog.bodyColor,
	      padding: (props.title ? 0 : gutter) + 'px ' + gutter + 'px ' + gutter + 'px',
	      boxSizing: 'border-box',
	      overflowY: autoScrollBodyContent ? 'auto' : 'hidden'
	    }
	  };
	}
	
	var DialogInline = function (_Component2) {
	  (0, _inherits3.default)(DialogInline, _Component2);
	
	  function DialogInline() {
	    var _ref2;
	
	    var _temp2, _this2, _ret2;
	
	    (0, _classCallCheck3.default)(this, DialogInline);
	
	    for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	      args[_key2] = arguments[_key2];
	    }
	
	    return _ret2 = (_temp2 = (_this2 = (0, _possibleConstructorReturn3.default)(this, (_ref2 = DialogInline.__proto__ || (0, _getPrototypeOf2.default)(DialogInline)).call.apply(_ref2, [this].concat(args))), _this2), _this2.handleTouchTapOverlay = function () {
	      _this2.requestClose(false);
	    }, _this2.handleKeyUp = function (event) {
	      if ((0, _keycode2.default)(event) === 'esc') {
	        _this2.requestClose(false);
	      }
	    }, _this2.handleResize = function () {
	      _this2.positionDialog();
	    }, _temp2), (0, _possibleConstructorReturn3.default)(_this2, _ret2);
	  }
	
	  (0, _createClass3.default)(DialogInline, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.positionDialog();
	    }
	  }, {
	    key: 'positionDialog',
	    value: function positionDialog() {
	      var _props2 = this.props,
	          actions = _props2.actions,
	          autoDetectWindowHeight = _props2.autoDetectWindowHeight,
	          autoScrollBodyContent = _props2.autoScrollBodyContent,
	          bodyStyle = _props2.bodyStyle,
	          open = _props2.open,
	          repositionOnUpdate = _props2.repositionOnUpdate,
	          title = _props2.title;
	
	
	      if (!open) {
	        return;
	      }
	
	      var clientHeight = window.innerHeight || document.documentElement.clientHeight || document.body.clientHeight;
	      var container = _reactDom2.default.findDOMNode(this);
	      var dialogWindow = _reactDom2.default.findDOMNode(this.refs.dialogWindow);
	      var dialogContent = _reactDom2.default.findDOMNode(this.refs.dialogContent);
	      var minPaddingTop = 16;
	
	      // Reset the height in case the window was resized.
	      dialogWindow.style.height = '';
	      dialogContent.style.height = '';
	
	      var dialogWindowHeight = dialogWindow.offsetHeight;
	      var paddingTop = (clientHeight - dialogWindowHeight) / 2 - 64;
	      if (paddingTop < minPaddingTop) paddingTop = minPaddingTop;
	
	      // Vertically center the dialog window, but make sure it doesn't
	      // transition to that position.
	      if (repositionOnUpdate || !container.style.paddingTop) {
	        container.style.paddingTop = paddingTop + 'px';
	      }
	
	      // Force a height if the dialog is taller than clientHeight
	      if (autoDetectWindowHeight || autoScrollBodyContent) {
	        var styles = getStyles(this.props, this.context);
	        styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	        var maxDialogContentHeight = clientHeight - 2 * 64;
	
	        if (title) maxDialogContentHeight -= dialogContent.previousSibling.offsetHeight;
	
	        if (_react2.default.Children.count(actions)) {
	          maxDialogContentHeight -= dialogContent.nextSibling.offsetHeight;
	        }
	
	        dialogContent.style.maxHeight = maxDialogContentHeight + 'px';
	      }
	    }
	  }, {
	    key: 'requestClose',
	    value: function requestClose(buttonClicked) {
	      if (!buttonClicked && this.props.modal) {
	        return;
	      }
	
	      if (this.props.onRequestClose) {
	        this.props.onRequestClose(!!buttonClicked);
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          actions = _props3.actions,
	          actionsContainerClassName = _props3.actionsContainerClassName,
	          actionsContainerStyle = _props3.actionsContainerStyle,
	          bodyClassName = _props3.bodyClassName,
	          bodyStyle = _props3.bodyStyle,
	          children = _props3.children,
	          className = _props3.className,
	          contentClassName = _props3.contentClassName,
	          contentStyle = _props3.contentStyle,
	          overlayClassName = _props3.overlayClassName,
	          overlayStyle = _props3.overlayStyle,
	          open = _props3.open,
	          titleClassName = _props3.titleClassName,
	          titleStyle = _props3.titleStyle,
	          title = _props3.title,
	          style = _props3.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      styles.root = (0, _simpleAssign2.default)(styles.root, style);
	      styles.content = (0, _simpleAssign2.default)(styles.content, contentStyle);
	      styles.body = (0, _simpleAssign2.default)(styles.body, bodyStyle);
	      styles.actionsContainer = (0, _simpleAssign2.default)(styles.actionsContainer, actionsContainerStyle);
	      styles.overlay = (0, _simpleAssign2.default)(styles.overlay, overlayStyle);
	      styles.title = (0, _simpleAssign2.default)(styles.title, titleStyle);
	
	      var actionsContainer = _react2.default.Children.count(actions) > 0 && _react2.default.createElement(
	        'div',
	        { className: actionsContainerClassName, style: prepareStyles(styles.actionsContainer) },
	        _react2.default.Children.toArray(actions)
	      );
	
	      var titleElement = title;
	      if (_react2.default.isValidElement(title)) {
	        titleElement = _react2.default.cloneElement(title, {
	          className: title.props.className || titleClassName,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.title, title.props.style))
	        });
	      } else if (typeof title === 'string') {
	        titleElement = _react2.default.createElement(
	          'h3',
	          { className: titleClassName, style: prepareStyles(styles.title) },
	          title
	        );
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { className: className, style: prepareStyles(styles.root) },
	        open && _react2.default.createElement(_reactEventListener2.default, {
	          target: 'window',
	          onKeyUp: this.handleKeyUp,
	          onResize: this.handleResize
	        }),
	        _react2.default.createElement(
	          _reactAddonsTransitionGroup2.default,
	          {
	            component: 'div',
	            ref: 'dialogWindow',
	            transitionAppear: true,
	            transitionAppearTimeout: 450,
	            transitionEnter: true,
	            transitionEnterTimeout: 450
	          },
	          open && _react2.default.createElement(
	            TransitionItem,
	            {
	              className: contentClassName,
	              style: styles.content
	            },
	            _react2.default.createElement(
	              _Paper2.default,
	              { zDepth: 4 },
	              titleElement,
	              _react2.default.createElement(
	                'div',
	                {
	                  ref: 'dialogContent',
	                  className: bodyClassName,
	                  style: prepareStyles(styles.body)
	                },
	                children
	              ),
	              actionsContainer
	            )
	          )
	        ),
	        _react2.default.createElement(_Overlay2.default, {
	          show: open,
	          className: overlayClassName,
	          style: styles.overlay,
	          onTouchTap: this.handleTouchTapOverlay
	        })
	      );
	    }
	  }]);
	  return DialogInline;
	}(_react.Component);
	
	DialogInline.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? DialogInline.propTypes = {
	  actions: _propTypes2.default.node,
	  actionsContainerClassName: _propTypes2.default.string,
	  actionsContainerStyle: _propTypes2.default.object,
	  autoDetectWindowHeight: _propTypes2.default.bool,
	  autoScrollBodyContent: _propTypes2.default.bool,
	  bodyClassName: _propTypes2.default.string,
	  bodyStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  className: _propTypes2.default.string,
	  contentClassName: _propTypes2.default.string,
	  contentStyle: _propTypes2.default.object,
	  modal: _propTypes2.default.bool,
	  onRequestClose: _propTypes2.default.func,
	  open: _propTypes2.default.bool.isRequired,
	  overlayClassName: _propTypes2.default.string,
	  overlayStyle: _propTypes2.default.object,
	  repositionOnUpdate: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  title: _propTypes2.default.node,
	  titleClassName: _propTypes2.default.string,
	  titleStyle: _propTypes2.default.object
	} : void 0;
	
	var Dialog = function (_Component3) {
	  (0, _inherits3.default)(Dialog, _Component3);
	
	  function Dialog() {
	    var _ref3;
	
	    var _temp3, _this3, _ret3;
	
	    (0, _classCallCheck3.default)(this, Dialog);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret3 = (_temp3 = (_this3 = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Dialog.__proto__ || (0, _getPrototypeOf2.default)(Dialog)).call.apply(_ref3, [this].concat(args))), _this3), _this3.renderLayer = function () {
	      return _react2.default.createElement(DialogInline, _this3.props);
	    }, _temp3), (0, _possibleConstructorReturn3.default)(_this3, _ret3);
	  }
	
	  (0, _createClass3.default)(Dialog, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(_RenderToLayer2.default, { render: this.renderLayer, open: true, useLayerForClickAway: false });
	    }
	  }]);
	  return Dialog;
	}(_react.Component);
	
	Dialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	Dialog.defaultProps = {
	  autoDetectWindowHeight: true,
	  autoScrollBodyContent: false,
	  modal: false,
	  repositionOnUpdate: true
	};
	 false ? Dialog.propTypes = {
	  /**
	   * Action buttons to display below the Dialog content (`children`).
	   * This property accepts either a React element, or an array of React elements.
	   */
	  actions: _propTypes2.default.node,
	  /**
	   * The `className` to add to the actions container's root element.
	   */
	  actionsContainerClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the actions container's root element.
	   */
	  actionsContainerStyle: _propTypes2.default.object,
	  /**
	   * If set to true, the height of the `Dialog` will be auto detected. A max height
	   * will be enforced so that the content does not extend beyond the viewport.
	   */
	  autoDetectWindowHeight: _propTypes2.default.bool,
	  /**
	   * If set to true, the body content of the `Dialog` will be scrollable.
	   */
	  autoScrollBodyContent: _propTypes2.default.bool,
	  /**
	   * The `className` to add to the content's root element under the title.
	   */
	  bodyClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the content's root element under the title.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * The contents of the `Dialog`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The `className` to add to the content container.
	   */
	  contentClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the content container.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * Force the user to use one of the actions in the `Dialog`.
	   * Clicking outside the `Dialog` will not trigger the `onRequestClose`.
	   */
	  modal: _propTypes2.default.bool,
	  /**
	   * Fired when the `Dialog` is requested to be closed by a click outside the `Dialog` or on the buttons.
	   *
	   * @param {bool} buttonClicked Determines whether a button click triggered this request.
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * Controls whether the Dialog is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * The `className` to add to the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the `Overlay` component that is rendered behind the `Dialog`.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * Determines whether the `Dialog` should be repositioned when it's contents are updated.
	   */
	  repositionOnUpdate: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The title to display on the `Dialog`. Could be number, string, element or an array containing these types.
	   */
	  title: _propTypes2.default.node,
	  /**
	   * The `className` to add to the title's root container element.
	   */
	  titleClassName: _propTypes2.default.string,
	  /**
	   * Overrides the inline-styles of the title's root container element.
	   */
	  titleStyle: _propTypes2.default.object
	} : void 0;
	exports.default = Dialog;

/***/ },
/* 810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Divider = function Divider(props, context) {
	  var inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      prepareStyles = _context$muiTheme.prepareStyles;
	
	
	  var styles = {
	    root: {
	      margin: 0,
	      marginTop: -1,
	      marginLeft: inset ? 72 : 0,
	      height: 1,
	      border: 'none',
	      backgroundColor: baseTheme.palette.borderColor
	    }
	  };
	
	  return _react2.default.createElement('hr', (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }));
	};
	
	Divider.muiName = 'Divider';
	
	 false ? Divider.propTypes = {
	  /**
	   * If true, the `Divider` will be indented.
	   */
	  inset: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	
	Divider.defaultProps = {
	  inset: false
	};
	
	Divider.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Divider;

/***/ },
/* 811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _reactEventListener = __webpack_require__(44);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _autoPrefix = __webpack_require__(64);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Overlay = __webpack_require__(371);
	
	var _Overlay2 = _interopRequireDefault(_Overlay);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var openNavEventHandler = null;
	
	var Drawer = function (_Component) {
	  (0, _inherits3.default)(Drawer, _Component);
	
	  function Drawer() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Drawer);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Drawer.__proto__ || (0, _getPrototypeOf2.default)(Drawer)).call.apply(_ref, [this].concat(args))), _this), _this.handleTouchTapOverlay = function (event) {
	      event.preventDefault();
	      _this.close('clickaway');
	    }, _this.handleKeyUp = function (event) {
	      if (_this.state.open && !_this.props.docked && (0, _keycode2.default)(event) === 'esc') {
	        _this.close('escape');
	      }
	    }, _this.onBodyTouchStart = function (event) {
	      var swipeAreaWidth = _this.props.swipeAreaWidth;
	
	      var touchStartX = event.touches[0].pageX;
	      var touchStartY = event.touches[0].pageY;
	
	      // Open only if swiping from far left (or right) while closed
	      if (swipeAreaWidth !== null && !_this.state.open) {
	        if (_this.props.openSecondary) {
	          // If openSecondary is true calculate from the far right
	          if (touchStartX < document.body.offsetWidth - swipeAreaWidth) return;
	        } else {
	          // If openSecondary is false calculate from the far left
	          if (touchStartX > swipeAreaWidth) return;
	        }
	      }
	
	      if (!_this.state.open && (openNavEventHandler !== _this.onBodyTouchStart || _this.props.disableSwipeToOpen)) {
	        return;
	      }
	
	      _this.maybeSwiping = true;
	      _this.touchStartX = touchStartX;
	      _this.touchStartY = touchStartY;
	
	      document.body.addEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.addEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.addEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _this.onBodyTouchMove = function (event) {
	      var currentX = event.touches[0].pageX;
	      var currentY = event.touches[0].pageY;
	
	      if (_this.state.swiping) {
	        event.preventDefault();
	        _this.setPosition(_this.getTranslateX(currentX));
	      } else if (_this.maybeSwiping) {
	        var dXAbs = Math.abs(currentX - _this.touchStartX);
	        var dYAbs = Math.abs(currentY - _this.touchStartY);
	        // If the user has moved his thumb ten pixels in either direction,
	        // we can safely make an assumption about whether he was intending
	        // to swipe or scroll.
	        var threshold = 10;
	
	        if (dXAbs > threshold && dYAbs <= threshold) {
	          _this.swipeStartX = currentX;
	          _this.setState({
	            swiping: _this.state.open ? 'closing' : 'opening'
	          });
	          _this.setPosition(_this.getTranslateX(currentX));
	        } else if (dXAbs <= threshold && dYAbs > threshold) {
	          _this.onBodyTouchEnd();
	        }
	      }
	    }, _this.onBodyTouchEnd = function (event) {
	      if (_this.state.swiping) {
	        var currentX = event.changedTouches[0].pageX;
	        var translateRatio = _this.getTranslateX(currentX) / _this.getMaxTranslateX();
	
	        _this.maybeSwiping = false;
	        var swiping = _this.state.swiping;
	        _this.setState({
	          swiping: null
	        });
	
	        // We have to open or close after setting swiping to null,
	        // because only then CSS transition is enabled.
	        if (translateRatio > 0.5) {
	          if (swiping === 'opening') {
	            _this.setPosition(_this.getMaxTranslateX());
	          } else {
	            _this.close('swipe');
	          }
	        } else {
	          if (swiping === 'opening') {
	            _this.open('swipe');
	          } else {
	            _this.setPosition(0);
	          }
	        }
	      } else {
	        _this.maybeSwiping = false;
	      }
	
	      document.body.removeEventListener('touchmove', _this.onBodyTouchMove);
	      document.body.removeEventListener('touchend', _this.onBodyTouchEnd);
	      document.body.removeEventListener('touchcancel', _this.onBodyTouchEnd);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Drawer, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.maybeSwiping = false;
	      this.touchStartX = null;
	      this.touchStartY = null;
	      this.swipeStartX = null;
	
	      this.setState({
	        open: this.props.open !== null ? this.props.open : this.props.docked,
	        swiping: null
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      // If controlled then the open prop takes precedence.
	      if (nextProps.open !== null) {
	        this.setState({
	          open: nextProps.open
	        });
	        // Otherwise, if docked is changed, change the open state for when uncontrolled.
	      } else if (this.props.docked !== nextProps.docked) {
	        this.setState({
	          open: nextProps.docked
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.enableSwipeHandling();
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.disableSwipeHandling();
	    }
	  }, {
	    key: 'getStyles',
	    value: function getStyles() {
	      var muiTheme = this.context.muiTheme;
	      var theme = muiTheme.drawer;
	
	      var x = this.getTranslateMultiplier() * (this.state.open ? 0 : this.getMaxTranslateX());
	
	      var styles = {
	        root: {
	          height: '100%',
	          width: this.getTranslatedWidth() || theme.width,
	          position: 'fixed',
	          zIndex: muiTheme.zIndex.drawer,
	          left: 0,
	          top: 0,
	          transform: 'translate(' + x + 'px, 0)',
	          transition: !this.state.swiping && _transitions2.default.easeOut(null, 'transform', null),
	          backgroundColor: theme.color,
	          overflow: 'auto',
	          WebkitOverflowScrolling: 'touch' },
	        overlay: {
	          zIndex: muiTheme.zIndex.drawerOverlay,
	          pointerEvents: this.state.open ? 'auto' : 'none' },
	        rootWhenOpenRight: {
	          left: 'auto',
	          right: 0
	        }
	      };
	
	      return styles;
	    }
	  }, {
	    key: 'shouldShow',
	    value: function shouldShow() {
	      return this.state.open || !!this.state.swiping; // component is swiping
	    }
	  }, {
	    key: 'close',
	    value: function close(reason) {
	      if (this.props.open === null) this.setState({ open: false });
	      if (this.props.onRequestChange) this.props.onRequestChange(false, reason);
	      return this;
	    }
	  }, {
	    key: 'open',
	    value: function open(reason) {
	      if (this.props.open === null) this.setState({ open: true });
	      if (this.props.onRequestChange) this.props.onRequestChange(true, reason);
	      return this;
	    }
	  }, {
	    key: 'getTranslatedWidth',
	    value: function getTranslatedWidth() {
	      if (typeof this.props.width === 'string') {
	        if (!/^\d+(\.\d+)?%$/.test(this.props.width)) {
	          throw new Error('Not a valid percentage format.');
	        }
	        var width = parseFloat(this.props.width) / 100.0;
	        // We are doing our best on the Server to render a consistent UI, hence the
	        // default value of 10000
	        return window ? width * window.innerWidth : 10000;
	      } else {
	        return this.props.width;
	      }
	    }
	  }, {
	    key: 'getMaxTranslateX',
	    value: function getMaxTranslateX() {
	      var width = this.getTranslatedWidth() || this.context.muiTheme.drawer.width;
	      return width + 10;
	    }
	  }, {
	    key: 'getTranslateMultiplier',
	    value: function getTranslateMultiplier() {
	      return this.props.openSecondary ? 1 : -1;
	    }
	  }, {
	    key: 'enableSwipeHandling',
	    value: function enableSwipeHandling() {
	      if (!this.props.docked) {
	        document.body.addEventListener('touchstart', this.onBodyTouchStart);
	        if (!openNavEventHandler) {
	          openNavEventHandler = this.onBodyTouchStart;
	        }
	      } else {
	        this.disableSwipeHandling();
	      }
	    }
	  }, {
	    key: 'disableSwipeHandling',
	    value: function disableSwipeHandling() {
	      document.body.removeEventListener('touchstart', this.onBodyTouchStart);
	      if (openNavEventHandler === this.onBodyTouchStart) {
	        openNavEventHandler = null;
	      }
	    }
	  }, {
	    key: 'setPosition',
	    value: function setPosition(translateX) {
	      var drawer = _reactDom2.default.findDOMNode(this.refs.clickAwayableElement);
	      var transformCSS = 'translate(' + this.getTranslateMultiplier() * translateX + 'px, 0)';
	      this.refs.overlay.setOpacity(1 - translateX / this.getMaxTranslateX());
	      _autoPrefix2.default.set(drawer.style, 'transform', transformCSS);
	    }
	  }, {
	    key: 'getTranslateX',
	    value: function getTranslateX(currentX) {
	      return Math.min(Math.max(this.state.swiping === 'closing' ? this.getTranslateMultiplier() * (currentX - this.swipeStartX) : this.getMaxTranslateX() - this.getTranslateMultiplier() * (this.swipeStartX - currentX), 0), this.getMaxTranslateX());
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          containerClassName = _props.containerClassName,
	          containerStyle = _props.containerStyle,
	          docked = _props.docked,
	          openSecondary = _props.openSecondary,
	          overlayClassName = _props.overlayClassName,
	          overlayStyle = _props.overlayStyle,
	          style = _props.style,
	          zDepth = _props.zDepth;
	
	
	      var styles = this.getStyles();
	
	      var overlay = void 0;
	      if (!docked) {
	        overlay = _react2.default.createElement(_Overlay2.default, {
	          ref: 'overlay',
	          show: this.shouldShow(),
	          className: overlayClassName,
	          style: (0, _simpleAssign2.default)(styles.overlay, overlayStyle),
	          transitionEnabled: !this.state.swiping,
	          onTouchTap: this.handleTouchTapOverlay
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        {
	          className: className,
	          style: style
	        },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        overlay,
	        _react2.default.createElement(
	          _Paper2.default,
	          {
	            ref: 'clickAwayableElement',
	            zDepth: zDepth,
	            rounded: false,
	            transitionEnabled: !this.state.swiping,
	            className: containerClassName,
	            style: (0, _simpleAssign2.default)(styles.root, openSecondary && styles.rootWhenOpenRight, containerStyle)
	          },
	          children
	        )
	      );
	    }
	  }]);
	  return Drawer;
	}(_react.Component);
	
	Drawer.defaultProps = {
	  disableSwipeToOpen: false,
	  docked: true,
	  open: null,
	  openSecondary: false,
	  swipeAreaWidth: 30,
	  width: null,
	  zDepth: 2
	};
	Drawer.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Drawer.propTypes = {
	  /**
	   * The contents of the `Drawer`
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The CSS class name of the container element.
	   */
	  containerClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the container element.
	   */
	  containerStyle: _propTypes2.default.object,
	  /**
	   * If true, swiping sideways when the `Drawer` is closed will not open it.
	   */
	  disableSwipeToOpen: _propTypes2.default.bool,
	  /**
	   * If true, the `Drawer` will be docked. In this state, the overlay won't show and
	   * clicking on a menu item will not close the `Drawer`.
	   */
	  docked: _propTypes2.default.bool,
	  /**
	   * Callback function fired when the `open` state of the `Drawer` is requested to be changed.
	   *
	   * @param {boolean} open If true, the `Drawer` was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'swipe' for open requests; 'clickaway' (on overlay clicks),
	   * 'escape' (on escape key press), and 'swipe' for close requests.
	   */
	  onRequestChange: _propTypes2.default.func,
	  /**
	   * If true, the `Drawer` is opened.  Providing a value will turn the `Drawer`
	   * into a controlled component.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * If true, the `Drawer` is positioned to open from the opposite side.
	   */
	  openSecondary: _propTypes2.default.bool,
	  /**
	   * The CSS class name to add to the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the `Overlay` component that is rendered behind the `Drawer`.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The width of the left most (or right most) area in pixels where the `Drawer` can be
	   * swiped open from. Setting this to `null` spans that area to the entire page
	   * (**CAUTION!** Setting this property to `null` might cause issues with sliders and
	   * swipeable `Tabs`: use at your own risk).
	   */
	  swipeAreaWidth: _propTypes2.default.number,
	  /**
	   * The width of the `Drawer` in pixels or percentage in string format ex. `50%` to fill
	   * half of the window or `100%` and so on. Defaults to using the values from theme.
	   */
	  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * The zDepth of the `Drawer`.
	   */
	  zDepth: _propTypes4.default.zDepth
	
	} : void 0;
	exports.default = Drawer;

/***/ },
/* 812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Drawer = __webpack_require__(811);
	
	var _Drawer2 = _interopRequireDefault(_Drawer);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Drawer2.default;

/***/ },
/* 813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _arrowDropDown = __webpack_require__(378);
	
	var _arrowDropDown2 = _interopRequireDefault(_arrowDropDown);
	
	var _Menu = __webpack_require__(149);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _ClearFix = __webpack_require__(876);
	
	var _ClearFix2 = _interopRequireDefault(_ClearFix);
	
	var _Popover = __webpack_require__(87);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _PopoverAnimationVertical = __webpack_require__(218);
	
	var _PopoverAnimationVertical2 = _interopRequireDefault(_PopoverAnimationVertical);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _events = __webpack_require__(152);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _IconButton = __webpack_require__(86);
	
	var _IconButton2 = _interopRequireDefault(_IconButton);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var disabled = props.disabled;
	
	  var spacing = context.muiTheme.baseTheme.spacing;
	  var palette = context.muiTheme.baseTheme.palette;
	  var accentColor = context.muiTheme.dropDownMenu.accentColor;
	  return {
	    control: {
	      cursor: disabled ? 'not-allowed' : 'pointer',
	      height: '100%',
	      position: 'relative',
	      width: '100%'
	    },
	    icon: {
	      fill: accentColor,
	      position: 'absolute',
	      right: spacing.desktopGutterLess,
	      top: (spacing.iconSize - 24) / 2 + spacing.desktopGutterMini / 2
	    },
	    iconChildren: {
	      fill: 'inherit'
	    },
	    label: {
	      color: disabled ? palette.disabledColor : palette.textColor,
	      height: spacing.desktopToolbarHeight + 'px',
	      lineHeight: spacing.desktopToolbarHeight + 'px',
	      overflow: 'hidden',
	      opacity: 1,
	      position: 'relative',
	      paddingLeft: spacing.desktopGutter,
	      paddingRight: spacing.iconSize * 2 + spacing.desktopGutterMini,
	      textOverflow: 'ellipsis',
	      top: 0,
	      whiteSpace: 'nowrap'
	    },
	    labelWhenOpen: {
	      opacity: 0,
	      top: spacing.desktopToolbarHeight / 8
	    },
	    root: {
	      display: 'inline-block',
	      fontSize: spacing.desktopDropDownMenuFontSize,
	      height: spacing.desktopSubheaderHeight,
	      fontFamily: context.muiTheme.baseTheme.fontFamily,
	      outline: 'none',
	      position: 'relative',
	      transition: _transitions2.default.easeOut()
	    },
	    rootWhenOpen: {
	      opacity: 1
	    },
	    underline: {
	      borderTop: 'solid 1px ' + accentColor,
	      bottom: 1,
	      left: 0,
	      margin: '-1px ' + spacing.desktopGutter + 'px',
	      right: 0,
	      position: 'absolute'
	    }
	  };
	}
	
	var DropDownMenu = function (_Component) {
	  (0, _inherits3.default)(DropDownMenu, _Component);
	
	  function DropDownMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, DropDownMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = DropDownMenu.__proto__ || (0, _getPrototypeOf2.default)(DropDownMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.rootNode = undefined, _this.arrowNode = undefined, _this.handleTouchTapControl = function (event) {
	      event.preventDefault();
	      if (!_this.props.disabled) {
	        _this.setState({
	          open: !_this.state.open,
	          anchorEl: _this.rootNode
	        });
	      }
	    }, _this.handleRequestCloseMenu = function () {
	      _this.close(false);
	    }, _this.handleEscKeyDownMenu = function () {
	      _this.close(true);
	    }, _this.handleKeyDown = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'up':
	        case 'down':
	        case 'space':
	        case 'enter':
	          event.preventDefault();
	          _this.setState({
	            open: true,
	            anchorEl: _this.rootNode
	          });
	          break;
	      }
	    }, _this.handleItemTouchTap = function (event, child, index) {
	      if (_this.props.multiple) {
	        if (!_this.state.open) {
	          _this.setState({ open: true });
	        }
	      } else {
	        event.persist();
	        _this.setState({
	          open: false
	        }, function () {
	          if (_this.props.onChange) {
	            _this.props.onChange(event, index, child.props.value);
	          }
	
	          _this.close(_events2.default.isKeyboard(event));
	        });
	      }
	    }, _this.handleChange = function (event, value) {
	      if (_this.props.multiple && _this.props.onChange) {
	        _this.props.onChange(event, undefined, value);
	      }
	    }, _this.close = function (isKeyboard) {
	      _this.setState({
	        open: false
	      }, function () {
	        if (_this.props.onClose) {
	          _this.props.onClose();
	        }
	
	        if (isKeyboard) {
	          var dropArrow = _this.arrowNode;
	          var dropNode = _reactDom2.default.findDOMNode(dropArrow);
	          dropNode.focus();
	          dropArrow.setKeyboardFocus(true);
	        }
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  // The nested styles for drop-down-menu are modified by toolbar and possibly
	  // other user components, so it will give full access to its js styles rather
	  // than just the parent.
	
	
	  (0, _createClass3.default)(DropDownMenu, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	      if (this.props.openImmediately) {
	        // TODO: Temporary fix to make openImmediately work with popover.
	        /* eslint-disable react/no-did-mount-set-state */
	        setTimeout(function () {
	          return _this2.setState({
	            open: true,
	            anchorEl: _this2.rootNode
	          });
	        }, 0);
	        /* eslint-enable react/no-did-mount-set-state */
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps() {
	      if (this.props.autoWidth) {
	        this.setWidth();
	      }
	    }
	  }, {
	    key: 'getInputNode',
	
	
	    /**
	     * This method is deprecated but still here because the TextField
	     * need it in order to work. TODO: That will be addressed later.
	     */
	    value: function getInputNode() {
	      var _this3 = this;
	
	      var rootNode = this.rootNode;
	
	      rootNode.focus = function () {
	        if (!_this3.props.disabled) {
	          _this3.setState({
	            open: !_this3.state.open,
	            anchorEl: _this3.rootNode
	          });
	        }
	      };
	
	      return rootNode;
	    }
	  }, {
	    key: 'setWidth',
	    value: function setWidth() {
	      var el = this.rootNode;
	      if (!this.props.style || !this.props.style.hasOwnProperty('width')) {
	        el.style.width = 'auto';
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props = this.props,
	          animated = _props.animated,
	          animation = _props.animation,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          iconStyle = _props.iconStyle,
	          labelStyle = _props.labelStyle,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyleProp = _props.menuStyle,
	          selectionRenderer = _props.selectionRenderer,
	          onClose = _props.onClose,
	          openImmediately = _props.openImmediately,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          style = _props.style,
	          underlineStyle = _props.underlineStyle,
	          value = _props.value,
	          iconButton = _props.iconButton,
	          anchorOrigin = _props.anchorOrigin,
	          targetOrigin = _props.targetOrigin,
	          other = (0, _objectWithoutProperties3.default)(_props, ['animated', 'animation', 'autoWidth', 'multiple', 'children', 'className', 'disabled', 'iconStyle', 'labelStyle', 'listStyle', 'maxHeight', 'menuStyle', 'selectionRenderer', 'onClose', 'openImmediately', 'menuItemStyle', 'selectedMenuItemStyle', 'style', 'underlineStyle', 'value', 'iconButton', 'anchorOrigin', 'targetOrigin']);
	      var _state = this.state,
	          anchorEl = _state.anchorEl,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var displayValue = '';
	      if (!multiple) {
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value === child.props.value) {
	            if (selectionRenderer) {
	              displayValue = selectionRenderer(value);
	            } else {
	              // This will need to be improved (in case primaryText is a node)
	              displayValue = child.props.label || child.props.primaryText;
	            }
	          }
	        });
	      } else {
	        var values = [];
	        _react2.default.Children.forEach(children, function (child) {
	          if (child && value && value.includes(child.props.value)) {
	            if (selectionRenderer) {
	              values.push(child.props.value);
	            } else {
	              values.push(child.props.label || child.props.primaryText);
	            }
	          }
	        });
	
	        displayValue = [];
	        if (selectionRenderer) {
	          displayValue = selectionRenderer(values);
	        } else {
	          displayValue = values.join(', ');
	        }
	      }
	
	      var menuStyle = void 0;
	      if (anchorEl && !autoWidth) {
	        menuStyle = (0, _simpleAssign2.default)({
	          width: anchorEl.clientWidth
	        }, menuStyleProp);
	      } else {
	        menuStyle = menuStyleProp;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, {
	          ref: function ref(node) {
	            _this4.rootNode = node;
	          },
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, open && styles.rootWhenOpen, style))
	        }),
	        _react2.default.createElement(
	          _ClearFix2.default,
	          { style: styles.control, onTouchTap: this.handleTouchTapControl },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.label, open && styles.labelWhenOpen, labelStyle)) },
	            displayValue
	          ),
	          _react2.default.createElement(
	            _IconButton2.default,
	            {
	              disabled: disabled,
	              onKeyDown: this.handleKeyDown,
	              ref: function ref(node) {
	                _this4.arrowNode = node;
	              },
	              style: (0, _simpleAssign2.default)({}, styles.icon, iconStyle),
	              iconStyle: styles.iconChildren
	            },
	            iconButton
	          ),
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.underline, underlineStyle)) })
	        ),
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            anchorEl: anchorEl,
	            animation: animation || _PopoverAnimationVertical2.default,
	            open: open,
	            animated: animated,
	            onRequestClose: this.handleRequestCloseMenu
	          },
	          _react2.default.createElement(
	            _Menu2.default,
	            {
	              multiple: multiple,
	              maxHeight: maxHeight,
	              desktop: true,
	              value: value,
	              onEscKeyDown: this.handleEscKeyDownMenu,
	              style: menuStyle,
	              listStyle: listStyle,
	              onItemTouchTap: this.handleItemTouchTap,
	              onChange: this.handleChange,
	              menuItemStyle: menuItemStyle,
	              selectedMenuItemStyle: selectedMenuItemStyle
	            },
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return DropDownMenu;
	}(_react.Component);
	
	DropDownMenu.muiName = 'DropDownMenu';
	DropDownMenu.defaultProps = {
	  animated: true,
	  autoWidth: true,
	  disabled: false,
	  iconButton: _react2.default.createElement(_arrowDropDown2.default, null),
	  openImmediately: false,
	  maxHeight: 500,
	  multiple: false,
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  }
	};
	DropDownMenu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? DropDownMenu.propTypes = {
	  /**
	   * This is the point on the anchor that the popover's
	   * `targetOrigin` will attach to.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * The width will automatically be set according to the items inside the menu.
	   * To control this width in css instead, set this prop to `false`.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The `MenuItem`s to populate the `Menu` with. If the `MenuItems` have the
	   * prop `label` that value will be used to render the representation of that
	   * item within the field.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the menu.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides default `SvgIcon` dropdown arrow component.
	   */
	  iconButton: _propTypes2.default.node,
	  /**
	   * Overrides the styles of icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the styles of label when the `DropDownMenu` is inactive.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override underlying list style.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * The maximum height of the `Menu` when it is displayed.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * Overrides the styles of `Menu` when the `DropDownMenu` is displayed.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item that was clicked.
	   * @param {number} key The index of the clicked menu item in the `children` collection.
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the menu is closed.
	   */
	  onClose: _propTypes2.default.func,
	  /**
	   * Set to true to have the `DropDownMenu` automatically open on mount.
	   */
	  openImmediately: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when a menu item is clicked, other than the one currently selected.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  selectionRenderer: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the popover which will attach to
	   * the anchor's origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Overrides the inline-styles of the underline.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _propTypes2.default.any
	} : void 0;
	exports.default = DropDownMenu;

/***/ },
/* 814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _childUtils = __webpack_require__(117);
	
	var _colorManipulator = __webpack_require__(53);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FlatButtonLabel = __webpack_require__(815);
	
	var _FlatButtonLabel2 = _interopRequireDefault(_FlatButtonLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	var FlatButton = function (_Component) {
	  (0, _inherits3.default)(FlatButton, _Component);
	
	  function FlatButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FlatButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FlatButton.__proto__ || (0, _getPrototypeOf2.default)(FlatButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      touch: false
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      _this.props.onKeyboardFocus(event, isKeyboardFocused);
	    }, _this.handleMouseEnter = function (event) {
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	      _this.props.onTouchStart(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FlatButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({
	          hovered: false
	        });
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          children = _props.children,
	          disabled = _props.disabled,
	          fullWidth = _props.fullWidth,
	          hoverColor = _props.hoverColor,
	          icon = _props.icon,
	          label = _props.label,
	          labelStyle = _props.labelStyle,
	          labelPosition = _props.labelPosition,
	          primary = _props.primary,
	          rippleColor = _props.rippleColor,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'children', 'disabled', 'fullWidth', 'hoverColor', 'icon', 'label', 'labelStyle', 'labelPosition', 'primary', 'rippleColor', 'secondary', 'style']);
	      var _context$muiTheme = this.context.muiTheme,
	          borderRadius = _context$muiTheme.borderRadius,
	          _context$muiTheme$but = _context$muiTheme.button,
	          buttonHeight = _context$muiTheme$but.height,
	          buttonMinWidth = _context$muiTheme$but.minWidth,
	          buttonTextTransform = _context$muiTheme$but.textTransform,
	          _context$muiTheme$fla = _context$muiTheme.flatButton,
	          buttonFilterColor = _context$muiTheme$fla.buttonFilterColor,
	          buttonColor = _context$muiTheme$fla.color,
	          disabledTextColor = _context$muiTheme$fla.disabledTextColor,
	          fontSize = _context$muiTheme$fla.fontSize,
	          fontWeight = _context$muiTheme$fla.fontWeight,
	          primaryTextColor = _context$muiTheme$fla.primaryTextColor,
	          secondaryTextColor = _context$muiTheme$fla.secondaryTextColor,
	          textColor = _context$muiTheme$fla.textColor,
	          _context$muiTheme$fla2 = _context$muiTheme$fla.textTransform,
	          textTransform = _context$muiTheme$fla2 === undefined ? buttonTextTransform || 'uppercase' : _context$muiTheme$fla2;
	
	      var defaultTextColor = disabled ? disabledTextColor : primary ? primaryTextColor : secondary ? secondaryTextColor : textColor;
	
	      var defaultHoverColor = (0, _colorManipulator.fade)(buttonFilterColor, 0.2);
	      var defaultRippleColor = buttonFilterColor;
	      var buttonHoverColor = hoverColor || defaultHoverColor;
	      var buttonRippleColor = rippleColor || defaultRippleColor;
	      var buttonBackgroundColor = backgroundColor || buttonColor;
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        height: buttonHeight,
	        lineHeight: buttonHeight + 'px',
	        minWidth: fullWidth ? '100%' : buttonMinWidth,
	        color: defaultTextColor,
	        transition: _transitions2.default.easeOut(),
	        borderRadius: borderRadius,
	        userSelect: 'none',
	        overflow: 'hidden',
	        backgroundColor: hovered ? buttonHoverColor : buttonBackgroundColor,
	        padding: 0,
	        margin: 0,
	        textAlign: 'center'
	      }, style);
	
	      var iconCloned = void 0;
	      var labelStyleIcon = {};
	
	      if (icon) {
	        var iconStyles = (0, _simpleAssign2.default)({
	          verticalAlign: 'middle',
	          marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	          marginRight: label && labelPosition === 'before' ? 12 : 0
	        }, icon.props.style);
	        iconCloned = _react2.default.cloneElement(icon, {
	          color: icon.props.color || mergedRootStyles.color,
	          style: iconStyles
	        });
	
	        if (labelPosition === 'before') {
	          labelStyleIcon.paddingRight = 8;
	        } else {
	          labelStyleIcon.paddingLeft = 8;
	        }
	      }
	
	      var mergedLabelStyles = (0, _simpleAssign2.default)({
	        letterSpacing: 0,
	        textTransform: textTransform,
	        fontWeight: fontWeight,
	        fontSize: fontSize
	      }, labelStyleIcon, labelStyle);
	
	      var labelElement = label ? _react2.default.createElement(_FlatButtonLabel2.default, { label: label, style: mergedLabelStyles }) : undefined;
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({}, other, {
	          disabled: disabled,
	          focusRippleColor: buttonRippleColor,
	          focusRippleOpacity: 0.3,
	          onKeyboardFocus: this.handleKeyboardFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          touchRippleColor: buttonRippleColor,
	          touchRippleOpacity: 0.3
	        }),
	        enhancedButtonChildren
	      );
	    }
	  }]);
	  return FlatButton;
	}(_react.Component);
	
	FlatButton.muiName = 'FlatButton';
	FlatButton.defaultProps = {
	  disabled: false,
	  fullWidth: false,
	  labelStyle: {},
	  labelPosition: 'after',
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  onTouchStart: function onTouchStart() {},
	  primary: false,
	  secondary: false
	};
	FlatButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? FlatButton.propTypes = {
	  /**
	   * Color of button when mouse is not hovering over it.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * This is what will be displayed inside the button.
	   * If a label is specified, the text within the label prop will
	   * be displayed. Otherwise, the component will expect children
	   * which will then be displayed. (In our example,
	   * we are nesting an `<input type="file" />` and a `span`
	   * that acts as our label to be displayed.) This only
	   * applies to flat and raised buttons.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The element to use as the container for the FlatButton. Either a string to
	   * use a DOM element or a ReactElement. This is useful for wrapping the
	   * FlatButton in a custom Link component. If a ReactElement is given, ensure
	   * that it passes all of its given props through to the underlying DOM
	   * element and renders its children prop for proper integration.
	   */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Color of button when mouse hovers over.
	   */
	  hoverColor: _propTypes2.default.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * Use this property to display an icon.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * Label for the button.
	   */
	  label: validateLabel,
	  /**
	   * Place label before or after the passed children.
	   */
	  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} isKeyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * If true, colors button according to
	   * primaryTextColor from the Theme.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * Color for the ripple after button is clicked.
	   */
	  rippleColor: _propTypes2.default.string,
	  /**
	   * If true, colors button according to secondaryTextColor from the theme.
	   * The primary prop has precendent if set to true.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = FlatButton;

/***/ },
/* 815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      position: 'relative',
	      paddingLeft: baseTheme.spacing.desktopGutterLess,
	      paddingRight: baseTheme.spacing.desktopGutterLess,
	      verticalAlign: 'middle'
	    }
	  };
	}
	
	var FlatButtonLabel = function (_Component) {
	  (0, _inherits3.default)(FlatButtonLabel, _Component);
	
	  function FlatButtonLabel() {
	    (0, _classCallCheck3.default)(this, FlatButtonLabel);
	    return (0, _possibleConstructorReturn3.default)(this, (FlatButtonLabel.__proto__ || (0, _getPrototypeOf2.default)(FlatButtonLabel)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(FlatButtonLabel, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          label = _props.label,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        label
	      );
	    }
	  }]);
	  return FlatButtonLabel;
	}(_react.Component);
	
	FlatButtonLabel.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? FlatButtonLabel.propTypes = {
	  label: _propTypes2.default.node,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = FlatButtonLabel;

/***/ },
/* 816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(53);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(213);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _childUtils = __webpack_require__(117);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var floatingActionButton = context.muiTheme.floatingActionButton;
	
	
	  var backgroundColor = props.backgroundColor || floatingActionButton.color;
	  var iconColor = floatingActionButton.iconColor;
	
	  if (props.disabled) {
	    backgroundColor = props.disabledColor || floatingActionButton.disabledColor;
	    iconColor = floatingActionButton.disabledTextColor;
	  } else if (props.secondary) {
	    backgroundColor = floatingActionButton.secondaryColor;
	    iconColor = floatingActionButton.secondaryIconColor;
	  }
	
	  return {
	    root: {
	      transition: _transitions2.default.easeOut(),
	      display: 'inline-block',
	      backgroundColor: 'transparent'
	    },
	    container: {
	      backgroundColor: backgroundColor,
	      transition: _transitions2.default.easeOut(),
	      height: floatingActionButton.buttonSize,
	      width: floatingActionButton.buttonSize,
	      padding: 0,
	      overflow: 'hidden',
	      borderRadius: '50%',
	      textAlign: 'center',
	      verticalAlign: 'bottom'
	    },
	    containerWhenMini: {
	      height: floatingActionButton.miniSize,
	      width: floatingActionButton.miniSize
	    },
	    overlay: {
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    overlayWhenHovered: {
	      backgroundColor: (0, _colorManipulator.fade)(iconColor, 0.4)
	    },
	    icon: {
	      height: floatingActionButton.buttonSize,
	      lineHeight: floatingActionButton.buttonSize + 'px',
	      fill: iconColor,
	      color: iconColor
	    },
	    iconWhenMini: {
	      height: floatingActionButton.miniSize,
	      lineHeight: floatingActionButton.miniSize + 'px'
	    }
	  };
	}
	
	var FloatingActionButton = function (_Component) {
	  (0, _inherits3.default)(FloatingActionButton, _Component);
	
	  function FloatingActionButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FloatingActionButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FloatingActionButton.__proto__ || (0, _getPrototypeOf2.default)(FloatingActionButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touch: false,
	      zDepth: undefined
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	      }
	      if (_this.props.onMouseDown) _this.props.onMouseDown(event);
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({ zDepth: _this.props.zDepth });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.refs.container.isKeyboardFocused()) {
	        _this.setState({ zDepth: _this.props.zDepth, hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.refs.container.isKeyboardFocused() && !_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth + 1
	      });
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touch: true,
	        zDepth: _this.props.zDepth
	      });
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      if (keyboardFocused && !_this.props.disabled) {
	        _this.setState({ zDepth: _this.props.zDepth + 1 });
	        _this.refs.overlay.style.backgroundColor = (0, _colorManipulator.fade)(getStyles(_this.props, _this.context).icon.color, 0.4);
	      } else if (!_this.state.hovered) {
	        _this.setState({ zDepth: _this.props.zDepth });
	        _this.refs.overlay.style.backgroundColor = 'transparent';
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FloatingActionButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        zDepth: this.props.disabled ? 0 : this.props.zDepth
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	       false ? (0, _warning2.default)(!this.props.iconClassName || !this.props.children, 'Material-UI: You have set both an iconClassName and a child icon. ' + 'It is recommended you use only one method when adding ' + 'icons to FloatingActionButtons.') : void 0;
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var nextState = {};
	
	      if (nextProps.disabled !== this.props.disabled) {
	        nextState.zDepth = nextProps.disabled ? 0 : this.props.zDepth;
	      }
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          className = _props.className,
	          childrenProp = _props.children,
	          disabled = _props.disabled,
	          disabledColor = _props.disabledColor,
	          mini = _props.mini,
	          secondary = _props.secondary,
	          iconStyle = _props.iconStyle,
	          iconClassName = _props.iconClassName,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'className', 'children', 'disabled', 'disabledColor', 'mini', 'secondary', 'iconStyle', 'iconClassName', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var iconElement = void 0;
	      if (iconClassName) {
	        iconElement = _react2.default.createElement(_FontIcon2.default, {
	          className: iconClassName,
	          style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle)
	        });
	      }
	
	      var children = void 0;
	
	      if (childrenProp) {
	        children = (0, _childUtils.extendChildren)(childrenProp, function (child) {
	          return {
	            style: (0, _simpleAssign2.default)({}, styles.icon, mini && styles.iconWhenMini, iconStyle, child.props.style)
	          };
	        });
	      }
	
	      var buttonEventHandlers = disabled ? null : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, this.props.style),
	          zDepth: this.state.zDepth,
	          circle: true
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.container, this.props.mini && styles.containerWhenMini, iconStyle),
	            focusRippleColor: styles.icon.color,
	            touchRippleColor: styles.icon.color
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, this.state.hovered && !this.props.disabled && styles.overlayWhenHovered))
	            },
	            iconElement,
	            children
	          )
	        )
	      );
	    }
	  }]);
	  return FloatingActionButton;
	}(_react.Component);
	
	FloatingActionButton.defaultProps = {
	  disabled: false,
	  mini: false,
	  secondary: false,
	  zDepth: 2
	};
	FloatingActionButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? FloatingActionButton.propTypes = {
	  /**
	   * This value will override the default background color for the button.
	   * However it will not override the default disabled background color.
	   * This has to be set separately using the disabledColor attribute.
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * This is what displayed inside the floating action button; for example, a SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the button if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * This value will override the default background color for the button when it is disabled.
	   */
	  disabledColor: _propTypes2.default.string,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * The icon within the FloatingActionButton is a FontIcon component.
	   * This property is the classname of the icon to be displayed inside the button.
	   * An alternative to adding an iconClassName would be to manually insert a
	   * FontIcon component or custom SvgIcon component or as a child of FloatingActionButton.
	   */
	  iconClassName: _propTypes2.default.string,
	  /**
	   * This is the equivalent to iconClassName except that it is used for
	   * overriding the inline-styles of the FontIcon component.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will be a small floating action button.
	   */
	  mini: _propTypes2.default.bool,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * If true, the button will use the secondary button colors.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The zDepth of the underlying `Paper` component.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : void 0;
	exports.default = FloatingActionButton;

/***/ },
/* 817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _FloatingActionButton = __webpack_require__(816);
	
	var _FloatingActionButton2 = _interopRequireDefault(_FloatingActionButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _FloatingActionButton2.default;

/***/ },
/* 818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var color = props.color,
	      hoverColor = props.hoverColor;
	  var baseTheme = context.muiTheme.baseTheme;
	
	  var offColor = color || baseTheme.palette.textColor;
	  var onColor = hoverColor || offColor;
	
	  return {
	    root: {
	      color: state.hovered ? onColor : offColor,
	      position: 'relative',
	      fontSize: baseTheme.spacing.iconSize,
	      display: 'inline-block',
	      userSelect: 'none',
	      transition: _transitions2.default.easeOut()
	    }
	  };
	}
	
	var FontIcon = function (_Component) {
	  (0, _inherits3.default)(FontIcon, _Component);
	
	  function FontIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, FontIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = FontIcon.__proto__ || (0, _getPrototypeOf2.default)(FontIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: false });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      // hover is needed only when a hoverColor is defined
	      if (_this.props.hoverColor !== undefined) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(FontIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          hoverColor = _props.hoverColor,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['hoverColor', 'onMouseLeave', 'onMouseEnter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement('span', (0, _extends3.default)({}, other, {
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	      }));
	    }
	  }]);
	  return FontIcon;
	}(_react.Component);
	
	FontIcon.muiName = 'FontIcon';
	FontIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {}
	};
	FontIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? FontIcon.propTypes = {
	  /**
	   * This is the font color of the font icon. If not specified,
	   * this component will default to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = FontIcon;

/***/ },
/* 819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    root: {
	      display: 'flex',
	      flexWrap: 'wrap',
	      margin: -props.padding / 2
	    },
	    item: {
	      boxSizing: 'border-box',
	      padding: props.padding / 2
	    }
	  };
	}
	
	var GridList = function (_Component) {
	  (0, _inherits3.default)(GridList, _Component);
	
	  function GridList() {
	    (0, _classCallCheck3.default)(this, GridList);
	    return (0, _possibleConstructorReturn3.default)(this, (GridList.__proto__ || (0, _getPrototypeOf2.default)(GridList)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(GridList, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          cols = _props.cols,
	          padding = _props.padding,
	          cellHeight = _props.cellHeight,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['cols', 'padding', 'cellHeight', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	
	      var wrappedChildren = _react2.default.Children.map(children, function (currentChild) {
	        if (_react2.default.isValidElement(currentChild) && currentChild.type.muiName === 'Subheader') {
	          return currentChild;
	        }
	        var childCols = currentChild.props.cols || 1;
	        var childRows = currentChild.props.rows || 1;
	        var itemStyle = (0, _simpleAssign2.default)({}, styles.item, {
	          width: 100 / cols * childCols + '%',
	          height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + padding
	        });
	
	        return _react2.default.createElement(
	          'div',
	          { style: prepareStyles(itemStyle) },
	          currentChild
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles(mergedRootStyles) }, other),
	        wrappedChildren
	      );
	    }
	  }]);
	  return GridList;
	}(_react.Component);
	
	GridList.defaultProps = {
	  cols: 2,
	  padding: 4,
	  cellHeight: 180
	};
	GridList.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? GridList.propTypes = {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.oneOf(['auto'])]),
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes2.default.number,
	  /**
	   * Number of px for the padding/spacing between items.
	   */
	  padding: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = GridList;

/***/ },
/* 820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.GridTile = exports.GridList = undefined;
	
	var _GridList2 = __webpack_require__(819);
	
	var _GridList3 = _interopRequireDefault(_GridList2);
	
	var _GridTile2 = __webpack_require__(354);
	
	var _GridTile3 = _interopRequireDefault(_GridTile2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.GridList = _GridList3.default;
	exports.GridTile = _GridTile3.default;
	exports.default = _GridList3.default;

/***/ },
/* 821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _FontIcon = __webpack_require__(213);
	
	var _FontIcon2 = _interopRequireDefault(_FontIcon);
	
	var _Tooltip = __webpack_require__(373);
	
	var _Tooltip2 = _interopRequireDefault(_Tooltip);
	
	var _childUtils = __webpack_require__(117);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var baseTheme = context.muiTheme.baseTheme;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      overflow: 'visible',
	      transition: _transitions2.default.easeOut(),
	      padding: baseTheme.spacing.iconSize / 2,
	      width: baseTheme.spacing.iconSize * 2,
	      height: baseTheme.spacing.iconSize * 2,
	      fontSize: 0
	    },
	    tooltip: {
	      boxSizing: 'border-box'
	    },
	    disabled: {
	      color: baseTheme.palette.disabledColor,
	      fill: baseTheme.palette.disabledColor,
	      cursor: 'not-allowed'
	    }
	  };
	}
	
	var IconButton = function (_Component) {
	  (0, _inherits3.default)(IconButton, _Component);
	
	  function IconButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconButton.__proto__ || (0, _getPrototypeOf2.default)(IconButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      isKeyboardFocused: false,
	      // Not to be confonded with the touch property.
	      // This state is to determined if it's a mobile device.
	      touch: false,
	      tooltipShown: false
	    }, _this.handleBlur = function (event) {
	      _this.hideTooltip();
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleFocus = function (event) {
	      _this.showTooltip();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.button.isKeyboardFocused()) {
	        _this.hideTooltip();
	      }
	      _this.setState({ hovered: false });
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseOut = function (event) {
	      if (_this.props.disabled) _this.hideTooltip();
	      if (_this.props.onMouseOut) _this.props.onMouseOut(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.showTooltip();
	
	      // Cancel hover styles for touch devices
	      if (!_this.state.touch) {
	        _this.setState({ hovered: true });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({ touch: true });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, isKeyboardFocused) {
	      var _this$props = _this.props,
	          disabled = _this$props.disabled,
	          onFocus = _this$props.onFocus,
	          onBlur = _this$props.onBlur,
	          onKeyboardFocus = _this$props.onKeyboardFocus;
	
	      if (isKeyboardFocused && !disabled) {
	        _this.showTooltip();
	        if (onFocus) {
	          onFocus(event);
	        }
	      } else {
	        _this.hideTooltip();
	        if (onBlur) {
	          onBlur(event);
	        }
	      }
	
	      _this.setState({ isKeyboardFocused: isKeyboardFocused });
	      if (onKeyboardFocus) {
	        onKeyboardFocus(event, isKeyboardFocused);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconButton, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.disabled) {
	        this.setState({ hovered: false });
	      }
	    }
	  }, {
	    key: 'setKeyboardFocus',
	    value: function setKeyboardFocus() {
	      this.button.setKeyboardFocus();
	    }
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip() {
	      if (this.props.tooltip) {
	        this.setState({ tooltipShown: true });
	      }
	    }
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip() {
	      if (this.props.tooltip) this.setState({ tooltipShown: false });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          disabled = _props.disabled,
	          hoveredStyle = _props.hoveredStyle,
	          disableTouchRipple = _props.disableTouchRipple,
	          children = _props.children,
	          iconClassName = _props.iconClassName,
	          style = _props.style,
	          tooltip = _props.tooltip,
	          tooltipPositionProp = _props.tooltipPosition,
	          tooltipStyles = _props.tooltipStyles,
	          touch = _props.touch,
	          iconStyle = _props.iconStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['disabled', 'hoveredStyle', 'disableTouchRipple', 'children', 'iconClassName', 'style', 'tooltip', 'tooltipPosition', 'tooltipStyles', 'touch', 'iconStyle']);
	
	      var fonticon = void 0;
	
	      var styles = getStyles(this.props, this.context);
	      var tooltipPosition = tooltipPositionProp.split('-');
	
	      var hovered = (this.state.hovered || this.state.isKeyboardFocused) && !disabled;
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style, hovered ? hoveredStyle : {});
	
	      var tooltipElement = tooltip ? _react2.default.createElement(_Tooltip2.default, {
	        label: tooltip,
	        show: this.state.tooltipShown,
	        touch: touch,
	        style: (0, _simpleAssign2.default)(styles.tooltip, tooltipStyles),
	        verticalPosition: tooltipPosition[0],
	        horizontalPosition: tooltipPosition[1]
	      }) : null;
	
	      if (iconClassName) {
	        var iconHoverColor = iconStyle.iconHoverColor,
	            iconStyleFontIcon = (0, _objectWithoutProperties3.default)(iconStyle, ['iconHoverColor']);
	
	
	        fonticon = _react2.default.createElement(
	          _FontIcon2.default,
	          {
	            className: iconClassName,
	            hoverColor: disabled ? null : iconHoverColor,
	            style: (0, _simpleAssign2.default)({}, disabled && styles.disabled, iconStyleFontIcon),
	            color: this.context.muiTheme.baseTheme.palette.textColor
	          },
	          children
	        );
	      }
	
	      var childrenStyle = disabled ? (0, _simpleAssign2.default)({}, iconStyle, styles.disabled) : iconStyle;
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          ref: function ref(_ref2) {
	            return _this2.button = _ref2;
	          }
	        }, other, {
	          centerRipple: true,
	          disabled: disabled,
	          onTouchStart: this.handleTouchStart,
	          style: mergedRootStyles,
	          disableTouchRipple: disableTouchRipple,
	          onBlur: this.handleBlur,
	          onFocus: this.handleFocus,
	          onMouseLeave: this.handleMouseLeave,
	          onMouseEnter: this.handleMouseEnter,
	          onMouseOut: this.handleMouseOut,
	          onKeyboardFocus: this.handleKeyboardFocus
	        }),
	        tooltipElement,
	        fonticon,
	        (0, _childUtils.extendChildren)(children, {
	          style: childrenStyle
	        })
	      );
	    }
	  }]);
	  return IconButton;
	}(_react.Component);
	
	IconButton.muiName = 'IconButton';
	IconButton.defaultProps = {
	  disabled: false,
	  disableTouchRipple: false,
	  iconStyle: {},
	  tooltipPosition: 'bottom-center',
	  touch: false
	};
	IconButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? IconButton.propTypes = {
	  /**
	   * Can be used to pass a `FontIcon` element as the icon for the button.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * If true, the element will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when the component is hovered.
	   */
	  hoveredStyle: _propTypes2.default.object,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * The CSS class name of the icon. Used for setting the icon with a stylesheet.
	   */
	  iconClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the icon element.
	   * Note: you can specify iconHoverColor as a String inside this object.
	   */
	  iconStyle: _propTypes2.default.object,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function fired when the element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the element.
	   * @param {boolean} keyboardFocused Indicates whether the element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseOut: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The text to supply to the element's tooltip.
	   */
	  tooltip: _propTypes2.default.node,
	  /**
	   * The vertical and horizontal positions, respectively, of the element's tooltip.
	   * Possible values are: "bottom-center", "top-center", "bottom-right", "top-right",
	   * "bottom-left", and "top-left".
	   */
	  tooltipPosition: _propTypes4.default.cornersAndCenter,
	  /**
	   * Override the inline-styles of the tooltip element.
	   */
	  tooltipStyles: _propTypes2.default.object,
	  /**
	   * If true, increase the tooltip element's size. Useful for increasing tooltip
	   * readability on mobile devices.
	   */
	  touch: _propTypes2.default.bool
	} : void 0;
	exports.default = IconButton;

/***/ },
/* 822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _events = __webpack_require__(152);
	
	var _events2 = _interopRequireDefault(_events);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Menu = __webpack_require__(149);
	
	var _Menu2 = _interopRequireDefault(_Menu);
	
	var _Popover = __webpack_require__(87);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var IconMenu = function (_Component) {
	  (0, _inherits3.default)(IconMenu, _Component);
	
	  function IconMenu() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, IconMenu);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = IconMenu.__proto__ || (0, _getPrototypeOf2.default)(IconMenu)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      menuInitiallyKeyboardFocused: false,
	      open: false
	    }, _this.handleItemTouchTap = function (event, child) {
	      if (_this.props.touchTapCloseDelay !== 0 && !child.props.hasOwnProperty('menuItems')) {
	        var isKeyboard = _events2.default.isKeyboard(event);
	        _this.timerCloseId = setTimeout(function () {
	          _this.close(isKeyboard ? 'enter' : 'itemTap', isKeyboard);
	        }, _this.props.touchTapCloseDelay);
	      }
	
	      _this.props.onItemTouchTap(event, child);
	    }, _this.handleRequestClose = function (reason) {
	      _this.close(reason);
	    }, _this.handleEscKeyDownMenu = function (event) {
	      _this.close('escape', event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(IconMenu, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.open != null) {
	        this.setState({
	          open: nextProps.open,
	          anchorEl: this.refs.iconMenuContainer
	        });
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerCloseId);
	    }
	  }, {
	    key: 'isOpen',
	    value: function isOpen() {
	      return this.state.open;
	    }
	  }, {
	    key: 'close',
	    value: function close(reason, isKeyboard) {
	      var _this2 = this;
	
	      if (!this.state.open) {
	        return;
	      }
	
	      if (this.props.open !== null) {
	        this.props.onRequestChange(false, reason);
	      } else {
	        this.setState({ open: false }, function () {
	          // Set focus on the icon button when the menu close
	          if (isKeyboard) {
	            var iconButton = _this2.refs.iconButton;
	            _reactDom2.default.findDOMNode(iconButton).focus();
	            iconButton.setKeyboardFocus();
	          }
	        });
	      }
	    }
	  }, {
	    key: 'open',
	    value: function open(reason, event) {
	      if (this.props.open !== null) {
	        this.props.onRequestChange(true, reason);
	
	        return this.setState({
	          menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	          anchorEl: event.currentTarget
	        });
	      }
	
	      this.setState({
	        open: true,
	        menuInitiallyKeyboardFocused: _events2.default.isKeyboard(event),
	        anchorEl: event.currentTarget
	      });
	
	      event.preventDefault();
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props = this.props,
	          anchorOrigin = _props.anchorOrigin,
	          className = _props.className,
	          animated = _props.animated,
	          animation = _props.animation,
	          iconButtonElement = _props.iconButtonElement,
	          iconStyle = _props.iconStyle,
	          onItemTouchTap = _props.onItemTouchTap,
	          onKeyboardFocus = _props.onKeyboardFocus,
	          onMouseDown = _props.onMouseDown,
	          onMouseLeave = _props.onMouseLeave,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseUp = _props.onMouseUp,
	          onRequestChange = _props.onRequestChange,
	          onTouchTap = _props.onTouchTap,
	          listStyle = _props.listStyle,
	          menuStyle = _props.menuStyle,
	          style = _props.style,
	          targetOrigin = _props.targetOrigin,
	          touchTapCloseDelay = _props.touchTapCloseDelay,
	          useLayerForClickAway = _props.useLayerForClickAway,
	          other = (0, _objectWithoutProperties3.default)(_props, ['anchorOrigin', 'className', 'animated', 'animation', 'iconButtonElement', 'iconStyle', 'onItemTouchTap', 'onKeyboardFocus', 'onMouseDown', 'onMouseLeave', 'onMouseEnter', 'onMouseUp', 'onRequestChange', 'onTouchTap', 'listStyle', 'menuStyle', 'style', 'targetOrigin', 'touchTapCloseDelay', 'useLayerForClickAway']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var _state = this.state,
	          open = _state.open,
	          anchorEl = _state.anchorEl;
	
	
	      var styles = {
	        root: {
	          display: 'inline-block',
	          position: 'relative'
	        },
	        menu: {
	          position: 'relative'
	        }
	      };
	
	      var mergedRootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var mergedMenuStyles = (0, _simpleAssign2.default)(styles.menu, menuStyle);
	
	       false ? (0, _warning2.default)(iconButtonElement.type.muiName !== 'SvgIcon', 'Material-UI: You shoud not provide an <SvgIcon /> to the \'iconButtonElement\' property of <IconMenu />.\nYou should wrapped it with an <IconButton />.') : void 0;
	
	      var iconButtonProps = {
	        onKeyboardFocus: onKeyboardFocus,
	        onTouchTap: function onTouchTap(event) {
	          _this3.open(_events2.default.isKeyboard(event) ? 'keyboard' : 'iconTap', event);
	          if (iconButtonElement.props.onTouchTap) {
	            iconButtonElement.props.onTouchTap(event);
	          }
	        },
	        ref: 'iconButton'
	      };
	      if (iconStyle || iconButtonElement.props.iconStyle) {
	        iconButtonProps.iconStyle = iconStyle ? (0, _simpleAssign2.default)({}, iconStyle, iconButtonElement.props.iconStyle) : iconButtonElement.props.iconStyle;
	      }
	      var iconButton = _react2.default.cloneElement(iconButtonElement, iconButtonProps);
	
	      var menu = _react2.default.createElement(
	        _Menu2.default,
	        (0, _extends3.default)({}, other, {
	          initiallyKeyboardFocused: this.state.menuInitiallyKeyboardFocused,
	          onEscKeyDown: this.handleEscKeyDownMenu,
	          onItemTouchTap: this.handleItemTouchTap,
	          style: mergedMenuStyles,
	          listStyle: listStyle
	        }),
	        this.props.children
	      );
	
	      return _react2.default.createElement(
	        'div',
	        {
	          ref: 'iconMenuContainer',
	          className: className,
	          onMouseDown: onMouseDown,
	          onMouseLeave: onMouseLeave,
	          onMouseEnter: onMouseEnter,
	          onMouseUp: onMouseUp,
	          onTouchTap: onTouchTap,
	          style: prepareStyles(mergedRootStyles)
	        },
	        iconButton,
	        _react2.default.createElement(
	          _Popover2.default,
	          {
	            anchorOrigin: anchorOrigin,
	            targetOrigin: targetOrigin,
	            open: open,
	            anchorEl: anchorEl,
	            childContextTypes: this.constructor.childContextTypes,
	            useLayerForClickAway: useLayerForClickAway,
	            onRequestClose: this.handleRequestClose,
	            animated: animated,
	            animation: animation,
	            context: this.context
	          },
	          menu
	        )
	      );
	    }
	  }]);
	  return IconMenu;
	}(_react.Component);
	
	IconMenu.muiName = 'IconMenu';
	IconMenu.defaultProps = {
	  anchorOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  animated: true,
	  multiple: false,
	  open: null,
	  onItemTouchTap: function onItemTouchTap() {},
	  onKeyboardFocus: function onKeyboardFocus() {},
	  onMouseDown: function onMouseDown() {},
	  onMouseLeave: function onMouseLeave() {},
	  onMouseEnter: function onMouseEnter() {},
	  onMouseUp: function onMouseUp() {},
	  onRequestChange: function onRequestChange() {},
	  onTouchTap: function onTouchTap() {},
	  targetOrigin: {
	    vertical: 'top',
	    horizontal: 'left'
	  },
	  touchTapCloseDelay: 200,
	  useLayerForClickAway: false
	};
	IconMenu.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? IconMenu.propTypes = {
	  /**
	   * This is the point on the icon where the menu
	   * `targetOrigin` will attach.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  anchorOrigin: _propTypes4.default.origin,
	  /**
	   * If true, the popover will apply transitions when
	   * it gets added to the DOM.
	   */
	  animated: _propTypes2.default.bool,
	  /**
	   * Override the default animation component used.
	   */
	  animation: _propTypes2.default.func,
	  /**
	   * Should be used to pass `MenuItem` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * This is the `IconButton` to render. This button will open the menu.
	   */
	  iconButtonElement: _propTypes2.default.element.isRequired,
	  /**
	   * Override the inline-styles of the underlying icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the menu element.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, the value can an be array and allow the menu to be a multi-select.
	   */
	  multiple: _propTypes2.default.bool,
	  /**
	   * Callback function fired when a menu item is selected with a touch-tap.
	   *
	   * @param {object} event TouchTap event targeting the selected menu item element.
	   * @param {object} child The selected element.
	   */
	  onItemTouchTap: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `IconButton` element is focused or blurred by the keyboard.
	   *
	   * @param {object} event `focus` or `blur` event targeting the `IconButton` element.
	   * @param {boolean} keyboardFocused If true, the `IconButton` element is focused.
	   */
	  onKeyboardFocus: _propTypes2.default.func,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `open` state of the menu is requested to be changed.
	   *
	   * @param {boolean} open If true, the menu was requested to be opened.
	   * @param {string} reason The reason for the open or close request. Possible values are
	   * 'keyboard' and 'iconTap' for open requests; 'enter', 'escape', 'itemTap', and 'clickAway'
	   * for close requests.
	   */
	  onRequestChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the `IconButton` element is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the `IconButton` element.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * If true, the `IconMenu` is opened.
	   */
	  open: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * This is the point on the menu which will stick to the menu
	   * origin.
	   * Options:
	   * vertical: [top, center, bottom]
	   * horizontal: [left, middle, right].
	   */
	  targetOrigin: _propTypes4.default.origin,
	  /**
	   * Sets the delay in milliseconds before closing the
	   * menu when an item is clicked.
	   * If set to 0 then the auto close functionality
	   * will be disabled.
	   */
	  touchTapCloseDelay: _propTypes2.default.number,
	  /**
	   * If true, the popover will render on top of an invisible
	   * layer, which will prevent clicks to the underlying elements.
	   */
	  useLayerForClickAway: _propTypes2.default.bool
	} : void 0;
	exports.default = IconMenu;

/***/ },
/* 823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.MenuItem = exports.IconMenu = undefined;
	
	var _IconMenu2 = __webpack_require__(822);
	
	var _IconMenu3 = _interopRequireDefault(_IconMenu2);
	
	var _MenuItem2 = __webpack_require__(216);
	
	var _MenuItem3 = _interopRequireDefault(_MenuItem2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.IconMenu = _IconMenu3.default;
	exports.MenuItem = _MenuItem3.default;
	exports.default = _IconMenu3.default;

/***/ },
/* 824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getRelativeValue(value, min, max) {
	  var clampedValue = Math.min(Math.max(min, value), max);
	  var rangeValue = max - min;
	  var relValue = Math.round((clampedValue - min) / rangeValue * 10000) / 10000;
	  return relValue * 100;
	}
	
	function getStyles(props, context) {
	  var max = props.max,
	      min = props.min,
	      value = props.value;
	  var _context$muiTheme = context.muiTheme,
	      palette = _context$muiTheme.baseTheme.palette,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var styles = {
	    root: {
	      position: 'relative',
	      height: 4,
	      display: 'block',
	      width: '100%',
	      backgroundColor: palette.primary3Color,
	      borderRadius: borderRadius,
	      margin: 0,
	      overflow: 'hidden'
	    },
	    bar: {
	      height: '100%'
	    },
	    barFragment1: {},
	    barFragment2: {}
	  };
	
	  if (props.mode === 'indeterminate') {
	    styles.barFragment1 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.650, 0.815, 0.735, 0.395)')
	    };
	
	    styles.barFragment2 = {
	      position: 'absolute',
	      backgroundColor: props.color || palette.primary1Color,
	      top: 0,
	      left: 0,
	      bottom: 0,
	      transition: _transitions2.default.create('all', '840ms', null, 'cubic-bezier(0.165, 0.840, 0.440, 1.000)')
	    };
	  } else {
	    styles.bar.backgroundColor = props.color || palette.primary1Color;
	    styles.bar.transition = _transitions2.default.create('width', '.3s', null, 'linear');
	    styles.bar.width = getRelativeValue(value, min, max) + '%';
	  }
	
	  return styles;
	}
	
	var LinearProgress = function (_Component) {
	  (0, _inherits3.default)(LinearProgress, _Component);
	
	  function LinearProgress() {
	    (0, _classCallCheck3.default)(this, LinearProgress);
	    return (0, _possibleConstructorReturn3.default)(this, (LinearProgress.__proto__ || (0, _getPrototypeOf2.default)(LinearProgress)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(LinearProgress, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _this2 = this;
	
	      this.timers = {};
	
	      this.timers.bar1 = this.barUpdate('bar1', 0, this.refs.bar1, [[-35, 100], [100, -90]], 0);
	
	      this.timers.bar2 = setTimeout(function () {
	        _this2.barUpdate('bar2', 0, _this2.refs.bar2, [[-200, 100], [107, -8]], 0);
	      }, 850);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timers.bar1);
	      clearTimeout(this.timers.bar2);
	    }
	  }, {
	    key: 'barUpdate',
	    value: function barUpdate(id, step, barElement, stepValues, timeToNextStep) {
	      var _this3 = this;
	
	      if (this.props.mode !== 'indeterminate') return;
	
	      timeToNextStep = timeToNextStep || 420;
	      step = step || 0;
	      step %= 4;
	
	      var right = this.context.muiTheme.isRtl ? 'left' : 'right';
	      var left = this.context.muiTheme.isRtl ? 'right' : 'left';
	
	      if (step === 0) {
	        barElement.style[left] = stepValues[0][0] + '%';
	        barElement.style[right] = stepValues[0][1] + '%';
	      } else if (step === 1) {
	        barElement.style.transitionDuration = '840ms';
	      } else if (step === 2) {
	        barElement.style[left] = stepValues[1][0] + '%';
	        barElement.style[right] = stepValues[1][1] + '%';
	      } else if (step === 3) {
	        barElement.style.transitionDuration = '0ms';
	      }
	      this.timers[id] = setTimeout(function () {
	        return _this3.barUpdate(id, step + 1, barElement, stepValues);
	      }, timeToNextStep);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.bar) },
	          _react2.default.createElement('div', { ref: 'bar1', style: prepareStyles(styles.barFragment1) }),
	          _react2.default.createElement('div', { ref: 'bar2', style: prepareStyles(styles.barFragment2) })
	        )
	      );
	    }
	  }]);
	  return LinearProgress;
	}(_react.Component);
	
	LinearProgress.defaultProps = {
	  mode: 'indeterminate',
	  value: 0,
	  min: 0,
	  max: 100
	};
	LinearProgress.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? LinearProgress.propTypes = {
	  /**
	   * The color of the progress bar, defaults to
	   * primary color of theme.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * The max value of progress, only works in determinate mode.
	   */
	  max: _propTypes2.default.number,
	  /**
	   * The min value of progress, only works in determinate mode.
	   */
	  min: _propTypes2.default.number,
	  /**
	   * The mode of show your progress, indeterminate for when
	   * there is no value for progress.
	   */
	  mode: _propTypes2.default.oneOf(['determinate', 'indeterminate']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The value of progress, only works in determinate mode.
	   */
	  value: _propTypes2.default.number
	} : void 0;
	exports.default = LinearProgress;

/***/ },
/* 825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _LinearProgress = __webpack_require__(824);
	
	var _LinearProgress2 = _interopRequireDefault(_LinearProgress);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _LinearProgress2.default;

/***/ },
/* 826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _List = __webpack_require__(214);
	
	var _List2 = _interopRequireDefault(_List);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NestedList = function NestedList(props) {
	  var children = props.children,
	      open = props.open,
	      nestedLevel = props.nestedLevel,
	      style = props.style;
	
	
	  if (!open) {
	    return null;
	  }
	
	  return _react2.default.createElement(
	    _List2.default,
	    { style: style },
	    _react.Children.map(children, function (child) {
	      return (0, _react.isValidElement)(child) ? (0, _react.cloneElement)(child, {
	        nestedLevel: nestedLevel + 1
	      }) : child;
	    })
	  );
	};
	
	 false ? NestedList.propTypes = {
	  children: _propTypes2.default.node,
	  nestedLevel: _propTypes2.default.number.isRequired,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	
	exports.default = NestedList;

/***/ },
/* 827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.makeSelectable = exports.ListItem = exports.List = undefined;
	
	var _List2 = __webpack_require__(214);
	
	var _List3 = _interopRequireDefault(_List2);
	
	var _ListItem2 = __webpack_require__(215);
	
	var _ListItem3 = _interopRequireDefault(_ListItem2);
	
	var _makeSelectable2 = __webpack_require__(355);
	
	var _makeSelectable3 = _interopRequireDefault(_makeSelectable2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.List = _List3.default;
	exports.ListItem = _ListItem3.default;
	exports.makeSelectable = _makeSelectable3.default;
	exports.default = _List3.default;

/***/ },
/* 828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.HotKeyHolder = undefined;
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HotKeyHolder = exports.HotKeyHolder = function () {
	  function HotKeyHolder() {
	    var _this = this;
	
	    (0, _classCallCheck3.default)(this, HotKeyHolder);
	
	    this.clear = function () {
	      _this.timerId = null;
	      _this.lastKeys = null;
	    };
	  }
	
	  (0, _createClass3.default)(HotKeyHolder, [{
	    key: 'append',
	    value: function append(key) {
	      clearTimeout(this.timerId);
	      this.timerId = setTimeout(this.clear, 500);
	      return this.lastKeys = (this.lastKeys || '') + key;
	    }
	  }]);
	  return HotKeyHolder;
	}();

/***/ },
/* 829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var rounded = props.rounded,
	      circle = props.circle,
	      transitionEnabled = props.transitionEnabled,
	      zDepth = props.zDepth;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      paper = _context$muiTheme.paper,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  return {
	    root: {
	      color: paper.color,
	      backgroundColor: paper.backgroundColor,
	      transition: transitionEnabled && _transitions2.default.easeOut(),
	      boxSizing: 'border-box',
	      fontFamily: baseTheme.fontFamily,
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      boxShadow: paper.zDepthShadows[zDepth - 1], // No shadow for 0 depth papers
	      borderRadius: circle ? '50%' : rounded ? borderRadius : '0px'
	    }
	  };
	}
	
	var Paper = function (_Component) {
	  (0, _inherits3.default)(Paper, _Component);
	
	  function Paper() {
	    (0, _classCallCheck3.default)(this, Paper);
	    return (0, _possibleConstructorReturn3.default)(this, (Paper.__proto__ || (0, _getPrototypeOf2.default)(Paper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Paper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          circle = _props.circle,
	          rounded = _props.rounded,
	          style = _props.style,
	          transitionEnabled = _props.transitionEnabled,
	          zDepth = _props.zDepth,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'circle', 'rounded', 'style', 'transitionEnabled', 'zDepth']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Paper;
	}(_react.Component);
	
	Paper.defaultProps = {
	  circle: false,
	  rounded: true,
	  transitionEnabled: true,
	  zDepth: 1
	};
	Paper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Paper.propTypes = {
	  /**
	   * Children passed into the paper element.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Set to true to generate a circlular paper container.
	   */
	  circle: _propTypes2.default.bool,
	  /**
	   * By default, the paper container will have a border radius.
	   * Set this to false to generate a container with sharp corners.
	   */
	  rounded: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Set to false to disable CSS transitions for the paper element.
	   */
	  transitionEnabled: _propTypes2.default.bool,
	  /**
	   * This number represents the zDepth of the paper shadow.
	   */
	  zDepth: _propTypes4.default.zDepth
	} : void 0;
	exports.default = Paper;

/***/ },
/* 830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _propTypes3 = __webpack_require__(25);
	
	var _propTypes4 = _interopRequireDefault(_propTypes3);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var targetOrigin = props.targetOrigin;
	  var open = state.open;
	  var muiTheme = context.muiTheme;
	
	  var horizontal = targetOrigin.horizontal.replace('middle', 'vertical');
	
	  return {
	    root: {
	      position: 'fixed',
	      zIndex: muiTheme.zIndex.popover,
	      opacity: open ? 1 : 0,
	      transform: open ? 'scale(1, 1)' : 'scale(0, 0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity']),
	      maxHeight: '100%'
	    },
	    horizontal: {
	      maxHeight: '100%',
	      overflowY: 'auto',
	      transform: open ? 'scaleX(1)' : 'scaleX(0)',
	      opacity: open ? 1 : 0,
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('250ms', ['transform', 'opacity'])
	    },
	    vertical: {
	      opacity: open ? 1 : 0,
	      transform: open ? 'scaleY(1)' : 'scaleY(0)',
	      transformOrigin: horizontal + ' ' + targetOrigin.vertical,
	      transition: _transitions2.default.easeOut('500ms', ['transform', 'opacity'])
	    }
	  };
	}
	
	var PopoverAnimationDefault = function (_Component) {
	  (0, _inherits3.default)(PopoverAnimationDefault, _Component);
	
	  function PopoverAnimationDefault() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, PopoverAnimationDefault);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = PopoverAnimationDefault.__proto__ || (0, _getPrototypeOf2.default)(PopoverAnimationDefault)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(PopoverAnimationDefault, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.setState({ open: true }); // eslint-disable-line react/no-did-mount-set-state
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      this.setState({
	        open: nextProps.open
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          className = _props.className,
	          style = _props.style,
	          zDepth = _props.zDepth;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: zDepth,
	          className: className
	        },
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.horizontal) },
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.vertical) },
	            this.props.children
	          )
	        )
	      );
	    }
	  }]);
	  return PopoverAnimationDefault;
	}(_react.Component);
	
	PopoverAnimationDefault.defaultProps = {
	  style: {},
	  zDepth: 1
	};
	PopoverAnimationDefault.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? PopoverAnimationDefault.propTypes = {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  targetOrigin: _propTypes4.default.origin.isRequired,
	  zDepth: _propTypes4.default.zDepth
	} : void 0;
	exports.default = PopoverAnimationDefault;

/***/ },
/* 831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.PopoverAnimationVertical = exports.Popover = undefined;
	
	var _Popover2 = __webpack_require__(87);
	
	var _Popover3 = _interopRequireDefault(_Popover2);
	
	var _PopoverAnimationVertical2 = __webpack_require__(218);
	
	var _PopoverAnimationVertical3 = _interopRequireDefault(_PopoverAnimationVertical2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Popover = _Popover3.default;
	exports.PopoverAnimationVertical = _PopoverAnimationVertical3.default;
	exports.default = _Popover3.default;

/***/ },
/* 832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.RadioButtonGroup = exports.RadioButton = undefined;
	
	var _RadioButton2 = __webpack_require__(357);
	
	var _RadioButton3 = _interopRequireDefault(_RadioButton2);
	
	var _RadioButtonGroup2 = __webpack_require__(358);
	
	var _RadioButtonGroup3 = _interopRequireDefault(_RadioButtonGroup2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.RadioButton = _RadioButton3.default;
	exports.RadioButtonGroup = _RadioButtonGroup3.default;
	exports.default = _RadioButton3.default;

/***/ },
/* 833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _colorManipulator = __webpack_require__(53);
	
	var _childUtils = __webpack_require__(117);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function validateLabel(props, propName, componentName) {
	  if (false) {
	    if (!props.children && props.label !== 0 && !props.label && !props.icon) {
	      return new Error('Required prop label or children or icon was not specified in ' + componentName + '.');
	    }
	  }
	}
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      button = _context$muiTheme.button,
	      raisedButton = _context$muiTheme.raisedButton,
	      borderRadius = _context$muiTheme.borderRadius;
	  var disabled = props.disabled,
	      disabledBackgroundColor = props.disabledBackgroundColor,
	      disabledLabelColor = props.disabledLabelColor,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      label = props.label,
	      labelPosition = props.labelPosition,
	      primary = props.primary,
	      secondary = props.secondary,
	      style = props.style;
	
	
	  var amount = primary || secondary ? 0.4 : 0.08;
	
	  var backgroundColor = raisedButton.color;
	  var labelColor = raisedButton.textColor;
	
	  if (disabled) {
	    backgroundColor = disabledBackgroundColor || raisedButton.disabledColor;
	    labelColor = disabledLabelColor || raisedButton.disabledTextColor;
	  } else if (primary) {
	    backgroundColor = raisedButton.primaryColor;
	    labelColor = raisedButton.primaryTextColor;
	  } else if (secondary) {
	    backgroundColor = raisedButton.secondaryColor;
	    labelColor = raisedButton.secondaryTextColor;
	  } else {
	    if (props.backgroundColor) {
	      backgroundColor = props.backgroundColor;
	    }
	    if (props.labelColor) {
	      labelColor = props.labelColor;
	    }
	  }
	
	  var buttonHeight = style && style.height || button.height;
	
	  return {
	    root: {
	      display: 'inline-block',
	      transition: _transitions2.default.easeOut(),
	      minWidth: fullWidth ? '100%' : button.minWidth
	    },
	    button: {
	      height: buttonHeight,
	      lineHeight: buttonHeight + 'px',
	      width: '100%',
	      padding: 0,
	      borderRadius: borderRadius,
	      transition: _transitions2.default.easeOut(),
	      backgroundColor: backgroundColor,
	      // That's the default value for a button but not a link
	      textAlign: 'center'
	    },
	    label: {
	      position: 'relative',
	      opacity: 1,
	      fontSize: raisedButton.fontSize,
	      letterSpacing: 0,
	      textTransform: raisedButton.textTransform || button.textTransform || 'uppercase',
	      fontWeight: raisedButton.fontWeight,
	      margin: 0,
	      userSelect: 'none',
	      paddingLeft: icon && labelPosition !== 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      paddingRight: icon && labelPosition === 'before' ? 8 : baseTheme.spacing.desktopGutterLess,
	      color: labelColor
	    },
	    icon: {
	      verticalAlign: 'middle',
	      marginLeft: label && labelPosition !== 'before' ? 12 : 0,
	      marginRight: label && labelPosition === 'before' ? 12 : 0
	    },
	    overlay: {
	      height: buttonHeight,
	      borderRadius: borderRadius,
	      backgroundColor: (state.keyboardFocused || state.hovered) && !disabled && (0, _colorManipulator.fade)(labelColor, amount),
	      transition: _transitions2.default.easeOut(),
	      top: 0
	    },
	    ripple: {
	      color: labelColor,
	      opacity: !(primary || secondary) ? 0.1 : 0.16
	    }
	  };
	}
	
	var RaisedButton = function (_Component) {
	  (0, _inherits3.default)(RaisedButton, _Component);
	
	  function RaisedButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, RaisedButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = RaisedButton.__proto__ || (0, _getPrototypeOf2.default)(RaisedButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      keyboardFocused: false,
	      touched: false,
	      initialZDepth: 0,
	      zDepth: 0
	    }, _this.handleMouseDown = function (event) {
	      // only listen to left clicks
	      if (event.button === 0) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth + 1
	        });
	      }
	      if (_this.props.onMouseDown) {
	        _this.props.onMouseDown(event);
	      }
	    }, _this.handleMouseUp = function (event) {
	      _this.setState({
	        zDepth: _this.state.initialZDepth
	      });
	      if (_this.props.onMouseUp) {
	        _this.props.onMouseUp(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      if (!_this.state.keyboardFocused) {
	        _this.setState({
	          zDepth: _this.state.initialZDepth,
	          hovered: false
	        });
	      }
	      if (_this.props.onMouseLeave) {
	        _this.props.onMouseLeave(event);
	      }
	    }, _this.handleMouseEnter = function (event) {
	      if (!_this.state.keyboardFocused && !_this.state.touched) {
	        _this.setState({
	          hovered: true
	        });
	      }
	      if (_this.props.onMouseEnter) {
	        _this.props.onMouseEnter(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth + 1
	      });
	
	      if (_this.props.onTouchStart) {
	        _this.props.onTouchStart(event);
	      }
	    }, _this.handleTouchEnd = function (event) {
	      _this.setState({
	        touched: true,
	        zDepth: _this.state.initialZDepth
	      });
	
	      if (_this.props.onTouchEnd) {
	        _this.props.onTouchEnd(event);
	      }
	    }, _this.handleKeyboardFocus = function (event, keyboardFocused) {
	      var zDepth = keyboardFocused && !_this.props.disabled ? _this.state.initialZDepth + 1 : _this.state.initialZDepth;
	
	      _this.setState({
	        zDepth: zDepth,
	        keyboardFocused: keyboardFocused
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(RaisedButton, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var zDepth = this.props.disabled ? 0 : 1;
	      this.setState({
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var zDepth = nextProps.disabled ? 0 : 1;
	      var nextState = {
	        zDepth: zDepth,
	        initialZDepth: zDepth
	      };
	
	      if (nextProps.disabled) {
	        nextState.hovered = false;
	      }
	
	      this.setState(nextState);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          backgroundColor = _props.backgroundColor,
	          buttonStyle = _props.buttonStyle,
	          children = _props.children,
	          className = _props.className,
	          disabled = _props.disabled,
	          disabledBackgroundColor = _props.disabledBackgroundColor,
	          disabledLabelColor = _props.disabledLabelColor,
	          fullWidth = _props.fullWidth,
	          icon = _props.icon,
	          label = _props.label,
	          labelColor = _props.labelColor,
	          labelPosition = _props.labelPosition,
	          labelStyle = _props.labelStyle,
	          overlayStyle = _props.overlayStyle,
	          primary = _props.primary,
	          rippleStyle = _props.rippleStyle,
	          secondary = _props.secondary,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['backgroundColor', 'buttonStyle', 'children', 'className', 'disabled', 'disabledBackgroundColor', 'disabledLabelColor', 'fullWidth', 'icon', 'label', 'labelColor', 'labelPosition', 'labelStyle', 'overlayStyle', 'primary', 'rippleStyle', 'secondary', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var mergedRippleStyles = (0, _simpleAssign2.default)({}, styles.ripple, rippleStyle);
	
	      var buttonEventHandlers = disabled ? {} : {
	        onMouseDown: this.handleMouseDown,
	        onMouseUp: this.handleMouseUp,
	        onMouseLeave: this.handleMouseLeave,
	        onMouseEnter: this.handleMouseEnter,
	        onTouchStart: this.handleTouchStart,
	        onTouchEnd: this.handleTouchEnd,
	        onKeyboardFocus: this.handleKeyboardFocus
	      };
	
	      var labelElement = label && _react2.default.createElement(
	        'span',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.label, labelStyle)) },
	        label
	      );
	
	      var iconCloned = icon && (0, _react.cloneElement)(icon, {
	        color: icon.props.color || styles.label.color,
	        style: (0, _simpleAssign2.default)(styles.icon, icon.props.style)
	      });
	
	      // Place label before or after children.
	      var childrenFragment = labelPosition === 'before' ? {
	        labelElement: labelElement,
	        iconCloned: iconCloned,
	        children: children
	      } : {
	        children: children,
	        iconCloned: iconCloned,
	        labelElement: labelElement
	      };
	
	      var enhancedButtonChildren = (0, _childUtils.createChildFragment)(childrenFragment);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        {
	          className: className,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          zDepth: this.state.zDepth
	        },
	        _react2.default.createElement(
	          _EnhancedButton2.default,
	          (0, _extends3.default)({}, other, buttonEventHandlers, {
	            ref: 'container',
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.button, buttonStyle),
	            focusRippleColor: mergedRippleStyles.color,
	            touchRippleColor: mergedRippleStyles.color,
	            focusRippleOpacity: mergedRippleStyles.opacity,
	            touchRippleOpacity: mergedRippleStyles.opacity
	          }),
	          _react2.default.createElement(
	            'div',
	            {
	              ref: 'overlay',
	              style: prepareStyles((0, _simpleAssign2.default)(styles.overlay, overlayStyle))
	            },
	            enhancedButtonChildren
	          )
	        )
	      );
	    }
	  }]);
	  return RaisedButton;
	}(_react.Component);
	
	RaisedButton.muiName = 'RaisedButton';
	RaisedButton.defaultProps = {
	  disabled: false,
	  labelPosition: 'after',
	  fullWidth: false,
	  primary: false,
	  secondary: false
	};
	RaisedButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? RaisedButton.propTypes = {
	  /**
	   * Override the default background color for the button,
	   * but not the default disabled background color
	   * (use `disabledBackgroundColor` for this).
	   */
	  backgroundColor: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the button element.
	   */
	  buttonStyle: _propTypes2.default.object,
	  /**
	   * The content of the button.
	   * If a label is provided via the `label` prop, the text within the label
	   * will be displayed in addition to the content provided here.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The CSS class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	    * The element to use as the container for the RaisedButton. Either a string to
	    * use a DOM element or a ReactElement. This is useful for wrapping the
	    * RaisedButton in a custom Link component. If a ReactElement is given, ensure
	    * that it passes all of its given props through to the underlying DOM
	    * element and renders its children prop for proper integration.
	    */
	  containerElement: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.element]),
	  /**
	   * If true, the element's ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes2.default.bool,
	  /**
	   * If true, the button will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the default background color for the button
	   * when it is disabled.
	   */
	  disabledBackgroundColor: _propTypes2.default.string,
	  /**
	   * The color of the button's label when the button is disabled.
	   */
	  disabledLabelColor: _propTypes2.default.string,
	  /**
	   * If true, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * The URL to link to when the button is clicked.
	   */
	  href: _propTypes2.default.string,
	  /**
	   * An icon to be displayed within the button.
	   */
	  icon: _propTypes2.default.node,
	  /**
	   * The label to be displayed within the button.
	   * If content is provided via the `children` prop, that content will be
	   * displayed in addition to the label provided here.
	   */
	  label: validateLabel,
	  /**
	   * The color of the button's label.
	   */
	  labelColor: _propTypes2.default.string,
	  /**
	   * The position of the button's label relative to the button's `children`.
	   */
	  labelPosition: _propTypes2.default.oneOf(['before', 'after']),
	  /**
	   * Override the inline-styles of the button's label element.
	   */
	  labelStyle: _propTypes2.default.object,
	  /** @ignore */
	  onMouseDown: _propTypes2.default.func,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onMouseUp: _propTypes2.default.func,
	  /** @ignore */
	  onTouchEnd: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Callback function fired when the button is touch-tapped.
	   *
	   * @param {object} event TouchTap event targeting the button.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * Override the inline style of the button overlay.
	   */
	  overlayStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will use the theme's primary color.
	   */
	  primary: _propTypes2.default.bool,
	  /**
	   * Override the inline style of the ripple element.
	   */
	  rippleStyle: _propTypes2.default.object,
	  /**
	   * If true, the button will use the theme's secondary color.
	   * If both `secondary` and `primary` are true, the button will use
	   * the theme's primary color.
	   */
	  secondary: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = RaisedButton;

/***/ },
/* 834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RaisedButton = __webpack_require__(833);
	
	var _RaisedButton2 = _interopRequireDefault(_RaisedButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RaisedButton2.default;

/***/ },
/* 835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _slicedToArray2 = __webpack_require__(164);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _autoPrefix = __webpack_require__(64);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VIEWBOX_SIZE = 32;
	
	function getStyles(props) {
	  var padding = props.size * 0.1; // same implementation of `this.getPaddingSize()`
	  return {
	    root: {
	      position: 'absolute',
	      zIndex: 2,
	      width: props.size,
	      height: props.size,
	      padding: padding,
	      top: -10000,
	      left: -10000,
	      transform: 'translate(' + (10000 + props.left) + 'px, ' + (10000 + props.top) + 'px)',
	      opacity: props.status === 'hide' ? 0 : 1,
	      transition: props.status === 'hide' ? _transitions2.default.create('all', '.3s', 'ease-out') : 'none'
	    }
	  };
	}
	
	var RefreshIndicator = function (_Component) {
	  (0, _inherits3.default)(RefreshIndicator, _Component);
	
	  function RefreshIndicator() {
	    (0, _classCallCheck3.default)(this, RefreshIndicator);
	    return (0, _possibleConstructorReturn3.default)(this, (RefreshIndicator.__proto__ || (0, _getPrototypeOf2.default)(RefreshIndicator)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(RefreshIndicator, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	
	      this.scalePath(this.refs.path, 0);
	      this.rotateWrapper(this.refs.wrapper);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.scalePathTimer);
	      clearTimeout(this.rotateWrapperTimer);
	      clearTimeout(this.rotateWrapperSecondTimer);
	    }
	  }, {
	    key: 'renderChildren',
	    value: function renderChildren() {
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var paperSize = this.getPaperSize();
	
	      var childrenCmp = null;
	      if (this.props.status !== 'ready') {
	        var circleStyle = this.getCircleStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'div',
	          {
	            ref: 'wrapper',
	            style: prepareStyles({
	              transition: _transitions2.default.create('transform', '20s', null, 'linear'),
	              width: '100%',
	              height: '100%'
	            })
	          },
	          _react2.default.createElement(
	            'svg',
	            {
	              style: {
	                width: paperSize,
	                height: paperSize
	              },
	              viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	            },
	            _react2.default.createElement('circle', (0, _extends3.default)({
	              ref: 'path',
	              style: prepareStyles((0, _simpleAssign2.default)(circleStyle.style, {
	                transition: _transitions2.default.create('all', '1.5s', null, 'ease-in-out')
	              }))
	            }, circleStyle.attr))
	          )
	        );
	      } else {
	        var _circleStyle = this.getCircleStyle(paperSize);
	        var polygonStyle = this.getPolygonStyle(paperSize);
	        childrenCmp = _react2.default.createElement(
	          'svg',
	          {
	            style: {
	              width: paperSize,
	              height: paperSize
	            },
	            viewBox: '0 0 ' + VIEWBOX_SIZE + ' ' + VIEWBOX_SIZE
	          },
	          _react2.default.createElement('circle', (0, _extends3.default)({
	            style: prepareStyles(_circleStyle.style)
	          }, _circleStyle.attr)),
	          _react2.default.createElement('polygon', (0, _extends3.default)({
	            style: prepareStyles(polygonStyle.style)
	          }, polygonStyle.attr))
	        );
	      }
	
	      return childrenCmp;
	    }
	  }, {
	    key: 'getTheme',
	    value: function getTheme() {
	      return this.context.muiTheme.refreshIndicator;
	    }
	  }, {
	    key: 'getPaddingSize',
	    value: function getPaddingSize() {
	      var padding = this.props.size * 0.1;
	      return padding;
	    }
	  }, {
	    key: 'getPaperSize',
	    value: function getPaperSize() {
	      return this.props.size - this.getPaddingSize() * 2;
	    }
	  }, {
	    key: 'getCircleAttr',
	    value: function getCircleAttr() {
	      return {
	        radiu: VIEWBOX_SIZE / 2 - 5,
	        originX: VIEWBOX_SIZE / 2,
	        originY: VIEWBOX_SIZE / 2,
	        strokeWidth: 3
	      };
	    }
	  }, {
	    key: 'getArcDeg',
	    value: function getArcDeg() {
	      var p = this.props.percentage / 100;
	
	      var beginDeg = p * 120;
	      var endDeg = p * 410;
	      return [beginDeg, endDeg];
	    }
	  }, {
	    key: 'getFactor',
	    value: function getFactor() {
	      var p = this.props.percentage / 100;
	      var p1 = Math.min(1, p / 0.4);
	
	      return p1;
	    }
	  }, {
	    key: 'getCircleStyle',
	    value: function getCircleStyle() {
	      var isLoading = this.props.status === 'loading';
	      var p1 = isLoading ? 1 : this.getFactor();
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	
	      var _getArcDeg = this.getArcDeg(),
	          _getArcDeg2 = (0, _slicedToArray3.default)(_getArcDeg, 2),
	          beginDeg = _getArcDeg2[0],
	          endDeg = _getArcDeg2[1];
	
	      var arcLen = (endDeg - beginDeg) * perimeter / 360;
	      var dashOffset = -beginDeg * perimeter / 360;
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          strokeDasharray: arcLen + ', ' + (perimeter - arcLen),
	          strokeDashoffset: dashOffset,
	          stroke: isLoading || this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          strokeLinecap: 'round',
	          opacity: p1,
	          strokeWidth: circle.strokeWidth * p1,
	          fill: 'none'
	        },
	        attr: {
	          cx: circle.originX,
	          cy: circle.originY,
	          r: circle.radiu
	        }
	      };
	    }
	  }, {
	    key: 'getPolygonStyle',
	    value: function getPolygonStyle() {
	      var p1 = this.getFactor();
	      var circle = this.getCircleAttr();
	
	      var triangleCx = circle.originX + circle.radiu;
	      var triangleCy = circle.originY;
	      var dx = circle.strokeWidth * 7 / 4 * p1;
	      var trianglePath = triangleCx - dx + ',' + triangleCy + ' ' + (triangleCx + dx) + ',' + triangleCy + ' ' + triangleCx + ',' + (triangleCy + dx);
	
	      var _getArcDeg3 = this.getArcDeg(),
	          _getArcDeg4 = (0, _slicedToArray3.default)(_getArcDeg3, 2),
	          endDeg = _getArcDeg4[1];
	
	      var theme = this.getTheme();
	      return {
	        style: {
	          fill: this.props.percentage === 100 ? this.props.loadingColor || theme.loadingStrokeColor : this.props.color || theme.strokeColor,
	          transform: 'rotate(' + endDeg + 'deg)',
	          transformOrigin: circle.originX + 'px ' + circle.originY + 'px',
	          opacity: p1
	        },
	        attr: {
	          points: trianglePath
	        }
	      };
	    }
	  }, {
	    key: 'scalePath',
	    value: function scalePath(path, step) {
	      var _this2 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      var currStep = (step || 0) % 3;
	
	      var circle = this.getCircleAttr();
	      var perimeter = Math.PI * 2 * circle.radiu;
	      var arcLen = perimeter * 0.64;
	
	      var strokeDasharray = void 0;
	      var strokeDashoffset = void 0;
	      var transitionDuration = void 0;
	
	      if (currStep === 0) {
	        strokeDasharray = '1, 200';
	        strokeDashoffset = 0;
	        transitionDuration = '0ms';
	      } else if (currStep === 1) {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -15;
	        transitionDuration = '750ms';
	      } else {
	        strokeDasharray = arcLen + ', 200';
	        strokeDashoffset = -(perimeter - 1);
	        transitionDuration = '850ms';
	      }
	
	      _autoPrefix2.default.set(path.style, 'strokeDasharray', strokeDasharray);
	      _autoPrefix2.default.set(path.style, 'strokeDashoffset', strokeDashoffset);
	      _autoPrefix2.default.set(path.style, 'transitionDuration', transitionDuration);
	
	      this.scalePathTimer = setTimeout(function () {
	        return _this2.scalePath(path, currStep + 1);
	      }, currStep ? 750 : 250);
	    }
	  }, {
	    key: 'rotateWrapper',
	    value: function rotateWrapper(wrapper) {
	      var _this3 = this;
	
	      if (this.props.status !== 'loading') return;
	
	      _autoPrefix2.default.set(wrapper.style, 'transform', null);
	      _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(0deg)');
	      _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '0ms');
	
	      this.rotateWrapperSecondTimer = setTimeout(function () {
	        _autoPrefix2.default.set(wrapper.style, 'transform', 'rotate(1800deg)');
	        _autoPrefix2.default.set(wrapper.style, 'transitionDuration', '10s');
	        _autoPrefix2.default.set(wrapper.style, 'transitionTimingFunction', 'linear');
	      }, 50);
	
	      this.rotateWrapperTimer = setTimeout(function () {
	        return _this3.rotateWrapper(wrapper);
	      }, 10050);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          style = _props.style,
	          top = _props.top,
	          left = _props.left,
	          percentage = _props.percentage,
	          status = _props.status,
	          loadingColor = _props.loadingColor,
	          other = (0, _objectWithoutProperties3.default)(_props, ['style', 'top', 'left', 'percentage', 'status', 'loadingColor']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _Paper2.default,
	        (0, _extends3.default)({
	          circle: true,
	          style: (0, _simpleAssign2.default)(styles.root, style)
	        }, other),
	        this.renderChildren()
	      );
	    }
	  }]);
	  return RefreshIndicator;
	}(_react.Component);
	
	RefreshIndicator.defaultProps = {
	  percentage: 0,
	  size: 40,
	  status: 'hide'
	};
	RefreshIndicator.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? RefreshIndicator.propTypes = {
	  /**
	   * Override the theme's color of the indicator while it's status is
	   * "ready" and it's percentage is less than 100.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * The absolute left position of the indicator in pixels.
	   */
	  left: _propTypes2.default.number.isRequired,
	  /**
	   * Override the theme's color of the indicator while
	   * it's status is "loading" or when it's percentage is 100.
	   */
	  loadingColor: _propTypes2.default.string,
	  /**
	   * The confirmation progress to fetch data. Max value is 100.
	   */
	  percentage: _propTypes2.default.number,
	  /**
	   * Size in pixels.
	   */
	  size: _propTypes2.default.number,
	  /**
	   * The display status of the indicator. If the status is
	   * "ready", the indicator will display the ready state
	   * arrow. If the status is "loading", it will display
	   * the loading progress indicator. If the status is "hide",
	   * the indicator will be hidden.
	   */
	  status: _propTypes2.default.oneOf(['ready', 'loading', 'hide']),
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The absolute top position of the indicator in pixels.
	   */
	  top: _propTypes2.default.number.isRequired
	} : void 0;
	exports.default = RefreshIndicator;

/***/ },
/* 836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _RefreshIndicator = __webpack_require__(835);
	
	var _RefreshIndicator2 = _interopRequireDefault(_RefreshIndicator);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _RefreshIndicator2.default;

/***/ },
/* 837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TextField = __webpack_require__(115);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _DropDownMenu = __webpack_require__(353);
	
	var _DropDownMenu2 = _interopRequireDefault(_DropDownMenu);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  return {
	    label: {
	      paddingLeft: 0,
	      top: props.floatingLabelText ? 6 : -4
	    },
	    icon: {
	      right: 0,
	      top: props.floatingLabelText ? 8 : 0
	    },
	    hideDropDownUnderline: {
	      borderTop: 'none'
	    },
	    dropDownMenu: {
	      display: 'block'
	    }
	  };
	}
	
	var SelectField = function (_Component) {
	  (0, _inherits3.default)(SelectField, _Component);
	
	  function SelectField() {
	    (0, _classCallCheck3.default)(this, SelectField);
	    return (0, _possibleConstructorReturn3.default)(this, (SelectField.__proto__ || (0, _getPrototypeOf2.default)(SelectField)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SelectField, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoWidth = _props.autoWidth,
	          multiple = _props.multiple,
	          children = _props.children,
	          style = _props.style,
	          labelStyle = _props.labelStyle,
	          iconStyle = _props.iconStyle,
	          id = _props.id,
	          underlineDisabledStyle = _props.underlineDisabledStyle,
	          underlineFocusStyle = _props.underlineFocusStyle,
	          menuItemStyle = _props.menuItemStyle,
	          selectedMenuItemStyle = _props.selectedMenuItemStyle,
	          underlineStyle = _props.underlineStyle,
	          dropDownMenuProps = _props.dropDownMenuProps,
	          errorStyle = _props.errorStyle,
	          disabled = _props.disabled,
	          floatingLabelFixed = _props.floatingLabelFixed,
	          floatingLabelText = _props.floatingLabelText,
	          floatingLabelStyle = _props.floatingLabelStyle,
	          hintStyle = _props.hintStyle,
	          hintText = _props.hintText,
	          fullWidth = _props.fullWidth,
	          errorText = _props.errorText,
	          listStyle = _props.listStyle,
	          maxHeight = _props.maxHeight,
	          menuStyle = _props.menuStyle,
	          onFocus = _props.onFocus,
	          onBlur = _props.onBlur,
	          onChange = _props.onChange,
	          selectionRenderer = _props.selectionRenderer,
	          value = _props.value,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoWidth', 'multiple', 'children', 'style', 'labelStyle', 'iconStyle', 'id', 'underlineDisabledStyle', 'underlineFocusStyle', 'menuItemStyle', 'selectedMenuItemStyle', 'underlineStyle', 'dropDownMenuProps', 'errorStyle', 'disabled', 'floatingLabelFixed', 'floatingLabelText', 'floatingLabelStyle', 'hintStyle', 'hintText', 'fullWidth', 'errorText', 'listStyle', 'maxHeight', 'menuStyle', 'onFocus', 'onBlur', 'onChange', 'selectionRenderer', 'value']);
	
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        _TextField2.default,
	        (0, _extends3.default)({}, other, {
	          style: style,
	          disabled: disabled,
	          floatingLabelFixed: floatingLabelFixed,
	          floatingLabelText: floatingLabelText,
	          floatingLabelStyle: floatingLabelStyle,
	          hintStyle: hintStyle,
	          hintText: !hintText && !floatingLabelText ? ' ' : hintText,
	          fullWidth: fullWidth,
	          errorText: errorText,
	          underlineStyle: underlineStyle,
	          errorStyle: errorStyle,
	          onFocus: onFocus,
	          onBlur: onBlur,
	          id: id,
	          underlineDisabledStyle: underlineDisabledStyle,
	          underlineFocusStyle: underlineFocusStyle
	        }),
	        _react2.default.createElement(
	          _DropDownMenu2.default,
	          (0, _extends3.default)({
	            disabled: disabled,
	            style: (0, _simpleAssign2.default)(styles.dropDownMenu, menuStyle),
	            labelStyle: (0, _simpleAssign2.default)(styles.label, labelStyle),
	            iconStyle: (0, _simpleAssign2.default)(styles.icon, iconStyle),
	            menuItemStyle: menuItemStyle,
	            selectedMenuItemStyle: selectedMenuItemStyle,
	            underlineStyle: styles.hideDropDownUnderline,
	            listStyle: listStyle,
	            autoWidth: autoWidth,
	            value: value,
	            onChange: onChange,
	            maxHeight: maxHeight,
	            multiple: multiple,
	            selectionRenderer: selectionRenderer
	          }, dropDownMenuProps),
	          children
	        )
	      );
	    }
	  }]);
	  return SelectField;
	}(_react.Component);
	
	SelectField.defaultProps = {
	  autoWidth: false,
	  disabled: false,
	  fullWidth: false,
	  multiple: false
	};
	SelectField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? SelectField.propTypes = {
	  /**
	   * If true, the width will automatically be set according to the
	   * items inside the menu.
	   * To control the width in CSS instead, leave this prop set to `false`.
	   */
	  autoWidth: _propTypes2.default.bool,
	  /**
	   * The `MenuItem` elements to populate the select field with.
	   * If the menu items have a `label` prop, that value will
	   * represent the selected menu item in the rendered select field.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the select field will be disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Object that can handle and override any property of component DropDownMenu.
	   */
	  dropDownMenuProps: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the error element.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when no value is selected.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the floating label.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content of the floating label.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the select field will take up the full width of its container.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the hint element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the label style when the select field is inactive.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `List` element.
	   */
	  listStyle: _propTypes2.default.object,
	  /**
	   * Override the default max-height of the underlying `DropDownMenu` element.
	   */
	  maxHeight: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of menu items.
	   */
	  menuItemStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underlying `DropDownMenu` element.
	   */
	  menuStyle: _propTypes2.default.object,
	  /**
	   * If true, `value` must be an array and the menu will support
	   * multiple selections.
	   */
	  multiple: _propTypes2.default.bool,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event TouchTap event targeting the menu item
	   * that was selected.
	   * @param {number} key The index of the selected menu item, or undefined
	   * if `multiple` is true.
	   * @param {any} payload If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of selected menu items.
	   */
	  selectedMenuItemStyle: _propTypes2.default.object,
	  /**
	   * Customize the rendering of the selected item.
	   *
	   * @param {any} value If `multiple` is true, the menu's `value`
	   * array with either the menu item's `value` added (if
	   * it wasn't already selected) or omitted (if it was already selected).
	   * Otherwise, the `value` of the menu item.
	   */
	  selectionRenderer: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element when the select
	   * field is disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element when the select field
	   * is focused.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * If `multiple` is true, an array of the `value`s of the selected
	   * menu items. Otherwise, the `value` of the selected menu item.
	   * If provided, the menu will be a controlled component.
	   */
	  value: _propTypes2.default.any
	} : void 0;
	exports.default = SelectField;

/***/ },
/* 838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _SelectField = __webpack_require__(837);
	
	var _SelectField2 = _interopRequireDefault(_SelectField);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _SelectField2.default;

/***/ },
/* 839 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _defineProperty2 = __webpack_require__(254);
	
	var _defineProperty3 = _interopRequireDefault(_defineProperty2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _FocusRipple = __webpack_require__(222);
	
	var _FocusRipple2 = _interopRequireDefault(_FocusRipple);
	
	var _deprecatedPropType = __webpack_require__(1838);
	
	var _deprecatedPropType2 = _interopRequireDefault(_deprecatedPropType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Verifies min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if min >= max otherwise null.
	 */
	var minMaxPropType = function minMaxPropType(props, propName, componentName) {
	  for (var _len = arguments.length, rest = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	    rest[_key - 3] = arguments[_key];
	  }
	
	  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  if (props.min >= props.max) {
	    var errorMsg = propName === 'min' ? 'min should be less than max' : 'max should be greater than min';
	    return new Error(errorMsg);
	  }
	};
	
	/**
	 * Verifies value is within the min/max range.
	 * @param   {Object} props         Properties of the React component.
	 * @param   {String} propName      Name of the property to validate.
	 * @param   {String} componentName Name of the component whose property is being validated.
	 * @returns {Object} Returns an Error if the value is not within the range otherwise null.
	 */
	var valueInRangePropType = function valueInRangePropType(props, propName, componentName) {
	  for (var _len2 = arguments.length, rest = Array(_len2 > 3 ? _len2 - 3 : 0), _key2 = 3; _key2 < _len2; _key2++) {
	    rest[_key2 - 3] = arguments[_key2];
	  }
	
	  var error = _propTypes2.default.number.apply(_propTypes2.default, [props, propName, componentName].concat(rest));
	  if (error !== null) {
	    return error;
	  }
	
	  var value = props[propName];
	  if (value < props.min || props.max < value) {
	    return new Error(propName + ' should be within the range specified by min and max');
	  }
	};
	
	var crossAxisProperty = {
	  x: 'height',
	  'x-reverse': 'height',
	  y: 'width',
	  'y-reverse': 'width'
	};
	
	var crossAxisOffsetProperty = {
	  x: 'top',
	  'x-reverse': 'top',
	  y: 'left',
	  'y-reverse': 'left'
	};
	
	var mainAxisProperty = {
	  x: 'width',
	  'x-reverse': 'width',
	  y: 'height',
	  'y-reverse': 'height'
	};
	
	var mainAxisMarginFromEnd = {
	  x: 'marginRight',
	  'x-reverse': 'marginLeft',
	  y: 'marginTop',
	  'y-reverse': 'marginBottom'
	};
	
	var mainAxisMarginFromStart = {
	  x: 'marginLeft',
	  'x-reverse': 'marginRight',
	  y: 'marginBottom',
	  'y-reverse': 'marginTop'
	};
	
	var mainAxisOffsetProperty = {
	  x: 'left',
	  'x-reverse': 'right',
	  y: 'bottom',
	  'y-reverse': 'top'
	};
	
	var mainAxisClientProperty = {
	  x: 'clientWidth',
	  'x-reverse': 'clientWidth',
	  y: 'clientHeight',
	  'y-reverse': 'clientHeight'
	};
	
	var mainAxisClientOffsetProperty = {
	  x: 'clientX',
	  'x-reverse': 'clientX',
	  y: 'clientY',
	  'y-reverse': 'clientY'
	};
	
	var reverseMainAxisOffsetProperty = {
	  x: 'right',
	  'x-reverse': 'left',
	  y: 'top',
	  'y-reverse': 'bottom'
	};
	
	var isMouseControlInverted = function isMouseControlInverted(axis) {
	  return axis === 'x-reverse' || axis === 'y';
	};
	
	function getPercent(value, min, max) {
	  var percent = (value - min) / (max - min);
	  if (isNaN(percent)) {
	    percent = 0;
	  }
	
	  return percent;
	}
	
	var getStyles = function getStyles(props, context, state) {
	  var _slider, _track, _filledAndRemaining, _handle, _objectAssign2, _objectAssign3;
	
	  var axis = props.axis,
	      disabled = props.disabled,
	      max = props.max,
	      min = props.min;
	  var _context$muiTheme$sli = context.muiTheme.slider,
	      handleColorZero = _context$muiTheme$sli.handleColorZero,
	      handleFillColor = _context$muiTheme$sli.handleFillColor,
	      handleSize = _context$muiTheme$sli.handleSize,
	      handleSizeDisabled = _context$muiTheme$sli.handleSizeDisabled,
	      handleSizeActive = _context$muiTheme$sli.handleSizeActive,
	      trackSize = _context$muiTheme$sli.trackSize,
	      trackColor = _context$muiTheme$sli.trackColor,
	      trackColorSelected = _context$muiTheme$sli.trackColorSelected,
	      rippleColor = _context$muiTheme$sli.rippleColor,
	      selectionColor = _context$muiTheme$sli.selectionColor;
	
	
	  var fillGutter = handleSize / 2;
	  var disabledGutter = trackSize + handleSizeDisabled / 2;
	  var calcDisabledSpacing = disabled ? ' - ' + disabledGutter + 'px' : '';
	  var percent = getPercent(state.value, min, max);
	
	  var styles = {
	    slider: (_slider = {
	      touchCallout: 'none',
	      userSelect: 'none',
	      cursor: 'default'
	    }, (0, _defineProperty3.default)(_slider, crossAxisProperty[axis], handleSizeActive), (0, _defineProperty3.default)(_slider, mainAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_slider, 'position', 'relative'), (0, _defineProperty3.default)(_slider, 'marginTop', 24), (0, _defineProperty3.default)(_slider, 'marginBottom', 48), _slider),
	    track: (_track = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_track, crossAxisOffsetProperty[axis], (handleSizeActive - trackSize) / 2), (0, _defineProperty3.default)(_track, mainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_track, mainAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_track, crossAxisProperty[axis], trackSize), _track),
	    filledAndRemaining: (_filledAndRemaining = {
	      position: 'absolute'
	    }, (0, _defineProperty3.default)(_filledAndRemaining, crossAxisOffsetProperty, 0), (0, _defineProperty3.default)(_filledAndRemaining, crossAxisProperty[axis], '100%'), (0, _defineProperty3.default)(_filledAndRemaining, 'transition', _transitions2.default.easeOut(null, 'margin')), _filledAndRemaining),
	    handle: (_handle = {
	      boxSizing: 'border-box',
	      position: 'absolute',
	      cursor: 'pointer',
	      pointerEvents: 'inherit'
	    }, (0, _defineProperty3.default)(_handle, crossAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_handle, mainAxisOffsetProperty[axis], percent === 0 ? '0%' : percent * 100 + '%'), (0, _defineProperty3.default)(_handle, 'zIndex', 1), (0, _defineProperty3.default)(_handle, 'margin', {
	      x: trackSize / 2 + 'px 0 0 0',
	      'x-reverse': trackSize / 2 + 'px 0 0 0',
	      y: '0 0 0 ' + trackSize / 2 + 'px',
	      'y-reverse': '0 0 0 ' + trackSize / 2 + 'px'
	    }[axis]), (0, _defineProperty3.default)(_handle, 'width', handleSize), (0, _defineProperty3.default)(_handle, 'height', handleSize), (0, _defineProperty3.default)(_handle, 'backgroundColor', selectionColor), (0, _defineProperty3.default)(_handle, 'backgroundClip', 'padding-box'), (0, _defineProperty3.default)(_handle, 'border', '0px solid transparent'), (0, _defineProperty3.default)(_handle, 'borderRadius', '50%'), (0, _defineProperty3.default)(_handle, 'transform', {
	      x: 'translate(-50%, -50%)',
	      'x-reverse': 'translate(50%, -50%)',
	      y: 'translate(-50%, 50%)',
	      'y-reverse': 'translate(-50%, -50%)'
	    }[axis]), (0, _defineProperty3.default)(_handle, 'transition', _transitions2.default.easeOut('450ms', 'background') + ', ' + _transitions2.default.easeOut('450ms', 'border-color') + ', ' + _transitions2.default.easeOut('450ms', 'width') + ', ' + _transitions2.default.easeOut('450ms', 'height')), (0, _defineProperty3.default)(_handle, 'overflow', 'visible'), (0, _defineProperty3.default)(_handle, 'outline', 'none'), _handle),
	    handleWhenDisabled: {
	      boxSizing: 'content-box',
	      cursor: 'not-allowed',
	      backgroundColor: trackColor,
	      width: handleSizeDisabled,
	      height: handleSizeDisabled,
	      border: 'none'
	    },
	    handleWhenPercentZero: {
	      border: trackSize + 'px solid ' + handleColorZero,
	      backgroundColor: handleFillColor,
	      boxShadow: 'none'
	    },
	    handleWhenPercentZeroAndDisabled: {
	      cursor: 'not-allowed',
	      width: handleSizeDisabled,
	      height: handleSizeDisabled
	    },
	    handleWhenPercentZeroAndFocused: {
	      border: trackSize + 'px solid ' + trackColorSelected
	    },
	    handleWhenActive: {
	      width: handleSizeActive,
	      height: handleSizeActive
	    },
	    ripple: {
	      height: handleSize,
	      width: handleSize,
	      overflow: 'visible'
	    },
	    rippleWhenPercentZero: {
	      top: -trackSize,
	      left: -trackSize
	    },
	    rippleInner: {
	      height: '300%',
	      width: '300%',
	      top: -handleSize,
	      left: -handleSize
	    },
	    rippleColor: {
	      fill: percent === 0 ? handleColorZero : rippleColor
	    }
	  };
	  styles.filled = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign2 = {}, (0, _defineProperty3.default)(_objectAssign2, mainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_objectAssign2, 'backgroundColor', disabled ? trackColor : selectionColor), (0, _defineProperty3.default)(_objectAssign2, mainAxisMarginFromEnd[axis], fillGutter), (0, _defineProperty3.default)(_objectAssign2, mainAxisProperty[axis], 'calc(' + percent * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign2));
	  styles.remaining = (0, _simpleAssign2.default)({}, styles.filledAndRemaining, (_objectAssign3 = {}, (0, _defineProperty3.default)(_objectAssign3, reverseMainAxisOffsetProperty[axis], 0), (0, _defineProperty3.default)(_objectAssign3, 'backgroundColor', (state.hovered || state.focused) && !disabled ? trackColorSelected : trackColor), (0, _defineProperty3.default)(_objectAssign3, mainAxisMarginFromStart[axis], fillGutter), (0, _defineProperty3.default)(_objectAssign3, mainAxisProperty[axis], 'calc(' + (1 - percent) * 100 + '%' + calcDisabledSpacing + ')'), _objectAssign3));
	
	  return styles;
	};
	
	var Slider = function (_Component) {
	  (0, _inherits3.default)(Slider, _Component);
	
	  function Slider() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Slider);
	
	    for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	      args[_key3] = arguments[_key3];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Slider.__proto__ || (0, _getPrototypeOf2.default)(Slider)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      active: false,
	      dragging: false,
	      focused: false,
	      hovered: false,
	      value: 0
	    }, _this.track = null, _this.handle = null, _this.handleKeyDown = function (event) {
	      var _this$props = _this.props,
	          axis = _this$props.axis,
	          min = _this$props.min,
	          max = _this$props.max,
	          step = _this$props.step;
	
	
	      var action = void 0;
	
	      switch ((0, _keycode2.default)(event)) {
	        case 'page down':
	        case 'down':
	          if (axis === 'y-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'left':
	          if (axis === 'x-reverse') {
	            action = 'increase';
	          } else {
	            action = 'decrease';
	          }
	          break;
	        case 'page up':
	        case 'up':
	          if (axis === 'y-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'right':
	          if (axis === 'x-reverse') {
	            action = 'decrease';
	          } else {
	            action = 'increase';
	          }
	          break;
	        case 'home':
	          action = 'min';
	          break;
	        case 'end':
	          action = 'max';
	          break;
	      }
	
	      if (action) {
	        var newValue = void 0;
	
	        // Cancel scroll
	        event.preventDefault();
	
	        switch (action) {
	          case 'decrease':
	            newValue = _this.state.value - step;
	            break;
	          case 'increase':
	            newValue = _this.state.value + step;
	            break;
	          case 'min':
	            newValue = min;
	            break;
	          case 'max':
	            newValue = max;
	            break;
	        }
	
	        // We need to use toFixed() because of float point errors.
	        // For example, 0.01 + 0.06 = 0.06999999999999999
	        newValue = parseFloat(newValue.toFixed(5));
	
	        if (newValue > max) {
	          newValue = max;
	        } else if (newValue < min) {
	          newValue = min;
	        }
	
	        if (_this.state.value !== newValue) {
	          _this.setState({
	            value: newValue
	          });
	
	          if (_this.props.onChange) {
	            _this.props.onChange(event, newValue);
	          }
	        }
	      }
	    }, _this.handleDragMouseMove = function (event) {
	      _this.onDragUpdate(event, 'mouse');
	    }, _this.handleTouchMove = function (event) {
	      _this.onDragUpdate(event, 'touch');
	    }, _this.handleMouseEnd = function (event) {
	      document.removeEventListener('mousemove', _this.handleDragMouseMove);
	      document.removeEventListener('mouseup', _this.handleMouseEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchEnd = function (event) {
	      document.removeEventListener('touchmove', _this.handleTouchMove);
	      document.removeEventListener('touchup', _this.handleTouchEnd);
	      document.removeEventListener('touchend', _this.handleTouchEnd);
	      document.removeEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStop(event);
	    }, _this.handleTouchStart = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      var position = void 0;
	      if (isMouseControlInverted(_this.props.axis)) {
	        position = _this.getTrackOffset() - event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]];
	      } else {
	        position = event.touches[0][mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('touchmove', _this.handleTouchMove);
	      document.addEventListener('touchup', _this.handleTouchEnd);
	      document.addEventListener('touchend', _this.handleTouchEnd);
	      document.addEventListener('touchcancel', _this.handleTouchEnd);
	
	      _this.onDragStart(event);
	
	      // Cancel scroll and context menu
	      event.preventDefault();
	    }, _this.handleFocus = function (event) {
	      _this.setState({
	        focused: true
	      });
	
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleBlur = function (event) {
	      _this.setState({
	        focused: false,
	        active: false
	      });
	
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleMouseDown = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	
	      var position = void 0;
	      if (isMouseControlInverted(_this.props.axis)) {
	        position = _this.getTrackOffset() - event[mainAxisClientOffsetProperty[_this.props.axis]];
	      } else {
	        position = event[mainAxisClientOffsetProperty[_this.props.axis]] - _this.getTrackOffset();
	      }
	      _this.setValueFromPosition(event, position);
	
	      document.addEventListener('mousemove', _this.handleDragMouseMove);
	      document.addEventListener('mouseup', _this.handleMouseEnd);
	
	      // Cancel text selection
	      event.preventDefault();
	
	      // Set focus manually since we called preventDefault()
	      _this.handle.focus();
	
	      _this.onDragStart(event);
	    }, _this.handleMouseUp = function () {
	      if (!_this.props.disabled) {
	        _this.setState({
	          active: false
	        });
	      }
	    }, _this.handleMouseEnter = function () {
	      _this.setState({
	        hovered: true
	      });
	    }, _this.handleMouseLeave = function () {
	      _this.setState({
	        hovered: false
	      });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Slider, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          valueProp = _props.value,
	          defaultValue = _props.defaultValue,
	          min = _props.min,
	          max = _props.max;
	
	
	      var value = valueProp;
	      if (value === undefined) {
	        value = defaultValue !== undefined ? defaultValue : min;
	      }
	
	      if (value > max) {
	        value = max;
	      } else if (value < min) {
	        value = min;
	      }
	
	      this.setState({
	        value: value
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== undefined && !this.state.dragging) {
	        this.setState({
	          value: nextProps.value
	        });
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: getValue() method is deprecated.\n      Use the onChange callbacks instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      return this.state.value;
	    }
	  }, {
	    key: 'clearValue',
	    value: function clearValue() {
	       false ? (0, _warning2.default)(false, 'Material-UI Slider: clearValue() method is deprecated.\n      Use the value property to control the component instead.\n      It will be removed with v0.17.0.') : void 0;
	
	      this.setState({
	        value: this.props.min
	      });
	    }
	  }, {
	    key: 'getTrackOffset',
	    value: function getTrackOffset() {
	      return this.track.getBoundingClientRect()[mainAxisOffsetProperty[this.props.axis]];
	    }
	  }, {
	    key: 'onDragStart',
	    value: function onDragStart(event) {
	      this.setState({
	        dragging: true,
	        active: true
	      });
	
	      if (this.props.onDragStart) {
	        this.props.onDragStart(event);
	      }
	    }
	  }, {
	    key: 'onDragUpdate',
	    value: function onDragUpdate(event, type) {
	      var _this2 = this;
	
	      if (this.dragRunning) {
	        return;
	      }
	      this.dragRunning = true;
	
	      requestAnimationFrame(function () {
	        _this2.dragRunning = false;
	
	        var source = type === 'touch' ? event.touches[0] : event;
	
	        var position = void 0;
	        if (isMouseControlInverted(_this2.props.axis)) {
	          position = _this2.getTrackOffset() - source[mainAxisClientOffsetProperty[_this2.props.axis]];
	        } else {
	          position = source[mainAxisClientOffsetProperty[_this2.props.axis]] - _this2.getTrackOffset();
	        }
	
	        if (!_this2.props.disabled) {
	          _this2.setValueFromPosition(event, position);
	        }
	      });
	    }
	  }, {
	    key: 'onDragStop',
	    value: function onDragStop(event) {
	      this.setState({
	        dragging: false,
	        active: false
	      });
	
	      if (this.props.onDragStop) {
	        this.props.onDragStop(event);
	      }
	    }
	  }, {
	    key: 'setValueFromPosition',
	    value: function setValueFromPosition(event, position) {
	      var positionMax = this.track[mainAxisClientProperty[this.props.axis]];
	      if (position < 0) {
	        position = 0;
	      } else if (position > positionMax) {
	        position = positionMax;
	      }
	
	      var _props2 = this.props,
	          step = _props2.step,
	          min = _props2.min,
	          max = _props2.max;
	
	
	      var value = void 0;
	      value = position / positionMax * (max - min);
	      value = Math.round(value / step) * step + min;
	      value = parseFloat(value.toFixed(5));
	
	      if (value > max) {
	        value = max;
	      } else if (value < min) {
	        value = min;
	      }
	
	      if (this.state.value !== value) {
	        this.setState({
	          value: value
	        });
	
	        if (this.props.onChange) {
	          this.props.onChange(event, value);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      var _props3 = this.props,
	          axis = _props3.axis,
	          description = _props3.description,
	          disabled = _props3.disabled,
	          disableFocusRipple = _props3.disableFocusRipple,
	          error = _props3.error,
	          max = _props3.max,
	          min = _props3.min,
	          name = _props3.name,
	          onBlur = _props3.onBlur,
	          onChange = _props3.onChange,
	          onDragStart = _props3.onDragStart,
	          onDragStop = _props3.onDragStop,
	          onFocus = _props3.onFocus,
	          required = _props3.required,
	          sliderStyle = _props3.sliderStyle,
	          step = _props3.step,
	          style = _props3.style,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['axis', 'description', 'disabled', 'disableFocusRipple', 'error', 'max', 'min', 'name', 'onBlur', 'onChange', 'onDragStart', 'onDragStop', 'onFocus', 'required', 'sliderStyle', 'step', 'style']);
	      var _state = this.state,
	          active = _state.active,
	          focused = _state.focused,
	          hovered = _state.hovered,
	          value = _state.value;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var percent = getPercent(value, min, max);
	
	      var handleStyles = {};
	      if (percent === 0) {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, styles.handleWhenPercentZero, active && styles.handleWhenActive, (hovered || focused) && !disabled && styles.handleWhenPercentZeroAndFocused, disabled && styles.handleWhenPercentZeroAndDisabled);
	      } else {
	        handleStyles = (0, _simpleAssign2.default)({}, styles.handle, active && styles.handleWhenActive, disabled && styles.handleWhenDisabled);
	      }
	
	      var rippleStyle = (0, _simpleAssign2.default)({}, styles.ripple, percent === 0 && styles.rippleWhenPercentZero);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)({}, style)) }),
	        _react2.default.createElement(
	          'span',
	          null,
	          description
	        ),
	        _react2.default.createElement(
	          'span',
	          null,
	          error
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.slider, sliderStyle)),
	            onFocus: this.handleFocus,
	            onBlur: this.handleBlur,
	            onMouseDown: this.handleMouseDown,
	            onMouseEnter: this.handleMouseEnter,
	            onMouseLeave: this.handleMouseLeave,
	            onMouseUp: this.handleMouseUp,
	            onTouchStart: this.handleTouchStart,
	            onKeyDown: !disabled && this.handleKeyDown
	          },
	          _react2.default.createElement(
	            'div',
	            { ref: function ref(node) {
	                return _this3.track = node;
	              }, style: prepareStyles(styles.track) },
	            _react2.default.createElement('div', { style: prepareStyles(styles.filled) }),
	            _react2.default.createElement('div', { style: prepareStyles(styles.remaining) }),
	            _react2.default.createElement(
	              'div',
	              {
	                ref: function ref(node) {
	                  return _this3.handle = node;
	                },
	                style: prepareStyles(handleStyles),
	                tabIndex: 0
	              },
	              !disabled && !disableFocusRipple && _react2.default.createElement(_FocusRipple2.default, {
	                style: rippleStyle,
	                innerStyle: styles.rippleInner,
	                show: (hovered || focused) && !active,
	                color: styles.rippleColor.fill
	              })
	            )
	          )
	        ),
	        _react2.default.createElement('input', {
	          type: 'hidden',
	          name: name,
	          value: value,
	          required: required,
	          min: min,
	          max: max,
	          step: step
	        })
	      );
	    }
	  }]);
	  return Slider;
	}(_react.Component);
	
	Slider.defaultProps = {
	  axis: 'x',
	  disabled: false,
	  disableFocusRipple: false,
	  max: 1,
	  min: 0,
	  required: true,
	  step: 0.01,
	  style: {}
	};
	Slider.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Slider.propTypes = {
	  /**
	   * The axis on which the slider will slide.
	   */
	  axis: _propTypes2.default.oneOf(['x', 'x-reverse', 'y', 'y-reverse']),
	  /**
	   * The default value of the slider.
	   */
	  defaultValue: valueInRangePropType,
	  /**
	   * Describe the slider.
	   */
	  description: (0, _deprecatedPropType2.default)(_propTypes2.default.node, 'Use a sibling node element instead. It will be removed with v0.17.0.'),
	  /**
	   * Disables focus ripple if set to true.
	   */
	  disableFocusRipple: _propTypes2.default.bool,
	  /**
	   * If true, the slider will not be interactable.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * An error message for the slider.
	   */
	  error: (0, _deprecatedPropType2.default)(_propTypes2.default.node, 'Use a sibling node element instead. It will be removed with v0.17.0.'),
	  /**
	   * The maximum value the slider can slide to on
	   * a scale from 0 to 1 inclusive. Cannot be equal to min.
	   */
	  max: minMaxPropType,
	  /**
	   * The minimum value the slider can slide to on a scale
	   * from 0 to 1 inclusive. Cannot be equal to max.
	   */
	  min: minMaxPropType,
	  /**
	   * The name of the slider. Behaves like the name attribute
	   * of an input element.
	   */
	  name: _propTypes2.default.string,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event KeyDown event targeting the slider.
	   * @param {number} newValue The new value of the slider.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slider has begun to move.
	   *
	   * @param {object} event MouseDown or TouchStart event targeting the slider.
	   */
	  onDragStart: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the slide has stopped moving.
	   *
	   * @param {object} event MouseEnd or TouchEnd event targeting the slider.
	   */
	  onDragStop: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Whether or not the slider is required in a form.
	   */
	  required: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the inner slider element.
	   */
	  sliderStyle: _propTypes2.default.object,
	  /**
	   * The granularity the slider can step through values.
	   */
	  step: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The value of the slider.
	   */
	  value: valueInRangePropType
	} : void 0;
	exports.default = Slider;

/***/ },
/* 840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Slider = __webpack_require__(839);
	
	var _Slider2 = _interopRequireDefault(_Slider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Slider2.default;

/***/ },
/* 841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _ClickAwayListener = __webpack_require__(220);
	
	var _ClickAwayListener2 = _interopRequireDefault(_ClickAwayListener);
	
	var _SnackbarBody = __webpack_require__(842);
	
	var _SnackbarBody2 = _interopRequireDefault(_SnackbarBody);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      desktopSubheaderHeight = _context$muiTheme.baseTheme.spacing.desktopSubheaderHeight,
	      zIndex = _context$muiTheme.zIndex;
	  var open = state.open;
	
	
	  var styles = {
	    root: {
	      position: 'fixed',
	      left: '50%',
	      display: 'flex',
	      bottom: 0,
	      zIndex: zIndex.snackbar,
	      visibility: open ? 'visible' : 'hidden',
	      transform: open ? 'translate(-50%, 0)' : 'translate(-50%, ' + desktopSubheaderHeight + 'px)',
	      transition: _transitions2.default.easeOut('400ms', 'transform') + ', ' + _transitions2.default.easeOut('400ms', 'visibility')
	    }
	  };
	
	  return styles;
	}
	
	var Snackbar = function (_Component) {
	  (0, _inherits3.default)(Snackbar, _Component);
	
	  function Snackbar() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Snackbar);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Snackbar.__proto__ || (0, _getPrototypeOf2.default)(Snackbar)).call.apply(_ref, [this].concat(args))), _this), _this.componentClickAway = function () {
	      if (_this.timerTransitionId) {
	        // If transitioning, don't close the snackbar.
	        return;
	      }
	
	      if (_this.props.open !== null && _this.props.onRequestClose) {
	        _this.props.onRequestClose('clickaway');
	      } else {
	        _this.setState({ open: false });
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Snackbar, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        open: this.props.open,
	        message: this.props.message,
	        action: this.props.action
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.state.open) {
	        this.setAutoHideTimer();
	        this.setTransitionTimer();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      var _this2 = this;
	
	      if (this.props.open && nextProps.open && (nextProps.message !== this.props.message || nextProps.action !== this.props.action)) {
	        this.setState({
	          open: false
	        });
	
	        clearTimeout(this.timerOneAtTheTimeId);
	        this.timerOneAtTheTimeId = setTimeout(function () {
	          _this2.setState({
	            message: nextProps.message,
	            action: nextProps.action,
	            open: true
	          });
	        }, 400);
	      } else {
	        var open = nextProps.open;
	
	        this.setState({
	          open: open !== null ? open : this.state.open,
	          message: nextProps.message,
	          action: nextProps.action
	        });
	      }
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps, prevState) {
	      if (prevState.open !== this.state.open) {
	        if (this.state.open) {
	          this.setAutoHideTimer();
	          this.setTransitionTimer();
	        } else {
	          clearTimeout(this.timerAutoHideId);
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.timerAutoHideId);
	      clearTimeout(this.timerTransitionId);
	      clearTimeout(this.timerOneAtTheTimeId);
	    }
	  }, {
	    key: 'setAutoHideTimer',
	
	
	    // Timer that controls delay before snackbar auto hides
	    value: function setAutoHideTimer() {
	      var _this3 = this;
	
	      var autoHideDuration = this.props.autoHideDuration;
	
	      if (autoHideDuration > 0) {
	        clearTimeout(this.timerAutoHideId);
	        this.timerAutoHideId = setTimeout(function () {
	          if (_this3.props.open !== null && _this3.props.onRequestClose) {
	            _this3.props.onRequestClose('timeout');
	          } else {
	            _this3.setState({ open: false });
	          }
	        }, autoHideDuration);
	      }
	    }
	
	    // Timer that controls delay before click-away events are captured (based on when animation completes)
	
	  }, {
	    key: 'setTransitionTimer',
	    value: function setTransitionTimer() {
	      var _this4 = this;
	
	      this.timerTransitionId = setTimeout(function () {
	        _this4.timerTransitionId = undefined;
	      }, 400);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoHideDuration = _props.autoHideDuration,
	          contentStyle = _props.contentStyle,
	          bodyStyle = _props.bodyStyle,
	          messageProp = _props.message,
	          onRequestClose = _props.onRequestClose,
	          onActionTouchTap = _props.onActionTouchTap,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoHideDuration', 'contentStyle', 'bodyStyle', 'message', 'onRequestClose', 'onActionTouchTap', 'style']);
	      var _state = this.state,
	          action = _state.action,
	          message = _state.message,
	          open = _state.open;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      return _react2.default.createElement(
	        _ClickAwayListener2.default,
	        { onClickAway: open ? this.componentClickAway : null },
	        _react2.default.createElement(
	          'div',
	          (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	          _react2.default.createElement(_SnackbarBody2.default, {
	            action: action,
	            contentStyle: contentStyle,
	            message: message,
	            open: open,
	            onActionTouchTap: onActionTouchTap,
	            style: bodyStyle
	          })
	        )
	      );
	    }
	  }]);
	  return Snackbar;
	}(_react.Component);
	
	Snackbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Snackbar.propTypes = {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * The number of milliseconds to wait before automatically dismissing.
	   * If no value is specified the snackbar will dismiss normally.
	   * If a value is provided the snackbar can still be dismissed normally.
	   * If a snackbar is dismissed before the timer expires, the timer will be cleared.
	   */
	  autoHideDuration: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the body element.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _propTypes2.default.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _propTypes2.default.func,
	  /**
	   * Fired when the `Snackbar` is requested to be closed by a click outside the `Snackbar`, or after the
	   * `autoHideDuration` timer expires.
	   *
	   * Typically `onRequestClose` is used to set state in the parent component, which is used to control the `Snackbar`
	   * `open` prop.
	   *
	   * The `reason` parameter can optionally be used to control the response to `onRequestClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {string} reason Can be:`"timeout"` (`autoHideDuration` expired) or: `"clickaway"`
	   */
	  onRequestClose: _propTypes2.default.func,
	  /**
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = Snackbar;

/***/ },
/* 842 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.SnackbarBody = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _withWidth = __webpack_require__(1841);
	
	var _withWidth2 = _interopRequireDefault(_withWidth);
	
	var _FlatButton = __webpack_require__(148);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var open = props.open,
	      width = props.width;
	  var _context$muiTheme = context.muiTheme,
	      _context$muiTheme$bas = _context$muiTheme.baseTheme,
	      _context$muiTheme$bas2 = _context$muiTheme$bas.spacing,
	      desktopGutter = _context$muiTheme$bas2.desktopGutter,
	      desktopSubheaderHeight = _context$muiTheme$bas2.desktopSubheaderHeight,
	      fontFamily = _context$muiTheme$bas.fontFamily,
	      _context$muiTheme$sna = _context$muiTheme.snackbar,
	      backgroundColor = _context$muiTheme$sna.backgroundColor,
	      textColor = _context$muiTheme$sna.textColor,
	      actionColor = _context$muiTheme$sna.actionColor,
	      borderRadius = _context$muiTheme.borderRadius;
	
	
	  var isSmall = width === _withWidth.SMALL;
	
	  var styles = {
	    root: {
	      fontFamily: fontFamily,
	      backgroundColor: backgroundColor,
	      padding: '0 ' + desktopGutter + 'px',
	      height: desktopSubheaderHeight,
	      lineHeight: desktopSubheaderHeight + 'px',
	      borderRadius: isSmall ? 0 : borderRadius,
	      maxWidth: isSmall ? 'inherit' : 568,
	      minWidth: isSmall ? 'inherit' : 288,
	      width: isSmall ? 'calc(100vw - ' + desktopGutter * 2 + 'px)' : 'auto',
	      flexGrow: isSmall ? 1 : 0
	    },
	    content: {
	      fontSize: 14,
	      color: textColor,
	      opacity: open ? 1 : 0,
	      transition: open ? _transitions2.default.easeOut('500ms', 'opacity', '100ms') : _transitions2.default.easeOut('400ms', 'opacity')
	    },
	    action: {
	      color: actionColor,
	      float: 'right',
	      marginTop: 6,
	      marginRight: -16,
	      marginLeft: desktopGutter,
	      backgroundColor: 'transparent'
	    }
	  };
	
	  return styles;
	}
	
	var SnackbarBody = function SnackbarBody(props, context) {
	  var action = props.action,
	      contentStyle = props.contentStyle,
	      message = props.message,
	      open = props.open,
	      onActionTouchTap = props.onActionTouchTap,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['action', 'contentStyle', 'message', 'open', 'onActionTouchTap', 'style']);
	  var prepareStyles = context.muiTheme.prepareStyles;
	
	  var styles = getStyles(props, context);
	
	  var actionButton = action && _react2.default.createElement(_FlatButton2.default, {
	    style: styles.action,
	    label: action,
	    onTouchTap: onActionTouchTap
	  });
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    _react2.default.createElement(
	      'div',
	      { style: prepareStyles((0, _simpleAssign2.default)(styles.content, contentStyle)) },
	      _react2.default.createElement(
	        'span',
	        null,
	        message
	      ),
	      actionButton
	    )
	  );
	};
	
	exports.SnackbarBody = SnackbarBody;
	 false ? SnackbarBody.propTypes = {
	  /**
	   * The label for the action on the snackbar.
	   */
	  action: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the content element.
	   */
	  contentStyle: _propTypes2.default.object,
	  /**
	   * The message to be displayed.
	   *
	   * (Note: If the message is an element or array, and the `Snackbar` may re-render while it is still open,
	   * ensure that the same object remains as the `message` property if you want to avoid the `Snackbar` hiding and
	   * showing again)
	   */
	  message: _propTypes2.default.node.isRequired,
	  /**
	   * Fired when the action button is touchtapped.
	   *
	   * @param {object} event Action button event.
	   */
	  onActionTouchTap: _propTypes2.default.func,
	  /**
	   * @ignore
	   * Controls whether the `Snackbar` is opened or not.
	   */
	  open: _propTypes2.default.bool.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * @ignore
	   * Width of the screen.
	   */
	  width: _propTypes2.default.number.isRequired
	} : void 0;
	
	SnackbarBody.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = (0, _withWidth2.default)()(SnackbarBody);

/***/ },
/* 843 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Snackbar = __webpack_require__(841);
	
	var _Snackbar2 = _interopRequireDefault(_Snackbar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Snackbar2.default;

/***/ },
/* 844 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(_ref, _ref2) {
	  var index = _ref.index;
	  var stepper = _ref2.stepper;
	  var orientation = stepper.orientation;
	
	  var styles = {
	    root: {
	      flex: '0 0 auto'
	    }
	  };
	
	  if (index > 0) {
	    if (orientation === 'horizontal') {
	      styles.root.marginLeft = -6;
	    } else if (orientation === 'vertical') {
	      styles.root.marginTop = -14;
	    }
	  }
	
	  return styles;
	};
	
	var Step = function (_Component) {
	  (0, _inherits3.default)(Step, _Component);
	
	  function Step() {
	    var _ref3;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Step);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref3 = Step.__proto__ || (0, _getPrototypeOf2.default)(Step)).call.apply(_ref3, [this].concat(args))), _this), _this.renderChild = function (child) {
	      var _this$props = _this.props,
	          active = _this$props.active,
	          completed = _this$props.completed,
	          disabled = _this$props.disabled,
	          index = _this$props.index,
	          last = _this$props.last;
	
	
	      var icon = index + 1;
	
	      return _react2.default.cloneElement(child, (0, _simpleAssign2.default)({ active: active, completed: completed, disabled: disabled, icon: icon, last: last }, child.props));
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Step, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          index = _props.index,
	          last = _props.last,
	          children = _props.children,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'completed', 'disabled', 'index', 'last', 'children', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.Children.map(children, this.renderChild)
	      );
	    }
	  }]);
	  return Step;
	}(_react.Component);
	
	Step.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	 false ? Step.propTypes = {
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Should be `Step` sub-components such as `StepLabel`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * @ignore
	   * Used internally for numbering.
	   */
	  index: _propTypes2.default.number,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = Step;

/***/ },
/* 845 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedButton = __webpack_require__(35);
	
	var _EnhancedButton2 = _interopRequireDefault(_EnhancedButton);
	
	var _StepLabel = __webpack_require__(359);
	
	var _StepLabel2 = _interopRequireDefault(_StepLabel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isLabel = function isLabel(child) {
	  return child && child.type && child.type.muiName === 'StepLabel';
	};
	
	var getStyles = function getStyles(props, context, state) {
	  var hovered = state.hovered;
	  var _context$muiTheme$ste = context.muiTheme.stepper,
	      backgroundColor = _context$muiTheme$ste.backgroundColor,
	      hoverBackgroundColor = _context$muiTheme$ste.hoverBackgroundColor;
	
	
	  var styles = {
	    root: {
	      padding: 0,
	      backgroundColor: hovered ? hoverBackgroundColor : backgroundColor,
	      transition: _transitions2.default.easeOut()
	    }
	  };
	
	  if (context.stepper.orientation === 'vertical') {
	    styles.root.width = '100%';
	  }
	
	  return styles;
	};
	
	var StepButton = function (_Component) {
	  (0, _inherits3.default)(StepButton, _Component);
	
	  function StepButton() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, StepButton);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = StepButton.__proto__ || (0, _getPrototypeOf2.default)(StepButton)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false,
	      touched: false
	    }, _this.handleMouseEnter = function (event) {
	      var onMouseEnter = _this.props.onMouseEnter;
	      // Cancel hover styles for touch devices
	
	      if (!_this.state.touched) {
	        _this.setState({ hovered: true });
	      }
	      if (typeof onMouseEnter === 'function') {
	        onMouseEnter(event);
	      }
	    }, _this.handleMouseLeave = function (event) {
	      var onMouseLeave = _this.props.onMouseLeave;
	
	      _this.setState({ hovered: false });
	      if (typeof onMouseLeave === 'function') {
	        onMouseLeave(event);
	      }
	    }, _this.handleTouchStart = function (event) {
	      var onTouchStart = _this.props.onTouchStart;
	
	      if (!_this.state.touched) {
	        _this.setState({ touched: true });
	      }
	      if (typeof onTouchStart === 'function') {
	        onTouchStart(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(StepButton, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          disabled = _props.disabled,
	          icon = _props.icon,
	          iconContainerStyle = _props.iconContainerStyle,
	          last = _props.last,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          onTouchStart = _props.onTouchStart,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'disabled', 'icon', 'iconContainerStyle', 'last', 'onMouseEnter', 'onMouseLeave', 'onTouchStart', 'style']);
	
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var child = isLabel(children) ? children : _react2.default.createElement(
	        _StepLabel2.default,
	        null,
	        children
	      );
	
	      return _react2.default.createElement(
	        _EnhancedButton2.default,
	        (0, _extends3.default)({
	          disabled: disabled,
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          onTouchStart: this.handleTouchStart
	        }, other),
	        _react2.default.cloneElement(child, { active: active, completed: completed, disabled: disabled, icon: icon, iconContainerStyle: iconContainerStyle })
	      );
	    }
	  }]);
	  return StepButton;
	}(_react.Component);
	
	StepButton.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	 false ? StepButton.propTypes = {
	  /**
	   * Passed from `Step` Is passed to StepLabel.
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes2.default.oneOfType([_propTypes2.default.element, _propTypes2.default.string, _propTypes2.default.number]),
	  /**
	   * Override the inline-styles of the icon container element.
	   */
	  iconContainerStyle: _propTypes2.default.object,
	  /** @ignore */
	  last: _propTypes2.default.bool,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /** @ignore */
	  onTouchStart: _propTypes2.default.func,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = StepButton;

/***/ },
/* 846 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PlainStepConnector = undefined;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	
	var StepConnector = function StepConnector(props, context) {
	  var muiTheme = context.muiTheme,
	      stepper = context.stepper;
	
	
	  var styles = {
	    wrapper: {
	      flex: '1 1 auto'
	    },
	    line: {
	      display: 'block',
	      borderColor: muiTheme.stepper.connectorLineColor
	    }
	  };
	
	  /**
	   * Clean up once we can use CSS pseudo elements
	   */
	  if (stepper.orientation === 'horizontal') {
	    styles.line.marginLeft = -6;
	    styles.line.borderTopStyle = 'solid';
	    styles.line.borderTopWidth = 1;
	  } else if (stepper.orientation === 'vertical') {
	    styles.wrapper.marginLeft = 14 + 11; // padding + 1/2 icon
	    styles.line.borderLeftStyle = 'solid';
	    styles.line.borderLeftWidth = 1;
	    styles.line.minHeight = 28;
	  }
	
	  var prepareStyles = muiTheme.prepareStyles;
	
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles(styles.wrapper) },
	    _react2.default.createElement('span', { style: prepareStyles(styles.line) })
	  );
	};
	
	 false ? StepConnector.propTypes = propTypes : void 0;
	StepConnector.contextTypes = contextTypes;
	
	exports.PlainStepConnector = StepConnector;
	exports.default = (0, _pure2.default)(StepConnector);

/***/ },
/* 847 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ExpandTransition = __webpack_require__(877);
	
	var _ExpandTransition2 = _interopRequireDefault(_ExpandTransition);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function ExpandTransition(props) {
	  return _react2.default.createElement(_ExpandTransition2.default, props);
	}
	
	var getStyles = function getStyles(props, context) {
	  var styles = {
	    root: {
	      marginTop: -14,
	      marginLeft: 14 + 11, // padding + 1/2 icon
	      paddingLeft: 24 - 11 + 8,
	      paddingRight: 16,
	      overflow: 'hidden'
	    }
	  };
	
	  if (!props.last) {
	    styles.root.borderLeft = '1px solid ' + context.muiTheme.stepper.connectorLineColor;
	  }
	
	  return styles;
	};
	
	var StepContent = function (_Component) {
	  (0, _inherits3.default)(StepContent, _Component);
	
	  function StepContent() {
	    (0, _classCallCheck3.default)(this, StepContent);
	    return (0, _possibleConstructorReturn3.default)(this, (StepContent.__proto__ || (0, _getPrototypeOf2.default)(StepContent)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(StepContent, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          active = _props.active,
	          children = _props.children,
	          completed = _props.completed,
	          last = _props.last,
	          style = _props.style,
	          transition = _props.transition,
	          transitionDuration = _props.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props, ['active', 'children', 'completed', 'last', 'style', 'transition', 'transitionDuration']);
	      var _context = this.context,
	          stepper = _context.stepper,
	          prepareStyles = _context.muiTheme.prepareStyles;
	
	
	      if (stepper.orientation !== 'vertical') {
	         false ? (0, _warning2.default)(false, 'Material-UI: <StepContent /> is only designed for use with the vertical stepper.') : void 0;
	        return null;
	      }
	
	      var styles = getStyles(this.props, this.context);
	      var transitionProps = {
	        enterDelay: transitionDuration,
	        transitionDuration: transitionDuration,
	        open: active
	      };
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }, other),
	        _react2.default.createElement(transition, transitionProps, _react2.default.createElement(
	          'div',
	          { style: { overflow: 'hidden' } },
	          children
	        ))
	      );
	    }
	  }]);
	  return StepContent;
	}(_react.Component);
	
	StepContent.defaultProps = {
	  transition: ExpandTransition,
	  transitionDuration: 450
	};
	StepContent.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired,
	  stepper: _propTypes2.default.object
	};
	 false ? StepContent.propTypes = {
	  /**
	   * Expands the content
	   */
	  active: _propTypes2.default.bool,
	  /**
	   * Step content
	   */
	  children: _propTypes2.default.node,
	  /**
	   * @ignore
	   */
	  completed: _propTypes2.default.bool,
	  /**
	   * @ignore
	   */
	  last: _propTypes2.default.bool,
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * ReactTransitionGroup component.
	   */
	  transition: _propTypes2.default.func,
	  /**
	   * Adjust the duration of the content expand transition. Passed as a prop to the transition component.
	   */
	  transitionDuration: _propTypes2.default.number
	} : void 0;
	exports.default = StepContent;

/***/ },
/* 848 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _StepConnector = __webpack_require__(846);
	
	var _StepConnector2 = _interopRequireDefault(_StepConnector);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props) {
	  var orientation = props.orientation;
	
	  return {
	    root: {
	      display: 'flex',
	      flexDirection: orientation === 'horizontal' ? 'row' : 'column',
	      alignContent: 'center',
	      alignItems: orientation === 'horizontal' ? 'center' : 'stretch',
	      justifyContent: 'space-between'
	    }
	  };
	};
	
	var Stepper = function (_Component) {
	  (0, _inherits3.default)(Stepper, _Component);
	
	  function Stepper() {
	    (0, _classCallCheck3.default)(this, Stepper);
	    return (0, _possibleConstructorReturn3.default)(this, (Stepper.__proto__ || (0, _getPrototypeOf2.default)(Stepper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Stepper, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      var orientation = this.props.orientation;
	
	      return { stepper: { orientation: orientation } };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          activeStep = _props.activeStep,
	          children = _props.children,
	          connector = _props.connector,
	          linear = _props.linear,
	          style = _props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      /**
	       * One day, we may be able to use real CSS tools
	       * For now, we need to create our own "pseudo" elements
	       * and nth child selectors, etc
	       * That's what some of this garbage is for :)
	       */
	      var numChildren = _react.Children.count(children);
	      var steps = _react.Children.map(children, function (step, index) {
	        var controlProps = { index: index };
	
	        if (activeStep === index) {
	          controlProps.active = true;
	        } else if (linear && activeStep > index) {
	          controlProps.completed = true;
	        } else if (linear && activeStep < index) {
	          controlProps.disabled = true;
	        }
	
	        if (index + 1 === numChildren) {
	          controlProps.last = true;
	        }
	
	        return [index > 0 && connector, _react2.default.cloneElement(step, (0, _simpleAssign2.default)(controlProps, step.props))];
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	        steps
	      );
	    }
	  }]);
	  return Stepper;
	}(_react.Component);
	
	Stepper.defaultProps = {
	  connector: _react2.default.createElement(_StepConnector2.default, null),
	  orientation: 'horizontal',
	  linear: true
	};
	Stepper.contextTypes = { muiTheme: _propTypes2.default.object.isRequired };
	Stepper.childContextTypes = { stepper: _propTypes2.default.object };
	 false ? Stepper.propTypes = {
	  /**
	   * Set the active step (zero based index). This will enable `Step` control helpers.
	   */
	  activeStep: _propTypes2.default.number,
	  /**
	   * Should be two or more `<Step />` components
	   */
	  children: _propTypes2.default.arrayOf(_propTypes2.default.node),
	  /**
	   * A component to be placed between each step.
	   */
	  connector: _propTypes2.default.node,
	  /**
	   * If set to `true`, the `Stepper` will assist in controlling steps for linear flow
	   */
	  linear: _propTypes2.default.bool,
	  /**
	   * The stepper orientation (layout flow direction)
	   */
	  orientation: _propTypes2.default.oneOf(['horizontal', 'vertical']),
	  /**
	   * Override the inline-style of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = Stepper;

/***/ },
/* 849 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Subheader = function Subheader(props, context) {
	  var children = props.children,
	      inset = props.inset,
	      style = props.style,
	      other = (0, _objectWithoutProperties3.default)(props, ['children', 'inset', 'style']);
	  var _context$muiTheme = context.muiTheme,
	      prepareStyles = _context$muiTheme.prepareStyles,
	      subheader = _context$muiTheme.subheader;
	
	
	  var styles = {
	    root: {
	      boxSizing: 'border-box',
	      color: subheader.color,
	      fontSize: 14,
	      fontWeight: subheader.fontWeight,
	      lineHeight: '48px',
	      paddingLeft: inset ? 72 : 16,
	      width: '100%'
	    }
	  };
	
	  return _react2.default.createElement(
	    'div',
	    (0, _extends3.default)({}, other, { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) }),
	    children
	  );
	};
	
	Subheader.muiName = 'Subheader';
	
	 false ? Subheader.propTypes = {
	  /**
	   * Node that will be placed inside the `Subheader`.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * If true, the `Subheader` will be indented.
	   */
	  inset: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	
	Subheader.defaultProps = {
	  inset: false
	};
	
	Subheader.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	
	exports.default = Subheader;

/***/ },
/* 850 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SvgIcon = function (_Component) {
	  (0, _inherits3.default)(SvgIcon, _Component);
	
	  function SvgIcon() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, SvgIcon);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = SvgIcon.__proto__ || (0, _getPrototypeOf2.default)(SvgIcon)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      hovered: false
	    }, _this.handleMouseLeave = function (event) {
	      _this.setState({ hovered: false });
	      _this.props.onMouseLeave(event);
	    }, _this.handleMouseEnter = function (event) {
	      _this.setState({ hovered: true });
	      _this.props.onMouseEnter(event);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(SvgIcon, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          color = _props.color,
	          hoverColor = _props.hoverColor,
	          onMouseEnter = _props.onMouseEnter,
	          onMouseLeave = _props.onMouseLeave,
	          style = _props.style,
	          viewBox = _props.viewBox,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'color', 'hoverColor', 'onMouseEnter', 'onMouseLeave', 'style', 'viewBox']);
	      var _context$muiTheme = this.context.muiTheme,
	          svgIcon = _context$muiTheme.svgIcon,
	          prepareStyles = _context$muiTheme.prepareStyles;
	
	
	      var offColor = color ? color : 'currentColor';
	      var onColor = hoverColor ? hoverColor : offColor;
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        display: 'inline-block',
	        color: svgIcon.color,
	        fill: this.state.hovered ? onColor : offColor,
	        height: 24,
	        width: 24,
	        userSelect: 'none',
	        transition: _transitions2.default.easeOut()
	      }, style);
	
	      return _react2.default.createElement(
	        'svg',
	        (0, _extends3.default)({}, other, {
	          onMouseEnter: this.handleMouseEnter,
	          onMouseLeave: this.handleMouseLeave,
	          style: prepareStyles(mergedStyles),
	          viewBox: viewBox
	        }),
	        children
	      );
	    }
	  }]);
	  return SvgIcon;
	}(_react.Component);
	
	SvgIcon.muiName = 'SvgIcon';
	SvgIcon.defaultProps = {
	  onMouseEnter: function onMouseEnter() {},
	  onMouseLeave: function onMouseLeave() {},
	  viewBox: '0 0 24 24'
	};
	SvgIcon.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? SvgIcon.propTypes = {
	  /**
	   * Elements passed into the SVG Icon.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * This is the fill color of the svg icon.
	   * If not specified, this component will default
	   * to muiTheme.palette.textColor.
	   */
	  color: _propTypes2.default.string,
	  /**
	   * This is the icon color when the mouse hovers over the icon.
	   */
	  hoverColor: _propTypes2.default.string,
	  /** @ignore */
	  onMouseEnter: _propTypes2.default.func,
	  /** @ignore */
	  onMouseLeave: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Allows you to redefine what the coordinates
	   * without units mean inside an svg element. For example,
	   * if the SVG element is 500 (width) by 200 (height), and you
	   * pass viewBox="0 0 50 20", this means that the coordinates inside
	   * the svg will go from the top left corner (0,0) to bottom right (50,20)
	   * and each unit will be worth 10px.
	   */
	  viewBox: _propTypes2.default.string
	} : void 0;
	exports.default = SvgIcon;

/***/ },
/* 851 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      table = _context$muiTheme.table;
	
	
	  return {
	    root: {
	      backgroundColor: table.backgroundColor,
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      tableLayout: 'fixed',
	      fontFamily: baseTheme.fontFamily
	    },
	    bodyTable: {
	      height: props.fixedHeader || props.fixedFooter ? props.height : 'auto',
	      overflowX: 'hidden',
	      overflowY: 'auto'
	    },
	    tableWrapper: {
	      height: props.fixedHeader || props.fixedFooter ? 'auto' : props.height,
	      overflow: 'auto'
	    }
	  };
	}
	
	var Table = function (_Component) {
	  (0, _inherits3.default)(Table, _Component);
	
	  function Table() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Table);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Table.__proto__ || (0, _getPrototypeOf2.default)(Table)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      allRowsSelected: false
	    }, _this.onCellClick = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellClick) _this.props.onCellClick(rowNumber, columnNumber, event);
	    }, _this.onCellHover = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHover) _this.props.onCellHover(rowNumber, columnNumber, event);
	    }, _this.onCellHoverExit = function (rowNumber, columnNumber, event) {
	      if (_this.props.onCellHoverExit) _this.props.onCellHoverExit(rowNumber, columnNumber, event);
	    }, _this.onRowHover = function (rowNumber) {
	      if (_this.props.onRowHover) _this.props.onRowHover(rowNumber);
	    }, _this.onRowHoverExit = function (rowNumber) {
	      if (_this.props.onRowHoverExit) _this.props.onRowHoverExit(rowNumber);
	    }, _this.onRowSelection = function (selectedRows) {
	      if (_this.state.allRowsSelected) _this.setState({ allRowsSelected: false });
	      if (_this.props.onRowSelection) _this.props.onRowSelection(selectedRows);
	    }, _this.onSelectAll = function () {
	      if (_this.props.onRowSelection) {
	        if (!_this.state.allRowsSelected) {
	          _this.props.onRowSelection('all');
	        } else {
	          _this.props.onRowSelection('none');
	        }
	      }
	
	      _this.setState({ allRowsSelected: !_this.state.allRowsSelected });
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Table, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      if (this.props.allRowsSelected) {
	        this.setState({ allRowsSelected: true });
	      }
	    }
	  }, {
	    key: 'isScrollbarVisible',
	    value: function isScrollbarVisible() {
	      var tableDivHeight = this.refs.tableDiv.clientHeight;
	      var tableBodyHeight = this.refs.tableBody.clientHeight;
	
	      return tableBodyHeight > tableDivHeight;
	    }
	  }, {
	    key: 'createTableHeader',
	    value: function createTableHeader(base) {
	      return _react2.default.cloneElement(base, {
	        enableSelectAll: base.props.enableSelectAll && this.props.selectable && this.props.multiSelectable,
	        onSelectAll: this.onSelectAll,
	        selectAllSelected: this.state.allRowsSelected
	      });
	    }
	  }, {
	    key: 'createTableBody',
	    value: function createTableBody(base) {
	      return _react2.default.cloneElement(base, {
	        allRowsSelected: this.state.allRowsSelected,
	        multiSelectable: this.props.multiSelectable,
	        onCellClick: this.onCellClick,
	        onCellHover: this.onCellHover,
	        onCellHoverExit: this.onCellHoverExit,
	        onRowHover: this.onRowHover,
	        onRowHoverExit: this.onRowHoverExit,
	        onRowSelection: this.onRowSelection,
	        selectable: this.props.selectable,
	        style: (0, _simpleAssign2.default)({ height: this.props.height }, base.props.style)
	      });
	    }
	  }, {
	    key: 'createTableFooter',
	    value: function createTableFooter(base) {
	      return base;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          fixedFooter = _props.fixedFooter,
	          fixedHeader = _props.fixedHeader,
	          style = _props.style,
	          wrapperStyle = _props.wrapperStyle,
	          headerStyle = _props.headerStyle,
	          bodyStyle = _props.bodyStyle,
	          footerStyle = _props.footerStyle;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      var tHead = void 0;
	      var tFoot = void 0;
	      var tBody = void 0;
	
	      _react2.default.Children.forEach(children, function (child) {
	        if (!_react2.default.isValidElement(child)) return;
	
	        var muiName = child.type.muiName;
	
	        if (muiName === 'TableBody') {
	          tBody = _this2.createTableBody(child);
	        } else if (muiName === 'TableHeader') {
	          tHead = _this2.createTableHeader(child);
	        } else if (muiName === 'TableFooter') {
	          tFoot = _this2.createTableFooter(child);
	        } else {
	           false ? (0, _warning2.default)(false, 'Material-UI: Children of the Table component must be TableBody or TableHeader or TableFooter.\n           Nothing is rendered.') : void 0;
	        }
	      });
	
	      // If we could not find a table-header and a table-body, do not attempt to display anything.
	      if (!tBody && !tHead) return null;
	
	      var mergedTableStyle = (0, _simpleAssign2.default)(styles.root, style);
	      var headerTable = void 0;
	      var footerTable = void 0;
	      var inlineHeader = void 0;
	      var inlineFooter = void 0;
	
	      if (fixedHeader) {
	        headerTable = _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)({}, headerStyle)) },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle },
	            tHead
	          )
	        );
	      } else {
	        inlineHeader = tHead;
	      }
	
	      if (tFoot !== undefined) {
	        if (fixedFooter) {
	          footerTable = _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, footerStyle)) },
	            _react2.default.createElement(
	              'table',
	              { className: className, style: prepareStyles(mergedTableStyle) },
	              tFoot
	            )
	          );
	        } else {
	          inlineFooter = tFoot;
	        }
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.tableWrapper, wrapperStyle)) },
	        headerTable,
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.bodyTable, bodyStyle)), ref: 'tableDiv' },
	          _react2.default.createElement(
	            'table',
	            { className: className, style: mergedTableStyle, ref: 'tableBody' },
	            inlineHeader,
	            inlineFooter,
	            tBody
	          )
	        ),
	        footerTable
	      );
	    }
	  }]);
	  return Table;
	}(_react.Component);
	
	Table.defaultProps = {
	  allRowsSelected: false,
	  fixedFooter: true,
	  fixedHeader: true,
	  height: 'inherit',
	  multiSelectable: false,
	  selectable: true
	};
	Table.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Table.propTypes = {
	  /**
	   * Set to true to indicate that all rows should be selected.
	   */
	  allRowsSelected: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the body's table element.
	   */
	  bodyStyle: _propTypes2.default.object,
	  /**
	   * Children passed to table.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * If true, the footer will appear fixed below the table.
	   * The default value is true.
	   */
	  fixedFooter: _propTypes2.default.bool,
	  /**
	   * If true, the header will appear fixed above the table.
	   * The default value is true.
	   */
	  fixedHeader: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the footer's table element.
	   */
	  footerStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the header's table element.
	   */
	  headerStyle: _propTypes2.default.object,
	  /**
	   * The height of the table.
	   */
	  height: _propTypes2.default.string,
	  /**
	   * If true, multiple table rows can be selected.
	   * CTRL/CMD+Click and SHIFT+Click are valid actions.
	   * The default value is false.
	   */
	  multiSelectable: _propTypes2.default.bool,
	  /**
	   * Called when a row cell is clicked.
	   * rowNumber is the row number and columnId is
	   * the column number or the column key.
	   */
	  onCellClick: _propTypes2.default.func,
	  /**
	   * Called when a table cell is hovered.
	   * rowNumber is the row number of the hovered row
	   * and columnId is the column number or the column key of the cell.
	   */
	  onCellHover: _propTypes2.default.func,
	  /**
	   * Called when a table cell is no longer hovered.
	   * rowNumber is the row number of the row and columnId
	   * is the column number or the column key of the cell.
	   */
	  onCellHoverExit: _propTypes2.default.func,
	  /**
	   * Called when a table row is hovered.
	   * rowNumber is the row number of the hovered row.
	   */
	  onRowHover: _propTypes2.default.func,
	  /**
	   * Called when a table row is no longer hovered.
	   * rowNumber is the row number of the row that is no longer hovered.
	   */
	  onRowHoverExit: _propTypes2.default.func,
	  /**
	   * Called when a row is selected.
	   * selectedRows is an array of all row selections.
	   * IF all rows have been selected, the string "all"
	   * will be returned instead to indicate that all rows have been selected.
	   */
	  onRowSelection: _propTypes2.default.func,
	  /**
	   * If true, table rows can be selected.
	   * If multiple row selection is desired, enable multiSelectable.
	   * The default value is true.
	   */
	  selectable: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the table's wrapper element.
	   */
	  wrapperStyle: _propTypes2.default.object
	} : void 0;
	exports.default = Table;

/***/ },
/* 852 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.TableRowColumn = exports.TableRow = exports.TableHeaderColumn = exports.TableHeader = exports.TableFooter = exports.TableBody = exports.Table = undefined;
	
	var _Table2 = __webpack_require__(851);
	
	var _Table3 = _interopRequireDefault(_Table2);
	
	var _TableBody2 = __webpack_require__(361);
	
	var _TableBody3 = _interopRequireDefault(_TableBody2);
	
	var _TableFooter2 = __webpack_require__(362);
	
	var _TableFooter3 = _interopRequireDefault(_TableFooter2);
	
	var _TableHeader2 = __webpack_require__(363);
	
	var _TableHeader3 = _interopRequireDefault(_TableHeader2);
	
	var _TableHeaderColumn2 = __webpack_require__(219);
	
	var _TableHeaderColumn3 = _interopRequireDefault(_TableHeaderColumn2);
	
	var _TableRow2 = __webpack_require__(364);
	
	var _TableRow3 = _interopRequireDefault(_TableRow2);
	
	var _TableRowColumn2 = __webpack_require__(150);
	
	var _TableRowColumn3 = _interopRequireDefault(_TableRowColumn2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Table = _Table3.default;
	exports.TableBody = _TableBody3.default;
	exports.TableFooter = _TableFooter3.default;
	exports.TableHeader = _TableHeader3.default;
	exports.TableHeaderColumn = _TableHeaderColumn3.default;
	exports.TableRow = _TableRow3.default;
	exports.TableRowColumn = _TableRowColumn3.default;
	exports.default = _Table3.default;

/***/ },
/* 853 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var inkBar = context.muiTheme.inkBar;
	
	
	  return {
	    root: {
	      left: props.left,
	      width: props.width,
	      bottom: 0,
	      display: 'block',
	      backgroundColor: props.color || inkBar.backgroundColor,
	      height: 2,
	      marginTop: -2,
	      position: 'relative',
	      transition: _transitions2.default.easeOut('1s', 'left')
	    }
	  };
	}
	
	var InkBar = function (_Component) {
	  (0, _inherits3.default)(InkBar, _Component);
	
	  function InkBar() {
	    (0, _classCallCheck3.default)(this, InkBar);
	    return (0, _possibleConstructorReturn3.default)(this, (InkBar.__proto__ || (0, _getPrototypeOf2.default)(InkBar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(InkBar, [{
	    key: 'render',
	    value: function render() {
	      var style = this.props.style;
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) });
	    }
	  }]);
	  return InkBar;
	}(_react.Component);
	
	InkBar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? InkBar.propTypes = {
	  color: _propTypes2.default.string,
	  left: _propTypes2.default.string.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  width: _propTypes2.default.string.isRequired
	} : void 0;
	exports.default = InkBar;

/***/ },
/* 854 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  width: '100%',
	  position: 'relative',
	  textAlign: 'initial'
	};
	
	var TabTemplate = function TabTemplate(_ref) {
	  var children = _ref.children,
	      selected = _ref.selected,
	      style = _ref.style;
	
	  var templateStyle = (0, _simpleAssign2.default)({}, styles, style);
	  if (!selected) {
	    templateStyle.height = 0;
	    templateStyle.overflow = 'hidden';
	  }
	
	  return _react2.default.createElement(
	    'div',
	    { style: templateStyle },
	    children
	  );
	};
	
	 false ? TabTemplate.propTypes = {
	  children: _propTypes2.default.node,
	  selected: _propTypes2.default.bool,
	  style: _propTypes2.default.object
	} : void 0;
	
	exports.default = TabTemplate;

/***/ },
/* 855 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _TabTemplate = __webpack_require__(854);
	
	var _TabTemplate2 = _interopRequireDefault(_TabTemplate);
	
	var _InkBar = __webpack_require__(853);
	
	var _InkBar2 = _interopRequireDefault(_InkBar);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var tabs = context.muiTheme.tabs;
	
	
	  return {
	    tabItemContainer: {
	      width: '100%',
	      backgroundColor: tabs.backgroundColor,
	      whiteSpace: 'nowrap',
	      display: 'flex'
	    }
	  };
	}
	
	var Tabs = function (_Component) {
	  (0, _inherits3.default)(Tabs, _Component);
	
	  function Tabs() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Tabs);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Tabs.__proto__ || (0, _getPrototypeOf2.default)(Tabs)).call.apply(_ref, [this].concat(args))), _this), _this.state = { selectedIndex: 0 }, _this.handleTabTouchTap = function (value, event, tab) {
	      var valueLink = _this.getValueLink(_this.props);
	      var index = tab.props.index;
	
	      if (valueLink.value && valueLink.value !== value || _this.state.selectedIndex !== index) {
	        valueLink.requestChange(value, event, tab);
	      }
	
	      _this.setState({ selectedIndex: index });
	
	      if (tab.props.onActive) {
	        tab.props.onActive(tab);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Tabs, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var valueLink = this.getValueLink(this.props);
	      var initialIndex = this.props.initialSelectedIndex;
	
	      this.setState({
	        selectedIndex: valueLink.value !== undefined ? this.getSelectedIndex(this.props) : initialIndex < this.getTabCount() ? initialIndex : 0
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(newProps, nextContext) {
	      var valueLink = this.getValueLink(newProps);
	      var newState = {
	        muiTheme: nextContext.muiTheme || this.context.muiTheme
	      };
	
	      if (valueLink.value !== undefined) {
	        newState.selectedIndex = this.getSelectedIndex(newProps);
	      }
	
	      this.setState(newState);
	    }
	  }, {
	    key: 'getTabs',
	    value: function getTabs() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var tabs = [];
	
	      _react.Children.forEach(props.children, function (tab) {
	        if ((0, _react.isValidElement)(tab)) {
	          tabs.push(tab);
	        }
	      });
	
	      return tabs;
	    }
	  }, {
	    key: 'getTabCount',
	    value: function getTabCount() {
	      return this.getTabs().length;
	    }
	
	    // Do not use outside of this component, it will be removed once valueLink is deprecated
	
	  }, {
	    key: 'getValueLink',
	    value: function getValueLink(props) {
	      return props.valueLink || {
	        value: props.value,
	        requestChange: props.onChange
	      };
	    }
	  }, {
	    key: 'getSelectedIndex',
	    value: function getSelectedIndex(props) {
	      var valueLink = this.getValueLink(props);
	      var selectedIndex = -1;
	
	      this.getTabs(props).forEach(function (tab, index) {
	        if (valueLink.value === tab.props.value) {
	          selectedIndex = index;
	        }
	      });
	
	      return selectedIndex;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected(tab, index) {
	      var valueLink = this.getValueLink(this.props);
	      return valueLink.value ? valueLink.value === tab.props.value : this.state.selectedIndex === index;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props = this.props,
	          contentContainerClassName = _props.contentContainerClassName,
	          contentContainerStyle = _props.contentContainerStyle,
	          initialSelectedIndex = _props.initialSelectedIndex,
	          inkBarStyle = _props.inkBarStyle,
	          onChange = _props.onChange,
	          style = _props.style,
	          tabItemContainerStyle = _props.tabItemContainerStyle,
	          tabTemplate = _props.tabTemplate,
	          tabTemplateStyle = _props.tabTemplateStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['contentContainerClassName', 'contentContainerStyle', 'initialSelectedIndex', 'inkBarStyle', 'onChange', 'style', 'tabItemContainerStyle', 'tabTemplate', 'tabTemplateStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	      var valueLink = this.getValueLink(this.props);
	      var tabValue = valueLink.value;
	      var tabContent = [];
	      var width = 100 / this.getTabCount();
	
	      var tabs = this.getTabs().map(function (tab, index) {
	         false ? (0, _warning2.default)(tab.type && tab.type.muiName === 'Tab', 'Material-UI: Tabs only accepts Tab Components as children.\n        Found ' + (tab.type.muiName || tab.type) + ' as child number ' + (index + 1) + ' of Tabs') : void 0;
	
	         false ? (0, _warning2.default)(!tabValue || tab.props.value !== undefined, 'Material-UI: Tabs value prop has been passed, but Tab ' + index + '\n        does not have a value prop. Needs value if Tabs is going\n        to be a controlled component.') : void 0;
	
	        tabContent.push(tab.props.children ? (0, _react.createElement)(tabTemplate || _TabTemplate2.default, {
	          key: index,
	          selected: _this2.getSelected(tab, index),
	          style: tabTemplateStyle
	        }, tab.props.children) : undefined);
	
	        return (0, _react.cloneElement)(tab, {
	          key: index,
	          index: index,
	          selected: _this2.getSelected(tab, index),
	          width: width + '%',
	          onTouchTap: _this2.handleTabTouchTap
	        });
	      });
	
	      var inkBar = this.state.selectedIndex !== -1 ? _react2.default.createElement(_InkBar2.default, {
	        left: width * this.state.selectedIndex + '%',
	        width: width + '%',
	        style: inkBarStyle
	      }) : null;
	
	      var inkBarContainerWidth = tabItemContainerStyle ? tabItemContainerStyle.width : '100%';
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({ style: prepareStyles((0, _simpleAssign2.default)({}, style)) }, other),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles((0, _simpleAssign2.default)(styles.tabItemContainer, tabItemContainerStyle)) },
	          tabs
	        ),
	        _react2.default.createElement(
	          'div',
	          { style: { width: inkBarContainerWidth } },
	          inkBar
	        ),
	        _react2.default.createElement(
	          'div',
	          {
	            style: prepareStyles((0, _simpleAssign2.default)({}, contentContainerStyle)),
	            className: contentContainerClassName
	          },
	          tabContent
	        )
	      );
	    }
	  }]);
	  return Tabs;
	}(_react.Component);
	
	Tabs.defaultProps = {
	  initialSelectedIndex: 0,
	  onChange: function onChange() {}
	};
	Tabs.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Tabs.propTypes = {
	  /**
	   * Should be used to pass `Tab` components.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The css class name of the content's container.
	   */
	  contentContainerClassName: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the content's container.
	   */
	  contentContainerStyle: _propTypes2.default.object,
	  /**
	   * Specify initial visible tab index.
	   * If `initialSelectedIndex` is set but larger than the total amount of specified tabs,
	   * `initialSelectedIndex` will revert back to default.
	   * If `initialSelectedIndex` is set to any negative value, no tab will be selected intially.
	   */
	  initialSelectedIndex: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the InkBar.
	   */
	  inkBarStyle: _propTypes2.default.object,
	  /**
	   * Called when the selected value change.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the tab-labels container.
	   */
	  tabItemContainerStyle: _propTypes2.default.object,
	  /**
	   * Override the default tab template used to wrap the content of each tab element.
	   */
	  tabTemplate: _propTypes2.default.func,
	  /**
	   * Override the inline-styles of the tab template.
	   */
	  tabTemplateStyle: _propTypes2.default.object,
	  /**
	   * Makes Tabs controllable and selects the tab whose value prop matches this prop.
	   */
	  value: _propTypes2.default.any
	} : void 0;
	exports.default = Tabs;

/***/ },
/* 856 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.Tabs = exports.Tab = undefined;
	
	var _Tab2 = __webpack_require__(365);
	
	var _Tab3 = _interopRequireDefault(_Tab2);
	
	var _Tabs2 = __webpack_require__(855);
	
	var _Tabs3 = _interopRequireDefault(_Tabs2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Tab = _Tab3.default;
	exports.Tabs = _Tabs3.default;
	exports.default = _Tabs3.default;

/***/ },
/* 857 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(44);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var rowsHeight = 24;
	
	function getStyles(props, context, state) {
	  return {
	    root: {
	      position: 'relative' },
	    textarea: {
	      height: state.height,
	      width: '100%',
	      resize: 'none',
	      font: 'inherit',
	      padding: 0,
	      cursor: 'inherit'
	    },
	    shadow: {
	      resize: 'none',
	      // Overflow also needed to here to remove the extra row
	      // added to textareas in Firefox.
	      overflow: 'hidden',
	      // Visibility needed to hide the extra text area on ipads
	      visibility: 'hidden',
	      position: 'absolute',
	      height: 'auto'
	    }
	  };
	}
	
	var EnhancedTextarea = function (_Component) {
	  (0, _inherits3.default)(EnhancedTextarea, _Component);
	
	  function EnhancedTextarea() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, EnhancedTextarea);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = EnhancedTextarea.__proto__ || (0, _getPrototypeOf2.default)(EnhancedTextarea)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      height: null
	    }, _this.handleResize = function (event) {
	      _this.syncHeightWithShadow(undefined, event);
	    }, _this.handleChange = function (event) {
	      _this.syncHeightWithShadow(event.target.value);
	
	      if (_this.props.hasOwnProperty('valueLink')) {
	        _this.props.valueLink.requestChange(event.target.value);
	      }
	
	      if (_this.props.onChange) {
	        _this.props.onChange(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(EnhancedTextarea, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        height: this.props.rows * rowsHeight
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.syncHeightWithShadow();
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value || nextProps.rowsMax !== this.props.rowsMax) {
	        this.syncHeightWithShadow(nextProps.value, null, nextProps);
	      }
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.refs.input;
	    }
	  }, {
	    key: 'setValue',
	    value: function setValue(value) {
	      this.getInputNode().value = value;
	      this.syncHeightWithShadow(value);
	    }
	  }, {
	    key: 'syncHeightWithShadow',
	    value: function syncHeightWithShadow(newValue, event, props) {
	      var shadow = this.refs.shadow;
	      var displayText = this.props.hintText && (newValue === '' || newValue === undefined || newValue === null) ? this.props.hintText : newValue;
	
	      if (displayText !== undefined) {
	        shadow.value = displayText;
	      }
	
	      var newHeight = shadow.scrollHeight;
	
	      // Guarding for jsdom, where scrollHeight isn't present.
	      // See https://github.com/tmpvar/jsdom/issues/1013
	      if (newHeight === undefined) return;
	
	      props = props || this.props;
	
	      if (props.rowsMax >= props.rows) {
	        newHeight = Math.min(props.rowsMax * rowsHeight, newHeight);
	      }
	
	      newHeight = Math.max(newHeight, rowsHeight);
	
	      if (this.state.height !== newHeight) {
	        this.setState({
	          height: newHeight
	        });
	
	        if (props.onHeightChange) {
	          props.onHeightChange(event, newHeight);
	        }
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          onChange = _props.onChange,
	          onHeightChange = _props.onHeightChange,
	          rows = _props.rows,
	          rowsMax = _props.rowsMax,
	          shadowStyle = _props.shadowStyle,
	          style = _props.style,
	          hintText = _props.hintText,
	          textareaStyle = _props.textareaStyle,
	          valueLink = _props.valueLink,
	          other = (0, _objectWithoutProperties3.default)(_props, ['onChange', 'onHeightChange', 'rows', 'rowsMax', 'shadowStyle', 'style', 'hintText', 'textareaStyle', 'valueLink']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var rootStyles = (0, _simpleAssign2.default)(styles.root, style);
	      var textareaStyles = (0, _simpleAssign2.default)(styles.textarea, textareaStyle);
	      var shadowStyles = (0, _simpleAssign2.default)({}, textareaStyles, styles.shadow, shadowStyle);
	
	      if (this.props.hasOwnProperty('valueLink')) {
	        other.value = this.props.valueLink.value;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(rootStyles) },
	        _react2.default.createElement(_reactEventListener2.default, { target: 'window', onResize: this.handleResize }),
	        _react2.default.createElement('textarea', {
	          ref: 'shadow',
	          style: prepareStyles(shadowStyles),
	          tabIndex: '-1',
	          rows: this.props.rows,
	          defaultValue: this.props.defaultValue,
	          readOnly: true,
	          value: this.props.value,
	          valueLink: this.props.valueLink
	        }),
	        _react2.default.createElement('textarea', (0, _extends3.default)({}, other, {
	          ref: 'input',
	          rows: this.props.rows,
	          style: prepareStyles(textareaStyles),
	          onChange: this.handleChange
	        }))
	      );
	    }
	  }]);
	  return EnhancedTextarea;
	}(_react.Component);
	
	EnhancedTextarea.defaultProps = {
	  rows: 1
	};
	EnhancedTextarea.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? EnhancedTextarea.propTypes = {
	  defaultValue: _propTypes2.default.any,
	  disabled: _propTypes2.default.bool,
	  hintText: _propTypes2.default.string,
	  onChange: _propTypes2.default.func,
	  onHeightChange: _propTypes2.default.func,
	  rows: _propTypes2.default.number,
	  rowsMax: _propTypes2.default.number,
	  shadowStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  textareaStyle: _propTypes2.default.object,
	  value: _propTypes2.default.string,
	  valueLink: _propTypes2.default.object
	} : void 0;
	exports.default = EnhancedTextarea;

/***/ },
/* 858 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(68);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _EnhancedTextarea = __webpack_require__(857);
	
	var _EnhancedTextarea2 = _interopRequireDefault(_EnhancedTextarea);
	
	var _TextFieldHint = __webpack_require__(859);
	
	var _TextFieldHint2 = _interopRequireDefault(_TextFieldHint);
	
	var _TextFieldLabel = __webpack_require__(860);
	
	var _TextFieldLabel2 = _interopRequireDefault(_TextFieldLabel);
	
	var _TextFieldUnderline = __webpack_require__(861);
	
	var _TextFieldUnderline2 = _interopRequireDefault(_TextFieldUnderline);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var getStyles = function getStyles(props, context, state) {
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      _context$muiTheme$tex = _context$muiTheme.textField,
	      floatingLabelColor = _context$muiTheme$tex.floatingLabelColor,
	      focusColor = _context$muiTheme$tex.focusColor,
	      textColor = _context$muiTheme$tex.textColor,
	      disabledTextColor = _context$muiTheme$tex.disabledTextColor,
	      backgroundColor = _context$muiTheme$tex.backgroundColor,
	      errorColor = _context$muiTheme$tex.errorColor;
	
	
	  var styles = {
	    root: {
	      fontSize: 16,
	      lineHeight: '24px',
	      width: props.fullWidth ? '100%' : 256,
	      height: (props.rows - 1) * 24 + (props.floatingLabelText ? 72 : 48),
	      display: 'inline-block',
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      fontFamily: baseTheme.fontFamily,
	      transition: _transitions2.default.easeOut('200ms', 'height'),
	      cursor: props.disabled ? 'not-allowed' : 'auto'
	    },
	    error: {
	      position: 'relative',
	      bottom: 2,
	      fontSize: 12,
	      lineHeight: '12px',
	      color: errorColor,
	      transition: _transitions2.default.easeOut()
	    },
	    floatingLabel: {
	      color: props.disabled ? disabledTextColor : floatingLabelColor,
	      pointerEvents: 'none'
	    },
	    input: {
	      padding: 0,
	      position: 'relative',
	      width: '100%',
	      border: 'none',
	      outline: 'none',
	      backgroundColor: 'rgba(0,0,0,0)',
	      color: props.disabled ? disabledTextColor : textColor,
	      cursor: 'inherit',
	      font: 'inherit',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)' },
	    inputNative: {
	      appearance: 'textfield' }
	  };
	
	  styles.textarea = (0, _simpleAssign2.default)({}, styles.input, {
	    marginTop: props.floatingLabelText ? 36 : 12,
	    marginBottom: props.floatingLabelText ? -36 : -12,
	    boxSizing: 'border-box',
	    font: 'inherit'
	  });
	
	  // Do not assign a height to the textarea as he handles it on his own.
	  styles.input.height = '100%';
	
	  if (state.isFocused) {
	    styles.floatingLabel.color = focusColor;
	  }
	
	  if (props.floatingLabelText) {
	    styles.input.boxSizing = 'border-box';
	
	    if (!props.multiLine) {
	      styles.input.marginTop = 14;
	    }
	
	    if (state.errorText) {
	      styles.error.bottom = !props.multiLine ? styles.error.fontSize + 3 : 3;
	    }
	  }
	
	  if (state.errorText) {
	    if (state.isFocused) {
	      styles.floatingLabel.color = styles.error.color;
	    }
	  }
	
	  return styles;
	};
	
	/**
	 * Check if a value is valid to be displayed inside an input.
	 *
	 * @param The value to check.
	 * @returns True if the string provided is valid, false otherwise.
	 */
	function isValid(value) {
	  return value !== '' && value !== undefined && value !== null && !(Array.isArray(value) && value.length === 0);
	}
	
	var TextField = function (_Component) {
	  (0, _inherits3.default)(TextField, _Component);
	
	  function TextField() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TextField);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TextField.__proto__ || (0, _getPrototypeOf2.default)(TextField)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      isFocused: false,
	      errorText: undefined,
	      hasValue: false
	    }, _this.handleInputBlur = function (event) {
	      _this.setState({ isFocused: false });
	      if (_this.props.onBlur) {
	        _this.props.onBlur(event);
	      }
	    }, _this.handleInputChange = function (event) {
	      if (!_this.props.hasOwnProperty('value')) {
	        _this.setState({ hasValue: isValid(event.target.value) });
	      }
	      if (_this.props.onChange) {
	        _this.props.onChange(event, event.target.value);
	      }
	    }, _this.handleInputFocus = function (event) {
	      if (_this.props.disabled) {
	        return;
	      }
	      _this.setState({ isFocused: true });
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleHeightChange = function (event, height) {
	      var newHeight = height + 24;
	      if (_this.props.floatingLabelText) {
	        newHeight += 24;
	      }
	      _reactDom2.default.findDOMNode(_this).style.height = newHeight + 'px';
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TextField, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          children = _props.children,
	          name = _props.name,
	          hintText = _props.hintText,
	          floatingLabelText = _props.floatingLabelText,
	          id = _props.id;
	
	
	      var propsLeaf = children ? children.props : this.props;
	
	      this.setState({
	        errorText: this.props.errorText,
	        hasValue: isValid(propsLeaf.value) || isValid(propsLeaf.defaultValue)
	      });
	
	       false ? (0, _warning2.default)(name || hintText || floatingLabelText || id, 'Material-UI: We don\'t have enough information\n      to build a robust unique id for the TextField component. Please provide an id or a name.') : void 0;
	
	      var uniqueId = name + '-' + hintText + '-' + floatingLabelText + '-' + Math.floor(Math.random() * 0xFFFF);
	      this.uniqueId = uniqueId.replace(/[^A-Za-z0-9-]/gi, '');
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.errorText !== this.props.errorText) {
	        this.setState({
	          errorText: nextProps.errorText
	        });
	      }
	
	      if (nextProps.children && nextProps.children.props) {
	        nextProps = nextProps.children.props;
	      }
	
	      if (nextProps.hasOwnProperty('value')) {
	        var hasValue = isValid(nextProps.value);
	
	        this.setState({
	          hasValue: hasValue
	        });
	      }
	    }
	  }, {
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps, nextState, nextContext) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps) || !(0, _shallowEqual2.default)(this.state, nextState) || !(0, _shallowEqual2.default)(this.context, nextContext);
	    }
	  }, {
	    key: 'blur',
	    value: function blur() {
	      if (this.input) {
	        this.getInputNode().blur();
	      }
	    }
	  }, {
	    key: 'focus',
	    value: function focus() {
	      if (this.input) {
	        this.getInputNode().focus();
	      }
	    }
	  }, {
	    key: 'select',
	    value: function select() {
	      if (this.input) {
	        this.getInputNode().select();
	      }
	    }
	  }, {
	    key: 'getValue',
	    value: function getValue() {
	      return this.input ? this.getInputNode().value : undefined;
	    }
	  }, {
	    key: 'getInputNode',
	    value: function getInputNode() {
	      return this.props.children || this.props.multiLine ? this.input.getInputNode() : _reactDom2.default.findDOMNode(this.input);
	    }
	  }, {
	    key: '_isControlled',
	    value: function _isControlled() {
	      return this.props.hasOwnProperty('value');
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var _props2 = this.props,
	          children = _props2.children,
	          className = _props2.className,
	          disabled = _props2.disabled,
	          errorStyle = _props2.errorStyle,
	          errorText = _props2.errorText,
	          floatingLabelFixed = _props2.floatingLabelFixed,
	          floatingLabelFocusStyle = _props2.floatingLabelFocusStyle,
	          floatingLabelShrinkStyle = _props2.floatingLabelShrinkStyle,
	          floatingLabelStyle = _props2.floatingLabelStyle,
	          floatingLabelText = _props2.floatingLabelText,
	          fullWidth = _props2.fullWidth,
	          hintText = _props2.hintText,
	          hintStyle = _props2.hintStyle,
	          id = _props2.id,
	          inputStyle = _props2.inputStyle,
	          multiLine = _props2.multiLine,
	          onBlur = _props2.onBlur,
	          onChange = _props2.onChange,
	          onFocus = _props2.onFocus,
	          style = _props2.style,
	          type = _props2.type,
	          underlineDisabledStyle = _props2.underlineDisabledStyle,
	          underlineFocusStyle = _props2.underlineFocusStyle,
	          underlineShow = _props2.underlineShow,
	          underlineStyle = _props2.underlineStyle,
	          rows = _props2.rows,
	          rowsMax = _props2.rowsMax,
	          textareaStyle = _props2.textareaStyle,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'className', 'disabled', 'errorStyle', 'errorText', 'floatingLabelFixed', 'floatingLabelFocusStyle', 'floatingLabelShrinkStyle', 'floatingLabelStyle', 'floatingLabelText', 'fullWidth', 'hintText', 'hintStyle', 'id', 'inputStyle', 'multiLine', 'onBlur', 'onChange', 'onFocus', 'style', 'type', 'underlineDisabledStyle', 'underlineFocusStyle', 'underlineShow', 'underlineStyle', 'rows', 'rowsMax', 'textareaStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	      var inputId = id || this.uniqueId;
	
	      var errorTextElement = this.state.errorText && _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)(styles.error, errorStyle)) },
	        this.state.errorText
	      );
	
	      var floatingLabelTextElement = floatingLabelText && _react2.default.createElement(
	        _TextFieldLabel2.default,
	        {
	          muiTheme: this.context.muiTheme,
	          style: (0, _simpleAssign2.default)(styles.floatingLabel, floatingLabelStyle, this.state.isFocused ? floatingLabelFocusStyle : null),
	          shrinkStyle: floatingLabelShrinkStyle,
	          htmlFor: inputId,
	          shrink: this.state.hasValue || this.state.isFocused || floatingLabelFixed,
	          disabled: disabled
	        },
	        floatingLabelText
	      );
	
	      var inputProps = {
	        id: inputId,
	        ref: function ref(elem) {
	          return _this2.input = elem;
	        },
	        disabled: this.props.disabled,
	        onBlur: this.handleInputBlur,
	        onChange: this.handleInputChange,
	        onFocus: this.handleInputFocus
	      };
	
	      var childStyleMerged = (0, _simpleAssign2.default)(styles.input, inputStyle);
	
	      var inputElement = void 0;
	      if (children) {
	        inputElement = _react2.default.cloneElement(children, (0, _extends3.default)({}, inputProps, children.props, {
	          style: (0, _simpleAssign2.default)(childStyleMerged, children.props.style)
	        }));
	      } else {
	        inputElement = multiLine ? _react2.default.createElement(_EnhancedTextarea2.default, (0, _extends3.default)({
	          style: childStyleMerged,
	          textareaStyle: (0, _simpleAssign2.default)(styles.textarea, styles.inputNative, textareaStyle),
	          rows: rows,
	          rowsMax: rowsMax,
	          hintText: hintText
	        }, other, inputProps, {
	          onHeightChange: this.handleHeightChange
	        })) : _react2.default.createElement('input', (0, _extends3.default)({
	          type: type,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.inputNative, childStyleMerged))
	        }, other, inputProps));
	      }
	
	      var rootProps = {};
	
	      if (children) {
	        rootProps = other;
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, rootProps, {
	          className: className,
	          style: prepareStyles((0, _simpleAssign2.default)(styles.root, style))
	        }),
	        floatingLabelTextElement,
	        hintText ? _react2.default.createElement(_TextFieldHint2.default, {
	          muiTheme: this.context.muiTheme,
	          show: !(this.state.hasValue || floatingLabelText && !this.state.isFocused) || !this.state.hasValue && floatingLabelText && floatingLabelFixed && !this.state.isFocused,
	          style: hintStyle,
	          text: hintText
	        }) : null,
	        inputElement,
	        underlineShow ? _react2.default.createElement(_TextFieldUnderline2.default, {
	          disabled: disabled,
	          disabledStyle: underlineDisabledStyle,
	          error: !!this.state.errorText,
	          errorStyle: errorStyle,
	          focus: this.state.isFocused,
	          focusStyle: underlineFocusStyle,
	          muiTheme: this.context.muiTheme,
	          style: underlineStyle
	        }) : null,
	        errorTextElement
	      );
	    }
	  }]);
	  return TextField;
	}(_react.Component);
	
	TextField.defaultProps = {
	  disabled: false,
	  floatingLabelFixed: false,
	  multiLine: false,
	  fullWidth: false,
	  type: 'text',
	  underlineShow: true,
	  rows: 1
	};
	TextField.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TextField.propTypes = {
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * The text string to use for the default value.
	   */
	  defaultValue: _propTypes2.default.any,
	  /**
	   * Disables the text field if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The style object to use to override error styles.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * The error content to display.
	   */
	  errorText: _propTypes2.default.node,
	  /**
	   * If true, the floating label will float even when there is no value.
	   */
	  floatingLabelFixed: _propTypes2.default.bool,
	  /**
	   * The style object to use to override floating label styles when focused.
	   */
	  floatingLabelFocusStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles when shrunk.
	   */
	  floatingLabelShrinkStyle: _propTypes2.default.object,
	  /**
	   * The style object to use to override floating label styles.
	   */
	  floatingLabelStyle: _propTypes2.default.object,
	  /**
	   * The content to use for the floating label element.
	   */
	  floatingLabelText: _propTypes2.default.node,
	  /**
	   * If true, the field receives the property width 100%.
	   */
	  fullWidth: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's hint text element.
	   */
	  hintStyle: _propTypes2.default.object,
	  /**
	   * The hint content to display.
	   */
	  hintText: _propTypes2.default.node,
	  /**
	   * The id prop for the text field.
	   */
	  id: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the TextField's input element.
	   * When multiLine is false: define the style of the input element.
	   * When multiLine is true: define the style of the container of the textarea.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * If true, a textarea element will be rendered.
	   * The textarea also grows and shrinks according to the number of lines.
	   */
	  multiLine: _propTypes2.default.bool,
	  /**
	   * Name applied to the input.
	   */
	  name: _propTypes2.default.string,
	  /** @ignore */
	  onBlur: _propTypes2.default.func,
	  /**
	   * Callback function that is fired when the textfield's value changes.
	   *
	   * @param {object} event Change event targeting the text field.
	   * @param {string} newValue The new value of the text field.
	   */
	  onChange: _propTypes2.default.func,
	  /** @ignore */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Number of rows to display when multiLine option is set to true.
	   */
	  rows: _propTypes2.default.number,
	  /**
	   * Maximum number of rows to display when
	   * multiLine option is set to true.
	   */
	  rowsMax: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's textarea element.
	   * The TextField use either a textarea or an input,
	   * this property has effects only when multiLine is true.
	   */
	  textareaStyle: _propTypes2.default.object,
	  /**
	   * Specifies the type of input to display
	   * such as "password" or "text".
	   */
	  type: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the
	   * TextField's underline element when disabled.
	   */
	  underlineDisabledStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the TextField's
	   * underline element when focussed.
	   */
	  underlineFocusStyle: _propTypes2.default.object,
	  /**
	   * If true, shows the underline for the text field.
	   */
	  underlineShow: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the TextField's underline element.
	   */
	  underlineStyle: _propTypes2.default.object,
	  /**
	   * The value of the text field.
	   */
	  value: _propTypes2.default.any
	} : void 0;
	exports.default = TextField;

/***/ },
/* 859 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var hintColor = props.muiTheme.textField.hintColor,
	      show = props.show;
	
	
	  return {
	    root: {
	      position: 'absolute',
	      opacity: show ? 1 : 0,
	      color: hintColor,
	      transition: _transitions2.default.easeOut(),
	      bottom: 12
	    }
	  };
	}
	
	var TextFieldHint = function TextFieldHint(props) {
	  var prepareStyles = props.muiTheme.prepareStyles,
	      style = props.style,
	      text = props.text;
	
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'div',
	    { style: prepareStyles((0, _simpleAssign2.default)(styles.root, style)) },
	    text
	  );
	};
	
	 false ? TextFieldHint.propTypes = {
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * True if the hint text should be visible.
	   */
	  show: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * The hint text displayed.
	   */
	  text: _propTypes2.default.node
	} : void 0;
	
	TextFieldHint.defaultProps = {
	  show: true
	};
	
	exports.default = TextFieldHint;

/***/ },
/* 860 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props) {
	  var defaultStyles = {
	    position: 'absolute',
	    lineHeight: '22px',
	    top: 38,
	    transition: _transitions2.default.easeOut(),
	    zIndex: 1, // Needed to display label above Chrome's autocomplete field background
	    transform: 'scale(1) translate(0, 0)',
	    transformOrigin: 'left top',
	    pointerEvents: 'auto',
	    userSelect: 'none'
	  };
	
	  var shrinkStyles = props.shrink ? (0, _simpleAssign2.default)({
	    transform: 'scale(0.75) translate(0, -28px)',
	    pointerEvents: 'none'
	  }, props.shrinkStyle) : null;
	
	  return {
	    root: (0, _simpleAssign2.default)(defaultStyles, props.style, shrinkStyles)
	  };
	}
	
	var TextFieldLabel = function TextFieldLabel(props) {
	  var muiTheme = props.muiTheme,
	      className = props.className,
	      children = props.children,
	      htmlFor = props.htmlFor,
	      onTouchTap = props.onTouchTap;
	  var prepareStyles = muiTheme.prepareStyles;
	
	  var styles = getStyles(props);
	
	  return _react2.default.createElement(
	    'label',
	    {
	      className: className,
	      style: prepareStyles(styles.root),
	      htmlFor: htmlFor,
	      onTouchTap: onTouchTap
	    },
	    children
	  );
	};
	
	 false ? TextFieldLabel.propTypes = {
	  /**
	   * The label contents.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Disables the label if set to true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * The id of the target element that this label should refer to.
	   */
	  htmlFor: _propTypes2.default.string,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Callback function for when the label is selected via a touch tap.
	   *
	   * @param {object} event TouchTap event targeting the text field label.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * True if the floating label should shrink.
	   */
	  shrink: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element when shrunk.
	   */
	  shrinkStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	
	TextFieldLabel.defaultProps = {
	  disabled: false,
	  shrink: false
	};
	
	exports.default = TextFieldLabel;

/***/ },
/* 861 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = {
	  /**
	   * True if the parent `TextField` is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is disabled.
	   */
	  disabledStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` has an error.
	   */
	  error: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` has an error.
	   */
	  errorStyle: _propTypes2.default.object,
	  /**
	   * True if the parent `TextField` is focused.
	   */
	  focus: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the underline when parent `TextField` is focused.
	   */
	  focusStyle: _propTypes2.default.object,
	  /**
	   * @ignore
	   * The material-ui theme applied to this component.
	   */
	  muiTheme: _propTypes2.default.object.isRequired,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	};
	
	var defaultProps = {
	  disabled: false,
	  disabledStyle: {},
	  error: false,
	  errorStyle: {},
	  focus: false,
	  focusStyle: {},
	  style: {}
	};
	
	var TextFieldUnderline = function TextFieldUnderline(props) {
	  var disabled = props.disabled,
	      disabledStyle = props.disabledStyle,
	      error = props.error,
	      errorStyle = props.errorStyle,
	      focus = props.focus,
	      focusStyle = props.focusStyle,
	      muiTheme = props.muiTheme,
	      style = props.style;
	  var errorStyleColor = errorStyle.color;
	  var prepareStyles = muiTheme.prepareStyles,
	      _muiTheme$textField = muiTheme.textField,
	      borderColor = _muiTheme$textField.borderColor,
	      disabledTextColor = _muiTheme$textField.disabledTextColor,
	      errorColor = _muiTheme$textField.errorColor,
	      focusColor = _muiTheme$textField.focusColor;
	
	
	  var styles = {
	    root: {
	      borderTop: 'none',
	      borderLeft: 'none',
	      borderRight: 'none',
	      borderBottom: 'solid 1px',
	      borderColor: borderColor,
	      bottom: 8,
	      boxSizing: 'content-box',
	      margin: 0,
	      position: 'absolute',
	      width: '100%'
	    },
	    disabled: {
	      borderBottom: 'dotted 2px',
	      borderColor: disabledTextColor
	    },
	    focus: {
	      borderBottom: 'solid 2px',
	      borderColor: focusColor,
	      transform: 'scaleX(0)',
	      transition: _transitions2.default.easeOut()
	    },
	    error: {
	      borderColor: errorStyleColor ? errorStyleColor : errorColor,
	      transform: 'scaleX(1)'
	    }
	  };
	
	  var underline = (0, _simpleAssign2.default)({}, styles.root, style);
	  var focusedUnderline = (0, _simpleAssign2.default)({}, underline, styles.focus, focusStyle);
	
	  if (disabled) underline = (0, _simpleAssign2.default)({}, underline, styles.disabled, disabledStyle);
	  if (focus) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, { transform: 'scaleX(1)' });
	  if (error) focusedUnderline = (0, _simpleAssign2.default)({}, focusedUnderline, styles.error);
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement('hr', { style: prepareStyles(underline) }),
	    _react2.default.createElement('hr', { style: prepareStyles(focusedUnderline) })
	  );
	};
	
	 false ? TextFieldUnderline.propTypes = propTypes : void 0;
	TextFieldUnderline.defaultProps = defaultProps;
	
	exports.default = TextFieldUnderline;

/***/ },
/* 862 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimeDisplay = __webpack_require__(865);
	
	var _TimeDisplay2 = _interopRequireDefault(_TimeDisplay);
	
	var _ClockHours = __webpack_require__(863);
	
	var _ClockHours2 = _interopRequireDefault(_ClockHours);
	
	var _ClockMinutes = __webpack_require__(864);
	
	var _ClockMinutes2 = _interopRequireDefault(_ClockMinutes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Clock = function (_Component) {
	  (0, _inherits3.default)(Clock, _Component);
	
	  function Clock() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Clock);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Clock.__proto__ || (0, _getPrototypeOf2.default)(Clock)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      selectedTime: null,
	      mode: 'hour'
	    }, _this.setMode = function (mode) {
	      setTimeout(function () {
	        _this.setState({
	          mode: mode
	        });
	      }, 100);
	    }, _this.handleSelectAffix = function (affix) {
	      if (affix === _this.getAffix()) return;
	
	      var hours = _this.state.selectedTime.getHours();
	
	      if (affix === 'am') {
	        _this.handleChangeHours(hours - 12, affix);
	        return;
	      }
	
	      _this.handleChangeHours(hours + 12, affix);
	    }, _this.handleChangeHours = function (hours, finished) {
	      var time = new Date(_this.state.selectedTime);
	      var affix = void 0;
	
	      if (typeof finished === 'string') {
	        affix = finished;
	        finished = undefined;
	      }
	      if (!affix) {
	        affix = _this.getAffix();
	      }
	      if (affix === 'pm' && hours < 12) {
	        hours += 12;
	      }
	
	      time.setHours(hours);
	      _this.setState({
	        selectedTime: time
	      });
	
	      if (finished) {
	        setTimeout(function () {
	          _this.setState({
	            mode: 'minute'
	          });
	
	          var onChangeHours = _this.props.onChangeHours;
	
	          if (onChangeHours) {
	            onChangeHours(time);
	          }
	        }, 100);
	      }
	    }, _this.handleChangeMinutes = function (minutes, finished) {
	      var time = new Date(_this.state.selectedTime);
	      time.setMinutes(minutes);
	      _this.setState({
	        selectedTime: time
	      });
	
	      var onChangeMinutes = _this.props.onChangeMinutes;
	
	      if (onChangeMinutes && finished) {
	        setTimeout(function () {
	          onChangeMinutes(time);
	        }, 0);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Clock, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        selectedTime: this.props.initialTime || new Date()
	      });
	    }
	  }, {
	    key: 'getAffix',
	    value: function getAffix() {
	      if (this.props.format !== 'ampm') return '';
	
	      var hours = this.state.selectedTime.getHours();
	      if (hours < 12) {
	        return 'am';
	      }
	
	      return 'pm';
	    }
	  }, {
	    key: 'getSelectedTime',
	    value: function getSelectedTime() {
	      return this.state.selectedTime;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var clock = null;
	
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          userSelect: 'none'
	        },
	        container: {
	          height: 280,
	          padding: 10,
	          position: 'relative',
	          boxSizing: 'content-box'
	        },
	        circle: {
	          position: 'absolute',
	          top: 20,
	          width: 260,
	          height: 260,
	          borderRadius: '100%',
	          backgroundColor: timePicker.clockCircleColor
	        }
	      };
	
	      if (this.state.mode === 'hour') {
	        clock = _react2.default.createElement(_ClockHours2.default, {
	          key: 'hours',
	          format: this.props.format,
	          onChange: this.handleChangeHours,
	          initialHours: this.state.selectedTime.getHours()
	        });
	      } else {
	        clock = _react2.default.createElement(_ClockMinutes2.default, {
	          key: 'minutes',
	          onChange: this.handleChangeMinutes,
	          initialMinutes: this.state.selectedTime.getMinutes()
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles(styles.root) },
	        _react2.default.createElement(_TimeDisplay2.default, {
	          selectedTime: this.state.selectedTime,
	          mode: this.state.mode,
	          format: this.props.format,
	          affix: this.getAffix(),
	          onSelectAffix: this.handleSelectAffix,
	          onSelectHour: this.setMode.bind(this, 'hour'),
	          onSelectMin: this.setMode.bind(this, 'minute')
	        }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.container) },
	          _react2.default.createElement('div', { style: prepareStyles(styles.circle) }),
	          clock
	        )
	      );
	    }
	  }]);
	  return Clock;
	}(_react.Component);
	
	Clock.defaultProps = {
	  initialTime: new Date()
	};
	Clock.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Clock.propTypes = {
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialTime: _propTypes2.default.object,
	  onChangeHours: _propTypes2.default.func,
	  onChangeMinutes: _propTypes2.default.func
	} : void 0;
	exports.default = Clock;

/***/ },
/* 863 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _ClockNumber = __webpack_require__(366);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(367);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockHours = function (_Component) {
	  (0, _inherits3.default)(ClockHours, _Component);
	
	  function ClockHours() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockHours);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockHours.__proto__ || (0, _getPrototypeOf2.default)(ClockHours)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) return;
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouchMove = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], false);
	    }, _this.handleTouchEnd = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], true);
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockHours, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = _reactDom2.default.findDOMNode(this.refs.mask);
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var hours = this.getHours(event.offsetX, event.offsetY);
	
	      this.props.onChange(hours, finish);
	    }
	  }, {
	    key: 'getHours',
	    value: function getHours(offsetX, offsetY) {
	      var step = 30;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      var delta = Math.pow(x, 2) + Math.pow(y, 2);
	      var distance = Math.sqrt(delta);
	
	      value = value || 12;
	      if (this.props.format === '24hr') {
	        if (distance < 90) {
	          value += 12;
	          value %= 24;
	        }
	      } else {
	        value %= 12;
	      }
	
	      return value;
	    }
	  }, {
	    key: 'getSelected',
	    value: function getSelected() {
	      var hour = this.props.initialHours;
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      return hour;
	    }
	  }, {
	    key: 'getHourNumbers',
	    value: function getHourNumbers() {
	      var _this2 = this;
	
	      var style = {
	        pointerEvents: 'none'
	      };
	      var hourSize = this.props.format === 'ampm' ? 12 : 24;
	
	      var hours = [];
	      for (var i = 1; i <= hourSize; i++) {
	        hours.push(i % 24);
	      }
	
	      return hours.map(function (hour) {
	        var isSelected = _this2.getSelected() === hour;
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: hour,
	          style: style,
	          isSelected: isSelected,
	          type: 'hour',
	          value: hour
	        });
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var hours = this.getSelected();
	      var numbers = this.getHourNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { hasSelected: true, value: hours, type: 'hour' }),
	        numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask', style: prepareStyles(styles.hitMask), onTouchMove: this.handleTouchMove,
	          onTouchEnd: this.handleTouchEnd, onMouseUp: this.handleUp, onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockHours;
	}(_react.Component);
	
	ClockHours.defaultProps = {
	  initialHours: new Date().getHours(),
	  onChange: function onChange() {},
	  format: 'ampm'
	};
	ClockHours.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ClockHours.propTypes = {
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialHours: _propTypes2.default.number,
	  onChange: _propTypes2.default.func
	} : void 0;
	exports.default = ClockHours;

/***/ },
/* 864 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _ClockNumber = __webpack_require__(366);
	
	var _ClockNumber2 = _interopRequireDefault(_ClockNumber);
	
	var _ClockPointer = __webpack_require__(367);
	
	var _ClockPointer2 = _interopRequireDefault(_ClockPointer);
	
	var _timeUtils = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ClockMinutes = function (_Component) {
	  (0, _inherits3.default)(ClockMinutes, _Component);
	
	  function ClockMinutes() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, ClockMinutes);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = ClockMinutes.__proto__ || (0, _getPrototypeOf2.default)(ClockMinutes)).call.apply(_ref, [this].concat(args))), _this), _this.handleUp = function (event) {
	      event.preventDefault();
	      _this.setClock(event.nativeEvent, true);
	    }, _this.handleMove = function (event) {
	      event.preventDefault();
	      if (_this.isMousePressed(event) !== 1) {
	        return;
	      }
	      _this.setClock(event.nativeEvent, false);
	    }, _this.handleTouch = function (event) {
	      event.preventDefault();
	      _this.setClock(event.changedTouches[0], event.type === 'touchend');
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(ClockMinutes, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var clockElement = this.refs.mask;
	
	      this.center = {
	        x: clockElement.offsetWidth / 2,
	        y: clockElement.offsetHeight / 2
	      };
	
	      this.basePoint = {
	        x: this.center.x,
	        y: 0
	      };
	    }
	  }, {
	    key: 'isMousePressed',
	    value: function isMousePressed(event) {
	      if (typeof event.buttons === 'undefined') {
	        return event.nativeEvent.which;
	      }
	      return event.buttons;
	    }
	  }, {
	    key: 'setClock',
	    value: function setClock(event, finish) {
	      if (typeof event.offsetX === 'undefined') {
	        var offset = (0, _timeUtils.getTouchEventOffsetValues)(event);
	
	        event.offsetX = offset.offsetX;
	        event.offsetY = offset.offsetY;
	      }
	
	      var minutes = this.getMinutes(event.offsetX, event.offsetY);
	
	      this.props.onChange(minutes, finish);
	    }
	  }, {
	    key: 'getMinutes',
	    value: function getMinutes(offsetX, offsetY) {
	      var step = 6;
	      var x = offsetX - this.center.x;
	      var y = offsetY - this.center.y;
	      var cx = this.basePoint.x - this.center.x;
	      var cy = this.basePoint.y - this.center.y;
	
	      var atan = Math.atan2(cx, cy) - Math.atan2(x, y);
	
	      var deg = (0, _timeUtils.rad2deg)(atan);
	      deg = Math.round(deg / step) * step;
	      deg %= 360;
	
	      var value = Math.floor(deg / step) || 0;
	
	      return value;
	    }
	  }, {
	    key: 'getMinuteNumbers',
	    value: function getMinuteNumbers() {
	      var minutes = [];
	      for (var i = 0; i < 12; i++) {
	        minutes.push(i * 5);
	      }
	      var selectedMinutes = this.props.initialMinutes;
	      var hasSelected = false;
	
	      var numbers = minutes.map(function (minute) {
	        var isSelected = selectedMinutes === minute;
	        if (isSelected) {
	          hasSelected = true;
	        }
	        return _react2.default.createElement(_ClockNumber2.default, {
	          key: minute,
	          isSelected: isSelected,
	          type: 'minute',
	          value: minute
	        });
	      });
	
	      return {
	        numbers: numbers,
	        hasSelected: hasSelected,
	        selected: selectedMinutes
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var styles = {
	        root: {
	          height: '100%',
	          width: '100%',
	          borderRadius: '100%',
	          position: 'relative',
	          pointerEvents: 'none',
	          boxSizing: 'border-box'
	        },
	
	        hitMask: {
	          height: '100%',
	          width: '100%',
	          pointerEvents: 'auto'
	        }
	      };
	
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var minutes = this.getMinuteNumbers();
	
	      return _react2.default.createElement(
	        'div',
	        { ref: 'clock', style: prepareStyles(styles.root) },
	        _react2.default.createElement(_ClockPointer2.default, { value: minutes.selected, type: 'minute', hasSelected: minutes.hasSelected }),
	        minutes.numbers,
	        _react2.default.createElement('div', {
	          ref: 'mask',
	          style: prepareStyles(styles.hitMask),
	          onTouchMove: this.handleTouch,
	          onTouchEnd: this.handleTouch,
	          onMouseUp: this.handleUp,
	          onMouseMove: this.handleMove
	        })
	      );
	    }
	  }]);
	  return ClockMinutes;
	}(_react.Component);
	
	ClockMinutes.defaultProps = {
	  initialMinutes: new Date().getMinutes(),
	  onChange: function onChange() {}
	};
	ClockMinutes.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ClockMinutes.propTypes = {
	  initialMinutes: _propTypes2.default.number,
	  onChange: _propTypes2.default.func
	} : void 0;
	exports.default = ClockMinutes;

/***/ },
/* 865 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _slicedToArray2 = __webpack_require__(164);
	
	var _slicedToArray3 = _interopRequireDefault(_slicedToArray2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimeDisplay = function (_Component) {
	  (0, _inherits3.default)(TimeDisplay, _Component);
	
	  function TimeDisplay() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimeDisplay);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimeDisplay.__proto__ || (0, _getPrototypeOf2.default)(TimeDisplay)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      transitionDirection: 'up'
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimeDisplay, [{
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.selectedTime !== this.props.selectedTime) {
	        var direction = nextProps.selectedTime > this.props.selectedTime ? 'up' : 'down';
	
	        this.setState({
	          transitionDirection: direction
	        });
	      }
	    }
	  }, {
	    key: 'sanitizeTime',
	    value: function sanitizeTime() {
	      var hour = this.props.selectedTime.getHours();
	      var min = this.props.selectedTime.getMinutes().toString();
	
	      if (this.props.format === 'ampm') {
	        hour %= 12;
	        hour = hour || 12;
	      }
	
	      hour = hour.toString();
	      if (hour.length < 2) hour = '0' + hour;
	      if (min.length < 2) min = '0' + min;
	
	      return [hour, min];
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          affix = _props.affix,
	          format = _props.format,
	          mode = _props.mode,
	          onSelectAffix = _props.onSelectAffix,
	          onSelectHour = _props.onSelectHour,
	          onSelectMin = _props.onSelectMin,
	          selectedTime = _props.selectedTime,
	          other = (0, _objectWithoutProperties3.default)(_props, ['affix', 'format', 'mode', 'onSelectAffix', 'onSelectHour', 'onSelectMin', 'selectedTime']);
	      var _context$muiTheme = this.context.muiTheme,
	          prepareStyles = _context$muiTheme.prepareStyles,
	          timePicker = _context$muiTheme.timePicker;
	
	
	      var styles = {
	        root: {
	          padding: '14px 0',
	          borderTopLeftRadius: 2,
	          borderTopRightRadius: 2,
	          backgroundColor: timePicker.headerColor,
	          color: timePicker.textColor
	        },
	        text: {
	          margin: '6px 0',
	          lineHeight: '58px',
	          height: 58,
	          fontSize: 58,
	          display: 'flex',
	          justifyContent: 'center',
	          alignItems: 'baseline'
	        },
	        time: {
	          margin: '0 10px'
	        },
	        affix: {
	          flex: 1,
	          position: 'relative',
	          lineHeight: '17px',
	          height: 17,
	          fontSize: 17
	        },
	        affixTop: {
	          position: 'absolute',
	          top: -20,
	          left: 0
	        },
	        clickable: {
	          cursor: 'pointer'
	        },
	        inactive: {
	          opacity: 0.7
	        }
	      };
	
	      var _sanitizeTime = this.sanitizeTime(),
	          _sanitizeTime2 = (0, _slicedToArray3.default)(_sanitizeTime, 2),
	          hour = _sanitizeTime2[0],
	          min = _sanitizeTime2[1];
	
	      var buttons = [];
	      if (format === 'ampm') {
	        buttons = [_react2.default.createElement(
	          'div',
	          {
	            key: 'pm',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, affix === 'pm' ? {} : styles.inactive)),
	            onTouchTap: function onTouchTap() {
	              return onSelectAffix('pm');
	            }
	          },
	          'PM'
	        ), _react2.default.createElement(
	          'div',
	          {
	            key: 'am',
	            style: prepareStyles((0, _simpleAssign2.default)({}, styles.affixTop, styles.clickable, affix === 'am' ? {} : styles.inactive)),
	            onTouchTap: function onTouchTap() {
	              return onSelectAffix('am');
	            }
	          },
	          'AM'
	        )];
	      }
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(styles.root) }),
	        _react2.default.createElement(
	          'div',
	          { style: prepareStyles(styles.text) },
	          _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) }),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles(styles.time) },
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'hour' ? {} : styles.inactive)),
	                onTouchTap: onSelectHour
	              },
	              hour
	            ),
	            _react2.default.createElement(
	              'span',
	              null,
	              ':'
	            ),
	            _react2.default.createElement(
	              'span',
	              {
	                style: prepareStyles((0, _simpleAssign2.default)({}, styles.clickable, mode === 'minute' ? {} : styles.inactive)),
	                onTouchTap: onSelectMin
	              },
	              min
	            )
	          ),
	          _react2.default.createElement(
	            'div',
	            { style: prepareStyles((0, _simpleAssign2.default)({}, styles.affix)) },
	            buttons
	          )
	        )
	      );
	    }
	  }]);
	  return TimeDisplay;
	}(_react.Component);
	
	TimeDisplay.defaultProps = {
	  affix: '',
	  mode: 'hour'
	};
	TimeDisplay.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TimeDisplay.propTypes = {
	  affix: _propTypes2.default.oneOf(['', 'pm', 'am']),
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  mode: _propTypes2.default.oneOf(['hour', 'minute']),
	  onSelectAffix: _propTypes2.default.func,
	  onSelectHour: _propTypes2.default.func,
	  onSelectMin: _propTypes2.default.func,
	  selectedTime: _propTypes2.default.object.isRequired
	} : void 0;
	exports.default = TimeDisplay;

/***/ },
/* 866 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _TimePickerDialog = __webpack_require__(867);
	
	var _TimePickerDialog2 = _interopRequireDefault(_TimePickerDialog);
	
	var _TextField = __webpack_require__(115);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _timeUtils = __webpack_require__(116);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var emptyTime = new Date();
	emptyTime.setHours(0);
	emptyTime.setMinutes(0);
	emptyTime.setSeconds(0);
	emptyTime.setMilliseconds(0);
	
	var TimePicker = function (_Component) {
	  (0, _inherits3.default)(TimePicker, _Component);
	
	  function TimePicker() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePicker);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePicker.__proto__ || (0, _getPrototypeOf2.default)(TimePicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      time: null,
	      dialogTime: new Date()
	    }, _this.handleAcceptDialog = function (time) {
	      _this.setState({
	        time: time
	      });
	      if (_this.props.onChange) _this.props.onChange(null, time);
	    }, _this.handleFocusInput = function (event) {
	      event.target.blur();
	      if (_this.props.onFocus) {
	        _this.props.onFocus(event);
	      }
	    }, _this.handleTouchTapInput = function (event) {
	      event.preventDefault();
	
	      if (!_this.props.disabled) {
	        _this.openDialog();
	      }
	
	      if (_this.props.onTouchTap) {
	        _this.props.onTouchTap(event);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePicker, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      this.setState({
	        time: this.isControlled() ? this.getControlledTime() : this.props.defaultTime
	      });
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (nextProps.value !== this.props.value) {
	        this.setState({
	          time: this.getControlledTime(nextProps)
	        });
	      }
	    }
	
	    /**
	     * Alias for `openDialog()` for an api consistent with TextField.
	     */
	
	  }, {
	    key: 'focus',
	    value: function focus() {
	      this.openDialog();
	    }
	  }, {
	    key: 'openDialog',
	    value: function openDialog() {
	      this.setState({
	        dialogTime: this.state.time
	      });
	      this.refs.dialogWindow.show();
	    }
	  }, {
	    key: 'isControlled',
	    value: function isControlled() {
	      return this.props.value !== null;
	    }
	  }, {
	    key: 'getControlledTime',
	    value: function getControlledTime() {
	      var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this.props;
	
	      var result = null;
	      if (props.value instanceof Date) {
	        result = props.value;
	      }
	      return result;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          autoOk = _props.autoOk,
	          cancelLabel = _props.cancelLabel,
	          defaultTime = _props.defaultTime,
	          dialogBodyStyle = _props.dialogBodyStyle,
	          dialogStyle = _props.dialogStyle,
	          format = _props.format,
	          okLabel = _props.okLabel,
	          onFocus = _props.onFocus,
	          onTouchTap = _props.onTouchTap,
	          onShow = _props.onShow,
	          onDismiss = _props.onDismiss,
	          pedantic = _props.pedantic,
	          style = _props.style,
	          textFieldStyle = _props.textFieldStyle,
	          other = (0, _objectWithoutProperties3.default)(_props, ['autoOk', 'cancelLabel', 'defaultTime', 'dialogBodyStyle', 'dialogStyle', 'format', 'okLabel', 'onFocus', 'onTouchTap', 'onShow', 'onDismiss', 'pedantic', 'style', 'textFieldStyle']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	      var time = this.state.time;
	
	
	      return _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, style)) },
	        _react2.default.createElement(_TextField2.default, (0, _extends3.default)({}, other, {
	          style: textFieldStyle,
	          ref: 'input',
	          value: time === emptyTime ? null : (0, _timeUtils.formatTime)(time, format, pedantic),
	          onFocus: this.handleFocusInput,
	          onTouchTap: this.handleTouchTapInput
	        })),
	        _react2.default.createElement(_TimePickerDialog2.default, {
	          ref: 'dialogWindow',
	          bodyStyle: dialogBodyStyle,
	          initialTime: this.state.dialogTime,
	          onAccept: this.handleAcceptDialog,
	          onShow: onShow,
	          onDismiss: onDismiss,
	          format: format,
	          okLabel: okLabel,
	          cancelLabel: cancelLabel,
	          autoOk: autoOk,
	          style: dialogStyle
	        })
	      );
	    }
	  }]);
	  return TimePicker;
	}(_react.Component);
	
	TimePicker.defaultProps = {
	  autoOk: false,
	  cancelLabel: 'Cancel',
	  defaultTime: null,
	  disabled: false,
	  format: 'ampm',
	  okLabel: 'OK',
	  pedantic: false,
	  style: {},
	  value: null
	};
	TimePicker.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TimePicker.propTypes = {
	  /**
	   * If true, automatically accept and close the picker on set minutes.
	   */
	  autoOk: _propTypes2.default.bool,
	  /**
	   * Override the label of the 'Cancel' button.
	   */
	  cancelLabel: _propTypes2.default.node,
	  /**
	   * The initial time value of the TimePicker.
	   */
	  defaultTime: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's body element.
	   */
	  dialogBodyStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePickerDialog's root element.
	   */
	  dialogStyle: _propTypes2.default.object,
	  /**
	   * If true, the TimePicker is disabled.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Tells the component to display the picker in `ampm` (12hr) format or `24hr` format.
	   */
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  /**
	   * Override the label of the 'OK' button.
	   */
	  okLabel: _propTypes2.default.node,
	  /**
	   * Callback function that is fired when the time value changes. The time value is passed in a Date Object.
	   * Since there is no particular event associated with the change the first argument will always be null
	   * and the second argument will be the new Date instance.
	   */
	  onChange: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker dialog is dismissed.
	   */
	  onDismiss: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker `TextField` gains focus.
	   */
	  onFocus: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker dialog is shown.
	   */
	  onShow: _propTypes2.default.func,
	  /**
	   * Callback function fired when the TimePicker is tapped or clicked.
	   */
	  onTouchTap: _propTypes2.default.func,
	  /**
	   * If true, uses ("noon" / "midnight") instead of ("12 a.m." / "12 p.m.").
	   *
	   * It's technically more correct to refer to "12 noon" and "12 midnight" rather than "12 a.m." and "12 p.m."
	   * and it avoids confusion between different locales. By default (for compatibility reasons) TimePicker uses
	   * ("12 a.m." / "12 p.m.").
	   */
	  pedantic: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of TimePicker's TextField element.
	   */
	  textFieldStyle: _propTypes2.default.object,
	  /**
	   * Sets the time for the Time Picker programmatically.
	   */
	  value: _propTypes2.default.object
	} : void 0;
	exports.default = TimePicker;

/***/ },
/* 867 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactEventListener = __webpack_require__(44);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	var _keycode = __webpack_require__(27);
	
	var _keycode2 = _interopRequireDefault(_keycode);
	
	var _Clock = __webpack_require__(862);
	
	var _Clock2 = _interopRequireDefault(_Clock);
	
	var _Dialog = __webpack_require__(212);
	
	var _Dialog2 = _interopRequireDefault(_Dialog);
	
	var _FlatButton = __webpack_require__(148);
	
	var _FlatButton2 = _interopRequireDefault(_FlatButton);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var TimePickerDialog = function (_Component) {
	  (0, _inherits3.default)(TimePickerDialog, _Component);
	
	  function TimePickerDialog() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, TimePickerDialog);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = TimePickerDialog.__proto__ || (0, _getPrototypeOf2.default)(TimePickerDialog)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      open: false
	    }, _this.handleRequestClose = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapCancel = function () {
	      _this.dismiss();
	    }, _this.handleTouchTapOK = function () {
	      if (_this.props.onAccept) {
	        _this.props.onAccept(_this.refs.clock.getSelectedTime());
	      }
	      _this.setState({
	        open: false
	      });
	    }, _this.handleKeyUp = function (event) {
	      switch ((0, _keycode2.default)(event)) {
	        case 'enter':
	          _this.handleTouchTapOK();
	          break;
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(TimePickerDialog, [{
	    key: 'show',
	    value: function show() {
	      if (this.props.onShow && !this.state.open) this.props.onShow();
	      this.setState({
	        open: true
	      });
	    }
	  }, {
	    key: 'dismiss',
	    value: function dismiss() {
	      if (this.props.onDismiss && this.state.open) this.props.onDismiss();
	      this.setState({
	        open: false
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          bodyStyle = _props.bodyStyle,
	          initialTime = _props.initialTime,
	          onAccept = _props.onAccept,
	          format = _props.format,
	          autoOk = _props.autoOk,
	          okLabel = _props.okLabel,
	          cancelLabel = _props.cancelLabel,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['bodyStyle', 'initialTime', 'onAccept', 'format', 'autoOk', 'okLabel', 'cancelLabel', 'style']);
	
	
	      var styles = {
	        root: {
	          fontSize: 14,
	          color: this.context.muiTheme.timePicker.clockColor
	        },
	        dialogContent: {
	          width: 280
	        },
	        body: {
	          padding: 0
	        }
	      };
	
	      var actions = [_react2.default.createElement(_FlatButton2.default, {
	        key: 0,
	        label: cancelLabel,
	        primary: true,
	        onTouchTap: this.handleTouchTapCancel
	      }), _react2.default.createElement(_FlatButton2.default, {
	        key: 1,
	        label: okLabel,
	        primary: true,
	        onTouchTap: this.handleTouchTapOK
	      })];
	
	      var onClockChangeMinutes = autoOk === true ? this.handleTouchTapOK : undefined;
	      var open = this.state.open;
	
	      return _react2.default.createElement(
	        _Dialog2.default,
	        (0, _extends3.default)({}, other, {
	          style: (0, _simpleAssign2.default)(styles.root, style),
	          bodyStyle: (0, _simpleAssign2.default)(styles.body, bodyStyle),
	          actions: actions,
	          contentStyle: styles.dialogContent,
	          repositionOnUpdate: false,
	          open: open,
	          onRequestClose: this.handleRequestClose
	        }),
	        open && _react2.default.createElement(_reactEventListener2.default, { target: 'window', onKeyUp: this.handleKeyUp }),
	        open && _react2.default.createElement(_Clock2.default, {
	          ref: 'clock',
	          format: format,
	          initialTime: initialTime,
	          onChangeMinutes: onClockChangeMinutes
	        })
	      );
	    }
	  }]);
	  return TimePickerDialog;
	}(_react.Component);
	
	TimePickerDialog.defaultProps = {
	  okLabel: 'OK',
	  cancelLabel: 'Cancel'
	};
	TimePickerDialog.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? TimePickerDialog.propTypes = {
	  autoOk: _propTypes2.default.bool,
	  bodyStyle: _propTypes2.default.object,
	  cancelLabel: _propTypes2.default.node,
	  format: _propTypes2.default.oneOf(['ampm', '24hr']),
	  initialTime: _propTypes2.default.object,
	  okLabel: _propTypes2.default.node,
	  onAccept: _propTypes2.default.func,
	  onDismiss: _propTypes2.default.func,
	  onShow: _propTypes2.default.func,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = TimePickerDialog;

/***/ },
/* 868 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _TimePicker = __webpack_require__(866);
	
	var _TimePicker2 = _interopRequireDefault(_TimePicker);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _TimePicker2.default;

/***/ },
/* 869 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _EnhancedSwitch = __webpack_require__(221);
	
	var _EnhancedSwitch2 = _interopRequireDefault(_EnhancedSwitch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context, state) {
	  var disabled = props.disabled,
	      elementStyle = props.elementStyle,
	      trackSwitchedStyle = props.trackSwitchedStyle,
	      thumbSwitchedStyle = props.thumbSwitchedStyle,
	      trackStyle = props.trackStyle,
	      thumbStyle = props.thumbStyle,
	      iconStyle = props.iconStyle,
	      rippleStyle = props.rippleStyle,
	      labelStyle = props.labelStyle;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toggle = _context$muiTheme.toggle;
	
	
	  var toggleSize = 20;
	  var toggleTrackWidth = 36;
	  var styles = {
	    icon: {
	      width: 36,
	      padding: '4px 0px 6px 2px'
	    },
	    ripple: {
	      top: -10,
	      left: -10,
	      color: state.switched ? toggle.thumbOnColor : baseTheme.palette.textColor
	    },
	    toggleElement: {
	      width: toggleTrackWidth
	    },
	    track: {
	      transition: _transitions2.default.easeOut(),
	      width: '100%',
	      height: 14,
	      borderRadius: 30,
	      backgroundColor: toggle.trackOffColor
	    },
	    thumb: {
	      transition: _transitions2.default.easeOut(),
	      position: 'absolute',
	      top: 1,
	      left: 0,
	      width: toggleSize,
	      height: toggleSize,
	      lineHeight: '24px',
	      borderRadius: '50%',
	      backgroundColor: toggle.thumbOffColor
	    },
	    trackWhenSwitched: {
	      backgroundColor: toggle.trackOnColor
	    },
	    thumbWhenSwitched: {
	      backgroundColor: toggle.thumbOnColor,
	      left: '100%'
	    },
	    trackWhenDisabled: {
	      backgroundColor: toggle.trackDisabledColor
	    },
	    thumbWhenDisabled: {
	      backgroundColor: toggle.thumbDisabledColor
	    },
	    label: {
	      color: disabled ? toggle.labelDisabledColor : toggle.labelColor,
	      width: 'calc(100% - ' + (toggleTrackWidth + 10) + 'px)'
	    }
	  };
	
	  (0, _simpleAssign2.default)(styles.track, trackStyle, state.switched && styles.trackWhenSwitched, state.switched && trackSwitchedStyle, disabled && styles.trackWhenDisabled);
	
	  (0, _simpleAssign2.default)(styles.thumb, thumbStyle, state.switched && styles.thumbWhenSwitched, state.switched && thumbSwitchedStyle, disabled && styles.thumbWhenDisabled);
	
	  if (state.switched) {
	    styles.thumb.marginLeft = 0 - styles.thumb.width;
	  }
	
	  (0, _simpleAssign2.default)(styles.icon, iconStyle);
	
	  (0, _simpleAssign2.default)(styles.ripple, rippleStyle);
	
	  (0, _simpleAssign2.default)(styles.label, labelStyle);
	
	  (0, _simpleAssign2.default)(styles.toggleElement, elementStyle);
	
	  return styles;
	}
	
	var Toggle = function (_Component) {
	  (0, _inherits3.default)(Toggle, _Component);
	
	  function Toggle() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, Toggle);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Toggle.__proto__ || (0, _getPrototypeOf2.default)(Toggle)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	      switched: false
	    }, _this.handleStateChange = function (newSwitched) {
	      _this.setState({
	        switched: newSwitched
	      });
	    }, _this.handleToggle = function (event, isInputChecked) {
	      if (_this.props.onToggle) {
	        _this.props.onToggle(event, isInputChecked);
	      }
	    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(Toggle, [{
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _props = this.props,
	          toggled = _props.toggled,
	          defaultToggled = _props.defaultToggled,
	          valueLink = _props.valueLink;
	
	
	      if (toggled || defaultToggled || valueLink && valueLink.value) {
	        this.setState({
	          switched: true
	        });
	      }
	    }
	  }, {
	    key: 'isToggled',
	    value: function isToggled() {
	      return this.refs.enhancedSwitch.isSwitched();
	    }
	  }, {
	    key: 'setToggled',
	    value: function setToggled(newToggledValue) {
	      this.refs.enhancedSwitch.setSwitched(newToggledValue);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          defaultToggled = _props2.defaultToggled,
	          elementStyle = _props2.elementStyle,
	          onToggle = _props2.onToggle,
	          trackSwitchedStyle = _props2.trackSwitchedStyle,
	          thumbSwitchedStyle = _props2.thumbSwitchedStyle,
	          toggled = _props2.toggled,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['defaultToggled', 'elementStyle', 'onToggle', 'trackSwitchedStyle', 'thumbSwitchedStyle', 'toggled']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context, this.state);
	
	      var toggleElement = _react2.default.createElement(
	        'div',
	        { style: prepareStyles((0, _simpleAssign2.default)({}, styles.toggleElement)) },
	        _react2.default.createElement('div', { style: prepareStyles((0, _simpleAssign2.default)({}, styles.track)) }),
	        _react2.default.createElement(_Paper2.default, { style: styles.thumb, circle: true, zDepth: 1 })
	      );
	
	      var enhancedSwitchProps = {
	        ref: 'enhancedSwitch',
	        inputType: 'checkbox',
	        switchElement: toggleElement,
	        rippleStyle: styles.ripple,
	        rippleColor: styles.ripple.color,
	        iconStyle: styles.icon,
	        trackStyle: styles.track,
	        thumbStyle: styles.thumb,
	        labelStyle: styles.label,
	        switched: this.state.switched,
	        onSwitch: this.handleToggle,
	        onParentShouldUpdate: this.handleStateChange,
	        labelPosition: this.props.labelPosition
	      };
	
	      if (this.props.hasOwnProperty('toggled')) {
	        enhancedSwitchProps.checked = toggled;
	      } else if (this.props.hasOwnProperty('defaultToggled')) {
	        enhancedSwitchProps.defaultChecked = defaultToggled;
	      }
	
	      return _react2.default.createElement(_EnhancedSwitch2.default, (0, _extends3.default)({}, other, enhancedSwitchProps));
	    }
	  }]);
	  return Toggle;
	}(_react.Component);
	
	Toggle.defaultProps = {
	  defaultToggled: false,
	  disabled: false,
	  labelPosition: 'left'
	};
	Toggle.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Toggle.propTypes = {
	  /**
	   * Determines whether the Toggle is initially turned on.
	   * **Warning:** This cannot be used in conjunction with `toggled`.
	   * Decide between using a controlled or uncontrolled input element and remove one of these props.
	   * More info: https://fb.me/react-controlled-components
	   */
	  defaultToggled: _propTypes2.default.bool,
	  /**
	   * Will disable the toggle if true.
	   */
	  disabled: _propTypes2.default.bool,
	  /**
	   * Overrides the inline-styles of the Toggle element.
	   */
	  elementStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the Icon element.
	   */
	  iconStyle: _propTypes2.default.object,
	  /**
	   * Overrides the inline-styles of the input element.
	   */
	  inputStyle: _propTypes2.default.object,
	  /**
	   * Label for toggle.
	   */
	  label: _propTypes2.default.node,
	  /**
	   * Where the label will be placed next to the toggle.
	   */
	  labelPosition: _propTypes2.default.oneOf(['left', 'right']),
	  /**
	   * Overrides the inline-styles of the Toggle element label.
	   */
	  labelStyle: _propTypes2.default.object,
	  /**
	   * Callback function that is fired when the toggle switch is toggled.
	   *
	   * @param {object} event Change event targeting the toggle.
	   * @param {bool} isInputChecked The new value of the toggle.
	   */
	  onToggle: _propTypes2.default.func,
	  /**
	   * Override style of ripple.
	   */
	  rippleStyle: _propTypes2.default.object,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object,
	  /**
	   * Override style for thumb.
	   */
	  thumbStyle: _propTypes2.default.object,
	  /**
	  * Override the inline styles for thumb when the toggle switch is toggled on.
	  */
	  thumbSwitchedStyle: _propTypes2.default.object,
	  /**
	   * Toggled if set to true.
	   */
	  toggled: _propTypes2.default.bool,
	  /**
	   * Override style for track.
	   */
	  trackStyle: _propTypes2.default.object,
	  /**
	  * Override the inline styles for track when the toggle switch is toggled on.
	  */
	  trackSwitchedStyle: _propTypes2.default.object,
	  /**
	   * ValueLink prop for when using controlled toggle.
	   */
	  valueLink: _propTypes2.default.object
	} : void 0;
	exports.default = Toggle;

/***/ },
/* 870 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = undefined;
	
	var _Toggle = __webpack_require__(869);
	
	var _Toggle2 = _interopRequireDefault(_Toggle);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Toggle2.default;

/***/ },
/* 871 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function getStyles(props, context) {
	  var noGutter = props.noGutter;
	  var _context$muiTheme = context.muiTheme,
	      baseTheme = _context$muiTheme.baseTheme,
	      toolbar = _context$muiTheme.toolbar;
	
	
	  return {
	    root: {
	      boxSizing: 'border-box',
	      WebkitTapHighlightColor: 'rgba(0,0,0,0)', // Remove mobile color flashing (deprecated)
	      backgroundColor: toolbar.backgroundColor,
	      height: toolbar.height,
	      padding: noGutter ? 0 : '0px ' + baseTheme.spacing.desktopGutter + 'px',
	      display: 'flex',
	      justifyContent: 'space-between'
	    }
	  };
	}
	
	var Toolbar = function (_Component) {
	  (0, _inherits3.default)(Toolbar, _Component);
	
	  function Toolbar() {
	    (0, _classCallCheck3.default)(this, Toolbar);
	    return (0, _possibleConstructorReturn3.default)(this, (Toolbar.__proto__ || (0, _getPrototypeOf2.default)(Toolbar)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(Toolbar, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          className = _props.className,
	          noGutter = _props.noGutter,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'className', 'noGutter', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	      var styles = getStyles(this.props, this.context);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { className: className, style: prepareStyles((0, _simpleAssign2.default)({}, styles.root, style)) }),
	        children
	      );
	    }
	  }]);
	  return Toolbar;
	}(_react.Component);
	
	Toolbar.defaultProps = {
	  noGutter: false
	};
	Toolbar.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? Toolbar.propTypes = {
	  /**
	   * Can be a `ToolbarGroup` to render a group of related items.
	   */
	  children: _propTypes2.default.node,
	  /**
	   * The css class name of the root element.
	   */
	  className: _propTypes2.default.string,
	  /**
	   * Do not apply `desktopGutter` to the `Toolbar`.
	   */
	  noGutter: _propTypes2.default.bool,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = Toolbar;

/***/ },
/* 872 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.ToolbarTitle = exports.ToolbarSeparator = exports.ToolbarGroup = exports.Toolbar = undefined;
	
	var _Toolbar2 = __webpack_require__(871);
	
	var _Toolbar3 = _interopRequireDefault(_Toolbar2);
	
	var _ToolbarGroup2 = __webpack_require__(368);
	
	var _ToolbarGroup3 = _interopRequireDefault(_ToolbarGroup2);
	
	var _ToolbarSeparator2 = __webpack_require__(369);
	
	var _ToolbarSeparator3 = _interopRequireDefault(_ToolbarSeparator2);
	
	var _ToolbarTitle2 = __webpack_require__(370);
	
	var _ToolbarTitle3 = _interopRequireDefault(_ToolbarTitle2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.Toolbar = _Toolbar3.default;
	exports.ToolbarGroup = _ToolbarGroup3.default;
	exports.ToolbarSeparator = _ToolbarSeparator3.default;
	exports.ToolbarTitle = _ToolbarTitle3.default;
	exports.default = _Toolbar3.default;

/***/ },
/* 873 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var originalBodyOverflow = null;
	var lockingCounter = 0;
	
	var AutoLockScrolling = function (_Component) {
	  (0, _inherits3.default)(AutoLockScrolling, _Component);
	
	  function AutoLockScrolling() {
	    var _ref;
	
	    var _temp, _this, _ret;
	
	    (0, _classCallCheck3.default)(this, AutoLockScrolling);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = AutoLockScrolling.__proto__ || (0, _getPrototypeOf2.default)(AutoLockScrolling)).call.apply(_ref, [this].concat(args))), _this), _this.locked = false, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	  }
	
	  (0, _createClass3.default)(AutoLockScrolling, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      if (this.props.lock === true) {
	        this.preventScrolling();
	      }
	    }
	  }, {
	    key: 'componentWillReceiveProps',
	    value: function componentWillReceiveProps(nextProps) {
	      if (this.props.lock !== nextProps.lock) {
	        if (nextProps.lock) {
	          this.preventScrolling();
	        } else {
	          this.allowScrolling();
	        }
	      }
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.allowScrolling();
	    }
	
	    // force to only lock/unlock once
	
	  }, {
	    key: 'preventScrolling',
	    value: function preventScrolling() {
	      if (this.locked === true) {
	        return;
	      }
	
	      lockingCounter = lockingCounter + 1;
	      this.locked = true;
	
	      // only lock the first time the component is mounted.
	      if (lockingCounter === 1) {
	        var body = document.getElementsByTagName('body')[0];
	        originalBodyOverflow = body.style.overflow;
	        body.style.overflow = 'hidden';
	      }
	    }
	  }, {
	    key: 'allowScrolling',
	    value: function allowScrolling() {
	      if (this.locked === true) {
	        lockingCounter = lockingCounter - 1;
	        this.locked = false;
	      }
	
	      if (lockingCounter === 0 && originalBodyOverflow !== null) {
	        var body = document.getElementsByTagName('body')[0];
	        body.style.overflow = originalBodyOverflow || '';
	        originalBodyOverflow = null;
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	  return AutoLockScrolling;
	}(_react.Component);
	
	 false ? AutoLockScrolling.propTypes = {
	  lock: _propTypes2.default.bool.isRequired
	} : void 0;
	exports.default = AutoLockScrolling;

/***/ },
/* 874 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  BeforeAfterWrapper
	 *    An alternative for the ::before and ::after css pseudo-elements for
	 *    components whose styles are defined in javascript instead of css.
	 *
	 *  Usage: For the element that we want to apply before and after elements to,
	 *    wrap its children with BeforeAfterWrapper. For example:
	 *
	 *                                            <Paper>
	 *  <Paper>                                     <div> // See notice
	 *    <BeforeAfterWrapper>        renders         <div/> // before element
	 *      [children of paper]       ------>         [children of paper]
	 *    </BeforeAfterWrapper>                       <div/> // after element
	 *  </Paper>                                    </div>
	 *                                            </Paper>
	 *
	 *  Notice: Notice that this div bundles together our elements. If the element
	 *    that we want to apply before and after elements is a HTML tag (i.e. a
	 *    div, p, or button tag), we can avoid this extra nesting by passing using
	 *    the BeforeAfterWrapper in place of said tag like so:
	 *
	 *  <p>
	 *    <BeforeAfterWrapper>   do this instead   <BeforeAfterWrapper elementType='p'>
	 *      [children of p]          ------>         [children of p]
	 *    </BeforeAfterWrapper>                    </BeforeAfterWrapper>
	 *  </p>
	 *
	 *  BeforeAfterWrapper features spread functionality. This means that we can
	 *  pass HTML tag properties directly into the BeforeAfterWrapper tag.
	 *
	 *  When using BeforeAfterWrapper, ensure that the parent of the beforeElement
	 *  and afterElement have a defined style position.
	 */
	
	var styles = {
	  box: {
	    boxSizing: 'border-box'
	  }
	};
	
	var BeforeAfterWrapper = function (_Component) {
	  (0, _inherits3.default)(BeforeAfterWrapper, _Component);
	
	  function BeforeAfterWrapper() {
	    (0, _classCallCheck3.default)(this, BeforeAfterWrapper);
	    return (0, _possibleConstructorReturn3.default)(this, (BeforeAfterWrapper.__proto__ || (0, _getPrototypeOf2.default)(BeforeAfterWrapper)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(BeforeAfterWrapper, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          beforeStyle = _props.beforeStyle,
	          afterStyle = _props.afterStyle,
	          beforeElementType = _props.beforeElementType,
	          afterElementType = _props.afterElementType,
	          elementType = _props.elementType,
	          other = (0, _objectWithoutProperties3.default)(_props, ['beforeStyle', 'afterStyle', 'beforeElementType', 'afterElementType', 'elementType']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var beforeElement = void 0;
	      var afterElement = void 0;
	
	      if (beforeStyle) {
	        beforeElement = _react2.default.createElement(this.props.beforeElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, beforeStyle)),
	          key: '::before'
	        });
	      }
	
	      if (afterStyle) {
	        afterElement = _react2.default.createElement(this.props.afterElementType, {
	          style: prepareStyles((0, _simpleAssign2.default)({}, styles.box, afterStyle)),
	          key: '::after'
	        });
	      }
	
	      var children = [beforeElement, this.props.children, afterElement];
	
	      var props = other;
	      props.style = prepareStyles((0, _simpleAssign2.default)({}, this.props.style));
	
	      return _react2.default.createElement(this.props.elementType, props, children);
	    }
	  }]);
	  return BeforeAfterWrapper;
	}(_react.Component);
	
	BeforeAfterWrapper.defaultProps = {
	  beforeElementType: 'div',
	  afterElementType: 'div',
	  elementType: 'div'
	};
	BeforeAfterWrapper.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? BeforeAfterWrapper.propTypes = {
	  afterElementType: _propTypes2.default.string,
	  afterStyle: _propTypes2.default.object,
	  beforeElementType: _propTypes2.default.string,
	  beforeStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  elementType: _propTypes2.default.string,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = BeforeAfterWrapper;

/***/ },
/* 875 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _shallowEqual = __webpack_require__(68);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _autoPrefix = __webpack_require__(64);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CircleRipple = function (_Component) {
	  (0, _inherits3.default)(CircleRipple, _Component);
	
	  function CircleRipple() {
	    (0, _classCallCheck3.default)(this, CircleRipple);
	    return (0, _possibleConstructorReturn3.default)(this, (CircleRipple.__proto__ || (0, _getPrototypeOf2.default)(CircleRipple)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(CircleRipple, [{
	    key: 'shouldComponentUpdate',
	    value: function shouldComponentUpdate(nextProps) {
	      return !(0, _shallowEqual2.default)(this.props, nextProps);
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = 0;
	      // If the animation is aborted, remove from the DOM immediately
	      var removeAfter = this.props.aborted ? 0 : 2000;
	      this.enterTimer = setTimeout(callback, removeAfter);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var transitionValue = _transitions2.default.easeOut('2s', 'opacity') + ', ' + _transitions2.default.easeOut('1s', 'transform');
	      _autoPrefix2.default.set(style, 'transition', transitionValue);
	      _autoPrefix2.default.set(style, 'transform', 'scale(1)');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = this.props.opacity;
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	      this.leaveTimer = setTimeout(callback, 0);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          aborted = _props.aborted,
	          color = _props.color,
	          opacity = _props.opacity,
	          style = _props.style,
	          touchGenerated = _props.touchGenerated,
	          other = (0, _objectWithoutProperties3.default)(_props, ['aborted', 'color', 'opacity', 'style', 'touchGenerated']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedStyles = (0, _simpleAssign2.default)({
	        position: 'absolute',
	        top: 0,
	        left: 0,
	        height: '100%',
	        width: '100%',
	        borderRadius: '50%',
	        backgroundColor: color
	      }, style);
	
	      return _react2.default.createElement('div', (0, _extends3.default)({}, other, { style: prepareStyles(mergedStyles) }));
	    }
	  }]);
	  return CircleRipple;
	}(_react.Component);
	
	CircleRipple.defaultProps = {
	  opacity: 0.1,
	  aborted: false
	};
	CircleRipple.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? CircleRipple.propTypes = {
	  aborted: _propTypes2.default.bool,
	  color: _propTypes2.default.string,
	  opacity: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  touchGenerated: _propTypes2.default.bool
	} : void 0;
	exports.default = CircleRipple;

/***/ },
/* 876 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _BeforeAfterWrapper = __webpack_require__(874);
	
	var _BeforeAfterWrapper2 = _interopRequireDefault(_BeforeAfterWrapper);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = {
	  before: {
	    content: "' '",
	    display: 'table'
	  },
	  after: {
	    content: "' '",
	    clear: 'both',
	    display: 'table'
	  }
	};
	
	var ClearFix = function ClearFix(_ref) {
	  var style = _ref.style,
	      children = _ref.children,
	      other = (0, _objectWithoutProperties3.default)(_ref, ['style', 'children']);
	  return _react2.default.createElement(
	    _BeforeAfterWrapper2.default,
	    (0, _extends3.default)({}, other, {
	      beforeStyle: styles.before,
	      afterStyle: styles.after,
	      style: style
	    }),
	    children
	  );
	};
	
	ClearFix.muiName = 'ClearFix';
	
	 false ? ClearFix.propTypes = {
	  children: _propTypes2.default.node,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	
	exports.default = ClearFix;

/***/ },
/* 877 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsTransitionGroup = __webpack_require__(118);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ExpandTransitionChild = __webpack_require__(878);
	
	var _ExpandTransitionChild2 = _interopRequireDefault(_ExpandTransitionChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ExpandTransition = function (_Component) {
	  (0, _inherits3.default)(ExpandTransition, _Component);
	
	  function ExpandTransition() {
	    (0, _classCallCheck3.default)(this, ExpandTransition);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransition.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransition)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransition, [{
	    key: 'renderChildren',
	    value: function renderChildren(children) {
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      return _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ExpandTransitionChild2.default,
	          {
	            enterDelay: enterDelay,
	            transitionDelay: transitionDelay,
	            transitionDuration: transitionDuration,
	            key: child.key
	          },
	          child
	        );
	      }, this);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props2 = this.props,
	          children = _props2.children,
	          enterDelay = _props2.enterDelay,
	          loading = _props2.loading,
	          open = _props2.open,
	          style = _props2.style,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props2, ['children', 'enterDelay', 'loading', 'open', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: 'auto'
	      }, style);
	
	      var newChildren = loading ? [] : this.renderChildren(children);
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }, other),
	        open && newChildren
	      );
	    }
	  }]);
	  return ExpandTransition;
	}(_react.Component);
	
	ExpandTransition.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450,
	  loading: false,
	  open: false
	};
	ExpandTransition.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ExpandTransition.propTypes = {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  loading: _propTypes2.default.bool,
	  open: _propTypes2.default.bool,
	  style: _propTypes2.default.object,
	  transitionDelay: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	} : void 0;
	exports.default = ExpandTransition;

/***/ },
/* 878 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reflow = function reflow(elem) {
	  return elem.offsetHeight;
	};
	
	var ExpandTransitionChild = function (_Component) {
	  (0, _inherits3.default)(ExpandTransitionChild, _Component);
	
	  function ExpandTransitionChild() {
	    (0, _classCallCheck3.default)(this, ExpandTransitionChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ExpandTransitionChild.__proto__ || (0, _getPrototypeOf2.default)(ExpandTransitionChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ExpandTransitionChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.enteredTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.open();
	      callback();
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var _this2 = this;
	
	      var _props = this.props,
	          enterDelay = _props.enterDelay,
	          transitionDelay = _props.transitionDelay,
	          transitionDuration = _props.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = 0;
	      this.enterTimer = setTimeout(function () {
	        return _this2.open();
	      }, enterDelay);
	      this.enteredTimer = setTimeout(function () {
	        return callback();
	      }, enterDelay + transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.setAutoHeight();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var _props2 = this.props,
	          transitionDelay = _props2.transitionDelay,
	          transitionDuration = _props2.transitionDuration;
	
	      var element = _reactDom2.default.findDOMNode(this);
	      // Set fixed height first for animated property value
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	      reflow(element);
	      element.style.transitionDuration = transitionDuration + 'ms';
	      element.style.height = 0;
	      this.leaveTimer = setTimeout(function () {
	        return callback();
	      }, transitionDelay + transitionDuration);
	    }
	  }, {
	    key: 'setAutoHeight',
	    value: function setAutoHeight() {
	      var _ReactDOM$findDOMNode = _reactDom2.default.findDOMNode(this),
	          style = _ReactDOM$findDOMNode.style;
	
	      style.transitionDuration = 0;
	      style.height = 'auto';
	    }
	  }, {
	    key: 'open',
	    value: function open() {
	      var element = _reactDom2.default.findDOMNode(this);
	      element.style.height = this.refs.wrapper.clientHeight + 'px';
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props3 = this.props,
	          children = _props3.children,
	          enterDelay = _props3.enterDelay,
	          style = _props3.style,
	          transitionDelay = _props3.transitionDelay,
	          transitionDuration = _props3.transitionDuration,
	          other = (0, _objectWithoutProperties3.default)(_props3, ['children', 'enterDelay', 'style', 'transitionDelay', 'transitionDuration']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({
	        position: 'relative',
	        height: 0,
	        width: '100%',
	        top: 0,
	        left: 0,
	        overflow: 'hidden',
	        transition: _transitions2.default.easeOut(transitionDuration + 'ms', ['height'], transitionDelay + 'ms')
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        _react2.default.createElement(
	          'div',
	          { ref: 'wrapper' },
	          children
	        )
	      );
	    }
	  }]);
	  return ExpandTransitionChild;
	}(_react.Component);
	
	ExpandTransitionChild.defaultProps = {
	  enterDelay: 0,
	  transitionDelay: 0,
	  transitionDuration: 450
	};
	ExpandTransitionChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ExpandTransitionChild.propTypes = {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  style: _propTypes2.default.object,
	  transitionDelay: _propTypes2.default.number,
	  transitionDuration: _propTypes2.default.number
	} : void 0;
	exports.default = ExpandTransitionChild;

/***/ },
/* 879 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactAddonsTransitionGroup = __webpack_require__(118);
	
	var _reactAddonsTransitionGroup2 = _interopRequireDefault(_reactAddonsTransitionGroup);
	
	var _ScaleInChild = __webpack_require__(880);
	
	var _ScaleInChild2 = _interopRequireDefault(_ScaleInChild);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleIn = function (_Component) {
	  (0, _inherits3.default)(ScaleIn, _Component);
	
	  function ScaleIn() {
	    (0, _classCallCheck3.default)(this, ScaleIn);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleIn.__proto__ || (0, _getPrototypeOf2.default)(ScaleIn)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleIn, [{
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          childStyle = _props.childStyle,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'childStyle', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'relative',
	        overflow: 'hidden',
	        height: '100%'
	      }, style);
	
	      var newChildren = _react2.default.Children.map(children, function (child) {
	        return _react2.default.createElement(
	          _ScaleInChild2.default,
	          {
	            key: child.key,
	            enterDelay: enterDelay,
	            maxScale: maxScale,
	            minScale: minScale,
	            style: childStyle
	          },
	          child
	        );
	      });
	
	      return _react2.default.createElement(
	        _reactAddonsTransitionGroup2.default,
	        (0, _extends3.default)({}, other, {
	          style: prepareStyles(mergedRootStyles),
	          component: 'div'
	        }),
	        newChildren
	      );
	    }
	  }]);
	  return ScaleIn;
	}(_react.Component);
	
	ScaleIn.defaultProps = {
	  enterDelay: 0
	};
	ScaleIn.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ScaleIn.propTypes = {
	  childStyle: _propTypes2.default.object,
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  /**
	   * Override the inline-styles of the root element.
	   */
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = ScaleIn;

/***/ },
/* 880 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(64);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ScaleInChild = function (_Component) {
	  (0, _inherits3.default)(ScaleInChild, _Component);
	
	  function ScaleInChild() {
	    (0, _classCallCheck3.default)(this, ScaleInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (ScaleInChild.__proto__ || (0, _getPrototypeOf2.default)(ScaleInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(ScaleInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillAppear',
	    value: function componentWillAppear(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      this.initializeAnimation(callback);
	    }
	  }, {
	    key: 'componentDidAppear',
	    value: function componentDidAppear() {
	      this.animate();
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      this.animate();
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.minScale + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'animate',
	    value: function animate() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'scale(' + this.props.maxScale + ')');
	    }
	  }, {
	    key: 'initializeAnimation',
	    value: function initializeAnimation(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'scale(0)');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          maxScale = _props.maxScale,
	          minScale = _props.minScale,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'maxScale', 'minScale', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return ScaleInChild;
	}(_react.Component);
	
	ScaleInChild.defaultProps = {
	  enterDelay: 0,
	  maxScale: 1,
	  minScale: 0
	};
	ScaleInChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? ScaleInChild.propTypes = {
	  children: _propTypes2.default.node,
	  enterDelay: _propTypes2.default.number,
	  maxScale: _propTypes2.default.number,
	  minScale: _propTypes2.default.number,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = ScaleInChild;

/***/ },
/* 881 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _objectWithoutProperties2 = __webpack_require__(12);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _simpleAssign = __webpack_require__(10);
	
	var _simpleAssign2 = _interopRequireDefault(_simpleAssign);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _reactDom = __webpack_require__(19);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _autoPrefix = __webpack_require__(64);
	
	var _autoPrefix2 = _interopRequireDefault(_autoPrefix);
	
	var _transitions = __webpack_require__(14);
	
	var _transitions2 = _interopRequireDefault(_transitions);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SlideInChild = function (_Component) {
	  (0, _inherits3.default)(SlideInChild, _Component);
	
	  function SlideInChild() {
	    (0, _classCallCheck3.default)(this, SlideInChild);
	    return (0, _possibleConstructorReturn3.default)(this, (SlideInChild.__proto__ || (0, _getPrototypeOf2.default)(SlideInChild)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(SlideInChild, [{
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      clearTimeout(this.enterTimer);
	      clearTimeout(this.leaveTimer);
	    }
	  }, {
	    key: 'componentWillEnter',
	    value: function componentWillEnter(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var x = this.props.direction === 'left' ? '100%' : this.props.direction === 'right' ? '-100%' : '0';
	      var y = this.props.direction === 'up' ? '100%' : this.props.direction === 'down' ? '-100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.enterTimer = setTimeout(callback, this.props.enterDelay);
	    }
	  }, {
	    key: 'componentDidEnter',
	    value: function componentDidEnter() {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      style.opacity = '1';
	      _autoPrefix2.default.set(style, 'transform', 'translate(0,0)');
	    }
	  }, {
	    key: 'componentWillLeave',
	    value: function componentWillLeave(callback) {
	      var style = _reactDom2.default.findDOMNode(this).style;
	      var direction = this.props.getLeaveDirection();
	      var x = direction === 'left' ? '-100%' : direction === 'right' ? '100%' : '0';
	      var y = direction === 'up' ? '-100%' : direction === 'down' ? '100%' : '0';
	
	      style.opacity = '0';
	      _autoPrefix2.default.set(style, 'transform', 'translate(' + x + ', ' + y + ')');
	
	      this.leaveTimer = setTimeout(callback, 450);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _props = this.props,
	          children = _props.children,
	          enterDelay = _props.enterDelay,
	          getLeaveDirection = _props.getLeaveDirection,
	          style = _props.style,
	          other = (0, _objectWithoutProperties3.default)(_props, ['children', 'enterDelay', 'getLeaveDirection', 'style']);
	      var prepareStyles = this.context.muiTheme.prepareStyles;
	
	
	      var mergedRootStyles = (0, _simpleAssign2.default)({}, {
	        position: 'absolute',
	        height: '100%',
	        width: '100%',
	        top: 0,
	        left: 0,
	        transition: _transitions2.default.easeOut(null, ['transform', 'opacity'])
	      }, style);
	
	      return _react2.default.createElement(
	        'div',
	        (0, _extends3.default)({}, other, { style: prepareStyles(mergedRootStyles) }),
	        children
	      );
	    }
	  }]);
	  return SlideInChild;
	}(_react.Component);
	
	SlideInChild.defaultProps = {
	  enterDelay: 0
	};
	SlideInChild.contextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? SlideInChild.propTypes = {
	  children: _propTypes2.default.node,
	  direction: _propTypes2.default.string,
	  enterDelay: _propTypes2.default.number,
	  // This callback is needed bacause the direction could change when leaving the DOM
	  getLeaveDirection: _propTypes2.default.func.isRequired,
	  style: _propTypes2.default.object
	} : void 0;
	exports.default = SlideInChild;

/***/ },
/* 882 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _getMuiTheme = __webpack_require__(884);
	
	var _getMuiTheme2 = _interopRequireDefault(_getMuiTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MuiThemeProvider = function (_Component) {
	  (0, _inherits3.default)(MuiThemeProvider, _Component);
	
	  function MuiThemeProvider() {
	    (0, _classCallCheck3.default)(this, MuiThemeProvider);
	    return (0, _possibleConstructorReturn3.default)(this, (MuiThemeProvider.__proto__ || (0, _getPrototypeOf2.default)(MuiThemeProvider)).apply(this, arguments));
	  }
	
	  (0, _createClass3.default)(MuiThemeProvider, [{
	    key: 'getChildContext',
	    value: function getChildContext() {
	      return {
	        muiTheme: this.props.muiTheme || (0, _getMuiTheme2.default)()
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return MuiThemeProvider;
	}(_react.Component);
	
	MuiThemeProvider.childContextTypes = {
	  muiTheme: _propTypes2.default.object.isRequired
	};
	 false ? MuiThemeProvider.propTypes = {
	  children: _propTypes2.default.element,
	  muiTheme: _propTypes2.default.object
	} : void 0;
	exports.default = MuiThemeProvider;

/***/ },
/* 883 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _colors = __webpack_require__(63);
	
	var _colorManipulator = __webpack_require__(53);
	
	var _spacing = __webpack_require__(885);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 *  Light Theme is the default theme used in material-ui. It is guaranteed to
	 *  have all theme variables needed for every component. Variables not defined
	 *  in a custom theme will default to these values.
	 */
	exports.default = {
	  spacing: _spacing2.default,
	  fontFamily: 'Roboto, sans-serif',
	  borderRadius: 2,
	  palette: {
	    primary1Color: _colors.cyan500,
	    primary2Color: _colors.cyan700,
	    primary3Color: _colors.grey400,
	    accent1Color: _colors.pinkA200,
	    accent2Color: _colors.grey100,
	    accent3Color: _colors.grey500,
	    textColor: _colors.darkBlack,
	    secondaryTextColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.54),
	    alternateTextColor: _colors.white,
	    canvasColor: _colors.white,
	    borderColor: _colors.grey300,
	    disabledColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.3),
	    pickerHeaderColor: _colors.cyan500,
	    clockCircleColor: (0, _colorManipulator.fade)(_colors.darkBlack, 0.07),
	    shadowColor: _colors.fullBlack
	  }
	}; /**
	    * NB: If you update this file, please also update `docs/src/app/customization/Themes.js`
	    */

/***/ },
/* 884 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _toConsumableArray2 = __webpack_require__(97);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	exports.default = getMuiTheme;
	
	var _lodash = __webpack_require__(297);
	
	var _lodash2 = _interopRequireDefault(_lodash);
	
	var _colorManipulator = __webpack_require__(53);
	
	var _lightBaseTheme = __webpack_require__(883);
	
	var _lightBaseTheme2 = _interopRequireDefault(_lightBaseTheme);
	
	var _zIndex = __webpack_require__(887);
	
	var _zIndex2 = _interopRequireDefault(_zIndex);
	
	var _autoprefixer = __webpack_require__(1834);
	
	var _autoprefixer2 = _interopRequireDefault(_autoprefixer);
	
	var _callOnce = __webpack_require__(1837);
	
	var _callOnce2 = _interopRequireDefault(_callOnce);
	
	var _rtl = __webpack_require__(1840);
	
	var _rtl2 = _interopRequireDefault(_rtl);
	
	var _compose = __webpack_require__(1975);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _typography = __webpack_require__(886);
	
	var _typography2 = _interopRequireDefault(_typography);
	
	var _colors = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	/**
	 * Get the MUI theme corresponding to a base theme.
	 * It's possible to override the computed theme values
	 * by providing a second argument. The calculated
	 * theme will be deeply merged with the second argument.
	 */
	function getMuiTheme(muiTheme) {
	  for (var _len = arguments.length, more = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    more[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = _lodash2.default.apply(undefined, [{
	    zIndex: _zIndex2.default,
	    isRtl: false,
	    userAgent: undefined
	  }, _lightBaseTheme2.default, muiTheme].concat(more));
	
	  var _muiTheme = muiTheme,
	      spacing = _muiTheme.spacing,
	      fontFamily = _muiTheme.fontFamily,
	      palette = _muiTheme.palette;
	
	  var baseTheme = { spacing: spacing, fontFamily: fontFamily, palette: palette };
	
	  muiTheme = (0, _lodash2.default)({
	    appBar: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      height: spacing.desktopKeylineIncrement,
	      titleFontWeight: _typography2.default.fontWeightNormal,
	      padding: spacing.desktopGutter
	    },
	    avatar: {
	      color: palette.canvasColor,
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.26)
	    },
	    badge: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    bottomNavigation: {
	      backgroundColor: palette.canvasColor,
	      unselectedColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      selectedColor: palette.primary1Color,
	      height: 56,
	      unselectedFontSize: 12,
	      selectedFontSize: 14
	    },
	    button: {
	      height: 36,
	      minWidth: 88,
	      iconButtonSize: spacing.iconSize * 2
	    },
	    card: {
	      titleColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      subtitleColor: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    cardMedia: {
	      color: _colors.darkWhite,
	      overlayContentBackground: _colors.lightBlack,
	      titleColor: _colors.darkWhite,
	      subtitleColor: _colors.lightWhite
	    },
	    cardText: {
	      textColor: palette.textColor
	    },
	    checkbox: {
	      boxColor: palette.textColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    chip: {
	      backgroundColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12),
	      deleteIconColor: (0, _colorManipulator.fade)(palette.textColor, 0.26),
	      textColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      fontSize: 14,
	      fontWeight: _typography2.default.fontWeightNormal,
	      shadow: '0 1px 6px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12) + ',\n        0 1px 4px ' + (0, _colorManipulator.fade)(palette.shadowColor, 0.12)
	    },
	    datePicker: {
	      color: palette.primary1Color,
	      textColor: palette.alternateTextColor,
	      calendarTextColor: palette.textColor,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor,
	      calendarYearBackgroundColor: palette.canvasColor
	    },
	    dialog: {
	      titleFontSize: 22,
	      bodyFontSize: 16,
	      bodyColor: (0, _colorManipulator.fade)(palette.textColor, 0.6)
	    },
	    dropDownMenu: {
	      accentColor: palette.borderColor
	    },
	    enhancedButton: {
	      tapHighlightColor: _colors.transparent
	    },
	    flatButton: {
	      color: _colors.transparent,
	      buttonFilterColor: '#999999',
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      textColor: palette.textColor,
	      primaryTextColor: palette.primary1Color,
	      secondaryTextColor: palette.accent1Color,
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    floatingActionButton: {
	      buttonSize: 56,
	      miniSize: 40,
	      color: palette.primary1Color,
	      iconColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryIconColor: palette.alternateTextColor,
	      disabledTextColor: palette.disabledColor,
	      disabledColor: (0, _colorManipulator.emphasize)(palette.canvasColor, 0.12)
	    },
	    gridTile: {
	      textColor: _colors.white
	    },
	    icon: {
	      color: palette.canvasColor,
	      backgroundColor: palette.primary1Color
	    },
	    inkBar: {
	      backgroundColor: palette.accent1Color
	    },
	    drawer: {
	      width: spacing.desktopKeylineIncrement * 4,
	      color: palette.canvasColor
	    },
	    listItem: {
	      nestedLevelDepth: 18,
	      secondaryTextColor: palette.secondaryTextColor,
	      leftIconColor: _colors.grey600,
	      rightIconColor: _colors.grey600
	    },
	    menu: {
	      backgroundColor: palette.canvasColor,
	      containerBackgroundColor: palette.canvasColor
	    },
	    menuItem: {
	      dataHeight: 32,
	      height: 48,
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1),
	      padding: spacing.desktopGutter,
	      selectedTextColor: palette.accent1Color,
	      rightIconDesktopFill: _colors.grey600
	    },
	    menuSubheader: {
	      padding: spacing.desktopGutter,
	      borderColor: palette.borderColor,
	      textColor: palette.primary1Color
	    },
	    overlay: {
	      backgroundColor: _colors.lightBlack
	    },
	    paper: {
	      color: palette.textColor,
	      backgroundColor: palette.canvasColor,
	      zDepthShadows: [[1, 6, 0.12, 1, 4, 0.12], [3, 10, 0.16, 3, 10, 0.23], [10, 30, 0.19, 6, 10, 0.23], [14, 45, 0.25, 10, 18, 0.22], [19, 60, 0.30, 15, 20, 0.22]].map(function (d) {
	        return '0 ' + d[0] + 'px ' + d[1] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[2]) + ',\n         0 ' + d[3] + 'px ' + d[4] + 'px ' + (0, _colorManipulator.fade)(palette.shadowColor, d[5]);
	      })
	    },
	    radioButton: {
	      borderColor: palette.textColor,
	      backgroundColor: palette.alternateTextColor,
	      checkedColor: palette.primary1Color,
	      requiredColor: palette.primary1Color,
	      disabledColor: palette.disabledColor,
	      size: 24,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor
	    },
	    raisedButton: {
	      color: palette.alternateTextColor,
	      textColor: palette.textColor,
	      primaryColor: palette.primary1Color,
	      primaryTextColor: palette.alternateTextColor,
	      secondaryColor: palette.accent1Color,
	      secondaryTextColor: palette.alternateTextColor,
	      disabledColor: (0, _colorManipulator.darken)(palette.alternateTextColor, 0.1),
	      disabledTextColor: (0, _colorManipulator.fade)(palette.textColor, 0.3),
	      fontSize: _typography2.default.fontStyleButtonFontSize,
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    refreshIndicator: {
	      strokeColor: palette.borderColor,
	      loadingStrokeColor: palette.primary1Color
	    },
	    ripple: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.87)
	    },
	    slider: {
	      trackSize: 2,
	      trackColor: palette.primary3Color,
	      trackColorSelected: palette.accent3Color,
	      handleSize: 12,
	      handleSizeDisabled: 8,
	      handleSizeActive: 18,
	      handleColorZero: palette.primary3Color,
	      handleFillColor: palette.alternateTextColor,
	      selectionColor: palette.primary1Color,
	      rippleColor: palette.primary1Color
	    },
	    snackbar: {
	      textColor: palette.alternateTextColor,
	      backgroundColor: palette.textColor,
	      actionColor: palette.accent1Color
	    },
	    subheader: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      fontWeight: _typography2.default.fontWeightMedium
	    },
	    stepper: {
	      backgroundColor: 'transparent',
	      hoverBackgroundColor: (0, _colorManipulator.fade)(_colors.black, 0.06),
	      iconColor: palette.primary1Color,
	      hoveredIconColor: _colors.grey700,
	      inactiveIconColor: _colors.grey500,
	      textColor: (0, _colorManipulator.fade)(_colors.black, 0.87),
	      disabledTextColor: (0, _colorManipulator.fade)(_colors.black, 0.26),
	      connectorLineColor: _colors.grey400
	    },
	    svgIcon: {
	      color: palette.textColor
	    },
	    table: {
	      backgroundColor: palette.canvasColor
	    },
	    tableFooter: {
	      borderColor: palette.borderColor,
	      textColor: palette.accent3Color
	    },
	    tableHeader: {
	      borderColor: palette.borderColor
	    },
	    tableHeaderColumn: {
	      textColor: palette.accent3Color,
	      height: 56,
	      spacing: 24
	    },
	    tableRow: {
	      hoverColor: palette.accent2Color,
	      stripeColor: (0, _colorManipulator.fade)((0, _colorManipulator.lighten)(palette.primary1Color, 0.5), 0.4),
	      selectedColor: palette.borderColor,
	      textColor: palette.textColor,
	      borderColor: palette.borderColor,
	      height: 48
	    },
	    tableRowColumn: {
	      height: 48,
	      spacing: 24
	    },
	    tabs: {
	      backgroundColor: palette.primary1Color,
	      textColor: (0, _colorManipulator.fade)(palette.alternateTextColor, 0.7),
	      selectedTextColor: palette.alternateTextColor
	    },
	    textField: {
	      textColor: palette.textColor,
	      hintColor: palette.disabledColor,
	      floatingLabelColor: palette.disabledColor,
	      disabledTextColor: palette.disabledColor,
	      errorColor: _colors.red500,
	      focusColor: palette.primary1Color,
	      backgroundColor: 'transparent',
	      borderColor: palette.borderColor
	    },
	    timePicker: {
	      color: palette.alternateTextColor,
	      textColor: palette.alternateTextColor,
	      accentColor: palette.primary1Color,
	      clockColor: palette.textColor,
	      clockCircleColor: palette.clockCircleColor,
	      headerColor: palette.pickerHeaderColor || palette.primary1Color,
	      selectColor: palette.primary2Color,
	      selectTextColor: palette.alternateTextColor
	    },
	    toggle: {
	      thumbOnColor: palette.primary1Color,
	      thumbOffColor: palette.accent2Color,
	      thumbDisabledColor: palette.borderColor,
	      thumbRequiredColor: palette.primary1Color,
	      trackOnColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5),
	      trackOffColor: palette.primary3Color,
	      trackDisabledColor: palette.primary3Color,
	      labelColor: palette.textColor,
	      labelDisabledColor: palette.disabledColor,
	      trackRequiredColor: (0, _colorManipulator.fade)(palette.primary1Color, 0.5)
	    },
	    toolbar: {
	      color: (0, _colorManipulator.fade)(palette.textColor, 0.54),
	      hoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.87),
	      backgroundColor: (0, _colorManipulator.darken)(palette.accent2Color, 0.05),
	      height: 56,
	      titleFontSize: 20,
	      iconColor: (0, _colorManipulator.fade)(palette.textColor, 0.4),
	      separatorColor: (0, _colorManipulator.fade)(palette.textColor, 0.175),
	      menuHoverColor: (0, _colorManipulator.fade)(palette.textColor, 0.1)
	    },
	    tooltip: {
	      color: _colors.white,
	      rippleBackgroundColor: _colors.grey700
	    }
	  }, muiTheme, {
	    baseTheme: baseTheme, // To provide backward compatibility.
	    rawTheme: baseTheme });
	
	  var transformers = [_autoprefixer2.default, _rtl2.default, _callOnce2.default].map(function (t) {
	    return t(muiTheme);
	  }).filter(function (t) {
	    return t;
	  });
	
	  muiTheme.prepareStyles = _compose2.default.apply(undefined, (0, _toConsumableArray3.default)(transformers));
	
	  return muiTheme;
	}

/***/ },
/* 885 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  iconSize: 24,
	
	  desktopGutter: 24,
	  desktopGutterMore: 32,
	  desktopGutterLess: 16,
	  desktopGutterMini: 8,
	  desktopKeylineIncrement: 64,
	  desktopDropDownMenuItemHeight: 32,
	  desktopDropDownMenuFontSize: 15,
	  desktopDrawerMenuItemHeight: 48,
	  desktopSubheaderHeight: 48,
	  desktopToolbarHeight: 56
	};

/***/ },
/* 886 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _colors = __webpack_require__(63);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Typography = function Typography() {
	  (0, _classCallCheck3.default)(this, Typography);
	
	  // text colors
	  this.textFullBlack = _colors.fullBlack;
	  this.textDarkBlack = _colors.darkBlack;
	  this.textLightBlack = _colors.lightBlack;
	  this.textMinBlack = _colors.minBlack;
	  this.textFullWhite = _colors.fullWhite;
	  this.textDarkWhite = _colors.darkWhite;
	  this.textLightWhite = _colors.lightWhite;
	
	  // font weight
	  this.fontWeightLight = 300;
	  this.fontWeightNormal = 400;
	  this.fontWeightMedium = 500;
	
	  this.fontStyleButtonFontSize = 14;
	};
	
	exports.default = new Typography();

/***/ },
/* 887 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  menu: 1000,
	  appBar: 1100,
	  drawerOverlay: 1200,
	  drawer: 1300,
	  dialogOverlay: 1400,
	  dialog: 1500,
	  layer: 2000,
	  popover: 2100,
	  snackbar: 2900,
	  tooltip: 3000
	};

/***/ },
/* 888 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccessibility = function ActionAccessibility(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 7h-6v13h-2v-6h-2v6H9V9H3V7h18v2z' })
	  );
	};
	ActionAccessibility = (0, _pure2.default)(ActionAccessibility);
	ActionAccessibility.displayName = 'ActionAccessibility';
	ActionAccessibility.muiName = 'SvgIcon';
	
	exports.default = ActionAccessibility;

/***/ },
/* 889 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccessible = function ActionAccessible(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '4', r: '2' }),
	    _react2.default.createElement('path', { d: 'M19 13v-2c-1.54.02-3.09-.75-4.07-1.83l-1.29-1.43c-.17-.19-.38-.34-.61-.45-.01 0-.01-.01-.02-.01H13c-.35-.2-.75-.3-1.19-.26C10.76 7.11 10 8.04 10 9.09V15c0 1.1.9 2 2 2h5v5h2v-5.5c0-1.1-.9-2-2-2h-3v-3.45c1.29 1.07 3.25 1.94 5 1.95zm-6.17 5c-.41 1.16-1.52 2-2.83 2-1.66 0-3-1.34-3-3 0-1.31.84-2.41 2-2.83V12.1c-2.28.46-4 2.48-4 4.9 0 2.76 2.24 5 5 5 2.42 0 4.44-1.72 4.9-4h-2.07z' })
	  );
	};
	ActionAccessible = (0, _pure2.default)(ActionAccessible);
	ActionAccessible.displayName = 'ActionAccessible';
	ActionAccessible.muiName = 'SvgIcon';
	
	exports.default = ActionAccessible;

/***/ },
/* 890 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountBalanceWallet = function ActionAccountBalanceWallet(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 18v1c0 1.1-.9 2-2 2H5c-1.11 0-2-.9-2-2V5c0-1.1.89-2 2-2h14c1.1 0 2 .9 2 2v1h-9c-1.11 0-2 .9-2 2v8c0 1.1.89 2 2 2h9zm-9-2h10V8H12v8zm4-2.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ActionAccountBalanceWallet = (0, _pure2.default)(ActionAccountBalanceWallet);
	ActionAccountBalanceWallet.displayName = 'ActionAccountBalanceWallet';
	ActionAccountBalanceWallet.muiName = 'SvgIcon';
	
	exports.default = ActionAccountBalanceWallet;

/***/ },
/* 891 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountBalance = function ActionAccountBalance(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 10v7h3v-7H4zm6 0v7h3v-7h-3zM2 22h19v-3H2v3zm14-12v7h3v-7h-3zm-4.5-9L2 6v2h19V6l-9.5-5z' })
	  );
	};
	ActionAccountBalance = (0, _pure2.default)(ActionAccountBalance);
	ActionAccountBalance.displayName = 'ActionAccountBalance';
	ActionAccountBalance.muiName = 'SvgIcon';
	
	exports.default = ActionAccountBalance;

/***/ },
/* 892 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountBox = function ActionAccountBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2H5c-1.11 0-2 .9-2 2zm12 4c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3zm-9 8c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1H6v-1z' })
	  );
	};
	ActionAccountBox = (0, _pure2.default)(ActionAccountBox);
	ActionAccountBox.displayName = 'ActionAccountBox';
	ActionAccountBox.muiName = 'SvgIcon';
	
	exports.default = ActionAccountBox;

/***/ },
/* 893 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAccountCircle = function ActionAccountCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm0 14.2c-2.5 0-4.71-1.28-6-3.22.03-1.99 4-3.08 6-3.08 1.99 0 5.97 1.09 6 3.08-1.29 1.94-3.5 3.22-6 3.22z' })
	  );
	};
	ActionAccountCircle = (0, _pure2.default)(ActionAccountCircle);
	ActionAccountCircle.displayName = 'ActionAccountCircle';
	ActionAccountCircle.muiName = 'SvgIcon';
	
	exports.default = ActionAccountCircle;

/***/ },
/* 894 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAddShoppingCart = function ActionAddShoppingCart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9h2V6h3V4h-3V1h-2v3H8v2h3v3zm-4 9c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zm10 0c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2zm-9.83-3.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.86-7.01L19.42 4h-.01l-1.1 2-2.76 5H8.53l-.13-.27L6.16 6l-.95-2-.94-2H1v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.13 0-.25-.11-.25-.25z' })
	  );
	};
	ActionAddShoppingCart = (0, _pure2.default)(ActionAddShoppingCart);
	ActionAddShoppingCart.displayName = 'ActionAddShoppingCart';
	ActionAddShoppingCart.muiName = 'SvgIcon';
	
	exports.default = ActionAddShoppingCart;

/***/ },
/* 895 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarmAdd = function ActionAlarmAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z' })
	  );
	};
	ActionAlarmAdd = (0, _pure2.default)(ActionAlarmAdd);
	ActionAlarmAdd.displayName = 'ActionAlarmAdd';
	ActionAlarmAdd.muiName = 'SvgIcon';
	
	exports.default = ActionAlarmAdd;

/***/ },
/* 896 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarmOff = function ActionAlarmOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c3.87 0 7 3.13 7 7 0 .84-.16 1.65-.43 2.4l1.52 1.52c.58-1.19.91-2.51.91-3.92 0-4.97-4.03-9-9-9-1.41 0-2.73.33-3.92.91L9.6 6.43C10.35 6.16 11.16 6 12 6zm10-.28l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM2.92 2.29L1.65 3.57 2.98 4.9l-1.11.93 1.42 1.42 1.11-.94.8.8C3.83 8.69 3 10.75 3 13c0 4.97 4.02 9 9 9 2.25 0 4.31-.83 5.89-2.2l2.2 2.2 1.27-1.27L3.89 3.27l-.97-.98zm13.55 16.1C15.26 19.39 13.7 20 12 20c-3.87 0-7-3.13-7-7 0-1.7.61-3.26 1.61-4.47l9.86 9.86zM8.02 3.28L6.6 1.86l-.86.71 1.42 1.42.86-.71z' })
	  );
	};
	ActionAlarmOff = (0, _pure2.default)(ActionAlarmOff);
	ActionAlarmOff.displayName = 'ActionAlarmOff';
	ActionAlarmOff.muiName = 'SvgIcon';
	
	exports.default = ActionAlarmOff;

/***/ },
/* 897 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarmOn = function ActionAlarmOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-1.46-5.47L8.41 12.4l-1.06 1.06 3.18 3.18 6-6-1.06-1.06-4.93 4.95z' })
	  );
	};
	ActionAlarmOn = (0, _pure2.default)(ActionAlarmOn);
	ActionAlarmOn.displayName = 'ActionAlarmOn';
	ActionAlarmOn.muiName = 'SvgIcon';
	
	exports.default = ActionAlarmOn;

/***/ },
/* 898 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAlarm = function ActionAlarm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	ActionAlarm = (0, _pure2.default)(ActionAlarm);
	ActionAlarm.displayName = 'ActionAlarm';
	ActionAlarm.muiName = 'SvgIcon';
	
	exports.default = ActionAlarm;

/***/ },
/* 899 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAllOut = function ActionAllOut(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.21 4.16l4 4v-4zm4 12l-4 4h4zm-12 4l-4-4v4zm-4-12l4-4h-4zm12.95-.95c-2.73-2.73-7.17-2.73-9.9 0s-2.73 7.17 0 9.9 7.17 2.73 9.9 0 2.73-7.16 0-9.9zm-1.1 8.8c-2.13 2.13-5.57 2.13-7.7 0s-2.13-5.57 0-7.7 5.57-2.13 7.7 0 2.13 5.57 0 7.7z' })
	  );
	};
	ActionAllOut = (0, _pure2.default)(ActionAllOut);
	ActionAllOut.displayName = 'ActionAllOut';
	ActionAllOut.muiName = 'SvgIcon';
	
	exports.default = ActionAllOut;

/***/ },
/* 900 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAndroid = function ActionAndroid(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 18c0 .55.45 1 1 1h1v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h2v3.5c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5V19h1c.55 0 1-.45 1-1V8H6v10zM3.5 8C2.67 8 2 8.67 2 9.5v7c0 .83.67 1.5 1.5 1.5S5 17.33 5 16.5v-7C5 8.67 4.33 8 3.5 8zm17 0c-.83 0-1.5.67-1.5 1.5v7c0 .83.67 1.5 1.5 1.5s1.5-.67 1.5-1.5v-7c0-.83-.67-1.5-1.5-1.5zm-4.97-5.84l1.3-1.3c.2-.2.2-.51 0-.71-.2-.2-.51-.2-.71 0l-1.48 1.48C13.85 1.23 12.95 1 12 1c-.96 0-1.86.23-2.66.63L7.85.15c-.2-.2-.51-.2-.71 0-.2.2-.2.51 0 .71l1.31 1.31C6.97 3.26 6 5.01 6 7h12c0-1.99-.97-3.75-2.47-4.84zM10 5H9V4h1v1zm5 0h-1V4h1v1z' })
	  );
	};
	ActionAndroid = (0, _pure2.default)(ActionAndroid);
	ActionAndroid.displayName = 'ActionAndroid';
	ActionAndroid.muiName = 'SvgIcon';
	
	exports.default = ActionAndroid;

/***/ },
/* 901 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAnnouncement = function ActionAnnouncement(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 9h-2V5h2v6zm0 4h-2v-2h2v2z' })
	  );
	};
	ActionAnnouncement = (0, _pure2.default)(ActionAnnouncement);
	ActionAnnouncement.displayName = 'ActionAnnouncement';
	ActionAnnouncement.muiName = 'SvgIcon';
	
	exports.default = ActionAnnouncement;

/***/ },
/* 902 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAspectRatio = function ActionAspectRatio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 12h-2v3h-3v2h5v-5zM7 9h3V7H5v5h2V9zm14-6H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
	  );
	};
	ActionAspectRatio = (0, _pure2.default)(ActionAspectRatio);
	ActionAspectRatio.displayName = 'ActionAspectRatio';
	ActionAspectRatio.muiName = 'SvgIcon';
	
	exports.default = ActionAspectRatio;

/***/ },
/* 903 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssessment = function ActionAssessment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
	  );
	};
	ActionAssessment = (0, _pure2.default)(ActionAssessment);
	ActionAssessment.displayName = 'ActionAssessment';
	ActionAssessment.muiName = 'SvgIcon';
	
	exports.default = ActionAssessment;

/***/ },
/* 904 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentInd = function ActionAssignmentInd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 4c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1.4c0-2 4-3.1 6-3.1s6 1.1 6 3.1V19z' })
	  );
	};
	ActionAssignmentInd = (0, _pure2.default)(ActionAssignmentInd);
	ActionAssignmentInd.displayName = 'ActionAssignmentInd';
	ActionAssignmentInd.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentInd;

/***/ },
/* 905 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentLate = function ActionAssignmentLate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-6 15h-2v-2h2v2zm0-4h-2V8h2v6zm-1-9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	ActionAssignmentLate = (0, _pure2.default)(ActionAssignmentLate);
	ActionAssignmentLate.displayName = 'ActionAssignmentLate';
	ActionAssignmentLate.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentLate;

/***/ },
/* 906 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentReturn = function ActionAssignmentReturn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm4 12h-4v3l-5-5 5-5v3h4v4z' })
	  );
	};
	ActionAssignmentReturn = (0, _pure2.default)(ActionAssignmentReturn);
	ActionAssignmentReturn.displayName = 'ActionAssignmentReturn';
	ActionAssignmentReturn.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentReturn;

/***/ },
/* 907 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentReturned = function ActionAssignmentReturned(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm0 15l-5-5h3V9h4v4h3l-5 5z' })
	  );
	};
	ActionAssignmentReturned = (0, _pure2.default)(ActionAssignmentReturned);
	ActionAssignmentReturned.displayName = 'ActionAssignmentReturned';
	ActionAssignmentReturned.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentReturned;

/***/ },
/* 908 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignmentTurnedIn = function ActionAssignmentTurnedIn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-2 14l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
	  );
	};
	ActionAssignmentTurnedIn = (0, _pure2.default)(ActionAssignmentTurnedIn);
	ActionAssignmentTurnedIn.displayName = 'ActionAssignmentTurnedIn';
	ActionAssignmentTurnedIn.muiName = 'SvgIcon';
	
	exports.default = ActionAssignmentTurnedIn;

/***/ },
/* 909 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAssignment = function ActionAssignment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-4.18C14.4 1.84 13.3 1 12 1c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2 14H7v-2h7v2zm3-4H7v-2h10v2zm0-4H7V7h10v2z' })
	  );
	};
	ActionAssignment = (0, _pure2.default)(ActionAssignment);
	ActionAssignment.displayName = 'ActionAssignment';
	ActionAssignment.muiName = 'SvgIcon';
	
	exports.default = ActionAssignment;

/***/ },
/* 910 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionAutorenew = function ActionAutorenew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6v3l4-4-4-4v3c-4.42 0-8 3.58-8 8 0 1.57.46 3.03 1.24 4.26L6.7 14.8c-.45-.83-.7-1.79-.7-2.8 0-3.31 2.69-6 6-6zm6.76 1.74L17.3 9.2c.44.84.7 1.79.7 2.8 0 3.31-2.69 6-6 6v-3l-4 4 4 4v-3c4.42 0 8-3.58 8-8 0-1.57-.46-3.03-1.24-4.26z' })
	  );
	};
	ActionAutorenew = (0, _pure2.default)(ActionAutorenew);
	ActionAutorenew.displayName = 'ActionAutorenew';
	ActionAutorenew.muiName = 'SvgIcon';
	
	exports.default = ActionAutorenew;

/***/ },
/* 911 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBackup = function ActionBackup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
	  );
	};
	ActionBackup = (0, _pure2.default)(ActionBackup);
	ActionBackup.displayName = 'ActionBackup';
	ActionBackup.muiName = 'SvgIcon';
	
	exports.default = ActionBackup;

/***/ },
/* 912 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBook = function ActionBook(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z' })
	  );
	};
	ActionBook = (0, _pure2.default)(ActionBook);
	ActionBook.displayName = 'ActionBook';
	ActionBook.muiName = 'SvgIcon';
	
	exports.default = ActionBook;

/***/ },
/* 913 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBookmarkBorder = function ActionBookmarkBorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' })
	  );
	};
	ActionBookmarkBorder = (0, _pure2.default)(ActionBookmarkBorder);
	ActionBookmarkBorder.displayName = 'ActionBookmarkBorder';
	ActionBookmarkBorder.muiName = 'SvgIcon';
	
	exports.default = ActionBookmarkBorder;

/***/ },
/* 914 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBookmark = function ActionBookmark(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionBookmark = (0, _pure2.default)(ActionBookmark);
	ActionBookmark.displayName = 'ActionBookmark';
	ActionBookmark.muiName = 'SvgIcon';
	
	exports.default = ActionBookmark;

/***/ },
/* 915 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBugReport = function ActionBugReport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8h-2.81c-.45-.78-1.07-1.45-1.82-1.96L17 4.41 15.59 3l-2.17 2.17C12.96 5.06 12.49 5 12 5c-.49 0-.96.06-1.41.17L8.41 3 7 4.41l1.62 1.63C7.88 6.55 7.26 7.22 6.81 8H4v2h2.09c-.05.33-.09.66-.09 1v1H4v2h2v1c0 .34.04.67.09 1H4v2h2.81c1.04 1.79 2.97 3 5.19 3s4.15-1.21 5.19-3H20v-2h-2.09c.05-.33.09-.66.09-1v-1h2v-2h-2v-1c0-.34-.04-.67-.09-1H20V8zm-6 8h-4v-2h4v2zm0-4h-4v-2h4v2z' })
	  );
	};
	ActionBugReport = (0, _pure2.default)(ActionBugReport);
	ActionBugReport.displayName = 'ActionBugReport';
	ActionBugReport.muiName = 'SvgIcon';
	
	exports.default = ActionBugReport;

/***/ },
/* 916 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionBuild = function ActionBuild(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.7 19l-9.1-9.1c.9-2.3.4-5-1.5-6.9-2-2-5-2.4-7.4-1.3L9 6 6 9 1.6 4.7C.4 7.1.9 10.1 2.9 12.1c1.9 1.9 4.6 2.4 6.9 1.5l9.1 9.1c.4.4 1 .4 1.4 0l2.3-2.3c.5-.4.5-1.1.1-1.4z' })
	  );
	};
	ActionBuild = (0, _pure2.default)(ActionBuild);
	ActionBuild.displayName = 'ActionBuild';
	ActionBuild.muiName = 'SvgIcon';
	
	exports.default = ActionBuild;

/***/ },
/* 917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCached = function ActionCached(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8l-4 4h3c0 3.31-2.69 6-6 6-1.01 0-1.97-.25-2.8-.7l-1.46 1.46C8.97 19.54 10.43 20 12 20c4.42 0 8-3.58 8-8h3l-4-4zM6 12c0-3.31 2.69-6 6-6 1.01 0 1.97.25 2.8.7l1.46-1.46C15.03 4.46 13.57 4 12 4c-4.42 0-8 3.58-8 8H1l4 4 4-4H6z' })
	  );
	};
	ActionCached = (0, _pure2.default)(ActionCached);
	ActionCached.displayName = 'ActionCached';
	ActionCached.muiName = 'SvgIcon';
	
	exports.default = ActionCached;

/***/ },
/* 918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCameraEnhance = function ActionCameraEnhance(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 3L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2h-3.17L15 3H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-1l1.25-2.75L16 13l-2.75-1.25L12 9l-1.25 2.75L8 13l2.75 1.25z' })
	  );
	};
	ActionCameraEnhance = (0, _pure2.default)(ActionCameraEnhance);
	ActionCameraEnhance.displayName = 'ActionCameraEnhance';
	ActionCameraEnhance.muiName = 'SvgIcon';
	
	exports.default = ActionCameraEnhance;

/***/ },
/* 919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCardGiftcard = function ActionCardGiftcard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z' })
	  );
	};
	ActionCardGiftcard = (0, _pure2.default)(ActionCardGiftcard);
	ActionCardGiftcard.displayName = 'ActionCardGiftcard';
	ActionCardGiftcard.muiName = 'SvgIcon';
	
	exports.default = ActionCardGiftcard;

/***/ },
/* 920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCardMembership = function ActionCardMembership(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h4v5l4-2 4 2v-5h4c1.11 0 2-.89 2-2V4c0-1.11-.89-2-2-2zm0 13H4v-2h16v2zm0-5H4V4h16v6z' })
	  );
	};
	ActionCardMembership = (0, _pure2.default)(ActionCardMembership);
	ActionCardMembership.displayName = 'ActionCardMembership';
	ActionCardMembership.muiName = 'SvgIcon';
	
	exports.default = ActionCardMembership;

/***/ },
/* 921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCardTravel = function ActionCardTravel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-3V4c0-1.11-.89-2-2-2H9c-1.11 0-2 .89-2 2v2H4c-1.11 0-2 .89-2 2v11c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zM9 4h6v2H9V4zm11 15H4v-2h16v2zm0-5H4V8h3v2h2V8h6v2h2V8h3v6z' })
	  );
	};
	ActionCardTravel = (0, _pure2.default)(ActionCardTravel);
	ActionCardTravel.displayName = 'ActionCardTravel';
	ActionCardTravel.muiName = 'SvgIcon';
	
	exports.default = ActionCardTravel;

/***/ },
/* 922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionChangeHistory = function ActionChangeHistory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7.77L18.39 18H5.61L12 7.77M12 4L2 20h20L12 4z' })
	  );
	};
	ActionChangeHistory = (0, _pure2.default)(ActionChangeHistory);
	ActionChangeHistory.displayName = 'ActionChangeHistory';
	ActionChangeHistory.muiName = 'SvgIcon';
	
	exports.default = ActionChangeHistory;

/***/ },
/* 923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionChromeReaderMode = function ActionChromeReaderMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 12h7v1.5h-7zm0-2.5h7V11h-7zm0 5h7V16h-7zM21 4H3c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 15h-9V6h9v13z' })
	  );
	};
	ActionChromeReaderMode = (0, _pure2.default)(ActionChromeReaderMode);
	ActionChromeReaderMode.displayName = 'ActionChromeReaderMode';
	ActionChromeReaderMode.muiName = 'SvgIcon';
	
	exports.default = ActionChromeReaderMode;

/***/ },
/* 924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionClass = function ActionClass(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4z' })
	  );
	};
	ActionClass = (0, _pure2.default)(ActionClass);
	ActionClass.displayName = 'ActionClass';
	ActionClass.muiName = 'SvgIcon';
	
	exports.default = ActionClass;

/***/ },
/* 925 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCode = function ActionCode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z' })
	  );
	};
	ActionCode = (0, _pure2.default)(ActionCode);
	ActionCode.displayName = 'ActionCode';
	ActionCode.muiName = 'SvgIcon';
	
	exports.default = ActionCode;

/***/ },
/* 926 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCompareArrows = function ActionCompareArrows(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.01 14H2v2h7.01v3L13 15l-3.99-4v3zm5.98-1v-3H22V8h-7.01V5L11 9l3.99 4z' })
	  );
	};
	ActionCompareArrows = (0, _pure2.default)(ActionCompareArrows);
	ActionCompareArrows.displayName = 'ActionCompareArrows';
	ActionCompareArrows.muiName = 'SvgIcon';
	
	exports.default = ActionCompareArrows;

/***/ },
/* 927 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCopyright = function ActionCopyright(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.08 10.86c.05-.33.16-.62.3-.87s.34-.46.59-.62c.24-.15.54-.22.91-.23.23.01.44.05.63.13.2.09.38.21.52.36s.25.33.34.53.13.42.14.64h1.79c-.02-.47-.11-.9-.28-1.29s-.4-.73-.7-1.01-.66-.5-1.08-.66-.88-.23-1.39-.23c-.65 0-1.22.11-1.7.34s-.88.53-1.2.92-.56.84-.71 1.36S8 11.29 8 11.87v.27c0 .58.08 1.12.23 1.64s.39.97.71 1.35.72.69 1.2.91 1.05.34 1.7.34c.47 0 .91-.08 1.32-.23s.77-.36 1.08-.63.56-.58.74-.94.29-.74.3-1.15h-1.79c-.01.21-.06.4-.15.58s-.21.33-.36.46-.32.23-.52.3c-.19.07-.39.09-.6.1-.36-.01-.66-.08-.89-.23-.25-.16-.45-.37-.59-.62s-.25-.55-.3-.88-.08-.67-.08-1v-.27c0-.35.03-.68.08-1.01zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ActionCopyright = (0, _pure2.default)(ActionCopyright);
	ActionCopyright.displayName = 'ActionCopyright';
	ActionCopyright.muiName = 'SvgIcon';
	
	exports.default = ActionCopyright;

/***/ },
/* 928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionCreditCard = function ActionCreditCard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
	  );
	};
	ActionCreditCard = (0, _pure2.default)(ActionCreditCard);
	ActionCreditCard.displayName = 'ActionCreditCard';
	ActionCreditCard.muiName = 'SvgIcon';
	
	exports.default = ActionCreditCard;

/***/ },
/* 929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDashboard = function ActionDashboard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z' })
	  );
	};
	ActionDashboard = (0, _pure2.default)(ActionDashboard);
	ActionDashboard.displayName = 'ActionDashboard';
	ActionDashboard.muiName = 'SvgIcon';
	
	exports.default = ActionDashboard;

/***/ },
/* 930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDateRange = function ActionDateRange(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11H7v2h2v-2zm4 0h-2v2h2v-2zm4 0h-2v2h2v-2zm2-7h-1V2h-2v2H8V2H6v2H5c-1.11 0-1.99.9-1.99 2L3 20c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H5V9h14v11z' })
	  );
	};
	ActionDateRange = (0, _pure2.default)(ActionDateRange);
	ActionDateRange.displayName = 'ActionDateRange';
	ActionDateRange.muiName = 'SvgIcon';
	
	exports.default = ActionDateRange;

/***/ },
/* 931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDeleteForever = function ActionDeleteForever(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zm2.46-7.12l1.41-1.41L12 12.59l2.12-2.12 1.41 1.41L13.41 14l2.12 2.12-1.41 1.41L12 15.41l-2.12 2.12-1.41-1.41L10.59 14l-2.13-2.12zM15.5 4l-1-1h-5l-1 1H5v2h14V4z' })
	  );
	};
	ActionDeleteForever = (0, _pure2.default)(ActionDeleteForever);
	ActionDeleteForever.displayName = 'ActionDeleteForever';
	ActionDeleteForever.muiName = 'SvgIcon';
	
	exports.default = ActionDeleteForever;

/***/ },
/* 932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDelete = function ActionDelete(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V7H6v12zM19 4h-3.5l-1-1h-5l-1 1H5v2h14V4z' })
	  );
	};
	ActionDelete = (0, _pure2.default)(ActionDelete);
	ActionDelete.displayName = 'ActionDelete';
	ActionDelete.muiName = 'SvgIcon';
	
	exports.default = ActionDelete;

/***/ },
/* 933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDescription = function ActionDescription(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z' })
	  );
	};
	ActionDescription = (0, _pure2.default)(ActionDescription);
	ActionDescription.displayName = 'ActionDescription';
	ActionDescription.muiName = 'SvgIcon';
	
	exports.default = ActionDescription;

/***/ },
/* 934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDns = function ActionDns(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 13H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zM7 19c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM20 3H4c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h16c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1zM7 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ActionDns = (0, _pure2.default)(ActionDns);
	ActionDns.displayName = 'ActionDns';
	ActionDns.muiName = 'SvgIcon';
	
	exports.default = ActionDns;

/***/ },
/* 935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDoneAll = function ActionDoneAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 7l-1.41-1.41-6.34 6.34 1.41 1.41L18 7zm4.24-1.41L11.66 16.17 7.48 12l-1.41 1.41L11.66 19l12-12-1.42-1.41zM.41 13.41L6 19l1.41-1.41L1.83 12 .41 13.41z' })
	  );
	};
	ActionDoneAll = (0, _pure2.default)(ActionDoneAll);
	ActionDoneAll.displayName = 'ActionDoneAll';
	ActionDoneAll.muiName = 'SvgIcon';
	
	exports.default = ActionDoneAll;

/***/ },
/* 936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDone = function ActionDone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16.2L4.8 12l-1.4 1.4L9 19 21 7l-1.4-1.4L9 16.2z' })
	  );
	};
	ActionDone = (0, _pure2.default)(ActionDone);
	ActionDone.displayName = 'ActionDone';
	ActionDone.muiName = 'SvgIcon';
	
	exports.default = ActionDone;

/***/ },
/* 937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDonutLarge = function ActionDonutLarge(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 5.08V2c-5 .5-9 4.81-9 10s4 9.5 9 10v-3.08c-3-.48-6-3.4-6-6.92s3-6.44 6-6.92zM18.97 11H22c-.47-5-4-8.53-9-9v3.08C16 5.51 18.54 8 18.97 11zM13 18.92V22c5-.47 8.53-4 9-9h-3.03c-.43 3-2.97 5.49-5.97 5.92z' })
	  );
	};
	ActionDonutLarge = (0, _pure2.default)(ActionDonutLarge);
	ActionDonutLarge.displayName = 'ActionDonutLarge';
	ActionDonutLarge.muiName = 'SvgIcon';
	
	exports.default = ActionDonutLarge;

/***/ },
/* 938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionDonutSmall = function ActionDonutSmall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9.16V2c-5 .5-9 4.79-9 10s4 9.5 9 10v-7.16c-1-.41-2-1.52-2-2.84s1-2.43 2-2.84zM14.86 11H22c-.48-4.75-4-8.53-9-9v7.16c1 .3 1.52.98 1.86 1.84zM13 14.84V22c5-.47 8.52-4.25 9-9h-7.14c-.34.86-.86 1.54-1.86 1.84z' })
	  );
	};
	ActionDonutSmall = (0, _pure2.default)(ActionDonutSmall);
	ActionDonutSmall.displayName = 'ActionDonutSmall';
	ActionDonutSmall.muiName = 'SvgIcon';
	
	exports.default = ActionDonutSmall;

/***/ },
/* 939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEject = function ActionEject(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 17h14v2H5zm7-12L5.33 15h13.34z' })
	  );
	};
	ActionEject = (0, _pure2.default)(ActionEject);
	ActionEject.displayName = 'ActionEject';
	ActionEject.muiName = 'SvgIcon';
	
	exports.default = ActionEject;

/***/ },
/* 940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEuroSymbol = function ActionEuroSymbol(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 18.5c-2.51 0-4.68-1.42-5.76-3.5H15v-2H8.58c-.05-.33-.08-.66-.08-1s.03-.67.08-1H15V9H9.24C10.32 6.92 12.5 5.5 15 5.5c1.61 0 3.09.59 4.23 1.57L21 5.3C19.41 3.87 17.3 3 15 3c-3.92 0-7.24 2.51-8.48 6H3v2h3.06c-.04.33-.06.66-.06 1 0 .34.02.67.06 1H3v2h3.52c1.24 3.49 4.56 6 8.48 6 2.31 0 4.41-.87 6-2.3l-1.78-1.77c-1.13.98-2.6 1.57-4.22 1.57z' })
	  );
	};
	ActionEuroSymbol = (0, _pure2.default)(ActionEuroSymbol);
	ActionEuroSymbol.displayName = 'ActionEuroSymbol';
	ActionEuroSymbol.muiName = 'SvgIcon';
	
	exports.default = ActionEuroSymbol;

/***/ },
/* 941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEventSeat = function ActionEventSeat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18v3h3v-3h10v3h3v-6H4zm15-8h3v3h-3zM2 10h3v3H2zm15 3H7V5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v8z' })
	  );
	};
	ActionEventSeat = (0, _pure2.default)(ActionEventSeat);
	ActionEventSeat.displayName = 'ActionEventSeat';
	ActionEventSeat.muiName = 'SvgIcon';
	
	exports.default = ActionEventSeat;

/***/ },
/* 942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionEvent = function ActionEvent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
	  );
	};
	ActionEvent = (0, _pure2.default)(ActionEvent);
	ActionEvent.displayName = 'ActionEvent';
	ActionEvent.muiName = 'SvgIcon';
	
	exports.default = ActionEvent;

/***/ },
/* 943 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionExitToApp = function ActionExitToApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.09 15.59L11.5 17l5-5-5-5-1.41 1.41L12.67 11H3v2h9.67l-2.58 2.59zM19 3H5c-1.11 0-2 .9-2 2v4h2V5h14v14H5v-4H3v4c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionExitToApp = (0, _pure2.default)(ActionExitToApp);
	ActionExitToApp.displayName = 'ActionExitToApp';
	ActionExitToApp.muiName = 'SvgIcon';
	
	exports.default = ActionExitToApp;

/***/ },
/* 944 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionExplore = function ActionExplore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 10.9c-.61 0-1.1.49-1.1 1.1s.49 1.1 1.1 1.1c.61 0 1.1-.49 1.1-1.1s-.49-1.1-1.1-1.1zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm2.19 12.19L6 18l3.81-8.19L18 6l-3.81 8.19z' })
	  );
	};
	ActionExplore = (0, _pure2.default)(ActionExplore);
	ActionExplore.displayName = 'ActionExplore';
	ActionExplore.muiName = 'SvgIcon';
	
	exports.default = ActionExplore;

/***/ },
/* 945 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionExtension = function ActionExtension(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.5 11H19V7c0-1.1-.9-2-2-2h-4V3.5C13 2.12 11.88 1 10.5 1S8 2.12 8 3.5V5H4c-1.1 0-1.99.9-1.99 2v3.8H3.5c1.49 0 2.7 1.21 2.7 2.7s-1.21 2.7-2.7 2.7H2V20c0 1.1.9 2 2 2h3.8v-1.5c0-1.49 1.21-2.7 2.7-2.7 1.49 0 2.7 1.21 2.7 2.7V22H17c1.1 0 2-.9 2-2v-4h1.5c1.38 0 2.5-1.12 2.5-2.5S21.88 11 20.5 11z' })
	  );
	};
	ActionExtension = (0, _pure2.default)(ActionExtension);
	ActionExtension.displayName = 'ActionExtension';
	ActionExtension.muiName = 'SvgIcon';
	
	exports.default = ActionExtension;

/***/ },
/* 946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFace = function ActionFace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11.75c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zm6 0c-.69 0-1.25.56-1.25 1.25s.56 1.25 1.25 1.25 1.25-.56 1.25-1.25-.56-1.25-1.25-1.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8 0-.29.02-.58.05-.86 2.36-1.05 4.23-2.98 5.21-5.37C11.07 8.33 14.05 10 17.42 10c.78 0 1.53-.09 2.25-.26.21.71.33 1.47.33 2.26 0 4.41-3.59 8-8 8z' })
	  );
	};
	ActionFace = (0, _pure2.default)(ActionFace);
	ActionFace.displayName = 'ActionFace';
	ActionFace.muiName = 'SvgIcon';
	
	exports.default = ActionFace;

/***/ },
/* 947 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFavoriteBorder = function ActionFavoriteBorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 3c-1.74 0-3.41.81-4.5 2.09C10.91 3.81 9.24 3 7.5 3 4.42 3 2 5.42 2 8.5c0 3.78 3.4 6.86 8.55 11.54L12 21.35l1.45-1.32C18.6 15.36 22 12.28 22 8.5 22 5.42 19.58 3 16.5 3zm-4.4 15.55l-.1.1-.1-.1C7.14 14.24 4 11.39 4 8.5 4 6.5 5.5 5 7.5 5c1.54 0 3.04.99 3.57 2.36h1.87C13.46 5.99 14.96 5 16.5 5c2 0 3.5 1.5 3.5 3.5 0 2.89-3.14 5.74-7.9 10.05z' })
	  );
	};
	ActionFavoriteBorder = (0, _pure2.default)(ActionFavoriteBorder);
	ActionFavoriteBorder.displayName = 'ActionFavoriteBorder';
	ActionFavoriteBorder.muiName = 'SvgIcon';
	
	exports.default = ActionFavoriteBorder;

/***/ },
/* 948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFavorite = function ActionFavorite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z' })
	  );
	};
	ActionFavorite = (0, _pure2.default)(ActionFavorite);
	ActionFavorite.displayName = 'ActionFavorite';
	ActionFavorite.muiName = 'SvgIcon';
	
	exports.default = ActionFavorite;

/***/ },
/* 949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFeedback = function ActionFeedback(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
	  );
	};
	ActionFeedback = (0, _pure2.default)(ActionFeedback);
	ActionFeedback.displayName = 'ActionFeedback';
	ActionFeedback.muiName = 'SvgIcon';
	
	exports.default = ActionFeedback;

/***/ },
/* 950 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFindInPage = function ActionFindInPage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 19.59V8l-6-6H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c.45 0 .85-.15 1.19-.4l-4.43-4.43c-.8.52-1.74.83-2.76.83-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5c0 1.02-.31 1.96-.83 2.75L20 19.59zM9 13c0 1.66 1.34 3 3 3s3-1.34 3-3-1.34-3-3-3-3 1.34-3 3z' })
	  );
	};
	ActionFindInPage = (0, _pure2.default)(ActionFindInPage);
	ActionFindInPage.displayName = 'ActionFindInPage';
	ActionFindInPage.muiName = 'SvgIcon';
	
	exports.default = ActionFindInPage;

/***/ },
/* 951 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFindReplace = function ActionFindReplace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 6c1.38 0 2.63.56 3.54 1.46L12 10h6V4l-2.05 2.05C14.68 4.78 12.93 4 11 4c-3.53 0-6.43 2.61-6.92 6H6.1c.46-2.28 2.48-4 4.9-4zm5.64 9.14c.66-.9 1.12-1.97 1.28-3.14H15.9c-.46 2.28-2.48 4-4.9 4-1.38 0-2.63-.56-3.54-1.46L10 12H4v6l2.05-2.05C7.32 17.22 9.07 18 11 18c1.55 0 2.98-.51 4.14-1.36L20 21.49 21.49 20l-4.85-4.86z' })
	  );
	};
	ActionFindReplace = (0, _pure2.default)(ActionFindReplace);
	ActionFindReplace.displayName = 'ActionFindReplace';
	ActionFindReplace.muiName = 'SvgIcon';
	
	exports.default = ActionFindReplace;

/***/ },
/* 952 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFingerprint = function ActionFingerprint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.81 4.47c-.08 0-.16-.02-.23-.06C15.66 3.42 14 3 12.01 3c-1.98 0-3.86.47-5.57 1.41-.24.13-.54.04-.68-.2-.13-.24-.04-.55.2-.68C7.82 2.52 9.86 2 12.01 2c2.13 0 3.99.47 6.03 1.52.25.13.34.43.21.67-.09.18-.26.28-.44.28zM3.5 9.72c-.1 0-.2-.03-.29-.09-.23-.16-.28-.47-.12-.7.99-1.4 2.25-2.5 3.75-3.27C9.98 4.04 14 4.03 17.15 5.65c1.5.77 2.76 1.86 3.75 3.25.16.22.11.54-.12.7-.23.16-.54.11-.7-.12-.9-1.26-2.04-2.25-3.39-2.94-2.87-1.47-6.54-1.47-9.4.01-1.36.7-2.5 1.7-3.4 2.96-.08.14-.23.21-.39.21zm6.25 12.07c-.13 0-.26-.05-.35-.15-.87-.87-1.34-1.43-2.01-2.64-.69-1.23-1.05-2.73-1.05-4.34 0-2.97 2.54-5.39 5.66-5.39s5.66 2.42 5.66 5.39c0 .28-.22.5-.5.5s-.5-.22-.5-.5c0-2.42-2.09-4.39-4.66-4.39-2.57 0-4.66 1.97-4.66 4.39 0 1.44.32 2.77.93 3.85.64 1.15 1.08 1.64 1.85 2.42.19.2.19.51 0 .71-.11.1-.24.15-.37.15zm7.17-1.85c-1.19 0-2.24-.3-3.1-.89-1.49-1.01-2.38-2.65-2.38-4.39 0-.28.22-.5.5-.5s.5.22.5.5c0 1.41.72 2.74 1.94 3.56.71.48 1.54.71 2.54.71.24 0 .64-.03 1.04-.1.27-.05.53.13.58.41.05.27-.13.53-.41.58-.57.11-1.07.12-1.21.12zM14.91 22c-.04 0-.09-.01-.13-.02-1.59-.44-2.63-1.03-3.72-2.1-1.4-1.39-2.17-3.24-2.17-5.22 0-1.62 1.38-2.94 3.08-2.94 1.7 0 3.08 1.32 3.08 2.94 0 1.07.93 1.94 2.08 1.94s2.08-.87 2.08-1.94c0-3.77-3.25-6.83-7.25-6.83-2.84 0-5.44 1.58-6.61 4.03-.39.81-.59 1.76-.59 2.8 0 .78.07 2.01.67 3.61.1.26-.03.55-.29.64-.26.1-.55-.04-.64-.29-.49-1.31-.73-2.61-.73-3.96 0-1.2.23-2.29.68-3.24 1.33-2.79 4.28-4.6 7.51-4.6 4.55 0 8.25 3.51 8.25 7.83 0 1.62-1.38 2.94-3.08 2.94s-3.08-1.32-3.08-2.94c0-1.07-.93-1.94-2.08-1.94s-2.08.87-2.08 1.94c0 1.71.66 3.31 1.87 4.51.95.94 1.86 1.46 3.27 1.85.27.07.42.35.35.61-.05.23-.26.38-.47.38z' })
	  );
	};
	ActionFingerprint = (0, _pure2.default)(ActionFingerprint);
	ActionFingerprint.displayName = 'ActionFingerprint';
	ActionFingerprint.muiName = 'SvgIcon';
	
	exports.default = ActionFingerprint;

/***/ },
/* 953 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlightLand = function ActionFlightLand(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.5 19h19v2h-19zm7.18-5.73l4.35 1.16 5.31 1.42c.8.21 1.62-.26 1.84-1.06.21-.8-.26-1.62-1.06-1.84l-5.31-1.42-2.76-9.02L10.12 2v8.28L5.15 8.95l-.93-2.32-1.45-.39v5.17l1.6.43 5.31 1.43z' })
	  );
	};
	ActionFlightLand = (0, _pure2.default)(ActionFlightLand);
	ActionFlightLand.displayName = 'ActionFlightLand';
	ActionFlightLand.muiName = 'SvgIcon';
	
	exports.default = ActionFlightLand;

/***/ },
/* 954 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlightTakeoff = function ActionFlightTakeoff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.5 19h19v2h-19zm19.57-9.36c-.21-.8-1.04-1.28-1.84-1.06L14.92 10l-6.9-6.43-1.93.51 4.14 7.17-4.97 1.33-1.97-1.54-1.45.39 1.82 3.16.77 1.33 1.6-.43 5.31-1.42 4.35-1.16L21 11.49c.81-.23 1.28-1.05 1.07-1.85z' })
	  );
	};
	ActionFlightTakeoff = (0, _pure2.default)(ActionFlightTakeoff);
	ActionFlightTakeoff.displayName = 'ActionFlightTakeoff';
	ActionFlightTakeoff.muiName = 'SvgIcon';
	
	exports.default = ActionFlightTakeoff;

/***/ },
/* 955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlipToBack = function ActionFlipToBack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 7H7v2h2V7zm0 4H7v2h2v-2zm0-8c-1.11 0-2 .9-2 2h2V3zm4 12h-2v2h2v-2zm6-12v2h2c0-1.1-.9-2-2-2zm-6 0h-2v2h2V3zM9 17v-2H7c0 1.1.89 2 2 2zm10-4h2v-2h-2v2zm0-4h2V7h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zM5 7H3v12c0 1.1.89 2 2 2h12v-2H5V7zm10-2h2V3h-2v2zm0 12h2v-2h-2v2z' })
	  );
	};
	ActionFlipToBack = (0, _pure2.default)(ActionFlipToBack);
	ActionFlipToBack.displayName = 'ActionFlipToBack';
	ActionFlipToBack.muiName = 'SvgIcon';
	
	exports.default = ActionFlipToBack;

/***/ },
/* 956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionFlipToFront = function ActionFlipToFront(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm2 4v-2H3c0 1.1.89 2 2 2zM3 9h2V7H3v2zm12 12h2v-2h-2v2zm4-18H9c-1.11 0-2 .9-2 2v10c0 1.1.89 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12H9V5h10v10zm-8 6h2v-2h-2v2zm-4 0h2v-2H7v2z' })
	  );
	};
	ActionFlipToFront = (0, _pure2.default)(ActionFlipToFront);
	ActionFlipToFront.displayName = 'ActionFlipToFront';
	ActionFlipToFront.muiName = 'SvgIcon';
	
	exports.default = ActionFlipToFront;

/***/ },
/* 957 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGTranslate = function ActionGTranslate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5h-9.12L10 2H4c-1.1 0-2 .9-2 2v13c0 1.1.9 2 2 2h7l1 3h8c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zM7.17 14.59c-2.25 0-4.09-1.83-4.09-4.09s1.83-4.09 4.09-4.09c1.04 0 1.99.37 2.74 1.07l.07.06-1.23 1.18-.06-.05c-.29-.27-.78-.59-1.52-.59-1.31 0-2.38 1.09-2.38 2.42s1.07 2.42 2.38 2.42c1.37 0 1.96-.87 2.12-1.46H7.08V9.91h3.95l.01.07c.04.21.05.4.05.61 0 2.35-1.61 4-3.92 4zm6.03-1.71c.33.6.74 1.18 1.19 1.7l-.54.53-.65-2.23zm.77-.76h-.99l-.31-1.04h3.99s-.34 1.31-1.56 2.74c-.52-.62-.89-1.23-1.13-1.7zM21 20c0 .55-.45 1-1 1h-7l2-2-.81-2.77.92-.92L17.79 18l.73-.73-2.71-2.68c.9-1.03 1.6-2.25 1.92-3.51H19v-1.04h-3.64V9h-1.04v1.04h-1.96L11.18 6H20c.55 0 1 .45 1 1v13z' })
	  );
	};
	ActionGTranslate = (0, _pure2.default)(ActionGTranslate);
	ActionGTranslate.displayName = 'ActionGTranslate';
	ActionGTranslate.muiName = 'SvgIcon';
	
	exports.default = ActionGTranslate;

/***/ },
/* 958 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGavel = function ActionGavel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h12v2H1zM5.245 8.07l2.83-2.827 14.14 14.142-2.828 2.828zM12.317 1l5.657 5.656-2.83 2.83-5.654-5.66zM3.825 9.485l5.657 5.657-2.828 2.828-5.657-5.657z' })
	  );
	};
	ActionGavel = (0, _pure2.default)(ActionGavel);
	ActionGavel.displayName = 'ActionGavel';
	ActionGavel.muiName = 'SvgIcon';
	
	exports.default = ActionGavel;

/***/ },
/* 959 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGetApp = function ActionGetApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
	  );
	};
	ActionGetApp = (0, _pure2.default)(ActionGetApp);
	ActionGetApp.displayName = 'ActionGetApp';
	ActionGetApp.muiName = 'SvgIcon';
	
	exports.default = ActionGetApp;

/***/ },
/* 960 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGif = function ActionGif(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.5 9H13v6h-1.5zM9 9H6c-.6 0-1 .5-1 1v4c0 .5.4 1 1 1h3c.6 0 1-.5 1-1v-2H8.5v1.5h-2v-3H10V10c0-.5-.4-1-1-1zm10 1.5V9h-4.5v6H16v-2h2v-1.5h-2v-1z' })
	  );
	};
	ActionGif = (0, _pure2.default)(ActionGif);
	ActionGif.displayName = 'ActionGif';
	ActionGif.muiName = 'SvgIcon';
	
	exports.default = ActionGif;

/***/ },
/* 961 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGrade = function ActionGrade(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
	  );
	};
	ActionGrade = (0, _pure2.default)(ActionGrade);
	ActionGrade.displayName = 'ActionGrade';
	ActionGrade.muiName = 'SvgIcon';
	
	exports.default = ActionGrade;

/***/ },
/* 962 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionGroupWork = function ActionGroupWork(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM8 17.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5zM9.5 8c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8zm6.5 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	ActionGroupWork = (0, _pure2.default)(ActionGroupWork);
	ActionGroupWork.displayName = 'ActionGroupWork';
	ActionGroupWork.muiName = 'SvgIcon';
	
	exports.default = ActionGroupWork;

/***/ },
/* 963 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHelpOutline = function ActionHelpOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z' })
	  );
	};
	ActionHelpOutline = (0, _pure2.default)(ActionHelpOutline);
	ActionHelpOutline.displayName = 'ActionHelpOutline';
	ActionHelpOutline.muiName = 'SvgIcon';
	
	exports.default = ActionHelpOutline;

/***/ },
/* 964 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHelp = function ActionHelp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 17h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 12.9 13 13.5 13 15h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
	  );
	};
	ActionHelp = (0, _pure2.default)(ActionHelp);
	ActionHelp.displayName = 'ActionHelp';
	ActionHelp.muiName = 'SvgIcon';
	
	exports.default = ActionHelp;

/***/ },
/* 965 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHighlightOff = function ActionHighlightOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.59 8L12 10.59 9.41 8 8 9.41 10.59 12 8 14.59 9.41 16 12 13.41 14.59 16 16 14.59 13.41 12 16 9.41 14.59 8zM12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ActionHighlightOff = (0, _pure2.default)(ActionHighlightOff);
	ActionHighlightOff.displayName = 'ActionHighlightOff';
	ActionHighlightOff.muiName = 'SvgIcon';
	
	exports.default = ActionHighlightOff;

/***/ },
/* 966 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHistory = function ActionHistory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
	  );
	};
	ActionHistory = (0, _pure2.default)(ActionHistory);
	ActionHistory.displayName = 'ActionHistory';
	ActionHistory.muiName = 'SvgIcon';
	
	exports.default = ActionHistory;

/***/ },
/* 967 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHome = function ActionHome(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20v-6h4v6h5v-8h3L12 3 2 12h3v8z' })
	  );
	};
	ActionHome = (0, _pure2.default)(ActionHome);
	ActionHome.displayName = 'ActionHome';
	ActionHome.muiName = 'SvgIcon';
	
	exports.default = ActionHome;

/***/ },
/* 968 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHourglassEmpty = function ActionHourglassEmpty(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6zm10 14.5V20H8v-3.5l4-4 4 4zm-4-5l-4-4V4h8v3.5l-4 4z' })
	  );
	};
	ActionHourglassEmpty = (0, _pure2.default)(ActionHourglassEmpty);
	ActionHourglassEmpty.displayName = 'ActionHourglassEmpty';
	ActionHourglassEmpty.muiName = 'SvgIcon';
	
	exports.default = ActionHourglassEmpty;

/***/ },
/* 969 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHourglassFull = function ActionHourglassFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 2v6h.01L6 8.01 10 12l-4 4 .01.01H6V22h12v-5.99h-.01L18 16l-4-4 4-3.99-.01-.01H18V2H6z' })
	  );
	};
	ActionHourglassFull = (0, _pure2.default)(ActionHourglassFull);
	ActionHourglassFull.displayName = 'ActionHourglassFull';
	ActionHourglassFull.muiName = 'SvgIcon';
	
	exports.default = ActionHourglassFull;

/***/ },
/* 970 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHttp = function ActionHttp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4.5 11h-2V9H1v6h1.5v-2.5h2V15H6V9H4.5v2zm2.5-.5h1.5V15H10v-4.5h1.5V9H7v1.5zm5.5 0H14V15h1.5v-4.5H17V9h-4.5v1.5zm9-1.5H18v6h1.5v-2h2c.8 0 1.5-.7 1.5-1.5v-1c0-.8-.7-1.5-1.5-1.5zm0 2.5h-2v-1h2v1z' })
	  );
	};
	ActionHttp = (0, _pure2.default)(ActionHttp);
	ActionHttp.displayName = 'ActionHttp';
	ActionHttp.muiName = 'SvgIcon';
	
	exports.default = ActionHttp;

/***/ },
/* 971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionHttps = function ActionHttps(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
	  );
	};
	ActionHttps = (0, _pure2.default)(ActionHttps);
	ActionHttps.displayName = 'ActionHttps';
	ActionHttps.muiName = 'SvgIcon';
	
	exports.default = ActionHttps;

/***/ },
/* 972 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionImportantDevices = function ActionImportantDevices(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 11.01L18 11c-.55 0-1 .45-1 1v9c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-9c0-.55-.45-.99-1-.99zM23 20h-5v-7h5v7zM20 2H2C.89 2 0 2.89 0 4v12c0 1.1.89 2 2 2h7v2H7v2h8v-2h-2v-2h2v-2H2V4h18v5h2V4c0-1.11-.9-2-2-2zm-8.03 7L11 6l-.97 3H7l2.47 1.76-.94 2.91 2.47-1.8 2.47 1.8-.94-2.91L15 9h-3.03z' })
	  );
	};
	ActionImportantDevices = (0, _pure2.default)(ActionImportantDevices);
	ActionImportantDevices.displayName = 'ActionImportantDevices';
	ActionImportantDevices.muiName = 'SvgIcon';
	
	exports.default = ActionImportantDevices;

/***/ },
/* 973 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInfoOutline = function ActionInfoOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17h2v-6h-2v6zm1-15C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zM11 9h2V7h-2v2z' })
	  );
	};
	ActionInfoOutline = (0, _pure2.default)(ActionInfoOutline);
	ActionInfoOutline.displayName = 'ActionInfoOutline';
	ActionInfoOutline.muiName = 'SvgIcon';
	
	exports.default = ActionInfoOutline;

/***/ },
/* 974 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInfo = function ActionInfo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z' })
	  );
	};
	ActionInfo = (0, _pure2.default)(ActionInfo);
	ActionInfo.displayName = 'ActionInfo';
	ActionInfo.muiName = 'SvgIcon';
	
	exports.default = ActionInfo;

/***/ },
/* 975 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInput = function ActionInput(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3.01H3c-1.1 0-2 .9-2 2V9h2V4.99h18v14.03H3V15H1v4.01c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98v-14c0-1.11-.9-2-2-2zM11 16l4-4-4-4v3H1v2h10v3z' })
	  );
	};
	ActionInput = (0, _pure2.default)(ActionInput);
	ActionInput.displayName = 'ActionInput';
	ActionInput.muiName = 'SvgIcon';
	
	exports.default = ActionInput;

/***/ },
/* 976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionInvertColors = function ActionInvertColors(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.66 7.93L12 2.27 6.34 7.93c-3.12 3.12-3.12 8.19 0 11.31C7.9 20.8 9.95 21.58 12 21.58c2.05 0 4.1-.78 5.66-2.34 3.12-3.12 3.12-8.19 0-11.31zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59s.62-3.11 1.76-4.24L12 5.1v14.49z' })
	  );
	};
	ActionInvertColors = (0, _pure2.default)(ActionInvertColors);
	ActionInvertColors.displayName = 'ActionInvertColors';
	ActionInvertColors.muiName = 'SvgIcon';
	
	exports.default = ActionInvertColors;

/***/ },
/* 977 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLabelOutline = function ActionLabelOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16zM16 17H5V7h11l3.55 5L16 17z' })
	  );
	};
	ActionLabelOutline = (0, _pure2.default)(ActionLabelOutline);
	ActionLabelOutline.displayName = 'ActionLabelOutline';
	ActionLabelOutline.muiName = 'SvgIcon';
	
	exports.default = ActionLabelOutline;

/***/ },
/* 978 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLabel = function ActionLabel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.63 5.84C17.27 5.33 16.67 5 16 5L5 5.01C3.9 5.01 3 5.9 3 7v10c0 1.1.9 1.99 2 1.99L16 19c.67 0 1.27-.33 1.63-.84L22 12l-4.37-6.16z' })
	  );
	};
	ActionLabel = (0, _pure2.default)(ActionLabel);
	ActionLabel.displayName = 'ActionLabel';
	ActionLabel.muiName = 'SvgIcon';
	
	exports.default = ActionLabel;

/***/ },
/* 979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLanguage = function ActionLanguage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm6.93 6h-2.95c-.32-1.25-.78-2.45-1.38-3.56 1.84.63 3.37 1.91 4.33 3.56zM12 4.04c.83 1.2 1.48 2.53 1.91 3.96h-3.82c.43-1.43 1.08-2.76 1.91-3.96zM4.26 14C4.1 13.36 4 12.69 4 12s.1-1.36.26-2h3.38c-.08.66-.14 1.32-.14 2 0 .68.06 1.34.14 2H4.26zm.82 2h2.95c.32 1.25.78 2.45 1.38 3.56-1.84-.63-3.37-1.9-4.33-3.56zm2.95-8H5.08c.96-1.66 2.49-2.93 4.33-3.56C8.81 5.55 8.35 6.75 8.03 8zM12 19.96c-.83-1.2-1.48-2.53-1.91-3.96h3.82c-.43 1.43-1.08 2.76-1.91 3.96zM14.34 14H9.66c-.09-.66-.16-1.32-.16-2 0-.68.07-1.35.16-2h4.68c.09.65.16 1.32.16 2 0 .68-.07 1.34-.16 2zm.25 5.56c.6-1.11 1.06-2.31 1.38-3.56h2.95c-.96 1.65-2.49 2.93-4.33 3.56zM16.36 14c.08-.66.14-1.32.14-2 0-.68-.06-1.34-.14-2h3.38c.16.64.26 1.31.26 2s-.1 1.36-.26 2h-3.38z' })
	  );
	};
	ActionLanguage = (0, _pure2.default)(ActionLanguage);
	ActionLanguage.displayName = 'ActionLanguage';
	ActionLanguage.muiName = 'SvgIcon';
	
	exports.default = ActionLanguage;

/***/ },
/* 980 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLaunch = function ActionLaunch(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
	  );
	};
	ActionLaunch = (0, _pure2.default)(ActionLaunch);
	ActionLaunch.displayName = 'ActionLaunch';
	ActionLaunch.muiName = 'SvgIcon';
	
	exports.default = ActionLaunch;

/***/ },
/* 981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLightbulbOutline = function ActionLightbulbOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 21c0 .55.45 1 1 1h4c.55 0 1-.45 1-1v-1H9v1zm3-19C8.14 2 5 5.14 5 9c0 2.38 1.19 4.47 3 5.74V17c0 .55.45 1 1 1h6c.55 0 1-.45 1-1v-2.26c1.81-1.27 3-3.36 3-5.74 0-3.86-3.14-7-7-7zm2.85 11.1l-.85.6V16h-4v-2.3l-.85-.6C7.8 12.16 7 10.63 7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 1.63-.8 3.16-2.15 4.1z' })
	  );
	};
	ActionLightbulbOutline = (0, _pure2.default)(ActionLightbulbOutline);
	ActionLightbulbOutline.displayName = 'ActionLightbulbOutline';
	ActionLightbulbOutline.muiName = 'SvgIcon';
	
	exports.default = ActionLightbulbOutline;

/***/ },
/* 982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLineStyle = function ActionLineStyle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 16h5v-2H3v2zm6.5 0h5v-2h-5v2zm6.5 0h5v-2h-5v2zM3 20h2v-2H3v2zm4 0h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM3 12h8v-2H3v2zm10 0h8v-2h-8v2zM3 4v4h18V4H3z' })
	  );
	};
	ActionLineStyle = (0, _pure2.default)(ActionLineStyle);
	ActionLineStyle.displayName = 'ActionLineStyle';
	ActionLineStyle.muiName = 'SvgIcon';
	
	exports.default = ActionLineStyle;

/***/ },
/* 983 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLineWeight = function ActionLineWeight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17h18v-2H3v2zm0 3h18v-1H3v1zm0-7h18v-3H3v3zm0-9v4h18V4H3z' })
	  );
	};
	ActionLineWeight = (0, _pure2.default)(ActionLineWeight);
	ActionLineWeight.displayName = 'ActionLineWeight';
	ActionLineWeight.muiName = 'SvgIcon';
	
	exports.default = ActionLineWeight;

/***/ },
/* 984 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionList = function ActionList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm4 4h14v-2H7v2zm0 4h14v-2H7v2zM7 7v2h14V7H7z' })
	  );
	};
	ActionList = (0, _pure2.default)(ActionList);
	ActionList.displayName = 'ActionList';
	ActionList.muiName = 'SvgIcon';
	
	exports.default = ActionList;

/***/ },
/* 985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLockOpen = function ActionLockOpen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6h1.9c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm0 12H6V10h12v10z' })
	  );
	};
	ActionLockOpen = (0, _pure2.default)(ActionLockOpen);
	ActionLockOpen.displayName = 'ActionLockOpen';
	ActionLockOpen.muiName = 'SvgIcon';
	
	exports.default = ActionLockOpen;

/***/ },
/* 986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLockOutline = function ActionLockOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm6-9h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM18 20H6V10h12v10z' })
	  );
	};
	ActionLockOutline = (0, _pure2.default)(ActionLockOutline);
	ActionLockOutline.displayName = 'ActionLockOutline';
	ActionLockOutline.muiName = 'SvgIcon';
	
	exports.default = ActionLockOutline;

/***/ },
/* 987 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLock = function ActionLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zm-6 9c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm3.1-9H8.9V6c0-1.71 1.39-3.1 3.1-3.1 1.71 0 3.1 1.39 3.1 3.1v2z' })
	  );
	};
	ActionLock = (0, _pure2.default)(ActionLock);
	ActionLock.displayName = 'ActionLock';
	ActionLock.muiName = 'SvgIcon';
	
	exports.default = ActionLock;

/***/ },
/* 988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionLoyalty = function ActionLoyalty(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7zm11.77 8.27L13 19.54l-4.27-4.27C8.28 14.81 8 14.19 8 13.5c0-1.38 1.12-2.5 2.5-2.5.69 0 1.32.28 1.77.74l.73.72.73-.73c.45-.45 1.08-.73 1.77-.73 1.38 0 2.5 1.12 2.5 2.5 0 .69-.28 1.32-.73 1.77z' })
	  );
	};
	ActionLoyalty = (0, _pure2.default)(ActionLoyalty);
	ActionLoyalty.displayName = 'ActionLoyalty';
	ActionLoyalty.muiName = 'SvgIcon';
	
	exports.default = ActionLoyalty;

/***/ },
/* 989 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionMarkunreadMailbox = function ActionMarkunreadMailbox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6H10v6H8V4h6V0H6v6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionMarkunreadMailbox = (0, _pure2.default)(ActionMarkunreadMailbox);
	ActionMarkunreadMailbox.displayName = 'ActionMarkunreadMailbox';
	ActionMarkunreadMailbox.muiName = 'SvgIcon';
	
	exports.default = ActionMarkunreadMailbox;

/***/ },
/* 990 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionMotorcycle = function ActionMotorcycle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.44 9.03L15.41 5H11v2h3.59l2 2H5c-2.8 0-5 2.2-5 5s2.2 5 5 5c2.46 0 4.45-1.69 4.9-4h1.65l2.77-2.77c-.21.54-.32 1.14-.32 1.77 0 2.8 2.2 5 5 5s5-2.2 5-5c0-2.65-1.97-4.77-4.56-4.97zM7.82 15C7.4 16.15 6.28 17 5 17c-1.63 0-3-1.37-3-3s1.37-3 3-3c1.28 0 2.4.85 2.82 2H5v2h2.82zM19 17c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3z' })
	  );
	};
	ActionMotorcycle = (0, _pure2.default)(ActionMotorcycle);
	ActionMotorcycle.displayName = 'ActionMotorcycle';
	ActionMotorcycle.muiName = 'SvgIcon';
	
	exports.default = ActionMotorcycle;

/***/ },
/* 991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionNoteAdd = function ActionNoteAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 14h-3v3h-2v-3H8v-2h3v-3h2v3h3v2zm-3-7V3.5L18.5 9H13z' })
	  );
	};
	ActionNoteAdd = (0, _pure2.default)(ActionNoteAdd);
	ActionNoteAdd.displayName = 'ActionNoteAdd';
	ActionNoteAdd.muiName = 'SvgIcon';
	
	exports.default = ActionNoteAdd;

/***/ },
/* 992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOfflinePin = function ActionOfflinePin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm5 16H7v-2h10v2zm-6.7-4L7 10.7l1.4-1.4 1.9 1.9 5.3-5.3L17 7.3 10.3 14z' })
	  );
	};
	ActionOfflinePin = (0, _pure2.default)(ActionOfflinePin);
	ActionOfflinePin.displayName = 'ActionOfflinePin';
	ActionOfflinePin.muiName = 'SvgIcon';
	
	exports.default = ActionOfflinePin;

/***/ },
/* 993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpacity = function ActionOpacity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.66 8L12 2.35 6.34 8C4.78 9.56 4 11.64 4 13.64s.78 4.11 2.34 5.67 3.61 2.35 5.66 2.35 4.1-.79 5.66-2.35S20 15.64 20 13.64 19.22 9.56 17.66 8zM6 14c.01-2 .62-3.27 1.76-4.4L12 5.27l4.24 4.38C17.38 10.77 17.99 12 18 14H6z' })
	  );
	};
	ActionOpacity = (0, _pure2.default)(ActionOpacity);
	ActionOpacity.displayName = 'ActionOpacity';
	ActionOpacity.muiName = 'SvgIcon';
	
	exports.default = ActionOpacity;

/***/ },
/* 994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenInBrowser = function ActionOpenInBrowser(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h4v-2H5V8h14v10h-4v2h4c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm-7 6l-4 4h3v6h2v-6h3l-4-4z' })
	  );
	};
	ActionOpenInBrowser = (0, _pure2.default)(ActionOpenInBrowser);
	ActionOpenInBrowser.displayName = 'ActionOpenInBrowser';
	ActionOpenInBrowser.muiName = 'SvgIcon';
	
	exports.default = ActionOpenInBrowser;

/***/ },
/* 995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenInNew = function ActionOpenInNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19H5V5h7V3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2v-7h-2v7zM14 3v2h3.59l-9.83 9.83 1.41 1.41L19 6.41V10h2V3h-7z' })
	  );
	};
	ActionOpenInNew = (0, _pure2.default)(ActionOpenInNew);
	ActionOpenInNew.displayName = 'ActionOpenInNew';
	ActionOpenInNew.muiName = 'SvgIcon';
	
	exports.default = ActionOpenInNew;

/***/ },
/* 996 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionOpenWith = function ActionOpenWith(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z' })
	  );
	};
	ActionOpenWith = (0, _pure2.default)(ActionOpenWith);
	ActionOpenWith.displayName = 'ActionOpenWith';
	ActionOpenWith.muiName = 'SvgIcon';
	
	exports.default = ActionOpenWith;

/***/ },
/* 997 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPageview = function ActionPageview(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.5 9C10.12 9 9 10.12 9 11.5s1.12 2.5 2.5 2.5 2.5-1.12 2.5-2.5S12.88 9 11.5 9zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-3.21 14.21l-2.91-2.91c-.69.44-1.51.7-2.39.7C9.01 16 7 13.99 7 11.5S9.01 7 11.5 7 16 9.01 16 11.5c0 .88-.26 1.69-.7 2.39l2.91 2.9-1.42 1.42z' })
	  );
	};
	ActionPageview = (0, _pure2.default)(ActionPageview);
	ActionPageview.displayName = 'ActionPageview';
	ActionPageview.muiName = 'SvgIcon';
	
	exports.default = ActionPageview;

/***/ },
/* 998 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPanTool = function ActionPanTool(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 5.5V20c0 2.2-1.8 4-4 4h-7.3c-1.08 0-2.1-.43-2.85-1.19L1 14.83s1.26-1.23 1.3-1.25c.22-.19.49-.29.79-.29.22 0 .42.06.6.16.04.01 4.31 2.46 4.31 2.46V4c0-.83.67-1.5 1.5-1.5S11 3.17 11 4v7h1V1.5c0-.83.67-1.5 1.5-1.5S15 .67 15 1.5V11h1V2.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V11h1V5.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5z' })
	  );
	};
	ActionPanTool = (0, _pure2.default)(ActionPanTool);
	ActionPanTool.displayName = 'ActionPanTool';
	ActionPanTool.muiName = 'SvgIcon';
	
	exports.default = ActionPanTool;

/***/ },
/* 999 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPayment = function ActionPayment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4v-6h16v6zm0-10H4V6h16v2z' })
	  );
	};
	ActionPayment = (0, _pure2.default)(ActionPayment);
	ActionPayment.displayName = 'ActionPayment';
	ActionPayment.muiName = 'SvgIcon';
	
	exports.default = ActionPayment;

/***/ },
/* 1000 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermCameraMic = function ActionPermCameraMic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5h-3.17L15 3H9L7.17 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v-2.09c-2.83-.48-5-2.94-5-5.91h2c0 2.21 1.79 4 4 4s4-1.79 4-4h2c0 2.97-2.17 5.43-5 5.91V21h7c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-6 8c0 1.1-.9 2-2 2s-2-.9-2-2V9c0-1.1.9-2 2-2s2 .9 2 2v4z' })
	  );
	};
	ActionPermCameraMic = (0, _pure2.default)(ActionPermCameraMic);
	ActionPermCameraMic.displayName = 'ActionPermCameraMic';
	ActionPermCameraMic.muiName = 'SvgIcon';
	
	exports.default = ActionPermCameraMic;

/***/ },
/* 1001 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermContactCalendar = function ActionPermContactCalendar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-7 3c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H6v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1z' })
	  );
	};
	ActionPermContactCalendar = (0, _pure2.default)(ActionPermContactCalendar);
	ActionPermContactCalendar.displayName = 'ActionPermContactCalendar';
	ActionPermContactCalendar.muiName = 'SvgIcon';
	
	exports.default = ActionPermContactCalendar;

/***/ },
/* 1002 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermDataSetting = function ActionPermDataSetting(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.99 11.5c.34 0 .67.03 1 .07L20 0 0 20h11.56c-.04-.33-.07-.66-.07-1 0-4.14 3.36-7.5 7.5-7.5zm3.71 7.99c.02-.16.04-.32.04-.49 0-.17-.01-.33-.04-.49l1.06-.83c.09-.08.12-.21.06-.32l-1-1.73c-.06-.11-.19-.15-.31-.11l-1.24.5c-.26-.2-.54-.37-.85-.49l-.19-1.32c-.01-.12-.12-.21-.24-.21h-2c-.12 0-.23.09-.25.21l-.19 1.32c-.3.13-.59.29-.85.49l-1.24-.5c-.11-.04-.24 0-.31.11l-1 1.73c-.06.11-.04.24.06.32l1.06.83c-.02.16-.03.32-.03.49 0 .17.01.33.03.49l-1.06.83c-.09.08-.12.21-.06.32l1 1.73c.06.11.19.15.31.11l1.24-.5c.26.2.54.37.85.49l.19 1.32c.02.12.12.21.25.21h2c.12 0 .23-.09.25-.21l.19-1.32c.3-.13.59-.29.84-.49l1.25.5c.11.04.24 0 .31-.11l1-1.73c.06-.11.03-.24-.06-.32l-1.07-.83zm-3.71 1.01c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ActionPermDataSetting = (0, _pure2.default)(ActionPermDataSetting);
	ActionPermDataSetting.displayName = 'ActionPermDataSetting';
	ActionPermDataSetting.muiName = 'SvgIcon';
	
	exports.default = ActionPermDataSetting;

/***/ },
/* 1003 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermDeviceInformation = function ActionPermDeviceInformation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v2h2V7zm0 4h-2v6h2v-6zm4-9.99L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	ActionPermDeviceInformation = (0, _pure2.default)(ActionPermDeviceInformation);
	ActionPermDeviceInformation.displayName = 'ActionPermDeviceInformation';
	ActionPermDeviceInformation.muiName = 'SvgIcon';
	
	exports.default = ActionPermDeviceInformation;

/***/ },
/* 1004 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermIdentity = function ActionPermIdentity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
	  );
	};
	ActionPermIdentity = (0, _pure2.default)(ActionPermIdentity);
	ActionPermIdentity.displayName = 'ActionPermIdentity';
	ActionPermIdentity.muiName = 'SvgIcon';
	
	exports.default = ActionPermIdentity;

/***/ },
/* 1005 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermMedia = function ActionPermMedia(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 6H0v5h.01L0 20c0 1.1.9 2 2 2h18v-2H2V6zm20-2h-8l-2-2H6c-1.1 0-1.99.9-1.99 2L4 16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7 15l4.5-6 3.5 4.51 2.5-3.01L21 15H7z' })
	  );
	};
	ActionPermMedia = (0, _pure2.default)(ActionPermMedia);
	ActionPermMedia.displayName = 'ActionPermMedia';
	ActionPermMedia.muiName = 'SvgIcon';
	
	exports.default = ActionPermMedia;

/***/ },
/* 1006 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermPhoneMsg = function ActionPermPhoneMsg(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM12 3v10l3-3h6V3h-9z' })
	  );
	};
	ActionPermPhoneMsg = (0, _pure2.default)(ActionPermPhoneMsg);
	ActionPermPhoneMsg.displayName = 'ActionPermPhoneMsg';
	ActionPermPhoneMsg.muiName = 'SvgIcon';
	
	exports.default = ActionPermPhoneMsg;

/***/ },
/* 1007 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPermScanWifi = function ActionPermScanWifi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3C6.95 3 3.15 4.85 0 7.23L12 22 24 7.25C20.85 4.87 17.05 3 12 3zm1 13h-2v-6h2v6zm-2-8V6h2v2h-2z' })
	  );
	};
	ActionPermScanWifi = (0, _pure2.default)(ActionPermScanWifi);
	ActionPermScanWifi.displayName = 'ActionPermScanWifi';
	ActionPermScanWifi.muiName = 'SvgIcon';
	
	exports.default = ActionPermScanWifi;

/***/ },
/* 1008 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPets = function ActionPets(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '4.5', cy: '9.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '9', cy: '5.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '15', cy: '5.5', r: '2.5' }),
	    _react2.default.createElement('circle', { cx: '19.5', cy: '9.5', r: '2.5' }),
	    _react2.default.createElement('path', { d: 'M17.34 14.86c-.87-1.02-1.6-1.89-2.48-2.91-.46-.54-1.05-1.08-1.75-1.32-.11-.04-.22-.07-.33-.09-.25-.04-.52-.04-.78-.04s-.53 0-.79.05c-.11.02-.22.05-.33.09-.7.24-1.28.78-1.75 1.32-.87 1.02-1.6 1.89-2.48 2.91-1.31 1.31-2.92 2.76-2.62 4.79.29 1.02 1.02 2.03 2.33 2.32.73.15 3.06-.44 5.54-.44h.18c2.48 0 4.81.58 5.54.44 1.31-.29 2.04-1.31 2.33-2.32.31-2.04-1.3-3.49-2.61-4.8z' })
	  );
	};
	ActionPets = (0, _pure2.default)(ActionPets);
	ActionPets.displayName = 'ActionPets';
	ActionPets.muiName = 'SvgIcon';
	
	exports.default = ActionPets;

/***/ },
/* 1009 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPictureInPictureAlt = function ActionPictureInPictureAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 11h-8v6h8v-6zm4 8V4.98C23 3.88 22.1 3 21 3H3c-1.1 0-2 .88-2 1.98V19c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zm-2 .02H3V4.97h18v14.05z' })
	  );
	};
	ActionPictureInPictureAlt = (0, _pure2.default)(ActionPictureInPictureAlt);
	ActionPictureInPictureAlt.displayName = 'ActionPictureInPictureAlt';
	ActionPictureInPictureAlt.muiName = 'SvgIcon';
	
	exports.default = ActionPictureInPictureAlt;

/***/ },
/* 1010 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPictureInPicture = function ActionPictureInPicture(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7h-8v6h8V7zm2-4H3c-1.1 0-2 .9-2 2v14c0 1.1.9 1.98 2 1.98h18c1.1 0 2-.88 2-1.98V5c0-1.1-.9-2-2-2zm0 16.01H3V4.98h18v14.03z' })
	  );
	};
	ActionPictureInPicture = (0, _pure2.default)(ActionPictureInPicture);
	ActionPictureInPicture.displayName = 'ActionPictureInPicture';
	ActionPictureInPicture.muiName = 'SvgIcon';
	
	exports.default = ActionPictureInPicture;

/***/ },
/* 1011 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPlayForWork = function ActionPlayForWork(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 5v5.59H7.5l4.5 4.5 4.5-4.5H13V5h-2zm-5 9c0 3.31 2.69 6 6 6s6-2.69 6-6h-2c0 2.21-1.79 4-4 4s-4-1.79-4-4H6z' })
	  );
	};
	ActionPlayForWork = (0, _pure2.default)(ActionPlayForWork);
	ActionPlayForWork.displayName = 'ActionPlayForWork';
	ActionPlayForWork.muiName = 'SvgIcon';
	
	exports.default = ActionPlayForWork;

/***/ },
/* 1012 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPolymer = function ActionPolymer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4h-4L7.11 16.63 4.5 12 9 4H5L.5 12 5 20h4l7.89-12.63L19.5 12 15 20h4l4.5-8z' })
	  );
	};
	ActionPolymer = (0, _pure2.default)(ActionPolymer);
	ActionPolymer.displayName = 'ActionPolymer';
	ActionPolymer.muiName = 'SvgIcon';
	
	exports.default = ActionPolymer;

/***/ },
/* 1013 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPowerSettingsNew = function ActionPowerSettingsNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3h-2v10h2V3zm4.83 2.17l-1.42 1.42C17.99 7.86 19 9.81 19 12c0 3.87-3.13 7-7 7s-7-3.13-7-7c0-2.19 1.01-4.14 2.58-5.42L6.17 5.17C4.23 6.82 3 9.26 3 12c0 4.97 4.03 9 9 9s9-4.03 9-9c0-2.74-1.23-5.18-3.17-6.83z' })
	  );
	};
	ActionPowerSettingsNew = (0, _pure2.default)(ActionPowerSettingsNew);
	ActionPowerSettingsNew.displayName = 'ActionPowerSettingsNew';
	ActionPowerSettingsNew.muiName = 'SvgIcon';
	
	exports.default = ActionPowerSettingsNew;

/***/ },
/* 1014 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPregnantWoman = function ActionPregnantWoman(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 4c0-1.11.89-2 2-2s2 .89 2 2-.89 2-2 2-2-.89-2-2zm7 9c-.01-1.34-.83-2.51-2-3 0-1.66-1.34-3-3-3s-3 1.34-3 3v7h2v5h3v-5h3v-4z' })
	  );
	};
	ActionPregnantWoman = (0, _pure2.default)(ActionPregnantWoman);
	ActionPregnantWoman.displayName = 'ActionPregnantWoman';
	ActionPregnantWoman.muiName = 'SvgIcon';
	
	exports.default = ActionPregnantWoman;

/***/ },
/* 1015 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionPrint = function ActionPrint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
	  );
	};
	ActionPrint = (0, _pure2.default)(ActionPrint);
	ActionPrint.displayName = 'ActionPrint';
	ActionPrint.muiName = 'SvgIcon';
	
	exports.default = ActionPrint;

/***/ },
/* 1016 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionQueryBuilder = function ActionQueryBuilder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
	  );
	};
	ActionQueryBuilder = (0, _pure2.default)(ActionQueryBuilder);
	ActionQueryBuilder.displayName = 'ActionQueryBuilder';
	ActionQueryBuilder.muiName = 'SvgIcon';
	
	exports.default = ActionQueryBuilder;

/***/ },
/* 1017 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionQuestionAnswer = function ActionQuestionAnswer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
	  );
	};
	ActionQuestionAnswer = (0, _pure2.default)(ActionQuestionAnswer);
	ActionQuestionAnswer.displayName = 'ActionQuestionAnswer';
	ActionQuestionAnswer.muiName = 'SvgIcon';
	
	exports.default = ActionQuestionAnswer;

/***/ },
/* 1018 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionReceipt = function ActionReceipt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 17H6v-2h12v2zm0-4H6v-2h12v2zm0-4H6V7h12v2zM3 22l1.5-1.5L6 22l1.5-1.5L9 22l1.5-1.5L12 22l1.5-1.5L15 22l1.5-1.5L18 22l1.5-1.5L21 22V2l-1.5 1.5L18 2l-1.5 1.5L15 2l-1.5 1.5L12 2l-1.5 1.5L9 2 7.5 3.5 6 2 4.5 3.5 3 2v20z' })
	  );
	};
	ActionReceipt = (0, _pure2.default)(ActionReceipt);
	ActionReceipt.displayName = 'ActionReceipt';
	ActionReceipt.muiName = 'SvgIcon';
	
	exports.default = ActionReceipt;

/***/ },
/* 1019 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRecordVoiceOver = function ActionRecordVoiceOver(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '9', cy: '9', r: '4' }),
	    _react2.default.createElement('path', { d: 'M9 15c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4zm7.76-9.64l-1.68 1.69c.84 1.18.84 2.71 0 3.89l1.68 1.69c2.02-2.02 2.02-5.07 0-7.27zM20.07 2l-1.63 1.63c2.77 3.02 2.77 7.56 0 10.74L20.07 16c3.9-3.89 3.91-9.95 0-14z' })
	  );
	};
	ActionRecordVoiceOver = (0, _pure2.default)(ActionRecordVoiceOver);
	ActionRecordVoiceOver.displayName = 'ActionRecordVoiceOver';
	ActionRecordVoiceOver.muiName = 'SvgIcon';
	
	exports.default = ActionRecordVoiceOver;

/***/ },
/* 1020 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRedeem = function ActionRedeem(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-2.18c.11-.31.18-.65.18-1 0-1.66-1.34-3-3-3-1.05 0-1.96.54-2.5 1.35l-.5.67-.5-.68C10.96 2.54 10.05 2 9 2 7.34 2 6 3.34 6 5c0 .35.07.69.18 1H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-5-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM9 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm11 15H4v-2h16v2zm0-5H4V8h5.08L7 10.83 8.62 12 11 8.76l1-1.36 1 1.36L15.38 12 17 10.83 14.92 8H20v6z' })
	  );
	};
	ActionRedeem = (0, _pure2.default)(ActionRedeem);
	ActionRedeem.displayName = 'ActionRedeem';
	ActionRedeem.muiName = 'SvgIcon';
	
	exports.default = ActionRedeem;

/***/ },
/* 1021 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRemoveShoppingCart = function ActionRemoveShoppingCart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.73 22.73L2.77 2.77 2 2l-.73-.73L0 2.54l4.39 4.39 2.21 4.66-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h7.46l1.38 1.38c-.5.36-.83.95-.83 1.62 0 1.1.89 2 1.99 2 .67 0 1.26-.33 1.62-.84L21.46 24l1.27-1.27zM7.42 15c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h2.36l2 2H7.42zm8.13-2c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H6.54l9.01 9zM7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2z' })
	  );
	};
	ActionRemoveShoppingCart = (0, _pure2.default)(ActionRemoveShoppingCart);
	ActionRemoveShoppingCart.displayName = 'ActionRemoveShoppingCart';
	ActionRemoveShoppingCart.muiName = 'SvgIcon';
	
	exports.default = ActionRemoveShoppingCart;

/***/ },
/* 1022 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionReorder = function ActionReorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 15h18v-2H3v2zm0 4h18v-2H3v2zm0-8h18V9H3v2zm0-6v2h18V5H3z' })
	  );
	};
	ActionReorder = (0, _pure2.default)(ActionReorder);
	ActionReorder.displayName = 'ActionReorder';
	ActionReorder.muiName = 'SvgIcon';
	
	exports.default = ActionReorder;

/***/ },
/* 1023 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionReportProblem = function ActionReportProblem(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
	  );
	};
	ActionReportProblem = (0, _pure2.default)(ActionReportProblem);
	ActionReportProblem.displayName = 'ActionReportProblem';
	ActionReportProblem.muiName = 'SvgIcon';
	
	exports.default = ActionReportProblem;

/***/ },
/* 1024 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRestorePage = function ActionRestorePage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm-2 16c-2.05 0-3.81-1.24-4.58-3h1.71c.63.9 1.68 1.5 2.87 1.5 1.93 0 3.5-1.57 3.5-3.5S13.93 9.5 12 9.5c-1.35 0-2.52.78-3.1 1.9l1.6 1.6h-4V9l1.3 1.3C8.69 8.92 10.23 8 12 8c2.76 0 5 2.24 5 5s-2.24 5-5 5z' })
	  );
	};
	ActionRestorePage = (0, _pure2.default)(ActionRestorePage);
	ActionRestorePage.displayName = 'ActionRestorePage';
	ActionRestorePage.muiName = 'SvgIcon';
	
	exports.default = ActionRestorePage;

/***/ },
/* 1025 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRestore = function ActionRestore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3c-4.97 0-9 4.03-9 9H1l3.89 3.89.07.14L9 12H6c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.93 0-3.68-.79-4.94-2.06l-1.42 1.42C8.27 19.99 10.51 21 13 21c4.97 0 9-4.03 9-9s-4.03-9-9-9zm-1 5v5l4.28 2.54.72-1.21-3.5-2.08V8H12z' })
	  );
	};
	ActionRestore = (0, _pure2.default)(ActionRestore);
	ActionRestore.displayName = 'ActionRestore';
	ActionRestore.muiName = 'SvgIcon';
	
	exports.default = ActionRestore;

/***/ },
/* 1026 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRoom = function ActionRoom(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	ActionRoom = (0, _pure2.default)(ActionRoom);
	ActionRoom.displayName = 'ActionRoom';
	ActionRoom.muiName = 'SvgIcon';
	
	exports.default = ActionRoom;

/***/ },
/* 1027 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRoundedCorner = function ActionRoundedCorner(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 19h2v2h-2v-2zm0-2h2v-2h-2v2zM3 13h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm0-4h2V3H3v2zm4 0h2V3H7v2zm8 16h2v-2h-2v2zm-4 0h2v-2h-2v2zm4 0h2v-2h-2v2zm-8 0h2v-2H7v2zm-4 0h2v-2H3v2zM21 8c0-2.76-2.24-5-5-5h-5v2h5c1.65 0 3 1.35 3 3v5h2V8z' })
	  );
	};
	ActionRoundedCorner = (0, _pure2.default)(ActionRoundedCorner);
	ActionRoundedCorner.displayName = 'ActionRoundedCorner';
	ActionRoundedCorner.muiName = 'SvgIcon';
	
	exports.default = ActionRoundedCorner;

/***/ },
/* 1028 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionRowing = function ActionRowing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.5 14.5L4 19l1.5 1.5L9 17h2l-2.5-2.5zM15 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 20.01L18 24l-2.99-3.01V19.5l-7.1-7.09c-.31.05-.61.07-.91.07v-2.16c1.66.03 3.61-.87 4.67-2.04l1.4-1.55c.19-.21.43-.38.69-.5.29-.14.62-.23.96-.23h.03C15.99 6.01 17 7.02 17 8.26v5.75c0 .84-.35 1.61-.92 2.16l-3.58-3.58v-2.27c-.63.52-1.43 1.02-2.29 1.39L16.5 18H18l3 3.01z' })
	  );
	};
	ActionRowing = (0, _pure2.default)(ActionRowing);
	ActionRowing.displayName = 'ActionRowing';
	ActionRowing.muiName = 'SvgIcon';
	
	exports.default = ActionRowing;

/***/ },
/* 1029 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSchedule = function ActionSchedule(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
	  );
	};
	ActionSchedule = (0, _pure2.default)(ActionSchedule);
	ActionSchedule.displayName = 'ActionSchedule';
	ActionSchedule.muiName = 'SvgIcon';
	
	exports.default = ActionSchedule;

/***/ },
/* 1030 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSearch = function ActionSearch(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z' })
	  );
	};
	ActionSearch = (0, _pure2.default)(ActionSearch);
	ActionSearch.displayName = 'ActionSearch';
	ActionSearch.muiName = 'SvgIcon';
	
	exports.default = ActionSearch;

/***/ },
/* 1031 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsApplications = function ActionSettingsApplications(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm7-7H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-1.75 9c0 .23-.02.46-.05.68l1.48 1.16c.13.11.17.3.08.45l-1.4 2.42c-.09.15-.27.21-.43.15l-1.74-.7c-.36.28-.76.51-1.18.69l-.26 1.85c-.03.17-.18.3-.35.3h-2.8c-.17 0-.32-.13-.35-.29l-.26-1.85c-.43-.18-.82-.41-1.18-.69l-1.74.7c-.16.06-.34 0-.43-.15l-1.4-2.42c-.09-.15-.05-.34.08-.45l1.48-1.16c-.03-.23-.05-.46-.05-.69 0-.23.02-.46.05-.68l-1.48-1.16c-.13-.11-.17-.3-.08-.45l1.4-2.42c.09-.15.27-.21.43-.15l1.74.7c.36-.28.76-.51 1.18-.69l.26-1.85c.03-.17.18-.3.35-.3h2.8c.17 0 .32.13.35.29l.26 1.85c.43.18.82.41 1.18.69l1.74-.7c.16-.06.34 0 .43.15l1.4 2.42c.09.15.05.34-.08.45l-1.48 1.16c.03.23.05.46.05.69z' })
	  );
	};
	ActionSettingsApplications = (0, _pure2.default)(ActionSettingsApplications);
	ActionSettingsApplications.displayName = 'ActionSettingsApplications';
	ActionSettingsApplications.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsApplications;

/***/ },
/* 1032 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsBackupRestore = function ActionSettingsBackupRestore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 12c0-1.1-.9-2-2-2s-2 .9-2 2 .9 2 2 2 2-.9 2-2zm-2-9c-4.97 0-9 4.03-9 9H0l4 4 4-4H5c0-3.87 3.13-7 7-7s7 3.13 7 7-3.13 7-7 7c-1.51 0-2.91-.49-4.06-1.3l-1.42 1.44C8.04 20.3 9.94 21 12 21c4.97 0 9-4.03 9-9s-4.03-9-9-9z' })
	  );
	};
	ActionSettingsBackupRestore = (0, _pure2.default)(ActionSettingsBackupRestore);
	ActionSettingsBackupRestore.displayName = 'ActionSettingsBackupRestore';
	ActionSettingsBackupRestore.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsBackupRestore;

/***/ },
/* 1033 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsBluetooth = function ActionSettingsBluetooth(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 24h2v-2h-2v2zm-4 0h2v-2H7v2zm8 0h2v-2h-2v2zm2.71-18.29L12 0h-1v7.59L6.41 3 5 4.41 10.59 10 5 15.59 6.41 17 11 12.41V20h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 3.83l1.88 1.88L13 7.59V3.83zm1.88 10.46L13 16.17v-3.76l1.88 1.88z' })
	  );
	};
	ActionSettingsBluetooth = (0, _pure2.default)(ActionSettingsBluetooth);
	ActionSettingsBluetooth.displayName = 'ActionSettingsBluetooth';
	ActionSettingsBluetooth.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsBluetooth;

/***/ },
/* 1034 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsBrightness = function ActionSettingsBrightness(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02zM8 16h2.5l1.5 1.5 1.5-1.5H16v-2.5l1.5-1.5-1.5-1.5V8h-2.5L12 6.5 10.5 8H8v2.5L6.5 12 8 13.5V16zm4-7c1.66 0 3 1.34 3 3s-1.34 3-3 3V9z' })
	  );
	};
	ActionSettingsBrightness = (0, _pure2.default)(ActionSettingsBrightness);
	ActionSettingsBrightness.displayName = 'ActionSettingsBrightness';
	ActionSettingsBrightness.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsBrightness;

/***/ },
/* 1035 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsCell = function ActionSettingsCell(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm4 0h2v-2h-2v2zM16 .01L8 0C6.9 0 6 .9 6 2v16c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V2c0-1.1-.9-1.99-2-1.99zM16 16H8V4h8v12z' })
	  );
	};
	ActionSettingsCell = (0, _pure2.default)(ActionSettingsCell);
	ActionSettingsCell.displayName = 'ActionSettingsCell';
	ActionSettingsCell.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsCell;

/***/ },
/* 1036 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsEthernet = function ActionSettingsEthernet(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.77 6.76L6.23 5.48.82 12l5.41 6.52 1.54-1.28L3.42 12l4.35-5.24zM7 13h2v-2H7v2zm10-2h-2v2h2v-2zm-6 2h2v-2h-2v2zm6.77-7.52l-1.54 1.28L20.58 12l-4.35 5.24 1.54 1.28L23.18 12l-5.41-6.52z' })
	  );
	};
	ActionSettingsEthernet = (0, _pure2.default)(ActionSettingsEthernet);
	ActionSettingsEthernet.displayName = 'ActionSettingsEthernet';
	ActionSettingsEthernet.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsEthernet;

/***/ },
/* 1037 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputAntenna = function ActionSettingsInputAntenna(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5c-3.87 0-7 3.13-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.87-3.13-7-7-7zm1 9.29c.88-.39 1.5-1.26 1.5-2.29 0-1.38-1.12-2.5-2.5-2.5S9.5 10.62 9.5 12c0 1.02.62 1.9 1.5 2.29v3.3L7.59 21 9 22.41l3-3 3 3L16.41 21 13 17.59v-3.3zM12 1C5.93 1 1 5.93 1 12h2c0-4.97 4.03-9 9-9s9 4.03 9 9h2c0-6.07-4.93-11-11-11z' })
	  );
	};
	ActionSettingsInputAntenna = (0, _pure2.default)(ActionSettingsInputAntenna);
	ActionSettingsInputAntenna.displayName = 'ActionSettingsInputAntenna';
	ActionSettingsInputAntenna.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputAntenna;

/***/ },
/* 1038 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputComponent = function ActionSettingsInputComponent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z' })
	  );
	};
	ActionSettingsInputComponent = (0, _pure2.default)(ActionSettingsInputComponent);
	ActionSettingsInputComponent.displayName = 'ActionSettingsInputComponent';
	ActionSettingsInputComponent.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputComponent;

/***/ },
/* 1039 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputComposite = function ActionSettingsInputComposite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 2c0-.55-.45-1-1-1s-1 .45-1 1v4H1v6h6V6H5V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2H9v2zm-8 0c0 1.3.84 2.4 2 2.82V23h2v-4.18C6.16 18.4 7 17.3 7 16v-2H1v2zM21 6V2c0-.55-.45-1-1-1s-1 .45-1 1v4h-2v6h6V6h-2zm-8-4c0-.55-.45-1-1-1s-1 .45-1 1v4H9v6h6V6h-2V2zm4 14c0 1.3.84 2.4 2 2.82V23h2v-4.18c1.16-.41 2-1.51 2-2.82v-2h-6v2z' })
	  );
	};
	ActionSettingsInputComposite = (0, _pure2.default)(ActionSettingsInputComposite);
	ActionSettingsInputComposite.displayName = 'ActionSettingsInputComposite';
	ActionSettingsInputComposite.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputComposite;

/***/ },
/* 1040 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputHdmi = function ActionSettingsInputHdmi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 7V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v3H5v6l3 6v3h8v-3l3-6V7h-1zM8 4h8v3h-2V5h-1v2h-2V5h-1v2H8V4z' })
	  );
	};
	ActionSettingsInputHdmi = (0, _pure2.default)(ActionSettingsInputHdmi);
	ActionSettingsInputHdmi.displayName = 'ActionSettingsInputHdmi';
	ActionSettingsInputHdmi.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputHdmi;

/***/ },
/* 1041 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsInputSvideo = function ActionSettingsInputSvideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 11.5c0-.83-.67-1.5-1.5-1.5S5 10.67 5 11.5 5.67 13 6.5 13 8 12.33 8 11.5zm7-5c0-.83-.67-1.5-1.5-1.5h-3C9.67 5 9 5.67 9 6.5S9.67 8 10.5 8h3c.83 0 1.5-.67 1.5-1.5zM8.5 15c-.83 0-1.5.67-1.5 1.5S7.67 18 8.5 18s1.5-.67 1.5-1.5S9.33 15 8.5 15zM12 1C5.93 1 1 5.93 1 12s4.93 11 11 11 11-4.93 11-11S18.07 1 12 1zm0 20c-4.96 0-9-4.04-9-9s4.04-9 9-9 9 4.04 9 9-4.04 9-9 9zm5.5-11c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm-2 5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' })
	  );
	};
	ActionSettingsInputSvideo = (0, _pure2.default)(ActionSettingsInputSvideo);
	ActionSettingsInputSvideo.displayName = 'ActionSettingsInputSvideo';
	ActionSettingsInputSvideo.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsInputSvideo;

/***/ },
/* 1042 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsOverscan = function ActionSettingsOverscan(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.01 5.5L10 8h4l-1.99-2.5zM18 10v4l2.5-1.99L18 10zM6 10l-2.5 2.01L6 14v-4zm8 6h-4l2.01 2.5L14 16zm7-13H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
	  );
	};
	ActionSettingsOverscan = (0, _pure2.default)(ActionSettingsOverscan);
	ActionSettingsOverscan.displayName = 'ActionSettingsOverscan';
	ActionSettingsOverscan.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsOverscan;

/***/ },
/* 1043 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsPhone = function ActionSettingsPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 9h-2v2h2V9zm4 0h-2v2h2V9zm3 6.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.58l2.2-2.21c.28-.27.36-.66.25-1.01C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 9v2h2V9h-2z' })
	  );
	};
	ActionSettingsPhone = (0, _pure2.default)(ActionSettingsPhone);
	ActionSettingsPhone.displayName = 'ActionSettingsPhone';
	ActionSettingsPhone.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsPhone;

/***/ },
/* 1044 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsPower = function ActionSettingsPower(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm4 0h2v-2h-2v2zm2-22h-2v10h2V2zm3.56 2.44l-1.45 1.45C16.84 6.94 18 8.83 18 11c0 3.31-2.69 6-6 6s-6-2.69-6-6c0-2.17 1.16-4.06 2.88-5.12L7.44 4.44C5.36 5.88 4 8.28 4 11c0 4.42 3.58 8 8 8s8-3.58 8-8c0-2.72-1.36-5.12-3.44-6.56zM15 24h2v-2h-2v2z' })
	  );
	};
	ActionSettingsPower = (0, _pure2.default)(ActionSettingsPower);
	ActionSettingsPower.displayName = 'ActionSettingsPower';
	ActionSettingsPower.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsPower;

/***/ },
/* 1045 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsRemote = function ActionSettingsRemote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 9H9c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V10c0-.55-.45-1-1-1zm-3 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM7.05 6.05l1.41 1.41C9.37 6.56 10.62 6 12 6s2.63.56 3.54 1.46l1.41-1.41C15.68 4.78 13.93 4 12 4s-3.68.78-4.95 2.05zM12 0C8.96 0 6.21 1.23 4.22 3.22l1.41 1.41C7.26 3.01 9.51 2 12 2s4.74 1.01 6.36 2.64l1.41-1.41C17.79 1.23 15.04 0 12 0z' })
	  );
	};
	ActionSettingsRemote = (0, _pure2.default)(ActionSettingsRemote);
	ActionSettingsRemote.displayName = 'ActionSettingsRemote';
	ActionSettingsRemote.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsRemote;

/***/ },
/* 1046 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettingsVoice = function ActionSettingsVoice(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 24h2v-2H7v2zm5-11c1.66 0 2.99-1.34 2.99-3L15 4c0-1.66-1.34-3-3-3S9 2.34 9 4v6c0 1.66 1.34 3 3 3zm-1 11h2v-2h-2v2zm4 0h2v-2h-2v2zm4-14h-1.7c0 3-2.54 5.1-5.3 5.1S6.7 13 6.7 10H5c0 3.41 2.72 6.23 6 6.72V20h2v-3.28c3.28-.49 6-3.31 6-6.72z' })
	  );
	};
	ActionSettingsVoice = (0, _pure2.default)(ActionSettingsVoice);
	ActionSettingsVoice.displayName = 'ActionSettingsVoice';
	ActionSettingsVoice.muiName = 'SvgIcon';
	
	exports.default = ActionSettingsVoice;

/***/ },
/* 1047 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSettings = function ActionSettings(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.43 12.98c.04-.32.07-.64.07-.98s-.03-.66-.07-.98l2.11-1.65c.19-.15.24-.42.12-.64l-2-3.46c-.12-.22-.39-.3-.61-.22l-2.49 1c-.52-.4-1.08-.73-1.69-.98l-.38-2.65C14.46 2.18 14.25 2 14 2h-4c-.25 0-.46.18-.49.42l-.38 2.65c-.61.25-1.17.59-1.69.98l-2.49-1c-.23-.09-.49 0-.61.22l-2 3.46c-.13.22-.07.49.12.64l2.11 1.65c-.04.32-.07.65-.07.98s.03.66.07.98l-2.11 1.65c-.19.15-.24.42-.12.64l2 3.46c.12.22.39.3.61.22l2.49-1c.52.4 1.08.73 1.69.98l.38 2.65c.03.24.24.42.49.42h4c.25 0 .46-.18.49-.42l.38-2.65c.61-.25 1.17-.59 1.69-.98l2.49 1c.23.09.49 0 .61-.22l2-3.46c.12-.22.07-.49-.12-.64l-2.11-1.65zM12 15.5c-1.93 0-3.5-1.57-3.5-3.5s1.57-3.5 3.5-3.5 3.5 1.57 3.5 3.5-1.57 3.5-3.5 3.5z' })
	  );
	};
	ActionSettings = (0, _pure2.default)(ActionSettings);
	ActionSettings.displayName = 'ActionSettings';
	ActionSettings.muiName = 'SvgIcon';
	
	exports.default = ActionSettings;

/***/ },
/* 1048 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShopTwo = function ActionShopTwo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9H1v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2H3V9zm15-4V3c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H5v11c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2V5h-5zm-6-2h4v2h-4V3zm0 12V8l5.5 3-5.5 4z' })
	  );
	};
	ActionShopTwo = (0, _pure2.default)(ActionShopTwo);
	ActionShopTwo.displayName = 'ActionShopTwo';
	ActionShopTwo.muiName = 'SvgIcon';
	
	exports.default = ActionShopTwo;

/***/ },
/* 1049 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShop = function ActionShop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 6V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H2v13c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6h-6zm-6-2h4v2h-4V4zM9 18V9l7.5 4L9 18z' })
	  );
	};
	ActionShop = (0, _pure2.default)(ActionShop);
	ActionShop.displayName = 'ActionShop';
	ActionShop.muiName = 'SvgIcon';
	
	exports.default = ActionShop;

/***/ },
/* 1050 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShoppingBasket = function ActionShoppingBasket(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.21 9l-4.38-6.56c-.19-.28-.51-.42-.83-.42-.32 0-.64.14-.83.43L6.79 9H2c-.55 0-1 .45-1 1 0 .09.01.18.04.27l2.54 9.27c.23.84 1 1.46 1.92 1.46h13c.92 0 1.69-.62 1.93-1.46l2.54-9.27L23 10c0-.55-.45-1-1-1h-4.79zM9 9l3-4.4L15 9H9zm3 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ActionShoppingBasket = (0, _pure2.default)(ActionShoppingBasket);
	ActionShoppingBasket.displayName = 'ActionShoppingBasket';
	ActionShoppingBasket.muiName = 'SvgIcon';
	
	exports.default = ActionShoppingBasket;

/***/ },
/* 1051 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionShoppingCart = function ActionShoppingCart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	ActionShoppingCart = (0, _pure2.default)(ActionShoppingCart);
	ActionShoppingCart.displayName = 'ActionShoppingCart';
	ActionShoppingCart.muiName = 'SvgIcon';
	
	exports.default = ActionShoppingCart;

/***/ },
/* 1052 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSpeakerNotesOff = function ActionSpeakerNotesOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.54 11l-.54-.54L7.54 8 6 6.46 2.38 2.84 1.27 1.73 0 3l2.01 2.01L2 22l4-4h9l5.73 5.73L22 22.46 17.54 18l-7-7zM8 14H6v-2h2v2zm-2-3V9l2 2H6zm14-9H4.08L10 7.92V6h8v2h-7.92l1 1H18v2h-4.92l6.99 6.99C21.14 17.95 22 17.08 22 16V4c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionSpeakerNotesOff = (0, _pure2.default)(ActionSpeakerNotesOff);
	ActionSpeakerNotesOff.displayName = 'ActionSpeakerNotesOff';
	ActionSpeakerNotesOff.muiName = 'SvgIcon';
	
	exports.default = ActionSpeakerNotesOff;

/***/ },
/* 1053 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSpeakerNotes = function ActionSpeakerNotes(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 14H6v-2h2v2zm0-3H6V9h2v2zm0-3H6V6h2v2zm7 6h-5v-2h5v2zm3-3h-8V9h8v2zm0-3h-8V6h8v2z' })
	  );
	};
	ActionSpeakerNotes = (0, _pure2.default)(ActionSpeakerNotes);
	ActionSpeakerNotes.displayName = 'ActionSpeakerNotes';
	ActionSpeakerNotes.muiName = 'SvgIcon';
	
	exports.default = ActionSpeakerNotes;

/***/ },
/* 1054 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSpellcheck = function ActionSpellcheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.45 16h2.09L9.43 3H7.57L2.46 16h2.09l1.12-3h5.64l1.14 3zm-6.02-5L8.5 5.48 10.57 11H6.43zm15.16.59l-8.09 8.09L9.83 16l-1.41 1.41 5.09 5.09L23 13l-1.41-1.41z' })
	  );
	};
	ActionSpellcheck = (0, _pure2.default)(ActionSpellcheck);
	ActionSpellcheck.displayName = 'ActionSpellcheck';
	ActionSpellcheck.muiName = 'SvgIcon';
	
	exports.default = ActionSpellcheck;

/***/ },
/* 1055 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionStars = function ActionStars(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zm4.24 16L12 15.45 7.77 18l1.12-4.81-3.73-3.23 4.92-.42L12 5l1.92 4.53 4.92.42-3.73 3.23L16.23 18z' })
	  );
	};
	ActionStars = (0, _pure2.default)(ActionStars);
	ActionStars.displayName = 'ActionStars';
	ActionStars.muiName = 'SvgIcon';
	
	exports.default = ActionStars;

/***/ },
/* 1056 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionStore = function ActionStore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
	  );
	};
	ActionStore = (0, _pure2.default)(ActionStore);
	ActionStore.displayName = 'ActionStore';
	ActionStore.muiName = 'SvgIcon';
	
	exports.default = ActionStore;

/***/ },
/* 1057 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSubject = function ActionSubject(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 17H4v2h10v-2zm6-8H4v2h16V9zM4 15h16v-2H4v2zM4 5v2h16V5H4z' })
	  );
	};
	ActionSubject = (0, _pure2.default)(ActionSubject);
	ActionSubject.displayName = 'ActionSubject';
	ActionSubject.muiName = 'SvgIcon';
	
	exports.default = ActionSubject;

/***/ },
/* 1058 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSupervisorAccount = function ActionSupervisorAccount(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 12c1.38 0 2.49-1.12 2.49-2.5S17.88 7 16.5 7C15.12 7 14 8.12 14 9.5s1.12 2.5 2.5 2.5zM9 11c1.66 0 2.99-1.34 2.99-3S10.66 5 9 5C7.34 5 6 6.34 6 8s1.34 3 3 3zm7.5 3c-1.83 0-5.5.92-5.5 2.75V19h11v-2.25c0-1.83-3.67-2.75-5.5-2.75zM9 13c-2.33 0-7 1.17-7 3.5V19h7v-2.25c0-.85.33-2.34 2.37-3.47C10.5 13.1 9.66 13 9 13z' })
	  );
	};
	ActionSupervisorAccount = (0, _pure2.default)(ActionSupervisorAccount);
	ActionSupervisorAccount.displayName = 'ActionSupervisorAccount';
	ActionSupervisorAccount.muiName = 'SvgIcon';
	
	exports.default = ActionSupervisorAccount;

/***/ },
/* 1059 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSwapHoriz = function ActionSwapHoriz(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.99 11L3 15l3.99 4v-3H14v-2H6.99v-3zM21 9l-3.99-4v3H10v2h7.01v3L21 9z' })
	  );
	};
	ActionSwapHoriz = (0, _pure2.default)(ActionSwapHoriz);
	ActionSwapHoriz.displayName = 'ActionSwapHoriz';
	ActionSwapHoriz.muiName = 'SvgIcon';
	
	exports.default = ActionSwapHoriz;

/***/ },
/* 1060 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSwapVert = function ActionSwapVert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 17.01V10h-2v7.01h-3L15 21l4-3.99h-3zM9 3L5 6.99h3V14h2V6.99h3L9 3z' })
	  );
	};
	ActionSwapVert = (0, _pure2.default)(ActionSwapVert);
	ActionSwapVert.displayName = 'ActionSwapVert';
	ActionSwapVert.muiName = 'SvgIcon';
	
	exports.default = ActionSwapVert;

/***/ },
/* 1061 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSwapVerticalCircle = function ActionSwapVerticalCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM6.5 9L10 5.5 13.5 9H11v4H9V9H6.5zm11 6L14 18.5 10.5 15H13v-4h2v4h2.5z' })
	  );
	};
	ActionSwapVerticalCircle = (0, _pure2.default)(ActionSwapVerticalCircle);
	ActionSwapVerticalCircle.displayName = 'ActionSwapVerticalCircle';
	ActionSwapVerticalCircle.muiName = 'SvgIcon';
	
	exports.default = ActionSwapVerticalCircle;

/***/ },
/* 1062 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionSystemUpdateAlt = function ActionSystemUpdateAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 16.5l4-4h-3v-9h-2v9H8l4 4zm9-13h-6v1.99h6v14.03H3V5.49h6V3.5H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-14c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionSystemUpdateAlt = (0, _pure2.default)(ActionSystemUpdateAlt);
	ActionSystemUpdateAlt.displayName = 'ActionSystemUpdateAlt';
	ActionSystemUpdateAlt.muiName = 'SvgIcon';
	
	exports.default = ActionSystemUpdateAlt;

/***/ },
/* 1063 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTabUnselected = function ActionTabUnselected(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 9h2V7H1v2zm0 4h2v-2H1v2zm0-8h2V3c-1.1 0-2 .9-2 2zm8 16h2v-2H9v2zm-8-4h2v-2H1v2zm2 4v-2H1c0 1.1.9 2 2 2zM21 3h-8v6h10V5c0-1.1-.9-2-2-2zm0 14h2v-2h-2v2zM9 5h2V3H9v2zM5 21h2v-2H5v2zM5 5h2V3H5v2zm16 16c1.1 0 2-.9 2-2h-2v2zm0-8h2v-2h-2v2zm-8 8h2v-2h-2v2zm4 0h2v-2h-2v2z' })
	  );
	};
	ActionTabUnselected = (0, _pure2.default)(ActionTabUnselected);
	ActionTabUnselected.displayName = 'ActionTabUnselected';
	ActionTabUnselected.muiName = 'SvgIcon';
	
	exports.default = ActionTabUnselected;

/***/ },
/* 1064 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTab = function ActionTab(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h10v4h8v10z' })
	  );
	};
	ActionTab = (0, _pure2.default)(ActionTab);
	ActionTab.displayName = 'ActionTab';
	ActionTab.muiName = 'SvgIcon';
	
	exports.default = ActionTab;

/***/ },
/* 1065 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTheaters = function ActionTheaters(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
	  );
	};
	ActionTheaters = (0, _pure2.default)(ActionTheaters);
	ActionTheaters.displayName = 'ActionTheaters';
	ActionTheaters.muiName = 'SvgIcon';
	
	exports.default = ActionTheaters;

/***/ },
/* 1066 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThreeDRotation = function ActionThreeDRotation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.52 21.48C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32zm.89-6.52c-.19 0-.37-.03-.52-.08-.16-.06-.29-.13-.4-.24-.11-.1-.2-.22-.26-.37-.06-.14-.09-.3-.09-.47h-1.3c0 .36.07.68.21.95.14.27.33.5.56.69.24.18.51.32.82.41.3.1.62.15.96.15.37 0 .72-.05 1.03-.15.32-.1.6-.25.83-.44s.42-.43.55-.72c.13-.29.2-.61.2-.97 0-.19-.02-.38-.07-.56-.05-.18-.12-.35-.23-.51-.1-.16-.24-.3-.4-.43-.17-.13-.37-.23-.61-.31.2-.09.37-.2.52-.33.15-.13.27-.27.37-.42.1-.15.17-.3.22-.46.05-.16.07-.32.07-.48 0-.36-.06-.68-.18-.96-.12-.28-.29-.51-.51-.69-.2-.19-.47-.33-.77-.43C9.1 8.05 8.76 8 8.39 8c-.36 0-.69.05-1 .16-.3.11-.57.26-.79.45-.21.19-.38.41-.51.67-.12.26-.18.54-.18.85h1.3c0-.17.03-.32.09-.45s.14-.25.25-.34c.11-.09.23-.17.38-.22.15-.05.3-.08.48-.08.4 0 .7.1.89.31.19.2.29.49.29.86 0 .18-.03.34-.08.49-.05.15-.14.27-.25.37-.11.1-.25.18-.41.24-.16.06-.36.09-.58.09H7.5v1.03h.77c.22 0 .42.02.6.07s.33.13.45.23c.12.11.22.24.29.4.07.16.1.35.1.57 0 .41-.12.72-.35.93-.23.23-.55.33-.95.33zm8.55-5.92c-.32-.33-.7-.59-1.14-.77-.43-.18-.92-.27-1.46-.27H12v8h2.3c.55 0 1.06-.09 1.51-.27.45-.18.84-.43 1.16-.76.32-.33.57-.73.74-1.19.17-.47.26-.99.26-1.57v-.4c0-.58-.09-1.1-.26-1.57-.18-.47-.43-.87-.75-1.2zm-.39 3.16c0 .42-.05.79-.14 1.13-.1.33-.24.62-.43.85-.19.23-.43.41-.71.53-.29.12-.62.18-.99.18h-.91V9.12h.97c.72 0 1.27.23 1.64.69.38.46.57 1.12.57 1.99v.4zM12 0l-.66.03 3.81 3.81 1.33-1.33c3.27 1.55 5.61 4.72 5.96 8.48h1.5C23.44 4.84 18.29 0 12 0z' })
	  );
	};
	ActionThreeDRotation = (0, _pure2.default)(ActionThreeDRotation);
	ActionThreeDRotation.displayName = 'ActionThreeDRotation';
	ActionThreeDRotation.muiName = 'SvgIcon';
	
	exports.default = ActionThreeDRotation;

/***/ },
/* 1067 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThumbDown = function ActionThumbDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 3H6c-.83 0-1.54.5-1.84 1.22l-3.02 7.05c-.09.23-.14.47-.14.73v1.91l.01.01L1 14c0 1.1.9 2 2 2h6.31l-.95 4.57-.03.32c0 .41.17.79.44 1.06L9.83 23l6.59-6.59c.36-.36.58-.86.58-1.41V5c0-1.1-.9-2-2-2zm4 0v12h4V3h-4z' })
	  );
	};
	ActionThumbDown = (0, _pure2.default)(ActionThumbDown);
	ActionThumbDown.displayName = 'ActionThumbDown';
	ActionThumbDown.muiName = 'SvgIcon';
	
	exports.default = ActionThumbDown;

/***/ },
/* 1068 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThumbUp = function ActionThumbUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h4V9H1v12zm22-11c0-1.1-.9-2-2-2h-6.31l.95-4.57.03-.32c0-.41-.17-.79-.44-1.06L14.17 1 7.59 7.59C7.22 7.95 7 8.45 7 9v10c0 1.1.9 2 2 2h9c.83 0 1.54-.5 1.84-1.22l3.02-7.05c.09-.23.14-.47.14-.73v-1.91l-.01-.01L23 10z' })
	  );
	};
	ActionThumbUp = (0, _pure2.default)(ActionThumbUp);
	ActionThumbUp.displayName = 'ActionThumbUp';
	ActionThumbUp.muiName = 'SvgIcon';
	
	exports.default = ActionThumbUp;

/***/ },
/* 1069 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionThumbsUpDown = function ActionThumbsUpDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c0-.55-.45-1-1-1H5.82l.66-3.18.02-.23c0-.31-.13-.59-.33-.8L5.38 0 .44 4.94C.17 5.21 0 5.59 0 6v6.5c0 .83.67 1.5 1.5 1.5h6.75c.62 0 1.15-.38 1.38-.91l2.26-5.29c.07-.17.11-.36.11-.55V6zm10.5 4h-6.75c-.62 0-1.15.38-1.38.91l-2.26 5.29c-.07.17-.11.36-.11.55V18c0 .55.45 1 1 1h5.18l-.66 3.18-.02.24c0 .31.13.59.33.8l.79.78 4.94-4.94c.27-.27.44-.65.44-1.06v-6.5c0-.83-.67-1.5-1.5-1.5z' })
	  );
	};
	ActionThumbsUpDown = (0, _pure2.default)(ActionThumbsUpDown);
	ActionThumbsUpDown.displayName = 'ActionThumbsUpDown';
	ActionThumbsUpDown.muiName = 'SvgIcon';
	
	exports.default = ActionThumbsUpDown;

/***/ },
/* 1070 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTimeline = function ActionTimeline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 8c0 1.1-.9 2-2 2-.18 0-.35-.02-.51-.07l-3.56 3.55c.05.16.07.34.07.52 0 1.1-.9 2-2 2s-2-.9-2-2c0-.18.02-.36.07-.52l-2.55-2.55c-.16.05-.34.07-.52.07s-.36-.02-.52-.07l-4.55 4.56c.05.16.07.33.07.51 0 1.1-.9 2-2 2s-2-.9-2-2 .9-2 2-2c.18 0 .35.02.51.07l4.56-4.55C8.02 9.36 8 9.18 8 9c0-1.1.9-2 2-2s2 .9 2 2c0 .18-.02.36-.07.52l2.55 2.55c.16-.05.34-.07.52-.07s.36.02.52.07l3.55-3.56C19.02 8.35 19 8.18 19 8c0-1.1.9-2 2-2s2 .9 2 2z' })
	  );
	};
	ActionTimeline = (0, _pure2.default)(ActionTimeline);
	ActionTimeline.displayName = 'ActionTimeline';
	ActionTimeline.muiName = 'SvgIcon';
	
	exports.default = ActionTimeline;

/***/ },
/* 1071 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionToc = function ActionToc(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9h14V7H3v2zm0 4h14v-2H3v2zm0 4h14v-2H3v2zm16 0h2v-2h-2v2zm0-10v2h2V7h-2zm0 6h2v-2h-2v2z' })
	  );
	};
	ActionToc = (0, _pure2.default)(ActionToc);
	ActionToc.displayName = 'ActionToc';
	ActionToc.muiName = 'SvgIcon';
	
	exports.default = ActionToc;

/***/ },
/* 1072 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionToday = function ActionToday(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zM7 10h5v5H7z' })
	  );
	};
	ActionToday = (0, _pure2.default)(ActionToday);
	ActionToday.displayName = 'ActionToday';
	ActionToday.muiName = 'SvgIcon';
	
	exports.default = ActionToday;

/***/ },
/* 1073 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionToll = function ActionToll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zM3 12c0-2.61 1.67-4.83 4-5.65V4.26C3.55 5.15 1 8.27 1 12s2.55 6.85 6 7.74v-2.09c-2.33-.82-4-3.04-4-5.65z' })
	  );
	};
	ActionToll = (0, _pure2.default)(ActionToll);
	ActionToll.displayName = 'ActionToll';
	ActionToll.muiName = 'SvgIcon';
	
	exports.default = ActionToll;

/***/ },
/* 1074 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTouchApp = function ActionTouchApp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11.24V7.5C9 6.12 10.12 5 11.5 5S14 6.12 14 7.5v3.74c1.21-.81 2-2.18 2-3.74C16 5.01 13.99 3 11.5 3S7 5.01 7 7.5c0 1.56.79 2.93 2 3.74zm9.84 4.63l-4.54-2.26c-.17-.07-.35-.11-.54-.11H13v-6c0-.83-.67-1.5-1.5-1.5S10 6.67 10 7.5v10.74l-3.43-.72c-.08-.01-.15-.03-.24-.03-.31 0-.59.13-.79.33l-.79.8 4.94 4.94c.27.27.65.44 1.06.44h6.79c.75 0 1.33-.55 1.44-1.28l.75-5.27c.01-.07.02-.14.02-.2 0-.62-.38-1.16-.91-1.38z' })
	  );
	};
	ActionTouchApp = (0, _pure2.default)(ActionTouchApp);
	ActionTouchApp.displayName = 'ActionTouchApp';
	ActionTouchApp.muiName = 'SvgIcon';
	
	exports.default = ActionTouchApp;

/***/ },
/* 1075 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrackChanges = function ActionTrackChanges(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.07 4.93l-1.41 1.41C19.1 7.79 20 9.79 20 12c0 4.42-3.58 8-8 8s-8-3.58-8-8c0-4.08 3.05-7.44 7-7.93v2.02C8.16 6.57 6 9.03 6 12c0 3.31 2.69 6 6 6s6-2.69 6-6c0-1.66-.67-3.16-1.76-4.24l-1.41 1.41C15.55 9.9 16 10.9 16 12c0 2.21-1.79 4-4 4s-4-1.79-4-4c0-1.86 1.28-3.41 3-3.86v2.14c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V2h-1C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10c0-2.76-1.12-5.26-2.93-7.07z' })
	  );
	};
	ActionTrackChanges = (0, _pure2.default)(ActionTrackChanges);
	ActionTrackChanges.displayName = 'ActionTrackChanges';
	ActionTrackChanges.muiName = 'SvgIcon';
	
	exports.default = ActionTrackChanges;

/***/ },
/* 1076 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTranslate = function ActionTranslate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.87 15.07l-2.54-2.51.03-.03c1.74-1.94 2.98-4.17 3.71-6.53H17V4h-7V2H8v2H1v1.99h11.17C11.5 7.92 10.44 9.75 9 11.35 8.07 10.32 7.3 9.19 6.69 8h-2c.73 1.63 1.73 3.17 2.98 4.56l-5.09 5.02L4 19l5-5 3.11 3.11.76-2.04zM18.5 10h-2L12 22h2l1.12-3h4.75L21 22h2l-4.5-12zm-2.62 7l1.62-4.33L19.12 17h-3.24z' })
	  );
	};
	ActionTranslate = (0, _pure2.default)(ActionTranslate);
	ActionTranslate.displayName = 'ActionTranslate';
	ActionTranslate.muiName = 'SvgIcon';
	
	exports.default = ActionTranslate;

/***/ },
/* 1077 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrendingDown = function ActionTrendingDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 18l2.29-2.29-4.88-4.88-4 4L2 7.41 3.41 6l6 6 4-4 6.3 6.29L22 12v6z' })
	  );
	};
	ActionTrendingDown = (0, _pure2.default)(ActionTrendingDown);
	ActionTrendingDown.displayName = 'ActionTrendingDown';
	ActionTrendingDown.muiName = 'SvgIcon';
	
	exports.default = ActionTrendingDown;

/***/ },
/* 1078 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrendingFlat = function ActionTrendingFlat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 12l-4-4v3H3v2h15v3z' })
	  );
	};
	ActionTrendingFlat = (0, _pure2.default)(ActionTrendingFlat);
	ActionTrendingFlat.displayName = 'ActionTrendingFlat';
	ActionTrendingFlat.muiName = 'SvgIcon';
	
	exports.default = ActionTrendingFlat;

/***/ },
/* 1079 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTrendingUp = function ActionTrendingUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 6l2.29 2.29-4.88 4.88-4-4L2 16.59 3.41 18l6-6 4 4 6.3-6.29L22 12V6z' })
	  );
	};
	ActionTrendingUp = (0, _pure2.default)(ActionTrendingUp);
	ActionTrendingUp.displayName = 'ActionTrendingUp';
	ActionTrendingUp.muiName = 'SvgIcon';
	
	exports.default = ActionTrendingUp;

/***/ },
/* 1080 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTurnedInNot = function ActionTurnedInNot(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2zm0 15l-5-2.18L7 18V5h10v13z' })
	  );
	};
	ActionTurnedInNot = (0, _pure2.default)(ActionTurnedInNot);
	ActionTurnedInNot.displayName = 'ActionTurnedInNot';
	ActionTurnedInNot.muiName = 'SvgIcon';
	
	exports.default = ActionTurnedInNot;

/***/ },
/* 1081 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionTurnedIn = function ActionTurnedIn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-1.99.9-1.99 2L5 21l7-3 7 3V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ActionTurnedIn = (0, _pure2.default)(ActionTurnedIn);
	ActionTurnedIn.displayName = 'ActionTurnedIn';
	ActionTurnedIn.muiName = 'SvgIcon';
	
	exports.default = ActionTurnedIn;

/***/ },
/* 1082 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionUpdate = function ActionUpdate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 10.12h-6.78l2.74-2.82c-2.73-2.7-7.15-2.8-9.88-.1-2.73 2.71-2.73 7.08 0 9.79 2.73 2.71 7.15 2.71 9.88 0C18.32 15.65 19 14.08 19 12.1h2c0 1.98-.88 4.55-2.64 6.29-3.51 3.48-9.21 3.48-12.72 0-3.5-3.47-3.53-9.11-.02-12.58 3.51-3.47 9.14-3.47 12.65 0L21 3v7.12zM12.5 8v4.25l3.5 2.08-.72 1.21L11 13V8h1.5z' })
	  );
	};
	ActionUpdate = (0, _pure2.default)(ActionUpdate);
	ActionUpdate.displayName = 'ActionUpdate';
	ActionUpdate.muiName = 'SvgIcon';
	
	exports.default = ActionUpdate;

/***/ },
/* 1083 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionVerifiedUser = function ActionVerifiedUser(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-2 16l-4-4 1.41-1.41L10 14.17l6.59-6.59L18 9l-8 8z' })
	  );
	};
	ActionVerifiedUser = (0, _pure2.default)(ActionVerifiedUser);
	ActionVerifiedUser.displayName = 'ActionVerifiedUser';
	ActionVerifiedUser.muiName = 'SvgIcon';
	
	exports.default = ActionVerifiedUser;

/***/ },
/* 1084 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewAgenda = function ActionViewAgenda(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 13H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1v-6c0-.55-.45-1-1-1zm0-10H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1z' })
	  );
	};
	ActionViewAgenda = (0, _pure2.default)(ActionViewAgenda);
	ActionViewAgenda.displayName = 'ActionViewAgenda';
	ActionViewAgenda.muiName = 'SvgIcon';
	
	exports.default = ActionViewAgenda;

/***/ },
/* 1085 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewArray = function ActionViewArray(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18h3V5H4v13zM18 5v13h3V5h-3zM8 18h9V5H8v13z' })
	  );
	};
	ActionViewArray = (0, _pure2.default)(ActionViewArray);
	ActionViewArray.displayName = 'ActionViewArray';
	ActionViewArray.muiName = 'SvgIcon';
	
	exports.default = ActionViewArray;

/***/ },
/* 1086 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewCarousel = function ActionViewCarousel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 19h10V4H7v15zm-5-2h4V6H2v11zM18 6v11h4V6h-4z' })
	  );
	};
	ActionViewCarousel = (0, _pure2.default)(ActionViewCarousel);
	ActionViewCarousel.displayName = 'ActionViewCarousel';
	ActionViewCarousel.muiName = 'SvgIcon';
	
	exports.default = ActionViewCarousel;

/***/ },
/* 1087 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewColumn = function ActionViewColumn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 18h5V5h-5v13zm-6 0h5V5H4v13zM16 5v13h5V5h-5z' })
	  );
	};
	ActionViewColumn = (0, _pure2.default)(ActionViewColumn);
	ActionViewColumn.displayName = 'ActionViewColumn';
	ActionViewColumn.muiName = 'SvgIcon';
	
	exports.default = ActionViewColumn;

/***/ },
/* 1088 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewDay = function ActionViewDay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 21h19v-3H2v3zM20 8H3c-.55 0-1 .45-1 1v6c0 .55.45 1 1 1h17c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zM2 3v3h19V3H2z' })
	  );
	};
	ActionViewDay = (0, _pure2.default)(ActionViewDay);
	ActionViewDay.displayName = 'ActionViewDay';
	ActionViewDay.muiName = 'SvgIcon';
	
	exports.default = ActionViewDay;

/***/ },
/* 1089 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewHeadline = function ActionViewHeadline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 15h16v-2H4v2zm0 4h16v-2H4v2zm0-8h16V9H4v2zm0-6v2h16V5H4z' })
	  );
	};
	ActionViewHeadline = (0, _pure2.default)(ActionViewHeadline);
	ActionViewHeadline.displayName = 'ActionViewHeadline';
	ActionViewHeadline.muiName = 'SvgIcon';
	
	exports.default = ActionViewHeadline;

/***/ },
/* 1090 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewList = function ActionViewList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 14h4v-4H4v4zm0 5h4v-4H4v4zM4 9h4V5H4v4zm5 5h12v-4H9v4zm0 5h12v-4H9v4zM9 5v4h12V5H9z' })
	  );
	};
	ActionViewList = (0, _pure2.default)(ActionViewList);
	ActionViewList.displayName = 'ActionViewList';
	ActionViewList.muiName = 'SvgIcon';
	
	exports.default = ActionViewList;

/***/ },
/* 1091 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewModule = function ActionViewModule(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 11h5V5H4v6zm0 7h5v-6H4v6zm6 0h5v-6h-5v6zm6 0h5v-6h-5v6zm-6-7h5V5h-5v6zm6-6v6h5V5h-5z' })
	  );
	};
	ActionViewModule = (0, _pure2.default)(ActionViewModule);
	ActionViewModule.displayName = 'ActionViewModule';
	ActionViewModule.muiName = 'SvgIcon';
	
	exports.default = ActionViewModule;

/***/ },
/* 1092 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewQuilt = function ActionViewQuilt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 18h5v-6h-5v6zm-6 0h5V5H4v13zm12 0h5v-6h-5v6zM10 5v6h11V5H10z' })
	  );
	};
	ActionViewQuilt = (0, _pure2.default)(ActionViewQuilt);
	ActionViewQuilt.displayName = 'ActionViewQuilt';
	ActionViewQuilt.muiName = 'SvgIcon';
	
	exports.default = ActionViewQuilt;

/***/ },
/* 1093 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewStream = function ActionViewStream(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18h17v-6H4v6zM4 5v6h17V5H4z' })
	  );
	};
	ActionViewStream = (0, _pure2.default)(ActionViewStream);
	ActionViewStream.displayName = 'ActionViewStream';
	ActionViewStream.muiName = 'SvgIcon';
	
	exports.default = ActionViewStream;

/***/ },
/* 1094 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionViewWeek = function ActionViewWeek(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 5H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm14 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zm-7 0h-3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h3c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1z' })
	  );
	};
	ActionViewWeek = (0, _pure2.default)(ActionViewWeek);
	ActionViewWeek.displayName = 'ActionViewWeek';
	ActionViewWeek.muiName = 'SvgIcon';
	
	exports.default = ActionViewWeek;

/***/ },
/* 1095 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionVisibilityOff = function ActionVisibilityOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7c2.76 0 5 2.24 5 5 0 .65-.13 1.26-.36 1.83l2.92 2.92c1.51-1.26 2.7-2.89 3.43-4.75-1.73-4.39-6-7.5-11-7.5-1.4 0-2.74.25-3.98.7l2.16 2.16C10.74 7.13 11.35 7 12 7zM2 4.27l2.28 2.28.46.46C3.08 8.3 1.78 10.02 1 12c1.73 4.39 6 7.5 11 7.5 1.55 0 3.03-.3 4.38-.84l.42.42L19.73 22 21 20.73 3.27 3 2 4.27zM7.53 9.8l1.55 1.55c-.05.21-.08.43-.08.65 0 1.66 1.34 3 3 3 .22 0 .44-.03.65-.08l1.55 1.55c-.67.33-1.41.53-2.2.53-2.76 0-5-2.24-5-5 0-.79.2-1.53.53-2.2zm4.31-.78l3.15 3.15.02-.16c0-1.66-1.34-3-3-3l-.17.01z' })
	  );
	};
	ActionVisibilityOff = (0, _pure2.default)(ActionVisibilityOff);
	ActionVisibilityOff.displayName = 'ActionVisibilityOff';
	ActionVisibilityOff.muiName = 'SvgIcon';
	
	exports.default = ActionVisibilityOff;

/***/ },
/* 1096 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionVisibility = function ActionVisibility(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	ActionVisibility = (0, _pure2.default)(ActionVisibility);
	ActionVisibility.displayName = 'ActionVisibility';
	ActionVisibility.muiName = 'SvgIcon';
	
	exports.default = ActionVisibility;

/***/ },
/* 1097 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionWatchLater = function ActionWatchLater(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm4.2 14.2L11 13V7h1.5v5.2l4.5 2.7-.8 1.3z' })
	  );
	};
	ActionWatchLater = (0, _pure2.default)(ActionWatchLater);
	ActionWatchLater.displayName = 'ActionWatchLater';
	ActionWatchLater.muiName = 'SvgIcon';
	
	exports.default = ActionWatchLater;

/***/ },
/* 1098 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionWork = function ActionWork(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-4V4c0-1.11-.89-2-2-2h-4c-1.11 0-2 .89-2 2v2H4c-1.11 0-1.99.89-1.99 2L2 19c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-6 0h-4V4h4v2z' })
	  );
	};
	ActionWork = (0, _pure2.default)(ActionWork);
	ActionWork.displayName = 'ActionWork';
	ActionWork.muiName = 'SvgIcon';
	
	exports.default = ActionWork;

/***/ },
/* 1099 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionYoutubeSearchedFor = function ActionYoutubeSearchedFor(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.01 14h-.8l-.27-.27c.98-1.14 1.57-2.61 1.57-4.23 0-3.59-2.91-6.5-6.5-6.5s-6.5 3-6.5 6.5H2l3.84 4 4.16-4H6.51C6.51 7 8.53 5 11.01 5s4.5 2.01 4.5 4.5c0 2.48-2.02 4.5-4.5 4.5-.65 0-1.26-.14-1.82-.38L7.71 15.1c.97.57 2.09.9 3.3.9 1.61 0 3.08-.59 4.22-1.57l.27.27v.79l5.01 4.99L22 19l-4.99-5z' })
	  );
	};
	ActionYoutubeSearchedFor = (0, _pure2.default)(ActionYoutubeSearchedFor);
	ActionYoutubeSearchedFor.displayName = 'ActionYoutubeSearchedFor';
	ActionYoutubeSearchedFor.muiName = 'SvgIcon';
	
	exports.default = ActionYoutubeSearchedFor;

/***/ },
/* 1100 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionZoomIn = function ActionZoomIn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zm2.5-4h-2v2H9v-2H7V9h2V7h1v2h2v1z' })
	  );
	};
	ActionZoomIn = (0, _pure2.default)(ActionZoomIn);
	ActionZoomIn.displayName = 'ActionZoomIn';
	ActionZoomIn.muiName = 'SvgIcon';
	
	exports.default = ActionZoomIn;

/***/ },
/* 1101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ActionZoomOut = function ActionZoomOut(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14zM7 9h5v1H7z' })
	  );
	};
	ActionZoomOut = (0, _pure2.default)(ActionZoomOut);
	ActionZoomOut.displayName = 'ActionZoomOut';
	ActionZoomOut.muiName = 'SvgIcon';
	
	exports.default = ActionZoomOut;

/***/ },
/* 1102 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertAddAlert = function AlertAddAlert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.01 21.01c0 1.1.89 1.99 1.99 1.99s1.99-.89 1.99-1.99h-3.98zm8.87-4.19V11c0-3.25-2.25-5.97-5.29-6.69v-.72C13.59 2.71 12.88 2 12 2s-1.59.71-1.59 1.59v.72C7.37 5.03 5.12 7.75 5.12 11v5.82L3 18.94V20h18v-1.06l-2.12-2.12zM16 13.01h-3v3h-2v-3H8V11h3V8h2v3h3v2.01z' })
	  );
	};
	AlertAddAlert = (0, _pure2.default)(AlertAddAlert);
	AlertAddAlert.displayName = 'AlertAddAlert';
	AlertAddAlert.muiName = 'SvgIcon';
	
	exports.default = AlertAddAlert;

/***/ },
/* 1103 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertErrorOutline = function AlertErrorOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 15h2v2h-2zm0-8h2v6h-2zm.99-5C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	AlertErrorOutline = (0, _pure2.default)(AlertErrorOutline);
	AlertErrorOutline.displayName = 'AlertErrorOutline';
	AlertErrorOutline.muiName = 'SvgIcon';
	
	exports.default = AlertErrorOutline;

/***/ },
/* 1104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertError = function AlertError(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z' })
	  );
	};
	AlertError = (0, _pure2.default)(AlertError);
	AlertError.displayName = 'AlertError';
	AlertError.muiName = 'SvgIcon';
	
	exports.default = AlertError;

/***/ },
/* 1105 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AlertWarning = function AlertWarning(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z' })
	  );
	};
	AlertWarning = (0, _pure2.default)(AlertWarning);
	AlertWarning.displayName = 'AlertWarning';
	AlertWarning.muiName = 'SvgIcon';
	
	exports.default = AlertWarning;

/***/ },
/* 1106 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAddToQueue = function AvAddToQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2h-3v3h-2v-3H8v-2h3V7h2v3h3z' })
	  );
	};
	AvAddToQueue = (0, _pure2.default)(AvAddToQueue);
	AvAddToQueue.displayName = 'AvAddToQueue';
	AvAddToQueue.muiName = 'SvgIcon';
	
	exports.default = AvAddToQueue;

/***/ },
/* 1107 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAirplay = function AvAirplay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 22h12l-6-6zM21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V5h18v12h-4v2h4c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	AvAirplay = (0, _pure2.default)(AvAirplay);
	AvAirplay.displayName = 'AvAirplay';
	AvAirplay.muiName = 'SvgIcon';
	
	exports.default = AvAirplay;

/***/ },
/* 1108 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAlbum = function AvAlbum(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 14.5c-2.49 0-4.5-2.01-4.5-4.5S9.51 7.5 12 7.5s4.5 2.01 4.5 4.5-2.01 4.5-4.5 4.5zm0-5.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' })
	  );
	};
	AvAlbum = (0, _pure2.default)(AvAlbum);
	AvAlbum.displayName = 'AvAlbum';
	AvAlbum.muiName = 'SvgIcon';
	
	exports.default = AvAlbum;

/***/ },
/* 1109 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvArtTrack = function AvArtTrack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 13h-8v-2h8v2zm0-6h-8v2h8V7zm-8 10h8v-2h-8v2zm-2-8v6c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V9c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2zm-1.5 6l-2.25-3-1.75 2.26-1.25-1.51L3.5 15h7z' })
	  );
	};
	AvArtTrack = (0, _pure2.default)(AvArtTrack);
	AvArtTrack.displayName = 'AvArtTrack';
	AvArtTrack.muiName = 'SvgIcon';
	
	exports.default = AvArtTrack;

/***/ },
/* 1110 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvAvTimer = function AvAvTimer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1zm0-14v4h2V5.08c3.39.49 6 3.39 6 6.92 0 3.87-3.13 7-7 7s-7-3.13-7-7c0-1.68.59-3.22 1.58-4.42L12 13l1.41-1.41-6.8-6.8v.02C4.42 6.45 3 9.05 3 12c0 4.97 4.02 9 9 9 4.97 0 9-4.03 9-9s-4.03-9-9-9h-1zm7 9c0-.55-.45-1-1-1s-1 .45-1 1 .45 1 1 1 1-.45 1-1zM6 12c0 .55.45 1 1 1s1-.45 1-1-.45-1-1-1-1 .45-1 1z' })
	  );
	};
	AvAvTimer = (0, _pure2.default)(AvAvTimer);
	AvAvTimer.displayName = 'AvAvTimer';
	AvAvTimer.muiName = 'SvgIcon';
	
	exports.default = AvAvTimer;

/***/ },
/* 1111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvBrandingWatermark = function AvBrandingWatermark(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16h-9v-6h9v6z' })
	  );
	};
	AvBrandingWatermark = (0, _pure2.default)(AvBrandingWatermark);
	AvBrandingWatermark.displayName = 'AvBrandingWatermark';
	AvBrandingWatermark.muiName = 'SvgIcon';
	
	exports.default = AvBrandingWatermark;

/***/ },
/* 1112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvCallToAction = function AvCallToAction(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3v-3h18v3z' })
	  );
	};
	AvCallToAction = (0, _pure2.default)(AvCallToAction);
	AvCallToAction.displayName = 'AvCallToAction';
	AvCallToAction.muiName = 'SvgIcon';
	
	exports.default = AvCallToAction;

/***/ },
/* 1113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvClosedCaption = function AvClosedCaption(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 7H9.5v-.5h-2v3h2V13H11v1c0 .55-.45 1-1 1H7c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1zm7 0h-1.5v-.5h-2v3h2V13H18v1c0 .55-.45 1-1 1h-3c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v1z' })
	  );
	};
	AvClosedCaption = (0, _pure2.default)(AvClosedCaption);
	AvClosedCaption.displayName = 'AvClosedCaption';
	AvClosedCaption.muiName = 'SvgIcon';
	
	exports.default = AvClosedCaption;

/***/ },
/* 1114 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvEqualizer = function AvEqualizer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20h4V4h-4v16zm-6 0h4v-8H4v8zM16 9v11h4V9h-4z' })
	  );
	};
	AvEqualizer = (0, _pure2.default)(AvEqualizer);
	AvEqualizer.displayName = 'AvEqualizer';
	AvEqualizer.muiName = 'SvgIcon';
	
	exports.default = AvEqualizer;

/***/ },
/* 1115 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvExplicit = function AvExplicit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h4v2h-4v2h4v2H9V7h6v2z' })
	  );
	};
	AvExplicit = (0, _pure2.default)(AvExplicit);
	AvExplicit.displayName = 'AvExplicit';
	AvExplicit.muiName = 'SvgIcon';
	
	exports.default = AvExplicit;

/***/ },
/* 1116 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFastForward = function AvFastForward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 18l8.5-6L4 6v12zm9-12v12l8.5-6L13 6z' })
	  );
	};
	AvFastForward = (0, _pure2.default)(AvFastForward);
	AvFastForward.displayName = 'AvFastForward';
	AvFastForward.muiName = 'SvgIcon';
	
	exports.default = AvFastForward;

/***/ },
/* 1117 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFastRewind = function AvFastRewind(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 18V6l-8.5 6 8.5 6zm.5-6l8.5 6V6l-8.5 6z' })
	  );
	};
	AvFastRewind = (0, _pure2.default)(AvFastRewind);
	AvFastRewind.displayName = 'AvFastRewind';
	AvFastRewind.muiName = 'SvgIcon';
	
	exports.default = AvFastRewind;

/***/ },
/* 1118 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFeaturedPlayList = function AvFeaturedPlayList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 8H3V9h9v2zm0-4H3V5h9v2z' })
	  );
	};
	AvFeaturedPlayList = (0, _pure2.default)(AvFeaturedPlayList);
	AvFeaturedPlayList.displayName = 'AvFeaturedPlayList';
	AvFeaturedPlayList.muiName = 'SvgIcon';
	
	exports.default = AvFeaturedPlayList;

/***/ },
/* 1119 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFeaturedVideo = function AvFeaturedVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 9H3V5h9v7z' })
	  );
	};
	AvFeaturedVideo = (0, _pure2.default)(AvFeaturedVideo);
	AvFeaturedVideo.displayName = 'AvFeaturedVideo';
	AvFeaturedVideo.muiName = 'SvgIcon';
	
	exports.default = AvFeaturedVideo;

/***/ },
/* 1120 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberDvr = function AvFiberDvr(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.5 10.5h2v1h-2zm-13 0h2v3h-2zM21 3H3c-1.11 0-2 .89-2 2v14c0 1.1.89 2 2 2h18c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zM8 13.5c0 .85-.65 1.5-1.5 1.5H3V9h3.5c.85 0 1.5.65 1.5 1.5v3zm4.62 1.5h-1.5L9.37 9h1.5l1 3.43 1-3.43h1.5l-1.75 6zM21 11.5c0 .6-.4 1.15-.9 1.4L21 15h-1.5l-.85-2H17.5v2H16V9h3.5c.85 0 1.5.65 1.5 1.5v1z' })
	  );
	};
	AvFiberDvr = (0, _pure2.default)(AvFiberDvr);
	AvFiberDvr.displayName = 'AvFiberDvr';
	AvFiberDvr.muiName = 'SvgIcon';
	
	exports.default = AvFiberDvr;

/***/ },
/* 1121 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberManualRecord = function AvFiberManualRecord(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '8' })
	  );
	};
	AvFiberManualRecord = (0, _pure2.default)(AvFiberManualRecord);
	AvFiberManualRecord.displayName = 'AvFiberManualRecord';
	AvFiberManualRecord.muiName = 'SvgIcon';
	
	exports.default = AvFiberManualRecord;

/***/ },
/* 1122 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberNew = function AvFiberNew(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM8.5 15H7.3l-2.55-3.5V15H3.5V9h1.25l2.5 3.5V9H8.5v6zm5-4.74H11v1.12h2.5v1.26H11v1.11h2.5V15h-4V9h4v1.26zm7 3.74c0 .55-.45 1-1 1h-4c-.55 0-1-.45-1-1V9h1.25v4.51h1.13V9.99h1.25v3.51h1.12V9h1.25v5z' })
	  );
	};
	AvFiberNew = (0, _pure2.default)(AvFiberNew);
	AvFiberNew.displayName = 'AvFiberNew';
	AvFiberNew.muiName = 'SvgIcon';
	
	exports.default = AvFiberNew;

/***/ },
/* 1123 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberPin = function AvFiberPin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.5 10.5h2v1h-2zM20 4H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zM9 11.5c0 .85-.65 1.5-1.5 1.5h-2v2H4V9h3.5c.85 0 1.5.65 1.5 1.5v1zm3.5 3.5H11V9h1.5v6zm7.5 0h-1.2l-2.55-3.5V15H15V9h1.25l2.5 3.5V9H20v6z' })
	  );
	};
	AvFiberPin = (0, _pure2.default)(AvFiberPin);
	AvFiberPin.displayName = 'AvFiberPin';
	AvFiberPin.muiName = 'SvgIcon';
	
	exports.default = AvFiberPin;

/***/ },
/* 1124 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvFiberSmartRecord = function AvFiberSmartRecord(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement(
	      'g',
	      null,
	      _react2.default.createElement('circle', { cx: '9', cy: '12', r: '8' }),
	      _react2.default.createElement('path', { d: 'M17 4.26v2.09c2.33.82 4 3.04 4 5.65s-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74s-2.55-6.85-6-7.74z' })
	    )
	  );
	};
	AvFiberSmartRecord = (0, _pure2.default)(AvFiberSmartRecord);
	AvFiberSmartRecord.displayName = 'AvFiberSmartRecord';
	AvFiberSmartRecord.muiName = 'SvgIcon';
	
	exports.default = AvFiberSmartRecord;

/***/ },
/* 1125 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvForward10 = function AvForward10(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.8 3H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
	  );
	};
	AvForward10 = (0, _pure2.default)(AvForward10);
	AvForward10.displayName = 'AvForward10';
	AvForward10.muiName = 'SvgIcon';
	
	exports.default = AvForward10;

/***/ },
/* 1126 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvForward30 = function AvForward30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.6 13.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5zM4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8z' })
	  );
	};
	AvForward30 = (0, _pure2.default)(AvForward30);
	AvForward30.displayName = 'AvForward30';
	AvForward30.muiName = 'SvgIcon';
	
	exports.default = AvForward30;

/***/ },
/* 1127 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvForward5 = function AvForward5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 13c0 4.4 3.6 8 8 8s8-3.6 8-8h-2c0 3.3-2.7 6-6 6s-6-2.7-6-6 2.7-6 6-6v4l5-5-5-5v4c-4.4 0-8 3.6-8 8zm6.7.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.5.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.6z' })
	  );
	};
	AvForward5 = (0, _pure2.default)(AvForward5);
	AvForward5.displayName = 'AvForward5';
	AvForward5.muiName = 'SvgIcon';
	
	exports.default = AvForward5;

/***/ },
/* 1128 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvGames = function AvGames(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
	  );
	};
	AvGames = (0, _pure2.default)(AvGames);
	AvGames.displayName = 'AvGames';
	AvGames.muiName = 'SvgIcon';
	
	exports.default = AvGames;

/***/ },
/* 1129 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvHd = function AvHd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-8 12H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm2-6h4c.55 0 1 .45 1 1v4c0 .55-.45 1-1 1h-4V9zm1.5 4.5h2v-3h-2v3z' })
	  );
	};
	AvHd = (0, _pure2.default)(AvHd);
	AvHd.displayName = 'AvHd';
	AvHd.muiName = 'SvgIcon';
	
	exports.default = AvHd;

/***/ },
/* 1130 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvHearing = function AvHearing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 20c-.29 0-.56-.06-.76-.15-.71-.37-1.21-.88-1.71-2.38-.51-1.56-1.47-2.29-2.39-3-.79-.61-1.61-1.24-2.32-2.53C9.29 10.98 9 9.93 9 9c0-2.8 2.2-5 5-5s5 2.2 5 5h2c0-3.93-3.07-7-7-7S7 5.07 7 9c0 1.26.38 2.65 1.07 3.9.91 1.65 1.98 2.48 2.85 3.15.81.62 1.39 1.07 1.71 2.05.6 1.82 1.37 2.84 2.73 3.55.51.23 1.07.35 1.64.35 2.21 0 4-1.79 4-4h-2c0 1.1-.9 2-2 2zM7.64 2.64L6.22 1.22C4.23 3.21 3 5.96 3 9s1.23 5.79 3.22 7.78l1.41-1.41C6.01 13.74 5 11.49 5 9s1.01-4.74 2.64-6.36zM11.5 9c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5-1.12-2.5-2.5-2.5-2.5 1.12-2.5 2.5z' })
	  );
	};
	AvHearing = (0, _pure2.default)(AvHearing);
	AvHearing.displayName = 'AvHearing';
	AvHearing.muiName = 'SvgIcon';
	
	exports.default = AvHearing;

/***/ },
/* 1131 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvHighQuality = function AvHighQuality(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 11H9.5v-2h-2v2H6V9h1.5v2.5h2V9H11v6zm7-1c0 .55-.45 1-1 1h-.75v1.5h-1.5V15H14c-.55 0-1-.45-1-1v-4c0-.55.45-1 1-1h3c.55 0 1 .45 1 1v4zm-3.5-.5h2v-3h-2v3z' })
	  );
	};
	AvHighQuality = (0, _pure2.default)(AvHighQuality);
	AvHighQuality.displayName = 'AvHighQuality';
	AvHighQuality.muiName = 'SvgIcon';
	
	exports.default = AvHighQuality;

/***/ },
/* 1132 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLibraryAdd = function AvLibraryAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
	  );
	};
	AvLibraryAdd = (0, _pure2.default)(AvLibraryAdd);
	AvLibraryAdd.displayName = 'AvLibraryAdd';
	AvLibraryAdd.muiName = 'SvgIcon';
	
	exports.default = AvLibraryAdd;

/***/ },
/* 1133 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLibraryBooks = function AvLibraryBooks(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9H9V9h10v2zm-4 4H9v-2h6v2zm4-8H9V5h10v2z' })
	  );
	};
	AvLibraryBooks = (0, _pure2.default)(AvLibraryBooks);
	AvLibraryBooks.displayName = 'AvLibraryBooks';
	AvLibraryBooks.muiName = 'SvgIcon';
	
	exports.default = AvLibraryBooks;

/***/ },
/* 1134 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLibraryMusic = function AvLibraryMusic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 5h-3v5.5c0 1.38-1.12 2.5-2.5 2.5S10 13.88 10 12.5s1.12-2.5 2.5-2.5c.57 0 1.08.19 1.5.51V5h4v2zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6z' })
	  );
	};
	AvLibraryMusic = (0, _pure2.default)(AvLibraryMusic);
	AvLibraryMusic.displayName = 'AvLibraryMusic';
	AvLibraryMusic.muiName = 'SvgIcon';
	
	exports.default = AvLibraryMusic;

/***/ },
/* 1135 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvLoop = function AvLoop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
	  );
	};
	AvLoop = (0, _pure2.default)(AvLoop);
	AvLoop.displayName = 'AvLoop';
	AvLoop.muiName = 'SvgIcon';
	
	exports.default = AvLoop;

/***/ },
/* 1136 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMicNone = function AvMicNone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm-1.2-9.1c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2l-.01 6.2c0 .66-.53 1.2-1.19 1.2-.66 0-1.2-.54-1.2-1.2V4.9zm6.5 6.1c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
	  );
	};
	AvMicNone = (0, _pure2.default)(AvMicNone);
	AvMicNone.displayName = 'AvMicNone';
	AvMicNone.muiName = 'SvgIcon';
	
	exports.default = AvMicNone;

/***/ },
/* 1137 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMicOff = function AvMicOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 11h-1.7c0 .74-.16 1.43-.43 2.05l1.23 1.23c.56-.98.9-2.09.9-3.28zm-4.02.17c0-.06.02-.11.02-.17V5c0-1.66-1.34-3-3-3S9 3.34 9 5v.18l5.98 5.99zM4.27 3L3 4.27l6.01 6.01V11c0 1.66 1.33 3 2.99 3 .22 0 .44-.03.65-.08l1.66 1.66c-.71.33-1.5.52-2.31.52-2.76 0-5.3-2.1-5.3-5.1H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c.91-.13 1.77-.45 2.54-.9L19.73 21 21 19.73 4.27 3z' })
	  );
	};
	AvMicOff = (0, _pure2.default)(AvMicOff);
	AvMicOff.displayName = 'AvMicOff';
	AvMicOff.muiName = 'SvgIcon';
	
	exports.default = AvMicOff;

/***/ },
/* 1138 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMic = function AvMic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 14c1.66 0 2.99-1.34 2.99-3L15 5c0-1.66-1.34-3-3-3S9 3.34 9 5v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 14 6.7 11H5c0 3.41 2.72 6.23 6 6.72V21h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
	  );
	};
	AvMic = (0, _pure2.default)(AvMic);
	AvMic.displayName = 'AvMic';
	AvMic.muiName = 'SvgIcon';
	
	exports.default = AvMic;

/***/ },
/* 1139 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMovie = function AvMovie(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
	  );
	};
	AvMovie = (0, _pure2.default)(AvMovie);
	AvMovie.displayName = 'AvMovie';
	AvMovie.muiName = 'SvgIcon';
	
	exports.default = AvMovie;

/***/ },
/* 1140 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvMusicVideo = function AvMusicVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H3V5h18v14zM8 15c0-1.66 1.34-3 3-3 .35 0 .69.07 1 .18V6h5v2h-3v7.03c-.02 1.64-1.35 2.97-3 2.97-1.66 0-3-1.34-3-3z' })
	  );
	};
	AvMusicVideo = (0, _pure2.default)(AvMusicVideo);
	AvMusicVideo.displayName = 'AvMusicVideo';
	AvMusicVideo.muiName = 'SvgIcon';
	
	exports.default = AvMusicVideo;

/***/ },
/* 1141 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvNewReleases = function AvNewReleases(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 12l-2.44-2.78.34-3.68-3.61-.82-1.89-3.18L12 3 8.6 1.54 6.71 4.72l-3.61.81.34 3.68L1 12l2.44 2.78-.34 3.69 3.61.82 1.89 3.18L12 21l3.4 1.46 1.89-3.18 3.61-.82-.34-3.68L23 12zm-10 5h-2v-2h2v2zm0-4h-2V7h2v6z' })
	  );
	};
	AvNewReleases = (0, _pure2.default)(AvNewReleases);
	AvNewReleases.displayName = 'AvNewReleases';
	AvNewReleases.muiName = 'SvgIcon';
	
	exports.default = AvNewReleases;

/***/ },
/* 1142 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvNotInterested = function AvNotInterested(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
	  );
	};
	AvNotInterested = (0, _pure2.default)(AvNotInterested);
	AvNotInterested.displayName = 'AvNotInterested';
	AvNotInterested.muiName = 'SvgIcon';
	
	exports.default = AvNotInterested;

/***/ },
/* 1143 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvNote = function AvNote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 10l-6-6H4c-1.1 0-2 .9-2 2v12.01c0 1.1.9 1.99 2 1.99l16-.01c1.1 0 2-.89 2-1.99v-8zm-7-4.5l5.5 5.5H15V5.5z' })
	  );
	};
	AvNote = (0, _pure2.default)(AvNote);
	AvNote.displayName = 'AvNote';
	AvNote.muiName = 'SvgIcon';
	
	exports.default = AvNote;

/***/ },
/* 1144 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPauseCircleFilled = function AvPauseCircleFilled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 14H9V8h2v8zm4 0h-2V8h2v8z' })
	  );
	};
	AvPauseCircleFilled = (0, _pure2.default)(AvPauseCircleFilled);
	AvPauseCircleFilled.displayName = 'AvPauseCircleFilled';
	AvPauseCircleFilled.muiName = 'SvgIcon';
	
	exports.default = AvPauseCircleFilled;

/***/ },
/* 1145 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPauseCircleOutline = function AvPauseCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16h2V8H9v8zm3-14C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm1-4h2V8h-2v8z' })
	  );
	};
	AvPauseCircleOutline = (0, _pure2.default)(AvPauseCircleOutline);
	AvPauseCircleOutline.displayName = 'AvPauseCircleOutline';
	AvPauseCircleOutline.muiName = 'SvgIcon';
	
	exports.default = AvPauseCircleOutline;

/***/ },
/* 1146 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPause = function AvPause(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 19h4V5H6v14zm8-14v14h4V5h-4z' })
	  );
	};
	AvPause = (0, _pure2.default)(AvPause);
	AvPause.displayName = 'AvPause';
	AvPause.muiName = 'SvgIcon';
	
	exports.default = AvPause;

/***/ },
/* 1147 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayArrow = function AvPlayArrow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 5v14l11-7z' })
	  );
	};
	AvPlayArrow = (0, _pure2.default)(AvPlayArrow);
	AvPlayArrow.displayName = 'AvPlayArrow';
	AvPlayArrow.muiName = 'SvgIcon';
	
	exports.default = AvPlayArrow;

/***/ },
/* 1148 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayCircleFilled = function AvPlayCircleFilled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 14.5v-9l6 4.5-6 4.5z' })
	  );
	};
	AvPlayCircleFilled = (0, _pure2.default)(AvPlayCircleFilled);
	AvPlayCircleFilled.displayName = 'AvPlayCircleFilled';
	AvPlayCircleFilled.muiName = 'SvgIcon';
	
	exports.default = AvPlayCircleFilled;

/***/ },
/* 1149 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlayCircleOutline = function AvPlayCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 16.5l6-4.5-6-4.5v9zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	AvPlayCircleOutline = (0, _pure2.default)(AvPlayCircleOutline);
	AvPlayCircleOutline.displayName = 'AvPlayCircleOutline';
	AvPlayCircleOutline.muiName = 'SvgIcon';
	
	exports.default = AvPlayCircleOutline;

/***/ },
/* 1150 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlaylistAddCheck = function AvPlaylistAddCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zM2 16h8v-2H2v2zm19.5-4.5L23 13l-6.99 7-4.51-4.5L13 14l3.01 3 5.49-5.5z' })
	  );
	};
	AvPlaylistAddCheck = (0, _pure2.default)(AvPlaylistAddCheck);
	AvPlaylistAddCheck.displayName = 'AvPlaylistAddCheck';
	AvPlaylistAddCheck.muiName = 'SvgIcon';
	
	exports.default = AvPlaylistAddCheck;

/***/ },
/* 1151 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlaylistAdd = function AvPlaylistAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 10H2v2h12v-2zm0-4H2v2h12V6zm4 8v-4h-2v4h-4v2h4v4h2v-4h4v-2h-4zM2 16h8v-2H2v2z' })
	  );
	};
	AvPlaylistAdd = (0, _pure2.default)(AvPlaylistAdd);
	AvPlaylistAdd.displayName = 'AvPlaylistAdd';
	AvPlaylistAdd.muiName = 'SvgIcon';
	
	exports.default = AvPlaylistAdd;

/***/ },
/* 1152 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvPlaylistPlay = function AvPlaylistPlay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 9H2v2h17V9zm0-4H2v2h17V5zM2 15h13v-2H2v2zm15-2v6l5-3-5-3z' })
	  );
	};
	AvPlaylistPlay = (0, _pure2.default)(AvPlaylistPlay);
	AvPlaylistPlay.displayName = 'AvPlaylistPlay';
	AvPlaylistPlay.muiName = 'SvgIcon';
	
	exports.default = AvPlaylistPlay;

/***/ },
/* 1153 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvQueueMusic = function AvQueueMusic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 6H3v2h12V6zm0 4H3v2h12v-2zM3 16h8v-2H3v2zM17 6v8.18c-.31-.11-.65-.18-1-.18-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3V8h3V6h-5z' })
	  );
	};
	AvQueueMusic = (0, _pure2.default)(AvQueueMusic);
	AvQueueMusic.displayName = 'AvQueueMusic';
	AvQueueMusic.muiName = 'SvgIcon';
	
	exports.default = AvQueueMusic;

/***/ },
/* 1154 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvQueuePlayNext = function AvQueuePlayNext(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5c0-1.11-.9-2-2-2zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3zm11 8l-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18z' })
	  );
	};
	AvQueuePlayNext = (0, _pure2.default)(AvQueuePlayNext);
	AvQueuePlayNext.displayName = 'AvQueuePlayNext';
	AvQueuePlayNext.muiName = 'SvgIcon';
	
	exports.default = AvQueuePlayNext;

/***/ },
/* 1155 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvQueue = function AvQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
	  );
	};
	AvQueue = (0, _pure2.default)(AvQueue);
	AvQueue.displayName = 'AvQueue';
	AvQueue.muiName = 'SvgIcon';
	
	exports.default = AvQueue;

/***/ },
/* 1156 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRadio = function AvRadio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.24 6.15C2.51 6.43 2 7.17 2 8v12c0 1.1.89 2 2 2h16c1.11 0 2-.9 2-2V8c0-1.11-.89-2-2-2H8.3l8.26-3.34L15.88 1 3.24 6.15zM7 20c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm13-8h-2v-2h-2v2H4V8h16v4z' })
	  );
	};
	AvRadio = (0, _pure2.default)(AvRadio);
	AvRadio.displayName = 'AvRadio';
	AvRadio.muiName = 'SvgIcon';
	
	exports.default = AvRadio;

/***/ },
/* 1157 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRecentActors = function AvRecentActors(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5v14h2V5h-2zm-4 14h2V5h-2v14zM14 5H2c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM8 7.75c1.24 0 2.25 1.01 2.25 2.25S9.24 12.25 8 12.25 5.75 11.24 5.75 10 6.76 7.75 8 7.75zM12.5 17h-9v-.75c0-1.5 3-2.25 4.5-2.25s4.5.75 4.5 2.25V17z' })
	  );
	};
	AvRecentActors = (0, _pure2.default)(AvRecentActors);
	AvRecentActors.displayName = 'AvRecentActors';
	AvRecentActors.muiName = 'SvgIcon';
	
	exports.default = AvRecentActors;

/***/ },
/* 1158 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRemoveFromQueue = function AvRemoveFromQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-7v2H8v-2h8z' })
	  );
	};
	AvRemoveFromQueue = (0, _pure2.default)(AvRemoveFromQueue);
	AvRemoveFromQueue.displayName = 'AvRemoveFromQueue';
	AvRemoveFromQueue.muiName = 'SvgIcon';
	
	exports.default = AvRemoveFromQueue;

/***/ },
/* 1159 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRepeatOne = function AvRepeatOne(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4zm-4-2V9h-1l-2 1v1h1.5v4H13z' })
	  );
	};
	AvRepeatOne = (0, _pure2.default)(AvRepeatOne);
	AvRepeatOne.displayName = 'AvRepeatOne';
	AvRepeatOne.muiName = 'SvgIcon';
	
	exports.default = AvRepeatOne;

/***/ },
/* 1160 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvRepeat = function AvRepeat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 7h10v3l4-4-4-4v3H5v6h2V7zm10 10H7v-3l-4 4 4 4v-3h12v-6h-2v4z' })
	  );
	};
	AvRepeat = (0, _pure2.default)(AvRepeat);
	AvRepeat.displayName = 'AvRepeat';
	AvRepeat.muiName = 'SvgIcon';
	
	exports.default = AvRepeat;

/***/ },
/* 1161 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay10 = function AvReplay10(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.1 11H10v-3.3L9 13v-.7l1.8-.6h.1V16zm4.3-1.8c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1c.2.1.3.2.5.3s.2.3.3.6.1.5.1.8v.7zm-.9-.8v-.5s-.1-.2-.1-.3-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
	  );
	};
	AvReplay10 = (0, _pure2.default)(AvReplay10);
	AvReplay10.displayName = 'AvReplay10';
	AvReplay10.muiName = 'SvgIcon';
	
	exports.default = AvReplay10;

/***/ },
/* 1162 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay30 = function AvReplay30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-2.4 8.5h.4c.2 0 .4-.1.5-.2s.2-.2.2-.4v-.2s-.1-.1-.1-.2-.1-.1-.2-.1h-.5s-.1.1-.2.1-.1.1-.1.2v.2h-1c0-.2 0-.3.1-.5s.2-.3.3-.4.3-.2.4-.2.4-.1.5-.1c.2 0 .4 0 .6.1s.3.1.5.2.2.2.3.4.1.3.1.5v.3s-.1.2-.1.3-.1.2-.2.2-.2.1-.3.2c.2.1.4.2.5.4s.2.4.2.6c0 .2 0 .4-.1.5s-.2.3-.3.4-.3.2-.5.2-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.4-.1-.6h.8v.2s.1.1.1.2.1.1.2.1h.5s.1-.1.2-.1.1-.1.1-.2v-.5s-.1-.1-.1-.2-.1-.1-.2-.1h-.6v-.7zm5.7.7c0 .3 0 .6-.1.8l-.3.6s-.3.3-.5.3-.4.1-.6.1-.4 0-.6-.1-.3-.2-.5-.3-.2-.3-.3-.6-.1-.5-.1-.8v-.7c0-.3 0-.6.1-.8l.3-.6s.3-.3.5-.3.4-.1.6-.1.4 0 .6.1.3.2.5.3.2.3.3.6.1.5.1.8v.7zm-.8-.8v-.5c0-.1-.1-.2-.1-.3s-.1-.1-.2-.2-.2-.1-.3-.1-.2 0-.3.1l-.2.2s-.1.2-.1.3v2s.1.2.1.3.1.1.2.2.2.1.3.1.2 0 .3-.1l.2-.2s.1-.2.1-.3v-1.5z' })
	  );
	};
	AvReplay30 = (0, _pure2.default)(AvReplay30);
	AvReplay30.displayName = 'AvReplay30';
	AvReplay30.muiName = 'SvgIcon';
	
	exports.default = AvReplay30;

/***/ },
/* 1163 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay5 = function AvReplay5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6H4c0 4.4 3.6 8 8 8s8-3.6 8-8-3.6-8-8-8zm-1.3 8.9l.2-2.2h2.4v.7h-1.7l-.1.9s.1 0 .1-.1.1 0 .1-.1.1 0 .2 0h.2c.2 0 .4 0 .5.1s.3.2.4.3.2.3.3.5.1.4.1.6c0 .2 0 .4-.1.5s-.1.3-.3.5-.3.2-.4.3-.4.1-.6.1c-.2 0-.4 0-.5-.1s-.3-.1-.5-.2-.2-.2-.3-.4-.1-.3-.1-.5h.8c0 .2.1.3.2.4s.2.1.4.1c.1 0 .2 0 .3-.1l.2-.2s.1-.2.1-.3v-.6l-.1-.2-.2-.2s-.2-.1-.3-.1h-.2s-.1 0-.2.1-.1 0-.1.1-.1.1-.1.1h-.7z' })
	  );
	};
	AvReplay5 = (0, _pure2.default)(AvReplay5);
	AvReplay5.displayName = 'AvReplay5';
	AvReplay5.muiName = 'SvgIcon';
	
	exports.default = AvReplay5;

/***/ },
/* 1164 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvReplay = function AvReplay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5V1L7 6l5 5V7c3.31 0 6 2.69 6 6s-2.69 6-6 6-6-2.69-6-6H4c0 4.42 3.58 8 8 8s8-3.58 8-8-3.58-8-8-8z' })
	  );
	};
	AvReplay = (0, _pure2.default)(AvReplay);
	AvReplay.displayName = 'AvReplay';
	AvReplay.muiName = 'SvgIcon';
	
	exports.default = AvReplay;

/***/ },
/* 1165 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvShuffle = function AvShuffle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.59 9.17L5.41 4 4 5.41l5.17 5.17 1.42-1.41zM14.5 4l2.04 2.04L4 18.59 5.41 20 17.96 7.46 20 9.5V4h-5.5zm.33 9.41l-1.41 1.41 3.13 3.13L14.5 20H20v-5.5l-2.04 2.04-3.13-3.13z' })
	  );
	};
	AvShuffle = (0, _pure2.default)(AvShuffle);
	AvShuffle.displayName = 'AvShuffle';
	AvShuffle.muiName = 'SvgIcon';
	
	exports.default = AvShuffle;

/***/ },
/* 1166 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSkipNext = function AvSkipNext(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 18l8.5-6L6 6v12zM16 6v12h2V6h-2z' })
	  );
	};
	AvSkipNext = (0, _pure2.default)(AvSkipNext);
	AvSkipNext.displayName = 'AvSkipNext';
	AvSkipNext.muiName = 'SvgIcon';
	
	exports.default = AvSkipNext;

/***/ },
/* 1167 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSkipPrevious = function AvSkipPrevious(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 6h2v12H6zm3.5 6l8.5 6V6z' })
	  );
	};
	AvSkipPrevious = (0, _pure2.default)(AvSkipPrevious);
	AvSkipPrevious.displayName = 'AvSkipPrevious';
	AvSkipPrevious.muiName = 'SvgIcon';
	
	exports.default = AvSkipPrevious;

/***/ },
/* 1168 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSlowMotionVideo = function AvSlowMotionVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.05 9.79L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zm0 0L10 7.5v9l3.05-2.29L16 12zM11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zm1.61 6.74C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43zM22 12c0 5.16-3.92 9.42-8.95 9.95v-2.02C16.97 19.41 20 16.05 20 12s-3.03-7.41-6.95-7.93V2.05C18.08 2.58 22 6.84 22 12z' })
	  );
	};
	AvSlowMotionVideo = (0, _pure2.default)(AvSlowMotionVideo);
	AvSlowMotionVideo.displayName = 'AvSlowMotionVideo';
	AvSlowMotionVideo.muiName = 'SvgIcon';
	
	exports.default = AvSlowMotionVideo;

/***/ },
/* 1169 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSnooze = function AvSnooze(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm-3-9h3.63L9 15.2V17h6v-2h-3.63L15 10.8V9H9v2z' })
	  );
	};
	AvSnooze = (0, _pure2.default)(AvSnooze);
	AvSnooze.displayName = 'AvSnooze';
	AvSnooze.muiName = 'SvgIcon';
	
	exports.default = AvSnooze;

/***/ },
/* 1170 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSortByAlpha = function AvSortByAlpha(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.94 4.66h-4.72l2.36-2.36zm-4.69 14.71h4.66l-2.33 2.33zM6.1 6.27L1.6 17.73h1.84l.92-2.45h5.11l.92 2.45h1.84L7.74 6.27H6.1zm-1.13 7.37l1.94-5.18 1.94 5.18H4.97zm10.76 2.5h6.12v1.59h-8.53v-1.29l5.92-8.56h-5.88v-1.6h8.3v1.26l-5.93 8.6z' })
	  );
	};
	AvSortByAlpha = (0, _pure2.default)(AvSortByAlpha);
	AvSortByAlpha.displayName = 'AvSortByAlpha';
	AvSortByAlpha.muiName = 'SvgIcon';
	
	exports.default = AvSortByAlpha;

/***/ },
/* 1171 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvStop = function AvStop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 6h12v12H6z' })
	  );
	};
	AvStop = (0, _pure2.default)(AvStop);
	AvStop.displayName = 'AvStop';
	AvStop.muiName = 'SvgIcon';
	
	exports.default = AvStop;

/***/ },
/* 1172 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSubscriptions = function AvSubscriptions(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8H4V6h16v2zm-2-6H6v2h12V2zm4 10v8c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2v-8c0-1.1.9-2 2-2h16c1.1 0 2 .9 2 2zm-6 4l-6-3.27v6.53L16 16z' })
	  );
	};
	AvSubscriptions = (0, _pure2.default)(AvSubscriptions);
	AvSubscriptions.displayName = 'AvSubscriptions';
	AvSubscriptions.muiName = 'SvgIcon';
	
	exports.default = AvSubscriptions;

/***/ },
/* 1173 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSubtitles = function AvSubtitles(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM4 12h4v2H4v-2zm10 6H4v-2h10v2zm6 0h-4v-2h4v2zm0-4H10v-2h10v2z' })
	  );
	};
	AvSubtitles = (0, _pure2.default)(AvSubtitles);
	AvSubtitles.displayName = 'AvSubtitles';
	AvSubtitles.muiName = 'SvgIcon';
	
	exports.default = AvSubtitles;

/***/ },
/* 1174 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvSurroundSound = function AvSurroundSound(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zM7.76 16.24l-1.41 1.41C4.78 16.1 4 14.05 4 12c0-2.05.78-4.1 2.34-5.66l1.41 1.41C6.59 8.93 6 10.46 6 12s.59 3.07 1.76 4.24zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4zm5.66 1.66l-1.41-1.41C17.41 15.07 18 13.54 18 12s-.59-3.07-1.76-4.24l1.41-1.41C19.22 7.9 20 9.95 20 12c0 2.05-.78 4.1-2.34 5.66zM12 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	AvSurroundSound = (0, _pure2.default)(AvSurroundSound);
	AvSurroundSound.displayName = 'AvSurroundSound';
	AvSurroundSound.muiName = 'SvgIcon';
	
	exports.default = AvSurroundSound;

/***/ },
/* 1175 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideoCall = function AvVideoCall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4zM14 13h-3v3H9v-3H6v-2h3V8h2v3h3v2z' })
	  );
	};
	AvVideoCall = (0, _pure2.default)(AvVideoCall);
	AvVideoCall.displayName = 'AvVideoCall';
	AvVideoCall.muiName = 'SvgIcon';
	
	exports.default = AvVideoCall;

/***/ },
/* 1176 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideoLabel = function AvVideoLabel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 13H3V5h18v11z' })
	  );
	};
	AvVideoLabel = (0, _pure2.default)(AvVideoLabel);
	AvVideoLabel.displayName = 'AvVideoLabel';
	AvVideoLabel.muiName = 'SvgIcon';
	
	exports.default = AvVideoLabel;

/***/ },
/* 1177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideoLibrary = function AvVideoLibrary(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8 12.5v-9l6 4.5-6 4.5z' })
	  );
	};
	AvVideoLibrary = (0, _pure2.default)(AvVideoLibrary);
	AvVideoLibrary.displayName = 'AvVideoLibrary';
	AvVideoLibrary.muiName = 'SvgIcon';
	
	exports.default = AvVideoLibrary;

/***/ },
/* 1178 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideocamOff = function AvVideocamOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6.5l-4 4V7c0-.55-.45-1-1-1H9.82L21 17.18V6.5zM3.27 2L2 3.27 4.73 6H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.21 0 .39-.08.54-.18L19.73 21 21 19.73 3.27 2z' })
	  );
	};
	AvVideocamOff = (0, _pure2.default)(AvVideocamOff);
	AvVideocamOff.displayName = 'AvVideocamOff';
	AvVideocamOff.muiName = 'SvgIcon';
	
	exports.default = AvVideocamOff;

/***/ },
/* 1179 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVideocam = function AvVideocam(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 10.5V7c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h12c.55 0 1-.45 1-1v-3.5l4 4v-11l-4 4z' })
	  );
	};
	AvVideocam = (0, _pure2.default)(AvVideocam);
	AvVideocam.displayName = 'AvVideocam';
	AvVideocam.muiName = 'SvgIcon';
	
	exports.default = AvVideocam;

/***/ },
/* 1180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeDown = function AvVolumeDown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.5 12c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM5 9v6h4l5 5V4L9 9H5z' })
	  );
	};
	AvVolumeDown = (0, _pure2.default)(AvVolumeDown);
	AvVolumeDown.displayName = 'AvVolumeDown';
	AvVolumeDown.muiName = 'SvgIcon';
	
	exports.default = AvVolumeDown;

/***/ },
/* 1181 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeMute = function AvVolumeMute(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 9v6h4l5 5V4l-5 5H7z' })
	  );
	};
	AvVolumeMute = (0, _pure2.default)(AvVolumeMute);
	AvVolumeMute.displayName = 'AvVolumeMute';
	AvVolumeMute.muiName = 'SvgIcon';
	
	exports.default = AvVolumeMute;

/***/ },
/* 1182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeOff = function AvVolumeOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 12c0-1.77-1.02-3.29-2.5-4.03v2.21l2.45 2.45c.03-.2.05-.41.05-.63zm2.5 0c0 .94-.2 1.82-.54 2.64l1.51 1.51C20.63 14.91 21 13.5 21 12c0-4.28-2.99-7.86-7-8.77v2.06c2.89.86 5 3.54 5 6.71zM4.27 3L3 4.27 7.73 9H3v6h4l5 5v-6.73l4.25 4.25c-.67.52-1.42.93-2.25 1.18v2.06c1.38-.31 2.63-.95 3.69-1.81L19.73 21 21 19.73l-9-9L4.27 3zM12 4L9.91 6.09 12 8.18V4z' })
	  );
	};
	AvVolumeOff = (0, _pure2.default)(AvVolumeOff);
	AvVolumeOff.displayName = 'AvVolumeOff';
	AvVolumeOff.muiName = 'SvgIcon';
	
	exports.default = AvVolumeOff;

/***/ },
/* 1183 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvVolumeUp = function AvVolumeUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9v6h4l5 5V4L7 9H3zm13.5 3c0-1.77-1.02-3.29-2.5-4.03v8.05c1.48-.73 2.5-2.25 2.5-4.02zM14 3.23v2.06c2.89.86 5 3.54 5 6.71s-2.11 5.85-5 6.71v2.06c4.01-.91 7-4.49 7-8.77s-2.99-7.86-7-8.77z' })
	  );
	};
	AvVolumeUp = (0, _pure2.default)(AvVolumeUp);
	AvVolumeUp.displayName = 'AvVolumeUp';
	AvVolumeUp.muiName = 'SvgIcon';
	
	exports.default = AvVolumeUp;

/***/ },
/* 1184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvWebAsset = function AvWebAsset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.11 0-2 .9-2 2v12c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.89-2-2-2zm0 14H5V8h14v10z' })
	  );
	};
	AvWebAsset = (0, _pure2.default)(AvWebAsset);
	AvWebAsset.displayName = 'AvWebAsset';
	AvWebAsset.muiName = 'SvgIcon';
	
	exports.default = AvWebAsset;

/***/ },
/* 1185 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var AvWeb = function AvWeb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 14H4v-4h11v4zm0-5H4V9h11v4zm5 5h-4V9h4v9z' })
	  );
	};
	AvWeb = (0, _pure2.default)(AvWeb);
	AvWeb.displayName = 'AvWeb';
	AvWeb.muiName = 'SvgIcon';
	
	exports.default = AvWeb;

/***/ },
/* 1186 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationBusiness = function CommunicationBusiness(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
	  );
	};
	CommunicationBusiness = (0, _pure2.default)(CommunicationBusiness);
	CommunicationBusiness.displayName = 'CommunicationBusiness';
	CommunicationBusiness.muiName = 'SvgIcon';
	
	exports.default = CommunicationBusiness;

/***/ },
/* 1187 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallEnd = function CommunicationCallEnd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 9c-1.6 0-3.15.25-4.6.72v3.1c0 .39-.23.74-.56.9-.98.49-1.87 1.12-2.66 1.85-.18.18-.43.28-.7.28-.28 0-.53-.11-.71-.29L.29 13.08c-.18-.17-.29-.42-.29-.7 0-.28.11-.53.29-.71C3.34 8.78 7.46 7 12 7s8.66 1.78 11.71 4.67c.18.18.29.43.29.71 0 .28-.11.53-.29.71l-2.48 2.48c-.18.18-.43.29-.71.29-.27 0-.52-.11-.7-.28-.79-.74-1.69-1.36-2.67-1.85-.33-.16-.56-.5-.56-.9v-3.1C15.15 9.25 13.6 9 12 9z' })
	  );
	};
	CommunicationCallEnd = (0, _pure2.default)(CommunicationCallEnd);
	CommunicationCallEnd.displayName = 'CommunicationCallEnd';
	CommunicationCallEnd.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallEnd;

/***/ },
/* 1188 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMade = function CommunicationCallMade(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 5v2h6.59L4 18.59 5.41 20 17 8.41V15h2V5z' })
	  );
	};
	CommunicationCallMade = (0, _pure2.default)(CommunicationCallMade);
	CommunicationCallMade.displayName = 'CommunicationCallMade';
	CommunicationCallMade.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMade;

/***/ },
/* 1189 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMerge = function CommunicationCallMerge(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
	  );
	};
	CommunicationCallMerge = (0, _pure2.default)(CommunicationCallMerge);
	CommunicationCallMerge.displayName = 'CommunicationCallMerge';
	CommunicationCallMerge.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMerge;

/***/ },
/* 1190 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMissedOutgoing = function CommunicationCallMissedOutgoing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 8.41l9 9 7-7V15h2V7h-8v2h4.59L12 14.59 4.41 7 3 8.41z' })
	  );
	};
	CommunicationCallMissedOutgoing = (0, _pure2.default)(CommunicationCallMissedOutgoing);
	CommunicationCallMissedOutgoing.displayName = 'CommunicationCallMissedOutgoing';
	CommunicationCallMissedOutgoing.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMissedOutgoing;

/***/ },
/* 1191 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallMissed = function CommunicationCallMissed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.59 7L12 14.59 6.41 9H11V7H3v8h2v-4.59l7 7 9-9z' })
	  );
	};
	CommunicationCallMissed = (0, _pure2.default)(CommunicationCallMissed);
	CommunicationCallMissed.displayName = 'CommunicationCallMissed';
	CommunicationCallMissed.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallMissed;

/***/ },
/* 1192 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallReceived = function CommunicationCallReceived(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5.41L18.59 4 7 15.59V9H5v10h10v-2H8.41z' })
	  );
	};
	CommunicationCallReceived = (0, _pure2.default)(CommunicationCallReceived);
	CommunicationCallReceived.displayName = 'CommunicationCallReceived';
	CommunicationCallReceived.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallReceived;

/***/ },
/* 1193 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCallSplit = function CommunicationCallSplit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 4l2.29 2.29-2.88 2.88 1.42 1.42 2.88-2.88L20 10V4zm-4 0H4v6l2.29-2.29 4.71 4.7V20h2v-8.41l-5.29-5.3z' })
	  );
	};
	CommunicationCallSplit = (0, _pure2.default)(CommunicationCallSplit);
	CommunicationCallSplit.displayName = 'CommunicationCallSplit';
	CommunicationCallSplit.muiName = 'SvgIcon';
	
	exports.default = CommunicationCallSplit;

/***/ },
/* 1194 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationCall = function CommunicationCall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
	  );
	};
	CommunicationCall = (0, _pure2.default)(CommunicationCall);
	CommunicationCall.displayName = 'CommunicationCall';
	CommunicationCall.muiName = 'SvgIcon';
	
	exports.default = CommunicationCall;

/***/ },
/* 1195 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationChatBubbleOutline = function CommunicationChatBubbleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H6l-2 2V4h16v12z' })
	  );
	};
	CommunicationChatBubbleOutline = (0, _pure2.default)(CommunicationChatBubbleOutline);
	CommunicationChatBubbleOutline.displayName = 'CommunicationChatBubbleOutline';
	CommunicationChatBubbleOutline.muiName = 'SvgIcon';
	
	exports.default = CommunicationChatBubbleOutline;

/***/ },
/* 1196 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationChatBubble = function CommunicationChatBubble(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v18l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2z' })
	  );
	};
	CommunicationChatBubble = (0, _pure2.default)(CommunicationChatBubble);
	CommunicationChatBubble.displayName = 'CommunicationChatBubble';
	CommunicationChatBubble.muiName = 'SvgIcon';
	
	exports.default = CommunicationChatBubble;

/***/ },
/* 1197 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationChat = function CommunicationChat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 9h12v2H6V9zm8 5H6v-2h8v2zm4-6H6V6h12v2z' })
	  );
	};
	CommunicationChat = (0, _pure2.default)(CommunicationChat);
	CommunicationChat.displayName = 'CommunicationChat';
	CommunicationChat.muiName = 'SvgIcon';
	
	exports.default = CommunicationChat;

/***/ },
/* 1198 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationClearAll = function CommunicationClearAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 13h14v-2H5v2zm-2 4h14v-2H3v2zM7 7v2h14V7H7z' })
	  );
	};
	CommunicationClearAll = (0, _pure2.default)(CommunicationClearAll);
	CommunicationClearAll.displayName = 'CommunicationClearAll';
	CommunicationClearAll.muiName = 'SvgIcon';
	
	exports.default = CommunicationClearAll;

/***/ },
/* 1199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationComment = function CommunicationComment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18zM18 14H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
	  );
	};
	CommunicationComment = (0, _pure2.default)(CommunicationComment);
	CommunicationComment.displayName = 'CommunicationComment';
	CommunicationComment.muiName = 'SvgIcon';
	
	exports.default = CommunicationComment;

/***/ },
/* 1200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationContactMail = function CommunicationContactMail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 8V7l-3 2-3-2v1l3 2 3-2zm1-5H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm8-6h-8V6h8v6z' })
	  );
	};
	CommunicationContactMail = (0, _pure2.default)(CommunicationContactMail);
	CommunicationContactMail.displayName = 'CommunicationContactMail';
	CommunicationContactMail.muiName = 'SvgIcon';
	
	exports.default = CommunicationContactMail;

/***/ },
/* 1201 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationContactPhone = function CommunicationContactPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 3H2C.9 3 0 3.9 0 5v14c0 1.1.9 2 2 2h20c1.1 0 1.99-.9 1.99-2L24 5c0-1.1-.9-2-2-2zM8 6c1.66 0 3 1.34 3 3s-1.34 3-3 3-3-1.34-3-3 1.34-3 3-3zm6 12H2v-1c0-2 4-3.1 6-3.1s6 1.1 6 3.1v1zm3.85-4h1.64L21 16l-1.99 1.99c-1.31-.98-2.28-2.38-2.73-3.99-.18-.64-.28-1.31-.28-2s.1-1.36.28-2c.45-1.62 1.42-3.01 2.73-3.99L21 8l-1.51 2h-1.64c-.22.63-.35 1.3-.35 2s.13 1.37.35 2z' })
	  );
	};
	CommunicationContactPhone = (0, _pure2.default)(CommunicationContactPhone);
	CommunicationContactPhone.displayName = 'CommunicationContactPhone';
	CommunicationContactPhone.muiName = 'SvgIcon';
	
	exports.default = CommunicationContactPhone;

/***/ },
/* 1202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationContacts = function CommunicationContacts(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 0H4v2h16V0zM4 24h16v-2H4v2zM20 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 2.75c1.24 0 2.25 1.01 2.25 2.25s-1.01 2.25-2.25 2.25S9.75 10.24 9.75 9 10.76 6.75 12 6.75zM17 17H7v-1.5c0-1.67 3.33-2.5 5-2.5s5 .83 5 2.5V17z' })
	  );
	};
	CommunicationContacts = (0, _pure2.default)(CommunicationContacts);
	CommunicationContacts.displayName = 'CommunicationContacts';
	CommunicationContacts.muiName = 'SvgIcon';
	
	exports.default = CommunicationContacts;

/***/ },
/* 1203 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationDialerSip = function CommunicationDialerSip(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3h-1v5h1V3zm-2 2h-2V4h2V3h-3v3h2v1h-2v1h3V5zm3-2v5h1V6h2V3h-3zm2 2h-1V4h1v1zm0 10.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.01.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.27-.26.35-.65.24-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
	  );
	};
	CommunicationDialerSip = (0, _pure2.default)(CommunicationDialerSip);
	CommunicationDialerSip.displayName = 'CommunicationDialerSip';
	CommunicationDialerSip.muiName = 'SvgIcon';
	
	exports.default = CommunicationDialerSip;

/***/ },
/* 1204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationDialpad = function CommunicationDialpad(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 19c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 1c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0-6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	CommunicationDialpad = (0, _pure2.default)(CommunicationDialpad);
	CommunicationDialpad.displayName = 'CommunicationDialpad';
	CommunicationDialpad.muiName = 'SvgIcon';
	
	exports.default = CommunicationDialpad;

/***/ },
/* 1205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationEmail = function CommunicationEmail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	CommunicationEmail = (0, _pure2.default)(CommunicationEmail);
	CommunicationEmail.displayName = 'CommunicationEmail';
	CommunicationEmail.muiName = 'SvgIcon';
	
	exports.default = CommunicationEmail;

/***/ },
/* 1206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationForum = function CommunicationForum(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6h-2v9H6v2c0 .55.45 1 1 1h11l4 4V7c0-.55-.45-1-1-1zm-4 6V3c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v14l4-4h10c.55 0 1-.45 1-1z' })
	  );
	};
	CommunicationForum = (0, _pure2.default)(CommunicationForum);
	CommunicationForum.displayName = 'CommunicationForum';
	CommunicationForum.muiName = 'SvgIcon';
	
	exports.default = CommunicationForum;

/***/ },
/* 1207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationImportContacts = function CommunicationImportContacts(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5c-1.11-.35-2.33-.5-3.5-.5-1.95 0-4.05.4-5.5 1.5-1.45-1.1-3.55-1.5-5.5-1.5S2.45 4.9 1 6v14.65c0 .25.25.5.5.5.1 0 .15-.05.25-.05C3.1 20.45 5.05 20 6.5 20c1.95 0 4.05.4 5.5 1.5 1.35-.85 3.8-1.5 5.5-1.5 1.65 0 3.35.3 4.75 1.05.1.05.15.05.25.05.25 0 .5-.25.5-.5V6c-.6-.45-1.25-.75-2-1zm0 13.5c-1.1-.35-2.3-.5-3.5-.5-1.7 0-4.15.65-5.5 1.5V8c1.35-.85 3.8-1.5 5.5-1.5 1.2 0 2.4.15 3.5.5v11.5z' })
	  );
	};
	CommunicationImportContacts = (0, _pure2.default)(CommunicationImportContacts);
	CommunicationImportContacts.displayName = 'CommunicationImportContacts';
	CommunicationImportContacts.muiName = 'SvgIcon';
	
	exports.default = CommunicationImportContacts;

/***/ },
/* 1208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationImportExport = function CommunicationImportExport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 3L5 6.99h3V14h2V6.99h3L9 3zm7 14.01V10h-2v7.01h-3L15 21l4-3.99h-3z' })
	  );
	};
	CommunicationImportExport = (0, _pure2.default)(CommunicationImportExport);
	CommunicationImportExport.displayName = 'CommunicationImportExport';
	CommunicationImportExport.muiName = 'SvgIcon';
	
	exports.default = CommunicationImportExport;

/***/ },
/* 1209 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationInvertColorsOff = function CommunicationInvertColorsOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.65 20.87l-2.35-2.35-6.3-6.29-3.56-3.57-1.42-1.41L4.27 4.5 3 5.77l2.78 2.78c-2.55 3.14-2.36 7.76.56 10.69C7.9 20.8 9.95 21.58 12 21.58c1.79 0 3.57-.59 5.03-1.78l2.7 2.7L21 21.23l-.35-.36zM12 19.59c-1.6 0-3.11-.62-4.24-1.76C6.62 16.69 6 15.19 6 13.59c0-1.32.43-2.57 1.21-3.6L12 14.77v4.82zM12 5.1v4.58l7.25 7.26c1.37-2.96.84-6.57-1.6-9.01L12 2.27l-3.7 3.7 1.41 1.41L12 5.1z' })
	  );
	};
	CommunicationInvertColorsOff = (0, _pure2.default)(CommunicationInvertColorsOff);
	CommunicationInvertColorsOff.displayName = 'CommunicationInvertColorsOff';
	CommunicationInvertColorsOff.muiName = 'SvgIcon';
	
	exports.default = CommunicationInvertColorsOff;

/***/ },
/* 1210 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationLiveHelp = function CommunicationLiveHelp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 16h-2v-2h2v2zm2.07-7.75l-.9.92C13.45 11.9 13 12.5 13 14h-2v-.5c0-1.1.45-2.1 1.17-2.83l1.24-1.26c.37-.36.59-.86.59-1.41 0-1.1-.9-2-2-2s-2 .9-2 2H8c0-2.21 1.79-4 4-4s4 1.79 4 4c0 .88-.36 1.68-.93 2.25z' })
	  );
	};
	CommunicationLiveHelp = (0, _pure2.default)(CommunicationLiveHelp);
	CommunicationLiveHelp.displayName = 'CommunicationLiveHelp';
	CommunicationLiveHelp.muiName = 'SvgIcon';
	
	exports.default = CommunicationLiveHelp;

/***/ },
/* 1211 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationLocationOff = function CommunicationLocationOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6.5c1.38 0 2.5 1.12 2.5 2.5 0 .74-.33 1.39-.83 1.85l3.63 3.63c.98-1.86 1.7-3.8 1.7-5.48 0-3.87-3.13-7-7-7-1.98 0-3.76.83-5.04 2.15l3.19 3.19c.46-.52 1.11-.84 1.85-.84zm4.37 9.6l-4.63-4.63-.11-.11L3.27 3 2 4.27l3.18 3.18C5.07 7.95 5 8.47 5 9c0 5.25 7 13 7 13s1.67-1.85 3.38-4.35L18.73 21 20 19.73l-3.63-3.63z' })
	  );
	};
	CommunicationLocationOff = (0, _pure2.default)(CommunicationLocationOff);
	CommunicationLocationOff.displayName = 'CommunicationLocationOff';
	CommunicationLocationOff.muiName = 'SvgIcon';
	
	exports.default = CommunicationLocationOff;

/***/ },
/* 1212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationLocationOn = function CommunicationLocationOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	CommunicationLocationOn = (0, _pure2.default)(CommunicationLocationOn);
	CommunicationLocationOn.displayName = 'CommunicationLocationOn';
	CommunicationLocationOn.muiName = 'SvgIcon';
	
	exports.default = CommunicationLocationOn;

/***/ },
/* 1213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationMailOutline = function CommunicationMailOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V8l8 5 8-5v10zm-8-7L4 6h16l-8 5z' })
	  );
	};
	CommunicationMailOutline = (0, _pure2.default)(CommunicationMailOutline);
	CommunicationMailOutline.displayName = 'CommunicationMailOutline';
	CommunicationMailOutline.muiName = 'SvgIcon';
	
	exports.default = CommunicationMailOutline;

/***/ },
/* 1214 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationMessage = function CommunicationMessage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
	  );
	};
	CommunicationMessage = (0, _pure2.default)(CommunicationMessage);
	CommunicationMessage.displayName = 'CommunicationMessage';
	CommunicationMessage.muiName = 'SvgIcon';
	
	exports.default = CommunicationMessage;

/***/ },
/* 1215 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationNoSim = function CommunicationNoSim(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' })
	  );
	};
	CommunicationNoSim = (0, _pure2.default)(CommunicationNoSim);
	CommunicationNoSim.displayName = 'CommunicationNoSim';
	CommunicationNoSim.muiName = 'SvgIcon';
	
	exports.default = CommunicationNoSim;

/***/ },
/* 1216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhone = function CommunicationPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
	  );
	};
	CommunicationPhone = (0, _pure2.default)(CommunicationPhone);
	CommunicationPhone.displayName = 'CommunicationPhone';
	CommunicationPhone.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhone;

/***/ },
/* 1217 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkErase = function CommunicationPhonelinkErase(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 8.2l-1-1-4 4-4-4-1 1 4 4-4 4 1 1 4-4 4 4 1-1-4-4 4-4zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
	  );
	};
	CommunicationPhonelinkErase = (0, _pure2.default)(CommunicationPhonelinkErase);
	CommunicationPhonelinkErase.displayName = 'CommunicationPhonelinkErase';
	CommunicationPhonelinkErase.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkErase;

/***/ },
/* 1218 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkLock = function CommunicationPhonelinkLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm-8.2 10V9.5C10.8 8.1 9.4 7 8 7S5.2 8.1 5.2 9.5V11c-.6 0-1.2.6-1.2 1.2v3.5c0 .7.6 1.3 1.2 1.3h5.5c.7 0 1.3-.6 1.3-1.2v-3.5c0-.7-.6-1.3-1.2-1.3zm-1.3 0h-3V9.5c0-.8.7-1.3 1.5-1.3s1.5.5 1.5 1.3V11z' })
	  );
	};
	CommunicationPhonelinkLock = (0, _pure2.default)(CommunicationPhonelinkLock);
	CommunicationPhonelinkLock.displayName = 'CommunicationPhonelinkLock';
	CommunicationPhonelinkLock.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkLock;

/***/ },
/* 1219 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkRing = function CommunicationPhonelinkRing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.1 7.7l-1 1c1.8 1.8 1.8 4.6 0 6.5l1 1c2.5-2.3 2.5-6.1 0-8.5zM18 9.8l-1 1c.5.7.5 1.6 0 2.3l1 1c1.2-1.2 1.2-3 0-4.3zM14 1H4c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 19H4V4h10v16z' })
	  );
	};
	CommunicationPhonelinkRing = (0, _pure2.default)(CommunicationPhonelinkRing);
	CommunicationPhonelinkRing.displayName = 'CommunicationPhonelinkRing';
	CommunicationPhonelinkRing.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkRing;

/***/ },
/* 1220 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPhonelinkSetup = function CommunicationPhonelinkSetup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.8 12.5v-1l1.1-.8c.1-.1.1-.2.1-.3l-1-1.7c-.1-.1-.2-.2-.3-.1l-1.3.4c-.3-.2-.6-.4-.9-.5l-.2-1.3c0-.1-.1-.2-.3-.2H7c-.1 0-.2.1-.3.2l-.2 1.3c-.3.1-.6.3-.9.5l-1.3-.5c-.1 0-.2 0-.3.1l-1 1.7c-.1.1 0 .2.1.3l1.1.8v1l-1.1.8c-.1.2-.1.3-.1.4l1 1.7c.1.1.2.2.3.1l1.4-.4c.3.2.6.4.9.5l.2 1.3c-.1.1.1.2.2.2h2c.1 0 .2-.1.3-.2l.2-1.3c.3-.1.6-.3.9-.5l1.3.5c.1 0 .2 0 .3-.1l1-1.7c.1-.1 0-.2-.1-.3l-1.1-.9zM8 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zM19 1H9c-1.1 0-2 .9-2 2v3h2V4h10v16H9v-2H7v3c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2z' })
	  );
	};
	CommunicationPhonelinkSetup = (0, _pure2.default)(CommunicationPhonelinkSetup);
	CommunicationPhonelinkSetup.displayName = 'CommunicationPhonelinkSetup';
	CommunicationPhonelinkSetup.muiName = 'SvgIcon';
	
	exports.default = CommunicationPhonelinkSetup;

/***/ },
/* 1221 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPortableWifiOff = function CommunicationPortableWifiOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.56 14.24c.28-.69.44-1.45.44-2.24 0-3.31-2.69-6-6-6-.79 0-1.55.16-2.24.44l1.62 1.62c.2-.03.41-.06.62-.06 2.21 0 4 1.79 4 4 0 .21-.02.42-.05.63l1.61 1.61zM12 4c4.42 0 8 3.58 8 8 0 1.35-.35 2.62-.95 3.74l1.47 1.47C21.46 15.69 22 13.91 22 12c0-5.52-4.48-10-10-10-1.91 0-3.69.55-5.21 1.47l1.46 1.46C9.37 4.34 10.65 4 12 4zM3.27 2.5L2 3.77l2.1 2.1C2.79 7.57 2 9.69 2 12c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 17.53 4 14.96 4 12c0-1.76.57-3.38 1.53-4.69l1.43 1.44C6.36 9.68 6 10.8 6 12c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-.65.17-1.25.44-1.79l1.58 1.58L10 12c0 1.1.9 2 2 2l.21-.02.01.01 7.51 7.51L21 20.23 4.27 3.5l-1-1z' })
	  );
	};
	CommunicationPortableWifiOff = (0, _pure2.default)(CommunicationPortableWifiOff);
	CommunicationPortableWifiOff.displayName = 'CommunicationPortableWifiOff';
	CommunicationPortableWifiOff.muiName = 'SvgIcon';
	
	exports.default = CommunicationPortableWifiOff;

/***/ },
/* 1222 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationPresentToAll = function CommunicationPresentToAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v14c0 1.11.89 2 2 2h18c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 16.02H3V4.98h18v14.04zM10 12H8l4-4 4 4h-2v4h-4v-4z' })
	  );
	};
	CommunicationPresentToAll = (0, _pure2.default)(CommunicationPresentToAll);
	CommunicationPresentToAll.displayName = 'CommunicationPresentToAll';
	CommunicationPresentToAll.muiName = 'SvgIcon';
	
	exports.default = CommunicationPresentToAll;

/***/ },
/* 1223 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationRingVolume = function CommunicationRingVolume(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23.71 16.67C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71 0 .28.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73s3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.66 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71 0-.27-.11-.52-.29-.7zM21.16 6.26l-1.41-1.41-3.56 3.55 1.41 1.41s3.45-3.52 3.56-3.55zM13 2h-2v5h2V2zM6.4 9.81L7.81 8.4 4.26 4.84 2.84 6.26c.11.03 3.56 3.55 3.56 3.55z' })
	  );
	};
	CommunicationRingVolume = (0, _pure2.default)(CommunicationRingVolume);
	CommunicationRingVolume.displayName = 'CommunicationRingVolume';
	CommunicationRingVolume.muiName = 'SvgIcon';
	
	exports.default = CommunicationRingVolume;

/***/ },
/* 1224 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationRssFeed = function CommunicationRssFeed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '6.18', cy: '17.82', r: '2.18' }),
	    _react2.default.createElement('path', { d: 'M4 4.44v2.83c7.03 0 12.73 5.7 12.73 12.73h2.83c0-8.59-6.97-15.56-15.56-15.56zm0 5.66v2.83c3.9 0 7.07 3.17 7.07 7.07h2.83c0-5.47-4.43-9.9-9.9-9.9z' })
	  );
	};
	CommunicationRssFeed = (0, _pure2.default)(CommunicationRssFeed);
	CommunicationRssFeed.displayName = 'CommunicationRssFeed';
	CommunicationRssFeed.muiName = 'SvgIcon';
	
	exports.default = CommunicationRssFeed;

/***/ },
/* 1225 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationScreenShare = function CommunicationScreenShare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.11-.9-2-2-2H4c-1.11 0-2 .89-2 2v10c0 1.1.89 2 2 2H0v2h24v-2h-4zm-7-3.53v-2.19c-2.78 0-4.61.85-6 2.72.56-2.67 2.11-5.33 6-5.87V7l4 3.73-4 3.74z' })
	  );
	};
	CommunicationScreenShare = (0, _pure2.default)(CommunicationScreenShare);
	CommunicationScreenShare.displayName = 'CommunicationScreenShare';
	CommunicationScreenShare.muiName = 'SvgIcon';
	
	exports.default = CommunicationScreenShare;

/***/ },
/* 1226 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationSpeakerPhone = function CommunicationSpeakerPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 7.07L8.43 8.5c.91-.91 2.18-1.48 3.57-1.48s2.66.57 3.57 1.48L17 7.07C15.72 5.79 13.95 5 12 5s-3.72.79-5 2.07zM12 1C8.98 1 6.24 2.23 4.25 4.21l1.41 1.41C7.28 4 9.53 3 12 3s4.72 1 6.34 2.62l1.41-1.41C17.76 2.23 15.02 1 12 1zm2.86 9.01L9.14 10C8.51 10 8 10.51 8 11.14v9.71c0 .63.51 1.14 1.14 1.14h5.71c.63 0 1.14-.51 1.14-1.14v-9.71c.01-.63-.5-1.13-1.13-1.13zM15 20H9v-8h6v8z' })
	  );
	};
	CommunicationSpeakerPhone = (0, _pure2.default)(CommunicationSpeakerPhone);
	CommunicationSpeakerPhone.displayName = 'CommunicationSpeakerPhone';
	CommunicationSpeakerPhone.muiName = 'SvgIcon';
	
	exports.default = CommunicationSpeakerPhone;

/***/ },
/* 1227 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayCurrentLandscape = function CommunicationStayCurrentLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z' })
	  );
	};
	CommunicationStayCurrentLandscape = (0, _pure2.default)(CommunicationStayCurrentLandscape);
	CommunicationStayCurrentLandscape.displayName = 'CommunicationStayCurrentLandscape';
	CommunicationStayCurrentLandscape.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayCurrentLandscape;

/***/ },
/* 1228 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayCurrentPortrait = function CommunicationStayCurrentPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	CommunicationStayCurrentPortrait = (0, _pure2.default)(CommunicationStayCurrentPortrait);
	CommunicationStayCurrentPortrait.displayName = 'CommunicationStayCurrentPortrait';
	CommunicationStayCurrentPortrait.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayCurrentPortrait;

/***/ },
/* 1229 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayPrimaryLandscape = function CommunicationStayPrimaryLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1.01 7L1 17c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2H3c-1.1 0-1.99.9-1.99 2zM19 7v10H5V7h14z' })
	  );
	};
	CommunicationStayPrimaryLandscape = (0, _pure2.default)(CommunicationStayPrimaryLandscape);
	CommunicationStayPrimaryLandscape.displayName = 'CommunicationStayPrimaryLandscape';
	CommunicationStayPrimaryLandscape.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayPrimaryLandscape;

/***/ },
/* 1230 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStayPrimaryPortrait = function CommunicationStayPrimaryPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-1.99.9-1.99 2v18c0 1.1.89 2 1.99 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	CommunicationStayPrimaryPortrait = (0, _pure2.default)(CommunicationStayPrimaryPortrait);
	CommunicationStayPrimaryPortrait.displayName = 'CommunicationStayPrimaryPortrait';
	CommunicationStayPrimaryPortrait.muiName = 'SvgIcon';
	
	exports.default = CommunicationStayPrimaryPortrait;

/***/ },
/* 1231 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationStopScreenShare = function CommunicationStopScreenShare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.22 18.02l2 2H24v-2h-2.78zm.77-2l.01-10c0-1.11-.9-2-2-2H7.22l5.23 5.23c.18-.04.36-.07.55-.1V7.02l4 3.73-1.58 1.47 5.54 5.54c.61-.33 1.03-.99 1.03-1.74zM2.39 1.73L1.11 3l1.54 1.54c-.4.36-.65.89-.65 1.48v10c0 1.1.89 2 2 2H0v2h18.13l2.71 2.71 1.27-1.27L2.39 1.73zM7 15.02c.31-1.48.92-2.95 2.07-4.06l1.59 1.59c-1.54.38-2.7 1.18-3.66 2.47z' })
	  );
	};
	CommunicationStopScreenShare = (0, _pure2.default)(CommunicationStopScreenShare);
	CommunicationStopScreenShare.displayName = 'CommunicationStopScreenShare';
	CommunicationStopScreenShare.muiName = 'SvgIcon';
	
	exports.default = CommunicationStopScreenShare;

/***/ },
/* 1232 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationSwapCalls = function CommunicationSwapCalls(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l-4 4h3v7c0 1.1-.9 2-2 2s-2-.9-2-2V8c0-2.21-1.79-4-4-4S5 5.79 5 8v7H2l4 4 4-4H7V8c0-1.1.9-2 2-2s2 .9 2 2v7c0 2.21 1.79 4 4 4s4-1.79 4-4V8h3l-4-4z' })
	  );
	};
	CommunicationSwapCalls = (0, _pure2.default)(CommunicationSwapCalls);
	CommunicationSwapCalls.displayName = 'CommunicationSwapCalls';
	CommunicationSwapCalls.muiName = 'SvgIcon';
	
	exports.default = CommunicationSwapCalls;

/***/ },
/* 1233 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationTextsms = function CommunicationTextsms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
	  );
	};
	CommunicationTextsms = (0, _pure2.default)(CommunicationTextsms);
	CommunicationTextsms.displayName = 'CommunicationTextsms';
	CommunicationTextsms.muiName = 'SvgIcon';
	
	exports.default = CommunicationTextsms;

/***/ },
/* 1234 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationVoicemail = function CommunicationVoicemail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.5 6C15.46 6 13 8.46 13 11.5c0 1.33.47 2.55 1.26 3.5H9.74c.79-.95 1.26-2.17 1.26-3.5C11 8.46 8.54 6 5.5 6S0 8.46 0 11.5 2.46 17 5.5 17h13c3.04 0 5.5-2.46 5.5-5.5S21.54 6 18.5 6zm-13 9C3.57 15 2 13.43 2 11.5S3.57 8 5.5 8 9 9.57 9 11.5 7.43 15 5.5 15zm13 0c-1.93 0-3.5-1.57-3.5-3.5S16.57 8 18.5 8 22 9.57 22 11.5 20.43 15 18.5 15z' })
	  );
	};
	CommunicationVoicemail = (0, _pure2.default)(CommunicationVoicemail);
	CommunicationVoicemail.displayName = 'CommunicationVoicemail';
	CommunicationVoicemail.muiName = 'SvgIcon';
	
	exports.default = CommunicationVoicemail;

/***/ },
/* 1235 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CommunicationVpnKey = function CommunicationVpnKey(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.65 10C11.83 7.67 9.61 6 7 6c-3.31 0-6 2.69-6 6s2.69 6 6 6c2.61 0 4.83-1.67 5.65-4H17v4h4v-4h2v-4H12.65zM7 14c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	CommunicationVpnKey = (0, _pure2.default)(CommunicationVpnKey);
	CommunicationVpnKey.displayName = 'CommunicationVpnKey';
	CommunicationVpnKey.muiName = 'SvgIcon';
	
	exports.default = CommunicationVpnKey;

/***/ },
/* 1236 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAddBox = function ContentAddBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
	  );
	};
	ContentAddBox = (0, _pure2.default)(ContentAddBox);
	ContentAddBox.displayName = 'ContentAddBox';
	ContentAddBox.muiName = 'SvgIcon';
	
	exports.default = ContentAddBox;

/***/ },
/* 1237 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAddCircleOutline = function ContentAddCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ContentAddCircleOutline = (0, _pure2.default)(ContentAddCircleOutline);
	ContentAddCircleOutline.displayName = 'ContentAddCircleOutline';
	ContentAddCircleOutline.muiName = 'SvgIcon';
	
	exports.default = ContentAddCircleOutline;

/***/ },
/* 1238 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAddCircle = function ContentAddCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11h-4v4h-2v-4H7v-2h4V7h2v4h4v2z' })
	  );
	};
	ContentAddCircle = (0, _pure2.default)(ContentAddCircle);
	ContentAddCircle.displayName = 'ContentAddCircle';
	ContentAddCircle.muiName = 'SvgIcon';
	
	exports.default = ContentAddCircle;

/***/ },
/* 1239 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentAdd = function ContentAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 13h-6v6h-2v-6H5v-2h6V5h2v6h6v2z' })
	  );
	};
	ContentAdd = (0, _pure2.default)(ContentAdd);
	ContentAdd.displayName = 'ContentAdd';
	ContentAdd.muiName = 'SvgIcon';
	
	exports.default = ContentAdd;

/***/ },
/* 1240 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentArchive = function ContentArchive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.54 5.23l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.16.55L3.46 5.23C3.17 5.57 3 6.02 3 6.5V19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.48-.17-.93-.46-1.27zM12 17.5L6.5 12H10v-2h4v2h3.5L12 17.5zM5.12 5l.81-1h12l.94 1H5.12z' })
	  );
	};
	ContentArchive = (0, _pure2.default)(ContentArchive);
	ContentArchive.displayName = 'ContentArchive';
	ContentArchive.muiName = 'SvgIcon';
	
	exports.default = ContentArchive;

/***/ },
/* 1241 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentBackspace = function ContentBackspace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.9.89 1.59.89h15c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-3 12.59L17.59 17 14 13.41 10.41 17 9 15.59 12.59 12 9 8.41 10.41 7 14 10.59 17.59 7 19 8.41 15.41 12 19 15.59z' })
	  );
	};
	ContentBackspace = (0, _pure2.default)(ContentBackspace);
	ContentBackspace.displayName = 'ContentBackspace';
	ContentBackspace.muiName = 'SvgIcon';
	
	exports.default = ContentBackspace;

/***/ },
/* 1242 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentBlock = function ContentBlock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zM4 12c0-4.42 3.58-8 8-8 1.85 0 3.55.63 4.9 1.69L5.69 16.9C4.63 15.55 4 13.85 4 12zm8 8c-1.85 0-3.55-.63-4.9-1.69L18.31 7.1C19.37 8.45 20 10.15 20 12c0 4.42-3.58 8-8 8z' })
	  );
	};
	ContentBlock = (0, _pure2.default)(ContentBlock);
	ContentBlock.displayName = 'ContentBlock';
	ContentBlock.muiName = 'SvgIcon';
	
	exports.default = ContentBlock;

/***/ },
/* 1243 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentClear = function ContentClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
	  );
	};
	ContentClear = (0, _pure2.default)(ContentClear);
	ContentClear.displayName = 'ContentClear';
	ContentClear.muiName = 'SvgIcon';
	
	exports.default = ContentClear;

/***/ },
/* 1244 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentContentCopy = function ContentContentCopy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z' })
	  );
	};
	ContentContentCopy = (0, _pure2.default)(ContentContentCopy);
	ContentContentCopy.displayName = 'ContentContentCopy';
	ContentContentCopy.muiName = 'SvgIcon';
	
	exports.default = ContentContentCopy;

/***/ },
/* 1245 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentContentCut = function ContentContentCut(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.64 7.64c.23-.5.36-1.05.36-1.64 0-2.21-1.79-4-4-4S2 3.79 2 6s1.79 4 4 4c.59 0 1.14-.13 1.64-.36L10 12l-2.36 2.36C7.14 14.13 6.59 14 6 14c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4c0-.59-.13-1.14-.36-1.64L12 14l7 7h3v-1L9.64 7.64zM6 8c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm0 12c-1.1 0-2-.89-2-2s.9-2 2-2 2 .89 2 2-.9 2-2 2zm6-7.5c-.28 0-.5-.22-.5-.5s.22-.5.5-.5.5.22.5.5-.22.5-.5.5zM19 3l-6 6 2 2 7-7V3z' })
	  );
	};
	ContentContentCut = (0, _pure2.default)(ContentContentCut);
	ContentContentCut.displayName = 'ContentContentCut';
	ContentContentCut.muiName = 'SvgIcon';
	
	exports.default = ContentContentCut;

/***/ },
/* 1246 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentContentPaste = function ContentContentPaste(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2h-4.18C14.4.84 13.3 0 12 0c-1.3 0-2.4.84-2.82 2H5c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 0c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm7 18H5V4h2v3h10V4h2v16z' })
	  );
	};
	ContentContentPaste = (0, _pure2.default)(ContentContentPaste);
	ContentContentPaste.displayName = 'ContentContentPaste';
	ContentContentPaste.muiName = 'SvgIcon';
	
	exports.default = ContentContentPaste;

/***/ },
/* 1247 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentCreate = function ContentCreate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
	  );
	};
	ContentCreate = (0, _pure2.default)(ContentCreate);
	ContentCreate.displayName = 'ContentCreate';
	ContentCreate.muiName = 'SvgIcon';
	
	exports.default = ContentCreate;

/***/ },
/* 1248 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentDeleteSweep = function ContentDeleteSweep(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 16h4v2h-4zm0-8h7v2h-7zm0 4h6v2h-6zM3 18c0 1.1.9 2 2 2h6c1.1 0 2-.9 2-2V8H3v10zM14 5h-3l-1-1H6L5 5H2v2h12z' })
	  );
	};
	ContentDeleteSweep = (0, _pure2.default)(ContentDeleteSweep);
	ContentDeleteSweep.displayName = 'ContentDeleteSweep';
	ContentDeleteSweep.muiName = 'SvgIcon';
	
	exports.default = ContentDeleteSweep;

/***/ },
/* 1249 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentDrafts = function ContentDrafts(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.99 8c0-.72-.37-1.35-.94-1.7L12 1 2.95 6.3C2.38 6.65 2 7.28 2 8v10c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2l-.01-10zM12 13L3.74 7.84 12 3l8.26 4.84L12 13z' })
	  );
	};
	ContentDrafts = (0, _pure2.default)(ContentDrafts);
	ContentDrafts.displayName = 'ContentDrafts';
	ContentDrafts.muiName = 'SvgIcon';
	
	exports.default = ContentDrafts;

/***/ },
/* 1250 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentFilterList = function ContentFilterList(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 18h4v-2h-4v2zM3 6v2h18V6H3zm3 7h12v-2H6v2z' })
	  );
	};
	ContentFilterList = (0, _pure2.default)(ContentFilterList);
	ContentFilterList.displayName = 'ContentFilterList';
	ContentFilterList.muiName = 'SvgIcon';
	
	exports.default = ContentFilterList;

/***/ },
/* 1251 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentFlag = function ContentFlag(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
	  );
	};
	ContentFlag = (0, _pure2.default)(ContentFlag);
	ContentFlag.displayName = 'ContentFlag';
	ContentFlag.muiName = 'SvgIcon';
	
	exports.default = ContentFlag;

/***/ },
/* 1252 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentFontDownload = function ContentFontDownload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.93 13.5h4.14L12 7.98zM20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-4.05 16.5l-1.14-3H9.17l-1.12 3H5.96l5.11-13h1.86l5.11 13h-2.09z' })
	  );
	};
	ContentFontDownload = (0, _pure2.default)(ContentFontDownload);
	ContentFontDownload.displayName = 'ContentFontDownload';
	ContentFontDownload.muiName = 'SvgIcon';
	
	exports.default = ContentFontDownload;

/***/ },
/* 1253 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentForward = function ContentForward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8V4l8 8-8 8v-4H4V8z' })
	  );
	};
	ContentForward = (0, _pure2.default)(ContentForward);
	ContentForward.displayName = 'ContentForward';
	ContentForward.muiName = 'SvgIcon';
	
	exports.default = ContentForward;

/***/ },
/* 1254 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentGesture = function ContentGesture(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4.59 6.89c.7-.71 1.4-1.35 1.71-1.22.5.2 0 1.03-.3 1.52-.25.42-2.86 3.89-2.86 6.31 0 1.28.48 2.34 1.34 2.98.75.56 1.74.73 2.64.46 1.07-.31 1.95-1.4 3.06-2.77 1.21-1.49 2.83-3.44 4.08-3.44 1.63 0 1.65 1.01 1.76 1.79-3.78.64-5.38 3.67-5.38 5.37 0 1.7 1.44 3.09 3.21 3.09 1.63 0 4.29-1.33 4.69-6.1H21v-2.5h-2.47c-.15-1.65-1.09-4.2-4.03-4.2-2.25 0-4.18 1.91-4.94 2.84-.58.73-2.06 2.48-2.29 2.72-.25.3-.68.84-1.11.84-.45 0-.72-.83-.36-1.92.35-1.09 1.4-2.86 1.85-3.52.78-1.14 1.3-1.92 1.3-3.28C8.95 3.69 7.31 3 6.44 3 5.12 3 3.97 4 3.72 4.25c-.36.36-.66.66-.88.93l1.75 1.71zm9.29 11.66c-.31 0-.74-.26-.74-.72 0-.6.73-2.2 2.87-2.76-.3 2.69-1.43 3.48-2.13 3.48z' })
	  );
	};
	ContentGesture = (0, _pure2.default)(ContentGesture);
	ContentGesture.displayName = 'ContentGesture';
	ContentGesture.muiName = 'SvgIcon';
	
	exports.default = ContentGesture;

/***/ },
/* 1255 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentInbox = function ContentInbox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H4.99c-1.11 0-1.98.89-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.11-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10z' })
	  );
	};
	ContentInbox = (0, _pure2.default)(ContentInbox);
	ContentInbox.displayName = 'ContentInbox';
	ContentInbox.muiName = 'SvgIcon';
	
	exports.default = ContentInbox;

/***/ },
/* 1256 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentLink = function ContentLink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
	  );
	};
	ContentLink = (0, _pure2.default)(ContentLink);
	ContentLink.displayName = 'ContentLink';
	ContentLink.muiName = 'SvgIcon';
	
	exports.default = ContentLink;

/***/ },
/* 1257 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentLowPriority = function ContentLowPriority(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 5h8v2h-8zm0 5.5h8v2h-8zm0 5.5h8v2h-8zM2 11.5C2 15.08 4.92 18 8.5 18H9v2l3-3-3-3v2h-.5C6.02 16 4 13.98 4 11.5S6.02 7 8.5 7H12V5H8.5C4.92 5 2 7.92 2 11.5z' })
	  );
	};
	ContentLowPriority = (0, _pure2.default)(ContentLowPriority);
	ContentLowPriority.displayName = 'ContentLowPriority';
	ContentLowPriority.muiName = 'SvgIcon';
	
	exports.default = ContentLowPriority;

/***/ },
/* 1258 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentMail = function ContentMail(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	ContentMail = (0, _pure2.default)(ContentMail);
	ContentMail.displayName = 'ContentMail';
	ContentMail.muiName = 'SvgIcon';
	
	exports.default = ContentMail;

/***/ },
/* 1259 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentMarkunread = function ContentMarkunread(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	ContentMarkunread = (0, _pure2.default)(ContentMarkunread);
	ContentMarkunread.displayName = 'ContentMarkunread';
	ContentMarkunread.muiName = 'SvgIcon';
	
	exports.default = ContentMarkunread;

/***/ },
/* 1260 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentMoveToInbox = function ContentMoveToInbox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H4.99c-1.11 0-1.98.9-1.98 2L3 19c0 1.1.88 2 1.99 2H19c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 12h-4c0 1.66-1.35 3-3 3s-3-1.34-3-3H4.99V5H19v10zm-3-5h-2V7h-4v3H8l4 4 4-4z' })
	  );
	};
	ContentMoveToInbox = (0, _pure2.default)(ContentMoveToInbox);
	ContentMoveToInbox.displayName = 'ContentMoveToInbox';
	ContentMoveToInbox.muiName = 'SvgIcon';
	
	exports.default = ContentMoveToInbox;

/***/ },
/* 1261 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentNextWeek = function ContentNextWeek(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 7h-4V5c0-.55-.22-1.05-.59-1.41C15.05 3.22 14.55 3 14 3h-4c-1.1 0-2 .9-2 2v2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zM10 5h4v2h-4V5zm1 13.5l-1-1 3-3-3-3 1-1 4 4-4 4z' })
	  );
	};
	ContentNextWeek = (0, _pure2.default)(ContentNextWeek);
	ContentNextWeek.displayName = 'ContentNextWeek';
	ContentNextWeek.muiName = 'SvgIcon';
	
	exports.default = ContentNextWeek;

/***/ },
/* 1262 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRedo = function ContentRedo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.4 10.6C16.55 8.99 14.15 8 11.5 8c-4.65 0-8.58 3.03-9.96 7.22L3.9 16c1.05-3.19 4.05-5.5 7.6-5.5 1.95 0 3.73.72 5.12 1.88L13 16h9V7l-3.6 3.6z' })
	  );
	};
	ContentRedo = (0, _pure2.default)(ContentRedo);
	ContentRedo.displayName = 'ContentRedo';
	ContentRedo.muiName = 'SvgIcon';
	
	exports.default = ContentRedo;

/***/ },
/* 1263 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemoveCircleOutline = function ContentRemoveCircleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 11v2h10v-2H7zm5-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ContentRemoveCircleOutline = (0, _pure2.default)(ContentRemoveCircleOutline);
	ContentRemoveCircleOutline.displayName = 'ContentRemoveCircleOutline';
	ContentRemoveCircleOutline.muiName = 'SvgIcon';
	
	exports.default = ContentRemoveCircleOutline;

/***/ },
/* 1264 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemoveCircle = function ContentRemoveCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z' })
	  );
	};
	ContentRemoveCircle = (0, _pure2.default)(ContentRemoveCircle);
	ContentRemoveCircle.displayName = 'ContentRemoveCircle';
	ContentRemoveCircle.muiName = 'SvgIcon';
	
	exports.default = ContentRemoveCircle;

/***/ },
/* 1265 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentRemove = function ContentRemove(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 13H5v-2h14v2z' })
	  );
	};
	ContentRemove = (0, _pure2.default)(ContentRemove);
	ContentRemove.displayName = 'ContentRemove';
	ContentRemove.muiName = 'SvgIcon';
	
	exports.default = ContentRemove;

/***/ },
/* 1266 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentReplyAll = function ContentReplyAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 8V5l-7 7 7 7v-3l-4-4 4-4zm6 1V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
	  );
	};
	ContentReplyAll = (0, _pure2.default)(ContentReplyAll);
	ContentReplyAll.displayName = 'ContentReplyAll';
	ContentReplyAll.muiName = 'SvgIcon';
	
	exports.default = ContentReplyAll;

/***/ },
/* 1267 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentReply = function ContentReply(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 9V5l-7 7 7 7v-4.1c5 0 8.5 1.6 11 5.1-1-5-4-10-11-11z' })
	  );
	};
	ContentReply = (0, _pure2.default)(ContentReply);
	ContentReply.displayName = 'ContentReply';
	ContentReply.muiName = 'SvgIcon';
	
	exports.default = ContentReply;

/***/ },
/* 1268 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentReport = function ContentReport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.73 3H8.27L3 8.27v7.46L8.27 21h7.46L21 15.73V8.27L15.73 3zM12 17.3c-.72 0-1.3-.58-1.3-1.3 0-.72.58-1.3 1.3-1.3.72 0 1.3.58 1.3 1.3 0 .72-.58 1.3-1.3 1.3zm1-4.3h-2V7h2v6z' })
	  );
	};
	ContentReport = (0, _pure2.default)(ContentReport);
	ContentReport.displayName = 'ContentReport';
	ContentReport.muiName = 'SvgIcon';
	
	exports.default = ContentReport;

/***/ },
/* 1269 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSave = function ContentSave(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V7l-4-4zm-5 16c-1.66 0-3-1.34-3-3s1.34-3 3-3 3 1.34 3 3-1.34 3-3 3zm3-10H5V5h10v4z' })
	  );
	};
	ContentSave = (0, _pure2.default)(ContentSave);
	ContentSave.displayName = 'ContentSave';
	ContentSave.muiName = 'SvgIcon';
	
	exports.default = ContentSave;

/***/ },
/* 1270 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSelectAll = function ContentSelectAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5h2V3c-1.1 0-2 .9-2 2zm0 8h2v-2H3v2zm4 8h2v-2H7v2zM3 9h2V7H3v2zm10-6h-2v2h2V3zm6 0v2h2c0-1.1-.9-2-2-2zM5 21v-2H3c0 1.1.9 2 2 2zm-2-4h2v-2H3v2zM9 3H7v2h2V3zm2 18h2v-2h-2v2zm8-8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2zm0-12h2V7h-2v2zm0 8h2v-2h-2v2zm-4 4h2v-2h-2v2zm0-16h2V3h-2v2zM7 17h10V7H7v10zm2-8h6v6H9V9z' })
	  );
	};
	ContentSelectAll = (0, _pure2.default)(ContentSelectAll);
	ContentSelectAll.displayName = 'ContentSelectAll';
	ContentSelectAll.muiName = 'SvgIcon';
	
	exports.default = ContentSelectAll;

/***/ },
/* 1271 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSend = function ContentSend(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.01 21L23 12 2.01 3 2 10l15 2-15 2z' })
	  );
	};
	ContentSend = (0, _pure2.default)(ContentSend);
	ContentSend.displayName = 'ContentSend';
	ContentSend.muiName = 'SvgIcon';
	
	exports.default = ContentSend;

/***/ },
/* 1272 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentSort = function ContentSort(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 18h6v-2H3v2zM3 6v2h18V6H3zm0 7h12v-2H3v2z' })
	  );
	};
	ContentSort = (0, _pure2.default)(ContentSort);
	ContentSort.displayName = 'ContentSort';
	ContentSort.muiName = 'SvgIcon';
	
	exports.default = ContentSort;

/***/ },
/* 1273 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentTextFormat = function ContentTextFormat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 17v2h14v-2H5zm4.5-4.2h5l.9 2.2h2.1L12.75 4h-1.5L6.5 15h2.1l.9-2.2zM12 5.98L13.87 11h-3.74L12 5.98z' })
	  );
	};
	ContentTextFormat = (0, _pure2.default)(ContentTextFormat);
	ContentTextFormat.displayName = 'ContentTextFormat';
	ContentTextFormat.muiName = 'SvgIcon';
	
	exports.default = ContentTextFormat;

/***/ },
/* 1274 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentUnarchive = function ContentUnarchive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.55 5.22l-1.39-1.68C18.88 3.21 18.47 3 18 3H6c-.47 0-.88.21-1.15.55L3.46 5.22C3.17 5.57 3 6.01 3 6.5V19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V6.5c0-.49-.17-.93-.45-1.28zM12 9.5l5.5 5.5H14v2h-4v-2H6.5L12 9.5zM5.12 5l.82-1h12l.93 1H5.12z' })
	  );
	};
	ContentUnarchive = (0, _pure2.default)(ContentUnarchive);
	ContentUnarchive.displayName = 'ContentUnarchive';
	ContentUnarchive.muiName = 'SvgIcon';
	
	exports.default = ContentUnarchive;

/***/ },
/* 1275 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentUndo = function ContentUndo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.5 8c-2.65 0-5.05.99-6.9 2.6L2 7v9h9l-3.62-3.62c1.39-1.16 3.16-1.88 5.12-1.88 3.54 0 6.55 2.31 7.6 5.5l2.37-.78C21.08 11.03 17.15 8 12.5 8z' })
	  );
	};
	ContentUndo = (0, _pure2.default)(ContentUndo);
	ContentUndo.displayName = 'ContentUndo';
	ContentUndo.muiName = 'SvgIcon';
	
	exports.default = ContentUndo;

/***/ },
/* 1276 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ContentWeekend = function ContentWeekend(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 10c-1.1 0-2 .9-2 2v3H5v-3c0-1.1-.9-2-2-2s-2 .9-2 2v5c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2v-5c0-1.1-.9-2-2-2zm-3-5H6c-1.1 0-2 .9-2 2v2.15c1.16.41 2 1.51 2 2.82V14h12v-2.03c0-1.3.84-2.4 2-2.82V7c0-1.1-.9-2-2-2z' })
	  );
	};
	ContentWeekend = (0, _pure2.default)(ContentWeekend);
	ContentWeekend.displayName = 'ContentWeekend';
	ContentWeekend.muiName = 'SvgIcon';
	
	exports.default = ContentWeekend;

/***/ },
/* 1277 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAccessAlarm = function DeviceAccessAlarm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM12.5 8H11v6l4.75 2.85.75-1.23-4-2.37V8zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceAccessAlarm = (0, _pure2.default)(DeviceAccessAlarm);
	DeviceAccessAlarm.displayName = 'DeviceAccessAlarm';
	DeviceAccessAlarm.muiName = 'SvgIcon';
	
	exports.default = DeviceAccessAlarm;

/***/ },
/* 1278 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAccessAlarms = function DeviceAccessAlarms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 5.7l-4.6-3.9-1.3 1.5 4.6 3.9L22 5.7zM7.9 3.4L6.6 1.9 2 5.7l1.3 1.5 4.6-3.8zM12.5 8H11v6l4.7 2.9.8-1.2-4-2.4V8zM12 4c-5 0-9 4-9 9s4 9 9 9 9-4 9-9-4-9-9-9zm0 16c-3.9 0-7-3.1-7-7s3.1-7 7-7 7 3.1 7 7-3.1 7-7 7z' })
	  );
	};
	DeviceAccessAlarms = (0, _pure2.default)(DeviceAccessAlarms);
	DeviceAccessAlarms.displayName = 'DeviceAccessAlarms';
	DeviceAccessAlarms.muiName = 'SvgIcon';
	
	exports.default = DeviceAccessAlarms;

/***/ },
/* 1279 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAccessTime = function DeviceAccessTime(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm.5-13H11v6l5.25 3.15.75-1.23-4.5-2.67z' })
	  );
	};
	DeviceAccessTime = (0, _pure2.default)(DeviceAccessTime);
	DeviceAccessTime.displayName = 'DeviceAccessTime';
	DeviceAccessTime.muiName = 'SvgIcon';
	
	exports.default = DeviceAccessTime;

/***/ },
/* 1280 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAddAlarm = function DeviceAddAlarm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.88 3.39L6.6 1.86 2 5.71l1.29 1.53 4.59-3.85zM22 5.72l-4.6-3.86-1.29 1.53 4.6 3.86L22 5.72zM12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9c4.97 0 9-4.03 9-9s-4.03-9-9-9zm0 16c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7zm1-11h-2v3H8v2h3v3h2v-3h3v-2h-3V9z' })
	  );
	};
	DeviceAddAlarm = (0, _pure2.default)(DeviceAddAlarm);
	DeviceAddAlarm.displayName = 'DeviceAddAlarm';
	DeviceAddAlarm.muiName = 'SvgIcon';
	
	exports.default = DeviceAddAlarm;

/***/ },
/* 1281 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAirplanemodeActive = function DeviceAirplanemodeActive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.18 9' }),
	    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
	  );
	};
	DeviceAirplanemodeActive = (0, _pure2.default)(DeviceAirplanemodeActive);
	DeviceAirplanemodeActive.displayName = 'DeviceAirplanemodeActive';
	DeviceAirplanemodeActive.muiName = 'SvgIcon';
	
	exports.default = DeviceAirplanemodeActive;

/***/ },
/* 1282 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceAirplanemodeInactive = function DeviceAirplanemodeInactive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 9V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5v3.68l7.83 7.83L21 16v-2l-8-5zM3 5.27l4.99 4.99L2 14v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-3.73L18.73 21 20 19.73 4.27 4 3 5.27z' })
	  );
	};
	DeviceAirplanemodeInactive = (0, _pure2.default)(DeviceAirplanemodeInactive);
	DeviceAirplanemodeInactive.displayName = 'DeviceAirplanemodeInactive';
	DeviceAirplanemodeInactive.muiName = 'SvgIcon';
	
	exports.default = DeviceAirplanemodeInactive;

/***/ },
/* 1283 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery20 = function DeviceBattery20(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 17v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17H7z' }),
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h10V5.33z' })
	  );
	};
	DeviceBattery20 = (0, _pure2.default)(DeviceBattery20);
	DeviceBattery20.displayName = 'DeviceBattery20';
	DeviceBattery20.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery20;

/***/ },
/* 1284 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery30 = function DeviceBattery30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V15h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 15v5.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V15H7z' })
	  );
	};
	DeviceBattery30 = (0, _pure2.default)(DeviceBattery30);
	DeviceBattery30.displayName = 'DeviceBattery30';
	DeviceBattery30.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery30;

/***/ },
/* 1285 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery50 = function DeviceBattery50(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V13h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 13v7.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13H7z' })
	  );
	};
	DeviceBattery50 = (0, _pure2.default)(DeviceBattery50);
	DeviceBattery50.displayName = 'DeviceBattery50';
	DeviceBattery50.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery50;

/***/ },
/* 1286 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery60 = function DeviceBattery60(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 11v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11H7z' })
	  );
	};
	DeviceBattery60 = (0, _pure2.default)(DeviceBattery60);
	DeviceBattery60.displayName = 'DeviceBattery60';
	DeviceBattery60.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery60;

/***/ },
/* 1287 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery80 = function DeviceBattery80(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 9v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9H7z' })
	  );
	};
	DeviceBattery80 = (0, _pure2.default)(DeviceBattery80);
	DeviceBattery80.displayName = 'DeviceBattery80';
	DeviceBattery80.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery80;

/***/ },
/* 1288 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBattery90 = function DeviceBattery90(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M17 5.33C17 4.6 16.4 4 15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h10V5.33z' }),
	    _react2.default.createElement('path', { d: 'M7 8v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8H7z' })
	  );
	};
	DeviceBattery90 = (0, _pure2.default)(DeviceBattery90);
	DeviceBattery90.displayName = 'DeviceBattery90';
	DeviceBattery90.muiName = 'SvgIcon';
	
	exports.default = DeviceBattery90;

/***/ },
/* 1289 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryAlert = function DeviceBatteryAlert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM13 18h-2v-2h2v2zm0-4h-2V9h2v5z' })
	  );
	};
	DeviceBatteryAlert = (0, _pure2.default)(DeviceBatteryAlert);
	DeviceBatteryAlert.displayName = 'DeviceBatteryAlert';
	DeviceBatteryAlert.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryAlert;

/***/ },
/* 1290 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging20 = function DeviceBatteryCharging20(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 20v-3H7v3.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V17h-4.4L11 20z' }),
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V17h4v-2.5H9L13 7v5.5h2L12.6 17H17V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryCharging20 = (0, _pure2.default)(DeviceBatteryCharging20);
	DeviceBatteryCharging20.displayName = 'DeviceBatteryCharging20';
	DeviceBatteryCharging20.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging20;

/***/ },
/* 1291 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging30 = function DeviceBatteryCharging30(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v9.17h2L13 7v5.5h2l-1.07 2H17V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M11 20v-5.5H7v6.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V14.5h-3.07L11 20z' })
	  );
	};
	DeviceBatteryCharging30 = (0, _pure2.default)(DeviceBatteryCharging30);
	DeviceBatteryCharging30.displayName = 'DeviceBatteryCharging30';
	DeviceBatteryCharging30.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging30;

/***/ },
/* 1292 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging50 = function DeviceBatteryCharging50(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.47 13.5L11 20v-5.5H9l.53-1H7v7.17C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V13.5h-2.53z' }),
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v8.17h2.53L13 7v5.5h2l-.53 1H17V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryCharging50 = (0, _pure2.default)(DeviceBatteryCharging50);
	DeviceBatteryCharging50.displayName = 'DeviceBatteryCharging50';
	DeviceBatteryCharging50.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging50;

/***/ },
/* 1293 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging60 = function DeviceBatteryCharging60(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V11h3.87L13 7v4h4V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9l1.87-3.5H7v9.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V11h-4v1.5z' })
	  );
	};
	DeviceBatteryCharging60 = (0, _pure2.default)(DeviceBatteryCharging60);
	DeviceBatteryCharging60.displayName = 'DeviceBatteryCharging60';
	DeviceBatteryCharging60.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging60;

/***/ },
/* 1294 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging80 = function DeviceBatteryCharging80(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V9h4.93L13 7v2h4V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9L11.93 9H7v11.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V9h-4v3.5z' })
	  );
	};
	DeviceBatteryCharging80 = (0, _pure2.default)(DeviceBatteryCharging80);
	DeviceBatteryCharging80.displayName = 'DeviceBatteryCharging80';
	DeviceBatteryCharging80.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging80;

/***/ },
/* 1295 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryCharging90 = function DeviceBatteryCharging90(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33V8h5.47L13 7v1h4V5.33C17 4.6 16.4 4 15.67 4z' }),
	    _react2.default.createElement('path', { d: 'M13 12.5h2L11 20v-5.5H9L12.47 8H7v12.67C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V8h-4v4.5z' })
	  );
	};
	DeviceBatteryCharging90 = (0, _pure2.default)(DeviceBatteryCharging90);
	DeviceBatteryCharging90.displayName = 'DeviceBatteryCharging90';
	DeviceBatteryCharging90.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryCharging90;

/***/ },
/* 1296 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryChargingFull = function DeviceBatteryChargingFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zM11 20v-5.5H9L13 7v5.5h2L11 20z' })
	  );
	};
	DeviceBatteryChargingFull = (0, _pure2.default)(DeviceBatteryChargingFull);
	DeviceBatteryChargingFull.displayName = 'DeviceBatteryChargingFull';
	DeviceBatteryChargingFull.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryChargingFull;

/***/ },
/* 1297 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryFull = function DeviceBatteryFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryFull = (0, _pure2.default)(DeviceBatteryFull);
	DeviceBatteryFull.displayName = 'DeviceBatteryFull';
	DeviceBatteryFull.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryFull;

/***/ },
/* 1298 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryStd = function DeviceBatteryStd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4z' })
	  );
	};
	DeviceBatteryStd = (0, _pure2.default)(DeviceBatteryStd);
	DeviceBatteryStd.displayName = 'DeviceBatteryStd';
	DeviceBatteryStd.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryStd;

/***/ },
/* 1299 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBatteryUnknown = function DeviceBatteryUnknown(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.67 4H14V2h-4v2H8.33C7.6 4 7 4.6 7 5.33v15.33C7 21.4 7.6 22 8.33 22h7.33c.74 0 1.34-.6 1.34-1.33V5.33C17 4.6 16.4 4 15.67 4zm-2.72 13.95h-1.9v-1.9h1.9v1.9zm1.35-5.26s-.38.42-.67.71c-.48.48-.83 1.15-.83 1.6h-1.6c0-.83.46-1.52.93-2l.93-.94c.27-.27.44-.65.44-1.06 0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5H9c0-1.66 1.34-3 3-3s3 1.34 3 3c0 .66-.27 1.26-.7 1.69z' })
	  );
	};
	DeviceBatteryUnknown = (0, _pure2.default)(DeviceBatteryUnknown);
	DeviceBatteryUnknown.displayName = 'DeviceBatteryUnknown';
	DeviceBatteryUnknown.muiName = 'SvgIcon';
	
	exports.default = DeviceBatteryUnknown;

/***/ },
/* 1300 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetoothConnected = function DeviceBluetoothConnected(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 12l-2-2-2 2 2 2 2-2zm10.71-4.29L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88zM19 10l-2 2 2 2 2-2-2-2z' })
	  );
	};
	DeviceBluetoothConnected = (0, _pure2.default)(DeviceBluetoothConnected);
	DeviceBluetoothConnected.displayName = 'DeviceBluetoothConnected';
	DeviceBluetoothConnected.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetoothConnected;

/***/ },
/* 1301 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetoothDisabled = function DeviceBluetoothDisabled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 5.83l1.88 1.88-1.6 1.6 1.41 1.41 3.02-3.02L12 2h-1v5.03l2 2v-3.2zM5.41 4L4 5.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l4.29-4.29 2.3 2.29L20 18.59 5.41 4zM13 18.17v-3.76l1.88 1.88L13 18.17z' })
	  );
	};
	DeviceBluetoothDisabled = (0, _pure2.default)(DeviceBluetoothDisabled);
	DeviceBluetoothDisabled.displayName = 'DeviceBluetoothDisabled';
	DeviceBluetoothDisabled.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetoothDisabled;

/***/ },
/* 1302 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetoothSearching = function DeviceBluetoothSearching(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z' })
	  );
	};
	DeviceBluetoothSearching = (0, _pure2.default)(DeviceBluetoothSearching);
	DeviceBluetoothSearching.displayName = 'DeviceBluetoothSearching';
	DeviceBluetoothSearching.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetoothSearching;

/***/ },
/* 1303 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBluetooth = function DeviceBluetooth(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.71 7.71L12 2h-1v7.59L6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 11 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM13 5.83l1.88 1.88L13 9.59V5.83zm1.88 10.46L13 18.17v-3.76l1.88 1.88z' })
	  );
	};
	DeviceBluetooth = (0, _pure2.default)(DeviceBluetooth);
	DeviceBluetooth.displayName = 'DeviceBluetooth';
	DeviceBluetooth.muiName = 'SvgIcon';
	
	exports.default = DeviceBluetooth;

/***/ },
/* 1304 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessAuto = function DeviceBrightnessAuto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.85 12.65h2.3L12 9l-1.15 3.65zM20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM14.3 16l-.7-2h-3.2l-.7 2H7.8L11 7h2l3.2 9h-1.9z' })
	  );
	};
	DeviceBrightnessAuto = (0, _pure2.default)(DeviceBrightnessAuto);
	DeviceBrightnessAuto.displayName = 'DeviceBrightnessAuto';
	DeviceBrightnessAuto.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessAuto;

/***/ },
/* 1305 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessHigh = function DeviceBrightnessHigh(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
	  );
	};
	DeviceBrightnessHigh = (0, _pure2.default)(DeviceBrightnessHigh);
	DeviceBrightnessHigh.displayName = 'DeviceBrightnessHigh';
	DeviceBrightnessHigh.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessHigh;

/***/ },
/* 1306 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessLow = function DeviceBrightnessLow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
	  );
	};
	DeviceBrightnessLow = (0, _pure2.default)(DeviceBrightnessLow);
	DeviceBrightnessLow.displayName = 'DeviceBrightnessLow';
	DeviceBrightnessLow.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessLow;

/***/ },
/* 1307 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceBrightnessMedium = function DeviceBrightnessMedium(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
	  );
	};
	DeviceBrightnessMedium = (0, _pure2.default)(DeviceBrightnessMedium);
	DeviceBrightnessMedium.displayName = 'DeviceBrightnessMedium';
	DeviceBrightnessMedium.muiName = 'SvgIcon';
	
	exports.default = DeviceBrightnessMedium;

/***/ },
/* 1308 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDataUsage = function DeviceDataUsage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 2.05v3.03c3.39.49 6 3.39 6 6.92 0 .9-.18 1.75-.48 2.54l2.6 1.53c.56-1.24.88-2.62.88-4.07 0-5.18-3.95-9.45-9-9.95zM12 19c-3.87 0-7-3.13-7-7 0-3.53 2.61-6.43 6-6.92V2.05c-5.06.5-9 4.76-9 9.95 0 5.52 4.47 10 9.99 10 3.31 0 6.24-1.61 8.06-4.09l-2.6-1.53C16.17 17.98 14.21 19 12 19z' })
	  );
	};
	DeviceDataUsage = (0, _pure2.default)(DeviceDataUsage);
	DeviceDataUsage.displayName = 'DeviceDataUsage';
	DeviceDataUsage.muiName = 'SvgIcon';
	
	exports.default = DeviceDataUsage;

/***/ },
/* 1309 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDeveloperMode = function DeviceDeveloperMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 5h10v2h2V3c0-1.1-.9-1.99-2-1.99L7 1c-1.1 0-2 .9-2 2v4h2V5zm8.41 11.59L20 12l-4.59-4.59L14 8.83 17.17 12 14 15.17l1.41 1.42zM10 15.17L6.83 12 10 8.83 8.59 7.41 4 12l4.59 4.59L10 15.17zM17 19H7v-2H5v4c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2v-4h-2v2z' })
	  );
	};
	DeviceDeveloperMode = (0, _pure2.default)(DeviceDeveloperMode);
	DeviceDeveloperMode.displayName = 'DeviceDeveloperMode';
	DeviceDeveloperMode.muiName = 'SvgIcon';
	
	exports.default = DeviceDeveloperMode;

/***/ },
/* 1310 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDevices = function DeviceDevices(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' })
	  );
	};
	DeviceDevices = (0, _pure2.default)(DeviceDevices);
	DeviceDevices.displayName = 'DeviceDevices';
	DeviceDevices.muiName = 'SvgIcon';
	
	exports.default = DeviceDevices;

/***/ },
/* 1311 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceDvr = function DeviceDvr(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12zm-2-9H8v2h11V8zm0 4H8v2h11v-2zM7 8H5v2h2V8zm0 4H5v2h2v-2z' })
	  );
	};
	DeviceDvr = (0, _pure2.default)(DeviceDvr);
	DeviceDvr.displayName = 'DeviceDvr';
	DeviceDvr.muiName = 'SvgIcon';
	
	exports.default = DeviceDvr;

/***/ },
/* 1312 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGpsFixed = function DeviceGpsFixed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceGpsFixed = (0, _pure2.default)(DeviceGpsFixed);
	DeviceGpsFixed.displayName = 'DeviceGpsFixed';
	DeviceGpsFixed.muiName = 'SvgIcon';
	
	exports.default = DeviceGpsFixed;

/***/ },
/* 1313 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGpsNotFixed = function DeviceGpsNotFixed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceGpsNotFixed = (0, _pure2.default)(DeviceGpsNotFixed);
	DeviceGpsNotFixed.displayName = 'DeviceGpsNotFixed';
	DeviceGpsNotFixed.muiName = 'SvgIcon';
	
	exports.default = DeviceGpsNotFixed;

/***/ },
/* 1314 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGpsOff = function DeviceGpsOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z' })
	  );
	};
	DeviceGpsOff = (0, _pure2.default)(DeviceGpsOff);
	DeviceGpsOff.displayName = 'DeviceGpsOff';
	DeviceGpsOff.muiName = 'SvgIcon';
	
	exports.default = DeviceGpsOff;

/***/ },
/* 1315 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceGraphicEq = function DeviceGraphicEq(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 18h2V6H7v12zm4 4h2V2h-2v20zm-8-8h2v-4H3v4zm12 4h2V6h-2v12zm4-8v4h2v-4h-2z' })
	  );
	};
	DeviceGraphicEq = (0, _pure2.default)(DeviceGraphicEq);
	DeviceGraphicEq.displayName = 'DeviceGraphicEq';
	DeviceGraphicEq.muiName = 'SvgIcon';
	
	exports.default = DeviceGraphicEq;

/***/ },
/* 1316 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceLocationDisabled = function DeviceLocationDisabled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06c-1.13.12-2.19.46-3.16.97l1.5 1.5C10.16 5.19 11.06 5 12 5c3.87 0 7 3.13 7 7 0 .94-.19 1.84-.52 2.65l1.5 1.5c.5-.96.84-2.02.97-3.15H23v-2h-2.06zM3 4.27l2.04 2.04C3.97 7.62 3.25 9.23 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c1.77-.2 3.38-.91 4.69-1.98L19.73 21 21 19.73 4.27 3 3 4.27zm13.27 13.27C15.09 18.45 13.61 19 12 19c-3.87 0-7-3.13-7-7 0-1.61.55-3.09 1.46-4.27l9.81 9.81z' })
	  );
	};
	DeviceLocationDisabled = (0, _pure2.default)(DeviceLocationDisabled);
	DeviceLocationDisabled.displayName = 'DeviceLocationDisabled';
	DeviceLocationDisabled.muiName = 'SvgIcon';
	
	exports.default = DeviceLocationDisabled;

/***/ },
/* 1317 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceLocationSearching = function DeviceLocationSearching(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.94 11c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	DeviceLocationSearching = (0, _pure2.default)(DeviceLocationSearching);
	DeviceLocationSearching.displayName = 'DeviceLocationSearching';
	DeviceLocationSearching.muiName = 'SvgIcon';
	
	exports.default = DeviceLocationSearching;

/***/ },
/* 1318 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceNetworkCell = function DeviceNetworkCell(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M17 7L2 22h15z' })
	  );
	};
	DeviceNetworkCell = (0, _pure2.default)(DeviceNetworkCell);
	DeviceNetworkCell.displayName = 'DeviceNetworkCell';
	DeviceNetworkCell.muiName = 'SvgIcon';
	
	exports.default = DeviceNetworkCell;

/***/ },
/* 1319 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceNetworkWifi = function DeviceNetworkWifi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
	  );
	};
	DeviceNetworkWifi = (0, _pure2.default)(DeviceNetworkWifi);
	DeviceNetworkWifi.displayName = 'DeviceNetworkWifi';
	DeviceNetworkWifi.muiName = 'SvgIcon';
	
	exports.default = DeviceNetworkWifi;

/***/ },
/* 1320 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceNfc = function DeviceNfc(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 18H4V4h16v16zM18 6h-5c-1.1 0-2 .9-2 2v2.28c-.6.35-1 .98-1 1.72 0 1.1.9 2 2 2s2-.9 2-2c0-.74-.4-1.38-1-1.72V8h3v8H8V8h2V6H6v12h12V6z' })
	  );
	};
	DeviceNfc = (0, _pure2.default)(DeviceNfc);
	DeviceNfc.displayName = 'DeviceNfc';
	DeviceNfc.muiName = 'SvgIcon';
	
	exports.default = DeviceNfc;

/***/ },
/* 1321 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenLockLandscape = function DeviceScreenLockLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5H3c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-2 12H5V7h14v10zm-9-1h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1z' })
	  );
	};
	DeviceScreenLockLandscape = (0, _pure2.default)(DeviceScreenLockLandscape);
	DeviceScreenLockLandscape.displayName = 'DeviceScreenLockLandscape';
	DeviceScreenLockLandscape.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenLockLandscape;

/***/ },
/* 1322 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenLockPortrait = function DeviceScreenLockPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 16h4c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1v-1c0-1.11-.9-2-2-2-1.11 0-2 .9-2 2v1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1zm.8-6c0-.66.54-1.2 1.2-1.2.66 0 1.2.54 1.2 1.2v1h-2.4v-1zM17 1H7c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 18H7V5h10v14z' })
	  );
	};
	DeviceScreenLockPortrait = (0, _pure2.default)(DeviceScreenLockPortrait);
	DeviceScreenLockPortrait.displayName = 'DeviceScreenLockPortrait';
	DeviceScreenLockPortrait.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenLockPortrait;

/***/ },
/* 1323 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenLockRotation = function DeviceScreenLockRotation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23.25 12.77l-2.57-2.57-1.41 1.41 2.22 2.22-5.66 5.66L4.51 8.17l5.66-5.66 2.1 2.1 1.41-1.41L11.23.75c-.59-.59-1.54-.59-2.12 0L2.75 7.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12zM8.47 20.48C5.2 18.94 2.86 15.76 2.5 12H1c.51 6.16 5.66 11 11.95 11l.66-.03-3.81-3.82-1.33 1.33zM16 9h5c.55 0 1-.45 1-1V4c0-.55-.45-1-1-1v-.5C21 1.12 19.88 0 18.5 0S16 1.12 16 2.5V3c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1zm.8-6.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V3h-3.4v-.5z' })
	  );
	};
	DeviceScreenLockRotation = (0, _pure2.default)(DeviceScreenLockRotation);
	DeviceScreenLockRotation.displayName = 'DeviceScreenLockRotation';
	DeviceScreenLockRotation.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenLockRotation;

/***/ },
/* 1324 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceScreenRotation = function DeviceScreenRotation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.48 2.52c3.27 1.55 5.61 4.72 5.97 8.48h1.5C23.44 4.84 18.29 0 12 0l-.66.03 3.81 3.81 1.33-1.32zm-6.25-.77c-.59-.59-1.54-.59-2.12 0L1.75 8.11c-.59.59-.59 1.54 0 2.12l12.02 12.02c.59.59 1.54.59 2.12 0l6.36-6.36c.59-.59.59-1.54 0-2.12L10.23 1.75zm4.6 19.44L2.81 9.17l6.36-6.36 12.02 12.02-6.36 6.36zm-7.31.29C4.25 19.94 1.91 16.76 1.55 13H.05C.56 19.16 5.71 24 12 24l.66-.03-3.81-3.81-1.33 1.32z' })
	  );
	};
	DeviceScreenRotation = (0, _pure2.default)(DeviceScreenRotation);
	DeviceScreenRotation.displayName = 'DeviceScreenRotation';
	DeviceScreenRotation.muiName = 'SvgIcon';
	
	exports.default = DeviceScreenRotation;

/***/ },
/* 1325 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSdStorage = function DeviceSdStorage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
	  );
	};
	DeviceSdStorage = (0, _pure2.default)(DeviceSdStorage);
	DeviceSdStorage.displayName = 'DeviceSdStorage';
	DeviceSdStorage.muiName = 'SvgIcon';
	
	exports.default = DeviceSdStorage;

/***/ },
/* 1326 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSettingsSystemDaydream = function DeviceSettingsSystemDaydream(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16h6.5c1.38 0 2.5-1.12 2.5-2.5S16.88 11 15.5 11h-.05c-.24-1.69-1.69-3-3.45-3-1.4 0-2.6.83-3.16 2.02h-.16C7.17 10.18 6 11.45 6 13c0 1.66 1.34 3 3 3zM21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16.01H3V4.99h18v14.02z' })
	  );
	};
	DeviceSettingsSystemDaydream = (0, _pure2.default)(DeviceSettingsSystemDaydream);
	DeviceSettingsSystemDaydream.displayName = 'DeviceSettingsSystemDaydream';
	DeviceSettingsSystemDaydream.muiName = 'SvgIcon';
	
	exports.default = DeviceSettingsSystemDaydream;

/***/ },
/* 1327 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular0Bar = function DeviceSignalCellular0Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' })
	  );
	};
	DeviceSignalCellular0Bar = (0, _pure2.default)(DeviceSignalCellular0Bar);
	DeviceSignalCellular0Bar.displayName = 'DeviceSignalCellular0Bar';
	DeviceSignalCellular0Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular0Bar;

/***/ },
/* 1328 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular1Bar = function DeviceSignalCellular1Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M12 12L2 22h10z' })
	  );
	};
	DeviceSignalCellular1Bar = (0, _pure2.default)(DeviceSignalCellular1Bar);
	DeviceSignalCellular1Bar.displayName = 'DeviceSignalCellular1Bar';
	DeviceSignalCellular1Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular1Bar;

/***/ },
/* 1329 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular2Bar = function DeviceSignalCellular2Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M14 10L2 22h12z' })
	  );
	};
	DeviceSignalCellular2Bar = (0, _pure2.default)(DeviceSignalCellular2Bar);
	DeviceSignalCellular2Bar.displayName = 'DeviceSignalCellular2Bar';
	DeviceSignalCellular2Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular2Bar;

/***/ },
/* 1330 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular3Bar = function DeviceSignalCellular3Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M2 22h20V2z' }),
	    _react2.default.createElement('path', { d: 'M17 7L2 22h15z' })
	  );
	};
	DeviceSignalCellular3Bar = (0, _pure2.default)(DeviceSignalCellular3Bar);
	DeviceSignalCellular3Bar.displayName = 'DeviceSignalCellular3Bar';
	DeviceSignalCellular3Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular3Bar;

/***/ },
/* 1331 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellular4Bar = function DeviceSignalCellular4Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 22h20V2z' })
	  );
	};
	DeviceSignalCellular4Bar = (0, _pure2.default)(DeviceSignalCellular4Bar);
	DeviceSignalCellular4Bar.displayName = 'DeviceSignalCellular4Bar';
	DeviceSignalCellular4Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellular4Bar;

/***/ },
/* 1332 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet0Bar = function DeviceSignalCellularConnectedNoInternet0Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M20 22h2v-2h-2v2zm0-12v8h2v-8h-2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet0Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet0Bar);
	DeviceSignalCellularConnectedNoInternet0Bar.displayName = 'DeviceSignalCellularConnectedNoInternet0Bar';
	DeviceSignalCellularConnectedNoInternet0Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet0Bar;

/***/ },
/* 1333 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet1Bar = function DeviceSignalCellularConnectedNoInternet1Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M20 10v8h2v-8h-2zm-8 12V12L2 22h10zm8 0h2v-2h-2v2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet1Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet1Bar);
	DeviceSignalCellularConnectedNoInternet1Bar.displayName = 'DeviceSignalCellularConnectedNoInternet1Bar';
	DeviceSignalCellularConnectedNoInternet1Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet1Bar;

/***/ },
/* 1334 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet2Bar = function DeviceSignalCellularConnectedNoInternet2Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M14 22V10L2 22h12zm6-12v8h2v-8h-2zm0 12h2v-2h-2v2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet2Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet2Bar);
	DeviceSignalCellularConnectedNoInternet2Bar.displayName = 'DeviceSignalCellularConnectedNoInternet2Bar';
	DeviceSignalCellularConnectedNoInternet2Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet2Bar;

/***/ },
/* 1335 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet3Bar = function DeviceSignalCellularConnectedNoInternet3Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M22 8V2L2 22h16V8z' }),
	    _react2.default.createElement('path', { d: 'M17 22V7L2 22h15zm3-12v8h2v-8h-2zm0 12h2v-2h-2v2z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet3Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet3Bar);
	DeviceSignalCellularConnectedNoInternet3Bar.displayName = 'DeviceSignalCellularConnectedNoInternet3Bar';
	DeviceSignalCellularConnectedNoInternet3Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet3Bar;

/***/ },
/* 1336 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularConnectedNoInternet4Bar = function DeviceSignalCellularConnectedNoInternet4Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18h2v-8h-2v8zm0 4h2v-2h-2v2zM2 22h16V8h4V2L2 22z' })
	  );
	};
	DeviceSignalCellularConnectedNoInternet4Bar = (0, _pure2.default)(DeviceSignalCellularConnectedNoInternet4Bar);
	DeviceSignalCellularConnectedNoInternet4Bar.displayName = 'DeviceSignalCellularConnectedNoInternet4Bar';
	DeviceSignalCellularConnectedNoInternet4Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularConnectedNoInternet4Bar;

/***/ },
/* 1337 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularNoSim = function DeviceSignalCellularNoSim(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.99 5c0-1.1-.89-2-1.99-2h-7L7.66 5.34 19 16.68 18.99 5zM3.65 3.88L2.38 5.15 5 7.77V19c0 1.1.9 2 2 2h10.01c.35 0 .67-.1.96-.26l1.88 1.88 1.27-1.27L3.65 3.88z' })
	  );
	};
	DeviceSignalCellularNoSim = (0, _pure2.default)(DeviceSignalCellularNoSim);
	DeviceSignalCellularNoSim.displayName = 'DeviceSignalCellularNoSim';
	DeviceSignalCellularNoSim.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularNoSim;

/***/ },
/* 1338 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularNull = function DeviceSignalCellularNull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6.83V20H6.83L20 6.83M22 2L2 22h20V2z' })
	  );
	};
	DeviceSignalCellularNull = (0, _pure2.default)(DeviceSignalCellularNull);
	DeviceSignalCellularNull.displayName = 'DeviceSignalCellularNull';
	DeviceSignalCellularNull.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularNull;

/***/ },
/* 1339 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalCellularOff = function DeviceSignalCellularOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 1l-8.59 8.59L21 18.18V1zM4.77 4.5L3.5 5.77l6.36 6.36L1 21h17.73l2 2L22 21.73 4.77 4.5z' })
	  );
	};
	DeviceSignalCellularOff = (0, _pure2.default)(DeviceSignalCellularOff);
	DeviceSignalCellularOff.displayName = 'DeviceSignalCellularOff';
	DeviceSignalCellularOff.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalCellularOff;

/***/ },
/* 1340 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi0Bar = function DeviceSignalWifi0Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
	  );
	};
	DeviceSignalWifi0Bar = (0, _pure2.default)(DeviceSignalWifi0Bar);
	DeviceSignalWifi0Bar.displayName = 'DeviceSignalWifi0Bar';
	DeviceSignalWifi0Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi0Bar;

/***/ },
/* 1341 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi1BarLock = function DeviceSignalWifi1BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z' }),
	    _react2.default.createElement('path', { d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z', opacity: '.3' }),
	    _react2.default.createElement('path', { d: 'M6.7 14.9l5.3 6.6 3.5-4.3v-2.6c0-.2 0-.5.1-.7-.9-.5-2.2-.9-3.6-.9-3 0-5.1 1.7-5.3 1.9z' })
	  );
	};
	DeviceSignalWifi1BarLock = (0, _pure2.default)(DeviceSignalWifi1BarLock);
	DeviceSignalWifi1BarLock.displayName = 'DeviceSignalWifi1BarLock';
	DeviceSignalWifi1BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi1BarLock;

/***/ },
/* 1342 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi1Bar = function DeviceSignalWifi1Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M6.67 14.86L12 21.49v.01l.01-.01 5.33-6.63C17.06 14.65 15.03 13 12 13s-5.06 1.65-5.33 1.86z' })
	  );
	};
	DeviceSignalWifi1Bar = (0, _pure2.default)(DeviceSignalWifi1Bar);
	DeviceSignalWifi1Bar.displayName = 'DeviceSignalWifi1Bar';
	DeviceSignalWifi1Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi1Bar;

/***/ },
/* 1343 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi2BarLock = function DeviceSignalWifi2BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16z' }),
	    _react2.default.createElement('path', { d: 'M15.5 14.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.3v-2.7z', opacity: '.3' }),
	    _react2.default.createElement('path', { d: 'M4.8 12.5l7.2 9 3.5-4.4v-2.6c0-1.3.5-2.5 1.4-3.4C15.6 10.5 14 10 12 10c-4.1 0-6.8 2.2-7.2 2.5z' })
	  );
	};
	DeviceSignalWifi2BarLock = (0, _pure2.default)(DeviceSignalWifi2BarLock);
	DeviceSignalWifi2BarLock.displayName = 'DeviceSignalWifi2BarLock';
	DeviceSignalWifi2BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi2BarLock;

/***/ },
/* 1344 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi2Bar = function DeviceSignalWifi2Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M4.79 12.52l7.2 8.98H12l.01-.01 7.2-8.98C18.85 12.24 16.1 10 12 10s-6.85 2.24-7.21 2.52z' })
	  );
	};
	DeviceSignalWifi2Bar = (0, _pure2.default)(DeviceSignalWifi2Bar);
	DeviceSignalWifi2Bar.displayName = 'DeviceSignalWifi2Bar';
	DeviceSignalWifi2Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi2Bar;

/***/ },
/* 1345 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi3BarLock = function DeviceSignalWifi3BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { opacity: '.3', d: 'M12 3C5.3 3 .8 6.7.4 7l3.2 3.9L12 21.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7.3-.1.5-.2.8-.2.3-.1.6-.1.9-.1.4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4z' }),
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-10 5.5l3.5-4.3v-2.6c0-2.2 1.4-4 3.3-4.7C17.3 9 14.9 8 12 8c-4.8 0-8 2.6-8.5 2.9' })
	  );
	};
	DeviceSignalWifi3BarLock = (0, _pure2.default)(DeviceSignalWifi3BarLock);
	DeviceSignalWifi3BarLock.displayName = 'DeviceSignalWifi3BarLock';
	DeviceSignalWifi3BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi3BarLock;

/***/ },
/* 1346 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi3Bar = function DeviceSignalWifi3Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.3', d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' }),
	    _react2.default.createElement('path', { d: 'M3.53 10.95l8.46 10.54.01.01.01-.01 8.46-10.54C20.04 10.62 16.81 8 12 8c-4.81 0-8.04 2.62-8.47 2.95z' })
	  );
	};
	DeviceSignalWifi3Bar = (0, _pure2.default)(DeviceSignalWifi3Bar);
	DeviceSignalWifi3Bar.displayName = 'DeviceSignalWifi3Bar';
	DeviceSignalWifi3Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi3Bar;

/***/ },
/* 1347 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi4BarLock = function DeviceSignalWifi4BarLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 16v-1.5c0-1.4-1.1-2.5-2.5-2.5S18 13.1 18 14.5V16c-.5 0-1 .5-1 1v4c0 .5.5 1 1 1h5c.5 0 1-.5 1-1v-4c0-.5-.5-1-1-1zm-1 0h-3v-1.5c0-.8.7-1.5 1.5-1.5s1.5.7 1.5 1.5V16zm-6.5-1.5c0-2.8 2.2-5 5-5 .4 0 .7 0 1 .1L23.6 7c-.4-.3-4.9-4-11.6-4C5.3 3 .8 6.7.4 7L12 21.5l3.5-4.4v-2.6z' })
	  );
	};
	DeviceSignalWifi4BarLock = (0, _pure2.default)(DeviceSignalWifi4BarLock);
	DeviceSignalWifi4BarLock.displayName = 'DeviceSignalWifi4BarLock';
	DeviceSignalWifi4BarLock.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi4BarLock;

/***/ },
/* 1348 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifi4Bar = function DeviceSignalWifi4Bar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.01 21.49L23.64 7c-.45-.34-4.93-4-11.64-4C5.28 3 .81 6.66.36 7l11.63 14.49.01.01.01-.01z' })
	  );
	};
	DeviceSignalWifi4Bar = (0, _pure2.default)(DeviceSignalWifi4Bar);
	DeviceSignalWifi4Bar.displayName = 'DeviceSignalWifi4Bar';
	DeviceSignalWifi4Bar.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifi4Bar;

/***/ },
/* 1349 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceSignalWifiOff = function DeviceSignalWifiOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23.64 7c-.45-.34-4.93-4-11.64-4-1.5 0-2.89.19-4.15.48L18.18 13.8 23.64 7zm-6.6 8.22L3.27 1.44 2 2.72l2.05 2.06C1.91 5.76.59 6.82.36 7l11.63 14.49.01.01.01-.01 3.9-4.86 3.32 3.32 1.27-1.27-3.46-3.46z' })
	  );
	};
	DeviceSignalWifiOff = (0, _pure2.default)(DeviceSignalWifiOff);
	DeviceSignalWifiOff.displayName = 'DeviceSignalWifiOff';
	DeviceSignalWifiOff.muiName = 'SvgIcon';
	
	exports.default = DeviceSignalWifiOff;

/***/ },
/* 1350 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceStorage = function DeviceStorage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 20h20v-4H2v4zm2-3h2v2H4v-2zM2 4v4h20V4H2zm4 3H4V5h2v2zm-4 7h20v-4H2v4zm2-3h2v2H4v-2z' })
	  );
	};
	DeviceStorage = (0, _pure2.default)(DeviceStorage);
	DeviceStorage.displayName = 'DeviceStorage';
	DeviceStorage.muiName = 'SvgIcon';
	
	exports.default = DeviceStorage;

/***/ },
/* 1351 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceUsb = function DeviceUsb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 7v4h1v2h-3V5h2l-3-4-3 4h2v8H8v-2.07c.7-.37 1.2-1.08 1.2-1.93 0-1.21-.99-2.2-2.2-2.2-1.21 0-2.2.99-2.2 2.2 0 .85.5 1.56 1.2 1.93V13c0 1.11.89 2 2 2h3v3.05c-.71.37-1.2 1.1-1.2 1.95 0 1.22.99 2.2 2.2 2.2 1.21 0 2.2-.98 2.2-2.2 0-.85-.49-1.58-1.2-1.95V15h3c1.11 0 2-.89 2-2v-2h1V7h-4z' })
	  );
	};
	DeviceUsb = (0, _pure2.default)(DeviceUsb);
	DeviceUsb.displayName = 'DeviceUsb';
	DeviceUsb.muiName = 'SvgIcon';
	
	exports.default = DeviceUsb;

/***/ },
/* 1352 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWallpaper = function DeviceWallpaper(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 4h7V2H4c-1.1 0-2 .9-2 2v7h2V4zm6 9l-4 5h12l-3-4-2.03 2.71L10 13zm7-4.5c0-.83-.67-1.5-1.5-1.5S14 7.67 14 8.5s.67 1.5 1.5 1.5S17 9.33 17 8.5zM20 2h-7v2h7v7h2V4c0-1.1-.9-2-2-2zm0 18h-7v2h7c1.1 0 2-.9 2-2v-7h-2v7zM4 13H2v7c0 1.1.9 2 2 2h7v-2H4v-7z' })
	  );
	};
	DeviceWallpaper = (0, _pure2.default)(DeviceWallpaper);
	DeviceWallpaper.displayName = 'DeviceWallpaper';
	DeviceWallpaper.muiName = 'SvgIcon';
	
	exports.default = DeviceWallpaper;

/***/ },
/* 1353 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWidgets = function DeviceWidgets(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 13v8h8v-8h-8zM3 21h8v-8H3v8zM3 3v8h8V3H3zm13.66-1.31L11 7.34 16.66 13l5.66-5.66-5.66-5.65z' })
	  );
	};
	DeviceWidgets = (0, _pure2.default)(DeviceWidgets);
	DeviceWidgets.displayName = 'DeviceWidgets';
	DeviceWidgets.muiName = 'SvgIcon';
	
	exports.default = DeviceWidgets;

/***/ },
/* 1354 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWifiLock = function DeviceWifiLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.5 9.5c.28 0 .55.04.81.08L24 6c-3.34-2.51-7.5-4-12-4S3.34 3.49 0 6l12 16 3.5-4.67V14.5c0-2.76 2.24-5 5-5zM23 16v-1.5c0-1.38-1.12-2.5-2.5-2.5S18 13.12 18 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z' })
	  );
	};
	DeviceWifiLock = (0, _pure2.default)(DeviceWifiLock);
	DeviceWifiLock.displayName = 'DeviceWifiLock';
	DeviceWifiLock.muiName = 'SvgIcon';
	
	exports.default = DeviceWifiLock;

/***/ },
/* 1355 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DeviceWifiTethering = function DeviceWifiTethering(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 11c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm6 2c0-3.31-2.69-6-6-6s-6 2.69-6 6c0 2.22 1.21 4.15 3 5.19l1-1.74c-1.19-.7-2-1.97-2-3.45 0-2.21 1.79-4 4-4s4 1.79 4 4c0 1.48-.81 2.75-2 3.45l1 1.74c1.79-1.04 3-2.97 3-5.19zM12 3C6.48 3 2 7.48 2 13c0 3.7 2.01 6.92 4.99 8.65l1-1.73C5.61 18.53 4 15.96 4 13c0-4.42 3.58-8 8-8s8 3.58 8 8c0 2.96-1.61 5.53-4 6.92l1 1.73c2.99-1.73 5-4.95 5-8.65 0-5.52-4.48-10-10-10z' })
	  );
	};
	DeviceWifiTethering = (0, _pure2.default)(DeviceWifiTethering);
	DeviceWifiTethering.displayName = 'DeviceWifiTethering';
	DeviceWifiTethering.muiName = 'SvgIcon';
	
	exports.default = DeviceWifiTethering;

/***/ },
/* 1356 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorAttachFile = function EditorAttachFile(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 6v11.5c0 2.21-1.79 4-4 4s-4-1.79-4-4V5c0-1.38 1.12-2.5 2.5-2.5s2.5 1.12 2.5 2.5v10.5c0 .55-.45 1-1 1s-1-.45-1-1V6H10v9.5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V5c0-2.21-1.79-4-4-4S7 2.79 7 5v12.5c0 3.04 2.46 5.5 5.5 5.5s5.5-2.46 5.5-5.5V6h-1.5z' })
	  );
	};
	EditorAttachFile = (0, _pure2.default)(EditorAttachFile);
	EditorAttachFile.displayName = 'EditorAttachFile';
	EditorAttachFile.muiName = 'SvgIcon';
	
	exports.default = EditorAttachFile;

/***/ },
/* 1357 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorAttachMoney = function EditorAttachMoney(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.13 2.5.6 3 1.48 3 2.41 0 .69-.49 1.79-2.7 1.79-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c1.95-.37 3.5-1.5 3.5-3.55 0-2.84-2.43-3.81-4.7-4.4z' })
	  );
	};
	EditorAttachMoney = (0, _pure2.default)(EditorAttachMoney);
	EditorAttachMoney.displayName = 'EditorAttachMoney';
	EditorAttachMoney.muiName = 'SvgIcon';
	
	exports.default = EditorAttachMoney;

/***/ },
/* 1358 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderAll = function EditorBorderAll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 3v18h18V3H3zm8 16H5v-6h6v6zm0-8H5V5h6v6zm8 8h-6v-6h6v6zm0-8h-6V5h6v6z' })
	  );
	};
	EditorBorderAll = (0, _pure2.default)(EditorBorderAll);
	EditorBorderAll.displayName = 'EditorBorderAll';
	EditorBorderAll.muiName = 'SvgIcon';
	
	exports.default = EditorBorderAll;

/***/ },
/* 1359 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderBottom = function EditorBorderBottom(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 11H7v2h2v-2zm4 4h-2v2h2v-2zM9 3H7v2h2V3zm4 8h-2v2h2v-2zM5 3H3v2h2V3zm8 4h-2v2h2V7zm4 4h-2v2h2v-2zm-4-8h-2v2h2V3zm4 0h-2v2h2V3zm2 10h2v-2h-2v2zm0 4h2v-2h-2v2zM5 7H3v2h2V7zm14-4v2h2V3h-2zm0 6h2V7h-2v2zM5 11H3v2h2v-2zM3 21h18v-2H3v2zm2-6H3v2h2v-2z' })
	  );
	};
	EditorBorderBottom = (0, _pure2.default)(EditorBorderBottom);
	EditorBorderBottom.displayName = 'EditorBorderBottom';
	EditorBorderBottom.muiName = 'SvgIcon';
	
	exports.default = EditorBorderBottom;

/***/ },
/* 1360 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderClear = function EditorBorderClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 5h2V3H7v2zm0 8h2v-2H7v2zm0 8h2v-2H7v2zm4-4h2v-2h-2v2zm0 4h2v-2h-2v2zm-8 0h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2v-2H3v2zm0-4h2V7H3v2zm0-4h2V3H3v2zm8 8h2v-2h-2v2zm8 4h2v-2h-2v2zm0-4h2v-2h-2v2zm0 8h2v-2h-2v2zm0-12h2V7h-2v2zm-8 0h2V7h-2v2zm8-6v2h2V3h-2zm-8 2h2V3h-2v2zm4 16h2v-2h-2v2zm0-8h2v-2h-2v2zm0-8h2V3h-2v2z' })
	  );
	};
	EditorBorderClear = (0, _pure2.default)(EditorBorderClear);
	EditorBorderClear.displayName = 'EditorBorderClear';
	EditorBorderClear.muiName = 'SvgIcon';
	
	exports.default = EditorBorderClear;

/***/ },
/* 1361 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderColor = function EditorBorderColor(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.75 7L14 3.25l-10 10V17h3.75l10-10zm2.96-2.96c.39-.39.39-1.02 0-1.41L18.37.29c-.39-.39-1.02-.39-1.41 0L15 2.25 18.75 6l1.96-1.96z' }),
	    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' })
	  );
	};
	EditorBorderColor = (0, _pure2.default)(EditorBorderColor);
	EditorBorderColor.displayName = 'EditorBorderColor';
	EditorBorderColor.muiName = 'SvgIcon';
	
	exports.default = EditorBorderColor;

/***/ },
/* 1362 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderHorizontal = function EditorBorderHorizontal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h2v-2H3v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zm4 4h2v-2H7v2zM5 3H3v2h2V3zm4 0H7v2h2V3zm8 0h-2v2h2V3zm-4 4h-2v2h2V7zm0-4h-2v2h2V3zm6 14h2v-2h-2v2zm-8 4h2v-2h-2v2zm-8-8h18v-2H3v2zM19 3v2h2V3h-2zm0 6h2V7h-2v2zm-8 8h2v-2h-2v2zm4 4h2v-2h-2v2zm4 0h2v-2h-2v2z' })
	  );
	};
	EditorBorderHorizontal = (0, _pure2.default)(EditorBorderHorizontal);
	EditorBorderHorizontal.displayName = 'EditorBorderHorizontal';
	EditorBorderHorizontal.muiName = 'SvgIcon';
	
	exports.default = EditorBorderHorizontal;

/***/ },
/* 1363 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderInner = function EditorBorderInner(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h2v-2H3v2zm4 0h2v-2H7v2zM5 7H3v2h2V7zM3 17h2v-2H3v2zM9 3H7v2h2V3zM5 3H3v2h2V3zm12 0h-2v2h2V3zm2 6h2V7h-2v2zm0-6v2h2V3h-2zm-4 18h2v-2h-2v2zM13 3h-2v8H3v2h8v8h2v-8h8v-2h-8V3zm6 18h2v-2h-2v2zm0-4h2v-2h-2v2z' })
	  );
	};
	EditorBorderInner = (0, _pure2.default)(EditorBorderInner);
	EditorBorderInner.displayName = 'EditorBorderInner';
	EditorBorderInner.muiName = 'SvgIcon';
	
	exports.default = EditorBorderInner;

/***/ },
/* 1364 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderLeft = function EditorBorderLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 21h2v-2h-2v2zm0-4h2v-2h-2v2zm0-12h2V3h-2v2zm0 4h2V7h-2v2zm0 4h2v-2h-2v2zm-4 8h2v-2H7v2zM7 5h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2V3H3v18zM19 9h2V7h-2v2zm-4 12h2v-2h-2v2zm4-4h2v-2h-2v2zm0-14v2h2V3h-2zm0 10h2v-2h-2v2zm0 8h2v-2h-2v2zm-4-8h2v-2h-2v2zm0-8h2V3h-2v2z' })
	  );
	};
	EditorBorderLeft = (0, _pure2.default)(EditorBorderLeft);
	EditorBorderLeft.displayName = 'EditorBorderLeft';
	EditorBorderLeft.muiName = 'SvgIcon';
	
	exports.default = EditorBorderLeft;

/***/ },
/* 1365 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderOuter = function EditorBorderOuter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v2h2V7zm0 4h-2v2h2v-2zm4 0h-2v2h2v-2zM3 3v18h18V3H3zm16 16H5V5h14v14zm-6-4h-2v2h2v-2zm-4-4H7v2h2v-2z' })
	  );
	};
	EditorBorderOuter = (0, _pure2.default)(EditorBorderOuter);
	EditorBorderOuter.displayName = 'EditorBorderOuter';
	EditorBorderOuter.muiName = 'SvgIcon';
	
	exports.default = EditorBorderOuter;

/***/ },
/* 1366 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderRight = function EditorBorderRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 21h2v-2H7v2zM3 5h2V3H3v2zm4 0h2V3H7v2zm0 8h2v-2H7v2zm-4 8h2v-2H3v2zm8 0h2v-2h-2v2zm-8-8h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2V7H3v2zm8 8h2v-2h-2v2zm4-4h2v-2h-2v2zm4-10v18h2V3h-2zm-4 18h2v-2h-2v2zm0-16h2V3h-2v2zm-4 8h2v-2h-2v2zm0-8h2V3h-2v2zm0 4h2V7h-2v2z' })
	  );
	};
	EditorBorderRight = (0, _pure2.default)(EditorBorderRight);
	EditorBorderRight.displayName = 'EditorBorderRight';
	EditorBorderRight.muiName = 'SvgIcon';
	
	exports.default = EditorBorderRight;

/***/ },
/* 1367 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderStyle = function EditorBorderStyle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 21h2v-2h-2v2zm4 0h2v-2h-2v2zM7 21h2v-2H7v2zm4 0h2v-2h-2v2zm8-4h2v-2h-2v2zm0-4h2v-2h-2v2zM3 3v18h2V5h16V3H3zm16 6h2V7h-2v2z' })
	  );
	};
	EditorBorderStyle = (0, _pure2.default)(EditorBorderStyle);
	EditorBorderStyle.displayName = 'EditorBorderStyle';
	EditorBorderStyle.muiName = 'SvgIcon';
	
	exports.default = EditorBorderStyle;

/***/ },
/* 1368 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderTop = function EditorBorderTop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 21h2v-2H7v2zm0-8h2v-2H7v2zm4 0h2v-2h-2v2zm0 8h2v-2h-2v2zm-8-4h2v-2H3v2zm0 4h2v-2H3v2zm0-8h2v-2H3v2zm0-4h2V7H3v2zm8 8h2v-2h-2v2zm8-8h2V7h-2v2zm0 4h2v-2h-2v2zM3 3v2h18V3H3zm16 14h2v-2h-2v2zm-4 4h2v-2h-2v2zM11 9h2V7h-2v2zm8 12h2v-2h-2v2zm-4-8h2v-2h-2v2z' })
	  );
	};
	EditorBorderTop = (0, _pure2.default)(EditorBorderTop);
	EditorBorderTop.displayName = 'EditorBorderTop';
	EditorBorderTop.muiName = 'SvgIcon';
	
	exports.default = EditorBorderTop;

/***/ },
/* 1369 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBorderVertical = function EditorBorderVertical(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9h2V7H3v2zm0-4h2V3H3v2zm4 16h2v-2H7v2zm0-8h2v-2H7v2zm-4 0h2v-2H3v2zm0 8h2v-2H3v2zm0-4h2v-2H3v2zM7 5h2V3H7v2zm12 12h2v-2h-2v2zm-8 4h2V3h-2v18zm8 0h2v-2h-2v2zm0-8h2v-2h-2v2zm0-10v2h2V3h-2zm0 6h2V7h-2v2zm-4-4h2V3h-2v2zm0 16h2v-2h-2v2zm0-8h2v-2h-2v2z' })
	  );
	};
	EditorBorderVertical = (0, _pure2.default)(EditorBorderVertical);
	EditorBorderVertical.displayName = 'EditorBorderVertical';
	EditorBorderVertical.muiName = 'SvgIcon';
	
	exports.default = EditorBorderVertical;

/***/ },
/* 1370 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorBubbleChart = function EditorBubbleChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '7.2', cy: '14.4', r: '3.2' }),
	    _react2.default.createElement('circle', { cx: '14.8', cy: '18', r: '2' }),
	    _react2.default.createElement('circle', { cx: '15.2', cy: '8.8', r: '4.8' })
	  );
	};
	EditorBubbleChart = (0, _pure2.default)(EditorBubbleChart);
	EditorBubbleChart.displayName = 'EditorBubbleChart';
	EditorBubbleChart.muiName = 'SvgIcon';
	
	exports.default = EditorBubbleChart;

/***/ },
/* 1371 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorDragHandle = function EditorDragHandle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 9H4v2h16V9zM4 15h16v-2H4v2z' })
	  );
	};
	EditorDragHandle = (0, _pure2.default)(EditorDragHandle);
	EditorDragHandle.displayName = 'EditorDragHandle';
	EditorDragHandle.muiName = 'SvgIcon';
	
	exports.default = EditorDragHandle;

/***/ },
/* 1372 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignCenter = function EditorFormatAlignCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 15v2h10v-2H7zm-4 6h18v-2H3v2zm0-8h18v-2H3v2zm4-6v2h10V7H7zM3 3v2h18V3H3z' })
	  );
	};
	EditorFormatAlignCenter = (0, _pure2.default)(EditorFormatAlignCenter);
	EditorFormatAlignCenter.displayName = 'EditorFormatAlignCenter';
	EditorFormatAlignCenter.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignCenter;

/***/ },
/* 1373 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignJustify = function EditorFormatAlignJustify(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18v-2H3v2zm0-4h18V7H3v2zm0-6v2h18V3H3z' })
	  );
	};
	EditorFormatAlignJustify = (0, _pure2.default)(EditorFormatAlignJustify);
	EditorFormatAlignJustify.displayName = 'EditorFormatAlignJustify';
	EditorFormatAlignJustify.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignJustify;

/***/ },
/* 1374 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignLeft = function EditorFormatAlignLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 15H3v2h12v-2zm0-8H3v2h12V7zM3 13h18v-2H3v2zm0 8h18v-2H3v2zM3 3v2h18V3H3z' })
	  );
	};
	EditorFormatAlignLeft = (0, _pure2.default)(EditorFormatAlignLeft);
	EditorFormatAlignLeft.displayName = 'EditorFormatAlignLeft';
	EditorFormatAlignLeft.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignLeft;

/***/ },
/* 1375 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatAlignRight = function EditorFormatAlignRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zm6-4h12v-2H9v2zm-6-4h18v-2H3v2zm6-4h12V7H9v2zM3 3v2h18V3H3z' })
	  );
	};
	EditorFormatAlignRight = (0, _pure2.default)(EditorFormatAlignRight);
	EditorFormatAlignRight.displayName = 'EditorFormatAlignRight';
	EditorFormatAlignRight.muiName = 'SvgIcon';
	
	exports.default = EditorFormatAlignRight;

/***/ },
/* 1376 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatBold = function EditorFormatBold(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.6 10.79c.97-.67 1.65-1.77 1.65-2.79 0-2.26-1.75-4-4-4H7v14h7.04c2.09 0 3.71-1.7 3.71-3.79 0-1.52-.86-2.82-2.15-3.42zM10 6.5h3c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5h-3v-3zm3.5 9H10v-3h3.5c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z' })
	  );
	};
	EditorFormatBold = (0, _pure2.default)(EditorFormatBold);
	EditorFormatBold.displayName = 'EditorFormatBold';
	EditorFormatBold.muiName = 'SvgIcon';
	
	exports.default = EditorFormatBold;

/***/ },
/* 1377 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatClear = function EditorFormatClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.27 5L2 6.27l6.97 6.97L6.5 19h3l1.57-3.66L16.73 21 18 19.73 3.55 5.27 3.27 5zM6 5v.18L8.82 8h2.4l-.72 1.68 2.1 2.1L14.21 8H20V5H6z' })
	  );
	};
	EditorFormatClear = (0, _pure2.default)(EditorFormatClear);
	EditorFormatClear.displayName = 'EditorFormatClear';
	EditorFormatClear.muiName = 'SvgIcon';
	
	exports.default = EditorFormatClear;

/***/ },
/* 1378 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatColorFill = function EditorFormatColorFill(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.56 8.94L7.62 0 6.21 1.41l2.38 2.38-5.15 5.15c-.59.59-.59 1.54 0 2.12l5.5 5.5c.29.29.68.44 1.06.44s.77-.15 1.06-.44l5.5-5.5c.59-.58.59-1.53 0-2.12zM5.21 10L10 5.21 14.79 10H5.21zM19 11.5s-2 2.17-2 3.5c0 1.1.9 2 2 2s2-.9 2-2c0-1.33-2-3.5-2-3.5z' }),
	    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' })
	  );
	};
	EditorFormatColorFill = (0, _pure2.default)(EditorFormatColorFill);
	EditorFormatColorFill.displayName = 'EditorFormatColorFill';
	EditorFormatColorFill.muiName = 'SvgIcon';
	
	exports.default = EditorFormatColorFill;

/***/ },
/* 1379 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatColorReset = function EditorFormatColorReset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 14c0-4-6-10.8-6-10.8s-1.33 1.51-2.73 3.52l8.59 8.59c.09-.42.14-.86.14-1.31zm-.88 3.12L12.5 12.5 5.27 5.27 4 6.55l3.32 3.32C6.55 11.32 6 12.79 6 14c0 3.31 2.69 6 6 6 1.52 0 2.9-.57 3.96-1.5l2.63 2.63 1.27-1.27-2.74-2.74z' })
	  );
	};
	EditorFormatColorReset = (0, _pure2.default)(EditorFormatColorReset);
	EditorFormatColorReset.displayName = 'EditorFormatColorReset';
	EditorFormatColorReset.muiName = 'SvgIcon';
	
	exports.default = EditorFormatColorReset;

/***/ },
/* 1380 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatColorText = function EditorFormatColorText(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { fillOpacity: '.36', d: 'M0 20h24v4H0z' }),
	    _react2.default.createElement('path', { d: 'M11 3L5.5 17h2.25l1.12-3h6.25l1.12 3h2.25L13 3h-2zm-1.38 9L12 5.67 14.38 12H9.62z' })
	  );
	};
	EditorFormatColorText = (0, _pure2.default)(EditorFormatColorText);
	EditorFormatColorText.displayName = 'EditorFormatColorText';
	EditorFormatColorText.muiName = 'SvgIcon';
	
	exports.default = EditorFormatColorText;

/***/ },
/* 1381 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatIndentDecrease = function EditorFormatIndentDecrease(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17h10v-2H11v2zm-8-5l4 4V8l-4 4zm0 9h18v-2H3v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
	  );
	};
	EditorFormatIndentDecrease = (0, _pure2.default)(EditorFormatIndentDecrease);
	EditorFormatIndentDecrease.displayName = 'EditorFormatIndentDecrease';
	EditorFormatIndentDecrease.muiName = 'SvgIcon';
	
	exports.default = EditorFormatIndentDecrease;

/***/ },
/* 1382 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatIndentIncrease = function EditorFormatIndentIncrease(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 21h18v-2H3v2zM3 8v8l4-4-4-4zm8 9h10v-2H11v2zM3 3v2h18V3H3zm8 6h10V7H11v2zm0 4h10v-2H11v2z' })
	  );
	};
	EditorFormatIndentIncrease = (0, _pure2.default)(EditorFormatIndentIncrease);
	EditorFormatIndentIncrease.displayName = 'EditorFormatIndentIncrease';
	EditorFormatIndentIncrease.muiName = 'SvgIcon';
	
	exports.default = EditorFormatIndentIncrease;

/***/ },
/* 1383 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatItalic = function EditorFormatItalic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 4v3h2.21l-3.42 8H6v3h8v-3h-2.21l3.42-8H18V4z' })
	  );
	};
	EditorFormatItalic = (0, _pure2.default)(EditorFormatItalic);
	EditorFormatItalic.displayName = 'EditorFormatItalic';
	EditorFormatItalic.muiName = 'SvgIcon';
	
	exports.default = EditorFormatItalic;

/***/ },
/* 1384 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatLineSpacing = function EditorFormatLineSpacing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 7h2.5L5 3.5 1.5 7H4v10H1.5L5 20.5 8.5 17H6V7zm4-2v2h12V5H10zm0 14h12v-2H10v2zm0-6h12v-2H10v2z' })
	  );
	};
	EditorFormatLineSpacing = (0, _pure2.default)(EditorFormatLineSpacing);
	EditorFormatLineSpacing.displayName = 'EditorFormatLineSpacing';
	EditorFormatLineSpacing.muiName = 'SvgIcon';
	
	exports.default = EditorFormatLineSpacing;

/***/ },
/* 1385 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatListBulleted = function EditorFormatListBulleted(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 10.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-6c-.83 0-1.5.67-1.5 1.5S3.17 7.5 4 7.5 5.5 6.83 5.5 6 4.83 4.5 4 4.5zm0 12c-.83 0-1.5.68-1.5 1.5s.68 1.5 1.5 1.5 1.5-.68 1.5-1.5-.67-1.5-1.5-1.5zM7 19h14v-2H7v2zm0-6h14v-2H7v2zm0-8v2h14V5H7z' })
	  );
	};
	EditorFormatListBulleted = (0, _pure2.default)(EditorFormatListBulleted);
	EditorFormatListBulleted.displayName = 'EditorFormatListBulleted';
	EditorFormatListBulleted.muiName = 'SvgIcon';
	
	exports.default = EditorFormatListBulleted;

/***/ },
/* 1386 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatListNumbered = function EditorFormatListNumbered(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 17h2v.5H3v1h1v.5H2v1h3v-4H2v1zm1-9h1V4H2v1h1v3zm-1 3h1.8L2 13.1v.9h3v-1H3.2L5 10.9V10H2v1zm5-6v2h14V5H7zm0 14h14v-2H7v2zm0-6h14v-2H7v2z' })
	  );
	};
	EditorFormatListNumbered = (0, _pure2.default)(EditorFormatListNumbered);
	EditorFormatListNumbered.displayName = 'EditorFormatListNumbered';
	EditorFormatListNumbered.muiName = 'SvgIcon';
	
	exports.default = EditorFormatListNumbered;

/***/ },
/* 1387 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatPaint = function EditorFormatPaint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4V3c0-.55-.45-1-1-1H5c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6h1v4H9v11c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-9h8V4h-3z' })
	  );
	};
	EditorFormatPaint = (0, _pure2.default)(EditorFormatPaint);
	EditorFormatPaint.displayName = 'EditorFormatPaint';
	EditorFormatPaint.muiName = 'SvgIcon';
	
	exports.default = EditorFormatPaint;

/***/ },
/* 1388 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatQuote = function EditorFormatQuote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 17h3l2-4V7H5v6h3zm8 0h3l2-4V7h-6v6h3z' })
	  );
	};
	EditorFormatQuote = (0, _pure2.default)(EditorFormatQuote);
	EditorFormatQuote.displayName = 'EditorFormatQuote';
	EditorFormatQuote.muiName = 'SvgIcon';
	
	exports.default = EditorFormatQuote;

/***/ },
/* 1389 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatShapes = function EditorFormatShapes(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 7V1h-6v2H7V1H1v6h2v10H1v6h6v-2h10v2h6v-6h-2V7h2zM3 3h2v2H3V3zm2 18H3v-2h2v2zm12-2H7v-2H5V7h2V5h10v2h2v10h-2v2zm4 2h-2v-2h2v2zM19 5V3h2v2h-2zm-5.27 9h-3.49l-.73 2H7.89l3.4-9h1.4l3.41 9h-1.63l-.74-2zm-3.04-1.26h2.61L12 8.91l-1.31 3.83z' })
	  );
	};
	EditorFormatShapes = (0, _pure2.default)(EditorFormatShapes);
	EditorFormatShapes.displayName = 'EditorFormatShapes';
	EditorFormatShapes.muiName = 'SvgIcon';
	
	exports.default = EditorFormatShapes;

/***/ },
/* 1390 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatSize = function EditorFormatSize(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 4v3h5v12h3V7h5V4H9zm-6 8h3v7h3v-7h3V9H3v3z' })
	  );
	};
	EditorFormatSize = (0, _pure2.default)(EditorFormatSize);
	EditorFormatSize.displayName = 'EditorFormatSize';
	EditorFormatSize.muiName = 'SvgIcon';
	
	exports.default = EditorFormatSize;

/***/ },
/* 1391 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatStrikethrough = function EditorFormatStrikethrough(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 19h4v-3h-4v3zM5 4v3h5v3h4V7h5V4H5zM3 14h18v-2H3v2z' })
	  );
	};
	EditorFormatStrikethrough = (0, _pure2.default)(EditorFormatStrikethrough);
	EditorFormatStrikethrough.displayName = 'EditorFormatStrikethrough';
	EditorFormatStrikethrough.muiName = 'SvgIcon';
	
	exports.default = EditorFormatStrikethrough;

/***/ },
/* 1392 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatTextdirectionLToR = function EditorFormatTextdirectionLToR(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 10v5h2V4h2v11h2V4h2V2H9C6.79 2 5 3.79 5 6s1.79 4 4 4zm12 8l-4-4v3H5v2h12v3l4-4z' })
	  );
	};
	EditorFormatTextdirectionLToR = (0, _pure2.default)(EditorFormatTextdirectionLToR);
	EditorFormatTextdirectionLToR.displayName = 'EditorFormatTextdirectionLToR';
	EditorFormatTextdirectionLToR.muiName = 'SvgIcon';
	
	exports.default = EditorFormatTextdirectionLToR;

/***/ },
/* 1393 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatTextdirectionRToL = function EditorFormatTextdirectionRToL(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 10v5h2V4h2v11h2V4h2V2h-8C7.79 2 6 3.79 6 6s1.79 4 4 4zm-2 7v-3l-4 4 4 4v-3h12v-2H8z' })
	  );
	};
	EditorFormatTextdirectionRToL = (0, _pure2.default)(EditorFormatTextdirectionRToL);
	EditorFormatTextdirectionRToL.displayName = 'EditorFormatTextdirectionRToL';
	EditorFormatTextdirectionRToL.muiName = 'SvgIcon';
	
	exports.default = EditorFormatTextdirectionRToL;

/***/ },
/* 1394 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFormatUnderlined = function EditorFormatUnderlined(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17c3.31 0 6-2.69 6-6V3h-2.5v8c0 1.93-1.57 3.5-3.5 3.5S8.5 12.93 8.5 11V3H6v8c0 3.31 2.69 6 6 6zm-7 2v2h14v-2H5z' })
	  );
	};
	EditorFormatUnderlined = (0, _pure2.default)(EditorFormatUnderlined);
	EditorFormatUnderlined.displayName = 'EditorFormatUnderlined';
	EditorFormatUnderlined.muiName = 'SvgIcon';
	
	exports.default = EditorFormatUnderlined;

/***/ },
/* 1395 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorFunctions = function EditorFunctions(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4H6v2l6.5 6L6 18v2h12v-3h-7l5-5-5-5h7z' })
	  );
	};
	EditorFunctions = (0, _pure2.default)(EditorFunctions);
	EditorFunctions.displayName = 'EditorFunctions';
	EditorFunctions.muiName = 'SvgIcon';
	
	exports.default = EditorFunctions;

/***/ },
/* 1396 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorHighlight = function EditorHighlight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 14l3 3v5h6v-5l3-3V9H6zm5-12h2v3h-2zM3.5 5.875L4.914 4.46l2.12 2.122L5.62 7.997zm13.46.71l2.123-2.12 1.414 1.414L18.375 8z' })
	  );
	};
	EditorHighlight = (0, _pure2.default)(EditorHighlight);
	EditorHighlight.displayName = 'EditorHighlight';
	EditorHighlight.muiName = 'SvgIcon';
	
	exports.default = EditorHighlight;

/***/ },
/* 1397 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertChart = function EditorInsertChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
	  );
	};
	EditorInsertChart = (0, _pure2.default)(EditorInsertChart);
	EditorInsertChart.displayName = 'EditorInsertChart';
	EditorInsertChart.muiName = 'SvgIcon';
	
	exports.default = EditorInsertChart;

/***/ },
/* 1398 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertComment = function EditorInsertComment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z' })
	  );
	};
	EditorInsertComment = (0, _pure2.default)(EditorInsertComment);
	EditorInsertComment.displayName = 'EditorInsertComment';
	EditorInsertComment.muiName = 'SvgIcon';
	
	exports.default = EditorInsertComment;

/***/ },
/* 1399 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertDriveFile = function EditorInsertDriveFile(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 2c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6H6zm7 7V3.5L18.5 9H13z' })
	  );
	};
	EditorInsertDriveFile = (0, _pure2.default)(EditorInsertDriveFile);
	EditorInsertDriveFile.displayName = 'EditorInsertDriveFile';
	EditorInsertDriveFile.muiName = 'SvgIcon';
	
	exports.default = EditorInsertDriveFile;

/***/ },
/* 1400 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertEmoticon = function EditorInsertEmoticon(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	EditorInsertEmoticon = (0, _pure2.default)(EditorInsertEmoticon);
	EditorInsertEmoticon.displayName = 'EditorInsertEmoticon';
	EditorInsertEmoticon.muiName = 'SvgIcon';
	
	exports.default = EditorInsertEmoticon;

/***/ },
/* 1401 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertInvitation = function EditorInsertInvitation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 12h-5v5h5v-5zM16 1v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2h-1V1h-2zm3 18H5V8h14v11z' })
	  );
	};
	EditorInsertInvitation = (0, _pure2.default)(EditorInsertInvitation);
	EditorInsertInvitation.displayName = 'EditorInsertInvitation';
	EditorInsertInvitation.muiName = 'SvgIcon';
	
	exports.default = EditorInsertInvitation;

/***/ },
/* 1402 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertLink = function EditorInsertLink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.9 12c0-1.71 1.39-3.1 3.1-3.1h4V7H7c-2.76 0-5 2.24-5 5s2.24 5 5 5h4v-1.9H7c-1.71 0-3.1-1.39-3.1-3.1zM8 13h8v-2H8v2zm9-6h-4v1.9h4c1.71 0 3.1 1.39 3.1 3.1s-1.39 3.1-3.1 3.1h-4V17h4c2.76 0 5-2.24 5-5s-2.24-5-5-5z' })
	  );
	};
	EditorInsertLink = (0, _pure2.default)(EditorInsertLink);
	EditorInsertLink.displayName = 'EditorInsertLink';
	EditorInsertLink.muiName = 'SvgIcon';
	
	exports.default = EditorInsertLink;

/***/ },
/* 1403 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorInsertPhoto = function EditorInsertPhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
	  );
	};
	EditorInsertPhoto = (0, _pure2.default)(EditorInsertPhoto);
	EditorInsertPhoto.displayName = 'EditorInsertPhoto';
	EditorInsertPhoto.muiName = 'SvgIcon';
	
	exports.default = EditorInsertPhoto;

/***/ },
/* 1404 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorLinearScale = function EditorLinearScale(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.5 9.5c-1.03 0-1.9.62-2.29 1.5h-2.92c-.39-.88-1.26-1.5-2.29-1.5s-1.9.62-2.29 1.5H6.79c-.39-.88-1.26-1.5-2.29-1.5C3.12 9.5 2 10.62 2 12s1.12 2.5 2.5 2.5c1.03 0 1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5s1.9-.62 2.29-1.5h2.92c.39.88 1.26 1.5 2.29 1.5 1.38 0 2.5-1.12 2.5-2.5s-1.12-2.5-2.5-2.5z' })
	  );
	};
	EditorLinearScale = (0, _pure2.default)(EditorLinearScale);
	EditorLinearScale.displayName = 'EditorLinearScale';
	EditorLinearScale.muiName = 'SvgIcon';
	
	exports.default = EditorLinearScale;

/***/ },
/* 1405 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMergeType = function EditorMergeType(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 20.41L18.41 19 15 15.59 13.59 17 17 20.41zM7.5 8H11v5.59L5.59 19 7 20.41l6-6V8h3.5L12 3.5 7.5 8z' })
	  );
	};
	EditorMergeType = (0, _pure2.default)(EditorMergeType);
	EditorMergeType.displayName = 'EditorMergeType';
	EditorMergeType.muiName = 'SvgIcon';
	
	exports.default = EditorMergeType;

/***/ },
/* 1406 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorModeComment = function EditorModeComment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.99 4c0-1.1-.89-2-1.99-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14l4 4-.01-18z' })
	  );
	};
	EditorModeComment = (0, _pure2.default)(EditorModeComment);
	EditorModeComment.displayName = 'EditorModeComment';
	EditorModeComment.muiName = 'SvgIcon';
	
	exports.default = EditorModeComment;

/***/ },
/* 1407 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorModeEdit = function EditorModeEdit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
	  );
	};
	EditorModeEdit = (0, _pure2.default)(EditorModeEdit);
	EditorModeEdit.displayName = 'EditorModeEdit';
	EditorModeEdit.muiName = 'SvgIcon';
	
	exports.default = EditorModeEdit;

/***/ },
/* 1408 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMonetizationOn = function EditorMonetizationOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1.41 16.09V20h-2.67v-1.93c-1.71-.36-3.16-1.46-3.27-3.4h1.96c.1 1.05.82 1.87 2.65 1.87 1.96 0 2.4-.98 2.4-1.59 0-.83-.44-1.61-2.67-2.14-2.48-.6-4.18-1.62-4.18-3.67 0-1.72 1.39-2.84 3.11-3.21V4h2.67v1.95c1.86.45 2.79 1.86 2.85 3.39H14.3c-.05-1.11-.64-1.87-2.22-1.87-1.5 0-2.4.68-2.4 1.64 0 .84.65 1.39 2.67 1.91s4.18 1.39 4.18 3.91c-.01 1.83-1.38 2.83-3.12 3.16z' })
	  );
	};
	EditorMonetizationOn = (0, _pure2.default)(EditorMonetizationOn);
	EditorMonetizationOn.displayName = 'EditorMonetizationOn';
	EditorMonetizationOn.muiName = 'SvgIcon';
	
	exports.default = EditorMonetizationOn;

/***/ },
/* 1409 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMoneyOff = function EditorMoneyOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.5 6.9c1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-.53.12-1.03.3-1.48.54l1.47 1.47c.41-.17.91-.27 1.51-.27zM5.33 4.06L4.06 5.33 7.5 8.77c0 2.08 1.56 3.21 3.91 3.91l3.51 3.51c-.34.48-1.05.91-2.42.91-2.06 0-2.87-.92-2.98-2.1h-2.2c.12 2.19 1.76 3.42 3.68 3.83V21h3v-2.15c.96-.18 1.82-.55 2.45-1.12l2.22 2.22 1.27-1.27L5.33 4.06z' })
	  );
	};
	EditorMoneyOff = (0, _pure2.default)(EditorMoneyOff);
	EditorMoneyOff.displayName = 'EditorMoneyOff';
	EditorMoneyOff.muiName = 'SvgIcon';
	
	exports.default = EditorMoneyOff;

/***/ },
/* 1410 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorMultilineChart = function EditorMultilineChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 6.92l-1.41-1.41-2.85 3.21C15.68 6.4 12.83 5 9.61 5 6.72 5 4.07 6.16 2 8l1.42 1.42C5.12 7.93 7.27 7 9.61 7c2.74 0 5.09 1.26 6.77 3.24l-2.88 3.24-4-4L2 16.99l1.5 1.5 6-6.01 4 4 4.05-4.55c.75 1.35 1.25 2.9 1.44 4.55H21c-.22-2.3-.95-4.39-2.04-6.14L22 6.92z' })
	  );
	};
	EditorMultilineChart = (0, _pure2.default)(EditorMultilineChart);
	EditorMultilineChart.displayName = 'EditorMultilineChart';
	EditorMultilineChart.muiName = 'SvgIcon';
	
	exports.default = EditorMultilineChart;

/***/ },
/* 1411 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorPieChartOutlined = function EditorPieChartOutlined(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zm1 2.07c3.61.45 6.48 3.33 6.93 6.93H13V4.07zM4 12c0-4.06 3.07-7.44 7-7.93v15.87c-3.93-.5-7-3.88-7-7.94zm9 7.93V13h6.93c-.45 3.61-3.32 6.48-6.93 6.93z' })
	  );
	};
	EditorPieChartOutlined = (0, _pure2.default)(EditorPieChartOutlined);
	EditorPieChartOutlined.displayName = 'EditorPieChartOutlined';
	EditorPieChartOutlined.muiName = 'SvgIcon';
	
	exports.default = EditorPieChartOutlined;

/***/ },
/* 1412 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorPieChart = function EditorPieChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 2v20c-5.07-.5-9-4.79-9-10s3.93-9.5 9-10zm2.03 0v8.99H22c-.47-4.74-4.24-8.52-8.97-8.99zm0 11.01V22c4.74-.47 8.5-4.25 8.97-8.99h-8.97z' })
	  );
	};
	EditorPieChart = (0, _pure2.default)(EditorPieChart);
	EditorPieChart.displayName = 'EditorPieChart';
	EditorPieChart.muiName = 'SvgIcon';
	
	exports.default = EditorPieChart;

/***/ },
/* 1413 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorPublish = function EditorPublish(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 4v2h14V4H5zm0 10h4v6h6v-6h4l-7-7-7 7z' })
	  );
	};
	EditorPublish = (0, _pure2.default)(EditorPublish);
	EditorPublish.displayName = 'EditorPublish';
	EditorPublish.muiName = 'SvgIcon';
	
	exports.default = EditorPublish;

/***/ },
/* 1414 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorShortText = function EditorShortText(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 9h16v2H4zm0 4h10v2H4z' })
	  );
	};
	EditorShortText = (0, _pure2.default)(EditorShortText);
	EditorShortText.displayName = 'EditorShortText';
	EditorShortText.muiName = 'SvgIcon';
	
	exports.default = EditorShortText;

/***/ },
/* 1415 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorShowChart = function EditorShowChart(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.5 18.49l6-6.01 4 4L22 6.92l-1.41-1.41-7.09 7.97-4-4L2 16.99z' })
	  );
	};
	EditorShowChart = (0, _pure2.default)(EditorShowChart);
	EditorShowChart.displayName = 'EditorShowChart';
	EditorShowChart.muiName = 'SvgIcon';
	
	exports.default = EditorShowChart;

/***/ },
/* 1416 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorSpaceBar = function EditorSpaceBar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 9v4H6V9H4v6h16V9z' })
	  );
	};
	EditorSpaceBar = (0, _pure2.default)(EditorSpaceBar);
	EditorSpaceBar.displayName = 'EditorSpaceBar';
	EditorSpaceBar.muiName = 'SvgIcon';
	
	exports.default = EditorSpaceBar;

/***/ },
/* 1417 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorStrikethroughS = function EditorStrikethroughS(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.24 8.75c-.26-.48-.39-1.03-.39-1.67 0-.61.13-1.16.4-1.67.26-.5.63-.93 1.11-1.29.48-.35 1.05-.63 1.7-.83.66-.19 1.39-.29 2.18-.29.81 0 1.54.11 2.21.34.66.22 1.23.54 1.69.94.47.4.83.88 1.08 1.43.25.55.38 1.15.38 1.81h-3.01c0-.31-.05-.59-.15-.85-.09-.27-.24-.49-.44-.68-.2-.19-.45-.33-.75-.44-.3-.1-.66-.16-1.06-.16-.39 0-.74.04-1.03.13-.29.09-.53.21-.72.36-.19.16-.34.34-.44.55-.1.21-.15.43-.15.66 0 .48.25.88.74 1.21.38.25.77.48 1.41.7H7.39c-.05-.08-.11-.17-.15-.25zM21 12v-2H3v2h9.62c.18.07.4.14.55.2.37.17.66.34.87.51.21.17.35.36.43.57.07.2.11.43.11.69 0 .23-.05.45-.14.66-.09.2-.23.38-.42.53-.19.15-.42.26-.71.35-.29.08-.63.13-1.01.13-.43 0-.83-.04-1.18-.13s-.66-.23-.91-.42c-.25-.19-.45-.44-.59-.75-.14-.31-.25-.76-.25-1.21H6.4c0 .55.08 1.13.24 1.58.16.45.37.85.65 1.21.28.35.6.66.98.92.37.26.78.48 1.22.65.44.17.9.3 1.38.39.48.08.96.13 1.44.13.8 0 1.53-.09 2.18-.28s1.21-.45 1.67-.79c.46-.34.82-.77 1.07-1.27s.38-1.07.38-1.71c0-.6-.1-1.14-.31-1.61-.05-.11-.11-.23-.17-.33H21z' })
	  );
	};
	EditorStrikethroughS = (0, _pure2.default)(EditorStrikethroughS);
	EditorStrikethroughS.displayName = 'EditorStrikethroughS';
	EditorStrikethroughS.muiName = 'SvgIcon';
	
	exports.default = EditorStrikethroughS;

/***/ },
/* 1418 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorTextFields = function EditorTextFields(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.5 4v3h5v12h3V7h5V4h-13zm19 5h-9v3h3v7h3v-7h3V9z' })
	  );
	};
	EditorTextFields = (0, _pure2.default)(EditorTextFields);
	EditorTextFields.displayName = 'EditorTextFields';
	EditorTextFields.muiName = 'SvgIcon';
	
	exports.default = EditorTextFields;

/***/ },
/* 1419 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorTitle = function EditorTitle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 4v3h5.5v12h3V7H19V4z' })
	  );
	};
	EditorTitle = (0, _pure2.default)(EditorTitle);
	EditorTitle.displayName = 'EditorTitle';
	EditorTitle.muiName = 'SvgIcon';
	
	exports.default = EditorTitle;

/***/ },
/* 1420 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorVerticalAlignBottom = function EditorVerticalAlignBottom(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 13h-3V3h-2v10H8l4 4 4-4zM4 19v2h16v-2H4z' })
	  );
	};
	EditorVerticalAlignBottom = (0, _pure2.default)(EditorVerticalAlignBottom);
	EditorVerticalAlignBottom.displayName = 'EditorVerticalAlignBottom';
	EditorVerticalAlignBottom.muiName = 'SvgIcon';
	
	exports.default = EditorVerticalAlignBottom;

/***/ },
/* 1421 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorVerticalAlignCenter = function EditorVerticalAlignCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 19h3v4h2v-4h3l-4-4-4 4zm8-14h-3V1h-2v4H8l4 4 4-4zM4 11v2h16v-2H4z' })
	  );
	};
	EditorVerticalAlignCenter = (0, _pure2.default)(EditorVerticalAlignCenter);
	EditorVerticalAlignCenter.displayName = 'EditorVerticalAlignCenter';
	EditorVerticalAlignCenter.muiName = 'SvgIcon';
	
	exports.default = EditorVerticalAlignCenter;

/***/ },
/* 1422 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorVerticalAlignTop = function EditorVerticalAlignTop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 11h3v10h2V11h3l-4-4-4 4zM4 3v2h16V3H4z' })
	  );
	};
	EditorVerticalAlignTop = (0, _pure2.default)(EditorVerticalAlignTop);
	EditorVerticalAlignTop.displayName = 'EditorVerticalAlignTop';
	EditorVerticalAlignTop.muiName = 'SvgIcon';
	
	exports.default = EditorVerticalAlignTop;

/***/ },
/* 1423 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var EditorWrapText = function EditorWrapText(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 19h6v-2H4v2zM20 5H4v2h16V5zm-3 6H4v2h13.25c1.1 0 2 .9 2 2s-.9 2-2 2H15v-2l-3 3 3 3v-2h2c2.21 0 4-1.79 4-4s-1.79-4-4-4z' })
	  );
	};
	EditorWrapText = (0, _pure2.default)(EditorWrapText);
	EditorWrapText.displayName = 'EditorWrapText';
	EditorWrapText.muiName = 'SvgIcon';
	
	exports.default = EditorWrapText;

/***/ },
/* 1424 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileAttachment = function FileAttachment(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 12.5C2 9.46 4.46 7 7.5 7H18c2.21 0 4 1.79 4 4s-1.79 4-4 4H9.5C8.12 15 7 13.88 7 12.5S8.12 10 9.5 10H17v2H9.41c-.55 0-.55 1 0 1H18c1.1 0 2-.9 2-2s-.9-2-2-2H7.5C5.57 9 4 10.57 4 12.5S5.57 16 7.5 16H17v2H7.5C4.46 18 2 15.54 2 12.5z' })
	  );
	};
	FileAttachment = (0, _pure2.default)(FileAttachment);
	FileAttachment.displayName = 'FileAttachment';
	FileAttachment.muiName = 'SvgIcon';
	
	exports.default = FileAttachment;

/***/ },
/* 1425 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudCircle = function FileCloudCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm4.5 14H8c-1.66 0-3-1.34-3-3s1.34-3 3-3l.14.01C8.58 8.28 10.13 7 12 7c2.21 0 4 1.79 4 4h.5c1.38 0 2.5 1.12 2.5 2.5S17.88 16 16.5 16z' })
	  );
	};
	FileCloudCircle = (0, _pure2.default)(FileCloudCircle);
	FileCloudCircle.displayName = 'FileCloudCircle';
	FileCloudCircle.muiName = 'SvgIcon';
	
	exports.default = FileCloudCircle;

/***/ },
/* 1426 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudDone = function FileCloudDone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM10 17l-3.5-3.5 1.41-1.41L10 14.17 15.18 9l1.41 1.41L10 17z' })
	  );
	};
	FileCloudDone = (0, _pure2.default)(FileCloudDone);
	FileCloudDone.displayName = 'FileCloudDone';
	FileCloudDone.muiName = 'SvgIcon';
	
	exports.default = FileCloudDone;

/***/ },
/* 1427 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudDownload = function FileCloudDownload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM17 13l-5 5-5-5h3V9h4v4h3z' })
	  );
	};
	FileCloudDownload = (0, _pure2.default)(FileCloudDownload);
	FileCloudDownload.displayName = 'FileCloudDownload';
	FileCloudDownload.muiName = 'SvgIcon';
	
	exports.default = FileCloudDownload;

/***/ },
/* 1428 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudOff = function FileCloudOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4c-1.48 0-2.85.43-4.01 1.17l1.46 1.46C10.21 6.23 11.08 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3 0 1.13-.64 2.11-1.56 2.62l1.45 1.45C23.16 18.16 24 16.68 24 15c0-2.64-2.05-4.78-4.65-4.96zM3 5.27l2.75 2.74C2.56 8.15 0 10.77 0 14c0 3.31 2.69 6 6 6h11.73l2 2L21 20.73 4.27 4 3 5.27zM7.73 10l8 8H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h1.73z' })
	  );
	};
	FileCloudOff = (0, _pure2.default)(FileCloudOff);
	FileCloudOff.displayName = 'FileCloudOff';
	FileCloudOff.muiName = 'SvgIcon';
	
	exports.default = FileCloudOff;

/***/ },
/* 1429 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudQueue = function FileCloudQueue(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4h.71C7.37 7.69 9.48 6 12 6c3.04 0 5.5 2.46 5.5 5.5v.5H19c1.66 0 3 1.34 3 3s-1.34 3-3 3z' })
	  );
	};
	FileCloudQueue = (0, _pure2.default)(FileCloudQueue);
	FileCloudQueue.displayName = 'FileCloudQueue';
	FileCloudQueue.muiName = 'SvgIcon';
	
	exports.default = FileCloudQueue;

/***/ },
/* 1430 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloudUpload = function FileCloudUpload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM14 13v4h-4v-4H7l5-5 5 5h-3z' })
	  );
	};
	FileCloudUpload = (0, _pure2.default)(FileCloudUpload);
	FileCloudUpload.displayName = 'FileCloudUpload';
	FileCloudUpload.muiName = 'SvgIcon';
	
	exports.default = FileCloudUpload;

/***/ },
/* 1431 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCloud = function FileCloud(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96z' })
	  );
	};
	FileCloud = (0, _pure2.default)(FileCloud);
	FileCloud.displayName = 'FileCloud';
	FileCloud.muiName = 'SvgIcon';
	
	exports.default = FileCloud;

/***/ },
/* 1432 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileCreateNewFolder = function FileCreateNewFolder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V8c0-1.11-.89-2-2-2zm-1 8h-3v3h-2v-3h-3v-2h3V9h2v3h3v2z' })
	  );
	};
	FileCreateNewFolder = (0, _pure2.default)(FileCreateNewFolder);
	FileCreateNewFolder.displayName = 'FileCreateNewFolder';
	FileCreateNewFolder.muiName = 'SvgIcon';
	
	exports.default = FileCreateNewFolder;

/***/ },
/* 1433 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFileDownload = function FileFileDownload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 9h-4V3H9v6H5l7 7 7-7zM5 18v2h14v-2H5z' })
	  );
	};
	FileFileDownload = (0, _pure2.default)(FileFileDownload);
	FileFileDownload.displayName = 'FileFileDownload';
	FileFileDownload.muiName = 'SvgIcon';
	
	exports.default = FileFileDownload;

/***/ },
/* 1434 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFileUpload = function FileFileUpload(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 16h6v-6h4l-7-7-7 7h4zm-4 2h14v2H5z' })
	  );
	};
	FileFileUpload = (0, _pure2.default)(FileFileUpload);
	FileFileUpload.displayName = 'FileFileUpload';
	FileFileUpload.muiName = 'SvgIcon';
	
	exports.default = FileFileUpload;

/***/ },
/* 1435 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFolderOpen = function FileFolderOpen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 12H4V8h16v10z' })
	  );
	};
	FileFolderOpen = (0, _pure2.default)(FileFolderOpen);
	FileFolderOpen.displayName = 'FileFolderOpen';
	FileFolderOpen.muiName = 'SvgIcon';
	
	exports.default = FileFolderOpen;

/***/ },
/* 1436 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFolderShared = function FileFolderShared(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-5 3c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm4 8h-8v-1c0-1.33 2.67-2 4-2s4 .67 4 2v1z' })
	  );
	};
	FileFolderShared = (0, _pure2.default)(FileFolderShared);
	FileFolderShared.displayName = 'FileFolderShared';
	FileFolderShared.muiName = 'SvgIcon';
	
	exports.default = FileFolderShared;

/***/ },
/* 1437 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var FileFolder = function FileFolder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2h-8l-2-2z' })
	  );
	};
	FileFolder = (0, _pure2.default)(FileFolder);
	FileFolder.displayName = 'FileFolder';
	FileFolder.muiName = 'SvgIcon';
	
	exports.default = FileFolder;

/***/ },
/* 1438 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareCastConnected = function HardwareCastConnected(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm18-7H5v1.63c3.96 1.28 7.09 4.41 8.37 8.37H19V7zM1 10v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11zm20-7H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	HardwareCastConnected = (0, _pure2.default)(HardwareCastConnected);
	HardwareCastConnected.displayName = 'HardwareCastConnected';
	HardwareCastConnected.muiName = 'SvgIcon';
	
	exports.default = HardwareCastConnected;

/***/ },
/* 1439 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareCast = function HardwareCast(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v3h2V5h18v14h-7v2h7c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM1 18v3h3c0-1.66-1.34-3-3-3zm0-4v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0-4v2c4.97 0 9 4.03 9 9h2c0-6.08-4.93-11-11-11z' })
	  );
	};
	HardwareCast = (0, _pure2.default)(HardwareCast);
	HardwareCast.displayName = 'HardwareCast';
	HardwareCast.muiName = 'SvgIcon';
	
	exports.default = HardwareCast;

/***/ },
/* 1440 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareComputer = function HardwareComputer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
	  );
	};
	HardwareComputer = (0, _pure2.default)(HardwareComputer);
	HardwareComputer.displayName = 'HardwareComputer';
	HardwareComputer.muiName = 'SvgIcon';
	
	exports.default = HardwareComputer;

/***/ },
/* 1441 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDesktopMac = function HardwareDesktopMac(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7l-2 3v1h8v-1l-2-3h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 12H3V4h18v10z' })
	  );
	};
	HardwareDesktopMac = (0, _pure2.default)(HardwareDesktopMac);
	HardwareDesktopMac.displayName = 'HardwareDesktopMac';
	HardwareDesktopMac.muiName = 'SvgIcon';
	
	exports.default = HardwareDesktopMac;

/***/ },
/* 1442 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDesktopWindows = function HardwareDesktopWindows(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h7v2H8v2h8v-2h-2v-2h7c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 14H3V4h18v12z' })
	  );
	};
	HardwareDesktopWindows = (0, _pure2.default)(HardwareDesktopWindows);
	HardwareDesktopWindows.displayName = 'HardwareDesktopWindows';
	HardwareDesktopWindows.muiName = 'SvgIcon';
	
	exports.default = HardwareDesktopWindows;

/***/ },
/* 1443 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDeveloperBoard = function HardwareDeveloperBoard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 9V7h-2V5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2v-2h-2V9h2zm-4 10H4V5h14v14zM6 13h5v4H6zm6-6h4v3h-4zM6 7h5v5H6zm6 4h4v6h-4z' })
	  );
	};
	HardwareDeveloperBoard = (0, _pure2.default)(HardwareDeveloperBoard);
	HardwareDeveloperBoard.displayName = 'HardwareDeveloperBoard';
	HardwareDeveloperBoard.muiName = 'SvgIcon';
	
	exports.default = HardwareDeveloperBoard;

/***/ },
/* 1444 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDeviceHub = function HardwareDeviceHub(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 16l-4-4V8.82C14.16 8.4 15 7.3 15 6c0-1.66-1.34-3-3-3S9 4.34 9 6c0 1.3.84 2.4 2 2.82V12l-4 4H3v5h5v-3.05l4-4.2 4 4.2V21h5v-5h-4z' })
	  );
	};
	HardwareDeviceHub = (0, _pure2.default)(HardwareDeviceHub);
	HardwareDeviceHub.displayName = 'HardwareDeviceHub';
	HardwareDeviceHub.muiName = 'SvgIcon';
	
	exports.default = HardwareDeviceHub;

/***/ },
/* 1445 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDevicesOther = function HardwareDevicesOther(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 6h18V4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h4v-2H3V6zm10 6H9v1.78c-.61.55-1 1.33-1 2.22s.39 1.67 1 2.22V20h4v-1.78c.61-.55 1-1.34 1-2.22s-.39-1.67-1-2.22V12zm-2 5.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM22 8h-6c-.5 0-1 .5-1 1v10c0 .5.5 1 1 1h6c.5 0 1-.5 1-1V9c0-.5-.5-1-1-1zm-1 10h-4v-8h4v8z' })
	  );
	};
	HardwareDevicesOther = (0, _pure2.default)(HardwareDevicesOther);
	HardwareDevicesOther.displayName = 'HardwareDevicesOther';
	HardwareDevicesOther.muiName = 'SvgIcon';
	
	exports.default = HardwareDevicesOther;

/***/ },
/* 1446 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareDock = function HardwareDock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 23h8v-2H8v2zm8-21.99L8 1c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM16 15H8V5h8v10z' })
	  );
	};
	HardwareDock = (0, _pure2.default)(HardwareDock);
	HardwareDock.displayName = 'HardwareDock';
	HardwareDock.muiName = 'SvgIcon';
	
	exports.default = HardwareDock;

/***/ },
/* 1447 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareGamepad = function HardwareGamepad(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 7.5V2H9v5.5l3 3 3-3zM7.5 9H2v6h5.5l3-3-3-3zM9 16.5V22h6v-5.5l-3-3-3 3zM16.5 9l-3 3 3 3H22V9h-5.5z' })
	  );
	};
	HardwareGamepad = (0, _pure2.default)(HardwareGamepad);
	HardwareGamepad.displayName = 'HardwareGamepad';
	HardwareGamepad.muiName = 'SvgIcon';
	
	exports.default = HardwareGamepad;

/***/ },
/* 1448 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareHeadsetMic = function HardwareHeadsetMic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h4v1h-7v2h6c1.66 0 3-1.34 3-3V10c0-4.97-4.03-9-9-9z' })
	  );
	};
	HardwareHeadsetMic = (0, _pure2.default)(HardwareHeadsetMic);
	HardwareHeadsetMic.displayName = 'HardwareHeadsetMic';
	HardwareHeadsetMic.muiName = 'SvgIcon';
	
	exports.default = HardwareHeadsetMic;

/***/ },
/* 1449 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareHeadset = function HardwareHeadset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1c-4.97 0-9 4.03-9 9v7c0 1.66 1.34 3 3 3h3v-8H5v-2c0-3.87 3.13-7 7-7s7 3.13 7 7v2h-4v8h3c1.66 0 3-1.34 3-3v-7c0-4.97-4.03-9-9-9z' })
	  );
	};
	HardwareHeadset = (0, _pure2.default)(HardwareHeadset);
	HardwareHeadset.displayName = 'HardwareHeadset';
	HardwareHeadset.muiName = 'SvgIcon';
	
	exports.default = HardwareHeadset;

/***/ },
/* 1450 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowLeft = function HardwareKeyboardArrowLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z' })
	  );
	};
	HardwareKeyboardArrowLeft = (0, _pure2.default)(HardwareKeyboardArrowLeft);
	HardwareKeyboardArrowLeft.displayName = 'HardwareKeyboardArrowLeft';
	HardwareKeyboardArrowLeft.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowLeft;

/***/ },
/* 1451 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardArrowRight = function HardwareKeyboardArrowRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z' })
	  );
	};
	HardwareKeyboardArrowRight = (0, _pure2.default)(HardwareKeyboardArrowRight);
	HardwareKeyboardArrowRight.displayName = 'HardwareKeyboardArrowRight';
	HardwareKeyboardArrowRight.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardArrowRight;

/***/ },
/* 1452 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardBackspace = function HardwareKeyboardBackspace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 11H6.83l3.58-3.59L9 6l-6 6 6 6 1.41-1.41L6.83 13H21z' })
	  );
	};
	HardwareKeyboardBackspace = (0, _pure2.default)(HardwareKeyboardBackspace);
	HardwareKeyboardBackspace.displayName = 'HardwareKeyboardBackspace';
	HardwareKeyboardBackspace.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardBackspace;

/***/ },
/* 1453 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardCapslock = function HardwareKeyboardCapslock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8.41L16.59 13 18 11.59l-6-6-6 6L7.41 13 12 8.41zM6 18h12v-2H6v2z' })
	  );
	};
	HardwareKeyboardCapslock = (0, _pure2.default)(HardwareKeyboardCapslock);
	HardwareKeyboardCapslock.displayName = 'HardwareKeyboardCapslock';
	HardwareKeyboardCapslock.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardCapslock;

/***/ },
/* 1454 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardHide = function HardwareKeyboardHide(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 3H4c-1.1 0-1.99.9-1.99 2L2 15c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 3h2v2h-2V6zm0 3h2v2h-2V9zM8 6h2v2H8V6zm0 3h2v2H8V9zm-1 2H5V9h2v2zm0-3H5V6h2v2zm9 7H8v-2h8v2zm0-4h-2V9h2v2zm0-3h-2V6h2v2zm3 3h-2V9h2v2zm0-3h-2V6h2v2zm-7 15l4-4H8l4 4z' })
	  );
	};
	HardwareKeyboardHide = (0, _pure2.default)(HardwareKeyboardHide);
	HardwareKeyboardHide.displayName = 'HardwareKeyboardHide';
	HardwareKeyboardHide.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardHide;

/***/ },
/* 1455 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardReturn = function HardwareKeyboardReturn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7z' })
	  );
	};
	HardwareKeyboardReturn = (0, _pure2.default)(HardwareKeyboardReturn);
	HardwareKeyboardReturn.displayName = 'HardwareKeyboardReturn';
	HardwareKeyboardReturn.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardReturn;

/***/ },
/* 1456 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardTab = function HardwareKeyboardTab(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.59 7.41L15.17 11H1v2h14.17l-3.59 3.59L13 18l6-6-6-6-1.41 1.41zM20 6v12h2V6h-2z' })
	  );
	};
	HardwareKeyboardTab = (0, _pure2.default)(HardwareKeyboardTab);
	HardwareKeyboardTab.displayName = 'HardwareKeyboardTab';
	HardwareKeyboardTab.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardTab;

/***/ },
/* 1457 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboardVoice = function HardwareKeyboardVoice(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 15c1.66 0 2.99-1.34 2.99-3L15 6c0-1.66-1.34-3-3-3S9 4.34 9 6v6c0 1.66 1.34 3 3 3zm5.3-3c0 3-2.54 5.1-5.3 5.1S6.7 15 6.7 12H5c0 3.42 2.72 6.23 6 6.72V22h2v-3.28c3.28-.48 6-3.3 6-6.72h-1.7z' })
	  );
	};
	HardwareKeyboardVoice = (0, _pure2.default)(HardwareKeyboardVoice);
	HardwareKeyboardVoice.displayName = 'HardwareKeyboardVoice';
	HardwareKeyboardVoice.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboardVoice;

/***/ },
/* 1458 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareKeyboard = function HardwareKeyboard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5H4c-1.1 0-1.99.9-1.99 2L2 17c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm-9 3h2v2h-2V8zm0 3h2v2h-2v-2zM8 8h2v2H8V8zm0 3h2v2H8v-2zm-1 2H5v-2h2v2zm0-3H5V8h2v2zm9 7H8v-2h8v2zm0-4h-2v-2h2v2zm0-3h-2V8h2v2zm3 3h-2v-2h2v2zm0-3h-2V8h2v2z' })
	  );
	};
	HardwareKeyboard = (0, _pure2.default)(HardwareKeyboard);
	HardwareKeyboard.displayName = 'HardwareKeyboard';
	HardwareKeyboard.muiName = 'SvgIcon';
	
	exports.default = HardwareKeyboard;

/***/ },
/* 1459 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptopChromebook = function HardwareLaptopChromebook(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 18V3H2v15H0v2h24v-2h-2zm-8 0h-4v-1h4v1zm6-3H4V5h16v10z' })
	  );
	};
	HardwareLaptopChromebook = (0, _pure2.default)(HardwareLaptopChromebook);
	HardwareLaptopChromebook.displayName = 'HardwareLaptopChromebook';
	HardwareLaptopChromebook.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptopChromebook;

/***/ },
/* 1460 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptopMac = function HardwareLaptopMac(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v11c0 1.1.9 2 2 2H0c0 1.1.9 2 2 2h20c1.1 0 2-.9 2-2h-4zM4 5h16v11H4V5zm8 14c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	HardwareLaptopMac = (0, _pure2.default)(HardwareLaptopMac);
	HardwareLaptopMac.displayName = 'HardwareLaptopMac';
	HardwareLaptopMac.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptopMac;

/***/ },
/* 1461 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptopWindows = function HardwareLaptopWindows(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18v-1c1.1 0 1.99-.9 1.99-2L22 5c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2v1H0v2h24v-2h-4zM4 5h16v10H4V5z' })
	  );
	};
	HardwareLaptopWindows = (0, _pure2.default)(HardwareLaptopWindows);
	HardwareLaptopWindows.displayName = 'HardwareLaptopWindows';
	HardwareLaptopWindows.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptopWindows;

/***/ },
/* 1462 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareLaptop = function HardwareLaptop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2H0v2h24v-2h-4zM4 6h16v10H4V6z' })
	  );
	};
	HardwareLaptop = (0, _pure2.default)(HardwareLaptop);
	HardwareLaptop.displayName = 'HardwareLaptop';
	HardwareLaptop.muiName = 'SvgIcon';
	
	exports.default = HardwareLaptop;

/***/ },
/* 1463 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareMemory = function HardwareMemory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 9H9v6h6V9zm-2 4h-2v-2h2v2zm8-2V9h-2V7c0-1.1-.9-2-2-2h-2V3h-2v2h-2V3H9v2H7c-1.1 0-2 .9-2 2v2H3v2h2v2H3v2h2v2c0 1.1.9 2 2 2h2v2h2v-2h2v2h2v-2h2c1.1 0 2-.9 2-2v-2h2v-2h-2v-2h2zm-4 6H7V7h10v10z' })
	  );
	};
	HardwareMemory = (0, _pure2.default)(HardwareMemory);
	HardwareMemory.displayName = 'HardwareMemory';
	HardwareMemory.muiName = 'SvgIcon';
	
	exports.default = HardwareMemory;

/***/ },
/* 1464 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareMouse = function HardwareMouse(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 1.07V9h7c0-4.08-3.05-7.44-7-7.93zM4 15c0 4.42 3.58 8 8 8s8-3.58 8-8v-4H4v4zm7-13.93C7.05 1.56 4 4.92 4 9h7V1.07z' })
	  );
	};
	HardwareMouse = (0, _pure2.default)(HardwareMouse);
	HardwareMouse.displayName = 'HardwareMouse';
	HardwareMouse.muiName = 'SvgIcon';
	
	exports.default = HardwareMouse;

/***/ },
/* 1465 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhoneAndroid = function HardwarePhoneAndroid(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 1H8C6.34 1 5 2.34 5 4v16c0 1.66 1.34 3 3 3h8c1.66 0 3-1.34 3-3V4c0-1.66-1.34-3-3-3zm-2 20h-4v-1h4v1zm3.25-3H6.75V4h10.5v14z' })
	  );
	};
	HardwarePhoneAndroid = (0, _pure2.default)(HardwarePhoneAndroid);
	HardwarePhoneAndroid.displayName = 'HardwarePhoneAndroid';
	HardwarePhoneAndroid.muiName = 'SvgIcon';
	
	exports.default = HardwarePhoneAndroid;

/***/ },
/* 1466 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhoneIphone = function HardwarePhoneIphone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 1h-8C6.12 1 5 2.12 5 3.5v17C5 21.88 6.12 23 7.5 23h8c1.38 0 2.5-1.12 2.5-2.5v-17C18 2.12 16.88 1 15.5 1zm-4 21c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5-4H7V4h9v14z' })
	  );
	};
	HardwarePhoneIphone = (0, _pure2.default)(HardwarePhoneIphone);
	HardwarePhoneIphone.displayName = 'HardwarePhoneIphone';
	HardwarePhoneIphone.muiName = 'SvgIcon';
	
	exports.default = HardwarePhoneIphone;

/***/ },
/* 1467 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhonelinkOff = function HardwarePhonelinkOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 6V4H6.82l2 2H22zM1.92 1.65L.65 2.92l1.82 1.82C2.18 5.08 2 5.52 2 6v11H0v3h17.73l2.35 2.35 1.27-1.27L3.89 3.62 1.92 1.65zM4 6.27L14.73 17H4V6.27zM23 8h-6c-.55 0-1 .45-1 1v4.18l2 2V10h4v7h-2.18l3 3H23c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1z' })
	  );
	};
	HardwarePhonelinkOff = (0, _pure2.default)(HardwarePhonelinkOff);
	HardwarePhonelinkOff.displayName = 'HardwarePhonelinkOff';
	HardwarePhonelinkOff.muiName = 'SvgIcon';
	
	exports.default = HardwarePhonelinkOff;

/***/ },
/* 1468 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePhonelink = function HardwarePhonelink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6h18V4H4c-1.1 0-2 .9-2 2v11H0v3h14v-3H4V6zm19 2h-6c-.55 0-1 .45-1 1v10c0 .55.45 1 1 1h6c.55 0 1-.45 1-1V9c0-.55-.45-1-1-1zm-1 9h-4v-7h4v7z' })
	  );
	};
	HardwarePhonelink = (0, _pure2.default)(HardwarePhonelink);
	HardwarePhonelink.displayName = 'HardwarePhonelink';
	HardwarePhonelink.muiName = 'SvgIcon';
	
	exports.default = HardwarePhonelink;

/***/ },
/* 1469 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwarePowerInput = function HardwarePowerInput(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 9v2h19V9H2zm0 6h5v-2H2v2zm7 0h5v-2H9v2zm7 0h5v-2h-5v2z' })
	  );
	};
	HardwarePowerInput = (0, _pure2.default)(HardwarePowerInput);
	HardwarePowerInput.displayName = 'HardwarePowerInput';
	HardwarePowerInput.muiName = 'SvgIcon';
	
	exports.default = HardwarePowerInput;

/***/ },
/* 1470 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareRouter = function HardwareRouter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.2 5.9l.8-.8C19.6 3.7 17.8 3 16 3s-3.6.7-5 2.1l.8.8C13 4.8 14.5 4.2 16 4.2s3 .6 4.2 1.7zm-.9.8c-.9-.9-2.1-1.4-3.3-1.4s-2.4.5-3.3 1.4l.8.8c.7-.7 1.6-1 2.5-1 .9 0 1.8.3 2.5 1l.8-.8zM19 13h-2V9h-2v4H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM8 18H6v-2h2v2zm3.5 0h-2v-2h2v2zm3.5 0h-2v-2h2v2z' })
	  );
	};
	HardwareRouter = (0, _pure2.default)(HardwareRouter);
	HardwareRouter.displayName = 'HardwareRouter';
	HardwareRouter.muiName = 'SvgIcon';
	
	exports.default = HardwareRouter;

/***/ },
/* 1471 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareScanner = function HardwareScanner(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.8 10.7L4.2 5l-.7 1.9L17.6 12H5c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-5.5c0-.8-.5-1.6-1.2-1.8zM7 17H5v-2h2v2zm12 0H9v-2h10v2z' })
	  );
	};
	HardwareScanner = (0, _pure2.default)(HardwareScanner);
	HardwareScanner.displayName = 'HardwareScanner';
	HardwareScanner.muiName = 'SvgIcon';
	
	exports.default = HardwareScanner;

/***/ },
/* 1472 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSecurity = function HardwareSecurity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 1L3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm0 10.99h7c-.53 4.12-3.28 7.79-7 8.94V12H5V6.3l7-3.11v8.8z' })
	  );
	};
	HardwareSecurity = (0, _pure2.default)(HardwareSecurity);
	HardwareSecurity.displayName = 'HardwareSecurity';
	HardwareSecurity.muiName = 'SvgIcon';
	
	exports.default = HardwareSecurity;

/***/ },
/* 1473 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSimCard = function HardwareSimCard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.99 4c0-1.1-.89-2-1.99-2h-8L4 8v12c0 1.1.9 2 2 2h12.01c1.1 0 1.99-.9 1.99-2l-.01-16zM9 19H7v-2h2v2zm8 0h-2v-2h2v2zm-8-4H7v-4h2v4zm4 4h-2v-4h2v4zm0-6h-2v-2h2v2zm4 2h-2v-4h2v4z' })
	  );
	};
	HardwareSimCard = (0, _pure2.default)(HardwareSimCard);
	HardwareSimCard.displayName = 'HardwareSimCard';
	HardwareSimCard.muiName = 'SvgIcon';
	
	exports.default = HardwareSimCard;

/***/ },
/* 1474 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSmartphone = function HardwareSmartphone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14z' })
	  );
	};
	HardwareSmartphone = (0, _pure2.default)(HardwareSmartphone);
	HardwareSmartphone.displayName = 'HardwareSmartphone';
	HardwareSmartphone.muiName = 'SvgIcon';
	
	exports.default = HardwareSmartphone;

/***/ },
/* 1475 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSpeakerGroup = function HardwareSpeakerGroup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.2 1H9.8C8.81 1 8 1.81 8 2.8v14.4c0 .99.81 1.79 1.8 1.79l8.4.01c.99 0 1.8-.81 1.8-1.8V2.8c0-.99-.81-1.8-1.8-1.8zM14 3c1.1 0 2 .89 2 2s-.9 2-2 2-2-.89-2-2 .9-2 2-2zm0 13.5c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' }),
	    _react2.default.createElement('circle', { cx: '14', cy: '12.5', r: '2.5' }),
	    _react2.default.createElement('path', { d: 'M6 5H4v16c0 1.1.89 2 2 2h10v-2H6V5z' })
	  );
	};
	HardwareSpeakerGroup = (0, _pure2.default)(HardwareSpeakerGroup);
	HardwareSpeakerGroup.displayName = 'HardwareSpeakerGroup';
	HardwareSpeakerGroup.muiName = 'SvgIcon';
	
	exports.default = HardwareSpeakerGroup;

/***/ },
/* 1476 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareSpeaker = function HardwareSpeaker(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 2H7c-1.1 0-2 .9-2 2v16c0 1.1.9 1.99 2 1.99L17 22c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 2c1.1 0 2 .9 2 2s-.9 2-2 2c-1.11 0-2-.9-2-2s.89-2 2-2zm0 16c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	HardwareSpeaker = (0, _pure2.default)(HardwareSpeaker);
	HardwareSpeaker.displayName = 'HardwareSpeaker';
	HardwareSpeaker.muiName = 'SvgIcon';
	
	exports.default = HardwareSpeaker;

/***/ },
/* 1477 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTabletAndroid = function HardwareTabletAndroid(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 0H6C4.34 0 3 1.34 3 3v18c0 1.66 1.34 3 3 3h12c1.66 0 3-1.34 3-3V3c0-1.66-1.34-3-3-3zm-4 22h-4v-1h4v1zm5.25-3H4.75V3h14.5v16z' })
	  );
	};
	HardwareTabletAndroid = (0, _pure2.default)(HardwareTabletAndroid);
	HardwareTabletAndroid.displayName = 'HardwareTabletAndroid';
	HardwareTabletAndroid.muiName = 'SvgIcon';
	
	exports.default = HardwareTabletAndroid;

/***/ },
/* 1478 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTabletMac = function HardwareTabletMac(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.5 0h-14C3.12 0 2 1.12 2 2.5v19C2 22.88 3.12 24 4.5 24h14c1.38 0 2.5-1.12 2.5-2.5v-19C21 1.12 19.88 0 18.5 0zm-7 23c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7.5-4H4V3h15v16z' })
	  );
	};
	HardwareTabletMac = (0, _pure2.default)(HardwareTabletMac);
	HardwareTabletMac.displayName = 'HardwareTabletMac';
	HardwareTabletMac.muiName = 'SvgIcon';
	
	exports.default = HardwareTabletMac;

/***/ },
/* 1479 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTablet = function HardwareTablet(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 4H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 1.99-.9 1.99-2L23 6c0-1.1-.9-2-2-2zm-2 14H5V6h14v12z' })
	  );
	};
	HardwareTablet = (0, _pure2.default)(HardwareTablet);
	HardwareTablet.displayName = 'HardwareTablet';
	HardwareTablet.muiName = 'SvgIcon';
	
	exports.default = HardwareTablet;

/***/ },
/* 1480 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareToys = function HardwareToys(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 12c0-3 2.5-5.5 5.5-5.5S23 9 23 12H12zm0 0c0 3-2.5 5.5-5.5 5.5S1 15 1 12h11zm0 0c-3 0-5.5-2.5-5.5-5.5S9 1 12 1v11zm0 0c3 0 5.5 2.5 5.5 5.5S15 23 12 23V12z' })
	  );
	};
	HardwareToys = (0, _pure2.default)(HardwareToys);
	HardwareToys.displayName = 'HardwareToys';
	HardwareToys.muiName = 'SvgIcon';
	
	exports.default = HardwareToys;

/***/ },
/* 1481 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareTv = function HardwareTv(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.1-.9-2-2-2zm0 14H3V5h18v12z' })
	  );
	};
	HardwareTv = (0, _pure2.default)(HardwareTv);
	HardwareTv.displayName = 'HardwareTv';
	HardwareTv.muiName = 'SvgIcon';
	
	exports.default = HardwareTv;

/***/ },
/* 1482 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareVideogameAsset = function HardwareVideogameAsset(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-10 7H8v3H6v-3H3v-2h3V8h2v3h3v2zm4.5 2c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4-3c-.83 0-1.5-.67-1.5-1.5S18.67 9 19.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	HardwareVideogameAsset = (0, _pure2.default)(HardwareVideogameAsset);
	HardwareVideogameAsset.displayName = 'HardwareVideogameAsset';
	HardwareVideogameAsset.muiName = 'SvgIcon';
	
	exports.default = HardwareVideogameAsset;

/***/ },
/* 1483 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var HardwareWatch = function HardwareWatch(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12c0-2.54-1.19-4.81-3.04-6.27L16 0H8l-.95 5.73C5.19 7.19 4 9.45 4 12s1.19 4.81 3.05 6.27L8 24h8l.96-5.73C18.81 16.81 20 14.54 20 12zM6 12c0-3.31 2.69-6 6-6s6 2.69 6 6-2.69 6-6 6-6-2.69-6-6z' })
	  );
	};
	HardwareWatch = (0, _pure2.default)(HardwareWatch);
	HardwareWatch.displayName = 'HardwareWatch';
	HardwareWatch.muiName = 'SvgIcon';
	
	exports.default = HardwareWatch;

/***/ },
/* 1484 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAddAPhoto = function ImageAddAPhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 4V1h2v3h3v2H5v3H3V6H0V4h3zm3 6V7h3V4h7l1.83 2H21c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2V10h3zm7 9c2.76 0 5-2.24 5-5s-2.24-5-5-5-5 2.24-5 5 2.24 5 5 5zm-3.2-5c0 1.77 1.43 3.2 3.2 3.2s3.2-1.43 3.2-3.2-1.43-3.2-3.2-3.2-3.2 1.43-3.2 3.2z' })
	  );
	};
	ImageAddAPhoto = (0, _pure2.default)(ImageAddAPhoto);
	ImageAddAPhoto.displayName = 'ImageAddAPhoto';
	ImageAddAPhoto.muiName = 'SvgIcon';
	
	exports.default = ImageAddAPhoto;

/***/ },
/* 1485 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAddToPhotos = function ImageAddToPhotos(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-1 9h-4v4h-2v-4H9V9h4V5h2v4h4v2z' })
	  );
	};
	ImageAddToPhotos = (0, _pure2.default)(ImageAddToPhotos);
	ImageAddToPhotos.displayName = 'ImageAddToPhotos';
	ImageAddToPhotos.muiName = 'SvgIcon';
	
	exports.default = ImageAddToPhotos;

/***/ },
/* 1486 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAdjust = function ImageAdjust(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm3-8c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z' })
	  );
	};
	ImageAdjust = (0, _pure2.default)(ImageAdjust);
	ImageAdjust.displayName = 'ImageAdjust';
	ImageAdjust.muiName = 'SvgIcon';
	
	exports.default = ImageAdjust;

/***/ },
/* 1487 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAssistantPhoto = function ImageAssistantPhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.4 6L14 4H5v17h2v-7h5.6l.4 2h7V6z' })
	  );
	};
	ImageAssistantPhoto = (0, _pure2.default)(ImageAssistantPhoto);
	ImageAssistantPhoto.displayName = 'ImageAssistantPhoto';
	ImageAssistantPhoto.muiName = 'SvgIcon';
	
	exports.default = ImageAssistantPhoto;

/***/ },
/* 1488 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAssistant = function ImageAssistant(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5.12 10.88L12 17l-1.88-4.12L6 11l4.12-1.88L12 5l1.88 4.12L18 11l-4.12 1.88z' })
	  );
	};
	ImageAssistant = (0, _pure2.default)(ImageAssistant);
	ImageAssistant.displayName = 'ImageAssistant';
	ImageAssistant.muiName = 'SvgIcon';
	
	exports.default = ImageAssistant;

/***/ },
/* 1489 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageAudiotrack = function ImageAudiotrack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3v9.28c-.47-.17-.97-.28-1.5-.28C8.01 12 6 14.01 6 16.5S8.01 21 10.5 21c2.31 0 4.2-1.75 4.45-4H15V6h4V3h-7z' })
	  );
	};
	ImageAudiotrack = (0, _pure2.default)(ImageAudiotrack);
	ImageAudiotrack.displayName = 'ImageAudiotrack';
	ImageAudiotrack.muiName = 'SvgIcon';
	
	exports.default = ImageAudiotrack;

/***/ },
/* 1490 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurCircular = function ImageBlurCircular(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM7 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-3-3c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm3-6c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-1.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm3 6c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-4c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm2-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-3.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1z' })
	  );
	};
	ImageBlurCircular = (0, _pure2.default)(ImageBlurCircular);
	ImageBlurCircular.displayName = 'ImageBlurCircular';
	ImageBlurCircular.muiName = 'SvgIcon';
	
	exports.default = ImageBlurCircular;

/***/ },
/* 1491 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurLinear = function ImageBlurLinear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 17.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 13c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zM3 21h18v-2H3v2zM5 9.5c.83 0 1.5-.67 1.5-1.5S5.83 6.5 5 6.5 3.5 7.17 3.5 8 4.17 9.5 5 9.5zm0 4c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5.67 1.5 1.5 1.5zM9 17c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8-.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM3 3v2h18V3H3zm14 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm0 4c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM13 9c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1z' })
	  );
	};
	ImageBlurLinear = (0, _pure2.default)(ImageBlurLinear);
	ImageBlurLinear.displayName = 'ImageBlurLinear';
	ImageBlurLinear.muiName = 'SvgIcon';
	
	exports.default = ImageBlurLinear;

/***/ },
/* 1492 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurOff = function ImageBlurOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-.2 4.48l.2.02c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5-1.5.67-1.5 1.5l.02.2c.09.67.61 1.19 1.28 1.28zM14 3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-4 0c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm11 7c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm8 8c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-4c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm-4 13.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM2.5 5.27l3.78 3.78L6 9c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l2.81 2.81c-.71.11-1.25.73-1.25 1.47 0 .83.67 1.5 1.5 1.5.74 0 1.36-.54 1.47-1.25l2.81 2.81c-.09-.03-.18-.06-.28-.06-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1c0-.1-.03-.19-.06-.28l3.78 3.78L20 20.23 3.77 4 2.5 5.27zM10 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm11-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zM3 9.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 11c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3-3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5z' })
	  );
	};
	ImageBlurOff = (0, _pure2.default)(ImageBlurOff);
	ImageBlurOff.displayName = 'ImageBlurOff';
	ImageBlurOff.muiName = 'SvgIcon';
	
	exports.default = ImageBlurOff;

/***/ },
/* 1493 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBlurOn = function ImageBlurOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 13c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm-3 .5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM6 5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm15 5.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM14 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0-3.5c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zm-11 10c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm7 7c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm0-17c.28 0 .5-.22.5-.5s-.22-.5-.5-.5-.5.22-.5.5.22.5.5.5zM10 7c.55 0 1-.45 1-1s-.45-1-1-1-1 .45-1 1 .45 1 1 1zm0 5.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm8 .5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-8c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0-4c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm3 8.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zM14 17c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm0 3.5c-.28 0-.5.22-.5.5s.22.5.5.5.5-.22.5-.5-.22-.5-.5-.5zm-4-12c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0 8.5c-.55 0-1 .45-1 1s.45 1 1 1 1-.45 1-1-.45-1-1-1zm4-4.5c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5zm0-4c-.83 0-1.5.67-1.5 1.5s.67 1.5 1.5 1.5 1.5-.67 1.5-1.5-.67-1.5-1.5-1.5z' })
	  );
	};
	ImageBlurOn = (0, _pure2.default)(ImageBlurOn);
	ImageBlurOn.displayName = 'ImageBlurOn';
	ImageBlurOn.muiName = 'SvgIcon';
	
	exports.default = ImageBlurOn;

/***/ },
/* 1494 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness1 = function ImageBrightness1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '10' })
	  );
	};
	ImageBrightness1 = (0, _pure2.default)(ImageBrightness1);
	ImageBrightness1.displayName = 'ImageBrightness1';
	ImageBrightness1.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness1;

/***/ },
/* 1495 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness2 = function ImageBrightness2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 2c-1.82 0-3.53.5-5 1.35C7.99 5.08 10 8.3 10 12s-2.01 6.92-5 8.65C6.47 21.5 8.18 22 10 22c5.52 0 10-4.48 10-10S15.52 2 10 2z' })
	  );
	};
	ImageBrightness2 = (0, _pure2.default)(ImageBrightness2);
	ImageBrightness2.displayName = 'ImageBrightness2';
	ImageBrightness2.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness2;

/***/ },
/* 1496 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness3 = function ImageBrightness3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 2c-1.05 0-2.05.16-3 .46 4.06 1.27 7 5.06 7 9.54 0 4.48-2.94 8.27-7 9.54.95.3 1.95.46 3 .46 5.52 0 10-4.48 10-10S14.52 2 9 2z' })
	  );
	};
	ImageBrightness3 = (0, _pure2.default)(ImageBrightness3);
	ImageBrightness3.displayName = 'ImageBrightness3';
	ImageBrightness3.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness3;

/***/ },
/* 1497 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness4 = function ImageBrightness4(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-.89 0-1.74-.2-2.5-.55C11.56 16.5 13 14.42 13 12s-1.44-4.5-3.5-5.45C10.26 6.2 11.11 6 12 6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
	  );
	};
	ImageBrightness4 = (0, _pure2.default)(ImageBrightness4);
	ImageBrightness4.displayName = 'ImageBrightness4';
	ImageBrightness4.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness4;

/***/ },
/* 1498 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness5 = function ImageBrightness5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
	  );
	};
	ImageBrightness5 = (0, _pure2.default)(ImageBrightness5);
	ImageBrightness5.displayName = 'ImageBrightness5';
	ImageBrightness5.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness5;

/***/ },
/* 1499 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness6 = function ImageBrightness6(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.31L23.31 12 20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69zM12 18V6c3.31 0 6 2.69 6 6s-2.69 6-6 6z' })
	  );
	};
	ImageBrightness6 = (0, _pure2.default)(ImageBrightness6);
	ImageBrightness6.displayName = 'ImageBrightness6';
	ImageBrightness6.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness6;

/***/ },
/* 1500 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrightness7 = function ImageBrightness7(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8.69V4h-4.69L12 .69 8.69 4H4v4.69L.69 12 4 15.31V20h4.69L12 23.31 15.31 20H20v-4.69L23.31 12 20 8.69zM12 18c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6zm0-10c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4z' })
	  );
	};
	ImageBrightness7 = (0, _pure2.default)(ImageBrightness7);
	ImageBrightness7.displayName = 'ImageBrightness7';
	ImageBrightness7.muiName = 'SvgIcon';
	
	exports.default = ImageBrightness7;

/***/ },
/* 1501 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrokenImage = function ImageBrokenImage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5v6.59l-3-3.01-4 4.01-4-4-4 4-3-3.01V5c0-1.1.9-2 2-2h14c1.1 0 2 .9 2 2zm-3 6.42l3 3.01V19c0 1.1-.9 2-2 2H5c-1.1 0-2-.9-2-2v-6.58l3 2.99 4-4 4 4 4-3.99z' })
	  );
	};
	ImageBrokenImage = (0, _pure2.default)(ImageBrokenImage);
	ImageBrokenImage.displayName = 'ImageBrokenImage';
	ImageBrokenImage.muiName = 'SvgIcon';
	
	exports.default = ImageBrokenImage;

/***/ },
/* 1502 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBrush = function ImageBrush(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 14c-1.66 0-3 1.34-3 3 0 1.31-1.16 2-2 2 .92 1.22 2.49 2 4 2 2.21 0 4-1.79 4-4 0-1.66-1.34-3-3-3zm13.71-9.37l-1.34-1.34c-.39-.39-1.02-.39-1.41 0L9 12.25 11.75 15l8.96-8.96c.39-.39.39-1.02 0-1.41z' })
	  );
	};
	ImageBrush = (0, _pure2.default)(ImageBrush);
	ImageBrush.displayName = 'ImageBrush';
	ImageBrush.muiName = 'SvgIcon';
	
	exports.default = ImageBrush;

/***/ },
/* 1503 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageBurstMode = function ImageBurstMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 5h2v14H1zm4 0h2v14H5zm17 0H10c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h12c.55 0 1-.45 1-1V6c0-.55-.45-1-1-1zM11 17l2.5-3.15L15.29 16l2.5-3.22L21 17H11z' })
	  );
	};
	ImageBurstMode = (0, _pure2.default)(ImageBurstMode);
	ImageBurstMode.displayName = 'ImageBurstMode';
	ImageBurstMode.muiName = 'SvgIcon';
	
	exports.default = ImageBurstMode;

/***/ },
/* 1504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraAlt = function ImageCameraAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	ImageCameraAlt = (0, _pure2.default)(ImageCameraAlt);
	ImageCameraAlt.displayName = 'ImageCameraAlt';
	ImageCameraAlt.muiName = 'SvgIcon';
	
	exports.default = ImageCameraAlt;

/***/ },
/* 1505 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraFront = function ImageCameraFront(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zM12 8c1.1 0 2-.9 2-2s-.9-2-2-2-1.99.9-1.99 2S10.9 8 12 8zm5-8H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zM7 2h10v10.5c0-1.67-3.33-2.5-5-2.5s-5 .83-5 2.5V2z' })
	  );
	};
	ImageCameraFront = (0, _pure2.default)(ImageCameraFront);
	ImageCameraFront.displayName = 'ImageCameraFront';
	ImageCameraFront.muiName = 'SvgIcon';
	
	exports.default = ImageCameraFront;

/***/ },
/* 1506 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraRear = function ImageCameraRear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 20H5v2h5v2l3-3-3-3v2zm4 0v2h5v-2h-5zm3-20H7C5.9 0 5 .9 5 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V2c0-1.1-.9-2-2-2zm-5 6c-1.11 0-2-.9-2-2s.89-2 1.99-2 2 .9 2 2C14 5.1 13.1 6 12 6z' })
	  );
	};
	ImageCameraRear = (0, _pure2.default)(ImageCameraRear);
	ImageCameraRear.displayName = 'ImageCameraRear';
	ImageCameraRear.muiName = 'SvgIcon';
	
	exports.default = ImageCameraRear;

/***/ },
/* 1507 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCameraRoll = function ImageCameraRoll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 5c0-1.1-.9-2-2-2h-1V2c0-.55-.45-1-1-1H6c-.55 0-1 .45-1 1v1H4c-1.1 0-2 .9-2 2v15c0 1.1.9 2 2 2h8c1.1 0 2-.9 2-2h8V5h-8zm-2 13h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2zm4 9h-2v-2h2v2zm0-9h-2V7h2v2z' })
	  );
	};
	ImageCameraRoll = (0, _pure2.default)(ImageCameraRoll);
	ImageCameraRoll.displayName = 'ImageCameraRoll';
	ImageCameraRoll.muiName = 'SvgIcon';
	
	exports.default = ImageCameraRoll;

/***/ },
/* 1508 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCamera = function ImageCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.4 10.5l4.77-8.26C13.47 2.09 12.75 2 12 2c-2.4 0-4.6.85-6.32 2.25l3.66 6.35.06-.1zM21.54 9c-.92-2.92-3.15-5.26-6-6.34L11.88 9h9.66zm.26 1h-7.49l.29.5 4.76 8.25C21 16.97 22 14.61 22 12c0-.69-.07-1.35-.2-2zM8.54 12l-3.9-6.75C3.01 7.03 2 9.39 2 12c0 .69.07 1.35.2 2h7.49l-1.15-2zm-6.08 3c.92 2.92 3.15 5.26 6 6.34L12.12 15H2.46zm11.27 0l-3.9 6.76c.7.15 1.42.24 2.17.24 2.4 0 4.6-.85 6.32-2.25l-3.66-6.35-.93 1.6z' })
	  );
	};
	ImageCamera = (0, _pure2.default)(ImageCamera);
	ImageCamera.displayName = 'ImageCamera';
	ImageCamera.muiName = 'SvgIcon';
	
	exports.default = ImageCamera;

/***/ },
/* 1509 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCenterFocusStrong = function ImageCenterFocusStrong(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm-7 7H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4z' })
	  );
	};
	ImageCenterFocusStrong = (0, _pure2.default)(ImageCenterFocusStrong);
	ImageCenterFocusStrong.displayName = 'ImageCenterFocusStrong';
	ImageCenterFocusStrong.muiName = 'SvgIcon';
	
	exports.default = ImageCenterFocusStrong;

/***/ },
/* 1510 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCenterFocusWeak = function ImageCenterFocusWeak(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ImageCenterFocusWeak = (0, _pure2.default)(ImageCenterFocusWeak);
	ImageCenterFocusWeak.displayName = 'ImageCenterFocusWeak';
	ImageCenterFocusWeak.muiName = 'SvgIcon';
	
	exports.default = ImageCenterFocusWeak;

/***/ },
/* 1511 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCollectionsBookmark = function ImageCollectionsBookmark(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm16-4H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm0 10l-2.5-1.5L15 12V4h5v8z' })
	  );
	};
	ImageCollectionsBookmark = (0, _pure2.default)(ImageCollectionsBookmark);
	ImageCollectionsBookmark.displayName = 'ImageCollectionsBookmark';
	ImageCollectionsBookmark.muiName = 'SvgIcon';
	
	exports.default = ImageCollectionsBookmark;

/***/ },
/* 1512 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCollections = function ImageCollections(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
	  );
	};
	ImageCollections = (0, _pure2.default)(ImageCollections);
	ImageCollections.displayName = 'ImageCollections';
	ImageCollections.muiName = 'SvgIcon';
	
	exports.default = ImageCollections;

/***/ },
/* 1513 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageColorLens = function ImageColorLens(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ImageColorLens = (0, _pure2.default)(ImageColorLens);
	ImageColorLens.displayName = 'ImageColorLens';
	ImageColorLens.muiName = 'SvgIcon';
	
	exports.default = ImageColorLens;

/***/ },
/* 1514 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageColorize = function ImageColorize(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.71 5.63l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-3.12 3.12-1.93-1.91-1.41 1.41 1.42 1.42L3 16.25V21h4.75l8.92-8.92 1.42 1.42 1.41-1.41-1.92-1.92 3.12-3.12c.4-.4.4-1.03.01-1.42zM6.92 19L5 17.08l8.06-8.06 1.92 1.92L6.92 19z' })
	  );
	};
	ImageColorize = (0, _pure2.default)(ImageColorize);
	ImageColorize.displayName = 'ImageColorize';
	ImageColorize.muiName = 'SvgIcon';
	
	exports.default = ImageColorize;

/***/ },
/* 1515 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCompare = function ImageCompare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h5v2h2V1h-2v2zm0 15H5l5-6v6zm9-15h-5v2h5v13l-5-6v9h5c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ImageCompare = (0, _pure2.default)(ImageCompare);
	ImageCompare.displayName = 'ImageCompare';
	ImageCompare.muiName = 'SvgIcon';
	
	exports.default = ImageCompare;

/***/ },
/* 1516 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageControlPointDuplicate = function ImageControlPointDuplicate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 8h-2v3h-3v2h3v3h2v-3h3v-2h-3zM2 12c0-2.79 1.64-5.2 4.01-6.32V3.52C2.52 4.76 0 8.09 0 12s2.52 7.24 6.01 8.48v-2.16C3.64 17.2 2 14.79 2 12zm13-9c-4.96 0-9 4.04-9 9s4.04 9 9 9 9-4.04 9-9-4.04-9-9-9zm0 16c-3.86 0-7-3.14-7-7s3.14-7 7-7 7 3.14 7 7-3.14 7-7 7z' })
	  );
	};
	ImageControlPointDuplicate = (0, _pure2.default)(ImageControlPointDuplicate);
	ImageControlPointDuplicate.displayName = 'ImageControlPointDuplicate';
	ImageControlPointDuplicate.muiName = 'SvgIcon';
	
	exports.default = ImageControlPointDuplicate;

/***/ },
/* 1517 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageControlPoint = function ImageControlPoint(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10 10-4.49 10-10S17.51 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ImageControlPoint = (0, _pure2.default)(ImageControlPoint);
	ImageControlPoint.displayName = 'ImageControlPoint';
	ImageControlPoint.muiName = 'SvgIcon';
	
	exports.default = ImageControlPoint;

/***/ },
/* 1518 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop169 = function ImageCrop169(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6H5c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H5V8h14v8z' })
	  );
	};
	ImageCrop169 = (0, _pure2.default)(ImageCrop169);
	ImageCrop169.displayName = 'ImageCrop169';
	ImageCrop169.muiName = 'SvgIcon';
	
	exports.default = ImageCrop169;

/***/ },
/* 1519 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop32 = function ImageCrop32(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 4H5c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H5V6h14v12z' })
	  );
	};
	ImageCrop32 = (0, _pure2.default)(ImageCrop32);
	ImageCrop32.displayName = 'ImageCrop32';
	ImageCrop32.muiName = 'SvgIcon';
	
	exports.default = ImageCrop32;

/***/ },
/* 1520 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop54 = function ImageCrop54(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
	  );
	};
	ImageCrop54 = (0, _pure2.default)(ImageCrop54);
	ImageCrop54.displayName = 'ImageCrop54';
	ImageCrop54.muiName = 'SvgIcon';
	
	exports.default = ImageCrop54;

/***/ },
/* 1521 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop75 = function ImageCrop75(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7H5c-1.1 0-2 .9-2 2v6c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm0 8H5V9h14v6z' })
	  );
	};
	ImageCrop75 = (0, _pure2.default)(ImageCrop75);
	ImageCrop75.displayName = 'ImageCrop75';
	ImageCrop75.muiName = 'SvgIcon';
	
	exports.default = ImageCrop75;

/***/ },
/* 1522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropDin = function ImageCropDin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
	  );
	};
	ImageCropDin = (0, _pure2.default)(ImageCropDin);
	ImageCropDin.displayName = 'ImageCropDin';
	ImageCropDin.muiName = 'SvgIcon';
	
	exports.default = ImageCropDin;

/***/ },
/* 1523 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropFree = function ImageCropFree(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5v4h2V5h4V3H5c-1.1 0-2 .9-2 2zm2 10H3v4c0 1.1.9 2 2 2h4v-2H5v-4zm14 4h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zm0-16h-4v2h4v4h2V5c0-1.1-.9-2-2-2z' })
	  );
	};
	ImageCropFree = (0, _pure2.default)(ImageCropFree);
	ImageCropFree.displayName = 'ImageCropFree';
	ImageCropFree.muiName = 'SvgIcon';
	
	exports.default = ImageCropFree;

/***/ },
/* 1524 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropLandscape = function ImageCropLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 5H5c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 12H5V7h14v10z' })
	  );
	};
	ImageCropLandscape = (0, _pure2.default)(ImageCropLandscape);
	ImageCropLandscape.displayName = 'ImageCropLandscape';
	ImageCropLandscape.muiName = 'SvgIcon';
	
	exports.default = ImageCropLandscape;

/***/ },
/* 1525 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropOriginal = function ImageCropOriginal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14zm-5.04-6.71l-2.75 3.54-1.96-2.36L6.5 17h11l-3.54-4.71z' })
	  );
	};
	ImageCropOriginal = (0, _pure2.default)(ImageCropOriginal);
	ImageCropOriginal.displayName = 'ImageCropOriginal';
	ImageCropOriginal.muiName = 'SvgIcon';
	
	exports.default = ImageCropOriginal;

/***/ },
/* 1526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropPortrait = function ImageCropPortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H7V5h10v14z' })
	  );
	};
	ImageCropPortrait = (0, _pure2.default)(ImageCropPortrait);
	ImageCropPortrait.displayName = 'ImageCropPortrait';
	ImageCropPortrait.muiName = 'SvgIcon';
	
	exports.default = ImageCropPortrait;

/***/ },
/* 1527 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropRotate = function ImageCropRotate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.47 21.49C4.2 19.93 1.86 16.76 1.5 13H0c.51 6.16 5.66 11 11.95 11 .23 0 .44-.02.66-.03L8.8 20.15l-1.33 1.34zM12.05 0c-.23 0-.44.02-.66.04l3.81 3.81 1.33-1.33C19.8 4.07 22.14 7.24 22.5 11H24c-.51-6.16-5.66-11-11.95-11zM16 14h2V8c0-1.11-.9-2-2-2h-6v2h6v6zm-8 2V4H6v2H4v2h2v8c0 1.1.89 2 2 2h8v2h2v-2h2v-2H8z' })
	  );
	};
	ImageCropRotate = (0, _pure2.default)(ImageCropRotate);
	ImageCropRotate.displayName = 'ImageCropRotate';
	ImageCropRotate.muiName = 'SvgIcon';
	
	exports.default = ImageCropRotate;

/***/ },
/* 1528 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCropSquare = function ImageCropSquare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4H6c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H6V6h12v12z' })
	  );
	};
	ImageCropSquare = (0, _pure2.default)(ImageCropSquare);
	ImageCropSquare.displayName = 'ImageCropSquare';
	ImageCropSquare.muiName = 'SvgIcon';
	
	exports.default = ImageCropSquare;

/***/ },
/* 1529 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageCrop = function ImageCrop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 15h2V7c0-1.1-.9-2-2-2H9v2h8v8zM7 17V1H5v4H1v2h4v10c0 1.1.9 2 2 2h10v4h2v-4h4v-2H7z' })
	  );
	};
	ImageCrop = (0, _pure2.default)(ImageCrop);
	ImageCrop.displayName = 'ImageCrop';
	ImageCrop.muiName = 'SvgIcon';
	
	exports.default = ImageCrop;

/***/ },
/* 1530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageDehaze = function ImageDehaze(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 15.5v2h20v-2H2zm0-5v2h20v-2H2zm0-5v2h20v-2H2z' })
	  );
	};
	ImageDehaze = (0, _pure2.default)(ImageDehaze);
	ImageDehaze.displayName = 'ImageDehaze';
	ImageDehaze.muiName = 'SvgIcon';
	
	exports.default = ImageDehaze;

/***/ },
/* 1531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageDetails = function ImageDetails(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 4l9 16 9-16H3zm3.38 2h11.25L12 16 6.38 6z' })
	  );
	};
	ImageDetails = (0, _pure2.default)(ImageDetails);
	ImageDetails.displayName = 'ImageDetails';
	ImageDetails.muiName = 'SvgIcon';
	
	exports.default = ImageDetails;

/***/ },
/* 1532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageEdit = function ImageEdit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17.25V21h3.75L17.81 9.94l-3.75-3.75L3 17.25zM20.71 7.04c.39-.39.39-1.02 0-1.41l-2.34-2.34c-.39-.39-1.02-.39-1.41 0l-1.83 1.83 3.75 3.75 1.83-1.83z' })
	  );
	};
	ImageEdit = (0, _pure2.default)(ImageEdit);
	ImageEdit.displayName = 'ImageEdit';
	ImageEdit.muiName = 'SvgIcon';
	
	exports.default = ImageEdit;

/***/ },
/* 1533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposureNeg1 = function ImageExposureNeg1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 11v2h8v-2H4zm15 7h-2V7.38L14 8.4V6.7L18.7 5h.3v13z' })
	  );
	};
	ImageExposureNeg1 = (0, _pure2.default)(ImageExposureNeg1);
	ImageExposureNeg1.displayName = 'ImageExposureNeg1';
	ImageExposureNeg1.muiName = 'SvgIcon';
	
	exports.default = ImageExposureNeg1;

/***/ },
/* 1534 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposureNeg2 = function ImageExposureNeg2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17s.19-.79.19-1.18c0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H21v-1.71h-5.95zM2 11v2h8v-2H2z' })
	  );
	};
	ImageExposureNeg2 = (0, _pure2.default)(ImageExposureNeg2);
	ImageExposureNeg2.displayName = 'ImageExposureNeg2';
	ImageExposureNeg2.muiName = 'SvgIcon';
	
	exports.default = ImageExposureNeg2;

/***/ },
/* 1535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposurePlus1 = function ImageExposurePlus1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 7H8v4H4v2h4v4h2v-4h4v-2h-4V7zm10 11h-2V7.38L15 8.4V6.7L19.7 5h.3v13z' })
	  );
	};
	ImageExposurePlus1 = (0, _pure2.default)(ImageExposurePlus1);
	ImageExposurePlus1.displayName = 'ImageExposurePlus1';
	ImageExposurePlus1.muiName = 'SvgIcon';
	
	exports.default = ImageExposurePlus1;

/***/ },
/* 1536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposurePlus2 = function ImageExposurePlus2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.05 16.29l2.86-3.07c.38-.39.72-.79 1.04-1.18.32-.39.59-.78.82-1.17.23-.39.41-.78.54-1.17.13-.39.19-.79.19-1.18 0-.53-.09-1.02-.27-1.46-.18-.44-.44-.81-.78-1.11-.34-.31-.77-.54-1.26-.71-.51-.16-1.08-.24-1.72-.24-.69 0-1.31.11-1.85.32-.54.21-1 .51-1.36.88-.37.37-.65.8-.84 1.3-.18.47-.27.97-.28 1.5h2.14c.01-.31.05-.6.13-.87.09-.29.23-.54.4-.75.18-.21.41-.37.68-.49.27-.12.6-.18.96-.18.31 0 .58.05.81.15.23.1.43.25.59.43.16.18.28.4.37.65.08.25.13.52.13.81 0 .22-.03.43-.08.65-.06.22-.15.45-.29.7-.14.25-.32.53-.56.83-.23.3-.52.65-.88 1.03l-4.17 4.55V18H22v-1.71h-5.95zM8 7H6v4H2v2h4v4h2v-4h4v-2H8V7z' })
	  );
	};
	ImageExposurePlus2 = (0, _pure2.default)(ImageExposurePlus2);
	ImageExposurePlus2.displayName = 'ImageExposurePlus2';
	ImageExposurePlus2.muiName = 'SvgIcon';
	
	exports.default = ImageExposurePlus2;

/***/ },
/* 1537 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposureZero = function ImageExposureZero(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.14 12.5c0 1-.1 1.85-.3 2.55-.2.7-.48 1.27-.83 1.7-.36.44-.79.75-1.3.95-.51.2-1.07.3-1.7.3-.62 0-1.18-.1-1.69-.3-.51-.2-.95-.51-1.31-.95-.36-.44-.65-1.01-.85-1.7-.2-.7-.3-1.55-.3-2.55v-2.04c0-1 .1-1.85.3-2.55.2-.7.48-1.26.84-1.69.36-.43.8-.74 1.31-.93C10.81 5.1 11.38 5 12 5c.63 0 1.19.1 1.7.29.51.19.95.5 1.31.93.36.43.64.99.84 1.69.2.7.3 1.54.3 2.55v2.04zm-2.11-2.36c0-.64-.05-1.18-.13-1.62-.09-.44-.22-.79-.4-1.06-.17-.27-.39-.46-.64-.58-.25-.13-.54-.19-.86-.19-.32 0-.61.06-.86.18s-.47.31-.64.58c-.17.27-.31.62-.4 1.06s-.13.98-.13 1.62v2.67c0 .64.05 1.18.14 1.62.09.45.23.81.4 1.09s.39.48.64.61.54.19.87.19c.33 0 .62-.06.87-.19s.46-.33.63-.61c.17-.28.3-.64.39-1.09.09-.45.13-.99.13-1.62v-2.66z' })
	  );
	};
	ImageExposureZero = (0, _pure2.default)(ImageExposureZero);
	ImageExposureZero.displayName = 'ImageExposureZero';
	ImageExposureZero.muiName = 'SvgIcon';
	
	exports.default = ImageExposureZero;

/***/ },
/* 1538 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageExposure = function ImageExposure(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 17v2h2v-2h2v-2h-2v-2h-2v2h-2v2h2zm5-15H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 5h6v2H5V5zm15 15H4L20 4v16z' })
	  );
	};
	ImageExposure = (0, _pure2.default)(ImageExposure);
	ImageExposure.displayName = 'ImageExposure';
	ImageExposure.muiName = 'SvgIcon';
	
	exports.default = ImageExposure;

/***/ },
/* 1539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter1 = function ImageFilter1(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 10h2V5h-4v2h2v8zm7-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilter1 = (0, _pure2.default)(ImageFilter1);
	ImageFilter1.displayName = 'ImageFilter1';
	ImageFilter1.muiName = 'SvgIcon';
	
	exports.default = ImageFilter1;

/***/ },
/* 1540 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter2 = function ImageFilter2(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-4-4h-4v-2h2c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2h-4v2h4v2h-2c-1.1 0-2 .89-2 2v4h6v-2z' })
	  );
	};
	ImageFilter2 = (0, _pure2.default)(ImageFilter2);
	ImageFilter2.displayName = 'ImageFilter2';
	ImageFilter2.muiName = 'SvgIcon';
	
	exports.default = ImageFilter2;

/***/ },
/* 1541 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter3 = function ImageFilter3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-4v2h4v2h-2v2h2v2h-4v2h4c1.1 0 2-.89 2-2z' })
	  );
	};
	ImageFilter3 = (0, _pure2.default)(ImageFilter3);
	ImageFilter3.displayName = 'ImageFilter3';
	ImageFilter3.muiName = 'SvgIcon';
	
	exports.default = ImageFilter3;

/***/ },
/* 1542 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter4 = function ImageFilter4(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm12 10h2V5h-2v4h-2V5h-2v6h4v4zm6-14H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilter4 = (0, _pure2.default)(ImageFilter4);
	ImageFilter4.displayName = 'ImageFilter4';
	ImageFilter4.muiName = 'SvgIcon';
	
	exports.default = ImageFilter4;

/***/ },
/* 1543 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter5 = function ImageFilter5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 1H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm14 8v-2c0-1.11-.9-2-2-2h-2V7h4V5h-6v6h4v2h-4v2h4c1.1 0 2-.89 2-2z' })
	  );
	};
	ImageFilter5 = (0, _pure2.default)(ImageFilter5);
	ImageFilter5.displayName = 'ImageFilter5';
	ImageFilter5.muiName = 'SvgIcon';
	
	exports.default = ImageFilter5;

/***/ },
/* 1544 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter6 = function ImageFilter6(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-2c0-1.11-.9-2-2-2h-2V7h4V5h-4c-1.1 0-2 .89-2 2v6c0 1.11.9 2 2 2zm0-4h2v2h-2v-2z' })
	  );
	};
	ImageFilter6 = (0, _pure2.default)(ImageFilter6);
	ImageFilter6.displayName = 'ImageFilter6';
	ImageFilter6.muiName = 'SvgIcon';
	
	exports.default = ImageFilter6;

/***/ },
/* 1545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter7 = function ImageFilter7(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2l4-8V5h-6v2h4l-4 8h2z' })
	  );
	};
	ImageFilter7 = (0, _pure2.default)(ImageFilter7);
	ImageFilter7.displayName = 'ImageFilter7';
	ImageFilter7.muiName = 'SvgIcon';
	
	exports.default = ImageFilter7;

/***/ },
/* 1546 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter8 = function ImageFilter8(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zm-8-2h2c1.1 0 2-.89 2-2v-1.5c0-.83-.67-1.5-1.5-1.5.83 0 1.5-.67 1.5-1.5V7c0-1.11-.9-2-2-2h-2c-1.1 0-2 .89-2 2v1.5c0 .83.67 1.5 1.5 1.5-.83 0-1.5.67-1.5 1.5V13c0 1.11.9 2 2 2zm0-8h2v2h-2V7zm0 4h2v2h-2v-2z' })
	  );
	};
	ImageFilter8 = (0, _pure2.default)(ImageFilter8);
	ImageFilter8.displayName = 'ImageFilter8';
	ImageFilter8.muiName = 'SvgIcon';
	
	exports.default = ImageFilter8;

/***/ },
/* 1547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter9Plus = function ImageFilter9Plus(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z' })
	  );
	};
	ImageFilter9Plus = (0, _pure2.default)(ImageFilter9Plus);
	ImageFilter9Plus.displayName = 'ImageFilter9Plus';
	ImageFilter9Plus.muiName = 'SvgIcon';
	
	exports.default = ImageFilter9Plus;

/***/ },
/* 1548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter9 = function ImageFilter9(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14zM15 5h-2c-1.1 0-2 .89-2 2v2c0 1.11.9 2 2 2h2v2h-4v2h4c1.1 0 2-.89 2-2V7c0-1.11-.9-2-2-2zm0 4h-2V7h2v2z' })
	  );
	};
	ImageFilter9 = (0, _pure2.default)(ImageFilter9);
	ImageFilter9.displayName = 'ImageFilter9';
	ImageFilter9.muiName = 'SvgIcon';
	
	exports.default = ImageFilter9;

/***/ },
/* 1549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterBAndW = function ImageFilterBAndW(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16l-7-8v8H5l7-8V5h7v14z' })
	  );
	};
	ImageFilterBAndW = (0, _pure2.default)(ImageFilterBAndW);
	ImageFilterBAndW.displayName = 'ImageFilterBAndW';
	ImageFilterBAndW.muiName = 'SvgIcon';
	
	exports.default = ImageFilterBAndW;

/***/ },
/* 1550 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterCenterFocus = function ImageFilterCenterFocus(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 15H3v4c0 1.1.9 2 2 2h4v-2H5v-4zM5 5h4V3H5c-1.1 0-2 .9-2 2v4h2V5zm14-2h-4v2h4v4h2V5c0-1.1-.9-2-2-2zm0 16h-4v2h4c1.1 0 2-.9 2-2v-4h-2v4zM12 9c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	ImageFilterCenterFocus = (0, _pure2.default)(ImageFilterCenterFocus);
	ImageFilterCenterFocus.displayName = 'ImageFilterCenterFocus';
	ImageFilterCenterFocus.muiName = 'SvgIcon';
	
	exports.default = ImageFilterCenterFocus;

/***/ },
/* 1551 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterDrama = function ImageFilterDrama(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.35 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.61 5.64 5.36 8.04 2.35 8.36 0 10.9 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.65-4.96zM19 18H6c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4h2c0-2.76-1.86-5.08-4.4-5.78C8.61 6.88 10.2 6 12 6c3.03 0 5.5 2.47 5.5 5.5v.5H19c1.65 0 3 1.35 3 3s-1.35 3-3 3z' })
	  );
	};
	ImageFilterDrama = (0, _pure2.default)(ImageFilterDrama);
	ImageFilterDrama.displayName = 'ImageFilterDrama';
	ImageFilterDrama.muiName = 'SvgIcon';
	
	exports.default = ImageFilterDrama;

/***/ },
/* 1552 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterFrames = function ImageFilterFrames(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4h-4l-4-4-4 4H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 16H4V6h4.52l3.52-3.5L15.52 6H20v14zM18 8H6v10h12' })
	  );
	};
	ImageFilterFrames = (0, _pure2.default)(ImageFilterFrames);
	ImageFilterFrames.displayName = 'ImageFilterFrames';
	ImageFilterFrames.muiName = 'SvgIcon';
	
	exports.default = ImageFilterFrames;

/***/ },
/* 1553 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterHdr = function ImageFilterHdr(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
	  );
	};
	ImageFilterHdr = (0, _pure2.default)(ImageFilterHdr);
	ImageFilterHdr.displayName = 'ImageFilterHdr';
	ImageFilterHdr.muiName = 'SvgIcon';
	
	exports.default = ImageFilterHdr;

/***/ },
/* 1554 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterNone = function ImageFilterNone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilterNone = (0, _pure2.default)(ImageFilterNone);
	ImageFilterNone.displayName = 'ImageFilterNone';
	ImageFilterNone.muiName = 'SvgIcon';
	
	exports.default = ImageFilterNone;

/***/ },
/* 1555 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterTiltShift = function ImageFilterTiltShift(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 4.07V2.05c-2.01.2-3.84 1-5.32 2.21L7.1 5.69c1.11-.86 2.44-1.44 3.9-1.62zm7.32.19C16.84 3.05 15.01 2.25 13 2.05v2.02c1.46.18 2.79.76 3.9 1.62l1.42-1.43zM19.93 11h2.02c-.2-2.01-1-3.84-2.21-5.32L18.31 7.1c.86 1.11 1.44 2.44 1.62 3.9zM5.69 7.1L4.26 5.68C3.05 7.16 2.25 8.99 2.05 11h2.02c.18-1.46.76-2.79 1.62-3.9zM4.07 13H2.05c.2 2.01 1 3.84 2.21 5.32l1.43-1.43c-.86-1.1-1.44-2.43-1.62-3.89zM15 12c0-1.66-1.34-3-3-3s-3 1.34-3 3 1.34 3 3 3 3-1.34 3-3zm3.31 4.9l1.43 1.43c1.21-1.48 2.01-3.32 2.21-5.32h-2.02c-.18 1.45-.76 2.78-1.62 3.89zM13 19.93v2.02c2.01-.2 3.84-1 5.32-2.21l-1.43-1.43c-1.1.86-2.43 1.44-3.89 1.62zm-7.32-.19C7.16 20.95 9 21.75 11 21.95v-2.02c-1.46-.18-2.79-.76-3.9-1.62l-1.42 1.43z' })
	  );
	};
	ImageFilterTiltShift = (0, _pure2.default)(ImageFilterTiltShift);
	ImageFilterTiltShift.displayName = 'ImageFilterTiltShift';
	ImageFilterTiltShift.muiName = 'SvgIcon';
	
	exports.default = ImageFilterTiltShift;

/***/ },
/* 1556 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilterVintage = function ImageFilterVintage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.7 12.4c-.28-.16-.57-.29-.86-.4.29-.11.58-.24.86-.4 1.92-1.11 2.99-3.12 3-5.19-1.79-1.03-4.07-1.11-6 0-.28.16-.54.35-.78.54.05-.31.08-.63.08-.95 0-2.22-1.21-4.15-3-5.19C10.21 1.85 9 3.78 9 6c0 .32.03.64.08.95-.24-.2-.5-.39-.78-.55-1.92-1.11-4.2-1.03-6 0 0 2.07 1.07 4.08 3 5.19.28.16.57.29.86.4-.29.11-.58.24-.86.4-1.92 1.11-2.99 3.12-3 5.19 1.79 1.03 4.07 1.11 6 0 .28-.16.54-.35.78-.54-.05.32-.08.64-.08.96 0 2.22 1.21 4.15 3 5.19 1.79-1.04 3-2.97 3-5.19 0-.32-.03-.64-.08-.95.24.2.5.38.78.54 1.92 1.11 4.2 1.03 6 0-.01-2.07-1.08-4.08-3-5.19zM12 16c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' })
	  );
	};
	ImageFilterVintage = (0, _pure2.default)(ImageFilterVintage);
	ImageFilterVintage.displayName = 'ImageFilterVintage';
	ImageFilterVintage.muiName = 'SvgIcon';
	
	exports.default = ImageFilterVintage;

/***/ },
/* 1557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFilter = function ImageFilter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.96 10.29l-2.75 3.54-1.96-2.36L8.5 15h11l-3.54-4.71zM3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm18-4H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 16H7V3h14v14z' })
	  );
	};
	ImageFilter = (0, _pure2.default)(ImageFilter);
	ImageFilter.displayName = 'ImageFilter';
	ImageFilter.muiName = 'SvgIcon';
	
	exports.default = ImageFilter;

/***/ },
/* 1558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlare = function ImageFlare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 11H1v2h6v-2zm2.17-3.24L7.05 5.64 5.64 7.05l2.12 2.12 1.41-1.41zM13 1h-2v6h2V1zm5.36 6.05l-1.41-1.41-2.12 2.12 1.41 1.41 2.12-2.12zM17 11v2h6v-2h-6zm-5-2c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3zm2.83 7.24l2.12 2.12 1.41-1.41-2.12-2.12-1.41 1.41zm-9.19.71l1.41 1.41 2.12-2.12-1.41-1.41-2.12 2.12zM11 23h2v-6h-2v6z' })
	  );
	};
	ImageFlare = (0, _pure2.default)(ImageFlare);
	ImageFlare.displayName = 'ImageFlare';
	ImageFlare.muiName = 'SvgIcon';
	
	exports.default = ImageFlare;

/***/ },
/* 1559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlashAuto = function ImageFlashAuto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 2v12h3v9l7-12H9l4-9H3zm16 0h-2l-3.2 9h1.9l.7-2h3.2l.7 2h1.9L19 2zm-2.15 5.65L18 4l1.15 3.65h-2.3z' })
	  );
	};
	ImageFlashAuto = (0, _pure2.default)(ImageFlashAuto);
	ImageFlashAuto.displayName = 'ImageFlashAuto';
	ImageFlashAuto.muiName = 'SvgIcon';
	
	exports.default = ImageFlashAuto;

/***/ },
/* 1560 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlashOff = function ImageFlashOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.27 3L2 4.27l5 5V13h3v9l3.58-6.14L17.73 20 19 18.73 3.27 3zM17 10h-4l4-8H7v2.18l8.46 8.46L17 10z' })
	  );
	};
	ImageFlashOff = (0, _pure2.default)(ImageFlashOff);
	ImageFlashOff.displayName = 'ImageFlashOff';
	ImageFlashOff.muiName = 'SvgIcon';
	
	exports.default = ImageFlashOff;

/***/ },
/* 1561 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlashOn = function ImageFlashOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 2v11h3v9l7-12h-4l4-8z' })
	  );
	};
	ImageFlashOn = (0, _pure2.default)(ImageFlashOn);
	ImageFlashOn.displayName = 'ImageFlashOn';
	ImageFlashOn.muiName = 'SvgIcon';
	
	exports.default = ImageFlashOn;

/***/ },
/* 1562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageFlip = function ImageFlip(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 21h2v-2h-2v2zm4-12h2V7h-2v2zM3 5v14c0 1.1.9 2 2 2h4v-2H5V5h4V3H5c-1.1 0-2 .9-2 2zm16-2v2h2c0-1.1-.9-2-2-2zm-8 20h2V1h-2v22zm8-6h2v-2h-2v2zM15 5h2V3h-2v2zm4 8h2v-2h-2v2zm0 8c1.1 0 2-.9 2-2h-2v2z' })
	  );
	};
	ImageFlip = (0, _pure2.default)(ImageFlip);
	ImageFlip.displayName = 'ImageFlip';
	ImageFlip.muiName = 'SvgIcon';
	
	exports.default = ImageFlip;

/***/ },
/* 1563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGradient = function ImageGradient(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9h2v2h-2zm-2 2h2v2H9zm4 0h2v2h-2zm2-2h2v2h-2zM7 9h2v2H7zm12-6H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 18H7v-2h2v2zm4 0h-2v-2h2v2zm4 0h-2v-2h2v2zm2-7h-2v2h2v2h-2v-2h-2v2h-2v-2h-2v2H9v-2H7v2H5v-2h2v-2H5V5h14v6z' })
	  );
	};
	ImageGradient = (0, _pure2.default)(ImageGradient);
	ImageGradient.displayName = 'ImageGradient';
	ImageGradient.muiName = 'SvgIcon';
	
	exports.default = ImageGradient;

/***/ },
/* 1564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGrain = function ImageGrain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 12c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zM6 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12-8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-4 8c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-4-4c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	ImageGrain = (0, _pure2.default)(ImageGrain);
	ImageGrain.displayName = 'ImageGrain';
	ImageGrain.muiName = 'SvgIcon';
	
	exports.default = ImageGrain;

/***/ },
/* 1565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGridOff = function ImageGridOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 4v1.45l2 2V4h4v4h-3.45l2 2H14v1.45l2 2V10h4v4h-3.45l2 2H20v1.45l2 2V4c0-1.1-.9-2-2-2H4.55l2 2H8zm8 0h4v4h-4V4zM1.27 1.27L0 2.55l2 2V20c0 1.1.9 2 2 2h15.46l2 2 1.27-1.27L1.27 1.27zM10 12.55L11.45 14H10v-1.45zm-6-6L5.45 8H4V6.55zM8 20H4v-4h4v4zm0-6H4v-4h3.45l.55.55V14zm6 6h-4v-4h3.45l.55.54V20zm2 0v-1.46L17.46 20H16z' })
	  );
	};
	ImageGridOff = (0, _pure2.default)(ImageGridOff);
	ImageGridOff.displayName = 'ImageGridOff';
	ImageGridOff.muiName = 'SvgIcon';
	
	exports.default = ImageGridOff;

/***/ },
/* 1566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageGridOn = function ImageGridOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM8 20H4v-4h4v4zm0-6H4v-4h4v4zm0-6H4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4zm6 12h-4v-4h4v4zm0-6h-4v-4h4v4zm0-6h-4V4h4v4z' })
	  );
	};
	ImageGridOn = (0, _pure2.default)(ImageGridOn);
	ImageGridOn.displayName = 'ImageGridOn';
	ImageGridOn.muiName = 'SvgIcon';
	
	exports.default = ImageGridOn;

/***/ },
/* 1567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrOff = function ImageHdrOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.5 15v-2h1.1l.9 2H21l-.9-2.1c.5-.2.9-.8.9-1.4v-1c0-.8-.7-1.5-1.5-1.5H16v4.9l1.1 1.1h.4zm0-4.5h2v1h-2v-1zm-4.5 0v.4l1.5 1.5v-1.9c0-.8-.7-1.5-1.5-1.5h-1.9l1.5 1.5h.4zm-3.5-1l-7-7-1.1 1L6.9 9h-.4v2h-2V9H3v6h1.5v-2.5h2V15H8v-4.9l1.5 1.5V15h3.4l7.6 7.6 1.1-1.1-12.1-12z' })
	  );
	};
	ImageHdrOff = (0, _pure2.default)(ImageHdrOff);
	ImageHdrOff.displayName = 'ImageHdrOff';
	ImageHdrOff.muiName = 'SvgIcon';
	
	exports.default = ImageHdrOff;

/***/ },
/* 1568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrOn = function ImageHdrOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 11.5v-1c0-.8-.7-1.5-1.5-1.5H16v6h1.5v-2h1.1l.9 2H21l-.9-2.1c.5-.3.9-.8.9-1.4zm-1.5 0h-2v-1h2v1zm-13-.5h-2V9H3v6h1.5v-2.5h2V15H8V9H6.5v2zM13 9H9.5v6H13c.8 0 1.5-.7 1.5-1.5v-3c0-.8-.7-1.5-1.5-1.5zm0 4.5h-2v-3h2v3z' })
	  );
	};
	ImageHdrOn = (0, _pure2.default)(ImageHdrOn);
	ImageHdrOn.displayName = 'ImageHdrOn';
	ImageHdrOn.muiName = 'SvgIcon';
	
	exports.default = ImageHdrOn;

/***/ },
/* 1569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrStrong = function ImageHdrStrong(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 6c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zM5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 6c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	ImageHdrStrong = (0, _pure2.default)(ImageHdrStrong);
	ImageHdrStrong.displayName = 'ImageHdrStrong';
	ImageHdrStrong.muiName = 'SvgIcon';
	
	exports.default = ImageHdrStrong;

/***/ },
/* 1570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHdrWeak = function ImageHdrWeak(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm12-2c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm0 10c-2.21 0-4-1.79-4-4s1.79-4 4-4 4 1.79 4 4-1.79 4-4 4z' })
	  );
	};
	ImageHdrWeak = (0, _pure2.default)(ImageHdrWeak);
	ImageHdrWeak.displayName = 'ImageHdrWeak';
	ImageHdrWeak.muiName = 'SvgIcon';
	
	exports.default = ImageHdrWeak;

/***/ },
/* 1571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageHealing = function ImageHealing(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.73 12.02l3.98-3.98c.39-.39.39-1.02 0-1.41l-4.34-4.34c-.39-.39-1.02-.39-1.41 0l-3.98 3.98L8 2.29C7.8 2.1 7.55 2 7.29 2c-.25 0-.51.1-.7.29L2.25 6.63c-.39.39-.39 1.02 0 1.41l3.98 3.98L2.25 16c-.39.39-.39 1.02 0 1.41l4.34 4.34c.39.39 1.02.39 1.41 0l3.98-3.98 3.98 3.98c.2.2.45.29.71.29.26 0 .51-.1.71-.29l4.34-4.34c.39-.39.39-1.02 0-1.41l-3.99-3.98zM12 9c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm-4.71 1.96L3.66 7.34l3.63-3.63 3.62 3.62-3.62 3.63zM10 13c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2 2c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm2-4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm2.66 9.34l-3.63-3.62 3.63-3.63 3.62 3.62-3.62 3.63z' })
	  );
	};
	ImageHealing = (0, _pure2.default)(ImageHealing);
	ImageHealing.displayName = 'ImageHealing';
	ImageHealing.muiName = 'SvgIcon';
	
	exports.default = ImageHealing;

/***/ },
/* 1572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageImageAspectRatio = function ImageImageAspectRatio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 10h-2v2h2v-2zm0 4h-2v2h2v-2zm-8-4H6v2h2v-2zm4 0h-2v2h2v-2zm8-6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 14H4V6h16v12z' })
	  );
	};
	ImageImageAspectRatio = (0, _pure2.default)(ImageImageAspectRatio);
	ImageImageAspectRatio.displayName = 'ImageImageAspectRatio';
	ImageImageAspectRatio.muiName = 'SvgIcon';
	
	exports.default = ImageImageAspectRatio;

/***/ },
/* 1573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageImage = function ImageImage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
	  );
	};
	ImageImage = (0, _pure2.default)(ImageImage);
	ImageImage.displayName = 'ImageImage';
	ImageImage.muiName = 'SvgIcon';
	
	exports.default = ImageImage;

/***/ },
/* 1574 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageIso = function ImageIso(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5.5 7.5h2v-2H9v2h2V9H9v2H7.5V9h-2V7.5zM19 19H5L19 5v14zm-2-2v-1.5h-5V17h5z' })
	  );
	};
	ImageIso = (0, _pure2.default)(ImageIso);
	ImageIso.displayName = 'ImageIso';
	ImageIso.muiName = 'SvgIcon';
	
	exports.default = ImageIso;

/***/ },
/* 1575 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLandscape = function ImageLandscape(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
	  );
	};
	ImageLandscape = (0, _pure2.default)(ImageLandscape);
	ImageLandscape.displayName = 'ImageLandscape';
	ImageLandscape.muiName = 'SvgIcon';
	
	exports.default = ImageLandscape;

/***/ },
/* 1576 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLeakAdd = function ImageLeakAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 3H3v3c1.66 0 3-1.34 3-3zm8 0h-2c0 4.97-4.03 9-9 9v2c6.08 0 11-4.93 11-11zm-4 0H8c0 2.76-2.24 5-5 5v2c3.87 0 7-3.13 7-7zm0 18h2c0-4.97 4.03-9 9-9v-2c-6.07 0-11 4.93-11 11zm8 0h3v-3c-1.66 0-3 1.34-3 3zm-4 0h2c0-2.76 2.24-5 5-5v-2c-3.87 0-7 3.13-7 7z' })
	  );
	};
	ImageLeakAdd = (0, _pure2.default)(ImageLeakAdd);
	ImageLeakAdd.displayName = 'ImageLeakAdd';
	ImageLeakAdd.muiName = 'SvgIcon';
	
	exports.default = ImageLeakAdd;

/***/ },
/* 1577 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLeakRemove = function ImageLeakRemove(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 3H8c0 .37-.04.72-.12 1.06l1.59 1.59C9.81 4.84 10 3.94 10 3zM3 4.27l2.84 2.84C5.03 7.67 4.06 8 3 8v2c1.61 0 3.09-.55 4.27-1.46L8.7 9.97C7.14 11.24 5.16 12 3 12v2c2.71 0 5.19-.99 7.11-2.62l2.5 2.5C10.99 15.81 10 18.29 10 21h2c0-2.16.76-4.14 2.03-5.69l1.43 1.43C14.55 17.91 14 19.39 14 21h2c0-1.06.33-2.03.89-2.84L19.73 21 21 19.73 4.27 3 3 4.27zM14 3h-2c0 1.5-.37 2.91-1.02 4.16l1.46 1.46C13.42 6.98 14 5.06 14 3zm5.94 13.12c.34-.08.69-.12 1.06-.12v-2c-.94 0-1.84.19-2.66.52l1.6 1.6zm-4.56-4.56l1.46 1.46C18.09 12.37 19.5 12 21 12v-2c-2.06 0-3.98.58-5.62 1.56z' })
	  );
	};
	ImageLeakRemove = (0, _pure2.default)(ImageLeakRemove);
	ImageLeakRemove.displayName = 'ImageLeakRemove';
	ImageLeakRemove.muiName = 'SvgIcon';
	
	exports.default = ImageLeakRemove;

/***/ },
/* 1578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLens = function ImageLens(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z' })
	  );
	};
	ImageLens = (0, _pure2.default)(ImageLens);
	ImageLens.displayName = 'ImageLens';
	ImageLens.muiName = 'SvgIcon';
	
	exports.default = ImageLens;

/***/ },
/* 1579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLinkedCamera = function ImageLinkedCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '14', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M16 3.33c2.58 0 4.67 2.09 4.67 4.67H22c0-3.31-2.69-6-6-6v1.33M16 6c1.11 0 2 .89 2 2h1.33c0-1.84-1.49-3.33-3.33-3.33V6' }),
	    _react2.default.createElement('path', { d: 'M17 9c0-1.11-.89-2-2-2V4H9L7.17 6H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V9h-5zm-5 10c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	ImageLinkedCamera = (0, _pure2.default)(ImageLinkedCamera);
	ImageLinkedCamera.displayName = 'ImageLinkedCamera';
	ImageLinkedCamera.muiName = 'SvgIcon';
	
	exports.default = ImageLinkedCamera;

/***/ },
/* 1580 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks3 = function ImageLooks3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.01 3h-14c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 7.5c0 .83-.67 1.5-1.5 1.5.83 0 1.5.67 1.5 1.5V15c0 1.11-.9 2-2 2h-4v-2h4v-2h-2v-2h2V9h-4V7h4c1.1 0 2 .89 2 2v1.5z' })
	  );
	};
	ImageLooks3 = (0, _pure2.default)(ImageLooks3);
	ImageLooks3.displayName = 'ImageLooks3';
	ImageLooks3.muiName = 'SvgIcon';
	
	exports.default = ImageLooks3;

/***/ },
/* 1581 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks4 = function ImageLooks4(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 14h-2v-4H9V7h2v4h2V7h2v10z' })
	  );
	};
	ImageLooks4 = (0, _pure2.default)(ImageLooks4);
	ImageLooks4.displayName = 'ImageLooks4';
	ImageLooks4.muiName = 'SvgIcon';
	
	exports.default = ImageLooks4;

/***/ },
/* 1582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks5 = function ImageLooks5(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2H9v-2h4v-2H9V7h6v2z' })
	  );
	};
	ImageLooks5 = (0, _pure2.default)(ImageLooks5);
	ImageLooks5.displayName = 'ImageLooks5';
	ImageLooks5.muiName = 'SvgIcon';
	
	exports.default = ImageLooks5;

/***/ },
/* 1583 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks6 = function ImageLooks6(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 15h2v-2h-2v2zm8-12H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 6h-4v2h2c1.1 0 2 .89 2 2v2c0 1.11-.9 2-2 2h-2c-1.1 0-2-.89-2-2V9c0-1.11.9-2 2-2h4v2z' })
	  );
	};
	ImageLooks6 = (0, _pure2.default)(ImageLooks6);
	ImageLooks6.displayName = 'ImageLooks6';
	ImageLooks6.muiName = 'SvgIcon';
	
	exports.default = ImageLooks6;

/***/ },
/* 1584 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooksOne = function ImageLooksOne(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-5 14h-2V9h-2V7h4v10z' })
	  );
	};
	ImageLooksOne = (0, _pure2.default)(ImageLooksOne);
	ImageLooksOne.displayName = 'ImageLooksOne';
	ImageLooksOne.muiName = 'SvgIcon';
	
	exports.default = ImageLooksOne;

/***/ },
/* 1585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooksTwo = function ImageLooksTwo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-4 8c0 1.11-.9 2-2 2h-2v2h4v2H9v-4c0-1.11.9-2 2-2h2V9H9V7h4c1.1 0 2 .89 2 2v2z' })
	  );
	};
	ImageLooksTwo = (0, _pure2.default)(ImageLooksTwo);
	ImageLooksTwo.displayName = 'ImageLooksTwo';
	ImageLooksTwo.muiName = 'SvgIcon';
	
	exports.default = ImageLooksTwo;

/***/ },
/* 1586 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLooks = function ImageLooks(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 10c-3.86 0-7 3.14-7 7h2c0-2.76 2.24-5 5-5s5 2.24 5 5h2c0-3.86-3.14-7-7-7zm0-4C5.93 6 1 10.93 1 17h2c0-4.96 4.04-9 9-9s9 4.04 9 9h2c0-6.07-4.93-11-11-11z' })
	  );
	};
	ImageLooks = (0, _pure2.default)(ImageLooks);
	ImageLooks.displayName = 'ImageLooks';
	ImageLooks.muiName = 'SvgIcon';
	
	exports.default = ImageLooks;

/***/ },
/* 1587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageLoupe = function ImageLoupe(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 7h-2v4H7v2h4v4h2v-4h4v-2h-4V7zm-1-5C6.49 2 2 6.49 2 12s4.49 10 10 10h8c1.1 0 2-.9 2-2v-8c0-5.51-4.49-10-10-10zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ImageLoupe = (0, _pure2.default)(ImageLoupe);
	ImageLoupe.displayName = 'ImageLoupe';
	ImageLoupe.muiName = 'SvgIcon';
	
	exports.default = ImageLoupe;

/***/ },
/* 1588 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMonochromePhotos = function ImageMonochromePhotos(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 5h-3.2L15 3H9L7.2 5H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 14h-8v-1c-2.8 0-5-2.2-5-5s2.2-5 5-5V7h8v12zm-3-6c0-2.8-2.2-5-5-5v1.8c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2V18c2.8 0 5-2.2 5-5zm-8.2 0c0 1.8 1.4 3.2 3.2 3.2V9.8c-1.8 0-3.2 1.4-3.2 3.2z' })
	  );
	};
	ImageMonochromePhotos = (0, _pure2.default)(ImageMonochromePhotos);
	ImageMonochromePhotos.displayName = 'ImageMonochromePhotos';
	ImageMonochromePhotos.muiName = 'SvgIcon';
	
	exports.default = ImageMonochromePhotos;

/***/ },
/* 1589 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMovieCreation = function ImageMovieCreation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l2 4h-3l-2-4h-2l2 4h-3l-2-4H8l2 4H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4z' })
	  );
	};
	ImageMovieCreation = (0, _pure2.default)(ImageMovieCreation);
	ImageMovieCreation.displayName = 'ImageMovieCreation';
	ImageMovieCreation.muiName = 'SvgIcon';
	
	exports.default = ImageMovieCreation;

/***/ },
/* 1590 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMovieFilter = function ImageMovieFilter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 4l2 3h-3l-2-3h-2l2 3h-3l-2-3H8l2 3H7L5 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V4h-4zm-6.75 11.25L10 18l-1.25-2.75L6 14l2.75-1.25L10 10l1.25 2.75L14 14l-2.75 1.25zm5.69-3.31L16 14l-.94-2.06L13 11l2.06-.94L16 8l.94 2.06L19 11l-2.06.94z' })
	  );
	};
	ImageMovieFilter = (0, _pure2.default)(ImageMovieFilter);
	ImageMovieFilter.displayName = 'ImageMovieFilter';
	ImageMovieFilter.muiName = 'SvgIcon';
	
	exports.default = ImageMovieFilter;

/***/ },
/* 1591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageMusicNote = function ImageMusicNote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3v10.55c-.59-.34-1.27-.55-2-.55-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4V7h4V3h-6z' })
	  );
	};
	ImageMusicNote = (0, _pure2.default)(ImageMusicNote);
	ImageMusicNote.displayName = 'ImageMusicNote';
	ImageMusicNote.muiName = 'SvgIcon';
	
	exports.default = ImageMusicNote;

/***/ },
/* 1592 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNaturePeople = function ImageNaturePeople(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.17 9.17c0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H6v-3h1v-4c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v4h1v5h16v-2h-3v-3.88c3.47-.41 6.17-3.36 6.17-6.95zM4.5 11c.83 0 1.5-.67 1.5-1.5S5.33 8 4.5 8 3 8.67 3 9.5 3.67 11 4.5 11z' })
	  );
	};
	ImageNaturePeople = (0, _pure2.default)(ImageNaturePeople);
	ImageNaturePeople.displayName = 'ImageNaturePeople';
	ImageNaturePeople.muiName = 'SvgIcon';
	
	exports.default = ImageNaturePeople;

/***/ },
/* 1593 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNature = function ImageNature(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 16.12c3.47-.41 6.17-3.36 6.17-6.95 0-3.87-3.13-7-7-7s-7 3.13-7 7c0 3.47 2.52 6.34 5.83 6.89V20H5v2h14v-2h-6v-3.88z' })
	  );
	};
	ImageNature = (0, _pure2.default)(ImageNature);
	ImageNature.displayName = 'ImageNature';
	ImageNature.muiName = 'SvgIcon';
	
	exports.default = ImageNature;

/***/ },
/* 1594 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNavigateBefore = function ImageNavigateBefore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z' })
	  );
	};
	ImageNavigateBefore = (0, _pure2.default)(ImageNavigateBefore);
	ImageNavigateBefore.displayName = 'ImageNavigateBefore';
	ImageNavigateBefore.muiName = 'SvgIcon';
	
	exports.default = ImageNavigateBefore;

/***/ },
/* 1595 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageNavigateNext = function ImageNavigateNext(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z' })
	  );
	};
	ImageNavigateNext = (0, _pure2.default)(ImageNavigateNext);
	ImageNavigateNext.displayName = 'ImageNavigateNext';
	ImageNavigateNext.muiName = 'SvgIcon';
	
	exports.default = ImageNavigateNext;

/***/ },
/* 1596 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePalette = function ImagePalette(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 3c-4.97 0-9 4.03-9 9s4.03 9 9 9c.83 0 1.5-.67 1.5-1.5 0-.39-.15-.74-.39-1.01-.23-.26-.38-.61-.38-.99 0-.83.67-1.5 1.5-1.5H16c2.76 0 5-2.24 5-5 0-4.42-4.03-8-9-8zm-5.5 9c-.83 0-1.5-.67-1.5-1.5S5.67 9 6.5 9 8 9.67 8 10.5 7.33 12 6.5 12zm3-4C8.67 8 8 7.33 8 6.5S8.67 5 9.5 5s1.5.67 1.5 1.5S10.33 8 9.5 8zm5 0c-.83 0-1.5-.67-1.5-1.5S13.67 5 14.5 5s1.5.67 1.5 1.5S15.33 8 14.5 8zm3 4c-.83 0-1.5-.67-1.5-1.5S16.67 9 17.5 9s1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	ImagePalette = (0, _pure2.default)(ImagePalette);
	ImagePalette.displayName = 'ImagePalette';
	ImagePalette.muiName = 'SvgIcon';
	
	exports.default = ImagePalette;

/***/ },
/* 1597 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaFishEye = function ImagePanoramaFishEye(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8z' })
	  );
	};
	ImagePanoramaFishEye = (0, _pure2.default)(ImagePanoramaFishEye);
	ImagePanoramaFishEye.displayName = 'ImagePanoramaFishEye';
	ImagePanoramaFishEye.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaFishEye;

/***/ },
/* 1598 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaHorizontal = function ImagePanoramaHorizontal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6.54v10.91c-2.6-.77-5.28-1.16-8-1.16-2.72 0-5.4.39-8 1.16V6.54c2.6.77 5.28 1.16 8 1.16 2.72.01 5.4-.38 8-1.16M21.43 4c-.1 0-.2.02-.31.06C18.18 5.16 15.09 5.7 12 5.7c-3.09 0-6.18-.55-9.12-1.64-.11-.04-.22-.06-.31-.06-.34 0-.57.23-.57.63v14.75c0 .39.23.62.57.62.1 0 .2-.02.31-.06 2.94-1.1 6.03-1.64 9.12-1.64 3.09 0 6.18.55 9.12 1.64.11.04.21.06.31.06.33 0 .57-.23.57-.63V4.63c0-.4-.24-.63-.57-.63z' })
	  );
	};
	ImagePanoramaHorizontal = (0, _pure2.default)(ImagePanoramaHorizontal);
	ImagePanoramaHorizontal.displayName = 'ImagePanoramaHorizontal';
	ImagePanoramaHorizontal.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaHorizontal;

/***/ },
/* 1599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaVertical = function ImagePanoramaVertical(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.94 21.12c-1.1-2.94-1.64-6.03-1.64-9.12 0-3.09.55-6.18 1.64-9.12.04-.11.06-.22.06-.31 0-.34-.23-.57-.63-.57H4.63c-.4 0-.63.23-.63.57 0 .1.02.2.06.31C5.16 5.82 5.71 8.91 5.71 12c0 3.09-.55 6.18-1.64 9.12-.05.11-.07.22-.07.31 0 .33.23.57.63.57h14.75c.39 0 .63-.24.63-.57-.01-.1-.03-.2-.07-.31zM6.54 20c.77-2.6 1.16-5.28 1.16-8 0-2.72-.39-5.4-1.16-8h10.91c-.77 2.6-1.16 5.28-1.16 8 0 2.72.39 5.4 1.16 8H6.54z' })
	  );
	};
	ImagePanoramaVertical = (0, _pure2.default)(ImagePanoramaVertical);
	ImagePanoramaVertical.displayName = 'ImagePanoramaVertical';
	ImagePanoramaVertical.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaVertical;

/***/ },
/* 1600 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanoramaWideAngle = function ImagePanoramaWideAngle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c2.45 0 4.71.2 7.29.64.47 1.78.71 3.58.71 5.36 0 1.78-.24 3.58-.71 5.36-2.58.44-4.84.64-7.29.64s-4.71-.2-7.29-.64C4.24 15.58 4 13.78 4 12c0-1.78.24-3.58.71-5.36C7.29 6.2 9.55 6 12 6m0-2c-2.73 0-5.22.24-7.95.72l-.93.16-.25.9C2.29 7.85 2 9.93 2 12s.29 4.15.87 6.22l.25.89.93.16c2.73.49 5.22.73 7.95.73s5.22-.24 7.95-.72l.93-.16.25-.89c.58-2.08.87-4.16.87-6.23s-.29-4.15-.87-6.22l-.25-.89-.93-.16C17.22 4.24 14.73 4 12 4z' })
	  );
	};
	ImagePanoramaWideAngle = (0, _pure2.default)(ImagePanoramaWideAngle);
	ImagePanoramaWideAngle.displayName = 'ImagePanoramaWideAngle';
	ImagePanoramaWideAngle.muiName = 'SvgIcon';
	
	exports.default = ImagePanoramaWideAngle;

/***/ },
/* 1601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePanorama = function ImagePanorama(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 18V6c0-1.1-.9-2-2-2H3c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2zM8.5 12.5l2.5 3.01L14.5 11l4.5 6H5l3.5-4.5z' })
	  );
	};
	ImagePanorama = (0, _pure2.default)(ImagePanorama);
	ImagePanorama.displayName = 'ImagePanorama';
	ImagePanorama.muiName = 'SvgIcon';
	
	exports.default = ImagePanorama;

/***/ },
/* 1602 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoAlbum = function ImagePhotoAlbum(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2H6c-1.1 0-2 .9-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 4h5v8l-2.5-1.5L6 12V4zm0 15l3-3.86 2.14 2.58 3-3.86L18 19H6z' })
	  );
	};
	ImagePhotoAlbum = (0, _pure2.default)(ImagePhotoAlbum);
	ImagePhotoAlbum.displayName = 'ImagePhotoAlbum';
	ImagePhotoAlbum.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoAlbum;

/***/ },
/* 1603 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoCamera = function ImagePhotoCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	ImagePhotoCamera = (0, _pure2.default)(ImagePhotoCamera);
	ImagePhotoCamera.displayName = 'ImagePhotoCamera';
	ImagePhotoCamera.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoCamera;

/***/ },
/* 1604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoFilter = function ImagePhotoFilter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.02 10v9H5V5h9V3H5.02c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-9h-2zM17 10l.94-2.06L20 7l-2.06-.94L17 4l-.94 2.06L14 7l2.06.94zm-3.75.75L12 8l-1.25 2.75L8 12l2.75 1.25L12 16l1.25-2.75L16 12z' })
	  );
	};
	ImagePhotoFilter = (0, _pure2.default)(ImagePhotoFilter);
	ImagePhotoFilter.displayName = 'ImagePhotoFilter';
	ImagePhotoFilter.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoFilter;

/***/ },
/* 1605 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoLibrary = function ImagePhotoLibrary(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 16V4c0-1.1-.9-2-2-2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2zm-11-4l2.03 2.71L16 11l4 5H8l3-4zM2 6v14c0 1.1.9 2 2 2h14v-2H4V6H2z' })
	  );
	};
	ImagePhotoLibrary = (0, _pure2.default)(ImagePhotoLibrary);
	ImagePhotoLibrary.displayName = 'ImagePhotoLibrary';
	ImagePhotoLibrary.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoLibrary;

/***/ },
/* 1606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoSizeSelectActual = function ImagePhotoSizeSelectActual(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3C2 3 1 4 1 5v14c0 1.1.9 2 2 2h18c1 0 2-1 2-2V5c0-1-1-2-2-2zM5 17l3.5-4.5 2.5 3.01L14.5 11l4.5 6H5z' })
	  );
	};
	ImagePhotoSizeSelectActual = (0, _pure2.default)(ImagePhotoSizeSelectActual);
	ImagePhotoSizeSelectActual.displayName = 'ImagePhotoSizeSelectActual';
	ImagePhotoSizeSelectActual.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoSizeSelectActual;

/***/ },
/* 1607 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoSizeSelectLarge = function ImagePhotoSizeSelectLarge(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 15h2v2h-2v-2zm0-4h2v2h-2v-2zm2 8h-2v2c1 0 2-1 2-2zM13 3h2v2h-2V3zm8 4h2v2h-2V7zm0-4v2h2c0-1-1-2-2-2zM1 7h2v2H1V7zm16-4h2v2h-2V3zm0 16h2v2h-2v-2zM3 3C2 3 1 4 1 5h2V3zm6 0h2v2H9V3zM5 3h2v2H5V3zm-4 8v8c0 1.1.9 2 2 2h12V11H1zm2 8l2.5-3.21 1.79 2.15 2.5-3.22L13 19H3z' })
	  );
	};
	ImagePhotoSizeSelectLarge = (0, _pure2.default)(ImagePhotoSizeSelectLarge);
	ImagePhotoSizeSelectLarge.displayName = 'ImagePhotoSizeSelectLarge';
	ImagePhotoSizeSelectLarge.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoSizeSelectLarge;

/***/ },
/* 1608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhotoSizeSelectSmall = function ImagePhotoSizeSelectSmall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M23 15h-2v2h2v-2zm0-4h-2v2h2v-2zm0 8h-2v2c1 0 2-1 2-2zM15 3h-2v2h2V3zm8 4h-2v2h2V7zm-2-4v2h2c0-1-1-2-2-2zM3 21h8v-6H1v4c0 1.1.9 2 2 2zM3 7H1v2h2V7zm12 12h-2v2h2v-2zm4-16h-2v2h2V3zm0 16h-2v2h2v-2zM3 3C2 3 1 4 1 5h2V3zm0 8H1v2h2v-2zm8-8H9v2h2V3zM7 3H5v2h2V3z' })
	  );
	};
	ImagePhotoSizeSelectSmall = (0, _pure2.default)(ImagePhotoSizeSelectSmall);
	ImagePhotoSizeSelectSmall.displayName = 'ImagePhotoSizeSelectSmall';
	ImagePhotoSizeSelectSmall.muiName = 'SvgIcon';
	
	exports.default = ImagePhotoSizeSelectSmall;

/***/ },
/* 1609 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePhoto = function ImagePhoto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 19V5c0-1.1-.9-2-2-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2zM8.5 13.5l2.5 3.01L14.5 12l4.5 6H5l3.5-4.5z' })
	  );
	};
	ImagePhoto = (0, _pure2.default)(ImagePhoto);
	ImagePhoto.displayName = 'ImagePhoto';
	ImagePhoto.muiName = 'SvgIcon';
	
	exports.default = ImagePhoto;

/***/ },
/* 1610 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePictureAsPdf = function ImagePictureAsPdf(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H8c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-8.5 7.5c0 .83-.67 1.5-1.5 1.5H9v2H7.5V7H10c.83 0 1.5.67 1.5 1.5v1zm5 2c0 .83-.67 1.5-1.5 1.5h-2.5V7H15c.83 0 1.5.67 1.5 1.5v3zm4-3H19v1h1.5V11H19v2h-1.5V7h3v1.5zM9 9.5h1v-1H9v1zM4 6H2v14c0 1.1.9 2 2 2h14v-2H4V6zm10 5.5h1v-3h-1v3z' })
	  );
	};
	ImagePictureAsPdf = (0, _pure2.default)(ImagePictureAsPdf);
	ImagePictureAsPdf.displayName = 'ImagePictureAsPdf';
	ImagePictureAsPdf.muiName = 'SvgIcon';
	
	exports.default = ImagePictureAsPdf;

/***/ },
/* 1611 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImagePortrait = function ImagePortrait(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 12.25c1.24 0 2.25-1.01 2.25-2.25S13.24 7.75 12 7.75 9.75 8.76 9.75 10s1.01 2.25 2.25 2.25zm4.5 4c0-1.5-3-2.25-4.5-2.25s-4.5.75-4.5 2.25V17h9v-.75zM19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
	  );
	};
	ImagePortrait = (0, _pure2.default)(ImagePortrait);
	ImagePortrait.displayName = 'ImagePortrait';
	ImagePortrait.muiName = 'SvgIcon';
	
	exports.default = ImagePortrait;

/***/ },
/* 1612 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRemoveRedEye = function ImageRemoveRedEye(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4.5C7 4.5 2.73 7.61 1 12c1.73 4.39 6 7.5 11 7.5s9.27-3.11 11-7.5c-1.73-4.39-6-7.5-11-7.5zM12 17c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5zm0-8c-1.66 0-3 1.34-3 3s1.34 3 3 3 3-1.34 3-3-1.34-3-3-3z' })
	  );
	};
	ImageRemoveRedEye = (0, _pure2.default)(ImageRemoveRedEye);
	ImageRemoveRedEye.displayName = 'ImageRemoveRedEye';
	ImageRemoveRedEye.muiName = 'SvgIcon';
	
	exports.default = ImageRemoveRedEye;

/***/ },
/* 1613 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRotate90DegreesCcw = function ImageRotate90DegreesCcw(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.34 6.41L.86 12.9l6.49 6.48 6.49-6.48-6.5-6.49zM3.69 12.9l3.66-3.66L11 12.9l-3.66 3.66-3.65-3.66zm15.67-6.26C17.61 4.88 15.3 4 13 4V.76L8.76 5 13 9.24V6c1.79 0 3.58.68 4.95 2.05 2.73 2.73 2.73 7.17 0 9.9C16.58 19.32 14.79 20 13 20c-.97 0-1.94-.21-2.84-.61l-1.49 1.49C10.02 21.62 11.51 22 13 22c2.3 0 4.61-.88 6.36-2.64 3.52-3.51 3.52-9.21 0-12.72z' })
	  );
	};
	ImageRotate90DegreesCcw = (0, _pure2.default)(ImageRotate90DegreesCcw);
	ImageRotate90DegreesCcw.displayName = 'ImageRotate90DegreesCcw';
	ImageRotate90DegreesCcw.muiName = 'SvgIcon';
	
	exports.default = ImageRotate90DegreesCcw;

/***/ },
/* 1614 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRotateLeft = function ImageRotateLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.11 8.53L5.7 7.11C4.8 8.27 4.24 9.61 4.07 11h2.02c.14-.87.49-1.72 1.02-2.47zM6.09 13H4.07c.17 1.39.72 2.73 1.62 3.89l1.41-1.42c-.52-.75-.87-1.59-1.01-2.47zm1.01 5.32c1.16.9 2.51 1.44 3.9 1.61V17.9c-.87-.15-1.71-.49-2.46-1.03L7.1 18.32zM13 4.07V1L8.45 5.55 13 10V6.09c2.84.48 5 2.94 5 5.91s-2.16 5.43-5 5.91v2.02c3.95-.49 7-3.85 7-7.93s-3.05-7.44-7-7.93z' })
	  );
	};
	ImageRotateLeft = (0, _pure2.default)(ImageRotateLeft);
	ImageRotateLeft.displayName = 'ImageRotateLeft';
	ImageRotateLeft.muiName = 'SvgIcon';
	
	exports.default = ImageRotateLeft;

/***/ },
/* 1615 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageRotateRight = function ImageRotateRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.55 5.55L11 1v3.07C7.06 4.56 4 7.92 4 12s3.05 7.44 7 7.93v-2.02c-2.84-.48-5-2.94-5-5.91s2.16-5.43 5-5.91V10l4.55-4.45zM19.93 11c-.17-1.39-.72-2.73-1.62-3.89l-1.42 1.42c.54.75.88 1.6 1.02 2.47h2.02zM13 17.9v2.02c1.39-.17 2.74-.71 3.9-1.61l-1.44-1.44c-.75.54-1.59.89-2.46 1.03zm3.89-2.42l1.42 1.41c.9-1.16 1.45-2.5 1.62-3.89h-2.02c-.14.87-.48 1.72-1.02 2.48z' })
	  );
	};
	ImageRotateRight = (0, _pure2.default)(ImageRotateRight);
	ImageRotateRight.displayName = 'ImageRotateRight';
	ImageRotateRight.muiName = 'SvgIcon';
	
	exports.default = ImageRotateRight;

/***/ },
/* 1616 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSlideshow = function ImageSlideshow(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 8v8l5-4-5-4zm9-5H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V5h14v14z' })
	  );
	};
	ImageSlideshow = (0, _pure2.default)(ImageSlideshow);
	ImageSlideshow.displayName = 'ImageSlideshow';
	ImageSlideshow.muiName = 'SvgIcon';
	
	exports.default = ImageSlideshow;

/***/ },
/* 1617 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageStraighten = function ImageStraighten(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6H3c-1.1 0-2 .9-2 2v8c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm0 10H3V8h2v4h2V8h2v4h2V8h2v4h2V8h2v4h2V8h2v8z' })
	  );
	};
	ImageStraighten = (0, _pure2.default)(ImageStraighten);
	ImageStraighten.displayName = 'ImageStraighten';
	ImageStraighten.muiName = 'SvgIcon';
	
	exports.default = ImageStraighten;

/***/ },
/* 1618 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageStyle = function ImageStyle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2.53 19.65l1.34.56v-9.03l-2.43 5.86c-.41 1.02.08 2.19 1.09 2.61zm19.5-3.7L17.07 3.98c-.31-.75-1.04-1.21-1.81-1.23-.26 0-.53.04-.79.15L7.1 5.95c-.75.31-1.21 1.03-1.23 1.8-.01.27.04.54.15.8l4.96 11.97c.31.76 1.05 1.22 1.83 1.23.26 0 .52-.05.77-.15l7.36-3.05c1.02-.42 1.51-1.59 1.09-2.6zM7.88 8.75c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-2 11c0 1.1.9 2 2 2h1.45l-3.45-8.34v6.34z' })
	  );
	};
	ImageStyle = (0, _pure2.default)(ImageStyle);
	ImageStyle.displayName = 'ImageStyle';
	ImageStyle.muiName = 'SvgIcon';
	
	exports.default = ImageStyle;

/***/ },
/* 1619 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSwitchCamera = function ImageSwitchCamera(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-5 11.5V13H9v2.5L5.5 12 9 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
	  );
	};
	ImageSwitchCamera = (0, _pure2.default)(ImageSwitchCamera);
	ImageSwitchCamera.displayName = 'ImageSwitchCamera';
	ImageSwitchCamera.muiName = 'SvgIcon';
	
	exports.default = ImageSwitchCamera;

/***/ },
/* 1620 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageSwitchVideo = function ImageSwitchVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 9.5V6c0-.55-.45-1-1-1H3c-.55 0-1 .45-1 1v12c0 .55.45 1 1 1h14c.55 0 1-.45 1-1v-3.5l4 4v-13l-4 4zm-5 6V13H7v2.5L3.5 12 7 8.5V11h6V8.5l3.5 3.5-3.5 3.5z' })
	  );
	};
	ImageSwitchVideo = (0, _pure2.default)(ImageSwitchVideo);
	ImageSwitchVideo.displayName = 'ImageSwitchVideo';
	ImageSwitchVideo.muiName = 'SvgIcon';
	
	exports.default = ImageSwitchVideo;

/***/ },
/* 1621 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTagFaces = function ImageTagFaces(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	ImageTagFaces = (0, _pure2.default)(ImageTagFaces);
	ImageTagFaces.displayName = 'ImageTagFaces';
	ImageTagFaces.muiName = 'SvgIcon';
	
	exports.default = ImageTagFaces;

/***/ },
/* 1622 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTexture = function ImageTexture(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.51 3.08L3.08 19.51c.09.34.27.65.51.9.25.24.56.42.9.51L20.93 4.49c-.19-.69-.73-1.23-1.42-1.41zM11.88 3L3 11.88v2.83L14.71 3h-2.83zM5 3c-1.1 0-2 .9-2 2v2l4-4H5zm14 18c.55 0 1.05-.22 1.41-.59.37-.36.59-.86.59-1.41v-2l-4 4h2zm-9.71 0h2.83L21 12.12V9.29L9.29 21z' })
	  );
	};
	ImageTexture = (0, _pure2.default)(ImageTexture);
	ImageTexture.displayName = 'ImageTexture';
	ImageTexture.muiName = 'SvgIcon';
	
	exports.default = ImageTexture;

/***/ },
/* 1623 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimelapse = function ImageTimelapse(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.24 7.76C15.07 6.59 13.54 6 12 6v6l-4.24 4.24c2.34 2.34 6.14 2.34 8.49 0 2.34-2.34 2.34-6.14-.01-8.48zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	ImageTimelapse = (0, _pure2.default)(ImageTimelapse);
	ImageTimelapse.displayName = 'ImageTimelapse';
	ImageTimelapse.muiName = 'SvgIcon';
	
	exports.default = ImageTimelapse;

/***/ },
/* 1624 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimer10 = function ImageTimer10(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M0 7.72V9.4l3-1V18h2V6h-.25L0 7.72zm23.78 6.65c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39 0-.14.03-.28.09-.41.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59C21.49 9.07 21 9 20.46 9c-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.69.23.96c.15.28.36.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02zm-9.96-7.32c-.34-.4-.75-.7-1.23-.88-.47-.18-1.01-.27-1.59-.27-.58 0-1.11.09-1.59.27-.48.18-.89.47-1.23.88-.34.41-.6.93-.79 1.59-.18.65-.28 1.45-.28 2.39v1.92c0 .94.09 1.74.28 2.39.19.66.45 1.19.8 1.6.34.41.75.71 1.23.89.48.18 1.01.28 1.59.28.59 0 1.12-.09 1.59-.28.48-.18.88-.48 1.22-.89.34-.41.6-.94.78-1.6.18-.65.28-1.45.28-2.39v-1.92c0-.94-.09-1.74-.28-2.39-.18-.66-.44-1.19-.78-1.59zm-.92 6.17c0 .6-.04 1.11-.12 1.53-.08.42-.2.76-.36 1.02-.16.26-.36.45-.59.57-.23.12-.51.18-.82.18-.3 0-.58-.06-.82-.18s-.44-.31-.6-.57c-.16-.26-.29-.6-.38-1.02-.09-.42-.13-.93-.13-1.53v-2.5c0-.6.04-1.11.13-1.52.09-.41.21-.74.38-1 .16-.25.36-.43.6-.55.24-.11.51-.17.81-.17.31 0 .58.06.81.17.24.11.44.29.6.55.16.25.29.58.37.99.08.41.13.92.13 1.52v2.51z' })
	  );
	};
	ImageTimer10 = (0, _pure2.default)(ImageTimer10);
	ImageTimer10.displayName = 'ImageTimer10';
	ImageTimer10.muiName = 'SvgIcon';
	
	exports.default = ImageTimer10;

/***/ },
/* 1625 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimer3 = function ImageTimer3(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.61 12.97c-.16-.24-.36-.46-.62-.65-.25-.19-.56-.35-.93-.48.3-.14.57-.3.8-.5.23-.2.42-.41.57-.64.15-.23.27-.46.34-.71.08-.24.11-.49.11-.73 0-.55-.09-1.04-.28-1.46-.18-.42-.44-.77-.78-1.06-.33-.28-.73-.5-1.2-.64-.45-.13-.97-.2-1.53-.2-.55 0-1.06.08-1.52.24-.47.17-.87.4-1.2.69-.33.29-.6.63-.78 1.03-.2.39-.29.83-.29 1.29h1.98c0-.26.05-.49.14-.69.09-.2.22-.38.38-.52.17-.14.36-.25.58-.33.22-.08.46-.12.73-.12.61 0 1.06.16 1.36.47.3.31.44.75.44 1.32 0 .27-.04.52-.12.74-.08.22-.21.41-.38.57-.17.16-.38.28-.63.37-.25.09-.55.13-.89.13H6.72v1.57H7.9c.34 0 .64.04.91.11.27.08.5.19.69.35.19.16.34.36.44.61.1.24.16.54.16.87 0 .62-.18 1.09-.53 1.42-.35.33-.84.49-1.45.49-.29 0-.56-.04-.8-.13-.24-.08-.44-.2-.61-.36-.17-.16-.3-.34-.39-.56-.09-.22-.14-.46-.14-.72H4.19c0 .55.11 1.03.32 1.45.21.42.5.77.86 1.05s.77.49 1.24.63.96.21 1.48.21c.57 0 1.09-.08 1.58-.23.49-.15.91-.38 1.26-.68.36-.3.64-.66.84-1.1.2-.43.3-.93.3-1.48 0-.29-.04-.58-.11-.86-.08-.25-.19-.51-.35-.76zm9.26 1.4c-.14-.28-.35-.53-.63-.74-.28-.21-.61-.39-1.01-.53s-.85-.27-1.35-.38c-.35-.07-.64-.15-.87-.23-.23-.08-.41-.16-.55-.25-.14-.09-.23-.19-.28-.3-.05-.11-.08-.24-.08-.39s.03-.28.09-.41c.06-.13.15-.25.27-.34.12-.1.27-.18.45-.24s.4-.09.64-.09c.25 0 .47.04.66.11.19.07.35.17.48.29.13.12.22.26.29.42.06.16.1.32.1.49h1.95c0-.39-.08-.75-.24-1.09-.16-.34-.39-.63-.69-.88-.3-.25-.66-.44-1.09-.59-.43-.15-.92-.22-1.46-.22-.51 0-.98.07-1.39.21-.41.14-.77.33-1.06.57-.29.24-.51.52-.67.84-.16.32-.23.65-.23 1.01s.08.68.23.96c.15.28.37.52.64.73.27.21.6.38.98.53.38.14.81.26 1.27.36.39.08.71.17.95.26s.43.19.57.29c.13.1.22.22.27.34.05.12.07.25.07.39 0 .32-.13.57-.4.77-.27.2-.66.29-1.17.29-.22 0-.43-.02-.64-.08-.21-.05-.4-.13-.56-.24-.17-.11-.3-.26-.41-.44-.11-.18-.17-.41-.18-.67h-1.89c0 .36.08.71.24 1.05.16.34.39.65.7.93.31.27.69.49 1.15.66.46.17.98.25 1.58.25.53 0 1.01-.06 1.44-.19.43-.13.8-.31 1.11-.54.31-.23.54-.51.71-.83.17-.32.25-.67.25-1.06-.02-.4-.09-.74-.24-1.02z' })
	  );
	};
	ImageTimer3 = (0, _pure2.default)(ImageTimer3);
	ImageTimer3.displayName = 'ImageTimer3';
	ImageTimer3.muiName = 'SvgIcon';
	
	exports.default = ImageTimer3;

/***/ },
/* 1626 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimerOff = function ImageTimerOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.04 4.55l-1.42 1.42C16.07 4.74 14.12 4 12 4c-1.83 0-3.53.55-4.95 1.48l1.46 1.46C9.53 6.35 10.73 6 12 6c3.87 0 7 3.13 7 7 0 1.27-.35 2.47-.94 3.49l1.45 1.45C20.45 16.53 21 14.83 21 13c0-2.12-.74-4.07-1.97-5.61l1.42-1.42-1.41-1.42zM15 1H9v2h6V1zm-4 8.44l2 2V8h-2v1.44zM3.02 4L1.75 5.27 4.5 8.03C3.55 9.45 3 11.16 3 13c0 4.97 4.02 9 9 9 1.84 0 3.55-.55 4.98-1.5l2.5 2.5 1.27-1.27-7.71-7.71L3.02 4zM12 20c-3.87 0-7-3.13-7-7 0-1.28.35-2.48.95-3.52l9.56 9.56c-1.03.61-2.23.96-3.51.96z' })
	  );
	};
	ImageTimerOff = (0, _pure2.default)(ImageTimerOff);
	ImageTimerOff.displayName = 'ImageTimerOff';
	ImageTimerOff.muiName = 'SvgIcon';
	
	exports.default = ImageTimerOff;

/***/ },
/* 1627 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTimer = function ImageTimer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 1H9v2h6V1zm-4 13h2V8h-2v6zm8.03-6.61l1.42-1.42c-.43-.51-.9-.99-1.41-1.41l-1.42 1.42C16.07 4.74 14.12 4 12 4c-4.97 0-9 4.03-9 9s4.02 9 9 9 9-4.03 9-9c0-2.12-.74-4.07-1.97-5.61zM12 20c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	ImageTimer = (0, _pure2.default)(ImageTimer);
	ImageTimer.displayName = 'ImageTimer';
	ImageTimer.muiName = 'SvgIcon';
	
	exports.default = ImageTimer;

/***/ },
/* 1628 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTonality = function ImageTonality(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.94-.49-7-3.85-7-7.93s3.05-7.44 7-7.93v15.86zm2-15.86c1.03.13 2 .45 2.87.93H13v-.93zM13 7h5.24c.25.31.48.65.68 1H13V7zm0 3h6.74c.08.33.15.66.19 1H13v-1zm0 9.93V19h2.87c-.87.48-1.84.8-2.87.93zM18.24 17H13v-1h5.92c-.2.35-.43.69-.68 1zm1.5-3H13v-1h6.93c-.04.34-.11.67-.19 1z' })
	  );
	};
	ImageTonality = (0, _pure2.default)(ImageTonality);
	ImageTonality.displayName = 'ImageTonality';
	ImageTonality.muiName = 'SvgIcon';
	
	exports.default = ImageTonality;

/***/ },
/* 1629 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTransform = function ImageTransform(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 18v-2H8V4h2L7 1 4 4h2v2H2v2h4v8c0 1.1.9 2 2 2h8v2h-2l3 3 3-3h-2v-2h4zM10 8h6v6h2V8c0-1.1-.9-2-2-2h-6v2z' })
	  );
	};
	ImageTransform = (0, _pure2.default)(ImageTransform);
	ImageTransform.displayName = 'ImageTransform';
	ImageTransform.muiName = 'SvgIcon';
	
	exports.default = ImageTransform;

/***/ },
/* 1630 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageTune = function ImageTune(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 17v2h6v-2H3zM3 5v2h10V5H3zm10 16v-2h8v-2h-8v-2h-2v6h2zM7 9v2H3v2h4v2h2V9H7zm14 4v-2H11v2h10zm-6-4h2V7h4V5h-4V3h-2v6z' })
	  );
	};
	ImageTune = (0, _pure2.default)(ImageTune);
	ImageTune.displayName = 'ImageTune';
	ImageTune.muiName = 'SvgIcon';
	
	exports.default = ImageTune;

/***/ },
/* 1631 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageViewComfy = function ImageViewComfy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 9h4V5H3v4zm0 5h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zM8 9h4V5H8v4zm5-4v4h4V5h-4zm5 9h4v-4h-4v4zM3 19h4v-4H3v4zm5 0h4v-4H8v4zm5 0h4v-4h-4v4zm5 0h4v-4h-4v4zm0-14v4h4V5h-4z' })
	  );
	};
	ImageViewComfy = (0, _pure2.default)(ImageViewComfy);
	ImageViewComfy.displayName = 'ImageViewComfy';
	ImageViewComfy.muiName = 'SvgIcon';
	
	exports.default = ImageViewComfy;

/***/ },
/* 1632 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageViewCompact = function ImageViewCompact(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 19h6v-7H3v7zm7 0h12v-7H10v7zM3 5v6h19V5H3z' })
	  );
	};
	ImageViewCompact = (0, _pure2.default)(ImageViewCompact);
	ImageViewCompact.displayName = 'ImageViewCompact';
	ImageViewCompact.muiName = 'SvgIcon';
	
	exports.default = ImageViewCompact;

/***/ },
/* 1633 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageVignette = function ImageVignette(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-9 15c-4.42 0-8-2.69-8-6s3.58-6 8-6 8 2.69 8 6-3.58 6-8 6z' })
	  );
	};
	ImageVignette = (0, _pure2.default)(ImageVignette);
	ImageVignette.displayName = 'ImageVignette';
	ImageVignette.muiName = 'SvgIcon';
	
	exports.default = ImageVignette;

/***/ },
/* 1634 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbAuto = function ImageWbAuto(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.85 12.65h2.3L8 9l-1.15 3.65zM22 7l-1.2 6.29L19.3 7h-1.6l-1.49 6.29L15 7h-.76C12.77 5.17 10.53 4 8 4c-4.42 0-8 3.58-8 8s3.58 8 8 8c3.13 0 5.84-1.81 7.15-4.43l.1.43H17l1.5-6.1L20 16h1.75l2.05-9H22zm-11.7 9l-.7-2H6.4l-.7 2H3.8L7 7h2l3.2 9h-1.9z' })
	  );
	};
	ImageWbAuto = (0, _pure2.default)(ImageWbAuto);
	ImageWbAuto.displayName = 'ImageWbAuto';
	ImageWbAuto.muiName = 'SvgIcon';
	
	exports.default = ImageWbAuto;

/***/ },
/* 1635 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbCloudy = function ImageWbCloudy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.36 10.04C18.67 6.59 15.64 4 12 4 9.11 4 6.6 5.64 5.35 8.04 2.34 8.36 0 10.91 0 14c0 3.31 2.69 6 6 6h13c2.76 0 5-2.24 5-5 0-2.64-2.05-4.78-4.64-4.96z' })
	  );
	};
	ImageWbCloudy = (0, _pure2.default)(ImageWbCloudy);
	ImageWbCloudy.displayName = 'ImageWbCloudy';
	ImageWbCloudy.muiName = 'SvgIcon';
	
	exports.default = ImageWbCloudy;

/***/ },
/* 1636 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbIncandescent = function ImageWbIncandescent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3.55 18.54l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8zM11 22.45h2V19.5h-2v2.95zM4 10.5H1v2h3v-2zm11-4.19V1.5H9v4.81C7.21 7.35 6 9.28 6 11.5c0 3.31 2.69 6 6 6s6-2.69 6-6c0-2.22-1.21-4.15-3-5.19zm5 4.19v2h3v-2h-3zm-2.76 7.66l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4z' })
	  );
	};
	ImageWbIncandescent = (0, _pure2.default)(ImageWbIncandescent);
	ImageWbIncandescent.displayName = 'ImageWbIncandescent';
	ImageWbIncandescent.muiName = 'SvgIcon';
	
	exports.default = ImageWbIncandescent;

/***/ },
/* 1637 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbIridescent = function ImageWbIridescent(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 14.5h14v-6H5v6zM11 .55V3.5h2V.55h-2zm8.04 2.5l-1.79 1.79 1.41 1.41 1.8-1.79-1.42-1.41zM13 22.45V19.5h-2v2.95h2zm7.45-3.91l-1.8-1.79-1.41 1.41 1.79 1.8 1.42-1.42zM3.55 4.46l1.79 1.79 1.41-1.41-1.79-1.79-1.41 1.41zm1.41 15.49l1.79-1.8-1.41-1.41-1.79 1.79 1.41 1.42z' })
	  );
	};
	ImageWbIridescent = (0, _pure2.default)(ImageWbIridescent);
	ImageWbIridescent.displayName = 'ImageWbIridescent';
	ImageWbIridescent.muiName = 'SvgIcon';
	
	exports.default = ImageWbIridescent;

/***/ },
/* 1638 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ImageWbSunny = function ImageWbSunny(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.76 4.84l-1.8-1.79-1.41 1.41 1.79 1.79 1.42-1.41zM4 10.5H1v2h3v-2zm9-9.95h-2V3.5h2V.55zm7.45 3.91l-1.41-1.41-1.79 1.79 1.41 1.41 1.79-1.79zm-3.21 13.7l1.79 1.8 1.41-1.41-1.8-1.79-1.4 1.4zM20 10.5v2h3v-2h-3zm-8-5c-3.31 0-6 2.69-6 6s2.69 6 6 6 6-2.69 6-6-2.69-6-6-6zm-1 16.95h2V19.5h-2v2.95zm-7.45-3.91l1.41 1.41 1.79-1.8-1.41-1.41-1.79 1.8z' })
	  );
	};
	ImageWbSunny = (0, _pure2.default)(ImageWbSunny);
	ImageWbSunny.displayName = 'ImageWbSunny';
	ImageWbSunny.muiName = 'SvgIcon';
	
	exports.default = ImageWbSunny;

/***/ },
/* 1639 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsAddLocation = function MapsAddLocation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm4 8h-3v3h-2v-3H8V8h3V5h2v3h3v2z' })
	  );
	};
	MapsAddLocation = (0, _pure2.default)(MapsAddLocation);
	MapsAddLocation.displayName = 'MapsAddLocation';
	MapsAddLocation.muiName = 'SvgIcon';
	
	exports.default = MapsAddLocation;

/***/ },
/* 1640 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsBeenhere = function MapsBeenhere(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 1H5c-1.1 0-1.99.9-1.99 2L3 15.93c0 .69.35 1.3.88 1.66L12 23l8.11-5.41c.53-.36.88-.97.88-1.66L21 3c0-1.1-.9-2-2-2zm-9 15l-5-5 1.41-1.41L10 13.17l7.59-7.59L19 7l-9 9z' })
	  );
	};
	MapsBeenhere = (0, _pure2.default)(MapsBeenhere);
	MapsBeenhere.displayName = 'MapsBeenhere';
	MapsBeenhere.muiName = 'SvgIcon';
	
	exports.default = MapsBeenhere;

/***/ },
/* 1641 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsBike = function MapsDirectionsBike(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5zm5.8-10l2.4-2.4.8.8c1.3 1.3 3 2.1 5.1 2.1V9c-1.5 0-2.7-.6-3.6-1.5l-1.9-1.9c-.5-.4-1-.6-1.6-.6s-1.1.2-1.4.6L7.8 8.4c-.4.4-.6.9-.6 1.4 0 .6.2 1.1.6 1.4L11 14v5h2v-6.2l-2.2-2.3zM19 12c-2.8 0-5 2.2-5 5s2.2 5 5 5 5-2.2 5-5-2.2-5-5-5zm0 8.5c-1.9 0-3.5-1.6-3.5-3.5s1.6-3.5 3.5-3.5 3.5 1.6 3.5 3.5-1.6 3.5-3.5 3.5z' })
	  );
	};
	MapsDirectionsBike = (0, _pure2.default)(MapsDirectionsBike);
	MapsDirectionsBike.displayName = 'MapsDirectionsBike';
	MapsDirectionsBike.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsBike;

/***/ },
/* 1642 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsBoat = function MapsDirectionsBoat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 21c-1.39 0-2.78-.47-4-1.32-2.44 1.71-5.56 1.71-8 0C6.78 20.53 5.39 21 4 21H2v2h2c1.38 0 2.74-.35 4-.99 2.52 1.29 5.48 1.29 8 0 1.26.65 2.62.99 4 .99h2v-2h-2zM3.95 19H4c1.6 0 3.02-.88 4-2 .98 1.12 2.4 2 4 2s3.02-.88 4-2c.98 1.12 2.4 2 4 2h.05l1.89-6.68c.08-.26.06-.54-.06-.78s-.34-.42-.6-.5L20 10.62V6c0-1.1-.9-2-2-2h-3V1H9v3H6c-1.1 0-2 .9-2 2v4.62l-1.29.42c-.26.08-.48.26-.6.5s-.15.52-.06.78L3.95 19zM6 6h12v3.97L12 8 6 9.97V6z' })
	  );
	};
	MapsDirectionsBoat = (0, _pure2.default)(MapsDirectionsBoat);
	MapsDirectionsBoat.displayName = 'MapsDirectionsBoat';
	MapsDirectionsBoat.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsBoat;

/***/ },
/* 1643 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsBus = function MapsDirectionsBus(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 16c0 .88.39 1.67 1 2.22V20c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h8v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1.78c.61-.55 1-1.34 1-2.22V6c0-3.5-3.58-4-8-4s-8 .5-8 4v10zm3.5 1c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm9 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6H6V6h12v5z' })
	  );
	};
	MapsDirectionsBus = (0, _pure2.default)(MapsDirectionsBus);
	MapsDirectionsBus.displayName = 'MapsDirectionsBus';
	MapsDirectionsBus.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsBus;

/***/ },
/* 1644 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsCar = function MapsDirectionsCar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5h-11c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' })
	  );
	};
	MapsDirectionsCar = (0, _pure2.default)(MapsDirectionsCar);
	MapsDirectionsCar.displayName = 'MapsDirectionsCar';
	MapsDirectionsCar.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsCar;

/***/ },
/* 1645 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsRailway = function MapsDirectionsRailway(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 15.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V5c0-3.5-3.58-4-8-4s-8 .5-8 4v10.5zm8 1.5c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2zm6-7H6V5h12v5z' })
	  );
	};
	MapsDirectionsRailway = (0, _pure2.default)(MapsDirectionsRailway);
	MapsDirectionsRailway.displayName = 'MapsDirectionsRailway';
	MapsDirectionsRailway.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsRailway;

/***/ },
/* 1646 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsRun = function MapsDirectionsRun(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.49 5.48c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm-3.6 13.9l1-4.4 2.1 2v6h2v-7.5l-2.1-2 .6-3c1.3 1.5 3.3 2.5 5.5 2.5v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1l-5.2 2.2v4.7h2v-3.4l1.8-.7-1.6 8.1-4.9-1-.4 2 7 1.4z' })
	  );
	};
	MapsDirectionsRun = (0, _pure2.default)(MapsDirectionsRun);
	MapsDirectionsRun.displayName = 'MapsDirectionsRun';
	MapsDirectionsRun.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsRun;

/***/ },
/* 1647 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsSubway = function MapsDirectionsSubway(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z' })
	  );
	};
	MapsDirectionsSubway = (0, _pure2.default)(MapsDirectionsSubway);
	MapsDirectionsSubway.displayName = 'MapsDirectionsSubway';
	MapsDirectionsSubway.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsSubway;

/***/ },
/* 1648 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsTransit = function MapsDirectionsTransit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c-4.42 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h12v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-6H6V6h5v5zm5.5 6c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm1.5-6h-5V6h5v5z' })
	  );
	};
	MapsDirectionsTransit = (0, _pure2.default)(MapsDirectionsTransit);
	MapsDirectionsTransit.displayName = 'MapsDirectionsTransit';
	MapsDirectionsTransit.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsTransit;

/***/ },
/* 1649 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirectionsWalk = function MapsDirectionsWalk(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM9.8 8.9L7 23h2.1l1.8-8 2.1 2v6h2v-7.5l-2.1-2 .6-3C14.8 12 16.8 13 19 13v-2c-1.9 0-3.5-1-4.3-2.4l-1-1.6c-.4-.6-1-1-1.7-1-.3 0-.5.1-.8.1L6 8.3V13h2V9.6l1.8-.7' })
	  );
	};
	MapsDirectionsWalk = (0, _pure2.default)(MapsDirectionsWalk);
	MapsDirectionsWalk.displayName = 'MapsDirectionsWalk';
	MapsDirectionsWalk.muiName = 'SvgIcon';
	
	exports.default = MapsDirectionsWalk;

/***/ },
/* 1650 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsDirections = function MapsDirections(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.71 11.29l-9-9c-.39-.39-1.02-.39-1.41 0l-9 9c-.39.39-.39 1.02 0 1.41l9 9c.39.39 1.02.39 1.41 0l9-9c.39-.38.39-1.01 0-1.41zM14 14.5V12h-4v3H8v-4c0-.55.45-1 1-1h5V7.5l3.5 3.5-3.5 3.5z' })
	  );
	};
	MapsDirections = (0, _pure2.default)(MapsDirections);
	MapsDirections.displayName = 'MapsDirections';
	MapsDirections.muiName = 'SvgIcon';
	
	exports.default = MapsDirections;

/***/ },
/* 1651 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsEditLocation = function MapsEditLocation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm-1.56 10H9v-1.44l3.35-3.34 1.43 1.43L10.44 12zm4.45-4.45l-.7.7-1.44-1.44.7-.7c.15-.15.39-.15.54 0l.9.9c.15.15.15.39 0 .54z' })
	  );
	};
	MapsEditLocation = (0, _pure2.default)(MapsEditLocation);
	MapsEditLocation.displayName = 'MapsEditLocation';
	MapsEditLocation.muiName = 'SvgIcon';
	
	exports.default = MapsEditLocation;

/***/ },
/* 1652 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsEvStation = function MapsEvStation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM18 10c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zM8 18v-4.5H6L10 6v5h2l-4 7z' })
	  );
	};
	MapsEvStation = (0, _pure2.default)(MapsEvStation);
	MapsEvStation.displayName = 'MapsEvStation';
	MapsEvStation.muiName = 'SvgIcon';
	
	exports.default = MapsEvStation;

/***/ },
/* 1653 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsFlight = function MapsFlight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10.18 9' }),
	    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
	  );
	};
	MapsFlight = (0, _pure2.default)(MapsFlight);
	MapsFlight.displayName = 'MapsFlight';
	MapsFlight.muiName = 'SvgIcon';
	
	exports.default = MapsFlight;

/***/ },
/* 1654 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsHotel = function MapsHotel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
	  );
	};
	MapsHotel = (0, _pure2.default)(MapsHotel);
	MapsHotel.displayName = 'MapsHotel';
	MapsHotel.muiName = 'SvgIcon';
	
	exports.default = MapsHotel;

/***/ },
/* 1655 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLayersClear = function MapsLayersClear(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.81 14.99l1.19-.92-1.43-1.43-1.19.92 1.43 1.43zm-.45-4.72L21 9l-9-7-2.91 2.27 7.87 7.88 2.4-1.88zM3.27 1L2 2.27l4.22 4.22L3 9l1.63 1.27L12 16l2.1-1.63 1.43 1.43L12 18.54l-7.37-5.73L3 14.07l9 7 4.95-3.85L20.73 21 22 19.73 3.27 1z' })
	  );
	};
	MapsLayersClear = (0, _pure2.default)(MapsLayersClear);
	MapsLayersClear.displayName = 'MapsLayersClear';
	MapsLayersClear.muiName = 'SvgIcon';
	
	exports.default = MapsLayersClear;

/***/ },
/* 1656 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLayers = function MapsLayers(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 18.54l-7.37-5.73L3 14.07l9 7 9-7-1.63-1.27-7.38 5.74zM12 16l7.36-5.73L21 9l-9-7-9 7 1.63 1.27L12 16z' })
	  );
	};
	MapsLayers = (0, _pure2.default)(MapsLayers);
	MapsLayers.displayName = 'MapsLayers';
	MapsLayers.muiName = 'SvgIcon';
	
	exports.default = MapsLayers;

/***/ },
/* 1657 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalActivity = function MapsLocalActivity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z' })
	  );
	};
	MapsLocalActivity = (0, _pure2.default)(MapsLocalActivity);
	MapsLocalActivity.displayName = 'MapsLocalActivity';
	MapsLocalActivity.muiName = 'SvgIcon';
	
	exports.default = MapsLocalActivity;

/***/ },
/* 1658 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalAirport = function MapsLocalAirport(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 16v-2l-8-5V3.5c0-.83-.67-1.5-1.5-1.5S10 2.67 10 3.5V9l-8 5v2l8-2.5V19l-2 1.5V22l3.5-1 3.5 1v-1.5L13 19v-5.5l8 2.5z' })
	  );
	};
	MapsLocalAirport = (0, _pure2.default)(MapsLocalAirport);
	MapsLocalAirport.displayName = 'MapsLocalAirport';
	MapsLocalAirport.muiName = 'SvgIcon';
	
	exports.default = MapsLocalAirport;

/***/ },
/* 1659 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalAtm = function MapsLocalAtm(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 17h2v-1h1c.55 0 1-.45 1-1v-3c0-.55-.45-1-1-1h-3v-1h4V8h-2V7h-2v1h-1c-.55 0-1 .45-1 1v3c0 .55.45 1 1 1h3v1H9v2h2v1zm9-13H4c-1.11 0-1.99.89-1.99 2L2 18c0 1.11.89 2 2 2h16c1.11 0 2-.89 2-2V6c0-1.11-.89-2-2-2zm0 14H4V6h16v12z' })
	  );
	};
	MapsLocalAtm = (0, _pure2.default)(MapsLocalAtm);
	MapsLocalAtm.displayName = 'MapsLocalAtm';
	MapsLocalAtm.muiName = 'SvgIcon';
	
	exports.default = MapsLocalAtm;

/***/ },
/* 1660 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalBar = function MapsLocalBar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5V3H3v2l8 9v5H6v2h12v-2h-5v-5l8-9zM7.43 7L5.66 5h12.69l-1.78 2H7.43z' })
	  );
	};
	MapsLocalBar = (0, _pure2.default)(MapsLocalBar);
	MapsLocalBar.displayName = 'MapsLocalBar';
	MapsLocalBar.muiName = 'SvgIcon';
	
	exports.default = MapsLocalBar;

/***/ },
/* 1661 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalCafe = function MapsLocalCafe(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.89 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM2 21h18v-2H2v2z' })
	  );
	};
	MapsLocalCafe = (0, _pure2.default)(MapsLocalCafe);
	MapsLocalCafe.displayName = 'MapsLocalCafe';
	MapsLocalCafe.muiName = 'SvgIcon';
	
	exports.default = MapsLocalCafe;

/***/ },
/* 1662 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalCarWash = function MapsLocalCarWash(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 5c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zm-5 0c.83 0 1.5-.67 1.5-1.5 0-1-1.5-2.7-1.5-2.7s-1.5 1.7-1.5 2.7c0 .83.67 1.5 1.5 1.5zM7 5c.83 0 1.5-.67 1.5-1.5C8.5 2.5 7 .8 7 .8S5.5 2.5 5.5 3.5C5.5 4.33 6.17 5 7 5zm11.92 3.01C18.72 7.42 18.16 7 17.5 7h-11c-.66 0-1.21.42-1.42 1.01L3 14v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 18c-.83 0-1.5-.67-1.5-1.5S5.67 15 6.5 15s1.5.67 1.5 1.5S7.33 18 6.5 18zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 13l1.5-4.5h11L19 13H5z' })
	  );
	};
	MapsLocalCarWash = (0, _pure2.default)(MapsLocalCarWash);
	MapsLocalCarWash.displayName = 'MapsLocalCarWash';
	MapsLocalCarWash.muiName = 'SvgIcon';
	
	exports.default = MapsLocalCarWash;

/***/ },
/* 1663 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalConvenienceStore = function MapsLocalConvenienceStore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 7V4H5v3H2v13h8v-4h4v4h8V7h-3zm-8 3H9v1h2v1H8V9h2V8H8V7h3v3zm5 2h-1v-2h-2V7h1v2h1V7h1v5z' })
	  );
	};
	MapsLocalConvenienceStore = (0, _pure2.default)(MapsLocalConvenienceStore);
	MapsLocalConvenienceStore.displayName = 'MapsLocalConvenienceStore';
	MapsLocalConvenienceStore.muiName = 'SvgIcon';
	
	exports.default = MapsLocalConvenienceStore;

/***/ },
/* 1664 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalDining = function MapsLocalDining(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z' })
	  );
	};
	MapsLocalDining = (0, _pure2.default)(MapsLocalDining);
	MapsLocalDining.displayName = 'MapsLocalDining';
	MapsLocalDining.muiName = 'SvgIcon';
	
	exports.default = MapsLocalDining;

/***/ },
/* 1665 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalDrink = function MapsLocalDrink(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 2l2.01 18.23C5.13 21.23 5.97 22 7 22h10c1.03 0 1.87-.77 1.99-1.77L21 2H3zm9 17c-1.66 0-3-1.34-3-3 0-2 3-5.4 3-5.4s3 3.4 3 5.4c0 1.66-1.34 3-3 3zm6.33-11H5.67l-.44-4h13.53l-.43 4z' })
	  );
	};
	MapsLocalDrink = (0, _pure2.default)(MapsLocalDrink);
	MapsLocalDrink.displayName = 'MapsLocalDrink';
	MapsLocalDrink.muiName = 'SvgIcon';
	
	exports.default = MapsLocalDrink;

/***/ },
/* 1666 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalFlorist = function MapsLocalFlorist(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c4.97 0 9-4.03 9-9-4.97 0-9 4.03-9 9zM5.6 10.25c0 1.38 1.12 2.5 2.5 2.5.53 0 1.01-.16 1.42-.44l-.02.19c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5l-.02-.19c.4.28.89.44 1.42.44 1.38 0 2.5-1.12 2.5-2.5 0-1-.59-1.85-1.43-2.25.84-.4 1.43-1.25 1.43-2.25 0-1.38-1.12-2.5-2.5-2.5-.53 0-1.01.16-1.42.44l.02-.19C14.5 2.12 13.38 1 12 1S9.5 2.12 9.5 3.5l.02.19c-.4-.28-.89-.44-1.42-.44-1.38 0-2.5 1.12-2.5 2.5 0 1 .59 1.85 1.43 2.25-.84.4-1.43 1.25-1.43 2.25zM12 5.5c1.38 0 2.5 1.12 2.5 2.5s-1.12 2.5-2.5 2.5S9.5 9.38 9.5 8s1.12-2.5 2.5-2.5zM3 13c0 4.97 4.03 9 9 9 0-4.97-4.03-9-9-9z' })
	  );
	};
	MapsLocalFlorist = (0, _pure2.default)(MapsLocalFlorist);
	MapsLocalFlorist.displayName = 'MapsLocalFlorist';
	MapsLocalFlorist.muiName = 'SvgIcon';
	
	exports.default = MapsLocalFlorist;

/***/ },
/* 1667 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalGasStation = function MapsLocalGasStation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.77 7.23l.01-.01-3.72-3.72L15 4.56l2.11 2.11c-.94.36-1.61 1.26-1.61 2.33 0 1.38 1.12 2.5 2.5 2.5.36 0 .69-.08 1-.21v7.21c0 .55-.45 1-1 1s-1-.45-1-1V14c0-1.1-.9-2-2-2h-1V5c0-1.1-.9-2-2-2H6c-1.1 0-2 .9-2 2v16h10v-7.5h1.5v5c0 1.38 1.12 2.5 2.5 2.5s2.5-1.12 2.5-2.5V9c0-.69-.28-1.32-.73-1.77zM12 10H6V5h6v5zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	MapsLocalGasStation = (0, _pure2.default)(MapsLocalGasStation);
	MapsLocalGasStation.displayName = 'MapsLocalGasStation';
	MapsLocalGasStation.muiName = 'SvgIcon';
	
	exports.default = MapsLocalGasStation;

/***/ },
/* 1668 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalGroceryStore = function MapsLocalGroceryStore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 18c-1.1 0-1.99.9-1.99 2S5.9 22 7 22s2-.9 2-2-.9-2-2-2zM1 2v2h2l3.6 7.59-1.35 2.45c-.16.28-.25.61-.25.96 0 1.1.9 2 2 2h12v-2H7.42c-.14 0-.25-.11-.25-.25l.03-.12.9-1.63h7.45c.75 0 1.41-.41 1.75-1.03l3.58-6.49c.08-.14.12-.31.12-.48 0-.55-.45-1-1-1H5.21l-.94-2H1zm16 16c-1.1 0-1.99.9-1.99 2s.89 2 1.99 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	MapsLocalGroceryStore = (0, _pure2.default)(MapsLocalGroceryStore);
	MapsLocalGroceryStore.displayName = 'MapsLocalGroceryStore';
	MapsLocalGroceryStore.muiName = 'SvgIcon';
	
	exports.default = MapsLocalGroceryStore;

/***/ },
/* 1669 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalHospital = function MapsLocalHospital(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-1.99.9-1.99 2L3 19c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-1 11h-4v4h-4v-4H6v-4h4V6h4v4h4v4z' })
	  );
	};
	MapsLocalHospital = (0, _pure2.default)(MapsLocalHospital);
	MapsLocalHospital.displayName = 'MapsLocalHospital';
	MapsLocalHospital.muiName = 'SvgIcon';
	
	exports.default = MapsLocalHospital;

/***/ },
/* 1670 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalHotel = function MapsLocalHotel(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 13c1.66 0 3-1.34 3-3S8.66 7 7 7s-3 1.34-3 3 1.34 3 3 3zm12-6h-8v7H3V5H1v15h2v-3h18v3h2v-9c0-2.21-1.79-4-4-4z' })
	  );
	};
	MapsLocalHotel = (0, _pure2.default)(MapsLocalHotel);
	MapsLocalHotel.displayName = 'MapsLocalHotel';
	MapsLocalHotel.muiName = 'SvgIcon';
	
	exports.default = MapsLocalHotel;

/***/ },
/* 1671 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalLaundryService = function MapsLocalLaundryService(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.17 16.83c1.56 1.56 4.1 1.56 5.66 0 1.56-1.56 1.56-4.1 0-5.66l-5.66 5.66zM18 2.01L6 2c-1.11 0-2 .89-2 2v16c0 1.11.89 2 2 2h12c1.11 0 2-.89 2-2V4c0-1.11-.89-1.99-2-1.99zM10 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zM7 4c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm5 16c-3.31 0-6-2.69-6-6s2.69-6 6-6 6 2.69 6 6-2.69 6-6 6z' })
	  );
	};
	MapsLocalLaundryService = (0, _pure2.default)(MapsLocalLaundryService);
	MapsLocalLaundryService.displayName = 'MapsLocalLaundryService';
	MapsLocalLaundryService.muiName = 'SvgIcon';
	
	exports.default = MapsLocalLaundryService;

/***/ },
/* 1672 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalLibrary = function MapsLocalLibrary(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 11.55C9.64 9.35 6.48 8 3 8v11c3.48 0 6.64 1.35 9 3.55 2.36-2.19 5.52-3.55 9-3.55V8c-3.48 0-6.64 1.35-9 3.55zM12 8c1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3 1.34 3 3 3z' })
	  );
	};
	MapsLocalLibrary = (0, _pure2.default)(MapsLocalLibrary);
	MapsLocalLibrary.displayName = 'MapsLocalLibrary';
	MapsLocalLibrary.muiName = 'SvgIcon';
	
	exports.default = MapsLocalLibrary;

/***/ },
/* 1673 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalMall = function MapsLocalMall(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6h-2c0-2.76-2.24-5-5-5S7 3.24 7 6H5c-1.1 0-1.99.9-1.99 2L3 20c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-7-3c1.66 0 3 1.34 3 3H9c0-1.66 1.34-3 3-3zm0 10c-2.76 0-5-2.24-5-5h2c0 1.66 1.34 3 3 3s3-1.34 3-3h2c0 2.76-2.24 5-5 5z' })
	  );
	};
	MapsLocalMall = (0, _pure2.default)(MapsLocalMall);
	MapsLocalMall.displayName = 'MapsLocalMall';
	MapsLocalMall.muiName = 'SvgIcon';
	
	exports.default = MapsLocalMall;

/***/ },
/* 1674 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalMovies = function MapsLocalMovies(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 3v2h-2V3H8v2H6V3H4v18h2v-2h2v2h8v-2h2v2h2V3h-2zM8 17H6v-2h2v2zm0-4H6v-2h2v2zm0-4H6V7h2v2zm10 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V7h2v2z' })
	  );
	};
	MapsLocalMovies = (0, _pure2.default)(MapsLocalMovies);
	MapsLocalMovies.displayName = 'MapsLocalMovies';
	MapsLocalMovies.muiName = 'SvgIcon';
	
	exports.default = MapsLocalMovies;

/***/ },
/* 1675 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalOffer = function MapsLocalOffer(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21.41 11.58l-9-9C12.05 2.22 11.55 2 11 2H4c-1.1 0-2 .9-2 2v7c0 .55.22 1.05.59 1.42l9 9c.36.36.86.58 1.41.58.55 0 1.05-.22 1.41-.59l7-7c.37-.36.59-.86.59-1.41 0-.55-.23-1.06-.59-1.42zM5.5 7C4.67 7 4 6.33 4 5.5S4.67 4 5.5 4 7 4.67 7 5.5 6.33 7 5.5 7z' })
	  );
	};
	MapsLocalOffer = (0, _pure2.default)(MapsLocalOffer);
	MapsLocalOffer.displayName = 'MapsLocalOffer';
	MapsLocalOffer.muiName = 'SvgIcon';
	
	exports.default = MapsLocalOffer;

/***/ },
/* 1676 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalParking = function MapsLocalParking(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 3H6v18h4v-6h3c3.31 0 6-2.69 6-6s-2.69-6-6-6zm.2 8H10V7h3.2c1.1 0 2 .9 2 2s-.9 2-2 2z' })
	  );
	};
	MapsLocalParking = (0, _pure2.default)(MapsLocalParking);
	MapsLocalParking.displayName = 'MapsLocalParking';
	MapsLocalParking.muiName = 'SvgIcon';
	
	exports.default = MapsLocalParking;

/***/ },
/* 1677 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPharmacy = function MapsLocalPharmacy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 5h-2.64l1.14-3.14L17.15 1l-1.46 4H3v2l2 6-2 6v2h18v-2l-2-6 2-6V5zm-5 9h-3v3h-2v-3H8v-2h3V9h2v3h3v2z' })
	  );
	};
	MapsLocalPharmacy = (0, _pure2.default)(MapsLocalPharmacy);
	MapsLocalPharmacy.displayName = 'MapsLocalPharmacy';
	MapsLocalPharmacy.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPharmacy;

/***/ },
/* 1678 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPhone = function MapsLocalPhone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24 1.12.37 2.33.57 3.57.57.55 0 1 .45 1 1V20c0 .55-.45 1-1 1-9.39 0-17-7.61-17-17 0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1 0 1.25.2 2.45.57 3.57.11.35.03.74-.25 1.02l-2.2 2.2z' })
	  );
	};
	MapsLocalPhone = (0, _pure2.default)(MapsLocalPhone);
	MapsLocalPhone.displayName = 'MapsLocalPhone';
	MapsLocalPhone.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPhone;

/***/ },
/* 1679 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPizza = function MapsLocalPizza(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.43 2 5.23 3.54 3.01 6L12 22l8.99-16C18.78 3.55 15.57 2 12 2zM7 7c0-1.1.9-2 2-2s2 .9 2 2-.9 2-2 2-2-.9-2-2zm5 8c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	MapsLocalPizza = (0, _pure2.default)(MapsLocalPizza);
	MapsLocalPizza.displayName = 'MapsLocalPizza';
	MapsLocalPizza.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPizza;

/***/ },
/* 1680 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPlay = function MapsLocalPlay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12c0-1.1.9-2 2-2V6c0-1.1-.9-2-2-2H4c-1.1 0-1.99.9-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2zm-4.42 4.8L12 14.5l-3.58 2.3 1.08-4.12-3.29-2.69 4.24-.25L12 5.8l1.54 3.95 4.24.25-3.29 2.69 1.09 4.11z' })
	  );
	};
	MapsLocalPlay = (0, _pure2.default)(MapsLocalPlay);
	MapsLocalPlay.displayName = 'MapsLocalPlay';
	MapsLocalPlay.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPlay;

/***/ },
/* 1681 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPostOffice = function MapsLocalPostOffice(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z' })
	  );
	};
	MapsLocalPostOffice = (0, _pure2.default)(MapsLocalPostOffice);
	MapsLocalPostOffice.displayName = 'MapsLocalPostOffice';
	MapsLocalPostOffice.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPostOffice;

/***/ },
/* 1682 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalPrintshop = function MapsLocalPrintshop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 8H5c-1.66 0-3 1.34-3 3v6h4v4h12v-4h4v-6c0-1.66-1.34-3-3-3zm-3 11H8v-5h8v5zm3-7c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm-1-9H6v4h12V3z' })
	  );
	};
	MapsLocalPrintshop = (0, _pure2.default)(MapsLocalPrintshop);
	MapsLocalPrintshop.displayName = 'MapsLocalPrintshop';
	MapsLocalPrintshop.muiName = 'SvgIcon';
	
	exports.default = MapsLocalPrintshop;

/***/ },
/* 1683 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalSee = function MapsLocalSee(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '12', r: '3.2' }),
	    _react2.default.createElement('path', { d: 'M9 2L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2h-3.17L15 2H9zm3 15c-2.76 0-5-2.24-5-5s2.24-5 5-5 5 2.24 5 5-2.24 5-5 5z' })
	  );
	};
	MapsLocalSee = (0, _pure2.default)(MapsLocalSee);
	MapsLocalSee.displayName = 'MapsLocalSee';
	MapsLocalSee.muiName = 'SvgIcon';
	
	exports.default = MapsLocalSee;

/***/ },
/* 1684 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalShipping = function MapsLocalShipping(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 8h-3V4H3c-1.1 0-2 .9-2 2v11h2c0 1.66 1.34 3 3 3s3-1.34 3-3h6c0 1.66 1.34 3 3 3s3-1.34 3-3h2v-5l-3-4zM6 18.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm13.5-9l1.96 2.5H17V9.5h2.5zm-1.5 9c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	MapsLocalShipping = (0, _pure2.default)(MapsLocalShipping);
	MapsLocalShipping.displayName = 'MapsLocalShipping';
	MapsLocalShipping.muiName = 'SvgIcon';
	
	exports.default = MapsLocalShipping;

/***/ },
/* 1685 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsLocalTaxi = function MapsLocalTaxi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 6.01C18.72 5.42 18.16 5 17.5 5H15V3H9v2H6.5c-.66 0-1.21.42-1.42 1.01L3 12v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 16c-.83 0-1.5-.67-1.5-1.5S5.67 13 6.5 13s1.5.67 1.5 1.5S7.33 16 6.5 16zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 11l1.5-4.5h11L19 11H5z' })
	  );
	};
	MapsLocalTaxi = (0, _pure2.default)(MapsLocalTaxi);
	MapsLocalTaxi.displayName = 'MapsLocalTaxi';
	MapsLocalTaxi.muiName = 'SvgIcon';
	
	exports.default = MapsLocalTaxi;

/***/ },
/* 1686 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsMap = function MapsMap(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.5 3l-.16.03L15 5.1 9 3 3.36 4.9c-.21.07-.36.25-.36.48V20.5c0 .28.22.5.5.5l.16-.03L9 18.9l6 2.1 5.64-1.9c.21-.07.36-.25.36-.48V3.5c0-.28-.22-.5-.5-.5zM15 19l-6-2.11V5l6 2.11V19z' })
	  );
	};
	MapsMap = (0, _pure2.default)(MapsMap);
	MapsMap.displayName = 'MapsMap';
	MapsMap.muiName = 'SvgIcon';
	
	exports.default = MapsMap;

/***/ },
/* 1687 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsMyLocation = function MapsMyLocation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c-2.21 0-4 1.79-4 4s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm8.94 3c-.46-4.17-3.77-7.48-7.94-7.94V1h-2v2.06C6.83 3.52 3.52 6.83 3.06 11H1v2h2.06c.46 4.17 3.77 7.48 7.94 7.94V23h2v-2.06c4.17-.46 7.48-3.77 7.94-7.94H23v-2h-2.06zM12 19c-3.87 0-7-3.13-7-7s3.13-7 7-7 7 3.13 7 7-3.13 7-7 7z' })
	  );
	};
	MapsMyLocation = (0, _pure2.default)(MapsMyLocation);
	MapsMyLocation.displayName = 'MapsMyLocation';
	MapsMyLocation.muiName = 'SvgIcon';
	
	exports.default = MapsMyLocation;

/***/ },
/* 1688 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsNavigation = function MapsNavigation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2L4.5 20.29l.71.71L12 18l6.79 3 .71-.71z' })
	  );
	};
	MapsNavigation = (0, _pure2.default)(MapsNavigation);
	MapsNavigation.displayName = 'MapsNavigation';
	MapsNavigation.muiName = 'SvgIcon';
	
	exports.default = MapsNavigation;

/***/ },
/* 1689 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsNearMe = function MapsNearMe(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3L3 10.53v.98l6.84 2.65L12.48 21h.98L21 3z' })
	  );
	};
	MapsNearMe = (0, _pure2.default)(MapsNearMe);
	MapsNearMe.displayName = 'MapsNearMe';
	MapsNearMe.muiName = 'SvgIcon';
	
	exports.default = MapsNearMe;

/***/ },
/* 1690 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPersonPinCircle = function MapsPersonPinCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.14 2 5 5.14 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.86-3.14-7-7-7zm0 2c1.1 0 2 .9 2 2 0 1.11-.9 2-2 2s-2-.89-2-2c0-1.1.9-2 2-2zm0 10c-1.67 0-3.14-.85-4-2.15.02-1.32 2.67-2.05 4-2.05s3.98.73 4 2.05c-.86 1.3-2.33 2.15-4 2.15z' })
	  );
	};
	MapsPersonPinCircle = (0, _pure2.default)(MapsPersonPinCircle);
	MapsPersonPinCircle.displayName = 'MapsPersonPinCircle';
	MapsPersonPinCircle.muiName = 'SvgIcon';
	
	exports.default = MapsPersonPinCircle;

/***/ },
/* 1691 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPersonPin = function MapsPersonPin(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 2H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h4l3 3 3-3h4c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 3.3c1.49 0 2.7 1.21 2.7 2.7 0 1.49-1.21 2.7-2.7 2.7-1.49 0-2.7-1.21-2.7-2.7 0-1.49 1.21-2.7 2.7-2.7zM18 16H6v-.9c0-2 4-3.1 6-3.1s6 1.1 6 3.1v.9z' })
	  );
	};
	MapsPersonPin = (0, _pure2.default)(MapsPersonPin);
	MapsPersonPin.displayName = 'MapsPersonPin';
	MapsPersonPin.muiName = 'SvgIcon';
	
	exports.default = MapsPersonPin;

/***/ },
/* 1692 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPinDrop = function MapsPinDrop(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8c0-3.31-2.69-6-6-6S6 4.69 6 8c0 4.5 6 11 6 11s6-6.5 6-11zm-8 0c0-1.1.9-2 2-2s2 .9 2 2-.89 2-2 2c-1.1 0-2-.9-2-2zM5 20v2h14v-2H5z' })
	  );
	};
	MapsPinDrop = (0, _pure2.default)(MapsPinDrop);
	MapsPinDrop.displayName = 'MapsPinDrop';
	MapsPinDrop.muiName = 'SvgIcon';
	
	exports.default = MapsPinDrop;

/***/ },
/* 1693 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsPlace = function MapsPlace(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zm0 9.5c-1.38 0-2.5-1.12-2.5-2.5s1.12-2.5 2.5-2.5 2.5 1.12 2.5 2.5-1.12 2.5-2.5 2.5z' })
	  );
	};
	MapsPlace = (0, _pure2.default)(MapsPlace);
	MapsPlace.displayName = 'MapsPlace';
	MapsPlace.muiName = 'SvgIcon';
	
	exports.default = MapsPlace;

/***/ },
/* 1694 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsRateReview = function MapsRateReview(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM6 14v-2.47l6.88-6.88c.2-.2.51-.2.71 0l1.77 1.77c.2.2.2.51 0 .71L8.47 14H6zm12 0h-7.5l2-2H18v2z' })
	  );
	};
	MapsRateReview = (0, _pure2.default)(MapsRateReview);
	MapsRateReview.displayName = 'MapsRateReview';
	MapsRateReview.muiName = 'SvgIcon';
	
	exports.default = MapsRateReview;

/***/ },
/* 1695 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsRestaurantMenu = function MapsRestaurantMenu(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.2-1.1-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z' })
	  );
	};
	MapsRestaurantMenu = (0, _pure2.default)(MapsRestaurantMenu);
	MapsRestaurantMenu.displayName = 'MapsRestaurantMenu';
	MapsRestaurantMenu.muiName = 'SvgIcon';
	
	exports.default = MapsRestaurantMenu;

/***/ },
/* 1696 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsRestaurant = function MapsRestaurant(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9H9V2H7v7H5V2H3v7c0 2.12 1.66 3.84 3.75 3.97V22h2.5v-9.03C11.34 12.84 13 11.12 13 9V2h-2v7zm5-3v8h2.5v8H21V2c-2.76 0-5 2.24-5 4z' })
	  );
	};
	MapsRestaurant = (0, _pure2.default)(MapsRestaurant);
	MapsRestaurant.displayName = 'MapsRestaurant';
	MapsRestaurant.muiName = 'SvgIcon';
	
	exports.default = MapsRestaurant;

/***/ },
/* 1697 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsSatellite = function MapsSatellite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM5 4.99h3C8 6.65 6.66 8 5 8V4.99zM5 12v-2c2.76 0 5-2.25 5-5.01h2C12 8.86 8.87 12 5 12zm0 6l3.5-4.5 2.5 3.01L14.5 12l4.5 6H5z' })
	  );
	};
	MapsSatellite = (0, _pure2.default)(MapsSatellite);
	MapsSatellite.displayName = 'MapsSatellite';
	MapsSatellite.muiName = 'SvgIcon';
	
	exports.default = MapsSatellite;

/***/ },
/* 1698 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsStoreMallDirectory = function MapsStoreMallDirectory(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4H4v2h16V4zm1 10v-2l-1-5H4l-1 5v2h1v6h10v-6h4v6h2v-6h1zm-9 4H6v-4h6v4z' })
	  );
	};
	MapsStoreMallDirectory = (0, _pure2.default)(MapsStoreMallDirectory);
	MapsStoreMallDirectory.displayName = 'MapsStoreMallDirectory';
	MapsStoreMallDirectory.muiName = 'SvgIcon';
	
	exports.default = MapsStoreMallDirectory;

/***/ },
/* 1699 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsStreetview = function MapsStreetview(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12.56 14.33c-.34.27-.56.7-.56 1.17V21h7c1.1 0 2-.9 2-2v-5.98c-.94-.33-1.95-.52-3-.52-2.03 0-3.93.7-5.44 1.83z' }),
	    _react2.default.createElement('circle', { cx: '18', cy: '6', r: '5' }),
	    _react2.default.createElement('path', { d: 'M11.5 6c0-1.08.27-2.1.74-3H5c-1.1 0-2 .9-2 2v14c0 .55.23 1.05.59 1.41l9.82-9.82C12.23 9.42 11.5 7.8 11.5 6z' })
	  );
	};
	MapsStreetview = (0, _pure2.default)(MapsStreetview);
	MapsStreetview.displayName = 'MapsStreetview';
	MapsStreetview.muiName = 'SvgIcon';
	
	exports.default = MapsStreetview;

/***/ },
/* 1700 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsSubway = function MapsSubway(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '15.5', cy: '16', r: '1' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '16', r: '1' }),
	    _react2.default.createElement('path', { d: 'M7.01 9h10v5h-10zM17.8 2.8C16 2.09 13.86 2 12 2c-1.86 0-4 .09-5.8.8C3.53 3.84 2 6.05 2 8.86V22h20V8.86c0-2.81-1.53-5.02-4.2-6.06zm.2 13.08c0 1.45-1.18 2.62-2.63 2.62l1.13 1.12V20H15l-1.5-1.5h-2.83L9.17 20H7.5v-.38l1.12-1.12C7.18 18.5 6 17.32 6 15.88V9c0-2.63 3-3 6-3 3.32 0 6 .38 6 3v6.88z' })
	  );
	};
	MapsSubway = (0, _pure2.default)(MapsSubway);
	MapsSubway.displayName = 'MapsSubway';
	MapsSubway.muiName = 'SvgIcon';
	
	exports.default = MapsSubway;

/***/ },
/* 1701 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTerrain = function MapsTerrain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14 6l-3.75 5 2.85 3.8-1.6 1.2C9.81 13.75 7 10 7 10l-6 8h22L14 6z' })
	  );
	};
	MapsTerrain = (0, _pure2.default)(MapsTerrain);
	MapsTerrain.displayName = 'MapsTerrain';
	MapsTerrain.muiName = 'SvgIcon';
	
	exports.default = MapsTerrain;

/***/ },
/* 1702 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTraffic = function MapsTraffic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 10h-3V8.86c1.72-.45 3-2 3-3.86h-3V4c0-.55-.45-1-1-1H8c-.55 0-1 .45-1 1v1H4c0 1.86 1.28 3.41 3 3.86V10H4c0 1.86 1.28 3.41 3 3.86V15H4c0 1.86 1.28 3.41 3 3.86V20c0 .55.45 1 1 1h8c.55 0 1-.45 1-1v-1.14c1.72-.45 3-2 3-3.86h-3v-1.14c1.72-.45 3-2 3-3.86zm-8 9c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2s.89-2 2-2c1.1 0 2 .9 2 2s-.89 2-2 2zm0-5c-1.11 0-2-.9-2-2 0-1.11.89-2 2-2 1.1 0 2 .89 2 2 0 1.1-.89 2-2 2z' })
	  );
	};
	MapsTraffic = (0, _pure2.default)(MapsTraffic);
	MapsTraffic.displayName = 'MapsTraffic';
	MapsTraffic.muiName = 'SvgIcon';
	
	exports.default = MapsTraffic;

/***/ },
/* 1703 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTrain = function MapsTrain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2c-4 0-8 .5-8 4v9.5C4 17.43 5.57 19 7.5 19L6 20.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 19c1.93 0 3.5-1.57 3.5-3.5V6c0-3.5-3.58-4-8-4zM7.5 17c-.83 0-1.5-.67-1.5-1.5S6.67 14 7.5 14s1.5.67 1.5 1.5S8.33 17 7.5 17zm3.5-7H6V6h5v4zm2 0V6h5v4h-5zm3.5 7c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	MapsTrain = (0, _pure2.default)(MapsTrain);
	MapsTrain.displayName = 'MapsTrain';
	MapsTrain.muiName = 'SvgIcon';
	
	exports.default = MapsTrain;

/***/ },
/* 1704 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTram = function MapsTram(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 16.94V8.5c0-2.79-2.61-3.4-6.01-3.49l.76-1.51H17V2H7v1.5h4.75l-.76 1.52C7.86 5.11 5 5.73 5 8.5v8.44c0 1.45 1.19 2.66 2.59 2.97L6 21.5v.5h2.23l2-2H14l2 2h2v-.5L16.5 20h-.08c1.69 0 2.58-1.37 2.58-3.06zm-7 1.56c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5-4.5H7V9h10v5z' })
	  );
	};
	MapsTram = (0, _pure2.default)(MapsTram);
	MapsTram.displayName = 'MapsTram';
	MapsTram.muiName = 'SvgIcon';
	
	exports.default = MapsTram;

/***/ },
/* 1705 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsTransferWithinAStation = function MapsTransferWithinAStation(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.49 15.5v-1.75L14 16.25l2.49 2.5V17H22v-1.5zm3.02 4.25H14v1.5h5.51V23L22 20.5 19.51 18zM9.5 5.5c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zM5.75 8.9L3 23h2.1l1.75-8L9 17v6h2v-7.55L8.95 13.4l.6-3C10.85 12 12.8 13 15 13v-2c-1.85 0-3.45-1-4.35-2.45l-.95-1.6C9.35 6.35 8.7 6 8 6c-.25 0-.5.05-.75.15L2 8.3V13h2V9.65l1.75-.75' })
	  );
	};
	MapsTransferWithinAStation = (0, _pure2.default)(MapsTransferWithinAStation);
	MapsTransferWithinAStation.displayName = 'MapsTransferWithinAStation';
	MapsTransferWithinAStation.muiName = 'SvgIcon';
	
	exports.default = MapsTransferWithinAStation;

/***/ },
/* 1706 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var MapsZoomOutMap = function MapsZoomOutMap(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 3l2.3 2.3-2.89 2.87 1.42 1.42L18.7 6.7 21 9V3zM3 9l2.3-2.3 2.87 2.89 1.42-1.42L6.7 5.3 9 3H3zm6 12l-2.3-2.3 2.89-2.87-1.42-1.42L5.3 17.3 3 15v6zm12-6l-2.3 2.3-2.87-2.89-1.42 1.42 2.89 2.87L15 21h6z' })
	  );
	};
	MapsZoomOutMap = (0, _pure2.default)(MapsZoomOutMap);
	MapsZoomOutMap.displayName = 'MapsZoomOutMap';
	MapsZoomOutMap.muiName = 'SvgIcon';
	
	exports.default = MapsZoomOutMap;

/***/ },
/* 1707 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropRight = function NavigationArrowDropRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.5,7l5,5l-5,5V7z' })
	  );
	};
	
	NavigationArrowDropRight = (0, _pure2.default)(NavigationArrowDropRight);
	NavigationArrowDropRight.displayName = 'NavigationArrowDropRight';
	NavigationArrowDropRight.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropRight;

/***/ },
/* 1708 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationApps = function NavigationApps(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 8h4V4H4v4zm6 12h4v-4h-4v4zm-6 0h4v-4H4v4zm0-6h4v-4H4v4zm6 0h4v-4h-4v4zm6-10v4h4V4h-4zm-6 4h4V4h-4v4zm6 6h4v-4h-4v4zm0 6h4v-4h-4v4z' })
	  );
	};
	NavigationApps = (0, _pure2.default)(NavigationApps);
	NavigationApps.displayName = 'NavigationApps';
	NavigationApps.muiName = 'SvgIcon';
	
	exports.default = NavigationApps;

/***/ },
/* 1709 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowBack = function NavigationArrowBack(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 11H7.83l5.59-5.59L12 4l-8 8 8 8 1.41-1.41L7.83 13H20v-2z' })
	  );
	};
	NavigationArrowBack = (0, _pure2.default)(NavigationArrowBack);
	NavigationArrowBack.displayName = 'NavigationArrowBack';
	NavigationArrowBack.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowBack;

/***/ },
/* 1710 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDownward = function NavigationArrowDownward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z' })
	  );
	};
	NavigationArrowDownward = (0, _pure2.default)(NavigationArrowDownward);
	NavigationArrowDownward.displayName = 'NavigationArrowDownward';
	NavigationArrowDownward.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDownward;

/***/ },
/* 1711 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropDownCircle = function NavigationArrowDropDownCircle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 12l-4-4h8l-4 4z' })
	  );
	};
	NavigationArrowDropDownCircle = (0, _pure2.default)(NavigationArrowDropDownCircle);
	NavigationArrowDropDownCircle.displayName = 'NavigationArrowDropDownCircle';
	NavigationArrowDropDownCircle.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropDownCircle;

/***/ },
/* 1712 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowDropUp = function NavigationArrowDropUp(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 14l5-5 5 5z' })
	  );
	};
	NavigationArrowDropUp = (0, _pure2.default)(NavigationArrowDropUp);
	NavigationArrowDropUp.displayName = 'NavigationArrowDropUp';
	NavigationArrowDropUp.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowDropUp;

/***/ },
/* 1713 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowForward = function NavigationArrowForward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4l-1.41 1.41L16.17 11H4v2h12.17l-5.58 5.59L12 20l8-8z' })
	  );
	};
	NavigationArrowForward = (0, _pure2.default)(NavigationArrowForward);
	NavigationArrowForward.displayName = 'NavigationArrowForward';
	NavigationArrowForward.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowForward;

/***/ },
/* 1714 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationArrowUpward = function NavigationArrowUpward(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 12l1.41 1.41L11 7.83V20h2V7.83l5.58 5.59L20 12l-8-8-8 8z' })
	  );
	};
	NavigationArrowUpward = (0, _pure2.default)(NavigationArrowUpward);
	NavigationArrowUpward.displayName = 'NavigationArrowUpward';
	NavigationArrowUpward.muiName = 'SvgIcon';
	
	exports.default = NavigationArrowUpward;

/***/ },
/* 1715 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationClose = function NavigationClose(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z' })
	  );
	};
	NavigationClose = (0, _pure2.default)(NavigationClose);
	NavigationClose.displayName = 'NavigationClose';
	NavigationClose.muiName = 'SvgIcon';
	
	exports.default = NavigationClose;

/***/ },
/* 1716 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFirstPage = function NavigationFirstPage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z' })
	  );
	};
	NavigationFirstPage = (0, _pure2.default)(NavigationFirstPage);
	NavigationFirstPage.displayName = 'NavigationFirstPage';
	NavigationFirstPage.muiName = 'SvgIcon';
	
	exports.default = NavigationFirstPage;

/***/ },
/* 1717 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFullscreenExit = function NavigationFullscreenExit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 16h3v3h2v-5H5v2zm3-8H5v2h5V5H8v3zm6 11h2v-3h3v-2h-5v5zm2-11V5h-2v5h5V8h-3z' })
	  );
	};
	NavigationFullscreenExit = (0, _pure2.default)(NavigationFullscreenExit);
	NavigationFullscreenExit.displayName = 'NavigationFullscreenExit';
	NavigationFullscreenExit.muiName = 'SvgIcon';
	
	exports.default = NavigationFullscreenExit;

/***/ },
/* 1718 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationFullscreen = function NavigationFullscreen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 14H5v5h5v-2H7v-3zm-2-4h2V7h3V5H5v5zm12 7h-3v2h5v-5h-2v3zM14 5v2h3v3h2V5h-5z' })
	  );
	};
	NavigationFullscreen = (0, _pure2.default)(NavigationFullscreen);
	NavigationFullscreen.displayName = 'NavigationFullscreen';
	NavigationFullscreen.muiName = 'SvgIcon';
	
	exports.default = NavigationFullscreen;

/***/ },
/* 1719 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationLastPage = function NavigationLastPage(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z' })
	  );
	};
	NavigationLastPage = (0, _pure2.default)(NavigationLastPage);
	NavigationLastPage.displayName = 'NavigationLastPage';
	NavigationLastPage.muiName = 'SvgIcon';
	
	exports.default = NavigationLastPage;

/***/ },
/* 1720 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMoreHoriz = function NavigationMoreHoriz(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	NavigationMoreHoriz = (0, _pure2.default)(NavigationMoreHoriz);
	NavigationMoreHoriz.displayName = 'NavigationMoreHoriz';
	NavigationMoreHoriz.muiName = 'SvgIcon';
	
	exports.default = NavigationMoreHoriz;

/***/ },
/* 1721 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationMoreVert = function NavigationMoreVert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 8c1.1 0 2-.9 2-2s-.9-2-2-2-2 .9-2 2 .9 2 2 2zm0 2c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm0 6c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z' })
	  );
	};
	NavigationMoreVert = (0, _pure2.default)(NavigationMoreVert);
	NavigationMoreVert.displayName = 'NavigationMoreVert';
	NavigationMoreVert.muiName = 'SvgIcon';
	
	exports.default = NavigationMoreVert;

/***/ },
/* 1722 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationRefresh = function NavigationRefresh(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17.65 6.35C16.2 4.9 14.21 4 12 4c-4.42 0-7.99 3.58-7.99 8s3.57 8 7.99 8c3.73 0 6.84-2.55 7.73-6h-2.08c-.82 2.33-3.04 4-5.65 4-3.31 0-6-2.69-6-6s2.69-6 6-6c1.66 0 3.14.69 4.22 1.78L13 11h7V4l-2.35 2.35z' })
	  );
	};
	NavigationRefresh = (0, _pure2.default)(NavigationRefresh);
	NavigationRefresh.displayName = 'NavigationRefresh';
	NavigationRefresh.muiName = 'SvgIcon';
	
	exports.default = NavigationRefresh;

/***/ },
/* 1723 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationSubdirectoryArrowLeft = function NavigationSubdirectoryArrowLeft(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11 9l1.42 1.42L8.83 14H18V4h2v12H8.83l3.59 3.58L11 21l-6-6 6-6z' })
	  );
	};
	NavigationSubdirectoryArrowLeft = (0, _pure2.default)(NavigationSubdirectoryArrowLeft);
	NavigationSubdirectoryArrowLeft.displayName = 'NavigationSubdirectoryArrowLeft';
	NavigationSubdirectoryArrowLeft.muiName = 'SvgIcon';
	
	exports.default = NavigationSubdirectoryArrowLeft;

/***/ },
/* 1724 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationSubdirectoryArrowRight = function NavigationSubdirectoryArrowRight(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 15l-6 6-1.42-1.42L15.17 16H4V4h2v10h9.17l-3.59-3.58L13 9l6 6z' })
	  );
	};
	NavigationSubdirectoryArrowRight = (0, _pure2.default)(NavigationSubdirectoryArrowRight);
	NavigationSubdirectoryArrowRight.displayName = 'NavigationSubdirectoryArrowRight';
	NavigationSubdirectoryArrowRight.muiName = 'SvgIcon';
	
	exports.default = NavigationSubdirectoryArrowRight;

/***/ },
/* 1725 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationUnfoldLess = function NavigationUnfoldLess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.41 18.59L8.83 20 12 16.83 15.17 20l1.41-1.41L12 14l-4.59 4.59zm9.18-13.18L15.17 4 12 7.17 8.83 4 7.41 5.41 12 10l4.59-4.59z' })
	  );
	};
	NavigationUnfoldLess = (0, _pure2.default)(NavigationUnfoldLess);
	NavigationUnfoldLess.displayName = 'NavigationUnfoldLess';
	NavigationUnfoldLess.muiName = 'SvgIcon';
	
	exports.default = NavigationUnfoldLess;

/***/ },
/* 1726 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NavigationUnfoldMore = function NavigationUnfoldMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5.83L15.17 9l1.41-1.41L12 3 7.41 7.59 8.83 9 12 5.83zm0 12.34L8.83 15l-1.41 1.41L12 21l4.59-4.59L15.17 15 12 18.17z' })
	  );
	};
	NavigationUnfoldMore = (0, _pure2.default)(NavigationUnfoldMore);
	NavigationUnfoldMore.displayName = 'NavigationUnfoldMore';
	NavigationUnfoldMore.muiName = 'SvgIcon';
	
	exports.default = NavigationUnfoldMore;

/***/ },
/* 1727 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAdb = function NotificationAdb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 16c0 3.87 3.13 7 7 7s7-3.13 7-7v-4H5v4zM16.12 4.37l2.1-2.1-.82-.83-2.3 2.31C14.16 3.28 13.12 3 12 3s-2.16.28-3.09.75L6.6 1.44l-.82.83 2.1 2.1C6.14 5.64 5 7.68 5 10v1h14v-1c0-2.32-1.14-4.36-2.88-5.63zM9 9c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm6 0c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1z' })
	  );
	};
	NotificationAdb = (0, _pure2.default)(NotificationAdb);
	NotificationAdb.displayName = 'NotificationAdb';
	NotificationAdb.muiName = 'SvgIcon';
	
	exports.default = NotificationAdb;

/***/ },
/* 1728 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatFlatAngled = function NotificationAirlineSeatFlatAngled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22.25 14.29l-.69 1.89L9.2 11.71l2.08-5.66 8.56 3.09c2.1.76 3.18 3.06 2.41 5.15zM1.5 12.14L8 14.48V19h8v-1.63L20.52 19l.69-1.89-19.02-6.86-.69 1.89zm5.8-1.94c1.49-.72 2.12-2.51 1.41-4C7.99 4.71 6.2 4.08 4.7 4.8c-1.49.71-2.12 2.5-1.4 4 .71 1.49 2.5 2.12 4 1.4z' })
	  );
	};
	NotificationAirlineSeatFlatAngled = (0, _pure2.default)(NotificationAirlineSeatFlatAngled);
	NotificationAirlineSeatFlatAngled.displayName = 'NotificationAirlineSeatFlatAngled';
	NotificationAirlineSeatFlatAngled.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatFlatAngled;

/***/ },
/* 1729 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatFlat = function NotificationAirlineSeatFlat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 11v2H9V7h9c2.21 0 4 1.79 4 4zM2 14v2h6v2h8v-2h6v-2H2zm5.14-1.9c1.16-1.19 1.14-3.08-.04-4.24-1.19-1.16-3.08-1.14-4.24.04-1.16 1.19-1.14 3.08.04 4.24 1.19 1.16 3.08 1.14 4.24-.04z' })
	  );
	};
	NotificationAirlineSeatFlat = (0, _pure2.default)(NotificationAirlineSeatFlat);
	NotificationAirlineSeatFlat.displayName = 'NotificationAirlineSeatFlat';
	NotificationAirlineSeatFlat.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatFlat;

/***/ },
/* 1730 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatIndividualSuite = function NotificationAirlineSeatIndividualSuite(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7 13c1.65 0 3-1.35 3-3S8.65 7 7 7s-3 1.35-3 3 1.35 3 3 3zm12-6h-8v7H3V7H1v10h22v-6c0-2.21-1.79-4-4-4z' })
	  );
	};
	NotificationAirlineSeatIndividualSuite = (0, _pure2.default)(NotificationAirlineSeatIndividualSuite);
	NotificationAirlineSeatIndividualSuite.displayName = 'NotificationAirlineSeatIndividualSuite';
	NotificationAirlineSeatIndividualSuite.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatIndividualSuite;

/***/ },
/* 1731 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatLegroomExtra = function NotificationAirlineSeatLegroomExtra(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M4 12V3H2v9c0 2.76 2.24 5 5 5h6v-2H7c-1.66 0-3-1.34-3-3zm18.83 5.24c-.38-.72-1.29-.97-2.03-.63l-1.09.5-3.41-6.98c-.34-.68-1.03-1.12-1.79-1.12L11 9V3H5v8c0 1.66 1.34 3 3 3h7l3.41 7 3.72-1.7c.77-.36 1.1-1.3.7-2.06z' })
	  );
	};
	NotificationAirlineSeatLegroomExtra = (0, _pure2.default)(NotificationAirlineSeatLegroomExtra);
	NotificationAirlineSeatLegroomExtra.displayName = 'NotificationAirlineSeatLegroomExtra';
	NotificationAirlineSeatLegroomExtra.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatLegroomExtra;

/***/ },
/* 1732 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatLegroomNormal = function NotificationAirlineSeatLegroomNormal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 12V3H3v9c0 2.76 2.24 5 5 5h6v-2H8c-1.66 0-3-1.34-3-3zm15.5 6H19v-7c0-1.1-.9-2-2-2h-5V3H6v8c0 1.65 1.35 3 3 3h7v7h4.5c.83 0 1.5-.67 1.5-1.5s-.67-1.5-1.5-1.5z' })
	  );
	};
	NotificationAirlineSeatLegroomNormal = (0, _pure2.default)(NotificationAirlineSeatLegroomNormal);
	NotificationAirlineSeatLegroomNormal.displayName = 'NotificationAirlineSeatLegroomNormal';
	NotificationAirlineSeatLegroomNormal.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatLegroomNormal;

/***/ },
/* 1733 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatLegroomReduced = function NotificationAirlineSeatLegroomReduced(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.97 19.2c.18.96-.55 1.8-1.47 1.8H14v-3l1-4H9c-1.65 0-3-1.35-3-3V3h6v6h5c1.1 0 2 .9 2 2l-2 7h1.44c.73 0 1.39.49 1.53 1.2zM5 12V3H3v9c0 2.76 2.24 5 5 5h4v-2H8c-1.66 0-3-1.34-3-3z' })
	  );
	};
	NotificationAirlineSeatLegroomReduced = (0, _pure2.default)(NotificationAirlineSeatLegroomReduced);
	NotificationAirlineSeatLegroomReduced.displayName = 'NotificationAirlineSeatLegroomReduced';
	NotificationAirlineSeatLegroomReduced.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatLegroomReduced;

/***/ },
/* 1734 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatReclineExtra = function NotificationAirlineSeatReclineExtra(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.35 5.64c-.9-.64-1.12-1.88-.49-2.79.63-.9 1.88-1.12 2.79-.49.9.64 1.12 1.88.49 2.79-.64.9-1.88 1.12-2.79.49zM16 19H8.93c-1.48 0-2.74-1.08-2.96-2.54L4 7H2l1.99 9.76C4.37 19.2 6.47 21 8.94 21H16v-2zm.23-4h-4.88l-1.03-4.1c1.58.89 3.28 1.54 5.15 1.22V9.99c-1.63.31-3.44-.27-4.69-1.25L9.14 7.47c-.23-.18-.49-.3-.76-.38-.32-.09-.66-.12-.99-.06h-.02c-1.23.22-2.05 1.39-1.84 2.61l1.35 5.92C7.16 16.98 8.39 18 9.83 18h6.85l3.82 3 1.5-1.5-5.77-4.5z' })
	  );
	};
	NotificationAirlineSeatReclineExtra = (0, _pure2.default)(NotificationAirlineSeatReclineExtra);
	NotificationAirlineSeatReclineExtra.displayName = 'NotificationAirlineSeatReclineExtra';
	NotificationAirlineSeatReclineExtra.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatReclineExtra;

/***/ },
/* 1735 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationAirlineSeatReclineNormal = function NotificationAirlineSeatReclineNormal(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.59 5.41c-.78-.78-.78-2.05 0-2.83.78-.78 2.05-.78 2.83 0 .78.78.78 2.05 0 2.83-.79.79-2.05.79-2.83 0zM6 16V7H4v9c0 2.76 2.24 5 5 5h6v-2H9c-1.66 0-3-1.34-3-3zm14 4.07L14.93 15H11.5v-3.68c1.4 1.15 3.6 2.16 5.5 2.16v-2.16c-1.66.02-3.61-.87-4.67-2.04l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C8.01 7 7 8.01 7 9.25V15c0 1.66 1.34 3 3 3h5.07l3.5 3.5L20 20.07z' })
	  );
	};
	NotificationAirlineSeatReclineNormal = (0, _pure2.default)(NotificationAirlineSeatReclineNormal);
	NotificationAirlineSeatReclineNormal.displayName = 'NotificationAirlineSeatReclineNormal';
	NotificationAirlineSeatReclineNormal.muiName = 'SvgIcon';
	
	exports.default = NotificationAirlineSeatReclineNormal;

/***/ },
/* 1736 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationBluetoothAudio = function NotificationBluetoothAudio(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.24 12.01l2.32 2.32c.28-.72.44-1.51.44-2.33 0-.82-.16-1.59-.43-2.31l-2.33 2.32zm5.29-5.3l-1.26 1.26c.63 1.21.98 2.57.98 4.02s-.36 2.82-.98 4.02l1.2 1.2c.97-1.54 1.54-3.36 1.54-5.31-.01-1.89-.55-3.67-1.48-5.19zm-3.82 1L10 2H9v7.59L4.41 5 3 6.41 8.59 12 3 17.59 4.41 19 9 14.41V22h1l5.71-5.71-4.3-4.29 4.3-4.29zM11 5.83l1.88 1.88L11 9.59V5.83zm1.88 10.46L11 18.17v-3.76l1.88 1.88z' })
	  );
	};
	NotificationBluetoothAudio = (0, _pure2.default)(NotificationBluetoothAudio);
	NotificationBluetoothAudio.displayName = 'NotificationBluetoothAudio';
	NotificationBluetoothAudio.muiName = 'SvgIcon';
	
	exports.default = NotificationBluetoothAudio;

/***/ },
/* 1737 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationConfirmationNumber = function NotificationConfirmationNumber(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 10V6c0-1.11-.9-2-2-2H4c-1.1 0-1.99.89-1.99 2v4c1.1 0 1.99.9 1.99 2s-.89 2-2 2v4c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-4c-1.1 0-2-.9-2-2s.9-2 2-2zm-9 7.5h-2v-2h2v2zm0-4.5h-2v-2h2v2zm0-4.5h-2v-2h2v2z' })
	  );
	};
	NotificationConfirmationNumber = (0, _pure2.default)(NotificationConfirmationNumber);
	NotificationConfirmationNumber.displayName = 'NotificationConfirmationNumber';
	NotificationConfirmationNumber.muiName = 'SvgIcon';
	
	exports.default = NotificationConfirmationNumber;

/***/ },
/* 1738 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDiscFull = function NotificationDiscFull(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 16h2v-2h-2v2zm0-9v5h2V7h-2zM10 4c-4.42 0-8 3.58-8 8s3.58 8 8 8 8-3.58 8-8-3.58-8-8-8zm0 10c-1.1 0-2-.9-2-2s.9-2 2-2 2 .9 2 2-.9 2-2 2z' })
	  );
	};
	NotificationDiscFull = (0, _pure2.default)(NotificationDiscFull);
	NotificationDiscFull.displayName = 'NotificationDiscFull';
	NotificationDiscFull.muiName = 'SvgIcon';
	
	exports.default = NotificationDiscFull;

/***/ },
/* 1739 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturbAlt = function NotificationDoNotDisturbAlt(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10 10-4.5 10-10S17.5 2 12 2zM4 12c0-4.4 3.6-8 8-8 1.8 0 3.5.6 4.9 1.7L5.7 16.9C4.6 15.5 4 13.8 4 12zm8 8c-1.8 0-3.5-.6-4.9-1.7L18.3 7.1C19.4 8.5 20 10.2 20 12c0 4.4-3.6 8-8 8z' })
	  );
	};
	NotificationDoNotDisturbAlt = (0, _pure2.default)(NotificationDoNotDisturbAlt);
	NotificationDoNotDisturbAlt.displayName = 'NotificationDoNotDisturbAlt';
	NotificationDoNotDisturbAlt.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturbAlt;

/***/ },
/* 1740 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturbOff = function NotificationDoNotDisturbOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 11v2h-1.46l4.68 4.68C21.34 16.07 22 14.11 22 12c0-5.52-4.48-10-10-10-2.11 0-4.07.66-5.68 1.78L13.54 11H17zM2.27 2.27L1 3.54l2.78 2.78C2.66 7.93 2 9.89 2 12c0 5.52 4.48 10 10 10 2.11 0 4.07-.66 5.68-1.78L20.46 23l1.27-1.27L11 11 2.27 2.27zM7 13v-2h1.46l2 2H7z' })
	  );
	};
	NotificationDoNotDisturbOff = (0, _pure2.default)(NotificationDoNotDisturbOff);
	NotificationDoNotDisturbOff.displayName = 'NotificationDoNotDisturbOff';
	NotificationDoNotDisturbOff.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturbOff;

/***/ },
/* 1741 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturbOn = function NotificationDoNotDisturbOn(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm5 11H7v-2h10v2z' })
	  );
	};
	NotificationDoNotDisturbOn = (0, _pure2.default)(NotificationDoNotDisturbOn);
	NotificationDoNotDisturbOn.displayName = 'NotificationDoNotDisturbOn';
	NotificationDoNotDisturbOn.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturbOn;

/***/ },
/* 1742 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDoNotDisturb = function NotificationDoNotDisturb(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8 0-1.85.63-3.55 1.69-4.9L16.9 18.31C15.55 19.37 13.85 20 12 20zm6.31-3.1L7.1 5.69C8.45 4.63 10.15 4 12 4c4.42 0 8 3.58 8 8 0 1.85-.63 3.55-1.69 4.9z' })
	  );
	};
	NotificationDoNotDisturb = (0, _pure2.default)(NotificationDoNotDisturb);
	NotificationDoNotDisturb.displayName = 'NotificationDoNotDisturb';
	NotificationDoNotDisturb.muiName = 'SvgIcon';
	
	exports.default = NotificationDoNotDisturb;

/***/ },
/* 1743 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationDriveEta = function NotificationDriveEta(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
	  );
	};
	NotificationDriveEta = (0, _pure2.default)(NotificationDriveEta);
	NotificationDriveEta.displayName = 'NotificationDriveEta';
	NotificationDriveEta.muiName = 'SvgIcon';
	
	exports.default = NotificationDriveEta;

/***/ },
/* 1744 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEnhancedEncryption = function NotificationEnhancedEncryption(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 8h-1V6c0-2.76-2.24-5-5-5S7 3.24 7 6v2H6c-1.1 0-2 .9-2 2v10c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V10c0-1.1-.9-2-2-2zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H8.9V6zM16 16h-3v3h-2v-3H8v-2h3v-3h2v3h3v2z' })
	  );
	};
	NotificationEnhancedEncryption = (0, _pure2.default)(NotificationEnhancedEncryption);
	NotificationEnhancedEncryption.displayName = 'NotificationEnhancedEncryption';
	NotificationEnhancedEncryption.muiName = 'SvgIcon';
	
	exports.default = NotificationEnhancedEncryption;

/***/ },
/* 1745 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEventAvailable = function NotificationEventAvailable(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.53 11.06L15.47 10l-4.88 4.88-2.12-2.12-1.06 1.06L10.59 17l5.94-5.94zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
	  );
	};
	NotificationEventAvailable = (0, _pure2.default)(NotificationEventAvailable);
	NotificationEventAvailable.displayName = 'NotificationEventAvailable';
	NotificationEventAvailable.muiName = 'SvgIcon';
	
	exports.default = NotificationEventAvailable;

/***/ },
/* 1746 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEventBusy = function NotificationEventBusy(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9.31 17l2.44-2.44L14.19 17l1.06-1.06-2.44-2.44 2.44-2.44L14.19 10l-2.44 2.44L9.31 10l-1.06 1.06 2.44 2.44-2.44 2.44L9.31 17zM19 3h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11z' })
	  );
	};
	NotificationEventBusy = (0, _pure2.default)(NotificationEventBusy);
	NotificationEventBusy.displayName = 'NotificationEventBusy';
	NotificationEventBusy.muiName = 'SvgIcon';
	
	exports.default = NotificationEventBusy;

/***/ },
/* 1747 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationEventNote = function NotificationEventNote(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 10H7v2h10v-2zm2-7h-1V1h-2v2H8V1H6v2H5c-1.11 0-1.99.9-1.99 2L3 19c0 1.1.89 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm0 16H5V8h14v11zm-5-5H7v2h7v-2z' })
	  );
	};
	NotificationEventNote = (0, _pure2.default)(NotificationEventNote);
	NotificationEventNote.displayName = 'NotificationEventNote';
	NotificationEventNote.muiName = 'SvgIcon';
	
	exports.default = NotificationEventNote;

/***/ },
/* 1748 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationFolderSpecial = function NotificationFolderSpecial(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 6h-8l-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V8c0-1.1-.9-2-2-2zm-2.06 11L15 15.28 12.06 17l.78-3.33-2.59-2.24 3.41-.29L15 8l1.34 3.14 3.41.29-2.59 2.24.78 3.33z' })
	  );
	};
	NotificationFolderSpecial = (0, _pure2.default)(NotificationFolderSpecial);
	NotificationFolderSpecial.displayName = 'NotificationFolderSpecial';
	NotificationFolderSpecial.muiName = 'SvgIcon';
	
	exports.default = NotificationFolderSpecial;

/***/ },
/* 1749 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationLiveTv = function NotificationLiveTv(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 6h-7.59l3.29-3.29L16 2l-4 4-4-4-.71.71L10.59 6H3c-1.1 0-2 .89-2 2v12c0 1.1.9 2 2 2h18c1.1 0 2-.9 2-2V8c0-1.11-.9-2-2-2zm0 14H3V8h18v12zM9 10v8l7-4z' })
	  );
	};
	NotificationLiveTv = (0, _pure2.default)(NotificationLiveTv);
	NotificationLiveTv.displayName = 'NotificationLiveTv';
	NotificationLiveTv.muiName = 'SvgIcon';
	
	exports.default = NotificationLiveTv;

/***/ },
/* 1750 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationMms = function NotificationMms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM5 14l3.5-4.5 2.5 3.01L14.5 8l4.5 6H5z' })
	  );
	};
	NotificationMms = (0, _pure2.default)(NotificationMms);
	NotificationMms.displayName = 'NotificationMms';
	NotificationMms.muiName = 'SvgIcon';
	
	exports.default = NotificationMms;

/***/ },
/* 1751 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationMore = function NotificationMore(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 3H7c-.69 0-1.23.35-1.59.88L0 12l5.41 8.11c.36.53.97.89 1.66.89H22c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 13.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm5 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5z' })
	  );
	};
	NotificationMore = (0, _pure2.default)(NotificationMore);
	NotificationMore.displayName = 'NotificationMore';
	NotificationMore.muiName = 'SvgIcon';
	
	exports.default = NotificationMore;

/***/ },
/* 1752 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationNetworkCheck = function NotificationNetworkCheck(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15.9 5c-.17 0-.32.09-.41.23l-.07.15-5.18 11.65c-.16.29-.26.61-.26.96 0 1.11.9 2.01 2.01 2.01.96 0 1.77-.68 1.96-1.59l.01-.03L16.4 5.5c0-.28-.22-.5-.5-.5zM1 9l2 2c2.88-2.88 6.79-4.08 10.53-3.62l1.19-2.68C9.89 3.84 4.74 5.27 1 9zm20 2l2-2c-1.64-1.64-3.55-2.82-5.59-3.57l-.53 2.82c1.5.62 2.9 1.53 4.12 2.75zm-4 4l2-2c-.8-.8-1.7-1.42-2.66-1.89l-.55 2.92c.42.27.83.59 1.21.97zM5 13l2 2c1.13-1.13 2.56-1.79 4.03-2l1.28-2.88c-2.63-.08-5.3.87-7.31 2.88z' })
	  );
	};
	NotificationNetworkCheck = (0, _pure2.default)(NotificationNetworkCheck);
	NotificationNetworkCheck.displayName = 'NotificationNetworkCheck';
	NotificationNetworkCheck.muiName = 'SvgIcon';
	
	exports.default = NotificationNetworkCheck;

/***/ },
/* 1753 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationNetworkLocked = function NotificationNetworkLocked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19.5 10c.17 0 .33.03.5.05V1L1 20h13v-3c0-.89.39-1.68 1-2.23v-.27c0-2.48 2.02-4.5 4.5-4.5zm2.5 6v-1.5c0-1.38-1.12-2.5-2.5-2.5S17 13.12 17 14.5V16c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1v-4c0-.55-.45-1-1-1zm-1 0h-3v-1.5c0-.83.67-1.5 1.5-1.5s1.5.67 1.5 1.5V16z' })
	  );
	};
	NotificationNetworkLocked = (0, _pure2.default)(NotificationNetworkLocked);
	NotificationNetworkLocked.displayName = 'NotificationNetworkLocked';
	NotificationNetworkLocked.muiName = 'SvgIcon';
	
	exports.default = NotificationNetworkLocked;

/***/ },
/* 1754 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationNoEncryption = function NotificationNoEncryption(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 21.78L4.22 5 3 6.22l2.04 2.04C4.42 8.6 4 9.25 4 10v10c0 1.1.9 2 2 2h12c.23 0 .45-.05.66-.12L19.78 23 21 21.78zM8.9 6c0-1.71 1.39-3.1 3.1-3.1s3.1 1.39 3.1 3.1v2H9.66L20 18.34V10c0-1.1-.9-2-2-2h-1V6c0-2.76-2.24-5-5-5-2.56 0-4.64 1.93-4.94 4.4L8.9 7.24V6z' })
	  );
	};
	NotificationNoEncryption = (0, _pure2.default)(NotificationNoEncryption);
	NotificationNoEncryption.displayName = 'NotificationNoEncryption';
	NotificationNoEncryption.muiName = 'SvgIcon';
	
	exports.default = NotificationNoEncryption;

/***/ },
/* 1755 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationOndemandVideo = function NotificationOndemandVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12zm-5-6l-7 4V7z' })
	  );
	};
	NotificationOndemandVideo = (0, _pure2.default)(NotificationOndemandVideo);
	NotificationOndemandVideo.displayName = 'NotificationOndemandVideo';
	NotificationOndemandVideo.muiName = 'SvgIcon';
	
	exports.default = NotificationOndemandVideo;

/***/ },
/* 1756 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPersonalVideo = function NotificationPersonalVideo(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M21 3H3c-1.11 0-2 .89-2 2v12c0 1.1.89 2 2 2h5v2h8v-2h5c1.1 0 1.99-.9 1.99-2L23 5c0-1.11-.9-2-2-2zm0 14H3V5h18v12z' })
	  );
	};
	NotificationPersonalVideo = (0, _pure2.default)(NotificationPersonalVideo);
	NotificationPersonalVideo.displayName = 'NotificationPersonalVideo';
	NotificationPersonalVideo.muiName = 'SvgIcon';
	
	exports.default = NotificationPersonalVideo;

/***/ },
/* 1757 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneBluetoothSpeaker = function NotificationPhoneBluetoothSpeaker(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M14.71 9.5L17 7.21V11h.5l2.85-2.85L18.21 6l2.15-2.15L17.5 1H17v3.79L14.71 2.5l-.71.71L16.79 6 14 8.79l.71.71zM18 2.91l.94.94-.94.94V2.91zm0 4.3l.94.94-.94.94V7.21zm2 8.29c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
	  );
	};
	NotificationPhoneBluetoothSpeaker = (0, _pure2.default)(NotificationPhoneBluetoothSpeaker);
	NotificationPhoneBluetoothSpeaker.displayName = 'NotificationPhoneBluetoothSpeaker';
	NotificationPhoneBluetoothSpeaker.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneBluetoothSpeaker;

/***/ },
/* 1758 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneForwarded = function NotificationPhoneForwarded(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 11l5-5-5-5v3h-4v4h4v3zm2 4.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1z' })
	  );
	};
	NotificationPhoneForwarded = (0, _pure2.default)(NotificationPhoneForwarded);
	NotificationPhoneForwarded.displayName = 'NotificationPhoneForwarded';
	NotificationPhoneForwarded.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneForwarded;

/***/ },
/* 1759 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneInTalk = function NotificationPhoneInTalk(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 12h2c0-4.97-4.03-9-9-9v2c3.87 0 7 3.13 7 7zm-4 0h2c0-2.76-2.24-5-5-5v2c1.66 0 3 1.34 3 3z' })
	  );
	};
	NotificationPhoneInTalk = (0, _pure2.default)(NotificationPhoneInTalk);
	NotificationPhoneInTalk.displayName = 'NotificationPhoneInTalk';
	NotificationPhoneInTalk.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneInTalk;

/***/ },
/* 1760 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneLocked = function NotificationPhoneLocked(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 15.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM20 4v-.5C20 2.12 18.88 1 17.5 1S15 2.12 15 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4z' })
	  );
	};
	NotificationPhoneLocked = (0, _pure2.default)(NotificationPhoneLocked);
	NotificationPhoneLocked.displayName = 'NotificationPhoneLocked';
	NotificationPhoneLocked.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneLocked;

/***/ },
/* 1761 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhoneMissed = function NotificationPhoneMissed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M6.5 5.5L12 11l7-7-1-1-6 6-4.5-4.5H11V3H5v6h1.5V5.5zm17.21 11.17C20.66 13.78 16.54 12 12 12 7.46 12 3.34 13.78.29 16.67c-.18.18-.29.43-.29.71s.11.53.29.71l2.48 2.48c.18.18.43.29.71.29.27 0 .52-.11.7-.28.79-.74 1.69-1.36 2.66-1.85.33-.16.56-.5.56-.9v-3.1c1.45-.48 3-.73 4.6-.73 1.6 0 3.15.25 4.6.72v3.1c0 .39.23.74.56.9.98.49 1.87 1.12 2.67 1.85.18.18.43.28.7.28.28 0 .53-.11.71-.29l2.48-2.48c.18-.18.29-.43.29-.71s-.12-.52-.3-.7z' })
	  );
	};
	NotificationPhoneMissed = (0, _pure2.default)(NotificationPhoneMissed);
	NotificationPhoneMissed.displayName = 'NotificationPhoneMissed';
	NotificationPhoneMissed.muiName = 'SvgIcon';
	
	exports.default = NotificationPhoneMissed;

/***/ },
/* 1762 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPhonePaused = function NotificationPhonePaused(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 3h-2v7h2V3zm3 12.5c-1.25 0-2.45-.2-3.57-.57-.35-.11-.74-.03-1.02.24l-2.2 2.2c-2.83-1.44-5.15-3.75-6.59-6.59l2.2-2.21c.28-.26.36-.65.25-1C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.5c0-.55-.45-1-1-1zM19 3v7h2V3h-2z' })
	  );
	};
	NotificationPhonePaused = (0, _pure2.default)(NotificationPhonePaused);
	NotificationPhonePaused.displayName = 'NotificationPhonePaused';
	NotificationPhonePaused.muiName = 'SvgIcon';
	
	exports.default = NotificationPhonePaused;

/***/ },
/* 1763 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPower = function NotificationPower(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.01 7L16 3h-2v4h-4V3H8v4h-.01C7 6.99 6 7.99 6 8.99v5.49L9.5 18v3h5v-3l3.5-3.51v-5.5c0-1-1-2-1.99-1.99z' })
	  );
	};
	NotificationPower = (0, _pure2.default)(NotificationPower);
	NotificationPower.displayName = 'NotificationPower';
	NotificationPower.muiName = 'SvgIcon';
	
	exports.default = NotificationPower;

/***/ },
/* 1764 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationPriorityHigh = function NotificationPriorityHigh(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '12', cy: '19', r: '2' }),
	    _react2.default.createElement('path', { d: 'M10 3h4v12h-4z' })
	  );
	};
	NotificationPriorityHigh = (0, _pure2.default)(NotificationPriorityHigh);
	NotificationPriorityHigh.displayName = 'NotificationPriorityHigh';
	NotificationPriorityHigh.muiName = 'SvgIcon';
	
	exports.default = NotificationPriorityHigh;

/***/ },
/* 1765 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationRvHookup = function NotificationRvHookup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z' })
	  );
	};
	NotificationRvHookup = (0, _pure2.default)(NotificationRvHookup);
	NotificationRvHookup.displayName = 'NotificationRvHookup';
	NotificationRvHookup.muiName = 'SvgIcon';
	
	exports.default = NotificationRvHookup;

/***/ },
/* 1766 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSdCard = function NotificationSdCard(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-6 6h-2V4h2v4zm3 0h-2V4h2v4zm3 0h-2V4h2v4z' })
	  );
	};
	NotificationSdCard = (0, _pure2.default)(NotificationSdCard);
	NotificationSdCard.displayName = 'NotificationSdCard';
	NotificationSdCard.muiName = 'SvgIcon';
	
	exports.default = NotificationSdCard;

/***/ },
/* 1767 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSimCardAlert = function NotificationSimCardAlert(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2h-8L4.02 8 4 20c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-5 15h-2v-2h2v2zm0-4h-2V8h2v5z' })
	  );
	};
	NotificationSimCardAlert = (0, _pure2.default)(NotificationSimCardAlert);
	NotificationSimCardAlert.displayName = 'NotificationSimCardAlert';
	NotificationSimCardAlert.muiName = 'SvgIcon';
	
	exports.default = NotificationSimCardAlert;

/***/ },
/* 1768 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSmsFailed = function NotificationSmsFailed(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z' })
	  );
	};
	NotificationSmsFailed = (0, _pure2.default)(NotificationSmsFailed);
	NotificationSmsFailed.displayName = 'NotificationSmsFailed';
	NotificationSmsFailed.muiName = 'SvgIcon';
	
	exports.default = NotificationSmsFailed;

/***/ },
/* 1769 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSms = function NotificationSms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zM9 11H7V9h2v2zm4 0h-2V9h2v2zm4 0h-2V9h2v2z' })
	  );
	};
	NotificationSms = (0, _pure2.default)(NotificationSms);
	NotificationSms.displayName = 'NotificationSms';
	NotificationSms.muiName = 'SvgIcon';
	
	exports.default = NotificationSms;

/***/ },
/* 1770 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSyncDisabled = function NotificationSyncDisabled(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 6.35V4.26c-.8.21-1.55.54-2.23.96l1.46 1.46c.25-.12.5-.24.77-.33zm-7.14-.94l2.36 2.36C4.45 8.99 4 10.44 4 12c0 2.21.91 4.2 2.36 5.64L4 20h6v-6l-2.24 2.24C6.68 15.15 6 13.66 6 12c0-1 .25-1.94.68-2.77l8.08 8.08c-.25.13-.5.25-.77.34v2.09c.8-.21 1.55-.54 2.23-.96l2.36 2.36 1.27-1.27L4.14 4.14 2.86 5.41zM20 4h-6v6l2.24-2.24C17.32 8.85 18 10.34 18 12c0 1-.25 1.94-.68 2.77l1.46 1.46C19.55 15.01 20 13.56 20 12c0-2.21-.91-4.2-2.36-5.64L20 4z' })
	  );
	};
	NotificationSyncDisabled = (0, _pure2.default)(NotificationSyncDisabled);
	NotificationSyncDisabled.displayName = 'NotificationSyncDisabled';
	NotificationSyncDisabled.muiName = 'SvgIcon';
	
	exports.default = NotificationSyncDisabled;

/***/ },
/* 1771 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSyncProblem = function NotificationSyncProblem(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 12c0 2.21.91 4.2 2.36 5.64L3 20h6v-6l-2.24 2.24C5.68 15.15 5 13.66 5 12c0-2.61 1.67-4.83 4-5.65V4.26C5.55 5.15 3 8.27 3 12zm8 5h2v-2h-2v2zM21 4h-6v6l2.24-2.24C18.32 8.85 19 10.34 19 12c0 2.61-1.67 4.83-4 5.65v2.09c3.45-.89 6-4.01 6-7.74 0-2.21-.91-4.2-2.36-5.64L21 4zm-10 9h2V7h-2v6z' })
	  );
	};
	NotificationSyncProblem = (0, _pure2.default)(NotificationSyncProblem);
	NotificationSyncProblem.displayName = 'NotificationSyncProblem';
	NotificationSyncProblem.muiName = 'SvgIcon';
	
	exports.default = NotificationSyncProblem;

/***/ },
/* 1772 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSync = function NotificationSync(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 4V1L8 5l4 4V6c3.31 0 6 2.69 6 6 0 1.01-.25 1.97-.7 2.8l1.46 1.46C19.54 15.03 20 13.57 20 12c0-4.42-3.58-8-8-8zm0 14c-3.31 0-6-2.69-6-6 0-1.01.25-1.97.7-2.8L5.24 7.74C4.46 8.97 4 10.43 4 12c0 4.42 3.58 8 8 8v3l4-4-4-4v3z' })
	  );
	};
	NotificationSync = (0, _pure2.default)(NotificationSync);
	NotificationSync.displayName = 'NotificationSync';
	NotificationSync.muiName = 'SvgIcon';
	
	exports.default = NotificationSync;

/***/ },
/* 1773 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationSystemUpdate = function NotificationSystemUpdate(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 1.01L7 1c-1.1 0-2 .9-2 2v18c0 1.1.9 2 2 2h10c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99zM17 19H7V5h10v14zm-1-6h-3V8h-2v5H8l4 4 4-4z' })
	  );
	};
	NotificationSystemUpdate = (0, _pure2.default)(NotificationSystemUpdate);
	NotificationSystemUpdate.displayName = 'NotificationSystemUpdate';
	NotificationSystemUpdate.muiName = 'SvgIcon';
	
	exports.default = NotificationSystemUpdate;

/***/ },
/* 1774 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationTapAndPlay = function NotificationTapAndPlay(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 16v2c2.76 0 5 2.24 5 5h2c0-3.87-3.13-7-7-7zm0 4v3h3c0-1.66-1.34-3-3-3zm0-8v2c4.97 0 9 4.03 9 9h2c0-6.08-4.92-11-11-11zM17 1.01L7 1c-1.1 0-2 .9-2 2v7.37c.69.16 1.36.37 2 .64V5h10v13h-3.03c.52 1.25.84 2.59.95 4H17c1.1 0 2-.9 2-2V3c0-1.1-.9-1.99-2-1.99z' })
	  );
	};
	NotificationTapAndPlay = (0, _pure2.default)(NotificationTapAndPlay);
	NotificationTapAndPlay.displayName = 'NotificationTapAndPlay';
	NotificationTapAndPlay.muiName = 'SvgIcon';
	
	exports.default = NotificationTapAndPlay;

/***/ },
/* 1775 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationTimeToLeave = function NotificationTimeToLeave(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.92 5.01C18.72 4.42 18.16 4 17.5 4h-11c-.66 0-1.21.42-1.42 1.01L3 11v8c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-1h12v1c0 .55.45 1 1 1h1c.55 0 1-.45 1-1v-8l-2.08-5.99zM6.5 15c-.83 0-1.5-.67-1.5-1.5S5.67 12 6.5 12s1.5.67 1.5 1.5S7.33 15 6.5 15zm11 0c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM5 10l1.5-4.5h11L19 10H5z' })
	  );
	};
	NotificationTimeToLeave = (0, _pure2.default)(NotificationTimeToLeave);
	NotificationTimeToLeave.displayName = 'NotificationTimeToLeave';
	NotificationTimeToLeave.muiName = 'SvgIcon';
	
	exports.default = NotificationTimeToLeave;

/***/ },
/* 1776 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationVibration = function NotificationVibration(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M0 15h2V9H0v6zm3 2h2V7H3v10zm19-8v6h2V9h-2zm-3 8h2V7h-2v10zM16.5 3h-9C6.67 3 6 3.67 6 4.5v15c0 .83.67 1.5 1.5 1.5h9c.83 0 1.5-.67 1.5-1.5v-15c0-.83-.67-1.5-1.5-1.5zM16 19H8V5h8v14z' })
	  );
	};
	NotificationVibration = (0, _pure2.default)(NotificationVibration);
	NotificationVibration.displayName = 'NotificationVibration';
	NotificationVibration.muiName = 'SvgIcon';
	
	exports.default = NotificationVibration;

/***/ },
/* 1777 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationVoiceChat = function NotificationVoiceChat(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12l-4-3.2V14H6V6h8v3.2L18 6v8z' })
	  );
	};
	NotificationVoiceChat = (0, _pure2.default)(NotificationVoiceChat);
	NotificationVoiceChat.displayName = 'NotificationVoiceChat';
	NotificationVoiceChat.muiName = 'SvgIcon';
	
	exports.default = NotificationVoiceChat;

/***/ },
/* 1778 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationVpnLock = function NotificationVpnLock(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 4v-.5C22 2.12 20.88 1 19.5 1S17 2.12 17 3.5V4c-.55 0-1 .45-1 1v4c0 .55.45 1 1 1h5c.55 0 1-.45 1-1V5c0-.55-.45-1-1-1zm-.8 0h-3.4v-.5c0-.94.76-1.7 1.7-1.7s1.7.76 1.7 1.7V4zm-2.28 8c.04.33.08.66.08 1 0 2.08-.8 3.97-2.1 5.39-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H7v-2h2c.55 0 1-.45 1-1V8h2c1.1 0 2-.9 2-2V3.46c-.95-.3-1.95-.46-3-.46C5.48 3 1 7.48 1 13s4.48 10 10 10 10-4.48 10-10c0-.34-.02-.67-.05-1h-2.03zM10 20.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L8 16v1c0 1.1.9 2 2 2v1.93z' })
	  );
	};
	NotificationVpnLock = (0, _pure2.default)(NotificationVpnLock);
	NotificationVpnLock.displayName = 'NotificationVpnLock';
	NotificationVpnLock.muiName = 'SvgIcon';
	
	exports.default = NotificationVpnLock;

/***/ },
/* 1779 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationWc = function NotificationWc(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5.5 22v-7.5H4V9c0-1.1.9-2 2-2h3c1.1 0 2 .9 2 2v5.5H9.5V22h-4zM18 22v-6h3l-2.54-7.63C18.18 7.55 17.42 7 16.56 7h-.12c-.86 0-1.63.55-1.9 1.37L12 16h3v6h3zM7.5 6c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2zm9 0c1.11 0 2-.89 2-2s-.89-2-2-2-2 .89-2 2 .89 2 2 2z' })
	  );
	};
	NotificationWc = (0, _pure2.default)(NotificationWc);
	NotificationWc.displayName = 'NotificationWc';
	NotificationWc.muiName = 'SvgIcon';
	
	exports.default = NotificationWc;

/***/ },
/* 1780 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var NotificationWifi = function NotificationWifi(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M1 9l2 2c4.97-4.97 13.03-4.97 18 0l2-2C16.93 2.93 7.08 2.93 1 9zm8 8l3 3 3-3c-1.65-1.66-4.34-1.66-6 0zm-4-4l2 2c2.76-2.76 7.24-2.76 10 0l2-2C15.14 9.14 8.87 9.14 5 13z' })
	  );
	};
	NotificationWifi = (0, _pure2.default)(NotificationWifi);
	NotificationWifi.displayName = 'NotificationWifi';
	NotificationWifi.muiName = 'SvgIcon';
	
	exports.default = NotificationWifi;

/***/ },
/* 1781 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesAcUnit = function PlacesAcUnit(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 11h-4.17l3.24-3.24-1.41-1.42L15 11h-2V9l4.66-4.66-1.42-1.41L13 6.17V2h-2v4.17L7.76 2.93 6.34 4.34 11 9v2H9L4.34 6.34 2.93 7.76 6.17 11H2v2h4.17l-3.24 3.24 1.41 1.42L9 13h2v2l-4.66 4.66 1.42 1.41L11 17.83V22h2v-4.17l3.24 3.24 1.42-1.41L13 15v-2h2l4.66 4.66 1.41-1.42L17.83 13H22z' })
	  );
	};
	PlacesAcUnit = (0, _pure2.default)(PlacesAcUnit);
	PlacesAcUnit.displayName = 'PlacesAcUnit';
	PlacesAcUnit.muiName = 'SvgIcon';
	
	exports.default = PlacesAcUnit;

/***/ },
/* 1782 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesAirportShuttle = function PlacesAirportShuttle(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M17 5H3c-1.1 0-2 .89-2 2v9h2c0 1.65 1.34 3 3 3s3-1.35 3-3h5.5c0 1.65 1.34 3 3 3s3-1.35 3-3H23v-5l-6-6zM3 11V7h4v4H3zm3 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm7-6.5H9V7h4v4zm4.5 6.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zM15 11V7h1l4 4h-5z' })
	  );
	};
	PlacesAirportShuttle = (0, _pure2.default)(PlacesAirportShuttle);
	PlacesAirportShuttle.displayName = 'PlacesAirportShuttle';
	PlacesAirportShuttle.muiName = 'SvgIcon';
	
	exports.default = PlacesAirportShuttle;

/***/ },
/* 1783 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesAllInclusive = function PlacesAllInclusive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18.6 6.62c-1.44 0-2.8.56-3.77 1.53L12 10.66 10.48 12h.01L7.8 14.39c-.64.64-1.49.99-2.4.99-1.87 0-3.39-1.51-3.39-3.38S3.53 8.62 5.4 8.62c.91 0 1.76.35 2.44 1.03l1.13 1 1.51-1.34L9.22 8.2C8.2 7.18 6.84 6.62 5.4 6.62 2.42 6.62 0 9.04 0 12s2.42 5.38 5.4 5.38c1.44 0 2.8-.56 3.77-1.53l2.83-2.5.01.01L13.52 12h-.01l2.69-2.39c.64-.64 1.49-.99 2.4-.99 1.87 0 3.39 1.51 3.39 3.38s-1.52 3.38-3.39 3.38c-.9 0-1.76-.35-2.44-1.03l-1.14-1.01-1.51 1.34 1.27 1.12c1.02 1.01 2.37 1.57 3.82 1.57 2.98 0 5.4-2.41 5.4-5.38s-2.42-5.37-5.4-5.37z' })
	  );
	};
	PlacesAllInclusive = (0, _pure2.default)(PlacesAllInclusive);
	PlacesAllInclusive.displayName = 'PlacesAllInclusive';
	PlacesAllInclusive.muiName = 'SvgIcon';
	
	exports.default = PlacesAllInclusive;

/***/ },
/* 1784 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesBeachAccess = function PlacesBeachAccess(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.127 14.56l1.43-1.43 6.44 6.443L19.57 21zm4.293-5.73l2.86-2.86c-3.95-3.95-10.35-3.96-14.3-.02 3.93-1.3 8.31-.25 11.44 2.88zM5.95 5.98c-3.94 3.95-3.93 10.35.02 14.3l2.86-2.86C5.7 14.29 4.65 9.91 5.95 5.98zm.02-.02l-.01.01c-.38 3.01 1.17 6.88 4.3 10.02l5.73-5.73c-3.13-3.13-7.01-4.68-10.02-4.3z' })
	  );
	};
	PlacesBeachAccess = (0, _pure2.default)(PlacesBeachAccess);
	PlacesBeachAccess.displayName = 'PlacesBeachAccess';
	PlacesBeachAccess.muiName = 'SvgIcon';
	
	exports.default = PlacesBeachAccess;

/***/ },
/* 1785 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesBusinessCenter = function PlacesBusinessCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 16v-1H3.01L3 19c0 1.11.89 2 2 2h14c1.11 0 2-.89 2-2v-4h-7v1h-4zm10-9h-4.01V5l-2-2h-4l-2 2v2H4c-1.1 0-2 .9-2 2v3c0 1.11.89 2 2 2h6v-2h4v2h6c1.1 0 2-.9 2-2V9c0-1.1-.9-2-2-2zm-6 0h-4V5h4v2z' })
	  );
	};
	PlacesBusinessCenter = (0, _pure2.default)(PlacesBusinessCenter);
	PlacesBusinessCenter.displayName = 'PlacesBusinessCenter';
	PlacesBusinessCenter.muiName = 'SvgIcon';
	
	exports.default = PlacesBusinessCenter;

/***/ },
/* 1786 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesCasino = function PlacesCasino(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM7.5 18c-.83 0-1.5-.67-1.5-1.5S6.67 15 7.5 15s1.5.67 1.5 1.5S8.33 18 7.5 18zm0-9C6.67 9 6 8.33 6 7.5S6.67 6 7.5 6 9 6.67 9 7.5 8.33 9 7.5 9zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm4.5 4.5c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5 1.5.67 1.5 1.5-.67 1.5-1.5 1.5zm0-9c-.83 0-1.5-.67-1.5-1.5S15.67 6 16.5 6s1.5.67 1.5 1.5S17.33 9 16.5 9z' })
	  );
	};
	PlacesCasino = (0, _pure2.default)(PlacesCasino);
	PlacesCasino.displayName = 'PlacesCasino';
	PlacesCasino.muiName = 'SvgIcon';
	
	exports.default = PlacesCasino;

/***/ },
/* 1787 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesChildCare = function PlacesChildCare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '14.5', cy: '10.5', r: '1.25' }),
	    _react2.default.createElement('circle', { cx: '9.5', cy: '10.5', r: '1.25' }),
	    _react2.default.createElement('path', { d: 'M22.94 12.66c.04-.21.06-.43.06-.66s-.02-.45-.06-.66c-.25-1.51-1.36-2.74-2.81-3.17-.53-1.12-1.28-2.1-2.19-2.91C16.36 3.85 14.28 3 12 3s-4.36.85-5.94 2.26c-.92.81-1.67 1.8-2.19 2.91-1.45.43-2.56 1.65-2.81 3.17-.04.21-.06.43-.06.66s.02.45.06.66c.25 1.51 1.36 2.74 2.81 3.17.52 1.11 1.27 2.09 2.17 2.89C7.62 20.14 9.71 21 12 21s4.38-.86 5.97-2.28c.9-.8 1.65-1.79 2.17-2.89 1.44-.43 2.55-1.65 2.8-3.17zM19 14c-.1 0-.19-.02-.29-.03-.2.67-.49 1.29-.86 1.86C16.6 17.74 14.45 19 12 19s-4.6-1.26-5.85-3.17c-.37-.57-.66-1.19-.86-1.86-.1.01-.19.03-.29.03-1.1 0-2-.9-2-2s.9-2 2-2c.1 0 .19.02.29.03.2-.67.49-1.29.86-1.86C7.4 6.26 9.55 5 12 5s4.6 1.26 5.85 3.17c.37.57.66 1.19.86 1.86.1-.01.19-.03.29-.03 1.1 0 2 .9 2 2s-.9 2-2 2zM7.5 14c.76 1.77 2.49 3 4.5 3s3.74-1.23 4.5-3h-9z' })
	  );
	};
	PlacesChildCare = (0, _pure2.default)(PlacesChildCare);
	PlacesChildCare.displayName = 'PlacesChildCare';
	PlacesChildCare.muiName = 'SvgIcon';
	
	exports.default = PlacesChildCare;

/***/ },
/* 1788 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesChildFriendly = function PlacesChildFriendly(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13 2v8h8c0-4.42-3.58-8-8-8zm6.32 13.89C20.37 14.54 21 12.84 21 11H6.44l-.95-2H2v2h2.22s1.89 4.07 2.12 4.42c-1.1.59-1.84 1.75-1.84 3.08C4.5 20.43 6.07 22 8 22c1.76 0 3.22-1.3 3.46-3h2.08c.24 1.7 1.7 3 3.46 3 1.93 0 3.5-1.57 3.5-3.5 0-1.04-.46-1.97-1.18-2.61zM8 20c-.83 0-1.5-.67-1.5-1.5S7.17 17 8 17s1.5.67 1.5 1.5S8.83 20 8 20zm9 0c-.83 0-1.5-.67-1.5-1.5S16.17 17 17 17s1.5.67 1.5 1.5S17.83 20 17 20z' })
	  );
	};
	PlacesChildFriendly = (0, _pure2.default)(PlacesChildFriendly);
	PlacesChildFriendly.displayName = 'PlacesChildFriendly';
	PlacesChildFriendly.muiName = 'SvgIcon';
	
	exports.default = PlacesChildFriendly;

/***/ },
/* 1789 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesFitnessCenter = function PlacesFitnessCenter(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20.57 14.86L22 13.43 20.57 12 17 15.57 8.43 7 12 3.43 10.57 2 9.14 3.43 7.71 2 5.57 4.14 4.14 2.71 2.71 4.14l1.43 1.43L2 7.71l1.43 1.43L2 10.57 3.43 12 7 8.43 15.57 17 12 20.57 13.43 22l1.43-1.43L16.29 22l2.14-2.14 1.43 1.43 1.43-1.43-1.43-1.43L22 16.29z' })
	  );
	};
	PlacesFitnessCenter = (0, _pure2.default)(PlacesFitnessCenter);
	PlacesFitnessCenter.displayName = 'PlacesFitnessCenter';
	PlacesFitnessCenter.muiName = 'SvgIcon';
	
	exports.default = PlacesFitnessCenter;

/***/ },
/* 1790 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesFreeBreakfast = function PlacesFreeBreakfast(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 3H4v10c0 2.21 1.79 4 4 4h6c2.21 0 4-1.79 4-4v-3h2c1.11 0 2-.9 2-2V5c0-1.11-.89-2-2-2zm0 5h-2V5h2v3zM4 19h16v2H4z' })
	  );
	};
	PlacesFreeBreakfast = (0, _pure2.default)(PlacesFreeBreakfast);
	PlacesFreeBreakfast.displayName = 'PlacesFreeBreakfast';
	PlacesFreeBreakfast.muiName = 'SvgIcon';
	
	exports.default = PlacesFreeBreakfast;

/***/ },
/* 1791 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesGolfCourse = function PlacesGolfCourse(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '19.5', cy: '19.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M17 5.92L9 2v18H7v-1.73c-1.79.35-3 .99-3 1.73 0 1.1 2.69 2 6 2s6-.9 6-2c0-.99-2.16-1.81-5-1.97V8.98l6-3.06z' })
	  );
	};
	PlacesGolfCourse = (0, _pure2.default)(PlacesGolfCourse);
	PlacesGolfCourse.displayName = 'PlacesGolfCourse';
	PlacesGolfCourse.muiName = 'SvgIcon';
	
	exports.default = PlacesGolfCourse;

/***/ },
/* 1792 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesHotTub = function PlacesHotTub(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '7', cy: '6', r: '2' }),
	    _react2.default.createElement('path', { d: 'M11.15 12c-.31-.22-.59-.46-.82-.72l-1.4-1.55c-.19-.21-.43-.38-.69-.5-.29-.14-.62-.23-.96-.23h-.03C6.01 9 5 10.01 5 11.25V12H2v8c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2v-8H11.15zM7 20H5v-6h2v6zm4 0H9v-6h2v6zm4 0h-2v-6h2v6zm4 0h-2v-6h2v6zm-.35-14.14l-.07-.07c-.57-.62-.82-1.41-.67-2.2L18 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71zm-4 0l-.07-.07c-.57-.62-.82-1.41-.67-2.2L14 3h-1.89l-.06.43c-.2 1.36.27 2.71 1.3 3.72l.07.06c.57.62.82 1.41.67 2.2l-.11.59h1.91l.06-.43c.21-1.36-.27-2.71-1.3-3.71z' })
	  );
	};
	PlacesHotTub = (0, _pure2.default)(PlacesHotTub);
	PlacesHotTub.displayName = 'PlacesHotTub';
	PlacesHotTub.muiName = 'SvgIcon';
	
	exports.default = PlacesHotTub;

/***/ },
/* 1793 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesKitchen = function PlacesKitchen(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 2.01L6 2c-1.1 0-2 .89-2 2v16c0 1.1.9 2 2 2h12c1.1 0 2-.9 2-2V4c0-1.11-.9-1.99-2-1.99zM18 20H6v-9.02h12V20zm0-11H6V4h12v5zM8 5h2v3H8zm0 7h2v5H8z' })
	  );
	};
	PlacesKitchen = (0, _pure2.default)(PlacesKitchen);
	PlacesKitchen.displayName = 'PlacesKitchen';
	PlacesKitchen.muiName = 'SvgIcon';
	
	exports.default = PlacesKitchen;

/***/ },
/* 1794 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesPool = function PlacesPool(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 21c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.46.27-1.08.64-2.19.64-1.11 0-1.73-.37-2.18-.64-.37-.23-.6-.36-1.15-.36s-.78.13-1.15.36c-.46.27-1.08.64-2.19.64v-2c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.23.59.36 1.15.36v2zm0-4.5c-1.11 0-1.73-.37-2.18-.64-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36-.56 0-.78.13-1.15.36-.45.27-1.07.64-2.18.64s-1.73-.37-2.18-.64c-.37-.22-.6-.36-1.15-.36s-.78.13-1.15.36c-.47.27-1.09.64-2.2.64v-2c.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36.56 0 .78-.13 1.15-.36.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36s.78-.13 1.15-.36c.45-.27 1.07-.64 2.18-.64s1.73.37 2.18.64c.37.22.6.36 1.15.36v2zM8.67 12c.56 0 .78-.13 1.15-.36.46-.27 1.08-.64 2.19-.64 1.11 0 1.73.37 2.18.64.37.22.6.36 1.15.36s.78-.13 1.15-.36c.12-.07.26-.15.41-.23L10.48 5C8.93 3.45 7.5 2.99 5 3v2.5c1.82-.01 2.89.39 4 1.5l1 1-3.25 3.25c.31.12.56.27.77.39.37.23.59.36 1.15.36z' }),
	    _react2.default.createElement('circle', { cx: '16.5', cy: '5.5', r: '2.5' })
	  );
	};
	PlacesPool = (0, _pure2.default)(PlacesPool);
	PlacesPool.displayName = 'PlacesPool';
	PlacesPool.muiName = 'SvgIcon';
	
	exports.default = PlacesPool;

/***/ },
/* 1795 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesRoomService = function PlacesRoomService(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 17h20v2H2zm11.84-9.21c.1-.24.16-.51.16-.79 0-1.1-.9-2-2-2s-2 .9-2 2c0 .28.06.55.16.79C6.25 8.6 3.27 11.93 3 16h18c-.27-4.07-3.25-7.4-7.16-8.21z' })
	  );
	};
	PlacesRoomService = (0, _pure2.default)(PlacesRoomService);
	PlacesRoomService.displayName = 'PlacesRoomService';
	PlacesRoomService.muiName = 'SvgIcon';
	
	exports.default = PlacesRoomService;

/***/ },
/* 1796 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesRvHookup = function PlacesRvHookup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 17v-6c0-1.1-.9-2-2-2H7V7l-3 3 3 3v-2h4v3H4v3c0 1.1.9 2 2 2h2c0 1.66 1.34 3 3 3s3-1.34 3-3h8v-2h-2zm-9 3c-.55 0-1-.45-1-1s.45-1 1-1 1 .45 1 1-.45 1-1 1zm7-6h-4v-3h4v3zM17 2v2H9v2h8v2l3-3z' })
	  );
	};
	PlacesRvHookup = (0, _pure2.default)(PlacesRvHookup);
	PlacesRvHookup.displayName = 'PlacesRvHookup';
	PlacesRvHookup.muiName = 'SvgIcon';
	
	exports.default = PlacesRvHookup;

/***/ },
/* 1797 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesSmokeFree = function PlacesSmokeFree(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 6l6.99 7H2v3h9.99l7 7 1.26-1.25-17-17zm18.5 7H22v3h-1.5zM18 13h1.5v3H18zm.85-8.12c.62-.61 1-1.45 1-2.38h-1.5c0 1.02-.83 1.85-1.85 1.85v1.5c2.24 0 4 1.83 4 4.07V12H22V9.92c0-2.23-1.28-4.15-3.15-5.04zM14.5 8.7h1.53c1.05 0 1.97.74 1.97 2.05V12h1.5v-1.59c0-1.8-1.6-3.16-3.47-3.16H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75V2c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35zm2.5 7.23V13h-2.93z' })
	  );
	};
	PlacesSmokeFree = (0, _pure2.default)(PlacesSmokeFree);
	PlacesSmokeFree.displayName = 'PlacesSmokeFree';
	PlacesSmokeFree.muiName = 'SvgIcon';
	
	exports.default = PlacesSmokeFree;

/***/ },
/* 1798 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesSmokingRooms = function PlacesSmokingRooms(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M2 16h15v3H2zm18.5 0H22v3h-1.5zM18 16h1.5v3H18zm.85-8.27c.62-.61 1-1.45 1-2.38C19.85 3.5 18.35 2 16.5 2v1.5c1.02 0 1.85.83 1.85 1.85S17.52 7.2 16.5 7.2v1.5c2.24 0 4 1.83 4 4.07V15H22v-2.24c0-2.22-1.28-4.14-3.15-5.03zm-2.82 2.47H14.5c-1.02 0-1.85-.98-1.85-2s.83-1.75 1.85-1.75v-1.5c-1.85 0-3.35 1.5-3.35 3.35s1.5 3.35 3.35 3.35h1.53c1.05 0 1.97.74 1.97 2.05V15h1.5v-1.64c0-1.81-1.6-3.16-3.47-3.16z' })
	  );
	};
	PlacesSmokingRooms = (0, _pure2.default)(PlacesSmokingRooms);
	PlacesSmokingRooms.displayName = 'PlacesSmokingRooms';
	PlacesSmokingRooms.muiName = 'SvgIcon';
	
	exports.default = PlacesSmokingRooms;

/***/ },
/* 1799 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var PlacesSpa = function PlacesSpa(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8.55 12c-1.07-.71-2.25-1.27-3.53-1.61 1.28.34 2.46.9 3.53 1.61zm10.43-1.61c-1.29.34-2.49.91-3.57 1.64 1.08-.73 2.28-1.3 3.57-1.64z' }),
	    _react2.default.createElement('path', { d: 'M15.49 9.63c-.18-2.79-1.31-5.51-3.43-7.63-2.14 2.14-3.32 4.86-3.55 7.63 1.28.68 2.46 1.56 3.49 2.63 1.03-1.06 2.21-1.94 3.49-2.63zm-6.5 2.65c-.14-.1-.3-.19-.45-.29.15.11.31.19.45.29zm6.42-.25c-.13.09-.27.16-.4.26.13-.1.27-.17.4-.26zM12 15.45C9.85 12.17 6.18 10 2 10c0 5.32 3.36 9.82 8.03 11.49.63.23 1.29.4 1.97.51.68-.12 1.33-.29 1.97-.51C18.64 19.82 22 15.32 22 10c-4.18 0-7.85 2.17-10 5.45z' })
	  );
	};
	PlacesSpa = (0, _pure2.default)(PlacesSpa);
	PlacesSpa.displayName = 'PlacesSpa';
	PlacesSpa.muiName = 'SvgIcon';
	
	exports.default = PlacesSpa;

/***/ },
/* 1800 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialCake = function SocialCake(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 6c1.11 0 2-.9 2-2 0-.38-.1-.73-.29-1.03L12 0l-1.71 2.97c-.19.3-.29.65-.29 1.03 0 1.1.9 2 2 2zm4.6 9.99l-1.07-1.07-1.08 1.07c-1.3 1.3-3.58 1.31-4.89 0l-1.07-1.07-1.09 1.07C6.75 16.64 5.88 17 4.96 17c-.73 0-1.4-.23-1.96-.61V21c0 .55.45 1 1 1h16c.55 0 1-.45 1-1v-4.61c-.56.38-1.23.61-1.96.61-.92 0-1.79-.36-2.44-1.01zM18 9h-5V7h-2v2H6c-1.66 0-3 1.34-3 3v1.54c0 1.08.88 1.96 1.96 1.96.52 0 1.02-.2 1.38-.57l2.14-2.13 2.13 2.13c.74.74 2.03.74 2.77 0l2.14-2.13 2.13 2.13c.37.37.86.57 1.38.57 1.08 0 1.96-.88 1.96-1.96V12C21 10.34 19.66 9 18 9z' })
	  );
	};
	SocialCake = (0, _pure2.default)(SocialCake);
	SocialCake.displayName = 'SocialCake';
	SocialCake.muiName = 'SvgIcon';
	
	exports.default = SocialCake;

/***/ },
/* 1801 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialDomain = function SocialDomain(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 7V3H2v18h20V7H12zM6 19H4v-2h2v2zm0-4H4v-2h2v2zm0-4H4V9h2v2zm0-4H4V5h2v2zm4 12H8v-2h2v2zm0-4H8v-2h2v2zm0-4H8V9h2v2zm0-4H8V5h2v2zm10 12h-8v-2h2v-2h-2v-2h2v-2h-2V9h8v10zm-2-8h-2v2h2v-2zm0 4h-2v2h2v-2z' })
	  );
	};
	SocialDomain = (0, _pure2.default)(SocialDomain);
	SocialDomain.displayName = 'SocialDomain';
	SocialDomain.muiName = 'SvgIcon';
	
	exports.default = SocialDomain;

/***/ },
/* 1802 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialGroupAdd = function SocialGroupAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M8 10H5V7H3v3H0v2h3v3h2v-3h3v-2zm10 1c1.66 0 2.99-1.34 2.99-3S19.66 5 18 5c-.32 0-.63.05-.91.14.57.81.9 1.79.9 2.86s-.34 2.04-.9 2.86c.28.09.59.14.91.14zm-5 0c1.66 0 2.99-1.34 2.99-3S14.66 5 13 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm6.62 2.16c.83.73 1.38 1.66 1.38 2.84v2h3v-2c0-1.54-2.37-2.49-4.38-2.84zM13 13c-2 0-6 1-6 3v2h12v-2c0-2-4-3-6-3z' })
	  );
	};
	SocialGroupAdd = (0, _pure2.default)(SocialGroupAdd);
	SocialGroupAdd.displayName = 'SocialGroupAdd';
	SocialGroupAdd.muiName = 'SvgIcon';
	
	exports.default = SocialGroupAdd;

/***/ },
/* 1803 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialGroup = function SocialGroup(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
	  );
	};
	SocialGroup = (0, _pure2.default)(SocialGroup);
	SocialGroup.displayName = 'SocialGroup';
	SocialGroup.muiName = 'SvgIcon';
	
	exports.default = SocialGroup;

/***/ },
/* 1804 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialLocationCity = function SocialLocationCity(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 11V5l-3-3-3 3v2H3v14h18V11h-6zm-8 8H5v-2h2v2zm0-4H5v-2h2v2zm0-4H5V9h2v2zm6 8h-2v-2h2v2zm0-4h-2v-2h2v2zm0-4h-2V9h2v2zm0-4h-2V5h2v2zm6 12h-2v-2h2v2zm0-4h-2v-2h2v2z' })
	  );
	};
	SocialLocationCity = (0, _pure2.default)(SocialLocationCity);
	SocialLocationCity.displayName = 'SocialLocationCity';
	SocialLocationCity.muiName = 'SvgIcon';
	
	exports.default = SocialLocationCity;

/***/ },
/* 1805 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMoodBad = function SocialMoodBad(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 3c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z' })
	  );
	};
	SocialMoodBad = (0, _pure2.default)(SocialMoodBad);
	SocialMoodBad.displayName = 'SocialMoodBad';
	SocialMoodBad.muiName = 'SvgIcon';
	
	exports.default = SocialMoodBad;

/***/ },
/* 1806 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialMood = function SocialMood(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm3.5-9c.83 0 1.5-.67 1.5-1.5S16.33 8 15.5 8 14 8.67 14 9.5s.67 1.5 1.5 1.5zm-7 0c.83 0 1.5-.67 1.5-1.5S9.33 8 8.5 8 7 8.67 7 9.5 7.67 11 8.5 11zm3.5 6.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	SocialMood = (0, _pure2.default)(SocialMood);
	SocialMood.displayName = 'SocialMood';
	SocialMood.muiName = 'SvgIcon';
	
	exports.default = SocialMood;

/***/ },
/* 1807 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsActive = function SocialNotificationsActive(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M7.58 4.08L6.15 2.65C3.75 4.48 2.17 7.3 2.03 10.5h2c.15-2.65 1.51-4.97 3.55-6.42zm12.39 6.42h2c-.15-3.2-1.73-6.02-4.12-7.85l-1.42 1.43c2.02 1.45 3.39 3.77 3.54 6.42zM18 11c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2v-5zm-6 11c.14 0 .27-.01.4-.04.65-.14 1.18-.58 1.44-1.18.1-.24.15-.5.15-.78h-4c.01 1.1.9 2 2.01 2z' })
	  );
	};
	SocialNotificationsActive = (0, _pure2.default)(SocialNotificationsActive);
	SocialNotificationsActive.displayName = 'SocialNotificationsActive';
	SocialNotificationsActive.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsActive;

/***/ },
/* 1808 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsNone = function SocialNotificationsNone(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.9 2 2 2zm6-6v-5c0-3.07-1.63-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.64 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2zm-2 1H8v-6c0-2.48 1.51-4.5 4-4.5s4 2.02 4 4.5v6z' })
	  );
	};
	SocialNotificationsNone = (0, _pure2.default)(SocialNotificationsNone);
	SocialNotificationsNone.displayName = 'SocialNotificationsNone';
	SocialNotificationsNone.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsNone;

/***/ },
/* 1809 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsOff = function SocialNotificationsOff(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 18.69L7.84 6.14 5.27 3.49 4 4.76l2.8 2.8v.01c-.52.99-.8 2.16-.8 3.42v5l-2 2v1h13.73l2 2L21 19.72l-1-1.03zM12 22c1.11 0 2-.89 2-2h-4c0 1.11.89 2 2 2zm6-7.32V11c0-3.08-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68c-.15.03-.29.08-.42.12-.1.03-.2.07-.3.11h-.01c-.01 0-.01 0-.02.01-.23.09-.46.2-.68.31 0 0-.01 0-.01.01L18 14.68z' })
	  );
	};
	SocialNotificationsOff = (0, _pure2.default)(SocialNotificationsOff);
	SocialNotificationsOff.displayName = 'SocialNotificationsOff';
	SocialNotificationsOff.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsOff;

/***/ },
/* 1810 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotificationsPaused = function SocialNotificationsPaused(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.93 6 11v5l-2 2v1h16v-1l-2-2zm-3.5-6.2l-2.8 3.4h2.8V15h-5v-1.8l2.8-3.4H9.5V8h5v1.8z' })
	  );
	};
	SocialNotificationsPaused = (0, _pure2.default)(SocialNotificationsPaused);
	SocialNotificationsPaused.displayName = 'SocialNotificationsPaused';
	SocialNotificationsPaused.muiName = 'SvgIcon';
	
	exports.default = SocialNotificationsPaused;

/***/ },
/* 1811 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialNotifications = function SocialNotifications(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 22c1.1 0 2-.9 2-2h-4c0 1.1.89 2 2 2zm6-6v-5c0-3.07-1.64-5.64-4.5-6.32V4c0-.83-.67-1.5-1.5-1.5s-1.5.67-1.5 1.5v.68C7.63 5.36 6 7.92 6 11v5l-2 2v1h16v-1l-2-2z' })
	  );
	};
	SocialNotifications = (0, _pure2.default)(SocialNotifications);
	SocialNotifications.displayName = 'SocialNotifications';
	SocialNotifications.muiName = 'SvgIcon';
	
	exports.default = SocialNotifications;

/***/ },
/* 1812 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPages = function SocialPages(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M3 5v6h5L7 7l4 1V3H5c-1.1 0-2 .9-2 2zm5 8H3v6c0 1.1.9 2 2 2h6v-5l-4 1 1-4zm9 4l-4-1v5h6c1.1 0 2-.9 2-2v-6h-5l1 4zm2-14h-6v5l4-1-1 4h5V5c0-1.1-.9-2-2-2z' })
	  );
	};
	SocialPages = (0, _pure2.default)(SocialPages);
	SocialPages.displayName = 'SocialPages';
	SocialPages.muiName = 'SvgIcon';
	
	exports.default = SocialPages;

/***/ },
/* 1813 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPartyMode = function SocialPartyMode(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M20 4h-3.17L15 2H9L7.17 4H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm-8 3c1.63 0 3.06.79 3.98 2H12c-1.66 0-3 1.34-3 3 0 .35.07.69.18 1H7.1c-.06-.32-.1-.66-.1-1 0-2.76 2.24-5 5-5zm0 10c-1.63 0-3.06-.79-3.98-2H12c1.66 0 3-1.34 3-3 0-.35-.07-.69-.18-1h2.08c.07.32.1.66.1 1 0 2.76-2.24 5-5 5z' })
	  );
	};
	SocialPartyMode = (0, _pure2.default)(SocialPartyMode);
	SocialPartyMode.displayName = 'SocialPartyMode';
	SocialPartyMode.muiName = 'SvgIcon';
	
	exports.default = SocialPartyMode;

/***/ },
/* 1814 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPeopleOutline = function SocialPeopleOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16.5 13c-1.2 0-3.07.34-4.5 1-1.43-.67-3.3-1-4.5-1C5.33 13 1 14.08 1 16.25V19h22v-2.75c0-2.17-4.33-3.25-6.5-3.25zm-4 4.5h-10v-1.25c0-.54 2.56-1.75 5-1.75s5 1.21 5 1.75v1.25zm9 0H14v-1.25c0-.46-.2-.86-.52-1.22.88-.3 1.96-.53 3.02-.53 2.44 0 5 1.21 5 1.75v1.25zM7.5 12c1.93 0 3.5-1.57 3.5-3.5S9.43 5 7.5 5 4 6.57 4 8.5 5.57 12 7.5 12zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2zm9 5.5c1.93 0 3.5-1.57 3.5-3.5S18.43 5 16.5 5 13 6.57 13 8.5s1.57 3.5 3.5 3.5zm0-5.5c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2z' })
	  );
	};
	SocialPeopleOutline = (0, _pure2.default)(SocialPeopleOutline);
	SocialPeopleOutline.displayName = 'SocialPeopleOutline';
	SocialPeopleOutline.muiName = 'SvgIcon';
	
	exports.default = SocialPeopleOutline;

/***/ },
/* 1815 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPeople = function SocialPeople(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z' })
	  );
	};
	SocialPeople = (0, _pure2.default)(SocialPeople);
	SocialPeople.displayName = 'SocialPeople';
	SocialPeople.muiName = 'SvgIcon';
	
	exports.default = SocialPeople;

/***/ },
/* 1816 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPersonAdd = function SocialPersonAdd(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M15 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm-9-2V7H4v3H1v2h3v3h2v-3h3v-2H6zm9 4c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
	  );
	};
	SocialPersonAdd = (0, _pure2.default)(SocialPersonAdd);
	SocialPersonAdd.displayName = 'SocialPersonAdd';
	SocialPersonAdd.muiName = 'SvgIcon';
	
	exports.default = SocialPersonAdd;

/***/ },
/* 1817 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPersonOutline = function SocialPersonOutline(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 5.9c1.16 0 2.1.94 2.1 2.1s-.94 2.1-2.1 2.1S9.9 9.16 9.9 8s.94-2.1 2.1-2.1m0 9c2.97 0 6.1 1.46 6.1 2.1v1.1H5.9V17c0-.64 3.13-2.1 6.1-2.1M12 4C9.79 4 8 5.79 8 8s1.79 4 4 4 4-1.79 4-4-1.79-4-4-4zm0 9c-2.67 0-8 1.34-8 4v3h16v-3c0-2.66-5.33-4-8-4z' })
	  );
	};
	SocialPersonOutline = (0, _pure2.default)(SocialPersonOutline);
	SocialPersonOutline.displayName = 'SocialPersonOutline';
	SocialPersonOutline.muiName = 'SvgIcon';
	
	exports.default = SocialPersonOutline;

/***/ },
/* 1818 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPerson = function SocialPerson(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z' })
	  );
	};
	SocialPerson = (0, _pure2.default)(SocialPerson);
	SocialPerson.displayName = 'SocialPerson';
	SocialPerson.muiName = 'SvgIcon';
	
	exports.default = SocialPerson;

/***/ },
/* 1819 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPlusOne = function SocialPlusOne(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M10 8H8v4H4v2h4v4h2v-4h4v-2h-4zm4.5-1.92V7.9l2.5-.5V18h2V5z' })
	  );
	};
	SocialPlusOne = (0, _pure2.default)(SocialPlusOne);
	SocialPlusOne.displayName = 'SocialPlusOne';
	SocialPlusOne.muiName = 'SvgIcon';
	
	exports.default = SocialPlusOne;

/***/ },
/* 1820 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPoll = function SocialPoll(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zM9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4z' })
	  );
	};
	SocialPoll = (0, _pure2.default)(SocialPoll);
	SocialPoll.displayName = 'SocialPoll';
	SocialPoll.muiName = 'SvgIcon';
	
	exports.default = SocialPoll;

/***/ },
/* 1821 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialPublic = function SocialPublic(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z' })
	  );
	};
	SocialPublic = (0, _pure2.default)(SocialPublic);
	SocialPublic.displayName = 'SocialPublic';
	SocialPublic.muiName = 'SvgIcon';
	
	exports.default = SocialPublic;

/***/ },
/* 1822 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSchool = function SocialSchool(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M5 13.18v4L12 21l7-3.82v-4L12 17l-7-3.82zM12 3L1 9l11 6 9-4.91V17h2V9L12 3z' })
	  );
	};
	SocialSchool = (0, _pure2.default)(SocialSchool);
	SocialSchool.displayName = 'SocialSchool';
	SocialSchool.muiName = 'SvgIcon';
	
	exports.default = SocialSchool;

/***/ },
/* 1823 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentDissatisfied = function SocialSentimentDissatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-6c-2.33 0-4.32 1.45-5.12 3.5h1.67c.69-1.19 1.97-2 3.45-2s2.75.81 3.45 2h1.67c-.8-2.05-2.79-3.5-5.12-3.5z' })
	  );
	};
	SocialSentimentDissatisfied = (0, _pure2.default)(SocialSentimentDissatisfied);
	SocialSentimentDissatisfied.displayName = 'SocialSentimentDissatisfied';
	SocialSentimentDissatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentDissatisfied;

/***/ },
/* 1824 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentNeutral = function SocialSentimentNeutral(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M9 14h6v1.5H9z' }),
	    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z' })
	  );
	};
	SocialSentimentNeutral = (0, _pure2.default)(SocialSentimentNeutral);
	SocialSentimentNeutral.displayName = 'SocialSentimentNeutral';
	SocialSentimentNeutral.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentNeutral;

/***/ },
/* 1825 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentSatisfied = function SocialSentimentSatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('circle', { cx: '15.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('circle', { cx: '8.5', cy: '9.5', r: '1.5' }),
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.48 2 12s4.47 10 9.99 10C17.52 22 22 17.52 22 12S17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm0-4c-1.48 0-2.75-.81-3.45-2H6.88c.8 2.05 2.79 3.5 5.12 3.5s4.32-1.45 5.12-3.5h-1.67c-.7 1.19-1.97 2-3.45 2z' })
	  );
	};
	SocialSentimentSatisfied = (0, _pure2.default)(SocialSentimentSatisfied);
	SocialSentimentSatisfied.displayName = 'SocialSentimentSatisfied';
	SocialSentimentSatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentSatisfied;

/***/ },
/* 1826 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentVeryDissatisfied = function SocialSentimentVeryDissatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm4.18-12.24l-1.06 1.06-1.06-1.06L13 8.82l1.06 1.06L13 10.94 14.06 12l1.06-1.06L16.18 12l1.06-1.06-1.06-1.06 1.06-1.06zM7.82 12l1.06-1.06L9.94 12 11 10.94 9.94 9.88 11 8.82 9.94 7.76 8.88 8.82 7.82 7.76 6.76 8.82l1.06 1.06-1.06 1.06zM12 14c-2.33 0-4.31 1.46-5.11 3.5h10.22c-.8-2.04-2.78-3.5-5.11-3.5z' })
	  );
	};
	SocialSentimentVeryDissatisfied = (0, _pure2.default)(SocialSentimentVeryDissatisfied);
	SocialSentimentVeryDissatisfied.displayName = 'SocialSentimentVeryDissatisfied';
	SocialSentimentVeryDissatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentVeryDissatisfied;

/***/ },
/* 1827 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialSentimentVerySatisfied = function SocialSentimentVerySatisfied(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M11.99 2C6.47 2 2 6.47 2 12s4.47 10 9.99 10S22 17.53 22 12 17.52 2 11.99 2zM12 20c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8zm1-10.06L14.06 11l1.06-1.06L16.18 11l1.06-1.06-2.12-2.12zm-4.12 0L9.94 11 11 9.94 8.88 7.82 6.76 9.94 7.82 11zM12 17.5c2.33 0 4.31-1.46 5.11-3.5H6.89c.8 2.04 2.78 3.5 5.11 3.5z' })
	  );
	};
	SocialSentimentVerySatisfied = (0, _pure2.default)(SocialSentimentVerySatisfied);
	SocialSentimentVerySatisfied.displayName = 'SocialSentimentVerySatisfied';
	SocialSentimentVerySatisfied.muiName = 'SvgIcon';
	
	exports.default = SocialSentimentVerySatisfied;

/***/ },
/* 1828 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialShare = function SocialShare(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z' })
	  );
	};
	SocialShare = (0, _pure2.default)(SocialShare);
	SocialShare.displayName = 'SocialShare';
	SocialShare.muiName = 'SvgIcon';
	
	exports.default = SocialShare;

/***/ },
/* 1829 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SocialWhatshot = function SocialWhatshot(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M13.5.67s.74 2.65.74 4.8c0 2.06-1.35 3.73-3.41 3.73-2.07 0-3.63-1.67-3.63-3.73l.03-.36C5.21 7.51 4 10.62 4 14c0 4.42 3.58 8 8 8s8-3.58 8-8C20 8.61 17.41 3.8 13.5.67zM11.71 19c-1.78 0-3.22-1.4-3.22-3.14 0-1.62 1.05-2.76 2.81-3.12 1.77-.36 3.6-1.21 4.62-2.58.39 1.29.59 2.65.59 4.04 0 2.65-2.15 4.8-4.8 4.8z' })
	  );
	};
	SocialWhatshot = (0, _pure2.default)(SocialWhatshot);
	SocialWhatshot.displayName = 'SocialWhatshot';
	SocialWhatshot.muiName = 'SvgIcon';
	
	exports.default = SocialWhatshot;

/***/ },
/* 1830 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleIndeterminateCheckBox = function ToggleIndeterminateCheckBox(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z' })
	  );
	};
	ToggleIndeterminateCheckBox = (0, _pure2.default)(ToggleIndeterminateCheckBox);
	ToggleIndeterminateCheckBox.displayName = 'ToggleIndeterminateCheckBox';
	ToggleIndeterminateCheckBox.muiName = 'SvgIcon';
	
	exports.default = ToggleIndeterminateCheckBox;

/***/ },
/* 1831 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleStarBorder = function ToggleStarBorder(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4l-3.76 2.27 1-4.28-3.32-2.88 4.38-.38L12 6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' })
	  );
	};
	ToggleStarBorder = (0, _pure2.default)(ToggleStarBorder);
	ToggleStarBorder.displayName = 'ToggleStarBorder';
	ToggleStarBorder.muiName = 'SvgIcon';
	
	exports.default = ToggleStarBorder;

/***/ },
/* 1832 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleStarHalf = function ToggleStarHalf(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M22 9.24l-7.19-.62L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21 12 17.27 18.18 21l-1.63-7.03L22 9.24zM12 15.4V6.1l1.71 4.04 4.38.38-3.32 2.88 1 4.28L12 15.4z' })
	  );
	};
	ToggleStarHalf = (0, _pure2.default)(ToggleStarHalf);
	ToggleStarHalf.displayName = 'ToggleStarHalf';
	ToggleStarHalf.muiName = 'SvgIcon';
	
	exports.default = ToggleStarHalf;

/***/ },
/* 1833 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _pure = __webpack_require__(3);
	
	var _pure2 = _interopRequireDefault(_pure);
	
	var _SvgIcon = __webpack_require__(2);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ToggleStar = function ToggleStar(props) {
	  return _react2.default.createElement(
	    _SvgIcon2.default,
	    props,
	    _react2.default.createElement('path', { d: 'M12 17.27L18.18 21l-1.64-7.03L22 9.24l-7.19-.61L12 2 9.19 8.63 2 9.24l5.46 4.73L5.82 21z' })
	  );
	};
	ToggleStar = (0, _pure2.default)(ToggleStar);
	ToggleStar.displayName = 'ToggleStar';
	ToggleStar.muiName = 'SvgIcon';
	
	exports.default = ToggleStar;

/***/ },
/* 1834 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (muiTheme) {
	  var isClient = typeof navigator !== 'undefined';
	  var userAgent = muiTheme.userAgent;
	
	  if (userAgent === undefined && isClient) {
	    userAgent = navigator.userAgent;
	  }
	
	  if (userAgent === undefined && !hasWarnedAboutUserAgent) {
	     false ? (0, _warning2.default)(false, 'Material-UI: userAgent should be supplied in the muiTheme context\n      for server-side rendering.') : void 0;
	
	    hasWarnedAboutUserAgent = true;
	  }
	
	  var prefixAll = (0, _createPrefixer2.default)(_autoprefixerStatic2.default);
	
	  if (userAgent === false) {
	    // Disabled autoprefixer
	    return null;
	  } else if (userAgent === 'all' || userAgent === undefined) {
	    // Prefix for all user agent
	    return function (style) {
	      var isFlex = ['flex', 'inline-flex'].indexOf(style.display) !== -1;
	      var stylePrefixed = prefixAll(style);
	
	      if (isFlex) {
	        var display = stylePrefixed.display;
	        if (isClient) {
	          // We can't apply this join with react-dom:
	          // #https://github.com/facebook/react/issues/6467
	          stylePrefixed.display = display[display.length - 1];
	        } else {
	          stylePrefixed.display = display.join('; display: ');
	        }
	      }
	
	      return stylePrefixed;
	    };
	  } else {
	    var Prefixer = (0, _createPrefixer4.default)(_autoprefixerDynamic2.default, prefixAll);
	    var prefixer = new Prefixer({
	      userAgent: userAgent
	    });
	
	    return function (style) {
	      return prefixer.prefix(style);
	    };
	  }
	};
	
	var _createPrefixer = __webpack_require__(601);
	
	var _createPrefixer2 = _interopRequireDefault(_createPrefixer);
	
	var _createPrefixer3 = __webpack_require__(593);
	
	var _createPrefixer4 = _interopRequireDefault(_createPrefixer3);
	
	var _autoprefixerDynamic = __webpack_require__(1835);
	
	var _autoprefixerDynamic2 = _interopRequireDefault(_autoprefixerDynamic);
	
	var _autoprefixerStatic = __webpack_require__(1836);
	
	var _autoprefixerStatic2 = _interopRequireDefault(_autoprefixerStatic);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var hasWarnedAboutUserAgent = false;

/***/ },
/* 1835 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(594);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(595);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(596);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(597);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(598);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(599);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(600);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "chrome": { "transform": 35, "transformOrigin": 35, "transformOriginX": 35, "transformOriginY": 35, "backfaceVisibility": 35, "perspective": 35, "perspectiveOrigin": 35, "transformStyle": 35, "transformOriginZ": 35, "animation": 42, "animationDelay": 42, "animationDirection": 42, "animationFillMode": 42, "animationDuration": 42, "animationIterationCount": 42, "animationName": 42, "animationPlayState": 42, "animationTimingFunction": 42, "appearance": 60, "userSelect": 53, "fontKerning": 32, "textEmphasisPosition": 60, "textEmphasis": 60, "textEmphasisStyle": 60, "textEmphasisColor": 60, "boxDecorationBreak": 60, "clipPath": 54, "maskImage": 60, "maskMode": 60, "maskRepeat": 60, "maskPosition": 60, "maskClip": 60, "maskOrigin": 60, "maskSize": 60, "maskComposite": 60, "mask": 60, "maskBorderSource": 60, "maskBorderMode": 60, "maskBorderSlice": 60, "maskBorderWidth": 60, "maskBorderOutset": 60, "maskBorderRepeat": 60, "maskBorder": 60, "maskType": 60, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56, "filter": 52, "fontFeatureSettings": 47, "breakAfter": 49, "breakBefore": 49, "breakInside": 49, "columnCount": 49, "columnFill": 49, "columnGap": 49, "columnRule": 49, "columnRuleColor": 49, "columnRuleStyle": 49, "columnRuleWidth": 49, "columns": 49, "columnSpan": 49, "columnWidth": 49 }, "safari": { "flex": 8, "flexBasis": 8, "flexDirection": 8, "flexGrow": 8, "flexFlow": 8, "flexShrink": 8, "flexWrap": 8, "alignContent": 8, "alignItems": 8, "alignSelf": 8, "justifyContent": 8, "order": 8, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8, "transformOrigin": 8, "transformOriginX": 8, "transformOriginY": 8, "backfaceVisibility": 8, "perspective": 8, "perspectiveOrigin": 8, "transformStyle": 8, "transformOriginZ": 8, "animation": 8, "animationDelay": 8, "animationDirection": 8, "animationFillMode": 8, "animationDuration": 8, "animationIterationCount": 8, "animationName": 8, "animationPlayState": 8, "animationTimingFunction": 8, "appearance": 10.1, "userSelect": 10.1, "backdropFilter": 10.1, "fontKerning": 9, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "textEmphasisPosition": 7, "textEmphasis": 7, "textEmphasisStyle": 7, "textEmphasisColor": 7, "boxDecorationBreak": 10.1, "clipPath": 10.1, "maskImage": 10.1, "maskMode": 10.1, "maskRepeat": 10.1, "maskPosition": 10.1, "maskClip": 10.1, "maskOrigin": 10.1, "maskSize": 10.1, "maskComposite": 10.1, "mask": 10.1, "maskBorderSource": 10.1, "maskBorderMode": 10.1, "maskBorderSlice": 10.1, "maskBorderWidth": 10.1, "maskBorderOutset": 10.1, "maskBorderRepeat": 10.1, "maskBorder": 10.1, "maskType": 10.1, "textDecorationStyle": 10.1, "textDecorationSkip": 10.1, "textDecorationLine": 10.1, "textDecorationColor": 10.1, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10.1, "flowInto": 10.1, "flowFrom": 10.1, "breakBefore": 8, "breakAfter": 8, "breakInside": 8, "regionFragment": 10.1, "columnCount": 8, "columnFill": 8, "columnGap": 8, "columnRule": 8, "columnRuleColor": 8, "columnRuleStyle": 8, "columnRuleWidth": 8, "columns": 8, "columnSpan": 8, "columnWidth": 8 }, "firefox": { "appearance": 55, "userSelect": 55, "boxSizing": 28, "textAlignLast": 48, "textDecorationStyle": 35, "textDecorationSkip": 35, "textDecorationLine": 35, "textDecorationColor": 35, "tabSize": 55, "hyphens": 42, "fontFeatureSettings": 33, "breakAfter": 51, "breakBefore": 51, "breakInside": 51, "columnCount": 51, "columnFill": 51, "columnGap": 51, "columnRule": 51, "columnRuleColor": 51, "columnRuleStyle": 51, "columnRuleWidth": 51, "columns": 51, "columnSpan": 51, "columnWidth": 51 }, "opera": { "flex": 16, "flexBasis": 16, "flexDirection": 16, "flexGrow": 16, "flexFlow": 16, "flexShrink": 16, "flexWrap": 16, "alignContent": 16, "alignItems": 16, "alignSelf": 16, "justifyContent": 16, "order": 16, "transform": 22, "transformOrigin": 22, "transformOriginX": 22, "transformOriginY": 22, "backfaceVisibility": 22, "perspective": 22, "perspectiveOrigin": 22, "transformStyle": 22, "transformOriginZ": 22, "animation": 29, "animationDelay": 29, "animationDirection": 29, "animationFillMode": 29, "animationDuration": 29, "animationIterationCount": 29, "animationName": 29, "animationPlayState": 29, "animationTimingFunction": 29, "appearance": 45, "userSelect": 40, "fontKerning": 19, "textEmphasisPosition": 45, "textEmphasis": 45, "textEmphasisStyle": 45, "textEmphasisColor": 45, "boxDecorationBreak": 45, "clipPath": 41, "maskImage": 45, "maskMode": 45, "maskRepeat": 45, "maskPosition": 45, "maskClip": 45, "maskOrigin": 45, "maskSize": 45, "maskComposite": 45, "mask": 45, "maskBorderSource": 45, "maskBorderMode": 45, "maskBorderSlice": 45, "maskBorderWidth": 45, "maskBorderOutset": 45, "maskBorderRepeat": 45, "maskBorder": 45, "maskType": 45, "textDecorationStyle": 43, "textDecorationSkip": 43, "textDecorationLine": 43, "textDecorationColor": 43, "filter": 39, "fontFeatureSettings": 34, "breakAfter": 36, "breakBefore": 36, "breakInside": 36, "columnCount": 36, "columnFill": 36, "columnGap": 36, "columnRule": 36, "columnRuleColor": 36, "columnRuleStyle": 36, "columnRuleWidth": 36, "columns": 36, "columnSpan": 36, "columnWidth": 36 }, "ie": { "flex": 10, "flexDirection": 10, "flexFlow": 10, "flexWrap": 10, "transform": 9, "transformOrigin": 9, "transformOriginX": 9, "transformOriginY": 9, "userSelect": 11, "wrapFlow": 11, "wrapThrough": 11, "wrapMargin": 11, "scrollSnapType": 11, "scrollSnapPointsX": 11, "scrollSnapPointsY": 11, "scrollSnapDestination": 11, "scrollSnapCoordinate": 11, "touchAction": 10, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "gridTemplateColumns": 11, "gridTemplateRows": 11, "gridTemplateAreas": 11, "gridTemplate": 11, "gridAutoColumns": 11, "gridAutoRows": 11, "gridAutoFlow": 11, "grid": 11, "gridRowStart": 11, "gridColumnStart": 11, "gridRowEnd": 11, "gridRow": 11, "gridColumn": 11, "gridColumnEnd": 11, "gridColumnGap": 11, "gridRowGap": 11, "gridArea": 11, "gridGap": 11, "textSizeAdjust": 11 }, "edge": { "userSelect": 15, "wrapFlow": 15, "wrapThrough": 15, "wrapMargin": 15, "scrollSnapType": 15, "scrollSnapPointsX": 15, "scrollSnapPointsY": 15, "scrollSnapDestination": 15, "scrollSnapCoordinate": 15, "hyphens": 15, "flowInto": 15, "flowFrom": 15, "breakBefore": 15, "breakAfter": 15, "breakInside": 15, "regionFragment": 15, "gridTemplateColumns": 15, "gridTemplateRows": 15, "gridTemplateAreas": 15, "gridTemplate": 15, "gridAutoColumns": 15, "gridAutoRows": 15, "gridAutoFlow": 15, "grid": 15, "gridRowStart": 15, "gridColumnStart": 15, "gridRowEnd": 15, "gridRow": 15, "gridColumn": 15, "gridColumnEnd": 15, "gridColumnGap": 15, "gridRowGap": 15, "gridArea": 15, "gridGap": 15 }, "ios_saf": { "flex": 8.1, "flexBasis": 8.1, "flexDirection": 8.1, "flexGrow": 8.1, "flexFlow": 8.1, "flexShrink": 8.1, "flexWrap": 8.1, "alignContent": 8.1, "alignItems": 8.1, "alignSelf": 8.1, "justifyContent": 8.1, "order": 8.1, "transition": 6, "transitionDelay": 6, "transitionDuration": 6, "transitionProperty": 6, "transitionTimingFunction": 6, "transform": 8.1, "transformOrigin": 8.1, "transformOriginX": 8.1, "transformOriginY": 8.1, "backfaceVisibility": 8.1, "perspective": 8.1, "perspectiveOrigin": 8.1, "transformStyle": 8.1, "transformOriginZ": 8.1, "animation": 8.1, "animationDelay": 8.1, "animationDirection": 8.1, "animationFillMode": 8.1, "animationDuration": 8.1, "animationIterationCount": 8.1, "animationName": 8.1, "animationPlayState": 8.1, "animationTimingFunction": 8.1, "appearance": 10, "userSelect": 10, "backdropFilter": 10, "fontKerning": 10, "scrollSnapType": 10, "scrollSnapPointsX": 10, "scrollSnapPointsY": 10, "scrollSnapDestination": 10, "scrollSnapCoordinate": 10, "boxDecorationBreak": 10, "clipPath": 10, "maskImage": 10, "maskMode": 10, "maskRepeat": 10, "maskPosition": 10, "maskClip": 10, "maskOrigin": 10, "maskSize": 10, "maskComposite": 10, "mask": 10, "maskBorderSource": 10, "maskBorderMode": 10, "maskBorderSlice": 10, "maskBorderWidth": 10, "maskBorderOutset": 10, "maskBorderRepeat": 10, "maskBorder": 10, "maskType": 10, "textSizeAdjust": 10, "textDecorationStyle": 10, "textDecorationSkip": 10, "textDecorationLine": 10, "textDecorationColor": 10, "shapeImageThreshold": 10, "shapeImageMargin": 10, "shapeImageOutside": 10, "filter": 9, "hyphens": 10, "flowInto": 10, "flowFrom": 10, "breakBefore": 8.1, "breakAfter": 8.1, "breakInside": 8.1, "regionFragment": 10, "columnCount": 8.1, "columnFill": 8.1, "columnGap": 8.1, "columnRule": 8.1, "columnRuleColor": 8.1, "columnRuleStyle": 8.1, "columnRuleWidth": 8.1, "columns": 8.1, "columnSpan": 8.1, "columnWidth": 8.1 }, "android": { "borderImage": 4.2, "borderImageOutset": 4.2, "borderImageRepeat": 4.2, "borderImageSlice": 4.2, "borderImageSource": 4.2, "borderImageWidth": 4.2, "flex": 4.2, "flexBasis": 4.2, "flexDirection": 4.2, "flexGrow": 4.2, "flexFlow": 4.2, "flexShrink": 4.2, "flexWrap": 4.2, "alignContent": 4.2, "alignItems": 4.2, "alignSelf": 4.2, "justifyContent": 4.2, "order": 4.2, "transition": 4.2, "transitionDelay": 4.2, "transitionDuration": 4.2, "transitionProperty": 4.2, "transitionTimingFunction": 4.2, "transform": 4.4, "transformOrigin": 4.4, "transformOriginX": 4.4, "transformOriginY": 4.4, "backfaceVisibility": 4.4, "perspective": 4.4, "perspectiveOrigin": 4.4, "transformStyle": 4.4, "transformOriginZ": 4.4, "animation": 4.4, "animationDelay": 4.4, "animationDirection": 4.4, "animationFillMode": 4.4, "animationDuration": 4.4, "animationIterationCount": 4.4, "animationName": 4.4, "animationPlayState": 4.4, "animationTimingFunction": 4.4, "appearance": 53, "userSelect": 53, "fontKerning": 4.4, "textEmphasisPosition": 53, "textEmphasis": 53, "textEmphasisStyle": 53, "textEmphasisColor": 53, "boxDecorationBreak": 53, "clipPath": 53, "maskImage": 53, "maskMode": 53, "maskRepeat": 53, "maskPosition": 53, "maskClip": 53, "maskOrigin": 53, "maskSize": 53, "maskComposite": 53, "mask": 53, "maskBorderSource": 53, "maskBorderMode": 53, "maskBorderSlice": 53, "maskBorderWidth": 53, "maskBorderOutset": 53, "maskBorderRepeat": 53, "maskBorder": 53, "maskType": 53, "filter": 4.4, "fontFeatureSettings": 4.4, "breakAfter": 53, "breakBefore": 53, "breakInside": 53, "columnCount": 53, "columnFill": 53, "columnGap": 53, "columnRule": 53, "columnRuleColor": 53, "columnRuleStyle": 53, "columnRuleWidth": 53, "columns": 53, "columnSpan": 53, "columnWidth": 53 }, "and_chr": { "appearance": 56, "textEmphasisPosition": 56, "textEmphasis": 56, "textEmphasisStyle": 56, "textEmphasisColor": 56, "boxDecorationBreak": 56, "maskImage": 56, "maskMode": 56, "maskRepeat": 56, "maskPosition": 56, "maskClip": 56, "maskOrigin": 56, "maskSize": 56, "maskComposite": 56, "mask": 56, "maskBorderSource": 56, "maskBorderMode": 56, "maskBorderSlice": 56, "maskBorderWidth": 56, "maskBorderOutset": 56, "maskBorderRepeat": 56, "maskBorder": 56, "maskType": 56, "textDecorationStyle": 56, "textDecorationSkip": 56, "textDecorationLine": 56, "textDecorationColor": 56 }, "and_uc": { "flex": 11, "flexBasis": 11, "flexDirection": 11, "flexGrow": 11, "flexFlow": 11, "flexShrink": 11, "flexWrap": 11, "alignContent": 11, "alignItems": 11, "alignSelf": 11, "justifyContent": 11, "order": 11, "transition": 11, "transitionDelay": 11, "transitionDuration": 11, "transitionProperty": 11, "transitionTimingFunction": 11, "transform": 11, "transformOrigin": 11, "transformOriginX": 11, "transformOriginY": 11, "backfaceVisibility": 11, "perspective": 11, "perspectiveOrigin": 11, "transformStyle": 11, "transformOriginZ": 11, "animation": 11, "animationDelay": 11, "animationDirection": 11, "animationFillMode": 11, "animationDuration": 11, "animationIterationCount": 11, "animationName": 11, "animationPlayState": 11, "animationTimingFunction": 11, "appearance": 11, "userSelect": 11, "fontKerning": 11, "textEmphasisPosition": 11, "textEmphasis": 11, "textEmphasisStyle": 11, "textEmphasisColor": 11, "maskImage": 11, "maskMode": 11, "maskRepeat": 11, "maskPosition": 11, "maskClip": 11, "maskOrigin": 11, "maskSize": 11, "maskComposite": 11, "mask": 11, "maskBorderSource": 11, "maskBorderMode": 11, "maskBorderSlice": 11, "maskBorderWidth": 11, "maskBorderOutset": 11, "maskBorderRepeat": 11, "maskBorder": 11, "maskType": 11, "textSizeAdjust": 11, "filter": 11, "hyphens": 11, "flowInto": 11, "flowFrom": 11, "breakBefore": 11, "breakAfter": 11, "breakInside": 11, "regionFragment": 11, "fontFeatureSettings": 11, "columnCount": 11, "columnFill": 11, "columnGap": 11, "columnRule": 11, "columnRuleColor": 11, "columnRuleStyle": 11, "columnRuleWidth": 11, "columns": 11, "columnSpan": 11, "columnWidth": 11 }, "op_mini": {} }
	}; /* eslint-disable */

/***/ },
/* 1836 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _calc = __webpack_require__(602);
	
	var _calc2 = _interopRequireDefault(_calc);
	
	var _flex = __webpack_require__(603);
	
	var _flex2 = _interopRequireDefault(_flex);
	
	var _flexboxIE = __webpack_require__(604);
	
	var _flexboxIE2 = _interopRequireDefault(_flexboxIE);
	
	var _flexboxOld = __webpack_require__(605);
	
	var _flexboxOld2 = _interopRequireDefault(_flexboxOld);
	
	var _gradient = __webpack_require__(606);
	
	var _gradient2 = _interopRequireDefault(_gradient);
	
	var _sizing = __webpack_require__(607);
	
	var _sizing2 = _interopRequireDefault(_sizing);
	
	var _transition = __webpack_require__(608);
	
	var _transition2 = _interopRequireDefault(_transition);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  plugins: [_calc2.default, _flex2.default, _flexboxIE2.default, _flexboxOld2.default, _gradient2.default, _sizing2.default, _transition2.default],
	  prefixMap: { "transform": ["Webkit", "ms"], "transformOrigin": ["Webkit", "ms"], "transformOriginX": ["Webkit", "ms"], "transformOriginY": ["Webkit", "ms"], "backfaceVisibility": ["Webkit"], "perspective": ["Webkit"], "perspectiveOrigin": ["Webkit"], "transformStyle": ["Webkit"], "transformOriginZ": ["Webkit"], "animation": ["Webkit"], "animationDelay": ["Webkit"], "animationDirection": ["Webkit"], "animationFillMode": ["Webkit"], "animationDuration": ["Webkit"], "animationIterationCount": ["Webkit"], "animationName": ["Webkit"], "animationPlayState": ["Webkit"], "animationTimingFunction": ["Webkit"], "appearance": ["Webkit", "Moz"], "userSelect": ["Webkit", "Moz", "ms"], "fontKerning": ["Webkit"], "textEmphasisPosition": ["Webkit"], "textEmphasis": ["Webkit"], "textEmphasisStyle": ["Webkit"], "textEmphasisColor": ["Webkit"], "boxDecorationBreak": ["Webkit"], "clipPath": ["Webkit"], "maskImage": ["Webkit"], "maskMode": ["Webkit"], "maskRepeat": ["Webkit"], "maskPosition": ["Webkit"], "maskClip": ["Webkit"], "maskOrigin": ["Webkit"], "maskSize": ["Webkit"], "maskComposite": ["Webkit"], "mask": ["Webkit"], "maskBorderSource": ["Webkit"], "maskBorderMode": ["Webkit"], "maskBorderSlice": ["Webkit"], "maskBorderWidth": ["Webkit"], "maskBorderOutset": ["Webkit"], "maskBorderRepeat": ["Webkit"], "maskBorder": ["Webkit"], "maskType": ["Webkit"], "textDecorationStyle": ["Webkit", "Moz"], "textDecorationSkip": ["Webkit", "Moz"], "textDecorationLine": ["Webkit", "Moz"], "textDecorationColor": ["Webkit", "Moz"], "filter": ["Webkit"], "fontFeatureSettings": ["Webkit", "Moz"], "breakAfter": ["Webkit", "Moz", "ms"], "breakBefore": ["Webkit", "Moz", "ms"], "breakInside": ["Webkit", "Moz", "ms"], "columnCount": ["Webkit", "Moz"], "columnFill": ["Webkit", "Moz"], "columnGap": ["Webkit", "Moz"], "columnRule": ["Webkit", "Moz"], "columnRuleColor": ["Webkit", "Moz"], "columnRuleStyle": ["Webkit", "Moz"], "columnRuleWidth": ["Webkit", "Moz"], "columns": ["Webkit", "Moz"], "columnSpan": ["Webkit", "Moz"], "columnWidth": ["Webkit", "Moz"], "flex": ["Webkit", "ms"], "flexBasis": ["Webkit"], "flexDirection": ["Webkit", "ms"], "flexGrow": ["Webkit"], "flexFlow": ["Webkit", "ms"], "flexShrink": ["Webkit"], "flexWrap": ["Webkit", "ms"], "alignContent": ["Webkit"], "alignItems": ["Webkit"], "alignSelf": ["Webkit"], "justifyContent": ["Webkit"], "order": ["Webkit"], "transitionDelay": ["Webkit"], "transitionDuration": ["Webkit"], "transitionProperty": ["Webkit"], "transitionTimingFunction": ["Webkit"], "backdropFilter": ["Webkit"], "scrollSnapType": ["Webkit", "ms"], "scrollSnapPointsX": ["Webkit", "ms"], "scrollSnapPointsY": ["Webkit", "ms"], "scrollSnapDestination": ["Webkit", "ms"], "scrollSnapCoordinate": ["Webkit", "ms"], "shapeImageThreshold": ["Webkit"], "shapeImageMargin": ["Webkit"], "shapeImageOutside": ["Webkit"], "hyphens": ["Webkit", "Moz", "ms"], "flowInto": ["Webkit", "ms"], "flowFrom": ["Webkit", "ms"], "regionFragment": ["Webkit", "ms"], "boxSizing": ["Moz"], "textAlignLast": ["Moz"], "tabSize": ["Moz"], "wrapFlow": ["ms"], "wrapThrough": ["ms"], "wrapMargin": ["ms"], "touchAction": ["ms"], "gridTemplateColumns": ["ms"], "gridTemplateRows": ["ms"], "gridTemplateAreas": ["ms"], "gridTemplate": ["ms"], "gridAutoColumns": ["ms"], "gridAutoRows": ["ms"], "gridAutoFlow": ["ms"], "grid": ["ms"], "gridRowStart": ["ms"], "gridColumnStart": ["ms"], "gridRowEnd": ["ms"], "gridRow": ["ms"], "gridColumn": ["ms"], "gridColumnEnd": ["ms"], "gridColumnGap": ["ms"], "gridRowGap": ["ms"], "gridArea": ["ms"], "gridGap": ["ms"], "textSizeAdjust": ["Webkit", "ms"], "borderImage": ["Webkit"], "borderImageOutset": ["Webkit"], "borderImageRepeat": ["Webkit"], "borderImageSlice": ["Webkit"], "borderImageSource": ["Webkit"], "borderImageWidth": ["Webkit"] }
	}; /* eslint-disable */

/***/ },
/* 1837 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = callOnce;
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CALLED_ONCE = 'muiPrepared';
	
	function callOnce() {
	  if (false) {
	    return function (style) {
	      if (style[CALLED_ONCE]) {
	        process.env.NODE_ENV !== "production" ? (0, _warning2.default)(false, 'Material-UI: You cannot call prepareStyles() on the same style object more than once.') : void 0;
	      }
	      style[CALLED_ONCE] = true;
	      return style;
	    };
	  }
	}

/***/ },
/* 1838 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecated;
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var warned = {}; /**
	                  * This module is taken from https://github.com/react-bootstrap/react-prop-types.
	                  * It's not a dependency to reduce build size / install time.
	                  * It should be pretty stable.
	                  */
	function deprecated(validator, reason) {
	  return function validate(props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (props[propName] != null) {
	      var messageKey = componentName + '.' + propName;
	
	       false ? (0, _warning2.default)(warned[messageKey], 'The ' + location + ' `' + propFullNameSafe + '` of ' + ('`' + componentNameSafe + '` is deprecated. ' + reason)) : void 0;
	
	      warned[messageKey] = true;
	    }
	
	    for (var _len = arguments.length, args = Array(_len > 5 ? _len - 5 : 0), _key = 5; _key < _len; _key++) {
	      args[_key - 5] = arguments[_key];
	    }
	
	    return validator.apply(undefined, [props, propName, componentName, location, propFullName].concat(args));
	  };
	}

/***/ },
/* 1839 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	/**
	* Returns a number of pixels from the top of the screen for given dom element.
	*
	* @param {object} dom element
	* @returns {number} A position from the top of the screen in pixels
	*/
	var getOffsetTop = exports.getOffsetTop = function getOffsetTop(elem) {
	  var yPos = elem.offsetTop;
	  var tempEl = elem.offsetParent;
	
	  while (tempEl != null) {
	    yPos += tempEl.offsetTop;
	    tempEl = tempEl.offsetParent;
	  }
	
	  return yPos;
	};
	
	var isIOS = exports.isIOS = function isIOS() {
	  return (/iPad|iPhone|iPod/.test(window.navigator.userAgent) && !window.MSStream
	  );
	};

/***/ },
/* 1840 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(163);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	exports.default = rtl;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var reTranslate = /((^|\s)translate(3d|X)?\()(\-?[\d]+)/;
	var reSkew = /((^|\s)skew(x|y)?\()\s*(\-?[\d]+)(deg|rad|grad)(,\s*(\-?[\d]+)(deg|rad|grad))?/;
	
	/**
	 * This function ensures that `style` supports both ltr and rtl directions by
	 * checking `styleConstants` in `muiTheme` and replacing attribute keys if
	 * necessary.
	 */
	function rtl(muiTheme) {
	  if (muiTheme.isRtl) {
	    return function (style) {
	      if (style.directionInvariant === true) {
	        return style;
	      }
	
	      var flippedAttributes = {
	        // Keys and their replacements.
	        right: 'left',
	        left: 'right',
	        marginRight: 'marginLeft',
	        marginLeft: 'marginRight',
	        paddingRight: 'paddingLeft',
	        paddingLeft: 'paddingRight',
	        borderRight: 'borderLeft',
	        borderLeft: 'borderRight'
	      };
	
	      var newStyle = {};
	
	      (0, _keys2.default)(style).forEach(function (attribute) {
	        var value = style[attribute];
	        var key = attribute;
	
	        if (flippedAttributes.hasOwnProperty(attribute)) {
	          key = flippedAttributes[attribute];
	        }
	
	        switch (attribute) {
	          case 'float':
	          case 'textAlign':
	            if (value === 'right') {
	              value = 'left';
	            } else if (value === 'left') {
	              value = 'right';
	            }
	            break;
	
	          case 'direction':
	            if (value === 'ltr') {
	              value = 'rtl';
	            } else if (value === 'rtl') {
	              value = 'ltr';
	            }
	            break;
	
	          case 'transform':
	            if (!value) break;
	            var matches = void 0;
	            if (matches = value.match(reTranslate)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]));
	            }
	            if (matches = value.match(reSkew)) {
	              value = value.replace(matches[0], matches[1] + -parseFloat(matches[4]) + matches[5] + matches[6] ? ', ' + (-parseFloat(matches[7]) + matches[8]) : '');
	            }
	            break;
	
	          case 'transformOrigin':
	            if (!value) break;
	            if (value.indexOf('right') > -1) {
	              value = value.replace('right', 'left');
	            } else if (value.indexOf('left') > -1) {
	              value = value.replace('left', 'right');
	            }
	            break;
	        }
	
	        newStyle[key] = value;
	      });
	
	      return newStyle;
	    };
	  }
	}

/***/ },
/* 1841 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.LARGE = exports.MEDIUM = exports.SMALL = undefined;
	
	var _extends2 = __webpack_require__(11);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _getPrototypeOf = __webpack_require__(7);
	
	var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);
	
	var _classCallCheck2 = __webpack_require__(5);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(6);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _possibleConstructorReturn2 = __webpack_require__(9);
	
	var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);
	
	var _inherits2 = __webpack_require__(8);
	
	var _inherits3 = _interopRequireDefault(_inherits2);
	
	exports.default = withWidth;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactEventListener = __webpack_require__(44);
	
	var _reactEventListener2 = _interopRequireDefault(_reactEventListener);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SMALL = exports.SMALL = 1;
	var MEDIUM = exports.MEDIUM = 2;
	var LARGE = exports.LARGE = 3;
	
	function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$largeWidth = options.largeWidth,
	      largeWidth = _options$largeWidth === undefined ? 992 : _options$largeWidth,
	      _options$mediumWidth = options.mediumWidth,
	      mediumWidth = _options$mediumWidth === undefined ? 768 : _options$mediumWidth,
	      _options$resizeInterv = options.resizeInterval,
	      resizeInterval = _options$resizeInterv === undefined ? 166 : _options$resizeInterv;
	
	
	  return function (MyComponent) {
	    return function (_Component) {
	      (0, _inherits3.default)(WithWidth, _Component);
	
	      function WithWidth() {
	        var _ref;
	
	        var _temp, _this, _ret;
	
	        (0, _classCallCheck3.default)(this, WithWidth);
	
	        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	          args[_key] = arguments[_key];
	        }
	
	        return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WithWidth.__proto__ || (0, _getPrototypeOf2.default)(WithWidth)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
	          width: null
	        }, _this.handleResize = function () {
	          clearTimeout(_this.deferTimer);
	          _this.deferTimer = setTimeout(function () {
	            _this.updateWidth();
	          }, resizeInterval);
	        }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
	      }
	
	      (0, _createClass3.default)(WithWidth, [{
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	          this.updateWidth();
	        }
	      }, {
	        key: 'componentWillUnmount',
	        value: function componentWillUnmount() {
	          clearTimeout(this.deferTimer);
	        }
	      }, {
	        key: 'updateWidth',
	        value: function updateWidth() {
	          var innerWidth = window.innerWidth;
	          var width = void 0;
	
	          if (innerWidth >= largeWidth) {
	            width = LARGE;
	          } else if (innerWidth >= mediumWidth) {
	            width = MEDIUM;
	          } else {
	            // innerWidth < 768
	            width = SMALL;
	          }
	
	          if (width !== this.state.width) {
	            this.setState({
	              width: width
	            });
	          }
	        }
	      }, {
	        key: 'render',
	        value: function render() {
	          var width = this.state.width;
	
	          /**
	           * When rendering the component on the server,
	           * we have no idea about the screen width.
	           * In order to prevent blinks and help the reconciliation
	           * we are not rendering the component.
	           *
	           * A better alternative would be to send client hints.
	           * But the browser support of this API is low:
	           * http://caniuse.com/#search=client%20hint
	           */
	          if (width === null) {
	            return null;
	          }
	
	          return _react2.default.createElement(
	            _reactEventListener2.default,
	            { target: 'window', onResize: this.handleResize },
	            _react2.default.createElement(MyComponent, (0, _extends3.default)({
	              width: width
	            }, this.props))
	          );
	        }
	      }]);
	      return WithWidth;
	    }(_react.Component);
	  };
	}

/***/ },
/* 1842 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = {
	    lex  : __webpack_require__(391),
	    parse: __webpack_require__(1843),
	    stringify: __webpack_require__(1844)
	};


/***/ },
/* 1843 */
/***/ function(module, exports, __webpack_require__) {

	var DEBUG = false; // `true` to print debugging info.
	var TIMER = false; // `true` to time calls to `parse()` and print the results.
	
	var debug = __webpack_require__(224)('parse');
	var lex = __webpack_require__(391);
	
	exports = module.exports = parse;
	
	var _comments;   // Whether comments are allowed.
	var _depth;      // Current block nesting depth.
	var _position;   // Whether to include line/column position.
	var _tokens;     // Array of lexical tokens.
	
	/**
	 * Convert a CSS string or array of lexical tokens into a `stringify`-able AST.
	 *
	 * @param {String} css CSS string or array of lexical token
	 * @param {Object} [options]
	 * @param {Boolean} [options.comments=false] allow comment nodes in the AST
	 * @returns {Object} `stringify`-able AST
	 */
	function parse(css, options) {
	  var start; // Debug timer start.
	
	  options || (options = {});
	  _comments = !!options.comments;
	  _position = !!options.position;
	
	  _depth = 0;
	
	  // Operate on a copy of the given tokens, or the lex()'d CSS string.
	  _tokens = Array.isArray(css) ? css.slice() : lex(css);
	
	  var rule;
	  var rules = [];
	  var token;
	
	  TIMER && (start = Date.now());
	
	  while ((token = next())) {
	    rule = parseToken(token);
	    rule && rules.push(rule);
	  }
	
	  TIMER && debug('ran in', (Date.now() - start) + 'ms');
	
	  return {
	    type: "stylesheet",
	    stylesheet: {
	      rules: rules
	    }
	  };
	}
	
	// -- Functions --------------------------------------------------------------
	
	/**
	 * Build an AST node from a lexical token.
	 *
	 * @param {Object} token lexical token
	 * @param {Object} [override] object hash of properties that override those
	 *   already in the token, or that will be added to the token.
	 * @returns {Object} AST node
	 */
	function astNode(token, override) {
	  override || (override = {});
	
	  var key;
	  var keys = ['type', 'name', 'value'];
	  var node = {};
	
	  // Avoiding [].forEach for performance reasons.
	  for (var i = 0; i < keys.length; ++i) {
	    key = keys[i];
	
	    if (token[key]) {
	      node[key] = override[key] || token[key];
	    }
	  }
	
	  keys = Object.keys(override);
	
	  for (i = 0; i < keys.length; ++i) {
	    key = keys[i];
	
	    if (!node[key]) {
	      node[key] = override[key];
	    }
	  }
	
	  if (_position) {
	    node.position = {
	      start: token.start,
	      end: token.end
	    };
	  }
	
	  DEBUG && debug('astNode:', JSON.stringify(node, null, 2));
	
	  return node;
	}
	
	/**
	 * Remove a lexical token from the stack and return the removed token.
	 *
	 * @returns {Object} lexical token
	 */
	function next() {
	  var token = _tokens.shift();
	  DEBUG && debug('next:', JSON.stringify(token, null, 2));
	  return token;
	}
	
	// -- Parse* Functions ---------------------------------------------------------
	
	/**
	 * Convert an @-group lexical token to an AST node.
	 *
	 * @param {Object} token @-group lexical token
	 * @returns {Object} @-group AST node
	 */
	function parseAtGroup(token) {
	  _depth = _depth + 1;
	
	  // As the @-group token is assembled, relevant token values are captured here
	  // temporarily. They will later be used as `tokenize()` overrides.
	  var overrides = {};
	
	  switch (token.type) {
	  case 'font-face':
	  case 'viewport' :
	    overrides.declarations = parseDeclarations();
	    break;
	
	  case 'page':
	    overrides.prefix = token.prefix;
	    overrides.declarations = parseDeclarations();
	    break;
	
	  default:
	    overrides.prefix = token.prefix;
	    overrides.rules = parseRules();
	  }
	
	  return astNode(token, overrides);
	}
	
	/**
	 * Convert an @import lexical token to an AST node.
	 *
	 * @param {Object} token @import lexical token
	 * @returns {Object} @import AST node
	 */
	function parseAtImport(token) {
	  return astNode(token);
	}
	
	/**
	 * Convert an @charset token to an AST node.
	 *
	 * @param {Object} token @charset lexical token
	 * @returns {Object} @charset node
	 */
	function parseCharset(token) {
	  return astNode(token);
	}
	
	/**
	 * Convert a comment token to an AST Node.
	 *
	 * @param {Object} token comment lexical token
	 * @returns {Object} comment node
	 */
	function parseComment(token) {
	  return astNode(token, {text: token.text});
	}
	
	function parseNamespace(token) {
	  return astNode(token);
	}
	
	/**
	 * Convert a property lexical token to a property AST node.
	 *
	 * @returns {Object} property node
	 */
	function parseProperty(token) {
	  return astNode(token);
	}
	
	/**
	 * Convert a selector lexical token to a selector AST node.
	 *
	 * @param {Object} token selector lexical token
	 * @returns {Object} selector node
	 */
	function parseSelector(token) {
	  function trim(str) {
	    return str.trim();
	  }
	
	  return astNode(token, {
	    type: 'rule',
	    selectors: token.text.split(',').map(trim),
	    declarations: parseDeclarations(token)
	  });
	}
	
	/**
	 * Convert a lexical token to an AST node.
	 *
	 * @returns {Object|undefined} AST node
	 */
	function parseToken(token) {
	  switch (token.type) {
	  // Cases are listed in roughly descending order of probability.
	  case 'property': return parseProperty(token);
	
	  case 'selector': return parseSelector(token);
	
	  case 'at-group-end': _depth = _depth - 1; return;
	
	  case 'media'     :
	  case 'keyframes' :return parseAtGroup(token);
	
	  case 'comment': if (_comments) { return parseComment(token); } break;
	
	  case 'charset': return parseCharset(token);
	  case 'import': return parseAtImport(token);
	
	  case 'namespace': return parseNamespace(token);
	
	  case 'font-face':
	  case 'supports' :
	  case 'viewport' :
	  case 'document' :
	  case 'page'     : return parseAtGroup(token);
	  }
	
	  DEBUG && debug('parseToken: unexpected token:', JSON.stringify(token));
	}
	
	// -- Parse Helper Functions ---------------------------------------------------
	
	/**
	 * Iteratively parses lexical tokens from the stack into AST nodes until a
	 * conditional function returns `false`, at which point iteration terminates
	 * and any AST nodes collected are returned.
	 *
	 * @param {Function} conditionFn
	 *   @param {Object} token the lexical token being parsed
	 *   @returns {Boolean} `true` if the token should be parsed, `false` otherwise
	 * @return {Array} AST nodes
	 */
	function parseTokensWhile(conditionFn) {
	  var node;
	  var nodes = [];
	  var token;
	
	  while ((token = next()) && (conditionFn && conditionFn(token))) {
	    node = parseToken(token);
	    node && nodes.push(node);
	  }
	
	  // Place an unused non-`end` lexical token back onto the stack.
	  if (token && token.type !== 'end') {
	    _tokens.unshift(token);
	  }
	
	  return nodes;
	}
	
	/**
	 * Convert a series of tokens into a sequence of declaration AST nodes.
	 *
	 * @returns {Array} declaration nodes
	 */
	function parseDeclarations() {
	  return parseTokensWhile(function (token) {
	    return (token.type === 'property' || token.type === 'comment');
	  });
	}
	
	/**
	 * Convert a series of tokens into a sequence of rule nodes.
	 *
	 * @returns {Array} rule nodes
	 */
	function parseRules() {
	  return parseTokensWhile(function () { return _depth; });
	}


/***/ },
/* 1844 */
/***/ function(module, exports, __webpack_require__) {

	var DEBUG = false; // `true` to print debugging info.
	var TIMER = false; // `true` to time calls to `stringify()` and print the results.
	
	var debug = __webpack_require__(224)('stringify');
	
	var _comments;      // Whether comments are allowed in the stringified CSS.
	var _compress;      // Whether the stringified CSS should be compressed.
	var _indentation;   // Indentation option value.
	var _n;             // Compression-aware newline character.
	var _s;             // Compression-aware space character.
	
	exports = module.exports = stringify;
	
	/**
	 * Convert a `stringify`-able AST into a CSS string.
	 *
	 * @param {Object} `stringify`-able AST
	 * @param {Object} [options]
	 * @param {Boolean} [options.comments=false] allow comments in the CSS
	 * @param {Boolean} [options.compress=false] compress whitespace
	 * @param {String} [options.indentation=''] indentation sequence
	 * @returns {String} CSS
	 */
	function stringify(ast, options) {
	  var start; // Debug timer start.
	
	  options || (options = {});
	  _indentation = options.indentation || '';
	  _compress = !!options.compress;
	  _comments = !!options.comments;
	
	  if (_compress) {
	    _n = _s = '';
	  } else {
	    _n = '\n';
	    _s = ' ';
	  }
	
	  TIMER && (start = Date.now());
	
	  var css = reduce(ast.stylesheet.rules, stringifyNode).join('\n').trim();
	
	  TIMER && debug('ran in', (Date.now() - start) + 'ms');
	
	  return css;
	}
	
	// -- Functions --------------------------------------------------------------
	
	/**
	 * Modify the indentation level, or return a compression-aware sequence of
	 * spaces equal to the current indentation level.
	 *
	 * @param {Number} [level=undefined] indentation level modifier
	 * @returns {String} sequence of spaces
	 */
	function indent(level) {
	  this.level || (this.level = 1);
	
	  if (level) {
	    this.level += level;
	    return;
	  }
	
	  if (_compress) { return ''; }
	
	  return Array(this.level).join(_indentation || '');
	}
	
	// -- Stringify Functions ------------------------------------------------------
	
	/**
	 * Stringify an @-rule AST node.
	 *
	 * Use `stringifyAtGroup()` when dealing with @-groups that may contain blocks
	 * such as @media.
	 *
	 * @param {String} type @-rule type. E.g., import, charset
	 * @returns {String} Stringified @-rule
	 */
	function stringifyAtRule(node) {
	  return '@' + node.type + ' ' + node.value + ';' + _n;
	}
	
	/**
	 * Stringify an @-group AST node.
	 *
	 * Use `stringifyAtRule()` when dealing with @-rules that may not contain blocks
	 * such as @import.
	 *
	 * @param {Object} node @-group AST node
	 * @returns {String}
	 */
	function stringifyAtGroup(node) {
	  var label = '';
	  var prefix = node.prefix || '';
	
	  if (node.name) {
	    label = ' ' + node.name;
	  }
	
	  // FIXME: @-rule conditional logic is leaking everywhere.
	  var chomp = node.type !== 'page';
	
	  return '@' + prefix + node.type + label + _s + stringifyBlock(node, chomp) + _n;
	}
	
	/**
	 * Stringify a comment AST node.
	 *
	 * @param {Object} node comment AST node
	 * @returns {String}
	 */
	function stringifyComment(node) {
	  if (!_comments) { return ''; }
	
	  return '/*' + (node.text || '') + '*/' + _n;
	}
	
	/**
	 * Stringify a rule AST node.
	 *
	 * @param {Object} node rule AST node
	 * @returns {String}
	 */
	function stringifyRule(node) {
	  var label;
	
	  if (node.selectors) {
	    label = node.selectors.join(',' + _n);
	  } else {
	    label = '@' + node.type;
	    label += node.name ? ' ' + node.name : '';
	  }
	
	  return indent() + label + _s + stringifyBlock(node) + _n;
	}
	
	
	// -- Stringify Helper Functions -----------------------------------------------
	
	/**
	 * Reduce an array by applying a function to each item and retaining the truthy
	 * results.
	 *
	 * When `item.type` is `'comment'` `stringifyComment` will be applied instead.
	 *
	 * @param {Array} items array to reduce
	 * @param {Function} fn function to call for each item in the array
	 *   @returns {Mixed} Truthy values will be retained, falsy values omitted
	 * @returns {Array} retained results
	 */
	function reduce(items, fn) {
	  return items.reduce(function (results, item) {
	    var result = (item.type === 'comment') ? stringifyComment(item) : fn(item);
	    result && results.push(result);
	    return results;
	  }, []);
	}
	
	/**
	 * Stringify an AST node with the assumption that it represents a block of
	 * declarations or other @-group contents.
	 *
	 * @param {Object} node AST node
	 * @returns {String}
	 */
	// FIXME: chomp should not be a magic boolean parameter
	function stringifyBlock(node, chomp) {
	  var children = node.declarations;
	  var fn = stringifyDeclaration;
	
	  if (node.rules) {
	    children = node.rules;
	    fn = stringifyRule;
	  }
	
	  children = stringifyChildren(children, fn);
	  children && (children = _n + children + (chomp ? '' : _n));
	
	  return '{' + children + indent() + '}';
	}
	
	/**
	 * Stringify an array of child AST nodes by calling the given stringify function
	 * once for each child, and concatenating the results.
	 *
	 * @param {Array} children `node.rules` or `node.declarations`
	 * @param {Function} fn stringify function
	 * @returns {String}
	 */
	function stringifyChildren(children, fn) {
	  if (!children) { return ''; }
	
	  indent(1);
	  var results = reduce(children, fn);
	  indent(-1);
	
	  if (!results.length) { return ''; }
	
	  return results.join(_n);
	}
	
	/**
	 * Stringify a declaration AST node.
	 *
	 * @param {Object} node declaration AST node
	 * @returns {String}
	 */
	function stringifyDeclaration(node) {
	  if (node.type === 'property') {
	    return stringifyProperty(node);
	  }
	
	  DEBUG && debug('stringifyDeclaration: unexpected node:', JSON.stringify(node));
	}
	
	/**
	 * Stringify an AST node.
	 *
	 * @param {Object} node AST node
	 * @returns {String}
	 */
	function stringifyNode(node) {
	  switch (node.type) {
	  // Cases are listed in roughly descending order of probability.
	  case 'rule': return stringifyRule(node);
	
	  case 'media'    :
	  case 'keyframes': return stringifyAtGroup(node);
	
	  case 'comment': return stringifyComment(node);
	
	  case 'import'   :
	  case 'charset'  :
	  case 'namespace': return stringifyAtRule(node);
	
	  case 'font-face':
	  case 'supports' :
	  case 'viewport' :
	  case 'document' :
	  case 'page'     : return stringifyAtGroup(node);
	  }
	
	  DEBUG && debug('stringifyNode: unexpected node: ' + JSON.stringify(node));
	}
	
	/**
	 * Stringify an AST property node.
	 *
	 * @param {Object} node AST property node
	 * @returns {String}
	 */
	function stringifyProperty(node) {
	  var name = node.name ? node.name + ':' + _s : '';
	
	  return indent() + name + node.value + ';';
	}


/***/ },
/* 1845 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = compile;
	
	var BaseFuncs = __webpack_require__(98),
	    trueFunc  = BaseFuncs.trueFunc,
	    falseFunc = BaseFuncs.falseFunc;
	
	/*
		returns a function that checks if an elements index matches the given rule
		highly optimized to return the fastest solution
	*/
	function compile(parsed){
		var a = parsed[0],
		    b = parsed[1] - 1;
	
		//when b <= 0, a*n won't be possible for any matches when a < 0
		//besides, the specification says that no element is matched when a and b are 0
		if(b < 0 && a <= 0) return falseFunc;
	
		//when a is in the range -1..1, it matches any element (so only b is checked)
		if(a ===-1) return function(pos){ return pos <= b; };
		if(a === 0) return function(pos){ return pos === b; };
		//when b <= 0 and a === 1, they match any element
		if(a === 1) return b < 0 ? trueFunc : function(pos){ return pos >= b; };
	
		//when a > 0, modulo can be used to check if there is a match
		var bMod = b % a;
		if(bMod < 0) bMod += a;
	
		if(a > 1){
			return function(pos){
				return pos >= b && pos % a === bMod;
			};
		}
	
		a *= -1; //make `a` positive
	
		return function(pos){
			return pos <= b && pos % a === bMod;
		};
	}

/***/ },
/* 1846 */
/***/ function(module, exports, __webpack_require__) {

	var parse = __webpack_require__(1847),
	    compile = __webpack_require__(1845);
	
	module.exports = function nthCheck(formula){
		return compile(parse(formula));
	};
	
	module.exports.parse = parse;
	module.exports.compile = compile;

/***/ },
/* 1847 */
/***/ function(module, exports) {

	module.exports = parse;
	
	//following http://www.w3.org/TR/css3-selectors/#nth-child-pseudo
	
	//[ ['-'|'+']? INTEGER? {N} [ S* ['-'|'+'] S* INTEGER ]?
	var re_nthElement = /^([+\-]?\d*n)?\s*(?:([+\-]?)\s*(\d+))?$/;
	
	/*
		parses a nth-check formula, returns an array of two numbers
	*/
	function parse(formula){
		formula = formula.trim().toLowerCase();
	
		if(formula === "even"){
			return [2, 0];
		} else if(formula === "odd"){
			return [2, 1];
		} else {
			var parsed = formula.match(re_nthElement);
	
			if(!parsed){
				throw new SyntaxError("n-th rule couldn't be parsed ('" + formula + "')");
			}
	
			var a;
	
			if(parsed[1]){
				a = parseInt(parsed[1], 10);
				if(isNaN(a)){
					if(parsed[1].charAt(0) === "-") a = -1;
					else a = 1;
				}
			} else a = 0;
	
			return [
				a,
				parsed[3] ? parseInt((parsed[2] || "") + parsed[3], 10) : 0
			];
		}
	}


/***/ },
/* 1848 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	if (false) {
	  var invariant = require('fbjs/lib/invariant');
	  var warning = require('fbjs/lib/warning');
	  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
	  var loggedTypeFailures = {};
	}
	
	/**
	 * Assert that the values match with the type specs.
	 * Error messages are memorized and will only be shown once.
	 *
	 * @param {object} typeSpecs Map of name to a ReactPropType
	 * @param {object} values Runtime values that need to be type-checked
	 * @param {string} location e.g. "prop", "context", "child context"
	 * @param {string} componentName Name of the component for error messages.
	 * @param {?Function} getStack Returns the component stack.
	 * @private
	 */
	function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
	  if (false) {
	    for (var typeSpecName in typeSpecs) {
	      if (typeSpecs.hasOwnProperty(typeSpecName)) {
	        var error;
	        // Prop type validation may throw. In case they do, we don't want to
	        // fail the render phase where it didn't fail before. So we log it.
	        // After these have been cleaned up, we'll let them throw.
	        try {
	          // This is intentionally an invariant that gets caught. It's the same
	          // behavior as without this statement except with a better message.
	          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
	          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
	        } catch (ex) {
	          error = ex;
	        }
	        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
	        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
	          // Only monitor this failure once because there tends to be a lot of the
	          // same error.
	          loggedTypeFailures[error.message] = true;
	
	          var stack = getStack ? getStack() : '';
	
	          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
	        }
	      }
	    }
	  }
	}
	
	module.exports = checkPropTypes;


/***/ },
/* 1849 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(24);
	var invariant = __webpack_require__(13);
	var ReactPropTypesSecret = __webpack_require__(393);
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    invariant(
	      false,
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim
	  };
	
	  ReactPropTypes.checkPropTypes = emptyFunction;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1850 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var emptyFunction = __webpack_require__(24);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(16);
	var assign = __webpack_require__(18);
	
	var ReactPropTypesSecret = __webpack_require__(393);
	var checkPropTypes = __webpack_require__(1848);
	
	module.exports = function(isValidElement, throwOnDirectAccess) {
	  /* global Symbol */
	  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	  /**
	   * Returns the iterator method function contained on the iterable object.
	   *
	   * Be sure to invoke the function with the iterable as context:
	   *
	   *     var iteratorFn = getIteratorFn(myIterable);
	   *     if (iteratorFn) {
	   *       var iterator = iteratorFn.call(myIterable);
	   *       ...
	   *     }
	   *
	   * @param {?object} maybeIterable
	   * @return {?function}
	   */
	  function getIteratorFn(maybeIterable) {
	    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	    if (typeof iteratorFn === 'function') {
	      return iteratorFn;
	    }
	  }
	
	  /**
	   * Collection of methods that allow declaration and validation of props that are
	   * supplied to React components. Example usage:
	   *
	   *   var Props = require('ReactPropTypes');
	   *   var MyArticle = React.createClass({
	   *     propTypes: {
	   *       // An optional string prop named "description".
	   *       description: Props.string,
	   *
	   *       // A required enum prop named "category".
	   *       category: Props.oneOf(['News','Photos']).isRequired,
	   *
	   *       // A prop named "dialog" that requires an instance of Dialog.
	   *       dialog: Props.instanceOf(Dialog).isRequired
	   *     },
	   *     render: function() { ... }
	   *   });
	   *
	   * A more formal specification of how these methods are used:
	   *
	   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
	   *   decl := ReactPropTypes.{type}(.isRequired)?
	   *
	   * Each and every declaration produces a function with the same signature. This
	   * allows the creation of custom validation functions. For example:
	   *
	   *  var MyLink = React.createClass({
	   *    propTypes: {
	   *      // An optional string or URI prop named "href".
	   *      href: function(props, propName, componentName) {
	   *        var propValue = props[propName];
	   *        if (propValue != null && typeof propValue !== 'string' &&
	   *            !(propValue instanceof URI)) {
	   *          return new Error(
	   *            'Expected a string or an URI for ' + propName + ' in ' +
	   *            componentName
	   *          );
	   *        }
	   *      }
	   *    },
	   *    render: function() {...}
	   *  });
	   *
	   * @internal
	   */
	
	  var ANONYMOUS = '<<anonymous>>';
	
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
	  var ReactPropTypes = {
	    array: createPrimitiveTypeChecker('array'),
	    bool: createPrimitiveTypeChecker('boolean'),
	    func: createPrimitiveTypeChecker('function'),
	    number: createPrimitiveTypeChecker('number'),
	    object: createPrimitiveTypeChecker('object'),
	    string: createPrimitiveTypeChecker('string'),
	    symbol: createPrimitiveTypeChecker('symbol'),
	
	    any: createAnyTypeChecker(),
	    arrayOf: createArrayOfTypeChecker,
	    element: createElementTypeChecker(),
	    instanceOf: createInstanceTypeChecker,
	    node: createNodeChecker(),
	    objectOf: createObjectOfTypeChecker,
	    oneOf: createEnumTypeChecker,
	    oneOfType: createUnionTypeChecker,
	    shape: createShapeTypeChecker,
	    exact: createStrictShapeTypeChecker,
	  };
	
	  /**
	   * inlined Object.is polyfill to avoid requiring consumers ship their own
	   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
	   */
	  /*eslint-disable no-self-compare*/
	  function is(x, y) {
	    // SameValue algorithm
	    if (x === y) {
	      // Steps 1-5, 7-10
	      // Steps 6.b-6.e: +0 != -0
	      return x !== 0 || 1 / x === 1 / y;
	    } else {
	      // Step 6.a: NaN == NaN
	      return x !== x && y !== y;
	    }
	  }
	  /*eslint-enable no-self-compare*/
	
	  /**
	   * We use an Error-like object for backward compatibility as people may call
	   * PropTypes directly and inspect their output. However, we don't use real
	   * Errors anymore. We don't inspect their stack anyway, and creating them
	   * is prohibitively expensive if they are created too often, such as what
	   * happens in oneOfType() for any type before the one that matched.
	   */
	  function PropTypeError(message) {
	    this.message = message;
	    this.stack = '';
	  }
	  // Make `instanceof Error` still work for returned errors.
	  PropTypeError.prototype = Error.prototype;
	
	  function createChainableTypeChecker(validate) {
	    if (false) {
	      var manualPropTypeCallCache = {};
	      var manualPropTypeWarningCount = 0;
	    }
	    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
	      componentName = componentName || ANONYMOUS;
	      propFullName = propFullName || propName;
	
	      if (secret !== ReactPropTypesSecret) {
	        if (throwOnDirectAccess) {
	          // New behavior only for users of `prop-types` package
	          invariant(
	            false,
	            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	            'Use `PropTypes.checkPropTypes()` to call them. ' +
	            'Read more at http://fb.me/use-check-prop-types'
	          );
	        } else if (false) {
	          // Old behavior for people using React.PropTypes
	          var cacheKey = componentName + ':' + propName;
	          if (
	            !manualPropTypeCallCache[cacheKey] &&
	            // Avoid spamming the console because they are often not actionable except for lib authors
	            manualPropTypeWarningCount < 3
	          ) {
	            warning(
	              false,
	              'You are manually calling a React.PropTypes validation ' +
	              'function for the `%s` prop on `%s`. This is deprecated ' +
	              'and will throw in the standalone `prop-types` package. ' +
	              'You may be seeing this warning due to a third-party PropTypes ' +
	              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
	              propFullName,
	              componentName
	            );
	            manualPropTypeCallCache[cacheKey] = true;
	            manualPropTypeWarningCount++;
	          }
	        }
	      }
	      if (props[propName] == null) {
	        if (isRequired) {
	          if (props[propName] === null) {
	            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
	          }
	          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
	        }
	        return null;
	      } else {
	        return validate(props, propName, componentName, location, propFullName);
	      }
	    }
	
	    var chainedCheckType = checkType.bind(null, false);
	    chainedCheckType.isRequired = checkType.bind(null, true);
	
	    return chainedCheckType;
	  }
	
	  function createPrimitiveTypeChecker(expectedType) {
	    function validate(props, propName, componentName, location, propFullName, secret) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== expectedType) {
	        // `propValue` being instance of, say, date/regexp, pass the 'object'
	        // check, but we can offer a more precise error message here rather than
	        // 'of type `object`'.
	        var preciseType = getPreciseType(propValue);
	
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createAnyTypeChecker() {
	    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
	  }
	
	  function createArrayOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
	      }
	      var propValue = props[propName];
	      if (!Array.isArray(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
	      }
	      for (var i = 0; i < propValue.length; i++) {
	        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
	        if (error instanceof Error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createElementTypeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      if (!isValidElement(propValue)) {
	        var propType = getPropType(propValue);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createInstanceTypeChecker(expectedClass) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!(props[propName] instanceof expectedClass)) {
	        var expectedClassName = expectedClass.name || ANONYMOUS;
	        var actualClassName = getClassName(props[propName]);
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createEnumTypeChecker(expectedValues) {
	    if (!Array.isArray(expectedValues)) {
	       false ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      for (var i = 0; i < expectedValues.length; i++) {
	        if (is(propValue, expectedValues[i])) {
	          return null;
	        }
	      }
	
	      var valuesString = JSON.stringify(expectedValues);
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createObjectOfTypeChecker(typeChecker) {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (typeof typeChecker !== 'function') {
	        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
	      }
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
	      }
	      for (var key in propValue) {
	        if (propValue.hasOwnProperty(key)) {
	          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	          if (error instanceof Error) {
	            return error;
	          }
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createUnionTypeChecker(arrayOfTypeCheckers) {
	    if (!Array.isArray(arrayOfTypeCheckers)) {
	       false ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
	      return emptyFunction.thatReturnsNull;
	    }
	
	    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	      var checker = arrayOfTypeCheckers[i];
	      if (typeof checker !== 'function') {
	        warning(
	          false,
	          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
	          'received %s at index %s.',
	          getPostfixForTypeWarning(checker),
	          i
	        );
	        return emptyFunction.thatReturnsNull;
	      }
	    }
	
	    function validate(props, propName, componentName, location, propFullName) {
	      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
	        var checker = arrayOfTypeCheckers[i];
	        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
	          return null;
	        }
	      }
	
	      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createNodeChecker() {
	    function validate(props, propName, componentName, location, propFullName) {
	      if (!isNode(props[propName])) {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      for (var key in shapeTypes) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          continue;
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	    return createChainableTypeChecker(validate);
	  }
	
	  function createStrictShapeTypeChecker(shapeTypes) {
	    function validate(props, propName, componentName, location, propFullName) {
	      var propValue = props[propName];
	      var propType = getPropType(propValue);
	      if (propType !== 'object') {
	        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
	      }
	      // We need to check all keys in case some are required but missing from
	      // props.
	      var allKeys = assign({}, props[propName], shapeTypes);
	      for (var key in allKeys) {
	        var checker = shapeTypes[key];
	        if (!checker) {
	          return new PropTypeError(
	            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
	            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
	            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
	          );
	        }
	        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
	        if (error) {
	          return error;
	        }
	      }
	      return null;
	    }
	
	    return createChainableTypeChecker(validate);
	  }
	
	  function isNode(propValue) {
	    switch (typeof propValue) {
	      case 'number':
	      case 'string':
	      case 'undefined':
	        return true;
	      case 'boolean':
	        return !propValue;
	      case 'object':
	        if (Array.isArray(propValue)) {
	          return propValue.every(isNode);
	        }
	        if (propValue === null || isValidElement(propValue)) {
	          return true;
	        }
	
	        var iteratorFn = getIteratorFn(propValue);
	        if (iteratorFn) {
	          var iterator = iteratorFn.call(propValue);
	          var step;
	          if (iteratorFn !== propValue.entries) {
	            while (!(step = iterator.next()).done) {
	              if (!isNode(step.value)) {
	                return false;
	              }
	            }
	          } else {
	            // Iterator will provide entry [k,v] tuples rather than values.
	            while (!(step = iterator.next()).done) {
	              var entry = step.value;
	              if (entry) {
	                if (!isNode(entry[1])) {
	                  return false;
	                }
	              }
	            }
	          }
	        } else {
	          return false;
	        }
	
	        return true;
	      default:
	        return false;
	    }
	  }
	
	  function isSymbol(propType, propValue) {
	    // Native Symbol.
	    if (propType === 'symbol') {
	      return true;
	    }
	
	    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
	    if (propValue['@@toStringTag'] === 'Symbol') {
	      return true;
	    }
	
	    // Fallback for non-spec compliant Symbols which are polyfilled.
	    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
	      return true;
	    }
	
	    return false;
	  }
	
	  // Equivalent of `typeof` but with special handling for array and regexp.
	  function getPropType(propValue) {
	    var propType = typeof propValue;
	    if (Array.isArray(propValue)) {
	      return 'array';
	    }
	    if (propValue instanceof RegExp) {
	      // Old webkits (at least until Android 4.0) return 'function' rather than
	      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
	      // passes PropTypes.object.
	      return 'object';
	    }
	    if (isSymbol(propType, propValue)) {
	      return 'symbol';
	    }
	    return propType;
	  }
	
	  // This handles more types than `getPropType`. Only used for error messages.
	  // See `createPrimitiveTypeChecker`.
	  function getPreciseType(propValue) {
	    if (typeof propValue === 'undefined' || propValue === null) {
	      return '' + propValue;
	    }
	    var propType = getPropType(propValue);
	    if (propType === 'object') {
	      if (propValue instanceof Date) {
	        return 'date';
	      } else if (propValue instanceof RegExp) {
	        return 'regexp';
	      }
	    }
	    return propType;
	  }
	
	  // Returns a string that is postfixed to a warning about an invalid type.
	  // For example, "undefined" or "of type array"
	  function getPostfixForTypeWarning(value) {
	    var type = getPreciseType(value);
	    switch (type) {
	      case 'array':
	      case 'object':
	        return 'an ' + type;
	      case 'boolean':
	      case 'date':
	      case 'regexp':
	        return 'a ' + type;
	      default:
	        return type;
	    }
	  }
	
	  // Returns class name of the object, if any.
	  function getClassName(propValue) {
	    if (!propValue.constructor || !propValue.constructor.name) {
	      return ANONYMOUS;
	    }
	    return propValue.constructor.name;
	  }
	
	  ReactPropTypes.checkPropTypes = checkPropTypes;
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 1851 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var React = __webpack_require__(1);
	
	var REACT_ELEMENT_TYPE =
	  (typeof Symbol === 'function' && Symbol.for && Symbol.for('react.element')) ||
	  0xeac7;
	
	var emptyFunction = __webpack_require__(24);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(16);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	var didWarnAboutMaps = false;
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	function getIteratorFn(maybeIterable) {
	  var iteratorFn =
	    maybeIterable &&
	    ((ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL]) ||
	      maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	function escape(key) {
	  var escapeRegex = /[=:]/g;
	  var escaperLookup = {
	    '=': '=0',
	    ':': '=2'
	  };
	  var escapedString = ('' + key).replace(escapeRegex, function(match) {
	    return escaperLookup[match];
	  });
	
	  return '$' + escapedString;
	}
	
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	function traverseAllChildrenImpl(
	  children,
	  nameSoFar,
	  callback,
	  traverseContext
	) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (
	    children === null ||
	    type === 'string' ||
	    type === 'number' ||
	    // The following is inlined from ReactElement. This means we can optimize
	    // some checks. React Fiber also inlines this logic for similar purposes.
	    (type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE)
	  ) {
	    callback(
	      traverseContext,
	      children,
	      // If it's the only child, treat the name as if it was wrapped in an array
	      // so that it's consistent if the number of children grows.
	      nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar
	    );
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(
	        child,
	        nextName,
	        callback,
	        traverseContext
	      );
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      if (false) {
	        // Warn about using Maps as children
	        if (iteratorFn === children.entries) {
	          warning(
	            didWarnAboutMaps,
	            'Using Maps as children is unsupported and will likely yield ' +
	              'unexpected results. Convert it to a sequence/iterable of keyed ' +
	              'ReactElements instead.'
	          );
	          didWarnAboutMaps = true;
	        }
	      }
	
	      var iterator = iteratorFn.call(children);
	      var step;
	      var ii = 0;
	      while (!(step = iterator.next()).done) {
	        child = step.value;
	        nextName = nextNamePrefix + getComponentKey(child, ii++);
	        subtreeCount += traverseAllChildrenImpl(
	          child,
	          nextName,
	          callback,
	          traverseContext
	        );
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum =
	          ' If you meant to render a collection of children, use an array ' +
	          'instead or wrap the object using createFragment(object) from the ' +
	          'React add-ons.';
	      }
	      var childrenString = '' + children;
	      invariant(
	        false,
	        'Objects are not valid as a React child (found: %s).%s',
	        childrenString === '[object Object]'
	          ? 'object with keys {' + Object.keys(children).join(', ') + '}'
	          : childrenString,
	        addendum
	      );
	    }
	  }
	
	  return subtreeCount;
	}
	
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	function cloneAndReplaceKey(oldElement, newKey) {
	  return React.cloneElement(
	    oldElement,
	    {key: newKey},
	    oldElement.props !== undefined ? oldElement.props.children : undefined
	  );
	}
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	var oneArgumentPooler = function(copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var addPoolingTo = function addPoolingTo(CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var standardReleaser = function standardReleaser(instance) {
	  var Klass = this;
	  invariant(
	    instance instanceof Klass,
	    'Trying to release an instance into a pool of a different type.'
	  );
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var fourArgumentPooler = function fourArgumentPooler(a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function() {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result;
	  var keyPrefix = bookKeeping.keyPrefix;
	  var func = bookKeeping.func;
	  var context = bookKeeping.context;
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(
	      mappedChild,
	      result,
	      childKey,
	      emptyFunction.thatReturnsArgument
	    );
	  } else if (mappedChild != null) {
	    if (React.isValidElement(mappedChild)) {
	      mappedChild = cloneAndReplaceKey(
	        mappedChild,
	        // Keep both the (mapped) and old keys if they differ, just as
	        // traverseAllChildren used to do for objects as children
	        keyPrefix +
	          (mappedChild.key && (!child || child.key !== mappedChild.key)
	            ? escapeUserProvidedKey(mappedChild.key) + '/'
	            : '') +
	          childKey
	      );
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(
	    array,
	    escapedPrefix,
	    func,
	    context
	  );
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	var numericPropertyRegex = /^\d+$/;
	
	var warnedAboutNumeric = false;
	
	function createReactFragment(object) {
	  if (typeof object !== 'object' || !object || Array.isArray(object)) {
	    warning(
	      false,
	      'React.addons.createFragment only accepts a single object. Got: %s',
	      object
	    );
	    return object;
	  }
	  if (React.isValidElement(object)) {
	    warning(
	      false,
	      'React.addons.createFragment does not accept a ReactElement ' +
	        'without a wrapper object.'
	    );
	    return object;
	  }
	
	  invariant(
	    object.nodeType !== 1,
	    'React.addons.createFragment(...): Encountered an invalid child; DOM ' +
	      'elements are not valid children of React components.'
	  );
	
	  var result = [];
	
	  for (var key in object) {
	    if (false) {
	      if (!warnedAboutNumeric && numericPropertyRegex.test(key)) {
	        warning(
	          false,
	          'React.addons.createFragment(...): Child objects should have ' +
	            'non-numeric keys so ordering is preserved.'
	        );
	        warnedAboutNumeric = true;
	      }
	    }
	    mapIntoWithKeyPrefixInternal(
	      object[key],
	      result,
	      key,
	      emptyFunction.thatReturnsArgument
	    );
	  }
	
	  return result;
	}
	
	module.exports = createReactFragment;


/***/ },
/* 1852 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = {
	  Properties: {
	    // Global States and Properties
	    'aria-current': 0, // state
	    'aria-details': 0,
	    'aria-disabled': 0, // state
	    'aria-hidden': 0, // state
	    'aria-invalid': 0, // state
	    'aria-keyshortcuts': 0,
	    'aria-label': 0,
	    'aria-roledescription': 0,
	    // Widget Attributes
	    'aria-autocomplete': 0,
	    'aria-checked': 0,
	    'aria-expanded': 0,
	    'aria-haspopup': 0,
	    'aria-level': 0,
	    'aria-modal': 0,
	    'aria-multiline': 0,
	    'aria-multiselectable': 0,
	    'aria-orientation': 0,
	    'aria-placeholder': 0,
	    'aria-pressed': 0,
	    'aria-readonly': 0,
	    'aria-required': 0,
	    'aria-selected': 0,
	    'aria-sort': 0,
	    'aria-valuemax': 0,
	    'aria-valuemin': 0,
	    'aria-valuenow': 0,
	    'aria-valuetext': 0,
	    // Live Region Attributes
	    'aria-atomic': 0,
	    'aria-busy': 0,
	    'aria-live': 0,
	    'aria-relevant': 0,
	    // Drag-and-Drop Attributes
	    'aria-dropeffect': 0,
	    'aria-grabbed': 0,
	    // Relationship Attributes
	    'aria-activedescendant': 0,
	    'aria-colcount': 0,
	    'aria-colindex': 0,
	    'aria-colspan': 0,
	    'aria-controls': 0,
	    'aria-describedby': 0,
	    'aria-errormessage': 0,
	    'aria-flowto': 0,
	    'aria-labelledby': 0,
	    'aria-owns': 0,
	    'aria-posinset': 0,
	    'aria-rowcount': 0,
	    'aria-rowindex': 0,
	    'aria-rowspan': 0,
	    'aria-setsize': 0
	  },
	  DOMAttributeNames: {},
	  DOMPropertyNames: {}
	};
	
	module.exports = ARIADOMPropertyConfig;

/***/ },
/* 1853 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(20);
	
	var focusNode = __webpack_require__(275);
	
	var AutoFocusUtils = {
	  focusDOMComponent: function () {
	    focusNode(ReactDOMComponentTree.getNodeFromInstance(this));
	  }
	};
	
	module.exports = AutoFocusUtils;

/***/ },
/* 1854 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(91);
	var ExecutionEnvironment = __webpack_require__(22);
	var FallbackCompositionState = __webpack_require__(1861);
	var SyntheticCompositionEvent = __webpack_require__(1898);
	var SyntheticInputEvent = __webpack_require__(1901);
	
	var END_KEYCODES = [9, 13, 27, 32]; // Tab, Return, Esc, Space
	var START_KEYCODE = 229;
	
	var canUseCompositionEvent = ExecutionEnvironment.canUseDOM && 'CompositionEvent' in window;
	
	var documentMode = null;
	if (ExecutionEnvironment.canUseDOM && 'documentMode' in document) {
	  documentMode = document.documentMode;
	}
	
	// Webkit offers a very useful `textInput` event that can be used to
	// directly represent `beforeInput`. The IE `textinput` event is not as
	// useful, so we don't use it.
	var canUseTextInputEvent = ExecutionEnvironment.canUseDOM && 'TextEvent' in window && !documentMode && !isPresto();
	
	// In IE9+, we have access to composition events, but the data supplied
	// by the native compositionend event may be incorrect. Japanese ideographic
	// spaces, for instance (\u3000) are not recorded correctly.
	var useFallbackCompositionData = ExecutionEnvironment.canUseDOM && (!canUseCompositionEvent || documentMode && documentMode > 8 && documentMode <= 11);
	
	/**
	 * Opera <= 12 includes TextEvent in window, but does not fire
	 * text input events. Rely on keypress instead.
	 */
	function isPresto() {
	  var opera = window.opera;
	  return typeof opera === 'object' && typeof opera.version === 'function' && parseInt(opera.version(), 10) <= 12;
	}
	
	var SPACEBAR_CODE = 32;
	var SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE);
	
	// Events and their corresponding property names.
	var eventTypes = {
	  beforeInput: {
	    phasedRegistrationNames: {
	      bubbled: 'onBeforeInput',
	      captured: 'onBeforeInputCapture'
	    },
	    dependencies: ['topCompositionEnd', 'topKeyPress', 'topTextInput', 'topPaste']
	  },
	  compositionEnd: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionEnd',
	      captured: 'onCompositionEndCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionEnd', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionStart: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionStart',
	      captured: 'onCompositionStartCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionStart', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  },
	  compositionUpdate: {
	    phasedRegistrationNames: {
	      bubbled: 'onCompositionUpdate',
	      captured: 'onCompositionUpdateCapture'
	    },
	    dependencies: ['topBlur', 'topCompositionUpdate', 'topKeyDown', 'topKeyPress', 'topKeyUp', 'topMouseDown']
	  }
	};
	
	// Track whether we've ever handled a keypress on the space key.
	var hasSpaceKeypress = false;
	
	/**
	 * Return whether a native keypress event is assumed to be a command.
	 * This is required because Firefox fires `keypress` events for key commands
	 * (cut, copy, select-all, etc.) even though no character is inserted.
	 */
	function isKeypressCommand(nativeEvent) {
	  return (nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) &&
	  // ctrlKey && altKey is equivalent to AltGr, and is not a command.
	  !(nativeEvent.ctrlKey && nativeEvent.altKey);
	}
	
	/**
	 * Translate native top level events into event types.
	 *
	 * @param {string} topLevelType
	 * @return {object}
	 */
	function getCompositionEventType(topLevelType) {
	  switch (topLevelType) {
	    case 'topCompositionStart':
	      return eventTypes.compositionStart;
	    case 'topCompositionEnd':
	      return eventTypes.compositionEnd;
	    case 'topCompositionUpdate':
	      return eventTypes.compositionUpdate;
	  }
	}
	
	/**
	 * Does our fallback best-guess model think this event signifies that
	 * composition has begun?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionStart(topLevelType, nativeEvent) {
	  return topLevelType === 'topKeyDown' && nativeEvent.keyCode === START_KEYCODE;
	}
	
	/**
	 * Does our fallback mode think that this event is the end of composition?
	 *
	 * @param {string} topLevelType
	 * @param {object} nativeEvent
	 * @return {boolean}
	 */
	function isFallbackCompositionEnd(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topKeyUp':
	      // Command keys insert or clear IME input.
	      return END_KEYCODES.indexOf(nativeEvent.keyCode) !== -1;
	    case 'topKeyDown':
	      // Expect IME keyCode on each keydown. If we get any other
	      // code we must have exited earlier.
	      return nativeEvent.keyCode !== START_KEYCODE;
	    case 'topKeyPress':
	    case 'topMouseDown':
	    case 'topBlur':
	      // Events are not possible without cancelling IME.
	      return true;
	    default:
	      return false;
	  }
	}
	
	/**
	 * Google Input Tools provides composition data via a CustomEvent,
	 * with the `data` property populated in the `detail` object. If this
	 * is available on the event object, use it. If not, this is a plain
	 * composition event and we have nothing special to extract.
	 *
	 * @param {object} nativeEvent
	 * @return {?string}
	 */
	function getDataFromCustomEvent(nativeEvent) {
	  var detail = nativeEvent.detail;
	  if (typeof detail === 'object' && 'data' in detail) {
	    return detail.data;
	  }
	  return null;
	}
	
	// Track the current IME composition fallback object, if any.
	var currentComposition = null;
	
	/**
	 * @return {?object} A SyntheticCompositionEvent.
	 */
	function extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var eventType;
	  var fallbackData;
	
	  if (canUseCompositionEvent) {
	    eventType = getCompositionEventType(topLevelType);
	  } else if (!currentComposition) {
	    if (isFallbackCompositionStart(topLevelType, nativeEvent)) {
	      eventType = eventTypes.compositionStart;
	    }
	  } else if (isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	    eventType = eventTypes.compositionEnd;
	  }
	
	  if (!eventType) {
	    return null;
	  }
	
	  if (useFallbackCompositionData) {
	    // The current composition is stored statically and must not be
	    // overwritten while composition continues.
	    if (!currentComposition && eventType === eventTypes.compositionStart) {
	      currentComposition = FallbackCompositionState.getPooled(nativeEventTarget);
	    } else if (eventType === eventTypes.compositionEnd) {
	      if (currentComposition) {
	        fallbackData = currentComposition.getData();
	      }
	    }
	  }
	
	  var event = SyntheticCompositionEvent.getPooled(eventType, targetInst, nativeEvent, nativeEventTarget);
	
	  if (fallbackData) {
	    // Inject data generated from fallback path into the synthetic event.
	    // This matches the property of native CompositionEventInterface.
	    event.data = fallbackData;
	  } else {
	    var customData = getDataFromCustomEvent(nativeEvent);
	    if (customData !== null) {
	      event.data = customData;
	    }
	  }
	
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The string corresponding to this `beforeInput` event.
	 */
	function getNativeBeforeInputChars(topLevelType, nativeEvent) {
	  switch (topLevelType) {
	    case 'topCompositionEnd':
	      return getDataFromCustomEvent(nativeEvent);
	    case 'topKeyPress':
	      /**
	       * If native `textInput` events are available, our goal is to make
	       * use of them. However, there is a special case: the spacebar key.
	       * In Webkit, preventing default on a spacebar `textInput` event
	       * cancels character insertion, but it *also* causes the browser
	       * to fall back to its default spacebar behavior of scrolling the
	       * page.
	       *
	       * Tracking at:
	       * https://code.google.com/p/chromium/issues/detail?id=355103
	       *
	       * To avoid this issue, use the keypress event as if no `textInput`
	       * event is available.
	       */
	      var which = nativeEvent.which;
	      if (which !== SPACEBAR_CODE) {
	        return null;
	      }
	
	      hasSpaceKeypress = true;
	      return SPACEBAR_CHAR;
	
	    case 'topTextInput':
	      // Record the characters to be added to the DOM.
	      var chars = nativeEvent.data;
	
	      // If it's a spacebar character, assume that we have already handled
	      // it at the keypress level and bail immediately. Android Chrome
	      // doesn't give us keycodes, so we need to blacklist it.
	      if (chars === SPACEBAR_CHAR && hasSpaceKeypress) {
	        return null;
	      }
	
	      return chars;
	
	    default:
	      // For other native event types, do nothing.
	      return null;
	  }
	}
	
	/**
	 * For browsers that do not provide the `textInput` event, extract the
	 * appropriate string to use for SyntheticInputEvent.
	 *
	 * @param {string} topLevelType Record from `EventConstants`.
	 * @param {object} nativeEvent Native browser event.
	 * @return {?string} The fallback string for this `beforeInput` event.
	 */
	function getFallbackBeforeInputChars(topLevelType, nativeEvent) {
	  // If we are currently composing (IME) and using a fallback to do so,
	  // try to extract the composed characters from the fallback object.
	  // If composition event is available, we extract a string only at
	  // compositionevent, otherwise extract it at fallback events.
	  if (currentComposition) {
	    if (topLevelType === 'topCompositionEnd' || !canUseCompositionEvent && isFallbackCompositionEnd(topLevelType, nativeEvent)) {
	      var chars = currentComposition.getData();
	      FallbackCompositionState.release(currentComposition);
	      currentComposition = null;
	      return chars;
	    }
	    return null;
	  }
	
	  switch (topLevelType) {
	    case 'topPaste':
	      // If a paste event occurs after a keypress, throw out the input
	      // chars. Paste events should not lead to BeforeInput events.
	      return null;
	    case 'topKeyPress':
	      /**
	       * As of v27, Firefox may fire keypress events even when no character
	       * will be inserted. A few possibilities:
	       *
	       * - `which` is `0`. Arrow keys, Esc key, etc.
	       *
	       * - `which` is the pressed key code, but no char is available.
	       *   Ex: 'AltGr + d` in Polish. There is no modified character for
	       *   this key combination and no character is inserted into the
	       *   document, but FF fires the keypress for char code `100` anyway.
	       *   No `input` event will occur.
	       *
	       * - `which` is the pressed key code, but a command combination is
	       *   being used. Ex: `Cmd+C`. No character is inserted, and no
	       *   `input` event will occur.
	       */
	      if (nativeEvent.which && !isKeypressCommand(nativeEvent)) {
	        return String.fromCharCode(nativeEvent.which);
	      }
	      return null;
	    case 'topCompositionEnd':
	      return useFallbackCompositionData ? null : nativeEvent.data;
	    default:
	      return null;
	  }
	}
	
	/**
	 * Extract a SyntheticInputEvent for `beforeInput`, based on either native
	 * `textInput` or fallback behavior.
	 *
	 * @return {?object} A SyntheticInputEvent.
	 */
	function extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	  var chars;
	
	  if (canUseTextInputEvent) {
	    chars = getNativeBeforeInputChars(topLevelType, nativeEvent);
	  } else {
	    chars = getFallbackBeforeInputChars(topLevelType, nativeEvent);
	  }
	
	  // If no characters are being inserted, no BeforeInput event should
	  // be fired.
	  if (!chars) {
	    return null;
	  }
	
	  var event = SyntheticInputEvent.getPooled(eventTypes.beforeInput, targetInst, nativeEvent, nativeEventTarget);
	
	  event.data = chars;
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	
	/**
	 * Create an `onBeforeInput` event to match
	 * http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105/#events-inputevents.
	 *
	 * This event plugin is based on the native `textInput` event
	 * available in Chrome, Safari, Opera, and IE. This event fires after
	 * `onKeyPress` and `onCompositionEnd`, but before `onInput`.
	 *
	 * `beforeInput` is spec'd but not implemented in any browsers, and
	 * the `input` event does not provide any useful information about what has
	 * actually been added, contrary to the spec. Thus, `textInput` is the best
	 * available event to identify the characters that have actually been inserted
	 * into the target node.
	 *
	 * This plugin is also responsible for emitting `composition` events, thus
	 * allowing us to share composition fallback code for both `beforeInput` and
	 * `composition` event types.
	 */
	var BeforeInputEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    return [extractCompositionEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget), extractBeforeInputEvent(topLevelType, targetInst, nativeEvent, nativeEventTarget)];
	  }
	};
	
	module.exports = BeforeInputEventPlugin;

/***/ },
/* 1855 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(394);
	var ExecutionEnvironment = __webpack_require__(22);
	var ReactInstrumentation = __webpack_require__(36);
	
	var camelizeStyleName = __webpack_require__(574);
	var dangerousStyleValue = __webpack_require__(1907);
	var hyphenateStyleName = __webpack_require__(581);
	var memoizeStringOnly = __webpack_require__(585);
	var warning = __webpack_require__(16);
	
	var processStyleName = memoizeStringOnly(function (styleName) {
	  return hyphenateStyleName(styleName);
	});
	
	var hasShorthandPropertyBug = false;
	var styleFloatAccessor = 'cssFloat';
	if (ExecutionEnvironment.canUseDOM) {
	  var tempStyle = document.createElement('div').style;
	  try {
	    // IE8 throws "Invalid argument." if resetting shorthand style properties.
	    tempStyle.font = '';
	  } catch (e) {
	    hasShorthandPropertyBug = true;
	  }
	  // IE8 only supports accessing cssFloat (standard) as styleFloat
	  if (document.documentElement.style.cssFloat === undefined) {
	    styleFloatAccessor = 'styleFloat';
	  }
	}
	
	if (false) {
	  // 'msTransform' is correct, but the other prefixes should be capitalized
	  var badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/;
	
	  // style values shouldn't contain a semicolon
	  var badStyleValueWithSemicolonPattern = /;\s*$/;
	
	  var warnedStyleNames = {};
	  var warnedStyleValues = {};
	  var warnedForNaNValue = false;
	
	  var warnHyphenatedStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported style property %s. Did you mean %s?%s', name, camelizeStyleName(name), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnBadVendoredStyleName = function (name, owner) {
	    if (warnedStyleNames.hasOwnProperty(name) && warnedStyleNames[name]) {
	      return;
	    }
	
	    warnedStyleNames[name] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, 'Unsupported vendor-prefixed style property %s. Did you mean %s?%s', name, name.charAt(0).toUpperCase() + name.slice(1), checkRenderMessage(owner)) : void 0;
	  };
	
	  var warnStyleValueWithSemicolon = function (name, value, owner) {
	    if (warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value]) {
	      return;
	    }
	
	    warnedStyleValues[value] = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, "Style property values shouldn't contain a semicolon.%s " + 'Try "%s: %s" instead.', checkRenderMessage(owner), name, value.replace(badStyleValueWithSemicolonPattern, '')) : void 0;
	  };
	
	  var warnStyleValueIsNaN = function (name, value, owner) {
	    if (warnedForNaNValue) {
	      return;
	    }
	
	    warnedForNaNValue = true;
	    process.env.NODE_ENV !== 'production' ? warning(false, '`NaN` is an invalid value for the `%s` css style property.%s', name, checkRenderMessage(owner)) : void 0;
	  };
	
	  var checkRenderMessage = function (owner) {
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' Check the render method of `' + name + '`.';
	      }
	    }
	    return '';
	  };
	
	  /**
	   * @param {string} name
	   * @param {*} value
	   * @param {ReactDOMComponent} component
	   */
	  var warnValidStyle = function (name, value, component) {
	    var owner;
	    if (component) {
	      owner = component._currentElement._owner;
	    }
	    if (name.indexOf('-') > -1) {
	      warnHyphenatedStyleName(name, owner);
	    } else if (badVendoredStyleNamePattern.test(name)) {
	      warnBadVendoredStyleName(name, owner);
	    } else if (badStyleValueWithSemicolonPattern.test(value)) {
	      warnStyleValueWithSemicolon(name, value, owner);
	    }
	
	    if (typeof value === 'number' && isNaN(value)) {
	      warnStyleValueIsNaN(name, value, owner);
	    }
	  };
	}
	
	/**
	 * Operations for dealing with CSS properties.
	 */
	var CSSPropertyOperations = {
	  /**
	   * Serializes a mapping of style properties for use as inline styles:
	   *
	   *   > createMarkupForStyles({width: '200px', height: 0})
	   *   "width:200px;height:0;"
	   *
	   * Undefined values are ignored so that declarative programming is easier.
	   * The result should be HTML-escaped before insertion into the DOM.
	   *
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   * @return {?string}
	   */
	  createMarkupForStyles: function (styles, component) {
	    var serialized = '';
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      var styleValue = styles[styleName];
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styleValue, component);
	        }
	      }
	      if (styleValue != null) {
	        serialized += processStyleName(styleName) + ':';
	        serialized += dangerousStyleValue(styleName, styleValue, component, isCustomProperty) + ';';
	      }
	    }
	    return serialized || null;
	  },
	
	  /**
	   * Sets the value for multiple styles on a node.  If a value is specified as
	   * '' (empty string), the corresponding style property will be unset.
	   *
	   * @param {DOMElement} node
	   * @param {object} styles
	   * @param {ReactDOMComponent} component
	   */
	  setValueForStyles: function (node, styles, component) {
	    if (false) {
	      ReactInstrumentation.debugTool.onHostOperation({
	        instanceID: component._debugID,
	        type: 'update styles',
	        payload: styles
	      });
	    }
	
	    var style = node.style;
	    for (var styleName in styles) {
	      if (!styles.hasOwnProperty(styleName)) {
	        continue;
	      }
	      var isCustomProperty = styleName.indexOf('--') === 0;
	      if (false) {
	        if (!isCustomProperty) {
	          warnValidStyle(styleName, styles[styleName], component);
	        }
	      }
	      var styleValue = dangerousStyleValue(styleName, styles[styleName], component, isCustomProperty);
	      if (styleName === 'float' || styleName === 'cssFloat') {
	        styleName = styleFloatAccessor;
	      }
	      if (isCustomProperty) {
	        style.setProperty(styleName, styleValue);
	      } else if (styleValue) {
	        style[styleName] = styleValue;
	      } else {
	        var expansion = hasShorthandPropertyBug && CSSProperty.shorthandPropertyExpansions[styleName];
	        if (expansion) {
	          // Shorthand property that IE8 won't like unsetting, so unset each
	          // component to placate it
	          for (var individualStyleName in expansion) {
	            style[individualStyleName] = '';
	          }
	        } else {
	          style[styleName] = '';
	        }
	      }
	    }
	  }
	};
	
	module.exports = CSSPropertyOperations;

/***/ },
/* 1856 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(90);
	var EventPropagators = __webpack_require__(91);
	var ExecutionEnvironment = __webpack_require__(22);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(42);
	var SyntheticEvent = __webpack_require__(43);
	
	var inputValueTracking = __webpack_require__(409);
	var getEventTarget = __webpack_require__(237);
	var isEventSupported = __webpack_require__(238);
	var isTextInputElement = __webpack_require__(411);
	
	var eventTypes = {
	  change: {
	    phasedRegistrationNames: {
	      bubbled: 'onChange',
	      captured: 'onChangeCapture'
	    },
	    dependencies: ['topBlur', 'topChange', 'topClick', 'topFocus', 'topInput', 'topKeyDown', 'topKeyUp', 'topSelectionChange']
	  }
	};
	
	function createAndAccumulateChangeEvent(inst, nativeEvent, target) {
	  var event = SyntheticEvent.getPooled(eventTypes.change, inst, nativeEvent, target);
	  event.type = 'change';
	  EventPropagators.accumulateTwoPhaseDispatches(event);
	  return event;
	}
	/**
	 * For IE shims
	 */
	var activeElement = null;
	var activeElementInst = null;
	
	/**
	 * SECTION: handle `change` event
	 */
	function shouldUseChangeEvent(elem) {
	  var nodeName = elem.nodeName && elem.nodeName.toLowerCase();
	  return nodeName === 'select' || nodeName === 'input' && elem.type === 'file';
	}
	
	var doesChangeEventBubble = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // See `handleChange` comment below
	  doesChangeEventBubble = isEventSupported('change') && (!document.documentMode || document.documentMode > 8);
	}
	
	function manualDispatchChangeEvent(nativeEvent) {
	  var event = createAndAccumulateChangeEvent(activeElementInst, nativeEvent, getEventTarget(nativeEvent));
	
	  // If change and propertychange bubbled, we'd just bind to it like all the
	  // other events and have it go through ReactBrowserEventEmitter. Since it
	  // doesn't, we manually listen for the events and so we have to enqueue and
	  // process the abstract event manually.
	  //
	  // Batching is necessary here in order to ensure that all event handlers run
	  // before the next rerender (including event handlers attached to ancestor
	  // elements instead of directly on the input). Without this, controlled
	  // components don't work properly in conjunction with event bubbling because
	  // the component is rerendered and the value reverted before all the event
	  // handlers can run. See https://github.com/facebook/react/issues/708.
	  ReactUpdates.batchedUpdates(runEventInBatch, event);
	}
	
	function runEventInBatch(event) {
	  EventPluginHub.enqueueEvents(event);
	  EventPluginHub.processEventQueue(false);
	}
	
	function startWatchingForChangeEventIE8(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onchange', manualDispatchChangeEvent);
	}
	
	function stopWatchingForChangeEventIE8() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onchange', manualDispatchChangeEvent);
	  activeElement = null;
	  activeElementInst = null;
	}
	
	function getInstIfValueChanged(targetInst, nativeEvent) {
	  var updated = inputValueTracking.updateValueIfChanged(targetInst);
	  var simulated = nativeEvent.simulated === true && ChangeEventPlugin._allowSimulatedPassThrough;
	
	  if (updated || simulated) {
	    return targetInst;
	  }
	}
	
	function getTargetInstForChangeEvent(topLevelType, targetInst) {
	  if (topLevelType === 'topChange') {
	    return targetInst;
	  }
	}
	
	function handleEventsForChangeEventIE8(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForChangeEventIE8();
	    startWatchingForChangeEventIE8(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForChangeEventIE8();
	  }
	}
	
	/**
	 * SECTION: handle `input` event
	 */
	var isInputEventSupported = false;
	if (ExecutionEnvironment.canUseDOM) {
	  // IE9 claims to support the input event but fails to trigger it when
	  // deleting text, so we ignore its input events.
	
	  isInputEventSupported = isEventSupported('input') && (!document.documentMode || document.documentMode > 9);
	}
	
	/**
	 * (For IE <=9) Starts tracking propertychange events on the passed-in element
	 * and override the value property so that we can distinguish user events from
	 * value changes in JS.
	 */
	function startWatchingForValueChange(target, targetInst) {
	  activeElement = target;
	  activeElementInst = targetInst;
	  activeElement.attachEvent('onpropertychange', handlePropertyChange);
	}
	
	/**
	 * (For IE <=9) Removes the event listeners from the currently-tracked element,
	 * if any exists.
	 */
	function stopWatchingForValueChange() {
	  if (!activeElement) {
	    return;
	  }
	  activeElement.detachEvent('onpropertychange', handlePropertyChange);
	
	  activeElement = null;
	  activeElementInst = null;
	}
	
	/**
	 * (For IE <=9) Handles a propertychange event, sending a `change` event if
	 * the value of the active element has changed.
	 */
	function handlePropertyChange(nativeEvent) {
	  if (nativeEvent.propertyName !== 'value') {
	    return;
	  }
	  if (getInstIfValueChanged(activeElementInst, nativeEvent)) {
	    manualDispatchChangeEvent(nativeEvent);
	  }
	}
	
	function handleEventsForInputEventPolyfill(topLevelType, target, targetInst) {
	  if (topLevelType === 'topFocus') {
	    // In IE8, we can capture almost all .value changes by adding a
	    // propertychange handler and looking for events with propertyName
	    // equal to 'value'
	    // In IE9, propertychange fires for most input events but is buggy and
	    // doesn't fire when text is deleted, but conveniently, selectionchange
	    // appears to fire in all of the remaining cases so we catch those and
	    // forward the event if the value has changed
	    // In either case, we don't want to call the event handler if the value
	    // is changed from JS so we redefine a setter for `.value` that updates
	    // our activeElementValue variable, allowing us to ignore those changes
	    //
	    // stopWatching() should be a noop here but we call it just in case we
	    // missed a blur event somehow.
	    stopWatchingForValueChange();
	    startWatchingForValueChange(target, targetInst);
	  } else if (topLevelType === 'topBlur') {
	    stopWatchingForValueChange();
	  }
	}
	
	// For IE8 and IE9.
	function getTargetInstForInputEventPolyfill(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topSelectionChange' || topLevelType === 'topKeyUp' || topLevelType === 'topKeyDown') {
	    // On the selectionchange event, the target is just document which isn't
	    // helpful for us so just check activeElement instead.
	    //
	    // 99% of the time, keydown and keyup aren't necessary. IE8 fails to fire
	    // propertychange on the first input event after setting `value` from a
	    // script and fires only keydown, keypress, keyup. Catching keyup usually
	    // gets it and catching keydown lets us fire an event for the first
	    // keystroke if user does a key repeat (it'll be a little delayed: right
	    // before the second keystroke). Other input methods (e.g., paste) seem to
	    // fire selectionchange normally.
	    return getInstIfValueChanged(activeElementInst, nativeEvent);
	  }
	}
	
	/**
	 * SECTION: handle `click` event
	 */
	function shouldUseClickEvent(elem) {
	  // Use the `click` event to detect changes to checkbox and radio inputs.
	  // This approach works across all browsers, whereas `change` does not fire
	  // until `blur` in IE8.
	  var nodeName = elem.nodeName;
	  return nodeName && nodeName.toLowerCase() === 'input' && (elem.type === 'checkbox' || elem.type === 'radio');
	}
	
	function getTargetInstForClickEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topClick') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function getTargetInstForInputOrChangeEvent(topLevelType, targetInst, nativeEvent) {
	  if (topLevelType === 'topInput' || topLevelType === 'topChange') {
	    return getInstIfValueChanged(targetInst, nativeEvent);
	  }
	}
	
	function handleControlledInputBlur(inst, node) {
	  // TODO: In IE, inst is occasionally null. Why?
	  if (inst == null) {
	    return;
	  }
	
	  // Fiber and ReactDOM keep wrapper state in separate places
	  var state = inst._wrapperState || node._wrapperState;
	
	  if (!state || !state.controlled || node.type !== 'number') {
	    return;
	  }
	
	  // If controlled, assign the value attribute to the current value on blur
	  var value = '' + node.value;
	  if (node.getAttribute('value') !== value) {
	    node.setAttribute('value', value);
	  }
	}
	
	/**
	 * This plugin creates an `onChange` event that normalizes change events
	 * across form elements. This event fires at a time when it's possible to
	 * change the element's value without seeing a flicker.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - select
	 */
	var ChangeEventPlugin = {
	  eventTypes: eventTypes,
	
	  _allowSimulatedPassThrough: true,
	  _isInputEventSupported: isInputEventSupported,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    var getTargetInstFunc, handleEventFunc;
	    if (shouldUseChangeEvent(targetNode)) {
	      if (doesChangeEventBubble) {
	        getTargetInstFunc = getTargetInstForChangeEvent;
	      } else {
	        handleEventFunc = handleEventsForChangeEventIE8;
	      }
	    } else if (isTextInputElement(targetNode)) {
	      if (isInputEventSupported) {
	        getTargetInstFunc = getTargetInstForInputOrChangeEvent;
	      } else {
	        getTargetInstFunc = getTargetInstForInputEventPolyfill;
	        handleEventFunc = handleEventsForInputEventPolyfill;
	      }
	    } else if (shouldUseClickEvent(targetNode)) {
	      getTargetInstFunc = getTargetInstForClickEvent;
	    }
	
	    if (getTargetInstFunc) {
	      var inst = getTargetInstFunc(topLevelType, targetInst, nativeEvent);
	      if (inst) {
	        var event = createAndAccumulateChangeEvent(inst, nativeEvent, nativeEventTarget);
	        return event;
	      }
	    }
	
	    if (handleEventFunc) {
	      handleEventFunc(topLevelType, targetNode, targetInst);
	    }
	
	    // When blurring, set the value attribute for number inputs
	    if (topLevelType === 'topBlur') {
	      handleControlledInputBlur(targetInst, targetNode);
	    }
	  }
	};
	
	module.exports = ChangeEventPlugin;

/***/ },
/* 1857 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var DOMLazyTree = __webpack_require__(88);
	var ExecutionEnvironment = __webpack_require__(22);
	
	var createNodesFromMarkup = __webpack_require__(577);
	var emptyFunction = __webpack_require__(24);
	var invariant = __webpack_require__(13);
	
	var Danger = {
	  /**
	   * Replaces a node with a string of markup at its current position within its
	   * parent. The markup must render into a single root node.
	   *
	   * @param {DOMElement} oldChild Child node to replace.
	   * @param {string} markup Markup to render in place of the child node.
	   * @internal
	   */
	  dangerouslyReplaceNodeWithMarkup: function (oldChild, markup) {
	    !ExecutionEnvironment.canUseDOM ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot render markup in a worker thread. Make sure `window` and `document` are available globally before requiring React when unit testing or use ReactDOMServer.renderToString() for server rendering.') : _prodInvariant('56') : void 0;
	    !markup ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Missing markup.') : _prodInvariant('57') : void 0;
	    !(oldChild.nodeName !== 'HTML') ?  false ? invariant(false, 'dangerouslyReplaceNodeWithMarkup(...): Cannot replace markup of the <html> node. This is because browser quirks make this unreliable and/or slow. If you want to render to the root you must use server rendering. See ReactDOMServer.renderToString().') : _prodInvariant('58') : void 0;
	
	    if (typeof markup === 'string') {
	      var newChild = createNodesFromMarkup(markup, emptyFunction)[0];
	      oldChild.parentNode.replaceChild(newChild, oldChild);
	    } else {
	      DOMLazyTree.replaceChildWithTree(oldChild, markup);
	    }
	  }
	};
	
	module.exports = Danger;

/***/ },
/* 1858 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Module that is injectable into `EventPluginHub`, that specifies a
	 * deterministic ordering of `EventPlugin`s. A convenient way to reason about
	 * plugins, without having to package every one of them. This is better than
	 * having plugins be ordered in the same order that they are injected because
	 * that ordering would be influenced by the packaging order.
	 * `ResponderEventPlugin` must occur before `SimpleEventPlugin` so that
	 * preventing default on events is convenient in `SimpleEventPlugin` handlers.
	 */
	
	var DefaultEventPluginOrder = ['ResponderEventPlugin', 'SimpleEventPlugin', 'TapEventPlugin', 'EnterLeaveEventPlugin', 'ChangeEventPlugin', 'SelectEventPlugin', 'BeforeInputEventPlugin'];
	
	module.exports = DefaultEventPluginOrder;

/***/ },
/* 1859 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(20);
	var SyntheticMouseEvent = __webpack_require__(156);
	
	var eventTypes = {
	  mouseEnter: {
	    registrationName: 'onMouseEnter',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  },
	  mouseLeave: {
	    registrationName: 'onMouseLeave',
	    dependencies: ['topMouseOut', 'topMouseOver']
	  }
	};
	
	var EnterLeaveEventPlugin = {
	  eventTypes: eventTypes,
	
	  /**
	   * For almost every interaction we care about, there will be both a top-level
	   * `mouseover` and `mouseout` event that occurs. Only use `mouseout` so that
	   * we do not extract duplicate events. However, moving the mouse into the
	   * browser from outside will not fire a `mouseout` event. In this case, we use
	   * the `mouseover` top-level event.
	   */
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (topLevelType === 'topMouseOver' && (nativeEvent.relatedTarget || nativeEvent.fromElement)) {
	      return null;
	    }
	    if (topLevelType !== 'topMouseOut' && topLevelType !== 'topMouseOver') {
	      // Must not be a mouse in or mouse out - ignoring.
	      return null;
	    }
	
	    var win;
	    if (nativeEventTarget.window === nativeEventTarget) {
	      // `nativeEventTarget` is probably a window object.
	      win = nativeEventTarget;
	    } else {
	      // TODO: Figure out why `ownerDocument` is sometimes undefined in IE8.
	      var doc = nativeEventTarget.ownerDocument;
	      if (doc) {
	        win = doc.defaultView || doc.parentWindow;
	      } else {
	        win = window;
	      }
	    }
	
	    var from;
	    var to;
	    if (topLevelType === 'topMouseOut') {
	      from = targetInst;
	      var related = nativeEvent.relatedTarget || nativeEvent.toElement;
	      to = related ? ReactDOMComponentTree.getClosestInstanceFromNode(related) : null;
	    } else {
	      // Moving to a node from outside the window.
	      from = null;
	      to = targetInst;
	    }
	
	    if (from === to) {
	      // Nothing pertains to our managed components.
	      return null;
	    }
	
	    var fromNode = from == null ? win : ReactDOMComponentTree.getNodeFromInstance(from);
	    var toNode = to == null ? win : ReactDOMComponentTree.getNodeFromInstance(to);
	
	    var leave = SyntheticMouseEvent.getPooled(eventTypes.mouseLeave, from, nativeEvent, nativeEventTarget);
	    leave.type = 'mouseleave';
	    leave.target = fromNode;
	    leave.relatedTarget = toNode;
	
	    var enter = SyntheticMouseEvent.getPooled(eventTypes.mouseEnter, to, nativeEvent, nativeEventTarget);
	    enter.type = 'mouseenter';
	    enter.target = toNode;
	    enter.relatedTarget = fromNode;
	
	    EventPropagators.accumulateEnterLeaveDispatches(leave, enter, from, to);
	
	    return [leave, enter];
	  }
	};
	
	module.exports = EnterLeaveEventPlugin;

/***/ },
/* 1860 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Types of raw signals from the browser caught at the top level.
	 */
	var topLevelTypes = {
	  topAbort: null,
	  topAnimationEnd: null,
	  topAnimationIteration: null,
	  topAnimationStart: null,
	  topBlur: null,
	  topCanPlay: null,
	  topCanPlayThrough: null,
	  topChange: null,
	  topClick: null,
	  topCompositionEnd: null,
	  topCompositionStart: null,
	  topCompositionUpdate: null,
	  topContextMenu: null,
	  topCopy: null,
	  topCut: null,
	  topDoubleClick: null,
	  topDrag: null,
	  topDragEnd: null,
	  topDragEnter: null,
	  topDragExit: null,
	  topDragLeave: null,
	  topDragOver: null,
	  topDragStart: null,
	  topDrop: null,
	  topDurationChange: null,
	  topEmptied: null,
	  topEncrypted: null,
	  topEnded: null,
	  topError: null,
	  topFocus: null,
	  topInput: null,
	  topInvalid: null,
	  topKeyDown: null,
	  topKeyPress: null,
	  topKeyUp: null,
	  topLoad: null,
	  topLoadedData: null,
	  topLoadedMetadata: null,
	  topLoadStart: null,
	  topMouseDown: null,
	  topMouseMove: null,
	  topMouseOut: null,
	  topMouseOver: null,
	  topMouseUp: null,
	  topPaste: null,
	  topPause: null,
	  topPlay: null,
	  topPlaying: null,
	  topProgress: null,
	  topRateChange: null,
	  topReset: null,
	  topScroll: null,
	  topSeeked: null,
	  topSeeking: null,
	  topSelectionChange: null,
	  topStalled: null,
	  topSubmit: null,
	  topSuspend: null,
	  topTextInput: null,
	  topTimeUpdate: null,
	  topTouchCancel: null,
	  topTouchEnd: null,
	  topTouchMove: null,
	  topTouchStart: null,
	  topTransitionEnd: null,
	  topVolumeChange: null,
	  topWaiting: null,
	  topWheel: null
	};
	
	var EventConstants = {
	  topLevelTypes: topLevelTypes
	};
	
	module.exports = EventConstants;

/***/ },
/* 1861 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(66);
	
	var getTextContentAccessor = __webpack_require__(408);
	
	/**
	 * This helper class stores information about text content of a target node,
	 * allowing comparison of content before and after a given event.
	 *
	 * Identify the node where selection currently begins, then observe
	 * both its text content and its current position in the DOM. Since the
	 * browser may natively replace the target node during composition, we can
	 * use its position to find its replacement.
	 *
	 * @param {DOMEventTarget} root
	 */
	function FallbackCompositionState(root) {
	  this._root = root;
	  this._startText = this.getText();
	  this._fallbackText = null;
	}
	
	_assign(FallbackCompositionState.prototype, {
	  destructor: function () {
	    this._root = null;
	    this._startText = null;
	    this._fallbackText = null;
	  },
	
	  /**
	   * Get current text of input.
	   *
	   * @return {string}
	   */
	  getText: function () {
	    if ('value' in this._root) {
	      return this._root.value;
	    }
	    return this._root[getTextContentAccessor()];
	  },
	
	  /**
	   * Determine the differing substring between the initially stored
	   * text content and the current content.
	   *
	   * @return {string}
	   */
	  getData: function () {
	    if (this._fallbackText) {
	      return this._fallbackText;
	    }
	
	    var start;
	    var startValue = this._startText;
	    var startLength = startValue.length;
	    var end;
	    var endValue = this.getText();
	    var endLength = endValue.length;
	
	    for (start = 0; start < startLength; start++) {
	      if (startValue[start] !== endValue[start]) {
	        break;
	      }
	    }
	
	    var minEnd = startLength - start;
	    for (end = 1; end <= minEnd; end++) {
	      if (startValue[startLength - end] !== endValue[endLength - end]) {
	        break;
	      }
	    }
	
	    var sliceTail = end > 1 ? 1 - end : undefined;
	    this._fallbackText = endValue.slice(start, sliceTail);
	    return this._fallbackText;
	  }
	});
	
	PooledClass.addPoolingTo(FallbackCompositionState);
	
	module.exports = FallbackCompositionState;

/***/ },
/* 1862 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(89);
	
	var MUST_USE_PROPERTY = DOMProperty.injection.MUST_USE_PROPERTY;
	var HAS_BOOLEAN_VALUE = DOMProperty.injection.HAS_BOOLEAN_VALUE;
	var HAS_NUMERIC_VALUE = DOMProperty.injection.HAS_NUMERIC_VALUE;
	var HAS_POSITIVE_NUMERIC_VALUE = DOMProperty.injection.HAS_POSITIVE_NUMERIC_VALUE;
	var HAS_OVERLOADED_BOOLEAN_VALUE = DOMProperty.injection.HAS_OVERLOADED_BOOLEAN_VALUE;
	
	var HTMLDOMPropertyConfig = {
	  isCustomAttribute: RegExp.prototype.test.bind(new RegExp('^(data|aria)-[' + DOMProperty.ATTRIBUTE_NAME_CHAR + ']*$')),
	  Properties: {
	    /**
	     * Standard Properties
	     */
	    accept: 0,
	    acceptCharset: 0,
	    accessKey: 0,
	    action: 0,
	    allowFullScreen: HAS_BOOLEAN_VALUE,
	    allowTransparency: 0,
	    alt: 0,
	    // specifies target context for links with `preload` type
	    as: 0,
	    async: HAS_BOOLEAN_VALUE,
	    autoComplete: 0,
	    // autoFocus is polyfilled/normalized by AutoFocusUtils
	    // autoFocus: HAS_BOOLEAN_VALUE,
	    autoPlay: HAS_BOOLEAN_VALUE,
	    capture: HAS_BOOLEAN_VALUE,
	    cellPadding: 0,
	    cellSpacing: 0,
	    charSet: 0,
	    challenge: 0,
	    checked: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    cite: 0,
	    classID: 0,
	    className: 0,
	    cols: HAS_POSITIVE_NUMERIC_VALUE,
	    colSpan: 0,
	    content: 0,
	    contentEditable: 0,
	    contextMenu: 0,
	    controls: HAS_BOOLEAN_VALUE,
	    controlsList: 0,
	    coords: 0,
	    crossOrigin: 0,
	    data: 0, // For `<object />` acts as `src`.
	    dateTime: 0,
	    'default': HAS_BOOLEAN_VALUE,
	    defer: HAS_BOOLEAN_VALUE,
	    dir: 0,
	    disabled: HAS_BOOLEAN_VALUE,
	    download: HAS_OVERLOADED_BOOLEAN_VALUE,
	    draggable: 0,
	    encType: 0,
	    form: 0,
	    formAction: 0,
	    formEncType: 0,
	    formMethod: 0,
	    formNoValidate: HAS_BOOLEAN_VALUE,
	    formTarget: 0,
	    frameBorder: 0,
	    headers: 0,
	    height: 0,
	    hidden: HAS_BOOLEAN_VALUE,
	    high: 0,
	    href: 0,
	    hrefLang: 0,
	    htmlFor: 0,
	    httpEquiv: 0,
	    icon: 0,
	    id: 0,
	    inputMode: 0,
	    integrity: 0,
	    is: 0,
	    keyParams: 0,
	    keyType: 0,
	    kind: 0,
	    label: 0,
	    lang: 0,
	    list: 0,
	    loop: HAS_BOOLEAN_VALUE,
	    low: 0,
	    manifest: 0,
	    marginHeight: 0,
	    marginWidth: 0,
	    max: 0,
	    maxLength: 0,
	    media: 0,
	    mediaGroup: 0,
	    method: 0,
	    min: 0,
	    minLength: 0,
	    // Caution; `option.selected` is not updated if `select.multiple` is
	    // disabled with `removeAttribute`.
	    multiple: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    muted: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    name: 0,
	    nonce: 0,
	    noValidate: HAS_BOOLEAN_VALUE,
	    open: HAS_BOOLEAN_VALUE,
	    optimum: 0,
	    pattern: 0,
	    placeholder: 0,
	    playsInline: HAS_BOOLEAN_VALUE,
	    poster: 0,
	    preload: 0,
	    profile: 0,
	    radioGroup: 0,
	    readOnly: HAS_BOOLEAN_VALUE,
	    referrerPolicy: 0,
	    rel: 0,
	    required: HAS_BOOLEAN_VALUE,
	    reversed: HAS_BOOLEAN_VALUE,
	    role: 0,
	    rows: HAS_POSITIVE_NUMERIC_VALUE,
	    rowSpan: HAS_NUMERIC_VALUE,
	    sandbox: 0,
	    scope: 0,
	    scoped: HAS_BOOLEAN_VALUE,
	    scrolling: 0,
	    seamless: HAS_BOOLEAN_VALUE,
	    selected: MUST_USE_PROPERTY | HAS_BOOLEAN_VALUE,
	    shape: 0,
	    size: HAS_POSITIVE_NUMERIC_VALUE,
	    sizes: 0,
	    span: HAS_POSITIVE_NUMERIC_VALUE,
	    spellCheck: 0,
	    src: 0,
	    srcDoc: 0,
	    srcLang: 0,
	    srcSet: 0,
	    start: HAS_NUMERIC_VALUE,
	    step: 0,
	    style: 0,
	    summary: 0,
	    tabIndex: 0,
	    target: 0,
	    title: 0,
	    // Setting .type throws on non-<input> tags
	    type: 0,
	    useMap: 0,
	    value: 0,
	    width: 0,
	    wmode: 0,
	    wrap: 0,
	
	    /**
	     * RDFa Properties
	     */
	    about: 0,
	    datatype: 0,
	    inlist: 0,
	    prefix: 0,
	    // property is also supported for OpenGraph in meta tags.
	    property: 0,
	    resource: 0,
	    'typeof': 0,
	    vocab: 0,
	
	    /**
	     * Non-standard Properties
	     */
	    // autoCapitalize and autoCorrect are supported in Mobile Safari for
	    // keyboard hints.
	    autoCapitalize: 0,
	    autoCorrect: 0,
	    // autoSave allows WebKit/Blink to persist values of input fields on page reloads
	    autoSave: 0,
	    // color is for Safari mask-icon link
	    color: 0,
	    // itemProp, itemScope, itemType are for
	    // Microdata support. See http://schema.org/docs/gs.html
	    itemProp: 0,
	    itemScope: HAS_BOOLEAN_VALUE,
	    itemType: 0,
	    // itemID and itemRef are for Microdata support as well but
	    // only specified in the WHATWG spec document. See
	    // https://html.spec.whatwg.org/multipage/microdata.html#microdata-dom-api
	    itemID: 0,
	    itemRef: 0,
	    // results show looking glass icon and recent searches on input
	    // search fields in WebKit/Blink
	    results: 0,
	    // IE-only attribute that specifies security restrictions on an iframe
	    // as an alternative to the sandbox attribute on IE<10
	    security: 0,
	    // IE-only attribute that controls focus behavior
	    unselectable: 0
	  },
	  DOMAttributeNames: {
	    acceptCharset: 'accept-charset',
	    className: 'class',
	    htmlFor: 'for',
	    httpEquiv: 'http-equiv'
	  },
	  DOMPropertyNames: {},
	  DOMMutationMethods: {
	    value: function (node, value) {
	      if (value == null) {
	        return node.removeAttribute('value');
	      }
	
	      // Number inputs get special treatment due to some edge cases in
	      // Chrome. Let everything else assign the value attribute as normal.
	      // https://github.com/facebook/react/issues/7253#issuecomment-236074326
	      if (node.type !== 'number' || node.hasAttribute('value') === false) {
	        node.setAttribute('value', '' + value);
	      } else if (node.validity && !node.validity.badInput && node.ownerDocument.activeElement !== node) {
	        // Don't assign an attribute if validation reports bad
	        // input. Chrome will clear the value. Additionally, don't
	        // operate on inputs that have focus, otherwise Chrome might
	        // strip off trailing decimal places and cause the user's
	        // cursor position to jump to the beginning of the input.
	        //
	        // In ReactDOMInput, we have an onBlur event that will trigger
	        // this function again when focus is lost.
	        node.setAttribute('value', '' + value);
	      }
	    }
	  }
	};
	
	module.exports = HTMLDOMPropertyConfig;

/***/ },
/* 1863 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactReconciler = __webpack_require__(92);
	
	var instantiateReactComponent = __webpack_require__(410);
	var KeyEscapeUtils = __webpack_require__(228);
	var shouldUpdateReactComponent = __webpack_require__(239);
	var traverseAllChildren = __webpack_require__(413);
	var warning = __webpack_require__(16);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(424);
	}
	
	function instantiateChild(childInstances, child, name, selfDebugID) {
	  // We found a component instance.
	  var keyUnique = childInstances[name] === undefined;
	  if (false) {
	    if (!ReactComponentTreeHook) {
	      ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	    }
	    if (!keyUnique) {
	      process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	    }
	  }
	  if (child != null && keyUnique) {
	    childInstances[name] = instantiateReactComponent(child, true);
	  }
	}
	
	/**
	 * ReactChildReconciler provides helpers for initializing or updating a set of
	 * children. Its output is suitable for passing it onto ReactMultiChild which
	 * does diffed reordering and insertion.
	 */
	var ReactChildReconciler = {
	  /**
	   * Generates a "mount image" for each of the supplied children. In the case
	   * of `ReactDOMComponent`, a mount image is a string of markup.
	   *
	   * @param {?object} nestedChildNodes Nested child maps.
	   * @return {?object} A set of child instances.
	   * @internal
	   */
	  instantiateChildren: function (nestedChildNodes, transaction, context, selfDebugID) // 0 in production and for roots
	  {
	    if (nestedChildNodes == null) {
	      return null;
	    }
	    var childInstances = {};
	
	    if (false) {
	      traverseAllChildren(nestedChildNodes, function (childInsts, child, name) {
	        return instantiateChild(childInsts, child, name, selfDebugID);
	      }, childInstances);
	    } else {
	      traverseAllChildren(nestedChildNodes, instantiateChild, childInstances);
	    }
	    return childInstances;
	  },
	
	  /**
	   * Updates the rendered children and returns a new set of children.
	   *
	   * @param {?object} prevChildren Previously initialized set of children.
	   * @param {?object} nextChildren Flat child element maps.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   * @return {?object} A new set of child instances.
	   * @internal
	   */
	  updateChildren: function (prevChildren, nextChildren, mountImages, removedNodes, transaction, hostParent, hostContainerInfo, context, selfDebugID) // 0 in production and for roots
	  {
	    // We currently don't have a way to track moves here but if we use iterators
	    // instead of for..in we can zip the iterators and check if an item has
	    // moved.
	    // TODO: If nothing has changed, return the prevChildren object so that we
	    // can quickly bailout if nothing has changed.
	    if (!nextChildren && !prevChildren) {
	      return;
	    }
	    var name;
	    var prevChild;
	    for (name in nextChildren) {
	      if (!nextChildren.hasOwnProperty(name)) {
	        continue;
	      }
	      prevChild = prevChildren && prevChildren[name];
	      var prevElement = prevChild && prevChild._currentElement;
	      var nextElement = nextChildren[name];
	      if (prevChild != null && shouldUpdateReactComponent(prevElement, nextElement)) {
	        ReactReconciler.receiveComponent(prevChild, nextElement, transaction, context);
	        nextChildren[name] = prevChild;
	      } else {
	        if (prevChild) {
	          removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	          ReactReconciler.unmountComponent(prevChild, false);
	        }
	        // The child must be instantiated before it's mounted.
	        var nextChildInstance = instantiateReactComponent(nextElement, true);
	        nextChildren[name] = nextChildInstance;
	        // Creating mount image now ensures refs are resolved in right order
	        // (see https://github.com/facebook/react/pull/7101 for explanation).
	        var nextChildMountImage = ReactReconciler.mountComponent(nextChildInstance, transaction, hostParent, hostContainerInfo, context, selfDebugID);
	        mountImages.push(nextChildMountImage);
	      }
	    }
	    // Unmount children that are no longer present.
	    for (name in prevChildren) {
	      if (prevChildren.hasOwnProperty(name) && !(nextChildren && nextChildren.hasOwnProperty(name))) {
	        prevChild = prevChildren[name];
	        removedNodes[name] = ReactReconciler.getHostNode(prevChild);
	        ReactReconciler.unmountComponent(prevChild, false);
	      }
	    }
	  },
	
	  /**
	   * Unmounts all rendered children. This should be used to clean up children
	   * when this component is unmounted.
	   *
	   * @param {?object} renderedChildren Previously initialized set of children.
	   * @internal
	   */
	  unmountChildren: function (renderedChildren, safely) {
	    for (var name in renderedChildren) {
	      if (renderedChildren.hasOwnProperty(name)) {
	        var renderedChild = renderedChildren[name];
	        ReactReconciler.unmountComponent(renderedChild, safely);
	      }
	    }
	  }
	};
	
	module.exports = ReactChildReconciler;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ },
/* 1864 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(225);
	var ReactDOMIDOperations = __webpack_require__(1871);
	
	/**
	 * Abstracts away all functionality of the reconciler that requires knowledge of
	 * the browser context. TODO: These callers should be refactored to avoid the
	 * need for this injection.
	 */
	var ReactComponentBrowserEnvironment = {
	  processChildrenUpdates: ReactDOMIDOperations.dangerouslyProcessChildrenUpdates,
	
	  replaceNodeWithMarkup: DOMChildrenOperations.dangerouslyReplaceNodeWithMarkup
	};
	
	module.exports = ReactComponentBrowserEnvironment;

/***/ },
/* 1865 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var React = __webpack_require__(94);
	var ReactComponentEnvironment = __webpack_require__(230);
	var ReactCurrentOwner = __webpack_require__(45);
	var ReactErrorUtils = __webpack_require__(231);
	var ReactInstanceMap = __webpack_require__(119);
	var ReactInstrumentation = __webpack_require__(36);
	var ReactNodeTypes = __webpack_require__(404);
	var ReactReconciler = __webpack_require__(92);
	
	if (false) {
	  var checkReactTypeSpec = require('./checkReactTypeSpec');
	}
	
	var emptyObject = __webpack_require__(130);
	var invariant = __webpack_require__(13);
	var shallowEqual = __webpack_require__(105);
	var shouldUpdateReactComponent = __webpack_require__(239);
	var warning = __webpack_require__(16);
	
	var CompositeTypes = {
	  ImpureClass: 0,
	  PureClass: 1,
	  StatelessFunctional: 2
	};
	
	function StatelessComponent(Component) {}
	StatelessComponent.prototype.render = function () {
	  var Component = ReactInstanceMap.get(this)._currentElement.type;
	  var element = Component(this.props, this.context, this.updater);
	  warnIfInvalidElement(Component, element);
	  return element;
	};
	
	function warnIfInvalidElement(Component, element) {
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(element === null || element === false || React.isValidElement(element), '%s(...): A valid React element (or null) must be returned. You may have ' + 'returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(!Component.childContextTypes, '%s(...): childContextTypes cannot be defined on a functional component.', Component.displayName || Component.name || 'Component') : void 0;
	  }
	}
	
	function shouldConstruct(Component) {
	  return !!(Component.prototype && Component.prototype.isReactComponent);
	}
	
	function isPureComponent(Component) {
	  return !!(Component.prototype && Component.prototype.isPureReactComponent);
	}
	
	// Separated into a function to contain deoptimizations caused by try/finally.
	function measureLifeCyclePerf(fn, debugID, timerType) {
	  if (debugID === 0) {
	    // Top-level wrappers (see ReactMount) and empty components (see
	    // ReactDOMEmptyComponent) are invisible to hooks and devtools.
	    // Both are implementation details that should go away in the future.
	    return fn();
	  }
	
	  ReactInstrumentation.debugTool.onBeginLifeCycleTimer(debugID, timerType);
	  try {
	    return fn();
	  } finally {
	    ReactInstrumentation.debugTool.onEndLifeCycleTimer(debugID, timerType);
	  }
	}
	
	/**
	 * ------------------ The Life-Cycle of a Composite Component ------------------
	 *
	 * - constructor: Initialization of state. The instance is now retained.
	 *   - componentWillMount
	 *   - render
	 *   - [children's constructors]
	 *     - [children's componentWillMount and render]
	 *     - [children's componentDidMount]
	 *     - componentDidMount
	 *
	 *       Update Phases:
	 *       - componentWillReceiveProps (only called if parent updated)
	 *       - shouldComponentUpdate
	 *         - componentWillUpdate
	 *           - render
	 *           - [children's constructors or receive props phases]
	 *         - componentDidUpdate
	 *
	 *     - componentWillUnmount
	 *     - [children's componentWillUnmount]
	 *   - [children destroyed]
	 * - (destroyed): The instance is now blank, released by React and ready for GC.
	 *
	 * -----------------------------------------------------------------------------
	 */
	
	/**
	 * An incrementing ID assigned to each component when it is mounted. This is
	 * used to enforce the order in which `ReactUpdates` updates dirty components.
	 *
	 * @private
	 */
	var nextMountID = 1;
	
	/**
	 * @lends {ReactCompositeComponent.prototype}
	 */
	var ReactCompositeComponent = {
	  /**
	   * Base constructor for all composite component.
	   *
	   * @param {ReactElement} element
	   * @final
	   * @internal
	   */
	  construct: function (element) {
	    this._currentElement = element;
	    this._rootNodeID = 0;
	    this._compositeType = null;
	    this._instance = null;
	    this._hostParent = null;
	    this._hostContainerInfo = null;
	
	    // See ReactUpdateQueue
	    this._updateBatchNumber = null;
	    this._pendingElement = null;
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    this._renderedNodeType = null;
	    this._renderedComponent = null;
	    this._context = null;
	    this._mountOrder = 0;
	    this._topLevelWrapper = null;
	
	    // See ReactUpdates and ReactUpdateQueue.
	    this._pendingCallbacks = null;
	
	    // ComponentWillUnmount shall only be called once
	    this._calledComponentWillUnmount = false;
	
	    if (false) {
	      this._warnedAboutRefsInRender = false;
	    }
	  },
	
	  /**
	   * Initializes the component, renders markup, and registers event listeners.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?object} hostParent
	   * @param {?object} hostContainerInfo
	   * @param {?object} context
	   * @return {?string} Rendered markup to be inserted into the DOM.
	   * @final
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var _this = this;
	
	    this._context = context;
	    this._mountOrder = nextMountID++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var publicProps = this._currentElement.props;
	    var publicContext = this._processContext(context);
	
	    var Component = this._currentElement.type;
	
	    var updateQueue = transaction.getUpdateQueue();
	
	    // Initialize the public class
	    var doConstruct = shouldConstruct(Component);
	    var inst = this._constructComponent(doConstruct, publicProps, publicContext, updateQueue);
	    var renderedElement;
	
	    // Support functional components
	    if (!doConstruct && (inst == null || inst.render == null)) {
	      renderedElement = inst;
	      warnIfInvalidElement(Component, renderedElement);
	      !(inst === null || inst === false || React.isValidElement(inst)) ?  false ? invariant(false, '%s(...): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', Component.displayName || Component.name || 'Component') : _prodInvariant('105', Component.displayName || Component.name || 'Component') : void 0;
	      inst = new StatelessComponent(Component);
	      this._compositeType = CompositeTypes.StatelessFunctional;
	    } else {
	      if (isPureComponent(Component)) {
	        this._compositeType = CompositeTypes.PureClass;
	      } else {
	        this._compositeType = CompositeTypes.ImpureClass;
	      }
	    }
	
	    if (false) {
	      // This will throw later in _renderValidatedComponent, but add an early
	      // warning now to help debugging
	      if (inst.render == null) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): No `render` method found on the returned component ' + 'instance: you may have forgotten to define `render`.', Component.displayName || Component.name || 'Component') : void 0;
	      }
	
	      var propsMutated = inst.props !== publicProps;
	      var componentName = Component.displayName || Component.name || 'Component';
	
	      process.env.NODE_ENV !== 'production' ? warning(inst.props === undefined || !propsMutated, '%s(...): When calling super() in `%s`, make sure to pass ' + "up the same props that your component's constructor was passed.", componentName, componentName) : void 0;
	    }
	
	    // These should be set up in the constructor, but as a convenience for
	    // simpler class abstractions, we set them up after the fact.
	    inst.props = publicProps;
	    inst.context = publicContext;
	    inst.refs = emptyObject;
	    inst.updater = updateQueue;
	
	    this._instance = inst;
	
	    // Store a reference from the instance back to the internal representation
	    ReactInstanceMap.set(inst, this);
	
	    if (false) {
	      // Since plain JS classes are defined without any special initialization
	      // logic, we can not catch common errors early. Therefore, we have to
	      // catch them here, at initialization time, instead.
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getInitialState || inst.getInitialState.isReactClassApproved || inst.state, 'getInitialState was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Did you mean to define a state property instead?', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.getDefaultProps || inst.getDefaultProps.isReactClassApproved, 'getDefaultProps was defined on %s, a plain JavaScript class. ' + 'This is only supported for classes created using React.createClass. ' + 'Use a static property to define defaultProps instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.propTypes, 'propTypes was defined as an instance property on %s. Use a static ' + 'property to define propTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(!inst.contextTypes, 'contextTypes was defined as an instance property on %s. Use a ' + 'static property to define contextTypes instead.', this.getName() || 'a component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentShouldUpdate !== 'function', '%s has a method called ' + 'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' + 'The name is phrased as a question because the function is ' + 'expected to return a value.', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentDidUnmount !== 'function', '%s has a method called ' + 'componentDidUnmount(). But there is no such lifecycle method. ' + 'Did you mean componentWillUnmount()?', this.getName() || 'A component') : void 0;
	      process.env.NODE_ENV !== 'production' ? warning(typeof inst.componentWillRecieveProps !== 'function', '%s has a method called ' + 'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?', this.getName() || 'A component') : void 0;
	    }
	
	    var initialState = inst.state;
	    if (initialState === undefined) {
	      inst.state = initialState = null;
	    }
	    !(typeof initialState === 'object' && !Array.isArray(initialState)) ?  false ? invariant(false, '%s.state: must be set to an object or null', this.getName() || 'ReactCompositeComponent') : _prodInvariant('106', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	
	    var markup;
	    if (inst.unstable_handleError) {
	      markup = this.performInitialMountWithErrorHandling(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } else {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	
	    if (inst.componentDidMount) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(function () {
	            return inst.componentDidMount();
	          }, _this._debugID, 'componentDidMount');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidMount, inst);
	      }
	    }
	
	    return markup;
	  },
	
	  _constructComponent: function (doConstruct, publicProps, publicContext, updateQueue) {
	    if (false) {
	      ReactCurrentOwner.current = this;
	      try {
	        return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      return this._constructComponentWithoutOwner(doConstruct, publicProps, publicContext, updateQueue);
	    }
	  },
	
	  _constructComponentWithoutOwner: function (doConstruct, publicProps, publicContext, updateQueue) {
	    var Component = this._currentElement.type;
	
	    if (doConstruct) {
	      if (false) {
	        return measureLifeCyclePerf(function () {
	          return new Component(publicProps, publicContext, updateQueue);
	        }, this._debugID, 'ctor');
	      } else {
	        return new Component(publicProps, publicContext, updateQueue);
	      }
	    }
	
	    // This can still be an instance in case of factory components
	    // but we'll count this as time spent rendering as the more common case.
	    if (false) {
	      return measureLifeCyclePerf(function () {
	        return Component(publicProps, publicContext, updateQueue);
	      }, this._debugID, 'render');
	    } else {
	      return Component(publicProps, publicContext, updateQueue);
	    }
	  },
	
	  performInitialMountWithErrorHandling: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var markup;
	    var checkpoint = transaction.checkpoint();
	    try {
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    } catch (e) {
	      // Roll back to checkpoint, handle error (which may add items to the transaction), and take a new checkpoint
	      transaction.rollback(checkpoint);
	      this._instance.unstable_handleError(e);
	      if (this._pendingStateQueue) {
	        this._instance.state = this._processPendingState(this._instance.props, this._instance.context);
	      }
	      checkpoint = transaction.checkpoint();
	
	      this._renderedComponent.unmountComponent(true);
	      transaction.rollback(checkpoint);
	
	      // Try again - we've informed the component about the error, so they can render an error message this time.
	      // If this throws again, the error will bubble up (and can be caught by a higher error boundary).
	      markup = this.performInitialMount(renderedElement, hostParent, hostContainerInfo, transaction, context);
	    }
	    return markup;
	  },
	
	  performInitialMount: function (renderedElement, hostParent, hostContainerInfo, transaction, context) {
	    var inst = this._instance;
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (inst.componentWillMount) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillMount();
	        }, debugID, 'componentWillMount');
	      } else {
	        inst.componentWillMount();
	      }
	      // When mounting, calls to `setState` by `componentWillMount` will set
	      // `this._pendingStateQueue` without triggering a re-render.
	      if (this._pendingStateQueue) {
	        inst.state = this._processPendingState(inst.props, inst.context);
	      }
	    }
	
	    // If not a stateless component, we now render
	    if (renderedElement === undefined) {
	      renderedElement = this._renderValidatedComponent();
	    }
	
	    var nodeType = ReactNodeTypes.getType(renderedElement);
	    this._renderedNodeType = nodeType;
	    var child = this._instantiateReactComponent(renderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	    );
	    this._renderedComponent = child;
	
	    var markup = ReactReconciler.mountComponent(child, transaction, hostParent, hostContainerInfo, this._processChildContext(context), debugID);
	
	    if (false) {
	      if (debugID !== 0) {
	        var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	        ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	      }
	    }
	
	    return markup;
	  },
	
	  getHostNode: function () {
	    return ReactReconciler.getHostNode(this._renderedComponent);
	  },
	
	  /**
	   * Releases any resources allocated by `mountComponent`.
	   *
	   * @final
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    if (!this._renderedComponent) {
	      return;
	    }
	
	    var inst = this._instance;
	
	    if (inst.componentWillUnmount && !inst._calledComponentWillUnmount) {
	      inst._calledComponentWillUnmount = true;
	
	      if (safely) {
	        var name = this.getName() + '.componentWillUnmount()';
	        ReactErrorUtils.invokeGuardedCallback(name, inst.componentWillUnmount.bind(inst));
	      } else {
	        if (false) {
	          measureLifeCyclePerf(function () {
	            return inst.componentWillUnmount();
	          }, this._debugID, 'componentWillUnmount');
	        } else {
	          inst.componentWillUnmount();
	        }
	      }
	    }
	
	    if (this._renderedComponent) {
	      ReactReconciler.unmountComponent(this._renderedComponent, safely);
	      this._renderedNodeType = null;
	      this._renderedComponent = null;
	      this._instance = null;
	    }
	
	    // Reset pending fields
	    // Even if this component is scheduled for another update in ReactUpdates,
	    // it would still be ignored because these fields are reset.
	    this._pendingStateQueue = null;
	    this._pendingReplaceState = false;
	    this._pendingForceUpdate = false;
	    this._pendingCallbacks = null;
	    this._pendingElement = null;
	
	    // These fields do not really need to be reset since this object is no
	    // longer accessible.
	    this._context = null;
	    this._rootNodeID = 0;
	    this._topLevelWrapper = null;
	
	    // Delete the reference from the instance to this internal representation
	    // which allow the internals to be properly cleaned up even if the user
	    // leaks a reference to the public instance.
	    ReactInstanceMap.remove(inst);
	
	    // Some existing components rely on inst.props even after they've been
	    // destroyed (in event handlers).
	    // TODO: inst.props = null;
	    // TODO: inst.state = null;
	    // TODO: inst.context = null;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _maskContext: function (context) {
	    var Component = this._currentElement.type;
	    var contextTypes = Component.contextTypes;
	    if (!contextTypes) {
	      return emptyObject;
	    }
	    var maskedContext = {};
	    for (var contextName in contextTypes) {
	      maskedContext[contextName] = context[contextName];
	    }
	    return maskedContext;
	  },
	
	  /**
	   * Filters the context object to only contain keys specified in
	   * `contextTypes`, and asserts that they are valid.
	   *
	   * @param {object} context
	   * @return {?object}
	   * @private
	   */
	  _processContext: function (context) {
	    var maskedContext = this._maskContext(context);
	    if (false) {
	      var Component = this._currentElement.type;
	      if (Component.contextTypes) {
	        this._checkContextTypes(Component.contextTypes, maskedContext, 'context');
	      }
	    }
	    return maskedContext;
	  },
	
	  /**
	   * @param {object} currentContext
	   * @return {object}
	   * @private
	   */
	  _processChildContext: function (currentContext) {
	    var Component = this._currentElement.type;
	    var inst = this._instance;
	    var childContext;
	
	    if (inst.getChildContext) {
	      if (false) {
	        ReactInstrumentation.debugTool.onBeginProcessingChildContext();
	        try {
	          childContext = inst.getChildContext();
	        } finally {
	          ReactInstrumentation.debugTool.onEndProcessingChildContext();
	        }
	      } else {
	        childContext = inst.getChildContext();
	      }
	    }
	
	    if (childContext) {
	      !(typeof Component.childContextTypes === 'object') ?  false ? invariant(false, '%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().', this.getName() || 'ReactCompositeComponent') : _prodInvariant('107', this.getName() || 'ReactCompositeComponent') : void 0;
	      if (false) {
	        this._checkContextTypes(Component.childContextTypes, childContext, 'child context');
	      }
	      for (var name in childContext) {
	        !(name in Component.childContextTypes) ?  false ? invariant(false, '%s.getChildContext(): key "%s" is not defined in childContextTypes.', this.getName() || 'ReactCompositeComponent', name) : _prodInvariant('108', this.getName() || 'ReactCompositeComponent', name) : void 0;
	      }
	      return _assign({}, currentContext, childContext);
	    }
	    return currentContext;
	  },
	
	  /**
	   * Assert that the context types are valid
	   *
	   * @param {object} typeSpecs Map of context field to a ReactPropType
	   * @param {object} values Runtime values that need to be type-checked
	   * @param {string} location e.g. "prop", "context", "child context"
	   * @private
	   */
	  _checkContextTypes: function (typeSpecs, values, location) {
	    if (false) {
	      checkReactTypeSpec(typeSpecs, values, location, this.getName(), null, this._debugID);
	    }
	  },
	
	  receiveComponent: function (nextElement, transaction, nextContext) {
	    var prevElement = this._currentElement;
	    var prevContext = this._context;
	
	    this._pendingElement = null;
	
	    this.updateComponent(transaction, prevElement, nextElement, prevContext, nextContext);
	  },
	
	  /**
	   * If any of `_pendingElement`, `_pendingStateQueue`, or `_pendingForceUpdate`
	   * is set, update the component.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  performUpdateIfNecessary: function (transaction) {
	    if (this._pendingElement != null) {
	      ReactReconciler.receiveComponent(this, this._pendingElement, transaction, this._context);
	    } else if (this._pendingStateQueue !== null || this._pendingForceUpdate) {
	      this.updateComponent(transaction, this._currentElement, this._currentElement, this._context, this._context);
	    } else {
	      this._updateBatchNumber = null;
	    }
	  },
	
	  /**
	   * Perform an update to a mounted component. The componentWillReceiveProps and
	   * shouldComponentUpdate methods are called, then (assuming the update isn't
	   * skipped) the remaining update lifecycle methods are called and the DOM
	   * representation is updated.
	   *
	   * By default, this implements React's rendering and reconciliation algorithm.
	   * Sophisticated clients may wish to override this.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevParentElement
	   * @param {ReactElement} nextParentElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevParentElement, nextParentElement, prevUnmaskedContext, nextUnmaskedContext) {
	    var inst = this._instance;
	    !(inst != null) ?  false ? invariant(false, 'Attempted to update component `%s` that has already been unmounted (or failed to mount).', this.getName() || 'ReactCompositeComponent') : _prodInvariant('136', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    var willReceive = false;
	    var nextContext;
	
	    // Determine if the context has changed or not
	    if (this._context === nextUnmaskedContext) {
	      nextContext = inst.context;
	    } else {
	      nextContext = this._processContext(nextUnmaskedContext);
	      willReceive = true;
	    }
	
	    var prevProps = prevParentElement.props;
	    var nextProps = nextParentElement.props;
	
	    // Not a simple state update but a props update
	    if (prevParentElement !== nextParentElement) {
	      willReceive = true;
	    }
	
	    // An update here will schedule an update but immediately set
	    // _pendingStateQueue which will ensure that any state updates gets
	    // immediately reconciled instead of waiting for the next batch.
	    if (willReceive && inst.componentWillReceiveProps) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillReceiveProps(nextProps, nextContext);
	        }, this._debugID, 'componentWillReceiveProps');
	      } else {
	        inst.componentWillReceiveProps(nextProps, nextContext);
	      }
	    }
	
	    var nextState = this._processPendingState(nextProps, nextContext);
	    var shouldUpdate = true;
	
	    if (!this._pendingForceUpdate) {
	      if (inst.shouldComponentUpdate) {
	        if (false) {
	          shouldUpdate = measureLifeCyclePerf(function () {
	            return inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	          }, this._debugID, 'shouldComponentUpdate');
	        } else {
	          shouldUpdate = inst.shouldComponentUpdate(nextProps, nextState, nextContext);
	        }
	      } else {
	        if (this._compositeType === CompositeTypes.PureClass) {
	          shouldUpdate = !shallowEqual(prevProps, nextProps) || !shallowEqual(inst.state, nextState);
	        }
	      }
	    }
	
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(shouldUpdate !== undefined, '%s.shouldComponentUpdate(): Returned undefined instead of a ' + 'boolean value. Make sure to return true or false.', this.getName() || 'ReactCompositeComponent') : void 0;
	    }
	
	    this._updateBatchNumber = null;
	    if (shouldUpdate) {
	      this._pendingForceUpdate = false;
	      // Will set `this.props`, `this.state` and `this.context`.
	      this._performComponentUpdate(nextParentElement, nextProps, nextState, nextContext, transaction, nextUnmaskedContext);
	    } else {
	      // If it's determined that a component should not update, we still want
	      // to set props and state but we shortcut the rest of the update.
	      this._currentElement = nextParentElement;
	      this._context = nextUnmaskedContext;
	      inst.props = nextProps;
	      inst.state = nextState;
	      inst.context = nextContext;
	    }
	  },
	
	  _processPendingState: function (props, context) {
	    var inst = this._instance;
	    var queue = this._pendingStateQueue;
	    var replace = this._pendingReplaceState;
	    this._pendingReplaceState = false;
	    this._pendingStateQueue = null;
	
	    if (!queue) {
	      return inst.state;
	    }
	
	    if (replace && queue.length === 1) {
	      return queue[0];
	    }
	
	    var nextState = _assign({}, replace ? queue[0] : inst.state);
	    for (var i = replace ? 1 : 0; i < queue.length; i++) {
	      var partial = queue[i];
	      _assign(nextState, typeof partial === 'function' ? partial.call(inst, nextState, props, context) : partial);
	    }
	
	    return nextState;
	  },
	
	  /**
	   * Merges new props and state, notifies delegate methods of update and
	   * performs update.
	   *
	   * @param {ReactElement} nextElement Next element
	   * @param {object} nextProps Next public object to set as properties.
	   * @param {?object} nextState Next object to set as state.
	   * @param {?object} nextContext Next public object to set as context.
	   * @param {ReactReconcileTransaction} transaction
	   * @param {?object} unmaskedContext
	   * @private
	   */
	  _performComponentUpdate: function (nextElement, nextProps, nextState, nextContext, transaction, unmaskedContext) {
	    var _this2 = this;
	
	    var inst = this._instance;
	
	    var hasComponentDidUpdate = Boolean(inst.componentDidUpdate);
	    var prevProps;
	    var prevState;
	    var prevContext;
	    if (hasComponentDidUpdate) {
	      prevProps = inst.props;
	      prevState = inst.state;
	      prevContext = inst.context;
	    }
	
	    if (inst.componentWillUpdate) {
	      if (false) {
	        measureLifeCyclePerf(function () {
	          return inst.componentWillUpdate(nextProps, nextState, nextContext);
	        }, this._debugID, 'componentWillUpdate');
	      } else {
	        inst.componentWillUpdate(nextProps, nextState, nextContext);
	      }
	    }
	
	    this._currentElement = nextElement;
	    this._context = unmaskedContext;
	    inst.props = nextProps;
	    inst.state = nextState;
	    inst.context = nextContext;
	
	    this._updateRenderedComponent(transaction, unmaskedContext);
	
	    if (hasComponentDidUpdate) {
	      if (false) {
	        transaction.getReactMountReady().enqueue(function () {
	          measureLifeCyclePerf(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), _this2._debugID, 'componentDidUpdate');
	        });
	      } else {
	        transaction.getReactMountReady().enqueue(inst.componentDidUpdate.bind(inst, prevProps, prevState, prevContext), inst);
	      }
	    }
	  },
	
	  /**
	   * Call the component's `render` method and update the DOM accordingly.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  _updateRenderedComponent: function (transaction, context) {
	    var prevComponentInstance = this._renderedComponent;
	    var prevRenderedElement = prevComponentInstance._currentElement;
	    var nextRenderedElement = this._renderValidatedComponent();
	
	    var debugID = 0;
	    if (false) {
	      debugID = this._debugID;
	    }
	
	    if (shouldUpdateReactComponent(prevRenderedElement, nextRenderedElement)) {
	      ReactReconciler.receiveComponent(prevComponentInstance, nextRenderedElement, transaction, this._processChildContext(context));
	    } else {
	      var oldHostNode = ReactReconciler.getHostNode(prevComponentInstance);
	      ReactReconciler.unmountComponent(prevComponentInstance, false);
	
	      var nodeType = ReactNodeTypes.getType(nextRenderedElement);
	      this._renderedNodeType = nodeType;
	      var child = this._instantiateReactComponent(nextRenderedElement, nodeType !== ReactNodeTypes.EMPTY /* shouldHaveDebugID */
	      );
	      this._renderedComponent = child;
	
	      var nextMarkup = ReactReconciler.mountComponent(child, transaction, this._hostParent, this._hostContainerInfo, this._processChildContext(context), debugID);
	
	      if (false) {
	        if (debugID !== 0) {
	          var childDebugIDs = child._debugID !== 0 ? [child._debugID] : [];
	          ReactInstrumentation.debugTool.onSetChildren(debugID, childDebugIDs);
	        }
	      }
	
	      this._replaceNodeWithMarkup(oldHostNode, nextMarkup, prevComponentInstance);
	    }
	  },
	
	  /**
	   * Overridden in shallow rendering.
	   *
	   * @protected
	   */
	  _replaceNodeWithMarkup: function (oldHostNode, nextMarkup, prevInstance) {
	    ReactComponentEnvironment.replaceNodeWithMarkup(oldHostNode, nextMarkup, prevInstance);
	  },
	
	  /**
	   * @protected
	   */
	  _renderValidatedComponentWithoutOwnerOrContext: function () {
	    var inst = this._instance;
	    var renderedElement;
	
	    if (false) {
	      renderedElement = measureLifeCyclePerf(function () {
	        return inst.render();
	      }, this._debugID, 'render');
	    } else {
	      renderedElement = inst.render();
	    }
	
	    if (false) {
	      // We allow auto-mocks to proceed as if they're returning null.
	      if (renderedElement === undefined && inst.render._isMockFunction) {
	        // This is probably bad practice. Consider warning here and
	        // deprecating this convenience.
	        renderedElement = null;
	      }
	    }
	
	    return renderedElement;
	  },
	
	  /**
	   * @private
	   */
	  _renderValidatedComponent: function () {
	    var renderedElement;
	    if (("production") !== 'production' || this._compositeType !== CompositeTypes.StatelessFunctional) {
	      ReactCurrentOwner.current = this;
	      try {
	        renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	      } finally {
	        ReactCurrentOwner.current = null;
	      }
	    } else {
	      renderedElement = this._renderValidatedComponentWithoutOwnerOrContext();
	    }
	    !(
	    // TODO: An `isValidNode` function would probably be more appropriate
	    renderedElement === null || renderedElement === false || React.isValidElement(renderedElement)) ?  false ? invariant(false, '%s.render(): A valid React element (or null) must be returned. You may have returned undefined, an array or some other invalid object.', this.getName() || 'ReactCompositeComponent') : _prodInvariant('109', this.getName() || 'ReactCompositeComponent') : void 0;
	
	    return renderedElement;
	  },
	
	  /**
	   * Lazily allocates the refs object and stores `component` as `ref`.
	   *
	   * @param {string} ref Reference name.
	   * @param {component} component Component to store as `ref`.
	   * @final
	   * @private
	   */
	  attachRef: function (ref, component) {
	    var inst = this.getPublicInstance();
	    !(inst != null) ?  false ? invariant(false, 'Stateless function components cannot have refs.') : _prodInvariant('110') : void 0;
	    var publicComponentInstance = component.getPublicInstance();
	    if (false) {
	      var componentName = component && component.getName ? component.getName() : 'a component';
	      process.env.NODE_ENV !== 'production' ? warning(publicComponentInstance != null || component._compositeType !== CompositeTypes.StatelessFunctional, 'Stateless function components cannot be given refs ' + '(See ref "%s" in %s created by %s). ' + 'Attempts to access this ref will fail.', ref, componentName, this.getName()) : void 0;
	    }
	    var refs = inst.refs === emptyObject ? inst.refs = {} : inst.refs;
	    refs[ref] = publicComponentInstance;
	  },
	
	  /**
	   * Detaches a reference name.
	   *
	   * @param {string} ref Name to dereference.
	   * @final
	   * @private
	   */
	  detachRef: function (ref) {
	    var refs = this.getPublicInstance().refs;
	    delete refs[ref];
	  },
	
	  /**
	   * Get a text description of the component that can be used to identify it
	   * in error messages.
	   * @return {string} The name or null.
	   * @internal
	   */
	  getName: function () {
	    var type = this._currentElement.type;
	    var constructor = this._instance && this._instance.constructor;
	    return type.displayName || constructor && constructor.displayName || type.name || constructor && constructor.name || null;
	  },
	
	  /**
	   * Get the publicly accessible representation of this component - i.e. what
	   * is exposed by refs and returned by render. Can be null for stateless
	   * components.
	   *
	   * @return {ReactComponent} the public component instance.
	   * @internal
	   */
	  getPublicInstance: function () {
	    var inst = this._instance;
	    if (this._compositeType === CompositeTypes.StatelessFunctional) {
	      return null;
	    }
	    return inst;
	  },
	
	  // Stub
	  _instantiateReactComponent: null
	};
	
	module.exports = ReactCompositeComponent;

/***/ },
/* 1866 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* globals __REACT_DEVTOOLS_GLOBAL_HOOK__*/
	
	'use strict';
	
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDefaultInjection = __webpack_require__(1879);
	var ReactMount = __webpack_require__(403);
	var ReactReconciler = __webpack_require__(92);
	var ReactUpdates = __webpack_require__(42);
	var ReactVersion = __webpack_require__(1892);
	
	var findDOMNode = __webpack_require__(1908);
	var getHostComponentFromComposite = __webpack_require__(407);
	var renderSubtreeIntoContainer = __webpack_require__(1915);
	var warning = __webpack_require__(16);
	
	ReactDefaultInjection.inject();
	
	var ReactDOM = {
	  findDOMNode: findDOMNode,
	  render: ReactMount.render,
	  unmountComponentAtNode: ReactMount.unmountComponentAtNode,
	  version: ReactVersion,
	
	  /* eslint-disable camelcase */
	  unstable_batchedUpdates: ReactUpdates.batchedUpdates,
	  unstable_renderSubtreeIntoContainer: renderSubtreeIntoContainer
	  /* eslint-enable camelcase */
	};
	
	// Inject the runtime into a devtools global hook regardless of browser.
	// Allows for debugging when the hook is injected on the page.
	if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ !== 'undefined' && typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.inject === 'function') {
	  __REACT_DEVTOOLS_GLOBAL_HOOK__.inject({
	    ComponentTree: {
	      getClosestInstanceFromNode: ReactDOMComponentTree.getClosestInstanceFromNode,
	      getNodeFromInstance: function (inst) {
	        // inst is an internal instance (but could be a composite)
	        if (inst._renderedComponent) {
	          inst = getHostComponentFromComposite(inst);
	        }
	        if (inst) {
	          return ReactDOMComponentTree.getNodeFromInstance(inst);
	        } else {
	          return null;
	        }
	      }
	    },
	    Mount: ReactMount,
	    Reconciler: ReactReconciler
	  });
	}
	
	if (false) {
	  var ExecutionEnvironment = require('fbjs/lib/ExecutionEnvironment');
	  if (ExecutionEnvironment.canUseDOM && window.top === window.self) {
	    // First check if devtools is not installed
	    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined') {
	      // If we're in Chrome or Firefox, provide a download link if not installed.
	      if (navigator.userAgent.indexOf('Chrome') > -1 && navigator.userAgent.indexOf('Edge') === -1 || navigator.userAgent.indexOf('Firefox') > -1) {
	        // Firefox does not have the issue with devtools loaded over file://
	        var showFileUrlMessage = window.location.protocol.indexOf('http') === -1 && navigator.userAgent.indexOf('Firefox') === -1;
	        console.debug('Download the React DevTools ' + (showFileUrlMessage ? 'and use an HTTP server (instead of a file: URL) ' : '') + 'for a better development experience: ' + 'https://fb.me/react-devtools');
	      }
	    }
	
	    var testFunc = function testFn() {};
	    process.env.NODE_ENV !== 'production' ? warning((testFunc.name || testFunc.toString()).indexOf('testFn') !== -1, "It looks like you're using a minified copy of the development build " + 'of React. When deploying React apps to production, make sure to use ' + 'the production build which skips development warnings and is faster. ' + 'See https://fb.me/react-minification for more details.') : void 0;
	
	    // If we're in IE8, check to see if we are in compatibility mode and provide
	    // information on preventing compatibility mode
	    var ieCompatibilityMode = document.documentMode && document.documentMode < 8;
	
	    process.env.NODE_ENV !== 'production' ? warning(!ieCompatibilityMode, 'Internet Explorer is running in compatibility mode; please add the ' + 'following tag to your HTML to prevent this from happening: ' + '<meta http-equiv="X-UA-Compatible" content="IE=edge" />') : void 0;
	
	    var expectedFeatures = [
	    // shims
	    Array.isArray, Array.prototype.every, Array.prototype.forEach, Array.prototype.indexOf, Array.prototype.map, Date.now, Function.prototype.bind, Object.keys, String.prototype.trim];
	
	    for (var i = 0; i < expectedFeatures.length; i++) {
	      if (!expectedFeatures[i]) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'One or more ES5 shims expected by React are not available: ' + 'https://fb.me/react-warning-polyfills') : void 0;
	        break;
	      }
	    }
	  }
	}
	
	if (false) {
	  var ReactInstrumentation = require('./ReactInstrumentation');
	  var ReactDOMUnknownPropertyHook = require('./ReactDOMUnknownPropertyHook');
	  var ReactDOMNullInputValuePropHook = require('./ReactDOMNullInputValuePropHook');
	  var ReactDOMInvalidARIAHook = require('./ReactDOMInvalidARIAHook');
	
	  ReactInstrumentation.debugTool.addHook(ReactDOMUnknownPropertyHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMNullInputValuePropHook);
	  ReactInstrumentation.debugTool.addHook(ReactDOMInvalidARIAHook);
	}
	
	module.exports = ReactDOM;

/***/ },
/* 1867 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	/* global hasOwnProperty:true */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var AutoFocusUtils = __webpack_require__(1853);
	var CSSPropertyOperations = __webpack_require__(1855);
	var DOMLazyTree = __webpack_require__(88);
	var DOMNamespaces = __webpack_require__(226);
	var DOMProperty = __webpack_require__(89);
	var DOMPropertyOperations = __webpack_require__(396);
	var EventPluginHub = __webpack_require__(90);
	var EventPluginRegistry = __webpack_require__(227);
	var ReactBrowserEventEmitter = __webpack_require__(155);
	var ReactDOMComponentFlags = __webpack_require__(397);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMInput = __webpack_require__(1872);
	var ReactDOMOption = __webpack_require__(1873);
	var ReactDOMSelect = __webpack_require__(398);
	var ReactDOMTextarea = __webpack_require__(1876);
	var ReactInstrumentation = __webpack_require__(36);
	var ReactMultiChild = __webpack_require__(1885);
	var ReactServerRenderingTransaction = __webpack_require__(1890);
	
	var emptyFunction = __webpack_require__(24);
	var escapeTextContentForBrowser = __webpack_require__(158);
	var invariant = __webpack_require__(13);
	var isEventSupported = __webpack_require__(238);
	var shallowEqual = __webpack_require__(105);
	var inputValueTracking = __webpack_require__(409);
	var validateDOMNesting = __webpack_require__(240);
	var warning = __webpack_require__(16);
	
	var Flags = ReactDOMComponentFlags;
	var deleteListener = EventPluginHub.deleteListener;
	var getNode = ReactDOMComponentTree.getNodeFromInstance;
	var listenTo = ReactBrowserEventEmitter.listenTo;
	var registrationNameModules = EventPluginRegistry.registrationNameModules;
	
	// For quickly matching children type, to test if can be treated as content.
	var CONTENT_TYPES = { string: true, number: true };
	
	var STYLE = 'style';
	var HTML = '__html';
	var RESERVED_PROPS = {
	  children: null,
	  dangerouslySetInnerHTML: null,
	  suppressContentEditableWarning: null
	};
	
	// Node type for document fragments (Node.DOCUMENT_FRAGMENT_NODE).
	var DOC_FRAGMENT_TYPE = 11;
	
	function getDeclarationErrorAddendum(internalInstance) {
	  if (internalInstance) {
	    var owner = internalInstance._currentElement._owner || null;
	    if (owner) {
	      var name = owner.getName();
	      if (name) {
	        return ' This DOM node was rendered by `' + name + '`.';
	      }
	    }
	  }
	  return '';
	}
	
	function friendlyStringify(obj) {
	  if (typeof obj === 'object') {
	    if (Array.isArray(obj)) {
	      return '[' + obj.map(friendlyStringify).join(', ') + ']';
	    } else {
	      var pairs = [];
	      for (var key in obj) {
	        if (Object.prototype.hasOwnProperty.call(obj, key)) {
	          var keyEscaped = /^[a-z$_][\w$_]*$/i.test(key) ? key : JSON.stringify(key);
	          pairs.push(keyEscaped + ': ' + friendlyStringify(obj[key]));
	        }
	      }
	      return '{' + pairs.join(', ') + '}';
	    }
	  } else if (typeof obj === 'string') {
	    return JSON.stringify(obj);
	  } else if (typeof obj === 'function') {
	    return '[function object]';
	  }
	  // Differs from JSON.stringify in that undefined because undefined and that
	  // inf and nan don't become null
	  return String(obj);
	}
	
	var styleMutationWarning = {};
	
	function checkAndWarnForMutatedStyle(style1, style2, component) {
	  if (style1 == null || style2 == null) {
	    return;
	  }
	  if (shallowEqual(style1, style2)) {
	    return;
	  }
	
	  var componentName = component._tag;
	  var owner = component._currentElement._owner;
	  var ownerName;
	  if (owner) {
	    ownerName = owner.getName();
	  }
	
	  var hash = ownerName + '|' + componentName;
	
	  if (styleMutationWarning.hasOwnProperty(hash)) {
	    return;
	  }
	
	  styleMutationWarning[hash] = true;
	
	   false ? warning(false, '`%s` was passed a style object that has previously been mutated. ' + 'Mutating `style` is deprecated. Consider cloning it beforehand. Check ' + 'the `render` %s. Previous style: %s. Mutated style: %s.', componentName, owner ? 'of `' + ownerName + '`' : 'using <' + componentName + '>', friendlyStringify(style1), friendlyStringify(style2)) : void 0;
	}
	
	/**
	 * @param {object} component
	 * @param {?object} props
	 */
	function assertValidProps(component, props) {
	  if (!props) {
	    return;
	  }
	  // Note the use of `==` which checks for null or undefined.
	  if (voidElementTags[component._tag]) {
	    !(props.children == null && props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '%s is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`.%s', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : _prodInvariant('137', component._tag, component._currentElement._owner ? ' Check the render method of ' + component._currentElement._owner.getName() + '.' : '') : void 0;
	  }
	  if (props.dangerouslySetInnerHTML != null) {
	    !(props.children == null) ?  false ? invariant(false, 'Can only set one of `children` or `props.dangerouslySetInnerHTML`.') : _prodInvariant('60') : void 0;
	    !(typeof props.dangerouslySetInnerHTML === 'object' && HTML in props.dangerouslySetInnerHTML) ?  false ? invariant(false, '`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://fb.me/react-invariant-dangerously-set-inner-html for more information.') : _prodInvariant('61') : void 0;
	  }
	  if (false) {
	    process.env.NODE_ENV !== 'production' ? warning(props.innerHTML == null, 'Directly setting property `innerHTML` is not permitted. ' + 'For more information, lookup documentation on `dangerouslySetInnerHTML`.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.suppressContentEditableWarning || !props.contentEditable || props.children == null, 'A component is `contentEditable` and contains `children` managed by ' + 'React. It is now your responsibility to guarantee that none of ' + 'those nodes are unexpectedly modified or duplicated. This is ' + 'probably not intentional.') : void 0;
	    process.env.NODE_ENV !== 'production' ? warning(props.onFocusIn == null && props.onFocusOut == null, 'React uses onFocus and onBlur instead of onFocusIn and onFocusOut. ' + 'All React events are normalized to bubble, so onFocusIn and onFocusOut ' + 'are not needed/supported by React.') : void 0;
	  }
	  !(props.style == null || typeof props.style === 'object') ?  false ? invariant(false, 'The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + \'em\'}} when using JSX.%s', getDeclarationErrorAddendum(component)) : _prodInvariant('62', getDeclarationErrorAddendum(component)) : void 0;
	}
	
	function enqueuePutListener(inst, registrationName, listener, transaction) {
	  if (transaction instanceof ReactServerRenderingTransaction) {
	    return;
	  }
	  if (false) {
	    // IE8 has no API for event capturing and the `onScroll` event doesn't
	    // bubble.
	    process.env.NODE_ENV !== 'production' ? warning(registrationName !== 'onScroll' || isEventSupported('scroll', true), "This browser doesn't support the `onScroll` event") : void 0;
	  }
	  var containerInfo = inst._hostContainerInfo;
	  var isDocumentFragment = containerInfo._node && containerInfo._node.nodeType === DOC_FRAGMENT_TYPE;
	  var doc = isDocumentFragment ? containerInfo._node : containerInfo._ownerDocument;
	  listenTo(registrationName, doc);
	  transaction.getReactMountReady().enqueue(putListener, {
	    inst: inst,
	    registrationName: registrationName,
	    listener: listener
	  });
	}
	
	function putListener() {
	  var listenerToPut = this;
	  EventPluginHub.putListener(listenerToPut.inst, listenerToPut.registrationName, listenerToPut.listener);
	}
	
	function inputPostMount() {
	  var inst = this;
	  ReactDOMInput.postMountWrapper(inst);
	}
	
	function textareaPostMount() {
	  var inst = this;
	  ReactDOMTextarea.postMountWrapper(inst);
	}
	
	function optionPostMount() {
	  var inst = this;
	  ReactDOMOption.postMountWrapper(inst);
	}
	
	var setAndValidateContentChildDev = emptyFunction;
	if (false) {
	  setAndValidateContentChildDev = function (content) {
	    var hasExistingContent = this._contentDebugID != null;
	    var debugID = this._debugID;
	    // This ID represents the inlined child that has no backing instance:
	    var contentDebugID = -debugID;
	
	    if (content == null) {
	      if (hasExistingContent) {
	        ReactInstrumentation.debugTool.onUnmountComponent(this._contentDebugID);
	      }
	      this._contentDebugID = null;
	      return;
	    }
	
	    validateDOMNesting(null, String(content), this, this._ancestorInfo);
	    this._contentDebugID = contentDebugID;
	    if (hasExistingContent) {
	      ReactInstrumentation.debugTool.onBeforeUpdateComponent(contentDebugID, content);
	      ReactInstrumentation.debugTool.onUpdateComponent(contentDebugID);
	    } else {
	      ReactInstrumentation.debugTool.onBeforeMountComponent(contentDebugID, content, debugID);
	      ReactInstrumentation.debugTool.onMountComponent(contentDebugID);
	      ReactInstrumentation.debugTool.onSetChildren(debugID, [contentDebugID]);
	    }
	  };
	}
	
	// There are so many media events, it makes sense to just
	// maintain a list rather than create a `trapBubbledEvent` for each
	var mediaEvents = {
	  topAbort: 'abort',
	  topCanPlay: 'canplay',
	  topCanPlayThrough: 'canplaythrough',
	  topDurationChange: 'durationchange',
	  topEmptied: 'emptied',
	  topEncrypted: 'encrypted',
	  topEnded: 'ended',
	  topError: 'error',
	  topLoadedData: 'loadeddata',
	  topLoadedMetadata: 'loadedmetadata',
	  topLoadStart: 'loadstart',
	  topPause: 'pause',
	  topPlay: 'play',
	  topPlaying: 'playing',
	  topProgress: 'progress',
	  topRateChange: 'ratechange',
	  topSeeked: 'seeked',
	  topSeeking: 'seeking',
	  topStalled: 'stalled',
	  topSuspend: 'suspend',
	  topTimeUpdate: 'timeupdate',
	  topVolumeChange: 'volumechange',
	  topWaiting: 'waiting'
	};
	
	function trackInputValue() {
	  inputValueTracking.track(this);
	}
	
	function trapBubbledEventsLocal() {
	  var inst = this;
	  // If a component renders to null or if another component fatals and causes
	  // the state of the tree to be corrupted, `node` here can be null.
	  !inst._rootNodeID ?  false ? invariant(false, 'Must be mounted to trap events') : _prodInvariant('63') : void 0;
	  var node = getNode(inst);
	  !node ?  false ? invariant(false, 'trapBubbledEvent(...): Requires node to be rendered.') : _prodInvariant('64') : void 0;
	
	  switch (inst._tag) {
	    case 'iframe':
	    case 'object':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'video':
	    case 'audio':
	      inst._wrapperState.listeners = [];
	      // Create listener for each media event
	      for (var event in mediaEvents) {
	        if (mediaEvents.hasOwnProperty(event)) {
	          inst._wrapperState.listeners.push(ReactBrowserEventEmitter.trapBubbledEvent(event, mediaEvents[event], node));
	        }
	      }
	      break;
	    case 'source':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node)];
	      break;
	    case 'img':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topError', 'error', node), ReactBrowserEventEmitter.trapBubbledEvent('topLoad', 'load', node)];
	      break;
	    case 'form':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topReset', 'reset', node), ReactBrowserEventEmitter.trapBubbledEvent('topSubmit', 'submit', node)];
	      break;
	    case 'input':
	    case 'select':
	    case 'textarea':
	      inst._wrapperState.listeners = [ReactBrowserEventEmitter.trapBubbledEvent('topInvalid', 'invalid', node)];
	      break;
	  }
	}
	
	function postUpdateSelectWrapper() {
	  ReactDOMSelect.postUpdateWrapper(this);
	}
	
	// For HTML, certain tags should omit their close tag. We keep a whitelist for
	// those special-case tags.
	
	var omittedCloseTags = {
	  area: true,
	  base: true,
	  br: true,
	  col: true,
	  embed: true,
	  hr: true,
	  img: true,
	  input: true,
	  keygen: true,
	  link: true,
	  meta: true,
	  param: true,
	  source: true,
	  track: true,
	  wbr: true
	  // NOTE: menuitem's close tag should be omitted, but that causes problems.
	};
	
	var newlineEatingTags = {
	  listing: true,
	  pre: true,
	  textarea: true
	};
	
	// For HTML, certain tags cannot have children. This has the same purpose as
	// `omittedCloseTags` except that `menuitem` should still have its closing tag.
	
	var voidElementTags = _assign({
	  menuitem: true
	}, omittedCloseTags);
	
	// We accept any tag to be rendered but since this gets injected into arbitrary
	// HTML, we want to make sure that it's a safe tag.
	// http://www.w3.org/TR/REC-xml/#NT-Name
	
	var VALID_TAG_REGEX = /^[a-zA-Z][a-zA-Z:_\.\-\d]*$/; // Simplified subset
	var validatedTagCache = {};
	var hasOwnProperty = {}.hasOwnProperty;
	
	function validateDangerousTag(tag) {
	  if (!hasOwnProperty.call(validatedTagCache, tag)) {
	    !VALID_TAG_REGEX.test(tag) ?  false ? invariant(false, 'Invalid tag: %s', tag) : _prodInvariant('65', tag) : void 0;
	    validatedTagCache[tag] = true;
	  }
	}
	
	function isCustomComponent(tagName, props) {
	  return tagName.indexOf('-') >= 0 || props.is != null;
	}
	
	var globalIdCounter = 1;
	
	/**
	 * Creates a new React class that is idempotent and capable of containing other
	 * React components. It accepts event listeners and DOM properties that are
	 * valid according to `DOMProperty`.
	 *
	 *  - Event listeners: `onClick`, `onMouseDown`, etc.
	 *  - DOM properties: `className`, `name`, `title`, etc.
	 *
	 * The `style` property functions differently from the DOM API. It accepts an
	 * object mapping of style properties to values.
	 *
	 * @constructor ReactDOMComponent
	 * @extends ReactMultiChild
	 */
	function ReactDOMComponent(element) {
	  var tag = element.type;
	  validateDangerousTag(tag);
	  this._currentElement = element;
	  this._tag = tag.toLowerCase();
	  this._namespaceURI = null;
	  this._renderedChildren = null;
	  this._previousStyle = null;
	  this._previousStyleCopy = null;
	  this._hostNode = null;
	  this._hostParent = null;
	  this._rootNodeID = 0;
	  this._domID = 0;
	  this._hostContainerInfo = null;
	  this._wrapperState = null;
	  this._topLevelWrapper = null;
	  this._flags = 0;
	  if (false) {
	    this._ancestorInfo = null;
	    setAndValidateContentChildDev.call(this, null);
	  }
	}
	
	ReactDOMComponent.displayName = 'ReactDOMComponent';
	
	ReactDOMComponent.Mixin = {
	  /**
	   * Generates root tag markup then recurses. This method has side effects and
	   * is not idempotent.
	   *
	   * @internal
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {?ReactDOMComponent} the parent component instance
	   * @param {?object} info about the host container
	   * @param {object} context
	   * @return {string} The computed markup.
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    this._rootNodeID = globalIdCounter++;
	    this._domID = hostContainerInfo._idCounter++;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var props = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        this._wrapperState = {
	          listeners: null
	        };
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'input':
	        ReactDOMInput.mountWrapper(this, props, hostParent);
	        props = ReactDOMInput.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'option':
	        ReactDOMOption.mountWrapper(this, props, hostParent);
	        props = ReactDOMOption.getHostProps(this, props);
	        break;
	      case 'select':
	        ReactDOMSelect.mountWrapper(this, props, hostParent);
	        props = ReactDOMSelect.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.mountWrapper(this, props, hostParent);
	        props = ReactDOMTextarea.getHostProps(this, props);
	        transaction.getReactMountReady().enqueue(trackInputValue, this);
	        transaction.getReactMountReady().enqueue(trapBubbledEventsLocal, this);
	        break;
	    }
	
	    assertValidProps(this, props);
	
	    // We create tags in the namespace of their parent container, except HTML
	    // tags get no namespace.
	    var namespaceURI;
	    var parentTag;
	    if (hostParent != null) {
	      namespaceURI = hostParent._namespaceURI;
	      parentTag = hostParent._tag;
	    } else if (hostContainerInfo._tag) {
	      namespaceURI = hostContainerInfo._namespaceURI;
	      parentTag = hostContainerInfo._tag;
	    }
	    if (namespaceURI == null || namespaceURI === DOMNamespaces.svg && parentTag === 'foreignobject') {
	      namespaceURI = DOMNamespaces.html;
	    }
	    if (namespaceURI === DOMNamespaces.html) {
	      if (this._tag === 'svg') {
	        namespaceURI = DOMNamespaces.svg;
	      } else if (this._tag === 'math') {
	        namespaceURI = DOMNamespaces.mathml;
	      }
	    }
	    this._namespaceURI = namespaceURI;
	
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo._tag) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(this._tag, null, this, parentInfo);
	      }
	      this._ancestorInfo = validateDOMNesting.updatedAncestorInfo(parentInfo, this._tag, this);
	    }
	
	    var mountImage;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var el;
	      if (namespaceURI === DOMNamespaces.html) {
	        if (this._tag === 'script') {
	          // Create the script via .innerHTML so its "parser-inserted" flag is
	          // set to true and it does not execute
	          var div = ownerDocument.createElement('div');
	          var type = this._currentElement.type;
	          div.innerHTML = '<' + type + '></' + type + '>';
	          el = div.removeChild(div.firstChild);
	        } else if (props.is) {
	          el = ownerDocument.createElement(this._currentElement.type, props.is);
	        } else {
	          // Separate else branch instead of using `props.is || undefined` above becuase of a Firefox bug.
	          // See discussion in https://github.com/facebook/react/pull/6896
	          // and discussion in https://bugzilla.mozilla.org/show_bug.cgi?id=1276240
	          el = ownerDocument.createElement(this._currentElement.type);
	        }
	      } else {
	        el = ownerDocument.createElementNS(namespaceURI, this._currentElement.type);
	      }
	      ReactDOMComponentTree.precacheNode(this, el);
	      this._flags |= Flags.hasCachedChildNodes;
	      if (!this._hostParent) {
	        DOMPropertyOperations.setAttributeForRoot(el);
	      }
	      this._updateDOMProperties(null, props, transaction);
	      var lazyTree = DOMLazyTree(el);
	      this._createInitialChildren(transaction, props, context, lazyTree);
	      mountImage = lazyTree;
	    } else {
	      var tagOpen = this._createOpenTagMarkupAndPutListeners(transaction, props);
	      var tagContent = this._createContentMarkup(transaction, props, context);
	      if (!tagContent && omittedCloseTags[this._tag]) {
	        mountImage = tagOpen + '/>';
	      } else {
	        mountImage = tagOpen + '>' + tagContent + '</' + this._currentElement.type + '>';
	      }
	    }
	
	    switch (this._tag) {
	      case 'input':
	        transaction.getReactMountReady().enqueue(inputPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'textarea':
	        transaction.getReactMountReady().enqueue(textareaPostMount, this);
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'select':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'button':
	        if (props.autoFocus) {
	          transaction.getReactMountReady().enqueue(AutoFocusUtils.focusDOMComponent, this);
	        }
	        break;
	      case 'option':
	        transaction.getReactMountReady().enqueue(optionPostMount, this);
	        break;
	    }
	
	    return mountImage;
	  },
	
	  /**
	   * Creates markup for the open tag and all attributes.
	   *
	   * This method has side effects because events get registered.
	   *
	   * Iterating over object properties is faster than iterating over arrays.
	   * @see http://jsperf.com/obj-vs-arr-iteration
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @return {string} Markup of opening tag.
	   */
	  _createOpenTagMarkupAndPutListeners: function (transaction, props) {
	    var ret = '<' + this._currentElement.type;
	
	    for (var propKey in props) {
	      if (!props.hasOwnProperty(propKey)) {
	        continue;
	      }
	      var propValue = props[propKey];
	      if (propValue == null) {
	        continue;
	      }
	      if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (propValue) {
	          enqueuePutListener(this, propKey, propValue, transaction);
	        }
	      } else {
	        if (propKey === STYLE) {
	          if (propValue) {
	            if (false) {
	              // See `_updateDOMProperties`. style block
	              this._previousStyle = propValue;
	            }
	            propValue = this._previousStyleCopy = _assign({}, props.style);
	          }
	          propValue = CSSPropertyOperations.createMarkupForStyles(propValue, this);
	        }
	        var markup = null;
	        if (this._tag != null && isCustomComponent(this._tag, props)) {
	          if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	            markup = DOMPropertyOperations.createMarkupForCustomAttribute(propKey, propValue);
	          }
	        } else {
	          markup = DOMPropertyOperations.createMarkupForProperty(propKey, propValue);
	        }
	        if (markup) {
	          ret += ' ' + markup;
	        }
	      }
	    }
	
	    // For static pages, no need to put React ID and checksum. Saves lots of
	    // bytes.
	    if (transaction.renderToStaticMarkup) {
	      return ret;
	    }
	
	    if (!this._hostParent) {
	      ret += ' ' + DOMPropertyOperations.createMarkupForRoot();
	    }
	    ret += ' ' + DOMPropertyOperations.createMarkupForID(this._domID);
	    return ret;
	  },
	
	  /**
	   * Creates markup for the content between the tags.
	   *
	   * @private
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} props
	   * @param {object} context
	   * @return {string} Content markup.
	   */
	  _createContentMarkup: function (transaction, props, context) {
	    var ret = '';
	
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        ret = innerHTML.__html;
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      if (contentToUse != null) {
	        // TODO: Validate that text is allowed as a child of this node
	        ret = escapeTextContentForBrowser(contentToUse);
	        if (false) {
	          setAndValidateContentChildDev.call(this, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        ret = mountImages.join('');
	      }
	    }
	    if (newlineEatingTags[this._tag] && ret.charAt(0) === '\n') {
	      // text/html ignores the first character in these tags if it's a newline
	      // Prefer to break application/xml over text/html (for now) by adding
	      // a newline specifically to get eaten by the parser. (Alternately for
	      // textareas, replacing "^\n" with "\r\n" doesn't get eaten, and the first
	      // \r is normalized out by HTMLTextAreaElement#value.)
	      // See: <http://www.w3.org/TR/html-polyglot/#newlines-in-textarea-and-pre>
	      // See: <http://www.w3.org/TR/html5/syntax.html#element-restrictions>
	      // See: <http://www.w3.org/TR/html5/syntax.html#newlines>
	      // See: Parsing of "textarea" "listing" and "pre" elements
	      //  from <http://www.w3.org/TR/html5/syntax.html#parsing-main-inbody>
	      return '\n' + ret;
	    } else {
	      return ret;
	    }
	  },
	
	  _createInitialChildren: function (transaction, props, context, lazyTree) {
	    // Intentional use of != to avoid catching zero/false.
	    var innerHTML = props.dangerouslySetInnerHTML;
	    if (innerHTML != null) {
	      if (innerHTML.__html != null) {
	        DOMLazyTree.queueHTML(lazyTree, innerHTML.__html);
	      }
	    } else {
	      var contentToUse = CONTENT_TYPES[typeof props.children] ? props.children : null;
	      var childrenToUse = contentToUse != null ? null : props.children;
	      // TODO: Validate that text is allowed as a child of this node
	      if (contentToUse != null) {
	        // Avoid setting textContent when the text is empty. In IE11 setting
	        // textContent on a text area will cause the placeholder to not
	        // show within the textarea until it has been focused and blurred again.
	        // https://github.com/facebook/react/issues/6731#issuecomment-254874553
	        if (contentToUse !== '') {
	          if (false) {
	            setAndValidateContentChildDev.call(this, contentToUse);
	          }
	          DOMLazyTree.queueText(lazyTree, contentToUse);
	        }
	      } else if (childrenToUse != null) {
	        var mountImages = this.mountChildren(childrenToUse, transaction, context);
	        for (var i = 0; i < mountImages.length; i++) {
	          DOMLazyTree.queueChild(lazyTree, mountImages[i]);
	        }
	      }
	    }
	  },
	
	  /**
	   * Receives a next element and updates the component.
	   *
	   * @internal
	   * @param {ReactElement} nextElement
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @param {object} context
	   */
	  receiveComponent: function (nextElement, transaction, context) {
	    var prevElement = this._currentElement;
	    this._currentElement = nextElement;
	    this.updateComponent(transaction, prevElement, nextElement, context);
	  },
	
	  /**
	   * Updates a DOM component after it has already been allocated and
	   * attached to the DOM. Reconciles the root DOM node, then recurses.
	   *
	   * @param {ReactReconcileTransaction} transaction
	   * @param {ReactElement} prevElement
	   * @param {ReactElement} nextElement
	   * @internal
	   * @overridable
	   */
	  updateComponent: function (transaction, prevElement, nextElement, context) {
	    var lastProps = prevElement.props;
	    var nextProps = this._currentElement.props;
	
	    switch (this._tag) {
	      case 'input':
	        lastProps = ReactDOMInput.getHostProps(this, lastProps);
	        nextProps = ReactDOMInput.getHostProps(this, nextProps);
	        break;
	      case 'option':
	        lastProps = ReactDOMOption.getHostProps(this, lastProps);
	        nextProps = ReactDOMOption.getHostProps(this, nextProps);
	        break;
	      case 'select':
	        lastProps = ReactDOMSelect.getHostProps(this, lastProps);
	        nextProps = ReactDOMSelect.getHostProps(this, nextProps);
	        break;
	      case 'textarea':
	        lastProps = ReactDOMTextarea.getHostProps(this, lastProps);
	        nextProps = ReactDOMTextarea.getHostProps(this, nextProps);
	        break;
	    }
	
	    assertValidProps(this, nextProps);
	    this._updateDOMProperties(lastProps, nextProps, transaction);
	    this._updateDOMChildren(lastProps, nextProps, transaction, context);
	
	    switch (this._tag) {
	      case 'input':
	        // Update the wrapper around inputs *after* updating props. This has to
	        // happen after `_updateDOMProperties`. Otherwise HTML5 input validations
	        // raise warnings and prevent the new value from being assigned.
	        ReactDOMInput.updateWrapper(this);
	
	        // We also check that we haven't missed a value update, such as a
	        // Radio group shifting the checked value to another named radio input.
	        inputValueTracking.updateValueIfChanged(this);
	        break;
	      case 'textarea':
	        ReactDOMTextarea.updateWrapper(this);
	        break;
	      case 'select':
	        // <select> value update needs to occur after <option> children
	        // reconciliation
	        transaction.getReactMountReady().enqueue(postUpdateSelectWrapper, this);
	        break;
	    }
	  },
	
	  /**
	   * Reconciles the properties by detecting differences in property values and
	   * updating the DOM as necessary. This function is probably the single most
	   * critical path for performance optimization.
	   *
	   * TODO: Benchmark whether checking for changed values in memory actually
	   *       improves performance (especially statically positioned elements).
	   * TODO: Benchmark the effects of putting this at the top since 99% of props
	   *       do not change for a given reconciliation.
	   * TODO: Benchmark areas that can be improved with caching.
	   *
	   * @private
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {?DOMElement} node
	   */
	  _updateDOMProperties: function (lastProps, nextProps, transaction) {
	    var propKey;
	    var styleName;
	    var styleUpdates;
	    for (propKey in lastProps) {
	      if (nextProps.hasOwnProperty(propKey) || !lastProps.hasOwnProperty(propKey) || lastProps[propKey] == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        var lastStyle = this._previousStyleCopy;
	        for (styleName in lastStyle) {
	          if (lastStyle.hasOwnProperty(styleName)) {
	            styleUpdates = styleUpdates || {};
	            styleUpdates[styleName] = '';
	          }
	        }
	        this._previousStyleCopy = null;
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (lastProps[propKey]) {
	          // Only call deleteListener if there was a listener previously or
	          // else willDeleteListener gets called when there wasn't actually a
	          // listener (e.g., onClick={null})
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, lastProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.deleteValueForAttribute(getNode(this), propKey);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        DOMPropertyOperations.deleteValueForProperty(getNode(this), propKey);
	      }
	    }
	    for (propKey in nextProps) {
	      var nextProp = nextProps[propKey];
	      var lastProp = propKey === STYLE ? this._previousStyleCopy : lastProps != null ? lastProps[propKey] : undefined;
	      if (!nextProps.hasOwnProperty(propKey) || nextProp === lastProp || nextProp == null && lastProp == null) {
	        continue;
	      }
	      if (propKey === STYLE) {
	        if (nextProp) {
	          if (false) {
	            checkAndWarnForMutatedStyle(this._previousStyleCopy, this._previousStyle, this);
	            this._previousStyle = nextProp;
	          }
	          nextProp = this._previousStyleCopy = _assign({}, nextProp);
	        } else {
	          this._previousStyleCopy = null;
	        }
	        if (lastProp) {
	          // Unset styles on `lastProp` but not on `nextProp`.
	          for (styleName in lastProp) {
	            if (lastProp.hasOwnProperty(styleName) && (!nextProp || !nextProp.hasOwnProperty(styleName))) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = '';
	            }
	          }
	          // Update styles that changed since `lastProp`.
	          for (styleName in nextProp) {
	            if (nextProp.hasOwnProperty(styleName) && lastProp[styleName] !== nextProp[styleName]) {
	              styleUpdates = styleUpdates || {};
	              styleUpdates[styleName] = nextProp[styleName];
	            }
	          }
	        } else {
	          // Relies on `updateStylesByID` not mutating `styleUpdates`.
	          styleUpdates = nextProp;
	        }
	      } else if (registrationNameModules.hasOwnProperty(propKey)) {
	        if (nextProp) {
	          enqueuePutListener(this, propKey, nextProp, transaction);
	        } else if (lastProp) {
	          deleteListener(this, propKey);
	        }
	      } else if (isCustomComponent(this._tag, nextProps)) {
	        if (!RESERVED_PROPS.hasOwnProperty(propKey)) {
	          DOMPropertyOperations.setValueForAttribute(getNode(this), propKey, nextProp);
	        }
	      } else if (DOMProperty.properties[propKey] || DOMProperty.isCustomAttribute(propKey)) {
	        var node = getNode(this);
	        // If we're updating to null or undefined, we should remove the property
	        // from the DOM node instead of inadvertently setting to a string. This
	        // brings us in line with the same behavior we have on initial render.
	        if (nextProp != null) {
	          DOMPropertyOperations.setValueForProperty(node, propKey, nextProp);
	        } else {
	          DOMPropertyOperations.deleteValueForProperty(node, propKey);
	        }
	      }
	    }
	    if (styleUpdates) {
	      CSSPropertyOperations.setValueForStyles(getNode(this), styleUpdates, this);
	    }
	  },
	
	  /**
	   * Reconciles the children with the various properties that affect the
	   * children content.
	   *
	   * @param {object} lastProps
	   * @param {object} nextProps
	   * @param {ReactReconcileTransaction} transaction
	   * @param {object} context
	   */
	  _updateDOMChildren: function (lastProps, nextProps, transaction, context) {
	    var lastContent = CONTENT_TYPES[typeof lastProps.children] ? lastProps.children : null;
	    var nextContent = CONTENT_TYPES[typeof nextProps.children] ? nextProps.children : null;
	
	    var lastHtml = lastProps.dangerouslySetInnerHTML && lastProps.dangerouslySetInnerHTML.__html;
	    var nextHtml = nextProps.dangerouslySetInnerHTML && nextProps.dangerouslySetInnerHTML.__html;
	
	    // Note the use of `!=` which checks for null or undefined.
	    var lastChildren = lastContent != null ? null : lastProps.children;
	    var nextChildren = nextContent != null ? null : nextProps.children;
	
	    // If we're switching from children to content/html or vice versa, remove
	    // the old content
	    var lastHasContentOrHtml = lastContent != null || lastHtml != null;
	    var nextHasContentOrHtml = nextContent != null || nextHtml != null;
	    if (lastChildren != null && nextChildren == null) {
	      this.updateChildren(null, transaction, context);
	    } else if (lastHasContentOrHtml && !nextHasContentOrHtml) {
	      this.updateTextContent('');
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    }
	
	    if (nextContent != null) {
	      if (lastContent !== nextContent) {
	        this.updateTextContent('' + nextContent);
	        if (false) {
	          setAndValidateContentChildDev.call(this, nextContent);
	        }
	      }
	    } else if (nextHtml != null) {
	      if (lastHtml !== nextHtml) {
	        this.updateMarkup('' + nextHtml);
	      }
	      if (false) {
	        ReactInstrumentation.debugTool.onSetChildren(this._debugID, []);
	      }
	    } else if (nextChildren != null) {
	      if (false) {
	        setAndValidateContentChildDev.call(this, null);
	      }
	
	      this.updateChildren(nextChildren, transaction, context);
	    }
	  },
	
	  getHostNode: function () {
	    return getNode(this);
	  },
	
	  /**
	   * Destroys all event registrations for this instance. Does not remove from
	   * the DOM. That must be done by the parent.
	   *
	   * @internal
	   */
	  unmountComponent: function (safely) {
	    switch (this._tag) {
	      case 'audio':
	      case 'form':
	      case 'iframe':
	      case 'img':
	      case 'link':
	      case 'object':
	      case 'source':
	      case 'video':
	        var listeners = this._wrapperState.listeners;
	        if (listeners) {
	          for (var i = 0; i < listeners.length; i++) {
	            listeners[i].remove();
	          }
	        }
	        break;
	      case 'input':
	      case 'textarea':
	        inputValueTracking.stopTracking(this);
	        break;
	      case 'html':
	      case 'head':
	      case 'body':
	        /**
	         * Components like <html> <head> and <body> can't be removed or added
	         * easily in a cross-browser way, however it's valuable to be able to
	         * take advantage of React's reconciliation for styling and <title>
	         * management. So we just document it and throw in dangerous cases.
	         */
	         true ?  false ? invariant(false, '<%s> tried to unmount. Because of cross-browser quirks it is impossible to unmount some top-level components (eg <html>, <head>, and <body>) reliably and efficiently. To fix this, have a single top-level component that never unmounts render these elements.', this._tag) : _prodInvariant('66', this._tag) : void 0;
	        break;
	    }
	
	    this.unmountChildren(safely);
	    ReactDOMComponentTree.uncacheNode(this);
	    EventPluginHub.deleteAllListeners(this);
	    this._rootNodeID = 0;
	    this._domID = 0;
	    this._wrapperState = null;
	
	    if (false) {
	      setAndValidateContentChildDev.call(this, null);
	    }
	  },
	
	  getPublicInstance: function () {
	    return getNode(this);
	  }
	};
	
	_assign(ReactDOMComponent.prototype, ReactDOMComponent.Mixin, ReactMultiChild.Mixin);
	
	module.exports = ReactDOMComponent;

/***/ },
/* 1868 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var validateDOMNesting = __webpack_require__(240);
	
	var DOC_NODE_TYPE = 9;
	
	function ReactDOMContainerInfo(topLevelWrapper, node) {
	  var info = {
	    _topLevelWrapper: topLevelWrapper,
	    _idCounter: 1,
	    _ownerDocument: node ? node.nodeType === DOC_NODE_TYPE ? node : node.ownerDocument : null,
	    _node: node,
	    _tag: node ? node.nodeName.toLowerCase() : null,
	    _namespaceURI: node ? node.namespaceURI : null
	  };
	  if (false) {
	    info._ancestorInfo = node ? validateDOMNesting.updatedAncestorInfo(null, info._tag, null) : null;
	  }
	  return info;
	}
	
	module.exports = ReactDOMContainerInfo;

/***/ },
/* 1869 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var DOMLazyTree = __webpack_require__(88);
	var ReactDOMComponentTree = __webpack_require__(20);
	
	var ReactDOMEmptyComponent = function (instantiate) {
	  // ReactCompositeComponent uses this:
	  this._currentElement = null;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	  this._hostContainerInfo = null;
	  this._domID = 0;
	};
	_assign(ReactDOMEmptyComponent.prototype, {
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    var domID = hostContainerInfo._idCounter++;
	    this._domID = domID;
	    this._hostParent = hostParent;
	    this._hostContainerInfo = hostContainerInfo;
	
	    var nodeValue = ' react-empty: ' + this._domID + ' ';
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var node = ownerDocument.createComment(nodeValue);
	      ReactDOMComponentTree.precacheNode(this, node);
	      return DOMLazyTree(node);
	    } else {
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd insert a comment node, but since this is a situation
	        // where React won't take over (static pages), we can simply return
	        // nothing.
	        return '';
	      }
	      return '<!--' + nodeValue + '-->';
	    }
	  },
	  receiveComponent: function () {},
	  getHostNode: function () {
	    return ReactDOMComponentTree.getNodeFromInstance(this);
	  },
	  unmountComponent: function () {
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMEmptyComponent;

/***/ },
/* 1870 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactDOMFeatureFlags = {
	  useCreateElement: true,
	  useFiber: false
	};
	
	module.exports = ReactDOMFeatureFlags;

/***/ },
/* 1871 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMChildrenOperations = __webpack_require__(225);
	var ReactDOMComponentTree = __webpack_require__(20);
	
	/**
	 * Operations used to process updates to DOM nodes.
	 */
	var ReactDOMIDOperations = {
	  /**
	   * Updates a component's children by processing a series of updates.
	   *
	   * @param {array<object>} updates List of update configurations.
	   * @internal
	   */
	  dangerouslyProcessChildrenUpdates: function (parentInst, updates) {
	    var node = ReactDOMComponentTree.getNodeFromInstance(parentInst);
	    DOMChildrenOperations.processUpdates(node, updates);
	  }
	};
	
	module.exports = ReactDOMIDOperations;

/***/ },
/* 1872 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var DOMPropertyOperations = __webpack_require__(396);
	var LinkedValueUtils = __webpack_require__(229);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(42);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(16);
	
	var didWarnValueLink = false;
	var didWarnCheckedLink = false;
	var didWarnValueDefaultValue = false;
	var didWarnCheckedDefaultChecked = false;
	var didWarnControlledToUncontrolled = false;
	var didWarnUncontrolledToControlled = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMInput.updateWrapper(this);
	  }
	}
	
	function isControlled(props) {
	  var usesChecked = props.type === 'checkbox' || props.type === 'radio';
	  return usesChecked ? props.checked != null : props.value != null;
	}
	
	/**
	 * Implements an <input> host component that allows setting these optional
	 * props: `checked`, `value`, `defaultChecked`, and `defaultValue`.
	 *
	 * If `checked` or `value` are not supplied (or null/undefined), user actions
	 * that affect the checked state or value will trigger updates to the element.
	 *
	 * If they are supplied (and not null/undefined), the rendered element will not
	 * trigger updates to the element. Instead, the props must change in order for
	 * the rendered element to be updated.
	 *
	 * The rendered element will be initialized as unchecked (or `defaultChecked`)
	 * with an empty value (or `defaultValue`).
	 *
	 * @see http://www.w3.org/TR/2012/WD-html5-20121025/the-input-element.html
	 */
	var ReactDOMInput = {
	  getHostProps: function (inst, props) {
	    var value = LinkedValueUtils.getValue(props);
	    var checked = LinkedValueUtils.getChecked(props);
	
	    var hostProps = _assign({
	      // Make sure we set .type before any other properties (setting .value
	      // before .type means .value is lost in IE11 and below)
	      type: undefined,
	      // Make sure we set .step before .value (setting .value before .step
	      // means .value is rounded on mount, based upon step precision)
	      step: undefined,
	      // Make sure we set .min & .max before .value (to ensure proper order
	      // in corner cases such as min or max deriving from value, e.g. Issue #7170)
	      min: undefined,
	      max: undefined
	    }, props, {
	      defaultChecked: undefined,
	      defaultValue: undefined,
	      value: value != null ? value : inst._wrapperState.initialValue,
	      checked: checked != null ? checked : inst._wrapperState.initialChecked,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('input', props, inst._currentElement._owner);
	
	      var owner = inst._currentElement._owner;
	
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.checkedLink !== undefined && !didWarnCheckedLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`checkedLink` prop on `input` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnCheckedLink = true;
	      }
	      if (props.checked !== undefined && props.defaultChecked !== undefined && !didWarnCheckedDefaultChecked) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both checked and defaultChecked props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the checked prop, or the defaultChecked prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnCheckedDefaultChecked = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValueDefaultValue) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s contains an input of type %s with both value and defaultValue props. ' + 'Input elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled input ' + 'element and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnValueDefaultValue = true;
	      }
	    }
	
	    var defaultValue = props.defaultValue;
	    inst._wrapperState = {
	      initialChecked: props.checked != null ? props.checked : props.defaultChecked,
	      initialValue: props.value != null ? props.value : defaultValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst),
	      controlled: isControlled(props)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    if (false) {
	      var controlled = isControlled(props);
	      var owner = inst._currentElement._owner;
	
	      if (!inst._wrapperState.controlled && controlled && !didWarnUncontrolledToControlled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing an uncontrolled input of type %s to be controlled. ' + 'Input elements should not switch from uncontrolled to controlled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnUncontrolledToControlled = true;
	      }
	      if (inst._wrapperState.controlled && !controlled && !didWarnControlledToUncontrolled) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '%s is changing a controlled input of type %s to be uncontrolled. ' + 'Input elements should not switch from controlled to uncontrolled (or vice versa). ' + 'Decide between using a controlled or uncontrolled input ' + 'element for the lifetime of the component. More info: https://fb.me/react-controlled-components', owner && owner.getName() || 'A component', props.type) : void 0;
	        didWarnControlledToUncontrolled = true;
	      }
	    }
	
	    // TODO: Shouldn't this be getChecked(props)?
	    var checked = props.checked;
	    if (checked != null) {
	      DOMPropertyOperations.setValueForProperty(ReactDOMComponentTree.getNodeFromInstance(inst), 'checked', checked || false);
	    }
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      if (value === 0 && node.value === '') {
	        node.value = '0';
	        // Note: IE9 reports a number inputs as 'text', so check props instead.
	      } else if (props.type === 'number') {
	        // Simulate `input.valueAsNumber`. IE9 does not support it
	        var valueAsNumber = parseFloat(node.value, 10) || 0;
	
	        if (
	        // eslint-disable-next-line
	        value != valueAsNumber ||
	        // eslint-disable-next-line
	        value == valueAsNumber && node.value != value) {
	          // Cast `value` to a string to ensure the value is set correctly. While
	          // browsers typically do this as necessary, jsdom doesn't.
	          node.value = '' + value;
	        }
	      } else if (node.value !== '' + value) {
	        // Cast `value` to a string to ensure the value is set correctly. While
	        // browsers typically do this as necessary, jsdom doesn't.
	        node.value = '' + value;
	      }
	    } else {
	      if (props.value == null && props.defaultValue != null) {
	        // In Chrome, assigning defaultValue to certain input types triggers input validation.
	        // For number inputs, the display value loses trailing decimal points. For email inputs,
	        // Chrome raises "The specified value <x> is not a valid email address".
	        //
	        // Here we check to see if the defaultValue has actually changed, avoiding these problems
	        // when the user is inputting text
	        //
	        // https://github.com/facebook/react/issues/7253
	        if (node.defaultValue !== '' + props.defaultValue) {
	          node.defaultValue = '' + props.defaultValue;
	        }
	      }
	      if (props.checked == null && props.defaultChecked != null) {
	        node.defaultChecked = !!props.defaultChecked;
	      }
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	
	    // Detach value from defaultValue. We won't do anything if we're working on
	    // submit or reset inputs as those values & defaultValues are linked. They
	    // are not resetable nodes so this operation doesn't matter and actually
	    // removes browser-default values (eg "Submit Query") when no value is
	    // provided.
	
	    switch (props.type) {
	      case 'submit':
	      case 'reset':
	        break;
	      case 'color':
	      case 'date':
	      case 'datetime':
	      case 'datetime-local':
	      case 'month':
	      case 'time':
	      case 'week':
	        // This fixes the no-show issue on iOS Safari and Android Chrome:
	        // https://github.com/facebook/react/issues/7233
	        node.value = '';
	        node.value = node.defaultValue;
	        break;
	      default:
	        node.value = node.value;
	        break;
	    }
	
	    // Normally, we'd just do `node.checked = node.checked` upon initial mount, less this bug
	    // this is needed to work around a chrome bug where setting defaultChecked
	    // will sometimes influence the value of checked (even after detachment).
	    // Reference: https://bugs.chromium.org/p/chromium/issues/detail?id=608416
	    // We need to temporarily unset name to avoid disrupting radio button groups.
	    var name = node.name;
	    if (name !== '') {
	      node.name = '';
	    }
	    node.defaultChecked = !node.defaultChecked;
	    node.defaultChecked = !node.defaultChecked;
	    if (name !== '') {
	      node.name = name;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	
	  // Here we use asap to wait until all updates have propagated, which
	  // is important when using controlled components within layers:
	  // https://github.com/facebook/react/issues/1698
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	
	  var name = props.name;
	  if (props.type === 'radio' && name != null) {
	    var rootNode = ReactDOMComponentTree.getNodeFromInstance(this);
	    var queryRoot = rootNode;
	
	    while (queryRoot.parentNode) {
	      queryRoot = queryRoot.parentNode;
	    }
	
	    // If `rootNode.form` was non-null, then we could try `form.elements`,
	    // but that sometimes behaves strangely in IE8. We could also try using
	    // `form.getElementsByName`, but that will only return direct children
	    // and won't include inputs that use the HTML5 `form=` attribute. Since
	    // the input might not even be in a form, let's just use the global
	    // `querySelectorAll` to ensure we don't miss anything.
	    var group = queryRoot.querySelectorAll('input[name=' + JSON.stringify('' + name) + '][type="radio"]');
	
	    for (var i = 0; i < group.length; i++) {
	      var otherNode = group[i];
	      if (otherNode === rootNode || otherNode.form !== rootNode.form) {
	        continue;
	      }
	      // This will throw if radio buttons rendered by different copies of React
	      // and the same name are rendered into the same form (same as #1939).
	      // That's probably okay; we don't support it just as we don't support
	      // mixing React radio buttons with non-React ones.
	      var otherInstance = ReactDOMComponentTree.getInstanceFromNode(otherNode);
	      !otherInstance ?  false ? invariant(false, 'ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported.') : _prodInvariant('90') : void 0;
	      // If this is a controlled radio button group, forcing the input that
	      // was previously checked to update will cause it to be come re-checked
	      // as appropriate.
	      ReactUpdates.asap(forceUpdateIfMounted, otherInstance);
	    }
	  }
	
	  return returnValue;
	}
	
	module.exports = ReactDOMInput;

/***/ },
/* 1873 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var React = __webpack_require__(94);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMSelect = __webpack_require__(398);
	
	var warning = __webpack_require__(16);
	var didWarnInvalidOptionChildren = false;
	
	function flattenChildren(children) {
	  var content = '';
	
	  // Flatten children and warn if they aren't strings or numbers;
	  // invalid types are ignored.
	  React.Children.forEach(children, function (child) {
	    if (child == null) {
	      return;
	    }
	    if (typeof child === 'string' || typeof child === 'number') {
	      content += child;
	    } else if (!didWarnInvalidOptionChildren) {
	      didWarnInvalidOptionChildren = true;
	       false ? warning(false, 'Only strings and numbers are supported as <option> children.') : void 0;
	    }
	  });
	
	  return content;
	}
	
	/**
	 * Implements an <option> host component that warns when `selected` is set.
	 */
	var ReactDOMOption = {
	  mountWrapper: function (inst, props, hostParent) {
	    // TODO (yungsters): Remove support for `selected` in <option>.
	    if (false) {
	      process.env.NODE_ENV !== 'production' ? warning(props.selected == null, 'Use the `defaultValue` or `value` props on <select> instead of ' + 'setting `selected` on <option>.') : void 0;
	    }
	
	    // Look up whether this option is 'selected'
	    var selectValue = null;
	    if (hostParent != null) {
	      var selectParent = hostParent;
	
	      if (selectParent._tag === 'optgroup') {
	        selectParent = selectParent._hostParent;
	      }
	
	      if (selectParent != null && selectParent._tag === 'select') {
	        selectValue = ReactDOMSelect.getSelectValueContext(selectParent);
	      }
	    }
	
	    // If the value is null (e.g., no specified value or after initial mount)
	    // or missing (e.g., for <datalist>), we don't change props.selected
	    var selected = null;
	    if (selectValue != null) {
	      var value;
	      if (props.value != null) {
	        value = props.value + '';
	      } else {
	        value = flattenChildren(props.children);
	      }
	      selected = false;
	      if (Array.isArray(selectValue)) {
	        // multiple
	        for (var i = 0; i < selectValue.length; i++) {
	          if ('' + selectValue[i] === value) {
	            selected = true;
	            break;
	          }
	        }
	      } else {
	        selected = '' + selectValue === value;
	      }
	    }
	
	    inst._wrapperState = { selected: selected };
	  },
	
	  postMountWrapper: function (inst) {
	    // value="" should make a value attribute (#6219)
	    var props = inst._currentElement.props;
	    if (props.value != null) {
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      node.setAttribute('value', props.value);
	    }
	  },
	
	  getHostProps: function (inst, props) {
	    var hostProps = _assign({ selected: undefined, children: undefined }, props);
	
	    // Read state only from initial mount because <select> updates value
	    // manually; we need the initial state only for server rendering
	    if (inst._wrapperState.selected != null) {
	      hostProps.selected = inst._wrapperState.selected;
	    }
	
	    var content = flattenChildren(props.children);
	
	    if (content) {
	      hostProps.children = content;
	    }
	
	    return hostProps;
	  }
	};
	
	module.exports = ReactDOMOption;

/***/ },
/* 1874 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	var getNodeForCharacterOffset = __webpack_require__(1912);
	var getTextContentAccessor = __webpack_require__(408);
	
	/**
	 * While `isCollapsed` is available on the Selection object and `collapsed`
	 * is available on the Range object, IE11 sometimes gets them wrong.
	 * If the anchor/focus nodes and offsets are the same, the range is collapsed.
	 */
	function isCollapsed(anchorNode, anchorOffset, focusNode, focusOffset) {
	  return anchorNode === focusNode && anchorOffset === focusOffset;
	}
	
	/**
	 * Get the appropriate anchor and focus node/offset pairs for IE.
	 *
	 * The catch here is that IE's selection API doesn't provide information
	 * about whether the selection is forward or backward, so we have to
	 * behave as though it's always forward.
	 *
	 * IE text differs from modern selection in that it behaves as though
	 * block elements end with a new line. This means character offsets will
	 * differ between the two APIs.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getIEOffsets(node) {
	  var selection = document.selection;
	  var selectedRange = selection.createRange();
	  var selectedLength = selectedRange.text.length;
	
	  // Duplicate selection so we can move range without breaking user selection.
	  var fromStart = selectedRange.duplicate();
	  fromStart.moveToElementText(node);
	  fromStart.setEndPoint('EndToStart', selectedRange);
	
	  var startOffset = fromStart.text.length;
	  var endOffset = startOffset + selectedLength;
	
	  return {
	    start: startOffset,
	    end: endOffset
	  };
	}
	
	/**
	 * @param {DOMElement} node
	 * @return {?object}
	 */
	function getModernOffsets(node) {
	  var selection = window.getSelection && window.getSelection();
	
	  if (!selection || selection.rangeCount === 0) {
	    return null;
	  }
	
	  var anchorNode = selection.anchorNode;
	  var anchorOffset = selection.anchorOffset;
	  var focusNode = selection.focusNode;
	  var focusOffset = selection.focusOffset;
	
	  var currentRange = selection.getRangeAt(0);
	
	  // In Firefox, range.startContainer and range.endContainer can be "anonymous
	  // divs", e.g. the up/down buttons on an <input type="number">. Anonymous
	  // divs do not seem to expose properties, triggering a "Permission denied
	  // error" if any of its properties are accessed. The only seemingly possible
	  // way to avoid erroring is to access a property that typically works for
	  // non-anonymous divs and catch any error that may otherwise arise. See
	  // https://bugzilla.mozilla.org/show_bug.cgi?id=208427
	  try {
	    /* eslint-disable no-unused-expressions */
	    currentRange.startContainer.nodeType;
	    currentRange.endContainer.nodeType;
	    /* eslint-enable no-unused-expressions */
	  } catch (e) {
	    return null;
	  }
	
	  // If the node and offset values are the same, the selection is collapsed.
	  // `Selection.isCollapsed` is available natively, but IE sometimes gets
	  // this value wrong.
	  var isSelectionCollapsed = isCollapsed(selection.anchorNode, selection.anchorOffset, selection.focusNode, selection.focusOffset);
	
	  var rangeLength = isSelectionCollapsed ? 0 : currentRange.toString().length;
	
	  var tempRange = currentRange.cloneRange();
	  tempRange.selectNodeContents(node);
	  tempRange.setEnd(currentRange.startContainer, currentRange.startOffset);
	
	  var isTempRangeCollapsed = isCollapsed(tempRange.startContainer, tempRange.startOffset, tempRange.endContainer, tempRange.endOffset);
	
	  var start = isTempRangeCollapsed ? 0 : tempRange.toString().length;
	  var end = start + rangeLength;
	
	  // Detect whether the selection is backward.
	  var detectionRange = document.createRange();
	  detectionRange.setStart(anchorNode, anchorOffset);
	  detectionRange.setEnd(focusNode, focusOffset);
	  var isBackward = detectionRange.collapsed;
	
	  return {
	    start: isBackward ? end : start,
	    end: isBackward ? start : end
	  };
	}
	
	/**
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setIEOffsets(node, offsets) {
	  var range = document.selection.createRange().duplicate();
	  var start, end;
	
	  if (offsets.end === undefined) {
	    start = offsets.start;
	    end = start;
	  } else if (offsets.start > offsets.end) {
	    start = offsets.end;
	    end = offsets.start;
	  } else {
	    start = offsets.start;
	    end = offsets.end;
	  }
	
	  range.moveToElementText(node);
	  range.moveStart('character', start);
	  range.setEndPoint('EndToStart', range);
	  range.moveEnd('character', end - start);
	  range.select();
	}
	
	/**
	 * In modern non-IE browsers, we can support both forward and backward
	 * selections.
	 *
	 * Note: IE10+ supports the Selection object, but it does not support
	 * the `extend` method, which means that even in modern IE, it's not possible
	 * to programmatically create a backward selection. Thus, for all IE
	 * versions, we use the old IE API to create our selections.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @param {object} offsets
	 */
	function setModernOffsets(node, offsets) {
	  if (!window.getSelection) {
	    return;
	  }
	
	  var selection = window.getSelection();
	  var length = node[getTextContentAccessor()].length;
	  var start = Math.min(offsets.start, length);
	  var end = offsets.end === undefined ? start : Math.min(offsets.end, length);
	
	  // IE 11 uses modern selection, but doesn't support the extend method.
	  // Flip backward selections, so we can set with a single range.
	  if (!selection.extend && start > end) {
	    var temp = end;
	    end = start;
	    start = temp;
	  }
	
	  var startMarker = getNodeForCharacterOffset(node, start);
	  var endMarker = getNodeForCharacterOffset(node, end);
	
	  if (startMarker && endMarker) {
	    var range = document.createRange();
	    range.setStart(startMarker.node, startMarker.offset);
	    selection.removeAllRanges();
	
	    if (start > end) {
	      selection.addRange(range);
	      selection.extend(endMarker.node, endMarker.offset);
	    } else {
	      range.setEnd(endMarker.node, endMarker.offset);
	      selection.addRange(range);
	    }
	  }
	}
	
	var useIEOffsets = ExecutionEnvironment.canUseDOM && 'selection' in document && !('getSelection' in window);
	
	var ReactDOMSelection = {
	  /**
	   * @param {DOMElement} node
	   */
	  getOffsets: useIEOffsets ? getIEOffsets : getModernOffsets,
	
	  /**
	   * @param {DOMElement|DOMTextNode} node
	   * @param {object} offsets
	   */
	  setOffsets: useIEOffsets ? setIEOffsets : setModernOffsets
	};
	
	module.exports = ReactDOMSelection;

/***/ },
/* 1875 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var DOMChildrenOperations = __webpack_require__(225);
	var DOMLazyTree = __webpack_require__(88);
	var ReactDOMComponentTree = __webpack_require__(20);
	
	var escapeTextContentForBrowser = __webpack_require__(158);
	var invariant = __webpack_require__(13);
	var validateDOMNesting = __webpack_require__(240);
	
	/**
	 * Text nodes violate a couple assumptions that React makes about components:
	 *
	 *  - When mounting text into the DOM, adjacent text nodes are merged.
	 *  - Text nodes cannot be assigned a React root ID.
	 *
	 * This component is used to wrap strings between comment nodes so that they
	 * can undergo the same reconciliation that is applied to elements.
	 *
	 * TODO: Investigate representing React components in the DOM with text nodes.
	 *
	 * @class ReactDOMTextComponent
	 * @extends ReactComponent
	 * @internal
	 */
	var ReactDOMTextComponent = function (text) {
	  // TODO: This is really a ReactText (ReactNode), not a ReactElement
	  this._currentElement = text;
	  this._stringText = '' + text;
	  // ReactDOMComponentTree uses these:
	  this._hostNode = null;
	  this._hostParent = null;
	
	  // Properties
	  this._domID = 0;
	  this._mountIndex = 0;
	  this._closingComment = null;
	  this._commentNodes = null;
	};
	
	_assign(ReactDOMTextComponent.prototype, {
	  /**
	   * Creates the markup for this text node. This node is not intended to have
	   * any features besides containing text content.
	   *
	   * @param {ReactReconcileTransaction|ReactServerRenderingTransaction} transaction
	   * @return {string} Markup for this text node.
	   * @internal
	   */
	  mountComponent: function (transaction, hostParent, hostContainerInfo, context) {
	    if (false) {
	      var parentInfo;
	      if (hostParent != null) {
	        parentInfo = hostParent._ancestorInfo;
	      } else if (hostContainerInfo != null) {
	        parentInfo = hostContainerInfo._ancestorInfo;
	      }
	      if (parentInfo) {
	        // parentInfo should always be present except for the top-level
	        // component when server rendering
	        validateDOMNesting(null, this._stringText, this, parentInfo);
	      }
	    }
	
	    var domID = hostContainerInfo._idCounter++;
	    var openingValue = ' react-text: ' + domID + ' ';
	    var closingValue = ' /react-text ';
	    this._domID = domID;
	    this._hostParent = hostParent;
	    if (transaction.useCreateElement) {
	      var ownerDocument = hostContainerInfo._ownerDocument;
	      var openingComment = ownerDocument.createComment(openingValue);
	      var closingComment = ownerDocument.createComment(closingValue);
	      var lazyTree = DOMLazyTree(ownerDocument.createDocumentFragment());
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(openingComment));
	      if (this._stringText) {
	        DOMLazyTree.queueChild(lazyTree, DOMLazyTree(ownerDocument.createTextNode(this._stringText)));
	      }
	      DOMLazyTree.queueChild(lazyTree, DOMLazyTree(closingComment));
	      ReactDOMComponentTree.precacheNode(this, openingComment);
	      this._closingComment = closingComment;
	      return lazyTree;
	    } else {
	      var escapedText = escapeTextContentForBrowser(this._stringText);
	
	      if (transaction.renderToStaticMarkup) {
	        // Normally we'd wrap this between comment nodes for the reasons stated
	        // above, but since this is a situation where React won't take over
	        // (static pages), we can simply return the text as it is.
	        return escapedText;
	      }
	
	      return '<!--' + openingValue + '-->' + escapedText + '<!--' + closingValue + '-->';
	    }
	  },
	
	  /**
	   * Updates this component by updating the text content.
	   *
	   * @param {ReactText} nextText The next text content
	   * @param {ReactReconcileTransaction} transaction
	   * @internal
	   */
	  receiveComponent: function (nextText, transaction) {
	    if (nextText !== this._currentElement) {
	      this._currentElement = nextText;
	      var nextStringText = '' + nextText;
	      if (nextStringText !== this._stringText) {
	        // TODO: Save this as pending props and use performUpdateIfNecessary
	        // and/or updateComponent to do the actual update for consistency with
	        // other component types?
	        this._stringText = nextStringText;
	        var commentNodes = this.getHostNode();
	        DOMChildrenOperations.replaceDelimitedText(commentNodes[0], commentNodes[1], nextStringText);
	      }
	    }
	  },
	
	  getHostNode: function () {
	    var hostNode = this._commentNodes;
	    if (hostNode) {
	      return hostNode;
	    }
	    if (!this._closingComment) {
	      var openingComment = ReactDOMComponentTree.getNodeFromInstance(this);
	      var node = openingComment.nextSibling;
	      while (true) {
	        !(node != null) ?  false ? invariant(false, 'Missing closing comment for text component %s', this._domID) : _prodInvariant('67', this._domID) : void 0;
	        if (node.nodeType === 8 && node.nodeValue === ' /react-text ') {
	          this._closingComment = node;
	          break;
	        }
	        node = node.nextSibling;
	      }
	    }
	    hostNode = [this._hostNode, this._closingComment];
	    this._commentNodes = hostNode;
	    return hostNode;
	  },
	
	  unmountComponent: function () {
	    this._closingComment = null;
	    this._commentNodes = null;
	    ReactDOMComponentTree.uncacheNode(this);
	  }
	});
	
	module.exports = ReactDOMTextComponent;

/***/ },
/* 1876 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17),
	    _assign = __webpack_require__(18);
	
	var LinkedValueUtils = __webpack_require__(229);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(42);
	
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(16);
	
	var didWarnValueLink = false;
	var didWarnValDefaultVal = false;
	
	function forceUpdateIfMounted() {
	  if (this._rootNodeID) {
	    // DOM component is still mounted; update
	    ReactDOMTextarea.updateWrapper(this);
	  }
	}
	
	/**
	 * Implements a <textarea> host component that allows setting `value`, and
	 * `defaultValue`. This differs from the traditional DOM API because value is
	 * usually set as PCDATA children.
	 *
	 * If `value` is not supplied (or null/undefined), user actions that affect the
	 * value will trigger updates to the element.
	 *
	 * If `value` is supplied (and not null/undefined), the rendered element will
	 * not trigger updates to the element. Instead, the `value` prop must change in
	 * order for the rendered element to be updated.
	 *
	 * The rendered element will be initialized with an empty value, the prop
	 * `defaultValue` if specified, or the children content (deprecated).
	 */
	var ReactDOMTextarea = {
	  getHostProps: function (inst, props) {
	    !(props.dangerouslySetInnerHTML == null) ?  false ? invariant(false, '`dangerouslySetInnerHTML` does not make sense on <textarea>.') : _prodInvariant('91') : void 0;
	
	    // Always set children to the same thing. In IE9, the selection range will
	    // get reset if `textContent` is mutated.  We could add a check in setTextContent
	    // to only set the value if/when the value differs from the node value (which would
	    // completely solve this IE9 bug), but Sebastian+Ben seemed to like this solution.
	    // The value can be a boolean or object so that's why it's forced to be a string.
	    var hostProps = _assign({}, props, {
	      value: undefined,
	      defaultValue: undefined,
	      children: '' + inst._wrapperState.initialValue,
	      onChange: inst._wrapperState.onChange
	    });
	
	    return hostProps;
	  },
	
	  mountWrapper: function (inst, props) {
	    if (false) {
	      LinkedValueUtils.checkPropTypes('textarea', props, inst._currentElement._owner);
	      if (props.valueLink !== undefined && !didWarnValueLink) {
	        process.env.NODE_ENV !== 'production' ? warning(false, '`valueLink` prop on `textarea` is deprecated; set `value` and `onChange` instead.') : void 0;
	        didWarnValueLink = true;
	      }
	      if (props.value !== undefined && props.defaultValue !== undefined && !didWarnValDefaultVal) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'Textarea elements must be either controlled or uncontrolled ' + '(specify either the value prop, or the defaultValue prop, but not ' + 'both). Decide between using a controlled or uncontrolled textarea ' + 'and remove one of these props. More info: ' + 'https://fb.me/react-controlled-components') : void 0;
	        didWarnValDefaultVal = true;
	      }
	    }
	
	    var value = LinkedValueUtils.getValue(props);
	    var initialValue = value;
	
	    // Only bother fetching default value if we're going to use it
	    if (value == null) {
	      var defaultValue = props.defaultValue;
	      // TODO (yungsters): Remove support for children content in <textarea>.
	      var children = props.children;
	      if (children != null) {
	        if (false) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'Use the `defaultValue` or `value` props instead of setting ' + 'children on <textarea>.') : void 0;
	        }
	        !(defaultValue == null) ?  false ? invariant(false, 'If you supply `defaultValue` on a <textarea>, do not pass children.') : _prodInvariant('92') : void 0;
	        if (Array.isArray(children)) {
	          !(children.length <= 1) ?  false ? invariant(false, '<textarea> can only have at most one child.') : _prodInvariant('93') : void 0;
	          children = children[0];
	        }
	
	        defaultValue = '' + children;
	      }
	      if (defaultValue == null) {
	        defaultValue = '';
	      }
	      initialValue = defaultValue;
	    }
	
	    inst._wrapperState = {
	      initialValue: '' + initialValue,
	      listeners: null,
	      onChange: _handleChange.bind(inst)
	    };
	  },
	
	  updateWrapper: function (inst) {
	    var props = inst._currentElement.props;
	
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var value = LinkedValueUtils.getValue(props);
	    if (value != null) {
	      // Cast `value` to a string to ensure the value is set correctly. While
	      // browsers typically do this as necessary, jsdom doesn't.
	      var newValue = '' + value;
	
	      // To avoid side effects (such as losing text selection), only set value if changed
	      if (newValue !== node.value) {
	        node.value = newValue;
	      }
	      if (props.defaultValue == null) {
	        node.defaultValue = newValue;
	      }
	    }
	    if (props.defaultValue != null) {
	      node.defaultValue = props.defaultValue;
	    }
	  },
	
	  postMountWrapper: function (inst) {
	    // This is in postMount because we need access to the DOM node, which is not
	    // available until after the component has mounted.
	    var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	    var textContent = node.textContent;
	
	    // Only set node.value if textContent is equal to the expected
	    // initial value. In IE10/IE11 there is a bug where the placeholder attribute
	    // will populate textContent as well.
	    // https://developer.microsoft.com/microsoft-edge/platform/issues/101525/
	    if (textContent === inst._wrapperState.initialValue) {
	      node.value = textContent;
	    }
	  }
	};
	
	function _handleChange(event) {
	  var props = this._currentElement.props;
	  var returnValue = LinkedValueUtils.executeOnChange(props, event);
	  ReactUpdates.asap(forceUpdateIfMounted, this);
	  return returnValue;
	}
	
	module.exports = ReactDOMTextarea;

/***/ },
/* 1877 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Return the lowest common ancestor of A and B, or null if they are in
	 * different trees.
	 */
	function getLowestCommonAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'getNodeFromInstance: Invalid argument.') : _prodInvariant('33') : void 0;
	
	  var depthA = 0;
	  for (var tempA = instA; tempA; tempA = tempA._hostParent) {
	    depthA++;
	  }
	  var depthB = 0;
	  for (var tempB = instB; tempB; tempB = tempB._hostParent) {
	    depthB++;
	  }
	
	  // If A is deeper, crawl up.
	  while (depthA - depthB > 0) {
	    instA = instA._hostParent;
	    depthA--;
	  }
	
	  // If B is deeper, crawl up.
	  while (depthB - depthA > 0) {
	    instB = instB._hostParent;
	    depthB--;
	  }
	
	  // Walk in lockstep until we find a match.
	  var depth = depthA;
	  while (depth--) {
	    if (instA === instB) {
	      return instA;
	    }
	    instA = instA._hostParent;
	    instB = instB._hostParent;
	  }
	  return null;
	}
	
	/**
	 * Return if A is an ancestor of B.
	 */
	function isAncestor(instA, instB) {
	  !('_hostNode' in instA) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	  !('_hostNode' in instB) ?  false ? invariant(false, 'isAncestor: Invalid argument.') : _prodInvariant('35') : void 0;
	
	  while (instB) {
	    if (instB === instA) {
	      return true;
	    }
	    instB = instB._hostParent;
	  }
	  return false;
	}
	
	/**
	 * Return the parent instance of the passed-in instance.
	 */
	function getParentInstance(inst) {
	  !('_hostNode' in inst) ?  false ? invariant(false, 'getParentInstance: Invalid argument.') : _prodInvariant('36') : void 0;
	
	  return inst._hostParent;
	}
	
	/**
	 * Simulates the traversal of a two-phase, capture/bubble event dispatch.
	 */
	function traverseTwoPhase(inst, fn, arg) {
	  var path = [];
	  while (inst) {
	    path.push(inst);
	    inst = inst._hostParent;
	  }
	  var i;
	  for (i = path.length; i-- > 0;) {
	    fn(path[i], 'captured', arg);
	  }
	  for (i = 0; i < path.length; i++) {
	    fn(path[i], 'bubbled', arg);
	  }
	}
	
	/**
	 * Traverses the ID hierarchy and invokes the supplied `cb` on any IDs that
	 * should would receive a `mouseEnter` or `mouseLeave` event.
	 *
	 * Does not invoke the callback on the nearest common ancestor because nothing
	 * "entered" or "left" that element.
	 */
	function traverseEnterLeave(from, to, fn, argFrom, argTo) {
	  var common = from && to ? getLowestCommonAncestor(from, to) : null;
	  var pathFrom = [];
	  while (from && from !== common) {
	    pathFrom.push(from);
	    from = from._hostParent;
	  }
	  var pathTo = [];
	  while (to && to !== common) {
	    pathTo.push(to);
	    to = to._hostParent;
	  }
	  var i;
	  for (i = 0; i < pathFrom.length; i++) {
	    fn(pathFrom[i], 'bubbled', argFrom);
	  }
	  for (i = pathTo.length; i-- > 0;) {
	    fn(pathTo[i], 'captured', argTo);
	  }
	}
	
	module.exports = {
	  isAncestor: isAncestor,
	  getLowestCommonAncestor: getLowestCommonAncestor,
	  getParentInstance: getParentInstance,
	  traverseTwoPhase: traverseTwoPhase,
	  traverseEnterLeave: traverseEnterLeave
	};

/***/ },
/* 1878 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var ReactUpdates = __webpack_require__(42);
	var Transaction = __webpack_require__(157);
	
	var emptyFunction = __webpack_require__(24);
	
	var RESET_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: function () {
	    ReactDefaultBatchingStrategy.isBatchingUpdates = false;
	  }
	};
	
	var FLUSH_BATCHED_UPDATES = {
	  initialize: emptyFunction,
	  close: ReactUpdates.flushBatchedUpdates.bind(ReactUpdates)
	};
	
	var TRANSACTION_WRAPPERS = [FLUSH_BATCHED_UPDATES, RESET_BATCHED_UPDATES];
	
	function ReactDefaultBatchingStrategyTransaction() {
	  this.reinitializeTransaction();
	}
	
	_assign(ReactDefaultBatchingStrategyTransaction.prototype, Transaction, {
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  }
	});
	
	var transaction = new ReactDefaultBatchingStrategyTransaction();
	
	var ReactDefaultBatchingStrategy = {
	  isBatchingUpdates: false,
	
	  /**
	   * Call the provided function in a context within which calls to `setState`
	   * and friends are batched such that components aren't updated unnecessarily.
	   */
	  batchedUpdates: function (callback, a, b, c, d, e) {
	    var alreadyBatchingUpdates = ReactDefaultBatchingStrategy.isBatchingUpdates;
	
	    ReactDefaultBatchingStrategy.isBatchingUpdates = true;
	
	    // The code is written this way to avoid extra allocations
	    if (alreadyBatchingUpdates) {
	      return callback(a, b, c, d, e);
	    } else {
	      return transaction.perform(callback, null, a, b, c, d, e);
	    }
	  }
	};
	
	module.exports = ReactDefaultBatchingStrategy;

/***/ },
/* 1879 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ARIADOMPropertyConfig = __webpack_require__(1852);
	var BeforeInputEventPlugin = __webpack_require__(1854);
	var ChangeEventPlugin = __webpack_require__(1856);
	var DefaultEventPluginOrder = __webpack_require__(1858);
	var EnterLeaveEventPlugin = __webpack_require__(1859);
	var HTMLDOMPropertyConfig = __webpack_require__(1862);
	var ReactComponentBrowserEnvironment = __webpack_require__(1864);
	var ReactDOMComponent = __webpack_require__(1867);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactDOMEmptyComponent = __webpack_require__(1869);
	var ReactDOMTreeTraversal = __webpack_require__(1877);
	var ReactDOMTextComponent = __webpack_require__(1875);
	var ReactDefaultBatchingStrategy = __webpack_require__(1878);
	var ReactEventListener = __webpack_require__(1882);
	var ReactInjection = __webpack_require__(1883);
	var ReactReconcileTransaction = __webpack_require__(1888);
	var SVGDOMPropertyConfig = __webpack_require__(1893);
	var SelectEventPlugin = __webpack_require__(1894);
	var SimpleEventPlugin = __webpack_require__(1895);
	
	var alreadyInjected = false;
	
	function inject() {
	  if (alreadyInjected) {
	    // TODO: This is currently true because these injections are shared between
	    // the client and the server package. They should be built independently
	    // and not share any injection state. Then this problem will be solved.
	    return;
	  }
	  alreadyInjected = true;
	
	  ReactInjection.EventEmitter.injectReactEventListener(ReactEventListener);
	
	  /**
	   * Inject modules for resolving DOM hierarchy and plugin ordering.
	   */
	  ReactInjection.EventPluginHub.injectEventPluginOrder(DefaultEventPluginOrder);
	  ReactInjection.EventPluginUtils.injectComponentTree(ReactDOMComponentTree);
	  ReactInjection.EventPluginUtils.injectTreeTraversal(ReactDOMTreeTraversal);
	
	  /**
	   * Some important event plugins included by default (without having to require
	   * them).
	   */
	  ReactInjection.EventPluginHub.injectEventPluginsByName({
	    SimpleEventPlugin: SimpleEventPlugin,
	    EnterLeaveEventPlugin: EnterLeaveEventPlugin,
	    ChangeEventPlugin: ChangeEventPlugin,
	    SelectEventPlugin: SelectEventPlugin,
	    BeforeInputEventPlugin: BeforeInputEventPlugin
	  });
	
	  ReactInjection.HostComponent.injectGenericComponentClass(ReactDOMComponent);
	
	  ReactInjection.HostComponent.injectTextComponentClass(ReactDOMTextComponent);
	
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(ARIADOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(HTMLDOMPropertyConfig);
	  ReactInjection.DOMProperty.injectDOMPropertyConfig(SVGDOMPropertyConfig);
	
	  ReactInjection.EmptyComponent.injectEmptyComponentFactory(function (instantiate) {
	    return new ReactDOMEmptyComponent(instantiate);
	  });
	
	  ReactInjection.Updates.injectReconcileTransaction(ReactReconcileTransaction);
	  ReactInjection.Updates.injectBatchingStrategy(ReactDefaultBatchingStrategy);
	
	  ReactInjection.Component.injectEnvironment(ReactComponentBrowserEnvironment);
	}
	
	module.exports = {
	  inject: inject
	};

/***/ },
/* 1880 */
425,
/* 1881 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPluginHub = __webpack_require__(90);
	
	function runEventQueueInBatch(events) {
	  EventPluginHub.enqueueEvents(events);
	  EventPluginHub.processEventQueue(false);
	}
	
	var ReactEventEmitterMixin = {
	  /**
	   * Streams a fired top-level event to `EventPluginHub` where plugins have the
	   * opportunity to create `ReactEvent`s to be dispatched.
	   */
	  handleTopLevel: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var events = EventPluginHub.extractEvents(topLevelType, targetInst, nativeEvent, nativeEventTarget);
	    runEventQueueInBatch(events);
	  }
	};
	
	module.exports = ReactEventEmitterMixin;

/***/ },
/* 1882 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var EventListener = __webpack_require__(274);
	var ExecutionEnvironment = __webpack_require__(22);
	var PooledClass = __webpack_require__(66);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactUpdates = __webpack_require__(42);
	
	var getEventTarget = __webpack_require__(237);
	var getUnboundedScrollPosition = __webpack_require__(579);
	
	/**
	 * Find the deepest React component completely containing the root of the
	 * passed-in instance (for use when entire React trees are nested within each
	 * other). If React trees are not nested, returns null.
	 */
	function findParent(inst) {
	  // TODO: It may be a good idea to cache this to prevent unnecessary DOM
	  // traversal, but caching is difficult to do correctly without using a
	  // mutation observer to listen for all DOM changes.
	  while (inst._hostParent) {
	    inst = inst._hostParent;
	  }
	  var rootNode = ReactDOMComponentTree.getNodeFromInstance(inst);
	  var container = rootNode.parentNode;
	  return ReactDOMComponentTree.getClosestInstanceFromNode(container);
	}
	
	// Used to store ancestor hierarchy in top level callback
	function TopLevelCallbackBookKeeping(topLevelType, nativeEvent) {
	  this.topLevelType = topLevelType;
	  this.nativeEvent = nativeEvent;
	  this.ancestors = [];
	}
	_assign(TopLevelCallbackBookKeeping.prototype, {
	  destructor: function () {
	    this.topLevelType = null;
	    this.nativeEvent = null;
	    this.ancestors.length = 0;
	  }
	});
	PooledClass.addPoolingTo(TopLevelCallbackBookKeeping, PooledClass.twoArgumentPooler);
	
	function handleTopLevelImpl(bookKeeping) {
	  var nativeEventTarget = getEventTarget(bookKeeping.nativeEvent);
	  var targetInst = ReactDOMComponentTree.getClosestInstanceFromNode(nativeEventTarget);
	
	  // Loop through the hierarchy, in case there's any nested components.
	  // It's important that we build the array of ancestors before calling any
	  // event handlers, because event handlers can modify the DOM, leading to
	  // inconsistencies with ReactMount's node cache. See #1105.
	  var ancestor = targetInst;
	  do {
	    bookKeeping.ancestors.push(ancestor);
	    ancestor = ancestor && findParent(ancestor);
	  } while (ancestor);
	
	  for (var i = 0; i < bookKeeping.ancestors.length; i++) {
	    targetInst = bookKeeping.ancestors[i];
	    ReactEventListener._handleTopLevel(bookKeeping.topLevelType, targetInst, bookKeeping.nativeEvent, getEventTarget(bookKeeping.nativeEvent));
	  }
	}
	
	function scrollValueMonitor(cb) {
	  var scrollPosition = getUnboundedScrollPosition(window);
	  cb(scrollPosition);
	}
	
	var ReactEventListener = {
	  _enabled: true,
	  _handleTopLevel: null,
	
	  WINDOW_HANDLE: ExecutionEnvironment.canUseDOM ? window : null,
	
	  setHandleTopLevel: function (handleTopLevel) {
	    ReactEventListener._handleTopLevel = handleTopLevel;
	  },
	
	  setEnabled: function (enabled) {
	    ReactEventListener._enabled = !!enabled;
	  },
	
	  isEnabled: function () {
	    return ReactEventListener._enabled;
	  },
	
	  /**
	   * Traps top-level events by using event bubbling.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapBubbledEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.listen(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  /**
	   * Traps a top-level event by using event capturing.
	   *
	   * @param {string} topLevelType Record from `EventConstants`.
	   * @param {string} handlerBaseName Event name (e.g. "click").
	   * @param {object} element Element on which to attach listener.
	   * @return {?object} An object with a remove function which will forcefully
	   *                  remove the listener.
	   * @internal
	   */
	  trapCapturedEvent: function (topLevelType, handlerBaseName, element) {
	    if (!element) {
	      return null;
	    }
	    return EventListener.capture(element, handlerBaseName, ReactEventListener.dispatchEvent.bind(null, topLevelType));
	  },
	
	  monitorScrollValue: function (refresh) {
	    var callback = scrollValueMonitor.bind(null, refresh);
	    EventListener.listen(window, 'scroll', callback);
	  },
	
	  dispatchEvent: function (topLevelType, nativeEvent) {
	    if (!ReactEventListener._enabled) {
	      return;
	    }
	
	    var bookKeeping = TopLevelCallbackBookKeeping.getPooled(topLevelType, nativeEvent);
	    try {
	      // Event queue being processed in the same cycle allows
	      // `preventDefault`.
	      ReactUpdates.batchedUpdates(handleTopLevelImpl, bookKeeping);
	    } finally {
	      TopLevelCallbackBookKeeping.release(bookKeeping);
	    }
	  }
	};
	
	module.exports = ReactEventListener;

/***/ },
/* 1883 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var DOMProperty = __webpack_require__(89);
	var EventPluginHub = __webpack_require__(90);
	var EventPluginUtils = __webpack_require__(154);
	var ReactComponentEnvironment = __webpack_require__(230);
	var ReactEmptyComponent = __webpack_require__(399);
	var ReactBrowserEventEmitter = __webpack_require__(155);
	var ReactHostComponent = __webpack_require__(401);
	var ReactUpdates = __webpack_require__(42);
	
	var ReactInjection = {
	  Component: ReactComponentEnvironment.injection,
	  DOMProperty: DOMProperty.injection,
	  EmptyComponent: ReactEmptyComponent.injection,
	  EventPluginHub: EventPluginHub.injection,
	  EventPluginUtils: EventPluginUtils.injection,
	  EventEmitter: ReactBrowserEventEmitter.injection,
	  HostComponent: ReactHostComponent.injection,
	  Updates: ReactUpdates.injection
	};
	
	module.exports = ReactInjection;

/***/ },
/* 1884 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var adler32 = __webpack_require__(1906);
	
	var TAG_END = /\/?>/;
	var COMMENT_START = /^<\!\-\-/;
	
	var ReactMarkupChecksum = {
	  CHECKSUM_ATTR_NAME: 'data-react-checksum',
	
	  /**
	   * @param {string} markup Markup string
	   * @return {string} Markup string with checksum attribute attached
	   */
	  addChecksumToMarkup: function (markup) {
	    var checksum = adler32(markup);
	
	    // Add checksum (handle both parent tags, comments and self-closing tags)
	    if (COMMENT_START.test(markup)) {
	      return markup;
	    } else {
	      return markup.replace(TAG_END, ' ' + ReactMarkupChecksum.CHECKSUM_ATTR_NAME + '="' + checksum + '"$&');
	    }
	  },
	
	  /**
	   * @param {string} markup to use
	   * @param {DOMElement} element root React element
	   * @returns {boolean} whether or not the markup is the same
	   */
	  canReuseMarkup: function (markup, element) {
	    var existingChecksum = element.getAttribute(ReactMarkupChecksum.CHECKSUM_ATTR_NAME);
	    existingChecksum = existingChecksum && parseInt(existingChecksum, 10);
	    var markupChecksum = adler32(markup);
	    return markupChecksum === existingChecksum;
	  }
	};
	
	module.exports = ReactMarkupChecksum;

/***/ },
/* 1885 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactComponentEnvironment = __webpack_require__(230);
	var ReactInstanceMap = __webpack_require__(119);
	var ReactInstrumentation = __webpack_require__(36);
	
	var ReactCurrentOwner = __webpack_require__(45);
	var ReactReconciler = __webpack_require__(92);
	var ReactChildReconciler = __webpack_require__(1863);
	
	var emptyFunction = __webpack_require__(24);
	var flattenChildren = __webpack_require__(1909);
	var invariant = __webpack_require__(13);
	
	/**
	 * Make an update for markup to be rendered and inserted at a supplied index.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @param {number} toIndex Destination index.
	 * @private
	 */
	function makeInsertMarkup(markup, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'INSERT_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for moving an existing element to another index.
	 *
	 * @param {number} fromIndex Source index of the existing element.
	 * @param {number} toIndex Destination index of the element.
	 * @private
	 */
	function makeMove(child, afterNode, toIndex) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'MOVE_EXISTING',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: ReactReconciler.getHostNode(child),
	    toIndex: toIndex,
	    afterNode: afterNode
	  };
	}
	
	/**
	 * Make an update for removing an element at an index.
	 *
	 * @param {number} fromIndex Index of the element to remove.
	 * @private
	 */
	function makeRemove(child, node) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'REMOVE_NODE',
	    content: null,
	    fromIndex: child._mountIndex,
	    fromNode: node,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the markup of a node.
	 *
	 * @param {string} markup Markup that renders into an element.
	 * @private
	 */
	function makeSetMarkup(markup) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'SET_MARKUP',
	    content: markup,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Make an update for setting the text content.
	 *
	 * @param {string} textContent Text content to set.
	 * @private
	 */
	function makeTextContent(textContent) {
	  // NOTE: Null values reduce hidden classes.
	  return {
	    type: 'TEXT_CONTENT',
	    content: textContent,
	    fromIndex: null,
	    fromNode: null,
	    toIndex: null,
	    afterNode: null
	  };
	}
	
	/**
	 * Push an update, if any, onto the queue. Creates a new queue if none is
	 * passed and always returns the queue. Mutative.
	 */
	function enqueue(queue, update) {
	  if (update) {
	    queue = queue || [];
	    queue.push(update);
	  }
	  return queue;
	}
	
	/**
	 * Processes any enqueued updates.
	 *
	 * @private
	 */
	function processQueue(inst, updateQueue) {
	  ReactComponentEnvironment.processChildrenUpdates(inst, updateQueue);
	}
	
	var setChildrenForInstrumentation = emptyFunction;
	if (false) {
	  var getDebugID = function (inst) {
	    if (!inst._debugID) {
	      // Check for ART-like instances. TODO: This is silly/gross.
	      var internal;
	      if (internal = ReactInstanceMap.get(inst)) {
	        inst = internal;
	      }
	    }
	    return inst._debugID;
	  };
	  setChildrenForInstrumentation = function (children) {
	    var debugID = getDebugID(this);
	    // TODO: React Native empty components are also multichild.
	    // This means they still get into this method but don't have _debugID.
	    if (debugID !== 0) {
	      ReactInstrumentation.debugTool.onSetChildren(debugID, children ? Object.keys(children).map(function (key) {
	        return children[key]._debugID;
	      }) : []);
	    }
	  };
	}
	
	/**
	 * ReactMultiChild are capable of reconciling multiple children.
	 *
	 * @class ReactMultiChild
	 * @internal
	 */
	var ReactMultiChild = {
	  /**
	   * Provides common functionality for components that must reconcile multiple
	   * children. This is used by `ReactDOMComponent` to mount, update, and
	   * unmount child components.
	   *
	   * @lends {ReactMultiChild.prototype}
	   */
	  Mixin: {
	    _reconcilerInstantiateChildren: function (nestedChildren, transaction, context) {
	      if (false) {
	        var selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	        }
	      }
	      return ReactChildReconciler.instantiateChildren(nestedChildren, transaction, context);
	    },
	
	    _reconcilerUpdateChildren: function (prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context) {
	      var nextChildren;
	      var selfDebugID = 0;
	      if (false) {
	        selfDebugID = getDebugID(this);
	        if (this._currentElement) {
	          try {
	            ReactCurrentOwner.current = this._currentElement._owner;
	            nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	          } finally {
	            ReactCurrentOwner.current = null;
	          }
	          ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          return nextChildren;
	        }
	      }
	      nextChildren = flattenChildren(nextNestedChildrenElements, selfDebugID);
	      ReactChildReconciler.updateChildren(prevChildren, nextChildren, mountImages, removedNodes, transaction, this, this._hostContainerInfo, context, selfDebugID);
	      return nextChildren;
	    },
	
	    /**
	     * Generates a "mount image" for each of the supplied children. In the case
	     * of `ReactDOMComponent`, a mount image is a string of markup.
	     *
	     * @param {?object} nestedChildren Nested child maps.
	     * @return {array} An array of mounted representations.
	     * @internal
	     */
	    mountChildren: function (nestedChildren, transaction, context) {
	      var children = this._reconcilerInstantiateChildren(nestedChildren, transaction, context);
	      this._renderedChildren = children;
	
	      var mountImages = [];
	      var index = 0;
	      for (var name in children) {
	        if (children.hasOwnProperty(name)) {
	          var child = children[name];
	          var selfDebugID = 0;
	          if (false) {
	            selfDebugID = getDebugID(this);
	          }
	          var mountImage = ReactReconciler.mountComponent(child, transaction, this, this._hostContainerInfo, context, selfDebugID);
	          child._mountIndex = index++;
	          mountImages.push(mountImage);
	        }
	      }
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, children);
	      }
	
	      return mountImages;
	    },
	
	    /**
	     * Replaces any rendered children with a text content string.
	     *
	     * @param {string} nextContent String of content.
	     * @internal
	     */
	    updateTextContent: function (nextContent) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      // Set new text content.
	      var updates = [makeTextContent(nextContent)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Replaces any rendered children with a markup string.
	     *
	     * @param {string} nextMarkup String of markup.
	     * @internal
	     */
	    updateMarkup: function (nextMarkup) {
	      var prevChildren = this._renderedChildren;
	      // Remove any rendered children.
	      ReactChildReconciler.unmountChildren(prevChildren, false);
	      for (var name in prevChildren) {
	        if (prevChildren.hasOwnProperty(name)) {
	           true ?  false ? invariant(false, 'updateTextContent called on non-empty component.') : _prodInvariant('118') : void 0;
	        }
	      }
	      var updates = [makeSetMarkup(nextMarkup)];
	      processQueue(this, updates);
	    },
	
	    /**
	     * Updates the rendered children with new children.
	     *
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @internal
	     */
	    updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      // Hook used by React ART
	      this._updateChildren(nextNestedChildrenElements, transaction, context);
	    },
	
	    /**
	     * @param {?object} nextNestedChildrenElements Nested child element maps.
	     * @param {ReactReconcileTransaction} transaction
	     * @final
	     * @protected
	     */
	    _updateChildren: function (nextNestedChildrenElements, transaction, context) {
	      var prevChildren = this._renderedChildren;
	      var removedNodes = {};
	      var mountImages = [];
	      var nextChildren = this._reconcilerUpdateChildren(prevChildren, nextNestedChildrenElements, mountImages, removedNodes, transaction, context);
	      if (!nextChildren && !prevChildren) {
	        return;
	      }
	      var updates = null;
	      var name;
	      // `nextIndex` will increment for each child in `nextChildren`, but
	      // `lastIndex` will be the last index visited in `prevChildren`.
	      var nextIndex = 0;
	      var lastIndex = 0;
	      // `nextMountIndex` will increment for each newly mounted child.
	      var nextMountIndex = 0;
	      var lastPlacedNode = null;
	      for (name in nextChildren) {
	        if (!nextChildren.hasOwnProperty(name)) {
	          continue;
	        }
	        var prevChild = prevChildren && prevChildren[name];
	        var nextChild = nextChildren[name];
	        if (prevChild === nextChild) {
	          updates = enqueue(updates, this.moveChild(prevChild, lastPlacedNode, nextIndex, lastIndex));
	          lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	          prevChild._mountIndex = nextIndex;
	        } else {
	          if (prevChild) {
	            // Update `lastIndex` before `_mountIndex` gets unset by unmounting.
	            lastIndex = Math.max(prevChild._mountIndex, lastIndex);
	            // The `removedNodes` loop below will actually remove the child.
	          }
	          // The child must be instantiated before it's mounted.
	          updates = enqueue(updates, this._mountChildAtIndex(nextChild, mountImages[nextMountIndex], lastPlacedNode, nextIndex, transaction, context));
	          nextMountIndex++;
	        }
	        nextIndex++;
	        lastPlacedNode = ReactReconciler.getHostNode(nextChild);
	      }
	      // Remove children that are no longer present.
	      for (name in removedNodes) {
	        if (removedNodes.hasOwnProperty(name)) {
	          updates = enqueue(updates, this._unmountChild(prevChildren[name], removedNodes[name]));
	        }
	      }
	      if (updates) {
	        processQueue(this, updates);
	      }
	      this._renderedChildren = nextChildren;
	
	      if (false) {
	        setChildrenForInstrumentation.call(this, nextChildren);
	      }
	    },
	
	    /**
	     * Unmounts all rendered children. This should be used to clean up children
	     * when this component is unmounted. It does not actually perform any
	     * backend operations.
	     *
	     * @internal
	     */
	    unmountChildren: function (safely) {
	      var renderedChildren = this._renderedChildren;
	      ReactChildReconciler.unmountChildren(renderedChildren, safely);
	      this._renderedChildren = null;
	    },
	
	    /**
	     * Moves a child component to the supplied index.
	     *
	     * @param {ReactComponent} child Component to move.
	     * @param {number} toIndex Destination index of the element.
	     * @param {number} lastIndex Last index visited of the siblings of `child`.
	     * @protected
	     */
	    moveChild: function (child, afterNode, toIndex, lastIndex) {
	      // If the index of `child` is less than `lastIndex`, then it needs to
	      // be moved. Otherwise, we do not need to move it because a child will be
	      // inserted or moved before `child`.
	      if (child._mountIndex < lastIndex) {
	        return makeMove(child, afterNode, toIndex);
	      }
	    },
	
	    /**
	     * Creates a child component.
	     *
	     * @param {ReactComponent} child Component to create.
	     * @param {string} mountImage Markup to insert.
	     * @protected
	     */
	    createChild: function (child, afterNode, mountImage) {
	      return makeInsertMarkup(mountImage, afterNode, child._mountIndex);
	    },
	
	    /**
	     * Removes a child component.
	     *
	     * @param {ReactComponent} child Child to remove.
	     * @protected
	     */
	    removeChild: function (child, node) {
	      return makeRemove(child, node);
	    },
	
	    /**
	     * Mounts a child with the supplied name.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to mount.
	     * @param {string} name Name of the child.
	     * @param {number} index Index at which to insert the child.
	     * @param {ReactReconcileTransaction} transaction
	     * @private
	     */
	    _mountChildAtIndex: function (child, mountImage, afterNode, index, transaction, context) {
	      child._mountIndex = index;
	      return this.createChild(child, afterNode, mountImage);
	    },
	
	    /**
	     * Unmounts a rendered child.
	     *
	     * NOTE: This is part of `updateChildren` and is here for readability.
	     *
	     * @param {ReactComponent} child Component to unmount.
	     * @private
	     */
	    _unmountChild: function (child, node) {
	      var update = this.removeChild(child, node);
	      child._mountIndex = null;
	      return update;
	    }
	  }
	};
	
	module.exports = ReactMultiChild;

/***/ },
/* 1886 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * @param {?object} object
	 * @return {boolean} True if `object` is a valid owner.
	 * @final
	 */
	function isValidOwner(object) {
	  return !!(object && typeof object.attachRef === 'function' && typeof object.detachRef === 'function');
	}
	
	/**
	 * ReactOwners are capable of storing references to owned components.
	 *
	 * All components are capable of //being// referenced by owner components, but
	 * only ReactOwner components are capable of //referencing// owned components.
	 * The named reference is known as a "ref".
	 *
	 * Refs are available when mounted and updated during reconciliation.
	 *
	 *   var MyComponent = React.createClass({
	 *     render: function() {
	 *       return (
	 *         <div onClick={this.handleClick}>
	 *           <CustomComponent ref="custom" />
	 *         </div>
	 *       );
	 *     },
	 *     handleClick: function() {
	 *       this.refs.custom.handleClick();
	 *     },
	 *     componentDidMount: function() {
	 *       this.refs.custom.initialize();
	 *     }
	 *   });
	 *
	 * Refs should rarely be used. When refs are used, they should only be done to
	 * control data that is not handled by React's data flow.
	 *
	 * @class ReactOwner
	 */
	var ReactOwner = {
	  /**
	   * Adds a component by ref to an owner component.
	   *
	   * @param {ReactComponent} component Component to reference.
	   * @param {string} ref Name by which to refer to the component.
	   * @param {ReactOwner} owner Component on which to record the ref.
	   * @final
	   * @internal
	   */
	  addComponentAsRefTo: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'addComponentAsRefTo(...): Only a ReactOwner can have refs. You might be adding a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('119') : void 0;
	    owner.attachRef(ref, component);
	  },
	
	  /**
	   * Removes a component by ref from an owner component.
	   *
	   * @param {ReactComponent} component Component to dereference.
	   * @param {string} ref Name of the ref to remove.
	   * @param {ReactOwner} owner Component on which the ref is recorded.
	   * @final
	   * @internal
	   */
	  removeComponentAsRefFrom: function (component, ref, owner) {
	    !isValidOwner(owner) ?  false ? invariant(false, 'removeComponentAsRefFrom(...): Only a ReactOwner can have refs. You might be removing a ref to a component that was not created inside a component\'s `render` method, or you have multiple copies of React loaded (details: https://fb.me/react-refs-must-have-owner).') : _prodInvariant('120') : void 0;
	    var ownerPublicInstance = owner.getPublicInstance();
	    // Check that `component`'s owner is still alive and that `component` is still the current ref
	    // because we do not want to detach the ref if another component stole it.
	    if (ownerPublicInstance && ownerPublicInstance.refs[ref] === component.getPublicInstance()) {
	      owner.detachRef(ref);
	    }
	  }
	};
	
	module.exports = ReactOwner;

/***/ },
/* 1887 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;

/***/ },
/* 1888 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var CallbackQueue = __webpack_require__(395);
	var PooledClass = __webpack_require__(66);
	var ReactBrowserEventEmitter = __webpack_require__(155);
	var ReactInputSelection = __webpack_require__(402);
	var ReactInstrumentation = __webpack_require__(36);
	var Transaction = __webpack_require__(157);
	var ReactUpdateQueue = __webpack_require__(232);
	
	/**
	 * Ensures that, when possible, the selection range (currently selected text
	 * input) is not disturbed by performing the transaction.
	 */
	var SELECTION_RESTORATION = {
	  /**
	   * @return {Selection} Selection information.
	   */
	  initialize: ReactInputSelection.getSelectionInformation,
	  /**
	   * @param {Selection} sel Selection information returned from `initialize`.
	   */
	  close: ReactInputSelection.restoreSelection
	};
	
	/**
	 * Suppresses events (blur/focus) that could be inadvertently dispatched due to
	 * high level DOM manipulations (like temporarily removing a text input from the
	 * DOM).
	 */
	var EVENT_SUPPRESSION = {
	  /**
	   * @return {boolean} The enabled status of `ReactBrowserEventEmitter` before
	   * the reconciliation.
	   */
	  initialize: function () {
	    var currentlyEnabled = ReactBrowserEventEmitter.isEnabled();
	    ReactBrowserEventEmitter.setEnabled(false);
	    return currentlyEnabled;
	  },
	
	  /**
	   * @param {boolean} previouslyEnabled Enabled status of
	   *   `ReactBrowserEventEmitter` before the reconciliation occurred. `close`
	   *   restores the previous value.
	   */
	  close: function (previouslyEnabled) {
	    ReactBrowserEventEmitter.setEnabled(previouslyEnabled);
	  }
	};
	
	/**
	 * Provides a queue for collecting `componentDidMount` and
	 * `componentDidUpdate` callbacks during the transaction.
	 */
	var ON_DOM_READY_QUEUEING = {
	  /**
	   * Initializes the internal `onDOMReady` queue.
	   */
	  initialize: function () {
	    this.reactMountReady.reset();
	  },
	
	  /**
	   * After DOM is flushed, invoke all registered `onDOMReady` callbacks.
	   */
	  close: function () {
	    this.reactMountReady.notifyAll();
	  }
	};
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [SELECTION_RESTORATION, EVENT_SUPPRESSION, ON_DOM_READY_QUEUEING];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	/**
	 * Currently:
	 * - The order that these are listed in the transaction is critical:
	 * - Suppresses events.
	 * - Restores selection range.
	 *
	 * Future:
	 * - Restore document/overflow scroll positions that were unintentionally
	 *   modified via DOM insertions above the top viewport boundary.
	 * - Implement/integrate with customized constraint based layout system and keep
	 *   track of which dimensions must be remeasured.
	 *
	 * @class ReactReconcileTransaction
	 */
	function ReactReconcileTransaction(useCreateElement) {
	  this.reinitializeTransaction();
	  // Only server-side rendering really needs this option (see
	  // `ReactServerRendering`), but server-side uses
	  // `ReactServerRenderingTransaction` instead. This option is here so that it's
	  // accessible and defaults to false when `ReactDOMComponent` and
	  // `ReactDOMTextComponent` checks it in `mountComponent`.`
	  this.renderToStaticMarkup = false;
	  this.reactMountReady = CallbackQueue.getPooled(null);
	  this.useCreateElement = useCreateElement;
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array<object>} List of operation wrap procedures.
	   *   TODO: convert to array<TransactionWrapper>
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return this.reactMountReady;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return ReactUpdateQueue;
	  },
	
	  /**
	   * Save current transaction state -- if the return value from this method is
	   * passed to `rollback`, the transaction will be reset to that state.
	   */
	  checkpoint: function () {
	    // reactMountReady is the our only stateful wrapper
	    return this.reactMountReady.checkpoint();
	  },
	
	  rollback: function (checkpoint) {
	    this.reactMountReady.rollback(checkpoint);
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {
	    CallbackQueue.release(this.reactMountReady);
	    this.reactMountReady = null;
	  }
	};
	
	_assign(ReactReconcileTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactReconcileTransaction);
	
	module.exports = ReactReconcileTransaction;

/***/ },
/* 1889 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var ReactOwner = __webpack_require__(1886);
	
	var ReactRef = {};
	
	function attachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(component.getPublicInstance());
	  } else {
	    // Legacy ref
	    ReactOwner.addComponentAsRefTo(component, ref, owner);
	  }
	}
	
	function detachRef(ref, component, owner) {
	  if (typeof ref === 'function') {
	    ref(null);
	  } else {
	    // Legacy ref
	    ReactOwner.removeComponentAsRefFrom(component, ref, owner);
	  }
	}
	
	ReactRef.attachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    attachRef(ref, instance, element._owner);
	  }
	};
	
	ReactRef.shouldUpdateRefs = function (prevElement, nextElement) {
	  // If either the owner or a `ref` has changed, make sure the newest owner
	  // has stored a reference to `this`, and the previous owner (if different)
	  // has forgotten the reference to `this`. We use the element instead
	  // of the public this.props because the post processing cannot determine
	  // a ref. The ref conceptually lives on the element.
	
	  // TODO: Should this even be possible? The owner cannot change because
	  // it's forbidden by shouldUpdateReactComponent. The ref can change
	  // if you swap the keys of but not the refs. Reconsider where this check
	  // is made. It probably belongs where the key checking and
	  // instantiateReactComponent is done.
	
	  var prevRef = null;
	  var prevOwner = null;
	  if (prevElement !== null && typeof prevElement === 'object') {
	    prevRef = prevElement.ref;
	    prevOwner = prevElement._owner;
	  }
	
	  var nextRef = null;
	  var nextOwner = null;
	  if (nextElement !== null && typeof nextElement === 'object') {
	    nextRef = nextElement.ref;
	    nextOwner = nextElement._owner;
	  }
	
	  return prevRef !== nextRef ||
	  // If owner changes but we have an unchanged function ref, don't update refs
	  typeof nextRef === 'string' && nextOwner !== prevOwner;
	};
	
	ReactRef.detachRefs = function (instance, element) {
	  if (element === null || typeof element !== 'object') {
	    return;
	  }
	  var ref = element.ref;
	  if (ref != null) {
	    detachRef(ref, instance, element._owner);
	  }
	};
	
	module.exports = ReactRef;

/***/ },
/* 1890 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _assign = __webpack_require__(18);
	
	var PooledClass = __webpack_require__(66);
	var Transaction = __webpack_require__(157);
	var ReactInstrumentation = __webpack_require__(36);
	var ReactServerUpdateQueue = __webpack_require__(1891);
	
	/**
	 * Executed within the scope of the `Transaction` instance. Consider these as
	 * being member methods, but with an implied ordering while being isolated from
	 * each other.
	 */
	var TRANSACTION_WRAPPERS = [];
	
	if (false) {
	  TRANSACTION_WRAPPERS.push({
	    initialize: ReactInstrumentation.debugTool.onBeginFlush,
	    close: ReactInstrumentation.debugTool.onEndFlush
	  });
	}
	
	var noopCallbackQueue = {
	  enqueue: function () {}
	};
	
	/**
	 * @class ReactServerRenderingTransaction
	 * @param {boolean} renderToStaticMarkup
	 */
	function ReactServerRenderingTransaction(renderToStaticMarkup) {
	  this.reinitializeTransaction();
	  this.renderToStaticMarkup = renderToStaticMarkup;
	  this.useCreateElement = false;
	  this.updateQueue = new ReactServerUpdateQueue(this);
	}
	
	var Mixin = {
	  /**
	   * @see Transaction
	   * @abstract
	   * @final
	   * @return {array} Empty list of operation wrap procedures.
	   */
	  getTransactionWrappers: function () {
	    return TRANSACTION_WRAPPERS;
	  },
	
	  /**
	   * @return {object} The queue to collect `onDOMReady` callbacks with.
	   */
	  getReactMountReady: function () {
	    return noopCallbackQueue;
	  },
	
	  /**
	   * @return {object} The queue to collect React async events.
	   */
	  getUpdateQueue: function () {
	    return this.updateQueue;
	  },
	
	  /**
	   * `PooledClass` looks for this, and will invoke this before allowing this
	   * instance to be reused.
	   */
	  destructor: function () {},
	
	  checkpoint: function () {},
	
	  rollback: function () {}
	};
	
	_assign(ReactServerRenderingTransaction.prototype, Transaction, Mixin);
	
	PooledClass.addPoolingTo(ReactServerRenderingTransaction);
	
	module.exports = ReactServerRenderingTransaction;

/***/ },
/* 1891 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ReactUpdateQueue = __webpack_require__(232);
	
	var warning = __webpack_require__(16);
	
	function warnNoop(publicInstance, callerName) {
	  if (false) {
	    var constructor = publicInstance.constructor;
	    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounting component. ' + 'This usually means you called %s() outside componentWillMount() on the server. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
	  }
	}
	
	/**
	 * This is the update queue used for server rendering.
	 * It delegates to ReactUpdateQueue while server rendering is in progress and
	 * switches to ReactNoopUpdateQueue after the transaction has completed.
	 * @class ReactServerUpdateQueue
	 * @param {Transaction} transaction
	 */
	
	var ReactServerUpdateQueue = function () {
	  function ReactServerUpdateQueue(transaction) {
	    _classCallCheck(this, ReactServerUpdateQueue);
	
	    this.transaction = transaction;
	  }
	
	  /**
	   * Checks whether or not this composite component is mounted.
	   * @param {ReactClass} publicInstance The instance we want to test.
	   * @return {boolean} True if mounted, false otherwise.
	   * @protected
	   * @final
	   */
	
	
	  ReactServerUpdateQueue.prototype.isMounted = function isMounted(publicInstance) {
	    return false;
	  };
	
	  /**
	   * Enqueue a callback that will be executed after all the pending updates
	   * have processed.
	   *
	   * @param {ReactClass} publicInstance The instance to use as `this` context.
	   * @param {?function} callback Called after state is updated.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueCallback = function enqueueCallback(publicInstance, callback, callerName) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueCallback(publicInstance, callback, callerName);
	    }
	  };
	
	  /**
	   * Forces an update. This should only be invoked when it is known with
	   * certainty that we are **not** in a DOM transaction.
	   *
	   * You may want to call this when you know that some deeper aspect of the
	   * component's state has changed but `setState` was not called.
	   *
	   * This will not invoke `shouldComponentUpdate`, but it will invoke
	   * `componentWillUpdate` and `componentDidUpdate`.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueForceUpdate = function enqueueForceUpdate(publicInstance) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueForceUpdate(publicInstance);
	    } else {
	      warnNoop(publicInstance, 'forceUpdate');
	    }
	  };
	
	  /**
	   * Replaces all of the state. Always use this or `setState` to mutate state.
	   * You should treat `this.state` as immutable.
	   *
	   * There is no guarantee that `this.state` will be immediately updated, so
	   * accessing `this.state` after calling this method may return the old value.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} completeState Next state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueReplaceState = function enqueueReplaceState(publicInstance, completeState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueReplaceState(publicInstance, completeState);
	    } else {
	      warnNoop(publicInstance, 'replaceState');
	    }
	  };
	
	  /**
	   * Sets a subset of the state. This only exists because _pendingState is
	   * internal. This provides a merging strategy that is not available to deep
	   * properties which is confusing. TODO: Expose pendingState or don't use it
	   * during the merge.
	   *
	   * @param {ReactClass} publicInstance The instance that should rerender.
	   * @param {object|function} partialState Next partial state to be merged with state.
	   * @internal
	   */
	
	
	  ReactServerUpdateQueue.prototype.enqueueSetState = function enqueueSetState(publicInstance, partialState) {
	    if (this.transaction.isInTransaction()) {
	      ReactUpdateQueue.enqueueSetState(publicInstance, partialState);
	    } else {
	      warnNoop(publicInstance, 'setState');
	    }
	  };
	
	  return ReactServerUpdateQueue;
	}();
	
	module.exports = ReactServerUpdateQueue;

/***/ },
/* 1892 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	module.exports = '15.6.2';

/***/ },
/* 1893 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var NS = {
	  xlink: 'http://www.w3.org/1999/xlink',
	  xml: 'http://www.w3.org/XML/1998/namespace'
	};
	
	// We use attributes for everything SVG so let's avoid some duplication and run
	// code instead.
	// The following are all specified in the HTML config already so we exclude here.
	// - class (as className)
	// - color
	// - height
	// - id
	// - lang
	// - max
	// - media
	// - method
	// - min
	// - name
	// - style
	// - target
	// - type
	// - width
	var ATTRS = {
	  accentHeight: 'accent-height',
	  accumulate: 0,
	  additive: 0,
	  alignmentBaseline: 'alignment-baseline',
	  allowReorder: 'allowReorder',
	  alphabetic: 0,
	  amplitude: 0,
	  arabicForm: 'arabic-form',
	  ascent: 0,
	  attributeName: 'attributeName',
	  attributeType: 'attributeType',
	  autoReverse: 'autoReverse',
	  azimuth: 0,
	  baseFrequency: 'baseFrequency',
	  baseProfile: 'baseProfile',
	  baselineShift: 'baseline-shift',
	  bbox: 0,
	  begin: 0,
	  bias: 0,
	  by: 0,
	  calcMode: 'calcMode',
	  capHeight: 'cap-height',
	  clip: 0,
	  clipPath: 'clip-path',
	  clipRule: 'clip-rule',
	  clipPathUnits: 'clipPathUnits',
	  colorInterpolation: 'color-interpolation',
	  colorInterpolationFilters: 'color-interpolation-filters',
	  colorProfile: 'color-profile',
	  colorRendering: 'color-rendering',
	  contentScriptType: 'contentScriptType',
	  contentStyleType: 'contentStyleType',
	  cursor: 0,
	  cx: 0,
	  cy: 0,
	  d: 0,
	  decelerate: 0,
	  descent: 0,
	  diffuseConstant: 'diffuseConstant',
	  direction: 0,
	  display: 0,
	  divisor: 0,
	  dominantBaseline: 'dominant-baseline',
	  dur: 0,
	  dx: 0,
	  dy: 0,
	  edgeMode: 'edgeMode',
	  elevation: 0,
	  enableBackground: 'enable-background',
	  end: 0,
	  exponent: 0,
	  externalResourcesRequired: 'externalResourcesRequired',
	  fill: 0,
	  fillOpacity: 'fill-opacity',
	  fillRule: 'fill-rule',
	  filter: 0,
	  filterRes: 'filterRes',
	  filterUnits: 'filterUnits',
	  floodColor: 'flood-color',
	  floodOpacity: 'flood-opacity',
	  focusable: 0,
	  fontFamily: 'font-family',
	  fontSize: 'font-size',
	  fontSizeAdjust: 'font-size-adjust',
	  fontStretch: 'font-stretch',
	  fontStyle: 'font-style',
	  fontVariant: 'font-variant',
	  fontWeight: 'font-weight',
	  format: 0,
	  from: 0,
	  fx: 0,
	  fy: 0,
	  g1: 0,
	  g2: 0,
	  glyphName: 'glyph-name',
	  glyphOrientationHorizontal: 'glyph-orientation-horizontal',
	  glyphOrientationVertical: 'glyph-orientation-vertical',
	  glyphRef: 'glyphRef',
	  gradientTransform: 'gradientTransform',
	  gradientUnits: 'gradientUnits',
	  hanging: 0,
	  horizAdvX: 'horiz-adv-x',
	  horizOriginX: 'horiz-origin-x',
	  ideographic: 0,
	  imageRendering: 'image-rendering',
	  'in': 0,
	  in2: 0,
	  intercept: 0,
	  k: 0,
	  k1: 0,
	  k2: 0,
	  k3: 0,
	  k4: 0,
	  kernelMatrix: 'kernelMatrix',
	  kernelUnitLength: 'kernelUnitLength',
	  kerning: 0,
	  keyPoints: 'keyPoints',
	  keySplines: 'keySplines',
	  keyTimes: 'keyTimes',
	  lengthAdjust: 'lengthAdjust',
	  letterSpacing: 'letter-spacing',
	  lightingColor: 'lighting-color',
	  limitingConeAngle: 'limitingConeAngle',
	  local: 0,
	  markerEnd: 'marker-end',
	  markerMid: 'marker-mid',
	  markerStart: 'marker-start',
	  markerHeight: 'markerHeight',
	  markerUnits: 'markerUnits',
	  markerWidth: 'markerWidth',
	  mask: 0,
	  maskContentUnits: 'maskContentUnits',
	  maskUnits: 'maskUnits',
	  mathematical: 0,
	  mode: 0,
	  numOctaves: 'numOctaves',
	  offset: 0,
	  opacity: 0,
	  operator: 0,
	  order: 0,
	  orient: 0,
	  orientation: 0,
	  origin: 0,
	  overflow: 0,
	  overlinePosition: 'overline-position',
	  overlineThickness: 'overline-thickness',
	  paintOrder: 'paint-order',
	  panose1: 'panose-1',
	  pathLength: 'pathLength',
	  patternContentUnits: 'patternContentUnits',
	  patternTransform: 'patternTransform',
	  patternUnits: 'patternUnits',
	  pointerEvents: 'pointer-events',
	  points: 0,
	  pointsAtX: 'pointsAtX',
	  pointsAtY: 'pointsAtY',
	  pointsAtZ: 'pointsAtZ',
	  preserveAlpha: 'preserveAlpha',
	  preserveAspectRatio: 'preserveAspectRatio',
	  primitiveUnits: 'primitiveUnits',
	  r: 0,
	  radius: 0,
	  refX: 'refX',
	  refY: 'refY',
	  renderingIntent: 'rendering-intent',
	  repeatCount: 'repeatCount',
	  repeatDur: 'repeatDur',
	  requiredExtensions: 'requiredExtensions',
	  requiredFeatures: 'requiredFeatures',
	  restart: 0,
	  result: 0,
	  rotate: 0,
	  rx: 0,
	  ry: 0,
	  scale: 0,
	  seed: 0,
	  shapeRendering: 'shape-rendering',
	  slope: 0,
	  spacing: 0,
	  specularConstant: 'specularConstant',
	  specularExponent: 'specularExponent',
	  speed: 0,
	  spreadMethod: 'spreadMethod',
	  startOffset: 'startOffset',
	  stdDeviation: 'stdDeviation',
	  stemh: 0,
	  stemv: 0,
	  stitchTiles: 'stitchTiles',
	  stopColor: 'stop-color',
	  stopOpacity: 'stop-opacity',
	  strikethroughPosition: 'strikethrough-position',
	  strikethroughThickness: 'strikethrough-thickness',
	  string: 0,
	  stroke: 0,
	  strokeDasharray: 'stroke-dasharray',
	  strokeDashoffset: 'stroke-dashoffset',
	  strokeLinecap: 'stroke-linecap',
	  strokeLinejoin: 'stroke-linejoin',
	  strokeMiterlimit: 'stroke-miterlimit',
	  strokeOpacity: 'stroke-opacity',
	  strokeWidth: 'stroke-width',
	  surfaceScale: 'surfaceScale',
	  systemLanguage: 'systemLanguage',
	  tableValues: 'tableValues',
	  targetX: 'targetX',
	  targetY: 'targetY',
	  textAnchor: 'text-anchor',
	  textDecoration: 'text-decoration',
	  textRendering: 'text-rendering',
	  textLength: 'textLength',
	  to: 0,
	  transform: 0,
	  u1: 0,
	  u2: 0,
	  underlinePosition: 'underline-position',
	  underlineThickness: 'underline-thickness',
	  unicode: 0,
	  unicodeBidi: 'unicode-bidi',
	  unicodeRange: 'unicode-range',
	  unitsPerEm: 'units-per-em',
	  vAlphabetic: 'v-alphabetic',
	  vHanging: 'v-hanging',
	  vIdeographic: 'v-ideographic',
	  vMathematical: 'v-mathematical',
	  values: 0,
	  vectorEffect: 'vector-effect',
	  version: 0,
	  vertAdvY: 'vert-adv-y',
	  vertOriginX: 'vert-origin-x',
	  vertOriginY: 'vert-origin-y',
	  viewBox: 'viewBox',
	  viewTarget: 'viewTarget',
	  visibility: 0,
	  widths: 0,
	  wordSpacing: 'word-spacing',
	  writingMode: 'writing-mode',
	  x: 0,
	  xHeight: 'x-height',
	  x1: 0,
	  x2: 0,
	  xChannelSelector: 'xChannelSelector',
	  xlinkActuate: 'xlink:actuate',
	  xlinkArcrole: 'xlink:arcrole',
	  xlinkHref: 'xlink:href',
	  xlinkRole: 'xlink:role',
	  xlinkShow: 'xlink:show',
	  xlinkTitle: 'xlink:title',
	  xlinkType: 'xlink:type',
	  xmlBase: 'xml:base',
	  xmlns: 0,
	  xmlnsXlink: 'xmlns:xlink',
	  xmlLang: 'xml:lang',
	  xmlSpace: 'xml:space',
	  y: 0,
	  y1: 0,
	  y2: 0,
	  yChannelSelector: 'yChannelSelector',
	  z: 0,
	  zoomAndPan: 'zoomAndPan'
	};
	
	var SVGDOMPropertyConfig = {
	  Properties: {},
	  DOMAttributeNamespaces: {
	    xlinkActuate: NS.xlink,
	    xlinkArcrole: NS.xlink,
	    xlinkHref: NS.xlink,
	    xlinkRole: NS.xlink,
	    xlinkShow: NS.xlink,
	    xlinkTitle: NS.xlink,
	    xlinkType: NS.xlink,
	    xmlBase: NS.xml,
	    xmlLang: NS.xml,
	    xmlSpace: NS.xml
	  },
	  DOMAttributeNames: {}
	};
	
	Object.keys(ATTRS).forEach(function (key) {
	  SVGDOMPropertyConfig.Properties[key] = 0;
	  if (ATTRS[key]) {
	    SVGDOMPropertyConfig.DOMAttributeNames[key] = ATTRS[key];
	  }
	});
	
	module.exports = SVGDOMPropertyConfig;

/***/ },
/* 1894 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var EventPropagators = __webpack_require__(91);
	var ExecutionEnvironment = __webpack_require__(22);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInputSelection = __webpack_require__(402);
	var SyntheticEvent = __webpack_require__(43);
	
	var getActiveElement = __webpack_require__(276);
	var isTextInputElement = __webpack_require__(411);
	var shallowEqual = __webpack_require__(105);
	
	var skipSelectionChangeEvent = ExecutionEnvironment.canUseDOM && 'documentMode' in document && document.documentMode <= 11;
	
	var eventTypes = {
	  select: {
	    phasedRegistrationNames: {
	      bubbled: 'onSelect',
	      captured: 'onSelectCapture'
	    },
	    dependencies: ['topBlur', 'topContextMenu', 'topFocus', 'topKeyDown', 'topKeyUp', 'topMouseDown', 'topMouseUp', 'topSelectionChange']
	  }
	};
	
	var activeElement = null;
	var activeElementInst = null;
	var lastSelection = null;
	var mouseDown = false;
	
	// Track whether a listener exists for this plugin. If none exist, we do
	// not extract events. See #3639.
	var hasListener = false;
	
	/**
	 * Get an object which is a unique representation of the current selection.
	 *
	 * The return value will not be consistent across nodes or browsers, but
	 * two identical selections on the same node will return identical objects.
	 *
	 * @param {DOMElement} node
	 * @return {object}
	 */
	function getSelection(node) {
	  if ('selectionStart' in node && ReactInputSelection.hasSelectionCapabilities(node)) {
	    return {
	      start: node.selectionStart,
	      end: node.selectionEnd
	    };
	  } else if (window.getSelection) {
	    var selection = window.getSelection();
	    return {
	      anchorNode: selection.anchorNode,
	      anchorOffset: selection.anchorOffset,
	      focusNode: selection.focusNode,
	      focusOffset: selection.focusOffset
	    };
	  } else if (document.selection) {
	    var range = document.selection.createRange();
	    return {
	      parentElement: range.parentElement(),
	      text: range.text,
	      top: range.boundingTop,
	      left: range.boundingLeft
	    };
	  }
	}
	
	/**
	 * Poll selection to see whether it's changed.
	 *
	 * @param {object} nativeEvent
	 * @return {?SyntheticEvent}
	 */
	function constructSelectEvent(nativeEvent, nativeEventTarget) {
	  // Ensure we have the right element, and that the user is not dragging a
	  // selection (this matches native `select` event behavior). In HTML5, select
	  // fires only on input and textarea thus if there's no focused element we
	  // won't dispatch.
	  if (mouseDown || activeElement == null || activeElement !== getActiveElement()) {
	    return null;
	  }
	
	  // Only fire when selection has actually changed.
	  var currentSelection = getSelection(activeElement);
	  if (!lastSelection || !shallowEqual(lastSelection, currentSelection)) {
	    lastSelection = currentSelection;
	
	    var syntheticEvent = SyntheticEvent.getPooled(eventTypes.select, activeElementInst, nativeEvent, nativeEventTarget);
	
	    syntheticEvent.type = 'select';
	    syntheticEvent.target = activeElement;
	
	    EventPropagators.accumulateTwoPhaseDispatches(syntheticEvent);
	
	    return syntheticEvent;
	  }
	
	  return null;
	}
	
	/**
	 * This plugin creates an `onSelect` event that normalizes select events
	 * across form elements.
	 *
	 * Supported elements are:
	 * - input (see `isTextInputElement`)
	 * - textarea
	 * - contentEditable
	 *
	 * This differs from native browser implementations in the following ways:
	 * - Fires on contentEditable fields as well as inputs.
	 * - Fires for collapsed selection.
	 * - Fires after user input.
	 */
	var SelectEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    if (!hasListener) {
	      return null;
	    }
	
	    var targetNode = targetInst ? ReactDOMComponentTree.getNodeFromInstance(targetInst) : window;
	
	    switch (topLevelType) {
	      // Track the input node that has focus.
	      case 'topFocus':
	        if (isTextInputElement(targetNode) || targetNode.contentEditable === 'true') {
	          activeElement = targetNode;
	          activeElementInst = targetInst;
	          lastSelection = null;
	        }
	        break;
	      case 'topBlur':
	        activeElement = null;
	        activeElementInst = null;
	        lastSelection = null;
	        break;
	      // Don't fire the event while the user is dragging. This matches the
	      // semantics of the native select event.
	      case 'topMouseDown':
	        mouseDown = true;
	        break;
	      case 'topContextMenu':
	      case 'topMouseUp':
	        mouseDown = false;
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	      // Chrome and IE fire non-standard event when selection is changed (and
	      // sometimes when it hasn't). IE's event fires out of order with respect
	      // to key and input events on deletion, so we discard it.
	      //
	      // Firefox doesn't support selectionchange, so check selection status
	      // after each key entry. The selection changes after keydown and before
	      // keyup, but we check on keydown as well in the case of holding down a
	      // key, when multiple keydown events are fired but only one keyup is.
	      // This is also our approach for IE handling, for the reason above.
	      case 'topSelectionChange':
	        if (skipSelectionChangeEvent) {
	          break;
	        }
	      // falls through
	      case 'topKeyDown':
	      case 'topKeyUp':
	        return constructSelectEvent(nativeEvent, nativeEventTarget);
	    }
	
	    return null;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    if (registrationName === 'onSelect') {
	      hasListener = true;
	    }
	  }
	};
	
	module.exports = SelectEventPlugin;

/***/ },
/* 1895 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var EventListener = __webpack_require__(274);
	var EventPropagators = __webpack_require__(91);
	var ReactDOMComponentTree = __webpack_require__(20);
	var SyntheticAnimationEvent = __webpack_require__(1896);
	var SyntheticClipboardEvent = __webpack_require__(1897);
	var SyntheticEvent = __webpack_require__(43);
	var SyntheticFocusEvent = __webpack_require__(1900);
	var SyntheticKeyboardEvent = __webpack_require__(1902);
	var SyntheticMouseEvent = __webpack_require__(156);
	var SyntheticDragEvent = __webpack_require__(1899);
	var SyntheticTouchEvent = __webpack_require__(1903);
	var SyntheticTransitionEvent = __webpack_require__(1904);
	var SyntheticUIEvent = __webpack_require__(93);
	var SyntheticWheelEvent = __webpack_require__(1905);
	
	var emptyFunction = __webpack_require__(24);
	var getEventCharCode = __webpack_require__(235);
	var invariant = __webpack_require__(13);
	
	/**
	 * Turns
	 * ['abort', ...]
	 * into
	 * eventTypes = {
	 *   'abort': {
	 *     phasedRegistrationNames: {
	 *       bubbled: 'onAbort',
	 *       captured: 'onAbortCapture',
	 *     },
	 *     dependencies: ['topAbort'],
	 *   },
	 *   ...
	 * };
	 * topLevelEventsToDispatchConfig = {
	 *   'topAbort': { sameConfig }
	 * };
	 */
	var eventTypes = {};
	var topLevelEventsToDispatchConfig = {};
	['abort', 'animationEnd', 'animationIteration', 'animationStart', 'blur', 'canPlay', 'canPlayThrough', 'click', 'contextMenu', 'copy', 'cut', 'doubleClick', 'drag', 'dragEnd', 'dragEnter', 'dragExit', 'dragLeave', 'dragOver', 'dragStart', 'drop', 'durationChange', 'emptied', 'encrypted', 'ended', 'error', 'focus', 'input', 'invalid', 'keyDown', 'keyPress', 'keyUp', 'load', 'loadedData', 'loadedMetadata', 'loadStart', 'mouseDown', 'mouseMove', 'mouseOut', 'mouseOver', 'mouseUp', 'paste', 'pause', 'play', 'playing', 'progress', 'rateChange', 'reset', 'scroll', 'seeked', 'seeking', 'stalled', 'submit', 'suspend', 'timeUpdate', 'touchCancel', 'touchEnd', 'touchMove', 'touchStart', 'transitionEnd', 'volumeChange', 'waiting', 'wheel'].forEach(function (event) {
	  var capitalizedEvent = event[0].toUpperCase() + event.slice(1);
	  var onEvent = 'on' + capitalizedEvent;
	  var topEvent = 'top' + capitalizedEvent;
	
	  var type = {
	    phasedRegistrationNames: {
	      bubbled: onEvent,
	      captured: onEvent + 'Capture'
	    },
	    dependencies: [topEvent]
	  };
	  eventTypes[event] = type;
	  topLevelEventsToDispatchConfig[topEvent] = type;
	});
	
	var onClickListeners = {};
	
	function getDictionaryKey(inst) {
	  // Prevents V8 performance issue:
	  // https://github.com/facebook/react/pull/7232
	  return '.' + inst._rootNodeID;
	}
	
	function isInteractive(tag) {
	  return tag === 'button' || tag === 'input' || tag === 'select' || tag === 'textarea';
	}
	
	var SimpleEventPlugin = {
	  eventTypes: eventTypes,
	
	  extractEvents: function (topLevelType, targetInst, nativeEvent, nativeEventTarget) {
	    var dispatchConfig = topLevelEventsToDispatchConfig[topLevelType];
	    if (!dispatchConfig) {
	      return null;
	    }
	    var EventConstructor;
	    switch (topLevelType) {
	      case 'topAbort':
	      case 'topCanPlay':
	      case 'topCanPlayThrough':
	      case 'topDurationChange':
	      case 'topEmptied':
	      case 'topEncrypted':
	      case 'topEnded':
	      case 'topError':
	      case 'topInput':
	      case 'topInvalid':
	      case 'topLoad':
	      case 'topLoadedData':
	      case 'topLoadedMetadata':
	      case 'topLoadStart':
	      case 'topPause':
	      case 'topPlay':
	      case 'topPlaying':
	      case 'topProgress':
	      case 'topRateChange':
	      case 'topReset':
	      case 'topSeeked':
	      case 'topSeeking':
	      case 'topStalled':
	      case 'topSubmit':
	      case 'topSuspend':
	      case 'topTimeUpdate':
	      case 'topVolumeChange':
	      case 'topWaiting':
	        // HTML Events
	        // @see http://www.w3.org/TR/html5/index.html#events-0
	        EventConstructor = SyntheticEvent;
	        break;
	      case 'topKeyPress':
	        // Firefox creates a keypress event for function keys too. This removes
	        // the unwanted keypress events. Enter is however both printable and
	        // non-printable. One would expect Tab to be as well (but it isn't).
	        if (getEventCharCode(nativeEvent) === 0) {
	          return null;
	        }
	      /* falls through */
	      case 'topKeyDown':
	      case 'topKeyUp':
	        EventConstructor = SyntheticKeyboardEvent;
	        break;
	      case 'topBlur':
	      case 'topFocus':
	        EventConstructor = SyntheticFocusEvent;
	        break;
	      case 'topClick':
	        // Firefox creates a click event on right mouse clicks. This removes the
	        // unwanted click events.
	        if (nativeEvent.button === 2) {
	          return null;
	        }
	      /* falls through */
	      case 'topDoubleClick':
	      case 'topMouseDown':
	      case 'topMouseMove':
	      case 'topMouseUp':
	      // TODO: Disabled elements should not respond to mouse events
	      /* falls through */
	      case 'topMouseOut':
	      case 'topMouseOver':
	      case 'topContextMenu':
	        EventConstructor = SyntheticMouseEvent;
	        break;
	      case 'topDrag':
	      case 'topDragEnd':
	      case 'topDragEnter':
	      case 'topDragExit':
	      case 'topDragLeave':
	      case 'topDragOver':
	      case 'topDragStart':
	      case 'topDrop':
	        EventConstructor = SyntheticDragEvent;
	        break;
	      case 'topTouchCancel':
	      case 'topTouchEnd':
	      case 'topTouchMove':
	      case 'topTouchStart':
	        EventConstructor = SyntheticTouchEvent;
	        break;
	      case 'topAnimationEnd':
	      case 'topAnimationIteration':
	      case 'topAnimationStart':
	        EventConstructor = SyntheticAnimationEvent;
	        break;
	      case 'topTransitionEnd':
	        EventConstructor = SyntheticTransitionEvent;
	        break;
	      case 'topScroll':
	        EventConstructor = SyntheticUIEvent;
	        break;
	      case 'topWheel':
	        EventConstructor = SyntheticWheelEvent;
	        break;
	      case 'topCopy':
	      case 'topCut':
	      case 'topPaste':
	        EventConstructor = SyntheticClipboardEvent;
	        break;
	    }
	    !EventConstructor ?  false ? invariant(false, 'SimpleEventPlugin: Unhandled event type, `%s`.', topLevelType) : _prodInvariant('86', topLevelType) : void 0;
	    var event = EventConstructor.getPooled(dispatchConfig, targetInst, nativeEvent, nativeEventTarget);
	    EventPropagators.accumulateTwoPhaseDispatches(event);
	    return event;
	  },
	
	  didPutListener: function (inst, registrationName, listener) {
	    // Mobile Safari does not fire properly bubble click events on
	    // non-interactive elements, which means delegated click listeners do not
	    // fire. The workaround for this bug involves attaching an empty click
	    // listener on the target node.
	    // http://www.quirksmode.org/blog/archives/2010/09/click_event_del.html
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      var node = ReactDOMComponentTree.getNodeFromInstance(inst);
	      if (!onClickListeners[key]) {
	        onClickListeners[key] = EventListener.listen(node, 'click', emptyFunction);
	      }
	    }
	  },
	
	  willDeleteListener: function (inst, registrationName) {
	    if (registrationName === 'onClick' && !isInteractive(inst._tag)) {
	      var key = getDictionaryKey(inst);
	      onClickListeners[key].remove();
	      delete onClickListeners[key];
	    }
	  }
	};
	
	module.exports = SimpleEventPlugin;

/***/ },
/* 1896 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/css3-animations/#AnimationEvent-interface
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/AnimationEvent
	 */
	var AnimationEventInterface = {
	  animationName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticAnimationEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticAnimationEvent, AnimationEventInterface);
	
	module.exports = SyntheticAnimationEvent;

/***/ },
/* 1897 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/clipboard-apis/
	 */
	var ClipboardEventInterface = {
	  clipboardData: function (event) {
	    return 'clipboardData' in event ? event.clipboardData : window.clipboardData;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticClipboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticClipboardEvent, ClipboardEventInterface);
	
	module.exports = SyntheticClipboardEvent;

/***/ },
/* 1898 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/#events-compositionevents
	 */
	var CompositionEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticCompositionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticCompositionEvent, CompositionEventInterface);
	
	module.exports = SyntheticCompositionEvent;

/***/ },
/* 1899 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(156);
	
	/**
	 * @interface DragEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var DragEventInterface = {
	  dataTransfer: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticDragEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticDragEvent, DragEventInterface);
	
	module.exports = SyntheticDragEvent;

/***/ },
/* 1900 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(93);
	
	/**
	 * @interface FocusEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var FocusEventInterface = {
	  relatedTarget: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticFocusEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticFocusEvent, FocusEventInterface);
	
	module.exports = SyntheticFocusEvent;

/***/ },
/* 1901 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2013/WD-DOM-Level-3-Events-20131105
	 *      /#events-inputevents
	 */
	var InputEventInterface = {
	  data: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticInputEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticInputEvent, InputEventInterface);
	
	module.exports = SyntheticInputEvent;

/***/ },
/* 1902 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(93);
	
	var getEventCharCode = __webpack_require__(235);
	var getEventKey = __webpack_require__(1910);
	var getEventModifierState = __webpack_require__(236);
	
	/**
	 * @interface KeyboardEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var KeyboardEventInterface = {
	  key: getEventKey,
	  location: null,
	  ctrlKey: null,
	  shiftKey: null,
	  altKey: null,
	  metaKey: null,
	  repeat: null,
	  locale: null,
	  getModifierState: getEventModifierState,
	  // Legacy Interface
	  charCode: function (event) {
	    // `charCode` is the result of a KeyPress event and represents the value of
	    // the actual printable character.
	
	    // KeyPress is deprecated, but its replacement is not yet final and not
	    // implemented in any major browser. Only KeyPress has charCode.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    return 0;
	  },
	  keyCode: function (event) {
	    // `keyCode` is the result of a KeyDown/Up event and represents the value of
	    // physical keyboard key.
	
	    // The actual meaning of the value depends on the users' keyboard layout
	    // which cannot be detected. Assuming that it is a US keyboard layout
	    // provides a surprisingly accurate mapping for US and European users.
	    // Due to this, it is left to the user to implement at this time.
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  },
	  which: function (event) {
	    // `which` is an alias for either `keyCode` or `charCode` depending on the
	    // type of the event.
	    if (event.type === 'keypress') {
	      return getEventCharCode(event);
	    }
	    if (event.type === 'keydown' || event.type === 'keyup') {
	      return event.keyCode;
	    }
	    return 0;
	  }
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticKeyboardEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticKeyboardEvent, KeyboardEventInterface);
	
	module.exports = SyntheticKeyboardEvent;

/***/ },
/* 1903 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticUIEvent = __webpack_require__(93);
	
	var getEventModifierState = __webpack_require__(236);
	
	/**
	 * @interface TouchEvent
	 * @see http://www.w3.org/TR/touch-events/
	 */
	var TouchEventInterface = {
	  touches: null,
	  targetTouches: null,
	  changedTouches: null,
	  altKey: null,
	  metaKey: null,
	  ctrlKey: null,
	  shiftKey: null,
	  getModifierState: getEventModifierState
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticUIEvent}
	 */
	function SyntheticTouchEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticUIEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticUIEvent.augmentClass(SyntheticTouchEvent, TouchEventInterface);
	
	module.exports = SyntheticTouchEvent;

/***/ },
/* 1904 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticEvent = __webpack_require__(43);
	
	/**
	 * @interface Event
	 * @see http://www.w3.org/TR/2009/WD-css3-transitions-20090320/#transition-events-
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/TransitionEvent
	 */
	var TransitionEventInterface = {
	  propertyName: null,
	  elapsedTime: null,
	  pseudoElement: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticEvent}
	 */
	function SyntheticTransitionEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticEvent.augmentClass(SyntheticTransitionEvent, TransitionEventInterface);
	
	module.exports = SyntheticTransitionEvent;

/***/ },
/* 1905 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var SyntheticMouseEvent = __webpack_require__(156);
	
	/**
	 * @interface WheelEvent
	 * @see http://www.w3.org/TR/DOM-Level-3-Events/
	 */
	var WheelEventInterface = {
	  deltaX: function (event) {
	    return 'deltaX' in event ? event.deltaX : // Fallback to `wheelDeltaX` for Webkit and normalize (right is positive).
	    'wheelDeltaX' in event ? -event.wheelDeltaX : 0;
	  },
	  deltaY: function (event) {
	    return 'deltaY' in event ? event.deltaY : // Fallback to `wheelDeltaY` for Webkit and normalize (down is positive).
	    'wheelDeltaY' in event ? -event.wheelDeltaY : // Fallback to `wheelDelta` for IE<9 and normalize (down is positive).
	    'wheelDelta' in event ? -event.wheelDelta : 0;
	  },
	  deltaZ: null,
	
	  // Browsers without "deltaMode" is reporting in raw wheel delta where one
	  // notch on the scroll is always +/- 120, roughly equivalent to pixels.
	  // A good approximation of DOM_DELTA_LINE (1) is 5% of viewport size or
	  // ~40 pixels, for DOM_DELTA_SCREEN (2) it is 87.5% of viewport size.
	  deltaMode: null
	};
	
	/**
	 * @param {object} dispatchConfig Configuration used to dispatch this event.
	 * @param {string} dispatchMarker Marker identifying the event target.
	 * @param {object} nativeEvent Native browser event.
	 * @extends {SyntheticMouseEvent}
	 */
	function SyntheticWheelEvent(dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget) {
	  return SyntheticMouseEvent.call(this, dispatchConfig, dispatchMarker, nativeEvent, nativeEventTarget);
	}
	
	SyntheticMouseEvent.augmentClass(SyntheticWheelEvent, WheelEventInterface);
	
	module.exports = SyntheticWheelEvent;

/***/ },
/* 1906 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var MOD = 65521;
	
	// adler32 is not cryptographically strong, and is only used to sanity check that
	// markup generated on the server matches the markup generated on the client.
	// This implementation (a modified version of the SheetJS version) has been optimized
	// for our use case, at the expense of conforming to the adler32 specification
	// for non-ascii inputs.
	function adler32(data) {
	  var a = 1;
	  var b = 0;
	  var i = 0;
	  var l = data.length;
	  var m = l & ~0x3;
	  while (i < m) {
	    var n = Math.min(i + 4096, m);
	    for (; i < n; i += 4) {
	      b += (a += data.charCodeAt(i)) + (a += data.charCodeAt(i + 1)) + (a += data.charCodeAt(i + 2)) + (a += data.charCodeAt(i + 3));
	    }
	    a %= MOD;
	    b %= MOD;
	  }
	  for (; i < l; i++) {
	    b += a += data.charCodeAt(i);
	  }
	  a %= MOD;
	  b %= MOD;
	  return a | b << 16;
	}
	
	module.exports = adler32;

/***/ },
/* 1907 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var CSSProperty = __webpack_require__(394);
	var warning = __webpack_require__(16);
	
	var isUnitlessNumber = CSSProperty.isUnitlessNumber;
	var styleWarnings = {};
	
	/**
	 * Convert a value into the proper css writable value. The style name `name`
	 * should be logical (no hyphens), as specified
	 * in `CSSProperty.isUnitlessNumber`.
	 *
	 * @param {string} name CSS property name such as `topMargin`.
	 * @param {*} value CSS property value such as `10px`.
	 * @param {ReactDOMComponent} component
	 * @return {string} Normalized style value with dimensions applied.
	 */
	function dangerousStyleValue(name, value, component, isCustomProperty) {
	  // Note that we've removed escapeTextForBrowser() calls here since the
	  // whole string will be escaped when the attribute is injected into
	  // the markup. If you provide unsafe user data here they can inject
	  // arbitrary CSS which may be problematic (I couldn't repro this):
	  // https://www.owasp.org/index.php/XSS_Filter_Evasion_Cheat_Sheet
	  // http://www.thespanner.co.uk/2007/11/26/ultimate-xss-css-injection/
	  // This is not an XSS hole but instead a potential CSS injection issue
	  // which has lead to a greater discussion about how we're going to
	  // trust URLs moving forward. See #2115901
	
	  var isEmpty = value == null || typeof value === 'boolean' || value === '';
	  if (isEmpty) {
	    return '';
	  }
	
	  var isNonNumeric = isNaN(value);
	  if (isCustomProperty || isNonNumeric || value === 0 || isUnitlessNumber.hasOwnProperty(name) && isUnitlessNumber[name]) {
	    return '' + value; // cast to string
	  }
	
	  if (typeof value === 'string') {
	    if (false) {
	      // Allow '0' to pass through without warning. 0 is already special and
	      // doesn't require units, so we don't need to warn about it.
	      if (component && value !== '0') {
	        var owner = component._currentElement._owner;
	        var ownerName = owner ? owner.getName() : null;
	        if (ownerName && !styleWarnings[ownerName]) {
	          styleWarnings[ownerName] = {};
	        }
	        var warned = false;
	        if (ownerName) {
	          var warnings = styleWarnings[ownerName];
	          warned = warnings[name];
	          if (!warned) {
	            warnings[name] = true;
	          }
	        }
	        if (!warned) {
	          process.env.NODE_ENV !== 'production' ? warning(false, 'a `%s` tag (owner: `%s`) was passed a numeric string value ' + 'for CSS property `%s` (value: `%s`) which will be treated ' + 'as a unitless number in a future version of React.', component._currentElement.type, ownerName || 'unknown', name, value) : void 0;
	        }
	      }
	    }
	    value = value.trim();
	  }
	  return value + 'px';
	}
	
	module.exports = dangerousStyleValue;

/***/ },
/* 1908 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(17);
	
	var ReactCurrentOwner = __webpack_require__(45);
	var ReactDOMComponentTree = __webpack_require__(20);
	var ReactInstanceMap = __webpack_require__(119);
	
	var getHostComponentFromComposite = __webpack_require__(407);
	var invariant = __webpack_require__(13);
	var warning = __webpack_require__(16);
	
	/**
	 * Returns the DOM node rendered by this element.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#reactdom.finddomnode
	 *
	 * @param {ReactComponent|DOMElement} componentOrElement
	 * @return {?DOMElement} The root node of this element.
	 */
	function findDOMNode(componentOrElement) {
	  if (false) {
	    var owner = ReactCurrentOwner.current;
	    if (owner !== null) {
	      process.env.NODE_ENV !== 'production' ? warning(owner._warnedAboutRefsInRender, '%s is accessing findDOMNode inside its render(). ' + 'render() should be a pure function of props and state. It should ' + 'never access something that requires stale data from the previous ' + 'render, such as refs. Move this logic to componentDidMount and ' + 'componentDidUpdate instead.', owner.getName() || 'A component') : void 0;
	      owner._warnedAboutRefsInRender = true;
	    }
	  }
	  if (componentOrElement == null) {
	    return null;
	  }
	  if (componentOrElement.nodeType === 1) {
	    return componentOrElement;
	  }
	
	  var inst = ReactInstanceMap.get(componentOrElement);
	  if (inst) {
	    inst = getHostComponentFromComposite(inst);
	    return inst ? ReactDOMComponentTree.getNodeFromInstance(inst) : null;
	  }
	
	  if (typeof componentOrElement.render === 'function') {
	     true ?  false ? invariant(false, 'findDOMNode was called on an unmounted component.') : _prodInvariant('44') : void 0;
	  } else {
	     true ?  false ? invariant(false, 'Element appears to be neither ReactComponent nor DOMNode (keys: %s)', Object.keys(componentOrElement)) : _prodInvariant('45', Object.keys(componentOrElement)) : void 0;
	  }
	}
	
	module.exports = findDOMNode;

/***/ },
/* 1909 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(process) {/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var KeyEscapeUtils = __webpack_require__(228);
	var traverseAllChildren = __webpack_require__(413);
	var warning = __webpack_require__(16);
	
	var ReactComponentTreeHook;
	
	if (typeof process !== 'undefined' && ({"NODE_ENV":"production","PUBLIC_URL":""}) && ("production") === 'test') {
	  // Temporary hack.
	  // Inline requires don't work well with Jest:
	  // https://github.com/facebook/react/issues/7240
	  // Remove the inline requires when we don't need them anymore:
	  // https://github.com/facebook/react/pull/7178
	  ReactComponentTreeHook = __webpack_require__(424);
	}
	
	/**
	 * @param {function} traverseContext Context passed through traversal.
	 * @param {?ReactComponent} child React child component.
	 * @param {!string} name String name of key path to child.
	 * @param {number=} selfDebugID Optional debugID of the current internal instance.
	 */
	function flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID) {
	  // We found a component instance.
	  if (traverseContext && typeof traverseContext === 'object') {
	    var result = traverseContext;
	    var keyUnique = result[name] === undefined;
	    if (false) {
	      if (!ReactComponentTreeHook) {
	        ReactComponentTreeHook = require('react/lib/ReactComponentTreeHook');
	      }
	      if (!keyUnique) {
	        process.env.NODE_ENV !== 'production' ? warning(false, 'flattenChildren(...): Encountered two children with the same key, ' + '`%s`. Child keys must be unique; when two children share a key, only ' + 'the first child will be used.%s', KeyEscapeUtils.unescape(name), ReactComponentTreeHook.getStackAddendumByID(selfDebugID)) : void 0;
	      }
	    }
	    if (keyUnique && child != null) {
	      result[name] = child;
	    }
	  }
	}
	
	/**
	 * Flattens children that are typically specified as `props.children`. Any null
	 * children will not be included in the resulting object.
	 * @return {!object} flattened children keyed by name.
	 */
	function flattenChildren(children, selfDebugID) {
	  if (children == null) {
	    return children;
	  }
	  var result = {};
	
	  if (false) {
	    traverseAllChildren(children, function (traverseContext, child, name) {
	      return flattenSingleChildIntoContext(traverseContext, child, name, selfDebugID);
	    }, result);
	  } else {
	    traverseAllChildren(children, flattenSingleChildIntoContext, result);
	  }
	  return result;
	}
	
	module.exports = flattenChildren;
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(65)))

/***/ },
/* 1910 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var getEventCharCode = __webpack_require__(235);
	
	/**
	 * Normalization of deprecated HTML5 `key` values
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var normalizeKey = {
	  Esc: 'Escape',
	  Spacebar: ' ',
	  Left: 'ArrowLeft',
	  Up: 'ArrowUp',
	  Right: 'ArrowRight',
	  Down: 'ArrowDown',
	  Del: 'Delete',
	  Win: 'OS',
	  Menu: 'ContextMenu',
	  Apps: 'ContextMenu',
	  Scroll: 'ScrollLock',
	  MozPrintableKey: 'Unidentified'
	};
	
	/**
	 * Translation from legacy `keyCode` to HTML5 `key`
	 * Only special keys supported, all others depend on keyboard layout or browser
	 * @see https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent#Key_names
	 */
	var translateToKey = {
	  8: 'Backspace',
	  9: 'Tab',
	  12: 'Clear',
	  13: 'Enter',
	  16: 'Shift',
	  17: 'Control',
	  18: 'Alt',
	  19: 'Pause',
	  20: 'CapsLock',
	  27: 'Escape',
	  32: ' ',
	  33: 'PageUp',
	  34: 'PageDown',
	  35: 'End',
	  36: 'Home',
	  37: 'ArrowLeft',
	  38: 'ArrowUp',
	  39: 'ArrowRight',
	  40: 'ArrowDown',
	  45: 'Insert',
	  46: 'Delete',
	  112: 'F1',
	  113: 'F2',
	  114: 'F3',
	  115: 'F4',
	  116: 'F5',
	  117: 'F6',
	  118: 'F7',
	  119: 'F8',
	  120: 'F9',
	  121: 'F10',
	  122: 'F11',
	  123: 'F12',
	  144: 'NumLock',
	  145: 'ScrollLock',
	  224: 'Meta'
	};
	
	/**
	 * @param {object} nativeEvent Native browser event.
	 * @return {string} Normalized `key` property.
	 */
	function getEventKey(nativeEvent) {
	  if (nativeEvent.key) {
	    // Normalize inconsistent values reported by browsers due to
	    // implementations of a working draft specification.
	
	    // FireFox implements `key` but returns `MozPrintableKey` for all
	    // printable characters (normalized to `Unidentified`), ignore it.
	    var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
	    if (key !== 'Unidentified') {
	      return key;
	    }
	  }
	
	  // Browser does not implement `key`, polyfill as much of it as we can.
	  if (nativeEvent.type === 'keypress') {
	    var charCode = getEventCharCode(nativeEvent);
	
	    // The enter-key is technically both printable and non-printable and can
	    // thus be captured by `keypress`, no other non-printable key should.
	    return charCode === 13 ? 'Enter' : String.fromCharCode(charCode);
	  }
	  if (nativeEvent.type === 'keydown' || nativeEvent.type === 'keyup') {
	    // While user keyboard layout determines the actual meaning of each
	    // `keyCode` value, almost all function keys have a universal value.
	    return translateToKey[nativeEvent.keyCode] || 'Unidentified';
	  }
	  return '';
	}
	
	module.exports = getEventKey;

/***/ },
/* 1911 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	/* global Symbol */
	
	var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
	var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.
	
	/**
	 * Returns the iterator method function contained on the iterable object.
	 *
	 * Be sure to invoke the function with the iterable as context:
	 *
	 *     var iteratorFn = getIteratorFn(myIterable);
	 *     if (iteratorFn) {
	 *       var iterator = iteratorFn.call(myIterable);
	 *       ...
	 *     }
	 *
	 * @param {?object} maybeIterable
	 * @return {?function}
	 */
	function getIteratorFn(maybeIterable) {
	  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
	  if (typeof iteratorFn === 'function') {
	    return iteratorFn;
	  }
	}
	
	module.exports = getIteratorFn;

/***/ },
/* 1912 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Given any node return the first leaf node without children.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {DOMElement|DOMTextNode}
	 */
	
	function getLeafNode(node) {
	  while (node && node.firstChild) {
	    node = node.firstChild;
	  }
	  return node;
	}
	
	/**
	 * Get the next sibling within a container. This will walk up the
	 * DOM if a node's siblings have been exhausted.
	 *
	 * @param {DOMElement|DOMTextNode} node
	 * @return {?DOMElement|DOMTextNode}
	 */
	function getSiblingNode(node) {
	  while (node) {
	    if (node.nextSibling) {
	      return node.nextSibling;
	    }
	    node = node.parentNode;
	  }
	}
	
	/**
	 * Get object describing the nodes which contain characters at offset.
	 *
	 * @param {DOMElement|DOMTextNode} root
	 * @param {number} offset
	 * @return {?object}
	 */
	function getNodeForCharacterOffset(root, offset) {
	  var node = getLeafNode(root);
	  var nodeStart = 0;
	  var nodeEnd = 0;
	
	  while (node) {
	    if (node.nodeType === 3) {
	      nodeEnd = nodeStart + node.textContent.length;
	
	      if (nodeStart <= offset && nodeEnd >= offset) {
	        return {
	          node: node,
	          offset: offset - nodeStart
	        };
	      }
	
	      nodeStart = nodeEnd;
	    }
	
	    node = getLeafNode(getSiblingNode(node));
	  }
	}
	
	module.exports = getNodeForCharacterOffset;

/***/ },
/* 1913 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ExecutionEnvironment = __webpack_require__(22);
	
	/**
	 * Generate a mapping of standard vendor prefixes using the defined style property and event name.
	 *
	 * @param {string} styleProp
	 * @param {string} eventName
	 * @returns {object}
	 */
	function makePrefixMap(styleProp, eventName) {
	  var prefixes = {};
	
	  prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
	  prefixes['Webkit' + styleProp] = 'webkit' + eventName;
	  prefixes['Moz' + styleProp] = 'moz' + eventName;
	  prefixes['ms' + styleProp] = 'MS' + eventName;
	  prefixes['O' + styleProp] = 'o' + eventName.toLowerCase();
	
	  return prefixes;
	}
	
	/**
	 * A list of event names to a configurable list of vendor prefixes.
	 */
	var vendorPrefixes = {
	  animationend: makePrefixMap('Animation', 'AnimationEnd'),
	  animationiteration: makePrefixMap('Animation', 'AnimationIteration'),
	  animationstart: makePrefixMap('Animation', 'AnimationStart'),
	  transitionend: makePrefixMap('Transition', 'TransitionEnd')
	};
	
	/**
	 * Event names that have already been detected and prefixed (if applicable).
	 */
	var prefixedEventNames = {};
	
	/**
	 * Element to check for prefixes on.
	 */
	var style = {};
	
	/**
	 * Bootstrap if a DOM exists.
	 */
	if (ExecutionEnvironment.canUseDOM) {
	  style = document.createElement('div').style;
	
	  // On some platforms, in particular some releases of Android 4.x,
	  // the un-prefixed "animation" and "transition" properties are defined on the
	  // style object but the events that fire will still be prefixed, so we need
	  // to check if the un-prefixed events are usable, and if not remove them from the map.
	  if (!('AnimationEvent' in window)) {
	    delete vendorPrefixes.animationend.animation;
	    delete vendorPrefixes.animationiteration.animation;
	    delete vendorPrefixes.animationstart.animation;
	  }
	
	  // Same as above
	  if (!('TransitionEvent' in window)) {
	    delete vendorPrefixes.transitionend.transition;
	  }
	}
	
	/**
	 * Attempts to determine the correct vendor prefixed event name.
	 *
	 * @param {string} eventName
	 * @returns {string}
	 */
	function getVendorPrefixedEventName(eventName) {
	  if (prefixedEventNames[eventName]) {
	    return prefixedEventNames[eventName];
	  } else if (!vendorPrefixes[eventName]) {
	    return eventName;
	  }
	
	  var prefixMap = vendorPrefixes[eventName];
	
	  for (var styleProp in prefixMap) {
	    if (prefixMap.hasOwnProperty(styleProp) && styleProp in style) {
	      return prefixedEventNames[eventName] = prefixMap[styleProp];
	    }
	  }
	
	  return '';
	}
	
	module.exports = getVendorPrefixedEventName;

/***/ },
/* 1914 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var escapeTextContentForBrowser = __webpack_require__(158);
	
	/**
	 * Escapes attribute value to prevent scripting attacks.
	 *
	 * @param {*} value Value to escape.
	 * @return {string} An escaped string.
	 */
	function quoteAttributeValueForBrowser(value) {
	  return '"' + escapeTextContentForBrowser(value) + '"';
	}
	
	module.exports = quoteAttributeValueForBrowser;

/***/ },
/* 1915 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactMount = __webpack_require__(403);
	
	module.exports = ReactMount.renderSubtreeIntoContainer;

/***/ },
/* 1916 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _defineProperty = __webpack_require__(162);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	exports.default = defineProperty;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	//  weak
	
	function defineProperty(o, p, attr) {
	  return (0, _defineProperty2.default)(o, p, attr);
	}

/***/ },
/* 1917 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.passiveOption = exports.detachEvent = exports.attachEvent = exports.removeEventListener = exports.addEventListener = exports.canUseDOM = undefined;
	
	var _defineProperty = __webpack_require__(1916);
	
	var _defineProperty2 = _interopRequireDefault(_defineProperty);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Inspired by https://github.com/facebook/fbjs/blob/master/packages/fbjs/src/core/ExecutionEnvironment.js
	var canUseDOM = exports.canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
	
	var addEventListener = exports.addEventListener = canUseDOM && 'addEventListener' in window;
	var removeEventListener = exports.removeEventListener = canUseDOM && 'removeEventListener' in window;
	
	// IE8+ Support
	var attachEvent = exports.attachEvent = canUseDOM && 'attachEvent' in window;
	var detachEvent = exports.detachEvent = canUseDOM && 'detachEvent' in window;
	
	// Passive options
	// Inspired by https://github.com/Modernizr/Modernizr/blob/master/feature-detects/dom/passiveeventlisteners.js
	var passiveOption = exports.passiveOption = function () {
	  var cache = null;
	
	  return function () {
	    if (cache !== null) {
	      return cache;
	    }
	
	    var supportsPassiveOption = false;
	
	    try {
	      window.addEventListener('test', null, (0, _defineProperty2.default)({}, 'passive', {
	        get: function get() {
	          supportsPassiveOption = true;
	        }
	      }));
	    } catch (e) {} // eslint-disable-line no-empty
	
	    cache = supportsPassiveOption;
	
	    return supportsPassiveOption;
	  }();
	}();

/***/ },
/* 1918 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.createProvider = createProvider;
	
	var _react = __webpack_require__(1);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PropTypes = __webpack_require__(416);
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var didWarnAboutReceivingStore = false;
	function warnAboutReceivingStore() {
	  if (didWarnAboutReceivingStore) {
	    return;
	  }
	  didWarnAboutReceivingStore = true;
	
	  (0, _warning2.default)('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reactjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
	}
	
	function createProvider() {
	  var _Provider$childContex;
	
	  var storeKey = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 'store';
	  var subKey = arguments[1];
	
	  var subscriptionKey = subKey || storeKey + 'Subscription';
	
	  var Provider = function (_Component) {
	    _inherits(Provider, _Component);
	
	    Provider.prototype.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
	    };
	
	    function Provider(props, context) {
	      _classCallCheck(this, Provider);
	
	      var _this = _possibleConstructorReturn(this, _Component.call(this, props, context));
	
	      _this[storeKey] = props.store;
	      return _this;
	    }
	
	    Provider.prototype.render = function render() {
	      return _react.Children.only(this.props.children);
	    };
	
	    return Provider;
	  }(_react.Component);
	
	  if (false) {
	    Provider.prototype.componentWillReceiveProps = function (nextProps) {
	      if (this[storeKey] !== nextProps.store) {
	        warnAboutReceivingStore();
	      }
	    };
	  }
	
	  Provider.propTypes = {
	    store: _PropTypes.storeShape.isRequired,
	    children: _propTypes2.default.element.isRequired
	  };
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = _PropTypes.storeShape.isRequired, _Provider$childContex[subscriptionKey] = _PropTypes.subscriptionShape, _Provider$childContex);
	
	  return Provider;
	}
	
	exports.default = createProvider();

/***/ },
/* 1919 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.createConnect = createConnect;
	
	var _connectAdvanced = __webpack_require__(414);
	
	var _connectAdvanced2 = _interopRequireDefault(_connectAdvanced);
	
	var _shallowEqual = __webpack_require__(1926);
	
	var _shallowEqual2 = _interopRequireDefault(_shallowEqual);
	
	var _mapDispatchToProps = __webpack_require__(1920);
	
	var _mapDispatchToProps2 = _interopRequireDefault(_mapDispatchToProps);
	
	var _mapStateToProps = __webpack_require__(1921);
	
	var _mapStateToProps2 = _interopRequireDefault(_mapStateToProps);
	
	var _mergeProps = __webpack_require__(1922);
	
	var _mergeProps2 = _interopRequireDefault(_mergeProps);
	
	var _selectorFactory = __webpack_require__(1923);
	
	var _selectorFactory2 = _interopRequireDefault(_selectorFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/*
	  connect is a facade over connectAdvanced. It turns its args into a compatible
	  selectorFactory, which has the signature:
	
	    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
	  
	  connect passes its args to connectAdvanced as options, which will in turn pass them to
	  selectorFactory each time a Connect component instance is instantiated or hot reloaded.
	
	  selectorFactory returns a final props selector from its mapStateToProps,
	  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
	  mergePropsFactories, and pure args.
	
	  The resulting final props selector is called by the Connect component instance whenever
	  it receives new props or store state.
	 */
	
	function match(arg, factories, name) {
	  for (var i = factories.length - 1; i >= 0; i--) {
	    var result = factories[i](arg);
	    if (result) return result;
	  }
	
	  return function (dispatch, options) {
	    throw new Error('Invalid value of type ' + typeof arg + ' for ' + name + ' argument when connecting component ' + options.wrappedComponentName + '.');
	  };
	}
	
	function strictEqual(a, b) {
	  return a === b;
	}
	
	// createConnect with default args builds the 'official' connect behavior. Calling it with
	// different options opens up some testing and extensibility scenarios
	function createConnect() {
	  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
	      _ref$connectHOC = _ref.connectHOC,
	      connectHOC = _ref$connectHOC === undefined ? _connectAdvanced2.default : _ref$connectHOC,
	      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
	      mapStateToPropsFactories = _ref$mapStateToPropsF === undefined ? _mapStateToProps2.default : _ref$mapStateToPropsF,
	      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
	      mapDispatchToPropsFactories = _ref$mapDispatchToPro === undefined ? _mapDispatchToProps2.default : _ref$mapDispatchToPro,
	      _ref$mergePropsFactor = _ref.mergePropsFactories,
	      mergePropsFactories = _ref$mergePropsFactor === undefined ? _mergeProps2.default : _ref$mergePropsFactor,
	      _ref$selectorFactory = _ref.selectorFactory,
	      selectorFactory = _ref$selectorFactory === undefined ? _selectorFactory2.default : _ref$selectorFactory;
	
	  return function connect(mapStateToProps, mapDispatchToProps, mergeProps) {
	    var _ref2 = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {},
	        _ref2$pure = _ref2.pure,
	        pure = _ref2$pure === undefined ? true : _ref2$pure,
	        _ref2$areStatesEqual = _ref2.areStatesEqual,
	        areStatesEqual = _ref2$areStatesEqual === undefined ? strictEqual : _ref2$areStatesEqual,
	        _ref2$areOwnPropsEqua = _ref2.areOwnPropsEqual,
	        areOwnPropsEqual = _ref2$areOwnPropsEqua === undefined ? _shallowEqual2.default : _ref2$areOwnPropsEqua,
	        _ref2$areStatePropsEq = _ref2.areStatePropsEqual,
	        areStatePropsEqual = _ref2$areStatePropsEq === undefined ? _shallowEqual2.default : _ref2$areStatePropsEq,
	        _ref2$areMergedPropsE = _ref2.areMergedPropsEqual,
	        areMergedPropsEqual = _ref2$areMergedPropsE === undefined ? _shallowEqual2.default : _ref2$areMergedPropsE,
	        extraOptions = _objectWithoutProperties(_ref2, ['pure', 'areStatesEqual', 'areOwnPropsEqual', 'areStatePropsEqual', 'areMergedPropsEqual']);
	
	    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
	    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
	    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
	
	    return connectHOC(selectorFactory, _extends({
	      // used in error messages
	      methodName: 'connect',
	
	      // used to compute Connect's displayName from the wrapped component's displayName.
	      getDisplayName: function getDisplayName(name) {
	        return 'Connect(' + name + ')';
	      },
	
	      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
	      shouldHandleStateChanges: Boolean(mapStateToProps),
	
	      // passed through to selectorFactory
	      initMapStateToProps: initMapStateToProps,
	      initMapDispatchToProps: initMapDispatchToProps,
	      initMergeProps: initMergeProps,
	      pure: pure,
	      areStatesEqual: areStatesEqual,
	      areOwnPropsEqual: areOwnPropsEqual,
	      areStatePropsEqual: areStatePropsEqual,
	      areMergedPropsEqual: areMergedPropsEqual
	
	    }, extraOptions));
	  };
	}
	
	exports.default = createConnect();

/***/ },
/* 1920 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapDispatchToPropsIsFunction = whenMapDispatchToPropsIsFunction;
	exports.whenMapDispatchToPropsIsMissing = whenMapDispatchToPropsIsMissing;
	exports.whenMapDispatchToPropsIsObject = whenMapDispatchToPropsIsObject;
	
	var _redux = __webpack_require__(121);
	
	var _wrapMapToProps = __webpack_require__(415);
	
	function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
	  return typeof mapDispatchToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapDispatchToProps, 'mapDispatchToProps') : undefined;
	}
	
	function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
	  return !mapDispatchToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return { dispatch: dispatch };
	  }) : undefined;
	}
	
	function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
	  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function (dispatch) {
	    return (0, _redux.bindActionCreators)(mapDispatchToProps, dispatch);
	  }) : undefined;
	}
	
	exports.default = [whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject];

/***/ },
/* 1921 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.whenMapStateToPropsIsFunction = whenMapStateToPropsIsFunction;
	exports.whenMapStateToPropsIsMissing = whenMapStateToPropsIsMissing;
	
	var _wrapMapToProps = __webpack_require__(415);
	
	function whenMapStateToPropsIsFunction(mapStateToProps) {
	  return typeof mapStateToProps === 'function' ? (0, _wrapMapToProps.wrapMapToPropsFunc)(mapStateToProps, 'mapStateToProps') : undefined;
	}
	
	function whenMapStateToPropsIsMissing(mapStateToProps) {
	  return !mapStateToProps ? (0, _wrapMapToProps.wrapMapToPropsConstant)(function () {
	    return {};
	  }) : undefined;
	}
	
	exports.default = [whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing];

/***/ },
/* 1922 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.defaultMergeProps = defaultMergeProps;
	exports.wrapMergePropsFunc = wrapMergePropsFunc;
	exports.whenMergePropsIsFunction = whenMergePropsIsFunction;
	exports.whenMergePropsIsOmitted = whenMergePropsIsOmitted;
	
	var _verifyPlainObject = __webpack_require__(417);
	
	var _verifyPlainObject2 = _interopRequireDefault(_verifyPlainObject);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function defaultMergeProps(stateProps, dispatchProps, ownProps) {
	  return _extends({}, ownProps, stateProps, dispatchProps);
	}
	
	function wrapMergePropsFunc(mergeProps) {
	  return function initMergePropsProxy(dispatch, _ref) {
	    var displayName = _ref.displayName,
	        pure = _ref.pure,
	        areMergedPropsEqual = _ref.areMergedPropsEqual;
	
	    var hasRunOnce = false;
	    var mergedProps = void 0;
	
	    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
	      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	      if (hasRunOnce) {
	        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
	      } else {
	        hasRunOnce = true;
	        mergedProps = nextMergedProps;
	
	        if (false) (0, _verifyPlainObject2.default)(mergedProps, displayName, 'mergeProps');
	      }
	
	      return mergedProps;
	    };
	  };
	}
	
	function whenMergePropsIsFunction(mergeProps) {
	  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
	}
	
	function whenMergePropsIsOmitted(mergeProps) {
	  return !mergeProps ? function () {
	    return defaultMergeProps;
	  } : undefined;
	}
	
	exports.default = [whenMergePropsIsFunction, whenMergePropsIsOmitted];

/***/ },
/* 1923 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.impureFinalPropsSelectorFactory = impureFinalPropsSelectorFactory;
	exports.pureFinalPropsSelectorFactory = pureFinalPropsSelectorFactory;
	exports.default = finalPropsSelectorFactory;
	
	var _verifySubselectors = __webpack_require__(1924);
	
	var _verifySubselectors2 = _interopRequireDefault(_verifySubselectors);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
	  return function impureFinalPropsSelector(state, ownProps) {
	    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
	  };
	}
	
	function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
	  var areStatesEqual = _ref.areStatesEqual,
	      areOwnPropsEqual = _ref.areOwnPropsEqual,
	      areStatePropsEqual = _ref.areStatePropsEqual;
	
	  var hasRunAtLeastOnce = false;
	  var state = void 0;
	  var ownProps = void 0;
	  var stateProps = void 0;
	  var dispatchProps = void 0;
	  var mergedProps = void 0;
	
	  function handleFirstCall(firstState, firstOwnProps) {
	    state = firstState;
	    ownProps = firstOwnProps;
	    stateProps = mapStateToProps(state, ownProps);
	    dispatchProps = mapDispatchToProps(dispatch, ownProps);
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    hasRunAtLeastOnce = true;
	    return mergedProps;
	  }
	
	  function handleNewPropsAndNewState() {
	    stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewProps() {
	    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
	
	    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
	
	    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	    return mergedProps;
	  }
	
	  function handleNewState() {
	    var nextStateProps = mapStateToProps(state, ownProps);
	    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
	    stateProps = nextStateProps;
	
	    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
	
	    return mergedProps;
	  }
	
	  function handleSubsequentCalls(nextState, nextOwnProps) {
	    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
	    var stateChanged = !areStatesEqual(nextState, state);
	    state = nextState;
	    ownProps = nextOwnProps;
	
	    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
	    if (propsChanged) return handleNewProps();
	    if (stateChanged) return handleNewState();
	    return mergedProps;
	  }
	
	  return function pureFinalPropsSelector(nextState, nextOwnProps) {
	    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
	  };
	}
	
	// TODO: Add more comments
	
	// If pure is true, the selector returned by selectorFactory will memoize its results,
	// allowing connectAdvanced's shouldComponentUpdate to return false if final
	// props have not changed. If false, the selector will always return a new
	// object and shouldComponentUpdate will always return true.
	
	function finalPropsSelectorFactory(dispatch, _ref2) {
	  var initMapStateToProps = _ref2.initMapStateToProps,
	      initMapDispatchToProps = _ref2.initMapDispatchToProps,
	      initMergeProps = _ref2.initMergeProps,
	      options = _objectWithoutProperties(_ref2, ['initMapStateToProps', 'initMapDispatchToProps', 'initMergeProps']);
	
	  var mapStateToProps = initMapStateToProps(dispatch, options);
	  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
	  var mergeProps = initMergeProps(dispatch, options);
	
	  if (false) {
	    (0, _verifySubselectors2.default)(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
	  }
	
	  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
	
	  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
	}

/***/ },
/* 1924 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = verifySubselectors;
	
	var _warning = __webpack_require__(241);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function verify(selector, methodName, displayName) {
	  if (!selector) {
	    throw new Error('Unexpected value for ' + methodName + ' in ' + displayName + '.');
	  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
	    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
	      (0, _warning2.default)('The selector for ' + methodName + ' of ' + displayName + ' did not specify a value for dependsOnOwnProps.');
	    }
	  }
	}
	
	function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
	  verify(mapStateToProps, 'mapStateToProps', displayName);
	  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
	  verify(mergeProps, 'mergeProps', displayName);
	}

/***/ },
/* 1925 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	// encapsulates the subscription logic for connecting a component to the redux store, as
	// well as nesting subscriptions of descendant components, so that we can ensure the
	// ancestor components re-render before descendants
	
	var CLEARED = null;
	var nullListeners = {
	  notify: function notify() {}
	};
	
	function createListenerCollection() {
	  // the current/next pattern is copied from redux's createStore code.
	  // TODO: refactor+expose that code to be reusable here?
	  var current = [];
	  var next = [];
	
	  return {
	    clear: function clear() {
	      next = CLEARED;
	      current = CLEARED;
	    },
	    notify: function notify() {
	      var listeners = current = next;
	      for (var i = 0; i < listeners.length; i++) {
	        listeners[i]();
	      }
	    },
	    get: function get() {
	      return next;
	    },
	    subscribe: function subscribe(listener) {
	      var isSubscribed = true;
	      if (next === current) next = current.slice();
	      next.push(listener);
	
	      return function unsubscribe() {
	        if (!isSubscribed || current === CLEARED) return;
	        isSubscribed = false;
	
	        if (next === current) next = current.slice();
	        next.splice(next.indexOf(listener), 1);
	      };
	    }
	  };
	}
	
	var Subscription = function () {
	  function Subscription(store, parentSub, onStateChange) {
	    _classCallCheck(this, Subscription);
	
	    this.store = store;
	    this.parentSub = parentSub;
	    this.onStateChange = onStateChange;
	    this.unsubscribe = null;
	    this.listeners = nullListeners;
	  }
	
	  Subscription.prototype.addNestedSub = function addNestedSub(listener) {
	    this.trySubscribe();
	    return this.listeners.subscribe(listener);
	  };
	
	  Subscription.prototype.notifyNestedSubs = function notifyNestedSubs() {
	    this.listeners.notify();
	  };
	
	  Subscription.prototype.isSubscribed = function isSubscribed() {
	    return Boolean(this.unsubscribe);
	  };
	
	  Subscription.prototype.trySubscribe = function trySubscribe() {
	    if (!this.unsubscribe) {
	      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
	
	      this.listeners = createListenerCollection();
	    }
	  };
	
	  Subscription.prototype.tryUnsubscribe = function tryUnsubscribe() {
	    if (this.unsubscribe) {
	      this.unsubscribe();
	      this.unsubscribe = null;
	      this.listeners.clear();
	      this.listeners = nullListeners;
	    }
	  };
	
	  return Subscription;
	}();
	
	exports.default = Subscription;

/***/ },
/* 1926 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports.default = shallowEqual;
	var hasOwn = Object.prototype.hasOwnProperty;
	
	function is(x, y) {
	  if (x === y) {
	    return x !== 0 || y !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function shallowEqual(objA, objB) {
	  if (is(objA, objB)) return true;
	
	  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
	    return false;
	  }
	
	  var keysA = Object.keys(objA);
	  var keysB = Object.keys(objB);
	
	  if (keysA.length !== keysB.length) return false;
	
	  for (var i = 0; i < keysA.length; i++) {
	    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
	      return false;
	    }
	  }
	
	  return true;
	}

/***/ },
/* 1927 */
/***/ function(module, exports) {

	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	'use strict';
	
	var REACT_STATICS = {
	    childContextTypes: true,
	    contextTypes: true,
	    defaultProps: true,
	    displayName: true,
	    getDefaultProps: true,
	    mixins: true,
	    propTypes: true,
	    type: true
	};
	
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = getPrototypeOf && getPrototypeOf(Object);
	
	module.exports = function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components
	
	        if (objectPrototype) {
	            var inheritedComponent = getPrototypeOf(sourceComponent);
	            if (inheritedComponent && inheritedComponent !== objectPrototype) {
	                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	            }
	        }
	
	        var keys = getOwnPropertyNames(sourceComponent);
	
	        if (getOwnPropertySymbols) {
	            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	        }
	
	        for (var i = 0; i < keys.length; ++i) {
	            var key = keys[i];
	            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
	                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	                try { // Avoid failures from read-only properties
	                    defineProperty(targetComponent, key, descriptor);
	                } catch (e) {}
	            }
	        }
	
	        return targetComponent;
	    }
	
	    return targetComponent;
	};


/***/ },
/* 1928 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createBrowserHistory = __webpack_require__(278);
	
	var _createBrowserHistory2 = _interopRequireDefault(_createBrowserHistory);
	
	var _Router = __webpack_require__(242);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses HTML5 history.
	 */
	var BrowserRouter = function (_React$Component) {
	  _inherits(BrowserRouter, _React$Component);
	
	  function BrowserRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, BrowserRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createBrowserHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<BrowserRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { BrowserRouter as Router }`.');
	  };
	
	  BrowserRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return BrowserRouter;
	}(_react2.default.Component);
	
	BrowserRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  forceRefresh: _propTypes2.default.bool,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = BrowserRouter;

/***/ },
/* 1929 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createHashHistory = __webpack_require__(279);
	
	var _createHashHistory2 = _interopRequireDefault(_createHashHistory);
	
	var _Router = __webpack_require__(242);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that uses window.location.hash.
	 */
	var HashRouter = function (_React$Component) {
	  _inherits(HashRouter, _React$Component);
	
	  function HashRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, HashRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createHashHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  HashRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<HashRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { HashRouter as Router }`.');
	  };
	
	  HashRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return HashRouter;
	}(_react2.default.Component);
	
	HashRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  getUserConfirmation: _propTypes2.default.func,
	  hashType: _propTypes2.default.oneOf(['hashbang', 'noslash', 'slash']),
	  children: _propTypes2.default.node
	};
	exports.default = HashRouter;

/***/ },
/* 1930 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _MemoryRouter = __webpack_require__(1938);
	
	var _MemoryRouter2 = _interopRequireDefault(_MemoryRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _MemoryRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 1931 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Route = __webpack_require__(419);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	var _Link = __webpack_require__(418);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A <Link> wrapper that knows if it's "active" or not.
	 */
	var NavLink = function NavLink(_ref) {
	  var to = _ref.to,
	      exact = _ref.exact,
	      strict = _ref.strict,
	      location = _ref.location,
	      activeClassName = _ref.activeClassName,
	      className = _ref.className,
	      activeStyle = _ref.activeStyle,
	      style = _ref.style,
	      getIsActive = _ref.isActive,
	      ariaCurrent = _ref.ariaCurrent,
	      rest = _objectWithoutProperties(_ref, ['to', 'exact', 'strict', 'location', 'activeClassName', 'className', 'activeStyle', 'style', 'isActive', 'ariaCurrent']);
	
	  return _react2.default.createElement(_Route2.default, {
	    path: (typeof to === 'undefined' ? 'undefined' : _typeof(to)) === 'object' ? to.pathname : to,
	    exact: exact,
	    strict: strict,
	    location: location,
	    children: function children(_ref2) {
	      var location = _ref2.location,
	          match = _ref2.match;
	
	      var isActive = !!(getIsActive ? getIsActive(match, location) : match);
	
	      return _react2.default.createElement(_Link2.default, _extends({
	        to: to,
	        className: isActive ? [className, activeClassName].filter(function (i) {
	          return i;
	        }).join(' ') : className,
	        style: isActive ? _extends({}, style, activeStyle) : style,
	        'aria-current': isActive && ariaCurrent
	      }, rest));
	    }
	  });
	};
	
	NavLink.propTypes = {
	  to: _Link2.default.propTypes.to,
	  exact: _propTypes2.default.bool,
	  strict: _propTypes2.default.bool,
	  location: _propTypes2.default.object,
	  activeClassName: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  activeStyle: _propTypes2.default.object,
	  style: _propTypes2.default.object,
	  isActive: _propTypes2.default.func,
	  ariaCurrent: _propTypes2.default.oneOf(['page', 'step', 'location', 'true'])
	};
	
	NavLink.defaultProps = {
	  activeClassName: 'active',
	  ariaCurrent: 'true'
	};
	
	exports.default = NavLink;

/***/ },
/* 1932 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Prompt = __webpack_require__(1939);
	
	var _Prompt2 = _interopRequireDefault(_Prompt);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Prompt2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 1933 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Redirect = __webpack_require__(1940);
	
	var _Redirect2 = _interopRequireDefault(_Redirect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Redirect2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 1934 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _StaticRouter = __webpack_require__(1941);
	
	var _StaticRouter2 = _interopRequireDefault(_StaticRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _StaticRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 1935 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _Switch = __webpack_require__(1942);
	
	var _Switch2 = _interopRequireDefault(_Switch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _Switch2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 1936 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _matchPath = __webpack_require__(244);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _matchPath2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 1937 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _withRouter = __webpack_require__(1946);
	
	var _withRouter2 = _interopRequireDefault(_withRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = _withRouter2.default; // Written in this round about way for babel-transform-imports

/***/ },
/* 1938 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _createMemoryHistory = __webpack_require__(280);
	
	var _createMemoryHistory2 = _interopRequireDefault(_createMemoryHistory);
	
	var _Router = __webpack_require__(243);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for a <Router> that stores location in memory.
	 */
	var MemoryRouter = function (_React$Component) {
	  _inherits(MemoryRouter, _React$Component);
	
	  function MemoryRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, MemoryRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = (0, _createMemoryHistory2.default)(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<MemoryRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { MemoryRouter as Router }`.');
	  };
	
	  MemoryRouter.prototype.render = function render() {
	    return _react2.default.createElement(_Router2.default, { history: this.history, children: this.props.children });
	  };
	
	  return MemoryRouter;
	}(_react2.default.Component);
	
	MemoryRouter.propTypes = {
	  initialEntries: _propTypes2.default.array,
	  initialIndex: _propTypes2.default.number,
	  getUserConfirmation: _propTypes2.default.func,
	  keyLength: _propTypes2.default.number,
	  children: _propTypes2.default.node
	};
	exports.default = MemoryRouter;

/***/ },
/* 1939 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for prompting the user before navigating away
	 * from a screen with a component.
	 */
	var Prompt = function (_React$Component) {
	  _inherits(Prompt, _React$Component);
	
	  function Prompt() {
	    _classCallCheck(this, Prompt);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Prompt.prototype.enable = function enable(message) {
	    if (this.unblock) this.unblock();
	
	    this.unblock = this.context.router.history.block(message);
	  };
	
	  Prompt.prototype.disable = function disable() {
	    if (this.unblock) {
	      this.unblock();
	      this.unblock = null;
	    }
	  };
	
	  Prompt.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Prompt> outside a <Router>');
	
	    if (this.props.when) this.enable(this.props.message);
	  };
	
	  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    if (nextProps.when) {
	      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
	    } else {
	      this.disable();
	    }
	  };
	
	  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.disable();
	  };
	
	  Prompt.prototype.render = function render() {
	    return null;
	  };
	
	  return Prompt;
	}(_react2.default.Component);
	
	Prompt.propTypes = {
	  when: _propTypes2.default.bool,
	  message: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.string]).isRequired
	};
	Prompt.defaultProps = {
	  when: true
	};
	Prompt.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      block: _propTypes2.default.func.isRequired
	    }).isRequired
	  }).isRequired
	};
	exports.default = Prompt;

/***/ },
/* 1940 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _history = __webpack_require__(586);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for updating the location programmatically
	 * with a component.
	 */
	var Redirect = function (_React$Component) {
	  _inherits(Redirect, _React$Component);
	
	  function Redirect() {
	    _classCallCheck(this, Redirect);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Redirect.prototype.isStatic = function isStatic() {
	    return this.context.router && this.context.router.staticContext;
	  };
	
	  Redirect.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Redirect> outside a <Router>');
	
	    if (this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidMount = function componentDidMount() {
	    if (!this.isStatic()) this.perform();
	  };
	
	  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var prevTo = (0, _history.createLocation)(prevProps.to);
	    var nextTo = (0, _history.createLocation)(this.props.to);
	
	    if ((0, _history.locationsAreEqual)(prevTo, nextTo)) {
	      (0, _warning2.default)(false, 'You tried to redirect to the same route you\'re currently on: ' + ('"' + nextTo.pathname + nextTo.search + '"'));
	      return;
	    }
	
	    this.perform();
	  };
	
	  Redirect.prototype.perform = function perform() {
	    var history = this.context.router.history;
	    var _props = this.props,
	        push = _props.push,
	        to = _props.to;
	
	
	    if (push) {
	      history.push(to);
	    } else {
	      history.replace(to);
	    }
	  };
	
	  Redirect.prototype.render = function render() {
	    return null;
	  };
	
	  return Redirect;
	}(_react2.default.Component);
	
	Redirect.propTypes = {
	  push: _propTypes2.default.bool,
	  from: _propTypes2.default.string,
	  to: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object]).isRequired
	};
	Redirect.defaultProps = {
	  push: false
	};
	Redirect.contextTypes = {
	  router: _propTypes2.default.shape({
	    history: _propTypes2.default.shape({
	      push: _propTypes2.default.func.isRequired,
	      replace: _propTypes2.default.func.isRequired
	    }).isRequired,
	    staticContext: _propTypes2.default.object
	  }).isRequired
	};
	exports.default = Redirect;

/***/ },
/* 1941 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _PathUtils = __webpack_require__(76);
	
	var _Router = __webpack_require__(243);
	
	var _Router2 = _interopRequireDefault(_Router);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var normalizeLocation = function normalizeLocation(object) {
	  var _object$pathname = object.pathname,
	      pathname = _object$pathname === undefined ? '/' : _object$pathname,
	      _object$search = object.search,
	      search = _object$search === undefined ? '' : _object$search,
	      _object$hash = object.hash,
	      hash = _object$hash === undefined ? '' : _object$hash;
	
	
	  return {
	    pathname: pathname,
	    search: search === '?' ? '' : search,
	    hash: hash === '#' ? '' : hash
	  };
	};
	
	var addBasename = function addBasename(basename, location) {
	  if (!basename) return location;
	
	  return _extends({}, location, {
	    pathname: (0, _PathUtils.addLeadingSlash)(basename) + location.pathname
	  });
	};
	
	var stripBasename = function stripBasename(basename, location) {
	  if (!basename) return location;
	
	  var base = (0, _PathUtils.addLeadingSlash)(basename);
	
	  if (location.pathname.indexOf(base) !== 0) return location;
	
	  return _extends({}, location, {
	    pathname: location.pathname.substr(base.length)
	  });
	};
	
	var createLocation = function createLocation(location) {
	  return typeof location === 'string' ? (0, _PathUtils.parsePath)(location) : normalizeLocation(location);
	};
	
	var createURL = function createURL(location) {
	  return typeof location === 'string' ? location : (0, _PathUtils.createPath)(location);
	};
	
	var staticHandler = function staticHandler(methodName) {
	  return function () {
	    (0, _invariant2.default)(false, 'You cannot %s with <StaticRouter>', methodName);
	  };
	};
	
	var noop = function noop() {};
	
	/**
	 * The public top-level API for a "static" <Router>, so-called because it
	 * can't actually change the current location. Instead, it just records
	 * location changes in a context object. Useful mainly in testing and
	 * server-rendering scenarios.
	 */
	
	var StaticRouter = function (_React$Component) {
	  _inherits(StaticRouter, _React$Component);
	
	  function StaticRouter() {
	    var _temp, _this, _ret;
	
	    _classCallCheck(this, StaticRouter);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
	      return (0, _PathUtils.addLeadingSlash)(_this.props.basename + createURL(path));
	    }, _this.handlePush = function (location) {
	      var _this$props = _this.props,
	          basename = _this$props.basename,
	          context = _this$props.context;
	
	      context.action = 'PUSH';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleReplace = function (location) {
	      var _this$props2 = _this.props,
	          basename = _this$props2.basename,
	          context = _this$props2.context;
	
	      context.action = 'REPLACE';
	      context.location = addBasename(basename, createLocation(location));
	      context.url = createURL(context.location);
	    }, _this.handleListen = function () {
	      return noop;
	    }, _this.handleBlock = function () {
	      return noop;
	    }, _temp), _possibleConstructorReturn(_this, _ret);
	  }
	
	  StaticRouter.prototype.getChildContext = function getChildContext() {
	    return {
	      router: {
	        staticContext: this.props.context
	      }
	    };
	  };
	
	  StaticRouter.prototype.componentWillMount = function componentWillMount() {
	    (0, _warning2.default)(!this.props.history, '<StaticRouter> ignores the history prop. To use a custom history, ' + 'use `import { Router }` instead of `import { StaticRouter as Router }`.');
	  };
	
	  StaticRouter.prototype.render = function render() {
	    var _props = this.props,
	        basename = _props.basename,
	        context = _props.context,
	        location = _props.location,
	        props = _objectWithoutProperties(_props, ['basename', 'context', 'location']);
	
	    var history = {
	      createHref: this.createHref,
	      action: 'POP',
	      location: stripBasename(basename, createLocation(location)),
	      push: this.handlePush,
	      replace: this.handleReplace,
	      go: staticHandler('go'),
	      goBack: staticHandler('goBack'),
	      goForward: staticHandler('goForward'),
	      listen: this.handleListen,
	      block: this.handleBlock
	    };
	
	    return _react2.default.createElement(_Router2.default, _extends({}, props, { history: history }));
	  };
	
	  return StaticRouter;
	}(_react2.default.Component);
	
	StaticRouter.propTypes = {
	  basename: _propTypes2.default.string,
	  context: _propTypes2.default.object.isRequired,
	  location: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.object])
	};
	StaticRouter.defaultProps = {
	  basename: '',
	  location: '/'
	};
	StaticRouter.childContextTypes = {
	  router: _propTypes2.default.object.isRequired
	};
	exports.default = StaticRouter;

/***/ },
/* 1942 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _invariant = __webpack_require__(39);
	
	var _invariant2 = _interopRequireDefault(_invariant);
	
	var _matchPath = __webpack_require__(244);
	
	var _matchPath2 = _interopRequireDefault(_matchPath);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * The public API for rendering the first <Route> that matches.
	 */
	var Switch = function (_React$Component) {
	  _inherits(Switch, _React$Component);
	
	  function Switch() {
	    _classCallCheck(this, Switch);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Switch.prototype.componentWillMount = function componentWillMount() {
	    (0, _invariant2.default)(this.context.router, 'You should not use <Switch> outside a <Router>');
	  };
	
	  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');
	
	    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
	  };
	
	  Switch.prototype.render = function render() {
	    var route = this.context.router.route;
	    var children = this.props.children;
	
	    var location = this.props.location || route.location;
	
	    var match = void 0,
	        child = void 0;
	    _react2.default.Children.forEach(children, function (element) {
	      if (!_react2.default.isValidElement(element)) return;
	
	      var _element$props = element.props,
	          pathProp = _element$props.path,
	          exact = _element$props.exact,
	          strict = _element$props.strict,
	          sensitive = _element$props.sensitive,
	          from = _element$props.from;
	
	      var path = pathProp || from;
	
	      if (match == null) {
	        child = element;
	        match = path ? (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }) : route.match;
	      }
	    });
	
	    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
	  };
	
	  return Switch;
	}(_react2.default.Component);
	
	Switch.contextTypes = {
	  router: _propTypes2.default.shape({
	    route: _propTypes2.default.object.isRequired
	  }).isRequired
	};
	Switch.propTypes = {
	  children: _propTypes2.default.node,
	  location: _propTypes2.default.object
	};
	exports.default = Switch;

/***/ },
/* 1943 */
1927,
/* 1944 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 1945 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(1944)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options))
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$')
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 1946 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _hoistNonReactStatics = __webpack_require__(1943);
	
	var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);
	
	var _Route = __webpack_require__(421);
	
	var _Route2 = _interopRequireDefault(_Route);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	/**
	 * A public higher-order component to access the imperative API
	 */
	var withRouter = function withRouter(Component) {
	  var C = function C(props) {
	    var wrappedComponentRef = props.wrappedComponentRef,
	        remainingProps = _objectWithoutProperties(props, ['wrappedComponentRef']);
	
	    return _react2.default.createElement(_Route2.default, { render: function render(routeComponentProps) {
	        return _react2.default.createElement(Component, _extends({}, remainingProps, routeComponentProps, { ref: wrappedComponentRef }));
	      } });
	  };
	
	  C.displayName = 'withRouter(' + (Component.displayName || Component.name) + ')';
	  C.WrappedComponent = Component;
	  C.propTypes = {
	    wrappedComponentRef: _propTypes2.default.func
	  };
	
	  return (0, _hoistNonReactStatics2.default)(C, Component);
	};
	
	exports.default = withRouter;

/***/ },
/* 1947 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	'use strict';
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(1949).enable();
	  window.Promise = __webpack_require__(1948);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(1950);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(18);


/***/ },
/* 1948 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(422);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 1949 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(422);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 1950 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  if (support.arrayBuffer) {
	    var viewClasses = [
	      '[object Int8Array]',
	      '[object Uint8Array]',
	      '[object Uint8ClampedArray]',
	      '[object Int16Array]',
	      '[object Uint16Array]',
	      '[object Int32Array]',
	      '[object Uint32Array]',
	      '[object Float32Array]',
	      '[object Float64Array]'
	    ]
	
	    var isDataView = function(obj) {
	      return obj && DataView.prototype.isPrototypeOf(obj)
	    }
	
	    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
	      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
	    }
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var oldValue = this.map[name]
	    this.map[name] = oldValue ? oldValue+','+value : value
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    name = normalizeName(name)
	    return this.has(name) ? this.map[name] : null
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = normalizeValue(value)
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    for (var name in this.map) {
	      if (this.map.hasOwnProperty(name)) {
	        callback.call(thisArg, this.map[name], name, this)
	      }
	    }
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsArrayBuffer(blob)
	    return promise
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    var promise = fileReaderReady(reader)
	    reader.readAsText(blob)
	    return promise
	  }
	
	  function readArrayBufferAsText(buf) {
	    var view = new Uint8Array(buf)
	    var chars = new Array(view.length)
	
	    for (var i = 0; i < view.length; i++) {
	      chars[i] = String.fromCharCode(view[i])
	    }
	    return chars.join('')
	  }
	
	  function bufferClone(buf) {
	    if (buf.slice) {
	      return buf.slice(0)
	    } else {
	      var view = new Uint8Array(buf.byteLength)
	      view.set(new Uint8Array(buf))
	      return view.buffer
	    }
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (!body) {
	        this._bodyText = ''
	      } else if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
	        this._bodyArrayBuffer = bufferClone(body.buffer)
	        // IE 10-11 can't handle a DataView body.
	        this._bodyInit = new Blob([this._bodyArrayBuffer])
	      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
	        this._bodyArrayBuffer = bufferClone(body)
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyArrayBuffer) {
	          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        if (this._bodyArrayBuffer) {
	          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
	        } else {
	          return this.blob().then(readBlobAsArrayBuffer)
	        }
	      }
	    }
	
	    this.text = function() {
	      var rejected = consumed(this)
	      if (rejected) {
	        return rejected
	      }
	
	      if (this._bodyBlob) {
	        return readBlobAsText(this._bodyBlob)
	      } else if (this._bodyArrayBuffer) {
	        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
	      } else if (this._bodyFormData) {
	        throw new Error('could not read FormData body as text')
	      } else {
	        return Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	
	    if (input instanceof Request) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body && input._bodyInit != null) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = String(input)
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this, { body: this._bodyInit })
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function parseHeaders(rawHeaders) {
	    var headers = new Headers()
	    rawHeaders.split(/\r?\n/).forEach(function(line) {
	      var parts = line.split(':')
	      var key = parts.shift().trim()
	      if (key) {
	        var value = parts.join(':').trim()
	        headers.append(key, value)
	      }
	    })
	    return headers
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = 'status' in options ? options.status : 200
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = 'statusText' in options ? options.statusText : 'OK'
	    this.headers = new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request = new Request(input, init)
	      var xhr = new XMLHttpRequest()
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
	        }
	        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 1951 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TapEventPlugin
	 * @typechecks static-only
	 */
	
	"use strict";
	
	var EventConstants = __webpack_require__(1860);
	var EventPluginUtils = __webpack_require__(154);
	var EventPropagators = __webpack_require__(91);
	var SyntheticUIEvent = __webpack_require__(93);
	var TouchEventUtils = __webpack_require__(1952);
	var ViewportMetrics = __webpack_require__(233);
	
	var keyOf = __webpack_require__(584);
	var topLevelTypes = EventConstants.topLevelTypes;
	
	var isStartish = EventPluginUtils.isStartish;
	var isEndish = EventPluginUtils.isEndish;
	
	var isTouch = function(topLevelType) {
	  var touchTypes = [
	    'topTouchCancel',
	    'topTouchEnd',
	    'topTouchStart',
	    'topTouchMove'
	  ];
	  return touchTypes.indexOf(topLevelType) >= 0;
	}
	
	/**
	 * Number of pixels that are tolerated in between a `touchStart` and `touchEnd`
	 * in order to still be considered a 'tap' event.
	 */
	var tapMoveThreshold = 10;
	var ignoreMouseThreshold = 750;
	var startCoords = {x: null, y: null};
	var lastTouchEvent = null;
	
	var Axis = {
	  x: {page: 'pageX', client: 'clientX', envScroll: 'currentPageScrollLeft'},
	  y: {page: 'pageY', client: 'clientY', envScroll: 'currentPageScrollTop'}
	};
	
	function getAxisCoordOfEvent(axis, nativeEvent) {
	  var singleTouch = TouchEventUtils.extractSingleTouch(nativeEvent);
	  if (singleTouch) {
	    return singleTouch[axis.page];
	  }
	  return axis.page in nativeEvent ?
	    nativeEvent[axis.page] :
	    nativeEvent[axis.client] + ViewportMetrics[axis.envScroll];
	}
	
	function getDistance(coords, nativeEvent) {
	  var pageX = getAxisCoordOfEvent(Axis.x, nativeEvent);
	  var pageY = getAxisCoordOfEvent(Axis.y, nativeEvent);
	  return Math.pow(
	    Math.pow(pageX - coords.x, 2) + Math.pow(pageY - coords.y, 2),
	    0.5
	  );
	}
	
	var touchEvents = [
	  'topTouchStart',
	  'topTouchCancel',
	  'topTouchEnd',
	  'topTouchMove',
	];
	
	var dependencies = [
	  'topMouseDown',
	  'topMouseMove',
	  'topMouseUp',
	].concat(touchEvents);
	
	var eventTypes = {
	  touchTap: {
	    phasedRegistrationNames: {
	      bubbled: keyOf({onTouchTap: null}),
	      captured: keyOf({onTouchTapCapture: null})
	    },
	    dependencies: dependencies
	  }
	};
	
	var now = (function() {
	  if (Date.now) {
	    return Date.now;
	  } else {
	    // IE8 support: http://stackoverflow.com/questions/9430357/please-explain-why-and-how-new-date-works-as-workaround-for-date-now-in
	    return function () {
	      return +new Date;
	    }
	  }
	})();
	
	function createTapEventPlugin(shouldRejectClick) {
	  return {
	
	    tapMoveThreshold: tapMoveThreshold,
	
	    ignoreMouseThreshold: ignoreMouseThreshold,
	
	    eventTypes: eventTypes,
	
	    /**
	     * @param {string} topLevelType Record from `EventConstants`.
	     * @param {DOMEventTarget} targetInst The listening component root node.
	     * @param {object} nativeEvent Native browser event.
	     * @return {*} An accumulation of synthetic events.
	     * @see {EventPluginHub.extractEvents}
	     */
	    extractEvents: function(
	      topLevelType,
	      targetInst,
	      nativeEvent,
	      nativeEventTarget
	    ) {
	
	      if (!isStartish(topLevelType) && !isEndish(topLevelType)) {
	        return null;
	      }
	
	      if (isTouch(topLevelType)) {
	        lastTouchEvent = now();
	      } else {
	        if (shouldRejectClick(lastTouchEvent, now())) {
	          return null;
	        }
	      }
	
	      var event = null;
	      var distance = getDistance(startCoords, nativeEvent);
	      if (isEndish(topLevelType) && distance < tapMoveThreshold) {
	        event = SyntheticUIEvent.getPooled(
	          eventTypes.touchTap,
	          targetInst,
	          nativeEvent,
	          nativeEventTarget
	        );
	      }
	      if (isStartish(topLevelType)) {
	        startCoords.x = getAxisCoordOfEvent(Axis.x, nativeEvent);
	        startCoords.y = getAxisCoordOfEvent(Axis.y, nativeEvent);
	      } else if (isEndish(topLevelType)) {
	        startCoords.x = 0;
	        startCoords.y = 0;
	      }
	      EventPropagators.accumulateTwoPhaseDispatches(event);
	      return event;
	    }
	
	  };
	}
	
	module.exports = createTapEventPlugin;


/***/ },
/* 1952 */
/***/ function(module, exports) {

	/**
	 * Copyright 2013-2014 Facebook, Inc.
	 *
	 * Licensed under the Apache License, Version 2.0 (the "License");
	 * you may not use this file except in compliance with the License.
	 * You may obtain a copy of the License at
	 *
	 * http://www.apache.org/licenses/LICENSE-2.0
	 *
	 * Unless required by applicable law or agreed to in writing, software
	 * distributed under the License is distributed on an "AS IS" BASIS,
	 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
	 * See the License for the specific language governing permissions and
	 * limitations under the License.
	 *
	 * @providesModule TouchEventUtils
	 */
	
	var TouchEventUtils = {
	  /**
	   * Utility function for common case of extracting out the primary touch from a
	   * touch event.
	   * - `touchEnd` events usually do not have the `touches` property.
	   *   http://stackoverflow.com/questions/3666929/
	   *   mobile-sarai-touchend-event-not-firing-when-last-touch-is-removed
	   *
	   * @param {Event} nativeEvent Native event that may or may not be a touch.
	   * @return {TouchesObject?} an object with pageX and pageY or null.
	   */
	  extractSingleTouch: function(nativeEvent) {
	    var touches = nativeEvent.touches;
	    var changedTouches = nativeEvent.changedTouches;
	    var hasTouches = touches && touches.length > 0;
	    var hasChangedTouches = changedTouches && changedTouches.length > 0;
	
	    return !hasTouches && hasChangedTouches ? changedTouches[0] :
	           hasTouches ? touches[0] :
	           nativeEvent;
	  }
	};
	
	module.exports = TouchEventUtils;


/***/ },
/* 1953 */
/***/ function(module, exports) {

	module.exports = function(lastTouchEvent, clickTimestamp) {
	  if (lastTouchEvent && (clickTimestamp - lastTouchEvent) < 750) {
	    return true;
	  }
	};


/***/ },
/* 1954 */
/***/ function(module, exports, __webpack_require__) {

	var invariant = __webpack_require__(13);
	var defaultClickRejectionStrategy = __webpack_require__(1953);
	
	var alreadyInjected = false;
	
	module.exports = function injectTapEventPlugin (strategyOverrides) {
	  strategyOverrides = strategyOverrides || {}
	  var shouldRejectClick = strategyOverrides.shouldRejectClick || defaultClickRejectionStrategy;
	
	  if (false) {
	    invariant(
	      !alreadyInjected,
	      'injectTapEventPlugin(): Can only be called once per application lifecycle.\n\n\
	It is recommended to call injectTapEventPlugin() just before you call \
	ReactDOM.render(). If you are using an external library which calls injectTapEventPlugin() \
	itself, please contact the maintainer as it shouldn\'t be called in library code and \
	should be injected by the application.'
	    )
	  }
	
	  alreadyInjected = true;
	
	  __webpack_require__(90).injection.injectEventPluginsByName({
	    'TapEventPlugin':       __webpack_require__(1951)(shouldRejectClick)
	  });
	};


/***/ },
/* 1955 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _chainFunction = __webpack_require__(498);
	
	var _chainFunction2 = _interopRequireDefault(_chainFunction);
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _warning = __webpack_require__(15);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	var _ChildMapping = __webpack_require__(1956);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var propTypes = {
	  component: _propTypes2.default.any,
	  childFactory: _propTypes2.default.func,
	  children: _propTypes2.default.node
	};
	
	var defaultProps = {
	  component: 'span',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	};
	
	var TransitionGroup = function (_React$Component) {
	  _inherits(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    _classCallCheck(this, TransitionGroup);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props, context));
	
	    _this.performAppear = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillAppear) {
	        component.componentWillAppear(_this._handleDoneAppearing.bind(_this, key, component));
	      } else {
	        _this._handleDoneAppearing(key, component);
	      }
	    };
	
	    _this._handleDoneAppearing = function (key, component) {
	      if (component.componentDidAppear) {
	        component.componentDidAppear();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully appeared. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performEnter = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillEnter) {
	        component.componentWillEnter(_this._handleDoneEntering.bind(_this, key, component));
	      } else {
	        _this._handleDoneEntering(key, component);
	      }
	    };
	
	    _this._handleDoneEntering = function (key, component) {
	      if (component.componentDidEnter) {
	        component.componentDidEnter();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (!currentChildMapping || !currentChildMapping.hasOwnProperty(key)) {
	        // This was removed before it had fully entered. Remove it.
	        _this.performLeave(key, component);
	      }
	    };
	
	    _this.performLeave = function (key, component) {
	      _this.currentlyTransitioningKeys[key] = true;
	
	      if (component.componentWillLeave) {
	        component.componentWillLeave(_this._handleDoneLeaving.bind(_this, key, component));
	      } else {
	        // Note that this is somewhat dangerous b/c it calls setState()
	        // again, effectively mutating the component before all the work
	        // is done.
	        _this._handleDoneLeaving(key, component);
	      }
	    };
	
	    _this._handleDoneLeaving = function (key, component) {
	      if (component.componentDidLeave) {
	        component.componentDidLeave();
	      }
	
	      delete _this.currentlyTransitioningKeys[key];
	
	      var currentChildMapping = (0, _ChildMapping.getChildMapping)(_this.props.children);
	
	      if (currentChildMapping && currentChildMapping.hasOwnProperty(key)) {
	        // This entered again before it fully left. Add it again.
	        _this.keysToEnter.push(key);
	      } else {
	        _this.setState(function (state) {
	          var newChildren = _extends({}, state.children);
	          delete newChildren[key];
	          return { children: newChildren };
	        });
	      }
	    };
	
	    _this.childRefs = Object.create(null);
	
	    _this.state = {
	      children: (0, _ChildMapping.getChildMapping)(props.children)
	    };
	    return _this;
	  }
	
	  TransitionGroup.prototype.componentWillMount = function componentWillMount() {
	    this.currentlyTransitioningKeys = {};
	    this.keysToEnter = [];
	    this.keysToLeave = [];
	  };
	
	  TransitionGroup.prototype.componentDidMount = function componentDidMount() {
	    var initialChildMapping = this.state.children;
	    for (var key in initialChildMapping) {
	      if (initialChildMapping[key]) {
	        this.performAppear(key, this.childRefs[key]);
	      }
	    }
	  };
	
	  TransitionGroup.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	    var nextChildMapping = (0, _ChildMapping.getChildMapping)(nextProps.children);
	    var prevChildMapping = this.state.children;
	
	    this.setState({
	      children: (0, _ChildMapping.mergeChildMappings)(prevChildMapping, nextChildMapping)
	    });
	
	    for (var key in nextChildMapping) {
	      var hasPrev = prevChildMapping && prevChildMapping.hasOwnProperty(key);
	      if (nextChildMapping[key] && !hasPrev && !this.currentlyTransitioningKeys[key]) {
	        this.keysToEnter.push(key);
	      }
	    }
	
	    for (var _key in prevChildMapping) {
	      var hasNext = nextChildMapping && nextChildMapping.hasOwnProperty(_key);
	      if (prevChildMapping[_key] && !hasNext && !this.currentlyTransitioningKeys[_key]) {
	        this.keysToLeave.push(_key);
	      }
	    }
	
	    // If we want to someday check for reordering, we could do it here.
	  };
	
	  TransitionGroup.prototype.componentDidUpdate = function componentDidUpdate() {
	    var _this2 = this;
	
	    var keysToEnter = this.keysToEnter;
	    this.keysToEnter = [];
	    keysToEnter.forEach(function (key) {
	      return _this2.performEnter(key, _this2.childRefs[key]);
	    });
	
	    var keysToLeave = this.keysToLeave;
	    this.keysToLeave = [];
	    keysToLeave.forEach(function (key) {
	      return _this2.performLeave(key, _this2.childRefs[key]);
	    });
	  };
	
	  TransitionGroup.prototype.render = function render() {
	    var _this3 = this;
	
	    // TODO: we could get rid of the need for the wrapper node
	    // by cloning a single child
	    var childrenToRender = [];
	
	    var _loop = function _loop(key) {
	      var child = _this3.state.children[key];
	      if (child) {
	        var isCallbackRef = typeof child.ref !== 'string';
	        var factoryChild = _this3.props.childFactory(child);
	        var ref = function ref(r) {
	          _this3.childRefs[key] = r;
	        };
	
	         false ? (0, _warning2.default)(isCallbackRef, 'string refs are not supported on children of TransitionGroup and will be ignored. ' + 'Please use a callback ref instead: https://facebook.github.io/react/docs/refs-and-the-dom.html#the-ref-callback-attribute') : void 0;
	
	        // Always chaining the refs leads to problems when the childFactory
	        // wraps the child. The child ref callback gets called twice with the
	        // wrapper and the child. So we only need to chain the ref if the
	        // factoryChild is not different from child.
	        if (factoryChild === child && isCallbackRef) {
	          ref = (0, _chainFunction2.default)(child.ref, ref);
	        }
	
	        // You may need to apply reactive updates to a child as it is leaving.
	        // The normal React way to do it won't work since the child will have
	        // already been removed. In case you need this behavior you can provide
	        // a childFactory function to wrap every child, even the ones that are
	        // leaving.
	        childrenToRender.push(_react2.default.cloneElement(factoryChild, {
	          key: key,
	          ref: ref
	        }));
	      }
	    };
	
	    for (var key in this.state.children) {
	      _loop(key);
	    }
	
	    // Do not forward TransitionGroup props to primitive DOM nodes
	    var props = _extends({}, this.props);
	    delete props.transitionLeave;
	    delete props.transitionName;
	    delete props.transitionAppear;
	    delete props.transitionEnter;
	    delete props.childFactory;
	    delete props.transitionLeaveTimeout;
	    delete props.transitionEnterTimeout;
	    delete props.transitionAppearTimeout;
	    delete props.component;
	
	    return _react2.default.createElement(this.props.component, props, childrenToRender);
	  };
	
	  return TransitionGroup;
	}(_react2.default.Component);
	
	TransitionGroup.displayName = 'TransitionGroup';
	
	
	TransitionGroup.propTypes =  false ? propTypes : {};
	TransitionGroup.defaultProps = defaultProps;
	
	exports.default = TransitionGroup;
	module.exports = exports['default'];

/***/ },
/* 1956 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	
	var _react = __webpack_require__(1);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children) {
	  if (!children) {
	    return children;
	  }
	  var result = {};
	  _react.Children.map(children, function (child) {
	    return child;
	  }).forEach(function (child) {
	    result[child.key] = child;
	  });
	  return result;
	}
	
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    if (next.hasOwnProperty(key)) {
	      return next[key];
	    }
	
	    return prev[key];
	  }
	
	  // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	  var nextKeysPending = {};
	
	  var pendingKeys = [];
	  for (var prevKey in prev) {
	    if (next.hasOwnProperty(prevKey)) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i = void 0;
	  var childMapping = {};
	  for (var nextKey in next) {
	    if (nextKeysPending.hasOwnProperty(nextKey)) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	    childMapping[nextKey] = getValueForKey(nextKey);
	  }
	
	  // Finally, add the keys which didn't appear before any key in `next`
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}

/***/ },
/* 1957 */
228,
/* 1958 */
[2035, 120],
/* 1959 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var PooledClass = __webpack_require__(1958);
	var ReactElement = __webpack_require__(95);
	
	var emptyFunction = __webpack_require__(24);
	var traverseAllChildren = __webpack_require__(1968);
	
	var twoArgumentPooler = PooledClass.twoArgumentPooler;
	var fourArgumentPooler = PooledClass.fourArgumentPooler;
	
	var userProvidedKeyEscapeRegex = /\/+/g;
	function escapeUserProvidedKey(text) {
	  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * traversal. Allows avoiding binding callbacks.
	 *
	 * @constructor ForEachBookKeeping
	 * @param {!function} forEachFunction Function to perform traversal with.
	 * @param {?*} forEachContext Context to perform context with.
	 */
	function ForEachBookKeeping(forEachFunction, forEachContext) {
	  this.func = forEachFunction;
	  this.context = forEachContext;
	  this.count = 0;
	}
	ForEachBookKeeping.prototype.destructor = function () {
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);
	
	function forEachSingleChild(bookKeeping, child, name) {
	  var func = bookKeeping.func,
	      context = bookKeeping.context;
	
	  func.call(context, child, bookKeeping.count++);
	}
	
	/**
	 * Iterates through children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
	 *
	 * The provided forEachFunc(child, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} forEachFunc
	 * @param {*} forEachContext Context for forEachContext.
	 */
	function forEachChildren(children, forEachFunc, forEachContext) {
	  if (children == null) {
	    return children;
	  }
	  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
	  traverseAllChildren(children, forEachSingleChild, traverseContext);
	  ForEachBookKeeping.release(traverseContext);
	}
	
	/**
	 * PooledClass representing the bookkeeping associated with performing a child
	 * mapping. Allows avoiding binding callbacks.
	 *
	 * @constructor MapBookKeeping
	 * @param {!*} mapResult Object containing the ordered map of results.
	 * @param {!function} mapFunction Function to perform mapping with.
	 * @param {?*} mapContext Context to perform mapping with.
	 */
	function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
	  this.result = mapResult;
	  this.keyPrefix = keyPrefix;
	  this.func = mapFunction;
	  this.context = mapContext;
	  this.count = 0;
	}
	MapBookKeeping.prototype.destructor = function () {
	  this.result = null;
	  this.keyPrefix = null;
	  this.func = null;
	  this.context = null;
	  this.count = 0;
	};
	PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);
	
	function mapSingleChildIntoContext(bookKeeping, child, childKey) {
	  var result = bookKeeping.result,
	      keyPrefix = bookKeeping.keyPrefix,
	      func = bookKeeping.func,
	      context = bookKeeping.context;
	
	
	  var mappedChild = func.call(context, child, bookKeeping.count++);
	  if (Array.isArray(mappedChild)) {
	    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
	  } else if (mappedChild != null) {
	    if (ReactElement.isValidElement(mappedChild)) {
	      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
	      // Keep both the (mapped) and old keys if they differ, just as
	      // traverseAllChildren used to do for objects as children
	      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
	    }
	    result.push(mappedChild);
	  }
	}
	
	function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
	  var escapedPrefix = '';
	  if (prefix != null) {
	    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
	  }
	  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
	  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
	  MapBookKeeping.release(traverseContext);
	}
	
	/**
	 * Maps children that are typically specified as `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
	 *
	 * The provided mapFunction(child, key, index) will be called for each
	 * leaf child.
	 *
	 * @param {?*} children Children tree container.
	 * @param {function(*, int)} func The map function.
	 * @param {*} context Context for mapFunction.
	 * @return {object} Object containing the ordered map of results.
	 */
	function mapChildren(children, func, context) {
	  if (children == null) {
	    return children;
	  }
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
	  return result;
	}
	
	function forEachSingleChildDummy(traverseContext, child, name) {
	  return null;
	}
	
	/**
	 * Count the number of children that are typically specified as
	 * `props.children`.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
	 *
	 * @param {?*} children Children tree container.
	 * @return {number} The number of children.
	 */
	function countChildren(children, context) {
	  return traverseAllChildren(children, forEachSingleChildDummy, null);
	}
	
	/**
	 * Flatten a children object (typically specified as `props.children`) and
	 * return an array with appropriately re-keyed children.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
	 */
	function toArray(children) {
	  var result = [];
	  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
	  return result;
	}
	
	var ReactChildren = {
	  forEach: forEachChildren,
	  map: mapChildren,
	  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
	  count: countChildren,
	  toArray: toArray
	};
	
	module.exports = ReactChildren;

/***/ },
/* 1960 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var ReactElement = __webpack_require__(95);
	
	/**
	 * Create a factory that creates HTML tag elements.
	 *
	 * @private
	 */
	var createDOMFactory = ReactElement.createFactory;
	if (false) {
	  var ReactElementValidator = require('./ReactElementValidator');
	  createDOMFactory = ReactElementValidator.createFactory;
	}
	
	/**
	 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
	 *
	 * @public
	 */
	var ReactDOMFactories = {
	  a: createDOMFactory('a'),
	  abbr: createDOMFactory('abbr'),
	  address: createDOMFactory('address'),
	  area: createDOMFactory('area'),
	  article: createDOMFactory('article'),
	  aside: createDOMFactory('aside'),
	  audio: createDOMFactory('audio'),
	  b: createDOMFactory('b'),
	  base: createDOMFactory('base'),
	  bdi: createDOMFactory('bdi'),
	  bdo: createDOMFactory('bdo'),
	  big: createDOMFactory('big'),
	  blockquote: createDOMFactory('blockquote'),
	  body: createDOMFactory('body'),
	  br: createDOMFactory('br'),
	  button: createDOMFactory('button'),
	  canvas: createDOMFactory('canvas'),
	  caption: createDOMFactory('caption'),
	  cite: createDOMFactory('cite'),
	  code: createDOMFactory('code'),
	  col: createDOMFactory('col'),
	  colgroup: createDOMFactory('colgroup'),
	  data: createDOMFactory('data'),
	  datalist: createDOMFactory('datalist'),
	  dd: createDOMFactory('dd'),
	  del: createDOMFactory('del'),
	  details: createDOMFactory('details'),
	  dfn: createDOMFactory('dfn'),
	  dialog: createDOMFactory('dialog'),
	  div: createDOMFactory('div'),
	  dl: createDOMFactory('dl'),
	  dt: createDOMFactory('dt'),
	  em: createDOMFactory('em'),
	  embed: createDOMFactory('embed'),
	  fieldset: createDOMFactory('fieldset'),
	  figcaption: createDOMFactory('figcaption'),
	  figure: createDOMFactory('figure'),
	  footer: createDOMFactory('footer'),
	  form: createDOMFactory('form'),
	  h1: createDOMFactory('h1'),
	  h2: createDOMFactory('h2'),
	  h3: createDOMFactory('h3'),
	  h4: createDOMFactory('h4'),
	  h5: createDOMFactory('h5'),
	  h6: createDOMFactory('h6'),
	  head: createDOMFactory('head'),
	  header: createDOMFactory('header'),
	  hgroup: createDOMFactory('hgroup'),
	  hr: createDOMFactory('hr'),
	  html: createDOMFactory('html'),
	  i: createDOMFactory('i'),
	  iframe: createDOMFactory('iframe'),
	  img: createDOMFactory('img'),
	  input: createDOMFactory('input'),
	  ins: createDOMFactory('ins'),
	  kbd: createDOMFactory('kbd'),
	  keygen: createDOMFactory('keygen'),
	  label: createDOMFactory('label'),
	  legend: createDOMFactory('legend'),
	  li: createDOMFactory('li'),
	  link: createDOMFactory('link'),
	  main: createDOMFactory('main'),
	  map: createDOMFactory('map'),
	  mark: createDOMFactory('mark'),
	  menu: createDOMFactory('menu'),
	  menuitem: createDOMFactory('menuitem'),
	  meta: createDOMFactory('meta'),
	  meter: createDOMFactory('meter'),
	  nav: createDOMFactory('nav'),
	  noscript: createDOMFactory('noscript'),
	  object: createDOMFactory('object'),
	  ol: createDOMFactory('ol'),
	  optgroup: createDOMFactory('optgroup'),
	  option: createDOMFactory('option'),
	  output: createDOMFactory('output'),
	  p: createDOMFactory('p'),
	  param: createDOMFactory('param'),
	  picture: createDOMFactory('picture'),
	  pre: createDOMFactory('pre'),
	  progress: createDOMFactory('progress'),
	  q: createDOMFactory('q'),
	  rp: createDOMFactory('rp'),
	  rt: createDOMFactory('rt'),
	  ruby: createDOMFactory('ruby'),
	  s: createDOMFactory('s'),
	  samp: createDOMFactory('samp'),
	  script: createDOMFactory('script'),
	  section: createDOMFactory('section'),
	  select: createDOMFactory('select'),
	  small: createDOMFactory('small'),
	  source: createDOMFactory('source'),
	  span: createDOMFactory('span'),
	  strong: createDOMFactory('strong'),
	  style: createDOMFactory('style'),
	  sub: createDOMFactory('sub'),
	  summary: createDOMFactory('summary'),
	  sup: createDOMFactory('sup'),
	  table: createDOMFactory('table'),
	  tbody: createDOMFactory('tbody'),
	  td: createDOMFactory('td'),
	  textarea: createDOMFactory('textarea'),
	  tfoot: createDOMFactory('tfoot'),
	  th: createDOMFactory('th'),
	  thead: createDOMFactory('thead'),
	  time: createDOMFactory('time'),
	  title: createDOMFactory('title'),
	  tr: createDOMFactory('tr'),
	  track: createDOMFactory('track'),
	  u: createDOMFactory('u'),
	  ul: createDOMFactory('ul'),
	  'var': createDOMFactory('var'),
	  video: createDOMFactory('video'),
	  wbr: createDOMFactory('wbr'),
	
	  // SVG
	  circle: createDOMFactory('circle'),
	  clipPath: createDOMFactory('clipPath'),
	  defs: createDOMFactory('defs'),
	  ellipse: createDOMFactory('ellipse'),
	  g: createDOMFactory('g'),
	  image: createDOMFactory('image'),
	  line: createDOMFactory('line'),
	  linearGradient: createDOMFactory('linearGradient'),
	  mask: createDOMFactory('mask'),
	  path: createDOMFactory('path'),
	  pattern: createDOMFactory('pattern'),
	  polygon: createDOMFactory('polygon'),
	  polyline: createDOMFactory('polyline'),
	  radialGradient: createDOMFactory('radialGradient'),
	  rect: createDOMFactory('rect'),
	  stop: createDOMFactory('stop'),
	  svg: createDOMFactory('svg'),
	  text: createDOMFactory('text'),
	  tspan: createDOMFactory('tspan')
	};
	
	module.exports = ReactDOMFactories;

/***/ },
/* 1961 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(95),
	    isValidElement = _require.isValidElement;
	
	var factory = __webpack_require__(392);
	
	module.exports = factory(isValidElement);

/***/ },
/* 1962 */
1892,
/* 1963 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _require = __webpack_require__(423),
	    Component = _require.Component;
	
	var _require2 = __webpack_require__(95),
	    isValidElement = _require2.isValidElement;
	
	var ReactNoopUpdateQueue = __webpack_require__(426);
	var factory = __webpack_require__(548);
	
	module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ },
/* 1964 */
1911,
/* 1965 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var nextDebugID = 1;
	
	function getNextDebugID() {
	  return nextDebugID++;
	}
	
	module.exports = getNextDebugID;

/***/ },
/* 1966 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2014-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	/**
	 * Forked from fbjs/warning:
	 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
	 *
	 * Only change is we use console.warn instead of console.error,
	 * and do nothing when 'console' is not supported.
	 * This really simplifies the code.
	 * ---
	 * Similar to invariant but only logs a warning if the condition is not met.
	 * This can be used to log issues in development environments in critical
	 * paths. Removing the logging code for production environments will keep the
	 * same logic and follow the same code paths.
	 */
	
	var lowPriorityWarning = function () {};
	
	if (false) {
	  var printWarning = function (format) {
	    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    var argIndex = 0;
	    var message = 'Warning: ' + format.replace(/%s/g, function () {
	      return args[argIndex++];
	    });
	    if (typeof console !== 'undefined') {
	      console.warn(message);
	    }
	    try {
	      // --- Welcome to debugging React ---
	      // This error was thrown as a convenience so that you can use this stack
	      // to find the callsite that caused this warning to fire.
	      throw new Error(message);
	    } catch (x) {}
	  };
	
	  lowPriorityWarning = function (condition, format) {
	    if (format === undefined) {
	      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
	    }
	    if (!condition) {
	      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
	        args[_key2 - 2] = arguments[_key2];
	      }
	
	      printWarning.apply(undefined, [format].concat(args));
	    }
	  };
	}
	
	module.exports = lowPriorityWarning;

/***/ },
/* 1967 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	'use strict';
	
	var _prodInvariant = __webpack_require__(120);
	
	var ReactElement = __webpack_require__(95);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Returns the first child in a collection of children and verifies that there
	 * is only one child in the collection.
	 *
	 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
	 *
	 * The current implementation of this function assumes that a single child gets
	 * passed without a wrapper, but the purpose of this helper function is to
	 * abstract away the particular structure of children.
	 *
	 * @param {?object} children Child collection structure.
	 * @return {ReactElement} The first and only `ReactElement` contained in the
	 * structure.
	 */
	function onlyChild(children) {
	  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
	  return children;
	}
	
	module.exports = onlyChild;

/***/ },
/* 1968 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(120);
	
	var ReactCurrentOwner = __webpack_require__(45);
	var REACT_ELEMENT_TYPE = __webpack_require__(425);
	
	var getIteratorFn = __webpack_require__(1964);
	var invariant = __webpack_require__(13);
	var KeyEscapeUtils = __webpack_require__(1957);
	var warning = __webpack_require__(16);
	
	var SEPARATOR = '.';
	var SUBSEPARATOR = ':';
	
	/**
	 * This is inlined from ReactElement since this file is shared between
	 * isomorphic and renderers. We could extract this to a
	 *
	 */
	
	/**
	 * TODO: Test that a single child and an array with one item have the same key
	 * pattern.
	 */
	
	var didWarnAboutMaps = false;
	
	/**
	 * Generate a key string that identifies a component within a set.
	 *
	 * @param {*} component A component that could contain a manual key.
	 * @param {number} index Index that is used if a manual key is not provided.
	 * @return {string}
	 */
	function getComponentKey(component, index) {
	  // Do some typechecking here since we call this blindly. We want to ensure
	  // that we don't block potential future ES APIs.
	  if (component && typeof component === 'object' && component.key != null) {
	    // Explicit key
	    return KeyEscapeUtils.escape(component.key);
	  }
	  // Implicit key determined by the index in the set
	  return index.toString(36);
	}
	
	/**
	 * @param {?*} children Children tree container.
	 * @param {!string} nameSoFar Name of the key path so far.
	 * @param {!function} callback Callback to invoke with each child found.
	 * @param {?*} traverseContext Used to pass information throughout the traversal
	 * process.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
	  var type = typeof children;
	
	  if (type === 'undefined' || type === 'boolean') {
	    // All of the above are perceived as null.
	    children = null;
	  }
	
	  if (children === null || type === 'string' || type === 'number' ||
	  // The following is inlined from ReactElement. This means we can optimize
	  // some checks. React Fiber also inlines this logic for similar purposes.
	  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
	    callback(traverseContext, children,
	    // If it's the only child, treat the name as if it was wrapped in an array
	    // so that it's consistent if the number of children grows.
	    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
	    return 1;
	  }
	
	  var child;
	  var nextName;
	  var subtreeCount = 0; // Count of children found in the current subtree.
	  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;
	
	  if (Array.isArray(children)) {
	    for (var i = 0; i < children.length; i++) {
	      child = children[i];
	      nextName = nextNamePrefix + getComponentKey(child, i);
	      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	    }
	  } else {
	    var iteratorFn = getIteratorFn(children);
	    if (iteratorFn) {
	      var iterator = iteratorFn.call(children);
	      var step;
	      if (iteratorFn !== children.entries) {
	        var ii = 0;
	        while (!(step = iterator.next()).done) {
	          child = step.value;
	          nextName = nextNamePrefix + getComponentKey(child, ii++);
	          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	        }
	      } else {
	        if (false) {
	          var mapsAsChildrenAddendum = '';
	          if (ReactCurrentOwner.current) {
	            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
	            if (mapsAsChildrenOwnerName) {
	              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
	            }
	          }
	          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
	          didWarnAboutMaps = true;
	        }
	        // Iterator will provide entry [k,v] tuples rather than values.
	        while (!(step = iterator.next()).done) {
	          var entry = step.value;
	          if (entry) {
	            child = entry[1];
	            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
	            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
	          }
	        }
	      }
	    } else if (type === 'object') {
	      var addendum = '';
	      if (false) {
	        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
	        if (children._isReactElement) {
	          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
	        }
	        if (ReactCurrentOwner.current) {
	          var name = ReactCurrentOwner.current.getName();
	          if (name) {
	            addendum += ' Check the render method of `' + name + '`.';
	          }
	        }
	      }
	      var childrenString = String(children);
	       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
	    }
	  }
	
	  return subtreeCount;
	}
	
	/**
	 * Traverses children that are typically specified as `props.children`, but
	 * might also be specified through attributes:
	 *
	 * - `traverseAllChildren(this.props.children, ...)`
	 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
	 *
	 * The `traverseContext` is an optional argument that is passed through the
	 * entire traversal. It can be used to store accumulations or anything else that
	 * the callback might find relevant.
	 *
	 * @param {?*} children Children tree object.
	 * @param {!function} callback To invoke upon traversing each child.
	 * @param {?*} traverseContext Context for traversal.
	 * @return {!number} The number of children in this subtree.
	 */
	function traverseAllChildren(children, callback, traverseContext) {
	  if (children == null) {
	    return 0;
	  }
	
	  return traverseAllChildrenImpl(children, '', callback, traverseContext);
	}
	
	module.exports = traverseAllChildren;

/***/ },
/* 1969 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(67);


/***/ },
/* 1970 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	// a passthrough stream.
	// basically just the most minimal sort of Transform stream.
	// Every written chunk gets output as-is.
	
	'use strict';
	
	module.exports = PassThrough;
	
	var Transform = __webpack_require__(429);
	
	/*<replacement>*/
	var util = __webpack_require__(103);
	util.inherits = __webpack_require__(38);
	/*</replacement>*/
	
	util.inherits(PassThrough, Transform);
	
	function PassThrough(options) {
	  if (!(this instanceof PassThrough)) return new PassThrough(options);
	
	  Transform.call(this, options);
	}
	
	PassThrough.prototype._transform = function (chunk, encoding, cb) {
	  cb(null, chunk);
	};

/***/ },
/* 1971 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/*<replacement>*/
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var Buffer = __webpack_require__(160).Buffer;
	/*</replacement>*/
	
	function copyBuffer(src, target, offset) {
	  src.copy(target, offset);
	}
	
	module.exports = function () {
	  function BufferList() {
	    _classCallCheck(this, BufferList);
	
	    this.head = null;
	    this.tail = null;
	    this.length = 0;
	  }
	
	  BufferList.prototype.push = function push(v) {
	    var entry = { data: v, next: null };
	    if (this.length > 0) this.tail.next = entry;else this.head = entry;
	    this.tail = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.unshift = function unshift(v) {
	    var entry = { data: v, next: this.head };
	    if (this.length === 0) this.tail = entry;
	    this.head = entry;
	    ++this.length;
	  };
	
	  BufferList.prototype.shift = function shift() {
	    if (this.length === 0) return;
	    var ret = this.head.data;
	    if (this.length === 1) this.head = this.tail = null;else this.head = this.head.next;
	    --this.length;
	    return ret;
	  };
	
	  BufferList.prototype.clear = function clear() {
	    this.head = this.tail = null;
	    this.length = 0;
	  };
	
	  BufferList.prototype.join = function join(s) {
	    if (this.length === 0) return '';
	    var p = this.head;
	    var ret = '' + p.data;
	    while (p = p.next) {
	      ret += s + p.data;
	    }return ret;
	  };
	
	  BufferList.prototype.concat = function concat(n) {
	    if (this.length === 0) return Buffer.alloc(0);
	    if (this.length === 1) return this.head.data;
	    var ret = Buffer.allocUnsafe(n >>> 0);
	    var p = this.head;
	    var i = 0;
	    while (p) {
	      copyBuffer(p.data, ret, i);
	      i += p.data.length;
	      p = p.next;
	    }
	    return ret;
	  };
	
	  return BufferList;
	}();

/***/ },
/* 1972 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(246).PassThrough


/***/ },
/* 1973 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(246).Transform


/***/ },
/* 1974 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(245);


/***/ },
/* 1975 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = compose;
	function compose() {
	  for (var _len = arguments.length, funcs = Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  if (funcs.length === 0) {
	    return function (arg) {
	      return arg;
	    };
	  }
	
	  if (funcs.length === 1) {
	    return funcs[0];
	  }
	
	  return funcs.reduce(function (a, b) {
	    return function () {
	      return a(b.apply(undefined, arguments));
	    };
	  });
	}

/***/ },
/* 1976 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _createEagerElementUtil = __webpack_require__(1982);
	
	var _createEagerElementUtil2 = _interopRequireDefault(_createEagerElementUtil);
	
	var _isReferentiallyTransparentFunctionComponent = __webpack_require__(1979);
	
	var _isReferentiallyTransparentFunctionComponent2 = _interopRequireDefault(_isReferentiallyTransparentFunctionComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createFactory = function createFactory(type) {
	  var isReferentiallyTransparent = (0, _isReferentiallyTransparentFunctionComponent2.default)(type);
	  return function (p, c) {
	    return (0, _createEagerElementUtil2.default)(false, isReferentiallyTransparent, type, p, c);
	  };
	};
	
	exports.default = createFactory;

/***/ },
/* 1977 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	var getDisplayName = function getDisplayName(Component) {
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (!Component) {
	    return undefined;
	  }
	
	  return Component.displayName || Component.name || 'Component';
	};
	
	exports.default = getDisplayName;

/***/ },
/* 1978 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isClassComponent = function isClassComponent(Component) {
	  return Boolean(Component && Component.prototype && _typeof(Component.prototype.isReactComponent) === 'object');
	};
	
	exports.default = isClassComponent;

/***/ },
/* 1979 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _isClassComponent = __webpack_require__(1978);
	
	var _isClassComponent2 = _interopRequireDefault(_isClassComponent);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var isReferentiallyTransparentFunctionComponent = function isReferentiallyTransparentFunctionComponent(Component) {
	  return Boolean(typeof Component === 'function' && !(0, _isClassComponent2.default)(Component) && !Component.defaultProps && !Component.contextTypes && (("production") === 'production' || !Component.propTypes));
	};
	
	exports.default = isReferentiallyTransparentFunctionComponent;

/***/ },
/* 1980 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var setStatic = function setStatic(key, value) {
	  return function (BaseComponent) {
	    /* eslint-disable no-param-reassign */
	    BaseComponent[key] = value;
	    /* eslint-enable no-param-reassign */
	    return BaseComponent;
	  };
	};
	
	exports.default = setStatic;

/***/ },
/* 1981 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _setDisplayName = __webpack_require__(432);
	
	var _setDisplayName2 = _interopRequireDefault(_setDisplayName);
	
	var _wrapDisplayName = __webpack_require__(433);
	
	var _wrapDisplayName2 = _interopRequireDefault(_wrapDisplayName);
	
	var _createEagerFactory = __webpack_require__(1976);
	
	var _createEagerFactory2 = _interopRequireDefault(_createEagerFactory);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var shouldUpdate = function shouldUpdate(test) {
	  return function (BaseComponent) {
	    var factory = (0, _createEagerFactory2.default)(BaseComponent);
	
	    var ShouldUpdate = function (_Component) {
	      _inherits(ShouldUpdate, _Component);
	
	      function ShouldUpdate() {
	        _classCallCheck(this, ShouldUpdate);
	
	        return _possibleConstructorReturn(this, _Component.apply(this, arguments));
	      }
	
	      ShouldUpdate.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
	        return test(this.props, nextProps);
	      };
	
	      ShouldUpdate.prototype.render = function render() {
	        return factory(this.props);
	      };
	
	      return ShouldUpdate;
	    }(_react.Component);
	
	    if (false) {
	      return (0, _setDisplayName2.default)((0, _wrapDisplayName2.default)(BaseComponent, 'shouldUpdate'))(ShouldUpdate);
	    }
	    return ShouldUpdate;
	  };
	};
	
	exports.default = shouldUpdate;

/***/ },
/* 1982 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var createEagerElementUtil = function createEagerElementUtil(hasKey, isReferentiallyTransparent, type, props, children) {
	  if (!hasKey && isReferentiallyTransparent) {
	    if (children) {
	      return type(_extends({}, props, { children: children }));
	    }
	    return type(props);
	  }
	
	  var Component = type;
	
	  if (children) {
	    return _react2.default.createElement(
	      Component,
	      props,
	      children
	    );
	  }
	
	  return _react2.default.createElement(Component, props);
	};
	
	exports.default = createEagerElementUtil;

/***/ },
/* 1983 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var compose = __webpack_require__(121).compose;
	
	exports.__esModule = true;
	exports.composeWithDevTools = (
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ?
	    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ :
	    function() {
	      if (arguments.length === 0) return undefined;
	      if (typeof arguments[0] === 'object') return compose;
	      return compose.apply(null, arguments);
	    }
	);
	
	exports.devToolsEnhancer = (
	  typeof window !== 'undefined' && window.__REDUX_DEVTOOLS_EXTENSION__ ?
	    window.__REDUX_DEVTOOLS_EXTENSION__ :
	    function() { return function(noop) { return noop; } }
	);


/***/ },
/* 1984 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var __DEBUG__ = void 0;
	var displayBuffer = void 0;
	
	var colors = {
	  prevState: '#9E9E9E',
	  action: '#03A9F4',
	  nextState: '#4CAF50'
	
	  /* istanbul ignore next: debug messaging is not tested */
	};function initBuffer() {
	  displayBuffer = {
	    header: [],
	    prev: [],
	    action: [],
	    next: [],
	    msgs: []
	  };
	}
	
	/* istanbul ignore next: debug messaging is not tested */
	function printBuffer() {
	  var _displayBuffer = displayBuffer,
	      header = _displayBuffer.header,
	      prev = _displayBuffer.prev,
	      next = _displayBuffer.next,
	      action = _displayBuffer.action,
	      msgs = _displayBuffer.msgs;
	
	  if (console.group) {
	    var _console, _console2, _console3, _console4, _console5;
	
	    (_console = console).groupCollapsed.apply(_console, _toConsumableArray(header));
	    (_console2 = console).log.apply(_console2, _toConsumableArray(prev));
	    (_console3 = console).log.apply(_console3, _toConsumableArray(action));
	    (_console4 = console).log.apply(_console4, _toConsumableArray(next));
	    (_console5 = console).log.apply(_console5, _toConsumableArray(msgs));
	    console.groupEnd();
	  } else {
	    var _console6, _console7, _console8, _console9, _console10;
	
	    (_console6 = console).log.apply(_console6, _toConsumableArray(header));
	    (_console7 = console).log.apply(_console7, _toConsumableArray(prev));
	    (_console8 = console).log.apply(_console8, _toConsumableArray(action));
	    (_console9 = console).log.apply(_console9, _toConsumableArray(next));
	    (_console10 = console).log.apply(_console10, _toConsumableArray(msgs));
	  }
	}
	
	/* istanbul ignore next: debug messaging is not tested */
	function colorFormat(text, color, obj) {
	  return ['%c' + text, 'color: ' + color + '; font-weight: bold', obj];
	}
	
	/* istanbul ignore next: debug messaging is not tested */
	function start(action, state) {
	  initBuffer();
	  if (__DEBUG__) {
	    if (console.group) {
	      displayBuffer.header = ['%credux-undo', 'font-style: italic', 'action', action.type];
	      displayBuffer.action = colorFormat('action', colors.action, action);
	      displayBuffer.prev = colorFormat('prev history', colors.prevState, state);
	    } else {
	      displayBuffer.header = ['redux-undo action', action.type];
	      displayBuffer.action = ['action', action];
	      displayBuffer.prev = ['prev history', state];
	    }
	  }
	}
	
	/* istanbul ignore next: debug messaging is not tested */
	function end(nextState) {
	  if (__DEBUG__) {
	    if (console.group) {
	      displayBuffer.next = colorFormat('next history', colors.nextState, nextState);
	    } else {
	      displayBuffer.next = ['next history', nextState];
	    }
	    printBuffer();
	  }
	}
	
	/* istanbul ignore next: debug messaging is not tested */
	function log() {
	  if (__DEBUG__) {
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    displayBuffer.msgs = displayBuffer.msgs.concat([].concat(args, ['\n']));
	  }
	}
	
	/* istanbul ignore next: debug messaging is not tested */
	function set(debug) {
	  __DEBUG__ = debug;
	}
	
	exports.set = set;
	exports.start = start;
	exports.end = end;
	exports.log = log;

/***/ },
/* 1985 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = undoable;
	
	var _debug = __webpack_require__(1984);
	
	var debug = _interopRequireWildcard(_debug);
	
	var _actions = __webpack_require__(434);
	
	var _helpers = __webpack_require__(435);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	// createHistory
	function createHistory(state, ignoreInitialState) {
	  // ignoreInitialState essentially prevents the user from undoing to the
	  // beginning, in the case that the undoable reducer handles initialization
	  // in a way that can't be redone simply
	  var history = (0, _helpers.newHistory)([], state, []);
	  if (ignoreInitialState) {
	    history._latestUnfiltered = null;
	  }
	  return history;
	}
	
	// lengthWithoutFuture: get length of history
	function lengthWithoutFuture(history) {
	  return history.past.length + 1;
	}
	
	// insert: insert `state` into history, which means adding the current state
	//         into `past`, setting the new `state` as `present` and erasing
	//         the `future`.
	function insert(history, state, limit, group) {
	  debug.log('inserting', state);
	  debug.log('new free: ', limit - lengthWithoutFuture(history));
	
	  var past = history.past,
	      _latestUnfiltered = history._latestUnfiltered;
	
	  var historyOverflow = limit && lengthWithoutFuture(history) >= limit;
	
	  var pastSliced = past.slice(historyOverflow ? 1 : 0);
	  var newPast = _latestUnfiltered != null ? [].concat(_toConsumableArray(pastSliced), [_latestUnfiltered]) : pastSliced;
	
	  return (0, _helpers.newHistory)(newPast, state, [], group);
	}
	
	// jumpToFuture: jump to requested index in future history
	function jumpToFuture(history, index) {
	  if (index < 0 || index >= history.future.length) return history;
	
	  var past = history.past,
	      future = history.future,
	      _latestUnfiltered = history._latestUnfiltered;
	
	
	  var newPast = [].concat(_toConsumableArray(past), [_latestUnfiltered], _toConsumableArray(future.slice(0, index)));
	  var newPresent = future[index];
	  var newFuture = future.slice(index + 1);
	
	  return (0, _helpers.newHistory)(newPast, newPresent, newFuture);
	}
	
	// jumpToPast: jump to requested index in past history
	function jumpToPast(history, index) {
	  if (index < 0 || index >= history.past.length) return history;
	
	  var past = history.past,
	      future = history.future,
	      _latestUnfiltered = history._latestUnfiltered;
	
	
	  var newPast = past.slice(0, index);
	  var newFuture = [].concat(_toConsumableArray(past.slice(index + 1)), [_latestUnfiltered], _toConsumableArray(future));
	  var newPresent = past[index];
	
	  return (0, _helpers.newHistory)(newPast, newPresent, newFuture);
	}
	
	// jump: jump n steps in the past or forward
	function jump(history, n) {
	  if (n > 0) return jumpToFuture(history, n - 1);
	  if (n < 0) return jumpToPast(history, history.past.length + n);
	  return history;
	}
	
	// helper to dynamically match in the reducer's switch-case
	function actionTypeAmongClearHistoryType(actionType, clearHistoryType) {
	  return clearHistoryType.indexOf(actionType) > -1 ? actionType : !actionType;
	}
	
	// redux-undo higher order reducer
	function undoable(reducer) {
	  var rawConfig = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  debug.set(rawConfig.debug);
	
	  var config = {
	    initTypes: (0, _helpers.parseActions)(rawConfig.initTypes, ['@@redux-undo/INIT']),
	    limit: rawConfig.limit,
	    filter: rawConfig.filter || function () {
	      return true;
	    },
	    groupBy: rawConfig.groupBy || function () {
	      return null;
	    },
	    undoType: rawConfig.undoType || _actions.ActionTypes.UNDO,
	    redoType: rawConfig.redoType || _actions.ActionTypes.REDO,
	    jumpToPastType: rawConfig.jumpToPastType || _actions.ActionTypes.JUMP_TO_PAST,
	    jumpToFutureType: rawConfig.jumpToFutureType || _actions.ActionTypes.JUMP_TO_FUTURE,
	    jumpType: rawConfig.jumpType || _actions.ActionTypes.JUMP,
	    clearHistoryType: Array.isArray(rawConfig.clearHistoryType) ? rawConfig.clearHistoryType : [rawConfig.clearHistoryType || _actions.ActionTypes.CLEAR_HISTORY],
	    neverSkipReducer: rawConfig.neverSkipReducer || false,
	    ignoreInitialState: rawConfig.ignoreInitialState || false,
	    syncFilter: rawConfig.syncFilter || false
	  };
	
	  var initialState = config.history;
	  return function () {
	    for (var _len = arguments.length, slices = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
	      slices[_key - 2] = arguments[_key];
	    }
	
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
	    var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	    debug.start(action, state);
	
	    var history = state;
	    if (!initialState) {
	      debug.log('history is uninitialized');
	
	      if (state === undefined) {
	        var clearHistoryAction = { type: _actions.ActionTypes.CLEAR_HISTORY };
	        var start = reducer.apply(undefined, [state, clearHistoryAction].concat(slices));
	
	        history = createHistory(start, config.ignoreInitialState);
	
	        debug.log('do not set initialState on probe actions');
	      } else if ((0, _helpers.isHistory)(state)) {
	        history = initialState = config.ignoreInitialState ? state : (0, _helpers.newHistory)(state.past, state.present, state.future);
	        debug.log('initialHistory initialized: initialState is a history', initialState);
	      } else {
	        history = initialState = createHistory(state, config.ignoreInitialState);
	        debug.log('initialHistory initialized: initialState is not a history', initialState);
	      }
	    }
	
	    var skipReducer = function skipReducer(res) {
	      return config.neverSkipReducer ? _extends({}, res, {
	        present: reducer.apply(undefined, [res.present, action].concat(slices))
	      }) : res;
	    };
	
	    var res = void 0;
	    switch (action.type) {
	      case undefined:
	        return history;
	
	      case config.undoType:
	        res = jump(history, -1);
	        debug.log('perform undo');
	        debug.end(res);
	        return skipReducer(res);
	
	      case config.redoType:
	        res = jump(history, 1);
	        debug.log('perform redo');
	        debug.end(res);
	        return skipReducer(res);
	
	      case config.jumpToPastType:
	        res = jumpToPast(history, action.index);
	        debug.log('perform jumpToPast to ' + action.index);
	        debug.end(res);
	        return skipReducer(res);
	
	      case config.jumpToFutureType:
	        res = jumpToFuture(history, action.index);
	        debug.log('perform jumpToFuture to ' + action.index);
	        debug.end(res);
	        return skipReducer(res);
	
	      case config.jumpType:
	        res = jump(history, action.index);
	        debug.log('perform jump to ' + action.index);
	        debug.end(res);
	        return skipReducer(res);
	
	      case actionTypeAmongClearHistoryType(action.type, config.clearHistoryType):
	        res = createHistory(history.present);
	        debug.log('perform clearHistory');
	        debug.end(res);
	        return skipReducer(res);
	
	      default:
	        res = reducer.apply(undefined, [history.present, action].concat(slices));
	
	        if (config.initTypes.some(function (actionType) {
	          return actionType === action.type;
	        })) {
	          debug.log('reset history due to init action');
	          debug.end(initialState);
	          return initialState;
	        }
	
	        if (history._latestUnfiltered === res) {
	          // Don't handle this action. Do not call debug.end here,
	          // because this action should not produce side effects to the console
	          return history;
	        }
	
	        var filtered = typeof config.filter === 'function' && !config.filter(action, res, history);
	        var group = config.groupBy(action, res, history);
	
	        if (filtered) {
	          // if filtering an action, merely update the present
	          var filteredState = (0, _helpers.newHistory)(history.past, res, history.future, history.group);
	          if (!config.syncFilter) {
	            filteredState._latestUnfiltered = history._latestUnfiltered;
	          }
	          debug.log('filter ignored action, not storing it in past');
	          debug.end(filteredState);
	          return filteredState;
	        } else if (group != null && group === history.group) {
	          var groupedState = (0, _helpers.newHistory)(history.past, res, history.future, history.group);
	          debug.log('groupBy grouped the action with the previous action');
	          debug.end(groupedState);
	          return groupedState;
	        } else {
	          // If the action wasn't filtered, insert normally
	          history = insert(history, res, config.limit, group);
	
	          debug.log('inserted new state into history');
	          debug.end(history);
	          return history;
	        }
	    }
	  };
	}
	module.exports = exports['default'];

/***/ },
/* 1986 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports['default'] = applyMiddleware;
	
	var _compose = __webpack_require__(437);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * Creates a store enhancer that applies middleware to the dispatch method
	 * of the Redux store. This is handy for a variety of tasks, such as expressing
	 * asynchronous actions in a concise manner, or logging every action payload.
	 *
	 * See `redux-thunk` package as an example of the Redux middleware.
	 *
	 * Because middleware is potentially asynchronous, this should be the first
	 * store enhancer in the composition chain.
	 *
	 * Note that each middleware will be given the `dispatch` and `getState` functions
	 * as named arguments.
	 *
	 * @param {...Function} middlewares The middleware chain to be applied.
	 * @returns {Function} A store enhancer applying the middleware.
	 */
	function applyMiddleware() {
	  for (var _len = arguments.length, middlewares = Array(_len), _key = 0; _key < _len; _key++) {
	    middlewares[_key] = arguments[_key];
	  }
	
	  return function (createStore) {
	    return function (reducer, preloadedState, enhancer) {
	      var store = createStore(reducer, preloadedState, enhancer);
	      var _dispatch = store.dispatch;
	      var chain = [];
	
	      var middlewareAPI = {
	        getState: store.getState,
	        dispatch: function dispatch(action) {
	          return _dispatch(action);
	        }
	      };
	      chain = middlewares.map(function (middleware) {
	        return middleware(middlewareAPI);
	      });
	      _dispatch = _compose2['default'].apply(undefined, chain)(store.dispatch);
	
	      return _extends({}, store, {
	        dispatch: _dispatch
	      });
	    };
	  };
	}

/***/ },
/* 1987 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = bindActionCreators;
	function bindActionCreator(actionCreator, dispatch) {
	  return function () {
	    return dispatch(actionCreator.apply(undefined, arguments));
	  };
	}
	
	/**
	 * Turns an object whose values are action creators, into an object with the
	 * same keys, but with every function wrapped into a `dispatch` call so they
	 * may be invoked directly. This is just a convenience method, as you can call
	 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
	 *
	 * For convenience, you can also pass a single function as the first argument,
	 * and get a function in return.
	 *
	 * @param {Function|Object} actionCreators An object whose values are action
	 * creator functions. One handy way to obtain it is to use ES6 `import * as`
	 * syntax. You may also pass a single function.
	 *
	 * @param {Function} dispatch The `dispatch` function available on your Redux
	 * store.
	 *
	 * @returns {Function|Object} The object mimicking the original object, but with
	 * every action creator wrapped into the `dispatch` call. If you passed a
	 * function as `actionCreators`, the return value will also be a single
	 * function.
	 */
	function bindActionCreators(actionCreators, dispatch) {
	  if (typeof actionCreators === 'function') {
	    return bindActionCreator(actionCreators, dispatch);
	  }
	
	  if (typeof actionCreators !== 'object' || actionCreators === null) {
	    throw new Error('bindActionCreators expected an object or a function, instead received ' + (actionCreators === null ? 'null' : typeof actionCreators) + '. ' + 'Did you write "import ActionCreators from" instead of "import * as ActionCreators from"?');
	  }
	
	  var keys = Object.keys(actionCreators);
	  var boundActionCreators = {};
	  for (var i = 0; i < keys.length; i++) {
	    var key = keys[i];
	    var actionCreator = actionCreators[key];
	    if (typeof actionCreator === 'function') {
	      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
	    }
	  }
	  return boundActionCreators;
	}

/***/ },
/* 1988 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports['default'] = combineReducers;
	
	var _createStore = __webpack_require__(438);
	
	var _isPlainObject = __webpack_require__(112);
	
	var _isPlainObject2 = _interopRequireDefault(_isPlainObject);
	
	var _warning = __webpack_require__(439);
	
	var _warning2 = _interopRequireDefault(_warning);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function getUndefinedStateErrorMessage(key, action) {
	  var actionType = action && action.type;
	  var actionName = actionType && '"' + actionType.toString() + '"' || 'an action';
	
	  return 'Given action ' + actionName + ', reducer "' + key + '" returned undefined. ' + 'To ignore an action, you must explicitly return the previous state. ' + 'If you want this reducer to hold no value, you can return null instead of undefined.';
	}
	
	function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
	  var reducerKeys = Object.keys(reducers);
	  var argumentName = action && action.type === _createStore.ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';
	
	  if (reducerKeys.length === 0) {
	    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
	  }
	
	  if (!(0, _isPlainObject2['default'])(inputState)) {
	    return 'The ' + argumentName + ' has unexpected type of "' + {}.toString.call(inputState).match(/\s([a-z|A-Z]+)/)[1] + '". Expected argument to be an object with the following ' + ('keys: "' + reducerKeys.join('", "') + '"');
	  }
	
	  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
	    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
	  });
	
	  unexpectedKeys.forEach(function (key) {
	    unexpectedKeyCache[key] = true;
	  });
	
	  if (unexpectedKeys.length > 0) {
	    return 'Unexpected ' + (unexpectedKeys.length > 1 ? 'keys' : 'key') + ' ' + ('"' + unexpectedKeys.join('", "') + '" found in ' + argumentName + '. ') + 'Expected to find one of the known reducer keys instead: ' + ('"' + reducerKeys.join('", "') + '". Unexpected keys will be ignored.');
	  }
	}
	
	function assertReducerShape(reducers) {
	  Object.keys(reducers).forEach(function (key) {
	    var reducer = reducers[key];
	    var initialState = reducer(undefined, { type: _createStore.ActionTypes.INIT });
	
	    if (typeof initialState === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined during initialization. ' + 'If the state passed to the reducer is undefined, you must ' + 'explicitly return the initial state. The initial state may ' + 'not be undefined. If you don\'t want to set a value for this reducer, ' + 'you can use null instead of undefined.');
	    }
	
	    var type = '@@redux/PROBE_UNKNOWN_ACTION_' + Math.random().toString(36).substring(7).split('').join('.');
	    if (typeof reducer(undefined, { type: type }) === 'undefined') {
	      throw new Error('Reducer "' + key + '" returned undefined when probed with a random type. ' + ('Don\'t try to handle ' + _createStore.ActionTypes.INIT + ' or other actions in "redux/*" ') + 'namespace. They are considered private. Instead, you must return the ' + 'current state for any unknown actions, unless it is undefined, ' + 'in which case you must return the initial state, regardless of the ' + 'action type. The initial state may not be undefined, but can be null.');
	    }
	  });
	}
	
	/**
	 * Turns an object whose values are different reducer functions, into a single
	 * reducer function. It will call every child reducer, and gather their results
	 * into a single state object, whose keys correspond to the keys of the passed
	 * reducer functions.
	 *
	 * @param {Object} reducers An object whose values correspond to different
	 * reducer functions that need to be combined into one. One handy way to obtain
	 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
	 * undefined for any action. Instead, they should return their initial state
	 * if the state passed to them was undefined, and the current state for any
	 * unrecognized action.
	 *
	 * @returns {Function} A reducer function that invokes every reducer inside the
	 * passed object, and builds a state object with the same shape.
	 */
	function combineReducers(reducers) {
	  var reducerKeys = Object.keys(reducers);
	  var finalReducers = {};
	  for (var i = 0; i < reducerKeys.length; i++) {
	    var key = reducerKeys[i];
	
	    if (false) {
	      if (typeof reducers[key] === 'undefined') {
	        (0, _warning2['default'])('No reducer provided for key "' + key + '"');
	      }
	    }
	
	    if (typeof reducers[key] === 'function') {
	      finalReducers[key] = reducers[key];
	    }
	  }
	  var finalReducerKeys = Object.keys(finalReducers);
	
	  var unexpectedKeyCache = void 0;
	  if (false) {
	    unexpectedKeyCache = {};
	  }
	
	  var shapeAssertionError = void 0;
	  try {
	    assertReducerShape(finalReducers);
	  } catch (e) {
	    shapeAssertionError = e;
	  }
	
	  return function combination() {
	    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var action = arguments[1];
	
	    if (shapeAssertionError) {
	      throw shapeAssertionError;
	    }
	
	    if (false) {
	      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
	      if (warningMessage) {
	        (0, _warning2['default'])(warningMessage);
	      }
	    }
	
	    var hasChanged = false;
	    var nextState = {};
	    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
	      var _key = finalReducerKeys[_i];
	      var reducer = finalReducers[_key];
	      var previousStateForKey = state[_key];
	      var nextStateForKey = reducer(previousStateForKey, action);
	      if (typeof nextStateForKey === 'undefined') {
	        var errorMessage = getUndefinedStateErrorMessage(_key, action);
	        throw new Error(errorMessage);
	      }
	      nextState[_key] = nextStateForKey;
	      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
	    }
	    return hasChanged ? nextState : state;
	  };
	}

/***/ },
/* 1989 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	function isAbsolute(pathname) {
	  return pathname.charAt(0) === '/';
	}
	
	// About 1.5x faster than the two-arg version of Array#splice()
	function spliceOne(list, index) {
	  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
	    list[i] = list[k];
	  }
	
	  list.pop();
	}
	
	// This implementation is based heavily on node's url.parse
	function resolvePathname(to) {
	  var from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	  var toParts = to && to.split('/') || [];
	  var fromParts = from && from.split('/') || [];
	
	  var isToAbs = to && isAbsolute(to);
	  var isFromAbs = from && isAbsolute(from);
	  var mustEndAbs = isToAbs || isFromAbs;
	
	  if (to && isAbsolute(to)) {
	    // to is absolute
	    fromParts = toParts;
	  } else if (toParts.length) {
	    // to is relative, drop the filename
	    fromParts.pop();
	    fromParts = fromParts.concat(toParts);
	  }
	
	  if (!fromParts.length) return '/';
	
	  var hasTrailingSlash = void 0;
	  if (fromParts.length) {
	    var last = fromParts[fromParts.length - 1];
	    hasTrailingSlash = last === '.' || last === '..' || last === '';
	  } else {
	    hasTrailingSlash = false;
	  }
	
	  var up = 0;
	  for (var i = fromParts.length; i >= 0; i--) {
	    var part = fromParts[i];
	
	    if (part === '.') {
	      spliceOne(fromParts, i);
	    } else if (part === '..') {
	      spliceOne(fromParts, i);
	      up++;
	    } else if (up) {
	      spliceOne(fromParts, i);
	      up--;
	    }
	  }
	
	  if (!mustEndAbs) for (; up--; up) {
	    fromParts.unshift('..');
	  }if (mustEndAbs && fromParts[0] !== '' && (!fromParts[0] || !isAbsolute(fromParts[0]))) fromParts.unshift('');
	
	  var result = fromParts.join('/');
	
	  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';
	
	  return result;
	}
	
	exports.default = resolvePathname;
	module.exports = exports['default'];

/***/ },
/* 1990 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(65)))

/***/ },
/* 1991 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	module.exports = __webpack_require__(1994);


/***/ },
/* 1992 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var encode = __webpack_require__(440);
	var alphabet = __webpack_require__(161);
	
	// Ignore all milliseconds before a certain time to reduce the size of the date entropy without sacrificing uniqueness.
	// This number should be updated every year or so to keep the generated id short.
	// To regenerate `new Date() - 0` and bump the version. Always bump the version!
	var REDUCE_TIME = 1459707606518;
	
	// don't change unless we change the algos or REDUCE_TIME
	// must be an integer and less than 16
	var version = 6;
	
	// Counter is used when shortid is called multiple times in one second.
	var counter;
	
	// Remember the last time shortid was called in case counter is needed.
	var previousSeconds;
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function build(clusterWorkerId) {
	
	    var str = '';
	
	    var seconds = Math.floor((Date.now() - REDUCE_TIME) * 0.001);
	
	    if (seconds === previousSeconds) {
	        counter++;
	    } else {
	        counter = 0;
	        previousSeconds = seconds;
	    }
	
	    str = str + encode(alphabet.lookup, version);
	    str = str + encode(alphabet.lookup, clusterWorkerId);
	    if (counter > 0) {
	        str = str + encode(alphabet.lookup, counter);
	    }
	    str = str + encode(alphabet.lookup, seconds);
	
	    return str;
	}
	
	module.exports = build;


/***/ },
/* 1993 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var alphabet = __webpack_require__(161);
	
	/**
	 * Decode the id to get the version and worker
	 * Mainly for debugging and testing.
	 * @param id - the shortid-generated id.
	 */
	function decode(id) {
	    var characters = alphabet.shuffled();
	    return {
	        version: characters.indexOf(id.substr(0, 1)) & 0x0f,
	        worker: characters.indexOf(id.substr(1, 1)) & 0x0f
	    };
	}
	
	module.exports = decode;


/***/ },
/* 1994 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var alphabet = __webpack_require__(161);
	var encode = __webpack_require__(440);
	var decode = __webpack_require__(1993);
	var build = __webpack_require__(1992);
	var isValid = __webpack_require__(1995);
	
	// if you are using cluster or multiple servers use this to make each instance
	// has a unique value for worker
	// Note: I don't know if this is automatically set when using third
	// party cluster solutions such as pm2.
	var clusterWorkerId = __webpack_require__(1998) || 0;
	
	/**
	 * Set the seed.
	 * Highly recommended if you don't want people to try to figure out your id schema.
	 * exposed as shortid.seed(int)
	 * @param seed Integer value to seed the random alphabet.  ALWAYS USE THE SAME SEED or you might get overlaps.
	 */
	function seed(seedValue) {
	    alphabet.seed(seedValue);
	    return module.exports;
	}
	
	/**
	 * Set the cluster worker or machine id
	 * exposed as shortid.worker(int)
	 * @param workerId worker must be positive integer.  Number less than 16 is recommended.
	 * returns shortid module so it can be chained.
	 */
	function worker(workerId) {
	    clusterWorkerId = workerId;
	    return module.exports;
	}
	
	/**
	 *
	 * sets new characters to use in the alphabet
	 * returns the shuffled alphabet
	 */
	function characters(newCharacters) {
	    if (newCharacters !== undefined) {
	        alphabet.characters(newCharacters);
	    }
	
	    return alphabet.shuffled();
	}
	
	/**
	 * Generate unique id
	 * Returns string id
	 */
	function generate() {
	  return build(clusterWorkerId);
	}
	
	// Export all other functions as properties of the generate function
	module.exports = generate;
	module.exports.generate = generate;
	module.exports.seed = seed;
	module.exports.worker = worker;
	module.exports.characters = characters;
	module.exports.decode = decode;
	module.exports.isValid = isValid;


/***/ },
/* 1995 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var alphabet = __webpack_require__(161);
	
	function isShortId(id) {
	    if (!id || typeof id !== 'string' || id.length < 6 ) {
	        return false;
	    }
	
	    var characters = alphabet.characters();
	    var len = id.length;
	    for(var i = 0; i < len;i++) {
	        if (characters.indexOf(id[i]) === -1) {
	            return false;
	        }
	    }
	    return true;
	}
	
	module.exports = isShortId;


/***/ },
/* 1996 */
/***/ function(module, exports) {

	'use strict';
	
	var crypto = typeof window === 'object' && (window.crypto || window.msCrypto); // IE 11 uses window.msCrypto
	
	function randomByte() {
	    if (!crypto || !crypto.getRandomValues) {
	        return Math.floor(Math.random() * 256) & 0x30;
	    }
	    var dest = new Uint8Array(1);
	    crypto.getRandomValues(dest);
	    return dest[0] & 0x30;
	}
	
	module.exports = randomByte;


/***/ },
/* 1997 */
/***/ function(module, exports) {

	'use strict';
	
	// Found this seed-based random generator somewhere
	// Based on The Central Randomizer 1.3 (C) 1997 by Paul Houle (houle@msc.cornell.edu)
	
	var seed = 1;
	
	/**
	 * return a random number based on a seed
	 * @param seed
	 * @returns {number}
	 */
	function getNextValue() {
	    seed = (seed * 9301 + 49297) % 233280;
	    return seed/(233280.0);
	}
	
	function setSeed(_seed_) {
	    seed = _seed_;
	}
	
	module.exports = {
	    nextValue: getNextValue,
	    seed: setSeed
	};


/***/ },
/* 1998 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = 0;


/***/ },
/* 1999 */
/***/ function(module, exports) {

	/*
	Slick Parser
	 - originally created by the almighty Thomas Aylott <@subtlegradient> (http://subtlegradient.com)
	*/"use strict"
	
	// Notable changes from Slick.Parser 1.0.x
	
	// The parser now uses 2 classes: Expressions and Expression
	// `new Expressions` produces an array-like object containing a list of Expression objects
	// - Expressions::toString() produces a cleaned up expressions string
	// `new Expression` produces an array-like object
	// - Expression::toString() produces a cleaned up expression string
	// The only exposed method is parse, which produces a (cached) `new Expressions` instance
	// parsed.raw is no longer present, use .toString()
	// parsed.expression is now useless, just use the indices
	// parsed.reverse() has been removed for now, due to its apparent uselessness
	// Other changes in the Expressions object:
	// - classNames are now unique, and save both escaped and unescaped values
	// - attributes now save both escaped and unescaped values
	// - pseudos now save both escaped and unescaped values
	
	var escapeRe   = /([-.*+?^${}()|[\]\/\\])/g,
	    unescapeRe = /\\/g
	
	var escape = function(string){
	    // XRegExp v2.0.0-beta-3
	    // « https://github.com/slevithan/XRegExp/blob/master/src/xregexp.js
	    return (string + "").replace(escapeRe, '\\$1')
	}
	
	var unescape = function(string){
	    return (string + "").replace(unescapeRe, '')
	}
	
	var slickRe = RegExp(
	/*
	#!/usr/bin/env ruby
	puts "\t\t" + DATA.read.gsub(/\(\?x\)|\s+#.*$|\s+|\\$|\\n/,'')
	__END__
	    "(?x)^(?:\
	      \\s* ( , ) \\s*               # Separator          \n\
	    | \\s* ( <combinator>+ ) \\s*   # Combinator         \n\
	    |      ( \\s+ )                 # CombinatorChildren \n\
	    |      ( <unicode>+ | \\* )     # Tag                \n\
	    | \\#  ( <unicode>+       )     # ID                 \n\
	    | \\.  ( <unicode>+       )     # ClassName          \n\
	    |                               # Attribute          \n\
	    \\[  \
	        \\s* (<unicode1>+)  (?:  \
	            \\s* ([*^$!~|]?=)  (?:  \
	                \\s* (?:\
	                    ([\"']?)(.*?)\\9 \
	                )\
	            )  \
	        )?  \\s*  \
	    \\](?!\\]) \n\
	    |   :+ ( <unicode>+ )(?:\
	    \\( (?:\
	        (?:([\"'])([^\\12]*)\\12)|((?:\\([^)]+\\)|[^()]*)+)\
	    ) \\)\
	    )?\
	    )"
	*/
	"^(?:\\s*(,)\\s*|\\s*(<combinator>+)\\s*|(\\s+)|(<unicode>+|\\*)|\\#(<unicode>+)|\\.(<unicode>+)|\\[\\s*(<unicode1>+)(?:\\s*([*^$!~|]?=)(?:\\s*(?:([\"']?)(.*?)\\9)))?\\s*\\](?!\\])|(:+)(<unicode>+)(?:\\((?:(?:([\"'])([^\\13]*)\\13)|((?:\\([^)]+\\)|[^()]*)+))\\))?)"
	    .replace(/<combinator>/, '[' + escape(">+~`!@$%^&={}\\;</") + ']')
	    .replace(/<unicode>/g, '(?:[\\w\\u00a1-\\uFFFF-]|\\\\[^\\s0-9a-f])')
	    .replace(/<unicode1>/g, '(?:[:\\w\\u00a1-\\uFFFF-]|\\\\[^\\s0-9a-f])')
	)
	
	// Part
	
	var Part = function Part(combinator){
	    this.combinator = combinator || " "
	    this.tag = "*"
	}
	
	Part.prototype.toString = function(){
	
	    if (!this.raw){
	
	        var xpr = "", k, part
	
	        xpr += this.tag || "*"
	        if (this.id) xpr += "#" + this.id
	        if (this.classes) xpr += "." + this.classList.join(".")
	        if (this.attributes) for (k = 0; part = this.attributes[k++];){
	            xpr += "[" + part.name + (part.operator ? part.operator + '"' + part.value + '"' : '') + "]"
	        }
	        if (this.pseudos) for (k = 0; part = this.pseudos[k++];){
	            xpr += ":" + part.name
	            if (part.value) xpr += "(" + part.value + ")"
	        }
	
	        this.raw = xpr
	
	    }
	
	    return this.raw
	}
	
	// Expression
	
	var Expression = function Expression(){
	    this.length = 0
	}
	
	Expression.prototype.toString = function(){
	
	    if (!this.raw){
	
	        var xpr = ""
	
	        for (var j = 0, bit; bit = this[j++];){
	            if (j !== 1) xpr += " "
	            if (bit.combinator !== " ") xpr += bit.combinator + " "
	            xpr += bit
	        }
	
	        this.raw = xpr
	
	    }
	
	    return this.raw
	}
	
	var replacer = function(
	    rawMatch,
	
	    separator,
	    combinator,
	    combinatorChildren,
	
	    tagName,
	    id,
	    className,
	
	    attributeKey,
	    attributeOperator,
	    attributeQuote,
	    attributeValue,
	
	    pseudoMarker,
	    pseudoClass,
	    pseudoQuote,
	    pseudoClassQuotedValue,
	    pseudoClassValue
	){
	
	    var expression, current
	
	    if (separator || !this.length){
	        expression = this[this.length++] = new Expression
	        if (separator) return ''
	    }
	
	    if (!expression) expression = this[this.length - 1]
	
	    if (combinator || combinatorChildren || !expression.length){
	        current = expression[expression.length++] = new Part(combinator)
	    }
	
	    if (!current) current = expression[expression.length - 1]
	
	    if (tagName){
	
	        current.tag = unescape(tagName)
	
	    } else if (id){
	
	        current.id = unescape(id)
	
	    } else if (className){
	
	        var unescaped = unescape(className)
	
	        var classes = current.classes || (current.classes = {})
	        if (!classes[unescaped]){
	            classes[unescaped] = escape(className)
	            var classList = current.classList || (current.classList = [])
	            classList.push(unescaped)
	            classList.sort()
	        }
	
	    } else if (pseudoClass){
	
	        pseudoClassValue = pseudoClassValue || pseudoClassQuotedValue
	
	        ;(current.pseudos || (current.pseudos = [])).push({
	            type         : pseudoMarker.length == 1 ? 'class' : 'element',
	            name         : unescape(pseudoClass),
	            escapedName  : escape(pseudoClass),
	            value        : pseudoClassValue ? unescape(pseudoClassValue) : null,
	            escapedValue : pseudoClassValue ? escape(pseudoClassValue) : null
	        })
	
	    } else if (attributeKey){
	
	        attributeValue = attributeValue ? escape(attributeValue) : null
	
	        ;(current.attributes || (current.attributes = [])).push({
	            operator     : attributeOperator,
	            name         : unescape(attributeKey),
	            escapedName  : escape(attributeKey),
	            value        : attributeValue ? unescape(attributeValue) : null,
	            escapedValue : attributeValue ? escape(attributeValue) : null
	        })
	
	    }
	
	    return ''
	
	}
	
	// Expressions
	
	var Expressions = function Expressions(expression){
	    this.length = 0
	
	    var self = this
	
	    var original = expression, replaced
	
	    while (expression){
	        replaced = expression.replace(slickRe, function(){
	            return replacer.apply(self, arguments)
	        })
	        if (replaced === expression) throw new Error(original + ' is an invalid expression')
	        expression = replaced
	    }
	}
	
	Expressions.prototype.toString = function(){
	    if (!this.raw){
	        var expressions = []
	        for (var i = 0, expression; expression = this[i++];) expressions.push(expression)
	        this.raw = expressions.join(", ")
	    }
	
	    return this.raw
	}
	
	var cache = {}
	
	var parse = function(expression){
	    if (expression == null) return null
	    expression = ('' + expression).replace(/^\s+|\s+$/g, '')
	    return cache[expression] || (cache[expression] = new Expressions(expression))
	}
	
	module.exports = parse


/***/ },
/* 2000 */
/***/ function(module, exports, __webpack_require__) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	module.exports = Stream;
	
	var EE = __webpack_require__(129).EventEmitter;
	var inherits = __webpack_require__(38);
	
	inherits(Stream, EE);
	Stream.Readable = __webpack_require__(246);
	Stream.Writable = __webpack_require__(1974);
	Stream.Duplex = __webpack_require__(1969);
	Stream.Transform = __webpack_require__(1973);
	Stream.PassThrough = __webpack_require__(1972);
	
	// Backwards-compat with node 0.4.x
	Stream.Stream = Stream;
	
	
	
	// old-style streams.  Note that the pipe method (the only relevant
	// part of this class) is overridden in the Readable class.
	
	function Stream() {
	  EE.call(this);
	}
	
	Stream.prototype.pipe = function(dest, options) {
	  var source = this;
	
	  function ondata(chunk) {
	    if (dest.writable) {
	      if (false === dest.write(chunk) && source.pause) {
	        source.pause();
	      }
	    }
	  }
	
	  source.on('data', ondata);
	
	  function ondrain() {
	    if (source.readable && source.resume) {
	      source.resume();
	    }
	  }
	
	  dest.on('drain', ondrain);
	
	  // If the 'end' option is not supplied, dest.end() will be called when
	  // source gets the 'end' or 'close' events.  Only dest.end() once.
	  if (!dest._isStdio && (!options || options.end !== false)) {
	    source.on('end', onend);
	    source.on('close', onclose);
	  }
	
	  var didOnEnd = false;
	  function onend() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    dest.end();
	  }
	
	
	  function onclose() {
	    if (didOnEnd) return;
	    didOnEnd = true;
	
	    if (typeof dest.destroy === 'function') dest.destroy();
	  }
	
	  // don't leave dangling pipes when there are errors.
	  function onerror(er) {
	    cleanup();
	    if (EE.listenerCount(this, 'error') === 0) {
	      throw er; // Unhandled stream error in pipe.
	    }
	  }
	
	  source.on('error', onerror);
	  dest.on('error', onerror);
	
	  // remove all the event listeners that were added.
	  function cleanup() {
	    source.removeListener('data', ondata);
	    dest.removeListener('drain', ondrain);
	
	    source.removeListener('end', onend);
	    source.removeListener('close', onclose);
	
	    source.removeListener('error', onerror);
	    dest.removeListener('error', onerror);
	
	    source.removeListener('end', cleanup);
	    source.removeListener('close', cleanup);
	
	    dest.removeListener('close', cleanup);
	  }
	
	  source.on('end', cleanup);
	  source.on('close', cleanup);
	
	  dest.on('close', cleanup);
	
	  dest.emit('pipe', source);
	
	  // Allow for unix-like usage: A.pipe(B).pipe(C)
	  return dest;
	};


/***/ },
/* 2001 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(2002);


/***/ },
/* 2002 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, module) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _ponyfill = __webpack_require__(2003);
	
	var _ponyfill2 = _interopRequireDefault(_ponyfill);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	var root; /* global window */
	
	
	if (typeof self !== 'undefined') {
	  root = self;
	} else if (typeof window !== 'undefined') {
	  root = window;
	} else if (typeof global !== 'undefined') {
	  root = global;
	} else if (true) {
	  root = module;
	} else {
	  root = Function('return this')();
	}
	
	var result = (0, _ponyfill2['default'])(root);
	exports['default'] = result;
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(37)(module)))

/***/ },
/* 2003 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
		value: true
	});
	exports['default'] = symbolObservablePonyfill;
	function symbolObservablePonyfill(root) {
		var result;
		var _Symbol = root.Symbol;
	
		if (typeof _Symbol === 'function') {
			if (_Symbol.observable) {
				result = _Symbol.observable;
			} else {
				result = _Symbol('observable');
				_Symbol.observable = result;
			}
		} else {
			result = '@@observable';
		}
	
		return result;
	};

/***/ },
/* 2004 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "advlist" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/advlist')
	//   ES2015:
	//     import 'tinymce/plugins/advlist'
	__webpack_require__(2005);

/***/ },
/* 2005 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.advlist.Plugin","tinymce.core.PluginManager","tinymce.core.util.Tools","tinymce.plugins.advlist.api.Commands","tinymce.plugins.advlist.ui.Buttons","global!tinymce.util.Tools.resolve","tinymce.plugins.advlist.core.Actions","tinymce.plugins.advlist.api.Settings","tinymce.plugins.advlist.core.ListUtils","tinymce.plugins.advlist.ui.ListStyles"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Tools',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Tools');
	  }
	);
	
	/**
	 * Actions.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.advlist.core.Actions',
	  [
	  ],
	  function () {
	    var applyListFormat = function (editor, listName, styleValue) {
	      var cmd = listName === 'UL' ? 'InsertUnorderedList' : 'InsertOrderedList';
	      editor.execCommand(cmd, false, styleValue === false ? null : { 'list-style-type': styleValue });
	    };
	
	    return {
	      applyListFormat: applyListFormat
	    };
	  }
	);
	/**
	 * Commands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.advlist.api.Commands',
	  [
	    'tinymce.plugins.advlist.core.Actions'
	  ],
	  function (Actions) {
	    var register = function (editor) {
	      editor.addCommand('ApplyUnorderedListStyle', function (ui, value) {
	        Actions.applyListFormat(editor, 'UL', value['list-style-type']);
	      });
	
	      editor.addCommand('ApplyOrderedListStyle', function (ui, value) {
	        Actions.applyListFormat(editor, 'OL', value['list-style-type']);
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.advlist.api.Settings',
	  [
	  ],
	  function () {
	    var getNumberStyles = function (editor) {
	      var styles = editor.getParam('advlist_number_styles', 'default,lower-alpha,lower-greek,lower-roman,upper-alpha,upper-roman');
	      return styles ? styles.split(/[ ,]/) : [];
	    };
	
	    var getBulletStyles = function (editor) {
	      var styles = editor.getParam('advlist_bullet_styles', 'default,circle,disc,square');
	      return styles ? styles.split(/[ ,]/) : [];
	    };
	
	    return {
	      getNumberStyles: getNumberStyles,
	      getBulletStyles: getBulletStyles
	    };
	  }
	);
	/**
	 * ListUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.advlist.core.ListUtils',
	  [
	  ],
	  function () {
	    var isChildOfBody = function (editor, elm) {
	      return editor.$.contains(editor.getBody(), elm);
	    };
	
	    var isTableCellNode = function (node) {
	      return node && /^(TH|TD)$/.test(node.nodeName);
	    };
	
	    var isListNode = function (editor) {
	      return function (node) {
	        return node && (/^(OL|UL|DL)$/).test(node.nodeName) && isChildOfBody(editor, node);
	      };
	    };
	
	    var getSelectedStyleType = function (editor) {
	      var listElm = editor.dom.getParent(editor.selection.getNode(), 'ol,ul');
	      return editor.dom.getStyle(listElm, 'listStyleType') || '';
	    };
	
	    return {
	      isTableCellNode: isTableCellNode,
	      isListNode: isListNode,
	      getSelectedStyleType: getSelectedStyleType
	    };
	  }
	);
	/**
	 * ListStyles.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.advlist.ui.ListStyles',
	  [
	    'tinymce.core.util.Tools'
	  ],
	  function (Tools) {
	    var styleValueToText = function (styleValue) {
	      return styleValue.replace(/\-/g, ' ').replace(/\b\w/g, function (chr) {
	        return chr.toUpperCase();
	      });
	    };
	
	    var toMenuItems = function (styles) {
	      return Tools.map(styles, function (styleValue) {
	        var text = styleValueToText(styleValue);
	        var data = styleValue === 'default' ? '' : styleValue;
	
	        return { text: text, data: data };
	      });
	    };
	
	    return {
	      toMenuItems: toMenuItems
	    };
	  }
	);
	/**
	 * Buttons.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.advlist.ui.Buttons',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.advlist.api.Settings',
	    'tinymce.plugins.advlist.core.Actions',
	    'tinymce.plugins.advlist.core.ListUtils',
	    'tinymce.plugins.advlist.ui.ListStyles'
	  ],
	  function (Tools, Settings, Actions, ListUtils, ListStyles) {
	    var findIndex = function (list, predicate) {
	      for (var index = 0; index < list.length; index++) {
	        var element = list[index];
	
	        if (predicate(element)) {
	          return index;
	        }
	      }
	      return -1;
	    };
	
	    var listState = function (editor, listName) {
	      return function (e) {
	        var ctrl = e.control;
	
	        editor.on('NodeChange', function (e) {
	          var tableCellIndex = findIndex(e.parents, ListUtils.isTableCellNode);
	          var parents = tableCellIndex !== -1 ? e.parents.slice(0, tableCellIndex) : e.parents;
	          var lists = Tools.grep(parents, ListUtils.isListNode(editor));
	          ctrl.active(lists.length > 0 && lists[0].nodeName === listName);
	        });
	      };
	    };
	
	    var updateSelection = function (editor) {
	      return function (e) {
	        var listStyleType = ListUtils.getSelectedStyleType(editor);
	        e.control.items().each(function (ctrl) {
	          ctrl.active(ctrl.settings.data === listStyleType);
	        });
	      };
	    };
	
	    var addSplitButton = function (editor, id, tooltip, cmd, nodeName, styles) {
	      editor.addButton(id, {
	        active: false,
	        type: 'splitbutton',
	        tooltip: tooltip,
	        menu: ListStyles.toMenuItems(styles),
	        onPostRender: listState(editor, nodeName),
	        onshow: updateSelection(editor),
	        onselect: function (e) {
	          Actions.applyListFormat(editor, nodeName, e.control.settings.data);
	        },
	        onclick: function () {
	          editor.execCommand(cmd);
	        }
	      });
	    };
	
	    var addButton = function (editor, id, tooltip, cmd, nodeName, styles) {
	      editor.addButton(id, {
	        active: false,
	        type: 'button',
	        tooltip: tooltip,
	        onPostRender: listState(editor, nodeName),
	        onclick: function () {
	          editor.execCommand(cmd);
	        }
	      });
	    };
	
	    var addControl = function (editor, id, tooltip, cmd, nodeName, styles) {
	      if (styles.length > 0) {
	        addSplitButton(editor, id, tooltip, cmd, nodeName, styles);
	      } else {
	        addButton(editor, id, tooltip, cmd, nodeName, styles);
	      }
	    };
	
	    var register = function (editor) {
	      addControl(editor, 'numlist', 'Numbered list', 'InsertOrderedList', 'OL', Settings.getNumberStyles(editor));
	      addControl(editor, 'bullist', 'Bullet list', 'InsertUnorderedList', 'UL', Settings.getBulletStyles(editor));
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.advlist.Plugin',
	  [
	    'tinymce.core.PluginManager',
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.advlist.api.Commands',
	    'tinymce.plugins.advlist.ui.Buttons'
	  ],
	  function (PluginManager, Tools, Commands, Buttons) {
	    PluginManager.add('advlist', function (editor) {
	      var hasPlugin = function (editor, plugin) {
	        var plugins = editor.settings.plugins ? editor.settings.plugins : '';
	        return Tools.inArray(plugins.split(/[ ,]/), plugin) !== -1;
	      };
	
	      if (hasPlugin(editor, "lists")) {
	        Buttons.register(editor);
	        Commands.register(editor);
	      }
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.advlist.Plugin')();
	})();


/***/ },
/* 2006 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "anchor" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/anchor')
	//   ES2015:
	//     import 'tinymce/plugins/anchor'
	__webpack_require__(2007);

/***/ },
/* 2007 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.anchor.Plugin","tinymce.core.PluginManager","tinymce.plugins.anchor.api.Commands","tinymce.plugins.anchor.core.FilterContent","tinymce.plugins.anchor.ui.Buttons","global!tinymce.util.Tools.resolve","tinymce.plugins.anchor.ui.Dialog","tinymce.plugins.anchor.core.Anchor"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	/**
	 * Anchor.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.anchor.core.Anchor',
	  [
	  ],
	  function () {
	    var isValidId = function (id) {
	      // Follows HTML4 rules: https://www.w3.org/TR/html401/types.html#type-id
	      return /^[A-Za-z][A-Za-z0-9\-:._]*$/.test(id);
	    };
	
	    var getId = function (editor) {
	      var selectedNode = editor.selection.getNode();
	      var isAnchor = selectedNode.tagName === 'A' && editor.dom.getAttrib(selectedNode, 'href') === '';
	      return isAnchor ? (selectedNode.id || selectedNode.name) : '';
	    };
	
	    var insert = function (editor, id) {
	      var selectedNode = editor.selection.getNode();
	      var isAnchor = selectedNode.tagName === 'A' && editor.dom.getAttrib(selectedNode, 'href') === '';
	
	      if (isAnchor) {
	        selectedNode.removeAttribute('name');
	        selectedNode.id = id;
	      } else {
	        editor.focus();
	        editor.selection.collapse(true);
	        editor.execCommand('mceInsertContent', false, editor.dom.createHTML('a', {
	          id: id
	        }));
	      }
	    };
	
	    return {
	      isValidId: isValidId,
	      getId: getId,
	      insert: insert
	    };
	  }
	);
	/**
	 * Dialog.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.anchor.ui.Dialog',
	  [
	    'tinymce.plugins.anchor.core.Anchor'
	  ],
	  function (Anchor) {
	    var insertAnchor = function (editor, newId) {
	      if (!Anchor.isValidId(newId)) {
	        editor.windowManager.alert(
	          'Id should start with a letter, followed only by letters, numbers, dashes, dots, colons or underscores.'
	        );
	        return true;
	      } else {
	        Anchor.insert(editor, newId);
	        return false;
	      }
	    };
	
	    var open = function (editor) {
	      var currentId = Anchor.getId(editor);
	
	      editor.windowManager.open({
	        title: 'Anchor',
	        body: { type: 'textbox', name: 'id', size: 40, label: 'Id', value: currentId },
	        onsubmit: function (e) {
	          var newId = e.data.id;
	
	          if (insertAnchor(editor, newId)) {
	            e.preventDefault();
	          }
	        }
	      });
	    };
	
	    return {
	      open: open
	    };
	  }
	);
	/**
	 * Commands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.anchor.api.Commands',
	  [
	    'tinymce.plugins.anchor.ui.Dialog'
	  ],
	  function (Dialog) {
	    var register = function (editor) {
	      editor.addCommand('mceAnchor', function () {
	        Dialog.open(editor);
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * FilterContent.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.anchor.core.FilterContent',
	  [
	  ],
	  function () {
	    var isAnchorNode = function (node) {
	      return !node.attr('href') && (node.attr('id') || node.attr('name')) && !node.firstChild;
	    };
	
	    var setContentEditable = function (state) {
	      return function (nodes) {
	        for (var i = 0; i < nodes.length; i++) {
	          if (isAnchorNode(nodes[i])) {
	            nodes[i].attr('contenteditable', state);
	          }
	        }
	      };
	    };
	
	    var setup = function (editor) {
	      editor.on('PreInit', function () {
	        editor.parser.addNodeFilter('a', setContentEditable('false'));
	        editor.serializer.addNodeFilter('a', setContentEditable(null));
	      });
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	/**
	 * Buttons.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.anchor.ui.Buttons',
	  [
	  ],
	  function () {
	    var register = function (editor) {
	      editor.addButton('anchor', {
	        icon: 'anchor',
	        tooltip: 'Anchor',
	        cmd: 'mceAnchor',
	        stateSelector: 'a:not([href])'
	      });
	
	      editor.addMenuItem('anchor', {
	        icon: 'anchor',
	        text: 'Anchor',
	        context: 'insert',
	        cmd: 'mceAnchor'
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.anchor.Plugin',
	  [
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.anchor.api.Commands',
	    'tinymce.plugins.anchor.core.FilterContent',
	    'tinymce.plugins.anchor.ui.Buttons'
	  ],
	  function (PluginManager, Commands, FilterContent, Buttons) {
	    PluginManager.add('anchor', function (editor) {
	      FilterContent.setup(editor);
	      Commands.register(editor);
	      Buttons.register(editor);
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.anchor.Plugin')();
	})();


/***/ },
/* 2008 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "autolink" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/autolink')
	//   ES2015:
	//     import 'tinymce/plugins/autolink'
	__webpack_require__(2009);

/***/ },
/* 2009 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.autolink.Plugin","tinymce.core.Env","tinymce.core.PluginManager","tinymce.plugins.autolink.core.Keys","global!tinymce.util.Tools.resolve","tinymce.plugins.autolink.api.Settings"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.Env',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.Env');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.autolink.api.Settings',
	  [
	  ],
	  function () {
	    var getAutoLinkPattern = function (editor) {
	      return editor.getParam('autolink_pattern', /^(https?:\/\/|ssh:\/\/|ftp:\/\/|file:\/|www\.|(?:mailto:)?[A-Z0-9._%+\-]+@)(.+)$/i);
	    };
	
	    var getDefaultLinkTarget = function (editor) {
	      return editor.getParam('default_link_target', '');
	    };
	
	    return {
	      getAutoLinkPattern: getAutoLinkPattern,
	      getDefaultLinkTarget: getDefaultLinkTarget
	    };
	  }
	);
	/**
	 * Keys.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.autolink.core.Keys',
	  [
	    'tinymce.core.Env',
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.autolink.api.Settings'
	  ],
	  function (Env, PluginManager, Settings) {
	    var rangeEqualsDelimiterOrSpace = function (rangeString, delimiter) {
	      return rangeString === delimiter || rangeString === ' ' || rangeString.charCodeAt(0) === 160;
	    };
	
	    var handleEclipse = function (editor) {
	      parseCurrentLine(editor, -1, '(', true);
	    };
	
	    var handleSpacebar = function (editor) {
	      parseCurrentLine(editor, 0, '', true);
	    };
	
	    var handleEnter = function (editor) {
	      parseCurrentLine(editor, -1, '', false);
	    };
	
	    var scopeIndex = function (container, index) {
	      if (index < 0) {
	        index = 0;
	      }
	
	      if (container.nodeType === 3) {
	        var len = container.data.length;
	
	        if (index > len) {
	          index = len;
	        }
	      }
	
	      return index;
	    };
	
	    var setStart = function (rng, container, offset) {
	      if (container.nodeType !== 1 || container.hasChildNodes()) {
	        rng.setStart(container, scopeIndex(container, offset));
	      } else {
	        rng.setStartBefore(container);
	      }
	    };
	
	    var setEnd = function (rng, container, offset) {
	      if (container.nodeType !== 1 || container.hasChildNodes()) {
	        rng.setEnd(container, scopeIndex(container, offset));
	      } else {
	        rng.setEndAfter(container);
	      }
	    };
	
	    var parseCurrentLine = function (editor, endOffset, delimiter) {
	      var rng, end, start, endContainer, bookmark, text, matches, prev, len, rngText;
	      var autoLinkPattern = Settings.getAutoLinkPattern(editor);
	      var defaultLinkTarget = Settings.getDefaultLinkTarget(editor);
	
	      // Never create a link when we are inside a link
	      if (editor.selection.getNode().tagName === 'A') {
	        return;
	      }
	
	      // We need at least five characters to form a URL,
	      // hence, at minimum, five characters from the beginning of the line.
	      rng = editor.selection.getRng(true).cloneRange();
	      if (rng.startOffset < 5) {
	        // During testing, the caret is placed between two text nodes.
	        // The previous text node contains the URL.
	        prev = rng.endContainer.previousSibling;
	        if (!prev) {
	          if (!rng.endContainer.firstChild || !rng.endContainer.firstChild.nextSibling) {
	            return;
	          }
	
	          prev = rng.endContainer.firstChild.nextSibling;
	        }
	
	        len = prev.length;
	        setStart(rng, prev, len);
	        setEnd(rng, prev, len);
	
	        if (rng.endOffset < 5) {
	          return;
	        }
	
	        end = rng.endOffset;
	        endContainer = prev;
	      } else {
	        endContainer = rng.endContainer;
	
	        // Get a text node
	        if (endContainer.nodeType !== 3 && endContainer.firstChild) {
	          while (endContainer.nodeType !== 3 && endContainer.firstChild) {
	            endContainer = endContainer.firstChild;
	          }
	
	          // Move range to text node
	          if (endContainer.nodeType === 3) {
	            setStart(rng, endContainer, 0);
	            setEnd(rng, endContainer, endContainer.nodeValue.length);
	          }
	        }
	
	        if (rng.endOffset === 1) {
	          end = 2;
	        } else {
	          end = rng.endOffset - 1 - endOffset;
	        }
	      }
	
	      start = end;
	
	      do {
	        // Move the selection one character backwards.
	        setStart(rng, endContainer, end >= 2 ? end - 2 : 0);
	        setEnd(rng, endContainer, end >= 1 ? end - 1 : 0);
	        end -= 1;
	        rngText = rng.toString();
	
	        // Loop until one of the following is found: a blank space, &nbsp;, delimiter, (end-2) >= 0
	      } while (rngText !== ' ' && rngText !== '' && rngText.charCodeAt(0) !== 160 && (end - 2) >= 0 && rngText !== delimiter);
	
	      if (rangeEqualsDelimiterOrSpace(rng.toString(), delimiter)) {
	        setStart(rng, endContainer, end);
	        setEnd(rng, endContainer, start);
	        end += 1;
	      } else if (rng.startOffset === 0) {
	        setStart(rng, endContainer, 0);
	        setEnd(rng, endContainer, start);
	      } else {
	        setStart(rng, endContainer, end);
	        setEnd(rng, endContainer, start);
	      }
	
	      // Exclude last . from word like "www.site.com."
	      text = rng.toString();
	      if (text.charAt(text.length - 1) === '.') {
	        setEnd(rng, endContainer, start - 1);
	      }
	
	      text = rng.toString().trim();
	      matches = text.match(autoLinkPattern);
	
	      if (matches) {
	        if (matches[1] === 'www.') {
	          matches[1] = 'http://www.';
	        } else if (/@$/.test(matches[1]) && !/^mailto:/.test(matches[1])) {
	          matches[1] = 'mailto:' + matches[1];
	        }
	
	        bookmark = editor.selection.getBookmark();
	
	        editor.selection.setRng(rng);
	        editor.execCommand('createlink', false, matches[1] + matches[2]);
	
	        if (defaultLinkTarget) {
	          editor.dom.setAttrib(editor.selection.getNode(), 'target', defaultLinkTarget);
	        }
	
	        editor.selection.moveToBookmark(bookmark);
	        editor.nodeChanged();
	      }
	    };
	
	    var setup = function (editor) {
	      var autoUrlDetectState;
	
	      editor.on("keydown", function (e) {
	        if (e.keyCode === 13) {
	          return handleEnter(editor);
	        }
	      });
	
	      // Internet Explorer has built-in automatic linking for most cases
	      if (Env.ie) {
	        editor.on("focus", function () {
	          if (!autoUrlDetectState) {
	            autoUrlDetectState = true;
	
	            try {
	              editor.execCommand('AutoUrlDetect', false, true);
	            } catch (ex) {
	              // Ignore
	            }
	          }
	        });
	
	        return;
	      }
	
	      editor.on("keypress", function (e) {
	        if (e.keyCode === 41) {
	          return handleEclipse(editor);
	        }
	      });
	
	      editor.on("keyup", function (e) {
	        if (e.keyCode === 32) {
	          return handleSpacebar(editor);
	        }
	      });
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.autolink.Plugin',
	  [
	    'tinymce.core.Env',
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.autolink.core.Keys'
	  ],
	  function (Env, PluginManager, Keys) {
	    PluginManager.add('autolink', function (editor) {
	      Keys.setup(editor);
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.autolink.Plugin')();
	})();


/***/ },
/* 2010 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "charmap" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/charmap')
	//   ES2015:
	//     import 'tinymce/plugins/charmap'
	__webpack_require__(2011);

/***/ },
/* 2011 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.charmap.Plugin","tinymce.core.PluginManager","tinymce.plugins.charmap.api.Api","tinymce.plugins.charmap.api.Commands","tinymce.plugins.charmap.ui.Buttons","global!tinymce.util.Tools.resolve","tinymce.plugins.charmap.core.Actions","tinymce.plugins.charmap.core.CharMap","tinymce.plugins.charmap.ui.Dialog","tinymce.plugins.charmap.api.Events","tinymce.core.util.Tools","tinymce.plugins.charmap.api.Settings","tinymce.plugins.charmap.ui.GridHtml"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	/**
	 * Events.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.charmap.api.Events',
	  [
	  ],
	  function () {
	    var fireInsertCustomChar = function (editor, chr) {
	      return editor.fire('insertCustomChar', { chr: chr });
	    };
	
	    return {
	      fireInsertCustomChar: fireInsertCustomChar
	    };
	  }
	);
	
	/**
	 * Actions.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.charmap.core.Actions',
	  [
	    'tinymce.plugins.charmap.api.Events'
	  ],
	  function (Events) {
	    var insertChar = function (editor, chr) {
	      var evtChr = Events.fireInsertCustomChar(editor, chr).chr;
	      editor.execCommand('mceInsertContent', false, evtChr);
	    };
	
	    return {
	      insertChar: insertChar
	    };
	  }
	);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Tools',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Tools');
	  }
	);
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.charmap.api.Settings',
	  [
	  ],
	  function () {
	    var getCharMap = function (editor) {
	      return editor.settings.charmap;
	    };
	
	    var getCharMapAppend = function (editor) {
	      return editor.settings.charmap_append;
	    };
	
	    return {
	      getCharMap: getCharMap,
	      getCharMapAppend: getCharMapAppend
	    };
	  }
	);
	/**
	 * CharMap.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.charmap.core.CharMap',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.charmap.api.Settings'
	  ],
	  function (Tools, Settings) {
	    var isArray = Tools.isArray;
	
	    var getDefaultCharMap = function () {
	      return [
	        ['160', 'no-break space'],
	        ['173', 'soft hyphen'],
	        ['34', 'quotation mark'],
	        // finance
	        ['162', 'cent sign'],
	        ['8364', 'euro sign'],
	        ['163', 'pound sign'],
	        ['165', 'yen sign'],
	        // signs
	        ['169', 'copyright sign'],
	        ['174', 'registered sign'],
	        ['8482', 'trade mark sign'],
	        ['8240', 'per mille sign'],
	        ['181', 'micro sign'],
	        ['183', 'middle dot'],
	        ['8226', 'bullet'],
	        ['8230', 'three dot leader'],
	        ['8242', 'minutes / feet'],
	        ['8243', 'seconds / inches'],
	        ['167', 'section sign'],
	        ['182', 'paragraph sign'],
	        ['223', 'sharp s / ess-zed'],
	        // quotations
	        ['8249', 'single left-pointing angle quotation mark'],
	        ['8250', 'single right-pointing angle quotation mark'],
	        ['171', 'left pointing guillemet'],
	        ['187', 'right pointing guillemet'],
	        ['8216', 'left single quotation mark'],
	        ['8217', 'right single quotation mark'],
	        ['8220', 'left double quotation mark'],
	        ['8221', 'right double quotation mark'],
	        ['8218', 'single low-9 quotation mark'],
	        ['8222', 'double low-9 quotation mark'],
	        ['60', 'less-than sign'],
	        ['62', 'greater-than sign'],
	        ['8804', 'less-than or equal to'],
	        ['8805', 'greater-than or equal to'],
	        ['8211', 'en dash'],
	        ['8212', 'em dash'],
	        ['175', 'macron'],
	        ['8254', 'overline'],
	        ['164', 'currency sign'],
	        ['166', 'broken bar'],
	        ['168', 'diaeresis'],
	        ['161', 'inverted exclamation mark'],
	        ['191', 'turned question mark'],
	        ['710', 'circumflex accent'],
	        ['732', 'small tilde'],
	        ['176', 'degree sign'],
	        ['8722', 'minus sign'],
	        ['177', 'plus-minus sign'],
	        ['247', 'division sign'],
	        ['8260', 'fraction slash'],
	        ['215', 'multiplication sign'],
	        ['185', 'superscript one'],
	        ['178', 'superscript two'],
	        ['179', 'superscript three'],
	        ['188', 'fraction one quarter'],
	        ['189', 'fraction one half'],
	        ['190', 'fraction three quarters'],
	        // math / logical
	        ['402', 'function / florin'],
	        ['8747', 'integral'],
	        ['8721', 'n-ary sumation'],
	        ['8734', 'infinity'],
	        ['8730', 'square root'],
	        ['8764', 'similar to'],
	        ['8773', 'approximately equal to'],
	        ['8776', 'almost equal to'],
	        ['8800', 'not equal to'],
	        ['8801', 'identical to'],
	        ['8712', 'element of'],
	        ['8713', 'not an element of'],
	        ['8715', 'contains as member'],
	        ['8719', 'n-ary product'],
	        ['8743', 'logical and'],
	        ['8744', 'logical or'],
	        ['172', 'not sign'],
	        ['8745', 'intersection'],
	        ['8746', 'union'],
	        ['8706', 'partial differential'],
	        ['8704', 'for all'],
	        ['8707', 'there exists'],
	        ['8709', 'diameter'],
	        ['8711', 'backward difference'],
	        ['8727', 'asterisk operator'],
	        ['8733', 'proportional to'],
	        ['8736', 'angle'],
	        // undefined
	        ['180', 'acute accent'],
	        ['184', 'cedilla'],
	        ['170', 'feminine ordinal indicator'],
	        ['186', 'masculine ordinal indicator'],
	        ['8224', 'dagger'],
	        ['8225', 'double dagger'],
	        // alphabetical special chars
	        ['192', 'A - grave'],
	        ['193', 'A - acute'],
	        ['194', 'A - circumflex'],
	        ['195', 'A - tilde'],
	        ['196', 'A - diaeresis'],
	        ['197', 'A - ring above'],
	        ['256', 'A - macron'],
	        ['198', 'ligature AE'],
	        ['199', 'C - cedilla'],
	        ['200', 'E - grave'],
	        ['201', 'E - acute'],
	        ['202', 'E - circumflex'],
	        ['203', 'E - diaeresis'],
	        ['274', 'E - macron'],
	        ['204', 'I - grave'],
	        ['205', 'I - acute'],
	        ['206', 'I - circumflex'],
	        ['207', 'I - diaeresis'],
	        ['298', 'I - macron'],
	        ['208', 'ETH'],
	        ['209', 'N - tilde'],
	        ['210', 'O - grave'],
	        ['211', 'O - acute'],
	        ['212', 'O - circumflex'],
	        ['213', 'O - tilde'],
	        ['214', 'O - diaeresis'],
	        ['216', 'O - slash'],
	        ['332', 'O - macron'],
	        ['338', 'ligature OE'],
	        ['352', 'S - caron'],
	        ['217', 'U - grave'],
	        ['218', 'U - acute'],
	        ['219', 'U - circumflex'],
	        ['220', 'U - diaeresis'],
	        ['362', 'U - macron'],
	        ['221', 'Y - acute'],
	        ['376', 'Y - diaeresis'],
	        ['562', 'Y - macron'],
	        ['222', 'THORN'],
	        ['224', 'a - grave'],
	        ['225', 'a - acute'],
	        ['226', 'a - circumflex'],
	        ['227', 'a - tilde'],
	        ['228', 'a - diaeresis'],
	        ['229', 'a - ring above'],
	        ['257', 'a - macron'],
	        ['230', 'ligature ae'],
	        ['231', 'c - cedilla'],
	        ['232', 'e - grave'],
	        ['233', 'e - acute'],
	        ['234', 'e - circumflex'],
	        ['235', 'e - diaeresis'],
	        ['275', 'e - macron'],
	        ['236', 'i - grave'],
	        ['237', 'i - acute'],
	        ['238', 'i - circumflex'],
	        ['239', 'i - diaeresis'],
	        ['299', 'i - macron'],
	        ['240', 'eth'],
	        ['241', 'n - tilde'],
	        ['242', 'o - grave'],
	        ['243', 'o - acute'],
	        ['244', 'o - circumflex'],
	        ['245', 'o - tilde'],
	        ['246', 'o - diaeresis'],
	        ['248', 'o slash'],
	        ['333', 'o macron'],
	        ['339', 'ligature oe'],
	        ['353', 's - caron'],
	        ['249', 'u - grave'],
	        ['250', 'u - acute'],
	        ['251', 'u - circumflex'],
	        ['252', 'u - diaeresis'],
	        ['363', 'u - macron'],
	        ['253', 'y - acute'],
	        ['254', 'thorn'],
	        ['255', 'y - diaeresis'],
	        ['563', 'y - macron'],
	        ['913', 'Alpha'],
	        ['914', 'Beta'],
	        ['915', 'Gamma'],
	        ['916', 'Delta'],
	        ['917', 'Epsilon'],
	        ['918', 'Zeta'],
	        ['919', 'Eta'],
	        ['920', 'Theta'],
	        ['921', 'Iota'],
	        ['922', 'Kappa'],
	        ['923', 'Lambda'],
	        ['924', 'Mu'],
	        ['925', 'Nu'],
	        ['926', 'Xi'],
	        ['927', 'Omicron'],
	        ['928', 'Pi'],
	        ['929', 'Rho'],
	        ['931', 'Sigma'],
	        ['932', 'Tau'],
	        ['933', 'Upsilon'],
	        ['934', 'Phi'],
	        ['935', 'Chi'],
	        ['936', 'Psi'],
	        ['937', 'Omega'],
	        ['945', 'alpha'],
	        ['946', 'beta'],
	        ['947', 'gamma'],
	        ['948', 'delta'],
	        ['949', 'epsilon'],
	        ['950', 'zeta'],
	        ['951', 'eta'],
	        ['952', 'theta'],
	        ['953', 'iota'],
	        ['954', 'kappa'],
	        ['955', 'lambda'],
	        ['956', 'mu'],
	        ['957', 'nu'],
	        ['958', 'xi'],
	        ['959', 'omicron'],
	        ['960', 'pi'],
	        ['961', 'rho'],
	        ['962', 'final sigma'],
	        ['963', 'sigma'],
	        ['964', 'tau'],
	        ['965', 'upsilon'],
	        ['966', 'phi'],
	        ['967', 'chi'],
	        ['968', 'psi'],
	        ['969', 'omega'],
	        // symbols
	        ['8501', 'alef symbol'],
	        ['982', 'pi symbol'],
	        ['8476', 'real part symbol'],
	        ['978', 'upsilon - hook symbol'],
	        ['8472', 'Weierstrass p'],
	        ['8465', 'imaginary part'],
	        // arrows
	        ['8592', 'leftwards arrow'],
	        ['8593', 'upwards arrow'],
	        ['8594', 'rightwards arrow'],
	        ['8595', 'downwards arrow'],
	        ['8596', 'left right arrow'],
	        ['8629', 'carriage return'],
	        ['8656', 'leftwards double arrow'],
	        ['8657', 'upwards double arrow'],
	        ['8658', 'rightwards double arrow'],
	        ['8659', 'downwards double arrow'],
	        ['8660', 'left right double arrow'],
	        ['8756', 'therefore'],
	        ['8834', 'subset of'],
	        ['8835', 'superset of'],
	        ['8836', 'not a subset of'],
	        ['8838', 'subset of or equal to'],
	        ['8839', 'superset of or equal to'],
	        ['8853', 'circled plus'],
	        ['8855', 'circled times'],
	        ['8869', 'perpendicular'],
	        ['8901', 'dot operator'],
	        ['8968', 'left ceiling'],
	        ['8969', 'right ceiling'],
	        ['8970', 'left floor'],
	        ['8971', 'right floor'],
	        ['9001', 'left-pointing angle bracket'],
	        ['9002', 'right-pointing angle bracket'],
	        ['9674', 'lozenge'],
	        ['9824', 'black spade suit'],
	        ['9827', 'black club suit'],
	        ['9829', 'black heart suit'],
	        ['9830', 'black diamond suit'],
	        ['8194', 'en space'],
	        ['8195', 'em space'],
	        ['8201', 'thin space'],
	        ['8204', 'zero width non-joiner'],
	        ['8205', 'zero width joiner'],
	        ['8206', 'left-to-right mark'],
	        ['8207', 'right-to-left mark']
	      ];
	    };
	
	    var charmapFilter = function (charmap) {
	      return Tools.grep(charmap, function (item) {
	        return isArray(item) && item.length === 2;
	      });
	    };
	
	    var getCharsFromSetting = function (settingValue) {
	      if (isArray(settingValue)) {
	        return [].concat(charmapFilter(settingValue));
	      }
	
	      if (typeof settingValue === "function") {
	        return settingValue();
	      }
	
	      return [];
	    };
	
	    var extendCharMap = function (editor, charmap) {
	      var userCharMap = Settings.getCharMap(editor);
	      if (userCharMap) {
	        charmap = getCharsFromSetting(userCharMap);
	      }
	
	      var userCharMapAppend = Settings.getCharMapAppend(editor);
	      if (userCharMapAppend) {
	        return [].concat(charmap).concat(getCharsFromSetting(userCharMapAppend));
	      }
	
	      return charmap;
	    };
	
	    var getCharMap = function (editor) {
	      return extendCharMap(editor, getDefaultCharMap());
	    };
	
	    return {
	      getCharMap: getCharMap
	    };
	  }
	);
	/**
	 * Api.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.charmap.api.Api',
	  [
	    'tinymce.plugins.charmap.core.Actions',
	    'tinymce.plugins.charmap.core.CharMap'
	  ],
	  function (Actions, CharMap) {
	    var get = function (editor) {
	      var getCharMap = function () {
	        return CharMap.getCharMap(editor);
	      };
	
	      var insertChar = function (chr) {
	        Actions.insertChar(editor, chr);
	      };
	
	      return {
	        getCharMap: getCharMap,
	        insertChar: insertChar
	      };
	    };
	
	    return {
	      get: get
	    };
	  }
	);
	
	
	/**
	 * GridHtml.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.charmap.ui.GridHtml',
	  [
	  ],
	  function () {
	    var getHtml = function (charmap) {
	      var gridHtml, x, y;
	      var width = Math.min(charmap.length, 25);
	      var height = Math.ceil(charmap.length / width);
	
	      gridHtml = '<table role="presentation" cellspacing="0" class="mce-charmap"><tbody>';
	
	      for (y = 0; y < height; y++) {
	        gridHtml += '<tr>';
	
	        for (x = 0; x < width; x++) {
	          var index = y * width + x;
	          if (index < charmap.length) {
	            var chr = charmap[index];
	            var charCode = parseInt(chr[0], 10);
	            var chrText = chr ? String.fromCharCode(charCode) : '&nbsp;';
	
	            gridHtml += (
	              '<td title="' + chr[1] + '">' +
	              '<div tabindex="-1" title="' + chr[1] + '" role="button" data-chr="' + charCode + '">' +
	              chrText +
	              '</div>' +
	              '</td>'
	            );
	          } else {
	            gridHtml += '<td />';
	          }
	        }
	
	        gridHtml += '</tr>';
	      }
	
	      gridHtml += '</tbody></table>';
	
	      return gridHtml;
	    };
	
	    return {
	      getHtml: getHtml
	    };
	  }
	);
	/**
	 * Dialog.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.charmap.ui.Dialog',
	  [
	    'tinymce.plugins.charmap.core.Actions',
	    'tinymce.plugins.charmap.core.CharMap',
	    'tinymce.plugins.charmap.ui.GridHtml'
	  ],
	  function (Actions, CharMap, GridHtml) {
	    var getParentTd = function (elm) {
	      while (elm) {
	        if (elm.nodeName === 'TD') {
	          return elm;
	        }
	
	        elm = elm.parentNode;
	      }
	    };
	
	    var open = function (editor) {
	      var win;
	
	      var charMapPanel = {
	        type: 'container',
	        html: GridHtml.getHtml(CharMap.getCharMap(editor)),
	        onclick: function (e) {
	          var target = e.target;
	
	          if (/^(TD|DIV)$/.test(target.nodeName)) {
	            var charDiv = getParentTd(target).firstChild;
	            if (charDiv && charDiv.hasAttribute('data-chr')) {
	              var charCodeString = charDiv.getAttribute('data-chr');
	              var charCode = parseInt(charCodeString, 10);
	
	              if (!isNaN(charCode)) {
	                Actions.insertChar(editor, String.fromCharCode(charCode));
	              }
	
	              if (!e.ctrlKey) {
	                win.close();
	              }
	            }
	          }
	        },
	        onmouseover: function (e) {
	          var td = getParentTd(e.target);
	
	          if (td && td.firstChild) {
	            win.find('#preview').text(td.firstChild.firstChild.data);
	            win.find('#previewTitle').text(td.title);
	          } else {
	            win.find('#preview').text(' ');
	            win.find('#previewTitle').text(' ');
	          }
	        }
	      };
	
	      win = editor.windowManager.open({
	        title: "Special character",
	        spacing: 10,
	        padding: 10,
	        items: [
	          charMapPanel,
	          {
	            type: 'container',
	            layout: 'flex',
	            direction: 'column',
	            align: 'center',
	            spacing: 5,
	            minWidth: 160,
	            minHeight: 160,
	            items: [
	              {
	                type: 'label',
	                name: 'preview',
	                text: ' ',
	                style: 'font-size: 40px; text-align: center',
	                border: 1,
	                minWidth: 140,
	                minHeight: 80
	              },
	              {
	                type: 'spacer',
	                minHeight: 20
	              },
	              {
	                type: 'label',
	                name: 'previewTitle',
	                text: ' ',
	                style: 'white-space: pre-wrap;',
	                border: 1,
	                minWidth: 140
	              }
	            ]
	          }
	        ],
	        buttons: [
	          {
	            text: "Close", onclick: function () {
	              win.close();
	            }
	          }
	        ]
	      });
	    };
	
	    return {
	      open: open
	    };
	  }
	);
	/**
	 * Commands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.charmap.api.Commands',
	  [
	    'tinymce.plugins.charmap.ui.Dialog'
	  ],
	  function (Dialog) {
	    var register = function (editor) {
	      editor.addCommand('mceShowCharmap', function () {
	        Dialog.open(editor);
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Buttons.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.charmap.ui.Buttons',
	  [
	  ],
	  function () {
	    var register = function (editor) {
	      editor.addButton('charmap', {
	        icon: 'charmap',
	        tooltip: 'Special character',
	        cmd: 'mceShowCharmap'
	      });
	
	      editor.addMenuItem('charmap', {
	        icon: 'charmap',
	        text: 'Special character',
	        cmd: 'mceShowCharmap',
	        context: 'insert'
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.charmap.Plugin',
	  [
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.charmap.api.Api',
	    'tinymce.plugins.charmap.api.Commands',
	    'tinymce.plugins.charmap.ui.Buttons'
	  ],
	  function (PluginManager, Api, Commands, Buttons) {
	    PluginManager.add('charmap', function (editor) {
	      Commands.register(editor);
	      Buttons.register(editor);
	
	      return Api.get(editor);
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.charmap.Plugin')();
	})();


/***/ },
/* 2012 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "code" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/code')
	//   ES2015:
	//     import 'tinymce/plugins/code'
	__webpack_require__(2013);

/***/ },
/* 2013 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.code.Plugin","tinymce.core.PluginManager","tinymce.plugins.code.api.Commands","tinymce.plugins.code.ui.Buttons","global!tinymce.util.Tools.resolve","tinymce.plugins.code.ui.Dialog","tinymce.plugins.code.api.Settings","tinymce.plugins.code.core.Content","tinymce.core.dom.DOMUtils"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DOMUtils',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.DOMUtils');
	  }
	);
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.code.api.Settings',
	  [
	    'tinymce.core.dom.DOMUtils'
	  ],
	  function (DOMUtils) {
	    var getMinWidth = function (editor) {
	      return editor.getParam('code_dialog_width', 600);
	    };
	
	    var getMinHeight = function (editor) {
	      return editor.getParam('code_dialog_height', Math.min(DOMUtils.DOM.getViewPort().h - 200, 500));
	    };
	
	    return {
	      getMinWidth: getMinWidth,
	      getMinHeight: getMinHeight
	    };
	  }
	);
	/**
	 * Content.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.code.core.Content',
	  [
	  ],
	  function () {
	    var setContent = function (editor, html) {
	      // We get a lovely "Wrong document" error in IE 11 if we
	      // don't move the focus to the editor before creating an undo
	      // transation since it tries to make a bookmark for the current selection
	      editor.focus();
	
	      editor.undoManager.transact(function () {
	        editor.setContent(html);
	      });
	
	      editor.selection.setCursorLocation();
	      editor.nodeChanged();
	    };
	
	    var getContent = function (editor) {
	      return editor.getContent({ source_view: true });
	    };
	
	    return {
	      setContent: setContent,
	      getContent: getContent
	    };
	  }
	);
	/**
	 * Dialog.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.code.ui.Dialog',
	  [
	    'tinymce.plugins.code.api.Settings',
	    'tinymce.plugins.code.core.Content'
	  ],
	  function (Settings, Content) {
	    var open = function (editor) {
	      var minWidth = Settings.getMinWidth(editor);
	      var minHeight = Settings.getMinHeight(editor);
	
	      var win = editor.windowManager.open({
	        title: 'Source code',
	        body: {
	          type: 'textbox',
	          name: 'code',
	          multiline: true,
	          minWidth: minWidth,
	          minHeight: minHeight,
	          spellcheck: false,
	          style: 'direction: ltr; text-align: left'
	        },
	        onSubmit: function (e) {
	          Content.setContent(editor, e.data.code);
	        }
	      });
	
	      // Gecko has a major performance issue with textarea
	      // contents so we need to set it when all reflows are done
	      win.find('#code').value(Content.getContent(editor));
	    };
	
	    return {
	      open: open
	    };
	  }
	);
	/**
	 * Commands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.code.api.Commands',
	  [
	    'tinymce.plugins.code.ui.Dialog'
	  ],
	  function (Dialog) {
	    var register = function (editor) {
	      editor.addCommand('mceCodeEditor', function () {
	        Dialog.open(editor);
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Buttons.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.code.ui.Buttons',
	  [
	    'tinymce.plugins.code.ui.Dialog'
	  ],
	  function (Dialog) {
	    var register = function (editor) {
	      editor.addButton('code', {
	        icon: 'code',
	        tooltip: 'Source code',
	        onclick: function () {
	          Dialog.open(editor);
	        }
	      });
	
	      editor.addMenuItem('code', {
	        icon: 'code',
	        text: 'Source code',
	        onclick: function () {
	          Dialog.open(editor);
	        }
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.code.Plugin',
	  [
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.code.api.Commands',
	    'tinymce.plugins.code.ui.Buttons'
	  ],
	  function (PluginManager, Commands, Buttons) {
	    PluginManager.add('code', function (editor) {
	      Commands.register(editor);
	      Buttons.register(editor);
	
	      return {};
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.code.Plugin')();
	})();


/***/ },
/* 2014 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "colorpicker" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/colorpicker')
	//   ES2015:
	//     import 'tinymce/plugins/colorpicker'
	__webpack_require__(2015);

/***/ },
/* 2015 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.colorpicker.Plugin","tinymce.core.PluginManager","tinymce.plugins.colorpicker.ui.Dialog","global!tinymce.util.Tools.resolve","tinymce.core.util.Color"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Color',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Color');
	  }
	);
	
	/**
	 * Dialog.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.colorpicker.ui.Dialog',
	  [
	    'tinymce.core.util.Color'
	  ],
	  function (Color) {
	    var showPreview = function (win, hexColor) {
	      win.find('#preview')[0].getEl().style.background = hexColor;
	    };
	
	    var setColor = function (win, value) {
	      var color = new Color(value), rgb = color.toRgb();
	
	      win.fromJSON({
	        r: rgb.r,
	        g: rgb.g,
	        b: rgb.b,
	        hex: color.toHex().substr(1)
	      });
	
	      showPreview(win, color.toHex());
	    };
	
	    var open = function (editor, callback, value) {
	      var win = editor.windowManager.open({
	        title: 'Color',
	        items: {
	          type: 'container',
	          layout: 'flex',
	          direction: 'row',
	          align: 'stretch',
	          padding: 5,
	          spacing: 10,
	          items: [
	            {
	              type: 'colorpicker',
	              value: value,
	              onchange: function () {
	                var rgb = this.rgb();
	
	                if (win) {
	                  win.find('#r').value(rgb.r);
	                  win.find('#g').value(rgb.g);
	                  win.find('#b').value(rgb.b);
	                  win.find('#hex').value(this.value().substr(1));
	                  showPreview(win, this.value());
	                }
	              }
	            },
	            {
	              type: 'form',
	              padding: 0,
	              labelGap: 5,
	              defaults: {
	                type: 'textbox',
	                size: 7,
	                value: '0',
	                flex: 1,
	                spellcheck: false,
	                onchange: function () {
	                  var colorPickerCtrl = win.find('colorpicker')[0];
	                  var name, value;
	
	                  name = this.name();
	                  value = this.value();
	
	                  if (name === "hex") {
	                    value = '#' + value;
	                    setColor(win, value);
	                    colorPickerCtrl.value(value);
	                    return;
	                  }
	
	                  value = {
	                    r: win.find('#r').value(),
	                    g: win.find('#g').value(),
	                    b: win.find('#b').value()
	                  };
	
	                  colorPickerCtrl.value(value);
	                  setColor(win, value);
	                }
	              },
	              items: [
	                { name: 'r', label: 'R', autofocus: 1 },
	                { name: 'g', label: 'G' },
	                { name: 'b', label: 'B' },
	                { name: 'hex', label: '#', value: '000000' },
	                { name: 'preview', type: 'container', border: 1 }
	              ]
	            }
	          ]
	        },
	        onSubmit: function () {
	          callback('#' + win.toJSON().hex);
	        }
	      });
	
	      setColor(win, value);
	    };
	
	    return {
	      open: open
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.colorpicker.Plugin',
	  [
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.colorpicker.ui.Dialog'
	  ],
	  function (PluginManager, Dialog) {
	    PluginManager.add('colorpicker', function (editor) {
	      if (!editor.settings.color_picker_callback) {
	        editor.settings.color_picker_callback = function (callback, value) {
	          Dialog.open(editor, callback, value);
	        };
	      }
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.colorpicker.Plugin')();
	})();


/***/ },
/* 2016 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "hr" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/hr')
	//   ES2015:
	//     import 'tinymce/plugins/hr'
	__webpack_require__(2017);

/***/ },
/* 2017 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.hr.Plugin","tinymce.core.PluginManager","tinymce.plugins.hr.api.Commands","tinymce.plugins.hr.ui.Buttons","global!tinymce.util.Tools.resolve"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	/**
	 * Commands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.hr.api.Commands',
	  [
	  ],
	  function () {
	    var register = function (editor) {
	      editor.addCommand('InsertHorizontalRule', function () {
	        editor.execCommand('mceInsertContent', false, '<hr />');
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Buttons.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.hr.ui.Buttons',
	  [
	  ],
	  function () {
	    var register = function (editor) {
	      editor.addButton('hr', {
	        icon: 'hr',
	        tooltip: 'Horizontal line',
	        cmd: 'InsertHorizontalRule'
	      });
	
	      editor.addMenuItem('hr', {
	        icon: 'hr',
	        text: 'Horizontal line',
	        cmd: 'InsertHorizontalRule',
	        context: 'insert'
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.hr.Plugin',
	  [
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.hr.api.Commands',
	    'tinymce.plugins.hr.ui.Buttons'
	  ],
	  function (PluginManager, Commands, Buttons) {
	    PluginManager.add('hr', function (editor) {
	      Commands.register(editor);
	      Buttons.register(editor);
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.hr.Plugin')();
	})();


/***/ },
/* 2018 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "link" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/link')
	//   ES2015:
	//     import 'tinymce/plugins/link'
	__webpack_require__(2019);

/***/ },
/* 2019 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.link.Plugin","tinymce.core.PluginManager","tinymce.plugins.link.api.Commands","tinymce.plugins.link.core.Actions","tinymce.plugins.link.core.Keyboard","tinymce.plugins.link.ui.Controls","global!tinymce.util.Tools.resolve","tinymce.core.util.VK","tinymce.plugins.link.api.Settings","tinymce.plugins.link.core.OpenUrl","tinymce.plugins.link.core.Utils","tinymce.plugins.link.ui.Dialog","global!document","global!window","tinymce.core.dom.DOMUtils","tinymce.core.Env","global!RegExp","tinymce.core.util.Tools","tinymce.core.util.Delay","tinymce.core.util.XHR"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.VK',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.VK');
	  }
	);
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.link.api.Settings',
	  [
	  ],
	  function () {
	    var assumeExternalTargets = function (editorSettings) {
	      return typeof editorSettings.link_assume_external_targets === 'boolean' ? editorSettings.link_assume_external_targets : false;
	    };
	
	    var hasContextToolbar = function (editorSettings) {
	      return typeof editorSettings.link_context_toolbar === 'boolean' ? editorSettings.link_context_toolbar : false;
	    };
	
	    var getLinkList = function (editorSettings) {
	      return editorSettings.link_list;
	    };
	
	    var hasDefaultLinkTarget = function (editorSettings) {
	      return typeof editorSettings.default_link_target === 'string';
	    };
	
	    var getDefaultLinkTarget = function (editorSettings) {
	      return editorSettings.default_link_target;
	    };
	
	    var getTargetList = function (editorSettings) {
	      return editorSettings.target_list;
	    };
	
	    var setTargetList = function (editor, list) {
	      editor.settings.target_list = list;
	    };
	
	    var shouldShowTargetList = function (editorSettings) {
	      return getTargetList(editorSettings) !== false;
	    };
	
	    var getRelList = function (editorSettings) {
	      return editorSettings.rel_list;
	    };
	
	    var hasRelList = function (editorSettings) {
	      return getRelList(editorSettings) !== undefined;
	    };
	
	    var getLinkClassList = function (editorSettings) {
	      return editorSettings.link_class_list;
	    };
	
	    var hasLinkClassList = function (editorSettings) {
	      return getLinkClassList(editorSettings) !== undefined;
	    };
	
	    var shouldShowLinkTitle = function (editorSettings) {
	      return editorSettings.link_title !== false;
	    };
	
	    var allowUnsafeLinkTarget = function (editorSettings) {
	      return typeof editorSettings.allow_unsafe_link_target === 'boolean' ? editorSettings.allow_unsafe_link_target : false;
	    };
	
	    return {
	      assumeExternalTargets: assumeExternalTargets,
	      hasContextToolbar: hasContextToolbar,
	      getLinkList: getLinkList,
	      hasDefaultLinkTarget: hasDefaultLinkTarget,
	      getDefaultLinkTarget: getDefaultLinkTarget,
	      getTargetList: getTargetList,
	      setTargetList: setTargetList,
	      shouldShowTargetList: shouldShowTargetList,
	      getRelList: getRelList,
	      hasRelList: hasRelList,
	      getLinkClassList: getLinkClassList,
	      hasLinkClassList: hasLinkClassList,
	      shouldShowLinkTitle: shouldShowLinkTitle,
	      allowUnsafeLinkTarget: allowUnsafeLinkTarget
	    };
	  }
	);
	
	defineGlobal("global!document", document);
	defineGlobal("global!window", window);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DOMUtils',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.DOMUtils');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.Env',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.Env');
	  }
	);
	
	/**
	 * OpenUrl.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.link.core.OpenUrl',
	  [
	    'global!document',
	    'global!window',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.Env'
	  ],
	  function (document, window, DOMUtils, Env) {
	    var appendClickRemove = function (link, evt) {
	      document.body.appendChild(link);
	      link.dispatchEvent(evt);
	      document.body.removeChild(link);
	    };
	
	    var open = function (url) {
	      // Chrome and Webkit has implemented noopener and works correctly with/without popup blocker
	      // Firefox has it implemented noopener but when the popup blocker is activated it doesn't work
	      // Edge has only implemented noreferrer and it seems to remove opener as well
	      // Older IE versions pre IE 11 falls back to a window.open approach
	      if (!Env.ie || Env.ie > 10) {
	        var link = document.createElement('a');
	        link.target = '_blank';
	        link.href = url;
	        link.rel = 'noreferrer noopener';
	
	        var evt = document.createEvent('MouseEvents');
	        evt.initMouseEvent('click', true, true, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
	
	        appendClickRemove(link, evt);
	      } else {
	        var win = window.open('', '_blank');
	        if (win) {
	          win.opener = null;
	          var doc = win.document;
	          doc.open();
	          doc.write('<meta http-equiv="refresh" content="0; url=' + DOMUtils.DOM.encode(url) + '">');
	          doc.close();
	        }
	      }
	    };
	
	    return {
	      open: open
	    };
	  }
	);
	defineGlobal("global!RegExp", RegExp);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Tools',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Tools');
	  }
	);
	
	/**
	 * Utils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.link.core.Utils',
	  [
	    'global!RegExp',
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.link.api.Settings'
	  ],
	  function (RegExp, Tools, Settings) {
	    var toggleTargetRules = function (rel, isUnsafe) {
	      var rules = ['noopener'];
	      var newRel = rel ? rel.split(/\s+/) : [];
	
	      var toString = function (rel) {
	        return Tools.trim(rel.sort().join(' '));
	      };
	
	      var addTargetRules = function (rel) {
	        rel = removeTargetRules(rel);
	        return rel.length ? rel.concat(rules) : rules;
	      };
	
	      var removeTargetRules = function (rel) {
	        return rel.filter(function (val) {
	          return Tools.inArray(rules, val) === -1;
	        });
	      };
	
	      newRel = isUnsafe ? addTargetRules(newRel) : removeTargetRules(newRel);
	      return newRel.length ? toString(newRel) : null;
	    };
	
	    var trimCaretContainers = function (text) {
	      return text.replace(/\uFEFF/g, '');
	    };
	
	    var getAnchorElement = function (editor, selectedElm) {
	      selectedElm = selectedElm || editor.selection.getNode();
	      if (isImageFigure(selectedElm)) {
	        // for an image conained in a figure we look for a link inside the selected element
	        return editor.dom.select('a[href]', selectedElm)[0];
	      } else {
	        return editor.dom.getParent(selectedElm, 'a[href]');
	      }
	    };
	
	    var getAnchorText = function (selection, anchorElm) {
	      var text = anchorElm ? (anchorElm.innerText || anchorElm.textContent) : selection.getContent({ format: 'text' });
	      return trimCaretContainers(text);
	    };
	
	    var isLink = function (elm) {
	      return elm && elm.nodeName === 'A' && elm.href;
	    };
	
	    var hasLinks = function (elements) {
	      return Tools.grep(elements, isLink).length > 0;
	    };
	
	    var isOnlyTextSelected = function (html) {
	      // Partial html and not a fully selected anchor element
	      if (/</.test(html) && (!/^<a [^>]+>[^<]+<\/a>$/.test(html) || html.indexOf('href=') === -1)) {
	        return false;
	      }
	
	      return true;
	    };
	
	    var isImageFigure = function (node) {
	      return node && node.nodeName === 'FIGURE' && /\bimage\b/i.test(node.className);
	    };
	
	    var link = function (editor, attachState) {
	      return function (data) {
	        editor.undoManager.transact(function () {
	          var selectedElm = editor.selection.getNode();
	          var anchorElm = getAnchorElement(editor, selectedElm);
	
	          var linkAttrs = {
	            href: data.href,
	            target: data.target ? data.target : null,
	            rel: data.rel ? data.rel : null,
	            "class": data["class"] ? data["class"] : null,
	            title: data.title ? data.title : null
	          };
	
	          if (!Settings.hasRelList(editor.settings) && Settings.allowUnsafeLinkTarget(editor.settings) === false) {
	            linkAttrs.rel = toggleTargetRules(linkAttrs.rel, linkAttrs.target === '_blank');
	          }
	
	          if (data.href === attachState.href) {
	            attachState.attach();
	            attachState = {};
	          }
	
	          if (anchorElm) {
	            editor.focus();
	
	            if (data.hasOwnProperty('text')) {
	              if ("innerText" in anchorElm) {
	                anchorElm.innerText = data.text;
	              } else {
	                anchorElm.textContent = data.text;
	              }
	            }
	
	            editor.dom.setAttribs(anchorElm, linkAttrs);
	
	            editor.selection.select(anchorElm);
	            editor.undoManager.add();
	          } else {
	            if (isImageFigure(selectedElm)) {
	              linkImageFigure(editor, selectedElm, linkAttrs);
	            } else if (data.hasOwnProperty('text')) {
	              editor.insertContent(editor.dom.createHTML('a', linkAttrs, editor.dom.encode(data.text)));
	            } else {
	              editor.execCommand('mceInsertLink', false, linkAttrs);
	            }
	          }
	        });
	      };
	    };
	
	    var unlink = function (editor) {
	      return function () {
	        editor.undoManager.transact(function () {
	          var node = editor.selection.getNode();
	          if (isImageFigure(node)) {
	            unlinkImageFigure(editor, node);
	          } else {
	            editor.execCommand('unlink');
	          }
	        });
	      };
	    };
	
	    var unlinkImageFigure = function (editor, fig) {
	      var a, img;
	      img = editor.dom.select('img', fig)[0];
	      if (img) {
	        a = editor.dom.getParents(img, 'a[href]', fig)[0];
	        if (a) {
	          a.parentNode.insertBefore(img, a);
	          editor.dom.remove(a);
	        }
	      }
	    };
	
	    var linkImageFigure = function (editor, fig, attrs) {
	      var a, img;
	      img = editor.dom.select('img', fig)[0];
	      if (img) {
	        a = editor.dom.create('a', attrs);
	        img.parentNode.insertBefore(a, img);
	        a.appendChild(img);
	      }
	    };
	
	    return {
	      link: link,
	      unlink: unlink,
	      isLink: isLink,
	      hasLinks: hasLinks,
	      isOnlyTextSelected: isOnlyTextSelected,
	      getAnchorElement: getAnchorElement,
	      getAnchorText: getAnchorText,
	      toggleTargetRules: toggleTargetRules
	    };
	  }
	);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Delay',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Delay');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.XHR',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.XHR');
	  }
	);
	
	/**
	 * Dialog.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.link.ui.Dialog',
	  [
	    'tinymce.core.util.Delay',
	    'tinymce.core.util.Tools',
	    'tinymce.core.util.XHR',
	    'tinymce.plugins.link.api.Settings',
	    'tinymce.plugins.link.core.Utils'
	  ],
	  function (Delay, Tools, XHR, Settings, Utils) {
	    var attachState = {};
	
	    var createLinkList = function (editor, callback) {
	      var linkList = Settings.getLinkList(editor.settings);
	
	      if (typeof linkList === "string") {
	        XHR.send({
	          url: linkList,
	          success: function (text) {
	            callback(editor, JSON.parse(text));
	          }
	        });
	      } else if (typeof linkList === "function") {
	        linkList(function (list) {
	          callback(editor, list);
	        });
	      } else {
	        callback(editor, linkList);
	      }
	    };
	
	    var buildListItems = function (inputList, itemCallback, startItems) {
	      var appendItems = function (values, output) {
	        output = output || [];
	
	        Tools.each(values, function (item) {
	          var menuItem = { text: item.text || item.title };
	
	          if (item.menu) {
	            menuItem.menu = appendItems(item.menu);
	          } else {
	            menuItem.value = item.value;
	
	            if (itemCallback) {
	              itemCallback(menuItem);
	            }
	          }
	
	          output.push(menuItem);
	        });
	
	        return output;
	      };
	
	      return appendItems(inputList, startItems || []);
	    };
	
	    // Delay confirm since onSubmit will move focus
	    var delayedConfirm = function (editor, message, callback) {
	      var rng = editor.selection.getRng();
	
	      Delay.setEditorTimeout(editor, function () {
	        editor.windowManager.confirm(message, function (state) {
	          editor.selection.setRng(rng);
	          callback(state);
	        });
	      });
	    };
	
	    var showDialog = function (editor, linkList) {
	      var data = {}, selection = editor.selection, dom = editor.dom, anchorElm, initialText;
	      var win, onlyText, textListCtrl, linkListCtrl, relListCtrl, targetListCtrl, classListCtrl, linkTitleCtrl, value;
	
	      var linkListChangeHandler = function (e) {
	        var textCtrl = win.find('#text');
	
	        if (!textCtrl.value() || (e.lastControl && textCtrl.value() === e.lastControl.text())) {
	          textCtrl.value(e.control.text());
	        }
	
	        win.find('#href').value(e.control.value());
	      };
	
	      var buildAnchorListControl = function (url) {
	        var anchorList = [];
	
	        Tools.each(editor.dom.select('a:not([href])'), function (anchor) {
	          var id = anchor.name || anchor.id;
	
	          if (id) {
	            anchorList.push({
	              text: id,
	              value: '#' + id,
	              selected: url.indexOf('#' + id) !== -1
	            });
	          }
	        });
	
	        if (anchorList.length) {
	          anchorList.unshift({ text: 'None', value: '' });
	
	          return {
	            name: 'anchor',
	            type: 'listbox',
	            label: 'Anchors',
	            values: anchorList,
	            onselect: linkListChangeHandler
	          };
	        }
	      };
	
	      var updateText = function () {
	        if (!initialText && onlyText && !data.text) {
	          this.parent().parent().find('#text')[0].value(this.value());
	        }
	      };
	
	      var urlChange = function (e) {
	        var meta = e.meta || {};
	
	        if (linkListCtrl) {
	          linkListCtrl.value(editor.convertURL(this.value(), 'href'));
	        }
	
	        Tools.each(e.meta, function (value, key) {
	          var inp = win.find('#' + key);
	
	          if (key === 'text') {
	            if (initialText.length === 0) {
	              inp.value(value);
	              data.text = value;
	            }
	          } else {
	            inp.value(value);
	          }
	        });
	
	        if (meta.attach) {
	          attachState = {
	            href: this.value(),
	            attach: meta.attach
	          };
	        }
	
	        if (!meta.text) {
	          updateText.call(this);
	        }
	      };
	
	      var onBeforeCall = function (e) {
	        e.meta = win.toJSON();
	      };
	
	      onlyText = Utils.isOnlyTextSelected(selection.getContent());
	      anchorElm = Utils.getAnchorElement(editor);
	
	      data.text = initialText = Utils.getAnchorText(editor.selection, anchorElm);
	      data.href = anchorElm ? dom.getAttrib(anchorElm, 'href') : '';
	
	      if (anchorElm) {
	        data.target = dom.getAttrib(anchorElm, 'target');
	      } else if (Settings.hasDefaultLinkTarget(editor.settings)) {
	        data.target = Settings.getDefaultLinkTarget(editor.settings);
	      }
	
	      if ((value = dom.getAttrib(anchorElm, 'rel'))) {
	        data.rel = value;
	      }
	
	      if ((value = dom.getAttrib(anchorElm, 'class'))) {
	        data['class'] = value;
	      }
	
	      if ((value = dom.getAttrib(anchorElm, 'title'))) {
	        data.title = value;
	      }
	
	      if (onlyText) {
	        textListCtrl = {
	          name: 'text',
	          type: 'textbox',
	          size: 40,
	          label: 'Text to display',
	          onchange: function () {
	            data.text = this.value();
	          }
	        };
	      }
	
	      if (linkList) {
	        linkListCtrl = {
	          type: 'listbox',
	          label: 'Link list',
	          values: buildListItems(
	            linkList,
	            function (item) {
	              item.value = editor.convertURL(item.value || item.url, 'href');
	            },
	            [{ text: 'None', value: '' }]
	          ),
	          onselect: linkListChangeHandler,
	          value: editor.convertURL(data.href, 'href'),
	          onPostRender: function () {
	            /*eslint consistent-this:0*/
	            linkListCtrl = this;
	          }
	        };
	      }
	
	      if (Settings.shouldShowTargetList(editor.settings)) {
	        if (Settings.getTargetList(editor.settings) === undefined) {
	          Settings.setTargetList(editor, [
	            { text: 'None', value: '' },
	            { text: 'New window', value: '_blank' }
	          ]);
	        }
	
	        targetListCtrl = {
	          name: 'target',
	          type: 'listbox',
	          label: 'Target',
	          values: buildListItems(Settings.getTargetList(editor.settings))
	        };
	      }
	
	      if (Settings.hasRelList(editor.settings)) {
	        relListCtrl = {
	          name: 'rel',
	          type: 'listbox',
	          label: 'Rel',
	          values: buildListItems(
	            Settings.getRelList(editor.settings),
	            function (item) {
	              if (Settings.allowUnsafeLinkTarget(editor.settings) === false) {
	                item.value = Utils.toggleTargetRules(item.value, data.target === '_blank');
	              }
	            }
	          )
	        };
	      }
	
	      if (Settings.hasLinkClassList(editor.settings)) {
	        classListCtrl = {
	          name: 'class',
	          type: 'listbox',
	          label: 'Class',
	          values: buildListItems(
	            Settings.getLinkClassList(editor.settings),
	            function (item) {
	              if (item.value) {
	                item.textStyle = function () {
	                  return editor.formatter.getCssText({ inline: 'a', classes: [item.value] });
	                };
	              }
	            }
	          )
	        };
	      }
	
	      if (Settings.shouldShowLinkTitle(editor.settings)) {
	        linkTitleCtrl = {
	          name: 'title',
	          type: 'textbox',
	          label: 'Title',
	          value: data.title
	        };
	      }
	
	      win = editor.windowManager.open({
	        title: 'Insert link',
	        data: data,
	        body: [
	          {
	            name: 'href',
	            type: 'filepicker',
	            filetype: 'file',
	            size: 40,
	            autofocus: true,
	            label: 'Url',
	            onchange: urlChange,
	            onkeyup: updateText,
	            onbeforecall: onBeforeCall
	          },
	          textListCtrl,
	          linkTitleCtrl,
	          buildAnchorListControl(data.href),
	          linkListCtrl,
	          relListCtrl,
	          targetListCtrl,
	          classListCtrl
	        ],
	        onSubmit: function (e) {
	          var assumeExternalTargets = Settings.assumeExternalTargets(editor.settings);
	          var insertLink = Utils.link(editor, attachState);
	          var removeLink = Utils.unlink(editor);
	
	          var resultData = Tools.extend({}, data, e.data);
	          /*eslint dot-notation: 0*/
	          var href = resultData.href;
	
	          if (!href) {
	            removeLink();
	            return;
	          }
	
	          if (!onlyText || resultData.text === initialText) {
	            delete resultData.text;
	          }
	
	          // Is email and not //user@domain.com
	          if (href.indexOf('@') > 0 && href.indexOf('//') === -1 && href.indexOf('mailto:') === -1) {
	            delayedConfirm(
	              editor,
	              'The URL you entered seems to be an email address. Do you want to add the required mailto: prefix?',
	              function (state) {
	                if (state) {
	                  resultData.href = 'mailto:' + href;
	                }
	                insertLink(resultData);
	              }
	            );
	            return;
	          }
	
	          // Is not protocol prefixed
	          if ((assumeExternalTargets === true && !/^\w+:/i.test(href)) ||
	            (assumeExternalTargets === false && /^\s*www[\.|\d\.]/i.test(href))) {
	            delayedConfirm(
	              editor,
	              'The URL you entered seems to be an external link. Do you want to add the required http:// prefix?',
	              function (state) {
	                if (state) {
	                  resultData.href = 'http://' + href;
	                }
	                insertLink(resultData);
	              }
	            );
	            return;
	          }
	
	          insertLink(resultData);
	        }
	      });
	    };
	
	    var open = function (editor) {
	      createLinkList(editor, showDialog);
	    };
	
	    return {
	      open: open
	    };
	  }
	);
	/**
	 * Actions.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.link.core.Actions',
	  [
	    'tinymce.core.util.VK',
	    'tinymce.plugins.link.api.Settings',
	    'tinymce.plugins.link.core.OpenUrl',
	    'tinymce.plugins.link.core.Utils',
	    'tinymce.plugins.link.ui.Dialog'
	  ],
	  function (VK, Settings, OpenUrl, Utils, Dialog) {
	    var getLink = function (editor, elm) {
	      return editor.dom.getParent(elm, 'a[href]');
	    };
	
	    var getSelectedLink = function (editor) {
	      return getLink(editor, editor.selection.getStart());
	    };
	
	    var getHref = function (elm) {
	      // Returns the real href value not the resolved a.href value
	      var href = elm.getAttribute('data-mce-href');
	      return href ? href : elm.getAttribute('href');
	    };
	
	    var isContextMenuVisible = function (editor) {
	      var contextmenu = editor.plugins.contextmenu;
	      return contextmenu ? contextmenu.isContextMenuVisible() : false;
	    };
	
	    var hasOnlyAltModifier = function (e) {
	      return e.altKey === true && e.shiftKey === false && e.ctrlKey === false && e.metaKey === false;
	    };
	
	    var gotoLink = function (editor, a) {
	      if (a) {
	        var href = getHref(a);
	        if (/^#/.test(href)) {
	          var targetEl = editor.$(href);
	          if (targetEl.length) {
	            editor.selection.scrollIntoView(targetEl[0], true);
	          }
	        } else {
	          OpenUrl.open(a.href);
	        }
	      }
	    };
	
	    var openDialog = function (editor) {
	      return function () {
	        Dialog.open(editor);
	      };
	    };
	
	    var gotoSelectedLink = function (editor) {
	      return function () {
	        gotoLink(editor, getSelectedLink(editor));
	      };
	    };
	
	    var leftClickedOnAHref = function (editor) {
	      return function (elm) {
	        var sel, rng, node;
	        if (Settings.hasContextToolbar(editor.settings) && !isContextMenuVisible(editor) && Utils.isLink(elm)) {
	          sel = editor.selection;
	          rng = sel.getRng();
	          node = rng.startContainer;
	          // ignore cursor positions at the beginning/end (to make context toolbar less noisy)
	          if (node.nodeType === 3 && sel.isCollapsed() && rng.startOffset > 0 && rng.startOffset < node.data.length) {
	            return true;
	          }
	        }
	        return false;
	      };
	    };
	
	    var setupGotoLinks = function (editor) {
	      editor.on('click', function (e) {
	        var link = getLink(editor, e.target);
	        if (link && VK.metaKeyPressed(e)) {
	          e.preventDefault();
	          gotoLink(editor, link);
	        }
	      });
	
	      editor.on('keydown', function (e) {
	        var link = getSelectedLink(editor);
	        if (link && e.keyCode === 13 && hasOnlyAltModifier(e)) {
	          e.preventDefault();
	          gotoLink(editor, link);
	        }
	      });
	    };
	
	    var toggleActiveState = function (editor) {
	      return function () {
	        var self = this;
	        editor.on('nodechange', function (e) {
	          self.active(!editor.readonly && !!Utils.getAnchorElement(editor, e.element));
	        });
	      };
	    };
	
	    var toggleViewLinkState = function (editor) {
	      return function () {
	        var self = this;
	
	        var toggleVisibility = function (e) {
	          if (Utils.hasLinks(e.parents)) {
	            self.show();
	          } else {
	            self.hide();
	          }
	        };
	
	        if (!Utils.hasLinks(editor.dom.getParents(editor.selection.getStart()))) {
	          self.hide();
	        }
	
	        editor.on('nodechange', toggleVisibility);
	
	        self.on('remove', function () {
	          editor.off('nodechange', toggleVisibility);
	        });
	      };
	    };
	
	    return {
	      openDialog: openDialog,
	      gotoSelectedLink: gotoSelectedLink,
	      leftClickedOnAHref: leftClickedOnAHref,
	      setupGotoLinks: setupGotoLinks,
	      toggleActiveState: toggleActiveState,
	      toggleViewLinkState: toggleViewLinkState
	    };
	  }
	);
	/**
	 * Commands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.link.api.Commands',
	  [
	    'tinymce.plugins.link.core.Actions'
	  ],
	  function (Actions) {
	    var register = function (editor) {
	      editor.addCommand('mceLink', Actions.openDialog(editor));
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	/**
	 * Keyboard.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.link.core.Keyboard',
	  [
	    'tinymce.plugins.link.core.Actions'
	  ],
	  function (Actions) {
	    var setup = function (editor) {
	      editor.addShortcut('Meta+K', '', Actions.openDialog(editor));
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	/**
	 * Controls.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.link.ui.Controls',
	  [
	    'tinymce.plugins.link.core.Actions',
	    'tinymce.plugins.link.core.Utils'
	  ],
	  function (Actions, Utils) {
	
	    var setupButtons = function (editor) {
	      editor.addButton('link', {
	        active: false,
	        icon: 'link',
	        tooltip: 'Insert/edit link',
	        onclick: Actions.openDialog(editor),
	        onpostrender: Actions.toggleActiveState(editor)
	      });
	
	      editor.addButton('unlink', {
	        active: false,
	        icon: 'unlink',
	        tooltip: 'Remove link',
	        onclick: Utils.unlink(editor),
	        onpostrender: Actions.toggleActiveState(editor)
	      });
	
	      if (editor.addContextToolbar) {
	        editor.addButton('openlink', {
	          icon: 'newtab',
	          tooltip: 'Open link',
	          onclick: Actions.gotoSelectedLink(editor)
	        });
	      }
	    };
	
	    var setupMenuItems = function (editor) {
	      editor.addMenuItem('openlink', {
	        text: 'Open link',
	        icon: 'newtab',
	        onclick: Actions.gotoSelectedLink(editor),
	        onPostRender: Actions.toggleViewLinkState(editor),
	        prependToContext: true
	      });
	
	      editor.addMenuItem('link', {
	        icon: 'link',
	        text: 'Link',
	        shortcut: 'Meta+K',
	        onclick: Actions.openDialog(editor),
	        stateSelector: 'a[href]',
	        context: 'insert',
	        prependToContext: true
	      });
	    };
	
	    var setupContextToolbars = function (editor) {
	      if (editor.addContextToolbar) {
	        editor.addContextToolbar(
	          Actions.leftClickedOnAHref(editor),
	          'openlink | link unlink'
	        );
	      }
	    };
	
	    return {
	      setupButtons: setupButtons,
	      setupMenuItems: setupMenuItems,
	      setupContextToolbars: setupContextToolbars
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.link.Plugin',
	  [
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.link.api.Commands',
	    'tinymce.plugins.link.core.Actions',
	    'tinymce.plugins.link.core.Keyboard',
	    'tinymce.plugins.link.ui.Controls'
	  ],
	  function (PluginManager, Commands, Actions, Keyboard, Controls) {
	    PluginManager.add('link', function (editor) {
	      Controls.setupButtons(editor);
	      Controls.setupMenuItems(editor);
	      Controls.setupContextToolbars(editor);
	      Actions.setupGotoLinks(editor);
	      Commands.register(editor);
	      Keyboard.setup(editor);
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.link.Plugin')();
	})();


/***/ },
/* 2020 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "lists" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/lists')
	//   ES2015:
	//     import 'tinymce/plugins/lists'
	__webpack_require__(2021);

/***/ },
/* 2021 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.lists.Plugin","tinymce.core.PluginManager","tinymce.plugins.lists.api.Api","tinymce.plugins.lists.api.Commands","tinymce.plugins.lists.core.Keyboard","tinymce.plugins.lists.ui.Buttons","global!tinymce.util.Tools.resolve","tinymce.plugins.lists.core.Delete","tinymce.plugins.lists.actions.Indent","tinymce.plugins.lists.actions.Outdent","tinymce.plugins.lists.actions.ToggleList","tinymce.core.util.VK","tinymce.plugins.lists.api.Settings","tinymce.core.util.Tools","tinymce.plugins.lists.core.NodeType","tinymce.plugins.lists.core.Selection","tinymce.core.api.dom.RangeUtils","tinymce.core.dom.TreeWalker","tinymce.core.api.dom.BookmarkManager","tinymce.core.dom.DOMUtils","tinymce.plugins.lists.core.Bookmark","tinymce.plugins.lists.core.NormalizeLists","tinymce.core.dom.DomQuery","tinymce.plugins.lists.core.SplitList","tinymce.plugins.lists.core.TextBlock","tinymce.plugins.lists.core.Range","tinymce.core.Env"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.api.dom.RangeUtils',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.RangeUtils');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.TreeWalker',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.TreeWalker');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.VK',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.VK');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.api.dom.BookmarkManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.BookmarkManager');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Tools',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Tools');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DOMUtils',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.DOMUtils');
	  }
	);
	
	/**
	 * NodeType.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.core.NodeType',
	  [
	  ],
	  function () {
	    var isTextNode = function (node) {
	      return node && node.nodeType === 3;
	    };
	
	    var isListNode = function (node) {
	      return node && (/^(OL|UL|DL)$/).test(node.nodeName);
	    };
	
	    var isListItemNode = function (node) {
	      return node && /^(LI|DT|DD)$/.test(node.nodeName);
	    };
	
	    var isTableCellNode = function (node) {
	      return node && /^(TH|TD)$/.test(node.nodeName);
	    };
	
	    var isBr = function (node) {
	      return node && node.nodeName === 'BR';
	    };
	
	    var isFirstChild = function (node) {
	      return node.parentNode.firstChild === node;
	    };
	
	    var isLastChild = function (node) {
	      return node.parentNode.lastChild === node;
	    };
	
	    var isTextBlock = function (editor, node) {
	      return node && !!editor.schema.getTextBlockElements()[node.nodeName];
	    };
	
	    var isBlock = function (node, blockElements) {
	      return node && node.nodeName in blockElements;
	    };
	
	    var isBogusBr = function (dom, node) {
	      if (!isBr(node)) {
	        return false;
	      }
	
	      if (dom.isBlock(node.nextSibling) && !isBr(node.previousSibling)) {
	        return true;
	      }
	
	      return false;
	    };
	
	    var isEmpty = function (dom, elm, keepBookmarks) {
	      var empty = dom.isEmpty(elm);
	
	      if (keepBookmarks && dom.select('span[data-mce-type=bookmark]', elm).length > 0) {
	        return false;
	      }
	
	      return empty;
	    };
	
	    var isChildOfBody = function (dom, elm) {
	      return dom.isChildOf(elm, dom.getRoot());
	    };
	
	    return {
	      isTextNode: isTextNode,
	      isListNode: isListNode,
	      isListItemNode: isListItemNode,
	      isTableCellNode: isTableCellNode,
	      isBr: isBr,
	      isFirstChild: isFirstChild,
	      isLastChild: isLastChild,
	      isTextBlock: isTextBlock,
	      isBlock: isBlock,
	      isBogusBr: isBogusBr,
	      isEmpty: isEmpty,
	      isChildOfBody: isChildOfBody
	    };
	  }
	);
	
	
	/**
	 * Range.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.core.Range',
	  [
	    'tinymce.core.api.dom.RangeUtils',
	    'tinymce.plugins.lists.core.NodeType'
	  ],
	  function (RangeUtils, NodeType) {
	    var getNormalizedEndPoint = function (container, offset) {
	      var node = RangeUtils.getNode(container, offset);
	
	      if (NodeType.isListItemNode(container) && NodeType.isTextNode(node)) {
	        var textNodeOffset = offset >= container.childNodes.length ? node.data.length : 0;
	        return { container: node, offset: textNodeOffset };
	      }
	
	      return { container: container, offset: offset };
	    };
	
	    var normalizeRange = function (rng) {
	      var outRng = rng.cloneRange();
	
	      var rangeStart = getNormalizedEndPoint(rng.startContainer, rng.startOffset);
	      outRng.setStart(rangeStart.container, rangeStart.offset);
	
	      var rangeEnd = getNormalizedEndPoint(rng.endContainer, rng.endOffset);
	      outRng.setEnd(rangeEnd.container, rangeEnd.offset);
	
	      return outRng;
	    };
	
	    return {
	      getNormalizedEndPoint: getNormalizedEndPoint,
	      normalizeRange: normalizeRange
	    };
	  }
	);
	
	
	/**
	 * Bookmark.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.core.Bookmark',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.plugins.lists.core.NodeType',
	    'tinymce.plugins.lists.core.Range'
	  ],
	  function (DOMUtils, NodeType, Range) {
	    var DOM = DOMUtils.DOM;
	
	    /**
	     * Returns a range bookmark. This will convert indexed bookmarks into temporary span elements with
	     * index 0 so that they can be restored properly after the DOM has been modified. Text bookmarks will not have spans
	     * added to them since they can be restored after a dom operation.
	     *
	     * So this: <p><b>|</b><b>|</b></p>
	     * becomes: <p><b><span data-mce-type="bookmark">|</span></b><b data-mce-type="bookmark">|</span></b></p>
	     *
	     * @param  {DOMRange} rng DOM Range to get bookmark on.
	     * @return {Object} Bookmark object.
	     */
	    var createBookmark = function (rng) {
	      var bookmark = {};
	
	      var setupEndPoint = function (start) {
	        var offsetNode, container, offset;
	
	        container = rng[start ? 'startContainer' : 'endContainer'];
	        offset = rng[start ? 'startOffset' : 'endOffset'];
	
	        if (container.nodeType === 1) {
	          offsetNode = DOM.create('span', { 'data-mce-type': 'bookmark' });
	
	          if (container.hasChildNodes()) {
	            offset = Math.min(offset, container.childNodes.length - 1);
	
	            if (start) {
	              container.insertBefore(offsetNode, container.childNodes[offset]);
	            } else {
	              DOM.insertAfter(offsetNode, container.childNodes[offset]);
	            }
	          } else {
	            container.appendChild(offsetNode);
	          }
	
	          container = offsetNode;
	          offset = 0;
	        }
	
	        bookmark[start ? 'startContainer' : 'endContainer'] = container;
	        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
	      };
	
	      setupEndPoint(true);
	
	      if (!rng.collapsed) {
	        setupEndPoint();
	      }
	
	      return bookmark;
	    };
	
	    var resolveBookmark = function (bookmark) {
	      function restoreEndPoint(start) {
	        var container, offset, node;
	
	        var nodeIndex = function (container) {
	          var node = container.parentNode.firstChild, idx = 0;
	
	          while (node) {
	            if (node === container) {
	              return idx;
	            }
	
	            // Skip data-mce-type=bookmark nodes
	            if (node.nodeType !== 1 || node.getAttribute('data-mce-type') !== 'bookmark') {
	              idx++;
	            }
	
	            node = node.nextSibling;
	          }
	
	          return -1;
	        };
	
	        container = node = bookmark[start ? 'startContainer' : 'endContainer'];
	        offset = bookmark[start ? 'startOffset' : 'endOffset'];
	
	        if (!container) {
	          return;
	        }
	
	        if (container.nodeType === 1) {
	          offset = nodeIndex(container);
	          container = container.parentNode;
	          DOM.remove(node);
	
	          if (!container.hasChildNodes() && DOM.isBlock(container)) {
	            container.appendChild(DOM.create('br'));
	          }
	        }
	
	        bookmark[start ? 'startContainer' : 'endContainer'] = container;
	        bookmark[start ? 'startOffset' : 'endOffset'] = offset;
	      }
	
	      restoreEndPoint(true);
	      restoreEndPoint();
	
	      var rng = DOM.createRng();
	
	      rng.setStart(bookmark.startContainer, bookmark.startOffset);
	
	      if (bookmark.endContainer) {
	        rng.setEnd(bookmark.endContainer, bookmark.endOffset);
	      }
	
	      return Range.normalizeRange(rng);
	    };
	
	    return {
	      createBookmark: createBookmark,
	      resolveBookmark: resolveBookmark
	    };
	  }
	);
	
	
	/**
	 * NormalizeLists.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.core.NormalizeLists',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.lists.core.NodeType'
	  ],
	  function (DOMUtils, Tools, NodeType) {
	    var DOM = DOMUtils.DOM;
	
	    var normalizeList = function (dom, ul) {
	      var sibling, parentNode = ul.parentNode;
	
	      // Move UL/OL to previous LI if it's the only child of a LI
	      if (parentNode.nodeName === 'LI' && parentNode.firstChild === ul) {
	        sibling = parentNode.previousSibling;
	        if (sibling && sibling.nodeName === 'LI') {
	          sibling.appendChild(ul);
	
	          if (NodeType.isEmpty(dom, parentNode)) {
	            DOM.remove(parentNode);
	          }
	        } else {
	          DOM.setStyle(parentNode, 'listStyleType', 'none');
	        }
	      }
	
	      // Append OL/UL to previous LI if it's in a parent OL/UL i.e. old HTML4
	      if (NodeType.isListNode(parentNode)) {
	        sibling = parentNode.previousSibling;
	        if (sibling && sibling.nodeName === 'LI') {
	          sibling.appendChild(ul);
	        }
	      }
	    };
	
	    var normalizeLists = function (dom, element) {
	      Tools.each(Tools.grep(dom.select('ol,ul', element)), function (ul) {
	        normalizeList(dom, ul);
	      });
	    };
	
	    return {
	      normalizeList: normalizeList,
	      normalizeLists: normalizeLists
	    };
	  }
	);
	
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DomQuery',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.DomQuery');
	  }
	);
	
	/**
	 * Selection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.core.Selection',
	  [
	    'tinymce.core.dom.DomQuery',
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.lists.core.NodeType'
	  ],
	  function (DomQuery, Tools, NodeType) {
	    var getParentList = function (editor) {
	      var selectionStart = editor.selection.getStart(true);
	
	      return editor.dom.getParent(selectionStart, 'OL,UL,DL', getClosestListRootElm(editor, selectionStart));
	    };
	
	    var isParentListSelected = function (parentList, selectedBlocks) {
	      return parentList && selectedBlocks.length === 1 && selectedBlocks[0] === parentList;
	    };
	
	    var findSubLists = function (parentList) {
	      return Tools.grep(parentList.querySelectorAll('ol,ul,dl'), function (elm) {
	        return NodeType.isListNode(elm);
	      });
	    };
	
	    var getSelectedSubLists = function (editor) {
	      var parentList = getParentList(editor);
	      var selectedBlocks = editor.selection.getSelectedBlocks();
	
	      if (isParentListSelected(parentList, selectedBlocks)) {
	        return findSubLists(parentList);
	      } else {
	        return Tools.grep(selectedBlocks, function (elm) {
	          return NodeType.isListNode(elm) && parentList !== elm;
	        });
	      }
	    };
	
	    var findParentListItemsNodes = function (editor, elms) {
	      var listItemsElms = Tools.map(elms, function (elm) {
	        var parentLi = editor.dom.getParent(elm, 'li,dd,dt', getClosestListRootElm(editor, elm));
	
	        return parentLi ? parentLi : elm;
	      });
	
	      return DomQuery.unique(listItemsElms);
	    };
	
	    var getSelectedListItems = function (editor) {
	      var selectedBlocks = editor.selection.getSelectedBlocks();
	      return Tools.grep(findParentListItemsNodes(editor, selectedBlocks), function (block) {
	        return NodeType.isListItemNode(block);
	      });
	    };
	
	    var getClosestListRootElm = function (editor, elm) {
	      var parentTableCell = editor.dom.getParents(elm, 'TD,TH');
	      var root = parentTableCell.length > 0 ? parentTableCell[0] : editor.getBody();
	
	      return root;
	    };
	
	    return {
	      getParentList: getParentList,
	      getSelectedSubLists: getSelectedSubLists,
	      getSelectedListItems: getSelectedListItems,
	      getClosestListRootElm: getClosestListRootElm
	    };
	  }
	);
	
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.Env',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.Env');
	  }
	);
	
	/**
	 * TextBlock.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.core.TextBlock',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.Env',
	    'tinymce.plugins.lists.core.NodeType'
	  ],
	  function (DOMUtils, Env, NodeType) {
	    var DOM = DOMUtils.DOM;
	
	    var createNewTextBlock = function (editor, contentNode, blockName) {
	      var node, textBlock, fragment = DOM.createFragment(), hasContentNode;
	      var blockElements = editor.schema.getBlockElements();
	
	      if (editor.settings.forced_root_block) {
	        blockName = blockName || editor.settings.forced_root_block;
	      }
	
	      if (blockName) {
	        textBlock = DOM.create(blockName);
	
	        if (textBlock.tagName === editor.settings.forced_root_block) {
	          DOM.setAttribs(textBlock, editor.settings.forced_root_block_attrs);
	        }
	
	        if (!NodeType.isBlock(contentNode.firstChild, blockElements)) {
	          fragment.appendChild(textBlock);
	        }
	      }
	
	      if (contentNode) {
	        while ((node = contentNode.firstChild)) {
	          var nodeName = node.nodeName;
	
	          if (!hasContentNode && (nodeName !== 'SPAN' || node.getAttribute('data-mce-type') !== 'bookmark')) {
	            hasContentNode = true;
	          }
	
	          if (NodeType.isBlock(node, blockElements)) {
	            fragment.appendChild(node);
	            textBlock = null;
	          } else {
	            if (blockName) {
	              if (!textBlock) {
	                textBlock = DOM.create(blockName);
	                fragment.appendChild(textBlock);
	              }
	
	              textBlock.appendChild(node);
	            } else {
	              fragment.appendChild(node);
	            }
	          }
	        }
	      }
	
	      if (!editor.settings.forced_root_block) {
	        fragment.appendChild(DOM.create('br'));
	      } else {
	        // BR is needed in empty blocks on non IE browsers
	        if (!hasContentNode && (!Env.ie || Env.ie > 10)) {
	          textBlock.appendChild(DOM.create('br', { 'data-mce-bogus': '1' }));
	        }
	      }
	
	      return fragment;
	    };
	
	    return {
	      createNewTextBlock: createNewTextBlock
	    };
	  }
	);
	
	/**
	 * SplitList.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.core.SplitList',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.plugins.lists.core.NodeType',
	    'tinymce.plugins.lists.core.TextBlock',
	    'tinymce.core.util.Tools'
	  ],
	  function (DOMUtils, NodeType, TextBlock, Tools) {
	    var DOM = DOMUtils.DOM;
	
	    var splitList = function (editor, ul, li, newBlock) {
	      var tmpRng, fragment, bookmarks, node;
	
	      var removeAndKeepBookmarks = function (targetNode) {
	        Tools.each(bookmarks, function (node) {
	          targetNode.parentNode.insertBefore(node, li.parentNode);
	        });
	
	        DOM.remove(targetNode);
	      };
	
	      bookmarks = DOM.select('span[data-mce-type="bookmark"]', ul);
	      newBlock = newBlock || TextBlock.createNewTextBlock(editor, li);
	      tmpRng = DOM.createRng();
	      tmpRng.setStartAfter(li);
	      tmpRng.setEndAfter(ul);
	      fragment = tmpRng.extractContents();
	
	      for (node = fragment.firstChild; node; node = node.firstChild) {
	        if (node.nodeName === 'LI' && editor.dom.isEmpty(node)) {
	          DOM.remove(node);
	          break;
	        }
	      }
	
	      if (!editor.dom.isEmpty(fragment)) {
	        DOM.insertAfter(fragment, ul);
	      }
	
	      DOM.insertAfter(newBlock, ul);
	
	      if (NodeType.isEmpty(editor.dom, li.parentNode)) {
	        removeAndKeepBookmarks(li.parentNode);
	      }
	
	      DOM.remove(li);
	
	      if (NodeType.isEmpty(editor.dom, ul)) {
	        DOM.remove(ul);
	      }
	    };
	
	    return {
	      splitList: splitList
	    };
	  }
	);
	
	
	/**
	 * Outdent.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.actions.Outdent',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.plugins.lists.core.Bookmark',
	    'tinymce.plugins.lists.core.NodeType',
	    'tinymce.plugins.lists.core.NormalizeLists',
	    'tinymce.plugins.lists.core.Selection',
	    'tinymce.plugins.lists.core.SplitList',
	    'tinymce.plugins.lists.core.TextBlock'
	  ],
	  function (DOMUtils, Bookmark, NodeType, NormalizeLists, Selection, SplitList, TextBlock) {
	    var DOM = DOMUtils.DOM;
	
	    var removeEmptyLi = function (dom, li) {
	      if (NodeType.isEmpty(dom, li)) {
	        DOM.remove(li);
	      }
	    };
	
	    var outdent = function (editor, li) {
	      var ul = li.parentNode, ulParent = ul.parentNode, newBlock;
	
	      if (ul === editor.getBody()) {
	        return true;
	      }
	
	      if (li.nodeName === 'DD') {
	        DOM.rename(li, 'DT');
	        return true;
	      }
	
	      if (NodeType.isFirstChild(li) && NodeType.isLastChild(li)) {
	        if (ulParent.nodeName === "LI") {
	          DOM.insertAfter(li, ulParent);
	          removeEmptyLi(editor.dom, ulParent);
	          DOM.remove(ul);
	        } else if (NodeType.isListNode(ulParent)) {
	          DOM.remove(ul, true);
	        } else {
	          ulParent.insertBefore(TextBlock.createNewTextBlock(editor, li), ul);
	          DOM.remove(ul);
	        }
	
	        return true;
	      } else if (NodeType.isFirstChild(li)) {
	        if (ulParent.nodeName === "LI") {
	          DOM.insertAfter(li, ulParent);
	          li.appendChild(ul);
	          removeEmptyLi(editor.dom, ulParent);
	        } else if (NodeType.isListNode(ulParent)) {
	          ulParent.insertBefore(li, ul);
	        } else {
	          ulParent.insertBefore(TextBlock.createNewTextBlock(editor, li), ul);
	          DOM.remove(li);
	        }
	
	        return true;
	      } else if (NodeType.isLastChild(li)) {
	        if (ulParent.nodeName === "LI") {
	          DOM.insertAfter(li, ulParent);
	        } else if (NodeType.isListNode(ulParent)) {
	          DOM.insertAfter(li, ul);
	        } else {
	          DOM.insertAfter(TextBlock.createNewTextBlock(editor, li), ul);
	          DOM.remove(li);
	        }
	
	        return true;
	      }
	
	      if (ulParent.nodeName === 'LI') {
	        ul = ulParent;
	        newBlock = TextBlock.createNewTextBlock(editor, li, 'LI');
	      } else if (NodeType.isListNode(ulParent)) {
	        newBlock = TextBlock.createNewTextBlock(editor, li, 'LI');
	      } else {
	        newBlock = TextBlock.createNewTextBlock(editor, li);
	      }
	
	      SplitList.splitList(editor, ul, li, newBlock);
	      NormalizeLists.normalizeLists(editor.dom, ul.parentNode);
	
	      return true;
	    };
	
	    var outdentSelection = function (editor) {
	      var listElements = Selection.getSelectedListItems(editor);
	
	      if (listElements.length) {
	        var bookmark = Bookmark.createBookmark(editor.selection.getRng(true));
	        var i, y;
	        var root = Selection.getClosestListRootElm(editor, editor.selection.getStart(true));
	
	        i = listElements.length;
	        while (i--) {
	          var node = listElements[i].parentNode;
	
	          while (node && node !== root) {
	            y = listElements.length;
	            while (y--) {
	              if (listElements[y] === node) {
	                listElements.splice(i, 1);
	                break;
	              }
	            }
	
	            node = node.parentNode;
	          }
	        }
	
	        for (i = 0; i < listElements.length; i++) {
	          if (!outdent(editor, listElements[i]) && i === 0) {
	            break;
	          }
	        }
	
	        editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	        editor.nodeChanged();
	
	        return true;
	      }
	    };
	
	    return {
	      outdent: outdent,
	      outdentSelection: outdentSelection
	    };
	  }
	);
	
	
	/**
	 * ToggleList.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.actions.ToggleList',
	  [
	    'tinymce.core.api.dom.BookmarkManager',
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.lists.actions.Outdent',
	    'tinymce.plugins.lists.core.Bookmark',
	    'tinymce.plugins.lists.core.NodeType',
	    'tinymce.plugins.lists.core.NormalizeLists',
	    'tinymce.plugins.lists.core.Selection',
	    'tinymce.plugins.lists.core.SplitList'
	  ],
	  function (BookmarkManager, Tools, Outdent, Bookmark, NodeType, NormalizeLists, Selection, SplitList) {
	    var updateListStyle = function (dom, el, detail) {
	      var type = detail['list-style-type'] ? detail['list-style-type'] : null;
	      dom.setStyle(el, 'list-style-type', type);
	    };
	
	    var setAttribs = function (elm, attrs) {
	      Tools.each(attrs, function (value, key) {
	        elm.setAttribute(key, value);
	      });
	    };
	
	    var updateListAttrs = function (dom, el, detail) {
	      setAttribs(el, detail['list-attributes']);
	      Tools.each(dom.select('li', el), function (li) {
	        setAttribs(li, detail['list-item-attributes']);
	      });
	    };
	
	    var updateListWithDetails = function (dom, el, detail) {
	      updateListStyle(dom, el, detail);
	      updateListAttrs(dom, el, detail);
	    };
	
	    var getEndPointNode = function (editor, rng, start, root) {
	      var container, offset;
	
	      container = rng[start ? 'startContainer' : 'endContainer'];
	      offset = rng[start ? 'startOffset' : 'endOffset'];
	
	      // Resolve node index
	      if (container.nodeType === 1) {
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	      }
	
	      if (!start && NodeType.isBr(container.nextSibling)) {
	        container = container.nextSibling;
	      }
	
	      while (container.parentNode !== root) {
	        if (NodeType.isTextBlock(editor, container)) {
	          return container;
	        }
	
	        if (/^(TD|TH)$/.test(container.parentNode.nodeName)) {
	          return container;
	        }
	
	        container = container.parentNode;
	      }
	
	      return container;
	    };
	
	    var getSelectedTextBlocks = function (editor, rng, root) {
	      var textBlocks = [], dom = editor.dom;
	
	      var startNode = getEndPointNode(editor, rng, true, root);
	      var endNode = getEndPointNode(editor, rng, false, root);
	      var block, siblings = [];
	
	      for (var node = startNode; node; node = node.nextSibling) {
	        siblings.push(node);
	
	        if (node === endNode) {
	          break;
	        }
	      }
	
	      Tools.each(siblings, function (node) {
	        if (NodeType.isTextBlock(editor, node)) {
	          textBlocks.push(node);
	          block = null;
	          return;
	        }
	
	        if (dom.isBlock(node) || NodeType.isBr(node)) {
	          if (NodeType.isBr(node)) {
	            dom.remove(node);
	          }
	
	          block = null;
	          return;
	        }
	
	        var nextSibling = node.nextSibling;
	        if (BookmarkManager.isBookmarkNode(node)) {
	          if (NodeType.isTextBlock(editor, nextSibling) || (!nextSibling && node.parentNode === root)) {
	            block = null;
	            return;
	          }
	        }
	
	        if (!block) {
	          block = dom.create('p');
	          node.parentNode.insertBefore(block, node);
	          textBlocks.push(block);
	        }
	
	        block.appendChild(node);
	      });
	
	      return textBlocks;
	    };
	
	    var hasCompatibleStyle = function (dom, sib, detail) {
	      var sibStyle = dom.getStyle(sib, 'list-style-type');
	      var detailStyle = detail ? detail['list-style-type'] : '';
	
	      detailStyle = detailStyle === null ? '' : detailStyle;
	
	      return sibStyle === detailStyle;
	    };
	
	    var applyList = function (editor, listName, detail) {
	      var rng = editor.selection.getRng(true), bookmark, listItemName = 'LI';
	      var root = Selection.getClosestListRootElm(editor, editor.selection.getStart(true));
	      var dom = editor.dom;
	
	      detail = detail ? detail : {};
	
	      if (dom.getContentEditable(editor.selection.getNode()) === "false") {
	        return;
	      }
	
	      listName = listName.toUpperCase();
	
	      if (listName === 'DL') {
	        listItemName = 'DT';
	      }
	
	      bookmark = Bookmark.createBookmark(rng);
	
	      Tools.each(getSelectedTextBlocks(editor, rng, root), function (block) {
	        var listBlock, sibling;
	
	        sibling = block.previousSibling;
	        if (sibling && NodeType.isListNode(sibling) && sibling.nodeName === listName && hasCompatibleStyle(dom, sibling, detail)) {
	          listBlock = sibling;
	          block = dom.rename(block, listItemName);
	          sibling.appendChild(block);
	        } else {
	          listBlock = dom.create(listName);
	          block.parentNode.insertBefore(listBlock, block);
	          listBlock.appendChild(block);
	          block = dom.rename(block, listItemName);
	        }
	
	        updateListWithDetails(dom, listBlock, detail);
	        mergeWithAdjacentLists(editor.dom, listBlock);
	      });
	
	      editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	    };
	
	    var removeList = function (editor) {
	      var bookmark = Bookmark.createBookmark(editor.selection.getRng(true));
	      var root = Selection.getClosestListRootElm(editor, editor.selection.getStart(true));
	      var listItems = Selection.getSelectedListItems(editor);
	      var emptyListItems = Tools.grep(listItems, function (li) {
	        return editor.dom.isEmpty(li);
	      });
	
	      listItems = Tools.grep(listItems, function (li) {
	        return !editor.dom.isEmpty(li);
	      });
	
	      Tools.each(emptyListItems, function (li) {
	        if (NodeType.isEmpty(editor.dom, li)) {
	          Outdent.outdent(editor, li);
	          return;
	        }
	      });
	
	      Tools.each(listItems, function (li) {
	        var node, rootList;
	
	        if (li.parentNode === editor.getBody()) {
	          return;
	        }
	
	        for (node = li; node && node !== root; node = node.parentNode) {
	          if (NodeType.isListNode(node)) {
	            rootList = node;
	          }
	        }
	
	        SplitList.splitList(editor, rootList, li);
	        NormalizeLists.normalizeLists(editor.dom, rootList.parentNode);
	      });
	
	      editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	    };
	
	    var isValidLists = function (list1, list2) {
	      return list1 && list2 && NodeType.isListNode(list1) && list1.nodeName === list2.nodeName;
	    };
	
	    var hasSameListStyle = function (dom, list1, list2) {
	      var targetStyle = dom.getStyle(list1, 'list-style-type', true);
	      var style = dom.getStyle(list2, 'list-style-type', true);
	      return targetStyle === style;
	    };
	
	    var hasSameClasses = function (elm1, elm2) {
	      return elm1.className === elm2.className;
	    };
	
	    var shouldMerge = function (dom, list1, list2) {
	      return isValidLists(list1, list2) && hasSameListStyle(dom, list1, list2) && hasSameClasses(list1, list2);
	    };
	
	    var mergeWithAdjacentLists = function (dom, listBlock) {
	      var sibling, node;
	
	      sibling = listBlock.nextSibling;
	      if (shouldMerge(dom, listBlock, sibling)) {
	        while ((node = sibling.firstChild)) {
	          listBlock.appendChild(node);
	        }
	
	        dom.remove(sibling);
	      }
	
	      sibling = listBlock.previousSibling;
	      if (shouldMerge(dom, listBlock, sibling)) {
	        while ((node = sibling.lastChild)) {
	          listBlock.insertBefore(node, listBlock.firstChild);
	        }
	
	        dom.remove(sibling);
	      }
	    };
	
	    var updateList = function (dom, list, listName, detail) {
	      if (list.nodeName !== listName) {
	        var newList = dom.rename(list, listName);
	        updateListWithDetails(dom, newList, detail);
	      } else {
	        updateListWithDetails(dom, list, detail);
	      }
	    };
	
	    var toggleMultipleLists = function (editor, parentList, lists, listName, detail) {
	      if (parentList.nodeName === listName && !hasListStyleDetail(detail)) {
	        removeList(editor, listName);
	      } else {
	        var bookmark = Bookmark.createBookmark(editor.selection.getRng(true));
	
	        Tools.each([parentList].concat(lists), function (elm) {
	          updateList(editor.dom, elm, listName, detail);
	        });
	
	        editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	      }
	    };
	
	    var hasListStyleDetail = function (detail) {
	      return 'list-style-type' in detail;
	    };
	
	    var toggleSingleList = function (editor, parentList, listName, detail) {
	      if (parentList === editor.getBody()) {
	        return;
	      }
	
	      if (parentList) {
	        if (parentList.nodeName === listName && !hasListStyleDetail(detail)) {
	          removeList(editor, listName);
	        } else {
	          var bookmark = Bookmark.createBookmark(editor.selection.getRng(true));
	          updateListWithDetails(editor.dom, parentList, detail);
	          mergeWithAdjacentLists(editor.dom, editor.dom.rename(parentList, listName));
	          editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	        }
	      } else {
	        applyList(editor, listName, detail);
	      }
	    };
	
	    var toggleList = function (editor, listName, detail) {
	      var parentList = Selection.getParentList(editor);
	      var selectedSubLists = Selection.getSelectedSubLists(editor);
	
	      detail = detail ? detail : {};
	
	      if (parentList && selectedSubLists.length > 0) {
	        toggleMultipleLists(editor, parentList, selectedSubLists, listName, detail);
	      } else {
	        toggleSingleList(editor, parentList, listName, detail);
	      }
	    };
	
	    return {
	      toggleList: toggleList,
	      removeList: removeList,
	      mergeWithAdjacentLists: mergeWithAdjacentLists
	    };
	  }
	);
	
	
	/**
	 * Delete.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.core.Delete',
	  [
	    'tinymce.core.api.dom.RangeUtils',
	    'tinymce.core.dom.TreeWalker',
	    'tinymce.core.util.VK',
	    'tinymce.plugins.lists.actions.ToggleList',
	    'tinymce.plugins.lists.core.Bookmark',
	    'tinymce.plugins.lists.core.NodeType',
	    'tinymce.plugins.lists.core.NormalizeLists',
	    'tinymce.plugins.lists.core.Range',
	    'tinymce.plugins.lists.core.Selection'
	  ],
	  function (RangeUtils, TreeWalker, VK, ToggleList, Bookmark, NodeType, NormalizeLists, Range, Selection) {
	    var findNextCaretContainer = function (editor, rng, isForward, root) {
	      var node = rng.startContainer, offset = rng.startOffset;
	      var nonEmptyBlocks, walker;
	
	      if (node.nodeType === 3 && (isForward ? offset < node.data.length : offset > 0)) {
	        return node;
	      }
	
	      nonEmptyBlocks = editor.schema.getNonEmptyElements();
	      if (node.nodeType === 1) {
	        node = RangeUtils.getNode(node, offset);
	      }
	
	      walker = new TreeWalker(node, root);
	
	      // Delete at <li>|<br></li> then jump over the bogus br
	      if (isForward) {
	        if (NodeType.isBogusBr(editor.dom, node)) {
	          walker.next();
	        }
	      }
	
	      while ((node = walker[isForward ? 'next' : 'prev2']())) {
	        if (node.nodeName === 'LI' && !node.hasChildNodes()) {
	          return node;
	        }
	
	        if (nonEmptyBlocks[node.nodeName]) {
	          return node;
	        }
	
	        if (node.nodeType === 3 && node.data.length > 0) {
	          return node;
	        }
	      }
	    };
	
	    var hasOnlyOneBlockChild = function (dom, elm) {
	      var childNodes = elm.childNodes;
	      return childNodes.length === 1 && !NodeType.isListNode(childNodes[0]) && dom.isBlock(childNodes[0]);
	    };
	
	    var unwrapSingleBlockChild = function (dom, elm) {
	      if (hasOnlyOneBlockChild(dom, elm)) {
	        dom.remove(elm.firstChild, true);
	      }
	    };
	
	    var moveChildren = function (dom, fromElm, toElm) {
	      var node, targetElm;
	
	      targetElm = hasOnlyOneBlockChild(dom, toElm) ? toElm.firstChild : toElm;
	      unwrapSingleBlockChild(dom, fromElm);
	
	      if (!NodeType.isEmpty(dom, fromElm, true)) {
	        while ((node = fromElm.firstChild)) {
	          targetElm.appendChild(node);
	        }
	      }
	    };
	
	    var mergeLiElements = function (dom, fromElm, toElm) {
	      var node, listNode, ul = fromElm.parentNode;
	
	      if (!NodeType.isChildOfBody(dom, fromElm) || !NodeType.isChildOfBody(dom, toElm)) {
	        return;
	      }
	
	      if (NodeType.isListNode(toElm.lastChild)) {
	        listNode = toElm.lastChild;
	      }
	
	      if (ul === toElm.lastChild) {
	        if (NodeType.isBr(ul.previousSibling)) {
	          dom.remove(ul.previousSibling);
	        }
	      }
	
	      node = toElm.lastChild;
	      if (node && NodeType.isBr(node) && fromElm.hasChildNodes()) {
	        dom.remove(node);
	      }
	
	      if (NodeType.isEmpty(dom, toElm, true)) {
	        dom.$(toElm).empty();
	      }
	
	      moveChildren(dom, fromElm, toElm);
	
	      if (listNode) {
	        toElm.appendChild(listNode);
	      }
	
	      dom.remove(fromElm);
	
	      if (NodeType.isEmpty(dom, ul) && ul !== dom.getRoot()) {
	        dom.remove(ul);
	      }
	    };
	
	    var mergeIntoEmptyLi = function (editor, fromLi, toLi) {
	      editor.dom.$(toLi).empty();
	      mergeLiElements(editor.dom, fromLi, toLi);
	      editor.selection.setCursorLocation(toLi);
	    };
	
	    var mergeForward = function (editor, rng, fromLi, toLi) {
	      var dom = editor.dom;
	
	      if (dom.isEmpty(toLi)) {
	        mergeIntoEmptyLi(editor, fromLi, toLi);
	      } else {
	        var bookmark = Bookmark.createBookmark(rng);
	        mergeLiElements(dom, fromLi, toLi);
	        editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	      }
	    };
	
	    var mergeBackward = function (editor, rng, fromLi, toLi) {
	      var bookmark = Bookmark.createBookmark(rng);
	      mergeLiElements(editor.dom, fromLi, toLi);
	      var resolvedBookmark = Bookmark.resolveBookmark(bookmark);
	      editor.selection.setRng(resolvedBookmark);
	    };
	
	    var backspaceDeleteFromListToListCaret = function (editor, isForward) {
	      var dom = editor.dom, selection = editor.selection;
	      var selectionStartElm = selection.getStart();
	      var root = Selection.getClosestListRootElm(editor, selectionStartElm);
	      var li = dom.getParent(selection.getStart(), 'LI', root);
	      var ul, rng, otherLi;
	
	      if (li) {
	        ul = li.parentNode;
	        if (ul === editor.getBody() && NodeType.isEmpty(dom, ul)) {
	          return true;
	        }
	
	        rng = Range.normalizeRange(selection.getRng(true));
	        otherLi = dom.getParent(findNextCaretContainer(editor, rng, isForward, root), 'LI', root);
	
	        if (otherLi && otherLi !== li) {
	          if (isForward) {
	            mergeForward(editor, rng, otherLi, li);
	          } else {
	            mergeBackward(editor, rng, li, otherLi);
	          }
	
	          return true;
	        } else if (!otherLi) {
	          if (!isForward && ToggleList.removeList(editor, ul.nodeName)) {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    };
	
	    var removeBlock = function (dom, block, root) {
	      var parentBlock = dom.getParent(block.parentNode, dom.isBlock, root);
	
	      dom.remove(block);
	      if (parentBlock && dom.isEmpty(parentBlock)) {
	        dom.remove(parentBlock);
	      }
	    };
	
	    var backspaceDeleteIntoListCaret = function (editor, isForward) {
	      var dom = editor.dom;
	      var selectionStartElm = editor.selection.getStart();
	      var root = Selection.getClosestListRootElm(editor, selectionStartElm);
	      var block = dom.getParent(selectionStartElm, dom.isBlock, root);
	
	      if (block && dom.isEmpty(block)) {
	        var rng = Range.normalizeRange(editor.selection.getRng(true));
	        var otherLi = dom.getParent(findNextCaretContainer(editor, rng, isForward, root), 'LI', root);
	
	        if (otherLi) {
	          editor.undoManager.transact(function () {
	            removeBlock(dom, block, root);
	            ToggleList.mergeWithAdjacentLists(dom, otherLi.parentNode);
	            editor.selection.select(otherLi, true);
	            editor.selection.collapse(isForward);
	          });
	
	          return true;
	        }
	      }
	
	      return false;
	    };
	
	    var backspaceDeleteCaret = function (editor, isForward) {
	      return backspaceDeleteFromListToListCaret(editor, isForward) || backspaceDeleteIntoListCaret(editor, isForward);
	    };
	
	    var backspaceDeleteRange = function (editor) {
	      var selectionStartElm = editor.selection.getStart();
	      var root = Selection.getClosestListRootElm(editor, selectionStartElm);
	      var startListParent = editor.dom.getParent(selectionStartElm, 'LI,DT,DD', root);
	
	      if (startListParent || Selection.getSelectedListItems(editor).length > 0) {
	        editor.undoManager.transact(function () {
	          editor.execCommand('Delete');
	          NormalizeLists.normalizeLists(editor.dom, editor.getBody());
	        });
	
	        return true;
	      }
	
	      return false;
	    };
	
	    var backspaceDelete = function (editor, isForward) {
	      return editor.selection.isCollapsed() ? backspaceDeleteCaret(editor, isForward) : backspaceDeleteRange(editor);
	    };
	
	    var setup = function (editor) {
	      editor.on('keydown', function (e) {
	        if (e.keyCode === VK.BACKSPACE) {
	          if (backspaceDelete(editor, false)) {
	            e.preventDefault();
	          }
	        } else if (e.keyCode === VK.DELETE) {
	          if (backspaceDelete(editor, true)) {
	            e.preventDefault();
	          }
	        }
	      });
	    };
	
	    return {
	      setup: setup,
	      backspaceDelete: backspaceDelete
	    };
	  }
	);
	
	
	/**
	 * Api.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.api.Api',
	  [
	    'tinymce.plugins.lists.core.Delete'
	  ],
	  function (Delete) {
	    var get = function (editor) {
	      return {
	        backspaceDelete: function (isForward) {
	          Delete.backspaceDelete(editor, isForward);
	        }
	      };
	    };
	
	    return {
	      get: get
	    };
	  }
	);
	
	
	/**
	 * Indent.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.actions.Indent',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.plugins.lists.core.Bookmark',
	    'tinymce.plugins.lists.core.NodeType',
	    'tinymce.plugins.lists.core.Selection'
	  ],
	  function (DOMUtils, Bookmark, NodeType, Selection) {
	    var DOM = DOMUtils.DOM;
	
	    var mergeLists = function (from, to) {
	      var node;
	
	      if (NodeType.isListNode(from)) {
	        while ((node = from.firstChild)) {
	          to.appendChild(node);
	        }
	
	        DOM.remove(from);
	      }
	    };
	
	    var indent = function (li) {
	      var sibling, newList, listStyle;
	
	      if (li.nodeName === 'DT') {
	        DOM.rename(li, 'DD');
	        return true;
	      }
	
	      sibling = li.previousSibling;
	
	      if (sibling && NodeType.isListNode(sibling)) {
	        sibling.appendChild(li);
	        return true;
	      }
	
	      if (sibling && sibling.nodeName === 'LI' && NodeType.isListNode(sibling.lastChild)) {
	        sibling.lastChild.appendChild(li);
	        mergeLists(li.lastChild, sibling.lastChild);
	        return true;
	      }
	
	      sibling = li.nextSibling;
	
	      if (sibling && NodeType.isListNode(sibling)) {
	        sibling.insertBefore(li, sibling.firstChild);
	        return true;
	      }
	
	      /*if (sibling && sibling.nodeName === 'LI' && isListNode(li.lastChild)) {
	        return false;
	      }*/
	
	      sibling = li.previousSibling;
	      if (sibling && sibling.nodeName === 'LI') {
	        newList = DOM.create(li.parentNode.nodeName);
	        listStyle = DOM.getStyle(li.parentNode, 'listStyleType');
	        if (listStyle) {
	          DOM.setStyle(newList, 'listStyleType', listStyle);
	        }
	        sibling.appendChild(newList);
	        newList.appendChild(li);
	        mergeLists(li.lastChild, newList);
	        return true;
	      }
	
	      return false;
	    };
	
	    var indentSelection = function (editor) {
	      var listElements = Selection.getSelectedListItems(editor);
	
	      if (listElements.length) {
	        var bookmark = Bookmark.createBookmark(editor.selection.getRng(true));
	
	        for (var i = 0; i < listElements.length; i++) {
	          if (!indent(listElements[i]) && i === 0) {
	            break;
	          }
	        }
	
	        editor.selection.setRng(Bookmark.resolveBookmark(bookmark));
	        editor.nodeChanged();
	
	        return true;
	      }
	    };
	
	    return {
	      indentSelection: indentSelection
	    };
	  }
	);
	
	
	/**
	 * Commands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.api.Commands',
	  [
	    'tinymce.plugins.lists.actions.Indent',
	    'tinymce.plugins.lists.actions.Outdent',
	    'tinymce.plugins.lists.actions.ToggleList'
	  ],
	  function (Indent, Outdent, ToggleList) {
	    var queryListCommandState = function (editor, listName) {
	      return function () {
	        var parentList = editor.dom.getParent(editor.selection.getStart(), 'UL,OL,DL');
	        return parentList && parentList.nodeName === listName;
	      };
	    };
	
	    var register = function (editor) {
	      editor.on('BeforeExecCommand', function (e) {
	        var cmd = e.command.toLowerCase(), isHandled;
	
	        if (cmd === "indent") {
	          if (Indent.indentSelection(editor)) {
	            isHandled = true;
	          }
	        } else if (cmd === "outdent") {
	          if (Outdent.outdentSelection(editor)) {
	            isHandled = true;
	          }
	        }
	
	        if (isHandled) {
	          editor.fire('ExecCommand', { command: e.command });
	          e.preventDefault();
	          return true;
	        }
	      });
	
	      editor.addCommand('InsertUnorderedList', function (ui, detail) {
	        ToggleList.toggleList(editor, 'UL', detail);
	      });
	
	      editor.addCommand('InsertOrderedList', function (ui, detail) {
	        ToggleList.toggleList(editor, 'OL', detail);
	      });
	
	      editor.addCommand('InsertDefinitionList', function (ui, detail) {
	        ToggleList.toggleList(editor, 'DL', detail);
	      });
	
	      editor.addQueryStateHandler('InsertUnorderedList', queryListCommandState(editor, 'UL'));
	      editor.addQueryStateHandler('InsertOrderedList', queryListCommandState(editor, 'OL'));
	      editor.addQueryStateHandler('InsertDefinitionList', queryListCommandState(editor, 'DL'));
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.api.Settings',
	  [
	  ],
	  function () {
	    var shouldIndentOnTab = function (editor) {
	      return editor.getParam('lists_indent_on_tab', true);
	    };
	
	    return {
	      shouldIndentOnTab: shouldIndentOnTab
	    };
	  }
	);
	
	
	/**
	 * Keyboard.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.core.Keyboard',
	  [
	    'tinymce.core.util.VK',
	    'tinymce.plugins.lists.actions.Indent',
	    'tinymce.plugins.lists.actions.Outdent',
	    'tinymce.plugins.lists.api.Settings',
	    'tinymce.plugins.lists.core.Delete'
	  ],
	  function (VK, Indent, Outdent, Settings, Delete) {
	    var setupTabKey = function (editor) {
	      editor.on('keydown', function (e) {
	        // Check for tab but not ctrl/cmd+tab since it switches browser tabs
	        if (e.keyCode !== VK.TAB || VK.metaKeyPressed(e)) {
	          return;
	        }
	
	        if (editor.dom.getParent(editor.selection.getStart(), 'LI,DT,DD')) {
	          e.preventDefault();
	
	          if (e.shiftKey) {
	            Outdent.outdentSelection(editor);
	          } else {
	            Indent.indentSelection(editor);
	          }
	        }
	      });
	    };
	
	    var setup = function (editor) {
	      if (Settings.shouldIndentOnTab(editor)) {
	        setupTabKey(editor);
	      }
	
	      Delete.setup(editor);
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	
	/**
	 * Buttons.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.ui.Buttons',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.lists.core.NodeType',
	    'tinymce.plugins.lists.core.Selection'
	  ],
	  function (Tools, NodeType, Selection) {
	    var findIndex = function (list, predicate) {
	      for (var index = 0; index < list.length; index++) {
	        var element = list[index];
	
	        if (predicate(element)) {
	          return index;
	        }
	      }
	      return -1;
	    };
	    var listState = function (editor, listName) {
	      return function (e) {
	        var ctrl = e.control;
	
	        editor.on('NodeChange', function (e) {
	          var tableCellIndex = findIndex(e.parents, NodeType.isTableCellNode);
	          var parents = tableCellIndex !== -1 ? e.parents.slice(0, tableCellIndex) : e.parents;
	          var lists = Tools.grep(parents, NodeType.isListNode);
	          ctrl.active(lists.length > 0 && lists[0].nodeName === listName);
	        });
	      };
	    };
	
	    var indentPostRender = function (editor) {
	      return function (e) {
	        var ctrl = e.control;
	
	        editor.on('nodechange', function () {
	          var listItemBlocks = Selection.getSelectedListItems(editor);
	          var disable = listItemBlocks.length > 0 && NodeType.isFirstChild(listItemBlocks[0]);
	          ctrl.disabled(disable);
	        });
	      };
	    };
	
	    var register = function (editor) {
	      var hasPlugin = function (editor, plugin) {
	        var plugins = editor.settings.plugins ? editor.settings.plugins : '';
	        return Tools.inArray(plugins.split(/[ ,]/), plugin) !== -1;
	      };
	
	      if (!hasPlugin(editor, 'advlist')) {
	        editor.addButton('numlist', {
	          active: false,
	          title: 'Numbered list',
	          cmd: 'InsertOrderedList',
	          onPostRender: listState(editor, 'OL')
	        });
	
	        editor.addButton('bullist', {
	          active: false,
	          title: 'Bullet list',
	          cmd: 'InsertUnorderedList',
	          onPostRender: listState(editor, 'UL')
	        });
	      }
	
	      editor.addButton('indent', {
	        icon: 'indent',
	        title: 'Increase indent',
	        cmd: 'Indent',
	        onPostRender: indentPostRender(editor)
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.lists.Plugin',
	  [
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.lists.api.Api',
	    'tinymce.plugins.lists.api.Commands',
	    'tinymce.plugins.lists.core.Keyboard',
	    'tinymce.plugins.lists.ui.Buttons'
	  ],
	  function (PluginManager, Api, Commands, Keyboard, Buttons) {
	    PluginManager.add('lists', function (editor) {
	      Keyboard.setup(editor);
	      Buttons.register(editor);
	      Commands.register(editor);
	
	      return Api.get(editor);
	    });
	
	    return function () { };
	  }
	);
	
	
	dem('tinymce.plugins.lists.Plugin')();
	})();


/***/ },
/* 2022 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "paste" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/paste')
	//   ES2015:
	//     import 'tinymce/plugins/paste'
	__webpack_require__(2023);

/***/ },
/* 2023 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.paste.Plugin","ephox.katamari.api.Cell","tinymce.core.PluginManager","tinymce.plugins.paste.alien.DetectProPlugin","tinymce.plugins.paste.api.Api","tinymce.plugins.paste.api.Commands","tinymce.plugins.paste.core.Clipboard","tinymce.plugins.paste.core.CutCopy","tinymce.plugins.paste.core.DragDrop","tinymce.plugins.paste.core.PrePostProcess","tinymce.plugins.paste.core.Quirks","tinymce.plugins.paste.ui.Buttons","global!tinymce.util.Tools.resolve","global!window","tinymce.plugins.paste.core.Actions","global!Image","global!navigator","tinymce.core.Env","tinymce.core.util.Delay","tinymce.core.util.Tools","tinymce.core.util.VK","tinymce.plugins.paste.api.Events","tinymce.plugins.paste.api.Settings","tinymce.plugins.paste.core.InternalHtml","tinymce.plugins.paste.core.Newlines","tinymce.plugins.paste.core.PasteBin","tinymce.plugins.paste.core.ProcessFilters","tinymce.plugins.paste.core.SmartPaste","tinymce.plugins.paste.core.Utils","global!setTimeout","tinymce.core.api.dom.RangeUtils","tinymce.plugins.paste.core.WordFilter","ephox.katamari.api.Fun","tinymce.core.html.Entities","tinymce.core.html.DomParser","tinymce.core.html.Node","tinymce.core.html.Schema","tinymce.core.html.Serializer","global!Array","global!Error"]
	jsc*/
	define(
	  'ephox.katamari.api.Cell',
	
	  [
	  ],
	
	  function () {
	    var Cell = function (initial) {
	      var value = initial;
	
	      var get = function () {
	        return value;
	      };
	
	      var set = function (v) {
	        value = v;
	      };
	
	      var clone = function () {
	        return Cell(get());
	      };
	
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    return Cell;
	  }
	);
	
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	defineGlobal("global!window", window);
	/**
	 * DetectProPlugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.alien.DetectProPlugin',
	  [
	    'global!window',
	    'tinymce.core.PluginManager'
	  ],
	  function (window, PluginManager) {
	    var hasProPlugin = function (editor) {
	      // draw back if power version is requested and registered
	      if (/(^|[ ,])powerpaste([, ]|$)/.test(editor.settings.plugins) && PluginManager.get('powerpaste')) {
	        /*eslint no-console:0 */
	        if (typeof window.console !== "undefined" && window.console.log) {
	          window.console.log("PowerPaste is incompatible with Paste plugin! Remove 'paste' from the 'plugins' option.");
	        }
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    return {
	      hasProPlugin: hasProPlugin
	    };
	  }
	);
	
	/**
	 * Api.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.api.Api',
	  [
	  ],
	  function (Actions) {
	    var get = function (clipboard, quirks) {
	      return {
	        clipboard: clipboard,
	        quirks: quirks
	      };
	    };
	
	    return {
	      get: get
	    };
	  }
	);
	
	/**
	 * Events.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.api.Events',
	  [
	  ],
	  function () {
	    var firePastePreProcess = function (editor, html, internal, isWordHtml) {
	      return editor.fire('PastePreProcess', { content: html, internal: internal, wordContent: isWordHtml });
	    };
	
	    var firePastePostProcess = function (editor, node, internal, isWordHtml) {
	      return editor.fire('PastePostProcess', { node: node, internal: internal, wordContent: isWordHtml });
	    };
	
	    var firePastePlainTextToggle = function (editor, state) {
	      return editor.fire('PastePlainTextToggle', { state: state });
	    };
	
	    var firePaste = function (editor, ieFake) {
	      return editor.fire('paste', { ieFake: ieFake });
	    };
	
	    return {
	      firePastePreProcess: firePastePreProcess,
	      firePastePostProcess: firePastePostProcess,
	      firePastePlainTextToggle: firePastePlainTextToggle,
	      firePaste: firePaste
	    };
	  }
	);
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.api.Settings',
	  [
	  ],
	  function () {
	    var shouldPlainTextInform = function (editor) {
	      return editor.getParam('paste_plaintext_inform', true);
	    };
	
	    var shouldBlockDrop = function (editor) {
	      return editor.getParam('paste_block_drop', false);
	    };
	
	    var shouldPasteDataImages = function (editor) {
	      return editor.getParam('paste_data_images', false);
	    };
	
	    var shouldFilterDrop = function (editor) {
	      return editor.getParam('paste_filter_drop', true);
	    };
	
	    var getPreProcess = function (editor) {
	      return editor.getParam('paste_preprocess');
	    };
	
	    var getPostProcess = function (editor) {
	      return editor.getParam('paste_postprocess');
	    };
	
	    var getWebkitStyles = function (editor) {
	      return editor.getParam('paste_webkit_styles');
	    };
	
	    var shouldRemoveWebKitStyles = function (editor) {
	      return editor.getParam('paste_remove_styles_if_webkit', true);
	    };
	
	    var shouldMergeFormats = function (editor) {
	      return editor.getParam('paste_merge_formats', true);
	    };
	
	    var isSmartPasteEnabled = function (editor) {
	      return editor.getParam('smart_paste', true);
	    };
	
	    var isPasteAsTextEnabled = function (editor) {
	      return editor.getParam('paste_as_text', false);
	    };
	
	    var getRetainStyleProps = function (editor) {
	      return editor.getParam('paste_retain_style_properties');
	    };
	
	    var getWordValidElements = function (editor) {
	      var defaultValidElements = (
	        '-strong/b,-em/i,-u,-span,-p,-ol,-ul,-li,-h1,-h2,-h3,-h4,-h5,-h6,' +
	        '-p/div,-a[href|name],sub,sup,strike,br,del,table[width],tr,' +
	        'td[colspan|rowspan|width],th[colspan|rowspan|width],thead,tfoot,tbody'
	      );
	
	      return editor.getParam('paste_word_valid_elements', defaultValidElements);
	    };
	
	    var shouldConvertWordFakeLists = function (editor) {
	      return editor.getParam('paste_convert_word_fake_lists', true);
	    };
	
	    var shouldUseDefaultFilters = function (editor) {
	      return editor.getParam('paste_enable_default_filters', true);
	    };
	
	    return {
	      shouldPlainTextInform: shouldPlainTextInform,
	      shouldBlockDrop: shouldBlockDrop,
	      shouldPasteDataImages: shouldPasteDataImages,
	      shouldFilterDrop: shouldFilterDrop,
	      getPreProcess: getPreProcess,
	      getPostProcess: getPostProcess,
	      getWebkitStyles: getWebkitStyles,
	      shouldRemoveWebKitStyles: shouldRemoveWebKitStyles,
	      shouldMergeFormats: shouldMergeFormats,
	      isSmartPasteEnabled: isSmartPasteEnabled,
	      isPasteAsTextEnabled: isPasteAsTextEnabled,
	      getRetainStyleProps: getRetainStyleProps,
	      getWordValidElements: getWordValidElements,
	      shouldConvertWordFakeLists: shouldConvertWordFakeLists,
	      shouldUseDefaultFilters: shouldUseDefaultFilters
	    };
	  }
	);
	
	/**
	 * Actions.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.core.Actions',
	  [
	    'tinymce.plugins.paste.api.Events',
	    'tinymce.plugins.paste.api.Settings'
	  ],
	  function (Events, Settings) {
	    var shouldInformUserAboutPlainText = function (editor, userIsInformedState) {
	      return userIsInformedState.get() === false && Settings.shouldPlainTextInform(editor);
	    };
	
	    var displayNotification = function (editor, message) {
	      editor.notificationManager.open({
	        text: editor.translate(message),
	        type: 'info'
	      });
	    };
	
	    var togglePlainTextPaste = function (editor, clipboard, userIsInformedState) {
	      if (clipboard.pasteFormat === "text") {
	        clipboard.pasteFormat = "html";
	        Events.firePastePlainTextToggle(editor, false);
	      } else {
	        clipboard.pasteFormat = "text";
	        Events.firePastePlainTextToggle(editor, true);
	
	        if (shouldInformUserAboutPlainText(editor, userIsInformedState)) {
	          displayNotification(editor, 'Paste is now in plain text mode. Contents will now be pasted as plain text until you toggle this option off.');
	          userIsInformedState.set(true);
	        }
	      }
	
	      editor.focus();
	    };
	
	    return {
	      togglePlainTextPaste: togglePlainTextPaste
	    };
	  }
	);
	/**
	 * Commands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.api.Commands',
	  [
	    'tinymce.plugins.paste.core.Actions'
	  ],
	  function (Actions) {
	    var register = function (editor, clipboard, userIsInformedState) {
	      editor.addCommand('mceTogglePlainTextPaste', function () {
	        Actions.togglePlainTextPaste(editor, clipboard, userIsInformedState);
	      });
	
	      editor.addCommand('mceInsertClipboardContent', function (ui, value) {
	        if (value.content) {
	          clipboard.pasteHtml(value.content, value.internal);
	        }
	
	        if (value.text) {
	          clipboard.pasteText(value.text);
	        }
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	defineGlobal("global!Image", Image);
	defineGlobal("global!navigator", navigator);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.Env',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.Env');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Delay',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Delay');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Tools',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Tools');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.VK',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.VK');
	  }
	);
	
	/**
	 * InternalHtml.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.core.InternalHtml',
	  [
	  ],
	  function () {
	    var internalMimeType = 'x-tinymce/html';
	    var internalMark = '<!-- ' + internalMimeType + ' -->';
	
	    var mark = function (html) {
	      return internalMark + html;
	    };
	
	    var unmark = function (html) {
	      return html.replace(internalMark, '');
	    };
	
	    var isMarked = function (html) {
	      return html.indexOf(internalMark) !== -1;
	    };
	
	    return {
	      mark: mark,
	      unmark: unmark,
	      isMarked: isMarked,
	      internalHtmlMime: function () {
	        return internalMimeType;
	      }
	    };
	  }
	);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.html.Entities',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.html.Entities');
	  }
	);
	
	/**
	 * Newlines.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Newlines class contains utilities to convert newlines (\n or \r\n) tp BRs or to a combination of the specified block element and BRs
	 *
	 * @class tinymce.Newlines
	 * @private
	 */
	define(
	  'tinymce.plugins.paste.core.Newlines',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.core.html.Entities'
	  ],
	  function (Tools, Entities) {
	
	    var isPlainText = function (text) {
	      // so basically any tag that is not one of the "p, div, span, br", or is one of them, but is followed
	      // by some additional characters qualifies the text as not a plain text (having some HTML tags)
	      // <span style="white-space:pre"> and <br /> are added as separate exceptions to the rule
	      return !/<(?:\/?(?!(?:div|p|br|span)>)\w+|(?:(?!(?:span style="white-space:\s?pre;?">)|br\s?\/>))\w+\s[^>]+)>/i.test(text);
	    };
	
	
	    var toBRs = function (text) {
	      return text.replace(/\r?\n/g, '<br>');
	    };
	
	
	    var openContainer = function (rootTag, rootAttrs) {
	      var key, attrs = [];
	      var tag = '<' + rootTag;
	
	      if (typeof rootAttrs === 'object') {
	        for (key in rootAttrs) {
	          if (rootAttrs.hasOwnProperty(key)) {
	            attrs.push(key + '="' + Entities.encodeAllRaw(rootAttrs[key]) + '"');
	          }
	        }
	
	        if (attrs.length) {
	          tag += ' ' + attrs.join(' ');
	        }
	      }
	      return tag + '>';
	    };
	
	
	    var toBlockElements = function (text, rootTag, rootAttrs) {
	      var blocks = text.split(/\n\n/);
	      var tagOpen = openContainer(rootTag, rootAttrs);
	      var tagClose = '</' + rootTag + '>';
	
	      var paragraphs = Tools.map(blocks, function (p) {
	        return p.split(/\n/).join('<br />');
	      });
	
	      var stitch = function (p) {
	        return tagOpen + p + tagClose;
	      };
	
	      return paragraphs.length === 1 ? paragraphs[0] : Tools.map(paragraphs, stitch).join('');
	    };
	
	
	    var convert = function (text, rootTag, rootAttrs) {
	      return rootTag ? toBlockElements(text, rootTag, rootAttrs) : toBRs(text);
	    };
	
	
	    return {
	      isPlainText: isPlainText,
	      convert: convert,
	      toBRs: toBRs,
	      toBlockElements: toBlockElements
	    };
	  }
	);
	/**
	 * PasteBin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * @class tinymce.pasteplugin.PasteBin
	 * @private
	 */
	define(
	  'tinymce.plugins.paste.core.PasteBin',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.core.Env'
	  ],
	  function (Tools, Env) {
	    return function (editor) {
	      var lastRng;
	      var pasteBinDefaultContent = '%MCEPASTEBIN%';
	
	      /**
	       * Creates a paste bin element as close as possible to the current caret location and places the focus inside that element
	       * so that when the real paste event occurs the contents gets inserted into this element
	       * instead of the current editor selection element.
	       */
	      var create = function () {
	        var dom = editor.dom, body = editor.getBody();
	        var viewport = editor.dom.getViewPort(editor.getWin()), scrollTop = viewport.y, top = 20;
	        var pasteBinElm;
	        var scrollContainer;
	
	        lastRng = editor.selection.getRng();
	
	        if (editor.inline) {
	          scrollContainer = editor.selection.getScrollContainer();
	
	          // Can't always rely on scrollTop returning a useful value.
	          // It returns 0 if the browser doesn't support scrollTop for the element or is non-scrollable
	          if (scrollContainer && scrollContainer.scrollTop > 0) {
	            scrollTop = scrollContainer.scrollTop;
	          }
	        }
	
	        /**
	         * Returns the rect of the current caret if the caret is in an empty block before a
	         * BR we insert a temporary invisible character that we get the rect this way we always get a proper rect.
	         *
	         * TODO: This might be useful in core.
	         */
	        function getCaretRect(rng) {
	          var rects, textNode, node, container = rng.startContainer;
	
	          rects = rng.getClientRects();
	          if (rects.length) {
	            return rects[0];
	          }
	
	          if (!rng.collapsed || container.nodeType !== 1) {
	            return;
	          }
	
	          node = container.childNodes[lastRng.startOffset];
	
	          // Skip empty whitespace nodes
	          while (node && node.nodeType === 3 && !node.data.length) {
	            node = node.nextSibling;
	          }
	
	          if (!node) {
	            return;
	          }
	
	          // Check if the location is |<br>
	          // TODO: Might need to expand this to say |<table>
	          if (node.tagName === 'BR') {
	            textNode = dom.doc.createTextNode('\uFEFF');
	            node.parentNode.insertBefore(textNode, node);
	
	            rng = dom.createRng();
	            rng.setStartBefore(textNode);
	            rng.setEndAfter(textNode);
	
	            rects = rng.getClientRects();
	            dom.remove(textNode);
	          }
	
	          if (rects.length) {
	            return rects[0];
	          }
	        }
	
	        // Calculate top cordinate this is needed to avoid scrolling to top of document
	        // We want the paste bin to be as close to the caret as possible to avoid scrolling
	        if (lastRng.getClientRects) {
	          var rect = getCaretRect(lastRng);
	
	          if (rect) {
	            // Client rects gets us closes to the actual
	            // caret location in for example a wrapped paragraph block
	            top = scrollTop + (rect.top - dom.getPos(body).y);
	          } else {
	            top = scrollTop;
	
	            // Check if we can find a closer location by checking the range element
	            var container = lastRng.startContainer;
	            if (container) {
	              if (container.nodeType === 3 && container.parentNode !== body) {
	                container = container.parentNode;
	              }
	
	              if (container.nodeType === 1) {
	                top = dom.getPos(container, scrollContainer || body).y;
	              }
	            }
	          }
	        }
	
	        // Create a pastebin
	        pasteBinElm = editor.dom.add(editor.getBody(), 'div', {
	          id: "mcepastebin",
	          contentEditable: true,
	          "data-mce-bogus": "all",
	          style: 'position: absolute; top: ' + top + 'px; width: 10px; height: 10px; overflow: hidden; opacity: 0'
	        }, pasteBinDefaultContent);
	
	        // Move paste bin out of sight since the controlSelection rect gets displayed otherwise on IE and Gecko
	        if (Env.ie || Env.gecko) {
	          dom.setStyle(pasteBinElm, 'left', dom.getStyle(body, 'direction', true) === 'rtl' ? 0xFFFF : -0xFFFF);
	        }
	
	        // Prevent focus events from bubbeling fixed FocusManager issues
	        dom.bind(pasteBinElm, 'beforedeactivate focusin focusout', function (e) {
	          e.stopPropagation();
	        });
	
	        pasteBinElm.focus();
	        editor.selection.select(pasteBinElm, true);
	      };
	
	      /**
	       * Removes the paste bin if it exists.
	       */
	      var remove = function () {
	        if (getEl()) {
	          var pasteBinClone;
	
	          // WebKit/Blink might clone the div so
	          // lets make sure we remove all clones
	          // TODO: Man o man is this ugly. WebKit is the new IE! Remove this if they ever fix it!
	          while ((pasteBinClone = editor.dom.get('mcepastebin'))) {
	            editor.dom.remove(pasteBinClone);
	            editor.dom.unbind(pasteBinClone);
	          }
	
	          if (lastRng) {
	            editor.selection.setRng(lastRng);
	          }
	        }
	
	        lastRng = null;
	      };
	
	
	      var getEl = function () {
	        return editor.dom.get('mcepastebin');
	      };
	
	      /**
	       * Returns the contents of the paste bin as a HTML string.
	       *
	       * @return {String} Get the contents of the paste bin.
	       */
	      var getHtml = function () {
	        var pasteBinElm, pasteBinClones, i, dirtyWrappers, cleanWrapper;
	
	        // Since WebKit/Chrome might clone the paste bin when pasting
	        // for example: <img style="float: right"> we need to check if any of them contains some useful html.
	        // TODO: Man o man is this ugly. WebKit is the new IE! Remove this if they ever fix it!
	
	        var copyAndRemove = function (toElm, fromElm) {
	          toElm.appendChild(fromElm);
	          editor.dom.remove(fromElm, true); // remove, but keep children
	        };
	
	        // find only top level elements (there might be more nested inside them as well, see TINY-1162)
	        pasteBinClones = Tools.grep(editor.getBody().childNodes, function (elm) {
	          return elm.id === 'mcepastebin';
	        });
	        pasteBinElm = pasteBinClones.shift();
	
	        // if clones were found, move their content into the first bin
	        Tools.each(pasteBinClones, function (pasteBinClone) {
	          copyAndRemove(pasteBinElm, pasteBinClone);
	        });
	
	        // TINY-1162: when copying plain text (from notepad for example) WebKit clones
	        // paste bin (with styles and attributes) and uses it as a default  wrapper for
	        // the chunks of the content, here we cycle over the whole paste bin and replace
	        // those wrappers with a basic div
	        dirtyWrappers = editor.dom.select('div[id=mcepastebin]', pasteBinElm);
	        for (i = dirtyWrappers.length - 1; i >= 0; i--) {
	          cleanWrapper = editor.dom.create('div');
	          pasteBinElm.insertBefore(cleanWrapper, dirtyWrappers[i]);
	          copyAndRemove(cleanWrapper, dirtyWrappers[i]);
	        }
	
	        return pasteBinElm ? pasteBinElm.innerHTML : '';
	      };
	
	
	      var getLastRng = function () {
	        return lastRng;
	      };
	
	
	      var isDefaultContent = function (content) {
	        return content === pasteBinDefaultContent;
	      };
	
	
	      var isPasteBin = function (elm) {
	        return elm && elm.id === 'mcepastebin';
	      };
	
	
	      var isDefault = function () {
	        var pasteBinElm = getEl();
	        return isPasteBin(pasteBinElm) && isDefaultContent(pasteBinElm.innerHTML);
	      };
	
	      return {
	        create: create,
	        remove: remove,
	        getEl: getEl,
	        getHtml: getHtml,
	        getLastRng: getLastRng,
	        isDefault: isDefault,
	        isDefaultContent: isDefaultContent
	      };
	    };
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.html.DomParser',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.html.DomParser');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.html.Node',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.html.Node');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.html.Schema',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.html.Schema');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.html.Serializer',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.html.Serializer');
	  }
	);
	
	/**
	 * Utils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contails various utility functions for the paste plugin.
	 *
	 * @class tinymce.pasteplugin.Utils
	 */
	define(
	  'tinymce.plugins.paste.core.Utils',
	  [
	    'global!navigator',
	    'tinymce.core.html.DomParser',
	    'tinymce.core.html.Schema',
	    'tinymce.core.util.Tools'
	  ],
	  function (navigator, DomParser, Schema, Tools) {
	    function filter(content, items) {
	      Tools.each(items, function (v) {
	        if (v.constructor === RegExp) {
	          content = content.replace(v, '');
	        } else {
	          content = content.replace(v[0], v[1]);
	        }
	      });
	
	      return content;
	    }
	
	    /**
	     * Gets the innerText of the specified element. It will handle edge cases
	     * and works better than textContent on Gecko.
	     *
	     * @param {String} html HTML string to get text from.
	     * @return {String} String of text with line feeds.
	     */
	    function innerText(html) {
	      var schema = new Schema(), domParser = new DomParser({}, schema), text = '';
	      var shortEndedElements = schema.getShortEndedElements();
	      var ignoreElements = Tools.makeMap('script noscript style textarea video audio iframe object', ' ');
	      var blockElements = schema.getBlockElements();
	
	      function walk(node) {
	        var name = node.name, currentNode = node;
	
	        if (name === 'br') {
	          text += '\n';
	          return;
	        }
	
	        // img/input/hr
	        if (shortEndedElements[name]) {
	          text += ' ';
	        }
	
	        // Ingore script, video contents
	        if (ignoreElements[name]) {
	          text += ' ';
	          return;
	        }
	
	        if (node.type === 3) {
	          text += node.value;
	        }
	
	        // Walk all children
	        if (!node.shortEnded) {
	          if ((node = node.firstChild)) {
	            do {
	              walk(node);
	            } while ((node = node.next));
	          }
	        }
	
	        // Add \n or \n\n for blocks or P
	        if (blockElements[name] && currentNode.next) {
	          text += '\n';
	
	          if (name === 'p') {
	            text += '\n';
	          }
	        }
	      }
	
	      html = filter(html, [
	        /<!\[[^\]]+\]>/g // Conditional comments
	      ]);
	
	      walk(domParser.parse(html));
	
	      return text;
	    }
	
	    /**
	     * Trims the specified HTML by removing all WebKit fragments, all elements wrapping the body trailing BR elements etc.
	     *
	     * @param {String} html Html string to trim contents on.
	     * @return {String} Html contents that got trimmed.
	     */
	    function trimHtml(html) {
	      function trimSpaces(all, s1, s2) {
	        // WebKit &nbsp; meant to preserve multiple spaces but instead inserted around all inline tags,
	        // including the spans with inline styles created on paste
	        if (!s1 && !s2) {
	          return ' ';
	        }
	
	        return '\u00a0';
	      }
	
	      html = filter(html, [
	        /^[\s\S]*<body[^>]*>\s*|\s*<\/body[^>]*>[\s\S]*$/ig, // Remove anything but the contents within the BODY element
	        /<!--StartFragment-->|<!--EndFragment-->/g, // Inner fragments (tables from excel on mac)
	        [/( ?)<span class="Apple-converted-space">\u00a0<\/span>( ?)/g, trimSpaces],
	        /<br class="Apple-interchange-newline">/g,
	        /<br>$/i // Trailing BR elements
	      ]);
	
	      return html;
	    }
	
	    // TODO: Should be in some global class
	    function createIdGenerator(prefix) {
	      var count = 0;
	
	      return function () {
	        return prefix + (count++);
	      };
	    }
	
	    var isMsEdge = function () {
	      return navigator.userAgent.indexOf(' Edge/') !== -1;
	    };
	
	    return {
	      filter: filter,
	      innerText: innerText,
	      trimHtml: trimHtml,
	      createIdGenerator: createIdGenerator,
	      isMsEdge: isMsEdge
	    };
	  }
	);
	
	/**
	 * WordFilter.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class parses word HTML into proper TinyMCE markup.
	 *
	 * @class tinymce.pasteplugin.WordFilter
	 * @private
	 */
	define(
	  'tinymce.plugins.paste.core.WordFilter',
	  [
	    'tinymce.core.html.DomParser',
	    'tinymce.core.html.Node',
	    'tinymce.core.html.Schema',
	    'tinymce.core.html.Serializer',
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.paste.api.Settings',
	    'tinymce.plugins.paste.core.Utils'
	  ],
	  function (DomParser, Node, Schema, Serializer, Tools, Settings, Utils) {
	    /**
	     * Checks if the specified content is from any of the following sources: MS Word/Office 365/Google docs.
	     */
	    function isWordContent(content) {
	      return (
	        (/<font face="Times New Roman"|class="?Mso|style="[^"]*\bmso-|style='[^'']*\bmso-|w:WordDocument/i).test(content) ||
	        (/class="OutlineElement/).test(content) ||
	        (/id="?docs\-internal\-guid\-/.test(content))
	      );
	    }
	
	    /**
	     * Checks if the specified text starts with "1. " or "a. " etc.
	     */
	    function isNumericList(text) {
	      var found, patterns;
	
	      patterns = [
	        /^[IVXLMCD]{1,2}\.[ \u00a0]/,  // Roman upper case
	        /^[ivxlmcd]{1,2}\.[ \u00a0]/,  // Roman lower case
	        /^[a-z]{1,2}[\.\)][ \u00a0]/,  // Alphabetical a-z
	        /^[A-Z]{1,2}[\.\)][ \u00a0]/,  // Alphabetical A-Z
	        /^[0-9]+\.[ \u00a0]/,          // Numeric lists
	        /^[\u3007\u4e00\u4e8c\u4e09\u56db\u4e94\u516d\u4e03\u516b\u4e5d]+\.[ \u00a0]/, // Japanese
	        /^[\u58f1\u5f10\u53c2\u56db\u4f0d\u516d\u4e03\u516b\u4e5d\u62fe]+\.[ \u00a0]/  // Chinese
	      ];
	
	      text = text.replace(/^[\u00a0 ]+/, '');
	
	      Tools.each(patterns, function (pattern) {
	        if (pattern.test(text)) {
	          found = true;
	          return false;
	        }
	      });
	
	      return found;
	    }
	
	    function isBulletList(text) {
	      return /^[\s\u00a0]*[\u2022\u00b7\u00a7\u25CF]\s*/.test(text);
	    }
	
	    /**
	     * Converts fake bullet and numbered lists to real semantic OL/UL.
	     *
	     * @param {tinymce.html.Node} node Root node to convert children of.
	     */
	    function convertFakeListsToProperLists(node) {
	      var currentListNode, prevListNode, lastLevel = 1;
	
	      function getText(node) {
	        var txt = '';
	
	        if (node.type === 3) {
	          return node.value;
	        }
	
	        if ((node = node.firstChild)) {
	          do {
	            txt += getText(node);
	          } while ((node = node.next));
	        }
	
	        return txt;
	      }
	
	      function trimListStart(node, regExp) {
	        if (node.type === 3) {
	          if (regExp.test(node.value)) {
	            node.value = node.value.replace(regExp, '');
	            return false;
	          }
	        }
	
	        if ((node = node.firstChild)) {
	          do {
	            if (!trimListStart(node, regExp)) {
	              return false;
	            }
	          } while ((node = node.next));
	        }
	
	        return true;
	      }
	
	      function removeIgnoredNodes(node) {
	        if (node._listIgnore) {
	          node.remove();
	          return;
	        }
	
	        if ((node = node.firstChild)) {
	          do {
	            removeIgnoredNodes(node);
	          } while ((node = node.next));
	        }
	      }
	
	      function convertParagraphToLi(paragraphNode, listName, start) {
	        var level = paragraphNode._listLevel || lastLevel;
	
	        // Handle list nesting
	        if (level !== lastLevel) {
	          if (level < lastLevel) {
	            // Move to parent list
	            if (currentListNode) {
	              currentListNode = currentListNode.parent.parent;
	            }
	          } else {
	            // Create new list
	            prevListNode = currentListNode;
	            currentListNode = null;
	          }
	        }
	
	        if (!currentListNode || currentListNode.name !== listName) {
	          prevListNode = prevListNode || currentListNode;
	          currentListNode = new Node(listName, 1);
	
	          if (start > 1) {
	            currentListNode.attr('start', '' + start);
	          }
	
	          paragraphNode.wrap(currentListNode);
	        } else {
	          currentListNode.append(paragraphNode);
	        }
	
	        paragraphNode.name = 'li';
	
	        // Append list to previous list if it exists
	        if (level > lastLevel && prevListNode) {
	          prevListNode.lastChild.append(currentListNode);
	        }
	
	        lastLevel = level;
	
	        // Remove start of list item "1. " or "&middot; " etc
	        removeIgnoredNodes(paragraphNode);
	        trimListStart(paragraphNode, /^\u00a0+/);
	        trimListStart(paragraphNode, /^\s*([\u2022\u00b7\u00a7\u25CF]|\w+\.)/);
	        trimListStart(paragraphNode, /^\u00a0+/);
	      }
	
	      // Build a list of all root level elements before we start
	      // altering them in the loop below.
	      var elements = [], child = node.firstChild;
	      while (typeof child !== 'undefined' && child !== null) {
	        elements.push(child);
	
	        child = child.walk();
	        if (child !== null) {
	          while (typeof child !== 'undefined' && child.parent !== node) {
	            child = child.walk();
	          }
	        }
	      }
	
	      for (var i = 0; i < elements.length; i++) {
	        node = elements[i];
	
	        if (node.name === 'p' && node.firstChild) {
	          // Find first text node in paragraph
	          var nodeText = getText(node);
	
	          // Detect unordered lists look for bullets
	          if (isBulletList(nodeText)) {
	            convertParagraphToLi(node, 'ul');
	            continue;
	          }
	
	          // Detect ordered lists 1., a. or ixv.
	          if (isNumericList(nodeText)) {
	            // Parse OL start number
	            var matches = /([0-9]+)\./.exec(nodeText);
	            var start = 1;
	            if (matches) {
	              start = parseInt(matches[1], 10);
	            }
	
	            convertParagraphToLi(node, 'ol', start);
	            continue;
	          }
	
	          // Convert paragraphs marked as lists but doesn't look like anything
	          if (node._listLevel) {
	            convertParagraphToLi(node, 'ul', 1);
	            continue;
	          }
	
	          currentListNode = null;
	        } else {
	          // If the root level element isn't a p tag which can be
	          // processed by convertParagraphToLi, it interrupts the
	          // lists, causing a new list to start instead of having
	          // elements from the next list inserted above this tag.
	          prevListNode = currentListNode;
	          currentListNode = null;
	        }
	      }
	    }
	
	    function filterStyles(editor, validStyles, node, styleValue) {
	      var outputStyles = {}, matches, styles = editor.dom.parseStyle(styleValue);
	
	      Tools.each(styles, function (value, name) {
	        // Convert various MS styles to W3C styles
	        switch (name) {
	          case 'mso-list':
	            // Parse out list indent level for lists
	            matches = /\w+ \w+([0-9]+)/i.exec(styleValue);
	            if (matches) {
	              node._listLevel = parseInt(matches[1], 10);
	            }
	
	            // Remove these nodes <span style="mso-list:Ignore">o</span>
	            // Since the span gets removed we mark the text node and the span
	            if (/Ignore/i.test(value) && node.firstChild) {
	              node._listIgnore = true;
	              node.firstChild._listIgnore = true;
	            }
	
	            break;
	
	          case "horiz-align":
	            name = "text-align";
	            break;
	
	          case "vert-align":
	            name = "vertical-align";
	            break;
	
	          case "font-color":
	          case "mso-foreground":
	            name = "color";
	            break;
	
	          case "mso-background":
	          case "mso-highlight":
	            name = "background";
	            break;
	
	          case "font-weight":
	          case "font-style":
	            if (value !== "normal") {
	              outputStyles[name] = value;
	            }
	            return;
	
	          case "mso-element":
	            // Remove track changes code
	            if (/^(comment|comment-list)$/i.test(value)) {
	              node.remove();
	              return;
	            }
	
	            break;
	        }
	
	        if (name.indexOf('mso-comment') === 0) {
	          node.remove();
	          return;
	        }
	
	        // Never allow mso- prefixed names
	        if (name.indexOf('mso-') === 0) {
	          return;
	        }
	
	        // Output only valid styles
	        if (Settings.getRetainStyleProps(editor) === "all" || (validStyles && validStyles[name])) {
	          outputStyles[name] = value;
	        }
	      });
	
	      // Convert bold style to "b" element
	      if (/(bold)/i.test(outputStyles["font-weight"])) {
	        delete outputStyles["font-weight"];
	        node.wrap(new Node("b", 1));
	      }
	
	      // Convert italic style to "i" element
	      if (/(italic)/i.test(outputStyles["font-style"])) {
	        delete outputStyles["font-style"];
	        node.wrap(new Node("i", 1));
	      }
	
	      // Serialize the styles and see if there is something left to keep
	      outputStyles = editor.dom.serializeStyle(outputStyles, node.name);
	      if (outputStyles) {
	        return outputStyles;
	      }
	
	      return null;
	    }
	
	    var filterWordContent = function (editor, content) {
	      var retainStyleProperties, validStyles;
	
	      retainStyleProperties = Settings.getRetainStyleProps(editor);
	      if (retainStyleProperties) {
	        validStyles = Tools.makeMap(retainStyleProperties.split(/[, ]/));
	      }
	
	      // Remove basic Word junk
	      content = Utils.filter(content, [
	        // Remove apple new line markers
	        /<br class="?Apple-interchange-newline"?>/gi,
	
	        // Remove google docs internal guid markers
	        /<b[^>]+id="?docs-internal-[^>]*>/gi,
	
	        // Word comments like conditional comments etc
	        /<!--[\s\S]+?-->/gi,
	
	        // Remove comments, scripts (e.g., msoShowComment), XML tag, VML content,
	        // MS Office namespaced tags, and a few other tags
	        /<(!|script[^>]*>.*?<\/script(?=[>\s])|\/?(\?xml(:\w+)?|img|meta|link|style|\w:\w+)(?=[\s\/>]))[^>]*>/gi,
	
	        // Convert <s> into <strike> for line-though
	        [/<(\/?)s>/gi, "<$1strike>"],
	
	        // Replace nsbp entites to char since it's easier to handle
	        [/&nbsp;/gi, "\u00a0"],
	
	        // Convert <span style="mso-spacerun:yes">___</span> to string of alternating
	        // breaking/non-breaking spaces of same length
	        [/<span\s+style\s*=\s*"\s*mso-spacerun\s*:\s*yes\s*;?\s*"\s*>([\s\u00a0]*)<\/span>/gi,
	          function (str, spaces) {
	            return (spaces.length > 0) ?
	              spaces.replace(/./, " ").slice(Math.floor(spaces.length / 2)).split("").join("\u00a0") : "";
	          }
	        ]
	      ]);
	
	      var validElements = Settings.getWordValidElements(editor);
	
	      // Setup strict schema
	      var schema = new Schema({
	        valid_elements: validElements,
	        valid_children: '-li[p]'
	      });
	
	      // Add style/class attribute to all element rules since the user might have removed them from
	      // paste_word_valid_elements config option and we need to check them for properties
	      Tools.each(schema.elements, function (rule) {
	        /*eslint dot-notation:0*/
	        if (!rule.attributes["class"]) {
	          rule.attributes["class"] = {};
	          rule.attributesOrder.push("class");
	        }
	
	        if (!rule.attributes.style) {
	          rule.attributes.style = {};
	          rule.attributesOrder.push("style");
	        }
	      });
	
	      // Parse HTML into DOM structure
	      var domParser = new DomParser({}, schema);
	
	      // Filter styles to remove "mso" specific styles and convert some of them
	      domParser.addAttributeFilter('style', function (nodes) {
	        var i = nodes.length, node;
	
	        while (i--) {
	          node = nodes[i];
	          node.attr('style', filterStyles(editor, validStyles, node, node.attr('style')));
	
	          // Remove pointess spans
	          if (node.name === 'span' && node.parent && !node.attributes.length) {
	            node.unwrap();
	          }
	        }
	      });
	
	      // Check the class attribute for comments or del items and remove those
	      domParser.addAttributeFilter('class', function (nodes) {
	        var i = nodes.length, node, className;
	
	        while (i--) {
	          node = nodes[i];
	
	          className = node.attr('class');
	          if (/^(MsoCommentReference|MsoCommentText|msoDel)$/i.test(className)) {
	            node.remove();
	          }
	
	          node.attr('class', null);
	        }
	      });
	
	      // Remove all del elements since we don't want the track changes code in the editor
	      domParser.addNodeFilter('del', function (nodes) {
	        var i = nodes.length;
	
	        while (i--) {
	          nodes[i].remove();
	        }
	      });
	
	      // Keep some of the links and anchors
	      domParser.addNodeFilter('a', function (nodes) {
	        var i = nodes.length, node, href, name;
	
	        while (i--) {
	          node = nodes[i];
	          href = node.attr('href');
	          name = node.attr('name');
	
	          if (href && href.indexOf('#_msocom_') !== -1) {
	            node.remove();
	            continue;
	          }
	
	          if (href && href.indexOf('file://') === 0) {
	            href = href.split('#')[1];
	            if (href) {
	              href = '#' + href;
	            }
	          }
	
	          if (!href && !name) {
	            node.unwrap();
	          } else {
	            // Remove all named anchors that aren't specific to TOC, Footnotes or Endnotes
	            if (name && !/^_?(?:toc|edn|ftn)/i.test(name)) {
	              node.unwrap();
	              continue;
	            }
	
	            node.attr({
	              href: href,
	              name: name
	            });
	          }
	        }
	      });
	
	      // Parse into DOM structure
	      var rootNode = domParser.parse(content);
	
	      // Process DOM
	      if (Settings.shouldConvertWordFakeLists(editor)) {
	        convertFakeListsToProperLists(rootNode);
	      }
	
	      // Serialize DOM back to HTML
	      content = new Serializer({
	        validate: editor.settings.validate
	      }, schema).serialize(rootNode);
	
	      return content;
	    };
	
	    var preProcess = function (editor, content) {
	      return Settings.shouldUseDefaultFilters(editor) ? filterWordContent(editor, content) : content;
	    };
	
	    return {
	      preProcess: preProcess,
	      isWordContent: isWordContent
	    };
	  }
	);
	
	/**
	 * ProcessFilters.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.core.ProcessFilters',
	  [
	    'tinymce.plugins.paste.api.Events',
	    'tinymce.plugins.paste.core.WordFilter'
	  ],
	  function (Events, WordFilter) {
	    var processResult = function (content, cancelled) {
	      return { content: content, cancelled: cancelled };
	    };
	
	    var postProcessFilter = function (editor, html, internal, isWordHtml) {
	      var tempBody = editor.dom.create('div', { style: 'display:none' }, html);
	      var postProcessArgs = Events.firePastePostProcess(editor, tempBody, internal, isWordHtml);
	      return processResult(postProcessArgs.node.innerHTML, postProcessArgs.isDefaultPrevented());
	    };
	
	    var filterContent = function (editor, content, internal, isWordHtml) {
	      var preProcessArgs = Events.firePastePreProcess(editor, content, internal, isWordHtml);
	
	      if (editor.hasEventListeners('PastePostProcess') && !preProcessArgs.isDefaultPrevented()) {
	        return postProcessFilter(editor, preProcessArgs.content, internal, isWordHtml);
	      } else {
	        return processResult(preProcessArgs.content, preProcessArgs.isDefaultPrevented());
	      }
	    };
	
	    var process = function (editor, html, internal) {
	      var isWordHtml = WordFilter.isWordContent(html);
	      var content = isWordHtml ? WordFilter.preProcess(editor, html) : html;
	
	      return filterContent(editor, content, internal, isWordHtml);
	    };
	
	    return {
	      process: process
	    };
	  }
	);
	
	/**
	 * SmartPaste.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Tries to be smart depending on what the user pastes if it looks like an url
	 * it will make a link out of the current selection. If it's an image url that looks
	 * like an image it will check if it's an image and insert it as an image.
	 *
	 * @class tinymce.pasteplugin.SmartPaste
	 * @private
	 */
	define(
	  'tinymce.plugins.paste.core.SmartPaste',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.paste.api.Settings'
	  ],
	  function (Tools, Settings) {
	    var isAbsoluteUrl = function (url) {
	      return /^https?:\/\/[\w\?\-\/+=.&%@~#]+$/i.test(url);
	    };
	
	    var isImageUrl = function (url) {
	      return isAbsoluteUrl(url) && /.(gif|jpe?g|png)$/.test(url);
	    };
	
	    var createImage = function (editor, url, pasteHtml) {
	      editor.undoManager.extra(function () {
	        pasteHtml(editor, url);
	      }, function () {
	        editor.insertContent('<img src="' + url + '">');
	      });
	
	      return true;
	    };
	
	    var createLink = function (editor, url, pasteHtml) {
	      editor.undoManager.extra(function () {
	        pasteHtml(editor, url);
	      }, function () {
	        editor.execCommand('mceInsertLink', false, url);
	      });
	
	      return true;
	    };
	
	    var linkSelection = function (editor, html, pasteHtml) {
	      return editor.selection.isCollapsed() === false && isAbsoluteUrl(html) ? createLink(editor, html, pasteHtml) : false;
	    };
	
	    var insertImage = function (editor, html, pasteHtml) {
	      return isImageUrl(html) ? createImage(editor, html, pasteHtml) : false;
	    };
	
	    var pasteHtml = function (editor, html) {
	      editor.insertContent(html, {
	        merge: Settings.shouldMergeFormats(editor),
	        paste: true
	      });
	
	      return true;
	    };
	
	    var smartInsertContent = function (editor, html) {
	      Tools.each([
	        linkSelection,
	        insertImage,
	        pasteHtml
	      ], function (action) {
	        return action(editor, html, pasteHtml) !== true;
	      });
	    };
	
	    var insertContent = function (editor, html) {
	      if (Settings.isSmartPasteEnabled(editor) === false) {
	        pasteHtml(editor, html);
	      } else {
	        smartInsertContent(editor, html);
	      }
	    };
	
	    return {
	      isImageUrl: isImageUrl,
	      isAbsoluteUrl: isAbsoluteUrl,
	      insertContent: insertContent
	    };
	  }
	);
	
	/**
	 * Clipboard.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains logic for getting HTML contents out of the clipboard.
	 *
	 * We need to make a lot of ugly hacks to get the contents out of the clipboard since
	 * the W3C Clipboard API is broken in all browsers that have it: Gecko/WebKit/Blink.
	 * We might rewrite this the way those API:s stabilize. Browsers doesn't handle pasting
	 * from applications like Word the same way as it does when pasting into a contentEditable area
	 * so we need to do lots of extra work to try to get to this clipboard data.
	 *
	 * Current implementation steps:
	 *  1. On keydown with paste keys Ctrl+V or Shift+Insert create
	 *     a paste bin element and move focus to that element.
	 *  2. Wait for the browser to fire a "paste" event and get the contents out of the paste bin.
	 *  3. Check if the paste was successful if true, process the HTML.
	 *  (4). If the paste was unsuccessful use IE execCommand, Clipboard API, document.dataTransfer old WebKit API etc.
	 *
	 * @class tinymce.pasteplugin.Clipboard
	 * @private
	 */
	define(
	  'tinymce.plugins.paste.core.Clipboard',
	  [
	    'global!Image',
	    'global!navigator',
	    'global!window',
	    'tinymce.core.Env',
	    'tinymce.core.util.Delay',
	    'tinymce.core.util.Tools',
	    'tinymce.core.util.VK',
	    'tinymce.plugins.paste.api.Events',
	    'tinymce.plugins.paste.api.Settings',
	    'tinymce.plugins.paste.core.InternalHtml',
	    'tinymce.plugins.paste.core.Newlines',
	    'tinymce.plugins.paste.core.PasteBin',
	    'tinymce.plugins.paste.core.ProcessFilters',
	    'tinymce.plugins.paste.core.SmartPaste',
	    'tinymce.plugins.paste.core.Utils'
	  ],
	  function (Image, navigator, window, Env, Delay, Tools, VK, Events, Settings, InternalHtml, Newlines, PasteBin, ProcessFilters, SmartPaste, Utils) {
	    return function (editor) {
	      var self = this, keyboardPasteTimeStamp = 0;
	      var pasteBin = new PasteBin(editor);
	      var keyboardPastePlainTextState;
	      var mceInternalUrlPrefix = 'data:text/mce-internal,';
	      var uniqueId = Utils.createIdGenerator("mceclip");
	
	      self.pasteFormat = Settings.isPasteAsTextEnabled(editor) ? 'text' : 'html';
	
	      /**
	       * Pastes the specified HTML. This means that the HTML is filtered and then
	       * inserted at the current selection in the editor. It will also fire paste events
	       * for custom user filtering.
	       *
	       * @param {String} html HTML code to paste into the current selection.
	       * @param {Boolean?} internalFlag Optional true/false flag if the contents is internal or external.
	       */
	      function pasteHtml(html, internalFlag) {
	        var internal = internalFlag ? internalFlag : InternalHtml.isMarked(html);
	        var args = ProcessFilters.process(editor, InternalHtml.unmark(html), internal);
	
	        if (args.cancelled === false) {
	          SmartPaste.insertContent(editor, args.content);
	        }
	      }
	
	      /**
	       * Pastes the specified text. This means that the plain text is processed
	       * and converted into BR and P elements. It will fire paste events for custom filtering.
	       *
	       * @param {String} text Text to paste as the current selection location.
	       */
	      function pasteText(text) {
	        text = editor.dom.encode(text).replace(/\r\n/g, '\n');
	        text = Newlines.convert(text, editor.settings.forced_root_block, editor.settings.forced_root_block_attrs);
	
	        pasteHtml(text, false);
	      }
	
	
	      /**
	       * Gets various content types out of a datatransfer object.
	       *
	       * @param {DataTransfer} dataTransfer Event fired on paste.
	       * @return {Object} Object with mime types and data for those mime types.
	       */
	      function getDataTransferItems(dataTransfer) {
	        var items = {};
	
	        if (dataTransfer) {
	          // Use old WebKit/IE API
	          if (dataTransfer.getData) {
	            var legacyText = dataTransfer.getData('Text');
	            if (legacyText && legacyText.length > 0) {
	              if (legacyText.indexOf(mceInternalUrlPrefix) === -1) {
	                items['text/plain'] = legacyText;
	              }
	            }
	          }
	
	          if (dataTransfer.types) {
	            for (var i = 0; i < dataTransfer.types.length; i++) {
	              var contentType = dataTransfer.types[i];
	              try { // IE11 throws exception when contentType is Files (type is present but data cannot be retrieved via getData())
	                items[contentType] = dataTransfer.getData(contentType);
	              } catch (ex) {
	                items[contentType] = ""; // useless in general, but for consistency across browsers
	              }
	            }
	          }
	        }
	
	        return items;
	      }
	
	      /**
	       * Gets various content types out of the Clipboard API. It will also get the
	       * plain text using older IE and WebKit API:s.
	       *
	       * @param {ClipboardEvent} clipboardEvent Event fired on paste.
	       * @return {Object} Object with mime types and data for those mime types.
	       */
	      function getClipboardContent(clipboardEvent) {
	        var content = getDataTransferItems(clipboardEvent.clipboardData || editor.getDoc().dataTransfer);
	
	        // Edge 15 has a broken HTML Clipboard API see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/11877517/
	        return Utils.isMsEdge() ? Tools.extend(content, { 'text/html': '' }) : content;
	      }
	
	      function hasHtmlOrText(content) {
	        return hasContentType(content, 'text/html') || hasContentType(content, 'text/plain');
	      }
	
	      function getBase64FromUri(uri) {
	        var idx;
	
	        idx = uri.indexOf(',');
	        if (idx !== -1) {
	          return uri.substr(idx + 1);
	        }
	
	        return null;
	      }
	
	      function isValidDataUriImage(settings, imgElm) {
	        return settings.images_dataimg_filter ? settings.images_dataimg_filter(imgElm) : true;
	      }
	
	      function extractFilename(str) {
	        var m = str.match(/([\s\S]+?)\.(?:jpeg|jpg|png|gif)$/i);
	        return m ? editor.dom.encode(m[1]) : null;
	      }
	
	      function pasteImage(rng, reader, blob) {
	        if (rng) {
	          editor.selection.setRng(rng);
	          rng = null;
	        }
	
	        var dataUri = reader.result;
	        var base64 = getBase64FromUri(dataUri);
	        var id = uniqueId();
	        var name = editor.settings.images_reuse_filename && blob.name ? extractFilename(blob.name) : id;
	        var img = new Image();
	
	        img.src = dataUri;
	
	        // TODO: Move the bulk of the cache logic to EditorUpload
	        if (isValidDataUriImage(editor.settings, img)) {
	          var blobCache = editor.editorUpload.blobCache;
	          var blobInfo, existingBlobInfo;
	
	          existingBlobInfo = blobCache.findFirst(function (cachedBlobInfo) {
	            return cachedBlobInfo.base64() === base64;
	          });
	
	          if (!existingBlobInfo) {
	            blobInfo = blobCache.create(id, blob, base64, name);
	            blobCache.add(blobInfo);
	          } else {
	            blobInfo = existingBlobInfo;
	          }
	
	          pasteHtml('<img src="' + blobInfo.blobUri() + '">', false);
	        } else {
	          pasteHtml('<img src="' + dataUri + '">', false);
	        }
	      }
	
	      /**
	       * Checks if the clipboard contains image data if it does it will take that data
	       * and convert it into a data url image and paste that image at the caret location.
	       *
	       * @param  {ClipboardEvent} e Paste/drop event object.
	       * @param  {DOMRange} rng Rng object to move selection to.
	       * @return {Boolean} true/false if the image data was found or not.
	       */
	      function pasteImageData(e, rng) {
	        var dataTransfer = e.clipboardData || e.dataTransfer;
	
	        function processItems(items) {
	          var i, item, reader, hadImage = false;
	
	          if (items) {
	            for (i = 0; i < items.length; i++) {
	              item = items[i];
	
	              if (/^image\/(jpeg|png|gif|bmp)$/.test(item.type)) {
	                var blob = item.getAsFile ? item.getAsFile() : item;
	
	                reader = new window.FileReader();
	                reader.onload = pasteImage.bind(null, rng, reader, blob);
	                reader.readAsDataURL(blob);
	
	                e.preventDefault();
	                hadImage = true;
	              }
	            }
	          }
	
	          return hadImage;
	        }
	
	        if (editor.settings.paste_data_images && dataTransfer) {
	          return processItems(dataTransfer.items) || processItems(dataTransfer.files);
	        }
	      }
	
	      /**
	       * Chrome on Android doesn't support proper clipboard access so we have no choice but to allow the browser default behavior.
	       *
	       * @param {Event} e Paste event object to check if it contains any data.
	       * @return {Boolean} true/false if the clipboard is empty or not.
	       */
	      function isBrokenAndroidClipboardEvent(e) {
	        var clipboardData = e.clipboardData;
	
	        return navigator.userAgent.indexOf('Android') !== -1 && clipboardData && clipboardData.items && clipboardData.items.length === 0;
	      }
	
	      function hasContentType(clipboardContent, mimeType) {
	        return mimeType in clipboardContent && clipboardContent[mimeType].length > 0;
	      }
	
	      function isKeyboardPasteEvent(e) {
	        return (VK.metaKeyPressed(e) && e.keyCode === 86) || (e.shiftKey && e.keyCode === 45);
	      }
	
	      function registerEventHandlers() {
	        editor.on('keydown', function (e) {
	          function removePasteBinOnKeyUp(e) {
	            // Ctrl+V or Shift+Insert
	            if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
	              pasteBin.remove();
	            }
	          }
	
	          // Ctrl+V or Shift+Insert
	          if (isKeyboardPasteEvent(e) && !e.isDefaultPrevented()) {
	            keyboardPastePlainTextState = e.shiftKey && e.keyCode === 86;
	
	            // Edge case on Safari on Mac where it doesn't handle Cmd+Shift+V correctly
	            // it fires the keydown but no paste or keyup so we are left with a paste bin
	            if (keyboardPastePlainTextState && Env.webkit && navigator.userAgent.indexOf('Version/') !== -1) {
	              return;
	            }
	
	            // Prevent undoManager keydown handler from making an undo level with the pastebin in it
	            e.stopImmediatePropagation();
	
	            keyboardPasteTimeStamp = new Date().getTime();
	
	            // IE doesn't support Ctrl+Shift+V and it doesn't even produce a paste event
	            // so lets fake a paste event and let IE use the execCommand/dataTransfer methods
	            if (Env.ie && keyboardPastePlainTextState) {
	              e.preventDefault();
	              Events.firePaste(editor, true);
	              return;
	            }
	
	            pasteBin.remove();
	            pasteBin.create();
	
	            // Remove pastebin if we get a keyup and no paste event
	            // For example pasting a file in IE 11 will not produce a paste event
	            editor.once('keyup', removePasteBinOnKeyUp);
	            editor.once('paste', function () {
	              editor.off('keyup', removePasteBinOnKeyUp);
	            });
	          }
	        });
	
	        function insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal) {
	          var content, isPlainTextHtml;
	
	          // Grab HTML from Clipboard API or paste bin as a fallback
	          if (hasContentType(clipboardContent, 'text/html')) {
	            content = clipboardContent['text/html'];
	          } else {
	            content = pasteBin.getHtml();
	            internal = internal ? internal : InternalHtml.isMarked(content);
	
	            // If paste bin is empty try using plain text mode
	            // since that is better than nothing right
	            if (pasteBin.isDefaultContent(content)) {
	              plainTextMode = true;
	            }
	          }
	
	          content = Utils.trimHtml(content);
	
	          pasteBin.remove();
	
	          isPlainTextHtml = (internal === false && Newlines.isPlainText(content));
	
	          // If we got nothing from clipboard API and pastebin or the content is a plain text (with only
	          // some BRs, Ps or DIVs as newlines) then we fallback to plain/text
	          if (!content.length || isPlainTextHtml) {
	            plainTextMode = true;
	          }
	
	          // Grab plain text from Clipboard API or convert existing HTML to plain text
	          if (plainTextMode) {
	            // Use plain text contents from Clipboard API unless the HTML contains paragraphs then
	            // we should convert the HTML to plain text since works better when pasting HTML/Word contents as plain text
	            if (hasContentType(clipboardContent, 'text/plain') && isPlainTextHtml) {
	              content = clipboardContent['text/plain'];
	            } else {
	              content = Utils.innerText(content);
	            }
	          }
	
	          // If the content is the paste bin default HTML then it was
	          // impossible to get the cliboard data out.
	          if (pasteBin.isDefaultContent(content)) {
	            if (!isKeyBoardPaste) {
	              editor.windowManager.alert('Please use Ctrl+V/Cmd+V keyboard shortcuts to paste contents.');
	            }
	
	            return;
	          }
	
	          if (plainTextMode) {
	            pasteText(content);
	          } else {
	            pasteHtml(content, internal);
	          }
	        }
	
	        var getLastRng = function () {
	          return pasteBin.getLastRng() || editor.selection.getRng();
	        };
	
	        editor.on('paste', function (e) {
	          // Getting content from the Clipboard can take some time
	          var clipboardTimer = new Date().getTime();
	          var clipboardContent = getClipboardContent(e);
	          var clipboardDelay = new Date().getTime() - clipboardTimer;
	
	          var isKeyBoardPaste = (new Date().getTime() - keyboardPasteTimeStamp - clipboardDelay) < 1000;
	          var plainTextMode = self.pasteFormat === "text" || keyboardPastePlainTextState;
	          var internal = hasContentType(clipboardContent, InternalHtml.internalHtmlMime());
	
	          keyboardPastePlainTextState = false;
	
	          if (e.isDefaultPrevented() || isBrokenAndroidClipboardEvent(e)) {
	            pasteBin.remove();
	            return;
	          }
	
	          if (!hasHtmlOrText(clipboardContent) && pasteImageData(e, getLastRng())) {
	            pasteBin.remove();
	            return;
	          }
	
	          // Not a keyboard paste prevent default paste and try to grab the clipboard contents using different APIs
	          if (!isKeyBoardPaste) {
	            e.preventDefault();
	          }
	
	          // Try IE only method if paste isn't a keyboard paste
	          if (Env.ie && (!isKeyBoardPaste || e.ieFake) && !hasContentType(clipboardContent, 'text/html')) {
	            pasteBin.create();
	
	            editor.dom.bind(pasteBin.getEl(), 'paste', function (e) {
	              e.stopPropagation();
	            });
	
	            editor.getDoc().execCommand('Paste', false, null);
	            clipboardContent["text/html"] = pasteBin.getHtml();
	          }
	
	          // If clipboard API has HTML then use that directly
	          if (hasContentType(clipboardContent, 'text/html')) {
	            e.preventDefault();
	
	            // if clipboard lacks internal mime type, inspect html for internal markings
	            if (!internal) {
	              internal = InternalHtml.isMarked(clipboardContent['text/html']);
	            }
	
	            insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal);
	          } else {
	            Delay.setEditorTimeout(editor, function () {
	              insertClipboardContent(clipboardContent, isKeyBoardPaste, plainTextMode, internal);
	            }, 0);
	          }
	        });
	      }
	
	      self.pasteHtml = pasteHtml;
	      self.pasteText = pasteText;
	      self.pasteImageData = pasteImageData;
	      self.getDataTransferItems = getDataTransferItems;
	      self.hasHtmlOrText = hasHtmlOrText;
	      self.hasContentType = hasContentType;
	
	      editor.on('preInit', function () {
	        registerEventHandlers();
	
	        // Remove all data images from paste for example from Gecko
	        // except internal images like video elements
	        editor.parser.addNodeFilter('img', function (nodes, name, args) {
	          function isPasteInsert(args) {
	            return args.data && args.data.paste === true;
	          }
	
	          function remove(node) {
	            if (!node.attr('data-mce-object') && src !== Env.transparentSrc) {
	              node.remove();
	            }
	          }
	
	          function isWebKitFakeUrl(src) {
	            return src.indexOf("webkit-fake-url") === 0;
	          }
	
	          function isDataUri(src) {
	            return src.indexOf("data:") === 0;
	          }
	
	          if (!editor.settings.paste_data_images && isPasteInsert(args)) {
	            var i = nodes.length;
	
	            while (i--) {
	              var src = nodes[i].attributes.map.src;
	
	              if (!src) {
	                continue;
	              }
	
	              // Safari on Mac produces webkit-fake-url see: https://bugs.webkit.org/show_bug.cgi?id=49141
	              if (isWebKitFakeUrl(src)) {
	                remove(nodes[i]);
	              } else if (!editor.settings.allow_html_data_urls && isDataUri(src)) {
	                remove(nodes[i]);
	              }
	            }
	          }
	        });
	      });
	    };
	  }
	);
	
	defineGlobal("global!setTimeout", setTimeout);
	/**
	 * CutCopy.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.core.CutCopy',
	  [
	    'global!setTimeout',
	    'tinymce.core.Env',
	    'tinymce.plugins.paste.core.InternalHtml',
	    'tinymce.plugins.paste.core.Utils'
	  ],
	  function (setTimeout, Env, InternalHtml, Utils) {
	    var noop = function () {
	    };
	
	    var hasWorkingClipboardApi = function (clipboardData) {
	      // iOS supports the clipboardData API but it doesn't do anything for cut operations
	      // Edge 15 has a broken HTML Clipboard API see https://developer.microsoft.com/en-us/microsoft-edge/platform/issues/11780845/
	      return Env.iOS === false && clipboardData !== undefined && typeof clipboardData.setData === 'function' && Utils.isMsEdge() !== true;
	    };
	
	    var setHtml5Clipboard = function (clipboardData, html, text) {
	      if (hasWorkingClipboardApi(clipboardData)) {
	        try {
	          clipboardData.clearData();
	          clipboardData.setData('text/html', html);
	          clipboardData.setData('text/plain', text);
	          clipboardData.setData(InternalHtml.internalHtmlMime(), html);
	          return true;
	        } catch (e) {
	          return false;
	        }
	      } else {
	        return false;
	      }
	    };
	
	    var setClipboardData = function (evt, data, fallback, done) {
	      if (setHtml5Clipboard(evt.clipboardData, data.html, data.text)) {
	        evt.preventDefault();
	        done();
	      } else {
	        fallback(data.html, done);
	      }
	    };
	
	    var fallback = function (editor) {
	      return function (html, done) {
	        var markedHtml = InternalHtml.mark(html);
	        var outer = editor.dom.create('div', {
	          contenteditable: "false",
	          "data-mce-bogus": "all"
	        });
	        var inner = editor.dom.create('div', { contenteditable: "true" }, markedHtml);
	        editor.dom.setStyles(outer, {
	          position: 'fixed',
	          left: '-3000px',
	          width: '1000px',
	          overflow: 'hidden'
	        });
	        outer.appendChild(inner);
	        editor.dom.add(editor.getBody(), outer);
	
	        var range = editor.selection.getRng();
	        inner.focus();
	
	        var offscreenRange = editor.dom.createRng();
	        offscreenRange.selectNodeContents(inner);
	        editor.selection.setRng(offscreenRange);
	
	        setTimeout(function () {
	          outer.parentNode.removeChild(outer);
	          editor.selection.setRng(range);
	          done();
	        }, 0);
	      };
	    };
	
	    var getData = function (editor) {
	      return {
	        html: editor.selection.getContent({ contextual: true }),
	        text: editor.selection.getContent({ format: 'text' })
	      };
	    };
	
	    var cut = function (editor) {
	      return function (evt) {
	        if (editor.selection.isCollapsed() === false) {
	          setClipboardData(evt, getData(editor), fallback(editor), function () {
	            // Chrome fails to execCommand from another execCommand with this message:
	            // "We don't execute document.execCommand() this time, because it is called recursively.""
	            setTimeout(function () { // detach
	              editor.execCommand('Delete');
	            }, 0);
	          });
	        }
	      };
	    };
	
	    var copy = function (editor) {
	      return function (evt) {
	        if (editor.selection.isCollapsed() === false) {
	          setClipboardData(evt, getData(editor), fallback(editor), noop);
	        }
	      };
	    };
	
	    var register = function (editor) {
	      editor.on('cut', cut(editor));
	      editor.on('copy', copy(editor));
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.api.dom.RangeUtils',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.RangeUtils');
	  }
	);
	
	/**
	 * DragDrop.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.core.DragDrop',
	  [
	    'tinymce.core.api.dom.RangeUtils',
	    'tinymce.core.util.Delay',
	    'tinymce.plugins.paste.api.Settings',
	    'tinymce.plugins.paste.core.InternalHtml',
	    'tinymce.plugins.paste.core.Utils'
	  ],
	  function (RangeUtils, Delay, Settings, InternalHtml, Utils) {
	    var getCaretRangeFromEvent = function (editor, e) {
	      return RangeUtils.getCaretRangeFromPoint(e.clientX, e.clientY, editor.getDoc());
	    };
	
	    var isPlainTextFileUrl = function (content) {
	      var plainTextContent = content['text/plain'];
	      return plainTextContent ? plainTextContent.indexOf('file://') === 0 : false;
	    };
	
	    var setFocusedRange = function (editor, rng) {
	      editor.focus();
	      editor.selection.setRng(rng);
	    };
	
	    var setup = function (editor, clipboard, draggingInternallyState) {
	      // Block all drag/drop events
	      if (Settings.shouldBlockDrop(editor)) {
	        editor.on('dragend dragover draggesture dragdrop drop drag', function (e) {
	          e.preventDefault();
	          e.stopPropagation();
	        });
	      }
	
	      // Prevent users from dropping data images on Gecko
	      if (!Settings.shouldPasteDataImages(editor)) {
	        editor.on('drop', function (e) {
	          var dataTransfer = e.dataTransfer;
	
	          if (dataTransfer && dataTransfer.files && dataTransfer.files.length > 0) {
	            e.preventDefault();
	          }
	        });
	      }
	
	      editor.on('drop', function (e) {
	        var dropContent, rng;
	
	        rng = getCaretRangeFromEvent(editor, e);
	
	        if (e.isDefaultPrevented() || draggingInternallyState.get()) {
	          return;
	        }
	
	        dropContent = clipboard.getDataTransferItems(e.dataTransfer);
	        var internal = clipboard.hasContentType(dropContent, InternalHtml.internalHtmlMime());
	
	        if ((!clipboard.hasHtmlOrText(dropContent) || isPlainTextFileUrl(dropContent)) && clipboard.pasteImageData(e, rng)) {
	          return;
	        }
	
	        if (rng && Settings.shouldFilterDrop(editor)) {
	          var content = dropContent['mce-internal'] || dropContent['text/html'] || dropContent['text/plain'];
	
	          if (content) {
	            e.preventDefault();
	
	            // FF 45 doesn't paint a caret when dragging in text in due to focus call by execCommand
	            Delay.setEditorTimeout(editor, function () {
	              editor.undoManager.transact(function () {
	                if (dropContent['mce-internal']) {
	                  editor.execCommand('Delete');
	                }
	
	                setFocusedRange(editor, rng);
	
	                content = Utils.trimHtml(content);
	
	                if (!dropContent['text/html']) {
	                  clipboard.pasteText(content);
	                } else {
	                  clipboard.pasteHtml(content, internal);
	                }
	              });
	            });
	          }
	        }
	      });
	
	      editor.on('dragstart', function (e) {
	        draggingInternallyState.set(true);
	      });
	
	      editor.on('dragover dragend', function (e) {
	        if (Settings.shouldPasteDataImages(editor) && draggingInternallyState.get() === false) {
	          e.preventDefault();
	          setFocusedRange(editor, getCaretRangeFromEvent(editor, e));
	        }
	
	        if (e.type === 'dragend') {
	          draggingInternallyState.set(false);
	        }
	      });
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.core.PrePostProcess',
	  [
	    'tinymce.plugins.paste.api.Settings'
	  ],
	  function (Settings) {
	    var setup = function (editor) {
	      var plugin = editor.plugins.paste;
	
	      var preProcess = Settings.getPreProcess(editor);
	      if (preProcess) {
	        editor.on('PastePreProcess', function (e) {
	          preProcess.call(plugin, plugin, e);
	        });
	      }
	
	      var postProcess = Settings.getPostProcess(editor);
	      if (postProcess) {
	        editor.on('PastePostProcess', function (e) {
	          postProcess.call(plugin, plugin, e);
	        });
	      }
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	/**
	 * Quirks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains various fixes for browsers. These issues can not be feature
	 * detected since we have no direct control over the clipboard. However we might be able
	 * to remove some of these fixes once the browsers gets updated/fixed.
	 *
	 * @class tinymce.pasteplugin.Quirks
	 * @private
	 */
	define(
	  'tinymce.plugins.paste.core.Quirks',
	  [
	    'tinymce.core.Env',
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.paste.api.Settings',
	    'tinymce.plugins.paste.core.Utils',
	    'tinymce.plugins.paste.core.WordFilter'
	  ],
	  function (Env, Tools, Settings, Utils, WordFilter) {
	    function addPreProcessFilter(editor, filterFunc) {
	      editor.on('PastePreProcess', function (e) {
	        e.content = filterFunc(editor, e.content, e.internal, e.wordContent);
	      });
	    }
	
	    function addPostProcessFilter(editor, filterFunc) {
	      editor.on('PastePostProcess', function (e) {
	        filterFunc(editor, e.node);
	      });
	    }
	
	    /**
	     * Removes BR elements after block elements. IE9 has a nasty bug where it puts a BR element after each
	     * block element when pasting from word. This removes those elements.
	     *
	     * This:
	     *  <p>a</p><br><p>b</p>
	     *
	     * Becomes:
	     *  <p>a</p><p>b</p>
	     */
	    function removeExplorerBrElementsAfterBlocks(editor, html) {
	      // Only filter word specific content
	      if (!WordFilter.isWordContent(html)) {
	        return html;
	      }
	
	      // Produce block regexp based on the block elements in schema
	      var blockElements = [];
	
	      Tools.each(editor.schema.getBlockElements(), function (block, blockName) {
	        blockElements.push(blockName);
	      });
	
	      var explorerBlocksRegExp = new RegExp(
	        '(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*(<\\/?(' + blockElements.join('|') + ')[^>]*>)(?:<br>&nbsp;[\\s\\r\\n]+|<br>)*',
	        'g'
	      );
	
	      // Remove BR:s from: <BLOCK>X</BLOCK><BR>
	      html = Utils.filter(html, [
	        [explorerBlocksRegExp, '$1']
	      ]);
	
	      // IE9 also adds an extra BR element for each soft-linefeed and it also adds a BR for each word wrap break
	      html = Utils.filter(html, [
	        [/<br><br>/g, '<BR><BR>'], // Replace multiple BR elements with uppercase BR to keep them intact
	        [/<br>/g, ' '],            // Replace single br elements with space since they are word wrap BR:s
	        [/<BR><BR>/g, '<br>']      // Replace back the double brs but into a single BR
	      ]);
	
	      return html;
	    }
	
	    /**
	     * WebKit has a nasty bug where the all computed styles gets added to style attributes when copy/pasting contents.
	     * This fix solves that by simply removing the whole style attribute.
	     *
	     * The paste_webkit_styles option can be set to specify what to keep:
	     *  paste_webkit_styles: "none" // Keep no styles
	     *  paste_webkit_styles: "all", // Keep all of them
	     *  paste_webkit_styles: "font-weight color" // Keep specific ones
	     */
	    function removeWebKitStyles(editor, content, internal, isWordHtml) {
	      // WordFilter has already processed styles at this point and internal doesn't need any processing
	      if (isWordHtml || internal) {
	        return content;
	      }
	
	      // Filter away styles that isn't matching the target node
	      var webKitStyles = Settings.getWebkitStyles(editor);
	
	      if (Settings.shouldRemoveWebKitStyles(editor) === false || webKitStyles === "all") {
	        return content;
	      }
	
	      if (webKitStyles) {
	        webKitStyles = webKitStyles.split(/[, ]/);
	      }
	
	      // Keep specific styles that doesn't match the current node computed style
	      if (webKitStyles) {
	        var dom = editor.dom, node = editor.selection.getNode();
	
	        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, function (all, before, value, after) {
	          var inputStyles = dom.parseStyle(dom.decode(value), 'span');
	          var outputStyles = {};
	
	          if (webKitStyles === "none") {
	            return before + after;
	          }
	
	          for (var i = 0; i < webKitStyles.length; i++) {
	            var inputValue = inputStyles[webKitStyles[i]], currentValue = dom.getStyle(node, webKitStyles[i], true);
	
	            if (/color/.test(webKitStyles[i])) {
	              inputValue = dom.toHex(inputValue);
	              currentValue = dom.toHex(currentValue);
	            }
	
	            if (currentValue !== inputValue) {
	              outputStyles[webKitStyles[i]] = inputValue;
	            }
	          }
	
	          outputStyles = dom.serializeStyle(outputStyles, 'span');
	          if (outputStyles) {
	            return before + ' style="' + outputStyles + '"' + after;
	          }
	
	          return before + after;
	        });
	      } else {
	        // Remove all external styles
	        content = content.replace(/(<[^>]+) style="([^"]*)"([^>]*>)/gi, '$1$3');
	      }
	
	      // Keep internal styles
	      content = content.replace(/(<[^>]+) data-mce-style="([^"]+)"([^>]*>)/gi, function (all, before, value, after) {
	        return before + ' style="' + value + '"' + after;
	      });
	
	      return content;
	    }
	
	    function removeUnderlineAndFontInAnchor(editor, root) {
	      editor.$('a', root).find('font,u').each(function (i, node) {
	        editor.dom.remove(node, true);
	      });
	    }
	
	    var setup = function (editor) {
	      if (Env.webkit) {
	        addPreProcessFilter(editor, removeWebKitStyles);
	      }
	
	      if (Env.ie) {
	        addPreProcessFilter(editor, removeExplorerBrElementsAfterBlocks);
	        addPostProcessFilter(editor, removeUnderlineAndFontInAnchor);
	      }
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	defineGlobal("global!Array", Array);
	defineGlobal("global!Error", Error);
	define(
	  'ephox.katamari.api.Fun',
	
	  [
	    'global!Array',
	    'global!Error'
	  ],
	
	  function (Array, Error) {
	
	    var noop = function () { };
	
	    var noarg = function (f) {
	      return function () {
	        return f();
	      };
	    };
	
	    var compose = function (fa, fb) {
	      return function () {
	        return fa(fb.apply(null, arguments));
	      };
	    };
	
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	
	    var identity = function (x) {
	      return x;
	    };
	
	    var tripleEquals = function(a, b) {
	      return a === b;
	    };
	
	    // Don't use array slice(arguments), makes the whole function unoptimisable on Chrome
	    var curry = function (f) {
	      // equivalent to arguments.slice(1)
	      // starting at 1 because 0 is the f, makes things tricky.
	      // Pay attention to what variable is where, and the -1 magic.
	      // thankfully, we have tests for this.
	      var args = new Array(arguments.length - 1);
	      for (var i = 1; i < arguments.length; i++) args[i-1] = arguments[i];
	
	      return function () {
	        var newArgs = new Array(arguments.length);
	        for (var j = 0; j < newArgs.length; j++) newArgs[j] = arguments[j];
	
	        var all = args.concat(newArgs);
	        return f.apply(null, all);
	      };
	    };
	
	    var not = function (f) {
	      return function () {
	        return !f.apply(null, arguments);
	      };
	    };
	
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	
	    var apply = function (f) {
	      return f();
	    };
	
	    var call = function(f) {
	      f();
	    };
	
	    var never = constant(false);
	    var always = constant(true);
	
	
	    return {
	      noop: noop,
	      noarg: noarg,
	      compose: compose,
	      constant: constant,
	      identity: identity,
	      tripleEquals: tripleEquals,
	      curry: curry,
	      not: not,
	      die: die,
	      apply: apply,
	      call: call,
	      never: never,
	      always: always
	    };
	  }
	);
	
	/**
	 * Buttons.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.ui.Buttons',
	  [
	    'ephox.katamari.api.Fun'
	  ],
	  function (Fun) {
	    var stateChange = function (editor, clipboard, e) {
	      var ctrl = e.control;
	
	      ctrl.active(clipboard.pasteFormat === 'text');
	
	      editor.on('PastePlainTextToggle', function (e) {
	        ctrl.active(e.state);
	      });
	    };
	
	    var register = function (editor, clipboard) {
	      var postRender = Fun.curry(stateChange, editor, clipboard);
	
	      editor.addButton('pastetext', {
	        active: false,
	        icon: 'pastetext',
	        tooltip: 'Paste as text',
	        cmd: 'mceTogglePlainTextPaste',
	        onPostRender: postRender
	      });
	
	      editor.addMenuItem('pastetext', {
	        text: 'Paste as text',
	        selectable: true,
	        active: clipboard.pasteFormat,
	        cmd: 'mceTogglePlainTextPaste',
	        onPostRender: postRender
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.paste.Plugin',
	  [
	    'ephox.katamari.api.Cell',
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.paste.alien.DetectProPlugin',
	    'tinymce.plugins.paste.api.Api',
	    'tinymce.plugins.paste.api.Commands',
	    'tinymce.plugins.paste.core.Clipboard',
	    'tinymce.plugins.paste.core.CutCopy',
	    'tinymce.plugins.paste.core.DragDrop',
	    'tinymce.plugins.paste.core.PrePostProcess',
	    'tinymce.plugins.paste.core.Quirks',
	    'tinymce.plugins.paste.ui.Buttons'
	  ],
	  function (Cell, PluginManager, DetectProPlugin, Api, Commands, Clipboard, CutCopy, DragDrop, PrePostProcess, Quirks, Buttons) {
	    var userIsInformedState = Cell(false);
	
	    PluginManager.add('paste', function (editor) {
	      if (DetectProPlugin.hasProPlugin(editor) === false) {
	        var clipboard = new Clipboard(editor);
	        var quirks = Quirks.setup(editor);
	        var draggingInternallyState = Cell(false);
	
	        Buttons.register(editor, clipboard);
	        Commands.register(editor, clipboard, userIsInformedState);
	        PrePostProcess.setup(editor);
	        CutCopy.register(editor);
	        DragDrop.setup(editor, clipboard, draggingInternallyState);
	
	        return Api.get(clipboard, quirks);
	      }
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.paste.Plugin')();
	})();


/***/ },
/* 2024 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "template" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/template')
	//   ES2015:
	//     import 'tinymce/plugins/template'
	__webpack_require__(2025);

/***/ },
/* 2025 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.template.Plugin","tinymce.core.PluginManager","tinymce.plugins.template.api.Commands","tinymce.plugins.template.core.FilterContent","tinymce.plugins.template.ui.Buttons","global!tinymce.util.Tools.resolve","ephox.katamari.api.Fun","tinymce.plugins.template.core.Templates","tinymce.core.util.Tools","tinymce.plugins.template.api.Settings","tinymce.plugins.template.core.DateTimeHelper","tinymce.plugins.template.ui.Dialog","global!Array","global!Error","tinymce.core.util.XHR","tinymce.core.dom.DOMUtils"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	defineGlobal("global!Array", Array);
	defineGlobal("global!Error", Error);
	define(
	  'ephox.katamari.api.Fun',
	
	  [
	    'global!Array',
	    'global!Error'
	  ],
	
	  function (Array, Error) {
	
	    var noop = function () { };
	
	    var noarg = function (f) {
	      return function () {
	        return f();
	      };
	    };
	
	    var compose = function (fa, fb) {
	      return function () {
	        return fa(fb.apply(null, arguments));
	      };
	    };
	
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	
	    var identity = function (x) {
	      return x;
	    };
	
	    var tripleEquals = function(a, b) {
	      return a === b;
	    };
	
	    // Don't use array slice(arguments), makes the whole function unoptimisable on Chrome
	    var curry = function (f) {
	      // equivalent to arguments.slice(1)
	      // starting at 1 because 0 is the f, makes things tricky.
	      // Pay attention to what variable is where, and the -1 magic.
	      // thankfully, we have tests for this.
	      var args = new Array(arguments.length - 1);
	      for (var i = 1; i < arguments.length; i++) args[i-1] = arguments[i];
	
	      return function () {
	        var newArgs = new Array(arguments.length);
	        for (var j = 0; j < newArgs.length; j++) newArgs[j] = arguments[j];
	
	        var all = args.concat(newArgs);
	        return f.apply(null, all);
	      };
	    };
	
	    var not = function (f) {
	      return function () {
	        return !f.apply(null, arguments);
	      };
	    };
	
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	
	    var apply = function (f) {
	      return f();
	    };
	
	    var call = function(f) {
	      f();
	    };
	
	    var never = constant(false);
	    var always = constant(true);
	
	
	    return {
	      noop: noop,
	      noarg: noarg,
	      compose: compose,
	      constant: constant,
	      identity: identity,
	      tripleEquals: tripleEquals,
	      curry: curry,
	      not: not,
	      die: die,
	      apply: apply,
	      call: call,
	      never: never,
	      always: always
	    };
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Tools',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Tools');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.XHR',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.XHR');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DOMUtils',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.DOMUtils');
	  }
	);
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.template.api.Settings',
	  [
	    'tinymce.core.dom.DOMUtils'
	  ],
	  function (DOMUtils) {
	    var getCreationDateClasses = function (editor) {
	      return editor.getParam('template_cdate_classes', 'cdate');
	    };
	
	    var getModificationDateClasses = function (editor) {
	      return editor.getParam('template_mdate_classes', 'mdate');
	    };
	
	    var getSelectedContentClasses = function (editor) {
	      return editor.getParam('template_selected_content_classes', 'selcontent');
	    };
	
	    var getPreviewReplaceValues = function (editor) {
	      return editor.getParam('template_preview_replace_values');
	    };
	
	    var getTemplateReplaceValues = function (editor) {
	      return editor.getParam('template_replace_values');
	    };
	
	    var getTemplates = function (editorSettings) {
	      return editorSettings.templates;
	    };
	
	    var getCdateFormat = function (editor) {
	      return editor.getParam('template_cdate_format', editor.getLang('template.cdate_format'));
	    };
	
	    var getMdateFormat = function (editor) {
	      return editor.getParam("template_mdate_format", editor.getLang("template.mdate_format"));
	    };
	
	    var getDialogWidth = function (editor) {
	      return editor.getParam('template_popup_width', 600);
	    };
	
	    var getDialogHeight = function (editor) {
	      return Math.min(DOMUtils.DOM.getViewPort().h, editor.getParam('template_popup_height', 500));
	    };
	
	    return {
	      getCreationDateClasses: getCreationDateClasses,
	      getModificationDateClasses: getModificationDateClasses,
	      getSelectedContentClasses: getSelectedContentClasses,
	      getPreviewReplaceValues: getPreviewReplaceValues,
	      getTemplateReplaceValues: getTemplateReplaceValues,
	      getTemplates: getTemplates,
	      getCdateFormat: getCdateFormat,
	      getMdateFormat: getMdateFormat,
	      getDialogWidth: getDialogWidth,
	      getDialogHeight: getDialogHeight
	    };
	  }
	);
	
	
	/**
	 * DateTimeHelper.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.template.core.DateTimeHelper',
	  [
	  ],
	  function () {
	    var addZeros = function (value, len) {
	      value = "" + value;
	
	      if (value.length < len) {
	        for (var i = 0; i < (len - value.length); i++) {
	          value = "0" + value;
	        }
	      }
	
	      return value;
	    };
	
	    var getDateTime = function (editor, fmt, date) {
	      var daysShort = "Sun Mon Tue Wed Thu Fri Sat Sun".split(' ');
	      var daysLong = "Sunday Monday Tuesday Wednesday Thursday Friday Saturday Sunday".split(' ');
	      var monthsShort = "Jan Feb Mar Apr May Jun Jul Aug Sep Oct Nov Dec".split(' ');
	      var monthsLong = "January February March April May June July August September October November December".split(' ');
	
	      date = date || new Date();
	
	      fmt = fmt.replace("%D", "%m/%d/%Y");
	      fmt = fmt.replace("%r", "%I:%M:%S %p");
	      fmt = fmt.replace("%Y", "" + date.getFullYear());
	      fmt = fmt.replace("%y", "" + date.getYear());
	      fmt = fmt.replace("%m", addZeros(date.getMonth() + 1, 2));
	      fmt = fmt.replace("%d", addZeros(date.getDate(), 2));
	      fmt = fmt.replace("%H", "" + addZeros(date.getHours(), 2));
	      fmt = fmt.replace("%M", "" + addZeros(date.getMinutes(), 2));
	      fmt = fmt.replace("%S", "" + addZeros(date.getSeconds(), 2));
	      fmt = fmt.replace("%I", "" + ((date.getHours() + 11) % 12 + 1));
	      fmt = fmt.replace("%p", "" + (date.getHours() < 12 ? "AM" : "PM"));
	      fmt = fmt.replace("%B", "" + editor.translate(monthsLong[date.getMonth()]));
	      fmt = fmt.replace("%b", "" + editor.translate(monthsShort[date.getMonth()]));
	      fmt = fmt.replace("%A", "" + editor.translate(daysLong[date.getDay()]));
	      fmt = fmt.replace("%a", "" + editor.translate(daysShort[date.getDay()]));
	      fmt = fmt.replace("%%", "%");
	
	      return fmt;
	    };
	
	    return {
	      getDateTime: getDateTime
	    };
	  }
	);
	
	/**
	 * Templates.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.template.core.Templates',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.core.util.XHR',
	    'tinymce.plugins.template.api.Settings',
	    'tinymce.plugins.template.core.DateTimeHelper'
	  ],
	  function (Tools, XHR, Settings, DateTimeHelper) {
	    var createTemplateList = function (editorSettings, callback) {
	      return function () {
	        var templateList = Settings.getTemplates(editorSettings);
	
	        if (typeof templateList === 'function') {
	          templateList(callback);
	          return;
	        }
	
	        if (typeof templateList === 'string') {
	          XHR.send({
	            url: templateList,
	            success: function (text) {
	              callback(JSON.parse(text));
	            }
	          });
	        } else {
	          callback(templateList);
	        }
	      };
	    };
	
	    var replaceTemplateValues = function (editor, html, templateValues) {
	      Tools.each(templateValues, function (v, k) {
	        if (typeof v === 'function') {
	          v = v(k);
	        }
	
	        html = html.replace(new RegExp('\\{\\$' + k + '\\}', 'g'), v);
	      });
	
	      return html;
	    };
	
	    var replaceVals = function (editor, e) {
	      var dom = editor.dom, vl = Settings.getTemplateReplaceValues(editor);
	
	      Tools.each(dom.select('*', e), function (e) {
	        Tools.each(vl, function (v, k) {
	          if (dom.hasClass(e, k)) {
	            if (typeof vl[k] === 'function') {
	              vl[k](e);
	            }
	          }
	        });
	      });
	    };
	
	    var hasClass = function (n, c) {
	      return new RegExp('\\b' + c + '\\b', 'g').test(n.className);
	    };
	
	    var insertTemplate = function (editor, ui, html) {
	      var el, n, dom = editor.dom, sel = editor.selection.getContent();
	
	      html = replaceTemplateValues(editor, html, Settings.getTemplateReplaceValues(editor));
	      el = dom.create('div', null, html);
	
	        // Find template element within div
	      n = dom.select('.mceTmpl', el);
	      if (n && n.length > 0) {
	        el = dom.create('div', null);
	        el.appendChild(n[0].cloneNode(true));
	      }
	
	      Tools.each(dom.select('*', el), function (n) {
	        // Replace cdate
	        if (hasClass(n, Settings.getCreationDateClasses(editor).replace(/\s+/g, '|'))) {
	          n.innerHTML = DateTimeHelper.getDateTime(editor, Settings.getCdateFormat(editor));
	        }
	
	        // Replace mdate
	        if (hasClass(n, Settings.getModificationDateClasses(editor).replace(/\s+/g, '|'))) {
	          n.innerHTML = DateTimeHelper.getDateTime(editor, Settings.getMdateFormat(editor));
	        }
	
	        // Replace selection
	        if (hasClass(n, Settings.getSelectedContentClasses(editor).replace(/\s+/g, '|'))) {
	          n.innerHTML = sel;
	        }
	      });
	
	      replaceVals(editor, el);
	
	      editor.execCommand('mceInsertContent', false, el.innerHTML);
	      editor.addVisual();
	    };
	
	    return {
	      createTemplateList: createTemplateList,
	      replaceTemplateValues: replaceTemplateValues,
	      replaceVals: replaceVals,
	      insertTemplate: insertTemplate
	    };
	  }
	);
	
	/**
	 * Commands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.template.api.Commands',
	  [
	    'ephox.katamari.api.Fun',
	    'tinymce.plugins.template.core.Templates'
	  ],
	  function (Fun, Templates) {
	    var register = function (editor) {
	      editor.addCommand('mceInsertTemplate', Fun.curry(Templates.insertTemplate, editor));
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * FilterContent.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.template.core.FilterContent',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.template.api.Settings',
	    'tinymce.plugins.template.core.DateTimeHelper',
	    'tinymce.plugins.template.core.Templates'
	  ],
	  function (Tools, Settings, DateTimeHelper, Templates) {
	    var setup = function (editor) {
	      editor.on('PreProcess', function (o) {
	        var dom = editor.dom, dateFormat = Settings.getMdateFormat(editor);
	
	        Tools.each(dom.select('div', o.node), function (e) {
	          if (dom.hasClass(e, 'mceTmpl')) {
	            Tools.each(dom.select('*', e), function (e) {
	              if (dom.hasClass(e, editor.getParam('template_mdate_classes', 'mdate').replace(/\s+/g, '|'))) {
	                e.innerHTML = DateTimeHelper.getDateTime(editor, dateFormat);
	              }
	            });
	
	            Templates.replaceVals(editor, e);
	          }
	        });
	      });
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	/**
	 * Dialog.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.template.ui.Dialog',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.util.Tools',
	    'tinymce.core.util.XHR',
	    'tinymce.plugins.template.api.Settings',
	    'tinymce.plugins.template.core.Templates'
	  ],
	  function (DOMUtils, Tools, XHR, Settings, Templates) {
	    var insertIframeHtml = function (editor, win, html) {
	      if (html.indexOf('<html>') === -1) {
	        var contentCssLinks = '';
	
	        Tools.each(editor.contentCSS, function (url) {
	          contentCssLinks += '<link type="text/css" rel="stylesheet" href="' +
	                  editor.documentBaseURI.toAbsolute(url) +
	                  '">';
	        });
	
	        var bodyClass = editor.settings.body_class || '';
	        if (bodyClass.indexOf('=') !== -1) {
	          bodyClass = editor.getParam('body_class', '', 'hash');
	          bodyClass = bodyClass[editor.id] || '';
	        }
	
	        html = (
	                '<!DOCTYPE html>' +
	                '<html>' +
	                '<head>' +
	                contentCssLinks +
	                '</head>' +
	                '<body class="' + bodyClass + '">' +
	                html +
	                '</body>' +
	                '</html>'
	              );
	      }
	
	      html = Templates.replaceTemplateValues(editor, html, Settings.getPreviewReplaceValues(editor));
	
	      var doc = win.find('iframe')[0].getEl().contentWindow.document;
	      doc.open();
	      doc.write(html);
	      doc.close();
	    };
	
	    var open = function (editor, templateList) {
	      var win, values = [], templateHtml;
	
	      if (!templateList || templateList.length === 0) {
	        var message = editor.translate('No templates defined.');
	        editor.notificationManager.open({ text: message, type: 'info' });
	        return;
	      }
	
	      Tools.each(templateList, function (template) {
	        values.push({
	          selected: !values.length,
	          text: template.title,
	          value: {
	            url: template.url,
	            content: template.content,
	            description: template.description
	          }
	        });
	      });
	
	      var onSelectTemplate = function (e) {
	        var value = e.control.value();
	
	        if (value.url) {
	          XHR.send({
	            url: value.url,
	            success: function (html) {
	              templateHtml = html;
	              insertIframeHtml(editor, win, templateHtml);
	            }
	          });
	        } else {
	          templateHtml = value.content;
	          insertIframeHtml(editor, win, templateHtml);
	        }
	
	        win.find('#description')[0].text(e.control.value().description);
	      };
	
	      win = editor.windowManager.open({
	        title: 'Insert template',
	        layout: 'flex',
	        direction: 'column',
	        align: 'stretch',
	        padding: 15,
	        spacing: 10,
	        items: [
	          {
	            type: 'form',
	            flex: 0,
	            padding: 0,
	            items: [
	              {
	                type: 'container',
	                label: 'Templates',
	                items: {
	                  type: 'listbox',
	                  label: 'Templates',
	                  name: 'template',
	                  values: values,
	                  onselect: onSelectTemplate
	                }
	              }
	            ]
	          },
	          {
	            type: 'label',
	            name: 'description',
	            label: 'Description',
	            text: '\u00a0'
	          },
	          {
	            type: 'iframe',
	            flex: 1,
	            border: 1
	          }
	        ],
	
	        onsubmit: function () {
	          Templates.insertTemplate(editor, false, templateHtml);
	        },
	
	        minWidth: Settings.getDialogWidth(editor),
	        minHeight: Settings.getDialogHeight(editor)
	      });
	
	      win.find('listbox')[0].fire('select');
	    };
	
	    return {
	      open: open
	    };
	  }
	);
	/**
	 * Buttons.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.template.ui.Buttons',
	  [
	    'tinymce.plugins.template.core.Templates',
	    'tinymce.plugins.template.ui.Dialog'
	  ],
	  function (Templates, Dialog) {
	    var showDialog = function (editor) {
	      return function (templates) {
	        Dialog.open(editor, templates);
	      };
	    };
	
	    var register = function (editor) {
	      editor.addButton('template', {
	        title: 'Insert template',
	        onclick: Templates.createTemplateList(editor.settings, showDialog(editor))
	      });
	
	      editor.addMenuItem('template', {
	        text: 'Template',
	        onclick: Templates.createTemplateList(editor.settings, showDialog(editor)),
	        icon: 'template',
	        context: 'insert'
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.template.Plugin',
	  [
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.template.api.Commands',
	    'tinymce.plugins.template.core.FilterContent',
	    'tinymce.plugins.template.ui.Buttons'
	  ],
	  function (PluginManager, Commands, FilterContent, Buttons) {
	    PluginManager.add('template', function (editor) {
	      Buttons.register(editor);
	      Commands.register(editor);
	      FilterContent.setup(editor);
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.template.Plugin')();
	})();


/***/ },
/* 2026 */
/***/ function(module, exports, __webpack_require__) {

	// Exports the "textcolor" plugin for usage with module loaders
	// Usage:
	//   CommonJS:
	//     require('tinymce/plugins/textcolor')
	//   ES2015:
	//     import 'tinymce/plugins/textcolor'
	__webpack_require__(2027);

/***/ },
/* 2027 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.plugins.textcolor.Plugin","tinymce.core.PluginManager","tinymce.plugins.textcolor.ui.Buttons","global!tinymce.util.Tools.resolve","tinymce.core.dom.DOMUtils","tinymce.core.util.Tools","tinymce.plugins.textcolor.api.Settings","tinymce.plugins.textcolor.core.TextColor","tinymce.plugins.textcolor.ui.ColorPickerHtml","tinymce.core.util.I18n"]
	jsc*/
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.PluginManager');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DOMUtils',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.DOMUtils');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Tools',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Tools');
	  }
	);
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.textcolor.api.Settings',
	  [
	  ],
	  function () {
	    var defaultColorMap = [
	      "000000", "Black",
	      "993300", "Burnt orange",
	      "333300", "Dark olive",
	      "003300", "Dark green",
	      "003366", "Dark azure",
	      "000080", "Navy Blue",
	      "333399", "Indigo",
	      "333333", "Very dark gray",
	      "800000", "Maroon",
	      "FF6600", "Orange",
	      "808000", "Olive",
	      "008000", "Green",
	      "008080", "Teal",
	      "0000FF", "Blue",
	      "666699", "Grayish blue",
	      "808080", "Gray",
	      "FF0000", "Red",
	      "FF9900", "Amber",
	      "99CC00", "Yellow green",
	      "339966", "Sea green",
	      "33CCCC", "Turquoise",
	      "3366FF", "Royal blue",
	      "800080", "Purple",
	      "999999", "Medium gray",
	      "FF00FF", "Magenta",
	      "FFCC00", "Gold",
	      "FFFF00", "Yellow",
	      "00FF00", "Lime",
	      "00FFFF", "Aqua",
	      "00CCFF", "Sky blue",
	      "993366", "Red violet",
	      "FFFFFF", "White",
	      "FF99CC", "Pink",
	      "FFCC99", "Peach",
	      "FFFF99", "Light yellow",
	      "CCFFCC", "Pale green",
	      "CCFFFF", "Pale cyan",
	      "99CCFF", "Light sky blue",
	      "CC99FF", "Plum"
	    ];
	
	    var getTextColorMap = function (editor) {
	      return editor.getParam('textcolor_map', defaultColorMap);
	    };
	
	    var getForeColorMap = function (editor) {
	      return editor.getParam('forecolor_map', getTextColorMap(editor));
	    };
	
	    var getBackColorMap = function (editor) {
	      return editor.getParam('backcolor_map', getTextColorMap(editor));
	    };
	
	    var getTextColorRows = function (editor) {
	      return editor.getParam('textcolor_rows', 5);
	    };
	
	    var getTextColorCols = function (editor) {
	      return editor.getParam('textcolor_cols', 8);
	    };
	
	    var getForeColorRows = function (editor) {
	      return editor.getParam('forecolor_rows', getTextColorRows(editor));
	    };
	
	    var getBackColorRows = function (editor) {
	      return editor.getParam('backcolor_rows', getTextColorRows(editor));
	    };
	
	    var getForeColorCols = function (editor) {
	      return editor.getParam('forecolor_cols', getTextColorCols(editor));
	    };
	
	    var getBackColorCols = function (editor) {
	      return editor.getParam('backcolor_cols', getTextColorCols(editor));
	    };
	
	    var getColorPickerCallback = function (editor) {
	      return editor.getParam('color_picker_callback', null);
	    };
	
	    var hasColorPicker = function (editor) {
	      return typeof getColorPickerCallback(editor) === 'function';
	    };
	
	    return {
	      getForeColorMap: getForeColorMap,
	      getBackColorMap: getBackColorMap,
	      getForeColorRows: getForeColorRows,
	      getBackColorRows: getBackColorRows,
	      getForeColorCols: getForeColorCols,
	      getBackColorCols: getBackColorCols,
	      getColorPickerCallback: getColorPickerCallback,
	      hasColorPicker: hasColorPicker
	    };
	  }
	);
	
	/**
	 * TextColor.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.textcolor.core.TextColor',
	  [
	  ],
	  function () {
	    var getCurrentColor = function (editor, format) {
	      var color;
	
	      editor.dom.getParents(editor.selection.getStart(), function (elm) {
	        var value;
	
	        if ((value = elm.style[format === 'forecolor' ? 'color' : 'background-color'])) {
	          color = value;
	        }
	      });
	
	      return color;
	    };
	
	    var mapColors = function (colorMap) {
	      var i, colors = [];
	
	      for (i = 0; i < colorMap.length; i += 2) {
	        colors.push({
	          text: colorMap[i + 1],
	          color: '#' + colorMap[i]
	        });
	      }
	
	      return colors;
	    };
	
	    var applyFormat = function (editor, format, value) {
	      editor.undoManager.transact(function () {
	        editor.focus();
	        editor.formatter.apply(format, { value: value });
	        editor.nodeChanged();
	      });
	    };
	
	    var removeFormat = function (editor, format) {
	      editor.undoManager.transact(function () {
	        editor.focus();
	        editor.formatter.remove(format, { value: null }, null, true);
	        editor.nodeChanged();
	      });
	    };
	
	    return {
	      getCurrentColor: getCurrentColor,
	      mapColors: mapColors,
	      applyFormat: applyFormat,
	      removeFormat: removeFormat
	    };
	  }
	);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.I18n',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.I18n');
	  }
	);
	
	/**
	 * ColorPickerHtml.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.textcolor.ui.ColorPickerHtml',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.util.I18n',
	    'tinymce.plugins.textcolor.api.Settings',
	    'tinymce.plugins.textcolor.core.TextColor'
	  ],
	  function (DOMUtils, I18n, Settings, TextColor) {
	    var getHtml = function (cols, rows, colorMap, hasColorPicker) {
	      var colors, color, html, last, x, y, i, count = 0, id = DOMUtils.DOM.uniqueId('mcearia');
	
	      var getColorCellHtml = function (color, title) {
	        var isNoColor = color === 'transparent';
	
	        return (
	          '<td class="mce-grid-cell' + (isNoColor ? ' mce-colorbtn-trans' : '') + '">' +
	          '<div id="' + id + '-' + (count++) + '"' +
	          ' data-mce-color="' + (color ? color : '') + '"' +
	          ' role="option"' +
	          ' tabIndex="-1"' +
	          ' style="' + (color ? 'background-color: ' + color : '') + '"' +
	          ' title="' + I18n.translate(title) + '">' +
	          (isNoColor ? '&#215;' : '') +
	          '</div>' +
	          '</td>'
	        );
	      };
	
	      colors = TextColor.mapColors(colorMap);
	      colors.push({
	        text: I18n.translate("No color"),
	        color: "transparent"
	      });
	
	      html = '<table class="mce-grid mce-grid-border mce-colorbutton-grid" role="list" cellspacing="0"><tbody>';
	      last = colors.length - 1;
	
	      for (y = 0; y < rows; y++) {
	        html += '<tr>';
	
	        for (x = 0; x < cols; x++) {
	          i = y * cols + x;
	
	          if (i > last) {
	            html += '<td></td>';
	          } else {
	            color = colors[i];
	            html += getColorCellHtml(color.color, color.text);
	          }
	        }
	
	        html += '</tr>';
	      }
	
	      if (hasColorPicker) {
	        html += (
	          '<tr>' +
	          '<td colspan="' + cols + '" class="mce-custom-color-btn">' +
	          '<div id="' + id + '-c" class="mce-widget mce-btn mce-btn-small mce-btn-flat" ' +
	          'role="button" tabindex="-1" aria-labelledby="' + id + '-c" style="width: 100%">' +
	          '<button type="button" role="presentation" tabindex="-1">' + I18n.translate('Custom...') + '</button>' +
	          '</div>' +
	          '</td>' +
	          '</tr>'
	        );
	
	        html += '<tr>';
	
	        for (x = 0; x < cols; x++) {
	          html += getColorCellHtml('', 'Custom color');
	        }
	
	        html += '</tr>';
	      }
	
	      html += '</tbody></table>';
	
	      return html;
	    };
	
	    return {
	      getHtml: getHtml
	    };
	  }
	);
	/**
	 * Buttons.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.textcolor.ui.Buttons',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.util.Tools',
	    'tinymce.plugins.textcolor.api.Settings',
	    'tinymce.plugins.textcolor.core.TextColor',
	    'tinymce.plugins.textcolor.ui.ColorPickerHtml'
	  ],
	  function (DOMUtils, Tools, Settings, TextColor, ColorPickerHtml) {
	    var setDivColor = function setDivColor(div, value) {
	      div.style.background = value;
	      div.setAttribute('data-mce-color', value);
	    };
	
	    var onButtonClick = function (editor) {
	      return function (e) {
	        var ctrl = e.control;
	
	        if (ctrl._color) {
	          TextColor.applyFormat(editor, ctrl.settings.format, ctrl._color);
	        } else {
	          TextColor.removeFormat(editor, ctrl.settings.format);
	        }
	      };
	    };
	
	    var onPanelClick = function (editor, cols) {
	      return function (e) {
	        var buttonCtrl = this.parent(), value;
	        var currentColor = TextColor.getCurrentColor(editor, buttonCtrl.settings.format);
	
	        var selectColor = function (value) {
	          buttonCtrl.hidePanel();
	          buttonCtrl.color(value);
	          TextColor.applyFormat(editor, buttonCtrl.settings.format, value);
	        };
	
	        var resetColor = function () {
	          buttonCtrl.hidePanel();
	          buttonCtrl.resetColor();
	          TextColor.removeFormat(editor, buttonCtrl.settings.format);
	        };
	
	        if (DOMUtils.DOM.getParent(e.target, '.mce-custom-color-btn')) {
	          buttonCtrl.hidePanel();
	
	          var colorPickerCallback = Settings.getColorPickerCallback(editor);
	
	          colorPickerCallback.call(editor, function (value) {
	            var tableElm = buttonCtrl.panel.getEl().getElementsByTagName('table')[0];
	            var customColorCells, div, i;
	
	            customColorCells = Tools.map(tableElm.rows[tableElm.rows.length - 1].childNodes, function (elm) {
	              return elm.firstChild;
	            });
	
	            for (i = 0; i < customColorCells.length; i++) {
	              div = customColorCells[i];
	              if (!div.getAttribute('data-mce-color')) {
	                break;
	              }
	            }
	
	            // Shift colors to the right
	            // TODO: Might need to be the left on RTL
	            if (i === cols) {
	              for (i = 0; i < cols - 1; i++) {
	                setDivColor(customColorCells[i], customColorCells[i + 1].getAttribute('data-mce-color'));
	              }
	            }
	
	            setDivColor(div, value);
	            selectColor(value);
	          }, currentColor);
	        }
	
	        value = e.target.getAttribute('data-mce-color');
	        if (value) {
	          if (this.lastId) {
	            DOMUtils.DOM.get(this.lastId).setAttribute('aria-selected', false);
	          }
	
	          e.target.setAttribute('aria-selected', true);
	          this.lastId = e.target.id;
	
	          if (value === 'transparent') {
	            resetColor();
	          } else {
	            selectColor(value);
	          }
	        } else if (value !== null) {
	          buttonCtrl.hidePanel();
	        }
	      };
	    };
	
	    var renderColorPicker = function (editor, foreColor) {
	      return function () {
	        var cols = foreColor ? Settings.getForeColorCols(editor) : Settings.getBackColorCols(editor);
	        var rows = foreColor ? Settings.getForeColorRows(editor) : Settings.getBackColorRows(editor);
	        var colorMap = foreColor ? Settings.getForeColorMap(editor) : Settings.getBackColorMap(editor);
	        var hasColorPicker = Settings.hasColorPicker(editor);
	
	        return ColorPickerHtml.getHtml(cols, rows, colorMap, hasColorPicker);
	      };
	    };
	
	    var register = function (editor) {
	      editor.addButton('forecolor', {
	        type: 'colorbutton',
	        tooltip: 'Text color',
	        format: 'forecolor',
	        panel: {
	          role: 'application',
	          ariaRemember: true,
	          html: renderColorPicker(editor, true),
	          onclick: onPanelClick(editor, Settings.getForeColorCols(editor))
	        },
	        onclick: onButtonClick(editor)
	      });
	
	      editor.addButton('backcolor', {
	        type: 'colorbutton',
	        tooltip: 'Background color',
	        format: 'hilitecolor',
	        panel: {
	          role: 'application',
	          ariaRemember: true,
	          html: renderColorPicker(editor, false),
	          onclick: onPanelClick(editor, Settings.getBackColorCols(editor))
	        },
	        onclick: onButtonClick(editor)
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Plugin.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.plugins.textcolor.Plugin',
	  [
	    'tinymce.core.PluginManager',
	    'tinymce.plugins.textcolor.ui.Buttons'
	  ],
	  function (PluginManager, Buttons) {
	    PluginManager.add('textcolor', function (editor) {
	      Buttons.register(editor);
	    });
	
	    return function () { };
	  }
	);
	dem('tinymce.plugins.textcolor.Plugin')();
	})();


/***/ },
/* 2028 */
/***/ function(module, exports) {

	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.themes.modern.Theme","global!window","tinymce.core.ThemeManager","tinymce.themes.modern.api.ThemeApi","tinymce.ui.Api","tinymce.ui.FormatControls","global!tinymce.util.Tools.resolve","tinymce.themes.modern.ui.Render","tinymce.themes.modern.ui.Resize","tinymce.ui.NotificationManagerImpl","tinymce.ui.WindowManagerImpl","tinymce.core.ui.Factory","tinymce.core.util.Tools","tinymce.ui.AbsoluteLayout","tinymce.ui.BrowseButton","tinymce.ui.Button","tinymce.ui.ButtonGroup","tinymce.ui.Checkbox","tinymce.ui.Collection","tinymce.ui.ColorBox","tinymce.ui.ColorButton","tinymce.ui.ColorPicker","tinymce.ui.ComboBox","tinymce.ui.Container","tinymce.ui.Control","tinymce.ui.DragHelper","tinymce.ui.DropZone","tinymce.ui.ElementPath","tinymce.ui.FieldSet","tinymce.ui.FilePicker","tinymce.ui.FitLayout","tinymce.ui.FlexLayout","tinymce.ui.FloatPanel","tinymce.ui.FlowLayout","tinymce.ui.Form","ephox.katamari.api.Fun","ephox.sugar.api.node.Element","ephox.sugar.api.search.SelectorFind","global!document","tinymce.core.EditorManager","tinymce.core.Env","tinymce.ui.Widget","tinymce.ui.editorui.Align","tinymce.ui.editorui.FontSelect","tinymce.ui.editorui.FontSizeSelect","tinymce.ui.editorui.FormatSelect","tinymce.ui.editorui.Formats","tinymce.ui.editorui.InsertButton","tinymce.ui.editorui.SimpleControls","tinymce.ui.editorui.UndoRedo","tinymce.ui.editorui.VisualAid","tinymce.ui.FormItem","tinymce.ui.GridLayout","tinymce.ui.Iframe","tinymce.ui.InfoBox","tinymce.ui.KeyboardNavigation","tinymce.ui.Label","tinymce.ui.Layout","tinymce.ui.ListBox","tinymce.ui.Menu","tinymce.ui.MenuBar","tinymce.ui.MenuButton","tinymce.ui.MenuItem","tinymce.ui.MessageBox","tinymce.ui.Movable","tinymce.ui.Notification","tinymce.ui.Panel","tinymce.ui.PanelButton","tinymce.ui.Path","tinymce.ui.Progress","tinymce.ui.Radio","tinymce.ui.ReflowQueue","tinymce.ui.Resizable","tinymce.ui.ResizeHandle","tinymce.ui.Scrollable","tinymce.ui.SelectBox","tinymce.ui.Selector","tinymce.ui.Slider","tinymce.ui.Spacer","tinymce.ui.SplitButton","tinymce.ui.StackLayout","tinymce.ui.TabPanel","tinymce.ui.TextBox","tinymce.ui.Throbber","tinymce.ui.Toolbar","tinymce.ui.Tooltip","tinymce.ui.Window","tinymce.themes.modern.api.Settings","tinymce.themes.modern.modes.Iframe","tinymce.themes.modern.modes.Inline","tinymce.themes.modern.ui.ProgressState","tinymce.core.dom.DOMUtils","tinymce.themes.modern.api.Events","ephox.katamari.api.Arr","global!setTimeout","tinymce.ui.DomUtils","tinymce.core.dom.DomQuery","tinymce.core.util.Class","tinymce.core.util.EventDispatcher","tinymce.ui.BoxUtils","tinymce.ui.ClassList","tinymce.ui.data.ObservableObject","tinymce.core.util.Delay","global!RegExp","tinymce.core.util.VK","tinymce.core.util.Color","global!Array","global!Error","tinymce.ui.content.LinkTargets","ephox.katamari.api.Option","global!console","ephox.sugar.api.search.PredicateFind","ephox.sugar.api.search.Selectors","ephox.sugar.impl.ClosestOrAncestor","tinymce.ui.editorui.FormatUtils","tinymce.ui.fmt.FontInfo","tinymce.core.util.I18n","tinymce.themes.modern.ui.A11y","tinymce.themes.modern.ui.ContextToolbars","tinymce.themes.modern.ui.Menubar","tinymce.themes.modern.ui.Sidebar","tinymce.themes.modern.ui.SkinLoaded","tinymce.themes.modern.ui.Toolbar","tinymce.ui.data.Binding","tinymce.core.util.Observable","global!Object","global!String","ephox.katamari.api.Id","ephox.sugar.api.search.SelectorFilter","ephox.katamari.api.Type","ephox.sugar.api.node.Body","ephox.sugar.api.dom.Compare","ephox.sugar.api.node.NodeTypes","ephox.sugar.api.node.Node","tinymce.core.geom.Rect","tinymce.themes.modern.alien.UiContainer","global!Date","global!Math","ephox.sugar.api.search.PredicateFilter","ephox.katamari.api.Thunk","ephox.sand.api.Node","ephox.sand.api.PlatformDetection","ephox.sugar.api.search.Traverse","ephox.sand.util.Global","ephox.sand.core.PlatformDetection","global!navigator","ephox.katamari.api.Struct","ephox.sugar.alien.Recurse","ephox.katamari.api.Resolve","ephox.sand.core.Browser","ephox.sand.core.OperatingSystem","ephox.sand.detect.DeviceType","ephox.sand.detect.UaString","ephox.sand.info.PlatformInfo","ephox.katamari.data.Immutable","ephox.katamari.data.MixedBag","ephox.katamari.api.Global","ephox.sand.detect.Version","ephox.katamari.api.Strings","ephox.katamari.api.Obj","ephox.katamari.util.BagUtils","global!Number","ephox.katamari.str.StrAppend","ephox.katamari.str.StringParts"]
	jsc*/
	defineGlobal("global!window", window);
	defineGlobal("global!tinymce.util.Tools.resolve", tinymce.util.Tools.resolve);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.ThemeManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.ThemeManager');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.EditorManager',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.EditorManager');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Tools',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Tools');
	  }
	);
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.api.Settings',
	  [
	    'tinymce.core.EditorManager',
	    'tinymce.core.util.Tools'
	  ],
	  function (EditorManager, Tools) {
	    var isBrandingEnabled = function (editor) {
	      return editor.getParam('branding', true);
	    };
	
	    var hasMenubar = function (editor) {
	      return getMenubar(editor) !== false;
	    };
	
	    var getMenubar = function (editor) {
	      return editor.getParam('menubar');
	    };
	
	    var hasStatusbar = function (editor) {
	      return editor.getParam('statusbar', true);
	    };
	
	    var getToolbarSize = function (editor) {
	      return editor.getParam('toolbar_items_size');
	    };
	
	    var getResize = function (editor) {
	      var resize = editor.getParam('resize', 'vertical');
	      if (resize === false) {
	        return 'none';
	      } else if (resize === 'both') {
	        return 'both';
	      } else {
	        return 'vertical';
	      }
	    };
	
	    var isReadOnly = function (editor) {
	      return editor.getParam('readonly', false);
	    };
	
	    var getFixedToolbarContainer = function (editor) {
	      return editor.getParam('fixed_toolbar_container');
	    };
	
	    var getInlineToolbarPositionHandler = function (editor) {
	      return editor.getParam('inline_toolbar_position_handler');
	    };
	
	    var getMenu = function (editor) {
	      return editor.getParam('menu');
	    };
	
	    var getRemovedMenuItems = function (editor) {
	      return editor.getParam('removed_menuitems', '');
	    };
	
	    var getMinWidth = function (editor) {
	      return editor.getParam('min_width', 100);
	    };
	
	    var getMinHeight = function (editor) {
	      return editor.getParam('min_height', 100);
	    };
	
	    var getMaxWidth = function (editor) {
	      return editor.getParam('max_width', 0xFFFF);
	    };
	
	    var getMaxHeight = function (editor) {
	      return editor.getParam('max_height', 0xFFFF);
	    };
	
	    var getSkinUrl = function (editor) {
	      var settings = editor.settings;
	      var skin = settings.skin;
	      var skinUrl = settings.skin_url;
	
	      if (skin !== false) {
	        var skinName = skin ? skin : 'lightgray';
	
	        if (skinUrl) {
	          skinUrl = editor.documentBaseURI.toAbsolute(skinUrl);
	        } else {
	          skinUrl = EditorManager.baseURL + '/skins/' + skinName;
	        }
	      }
	
	      return skinUrl;
	    };
	
	    var isSkinDisabled = function (editor) {
	      return editor.settings.skin === false;
	    };
	
	    var isInline = function (editor) {
	      return editor.getParam('inline', false);
	    };
	
	    var getIndexedToolbars = function (settings, defaultToolbar) {
	      var toolbars = [];
	
	      // Generate toolbar<n>
	      for (var i = 1; i < 10; i++) {
	        var toolbar = settings['toolbar' + i];
	        if (!toolbar) {
	          break;
	        }
	
	        toolbars.push(toolbar);
	      }
	
	      var mainToolbar = settings.toolbar ? [ settings.toolbar ] : [ defaultToolbar ];
	      return toolbars.length > 0 ? toolbars : mainToolbar;
	    };
	
	    var getToolbars = function (editor) {
	      var toolbar = editor.getParam('toolbar');
	      var defaultToolbar = 'undo redo | styleselect | bold italic | alignleft aligncenter alignright alignjustify | bullist numlist outdent indent | link image';
	
	      if (toolbar === false) {
	        return [];
	      } else if (Tools.isArray(toolbar)) {
	        return Tools.grep(toolbar, function (toolbar) {
	          return toolbar.length > 0;
	        });
	      } else {
	        return getIndexedToolbars(editor.settings, defaultToolbar);
	      }
	    };
	
	    return {
	      isBrandingEnabled: isBrandingEnabled,
	      hasMenubar: hasMenubar,
	      getMenubar: getMenubar,
	      hasStatusbar: hasStatusbar,
	      getToolbarSize: getToolbarSize,
	      getResize: getResize,
	      isReadOnly: isReadOnly,
	      getFixedToolbarContainer: getFixedToolbarContainer,
	      getInlineToolbarPositionHandler: getInlineToolbarPositionHandler,
	      getMenu: getMenu,
	      getRemovedMenuItems: getRemovedMenuItems,
	      getMinWidth: getMinWidth,
	      getMinHeight: getMinHeight,
	      getMaxWidth: getMaxWidth,
	      getMaxHeight: getMaxHeight,
	      getSkinUrl: getSkinUrl,
	      isSkinDisabled: isSkinDisabled,
	      isInline: isInline,
	      getToolbars: getToolbars
	    };
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DOMUtils',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.DOMUtils');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.ui.Factory',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.ui.Factory');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.I18n',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.I18n');
	  }
	);
	
	/**
	 * Events.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.api.Events',
	  [
	  ],
	  function () {
	    var fireSkinLoaded = function (editor) {
	      return editor.fire('SkinLoaded');
	    };
	
	    var fireResizeEditor = function (editor) {
	      return editor.fire('ResizeEditor');
	    };
	
	    var fireBeforeRenderUI = function (editor) {
	      return editor.fire('BeforeRenderUI');
	    };
	
	    return {
	      fireSkinLoaded: fireSkinLoaded,
	      fireResizeEditor: fireResizeEditor,
	      fireBeforeRenderUI: fireBeforeRenderUI
	    };
	  }
	);
	
	/**
	 * A11y.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.ui.A11y',
	  [
	  ],
	  function () {
	    var focus = function (panel, type) {
	      return function () {
	        var item = panel.find(type)[0];
	
	        if (item) {
	          item.focus(true);
	        }
	      };
	    };
	
	    var addKeys = function (editor, panel) {
	      editor.shortcuts.add('Alt+F9', '', focus(panel, 'menubar'));
	      editor.shortcuts.add('Alt+F10,F10', '', focus(panel, 'toolbar'));
	      editor.shortcuts.add('Alt+F11', '', focus(panel, 'elementpath'));
	      panel.on('cancel', function () {
	        editor.focus();
	      });
	    };
	
	    return {
	      addKeys: addKeys
	    };
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.Env',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.Env');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.geom.Rect',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.geom.Rect');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Delay',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Delay');
	  }
	);
	
	defineGlobal("global!Array", Array);
	defineGlobal("global!Error", Error);
	define(
	  'ephox.katamari.api.Fun',
	
	  [
	    'global!Array',
	    'global!Error'
	  ],
	
	  function (Array, Error) {
	
	    var noop = function () { };
	
	    var noarg = function (f) {
	      return function () {
	        return f();
	      };
	    };
	
	    var compose = function (fa, fb) {
	      return function () {
	        return fa(fb.apply(null, arguments));
	      };
	    };
	
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	
	    var identity = function (x) {
	      return x;
	    };
	
	    var tripleEquals = function(a, b) {
	      return a === b;
	    };
	
	    // Don't use array slice(arguments), makes the whole function unoptimisable on Chrome
	    var curry = function (f) {
	      // equivalent to arguments.slice(1)
	      // starting at 1 because 0 is the f, makes things tricky.
	      // Pay attention to what variable is where, and the -1 magic.
	      // thankfully, we have tests for this.
	      var args = new Array(arguments.length - 1);
	      for (var i = 1; i < arguments.length; i++) args[i-1] = arguments[i];
	
	      return function () {
	        var newArgs = new Array(arguments.length);
	        for (var j = 0; j < newArgs.length; j++) newArgs[j] = arguments[j];
	
	        var all = args.concat(newArgs);
	        return f.apply(null, all);
	      };
	    };
	
	    var not = function (f) {
	      return function () {
	        return !f.apply(null, arguments);
	      };
	    };
	
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	
	    var apply = function (f) {
	      return f();
	    };
	
	    var call = function(f) {
	      f();
	    };
	
	    var never = constant(false);
	    var always = constant(true);
	
	
	    return {
	      noop: noop,
	      noarg: noarg,
	      compose: compose,
	      constant: constant,
	      identity: identity,
	      tripleEquals: tripleEquals,
	      curry: curry,
	      not: not,
	      die: die,
	      apply: apply,
	      call: call,
	      never: never,
	      always: always
	    };
	  }
	);
	
	defineGlobal("global!Object", Object);
	define(
	  'ephox.katamari.api.Option',
	
	  [
	    'ephox.katamari.api.Fun',
	    'global!Object'
	  ],
	
	  function (Fun, Object) {
	
	    var never = Fun.never;
	    var always = Fun.always;
	
	    /**
	      Option objects support the following methods:
	
	      fold :: this Option a -> ((() -> b, a -> b)) -> Option b
	
	      is :: this Option a -> a -> Boolean
	
	      isSome :: this Option a -> () -> Boolean
	
	      isNone :: this Option a -> () -> Boolean
	
	      getOr :: this Option a -> a -> a
	
	      getOrThunk :: this Option a -> (() -> a) -> a
	
	      getOrDie :: this Option a -> String -> a
	
	      or :: this Option a -> Option a -> Option a
	        - if some: return self
	        - if none: return opt
	
	      orThunk :: this Option a -> (() -> Option a) -> Option a
	        - Same as "or", but uses a thunk instead of a value
	
	      map :: this Option a -> (a -> b) -> Option b
	        - "fmap" operation on the Option Functor.
	        - same as 'each'
	
	      ap :: this Option a -> Option (a -> b) -> Option b
	        - "apply" operation on the Option Apply/Applicative.
	        - Equivalent to <*> in Haskell/PureScript.
	
	      each :: this Option a -> (a -> b) -> undefined
	        - similar to 'map', but doesn't return a value.
	        - intended for clarity when performing side effects.
	
	      bind :: this Option a -> (a -> Option b) -> Option b
	        - "bind"/"flatMap" operation on the Option Bind/Monad.
	        - Equivalent to >>= in Haskell/PureScript; flatMap in Scala.
	
	      flatten :: {this Option (Option a))} -> () -> Option a
	        - "flatten"/"join" operation on the Option Monad.
	
	      exists :: this Option a -> (a -> Boolean) -> Boolean
	
	      forall :: this Option a -> (a -> Boolean) -> Boolean
	
	      filter :: this Option a -> (a -> Boolean) -> Option a
	
	      equals :: this Option a -> Option a -> Boolean
	
	      equals_ :: this Option a -> (Option a, a -> Boolean) -> Boolean
	
	      toArray :: this Option a -> () -> [a]
	
	    */
	
	    var none = function () { return NONE; };
	
	    var NONE = (function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	
	      // inlined from peanut, maybe a micro-optimisation?
	      var call = function (thunk) { return thunk(); };
	      var id = function (n) { return n; };
	      var noop = function () { };
	
	      var me = {
	        fold: function (n, s) { return n(); },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        or: id,
	        orThunk: call,
	        map: none,
	        ap: none,
	        each: noop,
	        bind: none,
	        flatten: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () { return []; },
	        toString: Fun.constant("none()")
	      };
	      if (Object.freeze) Object.freeze(me);
	      return me;
	    })();
	
	
	    /** some :: a -> Option a */
	    var some = function (a) {
	
	      // inlined from peanut, maybe a micro-optimisation?
	      var constant_a = function () { return a; };
	
	      var self = function () {
	        // can't Fun.constant this one
	        return me;
	      };
	
	      var map = function (f) {
	        return some(f(a));
	      };
	
	      var bind = function (f) {
	        return f(a);
	      };
	
	      var me = {
	        fold: function (n, s) { return s(a); },
	        is: function (v) { return a === v; },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        or: self,
	        orThunk: self,
	        map: map,
	        ap: function (optfab) {
	          return optfab.fold(none, function(fab) {
	            return some(fab(a));
	          });
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        flatten: constant_a,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(
	            never,
	            function (b) { return elementEq(a, b); }
	          );
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	
	    /** from :: undefined|null|a -> Option a */
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	
	    return {
	      some: some,
	      none: none,
	      from: from
	    };
	  }
	);
	
	/**
	 * UiContainer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.alien.UiContainer',
	  [
	    'ephox.katamari.api.Option',
	    'tinymce.core.Env',
	    'tinymce.core.dom.DOMUtils'
	  ],
	  function (Option, Env, DOMUtils) {
	    var getUiContainerDelta = function () {
	      var uiContainer = Env.container;
	      if (uiContainer && DOMUtils.DOM.getStyle(uiContainer, 'position', true) !== 'static') {
	        var containerPos = DOMUtils.DOM.getPos(uiContainer);
	        var dx = uiContainer.scrollLeft - containerPos.x;
	        var dy = uiContainer.scrollTop - containerPos.y;
	        return Option.some({
	          x: dx,
	          y: dy
	        });
	      } else {
	        return Option.none();
	      }
	    };
	
	    return {
	      getUiContainerDelta: getUiContainerDelta
	    };
	  }
	);
	
	/**
	 * Toolbar.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.ui.Toolbar',
	  [
	    'tinymce.core.ui.Factory',
	    'tinymce.core.util.Tools',
	    'tinymce.themes.modern.api.Settings'
	  ],
	  function (Factory, Tools, Settings) {
	    var createToolbar = function (editor, items, size) {
	      var toolbarItems = [], buttonGroup;
	
	      if (!items) {
	        return;
	      }
	
	      Tools.each(items.split(/[ ,]/), function (item) {
	        var itemName;
	
	        var bindSelectorChanged = function () {
	          var selection = editor.selection;
	
	          if (item.settings.stateSelector) {
	            selection.selectorChanged(item.settings.stateSelector, function (state) {
	              item.active(state);
	            }, true);
	          }
	
	          if (item.settings.disabledStateSelector) {
	            selection.selectorChanged(item.settings.disabledStateSelector, function (state) {
	              item.disabled(state);
	            });
	          }
	        };
	
	        if (item === "|") {
	          buttonGroup = null;
	        } else {
	          if (!buttonGroup) {
	            buttonGroup = { type: 'buttongroup', items: [] };
	            toolbarItems.push(buttonGroup);
	          }
	
	          if (editor.buttons[item]) {
	            // TODO: Move control creation to some UI class
	            itemName = item;
	            item = editor.buttons[itemName];
	
	            if (typeof item === "function") {
	              item = item();
	            }
	
	            item.type = item.type || 'button';
	            item.size = size;
	
	            item = Factory.create(item);
	            buttonGroup.items.push(item);
	
	            if (editor.initialized) {
	              bindSelectorChanged();
	            } else {
	              editor.on('init', bindSelectorChanged);
	            }
	          }
	        }
	      });
	
	      return {
	        type: 'toolbar',
	        layout: 'flow',
	        items: toolbarItems
	      };
	    };
	
	    /**
	     * Creates the toolbars from config and returns a toolbar array.
	     *
	     * @param {String} size Optional toolbar item size.
	     * @return {Array} Array with toolbars.
	     */
	    var createToolbars = function (editor, size) {
	      var toolbars = [];
	
	      var addToolbar = function (items) {
	        if (items) {
	          toolbars.push(createToolbar(editor, items, size));
	        }
	      };
	
	      Tools.each(Settings.getToolbars(editor), function (toolbar) {
	        addToolbar(toolbar);
	      });
	
	      if (toolbars.length) {
	        return {
	          type: 'panel',
	          layout: 'stack',
	          classes: "toolbar-grp",
	          ariaRoot: true,
	          ariaRemember: true,
	          items: toolbars
	        };
	      }
	    };
	
	    return {
	      createToolbar: createToolbar,
	      createToolbars: createToolbars
	    };
	  }
	);
	
	/**
	 * ContextToolbars.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.ui.ContextToolbars',
	  [
	    'tinymce.core.Env',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.geom.Rect',
	    'tinymce.core.ui.Factory',
	    'tinymce.core.util.Delay',
	    'tinymce.core.util.Tools',
	    'tinymce.themes.modern.alien.UiContainer',
	    'tinymce.themes.modern.api.Settings',
	    'tinymce.themes.modern.ui.Toolbar'
	  ],
	  function (Env, DOMUtils, Rect, Factory, Delay, Tools, UiContainer, Settings, Toolbar) {
	    var DOM = DOMUtils.DOM;
	
	    var toClientRect = function (geomRect) {
	      return {
	        left: geomRect.x,
	        top: geomRect.y,
	        width: geomRect.w,
	        height: geomRect.h,
	        right: geomRect.x + geomRect.w,
	        bottom: geomRect.y + geomRect.h
	      };
	    };
	
	    var hideAllFloatingPanels = function (editor) {
	      Tools.each(editor.contextToolbars, function (toolbar) {
	        if (toolbar.panel) {
	          toolbar.panel.hide();
	        }
	      });
	    };
	
	    var movePanelTo = function (panel, pos) {
	      panel.moveTo(pos.left, pos.top);
	    };
	
	    var togglePositionClass = function (panel, relPos, predicate) {
	      relPos = relPos ? relPos.substr(0, 2) : '';
	
	      Tools.each({
	        t: 'down',
	        b: 'up'
	      }, function (cls, pos) {
	        panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(0, 1)));
	      });
	
	      Tools.each({
	        l: 'left',
	        r: 'right'
	      }, function (cls, pos) {
	        panel.classes.toggle('arrow-' + cls, predicate(pos, relPos.substr(1, 1)));
	      });
	    };
	
	    var userConstrain = function (handler, x, y, elementRect, contentAreaRect, panelRect) {
	      panelRect = toClientRect({ x: x, y: y, w: panelRect.w, h: panelRect.h });
	
	      if (handler) {
	        panelRect = handler({
	          elementRect: toClientRect(elementRect),
	          contentAreaRect: toClientRect(contentAreaRect),
	          panelRect: panelRect
	        });
	      }
	
	      return panelRect;
	    };
	
	    var addContextualToolbars = function (editor) {
	      var scrollContainer;
	
	      var getContextToolbars = function () {
	        return editor.contextToolbars || [];
	      };
	
	      var getElementRect = function (elm) {
	        var pos, targetRect, root;
	
	        pos = DOM.getPos(editor.getContentAreaContainer());
	        targetRect = editor.dom.getRect(elm);
	        root = editor.dom.getRoot();
	
	        // Adjust targetPos for scrolling in the editor
	        if (root.nodeName === 'BODY') {
	          targetRect.x -= root.ownerDocument.documentElement.scrollLeft || root.scrollLeft;
	          targetRect.y -= root.ownerDocument.documentElement.scrollTop || root.scrollTop;
	        }
	
	        targetRect.x += pos.x;
	        targetRect.y += pos.y;
	
	        return targetRect;
	      };
	
	      var reposition = function (match, shouldShow) {
	        var relPos, panelRect, elementRect, contentAreaRect, panel, relRect, testPositions, smallElementWidthThreshold;
	        var handler = Settings.getInlineToolbarPositionHandler(editor);
	
	        if (editor.removed) {
	          return;
	        }
	
	        if (!match || !match.toolbar.panel) {
	          hideAllFloatingPanels(editor);
	          return;
	        }
	
	        testPositions = [
	          'bc-tc', 'tc-bc',
	          'tl-bl', 'bl-tl',
	          'tr-br', 'br-tr'
	        ];
	
	        panel = match.toolbar.panel;
	
	        // Only show the panel on some events not for example nodeChange since that fires when context menu is opened
	        if (shouldShow) {
	          panel.show();
	        }
	
	        elementRect = getElementRect(match.element);
	        panelRect = DOM.getRect(panel.getEl());
	        contentAreaRect = DOM.getRect(editor.getContentAreaContainer() || editor.getBody());
	
	        var delta = UiContainer.getUiContainerDelta().getOr({ x: 0, y: 0 });
	        elementRect.x += delta.x;
	        elementRect.y += delta.y;
	        panelRect.x += delta.x;
	        panelRect.y += delta.y;
	        contentAreaRect.x += delta.x;
	        contentAreaRect.y += delta.y;
	
	        smallElementWidthThreshold = 25;
	
	        if (DOM.getStyle(match.element, 'display', true) !== 'inline') {
	          // We need to use these instead of the rect values since the style
	          // size properites might not be the same as the real size for a table if it has a caption
	          var clientRect = match.element.getBoundingClientRect();
	          elementRect.w = clientRect.width;
	          elementRect.h = clientRect.height;
	        }
	
	        if (!editor.inline) {
	          contentAreaRect.w = editor.getDoc().documentElement.offsetWidth;
	        }
	
	        // Inflate the elementRect so it doesn't get placed above resize handles
	        if (editor.selection.controlSelection.isResizable(match.element) && elementRect.w < smallElementWidthThreshold) {
	          elementRect = Rect.inflate(elementRect, 0, 8);
	        }
	
	        relPos = Rect.findBestRelativePosition(panelRect, elementRect, contentAreaRect, testPositions);
	        elementRect = Rect.clamp(elementRect, contentAreaRect);
	
	        if (relPos) {
	          relRect = Rect.relativePosition(panelRect, elementRect, relPos);
	          movePanelTo(panel, userConstrain(handler, relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
	        } else {
	          // Allow overflow below the editor to avoid placing toolbars ontop of tables
	          contentAreaRect.h += panelRect.h;
	
	          elementRect = Rect.intersect(contentAreaRect, elementRect);
	          if (elementRect) {
	            relPos = Rect.findBestRelativePosition(panelRect, elementRect, contentAreaRect, [
	              'bc-tc', 'bl-tl', 'br-tr'
	            ]);
	
	            if (relPos) {
	              relRect = Rect.relativePosition(panelRect, elementRect, relPos);
	              movePanelTo(panel, userConstrain(handler, relRect.x, relRect.y, elementRect, contentAreaRect, panelRect));
	            } else {
	              movePanelTo(panel, userConstrain(handler, elementRect.x, elementRect.y, elementRect, contentAreaRect, panelRect));
	            }
	          } else {
	            panel.hide();
	          }
	        }
	
	        togglePositionClass(panel, relPos, function (pos1, pos2) {
	          return pos1 === pos2;
	        });
	
	        //drawRect(contentAreaRect, 'blue');
	        //drawRect(elementRect, 'red');
	        //drawRect(panelRect, 'green');
	      };
	
	      var repositionHandler = function (show) {
	        return function () {
	          var execute = function () {
	            if (editor.selection) {
	              reposition(findFrontMostMatch(editor.selection.getNode()), show);
	            }
	          };
	
	          Delay.requestAnimationFrame(execute);
	        };
	      };
	
	      var bindScrollEvent = function () {
	        if (!scrollContainer) {
	          var reposition = repositionHandler(true);
	
	          scrollContainer = editor.selection.getScrollContainer() || editor.getWin();
	          DOM.bind(scrollContainer, 'scroll', reposition);
	          DOM.bind(Env.container, 'scroll', reposition);
	
	          editor.on('remove', function () {
	            DOM.unbind(scrollContainer, 'scroll', reposition);
	            DOM.unbind(Env.container, 'scroll', reposition);
	          });
	        }
	      };
	
	      var showContextToolbar = function (match) {
	        var panel;
	
	        if (match.toolbar.panel) {
	          match.toolbar.panel.show();
	          reposition(match);
	          return;
	        }
	
	        bindScrollEvent();
	
	        panel = Factory.create({
	          type: 'floatpanel',
	          role: 'dialog',
	          classes: 'tinymce tinymce-inline arrow',
	          ariaLabel: 'Inline toolbar',
	          layout: 'flex',
	          direction: 'column',
	          align: 'stretch',
	          autohide: false,
	          autofix: true,
	          fixed: true,
	          border: 1,
	          items: Toolbar.createToolbar(editor, match.toolbar.items),
	          oncancel: function () {
	            editor.focus();
	          }
	        });
	
	        match.toolbar.panel = panel;
	        panel.renderTo().reflow();
	        reposition(match);
	      };
	
	      var hideAllContextToolbars = function () {
	        Tools.each(getContextToolbars(), function (toolbar) {
	          if (toolbar.panel) {
	            toolbar.panel.hide();
	          }
	        });
	      };
	
	      var findFrontMostMatch = function (targetElm) {
	        var i, y, parentsAndSelf, toolbars = getContextToolbars();
	
	        parentsAndSelf = editor.$(targetElm).parents().add(targetElm);
	        for (i = parentsAndSelf.length - 1; i >= 0; i--) {
	          for (y = toolbars.length - 1; y >= 0; y--) {
	            if (toolbars[y].predicate(parentsAndSelf[i])) {
	              return {
	                toolbar: toolbars[y],
	                element: parentsAndSelf[i]
	              };
	            }
	          }
	        }
	
	        return null;
	      };
	
	      editor.on('click keyup setContent ObjectResized', function (e) {
	        // Only act on partial inserts
	        if (e.type === 'setcontent' && !e.selection) {
	          return;
	        }
	
	        // Needs to be delayed to avoid Chrome img focus out bug
	        Delay.setEditorTimeout(editor, function () {
	          var match;
	
	          match = findFrontMostMatch(editor.selection.getNode());
	          if (match) {
	            hideAllContextToolbars();
	            showContextToolbar(match);
	          } else {
	            hideAllContextToolbars();
	          }
	        });
	      });
	
	      editor.on('blur hide contextmenu', hideAllContextToolbars);
	
	      editor.on('ObjectResizeStart', function () {
	        var match = findFrontMostMatch(editor.selection.getNode());
	
	        if (match && match.toolbar.panel) {
	          match.toolbar.panel.hide();
	        }
	      });
	
	      editor.on('ResizeEditor ResizeWindow', repositionHandler(true));
	      editor.on('nodeChange', repositionHandler(false));
	
	      editor.on('remove', function () {
	        Tools.each(getContextToolbars(), function (toolbar) {
	          if (toolbar.panel) {
	            toolbar.panel.remove();
	          }
	        });
	
	        editor.contextToolbars = {};
	      });
	
	      editor.shortcuts.add('ctrl+shift+e > ctrl+shift+p', '', function () {
	        var match = findFrontMostMatch(editor.selection.getNode());
	        if (match && match.toolbar.panel) {
	          match.toolbar.panel.items()[0].focus();
	        }
	      });
	    };
	
	    return {
	      addContextualToolbars: addContextualToolbars
	    };
	  }
	);
	
	defineGlobal("global!String", String);
	define(
	  'ephox.katamari.api.Arr',
	
	  [
	    'ephox.katamari.api.Option',
	    'global!Array',
	    'global!Error',
	    'global!String'
	  ],
	
	  function (Option, Array, Error, String) {
	    // Use the native Array.indexOf if it is available (IE9+) otherwise fall back to manual iteration
	    // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
	    var rawIndexOf = (function () {
	      var pIndexOf = Array.prototype.indexOf;
	
	      var fastIndex = function (xs, x) { return  pIndexOf.call(xs, x); };
	
	      var slowIndex = function(xs, x) { return slowIndexOf(xs, x); };
	
	      return pIndexOf === undefined ? slowIndex : fastIndex;
	    })();
	
	    var indexOf = function (xs, x) {
	      // The rawIndexOf method does not wrap up in an option. This is for performance reasons.
	      var r = rawIndexOf(xs, x);
	      return r === -1 ? Option.none() : Option.some(r);
	    };
	
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	
	    // Using findIndex is likely less optimal in Chrome (dynamic return type instead of bool)
	    // but if we need that micro-optimisation we can inline it later.
	    var exists = function (xs, pred) {
	      return findIndex(xs, pred).isSome();
	    };
	
	    var range = function (num, f) {
	      var r = [];
	      for (var i = 0; i < num; i++) {
	        r.push(f(i));
	      }
	      return r;
	    };
	
	    // It's a total micro optimisation, but these do make some difference.
	    // Particularly for browsers other than Chrome.
	    // - length caching
	    // http://jsperf.com/browser-diet-jquery-each-vs-for-loop/69
	    // - not using push
	    // http://jsperf.com/array-direct-assignment-vs-push/2
	
	    var chunk = function (array, size) {
	      var r = [];
	      for (var i = 0; i < array.length; i += size) {
	        var s = array.slice(i, i + size);
	        r.push(s);
	      }
	      return r;
	    };
	
	    var map = function(xs, f) {
	      // pre-allocating array size when it's guaranteed to be known
	      // http://jsperf.com/push-allocated-vs-dynamic/22
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i, xs);
	      }
	      return r;
	    };
	
	    // Unwound implementing other functions in terms of each.
	    // The code size is roughly the same, and it should allow for better optimisation.
	    var each = function(xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i, xs);
	      }
	    };
	
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i, xs);
	      }
	    };
	
	    var partition = function(xs, pred) {
	      var pass = [];
	      var fail = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        var arr = pred(x, i, xs) ? pass : fail;
	        arr.push(x);
	      }
	      return { pass: pass, fail: fail };
	    };
	
	    var filter = function(xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i, xs)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	
	    /*
	     * Groups an array into contiguous arrays of like elements. Whether an element is like or not depends on f.
	     *
	     * f is a function that derives a value from an element - e.g. true or false, or a string.
	     * Elements are like if this function generates the same value for them (according to ===).
	     *
	     *
	     * Order of the elements is preserved. Arr.flatten() on the result will return the original list, as with Haskell groupBy function.
	     *  For a good explanation, see the group function (which is a special case of groupBy)
	     *  http://hackage.haskell.org/package/base-4.7.0.0/docs/Data-List.html#v:group
	     */
	    var groupBy = function (xs, f) {
	      if (xs.length === 0) {
	        return [];
	      } else {
	        var wasType = f(xs[0]); // initial case for matching
	        var r = [];
	        var group = [];
	
	        for (var i = 0, len = xs.length; i < len; i++) {
	          var x = xs[i];
	          var type = f(x);
	          if (type !== wasType) {
	            r.push(group);
	            group = [];
	          }
	          wasType = type;
	          group.push(x);
	        }
	        if (group.length !== 0) {
	          r.push(group);
	        }
	        return r;
	      }
	    };
	
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	
	    var find = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i, xs)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i, xs)) {
	          return Option.some(i);
	        }
	      }
	
	      return Option.none();
	    };
	
	    var slowIndexOf = function (xs, x) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (xs[i] === x) {
	          return i;
	        }
	      }
	
	      return -1;
	    };
	
	    var push = Array.prototype.push;
	    var flatten = function (xs) {
	      // Note, this is possible because push supports multiple arguments:
	      // http://jsperf.com/concat-push/6
	      // Note that in the past, concat() would silently work (very slowly) for array-like objects.
	      // With this change it will throw an error.
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        // Ensure that each value is an array itself
	        if (! Array.prototype.isPrototypeOf(xs[i])) throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        push.apply(r, xs[i]);
	      }
	      return r;
	    };
	
	    var bind = function (xs, f) {
	      var output = map(xs, f);
	      return flatten(output);
	    };
	
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i, xs) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	
	    var equal = function (a1, a2) {
	      return a1.length === a2.length && forall(a1, function (x, i) {
	        return x === a2[i];
	      });
	    };
	
	    var slice = Array.prototype.slice;
	    var reverse = function (xs) {
	      var r = slice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	
	    var difference = function (a1, a2) {
	      return filter(a1, function (x) {
	        return !contains(a2, x);
	      });
	    };
	
	    var mapToObject = function(xs, f) {
	      var r = {};
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        r[String(x)] = f(x, i);
	      }
	      return r;
	    };
	
	    var pure = function(x) {
	      return [x];
	    };
	
	    var sort = function (xs, comparator) {
	      var copy = slice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	
	    var head = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[0]);
	    };
	
	    var last = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[xs.length - 1]);
	    };
	
	    return {
	      map: map,
	      each: each,
	      eachr: eachr,
	      partition: partition,
	      filter: filter,
	      groupBy: groupBy,
	      indexOf: indexOf,
	      foldr: foldr,
	      foldl: foldl,
	      find: find,
	      findIndex: findIndex,
	      flatten: flatten,
	      bind: bind,
	      forall: forall,
	      exists: exists,
	      contains: contains,
	      equal: equal,
	      reverse: reverse,
	      chunk: chunk,
	      difference: difference,
	      mapToObject: mapToObject,
	      pure: pure,
	      sort: sort,
	      range: range,
	      head: head,
	      last: last
	    };
	  }
	);
	/**
	 * Menubar.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.ui.Menubar',
	  [
	    'ephox.katamari.api.Arr',
	    'tinymce.core.util.Tools',
	    'tinymce.themes.modern.api.Settings'
	  ],
	  function (Arr, Tools, Settings) {
	    var defaultMenus = {
	      file: { title: 'File', items: 'newdocument restoredraft | preview | print' },
	      edit: { title: 'Edit', items: 'undo redo | cut copy paste pastetext | selectall' },
	      view: { title: 'View', items: 'code | visualaid visualchars visualblocks | spellchecker | preview fullscreen' },
	      insert: { title: 'Insert', items: 'image link media template codesample inserttable | charmap hr | pagebreak nonbreaking anchor toc | insertdatetime' },
	      format: { title: 'Format', items: 'bold italic underline strikethrough superscript subscript codeformat | blockformats align | removeformat' },
	      tools: { title: 'Tools', items: 'spellchecker spellcheckerlanguage | a11ycheck' },
	      table: { title: 'Table' },
	      help: { title: 'Help' }
	    };
	
	    var delimiterMenuNamePair = function () {
	      return { name: '|', item: { text: '|' } };
	    };
	
	    var createMenuNameItemPair = function (name, item) {
	      var menuItem = item ? { name: name, item: item } : null;
	      return name === '|' ? delimiterMenuNamePair() : menuItem;
	    };
	
	    var hasItemName = function (namedMenuItems, name) {
	      return Arr.findIndex(namedMenuItems, function (namedMenuItem) {
	        return namedMenuItem.name === name;
	      }).isSome();
	    };
	
	    var isSeparator = function (namedMenuItem) {
	      return namedMenuItem && namedMenuItem.item.text === '|';
	    };
	
	    var cleanupMenu = function (namedMenuItems, removedMenuItems) {
	      var menuItemsPass1 = Arr.filter(namedMenuItems, function (namedMenuItem) {
	        return removedMenuItems.hasOwnProperty(namedMenuItem.name) === false;
	      });
	
	      var menuItemsPass2 = Arr.filter(menuItemsPass1, function (namedMenuItem, i, namedMenuItems) {
	        return !isSeparator(namedMenuItem) || !isSeparator(namedMenuItems[i - 1]);
	      });
	
	      return Arr.filter(menuItemsPass2, function (namedMenuItem, i, namedMenuItems) {
	        return !isSeparator(namedMenuItem) || i > 0 && i < namedMenuItems.length - 1;
	      });
	    };
	
	    var createMenu = function (editorMenuItems, menus, removedMenuItems, context) {
	      var menuButton, menu, namedMenuItems, isUserDefined;
	
	      // User defined menu
	      if (menus) {
	        menu = menus[context];
	        isUserDefined = true;
	      } else {
	        menu = defaultMenus[context];
	      }
	
	      if (menu) {
	        menuButton = { text: menu.title };
	        namedMenuItems = [];
	
	        // Default/user defined items
	        Tools.each((menu.items || '').split(/[ ,]/), function (name) {
	          var namedMenuItem = createMenuNameItemPair(name, editorMenuItems[name]);
	
	          if (namedMenuItem) {
	            namedMenuItems.push(namedMenuItem);
	          }
	        });
	
	        // Added though context
	        if (!isUserDefined) {
	          Tools.each(editorMenuItems, function (item, name) {
	            if (item.context === context && !hasItemName(namedMenuItems, name)) {
	              if (item.separator === 'before') {
	                namedMenuItems.push(delimiterMenuNamePair());
	              }
	
	              if (item.prependToContext) {
	                namedMenuItems.unshift(createMenuNameItemPair(name, item));
	              } else {
	                namedMenuItems.push(createMenuNameItemPair(name, item));
	              }
	
	              if (item.separator === 'after') {
	                namedMenuItems.push(delimiterMenuNamePair());
	              }
	            }
	          });
	        }
	
	        menuButton.menu = Arr.map(cleanupMenu(namedMenuItems, removedMenuItems), function (menuItem) {
	          return menuItem.item;
	        });
	
	        if (!menuButton.menu.length) {
	          return null;
	        }
	      }
	
	      return menuButton;
	    };
	
	    var getDefaultMenubar = function (editor) {
	      var name, defaultMenuBar = [];
	      var menu = Settings.getMenu(editor);
	
	      if (menu) {
	        for (name in menu) {
	          defaultMenuBar.push(name);
	        }
	      } else {
	        for (name in defaultMenus) {
	          defaultMenuBar.push(name);
	        }
	      }
	
	      return defaultMenuBar;
	    };
	
	    var createMenuButtons = function (editor) {
	      var menuButtons = [];
	      var defaultMenuBar = getDefaultMenubar(editor);
	      var removedMenuItems = Tools.makeMap(Settings.getRemovedMenuItems(editor).split(/[ ,]/));
	
	      var menubar = Settings.getMenubar(editor);
	      var enabledMenuNames = typeof menubar === "string" ? menubar.split(/[ ,]/) : defaultMenuBar;
	      for (var i = 0; i < enabledMenuNames.length; i++) {
	        var menuItems = enabledMenuNames[i];
	        var menu = createMenu(editor.menuItems, Settings.getMenu(editor), removedMenuItems, menuItems);
	        if (menu) {
	          menuButtons.push(menu);
	        }
	      }
	
	      return menuButtons;
	    };
	
	    return {
	      createMenuButtons: createMenuButtons
	    };
	  }
	);
	
	/**
	 * Resize.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.ui.Resize',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.themes.modern.api.Events',
	    'tinymce.themes.modern.api.Settings'
	  ],
	  function (DOMUtils, Events, Settings) {
	    var DOM = DOMUtils.DOM;
	    var getSize = function (elm) {
	      return {
	        width: elm.clientWidth,
	        height: elm.clientHeight
	      };
	    };
	
	    var resizeTo = function (editor, width, height) {
	      var containerElm, iframeElm, containerSize, iframeSize;
	
	      containerElm = editor.getContainer();
	      iframeElm = editor.getContentAreaContainer().firstChild;
	      containerSize = getSize(containerElm);
	      iframeSize = getSize(iframeElm);
	
	      if (width !== null) {
	        width = Math.max(Settings.getMinWidth(editor), width);
	        width = Math.min(Settings.getMaxWidth(editor), width);
	
	        DOM.setStyle(containerElm, 'width', width + (containerSize.width - iframeSize.width));
	        DOM.setStyle(iframeElm, 'width', width);
	      }
	
	      height = Math.max(Settings.getMinHeight(editor), height);
	      height = Math.min(Settings.getMaxHeight(editor), height);
	      DOM.setStyle(iframeElm, 'height', height);
	
	      Events.fireResizeEditor(editor);
	    };
	
	    var resizeBy = function (editor, dw, dh) {
	      var elm = editor.getContentAreaContainer();
	      resizeTo(editor, elm.clientWidth + dw, elm.clientHeight + dh);
	    };
	
	    return {
	      resizeTo: resizeTo,
	      resizeBy: resizeBy
	    };
	  }
	);
	
	/**
	 * Sidebar.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.ui.Sidebar',
	  [
	    'tinymce.core.Env',
	    'tinymce.core.ui.Factory',
	    'tinymce.core.util.Tools',
	    'tinymce.themes.modern.api.Events'
	  ],
	  function (Env, Factory, Tools, Events) {
	    var api = function (elm) {
	      return {
	        element: function () {
	          return elm;
	        }
	      };
	    };
	
	    var trigger = function (sidebar, panel, callbackName) {
	      var callback = sidebar.settings[callbackName];
	      if (callback) {
	        callback(api(panel.getEl('body')));
	      }
	    };
	
	    var hidePanels = function (name, container, sidebars) {
	      Tools.each(sidebars, function (sidebar) {
	        var panel = container.items().filter('#' + sidebar.name)[0];
	
	        if (panel && panel.visible() && sidebar.name !== name) {
	          trigger(sidebar, panel, 'onhide');
	          panel.visible(false);
	        }
	      });
	    };
	
	    var deactivateButtons = function (toolbar) {
	      toolbar.items().each(function (ctrl) {
	        ctrl.active(false);
	      });
	    };
	
	    var findSidebar = function (sidebars, name) {
	      return Tools.grep(sidebars, function (sidebar) {
	        return sidebar.name === name;
	      })[0];
	    };
	
	    var showPanel = function (editor, name, sidebars) {
	      return function (e) {
	        var btnCtrl = e.control;
	        var container = btnCtrl.parents().filter('panel')[0];
	        var panel = container.find('#' + name)[0];
	        var sidebar = findSidebar(sidebars, name);
	
	        hidePanels(name, container, sidebars);
	        deactivateButtons(btnCtrl.parent());
	
	        if (panel && panel.visible()) {
	          trigger(sidebar, panel, 'onhide');
	          panel.hide();
	          btnCtrl.active(false);
	        } else {
	          if (panel) {
	            panel.show();
	            trigger(sidebar, panel, 'onshow');
	          } else {
	            panel = Factory.create({
	              type: 'container',
	              name: name,
	              layout: 'stack',
	              classes: 'sidebar-panel',
	              html: ''
	            });
	
	            container.prepend(panel);
	            trigger(sidebar, panel, 'onrender');
	            trigger(sidebar, panel, 'onshow');
	          }
	
	          btnCtrl.active(true);
	        }
	
	        Events.fireResizeEditor(editor);
	      };
	    };
	
	    var isModernBrowser = function () {
	      return !Env.ie || Env.ie >= 11;
	    };
	
	    var hasSidebar = function (editor) {
	      return isModernBrowser() && editor.sidebars ? editor.sidebars.length > 0 : false;
	    };
	
	    var createSidebar = function (editor) {
	      var buttons = Tools.map(editor.sidebars, function (sidebar) {
	        var settings = sidebar.settings;
	
	        return {
	          type: 'button',
	          icon: settings.icon,
	          image: settings.image,
	          tooltip: settings.tooltip,
	          onclick: showPanel(editor, sidebar.name, editor.sidebars)
	        };
	      });
	
	      return {
	        type: 'panel',
	        name: 'sidebar',
	        layout: 'stack',
	        classes: 'sidebar',
	        items: [
	          {
	            type: 'toolbar',
	            layout: 'stack',
	            classes: 'sidebar-toolbar',
	            items: buttons
	          }
	        ]
	      };
	    };
	
	    return {
	      hasSidebar: hasSidebar,
	      createSidebar: createSidebar
	    };
	  }
	);
	/**
	 * SkinLoaded.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.ui.SkinLoaded', [
	    'tinymce.themes.modern.api.Events'
	  ],
	  function (Events) {
	    var fireSkinLoaded = function (editor) {
	      var done = function () {
	        editor._skinLoaded = true;
	        Events.fireSkinLoaded(editor);
	      };
	
	      return function () {
	        if (editor.initialized) {
	          done();
	        } else {
	          editor.on('init', done);
	        }
	      };
	    };
	
	    return {
	      fireSkinLoaded: fireSkinLoaded
	    };
	  }
	);
	
	/**
	 * Iframe.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.modes.Iframe',
	  [
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.ui.Factory',
	    'tinymce.core.util.I18n',
	    'tinymce.core.util.Tools',
	    'tinymce.themes.modern.api.Events',
	    'tinymce.themes.modern.api.Settings',
	    'tinymce.themes.modern.ui.A11y',
	    'tinymce.themes.modern.ui.ContextToolbars',
	    'tinymce.themes.modern.ui.Menubar',
	    'tinymce.themes.modern.ui.Resize',
	    'tinymce.themes.modern.ui.Sidebar',
	    'tinymce.themes.modern.ui.SkinLoaded',
	    'tinymce.themes.modern.ui.Toolbar'
	  ],
	  function (DOMUtils, Factory, I18n, Tools, Events, Settings, A11y, ContextToolbars, Menubar, Resize, Sidebar, SkinLoaded, Toolbar) {
	    var DOM = DOMUtils.DOM;
	
	    var switchMode = function (panel) {
	      return function (e) {
	        panel.find('*').disabled(e.mode === 'readonly');
	      };
	    };
	
	    var editArea = function (border) {
	      return {
	        type: 'panel',
	        name: 'iframe',
	        layout: 'stack',
	        classes: 'edit-area',
	        border: border,
	        html: ''
	      };
	    };
	
	    var editAreaContainer = function (editor) {
	      return {
	        type: 'panel',
	        layout: 'stack',
	        classes: 'edit-aria-container',
	        border: '1 0 0 0',
	        items: [
	          editArea('0'),
	          Sidebar.createSidebar(editor)
	        ]
	      };
	    };
	
	    var render = function (editor, theme, args) {
	      var panel, resizeHandleCtrl, startSize;
	
	      if (Settings.isSkinDisabled(editor) === false && args.skinUiCss) {
	        DOM.styleSheetLoader.load(args.skinUiCss, SkinLoaded.fireSkinLoaded(editor));
	      } else {
	        SkinLoaded.fireSkinLoaded(editor)();
	      }
	
	      panel = theme.panel = Factory.create({
	        type: 'panel',
	        role: 'application',
	        classes: 'tinymce',
	        style: 'visibility: hidden',
	        layout: 'stack',
	        border: 1,
	        items: [
	          {
	            type: 'container',
	            classes: 'top-part',
	            items: [
	              Settings.hasMenubar(editor) === false ? null : { type: 'menubar', border: '0 0 1 0', items: Menubar.createMenuButtons(editor) },
	              Toolbar.createToolbars(editor, Settings.getToolbarSize(editor))
	            ]
	          },
	          Sidebar.hasSidebar(editor) ? editAreaContainer(editor) : editArea('1 0 0 0')
	        ]
	      });
	
	      if (Settings.getResize(editor) !== "none") {
	        resizeHandleCtrl = {
	          type: 'resizehandle',
	          direction: Settings.getResize(editor),
	
	          onResizeStart: function () {
	            var elm = editor.getContentAreaContainer().firstChild;
	
	            startSize = {
	              width: elm.clientWidth,
	              height: elm.clientHeight
	            };
	          },
	
	          onResize: function (e) {
	            if (Settings.getResize(editor) === 'both') {
	              Resize.resizeTo(editor, startSize.width + e.deltaX, startSize.height + e.deltaY);
	            } else {
	              Resize.resizeTo(editor, null, startSize.height + e.deltaY);
	            }
	          }
	        };
	      }
	
	      if (Settings.hasStatusbar(editor)) {
	        var linkHtml = '<a href="https://www.tinymce.com/?utm_campaign=editor_referral&utm_medium=poweredby&utm_source=tinymce" rel="noopener" target="_blank">tinymce</a>';
	        var html = I18n.translate(['Powered by {0}', linkHtml]);
	        var brandingLabel = Settings.isBrandingEnabled(editor) ? { type: 'label', classes: 'branding', html: ' ' + html } : null;
	
	        panel.add({
	          type: 'panel', name: 'statusbar', classes: 'statusbar', layout: 'flow', border: '1 0 0 0', ariaRoot: true, items: [
	            { type: 'elementpath', editor: editor },
	            resizeHandleCtrl,
	            brandingLabel
	          ]
	        });
	      }
	
	      Events.fireBeforeRenderUI(editor);
	      editor.on('SwitchMode', switchMode(panel));
	      panel.renderBefore(args.targetNode).reflow();
	
	      if (Settings.isReadOnly(editor)) {
	        editor.setMode('readonly');
	      }
	
	      if (args.width) {
	        DOM.setStyle(panel.getEl(), 'width', args.width);
	      }
	
	      // Remove the panel when the editor is removed
	      editor.on('remove', function () {
	        panel.remove();
	        panel = null;
	      });
	
	      // Add accesibility shortcuts
	      A11y.addKeys(editor, panel);
	      ContextToolbars.addContextualToolbars(editor);
	
	      return {
	        iframeContainer: panel.find('#iframe')[0].getEl(),
	        editorContainer: panel.getEl()
	      };
	    };
	
	    return {
	      render: render
	    };
	  }
	);
	
	defineGlobal("global!document", document);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DomQuery',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.dom.DomQuery');
	  }
	);
	
	/**
	 * DomUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Private UI DomUtils proxy.
	 *
	 * @private
	 * @class tinymce.ui.DomUtils
	 */
	define(
	  'tinymce.ui.DomUtils',
	  [
	    'global!document',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.Env',
	    'tinymce.core.util.Tools'
	  ],
	  function (document, DOMUtils, Env, Tools) {
	    "use strict";
	
	    var count = 0;
	
	    var funcs = {
	      id: function () {
	        return 'mceu_' + (count++);
	      },
	
	      create: function (name, attrs, children) {
	        var elm = document.createElement(name);
	
	        DOMUtils.DOM.setAttribs(elm, attrs);
	
	        if (typeof children === 'string') {
	          elm.innerHTML = children;
	        } else {
	          Tools.each(children, function (child) {
	            if (child.nodeType) {
	              elm.appendChild(child);
	            }
	          });
	        }
	
	        return elm;
	      },
	
	      createFragment: function (html) {
	        return DOMUtils.DOM.createFragment(html);
	      },
	
	      getWindowSize: function () {
	        return DOMUtils.DOM.getViewPort();
	      },
	
	      getSize: function (elm) {
	        var width, height;
	
	        if (elm.getBoundingClientRect) {
	          var rect = elm.getBoundingClientRect();
	
	          width = Math.max(rect.width || (rect.right - rect.left), elm.offsetWidth);
	          height = Math.max(rect.height || (rect.bottom - rect.bottom), elm.offsetHeight);
	        } else {
	          width = elm.offsetWidth;
	          height = elm.offsetHeight;
	        }
	
	        return { width: width, height: height };
	      },
	
	      getPos: function (elm, root) {
	        return DOMUtils.DOM.getPos(elm, root || funcs.getContainer());
	      },
	
	      getContainer: function () {
	        return Env.container ? Env.container : document.body;
	      },
	
	      getViewPort: function (win) {
	        return DOMUtils.DOM.getViewPort(win);
	      },
	
	      get: function (id) {
	        return document.getElementById(id);
	      },
	
	      addClass: function (elm, cls) {
	        return DOMUtils.DOM.addClass(elm, cls);
	      },
	
	      removeClass: function (elm, cls) {
	        return DOMUtils.DOM.removeClass(elm, cls);
	      },
	
	      hasClass: function (elm, cls) {
	        return DOMUtils.DOM.hasClass(elm, cls);
	      },
	
	      toggleClass: function (elm, cls, state) {
	        return DOMUtils.DOM.toggleClass(elm, cls, state);
	      },
	
	      css: function (elm, name, value) {
	        return DOMUtils.DOM.setStyle(elm, name, value);
	      },
	
	      getRuntimeStyle: function (elm, name) {
	        return DOMUtils.DOM.getStyle(elm, name, true);
	      },
	
	      on: function (target, name, callback, scope) {
	        return DOMUtils.DOM.bind(target, name, callback, scope);
	      },
	
	      off: function (target, name, callback) {
	        return DOMUtils.DOM.unbind(target, name, callback);
	      },
	
	      fire: function (target, name, args) {
	        return DOMUtils.DOM.fire(target, name, args);
	      },
	
	      innerHtml: function (elm, html) {
	        // Workaround for <div> in <p> bug on IE 8 #6178
	        DOMUtils.DOM.setHTML(elm, html);
	      }
	    };
	
	    return funcs;
	  }
	);
	/**
	 * Movable.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Movable mixin. Makes controls movable absolute and relative to other elements.
	 *
	 * @mixin tinymce.ui.Movable
	 */
	define(
	  'tinymce.ui.Movable',
	  [
	    'global!document',
	    'global!window',
	    'tinymce.ui.DomUtils'
	  ],
	  function (document, window, DomUtils) {
	    "use strict";
	
	    function calculateRelativePosition(ctrl, targetElm, rel) {
	      var ctrlElm, pos, x, y, selfW, selfH, targetW, targetH, viewport, size;
	
	      viewport = DomUtils.getViewPort();
	
	      // Get pos of target
	      pos = DomUtils.getPos(targetElm);
	      x = pos.x;
	      y = pos.y;
	
	      if (ctrl.state.get('fixed') && DomUtils.getRuntimeStyle(document.body, 'position') == 'static') {
	        x -= viewport.x;
	        y -= viewport.y;
	      }
	
	      // Get size of self
	      ctrlElm = ctrl.getEl();
	      size = DomUtils.getSize(ctrlElm);
	      selfW = size.width;
	      selfH = size.height;
	
	      // Get size of target
	      size = DomUtils.getSize(targetElm);
	      targetW = size.width;
	      targetH = size.height;
	
	      // Parse align string
	      rel = (rel || '').split('');
	
	      // Target corners
	      if (rel[0] === 'b') {
	        y += targetH;
	      }
	
	      if (rel[1] === 'r') {
	        x += targetW;
	      }
	
	      if (rel[0] === 'c') {
	        y += Math.round(targetH / 2);
	      }
	
	      if (rel[1] === 'c') {
	        x += Math.round(targetW / 2);
	      }
	
	      // Self corners
	      if (rel[3] === 'b') {
	        y -= selfH;
	      }
	
	      if (rel[4] === 'r') {
	        x -= selfW;
	      }
	
	      if (rel[3] === 'c') {
	        y -= Math.round(selfH / 2);
	      }
	
	      if (rel[4] === 'c') {
	        x -= Math.round(selfW / 2);
	      }
	
	      return {
	        x: x,
	        y: y,
	        w: selfW,
	        h: selfH
	      };
	    }
	
	    return {
	      /**
	       * Tests various positions to get the most suitable one.
	       *
	       * @method testMoveRel
	       * @param {DOMElement} elm Element to position against.
	       * @param {Array} rels Array with relative positions.
	       * @return {String} Best suitable relative position.
	       */
	      testMoveRel: function (elm, rels) {
	        var viewPortRect = DomUtils.getViewPort();
	
	        for (var i = 0; i < rels.length; i++) {
	          var pos = calculateRelativePosition(this, elm, rels[i]);
	
	          if (this.state.get('fixed')) {
	            if (pos.x > 0 && pos.x + pos.w < viewPortRect.w && pos.y > 0 && pos.y + pos.h < viewPortRect.h) {
	              return rels[i];
	            }
	          } else {
	            if (pos.x > viewPortRect.x && pos.x + pos.w < viewPortRect.w + viewPortRect.x &&
	              pos.y > viewPortRect.y && pos.y + pos.h < viewPortRect.h + viewPortRect.y) {
	              return rels[i];
	            }
	          }
	        }
	
	        return rels[0];
	      },
	
	      /**
	       * Move relative to the specified element.
	       *
	       * @method moveRel
	       * @param {Element} elm Element to move relative to.
	       * @param {String} rel Relative mode. For example: br-tl.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      moveRel: function (elm, rel) {
	        if (typeof rel != 'string') {
	          rel = this.testMoveRel(elm, rel);
	        }
	
	        var pos = calculateRelativePosition(this, elm, rel);
	        return this.moveTo(pos.x, pos.y);
	      },
	
	      /**
	       * Move by a relative x, y values.
	       *
	       * @method moveBy
	       * @param {Number} dx Relative x position.
	       * @param {Number} dy Relative y position.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      moveBy: function (dx, dy) {
	        var self = this, rect = self.layoutRect();
	
	        self.moveTo(rect.x + dx, rect.y + dy);
	
	        return self;
	      },
	
	      /**
	       * Move to absolute position.
	       *
	       * @method moveTo
	       * @param {Number} x Absolute x position.
	       * @param {Number} y Absolute y position.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      moveTo: function (x, y) {
	        var self = this;
	
	        // TODO: Move this to some global class
	        function constrain(value, max, size) {
	          if (value < 0) {
	            return 0;
	          }
	
	          if (value + size > max) {
	            value = max - size;
	            return value < 0 ? 0 : value;
	          }
	
	          return value;
	        }
	
	        if (self.settings.constrainToViewport) {
	          var viewPortRect = DomUtils.getViewPort(window);
	          var layoutRect = self.layoutRect();
	
	          x = constrain(x, viewPortRect.w + viewPortRect.x, layoutRect.w);
	          y = constrain(y, viewPortRect.h + viewPortRect.y, layoutRect.h);
	        }
	
	        if (self.state.get('rendered')) {
	          self.layoutRect({ x: x, y: y }).repaint();
	        } else {
	          self.settings.x = x;
	          self.settings.y = y;
	        }
	
	        self.fire('move', { x: x, y: y });
	
	        return self;
	      }
	    };
	  }
	);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Class',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Class');
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.EventDispatcher',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.EventDispatcher');
	  }
	);
	
	/**
	 * BoxUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility class for box parsing and measuring.
	 *
	 * @private
	 * @class tinymce.ui.BoxUtils
	 */
	define(
	  'tinymce.ui.BoxUtils',
	  [
	
	  ],
	  function () {
	    "use strict";
	
	    return {
	      /**
	       * Parses the specified box value. A box value contains 1-4 properties in clockwise order.
	       *
	       * @method parseBox
	       * @param {String/Number} value Box value "0 1 2 3" or "0" etc.
	       * @return {Object} Object with top/right/bottom/left properties.
	       * @private
	       */
	      parseBox: function (value) {
	        var len, radix = 10;
	
	        if (!value) {
	          return;
	        }
	
	        if (typeof value === "number") {
	          value = value || 0;
	
	          return {
	            top: value,
	            left: value,
	            bottom: value,
	            right: value
	          };
	        }
	
	        value = value.split(' ');
	        len = value.length;
	
	        if (len === 1) {
	          value[1] = value[2] = value[3] = value[0];
	        } else if (len === 2) {
	          value[2] = value[0];
	          value[3] = value[1];
	        } else if (len === 3) {
	          value[3] = value[1];
	        }
	
	        return {
	          top: parseInt(value[0], radix) || 0,
	          right: parseInt(value[1], radix) || 0,
	          bottom: parseInt(value[2], radix) || 0,
	          left: parseInt(value[3], radix) || 0
	        };
	      },
	
	      measureBox: function (elm, prefix) {
	        function getStyle(name) {
	          var defaultView = elm.ownerDocument.defaultView;
	
	          if (defaultView) {
	            var computedStyle = defaultView.getComputedStyle(elm, null);
	            if (computedStyle) {
	              // Remove camelcase
	              name = name.replace(/[A-Z]/g, function (a) {
	                return '-' + a;
	              });
	
	              return computedStyle.getPropertyValue(name);
	            } else {
	              return null;
	            }
	          }
	
	          return elm.currentStyle[name];
	        }
	
	        function getSide(name) {
	          var val = parseFloat(getStyle(name), 10);
	
	          return isNaN(val) ? 0 : val;
	        }
	
	        return {
	          top: getSide(prefix + "TopWidth"),
	          right: getSide(prefix + "RightWidth"),
	          bottom: getSide(prefix + "BottomWidth"),
	          left: getSide(prefix + "LeftWidth")
	        };
	      }
	    };
	  }
	);
	
	/**
	 * ClassList.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Handles adding and removal of classes.
	 *
	 * @private
	 * @class tinymce.ui.ClassList
	 */
	define(
	  'tinymce.ui.ClassList',
	  [
	    "tinymce.core.util.Tools"
	  ],
	  function (Tools) {
	    "use strict";
	
	    function noop() {
	    }
	
	    /**
	     * Constructs a new class list the specified onchange
	     * callback will be executed when the class list gets modifed.
	     *
	     * @constructor ClassList
	     * @param {function} onchange Onchange callback to be executed.
	     */
	    function ClassList(onchange) {
	      this.cls = [];
	      this.cls._map = {};
	      this.onchange = onchange || noop;
	      this.prefix = '';
	    }
	
	    Tools.extend(ClassList.prototype, {
	      /**
	       * Adds a new class to the class list.
	       *
	       * @method add
	       * @param {String} cls Class to be added.
	       * @return {tinymce.ui.ClassList} Current class list instance.
	       */
	      add: function (cls) {
	        if (cls && !this.contains(cls)) {
	          this.cls._map[cls] = true;
	          this.cls.push(cls);
	          this._change();
	        }
	
	        return this;
	      },
	
	      /**
	       * Removes the specified class from the class list.
	       *
	       * @method remove
	       * @param {String} cls Class to be removed.
	       * @return {tinymce.ui.ClassList} Current class list instance.
	       */
	      remove: function (cls) {
	        if (this.contains(cls)) {
	          for (var i = 0; i < this.cls.length; i++) {
	            if (this.cls[i] === cls) {
	              break;
	            }
	          }
	
	          this.cls.splice(i, 1);
	          delete this.cls._map[cls];
	          this._change();
	        }
	
	        return this;
	      },
	
	      /**
	       * Toggles a class in the class list.
	       *
	       * @method toggle
	       * @param {String} cls Class to be added/removed.
	       * @param {Boolean} state Optional state if it should be added/removed.
	       * @return {tinymce.ui.ClassList} Current class list instance.
	       */
	      toggle: function (cls, state) {
	        var curState = this.contains(cls);
	
	        if (curState !== state) {
	          if (curState) {
	            this.remove(cls);
	          } else {
	            this.add(cls);
	          }
	
	          this._change();
	        }
	
	        return this;
	      },
	
	      /**
	       * Returns true if the class list has the specified class.
	       *
	       * @method contains
	       * @param {String} cls Class to look for.
	       * @return {Boolean} true/false if the class exists or not.
	       */
	      contains: function (cls) {
	        return !!this.cls._map[cls];
	      },
	
	      /**
	       * Returns a space separated list of classes.
	       *
	       * @method toString
	       * @return {String} Space separated list of classes.
	       */
	
	      _change: function () {
	        delete this.clsValue;
	        this.onchange.call(this);
	      }
	    });
	
	    // IE 8 compatibility
	    ClassList.prototype.toString = function () {
	      var value;
	
	      if (this.clsValue) {
	        return this.clsValue;
	      }
	
	      value = '';
	      for (var i = 0; i < this.cls.length; i++) {
	        if (i > 0) {
	          value += ' ';
	        }
	
	        value += this.prefix + this.cls[i];
	      }
	
	      return value;
	    };
	
	    return ClassList;
	  }
	);
	/**
	 * Selector.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*eslint no-nested-ternary:0 */
	
	/**
	 * Selector engine, enables you to select controls by using CSS like expressions.
	 * We currently only support basic CSS expressions to reduce the size of the core
	 * and the ones we support should be enough for most cases.
	 *
	 * @example
	 * Supported expressions:
	 *  element
	 *  element#name
	 *  element.class
	 *  element[attr]
	 *  element[attr*=value]
	 *  element[attr~=value]
	 *  element[attr!=value]
	 *  element[attr^=value]
	 *  element[attr$=value]
	 *  element:<state>
	 *  element:not(<expression>)
	 *  element:first
	 *  element:last
	 *  element:odd
	 *  element:even
	 *  element element
	 *  element > element
	 *
	 * @class tinymce.ui.Selector
	 */
	define(
	  'tinymce.ui.Selector',
	  [
	    "tinymce.core.util.Class"
	  ],
	  function (Class) {
	    "use strict";
	
	    /**
	     * Produces an array with a unique set of objects. It will not compare the values
	     * but the references of the objects.
	     *
	     * @private
	     * @method unqiue
	     * @param {Array} array Array to make into an array with unique items.
	     * @return {Array} Array with unique items.
	     */
	    function unique(array) {
	      var uniqueItems = [], i = array.length, item;
	
	      while (i--) {
	        item = array[i];
	
	        if (!item.__checked) {
	          uniqueItems.push(item);
	          item.__checked = 1;
	        }
	      }
	
	      i = uniqueItems.length;
	      while (i--) {
	        delete uniqueItems[i].__checked;
	      }
	
	      return uniqueItems;
	    }
	
	    var expression = /^([\w\\*]+)?(?:#([\w\-\\]+))?(?:\.([\w\\\.]+))?(?:\[\@?([\w\\]+)([\^\$\*!~]?=)([\w\\]+)\])?(?:\:(.+))?/i;
	
	    /*jshint maxlen:255 */
	    /*eslint max-len:0 */
	    var chunker = /((?:\((?:\([^()]+\)|[^()]+)+\)|\[(?:\[[^\[\]]*\]|['"][^'"]*['"]|[^\[\]'"]+)+\]|\\.|[^ >+~,(\[\\]+)+|[>+~])(\s*,\s*)?((?:.|\r|\n)*)/g,
	      whiteSpace = /^\s*|\s*$/g,
	      Collection;
	
	    var Selector = Class.extend({
	      /**
	       * Constructs a new Selector instance.
	       *
	       * @constructor
	       * @method init
	       * @param {String} selector CSS like selector expression.
	       */
	      init: function (selector) {
	        var match = this.match;
	
	        function compileNameFilter(name) {
	          if (name) {
	            name = name.toLowerCase();
	
	            return function (item) {
	              return name === '*' || item.type === name;
	            };
	          }
	        }
	
	        function compileIdFilter(id) {
	          if (id) {
	            return function (item) {
	              return item._name === id;
	            };
	          }
	        }
	
	        function compileClassesFilter(classes) {
	          if (classes) {
	            classes = classes.split('.');
	
	            return function (item) {
	              var i = classes.length;
	
	              while (i--) {
	                if (!item.classes.contains(classes[i])) {
	                  return false;
	                }
	              }
	
	              return true;
	            };
	          }
	        }
	
	        function compileAttrFilter(name, cmp, check) {
	          if (name) {
	            return function (item) {
	              var value = item[name] ? item[name]() : '';
	
	              return !cmp ? !!check :
	                cmp === "=" ? value === check :
	                  cmp === "*=" ? value.indexOf(check) >= 0 :
	                    cmp === "~=" ? (" " + value + " ").indexOf(" " + check + " ") >= 0 :
	                      cmp === "!=" ? value != check :
	                        cmp === "^=" ? value.indexOf(check) === 0 :
	                          cmp === "$=" ? value.substr(value.length - check.length) === check :
	                            false;
	            };
	          }
	        }
	
	        function compilePsuedoFilter(name) {
	          var notSelectors;
	
	          if (name) {
	            name = /(?:not\((.+)\))|(.+)/i.exec(name);
	
	            if (!name[1]) {
	              name = name[2];
	
	              return function (item, index, length) {
	                return name === 'first' ? index === 0 :
	                  name === 'last' ? index === length - 1 :
	                    name === 'even' ? index % 2 === 0 :
	                      name === 'odd' ? index % 2 === 1 :
	                        item[name] ? item[name]() :
	                          false;
	              };
	            }
	
	            // Compile not expression
	            notSelectors = parseChunks(name[1], []);
	
	            return function (item) {
	              return !match(item, notSelectors);
	            };
	          }
	        }
	
	        function compile(selector, filters, direct) {
	          var parts;
	
	          function add(filter) {
	            if (filter) {
	              filters.push(filter);
	            }
	          }
	
	          // Parse expression into parts
	          parts = expression.exec(selector.replace(whiteSpace, ''));
	
	          add(compileNameFilter(parts[1]));
	          add(compileIdFilter(parts[2]));
	          add(compileClassesFilter(parts[3]));
	          add(compileAttrFilter(parts[4], parts[5], parts[6]));
	          add(compilePsuedoFilter(parts[7]));
	
	          // Mark the filter with pseudo for performance
	          filters.pseudo = !!parts[7];
	          filters.direct = direct;
	
	          return filters;
	        }
	
	        // Parser logic based on Sizzle by John Resig
	        function parseChunks(selector, selectors) {
	          var parts = [], extra, matches, i;
	
	          do {
	            chunker.exec("");
	            matches = chunker.exec(selector);
	
	            if (matches) {
	              selector = matches[3];
	              parts.push(matches[1]);
	
	              if (matches[2]) {
	                extra = matches[3];
	                break;
	              }
	            }
	          } while (matches);
	
	          if (extra) {
	            parseChunks(extra, selectors);
	          }
	
	          selector = [];
	          for (i = 0; i < parts.length; i++) {
	            if (parts[i] != '>') {
	              selector.push(compile(parts[i], [], parts[i - 1] === '>'));
	            }
	          }
	
	          selectors.push(selector);
	
	          return selectors;
	        }
	
	        this._selectors = parseChunks(selector, []);
	      },
	
	      /**
	       * Returns true/false if the selector matches the specified control.
	       *
	       * @method match
	       * @param {tinymce.ui.Control} control Control to match against the selector.
	       * @param {Array} selectors Optional array of selectors, mostly used internally.
	       * @return {Boolean} true/false state if the control matches or not.
	       */
	      match: function (control, selectors) {
	        var i, l, si, sl, selector, fi, fl, filters, index, length, siblings, count, item;
	
	        selectors = selectors || this._selectors;
	        for (i = 0, l = selectors.length; i < l; i++) {
	          selector = selectors[i];
	          sl = selector.length;
	          item = control;
	          count = 0;
	
	          for (si = sl - 1; si >= 0; si--) {
	            filters = selector[si];
	
	            while (item) {
	              // Find the index and length since a pseudo filter like :first needs it
	              if (filters.pseudo) {
	                siblings = item.parent().items();
	                index = length = siblings.length;
	                while (index--) {
	                  if (siblings[index] === item) {
	                    break;
	                  }
	                }
	              }
	
	              for (fi = 0, fl = filters.length; fi < fl; fi++) {
	                if (!filters[fi](item, index, length)) {
	                  fi = fl + 1;
	                  break;
	                }
	              }
	
	              if (fi === fl) {
	                count++;
	                break;
	              } else {
	                // If it didn't match the right most expression then
	                // break since it's no point looking at the parents
	                if (si === sl - 1) {
	                  break;
	                }
	              }
	
	              item = item.parent();
	            }
	          }
	
	          // If we found all selectors then return true otherwise continue looking
	          if (count === sl) {
	            return true;
	          }
	        }
	
	        return false;
	      },
	
	      /**
	       * Returns a tinymce.ui.Collection with matches of the specified selector inside the specified container.
	       *
	       * @method find
	       * @param {tinymce.ui.Control} container Container to look for items in.
	       * @return {tinymce.ui.Collection} Collection with matched elements.
	       */
	      find: function (container) {
	        var matches = [], i, l, selectors = this._selectors;
	
	        function collect(items, selector, index) {
	          var i, l, fi, fl, item, filters = selector[index];
	
	          for (i = 0, l = items.length; i < l; i++) {
	            item = items[i];
	
	            // Run each filter against the item
	            for (fi = 0, fl = filters.length; fi < fl; fi++) {
	              if (!filters[fi](item, i, l)) {
	                fi = fl + 1;
	                break;
	              }
	            }
	
	            // All filters matched the item
	            if (fi === fl) {
	              // Matched item is on the last expression like: panel toolbar [button]
	              if (index == selector.length - 1) {
	                matches.push(item);
	              } else {
	                // Collect next expression type
	                if (item.items) {
	                  collect(item.items(), selector, index + 1);
	                }
	              }
	            } else if (filters.direct) {
	              return;
	            }
	
	            // Collect child items
	            if (item.items) {
	              collect(item.items(), selector, index);
	            }
	          }
	        }
	
	        if (container.items) {
	          for (i = 0, l = selectors.length; i < l; i++) {
	            collect(container.items(), selectors[i], 0);
	          }
	
	          // Unique the matches if needed
	          if (l > 1) {
	            matches = unique(matches);
	          }
	        }
	
	        // Fix for circular reference
	        if (!Collection) {
	          // TODO: Fix me!
	          Collection = Selector.Collection;
	        }
	
	        return new Collection(matches);
	      }
	    });
	
	    return Selector;
	  }
	);
	
	/**
	 * Collection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Control collection, this class contains control instances and it enables you to
	 * perform actions on all the contained items. This is very similar to how jQuery works.
	 *
	 * @example
	 * someCollection.show().disabled(true);
	 *
	 * @class tinymce.ui.Collection
	 */
	define(
	  'tinymce.ui.Collection',
	  [
	    "tinymce.core.util.Tools",
	    "tinymce.ui.Selector",
	    "tinymce.core.util.Class"
	  ],
	  function (Tools, Selector, Class) {
	    "use strict";
	
	    var Collection, proto, push = Array.prototype.push, slice = Array.prototype.slice;
	
	    proto = {
	      /**
	       * Current number of contained control instances.
	       *
	       * @field length
	       * @type Number
	       */
	      length: 0,
	
	      /**
	       * Constructor for the collection.
	       *
	       * @constructor
	       * @method init
	       * @param {Array} items Optional array with items to add.
	       */
	      init: function (items) {
	        if (items) {
	          this.add(items);
	        }
	      },
	
	      /**
	       * Adds new items to the control collection.
	       *
	       * @method add
	       * @param {Array} items Array if items to add to collection.
	       * @return {tinymce.ui.Collection} Current collection instance.
	       */
	      add: function (items) {
	        var self = this;
	
	        // Force single item into array
	        if (!Tools.isArray(items)) {
	          if (items instanceof Collection) {
	            self.add(items.toArray());
	          } else {
	            push.call(self, items);
	          }
	        } else {
	          push.apply(self, items);
	        }
	
	        return self;
	      },
	
	      /**
	       * Sets the contents of the collection. This will remove any existing items
	       * and replace them with the ones specified in the input array.
	       *
	       * @method set
	       * @param {Array} items Array with items to set into the Collection.
	       * @return {tinymce.ui.Collection} Collection instance.
	       */
	      set: function (items) {
	        var self = this, len = self.length, i;
	
	        self.length = 0;
	        self.add(items);
	
	        // Remove old entries
	        for (i = self.length; i < len; i++) {
	          delete self[i];
	        }
	
	        return self;
	      },
	
	      /**
	       * Filters the collection item based on the specified selector expression or selector function.
	       *
	       * @method filter
	       * @param {String} selector Selector expression to filter items by.
	       * @return {tinymce.ui.Collection} Collection containing the filtered items.
	       */
	      filter: function (selector) {
	        var self = this, i, l, matches = [], item, match;
	
	        // Compile string into selector expression
	        if (typeof selector === "string") {
	          selector = new Selector(selector);
	
	          match = function (item) {
	            return selector.match(item);
	          };
	        } else {
	          // Use selector as matching function
	          match = selector;
	        }
	
	        for (i = 0, l = self.length; i < l; i++) {
	          item = self[i];
	
	          if (match(item)) {
	            matches.push(item);
	          }
	        }
	
	        return new Collection(matches);
	      },
	
	      /**
	       * Slices the items within the collection.
	       *
	       * @method slice
	       * @param {Number} index Index to slice at.
	       * @param {Number} len Optional length to slice.
	       * @return {tinymce.ui.Collection} Current collection.
	       */
	      slice: function () {
	        return new Collection(slice.apply(this, arguments));
	      },
	
	      /**
	       * Makes the current collection equal to the specified index.
	       *
	       * @method eq
	       * @param {Number} index Index of the item to set the collection to.
	       * @return {tinymce.ui.Collection} Current collection.
	       */
	      eq: function (index) {
	        return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
	      },
	
	      /**
	       * Executes the specified callback on each item in collection.
	       *
	       * @method each
	       * @param {function} callback Callback to execute for each item in collection.
	       * @return {tinymce.ui.Collection} Current collection instance.
	       */
	      each: function (callback) {
	        Tools.each(this, callback);
	
	        return this;
	      },
	
	      /**
	       * Returns an JavaScript array object of the contents inside the collection.
	       *
	       * @method toArray
	       * @return {Array} Array with all items from collection.
	       */
	      toArray: function () {
	        return Tools.toArray(this);
	      },
	
	      /**
	       * Finds the index of the specified control or return -1 if it isn't in the collection.
	       *
	       * @method indexOf
	       * @param {Control} ctrl Control instance to look for.
	       * @return {Number} Index of the specified control or -1.
	       */
	      indexOf: function (ctrl) {
	        var self = this, i = self.length;
	
	        while (i--) {
	          if (self[i] === ctrl) {
	            break;
	          }
	        }
	
	        return i;
	      },
	
	      /**
	       * Returns a new collection of the contents in reverse order.
	       *
	       * @method reverse
	       * @return {tinymce.ui.Collection} Collection instance with reversed items.
	       */
	      reverse: function () {
	        return new Collection(Tools.toArray(this).reverse());
	      },
	
	      /**
	       * Returns true/false if the class exists or not.
	       *
	       * @method hasClass
	       * @param {String} cls Class to check for.
	       * @return {Boolean} true/false state if the class exists or not.
	       */
	      hasClass: function (cls) {
	        return this[0] ? this[0].classes.contains(cls) : false;
	      },
	
	      /**
	       * Sets/gets the specific property on the items in the collection. The same as executing control.<property>(<value>);
	       *
	       * @method prop
	       * @param {String} name Property name to get/set.
	       * @param {Object} value Optional object value to set.
	       * @return {tinymce.ui.Collection} Current collection instance or value of the first item on a get operation.
	       */
	      prop: function (name, value) {
	        var self = this, undef, item;
	
	        if (value !== undef) {
	          self.each(function (item) {
	            if (item[name]) {
	              item[name](value);
	            }
	          });
	
	          return self;
	        }
	
	        item = self[0];
	
	        if (item && item[name]) {
	          return item[name]();
	        }
	      },
	
	      /**
	       * Executes the specific function name with optional arguments an all items in collection if it exists.
	       *
	       * @example collection.exec("myMethod", arg1, arg2, arg3);
	       * @method exec
	       * @param {String} name Name of the function to execute.
	       * @param {Object} ... Multiple arguments to pass to each function.
	       * @return {tinymce.ui.Collection} Current collection.
	       */
	      exec: function (name) {
	        var self = this, args = Tools.toArray(arguments).slice(1);
	
	        self.each(function (item) {
	          if (item[name]) {
	            item[name].apply(item, args);
	          }
	        });
	
	        return self;
	      },
	
	      /**
	       * Remove all items from collection and DOM.
	       *
	       * @method remove
	       * @return {tinymce.ui.Collection} Current collection.
	       */
	      remove: function () {
	        var i = this.length;
	
	        while (i--) {
	          this[i].remove();
	        }
	
	        return this;
	      },
	
	      /**
	       * Adds a class to all items in the collection.
	       *
	       * @method addClass
	       * @param {String} cls Class to add to each item.
	       * @return {tinymce.ui.Collection} Current collection instance.
	       */
	      addClass: function (cls) {
	        return this.each(function (item) {
	          item.classes.add(cls);
	        });
	      },
	
	      /**
	       * Removes the specified class from all items in collection.
	       *
	       * @method removeClass
	       * @param {String} cls Class to remove from each item.
	       * @return {tinymce.ui.Collection} Current collection instance.
	       */
	      removeClass: function (cls) {
	        return this.each(function (item) {
	          item.classes.remove(cls);
	        });
	      }
	
	      /**
	       * Fires the specified event by name and arguments on the control. This will execute all
	       * bound event handlers.
	       *
	       * @method fire
	       * @param {String} name Name of the event to fire.
	       * @param {Object} args Optional arguments to pass to the event.
	       * @return {tinymce.ui.Collection} Current collection instance.
	       */
	      // fire: function(event, args) {}, -- Generated by code below
	
	      /**
	       * Binds a callback to the specified event. This event can both be
	       * native browser events like "click" or custom ones like PostRender.
	       *
	       * The callback function gets one parameter: either the browser's native event object or a custom JS object.
	       *
	       * @method on
	       * @param {String} name Name of the event to bind. For example "click".
	       * @param {String/function} callback Callback function to execute once the event occurs.
	       * @return {tinymce.ui.Collection} Current collection instance.
	       */
	      // on: function(name, callback) {}, -- Generated by code below
	
	      /**
	       * Unbinds the specified event and optionally a specific callback. If you omit the name
	       * parameter all event handlers will be removed. If you omit the callback all event handles
	       * by the specified name will be removed.
	       *
	       * @method off
	       * @param {String} name Optional name for the event to unbind.
	       * @param {function} callback Optional callback function to unbind.
	       * @return {tinymce.ui.Collection} Current collection instance.
	       */
	      // off: function(name, callback) {}, -- Generated by code below
	
	      /**
	       * Shows the items in the current collection.
	       *
	       * @method show
	       * @return {tinymce.ui.Collection} Current collection instance.
	       */
	      // show: function() {}, -- Generated by code below
	
	      /**
	       * Hides the items in the current collection.
	       *
	       * @method hide
	       * @return {tinymce.ui.Collection} Current collection instance.
	       */
	      // hide: function() {}, -- Generated by code below
	
	      /**
	       * Sets/gets the text contents of the items in the current collection.
	       *
	       * @method text
	       * @return {tinymce.ui.Collection} Current collection instance or text value of the first item on a get operation.
	       */
	      // text: function(value) {}, -- Generated by code below
	
	      /**
	       * Sets/gets the name contents of the items in the current collection.
	       *
	       * @method name
	       * @return {tinymce.ui.Collection} Current collection instance or name value of the first item on a get operation.
	       */
	      // name: function(value) {}, -- Generated by code below
	
	      /**
	       * Sets/gets the disabled state on the items in the current collection.
	       *
	       * @method disabled
	       * @return {tinymce.ui.Collection} Current collection instance or disabled state of the first item on a get operation.
	       */
	      // disabled: function(state) {}, -- Generated by code below
	
	      /**
	       * Sets/gets the active state on the items in the current collection.
	       *
	       * @method active
	       * @return {tinymce.ui.Collection} Current collection instance or active state of the first item on a get operation.
	       */
	      // active: function(state) {}, -- Generated by code below
	
	      /**
	       * Sets/gets the selected state on the items in the current collection.
	       *
	       * @method selected
	       * @return {tinymce.ui.Collection} Current collection instance or selected state of the first item on a get operation.
	       */
	      // selected: function(state) {}, -- Generated by code below
	
	      /**
	       * Sets/gets the selected state on the items in the current collection.
	       *
	       * @method visible
	       * @return {tinymce.ui.Collection} Current collection instance or visible state of the first item on a get operation.
	       */
	      // visible: function(state) {}, -- Generated by code below
	    };
	
	    // Extend tinymce.ui.Collection prototype with some generated control specific methods
	    Tools.each('fire on off show hide append prepend before after reflow'.split(' '), function (name) {
	      proto[name] = function () {
	        var args = Tools.toArray(arguments);
	
	        this.each(function (ctrl) {
	          if (name in ctrl) {
	            ctrl[name].apply(ctrl, args);
	          }
	        });
	
	        return this;
	      };
	    });
	
	    // Extend tinymce.ui.Collection prototype with some property methods
	    Tools.each('text name disabled active selected checked visible parent value data'.split(' '), function (name) {
	      proto[name] = function (value) {
	        return this.prop(name, value);
	      };
	    });
	
	    // Create class based on the new prototype
	    Collection = Class.extend(proto);
	
	    // Stick Collection into Selector to prevent circual references
	    Selector.Collection = Collection;
	
	    return Collection;
	  }
	);
	
	/**
	 * Binding.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class gets dynamically extended to provide a binding between two models. This makes it possible to
	 * sync the state of two properties in two models by a layer of abstraction.
	 *
	 * @private
	 * @class tinymce.data.Binding
	 */
	define(
	  'tinymce.ui.data.Binding',
	  [
	  ],
	  function () {
	    /**
	     * Constructs a new bidning.
	     *
	     * @constructor
	     * @method Binding
	     * @param {Object} settings Settings to the binding.
	     */
	    function Binding(settings) {
	      this.create = settings.create;
	    }
	
	    /**
	     * Creates a binding for a property on a model.
	     *
	     * @method create
	     * @param {tinymce.data.ObservableObject} model Model to create binding to.
	     * @param {String} name Name of property to bind.
	     * @return {tinymce.data.Binding} Binding instance.
	     */
	    Binding.create = function (model, name) {
	      return new Binding({
	        create: function (otherModel, otherName) {
	          var bindings;
	
	          function fromSelfToOther(e) {
	            otherModel.set(otherName, e.value);
	          }
	
	          function fromOtherToSelf(e) {
	            model.set(name, e.value);
	          }
	
	          otherModel.on('change:' + otherName, fromOtherToSelf);
	          model.on('change:' + name, fromSelfToOther);
	
	          // Keep track of the bindings
	          bindings = otherModel._bindings;
	
	          if (!bindings) {
	            bindings = otherModel._bindings = [];
	
	            otherModel.on('destroy', function () {
	              var i = bindings.length;
	
	              while (i--) {
	                bindings[i]();
	              }
	            });
	          }
	
	          bindings.push(function () {
	            model.off('change:' + name, fromSelfToOther);
	          });
	
	          return model.get(name);
	        }
	      });
	    };
	
	    return Binding;
	  }
	);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Observable',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Observable');
	  }
	);
	
	/**
	 * ObservableObject.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is a object that is observable when properties changes a change event gets emitted.
	 *
	 * @private
	 * @class tinymce.data.ObservableObject
	 */
	define(
	  'tinymce.ui.data.ObservableObject',
	  [
	    'tinymce.ui.data.Binding',
	    'tinymce.core.util.Class',
	    'tinymce.core.util.Observable',
	    'tinymce.core.util.Tools'
	  ], function (Binding, Class, Observable, Tools) {
	    function isNode(node) {
	      return node.nodeType > 0;
	    }
	
	    // Todo: Maybe this should be shallow compare since it might be huge object references
	    function isEqual(a, b) {
	      var k, checked;
	
	      // Strict equals
	      if (a === b) {
	        return true;
	      }
	
	      // Compare null
	      if (a === null || b === null) {
	        return a === b;
	      }
	
	      // Compare number, boolean, string, undefined
	      if (typeof a !== "object" || typeof b !== "object") {
	        return a === b;
	      }
	
	      // Compare arrays
	      if (Tools.isArray(b)) {
	        if (a.length !== b.length) {
	          return false;
	        }
	
	        k = a.length;
	        while (k--) {
	          if (!isEqual(a[k], b[k])) {
	            return false;
	          }
	        }
	      }
	
	      // Shallow compare nodes
	      if (isNode(a) || isNode(b)) {
	        return a === b;
	      }
	
	      // Compare objects
	      checked = {};
	      for (k in b) {
	        if (!isEqual(a[k], b[k])) {
	          return false;
	        }
	
	        checked[k] = true;
	      }
	
	      for (k in a) {
	        if (!checked[k] && !isEqual(a[k], b[k])) {
	          return false;
	        }
	      }
	
	      return true;
	    }
	
	    return Class.extend({
	      Mixins: [Observable],
	
	      /**
	       * Constructs a new observable object instance.
	       *
	       * @constructor
	       * @param {Object} data Initial data for the object.
	       */
	      init: function (data) {
	        var name, value;
	
	        data = data || {};
	
	        for (name in data) {
	          value = data[name];
	
	          if (value instanceof Binding) {
	            data[name] = value.create(this, name);
	          }
	        }
	
	        this.data = data;
	      },
	
	      /**
	       * Sets a property on the value this will call
	       * observers if the value is a change from the current value.
	       *
	       * @method set
	       * @param {String/object} name Name of the property to set or a object of items to set.
	       * @param {Object} value Value to set for the property.
	       * @return {tinymce.data.ObservableObject} Observable object instance.
	       */
	      set: function (name, value) {
	        var key, args, oldValue = this.data[name];
	
	        if (value instanceof Binding) {
	          value = value.create(this, name);
	        }
	
	        if (typeof name === "object") {
	          for (key in name) {
	            this.set(key, name[key]);
	          }
	
	          return this;
	        }
	
	        if (!isEqual(oldValue, value)) {
	          this.data[name] = value;
	
	          args = {
	            target: this,
	            name: name,
	            value: value,
	            oldValue: oldValue
	          };
	
	          this.fire('change:' + name, args);
	          this.fire('change', args);
	        }
	
	        return this;
	      },
	
	      /**
	       * Gets a property by name.
	       *
	       * @method get
	       * @param {String} name Name of the property to get.
	       * @return {Object} Object value of propery.
	       */
	      get: function (name) {
	        return this.data[name];
	      },
	
	      /**
	       * Returns true/false if the specified property exists.
	       *
	       * @method has
	       * @param {String} name Name of the property to check for.
	       * @return {Boolean} true/false if the item exists.
	       */
	      has: function (name) {
	        return name in this.data;
	      },
	
	      /**
	       * Returns a dynamic property binding for the specified property name. This makes
	       * it possible to sync the state of two properties in two ObservableObject instances.
	       *
	       * @method bind
	       * @param {String} name Name of the property to sync with the property it's inserted to.
	       * @return {tinymce.data.Binding} Data binding instance.
	       */
	      bind: function (name) {
	        return Binding.create(this, name);
	      },
	
	      /**
	       * Destroys the observable object and fires the "destroy"
	       * event and clean up any internal resources.
	       *
	       * @method destroy
	       */
	      destroy: function () {
	        this.fire('destroy');
	      }
	    });
	  }
	);
	/**
	 * ReflowQueue.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class will automatically reflow controls on the next animation frame within a few milliseconds on older browsers.
	 * If the user manually reflows then the automatic reflow will be cancelled. This class is used internally when various control states
	 * changes that triggers a reflow.
	 *
	 * @class tinymce.ui.ReflowQueue
	 * @static
	 */
	define(
	  'tinymce.ui.ReflowQueue',
	  [
	    'global!document',
	    'tinymce.core.util.Delay'
	  ],
	  function (document, Delay) {
	    var dirtyCtrls = {}, animationFrameRequested;
	
	    return {
	      /**
	       * Adds a control to the next automatic reflow call. This is the control that had a state
	       * change for example if the control was hidden/shown.
	       *
	       * @method add
	       * @param {tinymce.ui.Control} ctrl Control to add to queue.
	       */
	      add: function (ctrl) {
	        var parent = ctrl.parent();
	
	        if (parent) {
	          if (!parent._layout || parent._layout.isNative()) {
	            return;
	          }
	
	          if (!dirtyCtrls[parent._id]) {
	            dirtyCtrls[parent._id] = parent;
	          }
	
	          if (!animationFrameRequested) {
	            animationFrameRequested = true;
	
	            Delay.requestAnimationFrame(function () {
	              var id, ctrl;
	
	              animationFrameRequested = false;
	
	              for (id in dirtyCtrls) {
	                ctrl = dirtyCtrls[id];
	
	                if (ctrl.state.get('rendered')) {
	                  ctrl.reflow();
	                }
	              }
	
	              dirtyCtrls = {};
	            }, document.body);
	          }
	        }
	      },
	
	      /**
	       * Removes the specified control from the automatic reflow. This will happen when for example the user
	       * manually triggers a reflow.
	       *
	       * @method remove
	       * @param {tinymce.ui.Control} ctrl Control to remove from queue.
	       */
	      remove: function (ctrl) {
	        if (dirtyCtrls[ctrl._id]) {
	          delete dirtyCtrls[ctrl._id];
	        }
	      }
	    };
	  }
	);
	
	/**
	 * Control.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*eslint consistent-this:0 */
	
	/**
	 * This is the base class for all controls and containers. All UI control instances inherit
	 * from this one as it has the base logic needed by all of them.
	 *
	 * @class tinymce.ui.Control
	 */
	define(
	  'tinymce.ui.Control',
	  [
	    'global!document',
	    'tinymce.core.dom.DomQuery',
	    'tinymce.core.util.Class',
	    'tinymce.core.util.EventDispatcher',
	    'tinymce.core.util.Tools',
	    'tinymce.ui.BoxUtils',
	    'tinymce.ui.ClassList',
	    'tinymce.ui.Collection',
	    'tinymce.ui.data.ObservableObject',
	    'tinymce.ui.DomUtils',
	    'tinymce.ui.ReflowQueue'
	  ],
	  function (document, DomQuery, Class, EventDispatcher, Tools, BoxUtils, ClassList, Collection, ObservableObject, DomUtils, ReflowQueue) {
	    "use strict";
	
	    var hasMouseWheelEventSupport = "onmousewheel" in document;
	    var hasWheelEventSupport = false;
	    var classPrefix = "mce-";
	    var Control, idCounter = 0;
	
	    var proto = {
	      Statics: {
	        classPrefix: classPrefix
	      },
	
	      isRtl: function () {
	        return Control.rtl;
	      },
	
	      /**
	       * Class/id prefix to use for all controls.
	       *
	       * @final
	       * @field {String} classPrefix
	       */
	      classPrefix: classPrefix,
	
	      /**
	       * Constructs a new control instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {String} style Style CSS properties to add.
	       * @setting {String} border Border box values example: 1 1 1 1
	       * @setting {String} padding Padding box values example: 1 1 1 1
	       * @setting {String} margin Margin box values example: 1 1 1 1
	       * @setting {Number} minWidth Minimal width for the control.
	       * @setting {Number} minHeight Minimal height for the control.
	       * @setting {String} classes Space separated list of classes to add.
	       * @setting {String} role WAI-ARIA role to use for control.
	       * @setting {Boolean} hidden Is the control hidden by default.
	       * @setting {Boolean} disabled Is the control disabled by default.
	       * @setting {String} name Name of the control instance.
	       */
	      init: function (settings) {
	        var self = this, classes, defaultClasses;
	
	        function applyClasses(classes) {
	          var i;
	
	          classes = classes.split(' ');
	          for (i = 0; i < classes.length; i++) {
	            self.classes.add(classes[i]);
	          }
	        }
	
	        self.settings = settings = Tools.extend({}, self.Defaults, settings);
	
	        // Initial states
	        self._id = settings.id || ('mceu_' + (idCounter++));
	        self._aria = { role: settings.role };
	        self._elmCache = {};
	        self.$ = DomQuery;
	
	        self.state = new ObservableObject({
	          visible: true,
	          active: false,
	          disabled: false,
	          value: ''
	        });
	
	        self.data = new ObservableObject(settings.data);
	
	        self.classes = new ClassList(function () {
	          if (self.state.get('rendered')) {
	            self.getEl().className = this.toString();
	          }
	        });
	        self.classes.prefix = self.classPrefix;
	
	        // Setup classes
	        classes = settings.classes;
	        if (classes) {
	          if (self.Defaults) {
	            defaultClasses = self.Defaults.classes;
	
	            if (defaultClasses && classes != defaultClasses) {
	              applyClasses(defaultClasses);
	            }
	          }
	
	          applyClasses(classes);
	        }
	
	        Tools.each('title text name visible disabled active value'.split(' '), function (name) {
	          if (name in settings) {
	            self[name](settings[name]);
	          }
	        });
	
	        self.on('click', function () {
	          if (self.disabled()) {
	            return false;
	          }
	        });
	
	        /**
	         * Name/value object with settings for the current control.
	         *
	         * @field {Object} settings
	         */
	        self.settings = settings;
	
	        self.borderBox = BoxUtils.parseBox(settings.border);
	        self.paddingBox = BoxUtils.parseBox(settings.padding);
	        self.marginBox = BoxUtils.parseBox(settings.margin);
	
	        if (settings.hidden) {
	          self.hide();
	        }
	      },
	
	      // Will generate getter/setter methods for these properties
	      Properties: 'parent,name',
	
	      /**
	       * Returns the root element to render controls into.
	       *
	       * @method getContainerElm
	       * @return {Element} HTML DOM element to render into.
	       */
	      getContainerElm: function () {
	        return DomUtils.getContainer();
	      },
	
	      /**
	       * Returns a control instance for the current DOM element.
	       *
	       * @method getParentCtrl
	       * @param {Element} elm HTML dom element to get parent control from.
	       * @return {tinymce.ui.Control} Control instance or undefined.
	       */
	      getParentCtrl: function (elm) {
	        var ctrl, lookup = this.getRoot().controlIdLookup;
	
	        while (elm && lookup) {
	          ctrl = lookup[elm.id];
	          if (ctrl) {
	            break;
	          }
	
	          elm = elm.parentNode;
	        }
	
	        return ctrl;
	      },
	
	      /**
	       * Initializes the current controls layout rect.
	       * This will be executed by the layout managers to determine the
	       * default minWidth/minHeight etc.
	       *
	       * @method initLayoutRect
	       * @return {Object} Layout rect instance.
	       */
	      initLayoutRect: function () {
	        var self = this, settings = self.settings, borderBox, layoutRect;
	        var elm = self.getEl(), width, height, minWidth, minHeight, autoResize;
	        var startMinWidth, startMinHeight, initialSize;
	
	        // Measure the current element
	        borderBox = self.borderBox = self.borderBox || BoxUtils.measureBox(elm, 'border');
	        self.paddingBox = self.paddingBox || BoxUtils.measureBox(elm, 'padding');
	        self.marginBox = self.marginBox || BoxUtils.measureBox(elm, 'margin');
	        initialSize = DomUtils.getSize(elm);
	
	        // Setup minWidth/minHeight and width/height
	        startMinWidth = settings.minWidth;
	        startMinHeight = settings.minHeight;
	        minWidth = startMinWidth || initialSize.width;
	        minHeight = startMinHeight || initialSize.height;
	        width = settings.width;
	        height = settings.height;
	        autoResize = settings.autoResize;
	        autoResize = typeof autoResize != "undefined" ? autoResize : !width && !height;
	
	        width = width || minWidth;
	        height = height || minHeight;
	
	        var deltaW = borderBox.left + borderBox.right;
	        var deltaH = borderBox.top + borderBox.bottom;
	
	        var maxW = settings.maxWidth || 0xFFFF;
	        var maxH = settings.maxHeight || 0xFFFF;
	
	        // Setup initial layout rect
	        self._layoutRect = layoutRect = {
	          x: settings.x || 0,
	          y: settings.y || 0,
	          w: width,
	          h: height,
	          deltaW: deltaW,
	          deltaH: deltaH,
	          contentW: width - deltaW,
	          contentH: height - deltaH,
	          innerW: width - deltaW,
	          innerH: height - deltaH,
	          startMinWidth: startMinWidth || 0,
	          startMinHeight: startMinHeight || 0,
	          minW: Math.min(minWidth, maxW),
	          minH: Math.min(minHeight, maxH),
	          maxW: maxW,
	          maxH: maxH,
	          autoResize: autoResize,
	          scrollW: 0
	        };
	
	        self._lastLayoutRect = {};
	
	        return layoutRect;
	      },
	
	      /**
	       * Getter/setter for the current layout rect.
	       *
	       * @method layoutRect
	       * @param {Object} [newRect] Optional new layout rect.
	       * @return {tinymce.ui.Control/Object} Current control or rect object.
	       */
	      layoutRect: function (newRect) {
	        var self = this, curRect = self._layoutRect, lastLayoutRect, size, deltaWidth, deltaHeight, undef, repaintControls;
	
	        // Initialize default layout rect
	        if (!curRect) {
	          curRect = self.initLayoutRect();
	        }
	
	        // Set new rect values
	        if (newRect) {
	          // Calc deltas between inner and outer sizes
	          deltaWidth = curRect.deltaW;
	          deltaHeight = curRect.deltaH;
	
	          // Set x position
	          if (newRect.x !== undef) {
	            curRect.x = newRect.x;
	          }
	
	          // Set y position
	          if (newRect.y !== undef) {
	            curRect.y = newRect.y;
	          }
	
	          // Set minW
	          if (newRect.minW !== undef) {
	            curRect.minW = newRect.minW;
	          }
	
	          // Set minH
	          if (newRect.minH !== undef) {
	            curRect.minH = newRect.minH;
	          }
	
	          // Set new width and calculate inner width
	          size = newRect.w;
	          if (size !== undef) {
	            size = size < curRect.minW ? curRect.minW : size;
	            size = size > curRect.maxW ? curRect.maxW : size;
	            curRect.w = size;
	            curRect.innerW = size - deltaWidth;
	          }
	
	          // Set new height and calculate inner height
	          size = newRect.h;
	          if (size !== undef) {
	            size = size < curRect.minH ? curRect.minH : size;
	            size = size > curRect.maxH ? curRect.maxH : size;
	            curRect.h = size;
	            curRect.innerH = size - deltaHeight;
	          }
	
	          // Set new inner width and calculate width
	          size = newRect.innerW;
	          if (size !== undef) {
	            size = size < curRect.minW - deltaWidth ? curRect.minW - deltaWidth : size;
	            size = size > curRect.maxW - deltaWidth ? curRect.maxW - deltaWidth : size;
	            curRect.innerW = size;
	            curRect.w = size + deltaWidth;
	          }
	
	          // Set new height and calculate inner height
	          size = newRect.innerH;
	          if (size !== undef) {
	            size = size < curRect.minH - deltaHeight ? curRect.minH - deltaHeight : size;
	            size = size > curRect.maxH - deltaHeight ? curRect.maxH - deltaHeight : size;
	            curRect.innerH = size;
	            curRect.h = size + deltaHeight;
	          }
	
	          // Set new contentW
	          if (newRect.contentW !== undef) {
	            curRect.contentW = newRect.contentW;
	          }
	
	          // Set new contentH
	          if (newRect.contentH !== undef) {
	            curRect.contentH = newRect.contentH;
	          }
	
	          // Compare last layout rect with the current one to see if we need to repaint or not
	          lastLayoutRect = self._lastLayoutRect;
	          if (lastLayoutRect.x !== curRect.x || lastLayoutRect.y !== curRect.y ||
	            lastLayoutRect.w !== curRect.w || lastLayoutRect.h !== curRect.h) {
	            repaintControls = Control.repaintControls;
	
	            if (repaintControls) {
	              if (repaintControls.map && !repaintControls.map[self._id]) {
	                repaintControls.push(self);
	                repaintControls.map[self._id] = true;
	              }
	            }
	
	            lastLayoutRect.x = curRect.x;
	            lastLayoutRect.y = curRect.y;
	            lastLayoutRect.w = curRect.w;
	            lastLayoutRect.h = curRect.h;
	          }
	
	          return self;
	        }
	
	        return curRect;
	      },
	
	      /**
	       * Repaints the control after a layout operation.
	       *
	       * @method repaint
	       */
	      repaint: function () {
	        var self = this, style, bodyStyle, bodyElm, rect, borderBox;
	        var borderW, borderH, lastRepaintRect, round, value;
	
	        // Use Math.round on all values on IE < 9
	        round = !document.createRange ? Math.round : function (value) {
	          return value;
	        };
	
	        style = self.getEl().style;
	        rect = self._layoutRect;
	        lastRepaintRect = self._lastRepaintRect || {};
	
	        borderBox = self.borderBox;
	        borderW = borderBox.left + borderBox.right;
	        borderH = borderBox.top + borderBox.bottom;
	
	        if (rect.x !== lastRepaintRect.x) {
	          style.left = round(rect.x) + 'px';
	          lastRepaintRect.x = rect.x;
	        }
	
	        if (rect.y !== lastRepaintRect.y) {
	          style.top = round(rect.y) + 'px';
	          lastRepaintRect.y = rect.y;
	        }
	
	        if (rect.w !== lastRepaintRect.w) {
	          value = round(rect.w - borderW);
	          style.width = (value >= 0 ? value : 0) + 'px';
	          lastRepaintRect.w = rect.w;
	        }
	
	        if (rect.h !== lastRepaintRect.h) {
	          value = round(rect.h - borderH);
	          style.height = (value >= 0 ? value : 0) + 'px';
	          lastRepaintRect.h = rect.h;
	        }
	
	        // Update body if needed
	        if (self._hasBody && rect.innerW !== lastRepaintRect.innerW) {
	          value = round(rect.innerW);
	
	          bodyElm = self.getEl('body');
	          if (bodyElm) {
	            bodyStyle = bodyElm.style;
	            bodyStyle.width = (value >= 0 ? value : 0) + 'px';
	          }
	
	          lastRepaintRect.innerW = rect.innerW;
	        }
	
	        if (self._hasBody && rect.innerH !== lastRepaintRect.innerH) {
	          value = round(rect.innerH);
	
	          bodyElm = bodyElm || self.getEl('body');
	          if (bodyElm) {
	            bodyStyle = bodyStyle || bodyElm.style;
	            bodyStyle.height = (value >= 0 ? value : 0) + 'px';
	          }
	
	          lastRepaintRect.innerH = rect.innerH;
	        }
	
	        self._lastRepaintRect = lastRepaintRect;
	        self.fire('repaint', {}, false);
	      },
	
	      /**
	       * Updates the controls layout rect by re-measuing it.
	       */
	      updateLayoutRect: function () {
	        var self = this;
	
	        self.parent()._lastRect = null;
	
	        DomUtils.css(self.getEl(), { width: '', height: '' });
	
	        self._layoutRect = self._lastRepaintRect = self._lastLayoutRect = null;
	        self.initLayoutRect();
	      },
	
	      /**
	       * Binds a callback to the specified event. This event can both be
	       * native browser events like "click" or custom ones like PostRender.
	       *
	       * The callback function will be passed a DOM event like object that enables yout do stop propagation.
	       *
	       * @method on
	       * @param {String} name Name of the event to bind. For example "click".
	       * @param {String/function} callback Callback function to execute ones the event occurs.
	       * @return {tinymce.ui.Control} Current control object.
	       */
	      on: function (name, callback) {
	        var self = this;
	
	        function resolveCallbackName(name) {
	          var callback, scope;
	
	          if (typeof name != 'string') {
	            return name;
	          }
	
	          return function (e) {
	            if (!callback) {
	              self.parentsAndSelf().each(function (ctrl) {
	                var callbacks = ctrl.settings.callbacks;
	
	                if (callbacks && (callback = callbacks[name])) {
	                  scope = ctrl;
	                  return false;
	                }
	              });
	            }
	
	            if (!callback) {
	              e.action = name;
	              this.fire('execute', e);
	              return;
	            }
	
	            return callback.call(scope, e);
	          };
	        }
	
	        getEventDispatcher(self).on(name, resolveCallbackName(callback));
	
	        return self;
	      },
	
	      /**
	       * Unbinds the specified event and optionally a specific callback. If you omit the name
	       * parameter all event handlers will be removed. If you omit the callback all event handles
	       * by the specified name will be removed.
	       *
	       * @method off
	       * @param {String} [name] Name for the event to unbind.
	       * @param {function} [callback] Callback function to unbind.
	       * @return {tinymce.ui.Control} Current control object.
	       */
	      off: function (name, callback) {
	        getEventDispatcher(this).off(name, callback);
	        return this;
	      },
	
	      /**
	       * Fires the specified event by name and arguments on the control. This will execute all
	       * bound event handlers.
	       *
	       * @method fire
	       * @param {String} name Name of the event to fire.
	       * @param {Object} [args] Arguments to pass to the event.
	       * @param {Boolean} [bubble] Value to control bubbling. Defaults to true.
	       * @return {Object} Current arguments object.
	       */
	      fire: function (name, args, bubble) {
	        var self = this;
	
	        args = args || {};
	
	        if (!args.control) {
	          args.control = self;
	        }
	
	        args = getEventDispatcher(self).fire(name, args);
	
	        // Bubble event up to parents
	        if (bubble !== false && self.parent) {
	          var parent = self.parent();
	          while (parent && !args.isPropagationStopped()) {
	            parent.fire(name, args, false);
	            parent = parent.parent();
	          }
	        }
	
	        return args;
	      },
	
	      /**
	       * Returns true/false if the specified event has any listeners.
	       *
	       * @method hasEventListeners
	       * @param {String} name Name of the event to check for.
	       * @return {Boolean} True/false state if the event has listeners.
	       */
	      hasEventListeners: function (name) {
	        return getEventDispatcher(this).has(name);
	      },
	
	      /**
	       * Returns a control collection with all parent controls.
	       *
	       * @method parents
	       * @param {String} selector Optional selector expression to find parents.
	       * @return {tinymce.ui.Collection} Collection with all parent controls.
	       */
	      parents: function (selector) {
	        var self = this, ctrl, parents = new Collection();
	
	        // Add each parent to collection
	        for (ctrl = self.parent(); ctrl; ctrl = ctrl.parent()) {
	          parents.add(ctrl);
	        }
	
	        // Filter away everything that doesn't match the selector
	        if (selector) {
	          parents = parents.filter(selector);
	        }
	
	        return parents;
	      },
	
	      /**
	       * Returns the current control and it's parents.
	       *
	       * @method parentsAndSelf
	       * @param {String} selector Optional selector expression to find parents.
	       * @return {tinymce.ui.Collection} Collection with all parent controls.
	       */
	      parentsAndSelf: function (selector) {
	        return new Collection(this).add(this.parents(selector));
	      },
	
	      /**
	       * Returns the control next to the current control.
	       *
	       * @method next
	       * @return {tinymce.ui.Control} Next control instance.
	       */
	      next: function () {
	        var parentControls = this.parent().items();
	
	        return parentControls[parentControls.indexOf(this) + 1];
	      },
	
	      /**
	       * Returns the control previous to the current control.
	       *
	       * @method prev
	       * @return {tinymce.ui.Control} Previous control instance.
	       */
	      prev: function () {
	        var parentControls = this.parent().items();
	
	        return parentControls[parentControls.indexOf(this) - 1];
	      },
	
	      /**
	       * Sets the inner HTML of the control element.
	       *
	       * @method innerHtml
	       * @param {String} html Html string to set as inner html.
	       * @return {tinymce.ui.Control} Current control object.
	       */
	      innerHtml: function (html) {
	        this.$el.html(html);
	        return this;
	      },
	
	      /**
	       * Returns the control DOM element or sub element.
	       *
	       * @method getEl
	       * @param {String} [suffix] Suffix to get element by.
	       * @return {Element} HTML DOM element for the current control or it's children.
	       */
	      getEl: function (suffix) {
	        var id = suffix ? this._id + '-' + suffix : this._id;
	
	        if (!this._elmCache[id]) {
	          this._elmCache[id] = DomQuery('#' + id)[0];
	        }
	
	        return this._elmCache[id];
	      },
	
	      /**
	       * Sets the visible state to true.
	       *
	       * @method show
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      show: function () {
	        return this.visible(true);
	      },
	
	      /**
	       * Sets the visible state to false.
	       *
	       * @method hide
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      hide: function () {
	        return this.visible(false);
	      },
	
	      /**
	       * Focuses the current control.
	       *
	       * @method focus
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      focus: function () {
	        try {
	          this.getEl().focus();
	        } catch (ex) {
	          // Ignore IE error
	        }
	
	        return this;
	      },
	
	      /**
	       * Blurs the current control.
	       *
	       * @method blur
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      blur: function () {
	        this.getEl().blur();
	
	        return this;
	      },
	
	      /**
	       * Sets the specified aria property.
	       *
	       * @method aria
	       * @param {String} name Name of the aria property to set.
	       * @param {String} value Value of the aria property.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      aria: function (name, value) {
	        var self = this, elm = self.getEl(self.ariaTarget);
	
	        if (typeof value === "undefined") {
	          return self._aria[name];
	        }
	
	        self._aria[name] = value;
	
	        if (self.state.get('rendered')) {
	          elm.setAttribute(name == 'role' ? name : 'aria-' + name, value);
	        }
	
	        return self;
	      },
	
	      /**
	       * Encodes the specified string with HTML entities. It will also
	       * translate the string to different languages.
	       *
	       * @method encode
	       * @param {String/Object/Array} text Text to entity encode.
	       * @param {Boolean} [translate=true] False if the contents shouldn't be translated.
	       * @return {String} Encoded and possible traslated string.
	       */
	      encode: function (text, translate) {
	        if (translate !== false) {
	          text = this.translate(text);
	        }
	
	        return (text || '').replace(/[&<>"]/g, function (match) {
	          return '&#' + match.charCodeAt(0) + ';';
	        });
	      },
	
	      /**
	       * Returns the translated string.
	       *
	       * @method translate
	       * @param {String} text Text to translate.
	       * @return {String} Translated string or the same as the input.
	       */
	      translate: function (text) {
	        return Control.translate ? Control.translate(text) : text;
	      },
	
	      /**
	       * Adds items before the current control.
	       *
	       * @method before
	       * @param {Array/tinymce.ui.Collection} items Array of items to prepend before this control.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      before: function (items) {
	        var self = this, parent = self.parent();
	
	        if (parent) {
	          parent.insert(items, parent.items().indexOf(self), true);
	        }
	
	        return self;
	      },
	
	      /**
	       * Adds items after the current control.
	       *
	       * @method after
	       * @param {Array/tinymce.ui.Collection} items Array of items to append after this control.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      after: function (items) {
	        var self = this, parent = self.parent();
	
	        if (parent) {
	          parent.insert(items, parent.items().indexOf(self));
	        }
	
	        return self;
	      },
	
	      /**
	       * Removes the current control from DOM and from UI collections.
	       *
	       * @method remove
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      remove: function () {
	        var self = this, elm = self.getEl(), parent = self.parent(), newItems, i;
	
	        if (self.items) {
	          var controls = self.items().toArray();
	          i = controls.length;
	          while (i--) {
	            controls[i].remove();
	          }
	        }
	
	        if (parent && parent.items) {
	          newItems = [];
	
	          parent.items().each(function (item) {
	            if (item !== self) {
	              newItems.push(item);
	            }
	          });
	
	          parent.items().set(newItems);
	          parent._lastRect = null;
	        }
	
	        if (self._eventsRoot && self._eventsRoot == self) {
	          DomQuery(elm).off();
	        }
	
	        var lookup = self.getRoot().controlIdLookup;
	        if (lookup) {
	          delete lookup[self._id];
	        }
	
	        if (elm && elm.parentNode) {
	          elm.parentNode.removeChild(elm);
	        }
	
	        self.state.set('rendered', false);
	        self.state.destroy();
	
	        self.fire('remove');
	
	        return self;
	      },
	
	      /**
	       * Renders the control before the specified element.
	       *
	       * @method renderBefore
	       * @param {Element} elm Element to render before.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      renderBefore: function (elm) {
	        DomQuery(elm).before(this.renderHtml());
	        this.postRender();
	        return this;
	      },
	
	      /**
	       * Renders the control to the specified element.
	       *
	       * @method renderBefore
	       * @param {Element} elm Element to render to.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      renderTo: function (elm) {
	        DomQuery(elm || this.getContainerElm()).append(this.renderHtml());
	        this.postRender();
	        return this;
	      },
	
	      preRender: function () {
	      },
	
	      render: function () {
	      },
	
	      renderHtml: function () {
	        return '<div id="' + this._id + '" class="' + this.classes + '"></div>';
	      },
	
	      /**
	       * Post render method. Called after the control has been rendered to the target.
	       *
	       * @method postRender
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      postRender: function () {
	        var self = this, settings = self.settings, elm, box, parent, name, parentEventsRoot;
	
	        self.$el = DomQuery(self.getEl());
	        self.state.set('rendered', true);
	
	        // Bind on<event> settings
	        for (name in settings) {
	          if (name.indexOf("on") === 0) {
	            self.on(name.substr(2), settings[name]);
	          }
	        }
	
	        if (self._eventsRoot) {
	          for (parent = self.parent(); !parentEventsRoot && parent; parent = parent.parent()) {
	            parentEventsRoot = parent._eventsRoot;
	          }
	
	          if (parentEventsRoot) {
	            for (name in parentEventsRoot._nativeEvents) {
	              self._nativeEvents[name] = true;
	            }
	          }
	        }
	
	        bindPendingEvents(self);
	
	        if (settings.style) {
	          elm = self.getEl();
	          if (elm) {
	            elm.setAttribute('style', settings.style);
	            elm.style.cssText = settings.style;
	          }
	        }
	
	        if (self.settings.border) {
	          box = self.borderBox;
	          self.$el.css({
	            'border-top-width': box.top,
	            'border-right-width': box.right,
	            'border-bottom-width': box.bottom,
	            'border-left-width': box.left
	          });
	        }
	
	        // Add instance to lookup
	        var root = self.getRoot();
	        if (!root.controlIdLookup) {
	          root.controlIdLookup = {};
	        }
	
	        root.controlIdLookup[self._id] = self;
	
	        for (var key in self._aria) {
	          self.aria(key, self._aria[key]);
	        }
	
	        if (self.state.get('visible') === false) {
	          self.getEl().style.display = 'none';
	        }
	
	        self.bindStates();
	
	        self.state.on('change:visible', function (e) {
	          var state = e.value, parentCtrl;
	
	          if (self.state.get('rendered')) {
	            self.getEl().style.display = state === false ? 'none' : '';
	
	            // Need to force a reflow here on IE 8
	            self.getEl().getBoundingClientRect();
	          }
	
	          // Parent container needs to reflow
	          parentCtrl = self.parent();
	          if (parentCtrl) {
	            parentCtrl._lastRect = null;
	          }
	
	          self.fire(state ? 'show' : 'hide');
	
	          ReflowQueue.add(self);
	        });
	
	        self.fire('postrender', {}, false);
	      },
	
	      bindStates: function () {
	      },
	
	      /**
	       * Scrolls the current control into view.
	       *
	       * @method scrollIntoView
	       * @param {String} align Alignment in view top|center|bottom.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      scrollIntoView: function (align) {
	        function getOffset(elm, rootElm) {
	          var x, y, parent = elm;
	
	          x = y = 0;
	          while (parent && parent != rootElm && parent.nodeType) {
	            x += parent.offsetLeft || 0;
	            y += parent.offsetTop || 0;
	            parent = parent.offsetParent;
	          }
	
	          return { x: x, y: y };
	        }
	
	        var elm = this.getEl(), parentElm = elm.parentNode;
	        var x, y, width, height, parentWidth, parentHeight;
	        var pos = getOffset(elm, parentElm);
	
	        x = pos.x;
	        y = pos.y;
	        width = elm.offsetWidth;
	        height = elm.offsetHeight;
	        parentWidth = parentElm.clientWidth;
	        parentHeight = parentElm.clientHeight;
	
	        if (align == "end") {
	          x -= parentWidth - width;
	          y -= parentHeight - height;
	        } else if (align == "center") {
	          x -= (parentWidth / 2) - (width / 2);
	          y -= (parentHeight / 2) - (height / 2);
	        }
	
	        parentElm.scrollLeft = x;
	        parentElm.scrollTop = y;
	
	        return this;
	      },
	
	      getRoot: function () {
	        var ctrl = this, rootControl, parents = [];
	
	        while (ctrl) {
	          if (ctrl.rootControl) {
	            rootControl = ctrl.rootControl;
	            break;
	          }
	
	          parents.push(ctrl);
	          rootControl = ctrl;
	          ctrl = ctrl.parent();
	        }
	
	        if (!rootControl) {
	          rootControl = this;
	        }
	
	        var i = parents.length;
	        while (i--) {
	          parents[i].rootControl = rootControl;
	        }
	
	        return rootControl;
	      },
	
	      /**
	       * Reflows the current control and it's parents.
	       * This should be used after you for example append children to the current control so
	       * that the layout managers know that they need to reposition everything.
	       *
	       * @example
	       * container.append({type: 'button', text: 'My button'}).reflow();
	       *
	       * @method reflow
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      reflow: function () {
	        ReflowQueue.remove(this);
	
	        var parent = this.parent();
	        if (parent && parent._layout && !parent._layout.isNative()) {
	          parent.reflow();
	        }
	
	        return this;
	      }
	
	      /**
	       * Sets/gets the parent container for the control.
	       *
	       * @method parent
	       * @param {tinymce.ui.Container} parent Optional parent to set.
	       * @return {tinymce.ui.Control} Parent control or the current control on a set action.
	       */
	      // parent: function(parent) {} -- Generated
	
	      /**
	       * Sets/gets the text for the control.
	       *
	       * @method text
	       * @param {String} value Value to set to control.
	       * @return {String/tinymce.ui.Control} Current control on a set operation or current value on a get.
	       */
	      // text: function(value) {} -- Generated
	
	      /**
	       * Sets/gets the disabled state on the control.
	       *
	       * @method disabled
	       * @param {Boolean} state Value to set to control.
	       * @return {Boolean/tinymce.ui.Control} Current control on a set operation or current state on a get.
	       */
	      // disabled: function(state) {} -- Generated
	
	      /**
	       * Sets/gets the active for the control.
	       *
	       * @method active
	       * @param {Boolean} state Value to set to control.
	       * @return {Boolean/tinymce.ui.Control} Current control on a set operation or current state on a get.
	       */
	      // active: function(state) {} -- Generated
	
	      /**
	       * Sets/gets the name for the control.
	       *
	       * @method name
	       * @param {String} value Value to set to control.
	       * @return {String/tinymce.ui.Control} Current control on a set operation or current value on a get.
	       */
	      // name: function(value) {} -- Generated
	
	      /**
	       * Sets/gets the title for the control.
	       *
	       * @method title
	       * @param {String} value Value to set to control.
	       * @return {String/tinymce.ui.Control} Current control on a set operation or current value on a get.
	       */
	      // title: function(value) {} -- Generated
	
	      /**
	       * Sets/gets the visible for the control.
	       *
	       * @method visible
	       * @param {Boolean} state Value to set to control.
	       * @return {Boolean/tinymce.ui.Control} Current control on a set operation or current state on a get.
	       */
	      // visible: function(value) {} -- Generated
	    };
	
	    /**
	     * Setup state properties.
	     */
	    Tools.each('text title visible disabled active value'.split(' '), function (name) {
	      proto[name] = function (value) {
	        if (arguments.length === 0) {
	          return this.state.get(name);
	        }
	
	        if (typeof value != "undefined") {
	          this.state.set(name, value);
	        }
	
	        return this;
	      };
	    });
	
	    Control = Class.extend(proto);
	
	    function getEventDispatcher(obj) {
	      if (!obj._eventDispatcher) {
	        obj._eventDispatcher = new EventDispatcher({
	          scope: obj,
	          toggleEvent: function (name, state) {
	            if (state && EventDispatcher.isNative(name)) {
	              if (!obj._nativeEvents) {
	                obj._nativeEvents = {};
	              }
	
	              obj._nativeEvents[name] = true;
	
	              if (obj.state.get('rendered')) {
	                bindPendingEvents(obj);
	              }
	            }
	          }
	        });
	      }
	
	      return obj._eventDispatcher;
	    }
	
	    function bindPendingEvents(eventCtrl) {
	      var i, l, parents, eventRootCtrl, nativeEvents, name;
	
	      function delegate(e) {
	        var control = eventCtrl.getParentCtrl(e.target);
	
	        if (control) {
	          control.fire(e.type, e);
	        }
	      }
	
	      function mouseLeaveHandler() {
	        var ctrl = eventRootCtrl._lastHoverCtrl;
	
	        if (ctrl) {
	          ctrl.fire("mouseleave", { target: ctrl.getEl() });
	
	          ctrl.parents().each(function (ctrl) {
	            ctrl.fire("mouseleave", { target: ctrl.getEl() });
	          });
	
	          eventRootCtrl._lastHoverCtrl = null;
	        }
	      }
	
	      function mouseEnterHandler(e) {
	        var ctrl = eventCtrl.getParentCtrl(e.target), lastCtrl = eventRootCtrl._lastHoverCtrl, idx = 0, i, parents, lastParents;
	
	        // Over on a new control
	        if (ctrl !== lastCtrl) {
	          eventRootCtrl._lastHoverCtrl = ctrl;
	
	          parents = ctrl.parents().toArray().reverse();
	          parents.push(ctrl);
	
	          if (lastCtrl) {
	            lastParents = lastCtrl.parents().toArray().reverse();
	            lastParents.push(lastCtrl);
	
	            for (idx = 0; idx < lastParents.length; idx++) {
	              if (parents[idx] !== lastParents[idx]) {
	                break;
	              }
	            }
	
	            for (i = lastParents.length - 1; i >= idx; i--) {
	              lastCtrl = lastParents[i];
	              lastCtrl.fire("mouseleave", {
	                target: lastCtrl.getEl()
	              });
	            }
	          }
	
	          for (i = idx; i < parents.length; i++) {
	            ctrl = parents[i];
	            ctrl.fire("mouseenter", {
	              target: ctrl.getEl()
	            });
	          }
	        }
	      }
	
	      function fixWheelEvent(e) {
	        e.preventDefault();
	
	        if (e.type == "mousewheel") {
	          e.deltaY = -1 / 40 * e.wheelDelta;
	
	          if (e.wheelDeltaX) {
	            e.deltaX = -1 / 40 * e.wheelDeltaX;
	          }
	        } else {
	          e.deltaX = 0;
	          e.deltaY = e.detail;
	        }
	
	        e = eventCtrl.fire("wheel", e);
	      }
	
	      nativeEvents = eventCtrl._nativeEvents;
	      if (nativeEvents) {
	        // Find event root element if it exists
	        parents = eventCtrl.parents().toArray();
	        parents.unshift(eventCtrl);
	        for (i = 0, l = parents.length; !eventRootCtrl && i < l; i++) {
	          eventRootCtrl = parents[i]._eventsRoot;
	        }
	
	        // Event root wasn't found the use the root control
	        if (!eventRootCtrl) {
	          eventRootCtrl = parents[parents.length - 1] || eventCtrl;
	        }
	
	        // Set the eventsRoot property on children that didn't have it
	        eventCtrl._eventsRoot = eventRootCtrl;
	        for (l = i, i = 0; i < l; i++) {
	          parents[i]._eventsRoot = eventRootCtrl;
	        }
	
	        var eventRootDelegates = eventRootCtrl._delegates;
	        if (!eventRootDelegates) {
	          eventRootDelegates = eventRootCtrl._delegates = {};
	        }
	
	        // Bind native event delegates
	        for (name in nativeEvents) {
	          if (!nativeEvents) {
	            return false;
	          }
	
	          if (name === "wheel" && !hasWheelEventSupport) {
	            if (hasMouseWheelEventSupport) {
	              DomQuery(eventCtrl.getEl()).on("mousewheel", fixWheelEvent);
	            } else {
	              DomQuery(eventCtrl.getEl()).on("DOMMouseScroll", fixWheelEvent);
	            }
	
	            continue;
	          }
	
	          // Special treatment for mousenter/mouseleave since these doesn't bubble
	          if (name === "mouseenter" || name === "mouseleave") {
	            // Fake mousenter/mouseleave
	            if (!eventRootCtrl._hasMouseEnter) {
	              DomQuery(eventRootCtrl.getEl()).on("mouseleave", mouseLeaveHandler).on("mouseover", mouseEnterHandler);
	              eventRootCtrl._hasMouseEnter = 1;
	            }
	          } else if (!eventRootDelegates[name]) {
	            DomQuery(eventRootCtrl.getEl()).on(name, delegate);
	            eventRootDelegates[name] = true;
	          }
	
	          // Remove the event once it's bound
	          nativeEvents[name] = false;
	        }
	      }
	    }
	
	    return Control;
	  }
	);
	
	/**
	 * KeyboardNavigation.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles keyboard navigation of controls and elements.
	 *
	 * @class tinymce.ui.KeyboardNavigation
	 */
	define(
	  'tinymce.ui.KeyboardNavigation',
	  [
	    'global!document'
	  ],
	  function (document) {
	    "use strict";
	
	    var hasTabstopData = function (elm) {
	      return elm.getAttribute('data-mce-tabstop') ? true : false;
	    };
	
	    /**
	     * This class handles all keyboard navigation for WAI-ARIA support. Each root container
	     * gets an instance of this class.
	     *
	     * @constructor
	     */
	    return function (settings) {
	      var root = settings.root, focusedElement, focusedControl;
	
	      function isElement(node) {
	        return node && node.nodeType === 1;
	      }
	
	      try {
	        focusedElement = document.activeElement;
	      } catch (ex) {
	        // IE sometimes fails to return a proper element
	        focusedElement = document.body;
	      }
	
	      focusedControl = root.getParentCtrl(focusedElement);
	
	      /**
	       * Returns the currently focused elements wai aria role of the currently
	       * focused element or specified element.
	       *
	       * @private
	       * @param {Element} elm Optional element to get role from.
	       * @return {String} Role of specified element.
	       */
	      function getRole(elm) {
	        elm = elm || focusedElement;
	
	        if (isElement(elm)) {
	          return elm.getAttribute('role');
	        }
	
	        return null;
	      }
	
	      /**
	       * Returns the wai role of the parent element of the currently
	       * focused element or specified element.
	       *
	       * @private
	       * @param {Element} elm Optional element to get parent role from.
	       * @return {String} Role of the first parent that has a role.
	       */
	      function getParentRole(elm) {
	        var role, parent = elm || focusedElement;
	
	        while ((parent = parent.parentNode)) {
	          if ((role = getRole(parent))) {
	            return role;
	          }
	        }
	      }
	
	      /**
	       * Returns a wai aria property by name for example aria-selected.
	       *
	       * @private
	       * @param {String} name Name of the aria property to get for example "disabled".
	       * @return {String} Aria property value.
	       */
	      function getAriaProp(name) {
	        var elm = focusedElement;
	
	        if (isElement(elm)) {
	          return elm.getAttribute('aria-' + name);
	        }
	      }
	
	      /**
	       * Is the element a text input element or not.
	       *
	       * @private
	       * @param {Element} elm Element to check if it's an text input element or not.
	       * @return {Boolean} True/false if the element is a text element or not.
	       */
	      function isTextInputElement(elm) {
	        var tagName = elm.tagName.toUpperCase();
	
	        // Notice: since type can be "email" etc we don't check the type
	        // So all input elements gets treated as text input elements
	        return tagName == "INPUT" || tagName == "TEXTAREA" || tagName == "SELECT";
	      }
	
	      /**
	       * Returns true/false if the specified element can be focused or not.
	       *
	       * @private
	       * @param {Element} elm DOM element to check if it can be focused or not.
	       * @return {Boolean} True/false if the element can have focus.
	       */
	      function canFocus(elm) {
	        if (isTextInputElement(elm) && !elm.hidden) {
	          return true;
	        }
	
	        if (hasTabstopData(elm)) {
	          return true;
	        }
	
	        if (/^(button|menuitem|checkbox|tab|menuitemcheckbox|option|gridcell|slider)$/.test(getRole(elm))) {
	          return true;
	        }
	
	        return false;
	      }
	
	      /**
	       * Returns an array of focusable visible elements within the specified container element.
	       *
	       * @private
	       * @param {Element} elm DOM element to find focusable elements within.
	       * @return {Array} Array of focusable elements.
	       */
	      function getFocusElements(elm) {
	        var elements = [];
	
	        function collect(elm) {
	          if (elm.nodeType != 1 || elm.style.display == 'none' || elm.disabled) {
	            return;
	          }
	
	          if (canFocus(elm)) {
	            elements.push(elm);
	          }
	
	          for (var i = 0; i < elm.childNodes.length; i++) {
	            collect(elm.childNodes[i]);
	          }
	        }
	
	        collect(elm || root.getEl());
	
	        return elements;
	      }
	
	      /**
	       * Returns the navigation root control for the specified control. The navigation root
	       * is the control that the keyboard navigation gets scoped to for example a menubar or toolbar group.
	       * It will look for parents of the specified target control or the currently focused control if this option is omitted.
	       *
	       * @private
	       * @param {tinymce.ui.Control} targetControl Optional target control to find root of.
	       * @return {tinymce.ui.Control} Navigation root control.
	       */
	      function getNavigationRoot(targetControl) {
	        var navigationRoot, controls;
	
	        targetControl = targetControl || focusedControl;
	        controls = targetControl.parents().toArray();
	        controls.unshift(targetControl);
	
	        for (var i = 0; i < controls.length; i++) {
	          navigationRoot = controls[i];
	
	          if (navigationRoot.settings.ariaRoot) {
	            break;
	          }
	        }
	
	        return navigationRoot;
	      }
	
	      /**
	       * Focuses the first item in the specified targetControl element or the last aria index if the
	       * navigation root has the ariaRemember option enabled.
	       *
	       * @private
	       * @param {tinymce.ui.Control} targetControl Target control to focus the first item in.
	       */
	      function focusFirst(targetControl) {
	        var navigationRoot = getNavigationRoot(targetControl);
	        var focusElements = getFocusElements(navigationRoot.getEl());
	
	        if (navigationRoot.settings.ariaRemember && "lastAriaIndex" in navigationRoot) {
	          moveFocusToIndex(navigationRoot.lastAriaIndex, focusElements);
	        } else {
	          moveFocusToIndex(0, focusElements);
	        }
	      }
	
	      /**
	       * Moves the focus to the specified index within the elements list.
	       * This will scope the index to the size of the element list if it changed.
	       *
	       * @private
	       * @param {Number} idx Specified index to move to.
	       * @param {Array} elements Array with dom elements to move focus within.
	       * @return {Number} Input index or a changed index if it was out of range.
	       */
	      function moveFocusToIndex(idx, elements) {
	        if (idx < 0) {
	          idx = elements.length - 1;
	        } else if (idx >= elements.length) {
	          idx = 0;
	        }
	
	        if (elements[idx]) {
	          elements[idx].focus();
	        }
	
	        return idx;
	      }
	
	      /**
	       * Moves the focus forwards or backwards.
	       *
	       * @private
	       * @param {Number} dir Direction to move in positive means forward, negative means backwards.
	       * @param {Array} elements Optional array of elements to move within defaults to the current navigation roots elements.
	       */
	      function moveFocus(dir, elements) {
	        var idx = -1, navigationRoot = getNavigationRoot();
	
	        elements = elements || getFocusElements(navigationRoot.getEl());
	
	        for (var i = 0; i < elements.length; i++) {
	          if (elements[i] === focusedElement) {
	            idx = i;
	          }
	        }
	
	        idx += dir;
	        navigationRoot.lastAriaIndex = moveFocusToIndex(idx, elements);
	      }
	
	      /**
	       * Moves the focus to the left this is called by the left key.
	       *
	       * @private
	       */
	      function left() {
	        var parentRole = getParentRole();
	
	        if (parentRole == "tablist") {
	          moveFocus(-1, getFocusElements(focusedElement.parentNode));
	        } else if (focusedControl.parent().submenu) {
	          cancel();
	        } else {
	          moveFocus(-1);
	        }
	      }
	
	      /**
	       * Moves the focus to the right this is called by the right key.
	       *
	       * @private
	       */
	      function right() {
	        var role = getRole(), parentRole = getParentRole();
	
	        if (parentRole == "tablist") {
	          moveFocus(1, getFocusElements(focusedElement.parentNode));
	        } else if (role == "menuitem" && parentRole == "menu" && getAriaProp('haspopup')) {
	          enter();
	        } else {
	          moveFocus(1);
	        }
	      }
	
	      /**
	       * Moves the focus to the up this is called by the up key.
	       *
	       * @private
	       */
	      function up() {
	        moveFocus(-1);
	      }
	
	      /**
	       * Moves the focus to the up this is called by the down key.
	       *
	       * @private
	       */
	      function down() {
	        var role = getRole(), parentRole = getParentRole();
	
	        if (role == "menuitem" && parentRole == "menubar") {
	          enter();
	        } else if (role == "button" && getAriaProp('haspopup')) {
	          enter({ key: 'down' });
	        } else {
	          moveFocus(1);
	        }
	      }
	
	      /**
	       * Moves the focus to the next item or previous item depending on shift key.
	       *
	       * @private
	       * @param {DOMEvent} e DOM event object.
	       */
	      function tab(e) {
	        var parentRole = getParentRole();
	
	        if (parentRole == "tablist") {
	          var elm = getFocusElements(focusedControl.getEl('body'))[0];
	
	          if (elm) {
	            elm.focus();
	          }
	        } else {
	          moveFocus(e.shiftKey ? -1 : 1);
	        }
	      }
	
	      /**
	       * Calls the cancel event on the currently focused control. This is normally done using the Esc key.
	       *
	       * @private
	       */
	      function cancel() {
	        focusedControl.fire('cancel');
	      }
	
	      /**
	       * Calls the click event on the currently focused control. This is normally done using the Enter/Space keys.
	       *
	       * @private
	       * @param {Object} aria Optional aria data to pass along with the enter event.
	       */
	      function enter(aria) {
	        aria = aria || {};
	        focusedControl.fire('click', { target: focusedElement, aria: aria });
	      }
	
	      root.on('keydown', function (e) {
	        function handleNonTabOrEscEvent(e, handler) {
	          // Ignore non tab keys for text elements
	          if (isTextInputElement(focusedElement) || hasTabstopData(focusedElement)) {
	            return;
	          }
	
	          if (getRole(focusedElement) === 'slider') {
	            return;
	          }
	
	          if (handler(e) !== false) {
	            e.preventDefault();
	          }
	        }
	
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	
	        switch (e.keyCode) {
	          case 37: // DOM_VK_LEFT
	            handleNonTabOrEscEvent(e, left);
	            break;
	
	          case 39: // DOM_VK_RIGHT
	            handleNonTabOrEscEvent(e, right);
	            break;
	
	          case 38: // DOM_VK_UP
	            handleNonTabOrEscEvent(e, up);
	            break;
	
	          case 40: // DOM_VK_DOWN
	            handleNonTabOrEscEvent(e, down);
	            break;
	
	          case 27: // DOM_VK_ESCAPE
	            cancel();
	            break;
	
	          case 14: // DOM_VK_ENTER
	          case 13: // DOM_VK_RETURN
	          case 32: // DOM_VK_SPACE
	            handleNonTabOrEscEvent(e, enter);
	            break;
	
	          case 9: // DOM_VK_TAB
	            if (tab(e) !== false) {
	              e.preventDefault();
	            }
	            break;
	        }
	      });
	
	      root.on('focusin', function (e) {
	        focusedElement = e.target;
	        focusedControl = e.control;
	      });
	
	      return {
	        focusFirst: focusFirst
	      };
	    };
	  }
	);
	/**
	 * Container.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Container control. This is extended by all controls that can have
	 * children such as panels etc. You can also use this class directly as an
	 * generic container instance. The container doesn't have any specific role or style.
	 *
	 * @-x-less Container.less
	 * @class tinymce.ui.Container
	 * @extends tinymce.ui.Control
	 */
	define(
	  'tinymce.ui.Container',
	  [
	    "tinymce.ui.Control",
	    "tinymce.ui.Collection",
	    "tinymce.ui.Selector",
	    "tinymce.core.ui.Factory",
	    "tinymce.ui.KeyboardNavigation",
	    "tinymce.core.util.Tools",
	    "tinymce.core.dom.DomQuery",
	    "tinymce.ui.ClassList",
	    "tinymce.ui.ReflowQueue"
	  ],
	  function (Control, Collection, Selector, Factory, KeyboardNavigation, Tools, $, ClassList, ReflowQueue) {
	    "use strict";
	
	    var selectorCache = {};
	
	    return Control.extend({
	      /**
	       * Constructs a new control instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Array} items Items to add to container in JSON format or control instances.
	       * @setting {String} layout Layout manager by name to use.
	       * @setting {Object} defaults Default settings to apply to all items.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	        settings = self.settings;
	
	        if (settings.fixed) {
	          self.state.set('fixed', true);
	        }
	
	        self._items = new Collection();
	
	        if (self.isRtl()) {
	          self.classes.add('rtl');
	        }
	
	        self.bodyClasses = new ClassList(function () {
	          if (self.state.get('rendered')) {
	            self.getEl('body').className = this.toString();
	          }
	        });
	        self.bodyClasses.prefix = self.classPrefix;
	
	        self.classes.add('container');
	        self.bodyClasses.add('container-body');
	
	        if (settings.containerCls) {
	          self.classes.add(settings.containerCls);
	        }
	
	        self._layout = Factory.create((settings.layout || '') + 'layout');
	
	        if (self.settings.items) {
	          self.add(self.settings.items);
	        } else {
	          self.add(self.render());
	        }
	
	        // TODO: Fix this!
	        self._hasBody = true;
	      },
	
	      /**
	       * Returns a collection of child items that the container currently have.
	       *
	       * @method items
	       * @return {tinymce.ui.Collection} Control collection direct child controls.
	       */
	      items: function () {
	        return this._items;
	      },
	
	      /**
	       * Find child controls by selector.
	       *
	       * @method find
	       * @param {String} selector Selector CSS pattern to find children by.
	       * @return {tinymce.ui.Collection} Control collection with child controls.
	       */
	      find: function (selector) {
	        selector = selectorCache[selector] = selectorCache[selector] || new Selector(selector);
	
	        return selector.find(this);
	      },
	
	      /**
	       * Adds one or many items to the current container. This will create instances of
	       * the object representations if needed.
	       *
	       * @method add
	       * @param {Array/Object/tinymce.ui.Control} items Array or item that will be added to the container.
	       * @return {tinymce.ui.Collection} Current collection control.
	       */
	      add: function (items) {
	        var self = this;
	
	        self.items().add(self.create(items)).parent(self);
	
	        return self;
	      },
	
	      /**
	       * Focuses the current container instance. This will look
	       * for the first control in the container and focus that.
	       *
	       * @method focus
	       * @param {Boolean} keyboard Optional true/false if the focus was a keyboard focus or not.
	       * @return {tinymce.ui.Collection} Current instance.
	       */
	      focus: function (keyboard) {
	        var self = this, focusCtrl, keyboardNav, items;
	
	        if (keyboard) {
	          keyboardNav = self.keyboardNav || self.parents().eq(-1)[0].keyboardNav;
	
	          if (keyboardNav) {
	            keyboardNav.focusFirst(self);
	            return;
	          }
	        }
	
	        items = self.find('*');
	
	        // TODO: Figure out a better way to auto focus alert dialog buttons
	        if (self.statusbar) {
	          items.add(self.statusbar.items());
	        }
	
	        items.each(function (ctrl) {
	          if (ctrl.settings.autofocus) {
	            focusCtrl = null;
	            return false;
	          }
	
	          if (ctrl.canFocus) {
	            focusCtrl = focusCtrl || ctrl;
	          }
	        });
	
	        if (focusCtrl) {
	          focusCtrl.focus();
	        }
	
	        return self;
	      },
	
	      /**
	       * Replaces the specified child control with a new control.
	       *
	       * @method replace
	       * @param {tinymce.ui.Control} oldItem Old item to be replaced.
	       * @param {tinymce.ui.Control} newItem New item to be inserted.
	       */
	      replace: function (oldItem, newItem) {
	        var ctrlElm, items = this.items(), i = items.length;
	
	        // Replace the item in collection
	        while (i--) {
	          if (items[i] === oldItem) {
	            items[i] = newItem;
	            break;
	          }
	        }
	
	        if (i >= 0) {
	          // Remove new item from DOM
	          ctrlElm = newItem.getEl();
	          if (ctrlElm) {
	            ctrlElm.parentNode.removeChild(ctrlElm);
	          }
	
	          // Remove old item from DOM
	          ctrlElm = oldItem.getEl();
	          if (ctrlElm) {
	            ctrlElm.parentNode.removeChild(ctrlElm);
	          }
	        }
	
	        // Adopt the item
	        newItem.parent(this);
	      },
	
	      /**
	       * Creates the specified items. If any of the items is plain JSON style objects
	       * it will convert these into real tinymce.ui.Control instances.
	       *
	       * @method create
	       * @param {Array} items Array of items to convert into control instances.
	       * @return {Array} Array with control instances.
	       */
	      create: function (items) {
	        var self = this, settings, ctrlItems = [];
	
	        // Non array structure, then force it into an array
	        if (!Tools.isArray(items)) {
	          items = [items];
	        }
	
	        // Add default type to each child control
	        Tools.each(items, function (item) {
	          if (item) {
	            // Construct item if needed
	            if (!(item instanceof Control)) {
	              // Name only then convert it to an object
	              if (typeof item == "string") {
	                item = { type: item };
	              }
	
	              // Create control instance based on input settings and default settings
	              settings = Tools.extend({}, self.settings.defaults, item);
	              item.type = settings.type = settings.type || item.type || self.settings.defaultType ||
	                (settings.defaults ? settings.defaults.type : null);
	              item = Factory.create(settings);
	            }
	
	            ctrlItems.push(item);
	          }
	        });
	
	        return ctrlItems;
	      },
	
	      /**
	       * Renders new control instances.
	       *
	       * @private
	       */
	      renderNew: function () {
	        var self = this;
	
	        // Render any new items
	        self.items().each(function (ctrl, index) {
	          var containerElm;
	
	          ctrl.parent(self);
	
	          if (!ctrl.state.get('rendered')) {
	            containerElm = self.getEl('body');
	
	            // Insert or append the item
	            if (containerElm.hasChildNodes() && index <= containerElm.childNodes.length - 1) {
	              $(containerElm.childNodes[index]).before(ctrl.renderHtml());
	            } else {
	              $(containerElm).append(ctrl.renderHtml());
	            }
	
	            ctrl.postRender();
	            ReflowQueue.add(ctrl);
	          }
	        });
	
	        self._layout.applyClasses(self.items().filter(':visible'));
	        self._lastRect = null;
	
	        return self;
	      },
	
	      /**
	       * Appends new instances to the current container.
	       *
	       * @method append
	       * @param {Array/tinymce.ui.Collection} items Array if controls to append.
	       * @return {tinymce.ui.Container} Current container instance.
	       */
	      append: function (items) {
	        return this.add(items).renderNew();
	      },
	
	      /**
	       * Prepends new instances to the current container.
	       *
	       * @method prepend
	       * @param {Array/tinymce.ui.Collection} items Array if controls to prepend.
	       * @return {tinymce.ui.Container} Current container instance.
	       */
	      prepend: function (items) {
	        var self = this;
	
	        self.items().set(self.create(items).concat(self.items().toArray()));
	
	        return self.renderNew();
	      },
	
	      /**
	       * Inserts an control at a specific index.
	       *
	       * @method insert
	       * @param {Array/tinymce.ui.Collection} items Array if controls to insert.
	       * @param {Number} index Index to insert controls at.
	       * @param {Boolean} [before=false] Inserts controls before the index.
	       */
	      insert: function (items, index, before) {
	        var self = this, curItems, beforeItems, afterItems;
	
	        items = self.create(items);
	        curItems = self.items();
	
	        if (!before && index < curItems.length - 1) {
	          index += 1;
	        }
	
	        if (index >= 0 && index < curItems.length) {
	          beforeItems = curItems.slice(0, index).toArray();
	          afterItems = curItems.slice(index).toArray();
	          curItems.set(beforeItems.concat(items, afterItems));
	        }
	
	        return self.renderNew();
	      },
	
	      /**
	       * Populates the form fields from the specified JSON data object.
	       *
	       * Control items in the form that matches the data will have it's value set.
	       *
	       * @method fromJSON
	       * @param {Object} data JSON data object to set control values by.
	       * @return {tinymce.ui.Container} Current form instance.
	       */
	      fromJSON: function (data) {
	        var self = this;
	
	        for (var name in data) {
	          self.find('#' + name).value(data[name]);
	        }
	
	        return self;
	      },
	
	      /**
	       * Serializes the form into a JSON object by getting all items
	       * that has a name and a value.
	       *
	       * @method toJSON
	       * @return {Object} JSON object with form data.
	       */
	      toJSON: function () {
	        var self = this, data = {};
	
	        self.find('*').each(function (ctrl) {
	          var name = ctrl.name(), value = ctrl.value();
	
	          if (name && typeof value != "undefined") {
	            data[name] = value;
	          }
	        });
	
	        return data;
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, layout = self._layout, role = this.settings.role;
	
	        self.preRender();
	        layout.preRender(self);
	
	        return (
	          '<div id="' + self._id + '" class="' + self.classes + '"' + (role ? ' role="' + this.settings.role + '"' : '') + '>' +
	          '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' +
	          (self.settings.html || '') + layout.renderHtml(self) +
	          '</div>' +
	          '</div>'
	        );
	      },
	
	      /**
	       * Post render method. Called after the control has been rendered to the target.
	       *
	       * @method postRender
	       * @return {tinymce.ui.Container} Current combobox instance.
	       */
	      postRender: function () {
	        var self = this, box;
	
	        self.items().exec('postRender');
	        self._super();
	
	        self._layout.postRender(self);
	        self.state.set('rendered', true);
	
	        if (self.settings.style) {
	          self.$el.css(self.settings.style);
	        }
	
	        if (self.settings.border) {
	          box = self.borderBox;
	          self.$el.css({
	            'border-top-width': box.top,
	            'border-right-width': box.right,
	            'border-bottom-width': box.bottom,
	            'border-left-width': box.left
	          });
	        }
	
	        if (!self.parent()) {
	          self.keyboardNav = new KeyboardNavigation({
	            root: self
	          });
	        }
	
	        return self;
	      },
	
	      /**
	       * Initializes the current controls layout rect.
	       * This will be executed by the layout managers to determine the
	       * default minWidth/minHeight etc.
	       *
	       * @method initLayoutRect
	       * @return {Object} Layout rect instance.
	       */
	      initLayoutRect: function () {
	        var self = this, layoutRect = self._super();
	
	        // Recalc container size by asking layout manager
	        self._layout.recalc(self);
	
	        return layoutRect;
	      },
	
	      /**
	       * Recalculates the positions of the controls in the current container.
	       * This is invoked by the reflow method and shouldn't be called directly.
	       *
	       * @method recalc
	       */
	      recalc: function () {
	        var self = this, rect = self._layoutRect, lastRect = self._lastRect;
	
	        if (!lastRect || lastRect.w != rect.w || lastRect.h != rect.h) {
	          self._layout.recalc(self);
	          rect = self.layoutRect();
	          self._lastRect = { x: rect.x, y: rect.y, w: rect.w, h: rect.h };
	          return true;
	        }
	      },
	
	      /**
	       * Reflows the current container and it's children and possible parents.
	       * This should be used after you for example append children to the current control so
	       * that the layout managers know that they need to reposition everything.
	       *
	       * @example
	       * container.append({type: 'button', text: 'My button'}).reflow();
	       *
	       * @method reflow
	       * @return {tinymce.ui.Container} Current container instance.
	       */
	      reflow: function () {
	        var i;
	
	        ReflowQueue.remove(this);
	
	        if (this.visible()) {
	          Control.repaintControls = [];
	          Control.repaintControls.map = {};
	
	          this.recalc();
	          i = Control.repaintControls.length;
	
	          while (i--) {
	            Control.repaintControls[i].repaint();
	          }
	
	          // TODO: Fix me!
	          if (this.settings.layout !== "flow" && this.settings.layout !== "stack") {
	            this.repaint();
	          }
	
	          Control.repaintControls = [];
	        }
	
	        return this;
	      }
	    });
	  }
	);
	/**
	 * DragHelper.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Drag/drop helper class.
	 *
	 * @example
	 * var dragHelper = new tinymce.ui.DragHelper('mydiv', {
	 *     start: function(document, window, evt) {
	 *     },
	 *
	 *     drag: function(evt) {
	 *     },
	 *
	 *     end: function(evt) {
	 *     }
	 * });
	 *
	 * @class tinymce.ui.DragHelper
	 */
	define(
	  'tinymce.ui.DragHelper',
	  [
	    'global!document',
	    'global!window',
	    'tinymce.core.dom.DomQuery'
	  ],
	  function (document, window, DomQuery) {
	    "use strict";
	
	    function getDocumentSize(doc) {
	      var documentElement, body, scrollWidth, clientWidth;
	      var offsetWidth, scrollHeight, clientHeight, offsetHeight, max = Math.max;
	
	      documentElement = doc.documentElement;
	      body = doc.body;
	
	      scrollWidth = max(documentElement.scrollWidth, body.scrollWidth);
	      clientWidth = max(documentElement.clientWidth, body.clientWidth);
	      offsetWidth = max(documentElement.offsetWidth, body.offsetWidth);
	
	      scrollHeight = max(documentElement.scrollHeight, body.scrollHeight);
	      clientHeight = max(documentElement.clientHeight, body.clientHeight);
	      offsetHeight = max(documentElement.offsetHeight, body.offsetHeight);
	
	      return {
	        width: scrollWidth < offsetWidth ? clientWidth : scrollWidth,
	        height: scrollHeight < offsetHeight ? clientHeight : scrollHeight
	      };
	    }
	
	    function updateWithTouchData(e) {
	      var keys, i;
	
	      if (e.changedTouches) {
	        keys = "screenX screenY pageX pageY clientX clientY".split(' ');
	        for (i = 0; i < keys.length; i++) {
	          e[keys[i]] = e.changedTouches[0][keys[i]];
	        }
	      }
	    }
	
	    return function (id, settings) {
	      var $eventOverlay, doc = settings.document || document, downButton, start, stop, drag, startX, startY;
	
	      settings = settings || {};
	
	      function getHandleElm() {
	        return doc.getElementById(settings.handle || id);
	      }
	
	      start = function (e) {
	        var docSize = getDocumentSize(doc), handleElm, cursor;
	
	        updateWithTouchData(e);
	
	        e.preventDefault();
	        downButton = e.button;
	        handleElm = getHandleElm();
	        startX = e.screenX;
	        startY = e.screenY;
	
	        // Grab cursor from handle so we can place it on overlay
	        if (window.getComputedStyle) {
	          cursor = window.getComputedStyle(handleElm, null).getPropertyValue("cursor");
	        } else {
	          cursor = handleElm.runtimeStyle.cursor;
	        }
	
	        $eventOverlay = DomQuery('<div></div>').css({
	          position: "absolute",
	          top: 0, left: 0,
	          width: docSize.width,
	          height: docSize.height,
	          zIndex: 0x7FFFFFFF,
	          opacity: 0.0001,
	          cursor: cursor
	        }).appendTo(doc.body);
	
	        DomQuery(doc).on('mousemove touchmove', drag).on('mouseup touchend', stop);
	
	        settings.start(e);
	      };
	
	      drag = function (e) {
	        updateWithTouchData(e);
	
	        if (e.button !== downButton) {
	          return stop(e);
	        }
	
	        e.deltaX = e.screenX - startX;
	        e.deltaY = e.screenY - startY;
	
	        e.preventDefault();
	        settings.drag(e);
	      };
	
	      stop = function (e) {
	        updateWithTouchData(e);
	
	        DomQuery(doc).off('mousemove touchmove', drag).off('mouseup touchend', stop);
	
	        $eventOverlay.remove();
	
	        if (settings.stop) {
	          settings.stop(e);
	        }
	      };
	
	      /**
	       * Destroys the drag/drop helper instance.
	       *
	       * @method destroy
	       */
	      this.destroy = function () {
	        DomQuery(getHandleElm()).off();
	      };
	
	      DomQuery(getHandleElm()).on('mousedown touchstart', start);
	    };
	  }
	);
	/**
	 * Scrollable.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This mixin makes controls scrollable using custom scrollbars.
	 *
	 * @-x-less Scrollable.less
	 * @mixin tinymce.ui.Scrollable
	 */
	define(
	  'tinymce.ui.Scrollable',
	  [
	    "tinymce.core.dom.DomQuery",
	    "tinymce.ui.DragHelper"
	  ],
	  function ($, DragHelper) {
	    "use strict";
	
	    return {
	      init: function () {
	        var self = this;
	        self.on('repaint', self.renderScroll);
	      },
	
	      renderScroll: function () {
	        var self = this, margin = 2;
	
	        function repaintScroll() {
	          var hasScrollH, hasScrollV, bodyElm;
	
	          function repaintAxis(axisName, posName, sizeName, contentSizeName, hasScroll, ax) {
	            var containerElm, scrollBarElm, scrollThumbElm;
	            var containerSize, scrollSize, ratio, rect;
	            var posNameLower, sizeNameLower;
	
	            scrollBarElm = self.getEl('scroll' + axisName);
	            if (scrollBarElm) {
	              posNameLower = posName.toLowerCase();
	              sizeNameLower = sizeName.toLowerCase();
	
	              $(self.getEl('absend')).css(posNameLower, self.layoutRect()[contentSizeName] - 1);
	
	              if (!hasScroll) {
	                $(scrollBarElm).css('display', 'none');
	                return;
	              }
	
	              $(scrollBarElm).css('display', 'block');
	              containerElm = self.getEl('body');
	              scrollThumbElm = self.getEl('scroll' + axisName + "t");
	              containerSize = containerElm["client" + sizeName] - (margin * 2);
	              containerSize -= hasScrollH && hasScrollV ? scrollBarElm["client" + ax] : 0;
	              scrollSize = containerElm["scroll" + sizeName];
	              ratio = containerSize / scrollSize;
	
	              rect = {};
	              rect[posNameLower] = containerElm["offset" + posName] + margin;
	              rect[sizeNameLower] = containerSize;
	              $(scrollBarElm).css(rect);
	
	              rect = {};
	              rect[posNameLower] = containerElm["scroll" + posName] * ratio;
	              rect[sizeNameLower] = containerSize * ratio;
	              $(scrollThumbElm).css(rect);
	            }
	          }
	
	          bodyElm = self.getEl('body');
	          hasScrollH = bodyElm.scrollWidth > bodyElm.clientWidth;
	          hasScrollV = bodyElm.scrollHeight > bodyElm.clientHeight;
	
	          repaintAxis("h", "Left", "Width", "contentW", hasScrollH, "Height");
	          repaintAxis("v", "Top", "Height", "contentH", hasScrollV, "Width");
	        }
	
	        function addScroll() {
	          function addScrollAxis(axisName, posName, sizeName, deltaPosName, ax) {
	            var scrollStart, axisId = self._id + '-scroll' + axisName, prefix = self.classPrefix;
	
	            $(self.getEl()).append(
	              '<div id="' + axisId + '" class="' + prefix + 'scrollbar ' + prefix + 'scrollbar-' + axisName + '">' +
	              '<div id="' + axisId + 't" class="' + prefix + 'scrollbar-thumb"></div>' +
	              '</div>'
	            );
	
	            self.draghelper = new DragHelper(axisId + 't', {
	              start: function () {
	                scrollStart = self.getEl('body')["scroll" + posName];
	                $('#' + axisId).addClass(prefix + 'active');
	              },
	
	              drag: function (e) {
	                var ratio, hasScrollH, hasScrollV, containerSize, layoutRect = self.layoutRect();
	
	                hasScrollH = layoutRect.contentW > layoutRect.innerW;
	                hasScrollV = layoutRect.contentH > layoutRect.innerH;
	                containerSize = self.getEl('body')["client" + sizeName] - (margin * 2);
	                containerSize -= hasScrollH && hasScrollV ? self.getEl('scroll' + axisName)["client" + ax] : 0;
	
	                ratio = containerSize / self.getEl('body')["scroll" + sizeName];
	                self.getEl('body')["scroll" + posName] = scrollStart + (e["delta" + deltaPosName] / ratio);
	              },
	
	              stop: function () {
	                $('#' + axisId).removeClass(prefix + 'active');
	              }
	            });
	          }
	
	          self.classes.add('scroll');
	
	          addScrollAxis("v", "Top", "Height", "Y", "Width");
	          addScrollAxis("h", "Left", "Width", "X", "Height");
	        }
	
	        if (self.settings.autoScroll) {
	          if (!self._hasScroll) {
	            self._hasScroll = true;
	            addScroll();
	
	            self.on('wheel', function (e) {
	              var bodyEl = self.getEl('body');
	
	              bodyEl.scrollLeft += (e.deltaX || 0) * 10;
	              bodyEl.scrollTop += e.deltaY * 10;
	
	              repaintScroll();
	            });
	
	            $(self.getEl('body')).on("scroll", repaintScroll);
	          }
	
	          repaintScroll();
	        }
	      }
	    };
	  }
	);
	/**
	 * Panel.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new panel.
	 *
	 * @-x-less Panel.less
	 * @class tinymce.ui.Panel
	 * @extends tinymce.ui.Container
	 * @mixes tinymce.ui.Scrollable
	 */
	define(
	  'tinymce.ui.Panel',
	  [
	    "tinymce.ui.Container",
	    "tinymce.ui.Scrollable"
	  ],
	  function (Container, Scrollable) {
	    "use strict";
	
	    return Container.extend({
	      Defaults: {
	        layout: 'fit',
	        containerCls: 'panel'
	      },
	
	      Mixins: [Scrollable],
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, layout = self._layout, innerHtml = self.settings.html;
	
	        self.preRender();
	        layout.preRender(self);
	
	        if (typeof innerHtml == "undefined") {
	          innerHtml = (
	            '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' +
	            layout.renderHtml(self) +
	            '</div>'
	          );
	        } else {
	          if (typeof innerHtml == 'function') {
	            innerHtml = innerHtml.call(self);
	          }
	
	          self._hasBody = false;
	        }
	
	        return (
	          '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1" role="group">' +
	          (self._preBodyHtml || '') +
	          innerHtml +
	          '</div>'
	        );
	      }
	    });
	  }
	);
	
	/**
	 * Resizable.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Resizable mixin. Enables controls to be resized.
	 *
	 * @mixin tinymce.ui.Resizable
	 */
	define(
	  'tinymce.ui.Resizable',
	  [
	    "tinymce.ui.DomUtils"
	  ],
	  function (DomUtils) {
	    "use strict";
	
	    return {
	      /**
	       * Resizes the control to contents.
	       *
	       * @method resizeToContent
	       */
	      resizeToContent: function () {
	        this._layoutRect.autoResize = true;
	        this._lastRect = null;
	        this.reflow();
	      },
	
	      /**
	       * Resizes the control to a specific width/height.
	       *
	       * @method resizeTo
	       * @param {Number} w Control width.
	       * @param {Number} h Control height.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      resizeTo: function (w, h) {
	        // TODO: Fix hack
	        if (w <= 1 || h <= 1) {
	          var rect = DomUtils.getWindowSize();
	
	          w = w <= 1 ? w * rect.w : w;
	          h = h <= 1 ? h * rect.h : h;
	        }
	
	        this._layoutRect.autoResize = false;
	        return this.layoutRect({ minW: w, minH: h, w: w, h: h }).reflow();
	      },
	
	      /**
	       * Resizes the control to a specific relative width/height.
	       *
	       * @method resizeBy
	       * @param {Number} dw Relative control width.
	       * @param {Number} dh Relative control height.
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      resizeBy: function (dw, dh) {
	        var self = this, rect = self.layoutRect();
	
	        return self.resizeTo(rect.w + dw, rect.h + dh);
	      }
	    };
	  }
	);
	/**
	 * FloatPanel.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a floating panel.
	 *
	 * @-x-less FloatPanel.less
	 * @class tinymce.ui.FloatPanel
	 * @extends tinymce.ui.Panel
	 * @mixes tinymce.ui.Movable
	 * @mixes tinymce.ui.Resizable
	 */
	define(
	  'tinymce.ui.FloatPanel',
	  [
	    'global!document',
	    'global!window',
	    'tinymce.core.dom.DomQuery',
	    'tinymce.core.util.Delay',
	    'tinymce.ui.DomUtils',
	    'tinymce.ui.Movable',
	    'tinymce.ui.Panel',
	    'tinymce.ui.Resizable'
	  ],
	  function (document, window, DomQuery, Delay, DomUtils, Movable, Panel, Resizable) {
	    "use strict";
	
	    var documentClickHandler, documentScrollHandler, windowResizeHandler, visiblePanels = [];
	    var zOrder = [], hasModal;
	
	    function isChildOf(ctrl, parent) {
	      while (ctrl) {
	        if (ctrl == parent) {
	          return true;
	        }
	
	        ctrl = ctrl.parent();
	      }
	    }
	
	    function skipOrHidePanels(e) {
	      // Hide any float panel when a click/focus out is out side that float panel and the
	      // float panels direct parent for example a click on a menu button
	      var i = visiblePanels.length;
	
	      while (i--) {
	        var panel = visiblePanels[i], clickCtrl = panel.getParentCtrl(e.target);
	
	        if (panel.settings.autohide) {
	          if (clickCtrl) {
	            if (isChildOf(clickCtrl, panel) || panel.parent() === clickCtrl) {
	              continue;
	            }
	          }
	
	          e = panel.fire('autohide', { target: e.target });
	          if (!e.isDefaultPrevented()) {
	            panel.hide();
	          }
	        }
	      }
	    }
	
	    function bindDocumentClickHandler() {
	
	      if (!documentClickHandler) {
	        documentClickHandler = function (e) {
	          // Gecko fires click event and in the wrong order on Mac so lets normalize
	          if (e.button == 2) {
	            return;
	          }
	
	          skipOrHidePanels(e);
	        };
	
	        DomQuery(document).on('click touchstart', documentClickHandler);
	      }
	    }
	
	    function bindDocumentScrollHandler() {
	      if (!documentScrollHandler) {
	        documentScrollHandler = function () {
	          var i;
	
	          i = visiblePanels.length;
	          while (i--) {
	            repositionPanel(visiblePanels[i]);
	          }
	        };
	
	        DomQuery(window).on('scroll', documentScrollHandler);
	      }
	    }
	
	    function bindWindowResizeHandler() {
	      if (!windowResizeHandler) {
	        var docElm = document.documentElement, clientWidth = docElm.clientWidth, clientHeight = docElm.clientHeight;
	
	        windowResizeHandler = function () {
	          // Workaround for #7065 IE 7 fires resize events event though the window wasn't resized
	          if (!document.all || clientWidth != docElm.clientWidth || clientHeight != docElm.clientHeight) {
	            clientWidth = docElm.clientWidth;
	            clientHeight = docElm.clientHeight;
	            FloatPanel.hideAll();
	          }
	        };
	
	        DomQuery(window).on('resize', windowResizeHandler);
	      }
	    }
	
	    /**
	     * Repositions the panel to the top of page if the panel is outside of the visual viewport. It will
	     * also reposition all child panels of the current panel.
	     */
	    function repositionPanel(panel) {
	      var scrollY = DomUtils.getViewPort().y;
	
	      function toggleFixedChildPanels(fixed, deltaY) {
	        var parent;
	
	        for (var i = 0; i < visiblePanels.length; i++) {
	          if (visiblePanels[i] != panel) {
	            parent = visiblePanels[i].parent();
	
	            while (parent && (parent = parent.parent())) {
	              if (parent == panel) {
	                visiblePanels[i].fixed(fixed).moveBy(0, deltaY).repaint();
	              }
	            }
	          }
	        }
	      }
	
	      if (panel.settings.autofix) {
	        if (!panel.state.get('fixed')) {
	          panel._autoFixY = panel.layoutRect().y;
	
	          if (panel._autoFixY < scrollY) {
	            panel.fixed(true).layoutRect({ y: 0 }).repaint();
	            toggleFixedChildPanels(true, scrollY - panel._autoFixY);
	          }
	        } else {
	          if (panel._autoFixY > scrollY) {
	            panel.fixed(false).layoutRect({ y: panel._autoFixY }).repaint();
	            toggleFixedChildPanels(false, panel._autoFixY - scrollY);
	          }
	        }
	      }
	    }
	
	    function addRemove(add, ctrl) {
	      var i, zIndex = FloatPanel.zIndex || 0xFFFF, topModal;
	
	      if (add) {
	        zOrder.push(ctrl);
	      } else {
	        i = zOrder.length;
	
	        while (i--) {
	          if (zOrder[i] === ctrl) {
	            zOrder.splice(i, 1);
	          }
	        }
	      }
	
	      if (zOrder.length) {
	        for (i = 0; i < zOrder.length; i++) {
	          if (zOrder[i].modal) {
	            zIndex++;
	            topModal = zOrder[i];
	          }
	
	          zOrder[i].getEl().style.zIndex = zIndex;
	          zOrder[i].zIndex = zIndex;
	          zIndex++;
	        }
	      }
	
	      var modalBlockEl = DomQuery('#' + ctrl.classPrefix + 'modal-block', ctrl.getContainerElm())[0];
	
	      if (topModal) {
	        DomQuery(modalBlockEl).css('z-index', topModal.zIndex - 1);
	      } else if (modalBlockEl) {
	        modalBlockEl.parentNode.removeChild(modalBlockEl);
	        hasModal = false;
	      }
	
	      FloatPanel.currentZIndex = zIndex;
	    }
	
	    var FloatPanel = Panel.extend({
	      Mixins: [Movable, Resizable],
	
	      /**
	       * Constructs a new control instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Boolean} autohide Automatically hide the panel.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	        self._eventsRoot = self;
	
	        self.classes.add('floatpanel');
	
	        // Hide floatpanes on click out side the root button
	        if (settings.autohide) {
	          bindDocumentClickHandler();
	          bindWindowResizeHandler();
	          visiblePanels.push(self);
	        }
	
	        if (settings.autofix) {
	          bindDocumentScrollHandler();
	
	          self.on('move', function () {
	            repositionPanel(this);
	          });
	        }
	
	        self.on('postrender show', function (e) {
	          if (e.control == self) {
	            var $modalBlockEl, prefix = self.classPrefix;
	
	            if (self.modal && !hasModal) {
	              $modalBlockEl = DomQuery('#' + prefix + 'modal-block', self.getContainerElm());
	              if (!$modalBlockEl[0]) {
	                $modalBlockEl = DomQuery(
	                  '<div id="' + prefix + 'modal-block" class="' + prefix + 'reset ' + prefix + 'fade"></div>'
	                ).appendTo(self.getContainerElm());
	              }
	
	              Delay.setTimeout(function () {
	                $modalBlockEl.addClass(prefix + 'in');
	                DomQuery(self.getEl()).addClass(prefix + 'in');
	              });
	
	              hasModal = true;
	            }
	
	            addRemove(true, self);
	          }
	        });
	
	        self.on('show', function () {
	          self.parents().each(function (ctrl) {
	            if (ctrl.state.get('fixed')) {
	              self.fixed(true);
	              return false;
	            }
	          });
	        });
	
	        if (settings.popover) {
	          self._preBodyHtml = '<div class="' + self.classPrefix + 'arrow"></div>';
	          self.classes.add('popover').add('bottom').add(self.isRtl() ? 'end' : 'start');
	        }
	
	        self.aria('label', settings.ariaLabel);
	        self.aria('labelledby', self._id);
	        self.aria('describedby', self.describedBy || self._id + '-none');
	      },
	
	      fixed: function (state) {
	        var self = this;
	
	        if (self.state.get('fixed') != state) {
	          if (self.state.get('rendered')) {
	            var viewport = DomUtils.getViewPort();
	
	            if (state) {
	              self.layoutRect().y -= viewport.y;
	            } else {
	              self.layoutRect().y += viewport.y;
	            }
	          }
	
	          self.classes.toggle('fixed', state);
	          self.state.set('fixed', state);
	        }
	
	        return self;
	      },
	
	      /**
	       * Shows the current float panel.
	       *
	       * @method show
	       * @return {tinymce.ui.FloatPanel} Current floatpanel instance.
	       */
	      show: function () {
	        var self = this, i, state = self._super();
	
	        i = visiblePanels.length;
	        while (i--) {
	          if (visiblePanels[i] === self) {
	            break;
	          }
	        }
	
	        if (i === -1) {
	          visiblePanels.push(self);
	        }
	
	        return state;
	      },
	
	      /**
	       * Hides the current float panel.
	       *
	       * @method hide
	       * @return {tinymce.ui.FloatPanel} Current floatpanel instance.
	       */
	      hide: function () {
	        removeVisiblePanel(this);
	        addRemove(false, this);
	
	        return this._super();
	      },
	
	      /**
	       * Hide all visible float panels with he autohide setting enabled. This is for
	       * manually hiding floating menus or panels.
	       *
	       * @method hideAll
	       */
	      hideAll: function () {
	        FloatPanel.hideAll();
	      },
	
	      /**
	       * Closes the float panel. This will remove the float panel from page and fire the close event.
	       *
	       * @method close
	       */
	      close: function () {
	        var self = this;
	
	        if (!self.fire('close').isDefaultPrevented()) {
	          self.remove();
	          addRemove(false, self);
	        }
	
	        return self;
	      },
	
	      /**
	       * Removes the float panel from page.
	       *
	       * @method remove
	       */
	      remove: function () {
	        removeVisiblePanel(this);
	        this._super();
	      },
	
	      postRender: function () {
	        var self = this;
	
	        if (self.settings.bodyRole) {
	          this.getEl('body').setAttribute('role', self.settings.bodyRole);
	        }
	
	        return self._super();
	      }
	    });
	
	    /**
	     * Hide all visible float panels with he autohide setting enabled. This is for
	     * manually hiding floating menus or panels.
	     *
	     * @static
	     * @method hideAll
	     */
	    FloatPanel.hideAll = function () {
	      var i = visiblePanels.length;
	
	      while (i--) {
	        var panel = visiblePanels[i];
	
	        if (panel && panel.settings.autohide) {
	          panel.hide();
	          visiblePanels.splice(i, 1);
	        }
	      }
	    };
	
	    function removeVisiblePanel(panel) {
	      var i;
	
	      i = visiblePanels.length;
	      while (i--) {
	        if (visiblePanels[i] === panel) {
	          visiblePanels.splice(i, 1);
	        }
	      }
	
	      i = zOrder.length;
	      while (i--) {
	        if (zOrder[i] === panel) {
	          zOrder.splice(i, 1);
	        }
	      }
	    }
	
	    return FloatPanel;
	  }
	);
	
	/**
	 * Inline.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.modes.Inline',
	  [
	    'global!document',
	    'tinymce.core.Env',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.ui.Factory',
	    'tinymce.themes.modern.api.Events',
	    'tinymce.themes.modern.api.Settings',
	    'tinymce.themes.modern.ui.A11y',
	    'tinymce.themes.modern.ui.ContextToolbars',
	    'tinymce.themes.modern.ui.Menubar',
	    'tinymce.themes.modern.ui.SkinLoaded',
	    'tinymce.themes.modern.ui.Toolbar',
	    'tinymce.ui.FloatPanel'
	  ],
	  function (document, Env, DOMUtils, Factory, Events, Settings, A11y, ContextToolbars, Menubar, SkinLoaded, Toolbar, FloatPanel) {
	    var isFixed = function (inlineToolbarContainer) {
	      return !!(inlineToolbarContainer && !Env.container);
	    };
	
	    var render = function (editor, theme, args) {
	      var panel, inlineToolbarContainer;
	      var DOM = DOMUtils.DOM;
	
	      var fixedToolbarContainer = Settings.getFixedToolbarContainer(editor);
	      if (fixedToolbarContainer) {
	        inlineToolbarContainer = DOM.select(fixedToolbarContainer)[0];
	      }
	
	      var reposition = function () {
	        if (panel && panel.moveRel && panel.visible() && !panel._fixed) {
	          // TODO: This is kind of ugly and doesn't handle multiple scrollable elements
	          var scrollContainer = editor.selection.getScrollContainer(), body = editor.getBody();
	          var deltaX = 0, deltaY = 0;
	
	          if (scrollContainer) {
	            var bodyPos = DOM.getPos(body), scrollContainerPos = DOM.getPos(scrollContainer);
	
	            deltaX = Math.max(0, scrollContainerPos.x - bodyPos.x);
	            deltaY = Math.max(0, scrollContainerPos.y - bodyPos.y);
	          }
	
	          panel.fixed(false).moveRel(body, editor.rtl ? ['tr-br', 'br-tr'] : ['tl-bl', 'bl-tl', 'tr-br']).moveBy(deltaX, deltaY);
	        }
	      };
	
	      var show = function () {
	        if (panel) {
	          panel.show();
	          reposition();
	          DOM.addClass(editor.getBody(), 'mce-edit-focus');
	        }
	      };
	
	      var hide = function () {
	        if (panel) {
	          // We require two events as the inline float panel based toolbar does not have autohide=true
	          panel.hide();
	
	          // All other autohidden float panels will be closed below.
	          FloatPanel.hideAll();
	
	          DOM.removeClass(editor.getBody(), 'mce-edit-focus');
	        }
	      };
	
	      var render = function () {
	        if (panel) {
	          if (!panel.visible()) {
	            show();
	          }
	
	          return;
	        }
	
	        // Render a plain panel inside the inlineToolbarContainer if it's defined
	        panel = theme.panel = Factory.create({
	          type: inlineToolbarContainer ? 'panel' : 'floatpanel',
	          role: 'application',
	          classes: 'tinymce tinymce-inline',
	          layout: 'flex',
	          direction: 'column',
	          align: 'stretch',
	          autohide: false,
	          autofix: isFixed(inlineToolbarContainer),
	          fixed: isFixed(inlineToolbarContainer),
	          border: 1,
	          items: [
	            Settings.hasMenubar(editor) === false ? null : { type: 'menubar', border: '0 0 1 0', items: Menubar.createMenuButtons(editor) },
	            Toolbar.createToolbars(editor, Settings.getToolbarSize(editor))
	          ]
	        });
	
	        // Add statusbar
	        /*if (settings.statusbar !== false) {
	          panel.add({type: 'panel', classes: 'statusbar', layout: 'flow', border: '1 0 0 0', items: [
	            {type: 'elementpath'}
	          ]});
	        }*/
	
	        Events.fireBeforeRenderUI(editor);
	
	        if (inlineToolbarContainer) {
	          panel.renderTo(inlineToolbarContainer).reflow();
	        } else {
	          panel.renderTo().reflow();
	        }
	
	        A11y.addKeys(editor, panel);
	        show();
	        ContextToolbars.addContextualToolbars(editor);
	
	        editor.on('nodeChange', reposition);
	        editor.on('activate', show);
	        editor.on('deactivate', hide);
	
	        editor.nodeChanged();
	      };
	
	      editor.settings.content_editable = true;
	
	      editor.on('focus', function () {
	        // Render only when the CSS file has been loaded
	        if (Settings.isSkinDisabled(editor) === false && args.skinUiCss) {
	          DOM.styleSheetLoader.load(args.skinUiCss, render, render);
	        } else {
	          render();
	        }
	      });
	
	      editor.on('blur hide', hide);
	
	      // Remove the panel when the editor is removed
	      editor.on('remove', function () {
	        if (panel) {
	          panel.remove();
	          panel = null;
	        }
	      });
	
	      // Preload skin css
	      if (Settings.isSkinDisabled(editor) === false && args.skinUiCss) {
	        DOM.styleSheetLoader.load(args.skinUiCss, SkinLoaded.fireSkinLoaded(editor));
	      } else {
	        SkinLoaded.fireSkinLoaded(editor)();
	      }
	
	      return {};
	    };
	
	    return {
	      render: render
	    };
	  }
	);
	
	/**
	 * Throbber.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class enables you to display a Throbber for any element.
	 *
	 * @-x-less Throbber.less
	 * @class tinymce.ui.Throbber
	 */
	define(
	  'tinymce.ui.Throbber',
	  [
	    "tinymce.core.dom.DomQuery",
	    "tinymce.ui.Control",
	    "tinymce.core.util.Delay"
	  ],
	  function ($, Control, Delay) {
	    "use strict";
	
	    /**
	     * Constructs a new throbber.
	     *
	     * @constructor
	     * @param {Element} elm DOM Html element to display throbber in.
	     * @param {Boolean} inline Optional true/false state if the throbber should be appended to end of element for infinite scroll.
	     */
	    return function (elm, inline) {
	      var self = this, state, classPrefix = Control.classPrefix, timer;
	
	      /**
	       * Shows the throbber.
	       *
	       * @method show
	       * @param {Number} [time] Time to wait before showing.
	       * @param {function} [callback] Optional callback to execute when the throbber is shown.
	       * @return {tinymce.ui.Throbber} Current throbber instance.
	       */
	      self.show = function (time, callback) {
	        function render() {
	          if (state) {
	            $(elm).append(
	              '<div class="' + classPrefix + 'throbber' + (inline ? ' ' + classPrefix + 'throbber-inline' : '') + '"></div>'
	            );
	
	            if (callback) {
	              callback();
	            }
	          }
	        }
	
	        self.hide();
	
	        state = true;
	
	        if (time) {
	          timer = Delay.setTimeout(render, time);
	        } else {
	          render();
	        }
	
	        return self;
	      };
	
	      /**
	       * Hides the throbber.
	       *
	       * @method hide
	       * @return {tinymce.ui.Throbber} Current throbber instance.
	       */
	      self.hide = function () {
	        var child = elm.lastChild;
	
	        Delay.clearTimeout(timer);
	
	        if (child && child.className.indexOf('throbber') != -1) {
	          child.parentNode.removeChild(child);
	        }
	
	        state = false;
	
	        return self;
	      };
	    };
	  }
	);
	
	/**
	 * ProgressState.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.ui.ProgressState',
	  [
	    'tinymce.ui.Throbber'
	  ],
	  function (Throbber) {
	    var setup = function (editor, theme) {
	      var throbber;
	
	      editor.on('ProgressState', function (e) {
	        throbber = throbber || new Throbber(theme.panel.getEl('body'));
	
	        if (e.state) {
	          throbber.show(e.time);
	        } else {
	          throbber.hide();
	        }
	      });
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	/**
	 * Render.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.ui.Render',
	  [
	    'tinymce.themes.modern.api.Settings',
	    'tinymce.themes.modern.modes.Iframe',
	    'tinymce.themes.modern.modes.Inline',
	    'tinymce.themes.modern.ui.ProgressState'
	  ],
	  function (Settings, Iframe, Inline, ProgressState) {
	    var renderUI = function (editor, theme, args) {
	      var skinUrl = Settings.getSkinUrl(editor);
	
	      if (skinUrl) {
	        args.skinUiCss = skinUrl + '/skin.min.css';
	        editor.contentCSS.push(skinUrl + '/content' + (editor.inline ? '.inline' : '') + '.min.css');
	      }
	
	      ProgressState.setup(editor, theme);
	
	      return Settings.isInline(editor) ? Inline.render(editor, theme, args) : Iframe.render(editor, theme, args);
	    };
	
	    return {
	      renderUI: renderUI
	    };
	  }
	);
	
	defineGlobal("global!setTimeout", setTimeout);
	/**
	 * Tooltip.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a tooltip instance.
	 *
	 * @-x-less ToolTip.less
	 * @class tinymce.ui.ToolTip
	 * @extends tinymce.ui.Control
	 * @mixes tinymce.ui.Movable
	 */
	define(
	  'tinymce.ui.Tooltip',
	  [
	    "tinymce.ui.Control",
	    "tinymce.ui.Movable"
	  ],
	  function (Control, Movable) {
	    return Control.extend({
	      Mixins: [Movable],
	
	      Defaults: {
	        classes: 'widget tooltip tooltip-n'
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, prefix = self.classPrefix;
	
	        return (
	          '<div id="' + self._id + '" class="' + self.classes + '" role="presentation">' +
	          '<div class="' + prefix + 'tooltip-arrow"></div>' +
	          '<div class="' + prefix + 'tooltip-inner">' + self.encode(self.state.get('text')) + '</div>' +
	          '</div>'
	        );
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:text', function (e) {
	          self.getEl().lastChild.innerHTML = self.encode(e.value);
	        });
	
	        return self._super();
	      },
	
	      /**
	       * Repaints the control after a layout operation.
	       *
	       * @method repaint
	       */
	      repaint: function () {
	        var self = this, style, rect;
	
	        style = self.getEl().style;
	        rect = self._layoutRect;
	
	        style.left = rect.x + 'px';
	        style.top = rect.y + 'px';
	        style.zIndex = 0xFFFF + 0xFFFF;
	      }
	    });
	  }
	);
	/**
	 * Widget.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Widget base class a widget is a control that has a tooltip and some basic states.
	 *
	 * @class tinymce.ui.Widget
	 * @extends tinymce.ui.Control
	 */
	define(
	  'tinymce.ui.Widget',
	  [
	    "tinymce.ui.Control",
	    "tinymce.ui.Tooltip"
	  ],
	  function (Control, Tooltip) {
	    "use strict";
	
	    var tooltip;
	
	    var Widget = Control.extend({
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {String} tooltip Tooltip text to display when hovering.
	       * @setting {Boolean} autofocus True if the control should be focused when rendered.
	       * @setting {String} text Text to display inside widget.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	        settings = self.settings;
	        self.canFocus = true;
	
	        if (settings.tooltip && Widget.tooltips !== false) {
	          self.on('mouseenter', function (e) {
	            var tooltip = self.tooltip().moveTo(-0xFFFF);
	
	            if (e.control == self) {
	              var rel = tooltip.text(settings.tooltip).show().testMoveRel(self.getEl(), ['bc-tc', 'bc-tl', 'bc-tr']);
	
	              tooltip.classes.toggle('tooltip-n', rel == 'bc-tc');
	              tooltip.classes.toggle('tooltip-nw', rel == 'bc-tl');
	              tooltip.classes.toggle('tooltip-ne', rel == 'bc-tr');
	
	              tooltip.moveRel(self.getEl(), rel);
	            } else {
	              tooltip.hide();
	            }
	          });
	
	          self.on('mouseleave mousedown click', function () {
	            self.tooltip().hide();
	          });
	        }
	
	        self.aria('label', settings.ariaLabel || settings.tooltip);
	      },
	
	      /**
	       * Returns the current tooltip instance.
	       *
	       * @method tooltip
	       * @return {tinymce.ui.Tooltip} Tooltip instance.
	       */
	      tooltip: function () {
	        if (!tooltip) {
	          tooltip = new Tooltip({ type: 'tooltip' });
	          tooltip.renderTo();
	        }
	
	        return tooltip;
	      },
	
	      /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this, settings = self.settings;
	
	        self._super();
	
	        if (!self.parent() && (settings.width || settings.height)) {
	          self.initLayoutRect();
	          self.repaint();
	        }
	
	        if (settings.autofocus) {
	          self.focus();
	        }
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        function disable(state) {
	          self.aria('disabled', state);
	          self.classes.toggle('disabled', state);
	        }
	
	        function active(state) {
	          self.aria('pressed', state);
	          self.classes.toggle('active', state);
	        }
	
	        self.state.on('change:disabled', function (e) {
	          disable(e.value);
	        });
	
	        self.state.on('change:active', function (e) {
	          active(e.value);
	        });
	
	        if (self.state.get('disabled')) {
	          disable(true);
	        }
	
	        if (self.state.get('active')) {
	          active(true);
	        }
	
	        return self._super();
	      },
	
	      /**
	       * Removes the current control from DOM and from UI collections.
	       *
	       * @method remove
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      remove: function () {
	        this._super();
	
	        if (tooltip) {
	          tooltip.remove();
	          tooltip = null;
	        }
	      }
	    });
	
	    return Widget;
	  }
	);
	
	/**
	 * Progress.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Progress control.
	 *
	 * @-x-less Progress.less
	 * @class tinymce.ui.Progress
	 * @extends tinymce.ui.Control
	 */
	define(
	  'tinymce.ui.Progress',
	  [
	    "tinymce.ui.Widget"
	  ],
	  function (Widget) {
	    "use strict";
	
	    return Widget.extend({
	      Defaults: {
	        value: 0
	      },
	
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	        self.classes.add('progress');
	
	        if (!self.settings.filter) {
	          self.settings.filter = function (value) {
	            return Math.round(value);
	          };
	        }
	      },
	
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = this.classPrefix;
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '">' +
	          '<div class="' + prefix + 'bar-container">' +
	          '<div class="' + prefix + 'bar"></div>' +
	          '</div>' +
	          '<div class="' + prefix + 'text">0%</div>' +
	          '</div>'
	        );
	      },
	
	      postRender: function () {
	        var self = this;
	
	        self._super();
	        self.value(self.settings.value);
	
	        return self;
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        function setValue(value) {
	          value = self.settings.filter(value);
	          self.getEl().lastChild.innerHTML = value + '%';
	          self.getEl().firstChild.firstChild.style.width = value + '%';
	        }
	
	        self.state.on('change:value', function (e) {
	          setValue(e.value);
	        });
	
	        setValue(self.state.get('value'));
	
	        return self._super();
	      }
	    });
	  }
	);
	/**
	 * Notification.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a notification instance.
	 *
	 * @-x-less Notification.less
	 * @class tinymce.ui.Notification
	 * @extends tinymce.ui.Container
	 * @mixes tinymce.ui.Movable
	 */
	define(
	  'tinymce.ui.Notification',
	  [
	    "tinymce.ui.Control",
	    "tinymce.ui.Movable",
	    "tinymce.ui.Progress",
	    "tinymce.core.util.Delay"
	  ],
	  function (Control, Movable, Progress, Delay) {
	    var updateLiveRegion = function (ctx, text) {
	      ctx.getEl().lastChild.textContent = text + (ctx.progressBar ? ' ' + ctx.progressBar.value() + '%' : '');
	    };
	
	    return Control.extend({
	      Mixins: [Movable],
	
	      Defaults: {
	        classes: 'widget notification'
	      },
	
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	
	        self.maxWidth = settings.maxWidth;
	
	        if (settings.text) {
	          self.text(settings.text);
	        }
	
	        if (settings.icon) {
	          self.icon = settings.icon;
	        }
	
	        if (settings.color) {
	          self.color = settings.color;
	        }
	
	        if (settings.type) {
	          self.classes.add('notification-' + settings.type);
	        }
	
	        if (settings.timeout && (settings.timeout < 0 || settings.timeout > 0) && !settings.closeButton) {
	          self.closeButton = false;
	        } else {
	          self.classes.add('has-close');
	          self.closeButton = true;
	        }
	
	        if (settings.progressBar) {
	          self.progressBar = new Progress();
	        }
	
	        self.on('click', function (e) {
	          if (e.target.className.indexOf(self.classPrefix + 'close') != -1) {
	            self.close();
	          }
	        });
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, prefix = self.classPrefix, icon = '', closeButton = '', progressBar = '', notificationStyle = '';
	
	        if (self.icon) {
	          icon = '<i class="' + prefix + 'ico' + ' ' + prefix + 'i-' + self.icon + '"></i>';
	        }
	
	        notificationStyle = ' style="max-width: ' + self.maxWidth + 'px;' + (self.color ? 'background-color: ' + self.color + ';"' : '"');
	
	        if (self.closeButton) {
	          closeButton = '<button type="button" class="' + prefix + 'close" aria-hidden="true">\u00d7</button>';
	        }
	
	        if (self.progressBar) {
	          progressBar = self.progressBar.renderHtml();
	        }
	
	        return (
	          '<div id="' + self._id + '" class="' + self.classes + '"' + notificationStyle + ' role="presentation">' +
	          icon +
	          '<div class="' + prefix + 'notification-inner">' + self.state.get('text') + '</div>' +
	          progressBar +
	          closeButton +
	          '<div style="clip: rect(1px, 1px, 1px, 1px);height: 1px;overflow: hidden;position: absolute;width: 1px;"' +
	          ' aria-live="assertive" aria-relevant="additions" aria-atomic="true"></div>' +
	          '</div>'
	        );
	      },
	
	      postRender: function () {
	        var self = this;
	
	        Delay.setTimeout(function () {
	          self.$el.addClass(self.classPrefix + 'in');
	          updateLiveRegion(self, self.state.get('text'));
	        }, 100);
	
	        return self._super();
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:text', function (e) {
	          self.getEl().firstChild.innerHTML = e.value;
	          updateLiveRegion(self, e.value);
	        });
	        if (self.progressBar) {
	          self.progressBar.bindStates();
	          self.progressBar.state.on('change:value', function (e) {
	            updateLiveRegion(self, self.state.get('text'));
	          });
	        }
	        return self._super();
	      },
	
	      close: function () {
	        var self = this;
	
	        if (!self.fire('close').isDefaultPrevented()) {
	          self.remove();
	        }
	
	        return self;
	      },
	
	      /**
	       * Repaints the control after a layout operation.
	       *
	       * @method repaint
	       */
	      repaint: function () {
	        var self = this, style, rect;
	
	        style = self.getEl().style;
	        rect = self._layoutRect;
	
	        style.left = rect.x + 'px';
	        style.top = rect.y + 'px';
	
	        // Hardcoded arbitrary z-value because we want the
	        // notifications under the other windows
	        style.zIndex = 0xFFFF - 1;
	      }
	    });
	  }
	);
	/**
	 * NotificationManagerImpl.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.NotificationManagerImpl',
	  [
	    'ephox.katamari.api.Arr',
	    'global!setTimeout',
	    'tinymce.core.util.Tools',
	    'tinymce.ui.DomUtils',
	    'tinymce.ui.Notification'
	  ],
	  function (Arr, setTimeout, Tools, DomUtils, Notification) {
	    return function (editor) {
	      var getEditorContainer = function (editor) {
	        return editor.inline ? editor.getElement() : editor.getContentAreaContainer();
	      };
	
	      var getContainerWidth = function () {
	        var container = getEditorContainer(editor);
	        return DomUtils.getSize(container).width;
	      };
	
	      // Since the viewport will change based on the present notifications, we need to move them all to the
	      // top left of the viewport to give an accurate size measurement so we can position them later.
	      var prePositionNotifications = function (notifications) {
	        Arr.each(notifications, function (notification) {
	          notification.moveTo(0, 0);
	        });
	      };
	
	      var positionNotifications = function (notifications) {
	        if (notifications.length > 0) {
	          var firstItem = notifications.slice(0, 1)[0];
	          var container = getEditorContainer(editor);
	          firstItem.moveRel(container, 'tc-tc');
	          Arr.each(notifications, function (notification, index) {
	            if (index > 0) {
	              notification.moveRel(notifications[index - 1].getEl(), 'bc-tc');
	            }
	          });
	        }
	      };
	
	      var reposition = function (notifications) {
	        prePositionNotifications(notifications);
	        positionNotifications(notifications);
	      };
	
	      var open = function (args, closeCallback) {
	        var extendedArgs = Tools.extend(args, { maxWidth: getContainerWidth() });
	        var notif = new Notification(extendedArgs);
	        notif.args = extendedArgs;
	
	        //If we have a timeout value
	        if (extendedArgs.timeout > 0) {
	          notif.timer = setTimeout(function () {
	            notif.close();
	            closeCallback();
	          }, extendedArgs.timeout);
	        }
	
	        notif.on('close', function () {
	          closeCallback();
	        });
	
	        notif.renderTo();
	
	        return notif;
	      };
	
	      var close = function (notification) {
	        notification.close();
	      };
	
	      var getArgs = function (notification) {
	        return notification.args;
	      };
	
	      return {
	        open: open,
	        close: close,
	        reposition: reposition,
	        getArgs: getArgs
	      };
	    };
	  }
	);
	
	/**
	 * Window.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new window.
	 *
	 * @-x-less Window.less
	 * @class tinymce.ui.Window
	 * @extends tinymce.ui.FloatPanel
	 */
	define(
	  'tinymce.ui.Window',
	  [
	    'global!document',
	    'global!setTimeout',
	    'global!window',
	    'tinymce.core.dom.DomQuery',
	    'tinymce.core.Env',
	    'tinymce.core.util.Delay',
	    'tinymce.ui.BoxUtils',
	    'tinymce.ui.DomUtils',
	    'tinymce.ui.DragHelper',
	    'tinymce.ui.FloatPanel',
	    'tinymce.ui.Panel'
	  ],
	  function (document, setTimeout, window, DomQuery, Env, Delay, BoxUtils, DomUtils, DragHelper, FloatPanel, Panel) {
	    "use strict";
	
	    var windows = [], oldMetaValue = '';
	
	    function toggleFullScreenState(state) {
	      var noScaleMetaValue = 'width=device-width,initial-scale=1.0,user-scalable=0,minimum-scale=1.0,maximum-scale=1.0',
	        viewport = DomQuery("meta[name=viewport]")[0],
	        contentValue;
	
	      if (Env.overrideViewPort === false) {
	        return;
	      }
	
	      if (!viewport) {
	        viewport = document.createElement('meta');
	        viewport.setAttribute('name', 'viewport');
	        document.getElementsByTagName('head')[0].appendChild(viewport);
	      }
	
	      contentValue = viewport.getAttribute('content');
	      if (contentValue && typeof oldMetaValue != 'undefined') {
	        oldMetaValue = contentValue;
	      }
	
	      viewport.setAttribute('content', state ? noScaleMetaValue : oldMetaValue);
	    }
	
	    function toggleBodyFullScreenClasses(classPrefix, state) {
	      if (checkFullscreenWindows() && state === false) {
	        DomQuery([document.documentElement, document.body]).removeClass(classPrefix + 'fullscreen');
	      }
	    }
	
	    function checkFullscreenWindows() {
	      for (var i = 0; i < windows.length; i++) {
	        if (windows[i]._fullscreen) {
	          return true;
	        }
	      }
	      return false;
	    }
	
	    function handleWindowResize() {
	      if (!Env.desktop) {
	        var lastSize = {
	          w: window.innerWidth,
	          h: window.innerHeight
	        };
	
	        Delay.setInterval(function () {
	          var w = window.innerWidth,
	            h = window.innerHeight;
	
	          if (lastSize.w != w || lastSize.h != h) {
	            lastSize = {
	              w: w,
	              h: h
	            };
	
	            DomQuery(window).trigger('resize');
	          }
	        }, 100);
	      }
	
	      function reposition() {
	        var i, rect = DomUtils.getWindowSize(), layoutRect;
	
	        for (i = 0; i < windows.length; i++) {
	          layoutRect = windows[i].layoutRect();
	
	          windows[i].moveTo(
	            windows[i].settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2),
	            windows[i].settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2)
	          );
	        }
	      }
	
	      DomQuery(window).on('resize', reposition);
	    }
	
	    var Window = FloatPanel.extend({
	      modal: true,
	
	      Defaults: {
	        border: 1,
	        layout: 'flex',
	        containerCls: 'panel',
	        role: 'dialog',
	        callbacks: {
	          submit: function () {
	            this.fire('submit', { data: this.toJSON() });
	          },
	
	          close: function () {
	            this.close();
	          }
	        }
	      },
	
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	
	        if (self.isRtl()) {
	          self.classes.add('rtl');
	        }
	
	        self.classes.add('window');
	        self.bodyClasses.add('window-body');
	        self.state.set('fixed', true);
	
	        // Create statusbar
	        if (settings.buttons) {
	          self.statusbar = new Panel({
	            layout: 'flex',
	            border: '1 0 0 0',
	            spacing: 3,
	            padding: 10,
	            align: 'center',
	            pack: self.isRtl() ? 'start' : 'end',
	            defaults: {
	              type: 'button'
	            },
	            items: settings.buttons
	          });
	
	          self.statusbar.classes.add('foot');
	          self.statusbar.parent(self);
	        }
	
	        self.on('click', function (e) {
	          var closeClass = self.classPrefix + 'close';
	
	          if (DomUtils.hasClass(e.target, closeClass) || DomUtils.hasClass(e.target.parentNode, closeClass)) {
	            self.close();
	          }
	        });
	
	        self.on('cancel', function () {
	          self.close();
	        });
	
	        self.aria('describedby', self.describedBy || self._id + '-none');
	        self.aria('label', settings.title);
	        self._fullscreen = false;
	      },
	
	      /**
	       * Recalculates the positions of the controls in the current container.
	       * This is invoked by the reflow method and shouldn't be called directly.
	       *
	       * @method recalc
	       */
	      recalc: function () {
	        var self = this, statusbar = self.statusbar, layoutRect, width, x, needsRecalc;
	
	        if (self._fullscreen) {
	          self.layoutRect(DomUtils.getWindowSize());
	          self.layoutRect().contentH = self.layoutRect().innerH;
	        }
	
	        self._super();
	
	        layoutRect = self.layoutRect();
	
	        // Resize window based on title width
	        if (self.settings.title && !self._fullscreen) {
	          width = layoutRect.headerW;
	          if (width > layoutRect.w) {
	            x = layoutRect.x - Math.max(0, width / 2);
	            self.layoutRect({ w: width, x: x });
	            needsRecalc = true;
	          }
	        }
	
	        // Resize window based on statusbar width
	        if (statusbar) {
	          statusbar.layoutRect({ w: self.layoutRect().innerW }).recalc();
	
	          width = statusbar.layoutRect().minW + layoutRect.deltaW;
	          if (width > layoutRect.w) {
	            x = layoutRect.x - Math.max(0, width - layoutRect.w);
	            self.layoutRect({ w: width, x: x });
	            needsRecalc = true;
	          }
	        }
	
	        // Recalc body and disable auto resize
	        if (needsRecalc) {
	          self.recalc();
	        }
	      },
	
	      /**
	       * Initializes the current controls layout rect.
	       * This will be executed by the layout managers to determine the
	       * default minWidth/minHeight etc.
	       *
	       * @method initLayoutRect
	       * @return {Object} Layout rect instance.
	       */
	      initLayoutRect: function () {
	        var self = this, layoutRect = self._super(), deltaH = 0, headEl;
	
	        // Reserve vertical space for title
	        if (self.settings.title && !self._fullscreen) {
	          headEl = self.getEl('head');
	
	          var size = DomUtils.getSize(headEl);
	
	          layoutRect.headerW = size.width;
	          layoutRect.headerH = size.height;
	
	          deltaH += layoutRect.headerH;
	        }
	
	        // Reserve vertical space for statusbar
	        if (self.statusbar) {
	          deltaH += self.statusbar.layoutRect().h;
	        }
	
	        layoutRect.deltaH += deltaH;
	        layoutRect.minH += deltaH;
	        //layoutRect.innerH -= deltaH;
	        layoutRect.h += deltaH;
	
	        var rect = DomUtils.getWindowSize();
	
	        layoutRect.x = self.settings.x || Math.max(0, rect.w / 2 - layoutRect.w / 2);
	        layoutRect.y = self.settings.y || Math.max(0, rect.h / 2 - layoutRect.h / 2);
	
	        return layoutRect;
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, layout = self._layout, id = self._id, prefix = self.classPrefix;
	        var settings = self.settings, headerHtml = '', footerHtml = '', html = settings.html;
	
	        self.preRender();
	        layout.preRender(self);
	
	        if (settings.title) {
	          headerHtml = (
	            '<div id="' + id + '-head" class="' + prefix + 'window-head">' +
	            '<div id="' + id + '-title" class="' + prefix + 'title">' + self.encode(settings.title) + '</div>' +
	            '<div id="' + id + '-dragh" class="' + prefix + 'dragh"></div>' +
	            '<button type="button" class="' + prefix + 'close" aria-hidden="true">' +
	            '<i class="mce-ico mce-i-remove"></i>' +
	            '</button>' +
	            '</div>'
	          );
	        }
	
	        if (settings.url) {
	          html = '<iframe src="' + settings.url + '" tabindex="-1"></iframe>';
	        }
	
	        if (typeof html == "undefined") {
	          html = layout.renderHtml(self);
	        }
	
	        if (self.statusbar) {
	          footerHtml = self.statusbar.renderHtml();
	        }
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '" hidefocus="1">' +
	          '<div class="' + self.classPrefix + 'reset" role="application">' +
	          headerHtml +
	          '<div id="' + id + '-body" class="' + self.bodyClasses + '">' +
	          html +
	          '</div>' +
	          footerHtml +
	          '</div>' +
	          '</div>'
	        );
	      },
	
	      /**
	       * Switches the window fullscreen mode.
	       *
	       * @method fullscreen
	       * @param {Boolean} state True/false state.
	       * @return {tinymce.ui.Window} Current window instance.
	       */
	      fullscreen: function (state) {
	        var self = this, documentElement = document.documentElement, slowRendering, prefix = self.classPrefix, layoutRect;
	
	        if (state != self._fullscreen) {
	          DomQuery(window).on('resize', function () {
	            var time;
	
	            if (self._fullscreen) {
	              // Time the layout time if it's to slow use a timeout to not hog the CPU
	              if (!slowRendering) {
	                time = new Date().getTime();
	
	                var rect = DomUtils.getWindowSize();
	                self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	
	                if ((new Date().getTime()) - time > 50) {
	                  slowRendering = true;
	                }
	              } else {
	                if (!self._timer) {
	                  self._timer = Delay.setTimeout(function () {
	                    var rect = DomUtils.getWindowSize();
	                    self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	
	                    self._timer = 0;
	                  }, 50);
	                }
	              }
	            }
	          });
	
	          layoutRect = self.layoutRect();
	          self._fullscreen = state;
	
	          if (!state) {
	            self.borderBox = BoxUtils.parseBox(self.settings.border);
	            self.getEl('head').style.display = '';
	            layoutRect.deltaH += layoutRect.headerH;
	            DomQuery([documentElement, document.body]).removeClass(prefix + 'fullscreen');
	            self.classes.remove('fullscreen');
	            self.moveTo(self._initial.x, self._initial.y).resizeTo(self._initial.w, self._initial.h);
	          } else {
	            self._initial = { x: layoutRect.x, y: layoutRect.y, w: layoutRect.w, h: layoutRect.h };
	
	            self.borderBox = BoxUtils.parseBox('0');
	            self.getEl('head').style.display = 'none';
	            layoutRect.deltaH -= layoutRect.headerH + 2;
	            DomQuery([documentElement, document.body]).addClass(prefix + 'fullscreen');
	            self.classes.add('fullscreen');
	
	            var rect = DomUtils.getWindowSize();
	            self.moveTo(0, 0).resizeTo(rect.w, rect.h);
	          }
	        }
	
	        return self.reflow();
	      },
	
	      /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this, startPos;
	
	        setTimeout(function () {
	          self.classes.add('in');
	          self.fire('open');
	        }, 0);
	
	        self._super();
	
	        if (self.statusbar) {
	          self.statusbar.postRender();
	        }
	
	        self.focus();
	
	        this.dragHelper = new DragHelper(self._id + '-dragh', {
	          start: function () {
	            startPos = {
	              x: self.layoutRect().x,
	              y: self.layoutRect().y
	            };
	          },
	
	          drag: function (e) {
	            self.moveTo(startPos.x + e.deltaX, startPos.y + e.deltaY);
	          }
	        });
	
	        self.on('submit', function (e) {
	          if (!e.isDefaultPrevented()) {
	            self.close();
	          }
	        });
	
	        windows.push(self);
	        toggleFullScreenState(true);
	      },
	
	      /**
	       * Fires a submit event with the serialized form.
	       *
	       * @method submit
	       * @return {Object} Event arguments object.
	       */
	      submit: function () {
	        return this.fire('submit', { data: this.toJSON() });
	      },
	
	      /**
	       * Removes the current control from DOM and from UI collections.
	       *
	       * @method remove
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      remove: function () {
	        var self = this, i;
	
	        self.dragHelper.destroy();
	        self._super();
	
	        if (self.statusbar) {
	          this.statusbar.remove();
	        }
	
	        toggleBodyFullScreenClasses(self.classPrefix, false);
	
	        i = windows.length;
	        while (i--) {
	          if (windows[i] === self) {
	            windows.splice(i, 1);
	          }
	        }
	
	        toggleFullScreenState(windows.length > 0);
	      },
	
	      /**
	       * Returns the contentWindow object of the iframe if it exists.
	       *
	       * @method getContentWindow
	       * @return {Window} window object or null.
	       */
	      getContentWindow: function () {
	        var ifr = this.getEl().getElementsByTagName('iframe')[0];
	        return ifr ? ifr.contentWindow : null;
	      }
	    });
	
	    handleWindowResize();
	
	    return Window;
	  }
	);
	/**
	 * MessageBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to create MessageBoxes like alerts/confirms etc.
	 *
	 * @class tinymce.ui.MessageBox
	 * @extends tinymce.ui.FloatPanel
	 */
	define(
	  'tinymce.ui.MessageBox',
	  [
	    'global!document',
	    'tinymce.ui.Window'
	  ],
	  function (document, Window) {
	    "use strict";
	
	    var MessageBox = Window.extend({
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       */
	      init: function (settings) {
	        settings = {
	          border: 1,
	          padding: 20,
	          layout: 'flex',
	          pack: "center",
	          align: "center",
	          containerCls: 'panel',
	          autoScroll: true,
	          buttons: { type: "button", text: "Ok", action: "ok" },
	          items: {
	            type: "label",
	            multiline: true,
	            maxWidth: 500,
	            maxHeight: 200
	          }
	        };
	
	        this._super(settings);
	      },
	
	      Statics: {
	        /**
	         * Ok buttons constant.
	         *
	         * @static
	         * @final
	         * @field {Number} OK
	         */
	        OK: 1,
	
	        /**
	         * Ok/cancel buttons constant.
	         *
	         * @static
	         * @final
	         * @field {Number} OK_CANCEL
	         */
	        OK_CANCEL: 2,
	
	        /**
	         * yes/no buttons constant.
	         *
	         * @static
	         * @final
	         * @field {Number} YES_NO
	         */
	        YES_NO: 3,
	
	        /**
	         * yes/no/cancel buttons constant.
	         *
	         * @static
	         * @final
	         * @field {Number} YES_NO_CANCEL
	         */
	        YES_NO_CANCEL: 4,
	
	        /**
	         * Constructs a new message box and renders it to the body element.
	         *
	         * @static
	         * @method msgBox
	         * @param {Object} settings Name/value object with settings.
	         */
	        msgBox: function (settings) {
	          var buttons, callback = settings.callback || function () { };
	
	          function createButton(text, status, primary) {
	            return {
	              type: "button",
	              text: text,
	              subtype: primary ? 'primary' : '',
	              onClick: function (e) {
	                e.control.parents()[1].close();
	                callback(status);
	              }
	            };
	          }
	
	          switch (settings.buttons) {
	            case MessageBox.OK_CANCEL:
	              buttons = [
	                createButton('Ok', true, true),
	                createButton('Cancel', false)
	              ];
	              break;
	
	            case MessageBox.YES_NO:
	            case MessageBox.YES_NO_CANCEL:
	              buttons = [
	                createButton('Yes', 1, true),
	                createButton('No', 0)
	              ];
	
	              if (settings.buttons == MessageBox.YES_NO_CANCEL) {
	                buttons.push(createButton('Cancel', -1));
	              }
	              break;
	
	            default:
	              buttons = [
	                createButton('Ok', true, true)
	              ];
	              break;
	          }
	
	          return new Window({
	            padding: 20,
	            x: settings.x,
	            y: settings.y,
	            minWidth: 300,
	            minHeight: 100,
	            layout: "flex",
	            pack: "center",
	            align: "center",
	            buttons: buttons,
	            title: settings.title,
	            role: 'alertdialog',
	            items: {
	              type: "label",
	              multiline: true,
	              maxWidth: 500,
	              maxHeight: 200,
	              text: settings.text
	            },
	            onPostRender: function () {
	              this.aria('describedby', this.items()[0]._id);
	            },
	            onClose: settings.onClose,
	            onCancel: function () {
	              callback(false);
	            }
	          }).renderTo(document.body).reflow();
	        },
	
	        /**
	         * Creates a new alert dialog.
	         *
	         * @method alert
	         * @param {Object} settings Settings for the alert dialog.
	         * @param {function} [callback] Callback to execute when the user makes a choice.
	         */
	        alert: function (settings, callback) {
	          if (typeof settings == "string") {
	            settings = { text: settings };
	          }
	
	          settings.callback = callback;
	          return MessageBox.msgBox(settings);
	        },
	
	        /**
	         * Creates a new confirm dialog.
	         *
	         * @method confirm
	         * @param {Object} settings Settings for the confirm dialog.
	         * @param {function} [callback] Callback to execute when the user makes a choice.
	         */
	        confirm: function (settings, callback) {
	          if (typeof settings == "string") {
	            settings = { text: settings };
	          }
	
	          settings.callback = callback;
	          settings.buttons = MessageBox.OK_CANCEL;
	
	          return MessageBox.msgBox(settings);
	        }
	      }
	    });
	
	    return MessageBox;
	  }
	);
	
	/**
	 * WindowManagerImpl.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.WindowManagerImpl',
	  [
	    "tinymce.ui.Window",
	    "tinymce.ui.MessageBox"
	  ],
	  function (Window, MessageBox) {
	    return function (editor) {
	      var open = function (args, params, closeCallback) {
	        var win;
	
	        args.title = args.title || ' ';
	
	        // Handle URL
	        args.url = args.url || args.file; // Legacy
	        if (args.url) {
	          args.width = parseInt(args.width || 320, 10);
	          args.height = parseInt(args.height || 240, 10);
	        }
	
	        // Handle body
	        if (args.body) {
	          args.items = {
	            defaults: args.defaults,
	            type: args.bodyType || 'form',
	            items: args.body,
	            data: args.data,
	            callbacks: args.commands
	          };
	        }
	
	        if (!args.url && !args.buttons) {
	          args.buttons = [
	            {
	              text: 'Ok', subtype: 'primary', onclick: function () {
	                win.find('form')[0].submit();
	              }
	            },
	
	            {
	              text: 'Cancel', onclick: function () {
	                win.close();
	              }
	            }
	          ];
	        }
	
	        win = new Window(args);
	
	        win.on('close', function () {
	          closeCallback(win);
	        });
	
	        // Handle data
	        if (args.data) {
	          win.on('postRender', function () {
	            this.find('*').each(function (ctrl) {
	              var name = ctrl.name();
	
	              if (name in args.data) {
	                ctrl.value(args.data[name]);
	              }
	            });
	          });
	        }
	
	        // store args and parameters
	        win.features = args || {};
	        win.params = params || {};
	
	        win = win.renderTo().reflow();
	
	        return win;
	      };
	
	      var alert = function (message, choiceCallback, closeCallback) {
	        var win;
	
	        win = MessageBox.alert(message, function () {
	          choiceCallback();
	        });
	
	        win.on('close', function () {
	          closeCallback(win);
	        });
	
	        return win;
	      };
	
	      var confirm = function (message, choiceCallback, closeCallback) {
	        var win;
	
	        win = MessageBox.confirm(message, function (state) {
	          choiceCallback(state);
	        });
	
	        win.on('close', function () {
	          closeCallback(win);
	        });
	
	        return win;
	      };
	
	      var close = function (window) {
	        window.close();
	      };
	
	      var getParams = function (window) {
	        return window.params;
	      };
	
	      var setParams = function (window, params) {
	        window.params = params;
	      };
	
	      return {
	        open: open,
	        alert: alert,
	        confirm: confirm,
	        close: close,
	        getParams: getParams,
	        setParams: setParams
	      };
	    };
	  }
	);
	
	/**
	 * ThemeApi.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.api.ThemeApi',
	  [
	    'tinymce.themes.modern.ui.Render',
	    'tinymce.themes.modern.ui.Resize',
	    'tinymce.ui.NotificationManagerImpl',
	    'tinymce.ui.WindowManagerImpl'
	  ],
	  function (Render, Resize, NotificationManagerImpl, WindowManagerImpl) {
	    var get = function (editor) {
	      var renderUI = function (args) {
	        return Render.renderUI(editor, this, args);
	      };
	
	      var resizeTo = function (w, h) {
	        return Resize.resizeTo(editor, w, h);
	      };
	
	      var resizeBy = function (dw, dh) {
	        return Resize.resizeBy(editor, dw, dh);
	      };
	
	      var getNotificationManagerImpl = function () {
	        return NotificationManagerImpl(editor);
	      };
	
	      var getWindowManagerImpl = function () {
	        return WindowManagerImpl(editor);
	      };
	
	      return {
	        renderUI: renderUI,
	        resizeTo: resizeTo,
	        resizeBy: resizeBy,
	        getNotificationManagerImpl: getNotificationManagerImpl,
	        getWindowManagerImpl: getWindowManagerImpl
	      };
	    };
	
	    return {
	      get: get
	    };
	  }
	);
	
	/**
	 * Layout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Base layout manager class.
	 *
	 * @class tinymce.ui.Layout
	 */
	define(
	  'tinymce.ui.Layout',
	  [
	    "tinymce.core.util.Class",
	    "tinymce.core.util.Tools"
	  ],
	  function (Class, Tools) {
	    "use strict";
	
	    return Class.extend({
	      Defaults: {
	        firstControlClass: 'first',
	        lastControlClass: 'last'
	      },
	
	      /**
	       * Constructs a layout instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       */
	      init: function (settings) {
	        this.settings = Tools.extend({}, this.Defaults, settings);
	      },
	
	      /**
	       * This method gets invoked before the layout renders the controls.
	       *
	       * @method preRender
	       * @param {tinymce.ui.Container} container Container instance to preRender.
	       */
	      preRender: function (container) {
	        container.bodyClasses.add(this.settings.containerClass);
	      },
	
	      /**
	       * Applies layout classes to the container.
	       *
	       * @private
	       */
	      applyClasses: function (items) {
	        var self = this, settings = self.settings, firstClass, lastClass, firstItem, lastItem;
	
	        firstClass = settings.firstControlClass;
	        lastClass = settings.lastControlClass;
	
	        items.each(function (item) {
	          item.classes.remove(firstClass).remove(lastClass).add(settings.controlClass);
	
	          if (item.visible()) {
	            if (!firstItem) {
	              firstItem = item;
	            }
	
	            lastItem = item;
	          }
	        });
	
	        if (firstItem) {
	          firstItem.classes.add(firstClass);
	        }
	
	        if (lastItem) {
	          lastItem.classes.add(lastClass);
	        }
	      },
	
	      /**
	       * Renders the specified container and any layout specific HTML.
	       *
	       * @method renderHtml
	       * @param {tinymce.ui.Container} container Container to render HTML for.
	       */
	      renderHtml: function (container) {
	        var self = this, html = '';
	
	        self.applyClasses(container.items());
	
	        container.items().each(function (item) {
	          html += item.renderHtml();
	        });
	
	        return html;
	      },
	
	      /**
	       * Recalculates the positions of the controls in the specified container.
	       *
	       * @method recalc
	       * @param {tinymce.ui.Container} container Container instance to recalc.
	       */
	      recalc: function () {
	      },
	
	      /**
	       * This method gets invoked after the layout renders the controls.
	       *
	       * @method postRender
	       * @param {tinymce.ui.Container} container Container instance to postRender.
	       */
	      postRender: function () {
	      },
	
	      isNative: function () {
	        return false;
	      }
	    });
	  }
	);
	/**
	 * AbsoluteLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * LayoutManager for absolute positioning. This layout manager is more of
	 * a base class for other layouts but can be created and used directly.
	 *
	 * @-x-less AbsoluteLayout.less
	 * @class tinymce.ui.AbsoluteLayout
	 * @extends tinymce.ui.Layout
	 */
	define(
	  'tinymce.ui.AbsoluteLayout',
	  [
	    "tinymce.ui.Layout"
	  ],
	  function (Layout) {
	    "use strict";
	
	    return Layout.extend({
	      Defaults: {
	        containerClass: 'abs-layout',
	        controlClass: 'abs-layout-item'
	      },
	
	      /**
	       * Recalculates the positions of the controls in the specified container.
	       *
	       * @method recalc
	       * @param {tinymce.ui.Container} container Container instance to recalc.
	       */
	      recalc: function (container) {
	        container.items().filter(':visible').each(function (ctrl) {
	          var settings = ctrl.settings;
	
	          ctrl.layoutRect({
	            x: settings.x,
	            y: settings.y,
	            w: settings.w,
	            h: settings.h
	          });
	
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	        });
	      },
	
	      /**
	       * Renders the specified container and any layout specific HTML.
	       *
	       * @method renderHtml
	       * @param {tinymce.ui.Container} container Container to render HTML for.
	       */
	      renderHtml: function (container) {
	        return '<div id="' + container._id + '-absend" class="' + container.classPrefix + 'abs-end"></div>' + this._super(container);
	      }
	    });
	  }
	);
	/**
	 * Button.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to create buttons. You can create them directly or through the Factory.
	 *
	 * @example
	 * // Create and render a button to the body element
	 * tinymce.ui.Factory.create({
	 *     type: 'button',
	 *     text: 'My button'
	 * }).renderTo(document.body);
	 *
	 * @-x-less Button.less
	 * @class tinymce.ui.Button
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.Button',
	  [
	    'global!document',
	    'global!window',
	    'tinymce.ui.Widget'
	  ],
	  function (document, window, Widget) {
	    "use strict";
	
	    return Widget.extend({
	      Defaults: {
	        classes: "widget btn",
	        role: "button"
	      },
	
	      /**
	       * Constructs a new button instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {String} size Size of the button small|medium|large.
	       * @setting {String} image Image to use for icon.
	       * @setting {String} icon Icon to use for button.
	       */
	      init: function (settings) {
	        var self = this, size;
	
	        self._super(settings);
	        settings = self.settings;
	
	        size = self.settings.size;
	
	        self.on('click mousedown', function (e) {
	          e.preventDefault();
	        });
	
	        self.on('touchstart', function (e) {
	          self.fire('click', e);
	          e.preventDefault();
	        });
	
	        if (settings.subtype) {
	          self.classes.add(settings.subtype);
	        }
	
	        if (size) {
	          self.classes.add('btn-' + size);
	        }
	
	        if (settings.icon) {
	          self.icon(settings.icon);
	        }
	      },
	
	      /**
	       * Sets/gets the current button icon.
	       *
	       * @method icon
	       * @param {String} [icon] New icon identifier.
	       * @return {String|tinymce.ui.MenuButton} Current icon or current MenuButton instance.
	       */
	      icon: function (icon) {
	        if (!arguments.length) {
	          return this.state.get('icon');
	        }
	
	        this.state.set('icon', icon);
	
	        return this;
	      },
	
	      /**
	       * Repaints the button for example after it's been resizes by a layout engine.
	       *
	       * @method repaint
	       */
	      repaint: function () {
	        var btnElm = this.getEl().firstChild,
	          btnStyle;
	
	        if (btnElm) {
	          btnStyle = btnElm.style;
	          btnStyle.width = btnStyle.height = "100%";
	        }
	
	        this._super();
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	        var icon = self.state.get('icon'), image, text = self.state.get('text'), textHtml = '';
	        var ariaPressed, settings = self.settings;
	
	        image = settings.image;
	        if (image) {
	          icon = 'none';
	
	          // Support for [high dpi, low dpi] image sources
	          if (typeof image != "string") {
	            image = window.getSelection ? image[0] : image[1];
	          }
	
	          image = ' style="background-image: url(\'' + image + '\')"';
	        } else {
	          image = '';
	        }
	
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	
	        icon = icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	        ariaPressed = typeof settings.active === 'boolean' ? ' aria-pressed="' + settings.active + '"' : '';
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '" tabindex="-1"' + ariaPressed + '>' +
	          '<button id="' + id + '-button" role="presentation" type="button" tabindex="-1">' +
	          (icon ? '<i class="' + icon + '"' + image + '></i>' : '') +
	          textHtml +
	          '</button>' +
	          '</div>'
	        );
	      },
	
	      bindStates: function () {
	        var self = this, $ = self.$, textCls = self.classPrefix + 'txt';
	
	        function setButtonText(text) {
	          var $span = $('span.' + textCls, self.getEl());
	
	          if (text) {
	            if (!$span[0]) {
	              $('button:first', self.getEl()).append('<span class="' + textCls + '"></span>');
	              $span = $('span.' + textCls, self.getEl());
	            }
	
	            $span.html(self.encode(text));
	          } else {
	            $span.remove();
	          }
	
	          self.classes.toggle('btn-has-text', !!text);
	        }
	
	        self.state.on('change:text', function (e) {
	          setButtonText(e.value);
	        });
	
	        self.state.on('change:icon', function (e) {
	          var icon = e.value, prefix = self.classPrefix;
	
	          self.settings.icon = icon;
	          icon = icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	
	          var btnElm = self.getEl().firstChild, iconElm = btnElm.getElementsByTagName('i')[0];
	
	          if (icon) {
	            if (!iconElm || iconElm != btnElm.firstChild) {
	              iconElm = document.createElement('i');
	              btnElm.insertBefore(iconElm, btnElm.firstChild);
	            }
	
	            iconElm.className = icon;
	          } else if (iconElm) {
	            btnElm.removeChild(iconElm);
	          }
	
	          setButtonText(self.state.get('text'));
	        });
	
	        return self._super();
	      }
	    });
	  }
	);
	
	defineGlobal("global!RegExp", RegExp);
	/**
	 * BrowseButton.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new browse button.
	 *
	 * @-x-less BrowseButton.less
	 * @class tinymce.ui.BrowseButton
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.BrowseButton',
	  [
	    'tinymce.ui.Button',
	    'tinymce.core.util.Tools',
	    'tinymce.ui.DomUtils',
	    'tinymce.core.dom.DomQuery',
	    'global!RegExp'
	  ],
	  function (Button, Tools, DomUtils, $, RegExp) {
	    return Button.extend({
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Boolean} multiple True if the dropzone is a multiple control.
	       * @setting {Number} maxLength Max length for the dropzone.
	       * @setting {Number} size Size of the dropzone in characters.
	       */
	      init: function (settings) {
	        var self = this;
	
	        settings = Tools.extend({
	          text: "Browse...",
	          multiple: false,
	          accept: null // by default accept any files
	        }, settings);
	
	        self._super(settings);
	
	        self.classes.add('browsebutton');
	
	        if (settings.multiple) {
	          self.classes.add('multiple');
	        }
	      },
	
	       /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this;
	
	        var input = DomUtils.create('input', {
	          type: 'file',
	          id: self._id + '-browse',
	          accept: self.settings.accept
	        });
	
	        self._super();
	
	        $(input).on('change', function (e) {
	          var files = e.target.files;
	
	          self.value = function () {
	            if (!files.length) {
	              return null;
	            } else if (self.settings.multiple) {
	              return files;
	            } else {
	              return files[0];
	            }
	          };
	
	          e.preventDefault();
	
	          if (files.length) {
	            self.fire('change', e);
	          }
	        });
	
	        // ui.Button prevents default on click, so we shouldn't let the click to propagate up to it
	        $(input).on('click', function (e) {
	          e.stopPropagation();
	        });
	
	        $(self.getEl('button')).on('click', function (e) {
	          e.stopPropagation();
	          input.click();
	        });
	
	        // in newer browsers input doesn't have to be attached to dom to trigger browser dialog
	        // however older IE11 (< 11.1358.14393.0) still requires this
	        self.getEl().appendChild(input);
	      },
	
	
	      remove: function () {
	        $(this.getEl('button')).off();
	        $(this.getEl('input')).off();
	
	        this._super();
	      }
	    });
	  }
	);
	
	/**
	 * ButtonGroup.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This control enables you to put multiple buttons into a group. This is
	 * useful when you want to combine similar toolbar buttons into a group.
	 *
	 * @example
	 * // Create and render a buttongroup with two buttons to the body element
	 * tinymce.ui.Factory.create({
	 *     type: 'buttongroup',
	 *     items: [
	 *         {text: 'Button A'},
	 *         {text: 'Button B'}
	 *     ]
	 * }).renderTo(document.body);
	 *
	 * @-x-less ButtonGroup.less
	 * @class tinymce.ui.ButtonGroup
	 * @extends tinymce.ui.Container
	 */
	define(
	  'tinymce.ui.ButtonGroup',
	  [
	    "tinymce.ui.Container"
	  ],
	  function (Container) {
	    "use strict";
	
	    return Container.extend({
	      Defaults: {
	        defaultType: 'button',
	        role: 'group'
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, layout = self._layout;
	
	        self.classes.add('btn-group');
	        self.preRender();
	        layout.preRender(self);
	
	        return (
	          '<div id="' + self._id + '" class="' + self.classes + '">' +
	          '<div id="' + self._id + '-body">' +
	          (self.settings.html || '') + layout.renderHtml(self) +
	          '</div>' +
	          '</div>'
	        );
	      }
	    });
	  }
	);
	/**
	 * Checkbox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This control creates a custom checkbox.
	 *
	 * @example
	 * // Create and render a checkbox to the body element
	 * tinymce.core.ui.Factory.create({
	 *     type: 'checkbox',
	 *     checked: true,
	 *     text: 'My checkbox'
	 * }).renderTo(document.body);
	 *
	 * @-x-less Checkbox.less
	 * @class tinymce.ui.Checkbox
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.Checkbox',
	  [
	    'global!document',
	    'tinymce.ui.Widget'
	  ],
	  function (document, Widget) {
	    "use strict";
	
	    return Widget.extend({
	      Defaults: {
	        classes: "checkbox",
	        role: "checkbox",
	        checked: false
	      },
	
	      /**
	       * Constructs a new Checkbox instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Boolean} checked True if the checkbox should be checked by default.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	
	        self.on('click mousedown', function (e) {
	          e.preventDefault();
	        });
	
	        self.on('click', function (e) {
	          e.preventDefault();
	
	          if (!self.disabled()) {
	            self.checked(!self.checked());
	          }
	        });
	
	        self.checked(self.settings.checked);
	      },
	
	      /**
	       * Getter/setter function for the checked state.
	       *
	       * @method checked
	       * @param {Boolean} [state] State to be set.
	       * @return {Boolean|tinymce.ui.Checkbox} True/false or checkbox if it's a set operation.
	       */
	      checked: function (state) {
	        if (!arguments.length) {
	          return this.state.get('checked');
	        }
	
	        this.state.set('checked', state);
	
	        return this;
	      },
	
	      /**
	       * Getter/setter function for the value state.
	       *
	       * @method value
	       * @param {Boolean} [state] State to be set.
	       * @return {Boolean|tinymce.ui.Checkbox} True/false or checkbox if it's a set operation.
	       */
	      value: function (state) {
	        if (!arguments.length) {
	          return this.checked();
	        }
	
	        return this.checked(state);
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '" unselectable="on" aria-labelledby="' + id + '-al" tabindex="-1">' +
	          '<i class="' + prefix + 'ico ' + prefix + 'i-checkbox"></i>' +
	          '<span id="' + id + '-al" class="' + prefix + 'label">' + self.encode(self.state.get('text')) + '</span>' +
	          '</div>'
	        );
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        function checked(state) {
	          self.classes.toggle("checked", state);
	          self.aria('checked', state);
	        }
	
	        self.state.on('change:text', function (e) {
	          self.getEl('al').firstChild.data = self.translate(e.value);
	        });
	
	        self.state.on('change:checked change:value', function (e) {
	          self.fire('change');
	          checked(e.value);
	        });
	
	        self.state.on('change:icon', function (e) {
	          var icon = e.value, prefix = self.classPrefix;
	
	          if (typeof icon == 'undefined') {
	            return self.settings.icon;
	          }
	
	          self.settings.icon = icon;
	          icon = icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	
	          var btnElm = self.getEl().firstChild, iconElm = btnElm.getElementsByTagName('i')[0];
	
	          if (icon) {
	            if (!iconElm || iconElm != btnElm.firstChild) {
	              iconElm = document.createElement('i');
	              btnElm.insertBefore(iconElm, btnElm.firstChild);
	            }
	
	            iconElm.className = icon;
	          } else if (iconElm) {
	            btnElm.removeChild(iconElm);
	          }
	        });
	
	        if (self.state.get('checked')) {
	          checked(true);
	        }
	
	        return self._super();
	      }
	    });
	  }
	);
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.VK',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.VK');
	  }
	);
	
	/**
	 * ComboBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a combobox control. Select box that you select a value from or
	 * type a value into.
	 *
	 * @-x-less ComboBox.less
	 * @class tinymce.ui.ComboBox
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.ComboBox',
	  [
	    'global!document',
	    'tinymce.core.dom.DomQuery',
	    'tinymce.core.ui.Factory',
	    'tinymce.core.util.Tools',
	    'tinymce.core.util.VK',
	    'tinymce.ui.DomUtils',
	    'tinymce.ui.Widget'
	  ],
	  function (document, DomQuery, Factory, Tools, VK, DomUtils, Widget) {
	    "use strict";
	
	    return Widget.extend({
	      /**
	       * Constructs a new control instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {String} placeholder Placeholder text to display.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	        settings = self.settings;
	
	        self.classes.add('combobox');
	        self.subinput = true;
	        self.ariaTarget = 'inp'; // TODO: Figure out a better way
	
	        settings.menu = settings.menu || settings.values;
	
	        if (settings.menu) {
	          settings.icon = 'caret';
	        }
	
	        self.on('click', function (e) {
	          var elm = e.target, root = self.getEl();
	
	          if (!DomQuery.contains(root, elm) && elm != root) {
	            return;
	          }
	
	          while (elm && elm != root) {
	            if (elm.id && elm.id.indexOf('-open') != -1) {
	              self.fire('action');
	
	              if (settings.menu) {
	                self.showMenu();
	
	                if (e.aria) {
	                  self.menu.items()[0].focus();
	                }
	              }
	            }
	
	            elm = elm.parentNode;
	          }
	        });
	
	        // TODO: Rework this
	        self.on('keydown', function (e) {
	          var rootControl;
	
	          if (e.keyCode == 13 && e.target.nodeName === 'INPUT') {
	            e.preventDefault();
	
	            // Find root control that we can do toJSON on
	            self.parents().reverse().each(function (ctrl) {
	              if (ctrl.toJSON) {
	                rootControl = ctrl;
	                return false;
	              }
	            });
	
	            // Fire event on current text box with the serialized data of the whole form
	            self.fire('submit', { data: rootControl.toJSON() });
	          }
	        });
	
	        self.on('keyup', function (e) {
	          if (e.target.nodeName == "INPUT") {
	            var oldValue = self.state.get('value');
	            var newValue = e.target.value;
	
	            if (newValue !== oldValue) {
	              self.state.set('value', newValue);
	              self.fire('autocomplete', e);
	            }
	          }
	        });
	
	        self.on('mouseover', function (e) {
	          var tooltip = self.tooltip().moveTo(-0xFFFF);
	
	          if (self.statusLevel() && e.target.className.indexOf(self.classPrefix + 'status') !== -1) {
	            var statusMessage = self.statusMessage() || 'Ok';
	            var rel = tooltip.text(statusMessage).show().testMoveRel(e.target, ['bc-tc', 'bc-tl', 'bc-tr']);
	
	            tooltip.classes.toggle('tooltip-n', rel == 'bc-tc');
	            tooltip.classes.toggle('tooltip-nw', rel == 'bc-tl');
	            tooltip.classes.toggle('tooltip-ne', rel == 'bc-tr');
	
	            tooltip.moveRel(e.target, rel);
	          }
	        });
	      },
	
	      statusLevel: function (value) {
	        if (arguments.length > 0) {
	          this.state.set('statusLevel', value);
	        }
	
	        return this.state.get('statusLevel');
	      },
	
	      statusMessage: function (value) {
	        if (arguments.length > 0) {
	          this.state.set('statusMessage', value);
	        }
	
	        return this.state.get('statusMessage');
	      },
	
	      showMenu: function () {
	        var self = this, settings = self.settings, menu;
	
	        if (!self.menu) {
	          menu = settings.menu || [];
	
	          // Is menu array then auto constuct menu control
	          if (menu.length) {
	            menu = {
	              type: 'menu',
	              items: menu
	            };
	          } else {
	            menu.type = menu.type || 'menu';
	          }
	
	          self.menu = Factory.create(menu).parent(self).renderTo(self.getContainerElm());
	          self.fire('createmenu');
	          self.menu.reflow();
	          self.menu.on('cancel', function (e) {
	            if (e.control === self.menu) {
	              self.focus();
	            }
	          });
	
	          self.menu.on('show hide', function (e) {
	            e.control.items().each(function (ctrl) {
	              ctrl.active(ctrl.value() == self.value());
	            });
	          }).fire('show');
	
	          self.menu.on('select', function (e) {
	            self.value(e.control.value());
	          });
	
	          self.on('focusin', function (e) {
	            if (e.target.tagName.toUpperCase() == 'INPUT') {
	              self.menu.hide();
	            }
	          });
	
	          self.aria('expanded', true);
	        }
	
	        self.menu.show();
	        self.menu.layoutRect({ w: self.layoutRect().w });
	        self.menu.moveRel(self.getEl(), self.isRtl() ? ['br-tr', 'tr-br'] : ['bl-tl', 'tl-bl']);
	      },
	
	      /**
	       * Focuses the input area of the control.
	       *
	       * @method focus
	       */
	      focus: function () {
	        this.getEl('inp').focus();
	      },
	
	      /**
	       * Repaints the control after a layout operation.
	       *
	       * @method repaint
	       */
	      repaint: function () {
	        var self = this, elm = self.getEl(), openElm = self.getEl('open'), rect = self.layoutRect();
	        var width, lineHeight, innerPadding = 0, inputElm = elm.firstChild;
	
	        if (self.statusLevel() && self.statusLevel() !== 'none') {
	          innerPadding = (
	            parseInt(DomUtils.getRuntimeStyle(inputElm, 'padding-right'), 10) -
	            parseInt(DomUtils.getRuntimeStyle(inputElm, 'padding-left'), 10)
	          );
	        }
	
	        if (openElm) {
	          width = rect.w - DomUtils.getSize(openElm).width - 10;
	        } else {
	          width = rect.w - 10;
	        }
	
	        // Detect old IE 7+8 add lineHeight to align caret vertically in the middle
	        var doc = document;
	        if (doc.all && (!doc.documentMode || doc.documentMode <= 8)) {
	          lineHeight = (self.layoutRect().h - 2) + 'px';
	        }
	
	        DomQuery(inputElm).css({
	          width: width - innerPadding,
	          lineHeight: lineHeight
	        });
	
	        self._super();
	
	        return self;
	      },
	
	      /**
	       * Post render method. Called after the control has been rendered to the target.
	       *
	       * @method postRender
	       * @return {tinymce.ui.ComboBox} Current combobox instance.
	       */
	      postRender: function () {
	        var self = this;
	
	        DomQuery(this.getEl('inp')).on('change', function (e) {
	          self.state.set('value', e.target.value);
	          self.fire('change', e);
	        });
	
	        return self._super();
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, id = self._id, settings = self.settings, prefix = self.classPrefix;
	        var value = self.state.get('value') || '';
	        var icon, text, openBtnHtml = '', extraAttrs = '', statusHtml = '';
	
	        if ("spellcheck" in settings) {
	          extraAttrs += ' spellcheck="' + settings.spellcheck + '"';
	        }
	
	        if (settings.maxLength) {
	          extraAttrs += ' maxlength="' + settings.maxLength + '"';
	        }
	
	        if (settings.size) {
	          extraAttrs += ' size="' + settings.size + '"';
	        }
	
	        if (settings.subtype) {
	          extraAttrs += ' type="' + settings.subtype + '"';
	        }
	
	        statusHtml = '<i id="' + id + '-status" class="mce-status mce-ico" style="display: none"></i>';
	
	        if (self.disabled()) {
	          extraAttrs += ' disabled="disabled"';
	        }
	
	        icon = settings.icon;
	        if (icon && icon != 'caret') {
	          icon = prefix + 'ico ' + prefix + 'i-' + settings.icon;
	        }
	
	        text = self.state.get('text');
	
	        if (icon || text) {
	          openBtnHtml = (
	            '<div id="' + id + '-open" class="' + prefix + 'btn ' + prefix + 'open" tabIndex="-1" role="button">' +
	            '<button id="' + id + '-action" type="button" hidefocus="1" tabindex="-1">' +
	            (icon != 'caret' ? '<i class="' + icon + '"></i>' : '<i class="' + prefix + 'caret"></i>') +
	            (text ? (icon ? ' ' : '') + text : '') +
	            '</button>' +
	            '</div>'
	          );
	
	          self.classes.add('has-open');
	        }
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '">' +
	          '<input id="' + id + '-inp" class="' + prefix + 'textbox" value="' +
	          self.encode(value, false) + '" hidefocus="1"' + extraAttrs + ' placeholder="' +
	          self.encode(settings.placeholder) + '" />' +
	          statusHtml +
	          openBtnHtml +
	          '</div>'
	        );
	      },
	
	      value: function (value) {
	        if (arguments.length) {
	          this.state.set('value', value);
	          return this;
	        }
	
	        // Make sure the real state is in sync
	        if (this.state.get('rendered')) {
	          this.state.set('value', this.getEl('inp').value);
	        }
	
	        return this.state.get('value');
	      },
	
	      showAutoComplete: function (items, term) {
	        var self = this;
	
	        if (items.length === 0) {
	          self.hideMenu();
	          return;
	        }
	
	        var insert = function (value, title) {
	          return function () {
	            self.fire('selectitem', {
	              title: title,
	              value: value
	            });
	          };
	        };
	
	        if (self.menu) {
	          self.menu.items().remove();
	        } else {
	          self.menu = Factory.create({
	            type: 'menu',
	            classes: 'combobox-menu',
	            layout: 'flow'
	          }).parent(self).renderTo();
	        }
	
	        Tools.each(items, function (item) {
	          self.menu.add({
	            text: item.title,
	            url: item.previewUrl,
	            match: term,
	            classes: 'menu-item-ellipsis',
	            onclick: insert(item.value, item.title)
	          });
	        });
	
	        self.menu.renderNew();
	        self.hideMenu();
	
	        self.menu.on('cancel', function (e) {
	          if (e.control.parent() === self.menu) {
	            e.stopPropagation();
	            self.focus();
	            self.hideMenu();
	          }
	        });
	
	        self.menu.on('select', function () {
	          self.focus();
	        });
	
	        var maxW = self.layoutRect().w;
	        self.menu.layoutRect({ w: maxW, minW: 0, maxW: maxW });
	        self.menu.reflow();
	        self.menu.show();
	        self.menu.moveRel(self.getEl(), self.isRtl() ? ['br-tr', 'tr-br'] : ['bl-tl', 'tl-bl']);
	      },
	
	      hideMenu: function () {
	        if (this.menu) {
	          this.menu.hide();
	        }
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:value', function (e) {
	          if (self.getEl('inp').value != e.value) {
	            self.getEl('inp').value = e.value;
	          }
	        });
	
	        self.state.on('change:disabled', function (e) {
	          self.getEl('inp').disabled = e.value;
	        });
	
	        self.state.on('change:statusLevel', function (e) {
	          var statusIconElm = self.getEl('status');
	          var prefix = self.classPrefix, value = e.value;
	
	          DomUtils.css(statusIconElm, 'display', value === 'none' ? 'none' : '');
	          DomUtils.toggleClass(statusIconElm, prefix + 'i-checkmark', value === 'ok');
	          DomUtils.toggleClass(statusIconElm, prefix + 'i-warning', value === 'warn');
	          DomUtils.toggleClass(statusIconElm, prefix + 'i-error', value === 'error');
	          self.classes.toggle('has-status', value !== 'none');
	          self.repaint();
	        });
	
	        DomUtils.on(self.getEl('status'), 'mouseleave', function () {
	          self.tooltip().hide();
	        });
	
	        self.on('cancel', function (e) {
	          if (self.menu && self.menu.visible()) {
	            e.stopPropagation();
	            self.hideMenu();
	          }
	        });
	
	        var focusIdx = function (idx, menu) {
	          if (menu && menu.items().length > 0) {
	            menu.items().eq(idx)[0].focus();
	          }
	        };
	
	        self.on('keydown', function (e) {
	          var keyCode = e.keyCode;
	
	          if (e.target.nodeName === 'INPUT') {
	            if (keyCode === VK.DOWN) {
	              e.preventDefault();
	              self.fire('autocomplete');
	              focusIdx(0, self.menu);
	            } else if (keyCode === VK.UP) {
	              e.preventDefault();
	              focusIdx(-1, self.menu);
	            }
	          }
	        });
	
	        return self._super();
	      },
	
	      remove: function () {
	        DomQuery(this.getEl('inp')).off();
	
	        if (this.menu) {
	          this.menu.remove();
	        }
	
	        this._super();
	      }
	    });
	  }
	);
	/**
	 * ColorBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This widget lets you enter colors and browse for colors by pressing the color button. It also displays
	 * a preview of the current color.
	 *
	 * @-x-less ColorBox.less
	 * @class tinymce.ui.ColorBox
	 * @extends tinymce.ui.ComboBox
	 */
	define(
	  'tinymce.ui.ColorBox',
	  [
	    "tinymce.ui.ComboBox"
	  ],
	  function (ComboBox) {
	    "use strict";
	
	    return ComboBox.extend({
	      /**
	       * Constructs a new control instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       */
	      init: function (settings) {
	        var self = this;
	
	        settings.spellcheck = false;
	
	        if (settings.onaction) {
	          settings.icon = 'none';
	        }
	
	        self._super(settings);
	
	        self.classes.add('colorbox');
	        self.on('change keyup postrender', function () {
	          self.repaintColor(self.value());
	        });
	      },
	
	      repaintColor: function (value) {
	        var openElm = this.getEl('open');
	        var elm = openElm ? openElm.getElementsByTagName('i')[0] : null;
	
	        if (elm) {
	          try {
	            elm.style.background = value;
	          } catch (ex) {
	            // Ignore
	          }
	        }
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:value', function (e) {
	          if (self.state.get('rendered')) {
	            self.repaintColor(e.value);
	          }
	        });
	
	        return self._super();
	      }
	    });
	  }
	);
	/**
	 * PanelButton.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new panel button.
	 *
	 * @class tinymce.ui.PanelButton
	 * @extends tinymce.ui.Button
	 */
	define(
	  'tinymce.ui.PanelButton',
	  [
	    "tinymce.ui.Button",
	    "tinymce.ui.FloatPanel"
	  ],
	  function (Button, FloatPanel) {
	    "use strict";
	
	    return Button.extend({
	      /**
	       * Shows the panel for the button.
	       *
	       * @method showPanel
	       */
	      showPanel: function () {
	        var self = this, settings = self.settings;
	
	        self.classes.add('opened');
	
	        if (!self.panel) {
	          var panelSettings = settings.panel;
	
	          // Wrap panel in grid layout if type if specified
	          // This makes it possible to add forms or other containers directly in the panel option
	          if (panelSettings.type) {
	            panelSettings = {
	              layout: 'grid',
	              items: panelSettings
	            };
	          }
	
	          panelSettings.role = panelSettings.role || 'dialog';
	          panelSettings.popover = true;
	          panelSettings.autohide = true;
	          panelSettings.ariaRoot = true;
	
	          self.panel = new FloatPanel(panelSettings).on('hide', function () {
	            self.classes.remove('opened');
	          }).on('cancel', function (e) {
	            e.stopPropagation();
	            self.focus();
	            self.hidePanel();
	          }).parent(self).renderTo(self.getContainerElm());
	
	          self.panel.fire('show');
	          self.panel.reflow();
	        } else {
	          self.panel.show();
	        }
	
	        var rel = self.panel.testMoveRel(self.getEl(), settings.popoverAlign || (self.isRtl() ? ['bc-tc', 'bc-tl', 'bc-tr'] : ['bc-tc', 'bc-tr', 'bc-tl']));
	
	        self.panel.classes.toggle('start', rel === 'bc-tl');
	        self.panel.classes.toggle('end', rel === 'bc-tr');
	
	        self.panel.moveRel(self.getEl(), rel);
	      },
	
	      /**
	       * Hides the panel for the button.
	       *
	       * @method hidePanel
	       */
	      hidePanel: function () {
	        var self = this;
	
	        if (self.panel) {
	          self.panel.hide();
	        }
	      },
	
	      /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this;
	
	        self.aria('haspopup', true);
	
	        self.on('click', function (e) {
	          if (e.control === self) {
	            if (self.panel && self.panel.visible()) {
	              self.hidePanel();
	            } else {
	              self.showPanel();
	              self.panel.focus(!!e.aria);
	            }
	          }
	        });
	
	        return self._super();
	      },
	
	      remove: function () {
	        if (this.panel) {
	          this.panel.remove();
	          this.panel = null;
	        }
	
	        return this._super();
	      }
	    });
	  }
	);
	/**
	 * ColorButton.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a color button control. This is a split button in which the main
	 * button has a visual representation of the currently selected color. When clicked
	 * the caret button displays a color picker, allowing the user to select a new color.
	 *
	 * @-x-less ColorButton.less
	 * @class tinymce.ui.ColorButton
	 * @extends tinymce.ui.PanelButton
	 */
	define(
	  'tinymce.ui.ColorButton',
	  [
	    "tinymce.ui.PanelButton",
	    "tinymce.core.dom.DOMUtils"
	  ],
	  function (PanelButton, DomUtils) {
	    "use strict";
	
	    var DOM = DomUtils.DOM;
	
	    return PanelButton.extend({
	      /**
	       * Constructs a new ColorButton instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       */
	      init: function (settings) {
	        this._super(settings);
	        this.classes.add('splitbtn');
	        this.classes.add('colorbutton');
	      },
	
	      /**
	       * Getter/setter for the current color.
	       *
	       * @method color
	       * @param {String} [color] Color to set.
	       * @return {String|tinymce.ui.ColorButton} Current color or current instance.
	       */
	      color: function (color) {
	        if (color) {
	          this._color = color;
	          this.getEl('preview').style.backgroundColor = color;
	          return this;
	        }
	
	        return this._color;
	      },
	
	      /**
	       * Resets the current color.
	       *
	       * @method resetColor
	       * @return {tinymce.ui.ColorButton} Current instance.
	       */
	      resetColor: function () {
	        this._color = null;
	        this.getEl('preview').style.backgroundColor = null;
	        return this;
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix, text = self.state.get('text');
	        var icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + self.settings.icon : '';
	        var image = self.settings.image ? ' style="background-image: url(\'' + self.settings.image + '\')"' : '',
	          textHtml = '';
	
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '" role="button" tabindex="-1" aria-haspopup="true">' +
	          '<button role="presentation" hidefocus="1" type="button" tabindex="-1">' +
	          (icon ? '<i class="' + icon + '"' + image + '></i>' : '') +
	          '<span id="' + id + '-preview" class="' + prefix + 'preview"></span>' +
	          textHtml +
	          '</button>' +
	          '<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' +
	          ' <i class="' + prefix + 'caret"></i>' +
	          '</button>' +
	          '</div>'
	        );
	      },
	
	      /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this, onClickHandler = self.settings.onclick;
	
	        self.on('click', function (e) {
	          if (e.aria && e.aria.key === 'down') {
	            return;
	          }
	
	          if (e.control == self && !DOM.getParent(e.target, '.' + self.classPrefix + 'open')) {
	            e.stopImmediatePropagation();
	            onClickHandler.call(self, e);
	          }
	        });
	
	        delete self.settings.onclick;
	
	        return self._super();
	      }
	    });
	  }
	);
	
	/**
	 * ResolveGlobal.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.Color',
	  [
	    'global!tinymce.util.Tools.resolve'
	  ],
	  function (resolve) {
	    return resolve('tinymce.util.Color');
	  }
	);
	
	/**
	 * ColorPicker.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Color picker widget lets you select colors.
	 *
	 * @-x-less ColorPicker.less
	 * @class tinymce.ui.ColorPicker
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.ColorPicker',
	  [
	    "tinymce.ui.Widget",
	    "tinymce.ui.DragHelper",
	    "tinymce.ui.DomUtils",
	    "tinymce.core.util.Color"
	  ],
	  function (Widget, DragHelper, DomUtils, Color) {
	    "use strict";
	
	    return Widget.extend({
	      Defaults: {
	        classes: "widget colorpicker"
	      },
	
	      /**
	       * Constructs a new colorpicker instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {String} color Initial color value.
	       */
	      init: function (settings) {
	        this._super(settings);
	      },
	
	      postRender: function () {
	        var self = this, color = self.color(), hsv, hueRootElm, huePointElm, svRootElm, svPointElm;
	
	        hueRootElm = self.getEl('h');
	        huePointElm = self.getEl('hp');
	        svRootElm = self.getEl('sv');
	        svPointElm = self.getEl('svp');
	
	        function getPos(elm, event) {
	          var pos = DomUtils.getPos(elm), x, y;
	
	          x = event.pageX - pos.x;
	          y = event.pageY - pos.y;
	
	          x = Math.max(0, Math.min(x / elm.clientWidth, 1));
	          y = Math.max(0, Math.min(y / elm.clientHeight, 1));
	
	          return {
	            x: x,
	            y: y
	          };
	        }
	
	        function updateColor(hsv, hueUpdate) {
	          var hue = (360 - hsv.h) / 360;
	
	          DomUtils.css(huePointElm, {
	            top: (hue * 100) + '%'
	          });
	
	          if (!hueUpdate) {
	            DomUtils.css(svPointElm, {
	              left: hsv.s + '%',
	              top: (100 - hsv.v) + '%'
	            });
	          }
	
	          svRootElm.style.background = new Color({ s: 100, v: 100, h: hsv.h }).toHex();
	          self.color().parse({ s: hsv.s, v: hsv.v, h: hsv.h });
	        }
	
	        function updateSaturationAndValue(e) {
	          var pos;
	
	          pos = getPos(svRootElm, e);
	          hsv.s = pos.x * 100;
	          hsv.v = (1 - pos.y) * 100;
	
	          updateColor(hsv);
	          self.fire('change');
	        }
	
	        function updateHue(e) {
	          var pos;
	
	          pos = getPos(hueRootElm, e);
	          hsv = color.toHsv();
	          hsv.h = (1 - pos.y) * 360;
	          updateColor(hsv, true);
	          self.fire('change');
	        }
	
	        self._repaint = function () {
	          hsv = color.toHsv();
	          updateColor(hsv);
	        };
	
	        self._super();
	
	        self._svdraghelper = new DragHelper(self._id + '-sv', {
	          start: updateSaturationAndValue,
	          drag: updateSaturationAndValue
	        });
	
	        self._hdraghelper = new DragHelper(self._id + '-h', {
	          start: updateHue,
	          drag: updateHue
	        });
	
	        self._repaint();
	      },
	
	      rgb: function () {
	        return this.color().toRgb();
	      },
	
	      value: function (value) {
	        var self = this;
	
	        if (arguments.length) {
	          self.color().parse(value);
	
	          if (self._rendered) {
	            self._repaint();
	          }
	        } else {
	          return self.color().toHex();
	        }
	      },
	
	      color: function () {
	        if (!this._color) {
	          this._color = new Color();
	        }
	
	        return this._color;
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix, hueHtml;
	        var stops = '#ff0000,#ff0080,#ff00ff,#8000ff,#0000ff,#0080ff,#00ffff,#00ff80,#00ff00,#80ff00,#ffff00,#ff8000,#ff0000';
	
	        function getOldIeFallbackHtml() {
	          var i, l, html = '', gradientPrefix, stopsList;
	
	          gradientPrefix = 'filter:progid:DXImageTransform.Microsoft.gradient(GradientType=0,startColorstr=';
	          stopsList = stops.split(',');
	          for (i = 0, l = stopsList.length - 1; i < l; i++) {
	            html += (
	              '<div class="' + prefix + 'colorpicker-h-chunk" style="' +
	              'height:' + (100 / l) + '%;' +
	              gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ');' +
	              '-ms-' + gradientPrefix + stopsList[i] + ',endColorstr=' + stopsList[i + 1] + ')' +
	              '"></div>'
	            );
	          }
	
	          return html;
	        }
	
	        var gradientCssText = (
	          'background: -ms-linear-gradient(top,' + stops + ');' +
	          'background: linear-gradient(to bottom,' + stops + ');'
	        );
	
	        hueHtml = (
	          '<div id="' + id + '-h" class="' + prefix + 'colorpicker-h" style="' + gradientCssText + '">' +
	          getOldIeFallbackHtml() +
	          '<div id="' + id + '-hp" class="' + prefix + 'colorpicker-h-marker"></div>' +
	          '</div>'
	        );
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '">' +
	          '<div id="' + id + '-sv" class="' + prefix + 'colorpicker-sv">' +
	          '<div class="' + prefix + 'colorpicker-overlay1">' +
	          '<div class="' + prefix + 'colorpicker-overlay2">' +
	          '<div id="' + id + '-svp" class="' + prefix + 'colorpicker-selector1">' +
	          '<div class="' + prefix + 'colorpicker-selector2"></div>' +
	          '</div>' +
	          '</div>' +
	          '</div>' +
	          '</div>' +
	          hueHtml +
	          '</div>'
	        );
	      }
	    });
	  }
	);
	/**
	 * DropZone.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new dropzone.
	 *
	 * @-x-less DropZone.less
	 * @class tinymce.ui.DropZone
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.DropZone',
	  [
	    'tinymce.ui.Widget',
	    'tinymce.core.util.Tools',
	    'tinymce.ui.DomUtils',
	    'global!RegExp'
	  ],
	  function (Widget, Tools, DomUtils, RegExp) {
	    return Widget.extend({
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Boolean} multiple True if the dropzone is a multiple control.
	       * @setting {Number} maxLength Max length for the dropzone.
	       * @setting {Number} size Size of the dropzone in characters.
	       */
	      init: function (settings) {
	        var self = this;
	
	        settings = Tools.extend({
	          height: 100,
	          text: "Drop an image here",
	          multiple: false,
	          accept: null // by default accept any files
	        }, settings);
	
	        self._super(settings);
	
	        self.classes.add('dropzone');
	
	        if (settings.multiple) {
	          self.classes.add('multiple');
	        }
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, attrs, elm;
	        var cfg = self.settings;
	
	        attrs = {
	          id: self._id,
	          hidefocus: '1'
	        };
	
	        elm = DomUtils.create('div', attrs, '<span>' + this.translate(cfg.text) + '</span>');
	
	        if (cfg.height) {
	          DomUtils.css(elm, 'height', cfg.height + 'px');
	        }
	
	        if (cfg.width) {
	          DomUtils.css(elm, 'width', cfg.width + 'px');
	        }
	
	        elm.className = self.classes;
	
	        return elm.outerHTML;
	      },
	
	
	        /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this;
	
	        var toggleDragClass = function (e) {
	          e.preventDefault();
	          self.classes.toggle('dragenter');
	          self.getEl().className = self.classes;
	        };
	
	        var filter = function (files) {
	          var accept = self.settings.accept;
	          if (typeof accept !== 'string') {
	            return files;
	          }
	
	          var re = new RegExp('(' + accept.split(/\s*,\s*/).join('|') + ')$', 'i');
	          return Tools.grep(files, function (file) {
	            return re.test(file.name);
	          });
	        };
	
	        self._super();
	
	        self.$el.on('dragover', function (e) {
	          e.preventDefault();
	        });
	
	        self.$el.on('dragenter', toggleDragClass);
	        self.$el.on('dragleave', toggleDragClass);
	
	        self.$el.on('drop', function (e) {
	          e.preventDefault();
	
	          if (self.state.get('disabled')) {
	            return;
	          }
	
	          var files = filter(e.dataTransfer.files);
	
	          self.value = function () {
	            if (!files.length) {
	              return null;
	            } else if (self.settings.multiple) {
	              return files;
	            } else {
	              return files[0];
	            }
	          };
	
	          if (files.length) {
	            self.fire('change', e);
	          }
	        });
	      },
	
	      remove: function () {
	        this.$el.off();
	        this._super();
	      }
	    });
	  }
	);
	
	/**
	 * Path.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new path control.
	 *
	 * @-x-less Path.less
	 * @class tinymce.ui.Path
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.Path',
	  [
	    "tinymce.ui.Widget"
	  ],
	  function (Widget) {
	    "use strict";
	
	    return Widget.extend({
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {String} delimiter Delimiter to display between row in path.
	       */
	      init: function (settings) {
	        var self = this;
	
	        if (!settings.delimiter) {
	          settings.delimiter = '\u00BB';
	        }
	
	        self._super(settings);
	        self.classes.add('path');
	        self.canFocus = true;
	
	        self.on('click', function (e) {
	          var index, target = e.target;
	
	          if ((index = target.getAttribute('data-index'))) {
	            self.fire('select', { value: self.row()[index], index: index });
	          }
	        });
	
	        self.row(self.settings.row);
	      },
	
	      /**
	       * Focuses the current control.
	       *
	       * @method focus
	       * @return {tinymce.ui.Control} Current control instance.
	       */
	      focus: function () {
	        var self = this;
	
	        self.getEl().firstChild.focus();
	
	        return self;
	      },
	
	      /**
	       * Sets/gets the data to be used for the path.
	       *
	       * @method row
	       * @param {Array} row Array with row name is rendered to path.
	       */
	      row: function (row) {
	        if (!arguments.length) {
	          return this.state.get('row');
	        }
	
	        this.state.set('row', row);
	
	        return this;
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this;
	
	        return (
	          '<div id="' + self._id + '" class="' + self.classes + '">' +
	          self._getDataPathHtml(self.state.get('row')) +
	          '</div>'
	        );
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:row', function (e) {
	          self.innerHtml(self._getDataPathHtml(e.value));
	        });
	
	        return self._super();
	      },
	
	      _getDataPathHtml: function (data) {
	        var self = this, parts = data || [], i, l, html = '', prefix = self.classPrefix;
	
	        for (i = 0, l = parts.length; i < l; i++) {
	          html += (
	            (i > 0 ? '<div class="' + prefix + 'divider" aria-hidden="true"> ' + self.settings.delimiter + ' </div>' : '') +
	            '<div role="button" class="' + prefix + 'path-item' + (i == l - 1 ? ' ' + prefix + 'last' : '') + '" data-index="' +
	            i + '" tabindex="-1" id="' + self._id + '-' + i + '" aria-level="' + (i + 1) + '">' + parts[i].name + '</div>'
	          );
	        }
	
	        if (!html) {
	          html = '<div class="' + prefix + 'path-item">\u00a0</div>';
	        }
	
	        return html;
	      }
	    });
	  }
	);
	
	/**
	 * ElementPath.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This control creates an path for the current selections parent elements in TinyMCE.
	 *
	 * @class tinymce.ui.ElementPath
	 * @extends tinymce.ui.Path
	 */
	define(
	  'tinymce.ui.ElementPath',
	  [
	    "tinymce.ui.Path"
	  ],
	  function (Path) {
	    return Path.extend({
	      /**
	       * Post render method. Called after the control has been rendered to the target.
	       *
	       * @method postRender
	       * @return {tinymce.ui.ElementPath} Current combobox instance.
	       */
	      postRender: function () {
	        var self = this, editor = self.settings.editor;
	
	        function isHidden(elm) {
	          if (elm.nodeType === 1) {
	            if (elm.nodeName == "BR" || !!elm.getAttribute('data-mce-bogus')) {
	              return true;
	            }
	
	            if (elm.getAttribute('data-mce-type') === 'bookmark') {
	              return true;
	            }
	          }
	
	          return false;
	        }
	
	        if (editor.settings.elementpath !== false) {
	          self.on('select', function (e) {
	            editor.focus();
	            editor.selection.select(this.row()[e.index].element);
	            editor.nodeChanged();
	          });
	
	          editor.on('nodeChange', function (e) {
	            var outParents = [], parents = e.parents, i = parents.length;
	
	            while (i--) {
	              if (parents[i].nodeType == 1 && !isHidden(parents[i])) {
	                var args = editor.fire('ResolveName', {
	                  name: parents[i].nodeName.toLowerCase(),
	                  target: parents[i]
	                });
	
	                if (!args.isDefaultPrevented()) {
	                  outParents.push({ name: args.name, element: parents[i] });
	                }
	
	                if (args.isPropagationStopped()) {
	                  break;
	                }
	              }
	            }
	
	            self.row(outParents);
	          });
	        }
	
	        return self._super();
	      }
	    });
	  }
	);
	/**
	 * FormItem.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is a container created by the form element with
	 * a label and control item.
	 *
	 * @class tinymce.ui.FormItem
	 * @extends tinymce.ui.Container
	 * @setting {String} label Label to display for the form item.
	 */
	define(
	  'tinymce.ui.FormItem',
	  [
	    "tinymce.ui.Container"
	  ],
	  function (Container) {
	    "use strict";
	
	    return Container.extend({
	      Defaults: {
	        layout: 'flex',
	        align: 'center',
	        defaults: {
	          flex: 1
	        }
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, layout = self._layout, prefix = self.classPrefix;
	
	        self.classes.add('formitem');
	        layout.preRender(self);
	
	        return (
	          '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' +
	          (self.settings.title ? ('<div id="' + self._id + '-title" class="' + prefix + 'title">' +
	            self.settings.title + '</div>') : '') +
	          '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' +
	          (self.settings.html || '') + layout.renderHtml(self) +
	          '</div>' +
	          '</div>'
	        );
	      }
	    });
	  }
	);
	/**
	 * Form.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a form container. A form container has the ability
	 * to automatically wrap items in tinymce.ui.FormItem instances.
	 *
	 * Each FormItem instance is a container for the label and the item.
	 *
	 * @example
	 * tinymce.core.ui.Factory.create({
	 *     type: 'form',
	 *     items: [
	 *         {type: 'textbox', label: 'My text box'}
	 *     ]
	 * }).renderTo(document.body);
	 *
	 * @class tinymce.ui.Form
	 * @extends tinymce.ui.Container
	 */
	define(
	  'tinymce.ui.Form',
	  [
	    "tinymce.ui.Container",
	    "tinymce.ui.FormItem",
	    "tinymce.core.util.Tools"
	  ],
	  function (Container, FormItem, Tools) {
	    "use strict";
	
	    return Container.extend({
	      Defaults: {
	        containerCls: 'form',
	        layout: 'flex',
	        direction: 'column',
	        align: 'stretch',
	        flex: 1,
	        padding: 15,
	        labelGap: 30,
	        spacing: 10,
	        callbacks: {
	          submit: function () {
	            this.submit();
	          }
	        }
	      },
	
	      /**
	       * This method gets invoked before the control is rendered.
	       *
	       * @method preRender
	       */
	      preRender: function () {
	        var self = this, items = self.items();
	
	        if (!self.settings.formItemDefaults) {
	          self.settings.formItemDefaults = {
	            layout: 'flex',
	            autoResize: "overflow",
	            defaults: { flex: 1 }
	          };
	        }
	
	        // Wrap any labeled items in FormItems
	        items.each(function (ctrl) {
	          var formItem, label = ctrl.settings.label;
	
	          if (label) {
	            formItem = new FormItem(Tools.extend({
	              items: {
	                type: 'label',
	                id: ctrl._id + '-l',
	                text: label,
	                flex: 0,
	                forId: ctrl._id,
	                disabled: ctrl.disabled()
	              }
	            }, self.settings.formItemDefaults));
	
	            formItem.type = 'formitem';
	            ctrl.aria('labelledby', ctrl._id + '-l');
	
	            if (typeof ctrl.settings.flex == "undefined") {
	              ctrl.settings.flex = 1;
	            }
	
	            self.replace(ctrl, formItem);
	            formItem.add(ctrl);
	          }
	        });
	      },
	
	      /**
	       * Fires a submit event with the serialized form.
	       *
	       * @method submit
	       * @return {Object} Event arguments object.
	       */
	      submit: function () {
	        return this.fire('submit', { data: this.toJSON() });
	      },
	
	      /**
	       * Post render method. Called after the control has been rendered to the target.
	       *
	       * @method postRender
	       * @return {tinymce.ui.ComboBox} Current combobox instance.
	       */
	      postRender: function () {
	        var self = this;
	
	        self._super();
	        self.fromJSON(self.settings.data);
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self._super();
	
	        function recalcLabels() {
	          var maxLabelWidth = 0, labels = [], i, labelGap, items;
	
	          if (self.settings.labelGapCalc === false) {
	            return;
	          }
	
	          if (self.settings.labelGapCalc == "children") {
	            items = self.find('formitem');
	          } else {
	            items = self.items();
	          }
	
	          items.filter('formitem').each(function (item) {
	            var labelCtrl = item.items()[0], labelWidth = labelCtrl.getEl().clientWidth;
	
	            maxLabelWidth = labelWidth > maxLabelWidth ? labelWidth : maxLabelWidth;
	            labels.push(labelCtrl);
	          });
	
	          labelGap = self.settings.labelGap || 0;
	
	          i = labels.length;
	          while (i--) {
	            labels[i].settings.minWidth = maxLabelWidth + labelGap;
	          }
	        }
	
	        self.on('show', recalcLabels);
	        recalcLabels();
	      }
	    });
	  }
	);
	/**
	 * FieldSet.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates fieldset containers.
	 *
	 * @-x-less FieldSet.less
	 * @class tinymce.ui.FieldSet
	 * @extends tinymce.ui.Form
	 */
	define(
	  'tinymce.ui.FieldSet',
	  [
	    "tinymce.ui.Form"
	  ],
	  function (Form) {
	    "use strict";
	
	    return Form.extend({
	      Defaults: {
	        containerCls: 'fieldset',
	        layout: 'flex',
	        direction: 'column',
	        align: 'stretch',
	        flex: 1,
	        padding: "25 15 5 15",
	        labelGap: 30,
	        spacing: 10,
	        border: 1
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, layout = self._layout, prefix = self.classPrefix;
	
	        self.preRender();
	        layout.preRender(self);
	
	        return (
	          '<fieldset id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' +
	          (self.settings.title ? ('<legend id="' + self._id + '-title" class="' + prefix + 'fieldset-title">' +
	            self.settings.title + '</legend>') : '') +
	          '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' +
	          (self.settings.html || '') + layout.renderHtml(self) +
	          '</div>' +
	          '</fieldset>'
	        );
	      }
	    });
	  }
	);
	defineGlobal("global!Date", Date);
	defineGlobal("global!Math", Math);
	define(
	  'ephox.katamari.api.Id',
	  [
	    'global!Date',
	    'global!Math',
	    'global!String'
	  ],
	
	  function (Date, Math, String) {
	
	    /**
	     * Generate a unique identifier.
	     *
	     * The unique portion of the identifier only contains an underscore
	     * and digits, so that it may safely be used within HTML attributes.
	     *
	     * The chance of generating a non-unique identifier has been minimized
	     * by combining the current time, a random number and a one-up counter.
	     *
	     * generate :: String -> String
	     */
	    var unique = 0;
	
	    var generate = function (prefix) {
	      var date   = new Date();
	      var time   = date.getTime();
	      var random = Math.floor(Math.random() * 1000000000);
	
	      unique++;
	
	      return prefix + '_' + random + unique + String(time);
	    };
	
	    return {
	      generate: generate
	    };
	
	  }
	);
	
	define("global!console", [], function () { if (typeof console === "undefined") console = { log: function () {} }; return console; });
	define(
	  'ephox.sugar.api.node.Element',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'global!Error',
	    'global!console',
	    'global!document'
	  ],
	
	  function (Fun, Option, Error, console, document) {
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw 'HTML must have a single root node';
	      }
	      return fromDom(div.childNodes[0]);
	    };
	
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	
	    var fromDom = function (node) {
	      if (node === null || node === undefined) throw new Error('Node cannot be null or undefined');
	      return {
	        dom: Fun.constant(node)
	      };
	    };
	
	    var fromPoint = function (doc, x, y) {
	      return Option.from(doc.dom().elementFromPoint(x, y)).map(fromDom);
	    };
	
	    return {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	  }
	);
	
	define(
	  'ephox.katamari.api.Thunk',
	
	  [
	  ],
	
	  function () {
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function() {
	        if (!called) {
	          called = true;
	          r = f.apply(null, arguments);
	        }
	        return r;
	      };
	    };
	
	    return {
	      cached: cached
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.node.NodeTypes',
	
	  [
	
	  ],
	
	  function () {
	    return {
	      ATTRIBUTE:              2,
	      CDATA_SECTION:          4,
	      COMMENT:                8,
	      DOCUMENT:               9,
	      DOCUMENT_TYPE:          10,
	      DOCUMENT_FRAGMENT:      11,
	      ELEMENT:                1,
	      TEXT:                   3,
	      PROCESSING_INSTRUCTION: 7,
	      ENTITY_REFERENCE:       5,
	      ENTITY:                 6,
	      NOTATION:               12
	    };
	  }
	);
	define(
	  'ephox.sugar.api.node.Node',
	
	  [
	    'ephox.sugar.api.node.NodeTypes'
	  ],
	
	  function (NodeTypes) {
	    var name = function (element) {
	      var r = element.dom().nodeName;
	      return r.toLowerCase();
	    };
	
	    var type = function (element) {
	      return element.dom().nodeType;
	    };
	
	    var value = function (element) {
	      return element.dom().nodeValue;
	    };
	
	    var isType = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	
	    var isComment = function (element) {
	      return type(element) === NodeTypes.COMMENT || name(element) === '#comment';
	    };
	
	    var isElement = isType(NodeTypes.ELEMENT);
	    var isText = isType(NodeTypes.TEXT);
	    var isDocument = isType(NodeTypes.DOCUMENT);
	
	    return {
	      name: name,
	      type: type,
	      value: value,
	      isElement: isElement,
	      isText: isText,
	      isDocument: isDocument,
	      isComment: isComment
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.node.Body',
	
	  [
	    'ephox.katamari.api.Thunk',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'global!document'
	  ],
	
	  function (Thunk, Element, Node, document) {
	
	    // Node.contains() is very, very, very good performance
	    // http://jsperf.com/closest-vs-contains/5
	    var inBody = function (element) {
	      // Technically this is only required on IE, where contains() returns false for text nodes.
	      // But it's cheap enough to run everywhere and Sugar doesn't have platform detection (yet).
	      var dom = Node.isText(element) ? element.dom().parentNode : element.dom();
	
	      // use ownerDocument.body to ensure this works inside iframes.
	      // Normally contains is bad because an element "contains" itself, but here we want that.
	      return dom !== undefined && dom !== null && dom.ownerDocument.body.contains(dom);
	    };
	
	    var body = Thunk.cached(function() {
	      return getBody(Element.fromDom(document));
	    });
	
	    var getBody = function (doc) {
	      var body = doc.dom().body;
	      if (body === null || body === undefined) throw 'Body is not available yet';
	      return Element.fromDom(body);
	    };
	
	    return {
	      body: body,
	      getBody: getBody,
	      inBody: inBody
	    };
	  }
	);
	
	define(
	  'ephox.katamari.api.Type',
	
	  [
	    'global!Array',
	    'global!String'
	  ],
	
	  function (Array, String) {
	    var typeOf = function(x) {
	      if (x === null) return 'null';
	      var t = typeof x;
	      if (t === 'object' && Array.prototype.isPrototypeOf(x)) return 'array';
	      if (t === 'object' && String.prototype.isPrototypeOf(x)) return 'string';
	      return t;
	    };
	
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	
	    return {
	      isString: isType('string'),
	      isObject: isType('object'),
	      isArray: isType('array'),
	      isNull: isType('null'),
	      isBoolean: isType('boolean'),
	      isUndefined: isType('undefined'),
	      isFunction: isType('function'),
	      isNumber: isType('number')
	    };
	  }
	);
	
	
	define(
	  'ephox.katamari.data.Immutable',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'global!Array',
	    'global!Error'
	  ],
	
	  function (Arr, Fun, Array, Error) {
	    return function () {
	      var fields = arguments;
	      return function(/* values */) {
	        //  Don't use array slice(arguments), makes the whole function unoptimisable on Chrome
	        var values = new Array(arguments.length);
	        for (var i = 0; i < values.length; i++) values[i] = arguments[i];
	
	        if (fields.length !== values.length)
	          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
	
	        var struct = {};
	        Arr.each(fields, function (name, i) {
	          struct[name] = Fun.constant(values[i]);
	        });
	        return struct;
	      };
	    };
	  }
	);
	
	define(
	  'ephox.katamari.api.Obj',
	
	  [
	    'ephox.katamari.api.Option',
	    'global!Object'
	  ],
	
	  function (Option, Object) {
	    // There are many variations of Object iteration that are faster than the 'for-in' style:
	    // http://jsperf.com/object-keys-iteration/107
	    //
	    // Use the native keys if it is available (IE9+), otherwise fall back to manually filtering
	    var keys = (function () {
	      var fastKeys = Object.keys;
	
	      // This technically means that 'each' and 'find' on IE8 iterate through the object twice.
	      // This code doesn't run on IE8 much, so it's an acceptable tradeoff.
	      // If it becomes a problem we can always duplicate the feature detection inside each and find as well.
	      var slowKeys = function (o) {
	        var r = [];
	        for (var i in o) {
	          if (o.hasOwnProperty(i)) {
	            r.push(i);
	          }
	        }
	        return r;
	      };
	
	      return fastKeys === undefined ? slowKeys : fastKeys;
	    })();
	
	
	    var each = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i, obj);
	      }
	    };
	
	    /** objectMap :: (JsObj(k, v), (v, k, JsObj(k, v) -> x)) -> JsObj(k, x) */
	    var objectMap = function (obj, f) {
	      return tupleMap(obj, function (x, i, obj) {
	        return {
	          k: i,
	          v: f(x, i, obj)
	        };
	      });
	    };
	
	    /** tupleMap :: (JsObj(k, v), (v, k, JsObj(k, v) -> { k: x, v: y })) -> JsObj(x, y) */
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each(obj, function (x, i) {
	        var tuple = f(x, i, obj);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	
	    /** bifilter :: (JsObj(k, v), (v, k -> Bool)) -> { t: JsObj(k, v), f: JsObj(k, v) } */
	    var bifilter = function (obj, pred) {
	      var t = {};
	      var f = {};
	      each(obj, function(x, i) {
	        var branch = pred(x, i) ? t : f;
	        branch[i] = x;
	      });
	      return {
	        t: t,
	        f: f
	      };
	    };
	
	    /** mapToArray :: (JsObj(k, v), (v, k -> a)) -> [a] */
	    var mapToArray = function (obj, f) {
	      var r = [];
	      each(obj, function(value, name) {
	        r.push(f(value, name));
	      });
	      return r;
	    };
	
	    /** find :: (JsObj(k, v), (v, k, JsObj(k, v) -> Bool)) -> Option v */
	    var find = function (obj, pred) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        if (pred(x, i, obj)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	
	    /** values :: JsObj(k, v) -> [v] */
	    var values = function (obj) {
	      return mapToArray(obj, function (v) {
	        return v;
	      });
	    };
	
	    var size = function (obj) {
	      return values(obj).length;
	    };
	
	    return {
	      bifilter: bifilter,
	      each: each,
	      map: objectMap,
	      mapToArray: mapToArray,
	      tupleMap: tupleMap,
	      find: find,
	      keys: keys,
	      values: values,
	      size: size
	    };
	  }
	);
	define(
	  'ephox.katamari.util.BagUtils',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Type',
	    'global!Error'
	  ],
	
	  function (Arr, Type, Error) {
	    var sort = function (arr) {
	      return arr.slice(0).sort();
	    };
	
	    var reqMessage = function (required, keys) {
	      throw new Error('All required keys (' + sort(required).join(', ') + ') were not specified. Specified keys were: ' + sort(keys).join(', ') + '.');
	    };
	
	    var unsuppMessage = function (unsupported) {
	      throw new Error('Unsupported keys for object: ' + sort(unsupported).join(', '));
	    };
	
	    var validateStrArr = function (label, array) {
	      if (!Type.isArray(array)) throw new Error('The ' + label + ' fields must be an array. Was: ' + array + '.');
	      Arr.each(array, function (a) {
	        if (!Type.isString(a)) throw new Error('The value ' + a + ' in the ' + label + ' fields was not a string.');
	      });
	    };
	
	    var invalidTypeMessage = function (incorrect, type) {
	      throw new Error('All values need to be of type: ' + type + '. Keys (' + sort(incorrect).join(', ') + ') were not.');
	    };
	
	    var checkDupes = function (everything) {
	      var sorted = sort(everything);
	      var dupe = Arr.find(sorted, function (s, i) {
	        return i < sorted.length -1 && s === sorted[i + 1];
	      });
	
	      dupe.each(function (d) {
	        throw new Error('The field: ' + d + ' occurs more than once in the combined fields: [' + sorted.join(', ') + '].');
	      });
	    };
	
	    return {
	      sort: sort,
	      reqMessage: reqMessage,
	      unsuppMessage: unsuppMessage,
	      validateStrArr: validateStrArr,
	      invalidTypeMessage: invalidTypeMessage,
	      checkDupes: checkDupes
	    };
	  }
	);
	define(
	  'ephox.katamari.data.MixedBag',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Obj',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.util.BagUtils',
	    'global!Error',
	    'global!Object'
	  ],
	
	  function (Arr, Fun, Obj, Option, BagUtils, Error, Object) {
	    
	    return function (required, optional) {
	      var everything = required.concat(optional);
	      if (everything.length === 0) throw new Error('You must specify at least one required or optional field.');
	
	      BagUtils.validateStrArr('required', required);
	      BagUtils.validateStrArr('optional', optional);
	
	      BagUtils.checkDupes(everything);
	
	      return function (obj) {
	        var keys = Obj.keys(obj);
	
	        // Ensure all required keys are present.
	        var allReqd = Arr.forall(required, function (req) {
	          return Arr.contains(keys, req);
	        });
	
	        if (! allReqd) BagUtils.reqMessage(required, keys);
	
	        var unsupported = Arr.filter(keys, function (key) {
	          return !Arr.contains(everything, key);
	        });
	
	        if (unsupported.length > 0) BagUtils.unsuppMessage(unsupported);
	
	        var r = {};
	        Arr.each(required, function (req) {
	          r[req] = Fun.constant(obj[req]);
	        });
	
	        Arr.each(optional, function (opt) {
	          r[opt] = Fun.constant(Object.prototype.hasOwnProperty.call(obj, opt) ? Option.some(obj[opt]): Option.none());
	        });
	
	        return r;
	      };
	    };
	  }
	);
	define(
	  'ephox.katamari.api.Struct',
	
	  [
	    'ephox.katamari.data.Immutable',
	    'ephox.katamari.data.MixedBag'
	  ],
	
	  function (Immutable, MixedBag) {
	    return {
	      immutable: Immutable,
	      immutableBag: MixedBag
	    };
	  }
	);
	
	define(
	  'ephox.sugar.alien.Recurse',
	
	  [
	
	  ],
	
	  function () {
	    /**
	     * Applies f repeatedly until it completes (by returning Option.none()).
	     *
	     * Normally would just use recursion, but JavaScript lacks tail call optimisation.
	     *
	     * This is what recursion looks like when manually unravelled :)
	     */
	    var toArray = function (target, f) {
	      var r = [];
	
	      var recurse = function (e) {
	        r.push(e);
	        return f(e);
	      };
	
	      var cur = f(target);
	      do {
	        cur = cur.bind(recurse);
	      } while (cur.isSome());
	
	      return r;
	    };
	
	    return {
	      toArray: toArray
	    };
	  }
	);
	define(
	  'ephox.katamari.api.Global',
	
	  [
	  ],
	
	  function () {
	    // Use window object as the global if it's available since CSP will block script evals
	    var global = typeof window !== 'undefined' ? window : Function('return this;')();
	    return global;
	  }
	);
	
	
	define(
	  'ephox.katamari.api.Resolve',
	
	  [
	    'ephox.katamari.api.Global'
	  ],
	
	  function (Global) {
	    /** path :: ([String], JsObj?) -> JsObj */
	    var path = function (parts, scope) {
	      var o = scope !== undefined ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i)
	        o = o[parts[i]];
	      return o;
	    };
	
	    /** resolve :: (String, JsObj?) -> JsObj */
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    /** step :: (JsObj, String) -> JsObj */
	    var step = function (o, part) {
	      if (o[part] === undefined || o[part] === null)
	        o[part] = {};
	      return o[part];
	    };
	
	    /** forge :: ([String], JsObj?) -> JsObj */
	    var forge = function (parts, target) {
	      var o = target !== undefined ? target : Global;      
	      for (var i = 0; i < parts.length; ++i)
	        o = step(o, parts[i]);
	      return o;
	    };
	
	    /** namespace :: (String, JsObj?) -> JsObj */
	    var namespace = function (name, target) {
	      var parts = name.split('.');
	      return forge(parts, target);
	    };
	
	    return {
	      path: path,
	      resolve: resolve,
	      forge: forge,
	      namespace: namespace
	    };
	  }
	);
	
	
	define(
	  'ephox.sand.util.Global',
	
	  [
	    'ephox.katamari.api.Resolve'
	  ],
	
	  function (Resolve) {
	    var unsafe = function (name, scope) {
	      return Resolve.resolve(name, scope);
	    };
	
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	
	      if (actual === undefined) throw name + ' not available on this browser';
	      return actual;
	    };
	
	    return {
	      getOrDie: getOrDie
	    };
	  }
	);
	define(
	  'ephox.sand.api.Node',
	
	  [
	    'ephox.sand.util.Global'
	  ],
	
	  function (Global) {
	    /*
	     * MDN says (yes) for IE, but it's undefined on IE8
	     */
	    var node = function () {
	      var f = Global.getOrDie('Node');
	      return f;
	    };
	
	    /*
	     * Most of numerosity doesn't alter the methods on the object.
	     * We're making an exception for Node, because bitwise and is so easy to get wrong.
	     *
	     * Might be nice to ADT this at some point instead of having individual methods.
	     */
	
	    var compareDocumentPosition = function (a, b, match) {
	      // Returns: 0 if e1 and e2 are the same node, or a bitmask comparing the positions
	      // of nodes e1 and e2 in their documents. See the URL below for bitmask interpretation
	      // https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
	    };
	
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
	    };
	
	    return {
	      documentPositionPreceding: documentPositionPreceding,
	      documentPositionContainedBy: documentPositionContainedBy
	    };
	  }
	);
	defineGlobal("global!Number", Number);
	define(
	  'ephox.sand.detect.Version',
	
	  [
	    'ephox.katamari.api.Arr',
	    'global!Number',
	    'global!String'
	  ],
	
	  function (Arr, Number, String) {
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) return x;
	      }
	      return undefined;
	    };
	
	    var find = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) return { major : 0, minor : 0 };
	      var group = function(i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	
	      if (versionRegexes.length === 0) return unknown();
	      return find(versionRegexes, cleanedAgent);
	    };
	
	    var unknown = function () {
	      return nu(0, 0);
	    };
	
	    var nu = function (major, minor) {
	      return { major: major, minor: minor };
	    };
	
	    return {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	  }
	);
	define(
	  'ephox.sand.core.Browser',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.sand.detect.Version'
	  ],
	
	  function (Fun, Version) {
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	
	    var isBrowser = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	
	    var unknown = function () {
	      return nu({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	
	    var nu = function (info) {
	      var current = info.current;
	      var version = info.version;
	
	      return {
	        current: current,
	        version: version,
	
	        // INVESTIGATE: Rename to Edge ?
	        isEdge: isBrowser(edge, current),
	        isChrome: isBrowser(chrome, current),
	        // NOTE: isIe just looks too weird
	        isIE: isBrowser(ie, current),
	        isOpera: isBrowser(opera, current),
	        isFirefox: isBrowser(firefox, current),
	        isSafari: isBrowser(safari, current)
	      };
	    };
	
	    return {
	      unknown: unknown,
	      nu: nu,
	      edge: Fun.constant(edge),
	      chrome: Fun.constant(chrome),
	      ie: Fun.constant(ie),
	      opera: Fun.constant(opera),
	      firefox: Fun.constant(firefox),
	      safari: Fun.constant(safari)
	    };
	  }
	);
	define(
	  'ephox.sand.core.OperatingSystem',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.sand.detect.Version'
	  ],
	
	  function (Fun, Version) {
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	
	    // Though there is a bit of dupe with this and Browser, trying to 
	    // reuse code makes it much harder to follow and change.
	    var isOS = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	
	    var unknown = function () {
	      return nu({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	
	    var nu = function (info) {
	      var current = info.current;
	      var version = info.version;
	
	      return {
	        current: current,
	        version: version,
	
	        isWindows: isOS(windows, current),
	        // TODO: Fix capitalisation
	        isiOS: isOS(ios, current),
	        isAndroid: isOS(android, current),
	        isOSX: isOS(osx, current),
	        isLinux: isOS(linux, current),
	        isSolaris: isOS(solaris, current),
	        isFreeBSD: isOS(freebsd, current)
	      };
	    };
	
	    return {
	      unknown: unknown,
	      nu: nu,
	
	      windows: Fun.constant(windows),
	      ios: Fun.constant(ios),
	      android: Fun.constant(android),
	      linux: Fun.constant(linux),
	      osx: Fun.constant(osx),
	      solaris: Fun.constant(solaris),
	      freebsd: Fun.constant(freebsd)
	    };
	  }
	);
	define(
	  'ephox.sand.detect.DeviceType',
	
	  [
	    'ephox.katamari.api.Fun'
	  ],
	
	  function (Fun) {
	    return function (os, browser, userAgent) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isAndroid3 = os.isAndroid() && os.version.major === 3;
	      var isAndroid4 = os.isAndroid() && os.version.major === 4;
	      var isTablet = isiPad || isAndroid3 || ( isAndroid4 && /mobile/i.test(userAgent) === true );
	      var isTouch = os.isiOS() || os.isAndroid();
	      var isPhone = isTouch && !isTablet;
	
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	
	      return {
	        isiPad : Fun.constant(isiPad),
	        isiPhone: Fun.constant(isiPhone),
	        isTablet: Fun.constant(isTablet),
	        isPhone: Fun.constant(isPhone),
	        isTouch: Fun.constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: Fun.constant(iOSwebview)
	      };
	    };
	  }
	);
	define(
	  'ephox.sand.detect.UaString',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sand.detect.Version',
	    'global!String'
	  ],
	
	  function (Arr, Version, String) {
	    var detect = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return Arr.find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	
	    // They (browser and os) are the same at the moment, but they might
	    // not stay that way.
	    var detectBrowser = function (browsers, userAgent) {
	      return detect(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	
	    var detectOs = function (oses, userAgent) {
	      return detect(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	
	    return {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	  }
	);
	define(
	  'ephox.katamari.str.StrAppend',
	
	  [
	
	  ],
	
	  function () {
	    var addToStart = function (str, prefix) {
	      return prefix + str;
	    };
	
	    var addToEnd = function (str, suffix) {
	      return str + suffix;
	    };
	
	    var removeFromStart = function (str, numChars) {
	      return str.substring(numChars);
	    };
	
	    var removeFromEnd = function (str, numChars) {
	      return str.substring(0, str.length - numChars);
	    };
	 
	    return {
	      addToStart: addToStart,
	      addToEnd: addToEnd,
	      removeFromStart: removeFromStart,
	      removeFromEnd: removeFromEnd
	    };
	  }
	);
	define(
	  'ephox.katamari.str.StringParts',
	
	  [
	    'ephox.katamari.api.Option',
	    'global!Error'
	  ],
	
	  function (Option, Error) {
	    /** Return the first 'count' letters from 'str'.
	-     *  e.g. first("abcde", 2) === "ab"
	-     */
	    var first = function(str, count) {
	     return str.substr(0, count);
	    };
	
	    /** Return the last 'count' letters from 'str'.
	    *  e.g. last("abcde", 2) === "de"
	    */
	    var last = function(str, count) {
	     return str.substr(str.length - count, str.length);
	    };
	
	    var head = function(str) {
	      return str === '' ? Option.none() : Option.some(str.substr(0, 1));
	    };
	
	    var tail = function(str) {
	      return str === '' ? Option.none() : Option.some(str.substring(1));
	    };
	
	    return {
	      first: first,
	      last: last,
	      head: head,
	      tail: tail
	    };
	  }
	);
	define(
	  'ephox.katamari.api.Strings',
	
	  [
	    'ephox.katamari.str.StrAppend',
	    'ephox.katamari.str.StringParts',
	    'global!Error'
	  ],
	
	  function (StrAppend, StringParts, Error) {
	    var checkRange = function(str, substr, start) {
	      if (substr === '') return true;
	      if (str.length < substr.length) return false;
	      var x = str.substr(start, start + substr.length);
	      return x === substr;
	    };
	
	    /** Given a string and object, perform template-replacements on the string, as specified by the object.
	     * Any template fields of the form ${name} are replaced by the string or number specified as obj["name"]
	     * Based on Douglas Crockford's 'supplant' method for template-replace of strings. Uses different template format.
	     */
	    var supplant = function(str, obj) {
	      var isStringOrNumber = function(a) {
	        var t = typeof a;
	        return t === 'string' || t === 'number';
	      };
	
	      return str.replace(/\${([^{}]*)}/g,
	        function (a, b) {
	          var value = obj[b];
	          return isStringOrNumber(value) ? value : a;
	        }
	      );
	    };
	
	    var removeLeading = function (str, prefix) {
	      return startsWith(str, prefix) ? StrAppend.removeFromStart(str, prefix.length) : str;
	    };
	
	    var removeTrailing = function (str, prefix) {
	      return endsWith(str, prefix) ? StrAppend.removeFromEnd(str, prefix.length) : str;
	    };
	
	    var ensureLeading = function (str, prefix) {
	      return startsWith(str, prefix) ? str : StrAppend.addToStart(str, prefix);
	    };
	
	    var ensureTrailing = function (str, prefix) {
	      return endsWith(str, prefix) ? str : StrAppend.addToEnd(str, prefix);
	    };
	 
	    var contains = function(str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	
	    var capitalize = function(str) {
	      return StringParts.head(str).bind(function (head) {
	        return StringParts.tail(str).map(function (tail) {
	          return head.toUpperCase() + tail;
	        });
	      }).getOr(str);
	    };
	
	    /** Does 'str' start with 'prefix'?
	     *  Note: all strings start with the empty string.
	     *        More formally, for all strings x, startsWith(x, "").
	     *        This is so that for all strings x and y, startsWith(y + x, y)
	     */
	    var startsWith = function(str, prefix) {
	      return checkRange(str, prefix, 0);
	    };
	
	    /** Does 'str' end with 'suffix'?
	     *  Note: all strings end with the empty string.
	     *        More formally, for all strings x, endsWith(x, "").
	     *        This is so that for all strings x and y, endsWith(x + y, y)
	     */
	    var endsWith = function(str, suffix) {
	      return checkRange(str, suffix, str.length - suffix.length);
	    };
	
	   
	    /** removes all leading and trailing spaces */
	    var trim = function(str) {
	      return str.replace(/^\s+|\s+$/g, '');
	    };
	
	    var lTrim = function(str) {
	      return str.replace(/^\s+/g, '');
	    };
	
	    var rTrim = function(str) {
	      return str.replace(/\s+$/g, '');
	    };
	
	    return {
	      supplant: supplant,
	      startsWith: startsWith,
	      removeLeading: removeLeading,
	      removeTrailing: removeTrailing,
	      ensureLeading: ensureLeading,
	      ensureTrailing: ensureTrailing,
	      endsWith: endsWith,
	      contains: contains,
	      trim: trim,
	      lTrim: lTrim,
	      rTrim: rTrim,
	      capitalize: capitalize
	    };
	  }
	);
	
	define(
	  'ephox.sand.info.PlatformInfo',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Strings'
	  ],
	
	  function (Fun, Strings) {
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	
	    var checkContains = function (target) {
	      return function (uastring) {
	        return Strings.contains(uastring, target);
	      };
	    };
	
	    var browsers = [
	      {
	        name : 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          var monstrosity = Strings.contains(uastring, 'edge/') && Strings.contains(uastring, 'chrome') && Strings.contains(uastring, 'safari') && Strings.contains(uastring, 'applewebkit');
	          return monstrosity;
	        }
	      },
	      {
	        name : 'Chrome',
	        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/, normalVersionRegex],
	        search : function (uastring) {
	          return Strings.contains(uastring, 'chrome') && !Strings.contains(uastring, 'chromeframe');
	        }
	      },
	      {
	        name : 'IE',
	        versionRegexes: [/.*?msie\ ?([0-9]+)\.([0-9]+).*/, /.*?rv:([0-9]+)\.([0-9]+).*/],
	        search: function (uastring) {
	          return Strings.contains(uastring, 'msie') || Strings.contains(uastring, 'trident');
	        }
	      },
	      // INVESTIGATE: Is this still the Opera user agent?
	      {
	        name : 'Opera',
	        versionRegexes: [normalVersionRegex, /.*?opera\/([0-9]+)\.([0-9]+).*/],
	        search : checkContains('opera')
	      },
	      {
	        name : 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search : checkContains('firefox')
	      },
	      {
	        name : 'Safari',
	        versionRegexes: [normalVersionRegex, /.*?cpu os ([0-9]+)_([0-9]+).*/],
	        search : function (uastring) {
	          return (Strings.contains(uastring, 'safari') || Strings.contains(uastring, 'mobile/')) && Strings.contains(uastring, 'applewebkit');
	        }
	      }
	    ];
	
	    var oses = [
	      {
	        name : 'Windows',
	        search : checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name : 'iOS',
	        search : function (uastring) {
	          return Strings.contains(uastring, 'iphone') || Strings.contains(uastring, 'ipad');
	        },
	        versionRegexes: [/.*?version\/\ ?([0-9]+)\.([0-9]+).*/, /.*cpu os ([0-9]+)_([0-9]+).*/, /.*cpu iphone os ([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name : 'Android',
	        search : checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name : 'OSX',
	        search : checkContains('os x'),
	        versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name : 'Linux',
	        search : checkContains('linux'),
	        versionRegexes: [ ]
	      },
	      { name : 'Solaris',
	        search : checkContains('sunos'),
	        versionRegexes: [ ]
	      },
	      {
	       name : 'FreeBSD',
	       search : checkContains('freebsd'),
	       versionRegexes: [ ]
	      }
	    ];
	
	    return {
	      browsers: Fun.constant(browsers),
	      oses: Fun.constant(oses)
	    };
	  }
	);
	define(
	  'ephox.sand.core.PlatformDetection',
	
	  [
	    'ephox.sand.core.Browser',
	    'ephox.sand.core.OperatingSystem',
	    'ephox.sand.detect.DeviceType',
	    'ephox.sand.detect.UaString',
	    'ephox.sand.info.PlatformInfo'
	  ],
	
	  function (Browser, OperatingSystem, DeviceType, UaString, PlatformInfo) {
	    var detect = function (userAgent) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(
	        Browser.unknown,
	        Browser.nu
	      );
	      var os = UaString.detectOs(oses, userAgent).fold(
	        OperatingSystem.unknown,
	        OperatingSystem.nu
	      );
	      var deviceType = DeviceType(os, browser, userAgent);
	
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	
	    return {
	      detect: detect
	    };
	  }
	);
	defineGlobal("global!navigator", navigator);
	define(
	  'ephox.sand.api.PlatformDetection',
	
	  [
	    'ephox.katamari.api.Thunk',
	    'ephox.sand.core.PlatformDetection',
	    'global!navigator'
	  ],
	
	  function (Thunk, PlatformDetection, navigator) {
	    var detect = Thunk.cached(function () {
	      var userAgent = navigator.userAgent;
	      return PlatformDetection.detect(userAgent);
	    });
	
	    return {
	      detect: detect
	    };
	  }
	);
	define(
	  'ephox.sugar.api.search.Selectors',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.NodeTypes',
	    'global!Error',
	    'global!document'
	  ],
	
	  function (Arr, Option, Element, NodeTypes, Error, document) {
	    var ELEMENT = NodeTypes.ELEMENT;
	    var DOCUMENT = NodeTypes.DOCUMENT;
	
	    var is = function (element, selector) {
	      var elem = element.dom();
	      if (elem.nodeType !== ELEMENT) return false; // documents have querySelector but not matches
	
	      // As of Chrome 34 / Safari 7.1 / FireFox 34, everyone except IE has the unprefixed function.
	      // Still check for the others, but do it last.
	      else if (elem.matches !== undefined) return elem.matches(selector);
	      else if (elem.msMatchesSelector !== undefined) return elem.msMatchesSelector(selector);
	      else if (elem.webkitMatchesSelector !== undefined) return elem.webkitMatchesSelector(selector);
	      else if (elem.mozMatchesSelector !== undefined) return elem.mozMatchesSelector(selector);
	      else throw new Error('Browser lacks native selectors'); // unfortunately we can't throw this on startup :(
	    };
	
	    var bypassSelector = function (dom) {
	      // Only elements and documents support querySelector
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT ||
	              // IE fix for complex queries on empty nodes: http://jsfiddle.net/spyder/fv9ptr5L/
	              dom.childElementCount === 0;
	    };
	
	    var all = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom();
	      return bypassSelector(base) ? [] : Arr.map(base.querySelectorAll(selector), Element.fromDom);
	    };
	
	    var one = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom();
	      return bypassSelector(base) ? Option.none() : Option.from(base.querySelector(selector)).map(Element.fromDom);
	    };
	
	    return {
	      all: all,
	      is: is,
	      one: one
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.dom.Compare',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.sand.api.Node',
	    'ephox.sand.api.PlatformDetection',
	    'ephox.sugar.api.search.Selectors'
	  ],
	
	  function (Arr, Fun, Node, PlatformDetection, Selectors) {
	
	    var eq = function (e1, e2) {
	      return e1.dom() === e2.dom();
	    };
	
	    var isEqualNode = function (e1, e2) {
	      return e1.dom().isEqualNode(e2.dom());
	    };
	
	    var member = function (element, elements) {
	      return Arr.exists(elements, Fun.curry(eq, element));
	    };
	
	    // DOM contains() method returns true if e1===e2, we define our contains() to return false (a node does not contain itself).
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom(), d2 = e2.dom();
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	
	    var ieContains = function (e1, e2) {
	      // IE only implements the contains() method for Element nodes.
	      // It fails for Text nodes, so implement it using compareDocumentPosition()
	      // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
	      // Note that compareDocumentPosition returns CONTAINED_BY if 'e2 *is_contained_by* e1':
	      // Also, compareDocumentPosition defines a node containing itself as false.
	      return Node.documentPositionContainedBy(e1.dom(), e2.dom());
	    };
	
	    var browser = PlatformDetection.detect().browser;
	
	    // Returns: true if node e1 contains e2, otherwise false.
	    // (returns false if e1===e2: A node does not contain itself).
	    var contains = browser.isIE() ? ieContains : regularContains;
	
	    return {
	      eq: eq,
	      isEqualNode: isEqualNode,
	      member: member,
	      contains: contains,
	
	      // Only used by DomUniverse. Remove (or should Selectors.is move here?)
	      is: Selectors.is
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.search.Traverse',
	
	  [
	    'ephox.katamari.api.Type',
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Struct',
	    'ephox.sugar.alien.Recurse',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element'
	  ],
	
	  function (Type, Arr, Fun, Option, Struct, Recurse, Compare, Element) {
	    // The document associated with the current element
	    var owner = function (element) {
	      return Element.fromDom(element.dom().ownerDocument);
	    };
	
	    var documentElement = function (element) {
	      // TODO: Avoid unnecessary wrap/unwrap here
	      var doc = owner(element);
	      return Element.fromDom(doc.dom().documentElement);
	    };
	
	    // The window element associated with the element
	    var defaultView = function (element) {
	      var el = element.dom();
	      var defaultView = el.ownerDocument.defaultView;
	      return Element.fromDom(defaultView);
	    };
	
	    var parent = function (element) {
	      var dom = element.dom();
	      return Option.from(dom.parentNode).map(Element.fromDom);
	    };
	
	    var findIndex = function (element) {
	      return parent(element).bind(function (p) {
	        // TODO: Refactor out children so we can avoid the constant unwrapping
	        var kin = children(p);
	        return Arr.findIndex(kin, function (elem) {
	          return Compare.eq(element, elem);
	        });
	      });
	    };
	
	    var parents = function (element, isRoot) {
	      var stop = Type.isFunction(isRoot) ? isRoot : Fun.constant(false);
	
	      // This is used a *lot* so it needs to be performant, not recursive
	      var dom = element.dom();
	      var ret = [];
	
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var parent = Element.fromDom(rawParent);
	        ret.push(parent);
	
	        if (stop(parent) === true) break;
	        else dom = rawParent;
	      }
	      return ret;
	    };
	
	    var siblings = function (element) {
	      // TODO: Refactor out children so we can just not add self instead of filtering afterwards
	      var filterSelf = function (elements) {
	        return Arr.filter(elements, function (x) {
	          return !Compare.eq(element, x);
	        });
	      };
	
	      return parent(element).map(children).map(filterSelf).getOr([]);
	    };
	
	    var offsetParent = function (element) {
	      var dom = element.dom();
	      return Option.from(dom.offsetParent).map(Element.fromDom);
	    };
	
	    var prevSibling = function (element) {
	      var dom = element.dom();
	      return Option.from(dom.previousSibling).map(Element.fromDom);
	    };
	
	    var nextSibling = function (element) {
	      var dom = element.dom();
	      return Option.from(dom.nextSibling).map(Element.fromDom);
	    };
	
	    var prevSiblings = function (element) {
	      // This one needs to be reversed, so they're still in DOM order
	      return Arr.reverse(Recurse.toArray(element, prevSibling));
	    };
	
	    var nextSiblings = function (element) {
	      return Recurse.toArray(element, nextSibling);
	    };
	
	    var children = function (element) {
	      var dom = element.dom();
	      return Arr.map(dom.childNodes, Element.fromDom);
	    };
	
	    var child = function (element, index) {
	      var children = element.dom().childNodes;
	      return Option.from(children[index]).map(Element.fromDom);
	    };
	
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	
	    var lastChild = function (element) {
	      return child(element, element.dom().childNodes.length - 1);
	    };
	
	    var childNodesCount = function (element) {
	      return element.dom().childNodes.length;
	    };
	
	    var hasChildNodes = function (element) {
	      return element.dom().hasChildNodes();
	    };
	
	    var spot = Struct.immutable('element', 'offset');
	    var leaf = function (element, offset) {
	      var cs = children(element);
	      return cs.length > 0 && offset < cs.length ? spot(cs[offset], 0) : spot(element, offset);
	    };
	
	    return {
	      owner: owner,
	      defaultView: defaultView,
	      documentElement: documentElement,
	      parent: parent,
	      findIndex: findIndex,
	      parents: parents,
	      siblings: siblings,
	      prevSibling: prevSibling,
	      offsetParent: offsetParent,
	      prevSiblings: prevSiblings,
	      nextSibling: nextSibling,
	      nextSiblings: nextSiblings,
	      children: children,
	      child: child,
	      firstChild: firstChild,
	      lastChild: lastChild,
	      childNodesCount: childNodesCount,
	      hasChildNodes: hasChildNodes,
	      leaf: leaf
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.search.PredicateFilter',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.node.Body',
	    'ephox.sugar.api.search.Traverse'
	  ],
	
	  function (Arr, Body, Traverse) {
	    // maybe TraverseWith, similar to traverse but with a predicate?
	
	    var all = function (predicate) {
	      return descendants(Body.body(), predicate);
	    };
	
	    var ancestors = function (scope, predicate, isRoot) {
	      return Arr.filter(Traverse.parents(scope, isRoot), predicate);
	    };
	
	    var siblings = function (scope, predicate) {
	      return Arr.filter(Traverse.siblings(scope), predicate);
	    };
	
	    var children = function (scope, predicate) {
	      return Arr.filter(Traverse.children(scope), predicate);
	    };
	
	    var descendants = function (scope, predicate) {
	      var result = [];
	
	      // Recurse.toArray() might help here
	      Arr.each(Traverse.children(scope), function (x) {
	        if (predicate(x)) {
	          result = result.concat([ x ]);
	        }
	        result = result.concat(descendants(x, predicate));
	      });
	      return result;
	    };
	
	    return {
	      all: all,
	      ancestors: ancestors,
	      siblings: siblings,
	      children: children,
	      descendants: descendants
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.search.SelectorFilter',
	
	  [
	    'ephox.sugar.api.search.PredicateFilter',
	    'ephox.sugar.api.search.Selectors'
	  ],
	
	  function (PredicateFilter, Selectors) {
	    var all = function (selector) {
	      return Selectors.all(selector);
	    };
	
	    // For all of the following:
	    //
	    // jQuery does siblings of firstChild. IE9+ supports scope.dom().children (similar to Traverse.children but elements only).
	    // Traverse should also do this (but probably not by default).
	    //
	
	    var ancestors = function (scope, selector, isRoot) {
	      // It may surprise you to learn this is exactly what JQuery does
	      // TODO: Avoid all this wrapping and unwrapping
	      return PredicateFilter.ancestors(scope, function (e) {
	        return Selectors.is(e, selector);
	      }, isRoot);
	    };
	
	    var siblings = function (scope, selector) {
	      // It may surprise you to learn this is exactly what JQuery does
	      // TODO: Avoid all the wrapping and unwrapping
	      return PredicateFilter.siblings(scope, function (e) {
	        return Selectors.is(e, selector);
	      });
	    };
	
	    var children = function (scope, selector) {
	      // It may surprise you to learn this is exactly what JQuery does
	      // TODO: Avoid all the wrapping and unwrapping
	      return PredicateFilter.children(scope, function (e) {
	        return Selectors.is(e, selector);
	      });
	    };
	
	    var descendants = function (scope, selector) {
	      return Selectors.all(selector, scope);
	    };
	
	    return {
	      all: all,
	      ancestors: ancestors,
	      siblings: siblings,
	      children: children,
	      descendants: descendants
	    };
	  }
	);
	
	/**
	 * LinkTargets.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module is enables you to get anything that you can link to in a element.
	 *
	 * @private
	 * @class tinymce.ui.LinkTargets
	 */
	define(
	  'tinymce.ui.content.LinkTargets',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Id',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.SelectorFilter',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.util.Tools'
	  ],
	  function (Arr, Fun, Id, Element, SelectorFilter, DOMUtils, Tools) {
	    var trim = Tools.trim;
	    var hasContentEditableState = function (value) {
	      return function (node) {
	        if (node && node.nodeType === 1) {
	          if (node.contentEditable === value) {
	            return true;
	          }
	
	          if (node.getAttribute('data-mce-contenteditable') === value) {
	            return true;
	          }
	        }
	
	        return false;
	      };
	    };
	
	    var isContentEditableTrue = hasContentEditableState('true');
	    var isContentEditableFalse = hasContentEditableState('false');
	
	    var create = function (type, title, url, level, attach) {
	      return {
	        type: type,
	        title: title,
	        url: url,
	        level: level,
	        attach: attach
	      };
	    };
	
	    var isChildOfContentEditableTrue = function (node) {
	      while ((node = node.parentNode)) {
	        var value = node.contentEditable;
	        if (value && value !== 'inherit') {
	          return isContentEditableTrue(node);
	        }
	      }
	
	      return false;
	    };
	
	    var select = function (selector, root) {
	      return Arr.map(SelectorFilter.descendants(Element.fromDom(root), selector), function (element) {
	        return element.dom();
	      });
	    };
	
	    var getElementText = function (elm) {
	      return elm.innerText || elm.textContent;
	    };
	
	    var getOrGenerateId = function (elm) {
	      return elm.id ? elm.id : Id.generate('h');
	    };
	
	    var isAnchor = function (elm) {
	      return elm && elm.nodeName === 'A' && (elm.id || elm.name);
	    };
	
	    var isValidAnchor = function (elm) {
	      return isAnchor(elm) && isEditable(elm);
	    };
	
	    var isHeader = function (elm) {
	      return elm && /^(H[1-6])$/.test(elm.nodeName);
	    };
	
	    var isEditable = function (elm) {
	      return isChildOfContentEditableTrue(elm) && !isContentEditableFalse(elm);
	    };
	
	    var isValidHeader = function (elm) {
	      return isHeader(elm) && isEditable(elm);
	    };
	
	    var getLevel = function (elm) {
	      return isHeader(elm) ? parseInt(elm.nodeName.substr(1), 10) : 0;
	    };
	
	    var headerTarget = function (elm) {
	      var headerId = getOrGenerateId(elm);
	
	      var attach = function () {
	        elm.id = headerId;
	      };
	
	      return create('header', getElementText(elm), '#' + headerId, getLevel(elm), attach);
	    };
	
	    var anchorTarget = function (elm) {
	      var anchorId = elm.id || elm.name;
	      var anchorText = getElementText(elm);
	
	      return create('anchor', anchorText ? anchorText : '#' + anchorId, '#' + anchorId, 0, Fun.noop);
	    };
	
	    var getHeaderTargets = function (elms) {
	      return Arr.map(Arr.filter(elms, isValidHeader), headerTarget);
	    };
	
	    var getAnchorTargets = function (elms) {
	      return Arr.map(Arr.filter(elms, isValidAnchor), anchorTarget);
	    };
	
	    var getTargetElements = function (elm) {
	      var elms = select('h1,h2,h3,h4,h5,h6,a:not([href])', elm);
	      return elms;
	    };
	
	    var hasTitle = function (target) {
	      return trim(target.title).length > 0;
	    };
	
	    var find = function (elm) {
	      var elms = getTargetElements(elm);
	      return Arr.filter(getHeaderTargets(elms).concat(getAnchorTargets(elms)), hasTitle);
	    };
	
	    return {
	      find: find
	    };
	  }
	);
	
	/**
	 * FilePicker.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a file picker control.
	 *
	 * @class tinymce.ui.FilePicker
	 * @extends tinymce.ui.ComboBox
	 */
	define(
	  'tinymce.ui.FilePicker',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'global!window',
	    'tinymce.ui.content.LinkTargets',
	    'tinymce.core.EditorManager',
	    'tinymce.ui.ComboBox',
	    'tinymce.core.util.Tools'
	  ],
	  function (Arr, Fun, window, LinkTargets, EditorManager, ComboBox, Tools) {
	    "use strict";
	
	    var getActiveEditor = function () {
	      return window.tinymce ? window.tinymce.activeEditor : EditorManager.activeEditor;
	    };
	
	    var history = {};
	    var HISTORY_LENGTH = 5;
	
	    var clearHistory = function () {
	      history = {};
	    };
	
	    var toMenuItem = function (target) {
	      return {
	        title: target.title,
	        value: {
	          title: { raw: target.title },
	          url: target.url,
	          attach: target.attach
	        }
	      };
	    };
	
	    var toMenuItems = function (targets) {
	      return Tools.map(targets, toMenuItem);
	    };
	
	    var staticMenuItem = function (title, url) {
	      return {
	        title: title,
	        value: {
	          title: title,
	          url: url,
	          attach: Fun.noop
	        }
	      };
	    };
	
	    var isUniqueUrl = function (url, targets) {
	      var foundTarget = Arr.exists(targets, function (target) {
	        return target.url === url;
	      });
	
	      return !foundTarget;
	    };
	
	    var getSetting = function (editorSettings, name, defaultValue) {
	      var value = name in editorSettings ? editorSettings[name] : defaultValue;
	      return value === false ? null : value;
	    };
	
	    var createMenuItems = function (term, targets, fileType, editorSettings) {
	      var separator = { title: '-' };
	
	      var fromHistoryMenuItems = function (history) {
	        var historyItems = history.hasOwnProperty(fileType) ? history[fileType] : [ ];
	        var uniqueHistory = Arr.filter(historyItems, function (url) {
	          return isUniqueUrl(url, targets);
	        });
	
	        return Tools.map(uniqueHistory, function (url) {
	          return {
	            title: url,
	            value: {
	              title: url,
	              url: url,
	              attach: Fun.noop
	            }
	          };
	        });
	      };
	
	      var fromMenuItems = function (type) {
	        var filteredTargets = Arr.filter(targets, function (target) {
	          return target.type === type;
	        });
	
	        return toMenuItems(filteredTargets);
	      };
	
	      var anchorMenuItems = function () {
	        var anchorMenuItems = fromMenuItems('anchor');
	        var topAnchor = getSetting(editorSettings, 'anchor_top', '#top');
	        var bottomAchor = getSetting(editorSettings, 'anchor_bottom', '#bottom');
	
	        if (topAnchor !== null) {
	          anchorMenuItems.unshift(staticMenuItem('<top>', topAnchor));
	        }
	
	        if (bottomAchor !== null) {
	          anchorMenuItems.push(staticMenuItem('<bottom>', bottomAchor));
	        }
	
	        return anchorMenuItems;
	      };
	
	      var join = function (items) {
	        return Arr.foldl(items, function (a, b) {
	          var bothEmpty = a.length === 0 || b.length === 0;
	          return bothEmpty ? a.concat(b) : a.concat(separator, b);
	        }, []);
	      };
	
	      if (editorSettings.typeahead_urls === false) {
	        return [];
	      }
	
	      return fileType === 'file' ? join([
	        filterByQuery(term, fromHistoryMenuItems(history)),
	        filterByQuery(term, fromMenuItems('header')),
	        filterByQuery(term, anchorMenuItems())
	      ]) : filterByQuery(term, fromHistoryMenuItems(history));
	    };
	
	    var addToHistory = function (url, fileType) {
	      var items = history[fileType];
	
	      if (!/^https?/.test(url)) {
	        return;
	      }
	
	      if (items) {
	        if (Arr.indexOf(items, url) === -1) {
	          history[fileType] = items.slice(0, HISTORY_LENGTH).concat(url);
	        }
	      } else {
	        history[fileType] = [url];
	      }
	    };
	
	    var filterByQuery = function (term, menuItems) {
	      var lowerCaseTerm = term.toLowerCase();
	      var result = Tools.grep(menuItems, function (item) {
	        return item.title.toLowerCase().indexOf(lowerCaseTerm) !== -1;
	      });
	
	      return result.length === 1 && result[0].title === term ? [] : result;
	    };
	
	    var getTitle = function (linkDetails) {
	      var title = linkDetails.title;
	      return title.raw ? title.raw : title;
	    };
	
	    var setupAutoCompleteHandler = function (ctrl, editorSettings, bodyElm, fileType) {
	      var autocomplete = function (term) {
	        var linkTargets = LinkTargets.find(bodyElm);
	        var menuItems = createMenuItems(term, linkTargets, fileType, editorSettings);
	        ctrl.showAutoComplete(menuItems, term);
	      };
	
	      ctrl.on('autocomplete', function () {
	        autocomplete(ctrl.value());
	      });
	
	      ctrl.on('selectitem', function (e) {
	        var linkDetails = e.value;
	
	        ctrl.value(linkDetails.url);
	        var title = getTitle(linkDetails);
	
	        if (fileType === 'image') {
	          ctrl.fire('change', { meta: { alt: title, attach: linkDetails.attach } });
	        } else {
	          ctrl.fire('change', { meta: { text: title, attach: linkDetails.attach } });
	        }
	
	        ctrl.focus();
	      });
	
	      ctrl.on('click', function (e) {
	        if (ctrl.value().length === 0 && e.target.nodeName === 'INPUT') {
	          autocomplete('');
	        }
	      });
	
	      ctrl.on('PostRender', function () {
	        ctrl.getRoot().on('submit', function (e) {
	          if (!e.isDefaultPrevented()) {
	            addToHistory(ctrl.value(), fileType);
	          }
	        });
	      });
	    };
	
	    var statusToUiState = function (result) {
	      var status = result.status, message = result.message;
	
	      if (status === 'valid') {
	        return { status: 'ok', message: message };
	      } else if (status === 'unknown') {
	        return { status: 'warn', message: message };
	      } else if (status === 'invalid') {
	        return { status: 'warn', message: message };
	      } else {
	        return { status: 'none', message: '' };
	      }
	    };
	
	    var setupLinkValidatorHandler = function (ctrl, editorSettings, fileType) {
	      var validatorHandler = editorSettings.filepicker_validator_handler;
	      if (validatorHandler) {
	        var validateUrl = function (url) {
	          if (url.length === 0) {
	            ctrl.statusLevel('none');
	            return;
	          }
	
	          validatorHandler({
	            url: url,
	            type: fileType
	          }, function (result) {
	            var uiState = statusToUiState(result);
	
	            ctrl.statusMessage(uiState.message);
	            ctrl.statusLevel(uiState.status);
	          });
	        };
	
	        ctrl.state.on('change:value', function (e) {
	          validateUrl(e.value);
	        });
	      }
	    };
	
	    return ComboBox.extend({
	      Statics: {
	        clearHistory: clearHistory
	      },
	
	      /**
	       * Constructs a new control instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       */
	      init: function (settings) {
	        var self = this, editor = getActiveEditor(), editorSettings = editor.settings;
	        var actionCallback, fileBrowserCallback, fileBrowserCallbackTypes;
	        var fileType = settings.filetype;
	
	        settings.spellcheck = false;
	
	        fileBrowserCallbackTypes = editorSettings.file_picker_types || editorSettings.file_browser_callback_types;
	        if (fileBrowserCallbackTypes) {
	          fileBrowserCallbackTypes = Tools.makeMap(fileBrowserCallbackTypes, /[, ]/);
	        }
	
	        if (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType]) {
	          fileBrowserCallback = editorSettings.file_picker_callback;
	          if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType])) {
	            actionCallback = function () {
	              var meta = self.fire('beforecall').meta;
	
	              meta = Tools.extend({ filetype: fileType }, meta);
	
	              // file_picker_callback(callback, currentValue, metaData)
	              fileBrowserCallback.call(
	                editor,
	                function (value, meta) {
	                  self.value(value).fire('change', { meta: meta });
	                },
	                self.value(),
	                meta
	              );
	            };
	          } else {
	            // Legacy callback: file_picker_callback(id, currentValue, filetype, window)
	            fileBrowserCallback = editorSettings.file_browser_callback;
	            if (fileBrowserCallback && (!fileBrowserCallbackTypes || fileBrowserCallbackTypes[fileType])) {
	              actionCallback = function () {
	                fileBrowserCallback(
	                  self.getEl('inp').id,
	                  self.value(),
	                  fileType,
	                  window
	                );
	              };
	            }
	          }
	        }
	
	        if (actionCallback) {
	          settings.icon = 'browse';
	          settings.onaction = actionCallback;
	        }
	
	        self._super(settings);
	
	        setupAutoCompleteHandler(self, editorSettings, editor.getBody(), fileType);
	        setupLinkValidatorHandler(self, editorSettings, fileType);
	      }
	    });
	  }
	);
	/**
	 * FitLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This layout manager will resize the control to be the size of it's parent container.
	 * In other words width: 100% and height: 100%.
	 *
	 * @-x-less FitLayout.less
	 * @class tinymce.ui.FitLayout
	 * @extends tinymce.ui.AbsoluteLayout
	 */
	define(
	  'tinymce.ui.FitLayout',
	  [
	    "tinymce.ui.AbsoluteLayout"
	  ],
	  function (AbsoluteLayout) {
	    "use strict";
	
	    return AbsoluteLayout.extend({
	      /**
	       * Recalculates the positions of the controls in the specified container.
	       *
	       * @method recalc
	       * @param {tinymce.ui.Container} container Container instance to recalc.
	       */
	      recalc: function (container) {
	        var contLayoutRect = container.layoutRect(), paddingBox = container.paddingBox;
	
	        container.items().filter(':visible').each(function (ctrl) {
	          ctrl.layoutRect({
	            x: paddingBox.left,
	            y: paddingBox.top,
	            w: contLayoutRect.innerW - paddingBox.right - paddingBox.left,
	            h: contLayoutRect.innerH - paddingBox.top - paddingBox.bottom
	          });
	
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	        });
	      }
	    });
	  }
	);
	/**
	 * FlexLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This layout manager works similar to the CSS flex box.
	 *
	 * @setting {String} direction row|row-reverse|column|column-reverse
	 * @setting {Number} flex A positive-number to flex by.
	 * @setting {String} align start|end|center|stretch
	 * @setting {String} pack start|end|justify
	 *
	 * @class tinymce.ui.FlexLayout
	 * @extends tinymce.ui.AbsoluteLayout
	 */
	define(
	  'tinymce.ui.FlexLayout',
	  [
	    "tinymce.ui.AbsoluteLayout"
	  ],
	  function (AbsoluteLayout) {
	    "use strict";
	
	    return AbsoluteLayout.extend({
	      /**
	       * Recalculates the positions of the controls in the specified container.
	       *
	       * @method recalc
	       * @param {tinymce.ui.Container} container Container instance to recalc.
	       */
	      recalc: function (container) {
	        // A ton of variables, needs to be in the same scope for performance
	        var i, l, items, contLayoutRect, contPaddingBox, contSettings, align, pack, spacing, totalFlex, availableSpace, direction;
	        var ctrl, ctrlLayoutRect, ctrlSettings, flex, maxSizeItems = [], size, maxSize, ratio, rect, pos, maxAlignEndPos;
	        var sizeName, minSizeName, posName, maxSizeName, beforeName, innerSizeName, deltaSizeName, contentSizeName;
	        var alignAxisName, alignInnerSizeName, alignSizeName, alignMinSizeName, alignBeforeName, alignAfterName;
	        var alignDeltaSizeName, alignContentSizeName;
	        var max = Math.max, min = Math.min;
	
	        // Get container items, properties and settings
	        items = container.items().filter(':visible');
	        contLayoutRect = container.layoutRect();
	        contPaddingBox = container.paddingBox;
	        contSettings = container.settings;
	        direction = container.isRtl() ? (contSettings.direction || 'row-reversed') : contSettings.direction;
	        align = contSettings.align;
	        pack = container.isRtl() ? (contSettings.pack || 'end') : contSettings.pack;
	        spacing = contSettings.spacing || 0;
	
	        if (direction == "row-reversed" || direction == "column-reverse") {
	          items = items.set(items.toArray().reverse());
	          direction = direction.split('-')[0];
	        }
	
	        // Setup axis variable name for row/column direction since the calculations is the same
	        if (direction == "column") {
	          posName = "y";
	          sizeName = "h";
	          minSizeName = "minH";
	          maxSizeName = "maxH";
	          innerSizeName = "innerH";
	          beforeName = 'top';
	          deltaSizeName = "deltaH";
	          contentSizeName = "contentH";
	
	          alignBeforeName = "left";
	          alignSizeName = "w";
	          alignAxisName = "x";
	          alignInnerSizeName = "innerW";
	          alignMinSizeName = "minW";
	          alignAfterName = "right";
	          alignDeltaSizeName = "deltaW";
	          alignContentSizeName = "contentW";
	        } else {
	          posName = "x";
	          sizeName = "w";
	          minSizeName = "minW";
	          maxSizeName = "maxW";
	          innerSizeName = "innerW";
	          beforeName = 'left';
	          deltaSizeName = "deltaW";
	          contentSizeName = "contentW";
	
	          alignBeforeName = "top";
	          alignSizeName = "h";
	          alignAxisName = "y";
	          alignInnerSizeName = "innerH";
	          alignMinSizeName = "minH";
	          alignAfterName = "bottom";
	          alignDeltaSizeName = "deltaH";
	          alignContentSizeName = "contentH";
	        }
	
	        // Figure out total flex, availableSpace and collect any max size elements
	        availableSpace = contLayoutRect[innerSizeName] - contPaddingBox[beforeName] - contPaddingBox[beforeName];
	        maxAlignEndPos = totalFlex = 0;
	        for (i = 0, l = items.length; i < l; i++) {
	          ctrl = items[i];
	          ctrlLayoutRect = ctrl.layoutRect();
	          ctrlSettings = ctrl.settings;
	          flex = ctrlSettings.flex;
	          availableSpace -= (i < l - 1 ? spacing : 0);
	
	          if (flex > 0) {
	            totalFlex += flex;
	
	            // Flexed item has a max size then we need to check if we will hit that size
	            if (ctrlLayoutRect[maxSizeName]) {
	              maxSizeItems.push(ctrl);
	            }
	
	            ctrlLayoutRect.flex = flex;
	          }
	
	          availableSpace -= ctrlLayoutRect[minSizeName];
	
	          // Calculate the align end position to be used to check for overflow/underflow
	          size = contPaddingBox[alignBeforeName] + ctrlLayoutRect[alignMinSizeName] + contPaddingBox[alignAfterName];
	          if (size > maxAlignEndPos) {
	            maxAlignEndPos = size;
	          }
	        }
	
	        // Calculate minW/minH
	        rect = {};
	        if (availableSpace < 0) {
	          rect[minSizeName] = contLayoutRect[minSizeName] - availableSpace + contLayoutRect[deltaSizeName];
	        } else {
	          rect[minSizeName] = contLayoutRect[innerSizeName] - availableSpace + contLayoutRect[deltaSizeName];
	        }
	
	        rect[alignMinSizeName] = maxAlignEndPos + contLayoutRect[alignDeltaSizeName];
	
	        rect[contentSizeName] = contLayoutRect[innerSizeName] - availableSpace;
	        rect[alignContentSizeName] = maxAlignEndPos;
	        rect.minW = min(rect.minW, contLayoutRect.maxW);
	        rect.minH = min(rect.minH, contLayoutRect.maxH);
	        rect.minW = max(rect.minW, contLayoutRect.startMinWidth);
	        rect.minH = max(rect.minH, contLayoutRect.startMinHeight);
	
	        // Resize container container if minSize was changed
	        if (contLayoutRect.autoResize && (rect.minW != contLayoutRect.minW || rect.minH != contLayoutRect.minH)) {
	          rect.w = rect.minW;
	          rect.h = rect.minH;
	
	          container.layoutRect(rect);
	          this.recalc(container);
	
	          // Forced recalc for example if items are hidden/shown
	          if (container._lastRect === null) {
	            var parentCtrl = container.parent();
	            if (parentCtrl) {
	              parentCtrl._lastRect = null;
	              parentCtrl.recalc();
	            }
	          }
	
	          return;
	        }
	
	        // Handle max size elements, check if they will become to wide with current options
	        ratio = availableSpace / totalFlex;
	        for (i = 0, l = maxSizeItems.length; i < l; i++) {
	          ctrl = maxSizeItems[i];
	          ctrlLayoutRect = ctrl.layoutRect();
	          maxSize = ctrlLayoutRect[maxSizeName];
	          size = ctrlLayoutRect[minSizeName] + ctrlLayoutRect.flex * ratio;
	
	          if (size > maxSize) {
	            availableSpace -= (ctrlLayoutRect[maxSizeName] - ctrlLayoutRect[minSizeName]);
	            totalFlex -= ctrlLayoutRect.flex;
	            ctrlLayoutRect.flex = 0;
	            ctrlLayoutRect.maxFlexSize = maxSize;
	          } else {
	            ctrlLayoutRect.maxFlexSize = 0;
	          }
	        }
	
	        // Setup new ratio, target layout rect, start position
	        ratio = availableSpace / totalFlex;
	        pos = contPaddingBox[beforeName];
	        rect = {};
	
	        // Handle pack setting moves the start position to end, center
	        if (totalFlex === 0) {
	          if (pack == "end") {
	            pos = availableSpace + contPaddingBox[beforeName];
	          } else if (pack == "center") {
	            pos = Math.round(
	              (contLayoutRect[innerSizeName] / 2) - ((contLayoutRect[innerSizeName] - availableSpace) / 2)
	            ) + contPaddingBox[beforeName];
	
	            if (pos < 0) {
	              pos = contPaddingBox[beforeName];
	            }
	          } else if (pack == "justify") {
	            pos = contPaddingBox[beforeName];
	            spacing = Math.floor(availableSpace / (items.length - 1));
	          }
	        }
	
	        // Default aligning (start) the other ones needs to be calculated while doing the layout
	        rect[alignAxisName] = contPaddingBox[alignBeforeName];
	
	        // Start laying out controls
	        for (i = 0, l = items.length; i < l; i++) {
	          ctrl = items[i];
	          ctrlLayoutRect = ctrl.layoutRect();
	          size = ctrlLayoutRect.maxFlexSize || ctrlLayoutRect[minSizeName];
	
	          // Align the control on the other axis
	          if (align === "center") {
	            rect[alignAxisName] = Math.round((contLayoutRect[alignInnerSizeName] / 2) - (ctrlLayoutRect[alignSizeName] / 2));
	          } else if (align === "stretch") {
	            rect[alignSizeName] = max(
	              ctrlLayoutRect[alignMinSizeName] || 0,
	              contLayoutRect[alignInnerSizeName] - contPaddingBox[alignBeforeName] - contPaddingBox[alignAfterName]
	            );
	            rect[alignAxisName] = contPaddingBox[alignBeforeName];
	          } else if (align === "end") {
	            rect[alignAxisName] = contLayoutRect[alignInnerSizeName] - ctrlLayoutRect[alignSizeName] - contPaddingBox.top;
	          }
	
	          // Calculate new size based on flex
	          if (ctrlLayoutRect.flex > 0) {
	            size += ctrlLayoutRect.flex * ratio;
	          }
	
	          rect[sizeName] = size;
	          rect[posName] = pos;
	          ctrl.layoutRect(rect);
	
	          // Recalculate containers
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	
	          // Move x/y position
	          pos += size + spacing;
	        }
	      }
	    });
	  }
	);
	/**
	 * FlowLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This layout manager will place the controls by using the browsers native layout.
	 *
	 * @-x-less FlowLayout.less
	 * @class tinymce.ui.FlowLayout
	 * @extends tinymce.ui.Layout
	 */
	define(
	  'tinymce.ui.FlowLayout',
	  [
	    "tinymce.ui.Layout"
	  ],
	  function (Layout) {
	    return Layout.extend({
	      Defaults: {
	        containerClass: 'flow-layout',
	        controlClass: 'flow-layout-item',
	        endClass: 'break'
	      },
	
	      /**
	       * Recalculates the positions of the controls in the specified container.
	       *
	       * @method recalc
	       * @param {tinymce.ui.Container} container Container instance to recalc.
	       */
	      recalc: function (container) {
	        container.items().filter(':visible').each(function (ctrl) {
	          if (ctrl.recalc) {
	            ctrl.recalc();
	          }
	        });
	      },
	
	      isNative: function () {
	        return true;
	      }
	    });
	  }
	);
	define(
	  'ephox.sugar.impl.ClosestOrAncestor',
	
	  [
	    'ephox.katamari.api.Type',
	    'ephox.katamari.api.Option'
	  ],
	
	  function (Type, Option) {
	    return function (is, ancestor, scope, a, isRoot) {
	      return is(scope, a) ?
	              Option.some(scope) :
	              Type.isFunction(isRoot) && isRoot(scope) ?
	                  Option.none() :
	                  ancestor(scope, a, isRoot);
	    };
	  }
	);
	define(
	  'ephox.sugar.api.search.PredicateFind',
	
	  [
	    'ephox.katamari.api.Type',
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.node.Body',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.impl.ClosestOrAncestor'
	  ],
	
	  function (Type, Arr, Fun, Option, Body, Compare, Element, ClosestOrAncestor) {
	    var first = function (predicate) {
	      return descendant(Body.body(), predicate);
	    };
	
	    var ancestor = function (scope, predicate, isRoot) {
	      var element = scope.dom();
	      var stop = Type.isFunction(isRoot) ? isRoot : Fun.constant(false);
	
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = Element.fromDom(element);
	
	        if (predicate(el)) return Option.some(el);
	        else if (stop(el)) break;
	      }
	      return Option.none();
	    };
	
	    var closest = function (scope, predicate, isRoot) {
	      // This is required to avoid ClosestOrAncestor passing the predicate to itself
	      var is = function (scope) {
	        return predicate(scope);
	      };
	      return ClosestOrAncestor(is, ancestor, scope, predicate, isRoot);
	    };
	
	    var sibling = function (scope, predicate) {
	      var element = scope.dom();
	      if (!element.parentNode) return Option.none();
	
	      return child(Element.fromDom(element.parentNode), function (x) {
	        return !Compare.eq(scope, x) && predicate(x);
	      });
	    };
	
	    var child = function (scope, predicate) {
	      var result = Arr.find(scope.dom().childNodes,
	        Fun.compose(predicate, Element.fromDom));
	      return result.map(Element.fromDom);
	    };
	
	    var descendant = function (scope, predicate) {
	      var descend = function (element) {
	        for (var i = 0; i < element.childNodes.length; i++) {
	          if (predicate(Element.fromDom(element.childNodes[i])))
	            return Option.some(Element.fromDom(element.childNodes[i]));
	
	          var res = descend(element.childNodes[i]);
	          if (res.isSome())
	            return res;
	        }
	
	        return Option.none();
	      };
	
	      return descend(scope.dom());
	    };
	
	    return {
	      first: first,
	      ancestor: ancestor,
	      closest: closest,
	      sibling: sibling,
	      child: child,
	      descendant: descendant
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.search.SelectorFind',
	
	  [
	    'ephox.sugar.api.search.PredicateFind',
	    'ephox.sugar.api.search.Selectors',
	    'ephox.sugar.impl.ClosestOrAncestor'
	  ],
	
	  function (PredicateFind, Selectors, ClosestOrAncestor) {
	    // TODO: An internal SelectorFilter module that doesn't Element.fromDom() everything
	
	    var first = function (selector) {
	      return Selectors.one(selector);
	    };
	
	    var ancestor = function (scope, selector, isRoot) {
	      return PredicateFind.ancestor(scope, function (e) {
	        return Selectors.is(e, selector);
	      }, isRoot);
	    };
	
	    var sibling = function (scope, selector) {
	      return PredicateFind.sibling(scope, function (e) {
	        return Selectors.is(e, selector);
	      });
	    };
	
	    var child = function (scope, selector) {
	      return PredicateFind.child(scope, function (e) {
	        return Selectors.is(e, selector);
	      });
	    };
	
	    var descendant = function (scope, selector) {
	      return Selectors.one(selector, scope);
	    };
	
	    // Returns Some(closest ancestor element (sugared)) matching 'selector' up to isRoot, or None() otherwise
	    var closest = function (scope, selector, isRoot) {
	      return ClosestOrAncestor(Selectors.is, ancestor, scope, selector, isRoot);
	    };
	
	    return {
	      first: first,
	      ancestor: ancestor,
	      sibling: sibling,
	      child: child,
	      descendant: descendant,
	      closest: closest
	    };
	  }
	);
	
	/**
	 * FormatUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.editorui.FormatUtils',
	  [
	  ],
	  function () {
	    var toggleFormat = function (editor, fmt) {
	      return function () {
	        editor.execCommand('mceToggleFormat', false, fmt);
	      };
	    };
	
	    var postRenderFormat = function (editor, name) {
	      return function () {
	        var self = this;
	
	        // TODO: Fix this
	        if (editor.formatter) {
	          editor.formatter.formatChanged(name, function (state) {
	            self.active(state);
	          });
	        } else {
	          editor.on('init', function () {
	            editor.formatter.formatChanged(name, function (state) {
	              self.active(state);
	            });
	          });
	        }
	      };
	    };
	
	    return {
	      toggleFormat: toggleFormat,
	      postRenderFormat: postRenderFormat
	    };
	  }
	);
	
	/**
	 * Align.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.editorui.Align',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.ui.editorui.FormatUtils'
	  ],
	  function (Tools, FormatUtils) {
	    var register = function (editor) {
	      editor.addMenuItem('align', {
	        text: 'Align',
	        menu: [
	          { text: 'Left', icon: 'alignleft', onclick: FormatUtils.toggleFormat(editor, 'alignleft') },
	          { text: 'Center', icon: 'aligncenter', onclick: FormatUtils.toggleFormat(editor, 'aligncenter') },
	          { text: 'Right', icon: 'alignright', onclick: FormatUtils.toggleFormat(editor, 'alignright') },
	          { text: 'Justify', icon: 'alignjustify', onclick: FormatUtils.toggleFormat(editor, 'alignjustify') }
	        ]
	      });
	
	      Tools.each({
	        alignleft: ['Align left', 'JustifyLeft'],
	        aligncenter: ['Align center', 'JustifyCenter'],
	        alignright: ['Align right', 'JustifyRight'],
	        alignjustify: ['Justify', 'JustifyFull'],
	        alignnone: ['No alignment', 'JustifyNone']
	      }, function (item, name) {
	        editor.addButton(name, {
	          active: false,
	          tooltip: item[0],
	          cmd: item[1],
	          onPostRender: FormatUtils.postRenderFormat(editor, name)
	        });
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	/**
	 * FontInfo.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Internal class for computing font size for elements.
	 *
	 * @private
	 * @class tinymce.fmt.FontInfo
	 */
	define(
	  'tinymce.ui.fmt.FontInfo',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'tinymce.core.dom.DOMUtils'
	  ],
	  function (Fun, Option, Element, Node, DOMUtils) {
	    var getSpecifiedFontProp = function (propName, rootElm, elm) {
	      while (elm !== rootElm) {
	        if (elm.style[propName]) {
	          var foundStyle = elm.style[propName];
	          return foundStyle !== '' ? Option.some(foundStyle) : Option.none();
	        }
	        elm = elm.parentNode;
	      }
	      return Option.none();
	    };
	
	    var round = function (number, precision) {
	      var factor = Math.pow(10, precision);
	      return Math.round(number * factor) / factor;
	    };
	
	    var toPt = function (fontSize, precision) {
	      if (/[0-9.]+px$/.test(fontSize)) {
	        // Round to the nearest 0.5
	        return round(parseInt(fontSize, 10) * 72 / 96, precision || 0) + 'pt';
	      }
	      return fontSize;
	    };
	
	    var normalizeFontFamily = function (fontFamily) {
	      // 'Font name', Font -> Font name,Font
	      return fontFamily.replace(/[\'\"]/g, '').replace(/,\s+/g, ',');
	    };
	
	    var getComputedFontProp = function (propName, elm) {
	      return Option.from(DOMUtils.DOM.getStyle(elm, propName, true));
	    };
	
	    var getFontProp = function (propName) {
	      return function (rootElm, elm) {
	        return Option.from(elm)
	          .map(Element.fromDom)
	          .filter(Node.isElement)
	          .bind(function (element) {
	            return getSpecifiedFontProp(propName, rootElm, element.dom())
	              .or(getComputedFontProp(propName, element.dom()));
	          })
	          .getOr('');
	      };
	    };
	
	    return {
	      getFontSize: getFontProp('fontSize'),
	      getFontFamily: Fun.compose(normalizeFontFamily, getFontProp('fontFamily')),
	      toPt: toPt
	    };
	  }
	);
	
	/**
	 * FontSelect.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.editorui.FontSelect',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.ui.fmt.FontInfo'
	  ],
	  function (Tools, FontInfo) {
	    var getFirstFont = function (fontFamily) {
	      return fontFamily ? fontFamily.split(',')[0] : '';
	    };
	
	    var findMatchingValue = function (items, fontFamily) {
	      var value;
	
	      Tools.each(items, function (item) {
	        if (item.value.toLowerCase() === fontFamily.toLowerCase()) {
	          value = item.value;
	        }
	      });
	
	      Tools.each(items, function (item) {
	        if (!value && getFirstFont(item.value).toLowerCase() === getFirstFont(fontFamily).toLowerCase()) {
	          value = item.value;
	        }
	      });
	
	      return value;
	    };
	
	    var createFontNameListBoxChangeHandler = function (editor, items) {
	      return function () {
	        var self = this;
	
	        editor.on('init nodeChange', function (e) {
	          var fontFamily = FontInfo.getFontFamily(editor.getBody(), e.element);
	          var match = findMatchingValue(items, fontFamily);
	
	          self.value(match ? match : null);
	
	          if (!match && fontFamily) {
	            self.text(getFirstFont(fontFamily));
	          }
	        });
	      };
	    };
	
	    var createFormats = function (formats) {
	      formats = formats.replace(/;$/, '').split(';');
	
	      var i = formats.length;
	      while (i--) {
	        formats[i] = formats[i].split('=');
	      }
	
	      return formats;
	    };
	
	    var getFontItems = function (editor) {
	      var defaultFontsFormats = (
	        'Andale Mono=andale mono,monospace;' +
	        'Arial=arial,helvetica,sans-serif;' +
	        'Arial Black=arial black,sans-serif;' +
	        'Book Antiqua=book antiqua,palatino,serif;' +
	        'Comic Sans MS=comic sans ms,sans-serif;' +
	        'Courier New=courier new,courier,monospace;' +
	        'Georgia=georgia,palatino,serif;' +
	        'Helvetica=helvetica,arial,sans-serif;' +
	        'Impact=impact,sans-serif;' +
	        'Symbol=symbol;' +
	        'Tahoma=tahoma,arial,helvetica,sans-serif;' +
	        'Terminal=terminal,monaco,monospace;' +
	        'Times New Roman=times new roman,times,serif;' +
	        'Trebuchet MS=trebuchet ms,geneva,sans-serif;' +
	        'Verdana=verdana,geneva,sans-serif;' +
	        'Webdings=webdings;' +
	        'Wingdings=wingdings,zapf dingbats'
	      );
	
	      var fonts = createFormats(editor.settings.font_formats || defaultFontsFormats);
	
	      return Tools.map(fonts, function (font) {
	        return {
	          text: { raw: font[0] },
	          value: font[1],
	          textStyle: font[1].indexOf('dings') === -1 ? 'font-family:' + font[1] : ''
	        };
	      });
	    };
	
	    var registerButtons = function (editor) {
	      editor.addButton('fontselect', function () {
	        var items = getFontItems(editor);
	
	        return {
	          type: 'listbox',
	          text: 'Font Family',
	          tooltip: 'Font Family',
	          values: items,
	          fixedWidth: true,
	          onPostRender: createFontNameListBoxChangeHandler(editor, items),
	          onselect: function (e) {
	            if (e.control.settings.value) {
	              editor.execCommand('FontName', false, e.control.settings.value);
	            }
	          }
	        };
	      });
	    };
	
	    var register = function (editor) {
	      registerButtons(editor);
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	/**
	 * FontSizeSelect.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.editorui.FontSizeSelect',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.ui.fmt.FontInfo'
	  ],
	  function (Tools, FontInfo) {
	    var findMatchingValue = function (items, pt, px) {
	      var value;
	
	      Tools.each(items, function (item) {
	        if (item.value === px) {
	          value = px;
	        } else if (item.value === pt) {
	          value = pt;
	        }
	      });
	
	      return value;
	    };
	
	    var createFontSizeListBoxChangeHandler = function (editor, items) {
	      return function () {
	        var self = this;
	
	        editor.on('init nodeChange', function (e) {
	          var px, pt, precision, match;
	
	          px = FontInfo.getFontSize(editor.getBody(), e.element);
	          if (px) {
	            // checking for three digits after decimal point, should be precise enough
	            for (precision = 3; !match && precision >= 0; precision--) {
	              pt = FontInfo.toPt(px, precision);
	              match = findMatchingValue(items, pt, px);
	            }
	          }
	
	          self.value(match ? match : null);
	
	          if (!match) {
	            self.text(pt);
	          }
	        });
	      };
	    };
	
	    var getFontSizeItems = function (editor) {
	      var defaultFontsizeFormats = '8pt 10pt 12pt 14pt 18pt 24pt 36pt';
	      var fontsizeFormats = editor.settings.fontsize_formats || defaultFontsizeFormats;
	
	      return Tools.map(fontsizeFormats.split(' '), function (item) {
	        var text = item, value = item;
	        // Allow text=value font sizes.
	        var values = item.split('=');
	        if (values.length > 1) {
	          text = values[0];
	          value = values[1];
	        }
	
	        return { text: text, value: value };
	      });
	    };
	
	    var registerButtons = function (editor) {
	      editor.addButton('fontsizeselect', function () {
	        var items = getFontSizeItems(editor);
	
	        return {
	          type: 'listbox',
	          text: 'Font Sizes',
	          tooltip: 'Font Sizes',
	          values: items,
	          fixedWidth: true,
	          onPostRender: createFontSizeListBoxChangeHandler(editor, items),
	          onclick: function (e) {
	            if (e.control.settings.value) {
	              editor.execCommand('FontSize', false, e.control.settings.value);
	            }
	          }
	        };
	      });
	    };
	
	    var register = function (editor) {
	      registerButtons(editor);
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	/**
	 * FormatSelect.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.editorui.FormatSelect',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.ui.editorui.FormatUtils'
	  ],
	  function (Tools, FormatUtils) {
	    var defaultBlocks = (
	      'Paragraph=p;' +
	      'Heading 1=h1;' +
	      'Heading 2=h2;' +
	      'Heading 3=h3;' +
	      'Heading 4=h4;' +
	      'Heading 5=h5;' +
	      'Heading 6=h6;' +
	      'Preformatted=pre'
	    );
	
	    var createFormats = function (formats) {
	      formats = formats.replace(/;$/, '').split(';');
	
	      var i = formats.length;
	      while (i--) {
	        formats[i] = formats[i].split('=');
	      }
	
	      return formats;
	    };
	
	    var createListBoxChangeHandler = function (editor, items, formatName) {
	      return function () {
	        var self = this;
	
	        editor.on('nodeChange', function (e) {
	          var formatter = editor.formatter;
	          var value = null;
	
	          Tools.each(e.parents, function (node) {
	            Tools.each(items, function (item) {
	              if (formatName) {
	                if (formatter.matchNode(node, formatName, { value: item.value })) {
	                  value = item.value;
	                }
	              } else {
	                if (formatter.matchNode(node, item.value)) {
	                  value = item.value;
	                }
	              }
	
	              if (value) {
	                return false;
	              }
	            });
	
	            if (value) {
	              return false;
	            }
	          });
	
	          self.value(value);
	        });
	      };
	    };
	
	    var lazyFormatSelectBoxItems = function (editor, blocks) {
	      return function () {
	        var items = [];
	
	        Tools.each(blocks, function (block) {
	          items.push({
	            text: block[0],
	            value: block[1],
	            textStyle: function () {
	              return editor.formatter.getCssText(block[1]);
	            }
	          });
	        });
	
	        return {
	          type: 'listbox',
	          text: blocks[0][0],
	          values: items,
	          fixedWidth: true,
	          onselect: function (e) {
	            if (e.control) {
	              var fmt = e.control.value();
	              FormatUtils.toggleFormat(editor, fmt)();
	            }
	          },
	          onPostRender: createListBoxChangeHandler(editor, items)
	        };
	      };
	    };
	
	    var buildMenuItems = function (editor, blocks) {
	      return Tools.map(blocks, function (block) {
	        return {
	          text: block[0],
	          onclick: FormatUtils.toggleFormat(editor, block[1]),
	          textStyle: function () {
	            return editor.formatter.getCssText(block[1]);
	          }
	        };
	      });
	    };
	
	    var register = function (editor) {
	      var blocks = createFormats(editor.settings.block_formats || defaultBlocks);
	
	      editor.addMenuItem('blockformats', {
	        text: 'Blocks',
	        menu: buildMenuItems(editor, blocks)
	      });
	
	      editor.addButton('formatselect', lazyFormatSelectBoxItems(editor, blocks));
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	
	/**
	 * Formats.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.editorui.Formats',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.ui.editorui.FormatUtils'
	  ],
	  function (Tools, FormatUtils) {
	    var hideMenuObjects = function (editor, menu) {
	      var count = menu.length;
	
	      Tools.each(menu, function (item) {
	        if (item.menu) {
	          item.hidden = hideMenuObjects(editor, item.menu) === 0;
	        }
	
	        var formatName = item.format;
	        if (formatName) {
	          item.hidden = !editor.formatter.canApply(formatName);
	        }
	
	        if (item.hidden) {
	          count--;
	        }
	      });
	
	      return count;
	    };
	
	    var hideFormatMenuItems = function (editor, menu) {
	      var count = menu.items().length;
	
	      menu.items().each(function (item) {
	        if (item.menu) {
	          item.visible(hideFormatMenuItems(editor, item.menu) > 0);
	        }
	
	        if (!item.menu && item.settings.menu) {
	          item.visible(hideMenuObjects(editor, item.settings.menu) > 0);
	        }
	
	        var formatName = item.settings.format;
	        if (formatName) {
	          item.visible(editor.formatter.canApply(formatName));
	        }
	
	        if (!item.visible()) {
	          count--;
	        }
	      });
	
	      return count;
	    };
	
	    var createFormatMenu = function (editor) {
	      var count = 0, newFormats = [];
	
	      var defaultStyleFormats = [
	        {
	          title: 'Headings', items: [
	            { title: 'Heading 1', format: 'h1' },
	            { title: 'Heading 2', format: 'h2' },
	            { title: 'Heading 3', format: 'h3' },
	            { title: 'Heading 4', format: 'h4' },
	            { title: 'Heading 5', format: 'h5' },
	            { title: 'Heading 6', format: 'h6' }
	          ]
	        },
	
	        {
	          title: 'Inline', items: [
	            { title: 'Bold', icon: 'bold', format: 'bold' },
	            { title: 'Italic', icon: 'italic', format: 'italic' },
	            { title: 'Underline', icon: 'underline', format: 'underline' },
	            { title: 'Strikethrough', icon: 'strikethrough', format: 'strikethrough' },
	            { title: 'Superscript', icon: 'superscript', format: 'superscript' },
	            { title: 'Subscript', icon: 'subscript', format: 'subscript' },
	            { title: 'Code', icon: 'code', format: 'code' }
	          ]
	        },
	
	        {
	          title: 'Blocks', items: [
	            { title: 'Paragraph', format: 'p' },
	            { title: 'Blockquote', format: 'blockquote' },
	            { title: 'Div', format: 'div' },
	            { title: 'Pre', format: 'pre' }
	          ]
	        },
	
	        {
	          title: 'Alignment', items: [
	            { title: 'Left', icon: 'alignleft', format: 'alignleft' },
	            { title: 'Center', icon: 'aligncenter', format: 'aligncenter' },
	            { title: 'Right', icon: 'alignright', format: 'alignright' },
	            { title: 'Justify', icon: 'alignjustify', format: 'alignjustify' }
	          ]
	        }
	      ];
	
	      var createMenu = function (formats) {
	        var menu = [];
	
	        if (!formats) {
	          return;
	        }
	
	        Tools.each(formats, function (format) {
	          var menuItem = {
	            text: format.title,
	            icon: format.icon
	          };
	
	          if (format.items) {
	            menuItem.menu = createMenu(format.items);
	          } else {
	            var formatName = format.format || "custom" + count++;
	
	            if (!format.format) {
	              format.name = formatName;
	              newFormats.push(format);
	            }
	
	            menuItem.format = formatName;
	            menuItem.cmd = format.cmd;
	          }
	
	          menu.push(menuItem);
	        });
	
	        return menu;
	      };
	
	      var createStylesMenu = function () {
	        var menu;
	
	        if (editor.settings.style_formats_merge) {
	          if (editor.settings.style_formats) {
	            menu = createMenu(defaultStyleFormats.concat(editor.settings.style_formats));
	          } else {
	            menu = createMenu(defaultStyleFormats);
	          }
	        } else {
	          menu = createMenu(editor.settings.style_formats || defaultStyleFormats);
	        }
	
	        return menu;
	      };
	
	      editor.on('init', function () {
	        Tools.each(newFormats, function (format) {
	          editor.formatter.register(format.name, format);
	        });
	      });
	
	      return {
	        type: 'menu',
	        items: createStylesMenu(),
	        onPostRender: function (e) {
	          editor.fire('renderFormatsMenu', { control: e.control });
	        },
	        itemDefaults: {
	          preview: true,
	
	          textStyle: function () {
	            if (this.settings.format) {
	              return editor.formatter.getCssText(this.settings.format);
	            }
	          },
	
	          onPostRender: function () {
	            var self = this;
	
	            self.parent().on('show', function () {
	              var formatName, command;
	
	              formatName = self.settings.format;
	              if (formatName) {
	                self.disabled(!editor.formatter.canApply(formatName));
	                self.active(editor.formatter.match(formatName));
	              }
	
	              command = self.settings.cmd;
	              if (command) {
	                self.active(editor.queryCommandState(command));
	              }
	            });
	          },
	
	          onclick: function () {
	            if (this.settings.format) {
	              FormatUtils.toggleFormat(editor, this.settings.format)();
	            }
	
	            if (this.settings.cmd) {
	              editor.execCommand(this.settings.cmd);
	            }
	          }
	        }
	      };
	    };
	
	    var registerMenuItems = function (editor, formatMenu) {
	      editor.addMenuItem('formats', {
	        text: 'Formats',
	        menu: formatMenu
	      });
	    };
	
	    var registerButtons = function (editor, formatMenu) {
	      editor.addButton('styleselect', {
	        type: 'menubutton',
	        text: 'Formats',
	        menu: formatMenu,
	        onShowMenu: function () {
	          if (editor.settings.style_formats_autohide) {
	            hideFormatMenuItems(editor, this.menu);
	          }
	        }
	      });
	    };
	
	    var register = function (editor) {
	      var formatMenu = createFormatMenu(editor);
	
	      registerMenuItems(editor, formatMenu);
	      registerButtons(editor, formatMenu);
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	/**
	 * InsertButton.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.editorui.InsertButton',
	  [
	    'ephox.katamari.api.Arr',
	    'tinymce.core.util.Tools'
	  ],
	  function (Arr, Tools) {
	    var createCustomMenuItems = function (editor, names) {
	      var items, nameList;
	
	      if (typeof names === 'string') {
	        nameList = names.split(' ');
	      } else if (Tools.isArray(names)) {
	        return Arr.flatten(Tools.map(names, function (names) {
	          return createCustomMenuItems(editor, names);
	        }));
	      }
	
	      items = Tools.grep(nameList, function (name) {
	        return name === '|' || name in editor.menuItems;
	      });
	
	      return Tools.map(items, function (name) {
	        return name === '|' ? { text: '-' } : editor.menuItems[name];
	      });
	    };
	
	    var isSeparator = function (menuItem) {
	      return menuItem && menuItem.text === '-';
	    };
	
	    var trimMenuItems = function (menuItems) {
	      var menuItems2 = Arr.filter(menuItems, function (menuItem, i, menuItems) {
	        return !isSeparator(menuItem) || !isSeparator(menuItems[i - 1]);
	      });
	
	      return Arr.filter(menuItems2, function (menuItem, i, menuItems) {
	        return !isSeparator(menuItem) || i > 0 && i < menuItems.length - 1;
	      });
	    };
	
	    var createContextMenuItems = function (editor, context) {
	      var outputMenuItems = [{ text: '-' }];
	      var menuItems = Tools.grep(editor.menuItems, function (menuItem) {
	        return menuItem.context === context;
	      });
	
	      Tools.each(menuItems, function (menuItem) {
	        if (menuItem.separator === 'before') {
	          outputMenuItems.push({ text: '|' });
	        }
	
	        if (menuItem.prependToContext) {
	          outputMenuItems.unshift(menuItem);
	        } else {
	          outputMenuItems.push(menuItem);
	        }
	
	        if (menuItem.separator === 'after') {
	          outputMenuItems.push({ text: '|' });
	        }
	      });
	
	      return outputMenuItems;
	    };
	
	    var createInsertMenu = function (editor) {
	      var insertButtonItems = editor.settings.insert_button_items;
	
	      if (insertButtonItems) {
	        return trimMenuItems(createCustomMenuItems(editor, insertButtonItems));
	      } else {
	        return trimMenuItems(createContextMenuItems(editor, 'insert'));
	      }
	    };
	
	    var registerButtons = function (editor) {
	      editor.addButton('insert', {
	        type: 'menubutton',
	        icon: 'insert',
	        menu: [],
	        oncreatemenu: function () {
	          this.menu.add(createInsertMenu(editor));
	          this.menu.renderNew();
	        }
	      });
	    };
	
	    var register = function (editor) {
	      registerButtons(editor);
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	/**
	 * SimpleControls.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.editorui.SimpleControls',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.ui.editorui.FormatUtils'
	  ],
	  function (Tools, FormatUtils) {
	    var registerFormatButtons = function (editor) {
	      Tools.each({
	        bold: 'Bold',
	        italic: 'Italic',
	        underline: 'Underline',
	        strikethrough: 'Strikethrough',
	        subscript: 'Subscript',
	        superscript: 'Superscript'
	      }, function (text, name) {
	        editor.addButton(name, {
	          active: false,
	          tooltip: text,
	          onPostRender: FormatUtils.postRenderFormat(editor, name),
	          onclick: FormatUtils.toggleFormat(editor, name)
	        });
	      });
	    };
	
	    var registerCommandButtons = function (editor) {
	      Tools.each({
	        outdent: ['Decrease indent', 'Outdent'],
	        indent: ['Increase indent', 'Indent'],
	        cut: ['Cut', 'Cut'],
	        copy: ['Copy', 'Copy'],
	        paste: ['Paste', 'Paste'],
	        help: ['Help', 'mceHelp'],
	        selectall: ['Select all', 'SelectAll'],
	        visualaid: ['Visual aids', 'mceToggleVisualAid'],
	        newdocument: ['New document', 'mceNewDocument'],
	        removeformat: ['Clear formatting', 'RemoveFormat'],
	        remove: ['Remove', 'Delete']
	      }, function (item, name) {
	        editor.addButton(name, {
	          tooltip: item[0],
	          cmd: item[1]
	        });
	      });
	    };
	
	    var registerCommandToggleButtons = function (editor) {
	      Tools.each({
	        blockquote: ['Blockquote', 'mceBlockQuote'],
	        subscript: ['Subscript', 'Subscript'],
	        superscript: ['Superscript', 'Superscript']
	      }, function (item, name) {
	        editor.addButton(name, {
	          active: false,
	          tooltip: item[0],
	          cmd: item[1],
	          onPostRender: FormatUtils.postRenderFormat(editor, name)
	        });
	      });
	    };
	
	    var registerButtons = function (editor) {
	      registerFormatButtons(editor);
	      registerCommandButtons(editor);
	      registerCommandToggleButtons(editor);
	    };
	
	    var registerMenuItems = function (editor) {
	      Tools.each({
	        bold: ['Bold', 'Bold', 'Meta+B'],
	        italic: ['Italic', 'Italic', 'Meta+I'],
	        underline: ['Underline', 'Underline', 'Meta+U'],
	        strikethrough: ['Strikethrough', 'Strikethrough'],
	        subscript: ['Subscript', 'Subscript'],
	        superscript: ['Superscript', 'Superscript'],
	        removeformat: ['Clear formatting', 'RemoveFormat'],
	        newdocument: ['New document', 'mceNewDocument'],
	        cut: ['Cut', 'Cut', 'Meta+X'],
	        copy: ['Copy', 'Copy', 'Meta+C'],
	        paste: ['Paste', 'Paste', 'Meta+V'],
	        selectall: ['Select all', 'SelectAll', 'Meta+A']
	      }, function (item, name) {
	        editor.addMenuItem(name, {
	          text: item[0],
	          icon: name,
	          shortcut: item[2],
	          cmd: item[1]
	        });
	      });
	
	      editor.addMenuItem('codeformat', {
	        text: 'Code',
	        icon: 'code',
	        onclick: FormatUtils.toggleFormat(editor, 'code')
	      });
	    };
	
	    var register = function (editor) {
	      registerButtons(editor);
	      registerMenuItems(editor);
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	/**
	 * UndoRedo.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.editorui.UndoRedo',
	  [
	  ],
	  function () {
	    var toggleUndoRedoState = function (editor, type) {
	      return function () {
	        var self = this;
	
	        var checkState = function () {
	          var typeFn = type === 'redo' ? 'hasRedo' : 'hasUndo';
	          return editor.undoManager ? editor.undoManager[typeFn]() : false;
	        };
	
	        self.disabled(!checkState());
	        editor.on('Undo Redo AddUndo TypingUndo ClearUndos SwitchMode', function () {
	          self.disabled(editor.readonly || !checkState());
	        });
	      };
	    };
	
	    var registerMenuItems = function (editor) {
	      editor.addMenuItem('undo', {
	        text: 'Undo',
	        icon: 'undo',
	        shortcut: 'Meta+Z',
	        onPostRender: toggleUndoRedoState(editor, 'undo'),
	        cmd: 'undo'
	      });
	
	      editor.addMenuItem('redo', {
	        text: 'Redo',
	        icon: 'redo',
	        shortcut: 'Meta+Y',
	        onPostRender: toggleUndoRedoState(editor, 'redo'),
	        cmd: 'redo'
	      });
	    };
	
	    var registerButtons = function (editor) {
	      editor.addButton('undo', {
	        tooltip: 'Undo',
	        onPostRender: toggleUndoRedoState(editor, 'undo'),
	        cmd: 'undo'
	      });
	
	      editor.addButton('redo', {
	        tooltip: 'Redo',
	        onPostRender: toggleUndoRedoState(editor, 'redo'),
	        cmd: 'redo'
	      });
	    };
	
	    var register = function (editor) {
	      registerMenuItems(editor);
	      registerButtons(editor);
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	/**
	 * VisualAid.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.editorui.VisualAid',
	  [
	  ],
	  function () {
	    var toggleVisualAidState = function (editor) {
	      return function () {
	        var self = this;
	
	        editor.on('VisualAid', function (e) {
	          self.active(e.hasVisual);
	        });
	
	        self.active(editor.hasVisual);
	      };
	    };
	
	    var registerMenuItems = function (editor) {
	      editor.addMenuItem('visualaid', {
	        text: 'Visual aids',
	        selectable: true,
	        onPostRender: toggleVisualAidState(editor),
	        cmd: 'mceToggleVisualAid'
	      });
	    };
	
	    var register = function (editor) {
	      registerMenuItems(editor);
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	/**
	 * FormatControls.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.FormatControls',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.SelectorFind',
	    'global!document',
	    'tinymce.core.EditorManager',
	    'tinymce.core.Env',
	    'tinymce.ui.Control',
	    'tinymce.ui.FloatPanel',
	    'tinymce.ui.Widget',
	    'tinymce.ui.editorui.Align',
	    'tinymce.ui.editorui.FontSelect',
	    'tinymce.ui.editorui.FontSizeSelect',
	    'tinymce.ui.editorui.FormatSelect',
	    'tinymce.ui.editorui.Formats',
	    'tinymce.ui.editorui.InsertButton',
	    'tinymce.ui.editorui.SimpleControls',
	    'tinymce.ui.editorui.UndoRedo',
	    'tinymce.ui.editorui.VisualAid'
	  ],
	  function (
	    Fun, Element, SelectorFind, document, EditorManager, Env, Control, FloatPanel, Widget, Align, FontSelect, FontSizeSelect, FormatSelect, Formats, InsertButton,
	    SimpleControls, UndoRedo, VisualAid
	  ) {
	    var setupEnvironment = function () {
	      Widget.tooltips = !Env.iOS;
	
	      Control.translate = function (text) {
	        return EditorManager.translate(text);
	      };
	    };
	
	    var setupUiContainer = function (editor) {
	      if (editor.settings.ui_container) {
	        Env.container = SelectorFind.descendant(Element.fromDom(document.body), editor.settings.ui_container).fold(Fun.constant(null), function (elm) {
	          return elm.dom();
	        });
	      }
	    };
	
	    var setupRtlMode = function (editor) {
	      if (editor.rtl) {
	        Control.rtl = true;
	      }
	    };
	
	    var setupHideFloatPanels = function (editor) {
	      editor.on('mousedown', function () {
	        FloatPanel.hideAll();
	      });
	    };
	
	    var setup = function (editor) {
	      setupRtlMode(editor);
	      setupHideFloatPanels(editor);
	      setupUiContainer(editor);
	      setupEnvironment(editor);
	
	      FormatSelect.register(editor);
	      Align.register(editor);
	      SimpleControls.register(editor);
	      UndoRedo.register(editor);
	      FontSizeSelect.register(editor);
	      FontSelect.register(editor);
	      Formats.register(editor);
	      VisualAid.register(editor);
	      InsertButton.register(editor);
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	/**
	 * GridLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This layout manager places controls in a grid.
	 *
	 * @setting {Number} spacing Spacing between controls.
	 * @setting {Number} spacingH Horizontal spacing between controls.
	 * @setting {Number} spacingV Vertical spacing between controls.
	 * @setting {Number} columns Number of columns to use.
	 * @setting {String/Array} alignH start|end|center|stretch or array of values for each column.
	 * @setting {String/Array} alignV start|end|center|stretch or array of values for each column.
	 * @setting {String} pack start|end
	 *
	 * @class tinymce.ui.GridLayout
	 * @extends tinymce.ui.AbsoluteLayout
	 */
	define(
	  'tinymce.ui.GridLayout',
	  [
	    "tinymce.ui.AbsoluteLayout"
	  ],
	  function (AbsoluteLayout) {
	    "use strict";
	
	    return AbsoluteLayout.extend({
	      /**
	       * Recalculates the positions of the controls in the specified container.
	       *
	       * @method recalc
	       * @param {tinymce.ui.Container} container Container instance to recalc.
	       */
	      recalc: function (container) {
	        var settings, rows, cols, items, contLayoutRect, width, height, rect,
	          ctrlLayoutRect, ctrl, x, y, posX, posY, ctrlSettings, contPaddingBox, align, spacingH, spacingV, alignH, alignV, maxX, maxY,
	          colWidths = [], rowHeights = [], ctrlMinWidth, ctrlMinHeight, availableWidth, availableHeight, reverseRows, idx;
	
	        // Get layout settings
	        settings = container.settings;
	        items = container.items().filter(':visible');
	        contLayoutRect = container.layoutRect();
	        cols = settings.columns || Math.ceil(Math.sqrt(items.length));
	        rows = Math.ceil(items.length / cols);
	        spacingH = settings.spacingH || settings.spacing || 0;
	        spacingV = settings.spacingV || settings.spacing || 0;
	        alignH = settings.alignH || settings.align;
	        alignV = settings.alignV || settings.align;
	        contPaddingBox = container.paddingBox;
	        reverseRows = 'reverseRows' in settings ? settings.reverseRows : container.isRtl();
	
	        if (alignH && typeof alignH == "string") {
	          alignH = [alignH];
	        }
	
	        if (alignV && typeof alignV == "string") {
	          alignV = [alignV];
	        }
	
	        // Zero padd columnWidths
	        for (x = 0; x < cols; x++) {
	          colWidths.push(0);
	        }
	
	        // Zero padd rowHeights
	        for (y = 0; y < rows; y++) {
	          rowHeights.push(0);
	        }
	
	        // Calculate columnWidths and rowHeights
	        for (y = 0; y < rows; y++) {
	          for (x = 0; x < cols; x++) {
	            ctrl = items[y * cols + x];
	
	            // Out of bounds
	            if (!ctrl) {
	              break;
	            }
	
	            ctrlLayoutRect = ctrl.layoutRect();
	            ctrlMinWidth = ctrlLayoutRect.minW;
	            ctrlMinHeight = ctrlLayoutRect.minH;
	
	            colWidths[x] = ctrlMinWidth > colWidths[x] ? ctrlMinWidth : colWidths[x];
	            rowHeights[y] = ctrlMinHeight > rowHeights[y] ? ctrlMinHeight : rowHeights[y];
	          }
	        }
	
	        // Calculate maxX
	        availableWidth = contLayoutRect.innerW - contPaddingBox.left - contPaddingBox.right;
	        for (maxX = 0, x = 0; x < cols; x++) {
	          maxX += colWidths[x] + (x > 0 ? spacingH : 0);
	          availableWidth -= (x > 0 ? spacingH : 0) + colWidths[x];
	        }
	
	        // Calculate maxY
	        availableHeight = contLayoutRect.innerH - contPaddingBox.top - contPaddingBox.bottom;
	        for (maxY = 0, y = 0; y < rows; y++) {
	          maxY += rowHeights[y] + (y > 0 ? spacingV : 0);
	          availableHeight -= (y > 0 ? spacingV : 0) + rowHeights[y];
	        }
	
	        maxX += contPaddingBox.left + contPaddingBox.right;
	        maxY += contPaddingBox.top + contPaddingBox.bottom;
	
	        // Calculate minW/minH
	        rect = {};
	        rect.minW = maxX + (contLayoutRect.w - contLayoutRect.innerW);
	        rect.minH = maxY + (contLayoutRect.h - contLayoutRect.innerH);
	
	        rect.contentW = rect.minW - contLayoutRect.deltaW;
	        rect.contentH = rect.minH - contLayoutRect.deltaH;
	        rect.minW = Math.min(rect.minW, contLayoutRect.maxW);
	        rect.minH = Math.min(rect.minH, contLayoutRect.maxH);
	        rect.minW = Math.max(rect.minW, contLayoutRect.startMinWidth);
	        rect.minH = Math.max(rect.minH, contLayoutRect.startMinHeight);
	
	        // Resize container container if minSize was changed
	        if (contLayoutRect.autoResize && (rect.minW != contLayoutRect.minW || rect.minH != contLayoutRect.minH)) {
	          rect.w = rect.minW;
	          rect.h = rect.minH;
	
	          container.layoutRect(rect);
	          this.recalc(container);
	
	          // Forced recalc for example if items are hidden/shown
	          if (container._lastRect === null) {
	            var parentCtrl = container.parent();
	            if (parentCtrl) {
	              parentCtrl._lastRect = null;
	              parentCtrl.recalc();
	            }
	          }
	
	          return;
	        }
	
	        // Update contentW/contentH so absEnd moves correctly
	        if (contLayoutRect.autoResize) {
	          rect = container.layoutRect(rect);
	          rect.contentW = rect.minW - contLayoutRect.deltaW;
	          rect.contentH = rect.minH - contLayoutRect.deltaH;
	        }
	
	        var flexV;
	
	        if (settings.packV == 'start') {
	          flexV = 0;
	        } else {
	          flexV = availableHeight > 0 ? Math.floor(availableHeight / rows) : 0;
	        }
	
	        // Calculate totalFlex
	        var totalFlex = 0;
	        var flexWidths = settings.flexWidths;
	        if (flexWidths) {
	          for (x = 0; x < flexWidths.length; x++) {
	            totalFlex += flexWidths[x];
	          }
	        } else {
	          totalFlex = cols;
	        }
	
	        // Calculate new column widths based on flex values
	        var ratio = availableWidth / totalFlex;
	        for (x = 0; x < cols; x++) {
	          colWidths[x] += flexWidths ? flexWidths[x] * ratio : ratio;
	        }
	
	        // Move/resize controls
	        posY = contPaddingBox.top;
	        for (y = 0; y < rows; y++) {
	          posX = contPaddingBox.left;
	          height = rowHeights[y] + flexV;
	
	          for (x = 0; x < cols; x++) {
	            if (reverseRows) {
	              idx = y * cols + cols - 1 - x;
	            } else {
	              idx = y * cols + x;
	            }
	
	            ctrl = items[idx];
	
	            // No more controls to render then break
	            if (!ctrl) {
	              break;
	            }
	
	            // Get control settings and calculate x, y
	            ctrlSettings = ctrl.settings;
	            ctrlLayoutRect = ctrl.layoutRect();
	            width = Math.max(colWidths[x], ctrlLayoutRect.startMinWidth);
	            ctrlLayoutRect.x = posX;
	            ctrlLayoutRect.y = posY;
	
	            // Align control horizontal
	            align = ctrlSettings.alignH || (alignH ? (alignH[x] || alignH[0]) : null);
	            if (align == "center") {
	              ctrlLayoutRect.x = posX + (width / 2) - (ctrlLayoutRect.w / 2);
	            } else if (align == "right") {
	              ctrlLayoutRect.x = posX + width - ctrlLayoutRect.w;
	            } else if (align == "stretch") {
	              ctrlLayoutRect.w = width;
	            }
	
	            // Align control vertical
	            align = ctrlSettings.alignV || (alignV ? (alignV[x] || alignV[0]) : null);
	            if (align == "center") {
	              ctrlLayoutRect.y = posY + (height / 2) - (ctrlLayoutRect.h / 2);
	            } else if (align == "bottom") {
	              ctrlLayoutRect.y = posY + height - ctrlLayoutRect.h;
	            } else if (align == "stretch") {
	              ctrlLayoutRect.h = height;
	            }
	
	            ctrl.layoutRect(ctrlLayoutRect);
	
	            posX += width + spacingH;
	
	            if (ctrl.recalc) {
	              ctrl.recalc();
	            }
	          }
	
	          posY += height + spacingV;
	        }
	      }
	    });
	  }
	);
	
	/**
	 * Iframe.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*jshint scripturl:true */
	
	/**
	 * This class creates an iframe.
	 *
	 * @setting {String} url Url to open in the iframe.
	 *
	 * @-x-less Iframe.less
	 * @class tinymce.ui.Iframe
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.Iframe',
	  [
	    "tinymce.ui.Widget",
	    "tinymce.core.util.Delay"
	  ],
	  function (Widget, Delay) {
	    "use strict";
	
	    return Widget.extend({
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this;
	
	        self.classes.add('iframe');
	        self.canFocus = false;
	
	        /*eslint no-script-url:0 */
	        return (
	          '<iframe id="' + self._id + '" class="' + self.classes + '" tabindex="-1" src="' +
	          (self.settings.url || "javascript:''") + '" frameborder="0"></iframe>'
	        );
	      },
	
	      /**
	       * Setter for the iframe source.
	       *
	       * @method src
	       * @param {String} src Source URL for iframe.
	       */
	      src: function (src) {
	        this.getEl().src = src;
	      },
	
	      /**
	       * Inner HTML for the iframe.
	       *
	       * @method html
	       * @param {String} html HTML string to set as HTML inside the iframe.
	       * @param {function} callback Optional callback to execute when the iframe body is filled with contents.
	       * @return {tinymce.ui.Iframe} Current iframe control.
	       */
	      html: function (html, callback) {
	        var self = this, body = this.getEl().contentWindow.document.body;
	
	        // Wait for iframe to initialize IE 10 takes time
	        if (!body) {
	          Delay.setTimeout(function () {
	            self.html(html);
	          });
	        } else {
	          body.innerHTML = html;
	
	          if (callback) {
	            callback();
	          }
	        }
	
	        return this;
	      }
	    });
	  }
	);
	
	/**
	 * InfoBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * ....
	 *
	 * @-x-less InfoBox.less
	 * @class tinymce.ui.InfoBox
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.InfoBox',
	  [
	    "tinymce.ui.Widget"
	  ],
	  function (Widget) {
	    "use strict";
	
	    return Widget.extend({
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Boolean} multiline Multiline label.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	        self.classes.add('widget').add('infobox');
	        self.canFocus = false;
	      },
	
	      severity: function (level) {
	        this.classes.remove('error');
	        this.classes.remove('warning');
	        this.classes.remove('success');
	        this.classes.add(level);
	      },
	
	      help: function (state) {
	        this.state.set('help', state);
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, prefix = self.classPrefix;
	
	        return (
	          '<div id="' + self._id + '" class="' + self.classes + '">' +
	          '<div id="' + self._id + '-body">' +
	          self.encode(self.state.get('text')) +
	          '<button role="button" tabindex="-1">' +
	          '<i class="' + prefix + 'ico ' + prefix + 'i-help"></i>' +
	          '</button>' +
	          '</div>' +
	          '</div>'
	        );
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:text', function (e) {
	          self.getEl('body').firstChild.data = self.encode(e.value);
	
	          if (self.state.get('rendered')) {
	            self.updateLayoutRect();
	          }
	        });
	
	        self.state.on('change:help', function (e) {
	          self.classes.toggle('has-help', e.value);
	
	          if (self.state.get('rendered')) {
	            self.updateLayoutRect();
	          }
	        });
	
	        return self._super();
	      }
	    });
	  }
	);
	
	/**
	 * Label.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class creates a label element. A label is a simple text control
	 * that can be bound to other controls.
	 *
	 * @-x-less Label.less
	 * @class tinymce.ui.Label
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.Label',
	  [
	    "tinymce.ui.Widget",
	    "tinymce.ui.DomUtils"
	  ],
	  function (Widget, DomUtils) {
	    "use strict";
	
	    return Widget.extend({
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Boolean} multiline Multiline label.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	        self.classes.add('widget').add('label');
	        self.canFocus = false;
	
	        if (settings.multiline) {
	          self.classes.add('autoscroll');
	        }
	
	        if (settings.strong) {
	          self.classes.add('strong');
	        }
	      },
	
	      /**
	       * Initializes the current controls layout rect.
	       * This will be executed by the layout managers to determine the
	       * default minWidth/minHeight etc.
	       *
	       * @method initLayoutRect
	       * @return {Object} Layout rect instance.
	       */
	      initLayoutRect: function () {
	        var self = this, layoutRect = self._super();
	
	        if (self.settings.multiline) {
	          var size = DomUtils.getSize(self.getEl());
	
	          // Check if the text fits within maxW if not then try word wrapping it
	          if (size.width > layoutRect.maxW) {
	            layoutRect.minW = layoutRect.maxW;
	            self.classes.add('multiline');
	          }
	
	          self.getEl().style.width = layoutRect.minW + 'px';
	          layoutRect.startMinH = layoutRect.h = layoutRect.minH = Math.min(layoutRect.maxH, DomUtils.getSize(self.getEl()).height);
	        }
	
	        return layoutRect;
	      },
	
	      /**
	       * Repaints the control after a layout operation.
	       *
	       * @method repaint
	       */
	      repaint: function () {
	        var self = this;
	
	        if (!self.settings.multiline) {
	          self.getEl().style.lineHeight = self.layoutRect().h + 'px';
	        }
	
	        return self._super();
	      },
	
	      severity: function (level) {
	        this.classes.remove('error');
	        this.classes.remove('warning');
	        this.classes.remove('success');
	        this.classes.add(level);
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, targetCtrl, forName, forId = self.settings.forId;
	        var text = self.settings.html ? self.settings.html : self.encode(self.state.get('text'));
	
	        if (!forId && (forName = self.settings.forName)) {
	          targetCtrl = self.getRoot().find('#' + forName)[0];
	
	          if (targetCtrl) {
	            forId = targetCtrl._id;
	          }
	        }
	
	        if (forId) {
	          return (
	            '<label id="' + self._id + '" class="' + self.classes + '"' + (forId ? ' for="' + forId + '"' : '') + '>' +
	            text +
	            '</label>'
	          );
	        }
	
	        return (
	          '<span id="' + self._id + '" class="' + self.classes + '">' +
	          text +
	          '</span>'
	        );
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:text', function (e) {
	          self.innerHtml(self.encode(e.value));
	
	          if (self.state.get('rendered')) {
	            self.updateLayoutRect();
	          }
	        });
	
	        return self._super();
	      }
	    });
	  }
	);
	
	/**
	 * Toolbar.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new toolbar.
	 *
	 * @class tinymce.ui.Toolbar
	 * @extends tinymce.ui.Container
	 */
	define(
	  'tinymce.ui.Toolbar',
	  [
	    "tinymce.ui.Container"
	  ],
	  function (Container) {
	    "use strict";
	
	    return Container.extend({
	      Defaults: {
	        role: 'toolbar',
	        layout: 'flow'
	      },
	
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	        self.classes.add('toolbar');
	      },
	
	      /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this;
	
	        self.items().each(function (ctrl) {
	          ctrl.classes.add('toolbar-item');
	        });
	
	        return self._super();
	      }
	    });
	  }
	);
	/**
	 * MenuBar.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new menubar.
	 *
	 * @-x-less MenuBar.less
	 * @class tinymce.ui.MenuBar
	 * @extends tinymce.ui.Container
	 */
	define(
	  'tinymce.ui.MenuBar',
	  [
	    "tinymce.ui.Toolbar"
	  ],
	  function (Toolbar) {
	    "use strict";
	
	    return Toolbar.extend({
	      Defaults: {
	        role: 'menubar',
	        containerCls: 'menubar',
	        ariaRoot: true,
	        defaults: {
	          type: 'menubutton'
	        }
	      }
	    });
	  }
	);
	/**
	 * MenuButton.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new menu button.
	 *
	 * @-x-less MenuButton.less
	 * @class tinymce.ui.MenuButton
	 * @extends tinymce.ui.Button
	 */
	define(
	  'tinymce.ui.MenuButton',
	  [
	    'global!window',
	    'tinymce.core.ui.Factory',
	    'tinymce.ui.Button',
	    'tinymce.ui.MenuBar'
	  ],
	  function (window, Factory, Button, MenuBar) {
	    "use strict";
	
	    // TODO: Maybe add as some global function
	    function isChildOf(node, parent) {
	      while (node) {
	        if (parent === node) {
	          return true;
	        }
	
	        node = node.parentNode;
	      }
	
	      return false;
	    }
	
	    var MenuButton = Button.extend({
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._renderOpen = true;
	
	        self._super(settings);
	        settings = self.settings;
	
	        self.classes.add('menubtn');
	
	        if (settings.fixedWidth) {
	          self.classes.add('fixed-width');
	        }
	
	        self.aria('haspopup', true);
	
	        self.state.set('menu', settings.menu || self.render());
	      },
	
	      /**
	       * Shows the menu for the button.
	       *
	       * @method showMenu
	       */
	      showMenu: function (toggle) {
	        var self = this, menu;
	
	        if (self.menu && self.menu.visible() && toggle !== false) {
	          return self.hideMenu();
	        }
	
	        if (!self.menu) {
	          menu = self.state.get('menu') || [];
	          self.classes.add('opened');
	
	          // Is menu array then auto constuct menu control
	          if (menu.length) {
	            menu = {
	              type: 'menu',
	              animate: true,
	              items: menu
	            };
	          } else {
	            menu.type = menu.type || 'menu';
	            menu.animate = true;
	          }
	
	          if (!menu.renderTo) {
	            self.menu = Factory.create(menu).parent(self).renderTo();
	          } else {
	            self.menu = menu.parent(self).show().renderTo();
	          }
	
	          self.fire('createmenu');
	          self.menu.reflow();
	          self.menu.on('cancel', function (e) {
	            if (e.control.parent() === self.menu) {
	              e.stopPropagation();
	              self.focus();
	              self.hideMenu();
	            }
	          });
	
	          // Move focus to button when a menu item is selected/clicked
	          self.menu.on('select', function () {
	            self.focus();
	          });
	
	          self.menu.on('show hide', function (e) {
	            if (e.control === self.menu) {
	              self.activeMenu(e.type == 'show');
	              self.classes.toggle('opened', e.type == 'show');
	            }
	
	            self.aria('expanded', e.type == 'show');
	          }).fire('show');
	        }
	
	        self.menu.show();
	        self.menu.layoutRect({ w: self.layoutRect().w });
	        self.menu.moveRel(self.getEl(), self.isRtl() ? ['br-tr', 'tr-br'] : ['bl-tl', 'tl-bl']);
	        self.fire('showmenu');
	      },
	
	      /**
	       * Hides the menu for the button.
	       *
	       * @method hideMenu
	       */
	      hideMenu: function () {
	        var self = this;
	
	        if (self.menu) {
	          self.menu.items().each(function (item) {
	            if (item.hideMenu) {
	              item.hideMenu();
	            }
	          });
	
	          self.menu.hide();
	        }
	      },
	
	      /**
	       * Sets the active menu state.
	       *
	       * @private
	       */
	      activeMenu: function (state) {
	        this.classes.toggle('active', state);
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	        var icon = self.settings.icon, image, text = self.state.get('text'),
	          textHtml = '';
	
	        image = self.settings.image;
	        if (image) {
	          icon = 'none';
	
	          // Support for [high dpi, low dpi] image sources
	          if (typeof image != "string") {
	            image = window.getSelection ? image[0] : image[1];
	          }
	
	          image = ' style="background-image: url(\'' + image + '\')"';
	        } else {
	          image = '';
	        }
	
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	
	        icon = self.settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	
	        self.aria('role', self.parent() instanceof MenuBar ? 'menuitem' : 'button');
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '" tabindex="-1" aria-labelledby="' + id + '">' +
	          '<button id="' + id + '-open" role="presentation" type="button" tabindex="-1">' +
	          (icon ? '<i class="' + icon + '"' + image + '></i>' : '') +
	          textHtml +
	          ' <i class="' + prefix + 'caret"></i>' +
	          '</button>' +
	          '</div>'
	        );
	      },
	
	      /**
	       * Gets invoked after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this;
	
	        self.on('click', function (e) {
	          if (e.control === self && isChildOf(e.target, self.getEl())) {
	            self.focus();
	            self.showMenu(!e.aria);
	
	            if (e.aria) {
	              self.menu.items().filter(':visible')[0].focus();
	            }
	          }
	        });
	
	        self.on('mouseenter', function (e) {
	          var overCtrl = e.control, parent = self.parent(), hasVisibleSiblingMenu;
	
	          if (overCtrl && parent && overCtrl instanceof MenuButton && overCtrl.parent() == parent) {
	            parent.items().filter('MenuButton').each(function (ctrl) {
	              if (ctrl.hideMenu && ctrl != overCtrl) {
	                if (ctrl.menu && ctrl.menu.visible()) {
	                  hasVisibleSiblingMenu = true;
	                }
	
	                ctrl.hideMenu();
	              }
	            });
	
	            if (hasVisibleSiblingMenu) {
	              overCtrl.focus(); // Fix for: #5887
	              overCtrl.showMenu();
	            }
	          }
	        });
	
	        return self._super();
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:menu', function () {
	          if (self.menu) {
	            self.menu.remove();
	          }
	
	          self.menu = null;
	        });
	
	        return self._super();
	      },
	
	      /**
	       * Removes the control and it's menus.
	       *
	       * @method remove
	       */
	      remove: function () {
	        this._super();
	
	        if (this.menu) {
	          this.menu.remove();
	        }
	      }
	    });
	
	    return MenuButton;
	  }
	);
	
	/**
	 * MenuItem.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new menu item.
	 *
	 * @-x-less MenuItem.less
	 * @class tinymce.ui.MenuItem
	 * @extends tinymce.ui.Control
	 */
	define(
	  'tinymce.ui.MenuItem',
	  [
	    "tinymce.ui.Widget",
	    "tinymce.core.ui.Factory",
	    "tinymce.core.Env",
	    "tinymce.core.util.Delay"
	  ],
	  function (Widget, Factory, Env, Delay) {
	    "use strict";
	
	    var toggleTextStyle = function (ctrl, state) {
	      var textStyle = ctrl._textStyle;
	      if (textStyle) {
	        var textElm = ctrl.getEl('text');
	        textElm.setAttribute('style', textStyle);
	
	        if (state) {
	          textElm.style.color = '';
	          textElm.style.backgroundColor = '';
	        }
	      }
	    };
	
	    return Widget.extend({
	      Defaults: {
	        border: 0,
	        role: 'menuitem'
	      },
	
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Boolean} selectable Selectable menu.
	       * @setting {Array} menu Submenu array with items.
	       * @setting {String} shortcut Shortcut to display for menu item. Example: Ctrl+X
	       */
	      init: function (settings) {
	        var self = this, text;
	
	        self._super(settings);
	
	        settings = self.settings;
	
	        self.classes.add('menu-item');
	
	        if (settings.menu) {
	          self.classes.add('menu-item-expand');
	        }
	
	        if (settings.preview) {
	          self.classes.add('menu-item-preview');
	        }
	
	        text = self.state.get('text');
	        if (text === '-' || text === '|') {
	          self.classes.add('menu-item-sep');
	          self.aria('role', 'separator');
	          self.state.set('text', '-');
	        }
	
	        if (settings.selectable) {
	          self.aria('role', 'menuitemcheckbox');
	          self.classes.add('menu-item-checkbox');
	          settings.icon = 'selected';
	        }
	
	        if (!settings.preview && !settings.selectable) {
	          self.classes.add('menu-item-normal');
	        }
	
	        self.on('mousedown', function (e) {
	          e.preventDefault();
	        });
	
	        if (settings.menu && !settings.ariaHideMenu) {
	          self.aria('haspopup', true);
	        }
	      },
	
	      /**
	       * Returns true/false if the menuitem has sub menu.
	       *
	       * @method hasMenus
	       * @return {Boolean} True/false state if it has submenu.
	       */
	      hasMenus: function () {
	        return !!this.settings.menu;
	      },
	
	      /**
	       * Shows the menu for the menu item.
	       *
	       * @method showMenu
	       */
	      showMenu: function () {
	        var self = this, settings = self.settings, menu, parent = self.parent();
	
	        parent.items().each(function (ctrl) {
	          if (ctrl !== self) {
	            ctrl.hideMenu();
	          }
	        });
	
	        if (settings.menu) {
	          menu = self.menu;
	
	          if (!menu) {
	            menu = settings.menu;
	
	            // Is menu array then auto constuct menu control
	            if (menu.length) {
	              menu = {
	                type: 'menu',
	                animate: true,
	                items: menu
	              };
	            } else {
	              menu.type = menu.type || 'menu';
	              menu.animate = true;
	            }
	
	            if (parent.settings.itemDefaults) {
	              menu.itemDefaults = parent.settings.itemDefaults;
	            }
	
	            menu = self.menu = Factory.create(menu).parent(self).renderTo();
	            menu.reflow();
	            menu.on('cancel', function (e) {
	              e.stopPropagation();
	              self.focus();
	              menu.hide();
	            });
	            menu.on('show hide', function (e) {
	              if (e.control.items) {
	                e.control.items().each(function (ctrl) {
	                  ctrl.active(ctrl.settings.selected);
	                });
	              }
	            }).fire('show');
	
	            menu.on('hide', function (e) {
	              if (e.control === menu) {
	                self.classes.remove('selected');
	              }
	            });
	
	            menu.submenu = true;
	          } else {
	            menu.show();
	          }
	
	          menu._parentMenu = parent;
	
	          menu.classes.add('menu-sub');
	
	          var rel = menu.testMoveRel(
	            self.getEl(),
	            self.isRtl() ? ['tl-tr', 'bl-br', 'tr-tl', 'br-bl'] : ['tr-tl', 'br-bl', 'tl-tr', 'bl-br']
	          );
	
	          menu.moveRel(self.getEl(), rel);
	          menu.rel = rel;
	
	          rel = 'menu-sub-' + rel;
	          menu.classes.remove(menu._lastRel).add(rel);
	          menu._lastRel = rel;
	
	          self.classes.add('selected');
	          self.aria('expanded', true);
	        }
	      },
	
	      /**
	       * Hides the menu for the menu item.
	       *
	       * @method hideMenu
	       */
	      hideMenu: function () {
	        var self = this;
	
	        if (self.menu) {
	          self.menu.items().each(function (item) {
	            if (item.hideMenu) {
	              item.hideMenu();
	            }
	          });
	
	          self.menu.hide();
	          self.aria('expanded', false);
	        }
	
	        return self;
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, id = self._id, settings = self.settings, prefix = self.classPrefix, text = self.state.get('text');
	        var icon = self.settings.icon, image = '', shortcut = settings.shortcut;
	        var url = self.encode(settings.url), iconHtml = '';
	
	        // Converts shortcut format to Mac/PC variants
	        function convertShortcut(shortcut) {
	          var i, value, replace = {};
	
	          if (Env.mac) {
	            replace = {
	              alt: '&#x2325;',
	              ctrl: '&#x2318;',
	              shift: '&#x21E7;',
	              meta: '&#x2318;'
	            };
	          } else {
	            replace = {
	              meta: 'Ctrl'
	            };
	          }
	
	          shortcut = shortcut.split('+');
	
	          for (i = 0; i < shortcut.length; i++) {
	            value = replace[shortcut[i].toLowerCase()];
	
	            if (value) {
	              shortcut[i] = value;
	            }
	          }
	
	          return shortcut.join('+');
	        }
	
	        function escapeRegExp(str) {
	          return str.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
	        }
	
	        function markMatches(text) {
	          var match = settings.match || '';
	
	          return match ? text.replace(new RegExp(escapeRegExp(match), 'gi'), function (match) {
	            return '!mce~match[' + match + ']mce~match!';
	          }) : text;
	        }
	
	        function boldMatches(text) {
	          return text.
	            replace(new RegExp(escapeRegExp('!mce~match['), 'g'), '<b>').
	            replace(new RegExp(escapeRegExp(']mce~match!'), 'g'), '</b>');
	        }
	
	        if (icon) {
	          self.parent().classes.add('menu-has-icons');
	        }
	
	        if (settings.image) {
	          image = ' style="background-image: url(\'' + settings.image + '\')"';
	        }
	
	        if (shortcut) {
	          shortcut = convertShortcut(shortcut);
	        }
	
	        icon = prefix + 'ico ' + prefix + 'i-' + (self.settings.icon || 'none');
	        iconHtml = (text !== '-' ? '<i class="' + icon + '"' + image + '></i>\u00a0' : '');
	
	        text = boldMatches(self.encode(markMatches(text)));
	        url = boldMatches(self.encode(markMatches(url)));
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '" tabindex="-1">' +
	          iconHtml +
	          (text !== '-' ? '<span id="' + id + '-text" class="' + prefix + 'text">' + text + '</span>' : '') +
	          (shortcut ? '<div id="' + id + '-shortcut" class="' + prefix + 'menu-shortcut">' + shortcut + '</div>' : '') +
	          (settings.menu ? '<div class="' + prefix + 'caret"></div>' : '') +
	          (url ? '<div class="' + prefix + 'menu-item-link">' + url + '</div>' : '') +
	          '</div>'
	        );
	      },
	
	      /**
	       * Gets invoked after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this, settings = self.settings;
	
	        var textStyle = settings.textStyle;
	        if (typeof textStyle === "function") {
	          textStyle = textStyle.call(this);
	        }
	
	        if (textStyle) {
	          var textElm = self.getEl('text');
	          if (textElm) {
	            textElm.setAttribute('style', textStyle);
	            self._textStyle = textStyle;
	          }
	        }
	
	        self.on('mouseenter click', function (e) {
	          if (e.control === self) {
	            if (!settings.menu && e.type === 'click') {
	              self.fire('select');
	
	              // Edge will crash if you stress it see #2660
	              Delay.requestAnimationFrame(function () {
	                self.parent().hideAll();
	              });
	            } else {
	              self.showMenu();
	
	              if (e.aria) {
	                self.menu.focus(true);
	              }
	            }
	          }
	        });
	
	        self._super();
	
	        return self;
	      },
	
	      hover: function () {
	        var self = this;
	
	        self.parent().items().each(function (ctrl) {
	          ctrl.classes.remove('selected');
	        });
	
	        self.classes.toggle('selected', true);
	
	        return self;
	      },
	
	      active: function (state) {
	        toggleTextStyle(this, state);
	
	        if (typeof state != "undefined") {
	          this.aria('checked', state);
	        }
	
	        return this._super(state);
	      },
	
	      /**
	       * Removes the control and it's menus.
	       *
	       * @method remove
	       */
	      remove: function () {
	        this._super();
	
	        if (this.menu) {
	          this.menu.remove();
	        }
	      }
	    });
	  }
	);
	
	/**
	 * Menu.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new menu.
	 *
	 * @-x-less Menu.less
	 * @class tinymce.ui.Menu
	 * @extends tinymce.ui.FloatPanel
	 */
	define(
	  'tinymce.ui.Menu',
	  [
	    'tinymce.core.Env',
	    'tinymce.core.util.Delay',
	    'tinymce.core.util.Tools',
	    'tinymce.ui.FloatPanel',
	    'tinymce.ui.MenuItem',
	    'tinymce.ui.Throbber'
	  ],
	  function (Env, Delay, Tools, FloatPanel, MenuItem, Throbber) {
	    "use strict";
	
	    return FloatPanel.extend({
	      Defaults: {
	        defaultType: 'menuitem',
	        border: 1,
	        layout: 'stack',
	        role: 'application',
	        bodyRole: 'menu',
	        ariaRoot: true
	      },
	
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       */
	      init: function (settings) {
	        var self = this;
	
	        settings.autohide = true;
	        settings.constrainToViewport = true;
	
	        if (typeof settings.items === 'function') {
	          settings.itemsFactory = settings.items;
	          settings.items = [];
	        }
	
	        if (settings.itemDefaults) {
	          var items = settings.items, i = items.length;
	
	          while (i--) {
	            items[i] = Tools.extend({}, settings.itemDefaults, items[i]);
	          }
	        }
	
	        self._super(settings);
	        self.classes.add('menu');
	
	        if (settings.animate && Env.ie !== 11) {
	          // IE 11 can't handle transforms it looks horrible and blurry so lets disable that
	          self.classes.add('animate');
	        }
	      },
	
	      /**
	       * Repaints the control after a layout operation.
	       *
	       * @method repaint
	       */
	      repaint: function () {
	        this.classes.toggle('menu-align', true);
	
	        this._super();
	
	        this.getEl().style.height = '';
	        this.getEl('body').style.height = '';
	
	        return this;
	      },
	
	      /**
	       * Hides/closes the menu.
	       *
	       * @method cancel
	       */
	      cancel: function () {
	        var self = this;
	
	        self.hideAll();
	        self.fire('select');
	      },
	
	      /**
	       * Loads new items from the factory items function.
	       *
	       * @method load
	       */
	      load: function () {
	        var self = this, time, factory;
	
	        function hideThrobber() {
	          if (self.throbber) {
	            self.throbber.hide();
	            self.throbber = null;
	          }
	        }
	
	        factory = self.settings.itemsFactory;
	        if (!factory) {
	          return;
	        }
	
	        if (!self.throbber) {
	          self.throbber = new Throbber(self.getEl('body'), true);
	
	          if (self.items().length === 0) {
	            self.throbber.show();
	            self.fire('loading');
	          } else {
	            self.throbber.show(100, function () {
	              self.items().remove();
	              self.fire('loading');
	            });
	          }
	
	          self.on('hide close', hideThrobber);
	        }
	
	        self.requestTime = time = new Date().getTime();
	
	        self.settings.itemsFactory(function (items) {
	          if (items.length === 0) {
	            self.hide();
	            return;
	          }
	
	          if (self.requestTime !== time) {
	            return;
	          }
	
	          self.getEl().style.width = '';
	          self.getEl('body').style.width = '';
	
	          hideThrobber();
	          self.items().remove();
	          self.getEl('body').innerHTML = '';
	
	          self.add(items);
	          self.renderNew();
	          self.fire('loaded');
	        });
	      },
	
	      /**
	       * Hide menu and all sub menus.
	       *
	       * @method hideAll
	       */
	      hideAll: function () {
	        var self = this;
	
	        this.find('menuitem').exec('hideMenu');
	
	        return self._super();
	      },
	
	      /**
	       * Invoked before the menu is rendered.
	       *
	       * @method preRender
	       */
	      preRender: function () {
	        var self = this;
	
	        self.items().each(function (ctrl) {
	          var settings = ctrl.settings;
	
	          if (settings.icon || settings.image || settings.selectable) {
	            self._hasIcons = true;
	            return false;
	          }
	        });
	
	        if (self.settings.itemsFactory) {
	          self.on('postrender', function () {
	            if (self.settings.itemsFactory) {
	              self.load();
	            }
	          });
	        }
	
	        self.on('show hide', function (e) {
	          if (e.control === self) {
	            if (e.type === 'show') {
	              Delay.setTimeout(function () {
	                self.classes.add('in');
	              }, 0);
	            } else {
	              self.classes.remove('in');
	            }
	          }
	        });
	
	        return self._super();
	      }
	    });
	  }
	);
	
	/**
	 * ListBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new list box control.
	 *
	 * @-x-less ListBox.less
	 * @class tinymce.ui.ListBox
	 * @extends tinymce.ui.MenuButton
	 */
	define(
	  'tinymce.ui.ListBox',
	  [
	    "tinymce.ui.MenuButton",
	    "tinymce.ui.Menu"
	  ],
	  function (MenuButton, Menu) {
	    "use strict";
	
	    return MenuButton.extend({
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Array} values Array with values to add to list box.
	       */
	      init: function (settings) {
	        var self = this, values, selected, selectedText, lastItemCtrl;
	
	        function setSelected(menuValues) {
	          // Try to find a selected value
	          for (var i = 0; i < menuValues.length; i++) {
	            selected = menuValues[i].selected || settings.value === menuValues[i].value;
	
	            if (selected) {
	              selectedText = selectedText || menuValues[i].text;
	              self.state.set('value', menuValues[i].value);
	              return true;
	            }
	
	            // If the value has a submenu, try to find the selected values in that menu
	            if (menuValues[i].menu) {
	              if (setSelected(menuValues[i].menu)) {
	                return true;
	              }
	            }
	          }
	        }
	
	        self._super(settings);
	        settings = self.settings;
	
	        self._values = values = settings.values;
	        if (values) {
	          if (typeof settings.value != "undefined") {
	            setSelected(values);
	          }
	
	          // Default with first item
	          if (!selected && values.length > 0) {
	            selectedText = values[0].text;
	            self.state.set('value', values[0].value);
	          }
	
	          self.state.set('menu', values);
	        }
	
	        self.state.set('text', settings.text || selectedText);
	
	        self.classes.add('listbox');
	
	        self.on('select', function (e) {
	          var ctrl = e.control;
	
	          if (lastItemCtrl) {
	            e.lastControl = lastItemCtrl;
	          }
	
	          if (settings.multiple) {
	            ctrl.active(!ctrl.active());
	          } else {
	            self.value(e.control.value());
	          }
	
	          lastItemCtrl = ctrl;
	        });
	      },
	
	      /**
	       * Getter/setter function for the control value.
	       *
	       * @method value
	       * @param {String} [value] Value to be set.
	       * @return {Boolean/tinymce.ui.ListBox} Value or self if it's a set operation.
	       */
	      bindStates: function () {
	        var self = this;
	
	        function activateMenuItemsByValue(menu, value) {
	          if (menu instanceof Menu) {
	            menu.items().each(function (ctrl) {
	              if (!ctrl.hasMenus()) {
	                ctrl.active(ctrl.value() === value);
	              }
	            });
	          }
	        }
	
	        function getSelectedItem(menuValues, value) {
	          var selectedItem;
	
	          if (!menuValues) {
	            return;
	          }
	
	          for (var i = 0; i < menuValues.length; i++) {
	            if (menuValues[i].value === value) {
	              return menuValues[i];
	            }
	
	            if (menuValues[i].menu) {
	              selectedItem = getSelectedItem(menuValues[i].menu, value);
	              if (selectedItem) {
	                return selectedItem;
	              }
	            }
	          }
	        }
	
	        self.on('show', function (e) {
	          activateMenuItemsByValue(e.control, self.value());
	        });
	
	        self.state.on('change:value', function (e) {
	          var selectedItem = getSelectedItem(self.state.get('menu'), e.value);
	
	          if (selectedItem) {
	            self.text(selectedItem.text);
	          } else {
	            self.text(self.settings.text);
	          }
	        });
	
	        return self._super();
	      }
	    });
	  }
	);
	
	/**
	 * Radio.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new radio button.
	 *
	 * @-x-less Radio.less
	 * @class tinymce.ui.Radio
	 * @extends tinymce.ui.Checkbox
	 */
	define(
	  'tinymce.ui.Radio',
	  [
	    "tinymce.ui.Checkbox"
	  ],
	  function (Checkbox) {
	    "use strict";
	
	    return Checkbox.extend({
	      Defaults: {
	        classes: "radio",
	        role: "radio"
	      }
	    });
	  }
	);
	/**
	 * ResizeHandle.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Renders a resize handle that fires ResizeStart, Resize and ResizeEnd events.
	 *
	 * @-x-less ResizeHandle.less
	 * @class tinymce.ui.ResizeHandle
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.ResizeHandle',
	  [
	    "tinymce.ui.Widget",
	    "tinymce.ui.DragHelper"
	  ],
	  function (Widget, DragHelper) {
	    "use strict";
	
	    return Widget.extend({
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, prefix = self.classPrefix;
	
	        self.classes.add('resizehandle');
	
	        if (self.settings.direction == "both") {
	          self.classes.add('resizehandle-both');
	        }
	
	        self.canFocus = false;
	
	        return (
	          '<div id="' + self._id + '" class="' + self.classes + '">' +
	          '<i class="' + prefix + 'ico ' + prefix + 'i-resize"></i>' +
	          '</div>'
	        );
	      },
	
	      /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this;
	
	        self._super();
	
	        self.resizeDragHelper = new DragHelper(this._id, {
	          start: function () {
	            self.fire('ResizeStart');
	          },
	
	          drag: function (e) {
	            if (self.settings.direction != "both") {
	              e.deltaX = 0;
	            }
	
	            self.fire('Resize', e);
	          },
	
	          stop: function () {
	            self.fire('ResizeEnd');
	          }
	        });
	      },
	
	      remove: function () {
	        if (this.resizeDragHelper) {
	          this.resizeDragHelper.destroy();
	        }
	
	        return this._super();
	      }
	    });
	  }
	);
	
	/**
	 * SelectBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new select box control.
	 *
	 * @-x-less SelectBox.less
	 * @class tinymce.ui.SelectBox
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.SelectBox',
	  [
	    "tinymce.ui.Widget"
	  ],
	  function (Widget) {
	    "use strict";
	
	    function createOptions(options) {
	      var strOptions = '';
	      if (options) {
	        for (var i = 0; i < options.length; i++) {
	          strOptions += '<option value="' + options[i] + '">' + options[i] + '</option>';
	        }
	      }
	      return strOptions;
	    }
	
	    return Widget.extend({
	      Defaults: {
	        classes: "selectbox",
	        role: "selectbox",
	        options: []
	      },
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Array} options Array with options to add to the select box.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	
	        if (self.settings.size) {
	          self.size = self.settings.size;
	        }
	
	        if (self.settings.options) {
	          self._options = self.settings.options;
	        }
	
	        self.on('keydown', function (e) {
	          var rootControl;
	
	          if (e.keyCode == 13) {
	            e.preventDefault();
	
	            // Find root control that we can do toJSON on
	            self.parents().reverse().each(function (ctrl) {
	              if (ctrl.toJSON) {
	                rootControl = ctrl;
	                return false;
	              }
	            });
	
	            // Fire event on current text box with the serialized data of the whole form
	            self.fire('submit', { data: rootControl.toJSON() });
	          }
	        });
	      },
	
	      /**
	       * Getter/setter function for the options state.
	       *
	       * @method options
	       * @param {Array} [state] State to be set.
	       * @return {Array|tinymce.ui.SelectBox} Array of string options.
	       */
	      options: function (state) {
	        if (!arguments.length) {
	          return this.state.get('options');
	        }
	
	        this.state.set('options', state);
	
	        return this;
	      },
	
	      renderHtml: function () {
	        var self = this, options, size = '';
	
	        options = createOptions(self._options);
	
	        if (self.size) {
	          size = ' size = "' + self.size + '"';
	        }
	
	        return (
	          '<select id="' + self._id + '" class="' + self.classes + '"' + size + '>' +
	          options +
	          '</select>'
	        );
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:options', function (e) {
	          self.getEl().innerHTML = createOptions(e.value);
	        });
	
	        return self._super();
	      }
	    });
	  }
	);
	
	/**
	 * Slider.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Slider control.
	 *
	 * @-x-less Slider.less
	 * @class tinymce.ui.Slider
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.Slider',
	  [
	    "tinymce.ui.Widget",
	    "tinymce.ui.DragHelper",
	    "tinymce.ui.DomUtils"
	  ],
	  function (Widget, DragHelper, DomUtils) {
	    "use strict";
	
	    function constrain(value, minVal, maxVal) {
	      if (value < minVal) {
	        value = minVal;
	      }
	
	      if (value > maxVal) {
	        value = maxVal;
	      }
	
	      return value;
	    }
	
	    function setAriaProp(el, name, value) {
	      el.setAttribute('aria-' + name, value);
	    }
	
	    function updateSliderHandle(ctrl, value) {
	      var maxHandlePos, shortSizeName, sizeName, stylePosName, styleValue, handleEl;
	
	      if (ctrl.settings.orientation == "v") {
	        stylePosName = "top";
	        sizeName = "height";
	        shortSizeName = "h";
	      } else {
	        stylePosName = "left";
	        sizeName = "width";
	        shortSizeName = "w";
	      }
	
	      handleEl = ctrl.getEl('handle');
	      maxHandlePos = (ctrl.layoutRect()[shortSizeName] || 100) - DomUtils.getSize(handleEl)[sizeName];
	
	      styleValue = (maxHandlePos * ((value - ctrl._minValue) / (ctrl._maxValue - ctrl._minValue))) + 'px';
	      handleEl.style[stylePosName] = styleValue;
	      handleEl.style.height = ctrl.layoutRect().h + 'px';
	
	      setAriaProp(handleEl, 'valuenow', value);
	      setAriaProp(handleEl, 'valuetext', '' + ctrl.settings.previewFilter(value));
	      setAriaProp(handleEl, 'valuemin', ctrl._minValue);
	      setAriaProp(handleEl, 'valuemax', ctrl._maxValue);
	    }
	
	    return Widget.extend({
	      init: function (settings) {
	        var self = this;
	
	        if (!settings.previewFilter) {
	          settings.previewFilter = function (value) {
	            return Math.round(value * 100) / 100.0;
	          };
	        }
	
	        self._super(settings);
	        self.classes.add('slider');
	
	        if (settings.orientation == "v") {
	          self.classes.add('vertical');
	        }
	
	        self._minValue = settings.minValue || 0;
	        self._maxValue = settings.maxValue || 100;
	        self._initValue = self.state.get('value');
	      },
	
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix;
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '">' +
	          '<div id="' + id + '-handle" class="' + prefix + 'slider-handle" role="slider" tabindex="-1"></div>' +
	          '</div>'
	        );
	      },
	
	      reset: function () {
	        this.value(this._initValue).repaint();
	      },
	
	      postRender: function () {
	        var self = this, minValue, maxValue, screenCordName,
	          stylePosName, sizeName, shortSizeName;
	
	        function toFraction(min, max, val) {
	          return (val + min) / (max - min);
	        }
	
	        function fromFraction(min, max, val) {
	          return (val * (max - min)) - min;
	        }
	
	        function handleKeyboard(minValue, maxValue) {
	          function alter(delta) {
	            var value;
	
	            value = self.value();
	            value = fromFraction(minValue, maxValue, toFraction(minValue, maxValue, value) + (delta * 0.05));
	            value = constrain(value, minValue, maxValue);
	
	            self.value(value);
	
	            self.fire('dragstart', { value: value });
	            self.fire('drag', { value: value });
	            self.fire('dragend', { value: value });
	          }
	
	          self.on('keydown', function (e) {
	            switch (e.keyCode) {
	              case 37:
	              case 38:
	                alter(-1);
	                break;
	
	              case 39:
	              case 40:
	                alter(1);
	                break;
	            }
	          });
	        }
	
	        function handleDrag(minValue, maxValue, handleEl) {
	          var startPos, startHandlePos, maxHandlePos, handlePos, value;
	
	          self._dragHelper = new DragHelper(self._id, {
	            handle: self._id + "-handle",
	
	            start: function (e) {
	              startPos = e[screenCordName];
	              startHandlePos = parseInt(self.getEl('handle').style[stylePosName], 10);
	              maxHandlePos = (self.layoutRect()[shortSizeName] || 100) - DomUtils.getSize(handleEl)[sizeName];
	              self.fire('dragstart', { value: value });
	            },
	
	            drag: function (e) {
	              var delta = e[screenCordName] - startPos;
	
	              handlePos = constrain(startHandlePos + delta, 0, maxHandlePos);
	              handleEl.style[stylePosName] = handlePos + 'px';
	
	              value = minValue + (handlePos / maxHandlePos) * (maxValue - minValue);
	              self.value(value);
	
	              self.tooltip().text('' + self.settings.previewFilter(value)).show().moveRel(handleEl, 'bc tc');
	
	              self.fire('drag', { value: value });
	            },
	
	            stop: function () {
	              self.tooltip().hide();
	              self.fire('dragend', { value: value });
	            }
	          });
	        }
	
	        minValue = self._minValue;
	        maxValue = self._maxValue;
	
	        if (self.settings.orientation == "v") {
	          screenCordName = "screenY";
	          stylePosName = "top";
	          sizeName = "height";
	          shortSizeName = "h";
	        } else {
	          screenCordName = "screenX";
	          stylePosName = "left";
	          sizeName = "width";
	          shortSizeName = "w";
	        }
	
	        self._super();
	
	        handleKeyboard(minValue, maxValue, self.getEl('handle'));
	        handleDrag(minValue, maxValue, self.getEl('handle'));
	      },
	
	      repaint: function () {
	        this._super();
	        updateSliderHandle(this, this.value());
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:value', function (e) {
	          updateSliderHandle(self, e.value);
	        });
	
	        return self._super();
	      }
	    });
	  }
	);
	/**
	 * Spacer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a spacer. This control is used in flex layouts for example.
	 *
	 * @-x-less Spacer.less
	 * @class tinymce.ui.Spacer
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.Spacer',
	  [
	    "tinymce.ui.Widget"
	  ],
	  function (Widget) {
	    "use strict";
	
	    return Widget.extend({
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this;
	
	        self.classes.add('spacer');
	        self.canFocus = false;
	
	        return '<div id="' + self._id + '" class="' + self.classes + '"></div>';
	      }
	    });
	  }
	);
	/**
	 * SplitButton.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a split button.
	 *
	 * @-x-less SplitButton.less
	 * @class tinymce.ui.SplitButton
	 * @extends tinymce.ui.Button
	 */
	define(
	  'tinymce.ui.SplitButton',
	  [
	    'global!window',
	    'tinymce.core.dom.DomQuery',
	    'tinymce.ui.DomUtils',
	    'tinymce.ui.MenuButton'
	  ],
	  function (window, DomQuery, DomUtils, MenuButton) {
	    return MenuButton.extend({
	      Defaults: {
	        classes: "widget btn splitbtn",
	        role: "button"
	      },
	
	      /**
	       * Repaints the control after a layout operation.
	       *
	       * @method repaint
	       */
	      repaint: function () {
	        var self = this, elm = self.getEl(), rect = self.layoutRect(), mainButtonElm, menuButtonElm;
	
	        self._super();
	
	        mainButtonElm = elm.firstChild;
	        menuButtonElm = elm.lastChild;
	
	        DomQuery(mainButtonElm).css({
	          width: rect.w - DomUtils.getSize(menuButtonElm).width,
	          height: rect.h - 2
	        });
	
	        DomQuery(menuButtonElm).css({
	          height: rect.h - 2
	        });
	
	        return self;
	      },
	
	      /**
	       * Sets the active menu state.
	       *
	       * @private
	       */
	      activeMenu: function (state) {
	        var self = this;
	
	        DomQuery(self.getEl().lastChild).toggleClass(self.classPrefix + 'active', state);
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, id = self._id, prefix = self.classPrefix, image;
	        var icon = self.state.get('icon'), text = self.state.get('text');
	        var settings = self.settings, textHtml = '', ariaPressed;
	
	        image = settings.image;
	        if (image) {
	          icon = 'none';
	
	          // Support for [high dpi, low dpi] image sources
	          if (typeof image != "string") {
	            image = window.getSelection ? image[0] : image[1];
	          }
	
	          image = ' style="background-image: url(\'' + image + '\')"';
	        } else {
	          image = '';
	        }
	
	        icon = settings.icon ? prefix + 'ico ' + prefix + 'i-' + icon : '';
	
	        if (text) {
	          self.classes.add('btn-has-text');
	          textHtml = '<span class="' + prefix + 'txt">' + self.encode(text) + '</span>';
	        }
	
	        ariaPressed = typeof settings.active === 'boolean' ? ' aria-pressed="' + settings.active + '"' : '';
	
	        return (
	          '<div id="' + id + '" class="' + self.classes + '" role="button"' + ariaPressed + ' tabindex="-1">' +
	          '<button type="button" hidefocus="1" tabindex="-1">' +
	          (icon ? '<i class="' + icon + '"' + image + '></i>' : '') +
	          textHtml +
	          '</button>' +
	          '<button type="button" class="' + prefix + 'open" hidefocus="1" tabindex="-1">' +
	          //(icon ? '<i class="' + icon + '"></i>' : '') +
	          (self._menuBtnText ? (icon ? '\u00a0' : '') + self._menuBtnText : '') +
	          ' <i class="' + prefix + 'caret"></i>' +
	          '</button>' +
	          '</div>'
	        );
	      },
	
	      /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this, onClickHandler = self.settings.onclick;
	
	        self.on('click', function (e) {
	          var node = e.target;
	
	          if (e.control == this) {
	            // Find clicks that is on the main button
	            while (node) {
	              if ((e.aria && e.aria.key != 'down') || (node.nodeName == 'BUTTON' && node.className.indexOf('open') == -1)) {
	                e.stopImmediatePropagation();
	
	                if (onClickHandler) {
	                  onClickHandler.call(this, e);
	                }
	
	                return;
	              }
	
	              node = node.parentNode;
	            }
	          }
	        });
	
	        delete self.settings.onclick;
	
	        return self._super();
	      }
	    });
	  }
	);
	/**
	 * StackLayout.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This layout uses the browsers layout when the items are blocks.
	 *
	 * @-x-less StackLayout.less
	 * @class tinymce.ui.StackLayout
	 * @extends tinymce.ui.FlowLayout
	 */
	define(
	  'tinymce.ui.StackLayout',
	  [
	    "tinymce.ui.FlowLayout"
	  ],
	  function (FlowLayout) {
	    "use strict";
	
	    return FlowLayout.extend({
	      Defaults: {
	        containerClass: 'stack-layout',
	        controlClass: 'stack-layout-item',
	        endClass: 'break'
	      },
	
	      isNative: function () {
	        return true;
	      }
	    });
	  }
	);
	/**
	 * TabPanel.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a tab panel control.
	 *
	 * @-x-less TabPanel.less
	 * @class tinymce.ui.TabPanel
	 * @extends tinymce.ui.Panel
	 *
	 * @setting {Number} activeTab Active tab index.
	 */
	define(
	  'tinymce.ui.TabPanel',
	  [
	    "tinymce.ui.Panel",
	    "tinymce.core.dom.DomQuery",
	    "tinymce.ui.DomUtils"
	  ],
	  function (Panel, $, DomUtils) {
	    "use strict";
	
	    return Panel.extend({
	      Defaults: {
	        layout: 'absolute',
	        defaults: {
	          type: 'panel'
	        }
	      },
	
	      /**
	       * Activates the specified tab by index.
	       *
	       * @method activateTab
	       * @param {Number} idx Index of the tab to activate.
	       */
	      activateTab: function (idx) {
	        var activeTabElm;
	
	        if (this.activeTabId) {
	          activeTabElm = this.getEl(this.activeTabId);
	          $(activeTabElm).removeClass(this.classPrefix + 'active');
	          activeTabElm.setAttribute('aria-selected', "false");
	        }
	
	        this.activeTabId = 't' + idx;
	
	        activeTabElm = this.getEl('t' + idx);
	        activeTabElm.setAttribute('aria-selected', "true");
	        $(activeTabElm).addClass(this.classPrefix + 'active');
	
	        this.items()[idx].show().fire('showtab');
	        this.reflow();
	
	        this.items().each(function (item, i) {
	          if (idx != i) {
	            item.hide();
	          }
	        });
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, layout = self._layout, tabsHtml = '', prefix = self.classPrefix;
	
	        self.preRender();
	        layout.preRender(self);
	
	        self.items().each(function (ctrl, i) {
	          var id = self._id + '-t' + i;
	
	          ctrl.aria('role', 'tabpanel');
	          ctrl.aria('labelledby', id);
	
	          tabsHtml += (
	            '<div id="' + id + '" class="' + prefix + 'tab" ' +
	            'unselectable="on" role="tab" aria-controls="' + ctrl._id + '" aria-selected="false" tabIndex="-1">' +
	            self.encode(ctrl.settings.title) +
	            '</div>'
	          );
	        });
	
	        return (
	          '<div id="' + self._id + '" class="' + self.classes + '" hidefocus="1" tabindex="-1">' +
	          '<div id="' + self._id + '-head" class="' + prefix + 'tabs" role="tablist">' +
	          tabsHtml +
	          '</div>' +
	          '<div id="' + self._id + '-body" class="' + self.bodyClasses + '">' +
	          layout.renderHtml(self) +
	          '</div>' +
	          '</div>'
	        );
	      },
	
	      /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this;
	
	        self._super();
	
	        self.settings.activeTab = self.settings.activeTab || 0;
	        self.activateTab(self.settings.activeTab);
	
	        this.on('click', function (e) {
	          var targetParent = e.target.parentNode;
	
	          if (targetParent && targetParent.id == self._id + '-head') {
	            var i = targetParent.childNodes.length;
	
	            while (i--) {
	              if (targetParent.childNodes[i] == e.target) {
	                self.activateTab(i);
	              }
	            }
	          }
	        });
	      },
	
	      /**
	       * Initializes the current controls layout rect.
	       * This will be executed by the layout managers to determine the
	       * default minWidth/minHeight etc.
	       *
	       * @method initLayoutRect
	       * @return {Object} Layout rect instance.
	       */
	      initLayoutRect: function () {
	        var self = this, rect, minW, minH;
	
	        minW = DomUtils.getSize(self.getEl('head')).width;
	        minW = minW < 0 ? 0 : minW;
	        minH = 0;
	
	        self.items().each(function (item) {
	          minW = Math.max(minW, item.layoutRect().minW);
	          minH = Math.max(minH, item.layoutRect().minH);
	        });
	
	        self.items().each(function (ctrl) {
	          ctrl.settings.x = 0;
	          ctrl.settings.y = 0;
	          ctrl.settings.w = minW;
	          ctrl.settings.h = minH;
	
	          ctrl.layoutRect({
	            x: 0,
	            y: 0,
	            w: minW,
	            h: minH
	          });
	        });
	
	        var headH = DomUtils.getSize(self.getEl('head')).height;
	
	        self.settings.minWidth = minW;
	        self.settings.minHeight = minH + headH;
	
	        rect = self._super();
	        rect.deltaH += headH;
	        rect.innerH = rect.h - rect.deltaH;
	
	        return rect;
	      }
	    });
	  }
	);
	
	/**
	 * TextBox.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Creates a new textbox.
	 *
	 * @-x-less TextBox.less
	 * @class tinymce.ui.TextBox
	 * @extends tinymce.ui.Widget
	 */
	define(
	  'tinymce.ui.TextBox',
	  [
	    'global!document',
	    'tinymce.core.util.Tools',
	    'tinymce.ui.DomUtils',
	    'tinymce.ui.Widget'
	  ],
	  function (document, Tools, DomUtils, Widget) {
	    return Widget.extend({
	      /**
	       * Constructs a instance with the specified settings.
	       *
	       * @constructor
	       * @param {Object} settings Name/value object with settings.
	       * @setting {Boolean} multiline True if the textbox is a multiline control.
	       * @setting {Number} maxLength Max length for the textbox.
	       * @setting {Number} size Size of the textbox in characters.
	       */
	      init: function (settings) {
	        var self = this;
	
	        self._super(settings);
	
	        self.classes.add('textbox');
	
	        if (settings.multiline) {
	          self.classes.add('multiline');
	        } else {
	          self.on('keydown', function (e) {
	            var rootControl;
	
	            if (e.keyCode == 13) {
	              e.preventDefault();
	
	              // Find root control that we can do toJSON on
	              self.parents().reverse().each(function (ctrl) {
	                if (ctrl.toJSON) {
	                  rootControl = ctrl;
	                  return false;
	                }
	              });
	
	              // Fire event on current text box with the serialized data of the whole form
	              self.fire('submit', { data: rootControl.toJSON() });
	            }
	          });
	
	          self.on('keyup', function (e) {
	            self.state.set('value', e.target.value);
	          });
	        }
	      },
	
	      /**
	       * Repaints the control after a layout operation.
	       *
	       * @method repaint
	       */
	      repaint: function () {
	        var self = this, style, rect, borderBox, borderW, borderH = 0, lastRepaintRect;
	
	        style = self.getEl().style;
	        rect = self._layoutRect;
	        lastRepaintRect = self._lastRepaintRect || {};
	
	        // Detect old IE 7+8 add lineHeight to align caret vertically in the middle
	        var doc = document;
	        if (!self.settings.multiline && doc.all && (!doc.documentMode || doc.documentMode <= 8)) {
	          style.lineHeight = (rect.h - borderH) + 'px';
	        }
	
	        borderBox = self.borderBox;
	        borderW = borderBox.left + borderBox.right + 8;
	        borderH = borderBox.top + borderBox.bottom + (self.settings.multiline ? 8 : 0);
	
	        if (rect.x !== lastRepaintRect.x) {
	          style.left = rect.x + 'px';
	          lastRepaintRect.x = rect.x;
	        }
	
	        if (rect.y !== lastRepaintRect.y) {
	          style.top = rect.y + 'px';
	          lastRepaintRect.y = rect.y;
	        }
	
	        if (rect.w !== lastRepaintRect.w) {
	          style.width = (rect.w - borderW) + 'px';
	          lastRepaintRect.w = rect.w;
	        }
	
	        if (rect.h !== lastRepaintRect.h) {
	          style.height = (rect.h - borderH) + 'px';
	          lastRepaintRect.h = rect.h;
	        }
	
	        self._lastRepaintRect = lastRepaintRect;
	        self.fire('repaint', {}, false);
	
	        return self;
	      },
	
	      /**
	       * Renders the control as a HTML string.
	       *
	       * @method renderHtml
	       * @return {String} HTML representing the control.
	       */
	      renderHtml: function () {
	        var self = this, settings = self.settings, attrs, elm;
	
	        attrs = {
	          id: self._id,
	          hidefocus: '1'
	        };
	
	        Tools.each([
	          'rows', 'spellcheck', 'maxLength', 'size', 'readonly', 'min',
	          'max', 'step', 'list', 'pattern', 'placeholder', 'required', 'multiple'
	        ], function (name) {
	          attrs[name] = settings[name];
	        });
	
	        if (self.disabled()) {
	          attrs.disabled = 'disabled';
	        }
	
	        if (settings.subtype) {
	          attrs.type = settings.subtype;
	        }
	
	        elm = DomUtils.create(settings.multiline ? 'textarea' : 'input', attrs);
	        elm.value = self.state.get('value');
	        elm.className = self.classes;
	
	        return elm.outerHTML;
	      },
	
	      value: function (value) {
	        if (arguments.length) {
	          this.state.set('value', value);
	          return this;
	        }
	
	        // Make sure the real state is in sync
	        if (this.state.get('rendered')) {
	          this.state.set('value', this.getEl().value);
	        }
	
	        return this.state.get('value');
	      },
	
	      /**
	       * Called after the control has been rendered.
	       *
	       * @method postRender
	       */
	      postRender: function () {
	        var self = this;
	
	        self.getEl().value = self.state.get('value');
	        self._super();
	
	        self.$el.on('change', function (e) {
	          self.state.set('value', e.target.value);
	          self.fire('change', e);
	        });
	      },
	
	      bindStates: function () {
	        var self = this;
	
	        self.state.on('change:value', function (e) {
	          if (self.getEl().value != e.value) {
	            self.getEl().value = e.value;
	          }
	        });
	
	        self.state.on('change:disabled', function (e) {
	          self.getEl().disabled = e.value;
	        });
	
	        return self._super();
	      },
	
	      remove: function () {
	        this.$el.off();
	        this._super();
	      }
	    });
	  }
	);
	
	/**
	 * Api.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.ui.Api',
	  [
	    'tinymce.core.ui.Factory',
	    'tinymce.core.util.Tools',
	    'tinymce.ui.AbsoluteLayout',
	    'tinymce.ui.BrowseButton',
	    'tinymce.ui.Button',
	    'tinymce.ui.ButtonGroup',
	    'tinymce.ui.Checkbox',
	    'tinymce.ui.Collection',
	    'tinymce.ui.ColorBox',
	    'tinymce.ui.ColorButton',
	    'tinymce.ui.ColorPicker',
	    'tinymce.ui.ComboBox',
	    'tinymce.ui.Container',
	    'tinymce.ui.Control',
	    'tinymce.ui.DragHelper',
	    'tinymce.ui.DropZone',
	    'tinymce.ui.ElementPath',
	    'tinymce.ui.FieldSet',
	    'tinymce.ui.FilePicker',
	    'tinymce.ui.FitLayout',
	    'tinymce.ui.FlexLayout',
	    'tinymce.ui.FloatPanel',
	    'tinymce.ui.FlowLayout',
	    'tinymce.ui.Form',
	    'tinymce.ui.FormatControls',
	    'tinymce.ui.FormItem',
	    'tinymce.ui.GridLayout',
	    'tinymce.ui.Iframe',
	    'tinymce.ui.InfoBox',
	    'tinymce.ui.KeyboardNavigation',
	    'tinymce.ui.Label',
	    'tinymce.ui.Layout',
	    'tinymce.ui.ListBox',
	    'tinymce.ui.Menu',
	    'tinymce.ui.MenuBar',
	    'tinymce.ui.MenuButton',
	    'tinymce.ui.MenuItem',
	    'tinymce.ui.MessageBox',
	    'tinymce.ui.Movable',
	    'tinymce.ui.Notification',
	    'tinymce.ui.Panel',
	    'tinymce.ui.PanelButton',
	    'tinymce.ui.Path',
	    'tinymce.ui.Progress',
	    'tinymce.ui.Radio',
	    'tinymce.ui.ReflowQueue',
	    'tinymce.ui.Resizable',
	    'tinymce.ui.ResizeHandle',
	    'tinymce.ui.Scrollable',
	    'tinymce.ui.SelectBox',
	    'tinymce.ui.Selector',
	    'tinymce.ui.Slider',
	    'tinymce.ui.Spacer',
	    'tinymce.ui.SplitButton',
	    'tinymce.ui.StackLayout',
	    'tinymce.ui.TabPanel',
	    'tinymce.ui.TextBox',
	    'tinymce.ui.Throbber',
	    'tinymce.ui.Toolbar',
	    'tinymce.ui.Tooltip',
	    'tinymce.ui.Widget',
	    'tinymce.ui.Window'
	  ],
	  function (
	    Factory, Tools, AbsoluteLayout, BrowseButton, Button, ButtonGroup, Checkbox, Collection, ColorBox, ColorButton, ColorPicker, ComboBox, Container, Control,
	    DragHelper, DropZone, ElementPath, FieldSet, FilePicker, FitLayout, FlexLayout, FloatPanel, FlowLayout, Form, FormatControls, FormItem, GridLayout, Iframe,
	    InfoBox, KeyboardNavigation, Label, Layout, ListBox, Menu, MenuBar, MenuButton, MenuItem, MessageBox, Movable, Notification, Panel, PanelButton, Path, Progress,
	    Radio, ReflowQueue, Resizable, ResizeHandle, Scrollable, SelectBox, Selector, Slider, Spacer, SplitButton, StackLayout, TabPanel, TextBox, Throbber, Toolbar,
	    Tooltip, Widget, Window
	  ) {
	    var getApi = function () {
	      return {
	        Selector: Selector,
	        Collection: Collection,
	        ReflowQueue: ReflowQueue,
	        Control: Control,
	        Factory: Factory,
	        KeyboardNavigation: KeyboardNavigation,
	        Container: Container,
	        DragHelper: DragHelper,
	        Scrollable: Scrollable,
	        Panel: Panel,
	        Movable: Movable,
	        Resizable: Resizable,
	        FloatPanel: FloatPanel,
	        Window: Window,
	        MessageBox: MessageBox,
	        Tooltip: Tooltip,
	        Widget: Widget,
	        Progress: Progress,
	        Notification: Notification,
	        Layout: Layout,
	        AbsoluteLayout: AbsoluteLayout,
	        Button: Button,
	        ButtonGroup: ButtonGroup,
	        Checkbox: Checkbox,
	        ComboBox: ComboBox,
	        ColorBox: ColorBox,
	        PanelButton: PanelButton,
	        ColorButton: ColorButton,
	        ColorPicker: ColorPicker,
	        Path: Path,
	        ElementPath: ElementPath,
	        FormItem: FormItem,
	        Form: Form,
	        FieldSet: FieldSet,
	        FilePicker: FilePicker,
	        FitLayout: FitLayout,
	        FlexLayout: FlexLayout,
	        FlowLayout: FlowLayout,
	        FormatControls: FormatControls,
	        GridLayout: GridLayout,
	        Iframe: Iframe,
	        InfoBox: InfoBox,
	        Label: Label,
	        Toolbar: Toolbar,
	        MenuBar: MenuBar,
	        MenuButton: MenuButton,
	        MenuItem: MenuItem,
	        Throbber: Throbber,
	        Menu: Menu,
	        ListBox: ListBox,
	        Radio: Radio,
	        ResizeHandle: ResizeHandle,
	        SelectBox: SelectBox,
	        Slider: Slider,
	        Spacer: Spacer,
	        SplitButton: SplitButton,
	        StackLayout: StackLayout,
	        TabPanel: TabPanel,
	        TextBox: TextBox,
	        DropZone: DropZone,
	        BrowseButton: BrowseButton
	      };
	    };
	
	    var appendTo = function (target) {
	      if (target.ui) {
	        Tools.each(getApi(), function (ref, key) {
	          target.ui[key] = ref;
	        });
	      } else {
	        target.ui = getApi();
	      }
	    };
	
	    var registerToFactory = function () {
	      Tools.each(getApi(), function (ref, key) {
	        Factory.add(key, ref);
	      });
	    };
	
	    var Api = {
	      appendTo: appendTo,
	      registerToFactory: registerToFactory
	    };
	
	    return Api;
	  }
	);
	/**
	 * Theme.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.themes.modern.Theme',
	  [
	    'global!window',
	    'tinymce.core.ThemeManager',
	    'tinymce.themes.modern.api.ThemeApi',
	    'tinymce.ui.Api',
	    'tinymce.ui.FormatControls'
	  ],
	  function (window, ThemeManager, ThemeApi, Api, FormatControls) {
	    Api.registerToFactory();
	    Api.appendTo(window.tinymce ? window.tinymce : {});
	
	    ThemeManager.add('modern', function (editor) {
	      FormatControls.setup(editor);
	      return ThemeApi.get(editor);
	    });
	
	    return function () { };
	  }
	);
	
	dem('tinymce.themes.modern.Theme')();
	})();


/***/ },
/* 2029 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {// 4.7.4 (2017-12-05)
	(function () {
	
	var defs = {}; // id -> {dependencies, definition, instance (possibly undefined)}
	
	// Used when there is no 'main' module.
	// The name is probably (hopefully) unique so minification removes for releases.
	var register_3795 = function (id) {
	  var module = dem(id);
	  var fragments = id.split('.');
	  var target = Function('return this;')();
	  for (var i = 0; i < fragments.length - 1; ++i) {
	    if (target[fragments[i]] === undefined)
	      target[fragments[i]] = {};
	    target = target[fragments[i]];
	  }
	  target[fragments[fragments.length - 1]] = module;
	};
	
	var instantiate = function (id) {
	  var actual = defs[id];
	  var dependencies = actual.deps;
	  var definition = actual.defn;
	  var len = dependencies.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(dependencies[i]);
	  var defResult = definition.apply(null, instances);
	  if (defResult === undefined)
	     throw 'module [' + id + '] returned undefined';
	  actual.instance = defResult;
	};
	
	var def = function (id, dependencies, definition) {
	  if (typeof id !== 'string')
	    throw 'module id must be a string';
	  else if (dependencies === undefined)
	    throw 'no dependencies for ' + id;
	  else if (definition === undefined)
	    throw 'no definition function for ' + id;
	  defs[id] = {
	    deps: dependencies,
	    defn: definition,
	    instance: undefined
	  };
	};
	
	var dem = function (id) {
	  var actual = defs[id];
	  if (actual === undefined)
	    throw 'module [' + id + '] was undefined';
	  else if (actual.instance === undefined)
	    instantiate(id);
	  return actual.instance;
	};
	
	var req = function (ids, callback) {
	  var len = ids.length;
	  var instances = new Array(len);
	  for (var i = 0; i < len; ++i)
	    instances[i] = dem(ids[i]);
	  callback.apply(null, instances);
	};
	
	var ephox = {};
	
	ephox.bolt = {
	  module: {
	    api: {
	      define: def,
	      require: req,
	      demand: dem
	    }
	  }
	};
	
	var define = def;
	var require = req;
	var demand = dem;
	// this helps with minification when using a lot of global references
	var defineGlobal = function (id, ref) {
	  define(id, [], function () { return ref; });
	};
	/*jsc
	["tinymce.core.api.Main","ephox.katamari.api.Fun","global!window","tinymce.core.api.Tinymce","global!Array","global!Error","tinymce.core.AddOnManager","tinymce.core.Editor","tinymce.core.EditorCommands","tinymce.core.EditorManager","tinymce.core.EditorObservable","tinymce.core.Env","tinymce.core.Shortcuts","tinymce.core.UndoManager","tinymce.core.api.FocusManager","tinymce.core.api.Formatter","tinymce.core.api.NotificationManager","tinymce.core.api.WindowManager","tinymce.core.api.dom.BookmarkManager","tinymce.core.api.dom.RangeUtils","tinymce.core.api.dom.Serializer","tinymce.core.dom.ControlSelection","tinymce.core.dom.DOMUtils","tinymce.core.dom.DomQuery","tinymce.core.dom.EventUtils","tinymce.core.dom.ScriptLoader","tinymce.core.dom.Selection","tinymce.core.dom.Sizzle","tinymce.core.dom.TreeWalker","tinymce.core.geom.Rect","tinymce.core.html.DomParser","tinymce.core.html.Entities","tinymce.core.html.Node","tinymce.core.html.SaxParser","tinymce.core.html.Schema","tinymce.core.html.Serializer","tinymce.core.html.Styles","tinymce.core.html.Writer","tinymce.core.ui.Factory","tinymce.core.util.Class","tinymce.core.util.Color","tinymce.core.util.Delay","tinymce.core.util.EventDispatcher","tinymce.core.util.I18n","tinymce.core.util.JSON","tinymce.core.util.JSONP","tinymce.core.util.JSONRequest","tinymce.core.util.LocalStorage","tinymce.core.util.Observable","tinymce.core.util.Promise","tinymce.core.util.Tools","tinymce.core.util.URI","tinymce.core.util.VK","tinymce.core.util.XHR","ephox.katamari.api.Arr","global!document","ephox.sand.api.URL","global!matchMedia","global!navigator","global!clearInterval","global!clearTimeout","global!setInterval","global!setTimeout","tinymce.core.util.Arr","tinymce.core.dom.Position","tinymce.core.dom.StyleSheetLoader","tinymce.core.dom.TrimNode","ephox.sugar.api.node.Element","tinymce.core.InsertContent","tinymce.core.delete.DeleteCommands","tinymce.core.dom.NodeType","tinymce.core.newline.InsertBr","tinymce.core.selection.SelectionBookmark","tinymce.core.EditorSettings","tinymce.core.Mode","tinymce.core.dom.TrimHtml","tinymce.core.focus.EditorFocus","tinymce.core.init.Render","tinymce.core.ui.Sidebar","tinymce.core.util.Uuid","ephox.katamari.api.Type","tinymce.core.ErrorReporter","tinymce.core.focus.FocusController","tinymce.core.dom.GetBookmark","tinymce.core.undo.Levels","ephox.katamari.api.Cell","tinymce.core.fmt.ApplyFormat","tinymce.core.fmt.CaretFormat","tinymce.core.fmt.FormatChanged","tinymce.core.fmt.FormatRegistry","tinymce.core.fmt.MatchFormat","tinymce.core.fmt.Preview","tinymce.core.fmt.RemoveFormat","tinymce.core.fmt.ToggleFormat","tinymce.core.keyboard.FormatShortcuts","ephox.katamari.api.Option","tinymce.core.EditorView","tinymce.core.ui.NotificationManagerImpl","tinymce.core.ui.WindowManagerImpl","tinymce.core.dom.Bookmarks","tinymce.core.selection.CaretRangeFromPoint","tinymce.core.selection.NormalizeRange","tinymce.core.selection.RangeCompare","tinymce.core.selection.RangeNodes","tinymce.core.selection.RangeWalk","tinymce.core.selection.SplitRange","tinymce.core.dom.DomSerializer","ephox.sugar.api.search.Selectors","tinymce.core.dom.RangePoint","ephox.sugar.api.dom.Compare","tinymce.core.caret.CaretPosition","tinymce.core.dom.ScrollIntoView","tinymce.core.selection.EventProcessRanges","tinymce.core.selection.GetSelectionContent","tinymce.core.selection.MultiRange","tinymce.core.selection.SetSelectionContent","tinymce.core.html.LegacyFilter","ephox.sand.api.XMLHttpRequest","global!Object","global!String","ephox.sand.util.Global","ephox.sand.api.PlatformDetection","global!console","ephox.sugar.api.node.Node","ephox.sugar.api.properties.Css","ephox.sugar.api.search.Traverse","ephox.katamari.api.Future","ephox.katamari.api.Futures","ephox.katamari.api.Result","tinymce.core.dom.ElementType","tinymce.core.InsertList","tinymce.core.caret.CaretCandidate","tinymce.core.geom.ClientRect","tinymce.core.text.ExtendingChar","tinymce.core.util.Fun","tinymce.core.caret.CaretWalker","tinymce.core.dom.ElementUtils","tinymce.core.dom.PaddingBr","tinymce.core.selection.RangeNormalizer","tinymce.core.delete.BlockBoundaryDelete","tinymce.core.delete.BlockRangeDelete","tinymce.core.delete.CefDelete","tinymce.core.delete.DeleteUtils","tinymce.core.delete.InlineBoundaryDelete","tinymce.core.delete.TableDelete","ephox.sugar.api.dom.Insert","tinymce.core.caret.CaretFinder","tinymce.core.keyboard.BoundaryLocation","tinymce.core.keyboard.InlineUtils","ephox.katamari.api.Struct","tinymce.core.caret.CaretContainer","ephox.sugar.api.dom.Remove","ephox.sugar.api.properties.Attr","tinymce.core.fmt.ExpandRange","tinymce.core.fmt.FormatUtils","tinymce.core.text.Zwsp","ephox.sand.api.Node","ephox.sugar.api.node.NodeTypes","ephox.sugar.api.node.Text","ephox.sugar.api.selection.Selection","ephox.katamari.api.Obj","ephox.katamari.api.Strings","ephox.sugar.api.dom.Focus","tinymce.core.init.Init","tinymce.core.PluginManager","tinymce.core.ThemeManager","tinymce.core.selection.SelectionRestore","tinymce.core.caret.CaretBookmark","tinymce.core.undo.Fragments","tinymce.core.dom.ResolveBookmark","tinymce.core.fmt.Hooks","tinymce.core.fmt.MergeFormats","tinymce.core.fmt.DefaultFormats","ephox.katamari.api.Merger","tinymce.core.api.Events","tinymce.core.dom.DomSerializerFilters","tinymce.core.dom.DomSerializerPreProcess","tinymce.core.selection.FragmentReader","ephox.katamari.api.Resolve","ephox.katamari.api.Thunk","ephox.sand.core.PlatformDetection","ephox.sugar.api.node.Body","ephox.sugar.impl.Style","ephox.katamari.str.StrAppend","ephox.katamari.str.StringParts","ephox.katamari.data.Immutable","ephox.katamari.data.MixedBag","ephox.sugar.alien.Recurse","ephox.katamari.api.LazyValue","ephox.katamari.async.Bounce","ephox.katamari.async.AsyncValues","tinymce.core.caret.CaretUtils","ephox.katamari.api.Options","ephox.sugar.api.dom.InsertAll","ephox.sugar.impl.NodeValue","ephox.sugar.api.search.SelectorFilter","tinymce.core.delete.BlockBoundary","tinymce.core.delete.MergeBlocks","ephox.sugar.api.search.PredicateFind","tinymce.core.text.Bidi","tinymce.core.delete.CefDeleteAction","tinymce.core.delete.DeleteElement","tinymce.core.keyboard.BoundaryCaret","ephox.katamari.api.Adt","tinymce.core.util.LazyEvaluator","tinymce.core.keyboard.BoundarySelection","tinymce.core.delete.TableDeleteAction","tinymce.core.dom.Empty","tinymce.core.dom.Parents","tinymce.core.selection.TableCellSelection","ephox.sugar.api.selection.Situ","ephox.sugar.api.search.PredicateExists","tinymce.core.init.InitContentBody","tinymce.core.init.InitIframe","ephox.katamari.api.Throttler","tinymce.core.undo.Diff","ephox.sugar.api.dom.Replication","ephox.sugar.api.node.Fragment","ephox.sugar.api.search.SelectorFind","tinymce.core.selection.SelectionUtils","tinymce.core.selection.SimpleTableModel","ephox.katamari.api.Global","ephox.sand.core.Browser","ephox.sand.core.OperatingSystem","ephox.sand.detect.DeviceType","ephox.sand.detect.UaString","ephox.sand.info.PlatformInfo","ephox.katamari.util.BagUtils","ephox.sugar.api.search.PredicateFilter","ephox.sugar.impl.ClosestOrAncestor","ephox.sugar.api.search.SelectorExists","tinymce.core.caret.CaretContainerInline","tinymce.core.caret.CaretContainerRemove","tinymce.core.selection.WordSelection","tinymce.core.EditorUpload","tinymce.core.ForceBlocks","tinymce.core.NodeChange","tinymce.core.SelectionOverrides","tinymce.core.caret.CaretContainerInput","tinymce.core.keyboard.KeyboardOverrides","tinymce.core.util.Quirks","tinymce.core.api.Settings","ephox.sand.detect.Version","tinymce.core.file.Uploader","tinymce.core.file.ImageScanner","tinymce.core.file.BlobCache","tinymce.core.file.UploadStatus","tinymce.core.DragDropOverrides","tinymce.core.caret.FakeCaret","tinymce.core.caret.LineUtils","tinymce.core.focus.CefFocus","tinymce.core.keyboard.CefUtils","tinymce.core.keyboard.ArrowKeys","tinymce.core.keyboard.DeleteBackspaceKeys","tinymce.core.keyboard.EnterKey","tinymce.core.keyboard.SpaceKey","global!Number","tinymce.core.file.Conversions","tinymce.core.dom.MousePosition","tinymce.core.dom.Dimensions","tinymce.core.keyboard.CefNavigation","tinymce.core.keyboard.MatchKeys","tinymce.core.delete.InlineFormatDelete","tinymce.core.newline.InsertNewLine","tinymce.core.keyboard.InsertSpace","ephox.sand.api.Blob","ephox.sand.api.FileReader","ephox.sand.api.Uint8Array","ephox.sand.api.Window","tinymce.core.caret.LineWalker","tinymce.core.newline.InsertBlock","tinymce.core.newline.NewLineAction","tinymce.core.newline.InsertLi","tinymce.core.newline.NewLineUtils","tinymce.core.newline.ContextSelectors"]
	jsc*/
	defineGlobal("global!Array", Array);
	defineGlobal("global!Error", Error);
	define(
	  'ephox.katamari.api.Fun',
	
	  [
	    'global!Array',
	    'global!Error'
	  ],
	
	  function (Array, Error) {
	
	    var noop = function () { };
	
	    var noarg = function (f) {
	      return function () {
	        return f();
	      };
	    };
	
	    var compose = function (fa, fb) {
	      return function () {
	        return fa(fb.apply(null, arguments));
	      };
	    };
	
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	
	    var identity = function (x) {
	      return x;
	    };
	
	    var tripleEquals = function(a, b) {
	      return a === b;
	    };
	
	    // Don't use array slice(arguments), makes the whole function unoptimisable on Chrome
	    var curry = function (f) {
	      // equivalent to arguments.slice(1)
	      // starting at 1 because 0 is the f, makes things tricky.
	      // Pay attention to what variable is where, and the -1 magic.
	      // thankfully, we have tests for this.
	      var args = new Array(arguments.length - 1);
	      for (var i = 1; i < arguments.length; i++) args[i-1] = arguments[i];
	
	      return function () {
	        var newArgs = new Array(arguments.length);
	        for (var j = 0; j < newArgs.length; j++) newArgs[j] = arguments[j];
	
	        var all = args.concat(newArgs);
	        return f.apply(null, all);
	      };
	    };
	
	    var not = function (f) {
	      return function () {
	        return !f.apply(null, arguments);
	      };
	    };
	
	    var die = function (msg) {
	      return function () {
	        throw new Error(msg);
	      };
	    };
	
	    var apply = function (f) {
	      return f();
	    };
	
	    var call = function(f) {
	      f();
	    };
	
	    var never = constant(false);
	    var always = constant(true);
	
	
	    return {
	      noop: noop,
	      noarg: noarg,
	      compose: compose,
	      constant: constant,
	      identity: identity,
	      tripleEquals: tripleEquals,
	      curry: curry,
	      not: not,
	      die: die,
	      apply: apply,
	      call: call,
	      never: never,
	      always: always
	    };
	  }
	);
	
	defineGlobal("global!window", window);
	defineGlobal("global!Object", Object);
	define(
	  'ephox.katamari.api.Option',
	
	  [
	    'ephox.katamari.api.Fun',
	    'global!Object'
	  ],
	
	  function (Fun, Object) {
	
	    var never = Fun.never;
	    var always = Fun.always;
	
	    /**
	      Option objects support the following methods:
	
	      fold :: this Option a -> ((() -> b, a -> b)) -> Option b
	
	      is :: this Option a -> a -> Boolean
	
	      isSome :: this Option a -> () -> Boolean
	
	      isNone :: this Option a -> () -> Boolean
	
	      getOr :: this Option a -> a -> a
	
	      getOrThunk :: this Option a -> (() -> a) -> a
	
	      getOrDie :: this Option a -> String -> a
	
	      or :: this Option a -> Option a -> Option a
	        - if some: return self
	        - if none: return opt
	
	      orThunk :: this Option a -> (() -> Option a) -> Option a
	        - Same as "or", but uses a thunk instead of a value
	
	      map :: this Option a -> (a -> b) -> Option b
	        - "fmap" operation on the Option Functor.
	        - same as 'each'
	
	      ap :: this Option a -> Option (a -> b) -> Option b
	        - "apply" operation on the Option Apply/Applicative.
	        - Equivalent to <*> in Haskell/PureScript.
	
	      each :: this Option a -> (a -> b) -> undefined
	        - similar to 'map', but doesn't return a value.
	        - intended for clarity when performing side effects.
	
	      bind :: this Option a -> (a -> Option b) -> Option b
	        - "bind"/"flatMap" operation on the Option Bind/Monad.
	        - Equivalent to >>= in Haskell/PureScript; flatMap in Scala.
	
	      flatten :: {this Option (Option a))} -> () -> Option a
	        - "flatten"/"join" operation on the Option Monad.
	
	      exists :: this Option a -> (a -> Boolean) -> Boolean
	
	      forall :: this Option a -> (a -> Boolean) -> Boolean
	
	      filter :: this Option a -> (a -> Boolean) -> Option a
	
	      equals :: this Option a -> Option a -> Boolean
	
	      equals_ :: this Option a -> (Option a, a -> Boolean) -> Boolean
	
	      toArray :: this Option a -> () -> [a]
	
	    */
	
	    var none = function () { return NONE; };
	
	    var NONE = (function () {
	      var eq = function (o) {
	        return o.isNone();
	      };
	
	      // inlined from peanut, maybe a micro-optimisation?
	      var call = function (thunk) { return thunk(); };
	      var id = function (n) { return n; };
	      var noop = function () { };
	
	      var me = {
	        fold: function (n, s) { return n(); },
	        is: never,
	        isSome: never,
	        isNone: always,
	        getOr: id,
	        getOrThunk: call,
	        getOrDie: function (msg) {
	          throw new Error(msg || 'error: getOrDie called on none.');
	        },
	        or: id,
	        orThunk: call,
	        map: none,
	        ap: none,
	        each: noop,
	        bind: none,
	        flatten: none,
	        exists: never,
	        forall: always,
	        filter: none,
	        equals: eq,
	        equals_: eq,
	        toArray: function () { return []; },
	        toString: Fun.constant("none()")
	      };
	      if (Object.freeze) Object.freeze(me);
	      return me;
	    })();
	
	
	    /** some :: a -> Option a */
	    var some = function (a) {
	
	      // inlined from peanut, maybe a micro-optimisation?
	      var constant_a = function () { return a; };
	
	      var self = function () {
	        // can't Fun.constant this one
	        return me;
	      };
	
	      var map = function (f) {
	        return some(f(a));
	      };
	
	      var bind = function (f) {
	        return f(a);
	      };
	
	      var me = {
	        fold: function (n, s) { return s(a); },
	        is: function (v) { return a === v; },
	        isSome: always,
	        isNone: never,
	        getOr: constant_a,
	        getOrThunk: constant_a,
	        getOrDie: constant_a,
	        or: self,
	        orThunk: self,
	        map: map,
	        ap: function (optfab) {
	          return optfab.fold(none, function(fab) {
	            return some(fab(a));
	          });
	        },
	        each: function (f) {
	          f(a);
	        },
	        bind: bind,
	        flatten: constant_a,
	        exists: bind,
	        forall: bind,
	        filter: function (f) {
	          return f(a) ? me : NONE;
	        },
	        equals: function (o) {
	          return o.is(a);
	        },
	        equals_: function (o, elementEq) {
	          return o.fold(
	            never,
	            function (b) { return elementEq(a, b); }
	          );
	        },
	        toArray: function () {
	          return [a];
	        },
	        toString: function () {
	          return 'some(' + a + ')';
	        }
	      };
	      return me;
	    };
	
	    /** from :: undefined|null|a -> Option a */
	    var from = function (value) {
	      return value === null || value === undefined ? NONE : some(value);
	    };
	
	    return {
	      some: some,
	      none: none,
	      from: from
	    };
	  }
	);
	
	defineGlobal("global!String", String);
	define(
	  'ephox.katamari.api.Arr',
	
	  [
	    'ephox.katamari.api.Option',
	    'global!Array',
	    'global!Error',
	    'global!String'
	  ],
	
	  function (Option, Array, Error, String) {
	    // Use the native Array.indexOf if it is available (IE9+) otherwise fall back to manual iteration
	    // https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Global_Objects/Array/indexOf
	    var rawIndexOf = (function () {
	      var pIndexOf = Array.prototype.indexOf;
	
	      var fastIndex = function (xs, x) { return  pIndexOf.call(xs, x); };
	
	      var slowIndex = function(xs, x) { return slowIndexOf(xs, x); };
	
	      return pIndexOf === undefined ? slowIndex : fastIndex;
	    })();
	
	    var indexOf = function (xs, x) {
	      // The rawIndexOf method does not wrap up in an option. This is for performance reasons.
	      var r = rawIndexOf(xs, x);
	      return r === -1 ? Option.none() : Option.some(r);
	    };
	
	    var contains = function (xs, x) {
	      return rawIndexOf(xs, x) > -1;
	    };
	
	    // Using findIndex is likely less optimal in Chrome (dynamic return type instead of bool)
	    // but if we need that micro-optimisation we can inline it later.
	    var exists = function (xs, pred) {
	      return findIndex(xs, pred).isSome();
	    };
	
	    var range = function (num, f) {
	      var r = [];
	      for (var i = 0; i < num; i++) {
	        r.push(f(i));
	      }
	      return r;
	    };
	
	    // It's a total micro optimisation, but these do make some difference.
	    // Particularly for browsers other than Chrome.
	    // - length caching
	    // http://jsperf.com/browser-diet-jquery-each-vs-for-loop/69
	    // - not using push
	    // http://jsperf.com/array-direct-assignment-vs-push/2
	
	    var chunk = function (array, size) {
	      var r = [];
	      for (var i = 0; i < array.length; i += size) {
	        var s = array.slice(i, i + size);
	        r.push(s);
	      }
	      return r;
	    };
	
	    var map = function(xs, f) {
	      // pre-allocating array size when it's guaranteed to be known
	      // http://jsperf.com/push-allocated-vs-dynamic/22
	      var len = xs.length;
	      var r = new Array(len);
	      for (var i = 0; i < len; i++) {
	        var x = xs[i];
	        r[i] = f(x, i, xs);
	      }
	      return r;
	    };
	
	    // Unwound implementing other functions in terms of each.
	    // The code size is roughly the same, and it should allow for better optimisation.
	    var each = function(xs, f) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        f(x, i, xs);
	      }
	    };
	
	    var eachr = function (xs, f) {
	      for (var i = xs.length - 1; i >= 0; i--) {
	        var x = xs[i];
	        f(x, i, xs);
	      }
	    };
	
	    var partition = function(xs, pred) {
	      var pass = [];
	      var fail = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        var arr = pred(x, i, xs) ? pass : fail;
	        arr.push(x);
	      }
	      return { pass: pass, fail: fail };
	    };
	
	    var filter = function(xs, pred) {
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i, xs)) {
	          r.push(x);
	        }
	      }
	      return r;
	    };
	
	    /*
	     * Groups an array into contiguous arrays of like elements. Whether an element is like or not depends on f.
	     *
	     * f is a function that derives a value from an element - e.g. true or false, or a string.
	     * Elements are like if this function generates the same value for them (according to ===).
	     *
	     *
	     * Order of the elements is preserved. Arr.flatten() on the result will return the original list, as with Haskell groupBy function.
	     *  For a good explanation, see the group function (which is a special case of groupBy)
	     *  http://hackage.haskell.org/package/base-4.7.0.0/docs/Data-List.html#v:group
	     */
	    var groupBy = function (xs, f) {
	      if (xs.length === 0) {
	        return [];
	      } else {
	        var wasType = f(xs[0]); // initial case for matching
	        var r = [];
	        var group = [];
	
	        for (var i = 0, len = xs.length; i < len; i++) {
	          var x = xs[i];
	          var type = f(x);
	          if (type !== wasType) {
	            r.push(group);
	            group = [];
	          }
	          wasType = type;
	          group.push(x);
	        }
	        if (group.length !== 0) {
	          r.push(group);
	        }
	        return r;
	      }
	    };
	
	    var foldr = function (xs, f, acc) {
	      eachr(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	
	    var foldl = function (xs, f, acc) {
	      each(xs, function (x) {
	        acc = f(acc, x);
	      });
	      return acc;
	    };
	
	    var find = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i, xs)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	
	    var findIndex = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        if (pred(x, i, xs)) {
	          return Option.some(i);
	        }
	      }
	
	      return Option.none();
	    };
	
	    var slowIndexOf = function (xs, x) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        if (xs[i] === x) {
	          return i;
	        }
	      }
	
	      return -1;
	    };
	
	    var push = Array.prototype.push;
	    var flatten = function (xs) {
	      // Note, this is possible because push supports multiple arguments:
	      // http://jsperf.com/concat-push/6
	      // Note that in the past, concat() would silently work (very slowly) for array-like objects.
	      // With this change it will throw an error.
	      var r = [];
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        // Ensure that each value is an array itself
	        if (! Array.prototype.isPrototypeOf(xs[i])) throw new Error('Arr.flatten item ' + i + ' was not an array, input: ' + xs);
	        push.apply(r, xs[i]);
	      }
	      return r;
	    };
	
	    var bind = function (xs, f) {
	      var output = map(xs, f);
	      return flatten(output);
	    };
	
	    var forall = function (xs, pred) {
	      for (var i = 0, len = xs.length; i < len; ++i) {
	        var x = xs[i];
	        if (pred(x, i, xs) !== true) {
	          return false;
	        }
	      }
	      return true;
	    };
	
	    var equal = function (a1, a2) {
	      return a1.length === a2.length && forall(a1, function (x, i) {
	        return x === a2[i];
	      });
	    };
	
	    var slice = Array.prototype.slice;
	    var reverse = function (xs) {
	      var r = slice.call(xs, 0);
	      r.reverse();
	      return r;
	    };
	
	    var difference = function (a1, a2) {
	      return filter(a1, function (x) {
	        return !contains(a2, x);
	      });
	    };
	
	    var mapToObject = function(xs, f) {
	      var r = {};
	      for (var i = 0, len = xs.length; i < len; i++) {
	        var x = xs[i];
	        r[String(x)] = f(x, i);
	      }
	      return r;
	    };
	
	    var pure = function(x) {
	      return [x];
	    };
	
	    var sort = function (xs, comparator) {
	      var copy = slice.call(xs, 0);
	      copy.sort(comparator);
	      return copy;
	    };
	
	    var head = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[0]);
	    };
	
	    var last = function (xs) {
	      return xs.length === 0 ? Option.none() : Option.some(xs[xs.length - 1]);
	    };
	
	    return {
	      map: map,
	      each: each,
	      eachr: eachr,
	      partition: partition,
	      filter: filter,
	      groupBy: groupBy,
	      indexOf: indexOf,
	      foldr: foldr,
	      foldl: foldl,
	      find: find,
	      findIndex: findIndex,
	      flatten: flatten,
	      bind: bind,
	      forall: forall,
	      exists: exists,
	      contains: contains,
	      equal: equal,
	      reverse: reverse,
	      chunk: chunk,
	      difference: difference,
	      mapToObject: mapToObject,
	      pure: pure,
	      sort: sort,
	      range: range,
	      head: head,
	      last: last
	    };
	  }
	);
	defineGlobal("global!document", document);
	define(
	  'ephox.katamari.api.Global',
	
	  [
	  ],
	
	  function () {
	    // Use window object as the global if it's available since CSP will block script evals
	    var global = typeof window !== 'undefined' ? window : Function('return this;')();
	    return global;
	  }
	);
	
	
	define(
	  'ephox.katamari.api.Resolve',
	
	  [
	    'ephox.katamari.api.Global'
	  ],
	
	  function (Global) {
	    /** path :: ([String], JsObj?) -> JsObj */
	    var path = function (parts, scope) {
	      var o = scope !== undefined ? scope : Global;
	      for (var i = 0; i < parts.length && o !== undefined && o !== null; ++i)
	        o = o[parts[i]];
	      return o;
	    };
	
	    /** resolve :: (String, JsObj?) -> JsObj */
	    var resolve = function (p, scope) {
	      var parts = p.split('.');
	      return path(parts, scope);
	    };
	
	    /** step :: (JsObj, String) -> JsObj */
	    var step = function (o, part) {
	      if (o[part] === undefined || o[part] === null)
	        o[part] = {};
	      return o[part];
	    };
	
	    /** forge :: ([String], JsObj?) -> JsObj */
	    var forge = function (parts, target) {
	      var o = target !== undefined ? target : Global;      
	      for (var i = 0; i < parts.length; ++i)
	        o = step(o, parts[i]);
	      return o;
	    };
	
	    /** namespace :: (String, JsObj?) -> JsObj */
	    var namespace = function (name, target) {
	      var parts = name.split('.');
	      return forge(parts, target);
	    };
	
	    return {
	      path: path,
	      resolve: resolve,
	      forge: forge,
	      namespace: namespace
	    };
	  }
	);
	
	
	define(
	  'ephox.sand.util.Global',
	
	  [
	    'ephox.katamari.api.Resolve'
	  ],
	
	  function (Resolve) {
	    var unsafe = function (name, scope) {
	      return Resolve.resolve(name, scope);
	    };
	
	    var getOrDie = function (name, scope) {
	      var actual = unsafe(name, scope);
	
	      if (actual === undefined) throw name + ' not available on this browser';
	      return actual;
	    };
	
	    return {
	      getOrDie: getOrDie
	    };
	  }
	);
	define(
	  'ephox.sand.api.URL',
	
	  [
	    'ephox.sand.util.Global'
	  ],
	
	  function (Global) {
	    /*
	     * IE10 and above per
	     * https://developer.mozilla.org/en-US/docs/Web/API/URL.createObjectURL
	     *
	     * Also Safari 6.1+
	     * Safari 6.0 has 'webkitURL' instead, but doesn't support flexbox so we
	     * aren't supporting it anyway
	     */
	    var url = function () {
	      return Global.getOrDie('URL');
	    };
	
	    var createObjectURL = function (blob) {
	      return url().createObjectURL(blob);
	    };
	
	    var revokeObjectURL = function (u) {
	      url().revokeObjectURL(u);
	    };
	
	    return {
	      createObjectURL: createObjectURL,
	      revokeObjectURL: revokeObjectURL
	    };
	  }
	);
	defineGlobal("global!matchMedia", matchMedia);
	defineGlobal("global!navigator", navigator);
	/**
	 * Env.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains various environment constants like browser versions etc.
	 * Normally you don't want to sniff specific browser versions but sometimes you have
	 * to when it's impossible to feature detect. So use this with care.
	 *
	 * @class tinymce.Env
	 * @static
	 */
	define(
	  'tinymce.core.Env',
	  [
	    'ephox.sand.api.URL',
	    'global!document',
	    'global!matchMedia',
	    'global!navigator',
	    'global!window'
	  ],
	  function (URL, document, matchMedia, navigator, window) {
	    var nav = navigator, userAgent = nav.userAgent;
	    var opera, webkit, ie, ie11, ie12, gecko, mac, iDevice, android, fileApi, phone, tablet, windowsPhone;
	
	    var matchMediaQuery = function (query) {
	      return "matchMedia" in window ? matchMedia(query).matches : false;
	    };
	
	    opera = window.opera && window.opera.buildNumber;
	    android = /Android/.test(userAgent);
	    webkit = /WebKit/.test(userAgent);
	    ie = !webkit && !opera && (/MSIE/gi).test(userAgent) && (/Explorer/gi).test(nav.appName);
	    ie = ie && /MSIE (\w+)\./.exec(userAgent)[1];
	    ie11 = userAgent.indexOf('Trident/') != -1 && (userAgent.indexOf('rv:') != -1 || nav.appName.indexOf('Netscape') != -1) ? 11 : false;
	    ie12 = (userAgent.indexOf('Edge/') != -1 && !ie && !ie11) ? 12 : false;
	    ie = ie || ie11 || ie12;
	    gecko = !webkit && !ie11 && /Gecko/.test(userAgent);
	    mac = userAgent.indexOf('Mac') != -1;
	    iDevice = /(iPad|iPhone)/.test(userAgent);
	    fileApi = "FormData" in window && "FileReader" in window && "URL" in window && !!URL.createObjectURL;
	    phone = matchMediaQuery("only screen and (max-device-width: 480px)") && (android || iDevice);
	    tablet = matchMediaQuery("only screen and (min-width: 800px)") && (android || iDevice);
	    windowsPhone = userAgent.indexOf('Windows Phone') != -1;
	
	    if (ie12) {
	      webkit = false;
	    }
	
	    // Is a iPad/iPhone and not on iOS5 sniff the WebKit version since older iOS WebKit versions
	    // says it has contentEditable support but there is no visible caret.
	    var contentEditable = !iDevice || fileApi || userAgent.match(/AppleWebKit\/(\d*)/)[1] >= 534;
	
	    return {
	      /**
	       * Constant that is true if the browser is Opera.
	       *
	       * @property opera
	       * @type Boolean
	       * @final
	       */
	      opera: opera,
	
	      /**
	       * Constant that is true if the browser is WebKit (Safari/Chrome).
	       *
	       * @property webKit
	       * @type Boolean
	       * @final
	       */
	      webkit: webkit,
	
	      /**
	       * Constant that is more than zero if the browser is IE.
	       *
	       * @property ie
	       * @type Boolean
	       * @final
	       */
	      ie: ie,
	
	      /**
	       * Constant that is true if the browser is Gecko.
	       *
	       * @property gecko
	       * @type Boolean
	       * @final
	       */
	      gecko: gecko,
	
	      /**
	       * Constant that is true if the os is Mac OS.
	       *
	       * @property mac
	       * @type Boolean
	       * @final
	       */
	      mac: mac,
	
	      /**
	       * Constant that is true if the os is iOS.
	       *
	       * @property iOS
	       * @type Boolean
	       * @final
	       */
	      iOS: iDevice,
	
	      /**
	       * Constant that is true if the os is android.
	       *
	       * @property android
	       * @type Boolean
	       * @final
	       */
	      android: android,
	
	      /**
	       * Constant that is true if the browser supports editing.
	       *
	       * @property contentEditable
	       * @type Boolean
	       * @final
	       */
	      contentEditable: contentEditable,
	
	      /**
	       * Transparent image data url.
	       *
	       * @property transparentSrc
	       * @type Boolean
	       * @final
	       */
	      transparentSrc: "data:image/gif;base64,R0lGODlhAQABAIAAAAAAAP///yH5BAEAAAAALAAAAAABAAEAAAIBRAA7",
	
	      /**
	       * Returns true/false if the browser can or can't place the caret after a inline block like an image.
	       *
	       * @property noCaretAfter
	       * @type Boolean
	       * @final
	       */
	      caretAfter: ie != 8,
	
	      /**
	       * Constant that is true if the browser supports native DOM Ranges. IE 9+.
	       *
	       * @property range
	       * @type Boolean
	       */
	      range: window.getSelection && "Range" in window,
	
	      /**
	       * Returns the IE document mode for non IE browsers this will fake IE 10.
	       *
	       * @property documentMode
	       * @type Number
	       */
	      documentMode: ie && !ie12 ? (document.documentMode || 7) : 10,
	
	      /**
	       * Constant that is true if the browser has a modern file api.
	       *
	       * @property fileApi
	       * @type Boolean
	       */
	      fileApi: fileApi,
	
	      /**
	       * Constant that is true if the browser supports contentEditable=false regions.
	       *
	       * @property ceFalse
	       * @type Boolean
	       */
	      ceFalse: (ie === false || ie > 8),
	
	      /**
	       * Constant if CSP mode is possible or not. Meaning we can't use script urls for the iframe.
	       */
	      canHaveCSP: (ie === false || ie > 11),
	
	      desktop: !phone && !tablet,
	      windowsPhone: windowsPhone
	    };
	  }
	);
	
	defineGlobal("global!clearInterval", clearInterval);
	defineGlobal("global!clearTimeout", clearTimeout);
	defineGlobal("global!setInterval", setInterval);
	defineGlobal("global!setTimeout", setTimeout);
	/**
	 * Promise.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * Promise polyfill under MIT license: https://github.com/taylorhakes/promise-polyfill
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/* eslint-disable */
	/* jshint ignore:start */
	
	/**
	 * Modifed to be a feature fill and wrapped as tinymce module.
	 */
	define(
	  'tinymce.core.util.Promise',
	  [],
	  function () {
	    if (window.Promise) {
	      return window.Promise;
	    }
	
	    // Use polyfill for setImmediate for performance gains
	    var asap = Promise.immediateFn || (typeof setImmediate === 'function' && setImmediate) ||
	      function (fn) { setTimeout(fn, 1); };
	
	    // Polyfill for Function.prototype.bind
	    function bind(fn, thisArg) {
	      return function () {
	        fn.apply(thisArg, arguments);
	      };
	    }
	
	    var isArray = Array.isArray || function (value) { return Object.prototype.toString.call(value) === "[object Array]"; };
	
	    function Promise(fn) {
	      if (typeof this !== 'object') throw new TypeError('Promises must be constructed via new');
	      if (typeof fn !== 'function') throw new TypeError('not a function');
	      this._state = null;
	      this._value = null;
	      this._deferreds = [];
	
	      doResolve(fn, bind(resolve, this), bind(reject, this));
	    }
	
	    function handle(deferred) {
	      var me = this;
	      if (this._state === null) {
	        this._deferreds.push(deferred);
	        return;
	      }
	      asap(function () {
	        var cb = me._state ? deferred.onFulfilled : deferred.onRejected;
	        if (cb === null) {
	          (me._state ? deferred.resolve : deferred.reject)(me._value);
	          return;
	        }
	        var ret;
	        try {
	          ret = cb(me._value);
	        }
	        catch (e) {
	          deferred.reject(e);
	          return;
	        }
	        deferred.resolve(ret);
	      });
	    }
	
	    function resolve(newValue) {
	      try { //Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	        if (newValue === this) throw new TypeError('A promise cannot be resolved with itself.');
	        if (newValue && (typeof newValue === 'object' || typeof newValue === 'function')) {
	          var then = newValue.then;
	          if (typeof then === 'function') {
	            doResolve(bind(then, newValue), bind(resolve, this), bind(reject, this));
	            return;
	          }
	        }
	        this._state = true;
	        this._value = newValue;
	        finale.call(this);
	      } catch (e) { reject.call(this, e); }
	    }
	
	    function reject(newValue) {
	      this._state = false;
	      this._value = newValue;
	      finale.call(this);
	    }
	
	    function finale() {
	      for (var i = 0, len = this._deferreds.length; i < len; i++) {
	        handle.call(this, this._deferreds[i]);
	      }
	      this._deferreds = null;
	    }
	
	    function Handler(onFulfilled, onRejected, resolve, reject) {
	      this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	      this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	      this.resolve = resolve;
	      this.reject = reject;
	    }
	
	    /**
	     * Take a potentially misbehaving resolver function and make sure
	     * onFulfilled and onRejected are only called once.
	     *
	     * Makes no guarantees about asynchrony.
	     */
	    function doResolve(fn, onFulfilled, onRejected) {
	      var done = false;
	      try {
	        fn(function (value) {
	          if (done) return;
	          done = true;
	          onFulfilled(value);
	        }, function (reason) {
	          if (done) return;
	          done = true;
	          onRejected(reason);
	        });
	      } catch (ex) {
	        if (done) return;
	        done = true;
	        onRejected(ex);
	      }
	    }
	
	    Promise.prototype['catch'] = function (onRejected) {
	      return this.then(null, onRejected);
	    };
	
	    Promise.prototype.then = function (onFulfilled, onRejected) {
	      var me = this;
	      return new Promise(function (resolve, reject) {
	        handle.call(me, new Handler(onFulfilled, onRejected, resolve, reject));
	      });
	    };
	
	    Promise.all = function () {
	      var args = Array.prototype.slice.call(arguments.length === 1 && isArray(arguments[0]) ? arguments[0] : arguments);
	
	      return new Promise(function (resolve, reject) {
	        if (args.length === 0) return resolve([]);
	        var remaining = args.length;
	        function res(i, val) {
	          try {
	            if (val && (typeof val === 'object' || typeof val === 'function')) {
	              var then = val.then;
	              if (typeof then === 'function') {
	                then.call(val, function (val) { res(i, val); }, reject);
	                return;
	              }
	            }
	            args[i] = val;
	            if (--remaining === 0) {
	              resolve(args);
	            }
	          } catch (ex) {
	            reject(ex);
	          }
	        }
	        for (var i = 0; i < args.length; i++) {
	          res(i, args[i]);
	        }
	      });
	    };
	
	    Promise.resolve = function (value) {
	      if (value && typeof value === 'object' && value.constructor === Promise) {
	        return value;
	      }
	
	      return new Promise(function (resolve) {
	        resolve(value);
	      });
	    };
	
	    Promise.reject = function (value) {
	      return new Promise(function (resolve, reject) {
	        reject(value);
	      });
	    };
	
	    Promise.race = function (values) {
	      return new Promise(function (resolve, reject) {
	        for (var i = 0, len = values.length; i < len; i++) {
	          values[i].then(resolve, reject);
	        }
	      });
	    };
	
	    return Promise;
	  }
	);
	
	/* jshint ignore:end */
	/* eslint-enable */
	/**
	 * Delay.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility class for working with delayed actions like setTimeout.
	 *
	 * @class tinymce.util.Delay
	 */
	define(
	  'tinymce.core.util.Delay',
	  [
	    'global!clearInterval',
	    'global!clearTimeout',
	    'global!document',
	    'global!setInterval',
	    'global!setTimeout',
	    'global!window',
	    'tinymce.core.util.Promise'
	  ],
	  function (clearInterval, clearTimeout, document, setInterval, setTimeout, window, Promise) {
	    var requestAnimationFramePromise;
	
	    var requestAnimationFrame = function (callback, element) {
	      var i, requestAnimationFrameFunc = window.requestAnimationFrame, vendors = ['ms', 'moz', 'webkit'];
	
	      var featurefill = function (callback) {
	        window.setTimeout(callback, 0);
	      };
	
	      for (i = 0; i < vendors.length && !requestAnimationFrameFunc; i++) {
	        requestAnimationFrameFunc = window[vendors[i] + 'RequestAnimationFrame'];
	      }
	
	      if (!requestAnimationFrameFunc) {
	        requestAnimationFrameFunc = featurefill;
	      }
	
	      requestAnimationFrameFunc(callback, element);
	    };
	
	    var wrappedSetTimeout = function (callback, time) {
	      if (typeof time != 'number') {
	        time = 0;
	      }
	
	      return setTimeout(callback, time);
	    };
	
	    var wrappedSetInterval = function (callback, time) {
	      if (typeof time != 'number') {
	        time = 1; // IE 8 needs it to be > 0
	      }
	
	      return setInterval(callback, time);
	    };
	
	    var wrappedClearTimeout = function (id) {
	      return clearTimeout(id);
	    };
	
	    var wrappedClearInterval = function (id) {
	      return clearInterval(id);
	    };
	
	    var debounce = function (callback, time) {
	      var timer, func;
	
	      func = function () {
	        var args = arguments;
	
	        clearTimeout(timer);
	
	        timer = wrappedSetTimeout(function () {
	          callback.apply(this, args);
	        }, time);
	      };
	
	      func.stop = function () {
	        clearTimeout(timer);
	      };
	
	      return func;
	    };
	
	    return {
	      /**
	       * Requests an animation frame and fallbacks to a timeout on older browsers.
	       *
	       * @method requestAnimationFrame
	       * @param {function} callback Callback to execute when a new frame is available.
	       * @param {DOMElement} element Optional element to scope it to.
	       */
	      requestAnimationFrame: function (callback, element) {
	        if (requestAnimationFramePromise) {
	          requestAnimationFramePromise.then(callback);
	          return;
	        }
	
	        requestAnimationFramePromise = new Promise(function (resolve) {
	          if (!element) {
	            element = document.body;
	          }
	
	          requestAnimationFrame(resolve, element);
	        }).then(callback);
	      },
	
	      /**
	       * Sets a timer in ms and executes the specified callback when the timer runs out.
	       *
	       * @method setTimeout
	       * @param {function} callback Callback to execute when timer runs out.
	       * @param {Number} time Optional time to wait before the callback is executed, defaults to 0.
	       * @return {Number} Timeout id number.
	       */
	      setTimeout: wrappedSetTimeout,
	
	      /**
	       * Sets an interval timer in ms and executes the specified callback at every interval of that time.
	       *
	       * @method setInterval
	       * @param {function} callback Callback to execute when interval time runs out.
	       * @param {Number} time Optional time to wait before the callback is executed, defaults to 0.
	       * @return {Number} Timeout id number.
	       */
	      setInterval: wrappedSetInterval,
	
	      /**
	       * Sets an editor timeout it's similar to setTimeout except that it checks if the editor instance is
	       * still alive when the callback gets executed.
	       *
	       * @method setEditorTimeout
	       * @param {tinymce.Editor} editor Editor instance to check the removed state on.
	       * @param {function} callback Callback to execute when timer runs out.
	       * @param {Number} time Optional time to wait before the callback is executed, defaults to 0.
	       * @return {Number} Timeout id number.
	       */
	      setEditorTimeout: function (editor, callback, time) {
	        return wrappedSetTimeout(function () {
	          if (!editor.removed) {
	            callback();
	          }
	        }, time);
	      },
	
	      /**
	       * Sets an interval timer it's similar to setInterval except that it checks if the editor instance is
	       * still alive when the callback gets executed.
	       *
	       * @method setEditorInterval
	       * @param {function} callback Callback to execute when interval time runs out.
	       * @param {Number} time Optional time to wait before the callback is executed, defaults to 0.
	       * @return {Number} Timeout id number.
	       */
	      setEditorInterval: function (editor, callback, time) {
	        var timer;
	
	        timer = wrappedSetInterval(function () {
	          if (!editor.removed) {
	            callback();
	          } else {
	            clearInterval(timer);
	          }
	        }, time);
	
	        return timer;
	      },
	
	      /**
	       * Creates debounced callback function that only gets executed once within the specified time.
	       *
	       * @method debounce
	       * @param {function} callback Callback to execute when timer finishes.
	       * @param {Number} time Optional time to wait before the callback is executed, defaults to 0.
	       * @return {Function} debounced function callback.
	       */
	      debounce: debounce,
	
	      // Throttle needs to be debounce due to backwards compatibility.
	      throttle: debounce,
	
	      /**
	       * Clears an interval timer so it won't execute.
	       *
	       * @method clearInterval
	       * @param {Number} Interval timer id number.
	       */
	      clearInterval: wrappedClearInterval,
	
	      /**
	       * Clears an timeout timer so it won't execute.
	       *
	       * @method clearTimeout
	       * @param {Number} Timeout timer id number.
	       */
	      clearTimeout: wrappedClearTimeout
	    };
	  }
	);
	
	/**
	 * EventUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*jshint loopfunc:true*/
	/*eslint no-loop-func:0 */
	
	/**
	 * This class wraps the browsers native event logic with more convenient methods.
	 *
	 * @class tinymce.dom.EventUtils
	 */
	define(
	  'tinymce.core.dom.EventUtils',
	  [
	    'global!document',
	    'global!window',
	    'tinymce.core.Env',
	    'tinymce.core.util.Delay'
	  ],
	  function (document, window, Env, Delay) {
	    "use strict";
	
	    var eventExpandoPrefix = "mce-data-";
	    var mouseEventRe = /^(?:mouse|contextmenu)|click/;
	    var deprecated = {
	      keyLocation: 1, layerX: 1, layerY: 1, returnValue: 1,
	      webkitMovementX: 1, webkitMovementY: 1, keyIdentifier: 1
	    };
	
	    // Checks if it is our own isDefaultPrevented function
	    var hasIsDefaultPrevented = function (event) {
	      return event.isDefaultPrevented === returnTrue || event.isDefaultPrevented === returnFalse;
	    };
	
	    // Dummy function that gets replaced on the delegation state functions
	    var returnFalse = function () {
	      return false;
	    };
	
	    // Dummy function that gets replaced on the delegation state functions
	    var returnTrue = function () {
	      return true;
	    };
	
	    /**
	     * Binds a native event to a callback on the speified target.
	     */
	    var addEvent = function (target, name, callback, capture) {
	      if (target.addEventListener) {
	        target.addEventListener(name, callback, capture || false);
	      } else if (target.attachEvent) {
	        target.attachEvent('on' + name, callback);
	      }
	    };
	
	    /**
	     * Unbinds a native event callback on the specified target.
	     */
	    var removeEvent = function (target, name, callback, capture) {
	      if (target.removeEventListener) {
	        target.removeEventListener(name, callback, capture || false);
	      } else if (target.detachEvent) {
	        target.detachEvent('on' + name, callback);
	      }
	    };
	
	    /**
	     * Gets the event target based on shadow dom properties like path and deepPath.
	     */
	    var getTargetFromShadowDom = function (event, defaultTarget) {
	      var path, target = defaultTarget;
	
	      // When target element is inside Shadow DOM we need to take first element from path
	      // otherwise we'll get Shadow Root parent, not actual target element
	
	      // Normalize target for WebComponents v0 implementation (in Chrome)
	      path = event.path;
	      if (path && path.length > 0) {
	        target = path[0];
	      }
	
	      // Normalize target for WebComponents v1 implementation (standard)
	      if (event.deepPath) {
	        path = event.deepPath();
	        if (path && path.length > 0) {
	          target = path[0];
	        }
	      }
	
	      return target;
	    };
	
	    /**
	     * Normalizes a native event object or just adds the event specific methods on a custom event.
	     */
	    var fix = function (originalEvent, data) {
	      var name, event = data || {}, undef;
	
	      // Copy all properties from the original event
	      for (name in originalEvent) {
	        // layerX/layerY is deprecated in Chrome and produces a warning
	        if (!deprecated[name]) {
	          event[name] = originalEvent[name];
	        }
	      }
	
	      // Normalize target IE uses srcElement
	      if (!event.target) {
	        event.target = event.srcElement || document;
	      }
	
	      // Experimental shadow dom support
	      if (Env.experimentalShadowDom) {
	        event.target = getTargetFromShadowDom(originalEvent, event.target);
	      }
	
	      // Calculate pageX/Y if missing and clientX/Y available
	      if (originalEvent && mouseEventRe.test(originalEvent.type) && originalEvent.pageX === undef && originalEvent.clientX !== undef) {
	        var eventDoc = event.target.ownerDocument || document;
	        var doc = eventDoc.documentElement;
	        var body = eventDoc.body;
	
	        event.pageX = originalEvent.clientX + (doc && doc.scrollLeft || body && body.scrollLeft || 0) -
	          (doc && doc.clientLeft || body && body.clientLeft || 0);
	
	        event.pageY = originalEvent.clientY + (doc && doc.scrollTop || body && body.scrollTop || 0) -
	          (doc && doc.clientTop || body && body.clientTop || 0);
	      }
	
	      // Add preventDefault method
	      event.preventDefault = function () {
	        event.isDefaultPrevented = returnTrue;
	
	        // Execute preventDefault on the original event object
	        if (originalEvent) {
	          if (originalEvent.preventDefault) {
	            originalEvent.preventDefault();
	          } else {
	            originalEvent.returnValue = false; // IE
	          }
	        }
	      };
	
	      // Add stopPropagation
	      event.stopPropagation = function () {
	        event.isPropagationStopped = returnTrue;
	
	        // Execute stopPropagation on the original event object
	        if (originalEvent) {
	          if (originalEvent.stopPropagation) {
	            originalEvent.stopPropagation();
	          } else {
	            originalEvent.cancelBubble = true; // IE
	          }
	        }
	      };
	
	      // Add stopImmediatePropagation
	      event.stopImmediatePropagation = function () {
	        event.isImmediatePropagationStopped = returnTrue;
	        event.stopPropagation();
	      };
	
	      // Add event delegation states
	      if (hasIsDefaultPrevented(event) === false) {
	        event.isDefaultPrevented = returnFalse;
	        event.isPropagationStopped = returnFalse;
	        event.isImmediatePropagationStopped = returnFalse;
	      }
	
	      // Add missing metaKey for IE 8
	      if (typeof event.metaKey == 'undefined') {
	        event.metaKey = false;
	      }
	
	      return event;
	    };
	
	    /**
	     * Bind a DOMContentLoaded event across browsers and executes the callback once the page DOM is initialized.
	     * It will also set/check the domLoaded state of the event_utils instance so ready isn't called multiple times.
	     */
	    var bindOnReady = function (win, callback, eventUtils) {
	      var doc = win.document, event = { type: 'ready' };
	
	      if (eventUtils.domLoaded) {
	        callback(event);
	        return;
	      }
	
	      var isDocReady = function () {
	        // Check complete or interactive state if there is a body
	        // element on some iframes IE 8 will produce a null body
	        return doc.readyState === "complete" || (doc.readyState === "interactive" && doc.body);
	      };
	
	      // Gets called when the DOM is ready
	      var readyHandler = function () {
	        if (!eventUtils.domLoaded) {
	          eventUtils.domLoaded = true;
	          callback(event);
	        }
	      };
	
	      var waitForDomLoaded = function () {
	        if (isDocReady()) {
	          removeEvent(doc, "readystatechange", waitForDomLoaded);
	          readyHandler();
	        }
	      };
	
	      var tryScroll = function () {
	        try {
	          // If IE is used, use the trick by Diego Perini licensed under MIT by request to the author.
	          // http://javascript.nwbox.com/IEContentLoaded/
	          doc.documentElement.doScroll("left");
	        } catch (ex) {
	          Delay.setTimeout(tryScroll);
	          return;
	        }
	
	        readyHandler();
	      };
	
	      // Use W3C method (exclude IE 9,10 - readyState "interactive" became valid only in IE 11)
	      if (doc.addEventListener && !(Env.ie && Env.ie < 11)) {
	        if (isDocReady()) {
	          readyHandler();
	        } else {
	          addEvent(win, 'DOMContentLoaded', readyHandler);
	        }
	      } else {
	        // Use IE method
	        addEvent(doc, "readystatechange", waitForDomLoaded);
	
	        // Wait until we can scroll, when we can the DOM is initialized
	        if (doc.documentElement.doScroll && win.self === win.top) {
	          tryScroll();
	        }
	      }
	
	      // Fallback if any of the above methods should fail for some odd reason
	      addEvent(win, 'load', readyHandler);
	    };
	
	    /**
	     * This class enables you to bind/unbind native events to elements and normalize it's behavior across browsers.
	     */
	    var EventUtils = function () {
	      var self = this, events = {}, count, expando, hasFocusIn, hasMouseEnterLeave, mouseEnterLeave;
	
	      expando = eventExpandoPrefix + (+new Date()).toString(32);
	      hasMouseEnterLeave = "onmouseenter" in document.documentElement;
	      hasFocusIn = "onfocusin" in document.documentElement;
	      mouseEnterLeave = { mouseenter: 'mouseover', mouseleave: 'mouseout' };
	      count = 1;
	
	      // State if the DOMContentLoaded was executed or not
	      self.domLoaded = false;
	      self.events = events;
	
	      /**
	       * Executes all event handler callbacks for a specific event.
	       *
	       * @private
	       * @param {Event} evt Event object.
	       * @param {String} id Expando id value to look for.
	       */
	      var executeHandlers = function (evt, id) {
	        var callbackList, i, l, callback, container = events[id];
	
	        callbackList = container && container[evt.type];
	        if (callbackList) {
	          for (i = 0, l = callbackList.length; i < l; i++) {
	            callback = callbackList[i];
	
	            // Check if callback exists might be removed if a unbind is called inside the callback
	            if (callback && callback.func.call(callback.scope, evt) === false) {
	              evt.preventDefault();
	            }
	
	            // Should we stop propagation to immediate listeners
	            if (evt.isImmediatePropagationStopped()) {
	              return;
	            }
	          }
	        }
	      };
	
	      /**
	       * Binds a callback to an event on the specified target.
	       *
	       * @method bind
	       * @param {Object} target Target node/window or custom object.
	       * @param {String} names Name of the event to bind.
	       * @param {function} callback Callback function to execute when the event occurs.
	       * @param {Object} scope Scope to call the callback function on, defaults to target.
	       * @return {function} Callback function that got bound.
	       */
	      self.bind = function (target, names, callback, scope) {
	        var id, callbackList, i, name, fakeName, nativeHandler, capture, win = window;
	
	        // Native event handler function patches the event and executes the callbacks for the expando
	        var defaultNativeHandler = function (evt) {
	          executeHandlers(fix(evt || win.event), id);
	        };
	
	        // Don't bind to text nodes or comments
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return;
	        }
	
	        // Create or get events id for the target
	        if (!target[expando]) {
	          id = count++;
	          target[expando] = id;
	          events[id] = {};
	        } else {
	          id = target[expando];
	        }
	
	        // Setup the specified scope or use the target as a default
	        scope = scope || target;
	
	        // Split names and bind each event, enables you to bind multiple events with one call
	        names = names.split(' ');
	        i = names.length;
	        while (i--) {
	          name = names[i];
	          nativeHandler = defaultNativeHandler;
	          fakeName = capture = false;
	
	          // Use ready instead of DOMContentLoaded
	          if (name === "DOMContentLoaded") {
	            name = "ready";
	          }
	
	          // DOM is already ready
	          if (self.domLoaded && name === "ready" && target.readyState == 'complete') {
	            callback.call(scope, fix({ type: name }));
	            continue;
	          }
	
	          // Handle mouseenter/mouseleaver
	          if (!hasMouseEnterLeave) {
	            fakeName = mouseEnterLeave[name];
	
	            if (fakeName) {
	              nativeHandler = function (evt) {
	                var current, related;
	
	                current = evt.currentTarget;
	                related = evt.relatedTarget;
	
	                // Check if related is inside the current target if it's not then the event should
	                // be ignored since it's a mouseover/mouseout inside the element
	                if (related && current.contains) {
	                  // Use contains for performance
	                  related = current.contains(related);
	                } else {
	                  while (related && related !== current) {
	                    related = related.parentNode;
	                  }
	                }
	
	                // Fire fake event
	                if (!related) {
	                  evt = fix(evt || win.event);
	                  evt.type = evt.type === 'mouseout' ? 'mouseleave' : 'mouseenter';
	                  evt.target = current;
	                  executeHandlers(evt, id);
	                }
	              };
	            }
	          }
	
	          // Fake bubbling of focusin/focusout
	          if (!hasFocusIn && (name === "focusin" || name === "focusout")) {
	            capture = true;
	            fakeName = name === "focusin" ? "focus" : "blur";
	            nativeHandler = function (evt) {
	              evt = fix(evt || win.event);
	              evt.type = evt.type === 'focus' ? 'focusin' : 'focusout';
	              executeHandlers(evt, id);
	            };
	          }
	
	          // Setup callback list and bind native event
	          callbackList = events[id][name];
	          if (!callbackList) {
	            events[id][name] = callbackList = [{ func: callback, scope: scope }];
	            callbackList.fakeName = fakeName;
	            callbackList.capture = capture;
	            //callbackList.callback = callback;
	
	            // Add the nativeHandler to the callback list so that we can later unbind it
	            callbackList.nativeHandler = nativeHandler;
	
	            // Check if the target has native events support
	
	            if (name === "ready") {
	              bindOnReady(target, nativeHandler, self);
	            } else {
	              addEvent(target, fakeName || name, nativeHandler, capture);
	            }
	          } else {
	            if (name === "ready" && self.domLoaded) {
	              callback({ type: name });
	            } else {
	              // If it already has an native handler then just push the callback
	              callbackList.push({ func: callback, scope: scope });
	            }
	          }
	        }
	
	        target = callbackList = 0; // Clean memory for IE
	
	        return callback;
	      };
	
	      /**
	       * Unbinds the specified event by name, name and callback or all events on the target.
	       *
	       * @method unbind
	       * @param {Object} target Target node/window or custom object.
	       * @param {String} names Optional event name to unbind.
	       * @param {function} callback Optional callback function to unbind.
	       * @return {EventUtils} Event utils instance.
	       */
	      self.unbind = function (target, names, callback) {
	        var id, callbackList, i, ci, name, eventMap;
	
	        // Don't bind to text nodes or comments
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return self;
	        }
	
	        // Unbind event or events if the target has the expando
	        id = target[expando];
	        if (id) {
	          eventMap = events[id];
	
	          // Specific callback
	          if (names) {
	            names = names.split(' ');
	            i = names.length;
	            while (i--) {
	              name = names[i];
	              callbackList = eventMap[name];
	
	              // Unbind the event if it exists in the map
	              if (callbackList) {
	                // Remove specified callback
	                if (callback) {
	                  ci = callbackList.length;
	                  while (ci--) {
	                    if (callbackList[ci].func === callback) {
	                      var nativeHandler = callbackList.nativeHandler;
	                      var fakeName = callbackList.fakeName, capture = callbackList.capture;
	
	                      // Clone callbackList since unbind inside a callback would otherwise break the handlers loop
	                      callbackList = callbackList.slice(0, ci).concat(callbackList.slice(ci + 1));
	                      callbackList.nativeHandler = nativeHandler;
	                      callbackList.fakeName = fakeName;
	                      callbackList.capture = capture;
	
	                      eventMap[name] = callbackList;
	                    }
	                  }
	                }
	
	                // Remove all callbacks if there isn't a specified callback or there is no callbacks left
	                if (!callback || callbackList.length === 0) {
	                  delete eventMap[name];
	                  removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
	                }
	              }
	            }
	          } else {
	            // All events for a specific element
	            for (name in eventMap) {
	              callbackList = eventMap[name];
	              removeEvent(target, callbackList.fakeName || name, callbackList.nativeHandler, callbackList.capture);
	            }
	
	            eventMap = {};
	          }
	
	          // Check if object is empty, if it isn't then we won't remove the expando map
	          for (name in eventMap) {
	            return self;
	          }
	
	          // Delete event object
	          delete events[id];
	
	          // Remove expando from target
	          try {
	            // IE will fail here since it can't delete properties from window
	            delete target[expando];
	          } catch (ex) {
	            // IE will set it to null
	            target[expando] = null;
	          }
	        }
	
	        return self;
	      };
	
	      /**
	       * Fires the specified event on the specified target.
	       *
	       * @method fire
	       * @param {Object} target Target node/window or custom object.
	       * @param {String} name Event name to fire.
	       * @param {Object} args Optional arguments to send to the observers.
	       * @return {EventUtils} Event utils instance.
	       */
	      self.fire = function (target, name, args) {
	        var id;
	
	        // Don't bind to text nodes or comments
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return self;
	        }
	
	        // Build event object by patching the args
	        args = fix(null, args);
	        args.type = name;
	        args.target = target;
	
	        do {
	          // Found an expando that means there is listeners to execute
	          id = target[expando];
	          if (id) {
	            executeHandlers(args, id);
	          }
	
	          // Walk up the DOM
	          target = target.parentNode || target.ownerDocument || target.defaultView || target.parentWindow;
	        } while (target && !args.isPropagationStopped());
	
	        return self;
	      };
	
	      /**
	       * Removes all bound event listeners for the specified target. This will also remove any bound
	       * listeners to child nodes within that target.
	       *
	       * @method clean
	       * @param {Object} target Target node/window object.
	       * @return {EventUtils} Event utils instance.
	       */
	      self.clean = function (target) {
	        var i, children, unbind = self.unbind;
	
	        // Don't bind to text nodes or comments
	        if (!target || target.nodeType === 3 || target.nodeType === 8) {
	          return self;
	        }
	
	        // Unbind any element on the specified target
	        if (target[expando]) {
	          unbind(target);
	        }
	
	        // Target doesn't have getElementsByTagName it's probably a window object then use it's document to find the children
	        if (!target.getElementsByTagName) {
	          target = target.document;
	        }
	
	        // Remove events from each child element
	        if (target && target.getElementsByTagName) {
	          unbind(target);
	
	          children = target.getElementsByTagName('*');
	          i = children.length;
	          while (i--) {
	            target = children[i];
	
	            if (target[expando]) {
	              unbind(target);
	            }
	          }
	        }
	
	        return self;
	      };
	
	      /**
	       * Destroys the event object. Call this on IE to remove memory leaks.
	       */
	      self.destroy = function () {
	        events = {};
	      };
	
	      // Legacy function for canceling events
	      self.cancel = function (e) {
	        if (e) {
	          e.preventDefault();
	          e.stopImmediatePropagation();
	        }
	
	        return false;
	      };
	    };
	
	    EventUtils.Event = new EventUtils();
	    EventUtils.Event.bind(window, 'ready', function () { });
	
	    return EventUtils;
	  }
	);
	
	/**
	 * Sizzle.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 *
	 * @ignore-file
	 *
	 * Forked changes:
	 * - Disabled all assertions since they are only used for non supported browsers and cause dom repaints see #TINY-1141
	 */
	
	/*jshint bitwise:false, expr:true, noempty:false, sub:true, eqnull:true, latedef:false, maxlen:255 */
	/*eslint-disable */
	
	/**
	 * Sizzle CSS Selector Engine v@VERSION
	 * http://sizzlejs.com/
	 *
	 * Copyright 2008, 2014 jQuery Foundation, Inc. and other contributors
	 * Released under the MIT license
	 * http://jquery.org/license
	 *
	 * Date: @DATE
	 */
	define(
	  'tinymce.core.dom.Sizzle',
	  [],
	  function () {
	    var i,
	      support,
	      Expr,
	      getText,
	      isXML,
	      tokenize,
	      compile,
	      select,
	      outermostContext,
	      sortInput,
	      hasDuplicate,
	
	      // Local document vars
	      setDocument,
	      document,
	      docElem,
	      documentIsHTML,
	      rbuggyQSA,
	      rbuggyMatches,
	      matches,
	      contains,
	
	      // Instance-specific data
	      expando = "sizzle" + -(new Date()),
	      preferredDoc = window.document,
	      dirruns = 0,
	      done = 0,
	      classCache = createCache(),
	      tokenCache = createCache(),
	      compilerCache = createCache(),
	      sortOrder = function (a, b) {
	        if (a === b) {
	          hasDuplicate = true;
	        }
	        return 0;
	      },
	
	      // General-purpose constants
	      strundefined = typeof undefined,
	      MAX_NEGATIVE = 1 << 31,
	
	      // Instance methods
	      hasOwn = ({}).hasOwnProperty,
	      arr = [],
	      pop = arr.pop,
	      push_native = arr.push,
	      push = arr.push,
	      slice = arr.slice,
	      // Use a stripped-down indexOf if we can't use a native one
	      indexOf = arr.indexOf || function (elem) {
	        var i = 0,
	          len = this.length;
	        for (; i < len; i++) {
	          if (this[i] === elem) {
	            return i;
	          }
	        }
	        return -1;
	      },
	
	      booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|loop|multiple|open|readonly|required|scoped",
	
	      // Regular expressions
	
	      // http://www.w3.org/TR/css3-selectors/#whitespace
	      whitespace = "[\\x20\\t\\r\\n\\f]",
	
	      // http://www.w3.org/TR/CSS21/syndata.html#value-def-identifier
	      identifier = "(?:\\\\.|[\\w-]|[^\\x00-\\xa0])+",
	
	      // Attribute selectors: http://www.w3.org/TR/selectors/#attribute-selectors
	      attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
	        // Operator (capture 2)
	        "*([*^$|!~]?=)" + whitespace +
	        // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
	        "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace +
	        "*\\]",
	
	      pseudos = ":(" + identifier + ")(?:\\((" +
	        // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
	        // 1. quoted (capture 3; capture 4 or capture 5)
	        "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
	        // 2. simple (capture 6)
	        "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
	        // 3. anything else (capture 2)
	        ".*" +
	        ")\\)|)",
	
	      // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	      rtrim = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g"),
	
	      rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
	      rcombinators = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
	
	      rattributeQuotes = new RegExp("=" + whitespace + "*([^\\]'\"]*?)" + whitespace + "*\\]", "g"),
	
	      rpseudo = new RegExp(pseudos),
	      ridentifier = new RegExp("^" + identifier + "$"),
	
	      matchExpr = {
	        "ID": new RegExp("^#(" + identifier + ")"),
	        "CLASS": new RegExp("^\\.(" + identifier + ")"),
	        "TAG": new RegExp("^(" + identifier + "|[*])"),
	        "ATTR": new RegExp("^" + attributes),
	        "PSEUDO": new RegExp("^" + pseudos),
	        "CHILD": new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace +
	          "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace +
	          "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
	        "bool": new RegExp("^(?:" + booleans + ")$", "i"),
	        // For use in libraries implementing .is()
	        // We use this for POS matching in `select`
	        "needsContext": new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" +
	          whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
	      },
	
	      rinputs = /^(?:input|select|textarea|button)$/i,
	      rheader = /^h\d$/i,
	
	      rnative = /^[^{]+\{\s*\[native \w/,
	
	      // Easily-parseable/retrievable ID or TAG or CLASS selectors
	      rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
	
	      rsibling = /[+~]/,
	      rescape = /'|\\/g,
	
	      // CSS escapes http://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	      runescape = new RegExp("\\\\([\\da-f]{1,6}" + whitespace + "?|(" + whitespace + ")|.)", "ig"),
	      funescape = function (_, escaped, escapedWhitespace) {
	        var high = "0x" + escaped - 0x10000;
	        // NaN means non-codepoint
	        // Support: Firefox<24
	        // Workaround erroneous numeric interpretation of +"0x"
	        return high !== high || escapedWhitespace ?
	          escaped :
	          high < 0 ?
	            // BMP codepoint
	            String.fromCharCode(high + 0x10000) :
	            // Supplemental Plane codepoint (surrogate pair)
	            String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
	      };
	
	    // Optimize for push.apply( _, NodeList )
	    try {
	      push.apply(
	        (arr = slice.call(preferredDoc.childNodes)),
	        preferredDoc.childNodes
	      );
	      // Support: Android<4.0
	      // Detect silently failing push.apply
	      arr[preferredDoc.childNodes.length].nodeType;
	    } catch (e) {
	      push = {
	        apply: arr.length ?
	
	          // Leverage slice if possible
	          function (target, els) {
	            push_native.apply(target, slice.call(els));
	          } :
	
	          // Support: IE<9
	          // Otherwise append directly
	          function (target, els) {
	            var j = target.length,
	              i = 0;
	            // Can't trust NodeList.length
	            while ((target[j++] = els[i++])) { }
	            target.length = j - 1;
	          }
	      };
	    }
	
	    function Sizzle(selector, context, results, seed) {
	      var match, elem, m, nodeType,
	        // QSA vars
	        i, groups, old, nid, newContext, newSelector;
	
	      if ((context ? context.ownerDocument || context : preferredDoc) !== document) {
	        setDocument(context);
	      }
	
	      context = context || document;
	      results = results || [];
	
	      if (!selector || typeof selector !== "string") {
	        return results;
	      }
	
	      if ((nodeType = context.nodeType) !== 1 && nodeType !== 9) {
	        return [];
	      }
	
	      if (documentIsHTML && !seed) {
	
	        // Shortcuts
	        if ((match = rquickExpr.exec(selector))) {
	          // Speed-up: Sizzle("#ID")
	          if ((m = match[1])) {
	            if (nodeType === 9) {
	              elem = context.getElementById(m);
	              // Check parentNode to catch when Blackberry 4.6 returns
	              // nodes that are no longer in the document (jQuery #6963)
	              if (elem && elem.parentNode) {
	                // Handle the case where IE, Opera, and Webkit return items
	                // by name instead of ID
	                if (elem.id === m) {
	                  results.push(elem);
	                  return results;
	                }
	              } else {
	                return results;
	              }
	            } else {
	              // Context is not a document
	              if (context.ownerDocument && (elem = context.ownerDocument.getElementById(m)) &&
	                contains(context, elem) && elem.id === m) {
	                results.push(elem);
	                return results;
	              }
	            }
	
	            // Speed-up: Sizzle("TAG")
	          } else if (match[2]) {
	            push.apply(results, context.getElementsByTagName(selector));
	            return results;
	
	            // Speed-up: Sizzle(".CLASS")
	          } else if ((m = match[3]) && support.getElementsByClassName) {
	            push.apply(results, context.getElementsByClassName(m));
	            return results;
	          }
	        }
	
	        // QSA path
	        if (support.qsa && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
	          nid = old = expando;
	          newContext = context;
	          newSelector = nodeType === 9 && selector;
	
	          // qSA works strangely on Element-rooted queries
	          // We can work around this by specifying an extra ID on the root
	          // and working up from there (Thanks to Andrew Dupont for the technique)
	          // IE 8 doesn't work on object elements
	          if (nodeType === 1 && context.nodeName.toLowerCase() !== "object") {
	            groups = tokenize(selector);
	
	            if ((old = context.getAttribute("id"))) {
	              nid = old.replace(rescape, "\\$&");
	            } else {
	              context.setAttribute("id", nid);
	            }
	            nid = "[id='" + nid + "'] ";
	
	            i = groups.length;
	            while (i--) {
	              groups[i] = nid + toSelector(groups[i]);
	            }
	            newContext = rsibling.test(selector) && testContext(context.parentNode) || context;
	            newSelector = groups.join(",");
	          }
	
	          if (newSelector) {
	            try {
	              push.apply(results,
	                newContext.querySelectorAll(newSelector)
	              );
	              return results;
	            } catch (qsaError) {
	            } finally {
	              if (!old) {
	                context.removeAttribute("id");
	              }
	            }
	          }
	        }
	      }
	
	      // All others
	      return select(selector.replace(rtrim, "$1"), context, results, seed);
	    }
	
	    /**
	     * Create key-value caches of limited size
	     * @returns {Function(string, Object)} Returns the Object data after storing it on itself with
	     * property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
	     * deleting the oldest entry
	     */
	    function createCache() {
	      var keys = [];
	
	      function cache(key, value) {
	        // Use (key + " ") to avoid collision with native prototype properties (see Issue #157)
	        if (keys.push(key + " ") > Expr.cacheLength) {
	          // Only keep the most recent entries
	          delete cache[keys.shift()];
	        }
	        return (cache[key + " "] = value);
	      }
	      return cache;
	    }
	
	    /**
	     * Mark a function for special use by Sizzle
	     * @param {Function} fn The function to mark
	     */
	    function markFunction(fn) {
	      fn[expando] = true;
	      return fn;
	    }
	
	    /**
	     * Support testing using an element
	     * @param {Function} fn Passed the created div and expects a boolean result
	     */
	    /*function assert(fn) {
	      var div = document.createElement("div");
	
	      try {
	        return !!fn(div);
	      } catch (e) {
	        return false;
	      } finally {
	        // Remove from its parent by default
	        if (div.parentNode) {
	          div.parentNode.removeChild(div);
	        }
	        // release memory in IE
	        div = null;
	      }
	    }*/
	
	    /**
	     * Adds the same handler for all of the specified attrs
	     * @param {String} attrs Pipe-separated list of attributes
	     * @param {Function} handler The method that will be applied
	     */
	    function addHandle(attrs, handler) {
	      var arr = attrs.split("|"),
	        i = attrs.length;
	
	      while (i--) {
	        Expr.attrHandle[arr[i]] = handler;
	      }
	    }
	
	    /**
	     * Checks document order of two siblings
	     * @param {Element} a
	     * @param {Element} b
	     * @returns {Number} Returns less than 0 if a precedes b, greater than 0 if a follows b
	     */
	    function siblingCheck(a, b) {
	      var cur = b && a,
	        diff = cur && a.nodeType === 1 && b.nodeType === 1 &&
	          (~b.sourceIndex || MAX_NEGATIVE) -
	          (~a.sourceIndex || MAX_NEGATIVE);
	
	      // Use IE sourceIndex if available on both nodes
	      if (diff) {
	        return diff;
	      }
	
	      // Check if b follows a
	      if (cur) {
	        while ((cur = cur.nextSibling)) {
	          if (cur === b) {
	            return -1;
	          }
	        }
	      }
	
	      return a ? 1 : -1;
	    }
	
	    /**
	     * Returns a function to use in pseudos for input types
	     * @param {String} type
	     */
	    function createInputPseudo(type) {
	      return function (elem) {
	        var name = elem.nodeName.toLowerCase();
	        return name === "input" && elem.type === type;
	      };
	    }
	
	    /**
	     * Returns a function to use in pseudos for buttons
	     * @param {String} type
	     */
	    function createButtonPseudo(type) {
	      return function (elem) {
	        var name = elem.nodeName.toLowerCase();
	        return (name === "input" || name === "button") && elem.type === type;
	      };
	    }
	
	    /**
	     * Returns a function to use in pseudos for positionals
	     * @param {Function} fn
	     */
	    function createPositionalPseudo(fn) {
	      return markFunction(function (argument) {
	        argument = +argument;
	        return markFunction(function (seed, matches) {
	          var j,
	            matchIndexes = fn([], seed.length, argument),
	            i = matchIndexes.length;
	
	          // Match elements found at the specified indexes
	          while (i--) {
	            if (seed[(j = matchIndexes[i])]) {
	              seed[j] = !(matches[j] = seed[j]);
	            }
	          }
	        });
	      });
	    }
	
	    /**
	     * Checks a node for validity as a Sizzle context
	     * @param {Element|Object=} context
	     * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
	     */
	    function testContext(context) {
	      return context && typeof context.getElementsByTagName !== strundefined && context;
	    }
	
	    // Expose support vars for convenience
	    support = Sizzle.support = {};
	
	    /**
	     * Detects XML nodes
	     * @param {Element|Object} elem An element or a document
	     * @returns {Boolean} True iff elem is a non-HTML XML node
	     */
	    isXML = Sizzle.isXML = function (elem) {
	      // documentElement is verified for cases where it doesn't yet exist
	      // (such as loading iframes in IE - #4833)
	      var documentElement = elem && (elem.ownerDocument || elem).documentElement;
	      return documentElement ? documentElement.nodeName !== "HTML" : false;
	    };
	
	    /**
	     * Sets document-related variables once based on the current document
	     * @param {Element|Object} [doc] An element or document object to use to set the document
	     * @returns {Object} Returns the current document
	     */
	    setDocument = Sizzle.setDocument = function (node) {
	      var hasCompare,
	        doc = node ? node.ownerDocument || node : preferredDoc,
	        parent = doc.defaultView;
	
	      function getTop(win) {
	        // Edge throws a lovely Object expected if you try to get top on a detached reference see #2642
	        try {
	          return win.top;
	        } catch (ex) {
	          // Ignore
	        }
	
	        return null;
	      }
	
	      // If no document and documentElement is available, return
	      if (doc === document || doc.nodeType !== 9 || !doc.documentElement) {
	        return document;
	      }
	
	      // Set our document
	      document = doc;
	      docElem = doc.documentElement;
	
	      // Support tests
	      documentIsHTML = !isXML(doc);
	
	      // Support: IE>8
	      // If iframe document is assigned to "document" variable and if iframe has been reloaded,
	      // IE will throw "permission denied" error when accessing "document" variable, see jQuery #13936
	      // IE6-8 do not support the defaultView property so parent will be undefined
	      if (parent && parent !== getTop(parent)) {
	        // IE11 does not have attachEvent, so all must suffer
	        if (parent.addEventListener) {
	          parent.addEventListener("unload", function () {
	            setDocument();
	          }, false);
	        } else if (parent.attachEvent) {
	          parent.attachEvent("onunload", function () {
	            setDocument();
	          });
	        }
	      }
	
	      /* Attributes
	      ---------------------------------------------------------------------- */
	
	      // Support: IE<8
	      // Verify that getAttribute really returns attributes and not properties (excepting IE8 booleans)
	      support.attributes = true;
	
	      /* getElement(s)By*
	      ---------------------------------------------------------------------- */
	
	      // Check if getElementsByTagName("*") returns only elements
	      support.getElementsByTagName = true;
	
	      // Support: IE<9
	      support.getElementsByClassName = rnative.test(doc.getElementsByClassName);
	
	      // Support: IE<10
	      // Check if getElementById returns elements by name
	      // The broken getElementById methods don't pick up programatically-set names,
	      // so use a roundabout getElementsByName test
	      support.getById = true;
	
	      // ID find and filter
	      /*if (support.getById) {*/
	        Expr.find["ID"] = function (id, context) {
	          if (typeof context.getElementById !== strundefined && documentIsHTML) {
	            var m = context.getElementById(id);
	            // Check parentNode to catch when Blackberry 4.6 returns
	            // nodes that are no longer in the document #6963
	            return m && m.parentNode ? [m] : [];
	          }
	        };
	        Expr.filter["ID"] = function (id) {
	          var attrId = id.replace(runescape, funescape);
	          return function (elem) {
	            return elem.getAttribute("id") === attrId;
	          };
	        };
	      /*} else {
	        // Support: IE6/7
	        // getElementById is not reliable as a find shortcut
	        delete Expr.find["ID"];
	
	        Expr.filter["ID"] = function (id) {
	          var attrId = id.replace(runescape, funescape);
	          return function (elem) {
	            var node = typeof elem.getAttributeNode !== strundefined && elem.getAttributeNode("id");
	            return node && node.value === attrId;
	          };
	        };
	      }*/
	
	      // Tag
	      Expr.find["TAG"] = support.getElementsByTagName ?
	        function (tag, context) {
	          if (typeof context.getElementsByTagName !== strundefined) {
	            return context.getElementsByTagName(tag);
	          }
	        } :
	        function (tag, context) {
	          var elem,
	            tmp = [],
	            i = 0,
	            results = context.getElementsByTagName(tag);
	
	          // Filter out possible comments
	          if (tag === "*") {
	            while ((elem = results[i++])) {
	              if (elem.nodeType === 1) {
	                tmp.push(elem);
	              }
	            }
	
	            return tmp;
	          }
	          return results;
	        };
	
	      // Class
	      Expr.find["CLASS"] = support.getElementsByClassName && function (className, context) {
	        if (documentIsHTML) {
	          return context.getElementsByClassName(className);
	        }
	      };
	
	      /* QSA/matchesSelector
	      ---------------------------------------------------------------------- */
	
	      // QSA and matchesSelector support
	
	      // matchesSelector(:active) reports false when true (IE9/Opera 11.5)
	      rbuggyMatches = [];
	
	      // qSa(:focus) reports false when true (Chrome 21)
	      // We allow this because of a bug in IE8/9 that throws an error
	      // whenever `document.activeElement` is accessed on an iframe
	      // So, we allow :focus to pass through QSA all the time to avoid the IE error
	      // See http://bugs.jquery.com/ticket/13378
	      rbuggyQSA = [];
	
	      /*
	      if ((support.qsa = rnative.test(doc.querySelectorAll))) {
	        // Build QSA regex
	        // Regex strategy adopted from Diego Perini
	        assert(function (div) {
	          // Select is set to empty string on purpose
	          // This is to test IE's treatment of not explicitly
	          // setting a boolean content attribute,
	          // since its presence should be enough
	          // http://bugs.jquery.com/ticket/12359
	          div.innerHTML = "<select msallowcapture=''><option selected=''></option></select>";
	
	          // Support: IE8, Opera 11-12.16
	          // Nothing should be selected when empty strings follow ^= or $= or *=
	          // The test attribute must be unknown in Opera but "safe" for WinRT
	          // http://msdn.microsoft.com/en-us/library/ie/hh465388.aspx#attribute_section
	          if (div.querySelectorAll("[msallowcapture^='']").length) {
	            rbuggyQSA.push("[*^$]=" + whitespace + "*(?:''|\"\")");
	          }
	
	          // Support: IE8
	          // Boolean attributes and "value" are not treated correctly
	          if (!div.querySelectorAll("[selected]").length) {
	            rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
	          }
	
	          // Webkit/Opera - :checked should return selected option elements
	          // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
	          // IE8 throws error here and will not see later tests
	          if (!div.querySelectorAll(":checked").length) {
	            rbuggyQSA.push(":checked");
	          }
	        });
	
	        assert(function (div) {
	          // Support: Windows 8 Native Apps
	          // The type and name attributes are restricted during .innerHTML assignment
	          var input = doc.createElement("input");
	          input.setAttribute("type", "hidden");
	          div.appendChild(input).setAttribute("name", "D");
	
	          // Support: IE8
	          // Enforce case-sensitivity of name attribute
	          if (div.querySelectorAll("[name=d]").length) {
	            rbuggyQSA.push("name" + whitespace + "*[*^$|!~]?=");
	          }
	
	          // FF 3.5 - :enabled/:disabled and hidden elements (hidden elements are still enabled)
	          // IE8 throws error here and will not see later tests
	          if (!div.querySelectorAll(":enabled").length) {
	            rbuggyQSA.push(":enabled", ":disabled");
	          }
	
	          // Opera 10-11 does not throw on post-comma invalid pseudos
	          div.querySelectorAll("*,:x");
	          rbuggyQSA.push(",.*:");
	        });
	      }
	      */
	
	      support.disconnectedMatch = true;
	
	      /*
	      if ((support.matchesSelector = rnative.test((matches = docElem.matches ||
	        docElem.webkitMatchesSelector ||
	        docElem.mozMatchesSelector ||
	        docElem.oMatchesSelector ||
	        docElem.msMatchesSelector)))) {
	
	        assert(function (div) {
	          // Check to see if it's possible to do matchesSelector
	          // on a disconnected node (IE 9)
	          support.disconnectedMatch = matches.call(div, "div");
	
	          // This should fail with an exception
	          // Gecko does not error, returns false instead
	          matches.call(div, "[s!='']:x");
	          rbuggyMatches.push("!=", pseudos);
	        });
	      }
	      */
	
	      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));
	      rbuggyMatches = rbuggyMatches.length && new RegExp(rbuggyMatches.join("|"));
	
	      /* Contains
	      ---------------------------------------------------------------------- */
	      hasCompare = rnative.test(docElem.compareDocumentPosition);
	
	      // Element contains another
	      // Purposefully does not implement inclusive descendent
	      // As in, an element does not contain itself
	      contains = hasCompare || rnative.test(docElem.contains) ?
	        function (a, b) {
	          var adown = a.nodeType === 9 ? a.documentElement : a,
	            bup = b && b.parentNode;
	          return a === bup || !!(bup && bup.nodeType === 1 && (
	            adown.contains ?
	              adown.contains(bup) :
	              a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16
	          ));
	        } :
	        function (a, b) {
	          if (b) {
	            while ((b = b.parentNode)) {
	              if (b === a) {
	                return true;
	              }
	            }
	          }
	          return false;
	        };
	
	      /* Sorting
	      ---------------------------------------------------------------------- */
	
	      // Document order sorting
	      sortOrder = hasCompare ?
	        function (a, b) {
	
	          // Flag for duplicate removal
	          if (a === b) {
	            hasDuplicate = true;
	            return 0;
	          }
	
	          // Sort on method existence if only one input has compareDocumentPosition
	          var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
	          if (compare) {
	            return compare;
	          }
	
	          // Calculate position if both inputs belong to the same document
	          compare = (a.ownerDocument || a) === (b.ownerDocument || b) ?
	            a.compareDocumentPosition(b) :
	
	            // Otherwise we know they are disconnected
	            1;
	
	          // Disconnected nodes
	          if (compare & 1 ||
	            (!support.sortDetached && b.compareDocumentPosition(a) === compare)) {
	
	            // Choose the first element that is related to our preferred document
	            if (a === doc || a.ownerDocument === preferredDoc && contains(preferredDoc, a)) {
	              return -1;
	            }
	            if (b === doc || b.ownerDocument === preferredDoc && contains(preferredDoc, b)) {
	              return 1;
	            }
	
	            // Maintain original order
	            return sortInput ?
	              (indexOf.call(sortInput, a) - indexOf.call(sortInput, b)) :
	              0;
	          }
	
	          return compare & 4 ? -1 : 1;
	        } :
	        function (a, b) {
	          // Exit early if the nodes are identical
	          if (a === b) {
	            hasDuplicate = true;
	            return 0;
	          }
	
	          var cur,
	            i = 0,
	            aup = a.parentNode,
	            bup = b.parentNode,
	            ap = [a],
	            bp = [b];
	
	          // Parentless nodes are either documents or disconnected
	          if (!aup || !bup) {
	            return a === doc ? -1 :
	              b === doc ? 1 :
	                aup ? -1 :
	                  bup ? 1 :
	                    sortInput ?
	                      (indexOf.call(sortInput, a) - indexOf.call(sortInput, b)) :
	                      0;
	
	            // If the nodes are siblings, we can do a quick check
	          } else if (aup === bup) {
	            return siblingCheck(a, b);
	          }
	
	          // Otherwise we need full lists of their ancestors for comparison
	          cur = a;
	          while ((cur = cur.parentNode)) {
	            ap.unshift(cur);
	          }
	          cur = b;
	          while ((cur = cur.parentNode)) {
	            bp.unshift(cur);
	          }
	
	          // Walk down the tree looking for a discrepancy
	          while (ap[i] === bp[i]) {
	            i++;
	          }
	
	          return i ?
	            // Do a sibling check if the nodes have a common ancestor
	            siblingCheck(ap[i], bp[i]) :
	
	            // Otherwise nodes in our document sort first
	            ap[i] === preferredDoc ? -1 :
	              bp[i] === preferredDoc ? 1 :
	                0;
	        };
	
	      return doc;
	    };
	
	    Sizzle.matches = function (expr, elements) {
	      return Sizzle(expr, null, null, elements);
	    };
	
	    Sizzle.matchesSelector = function (elem, expr) {
	      // Set document vars if needed
	      if ((elem.ownerDocument || elem) !== document) {
	        setDocument(elem);
	      }
	
	      // Make sure that attribute selectors are quoted
	      expr = expr.replace(rattributeQuotes, "='$1']");
	
	      if (support.matchesSelector && documentIsHTML &&
	        (!rbuggyMatches || !rbuggyMatches.test(expr)) &&
	        (!rbuggyQSA || !rbuggyQSA.test(expr))) {
	
	        try {
	          var ret = matches.call(elem, expr);
	
	          // IE 9's matchesSelector returns false on disconnected nodes
	          if (ret || support.disconnectedMatch ||
	            // As well, disconnected nodes are said to be in a document
	            // fragment in IE 9
	            elem.document && elem.document.nodeType !== 11) {
	            return ret;
	          }
	        } catch (e) { }
	      }
	
	      return Sizzle(expr, document, null, [elem]).length > 0;
	    };
	
	    Sizzle.contains = function (context, elem) {
	      // Set document vars if needed
	      if ((context.ownerDocument || context) !== document) {
	        setDocument(context);
	      }
	      return contains(context, elem);
	    };
	
	    Sizzle.attr = function (elem, name) {
	      // Set document vars if needed
	      if ((elem.ownerDocument || elem) !== document) {
	        setDocument(elem);
	      }
	
	      var fn = Expr.attrHandle[name.toLowerCase()],
	        // Don't get fooled by Object.prototype properties (jQuery #13807)
	        val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ?
	          fn(elem, name, !documentIsHTML) :
	          undefined;
	
	      return val !== undefined ?
	        val :
	        support.attributes || !documentIsHTML ?
	          elem.getAttribute(name) :
	          (val = elem.getAttributeNode(name)) && val.specified ?
	            val.value :
	            null;
	    };
	
	    Sizzle.error = function (msg) {
	      throw new Error("Syntax error, unrecognized expression: " + msg);
	    };
	
	    /**
	     * Document sorting and removing duplicates
	     * @param {ArrayLike} results
	     */
	    Sizzle.uniqueSort = function (results) {
	      var elem,
	        duplicates = [],
	        j = 0,
	        i = 0;
	
	      // Unless we *know* we can detect duplicates, assume their presence
	      hasDuplicate = !support.detectDuplicates;
	      sortInput = !support.sortStable && results.slice(0);
	      results.sort(sortOrder);
	
	      if (hasDuplicate) {
	        while ((elem = results[i++])) {
	          if (elem === results[i]) {
	            j = duplicates.push(i);
	          }
	        }
	        while (j--) {
	          results.splice(duplicates[j], 1);
	        }
	      }
	
	      // Clear input after sorting to release objects
	      // See https://github.com/jquery/sizzle/pull/225
	      sortInput = null;
	
	      return results;
	    };
	
	    /**
	     * Utility function for retrieving the text value of an array of DOM nodes
	     * @param {Array|Element} elem
	     */
	    getText = Sizzle.getText = function (elem) {
	      var node,
	        ret = "",
	        i = 0,
	        nodeType = elem.nodeType;
	
	      if (!nodeType) {
	        // If no nodeType, this is expected to be an array
	        while ((node = elem[i++])) {
	          // Do not traverse comment nodes
	          ret += getText(node);
	        }
	      } else if (nodeType === 1 || nodeType === 9 || nodeType === 11) {
	        // Use textContent for elements
	        // innerText usage removed for consistency of new lines (jQuery #11153)
	        if (typeof elem.textContent === "string") {
	          return elem.textContent;
	        } else {
	          // Traverse its children
	          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
	            ret += getText(elem);
	          }
	        }
	      } else if (nodeType === 3 || nodeType === 4) {
	        return elem.nodeValue;
	      }
	      // Do not include comment or processing instruction nodes
	
	      return ret;
	    };
	
	    Expr = Sizzle.selectors = {
	
	      // Can be adjusted by the user
	      cacheLength: 50,
	
	      createPseudo: markFunction,
	
	      match: matchExpr,
	
	      attrHandle: {},
	
	      find: {},
	
	      relative: {
	        ">": { dir: "parentNode", first: true },
	        " ": { dir: "parentNode" },
	        "+": { dir: "previousSibling", first: true },
	        "~": { dir: "previousSibling" }
	      },
	
	      preFilter: {
	        "ATTR": function (match) {
	          match[1] = match[1].replace(runescape, funescape);
	
	          // Move the given value to match[3] whether quoted or unquoted
	          match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
	
	          if (match[2] === "~=") {
	            match[3] = " " + match[3] + " ";
	          }
	
	          return match.slice(0, 4);
	        },
	
	        "CHILD": function (match) {
	          /* matches from matchExpr["CHILD"]
	            1 type (only|nth|...)
	            2 what (child|of-type)
	            3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
	            4 xn-component of xn+y argument ([+-]?\d*n|)
	            5 sign of xn-component
	            6 x of xn-component
	            7 sign of y-component
	            8 y of y-component
	          */
	          match[1] = match[1].toLowerCase();
	
	          if (match[1].slice(0, 3) === "nth") {
	            // nth-* requires argument
	            if (!match[3]) {
	              Sizzle.error(match[0]);
	            }
	
	            // numeric x and y parameters for Expr.filter.CHILD
	            // remember that false/true cast respectively to 0/1
	            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
	            match[5] = +((match[7] + match[8]) || match[3] === "odd");
	
	            // other types prohibit arguments
	          } else if (match[3]) {
	            Sizzle.error(match[0]);
	          }
	
	          return match;
	        },
	
	        "PSEUDO": function (match) {
	          var excess,
	            unquoted = !match[6] && match[2];
	
	          if (matchExpr["CHILD"].test(match[0])) {
	            return null;
	          }
	
	          // Accept quoted arguments as-is
	          if (match[3]) {
	            match[2] = match[4] || match[5] || "";
	
	            // Strip excess characters from unquoted arguments
	          } else if (unquoted && rpseudo.test(unquoted) &&
	            // Get excess from tokenize (recursively)
	            (excess = tokenize(unquoted, true)) &&
	            // advance to the next closing parenthesis
	            (excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
	
	            // excess is a negative index
	            match[0] = match[0].slice(0, excess);
	            match[2] = unquoted.slice(0, excess);
	          }
	
	          // Return only captures needed by the pseudo filter method (type and argument)
	          return match.slice(0, 3);
	        }
	      },
	
	      filter: {
	
	        "TAG": function (nodeNameSelector) {
	          var nodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
	          return nodeNameSelector === "*" ?
	            function () { return true; } :
	            function (elem) {
	              return elem.nodeName && elem.nodeName.toLowerCase() === nodeName;
	            };
	        },
	
	        "CLASS": function (className) {
	          var pattern = classCache[className + " "];
	
	          return pattern ||
	            (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) &&
	            classCache(className, function (elem) {
	              return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== strundefined && elem.getAttribute("class") || "");
	            });
	        },
	
	        "ATTR": function (name, operator, check) {
	          return function (elem) {
	            var result = Sizzle.attr(elem, name);
	
	            if (result == null) {
	              return operator === "!=";
	            }
	            if (!operator) {
	              return true;
	            }
	
	            result += "";
	
	            return operator === "=" ? result === check :
	              operator === "!=" ? result !== check :
	                operator === "^=" ? check && result.indexOf(check) === 0 :
	                  operator === "*=" ? check && result.indexOf(check) > -1 :
	                    operator === "$=" ? check && result.slice(-check.length) === check :
	                      operator === "~=" ? (" " + result + " ").indexOf(check) > -1 :
	                        operator === "|=" ? result === check || result.slice(0, check.length + 1) === check + "-" :
	                          false;
	          };
	        },
	
	        "CHILD": function (type, what, argument, first, last) {
	          var simple = type.slice(0, 3) !== "nth",
	            forward = type.slice(-4) !== "last",
	            ofType = what === "of-type";
	
	          return first === 1 && last === 0 ?
	
	            // Shortcut for :nth-*(n)
	            function (elem) {
	              return !!elem.parentNode;
	            } :
	
	            function (elem, context, xml) {
	              var cache, outerCache, node, diff, nodeIndex, start,
	                dir = simple !== forward ? "nextSibling" : "previousSibling",
	                parent = elem.parentNode,
	                name = ofType && elem.nodeName.toLowerCase(),
	                useCache = !xml && !ofType;
	
	              if (parent) {
	
	                // :(first|last|only)-(child|of-type)
	                if (simple) {
	                  while (dir) {
	                    node = elem;
	                    while ((node = node[dir])) {
	                      if (ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) {
	                        return false;
	                      }
	                    }
	                    // Reverse direction for :only-* (if we haven't yet done so)
	                    start = dir = type === "only" && !start && "nextSibling";
	                  }
	                  return true;
	                }
	
	                start = [forward ? parent.firstChild : parent.lastChild];
	
	                // non-xml :nth-child(...) stores cache data on `parent`
	                if (forward && useCache) {
	                  // Seek `elem` from a previously-cached index
	                  outerCache = parent[expando] || (parent[expando] = {});
	                  cache = outerCache[type] || [];
	                  nodeIndex = cache[0] === dirruns && cache[1];
	                  diff = cache[0] === dirruns && cache[2];
	                  node = nodeIndex && parent.childNodes[nodeIndex];
	
	                  while ((node = ++nodeIndex && node && node[dir] ||
	
	                    // Fallback to seeking `elem` from the start
	                    (diff = nodeIndex = 0) || start.pop())) {
	
	                    // When found, cache indexes on `parent` and break
	                    if (node.nodeType === 1 && ++diff && node === elem) {
	                      outerCache[type] = [dirruns, nodeIndex, diff];
	                      break;
	                    }
	                  }
	
	                  // Use previously-cached element index if available
	                } else if (useCache && (cache = (elem[expando] || (elem[expando] = {}))[type]) && cache[0] === dirruns) {
	                  diff = cache[1];
	
	                  // xml :nth-child(...) or :nth-last-child(...) or :nth(-last)?-of-type(...)
	                } else {
	                  // Use the same loop as above to seek `elem` from the start
	                  while ((node = ++nodeIndex && node && node[dir] ||
	                    (diff = nodeIndex = 0) || start.pop())) {
	
	                    if ((ofType ? node.nodeName.toLowerCase() === name : node.nodeType === 1) && ++diff) {
	                      // Cache the index of each encountered element
	                      if (useCache) {
	                        (node[expando] || (node[expando] = {}))[type] = [dirruns, diff];
	                      }
	
	                      if (node === elem) {
	                        break;
	                      }
	                    }
	                  }
	                }
	
	                // Incorporate the offset, then check against cycle size
	                diff -= last;
	                return diff === first || (diff % first === 0 && diff / first >= 0);
	              }
	            };
	        },
	
	        "PSEUDO": function (pseudo, argument) {
	          // pseudo-class names are case-insensitive
	          // http://www.w3.org/TR/selectors/#pseudo-classes
	          // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
	          // Remember that setFilters inherits from pseudos
	          var args,
	            fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] ||
	              Sizzle.error("unsupported pseudo: " + pseudo);
	
	          // The user may use createPseudo to indicate that
	          // arguments are needed to create the filter function
	          // just as Sizzle does
	          if (fn[expando]) {
	            return fn(argument);
	          }
	
	          // But maintain support for old signatures
	          if (fn.length > 1) {
	            args = [pseudo, pseudo, "", argument];
	            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ?
	              markFunction(function (seed, matches) {
	                var idx,
	                  matched = fn(seed, argument),
	                  i = matched.length;
	                while (i--) {
	                  idx = indexOf.call(seed, matched[i]);
	                  seed[idx] = !(matches[idx] = matched[i]);
	                }
	              }) :
	              function (elem) {
	                return fn(elem, 0, args);
	              };
	          }
	
	          return fn;
	        }
	      },
	
	      pseudos: {
	        // Potentially complex pseudos
	        "not": markFunction(function (selector) {
	          // Trim the selector passed to compile
	          // to avoid treating leading and trailing
	          // spaces as combinators
	          var input = [],
	            results = [],
	            matcher = compile(selector.replace(rtrim, "$1"));
	
	          return matcher[expando] ?
	            markFunction(function (seed, matches, context, xml) {
	              var elem,
	                unmatched = matcher(seed, null, xml, []),
	                i = seed.length;
	
	              // Match elements unmatched by `matcher`
	              while (i--) {
	                if ((elem = unmatched[i])) {
	                  seed[i] = !(matches[i] = elem);
	                }
	              }
	            }) :
	            function (elem, context, xml) {
	              input[0] = elem;
	              matcher(input, null, xml, results);
	              return !results.pop();
	            };
	        }),
	
	        "has": markFunction(function (selector) {
	          return function (elem) {
	            return Sizzle(selector, elem).length > 0;
	          };
	        }),
	
	        "contains": markFunction(function (text) {
	          text = text.replace(runescape, funescape);
	          return function (elem) {
	            return (elem.textContent || elem.innerText || getText(elem)).indexOf(text) > -1;
	          };
	        }),
	
	        // "Whether an element is represented by a :lang() selector
	        // is based solely on the element's language value
	        // being equal to the identifier C,
	        // or beginning with the identifier C immediately followed by "-".
	        // The matching of C against the element's language value is performed case-insensitively.
	        // The identifier C does not have to be a valid language name."
	        // http://www.w3.org/TR/selectors/#lang-pseudo
	        "lang": markFunction(function (lang) {
	          // lang value must be a valid identifier
	          if (!ridentifier.test(lang || "")) {
	            Sizzle.error("unsupported lang: " + lang);
	          }
	          lang = lang.replace(runescape, funescape).toLowerCase();
	          return function (elem) {
	            var elemLang;
	            do {
	              if ((elemLang = documentIsHTML ?
	                elem.lang :
	                elem.getAttribute("xml:lang") || elem.getAttribute("lang"))) {
	
	                elemLang = elemLang.toLowerCase();
	                return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
	              }
	            } while ((elem = elem.parentNode) && elem.nodeType === 1);
	            return false;
	          };
	        }),
	
	        // Miscellaneous
	        "target": function (elem) {
	          var hash = window.location && window.location.hash;
	          return hash && hash.slice(1) === elem.id;
	        },
	
	        "root": function (elem) {
	          return elem === docElem;
	        },
	
	        "focus": function (elem) {
	          return elem === document.activeElement && (!document.hasFocus || document.hasFocus()) && !!(elem.type || elem.href || ~elem.tabIndex);
	        },
	
	        // Boolean properties
	        "enabled": function (elem) {
	          return elem.disabled === false;
	        },
	
	        "disabled": function (elem) {
	          return elem.disabled === true;
	        },
	
	        "checked": function (elem) {
	          // In CSS3, :checked should return both checked and selected elements
	          // http://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
	          var nodeName = elem.nodeName.toLowerCase();
	          return (nodeName === "input" && !!elem.checked) || (nodeName === "option" && !!elem.selected);
	        },
	
	        "selected": function (elem) {
	          // Accessing this property makes selected-by-default
	          // options in Safari work properly
	          if (elem.parentNode) {
	            elem.parentNode.selectedIndex;
	          }
	
	          return elem.selected === true;
	        },
	
	        // Contents
	        "empty": function (elem) {
	          // http://www.w3.org/TR/selectors/#empty-pseudo
	          // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
	          //   but not by others (comment: 8; processing instruction: 7; etc.)
	          // nodeType < 6 works because attributes (2) do not appear as children
	          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
	            if (elem.nodeType < 6) {
	              return false;
	            }
	          }
	          return true;
	        },
	
	        "parent": function (elem) {
	          return !Expr.pseudos["empty"](elem);
	        },
	
	        // Element/input types
	        "header": function (elem) {
	          return rheader.test(elem.nodeName);
	        },
	
	        "input": function (elem) {
	          return rinputs.test(elem.nodeName);
	        },
	
	        "button": function (elem) {
	          var name = elem.nodeName.toLowerCase();
	          return name === "input" && elem.type === "button" || name === "button";
	        },
	
	        "text": function (elem) {
	          var attr;
	          return elem.nodeName.toLowerCase() === "input" &&
	            elem.type === "text" &&
	
	            // Support: IE<8
	            // New HTML5 attribute values (e.g., "search") appear with elem.type === "text"
	            ((attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
	        },
	
	        // Position-in-collection
	        "first": createPositionalPseudo(function () {
	          return [0];
	        }),
	
	        "last": createPositionalPseudo(function (matchIndexes, length) {
	          return [length - 1];
	        }),
	
	        "eq": createPositionalPseudo(function (matchIndexes, length, argument) {
	          return [argument < 0 ? argument + length : argument];
	        }),
	
	        "even": createPositionalPseudo(function (matchIndexes, length) {
	          var i = 0;
	          for (; i < length; i += 2) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	
	        "odd": createPositionalPseudo(function (matchIndexes, length) {
	          var i = 1;
	          for (; i < length; i += 2) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	
	        "lt": createPositionalPseudo(function (matchIndexes, length, argument) {
	          var i = argument < 0 ? argument + length : argument;
	          for (; --i >= 0;) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        }),
	
	        "gt": createPositionalPseudo(function (matchIndexes, length, argument) {
	          var i = argument < 0 ? argument + length : argument;
	          for (; ++i < length;) {
	            matchIndexes.push(i);
	          }
	          return matchIndexes;
	        })
	      }
	    };
	
	    Expr.pseudos["nth"] = Expr.pseudos["eq"];
	
	    // Add button/input type pseudos
	    for (i in { radio: true, checkbox: true, file: true, password: true, image: true }) {
	      Expr.pseudos[i] = createInputPseudo(i);
	    }
	    for (i in { submit: true, reset: true }) {
	      Expr.pseudos[i] = createButtonPseudo(i);
	    }
	
	    // Easy API for creating new setFilters
	    function setFilters() { }
	    setFilters.prototype = Expr.filters = Expr.pseudos;
	    Expr.setFilters = new setFilters();
	
	    tokenize = Sizzle.tokenize = function (selector, parseOnly) {
	      var matched, match, tokens, type,
	        soFar, groups, preFilters,
	        cached = tokenCache[selector + " "];
	
	      if (cached) {
	        return parseOnly ? 0 : cached.slice(0);
	      }
	
	      soFar = selector;
	      groups = [];
	      preFilters = Expr.preFilter;
	
	      while (soFar) {
	
	        // Comma and first run
	        if (!matched || (match = rcomma.exec(soFar))) {
	          if (match) {
	            // Don't consume trailing commas as valid
	            soFar = soFar.slice(match[0].length) || soFar;
	          }
	          groups.push((tokens = []));
	        }
	
	        matched = false;
	
	        // Combinators
	        if ((match = rcombinators.exec(soFar))) {
	          matched = match.shift();
	          tokens.push({
	            value: matched,
	            // Cast descendant combinators to space
	            type: match[0].replace(rtrim, " ")
	          });
	          soFar = soFar.slice(matched.length);
	        }
	
	        // Filters
	        for (type in Expr.filter) {
	          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] ||
	            (match = preFilters[type](match)))) {
	            matched = match.shift();
	            tokens.push({
	              value: matched,
	              type: type,
	              matches: match
	            });
	            soFar = soFar.slice(matched.length);
	          }
	        }
	
	        if (!matched) {
	          break;
	        }
	      }
	
	      // Return the length of the invalid excess
	      // if we're just parsing
	      // Otherwise, throw an error or return tokens
	      return parseOnly ?
	        soFar.length :
	        soFar ?
	          Sizzle.error(selector) :
	          // Cache the tokens
	          tokenCache(selector, groups).slice(0);
	    };
	
	    function toSelector(tokens) {
	      var i = 0,
	        len = tokens.length,
	        selector = "";
	      for (; i < len; i++) {
	        selector += tokens[i].value;
	      }
	      return selector;
	    }
	
	    function addCombinator(matcher, combinator, base) {
	      var dir = combinator.dir,
	        checkNonElements = base && dir === "parentNode",
	        doneName = done++;
	
	      return combinator.first ?
	        // Check against closest ancestor/preceding element
	        function (elem, context, xml) {
	          while ((elem = elem[dir])) {
	            if (elem.nodeType === 1 || checkNonElements) {
	              return matcher(elem, context, xml);
	            }
	          }
	        } :
	
	        // Check against all ancestor/preceding elements
	        function (elem, context, xml) {
	          var oldCache, outerCache,
	            newCache = [dirruns, doneName];
	
	          // We can't set arbitrary data on XML nodes, so they don't benefit from dir caching
	          if (xml) {
	            while ((elem = elem[dir])) {
	              if (elem.nodeType === 1 || checkNonElements) {
	                if (matcher(elem, context, xml)) {
	                  return true;
	                }
	              }
	            }
	          } else {
	            while ((elem = elem[dir])) {
	              if (elem.nodeType === 1 || checkNonElements) {
	                outerCache = elem[expando] || (elem[expando] = {});
	                if ((oldCache = outerCache[dir]) &&
	                  oldCache[0] === dirruns && oldCache[1] === doneName) {
	
	                  // Assign to newCache so results back-propagate to previous elements
	                  return (newCache[2] = oldCache[2]);
	                } else {
	                  // Reuse newcache so results back-propagate to previous elements
	                  outerCache[dir] = newCache;
	
	                  // A match means we're done; a fail means we have to keep checking
	                  if ((newCache[2] = matcher(elem, context, xml))) {
	                    return true;
	                  }
	                }
	              }
	            }
	          }
	        };
	    }
	
	    function elementMatcher(matchers) {
	      return matchers.length > 1 ?
	        function (elem, context, xml) {
	          var i = matchers.length;
	          while (i--) {
	            if (!matchers[i](elem, context, xml)) {
	              return false;
	            }
	          }
	          return true;
	        } :
	        matchers[0];
	    }
	
	    function multipleContexts(selector, contexts, results) {
	      var i = 0,
	        len = contexts.length;
	      for (; i < len; i++) {
	        Sizzle(selector, contexts[i], results);
	      }
	      return results;
	    }
	
	    function condense(unmatched, map, filter, context, xml) {
	      var elem,
	        newUnmatched = [],
	        i = 0,
	        len = unmatched.length,
	        mapped = map != null;
	
	      for (; i < len; i++) {
	        if ((elem = unmatched[i])) {
	          if (!filter || filter(elem, context, xml)) {
	            newUnmatched.push(elem);
	            if (mapped) {
	              map.push(i);
	            }
	          }
	        }
	      }
	
	      return newUnmatched;
	    }
	
	    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
	      if (postFilter && !postFilter[expando]) {
	        postFilter = setMatcher(postFilter);
	      }
	      if (postFinder && !postFinder[expando]) {
	        postFinder = setMatcher(postFinder, postSelector);
	      }
	      return markFunction(function (seed, results, context, xml) {
	        var temp, i, elem,
	          preMap = [],
	          postMap = [],
	          preexisting = results.length,
	
	          // Get initial elements from seed or context
	          elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
	
	          // Prefilter to get matcher input, preserving a map for seed-results synchronization
	          matcherIn = preFilter && (seed || !selector) ?
	            condense(elems, preMap, preFilter, context, xml) :
	            elems,
	
	          matcherOut = matcher ?
	            // If we have a postFinder, or filtered seed, or non-seed postFilter or preexisting results,
	            postFinder || (seed ? preFilter : preexisting || postFilter) ?
	
	              // ...intermediate processing is necessary
	              [] :
	
	              // ...otherwise use results directly
	              results :
	            matcherIn;
	
	        // Find primary matches
	        if (matcher) {
	          matcher(matcherIn, matcherOut, context, xml);
	        }
	
	        // Apply postFilter
	        if (postFilter) {
	          temp = condense(matcherOut, postMap);
	          postFilter(temp, [], context, xml);
	
	          // Un-match failing elements by moving them back to matcherIn
	          i = temp.length;
	          while (i--) {
	            if ((elem = temp[i])) {
	              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
	            }
	          }
	        }
	
	        if (seed) {
	          if (postFinder || preFilter) {
	            if (postFinder) {
	              // Get the final matcherOut by condensing this intermediate into postFinder contexts
	              temp = [];
	              i = matcherOut.length;
	              while (i--) {
	                if ((elem = matcherOut[i])) {
	                  // Restore matcherIn since elem is not yet a final match
	                  temp.push((matcherIn[i] = elem));
	                }
	              }
	              postFinder(null, (matcherOut = []), temp, xml);
	            }
	
	            // Move matched elements from seed to results to keep them synchronized
	            i = matcherOut.length;
	            while (i--) {
	              if ((elem = matcherOut[i]) &&
	                (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) {
	
	                seed[temp] = !(results[temp] = elem);
	              }
	            }
	          }
	
	          // Add elements to results, through postFinder if defined
	        } else {
	          matcherOut = condense(
	            matcherOut === results ?
	              matcherOut.splice(preexisting, matcherOut.length) :
	              matcherOut
	          );
	          if (postFinder) {
	            postFinder(null, results, matcherOut, xml);
	          } else {
	            push.apply(results, matcherOut);
	          }
	        }
	      });
	    }
	
	    function matcherFromTokens(tokens) {
	      var checkContext, matcher, j,
	        len = tokens.length,
	        leadingRelative = Expr.relative[tokens[0].type],
	        implicitRelative = leadingRelative || Expr.relative[" "],
	        i = leadingRelative ? 1 : 0,
	
	        // The foundational matcher ensures that elements are reachable from top-level context(s)
	        matchContext = addCombinator(function (elem) {
	          return elem === checkContext;
	        }, implicitRelative, true),
	        matchAnyContext = addCombinator(function (elem) {
	          return indexOf.call(checkContext, elem) > -1;
	        }, implicitRelative, true),
	        matchers = [function (elem, context, xml) {
	          return (!leadingRelative && (xml || context !== outermostContext)) || (
	            (checkContext = context).nodeType ?
	              matchContext(elem, context, xml) :
	              matchAnyContext(elem, context, xml));
	        }];
	
	      for (; i < len; i++) {
	        if ((matcher = Expr.relative[tokens[i].type])) {
	          matchers = [addCombinator(elementMatcher(matchers), matcher)];
	        } else {
	          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);
	
	          // Return special upon seeing a positional matcher
	          if (matcher[expando]) {
	            // Find the next relative operator (if any) for proper handling
	            j = ++i;
	            for (; j < len; j++) {
	              if (Expr.relative[tokens[j].type]) {
	                break;
	              }
	            }
	            return setMatcher(
	              i > 1 && elementMatcher(matchers),
	              i > 1 && toSelector(
	                // If the preceding token was a descendant combinator, insert an implicit any-element `*`
	                tokens.slice(0, i - 1).concat({ value: tokens[i - 2].type === " " ? "*" : "" })
	              ).replace(rtrim, "$1"),
	              matcher,
	              i < j && matcherFromTokens(tokens.slice(i, j)),
	              j < len && matcherFromTokens((tokens = tokens.slice(j))),
	              j < len && toSelector(tokens)
	            );
	          }
	          matchers.push(matcher);
	        }
	      }
	
	      return elementMatcher(matchers);
	    }
	
	    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
	      var bySet = setMatchers.length > 0,
	        byElement = elementMatchers.length > 0,
	        superMatcher = function (seed, context, xml, results, outermost) {
	          var elem, j, matcher,
	            matchedCount = 0,
	            i = "0",
	            unmatched = seed && [],
	            setMatched = [],
	            contextBackup = outermostContext,
	            // We must always have either seed elements or outermost context
	            elems = seed || byElement && Expr.find["TAG"]("*", outermost),
	            // Use integer dirruns iff this is the outermost matcher
	            dirrunsUnique = (dirruns += contextBackup == null ? 1 : Math.random() || 0.1),
	            len = elems.length;
	
	          if (outermost) {
	            outermostContext = context !== document && context;
	          }
	
	          // Add elements passing elementMatchers directly to results
	          // Keep `i` a string if there are no elements so `matchedCount` will be "00" below
	          // Support: IE<9, Safari
	          // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching elements by id
	          for (; i !== len && (elem = elems[i]) != null; i++) {
	            if (byElement && elem) {
	              j = 0;
	              while ((matcher = elementMatchers[j++])) {
	                if (matcher(elem, context, xml)) {
	                  results.push(elem);
	                  break;
	                }
	              }
	              if (outermost) {
	                dirruns = dirrunsUnique;
	              }
	            }
	
	            // Track unmatched elements for set filters
	            if (bySet) {
	              // They will have gone through all possible matchers
	              if ((elem = !matcher && elem)) {
	                matchedCount--;
	              }
	
	              // Lengthen the array for every element, matched or not
	              if (seed) {
	                unmatched.push(elem);
	              }
	            }
	          }
	
	          // Apply set filters to unmatched elements
	          matchedCount += i;
	          if (bySet && i !== matchedCount) {
	            j = 0;
	            while ((matcher = setMatchers[j++])) {
	              matcher(unmatched, setMatched, context, xml);
	            }
	
	            if (seed) {
	              // Reintegrate element matches to eliminate the need for sorting
	              if (matchedCount > 0) {
	                while (i--) {
	                  if (!(unmatched[i] || setMatched[i])) {
	                    setMatched[i] = pop.call(results);
	                  }
	                }
	              }
	
	              // Discard index placeholder values to get only actual matches
	              setMatched = condense(setMatched);
	            }
	
	            // Add matches to results
	            push.apply(results, setMatched);
	
	            // Seedless set matches succeeding multiple successful matchers stipulate sorting
	            if (outermost && !seed && setMatched.length > 0 &&
	              (matchedCount + setMatchers.length) > 1) {
	
	              Sizzle.uniqueSort(results);
	            }
	          }
	
	          // Override manipulation of globals by nested matchers
	          if (outermost) {
	            dirruns = dirrunsUnique;
	            outermostContext = contextBackup;
	          }
	
	          return unmatched;
	        };
	
	      return bySet ?
	        markFunction(superMatcher) :
	        superMatcher;
	    }
	
	    compile = Sizzle.compile = function (selector, match /* Internal Use Only */) {
	      var i,
	        setMatchers = [],
	        elementMatchers = [],
	        cached = compilerCache[selector + " "];
	
	      if (!cached) {
	        // Generate a function of recursive functions that can be used to check each element
	        if (!match) {
	          match = tokenize(selector);
	        }
	        i = match.length;
	        while (i--) {
	          cached = matcherFromTokens(match[i]);
	          if (cached[expando]) {
	            setMatchers.push(cached);
	          } else {
	            elementMatchers.push(cached);
	          }
	        }
	
	        // Cache the compiled function
	        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));
	
	        // Save selector and tokenization
	        cached.selector = selector;
	      }
	      return cached;
	    };
	
	    /**
	     * A low-level selection function that works with Sizzle's compiled
	     *  selector functions
	     * @param {String|Function} selector A selector or a pre-compiled
	     *  selector function built with Sizzle.compile
	     * @param {Element} context
	     * @param {Array} [results]
	     * @param {Array} [seed] A set of elements to match against
	     */
	    select = Sizzle.select = function (selector, context, results, seed) {
	      var i, tokens, token, type, find,
	        compiled = typeof selector === "function" && selector,
	        match = !seed && tokenize((selector = compiled.selector || selector));
	
	      results = results || [];
	
	      // Try to minimize operations if there is no seed and only one group
	      if (match.length === 1) {
	
	        // Take a shortcut and set the context if the root selector is an ID
	        tokens = match[0] = match[0].slice(0);
	        if (tokens.length > 2 && (token = tokens[0]).type === "ID" &&
	          support.getById && context.nodeType === 9 && documentIsHTML &&
	          Expr.relative[tokens[1].type]) {
	
	          context = (Expr.find["ID"](token.matches[0].replace(runescape, funescape), context) || [])[0];
	          if (!context) {
	            return results;
	
	            // Precompiled matchers will still verify ancestry, so step up a level
	          } else if (compiled) {
	            context = context.parentNode;
	          }
	
	          selector = selector.slice(tokens.shift().value.length);
	        }
	
	        // Fetch a seed set for right-to-left matching
	        i = matchExpr["needsContext"].test(selector) ? 0 : tokens.length;
	        while (i--) {
	          token = tokens[i];
	
	          // Abort if we hit a combinator
	          if (Expr.relative[(type = token.type)]) {
	            break;
	          }
	          if ((find = Expr.find[type])) {
	            // Search, expanding context for leading sibling combinators
	            if ((seed = find(
	              token.matches[0].replace(runescape, funescape),
	              rsibling.test(tokens[0].type) && testContext(context.parentNode) || context
	            ))) {
	
	              // If seed is empty or no tokens remain, we can return early
	              tokens.splice(i, 1);
	              selector = seed.length && toSelector(tokens);
	              if (!selector) {
	                push.apply(results, seed);
	                return results;
	              }
	
	              break;
	            }
	          }
	        }
	      }
	
	      // Compile and execute a filtering function if one is not provided
	      // Provide `match` to avoid retokenization if we modified the selector above
	      (compiled || compile(selector, match))(
	        seed,
	        context,
	        !documentIsHTML,
	        results,
	        rsibling.test(selector) && testContext(context.parentNode) || context
	      );
	      return results;
	    };
	
	    // One-time assignments
	
	    // Sort stability
	    support.sortStable = expando.split("").sort(sortOrder).join("") === expando;
	
	    // Support: Chrome 14-35+
	    // Always assume duplicates if they aren't passed to the comparison function
	    support.detectDuplicates = !!hasDuplicate;
	
	    // Initialize against the default document
	    setDocument();
	
	    // Support: Webkit<537.32 - Safari 6.0.3/Chrome 25 (fixed in Chrome 27)
	    // Detached nodes confoundingly follow *each other*
	    support.sortDetached = true;
	
	    // Support: IE<8
	    // Prevent attribute/property "interpolation"
	    // http://msdn.microsoft.com/en-us/library/ms536429%28VS.85%29.aspx
	    /*if (!assert(function (div) {
	      div.innerHTML = "<a href='#'></a>";
	      return div.firstChild.getAttribute("href") === "#";
	    })) {
	      addHandle("type|href|height|width", function (elem, name, isXML) {
	        if (!isXML) {
	          return elem.getAttribute(name, name.toLowerCase() === "type" ? 1 : 2);
	        }
	      });
	    }*/
	
	    // Support: IE<9
	    // Use defaultValue in place of getAttribute("value")
	    /*if (!support.attributes || !assert(function (div) {
	      div.innerHTML = "<input/>";
	      div.firstChild.setAttribute("value", "");
	      return div.firstChild.getAttribute("value") === "";
	    })) {
	      addHandle("value", function (elem, name, isXML) {
	        if (!isXML && elem.nodeName.toLowerCase() === "input") {
	          return elem.defaultValue;
	        }
	      });
	    }*/
	
	    // Support: IE<9
	    // Use getAttributeNode to fetch booleans when getAttribute lies
	    /*if (!assert(function (div) {
	      return div.getAttribute("disabled") == null;
	    })) {
	      addHandle(booleans, function (elem, name, isXML) {
	        var val;
	        if (!isXML) {
	          return elem[name] === true ? name.toLowerCase() :
	            (val = elem.getAttributeNode(name)) && val.specified ?
	              val.value :
	              null;
	        }
	      });
	    }*/
	
	    // EXPOSE
	    return Sizzle;
	  }
	);
	
	/*eslint-enable */
	
	/**
	 * Arr.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Array utility class.
	 *
	 * @private
	 * @class tinymce.util.Arr
	 */
	define(
	  'tinymce.core.util.Arr',
	  [
	  ],
	  function () {
	    var isArray = Array.isArray || function (obj) {
	      return Object.prototype.toString.call(obj) === "[object Array]";
	    };
	
	    var toArray = function (obj) {
	      var array = obj, i, l;
	
	      if (!isArray(obj)) {
	        array = [];
	        for (i = 0, l = obj.length; i < l; i++) {
	          array[i] = obj[i];
	        }
	      }
	
	      return array;
	    };
	
	    var each = function (o, cb, s) {
	      var n, l;
	
	      if (!o) {
	        return 0;
	      }
	
	      s = s || o;
	
	      if (o.length !== undefined) {
	        // Indexed arrays, needed for Safari
	        for (n = 0, l = o.length; n < l; n++) {
	          if (cb.call(s, o[n], n, o) === false) {
	            return 0;
	          }
	        }
	      } else {
	        // Hashtables
	        for (n in o) {
	          if (o.hasOwnProperty(n)) {
	            if (cb.call(s, o[n], n, o) === false) {
	              return 0;
	            }
	          }
	        }
	      }
	
	      return 1;
	    };
	
	    var map = function (array, callback) {
	      var out = [];
	
	      each(array, function (item, index) {
	        out.push(callback(item, index, array));
	      });
	
	      return out;
	    };
	
	    var filter = function (a, f) {
	      var o = [];
	
	      each(a, function (v, index) {
	        if (!f || f(v, index, a)) {
	          o.push(v);
	        }
	      });
	
	      return o;
	    };
	
	    var indexOf = function (a, v) {
	      var i, l;
	
	      if (a) {
	        for (i = 0, l = a.length; i < l; i++) {
	          if (a[i] === v) {
	            return i;
	          }
	        }
	      }
	
	      return -1;
	    };
	
	    var reduce = function (collection, iteratee, accumulator, thisArg) {
	      var i = 0;
	
	      if (arguments.length < 3) {
	        accumulator = collection[0];
	      }
	
	      for (; i < collection.length; i++) {
	        accumulator = iteratee.call(thisArg, accumulator, collection[i], i);
	      }
	
	      return accumulator;
	    };
	
	    var findIndex = function (array, predicate, thisArg) {
	      var i, l;
	
	      for (i = 0, l = array.length; i < l; i++) {
	        if (predicate.call(thisArg, array[i], i, array)) {
	          return i;
	        }
	      }
	
	      return -1;
	    };
	
	    var find = function (array, predicate, thisArg) {
	      var idx = findIndex(array, predicate, thisArg);
	
	      if (idx !== -1) {
	        return array[idx];
	      }
	
	      return undefined;
	    };
	
	    var last = function (collection) {
	      return collection[collection.length - 1];
	    };
	
	    return {
	      isArray: isArray,
	      toArray: toArray,
	      each: each,
	      map: map,
	      filter: filter,
	      indexOf: indexOf,
	      reduce: reduce,
	      findIndex: findIndex,
	      find: find,
	      last: last
	    };
	  }
	);
	/**
	 * Tools.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains various utlity functions. These are also exposed
	 * directly on the tinymce namespace.
	 *
	 * @class tinymce.util.Tools
	 */
	define(
	  'tinymce.core.util.Tools',
	  [
	    'global!window',
	    'tinymce.core.Env',
	    'tinymce.core.util.Arr'
	  ],
	  function (window, Env, Arr) {
	    /**
	     * Removes whitespace from the beginning and end of a string.
	     *
	     * @method trim
	     * @param {String} s String to remove whitespace from.
	     * @return {String} New string with removed whitespace.
	     */
	    var whiteSpaceRegExp = /^\s*|\s*$/g;
	
	    var trim = function (str) {
	      return (str === null || str === undefined) ? '' : ("" + str).replace(whiteSpaceRegExp, '');
	    };
	
	    /**
	     * Checks if a object is of a specific type for example an array.
	     *
	     * @method is
	     * @param {Object} obj Object to check type of.
	     * @param {string} type Optional type to check for.
	     * @return {Boolean} true/false if the object is of the specified type.
	     */
	    var is = function (obj, type) {
	      if (!type) {
	        return obj !== undefined;
	      }
	
	      if (type == 'array' && Arr.isArray(obj)) {
	        return true;
	      }
	
	      return typeof obj == type;
	    };
	
	    /**
	     * Makes a name/object map out of an array with names.
	     *
	     * @method makeMap
	     * @param {Array/String} items Items to make map out of.
	     * @param {String} delim Optional delimiter to split string by.
	     * @param {Object} map Optional map to add items to.
	     * @return {Object} Name/value map of items.
	     */
	    var makeMap = function (items, delim, map) {
	      var i;
	
	      items = items || [];
	      delim = delim || ',';
	
	      if (typeof items == "string") {
	        items = items.split(delim);
	      }
	
	      map = map || {};
	
	      i = items.length;
	      while (i--) {
	        map[items[i]] = {};
	      }
	
	      return map;
	    };
	
	    /**
	     * JavaScript does not protect hasOwnProperty method, so it is possible to overwrite it. This is
	     * object independent version.
	     *
	     * @param {Object} obj
	     * @param {String} prop
	     * @returns {Boolean}
	     */
	    var hasOwnProperty = function (obj, prop) {
	      return Object.prototype.hasOwnProperty.call(obj, prop);
	    };
	
	    /**
	     * Creates a class, subclass or static singleton.
	     * More details on this method can be found in the Wiki.
	     *
	     * @method create
	     * @param {String} s Class name, inheritance and prefix.
	     * @param {Object} p Collection of methods to add to the class.
	     * @param {Object} root Optional root object defaults to the global window object.
	     * @example
	     * // Creates a basic class
	     * tinymce.create('tinymce.somepackage.SomeClass', {
	     *     SomeClass: function() {
	     *         // Class constructor
	     *     },
	     *
	     *     method: function() {
	     *         // Some method
	     *     }
	     * });
	     *
	     * // Creates a basic subclass class
	     * tinymce.create('tinymce.somepackage.SomeSubClass:tinymce.somepackage.SomeClass', {
	     *     SomeSubClass: function() {
	     *         // Class constructor
	     *         this.parent(); // Call parent constructor
	     *     },
	     *
	     *     method: function() {
	     *         // Some method
	     *         this.parent(); // Call parent method
	     *     },
	     *
	     *     'static': {
	     *         staticMethod: function() {
	     *             // Static method
	     *         }
	     *     }
	     * });
	     *
	     * // Creates a singleton/static class
	     * tinymce.create('static tinymce.somepackage.SomeSingletonClass', {
	     *     method: function() {
	     *         // Some method
	     *     }
	     * });
	     */
	    var create = function (s, p, root) {
	      var self = this, sp, ns, cn, scn, c, de = 0;
	
	      // Parse : <prefix> <class>:<super class>
	      s = /^((static) )?([\w.]+)(:([\w.]+))?/.exec(s);
	      cn = s[3].match(/(^|\.)(\w+)$/i)[2]; // Class name
	
	      // Create namespace for new class
	      ns = self.createNS(s[3].replace(/\.\w+$/, ''), root);
	
	      // Class already exists
	      if (ns[cn]) {
	        return;
	      }
	
	      // Make pure static class
	      if (s[2] == 'static') {
	        ns[cn] = p;
	
	        if (this.onCreate) {
	          this.onCreate(s[2], s[3], ns[cn]);
	        }
	
	        return;
	      }
	
	      // Create default constructor
	      if (!p[cn]) {
	        p[cn] = function () { };
	        de = 1;
	      }
	
	      // Add constructor and methods
	      ns[cn] = p[cn];
	      self.extend(ns[cn].prototype, p);
	
	      // Extend
	      if (s[5]) {
	        sp = self.resolve(s[5]).prototype;
	        scn = s[5].match(/\.(\w+)$/i)[1]; // Class name
	
	        // Extend constructor
	        c = ns[cn];
	        if (de) {
	          // Add passthrough constructor
	          ns[cn] = function () {
	            return sp[scn].apply(this, arguments);
	          };
	        } else {
	          // Add inherit constructor
	          ns[cn] = function () {
	            this.parent = sp[scn];
	            return c.apply(this, arguments);
	          };
	        }
	        ns[cn].prototype[cn] = ns[cn];
	
	        // Add super methods
	        self.each(sp, function (f, n) {
	          ns[cn].prototype[n] = sp[n];
	        });
	
	        // Add overridden methods
	        self.each(p, function (f, n) {
	          // Extend methods if needed
	          if (sp[n]) {
	            ns[cn].prototype[n] = function () {
	              this.parent = sp[n];
	              return f.apply(this, arguments);
	            };
	          } else {
	            if (n != cn) {
	              ns[cn].prototype[n] = f;
	            }
	          }
	        });
	      }
	
	      // Add static methods
	      /*jshint sub:true*/
	      /*eslint dot-notation:0*/
	      self.each(p['static'], function (f, n) {
	        ns[cn][n] = f;
	      });
	    };
	
	    var extend = function (obj, ext) {
	      var i, l, name, args = arguments, value;
	
	      for (i = 1, l = args.length; i < l; i++) {
	        ext = args[i];
	        for (name in ext) {
	          if (ext.hasOwnProperty(name)) {
	            value = ext[name];
	
	            if (value !== undefined) {
	              obj[name] = value;
	            }
	          }
	        }
	      }
	
	      return obj;
	    };
	
	    /**
	     * Executed the specified function for each item in a object tree.
	     *
	     * @method walk
	     * @param {Object} o Object tree to walk though.
	     * @param {function} f Function to call for each item.
	     * @param {String} n Optional name of collection inside the objects to walk for example childNodes.
	     * @param {String} s Optional scope to execute the function in.
	     */
	    var walk = function (o, f, n, s) {
	      s = s || this;
	
	      if (o) {
	        if (n) {
	          o = o[n];
	        }
	
	        Arr.each(o, function (o, i) {
	          if (f.call(s, o, i, n) === false) {
	            return false;
	          }
	
	          walk(o, f, n, s);
	        });
	      }
	    };
	
	    /**
	     * Creates a namespace on a specific object.
	     *
	     * @method createNS
	     * @param {String} n Namespace to create for example a.b.c.d.
	     * @param {Object} o Optional object to add namespace to, defaults to window.
	     * @return {Object} New namespace object the last item in path.
	     * @example
	     * // Create some namespace
	     * tinymce.createNS('tinymce.somepackage.subpackage');
	     *
	     * // Add a singleton
	     * var tinymce.somepackage.subpackage.SomeSingleton = {
	     *     method: function() {
	     *         // Some method
	     *     }
	     * };
	     */
	    var createNS = function (n, o) {
	      var i, v;
	
	      o = o || window;
	
	      n = n.split('.');
	      for (i = 0; i < n.length; i++) {
	        v = n[i];
	
	        if (!o[v]) {
	          o[v] = {};
	        }
	
	        o = o[v];
	      }
	
	      return o;
	    };
	
	    /**
	     * Resolves a string and returns the object from a specific structure.
	     *
	     * @method resolve
	     * @param {String} n Path to resolve for example a.b.c.d.
	     * @param {Object} o Optional object to search though, defaults to window.
	     * @return {Object} Last object in path or null if it couldn't be resolved.
	     * @example
	     * // Resolve a path into an object reference
	     * var obj = tinymce.resolve('a.b.c.d');
	     */
	    var resolve = function (n, o) {
	      var i, l;
	
	      o = o || window;
	
	      n = n.split('.');
	      for (i = 0, l = n.length; i < l; i++) {
	        o = o[n[i]];
	
	        if (!o) {
	          break;
	        }
	      }
	
	      return o;
	    };
	
	    /**
	     * Splits a string but removes the whitespace before and after each value.
	     *
	     * @method explode
	     * @param {string} s String to split.
	     * @param {string} d Delimiter to split by.
	     * @example
	     * // Split a string into an array with a,b,c
	     * var arr = tinymce.explode('a, b,   c');
	     */
	    var explode = function (s, d) {
	      if (!s || is(s, 'array')) {
	        return s;
	      }
	
	      return Arr.map(s.split(d || ','), trim);
	    };
	
	    var _addCacheSuffix = function (url) {
	      var cacheSuffix = Env.cacheSuffix;
	
	      if (cacheSuffix) {
	        url += (url.indexOf('?') === -1 ? '?' : '&') + cacheSuffix;
	      }
	
	      return url;
	    };
	
	    return {
	      trim: trim,
	
	      /**
	       * Returns true/false if the object is an array or not.
	       *
	       * @method isArray
	       * @param {Object} obj Object to check.
	       * @return {boolean} true/false state if the object is an array or not.
	       */
	      isArray: Arr.isArray,
	
	      is: is,
	
	      /**
	       * Converts the specified object into a real JavaScript array.
	       *
	       * @method toArray
	       * @param {Object} obj Object to convert into array.
	       * @return {Array} Array object based in input.
	       */
	      toArray: Arr.toArray,
	      makeMap: makeMap,
	
	      /**
	       * Performs an iteration of all items in a collection such as an object or array. This method will execure the
	       * callback function for each item in the collection, if the callback returns false the iteration will terminate.
	       * The callback has the following format: cb(value, key_or_index).
	       *
	       * @method each
	       * @param {Object} o Collection to iterate.
	       * @param {function} cb Callback function to execute for each item.
	       * @param {Object} s Optional scope to execute the callback in.
	       * @example
	       * // Iterate an array
	       * tinymce.each([1,2,3], function(v, i) {
	       *     console.debug("Value: " + v + ", Index: " + i);
	       * });
	       *
	       * // Iterate an object
	       * tinymce.each({a: 1, b: 2, c: 3], function(v, k) {
	       *     console.debug("Value: " + v + ", Key: " + k);
	       * });
	       */
	      each: Arr.each,
	
	      /**
	       * Creates a new array by the return value of each iteration function call. This enables you to convert
	       * one array list into another.
	       *
	       * @method map
	       * @param {Array} array Array of items to iterate.
	       * @param {function} callback Function to call for each item. It's return value will be the new value.
	       * @return {Array} Array with new values based on function return values.
	       */
	      map: Arr.map,
	
	      /**
	       * Filters out items from the input array by calling the specified function for each item.
	       * If the function returns false the item will be excluded if it returns true it will be included.
	       *
	       * @method grep
	       * @param {Array} a Array of items to loop though.
	       * @param {function} f Function to call for each item. Include/exclude depends on it's return value.
	       * @return {Array} New array with values imported and filtered based in input.
	       * @example
	       * // Filter out some items, this will return an array with 4 and 5
	       * var items = tinymce.grep([1,2,3,4,5], function(v) {return v > 3;});
	       */
	      grep: Arr.filter,
	
	      /**
	       * Returns an index of the item or -1 if item is not present in the array.
	       *
	       * @method inArray
	       * @param {any} item Item to search for.
	       * @param {Array} arr Array to search in.
	       * @return {Number} index of the item or -1 if item was not found.
	       */
	      inArray: Arr.indexOf,
	
	      hasOwn: hasOwnProperty,
	
	      extend: extend,
	      create: create,
	      walk: walk,
	      createNS: createNS,
	      resolve: resolve,
	      explode: explode,
	      _addCacheSuffix: _addCacheSuffix
	    };
	  }
	);
	/**
	 * DomQuery.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class mimics most of the jQuery API:
	 *
	 * This is whats currently implemented:
	 * - Utility functions
	 * - DOM traversial
	 * - DOM manipulation
	 * - Event binding
	 *
	 * This is not currently implemented:
	 * - Dimension
	 * - Ajax
	 * - Animation
	 * - Advanced chaining
	 *
	 * @example
	 * var $ = tinymce.dom.DomQuery;
	 * $('p').attr('attr', 'value').addClass('class');
	 *
	 * @class tinymce.dom.DomQuery
	 */
	define(
	  'tinymce.core.dom.DomQuery',
	  [
	    'global!document',
	    'tinymce.core.dom.EventUtils',
	    'tinymce.core.dom.Sizzle',
	    'tinymce.core.Env',
	    'tinymce.core.util.Tools'
	  ],
	  function (document, EventUtils, Sizzle, Env, Tools) {
	    var doc = document, push = Array.prototype.push, slice = Array.prototype.slice;
	    var rquickExpr = /^(?:[^#<]*(<[\w\W]+>)[^>]*$|#([\w\-]*)$)/;
	    var Event = EventUtils.Event, undef;
	    var skipUniques = Tools.makeMap('children,contents,next,prev');
	
	    var isDefined = function (obj) {
	      return typeof obj !== 'undefined';
	    };
	
	    var isString = function (obj) {
	      return typeof obj === 'string';
	    };
	
	    var isWindow = function (obj) {
	      return obj && obj == obj.window;
	    };
	
	    var createFragment = function (html, fragDoc) {
	      var frag, node, container;
	
	      fragDoc = fragDoc || doc;
	      container = fragDoc.createElement('div');
	      frag = fragDoc.createDocumentFragment();
	      container.innerHTML = html;
	
	      while ((node = container.firstChild)) {
	        frag.appendChild(node);
	      }
	
	      return frag;
	    };
	
	    var domManipulate = function (targetNodes, sourceItem, callback, reverse) {
	      var i;
	
	      if (isString(sourceItem)) {
	        sourceItem = createFragment(sourceItem, getElementDocument(targetNodes[0]));
	      } else if (sourceItem.length && !sourceItem.nodeType) {
	        sourceItem = DomQuery.makeArray(sourceItem);
	
	        if (reverse) {
	          for (i = sourceItem.length - 1; i >= 0; i--) {
	            domManipulate(targetNodes, sourceItem[i], callback, reverse);
	          }
	        } else {
	          for (i = 0; i < sourceItem.length; i++) {
	            domManipulate(targetNodes, sourceItem[i], callback, reverse);
	          }
	        }
	
	        return targetNodes;
	      }
	
	      if (sourceItem.nodeType) {
	        i = targetNodes.length;
	        while (i--) {
	          callback.call(targetNodes[i], sourceItem);
	        }
	      }
	
	      return targetNodes;
	    };
	
	    var hasClass = function (node, className) {
	      return node && className && (' ' + node.className + ' ').indexOf(' ' + className + ' ') !== -1;
	    };
	
	    var wrap = function (elements, wrapper, all) {
	      var lastParent, newWrapper;
	
	      wrapper = DomQuery(wrapper)[0];
	
	      elements.each(function () {
	        var self = this;
	
	        if (!all || lastParent != self.parentNode) {
	          lastParent = self.parentNode;
	          newWrapper = wrapper.cloneNode(false);
	          self.parentNode.insertBefore(newWrapper, self);
	          newWrapper.appendChild(self);
	        } else {
	          newWrapper.appendChild(self);
	        }
	      });
	
	      return elements;
	    };
	
	    var numericCssMap = Tools.makeMap('fillOpacity fontWeight lineHeight opacity orphans widows zIndex zoom', ' ');
	    var booleanMap = Tools.makeMap('checked compact declare defer disabled ismap multiple nohref noshade nowrap readonly selected', ' ');
	    var propFix = {
	      'for': 'htmlFor',
	      'class': 'className',
	      'readonly': 'readOnly'
	    };
	    var cssFix = {
	      'float': 'cssFloat'
	    };
	
	    var attrHooks = {}, cssHooks = {};
	
	    var DomQuery = function (selector, context) {
	      /*eslint new-cap:0 */
	      return new DomQuery.fn.init(selector, context);
	    };
	
	    var inArray = function (item, array) {
	      var i;
	
	      if (array.indexOf) {
	        return array.indexOf(item);
	      }
	
	      i = array.length;
	      while (i--) {
	        if (array[i] === item) {
	          return i;
	        }
	      }
	
	      return -1;
	    };
	
	    var whiteSpaceRegExp = /^\s*|\s*$/g;
	
	    var trim = function (str) {
	      return (str === null || str === undef) ? '' : ("" + str).replace(whiteSpaceRegExp, '');
	    };
	
	    var each = function (obj, callback) {
	      var length, key, i, undef, value;
	
	      if (obj) {
	        length = obj.length;
	
	        if (length === undef) {
	          // Loop object items
	          for (key in obj) {
	            if (obj.hasOwnProperty(key)) {
	              value = obj[key];
	              if (callback.call(value, key, value) === false) {
	                break;
	              }
	            }
	          }
	        } else {
	          // Loop array items
	          for (i = 0; i < length; i++) {
	            value = obj[i];
	            if (callback.call(value, i, value) === false) {
	              break;
	            }
	          }
	        }
	      }
	
	      return obj;
	    };
	
	    var grep = function (array, callback) {
	      var out = [];
	
	      each(array, function (i, item) {
	        if (callback(item, i)) {
	          out.push(item);
	        }
	      });
	
	      return out;
	    };
	
	    var getElementDocument = function (element) {
	      if (!element) {
	        return doc;
	      }
	
	      if (element.nodeType == 9) {
	        return element;
	      }
	
	      return element.ownerDocument;
	    };
	
	    DomQuery.fn = DomQuery.prototype = {
	      constructor: DomQuery,
	
	      /**
	       * Selector for the current set.
	       *
	       * @property selector
	       * @type String
	       */
	      selector: "",
	
	      /**
	       * Context used to create the set.
	       *
	       * @property context
	       * @type Element
	       */
	      context: null,
	
	      /**
	       * Number of items in the current set.
	       *
	       * @property length
	       * @type Number
	       */
	      length: 0,
	
	      /**
	       * Constructs a new DomQuery instance with the specified selector or context.
	       *
	       * @constructor
	       * @method init
	       * @param {String/Array/DomQuery} selector Optional CSS selector/Array or array like object or HTML string.
	       * @param {Document/Element} context Optional context to search in.
	       */
	      init: function (selector, context) {
	        var self = this, match, node;
	
	        if (!selector) {
	          return self;
	        }
	
	        if (selector.nodeType) {
	          self.context = self[0] = selector;
	          self.length = 1;
	
	          return self;
	        }
	
	        if (context && context.nodeType) {
	          self.context = context;
	        } else {
	          if (context) {
	            return DomQuery(selector).attr(context);
	          }
	
	          self.context = context = document;
	        }
	
	        if (isString(selector)) {
	          self.selector = selector;
	
	          if (selector.charAt(0) === "<" && selector.charAt(selector.length - 1) === ">" && selector.length >= 3) {
	            match = [null, selector, null];
	          } else {
	            match = rquickExpr.exec(selector);
	          }
	
	          if (match) {
	            if (match[1]) {
	              node = createFragment(selector, getElementDocument(context)).firstChild;
	
	              while (node) {
	                push.call(self, node);
	                node = node.nextSibling;
	              }
	            } else {
	              node = getElementDocument(context).getElementById(match[2]);
	
	              if (!node) {
	                return self;
	              }
	
	              if (node.id !== match[2]) {
	                return self.find(selector);
	              }
	
	              self.length = 1;
	              self[0] = node;
	            }
	          } else {
	            return DomQuery(context).find(selector);
	          }
	        } else {
	          this.add(selector, false);
	        }
	
	        return self;
	      },
	
	      /**
	       * Converts the current set to an array.
	       *
	       * @method toArray
	       * @return {Array} Array of all nodes in set.
	       */
	      toArray: function () {
	        return Tools.toArray(this);
	      },
	
	      /**
	       * Adds new nodes to the set.
	       *
	       * @method add
	       * @param {Array/tinymce.core.dom.DomQuery} items Array of all nodes to add to set.
	       * @param {Boolean} sort Optional sort flag that enables sorting of elements.
	       * @return {tinymce.dom.DomQuery} New instance with nodes added.
	       */
	      add: function (items, sort) {
	        var self = this, nodes, i;
	
	        if (isString(items)) {
	          return self.add(DomQuery(items));
	        }
	
	        if (sort !== false) {
	          nodes = DomQuery.unique(self.toArray().concat(DomQuery.makeArray(items)));
	          self.length = nodes.length;
	          for (i = 0; i < nodes.length; i++) {
	            self[i] = nodes[i];
	          }
	        } else {
	          push.apply(self, DomQuery.makeArray(items));
	        }
	
	        return self;
	      },
	
	      /**
	       * Sets/gets attributes on the elements in the current set.
	       *
	       * @method attr
	       * @param {String/Object} name Name of attribute to get or an object with attributes to set.
	       * @param {String} value Optional value to set.
	       * @return {tinymce.dom.DomQuery/String} Current set or the specified attribute when only the name is specified.
	       */
	      attr: function (name, value) {
	        var self = this, hook;
	
	        if (typeof name === "object") {
	          each(name, function (name, value) {
	            self.attr(name, value);
	          });
	        } else if (isDefined(value)) {
	          this.each(function () {
	            var hook;
	
	            if (this.nodeType === 1) {
	              hook = attrHooks[name];
	              if (hook && hook.set) {
	                hook.set(this, value);
	                return;
	              }
	
	              if (value === null) {
	                this.removeAttribute(name, 2);
	              } else {
	                this.setAttribute(name, value, 2);
	              }
	            }
	          });
	        } else {
	          if (self[0] && self[0].nodeType === 1) {
	            hook = attrHooks[name];
	            if (hook && hook.get) {
	              return hook.get(self[0], name);
	            }
	
	            if (booleanMap[name]) {
	              return self.prop(name) ? name : undef;
	            }
	
	            value = self[0].getAttribute(name, 2);
	
	            if (value === null) {
	              value = undef;
	            }
	          }
	
	          return value;
	        }
	
	        return self;
	      },
	
	      /**
	       * Removes attributse on the elements in the current set.
	       *
	       * @method removeAttr
	       * @param {String/Object} name Name of attribute to remove.
	       * @return {tinymce.dom.DomQuery/String} Current set.
	       */
	      removeAttr: function (name) {
	        return this.attr(name, null);
	      },
	
	      /**
	       * Sets/gets properties on the elements in the current set.
	       *
	       * @method attr
	       * @param {String/Object} name Name of property to get or an object with properties to set.
	       * @param {String} value Optional value to set.
	       * @return {tinymce.dom.DomQuery/String} Current set or the specified property when only the name is specified.
	       */
	      prop: function (name, value) {
	        var self = this;
	
	        name = propFix[name] || name;
	
	        if (typeof name === "object") {
	          each(name, function (name, value) {
	            self.prop(name, value);
	          });
	        } else if (isDefined(value)) {
	          this.each(function () {
	            if (this.nodeType == 1) {
	              this[name] = value;
	            }
	          });
	        } else {
	          if (self[0] && self[0].nodeType && name in self[0]) {
	            return self[0][name];
	          }
	
	          return value;
	        }
	
	        return self;
	      },
	
	      /**
	       * Sets/gets styles on the elements in the current set.
	       *
	       * @method css
	       * @param {String/Object} name Name of style to get or an object with styles to set.
	       * @param {String} value Optional value to set.
	       * @return {tinymce.dom.DomQuery/String} Current set or the specified style when only the name is specified.
	       */
	      css: function (name, value) {
	        var self = this, elm, hook;
	
	        var camel = function (name) {
	          return name.replace(/-(\D)/g, function (a, b) {
	            return b.toUpperCase();
	          });
	        };
	
	        var dashed = function (name) {
	          return name.replace(/[A-Z]/g, function (a) {
	            return '-' + a;
	          });
	        };
	
	        if (typeof name === "object") {
	          each(name, function (name, value) {
	            self.css(name, value);
	          });
	        } else {
	          if (isDefined(value)) {
	            name = camel(name);
	
	            // Default px suffix on these
	            if (typeof value === 'number' && !numericCssMap[name]) {
	              value += 'px';
	            }
	
	            self.each(function () {
	              var style = this.style;
	
	              hook = cssHooks[name];
	              if (hook && hook.set) {
	                hook.set(this, value);
	                return;
	              }
	
	              try {
	                this.style[cssFix[name] || name] = value;
	              } catch (ex) {
	                // Ignore
	              }
	
	              if (value === null || value === '') {
	                if (style.removeProperty) {
	                  style.removeProperty(dashed(name));
	                } else {
	                  style.removeAttribute(name);
	                }
	              }
	            });
	          } else {
	            elm = self[0];
	
	            hook = cssHooks[name];
	            if (hook && hook.get) {
	              return hook.get(elm);
	            }
	
	            if (elm.ownerDocument.defaultView) {
	              try {
	                return elm.ownerDocument.defaultView.getComputedStyle(elm, null).getPropertyValue(dashed(name));
	              } catch (ex) {
	                return undef;
	              }
	            } else if (elm.currentStyle) {
	              return elm.currentStyle[camel(name)];
	            }
	          }
	        }
	
	        return self;
	      },
	
	      /**
	       * Removes all nodes in set from the document.
	       *
	       * @method remove
	       * @return {tinymce.dom.DomQuery} Current set with the removed nodes.
	       */
	      remove: function () {
	        var self = this, node, i = this.length;
	
	        while (i--) {
	          node = self[i];
	          Event.clean(node);
	
	          if (node.parentNode) {
	            node.parentNode.removeChild(node);
	          }
	        }
	
	        return this;
	      },
	
	      /**
	       * Empties all elements in set.
	       *
	       * @method empty
	       * @return {tinymce.dom.DomQuery} Current set with the empty nodes.
	       */
	      empty: function () {
	        var self = this, node, i = this.length;
	
	        while (i--) {
	          node = self[i];
	          while (node.firstChild) {
	            node.removeChild(node.firstChild);
	          }
	        }
	
	        return this;
	      },
	
	      /**
	       * Sets or gets the HTML of the current set or first set node.
	       *
	       * @method html
	       * @param {String} value Optional innerHTML value to set on each element.
	       * @return {tinymce.dom.DomQuery/String} Current set or the innerHTML of the first element.
	       */
	      html: function (value) {
	        var self = this, i;
	
	        if (isDefined(value)) {
	          i = self.length;
	
	          try {
	            while (i--) {
	              self[i].innerHTML = value;
	            }
	          } catch (ex) {
	            // Workaround for "Unknown runtime error" when DIV is added to P on IE
	            DomQuery(self[i]).empty().append(value);
	          }
	
	          return self;
	        }
	
	        return self[0] ? self[0].innerHTML : '';
	      },
	
	      /**
	       * Sets or gets the text of the current set or first set node.
	       *
	       * @method text
	       * @param {String} value Optional innerText value to set on each element.
	       * @return {tinymce.dom.DomQuery/String} Current set or the innerText of the first element.
	       */
	      text: function (value) {
	        var self = this, i;
	
	        if (isDefined(value)) {
	          i = self.length;
	          while (i--) {
	            if ("innerText" in self[i]) {
	              self[i].innerText = value;
	            } else {
	              self[0].textContent = value;
	            }
	          }
	
	          return self;
	        }
	
	        return self[0] ? (self[0].innerText || self[0].textContent) : '';
	      },
	
	      /**
	       * Appends the specified node/html or node set to the current set nodes.
	       *
	       * @method append
	       * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to append to each element in set.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      append: function () {
	        return domManipulate(this, arguments, function (node) {
	          // Either element or Shadow Root
	          if (this.nodeType === 1 || (this.host && this.host.nodeType === 1)) {
	            this.appendChild(node);
	          }
	        });
	      },
	
	      /**
	       * Prepends the specified node/html or node set to the current set nodes.
	       *
	       * @method prepend
	       * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to prepend to each element in set.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      prepend: function () {
	        return domManipulate(this, arguments, function (node) {
	          // Either element or Shadow Root
	          if (this.nodeType === 1 || (this.host && this.host.nodeType === 1)) {
	            this.insertBefore(node, this.firstChild);
	          }
	        }, true);
	      },
	
	      /**
	       * Adds the specified elements before current set nodes.
	       *
	       * @method before
	       * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to add before to each element in set.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      before: function () {
	        var self = this;
	
	        if (self[0] && self[0].parentNode) {
	          return domManipulate(self, arguments, function (node) {
	            this.parentNode.insertBefore(node, this);
	          });
	        }
	
	        return self;
	      },
	
	      /**
	       * Adds the specified elements after current set nodes.
	       *
	       * @method after
	       * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to add after to each element in set.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      after: function () {
	        var self = this;
	
	        if (self[0] && self[0].parentNode) {
	          return domManipulate(self, arguments, function (node) {
	            this.parentNode.insertBefore(node, this.nextSibling);
	          }, true);
	        }
	
	        return self;
	      },
	
	      /**
	       * Appends the specified set nodes to the specified selector/instance.
	       *
	       * @method appendTo
	       * @param {String/Element/Array/tinymce.dom.DomQuery} val Item to append the current set to.
	       * @return {tinymce.dom.DomQuery} Current set with the appended nodes.
	       */
	      appendTo: function (val) {
	        DomQuery(val).append(this);
	
	        return this;
	      },
	
	      /**
	       * Prepends the specified set nodes to the specified selector/instance.
	       *
	       * @method prependTo
	       * @param {String/Element/Array/tinymce.dom.DomQuery} val Item to prepend the current set to.
	       * @return {tinymce.dom.DomQuery} Current set with the prepended nodes.
	       */
	      prependTo: function (val) {
	        DomQuery(val).prepend(this);
	
	        return this;
	      },
	
	      /**
	       * Replaces the nodes in set with the specified content.
	       *
	       * @method replaceWith
	       * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to replace nodes with.
	       * @return {tinymce.dom.DomQuery} Set with replaced nodes.
	       */
	      replaceWith: function (content) {
	        return this.before(content).remove();
	      },
	
	      /**
	       * Wraps all elements in set with the specified wrapper.
	       *
	       * @method wrap
	       * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to wrap nodes with.
	       * @return {tinymce.dom.DomQuery} Set with wrapped nodes.
	       */
	      wrap: function (content) {
	        return wrap(this, content);
	      },
	
	      /**
	       * Wraps all nodes in set with the specified wrapper. If the nodes are siblings all of them
	       * will be wrapped in the same wrapper.
	       *
	       * @method wrapAll
	       * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to wrap nodes with.
	       * @return {tinymce.dom.DomQuery} Set with wrapped nodes.
	       */
	      wrapAll: function (content) {
	        return wrap(this, content, true);
	      },
	
	      /**
	       * Wraps all elements inner contents in set with the specified wrapper.
	       *
	       * @method wrapInner
	       * @param {String/Element/Array/tinymce.dom.DomQuery} content Content to wrap nodes with.
	       * @return {tinymce.dom.DomQuery} Set with wrapped nodes.
	       */
	      wrapInner: function (content) {
	        this.each(function () {
	          DomQuery(this).contents().wrapAll(content);
	        });
	
	        return this;
	      },
	
	      /**
	       * Unwraps all elements by removing the parent element of each item in set.
	       *
	       * @method unwrap
	       * @return {tinymce.dom.DomQuery} Set with unwrapped nodes.
	       */
	      unwrap: function () {
	        return this.parent().each(function () {
	          DomQuery(this).replaceWith(this.childNodes);
	        });
	      },
	
	      /**
	       * Clones all nodes in set.
	       *
	       * @method clone
	       * @return {tinymce.dom.DomQuery} Set with cloned nodes.
	       */
	      clone: function () {
	        var result = [];
	
	        this.each(function () {
	          result.push(this.cloneNode(true));
	        });
	
	        return DomQuery(result);
	      },
	
	      /**
	       * Adds the specified class name to the current set elements.
	       *
	       * @method addClass
	       * @param {String} className Class name to add.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      addClass: function (className) {
	        return this.toggleClass(className, true);
	      },
	
	      /**
	       * Removes the specified class name to the current set elements.
	       *
	       * @method removeClass
	       * @param {String} className Class name to remove.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      removeClass: function (className) {
	        return this.toggleClass(className, false);
	      },
	
	      /**
	       * Toggles the specified class name on the current set elements.
	       *
	       * @method toggleClass
	       * @param {String} className Class name to add/remove.
	       * @param {Boolean} state Optional state to toggle on/off.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      toggleClass: function (className, state) {
	        var self = this;
	
	        // Functions are not supported
	        if (typeof className != 'string') {
	          return self;
	        }
	
	        if (className.indexOf(' ') !== -1) {
	          each(className.split(' '), function () {
	            self.toggleClass(this, state);
	          });
	        } else {
	          self.each(function (index, node) {
	            var existingClassName, classState;
	
	            classState = hasClass(node, className);
	            if (classState !== state) {
	              existingClassName = node.className;
	
	              if (classState) {
	                node.className = trim((" " + existingClassName + " ").replace(' ' + className + ' ', ' '));
	              } else {
	                node.className += existingClassName ? ' ' + className : className;
	              }
	            }
	          });
	        }
	
	        return self;
	      },
	
	      /**
	       * Returns true/false if the first item in set has the specified class.
	       *
	       * @method hasClass
	       * @param {String} className Class name to check for.
	       * @return {Boolean} True/false if the set has the specified class.
	       */
	      hasClass: function (className) {
	        return hasClass(this[0], className);
	      },
	
	      /**
	       * Executes the callback function for each item DomQuery collection. If you return false in the
	       * callback it will break the loop.
	       *
	       * @method each
	       * @param {function} callback Callback function to execute for each item.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      each: function (callback) {
	        return each(this, callback);
	      },
	
	      /**
	       * Binds an event with callback function to the elements in set.
	       *
	       * @method on
	       * @param {String} name Name of the event to bind.
	       * @param {function} callback Callback function to execute when the event occurs.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      on: function (name, callback) {
	        return this.each(function () {
	          Event.bind(this, name, callback);
	        });
	      },
	
	      /**
	       * Unbinds an event with callback function to the elements in set.
	       *
	       * @method off
	       * @param {String} name Optional name of the event to bind.
	       * @param {function} callback Optional callback function to execute when the event occurs.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      off: function (name, callback) {
	        return this.each(function () {
	          Event.unbind(this, name, callback);
	        });
	      },
	
	      /**
	       * Triggers the specified event by name or event object.
	       *
	       * @method trigger
	       * @param {String/Object} name Name of the event to trigger or event object.
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      trigger: function (name) {
	        return this.each(function () {
	          if (typeof name == 'object') {
	            Event.fire(this, name.type, name);
	          } else {
	            Event.fire(this, name);
	          }
	        });
	      },
	
	      /**
	       * Shows all elements in set.
	       *
	       * @method show
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      show: function () {
	        return this.css('display', '');
	      },
	
	      /**
	       * Hides all elements in set.
	       *
	       * @method hide
	       * @return {tinymce.dom.DomQuery} Current set.
	       */
	      hide: function () {
	        return this.css('display', 'none');
	      },
	
	      /**
	       * Slices the current set.
	       *
	       * @method slice
	       * @param {Number} start Start index to slice at.
	       * @param {Number} end Optional end index to end slice at.
	       * @return {tinymce.dom.DomQuery} Sliced set.
	       */
	      slice: function () {
	        return new DomQuery(slice.apply(this, arguments));
	      },
	
	      /**
	       * Makes the set equal to the specified index.
	       *
	       * @method eq
	       * @param {Number} index Index to set it equal to.
	       * @return {tinymce.dom.DomQuery} Single item set.
	       */
	      eq: function (index) {
	        return index === -1 ? this.slice(index) : this.slice(index, +index + 1);
	      },
	
	      /**
	       * Makes the set equal to first element in set.
	       *
	       * @method first
	       * @return {tinymce.dom.DomQuery} Single item set.
	       */
	      first: function () {
	        return this.eq(0);
	      },
	
	      /**
	       * Makes the set equal to last element in set.
	       *
	       * @method last
	       * @return {tinymce.dom.DomQuery} Single item set.
	       */
	      last: function () {
	        return this.eq(-1);
	      },
	
	      /**
	       * Finds elements by the specified selector for each element in set.
	       *
	       * @method find
	       * @param {String} selector Selector to find elements by.
	       * @return {tinymce.dom.DomQuery} Set with matches elements.
	       */
	      find: function (selector) {
	        var i, l, ret = [];
	
	        for (i = 0, l = this.length; i < l; i++) {
	          DomQuery.find(selector, this[i], ret);
	        }
	
	        return DomQuery(ret);
	      },
	
	      /**
	       * Filters the current set with the specified selector.
	       *
	       * @method filter
	       * @param {String/function} selector Selector to filter elements by.
	       * @return {tinymce.dom.DomQuery} Set with filtered elements.
	       */
	      filter: function (selector) {
	        if (typeof selector == 'function') {
	          return DomQuery(grep(this.toArray(), function (item, i) {
	            return selector(i, item);
	          }));
	        }
	
	        return DomQuery(DomQuery.filter(selector, this.toArray()));
	      },
	
	      /**
	       * Gets the current node or any parent matching the specified selector.
	       *
	       * @method closest
	       * @param {String/Element/tinymce.dom.DomQuery} selector Selector or element to find.
	       * @return {tinymce.dom.DomQuery} Set with closest elements.
	       */
	      closest: function (selector) {
	        var result = [];
	
	        if (selector instanceof DomQuery) {
	          selector = selector[0];
	        }
	
	        this.each(function (i, node) {
	          while (node) {
	            if (typeof selector == 'string' && DomQuery(node).is(selector)) {
	              result.push(node);
	              break;
	            } else if (node == selector) {
	              result.push(node);
	              break;
	            }
	
	            node = node.parentNode;
	          }
	        });
	
	        return DomQuery(result);
	      },
	
	      /**
	       * Returns the offset of the first element in set or sets the top/left css properties of all elements in set.
	       *
	       * @method offset
	       * @param {Object} offset Optional offset object to set on each item.
	       * @return {Object/tinymce.dom.DomQuery} Returns the first element offset or the current set if you specified an offset.
	       */
	      offset: function (offset) {
	        var elm, doc, docElm;
	        var x = 0, y = 0, pos;
	
	        if (!offset) {
	          elm = this[0];
	
	          if (elm) {
	            doc = elm.ownerDocument;
	            docElm = doc.documentElement;
	
	            if (elm.getBoundingClientRect) {
	              pos = elm.getBoundingClientRect();
	              x = pos.left + (docElm.scrollLeft || doc.body.scrollLeft) - docElm.clientLeft;
	              y = pos.top + (docElm.scrollTop || doc.body.scrollTop) - docElm.clientTop;
	            }
	          }
	
	          return {
	            left: x,
	            top: y
	          };
	        }
	
	        return this.css(offset);
	      },
	
	      push: push,
	      sort: [].sort,
	      splice: [].splice
	    };
	
	    // Static members
	    Tools.extend(DomQuery, {
	      /**
	       * Extends the specified object with one or more objects.
	       *
	       * @static
	       * @method extend
	       * @param {Object} target Target object to extend with new items.
	       * @param {Object..} object Object to extend the target with.
	       * @return {Object} Extended input object.
	       */
	      extend: Tools.extend,
	
	      /**
	       * Creates an array out of an array like object.
	       *
	       * @static
	       * @method makeArray
	       * @param {Object} object Object to convert to array.
	       * @return {Array} Array produced from object.
	       */
	      makeArray: function (object) {
	        if (isWindow(object) || object.nodeType) {
	          return [object];
	        }
	
	        return Tools.toArray(object);
	      },
	
	      /**
	       * Returns the index of the specified item inside the array.
	       *
	       * @static
	       * @method inArray
	       * @param {Object} item Item to look for.
	       * @param {Array} array Array to look for item in.
	       * @return {Number} Index of the item or -1.
	       */
	      inArray: inArray,
	
	      /**
	       * Returns true/false if the specified object is an array or not.
	       *
	       * @static
	       * @method isArray
	       * @param {Object} array Object to check if it's an array or not.
	       * @return {Boolean} True/false if the object is an array.
	       */
	      isArray: Tools.isArray,
	
	      /**
	       * Executes the callback function for each item in array/object. If you return false in the
	       * callback it will break the loop.
	       *
	       * @static
	       * @method each
	       * @param {Object} obj Object to iterate.
	       * @param {function} callback Callback function to execute for each item.
	       */
	      each: each,
	
	      /**
	       * Removes whitespace from the beginning and end of a string.
	       *
	       * @static
	       * @method trim
	       * @param {String} str String to remove whitespace from.
	       * @return {String} New string with removed whitespace.
	       */
	      trim: trim,
	
	      /**
	       * Filters out items from the input array by calling the specified function for each item.
	       * If the function returns false the item will be excluded if it returns true it will be included.
	       *
	       * @static
	       * @method grep
	       * @param {Array} array Array of items to loop though.
	       * @param {function} callback Function to call for each item. Include/exclude depends on it's return value.
	       * @return {Array} New array with values imported and filtered based in input.
	       * @example
	       * // Filter out some items, this will return an array with 4 and 5
	       * var items = DomQuery.grep([1, 2, 3, 4, 5], function(v) {return v > 3;});
	       */
	      grep: grep,
	
	      // Sizzle
	      find: Sizzle,
	      expr: Sizzle.selectors,
	      unique: Sizzle.uniqueSort,
	      text: Sizzle.getText,
	      contains: Sizzle.contains,
	      filter: function (expr, elems, not) {
	        var i = elems.length;
	
	        if (not) {
	          expr = ":not(" + expr + ")";
	        }
	
	        while (i--) {
	          if (elems[i].nodeType != 1) {
	            elems.splice(i, 1);
	          }
	        }
	
	        if (elems.length === 1) {
	          elems = DomQuery.find.matchesSelector(elems[0], expr) ? [elems[0]] : [];
	        } else {
	          elems = DomQuery.find.matches(expr, elems);
	        }
	
	        return elems;
	      }
	    });
	
	    var dir = function (el, prop, until) {
	      var matched = [], cur = el[prop];
	
	      if (typeof until != 'string' && until instanceof DomQuery) {
	        until = until[0];
	      }
	
	      while (cur && cur.nodeType !== 9) {
	        if (until !== undefined) {
	          if (cur === until) {
	            break;
	          }
	
	          if (typeof until == 'string' && DomQuery(cur).is(until)) {
	            break;
	          }
	        }
	
	        if (cur.nodeType === 1) {
	          matched.push(cur);
	        }
	
	        cur = cur[prop];
	      }
	
	      return matched;
	    };
	
	    var sibling = function (node, siblingName, nodeType, until) {
	      var result = [];
	
	      if (until instanceof DomQuery) {
	        until = until[0];
	      }
	
	      for (; node; node = node[siblingName]) {
	        if (nodeType && node.nodeType !== nodeType) {
	          continue;
	        }
	
	        if (until !== undefined) {
	          if (node === until) {
	            break;
	          }
	
	          if (typeof until == 'string' && DomQuery(node).is(until)) {
	            break;
	          }
	        }
	
	        result.push(node);
	      }
	
	      return result;
	    };
	
	    var firstSibling = function (node, siblingName, nodeType) {
	      for (node = node[siblingName]; node; node = node[siblingName]) {
	        if (node.nodeType == nodeType) {
	          return node;
	        }
	      }
	
	      return null;
	    };
	
	    each({
	      /**
	       * Returns a new collection with the parent of each item in current collection matching the optional selector.
	       *
	       * @method parent
	       * @param {Element/tinymce.dom.DomQuery} node Node to match parents against.
	       * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching parents.
	       */
	      parent: function (node) {
	        var parent = node.parentNode;
	
	        return parent && parent.nodeType !== 11 ? parent : null;
	      },
	
	      /**
	       * Returns a new collection with the all the parents of each item in current collection matching the optional selector.
	       *
	       * @method parents
	       * @param {Element/tinymce.dom.DomQuery} node Node to match parents against.
	       * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching parents.
	       */
	      parents: function (node) {
	        return dir(node, "parentNode");
	      },
	
	      /**
	       * Returns a new collection with next sibling of each item in current collection matching the optional selector.
	       *
	       * @method next
	       * @param {Element/tinymce.dom.DomQuery} node Node to match the next element against.
	       * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
	       */
	      next: function (node) {
	        return firstSibling(node, 'nextSibling', 1);
	      },
	
	      /**
	       * Returns a new collection with previous sibling of each item in current collection matching the optional selector.
	       *
	       * @method prev
	       * @param {Element/tinymce.dom.DomQuery} node Node to match the previous element against.
	       * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
	       */
	      prev: function (node) {
	        return firstSibling(node, 'previousSibling', 1);
	      },
	
	      /**
	       * Returns all child elements matching the optional selector.
	       *
	       * @method children
	       * @param {Element/tinymce.dom.DomQuery} node Node to match the elements against.
	       * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
	       */
	      children: function (node) {
	        return sibling(node.firstChild, 'nextSibling', 1);
	      },
	
	      /**
	       * Returns all child nodes matching the optional selector.
	       *
	       * @method contents
	       * @param {Element/tinymce.dom.DomQuery} node Node to get the contents of.
	       * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
	       */
	      contents: function (node) {
	        return Tools.toArray((node.nodeName === "iframe" ? node.contentDocument || node.contentWindow.document : node).childNodes);
	      }
	    }, function (name, fn) {
	      DomQuery.fn[name] = function (selector) {
	        var self = this, result = [];
	
	        self.each(function () {
	          var nodes = fn.call(result, this, selector, result);
	
	          if (nodes) {
	            if (DomQuery.isArray(nodes)) {
	              result.push.apply(result, nodes);
	            } else {
	              result.push(nodes);
	            }
	          }
	        });
	
	        // If traversing on multiple elements we might get the same elements twice
	        if (this.length > 1) {
	          if (!skipUniques[name]) {
	            result = DomQuery.unique(result);
	          }
	
	          if (name.indexOf('parents') === 0) {
	            result = result.reverse();
	          }
	        }
	
	        result = DomQuery(result);
	
	        if (selector) {
	          return result.filter(selector);
	        }
	
	        return result;
	      };
	    });
	
	    each({
	      /**
	       * Returns a new collection with the all the parents until the matching selector/element
	       * of each item in current collection matching the optional selector.
	       *
	       * @method parentsUntil
	       * @param {Element/tinymce.dom.DomQuery} node Node to find parent of.
	       * @param {String/Element/tinymce.dom.DomQuery} until Until the matching selector or element.
	       * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching parents.
	       */
	      parentsUntil: function (node, until) {
	        return dir(node, "parentNode", until);
	      },
	
	      /**
	       * Returns a new collection with all next siblings of each item in current collection matching the optional selector.
	       *
	       * @method nextUntil
	       * @param {Element/tinymce.dom.DomQuery} node Node to find next siblings on.
	       * @param {String/Element/tinymce.dom.DomQuery} until Until the matching selector or element.
	       * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
	       */
	      nextUntil: function (node, until) {
	        return sibling(node, 'nextSibling', 1, until).slice(1);
	      },
	
	      /**
	       * Returns a new collection with all previous siblings of each item in current collection matching the optional selector.
	       *
	       * @method prevUntil
	       * @param {Element/tinymce.dom.DomQuery} node Node to find previous siblings on.
	       * @param {String/Element/tinymce.dom.DomQuery} until Until the matching selector or element.
	       * @return {tinymce.dom.DomQuery} New DomQuery instance with all matching elements.
	       */
	      prevUntil: function (node, until) {
	        return sibling(node, 'previousSibling', 1, until).slice(1);
	      }
	    }, function (name, fn) {
	      DomQuery.fn[name] = function (selector, filter) {
	        var self = this, result = [];
	
	        self.each(function () {
	          var nodes = fn.call(result, this, selector, result);
	
	          if (nodes) {
	            if (DomQuery.isArray(nodes)) {
	              result.push.apply(result, nodes);
	            } else {
	              result.push(nodes);
	            }
	          }
	        });
	
	        // If traversing on multiple elements we might get the same elements twice
	        if (this.length > 1) {
	          result = DomQuery.unique(result);
	
	          if (name.indexOf('parents') === 0 || name === 'prevUntil') {
	            result = result.reverse();
	          }
	        }
	
	        result = DomQuery(result);
	
	        if (filter) {
	          return result.filter(filter);
	        }
	
	        return result;
	      };
	    });
	
	    /**
	     * Returns true/false if the current set items matches the selector.
	     *
	     * @method is
	     * @param {String} selector Selector to match the elements against.
	     * @return {Boolean} True/false if the current set matches the selector.
	     */
	    DomQuery.fn.is = function (selector) {
	      return !!selector && this.filter(selector).length > 0;
	    };
	
	    DomQuery.fn.init.prototype = DomQuery.fn;
	
	    DomQuery.overrideDefaults = function (callback) {
	      var defaults;
	
	      var sub = function (selector, context) {
	        defaults = defaults || callback();
	
	        if (arguments.length === 0) {
	          selector = defaults.element;
	        }
	
	        if (!context) {
	          context = defaults.context;
	        }
	
	        return new sub.fn.init(selector, context);
	      };
	
	      DomQuery.extend(sub, this);
	
	      return sub;
	    };
	
	    var appendHooks = function (targetHooks, prop, hooks) {
	      each(hooks, function (name, func) {
	        targetHooks[name] = targetHooks[name] || {};
	        targetHooks[name][prop] = func;
	      });
	    };
	
	    if (Env.ie && Env.ie < 8) {
	      appendHooks(attrHooks, 'get', {
	        maxlength: function (elm) {
	          var value = elm.maxLength;
	
	          if (value === 0x7fffffff) {
	            return undef;
	          }
	
	          return value;
	        },
	
	        size: function (elm) {
	          var value = elm.size;
	
	          if (value === 20) {
	            return undef;
	          }
	
	          return value;
	        },
	
	        'class': function (elm) {
	          return elm.className;
	        },
	
	        style: function (elm) {
	          var value = elm.style.cssText;
	
	          if (value.length === 0) {
	            return undef;
	          }
	
	          return value;
	        }
	      });
	
	      appendHooks(attrHooks, 'set', {
	        'class': function (elm, value) {
	          elm.className = value;
	        },
	
	        style: function (elm, value) {
	          elm.style.cssText = value;
	        }
	      });
	    }
	
	    if (Env.ie && Env.ie < 9) {
	      /*jshint sub:true */
	      /*eslint dot-notation: 0*/
	      cssFix['float'] = 'styleFloat';
	
	      appendHooks(cssHooks, 'set', {
	        opacity: function (elm, value) {
	          var style = elm.style;
	
	          if (value === null || value === '') {
	            style.removeAttribute('filter');
	          } else {
	            style.zoom = 1;
	            style.filter = 'alpha(opacity=' + (value * 100) + ')';
	          }
	        }
	      });
	    }
	
	    DomQuery.attrHooks = attrHooks;
	    DomQuery.cssHooks = cssHooks;
	
	    return DomQuery;
	  }
	);
	
	define(
	  'ephox.katamari.api.Thunk',
	
	  [
	  ],
	
	  function () {
	
	    var cached = function (f) {
	      var called = false;
	      var r;
	      return function() {
	        if (!called) {
	          called = true;
	          r = f.apply(null, arguments);
	        }
	        return r;
	      };
	    };
	
	    return {
	      cached: cached
	    };
	  }
	);
	
	defineGlobal("global!Number", Number);
	define(
	  'ephox.sand.detect.Version',
	
	  [
	    'ephox.katamari.api.Arr',
	    'global!Number',
	    'global!String'
	  ],
	
	  function (Arr, Number, String) {
	    var firstMatch = function (regexes, s) {
	      for (var i = 0; i < regexes.length; i++) {
	        var x = regexes[i];
	        if (x.test(s)) return x;
	      }
	      return undefined;
	    };
	
	    var find = function (regexes, agent) {
	      var r = firstMatch(regexes, agent);
	      if (!r) return { major : 0, minor : 0 };
	      var group = function(i) {
	        return Number(agent.replace(r, '$' + i));
	      };
	      return nu(group(1), group(2));
	    };
	
	    var detect = function (versionRegexes, agent) {
	      var cleanedAgent = String(agent).toLowerCase();
	
	      if (versionRegexes.length === 0) return unknown();
	      return find(versionRegexes, cleanedAgent);
	    };
	
	    var unknown = function () {
	      return nu(0, 0);
	    };
	
	    var nu = function (major, minor) {
	      return { major: major, minor: minor };
	    };
	
	    return {
	      nu: nu,
	      detect: detect,
	      unknown: unknown
	    };
	  }
	);
	define(
	  'ephox.sand.core.Browser',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.sand.detect.Version'
	  ],
	
	  function (Fun, Version) {
	    var edge = 'Edge';
	    var chrome = 'Chrome';
	    var ie = 'IE';
	    var opera = 'Opera';
	    var firefox = 'Firefox';
	    var safari = 'Safari';
	
	    var isBrowser = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	
	    var unknown = function () {
	      return nu({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	
	    var nu = function (info) {
	      var current = info.current;
	      var version = info.version;
	
	      return {
	        current: current,
	        version: version,
	
	        // INVESTIGATE: Rename to Edge ?
	        isEdge: isBrowser(edge, current),
	        isChrome: isBrowser(chrome, current),
	        // NOTE: isIe just looks too weird
	        isIE: isBrowser(ie, current),
	        isOpera: isBrowser(opera, current),
	        isFirefox: isBrowser(firefox, current),
	        isSafari: isBrowser(safari, current)
	      };
	    };
	
	    return {
	      unknown: unknown,
	      nu: nu,
	      edge: Fun.constant(edge),
	      chrome: Fun.constant(chrome),
	      ie: Fun.constant(ie),
	      opera: Fun.constant(opera),
	      firefox: Fun.constant(firefox),
	      safari: Fun.constant(safari)
	    };
	  }
	);
	define(
	  'ephox.sand.core.OperatingSystem',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.sand.detect.Version'
	  ],
	
	  function (Fun, Version) {
	    var windows = 'Windows';
	    var ios = 'iOS';
	    var android = 'Android';
	    var linux = 'Linux';
	    var osx = 'OSX';
	    var solaris = 'Solaris';
	    var freebsd = 'FreeBSD';
	
	    // Though there is a bit of dupe with this and Browser, trying to 
	    // reuse code makes it much harder to follow and change.
	    var isOS = function (name, current) {
	      return function () {
	        return current === name;
	      };
	    };
	
	    var unknown = function () {
	      return nu({
	        current: undefined,
	        version: Version.unknown()
	      });
	    };
	
	    var nu = function (info) {
	      var current = info.current;
	      var version = info.version;
	
	      return {
	        current: current,
	        version: version,
	
	        isWindows: isOS(windows, current),
	        // TODO: Fix capitalisation
	        isiOS: isOS(ios, current),
	        isAndroid: isOS(android, current),
	        isOSX: isOS(osx, current),
	        isLinux: isOS(linux, current),
	        isSolaris: isOS(solaris, current),
	        isFreeBSD: isOS(freebsd, current)
	      };
	    };
	
	    return {
	      unknown: unknown,
	      nu: nu,
	
	      windows: Fun.constant(windows),
	      ios: Fun.constant(ios),
	      android: Fun.constant(android),
	      linux: Fun.constant(linux),
	      osx: Fun.constant(osx),
	      solaris: Fun.constant(solaris),
	      freebsd: Fun.constant(freebsd)
	    };
	  }
	);
	define(
	  'ephox.sand.detect.DeviceType',
	
	  [
	    'ephox.katamari.api.Fun'
	  ],
	
	  function (Fun) {
	    return function (os, browser, userAgent) {
	      var isiPad = os.isiOS() && /ipad/i.test(userAgent) === true;
	      var isiPhone = os.isiOS() && !isiPad;
	      var isAndroid3 = os.isAndroid() && os.version.major === 3;
	      var isAndroid4 = os.isAndroid() && os.version.major === 4;
	      var isTablet = isiPad || isAndroid3 || ( isAndroid4 && /mobile/i.test(userAgent) === true );
	      var isTouch = os.isiOS() || os.isAndroid();
	      var isPhone = isTouch && !isTablet;
	
	      var iOSwebview = browser.isSafari() && os.isiOS() && /safari/i.test(userAgent) === false;
	
	      return {
	        isiPad : Fun.constant(isiPad),
	        isiPhone: Fun.constant(isiPhone),
	        isTablet: Fun.constant(isTablet),
	        isPhone: Fun.constant(isPhone),
	        isTouch: Fun.constant(isTouch),
	        isAndroid: os.isAndroid,
	        isiOS: os.isiOS,
	        isWebView: Fun.constant(iOSwebview)
	      };
	    };
	  }
	);
	define(
	  'ephox.sand.detect.UaString',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sand.detect.Version',
	    'global!String'
	  ],
	
	  function (Arr, Version, String) {
	    var detect = function (candidates, userAgent) {
	      var agent = String(userAgent).toLowerCase();
	      return Arr.find(candidates, function (candidate) {
	        return candidate.search(agent);
	      });
	    };
	
	    // They (browser and os) are the same at the moment, but they might
	    // not stay that way.
	    var detectBrowser = function (browsers, userAgent) {
	      return detect(browsers, userAgent).map(function (browser) {
	        var version = Version.detect(browser.versionRegexes, userAgent);
	        return {
	          current: browser.name,
	          version: version
	        };
	      });
	    };
	
	    var detectOs = function (oses, userAgent) {
	      return detect(oses, userAgent).map(function (os) {
	        var version = Version.detect(os.versionRegexes, userAgent);
	        return {
	          current: os.name,
	          version: version
	        };
	      });
	    };
	
	    return {
	      detectBrowser: detectBrowser,
	      detectOs: detectOs
	    };
	  }
	);
	define(
	  'ephox.katamari.str.StrAppend',
	
	  [
	
	  ],
	
	  function () {
	    var addToStart = function (str, prefix) {
	      return prefix + str;
	    };
	
	    var addToEnd = function (str, suffix) {
	      return str + suffix;
	    };
	
	    var removeFromStart = function (str, numChars) {
	      return str.substring(numChars);
	    };
	
	    var removeFromEnd = function (str, numChars) {
	      return str.substring(0, str.length - numChars);
	    };
	 
	    return {
	      addToStart: addToStart,
	      addToEnd: addToEnd,
	      removeFromStart: removeFromStart,
	      removeFromEnd: removeFromEnd
	    };
	  }
	);
	define(
	  'ephox.katamari.str.StringParts',
	
	  [
	    'ephox.katamari.api.Option',
	    'global!Error'
	  ],
	
	  function (Option, Error) {
	    /** Return the first 'count' letters from 'str'.
	-     *  e.g. first("abcde", 2) === "ab"
	-     */
	    var first = function(str, count) {
	     return str.substr(0, count);
	    };
	
	    /** Return the last 'count' letters from 'str'.
	    *  e.g. last("abcde", 2) === "de"
	    */
	    var last = function(str, count) {
	     return str.substr(str.length - count, str.length);
	    };
	
	    var head = function(str) {
	      return str === '' ? Option.none() : Option.some(str.substr(0, 1));
	    };
	
	    var tail = function(str) {
	      return str === '' ? Option.none() : Option.some(str.substring(1));
	    };
	
	    return {
	      first: first,
	      last: last,
	      head: head,
	      tail: tail
	    };
	  }
	);
	define(
	  'ephox.katamari.api.Strings',
	
	  [
	    'ephox.katamari.str.StrAppend',
	    'ephox.katamari.str.StringParts',
	    'global!Error'
	  ],
	
	  function (StrAppend, StringParts, Error) {
	    var checkRange = function(str, substr, start) {
	      if (substr === '') return true;
	      if (str.length < substr.length) return false;
	      var x = str.substr(start, start + substr.length);
	      return x === substr;
	    };
	
	    /** Given a string and object, perform template-replacements on the string, as specified by the object.
	     * Any template fields of the form ${name} are replaced by the string or number specified as obj["name"]
	     * Based on Douglas Crockford's 'supplant' method for template-replace of strings. Uses different template format.
	     */
	    var supplant = function(str, obj) {
	      var isStringOrNumber = function(a) {
	        var t = typeof a;
	        return t === 'string' || t === 'number';
	      };
	
	      return str.replace(/\${([^{}]*)}/g,
	        function (a, b) {
	          var value = obj[b];
	          return isStringOrNumber(value) ? value : a;
	        }
	      );
	    };
	
	    var removeLeading = function (str, prefix) {
	      return startsWith(str, prefix) ? StrAppend.removeFromStart(str, prefix.length) : str;
	    };
	
	    var removeTrailing = function (str, prefix) {
	      return endsWith(str, prefix) ? StrAppend.removeFromEnd(str, prefix.length) : str;
	    };
	
	    var ensureLeading = function (str, prefix) {
	      return startsWith(str, prefix) ? str : StrAppend.addToStart(str, prefix);
	    };
	
	    var ensureTrailing = function (str, prefix) {
	      return endsWith(str, prefix) ? str : StrAppend.addToEnd(str, prefix);
	    };
	 
	    var contains = function(str, substr) {
	      return str.indexOf(substr) !== -1;
	    };
	
	    var capitalize = function(str) {
	      return StringParts.head(str).bind(function (head) {
	        return StringParts.tail(str).map(function (tail) {
	          return head.toUpperCase() + tail;
	        });
	      }).getOr(str);
	    };
	
	    /** Does 'str' start with 'prefix'?
	     *  Note: all strings start with the empty string.
	     *        More formally, for all strings x, startsWith(x, "").
	     *        This is so that for all strings x and y, startsWith(y + x, y)
	     */
	    var startsWith = function(str, prefix) {
	      return checkRange(str, prefix, 0);
	    };
	
	    /** Does 'str' end with 'suffix'?
	     *  Note: all strings end with the empty string.
	     *        More formally, for all strings x, endsWith(x, "").
	     *        This is so that for all strings x and y, endsWith(x + y, y)
	     */
	    var endsWith = function(str, suffix) {
	      return checkRange(str, suffix, str.length - suffix.length);
	    };
	
	   
	    /** removes all leading and trailing spaces */
	    var trim = function(str) {
	      return str.replace(/^\s+|\s+$/g, '');
	    };
	
	    var lTrim = function(str) {
	      return str.replace(/^\s+/g, '');
	    };
	
	    var rTrim = function(str) {
	      return str.replace(/\s+$/g, '');
	    };
	
	    return {
	      supplant: supplant,
	      startsWith: startsWith,
	      removeLeading: removeLeading,
	      removeTrailing: removeTrailing,
	      ensureLeading: ensureLeading,
	      ensureTrailing: ensureTrailing,
	      endsWith: endsWith,
	      contains: contains,
	      trim: trim,
	      lTrim: lTrim,
	      rTrim: rTrim,
	      capitalize: capitalize
	    };
	  }
	);
	
	define(
	  'ephox.sand.info.PlatformInfo',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Strings'
	  ],
	
	  function (Fun, Strings) {
	    var normalVersionRegex = /.*?version\/\ ?([0-9]+)\.([0-9]+).*/;
	
	    var checkContains = function (target) {
	      return function (uastring) {
	        return Strings.contains(uastring, target);
	      };
	    };
	
	    var browsers = [
	      {
	        name : 'Edge',
	        versionRegexes: [/.*?edge\/ ?([0-9]+)\.([0-9]+)$/],
	        search: function (uastring) {
	          var monstrosity = Strings.contains(uastring, 'edge/') && Strings.contains(uastring, 'chrome') && Strings.contains(uastring, 'safari') && Strings.contains(uastring, 'applewebkit');
	          return monstrosity;
	        }
	      },
	      {
	        name : 'Chrome',
	        versionRegexes: [/.*?chrome\/([0-9]+)\.([0-9]+).*/, normalVersionRegex],
	        search : function (uastring) {
	          return Strings.contains(uastring, 'chrome') && !Strings.contains(uastring, 'chromeframe');
	        }
	      },
	      {
	        name : 'IE',
	        versionRegexes: [/.*?msie\ ?([0-9]+)\.([0-9]+).*/, /.*?rv:([0-9]+)\.([0-9]+).*/],
	        search: function (uastring) {
	          return Strings.contains(uastring, 'msie') || Strings.contains(uastring, 'trident');
	        }
	      },
	      // INVESTIGATE: Is this still the Opera user agent?
	      {
	        name : 'Opera',
	        versionRegexes: [normalVersionRegex, /.*?opera\/([0-9]+)\.([0-9]+).*/],
	        search : checkContains('opera')
	      },
	      {
	        name : 'Firefox',
	        versionRegexes: [/.*?firefox\/\ ?([0-9]+)\.([0-9]+).*/],
	        search : checkContains('firefox')
	      },
	      {
	        name : 'Safari',
	        versionRegexes: [normalVersionRegex, /.*?cpu os ([0-9]+)_([0-9]+).*/],
	        search : function (uastring) {
	          return (Strings.contains(uastring, 'safari') || Strings.contains(uastring, 'mobile/')) && Strings.contains(uastring, 'applewebkit');
	        }
	      }
	    ];
	
	    var oses = [
	      {
	        name : 'Windows',
	        search : checkContains('win'),
	        versionRegexes: [/.*?windows\ nt\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name : 'iOS',
	        search : function (uastring) {
	          return Strings.contains(uastring, 'iphone') || Strings.contains(uastring, 'ipad');
	        },
	        versionRegexes: [/.*?version\/\ ?([0-9]+)\.([0-9]+).*/, /.*cpu os ([0-9]+)_([0-9]+).*/, /.*cpu iphone os ([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name : 'Android',
	        search : checkContains('android'),
	        versionRegexes: [/.*?android\ ?([0-9]+)\.([0-9]+).*/]
	      },
	      {
	        name : 'OSX',
	        search : checkContains('os x'),
	        versionRegexes: [/.*?os\ x\ ?([0-9]+)_([0-9]+).*/]
	      },
	      {
	        name : 'Linux',
	        search : checkContains('linux'),
	        versionRegexes: [ ]
	      },
	      { name : 'Solaris',
	        search : checkContains('sunos'),
	        versionRegexes: [ ]
	      },
	      {
	       name : 'FreeBSD',
	       search : checkContains('freebsd'),
	       versionRegexes: [ ]
	      }
	    ];
	
	    return {
	      browsers: Fun.constant(browsers),
	      oses: Fun.constant(oses)
	    };
	  }
	);
	define(
	  'ephox.sand.core.PlatformDetection',
	
	  [
	    'ephox.sand.core.Browser',
	    'ephox.sand.core.OperatingSystem',
	    'ephox.sand.detect.DeviceType',
	    'ephox.sand.detect.UaString',
	    'ephox.sand.info.PlatformInfo'
	  ],
	
	  function (Browser, OperatingSystem, DeviceType, UaString, PlatformInfo) {
	    var detect = function (userAgent) {
	      var browsers = PlatformInfo.browsers();
	      var oses = PlatformInfo.oses();
	
	      var browser = UaString.detectBrowser(browsers, userAgent).fold(
	        Browser.unknown,
	        Browser.nu
	      );
	      var os = UaString.detectOs(oses, userAgent).fold(
	        OperatingSystem.unknown,
	        OperatingSystem.nu
	      );
	      var deviceType = DeviceType(os, browser, userAgent);
	
	      return {
	        browser: browser,
	        os: os,
	        deviceType: deviceType
	      };
	    };
	
	    return {
	      detect: detect
	    };
	  }
	);
	define(
	  'ephox.sand.api.PlatformDetection',
	
	  [
	    'ephox.katamari.api.Thunk',
	    'ephox.sand.core.PlatformDetection',
	    'global!navigator'
	  ],
	
	  function (Thunk, PlatformDetection, navigator) {
	    var detect = Thunk.cached(function () {
	      var userAgent = navigator.userAgent;
	      return PlatformDetection.detect(userAgent);
	    });
	
	    return {
	      detect: detect
	    };
	  }
	);
	define("global!console", [], function () { if (typeof console === "undefined") console = { log: function () {} }; return console; });
	define(
	  'ephox.sugar.api.node.Element',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'global!Error',
	    'global!console',
	    'global!document'
	  ],
	
	  function (Fun, Option, Error, console, document) {
	    var fromHtml = function (html, scope) {
	      var doc = scope || document;
	      var div = doc.createElement('div');
	      div.innerHTML = html;
	      if (!div.hasChildNodes() || div.childNodes.length > 1) {
	        console.error('HTML does not have a single root node', html);
	        throw 'HTML must have a single root node';
	      }
	      return fromDom(div.childNodes[0]);
	    };
	
	    var fromTag = function (tag, scope) {
	      var doc = scope || document;
	      var node = doc.createElement(tag);
	      return fromDom(node);
	    };
	
	    var fromText = function (text, scope) {
	      var doc = scope || document;
	      var node = doc.createTextNode(text);
	      return fromDom(node);
	    };
	
	    var fromDom = function (node) {
	      if (node === null || node === undefined) throw new Error('Node cannot be null or undefined');
	      return {
	        dom: Fun.constant(node)
	      };
	    };
	
	    var fromPoint = function (doc, x, y) {
	      return Option.from(doc.dom().elementFromPoint(x, y)).map(fromDom);
	    };
	
	    return {
	      fromHtml: fromHtml,
	      fromTag: fromTag,
	      fromText: fromText,
	      fromDom: fromDom,
	      fromPoint: fromPoint
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.node.NodeTypes',
	
	  [
	
	  ],
	
	  function () {
	    return {
	      ATTRIBUTE:              2,
	      CDATA_SECTION:          4,
	      COMMENT:                8,
	      DOCUMENT:               9,
	      DOCUMENT_TYPE:          10,
	      DOCUMENT_FRAGMENT:      11,
	      ELEMENT:                1,
	      TEXT:                   3,
	      PROCESSING_INSTRUCTION: 7,
	      ENTITY_REFERENCE:       5,
	      ENTITY:                 6,
	      NOTATION:               12
	    };
	  }
	);
	define(
	  'ephox.sugar.api.node.Node',
	
	  [
	    'ephox.sugar.api.node.NodeTypes'
	  ],
	
	  function (NodeTypes) {
	    var name = function (element) {
	      var r = element.dom().nodeName;
	      return r.toLowerCase();
	    };
	
	    var type = function (element) {
	      return element.dom().nodeType;
	    };
	
	    var value = function (element) {
	      return element.dom().nodeValue;
	    };
	
	    var isType = function (t) {
	      return function (element) {
	        return type(element) === t;
	      };
	    };
	
	    var isComment = function (element) {
	      return type(element) === NodeTypes.COMMENT || name(element) === '#comment';
	    };
	
	    var isElement = isType(NodeTypes.ELEMENT);
	    var isText = isType(NodeTypes.TEXT);
	    var isDocument = isType(NodeTypes.DOCUMENT);
	
	    return {
	      name: name,
	      type: type,
	      value: value,
	      isElement: isElement,
	      isText: isText,
	      isDocument: isDocument,
	      isComment: isComment
	    };
	  }
	);
	
	define(
	  'ephox.katamari.api.Type',
	
	  [
	    'global!Array',
	    'global!String'
	  ],
	
	  function (Array, String) {
	    var typeOf = function(x) {
	      if (x === null) return 'null';
	      var t = typeof x;
	      if (t === 'object' && Array.prototype.isPrototypeOf(x)) return 'array';
	      if (t === 'object' && String.prototype.isPrototypeOf(x)) return 'string';
	      return t;
	    };
	
	    var isType = function (type) {
	      return function (value) {
	        return typeOf(value) === type;
	      };
	    };
	
	    return {
	      isString: isType('string'),
	      isObject: isType('object'),
	      isArray: isType('array'),
	      isNull: isType('null'),
	      isBoolean: isType('boolean'),
	      isUndefined: isType('undefined'),
	      isFunction: isType('function'),
	      isNumber: isType('number')
	    };
	  }
	);
	
	
	define(
	  'ephox.katamari.api.Obj',
	
	  [
	    'ephox.katamari.api.Option',
	    'global!Object'
	  ],
	
	  function (Option, Object) {
	    // There are many variations of Object iteration that are faster than the 'for-in' style:
	    // http://jsperf.com/object-keys-iteration/107
	    //
	    // Use the native keys if it is available (IE9+), otherwise fall back to manually filtering
	    var keys = (function () {
	      var fastKeys = Object.keys;
	
	      // This technically means that 'each' and 'find' on IE8 iterate through the object twice.
	      // This code doesn't run on IE8 much, so it's an acceptable tradeoff.
	      // If it becomes a problem we can always duplicate the feature detection inside each and find as well.
	      var slowKeys = function (o) {
	        var r = [];
	        for (var i in o) {
	          if (o.hasOwnProperty(i)) {
	            r.push(i);
	          }
	        }
	        return r;
	      };
	
	      return fastKeys === undefined ? slowKeys : fastKeys;
	    })();
	
	
	    var each = function (obj, f) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        f(x, i, obj);
	      }
	    };
	
	    /** objectMap :: (JsObj(k, v), (v, k, JsObj(k, v) -> x)) -> JsObj(k, x) */
	    var objectMap = function (obj, f) {
	      return tupleMap(obj, function (x, i, obj) {
	        return {
	          k: i,
	          v: f(x, i, obj)
	        };
	      });
	    };
	
	    /** tupleMap :: (JsObj(k, v), (v, k, JsObj(k, v) -> { k: x, v: y })) -> JsObj(x, y) */
	    var tupleMap = function (obj, f) {
	      var r = {};
	      each(obj, function (x, i) {
	        var tuple = f(x, i, obj);
	        r[tuple.k] = tuple.v;
	      });
	      return r;
	    };
	
	    /** bifilter :: (JsObj(k, v), (v, k -> Bool)) -> { t: JsObj(k, v), f: JsObj(k, v) } */
	    var bifilter = function (obj, pred) {
	      var t = {};
	      var f = {};
	      each(obj, function(x, i) {
	        var branch = pred(x, i) ? t : f;
	        branch[i] = x;
	      });
	      return {
	        t: t,
	        f: f
	      };
	    };
	
	    /** mapToArray :: (JsObj(k, v), (v, k -> a)) -> [a] */
	    var mapToArray = function (obj, f) {
	      var r = [];
	      each(obj, function(value, name) {
	        r.push(f(value, name));
	      });
	      return r;
	    };
	
	    /** find :: (JsObj(k, v), (v, k, JsObj(k, v) -> Bool)) -> Option v */
	    var find = function (obj, pred) {
	      var props = keys(obj);
	      for (var k = 0, len = props.length; k < len; k++) {
	        var i = props[k];
	        var x = obj[i];
	        if (pred(x, i, obj)) {
	          return Option.some(x);
	        }
	      }
	      return Option.none();
	    };
	
	    /** values :: JsObj(k, v) -> [v] */
	    var values = function (obj) {
	      return mapToArray(obj, function (v) {
	        return v;
	      });
	    };
	
	    var size = function (obj) {
	      return values(obj).length;
	    };
	
	    return {
	      bifilter: bifilter,
	      each: each,
	      map: objectMap,
	      mapToArray: mapToArray,
	      tupleMap: tupleMap,
	      find: find,
	      keys: keys,
	      values: values,
	      size: size
	    };
	  }
	);
	define(
	  'ephox.sugar.api.properties.Attr',
	
	  [
	    'ephox.katamari.api.Type',
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Obj',
	    'ephox.sugar.api.node.Node',
	    'global!Error',
	    'global!console'
	  ],
	
	  /*
	   * Direct attribute manipulation has been around since IE8, but
	   * was apparently unstable until IE10.
	   */
	  function (Type, Arr, Obj, Node, Error, console) {
	    var rawSet = function (dom, key, value) {
	      /*
	       * JQuery coerced everything to a string, and silently did nothing on text node/null/undefined.
	       *
	       * We fail on those invalid cases, only allowing numbers and booleans.
	       */
	      if (Type.isString(value) || Type.isBoolean(value) || Type.isNumber(value)) {
	        dom.setAttribute(key, value + '');
	      } else {
	        console.error('Invalid call to Attr.set. Key ', key, ':: Value ', value, ':: Element ', dom);
	        throw new Error('Attribute value was not simple');
	      }
	    };
	
	    var set = function (element, key, value) {
	      rawSet(element.dom(), key, value);
	    };
	
	    var setAll = function (element, attrs) {
	      var dom = element.dom();
	      Obj.each(attrs, function (v, k) {
	        rawSet(dom, k, v);
	      });
	    };
	
	    var get = function (element, key) {
	      var v = element.dom().getAttribute(key);
	
	      // undefined is the more appropriate value for JS, and this matches JQuery
	      return v === null ? undefined : v;
	    };
	
	    var has = function (element, key) {
	      var dom = element.dom();
	
	      // return false for non-element nodes, no point in throwing an error
	      return dom && dom.hasAttribute ? dom.hasAttribute(key) : false;
	    };
	
	    var remove = function (element, key) {
	      element.dom().removeAttribute(key);
	    };
	
	    var hasNone = function (element) {
	      var attrs = element.dom().attributes;
	      return attrs === undefined || attrs === null || attrs.length === 0;
	    };
	
	    var clone = function (element) {
	      return Arr.foldl(element.dom().attributes, function (acc, attr) {
	        acc[attr.name] = attr.value;
	        return acc;
	      }, {});
	    };
	
	    var transferOne = function (source, destination, attr) {
	      // NOTE: We don't want to clobber any existing attributes
	      if (has(source, attr) && !has(destination, attr)) set(destination, attr, get(source, attr));        
	    };
	
	    // Transfer attributes(attrs) from source to destination, unless they are already present
	    var transfer = function (source, destination, attrs) {
	      if (!Node.isElement(source) || !Node.isElement(destination)) return;
	      Arr.each(attrs, function (attr) {
	        transferOne(source, destination, attr);
	      });
	    };
	
	    return {
	      clone: clone,
	      set: set,
	      setAll: setAll,
	      get: get,
	      has: has,
	      remove: remove,
	      hasNone: hasNone,
	      transfer: transfer
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.node.Body',
	
	  [
	    'ephox.katamari.api.Thunk',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'global!document'
	  ],
	
	  function (Thunk, Element, Node, document) {
	
	    // Node.contains() is very, very, very good performance
	    // http://jsperf.com/closest-vs-contains/5
	    var inBody = function (element) {
	      // Technically this is only required on IE, where contains() returns false for text nodes.
	      // But it's cheap enough to run everywhere and Sugar doesn't have platform detection (yet).
	      var dom = Node.isText(element) ? element.dom().parentNode : element.dom();
	
	      // use ownerDocument.body to ensure this works inside iframes.
	      // Normally contains is bad because an element "contains" itself, but here we want that.
	      return dom !== undefined && dom !== null && dom.ownerDocument.body.contains(dom);
	    };
	
	    var body = Thunk.cached(function() {
	      return getBody(Element.fromDom(document));
	    });
	
	    var getBody = function (doc) {
	      var body = doc.dom().body;
	      if (body === null || body === undefined) throw 'Body is not available yet';
	      return Element.fromDom(body);
	    };
	
	    return {
	      body: body,
	      getBody: getBody,
	      inBody: inBody
	    };
	  }
	);
	
	define(
	  'ephox.sugar.impl.Style',
	
	  [
	
	  ],
	
	  function () {
	    // some elements, such as mathml, don't have style attributes
	    var isSupported = function (dom) {
	      return dom.style !== undefined;
	    };
	
	    return {
	      isSupported: isSupported
	    };
	  }
	);
	define(
	  'ephox.sugar.api.properties.Css',
	
	  [
	    'ephox.katamari.api.Type',
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Obj',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.properties.Attr',
	    'ephox.sugar.api.node.Body',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'ephox.sugar.impl.Style',
	    'ephox.katamari.api.Strings',
	    'global!Error',
	    'global!console',
	    'global!window'
	  ],
	
	  function (Type, Arr, Obj, Option, Attr, Body, Element, Node, Style, Strings, Error, console, window) {
	    var internalSet = function (dom, property, value) {
	      // This is going to hurt. Apologies.
	      // JQuery coerces numbers to pixels for certain property names, and other times lets numbers through.
	      // we're going to be explicit; strings only.
	      if (!Type.isString(value)) {
	        console.error('Invalid call to CSS.set. Property ', property, ':: Value ', value, ':: Element ', dom);
	        throw new Error('CSS value must be a string: ' + value);
	      }
	
	      // removed: support for dom().style[property] where prop is camel case instead of normal property name
	      if (Style.isSupported(dom)) dom.style.setProperty(property, value);
	    };
	
	    var internalRemove = function (dom, property) {
	      /*
	       * IE9 and above - MDN doesn't have details, but here's a couple of random internet claims
	       *
	       * http://help.dottoro.com/ljopsjck.php
	       * http://stackoverflow.com/a/7901886/7546
	       */
	      if (Style.isSupported(dom)) dom.style.removeProperty(property);
	    };
	
	    var set = function (element, property, value) {
	      var dom = element.dom();
	      internalSet(dom, property, value);
	    };
	
	    var setAll = function (element, css) {
	      var dom = element.dom();
	
	      Obj.each(css, function (v, k) {
	        internalSet(dom, k, v);
	      });
	    };
	
	    var setOptions = function(element, css) {
	      var dom = element.dom();
	
	      Obj.each(css, function (v, k) {
	        v.fold(function () {
	          internalRemove(dom, k);
	        }, function (value) {
	          internalSet(dom, k, value);
	        });
	      });
	    };
	
	    /*
	     * NOTE: For certain properties, this returns the "used value" which is subtly different to the "computed value" (despite calling getComputedStyle).
	     * Blame CSS 2.0.
	     *
	     * https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	     */
	    var get = function (element, property) {
	      var dom = element.dom();
	      /*
	       * IE9 and above per
	       * https://developer.mozilla.org/en/docs/Web/API/window.getComputedStyle
	       *
	       * Not in numerosity, because it doesn't memoize and looking this up dynamically in performance critical code would be horrendous.
	       *
	       * JQuery has some magic here for IE popups, but we don't really need that.
	       * It also uses element.ownerDocument.defaultView to handle iframes but that hasn't been required since FF 3.6.
	       */
	      var styles = window.getComputedStyle(dom);
	      var r = styles.getPropertyValue(property);
	
	      // jquery-ism: If r is an empty string, check that the element is not in a document. If it isn't, return the raw value.
	      // Turns out we do this a lot.
	      var v = (r === '' && !Body.inBody(element)) ? getUnsafeProperty(dom, property) : r;
	
	      // undefined is the more appropriate value for JS. JQuery coerces to an empty string, but screw that!
	      return v === null ? undefined : v;
	    };
	
	    var getUnsafeProperty = function (dom, property) {
	      // removed: support for dom().style[property] where prop is camel case instead of normal property name
	      // empty string is what the browsers (IE11 and Chrome) return when the propertyValue doesn't exists.
	      return Style.isSupported(dom) ? dom.style.getPropertyValue(property) : '';
	    };
	
	    /*
	     * Gets the raw value from the style attribute. Useful for retrieving "used values" from the DOM:
	     * https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
	     *
	     * Returns NONE if the property isn't set, or the value is an empty string.
	     */
	    var getRaw = function (element, property) {
	      var dom = element.dom();
	      var raw = getUnsafeProperty(dom, property);
	
	      return Option.from(raw).filter(function (r) { return r.length > 0; });
	    };
	
	    var getAllRaw = function (element) {
	      var css = {};
	      var dom = element.dom();
	
	      if (Style.isSupported(dom)) {
	        for (var i = 0; i < dom.style.length; i++) {
	          var ruleName = dom.style.item(i);
	          css[ruleName] = dom.style[ruleName];
	        }
	      }
	      return css;
	    };
	
	    var isValidValue = function (tag, property, value) {
	      var element = Element.fromTag(tag);
	      set(element, property, value);
	      var style = getRaw(element, property);
	      return style.isSome();
	    };
	
	    var remove = function (element, property) {
	      var dom = element.dom();
	
	      internalRemove(dom, property);
	
	      if (Attr.has(element, 'style') && Strings.trim(Attr.get(element, 'style')) === '') {
	        // No more styles left, remove the style attribute as well
	        Attr.remove(element, 'style');
	      }
	    };
	
	    var preserve = function (element, f) {
	      var oldStyles = Attr.get(element, 'style');
	      var result = f(element);
	      var restore = oldStyles === undefined ? Attr.remove : Attr.set;
	      restore(element, 'style', oldStyles);
	      return result;
	    };
	
	    var copy = function (source, target) {
	      var sourceDom = source.dom();
	      var targetDom = target.dom();
	      if (Style.isSupported(sourceDom) && Style.isSupported(targetDom)) {
	        targetDom.style.cssText = sourceDom.style.cssText;
	      }
	    };
	
	    var reflow = function (e) {
	      /* NOTE:
	       * do not rely on this return value.
	       * It's here so the closure compiler doesn't optimise the property access away.
	       */
	      return e.dom().offsetWidth;
	    };
	
	    var transferOne = function (source, destination, style) {
	      getRaw(source, style).each(function (value) {
	        // NOTE: We don't want to clobber any existing inline styles.
	        if (getRaw(destination, style).isNone()) set(destination, style, value);
	      });
	    };
	
	    var transfer = function (source, destination, styles) {
	      if (!Node.isElement(source) || !Node.isElement(destination)) return;
	      Arr.each(styles, function (style) {
	        transferOne(source, destination, style);
	      });
	    };
	
	    return {
	      copy: copy,
	      set: set,
	      preserve: preserve,
	      setAll: setAll,
	      setOptions: setOptions,
	      remove: remove,
	      get: get,
	      getRaw: getRaw,
	      getAllRaw: getAllRaw,
	      isValidValue: isValidValue,
	      reflow: reflow,
	      transfer: transfer
	    };
	  }
	);
	
	define(
	  'ephox.katamari.data.Immutable',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'global!Array',
	    'global!Error'
	  ],
	
	  function (Arr, Fun, Array, Error) {
	    return function () {
	      var fields = arguments;
	      return function(/* values */) {
	        //  Don't use array slice(arguments), makes the whole function unoptimisable on Chrome
	        var values = new Array(arguments.length);
	        for (var i = 0; i < values.length; i++) values[i] = arguments[i];
	
	        if (fields.length !== values.length)
	          throw new Error('Wrong number of arguments to struct. Expected "[' + fields.length + ']", got ' + values.length + ' arguments');
	
	        var struct = {};
	        Arr.each(fields, function (name, i) {
	          struct[name] = Fun.constant(values[i]);
	        });
	        return struct;
	      };
	    };
	  }
	);
	
	define(
	  'ephox.katamari.util.BagUtils',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Type',
	    'global!Error'
	  ],
	
	  function (Arr, Type, Error) {
	    var sort = function (arr) {
	      return arr.slice(0).sort();
	    };
	
	    var reqMessage = function (required, keys) {
	      throw new Error('All required keys (' + sort(required).join(', ') + ') were not specified. Specified keys were: ' + sort(keys).join(', ') + '.');
	    };
	
	    var unsuppMessage = function (unsupported) {
	      throw new Error('Unsupported keys for object: ' + sort(unsupported).join(', '));
	    };
	
	    var validateStrArr = function (label, array) {
	      if (!Type.isArray(array)) throw new Error('The ' + label + ' fields must be an array. Was: ' + array + '.');
	      Arr.each(array, function (a) {
	        if (!Type.isString(a)) throw new Error('The value ' + a + ' in the ' + label + ' fields was not a string.');
	      });
	    };
	
	    var invalidTypeMessage = function (incorrect, type) {
	      throw new Error('All values need to be of type: ' + type + '. Keys (' + sort(incorrect).join(', ') + ') were not.');
	    };
	
	    var checkDupes = function (everything) {
	      var sorted = sort(everything);
	      var dupe = Arr.find(sorted, function (s, i) {
	        return i < sorted.length -1 && s === sorted[i + 1];
	      });
	
	      dupe.each(function (d) {
	        throw new Error('The field: ' + d + ' occurs more than once in the combined fields: [' + sorted.join(', ') + '].');
	      });
	    };
	
	    return {
	      sort: sort,
	      reqMessage: reqMessage,
	      unsuppMessage: unsuppMessage,
	      validateStrArr: validateStrArr,
	      invalidTypeMessage: invalidTypeMessage,
	      checkDupes: checkDupes
	    };
	  }
	);
	define(
	  'ephox.katamari.data.MixedBag',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Obj',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.util.BagUtils',
	    'global!Error',
	    'global!Object'
	  ],
	
	  function (Arr, Fun, Obj, Option, BagUtils, Error, Object) {
	    
	    return function (required, optional) {
	      var everything = required.concat(optional);
	      if (everything.length === 0) throw new Error('You must specify at least one required or optional field.');
	
	      BagUtils.validateStrArr('required', required);
	      BagUtils.validateStrArr('optional', optional);
	
	      BagUtils.checkDupes(everything);
	
	      return function (obj) {
	        var keys = Obj.keys(obj);
	
	        // Ensure all required keys are present.
	        var allReqd = Arr.forall(required, function (req) {
	          return Arr.contains(keys, req);
	        });
	
	        if (! allReqd) BagUtils.reqMessage(required, keys);
	
	        var unsupported = Arr.filter(keys, function (key) {
	          return !Arr.contains(everything, key);
	        });
	
	        if (unsupported.length > 0) BagUtils.unsuppMessage(unsupported);
	
	        var r = {};
	        Arr.each(required, function (req) {
	          r[req] = Fun.constant(obj[req]);
	        });
	
	        Arr.each(optional, function (opt) {
	          r[opt] = Fun.constant(Object.prototype.hasOwnProperty.call(obj, opt) ? Option.some(obj[opt]): Option.none());
	        });
	
	        return r;
	      };
	    };
	  }
	);
	define(
	  'ephox.katamari.api.Struct',
	
	  [
	    'ephox.katamari.data.Immutable',
	    'ephox.katamari.data.MixedBag'
	  ],
	
	  function (Immutable, MixedBag) {
	    return {
	      immutable: Immutable,
	      immutableBag: MixedBag
	    };
	  }
	);
	
	define(
	  'ephox.sugar.alien.Recurse',
	
	  [
	
	  ],
	
	  function () {
	    /**
	     * Applies f repeatedly until it completes (by returning Option.none()).
	     *
	     * Normally would just use recursion, but JavaScript lacks tail call optimisation.
	     *
	     * This is what recursion looks like when manually unravelled :)
	     */
	    var toArray = function (target, f) {
	      var r = [];
	
	      var recurse = function (e) {
	        r.push(e);
	        return f(e);
	      };
	
	      var cur = f(target);
	      do {
	        cur = cur.bind(recurse);
	      } while (cur.isSome());
	
	      return r;
	    };
	
	    return {
	      toArray: toArray
	    };
	  }
	);
	define(
	  'ephox.sand.api.Node',
	
	  [
	    'ephox.sand.util.Global'
	  ],
	
	  function (Global) {
	    /*
	     * MDN says (yes) for IE, but it's undefined on IE8
	     */
	    var node = function () {
	      var f = Global.getOrDie('Node');
	      return f;
	    };
	
	    /*
	     * Most of numerosity doesn't alter the methods on the object.
	     * We're making an exception for Node, because bitwise and is so easy to get wrong.
	     *
	     * Might be nice to ADT this at some point instead of having individual methods.
	     */
	
	    var compareDocumentPosition = function (a, b, match) {
	      // Returns: 0 if e1 and e2 are the same node, or a bitmask comparing the positions
	      // of nodes e1 and e2 in their documents. See the URL below for bitmask interpretation
	      // https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
	      return (a.compareDocumentPosition(b) & match) !== 0;
	    };
	
	    var documentPositionPreceding = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_PRECEDING);
	    };
	
	    var documentPositionContainedBy = function (a, b) {
	      return compareDocumentPosition(a, b, node().DOCUMENT_POSITION_CONTAINED_BY);
	    };
	
	    return {
	      documentPositionPreceding: documentPositionPreceding,
	      documentPositionContainedBy: documentPositionContainedBy
	    };
	  }
	);
	define(
	  'ephox.sugar.api.search.Selectors',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.NodeTypes',
	    'global!Error',
	    'global!document'
	  ],
	
	  function (Arr, Option, Element, NodeTypes, Error, document) {
	    var ELEMENT = NodeTypes.ELEMENT;
	    var DOCUMENT = NodeTypes.DOCUMENT;
	
	    var is = function (element, selector) {
	      var elem = element.dom();
	      if (elem.nodeType !== ELEMENT) return false; // documents have querySelector but not matches
	
	      // As of Chrome 34 / Safari 7.1 / FireFox 34, everyone except IE has the unprefixed function.
	      // Still check for the others, but do it last.
	      else if (elem.matches !== undefined) return elem.matches(selector);
	      else if (elem.msMatchesSelector !== undefined) return elem.msMatchesSelector(selector);
	      else if (elem.webkitMatchesSelector !== undefined) return elem.webkitMatchesSelector(selector);
	      else if (elem.mozMatchesSelector !== undefined) return elem.mozMatchesSelector(selector);
	      else throw new Error('Browser lacks native selectors'); // unfortunately we can't throw this on startup :(
	    };
	
	    var bypassSelector = function (dom) {
	      // Only elements and documents support querySelector
	      return dom.nodeType !== ELEMENT && dom.nodeType !== DOCUMENT ||
	              // IE fix for complex queries on empty nodes: http://jsfiddle.net/spyder/fv9ptr5L/
	              dom.childElementCount === 0;
	    };
	
	    var all = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom();
	      return bypassSelector(base) ? [] : Arr.map(base.querySelectorAll(selector), Element.fromDom);
	    };
	
	    var one = function (selector, scope) {
	      var base = scope === undefined ? document : scope.dom();
	      return bypassSelector(base) ? Option.none() : Option.from(base.querySelector(selector)).map(Element.fromDom);
	    };
	
	    return {
	      all: all,
	      is: is,
	      one: one
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.dom.Compare',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.sand.api.Node',
	    'ephox.sand.api.PlatformDetection',
	    'ephox.sugar.api.search.Selectors'
	  ],
	
	  function (Arr, Fun, Node, PlatformDetection, Selectors) {
	
	    var eq = function (e1, e2) {
	      return e1.dom() === e2.dom();
	    };
	
	    var isEqualNode = function (e1, e2) {
	      return e1.dom().isEqualNode(e2.dom());
	    };
	
	    var member = function (element, elements) {
	      return Arr.exists(elements, Fun.curry(eq, element));
	    };
	
	    // DOM contains() method returns true if e1===e2, we define our contains() to return false (a node does not contain itself).
	    var regularContains = function (e1, e2) {
	      var d1 = e1.dom(), d2 = e2.dom();
	      return d1 === d2 ? false : d1.contains(d2);
	    };
	
	    var ieContains = function (e1, e2) {
	      // IE only implements the contains() method for Element nodes.
	      // It fails for Text nodes, so implement it using compareDocumentPosition()
	      // https://connect.microsoft.com/IE/feedback/details/780874/node-contains-is-incorrect
	      // Note that compareDocumentPosition returns CONTAINED_BY if 'e2 *is_contained_by* e1':
	      // Also, compareDocumentPosition defines a node containing itself as false.
	      return Node.documentPositionContainedBy(e1.dom(), e2.dom());
	    };
	
	    var browser = PlatformDetection.detect().browser;
	
	    // Returns: true if node e1 contains e2, otherwise false.
	    // (returns false if e1===e2: A node does not contain itself).
	    var contains = browser.isIE() ? ieContains : regularContains;
	
	    return {
	      eq: eq,
	      isEqualNode: isEqualNode,
	      member: member,
	      contains: contains,
	
	      // Only used by DomUniverse. Remove (or should Selectors.is move here?)
	      is: Selectors.is
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.search.Traverse',
	
	  [
	    'ephox.katamari.api.Type',
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Struct',
	    'ephox.sugar.alien.Recurse',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element'
	  ],
	
	  function (Type, Arr, Fun, Option, Struct, Recurse, Compare, Element) {
	    // The document associated with the current element
	    var owner = function (element) {
	      return Element.fromDom(element.dom().ownerDocument);
	    };
	
	    var documentElement = function (element) {
	      // TODO: Avoid unnecessary wrap/unwrap here
	      var doc = owner(element);
	      return Element.fromDom(doc.dom().documentElement);
	    };
	
	    // The window element associated with the element
	    var defaultView = function (element) {
	      var el = element.dom();
	      var defaultView = el.ownerDocument.defaultView;
	      return Element.fromDom(defaultView);
	    };
	
	    var parent = function (element) {
	      var dom = element.dom();
	      return Option.from(dom.parentNode).map(Element.fromDom);
	    };
	
	    var findIndex = function (element) {
	      return parent(element).bind(function (p) {
	        // TODO: Refactor out children so we can avoid the constant unwrapping
	        var kin = children(p);
	        return Arr.findIndex(kin, function (elem) {
	          return Compare.eq(element, elem);
	        });
	      });
	    };
	
	    var parents = function (element, isRoot) {
	      var stop = Type.isFunction(isRoot) ? isRoot : Fun.constant(false);
	
	      // This is used a *lot* so it needs to be performant, not recursive
	      var dom = element.dom();
	      var ret = [];
	
	      while (dom.parentNode !== null && dom.parentNode !== undefined) {
	        var rawParent = dom.parentNode;
	        var parent = Element.fromDom(rawParent);
	        ret.push(parent);
	
	        if (stop(parent) === true) break;
	        else dom = rawParent;
	      }
	      return ret;
	    };
	
	    var siblings = function (element) {
	      // TODO: Refactor out children so we can just not add self instead of filtering afterwards
	      var filterSelf = function (elements) {
	        return Arr.filter(elements, function (x) {
	          return !Compare.eq(element, x);
	        });
	      };
	
	      return parent(element).map(children).map(filterSelf).getOr([]);
	    };
	
	    var offsetParent = function (element) {
	      var dom = element.dom();
	      return Option.from(dom.offsetParent).map(Element.fromDom);
	    };
	
	    var prevSibling = function (element) {
	      var dom = element.dom();
	      return Option.from(dom.previousSibling).map(Element.fromDom);
	    };
	
	    var nextSibling = function (element) {
	      var dom = element.dom();
	      return Option.from(dom.nextSibling).map(Element.fromDom);
	    };
	
	    var prevSiblings = function (element) {
	      // This one needs to be reversed, so they're still in DOM order
	      return Arr.reverse(Recurse.toArray(element, prevSibling));
	    };
	
	    var nextSiblings = function (element) {
	      return Recurse.toArray(element, nextSibling);
	    };
	
	    var children = function (element) {
	      var dom = element.dom();
	      return Arr.map(dom.childNodes, Element.fromDom);
	    };
	
	    var child = function (element, index) {
	      var children = element.dom().childNodes;
	      return Option.from(children[index]).map(Element.fromDom);
	    };
	
	    var firstChild = function (element) {
	      return child(element, 0);
	    };
	
	    var lastChild = function (element) {
	      return child(element, element.dom().childNodes.length - 1);
	    };
	
	    var childNodesCount = function (element) {
	      return element.dom().childNodes.length;
	    };
	
	    var hasChildNodes = function (element) {
	      return element.dom().hasChildNodes();
	    };
	
	    var spot = Struct.immutable('element', 'offset');
	    var leaf = function (element, offset) {
	      var cs = children(element);
	      return cs.length > 0 && offset < cs.length ? spot(cs[offset], 0) : spot(element, offset);
	    };
	
	    return {
	      owner: owner,
	      defaultView: defaultView,
	      documentElement: documentElement,
	      parent: parent,
	      findIndex: findIndex,
	      parents: parents,
	      siblings: siblings,
	      prevSibling: prevSibling,
	      offsetParent: offsetParent,
	      prevSiblings: prevSiblings,
	      nextSibling: nextSibling,
	      nextSiblings: nextSiblings,
	      children: children,
	      child: child,
	      firstChild: firstChild,
	      lastChild: lastChild,
	      childNodesCount: childNodesCount,
	      hasChildNodes: hasChildNodes,
	      leaf: leaf
	    };
	  }
	);
	
	/**
	 * Position.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.Position',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sand.api.PlatformDetection',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'ephox.sugar.api.properties.Css',
	    'ephox.sugar.api.search.Traverse'
	  ],
	  function (Arr, PlatformDetection, Element, Node, Css, Traverse) {
	    var browser = PlatformDetection.detect().browser;
	
	    var firstElement = function (nodes) {
	      return Arr.find(nodes, Node.isElement);
	    };
	
	    // Firefox has a bug where caption height is not included correctly in offset calculations of tables
	    // this tries to compensate for that by detecting if that offsets are incorrect and then remove the height
	    var getTableCaptionDeltaY = function (elm) {
	      if (browser.isFirefox() && Node.name(elm) === 'table') {
	        return firstElement(Traverse.children(elm)).filter(function (elm) {
	          return Node.name(elm) === 'caption';
	        }).bind(function (caption) {
	          return firstElement(Traverse.nextSiblings(caption)).map(function (body) {
	            var bodyTop = body.dom().offsetTop;
	            var captionTop = caption.dom().offsetTop;
	            var captionHeight = caption.dom().offsetHeight;
	            return bodyTop <= captionTop ? -captionHeight : 0;
	          });
	        }).getOr(0);
	      } else {
	        return 0;
	      }
	    };
	
	    var getPos = function (body, elm, rootElm) {
	      var x = 0, y = 0, offsetParent, doc = body.ownerDocument, pos;
	
	      rootElm = rootElm ? rootElm : body;
	
	      if (elm) {
	        // Use getBoundingClientRect if it exists since it's faster than looping offset nodes
	        // Fallback to offsetParent calculations if the body isn't static better since it stops at the body root
	        if (rootElm === body && elm.getBoundingClientRect && Css.get(Element.fromDom(body), 'position') === 'static') {
	          pos = elm.getBoundingClientRect();
	
	          // Add scroll offsets from documentElement or body since IE with the wrong box model will use d.body and so do WebKit
	          // Also remove the body/documentelement clientTop/clientLeft on IE 6, 7 since they offset the position
	          x = pos.left + (doc.documentElement.scrollLeft || body.scrollLeft) - doc.documentElement.clientLeft;
	          y = pos.top + (doc.documentElement.scrollTop || body.scrollTop) - doc.documentElement.clientTop;
	
	          return { x: x, y: y };
	        }
	
	        offsetParent = elm;
	        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType) {
	          x += offsetParent.offsetLeft || 0;
	          y += offsetParent.offsetTop || 0;
	          offsetParent = offsetParent.offsetParent;
	        }
	
	        offsetParent = elm.parentNode;
	        while (offsetParent && offsetParent !== rootElm && offsetParent.nodeType) {
	          x -= offsetParent.scrollLeft || 0;
	          y -= offsetParent.scrollTop || 0;
	          offsetParent = offsetParent.parentNode;
	        }
	
	        y += getTableCaptionDeltaY(Element.fromDom(elm));
	      }
	
	      return { x: x, y: y };
	    };
	
	    return {
	      getPos: getPos
	    };
	  }
	);
	define(
	  'ephox.katamari.api.LazyValue',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Option',
	    'global!setTimeout'
	  ],
	
	  function (Arr, Option, setTimeout) {
	    var nu = function (baseFn) {
	      var data = Option.none();
	      var callbacks = [];
	
	      /** map :: this LazyValue a -> (a -> b) -> LazyValue b */
	      var map = function (f) {
	        return nu(function (nCallback) {
	          get(function (data) {
	            nCallback(f(data));
	          });
	        });
	      };
	
	      var get = function (nCallback) {
	        if (isReady()) call(nCallback);
	        else callbacks.push(nCallback);
	      };
	
	      var set = function (x) {
	        data = Option.some(x);
	        run(callbacks);
	        callbacks = [];
	      };
	
	      var isReady = function () {
	        return data.isSome();
	      };
	
	      var run = function (cbs) {
	        Arr.each(cbs, call);
	      };
	
	      var call = function(cb) {
	        data.each(function(x) {
	          setTimeout(function() {
	            cb(x);
	          }, 0);
	        });
	      };
	
	      // Lazy values cache the value and kick off immediately
	      baseFn(set);
	
	      return {
	        get: get,
	        map: map,
	        isReady: isReady
	      };
	    };
	
	    var pure = function (a) {
	      return nu(function (callback) {
	        callback(a);
	      });
	    };
	
	    return {
	      nu: nu,
	      pure: pure
	    };
	  }
	);
	define(
	  'ephox.katamari.async.Bounce',
	
	  [
	    'global!Array',
	    'global!setTimeout'
	  ],
	
	  function (Array, setTimeout) {
	
	    var bounce = function(f) {
	      return function() {
	        var args = Array.prototype.slice.call(arguments);
	        var me = this;
	        setTimeout(function() {
	          f.apply(me, args);
	        }, 0);
	      };
	    };
	
	    return {
	      bounce: bounce
	    };
	  }
	);
	
	define(
	  'ephox.katamari.api.Future',
	
	  [
	    'ephox.katamari.api.LazyValue',
	    'ephox.katamari.async.Bounce'
	  ],
	
	  /** A future value that is evaluated on demand. The base function is re-evaluated each time 'get' is called. */
	  function (LazyValue, Bounce) {
	    var nu = function (baseFn) {
	      var get = function(callback) {
	        baseFn(Bounce.bounce(callback));
	      };
	
	      /** map :: this Future a -> (a -> b) -> Future b */
	      var map = function (fab) {
	        return nu(function (callback) {
	          get(function (a) {
	            var value = fab(a);
	            callback(value);
	          });
	        });
	      };
	
	      /** bind :: this Future a -> (a -> Future b) -> Future b */
	      var bind = function (aFutureB) {
	        return nu(function (callback) {
	          get(function (a) {
	            aFutureB(a).get(callback);
	          });
	        });
	      };
	
	      /** anonBind :: this Future a -> Future b -> Future b
	       *  Returns a future, which evaluates the first future, ignores the result, then evaluates the second.
	       */
	      var anonBind = function (futureB) {
	        return nu(function (callback) {
	          get(function (a) {
	            futureB.get(callback);
	          });
	        });
	      };
	
	      var toLazy = function () {
	        return LazyValue.nu(get);
	      };
	
	      return {
	        map: map,
	        bind: bind,
	        anonBind: anonBind,
	        toLazy: toLazy,
	        get: get
	      };
	
	    };
	
	    /** a -> Future a */
	    var pure = function (a) {
	      return nu(function (callback) {
	        callback(a);
	      });
	    };
	
	    return {
	      nu: nu,
	      pure: pure
	    };
	  }
	);
	
	define(
	  'ephox.katamari.async.AsyncValues',
	
	  [
	    'ephox.katamari.api.Arr'
	  ],
	
	  function (Arr) {
	    /* 
	     * NOTE: an `asyncValue` must have a `get` function which gets given a callback and calls 
	     * that callback with a value once it is ready
	     *
	     * e.g 
	     * {
	     *   get: function (callback) { callback(10); }
	     * }
	     */
	    var par = function (asyncValues, nu) {
	      return nu(function(callback) {
	        var r = [];
	        var count = 0;
	
	        var cb = function(i) {
	          return function(value) {
	            r[i] = value;
	            count++;
	            if (count >= asyncValues.length) {
	              callback(r);
	            }
	          };
	        };
	
	        if (asyncValues.length === 0) {
	          callback([]);
	        } else {
	          Arr.each(asyncValues, function(asyncValue, i) {
	            asyncValue.get(cb(i));
	          });
	        }
	      });
	    };
	
	    return {
	      par: par
	    };
	  }
	);
	define(
	  'ephox.katamari.api.Futures',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Future',
	    'ephox.katamari.async.AsyncValues'
	  ],
	
	  function (Arr, Future, AsyncValues) {
	    /** par :: [Future a] -> Future [a] */
	    var par = function(futures) {
	      return AsyncValues.par(futures, Future.nu);
	    };
	
	    /** mapM :: [a] -> (a -> Future b) -> Future [b] */
	    var mapM = function(array, fn) {
	      var futures = Arr.map(array, fn);
	      return par(futures);
	    };
	
	    /** Kleisli composition of two functions: a -> Future b.
	     *  Note the order of arguments: g is invoked first, then the result passed to f.
	     *  This is in line with f . g = \x -> f (g a)
	     *
	     *  compose :: ((b -> Future c), (a -> Future b)) -> a -> Future c
	     */
	    var compose = function (f, g) {
	      return function (a) {
	        return g(a).bind(f);
	      };
	    };
	
	    return {
	      par: par,
	      mapM: mapM,
	      compose: compose
	    };
	  }
	);
	define(
	  'ephox.katamari.api.Result',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option'
	  ],
	
	  function (Fun, Option) {
	    /* The type signatures for Result 
	     * is :: this Result a -> a -> Bool
	     * or :: this Result a -> Result a -> Result a
	     * orThunk :: this Result a -> (_ -> Result a) -> Result a
	     * map :: this Result a -> (a -> b) -> Result b
	     * each :: this Result a -> (a -> _) -> _ 
	     * bind :: this Result a -> (a -> Result b) -> Result b
	     * fold :: this Result a -> (_ -> b, a -> b) -> b
	     * exists :: this Result a -> (a -> Bool) -> Bool
	     * forall :: this Result a -> (a -> Bool) -> Bool
	     * toOption :: this Result a -> Option a
	     * isValue :: this Result a -> Bool
	     * isError :: this Result a -> Bool
	     * getOr :: this Result a -> a -> a
	     * getOrThunk :: this Result a -> (_ -> a) -> a
	     * getOrDie :: this Result a -> a (or throws error)
	    */
	
	    var value = function (o) {
	      var is = function (v) {
	        return o === v;      
	      };
	
	      var or = function (opt) {
	        return value(o);
	      };
	
	      var orThunk = function (f) {
	        return value(o);
	      };
	
	      var map = function (f) {
	        return value(f(o));
	      };
	
	      var each = function (f) {
	        f(o);
	      };
	
	      var bind = function (f) {
	        return f(o);
	      };
	
	      var fold = function (_, onValue) {
	        return onValue(o);
	      };
	
	      var exists = function (f) {
	        return f(o);
	      };
	
	      var forall = function (f) {
	        return f(o);
	      };
	
	      var toOption = function () {
	        return Option.some(o);
	      };
	     
	      return {
	        is: is,
	        isValue: Fun.constant(true),
	        isError: Fun.constant(false),
	        getOr: Fun.constant(o),
	        getOrThunk: Fun.constant(o),
	        getOrDie: Fun.constant(o),
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        each: each,
	        bind: bind,
	        exists: exists,
	        forall: forall,
	        toOption: toOption
	      };
	    };
	
	    var error = function (message) {
	      var getOrThunk = function (f) {
	        return f();
	      };
	
	      var getOrDie = function () {
	        return Fun.die(message)();
	      };
	
	      var or = function (opt) {
	        return opt;
	      };
	
	      var orThunk = function (f) {
	        return f();
	      };
	
	      var map = function (f) {
	        return error(message);
	      };
	
	      var bind = function (f) {
	        return error(message);
	      };
	
	      var fold = function (onError, _) {
	        return onError(message);
	      };
	
	      return {
	        is: Fun.constant(false),
	        isValue: Fun.constant(false),
	        isError: Fun.constant(true),
	        getOr: Fun.identity,
	        getOrThunk: getOrThunk,
	        getOrDie: getOrDie,
	        or: or,
	        orThunk: orThunk,
	        fold: fold,
	        map: map,
	        each: Fun.noop,
	        bind: bind,
	        exists: Fun.constant(false),
	        forall: Fun.constant(true),
	        toOption: Option.none
	      };
	    };
	
	    return {
	      value: value,
	      error: error
	    };
	  }
	);
	
	/**
	 * StyleSheetLoader.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles loading of external stylesheets and fires events when these are loaded.
	 *
	 * @class tinymce.dom.StyleSheetLoader
	 * @private
	 */
	define(
	  'tinymce.core.dom.StyleSheetLoader',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Future',
	    'ephox.katamari.api.Futures',
	    'ephox.katamari.api.Result',
	    'global!navigator',
	    'tinymce.core.util.Delay',
	    'tinymce.core.util.Tools'
	  ],
	  function (Arr, Fun, Future, Futures, Result, navigator, Delay, Tools) {
	    "use strict";
	
	    return function (document, settings) {
	      var idCount = 0, loadedStates = {}, maxLoadTime;
	
	      settings = settings || {};
	      maxLoadTime = settings.maxLoadTime || 5000;
	
	      var appendToHead = function (node) {
	        document.getElementsByTagName('head')[0].appendChild(node);
	      };
	
	      /**
	       * Loads the specified css style sheet file and call the loadedCallback once it's finished loading.
	       *
	       * @method load
	       * @param {String} url Url to be loaded.
	       * @param {Function} loadedCallback Callback to be executed when loaded.
	       * @param {Function} errorCallback Callback to be executed when failed loading.
	       */
	      var load = function (url, loadedCallback, errorCallback) {
	        var link, style, startTime, state;
	
	        var passed = function () {
	          var callbacks = state.passed, i = callbacks.length;
	
	          while (i--) {
	            callbacks[i]();
	          }
	
	          state.status = 2;
	          state.passed = [];
	          state.failed = [];
	        };
	
	        var failed = function () {
	          var callbacks = state.failed, i = callbacks.length;
	
	          while (i--) {
	            callbacks[i]();
	          }
	
	          state.status = 3;
	          state.passed = [];
	          state.failed = [];
	        };
	
	        // Sniffs for older WebKit versions that have the link.onload but a broken one
	        var isOldWebKit = function () {
	          var webKitChunks = navigator.userAgent.match(/WebKit\/(\d*)/);
	          return !!(webKitChunks && webKitChunks[1] < 536);
	        };
	
	        // Calls the waitCallback until the test returns true or the timeout occurs
	        var wait = function (testCallback, waitCallback) {
	          if (!testCallback()) {
	            // Wait for timeout
	            if ((new Date().getTime()) - startTime < maxLoadTime) {
	              Delay.setTimeout(waitCallback);
	            } else {
	              failed();
	            }
	          }
	        };
	
	        // Workaround for WebKit that doesn't properly support the onload event for link elements
	        // Or WebKit that fires the onload event before the StyleSheet is added to the document
	        var waitForWebKitLinkLoaded = function () {
	          wait(function () {
	            var styleSheets = document.styleSheets, styleSheet, i = styleSheets.length, owner;
	
	            while (i--) {
	              styleSheet = styleSheets[i];
	              owner = styleSheet.ownerNode ? styleSheet.ownerNode : styleSheet.owningElement;
	              if (owner && owner.id === link.id) {
	                passed();
	                return true;
	              }
	            }
	          }, waitForWebKitLinkLoaded);
	        };
	
	        // Workaround for older Geckos that doesn't have any onload event for StyleSheets
	        var waitForGeckoLinkLoaded = function () {
	          wait(function () {
	            try {
	              // Accessing the cssRules will throw an exception until the CSS file is loaded
	              var cssRules = style.sheet.cssRules;
	              passed();
	              return !!cssRules;
	            } catch (ex) {
	              // Ignore
	            }
	          }, waitForGeckoLinkLoaded);
	        };
	
	        url = Tools._addCacheSuffix(url);
	
	        if (!loadedStates[url]) {
	          state = {
	            passed: [],
	            failed: []
	          };
	
	          loadedStates[url] = state;
	        } else {
	          state = loadedStates[url];
	        }
	
	        if (loadedCallback) {
	          state.passed.push(loadedCallback);
	        }
	
	        if (errorCallback) {
	          state.failed.push(errorCallback);
	        }
	
	        // Is loading wait for it to pass
	        if (state.status == 1) {
	          return;
	        }
	
	        // Has finished loading and was success
	        if (state.status == 2) {
	          passed();
	          return;
	        }
	
	        // Has finished loading and was a failure
	        if (state.status == 3) {
	          failed();
	          return;
	        }
	
	        // Start loading
	        state.status = 1;
	        link = document.createElement('link');
	        link.rel = 'stylesheet';
	        link.type = 'text/css';
	        link.id = 'u' + (idCount++);
	        link.async = false;
	        link.defer = false;
	        startTime = new Date().getTime();
	
	        // Feature detect onload on link element and sniff older webkits since it has an broken onload event
	        if ("onload" in link && !isOldWebKit()) {
	          link.onload = waitForWebKitLinkLoaded;
	          link.onerror = failed;
	        } else {
	          // Sniff for old Firefox that doesn't support the onload event on link elements
	          // TODO: Remove this in the future when everyone uses modern browsers
	          if (navigator.userAgent.indexOf("Firefox") > 0) {
	            style = document.createElement('style');
	            style.textContent = '@import "' + url + '"';
	            waitForGeckoLinkLoaded();
	            appendToHead(style);
	            return;
	          }
	
	          // Use the id owner on older webkits
	          waitForWebKitLinkLoaded();
	        }
	
	        appendToHead(link);
	        link.href = url;
	      };
	
	      var loadF = function (url) {
	        return Future.nu(function (resolve) {
	          load(
	            url,
	            Fun.compose(resolve, Fun.constant(Result.value(url))),
	            Fun.compose(resolve, Fun.constant(Result.error(url)))
	          );
	        });
	      };
	
	      var unbox = function (result) {
	        return result.fold(Fun.identity, Fun.identity);
	      };
	
	      var loadAll = function (urls, success, failure) {
	        Futures.par(Arr.map(urls, loadF)).get(function (result) {
	          var parts = Arr.partition(result, function (r) {
	            return r.isValue();
	          });
	
	          if (parts.fail.length > 0) {
	            failure(parts.fail.map(unbox));
	          } else {
	            success(parts.pass.map(unbox));
	          }
	        });
	      };
	
	      return {
	        load: load,
	        loadAll: loadAll
	      };
	    };
	  }
	);
	
	/**
	 * TreeWalker.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * TreeWalker class enables you to walk the DOM in a linear manner.
	 *
	 * @class tinymce.dom.TreeWalker
	 * @example
	 * var walker = new tinymce.dom.TreeWalker(startNode);
	 *
	 * do {
	 *     console.log(walker.current());
	 * } while (walker.next());
	 */
	define(
	  'tinymce.core.dom.TreeWalker',
	  [
	  ],
	  function () {
	    /**
	     * Constructs a new TreeWalker instance.
	     *
	     * @constructor
	     * @method TreeWalker
	     * @param {Node} startNode Node to start walking from.
	     * @param {node} rootNode Optional root node to never walk out of.
	     */
	    return function (startNode, rootNode) {
	      var node = startNode;
	
	      var findSibling = function (node, startName, siblingName, shallow) {
	        var sibling, parent;
	
	        if (node) {
	          // Walk into nodes if it has a start
	          if (!shallow && node[startName]) {
	            return node[startName];
	          }
	
	          // Return the sibling if it has one
	          if (node != rootNode) {
	            sibling = node[siblingName];
	            if (sibling) {
	              return sibling;
	            }
	
	            // Walk up the parents to look for siblings
	            for (parent = node.parentNode; parent && parent != rootNode; parent = parent.parentNode) {
	              sibling = parent[siblingName];
	              if (sibling) {
	                return sibling;
	              }
	            }
	          }
	        }
	      };
	
	      var findPreviousNode = function (node, startName, siblingName, shallow) {
	        var sibling, parent, child;
	
	        if (node) {
	          sibling = node[siblingName];
	          if (rootNode && sibling === rootNode) {
	            return;
	          }
	
	          if (sibling) {
	            if (!shallow) {
	              // Walk up the parents to look for siblings
	              for (child = sibling[startName]; child; child = child[startName]) {
	                if (!child[startName]) {
	                  return child;
	                }
	              }
	            }
	
	            return sibling;
	          }
	
	          parent = node.parentNode;
	          if (parent && parent !== rootNode) {
	            return parent;
	          }
	        }
	      };
	
	      /**
	       * Returns the current node.
	       *
	       * @method current
	       * @return {Node} Current node where the walker is.
	       */
	      this.current = function () {
	        return node;
	      };
	
	      /**
	       * Walks to the next node in tree.
	       *
	       * @method next
	       * @return {Node} Current node where the walker is after moving to the next node.
	       */
	      this.next = function (shallow) {
	        node = findSibling(node, 'firstChild', 'nextSibling', shallow);
	        return node;
	      };
	
	      /**
	       * Walks to the previous node in tree.
	       *
	       * @method prev
	       * @return {Node} Current node where the walker is after moving to the previous node.
	       */
	      this.prev = function (shallow) {
	        node = findSibling(node, 'lastChild', 'previousSibling', shallow);
	        return node;
	      };
	
	      this.prev2 = function (shallow) {
	        node = findPreviousNode(node, 'lastChild', 'previousSibling', shallow);
	        return node;
	      };
	    };
	  }
	);
	
	/**
	 * ElementType.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.ElementType',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.sugar.api.node.Node'
	  ],
	  function (Arr, Fun, Node) {
	    var blocks = [
	      'article', 'aside', 'details', 'div', 'dt', 'figcaption', 'footer',
	      'form', 'fieldset', 'header', 'hgroup', 'html', 'main', 'nav',
	      'section', 'summary', 'body', 'p', 'dl', 'multicol', 'dd', 'figure',
	      'address', 'center', 'blockquote', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6',
	      'listing', 'xmp', 'pre', 'plaintext', 'menu', 'dir', 'ul', 'ol', 'li', 'hr',
	      'table', 'tbody', 'thead', 'tfoot', 'th', 'tr', 'td', 'caption'
	    ];
	
	    var voids = [
	      'area', 'base', 'basefont', 'br', 'col', 'frame', 'hr', 'img', 'input',
	      'isindex', 'link', 'meta', 'param', 'embed', 'source', 'wbr', 'track'
	    ];
	
	    var tableCells = ['td', 'th'];
	    var tableSections = ['thead', 'tbody', 'tfoot'];
	
	    var textBlocks = [
	      'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'p', 'div', 'address', 'pre', 'form',
	      'blockquote', 'center', 'dir', 'fieldset', 'header', 'footer', 'article',
	      'section', 'hgroup', 'aside', 'nav', 'figure'
	    ];
	
	    var headings = ['h1', 'h2', 'h3', 'h4', 'h5', 'h6'];
	    var listItems = ['li', 'dd', 'dt'];
	    var lists = ['ul', 'ol', 'dl'];
	
	    var lazyLookup = function (items) {
	      var lookup;
	      return function (node) {
	        lookup = lookup ? lookup : Arr.mapToObject(items, Fun.constant(true));
	        return lookup.hasOwnProperty(Node.name(node));
	      };
	    };
	
	    var isHeading = lazyLookup(headings);
	
	    var isBlock = lazyLookup(blocks);
	
	    var isInline = function (node) {
	      return Node.isElement(node) && !isBlock(node);
	    };
	
	    var isBr = function (node) {
	      return Node.isElement(node) && Node.name(node) === 'br';
	    };
	
	    return {
	      isBlock: isBlock,
	      isInline: isInline,
	      isHeading: isHeading,
	      isTextBlock: lazyLookup(textBlocks),
	      isList: lazyLookup(lists),
	      isListItem: lazyLookup(listItems),
	      isVoid: lazyLookup(voids),
	      isTableSection: lazyLookup(tableSections),
	      isTableCell: lazyLookup(tableCells),
	      isBr: isBr
	    };
	  }
	);
	
	/**
	 * NodeType.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Contains various node validation functions.
	 *
	 * @private
	 * @class tinymce.dom.NodeType
	 */
	define(
	  'tinymce.core.dom.NodeType',
	  [
	  ],
	  function () {
	    var isNodeType = function (type) {
	      return function (node) {
	        return !!node && node.nodeType == type;
	      };
	    };
	
	    var isElement = isNodeType(1);
	
	    var matchNodeNames = function (names) {
	      names = names.toLowerCase().split(' ');
	
	      return function (node) {
	        var i, name;
	
	        if (node && node.nodeType) {
	          name = node.nodeName.toLowerCase();
	
	          for (i = 0; i < names.length; i++) {
	            if (name === names[i]) {
	              return true;
	            }
	          }
	        }
	
	        return false;
	      };
	    };
	
	    var matchStyleValues = function (name, values) {
	      values = values.toLowerCase().split(' ');
	
	      return function (node) {
	        var i, cssValue;
	
	        if (isElement(node)) {
	          for (i = 0; i < values.length; i++) {
	            cssValue = node.ownerDocument.defaultView.getComputedStyle(node, null).getPropertyValue(name);
	            if (cssValue === values[i]) {
	              return true;
	            }
	          }
	        }
	
	        return false;
	      };
	    };
	
	    var hasPropValue = function (propName, propValue) {
	      return function (node) {
	        return isElement(node) && node[propName] === propValue;
	      };
	    };
	
	    var hasAttribute = function (attrName, attrValue) {
	      return function (node) {
	        return isElement(node) && node.hasAttribute(attrName);
	      };
	    };
	
	    var hasAttributeValue = function (attrName, attrValue) {
	      return function (node) {
	        return isElement(node) && node.getAttribute(attrName) === attrValue;
	      };
	    };
	
	    var isBogus = function (node) {
	      return isElement(node) && node.hasAttribute('data-mce-bogus');
	    };
	
	    var hasContentEditableState = function (value) {
	      return function (node) {
	        if (isElement(node)) {
	          if (node.contentEditable === value) {
	            return true;
	          }
	
	          if (node.getAttribute('data-mce-contenteditable') === value) {
	            return true;
	          }
	        }
	
	        return false;
	      };
	    };
	
	    return {
	      isText: isNodeType(3),
	      isElement: isElement,
	      isComment: isNodeType(8),
	      isDocument: isNodeType(9),
	      isBr: matchNodeNames('br'),
	      isContentEditableTrue: hasContentEditableState('true'),
	      isContentEditableFalse: hasContentEditableState('false'),
	      matchNodeNames: matchNodeNames,
	      hasPropValue: hasPropValue,
	      hasAttribute: hasAttribute,
	      hasAttributeValue: hasAttributeValue,
	      matchStyleValues: matchStyleValues,
	      isBogus: isBogus
	    };
	  }
	);
	define(
	  'tinymce.core.dom.TrimNode',
	
	  [
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.dom.ElementType',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.util.Tools'
	  ],
	
	  function (Element, ElementType, NodeType, Tools) {
	    var surroundedBySpans = function (node) {
	      var previousIsSpan = node.previousSibling && node.previousSibling.nodeName === 'SPAN';
	      var nextIsSpan = node.nextSibling && node.nextSibling.nodeName === 'SPAN';
	      return previousIsSpan && nextIsSpan;
	    };
	
	    var isBookmarkNode = function (node) {
	      return node && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
	    };
	
	    // W3C valid browsers tend to leave empty nodes to the left/right side of the contents - this makes sense
	    // but we don't want that in our code since it serves no purpose for the end user
	    // For example splitting this html at the bold element:
	    //   <p>text 1<span><b>CHOP</b></span>text 2</p>
	    // would produce:
	    //   <p>text 1<span></span></p><b>CHOP</b><p><span></span>text 2</p>
	    // this function will then trim off empty edges and produce:
	    //   <p>text 1</p><b>CHOP</b><p>text 2</p>
	    var trimNode = function (dom, node) {
	      var i, children = node.childNodes;
	
	      if (NodeType.isElement(node) && isBookmarkNode(node)) {
	        return;
	      }
	
	      for (i = children.length - 1; i >= 0; i--) {
	        trimNode(dom, children[i]);
	      }
	
	      if (NodeType.isDocument(node) === false) {
	        // Keep non whitespace text nodes
	        if (NodeType.isText(node) && node.nodeValue.length > 0) {
	          // Keep if parent element is a block or if there is some useful content
	          var trimmedLength = Tools.trim(node.nodeValue).length;
	          if (dom.isBlock(node.parentNode) || trimmedLength > 0) {
	            return;
	          }
	          // Also keep text nodes with only spaces if surrounded by spans.
	          // eg. "<p><span>a</span> <span>b</span></p>" should keep space between a and b
	          if (trimmedLength === 0 && surroundedBySpans(node)) {
	            return;
	          }
	        } else if (NodeType.isElement(node)) {
	          // If the only child is a bookmark then move it up
	          children = node.childNodes;
	
	          if (children.length === 1 && isBookmarkNode(children[0])) {
	            node.parentNode.insertBefore(children[0], node);
	          }
	
	          // Keep non empty elements and void elements
	          if (children.length || ElementType.isVoid(Element.fromDom(node))) {
	            return;
	          }
	        }
	
	        dom.remove(node);
	      }
	      return node;
	    };
	
	    return {
	      trimNode: trimNode
	    };
	  }
	);
	
	/**
	 * Entities.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*jshint bitwise:false */
	/*eslint no-bitwise:0 */
	
	/**
	 * Entity encoder class.
	 *
	 * @class tinymce.html.Entities
	 * @static
	 * @version 3.4
	 */
	define(
	  'tinymce.core.html.Entities',
	  [
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.util.Tools'
	  ],
	  function (Element, Tools) {
	    var makeMap = Tools.makeMap;
	
	    var namedEntities, baseEntities, reverseEntities,
	      attrsCharsRegExp = /[&<>\"\u0060\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	      textCharsRegExp = /[<>&\u007E-\uD7FF\uE000-\uFFEF]|[\uD800-\uDBFF][\uDC00-\uDFFF]/g,
	      rawCharsRegExp = /[<>&\"\']/g,
	      entityRegExp = /&#([a-z0-9]+);?|&([a-z0-9]+);/gi,
	      asciiMap = {
	        128: "\u20AC", 130: "\u201A", 131: "\u0192", 132: "\u201E", 133: "\u2026", 134: "\u2020",
	        135: "\u2021", 136: "\u02C6", 137: "\u2030", 138: "\u0160", 139: "\u2039", 140: "\u0152",
	        142: "\u017D", 145: "\u2018", 146: "\u2019", 147: "\u201C", 148: "\u201D", 149: "\u2022",
	        150: "\u2013", 151: "\u2014", 152: "\u02DC", 153: "\u2122", 154: "\u0161", 155: "\u203A",
	        156: "\u0153", 158: "\u017E", 159: "\u0178"
	      };
	
	    // Raw entities
	    baseEntities = {
	      '\"': '&quot;', // Needs to be escaped since the YUI compressor would otherwise break the code
	      "'": '&#39;',
	      '<': '&lt;',
	      '>': '&gt;',
	      '&': '&amp;',
	      '\u0060': '&#96;'
	    };
	
	    // Reverse lookup table for raw entities
	    reverseEntities = {
	      '&lt;': '<',
	      '&gt;': '>',
	      '&amp;': '&',
	      '&quot;': '"',
	      '&apos;': "'"
	    };
	
	    // Decodes text by using the browser
	    var nativeDecode = function (text) {
	      var elm;
	
	      elm = Element.fromTag("div").dom();
	      elm.innerHTML = text;
	
	      return elm.textContent || elm.innerText || text;
	    };
	
	    // Build a two way lookup table for the entities
	    var buildEntitiesLookup = function (items, radix) {
	      var i, chr, entity, lookup = {};
	
	      if (items) {
	        items = items.split(',');
	        radix = radix || 10;
	
	        // Build entities lookup table
	        for (i = 0; i < items.length; i += 2) {
	          chr = String.fromCharCode(parseInt(items[i], radix));
	
	          // Only add non base entities
	          if (!baseEntities[chr]) {
	            entity = '&' + items[i + 1] + ';';
	            lookup[chr] = entity;
	            lookup[entity] = chr;
	          }
	        }
	
	        return lookup;
	      }
	    };
	
	    // Unpack entities lookup where the numbers are in radix 32 to reduce the size
	    namedEntities = buildEntitiesLookup(
	      '50,nbsp,51,iexcl,52,cent,53,pound,54,curren,55,yen,56,brvbar,57,sect,58,uml,59,copy,' +
	      '5a,ordf,5b,laquo,5c,not,5d,shy,5e,reg,5f,macr,5g,deg,5h,plusmn,5i,sup2,5j,sup3,5k,acute,' +
	      '5l,micro,5m,para,5n,middot,5o,cedil,5p,sup1,5q,ordm,5r,raquo,5s,frac14,5t,frac12,5u,frac34,' +
	      '5v,iquest,60,Agrave,61,Aacute,62,Acirc,63,Atilde,64,Auml,65,Aring,66,AElig,67,Ccedil,' +
	      '68,Egrave,69,Eacute,6a,Ecirc,6b,Euml,6c,Igrave,6d,Iacute,6e,Icirc,6f,Iuml,6g,ETH,6h,Ntilde,' +
	      '6i,Ograve,6j,Oacute,6k,Ocirc,6l,Otilde,6m,Ouml,6n,times,6o,Oslash,6p,Ugrave,6q,Uacute,' +
	      '6r,Ucirc,6s,Uuml,6t,Yacute,6u,THORN,6v,szlig,70,agrave,71,aacute,72,acirc,73,atilde,74,auml,' +
	      '75,aring,76,aelig,77,ccedil,78,egrave,79,eacute,7a,ecirc,7b,euml,7c,igrave,7d,iacute,7e,icirc,' +
	      '7f,iuml,7g,eth,7h,ntilde,7i,ograve,7j,oacute,7k,ocirc,7l,otilde,7m,ouml,7n,divide,7o,oslash,' +
	      '7p,ugrave,7q,uacute,7r,ucirc,7s,uuml,7t,yacute,7u,thorn,7v,yuml,ci,fnof,sh,Alpha,si,Beta,' +
	      'sj,Gamma,sk,Delta,sl,Epsilon,sm,Zeta,sn,Eta,so,Theta,sp,Iota,sq,Kappa,sr,Lambda,ss,Mu,' +
	      'st,Nu,su,Xi,sv,Omicron,t0,Pi,t1,Rho,t3,Sigma,t4,Tau,t5,Upsilon,t6,Phi,t7,Chi,t8,Psi,' +
	      't9,Omega,th,alpha,ti,beta,tj,gamma,tk,delta,tl,epsilon,tm,zeta,tn,eta,to,theta,tp,iota,' +
	      'tq,kappa,tr,lambda,ts,mu,tt,nu,tu,xi,tv,omicron,u0,pi,u1,rho,u2,sigmaf,u3,sigma,u4,tau,' +
	      'u5,upsilon,u6,phi,u7,chi,u8,psi,u9,omega,uh,thetasym,ui,upsih,um,piv,812,bull,816,hellip,' +
	      '81i,prime,81j,Prime,81u,oline,824,frasl,88o,weierp,88h,image,88s,real,892,trade,89l,alefsym,' +
	      '8cg,larr,8ch,uarr,8ci,rarr,8cj,darr,8ck,harr,8dl,crarr,8eg,lArr,8eh,uArr,8ei,rArr,8ej,dArr,' +
	      '8ek,hArr,8g0,forall,8g2,part,8g3,exist,8g5,empty,8g7,nabla,8g8,isin,8g9,notin,8gb,ni,8gf,prod,' +
	      '8gh,sum,8gi,minus,8gn,lowast,8gq,radic,8gt,prop,8gu,infin,8h0,ang,8h7,and,8h8,or,8h9,cap,8ha,cup,' +
	      '8hb,int,8hk,there4,8hs,sim,8i5,cong,8i8,asymp,8j0,ne,8j1,equiv,8j4,le,8j5,ge,8k2,sub,8k3,sup,8k4,' +
	      'nsub,8k6,sube,8k7,supe,8kl,oplus,8kn,otimes,8l5,perp,8m5,sdot,8o8,lceil,8o9,rceil,8oa,lfloor,8ob,' +
	      'rfloor,8p9,lang,8pa,rang,9ea,loz,9j0,spades,9j3,clubs,9j5,hearts,9j6,diams,ai,OElig,aj,oelig,b0,' +
	      'Scaron,b1,scaron,bo,Yuml,m6,circ,ms,tilde,802,ensp,803,emsp,809,thinsp,80c,zwnj,80d,zwj,80e,lrm,' +
	      '80f,rlm,80j,ndash,80k,mdash,80o,lsquo,80p,rsquo,80q,sbquo,80s,ldquo,80t,rdquo,80u,bdquo,810,dagger,' +
	      '811,Dagger,81g,permil,81p,lsaquo,81q,rsaquo,85c,euro', 32);
	
	    var Entities = {
	      /**
	       * Encodes the specified string using raw entities. This means only the required XML base entities will be encoded.
	       *
	       * @method encodeRaw
	       * @param {String} text Text to encode.
	       * @param {Boolean} attr Optional flag to specify if the text is attribute contents.
	       * @return {String} Entity encoded text.
	       */
	      encodeRaw: function (text, attr) {
	        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	          return baseEntities[chr] || chr;
	        });
	      },
	
	      /**
	       * Encoded the specified text with both the attributes and text entities. This function will produce larger text contents
	       * since it doesn't know if the context is within a attribute or text node. This was added for compatibility
	       * and is exposed as the DOMUtils.encode function.
	       *
	       * @method encodeAllRaw
	       * @param {String} text Text to encode.
	       * @return {String} Entity encoded text.
	       */
	      encodeAllRaw: function (text) {
	        return ('' + text).replace(rawCharsRegExp, function (chr) {
	          return baseEntities[chr] || chr;
	        });
	      },
	
	      /**
	       * Encodes the specified string using numeric entities. The core entities will be
	       * encoded as named ones but all non lower ascii characters will be encoded into numeric entities.
	       *
	       * @method encodeNumeric
	       * @param {String} text Text to encode.
	       * @param {Boolean} attr Optional flag to specify if the text is attribute contents.
	       * @return {String} Entity encoded text.
	       */
	      encodeNumeric: function (text, attr) {
	        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	          // Multi byte sequence convert it to a single entity
	          if (chr.length > 1) {
	            return '&#' + (((chr.charCodeAt(0) - 0xD800) * 0x400) + (chr.charCodeAt(1) - 0xDC00) + 0x10000) + ';';
	          }
	
	          return baseEntities[chr] || '&#' + chr.charCodeAt(0) + ';';
	        });
	      },
	
	      /**
	       * Encodes the specified string using named entities. The core entities will be encoded
	       * as named ones but all non lower ascii characters will be encoded into named entities.
	       *
	       * @method encodeNamed
	       * @param {String} text Text to encode.
	       * @param {Boolean} attr Optional flag to specify if the text is attribute contents.
	       * @param {Object} entities Optional parameter with entities to use.
	       * @return {String} Entity encoded text.
	       */
	      encodeNamed: function (text, attr, entities) {
	        entities = entities || namedEntities;
	
	        return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	          return baseEntities[chr] || entities[chr] || chr;
	        });
	      },
	
	      /**
	       * Returns an encode function based on the name(s) and it's optional entities.
	       *
	       * @method getEncodeFunc
	       * @param {String} name Comma separated list of encoders for example named,numeric.
	       * @param {String} entities Optional parameter with entities to use instead of the built in set.
	       * @return {function} Encode function to be used.
	       */
	      getEncodeFunc: function (name, entities) {
	        entities = buildEntitiesLookup(entities) || namedEntities;
	
	        var encodeNamedAndNumeric = function (text, attr) {
	          return text.replace(attr ? attrsCharsRegExp : textCharsRegExp, function (chr) {
	            if (baseEntities[chr] !== undefined) {
	              return baseEntities[chr];
	            }
	
	            if (entities[chr] !== undefined) {
	              return entities[chr];
	            }
	
	            // Convert multi-byte sequences to a single entity.
	            if (chr.length > 1) {
	              return '&#' + (((chr.charCodeAt(0) - 0xD800) * 0x400) + (chr.charCodeAt(1) - 0xDC00) + 0x10000) + ';';
	            }
	
	            return '&#' + chr.charCodeAt(0) + ';';
	          });
	        };
	
	        var encodeCustomNamed = function (text, attr) {
	          return Entities.encodeNamed(text, attr, entities);
	        };
	
	        // Replace + with , to be compatible with previous TinyMCE versions
	        name = makeMap(name.replace(/\+/g, ','));
	
	        // Named and numeric encoder
	        if (name.named && name.numeric) {
	          return encodeNamedAndNumeric;
	        }
	
	        // Named encoder
	        if (name.named) {
	          // Custom names
	          if (entities) {
	            return encodeCustomNamed;
	          }
	
	          return Entities.encodeNamed;
	        }
	
	        // Numeric
	        if (name.numeric) {
	          return Entities.encodeNumeric;
	        }
	
	        // Raw encoder
	        return Entities.encodeRaw;
	      },
	
	      /**
	       * Decodes the specified string, this will replace entities with raw UTF characters.
	       *
	       * @method decode
	       * @param {String} text Text to entity decode.
	       * @return {String} Entity decoded string.
	       */
	      decode: function (text) {
	        return text.replace(entityRegExp, function (all, numeric) {
	          if (numeric) {
	            if (numeric.charAt(0).toLowerCase() === 'x') {
	              numeric = parseInt(numeric.substr(1), 16);
	            } else {
	              numeric = parseInt(numeric, 10);
	            }
	
	            // Support upper UTF
	            if (numeric > 0xFFFF) {
	              numeric -= 0x10000;
	
	              return String.fromCharCode(0xD800 + (numeric >> 10), 0xDC00 + (numeric & 0x3FF));
	            }
	
	            return asciiMap[numeric] || String.fromCharCode(numeric);
	          }
	
	          return reverseEntities[all] || namedEntities[all] || nativeDecode(all);
	        });
	      }
	    };
	
	    return Entities;
	  }
	);
	
	/**
	 * Schema.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Schema validator class.
	 *
	 * @class tinymce.html.Schema
	 * @example
	 *  if (tinymce.activeEditor.schema.isValidChild('p', 'span'))
	 *    alert('span is valid child of p.');
	 *
	 *  if (tinymce.activeEditor.schema.getElementRule('p'))
	 *    alert('P is a valid element.');
	 *
	 * @class tinymce.html.Schema
	 * @version 3.4
	 */
	define(
	  'tinymce.core.html.Schema',
	  [
	    "tinymce.core.util.Tools"
	  ],
	  function (Tools) {
	    var mapCache = {}, dummyObj = {};
	    var makeMap = Tools.makeMap, each = Tools.each, extend = Tools.extend, explode = Tools.explode, inArray = Tools.inArray;
	
	    var split = function (items, delim) {
	      items = Tools.trim(items);
	      return items ? items.split(delim || ' ') : [];
	    };
	
	    /**
	     * Builds a schema lookup table
	     *
	     * @private
	     * @param {String} type html4, html5 or html5-strict schema type.
	     * @return {Object} Schema lookup table.
	     */
	    var compileSchema = function (type) {
	      var schema = {}, globalAttributes, blockContent;
	      var phrasingContent, flowContent, html4BlockContent, html4PhrasingContent;
	
	      var add = function (name, attributes, children) {
	        var ni, attributesOrder, element;
	
	        var arrayToMap = function (array, obj) {
	          var map = {}, i, l;
	
	          for (i = 0, l = array.length; i < l; i++) {
	            map[array[i]] = obj || {};
	          }
	
	          return map;
	        };
	
	        children = children || [];
	        attributes = attributes || "";
	
	        if (typeof children === "string") {
	          children = split(children);
	        }
	
	        name = split(name);
	        ni = name.length;
	        while (ni--) {
	          attributesOrder = split([globalAttributes, attributes].join(' '));
	
	          element = {
	            attributes: arrayToMap(attributesOrder),
	            attributesOrder: attributesOrder,
	            children: arrayToMap(children, dummyObj)
	          };
	
	          schema[name[ni]] = element;
	        }
	      };
	
	      var addAttrs = function (name, attributes) {
	        var ni, schemaItem, i, l;
	
	        name = split(name);
	        ni = name.length;
	        attributes = split(attributes);
	        while (ni--) {
	          schemaItem = schema[name[ni]];
	          for (i = 0, l = attributes.length; i < l; i++) {
	            schemaItem.attributes[attributes[i]] = {};
	            schemaItem.attributesOrder.push(attributes[i]);
	          }
	        }
	      };
	
	      // Use cached schema
	      if (mapCache[type]) {
	        return mapCache[type];
	      }
	
	      // Attributes present on all elements
	      globalAttributes = "id accesskey class dir lang style tabindex title role";
	
	      // Event attributes can be opt-in/opt-out
	      /*eventAttributes = split("onabort onblur oncancel oncanplay oncanplaythrough onchange onclick onclose oncontextmenu oncuechange " +
	       "ondblclick ondrag ondragend ondragenter ondragleave ondragover ondragstart ondrop ondurationchange onemptied onended " +
	       "onerror onfocus oninput oninvalid onkeydown onkeypress onkeyup onload onloadeddata onloadedmetadata onloadstart " +
	       "onmousedown onmousemove onmouseout onmouseover onmouseup onmousewheel onpause onplay onplaying onprogress onratechange " +
	       "onreset onscroll onseeked onseeking onseeking onselect onshow onstalled onsubmit onsuspend ontimeupdate onvolumechange " +
	       "onwaiting"
	       );*/
	
	      // Block content elements
	      blockContent =
	        "address blockquote div dl fieldset form h1 h2 h3 h4 h5 h6 hr menu ol p pre table ul";
	
	      // Phrasing content elements from the HTML5 spec (inline)
	      phrasingContent =
	        "a abbr b bdo br button cite code del dfn em embed i iframe img input ins kbd " +
	        "label map noscript object q s samp script select small span strong sub sup " +
	        "textarea u var #text #comment"
	        ;
	
	      // Add HTML5 items to globalAttributes, blockContent, phrasingContent
	      if (type != "html4") {
	        globalAttributes += " contenteditable contextmenu draggable dropzone " +
	          "hidden spellcheck translate";
	        blockContent += " article aside details dialog figure header footer hgroup section nav";
	        phrasingContent += " audio canvas command datalist mark meter output picture " +
	          "progress time wbr video ruby bdi keygen";
	      }
	
	      // Add HTML4 elements unless it's html5-strict
	      if (type != "html5-strict") {
	        globalAttributes += " xml:lang";
	
	        html4PhrasingContent = "acronym applet basefont big font strike tt";
	        phrasingContent = [phrasingContent, html4PhrasingContent].join(' ');
	
	        each(split(html4PhrasingContent), function (name) {
	          add(name, "", phrasingContent);
	        });
	
	        html4BlockContent = "center dir isindex noframes";
	        blockContent = [blockContent, html4BlockContent].join(' ');
	
	        // Flow content elements from the HTML5 spec (block+inline)
	        flowContent = [blockContent, phrasingContent].join(' ');
	
	        each(split(html4BlockContent), function (name) {
	          add(name, "", flowContent);
	        });
	      }
	
	      // Flow content elements from the HTML5 spec (block+inline)
	      flowContent = flowContent || [blockContent, phrasingContent].join(" ");
	
	      // HTML4 base schema TODO: Move HTML5 specific attributes to HTML5 specific if statement
	      // Schema items <element name>, <specific attributes>, <children ..>
	      add("html", "manifest", "head body");
	      add("head", "", "base command link meta noscript script style title");
	      add("title hr noscript br");
	      add("base", "href target");
	      add("link", "href rel media hreflang type sizes hreflang");
	      add("meta", "name http-equiv content charset");
	      add("style", "media type scoped");
	      add("script", "src async defer type charset");
	      add("body", "onafterprint onbeforeprint onbeforeunload onblur onerror onfocus " +
	        "onhashchange onload onmessage onoffline ononline onpagehide onpageshow " +
	        "onpopstate onresize onscroll onstorage onunload", flowContent);
	      add("address dt dd div caption", "", flowContent);
	      add("h1 h2 h3 h4 h5 h6 pre p abbr code var samp kbd sub sup i b u bdo span legend em strong small s cite dfn", "", phrasingContent);
	      add("blockquote", "cite", flowContent);
	      add("ol", "reversed start type", "li");
	      add("ul", "", "li");
	      add("li", "value", flowContent);
	      add("dl", "", "dt dd");
	      add("a", "href target rel media hreflang type", phrasingContent);
	      add("q", "cite", phrasingContent);
	      add("ins del", "cite datetime", flowContent);
	      add("img", "src sizes srcset alt usemap ismap width height");
	      add("iframe", "src name width height", flowContent);
	      add("embed", "src type width height");
	      add("object", "data type typemustmatch name usemap form width height", [flowContent, "param"].join(' '));
	      add("param", "name value");
	      add("map", "name", [flowContent, "area"].join(' '));
	      add("area", "alt coords shape href target rel media hreflang type");
	      add("table", "border", "caption colgroup thead tfoot tbody tr" + (type == "html4" ? " col" : ""));
	      add("colgroup", "span", "col");
	      add("col", "span");
	      add("tbody thead tfoot", "", "tr");
	      add("tr", "", "td th");
	      add("td", "colspan rowspan headers", flowContent);
	      add("th", "colspan rowspan headers scope abbr", flowContent);
	      add("form", "accept-charset action autocomplete enctype method name novalidate target", flowContent);
	      add("fieldset", "disabled form name", [flowContent, "legend"].join(' '));
	      add("label", "form for", phrasingContent);
	      add("input", "accept alt autocomplete checked dirname disabled form formaction formenctype formmethod formnovalidate " +
	        "formtarget height list max maxlength min multiple name pattern readonly required size src step type value width"
	      );
	      add("button", "disabled form formaction formenctype formmethod formnovalidate formtarget name type value",
	        type == "html4" ? flowContent : phrasingContent);
	      add("select", "disabled form multiple name required size", "option optgroup");
	      add("optgroup", "disabled label", "option");
	      add("option", "disabled label selected value");
	      add("textarea", "cols dirname disabled form maxlength name readonly required rows wrap");
	      add("menu", "type label", [flowContent, "li"].join(' '));
	      add("noscript", "", flowContent);
	
	      // Extend with HTML5 elements
	      if (type != "html4") {
	        add("wbr");
	        add("ruby", "", [phrasingContent, "rt rp"].join(' '));
	        add("figcaption", "", flowContent);
	        add("mark rt rp summary bdi", "", phrasingContent);
	        add("canvas", "width height", flowContent);
	        add("video", "src crossorigin poster preload autoplay mediagroup loop " +
	          "muted controls width height buffered", [flowContent, "track source"].join(' '));
	        add("audio", "src crossorigin preload autoplay mediagroup loop muted controls " +
	          "buffered volume", [flowContent, "track source"].join(' '));
	        add("picture", "", "img source");
	        add("source", "src srcset type media sizes");
	        add("track", "kind src srclang label default");
	        add("datalist", "", [phrasingContent, "option"].join(' '));
	        add("article section nav aside header footer", "", flowContent);
	        add("hgroup", "", "h1 h2 h3 h4 h5 h6");
	        add("figure", "", [flowContent, "figcaption"].join(' '));
	        add("time", "datetime", phrasingContent);
	        add("dialog", "open", flowContent);
	        add("command", "type label icon disabled checked radiogroup command");
	        add("output", "for form name", phrasingContent);
	        add("progress", "value max", phrasingContent);
	        add("meter", "value min max low high optimum", phrasingContent);
	        add("details", "open", [flowContent, "summary"].join(' '));
	        add("keygen", "autofocus challenge disabled form keytype name");
	      }
	
	      // Extend with HTML4 attributes unless it's html5-strict
	      if (type != "html5-strict") {
	        addAttrs("script", "language xml:space");
	        addAttrs("style", "xml:space");
	        addAttrs("object", "declare classid code codebase codetype archive standby align border hspace vspace");
	        addAttrs("embed", "align name hspace vspace");
	        addAttrs("param", "valuetype type");
	        addAttrs("a", "charset name rev shape coords");
	        addAttrs("br", "clear");
	        addAttrs("applet", "codebase archive code object alt name width height align hspace vspace");
	        addAttrs("img", "name longdesc align border hspace vspace");
	        addAttrs("iframe", "longdesc frameborder marginwidth marginheight scrolling align");
	        addAttrs("font basefont", "size color face");
	        addAttrs("input", "usemap align");
	        addAttrs("select", "onchange");
	        addAttrs("textarea");
	        addAttrs("h1 h2 h3 h4 h5 h6 div p legend caption", "align");
	        addAttrs("ul", "type compact");
	        addAttrs("li", "type");
	        addAttrs("ol dl menu dir", "compact");
	        addAttrs("pre", "width xml:space");
	        addAttrs("hr", "align noshade size width");
	        addAttrs("isindex", "prompt");
	        addAttrs("table", "summary width frame rules cellspacing cellpadding align bgcolor");
	        addAttrs("col", "width align char charoff valign");
	        addAttrs("colgroup", "width align char charoff valign");
	        addAttrs("thead", "align char charoff valign");
	        addAttrs("tr", "align char charoff valign bgcolor");
	        addAttrs("th", "axis align char charoff valign nowrap bgcolor width height");
	        addAttrs("form", "accept");
	        addAttrs("td", "abbr axis scope align char charoff valign nowrap bgcolor width height");
	        addAttrs("tfoot", "align char charoff valign");
	        addAttrs("tbody", "align char charoff valign");
	        addAttrs("area", "nohref");
	        addAttrs("body", "background bgcolor text link vlink alink");
	      }
	
	      // Extend with HTML5 attributes unless it's html4
	      if (type != "html4") {
	        addAttrs("input button select textarea", "autofocus");
	        addAttrs("input textarea", "placeholder");
	        addAttrs("a", "download");
	        addAttrs("link script img", "crossorigin");
	        addAttrs("iframe", "sandbox seamless allowfullscreen"); // Excluded: srcdoc
	      }
	
	      // Special: iframe, ruby, video, audio, label
	
	      // Delete children of the same name from it's parent
	      // For example: form can't have a child of the name form
	      each(split('a form meter progress dfn'), function (name) {
	        if (schema[name]) {
	          delete schema[name].children[name];
	        }
	      });
	
	      // Delete header, footer, sectioning and heading content descendants
	      /*each('dt th address', function(name) {
	       delete schema[name].children[name];
	       });*/
	
	      // Caption can't have tables
	      delete schema.caption.children.table;
	
	      // Delete scripts by default due to possible XSS
	      delete schema.script;
	
	      // TODO: LI:s can only have value if parent is OL
	
	      // TODO: Handle transparent elements
	      // a ins del canvas map
	
	      mapCache[type] = schema;
	
	      return schema;
	    };
	
	    var compileElementMap = function (value, mode) {
	      var styles;
	
	      if (value) {
	        styles = {};
	
	        if (typeof value == 'string') {
	          value = {
	            '*': value
	          };
	        }
	
	        // Convert styles into a rule list
	        each(value, function (value, key) {
	          styles[key] = styles[key.toUpperCase()] = mode == 'map' ? makeMap(value, /[, ]/) : explode(value, /[, ]/);
	        });
	      }
	
	      return styles;
	    };
	
	    /**
	     * Constructs a new Schema instance.
	     *
	     * @constructor
	     * @method Schema
	     * @param {Object} settings Name/value settings object.
	     */
	    return function (settings) {
	      var self = this, elements = {}, children = {}, patternElements = [], validStyles, invalidStyles, schemaItems;
	      var whiteSpaceElementsMap, selfClosingElementsMap, shortEndedElementsMap, boolAttrMap, validClasses;
	      var blockElementsMap, nonEmptyElementsMap, moveCaretBeforeOnEnterElementsMap, textBlockElementsMap, textInlineElementsMap;
	      var customElementsMap = {}, specialElements = {};
	
	      // Creates an lookup table map object for the specified option or the default value
	      var createLookupTable = function (option, defaultValue, extendWith) {
	        var value = settings[option];
	
	        if (!value) {
	          // Get cached default map or make it if needed
	          value = mapCache[option];
	
	          if (!value) {
	            value = makeMap(defaultValue, ' ', makeMap(defaultValue.toUpperCase(), ' '));
	            value = extend(value, extendWith);
	
	            mapCache[option] = value;
	          }
	        } else {
	          // Create custom map
	          value = makeMap(value, /[, ]/, makeMap(value.toUpperCase(), /[, ]/));
	        }
	
	        return value;
	      };
	
	      settings = settings || {};
	      schemaItems = compileSchema(settings.schema);
	
	      // Allow all elements and attributes if verify_html is set to false
	      if (settings.verify_html === false) {
	        settings.valid_elements = '*[*]';
	      }
	
	      validStyles = compileElementMap(settings.valid_styles);
	      invalidStyles = compileElementMap(settings.invalid_styles, 'map');
	      validClasses = compileElementMap(settings.valid_classes, 'map');
	
	      // Setup map objects
	      whiteSpaceElementsMap = createLookupTable(
	        'whitespace_elements',
	        'pre script noscript style textarea video audio iframe object code'
	      );
	      selfClosingElementsMap = createLookupTable('self_closing_elements', 'colgroup dd dt li option p td tfoot th thead tr');
	      shortEndedElementsMap = createLookupTable('short_ended_elements', 'area base basefont br col frame hr img input isindex link ' +
	        'meta param embed source wbr track');
	      boolAttrMap = createLookupTable('boolean_attributes', 'checked compact declare defer disabled ismap multiple nohref noresize ' +
	        'noshade nowrap readonly selected autoplay loop controls');
	      nonEmptyElementsMap = createLookupTable('non_empty_elements', 'td th iframe video audio object ' +
	        'script pre code', shortEndedElementsMap);
	      moveCaretBeforeOnEnterElementsMap = createLookupTable('move_caret_before_on_enter_elements', 'table', nonEmptyElementsMap);
	      textBlockElementsMap = createLookupTable('text_block_elements', 'h1 h2 h3 h4 h5 h6 p div address pre form ' +
	        'blockquote center dir fieldset header footer article section hgroup aside nav figure');
	      blockElementsMap = createLookupTable('block_elements', 'hr table tbody thead tfoot ' +
	        'th tr td li ol ul caption dl dt dd noscript menu isindex option ' +
	        'datalist select optgroup figcaption', textBlockElementsMap);
	      textInlineElementsMap = createLookupTable('text_inline_elements', 'span strong b em i font strike u var cite ' +
	        'dfn code mark q sup sub samp');
	
	      each((settings.special || 'script noscript noframes noembed title style textarea xmp').split(' '), function (name) {
	        specialElements[name] = new RegExp('<\/' + name + '[^>]*>', 'gi');
	      });
	
	      // Converts a wildcard expression string to a regexp for example *a will become /.*a/.
	      var patternToRegExp = function (str) {
	        return new RegExp('^' + str.replace(/([?+*])/g, '.$1') + '$');
	      };
	
	      // Parses the specified valid_elements string and adds to the current rules
	      // This function is a bit hard to read since it's heavily optimized for speed
	      var addValidElements = function (validElements) {
	        var ei, el, ai, al, matches, element, attr, attrData, elementName, attrName, attrType, attributes, attributesOrder,
	          prefix, outputName, globalAttributes, globalAttributesOrder, key, value,
	          elementRuleRegExp = /^([#+\-])?([^\[!\/]+)(?:\/([^\[!]+))?(?:(!?)\[([^\]]+)\])?$/,
	          attrRuleRegExp = /^([!\-])?(\w+[\\:]:\w+|[^=:<]+)?(?:([=:<])(.*))?$/,
	          hasPatternsRegExp = /[*?+]/;
	
	        if (validElements) {
	          // Split valid elements into an array with rules
	          validElements = split(validElements, ',');
	
	          if (elements['@']) {
	            globalAttributes = elements['@'].attributes;
	            globalAttributesOrder = elements['@'].attributesOrder;
	          }
	
	          // Loop all rules
	          for (ei = 0, el = validElements.length; ei < el; ei++) {
	            // Parse element rule
	            matches = elementRuleRegExp.exec(validElements[ei]);
	            if (matches) {
	              // Setup local names for matches
	              prefix = matches[1];
	              elementName = matches[2];
	              outputName = matches[3];
	              attrData = matches[5];
	
	              // Create new attributes and attributesOrder
	              attributes = {};
	              attributesOrder = [];
	
	              // Create the new element
	              element = {
	                attributes: attributes,
	                attributesOrder: attributesOrder
	              };
	
	              // Padd empty elements prefix
	              if (prefix === '#') {
	                element.paddEmpty = true;
	              }
	
	              // Remove empty elements prefix
	              if (prefix === '-') {
	                element.removeEmpty = true;
	              }
	
	              if (matches[4] === '!') {
	                element.removeEmptyAttrs = true;
	              }
	
	              // Copy attributes from global rule into current rule
	              if (globalAttributes) {
	                for (key in globalAttributes) {
	                  attributes[key] = globalAttributes[key];
	                }
	
	                attributesOrder.push.apply(attributesOrder, globalAttributesOrder);
	              }
	
	              // Attributes defined
	              if (attrData) {
	                attrData = split(attrData, '|');
	                for (ai = 0, al = attrData.length; ai < al; ai++) {
	                  matches = attrRuleRegExp.exec(attrData[ai]);
	                  if (matches) {
	                    attr = {};
	                    attrType = matches[1];
	                    attrName = matches[2].replace(/[\\:]:/g, ':');
	                    prefix = matches[3];
	                    value = matches[4];
	
	                    // Required
	                    if (attrType === '!') {
	                      element.attributesRequired = element.attributesRequired || [];
	                      element.attributesRequired.push(attrName);
	                      attr.required = true;
	                    }
	
	                    // Denied from global
	                    if (attrType === '-') {
	                      delete attributes[attrName];
	                      attributesOrder.splice(inArray(attributesOrder, attrName), 1);
	                      continue;
	                    }
	
	                    // Default value
	                    if (prefix) {
	                      // Default value
	                      if (prefix === '=') {
	                        element.attributesDefault = element.attributesDefault || [];
	                        element.attributesDefault.push({ name: attrName, value: value });
	                        attr.defaultValue = value;
	                      }
	
	                      // Forced value
	                      if (prefix === ':') {
	                        element.attributesForced = element.attributesForced || [];
	                        element.attributesForced.push({ name: attrName, value: value });
	                        attr.forcedValue = value;
	                      }
	
	                      // Required values
	                      if (prefix === '<') {
	                        attr.validValues = makeMap(value, '?');
	                      }
	                    }
	
	                    // Check for attribute patterns
	                    if (hasPatternsRegExp.test(attrName)) {
	                      element.attributePatterns = element.attributePatterns || [];
	                      attr.pattern = patternToRegExp(attrName);
	                      element.attributePatterns.push(attr);
	                    } else {
	                      // Add attribute to order list if it doesn't already exist
	                      if (!attributes[attrName]) {
	                        attributesOrder.push(attrName);
	                      }
	
	                      attributes[attrName] = attr;
	                    }
	                  }
	                }
	              }
	
	              // Global rule, store away these for later usage
	              if (!globalAttributes && elementName == '@') {
	                globalAttributes = attributes;
	                globalAttributesOrder = attributesOrder;
	              }
	
	              // Handle substitute elements such as b/strong
	              if (outputName) {
	                element.outputName = elementName;
	                elements[outputName] = element;
	              }
	
	              // Add pattern or exact element
	              if (hasPatternsRegExp.test(elementName)) {
	                element.pattern = patternToRegExp(elementName);
	                patternElements.push(element);
	              } else {
	                elements[elementName] = element;
	              }
	            }
	          }
	        }
	      };
	
	      var setValidElements = function (validElements) {
	        elements = {};
	        patternElements = [];
	
	        addValidElements(validElements);
	
	        each(schemaItems, function (element, name) {
	          children[name] = element.children;
	        });
	      };
	
	      // Adds custom non HTML elements to the schema
	      var addCustomElements = function (customElements) {
	        var customElementRegExp = /^(~)?(.+)$/;
	
	        if (customElements) {
	          // Flush cached items since we are altering the default maps
	          mapCache.text_block_elements = mapCache.block_elements = null;
	
	          each(split(customElements, ','), function (rule) {
	            var matches = customElementRegExp.exec(rule),
	              inline = matches[1] === '~',
	              cloneName = inline ? 'span' : 'div',
	              name = matches[2];
	
	            children[name] = children[cloneName];
	            customElementsMap[name] = cloneName;
	
	            // If it's not marked as inline then add it to valid block elements
	            if (!inline) {
	              blockElementsMap[name.toUpperCase()] = {};
	              blockElementsMap[name] = {};
	            }
	
	            // Add elements clone if needed
	            if (!elements[name]) {
	              var customRule = elements[cloneName];
	
	              customRule = extend({}, customRule);
	              delete customRule.removeEmptyAttrs;
	              delete customRule.removeEmpty;
	
	              elements[name] = customRule;
	            }
	
	            // Add custom elements at span/div positions
	            each(children, function (element, elmName) {
	              if (element[cloneName]) {
	                children[elmName] = element = extend({}, children[elmName]);
	                element[name] = element[cloneName];
	              }
	            });
	          });
	        }
	      };
	
	      // Adds valid children to the schema object
	      var addValidChildren = function (validChildren) {
	        var childRuleRegExp = /^([+\-]?)(\w+)\[([^\]]+)\]$/;
	
	        // Invalidate the schema cache if the schema is mutated
	        mapCache[settings.schema] = null;
	
	        if (validChildren) {
	          each(split(validChildren, ','), function (rule) {
	            var matches = childRuleRegExp.exec(rule), parent, prefix;
	
	            if (matches) {
	              prefix = matches[1];
	
	              // Add/remove items from default
	              if (prefix) {
	                parent = children[matches[2]];
	              } else {
	                parent = children[matches[2]] = { '#comment': {} };
	              }
	
	              parent = children[matches[2]];
	
	              each(split(matches[3], '|'), function (child) {
	                if (prefix === '-') {
	                  delete parent[child];
	                } else {
	                  parent[child] = {};
	                }
	              });
	            }
	          });
	        }
	      };
	
	      var getElementRule = function (name) {
	        var element = elements[name], i;
	
	        // Exact match found
	        if (element) {
	          return element;
	        }
	
	        // No exact match then try the patterns
	        i = patternElements.length;
	        while (i--) {
	          element = patternElements[i];
	
	          if (element.pattern.test(name)) {
	            return element;
	          }
	        }
	      };
	
	      if (!settings.valid_elements) {
	        // No valid elements defined then clone the elements from the schema spec
	        each(schemaItems, function (element, name) {
	          elements[name] = {
	            attributes: element.attributes,
	            attributesOrder: element.attributesOrder
	          };
	
	          children[name] = element.children;
	        });
	
	        // Switch these on HTML4
	        if (settings.schema != "html5") {
	          each(split('strong/b em/i'), function (item) {
	            item = split(item, '/');
	            elements[item[1]].outputName = item[0];
	          });
	        }
	
	        // Add default alt attribute for images, removed since alt="" is treated as presentational.
	        // elements.img.attributesDefault = [{name: 'alt', value: ''}];
	
	        // Remove these if they are empty by default
	        each(split('ol ul sub sup blockquote span font a table tbody tr strong em b i'), function (name) {
	          if (elements[name]) {
	            elements[name].removeEmpty = true;
	          }
	        });
	
	        // Padd these by default
	        each(split('p h1 h2 h3 h4 h5 h6 th td pre div address caption li'), function (name) {
	          elements[name].paddEmpty = true;
	        });
	
	        // Remove these if they have no attributes
	        each(split('span'), function (name) {
	          elements[name].removeEmptyAttrs = true;
	        });
	
	        // Remove these by default
	        // TODO: Reenable in 4.1
	        /*each(split('script style'), function(name) {
	         delete elements[name];
	         });*/
	      } else {
	        setValidElements(settings.valid_elements);
	      }
	
	      addCustomElements(settings.custom_elements);
	      addValidChildren(settings.valid_children);
	      addValidElements(settings.extended_valid_elements);
	
	      // Todo: Remove this when we fix list handling to be valid
	      addValidChildren('+ol[ul|ol],+ul[ul|ol]');
	
	
	      // Some elements are not valid by themselves - require parents
	      each({
	        dd: 'dl',
	        dt: 'dl',
	        li: 'ul ol',
	        td: 'tr',
	        th: 'tr',
	        tr: 'tbody thead tfoot',
	        tbody: 'table',
	        thead: 'table',
	        tfoot: 'table',
	        legend: 'fieldset',
	        area: 'map',
	        param: 'video audio object'
	      }, function (parents, item) {
	        if (elements[item]) {
	          elements[item].parentsRequired = split(parents);
	        }
	      });
	
	
	      // Delete invalid elements
	      if (settings.invalid_elements) {
	        each(explode(settings.invalid_elements), function (item) {
	          if (elements[item]) {
	            delete elements[item];
	          }
	        });
	      }
	
	      // If the user didn't allow span only allow internal spans
	      if (!getElementRule('span')) {
	        addValidElements('span[!data-mce-type|*]');
	      }
	
	      /**
	       * Name/value map object with valid parents and children to those parents.
	       *
	       * @example
	       * children = {
	       *    div:{p:{}, h1:{}}
	       * };
	       * @field children
	       * @type Object
	       */
	      self.children = children;
	
	      /**
	       * Name/value map object with valid styles for each element.
	       *
	       * @method getValidStyles
	       * @type Object
	       */
	      self.getValidStyles = function () {
	        return validStyles;
	      };
	
	      /**
	       * Name/value map object with valid styles for each element.
	       *
	       * @method getInvalidStyles
	       * @type Object
	       */
	      self.getInvalidStyles = function () {
	        return invalidStyles;
	      };
	
	      /**
	       * Name/value map object with valid classes for each element.
	       *
	       * @method getValidClasses
	       * @type Object
	       */
	      self.getValidClasses = function () {
	        return validClasses;
	      };
	
	      /**
	       * Returns a map with boolean attributes.
	       *
	       * @method getBoolAttrs
	       * @return {Object} Name/value lookup map for boolean attributes.
	       */
	      self.getBoolAttrs = function () {
	        return boolAttrMap;
	      };
	
	      /**
	       * Returns a map with block elements.
	       *
	       * @method getBlockElements
	       * @return {Object} Name/value lookup map for block elements.
	       */
	      self.getBlockElements = function () {
	        return blockElementsMap;
	      };
	
	      /**
	       * Returns a map with text block elements. Such as: p,h1-h6,div,address
	       *
	       * @method getTextBlockElements
	       * @return {Object} Name/value lookup map for block elements.
	       */
	      self.getTextBlockElements = function () {
	        return textBlockElementsMap;
	      };
	
	      /**
	       * Returns a map of inline text format nodes for example strong/span or ins.
	       *
	       * @method getTextInlineElements
	       * @return {Object} Name/value lookup map for text format elements.
	       */
	      self.getTextInlineElements = function () {
	        return textInlineElementsMap;
	      };
	
	      /**
	       * Returns a map with short ended elements such as BR or IMG.
	       *
	       * @method getShortEndedElements
	       * @return {Object} Name/value lookup map for short ended elements.
	       */
	      self.getShortEndedElements = function () {
	        return shortEndedElementsMap;
	      };
	
	      /**
	       * Returns a map with self closing tags such as <li>.
	       *
	       * @method getSelfClosingElements
	       * @return {Object} Name/value lookup map for self closing tags elements.
	       */
	      self.getSelfClosingElements = function () {
	        return selfClosingElementsMap;
	      };
	
	      /**
	       * Returns a map with elements that should be treated as contents regardless if it has text
	       * content in them or not such as TD, VIDEO or IMG.
	       *
	       * @method getNonEmptyElements
	       * @return {Object} Name/value lookup map for non empty elements.
	       */
	      self.getNonEmptyElements = function () {
	        return nonEmptyElementsMap;
	      };
	
	      /**
	       * Returns a map with elements that the caret should be moved in front of after enter is
	       * pressed
	       *
	       * @method getMoveCaretBeforeOnEnterElements
	       * @return {Object} Name/value lookup map for elements to place the caret in front of.
	       */
	      self.getMoveCaretBeforeOnEnterElements = function () {
	        return moveCaretBeforeOnEnterElementsMap;
	      };
	
	      /**
	       * Returns a map with elements where white space is to be preserved like PRE or SCRIPT.
	       *
	       * @method getWhiteSpaceElements
	       * @return {Object} Name/value lookup map for white space elements.
	       */
	      self.getWhiteSpaceElements = function () {
	        return whiteSpaceElementsMap;
	      };
	
	      /**
	       * Returns a map with special elements. These are elements that needs to be parsed
	       * in a special way such as script, style, textarea etc. The map object values
	       * are regexps used to find the end of the element.
	       *
	       * @method getSpecialElements
	       * @return {Object} Name/value lookup map for special elements.
	       */
	      self.getSpecialElements = function () {
	        return specialElements;
	      };
	
	      /**
	       * Returns true/false if the specified element and it's child is valid or not
	       * according to the schema.
	       *
	       * @method isValidChild
	       * @param {String} name Element name to check for.
	       * @param {String} child Element child to verify.
	       * @return {Boolean} True/false if the element is a valid child of the specified parent.
	       */
	      self.isValidChild = function (name, child) {
	        var parent = children[name.toLowerCase()];
	
	        return !!(parent && parent[child.toLowerCase()]);
	      };
	
	      /**
	       * Returns true/false if the specified element name and optional attribute is
	       * valid according to the schema.
	       *
	       * @method isValid
	       * @param {String} name Name of element to check.
	       * @param {String} attr Optional attribute name to check for.
	       * @return {Boolean} True/false if the element and attribute is valid.
	       */
	      self.isValid = function (name, attr) {
	        var attrPatterns, i, rule = getElementRule(name);
	
	        // Check if it's a valid element
	        if (rule) {
	          if (attr) {
	            // Check if attribute name exists
	            if (rule.attributes[attr]) {
	              return true;
	            }
	
	            // Check if attribute matches a regexp pattern
	            attrPatterns = rule.attributePatterns;
	            if (attrPatterns) {
	              i = attrPatterns.length;
	              while (i--) {
	                if (attrPatterns[i].pattern.test(name)) {
	                  return true;
	                }
	              }
	            }
	          } else {
	            return true;
	          }
	        }
	
	        // No match
	        return false;
	      };
	
	      /**
	       * Returns true/false if the specified element is valid or not
	       * according to the schema.
	       *
	       * @method getElementRule
	       * @param {String} name Element name to check for.
	       * @return {Object} Element object or undefined if the element isn't valid.
	       */
	      self.getElementRule = getElementRule;
	
	      /**
	       * Returns an map object of all custom elements.
	       *
	       * @method getCustomElements
	       * @return {Object} Name/value map object of all custom elements.
	       */
	      self.getCustomElements = function () {
	        return customElementsMap;
	      };
	
	      /**
	       * Parses a valid elements string and adds it to the schema. The valid elements
	       * format is for example "element[attr=default|otherattr]".
	       * Existing rules will be replaced with the ones specified, so this extends the schema.
	       *
	       * @method addValidElements
	       * @param {String} valid_elements String in the valid elements format to be parsed.
	       */
	      self.addValidElements = addValidElements;
	
	      /**
	       * Parses a valid elements string and sets it to the schema. The valid elements
	       * format is for example "element[attr=default|otherattr]".
	       * Existing rules will be replaced with the ones specified, so this extends the schema.
	       *
	       * @method setValidElements
	       * @param {String} valid_elements String in the valid elements format to be parsed.
	       */
	      self.setValidElements = setValidElements;
	
	      /**
	       * Adds custom non HTML elements to the schema.
	       *
	       * @method addCustomElements
	       * @param {String} custom_elements Comma separated list of custom elements to add.
	       */
	      self.addCustomElements = addCustomElements;
	
	      /**
	       * Parses a valid children string and adds them to the schema structure. The valid children
	       * format is for example: "element[child1|child2]".
	       *
	       * @method addValidChildren
	       * @param {String} valid_children Valid children elements string to parse
	       */
	      self.addValidChildren = addValidChildren;
	
	      self.elements = elements;
	    };
	  }
	);
	
	/**
	 * Styles.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to parse CSS styles it also compresses styles to reduce the output size.
	 *
	 * @example
	 * var Styles = new tinymce.html.Styles({
	 *    url_converter: function(url) {
	 *       return url;
	 *    }
	 * });
	 *
	 * styles = Styles.parse('border: 1px solid red');
	 * styles.color = 'red';
	 *
	 * console.log(new tinymce.html.StyleSerializer().serialize(styles));
	 *
	 * @class tinymce.html.Styles
	 * @version 3.4
	 */
	define(
	  'tinymce.core.html.Styles',
	  [
	  ],
	  function () {
	    return function (settings, schema) {
	      /*jshint maxlen:255 */
	      /*eslint max-len:0 */
	      var rgbRegExp = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)\s*\)/gi,
	        urlOrStrRegExp = /(?:url(?:(?:\(\s*\"([^\"]+)\"\s*\))|(?:\(\s*\'([^\']+)\'\s*\))|(?:\(\s*([^)\s]+)\s*\))))|(?:\'([^\']+)\')|(?:\"([^\"]+)\")/gi,
	        styleRegExp = /\s*([^:]+):\s*([^;]+);?/g,
	        trimRightRegExp = /\s+$/,
	        i, encodingLookup = {}, encodingItems, validStyles, invalidStyles, invisibleChar = '\uFEFF';
	
	      settings = settings || {};
	
	      if (schema) {
	        validStyles = schema.getValidStyles();
	        invalidStyles = schema.getInvalidStyles();
	      }
	
	      encodingItems = ('\\" \\\' \\; \\: ; : ' + invisibleChar).split(' ');
	      for (i = 0; i < encodingItems.length; i++) {
	        encodingLookup[encodingItems[i]] = invisibleChar + i;
	        encodingLookup[invisibleChar + i] = encodingItems[i];
	      }
	
	      var toHex = function (match, r, g, b) {
	        var hex = function (val) {
	          val = parseInt(val, 10).toString(16);
	
	          return val.length > 1 ? val : '0' + val; // 0 -> 00
	        };
	
	        return '#' + hex(r) + hex(g) + hex(b);
	      };
	
	      return {
	        /**
	         * Parses the specified RGB color value and returns a hex version of that color.
	         *
	         * @method toHex
	         * @param {String} color RGB string value like rgb(1,2,3)
	         * @return {String} Hex version of that RGB value like #FF00FF.
	         */
	        toHex: function (color) {
	          return color.replace(rgbRegExp, toHex);
	        },
	
	        /**
	         * Parses the specified style value into an object collection. This parser will also
	         * merge and remove any redundant items that browsers might have added. It will also convert non hex
	         * colors to hex values. Urls inside the styles will also be converted to absolute/relative based on settings.
	         *
	         * @method parse
	         * @param {String} css Style value to parse for example: border:1px solid red;.
	         * @return {Object} Object representation of that style like {border: '1px solid red'}
	         */
	        parse: function (css) {
	          var styles = {}, matches, name, value, isEncoded, urlConverter = settings.url_converter;
	          var urlConverterScope = settings.url_converter_scope || this;
	
	          var compress = function (prefix, suffix, noJoin) {
	            var top, right, bottom, left;
	
	            top = styles[prefix + '-top' + suffix];
	            if (!top) {
	              return;
	            }
	
	            right = styles[prefix + '-right' + suffix];
	            if (!right) {
	              return;
	            }
	
	            bottom = styles[prefix + '-bottom' + suffix];
	            if (!bottom) {
	              return;
	            }
	
	            left = styles[prefix + '-left' + suffix];
	            if (!left) {
	              return;
	            }
	
	            var box = [top, right, bottom, left];
	            i = box.length - 1;
	            while (i--) {
	              if (box[i] !== box[i + 1]) {
	                break;
	              }
	            }
	
	            if (i > -1 && noJoin) {
	              return;
	            }
	
	            styles[prefix + suffix] = i == -1 ? box[0] : box.join(' ');
	            delete styles[prefix + '-top' + suffix];
	            delete styles[prefix + '-right' + suffix];
	            delete styles[prefix + '-bottom' + suffix];
	            delete styles[prefix + '-left' + suffix];
	          };
	
	          /**
	           * Checks if the specific style can be compressed in other words if all border-width are equal.
	           */
	          var canCompress = function (key) {
	            var value = styles[key], i;
	
	            if (!value) {
	              return;
	            }
	
	            value = value.split(' ');
	            i = value.length;
	            while (i--) {
	              if (value[i] !== value[0]) {
	                return false;
	              }
	            }
	
	            styles[key] = value[0];
	
	            return true;
	          };
	
	          /**
	           * Compresses multiple styles into one style.
	           */
	          var compress2 = function (target, a, b, c) {
	            if (!canCompress(a)) {
	              return;
	            }
	
	            if (!canCompress(b)) {
	              return;
	            }
	
	            if (!canCompress(c)) {
	              return;
	            }
	
	            // Compress
	            styles[target] = styles[a] + ' ' + styles[b] + ' ' + styles[c];
	            delete styles[a];
	            delete styles[b];
	            delete styles[c];
	          };
	
	          // Encodes the specified string by replacing all \" \' ; : with _<num>
	          var encode = function (str) {
	            isEncoded = true;
	
	            return encodingLookup[str];
	          };
	
	          // Decodes the specified string by replacing all _<num> with it's original value \" \' etc
	          // It will also decode the \" \' if keepSlashes is set to fale or omitted
	          var decode = function (str, keepSlashes) {
	            if (isEncoded) {
	              str = str.replace(/\uFEFF[0-9]/g, function (str) {
	                return encodingLookup[str];
	              });
	            }
	
	            if (!keepSlashes) {
	              str = str.replace(/\\([\'\";:])/g, "$1");
	            }
	
	            return str;
	          };
	
	          var decodeSingleHexSequence = function (escSeq) {
	            return String.fromCharCode(parseInt(escSeq.slice(1), 16));
	          };
	
	          var decodeHexSequences = function (value) {
	            return value.replace(/\\[0-9a-f]+/gi, decodeSingleHexSequence);
	          };
	
	          var processUrl = function (match, url, url2, url3, str, str2) {
	            str = str || str2;
	
	            if (str) {
	              str = decode(str);
	
	              // Force strings into single quote format
	              return "'" + str.replace(/\'/g, "\\'") + "'";
	            }
	
	            url = decode(url || url2 || url3);
	
	            if (!settings.allow_script_urls) {
	              var scriptUrl = url.replace(/[\s\r\n]+/g, '');
	
	              if (/(java|vb)script:/i.test(scriptUrl)) {
	                return "";
	              }
	
	              if (!settings.allow_svg_data_urls && /^data:image\/svg/i.test(scriptUrl)) {
	                return "";
	              }
	            }
	
	            // Convert the URL to relative/absolute depending on config
	            if (urlConverter) {
	              url = urlConverter.call(urlConverterScope, url, 'style');
	            }
	
	            // Output new URL format
	            return "url('" + url.replace(/\'/g, "\\'") + "')";
	          };
	
	          if (css) {
	            css = css.replace(/[\u0000-\u001F]/g, '');
	
	            // Encode \" \' % and ; and : inside strings so they don't interfere with the style parsing
	            css = css.replace(/\\[\"\';:\uFEFF]/g, encode).replace(/\"[^\"]+\"|\'[^\']+\'/g, function (str) {
	              return str.replace(/[;:]/g, encode);
	            });
	
	            // Parse styles
	            while ((matches = styleRegExp.exec(css))) {
	              styleRegExp.lastIndex = matches.index + matches[0].length;
	              name = matches[1].replace(trimRightRegExp, '').toLowerCase();
	              value = matches[2].replace(trimRightRegExp, '');
	
	              if (name && value) {
	                // Decode escaped sequences like \65 -> e
	                name = decodeHexSequences(name);
	                value = decodeHexSequences(value);
	
	                // Skip properties with double quotes and sequences like \" \' in their names
	                // See 'mXSS Attacks: Attacking well-secured Web-Applications by using innerHTML Mutations'
	                // https://cure53.de/fp170.pdf
	                if (name.indexOf(invisibleChar) !== -1 || name.indexOf('"') !== -1) {
	                  continue;
	                }
	
	                // Don't allow behavior name or expression/comments within the values
	                if (!settings.allow_script_urls && (name == "behavior" || /expression\s*\(|\/\*|\*\//.test(value))) {
	                  continue;
	                }
	
	                // Opera will produce 700 instead of bold in their style values
	                if (name === 'font-weight' && value === '700') {
	                  value = 'bold';
	                } else if (name === 'color' || name === 'background-color') { // Lowercase colors like RED
	                  value = value.toLowerCase();
	                }
	
	                // Convert RGB colors to HEX
	                value = value.replace(rgbRegExp, toHex);
	
	                // Convert URLs and force them into url('value') format
	                value = value.replace(urlOrStrRegExp, processUrl);
	                styles[name] = isEncoded ? decode(value, true) : value;
	              }
	            }
	            // Compress the styles to reduce it's size for example IE will expand styles
	            compress("border", "", true);
	            compress("border", "-width");
	            compress("border", "-color");
	            compress("border", "-style");
	            compress("padding", "");
	            compress("margin", "");
	            compress2('border', 'border-width', 'border-style', 'border-color');
	
	            // Remove pointless border, IE produces these
	            if (styles.border === 'medium none') {
	              delete styles.border;
	            }
	
	            // IE 11 will produce a border-image: none when getting the style attribute from <p style="border: 1px solid red"></p>
	            // So let us assume it shouldn't be there
	            if (styles['border-image'] === 'none') {
	              delete styles['border-image'];
	            }
	          }
	
	          return styles;
	        },
	
	        /**
	         * Serializes the specified style object into a string.
	         *
	         * @method serialize
	         * @param {Object} styles Object to serialize as string for example: {border: '1px solid red'}
	         * @param {String} elementName Optional element name, if specified only the styles that matches the schema will be serialized.
	         * @return {String} String representation of the style object for example: border: 1px solid red.
	         */
	        serialize: function (styles, elementName) {
	          var css = '', name, value;
	
	          var serializeStyles = function (name) {
	            var styleList, i, l, value;
	
	            styleList = validStyles[name];
	            if (styleList) {
	              for (i = 0, l = styleList.length; i < l; i++) {
	                name = styleList[i];
	                value = styles[name];
	
	                if (value) {
	                  css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
	                }
	              }
	            }
	          };
	
	          var isValid = function (name, elementName) {
	            var styleMap;
	
	            styleMap = invalidStyles['*'];
	            if (styleMap && styleMap[name]) {
	              return false;
	            }
	
	            styleMap = invalidStyles[elementName];
	            if (styleMap && styleMap[name]) {
	              return false;
	            }
	
	            return true;
	          };
	
	          // Serialize styles according to schema
	          if (elementName && validStyles) {
	            // Serialize global styles and element specific styles
	            serializeStyles('*');
	            serializeStyles(elementName);
	          } else {
	            // Output the styles in the order they are inside the object
	            for (name in styles) {
	              value = styles[name];
	
	              if (value && (!invalidStyles || isValid(name, elementName))) {
	                css += (css.length > 0 ? ' ' : '') + name + ': ' + value + ';';
	              }
	            }
	          }
	
	          return css;
	        }
	      };
	    };
	  }
	);
	
	/**
	 * DOMUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility class for various DOM manipulation and retrieval functions.
	 *
	 * @class tinymce.dom.DOMUtils
	 * @example
	 * // Add a class to an element by id in the page
	 * tinymce.DOM.addClass('someid', 'someclass');
	 *
	 * // Add a class to an element by id inside the editor
	 * tinymce.activeEditor.dom.addClass('someid', 'someclass');
	 */
	define(
	  'tinymce.core.dom.DOMUtils',
	  [
	    'global!document',
	    'global!window',
	    'tinymce.core.Env',
	    'tinymce.core.dom.DomQuery',
	    'tinymce.core.dom.EventUtils',
	    'tinymce.core.dom.Position',
	    'tinymce.core.dom.Sizzle',
	    'tinymce.core.dom.StyleSheetLoader',
	    'tinymce.core.dom.TreeWalker',
	    'tinymce.core.dom.TrimNode',
	    'tinymce.core.html.Entities',
	    'tinymce.core.html.Schema',
	    'tinymce.core.html.Styles',
	    'tinymce.core.util.Tools'
	  ],
	  function (document, window, Env, DomQuery, EventUtils, Position, Sizzle, StyleSheetLoader, TreeWalker, TrimNode, Entities, Schema, Styles, Tools) {
	    // Shorten names
	    var each = Tools.each, is = Tools.is, grep = Tools.grep;
	    var isIE = Env.ie;
	    var simpleSelectorRe = /^([a-z0-9],?)+$/i;
	    var whiteSpaceRegExp = /^[ \t\r\n]*$/;
	
	    var setupAttrHooks = function (domUtils, settings) {
	      var attrHooks = {}, keepValues = settings.keep_values, keepUrlHook;
	
	      keepUrlHook = {
	        set: function ($elm, value, name) {
	          if (settings.url_converter) {
	            value = settings.url_converter.call(settings.url_converter_scope || domUtils, value, name, $elm[0]);
	          }
	
	          $elm.attr('data-mce-' + name, value).attr(name, value);
	        },
	
	        get: function ($elm, name) {
	          return $elm.attr('data-mce-' + name) || $elm.attr(name);
	        }
	      };
	
	      attrHooks = {
	        style: {
	          set: function ($elm, value) {
	            if (value !== null && typeof value === 'object') {
	              $elm.css(value);
	              return;
	            }
	
	            if (keepValues) {
	              $elm.attr('data-mce-style', value);
	            }
	
	            $elm.attr('style', value);
	          },
	
	          get: function ($elm) {
	            var value = $elm.attr('data-mce-style') || $elm.attr('style');
	
	            value = domUtils.serializeStyle(domUtils.parseStyle(value), $elm[0].nodeName);
	
	            return value;
	          }
	        }
	      };
	
	      if (keepValues) {
	        attrHooks.href = attrHooks.src = keepUrlHook;
	      }
	
	      return attrHooks;
	    };
	
	    var updateInternalStyleAttr = function (domUtils, $elm) {
	      var value = $elm.attr('style');
	
	      value = domUtils.serializeStyle(domUtils.parseStyle(value), $elm[0].nodeName);
	
	      if (!value) {
	        value = null;
	      }
	
	      $elm.attr('data-mce-style', value);
	    };
	
	    var nodeIndex = function (node, normalized) {
	      var idx = 0, lastNodeType, nodeType;
	
	      if (node) {
	        for (lastNodeType = node.nodeType, node = node.previousSibling; node; node = node.previousSibling) {
	          nodeType = node.nodeType;
	
	          // Normalize text nodes
	          if (normalized && nodeType == 3) {
	            if (nodeType == lastNodeType || !node.nodeValue.length) {
	              continue;
	            }
	          }
	          idx++;
	          lastNodeType = nodeType;
	        }
	      }
	
	      return idx;
	    };
	
	    /**
	     * Constructs a new DOMUtils instance. Consult the Wiki for more details on settings etc for this class.
	     *
	     * @constructor
	     * @method DOMUtils
	     * @param {Document} doc Document reference to bind the utility class to.
	     * @param {settings} settings Optional settings collection.
	     */
	    var DOMUtils = function (doc, settings) {
	      var self = this, blockElementsMap;
	
	      self.doc = doc;
	      self.win = window;
	      self.files = {};
	      self.counter = 0;
	      self.stdMode = !isIE || doc.documentMode >= 8;
	      self.boxModel = !isIE || doc.compatMode == "CSS1Compat" || self.stdMode;
	      self.styleSheetLoader = new StyleSheetLoader(doc);
	      self.boundEvents = [];
	      self.settings = settings = settings || {};
	      self.schema = settings.schema ? settings.schema : new Schema({});
	      self.styles = new Styles({
	        url_converter: settings.url_converter,
	        url_converter_scope: settings.url_converter_scope
	      }, settings.schema);
	
	      self.fixDoc(doc);
	      self.events = settings.ownEvents ? new EventUtils(settings.proxy) : EventUtils.Event;
	      self.attrHooks = setupAttrHooks(self, settings);
	      blockElementsMap = self.schema.getBlockElements();
	      self.$ = DomQuery.overrideDefaults(function () {
	        return {
	          context: doc,
	          element: self.getRoot()
	        };
	      });
	
	      /**
	       * Returns true/false if the specified element is a block element or not.
	       *
	       * @method isBlock
	       * @param {Node/String} node Element/Node to check.
	       * @return {Boolean} True/False state if the node is a block element or not.
	       */
	      self.isBlock = function (node) {
	        // Fix for #5446
	        if (!node) {
	          return false;
	        }
	
	        // This function is called in module pattern style since it might be executed with the wrong this scope
	        var type = node.nodeType;
	
	        // If it's a node then check the type and use the nodeName
	        if (type) {
	          return !!(type === 1 && blockElementsMap[node.nodeName]);
	        }
	
	        return !!blockElementsMap[node];
	      };
	    };
	
	    DOMUtils.prototype = {
	      $$: function (elm) {
	        if (typeof elm == 'string') {
	          elm = this.get(elm);
	        }
	
	        return this.$(elm);
	      },
	
	      root: null,
	
	      fixDoc: function (doc) {
	        var settings = this.settings, name;
	
	        if (isIE && settings.schema) {
	          // Add missing HTML 4/5 elements to IE
	          ('abbr article aside audio canvas ' +
	            'details figcaption figure footer ' +
	            'header hgroup mark menu meter nav ' +
	            'output progress section summary ' +
	            'time video').replace(/\w+/g, function (name) {
	              doc.createElement(name);
	            });
	
	          // Create all custom elements
	          for (name in settings.schema.getCustomElements()) {
	            doc.createElement(name);
	          }
	        }
	      },
	
	      clone: function (node, deep) {
	        var self = this, clone, doc;
	
	        // TODO: Add feature detection here in the future
	        if (!isIE || node.nodeType !== 1 || deep) {
	          return node.cloneNode(deep);
	        }
	
	        doc = self.doc;
	
	        // Make a HTML5 safe shallow copy
	        if (!deep) {
	          clone = doc.createElement(node.nodeName);
	
	          // Copy attribs
	          each(self.getAttribs(node), function (attr) {
	            self.setAttrib(clone, attr.nodeName, self.getAttrib(node, attr.nodeName));
	          });
	
	          return clone;
	        }
	
	        return clone.firstChild;
	      },
	
	      /**
	       * Returns the root node of the document. This is normally the body but might be a DIV. Parents like getParent will not
	       * go above the point of this root node.
	       *
	       * @method getRoot
	       * @return {Element} Root element for the utility class.
	       */
	      getRoot: function () {
	        var self = this;
	
	        return self.settings.root_element || self.doc.body;
	      },
	
	      /**
	       * Returns the viewport of the window.
	       *
	       * @method getViewPort
	       * @param {Window} win Optional window to get viewport of.
	       * @return {Object} Viewport object with fields x, y, w and h.
	       */
	      getViewPort: function (win) {
	        var doc, rootElm;
	
	        win = !win ? this.win : win;
	        doc = win.document;
	        rootElm = this.boxModel ? doc.documentElement : doc.body;
	
	        // Returns viewport size excluding scrollbars
	        return {
	          x: win.pageXOffset || rootElm.scrollLeft,
	          y: win.pageYOffset || rootElm.scrollTop,
	          w: win.innerWidth || rootElm.clientWidth,
	          h: win.innerHeight || rootElm.clientHeight
	        };
	      },
	
	      /**
	       * Returns the rectangle for a specific element.
	       *
	       * @method getRect
	       * @param {Element/String} elm Element object or element ID to get rectangle from.
	       * @return {object} Rectangle for specified element object with x, y, w, h fields.
	       */
	      getRect: function (elm) {
	        var self = this, pos, size;
	
	        elm = self.get(elm);
	        pos = self.getPos(elm);
	        size = self.getSize(elm);
	
	        return {
	          x: pos.x, y: pos.y,
	          w: size.w, h: size.h
	        };
	      },
	
	      /**
	       * Returns the size dimensions of the specified element.
	       *
	       * @method getSize
	       * @param {Element/String} elm Element object or element ID to get rectangle from.
	       * @return {object} Rectangle for specified element object with w, h fields.
	       */
	      getSize: function (elm) {
	        var self = this, w, h;
	
	        elm = self.get(elm);
	        w = self.getStyle(elm, 'width');
	        h = self.getStyle(elm, 'height');
	
	        // Non pixel value, then force offset/clientWidth
	        if (w.indexOf('px') === -1) {
	          w = 0;
	        }
	
	        // Non pixel value, then force offset/clientWidth
	        if (h.indexOf('px') === -1) {
	          h = 0;
	        }
	
	        return {
	          w: parseInt(w, 10) || elm.offsetWidth || elm.clientWidth,
	          h: parseInt(h, 10) || elm.offsetHeight || elm.clientHeight
	        };
	      },
	
	      /**
	       * Returns a node by the specified selector function. This function will
	       * loop through all parent nodes and call the specified function for each node.
	       * If the function then returns true indicating that it has found what it was looking for, the loop execution will then end
	       * and the node it found will be returned.
	       *
	       * @method getParent
	       * @param {Node/String} node DOM node to search parents on or ID string.
	       * @param {function} selector Selection function or CSS selector to execute on each node.
	       * @param {Node} root Optional root element, never go beyond this point.
	       * @return {Node} DOM Node or null if it wasn't found.
	       */
	      getParent: function (node, selector, root) {
	        return this.getParents(node, selector, root, false);
	      },
	
	      /**
	       * Returns a node list of all parents matching the specified selector function or pattern.
	       * If the function then returns true indicating that it has found what it was looking for and that node will be collected.
	       *
	       * @method getParents
	       * @param {Node/String} node DOM node to search parents on or ID string.
	       * @param {function} selector Selection function to execute on each node or CSS pattern.
	       * @param {Node} root Optional root element, never go beyond this point.
	       * @return {Array} Array of nodes or null if it wasn't found.
	       */
	      getParents: function (node, selector, root, collect) {
	        var self = this, selectorVal, result = [];
	
	        node = self.get(node);
	        collect = collect === undefined;
	
	        // Default root on inline mode
	        root = root || (self.getRoot().nodeName != 'BODY' ? self.getRoot().parentNode : null);
	
	        // Wrap node name as func
	        if (is(selector, 'string')) {
	          selectorVal = selector;
	
	          if (selector === '*') {
	            selector = function (node) {
	              return node.nodeType == 1;
	            };
	          } else {
	            selector = function (node) {
	              return self.is(node, selectorVal);
	            };
	          }
	        }
	
	        while (node) {
	          if (node == root || !node.nodeType || node.nodeType === 9) {
	            break;
	          }
	
	          if (!selector || selector(node)) {
	            if (collect) {
	              result.push(node);
	            } else {
	              return node;
	            }
	          }
	
	          node = node.parentNode;
	        }
	
	        return collect ? result : null;
	      },
	
	      /**
	       * Returns the specified element by ID or the input element if it isn't a string.
	       *
	       * @method get
	       * @param {String/Element} n Element id to look for or element to just pass though.
	       * @return {Element} Element matching the specified id or null if it wasn't found.
	       */
	      get: function (elm) {
	        var name;
	
	        if (elm && this.doc && typeof elm == 'string') {
	          name = elm;
	          elm = this.doc.getElementById(elm);
	
	          // IE and Opera returns meta elements when they match the specified input ID, but getElementsByName seems to do the trick
	          if (elm && elm.id !== name) {
	            return this.doc.getElementsByName(name)[1];
	          }
	        }
	
	        return elm;
	      },
	
	      /**
	       * Returns the next node that matches selector or function
	       *
	       * @method getNext
	       * @param {Node} node Node to find siblings from.
	       * @param {String/function} selector Selector CSS expression or function.
	       * @return {Node} Next node item matching the selector or null if it wasn't found.
	       */
	      getNext: function (node, selector) {
	        return this._findSib(node, selector, 'nextSibling');
	      },
	
	      /**
	       * Returns the previous node that matches selector or function
	       *
	       * @method getPrev
	       * @param {Node} node Node to find siblings from.
	       * @param {String/function} selector Selector CSS expression or function.
	       * @return {Node} Previous node item matching the selector or null if it wasn't found.
	       */
	      getPrev: function (node, selector) {
	        return this._findSib(node, selector, 'previousSibling');
	      },
	
	      // #ifndef jquery
	
	      /**
	       * Selects specific elements by a CSS level 3 pattern. For example "div#a1 p.test".
	       * This function is optimized for the most common patterns needed in TinyMCE but it also performs well enough
	       * on more complex patterns.
	       *
	       * @method select
	       * @param {String} selector CSS level 3 pattern to select/find elements by.
	       * @param {Object} scope Optional root element/scope element to search in.
	       * @return {Array} Array with all matched elements.
	       * @example
	       * // Adds a class to all paragraphs in the currently active editor
	       * tinymce.activeEditor.dom.addClass(tinymce.activeEditor.dom.select('p'), 'someclass');
	       *
	       * // Adds a class to all spans that have the test class in the currently active editor
	       * tinymce.activeEditor.dom.addClass(tinymce.activeEditor.dom.select('span.test'), 'someclass')
	       */
	      select: function (selector, scope) {
	        var self = this;
	
	        /*eslint new-cap:0 */
	        return Sizzle(selector, self.get(scope) || self.settings.root_element || self.doc, []);
	      },
	
	      /**
	       * Returns true/false if the specified element matches the specified css pattern.
	       *
	       * @method is
	       * @param {Node/NodeList} elm DOM node to match or an array of nodes to match.
	       * @param {String} selector CSS pattern to match the element against.
	       */
	      is: function (elm, selector) {
	        var i;
	
	        if (!elm) {
	          return false;
	        }
	
	        // If it isn't an array then try to do some simple selectors instead of Sizzle for to boost performance
	        if (elm.length === undefined) {
	          // Simple all selector
	          if (selector === '*') {
	            return elm.nodeType == 1;
	          }
	
	          // Simple selector just elements
	          if (simpleSelectorRe.test(selector)) {
	            selector = selector.toLowerCase().split(/,/);
	            elm = elm.nodeName.toLowerCase();
	
	            for (i = selector.length - 1; i >= 0; i--) {
	              if (selector[i] == elm) {
	                return true;
	              }
	            }
	
	            return false;
	          }
	        }
	
	        // Is non element
	        if (elm.nodeType && elm.nodeType != 1) {
	          return false;
	        }
	
	        var elms = elm.nodeType ? [elm] : elm;
	
	        /*eslint new-cap:0 */
	        return Sizzle(selector, elms[0].ownerDocument || elms[0], null, elms).length > 0;
	      },
	
	      // #endif
	
	      /**
	       * Adds the specified element to another element or elements.
	       *
	       * @method add
	       * @param {String/Element/Array} parentElm Element id string, DOM node element or array of ids or elements to add to.
	       * @param {String/Element} name Name of new element to add or existing element to add.
	       * @param {Object} attrs Optional object collection with arguments to add to the new element(s).
	       * @param {String} html Optional inner HTML contents to add for each element.
	       * @param {Boolean} create Optional flag if the element should be created or added.
	       * @return {Element/Array} Element that got created, or an array of created elements if multiple input elements
	       * were passed in.
	       * @example
	       * // Adds a new paragraph to the end of the active editor
	       * tinymce.activeEditor.dom.add(tinymce.activeEditor.getBody(), 'p', {title: 'my title'}, 'Some content');
	       */
	      add: function (parentElm, name, attrs, html, create) {
	        var self = this;
	
	        return this.run(parentElm, function (parentElm) {
	          var newElm;
	
	          newElm = is(name, 'string') ? self.doc.createElement(name) : name;
	          self.setAttribs(newElm, attrs);
	
	          if (html) {
	            if (html.nodeType) {
	              newElm.appendChild(html);
	            } else {
	              self.setHTML(newElm, html);
	            }
	          }
	
	          return !create ? parentElm.appendChild(newElm) : newElm;
	        });
	      },
	
	      /**
	       * Creates a new element.
	       *
	       * @method create
	       * @param {String} name Name of new element.
	       * @param {Object} attrs Optional object name/value collection with element attributes.
	       * @param {String} html Optional HTML string to set as inner HTML of the element.
	       * @return {Element} HTML DOM node element that got created.
	       * @example
	       * // Adds an element where the caret/selection is in the active editor
	       * var el = tinymce.activeEditor.dom.create('div', {id: 'test', 'class': 'myclass'}, 'some content');
	       * tinymce.activeEditor.selection.setNode(el);
	       */
	      create: function (name, attrs, html) {
	        return this.add(this.doc.createElement(name), name, attrs, html, 1);
	      },
	
	      /**
	       * Creates HTML string for element. The element will be closed unless an empty inner HTML string is passed in.
	       *
	       * @method createHTML
	       * @param {String} name Name of new element.
	       * @param {Object} attrs Optional object name/value collection with element attributes.
	       * @param {String} html Optional HTML string to set as inner HTML of the element.
	       * @return {String} String with new HTML element, for example: <a href="#">test</a>.
	       * @example
	       * // Creates a html chunk and inserts it at the current selection/caret location
	       * tinymce.activeEditor.selection.setContent(tinymce.activeEditor.dom.createHTML('a', {href: 'test.html'}, 'some line'));
	       */
	      createHTML: function (name, attrs, html) {
	        var outHtml = '', key;
	
	        outHtml += '<' + name;
	
	        for (key in attrs) {
	          if (attrs.hasOwnProperty(key) && attrs[key] !== null && typeof attrs[key] != 'undefined') {
	            outHtml += ' ' + key + '="' + this.encode(attrs[key]) + '"';
	          }
	        }
	
	        // A call to tinymce.is doesn't work for some odd reason on IE9 possible bug inside their JS runtime
	        if (typeof html != "undefined") {
	          return outHtml + '>' + html + '</' + name + '>';
	        }
	
	        return outHtml + ' />';
	      },
	
	      /**
	       * Creates a document fragment out of the specified HTML string.
	       *
	       * @method createFragment
	       * @param {String} html Html string to create fragment from.
	       * @return {DocumentFragment} Document fragment node.
	       */
	      createFragment: function (html) {
	        var frag, node, doc = this.doc, container;
	
	        container = doc.createElement("div");
	        frag = doc.createDocumentFragment();
	
	        if (html) {
	          container.innerHTML = html;
	        }
	
	        while ((node = container.firstChild)) {
	          frag.appendChild(node);
	        }
	
	        return frag;
	      },
	
	      /**
	       * Removes/deletes the specified element(s) from the DOM.
	       *
	       * @method remove
	       * @param {String/Element/Array} node ID of element or DOM element object or array containing multiple elements/ids.
	       * @param {Boolean} keepChildren Optional state to keep children or not. If set to true all children will be
	       * placed at the location of the removed element.
	       * @return {Element/Array} HTML DOM element that got removed, or an array of removed elements if multiple input elements
	       * were passed in.
	       * @example
	       * // Removes all paragraphs in the active editor
	       * tinymce.activeEditor.dom.remove(tinymce.activeEditor.dom.select('p'));
	       *
	       * // Removes an element by id in the document
	       * tinymce.DOM.remove('mydiv');
	       */
	      remove: function (node, keepChildren) {
	        node = this.$$(node);
	
	        if (keepChildren) {
	          node.each(function () {
	            var child;
	
	            while ((child = this.firstChild)) {
	              if (child.nodeType == 3 && child.data.length === 0) {
	                this.removeChild(child);
	              } else {
	                this.parentNode.insertBefore(child, this);
	              }
	            }
	          }).remove();
	        } else {
	          node.remove();
	        }
	
	        return node.length > 1 ? node.toArray() : node[0];
	      },
	
	      /**
	       * Sets the CSS style value on a HTML element. The name can be a camelcase string
	       * or the CSS style name like background-color.
	       *
	       * @method setStyle
	       * @param {String/Element/Array} elm HTML element/Array of elements to set CSS style value on.
	       * @param {String} name Name of the style value to set.
	       * @param {String} value Value to set on the style.
	       * @example
	       * // Sets a style value on all paragraphs in the currently active editor
	       * tinymce.activeEditor.dom.setStyle(tinymce.activeEditor.dom.select('p'), 'background-color', 'red');
	       *
	       * // Sets a style value to an element by id in the current document
	       * tinymce.DOM.setStyle('mydiv', 'background-color', 'red');
	       */
	      setStyle: function (elm, name, value) {
	        elm = this.$$(elm).css(name, value);
	
	        if (this.settings.update_styles) {
	          updateInternalStyleAttr(this, elm);
	        }
	      },
	
	      /**
	       * Returns the current style or runtime/computed value of an element.
	       *
	       * @method getStyle
	       * @param {String/Element} elm HTML element or element id string to get style from.
	       * @param {String} name Style name to return.
	       * @param {Boolean} computed Computed style.
	       * @return {String} Current style or computed style value of an element.
	       */
	      getStyle: function (elm, name, computed) {
	        elm = this.$$(elm);
	
	        if (computed) {
	          return elm.css(name);
	        }
	
	        // Camelcase it, if needed
	        name = name.replace(/-(\D)/g, function (a, b) {
	          return b.toUpperCase();
	        });
	
	        if (name == 'float') {
	          name = Env.ie && Env.ie < 12 ? 'styleFloat' : 'cssFloat';
	        }
	
	        return elm[0] && elm[0].style ? elm[0].style[name] : undefined;
	      },
	
	      /**
	       * Sets multiple styles on the specified element(s).
	       *
	       * @method setStyles
	       * @param {Element/String/Array} elm DOM element, element id string or array of elements/ids to set styles on.
	       * @param {Object} styles Name/Value collection of style items to add to the element(s).
	       * @example
	       * // Sets styles on all paragraphs in the currently active editor
	       * tinymce.activeEditor.dom.setStyles(tinymce.activeEditor.dom.select('p'), {'background-color': 'red', 'color': 'green'});
	       *
	       * // Sets styles to an element by id in the current document
	       * tinymce.DOM.setStyles('mydiv', {'background-color': 'red', 'color': 'green'});
	       */
	      setStyles: function (elm, styles) {
	        elm = this.$$(elm).css(styles);
	
	        if (this.settings.update_styles) {
	          updateInternalStyleAttr(this, elm);
	        }
	      },
	
	      /**
	       * Removes all attributes from an element or elements.
	       *
	       * @method removeAllAttribs
	       * @param {Element/String/Array} e DOM element, element id string or array of elements/ids to remove attributes from.
	       */
	      removeAllAttribs: function (e) {
	        return this.run(e, function (e) {
	          var i, attrs = e.attributes;
	          for (i = attrs.length - 1; i >= 0; i--) {
	            e.removeAttributeNode(attrs.item(i));
	          }
	        });
	      },
	
	      /**
	       * Sets the specified attribute of an element or elements.
	       *
	       * @method setAttrib
	       * @param {Element/String/Array} elm DOM element, element id string or array of elements/ids to set attribute on.
	       * @param {String} name Name of attribute to set.
	       * @param {String} value Value to set on the attribute - if this value is falsy like null, 0 or '' it will remove
	       * the attribute instead.
	       * @example
	       * // Sets class attribute on all paragraphs in the active editor
	       * tinymce.activeEditor.dom.setAttrib(tinymce.activeEditor.dom.select('p'), 'class', 'myclass');
	       *
	       * // Sets class attribute on a specific element in the current page
	       * tinymce.dom.setAttrib('mydiv', 'class', 'myclass');
	       */
	      setAttrib: function (elm, name, value) {
	        var self = this, originalValue, hook, settings = self.settings;
	
	        if (value === '') {
	          value = null;
	        }
	
	        elm = self.$$(elm);
	        originalValue = elm.attr(name);
	
	        if (!elm.length) {
	          return;
	        }
	
	        hook = self.attrHooks[name];
	        if (hook && hook.set) {
	          hook.set(elm, value, name);
	        } else {
	          elm.attr(name, value);
	        }
	
	        if (originalValue != value && settings.onSetAttrib) {
	          settings.onSetAttrib({
	            attrElm: elm,
	            attrName: name,
	            attrValue: value
	          });
	        }
	      },
	
	      /**
	       * Sets two or more specified attributes of an element or elements.
	       *
	       * @method setAttribs
	       * @param {Element/String/Array} elm DOM element, element id string or array of elements/ids to set attributes on.
	       * @param {Object} attrs Name/Value collection of attribute items to add to the element(s).
	       * @example
	       * // Sets class and title attributes on all paragraphs in the active editor
	       * tinymce.activeEditor.dom.setAttribs(tinymce.activeEditor.dom.select('p'), {'class': 'myclass', title: 'some title'});
	       *
	       * // Sets class and title attributes on a specific element in the current page
	       * tinymce.DOM.setAttribs('mydiv', {'class': 'myclass', title: 'some title'});
	       */
	      setAttribs: function (elm, attrs) {
	        var self = this;
	
	        self.$$(elm).each(function (i, node) {
	          each(attrs, function (value, name) {
	            self.setAttrib(node, name, value);
	          });
	        });
	      },
	
	      /**
	       * Returns the specified attribute by name.
	       *
	       * @method getAttrib
	       * @param {String/Element} elm Element string id or DOM element to get attribute from.
	       * @param {String} name Name of attribute to get.
	       * @param {String} defaultVal Optional default value to return if the attribute didn't exist.
	       * @return {String} Attribute value string, default value or null if the attribute wasn't found.
	       */
	      getAttrib: function (elm, name, defaultVal) {
	        var self = this, hook, value;
	
	        elm = self.$$(elm);
	
	        if (elm.length) {
	          hook = self.attrHooks[name];
	
	          if (hook && hook.get) {
	            value = hook.get(elm, name);
	          } else {
	            value = elm.attr(name);
	          }
	        }
	
	        if (typeof value == 'undefined') {
	          value = defaultVal || '';
	        }
	
	        return value;
	      },
	
	      /**
	       * Returns the absolute x, y position of a node. The position will be returned in an object with x, y fields.
	       *
	       * @method getPos
	       * @param {Element/String} elm HTML element or element id to get x, y position from.
	       * @param {Element} rootElm Optional root element to stop calculations at.
	       * @return {object} Absolute position of the specified element object with x, y fields.
	       */
	      getPos: function (elm, rootElm) {
	        return Position.getPos(this.doc.body, this.get(elm), rootElm);
	      },
	
	      /**
	       * Parses the specified style value into an object collection. This parser will also
	       * merge and remove any redundant items that browsers might have added. It will also convert non-hex
	       * colors to hex values. Urls inside the styles will also be converted to absolute/relative based on settings.
	       *
	       * @method parseStyle
	       * @param {String} cssText Style value to parse, for example: border:1px solid red;.
	       * @return {Object} Object representation of that style, for example: {border: '1px solid red'}
	       */
	      parseStyle: function (cssText) {
	        return this.styles.parse(cssText);
	      },
	
	      /**
	       * Serializes the specified style object into a string.
	       *
	       * @method serializeStyle
	       * @param {Object} styles Object to serialize as string, for example: {border: '1px solid red'}
	       * @param {String} name Optional element name.
	       * @return {String} String representation of the style object, for example: border: 1px solid red.
	       */
	      serializeStyle: function (styles, name) {
	        return this.styles.serialize(styles, name);
	      },
	
	      /**
	       * Adds a style element at the top of the document with the specified cssText content.
	       *
	       * @method addStyle
	       * @param {String} cssText CSS Text style to add to top of head of document.
	       */
	      addStyle: function (cssText) {
	        var self = this, doc = self.doc, head, styleElm;
	
	        // Prevent inline from loading the same styles twice
	        if (self !== DOMUtils.DOM && doc === document) {
	          var addedStyles = DOMUtils.DOM.addedStyles;
	
	          addedStyles = addedStyles || [];
	          if (addedStyles[cssText]) {
	            return;
	          }
	
	          addedStyles[cssText] = true;
	          DOMUtils.DOM.addedStyles = addedStyles;
	        }
	
	        // Create style element if needed
	        styleElm = doc.getElementById('mceDefaultStyles');
	        if (!styleElm) {
	          styleElm = doc.createElement('style');
	          styleElm.id = 'mceDefaultStyles';
	          styleElm.type = 'text/css';
	
	          head = doc.getElementsByTagName('head')[0];
	          if (head.firstChild) {
	            head.insertBefore(styleElm, head.firstChild);
	          } else {
	            head.appendChild(styleElm);
	          }
	        }
	
	        // Append style data to old or new style element
	        if (styleElm.styleSheet) {
	          styleElm.styleSheet.cssText += cssText;
	        } else {
	          styleElm.appendChild(doc.createTextNode(cssText));
	        }
	      },
	
	      /**
	       * Imports/loads the specified CSS file into the document bound to the class.
	       *
	       * @method loadCSS
	       * @param {String} url URL to CSS file to load.
	       * @example
	       * // Loads a CSS file dynamically into the current document
	       * tinymce.DOM.loadCSS('somepath/some.css');
	       *
	       * // Loads a CSS file into the currently active editor instance
	       * tinymce.activeEditor.dom.loadCSS('somepath/some.css');
	       *
	       * // Loads a CSS file into an editor instance by id
	       * tinymce.get('someid').dom.loadCSS('somepath/some.css');
	       *
	       * // Loads multiple CSS files into the current document
	       * tinymce.DOM.loadCSS('somepath/some.css,somepath/someother.css');
	       */
	      loadCSS: function (url) {
	        var self = this, doc = self.doc, head;
	
	        // Prevent inline from loading the same CSS file twice
	        if (self !== DOMUtils.DOM && doc === document) {
	          DOMUtils.DOM.loadCSS(url);
	          return;
	        }
	
	        if (!url) {
	          url = '';
	        }
	
	        head = doc.getElementsByTagName('head')[0];
	
	        each(url.split(','), function (url) {
	          var link;
	
	          url = Tools._addCacheSuffix(url);
	
	          if (self.files[url]) {
	            return;
	          }
	
	          self.files[url] = true;
	          link = self.create('link', { rel: 'stylesheet', href: url });
	
	          // IE 8 has a bug where dynamically loading stylesheets would produce a 1 item remaining bug
	          // This fix seems to resolve that issue by recalcing the document once a stylesheet finishes loading
	          // It's ugly but it seems to work fine.
	          if (isIE && doc.documentMode && doc.recalc) {
	            link.onload = function () {
	              if (doc.recalc) {
	                doc.recalc();
	              }
	
	              link.onload = null;
	            };
	          }
	
	          head.appendChild(link);
	        });
	      },
	
	      /**
	       * Adds a class to the specified element or elements.
	       *
	       * @method addClass
	       * @param {String/Element/Array} elm Element ID string or DOM element or array with elements or IDs.
	       * @param {String} cls Class name to add to each element.
	       * @return {String/Array} String with new class value or array with new class values for all elements.
	       * @example
	       * // Adds a class to all paragraphs in the active editor
	       * tinymce.activeEditor.dom.addClass(tinymce.activeEditor.dom.select('p'), 'myclass');
	       *
	       * // Adds a class to a specific element in the current page
	       * tinymce.DOM.addClass('mydiv', 'myclass');
	       */
	      addClass: function (elm, cls) {
	        this.$$(elm).addClass(cls);
	      },
	
	      /**
	       * Removes a class from the specified element or elements.
	       *
	       * @method removeClass
	       * @param {String/Element/Array} elm Element ID string or DOM element or array with elements or IDs.
	       * @param {String} cls Class name to remove from each element.
	       * @return {String/Array} String of remaining class name(s), or an array of strings if multiple input elements
	       * were passed in.
	       * @example
	       * // Removes a class from all paragraphs in the active editor
	       * tinymce.activeEditor.dom.removeClass(tinymce.activeEditor.dom.select('p'), 'myclass');
	       *
	       * // Removes a class from a specific element in the current page
	       * tinymce.DOM.removeClass('mydiv', 'myclass');
	       */
	      removeClass: function (elm, cls) {
	        this.toggleClass(elm, cls, false);
	      },
	
	      /**
	       * Returns true if the specified element has the specified class.
	       *
	       * @method hasClass
	       * @param {String/Element} elm HTML element or element id string to check CSS class on.
	       * @param {String} cls CSS class to check for.
	       * @return {Boolean} true/false if the specified element has the specified class.
	       */
	      hasClass: function (elm, cls) {
	        return this.$$(elm).hasClass(cls);
	      },
	
	      /**
	       * Toggles the specified class on/off.
	       *
	       * @method toggleClass
	       * @param {Element} elm Element to toggle class on.
	       * @param {[type]} cls Class to toggle on/off.
	       * @param {[type]} state Optional state to set.
	       */
	      toggleClass: function (elm, cls, state) {
	        this.$$(elm).toggleClass(cls, state).each(function () {
	          if (this.className === '') {
	            DomQuery(this).attr('class', null);
	          }
	        });
	      },
	
	      /**
	       * Shows the specified element(s) by ID by setting the "display" style.
	       *
	       * @method show
	       * @param {String/Element/Array} elm ID of DOM element or DOM element or array with elements or IDs to show.
	       */
	      show: function (elm) {
	        this.$$(elm).show();
	      },
	
	      /**
	       * Hides the specified element(s) by ID by setting the "display" style.
	       *
	       * @method hide
	       * @param {String/Element/Array} elm ID of DOM element or DOM element or array with elements or IDs to hide.
	       * @example
	       * // Hides an element by id in the document
	       * tinymce.DOM.hide('myid');
	       */
	      hide: function (elm) {
	        this.$$(elm).hide();
	      },
	
	      /**
	       * Returns true/false if the element is hidden or not by checking the "display" style.
	       *
	       * @method isHidden
	       * @param {String/Element} elm Id or element to check display state on.
	       * @return {Boolean} true/false if the element is hidden or not.
	       */
	      isHidden: function (elm) {
	        return this.$$(elm).css('display') == 'none';
	      },
	
	      /**
	       * Returns a unique id. This can be useful when generating elements on the fly.
	       * This method will not check if the element already exists.
	       *
	       * @method uniqueId
	       * @param {String} prefix Optional prefix to add in front of all ids - defaults to "mce_".
	       * @return {String} Unique id.
	       */
	      uniqueId: function (prefix) {
	        return (!prefix ? 'mce_' : prefix) + (this.counter++);
	      },
	
	      /**
	       * Sets the specified HTML content inside the element or elements. The HTML will first be processed. This means
	       * URLs will get converted, hex color values fixed etc. Check processHTML for details.
	       *
	       * @method setHTML
	       * @param {Element/String/Array} elm DOM element, element id string or array of elements/ids to set HTML inside of.
	       * @param {String} html HTML content to set as inner HTML of the element.
	       * @example
	       * // Sets the inner HTML of all paragraphs in the active editor
	       * tinymce.activeEditor.dom.setHTML(tinymce.activeEditor.dom.select('p'), 'some inner html');
	       *
	       * // Sets the inner HTML of an element by id in the document
	       * tinymce.DOM.setHTML('mydiv', 'some inner html');
	       */
	      setHTML: function (elm, html) {
	        elm = this.$$(elm);
	
	        if (isIE) {
	          elm.each(function (i, target) {
	            if (target.canHaveHTML === false) {
	              return;
	            }
	
	            // Remove all child nodes, IE keeps empty text nodes in DOM
	            while (target.firstChild) {
	              target.removeChild(target.firstChild);
	            }
	
	            try {
	              // IE will remove comments from the beginning
	              // unless you padd the contents with something
	              target.innerHTML = '<br>' + html;
	              target.removeChild(target.firstChild);
	            } catch (ex) {
	              // IE sometimes produces an unknown runtime error on innerHTML if it's a div inside a p
	              DomQuery('<div></div>').html('<br>' + html).contents().slice(1).appendTo(target);
	            }
	
	            return html;
	          });
	        } else {
	          elm.html(html);
	        }
	      },
	
	      /**
	       * Returns the outer HTML of an element.
	       *
	       * @method getOuterHTML
	       * @param {String/Element} elm Element ID or element object to get outer HTML from.
	       * @return {String} Outer HTML string.
	       * @example
	       * tinymce.DOM.getOuterHTML(editorElement);
	       * tinymce.activeEditor.getOuterHTML(tinymce.activeEditor.getBody());
	       */
	      getOuterHTML: function (elm) {
	        elm = this.get(elm);
	
	        // Older FF doesn't have outerHTML 3.6 is still used by some orgaizations
	        return elm.nodeType == 1 && "outerHTML" in elm ? elm.outerHTML : DomQuery('<div></div>').append(DomQuery(elm).clone()).html();
	      },
	
	      /**
	       * Sets the specified outer HTML on an element or elements.
	       *
	       * @method setOuterHTML
	       * @param {Element/String/Array} elm DOM element, element id string or array of elements/ids to set outer HTML on.
	       * @param {Object} html HTML code to set as outer value for the element.
	       * @example
	       * // Sets the outer HTML of all paragraphs in the active editor
	       * tinymce.activeEditor.dom.setOuterHTML(tinymce.activeEditor.dom.select('p'), '<div>some html</div>');
	       *
	       * // Sets the outer HTML of an element by id in the document
	       * tinymce.DOM.setOuterHTML('mydiv', '<div>some html</div>');
	       */
	      setOuterHTML: function (elm, html) {
	        var self = this;
	
	        self.$$(elm).each(function () {
	          try {
	            // Older FF doesn't have outerHTML 3.6 is still used by some organizations
	            if ("outerHTML" in this) {
	              this.outerHTML = html;
	              return;
	            }
	          } catch (ex) {
	            // Ignore
	          }
	
	          // OuterHTML for IE it sometimes produces an "unknown runtime error"
	          self.remove(DomQuery(this).html(html), true);
	        });
	      },
	
	      /**
	       * Entity decodes a string. This method decodes any HTML entities, such as &aring;.
	       *
	       * @method decode
	       * @param {String} s String to decode entities on.
	       * @return {String} Entity decoded string.
	       */
	      decode: Entities.decode,
	
	      /**
	       * Entity encodes a string. This method encodes the most common entities, such as <>"&.
	       *
	       * @method encode
	       * @param {String} text String to encode with entities.
	       * @return {String} Entity encoded string.
	       */
	      encode: Entities.encodeAllRaw,
	
	      /**
	       * Inserts an element after the reference element.
	       *
	       * @method insertAfter
	       * @param {Element} node Element to insert after the reference.
	       * @param {Element/String/Array} referenceNode Reference element, element id or array of elements to insert after.
	       * @return {Element/Array} Element that got added or an array with elements.
	       */
	      insertAfter: function (node, referenceNode) {
	        referenceNode = this.get(referenceNode);
	
	        return this.run(node, function (node) {
	          var parent, nextSibling;
	
	          parent = referenceNode.parentNode;
	          nextSibling = referenceNode.nextSibling;
	
	          if (nextSibling) {
	            parent.insertBefore(node, nextSibling);
	          } else {
	            parent.appendChild(node);
	          }
	
	          return node;
	        });
	      },
	
	      /**
	       * Replaces the specified element or elements with the new element specified. The new element will
	       * be cloned if multiple input elements are passed in.
	       *
	       * @method replace
	       * @param {Element} newElm New element to replace old ones with.
	       * @param {Element/String/Array} oldElm Element DOM node, element id or array of elements or ids to replace.
	       * @param {Boolean} keepChildren Optional keep children state, if set to true child nodes from the old object will be added
	       * to new ones.
	       */
	      replace: function (newElm, oldElm, keepChildren) {
	        var self = this;
	
	        return self.run(oldElm, function (oldElm) {
	          if (is(oldElm, 'array')) {
	            newElm = newElm.cloneNode(true);
	          }
	
	          if (keepChildren) {
	            each(grep(oldElm.childNodes), function (node) {
	              newElm.appendChild(node);
	            });
	          }
	
	          return oldElm.parentNode.replaceChild(newElm, oldElm);
	        });
	      },
	
	      /**
	       * Renames the specified element and keeps its attributes and children.
	       *
	       * @method rename
	       * @param {Element} elm Element to rename.
	       * @param {String} name Name of the new element.
	       * @return {Element} New element or the old element if it needed renaming.
	       */
	      rename: function (elm, name) {
	        var self = this, newElm;
	
	        if (elm.nodeName != name.toUpperCase()) {
	          // Rename block element
	          newElm = self.create(name);
	
	          // Copy attribs to new block
	          each(self.getAttribs(elm), function (attrNode) {
	            self.setAttrib(newElm, attrNode.nodeName, self.getAttrib(elm, attrNode.nodeName));
	          });
	
	          // Replace block
	          self.replace(newElm, elm, 1);
	        }
	
	        return newElm || elm;
	      },
	
	      /**
	       * Find the common ancestor of two elements. This is a shorter method than using the DOM Range logic.
	       *
	       * @method findCommonAncestor
	       * @param {Element} a Element to find common ancestor of.
	       * @param {Element} b Element to find common ancestor of.
	       * @return {Element} Common ancestor element of the two input elements.
	       */
	      findCommonAncestor: function (a, b) {
	        var ps = a, pe;
	
	        while (ps) {
	          pe = b;
	
	          while (pe && ps != pe) {
	            pe = pe.parentNode;
	          }
	
	          if (ps == pe) {
	            break;
	          }
	
	          ps = ps.parentNode;
	        }
	
	        if (!ps && a.ownerDocument) {
	          return a.ownerDocument.documentElement;
	        }
	
	        return ps;
	      },
	
	      /**
	       * Parses the specified RGB color value and returns a hex version of that color.
	       *
	       * @method toHex
	       * @param {String} rgbVal RGB string value like rgb(1,2,3)
	       * @return {String} Hex version of that RGB value like #FF00FF.
	       */
	      toHex: function (rgbVal) {
	        return this.styles.toHex(Tools.trim(rgbVal));
	      },
	
	      /**
	       * Executes the specified function on the element by id or dom element node or array of elements/id.
	       *
	       * @method run
	       * @param {String/Element/Array} elm ID or DOM element object or array with ids or elements.
	       * @param {function} func Function to execute for each item.
	       * @param {Object} scope Optional scope to execute the function in.
	       * @return {Object/Array} Single object, or an array of objects if multiple input elements were passed in.
	       */
	      run: function (elm, func, scope) {
	        var self = this, result;
	
	        if (typeof elm === 'string') {
	          elm = self.get(elm);
	        }
	
	        if (!elm) {
	          return false;
	        }
	
	        scope = scope || this;
	        if (!elm.nodeType && (elm.length || elm.length === 0)) {
	          result = [];
	
	          each(elm, function (elm, i) {
	            if (elm) {
	              if (typeof elm == 'string') {
	                elm = self.get(elm);
	              }
	
	              result.push(func.call(scope, elm, i));
	            }
	          });
	
	          return result;
	        }
	
	        return func.call(scope, elm);
	      },
	
	      /**
	       * Returns a NodeList with attributes for the element.
	       *
	       * @method getAttribs
	       * @param {HTMLElement/string} elm Element node or string id to get attributes from.
	       * @return {NodeList} NodeList with attributes.
	       */
	      getAttribs: function (elm) {
	        var attrs;
	
	        elm = this.get(elm);
	
	        if (!elm) {
	          return [];
	        }
	
	        if (isIE) {
	          attrs = [];
	
	          // Object will throw exception in IE
	          if (elm.nodeName == 'OBJECT') {
	            return elm.attributes;
	          }
	
	          // IE doesn't keep the selected attribute if you clone option elements
	          if (elm.nodeName === 'OPTION' && this.getAttrib(elm, 'selected')) {
	            attrs.push({ specified: 1, nodeName: 'selected' });
	          }
	
	          // It's crazy that this is faster in IE but it's because it returns all attributes all the time
	          var attrRegExp = /<\/?[\w:\-]+ ?|=[\"][^\"]+\"|=\'[^\']+\'|=[\w\-]+|>/gi;
	          elm.cloneNode(false).outerHTML.replace(attrRegExp, '').replace(/[\w:\-]+/gi, function (a) {
	            attrs.push({ specified: 1, nodeName: a });
	          });
	
	          return attrs;
	        }
	
	        return elm.attributes;
	      },
	
	      /**
	       * Returns true/false if the specified node is to be considered empty or not.
	       *
	       * @example
	       * tinymce.DOM.isEmpty(node, {img: true});
	       * @method isEmpty
	       * @param {Object} elements Optional name/value object with elements that are automatically treated as non-empty elements.
	       * @return {Boolean} true/false if the node is empty or not.
	       */
	      isEmpty: function (node, elements) {
	        var self = this, i, attributes, type, whitespace, walker, name, brCount = 0;
	
	        node = node.firstChild;
	        if (node) {
	          walker = new TreeWalker(node, node.parentNode);
	          elements = elements || (self.schema ? self.schema.getNonEmptyElements() : null);
	          whitespace = self.schema ? self.schema.getWhiteSpaceElements() : {};
	
	          do {
	            type = node.nodeType;
	
	            if (type === 1) {
	              // Ignore bogus elements
	              var bogusVal = node.getAttribute('data-mce-bogus');
	              if (bogusVal) {
	                node = walker.next(bogusVal === 'all');
	                continue;
	              }
	
	              // Keep empty elements like <img />
	              name = node.nodeName.toLowerCase();
	              if (elements && elements[name]) {
	                // Ignore single BR elements in blocks like <p><br /></p> or <p><span><br /></span></p>
	                if (name === 'br') {
	                  brCount++;
	                  node = walker.next();
	                  continue;
	                }
	
	                return false;
	              }
	
	              // Keep elements with data-bookmark attributes or name attribute like <a name="1"></a>
	              attributes = self.getAttribs(node);
	              i = attributes.length;
	              while (i--) {
	                name = attributes[i].nodeName;
	                if (name === "name" || name === 'data-mce-bookmark') {
	                  return false;
	                }
	              }
	            }
	
	            // Keep comment nodes
	            if (type == 8) {
	              return false;
	            }
	
	            // Keep non whitespace text nodes
	            if (type === 3 && !whiteSpaceRegExp.test(node.nodeValue)) {
	              return false;
	            }
	
	            // Keep whitespace preserve elements
	            if (type === 3 && node.parentNode && whitespace[node.parentNode.nodeName] && whiteSpaceRegExp.test(node.nodeValue)) {
	              return false;
	            }
	
	            node = walker.next();
	          } while (node);
	        }
	
	        return brCount <= 1;
	      },
	
	      /**
	       * Creates a new DOM Range object. This will use the native DOM Range API if it's
	       * available. If it's not, it will fall back to the custom TinyMCE implementation.
	       *
	       * @method createRng
	       * @return {DOMRange} DOM Range object.
	       * @example
	       * var rng = tinymce.DOM.createRng();
	       * alert(rng.startContainer + "," + rng.startOffset);
	       */
	      createRng: function () {
	        return this.doc.createRange();
	      },
	
	      /**
	       * Returns the index of the specified node within its parent.
	       *
	       * @method nodeIndex
	       * @param {Node} node Node to look for.
	       * @param {boolean} normalized Optional true/false state if the index is what it would be after a normalization.
	       * @return {Number} Index of the specified node.
	       */
	      nodeIndex: nodeIndex,
	
	      /**
	       * Splits an element into two new elements and places the specified split
	       * element or elements between the new ones. For example splitting the paragraph at the bold element in
	       * this example <p>abc<b>abc</b>123</p> would produce <p>abc</p><b>abc</b><p>123</p>.
	       *
	       * @method split
	       * @param {Element} parentElm Parent element to split.
	       * @param {Element} splitElm Element to split at.
	       * @param {Element} replacementElm Optional replacement element to replace the split element with.
	       * @return {Element} Returns the split element or the replacement element if that is specified.
	       */
	      split: function (parentElm, splitElm, replacementElm) {
	        var self = this, r = self.createRng(), bef, aft, pa;
	
	        if (parentElm && splitElm) {
	          // Get before chunk
	          r.setStart(parentElm.parentNode, self.nodeIndex(parentElm));
	          r.setEnd(splitElm.parentNode, self.nodeIndex(splitElm));
	          bef = r.extractContents();
	
	          // Get after chunk
	          r = self.createRng();
	          r.setStart(splitElm.parentNode, self.nodeIndex(splitElm) + 1);
	          r.setEnd(parentElm.parentNode, self.nodeIndex(parentElm) + 1);
	          aft = r.extractContents();
	
	          // Insert before chunk
	          pa = parentElm.parentNode;
	          pa.insertBefore(TrimNode.trimNode(self, bef), parentElm);
	
	          // Insert middle chunk
	          if (replacementElm) {
	            pa.insertBefore(replacementElm, parentElm);
	            //pa.replaceChild(replacementElm, splitElm);
	          } else {
	            pa.insertBefore(splitElm, parentElm);
	          }
	
	          // Insert after chunk
	          pa.insertBefore(TrimNode.trimNode(self, aft), parentElm);
	          self.remove(parentElm);
	
	          return replacementElm || splitElm;
	        }
	      },
	
	      /**
	       * Adds an event handler to the specified object.
	       *
	       * @method bind
	       * @param {Element/Document/Window/Array} target Target element to bind events to.
	       * handler to or an array of elements/ids/documents.
	       * @param {String} name Name of event handler to add, for example: click.
	       * @param {function} func Function to execute when the event occurs.
	       * @param {Object} scope Optional scope to execute the function in.
	       * @return {function} Function callback handler the same as the one passed in.
	       */
	      bind: function (target, name, func, scope) {
	        var self = this;
	
	        if (Tools.isArray(target)) {
	          var i = target.length;
	
	          while (i--) {
	            target[i] = self.bind(target[i], name, func, scope);
	          }
	
	          return target;
	        }
	
	        // Collect all window/document events bound by editor instance
	        if (self.settings.collect && (target === self.doc || target === self.win)) {
	          self.boundEvents.push([target, name, func, scope]);
	        }
	
	        return self.events.bind(target, name, func, scope || self);
	      },
	
	      /**
	       * Removes the specified event handler by name and function from an element or collection of elements.
	       *
	       * @method unbind
	       * @param {Element/Document/Window/Array} target Target element to unbind events on.
	       * @param {String} name Event handler name, for example: "click"
	       * @param {function} func Function to remove.
	       * @return {bool/Array} Bool state of true if the handler was removed, or an array of states if multiple input elements
	       * were passed in.
	       */
	      unbind: function (target, name, func) {
	        var self = this, i;
	
	        if (Tools.isArray(target)) {
	          i = target.length;
	
	          while (i--) {
	            target[i] = self.unbind(target[i], name, func);
	          }
	
	          return target;
	        }
	
	        // Remove any bound events matching the input
	        if (self.boundEvents && (target === self.doc || target === self.win)) {
	          i = self.boundEvents.length;
	
	          while (i--) {
	            var item = self.boundEvents[i];
	
	            if (target == item[0] && (!name || name == item[1]) && (!func || func == item[2])) {
	              this.events.unbind(item[0], item[1], item[2]);
	            }
	          }
	        }
	
	        return this.events.unbind(target, name, func);
	      },
	
	      /**
	       * Fires the specified event name with object on target.
	       *
	       * @method fire
	       * @param {Node/Document/Window} target Target element or object to fire event on.
	       * @param {String} name Name of the event to fire.
	       * @param {Object} evt Event object to send.
	       * @return {Event} Event object.
	       */
	      fire: function (target, name, evt) {
	        return this.events.fire(target, name, evt);
	      },
	
	      // Returns the content editable state of a node
	      getContentEditable: function (node) {
	        var contentEditable;
	
	        // Check type
	        if (!node || node.nodeType != 1) {
	          return null;
	        }
	
	        // Check for fake content editable
	        contentEditable = node.getAttribute("data-mce-contenteditable");
	        if (contentEditable && contentEditable !== "inherit") {
	          return contentEditable;
	        }
	
	        // Check for real content editable
	        return node.contentEditable !== "inherit" ? node.contentEditable : null;
	      },
	
	      getContentEditableParent: function (node) {
	        var root = this.getRoot(), state = null;
	
	        for (; node && node !== root; node = node.parentNode) {
	          state = this.getContentEditable(node);
	
	          if (state !== null) {
	            break;
	          }
	        }
	
	        return state;
	      },
	
	      /**
	       * Destroys all internal references to the DOM to solve IE leak issues.
	       *
	       * @method destroy
	       */
	      destroy: function () {
	        var self = this;
	
	        // Unbind all events bound to window/document by editor instance
	        if (self.boundEvents) {
	          var i = self.boundEvents.length;
	
	          while (i--) {
	            var item = self.boundEvents[i];
	            this.events.unbind(item[0], item[1], item[2]);
	          }
	
	          self.boundEvents = null;
	        }
	
	        // Restore sizzle document to window.document
	        // Since the current document might be removed producing "Permission denied" on IE see #6325
	        if (Sizzle.setDocument) {
	          Sizzle.setDocument();
	        }
	
	        self.win = self.doc = self.root = self.events = self.frag = null;
	      },
	
	      isChildOf: function (node, parent) {
	        while (node) {
	          if (parent === node) {
	            return true;
	          }
	
	          node = node.parentNode;
	        }
	
	        return false;
	      },
	
	      // #ifdef debug
	
	      dumpRng: function (r) {
	        return (
	          'startContainer: ' + r.startContainer.nodeName +
	          ', startOffset: ' + r.startOffset +
	          ', endContainer: ' + r.endContainer.nodeName +
	          ', endOffset: ' + r.endOffset
	        );
	      },
	
	      // #endif
	
	      _findSib: function (node, selector, name) {
	        var self = this, func = selector;
	
	        if (node) {
	          // If expression make a function of it using is
	          if (typeof func == 'string') {
	            func = function (node) {
	              return self.is(node, selector);
	            };
	          }
	
	          // Loop all siblings
	          for (node = node[name]; node; node = node[name]) {
	            if (func(node)) {
	              return node;
	            }
	          }
	        }
	
	        return null;
	      }
	    };
	
	    /**
	     * Instance of DOMUtils for the current document.
	     *
	     * @static
	     * @property DOM
	     * @type tinymce.dom.DOMUtils
	     * @example
	     * // Example of how to add a class to some element by id
	     * tinymce.DOM.addClass('someid', 'someclass');
	     */
	    DOMUtils.DOM = new DOMUtils(document);
	    DOMUtils.nodeIndex = nodeIndex;
	
	    return DOMUtils;
	  }
	);
	
	/**
	 * ScriptLoader.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*globals console*/
	
	/**
	 * This class handles asynchronous/synchronous loading of JavaScript files it will execute callbacks
	 * when various items gets loaded. This class is useful to load external JavaScript files.
	 *
	 * @class tinymce.dom.ScriptLoader
	 * @example
	 * // Load a script from a specific URL using the global script loader
	 * tinymce.ScriptLoader.load('somescript.js');
	 *
	 * // Load a script using a unique instance of the script loader
	 * var scriptLoader = new tinymce.dom.ScriptLoader();
	 *
	 * scriptLoader.load('somescript.js');
	 *
	 * // Load multiple scripts
	 * var scriptLoader = new tinymce.dom.ScriptLoader();
	 *
	 * scriptLoader.add('somescript1.js');
	 * scriptLoader.add('somescript2.js');
	 * scriptLoader.add('somescript3.js');
	 *
	 * scriptLoader.loadQueue(function() {
	 *    alert('All scripts are now loaded.');
	 * });
	 */
	define(
	  'tinymce.core.dom.ScriptLoader',
	  [
	    'global!document',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.util.Tools'
	  ],
	  function (document, DOMUtils, Tools) {
	    var DOM = DOMUtils.DOM;
	    var each = Tools.each, grep = Tools.grep;
	
	    var isFunction = function (f) {
	      return typeof f === 'function';
	    };
	
	    var ScriptLoader = function () {
	      var QUEUED = 0,
	        LOADING = 1,
	        LOADED = 2,
	        FAILED = 3,
	        states = {},
	        queue = [],
	        scriptLoadedCallbacks = {},
	        queueLoadedCallbacks = [],
	        loading = 0,
	        undef;
	
	      /**
	       * Loads a specific script directly without adding it to the load queue.
	       *
	       * @method load
	       * @param {String} url Absolute URL to script to add.
	       * @param {function} callback Optional success callback function when the script loaded successfully.
	       * @param {function} callback Optional failure callback function when the script failed to load.
	       */
	      var loadScript = function (url, success, failure) {
	        var dom = DOM, elm, id;
	
	        // Execute callback when script is loaded
	        var done = function () {
	          dom.remove(id);
	
	          if (elm) {
	            elm.onreadystatechange = elm.onload = elm = null;
	          }
	
	          success();
	        };
	
	        var error = function () {
	          /*eslint no-console:0 */
	
	          // We can't mark it as done if there is a load error since
	          // A) We don't want to produce 404 errors on the server and
	          // B) the onerror event won't fire on all browsers.
	          // done();
	
	          if (isFunction(failure)) {
	            failure();
	          } else {
	            // Report the error so it's easier for people to spot loading errors
	            if (typeof console !== "undefined" && console.log) {
	              console.log("Failed to load script: " + url);
	            }
	          }
	        };
	
	        id = dom.uniqueId();
	
	        // Create new script element
	        elm = document.createElement('script');
	        elm.id = id;
	        elm.type = 'text/javascript';
	        elm.src = Tools._addCacheSuffix(url);
	
	        // Seems that onreadystatechange works better on IE 10 onload seems to fire incorrectly
	        if ("onreadystatechange" in elm) {
	          elm.onreadystatechange = function () {
	            if (/loaded|complete/.test(elm.readyState)) {
	              done();
	            }
	          };
	        } else {
	          elm.onload = done;
	        }
	
	        // Add onerror event will get fired on some browsers but not all of them
	        elm.onerror = error;
	
	        // Add script to document
	        (document.getElementsByTagName('head')[0] || document.body).appendChild(elm);
	      };
	
	      /**
	       * Returns true/false if a script has been loaded or not.
	       *
	       * @method isDone
	       * @param {String} url URL to check for.
	       * @return {Boolean} true/false if the URL is loaded.
	       */
	      this.isDone = function (url) {
	        return states[url] == LOADED;
	      };
	
	      /**
	       * Marks a specific script to be loaded. This can be useful if a script got loaded outside
	       * the script loader or to skip it from loading some script.
	       *
	       * @method markDone
	       * @param {string} url Absolute URL to the script to mark as loaded.
	       */
	      this.markDone = function (url) {
	        states[url] = LOADED;
	      };
	
	      /**
	       * Adds a specific script to the load queue of the script loader.
	       *
	       * @method add
	       * @param {String} url Absolute URL to script to add.
	       * @param {function} success Optional success callback function to execute when the script loades successfully.
	       * @param {Object} scope Optional scope to execute callback in.
	       * @param {function} failure Optional failure callback function to execute when the script failed to load.
	       */
	      this.add = this.load = function (url, success, scope, failure) {
	        var state = states[url];
	
	        // Add url to load queue
	        if (state == undef) {
	          queue.push(url);
	          states[url] = QUEUED;
	        }
	
	        if (success) {
	          // Store away callback for later execution
	          if (!scriptLoadedCallbacks[url]) {
	            scriptLoadedCallbacks[url] = [];
	          }
	
	          scriptLoadedCallbacks[url].push({
	            success: success,
	            failure: failure,
	            scope: scope || this
	          });
	        }
	      };
	
	      this.remove = function (url) {
	        delete states[url];
	        delete scriptLoadedCallbacks[url];
	      };
	
	      /**
	       * Starts the loading of the queue.
	       *
	       * @method loadQueue
	       * @param {function} success Optional callback to execute when all queued items are loaded.
	       * @param {function} failure Optional callback to execute when queued items failed to load.
	       * @param {Object} scope Optional scope to execute the callback in.
	       */
	      this.loadQueue = function (success, scope, failure) {
	        this.loadScripts(queue, success, scope, failure);
	      };
	
	      /**
	       * Loads the specified queue of files and executes the callback ones they are loaded.
	       * This method is generally not used outside this class but it might be useful in some scenarios.
	       *
	       * @method loadScripts
	       * @param {Array} scripts Array of queue items to load.
	       * @param {function} callback Optional callback to execute when scripts is loaded successfully.
	       * @param {Object} scope Optional scope to execute callback in.
	       * @param {function} callback Optional callback to execute if scripts failed to load.
	       */
	      this.loadScripts = function (scripts, success, scope, failure) {
	        var loadScripts, failures = [];
	
	        var execCallbacks = function (name, url) {
	          // Execute URL callback functions
	          each(scriptLoadedCallbacks[url], function (callback) {
	            if (isFunction(callback[name])) {
	              callback[name].call(callback.scope);
	            }
	          });
	
	          scriptLoadedCallbacks[url] = undef;
	        };
	
	        queueLoadedCallbacks.push({
	          success: success,
	          failure: failure,
	          scope: scope || this
	        });
	
	        loadScripts = function () {
	          var loadingScripts = grep(scripts);
	
	          // Current scripts has been handled
	          scripts.length = 0;
	
	          // Load scripts that needs to be loaded
	          each(loadingScripts, function (url) {
	            // Script is already loaded then execute script callbacks directly
	            if (states[url] === LOADED) {
	              execCallbacks('success', url);
	              return;
	            }
	
	            if (states[url] === FAILED) {
	              execCallbacks('failure', url);
	              return;
	            }
	
	            // Is script not loading then start loading it
	            if (states[url] !== LOADING) {
	              states[url] = LOADING;
	              loading++;
	
	              loadScript(url, function () {
	                states[url] = LOADED;
	                loading--;
	
	                execCallbacks('success', url);
	
	                // Load more scripts if they where added by the recently loaded script
	                loadScripts();
	              }, function () {
	                states[url] = FAILED;
	                loading--;
	
	                failures.push(url);
	                execCallbacks('failure', url);
	
	                // Load more scripts if they where added by the recently loaded script
	                loadScripts();
	              });
	            }
	          });
	
	          // No scripts are currently loading then execute all pending queue loaded callbacks
	          if (!loading) {
	            // We need to clone the notifications and empty the pending callbacks so that callbacks can load more resources
	            var notifyCallbacks = queueLoadedCallbacks.slice(0);
	            queueLoadedCallbacks.length = 0;
	
	            each(notifyCallbacks, function (callback) {
	              if (failures.length === 0) {
	                if (isFunction(callback.success)) {
	                  callback.success.call(callback.scope);
	                }
	              } else {
	                if (isFunction(callback.failure)) {
	                  callback.failure.call(callback.scope, failures);
	                }
	              }
	            });
	          }
	        };
	
	        loadScripts();
	      };
	    };
	
	    ScriptLoader.ScriptLoader = new ScriptLoader();
	
	    return ScriptLoader;
	  }
	);
	
	/**
	 * AddOnManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles the loading of themes/plugins or other add-ons and their language packs.
	 *
	 * @class tinymce.AddOnManager
	 */
	define(
	  'tinymce.core.AddOnManager',
	  [
	    'ephox.katamari.api.Arr',
	    'tinymce.core.dom.ScriptLoader',
	    'tinymce.core.util.Tools'
	  ],
	  function (Arr, ScriptLoader, Tools) {
	    var each = Tools.each;
	
	    var AddOnManager = function () {
	      var self = this;
	
	      self.items = [];
	      self.urls = {};
	      self.lookup = {};
	      self._listeners = [];
	    };
	
	    AddOnManager.prototype = {
	      /**
	       * Returns the specified add on by the short name.
	       *
	       * @method get
	       * @param {String} name Add-on to look for.
	       * @return {tinymce.Theme/tinymce.Plugin} Theme or plugin add-on instance or undefined.
	       */
	      get: function (name) {
	        if (this.lookup[name]) {
	          return this.lookup[name].instance;
	        }
	
	        return undefined;
	      },
	
	      dependencies: function (name) {
	        var result;
	
	        if (this.lookup[name]) {
	          result = this.lookup[name].dependencies;
	        }
	
	        return result || [];
	      },
	
	      /**
	       * Loads a language pack for the specified add-on.
	       *
	       * @method requireLangPack
	       * @param {String} name Short name of the add-on.
	       * @param {String} languages Optional comma or space separated list of languages to check if it matches the name.
	       */
	      requireLangPack: function (name, languages) {
	        var language = AddOnManager.language;
	
	        if (language && AddOnManager.languageLoad !== false) {
	          if (languages) {
	            languages = ',' + languages + ',';
	
	            // Load short form sv.js or long form sv_SE.js
	            if (languages.indexOf(',' + language.substr(0, 2) + ',') != -1) {
	              language = language.substr(0, 2);
	            } else if (languages.indexOf(',' + language + ',') == -1) {
	              return;
	            }
	          }
	
	          ScriptLoader.ScriptLoader.add(this.urls[name] + '/langs/' + language + '.js');
	        }
	      },
	
	      /**
	       * Adds a instance of the add-on by it's short name.
	       *
	       * @method add
	       * @param {String} id Short name/id for the add-on.
	       * @param {tinymce.Theme/tinymce.Plugin} addOn Theme or plugin to add.
	       * @return {tinymce.Theme/tinymce.Plugin} The same theme or plugin instance that got passed in.
	       * @example
	       * // Create a simple plugin
	       * tinymce.create('tinymce.plugins.TestPlugin', {
	       *   TestPlugin: function(ed, url) {
	       *   ed.on('click', function(e) {
	       *      ed.windowManager.alert('Hello World!');
	       *   });
	       *   }
	       * });
	       *
	       * // Register plugin using the add method
	       * tinymce.PluginManager.add('test', tinymce.plugins.TestPlugin);
	       *
	       * // Initialize TinyMCE
	       * tinymce.init({
	       *  ...
	       *  plugins: '-test' // Init the plugin but don't try to load it
	       * });
	       */
	      add: function (id, addOn, dependencies) {
	        this.items.push(addOn);
	        this.lookup[id] = { instance: addOn, dependencies: dependencies };
	        var result = Arr.partition(this._listeners, function (listener) {
	          return listener.name === id;
	        });
	
	        this._listeners = result.fail;
	
	        each(result.pass, function (listener) {
	          listener.callback();
	        });
	
	        return addOn;
	      },
	
	      remove: function (name) {
	        delete this.urls[name];
	        delete this.lookup[name];
	      },
	
	      createUrl: function (baseUrl, dep) {
	        if (typeof dep === "object") {
	          return dep;
	        }
	
	        return { prefix: baseUrl.prefix, resource: dep, suffix: baseUrl.suffix };
	      },
	
	      /**
	       * Add a set of components that will make up the add-on. Using the url of the add-on name as the base url.
	       * This should be used in development mode.  A new compressor/javascript munger process will ensure that the
	       * components are put together into the plugin.js file and compressed correctly.
	       *
	       * @method addComponents
	       * @param {String} pluginName name of the plugin to load scripts from (will be used to get the base url for the plugins).
	       * @param {Array} scripts Array containing the names of the scripts to load.
	       */
	      addComponents: function (pluginName, scripts) {
	        var pluginUrl = this.urls[pluginName];
	
	        each(scripts, function (script) {
	          ScriptLoader.ScriptLoader.add(pluginUrl + "/" + script);
	        });
	      },
	
	      /**
	       * Loads an add-on from a specific url.
	       *
	       * @method load
	       * @param {String} name Short name of the add-on that gets loaded.
	       * @param {String} addOnUrl URL to the add-on that will get loaded.
	       * @param {function} success Optional success callback to execute when an add-on is loaded.
	       * @param {Object} scope Optional scope to execute the callback in.
	       * @param {function} failure Optional failure callback to execute when an add-on failed to load.
	       * @example
	       * // Loads a plugin from an external URL
	       * tinymce.PluginManager.load('myplugin', '/some/dir/someplugin/plugin.js');
	       *
	       * // Initialize TinyMCE
	       * tinymce.init({
	       *  ...
	       *  plugins: '-myplugin' // Don't try to load it again
	       * });
	       */
	      load: function (name, addOnUrl, success, scope, failure) {
	        var self = this, url = addOnUrl;
	
	        var loadDependencies = function () {
	          var dependencies = self.dependencies(name);
	
	          each(dependencies, function (dep) {
	            var newUrl = self.createUrl(addOnUrl, dep);
	
	            self.load(newUrl.resource, newUrl, undefined, undefined);
	          });
	
	          if (success) {
	            if (scope) {
	              success.call(scope);
	            } else {
	              success.call(ScriptLoader);
	            }
	          }
	        };
	
	        if (self.urls[name]) {
	          return;
	        }
	
	        if (typeof addOnUrl === "object") {
	          url = addOnUrl.prefix + addOnUrl.resource + addOnUrl.suffix;
	        }
	
	        if (url.indexOf('/') !== 0 && url.indexOf('://') == -1) {
	          url = AddOnManager.baseURL + '/' + url;
	        }
	
	        self.urls[name] = url.substring(0, url.lastIndexOf('/'));
	
	        if (self.lookup[name]) {
	          loadDependencies();
	        } else {
	          ScriptLoader.ScriptLoader.add(url, loadDependencies, scope, failure);
	        }
	      },
	
	      waitFor: function (name, callback) {
	        if (this.lookup.hasOwnProperty(name)) {
	          callback();
	        } else {
	          this._listeners.push({ name: name, callback: callback });
	        }
	      }
	    };
	
	    AddOnManager.PluginManager = new AddOnManager();
	    AddOnManager.ThemeManager = new AddOnManager();
	
	    return AddOnManager;
	  }
	);
	
	/**
	 * TinyMCE theme class.
	 *
	 * @class tinymce.Theme
	 */
	
	/**
	 * This method is responsible for rendering/generating the overall user interface with toolbars, buttons, iframe containers etc.
	 *
	 * @method renderUI
	 * @param {Object} obj Object parameter containing the targetNode DOM node that will be replaced visually with an editor instance.
	 * @return {Object} an object with items like iframeContainer, editorContainer, sizeContainer, deltaWidth, deltaHeight.
	 */
	
	/**
	 * Plugin base class, this is a pseudo class that describes how a plugin is to be created for TinyMCE. The methods below are all optional.
	 *
	 * @class tinymce.Plugin
	 * @example
	 * tinymce.PluginManager.add('example', function(editor, url) {
	 *     // Add a button that opens a window
	 *     editor.addButton('example', {
	 *         text: 'My button',
	 *         icon: false,
	 *         onclick: function() {
	 *             // Open window
	 *             editor.windowManager.open({
	 *                 title: 'Example plugin',
	 *                 body: [
	 *                     {type: 'textbox', name: 'title', label: 'Title'}
	 *                 ],
	 *                 onsubmit: function(e) {
	 *                     // Insert content when the window form is submitted
	 *                     editor.insertContent('Title: ' + e.data.title);
	 *                 }
	 *             });
	 *         }
	 *     });
	 *
	 *     // Adds a menu item to the tools menu
	 *     editor.addMenuItem('example', {
	 *         text: 'Example plugin',
	 *         context: 'tools',
	 *         onclick: function() {
	 *             // Open window with a specific url
	 *             editor.windowManager.open({
	 *                 title: 'TinyMCE site',
	 *                 url: 'http://www.tinymce.com',
	 *                 width: 800,
	 *                 height: 600,
	 *                 buttons: [{
	 *                     text: 'Close',
	 *                     onclick: 'close'
	 *                 }]
	 *             });
	 *         }
	 *     });
	 * });
	 */
	
	/**
	 * Zwsp.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility functions for working with zero width space
	 * characters used as character containers etc.
	 *
	 * @private
	 * @class tinymce.text.Zwsp
	 * @example
	 * var isZwsp = Zwsp.isZwsp('\uFEFF');
	 * var abc = Zwsp.trim('a\uFEFFc');
	 */
	define(
	  'tinymce.core.text.Zwsp',
	  [
	  ],
	  function () {
	    // This is technically not a ZWSP but a ZWNBSP or a BYTE ORDER MARK it used to be a ZWSP
	    var ZWSP = '\uFEFF';
	
	    var isZwsp = function (chr) {
	      return chr === ZWSP;
	    };
	
	    var trim = function (text) {
	      return text.replace(new RegExp(ZWSP, 'g'), '');
	    };
	
	    return {
	      isZwsp: isZwsp,
	      ZWSP: ZWSP,
	      trim: trim
	    };
	  }
	);
	/**
	 * CaretContainer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module handles caret containers. A caret container is a node that
	 * holds the caret for positional purposes.
	 *
	 * @private
	 * @class tinymce.caret.CaretContainer
	 */
	define(
	  'tinymce.core.caret.CaretContainer',
	  [
	    'global!document',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.text.Zwsp'
	  ],
	  function (document, NodeType, Zwsp) {
	    var isElement = NodeType.isElement,
	      isText = NodeType.isText;
	
	    var isCaretContainerBlock = function (node) {
	      if (isText(node)) {
	        node = node.parentNode;
	      }
	
	      return isElement(node) && node.hasAttribute('data-mce-caret');
	    };
	
	    var isCaretContainerInline = function (node) {
	      return isText(node) && Zwsp.isZwsp(node.data);
	    };
	
	    var isCaretContainer = function (node) {
	      return isCaretContainerBlock(node) || isCaretContainerInline(node);
	    };
	
	    var hasContent = function (node) {
	      return node.firstChild !== node.lastChild || !NodeType.isBr(node.firstChild);
	    };
	
	    var insertInline = function (node, before) {
	      var doc, sibling, textNode, parentNode;
	
	      doc = node.ownerDocument;
	      textNode = doc.createTextNode(Zwsp.ZWSP);
	      parentNode = node.parentNode;
	
	      if (!before) {
	        sibling = node.nextSibling;
	        if (isText(sibling)) {
	          if (isCaretContainer(sibling)) {
	            return sibling;
	          }
	
	          if (startsWithCaretContainer(sibling)) {
	            sibling.splitText(1);
	            return sibling;
	          }
	        }
	
	        if (node.nextSibling) {
	          parentNode.insertBefore(textNode, node.nextSibling);
	        } else {
	          parentNode.appendChild(textNode);
	        }
	      } else {
	        sibling = node.previousSibling;
	        if (isText(sibling)) {
	          if (isCaretContainer(sibling)) {
	            return sibling;
	          }
	
	          if (endsWithCaretContainer(sibling)) {
	            return sibling.splitText(sibling.data.length - 1);
	          }
	        }
	
	        parentNode.insertBefore(textNode, node);
	      }
	
	      return textNode;
	    };
	
	    var prependInline = function (node) {
	      if (NodeType.isText(node)) {
	        var data = node.data;
	        if (data.length > 0 && data.charAt(0) !== Zwsp.ZWSP) {
	          node.insertData(0, Zwsp.ZWSP);
	        }
	        return node;
	      } else {
	        return null;
	      }
	    };
	
	    var appendInline = function (node) {
	      if (NodeType.isText(node)) {
	        var data = node.data;
	        if (data.length > 0 && data.charAt(data.length - 1) !== Zwsp.ZWSP) {
	          node.insertData(data.length, Zwsp.ZWSP);
	        }
	        return node;
	      } else {
	        return null;
	      }
	    };
	
	    var isBeforeInline = function (pos) {
	      return pos && NodeType.isText(pos.container()) && pos.container().data.charAt(pos.offset()) === Zwsp.ZWSP;
	    };
	
	    var isAfterInline = function (pos) {
	      return pos && NodeType.isText(pos.container()) && pos.container().data.charAt(pos.offset() - 1) === Zwsp.ZWSP;
	    };
	
	    var createBogusBr = function () {
	      var br = document.createElement('br');
	      br.setAttribute('data-mce-bogus', '1');
	      return br;
	    };
	
	    var insertBlock = function (blockName, node, before) {
	      var doc, blockNode, parentNode;
	
	      doc = node.ownerDocument;
	      blockNode = doc.createElement(blockName);
	      blockNode.setAttribute('data-mce-caret', before ? 'before' : 'after');
	      blockNode.setAttribute('data-mce-bogus', 'all');
	      blockNode.appendChild(createBogusBr());
	      parentNode = node.parentNode;
	
	      if (!before) {
	        if (node.nextSibling) {
	          parentNode.insertBefore(blockNode, node.nextSibling);
	        } else {
	          parentNode.appendChild(blockNode);
	        }
	      } else {
	        parentNode.insertBefore(blockNode, node);
	      }
	
	      return blockNode;
	    };
	
	    var startsWithCaretContainer = function (node) {
	      return isText(node) && node.data[0] == Zwsp.ZWSP;
	    };
	
	    var endsWithCaretContainer = function (node) {
	      return isText(node) && node.data[node.data.length - 1] == Zwsp.ZWSP;
	    };
	
	    var trimBogusBr = function (elm) {
	      var brs = elm.getElementsByTagName('br');
	      var lastBr = brs[brs.length - 1];
	      if (NodeType.isBogus(lastBr)) {
	        lastBr.parentNode.removeChild(lastBr);
	      }
	    };
	
	    var showCaretContainerBlock = function (caretContainer) {
	      if (caretContainer && caretContainer.hasAttribute('data-mce-caret')) {
	        trimBogusBr(caretContainer);
	        caretContainer.removeAttribute('data-mce-caret');
	        caretContainer.removeAttribute('data-mce-bogus');
	        caretContainer.removeAttribute('style');
	        caretContainer.removeAttribute('_moz_abspos');
	        return caretContainer;
	      }
	
	      return null;
	    };
	
	    return {
	      isCaretContainer: isCaretContainer,
	      isCaretContainerBlock: isCaretContainerBlock,
	      isCaretContainerInline: isCaretContainerInline,
	      showCaretContainerBlock: showCaretContainerBlock,
	      insertInline: insertInline,
	      prependInline: prependInline,
	      appendInline: appendInline,
	      isBeforeInline: isBeforeInline,
	      isAfterInline: isAfterInline,
	      insertBlock: insertBlock,
	      hasContent: hasContent,
	      startsWithCaretContainer: startsWithCaretContainer,
	      endsWithCaretContainer: endsWithCaretContainer
	    };
	  }
	);
	/**
	 * CaretCandidate.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic for handling caret candidates. A caret candidate is
	 * for example text nodes, images, input elements, cE=false elements etc.
	 *
	 * @private
	 * @class tinymce.caret.CaretCandidate
	 */
	define(
	  'tinymce.core.caret.CaretCandidate',
	  [
	    "tinymce.core.dom.NodeType",
	    "tinymce.core.util.Arr",
	    "tinymce.core.caret.CaretContainer"
	  ],
	  function (NodeType, Arr, CaretContainer) {
	    var isContentEditableTrue = NodeType.isContentEditableTrue,
	      isContentEditableFalse = NodeType.isContentEditableFalse,
	      isBr = NodeType.isBr,
	      isText = NodeType.isText,
	      isInvalidTextElement = NodeType.matchNodeNames('script style textarea'),
	      isAtomicInline = NodeType.matchNodeNames('img input textarea hr iframe video audio object'),
	      isTable = NodeType.matchNodeNames('table'),
	      isCaretContainer = CaretContainer.isCaretContainer;
	
	    var isCaretCandidate = function (node) {
	      if (isCaretContainer(node)) {
	        return false;
	      }
	
	      if (isText(node)) {
	        if (isInvalidTextElement(node.parentNode)) {
	          return false;
	        }
	
	        return true;
	      }
	
	      return isAtomicInline(node) || isBr(node) || isTable(node) || isContentEditableFalse(node);
	    };
	
	    var isInEditable = function (node, rootNode) {
	      for (node = node.parentNode; node && node != rootNode; node = node.parentNode) {
	        if (isContentEditableFalse(node)) {
	          return false;
	        }
	
	        if (isContentEditableTrue(node)) {
	          return true;
	        }
	      }
	
	      return true;
	    };
	
	    var isAtomicContentEditableFalse = function (node) {
	      if (!isContentEditableFalse(node)) {
	        return false;
	      }
	
	      return Arr.reduce(node.getElementsByTagName('*'), function (result, elm) {
	        return result || isContentEditableTrue(elm);
	      }, false) !== true;
	    };
	
	    var isAtomic = function (node) {
	      return isAtomicInline(node) || isAtomicContentEditableFalse(node);
	    };
	
	    var isEditableCaretCandidate = function (node, rootNode) {
	      return isCaretCandidate(node) && isInEditable(node, rootNode);
	    };
	
	    return {
	      isCaretCandidate: isCaretCandidate,
	      isInEditable: isInEditable,
	      isAtomic: isAtomic,
	      isEditableCaretCandidate: isEditableCaretCandidate
	    };
	  }
	);
	/**
	 * ClientRect.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility functions for working with client rects.
	 *
	 * @private
	 * @class tinymce.geom.ClientRect
	 */
	define(
	  'tinymce.core.geom.ClientRect',
	  [
	  ],
	  function () {
	    var round = Math.round;
	
	    var clone = function (rect) {
	      if (!rect) {
	        return { left: 0, top: 0, bottom: 0, right: 0, width: 0, height: 0 };
	      }
	
	      return {
	        left: round(rect.left),
	        top: round(rect.top),
	        bottom: round(rect.bottom),
	        right: round(rect.right),
	        width: round(rect.width),
	        height: round(rect.height)
	      };
	    };
	
	    var collapse = function (clientRect, toStart) {
	      clientRect = clone(clientRect);
	
	      if (toStart) {
	        clientRect.right = clientRect.left;
	      } else {
	        clientRect.left = clientRect.left + clientRect.width;
	        clientRect.right = clientRect.left;
	      }
	
	      clientRect.width = 0;
	
	      return clientRect;
	    };
	
	    var isEqual = function (rect1, rect2) {
	      return (
	        rect1.left === rect2.left &&
	        rect1.top === rect2.top &&
	        rect1.bottom === rect2.bottom &&
	        rect1.right === rect2.right
	      );
	    };
	
	    var isValidOverflow = function (overflowY, clientRect1, clientRect2) {
	      return overflowY >= 0 && overflowY <= Math.min(clientRect1.height, clientRect2.height) / 2;
	
	    };
	
	    var isAbove = function (clientRect1, clientRect2) {
	      if ((clientRect1.bottom - clientRect1.height / 2) < clientRect2.top) {
	        return true;
	      }
	
	      if (clientRect1.top > clientRect2.bottom) {
	        return false;
	      }
	
	      return isValidOverflow(clientRect2.top - clientRect1.bottom, clientRect1, clientRect2);
	    };
	
	    var isBelow = function (clientRect1, clientRect2) {
	      if (clientRect1.top > clientRect2.bottom) {
	        return true;
	      }
	
	      if (clientRect1.bottom < clientRect2.top) {
	        return false;
	      }
	
	      return isValidOverflow(clientRect2.bottom - clientRect1.top, clientRect1, clientRect2);
	    };
	
	    var isLeft = function (clientRect1, clientRect2) {
	      return clientRect1.left < clientRect2.left;
	    };
	
	    var isRight = function (clientRect1, clientRect2) {
	      return clientRect1.right > clientRect2.right;
	    };
	
	    var compare = function (clientRect1, clientRect2) {
	      if (isAbove(clientRect1, clientRect2)) {
	        return -1;
	      }
	
	      if (isBelow(clientRect1, clientRect2)) {
	        return 1;
	      }
	
	      if (isLeft(clientRect1, clientRect2)) {
	        return -1;
	      }
	
	      if (isRight(clientRect1, clientRect2)) {
	        return 1;
	      }
	
	      return 0;
	    };
	
	    var containsXY = function (clientRect, clientX, clientY) {
	      return (
	        clientX >= clientRect.left &&
	        clientX <= clientRect.right &&
	        clientY >= clientRect.top &&
	        clientY <= clientRect.bottom
	      );
	    };
	
	    return {
	      clone: clone,
	      collapse: collapse,
	      isEqual: isEqual,
	      isAbove: isAbove,
	      isBelow: isBelow,
	      isLeft: isLeft,
	      isRight: isRight,
	      compare: compare,
	      containsXY: containsXY
	    };
	  }
	);
	
	/**
	 * RangeNodes.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.RangeNodes',
	  [
	  ],
	  function () {
	    var getSelectedNode = function (range) {
	      var startContainer = range.startContainer,
	        startOffset = range.startOffset;
	
	      if (startContainer.hasChildNodes() && range.endOffset == startOffset + 1) {
	        return startContainer.childNodes[startOffset];
	      }
	
	      return null;
	    };
	
	    var getNode = function (container, offset) {
	      if (container.nodeType === 1 && container.hasChildNodes()) {
	        if (offset >= container.childNodes.length) {
	          offset = container.childNodes.length - 1;
	        }
	
	        container = container.childNodes[offset];
	      }
	
	      return container;
	    };
	
	    return {
	      getSelectedNode: getSelectedNode,
	      getNode: getNode
	    };
	  }
	);
	
	/**
	 * ExtendingChar.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains logic for detecting extending characters.
	 *
	 * @private
	 * @class tinymce.text.ExtendingChar
	 * @example
	 * var isExtending = ExtendingChar.isExtendingChar('a');
	 */
	define(
	  'tinymce.core.text.ExtendingChar',
	  [
	  ],
	  function () {
	    // Generated from: http://www.unicode.org/Public/UNIDATA/DerivedCoreProperties.txt
	    // Only includes the characters in that fit into UCS-2 16 bit
	    var extendingChars = new RegExp(
	      "[\u0300-\u036F\u0483-\u0487\u0488-\u0489\u0591-\u05BD\u05BF\u05C1-\u05C2\u05C4-\u05C5\u05C7\u0610-\u061A" +
	      "\u064B-\u065F\u0670\u06D6-\u06DC\u06DF-\u06E4\u06E7-\u06E8\u06EA-\u06ED\u0711\u0730-\u074A\u07A6-\u07B0" +
	      "\u07EB-\u07F3\u0816-\u0819\u081B-\u0823\u0825-\u0827\u0829-\u082D\u0859-\u085B\u08E3-\u0902\u093A\u093C" +
	      "\u0941-\u0948\u094D\u0951-\u0957\u0962-\u0963\u0981\u09BC\u09BE\u09C1-\u09C4\u09CD\u09D7\u09E2-\u09E3" +
	      "\u0A01-\u0A02\u0A3C\u0A41-\u0A42\u0A47-\u0A48\u0A4B-\u0A4D\u0A51\u0A70-\u0A71\u0A75\u0A81-\u0A82\u0ABC" +
	      "\u0AC1-\u0AC5\u0AC7-\u0AC8\u0ACD\u0AE2-\u0AE3\u0B01\u0B3C\u0B3E\u0B3F\u0B41-\u0B44\u0B4D\u0B56\u0B57" +
	      "\u0B62-\u0B63\u0B82\u0BBE\u0BC0\u0BCD\u0BD7\u0C00\u0C3E-\u0C40\u0C46-\u0C48\u0C4A-\u0C4D\u0C55-\u0C56" +
	      "\u0C62-\u0C63\u0C81\u0CBC\u0CBF\u0CC2\u0CC6\u0CCC-\u0CCD\u0CD5-\u0CD6\u0CE2-\u0CE3\u0D01\u0D3E\u0D41-\u0D44" +
	      "\u0D4D\u0D57\u0D62-\u0D63\u0DCA\u0DCF\u0DD2-\u0DD4\u0DD6\u0DDF\u0E31\u0E34-\u0E3A\u0E47-\u0E4E\u0EB1\u0EB4-\u0EB9" +
	      "\u0EBB-\u0EBC\u0EC8-\u0ECD\u0F18-\u0F19\u0F35\u0F37\u0F39\u0F71-\u0F7E\u0F80-\u0F84\u0F86-\u0F87\u0F8D-\u0F97" +
	      "\u0F99-\u0FBC\u0FC6\u102D-\u1030\u1032-\u1037\u1039-\u103A\u103D-\u103E\u1058-\u1059\u105E-\u1060\u1071-\u1074" +
	      "\u1082\u1085-\u1086\u108D\u109D\u135D-\u135F\u1712-\u1714\u1732-\u1734\u1752-\u1753\u1772-\u1773\u17B4-\u17B5" +
	      "\u17B7-\u17BD\u17C6\u17C9-\u17D3\u17DD\u180B-\u180D\u18A9\u1920-\u1922\u1927-\u1928\u1932\u1939-\u193B\u1A17-\u1A18" +
	      "\u1A1B\u1A56\u1A58-\u1A5E\u1A60\u1A62\u1A65-\u1A6C\u1A73-\u1A7C\u1A7F\u1AB0-\u1ABD\u1ABE\u1B00-\u1B03\u1B34" +
	      "\u1B36-\u1B3A\u1B3C\u1B42\u1B6B-\u1B73\u1B80-\u1B81\u1BA2-\u1BA5\u1BA8-\u1BA9\u1BAB-\u1BAD\u1BE6\u1BE8-\u1BE9" +
	      "\u1BED\u1BEF-\u1BF1\u1C2C-\u1C33\u1C36-\u1C37\u1CD0-\u1CD2\u1CD4-\u1CE0\u1CE2-\u1CE8\u1CED\u1CF4\u1CF8-\u1CF9" +
	      "\u1DC0-\u1DF5\u1DFC-\u1DFF\u200C-\u200D\u20D0-\u20DC\u20DD-\u20E0\u20E1\u20E2-\u20E4\u20E5-\u20F0\u2CEF-\u2CF1" +
	      "\u2D7F\u2DE0-\u2DFF\u302A-\u302D\u302E-\u302F\u3099-\u309A\uA66F\uA670-\uA672\uA674-\uA67D\uA69E-\uA69F\uA6F0-\uA6F1" +
	      "\uA802\uA806\uA80B\uA825-\uA826\uA8C4\uA8E0-\uA8F1\uA926-\uA92D\uA947-\uA951\uA980-\uA982\uA9B3\uA9B6-\uA9B9\uA9BC" +
	      "\uA9E5\uAA29-\uAA2E\uAA31-\uAA32\uAA35-\uAA36\uAA43\uAA4C\uAA7C\uAAB0\uAAB2-\uAAB4\uAAB7-\uAAB8\uAABE-\uAABF\uAAC1" +
	      "\uAAEC-\uAAED\uAAF6\uABE5\uABE8\uABED\uFB1E\uFE00-\uFE0F\uFE20-\uFE2F\uFF9E-\uFF9F]"
	    );
	
	    var isExtendingChar = function (ch) {
	      return typeof ch == "string" && ch.charCodeAt(0) >= 768 && extendingChars.test(ch);
	    };
	
	    return {
	      isExtendingChar: isExtendingChar
	    };
	  }
	);
	/**
	 * Fun.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Functional utility class.
	 *
	 * @private
	 * @class tinymce.util.Fun
	 */
	define(
	  'tinymce.core.util.Fun',
	  [
	  ],
	  function () {
	    var slice = [].slice;
	
	    var constant = function (value) {
	      return function () {
	        return value;
	      };
	    };
	
	    var negate = function (predicate) {
	      return function (x) {
	        return !predicate(x);
	      };
	    };
	
	    var compose = function (f, g) {
	      return function (x) {
	        return f(g(x));
	      };
	    };
	
	    var or = function () {
	      var args = slice.call(arguments);
	
	      return function (x) {
	        for (var i = 0; i < args.length; i++) {
	          if (args[i](x)) {
	            return true;
	          }
	        }
	
	        return false;
	      };
	    };
	
	    var and = function () {
	      var args = slice.call(arguments);
	
	      return function (x) {
	        for (var i = 0; i < args.length; i++) {
	          if (!args[i](x)) {
	            return false;
	          }
	        }
	
	        return true;
	      };
	    };
	
	    var curry = function (fn) {
	      var args = slice.call(arguments);
	
	      if (args.length - 1 >= fn.length) {
	        return fn.apply(this, args.slice(1));
	      }
	
	      return function () {
	        var tempArgs = args.concat([].slice.call(arguments));
	        return curry.apply(this, tempArgs);
	      };
	    };
	
	    var noop = function () {
	    };
	
	    return {
	      constant: constant,
	      negate: negate,
	      and: and,
	      or: or,
	      curry: curry,
	      compose: compose,
	      noop: noop
	    };
	  }
	);
	/**
	 * CaretPosition.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic for creating caret positions within a document a caretposition
	 * is similar to a DOMRange object but it doesn't have two endpoints and is also more lightweight
	 * since it's now updated live when the DOM changes.
	 *
	 * @private
	 * @class tinymce.caret.CaretPosition
	 * @example
	 * var caretPos1 = new CaretPosition(container, offset);
	 * var caretPos2 = CaretPosition.fromRangeStart(someRange);
	 */
	define(
	  'tinymce.core.caret.CaretPosition',
	  [
	    'tinymce.core.caret.CaretCandidate',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.geom.ClientRect',
	    'tinymce.core.selection.RangeNodes',
	    'tinymce.core.text.ExtendingChar',
	    'tinymce.core.util.Fun'
	  ],
	  function (CaretCandidate, DOMUtils, NodeType, ClientRect, RangeNodes, ExtendingChar, Fun) {
	    var isElement = NodeType.isElement,
	      isCaretCandidate = CaretCandidate.isCaretCandidate,
	      isBlock = NodeType.matchStyleValues('display', 'block table'),
	      isFloated = NodeType.matchStyleValues('float', 'left right'),
	      isValidElementCaretCandidate = Fun.and(isElement, isCaretCandidate, Fun.negate(isFloated)),
	      isNotPre = Fun.negate(NodeType.matchStyleValues('white-space', 'pre pre-line pre-wrap')),
	      isText = NodeType.isText,
	      isBr = NodeType.isBr,
	      nodeIndex = DOMUtils.nodeIndex,
	      resolveIndex = RangeNodes.getNode;
	
	    var createRange = function (doc) {
	      return "createRange" in doc ? doc.createRange() : DOMUtils.DOM.createRng();
	    };
	
	    var isWhiteSpace = function (chr) {
	      return chr && /[\r\n\t ]/.test(chr);
	    };
	
	    var isHiddenWhiteSpaceRange = function (range) {
	      var container = range.startContainer,
	        offset = range.startOffset,
	        text;
	
	      if (isWhiteSpace(range.toString()) && isNotPre(container.parentNode)) {
	        text = container.data;
	
	        if (isWhiteSpace(text[offset - 1]) || isWhiteSpace(text[offset + 1])) {
	          return true;
	        }
	      }
	
	      return false;
	    };
	
	    var getCaretPositionClientRects = function (caretPosition) {
	      var clientRects = [], beforeNode, node;
	
	      // Hack for older WebKit versions that doesn't
	      // support getBoundingClientRect on BR elements
	      var getBrClientRect = function (brNode) {
	        var doc = brNode.ownerDocument,
	          rng = createRange(doc),
	          nbsp = doc.createTextNode('\u00a0'),
	          parentNode = brNode.parentNode,
	          clientRect;
	
	        parentNode.insertBefore(nbsp, brNode);
	        rng.setStart(nbsp, 0);
	        rng.setEnd(nbsp, 1);
	        clientRect = ClientRect.clone(rng.getBoundingClientRect());
	        parentNode.removeChild(nbsp);
	
	        return clientRect;
	      };
	
	      var getBoundingClientRect = function (item) {
	        var clientRect, clientRects;
	
	        clientRects = item.getClientRects();
	        if (clientRects.length > 0) {
	          clientRect = ClientRect.clone(clientRects[0]);
	        } else {
	          clientRect = ClientRect.clone(item.getBoundingClientRect());
	        }
	
	        if (isBr(item) && clientRect.left === 0) {
	          return getBrClientRect(item);
	        }
	
	        return clientRect;
	      };
	
	      var collapseAndInflateWidth = function (clientRect, toStart) {
	        clientRect = ClientRect.collapse(clientRect, toStart);
	        clientRect.width = 1;
	        clientRect.right = clientRect.left + 1;
	
	        return clientRect;
	      };
	
	      var addUniqueAndValidRect = function (clientRect) {
	        if (clientRect.height === 0) {
	          return;
	        }
	
	        if (clientRects.length > 0) {
	          if (ClientRect.isEqual(clientRect, clientRects[clientRects.length - 1])) {
	            return;
	          }
	        }
	
	        clientRects.push(clientRect);
	      };
	
	      var addCharacterOffset = function (container, offset) {
	        var range = createRange(container.ownerDocument);
	
	        if (offset < container.data.length) {
	          if (ExtendingChar.isExtendingChar(container.data[offset])) {
	            return clientRects;
	          }
	
	          // WebKit returns two client rects for a position after an extending
	          // character a\uxxx|b so expand on "b" and collapse to start of "b" box
	          if (ExtendingChar.isExtendingChar(container.data[offset - 1])) {
	            range.setStart(container, offset);
	            range.setEnd(container, offset + 1);
	
	            if (!isHiddenWhiteSpaceRange(range)) {
	              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
	              return clientRects;
	            }
	          }
	        }
	
	        if (offset > 0) {
	          range.setStart(container, offset - 1);
	          range.setEnd(container, offset);
	
	          if (!isHiddenWhiteSpaceRange(range)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), false));
	          }
	        }
	
	        if (offset < container.data.length) {
	          range.setStart(container, offset);
	          range.setEnd(container, offset + 1);
	
	          if (!isHiddenWhiteSpaceRange(range)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(range), true));
	          }
	        }
	      };
	
	      if (isText(caretPosition.container())) {
	        addCharacterOffset(caretPosition.container(), caretPosition.offset());
	        return clientRects;
	      }
	
	      if (isElement(caretPosition.container())) {
	        if (caretPosition.isAtEnd()) {
	          node = resolveIndex(caretPosition.container(), caretPosition.offset());
	          if (isText(node)) {
	            addCharacterOffset(node, node.data.length);
	          }
	
	          if (isValidElementCaretCandidate(node) && !isBr(node)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
	          }
	        } else {
	          node = resolveIndex(caretPosition.container(), caretPosition.offset());
	          if (isText(node)) {
	            addCharacterOffset(node, 0);
	          }
	
	          if (isValidElementCaretCandidate(node) && caretPosition.isAtEnd()) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), false));
	            return clientRects;
	          }
	
	          beforeNode = resolveIndex(caretPosition.container(), caretPosition.offset() - 1);
	          if (isValidElementCaretCandidate(beforeNode) && !isBr(beforeNode)) {
	            if (isBlock(beforeNode) || isBlock(node) || !isValidElementCaretCandidate(node)) {
	              addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(beforeNode), false));
	            }
	          }
	
	          if (isValidElementCaretCandidate(node)) {
	            addUniqueAndValidRect(collapseAndInflateWidth(getBoundingClientRect(node), true));
	          }
	        }
	      }
	
	      return clientRects;
	    };
	
	    /**
	     * Represents a location within the document by a container and an offset.
	     *
	     * @constructor
	     * @param {Node} container Container node.
	     * @param {Number} offset Offset within that container node.
	     * @param {Array} clientRects Optional client rects array for the position.
	     */
	    var CaretPosition = function (container, offset, clientRects) {
	      var isAtStart = function () {
	        if (isText(container)) {
	          return offset === 0;
	        }
	
	        return offset === 0;
	      };
	
	      var isAtEnd = function () {
	        if (isText(container)) {
	          return offset >= container.data.length;
	        }
	
	        return offset >= container.childNodes.length;
	      };
	
	      var toRange = function () {
	        var range;
	
	        range = createRange(container.ownerDocument);
	        range.setStart(container, offset);
	        range.setEnd(container, offset);
	
	        return range;
	      };
	
	      var getClientRects = function () {
	        if (!clientRects) {
	          clientRects = getCaretPositionClientRects(new CaretPosition(container, offset));
	        }
	
	        return clientRects;
	      };
	
	      var isVisible = function () {
	        return getClientRects().length > 0;
	      };
	
	      var isEqual = function (caretPosition) {
	        return caretPosition && container === caretPosition.container() && offset === caretPosition.offset();
	      };
	
	      var getNode = function (before) {
	        return resolveIndex(container, before ? offset - 1 : offset);
	      };
	
	      return {
	        /**
	         * Returns the container node.
	         *
	         * @method container
	         * @return {Node} Container node.
	         */
	        container: Fun.constant(container),
	
	        /**
	         * Returns the offset within the container node.
	         *
	         * @method offset
	         * @return {Number} Offset within the container node.
	         */
	        offset: Fun.constant(offset),
	
	        /**
	         * Returns a range out of a the caret position.
	         *
	         * @method toRange
	         * @return {DOMRange} range for the caret position.
	         */
	        toRange: toRange,
	
	        /**
	         * Returns the client rects for the caret position. Might be multiple rects between
	         * block elements.
	         *
	         * @method getClientRects
	         * @return {Array} Array of client rects.
	         */
	        getClientRects: getClientRects,
	
	        /**
	         * Returns true if the caret location is visible/displayed on screen.
	         *
	         * @method isVisible
	         * @return {Boolean} true/false if the position is visible or not.
	         */
	        isVisible: isVisible,
	
	        /**
	         * Returns true if the caret location is at the beginning of text node or container.
	         *
	         * @method isVisible
	         * @return {Boolean} true/false if the position is at the beginning.
	         */
	        isAtStart: isAtStart,
	
	        /**
	         * Returns true if the caret location is at the end of text node or container.
	         *
	         * @method isVisible
	         * @return {Boolean} true/false if the position is at the end.
	         */
	        isAtEnd: isAtEnd,
	
	        /**
	         * Compares the caret position to another caret position. This will only compare the
	         * container and offset not it's visual position.
	         *
	         * @method isEqual
	         * @param {tinymce.caret.CaretPosition} caretPosition Caret position to compare with.
	         * @return {Boolean} true if the caret positions are equal.
	         */
	        isEqual: isEqual,
	
	        /**
	         * Returns the closest resolved node from a node index. That means if you have an offset after the
	         * last node in a container it will return that last node.
	         *
	         * @method getNode
	         * @return {Node} Node that is closest to the index.
	         */
	        getNode: getNode
	      };
	    };
	
	    /**
	     * Creates a caret position from the start of a range.
	     *
	     * @method fromRangeStart
	     * @param {DOMRange} range DOM Range to create caret position from.
	     * @return {tinymce.caret.CaretPosition} Caret position from the start of DOM range.
	     */
	    CaretPosition.fromRangeStart = function (range) {
	      return new CaretPosition(range.startContainer, range.startOffset);
	    };
	
	    /**
	     * Creates a caret position from the end of a range.
	     *
	     * @method fromRangeEnd
	     * @param {DOMRange} range DOM Range to create caret position from.
	     * @return {tinymce.caret.CaretPosition} Caret position from the end of DOM range.
	     */
	    CaretPosition.fromRangeEnd = function (range) {
	      return new CaretPosition(range.endContainer, range.endOffset);
	    };
	
	    /**
	     * Creates a caret position from a node and places the offset after it.
	     *
	     * @method after
	     * @param {Node} node Node to get caret position from.
	     * @return {tinymce.caret.CaretPosition} Caret position from the node.
	     */
	    CaretPosition.after = function (node) {
	      return new CaretPosition(node.parentNode, nodeIndex(node) + 1);
	    };
	
	    /**
	     * Creates a caret position from a node and places the offset before it.
	     *
	     * @method before
	     * @param {Node} node Node to get caret position from.
	     * @return {tinymce.caret.CaretPosition} Caret position from the node.
	     */
	    CaretPosition.before = function (node) {
	      return new CaretPosition(node.parentNode, nodeIndex(node));
	    };
	
	    CaretPosition.isAtStart = function (pos) {
	      return pos ? pos.isAtStart() : false;
	    };
	
	    CaretPosition.isAtEnd = function (pos) {
	      return pos ? pos.isAtEnd() : false;
	    };
	
	    CaretPosition.isTextPosition = function (pos) {
	      return pos ? NodeType.isText(pos.container()) : false;
	    };
	
	    return CaretPosition;
	  }
	);
	/**
	 * CaretUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility functions shared by the caret logic.
	 *
	 * @private
	 * @class tinymce.caret.CaretUtils
	 */
	define(
	  'tinymce.core.caret.CaretUtils',
	  [
	    "tinymce.core.util.Fun",
	    "tinymce.core.dom.TreeWalker",
	    "tinymce.core.dom.NodeType",
	    "tinymce.core.caret.CaretPosition",
	    "tinymce.core.caret.CaretContainer",
	    "tinymce.core.caret.CaretCandidate"
	  ],
	  function (Fun, TreeWalker, NodeType, CaretPosition, CaretContainer, CaretCandidate) {
	    var isContentEditableTrue = NodeType.isContentEditableTrue,
	      isContentEditableFalse = NodeType.isContentEditableFalse,
	      isBlockLike = NodeType.matchStyleValues('display', 'block table table-cell table-caption list-item'),
	      isCaretContainer = CaretContainer.isCaretContainer,
	      isCaretContainerBlock = CaretContainer.isCaretContainerBlock,
	      curry = Fun.curry,
	      isElement = NodeType.isElement,
	      isCaretCandidate = CaretCandidate.isCaretCandidate;
	
	    var isForwards = function (direction) {
	      return direction > 0;
	    };
	
	    var isBackwards = function (direction) {
	      return direction < 0;
	    };
	
	    var skipCaretContainers = function (walk, shallow) {
	      var node;
	
	      while ((node = walk(shallow))) {
	        if (!isCaretContainerBlock(node)) {
	          return node;
	        }
	      }
	
	      return null;
	    };
	
	    var findNode = function (node, direction, predicateFn, rootNode, shallow) {
	      var walker = new TreeWalker(node, rootNode);
	
	      if (isBackwards(direction)) {
	        if (isContentEditableFalse(node) || isCaretContainerBlock(node)) {
	          node = skipCaretContainers(walker.prev, true);
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	
	        while ((node = skipCaretContainers(walker.prev, shallow))) {
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	      }
	
	      if (isForwards(direction)) {
	        if (isContentEditableFalse(node) || isCaretContainerBlock(node)) {
	          node = skipCaretContainers(walker.next, true);
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	
	        while ((node = skipCaretContainers(walker.next, shallow))) {
	          if (predicateFn(node)) {
	            return node;
	          }
	        }
	      }
	
	      return null;
	    };
	
	    var getEditingHost = function (node, rootNode) {
	      for (node = node.parentNode; node && node != rootNode; node = node.parentNode) {
	        if (isContentEditableTrue(node)) {
	          return node;
	        }
	      }
	
	      return rootNode;
	    };
	
	    var getParentBlock = function (node, rootNode) {
	      while (node && node != rootNode) {
	        if (isBlockLike(node)) {
	          return node;
	        }
	
	        node = node.parentNode;
	      }
	
	      return null;
	    };
	
	    var isInSameBlock = function (caretPosition1, caretPosition2, rootNode) {
	      return getParentBlock(caretPosition1.container(), rootNode) == getParentBlock(caretPosition2.container(), rootNode);
	    };
	
	    var isInSameEditingHost = function (caretPosition1, caretPosition2, rootNode) {
	      return getEditingHost(caretPosition1.container(), rootNode) == getEditingHost(caretPosition2.container(), rootNode);
	    };
	
	    var getChildNodeAtRelativeOffset = function (relativeOffset, caretPosition) {
	      var container, offset;
	
	      if (!caretPosition) {
	        return null;
	      }
	
	      container = caretPosition.container();
	      offset = caretPosition.offset();
	
	      if (!isElement(container)) {
	        return null;
	      }
	
	      return container.childNodes[offset + relativeOffset];
	    };
	
	    var beforeAfter = function (before, node) {
	      var range = node.ownerDocument.createRange();
	
	      if (before) {
	        range.setStartBefore(node);
	        range.setEndBefore(node);
	      } else {
	        range.setStartAfter(node);
	        range.setEndAfter(node);
	      }
	
	      return range;
	    };
	
	    var isNodesInSameBlock = function (rootNode, node1, node2) {
	      return getParentBlock(node1, rootNode) == getParentBlock(node2, rootNode);
	    };
	
	    var lean = function (left, rootNode, node) {
	      var sibling, siblingName;
	
	      if (left) {
	        siblingName = 'previousSibling';
	      } else {
	        siblingName = 'nextSibling';
	      }
	
	      while (node && node != rootNode) {
	        sibling = node[siblingName];
	
	        if (isCaretContainer(sibling)) {
	          sibling = sibling[siblingName];
	        }
	
	        if (isContentEditableFalse(sibling)) {
	          if (isNodesInSameBlock(rootNode, sibling, node)) {
	            return sibling;
	          }
	
	          break;
	        }
	
	        if (isCaretCandidate(sibling)) {
	          break;
	        }
	
	        node = node.parentNode;
	      }
	
	      return null;
	    };
	
	    var before = curry(beforeAfter, true);
	    var after = curry(beforeAfter, false);
	
	    var normalizeRange = function (direction, rootNode, range) {
	      var node, container, offset, location;
	      var leanLeft = curry(lean, true, rootNode);
	      var leanRight = curry(lean, false, rootNode);
	
	      container = range.startContainer;
	      offset = range.startOffset;
	
	      if (CaretContainer.isCaretContainerBlock(container)) {
	        if (!isElement(container)) {
	          container = container.parentNode;
	        }
	
	        location = container.getAttribute('data-mce-caret');
	
	        if (location == 'before') {
	          node = container.nextSibling;
	          if (isContentEditableFalse(node)) {
	            return before(node);
	          }
	        }
	
	        if (location == 'after') {
	          node = container.previousSibling;
	          if (isContentEditableFalse(node)) {
	            return after(node);
	          }
	        }
	      }
	
	      if (!range.collapsed) {
	        return range;
	      }
	
	      if (NodeType.isText(container)) {
	        if (isCaretContainer(container)) {
	          if (direction === 1) {
	            node = leanRight(container);
	            if (node) {
	              return before(node);
	            }
	
	            node = leanLeft(container);
	            if (node) {
	              return after(node);
	            }
	          }
	
	          if (direction === -1) {
	            node = leanLeft(container);
	            if (node) {
	              return after(node);
	            }
	
	            node = leanRight(container);
	            if (node) {
	              return before(node);
	            }
	          }
	
	          return range;
	        }
	
	        if (CaretContainer.endsWithCaretContainer(container) && offset >= container.data.length - 1) {
	          if (direction === 1) {
	            node = leanRight(container);
	            if (node) {
	              return before(node);
	            }
	          }
	
	          return range;
	        }
	
	        if (CaretContainer.startsWithCaretContainer(container) && offset <= 1) {
	          if (direction === -1) {
	            node = leanLeft(container);
	            if (node) {
	              return after(node);
	            }
	          }
	
	          return range;
	        }
	
	        if (offset === container.data.length) {
	          node = leanRight(container);
	          if (node) {
	            return before(node);
	          }
	
	          return range;
	        }
	
	        if (offset === 0) {
	          node = leanLeft(container);
	          if (node) {
	            return after(node);
	          }
	
	          return range;
	        }
	      }
	
	      return range;
	    };
	
	    var isNextToContentEditableFalse = function (relativeOffset, caretPosition) {
	      return isContentEditableFalse(getChildNodeAtRelativeOffset(relativeOffset, caretPosition));
	    };
	
	    return {
	      isForwards: isForwards,
	      isBackwards: isBackwards,
	      findNode: findNode,
	      getEditingHost: getEditingHost,
	      getParentBlock: getParentBlock,
	      isInSameBlock: isInSameBlock,
	      isInSameEditingHost: isInSameEditingHost,
	      isBeforeContentEditableFalse: curry(isNextToContentEditableFalse, 0),
	      isAfterContentEditableFalse: curry(isNextToContentEditableFalse, -1),
	      normalizeRange: normalizeRange
	    };
	  }
	);
	
	/**
	 * CaretWalker.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic for moving around a virtual caret in logical order within a DOM element.
	 *
	 * It ignores the most obvious invalid caret locations such as within a script element or within a
	 * contentEditable=false element but it will return locations that isn't possible to render visually.
	 *
	 * @private
	 * @class tinymce.caret.CaretWalker
	 * @example
	 * var caretWalker = new CaretWalker(rootElm);
	 *
	 * var prevLogicalCaretPosition = caretWalker.prev(CaretPosition.fromRangeStart(range));
	 * var nextLogicalCaretPosition = caretWalker.next(CaretPosition.fromRangeEnd(range));
	 */
	define(
	  'tinymce.core.caret.CaretWalker',
	  [
	    "tinymce.core.dom.NodeType",
	    "tinymce.core.caret.CaretCandidate",
	    "tinymce.core.caret.CaretPosition",
	    "tinymce.core.caret.CaretUtils",
	    "tinymce.core.util.Arr",
	    "tinymce.core.util.Fun"
	  ],
	  function (NodeType, CaretCandidate, CaretPosition, CaretUtils, Arr, Fun) {
	    var isContentEditableFalse = NodeType.isContentEditableFalse,
	      isText = NodeType.isText,
	      isElement = NodeType.isElement,
	      isBr = NodeType.isBr,
	      isForwards = CaretUtils.isForwards,
	      isBackwards = CaretUtils.isBackwards,
	      isCaretCandidate = CaretCandidate.isCaretCandidate,
	      isAtomic = CaretCandidate.isAtomic,
	      isEditableCaretCandidate = CaretCandidate.isEditableCaretCandidate;
	
	    var getParents = function (node, rootNode) {
	      var parents = [];
	
	      while (node && node != rootNode) {
	        parents.push(node);
	        node = node.parentNode;
	      }
	
	      return parents;
	    };
	
	    var nodeAtIndex = function (container, offset) {
	      if (container.hasChildNodes() && offset < container.childNodes.length) {
	        return container.childNodes[offset];
	      }
	
	      return null;
	    };
	
	    var getCaretCandidatePosition = function (direction, node) {
	      if (isForwards(direction)) {
	        if (isCaretCandidate(node.previousSibling) && !isText(node.previousSibling)) {
	          return CaretPosition.before(node);
	        }
	
	        if (isText(node)) {
	          return CaretPosition(node, 0);
	        }
	      }
	
	      if (isBackwards(direction)) {
	        if (isCaretCandidate(node.nextSibling) && !isText(node.nextSibling)) {
	          return CaretPosition.after(node);
	        }
	
	        if (isText(node)) {
	          return CaretPosition(node, node.data.length);
	        }
	      }
	
	      if (isBackwards(direction)) {
	        if (isBr(node)) {
	          return CaretPosition.before(node);
	        }
	
	        return CaretPosition.after(node);
	      }
	
	      return CaretPosition.before(node);
	    };
	
	    // Jumps over BR elements <p>|<br></p><p>a</p> -> <p><br></p><p>|a</p>
	    var isBrBeforeBlock = function (node, rootNode) {
	      var next;
	
	      if (!NodeType.isBr(node)) {
	        return false;
	      }
	
	      next = findCaretPosition(1, CaretPosition.after(node), rootNode);
	      if (!next) {
	        return false;
	      }
	
	      return !CaretUtils.isInSameBlock(CaretPosition.before(node), CaretPosition.before(next), rootNode);
	    };
	
	    var findCaretPosition = function (direction, startCaretPosition, rootNode) {
	      var container, offset, node, nextNode, innerNode,
	        rootContentEditableFalseElm, caretPosition;
	
	      if (!isElement(rootNode) || !startCaretPosition) {
	        return null;
	      }
	
	      if (startCaretPosition.isEqual(CaretPosition.after(rootNode)) && rootNode.lastChild) {
	        caretPosition = CaretPosition.after(rootNode.lastChild);
	        if (isBackwards(direction) && isCaretCandidate(rootNode.lastChild) && isElement(rootNode.lastChild)) {
	          return isBr(rootNode.lastChild) ? CaretPosition.before(rootNode.lastChild) : caretPosition;
	        }
	      } else {
	        caretPosition = startCaretPosition;
	      }
	
	      container = caretPosition.container();
	      offset = caretPosition.offset();
	
	      if (isText(container)) {
	        if (isBackwards(direction) && offset > 0) {
	          return CaretPosition(container, --offset);
	        }
	
	        if (isForwards(direction) && offset < container.length) {
	          return CaretPosition(container, ++offset);
	        }
	
	        node = container;
	      } else {
	        if (isBackwards(direction) && offset > 0) {
	          nextNode = nodeAtIndex(container, offset - 1);
	          if (isCaretCandidate(nextNode)) {
	            if (!isAtomic(nextNode)) {
	              innerNode = CaretUtils.findNode(nextNode, direction, isEditableCaretCandidate, nextNode);
	              if (innerNode) {
	                if (isText(innerNode)) {
	                  return CaretPosition(innerNode, innerNode.data.length);
	                }
	
	                return CaretPosition.after(innerNode);
	              }
	            }
	
	            if (isText(nextNode)) {
	              return CaretPosition(nextNode, nextNode.data.length);
	            }
	
	            return CaretPosition.before(nextNode);
	          }
	        }
	
	        if (isForwards(direction) && offset < container.childNodes.length) {
	          nextNode = nodeAtIndex(container, offset);
	          if (isCaretCandidate(nextNode)) {
	            if (isBrBeforeBlock(nextNode, rootNode)) {
	              return findCaretPosition(direction, CaretPosition.after(nextNode), rootNode);
	            }
	
	            if (!isAtomic(nextNode)) {
	              innerNode = CaretUtils.findNode(nextNode, direction, isEditableCaretCandidate, nextNode);
	              if (innerNode) {
	                if (isText(innerNode)) {
	                  return CaretPosition(innerNode, 0);
	                }
	
	                return CaretPosition.before(innerNode);
	              }
	            }
	
	            if (isText(nextNode)) {
	              return CaretPosition(nextNode, 0);
	            }
	
	            return CaretPosition.after(nextNode);
	          }
	        }
	
	        node = caretPosition.getNode();
	      }
	
	      if ((isForwards(direction) && caretPosition.isAtEnd()) || (isBackwards(direction) && caretPosition.isAtStart())) {
	        node = CaretUtils.findNode(node, direction, Fun.constant(true), rootNode, true);
	        if (isEditableCaretCandidate(node)) {
	          return getCaretCandidatePosition(direction, node);
	        }
	      }
	
	      nextNode = CaretUtils.findNode(node, direction, isEditableCaretCandidate, rootNode);
	
	      rootContentEditableFalseElm = Arr.last(Arr.filter(getParents(container, rootNode), isContentEditableFalse));
	      if (rootContentEditableFalseElm && (!nextNode || !rootContentEditableFalseElm.contains(nextNode))) {
	        if (isForwards(direction)) {
	          caretPosition = CaretPosition.after(rootContentEditableFalseElm);
	        } else {
	          caretPosition = CaretPosition.before(rootContentEditableFalseElm);
	        }
	
	        return caretPosition;
	      }
	
	      if (nextNode) {
	        return getCaretCandidatePosition(direction, nextNode);
	      }
	
	      return null;
	    };
	
	    return function (rootNode) {
	      return {
	        /**
	         * Returns the next logical caret position from the specificed input
	         * caretPoisiton or null if there isn't any more positions left for example
	         * at the end specified root element.
	         *
	         * @method next
	         * @param {tinymce.caret.CaretPosition} caretPosition Caret position to start from.
	         * @return {tinymce.caret.CaretPosition} CaretPosition or null if no position was found.
	         */
	        next: function (caretPosition) {
	          return findCaretPosition(1, caretPosition, rootNode);
	        },
	
	        /**
	         * Returns the previous logical caret position from the specificed input
	         * caretPoisiton or null if there isn't any more positions left for example
	         * at the end specified root element.
	         *
	         * @method prev
	         * @param {tinymce.caret.CaretPosition} caretPosition Caret position to start from.
	         * @return {tinymce.caret.CaretPosition} CaretPosition or null if no position was found.
	         */
	        prev: function (caretPosition) {
	          return findCaretPosition(-1, caretPosition, rootNode);
	        }
	      };
	    };
	  }
	);
	/**
	 * InsertList.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Handles inserts of lists into the editor instance.
	 *
	 * @class tinymce.InsertList
	 * @private
	 */
	define(
	  'tinymce.core.InsertList',
	  [
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.caret.CaretWalker',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.util.Tools'
	  ],
	  function (CaretPosition, CaretWalker, NodeType, Tools) {
	    var hasOnlyOneChild = function (node) {
	      return node.firstChild && node.firstChild === node.lastChild;
	    };
	
	    var isPaddingNode = function (node) {
	      return node.name === 'br' || node.value === '\u00a0';
	    };
	
	    var isPaddedEmptyBlock = function (schema, node) {
	      var blockElements = schema.getBlockElements();
	      return blockElements[node.name] && hasOnlyOneChild(node) && isPaddingNode(node.firstChild);
	    };
	
	    var isEmptyFragmentElement = function (schema, node) {
	      var nonEmptyElements = schema.getNonEmptyElements();
	      return node && (node.isEmpty(nonEmptyElements) || isPaddedEmptyBlock(schema, node));
	    };
	
	    var isListFragment = function (schema, fragment) {
	      var firstChild = fragment.firstChild;
	      var lastChild = fragment.lastChild;
	
	      // Skip meta since it's likely <meta><ul>..</ul>
	      if (firstChild && firstChild.name === 'meta') {
	        firstChild = firstChild.next;
	      }
	
	      // Skip mce_marker since it's likely <ul>..</ul><span id="mce_marker"></span>
	      if (lastChild && lastChild.attr('id') === 'mce_marker') {
	        lastChild = lastChild.prev;
	      }
	
	      // Skip last child if it's an empty block
	      if (isEmptyFragmentElement(schema, lastChild)) {
	        lastChild = lastChild.prev;
	      }
	
	      if (!firstChild || firstChild !== lastChild) {
	        return false;
	      }
	
	      return firstChild.name === 'ul' || firstChild.name === 'ol';
	    };
	
	    var cleanupDomFragment = function (domFragment) {
	      var firstChild = domFragment.firstChild;
	      var lastChild = domFragment.lastChild;
	
	      // TODO: remove the meta tag from paste logic
	      if (firstChild && firstChild.nodeName === 'META') {
	        firstChild.parentNode.removeChild(firstChild);
	      }
	
	      if (lastChild && lastChild.id === 'mce_marker') {
	        lastChild.parentNode.removeChild(lastChild);
	      }
	
	      return domFragment;
	    };
	
	    var toDomFragment = function (dom, serializer, fragment) {
	      var html = serializer.serialize(fragment);
	      var domFragment = dom.createFragment(html);
	
	      return cleanupDomFragment(domFragment);
	    };
	
	    var listItems = function (elm) {
	      return Tools.grep(elm.childNodes, function (child) {
	        return child.nodeName === 'LI';
	      });
	    };
	
	    var isPadding = function (node) {
	      return node.data === '\u00a0' || NodeType.isBr(node);
	    };
	
	    var isListItemPadded = function (node) {
	      return node && node.firstChild && node.firstChild === node.lastChild && isPadding(node.firstChild);
	    };
	
	    var isEmptyOrPadded = function (elm) {
	      return !elm.firstChild || isListItemPadded(elm);
	    };
	
	    var trimListItems = function (elms) {
	      return elms.length > 0 && isEmptyOrPadded(elms[elms.length - 1]) ? elms.slice(0, -1) : elms;
	    };
	
	    var getParentLi = function (dom, node) {
	      var parentBlock = dom.getParent(node, dom.isBlock);
	      return parentBlock && parentBlock.nodeName === 'LI' ? parentBlock : null;
	    };
	
	    var isParentBlockLi = function (dom, node) {
	      return !!getParentLi(dom, node);
	    };
	
	    var getSplit = function (parentNode, rng) {
	      var beforeRng = rng.cloneRange();
	      var afterRng = rng.cloneRange();
	
	      beforeRng.setStartBefore(parentNode);
	      afterRng.setEndAfter(parentNode);
	
	      return [
	        beforeRng.cloneContents(),
	        afterRng.cloneContents()
	      ];
	    };
	
	    var findFirstIn = function (node, rootNode) {
	      var caretPos = CaretPosition.before(node);
	      var caretWalker = new CaretWalker(rootNode);
	      var newCaretPos = caretWalker.next(caretPos);
	
	      return newCaretPos ? newCaretPos.toRange() : null;
	    };
	
	    var findLastOf = function (node, rootNode) {
	      var caretPos = CaretPosition.after(node);
	      var caretWalker = new CaretWalker(rootNode);
	      var newCaretPos = caretWalker.prev(caretPos);
	
	      return newCaretPos ? newCaretPos.toRange() : null;
	    };
	
	    var insertMiddle = function (target, elms, rootNode, rng) {
	      var parts = getSplit(target, rng);
	      var parentElm = target.parentNode;
	
	      parentElm.insertBefore(parts[0], target);
	      Tools.each(elms, function (li) {
	        parentElm.insertBefore(li, target);
	      });
	      parentElm.insertBefore(parts[1], target);
	      parentElm.removeChild(target);
	
	      return findLastOf(elms[elms.length - 1], rootNode);
	    };
	
	    var insertBefore = function (target, elms, rootNode) {
	      var parentElm = target.parentNode;
	
	      Tools.each(elms, function (elm) {
	        parentElm.insertBefore(elm, target);
	      });
	
	      return findFirstIn(target, rootNode);
	    };
	
	    var insertAfter = function (target, elms, rootNode, dom) {
	      dom.insertAfter(elms.reverse(), target);
	      return findLastOf(elms[0], rootNode);
	    };
	
	    var insertAtCaret = function (serializer, dom, rng, fragment) {
	      var domFragment = toDomFragment(dom, serializer, fragment);
	      var liTarget = getParentLi(dom, rng.startContainer);
	      var liElms = trimListItems(listItems(domFragment.firstChild));
	      var BEGINNING = 1, END = 2;
	      var rootNode = dom.getRoot();
	
	      var isAt = function (location) {
	        var caretPos = CaretPosition.fromRangeStart(rng);
	        var caretWalker = new CaretWalker(dom.getRoot());
	        var newPos = location === BEGINNING ? caretWalker.prev(caretPos) : caretWalker.next(caretPos);
	
	        return newPos ? getParentLi(dom, newPos.getNode()) !== liTarget : true;
	      };
	
	      if (isAt(BEGINNING)) {
	        return insertBefore(liTarget, liElms, rootNode);
	      } else if (isAt(END)) {
	        return insertAfter(liTarget, liElms, rootNode, dom);
	      }
	
	      return insertMiddle(liTarget, liElms, rootNode, rng);
	    };
	
	    return {
	      isListFragment: isListFragment,
	      insertAtCaret: insertAtCaret,
	      isParentBlockLi: isParentBlockLi,
	      trimListItems: trimListItems,
	      listItems: listItems
	    };
	  }
	);
	/**
	 * CaretBookmark.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module creates or resolves xpath like string representation of a CaretPositions.
	 *
	 * The format is a / separated list of chunks with:
	 * <element|text()>[index|after|before]
	 *
	 * For example:
	 *  p[0]/b[0]/text()[0],1 = <p><b>a|c</b></p>
	 *  p[0]/img[0],before = <p>|<img></p>
	 *  p[0]/img[0],after = <p><img>|</p>
	 *
	 * @private
	 * @static
	 * @class tinymce.caret.CaretBookmark
	 * @example
	 * var bookmark = CaretBookmark.create(rootElm, CaretPosition.before(rootElm.firstChild));
	 * var caretPosition = CaretBookmark.resolve(bookmark);
	 */
	define(
	  'tinymce.core.caret.CaretBookmark',
	  [
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.util.Fun',
	    'tinymce.core.util.Arr',
	    'tinymce.core.caret.CaretPosition'
	  ],
	  function (NodeType, DomUtils, Fun, Arr, CaretPosition) {
	    var isText = NodeType.isText,
	      isBogus = NodeType.isBogus,
	      nodeIndex = DomUtils.nodeIndex;
	
	    var normalizedParent = function (node) {
	      var parentNode = node.parentNode;
	
	      if (isBogus(parentNode)) {
	        return normalizedParent(parentNode);
	      }
	
	      return parentNode;
	    };
	
	    var getChildNodes = function (node) {
	      if (!node) {
	        return [];
	      }
	
	      return Arr.reduce(node.childNodes, function (result, node) {
	        if (isBogus(node) && node.nodeName != 'BR') {
	          result = result.concat(getChildNodes(node));
	        } else {
	          result.push(node);
	        }
	
	        return result;
	      }, []);
	    };
	
	    var normalizedTextOffset = function (textNode, offset) {
	      while ((textNode = textNode.previousSibling)) {
	        if (!isText(textNode)) {
	          break;
	        }
	
	        offset += textNode.data.length;
	      }
	
	      return offset;
	    };
	
	    var equal = function (targetValue) {
	      return function (value) {
	        return targetValue === value;
	      };
	    };
	
	    var normalizedNodeIndex = function (node) {
	      var nodes, index, numTextFragments;
	
	      nodes = getChildNodes(normalizedParent(node));
	      index = Arr.findIndex(nodes, equal(node), node);
	      nodes = nodes.slice(0, index + 1);
	      numTextFragments = Arr.reduce(nodes, function (result, node, i) {
	        if (isText(node) && isText(nodes[i - 1])) {
	          result++;
	        }
	
	        return result;
	      }, 0);
	
	      nodes = Arr.filter(nodes, NodeType.matchNodeNames(node.nodeName));
	      index = Arr.findIndex(nodes, equal(node), node);
	
	      return index - numTextFragments;
	    };
	
	    var createPathItem = function (node) {
	      var name;
	
	      if (isText(node)) {
	        name = 'text()';
	      } else {
	        name = node.nodeName.toLowerCase();
	      }
	
	      return name + '[' + normalizedNodeIndex(node) + ']';
	    };
	
	    var parentsUntil = function (rootNode, node, predicate) {
	      var parents = [];
	
	      for (node = node.parentNode; node != rootNode; node = node.parentNode) {
	        if (predicate && predicate(node)) {
	          break;
	        }
	
	        parents.push(node);
	      }
	
	      return parents;
	    };
	
	    var create = function (rootNode, caretPosition) {
	      var container, offset, path = [],
	        outputOffset, childNodes, parents;
	
	      container = caretPosition.container();
	      offset = caretPosition.offset();
	
	      if (isText(container)) {
	        outputOffset = normalizedTextOffset(container, offset);
	      } else {
	        childNodes = container.childNodes;
	        if (offset >= childNodes.length) {
	          outputOffset = 'after';
	          offset = childNodes.length - 1;
	        } else {
	          outputOffset = 'before';
	        }
	
	        container = childNodes[offset];
	      }
	
	      path.push(createPathItem(container));
	      parents = parentsUntil(rootNode, container);
	      parents = Arr.filter(parents, Fun.negate(NodeType.isBogus));
	      path = path.concat(Arr.map(parents, function (node) {
	        return createPathItem(node);
	      }));
	
	      return path.reverse().join('/') + ',' + outputOffset;
	    };
	
	    var resolvePathItem = function (node, name, index) {
	      var nodes = getChildNodes(node);
	
	      nodes = Arr.filter(nodes, function (node, index) {
	        return !isText(node) || !isText(nodes[index - 1]);
	      });
	
	      nodes = Arr.filter(nodes, NodeType.matchNodeNames(name));
	      return nodes[index];
	    };
	
	    var findTextPosition = function (container, offset) {
	      var node = container, targetOffset = 0, dataLen;
	
	      while (isText(node)) {
	        dataLen = node.data.length;
	
	        if (offset >= targetOffset && offset <= targetOffset + dataLen) {
	          container = node;
	          offset = offset - targetOffset;
	          break;
	        }
	
	        if (!isText(node.nextSibling)) {
	          container = node;
	          offset = dataLen;
	          break;
	        }
	
	        targetOffset += dataLen;
	        node = node.nextSibling;
	      }
	
	      if (offset > container.data.length) {
	        offset = container.data.length;
	      }
	
	      return new CaretPosition(container, offset);
	    };
	
	    var resolve = function (rootNode, path) {
	      var parts, container, offset;
	
	      if (!path) {
	        return null;
	      }
	
	      parts = path.split(',');
	      path = parts[0].split('/');
	      offset = parts.length > 1 ? parts[1] : 'before';
	
	      container = Arr.reduce(path, function (result, value) {
	        value = /([\w\-\(\)]+)\[([0-9]+)\]/.exec(value);
	        if (!value) {
	          return null;
	        }
	
	        if (value[1] === 'text()') {
	          value[1] = '#text';
	        }
	
	        return resolvePathItem(result, value[1], parseInt(value[2], 10));
	      }, rootNode);
	
	      if (!container) {
	        return null;
	      }
	
	      if (!isText(container)) {
	        if (offset === 'after') {
	          offset = nodeIndex(container) + 1;
	        } else {
	          offset = nodeIndex(container);
	        }
	
	        return new CaretPosition(container.parentNode, offset);
	      }
	
	      return findTextPosition(container, parseInt(offset, 10));
	    };
	
	    return {
	      /**
	       * Create a xpath bookmark location for the specified caret position.
	       *
	       * @method create
	       * @param {Node} rootNode Root node to create bookmark within.
	       * @param {tinymce.caret.CaretPosition} caretPosition Caret position within the root node.
	       * @return {String} String xpath like location of caret position.
	       */
	      create: create,
	
	      /**
	       * Resolves a xpath like bookmark location to the a caret position.
	       *
	       * @method resolve
	       * @param {Node} rootNode Root node to resolve xpath bookmark within.
	       * @param {String} bookmark Bookmark string to resolve.
	       * @return {tinymce.caret.CaretPosition} Caret position resolved from xpath like bookmark.
	       */
	      resolve: resolve
	    };
	  }
	);
	/**
	 * GetBookmark.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.GetBookmark',
	  [
	    'ephox.katamari.api.Fun',
	    'tinymce.core.caret.CaretBookmark',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.selection.RangeNodes',
	    'tinymce.core.text.Zwsp',
	    'tinymce.core.util.Tools'
	  ],
	  function (Fun, CaretBookmark, CaretContainer, CaretPosition, NodeType, RangeNodes, Zwsp, Tools) {
	    var isContentEditableFalse = NodeType.isContentEditableFalse;
	
	    var getNormalizedTextOffset = function (trim, container, offset) {
	      var node, trimmedOffset;
	
	      trimmedOffset = trim(container.data.slice(0, offset)).length;
	      for (node = container.previousSibling; node && NodeType.isText(node); node = node.previousSibling) {
	        trimmedOffset += trim(node.data).length;
	      }
	
	      return trimmedOffset;
	    };
	
	    var getPoint = function (dom, trim, normalized, rng, start) {
	      var container = rng[start ? 'startContainer' : 'endContainer'];
	      var offset = rng[start ? 'startOffset' : 'endOffset'], point = [], childNodes, after = 0;
	      var root = dom.getRoot();
	
	      if (NodeType.isText(container)) {
	        point.push(normalized ? getNormalizedTextOffset(trim, container, offset) : offset);
	      } else {
	        childNodes = container.childNodes;
	
	        if (offset >= childNodes.length && childNodes.length) {
	          after = 1;
	          offset = Math.max(0, childNodes.length - 1);
	        }
	
	        point.push(dom.nodeIndex(childNodes[offset], normalized) + after);
	      }
	
	      for (; container && container !== root; container = container.parentNode) {
	        point.push(dom.nodeIndex(container, normalized));
	      }
	
	      return point;
	    };
	
	    var getLocation = function (trim, selection, normalized, rng) {
	      var dom = selection.dom, bookmark = {};
	
	      bookmark.start = getPoint(dom, trim, normalized, rng, true);
	
	      if (!selection.isCollapsed()) {
	        bookmark.end = getPoint(dom, trim, normalized, rng, false);
	      }
	
	      return bookmark;
	    };
	
	    var trimEmptyTextNode = function (node) {
	      if (NodeType.isText(node) && node.data.length === 0) {
	        node.parentNode.removeChild(node);
	      }
	    };
	
	    var findIndex = function (dom, name, element) {
	      var count = 0;
	
	      Tools.each(dom.select(name), function (node) {
	        if (node.getAttribute('data-mce-bogus') === 'all') {
	          return;
	        }
	
	        if (node === element) {
	          return false;
	        }
	
	        count++;
	      });
	
	      return count;
	    };
	
	    var moveEndPoint = function (rng, start) {
	      var container, offset, childNodes, prefix = start ? 'start' : 'end';
	
	      container = rng[prefix + 'Container'];
	      offset = rng[prefix + 'Offset'];
	
	      if (NodeType.isElement(container) && container.nodeName === 'TR') {
	        childNodes = container.childNodes;
	        container = childNodes[Math.min(start ? offset : offset - 1, childNodes.length - 1)];
	        if (container) {
	          offset = start ? 0 : container.childNodes.length;
	          rng['set' + (start ? 'Start' : 'End')](container, offset);
	        }
	      }
	    };
	
	    var normalizeTableCellSelection = function (rng) {
	      moveEndPoint(rng, true);
	      moveEndPoint(rng, false);
	
	      return rng;
	    };
	
	    var findSibling = function (node, offset) {
	      var sibling;
	
	      if (NodeType.isElement(node)) {
	        node = RangeNodes.getNode(node, offset);
	        if (isContentEditableFalse(node)) {
	          return node;
	        }
	      }
	
	      if (CaretContainer.isCaretContainer(node)) {
	        if (NodeType.isText(node) && CaretContainer.isCaretContainerBlock(node)) {
	          node = node.parentNode;
	        }
	
	        sibling = node.previousSibling;
	        if (isContentEditableFalse(sibling)) {
	          return sibling;
	        }
	
	        sibling = node.nextSibling;
	        if (isContentEditableFalse(sibling)) {
	          return sibling;
	        }
	      }
	    };
	
	    var findAdjacentContentEditableFalseElm = function (rng) {
	      return findSibling(rng.startContainer, rng.startOffset) || findSibling(rng.endContainer, rng.endOffset);
	    };
	
	    var getOffsetBookmark = function (trim, normalized, selection) {
	      var element = selection.getNode();
	      var name = element ? element.nodeName : null;
	      var rng = selection.getRng();
	
	      if (isContentEditableFalse(element) || name === 'IMG') {
	        return { name: name, index: findIndex(selection.dom, name, element) };
	      }
	
	      element = findAdjacentContentEditableFalseElm(rng);
	      if (element) {
	        name = element.tagName;
	        return { name: name, index: findIndex(selection.dom, name, element) };
	      }
	
	      return getLocation(trim, selection, normalized, rng);
	    };
	
	    var getCaretBookmark = function (selection) {
	      var rng = selection.getRng();
	
	      return {
	        start: CaretBookmark.create(selection.dom.getRoot(), CaretPosition.fromRangeStart(rng)),
	        end: CaretBookmark.create(selection.dom.getRoot(), CaretPosition.fromRangeEnd(rng))
	      };
	    };
	
	    var getRangeBookmark = function (selection) {
	      return { rng: selection.getRng() };
	    };
	
	    var getPersistentBookmark = function (selection) {
	      var dom = selection.dom;
	      var rng = selection.getRng();
	      var id = dom.uniqueId();
	      var collapsed = selection.isCollapsed();
	      var styles = 'overflow:hidden;line-height:0px';
	      var element = selection.getNode();
	      var name = element.nodeName;
	      var chr = '&#xFEFF;';
	
	      if (name === 'IMG') {
	        return { name: name, index: findIndex(dom, name, element) };
	      }
	
	      // W3C method
	      var rng2 = normalizeTableCellSelection(rng.cloneRange());
	
	      // Insert end marker
	      if (!collapsed) {
	        rng2.collapse(false);
	        var endBookmarkNode = dom.create('span', { 'data-mce-type': 'bookmark', id: id + '_end', style: styles }, chr);
	        rng2.insertNode(endBookmarkNode);
	        trimEmptyTextNode(endBookmarkNode.nextSibling);
	      }
	
	      rng = normalizeTableCellSelection(rng);
	      rng.collapse(true);
	      var startBookmarkNode = dom.create('span', { 'data-mce-type': 'bookmark', id: id + '_start', style: styles }, chr);
	      rng.insertNode(startBookmarkNode);
	      trimEmptyTextNode(startBookmarkNode.previousSibling);
	
	      selection.moveToBookmark({ id: id, keep: 1 });
	
	      return { id: id };
	    };
	
	    var getBookmark = function (selection, type, normalized) {
	      if (type === 2) {
	        return getOffsetBookmark(Zwsp.trim, normalized, selection);
	      } else if (type === 3) {
	        return getCaretBookmark(selection);
	      } else if (type) {
	        return getRangeBookmark(selection);
	      } else {
	        return getPersistentBookmark(selection);
	      }
	    };
	
	    return {
	      getBookmark: getBookmark,
	      getUndoBookmark: Fun.curry(getOffsetBookmark, Fun.identity, true)
	    };
	  }
	);
	define(
	  'ephox.katamari.api.Options',
	
	  [
	    'ephox.katamari.api.Option'
	  ],
	
	  function (Option) {
	    /** cat :: [Option a] -> [a] */
	    var cat = function (arr) {
	      var r = [];
	      var push = function (x) {
	        r.push(x);
	      };
	      for (var i = 0; i < arr.length; i++) {
	        arr[i].each(push);
	      }
	      return r;
	    };
	
	    /** findMap :: ([a], (a, Int -> Option b)) -> Option b */
	    var findMap = function (arr, f) {
	      for (var i = 0; i < arr.length; i++) {
	        var r = f(arr[i], i);
	        if (r.isSome()) {
	          return r;
	        }
	      }
	      return Option.none();
	    };
	
	    /**
	     * if all elements in arr are 'some', their inner values are passed as arguments to f
	     * f must have arity arr.length
	    */
	    var liftN = function(arr, f) {
	      var r = [];
	      for (var i = 0; i < arr.length; i++) {
	        var x = arr[i];
	        if (x.isSome()) {
	          r.push(x.getOrDie());
	        } else {
	          return Option.none();
	        }
	      }
	      return Option.some(f.apply(null, r));
	    };
	
	    return {
	      cat: cat,
	      findMap: findMap,
	      liftN: liftN
	    };
	  }
	);
	
	/**
	 * ResolveBookmark.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.ResolveBookmark',
	  [
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Options',
	    'tinymce.core.Env',
	    'tinymce.core.caret.CaretBookmark',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.util.Tools'
	  ],
	  function (Option, Options, Env, CaretBookmark, CaretPosition, NodeType, Tools) {
	    var addBogus = function (dom, node) {
	      // Adds a bogus BR element for empty block elements
	      if (dom.isBlock(node) && !node.innerHTML && !Env.ie) {
	        node.innerHTML = '<br data-mce-bogus="1" />';
	      }
	
	      return node;
	    };
	
	    var resolveCaretPositionBookmark = function (dom, bookmark) {
	      var rng, pos;
	
	      rng = dom.createRng();
	      pos = CaretBookmark.resolve(dom.getRoot(), bookmark.start);
	      rng.setStart(pos.container(), pos.offset());
	
	      pos = CaretBookmark.resolve(dom.getRoot(), bookmark.end);
	      rng.setEnd(pos.container(), pos.offset());
	
	      return rng;
	    };
	
	    var setEndPoint = function (dom, start, bookmark, rng) {
	      var point = bookmark[start ? 'start' : 'end'], i, node, offset, children, root = dom.getRoot();
	
	      if (point) {
	        offset = point[0];
	
	        // Find container node
	        for (node = root, i = point.length - 1; i >= 1; i--) {
	          children = node.childNodes;
	
	          if (point[i] > children.length - 1) {
	            return;
	          }
	
	          node = children[point[i]];
	        }
	
	        // Move text offset to best suitable location
	        if (node.nodeType === 3) {
	          offset = Math.min(point[0], node.nodeValue.length);
	        }
	
	        // Move element offset to best suitable location
	        if (node.nodeType === 1) {
	          offset = Math.min(point[0], node.childNodes.length);
	        }
	
	        // Set offset within container node
	        if (start) {
	          rng.setStart(node, offset);
	        } else {
	          rng.setEnd(node, offset);
	        }
	      }
	
	      return true;
	    };
	
	    var restoreEndPoint = function (dom, suffix, bookmark) {
	      var marker = dom.get(bookmark.id + '_' + suffix), node, idx, next, prev, keep = bookmark.keep;
	      var container, offset;
	
	      if (marker) {
	        node = marker.parentNode;
	
	        if (suffix === 'start') {
	          if (!keep) {
	            idx = dom.nodeIndex(marker);
	          } else {
	            node = marker.firstChild;
	            idx = 1;
	          }
	
	          container = node;
	          offset = idx;
	        } else {
	          if (!keep) {
	            idx = dom.nodeIndex(marker);
	          } else {
	            node = marker.firstChild;
	            idx = 1;
	          }
	
	          container = node;
	          offset = idx;
	        }
	
	        if (!keep) {
	          prev = marker.previousSibling;
	          next = marker.nextSibling;
	
	          // Remove all marker text nodes
	          Tools.each(Tools.grep(marker.childNodes), function (node) {
	            if (NodeType.isText(node)) {
	              node.nodeValue = node.nodeValue.replace(/\uFEFF/g, '');
	            }
	          });
	
	          // Remove marker but keep children if for example contents where inserted into the marker
	          // Also remove duplicated instances of the marker for example by a
	          // split operation or by WebKit auto split on paste feature
	          while ((marker = dom.get(bookmark.id + '_' + suffix))) {
	            dom.remove(marker, 1);
	          }
	
	          // If siblings are text nodes then merge them unless it's Opera since it some how removes the node
	          // and we are sniffing since adding a lot of detection code for a browser with 3% of the market
	          // isn't worth the effort. Sorry, Opera but it's just a fact
	          if (prev && next && prev.nodeType === next.nodeType && NodeType.isText(prev) && !Env.opera) {
	            idx = prev.nodeValue.length;
	            prev.appendData(next.nodeValue);
	            dom.remove(next);
	
	            if (suffix === 'start') {
	              container = prev;
	              offset = idx;
	            } else {
	              container = prev;
	              offset = idx;
	            }
	          }
	        }
	
	        return Option.some(CaretPosition(container, offset));
	      } else {
	        return Option.none();
	      }
	    };
	
	    var alt = function (o1, o2) {
	      return o1.isSome() ? o1 : o2;
	    };
	
	    var resolvePaths = function (dom, bookmark) {
	      var rng = dom.createRng();
	
	      if (setEndPoint(dom, true, bookmark, rng) && setEndPoint(dom, false, bookmark, rng)) {
	        return Option.some(rng);
	      } else {
	        return Option.none();
	      }
	    };
	
	    var resolveId = function (dom, bookmark) {
	      var startPos = restoreEndPoint(dom, 'start', bookmark);
	      var endPos = restoreEndPoint(dom, 'end', bookmark);
	
	      return Options.liftN([
	        startPos,
	        alt(endPos, startPos)
	      ], function (spos, epos) {
	        var rng = dom.createRng();
	        rng.setStart(addBogus(dom, spos.container()), spos.offset());
	        rng.setEnd(addBogus(dom, epos.container()), epos.offset());
	        return rng;
	      });
	    };
	
	    var resolveIndex = function (dom, bookmark) {
	      return Option.from(dom.select(bookmark.name)[bookmark.index]).map(function (elm) {
	        var rng = dom.createRng();
	        rng.selectNode(elm);
	        return rng;
	      });
	    };
	
	    var resolve = function (selection, bookmark) {
	      var dom = selection.dom;
	
	      if (bookmark) {
	        if (Tools.isArray(bookmark.start)) {
	          return resolvePaths(dom, bookmark);
	        } else if (typeof bookmark.start === 'string') {
	          return Option.some(resolveCaretPositionBookmark(dom, bookmark));
	        } else if (bookmark.id) {
	          return resolveId(dom, bookmark);
	        } else if (bookmark.name) {
	          return resolveIndex(dom, bookmark);
	        } else if (bookmark.rng) {
	          return Option.some(bookmark.rng);
	        }
	      }
	
	      return Option.none();
	    };
	
	    return {
	      resolve: resolve
	    };
	  }
	);
	/**
	 * Bookmarks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.Bookmarks',
	  [
	    'tinymce.core.dom.GetBookmark',
	    'tinymce.core.dom.ResolveBookmark'
	  ],
	  function (GetBookmark, ResolveBookmark) {
	    var getBookmark = function (selection, type, normalized) {
	      return GetBookmark.getBookmark(selection, type, normalized);
	    };
	
	    var moveToBookmark = function (selection, bookmark) {
	      ResolveBookmark.resolve(selection, bookmark).each(function (rng) {
	        selection.setRng(rng);
	      });
	    };
	
	    var isBookmarkNode = function (node) {
	      return node && node.tagName === 'SPAN' && node.getAttribute('data-mce-type') === 'bookmark';
	    };
	
	    return {
	      getBookmark: getBookmark,
	      moveToBookmark: moveToBookmark,
	      isBookmarkNode: isBookmarkNode
	    };
	  }
	);
	/**
	 * ElementUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility class for various element specific functions.
	 *
	 * @private
	 * @class tinymce.dom.ElementUtils
	 */
	define(
	  'tinymce.core.dom.ElementUtils',
	  [
	    "tinymce.core.dom.Bookmarks",
	    "tinymce.core.util.Tools"
	  ],
	  function (Bookmarks, Tools) {
	    var each = Tools.each;
	
	    var ElementUtils = function (dom) {
	      /**
	       * Compares two nodes and checks if it's attributes and styles matches.
	       * This doesn't compare classes as items since their order is significant.
	       *
	       * @method compare
	       * @param {Node} node1 First node to compare with.
	       * @param {Node} node2 Second node to compare with.
	       * @return {boolean} True/false if the nodes are the same or not.
	       */
	      this.compare = function (node1, node2) {
	        // Not the same name
	        if (node1.nodeName != node2.nodeName) {
	          return false;
	        }
	
	        /**
	         * Returns all the nodes attributes excluding internal ones, styles and classes.
	         *
	         * @private
	         * @param {Node} node Node to get attributes from.
	         * @return {Object} Name/value object with attributes and attribute values.
	         */
	        var getAttribs = function (node) {
	          var attribs = {};
	
	          each(dom.getAttribs(node), function (attr) {
	            var name = attr.nodeName.toLowerCase();
	
	            // Don't compare internal attributes or style
	            if (name.indexOf('_') !== 0 && name !== 'style' && name.indexOf('data-') !== 0) {
	              attribs[name] = dom.getAttrib(node, name);
	            }
	          });
	
	          return attribs;
	        };
	
	        /**
	         * Compares two objects checks if it's key + value exists in the other one.
	         *
	         * @private
	         * @param {Object} obj1 First object to compare.
	         * @param {Object} obj2 Second object to compare.
	         * @return {boolean} True/false if the objects matches or not.
	         */
	        var compareObjects = function (obj1, obj2) {
	          var value, name;
	
	          for (name in obj1) {
	            // Obj1 has item obj2 doesn't have
	            if (obj1.hasOwnProperty(name)) {
	              value = obj2[name];
	
	              // Obj2 doesn't have obj1 item
	              if (typeof value == "undefined") {
	                return false;
	              }
	
	              // Obj2 item has a different value
	              if (obj1[name] != value) {
	                return false;
	              }
	
	              // Delete similar value
	              delete obj2[name];
	            }
	          }
	
	          // Check if obj 2 has something obj 1 doesn't have
	          for (name in obj2) {
	            // Obj2 has item obj1 doesn't have
	            if (obj2.hasOwnProperty(name)) {
	              return false;
	            }
	          }
	
	          return true;
	        };
	
	        // Attribs are not the same
	        if (!compareObjects(getAttribs(node1), getAttribs(node2))) {
	          return false;
	        }
	
	        // Styles are not the same
	        if (!compareObjects(dom.parseStyle(dom.getAttrib(node1, 'style')), dom.parseStyle(dom.getAttrib(node2, 'style')))) {
	          return false;
	        }
	
	        return !Bookmarks.isBookmarkNode(node1) && !Bookmarks.isBookmarkNode(node2);
	      };
	    };
	
	    return ElementUtils;
	  }
	);
	
	define(
	  'ephox.sugar.api.dom.Insert',
	
	  [
	    'ephox.sugar.api.search.Traverse'
	  ],
	
	  function (Traverse) {
	    var before = function (marker, element) {
	      var parent = Traverse.parent(marker);
	      parent.each(function (v) {
	        v.dom().insertBefore(element.dom(), marker.dom());
	      });
	    };
	
	    var after = function (marker, element) {
	      var sibling = Traverse.nextSibling(marker);
	      sibling.fold(function () {
	        var parent = Traverse.parent(marker);
	        parent.each(function (v) {
	          append(v, element);
	        });
	      }, function (v) {
	        before(v, element);
	      });
	    };
	
	    var prepend = function (parent, element) {
	      var firstChild = Traverse.firstChild(parent);
	      firstChild.fold(function () {
	        append(parent, element);
	      }, function (v) {
	        parent.dom().insertBefore(element.dom(), v.dom());
	      });
	    };
	
	    var append = function (parent, element) {
	      parent.dom().appendChild(element.dom());
	    };
	
	    var appendAt = function (parent, element, index) {
	      Traverse.child(parent, index).fold(function () {
	        append(parent, element);
	      }, function (v) {
	        before(v, element);
	      });
	    };
	
	    var wrap = function (element, wrapper) {
	      before(element, wrapper);
	      append(wrapper, element);
	    };
	
	    return {
	      before: before,
	      after: after,
	      prepend: prepend,
	      append: append,
	      appendAt: appendAt,
	      wrap: wrap
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.dom.InsertAll',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.dom.Insert'
	  ],
	
	  function (Arr, Insert) {
	    var before = function (marker, elements) {
	      Arr.each(elements, function (x) {
	        Insert.before(marker, x);
	      });
	    };
	
	    var after = function (marker, elements) {
	      Arr.each(elements, function (x, i) {
	        var e = i === 0 ? marker : elements[i - 1];
	        Insert.after(e, x);
	      });
	    };
	
	    var prepend = function (parent, elements) {
	      Arr.each(elements.slice().reverse(), function (x) {
	        Insert.prepend(parent, x);
	      });
	    };
	
	    var append = function (parent, elements) {
	      Arr.each(elements, function (x) {
	        Insert.append(parent, x);
	      });
	    };
	
	    return {
	      before: before,
	      after: after,
	      prepend: prepend,
	      append: append
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.dom.Remove',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.dom.InsertAll',
	    'ephox.sugar.api.search.Traverse'
	  ],
	
	  function (Arr, InsertAll, Traverse) {
	    var empty = function (element) {
	      // shortcut "empty node" trick. Requires IE 9.
	      element.dom().textContent = '';
	
	      // If the contents was a single empty text node, the above doesn't remove it. But, it's still faster in general
	      // than removing every child node manually.
	      // The following is (probably) safe for performance as 99.9% of the time the trick works and
	      // Traverse.children will return an empty array.
	      Arr.each(Traverse.children(element), function (rogue) {
	        remove(rogue);
	      });
	    };
	
	    var remove = function (element) {
	      var dom = element.dom();
	      if (dom.parentNode !== null)
	        dom.parentNode.removeChild(dom);
	    };
	
	    var unwrap = function (wrapper) {
	      var children = Traverse.children(wrapper);
	      if (children.length > 0)
	        InsertAll.before(wrapper, children);
	      remove(wrapper);
	    };
	
	    return {
	      empty: empty,
	      remove: remove,
	      unwrap: unwrap
	    };
	  }
	);
	
	define(
	  'ephox.sugar.impl.NodeValue',
	
	  [
	    'ephox.sand.api.PlatformDetection',
	    'ephox.katamari.api.Option',
	    'global!Error'
	  ],
	
	  function (PlatformDetection, Option, Error) {
	    return function (is, name) {
	      var get = function (element) {
	        if (!is(element)) throw new Error('Can only get ' + name + ' value of a ' + name + ' node');
	        return getOption(element).getOr('');
	      };
	
	      var getOptionIE10 = function (element) {
	        // Prevent IE10 from throwing exception when setting parent innerHTML clobbers (TBIO-451).
	        try {
	          return getOptionSafe(element);
	        } catch (e) {
	          return Option.none();
	        }
	      };
	
	      var getOptionSafe = function (element) {
	        return is(element) ? Option.from(element.dom().nodeValue) : Option.none();
	      };
	
	      var browser = PlatformDetection.detect().browser;
	      var getOption = browser.isIE() && browser.version.major === 10 ? getOptionIE10 : getOptionSafe;
	
	      var set = function (element, value) {
	        if (!is(element)) throw new Error('Can only set raw ' + name + ' value of a ' + name + ' node');
	        element.dom().nodeValue = value;
	      };
	
	      return {
	        get: get,
	        getOption: getOption,
	        set: set
	      };
	    };
	  }
	);
	define(
	  'ephox.sugar.api.node.Text',
	
	  [
	    'ephox.sugar.api.node.Node',
	    'ephox.sugar.impl.NodeValue'
	  ],
	
	  function (Node, NodeValue) {
	    var api = NodeValue(Node.isText, 'text');
	
	    var get = function (element) {
	      return api.get(element);
	    };
	
	    var getOption = function (element) {
	      return api.getOption(element);
	    };
	
	    var set = function (element, value) {
	      api.set(element, value);
	    };
	
	    return {
	      get: get,
	      getOption: getOption,
	      set: set
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.search.PredicateFilter',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.node.Body',
	    'ephox.sugar.api.search.Traverse'
	  ],
	
	  function (Arr, Body, Traverse) {
	    // maybe TraverseWith, similar to traverse but with a predicate?
	
	    var all = function (predicate) {
	      return descendants(Body.body(), predicate);
	    };
	
	    var ancestors = function (scope, predicate, isRoot) {
	      return Arr.filter(Traverse.parents(scope, isRoot), predicate);
	    };
	
	    var siblings = function (scope, predicate) {
	      return Arr.filter(Traverse.siblings(scope), predicate);
	    };
	
	    var children = function (scope, predicate) {
	      return Arr.filter(Traverse.children(scope), predicate);
	    };
	
	    var descendants = function (scope, predicate) {
	      var result = [];
	
	      // Recurse.toArray() might help here
	      Arr.each(Traverse.children(scope), function (x) {
	        if (predicate(x)) {
	          result = result.concat([ x ]);
	        }
	        result = result.concat(descendants(x, predicate));
	      });
	      return result;
	    };
	
	    return {
	      all: all,
	      ancestors: ancestors,
	      siblings: siblings,
	      children: children,
	      descendants: descendants
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.search.SelectorFilter',
	
	  [
	    'ephox.sugar.api.search.PredicateFilter',
	    'ephox.sugar.api.search.Selectors'
	  ],
	
	  function (PredicateFilter, Selectors) {
	    var all = function (selector) {
	      return Selectors.all(selector);
	    };
	
	    // For all of the following:
	    //
	    // jQuery does siblings of firstChild. IE9+ supports scope.dom().children (similar to Traverse.children but elements only).
	    // Traverse should also do this (but probably not by default).
	    //
	
	    var ancestors = function (scope, selector, isRoot) {
	      // It may surprise you to learn this is exactly what JQuery does
	      // TODO: Avoid all this wrapping and unwrapping
	      return PredicateFilter.ancestors(scope, function (e) {
	        return Selectors.is(e, selector);
	      }, isRoot);
	    };
	
	    var siblings = function (scope, selector) {
	      // It may surprise you to learn this is exactly what JQuery does
	      // TODO: Avoid all the wrapping and unwrapping
	      return PredicateFilter.siblings(scope, function (e) {
	        return Selectors.is(e, selector);
	      });
	    };
	
	    var children = function (scope, selector) {
	      // It may surprise you to learn this is exactly what JQuery does
	      // TODO: Avoid all the wrapping and unwrapping
	      return PredicateFilter.children(scope, function (e) {
	        return Selectors.is(e, selector);
	      });
	    };
	
	    var descendants = function (scope, selector) {
	      return Selectors.all(selector, scope);
	    };
	
	    return {
	      all: all,
	      ancestors: ancestors,
	      siblings: siblings,
	      children: children,
	      descendants: descendants
	    };
	  }
	);
	
	/**
	 * PaddingBr.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.PaddingBr',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.dom.Insert',
	    'ephox.sugar.api.dom.Remove',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'ephox.sugar.api.node.Text',
	    'ephox.sugar.api.search.SelectorFilter',
	    'ephox.sugar.api.search.Traverse',
	    'tinymce.core.dom.ElementType'
	  ],
	  function (Arr, Insert, Remove, Element, Node, Text, SelectorFilter, Traverse, ElementType) {
	    var getLastChildren = function (elm) {
	      var children = [], rawNode = elm.dom();
	
	      while (rawNode) {
	        children.push(Element.fromDom(rawNode));
	        rawNode = rawNode.lastChild;
	      }
	
	      return children;
	    };
	
	    var removeTrailingBr = function (elm) {
	      var allBrs = SelectorFilter.descendants(elm, 'br');
	      var brs = Arr.filter(getLastChildren(elm).slice(-1), ElementType.isBr);
	      if (allBrs.length === brs.length) {
	        Arr.each(brs, Remove.remove);
	      }
	    };
	
	    var fillWithPaddingBr = function (elm) {
	      Remove.empty(elm);
	      Insert.append(elm, Element.fromHtml('<br data-mce-bogus="1">'));
	    };
	
	    var isPaddingContents = function (elm) {
	      return Node.isText(elm) ? Text.get(elm) === '\u00a0' : ElementType.isBr(elm);
	    };
	
	    var isPaddedElement = function (elm) {
	      return Arr.filter(Traverse.children(elm), isPaddingContents).length === 1;
	    };
	
	    var trimBlockTrailingBr = function (elm) {
	      Traverse.lastChild(elm).each(function (lastChild) {
	        Traverse.prevSibling(lastChild).each(function (lastChildPrevSibling) {
	          if (ElementType.isBlock(elm) && ElementType.isBr(lastChild) && ElementType.isBlock(lastChildPrevSibling)) {
	            Remove.remove(lastChild);
	          }
	        });
	      });
	    };
	
	    return {
	      removeTrailingBr: removeTrailingBr,
	      fillWithPaddingBr: fillWithPaddingBr,
	      isPaddedElement: isPaddedElement,
	      trimBlockTrailingBr: trimBlockTrailingBr
	    };
	  }
	);
	/**
	 * Writer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to write HTML tags out it can be used with the Serializer or the SaxParser.
	 *
	 * @class tinymce.html.Writer
	 * @example
	 * var writer = new tinymce.html.Writer({indent: true});
	 * var parser = new tinymce.html.SaxParser(writer).parse('<p><br></p>');
	 * console.log(writer.getContent());
	 *
	 * @class tinymce.html.Writer
	 * @version 3.4
	 */
	define(
	  'tinymce.core.html.Writer',
	  [
	    "tinymce.core.html.Entities",
	    "tinymce.core.util.Tools"
	  ],
	  function (Entities, Tools) {
	    var makeMap = Tools.makeMap;
	
	    /**
	     * Constructs a new Writer instance.
	     *
	     * @constructor
	     * @method Writer
	     * @param {Object} settings Name/value settings object.
	     */
	    return function (settings) {
	      var html = [], indent, indentBefore, indentAfter, encode, htmlOutput;
	
	      settings = settings || {};
	      indent = settings.indent;
	      indentBefore = makeMap(settings.indent_before || '');
	      indentAfter = makeMap(settings.indent_after || '');
	      encode = Entities.getEncodeFunc(settings.entity_encoding || 'raw', settings.entities);
	      htmlOutput = settings.element_format == "html";
	
	      return {
	        /**
	         * Writes the a start element such as <p id="a">.
	         *
	         * @method start
	         * @param {String} name Name of the element.
	         * @param {Array} attrs Optional attribute array or undefined if it hasn't any.
	         * @param {Boolean} empty Optional empty state if the tag should end like <br />.
	         */
	        start: function (name, attrs, empty) {
	          var i, l, attr, value;
	
	          if (indent && indentBefore[name] && html.length > 0) {
	            value = html[html.length - 1];
	
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	
	          html.push('<', name);
	
	          if (attrs) {
	            for (i = 0, l = attrs.length; i < l; i++) {
	              attr = attrs[i];
	              html.push(' ', attr.name, '="', encode(attr.value, true), '"');
	            }
	          }
	
	          if (!empty || htmlOutput) {
	            html[html.length] = '>';
	          } else {
	            html[html.length] = ' />';
	          }
	
	          if (empty && indent && indentAfter[name] && html.length > 0) {
	            value = html[html.length - 1];
	
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	        },
	
	        /**
	         * Writes the a end element such as </p>.
	         *
	         * @method end
	         * @param {String} name Name of the element.
	         */
	        end: function (name) {
	          var value;
	
	          /*if (indent && indentBefore[name] && html.length > 0) {
	            value = html[html.length - 1];
	
	            if (value.length > 0 && value !== '\n')
	              html.push('\n');
	          }*/
	
	          html.push('</', name, '>');
	
	          if (indent && indentAfter[name] && html.length > 0) {
	            value = html[html.length - 1];
	
	            if (value.length > 0 && value !== '\n') {
	              html.push('\n');
	            }
	          }
	        },
	
	        /**
	         * Writes a text node.
	         *
	         * @method text
	         * @param {String} text String to write out.
	         * @param {Boolean} raw Optional raw state if true the contents wont get encoded.
	         */
	        text: function (text, raw) {
	          if (text.length > 0) {
	            html[html.length] = raw ? text : encode(text);
	          }
	        },
	
	        /**
	         * Writes a cdata node such as <![CDATA[data]]>.
	         *
	         * @method cdata
	         * @param {String} text String to write out inside the cdata.
	         */
	        cdata: function (text) {
	          html.push('<![CDATA[', text, ']]>');
	        },
	
	        /**
	         * Writes a comment node such as <!-- Comment -->.
	         *
	         * @method cdata
	         * @param {String} text String to write out inside the comment.
	         */
	        comment: function (text) {
	          html.push('<!--', text, '-->');
	        },
	
	        /**
	         * Writes a PI node such as <?xml attr="value" ?>.
	         *
	         * @method pi
	         * @param {String} name Name of the pi.
	         * @param {String} text String to write out inside the pi.
	         */
	        pi: function (name, text) {
	          if (text) {
	            html.push('<?', name, ' ', encode(text), '?>');
	          } else {
	            html.push('<?', name, '?>');
	          }
	
	          if (indent) {
	            html.push('\n');
	          }
	        },
	
	        /**
	         * Writes a doctype node such as <!DOCTYPE data>.
	         *
	         * @method doctype
	         * @param {String} text String to write out inside the doctype.
	         */
	        doctype: function (text) {
	          html.push('<!DOCTYPE', text, '>', indent ? '\n' : '');
	        },
	
	        /**
	         * Resets the internal buffer if one wants to reuse the writer.
	         *
	         * @method reset
	         */
	        reset: function () {
	          html.length = 0;
	        },
	
	        /**
	         * Returns the contents that got serialized.
	         *
	         * @method getContent
	         * @return {String} HTML contents that got written down.
	         */
	        getContent: function () {
	          return html.join('').replace(/\n$/, '');
	        }
	      };
	    };
	  }
	);
	/**
	 * Serializer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to serialize down the DOM tree into a string using a Writer instance.
	 *
	 *
	 * @example
	 * new tinymce.html.Serializer().serialize(new tinymce.html.DomParser().parse('<p>text</p>'));
	 * @class tinymce.html.Serializer
	 * @version 3.4
	 */
	define(
	  'tinymce.core.html.Serializer',
	  [
	    "tinymce.core.html.Writer",
	    "tinymce.core.html.Schema"
	  ],
	  function (Writer, Schema) {
	    /**
	     * Constructs a new Serializer instance.
	     *
	     * @constructor
	     * @method Serializer
	     * @param {Object} settings Name/value settings object.
	     * @param {tinymce.html.Schema} schema Schema instance to use.
	     */
	    return function (settings, schema) {
	      var self = this, writer = new Writer(settings);
	
	      settings = settings || {};
	      settings.validate = "validate" in settings ? settings.validate : true;
	
	      self.schema = schema = schema || new Schema();
	      self.writer = writer;
	
	      /**
	       * Serializes the specified node into a string.
	       *
	       * @example
	       * new tinymce.html.Serializer().serialize(new tinymce.html.DomParser().parse('<p>text</p>'));
	       * @method serialize
	       * @param {tinymce.html.Node} node Node instance to serialize.
	       * @return {String} String with HTML based on DOM tree.
	       */
	      self.serialize = function (node) {
	        var handlers, validate;
	
	        validate = settings.validate;
	
	        handlers = {
	          // #text
	          3: function (node) {
	            writer.text(node.value, node.raw);
	          },
	
	          // #comment
	          8: function (node) {
	            writer.comment(node.value);
	          },
	
	          // Processing instruction
	          7: function (node) {
	            writer.pi(node.name, node.value);
	          },
	
	          // Doctype
	          10: function (node) {
	            writer.doctype(node.value);
	          },
	
	          // CDATA
	          4: function (node) {
	            writer.cdata(node.value);
	          },
	
	          // Document fragment
	          11: function (node) {
	            if ((node = node.firstChild)) {
	              do {
	                walk(node);
	              } while ((node = node.next));
	            }
	          }
	        };
	
	        writer.reset();
	
	        var walk = function (node) {
	          var handler = handlers[node.type], name, isEmpty, attrs, attrName, attrValue, sortedAttrs, i, l, elementRule;
	
	          if (!handler) {
	            name = node.name;
	            isEmpty = node.shortEnded;
	            attrs = node.attributes;
	
	            // Sort attributes
	            if (validate && attrs && attrs.length > 1) {
	              sortedAttrs = [];
	              sortedAttrs.map = {};
	
	              elementRule = schema.getElementRule(node.name);
	              if (elementRule) {
	                for (i = 0, l = elementRule.attributesOrder.length; i < l; i++) {
	                  attrName = elementRule.attributesOrder[i];
	
	                  if (attrName in attrs.map) {
	                    attrValue = attrs.map[attrName];
	                    sortedAttrs.map[attrName] = attrValue;
	                    sortedAttrs.push({ name: attrName, value: attrValue });
	                  }
	                }
	
	                for (i = 0, l = attrs.length; i < l; i++) {
	                  attrName = attrs[i].name;
	
	                  if (!(attrName in sortedAttrs.map)) {
	                    attrValue = attrs.map[attrName];
	                    sortedAttrs.map[attrName] = attrValue;
	                    sortedAttrs.push({ name: attrName, value: attrValue });
	                  }
	                }
	
	                attrs = sortedAttrs;
	              }
	            }
	
	            writer.start(node.name, attrs, isEmpty);
	
	            if (!isEmpty) {
	              if ((node = node.firstChild)) {
	                do {
	                  walk(node);
	                } while ((node = node.next));
	              }
	
	              writer.end(name);
	            }
	          } else {
	            handler(node);
	          }
	        };
	
	        // Serialize element and treat all non elements as fragments
	        if (node.type == 1 && !settings.inner) {
	          walk(node);
	        } else {
	          handlers[11](node);
	        }
	
	        return writer.getContent();
	      };
	    };
	  }
	);
	
	/**
	 * CaretFinder.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.caret.CaretFinder',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'tinymce.core.caret.CaretCandidate',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.caret.CaretUtils',
	    'tinymce.core.caret.CaretWalker',
	    'tinymce.core.dom.NodeType'
	  ],
	  function (Fun, Option, CaretCandidate, CaretPosition, CaretUtils, CaretWalker, NodeType) {
	    var walkToPositionIn = function (forward, rootNode, startNode) {
	      var position = forward ? CaretPosition.before(startNode) : CaretPosition.after(startNode);
	      return fromPosition(forward, rootNode, position);
	    };
	
	    var afterElement = function (node) {
	      return NodeType.isBr(node) ? CaretPosition.before(node) : CaretPosition.after(node);
	    };
	
	    var isBeforeOrStart = function (position) {
	      if (CaretPosition.isTextPosition(position)) {
	        return position.offset() === 0;
	      } else {
	        return CaretCandidate.isCaretCandidate(position.getNode());
	      }
	    };
	
	    var isAfterOrEnd = function (position) {
	      if (CaretPosition.isTextPosition(position)) {
	        return position.offset() === position.container().data.length;
	      } else {
	        return CaretCandidate.isCaretCandidate(position.getNode(true));
	      }
	    };
	
	    var isBeforeAfterSameElement = function (from, to) {
	      return !CaretPosition.isTextPosition(from) && !CaretPosition.isTextPosition(to) && from.getNode() === to.getNode(true);
	    };
	
	    var isAtBr = function (position) {
	      return !CaretPosition.isTextPosition(position) && NodeType.isBr(position.getNode());
	    };
	
	    var shouldSkipPosition = function (forward, from, to) {
	      if (forward) {
	        return !isBeforeAfterSameElement(from, to) && !isAtBr(from) && isAfterOrEnd(from) && isBeforeOrStart(to);
	      } else {
	        return !isBeforeAfterSameElement(to, from) && isBeforeOrStart(from) && isAfterOrEnd(to);
	      }
	    };
	
	    // Finds: <p>a|<b>b</b></p> -> <p>a<b>|b</b></p>
	    var fromPosition = function (forward, rootNode, position) {
	      var walker = new CaretWalker(rootNode);
	      return Option.from(forward ? walker.next(position) : walker.prev(position));
	    };
	
	    // Finds: <p>a|<b>b</b></p> -> <p>a<b>b|</b></p>
	    var navigate = function (forward, rootNode, from) {
	      return fromPosition(forward, rootNode, from).bind(function (to) {
	        if (CaretUtils.isInSameBlock(from, to, rootNode) && shouldSkipPosition(forward, from, to)) {
	          return fromPosition(forward, rootNode, to);
	        } else {
	          return Option.some(to);
	        }
	      });
	    };
	
	    var positionIn = function (forward, element) {
	      var startNode = forward ? element.firstChild : element.lastChild;
	      if (NodeType.isText(startNode)) {
	        return Option.some(new CaretPosition(startNode, forward ? 0 : startNode.data.length));
	      } else if (startNode) {
	        if (CaretCandidate.isCaretCandidate(startNode)) {
	          return Option.some(forward ? CaretPosition.before(startNode) : afterElement(startNode));
	        } else {
	          return walkToPositionIn(forward, element, startNode);
	        }
	      } else {
	        return Option.none();
	      }
	    };
	
	    return {
	      fromPosition: fromPosition,
	      nextPosition: Fun.curry(fromPosition, true),
	      prevPosition: Fun.curry(fromPosition, false),
	      navigate: navigate,
	      positionIn: positionIn,
	      firstPositionIn: Fun.curry(positionIn, true),
	      lastPositionIn: Fun.curry(positionIn, false)
	    };
	  }
	);
	
	/**
	 * RangeNormalizer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.RangeNormalizer',
	  [
	    'global!document',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.caret.CaretUtils'
	  ],
	  function (document, CaretFinder, CaretPosition, CaretUtils) {
	    var createRange = function (sc, so, ec, eo) {
	      var rng = document.createRange();
	      rng.setStart(sc, so);
	      rng.setEnd(ec, eo);
	      return rng;
	    };
	
	    // If you triple click a paragraph in this case:
	    //   <blockquote><p>a</p></blockquote><p>b</p>
	    // It would become this range in webkit:
	    //   <blockquote><p>[a</p></blockquote><p>]b</p>
	    // We would want it to be:
	    //   <blockquote><p>[a]</p></blockquote><p>b</p>
	    // Since it would otherwise produces spans out of thin air on insertContent for example.
	    var normalizeBlockSelectionRange = function (rng) {
	      var startPos = CaretPosition.fromRangeStart(rng);
	      var endPos = CaretPosition.fromRangeEnd(rng);
	      var rootNode = rng.commonAncestorContainer;
	
	      return CaretFinder.fromPosition(false, rootNode, endPos)
	        .map(function (newEndPos) {
	          if (!CaretUtils.isInSameBlock(startPos, endPos, rootNode) && CaretUtils.isInSameBlock(startPos, newEndPos, rootNode)) {
	            return createRange(startPos.container(), startPos.offset(), newEndPos.container(), newEndPos.offset());
	          } else {
	            return rng;
	          }
	        }).getOr(rng);
	    };
	
	    var normalizeBlockSelection = function (rng) {
	      return rng.collapsed ? rng : normalizeBlockSelectionRange(rng);
	    };
	
	    var normalize = function (rng) {
	      return normalizeBlockSelection(rng);
	    };
	
	    return {
	      normalize: normalize
	    };
	  }
	);
	/**
	 * InsertContent.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Handles inserts of contents into the editor instance.
	 *
	 * @class tinymce.InsertContent
	 * @private
	 */
	define(
	  'tinymce.core.InsertContent',
	  [
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.Env',
	    'tinymce.core.InsertList',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.caret.CaretWalker',
	    'tinymce.core.dom.ElementUtils',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.PaddingBr',
	    'tinymce.core.html.Serializer',
	    'tinymce.core.selection.RangeNormalizer',
	    'tinymce.core.util.Tools'
	  ],
	  function (Option, Element, Env, InsertList, CaretPosition, CaretWalker, ElementUtils, NodeType, PaddingBr, Serializer, RangeNormalizer, Tools) {
	    var isTableCell = NodeType.matchNodeNames('td th');
	
	    var validInsertion = function (editor, value, parentNode) {
	      // Should never insert content into bogus elements, since these can
	      // be resize handles or similar
	      if (parentNode.getAttribute('data-mce-bogus') === 'all') {
	        parentNode.parentNode.insertBefore(editor.dom.createFragment(value), parentNode);
	      } else {
	        // Check if parent is empty or only has one BR element then set the innerHTML of that parent
	        var node = parentNode.firstChild;
	        var node2 = parentNode.lastChild;
	        if (!node || (node === node2 && node.nodeName === 'BR')) {///
	          editor.dom.setHTML(parentNode, value);
	        } else {
	          editor.selection.setContent(value);
	        }
	      }
	    };
	
	    var trimBrsFromTableCell = function (dom, elm) {
	      Option.from(dom.getParent(elm, 'td,th')).map(Element.fromDom).each(PaddingBr.trimBlockTrailingBr);
	    };
	
	    var insertHtmlAtCaret = function (editor, value, details) {
	      var parser, serializer, parentNode, rootNode, fragment, args;
	      var marker, rng, node, node2, bookmarkHtml, merge;
	      var textInlineElements = editor.schema.getTextInlineElements();
	      var selection = editor.selection, dom = editor.dom;
	
	      var trimOrPaddLeftRight = function (html) {
	        var rng, container, offset;
	
	        rng = selection.getRng(true);
	        container = rng.startContainer;
	        offset = rng.startOffset;
	
	        var hasSiblingText = function (siblingName) {
	          return container[siblingName] && container[siblingName].nodeType == 3;
	        };
	
	        if (container.nodeType == 3) {
	          if (offset > 0) {
	            html = html.replace(/^&nbsp;/, ' ');
	          } else if (!hasSiblingText('previousSibling')) {
	            html = html.replace(/^ /, '&nbsp;');
	          }
	
	          if (offset < container.length) {
	            html = html.replace(/&nbsp;(<br>|)$/, ' ');
	          } else if (!hasSiblingText('nextSibling')) {
	            html = html.replace(/(&nbsp;| )(<br>|)$/, '&nbsp;');
	          }
	        }
	
	        return html;
	      };
	
	      // Removes &nbsp; from a [b] c -> a &nbsp;c -> a c
	      var trimNbspAfterDeleteAndPaddValue = function () {
	        var rng, container, offset;
	
	        rng = selection.getRng(true);
	        container = rng.startContainer;
	        offset = rng.startOffset;
	
	        if (container.nodeType == 3 && rng.collapsed) {
	          if (container.data[offset] === '\u00a0') {
	            container.deleteData(offset, 1);
	
	            if (!/[\u00a0| ]$/.test(value)) {
	              value += ' ';
	            }
	          } else if (container.data[offset - 1] === '\u00a0') {
	            container.deleteData(offset - 1, 1);
	
	            if (!/[\u00a0| ]$/.test(value)) {
	              value = ' ' + value;
	            }
	          }
	        }
	      };
	
	      var reduceInlineTextElements = function () {
	        if (merge) {
	          var root = editor.getBody(), elementUtils = new ElementUtils(dom);
	
	          Tools.each(dom.select('*[data-mce-fragment]'), function (node) {
	            for (var testNode = node.parentNode; testNode && testNode != root; testNode = testNode.parentNode) {
	              if (textInlineElements[node.nodeName.toLowerCase()] && elementUtils.compare(testNode, node)) {
	                dom.remove(node, true);
	              }
	            }
	          });
	        }
	      };
	
	      var markFragmentElements = function (fragment) {
	        var node = fragment;
	
	        while ((node = node.walk())) {
	          if (node.type === 1) {
	            node.attr('data-mce-fragment', '1');
	          }
	        }
	      };
	
	      var umarkFragmentElements = function (elm) {
	        Tools.each(elm.getElementsByTagName('*'), function (elm) {
	          elm.removeAttribute('data-mce-fragment');
	        });
	      };
	
	      var isPartOfFragment = function (node) {
	        return !!node.getAttribute('data-mce-fragment');
	      };
	
	      var canHaveChildren = function (node) {
	        return node && !editor.schema.getShortEndedElements()[node.nodeName];
	      };
	
	      var moveSelectionToMarker = function (marker) {
	        var parentEditableFalseElm, parentBlock, nextRng;
	
	        var getContentEditableFalseParent = function (node) {
	          var root = editor.getBody();
	
	          for (; node && node !== root; node = node.parentNode) {
	            if (editor.dom.getContentEditable(node) === 'false') {
	              return node;
	            }
	          }
	
	          return null;
	        };
	
	        if (!marker) {
	          return;
	        }
	
	        selection.scrollIntoView(marker);
	
	        // If marker is in cE=false then move selection to that element instead
	        parentEditableFalseElm = getContentEditableFalseParent(marker);
	        if (parentEditableFalseElm) {
	          dom.remove(marker);
	          selection.select(parentEditableFalseElm);
	          return;
	        }
	
	        // Move selection before marker and remove it
	        rng = dom.createRng();
	
	        // If previous sibling is a text node set the selection to the end of that node
	        node = marker.previousSibling;
	        if (node && node.nodeType == 3) {
	          rng.setStart(node, node.nodeValue.length);
	
	          // TODO: Why can't we normalize on IE
	          if (!Env.ie) {
	            node2 = marker.nextSibling;
	            if (node2 && node2.nodeType == 3) {
	              node.appendData(node2.data);
	              node2.parentNode.removeChild(node2);
	            }
	          }
	        } else {
	          // If the previous sibling isn't a text node or doesn't exist set the selection before the marker node
	          rng.setStartBefore(marker);
	          rng.setEndBefore(marker);
	        }
	
	        var findNextCaretRng = function (rng) {
	          var caretPos = CaretPosition.fromRangeStart(rng);
	          var caretWalker = new CaretWalker(editor.getBody());
	
	          caretPos = caretWalker.next(caretPos);
	          if (caretPos) {
	            return caretPos.toRange();
	          }
	        };
	
	        // Remove the marker node and set the new range
	        parentBlock = dom.getParent(marker, dom.isBlock);
	        dom.remove(marker);
	
	        if (parentBlock && dom.isEmpty(parentBlock)) {
	          editor.$(parentBlock).empty();
	
	          rng.setStart(parentBlock, 0);
	          rng.setEnd(parentBlock, 0);
	
	          if (!isTableCell(parentBlock) && !isPartOfFragment(parentBlock) && (nextRng = findNextCaretRng(rng))) {
	            rng = nextRng;
	            dom.remove(parentBlock);
	          } else {
	            dom.add(parentBlock, dom.create('br', { 'data-mce-bogus': '1' }));
	          }
	        }
	
	        selection.setRng(rng);
	      };
	
	      // Check for whitespace before/after value
	      if (/^ | $/.test(value)) {
	        value = trimOrPaddLeftRight(value);
	      }
	
	      // Setup parser and serializer
	      parser = editor.parser;
	      merge = details.merge;
	
	      serializer = new Serializer({
	        validate: editor.settings.validate
	      }, editor.schema);
	      bookmarkHtml = '<span id="mce_marker" data-mce-type="bookmark">&#xFEFF;&#x200B;</span>';
	
	      // Run beforeSetContent handlers on the HTML to be inserted
	      args = { content: value, format: 'html', selection: true, paste: details.paste };
	      args = editor.fire('BeforeSetContent', args);
	      if (args.isDefaultPrevented()) {
	        editor.fire('SetContent', { content: args.content, format: 'html', selection: true, paste: details.paste });
	        return;
	      }
	
	      value = args.content;
	
	      // Add caret at end of contents if it's missing
	      if (value.indexOf('{$caret}') == -1) {
	        value += '{$caret}';
	      }
	
	      // Replace the caret marker with a span bookmark element
	      value = value.replace(/\{\$caret\}/, bookmarkHtml);
	
	      // If selection is at <body>|<p></p> then move it into <body><p>|</p>
	      rng = selection.getRng();
	      var caretElement = rng.startContainer || (rng.parentElement ? rng.parentElement() : null);
	      var body = editor.getBody();
	      if (caretElement === body && selection.isCollapsed()) {
	        if (dom.isBlock(body.firstChild) && canHaveChildren(body.firstChild) && dom.isEmpty(body.firstChild)) {
	          rng = dom.createRng();
	          rng.setStart(body.firstChild, 0);
	          rng.setEnd(body.firstChild, 0);
	          selection.setRng(rng);
	        }
	      }
	
	      // Insert node maker where we will insert the new HTML and get it's parent
	      if (!selection.isCollapsed()) {
	        // Fix for #2595 seems that delete removes one extra character on
	        // WebKit for some odd reason if you double click select a word
	        editor.selection.setRng(RangeNormalizer.normalize(editor.selection.getRng()));
	        editor.getDoc().execCommand('Delete', false, null);
	        trimNbspAfterDeleteAndPaddValue();
	      }
	
	      parentNode = selection.getNode();
	
	      // Parse the fragment within the context of the parent node
	      var parserArgs = { context: parentNode.nodeName.toLowerCase(), data: details.data, insert: true };
	      fragment = parser.parse(value, parserArgs);
	
	      // Custom handling of lists
	      if (details.paste === true && InsertList.isListFragment(editor.schema, fragment) && InsertList.isParentBlockLi(dom, parentNode)) {
	        rng = InsertList.insertAtCaret(serializer, dom, editor.selection.getRng(true), fragment);
	        editor.selection.setRng(rng);
	        editor.fire('SetContent', args);
	        return;
	      }
	
	      markFragmentElements(fragment);
	
	      // Move the caret to a more suitable location
	      node = fragment.lastChild;
	      if (node.attr('id') == 'mce_marker') {
	        marker = node;
	
	        for (node = node.prev; node; node = node.walk(true)) {
	          if (node.type == 3 || !dom.isBlock(node.name)) {
	            if (editor.schema.isValidChild(node.parent.name, 'span')) {
	              node.parent.insert(marker, node, node.name === 'br');
	            }
	            break;
	          }
	        }
	      }
	
	      editor._selectionOverrides.showBlockCaretContainer(parentNode);
	
	      // If parser says valid we can insert the contents into that parent
	      if (!parserArgs.invalid) {
	        value = serializer.serialize(fragment);
	        validInsertion(editor, value, parentNode);
	      } else {
	        // If the fragment was invalid within that context then we need
	        // to parse and process the parent it's inserted into
	
	        // Insert bookmark node and get the parent
	        selection.setContent(bookmarkHtml);
	        parentNode = selection.getNode();
	        rootNode = editor.getBody();
	
	        // Opera will return the document node when selection is in root
	        if (parentNode.nodeType == 9) {
	          parentNode = node = rootNode;
	        } else {
	          node = parentNode;
	        }
	
	        // Find the ancestor just before the root element
	        while (node !== rootNode) {
	          parentNode = node;
	          node = node.parentNode;
	        }
	
	        // Get the outer/inner HTML depending on if we are in the root and parser and serialize that
	        value = parentNode == rootNode ? rootNode.innerHTML : dom.getOuterHTML(parentNode);
	        value = serializer.serialize(
	          parser.parse(
	            // Need to replace by using a function since $ in the contents would otherwise be a problem
	            value.replace(/<span (id="mce_marker"|id=mce_marker).+?<\/span>/i, function () {
	              return serializer.serialize(fragment);
	            })
	          )
	        );
	
	        // Set the inner/outer HTML depending on if we are in the root or not
	        if (parentNode == rootNode) {
	          dom.setHTML(rootNode, value);
	        } else {
	          dom.setOuterHTML(parentNode, value);
	        }
	      }
	
	      reduceInlineTextElements();
	      moveSelectionToMarker(dom.get('mce_marker'));
	      umarkFragmentElements(editor.getBody());
	      trimBrsFromTableCell(editor.dom, editor.selection.getStart());
	
	      editor.fire('SetContent', args);
	      editor.addVisual();
	    };
	
	    var processValue = function (value) {
	      var details;
	
	      if (typeof value !== 'string') {
	        details = Tools.extend({
	          paste: value.paste,
	          data: {
	            paste: value.paste
	          }
	        }, value);
	
	        return {
	          content: value.content,
	          details: details
	        };
	      }
	
	      return {
	        content: value,
	        details: {}
	      };
	    };
	
	    var insertAtCaret = function (editor, value) {
	      var result = processValue(value);
	      insertHtmlAtCaret(editor, result.content, result.details);
	    };
	
	    return {
	      insertAtCaret: insertAtCaret
	    };
	  }
	);
	define(
	  'ephox.sugar.impl.ClosestOrAncestor',
	
	  [
	    'ephox.katamari.api.Type',
	    'ephox.katamari.api.Option'
	  ],
	
	  function (Type, Option) {
	    return function (is, ancestor, scope, a, isRoot) {
	      return is(scope, a) ?
	              Option.some(scope) :
	              Type.isFunction(isRoot) && isRoot(scope) ?
	                  Option.none() :
	                  ancestor(scope, a, isRoot);
	    };
	  }
	);
	define(
	  'ephox.sugar.api.search.PredicateFind',
	
	  [
	    'ephox.katamari.api.Type',
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.node.Body',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.impl.ClosestOrAncestor'
	  ],
	
	  function (Type, Arr, Fun, Option, Body, Compare, Element, ClosestOrAncestor) {
	    var first = function (predicate) {
	      return descendant(Body.body(), predicate);
	    };
	
	    var ancestor = function (scope, predicate, isRoot) {
	      var element = scope.dom();
	      var stop = Type.isFunction(isRoot) ? isRoot : Fun.constant(false);
	
	      while (element.parentNode) {
	        element = element.parentNode;
	        var el = Element.fromDom(element);
	
	        if (predicate(el)) return Option.some(el);
	        else if (stop(el)) break;
	      }
	      return Option.none();
	    };
	
	    var closest = function (scope, predicate, isRoot) {
	      // This is required to avoid ClosestOrAncestor passing the predicate to itself
	      var is = function (scope) {
	        return predicate(scope);
	      };
	      return ClosestOrAncestor(is, ancestor, scope, predicate, isRoot);
	    };
	
	    var sibling = function (scope, predicate) {
	      var element = scope.dom();
	      if (!element.parentNode) return Option.none();
	
	      return child(Element.fromDom(element.parentNode), function (x) {
	        return !Compare.eq(scope, x) && predicate(x);
	      });
	    };
	
	    var child = function (scope, predicate) {
	      var result = Arr.find(scope.dom().childNodes,
	        Fun.compose(predicate, Element.fromDom));
	      return result.map(Element.fromDom);
	    };
	
	    var descendant = function (scope, predicate) {
	      var descend = function (element) {
	        for (var i = 0; i < element.childNodes.length; i++) {
	          if (predicate(Element.fromDom(element.childNodes[i])))
	            return Option.some(Element.fromDom(element.childNodes[i]));
	
	          var res = descend(element.childNodes[i]);
	          if (res.isSome())
	            return res;
	        }
	
	        return Option.none();
	      };
	
	      return descend(scope.dom());
	    };
	
	    return {
	      first: first,
	      ancestor: ancestor,
	      closest: closest,
	      sibling: sibling,
	      child: child,
	      descendant: descendant
	    };
	  }
	);
	
	/**
	 * DefaultSettings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.EditorSettings',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Obj',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Strings',
	    'ephox.katamari.api.Struct',
	    'ephox.katamari.api.Type',
	    'ephox.sand.api.PlatformDetection',
	    'tinymce.core.util.Tools'
	  ],
	  function (Arr, Fun, Obj, Option, Strings, Struct, Type, PlatformDetection, Tools) {
	    var sectionResult = Struct.immutable('sections', 'settings');
	    var detection = PlatformDetection.detect();
	    var isTouch = detection.deviceType.isTouch();
	    var mobilePlugins = [ 'lists', 'autolink', 'autosave' ];
	    var defaultMobileSettings = { theme: 'mobile' };
	
	    var normalizePlugins = function (plugins) {
	      var pluginNames = Type.isArray(plugins) ? plugins.join(' ') : plugins;
	      var trimmedPlugins = Arr.map(Type.isString(pluginNames) ? pluginNames.split(' ') : [ ], Strings.trim);
	      return Arr.filter(trimmedPlugins, function (item) {
	        return item.length > 0;
	      });
	    };
	
	    var filterMobilePlugins = function (plugins) {
	      return Arr.filter(plugins, Fun.curry(Arr.contains, mobilePlugins));
	    };
	
	    var extractSections = function (keys, settings) {
	      var result = Obj.bifilter(settings, function (value, key) {
	        return Arr.contains(keys, key);
	      });
	
	      return sectionResult(result.t, result.f);
	    };
	
	    var getSection = function (sectionResult, name, defaults) {
	      var sections = sectionResult.sections();
	      var sectionSettings = sections.hasOwnProperty(name) ? sections[name] : { };
	      return Tools.extend({}, defaults, sectionSettings);
	    };
	
	    var hasSection = function (sectionResult, name) {
	      return sectionResult.sections().hasOwnProperty(name);
	    };
	
	    var getDefaultSettings = function (id, documentBaseUrl, editor) {
	      return {
	        id: id,
	        theme: 'modern',
	        delta_width: 0,
	        delta_height: 0,
	        popup_css: '',
	        plugins: '',
	        document_base_url: documentBaseUrl,
	        add_form_submit_trigger: true,
	        submit_patch: true,
	        add_unload_trigger: true,
	        convert_urls: true,
	        relative_urls: true,
	        remove_script_host: true,
	        object_resizing: true,
	        doctype: '<!DOCTYPE html>',
	        visual: true,
	        font_size_style_values: 'xx-small,x-small,small,medium,large,x-large,xx-large',
	
	        // See: http://www.w3.org/TR/CSS2/fonts.html#propdef-font-size
	        font_size_legacy_values: 'xx-small,small,medium,large,x-large,xx-large,300%',
	        forced_root_block: 'p',
	        hidden_input: true,
	        padd_empty_editor: true,
	        render_ui: true,
	        indentation: '30px',
	        inline_styles: true,
	        convert_fonts_to_spans: true,
	        indent: 'simple',
	        indent_before: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' +
	        'tfoot,tbody,tr,section,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
	        indent_after: 'p,h1,h2,h3,h4,h5,h6,blockquote,div,title,style,pre,script,td,th,ul,ol,li,dl,dt,dd,area,table,thead,' +
	        'tfoot,tbody,tr,section,article,hgroup,aside,figure,figcaption,option,optgroup,datalist',
	        entity_encoding: 'named',
	        url_converter: editor.convertURL,
	        url_converter_scope: editor,
	        ie7_compat: true
	      };
	    };
	
	    var getExternalPlugins = function (overrideSettings, settings) {
	      var userDefinedExternalPlugins = settings.external_plugins ? settings.external_plugins : { };
	
	      if (overrideSettings && overrideSettings.external_plugins) {
	        return Tools.extend({}, overrideSettings.external_plugins, userDefinedExternalPlugins);
	      } else {
	        return userDefinedExternalPlugins;
	      }
	    };
	
	    var combinePlugins = function (forcedPlugins, plugins) {
	      return [].concat(normalizePlugins(forcedPlugins)).concat(normalizePlugins(plugins));
	    };
	
	    var processPlugins = function (isTouchDevice, sectionResult, defaultOverrideSettings, settings) {
	      var forcedPlugins = normalizePlugins(defaultOverrideSettings.forced_plugins);
	      var plugins = normalizePlugins(settings.plugins);
	      var platformPlugins = isTouchDevice && hasSection(sectionResult, 'mobile') ? filterMobilePlugins(plugins) : plugins;
	      var combinedPlugins = combinePlugins(forcedPlugins, platformPlugins);
	
	      return Tools.extend(settings, {
	        plugins: combinedPlugins.join(' ')
	      });
	    };
	
	    var isOnMobile = function (isTouchDevice, sectionResult) {
	      var isInline = sectionResult.settings().inline; // We don't support mobile inline yet
	      return isTouchDevice && hasSection(sectionResult, 'mobile') && !isInline;
	    };
	
	    var combineSettings = function (isTouchDevice, defaultSettings, defaultOverrideSettings, settings) {
	      var sectionResult = extractSections(['mobile'], settings);
	      var extendedSettings = Tools.extend(
	        // Default settings
	        defaultSettings,
	
	        // tinymce.overrideDefaults settings
	        defaultOverrideSettings,
	
	        // User settings
	        sectionResult.settings(),
	
	        // Sections
	        isOnMobile(isTouchDevice, sectionResult) ? getSection(sectionResult, 'mobile', defaultMobileSettings) : { },
	
	        // Forced settings
	        {
	          validate: true,
	          content_editable: sectionResult.settings().inline,
	          external_plugins: getExternalPlugins(defaultOverrideSettings, sectionResult.settings())
	        }
	      );
	
	      return processPlugins(isTouchDevice, sectionResult, defaultOverrideSettings, extendedSettings);
	    };
	
	    var getEditorSettings = function (editor, id, documentBaseUrl, defaultOverrideSettings, settings) {
	      var defaultSettings = getDefaultSettings(id, documentBaseUrl, editor);
	      return combineSettings(isTouch, defaultSettings, defaultOverrideSettings, settings);
	    };
	
	    var get = function (editor, name) {
	      return Option.from(editor.settings[name]);
	    };
	
	    var getFiltered = function (predicate, editor, name) {
	      return Option.from(editor.settings[name]).filter(predicate);
	    };
	
	    return {
	      getEditorSettings: getEditorSettings,
	      get: get,
	      getString: Fun.curry(getFiltered, Type.isString),
	      combineSettings: combineSettings
	    };
	  }
	);
	
	/**
	 * Bidi.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.text.Bidi',
	  [
	  ],
	  function () {
	    var strongRtl = /[\u0591-\u07FF\uFB1D-\uFDFF\uFE70-\uFEFC]/;
	
	    var hasStrongRtl = function (text) {
	      return strongRtl.test(text);
	    };
	
	    return {
	      hasStrongRtl: hasStrongRtl
	    };
	  }
	);
	/**
	 * InlineUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.InlineUtils',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.Selectors',
	    'tinymce.core.EditorSettings',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.caret.CaretUtils',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.text.Bidi'
	  ],
	  function (Arr, Fun, Option, Element, Selectors, EditorSettings, CaretContainer, CaretPosition, CaretUtils, DOMUtils, NodeType, Bidi) {
	    var isInlineTarget = function (editor, elm) {
	      var selector = EditorSettings.getString(editor, 'inline_boundaries_selector').getOr('a[href],code');
	      return Selectors.is(Element.fromDom(elm), selector);
	    };
	
	    var isRtl = function (element) {
	      return DOMUtils.DOM.getStyle(element, 'direction', true) === 'rtl' || Bidi.hasStrongRtl(element.textContent);
	    };
	
	    var findInlineParents = function (isInlineTarget, rootNode, pos) {
	      return Arr.filter(DOMUtils.DOM.getParents(pos.container(), '*', rootNode), isInlineTarget);
	    };
	
	    var findRootInline = function (isInlineTarget, rootNode, pos) {
	      var parents = findInlineParents(isInlineTarget, rootNode, pos);
	      return Option.from(parents[parents.length - 1]);
	    };
	
	    var hasSameParentBlock = function (rootNode, node1, node2) {
	      var block1 = CaretUtils.getParentBlock(node1, rootNode);
	      var block2 = CaretUtils.getParentBlock(node2, rootNode);
	      return block1 && block1 === block2;
	    };
	
	    var isAtZwsp = function (pos) {
	      return CaretContainer.isBeforeInline(pos) || CaretContainer.isAfterInline(pos);
	    };
	
	    var normalizePosition = function (forward, pos) {
	      var container = pos.container(), offset = pos.offset();
	
	      if (forward) {
	        if (CaretContainer.isCaretContainerInline(container)) {
	          if (NodeType.isText(container.nextSibling)) {
	            return new CaretPosition(container.nextSibling, 0);
	          } else {
	            return CaretPosition.after(container);
	          }
	        } else {
	          return CaretContainer.isBeforeInline(pos) ? new CaretPosition(container, offset + 1) : pos;
	        }
	      } else {
	        if (CaretContainer.isCaretContainerInline(container)) {
	          if (NodeType.isText(container.previousSibling)) {
	            return new CaretPosition(container.previousSibling, container.previousSibling.data.length);
	          } else {
	            return CaretPosition.before(container);
	          }
	        } else {
	          return CaretContainer.isAfterInline(pos) ? new CaretPosition(container, offset - 1) : pos;
	        }
	      }
	    };
	
	    var normalizeForwards = Fun.curry(normalizePosition, true);
	    var normalizeBackwards = Fun.curry(normalizePosition, false);
	
	    return {
	      isInlineTarget: isInlineTarget,
	      findRootInline: findRootInline,
	      isRtl: isRtl,
	      isAtZwsp: isAtZwsp,
	      normalizePosition: normalizePosition,
	      normalizeForwards: normalizeForwards,
	      normalizeBackwards: normalizeBackwards,
	      hasSameParentBlock: hasSameParentBlock
	    };
	  }
	);
	/**
	 * DeleteUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.DeleteUtils',
	  [
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Options',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.PredicateFind',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.dom.ElementType',
	    'tinymce.core.keyboard.InlineUtils'
	  ],
	  function (Option, Options, Compare, Element, PredicateFind, CaretFinder, ElementType, InlineUtils) {
	    var isBeforeRoot = function (rootNode) {
	      return function (elm) {
	        return Compare.eq(rootNode, Element.fromDom(elm.dom().parentNode));
	      };
	    };
	
	    var getParentBlock = function (rootNode, elm) {
	      return Compare.contains(rootNode, elm) ? PredicateFind.closest(elm, function (element) {
	        return ElementType.isTextBlock(element) || ElementType.isListItem(element);
	      }, isBeforeRoot(rootNode)) : Option.none();
	    };
	
	    var placeCaretInEmptyBody = function (editor) {
	      var body = editor.getBody();
	      var node = body.firstChild && editor.dom.isBlock(body.firstChild) ? body.firstChild : body;
	      editor.selection.setCursorLocation(node, 0);
	    };
	
	    var paddEmptyBody = function (editor) {
	      if (editor.dom.isEmpty(editor.getBody())) {
	        editor.setContent('');
	        placeCaretInEmptyBody(editor);
	      }
	    };
	
	    var willDeleteLastPositionInElement = function (forward, fromPos, elm) {
	      return Options.liftN([
	        CaretFinder.firstPositionIn(elm),
	        CaretFinder.lastPositionIn(elm)
	      ], function (firstPos, lastPos) {
	        var normalizedFirstPos = InlineUtils.normalizePosition(true, firstPos);
	        var normalizedLastPos = InlineUtils.normalizePosition(false, lastPos);
	        var normalizedFromPos = InlineUtils.normalizePosition(false, fromPos);
	
	        if (forward) {
	          return CaretFinder.nextPosition(elm, normalizedFromPos).map(function (nextPos) {
	            return nextPos.isEqual(normalizedLastPos) && fromPos.isEqual(normalizedFirstPos);
	          }).getOr(false);
	        } else {
	          return CaretFinder.prevPosition(elm, normalizedFromPos).map(function (prevPos) {
	            return prevPos.isEqual(normalizedFirstPos) && fromPos.isEqual(normalizedLastPos);
	          }).getOr(false);
	        }
	      }).getOr(true);
	    };
	
	    return {
	      getParentBlock: getParentBlock,
	      paddEmptyBody: paddEmptyBody,
	      willDeleteLastPositionInElement: willDeleteLastPositionInElement
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.search.SelectorFind',
	
	  [
	    'ephox.sugar.api.search.PredicateFind',
	    'ephox.sugar.api.search.Selectors',
	    'ephox.sugar.impl.ClosestOrAncestor'
	  ],
	
	  function (PredicateFind, Selectors, ClosestOrAncestor) {
	    // TODO: An internal SelectorFilter module that doesn't Element.fromDom() everything
	
	    var first = function (selector) {
	      return Selectors.one(selector);
	    };
	
	    var ancestor = function (scope, selector, isRoot) {
	      return PredicateFind.ancestor(scope, function (e) {
	        return Selectors.is(e, selector);
	      }, isRoot);
	    };
	
	    var sibling = function (scope, selector) {
	      return PredicateFind.sibling(scope, function (e) {
	        return Selectors.is(e, selector);
	      });
	    };
	
	    var child = function (scope, selector) {
	      return PredicateFind.child(scope, function (e) {
	        return Selectors.is(e, selector);
	      });
	    };
	
	    var descendant = function (scope, selector) {
	      return Selectors.one(selector, scope);
	    };
	
	    // Returns Some(closest ancestor element (sugared)) matching 'selector' up to isRoot, or None() otherwise
	    var closest = function (scope, selector, isRoot) {
	      return ClosestOrAncestor(Selectors.is, ancestor, scope, selector, isRoot);
	    };
	
	    return {
	      first: first,
	      ancestor: ancestor,
	      sibling: sibling,
	      child: child,
	      descendant: descendant,
	      closest: closest
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.search.SelectorExists',
	
	  [
	    'ephox.sugar.api.search.SelectorFind'
	  ],
	
	  function (SelectorFind) {
	    var any = function (selector) {
	      return SelectorFind.first(selector).isSome();
	    };
	
	    var ancestor = function (scope, selector, isRoot) {
	      return SelectorFind.ancestor(scope, selector, isRoot).isSome();
	    };
	
	    var sibling = function (scope, selector) {
	      return SelectorFind.sibling(scope, selector).isSome();
	    };
	
	    var child = function (scope, selector) {
	      return SelectorFind.child(scope, selector).isSome();
	    };
	
	    var descendant = function (scope, selector) {
	      return SelectorFind.descendant(scope, selector).isSome();
	    };
	
	    var closest = function (scope, selector, isRoot) {
	      return SelectorFind.closest(scope, selector, isRoot).isSome();
	    };
	
	    return {
	      any: any,
	      ancestor: ancestor,
	      sibling: sibling,
	      child: child,
	      descendant: descendant,
	      closest: closest
	    };
	  }
	);
	
	/**
	 * Empty.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.Empty',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.SelectorExists',
	    'tinymce.core.caret.CaretCandidate',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.TreeWalker'
	  ],
	  function (Fun, Compare, Element, SelectorExists, CaretCandidate, NodeType, TreeWalker) {
	    var hasWhitespacePreserveParent = function (rootNode, node) {
	      var rootElement = Element.fromDom(rootNode);
	      var startNode = Element.fromDom(node);
	      return SelectorExists.ancestor(startNode, 'pre,code', Fun.curry(Compare.eq, rootElement));
	    };
	
	    var isWhitespace = function (rootNode, node) {
	      return NodeType.isText(node) && /^[ \t\r\n]*$/.test(node.data) && hasWhitespacePreserveParent(rootNode, node) === false;
	    };
	
	    var isNamedAnchor = function (node) {
	      return NodeType.isElement(node) && node.nodeName === 'A' && node.hasAttribute('name');
	    };
	
	    var isContent = function (rootNode, node) {
	      return (CaretCandidate.isCaretCandidate(node) && isWhitespace(rootNode, node) === false) || isNamedAnchor(node) || isBookmark(node);
	    };
	
	    var isBookmark = NodeType.hasAttribute('data-mce-bookmark');
	    var isBogus = NodeType.hasAttribute('data-mce-bogus');
	    var isBogusAll = NodeType.hasAttributeValue('data-mce-bogus', 'all');
	
	    var isEmptyNode = function (targetNode) {
	      var walker, node, brCount = 0;
	
	      if (isContent(targetNode, targetNode)) {
	        return false;
	      } else {
	        node = targetNode.firstChild;
	        if (!node) {
	          return true;
	        }
	
	        walker = new TreeWalker(node, targetNode);
	        do {
	          if (isBogusAll(node)) {
	            node = walker.next(true);
	            continue;
	          }
	
	          if (isBogus(node)) {
	            node = walker.next();
	            continue;
	          }
	
	          if (NodeType.isBr(node)) {
	            brCount++;
	            node = walker.next();
	            continue;
	          }
	
	          if (isContent(targetNode, node)) {
	            return false;
	          }
	
	          node = walker.next();
	        } while (node);
	
	        return brCount <= 1;
	      }
	    };
	
	    var isEmpty = function (elm) {
	      return isEmptyNode(elm.dom());
	    };
	
	    return {
	      isEmpty: isEmpty
	    };
	  }
	);
	
	/**
	 * BlockBoundary.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.BlockBoundary',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Options',
	    'ephox.katamari.api.Struct',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'ephox.sugar.api.search.PredicateFind',
	    'ephox.sugar.api.search.Traverse',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.delete.DeleteUtils',
	    'tinymce.core.dom.Empty',
	    'tinymce.core.dom.NodeType'
	  ],
	  function (Arr, Fun, Option, Options, Struct, Compare, Element, Node, PredicateFind, Traverse, CaretFinder, CaretPosition, DeleteUtils, Empty, NodeType) {
	    var BlockPosition = Struct.immutable('block', 'position');
	    var BlockBoundary = Struct.immutable('from', 'to');
	
	    var getBlockPosition = function (rootNode, pos) {
	      var rootElm = Element.fromDom(rootNode);
	      var containerElm = Element.fromDom(pos.container());
	      return DeleteUtils.getParentBlock(rootElm, containerElm).map(function (block) {
	        return BlockPosition(block, pos);
	      });
	    };
	
	    var isDifferentBlocks = function (blockBoundary) {
	      return Compare.eq(blockBoundary.from().block(), blockBoundary.to().block()) === false;
	    };
	
	    var hasSameParent = function (blockBoundary) {
	      return Traverse.parent(blockBoundary.from().block()).bind(function (parent1) {
	        return Traverse.parent(blockBoundary.to().block()).filter(function (parent2) {
	          return Compare.eq(parent1, parent2);
	        });
	      }).isSome();
	    };
	
	    var isEditable = function (blockBoundary) {
	      return NodeType.isContentEditableFalse(blockBoundary.from().block()) === false && NodeType.isContentEditableFalse(blockBoundary.to().block()) === false;
	    };
	
	    var skipLastBr = function (rootNode, forward, blockPosition) {
	      if (NodeType.isBr(blockPosition.position().getNode()) && Empty.isEmpty(blockPosition.block()) === false) {
	        return CaretFinder.positionIn(false, blockPosition.block().dom()).bind(function (lastPositionInBlock) {
	          if (lastPositionInBlock.isEqual(blockPosition.position())) {
	            return CaretFinder.fromPosition(forward, rootNode, lastPositionInBlock).bind(function (to) {
	              return getBlockPosition(rootNode, to);
	            });
	          } else {
	            return Option.some(blockPosition);
	          }
	        }).getOr(blockPosition);
	      } else {
	        return blockPosition;
	      }
	    };
	
	    var readFromRange = function (rootNode, forward, rng) {
	      var fromBlockPos = getBlockPosition(rootNode, CaretPosition.fromRangeStart(rng));
	      var toBlockPos = fromBlockPos.bind(function (blockPos) {
	        return CaretFinder.fromPosition(forward, rootNode, blockPos.position()).bind(function (to) {
	          return getBlockPosition(rootNode, to).map(function (blockPos) {
	            return skipLastBr(rootNode, forward, blockPos);
	          });
	        });
	      });
	
	      return Options.liftN([fromBlockPos, toBlockPos], BlockBoundary).filter(function (blockBoundary) {
	        return isDifferentBlocks(blockBoundary) && hasSameParent(blockBoundary) && isEditable(blockBoundary);
	      });
	    };
	
	    var read = function (rootNode, forward, rng) {
	      return rng.collapsed ? readFromRange(rootNode, forward, rng) : Option.none();
	    };
	
	    return {
	      read: read
	    };
	  }
	);
	
	/**
	 * Parents.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.Parents',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.search.Traverse'
	  ],
	  function (Fun, Compare, Traverse) {
	    var dropLast = function (xs) {
	      return xs.slice(0, -1);
	    };
	
	    var parentsUntil = function (startNode, rootElm, predicate) {
	      if (Compare.contains(rootElm, startNode)) {
	        return dropLast(Traverse.parents(startNode, function (elm) {
	          return predicate(elm) || Compare.eq(elm, rootElm);
	        }));
	      } else {
	        return [];
	      }
	    };
	
	    var parents = function (startNode, rootElm) {
	      return parentsUntil(startNode, rootElm, Fun.constant(false));
	    };
	
	    var parentsAndSelf = function (startNode, rootElm) {
	      return [startNode].concat(parents(startNode, rootElm));
	    };
	
	    return {
	      parentsUntil: parentsUntil,
	      parents: parents,
	      parentsAndSelf: parentsAndSelf
	    };
	  }
	);
	
	/**
	 * MergeBlocks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.MergeBlocks',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.dom.Insert',
	    'ephox.sugar.api.dom.Remove',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.Traverse',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.dom.ElementType',
	    'tinymce.core.dom.Empty',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.PaddingBr',
	    'tinymce.core.dom.Parents'
	  ],
	  function (Arr, Option, Compare, Insert, Remove, Element, Traverse, CaretFinder, CaretPosition, ElementType, Empty, NodeType, PaddingBr, Parents) {
	    var getChildrenUntilBlockBoundary = function (block) {
	      var children = Traverse.children(block);
	      return Arr.findIndex(children, ElementType.isBlock).fold(
	        function () {
	          return children;
	        },
	        function (index) {
	          return children.slice(0, index);
	        }
	      );
	    };
	
	    var extractChildren = function (block) {
	      var children = getChildrenUntilBlockBoundary(block);
	
	      Arr.each(children, function (node) {
	        Remove.remove(node);
	      });
	
	      return children;
	    };
	
	    var trimBr = function (first, block) {
	      CaretFinder.positionIn(first, block.dom()).each(function (position) {
	        var node = position.getNode();
	        if (NodeType.isBr(node)) {
	          Remove.remove(Element.fromDom(node));
	        }
	      });
	    };
	
	    var removeEmptyRoot = function (rootNode, block) {
	      var parents = Parents.parentsAndSelf(block, rootNode);
	      return Arr.find(parents.reverse(), Empty.isEmpty).each(Remove.remove);
	    };
	
	    var findParentInsertPoint = function (toBlock, block) {
	      var parents = Traverse.parents(block, function (elm) {
	        return Compare.eq(elm, toBlock);
	      });
	
	      return Option.from(parents[parents.length - 2]);
	    };
	
	    var getInsertionPoint = function (fromBlock, toBlock) {
	      if (Compare.contains(toBlock, fromBlock)) {
	        return Traverse.parent(fromBlock).bind(function (parent) {
	          return Compare.eq(parent, toBlock) ? Option.some(fromBlock) : findParentInsertPoint(toBlock, fromBlock);
	        });
	      } else {
	        return Option.none();
	      }
	    };
	
	    var mergeBlockInto = function (rootNode, fromBlock, toBlock) {
	      if (Empty.isEmpty(toBlock)) {
	        Remove.remove(toBlock);
	
	        if (Empty.isEmpty(fromBlock)) {
	          PaddingBr.fillWithPaddingBr(fromBlock);
	        }
	
	        return CaretFinder.firstPositionIn(fromBlock.dom());
	      } else {
	        trimBr(true, fromBlock);
	        trimBr(false, toBlock);
	
	        var children = extractChildren(fromBlock);
	
	        return getInsertionPoint(fromBlock, toBlock).fold(
	          function () {
	            removeEmptyRoot(rootNode, fromBlock);
	
	            var position = CaretFinder.lastPositionIn(toBlock.dom());
	
	            Arr.each(children, function (node) {
	              Insert.append(toBlock, node);
	            });
	
	            return position;
	          },
	          function (target) {
	            var position = CaretFinder.prevPosition(toBlock.dom(), CaretPosition.before(target.dom()));
	
	            Arr.each(children, function (node) {
	              Insert.before(target, node);
	            });
	
	            removeEmptyRoot(rootNode, fromBlock);
	
	            return position;
	          }
	        );
	      }
	    };
	
	    var mergeBlocks = function (rootNode, forward, block1, block2) {
	      return forward ? mergeBlockInto(rootNode, block2, block1) : mergeBlockInto(rootNode, block1, block2);
	    };
	
	    return {
	      mergeBlocks: mergeBlocks
	    };
	  }
	);
	
	/**
	 * BlockBoundaryDelete.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.BlockBoundaryDelete',
	  [
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.delete.BlockBoundary',
	    'tinymce.core.delete.MergeBlocks'
	  ],
	  function (Element, BlockBoundary, MergeBlocks) {
	    var backspaceDelete = function (editor, forward) {
	      var position, rootNode = Element.fromDom(editor.getBody());
	
	      position = BlockBoundary.read(rootNode.dom(), forward, editor.selection.getRng()).bind(function (blockBoundary) {
	        return MergeBlocks.mergeBlocks(rootNode, forward, blockBoundary.from().block(), blockBoundary.to().block());
	      });
	
	      position.each(function (pos) {
	        editor.selection.setRng(pos.toRange());
	      });
	
	      return position.isSome();
	    };
	
	    return {
	      backspaceDelete: backspaceDelete
	    };
	  }
	);
	
	/**
	 * BlockRangeDelete.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.BlockRangeDelete',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Options',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.PredicateFind',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.delete.DeleteUtils',
	    'tinymce.core.delete.MergeBlocks',
	    'tinymce.core.dom.ElementType'
	  ],
	  function (Fun, Options, Compare, Element, PredicateFind, CaretFinder, CaretPosition, DeleteUtils, MergeBlocks, ElementType) {
	    var deleteRangeMergeBlocks = function (rootNode, selection) {
	      var rng = selection.getRng();
	
	      return Options.liftN([
	        DeleteUtils.getParentBlock(rootNode, Element.fromDom(rng.startContainer)),
	        DeleteUtils.getParentBlock(rootNode, Element.fromDom(rng.endContainer))
	      ], function (block1, block2) {
	        if (Compare.eq(block1, block2) === false) {
	          rng.deleteContents();
	
	          MergeBlocks.mergeBlocks(rootNode, true, block1, block2).each(function (pos) {
	            selection.setRng(pos.toRange());
	          });
	
	          return true;
	        } else {
	          return false;
	        }
	      }).getOr(false);
	    };
	
	    var isRawNodeInTable = function (root, rawNode) {
	      var node = Element.fromDom(rawNode);
	      var isRoot = Fun.curry(Compare.eq, root);
	      return PredicateFind.ancestor(node, ElementType.isTableCell, isRoot).isSome();
	    };
	
	    var isSelectionInTable = function (root, rng) {
	      return isRawNodeInTable(root, rng.startContainer) || isRawNodeInTable(root, rng.endContainer);
	    };
	
	    var isEverythingSelected = function (root, rng) {
	      var noPrevious = CaretFinder.prevPosition(root.dom(), CaretPosition.fromRangeStart(rng)).isNone();
	      var noNext = CaretFinder.nextPosition(root.dom(), CaretPosition.fromRangeEnd(rng)).isNone();
	      return !isSelectionInTable(root, rng) && noPrevious && noNext;
	    };
	
	    var emptyEditor = function (editor) {
	      editor.setContent('');
	      editor.selection.setCursorLocation();
	      return true;
	    };
	
	    var deleteRange = function (editor) {
	      var rootNode = Element.fromDom(editor.getBody());
	      var rng = editor.selection.getRng();
	      return isEverythingSelected(rootNode, rng) ? emptyEditor(editor) : deleteRangeMergeBlocks(rootNode, editor.selection);
	    };
	
	    var backspaceDelete = function (editor, forward) {
	      return editor.selection.isCollapsed() ? false : deleteRange(editor, editor.selection.getRng());
	    };
	
	    return {
	      backspaceDelete: backspaceDelete
	    };
	  }
	);
	
	define(
	  'ephox.katamari.api.Adt',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Obj',
	    'ephox.katamari.api.Type',
	    'global!Array',
	    'global!Error',
	    'global!console'
	  ],
	
	  function (Arr, Obj, Type, Array, Error, console) {
	    /*
	     * Generates a church encoded ADT (https://en.wikipedia.org/wiki/Church_encoding)
	     * For syntax and use, look at the test code.
	     */
	    var generate = function (cases) {
	      // validation
	      if (!Type.isArray(cases)) {
	        throw new Error('cases must be an array');
	      }
	      if (cases.length === 0) {
	        throw new Error('there must be at least one case');
	      }
	
	      var constructors = [ ];
	
	      // adt is mutated to add the individual cases
	      var adt = {};
	      Arr.each(cases, function (acase, count) {
	        var keys = Obj.keys(acase);
	
	        // validation
	        if (keys.length !== 1) {
	          throw new Error('one and only one name per case');
	        }
	
	        var key = keys[0];
	        var value = acase[key];
	
	        // validation
	        if (adt[key] !== undefined) {
	          throw new Error('duplicate key detected:' + key);
	        } else if (key === 'cata') {
	          throw new Error('cannot have a case named cata (sorry)');
	        } else if (!Type.isArray(value)) {
	          // this implicitly checks if acase is an object
	          throw new Error('case arguments must be an array');
	        }
	
	        constructors.push(key);
	        //
	        // constructor for key
	        //
	        adt[key] = function () {
	          var argLength = arguments.length;
	
	          // validation
	          if (argLength !== value.length) {
	            throw new Error('Wrong number of arguments to case ' + key + '. Expected ' + value.length + ' (' + value + '), got ' + argLength);
	          }
	
	          // Don't use array slice(arguments), makes the whole function unoptimisable on Chrome
	          var args = new Array(argLength);
	          for (var i = 0; i < args.length; i++) args[i] = arguments[i];
	
	
	          var match = function (branches) {
	            var branchKeys = Obj.keys(branches);
	            if (constructors.length !== branchKeys.length) {
	              throw new Error('Wrong number of arguments to match. Expected: ' + constructors.join(',') + '\nActual: ' + branchKeys.join(','));
	            }
	
	            var allReqd = Arr.forall(constructors, function (reqKey) {
	              return Arr.contains(branchKeys, reqKey);
	            });
	
	            if (!allReqd) throw new Error('Not all branches were specified when using match. Specified: ' + branchKeys.join(', ') + '\nRequired: ' + constructors.join(', '));
	
	            return branches[key].apply(null, args);
	          };
	
	          //
	          // the fold function for key
	          //
	          return {
	            fold: function (/* arguments */) {
	              // runtime validation
	              if (arguments.length !== cases.length) {
	                throw new Error('Wrong number of arguments to fold. Expected ' + cases.length + ', got ' + arguments.length);
	              }
	              var target = arguments[count];
	              return target.apply(null, args);
	            },
	            match: match,
	
	            // NOTE: Only for debugging.
	            log: function (label) {
	              console.log(label, {
	                constructors: constructors,
	                constructor: key,
	                params: args
	              });
	            }
	          };
	        };
	      });
	
	      return adt;
	    };
	    return {
	      generate: generate
	    };
	  }
	);
	/**
	 * CefDeleteAction.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.CefDeleteAction',
	  [
	    'ephox.katamari.api.Adt',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.caret.CaretUtils',
	    'tinymce.core.delete.DeleteUtils',
	    'tinymce.core.dom.Empty',
	    'tinymce.core.dom.NodeType'
	  ],
	  function (Adt, Option, Element, CaretFinder, CaretPosition, CaretUtils, DeleteUtils, Empty, NodeType) {
	    var DeleteAction = Adt.generate([
	      { remove: [ 'element' ] },
	      { moveToElement: [ 'element' ] },
	      { moveToPosition: [ 'position' ] }
	    ]);
	
	    var isAtContentEditableBlockCaret = function (forward, from) {
	      var elm = from.getNode(forward === false);
	      var caretLocation = forward ? 'after' : 'before';
	      return NodeType.isElement(elm) && elm.getAttribute('data-mce-caret') === caretLocation;
	    };
	
	    var deleteEmptyBlockOrMoveToCef = function (rootNode, forward, from, to) {
	      var toCefElm = to.getNode(forward === false);
	      return DeleteUtils.getParentBlock(Element.fromDom(rootNode), Element.fromDom(from.getNode())).map(function (blockElm) {
	        return Empty.isEmpty(blockElm) ? DeleteAction.remove(blockElm.dom()) : DeleteAction.moveToElement(toCefElm);
	      }).orThunk(function () {
	        return Option.some(DeleteAction.moveToElement(toCefElm));
	      });
	    };
	
	    var findCefPosition = function (rootNode, forward, from) {
	      return CaretFinder.fromPosition(forward, rootNode, from).bind(function (to) {
	        if (forward && NodeType.isContentEditableFalse(to.getNode())) {
	          return deleteEmptyBlockOrMoveToCef(rootNode, forward, from, to);
	        } else if (forward === false && NodeType.isContentEditableFalse(to.getNode(true))) {
	          return deleteEmptyBlockOrMoveToCef(rootNode, forward, from, to);
	        } else if (forward && CaretUtils.isAfterContentEditableFalse(from)) {
	          return Option.some(DeleteAction.moveToPosition(to));
	        } else if (forward === false && CaretUtils.isBeforeContentEditableFalse(from)) {
	          return Option.some(DeleteAction.moveToPosition(to));
	        } else {
	          return Option.none();
	        }
	      });
	    };
	
	    var getContentEditableBlockAction = function (forward, elm) {
	      if (forward && NodeType.isContentEditableFalse(elm.nextSibling)) {
	        return Option.some(DeleteAction.moveToElement(elm.nextSibling));
	      } else if (forward === false && NodeType.isContentEditableFalse(elm.previousSibling)) {
	        return Option.some(DeleteAction.moveToElement(elm.previousSibling));
	      } else {
	        return Option.none();
	      }
	    };
	
	    var skipMoveToActionFromInlineCefToContent = function (root, from, deleteAction) {
	      return deleteAction.fold(
	        function (elm) {
	          return Option.some(DeleteAction.remove(elm));
	        },
	        function (elm) {
	          return Option.some(DeleteAction.moveToElement(elm));
	        },
	        function (to) {
	          if (CaretUtils.isInSameBlock(from, to, root)) {
	            return Option.none();
	          } else {
	            return Option.some(DeleteAction.moveToPosition(to));
	          }
	        }
	      );
	    };
	
	    var getContentEditableAction = function (rootNode, forward, from) {
	      if (isAtContentEditableBlockCaret(forward, from)) {
	        return getContentEditableBlockAction(forward, from.getNode(forward === false))
	          .fold(
	            function () {
	              return findCefPosition(rootNode, forward, from);
	            },
	            Option.some
	          );
	      } else {
	        return findCefPosition(rootNode, forward, from).bind(function (deleteAction) {
	          return skipMoveToActionFromInlineCefToContent(rootNode, from, deleteAction);
	        });
	      }
	    };
	
	    var read = function (rootNode, forward, rng) {
	      var normalizedRange = CaretUtils.normalizeRange(forward ? 1 : -1, rootNode, rng);
	      var from = CaretPosition.fromRangeStart(normalizedRange);
	
	      if (forward === false && CaretUtils.isAfterContentEditableFalse(from)) {
	        return Option.some(DeleteAction.remove(from.getNode(true)));
	      } else if (forward && CaretUtils.isBeforeContentEditableFalse(from)) {
	        return Option.some(DeleteAction.remove(from.getNode()));
	      } else {
	        return getContentEditableAction(rootNode, forward, from);
	      }
	    };
	
	    return {
	      read: read
	    };
	  }
	);
	
	/**
	 * DeleteElement.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.DeleteElement',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Options',
	    'ephox.sugar.api.dom.Insert',
	    'ephox.sugar.api.dom.Remove',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'ephox.sugar.api.search.PredicateFind',
	    'ephox.sugar.api.search.Traverse',
	    'tinymce.core.caret.CaretCandidate',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.dom.Empty',
	    'tinymce.core.dom.NodeType'
	  ],
	  function (Fun, Option, Options, Insert, Remove, Element, Node, PredicateFind, Traverse, CaretCandidate, CaretFinder, CaretPosition, Empty, NodeType) {
	    var needsReposition = function (pos, elm) {
	      var container = pos.container();
	      var offset = pos.offset();
	      return CaretPosition.isTextPosition(pos) === false && container === elm.parentNode && offset > CaretPosition.before(elm).offset();
	    };
	
	    var reposition = function (elm, pos) {
	      return needsReposition(pos, elm) ? new CaretPosition(pos.container(), pos.offset() - 1) : pos;
	    };
	
	    var beforeOrStartOf = function (node) {
	      return NodeType.isText(node) ? new CaretPosition(node, 0) : CaretPosition.before(node);
	    };
	
	    var afterOrEndOf = function (node) {
	      return NodeType.isText(node) ? new CaretPosition(node, node.data.length) : CaretPosition.after(node);
	    };
	
	    var getPreviousSiblingCaretPosition = function (elm) {
	      if (CaretCandidate.isCaretCandidate(elm.previousSibling)) {
	        return Option.some(afterOrEndOf(elm.previousSibling));
	      } else {
	        return elm.previousSibling ? CaretFinder.lastPositionIn(elm.previousSibling) : Option.none();
	      }
	    };
	
	    var getNextSiblingCaretPosition = function (elm) {
	      if (CaretCandidate.isCaretCandidate(elm.nextSibling)) {
	        return Option.some(beforeOrStartOf(elm.nextSibling));
	      } else {
	        return elm.nextSibling ? CaretFinder.firstPositionIn(elm.nextSibling) : Option.none();
	      }
	    };
	
	    var findCaretPositionBackwardsFromElm = function (rootElement, elm) {
	      var startPosition = CaretPosition.before(elm.previousSibling ? elm.previousSibling : elm.parentNode);
	      return CaretFinder.prevPosition(rootElement, startPosition).fold(
	        function () {
	          return CaretFinder.nextPosition(rootElement, CaretPosition.after(elm));
	        },
	        Option.some
	      );
	    };
	
	    var findCaretPositionForwardsFromElm = function (rootElement, elm) {
	      return CaretFinder.nextPosition(rootElement, CaretPosition.after(elm)).fold(
	        function () {
	          return CaretFinder.prevPosition(rootElement, CaretPosition.before(elm));
	        },
	        Option.some
	      );
	    };
	
	    var findCaretPositionBackwards = function (rootElement, elm) {
	      return getPreviousSiblingCaretPosition(elm).orThunk(function () {
	        return getNextSiblingCaretPosition(elm);
	      }).orThunk(function () {
	        return findCaretPositionBackwardsFromElm(rootElement, elm);
	      });
	    };
	
	    var findCaretPositionForward = function (rootElement, elm) {
	      return getNextSiblingCaretPosition(elm).orThunk(function () {
	        return getPreviousSiblingCaretPosition(elm);
	      }).orThunk(function () {
	        return findCaretPositionForwardsFromElm(rootElement, elm);
	      });
	    };
	
	    var findCaretPosition = function (forward, rootElement, elm) {
	      return forward ? findCaretPositionForward(rootElement, elm) : findCaretPositionBackwards(rootElement, elm);
	    };
	
	    var findCaretPosOutsideElmAfterDelete = function (forward, rootElement, elm) {
	      return findCaretPosition(forward, rootElement, elm).map(Fun.curry(reposition, elm));
	    };
	
	    var setSelection = function (editor, forward, pos) {
	      pos.fold(
	        function () {
	          editor.focus();
	        },
	        function (pos) {
	          editor.selection.setRng(pos.toRange(), forward);
	        }
	      );
	    };
	
	    var eqRawNode = function (rawNode) {
	      return function (elm) {
	        return elm.dom() === rawNode;
	      };
	    };
	
	    var isBlock = function (editor, elm) {
	      return elm && editor.schema.getBlockElements().hasOwnProperty(Node.name(elm));
	    };
	
	    var paddEmptyBlock = function (elm) {
	      if (Empty.isEmpty(elm)) {
	        var br = Element.fromHtml('<br data-mce-bogus="1">');
	        Remove.empty(elm);
	        Insert.append(elm, br);
	        return Option.some(CaretPosition.before(br.dom()));
	      } else {
	        return Option.none();
	      }
	    };
	
	    // When deleting an element between two text nodes IE 11 doesn't automatically merge the adjacent text nodes
	    var deleteNormalized = function (elm, afterDeletePosOpt) {
	      return Options.liftN([Traverse.prevSibling(elm), Traverse.nextSibling(elm), afterDeletePosOpt], function (prev, next, afterDeletePos) {
	        var offset, prevNode = prev.dom(), nextNode = next.dom();
	
	        if (NodeType.isText(prevNode) && NodeType.isText(nextNode)) {
	          offset = prevNode.data.length;
	          prevNode.appendData(nextNode.data);
	          Remove.remove(next);
	          Remove.remove(elm);
	          if (afterDeletePos.container() === nextNode) {
	            return new CaretPosition(prevNode, offset);
	          } else {
	            return afterDeletePos;
	          }
	        } else {
	          Remove.remove(elm);
	          return afterDeletePos;
	        }
	      }).orThunk(function () {
	        Remove.remove(elm);
	        return afterDeletePosOpt;
	      });
	    };
	
	    var deleteElement = function (editor, forward, elm) {
	      var afterDeletePos = findCaretPosOutsideElmAfterDelete(forward, editor.getBody(), elm.dom());
	      var parentBlock = PredicateFind.ancestor(elm, Fun.curry(isBlock, editor), eqRawNode(editor.getBody()));
	      var normalizedAfterDeletePos = deleteNormalized(elm, afterDeletePos);
	
	      if (editor.dom.isEmpty(editor.getBody())) {
	        editor.setContent('');
	        editor.selection.setCursorLocation();
	      } else {
	        parentBlock.bind(paddEmptyBlock).fold(
	          function () {
	            setSelection(editor, forward, normalizedAfterDeletePos);
	          },
	          function (paddPos) {
	            setSelection(editor, forward, Option.some(paddPos));
	          }
	        );
	      }
	    };
	
	    return {
	      deleteElement: deleteElement
	    };
	  }
	);
	/**
	 * CefDelete.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.CefDelete',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.dom.Remove',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.SelectorFilter',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.delete.CefDeleteAction',
	    'tinymce.core.delete.DeleteElement',
	    'tinymce.core.delete.DeleteUtils',
	    'tinymce.core.dom.NodeType'
	  ],
	  function (Arr, Remove, Element, SelectorFilter, CaretPosition, CefDeleteAction, DeleteElement, DeleteUtils, NodeType) {
	    var deleteElement = function (editor, forward) {
	      return function (element) {
	        editor._selectionOverrides.hideFakeCaret();
	        DeleteElement.deleteElement(editor, forward, Element.fromDom(element));
	        return true;
	      };
	    };
	
	    var moveToElement = function (editor, forward) {
	      return function (element) {
	        var pos = forward ? CaretPosition.before(element) : CaretPosition.after(element);
	        editor.selection.setRng(pos.toRange());
	        return true;
	      };
	    };
	
	    var moveToPosition = function (editor) {
	      return function (pos) {
	        editor.selection.setRng(pos.toRange());
	        return true;
	      };
	    };
	
	    var backspaceDeleteCaret = function (editor, forward) {
	      var result = CefDeleteAction.read(editor.getBody(), forward, editor.selection.getRng()).map(function (deleteAction) {
	        return deleteAction.fold(
	          deleteElement(editor, forward),
	          moveToElement(editor, forward),
	          moveToPosition(editor)
	        );
	      });
	
	      return result.getOr(false);
	    };
	
	    var deleteOffscreenSelection = function (rootElement) {
	      Arr.each(SelectorFilter.descendants(rootElement, '.mce-offscreen-selection'), Remove.remove);
	    };
	
	    var backspaceDeleteRange = function (editor, forward) {
	      var selectedElement = editor.selection.getNode();
	      if (NodeType.isContentEditableFalse(selectedElement)) {
	        deleteOffscreenSelection(Element.fromDom(editor.getBody()));
	        DeleteElement.deleteElement(editor, forward, Element.fromDom(editor.selection.getNode()));
	        DeleteUtils.paddEmptyBody(editor);
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    var getContentEditableRoot = function (root, node) {
	      while (node && node !== root) {
	        if (NodeType.isContentEditableTrue(node) || NodeType.isContentEditableFalse(node)) {
	          return node;
	        }
	
	        node = node.parentNode;
	      }
	
	      return null;
	    };
	
	    var paddEmptyElement = function (editor) {
	      var br, ceRoot = getContentEditableRoot(editor.getBody(), editor.selection.getNode());
	
	      if (NodeType.isContentEditableTrue(ceRoot) && editor.dom.isBlock(ceRoot) && editor.dom.isEmpty(ceRoot)) {
	        br = editor.dom.create('br', { "data-mce-bogus": "1" });
	        editor.dom.setHTML(ceRoot, '');
	        ceRoot.appendChild(br);
	        editor.selection.setRng(CaretPosition.before(br).toRange());
	      }
	
	      return true;
	    };
	
	    var backspaceDelete = function (editor, forward) {
	      if (editor.selection.isCollapsed()) {
	        return backspaceDeleteCaret(editor, forward);
	      } else {
	        return backspaceDeleteRange(editor, forward);
	      }
	    };
	
	    return {
	      backspaceDelete: backspaceDelete,
	      paddEmptyElement: paddEmptyElement
	    };
	  }
	);
	
	/**
	 * CaretContainerInline.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.caret.CaretContainerInline',
	  [
	    'ephox.katamari.api.Fun',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.text.Zwsp'
	  ],
	  function (Fun, NodeType, Zwsp) {
	    var isText = NodeType.isText;
	
	    var startsWithCaretContainer = function (node) {
	      return isText(node) && node.data[0] === Zwsp.ZWSP;
	    };
	
	    var endsWithCaretContainer = function (node) {
	      return isText(node) && node.data[node.data.length - 1] === Zwsp.ZWSP;
	    };
	
	    var createZwsp = function (node) {
	      return node.ownerDocument.createTextNode(Zwsp.ZWSP);
	    };
	
	    var insertBefore = function (node) {
	      if (isText(node.previousSibling)) {
	        if (endsWithCaretContainer(node.previousSibling)) {
	          return node.previousSibling;
	        } else {
	          node.previousSibling.appendData(Zwsp.ZWSP);
	          return node.previousSibling;
	        }
	      } else if (isText(node)) {
	        if (startsWithCaretContainer(node)) {
	          return node;
	        } else {
	          node.insertData(0, Zwsp.ZWSP);
	          return node;
	        }
	      } else {
	        var newNode = createZwsp(node);
	        node.parentNode.insertBefore(newNode, node);
	        return newNode;
	      }
	    };
	
	    var insertAfter = function (node) {
	      if (isText(node.nextSibling)) {
	        if (startsWithCaretContainer(node.nextSibling)) {
	          return node.nextSibling;
	        } else {
	          node.nextSibling.insertData(0, Zwsp.ZWSP);
	          return node.nextSibling;
	        }
	      } else if (isText(node)) {
	        if (endsWithCaretContainer(node)) {
	          return node;
	        } else {
	          node.appendData(Zwsp.ZWSP);
	          return node;
	        }
	      } else {
	        var newNode = createZwsp(node);
	        if (node.nextSibling) {
	          node.parentNode.insertBefore(newNode, node.nextSibling);
	        } else {
	          node.parentNode.appendChild(newNode);
	        }
	        return newNode;
	      }
	    };
	
	    var insertInline = function (before, node) {
	      return before ? insertBefore(node) : insertAfter(node);
	    };
	
	    return {
	      insertInline: insertInline,
	      insertInlineBefore: Fun.curry(insertInline, true),
	      insertInlineAfter: Fun.curry(insertInline, false)
	    };
	  }
	);
	/**
	 * CaretContainerRemove.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.caret.CaretContainerRemove',
	  [
	    'ephox.katamari.api.Arr',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.text.Zwsp'
	  ],
	  function (Arr, CaretContainer, CaretPosition, NodeType, Zwsp) {
	    var isElement = NodeType.isElement;
	    var isText = NodeType.isText;
	
	    var removeNode = function (node) {
	      var parentNode = node.parentNode;
	      if (parentNode) {
	        parentNode.removeChild(node);
	      }
	    };
	
	    var getNodeValue = function (node) {
	      try {
	        return node.nodeValue;
	      } catch (ex) {
	        // IE sometimes produces "Invalid argument" on nodes
	        return "";
	      }
	    };
	
	    var setNodeValue = function (node, text) {
	      if (text.length === 0) {
	        removeNode(node);
	      } else {
	        node.nodeValue = text;
	      }
	    };
	
	    var trimCount = function (text) {
	      var trimmedText = Zwsp.trim(text);
	      return { count: text.length - trimmedText.length, text: trimmedText };
	    };
	
	    var removeUnchanged = function (caretContainer, pos) {
	      remove(caretContainer);
	      return pos;
	    };
	
	    var removeTextAndReposition = function (caretContainer, pos) {
	      var before = trimCount(caretContainer.data.substr(0, pos.offset()));
	      var after = trimCount(caretContainer.data.substr(pos.offset()));
	      var text = before.text + after.text;
	
	      if (text.length > 0) {
	        setNodeValue(caretContainer, text);
	        return new CaretPosition(caretContainer, pos.offset() - before.count);
	      } else {
	        return pos;
	      }
	    };
	
	    var removeElementAndReposition = function (caretContainer, pos) {
	      var parentNode = pos.container();
	      var newPosition = Arr.indexOf(parentNode.childNodes, caretContainer).map(function (index) {
	        return index < pos.offset() ? new CaretPosition(parentNode, pos.offset() - 1) : pos;
	      }).getOr(pos);
	      remove(caretContainer);
	      return newPosition;
	    };
	
	    var removeTextCaretContainer = function (caretContainer, pos) {
	      return pos.container() === caretContainer ? removeTextAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
	    };
	
	    var removeElementCaretContainer = function (caretContainer, pos) {
	      return pos.container() === caretContainer.parentNode ? removeElementAndReposition(caretContainer, pos) : removeUnchanged(caretContainer, pos);
	    };
	
	    var removeAndReposition = function (container, pos) {
	      return CaretPosition.isTextPosition(pos) ? removeTextCaretContainer(container, pos) : removeElementCaretContainer(container, pos);
	    };
	
	    var remove = function (caretContainerNode) {
	      if (isElement(caretContainerNode) && CaretContainer.isCaretContainer(caretContainerNode)) {
	        if (CaretContainer.hasContent(caretContainerNode)) {
	          caretContainerNode.removeAttribute('data-mce-caret');
	        } else {
	          removeNode(caretContainerNode);
	        }
	      }
	
	      if (isText(caretContainerNode)) {
	        var text = Zwsp.trim(getNodeValue(caretContainerNode));
	        setNodeValue(caretContainerNode, text);
	      }
	    };
	
	    return {
	      removeAndReposition: removeAndReposition,
	      remove: remove
	    };
	  }
	);
	/**
	 * BoundaryCaret.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.BoundaryCaret',
	  [
	    'ephox.katamari.api.Option',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.caret.CaretContainerInline',
	    'tinymce.core.caret.CaretContainerRemove',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.keyboard.InlineUtils'
	  ],
	  function (Option, CaretContainer, CaretContainerInline, CaretContainerRemove, CaretFinder, CaretPosition, NodeType, InlineUtils) {
	    var insertInlinePos = function (pos, before) {
	      if (NodeType.isText(pos.container())) {
	        return CaretContainerInline.insertInline(before, pos.container());
	      } else {
	        return CaretContainerInline.insertInline(before, pos.getNode());
	      }
	    };
	
	    var isPosCaretContainer = function (pos, caret) {
	      var caretNode = caret.get();
	      return caretNode && pos.container() === caretNode && CaretContainer.isCaretContainerInline(caretNode);
	    };
	
	    var renderCaret = function (caret, location) {
	      return location.fold(
	        function (element) { // Before
	          CaretContainerRemove.remove(caret.get());
	          var text = CaretContainerInline.insertInlineBefore(element);
	          caret.set(text);
	          return Option.some(new CaretPosition(text, text.length - 1));
	        },
	        function (element) { // Start
	          return CaretFinder.firstPositionIn(element).map(function (pos) {
	            if (!isPosCaretContainer(pos, caret)) {
	              CaretContainerRemove.remove(caret.get());
	              var text = insertInlinePos(pos, true);
	              caret.set(text);
	              return new CaretPosition(text, 1);
	            } else {
	              return new CaretPosition(caret.get(), 1);
	            }
	          });
	        },
	        function (element) { // End
	          return CaretFinder.lastPositionIn(element).map(function (pos) {
	            if (!isPosCaretContainer(pos, caret)) {
	              CaretContainerRemove.remove(caret.get());
	              var text = insertInlinePos(pos, false);
	              caret.set(text);
	              return new CaretPosition(text, text.length - 1);
	            } else {
	              return new CaretPosition(caret.get(), caret.get().length - 1);
	            }
	          });
	        },
	        function (element) { // After
	          CaretContainerRemove.remove(caret.get());
	          var text = CaretContainerInline.insertInlineAfter(element);
	          caret.set(text);
	          return Option.some(new CaretPosition(text, 1));
	        }
	      );
	    };
	
	    return {
	      renderCaret: renderCaret
	    };
	  }
	);
	/**
	 * FormatUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.FormatUtils',
	  [
	    'tinymce.core.dom.TreeWalker'
	  ],
	  function (TreeWalker) {
	    var isInlineBlock = function (node) {
	      return node && /^(IMG)$/.test(node.nodeName);
	    };
	
	    var moveStart = function (dom, selection, rng) {
	      var container = rng.startContainer,
	        offset = rng.startOffset,
	        walker, node, nodes;
	
	      if (rng.startContainer === rng.endContainer) {
	        if (isInlineBlock(rng.startContainer.childNodes[rng.startOffset])) {
	          return;
	        }
	      }
	
	      // Convert text node into index if possible
	      if (container.nodeType === 3 && offset >= container.nodeValue.length) {
	        // Get the parent container location and walk from there
	        offset = dom.nodeIndex(container);
	        container = container.parentNode;
	      }
	
	      // Move startContainer/startOffset in to a suitable node
	      if (container.nodeType === 1) {
	        nodes = container.childNodes;
	        if (offset < nodes.length) {
	          container = nodes[offset];
	          walker = new TreeWalker(container, dom.getParent(container, dom.isBlock));
	        } else {
	          container = nodes[nodes.length - 1];
	          walker = new TreeWalker(container, dom.getParent(container, dom.isBlock));
	          walker.next(true);
	        }
	
	        for (node = walker.current(); node; node = walker.next()) {
	          if (node.nodeType === 3 && !isWhiteSpaceNode(node)) {
	            rng.setStart(node, 0);
	            selection.setRng(rng);
	
	            return;
	          }
	        }
	      }
	    };
	
	    /**
	     * Returns the next/previous non whitespace node.
	     *
	     * @private
	     * @param {Node} node Node to start at.
	     * @param {boolean} next (Optional) Include next or previous node defaults to previous.
	     * @param {boolean} inc (Optional) Include the current node in checking. Defaults to false.
	     * @return {Node} Next or previous node or undefined if it wasn't found.
	     */
	    var getNonWhiteSpaceSibling = function (node, next, inc) {
	      if (node) {
	        next = next ? 'nextSibling' : 'previousSibling';
	
	        for (node = inc ? node : node[next]; node; node = node[next]) {
	          if (node.nodeType === 1 || !isWhiteSpaceNode(node)) {
	            return node;
	          }
	        }
	      }
	    };
	
	    var isTextBlock = function (editor, name) {
	      if (name.nodeType) {
	        name = name.nodeName;
	      }
	
	      return !!editor.schema.getTextBlockElements()[name.toLowerCase()];
	    };
	
	    var isValid = function (ed, parent, child) {
	      return ed.schema.isValidChild(parent, child);
	    };
	
	    var isWhiteSpaceNode = function (node) {
	      return node && node.nodeType === 3 && /^([\t \r\n]+|)$/.test(node.nodeValue);
	    };
	
	    /**
	     * Replaces variables in the value. The variable format is %var.
	     *
	     * @private
	     * @param {String} value Value to replace variables in.
	     * @param {Object} vars Name/value array with variables to replace.
	     * @return {String} New value with replaced variables.
	     */
	    var replaceVars = function (value, vars) {
	      if (typeof value !== "string") {
	        value = value(vars);
	      } else if (vars) {
	        value = value.replace(/%(\w+)/g, function (str, name) {
	          return vars[name] || str;
	        });
	      }
	
	      return value;
	    };
	
	    /**
	     * Compares two string/nodes regardless of their case.
	     *
	     * @private
	     * @param {String/Node} str1 Node or string to compare.
	     * @param {String/Node} str2 Node or string to compare.
	     * @return {boolean} True/false if they match.
	     */
	    var isEq = function (str1, str2) {
	      str1 = str1 || '';
	      str2 = str2 || '';
	
	      str1 = '' + (str1.nodeName || str1);
	      str2 = '' + (str2.nodeName || str2);
	
	      return str1.toLowerCase() === str2.toLowerCase();
	    };
	
	    var normalizeStyleValue = function (dom, value, name) {
	      // Force the format to hex
	      if (name === 'color' || name === 'backgroundColor') {
	        value = dom.toHex(value);
	      }
	
	      // Opera will return bold as 700
	      if (name === 'fontWeight' && value === 700) {
	        value = 'bold';
	      }
	
	      // Normalize fontFamily so "'Font name', Font" becomes: "Font name,Font"
	      if (name === 'fontFamily') {
	        value = value.replace(/[\'\"]/g, '').replace(/,\s+/g, ',');
	      }
	
	      return '' + value;
	    };
	
	    var getStyle = function (dom, node, name) {
	      return normalizeStyleValue(dom, dom.getStyle(node, name), name);
	    };
	
	    var getTextDecoration = function (dom, node) {
	      var decoration;
	
	      dom.getParent(node, function (n) {
	        decoration = dom.getStyle(n, 'text-decoration');
	        return decoration && decoration !== 'none';
	      });
	
	      return decoration;
	    };
	
	    var getParents = function (dom, node, selector) {
	      return dom.getParents(node, selector, dom.getRoot());
	    };
	
	    return {
	      isInlineBlock: isInlineBlock,
	      moveStart: moveStart,
	      getNonWhiteSpaceSibling: getNonWhiteSpaceSibling,
	      isTextBlock: isTextBlock,
	      isValid: isValid,
	      isWhiteSpaceNode: isWhiteSpaceNode,
	      replaceVars: replaceVars,
	      isEq: isEq,
	      normalizeStyleValue: normalizeStyleValue,
	      getStyle: getStyle,
	      getTextDecoration: getTextDecoration,
	      getParents: getParents
	    };
	  }
	);
	/**
	 * ExpandRange.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.ExpandRange',
	  [
	    'tinymce.core.dom.Bookmarks',
	    'tinymce.core.dom.TreeWalker',
	    'tinymce.core.fmt.FormatUtils',
	    'tinymce.core.selection.RangeNodes'
	  ],
	  function (Bookmarks, TreeWalker, FormatUtils, RangeNodes) {
	    var isBookmarkNode = Bookmarks.isBookmarkNode;
	    var getParents = FormatUtils.getParents, isWhiteSpaceNode = FormatUtils.isWhiteSpaceNode, isTextBlock = FormatUtils.isTextBlock;
	
	    // This function walks down the tree to find the leaf at the selection.
	    // The offset is also returned as if node initially a leaf, the offset may be in the middle of the text node.
	    var findLeaf = function (node, offset) {
	      if (typeof offset === 'undefined') {
	        offset = node.nodeType === 3 ? node.length : node.childNodes.length;
	      }
	
	      while (node && node.hasChildNodes()) {
	        node = node.childNodes[offset];
	        if (node) {
	          offset = node.nodeType === 3 ? node.length : node.childNodes.length;
	        }
	      }
	
	      return { node: node, offset: offset };
	    };
	
	    var excludeTrailingWhitespace = function (endContainer, endOffset) {
	      // Avoid applying formatting to a trailing space,
	      // but remove formatting from trailing space
	      var leaf = findLeaf(endContainer, endOffset);
	      if (leaf.node) {
	        while (leaf.node && leaf.offset === 0 && leaf.node.previousSibling) {
	          leaf = findLeaf(leaf.node.previousSibling);
	        }
	
	        if (leaf.node && leaf.offset > 0 && leaf.node.nodeType === 3 &&
	            leaf.node.nodeValue.charAt(leaf.offset - 1) === ' ') {
	
	          if (leaf.offset > 1) {
	            endContainer = leaf.node;
	            endContainer.splitText(leaf.offset - 1);
	          }
	        }
	      }
	
	      return endContainer;
	    };
	
	    var isBogusBr = function (node) {
	      return node.nodeName === "BR" && node.getAttribute('data-mce-bogus') && !node.nextSibling;
	    };
	
	    // Expands the node to the closes contentEditable false element if it exists
	    var findParentContentEditable = function (dom, node) {
	      var parent = node;
	
	      while (parent) {
	        if (parent.nodeType === 1 && dom.getContentEditable(parent)) {
	          return dom.getContentEditable(parent) === "false" ? parent : node;
	        }
	
	        parent = parent.parentNode;
	      }
	
	      return node;
	    };
	
	    var findSpace = function (start, remove, node, offset) {
	      var pos, pos2, str = node.nodeValue;
	
	      if (typeof offset === "undefined") {
	        offset = start ? str.length : 0;
	      }
	
	      if (start) {
	        pos = str.lastIndexOf(' ', offset);
	        pos2 = str.lastIndexOf('\u00a0', offset);
	        pos = pos > pos2 ? pos : pos2;
	
	        // Include the space on remove to avoid tag soup
	        if (pos !== -1 && !remove) {
	          pos++;
	        }
	      } else {
	        pos = str.indexOf(' ', offset);
	        pos2 = str.indexOf('\u00a0', offset);
	        pos = pos !== -1 && (pos2 === -1 || pos < pos2) ? pos : pos2;
	      }
	
	      return pos;
	    };
	
	    var findWordEndPoint = function (dom, body, container, offset, start, remove) {
	      var walker, node, pos, lastTextNode;
	
	      if (container.nodeType === 3) {
	        pos = findSpace(start, remove, container, offset);
	
	        if (pos !== -1) {
	          return { container: container, offset: pos };
	        }
	
	        lastTextNode = container;
	      }
	
	      // Walk the nodes inside the block
	      walker = new TreeWalker(container, dom.getParent(container, dom.isBlock) || body);
	      while ((node = walker[start ? 'prev' : 'next']())) {
	        if (node.nodeType === 3) {
	          lastTextNode = node;
	          pos = findSpace(start, remove, node);
	
	          if (pos !== -1) {
	            return { container: node, offset: pos };
	          }
	        } else if (dom.isBlock(node)) {
	          break;
	        }
	      }
	
	      if (lastTextNode) {
	        if (start) {
	          offset = 0;
	        } else {
	          offset = lastTextNode.length;
	        }
	
	        return { container: lastTextNode, offset: offset };
	      }
	    };
	
	    var findSelectorEndPoint = function (dom, format, rng, container, siblingName) {
	      var parents, i, y, curFormat;
	
	      if (container.nodeType === 3 && container.nodeValue.length === 0 && container[siblingName]) {
	        container = container[siblingName];
	      }
	
	      parents = getParents(dom, container);
	      for (i = 0; i < parents.length; i++) {
	        for (y = 0; y < format.length; y++) {
	          curFormat = format[y];
	
	          // If collapsed state is set then skip formats that doesn't match that
	          if ("collapsed" in curFormat && curFormat.collapsed !== rng.collapsed) {
	            continue;
	          }
	
	          if (dom.is(parents[i], curFormat.selector)) {
	            return parents[i];
	          }
	        }
	      }
	
	      return container;
	    };
	
	    var findBlockEndPoint = function (editor, format, container, siblingName) {
	      var node, dom = editor.dom, root = dom.getRoot();
	
	      // Expand to block of similar type
	      if (!format[0].wrapper) {
	        node = dom.getParent(container, format[0].block, root);
	      }
	
	      // Expand to first wrappable block element or any block element
	      if (!node) {
	        var scopeRoot = dom.getParent(container, 'LI,TD,TH');
	        node = dom.getParent(container.nodeType === 3 ? container.parentNode : container, function (node) {
	          // Fixes #6183 where it would expand to editable parent element in inline mode
	          return node !== root && isTextBlock(editor, node);
	        }, scopeRoot);
	      }
	
	      // Exclude inner lists from wrapping
	      if (node && format[0].wrapper) {
	        node = getParents(dom, node, 'ul,ol').reverse()[0] || node;
	      }
	
	      // Didn't find a block element look for first/last wrappable element
	      if (!node) {
	        node = container;
	
	        while (node[siblingName] && !dom.isBlock(node[siblingName])) {
	          node = node[siblingName];
	
	          // Break on BR but include it will be removed later on
	          // we can't remove it now since we need to check if it can be wrapped
	          if (FormatUtils.isEq(node, 'br')) {
	            break;
	          }
	        }
	      }
	
	      return node || container;
	    };
	
	    // This function walks up the tree if there is no siblings before/after the node
	    var findParentContainer = function (dom, format, startContainer, startOffset, endContainer, endOffset, start) {
	      var container, parent, sibling, siblingName, root;
	
	      container = parent = start ? startContainer : endContainer;
	      siblingName = start ? 'previousSibling' : 'nextSibling';
	      root = dom.getRoot();
	
	      // If it's a text node and the offset is inside the text
	      if (container.nodeType === 3 && !isWhiteSpaceNode(container)) {
	        if (start ? startOffset > 0 : endOffset < container.nodeValue.length) {
	          return container;
	        }
	      }
	
	      /*eslint no-constant-condition:0 */
	      while (true) {
	        // Stop expanding on block elements
	        if (!format[0].block_expand && dom.isBlock(parent)) {
	          return parent;
	        }
	
	        // Walk left/right
	        for (sibling = parent[siblingName]; sibling; sibling = sibling[siblingName]) {
	          if (!isBookmarkNode(sibling) && !isWhiteSpaceNode(sibling) && !isBogusBr(sibling)) {
	            return parent;
	          }
	        }
	
	        // Check if we can move up are we at root level or body level
	        if (parent === root || parent.parentNode === root) {
	          container = parent;
	          break;
	        }
	
	        parent = parent.parentNode;
	      }
	
	      return container;
	    };
	
	    var expandRng = function (editor, rng, format, remove) {
	      var endPoint,
	        startContainer = rng.startContainer,
	        startOffset = rng.startOffset,
	        endContainer = rng.endContainer,
	        endOffset = rng.endOffset,
	        dom = editor.dom;
	
	      // If index based start position then resolve it
	      if (startContainer.nodeType === 1 && startContainer.hasChildNodes()) {
	        startContainer = RangeNodes.getNode(startContainer, startOffset);
	        if (startContainer.nodeType === 3) {
	          startOffset = 0;
	        }
	      }
	
	      // If index based end position then resolve it
	      if (endContainer.nodeType === 1 && endContainer.hasChildNodes()) {
	        endContainer = RangeNodes.getNode(endContainer, rng.collapsed ? endOffset : endOffset - 1);
	        if (endContainer.nodeType === 3) {
	          endOffset = endContainer.nodeValue.length;
	        }
	      }
	
	      // Expand to closest contentEditable element
	      startContainer = findParentContentEditable(dom, startContainer);
	      endContainer = findParentContentEditable(dom, endContainer);
	
	      // Exclude bookmark nodes if possible
	      if (isBookmarkNode(startContainer.parentNode) || isBookmarkNode(startContainer)) {
	        startContainer = isBookmarkNode(startContainer) ? startContainer : startContainer.parentNode;
	        startContainer = startContainer.nextSibling || startContainer;
	
	        if (startContainer.nodeType === 3) {
	          startOffset = 0;
	        }
	      }
	
	      if (isBookmarkNode(endContainer.parentNode) || isBookmarkNode(endContainer)) {
	        endContainer = isBookmarkNode(endContainer) ? endContainer : endContainer.parentNode;
	        endContainer = endContainer.previousSibling || endContainer;
	
	        if (endContainer.nodeType === 3) {
	          endOffset = endContainer.length;
	        }
	      }
	
	      if (format[0].inline) {
	        if (rng.collapsed) {
	          // Expand left to closest word boundary
	          endPoint = findWordEndPoint(dom, editor.getBody(), startContainer, startOffset, true, remove);
	          if (endPoint) {
	            startContainer = endPoint.container;
	            startOffset = endPoint.offset;
	          }
	
	          // Expand right to closest word boundary
	          endPoint = findWordEndPoint(dom, editor.getBody(), endContainer, endOffset, false, remove);
	          if (endPoint) {
	            endContainer = endPoint.container;
	            endOffset = endPoint.offset;
	          }
	        }
	
	        endContainer = remove ? endContainer : excludeTrailingWhitespace(endContainer, endOffset);
	      }
	
	      // Move start/end point up the tree if the leaves are sharp and if we are in different containers
	      // Example * becomes !: !<p><b><i>*text</i><i>text*</i></b></p>!
	      // This will reduce the number of wrapper elements that needs to be created
	      // Move start point up the tree
	      if (format[0].inline || format[0].block_expand) {
	        if (!format[0].inline || (startContainer.nodeType !== 3 || startOffset === 0)) {
	          startContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, true);
	        }
	
	        if (!format[0].inline || (endContainer.nodeType !== 3 || endOffset === endContainer.nodeValue.length)) {
	          endContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, false);
	        }
	      }
	
	      // Expand start/end container to matching selector
	      if (format[0].selector && format[0].expand !== false && !format[0].inline) {
	        // Find new startContainer/endContainer if there is better one
	        startContainer = findSelectorEndPoint(dom, format, rng, startContainer, 'previousSibling');
	        endContainer = findSelectorEndPoint(dom, format, rng, endContainer, 'nextSibling');
	      }
	
	      // Expand start/end container to matching block element or text node
	      if (format[0].block || format[0].selector) {
	        // Find new startContainer/endContainer if there is better one
	        startContainer = findBlockEndPoint(editor, format, startContainer, 'previousSibling');
	        endContainer = findBlockEndPoint(editor, format, endContainer, 'nextSibling');
	
	        // Non block element then try to expand up the leaf
	        if (format[0].block) {
	          if (!dom.isBlock(startContainer)) {
	            startContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, true);
	          }
	
	          if (!dom.isBlock(endContainer)) {
	            endContainer = findParentContainer(dom, format, startContainer, startOffset, endContainer, endOffset, false);
	          }
	        }
	      }
	
	      // Setup index for startContainer
	      if (startContainer.nodeType === 1) {
	        startOffset = dom.nodeIndex(startContainer);
	        startContainer = startContainer.parentNode;
	      }
	
	      // Setup index for endContainer
	      if (endContainer.nodeType === 1) {
	        endOffset = dom.nodeIndex(endContainer) + 1;
	        endContainer = endContainer.parentNode;
	      }
	
	      // Return new range like object
	      return {
	        startContainer: startContainer,
	        startOffset: startOffset,
	        endContainer: endContainer,
	        endOffset: endOffset
	      };
	    };
	
	    return {
	      expandRng: expandRng
	    };
	  }
	);
	/**
	 * MatchFormat.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.MatchFormat',
	  [
	    'tinymce.core.fmt.FormatUtils'
	  ],
	  function (FormatUtils) {
	    var isEq = FormatUtils.isEq;
	
	    var matchesUnInheritedFormatSelector = function (ed, node, name) {
	      var formatList = ed.formatter.get(name);
	
	      if (formatList) {
	        for (var i = 0; i < formatList.length; i++) {
	          if (formatList[i].inherit === false && ed.dom.is(node, formatList[i].selector)) {
	            return true;
	          }
	        }
	      }
	
	      return false;
	    };
	
	    var matchParents = function (editor, node, name, vars) {
	      var root = editor.dom.getRoot();
	
	      if (node === root) {
	        return false;
	      }
	
	      // Find first node with similar format settings
	      node = editor.dom.getParent(node, function (node) {
	        if (matchesUnInheritedFormatSelector(editor, node, name)) {
	          return true;
	        }
	
	        return node.parentNode === root || !!matchNode(editor, node, name, vars, true);
	      });
	
	      // Do an exact check on the similar format element
	      return matchNode(editor, node, name, vars);
	    };
	
	    var matchName = function (dom, node, format) {
	      // Check for inline match
	      if (isEq(node, format.inline)) {
	        return true;
	      }
	
	      // Check for block match
	      if (isEq(node, format.block)) {
	        return true;
	      }
	
	      // Check for selector match
	      if (format.selector) {
	        return node.nodeType === 1 && dom.is(node, format.selector);
	      }
	    };
	
	    var matchItems = function (dom, node, format, itemName, similar, vars) {
	      var key, value, items = format[itemName], i;
	
	      // Custom match
	      if (format.onmatch) {
	        return format.onmatch(node, format, itemName);
	      }
	
	      // Check all items
	      if (items) {
	        // Non indexed object
	        if (typeof items.length === 'undefined') {
	          for (key in items) {
	            if (items.hasOwnProperty(key)) {
	              if (itemName === 'attributes') {
	                value = dom.getAttrib(node, key);
	              } else {
	                value = FormatUtils.getStyle(dom, node, key);
	              }
	
	              if (similar && !value && !format.exact) {
	                return;
	              }
	
	              if ((!similar || format.exact) && !isEq(value, FormatUtils.normalizeStyleValue(dom, FormatUtils.replaceVars(items[key], vars), key))) {
	                return;
	              }
	            }
	          }
	        } else {
	          // Only one match needed for indexed arrays
	          for (i = 0; i < items.length; i++) {
	            if (itemName === 'attributes' ? dom.getAttrib(node, items[i]) : FormatUtils.getStyle(dom, node, items[i])) {
	              return format;
	            }
	          }
	        }
	      }
	
	      return format;
	    };
	
	    var matchNode = function (ed, node, name, vars, similar) {
	      var formatList = ed.formatter.get(name), format, i, x, classes, dom = ed.dom;
	
	      if (formatList && node) {
	        // Check each format in list
	        for (i = 0; i < formatList.length; i++) {
	          format = formatList[i];
	
	          // Name name, attributes, styles and classes
	          if (matchName(ed.dom, node, format) && matchItems(dom, node, format, 'attributes', similar, vars) && matchItems(dom, node, format, 'styles', similar, vars)) {
	            // Match classes
	            if ((classes = format.classes)) {
	              for (x = 0; x < classes.length; x++) {
	                if (!ed.dom.hasClass(node, classes[x])) {
	                  return;
	                }
	              }
	            }
	
	            return format;
	          }
	        }
	      }
	    };
	
	    var match = function (editor, name, vars, node) {
	      var startNode;
	
	      // Check specified node
	      if (node) {
	        return matchParents(editor, node, name, vars);
	      }
	
	      // Check selected node
	      node = editor.selection.getNode();
	      if (matchParents(editor, node, name, vars)) {
	        return true;
	      }
	
	      // Check start node if it's different
	      startNode = editor.selection.getStart();
	      if (startNode !== node) {
	        if (matchParents(editor, startNode, name, vars)) {
	          return true;
	        }
	      }
	
	      return false;
	    };
	
	    var matchAll = function (editor, names, vars) {
	      var startElement, matchedFormatNames = [], checkedMap = {};
	
	      // Check start of selection for formats
	      startElement = editor.selection.getStart();
	      editor.dom.getParent(startElement, function (node) {
	        var i, name;
	
	        for (i = 0; i < names.length; i++) {
	          name = names[i];
	
	          if (!checkedMap[name] && matchNode(editor, node, name, vars)) {
	            checkedMap[name] = true;
	            matchedFormatNames.push(name);
	          }
	        }
	      }, editor.dom.getRoot());
	
	      return matchedFormatNames;
	    };
	
	    var canApply = function (editor, name) {
	      var formatList = editor.formatter.get(name), startNode, parents, i, x, selector, dom = editor.dom;
	
	      if (formatList) {
	        startNode = editor.selection.getStart();
	        parents = FormatUtils.getParents(dom, startNode);
	
	        for (x = formatList.length - 1; x >= 0; x--) {
	          selector = formatList[x].selector;
	
	          // Format is not selector based then always return TRUE
	          // Is it has a defaultBlock then it's likely it can be applied for example align on a non block element line
	          if (!selector || formatList[x].defaultBlock) {
	            return true;
	          }
	
	          for (i = parents.length - 1; i >= 0; i--) {
	            if (dom.is(parents[i], selector)) {
	              return true;
	            }
	          }
	        }
	      }
	
	      return false;
	    };
	
	    return {
	      matchNode: matchNode,
	      matchName: matchName,
	      match: match,
	      matchAll: matchAll,
	      canApply: canApply,
	      matchesUnInheritedFormatSelector: matchesUnInheritedFormatSelector
	    };
	  }
	);
	/**
	 * SplitRange.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.SplitRange',
	  [
	    'tinymce.core.dom.NodeType'
	  ],
	  function (NodeType) {
	    var splitText = function (node, offset) {
	      return node.splitText(offset);
	    };
	
	    var split = function (rng) {
	      var startContainer = rng.startContainer,
	        startOffset = rng.startOffset,
	        endContainer = rng.endContainer,
	        endOffset = rng.endOffset;
	
	      // Handle single text node
	      if (startContainer === endContainer && NodeType.isText(startContainer)) {
	        if (startOffset > 0 && startOffset < startContainer.nodeValue.length) {
	          endContainer = splitText(startContainer, startOffset);
	          startContainer = endContainer.previousSibling;
	
	          if (endOffset > startOffset) {
	            endOffset = endOffset - startOffset;
	            startContainer = endContainer = splitText(endContainer, endOffset).previousSibling;
	            endOffset = endContainer.nodeValue.length;
	            startOffset = 0;
	          } else {
	            endOffset = 0;
	          }
	        }
	      } else {
	        // Split startContainer text node if needed
	        if (NodeType.isText(startContainer) && startOffset > 0 && startOffset < startContainer.nodeValue.length) {
	          startContainer = splitText(startContainer, startOffset);
	          startOffset = 0;
	        }
	
	        // Split endContainer text node if needed
	        if (NodeType.isText(endContainer) && endOffset > 0 && endOffset < endContainer.nodeValue.length) {
	          endContainer = splitText(endContainer, endOffset).previousSibling;
	          endOffset = endContainer.nodeValue.length;
	        }
	      }
	
	      return {
	        startContainer: startContainer,
	        startOffset: startOffset,
	        endContainer: endContainer,
	        endOffset: endOffset
	      };
	    };
	
	    return {
	      split: split
	    };
	  }
	);
	
	/**
	 * CaretFormat.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.CaretFormat',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.dom.Insert',
	    'ephox.sugar.api.dom.Remove',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'ephox.sugar.api.properties.Attr',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.PaddingBr',
	    'tinymce.core.dom.TreeWalker',
	    'tinymce.core.fmt.ExpandRange',
	    'tinymce.core.fmt.FormatUtils',
	    'tinymce.core.fmt.MatchFormat',
	    'tinymce.core.selection.SplitRange',
	    'tinymce.core.text.Zwsp',
	    'tinymce.core.util.Fun'
	  ],
	  function (Arr, Insert, Remove, Element, Node, Attr, CaretPosition, NodeType, PaddingBr, TreeWalker, ExpandRange, FormatUtils, MatchFormat, SplitRange, Zwsp, Fun) {
	    var ZWSP = Zwsp.ZWSP, CARET_ID = '_mce_caret';
	
	    var importNode = function (ownerDocument, node) {
	      return ownerDocument.importNode(node, true);
	    };
	
	    var isCaretNode = function (node) {
	      return node.nodeType === 1 && node.id === CARET_ID;
	    };
	
	    var getEmptyCaretContainers = function (node) {
	      var nodes = [];
	
	      while (node) {
	        if ((node.nodeType === 3 && node.nodeValue !== ZWSP) || node.childNodes.length > 1) {
	          return [];
	        }
	
	        // Collect nodes
	        if (node.nodeType === 1) {
	          nodes.push(node);
	        }
	
	        node = node.firstChild;
	      }
	
	      return nodes;
	    };
	
	    var isCaretContainerEmpty = function (node) {
	      return getEmptyCaretContainers(node).length > 0;
	    };
	
	    var findFirstTextNode = function (node) {
	      var walker;
	
	      if (node) {
	        walker = new TreeWalker(node, node);
	
	        for (node = walker.current(); node; node = walker.next()) {
	          if (node.nodeType === 3) {
	            return node;
	          }
	        }
	      }
	
	      return null;
	    };
	
	    var createCaretContainer = function (fill) {
	      var caretContainer = Element.fromTag('span');
	
	      Attr.setAll(caretContainer, {
	        //style: 'color:red',
	        id: CARET_ID,
	        'data-mce-bogus': '1',
	        'data-mce-type': 'format-caret'
	      });
	
	      if (fill) {
	        Insert.append(caretContainer, Element.fromText(ZWSP));
	      }
	
	      return caretContainer;
	    };
	
	    var getParentCaretContainer = function (body, node) {
	      while (node && node !== body) {
	        if (node.id === CARET_ID) {
	          return node;
	        }
	
	        node = node.parentNode;
	      }
	
	      return null;
	    };
	
	    var trimZwspFromCaretContainer = function (caretContainerNode) {
	      var textNode = findFirstTextNode(caretContainerNode);
	      if (textNode && textNode.nodeValue.charAt(0) === ZWSP) {
	        textNode.deleteData(0, 1);
	      }
	
	      return textNode;
	    };
	
	    var removeCaretContainerNode = function (dom, selection, node, moveCaret) {
	      var rng, block, textNode;
	
	      rng = selection.getRng(true);
	      block = dom.getParent(node, dom.isBlock);
	
	      if (isCaretContainerEmpty(node)) {
	        if (moveCaret !== false) {
	          rng.setStartBefore(node);
	          rng.setEndBefore(node);
	        }
	
	        dom.remove(node);
	      } else {
	        textNode = trimZwspFromCaretContainer(node);
	        if (rng.startContainer === textNode && rng.startOffset > 0) {
	          rng.setStart(textNode, rng.startOffset - 1);
	        }
	
	        if (rng.endContainer === textNode && rng.endOffset > 0) {
	          rng.setEnd(textNode, rng.endOffset - 1);
	        }
	
	        dom.remove(node, true);
	      }
	
	      if (block && dom.isEmpty(block)) {
	        PaddingBr.fillWithPaddingBr(Element.fromDom(block));
	      }
	
	      selection.setRng(rng);
	    };
	
	    // Removes the caret container for the specified node or all on the current document
	    var removeCaretContainer = function (body, dom, selection, node, moveCaret) {
	      if (!node) {
	        node = getParentCaretContainer(body, selection.getStart());
	
	        if (!node) {
	          while ((node = dom.get(CARET_ID))) {
	            removeCaretContainerNode(dom, selection, node, false);
	          }
	        }
	      } else {
	        removeCaretContainerNode(dom, selection, node, moveCaret);
	      }
	    };
	
	    var insertCaretContainerNode = function (editor, caretContainer, formatNode) {
	      var dom = editor.dom, block = dom.getParent(formatNode, Fun.curry(FormatUtils.isTextBlock, editor));
	
	      if (block && dom.isEmpty(block)) {
	        // Replace formatNode with caretContainer when removing format from empty block like <p><b>|</b></p>
	        formatNode.parentNode.replaceChild(caretContainer, formatNode);
	      } else {
	        PaddingBr.removeTrailingBr(Element.fromDom(formatNode));
	        if (dom.isEmpty(formatNode)) {
	          formatNode.parentNode.replaceChild(caretContainer, formatNode);
	        } else {
	          dom.insertAfter(caretContainer, formatNode);
	        }
	      }
	    };
	
	    var appendNode = function (parentNode, node) {
	      parentNode.appendChild(node);
	      return node;
	    };
	
	    var insertFormatNodesIntoCaretContainer = function (formatNodes, caretContainer) {
	      var innerMostFormatNode = Arr.foldr(formatNodes, function (parentNode, formatNode) {
	        return appendNode(parentNode, formatNode.cloneNode(false));
	      }, caretContainer);
	
	      return appendNode(innerMostFormatNode, innerMostFormatNode.ownerDocument.createTextNode(ZWSP));
	    };
	
	    var applyCaretFormat = function (editor, name, vars) {
	      var rng, caretContainer, textNode, offset, bookmark, container, text;
	      var selection = editor.selection;
	
	      rng = selection.getRng(true);
	      offset = rng.startOffset;
	      container = rng.startContainer;
	      text = container.nodeValue;
	
	      caretContainer = getParentCaretContainer(editor.getBody(), selection.getStart());
	      if (caretContainer) {
	        textNode = findFirstTextNode(caretContainer);
	      }
	
	      // Expand to word if caret is in the middle of a text node and the char before/after is a alpha numeric character
	      var wordcharRegex = /[^\s\u00a0\u00ad\u200b\ufeff]/;
	      if (text && offset > 0 && offset < text.length &&
	        wordcharRegex.test(text.charAt(offset)) && wordcharRegex.test(text.charAt(offset - 1))) {
	        // Get bookmark of caret position
	        bookmark = selection.getBookmark();
	
	        // Collapse bookmark range (WebKit)
	        rng.collapse(true);
	
	        // Expand the range to the closest word and split it at those points
	        rng = ExpandRange.expandRng(editor, rng, editor.formatter.get(name));
	        rng = SplitRange.split(rng);
	
	        // Apply the format to the range
	        editor.formatter.apply(name, vars, rng);
	
	        // Move selection back to caret position
	        selection.moveToBookmark(bookmark);
	      } else {
	        if (!caretContainer || textNode.nodeValue !== ZWSP) {
	          // Need to import the node into the document on IE or we get a lovely WrongDocument exception
	          caretContainer = importNode(editor.getDoc(), createCaretContainer(true).dom());
	          textNode = caretContainer.firstChild;
	
	          rng.insertNode(caretContainer);
	          offset = 1;
	
	          editor.formatter.apply(name, vars, caretContainer);
	        } else {
	          editor.formatter.apply(name, vars, caretContainer);
	        }
	
	        // Move selection to text node
	        selection.setCursorLocation(textNode, offset);
	      }
	    };
	
	    var removeCaretFormat = function (editor, name, vars, similar) {
	      var dom = editor.dom, selection = editor.selection;
	      var rng = selection.getRng(true), container, offset, bookmark;
	      var hasContentAfter, node, formatNode, parents = [], caretContainer;
	
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      node = container;
	
	      if (container.nodeType === 3) {
	        if (offset !== container.nodeValue.length) {
	          hasContentAfter = true;
	        }
	
	        node = node.parentNode;
	      }
	
	      while (node) {
	        if (MatchFormat.matchNode(editor, node, name, vars, similar)) {
	          formatNode = node;
	          break;
	        }
	
	        if (node.nextSibling) {
	          hasContentAfter = true;
	        }
	
	        parents.push(node);
	        node = node.parentNode;
	      }
	
	      // Node doesn't have the specified format
	      if (!formatNode) {
	        return;
	      }
	
	      // Is there contents after the caret then remove the format on the element
	      if (hasContentAfter) {
	        bookmark = selection.getBookmark();
	
	        // Collapse bookmark range (WebKit)
	        rng.collapse(true);
	
	        // Expand the range to the closest word and split it at those points
	        rng = ExpandRange.expandRng(editor, rng, editor.formatter.get(name), true);
	        rng = SplitRange.split(rng);
	
	        editor.formatter.remove(name, vars, rng);
	        selection.moveToBookmark(bookmark);
	      } else {
	        caretContainer = getParentCaretContainer(editor.getBody(), formatNode);
	        var newCaretContainer = createCaretContainer(false).dom();
	        var caretNode = insertFormatNodesIntoCaretContainer(parents, newCaretContainer);
	
	        if (caretContainer) {
	          insertCaretContainerNode(editor, newCaretContainer, caretContainer);
	        } else {
	          insertCaretContainerNode(editor, newCaretContainer, formatNode);
	        }
	
	        removeCaretContainerNode(dom, selection, caretContainer, false);
	        selection.setCursorLocation(caretNode, 1);
	
	        if (dom.isEmpty(formatNode)) {
	          dom.remove(formatNode);
	        }
	      }
	    };
	
	    var disableCaretContainer = function (body, dom, selection, keyCode) {
	      removeCaretContainer(body, dom, selection, null, false);
	
	      // Remove caret container if it's empty
	      if (keyCode === 8 && selection.isCollapsed() && selection.getStart().innerHTML === ZWSP) {
	        removeCaretContainer(body, dom, selection, getParentCaretContainer(body, selection.getStart()));
	      }
	
	      // Remove caret container on keydown and it's left/right arrow keys
	      if (keyCode === 37 || keyCode === 39) {
	        removeCaretContainer(body, dom, selection, getParentCaretContainer(body, selection.getStart()));
	      }
	    };
	
	    var setup = function (editor) {
	      var dom = editor.dom, selection = editor.selection;
	      var body = editor.getBody();
	
	      editor.on('mouseup keydown', function (e) {
	        disableCaretContainer(body, dom, selection, e.keyCode);
	      });
	    };
	
	    var replaceWithCaretFormat = function (targetNode, formatNodes) {
	      var caretContainer = createCaretContainer(false);
	      var innerMost = insertFormatNodesIntoCaretContainer(formatNodes, caretContainer.dom());
	      Insert.before(Element.fromDom(targetNode), caretContainer);
	      Remove.remove(Element.fromDom(targetNode));
	
	      return CaretPosition(innerMost, 0);
	    };
	
	    var isFormatElement = function (editor, element) {
	      var inlineElements = editor.schema.getTextInlineElements();
	      return inlineElements.hasOwnProperty(Node.name(element)) && !isCaretNode(element.dom()) && !NodeType.isBogus(element.dom());
	    };
	
	    return {
	      setup: setup,
	      applyCaretFormat: applyCaretFormat,
	      removeCaretFormat: removeCaretFormat,
	      isCaretNode: isCaretNode,
	      getParentCaretContainer: getParentCaretContainer,
	      replaceWithCaretFormat: replaceWithCaretFormat,
	      isFormatElement: isFormatElement
	    };
	  }
	);
	/**
	 * LazyEvaluator.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.LazyEvaluator',
	  [
	    'ephox.katamari.api.Option'
	  ],
	  function (Option) {
	    var evaluateUntil = function (fns, args) {
	      for (var i = 0; i < fns.length; i++) {
	        var result = fns[i].apply(null, args);
	        if (result.isSome()) {
	          return result;
	        }
	      }
	
	      return Option.none();
	    };
	
	    return {
	      evaluateUntil: evaluateUntil
	    };
	  }
	);
	/**
	 * BoundaryLocation.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.BoundaryLocation',
	  [
	    'ephox.katamari.api.Adt',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Options',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretUtils',
	    'tinymce.core.fmt.CaretFormat',
	    'tinymce.core.keyboard.InlineUtils',
	    'tinymce.core.util.LazyEvaluator'
	  ],
	  function (Adt, Fun, Option, Options, CaretFinder, CaretUtils, CaretFormat, InlineUtils, LazyEvaluator) {
	    var Location = Adt.generate([
	      { before: [ 'element' ] },
	      { start: [ 'element' ] },
	      { end: [ 'element' ] },
	      { after: [ 'element' ] }
	    ]);
	
	    var rescope = function (rootNode, node) {
	      var parentBlock = CaretUtils.getParentBlock(node, rootNode);
	      return parentBlock ? parentBlock : rootNode;
	    };
	
	    var before = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeForwards(pos);
	      var scope = rescope(rootNode, nPos.container());
	      return InlineUtils.findRootInline(isInlineTarget, scope, nPos).fold(
	        function () {
	          return CaretFinder.nextPosition(scope, nPos)
	            .bind(Fun.curry(InlineUtils.findRootInline, isInlineTarget, scope))
	            .map(function (inline) {
	              return Location.before(inline);
	            });
	        },
	        Option.none
	      );
	    };
	
	    var isNotInsideFormatCaretContainer = function (rootNode, elm) {
	      return CaretFormat.getParentCaretContainer(rootNode, elm) === null;
	    };
	
	    var findInsideRootInline = function (isInlineTarget, rootNode, pos) {
	      return InlineUtils.findRootInline(isInlineTarget, rootNode, pos).filter(Fun.curry(isNotInsideFormatCaretContainer, rootNode));
	    };
	
	    var start = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeBackwards(pos);
	      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
	        var prevPos = CaretFinder.prevPosition(inline, nPos);
	        return prevPos.isNone() ? Option.some(Location.start(inline)) : Option.none();
	      });
	    };
	
	    var end = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeForwards(pos);
	      return findInsideRootInline(isInlineTarget, rootNode, nPos).bind(function (inline) {
	        var nextPos = CaretFinder.nextPosition(inline, nPos);
	        return nextPos.isNone() ? Option.some(Location.end(inline)) : Option.none();
	      });
	    };
	
	    var after = function (isInlineTarget, rootNode, pos) {
	      var nPos = InlineUtils.normalizeBackwards(pos);
	      var scope = rescope(rootNode, nPos.container());
	      return InlineUtils.findRootInline(isInlineTarget, scope, nPos).fold(
	        function () {
	          return CaretFinder.prevPosition(scope, nPos)
	            .bind(Fun.curry(InlineUtils.findRootInline, isInlineTarget, scope))
	            .map(function (inline) {
	              return Location.after(inline);
	            });
	        },
	        Option.none
	      );
	    };
	
	    var isValidLocation = function (location) {
	      return InlineUtils.isRtl(getElement(location)) === false;
	    };
	
	    var readLocation = function (isInlineTarget, rootNode, pos) {
	      var location = LazyEvaluator.evaluateUntil([
	        before,
	        start,
	        end,
	        after
	      ], [isInlineTarget, rootNode, pos]);
	
	      return location.filter(isValidLocation);
	    };
	
	    var getElement = function (location) {
	      return location.fold(
	        Fun.identity, // Before
	        Fun.identity, // Start
	        Fun.identity, // End
	        Fun.identity  // After
	      );
	    };
	
	    var getName = function (location) {
	      return location.fold(
	        Fun.constant('before'), // Before
	        Fun.constant('start'),  // Start
	        Fun.constant('end'),    // End
	        Fun.constant('after')   // After
	      );
	    };
	
	    var outside = function (location) {
	      return location.fold(
	        Location.before, // Before
	        Location.before, // Start
	        Location.after,  // End
	        Location.after   // After
	      );
	    };
	
	    var inside = function (location) {
	      return location.fold(
	        Location.start, // Before
	        Location.start, // Start
	        Location.end,   // End
	        Location.end    // After
	      );
	    };
	
	    var isEq = function (location1, location2) {
	      return getName(location1) === getName(location2) && getElement(location1) === getElement(location2);
	    };
	
	    var betweenInlines = function (forward, isInlineTarget, rootNode, from, to, location) {
	      return Options.liftN([
	        InlineUtils.findRootInline(isInlineTarget, rootNode, from),
	        InlineUtils.findRootInline(isInlineTarget, rootNode, to)
	      ], function (fromInline, toInline) {
	        if (fromInline !== toInline && InlineUtils.hasSameParentBlock(rootNode, fromInline, toInline)) {
	          // Force after since some browsers normalize and lean left into the closest inline
	          return Location.after(forward ? fromInline : toInline);
	        } else {
	          return location;
	        }
	      }).getOr(location);
	    };
	
	    var skipNoMovement = function (fromLocation, toLocation) {
	      return fromLocation.fold(
	        Fun.constant(true),
	        function (fromLocation) {
	          return !isEq(fromLocation, toLocation);
	        }
	      );
	    };
	
	    var findLocationTraverse = function (forward, isInlineTarget, rootNode, fromLocation, pos) {
	      var from = InlineUtils.normalizePosition(forward, pos);
	      var to = CaretFinder.fromPosition(forward, rootNode, from).map(Fun.curry(InlineUtils.normalizePosition, forward));
	
	      var location = to.fold(
	        function () {
	          return fromLocation.map(outside);
	        },
	        function (to) {
	          return readLocation(isInlineTarget, rootNode, to)
	            .map(Fun.curry(betweenInlines, forward, isInlineTarget, rootNode, from, to))
	            .filter(Fun.curry(skipNoMovement, fromLocation));
	        }
	      );
	
	      return location.filter(isValidLocation);
	    };
	
	    var findLocationSimple = function (forward, location) {
	      if (forward) {
	        return location.fold(
	          Fun.compose(Option.some, Location.start), // Before -> Start
	          Option.none,
	          Fun.compose(Option.some, Location.after), // End -> After
	          Option.none
	        );
	      } else {
	        return location.fold(
	          Option.none,
	          Fun.compose(Option.some, Location.before), // Before <- Start
	          Option.none,
	          Fun.compose(Option.some, Location.end) // End <- After
	        );
	      }
	    };
	
	    var findLocation = function (forward, isInlineTarget, rootNode, pos) {
	      var from = InlineUtils.normalizePosition(forward, pos);
	      var fromLocation = readLocation(isInlineTarget, rootNode, from);
	
	      return readLocation(isInlineTarget, rootNode, from).bind(Fun.curry(findLocationSimple, forward)).orThunk(function () {
	        return findLocationTraverse(forward, isInlineTarget, rootNode, fromLocation, pos);
	      });
	    };
	
	    return {
	      readLocation: readLocation,
	      findLocation: findLocation,
	      prevLocation: Fun.curry(findLocation, false),
	      nextLocation: Fun.curry(findLocation, true),
	      getElement: getElement,
	      outside: outside,
	      inside: inside
	    };
	  }
	);
	define(
	  'ephox.katamari.api.Cell',
	
	  [
	  ],
	
	  function () {
	    var Cell = function (initial) {
	      var value = initial;
	
	      var get = function () {
	        return value;
	      };
	
	      var set = function (v) {
	        value = v;
	      };
	
	      var clone = function () {
	        return Cell(get());
	      };
	
	      return {
	        get: get,
	        set: set,
	        clone: clone
	      };
	    };
	
	    return Cell;
	  }
	);
	
	/**
	 * WordSelection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.WordSelection',
	  [
	    'ephox.katamari.api.Type',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.caret.CaretPosition'
	  ],
	  function (Type, CaretContainer, CaretPosition) {
	    var hasSelectionModifyApi = function (editor) {
	      return Type.isFunction(editor.selection.getSel().modify);
	    };
	
	    var moveRel = function (forward, selection, pos) {
	      var delta = forward ? 1 : -1;
	      selection.setRng(CaretPosition(pos.container(), pos.offset() + delta).toRange());
	      selection.getSel().modify('move', forward ? 'forward' : 'backward', 'word');
	      return true;
	    };
	
	    var moveByWord = function (forward, editor) {
	      var rng = editor.selection.getRng();
	      var pos = forward ? CaretPosition.fromRangeEnd(rng) : CaretPosition.fromRangeStart(rng);
	
	      if (!hasSelectionModifyApi(editor)) {
	        return false;
	      } else if (forward && CaretContainer.isBeforeInline(pos)) {
	        return moveRel(true, editor.selection, pos);
	      } else if (!forward && CaretContainer.isAfterInline(pos)) {
	        return moveRel(false, editor.selection, pos);
	      } else {
	        return false;
	      }
	    };
	
	    return {
	      hasSelectionModifyApi: hasSelectionModifyApi,
	      moveByWord: moveByWord
	    };
	  }
	);
	/**
	 * BoundarySelection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.BoundarySelection',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Cell',
	    'ephox.katamari.api.Fun',
	    'tinymce.core.caret.CaretContainerRemove',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.keyboard.BoundaryCaret',
	    'tinymce.core.keyboard.BoundaryLocation',
	    'tinymce.core.keyboard.InlineUtils',
	    'tinymce.core.selection.WordSelection'
	  ],
	  function (Arr, Cell, Fun, CaretContainerRemove, CaretPosition, BoundaryCaret, BoundaryLocation, InlineUtils, WordSelection) {
	    var setCaretPosition = function (editor, pos) {
	      var rng = editor.dom.createRng();
	      rng.setStart(pos.container(), pos.offset());
	      rng.setEnd(pos.container(), pos.offset());
	      editor.selection.setRng(rng);
	    };
	
	    var isFeatureEnabled = function (editor) {
	      return editor.settings.inline_boundaries !== false;
	    };
	
	    var setSelected = function (state, elm) {
	      if (state) {
	        elm.setAttribute('data-mce-selected', 'inline-boundary');
	      } else {
	        elm.removeAttribute('data-mce-selected');
	      }
	    };
	
	    var renderCaretLocation = function (editor, caret, location) {
	      return BoundaryCaret.renderCaret(caret, location).map(function (pos) {
	        setCaretPosition(editor, pos);
	        return location;
	      });
	    };
	
	    var findLocation = function (editor, caret, forward) {
	      var rootNode = editor.getBody();
	      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	      var isInlineTarget = Fun.curry(InlineUtils.isInlineTarget, editor);
	      var location = BoundaryLocation.findLocation(forward, isInlineTarget, rootNode, from);
	      return location.bind(function (location) {
	        return renderCaretLocation(editor, caret, location);
	      });
	    };
	
	    var toggleInlines = function (isInlineTarget, dom, elms) {
	      var selectedInlines = Arr.filter(dom.select('*[data-mce-selected="inline-boundary"]'), isInlineTarget);
	      var targetInlines = Arr.filter(elms, isInlineTarget);
	      Arr.each(Arr.difference(selectedInlines, targetInlines), Fun.curry(setSelected, false));
	      Arr.each(Arr.difference(targetInlines, selectedInlines), Fun.curry(setSelected, true));
	    };
	
	    var safeRemoveCaretContainer = function (editor, caret) {
	      if (editor.selection.isCollapsed() && editor.composing !== true && caret.get()) {
	        var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
	        if (CaretPosition.isTextPosition(pos) && InlineUtils.isAtZwsp(pos) === false) {
	          setCaretPosition(editor, CaretContainerRemove.removeAndReposition(caret.get(), pos));
	          caret.set(null);
	        }
	      }
	    };
	
	    var renderInsideInlineCaret = function (isInlineTarget, editor, caret, elms) {
	      if (editor.selection.isCollapsed()) {
	        var inlines = Arr.filter(elms, isInlineTarget);
	        Arr.each(inlines, function (inline) {
	          var pos = CaretPosition.fromRangeStart(editor.selection.getRng());
	          BoundaryLocation.readLocation(isInlineTarget, editor.getBody(), pos).bind(function (location) {
	            return renderCaretLocation(editor, caret, location);
	          });
	        });
	      }
	    };
	
	    var move = function (editor, caret, forward) {
	      return function () {
	        return isFeatureEnabled(editor) ? findLocation(editor, caret, forward).isSome() : false;
	      };
	    };
	
	    var moveWord = function (forward, editor, caret) {
	      return function () {
	        return isFeatureEnabled(editor) ? WordSelection.moveByWord(forward, editor) : false;
	      };
	    };
	
	    var setupSelectedState = function (editor) {
	      var caret = new Cell(null);
	      var isInlineTarget = Fun.curry(InlineUtils.isInlineTarget, editor);
	
	      editor.on('NodeChange', function (e) {
	        if (isFeatureEnabled(editor)) {
	          toggleInlines(isInlineTarget, editor.dom, e.parents);
	          safeRemoveCaretContainer(editor, caret);
	          renderInsideInlineCaret(isInlineTarget, editor, caret, e.parents);
	        }
	      });
	
	      return caret;
	    };
	
	    return {
	      move: move,
	      moveNextWord: Fun.curry(moveWord, true),
	      movePrevWord: Fun.curry(moveWord, false),
	      setupSelectedState: setupSelectedState,
	      setCaretPosition: setCaretPosition
	    };
	  }
	);
	/**
	 * InlineBoundaryDelete.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.InlineBoundaryDelete',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Options',
	    'ephox.sugar.api.node.Element',
	    'global!document',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.caret.CaretUtils',
	    'tinymce.core.delete.DeleteElement',
	    'tinymce.core.keyboard.BoundaryCaret',
	    'tinymce.core.keyboard.BoundaryLocation',
	    'tinymce.core.keyboard.BoundarySelection',
	    'tinymce.core.keyboard.InlineUtils'
	  ],
	  function (
	    Fun, Option, Options, Element, document, CaretContainer, CaretFinder, CaretPosition, CaretUtils, DeleteElement, BoundaryCaret, BoundaryLocation, BoundarySelection,
	    InlineUtils
	  ) {
	    var isFeatureEnabled = function (editor) {
	      return editor.settings.inline_boundaries !== false;
	    };
	
	    var rangeFromPositions = function (from, to) {
	      var range = document.createRange();
	
	      range.setStart(from.container(), from.offset());
	      range.setEnd(to.container(), to.offset());
	
	      return range;
	    };
	
	    // Checks for delete at <code>|a</code> when there is only one item left except the zwsp caret container nodes
	    var hasOnlyTwoOrLessPositionsLeft = function (elm) {
	      return Options.liftN([
	        CaretFinder.firstPositionIn(elm),
	        CaretFinder.lastPositionIn(elm)
	      ], function (firstPos, lastPos) {
	        var normalizedFirstPos = InlineUtils.normalizePosition(true, firstPos);
	        var normalizedLastPos = InlineUtils.normalizePosition(false, lastPos);
	
	        return CaretFinder.nextPosition(elm, normalizedFirstPos).map(function (pos) {
	          return pos.isEqual(normalizedLastPos);
	        }).getOr(true);
	      }).getOr(true);
	    };
	
	    var setCaretLocation = function (editor, caret) {
	      return function (location) {
	        return BoundaryCaret.renderCaret(caret, location).map(function (pos) {
	          BoundarySelection.setCaretPosition(editor, pos);
	          return true;
	        }).getOr(false);
	      };
	    };
	
	    var deleteFromTo = function (editor, caret, from, to) {
	      var rootNode = editor.getBody();
	      var isInlineTarget = Fun.curry(InlineUtils.isInlineTarget, editor);
	
	      editor.undoManager.ignore(function () {
	        editor.selection.setRng(rangeFromPositions(from, to));
	        editor.execCommand('Delete');
	
	        BoundaryLocation.readLocation(isInlineTarget, rootNode, CaretPosition.fromRangeStart(editor.selection.getRng()))
	          .map(BoundaryLocation.inside)
	          .map(setCaretLocation(editor, caret));
	      });
	
	      editor.nodeChanged();
	    };
	
	    var rescope = function (rootNode, node) {
	      var parentBlock = CaretUtils.getParentBlock(node, rootNode);
	      return parentBlock ? parentBlock : rootNode;
	    };
	
	    var backspaceDeleteCollapsed = function (editor, caret, forward, from) {
	      var rootNode = rescope(editor.getBody(), from.container());
	      var isInlineTarget = Fun.curry(InlineUtils.isInlineTarget, editor);
	      var fromLocation = BoundaryLocation.readLocation(isInlineTarget, rootNode, from);
	
	      return fromLocation.bind(function (location) {
	        if (forward) {
	          return location.fold(
	            Fun.constant(Option.some(BoundaryLocation.inside(location))), // Before
	            Option.none, // Start
	            Fun.constant(Option.some(BoundaryLocation.outside(location))), // End
	            Option.none  // After
	          );
	        } else {
	          return location.fold(
	            Option.none, // Before
	            Fun.constant(Option.some(BoundaryLocation.outside(location))), // Start
	            Option.none, // End
	            Fun.constant(Option.some(BoundaryLocation.inside(location)))  // After
	          );
	        }
	      })
	      .map(setCaretLocation(editor, caret))
	      .getOrThunk(function () {
	        var toPosition = CaretFinder.navigate(forward, rootNode, from);
	        var toLocation = toPosition.bind(function (pos) {
	          return BoundaryLocation.readLocation(isInlineTarget, rootNode, pos);
	        });
	
	        if (fromLocation.isSome() && toLocation.isSome()) {
	          return InlineUtils.findRootInline(isInlineTarget, rootNode, from).map(function (elm) {
	            if (hasOnlyTwoOrLessPositionsLeft(elm)) {
	              DeleteElement.deleteElement(editor, forward, Element.fromDom(elm));
	              return true;
	            } else {
	              return false;
	            }
	          }).getOr(false);
	        } else {
	          return toLocation.bind(function (_) {
	            return toPosition.map(function (to) {
	              if (forward) {
	                deleteFromTo(editor, caret, from, to);
	              } else {
	                deleteFromTo(editor, caret, to, from);
	              }
	
	              return true;
	            });
	          }).getOr(false);
	        }
	      });
	    };
	
	    var backspaceDelete = function (editor, caret, forward) {
	      if (editor.selection.isCollapsed() && isFeatureEnabled(editor)) {
	        var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	        return backspaceDeleteCollapsed(editor, caret, forward, from);
	      }
	
	      return false;
	    };
	
	    return {
	      backspaceDelete: backspaceDelete
	    };
	  }
	);
	define(
	  'tinymce.core.delete.TableDeleteAction',
	
	  [
	    'ephox.katamari.api.Adt',
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Options',
	    'ephox.katamari.api.Struct',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.SelectorFilter',
	    'ephox.sugar.api.search.SelectorFind'
	  ],
	
	  function (Adt, Arr, Fun, Option, Options, Struct, Compare, Element, SelectorFilter, SelectorFind) {
	    var tableCellRng = Struct.immutable('start', 'end');
	    var tableSelection = Struct.immutable('rng', 'table', 'cells');
	    var deleteAction = Adt.generate([
	      { removeTable: [ 'element' ] },
	      { emptyCells: [ 'cells' ] }
	    ]);
	
	    var getClosestCell = function (container, isRoot) {
	      return SelectorFind.closest(Element.fromDom(container), 'td,th', isRoot);
	    };
	
	    var getClosestTable = function (cell, isRoot) {
	      return SelectorFind.ancestor(cell, 'table', isRoot);
	    };
	
	    var isExpandedCellRng = function (cellRng) {
	      return Compare.eq(cellRng.start(), cellRng.end()) === false;
	    };
	
	    var getTableFromCellRng = function (cellRng, isRoot) {
	      return getClosestTable(cellRng.start(), isRoot)
	        .bind(function (startParentTable) {
	          return getClosestTable(cellRng.end(), isRoot)
	            .bind(function (endParentTable) {
	              return Compare.eq(startParentTable, endParentTable) ? Option.some(startParentTable) : Option.none();
	            });
	        });
	    };
	
	    var getCellRng = function (rng, isRoot) {
	      return Options.liftN([ // get start and end cell
	        getClosestCell(rng.startContainer, isRoot),
	        getClosestCell(rng.endContainer, isRoot)
	      ], tableCellRng)
	        .filter(isExpandedCellRng);
	    };
	
	    var getTableSelectionFromCellRng = function (cellRng, isRoot) {
	      return getTableFromCellRng(cellRng, isRoot)
	        .bind(function (table) {
	          var cells = SelectorFilter.descendants(table, 'td,th');
	
	          return tableSelection(cellRng, table, cells);
	        });
	    };
	
	    var getTableSelectionFromRng = function (rootNode, rng) {
	      var isRoot = Fun.curry(Compare.eq, rootNode);
	
	      return getCellRng(rng, isRoot)
	        .map(function (cellRng) {
	          return getTableSelectionFromCellRng(cellRng, isRoot);
	        });
	    };
	
	    var getCellIndex = function (cellArray, cell) {
	      return Arr.findIndex(cellArray, function (x) {
	        return Compare.eq(x, cell);
	      });
	    };
	
	    var getSelectedCells = function (tableSelection) {
	      return Options.liftN([
	        getCellIndex(tableSelection.cells(), tableSelection.rng().start()),
	        getCellIndex(tableSelection.cells(), tableSelection.rng().end())
	      ], function (startIndex, endIndex) {
	        return tableSelection.cells().slice(startIndex, endIndex + 1);
	      });
	    };
	
	    var getAction = function (tableSelection) {
	      return getSelectedCells(tableSelection)
	        .bind(function (selected) {
	          var cells = tableSelection.cells();
	
	          return selected.length === cells.length ? deleteAction.removeTable(tableSelection.table()) : deleteAction.emptyCells(selected);
	        });
	    };
	
	    var getActionFromCells = function (cells) {
	      return deleteAction.emptyCells(cells);
	    };
	
	    var getActionFromRange = function (rootNode, rng) {
	      return getTableSelectionFromRng(rootNode, rng)
	        .map(getAction);
	    };
	
	    return {
	      getActionFromRange: getActionFromRange,
	      getActionFromCells: getActionFromCells
	    };
	  }
	);
	
	/**
	 * MultiRange.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.MultiRange',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.selection.RangeNodes'
	  ],
	  function (Arr, Element, RangeNodes) {
	    var getRanges = function (selection) {
	      var ranges = [];
	
	      if (selection) {
	        for (var i = 0; i < selection.rangeCount; i++) {
	          ranges.push(selection.getRangeAt(i));
	        }
	      }
	
	      return ranges;
	    };
	
	    var getSelectedNodes = function (ranges) {
	      return Arr.bind(ranges, function (range) {
	        var node = RangeNodes.getSelectedNode(range);
	        return node ? [ Element.fromDom(node) ] : [];
	      });
	    };
	
	    var hasMultipleRanges = function (selection) {
	      return getRanges(selection).length > 1;
	    };
	
	    return {
	      getRanges: getRanges,
	      getSelectedNodes: getSelectedNodes,
	      hasMultipleRanges: hasMultipleRanges
	    };
	  }
	);
	
	/**
	 * TableCellSelection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.TableCellSelection',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.SelectorFilter',
	    'tinymce.core.dom.ElementType',
	    'tinymce.core.selection.MultiRange'
	  ],
	  function (Arr, Element, SelectorFilter, ElementType, MultiRange) {
	    var getCellsFromRanges = function (ranges) {
	      return Arr.filter(MultiRange.getSelectedNodes(ranges), ElementType.isTableCell);
	    };
	
	    var getCellsFromElement = function (elm) {
	      var selectedCells = SelectorFilter.descendants(elm, 'td[data-mce-selected],th[data-mce-selected]');
	      return selectedCells;
	    };
	
	    var getCellsFromElementOrRanges = function (ranges, element) {
	      var selectedCells = getCellsFromElement(element);
	      var rangeCells = getCellsFromRanges(ranges);
	      return selectedCells.length > 0 ? selectedCells : rangeCells;
	    };
	
	    var getCellsFromEditor = function (editor) {
	      return getCellsFromElementOrRanges(MultiRange.getRanges(editor.selection.getSel()), Element.fromDom(editor.getBody()));
	    };
	
	    return {
	      getCellsFromRanges: getCellsFromRanges,
	      getCellsFromElement: getCellsFromElement,
	      getCellsFromElementOrRanges: getCellsFromElementOrRanges,
	      getCellsFromEditor: getCellsFromEditor
	    };
	  }
	);
	
	/**
	 * TableDelete.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.TableDelete',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.delete.DeleteElement',
	    'tinymce.core.delete.TableDeleteAction',
	    'tinymce.core.dom.ElementType',
	    'tinymce.core.dom.Empty',
	    'tinymce.core.dom.PaddingBr',
	    'tinymce.core.dom.Parents',
	    'tinymce.core.selection.TableCellSelection'
	  ],
	  function (Arr, Fun, Option, Compare, Element, Node, CaretFinder, CaretPosition, DeleteElement, TableDeleteAction, ElementType, Empty, PaddingBr, Parents, TableCellSelection) {
	    var emptyCells = function (editor, cells) {
	      Arr.each(cells, PaddingBr.fillWithPaddingBr);
	      editor.selection.setCursorLocation(cells[0].dom(), 0);
	
	      return true;
	    };
	
	    var deleteTableElement = function (editor, table) {
	      DeleteElement.deleteElement(editor, false, table);
	
	      return true;
	    };
	
	    var deleteCellRange = function (editor, rootElm, rng) {
	      return TableDeleteAction.getActionFromRange(rootElm, rng).map(function (action) {
	        return action.fold(
	          Fun.curry(deleteTableElement, editor),
	          Fun.curry(emptyCells, editor)
	        );
	      });
	    };
	
	    var deleteCaptionRange = function (editor, caption) {
	      return emptyElement(editor, caption);
	    };
	
	    var deleteTableRange = function (editor, rootElm, rng, startElm) {
	      return getParentCaption(rootElm, startElm).fold(
	        function () {
	          return deleteCellRange(editor, rootElm, rng);
	        },
	        function (caption) {
	          return deleteCaptionRange(editor, caption);
	        }
	      ).getOr(false);
	    };
	
	    var deleteRange = function (editor, startElm) {
	      var rootNode = Element.fromDom(editor.getBody());
	      var rng = editor.selection.getRng();
	      var selectedCells = TableCellSelection.getCellsFromEditor(editor);
	
	      return selectedCells.length !== 0 ? emptyCells(editor, selectedCells) : deleteTableRange(editor, rootNode, rng, startElm);
	    };
	
	    var getParentCell = function (rootElm, elm) {
	      return Arr.find(Parents.parentsAndSelf(elm, rootElm), ElementType.isTableCell);
	    };
	
	    var getParentCaption = function (rootElm, elm) {
	      return Arr.find(Parents.parentsAndSelf(elm, rootElm), function (elm) {
	        return Node.name(elm) === 'caption';
	      });
	    };
	
	    var deleteBetweenCells = function (editor, rootElm, forward, fromCell, from) {
	      return CaretFinder.navigate(forward, editor.getBody(), from).bind(function (to) {
	        return getParentCell(rootElm, Element.fromDom(to.getNode())).map(function (toCell) {
	          return Compare.eq(toCell, fromCell) === false;
	        });
	      });
	    };
	
	    var emptyElement = function (editor, elm) {
	      PaddingBr.fillWithPaddingBr(elm);
	      editor.selection.setCursorLocation(elm.dom(), 0);
	      return Option.some(true);
	    };
	
	    var isDeleteOfLastCharPos = function (fromCaption, forward, from, to) {
	      return CaretFinder.firstPositionIn(fromCaption.dom()).bind(function (first) {
	        return CaretFinder.lastPositionIn(fromCaption.dom()).map(function (last) {
	          return forward ? from.isEqual(first) && to.isEqual(last) : from.isEqual(last) && to.isEqual(first);
	        });
	      }).getOr(true);
	    };
	
	    var emptyCaretCaption = function (editor, elm) {
	      return emptyElement(editor, elm);
	    };
	
	    var validateCaretCaption = function (rootElm, fromCaption, to) {
	      return getParentCaption(rootElm, Element.fromDom(to.getNode())).map(function (toCaption) {
	        return Compare.eq(toCaption, fromCaption) === false;
	      });
	    };
	
	    var deleteCaretInsideCaption = function (editor, rootElm, forward, fromCaption, from) {
	      return CaretFinder.navigate(forward, editor.getBody(), from).bind(function (to) {
	        return isDeleteOfLastCharPos(fromCaption, forward, from, to) ? emptyCaretCaption(editor, fromCaption) : validateCaretCaption(rootElm, fromCaption, to);
	      }).or(Option.some(true));
	    };
	
	    var deleteCaretCells = function (editor, forward, rootElm, startElm) {
	      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return getParentCell(rootElm, startElm).bind(function (fromCell) {
	        return Empty.isEmpty(fromCell) ? emptyElement(editor, fromCell) : deleteBetweenCells(editor, rootElm, forward, fromCell, from);
	      });
	    };
	
	    var deleteCaretCaption = function (editor, forward, rootElm, fromCaption) {
	      var from = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return Empty.isEmpty(fromCaption) ? emptyElement(editor, fromCaption) : deleteCaretInsideCaption(editor, rootElm, forward, fromCaption, from);
	    };
	
	    var deleteCaret = function (editor, forward, startElm) {
	      var rootElm = Element.fromDom(editor.getBody());
	
	      return getParentCaption(rootElm, startElm).fold(
	        function () {
	          return deleteCaretCells(editor, forward, rootElm, startElm);
	        },
	        function (fromCaption) {
	          return deleteCaretCaption(editor, forward, rootElm, fromCaption);
	        }
	      ).getOr(false);
	    };
	
	    var backspaceDelete = function (editor, forward) {
	      var startElm = Element.fromDom(editor.selection.getStart(true));
	      return editor.selection.isCollapsed() ? deleteCaret(editor, forward, startElm) : deleteRange(editor, startElm);
	    };
	
	    return {
	      backspaceDelete: backspaceDelete
	    };
	  }
	);
	
	/**
	 * Commands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.DeleteCommands',
	  [
	    'tinymce.core.delete.BlockBoundaryDelete',
	    'tinymce.core.delete.BlockRangeDelete',
	    'tinymce.core.delete.CefDelete',
	    'tinymce.core.delete.DeleteUtils',
	    'tinymce.core.delete.InlineBoundaryDelete',
	    'tinymce.core.delete.TableDelete'
	  ],
	  function (BlockBoundaryDelete, BlockRangeDelete, CefDelete, DeleteUtils, BoundaryDelete, TableDelete) {
	    var nativeCommand = function (editor, command) {
	      editor.getDoc().execCommand(command, false, null);
	    };
	
	    var deleteCommand = function (editor) {
	      if (CefDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (BoundaryDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (BlockBoundaryDelete.backspaceDelete(editor, false)) {
	        return;
	      } else if (TableDelete.backspaceDelete(editor)) {
	        return;
	      } else if (BlockRangeDelete.backspaceDelete(editor, false)) {
	        return;
	      } else {
	        nativeCommand(editor, 'Delete');
	        DeleteUtils.paddEmptyBody(editor);
	      }
	    };
	
	    var forwardDeleteCommand = function (editor) {
	      if (CefDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (BoundaryDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (BlockBoundaryDelete.backspaceDelete(editor, true)) {
	        return;
	      } else if (TableDelete.backspaceDelete(editor)) {
	        return;
	      } else if (BlockRangeDelete.backspaceDelete(editor, true)) {
	        return;
	      } else {
	        nativeCommand(editor, 'ForwardDelete');
	      }
	    };
	
	    return {
	      deleteCommand: deleteCommand,
	      forwardDeleteCommand: forwardDeleteCommand
	    };
	  }
	);
	/**
	 * RangeCompare.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.RangeCompare',
	  [
	  ],
	  function () {
	    var isEq = function (rng1, rng2) {
	      return rng1 && rng2 &&
	        (rng1.startContainer === rng2.startContainer && rng1.startOffset === rng2.startOffset) &&
	        (rng1.endContainer === rng2.endContainer && rng1.endOffset === rng2.endOffset);
	    };
	
	    return {
	      isEq: isEq
	    };
	  }
	);
	
	/**
	 * NormalizeRange.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.NormalizeRange',
	  [
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Struct',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.TreeWalker',
	    'tinymce.core.fmt.CaretFormat',
	    'tinymce.core.selection.RangeCompare'
	  ],
	  function (Option, Struct, CaretContainer, NodeType, TreeWalker, CaretFormat, RangeCompare) {
	    var position = Struct.immutable('container', 'offset');
	
	    var findParent = function (node, rootNode, predicate) {
	      while (node && node !== rootNode) {
	        if (predicate(node)) {
	          return node;
	        }
	
	        node = node.parentNode;
	      }
	
	      return null;
	    };
	
	    var hasParent = function (node, rootNode, predicate) {
	      return findParent(node, rootNode, predicate) !== null;
	    };
	
	    var hasParentWithName = function (node, rootNode, name) {
	      return hasParent(node, rootNode, function (node) {
	        return node.nodeName === name;
	      });
	    };
	
	    var isTable = function (node) {
	      return node && node.nodeName === 'TABLE';
	    };
	
	    var isTableCell = function (node) {
	      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
	    };
	
	    var isCeFalseCaretContainer = function (node, rootNode) {
	      return CaretContainer.isCaretContainer(node) && hasParent(node, rootNode, CaretFormat.isCaretNode) === false;
	    };
	
	    var hasBrBeforeAfter = function (dom, node, left) {
	      var walker = new TreeWalker(node, dom.getParent(node.parentNode, dom.isBlock) || dom.getRoot());
	
	      while ((node = walker[left ? 'prev' : 'next']())) {
	        if (NodeType.isBr(node)) {
	          return true;
	        }
	      }
	    };
	
	    var isPrevNode = function (node, name) {
	      return node.previousSibling && node.previousSibling.nodeName === name;
	    };
	
	    var hasContentEditableFalseParent = function (body, node) {
	      while (node && node !== body) {
	        if (NodeType.isContentEditableFalse(node)) {
	          return true;
	        }
	
	        node = node.parentNode;
	      }
	
	      return false;
	    };
	
	    // Walks the dom left/right to find a suitable text node to move the endpoint into
	    // It will only walk within the current parent block or body and will stop if it hits a block or a BR/IMG
	    var findTextNodeRelative = function (dom, isAfterNode, collapsed, left, startNode) {
	      var walker, lastInlineElement, parentBlockContainer, body = dom.getRoot(), node;
	      var nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	
	      parentBlockContainer = dom.getParent(startNode.parentNode, dom.isBlock) || body;
	
	      // Lean left before the BR element if it's the only BR within a block element. Gecko bug: #6680
	      // This: <p><br>|</p> becomes <p>|<br></p>
	      if (left && NodeType.isBr(startNode) && isAfterNode && dom.isEmpty(parentBlockContainer)) {
	        return Option.some(position(startNode.parentNode, dom.nodeIndex(startNode)));
	      }
	
	      // Walk left until we hit a text node we can move to or a block/br/img
	      walker = new TreeWalker(startNode, parentBlockContainer);
	      while ((node = walker[left ? 'prev' : 'next']())) {
	        // Break if we hit a non content editable node
	        if (dom.getContentEditableParent(node) === "false" || isCeFalseCaretContainer(node, body)) {
	          return Option.none();
	        }
	
	        // Found text node that has a length
	        if (NodeType.isText(node) && node.nodeValue.length > 0) {
	          if (hasParentWithName(node, body, 'A') === false) {
	            return Option.some(position(node, left ? node.nodeValue.length : 0));
	          }
	
	          return Option.none();
	        }
	
	        // Break if we find a block or a BR/IMG/INPUT etc
	        if (dom.isBlock(node) || nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
	          return Option.none();
	        }
	
	        lastInlineElement = node;
	      }
	
	      // Only fetch the last inline element when in caret mode for now
	      if (collapsed && lastInlineElement) {
	        return Option.some(position(lastInlineElement, 0));
	      }
	
	      return Option.none();
	    };
	
	    var normalizeEndPoint = function (dom, collapsed, start, rng) {
	      var container, offset, walker, body = dom.getRoot(), node, nonEmptyElementsMap;
	      var directionLeft, isAfterNode, normalized = false;
	
	      container = rng[(start ? 'start' : 'end') + 'Container'];
	      offset = rng[(start ? 'start' : 'end') + 'Offset'];
	      isAfterNode = NodeType.isElement(container) && offset === container.childNodes.length;
	      nonEmptyElementsMap = dom.schema.getNonEmptyElements();
	      directionLeft = start;
	
	      if (CaretContainer.isCaretContainer(container)) {
	        return Option.none();
	      }
	
	      if (NodeType.isElement(container) && offset > container.childNodes.length - 1) {
	        directionLeft = false;
	      }
	
	      // If the container is a document move it to the body element
	      if (NodeType.isDocument(container)) {
	        container = body;
	        offset = 0;
	      }
	
	      // If the container is body try move it into the closest text node or position
	      if (container === body) {
	        // If start is before/after a image, table etc
	        if (directionLeft) {
	          node = container.childNodes[offset > 0 ? offset - 1 : 0];
	          if (node) {
	            if (CaretContainer.isCaretContainer(node)) {
	              return Option.none();
	            }
	
	            if (nonEmptyElementsMap[node.nodeName] || isTable(node)) {
	              return Option.none();
	            }
	          }
	        }
	
	        // Resolve the index
	        if (container.hasChildNodes()) {
	          offset = Math.min(!directionLeft && offset > 0 ? offset - 1 : offset, container.childNodes.length - 1);
	          container = container.childNodes[offset];
	          offset = NodeType.isText(container) && isAfterNode ? container.data.length : 0;
	
	          // Don't normalize non collapsed selections like <p>[a</p><table></table>]
	          if (!collapsed && container === body.lastChild && isTable(container)) {
	            return Option.none();
	          }
	
	          if (hasContentEditableFalseParent(body, container) || CaretContainer.isCaretContainer(container)) {
	            return Option.none();
	          }
	
	          // Don't walk into elements that doesn't have any child nodes like a IMG
	          if (container.hasChildNodes() && isTable(container) === false) {
	            // Walk the DOM to find a text node to place the caret at or a BR
	            node = container;
	            walker = new TreeWalker(container, body);
	
	            do {
	              if (NodeType.isContentEditableFalse(node) || CaretContainer.isCaretContainer(node)) {
	                normalized = false;
	                break;
	              }
	
	              // Found a text node use that position
	              if (NodeType.isText(node) && node.nodeValue.length > 0) {
	                offset = directionLeft ? 0 : node.nodeValue.length;
	                container = node;
	                normalized = true;
	                break;
	              }
	
	              // Found a BR/IMG/PRE element that we can place the caret before
	              if (nonEmptyElementsMap[node.nodeName.toLowerCase()] && !isTableCell(node)) {
	                offset = dom.nodeIndex(node);
	                container = node.parentNode;
	
	                // Put caret after image and pre tag when moving the end point
	                if ((node.nodeName === 'IMG' || node.nodeName === 'PRE') && !directionLeft) {
	                  offset++;
	                }
	
	                normalized = true;
	                break;
	              }
	            } while ((node = (directionLeft ? walker.next() : walker.prev())));
	          }
	        }
	      }
	
	      // Lean the caret to the left if possible
	      if (collapsed) {
	        // So this: <b>x</b><i>|x</i>
	        // Becomes: <b>x|</b><i>x</i>
	        // Seems that only gecko has issues with this
	        if (NodeType.isText(container) && offset === 0) {
	          findTextNodeRelative(dom, isAfterNode, collapsed, true, container).each(function (pos) {
	            container = pos.container();
	            offset = pos.offset();
	            normalized = true;
	          });
	        }
	
	        // Lean left into empty inline elements when the caret is before a BR
	        // So this: <i><b></b><i>|<br></i>
	        // Becomes: <i><b>|</b><i><br></i>
	        // Seems that only gecko has issues with this.
	        // Special edge case for <p><a>x</a>|<br></p> since we don't want <p><a>x|</a><br></p>
	        if (NodeType.isElement(container)) {
	          node = container.childNodes[offset];
	
	          // Offset is after the containers last child
	          // then use the previous child for normalization
	          if (!node) {
	            node = container.childNodes[offset - 1];
	          }
	
	          if (node && NodeType.isBr(node) && !isPrevNode(node, 'A') &&
	            !hasBrBeforeAfter(dom, node, false) && !hasBrBeforeAfter(dom, node, true)) {
	            findTextNodeRelative(dom, isAfterNode, collapsed, true, node).each(function (pos) {
	              container = pos.container();
	              offset = pos.offset();
	              normalized = true;
	            });
	          }
	        }
	      }
	
	      // Lean the start of the selection right if possible
	      // So this: x[<b>x]</b>
	      // Becomes: x<b>[x]</b>
	      if (directionLeft && !collapsed && NodeType.isText(container) && offset === container.nodeValue.length) {
	        findTextNodeRelative(dom, isAfterNode, collapsed, false, container).each(function (pos) {
	          container = pos.container();
	          offset = pos.offset();
	          normalized = true;
	        });
	      }
	
	      return normalized ? Option.some(position(container, offset)) : Option.none();
	    };
	
	    var normalize = function (dom, rng) {
	      var collapsed = rng.collapsed, normRng = rng.cloneRange();
	
	      normalizeEndPoint(dom, collapsed, true, normRng).each(function (pos) {
	        normRng.setStart(pos.container(), pos.offset());
	      });
	
	      if (!collapsed) {
	        normalizeEndPoint(dom, collapsed, false, normRng).each(function (pos) {
	          normRng.setEnd(pos.container(), pos.offset());
	        });
	      }
	
	      // If it was collapsed then make sure it still is
	      if (collapsed) {
	        normRng.collapse(true);
	      }
	
	      return RangeCompare.isEq(rng, normRng) ? Option.none() : Option.some(normRng);
	    };
	
	    return {
	      normalize: normalize
	    };
	  }
	);
	/**
	 * InsertBr.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.newline.InsertBr',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.sugar.api.dom.Insert',
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.TreeWalker',
	    'tinymce.core.keyboard.BoundaryLocation',
	    'tinymce.core.keyboard.InlineUtils',
	    'tinymce.core.selection.NormalizeRange'
	  ],
	  function (Fun, Insert, Element, CaretFinder, CaretPosition, NodeType, TreeWalker, BoundaryLocation, InlineUtils, NormalizeRange) {
	    // Walks the parent block to the right and look for BR elements
	    var hasRightSideContent = function (schema, container, parentBlock) {
	      var walker = new TreeWalker(container, parentBlock), node;
	      var nonEmptyElementsMap = schema.getNonEmptyElements();
	
	      while ((node = walker.next())) {
	        if (nonEmptyElementsMap[node.nodeName.toLowerCase()] || node.length > 0) {
	          return true;
	        }
	      }
	    };
	
	    var scrollToBr = function (dom, selection, brElm) {
	      // Insert temp marker and scroll to that
	      var marker = dom.create('span', {}, '&nbsp;');
	      brElm.parentNode.insertBefore(marker, brElm);
	      selection.scrollIntoView(marker);
	      dom.remove(marker);
	    };
	
	    var moveSelectionToBr = function (dom, selection, brElm, extraBr) {
	      var rng = dom.createRng();
	
	      if (!extraBr) {
	        rng.setStartAfter(brElm);
	        rng.setEndAfter(brElm);
	      } else {
	        rng.setStartBefore(brElm);
	        rng.setEndBefore(brElm);
	      }
	
	      selection.setRng(rng);
	    };
	
	    var insertBrAtCaret = function (editor, evt) {
	      // We load the current event in from EnterKey.js when appropriate to heed
	      // certain event-specific variations such as ctrl-enter in a list
	      var selection = editor.selection, dom = editor.dom;
	      var brElm, extraBr;
	      var rng = selection.getRng(true);
	
	      NormalizeRange.normalize(dom, rng).each(function (normRng) {
	        rng.setStart(normRng.startContainer, normRng.startOffset);
	        rng.setEnd(normRng.endContainer, normRng.endOffset);
	      });
	
	      var offset = rng.startOffset;
	      var container = rng.startContainer;
	
	      // Resolve node index
	      if (container.nodeType === 1 && container.hasChildNodes()) {
	        var isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	        if (isAfterLastNodeInContainer && container.nodeType === 3) {
	          offset = container.nodeValue.length;
	        } else {
	          offset = 0;
	        }
	      }
	
	      var parentBlock = dom.getParent(container, dom.isBlock);
	      var containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	      var containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : ''; // IE < 9 & HTML5
	
	      // Enter inside block contained within a LI then split or insert before/after LI
	      var isControlKey = evt && evt.ctrlKey;
	      if (containerBlockName === 'LI' && !isControlKey) {
	        parentBlock = containerBlock;
	      }
	
	      if (container && container.nodeType === 3 && offset >= container.nodeValue.length) {
	        // Insert extra BR element at the end block elements
	        if (!hasRightSideContent(editor.schema, container, parentBlock)) {
	          brElm = dom.create('br');
	          rng.insertNode(brElm);
	          rng.setStartAfter(brElm);
	          rng.setEndAfter(brElm);
	          extraBr = true;
	        }
	      }
	
	      brElm = dom.create('br');
	      rng.insertNode(brElm);
	
	      scrollToBr(dom, selection, brElm);
	      moveSelectionToBr(dom, selection, brElm, extraBr);
	      editor.undoManager.add();
	    };
	
	    var insertBrBefore = function (editor, inline) {
	      var br = Element.fromTag('br');
	      Insert.before(Element.fromDom(inline), br);
	      editor.undoManager.add();
	    };
	
	    var insertBrAfter = function (editor, inline) {
	      if (!hasBrAfter(editor.getBody(), inline)) {
	        Insert.after(Element.fromDom(inline), Element.fromTag('br'));
	      }
	
	      var br = Element.fromTag('br');
	      Insert.after(Element.fromDom(inline), br);
	      scrollToBr(editor.dom, editor.selection, br.dom());
	      moveSelectionToBr(editor.dom, editor.selection, br.dom(), false);
	      editor.undoManager.add();
	    };
	
	    var isBeforeBr = function (pos) {
	      return NodeType.isBr(pos.getNode());
	    };
	
	    var hasBrAfter = function (rootNode, startNode) {
	      if (isBeforeBr(CaretPosition.after(startNode))) {
	        return true;
	      } else {
	        return CaretFinder.nextPosition(rootNode, CaretPosition.after(startNode)).map(function (pos) {
	          return NodeType.isBr(pos.getNode());
	        }).getOr(false);
	      }
	    };
	
	    var isAnchorLink = function (elm) {
	      return elm && elm.nodeName === 'A' && 'href' in elm;
	    };
	
	    var isInsideAnchor = function (location) {
	      return location.fold(
	        Fun.constant(false),
	        isAnchorLink,
	        isAnchorLink,
	        Fun.constant(false)
	      );
	    };
	
	    var readInlineAnchorLocation = function (editor) {
	      var isInlineTarget = Fun.curry(InlineUtils.isInlineTarget, editor);
	      var position = CaretPosition.fromRangeStart(editor.selection.getRng());
	      return BoundaryLocation.readLocation(isInlineTarget, editor.getBody(), position).filter(isInsideAnchor);
	    };
	
	    var insertBrOutsideAnchor = function (editor, location) {
	      location.fold(
	        Fun.noop,
	        Fun.curry(insertBrBefore, editor),
	        Fun.curry(insertBrAfter, editor),
	        Fun.noop
	      );
	    };
	
	    var insert = function (editor, evt) {
	      var anchorLocation = readInlineAnchorLocation(editor);
	
	      if (anchorLocation.isSome()) {
	        anchorLocation.each(Fun.curry(insertBrOutsideAnchor, editor));
	      } else {
	        insertBrAtCaret(editor, evt);
	      }
	    };
	
	    return {
	      insert: insert
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.selection.Situ',
	
	  [
	    'ephox.katamari.api.Adt',
	    'ephox.katamari.api.Fun'
	  ],
	
	  function (Adt, Fun) {
	    var adt = Adt.generate([
	      { 'before': [ 'element' ] },
	      { 'on': [ 'element', 'offset' ] },
	      { after: [ 'element' ] }
	    ]);
	
	    // Probably don't need this given that we now have "match"
	    var cata = function (subject, onBefore, onOn, onAfter) {
	      return subject.fold(onBefore, onOn, onAfter);
	    };
	
	    var getStart = function (situ) {
	      return situ.fold(Fun.identity, Fun.identity, Fun.identity)
	    };
	
	    return {
	      before: adt.before,
	      on: adt.on,
	      after: adt.after,
	      cata: cata,
	      getStart: getStart
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.selection.Selection',
	
	  [
	    'ephox.katamari.api.Adt',
	    'ephox.katamari.api.Struct',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.Traverse',
	    'ephox.sugar.api.selection.Situ'
	  ],
	
	  function (Adt, Struct, Element, Traverse, Situ) {
	    // Consider adding a type for "element"
	    var type = Adt.generate([
	      { domRange: [ 'rng' ] },
	      { relative: [ 'startSitu', 'finishSitu' ] },
	      { exact: [ 'start', 'soffset', 'finish', 'foffset' ] }
	    ]);
	
	    var range = Struct.immutable(
	      'start',
	      'soffset',
	      'finish',
	      'foffset'
	    );
	
	    var exactFromRange = function (simRange) {
	      return type.exact(simRange.start(), simRange.soffset(), simRange.finish(), simRange.foffset());
	    };
	
	    var getStart = function (selection) {
	      return selection.match({
	        domRange: function (rng) {
	          return Element.fromDom(rng.startContainer);
	        },
	        relative: function (startSitu, finishSitu) {
	          return Situ.getStart(startSitu);
	        },
	        exact: function (start, soffset, finish, foffset) {
	          return start;
	        }
	      });
	    };
	
	    var getWin = function (selection) {
	      var start = getStart(selection);
	
	      return Traverse.defaultView(start);
	    };
	
	    return {
	      domRange: type.domRange,
	      relative: type.relative,
	      exact: type.exact,
	
	      exactFromRange: exactFromRange,
	      range: range,
	
	      getWin: getWin
	    };
	  }
	);
	
	define(
	  'tinymce.core.selection.SelectionBookmark',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.sand.api.PlatformDetection',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'ephox.sugar.api.node.Text',
	    'ephox.sugar.api.search.Traverse',
	    'ephox.sugar.api.selection.Selection',
	    'global!document'
	  ],
	
	  function (Fun, Option, PlatformDetection, Compare, Element, Node, Text, Traverse, Selection, document) {
	    var browser = PlatformDetection.detect().browser;
	
	    var clamp = function (offset, element) {
	      var max = Node.isText(element) ? Text.get(element).length : Traverse.children(element).length + 1;
	
	      if (offset > max) {
	        return max;
	      } else if (offset < 0) {
	        return 0;
	      }
	
	      return offset;
	    };
	
	    var normalizeRng = function (rng) {
	      return Selection.range(
	        rng.start(),
	        clamp(rng.soffset(), rng.start()),
	        rng.finish(),
	        clamp(rng.foffset(), rng.finish())
	      );
	    };
	
	    var isOrContains = function (root, elm) {
	      return Compare.contains(root, elm) || Compare.eq(root, elm);
	    };
	
	    var isRngInRoot = function (root) {
	      return function (rng) {
	        return isOrContains(root, rng.start()) && isOrContains(root, rng.finish());
	      };
	    };
	
	    // var dumpRng = function (rng) {
	    //   console.log('start', rng.start().dom());
	    //   console.log('soffset', rng.soffset());
	    //   console.log('finish', rng.finish().dom());
	    //   console.log('foffset', rng.foffset());
	    //   return rng;
	    // };
	
	    var shouldStore = function (editor) {
	      return editor.inline === true || browser.isIE();
	    };
	
	    var nativeRangeToSelectionRange = function (r) {
	      return Selection.range(Element.fromDom(r.startContainer), r.startOffset, Element.fromDom(r.endContainer), r.endOffset);
	    };
	
	    var readRange = function (win) {
	      var selection = win.getSelection();
	      var rng = !selection || selection.rangeCount === 0 ? Option.none() : Option.from(selection.getRangeAt(0));
	      return rng.map(nativeRangeToSelectionRange);
	    };
	
	    var getBookmark = function (root) {
	      var win = Traverse.defaultView(root);
	
	      return readRange(win.dom())
	        .filter(isRngInRoot(root));
	    };
	
	    var validate = function (root, bookmark) {
	      return Option.from(bookmark)
	          .filter(isRngInRoot(root))
	          .map(normalizeRng);
	    };
	
	    var bookmarkToNativeRng = function (bookmark) {
	      var rng = document.createRange();
	      rng.setStart(bookmark.start().dom(), bookmark.soffset());
	      rng.setEnd(bookmark.finish().dom(), bookmark.foffset());
	
	      return Option.some(rng);
	    };
	
	    var store = function (editor) {
	      var newBookmark = shouldStore(editor) ? getBookmark(Element.fromDom(editor.getBody())) : Option.none();
	
	      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
	    };
	
	    var storeNative = function (editor, rng) {
	      var root = Element.fromDom(editor.getBody());
	      var range = shouldStore(editor) ? Option.from(rng) : Option.none();
	
	      var newBookmark = range.map(nativeRangeToSelectionRange)
	        .filter(isRngInRoot(root));
	
	      editor.bookmark = newBookmark.isSome() ? newBookmark : editor.bookmark;
	    };
	
	    var getRng = function (editor) {
	      var bookmark = editor.bookmark ? editor.bookmark : Option.none();
	
	      return bookmark
	        .bind(Fun.curry(validate, Element.fromDom(editor.getBody())))
	        .bind(bookmarkToNativeRng);
	    };
	
	    var restore = function (editor) {
	      getRng(editor).each(function (rng) {
	        editor.selection.setRng(rng);
	      });
	    };
	
	    return {
	      store: store,
	      storeNative: storeNative,
	      readRange: readRange,
	      restore: restore,
	      getRng: getRng,
	      getBookmark: getBookmark,
	      validate: validate
	    };
	  }
	);
	
	/**
	 * EditorCommands.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class enables you to add custom editor commands and it contains
	 * overrides for native browser commands to address various bugs and issues.
	 *
	 * @class tinymce.EditorCommands
	 */
	define(
	  'tinymce.core.EditorCommands',
	  [
	    'tinymce.core.Env',
	    'tinymce.core.InsertContent',
	    'tinymce.core.delete.DeleteCommands',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.newline.InsertBr',
	    'tinymce.core.selection.SelectionBookmark',
	    'tinymce.core.util.Tools'
	  ],
	  function (Env, InsertContent, DeleteCommands, NodeType, InsertBr, SelectionBookmark, Tools) {
	    // Added for compression purposes
	    var each = Tools.each, extend = Tools.extend;
	    var map = Tools.map, inArray = Tools.inArray, explode = Tools.explode;
	    var TRUE = true, FALSE = false;
	
	    return function (editor) {
	      var dom, selection, formatter,
	        commands = { state: {}, exec: {}, value: {} },
	        settings = editor.settings,
	        bookmark;
	
	      editor.on('PreInit', function () {
	        dom = editor.dom;
	        selection = editor.selection;
	        settings = editor.settings;
	        formatter = editor.formatter;
	      });
	
	      /**
	       * Executes the specified command.
	       *
	       * @method execCommand
	       * @param {String} command Command to execute.
	       * @param {Boolean} ui Optional user interface state.
	       * @param {Object} value Optional value for command.
	       * @param {Object} args Optional extra arguments to the execCommand.
	       * @return {Boolean} true/false if the command was found or not.
	       */
	      var execCommand = function (command, ui, value, args) {
	        var func, customCommand, state = 0;
	
	        if (editor.removed) {
	          return;
	        }
	
	        if (!/^(mceAddUndoLevel|mceEndUndoLevel|mceBeginUndoLevel|mceRepaint)$/.test(command) && (!args || !args.skip_focus)) {
	          editor.focus();
	        } else {
	          SelectionBookmark.restore(editor);
	        }
	
	        args = editor.fire('BeforeExecCommand', { command: command, ui: ui, value: value });
	        if (args.isDefaultPrevented()) {
	          return false;
	        }
	
	        customCommand = command.toLowerCase();
	        if ((func = commands.exec[customCommand])) {
	          func(customCommand, ui, value);
	          editor.fire('ExecCommand', { command: command, ui: ui, value: value });
	          return true;
	        }
	
	        // Plugin commands
	        each(editor.plugins, function (p) {
	          if (p.execCommand && p.execCommand(command, ui, value)) {
	            editor.fire('ExecCommand', { command: command, ui: ui, value: value });
	            state = true;
	            return false;
	          }
	        });
	
	        if (state) {
	          return state;
	        }
	
	        // Theme commands
	        if (editor.theme && editor.theme.execCommand && editor.theme.execCommand(command, ui, value)) {
	          editor.fire('ExecCommand', { command: command, ui: ui, value: value });
	          return true;
	        }
	
	        // Browser commands
	        try {
	          state = editor.getDoc().execCommand(command, ui, value);
	        } catch (ex) {
	          // Ignore old IE errors
	        }
	
	        if (state) {
	          editor.fire('ExecCommand', { command: command, ui: ui, value: value });
	          return true;
	        }
	
	        return false;
	      };
	
	      /**
	       * Queries the current state for a command for example if the current selection is "bold".
	       *
	       * @method queryCommandState
	       * @param {String} command Command to check the state of.
	       * @return {Boolean/Number} true/false if the selected contents is bold or not, -1 if it's not found.
	       */
	      var queryCommandState = function (command) {
	        var func;
	
	        if (editor.quirks.isHidden() || editor.removed) {
	          return;
	        }
	
	        command = command.toLowerCase();
	        if ((func = commands.state[command])) {
	          return func(command);
	        }
	
	        // Browser commands
	        try {
	          return editor.getDoc().queryCommandState(command);
	        } catch (ex) {
	          // Fails sometimes see bug: 1896577
	        }
	
	        return false;
	      };
	
	      /**
	       * Queries the command value for example the current fontsize.
	       *
	       * @method queryCommandValue
	       * @param {String} command Command to check the value of.
	       * @return {Object} Command value of false if it's not found.
	       */
	      var queryCommandValue = function (command) {
	        var func;
	
	        if (editor.quirks.isHidden() || editor.removed) {
	          return;
	        }
	
	        command = command.toLowerCase();
	        if ((func = commands.value[command])) {
	          return func(command);
	        }
	
	        // Browser commands
	        try {
	          return editor.getDoc().queryCommandValue(command);
	        } catch (ex) {
	          // Fails sometimes see bug: 1896577
	        }
	      };
	
	      /**
	       * Adds commands to the command collection.
	       *
	       * @method addCommands
	       * @param {Object} commandList Name/value collection with commands to add, the names can also be comma separated.
	       * @param {String} type Optional type to add, defaults to exec. Can be value or state as well.
	       */
	      var addCommands = function (commandList, type) {
	        type = type || 'exec';
	
	        each(commandList, function (callback, command) {
	          each(command.toLowerCase().split(','), function (command) {
	            commands[type][command] = callback;
	          });
	        });
	      };
	
	      var addCommand = function (command, callback, scope) {
	        command = command.toLowerCase();
	        commands.exec[command] = function (command, ui, value, args) {
	          return callback.call(scope || editor, ui, value, args);
	        };
	      };
	
	      /**
	       * Returns true/false if the command is supported or not.
	       *
	       * @method queryCommandSupported
	       * @param {String} command Command that we check support for.
	       * @return {Boolean} true/false if the command is supported or not.
	       */
	      var queryCommandSupported = function (command) {
	        command = command.toLowerCase();
	
	        if (commands.exec[command]) {
	          return true;
	        }
	
	        // Browser commands
	        try {
	          return editor.getDoc().queryCommandSupported(command);
	        } catch (ex) {
	          // Fails sometimes see bug: 1896577
	        }
	
	        return false;
	      };
	
	      var addQueryStateHandler = function (command, callback, scope) {
	        command = command.toLowerCase();
	        commands.state[command] = function () {
	          return callback.call(scope || editor);
	        };
	      };
	
	      var addQueryValueHandler = function (command, callback, scope) {
	        command = command.toLowerCase();
	        commands.value[command] = function () {
	          return callback.call(scope || editor);
	        };
	      };
	
	      var hasCustomCommand = function (command) {
	        command = command.toLowerCase();
	        return !!commands.exec[command];
	      };
	
	      // Expose public methods
	      extend(this, {
	        execCommand: execCommand,
	        queryCommandState: queryCommandState,
	        queryCommandValue: queryCommandValue,
	        queryCommandSupported: queryCommandSupported,
	        addCommands: addCommands,
	        addCommand: addCommand,
	        addQueryStateHandler: addQueryStateHandler,
	        addQueryValueHandler: addQueryValueHandler,
	        hasCustomCommand: hasCustomCommand
	      });
	
	      // Private methods
	
	      var execNativeCommand = function (command, ui, value) {
	        if (ui === undefined) {
	          ui = FALSE;
	        }
	
	        if (value === undefined) {
	          value = null;
	        }
	
	        return editor.getDoc().execCommand(command, ui, value);
	      };
	
	      var isFormatMatch = function (name) {
	        return formatter.match(name);
	      };
	
	      var toggleFormat = function (name, value) {
	        formatter.toggle(name, value ? { value: value } : undefined);
	        editor.nodeChanged();
	      };
	
	      var storeSelection = function (type) {
	        bookmark = selection.getBookmark(type);
	      };
	
	      var restoreSelection = function () {
	        selection.moveToBookmark(bookmark);
	      };
	
	      // Add execCommand overrides
	      addCommands({
	        // Ignore these, added for compatibility
	        'mceResetDesignMode,mceBeginUndoLevel': function () { },
	
	        // Add undo manager logic
	        'mceEndUndoLevel,mceAddUndoLevel': function () {
	          editor.undoManager.add();
	        },
	
	        'Cut,Copy,Paste': function (command) {
	          var doc = editor.getDoc(), failed;
	
	          // Try executing the native command
	          try {
	            execNativeCommand(command);
	          } catch (ex) {
	            // Command failed
	            failed = TRUE;
	          }
	
	          // Chrome reports the paste command as supported however older IE:s will return false for cut/paste
	          if (command === 'paste' && !doc.queryCommandEnabled(command)) {
	            failed = true;
	          }
	
	          // Present alert message about clipboard access not being available
	          if (failed || !doc.queryCommandSupported(command)) {
	            var msg = editor.translate(
	              "Your browser doesn't support direct access to the clipboard. " +
	              "Please use the Ctrl+X/C/V keyboard shortcuts instead."
	            );
	
	            if (Env.mac) {
	              msg = msg.replace(/Ctrl\+/g, '\u2318+');
	            }
	
	            editor.notificationManager.open({ text: msg, type: 'error' });
	          }
	        },
	
	        // Override unlink command
	        unlink: function () {
	          if (selection.isCollapsed()) {
	            var elm = editor.dom.getParent(editor.selection.getStart(), 'a');
	            if (elm) {
	              editor.dom.remove(elm, true);
	            }
	
	            return;
	          }
	
	          formatter.remove("link");
	        },
	
	        // Override justify commands to use the text formatter engine
	        'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull,JustifyNone': function (command) {
	          var align = command.substring(7);
	
	          if (align == 'full') {
	            align = 'justify';
	          }
	
	          // Remove all other alignments first
	          each('left,center,right,justify'.split(','), function (name) {
	            if (align != name) {
	              formatter.remove('align' + name);
	            }
	          });
	
	          if (align != 'none') {
	            toggleFormat('align' + align);
	          }
	        },
	
	        // Override list commands to fix WebKit bug
	        'InsertUnorderedList,InsertOrderedList': function (command) {
	          var listElm, listParent;
	
	          execNativeCommand(command);
	
	          // WebKit produces lists within block elements so we need to split them
	          // we will replace the native list creation logic to custom logic later on
	          // TODO: Remove this when the list creation logic is removed
	          listElm = dom.getParent(selection.getNode(), 'ol,ul');
	          if (listElm) {
	            listParent = listElm.parentNode;
	
	            // If list is within a text block then split that block
	            if (/^(H[1-6]|P|ADDRESS|PRE)$/.test(listParent.nodeName)) {
	              storeSelection();
	              dom.split(listParent, listElm);
	              restoreSelection();
	            }
	          }
	        },
	
	        // Override commands to use the text formatter engine
	        'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
	          toggleFormat(command);
	        },
	
	        // Override commands to use the text formatter engine
	        'ForeColor,HiliteColor,FontName': function (command, ui, value) {
	          toggleFormat(command, value);
	        },
	
	        FontSize: function (command, ui, value) {
	          var fontClasses, fontSizes;
	
	          // Convert font size 1-7 to styles
	          if (value >= 1 && value <= 7) {
	            fontSizes = explode(settings.font_size_style_values);
	            fontClasses = explode(settings.font_size_classes);
	
	            if (fontClasses) {
	              value = fontClasses[value - 1] || value;
	            } else {
	              value = fontSizes[value - 1] || value;
	            }
	          }
	
	          toggleFormat(command, value);
	        },
	
	        RemoveFormat: function (command) {
	          formatter.remove(command);
	        },
	
	        mceBlockQuote: function () {
	          toggleFormat('blockquote');
	        },
	
	        FormatBlock: function (command, ui, value) {
	          return toggleFormat(value || 'p');
	        },
	
	        mceCleanup: function () {
	          var bookmark = selection.getBookmark();
	
	          editor.setContent(editor.getContent({ cleanup: TRUE }), { cleanup: TRUE });
	
	          selection.moveToBookmark(bookmark);
	        },
	
	        mceRemoveNode: function (command, ui, value) {
	          var node = value || selection.getNode();
	
	          // Make sure that the body node isn't removed
	          if (node != editor.getBody()) {
	            storeSelection();
	            editor.dom.remove(node, TRUE);
	            restoreSelection();
	          }
	        },
	
	        mceSelectNodeDepth: function (command, ui, value) {
	          var counter = 0;
	
	          dom.getParent(selection.getNode(), function (node) {
	            if (node.nodeType == 1 && counter++ == value) {
	              selection.select(node);
	              return FALSE;
	            }
	          }, editor.getBody());
	        },
	
	        mceSelectNode: function (command, ui, value) {
	          selection.select(value);
	        },
	
	        mceInsertContent: function (command, ui, value) {
	          InsertContent.insertAtCaret(editor, value);
	        },
	
	        mceInsertRawHTML: function (command, ui, value) {
	          selection.setContent('tiny_mce_marker');
	          editor.setContent(
	            editor.getContent().replace(/tiny_mce_marker/g, function () {
	              return value;
	            })
	          );
	        },
	
	        mceToggleFormat: function (command, ui, value) {
	          toggleFormat(value);
	        },
	
	        mceSetContent: function (command, ui, value) {
	          editor.setContent(value);
	        },
	
	        'Indent,Outdent': function (command) {
	          var intentValue, indentUnit, value;
	
	          // Setup indent level
	          intentValue = settings.indentation;
	          indentUnit = /[a-z%]+$/i.exec(intentValue);
	          intentValue = parseInt(intentValue, 10);
	
	          if (!queryCommandState('InsertUnorderedList') && !queryCommandState('InsertOrderedList')) {
	            // If forced_root_blocks is set to false we don't have a block to indent so lets create a div
	            if (!settings.forced_root_block && !dom.getParent(selection.getNode(), dom.isBlock)) {
	              formatter.apply('div');
	            }
	
	            each(selection.getSelectedBlocks(), function (element) {
	              if (dom.getContentEditable(element) === "false") {
	                return;
	              }
	
	              if (element.nodeName !== "LI") {
	                var indentStyleName = editor.getParam('indent_use_margin', false) ? 'margin' : 'padding';
	                indentStyleName = element.nodeName === 'TABLE' ? 'margin' : indentStyleName;
	                indentStyleName += dom.getStyle(element, 'direction', true) == 'rtl' ? 'Right' : 'Left';
	
	                if (command == 'outdent') {
	                  value = Math.max(0, parseInt(element.style[indentStyleName] || 0, 10) - intentValue);
	                  dom.setStyle(element, indentStyleName, value ? value + indentUnit : '');
	                } else {
	                  value = (parseInt(element.style[indentStyleName] || 0, 10) + intentValue) + indentUnit;
	                  dom.setStyle(element, indentStyleName, value);
	                }
	              }
	            });
	          } else {
	            execNativeCommand(command);
	          }
	        },
	
	        mceRepaint: function () {
	        },
	
	        InsertHorizontalRule: function () {
	          editor.execCommand('mceInsertContent', false, '<hr />');
	        },
	
	        mceToggleVisualAid: function () {
	          editor.hasVisual = !editor.hasVisual;
	          editor.addVisual();
	        },
	
	        mceReplaceContent: function (command, ui, value) {
	          editor.execCommand('mceInsertContent', false, value.replace(/\{\$selection\}/g, selection.getContent({ format: 'text' })));
	        },
	
	        mceInsertLink: function (command, ui, value) {
	          var anchor;
	
	          if (typeof value == 'string') {
	            value = { href: value };
	          }
	
	          anchor = dom.getParent(selection.getNode(), 'a');
	
	          // Spaces are never valid in URLs and it's a very common mistake for people to make so we fix it here.
	          value.href = value.href.replace(' ', '%20');
	
	          // Remove existing links if there could be child links or that the href isn't specified
	          if (!anchor || !value.href) {
	            formatter.remove('link');
	          }
	
	          // Apply new link to selection
	          if (value.href) {
	            formatter.apply('link', value, anchor);
	          }
	        },
	
	        selectAll: function () {
	          var editingHost = dom.getParent(selection.getStart(), NodeType.isContentEditableTrue);
	          if (editingHost) {
	            var rng = dom.createRng();
	            rng.selectNodeContents(editingHost);
	            selection.setRng(rng);
	          }
	        },
	
	        "delete": function () {
	          DeleteCommands.deleteCommand(editor);
	        },
	
	        "forwardDelete": function () {
	          DeleteCommands.forwardDeleteCommand(editor);
	        },
	
	        mceNewDocument: function () {
	          editor.setContent('');
	        },
	
	        InsertLineBreak: function (command, ui, value) {
	          InsertBr.insert(editor, value);
	          return true;
	        }
	      });
	
	      // Add queryCommandState overrides
	      addCommands({
	        // Override justify commands
	        'JustifyLeft,JustifyCenter,JustifyRight,JustifyFull': function (command) {
	          var name = 'align' + command.substring(7);
	          var nodes = selection.isCollapsed() ? [dom.getParent(selection.getNode(), dom.isBlock)] : selection.getSelectedBlocks();
	          var matches = map(nodes, function (node) {
	            return !!formatter.matchNode(node, name);
	          });
	          return inArray(matches, TRUE) !== -1;
	        },
	
	        'Bold,Italic,Underline,Strikethrough,Superscript,Subscript': function (command) {
	          return isFormatMatch(command);
	        },
	
	        mceBlockQuote: function () {
	          return isFormatMatch('blockquote');
	        },
	
	        Outdent: function () {
	          var node;
	
	          if (settings.inline_styles) {
	            if ((node = dom.getParent(selection.getStart(), dom.isBlock)) && parseInt(node.style.paddingLeft, 10) > 0) {
	              return TRUE;
	            }
	
	            if ((node = dom.getParent(selection.getEnd(), dom.isBlock)) && parseInt(node.style.paddingLeft, 10) > 0) {
	              return TRUE;
	            }
	          }
	
	          return (
	            queryCommandState('InsertUnorderedList') ||
	            queryCommandState('InsertOrderedList') ||
	            (!settings.inline_styles && !!dom.getParent(selection.getNode(), 'BLOCKQUOTE'))
	          );
	        },
	
	        'InsertUnorderedList,InsertOrderedList': function (command) {
	          var list = dom.getParent(selection.getNode(), 'ul,ol');
	
	          return list &&
	            (
	              command === 'insertunorderedlist' && list.tagName === 'UL' ||
	              command === 'insertorderedlist' && list.tagName === 'OL'
	            );
	        }
	      }, 'state');
	
	      // Add queryCommandValue overrides
	      addCommands({
	        'FontSize,FontName': function (command) {
	          var value = 0, parent;
	
	          if ((parent = dom.getParent(selection.getNode(), 'span'))) {
	            if (command == 'fontsize') {
	              value = parent.style.fontSize;
	            } else {
	              value = parent.style.fontFamily.replace(/, /g, ',').replace(/[\'\"]/g, '').toLowerCase();
	            }
	          }
	
	          return value;
	        }
	      }, 'value');
	
	      // Add undo manager logic
	      addCommands({
	        Undo: function () {
	          editor.undoManager.undo();
	        },
	
	        Redo: function () {
	          editor.undoManager.redo();
	        }
	      });
	    };
	  }
	);
	
	/**
	 * EventDispatcher.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class lets you add/remove and fire events by name on the specified scope. This makes
	 * it easy to add event listener logic to any class.
	 *
	 * @class tinymce.util.EventDispatcher
	 * @example
	 *  var eventDispatcher = new EventDispatcher();
	 *
	 *  eventDispatcher.on('click', function() {console.log('data');});
	 *  eventDispatcher.fire('click', {data: 123});
	 */
	define(
	  'tinymce.core.util.EventDispatcher',
	  [
	    "tinymce.core.util.Tools"
	  ],
	  function (Tools) {
	    var nativeEvents = Tools.makeMap(
	      "focus blur focusin focusout click dblclick mousedown mouseup mousemove mouseover beforepaste paste cut copy selectionchange " +
	      "mouseout mouseenter mouseleave wheel keydown keypress keyup input contextmenu dragstart dragend dragover " +
	      "draggesture dragdrop drop drag submit " +
	      "compositionstart compositionend compositionupdate touchstart touchmove touchend",
	      ' '
	    );
	
	    var Dispatcher = function (settings) {
	      var self = this, scope, bindings = {}, toggleEvent;
	
	      var returnFalse = function () {
	        return false;
	      };
	
	      var returnTrue = function () {
	        return true;
	      };
	
	      settings = settings || {};
	      scope = settings.scope || self;
	      toggleEvent = settings.toggleEvent || returnFalse;
	
	      /**
	       * Fires the specified event by name.
	       *
	       * @method fire
	       * @param {String} name Name of the event to fire.
	       * @param {Object?} args Event arguments.
	       * @return {Object} Event args instance passed in.
	       * @example
	       * instance.fire('event', {...});
	       */
	      var fire = function (name, args) {
	        var handlers, i, l, callback;
	
	        name = name.toLowerCase();
	        args = args || {};
	        args.type = name;
	
	        // Setup target is there isn't one
	        if (!args.target) {
	          args.target = scope;
	        }
	
	        // Add event delegation methods if they are missing
	        if (!args.preventDefault) {
	          // Add preventDefault method
	          args.preventDefault = function () {
	            args.isDefaultPrevented = returnTrue;
	          };
	
	          // Add stopPropagation
	          args.stopPropagation = function () {
	            args.isPropagationStopped = returnTrue;
	          };
	
	          // Add stopImmediatePropagation
	          args.stopImmediatePropagation = function () {
	            args.isImmediatePropagationStopped = returnTrue;
	          };
	
	          // Add event delegation states
	          args.isDefaultPrevented = returnFalse;
	          args.isPropagationStopped = returnFalse;
	          args.isImmediatePropagationStopped = returnFalse;
	        }
	
	        if (settings.beforeFire) {
	          settings.beforeFire(args);
	        }
	
	        handlers = bindings[name];
	        if (handlers) {
	          for (i = 0, l = handlers.length; i < l; i++) {
	            callback = handlers[i];
	
	            // Unbind handlers marked with "once"
	            if (callback.once) {
	              off(name, callback.func);
	            }
	
	            // Stop immediate propagation if needed
	            if (args.isImmediatePropagationStopped()) {
	              args.stopPropagation();
	              return args;
	            }
	
	            // If callback returns false then prevent default and stop all propagation
	            if (callback.func.call(scope, args) === false) {
	              args.preventDefault();
	              return args;
	            }
	          }
	        }
	
	        return args;
	      };
	
	      /**
	       * Binds an event listener to a specific event by name.
	       *
	       * @method on
	       * @param {String} name Event name or space separated list of events to bind.
	       * @param {callback} callback Callback to be executed when the event occurs.
	       * @param {Boolean} first Optional flag if the event should be prepended. Use this with care.
	       * @return {Object} Current class instance.
	       * @example
	       * instance.on('event', function(e) {
	       *     // Callback logic
	       * });
	       */
	      var on = function (name, callback, prepend, extra) {
	        var handlers, names, i;
	
	        if (callback === false) {
	          callback = returnFalse;
	        }
	
	        if (callback) {
	          callback = {
	            func: callback
	          };
	
	          if (extra) {
	            Tools.extend(callback, extra);
	          }
	
	          names = name.toLowerCase().split(' ');
	          i = names.length;
	          while (i--) {
	            name = names[i];
	            handlers = bindings[name];
	            if (!handlers) {
	              handlers = bindings[name] = [];
	              toggleEvent(name, true);
	            }
	
	            if (prepend) {
	              handlers.unshift(callback);
	            } else {
	              handlers.push(callback);
	            }
	          }
	        }
	
	        return self;
	      };
	
	      /**
	       * Unbinds an event listener to a specific event by name.
	       *
	       * @method off
	       * @param {String?} name Name of the event to unbind.
	       * @param {callback?} callback Callback to unbind.
	       * @return {Object} Current class instance.
	       * @example
	       * // Unbind specific callback
	       * instance.off('event', handler);
	       *
	       * // Unbind all listeners by name
	       * instance.off('event');
	       *
	       * // Unbind all events
	       * instance.off();
	       */
	      var off = function (name, callback) {
	        var i, handlers, bindingName, names, hi;
	
	        if (name) {
	          names = name.toLowerCase().split(' ');
	          i = names.length;
	          while (i--) {
	            name = names[i];
	            handlers = bindings[name];
	
	            // Unbind all handlers
	            if (!name) {
	              for (bindingName in bindings) {
	                toggleEvent(bindingName, false);
	                delete bindings[bindingName];
	              }
	
	              return self;
	            }
	
	            if (handlers) {
	              // Unbind all by name
	              if (!callback) {
	                handlers.length = 0;
	              } else {
	                // Unbind specific ones
	                hi = handlers.length;
	                while (hi--) {
	                  if (handlers[hi].func === callback) {
	                    handlers = handlers.slice(0, hi).concat(handlers.slice(hi + 1));
	                    bindings[name] = handlers;
	                  }
	                }
	              }
	
	              if (!handlers.length) {
	                toggleEvent(name, false);
	                delete bindings[name];
	              }
	            }
	          }
	        } else {
	          for (name in bindings) {
	            toggleEvent(name, false);
	          }
	
	          bindings = {};
	        }
	
	        return self;
	      };
	
	      /**
	       * Binds an event listener to a specific event by name
	       * and automatically unbind the event once the callback fires.
	       *
	       * @method once
	       * @param {String} name Event name or space separated list of events to bind.
	       * @param {callback} callback Callback to be executed when the event occurs.
	       * @param {Boolean} first Optional flag if the event should be prepended. Use this with care.
	       * @return {Object} Current class instance.
	       * @example
	       * instance.once('event', function(e) {
	       *     // Callback logic
	       * });
	       */
	      var once = function (name, callback, prepend) {
	        return on(name, callback, prepend, { once: true });
	      };
	
	      /**
	       * Returns true/false if the dispatcher has a event of the specified name.
	       *
	       * @method has
	       * @param {String} name Name of the event to check for.
	       * @return {Boolean} true/false if the event exists or not.
	       */
	      var has = function (name) {
	        name = name.toLowerCase();
	        return !(!bindings[name] || bindings[name].length === 0);
	      };
	
	      // Expose
	      self.fire = fire;
	      self.on = on;
	      self.off = off;
	      self.once = once;
	      self.has = has;
	    };
	
	    /**
	     * Returns true/false if the specified event name is a native browser event or not.
	     *
	     * @method isNative
	     * @param {String} name Name to check if it's native.
	     * @return {Boolean} true/false if the event is native or not.
	     * @static
	     */
	    Dispatcher.isNative = function (name) {
	      return !!nativeEvents[name.toLowerCase()];
	    };
	
	    return Dispatcher;
	  }
	);
	
	/**
	 * Observable.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This mixin will add event binding logic to classes.
	 *
	 * @mixin tinymce.util.Observable
	 */
	define(
	  'tinymce.core.util.Observable',
	  [
	    "tinymce.core.util.EventDispatcher"
	  ],
	  function (EventDispatcher) {
	    var getEventDispatcher = function (obj) {
	      if (!obj._eventDispatcher) {
	        obj._eventDispatcher = new EventDispatcher({
	          scope: obj,
	          toggleEvent: function (name, state) {
	            if (EventDispatcher.isNative(name) && obj.toggleNativeEvent) {
	              obj.toggleNativeEvent(name, state);
	            }
	          }
	        });
	      }
	
	      return obj._eventDispatcher;
	    };
	
	    return {
	      /**
	       * Fires the specified event by name. Consult the
	       * <a href="/docs/advanced/events">event reference</a> for more details on each event.
	       *
	       * @method fire
	       * @param {String} name Name of the event to fire.
	       * @param {Object?} args Event arguments.
	       * @param {Boolean?} bubble True/false if the event is to be bubbled.
	       * @return {Object} Event args instance passed in.
	       * @example
	       * instance.fire('event', {...});
	       */
	      fire: function (name, args, bubble) {
	        var self = this;
	
	        // Prevent all events except the remove event after the instance has been removed
	        if (self.removed && name !== "remove") {
	          return args;
	        }
	
	        args = getEventDispatcher(self).fire(name, args, bubble);
	
	        // Bubble event up to parents
	        if (bubble !== false && self.parent) {
	          var parent = self.parent();
	          while (parent && !args.isPropagationStopped()) {
	            parent.fire(name, args, false);
	            parent = parent.parent();
	          }
	        }
	
	        return args;
	      },
	
	      /**
	       * Binds an event listener to a specific event by name. Consult the
	       * <a href="/docs/advanced/events">event reference</a> for more details on each event.
	       *
	       * @method on
	       * @param {String} name Event name or space separated list of events to bind.
	       * @param {callback} callback Callback to be executed when the event occurs.
	       * @param {Boolean} first Optional flag if the event should be prepended. Use this with care.
	       * @return {Object} Current class instance.
	       * @example
	       * instance.on('event', function(e) {
	       *     // Callback logic
	       * });
	       */
	      on: function (name, callback, prepend) {
	        return getEventDispatcher(this).on(name, callback, prepend);
	      },
	
	      /**
	       * Unbinds an event listener to a specific event by name. Consult the
	       * <a href="/docs/advanced/events">event reference</a> for more details on each event.
	       *
	       * @method off
	       * @param {String?} name Name of the event to unbind.
	       * @param {callback?} callback Callback to unbind.
	       * @return {Object} Current class instance.
	       * @example
	       * // Unbind specific callback
	       * instance.off('event', handler);
	       *
	       * // Unbind all listeners by name
	       * instance.off('event');
	       *
	       * // Unbind all events
	       * instance.off();
	       */
	      off: function (name, callback) {
	        return getEventDispatcher(this).off(name, callback);
	      },
	
	      /**
	       * Bind the event callback and once it fires the callback is removed. Consult the
	       * <a href="/docs/advanced/events">event reference</a> for more details on each event.
	       *
	       * @method once
	       * @param {String} name Name of the event to bind.
	       * @param {callback} callback Callback to bind only once.
	       * @return {Object} Current class instance.
	       */
	      once: function (name, callback) {
	        return getEventDispatcher(this).once(name, callback);
	      },
	
	      /**
	       * Returns true/false if the object has a event of the specified name.
	       *
	       * @method hasEventListeners
	       * @param {String} name Name of the event to check for.
	       * @return {Boolean} true/false if the event exists or not.
	       */
	      hasEventListeners: function (name) {
	        return getEventDispatcher(this).has(name);
	      }
	    };
	  }
	);
	/**
	 * EditorObservable.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This mixin contains the event logic for the tinymce.Editor class.
	 *
	 * @mixin tinymce.EditorObservable
	 * @extends tinymce.util.Observable
	 */
	define(
	  'tinymce.core.EditorObservable',
	  [
	    "tinymce.core.util.Observable",
	    "tinymce.core.dom.DOMUtils",
	    "tinymce.core.util.Tools"
	  ],
	  function (Observable, DOMUtils, Tools) {
	    var DOM = DOMUtils.DOM, customEventRootDelegates;
	
	    /**
	     * Returns the event target so for the specified event. Some events fire
	     * only on document, some fire on documentElement etc. This also handles the
	     * custom event root setting where it returns that element instead of the body.
	     *
	     * @private
	     * @param {tinymce.Editor} editor Editor instance to get event target from.
	     * @param {String} eventName Name of the event for example "click".
	     * @return {Element/Document} HTML Element or document target to bind on.
	     */
	    var getEventTarget = function (editor, eventName) {
	      if (eventName == 'selectionchange') {
	        return editor.getDoc();
	      }
	
	      // Need to bind mousedown/mouseup etc to document not body in iframe mode
	      // Since the user might click on the HTML element not the BODY
	      if (!editor.inline && /^mouse|touch|click|contextmenu|drop|dragover|dragend/.test(eventName)) {
	        return editor.getDoc().documentElement;
	      }
	
	      // Bind to event root instead of body if it's defined
	      if (editor.settings.event_root) {
	        if (!editor.eventRoot) {
	          editor.eventRoot = DOM.select(editor.settings.event_root)[0];
	        }
	
	        return editor.eventRoot;
	      }
	
	      return editor.getBody();
	    };
	
	    /**
	     * Binds a event delegate for the specified name this delegate will fire
	     * the event to the editor dispatcher.
	     *
	     * @private
	     * @param {tinymce.Editor} editor Editor instance to get event target from.
	     * @param {String} eventName Name of the event for example "click".
	     */
	    var bindEventDelegate = function (editor, eventName) {
	      var eventRootElm, delegate;
	
	      var isListening = function (editor) {
	        return !editor.hidden && !editor.readonly;
	      };
	
	      if (!editor.delegates) {
	        editor.delegates = {};
	      }
	
	      if (editor.delegates[eventName] || editor.removed) {
	        return;
	      }
	
	      eventRootElm = getEventTarget(editor, eventName);
	
	      if (editor.settings.event_root) {
	        if (!customEventRootDelegates) {
	          customEventRootDelegates = {};
	          editor.editorManager.on('removeEditor', function () {
	            var name;
	
	            if (!editor.editorManager.activeEditor) {
	              if (customEventRootDelegates) {
	                for (name in customEventRootDelegates) {
	                  editor.dom.unbind(getEventTarget(editor, name));
	                }
	
	                customEventRootDelegates = null;
	              }
	            }
	          });
	        }
	
	        if (customEventRootDelegates[eventName]) {
	          return;
	        }
	
	        delegate = function (e) {
	          var target = e.target, editors = editor.editorManager.get(), i = editors.length;
	
	          while (i--) {
	            var body = editors[i].getBody();
	
	            if (body === target || DOM.isChildOf(target, body)) {
	              if (isListening(editors[i])) {
	                editors[i].fire(eventName, e);
	              }
	            }
	          }
	        };
	
	        customEventRootDelegates[eventName] = delegate;
	        DOM.bind(eventRootElm, eventName, delegate);
	      } else {
	        delegate = function (e) {
	          if (isListening(editor)) {
	            editor.fire(eventName, e);
	          }
	        };
	
	        DOM.bind(eventRootElm, eventName, delegate);
	        editor.delegates[eventName] = delegate;
	      }
	    };
	
	    var EditorObservable = {
	      /**
	       * Bind any pending event delegates. This gets executed after the target body/document is created.
	       *
	       * @private
	       */
	      bindPendingEventDelegates: function () {
	        var self = this;
	
	        Tools.each(self._pendingNativeEvents, function (name) {
	          bindEventDelegate(self, name);
	        });
	      },
	
	      /**
	       * Toggles a native event on/off this is called by the EventDispatcher when
	       * the first native event handler is added and when the last native event handler is removed.
	       *
	       * @private
	       */
	      toggleNativeEvent: function (name, state) {
	        var self = this;
	
	        // Never bind focus/blur since the FocusManager fakes those
	        if (name == "focus" || name == "blur") {
	          return;
	        }
	
	        if (state) {
	          if (self.initialized) {
	            bindEventDelegate(self, name);
	          } else {
	            if (!self._pendingNativeEvents) {
	              self._pendingNativeEvents = [name];
	            } else {
	              self._pendingNativeEvents.push(name);
	            }
	          }
	        } else if (self.initialized) {
	          self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
	          delete self.delegates[name];
	        }
	      },
	
	      /**
	       * Unbinds all native event handlers that means delegates, custom events bound using the Events API etc.
	       *
	       * @private
	       */
	      unbindAllNativeEvents: function () {
	        var self = this, name;
	
	        if (self.delegates) {
	          for (name in self.delegates) {
	            self.dom.unbind(getEventTarget(self, name), name, self.delegates[name]);
	          }
	
	          delete self.delegates;
	        }
	
	        if (!self.inline) {
	          self.getBody().onload = null;
	          self.dom.unbind(self.getWin());
	          self.dom.unbind(self.getDoc());
	        }
	
	        self.dom.unbind(self.getBody());
	        self.dom.unbind(self.getContainer());
	      }
	    };
	
	    EditorObservable = Tools.extend({}, Observable, EditorObservable);
	
	    return EditorObservable;
	  }
	);
	
	/**
	 * Mode.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Mode switcher logic.
	 *
	 * @private
	 * @class tinymce.Mode
	 */
	define(
	  'tinymce.core.Mode',
	  [
	  ],
	  function () {
	    var setEditorCommandState = function (editor, cmd, state) {
	      try {
	        editor.getDoc().execCommand(cmd, false, state);
	      } catch (ex) {
	        // Ignore
	      }
	    };
	
	    var clickBlocker = function (editor) {
	      var target, handler;
	
	      target = editor.getBody();
	
	      handler = function (e) {
	        if (editor.dom.getParents(e.target, 'a').length > 0) {
	          e.preventDefault();
	        }
	      };
	
	      editor.dom.bind(target, 'click', handler);
	
	      return {
	        unbind: function () {
	          editor.dom.unbind(target, 'click', handler);
	        }
	      };
	    };
	
	    var toggleReadOnly = function (editor, state) {
	      if (editor._clickBlocker) {
	        editor._clickBlocker.unbind();
	        editor._clickBlocker = null;
	      }
	
	      if (state) {
	        editor._clickBlocker = clickBlocker(editor);
	        editor.selection.controlSelection.hideResizeRect();
	        editor.readonly = true;
	        editor.getBody().contentEditable = false;
	      } else {
	        editor.readonly = false;
	        editor.getBody().contentEditable = true;
	        setEditorCommandState(editor, "StyleWithCSS", false);
	        setEditorCommandState(editor, "enableInlineTableEditing", false);
	        setEditorCommandState(editor, "enableObjectResizing", false);
	        editor.focus();
	        editor.nodeChanged();
	      }
	    };
	
	    var setMode = function (editor, mode) {
	      var currentMode = editor.readonly ? 'readonly' : 'design';
	
	      if (mode == currentMode) {
	        return;
	      }
	
	      if (editor.initialized) {
	        toggleReadOnly(editor, mode == 'readonly');
	      } else {
	        editor.on('init', function () {
	          toggleReadOnly(editor, mode == 'readonly');
	        });
	      }
	
	      // Event is NOT preventable
	      editor.fire('SwitchMode', { mode: mode });
	    };
	
	    return {
	      setMode: setMode
	    };
	  }
	);
	/**
	 * Shortcuts.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Contains logic for handling keyboard shortcuts.
	 *
	 * @class tinymce.Shortcuts
	 * @example
	 * editor.shortcuts.add('ctrl+a', "description of the shortcut", function() {});
	 * editor.shortcuts.add('meta+a', "description of the shortcut", function() {}); // "meta" maps to Command on Mac and Ctrl on PC
	 * editor.shortcuts.add('ctrl+alt+a', "description of the shortcut", function() {});
	 * editor.shortcuts.add('access+a', "description of the shortcut", function() {}); // "access" maps to ctrl+alt on Mac and shift+alt on PC
	 */
	define(
	  'tinymce.core.Shortcuts',
	  [
	    'tinymce.core.util.Tools',
	    'tinymce.core.Env'
	  ],
	  function (Tools, Env) {
	    var each = Tools.each, explode = Tools.explode;
	
	    var keyCodeLookup = {
	      "f9": 120,
	      "f10": 121,
	      "f11": 122
	    };
	
	    var modifierNames = Tools.makeMap('alt,ctrl,shift,meta,access');
	
	    return function (editor) {
	      var self = this, shortcuts = {}, pendingPatterns = [];
	
	      var parseShortcut = function (pattern) {
	        var id, key, shortcut = {};
	
	        // Parse modifiers and keys ctrl+alt+b for example
	        each(explode(pattern, '+'), function (value) {
	          if (value in modifierNames) {
	            shortcut[value] = true;
	          } else {
	            // Allow numeric keycodes like ctrl+219 for ctrl+[
	            if (/^[0-9]{2,}$/.test(value)) {
	              shortcut.keyCode = parseInt(value, 10);
	            } else {
	              shortcut.charCode = value.charCodeAt(0);
	              shortcut.keyCode = keyCodeLookup[value] || value.toUpperCase().charCodeAt(0);
	            }
	          }
	        });
	
	        // Generate unique id for modifier combination and set default state for unused modifiers
	        id = [shortcut.keyCode];
	        for (key in modifierNames) {
	          if (shortcut[key]) {
	            id.push(key);
	          } else {
	            shortcut[key] = false;
	          }
	        }
	        shortcut.id = id.join(',');
	
	        // Handle special access modifier differently depending on Mac/Win
	        if (shortcut.access) {
	          shortcut.alt = true;
	
	          if (Env.mac) {
	            shortcut.ctrl = true;
	          } else {
	            shortcut.shift = true;
	          }
	        }
	
	        // Handle special meta modifier differently depending on Mac/Win
	        if (shortcut.meta) {
	          if (Env.mac) {
	            shortcut.meta = true;
	          } else {
	            shortcut.ctrl = true;
	            shortcut.meta = false;
	          }
	        }
	
	        return shortcut;
	      };
	
	      var createShortcut = function (pattern, desc, cmdFunc, scope) {
	        var shortcuts;
	
	        shortcuts = Tools.map(explode(pattern, '>'), parseShortcut);
	        shortcuts[shortcuts.length - 1] = Tools.extend(shortcuts[shortcuts.length - 1], {
	          func: cmdFunc,
	          scope: scope || editor
	        });
	
	        return Tools.extend(shortcuts[0], {
	          desc: editor.translate(desc),
	          subpatterns: shortcuts.slice(1)
	        });
	      };
	
	      var hasModifier = function (e) {
	        return e.altKey || e.ctrlKey || e.metaKey;
	      };
	
	      var isFunctionKey = function (e) {
	        return e.type === "keydown" && e.keyCode >= 112 && e.keyCode <= 123;
	      };
	
	      var matchShortcut = function (e, shortcut) {
	        if (!shortcut) {
	          return false;
	        }
	
	        if (shortcut.ctrl != e.ctrlKey || shortcut.meta != e.metaKey) {
	          return false;
	        }
	
	        if (shortcut.alt != e.altKey || shortcut.shift != e.shiftKey) {
	          return false;
	        }
	
	        if (e.keyCode == shortcut.keyCode || (e.charCode && e.charCode == shortcut.charCode)) {
	          e.preventDefault();
	          return true;
	        }
	
	        return false;
	      };
	
	      var executeShortcutAction = function (shortcut) {
	        return shortcut.func ? shortcut.func.call(shortcut.scope) : null;
	      };
	
	      editor.on('keyup keypress keydown', function (e) {
	        if ((hasModifier(e) || isFunctionKey(e)) && !e.isDefaultPrevented()) {
	          each(shortcuts, function (shortcut) {
	            if (matchShortcut(e, shortcut)) {
	              pendingPatterns = shortcut.subpatterns.slice(0);
	
	              if (e.type == "keydown") {
	                executeShortcutAction(shortcut);
	              }
	
	              return true;
	            }
	          });
	
	          if (matchShortcut(e, pendingPatterns[0])) {
	            if (pendingPatterns.length === 1) {
	              if (e.type == "keydown") {
	                executeShortcutAction(pendingPatterns[0]);
	              }
	            }
	
	            pendingPatterns.shift();
	          }
	        }
	      });
	
	      /**
	       * Adds a keyboard shortcut for some command or function.
	       *
	       * @method add
	       * @param {String} pattern Shortcut pattern. Like for example: ctrl+alt+o.
	       * @param {String} desc Text description for the command.
	       * @param {String/Function} cmdFunc Command name string or function to execute when the key is pressed.
	       * @param {Object} scope Optional scope to execute the function in.
	       * @return {Boolean} true/false state if the shortcut was added or not.
	       */
	      self.add = function (pattern, desc, cmdFunc, scope) {
	        var cmd;
	
	        cmd = cmdFunc;
	
	        if (typeof cmdFunc === 'string') {
	          cmdFunc = function () {
	            editor.execCommand(cmd, false, null);
	          };
	        } else if (Tools.isArray(cmd)) {
	          cmdFunc = function () {
	            editor.execCommand(cmd[0], cmd[1], cmd[2]);
	          };
	        }
	
	        each(explode(Tools.trim(pattern.toLowerCase())), function (pattern) {
	          var shortcut = createShortcut(pattern, desc, cmdFunc, scope);
	          shortcuts[shortcut.id] = shortcut;
	        });
	
	        return true;
	      };
	
	      /**
	       * Remove a keyboard shortcut by pattern.
	       *
	       * @method remove
	       * @param {String} pattern Shortcut pattern. Like for example: ctrl+alt+o.
	       * @return {Boolean} true/false state if the shortcut was removed or not.
	       */
	      self.remove = function (pattern) {
	        var shortcut = createShortcut(pattern);
	
	        if (shortcuts[shortcut.id]) {
	          delete shortcuts[shortcut.id];
	          return true;
	        }
	
	        return false;
	      };
	    };
	  }
	);
	
	/**
	 * SaxParser.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*eslint max-depth:[2, 9] */
	
	/**
	 * This class parses HTML code using pure JavaScript and executes various events for each item it finds. It will
	 * always execute the events in the right order for tag soup code like <b><p></b></p>. It will also remove elements
	 * and attributes that doesn't fit the schema if the validate setting is enabled.
	 *
	 * @example
	 * var parser = new tinymce.html.SaxParser({
	 *     validate: true,
	 *
	 *     comment: function(text) {
	 *         console.log('Comment:', text);
	 *     },
	 *
	 *     cdata: function(text) {
	 *         console.log('CDATA:', text);
	 *     },
	 *
	 *     text: function(text, raw) {
	 *         console.log('Text:', text, 'Raw:', raw);
	 *     },
	 *
	 *     start: function(name, attrs, empty) {
	 *         console.log('Start:', name, attrs, empty);
	 *     },
	 *
	 *     end: function(name) {
	 *         console.log('End:', name);
	 *     },
	 *
	 *     pi: function(name, text) {
	 *         console.log('PI:', name, text);
	 *     },
	 *
	 *     doctype: function(text) {
	 *         console.log('DocType:', text);
	 *     }
	 * }, schema);
	 * @class tinymce.html.SaxParser
	 * @version 3.4
	 */
	define(
	  'tinymce.core.html.SaxParser',
	  [
	    "tinymce.core.html.Schema",
	    "tinymce.core.html.Entities",
	    "tinymce.core.util.Tools"
	  ],
	  function (Schema, Entities, Tools) {
	    var each = Tools.each;
	
	    var isValidPrefixAttrName = function (name) {
	      return name.indexOf('data-') === 0 || name.indexOf('aria-') === 0;
	    };
	
	    var trimComments = function (text) {
	      return text.replace(/<!--|-->/g, '');
	    };
	
	    /**
	     * Returns the index of the end tag for a specific start tag. This can be
	     * used to skip all children of a parent element from being processed.
	     *
	     * @private
	     * @method findEndTag
	     * @param {tinymce.html.Schema} schema Schema instance to use to match short ended elements.
	     * @param {String} html HTML string to find the end tag in.
	     * @param {Number} startIndex Indext to start searching at should be after the start tag.
	     * @return {Number} Index of the end tag.
	     */
	    var findEndTag = function (schema, html, startIndex) {
	      var count = 1, index, matches, tokenRegExp, shortEndedElements;
	
	      shortEndedElements = schema.getShortEndedElements();
	      tokenRegExp = /<([!?\/])?([A-Za-z0-9\-_\:\.]+)((?:\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\/|\s+)>/g;
	      tokenRegExp.lastIndex = index = startIndex;
	
	      while ((matches = tokenRegExp.exec(html))) {
	        index = tokenRegExp.lastIndex;
	
	        if (matches[1] === '/') { // End element
	          count--;
	        } else if (!matches[1]) { // Start element
	          if (matches[2] in shortEndedElements) {
	            continue;
	          }
	
	          count++;
	        }
	
	        if (count === 0) {
	          break;
	        }
	      }
	
	      return index;
	    };
	
	    /**
	     * Constructs a new SaxParser instance.
	     *
	     * @constructor
	     * @method SaxParser
	     * @param {Object} settings Name/value collection of settings. comment, cdata, text, start and end are callbacks.
	     * @param {tinymce.html.Schema} schema HTML Schema class to use when parsing.
	     */
	    var SaxParser = function (settings, schema) {
	      var self = this;
	
	      var noop = function () { };
	
	      settings = settings || {};
	      self.schema = schema = schema || new Schema();
	
	      if (settings.fix_self_closing !== false) {
	        settings.fix_self_closing = true;
	      }
	
	      // Add handler functions from settings and setup default handlers
	      each('comment cdata text start end pi doctype'.split(' '), function (name) {
	        if (name) {
	          self[name] = settings[name] || noop;
	        }
	      });
	
	      /**
	       * Parses the specified HTML string and executes the callbacks for each item it finds.
	       *
	       * @example
	       * new SaxParser({...}).parse('<b>text</b>');
	       * @method parse
	       * @param {String} html Html string to sax parse.
	       */
	      self.parse = function (html) {
	        var self = this, matches, index = 0, value, endRegExp, stack = [], attrList, i, text, name;
	        var isInternalElement, removeInternalElements, shortEndedElements, fillAttrsMap, isShortEnded;
	        var validate, elementRule, isValidElement, attr, attribsValue, validAttributesMap, validAttributePatterns;
	        var attributesRequired, attributesDefault, attributesForced, processHtml;
	        var anyAttributesRequired, selfClosing, tokenRegExp, attrRegExp, specialElements, attrValue, idCount = 0;
	        var decode = Entities.decode, fixSelfClosing, filteredUrlAttrs = Tools.makeMap('src,href,data,background,formaction,poster');
	        var scriptUriRegExp = /((java|vb)script|mhtml):/i, dataUriRegExp = /^data:/i;
	
	        var processEndTag = function (name) {
	          var pos, i;
	
	          // Find position of parent of the same type
	          pos = stack.length;
	          while (pos--) {
	            if (stack[pos].name === name) {
	              break;
	            }
	          }
	
	          // Found parent
	          if (pos >= 0) {
	            // Close all the open elements
	            for (i = stack.length - 1; i >= pos; i--) {
	              name = stack[i];
	
	              if (name.valid) {
	                self.end(name.name);
	              }
	            }
	
	            // Remove the open elements from the stack
	            stack.length = pos;
	          }
	        };
	
	        var parseAttribute = function (match, name, value, val2, val3) {
	          var attrRule, i, trimRegExp = /[\s\u0000-\u001F]+/g;
	
	          name = name.toLowerCase();
	          value = name in fillAttrsMap ? name : decode(value || val2 || val3 || ''); // Handle boolean attribute than value attribute
	
	          // Validate name and value pass through all data- attributes
	          if (validate && !isInternalElement && isValidPrefixAttrName(name) === false) {
	            attrRule = validAttributesMap[name];
	
	            // Find rule by pattern matching
	            if (!attrRule && validAttributePatterns) {
	              i = validAttributePatterns.length;
	              while (i--) {
	                attrRule = validAttributePatterns[i];
	                if (attrRule.pattern.test(name)) {
	                  break;
	                }
	              }
	
	              // No rule matched
	              if (i === -1) {
	                attrRule = null;
	              }
	            }
	
	            // No attribute rule found
	            if (!attrRule) {
	              return;
	            }
	
	            // Validate value
	            if (attrRule.validValues && !(value in attrRule.validValues)) {
	              return;
	            }
	          }
	
	          // Block any javascript: urls or non image data uris
	          if (filteredUrlAttrs[name] && !settings.allow_script_urls) {
	            var uri = value.replace(trimRegExp, '');
	
	            try {
	              // Might throw malformed URI sequence
	              uri = decodeURIComponent(uri);
	            } catch (ex) {
	              // Fallback to non UTF-8 decoder
	              uri = unescape(uri);
	            }
	
	            if (scriptUriRegExp.test(uri)) {
	              return;
	            }
	
	            if (!settings.allow_html_data_urls && dataUriRegExp.test(uri) && !/^data:image\//i.test(uri)) {
	              return;
	            }
	          }
	
	          // Block data or event attributes on elements marked as internal
	          if (isInternalElement && (name in filteredUrlAttrs || name.indexOf('on') === 0)) {
	            return;
	          }
	
	          // Add attribute to list and map
	          attrList.map[name] = value;
	          attrList.push({
	            name: name,
	            value: value
	          });
	        };
	
	        // Precompile RegExps and map objects
	        tokenRegExp = new RegExp('<(?:' +
	          '(?:!--([\\w\\W]*?)-->)|' + // Comment
	          '(?:!\\[CDATA\\[([\\w\\W]*?)\\]\\]>)|' + // CDATA
	          '(?:!DOCTYPE([\\w\\W]*?)>)|' + // DOCTYPE
	          '(?:\\?([^\\s\\/<>]+) ?([\\w\\W]*?)[?/]>)|' + // PI
	          '(?:\\/([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)>)|' + // End element
	          '(?:([A-Za-z][A-Za-z0-9\\-_\\:\\.]*)((?:\\s+[^"\'>]+(?:(?:"[^"]*")|(?:\'[^\']*\')|[^>]*))*|\\/|\\s+)>)' + // Start element
	          ')', 'g');
	
	        attrRegExp = /([\w:\-]+)(?:\s*=\s*(?:(?:\"((?:[^\"])*)\")|(?:\'((?:[^\'])*)\')|([^>\s]+)))?/g;
	
	        // Setup lookup tables for empty elements and boolean attributes
	        shortEndedElements = schema.getShortEndedElements();
	        selfClosing = settings.self_closing_elements || schema.getSelfClosingElements();
	        fillAttrsMap = schema.getBoolAttrs();
	        validate = settings.validate;
	        removeInternalElements = settings.remove_internals;
	        fixSelfClosing = settings.fix_self_closing;
	        specialElements = schema.getSpecialElements();
	        processHtml = html + '>';
	
	        while ((matches = tokenRegExp.exec(processHtml))) { // Adds and extra '>' to keep regexps from doing catastrofic backtracking on malformed html
	          // Text
	          if (index < matches.index) {
	            self.text(decode(html.substr(index, matches.index - index)));
	          }
	
	          if ((value = matches[6])) { // End element
	            value = value.toLowerCase();
	
	            // IE will add a ":" in front of elements it doesn't understand like custom elements or HTML5 elements
	            if (value.charAt(0) === ':') {
	              value = value.substr(1);
	            }
	
	            processEndTag(value);
	          } else if ((value = matches[7])) { // Start element
	            // Did we consume the extra character then treat it as text
	            // This handles the case with html like this: "text a<b text"
	            if (matches.index + matches[0].length > html.length) {
	              self.text(decode(html.substr(matches.index)));
	              index = matches.index + matches[0].length;
	              continue;
	            }
	
	            value = value.toLowerCase();
	
	            // IE will add a ":" in front of elements it doesn't understand like custom elements or HTML5 elements
	            if (value.charAt(0) === ':') {
	              value = value.substr(1);
	            }
	
	            isShortEnded = value in shortEndedElements;
	
	            // Is self closing tag for example an <li> after an open <li>
	            if (fixSelfClosing && selfClosing[value] && stack.length > 0 && stack[stack.length - 1].name === value) {
	              processEndTag(value);
	            }
	
	            // Validate element
	            if (!validate || (elementRule = schema.getElementRule(value))) {
	              isValidElement = true;
	
	              // Grab attributes map and patters when validation is enabled
	              if (validate) {
	                validAttributesMap = elementRule.attributes;
	                validAttributePatterns = elementRule.attributePatterns;
	              }
	
	              // Parse attributes
	              if ((attribsValue = matches[8])) {
	                isInternalElement = attribsValue.indexOf('data-mce-type') !== -1; // Check if the element is an internal element
	
	                // If the element has internal attributes then remove it if we are told to do so
	                if (isInternalElement && removeInternalElements) {
	                  isValidElement = false;
	                }
	
	                attrList = [];
	                attrList.map = {};
	
	                attribsValue.replace(attrRegExp, parseAttribute);
	              } else {
	                attrList = [];
	                attrList.map = {};
	              }
	
	              // Process attributes if validation is enabled
	              if (validate && !isInternalElement) {
	                attributesRequired = elementRule.attributesRequired;
	                attributesDefault = elementRule.attributesDefault;
	                attributesForced = elementRule.attributesForced;
	                anyAttributesRequired = elementRule.removeEmptyAttrs;
	
	                // Check if any attribute exists
	                if (anyAttributesRequired && !attrList.length) {
	                  isValidElement = false;
	                }
	
	                // Handle forced attributes
	                if (attributesForced) {
	                  i = attributesForced.length;
	                  while (i--) {
	                    attr = attributesForced[i];
	                    name = attr.name;
	                    attrValue = attr.value;
	
	                    if (attrValue === '{$uid}') {
	                      attrValue = 'mce_' + idCount++;
	                    }
	
	                    attrList.map[name] = attrValue;
	                    attrList.push({ name: name, value: attrValue });
	                  }
	                }
	
	                // Handle default attributes
	                if (attributesDefault) {
	                  i = attributesDefault.length;
	                  while (i--) {
	                    attr = attributesDefault[i];
	                    name = attr.name;
	
	                    if (!(name in attrList.map)) {
	                      attrValue = attr.value;
	
	                      if (attrValue === '{$uid}') {
	                        attrValue = 'mce_' + idCount++;
	                      }
	
	                      attrList.map[name] = attrValue;
	                      attrList.push({ name: name, value: attrValue });
	                    }
	                  }
	                }
	
	                // Handle required attributes
	                if (attributesRequired) {
	                  i = attributesRequired.length;
	                  while (i--) {
	                    if (attributesRequired[i] in attrList.map) {
	                      break;
	                    }
	                  }
	
	                  // None of the required attributes where found
	                  if (i === -1) {
	                    isValidElement = false;
	                  }
	                }
	
	                // Invalidate element if it's marked as bogus
	                if ((attr = attrList.map['data-mce-bogus'])) {
	                  if (attr === 'all') {
	                    index = findEndTag(schema, html, tokenRegExp.lastIndex);
	                    tokenRegExp.lastIndex = index;
	                    continue;
	                  }
	
	                  isValidElement = false;
	                }
	              }
	
	              if (isValidElement) {
	                self.start(value, attrList, isShortEnded);
	              }
	            } else {
	              isValidElement = false;
	            }
	
	            // Treat script, noscript and style a bit different since they may include code that looks like elements
	            if ((endRegExp = specialElements[value])) {
	              endRegExp.lastIndex = index = matches.index + matches[0].length;
	
	              if ((matches = endRegExp.exec(html))) {
	                if (isValidElement) {
	                  text = html.substr(index, matches.index - index);
	                }
	
	                index = matches.index + matches[0].length;
	              } else {
	                text = html.substr(index);
	                index = html.length;
	              }
	
	              if (isValidElement) {
	                if (text.length > 0) {
	                  self.text(text, true);
	                }
	
	                self.end(value);
	              }
	
	              tokenRegExp.lastIndex = index;
	              continue;
	            }
	
	            // Push value on to stack
	            if (!isShortEnded) {
	              if (!attribsValue || attribsValue.indexOf('/') != attribsValue.length - 1) {
	                stack.push({ name: value, valid: isValidElement });
	              } else if (isValidElement) {
	                self.end(value);
	              }
	            }
	          } else if ((value = matches[1])) { // Comment
	            // Padd comment value to avoid browsers from parsing invalid comments as HTML
	            if (value.charAt(0) === '>') {
	              value = ' ' + value;
	            }
	
	            if (!settings.allow_conditional_comments && value.substr(0, 3).toLowerCase() === '[if') {
	              value = ' ' + value;
	            }
	
	            self.comment(value);
	          } else if ((value = matches[2])) { // CDATA
	            self.cdata(trimComments(value));
	          } else if ((value = matches[3])) { // DOCTYPE
	            self.doctype(value);
	          } else if ((value = matches[4])) { // PI
	            self.pi(value, matches[5]);
	          }
	
	          index = matches.index + matches[0].length;
	        }
	
	        // Text
	        if (index < html.length) {
	          self.text(decode(html.substr(index)));
	        }
	
	        // Close any open elements
	        for (i = stack.length - 1; i >= 0; i--) {
	          value = stack[i];
	
	          if (value.valid) {
	            self.end(value.name);
	          }
	        }
	      };
	    };
	
	    SaxParser.findEndTag = findEndTag;
	
	    return SaxParser;
	  }
	);
	/**
	 * TrimHtml.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.TrimHtml',
	  [
	    'tinymce.core.html.SaxParser',
	    'tinymce.core.text.Zwsp'
	  ],
	  function (SaxParser, Zwsp) {
	    var trimHtml = function (tempAttrs, html) {
	      var trimContentRegExp = new RegExp([
	        '\\s?(' + tempAttrs.join('|') + ')="[^"]+"' // Trim temporaty data-mce prefixed attributes like data-mce-selected
	      ].join('|'), 'gi');
	
	      return html.replace(trimContentRegExp, '');
	    };
	
	    var trimInternal = function (serializer, html) {
	      var content = html;
	      var bogusAllRegExp = /<(\w+) [^>]*data-mce-bogus="all"[^>]*>/g;
	      var endTagIndex, index, matchLength, matches, shortEndedElements;
	      var schema = serializer.schema;
	
	      content = trimHtml(serializer.getTempAttrs(), content);
	      shortEndedElements = schema.getShortEndedElements();
	
	      // Remove all bogus elements marked with "all"
	      while ((matches = bogusAllRegExp.exec(content))) {
	        index = bogusAllRegExp.lastIndex;
	        matchLength = matches[0].length;
	
	        if (shortEndedElements[matches[1]]) {
	          endTagIndex = index;
	        } else {
	          endTagIndex = SaxParser.findEndTag(schema, content, index);
	        }
	
	        content = content.substring(0, index - matchLength) + content.substring(endTagIndex);
	        bogusAllRegExp.lastIndex = index - matchLength;
	      }
	
	      return content;
	    };
	
	    var trimExternal = function (serializer, html) {
	      return Zwsp.trim(trimInternal(serializer, html));
	    };
	
	    return {
	      trimExternal: trimExternal,
	      trimInternal: trimInternal
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.search.PredicateExists',
	
	  [
	    'ephox.sugar.api.search.PredicateFind'
	  ],
	
	  function (PredicateFind) {
	    var any = function (predicate) {
	      return PredicateFind.first(predicate).isSome();
	    };
	
	    var ancestor = function (scope, predicate, isRoot) {
	      return PredicateFind.ancestor(scope, predicate, isRoot).isSome();
	    };
	
	    var closest = function (scope, predicate, isRoot) {
	      return PredicateFind.closest(scope, predicate, isRoot).isSome();
	    };
	
	    var sibling = function (scope, predicate) {
	      return PredicateFind.sibling(scope, predicate).isSome();
	    };
	
	    var child = function (scope, predicate) {
	      return PredicateFind.child(scope, predicate).isSome();
	    };
	
	    var descendant = function (scope, predicate) {
	      return PredicateFind.descendant(scope, predicate).isSome();
	    };
	
	    return {
	      any: any,
	      ancestor: ancestor,
	      closest: closest,
	      sibling: sibling,
	      child: child,
	      descendant: descendant
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.dom.Focus',
	
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.PredicateExists',
	    'ephox.sugar.api.search.Traverse',
	    'global!document'
	  ],
	
	  function (Fun, Option, Compare, Element, PredicateExists, Traverse, document) {
	    var focus = function (element) {
	      element.dom().focus();
	    };
	
	    var blur = function (element) {
	      element.dom().blur();
	    };
	
	    var hasFocus = function (element) {
	      var doc = Traverse.owner(element).dom();
	      return element.dom() === doc.activeElement;
	    };
	
	    var active = function (_doc) {
	      var doc = _doc !== undefined ? _doc.dom() : document;
	      return Option.from(doc.activeElement).map(Element.fromDom);
	    };
	
	    var focusInside = function (element) {
	      // Only call focus if the focus is not already inside it.
	      var doc = Traverse.owner(element);
	      var inside = active(doc).filter(function (a) {
	        return PredicateExists.closest(a, Fun.curry(Compare.eq, element));
	      });
	
	      inside.fold(function () {
	        focus(element);
	      }, Fun.noop);
	    };
	
	    /**
	     * Return the descendant element that has focus.
	     * Use instead of SelectorFind.descendant(container, ':focus')
	     *  because the :focus selector relies on keyboard focus.
	     */
	    var search = function (element) {
	      return active(Traverse.owner(element)).filter(function (e) {
	        return element.dom().contains(e.dom());
	      });
	    };
	
	    return {
	      hasFocus: hasFocus,
	      focus: focus,
	      blur: blur,
	      active: active,
	      search: search,
	      focusInside: focusInside
	    };
	  }
	);
	/**
	 * EditorFocus.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.focus.EditorFocus',
	  [
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.dom.Focus',
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.Env',
	    'tinymce.core.caret.CaretFinder',
	    'tinymce.core.dom.ElementType',
	    'tinymce.core.selection.RangeNodes',
	    'tinymce.core.selection.SelectionBookmark'
	  ],
	  function (Option, Compare, Focus, Element, Env, CaretFinder, ElementType, RangeNodes, SelectionBookmark) {
	    var getContentEditableHost = function (editor, node) {
	      return editor.dom.getParent(node, function (node) {
	        return editor.dom.getContentEditable(node) === "true";
	      });
	    };
	
	    var getCollapsedNode = function (rng) {
	      return rng.collapsed ? Option.from(RangeNodes.getNode(rng.startContainer, rng.startOffset)).map(Element.fromDom) : Option.none();
	    };
	
	    var getFocusInElement = function (root, rng) {
	      return getCollapsedNode(rng).bind(function (node) {
	        if (ElementType.isTableSection(node)) {
	          return Option.some(node);
	        } else if (Compare.contains(root, node) === false) {
	          return Option.some(root);
	        } else {
	          return Option.none();
	        }
	      });
	    };
	
	    var normalizeSelection = function (editor, rng) {
	      getFocusInElement(Element.fromDom(editor.getBody()), rng).bind(function (elm) {
	        return CaretFinder.firstPositionIn(elm.dom());
	      }).fold(
	        function () {
	          editor.selection.normalize();
	        },
	        function (caretPos) {
	          editor.selection.setRng(caretPos.toRange());
	        }
	      );
	    };
	
	    var focusBody = function (body) {
	      if (body.setActive) {
	        // IE 11 sometimes throws "Invalid function" then fallback to focus
	        // setActive is better since it doesn't scroll to the element being focused
	        try {
	          body.setActive();
	        } catch (ex) {
	          body.focus();
	        }
	      } else {
	        body.focus();
	      }
	    };
	
	    var hasElementFocus = function (elm) {
	      return Focus.hasFocus(elm) || Focus.search(elm).isSome();
	    };
	
	    var hasIframeFocus = function (editor) {
	      return editor.iframeElement && Focus.hasFocus(Element.fromDom(editor.iframeElement));
	    };
	
	    var hasInlineFocus = function (editor) {
	      var rawBody = editor.getBody();
	      return rawBody && hasElementFocus(Element.fromDom(rawBody));
	    };
	
	    var hasFocus = function (editor) {
	      return editor.inline ? hasInlineFocus(editor) : hasIframeFocus(editor);
	    };
	
	    var focusEditor = function (editor) {
	      var selection = editor.selection, contentEditable = editor.settings.content_editable;
	      var body = editor.getBody(), contentEditableHost, rng = selection.getRng();
	
	      editor.quirks.refreshContentEditable();
	
	      // Move focus to contentEditable=true child if needed
	      contentEditableHost = getContentEditableHost(editor, selection.getNode());
	      if (editor.$.contains(body, contentEditableHost)) {
	        focusBody(contentEditableHost);
	        normalizeSelection(editor, rng);
	        activateEditor(editor);
	        return;
	      }
	
	      if (editor.bookmark !== undefined && hasFocus(editor) === false) {
	        SelectionBookmark.getRng(editor).each(function (bookmarkRng) {
	          editor.selection.setRng(bookmarkRng);
	          rng = bookmarkRng;
	        });
	      }
	
	      // Focus the window iframe
	      if (!contentEditable) {
	        // WebKit needs this call to fire focusin event properly see #5948
	        // But Opera pre Blink engine will produce an empty selection so skip Opera
	        if (!Env.opera) {
	          focusBody(body);
	        }
	
	        editor.getWin().focus();
	      }
	
	      // Focus the body as well since it's contentEditable
	      if (Env.gecko || contentEditable) {
	        focusBody(body);
	        normalizeSelection(editor, rng);
	      }
	
	      activateEditor(editor);
	    };
	
	    var activateEditor = function (editor) {
	      editor.editorManager.setActive(editor);
	    };
	
	    var focus = function (editor, skipFocus) {
	      if (editor.removed) {
	        return;
	      }
	
	      skipFocus ? activateEditor(editor) : focusEditor(editor);
	    };
	
	    return {
	      focus: focus,
	      hasFocus: hasFocus
	    };
	  }
	);
	
	/**
	 * EditorView.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.EditorView',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.properties.Css',
	    'ephox.sugar.api.search.Traverse'
	  ],
	  function (Fun, Option, Compare, Element, Css, Traverse) {
	    var getProp = function (propName, elm) {
	      var rawElm = elm.dom();
	      return rawElm[propName];
	    };
	
	    var getComputedSizeProp = function (propName, elm) {
	      return parseInt(Css.get(elm, propName), 10);
	    };
	
	    var getClientWidth = Fun.curry(getProp, 'clientWidth');
	    var getClientHeight = Fun.curry(getProp, 'clientHeight');
	    var getMarginTop = Fun.curry(getComputedSizeProp, 'margin-top');
	    var getMarginLeft = Fun.curry(getComputedSizeProp, 'margin-left');
	
	    var getBoundingClientRect = function (elm) {
	      return elm.dom().getBoundingClientRect();
	    };
	
	    var isInsideElementContentArea = function (bodyElm, clientX, clientY) {
	      var clientWidth = getClientWidth(bodyElm);
	      var clientHeight = getClientHeight(bodyElm);
	
	      return clientX >= 0 && clientY >= 0 && clientX <= clientWidth && clientY <= clientHeight;
	    };
	
	    var transpose = function (inline, elm, clientX, clientY) {
	      var clientRect = getBoundingClientRect(elm);
	      var deltaX = inline ? clientRect.left + elm.dom().clientLeft + getMarginLeft(elm) : 0;
	      var deltaY = inline ? clientRect.top + elm.dom().clientTop + getMarginTop(elm) : 0;
	      var x = clientX - deltaX;
	      var y = clientY - deltaY;
	
	      return { x: x, y: y };
	    };
	
	    // Checks if the specified coordinate is within the visual content area excluding the scrollbars
	    var isXYInContentArea = function (editor, clientX, clientY) {
	      var bodyElm = Element.fromDom(editor.getBody());
	      var targetElm = editor.inline ? bodyElm : Traverse.documentElement(bodyElm);
	      var transposedPoint = transpose(editor.inline, targetElm, clientX, clientY);
	
	      return isInsideElementContentArea(targetElm, transposedPoint.x, transposedPoint.y);
	    };
	
	    var fromDomSafe = function (node) {
	      return Option.from(node).map(Element.fromDom);
	    };
	
	    var isEditorAttachedToDom = function (editor) {
	      var rawContainer = editor.inline ? editor.getBody() : editor.getContentAreaContainer();
	
	      return fromDomSafe(rawContainer).map(function (container) {
	        return Compare.contains(Traverse.owner(container), container);
	      }).getOr(false);
	    };
	
	    return {
	      isXYInContentArea: isXYInContentArea,
	      isEditorAttachedToDom: isEditorAttachedToDom
	    };
	  }
	);
	
	/**
	 * NotificationManagerImpl.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.ui.NotificationManagerImpl',
	  [
	  ],
	  function () {
	    return function () {
	      var unimplemented = function () {
	        throw new Error('Theme did not provide a NotificationManager implementation.');
	      };
	
	      return {
	        open: unimplemented,
	        close: unimplemented,
	        reposition: unimplemented,
	        getArgs: unimplemented
	      };
	    };
	  }
	);
	
	/**
	 * NotificationManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles the creation of TinyMCE's notifications.
	 *
	 * @class tinymce.NotificationManager
	 * @example
	 * // Opens a new notification of type "error" with text "An error occurred."
	 * tinymce.activeEditor.notificationManager.open({
	 *    text: 'An error occurred.',
	 *    type: 'error'
	 * });
	 */
	define(
	  'tinymce.core.api.NotificationManager',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Option',
	    'tinymce.core.EditorView',
	    'tinymce.core.ui.NotificationManagerImpl',
	    'tinymce.core.util.Delay'
	  ],
	  function (Arr, Option, EditorView, NotificationManagerImpl, Delay) {
	    return function (editor) {
	      var notifications = [];
	
	      var getImplementation = function () {
	        var theme = editor.theme;
	        return theme && theme.getNotificationManagerImpl ? theme.getNotificationManagerImpl() : NotificationManagerImpl();
	      };
	
	      var getTopNotification = function () {
	        return Option.from(notifications[0]);
	      };
	
	      var isEqual = function (a, b) {
	        return a.type === b.type && a.text === b.text && !a.progressBar && !a.timeout && !b.progressBar && !b.timeout;
	      };
	
	      var reposition = function () {
	        if (notifications.length > 0) {
	          getImplementation().reposition(notifications);
	        }
	      };
	
	      var addNotification = function (notification) {
	        notifications.push(notification);
	      };
	
	      var closeNotification = function (notification) {
	        Arr.findIndex(notifications, function (otherNotification) {
	          return otherNotification === notification;
	        }).each(function (index) {
	          // Mutate here since third party might have stored away the window array
	          // TODO: Consider breaking this api
	          notifications.splice(index, 1);
	        });
	      };
	
	      var open = function (args) {
	        // Never open notification if editor has been removed.
	        if (editor.removed || !EditorView.isEditorAttachedToDom(editor)) {
	          return;
	        }
	
	        return Arr.find(notifications, function (notification) {
	          return isEqual(getImplementation().getArgs(notification), args);
	        }).getOrThunk(function () {
	          editor.editorManager.setActive(editor);
	
	          var notification = getImplementation().open(args, function () {
	            closeNotification(notification);
	            reposition();
	          });
	
	          addNotification(notification);
	          reposition();
	          return notification;
	        });
	      };
	
	      var close = function () {
	        getTopNotification().each(function (notification) {
	          getImplementation().close(notification);
	          closeNotification(notification);
	          reposition();
	        });
	      };
	
	      var getNotifications = function () {
	        return notifications;
	      };
	
	      var registerEvents = function (editor) {
	        editor.on('SkinLoaded', function () {
	          var serviceMessage = editor.settings.service_message;
	
	          if (serviceMessage) {
	            open({
	              text: serviceMessage,
	              type: 'warning',
	              timeout: 0,
	              icon: ''
	            });
	          }
	        });
	
	        editor.on('ResizeEditor ResizeWindow', function () {
	          Delay.requestAnimationFrame(reposition);
	        });
	
	        editor.on('remove', function () {
	          Arr.each(notifications, function (notification) {
	            getImplementation().close(notification);
	          });
	        });
	      };
	
	      registerEvents(editor);
	
	      return {
	        /**
	         * Opens a new notification.
	         *
	         * @method open
	         * @param {Object} args Optional name/value settings collection contains things like timeout/color/message etc.
	         */
	        open: open,
	
	        /**
	         * Closes the top most notification.
	         *
	         * @method close
	         */
	        close: close,
	
	        /**
	         * Returns the currently opened notification objects.
	         *
	         * @method getNotifications
	         * @return {Array} Array of the currently opened notifications.
	         */
	        getNotifications: getNotifications
	      };
	    };
	  }
	);
	
	/**
	 * WindowManagerImpl.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.ui.WindowManagerImpl',
	  [
	  ],
	  function () {
	    return function () {
	      var unimplemented = function () {
	        throw new Error('Theme did not provide a WindowManager implementation.');
	      };
	
	      return {
	        open: unimplemented,
	        alert: unimplemented,
	        confirm: unimplemented,
	        close: unimplemented,
	        getParams: unimplemented,
	        setParams: unimplemented
	      };
	    };
	  }
	);
	
	/**
	 * WindowManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles the creation of native windows and dialogs. This class can be extended to provide for example inline dialogs.
	 *
	 * @class tinymce.WindowManager
	 * @example
	 * // Opens a new dialog with the file.htm file and the size 320x240
	 * // It also adds a custom parameter this can be retrieved by using tinyMCEPopup.getWindowArg inside the dialog.
	 * tinymce.activeEditor.windowManager.open({
	 *    url: 'file.htm',
	 *    width: 320,
	 *    height: 240
	 * }, {
	 *    custom_param: 1
	 * });
	 *
	 * // Displays an alert box using the active editors window manager instance
	 * tinymce.activeEditor.windowManager.alert('Hello world!');
	 *
	 * // Displays an confirm box and an alert message will be displayed depending on what you choose in the confirm
	 * });
	 */
	define(
	  'tinymce.core.api.WindowManager',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Option',
	    'tinymce.core.selection.SelectionBookmark',
	    'tinymce.core.ui.WindowManagerImpl'
	  ],
	  function (Arr, Option, SelectionBookmark, WindowManagerImpl) {
	    return function (editor) {
	      var windows = [];
	
	      var getImplementation = function () {
	        var theme = editor.theme;
	        return theme && theme.getWindowManagerImpl ? theme.getWindowManagerImpl() : WindowManagerImpl();
	      };
	
	      var funcBind = function (scope, f) {
	        return function () {
	          return f ? f.apply(scope, arguments) : undefined;
	        };
	      };
	
	      var fireOpenEvent = function (win) {
	        editor.fire('OpenWindow', {
	          win: win
	        });
	      };
	
	      var fireCloseEvent = function (win) {
	        editor.fire('CloseWindow', {
	          win: win
	        });
	      };
	
	      var addWindow = function (win) {
	        windows.push(win);
	        fireOpenEvent(win);
	      };
	
	      var closeWindow = function (win) {
	        Arr.findIndex(windows, function (otherWindow) {
	          return otherWindow === win;
	        }).each(function (index) {
	          // Mutate here since third party might have stored away the window array, consider breaking this api
	          windows.splice(index, 1);
	
	          fireCloseEvent(win);
	
	          // Move focus back to editor when the last window is closed
	          if (windows.length === 0) {
	            editor.focus();
	          }
	        });
	      };
	
	      var getTopWindow = function () {
	        return Option.from(windows[windows.length - 1]);
	      };
	
	      var open = function (args, params) {
	        editor.editorManager.setActive(editor);
	        SelectionBookmark.store(editor);
	
	        var win = getImplementation().open(args, params, closeWindow);
	        addWindow(win);
	        return win;
	      };
	
	      var alert = function (message, callback, scope) {
	        var win = getImplementation().alert(message, funcBind(scope ? scope : this, callback), closeWindow);
	        addWindow(win);
	      };
	
	      var confirm = function (message, callback, scope) {
	        var win = getImplementation().confirm(message, funcBind(scope ? scope : this, callback), closeWindow);
	        addWindow(win);
	      };
	
	      var close = function () {
	        getTopWindow().each(function (win) {
	          getImplementation().close(win);
	          closeWindow(win);
	        });
	      };
	
	      var getParams = function () {
	        return getTopWindow().map(getImplementation().getParams).getOr(null);
	      };
	
	      var setParams = function (params) {
	        getTopWindow().each(function (win) {
	          getImplementation().setParams(win, params);
	        });
	      };
	
	      var getWindows = function () {
	        return windows;
	      };
	
	      editor.on('remove', function () {
	        Arr.each(windows.slice(0), function (win) {
	          getImplementation().close(win);
	        });
	      });
	
	      return {
	        // Used by the legacy3x compat layer and possible third party
	        // TODO: Deprecate this, and possible switch to a immutable window array for getWindows
	        windows: windows,
	
	        /**
	         * Opens a new window.
	         *
	         * @method open
	         * @param {Object} args Optional name/value settings collection contains things like width/height/url etc.
	         * @param {Object} params Options like title, file, width, height etc.
	         * @option {String} title Window title.
	         * @option {String} file URL of the file to open in the window.
	         * @option {Number} width Width in pixels.
	         * @option {Number} height Height in pixels.
	         * @option {Boolean} autoScroll Specifies whether the popup window can have scrollbars if required (i.e. content
	         * larger than the popup size specified).
	         */
	        open: open,
	
	        /**
	         * Creates a alert dialog. Please don't use the blocking behavior of this
	         * native version use the callback method instead then it can be extended.
	         *
	         * @method alert
	         * @param {String} message Text to display in the new alert dialog.
	         * @param {function} callback Callback function to be executed after the user has selected ok.
	         * @param {Object} scope Optional scope to execute the callback in.
	         * @example
	         * // Displays an alert box using the active editors window manager instance
	         * tinymce.activeEditor.windowManager.alert('Hello world!');
	         */
	        alert: alert,
	
	        /**
	         * Creates a confirm dialog. Please don't use the blocking behavior of this
	         * native version use the callback method instead then it can be extended.
	         *
	         * @method confirm
	         * @param {String} message Text to display in the new confirm dialog.
	         * @param {function} callback Callback function to be executed after the user has selected ok or cancel.
	         * @param {Object} scope Optional scope to execute the callback in.
	         * @example
	         * // Displays an confirm box and an alert message will be displayed depending on what you choose in the confirm
	         * tinymce.activeEditor.windowManager.confirm("Do you want to do something", function(s) {
	         *    if (s)
	         *       tinymce.activeEditor.windowManager.alert("Ok");
	         *    else
	         *       tinymce.activeEditor.windowManager.alert("Cancel");
	         * });
	         */
	        confirm: confirm,
	
	        /**
	         * Closes the top most window.
	         *
	         * @method close
	         */
	        close: close,
	
	        /**
	         * Returns the params of the last window open call. This can be used in iframe based
	         * dialog to get params passed from the tinymce plugin.
	         *
	         * @example
	         * var dialogArguments = top.tinymce.activeEditor.windowManager.getParams();
	         *
	         * @method getParams
	         * @return {Object} Name/value object with parameters passed from windowManager.open call.
	         */
	        getParams: getParams,
	
	        /**
	         * Sets the params of the last opened window.
	         *
	         * @method setParams
	         * @param {Object} params Params object to set for the last opened window.
	         */
	        setParams: setParams,
	
	        /**
	         * Returns the currently opened window objects.
	         *
	         * @method getWindows
	         * @return {Array} Array of the currently opened windows.
	         */
	        getWindows: getWindows
	      };
	    };
	  }
	);
	
	/**
	 * ErrorReporter.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Various error reporting helper functions.
	 *
	 * @class tinymce.ErrorReporter
	 * @private
	 */
	define(
	  'tinymce.core.ErrorReporter',
	  [
	    'global!window',
	    'tinymce.core.AddOnManager'
	  ],
	  function (window, AddOnManager) {
	    var PluginManager = AddOnManager.PluginManager;
	
	    var resolvePluginName = function (targetUrl, suffix) {
	      for (var name in PluginManager.urls) {
	        var matchUrl = PluginManager.urls[name] + '/plugin' + suffix + '.js';
	        if (matchUrl === targetUrl) {
	          return name;
	        }
	      }
	
	      return null;
	    };
	
	    var pluginUrlToMessage = function (editor, url) {
	      var plugin = resolvePluginName(url, editor.suffix);
	      return plugin ?
	        'Failed to load plugin: ' + plugin + ' from url ' + url :
	        'Failed to load plugin url: ' + url;
	    };
	
	    var displayNotification = function (editor, message) {
	      editor.notificationManager.open({
	        type: 'error',
	        text: message
	      });
	    };
	
	    var displayError = function (editor, message) {
	      if (editor._skinLoaded) {
	        displayNotification(editor, message);
	      } else {
	        editor.on('SkinLoaded', function () {
	          displayNotification(editor, message);
	        });
	      }
	    };
	
	    var uploadError = function (editor, message) {
	      displayError(editor, 'Failed to upload image: ' + message);
	    };
	
	    var pluginLoadError = function (editor, url) {
	      displayError(editor, pluginUrlToMessage(editor, url));
	    };
	
	    var initError = function (message) {
	      var console = window.console;
	      if (console && !window.test) { // Skip test env
	        if (console.error) {
	          console.error.apply(console, arguments);
	        } else {
	          console.log.apply(console, arguments);
	        }
	      }
	    };
	
	    return {
	      pluginLoadError: pluginLoadError,
	      uploadError: uploadError,
	      displayError: displayError,
	      initError: initError
	    };
	  }
	);
	/**
	 * PluginManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.PluginManager',
	  [
	    'tinymce.core.AddOnManager'
	  ],
	  function (AddOnManager) {
	    return AddOnManager.PluginManager;
	  }
	);
	
	/**
	 * ThemeManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.ThemeManager',
	  [
	    'tinymce.core.AddOnManager'
	  ],
	  function (AddOnManager) {
	    return AddOnManager.ThemeManager;
	  }
	);
	
	define(
	  'ephox.sand.api.XMLHttpRequest',
	
	  [
	    'ephox.sand.util.Global'
	  ],
	
	  function (Global) {
	    /*
	     * IE8 and above per
	     * https://developer.mozilla.org/en/docs/XMLHttpRequest
	     */
	    return function () {
	      var f = Global.getOrDie('XMLHttpRequest');
	      return new f();
	    };
	  }
	);
	/**
	 * Uploader.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Upload blobs or blob infos to the specified URL or handler.
	 *
	 * @private
	 * @class tinymce.file.Uploader
	 * @example
	 * var uploader = new Uploader({
	 *     url: '/upload.php',
	 *     basePath: '/base/path',
	 *     credentials: true,
	 *     handler: function(data, success, failure) {
	 *         ...
	 *     }
	 * });
	 *
	 * uploader.upload(blobInfos).then(function(result) {
	 *     ...
	 * });
	 */
	define(
	  'tinymce.core.file.Uploader',
	  [
	    'ephox.sand.api.XMLHttpRequest',
	    'global!window',
	    'tinymce.core.util.Fun',
	    'tinymce.core.util.Promise',
	    'tinymce.core.util.Tools'
	  ],
	  function (XMLHttpRequest, window, Fun, Promise, Tools) {
	    return function (uploadStatus, settings) {
	      var pendingPromises = {};
	
	      var pathJoin = function (path1, path2) {
	        if (path1) {
	          return path1.replace(/\/$/, '') + '/' + path2.replace(/^\//, '');
	        }
	
	        return path2;
	      };
	
	      var defaultHandler = function (blobInfo, success, failure, progress) {
	        var xhr, formData;
	
	        xhr = new XMLHttpRequest();
	        xhr.open('POST', settings.url);
	        xhr.withCredentials = settings.credentials;
	
	        xhr.upload.onprogress = function (e) {
	          progress(e.loaded / e.total * 100);
	        };
	
	        xhr.onerror = function () {
	          failure("Image upload failed due to a XHR Transport error. Code: " + xhr.status);
	        };
	
	        xhr.onload = function () {
	          var json;
	
	          if (xhr.status < 200 || xhr.status >= 300) {
	            failure("HTTP Error: " + xhr.status);
	            return;
	          }
	
	          json = JSON.parse(xhr.responseText);
	
	          if (!json || typeof json.location != "string") {
	            failure("Invalid JSON: " + xhr.responseText);
	            return;
	          }
	
	          success(pathJoin(settings.basePath, json.location));
	        };
	
	        formData = new window.FormData(); // TODO: Stick this in sand
	        formData.append('file', blobInfo.blob(), blobInfo.filename());
	
	        xhr.send(formData);
	      };
	
	      var noUpload = function () {
	        return new Promise(function (resolve) {
	          resolve([]);
	        });
	      };
	
	      var handlerSuccess = function (blobInfo, url) {
	        return {
	          url: url,
	          blobInfo: blobInfo,
	          status: true
	        };
	      };
	
	      var handlerFailure = function (blobInfo, error) {
	        return {
	          url: '',
	          blobInfo: blobInfo,
	          status: false,
	          error: error
	        };
	      };
	
	      var resolvePending = function (blobUri, result) {
	        Tools.each(pendingPromises[blobUri], function (resolve) {
	          resolve(result);
	        });
	
	        delete pendingPromises[blobUri];
	      };
	
	      var uploadBlobInfo = function (blobInfo, handler, openNotification) {
	        uploadStatus.markPending(blobInfo.blobUri());
	
	        return new Promise(function (resolve) {
	          var notification, progress;
	
	          var noop = function () {
	          };
	
	          try {
	            var closeNotification = function () {
	              if (notification) {
	                notification.close();
	                progress = noop; // Once it's closed it's closed
	              }
	            };
	
	            var success = function (url) {
	              closeNotification();
	              uploadStatus.markUploaded(blobInfo.blobUri(), url);
	              resolvePending(blobInfo.blobUri(), handlerSuccess(blobInfo, url));
	              resolve(handlerSuccess(blobInfo, url));
	            };
	
	            var failure = function (error) {
	              closeNotification();
	              uploadStatus.removeFailed(blobInfo.blobUri());
	              resolvePending(blobInfo.blobUri(), handlerFailure(blobInfo, error));
	              resolve(handlerFailure(blobInfo, error));
	            };
	
	            progress = function (percent) {
	              if (percent < 0 || percent > 100) {
	                return;
	              }
	
	              if (!notification) {
	                notification = openNotification();
	              }
	
	              notification.progressBar.value(percent);
	            };
	
	            handler(blobInfo, success, failure, progress);
	          } catch (ex) {
	            resolve(handlerFailure(blobInfo, ex.message));
	          }
	        });
	      };
	
	      var isDefaultHandler = function (handler) {
	        return handler === defaultHandler;
	      };
	
	      var pendingUploadBlobInfo = function (blobInfo) {
	        var blobUri = blobInfo.blobUri();
	
	        return new Promise(function (resolve) {
	          pendingPromises[blobUri] = pendingPromises[blobUri] || [];
	          pendingPromises[blobUri].push(resolve);
	        });
	      };
	
	      var uploadBlobs = function (blobInfos, openNotification) {
	        blobInfos = Tools.grep(blobInfos, function (blobInfo) {
	          return !uploadStatus.isUploaded(blobInfo.blobUri());
	        });
	
	        return Promise.all(Tools.map(blobInfos, function (blobInfo) {
	          return uploadStatus.isPending(blobInfo.blobUri()) ?
	            pendingUploadBlobInfo(blobInfo) : uploadBlobInfo(blobInfo, settings.handler, openNotification);
	        }));
	      };
	
	      var upload = function (blobInfos, openNotification) {
	        return (!settings.url && isDefaultHandler(settings.handler)) ? noUpload() : uploadBlobs(blobInfos, openNotification);
	      };
	
	      settings = Tools.extend({
	        credentials: false,
	        // We are adding a notify argument to this (at the moment, until it doesn't work)
	        handler: defaultHandler
	      }, settings);
	
	      return {
	        upload: upload
	      };
	    };
	  }
	);
	define(
	  'ephox.sand.api.Blob',
	
	  [
	    'ephox.sand.util.Global'
	  ],
	
	  function (Global) {
	    /*
	     * IE10 and above per
	     * https://developer.mozilla.org/en-US/docs/Web/API/Blob
	     */
	    return function (parts, properties) {
	      var f = Global.getOrDie('Blob');
	      return new f(parts, properties);
	    };
	  }
	);
	define(
	  'ephox.sand.api.FileReader',
	
	  [
	    'ephox.sand.util.Global'
	  ],
	
	  function (Global) {
	    /*
	     * IE10 and above per
	     * https://developer.mozilla.org/en-US/docs/Web/API/FileReader
	     */
	    return function () {
	      var f = Global.getOrDie('FileReader');
	      return new f();
	    };
	  }
	);
	define(
	  'ephox.sand.api.Uint8Array',
	
	  [
	    'ephox.sand.util.Global'
	  ],
	
	  function (Global) {
	    /*
	     * https://developer.mozilla.org/en-US/docs/Web/API/Uint8Array
	     *
	     * IE10 and above per
	     * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Typed_arrays
	     */
	    return function (arr) {
	      var f = Global.getOrDie('Uint8Array');
	      return new f(arr);
	    };
	  }
	);
	define(
	  'ephox.sand.api.Window',
	
	  [
	    'ephox.sand.util.Global'
	  ],
	
	  function (Global) {
	    /******************************************************************************************
	     * BIG BIG WARNING: Don't put anything other than top-level window functions in here.
	     *
	     * Objects that are technically available as window.X should be in their own module X (e.g. Blob, FileReader, URL).
	     ******************************************************************************************
	     */
	
	    /*
	     * IE10 and above per
	     * https://developer.mozilla.org/en/docs/Web/API/window.requestAnimationFrame
	     */
	    var requestAnimationFrame = function (callback) {
	      var f = Global.getOrDie('requestAnimationFrame');
	      f(callback);
	    };
	
	    /*
	     * IE10 and above per
	     * https://developer.mozilla.org/en-US/docs/Web/API/WindowBase64.atob
	     */
	    var atob = function (base64) {
	      var f = Global.getOrDie('atob');
	      return f(base64);
	    };
	
	    return {
	      atob: atob,
	      requestAnimationFrame: requestAnimationFrame
	    };
	  }
	);
	/**
	 * Conversions.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Converts blob/uris back and forth.
	 *
	 * @private
	 * @class tinymce.file.Conversions
	 */
	define(
	  'tinymce.core.file.Conversions',
	  [
	    'ephox.sand.api.Blob',
	    'ephox.sand.api.FileReader',
	    'ephox.sand.api.Uint8Array',
	    'ephox.sand.api.Window',
	    'ephox.sand.api.XMLHttpRequest',
	    'tinymce.core.util.Promise'
	  ],
	  function (Blob, FileReader, Uint8Array, Window, XMLHttpRequest, Promise) {
	    var blobUriToBlob = function (url) {
	      return new Promise(function (resolve, reject) {
	
	        var rejectWithError = function () {
	          reject("Cannot convert " + url + " to Blob. Resource might not exist or is inaccessible.");
	        };
	
	        try {
	          var xhr = new XMLHttpRequest();
	
	          xhr.open('GET', url, true);
	          xhr.responseType = 'blob';
	
	          xhr.onload = function () {
	            if (this.status == 200) {
	              resolve(this.response);
	            } else {
	              // IE11 makes it into onload but responds with status 500
	              rejectWithError();
	            }
	          };
	
	          // Chrome fires an error event instead of the exception
	          // Also there seems to be no way to intercept the message that is logged to the console
	          xhr.onerror = rejectWithError;
	
	          xhr.send();
	        } catch (ex) {
	          rejectWithError();
	        }
	      });
	    };
	
	    var parseDataUri = function (uri) {
	      var type, matches;
	
	      uri = decodeURIComponent(uri).split(',');
	
	      matches = /data:([^;]+)/.exec(uri[0]);
	      if (matches) {
	        type = matches[1];
	      }
	
	      return {
	        type: type,
	        data: uri[1]
	      };
	    };
	
	    var dataUriToBlob = function (uri) {
	      return new Promise(function (resolve) {
	        var str, arr, i;
	
	        uri = parseDataUri(uri);
	
	        // Might throw error if data isn't proper base64
	        try {
	          str = Window.atob(uri.data);
	        } catch (e) {
	          resolve(new Blob([]));
	          return;
	        }
	
	        arr = new Uint8Array(str.length);
	
	        for (i = 0; i < arr.length; i++) {
	          arr[i] = str.charCodeAt(i);
	        }
	
	        resolve(new Blob([arr], { type: uri.type }));
	      });
	    };
	
	    var uriToBlob = function (url) {
	      if (url.indexOf('blob:') === 0) {
	        return blobUriToBlob(url);
	      }
	
	      if (url.indexOf('data:') === 0) {
	        return dataUriToBlob(url);
	      }
	
	      return null;
	    };
	
	    var blobToDataUri = function (blob) {
	      return new Promise(function (resolve) {
	        var reader = new FileReader();
	
	        reader.onloadend = function () {
	          resolve(reader.result);
	        };
	
	        reader.readAsDataURL(blob);
	      });
	    };
	
	    return {
	      uriToBlob: uriToBlob,
	      blobToDataUri: blobToDataUri,
	      parseDataUri: parseDataUri
	    };
	  }
	);
	/**
	 * ImageScanner.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Finds images with data uris or blob uris. If data uris are found it will convert them into blob uris.
	 *
	 * @private
	 * @class tinymce.file.ImageScanner
	 */
	define(
	  'tinymce.core.file.ImageScanner',
	  [
	    "tinymce.core.util.Promise",
	    "tinymce.core.util.Arr",
	    "tinymce.core.util.Fun",
	    "tinymce.core.file.Conversions",
	    "tinymce.core.Env"
	  ],
	  function (Promise, Arr, Fun, Conversions, Env) {
	    var count = 0;
	
	    var uniqueId = function (prefix) {
	      return (prefix || 'blobid') + (count++);
	    };
	
	    var imageToBlobInfo = function (blobCache, img, resolve, reject) {
	      var base64, blobInfo;
	
	      if (img.src.indexOf('blob:') === 0) {
	        blobInfo = blobCache.getByUri(img.src);
	
	        if (blobInfo) {
	          resolve({
	            image: img,
	            blobInfo: blobInfo
	          });
	        } else {
	          Conversions.uriToBlob(img.src).then(function (blob) {
	            Conversions.blobToDataUri(blob).then(function (dataUri) {
	              base64 = Conversions.parseDataUri(dataUri).data;
	              blobInfo = blobCache.create(uniqueId(), blob, base64);
	              blobCache.add(blobInfo);
	
	              resolve({
	                image: img,
	                blobInfo: blobInfo
	              });
	            });
	          }, function (err) {
	            reject(err);
	          });
	        }
	
	        return;
	      }
	
	      base64 = Conversions.parseDataUri(img.src).data;
	      blobInfo = blobCache.findFirst(function (cachedBlobInfo) {
	        return cachedBlobInfo.base64() === base64;
	      });
	
	      if (blobInfo) {
	        resolve({
	          image: img,
	          blobInfo: blobInfo
	        });
	      } else {
	        Conversions.uriToBlob(img.src).then(function (blob) {
	          blobInfo = blobCache.create(uniqueId(), blob, base64);
	          blobCache.add(blobInfo);
	
	          resolve({
	            image: img,
	            blobInfo: blobInfo
	          });
	        }, function (err) {
	          reject(err);
	        });
	      }
	    };
	
	    var getAllImages = function (elm) {
	      return elm ? elm.getElementsByTagName('img') : [];
	    };
	
	    return function (uploadStatus, blobCache) {
	      var cachedPromises = {};
	
	      var findAll = function (elm, predicate) {
	        var images, promises;
	
	        if (!predicate) {
	          predicate = Fun.constant(true);
	        }
	
	        images = Arr.filter(getAllImages(elm), function (img) {
	          var src = img.src;
	
	          if (!Env.fileApi) {
	            return false;
	          }
	
	          if (img.hasAttribute('data-mce-bogus')) {
	            return false;
	          }
	
	          if (img.hasAttribute('data-mce-placeholder')) {
	            return false;
	          }
	
	          if (!src || src == Env.transparentSrc) {
	            return false;
	          }
	
	          if (src.indexOf('blob:') === 0) {
	            return !uploadStatus.isUploaded(src);
	          }
	
	          if (src.indexOf('data:') === 0) {
	            return predicate(img);
	          }
	
	          return false;
	        });
	
	        promises = Arr.map(images, function (img) {
	          var newPromise;
	
	          if (cachedPromises[img.src]) {
	            // Since the cached promise will return the cached image
	            // We need to wrap it and resolve with the actual image
	            return new Promise(function (resolve) {
	              cachedPromises[img.src].then(function (imageInfo) {
	                if (typeof imageInfo === 'string') { // error apparently
	                  return imageInfo;
	                }
	                resolve({
	                  image: img,
	                  blobInfo: imageInfo.blobInfo
	                });
	              });
	            });
	          }
	
	          newPromise = new Promise(function (resolve, reject) {
	            imageToBlobInfo(blobCache, img, resolve, reject);
	          }).then(function (result) {
	            delete cachedPromises[result.image.src];
	            return result;
	          })['catch'](function (error) {
	            delete cachedPromises[img.src];
	            return error;
	          });
	
	          cachedPromises[img.src] = newPromise;
	
	          return newPromise;
	        });
	
	        return Promise.all(promises);
	      };
	
	      return {
	        findAll: findAll
	      };
	    };
	  }
	);
	/**
	 * Uuid.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Generates unique ids.
	 *
	 * @class tinymce.util.Uuid
	 * @private
	 */
	define(
	  'tinymce.core.util.Uuid',
	  [
	  ],
	  function () {
	    var count = 0;
	
	    var seed = function () {
	      var rnd = function () {
	        return Math.round(Math.random() * 0xFFFFFFFF).toString(36);
	      };
	
	      var now = new Date().getTime();
	      return 's' + now.toString(36) + rnd() + rnd() + rnd();
	    };
	
	    var uuid = function (prefix) {
	      return prefix + (count++) + seed();
	    };
	
	    return {
	      uuid: uuid
	    };
	  }
	);
	
	/**
	 * BlobCache.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Hold blob info objects where a blob has extra internal information.
	 *
	 * @private
	 * @class tinymce.file.BlobCache
	 */
	define(
	  'tinymce.core.file.BlobCache',
	  [
	    'ephox.sand.api.URL',
	    'tinymce.core.util.Arr',
	    'tinymce.core.util.Fun',
	    'tinymce.core.util.Uuid'
	  ],
	  function (URL, Arr, Fun, Uuid) {
	    return function () {
	      var cache = [], constant = Fun.constant;
	
	      var mimeToExt = function (mime) {
	        var mimes = {
	          'image/jpeg': 'jpg',
	          'image/jpg': 'jpg',
	          'image/gif': 'gif',
	          'image/png': 'png'
	        };
	
	        return mimes[mime.toLowerCase()] || 'dat';
	      };
	
	      var create = function (o, blob, base64, filename) {
	        return typeof o === 'object' ? toBlobInfo(o) : toBlobInfo({
	          id: o,
	          name: filename,
	          blob: blob,
	          base64: base64
	        });
	      };
	
	      var toBlobInfo = function (o) {
	        var id, name;
	
	        if (!o.blob || !o.base64) {
	          throw "blob and base64 representations of the image are required for BlobInfo to be created";
	        }
	
	        id = o.id || Uuid.uuid('blobid');
	        name = o.name || id;
	
	        return {
	          id: constant(id),
	          name: constant(name),
	          filename: constant(name + '.' + mimeToExt(o.blob.type)),
	          blob: constant(o.blob),
	          base64: constant(o.base64),
	          blobUri: constant(o.blobUri || URL.createObjectURL(o.blob)),
	          uri: constant(o.uri)
	        };
	      };
	
	      var add = function (blobInfo) {
	        if (!get(blobInfo.id())) {
	          cache.push(blobInfo);
	        }
	      };
	
	      var get = function (id) {
	        return findFirst(function (cachedBlobInfo) {
	          return cachedBlobInfo.id() === id;
	        });
	      };
	
	      var findFirst = function (predicate) {
	        return Arr.filter(cache, predicate)[0];
	      };
	
	      var getByUri = function (blobUri) {
	        return findFirst(function (blobInfo) {
	          return blobInfo.blobUri() == blobUri;
	        });
	      };
	
	      var removeByUri = function (blobUri) {
	        cache = Arr.filter(cache, function (blobInfo) {
	          if (blobInfo.blobUri() === blobUri) {
	            URL.revokeObjectURL(blobInfo.blobUri());
	            return false;
	          }
	
	          return true;
	        });
	      };
	
	      var destroy = function () {
	        Arr.each(cache, function (cachedBlobInfo) {
	          URL.revokeObjectURL(cachedBlobInfo.blobUri());
	        });
	
	        cache = [];
	      };
	
	      return {
	        create: create,
	        add: add,
	        get: get,
	        getByUri: getByUri,
	        findFirst: findFirst,
	        removeByUri: removeByUri,
	        destroy: destroy
	      };
	    };
	  }
	);
	/**
	 * UploadStatus.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Holds the current status of a blob uri, if it's pending or uploaded and what the result urls was.
	 *
	 * @private
	 * @class tinymce.file.UploadStatus
	 */
	define(
	  'tinymce.core.file.UploadStatus',
	  [
	  ],
	  function () {
	    return function () {
	      var PENDING = 1, UPLOADED = 2;
	      var blobUriStatuses = {};
	
	      var createStatus = function (status, resultUri) {
	        return {
	          status: status,
	          resultUri: resultUri
	        };
	      };
	
	      var hasBlobUri = function (blobUri) {
	        return blobUri in blobUriStatuses;
	      };
	
	      var getResultUri = function (blobUri) {
	        var result = blobUriStatuses[blobUri];
	
	        return result ? result.resultUri : null;
	      };
	
	      var isPending = function (blobUri) {
	        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === PENDING : false;
	      };
	
	      var isUploaded = function (blobUri) {
	        return hasBlobUri(blobUri) ? blobUriStatuses[blobUri].status === UPLOADED : false;
	      };
	
	      var markPending = function (blobUri) {
	        blobUriStatuses[blobUri] = createStatus(PENDING, null);
	      };
	
	      var markUploaded = function (blobUri, resultUri) {
	        blobUriStatuses[blobUri] = createStatus(UPLOADED, resultUri);
	      };
	
	      var removeFailed = function (blobUri) {
	        delete blobUriStatuses[blobUri];
	      };
	
	      var destroy = function () {
	        blobUriStatuses = {};
	      };
	
	      return {
	        hasBlobUri: hasBlobUri,
	        getResultUri: getResultUri,
	        isPending: isPending,
	        isUploaded: isUploaded,
	        markPending: markPending,
	        markUploaded: markUploaded,
	        removeFailed: removeFailed,
	        destroy: destroy
	      };
	    };
	  }
	);
	/**
	 * EditorUpload.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Handles image uploads, updates undo stack and patches over various internal functions.
	 *
	 * @private
	 * @class tinymce.EditorUpload
	 */
	define(
	  'tinymce.core.EditorUpload',
	  [
	    "tinymce.core.util.Arr",
	    "tinymce.core.file.Uploader",
	    "tinymce.core.file.ImageScanner",
	    "tinymce.core.file.BlobCache",
	    "tinymce.core.file.UploadStatus",
	    "tinymce.core.ErrorReporter"
	  ],
	  function (Arr, Uploader, ImageScanner, BlobCache, UploadStatus, ErrorReporter) {
	    return function (editor) {
	      var blobCache = new BlobCache(), uploader, imageScanner, settings = editor.settings;
	      var uploadStatus = new UploadStatus();
	
	      var aliveGuard = function (callback) {
	        return function (result) {
	          if (editor.selection) {
	            return callback(result);
	          }
	
	          return [];
	        };
	      };
	
	      var cacheInvalidator = function () {
	        return '?' + (new Date()).getTime();
	      };
	
	      // Replaces strings without regexps to avoid FF regexp to big issue
	      var replaceString = function (content, search, replace) {
	        var index = 0;
	
	        do {
	          index = content.indexOf(search, index);
	
	          if (index !== -1) {
	            content = content.substring(0, index) + replace + content.substr(index + search.length);
	            index += replace.length - search.length + 1;
	          }
	        } while (index !== -1);
	
	        return content;
	      };
	
	      var replaceImageUrl = function (content, targetUrl, replacementUrl) {
	        content = replaceString(content, 'src="' + targetUrl + '"', 'src="' + replacementUrl + '"');
	        content = replaceString(content, 'data-mce-src="' + targetUrl + '"', 'data-mce-src="' + replacementUrl + '"');
	
	        return content;
	      };
	
	      var replaceUrlInUndoStack = function (targetUrl, replacementUrl) {
	        Arr.each(editor.undoManager.data, function (level) {
	          if (level.type === 'fragmented') {
	            level.fragments = Arr.map(level.fragments, function (fragment) {
	              return replaceImageUrl(fragment, targetUrl, replacementUrl);
	            });
	          } else {
	            level.content = replaceImageUrl(level.content, targetUrl, replacementUrl);
	          }
	        });
	      };
	
	      var openNotification = function () {
	        return editor.notificationManager.open({
	          text: editor.translate('Image uploading...'),
	          type: 'info',
	          timeout: -1,
	          progressBar: true
	        });
	      };
	
	      var replaceImageUri = function (image, resultUri) {
	        blobCache.removeByUri(image.src);
	        replaceUrlInUndoStack(image.src, resultUri);
	
	        editor.$(image).attr({
	          src: settings.images_reuse_filename ? resultUri + cacheInvalidator() : resultUri,
	          'data-mce-src': editor.convertURL(resultUri, 'src')
	        });
	      };
	
	      var uploadImages = function (callback) {
	        if (!uploader) {
	          uploader = new Uploader(uploadStatus, {
	            url: settings.images_upload_url,
	            basePath: settings.images_upload_base_path,
	            credentials: settings.images_upload_credentials,
	            handler: settings.images_upload_handler
	          });
	        }
	
	        return scanForImages().then(aliveGuard(function (imageInfos) {
	          var blobInfos;
	
	          blobInfos = Arr.map(imageInfos, function (imageInfo) {
	            return imageInfo.blobInfo;
	          });
	
	          return uploader.upload(blobInfos, openNotification).then(aliveGuard(function (result) {
	            var filteredResult = Arr.map(result, function (uploadInfo, index) {
	              var image = imageInfos[index].image;
	
	              if (uploadInfo.status && editor.settings.images_replace_blob_uris !== false) {
	                replaceImageUri(image, uploadInfo.url);
	              } else if (uploadInfo.error) {
	                ErrorReporter.uploadError(editor, uploadInfo.error);
	              }
	
	              return {
	                element: image,
	                status: uploadInfo.status
	              };
	            });
	
	            if (callback) {
	              callback(filteredResult);
	            }
	
	            return filteredResult;
	          }));
	        }));
	      };
	
	      var uploadImagesAuto = function (callback) {
	        if (settings.automatic_uploads !== false) {
	          return uploadImages(callback);
	        }
	      };
	
	      var isValidDataUriImage = function (imgElm) {
	        return settings.images_dataimg_filter ? settings.images_dataimg_filter(imgElm) : true;
	      };
	
	      var scanForImages = function () {
	        if (!imageScanner) {
	          imageScanner = new ImageScanner(uploadStatus, blobCache);
	        }
	
	        return imageScanner.findAll(editor.getBody(), isValidDataUriImage).then(aliveGuard(function (result) {
	          result = Arr.filter(result, function (resultItem) {
	            // ImageScanner internally converts images that it finds, but it may fail to do so if image source is inaccessible.
	            // In such case resultItem will contain appropriate text error message, instead of image data.
	            if (typeof resultItem === 'string') {
	              ErrorReporter.displayError(editor, resultItem);
	              return false;
	            }
	            return true;
	          });
	
	          Arr.each(result, function (resultItem) {
	            replaceUrlInUndoStack(resultItem.image.src, resultItem.blobInfo.blobUri());
	            resultItem.image.src = resultItem.blobInfo.blobUri();
	            resultItem.image.removeAttribute('data-mce-src');
	          });
	
	          return result;
	        }));
	      };
	
	      var destroy = function () {
	        blobCache.destroy();
	        uploadStatus.destroy();
	        imageScanner = uploader = null;
	      };
	
	      var replaceBlobUris = function (content) {
	        return content.replace(/src="(blob:[^"]+)"/g, function (match, blobUri) {
	          var resultUri = uploadStatus.getResultUri(blobUri);
	
	          if (resultUri) {
	            return 'src="' + resultUri + '"';
	          }
	
	          var blobInfo = blobCache.getByUri(blobUri);
	
	          if (!blobInfo) {
	            blobInfo = Arr.reduce(editor.editorManager.get(), function (result, editor) {
	              return result || editor.editorUpload && editor.editorUpload.blobCache.getByUri(blobUri);
	            }, null);
	          }
	
	          if (blobInfo) {
	            return 'src="data:' + blobInfo.blob().type + ';base64,' + blobInfo.base64() + '"';
	          }
	
	          return match;
	        });
	      };
	
	      editor.on('setContent', function () {
	        if (editor.settings.automatic_uploads !== false) {
	          uploadImagesAuto();
	        } else {
	          scanForImages();
	        }
	      });
	
	      editor.on('RawSaveContent', function (e) {
	        e.content = replaceBlobUris(e.content);
	      });
	
	      editor.on('getContent', function (e) {
	        if (e.source_view || e.format == 'raw') {
	          return;
	        }
	
	        e.content = replaceBlobUris(e.content);
	      });
	
	      editor.on('PostRender', function () {
	        editor.parser.addNodeFilter('img', function (images) {
	          Arr.each(images, function (img) {
	            var src = img.attr('src');
	
	            if (blobCache.getByUri(src)) {
	              return;
	            }
	
	            var resultUri = uploadStatus.getResultUri(src);
	            if (resultUri) {
	              img.attr('src', resultUri);
	            }
	          });
	        });
	      });
	
	      return {
	        blobCache: blobCache,
	        uploadImages: uploadImages,
	        uploadImagesAuto: uploadImagesAuto,
	        scanForImages: scanForImages,
	        destroy: destroy
	      };
	    };
	  }
	);
	/**
	 * ForceBlocks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Makes sure that everything gets wrapped in paragraphs.
	 *
	 * @private
	 * @class tinymce.ForceBlocks
	 */
	define(
	  'tinymce.core.ForceBlocks',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.dom.Bookmarks',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.Parents',
	    'tinymce.core.focus.EditorFocus'
	  ],
	  function (Arr, Fun, Element, Bookmarks, NodeType, Parents, EditorFocus) {
	    var isBlockElement = function (blockElements, node) {
	      return blockElements.hasOwnProperty(node.nodeName);
	    };
	
	    var isValidTarget = function (blockElements, node) {
	      if (NodeType.isText(node)) {
	        return true;
	      } else if (NodeType.isElement(node)) {
	        return !isBlockElement(blockElements, node) && !Bookmarks.isBookmarkNode(node);
	      } else {
	        return false;
	      }
	    };
	
	    var hasBlockParent = function (blockElements, root, node) {
	      return Arr.exists(Parents.parents(Element.fromDom(node), Element.fromDom(root)), function (elm) {
	        return isBlockElement(blockElements, elm.dom());
	      });
	    };
	
	    var addRootBlocks = function (editor) {
	      var settings = editor.settings, dom = editor.dom, selection = editor.selection;
	      var schema = editor.schema, blockElements = schema.getBlockElements();
	      var node = selection.getStart(), rootNode = editor.getBody(), rng;
	      var startContainer, startOffset, endContainer, endOffset, rootBlockNode;
	      var tempNode, wrapped, restoreSelection;
	      var rootNodeName, forcedRootBlock;
	
	      forcedRootBlock = settings.forced_root_block;
	
	      if (!node || !NodeType.isElement(node) || !forcedRootBlock) {
	        return;
	      }
	
	      rootNodeName = rootNode.nodeName.toLowerCase();
	      if (!schema.isValidChild(rootNodeName, forcedRootBlock.toLowerCase()) || hasBlockParent(blockElements, rootNode, node)) {
	        return;
	      }
	
	      // Get current selection
	      rng = selection.getRng();
	      startContainer = rng.startContainer;
	      startOffset = rng.startOffset;
	      endContainer = rng.endContainer;
	      endOffset = rng.endOffset;
	      restoreSelection = EditorFocus.hasFocus(editor);
	
	      // Wrap non block elements and text nodes
	      node = rootNode.firstChild;
	      while (node) {
	        if (isValidTarget(blockElements, node)) {
	          // Remove empty text nodes
	          if (NodeType.isText(node) && node.nodeValue.length === 0) {
	            tempNode = node;
	            node = node.nextSibling;
	            dom.remove(tempNode);
	            continue;
	          }
	
	          if (!rootBlockNode) {
	            rootBlockNode = dom.create(forcedRootBlock, editor.settings.forced_root_block_attrs);
	            node.parentNode.insertBefore(rootBlockNode, node);
	            wrapped = true;
	          }
	
	          tempNode = node;
	          node = node.nextSibling;
	          rootBlockNode.appendChild(tempNode);
	        } else {
	          rootBlockNode = null;
	          node = node.nextSibling;
	        }
	      }
	
	      if (wrapped && restoreSelection) {
	        rng.setStart(startContainer, startOffset);
	        rng.setEnd(endContainer, endOffset);
	        selection.setRng(rng);
	        editor.nodeChanged();
	      }
	    };
	
	    var setup = function (editor) {
	      if (editor.settings.forced_root_block) {
	        editor.on('NodeChange', Fun.curry(addRootBlocks, editor));
	      }
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	/**
	 * NodeChange.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles the nodechange event dispatching both manual and through selection change events.
	 *
	 * @class tinymce.NodeChange
	 * @private
	 */
	define(
	  'tinymce.core.NodeChange',
	  [
	    'tinymce.core.Env',
	    'tinymce.core.selection.RangeCompare',
	    'tinymce.core.util.Delay'
	  ],
	  function (Env, RangeCompare, Delay) {
	    return function (editor) {
	      var lastRng, lastPath = [];
	
	      /**
	       * Returns true/false if the current element path has been changed or not.
	       *
	       * @private
	       * @return {Boolean} True if the element path is the same false if it's not.
	       */
	      var isSameElementPath = function (startElm) {
	        var i, currentPath;
	
	        currentPath = editor.$(startElm).parentsUntil(editor.getBody()).add(startElm);
	        if (currentPath.length === lastPath.length) {
	          for (i = currentPath.length; i >= 0; i--) {
	            if (currentPath[i] !== lastPath[i]) {
	              break;
	            }
	          }
	
	          if (i === -1) {
	            lastPath = currentPath;
	            return true;
	          }
	        }
	
	        lastPath = currentPath;
	
	        return false;
	      };
	
	      // Gecko doesn't support the "selectionchange" event
	      if (!('onselectionchange' in editor.getDoc())) {
	        editor.on('NodeChange Click MouseUp KeyUp Focus', function (e) {
	          var nativeRng, fakeRng;
	
	          // Since DOM Ranges mutate on modification
	          // of the DOM we need to clone it's contents
	          nativeRng = editor.selection.getRng();
	          fakeRng = {
	            startContainer: nativeRng.startContainer,
	            startOffset: nativeRng.startOffset,
	            endContainer: nativeRng.endContainer,
	            endOffset: nativeRng.endOffset
	          };
	
	          // Always treat nodechange as a selectionchange since applying
	          // formatting to the current range wouldn't update the range but it's parent
	          if (e.type == 'nodechange' || !RangeCompare.isEq(fakeRng, lastRng)) {
	            editor.fire('SelectionChange');
	          }
	
	          lastRng = fakeRng;
	        });
	      }
	
	      // IE has a bug where it fires a selectionchange on right click that has a range at the start of the body
	      // When the contextmenu event fires the selection is located at the right location
	      editor.on('contextmenu', function () {
	        editor.fire('SelectionChange');
	      });
	
	      // Selection change is delayed ~200ms on IE when you click inside the current range
	      editor.on('SelectionChange', function () {
	        var startElm = editor.selection.getStart(true);
	
	        // When focusout from after cef element to other input element the startelm can be undefined.
	        // IE 8 will fire a selectionchange event with an incorrect selection
	        // when focusing out of table cells. Click inside cell -> toolbar = Invalid SelectionChange event
	        if (!startElm || (!Env.range && editor.selection.isCollapsed())) {
	          return;
	        }
	
	        if (!isSameElementPath(startElm) && editor.dom.isChildOf(startElm, editor.getBody())) {
	          editor.nodeChanged({ selectionChange: true });
	        }
	      });
	
	      // Fire an extra nodeChange on mouseup for compatibility reasons
	      editor.on('MouseUp', function (e) {
	        if (!e.isDefaultPrevented()) {
	          // Delay nodeChanged call for WebKit edge case issue where the range
	          // isn't updated until after you click outside a selected image
	          if (editor.selection.getNode().nodeName == 'IMG') {
	            Delay.setEditorTimeout(editor, function () {
	              editor.nodeChanged();
	            });
	          } else {
	            editor.nodeChanged();
	          }
	        }
	      });
	
	      /**
	       * Dispatches out a onNodeChange event to all observers. This method should be called when you
	       * need to update the UI states or element path etc.
	       *
	       * @method nodeChanged
	       * @param {Object} args Optional args to pass to NodeChange event handlers.
	       */
	      this.nodeChanged = function (args) {
	        var selection = editor.selection, node, parents, root;
	
	        // Fix for bug #1896577 it seems that this can not be fired while the editor is loading
	        if (editor.initialized && selection && !editor.settings.disable_nodechange && !editor.readonly) {
	          // Get start node
	          root = editor.getBody();
	          node = selection.getStart(true) || root;
	
	          // Make sure the node is within the editor root or is the editor root
	          if (node.ownerDocument != editor.getDoc() || !editor.dom.isChildOf(node, root)) {
	            node = root;
	          }
	
	          // Get parents and add them to object
	          parents = [];
	          editor.dom.getParent(node, function (node) {
	            if (node === root) {
	              return true;
	            }
	
	            parents.push(node);
	          });
	
	          args = args || {};
	          args.element = node;
	          args.parents = parents;
	
	          editor.fire('NodeChange', args);
	        }
	      };
	    };
	  }
	);
	
	/**
	 * MousePosition.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module calculates an absolute coordinate inside the editor body for both local and global mouse events.
	 *
	 * @private
	 * @class tinymce.dom.MousePosition
	 */
	define(
	  'tinymce.core.dom.MousePosition',
	  [
	  ],
	  function () {
	    var getAbsolutePosition = function (elm) {
	      var doc, docElem, win, clientRect;
	
	      clientRect = elm.getBoundingClientRect();
	      doc = elm.ownerDocument;
	      docElem = doc.documentElement;
	      win = doc.defaultView;
	
	      return {
	        top: clientRect.top + win.pageYOffset - docElem.clientTop,
	        left: clientRect.left + win.pageXOffset - docElem.clientLeft
	      };
	    };
	
	    var getBodyPosition = function (editor) {
	      return editor.inline ? getAbsolutePosition(editor.getBody()) : { left: 0, top: 0 };
	    };
	
	    var getScrollPosition = function (editor) {
	      var body = editor.getBody();
	      return editor.inline ? { left: body.scrollLeft, top: body.scrollTop } : { left: 0, top: 0 };
	    };
	
	    var getBodyScroll = function (editor) {
	      var body = editor.getBody(), docElm = editor.getDoc().documentElement;
	      var inlineScroll = { left: body.scrollLeft, top: body.scrollTop };
	      var iframeScroll = { left: body.scrollLeft || docElm.scrollLeft, top: body.scrollTop || docElm.scrollTop };
	
	      return editor.inline ? inlineScroll : iframeScroll;
	    };
	
	    var getMousePosition = function (editor, event) {
	      if (event.target.ownerDocument !== editor.getDoc()) {
	        var iframePosition = getAbsolutePosition(editor.getContentAreaContainer());
	        var scrollPosition = getBodyScroll(editor);
	
	        return {
	          left: event.pageX - iframePosition.left + scrollPosition.left,
	          top: event.pageY - iframePosition.top + scrollPosition.top
	        };
	      }
	
	      return {
	        left: event.pageX,
	        top: event.pageY
	      };
	    };
	
	    var calculatePosition = function (bodyPosition, scrollPosition, mousePosition) {
	      return {
	        pageX: (mousePosition.left - bodyPosition.left) + scrollPosition.left,
	        pageY: (mousePosition.top - bodyPosition.top) + scrollPosition.top
	      };
	    };
	
	    var calc = function (editor, event) {
	      return calculatePosition(getBodyPosition(editor), getScrollPosition(editor), getMousePosition(editor, event));
	    };
	
	    return {
	      calc: calc
	    };
	  }
	);
	
	/**
	 * DragDropOverrides.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic overriding the drag/drop logic of the editor.
	 *
	 * @private
	 * @class tinymce.DragDropOverrides
	 */
	define(
	  'tinymce.core.DragDropOverrides',
	  [
	    'global!document',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.dom.MousePosition',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.util.Arr',
	    'tinymce.core.util.Delay',
	    'tinymce.core.util.Fun'
	  ],
	  function (document, DOMUtils, MousePosition, NodeType, Arr, Delay, Fun) {
	    var isContentEditableFalse = NodeType.isContentEditableFalse,
	      isContentEditableTrue = NodeType.isContentEditableTrue;
	
	    var isDraggable = function (rootElm, elm) {
	      return isContentEditableFalse(elm) && elm !== rootElm;
	    };
	
	    var isValidDropTarget = function (editor, targetElement, dragElement) {
	      if (targetElement === dragElement || editor.dom.isChildOf(targetElement, dragElement)) {
	        return false;
	      }
	
	      if (isContentEditableFalse(targetElement)) {
	        return false;
	      }
	
	      return true;
	    };
	
	    var cloneElement = function (elm) {
	      var cloneElm = elm.cloneNode(true);
	      cloneElm.removeAttribute('data-mce-selected');
	      return cloneElm;
	    };
	
	    var createGhost = function (editor, elm, width, height) {
	      var clonedElm = elm.cloneNode(true);
	
	      editor.dom.setStyles(clonedElm, { width: width, height: height });
	      editor.dom.setAttrib(clonedElm, 'data-mce-selected', null);
	
	      var ghostElm = editor.dom.create('div', {
	        'class': 'mce-drag-container',
	        'data-mce-bogus': 'all',
	        unselectable: 'on',
	        contenteditable: 'false'
	      });
	
	      editor.dom.setStyles(ghostElm, {
	        position: 'absolute',
	        opacity: 0.5,
	        overflow: 'hidden',
	        border: 0,
	        padding: 0,
	        margin: 0,
	        width: width,
	        height: height
	      });
	
	      editor.dom.setStyles(clonedElm, {
	        margin: 0,
	        boxSizing: 'border-box'
	      });
	
	      ghostElm.appendChild(clonedElm);
	
	      return ghostElm;
	    };
	
	    var appendGhostToBody = function (ghostElm, bodyElm) {
	      if (ghostElm.parentNode !== bodyElm) {
	        bodyElm.appendChild(ghostElm);
	      }
	    };
	
	    var moveGhost = function (ghostElm, position, width, height, maxX, maxY) {
	      var overflowX = 0, overflowY = 0;
	
	      ghostElm.style.left = position.pageX + 'px';
	      ghostElm.style.top = position.pageY + 'px';
	
	      if (position.pageX + width > maxX) {
	        overflowX = (position.pageX + width) - maxX;
	      }
	
	      if (position.pageY + height > maxY) {
	        overflowY = (position.pageY + height) - maxY;
	      }
	
	      ghostElm.style.width = (width - overflowX) + 'px';
	      ghostElm.style.height = (height - overflowY) + 'px';
	    };
	
	    var removeElement = function (elm) {
	      if (elm && elm.parentNode) {
	        elm.parentNode.removeChild(elm);
	      }
	    };
	
	    var isLeftMouseButtonPressed = function (e) {
	      return e.button === 0;
	    };
	
	    var hasDraggableElement = function (state) {
	      return state.element;
	    };
	
	    var applyRelPos = function (state, position) {
	      return {
	        pageX: position.pageX - state.relX,
	        pageY: position.pageY + 5
	      };
	    };
	
	    var start = function (state, editor) {
	      return function (e) {
	        if (isLeftMouseButtonPressed(e)) {
	          var ceElm = Arr.find(editor.dom.getParents(e.target), Fun.or(isContentEditableFalse, isContentEditableTrue));
	
	          if (isDraggable(editor.getBody(), ceElm)) {
	            var elmPos = editor.dom.getPos(ceElm);
	            var bodyElm = editor.getBody();
	            var docElm = editor.getDoc().documentElement;
	
	            state.element = ceElm;
	            state.screenX = e.screenX;
	            state.screenY = e.screenY;
	            state.maxX = (editor.inline ? bodyElm.scrollWidth : docElm.offsetWidth) - 2;
	            state.maxY = (editor.inline ? bodyElm.scrollHeight : docElm.offsetHeight) - 2;
	            state.relX = e.pageX - elmPos.x;
	            state.relY = e.pageY - elmPos.y;
	            state.width = ceElm.offsetWidth;
	            state.height = ceElm.offsetHeight;
	            state.ghost = createGhost(editor, ceElm, state.width, state.height);
	          }
	        }
	      };
	    };
	
	    var move = function (state, editor) {
	      // Reduces laggy drag behavior on Gecko
	      var throttledPlaceCaretAt = Delay.throttle(function (clientX, clientY) {
	        editor._selectionOverrides.hideFakeCaret();
	        editor.selection.placeCaretAt(clientX, clientY);
	      }, 0);
	
	      return function (e) {
	        var movement = Math.max(Math.abs(e.screenX - state.screenX), Math.abs(e.screenY - state.screenY));
	
	        if (hasDraggableElement(state) && !state.dragging && movement > 10) {
	          var args = editor.fire('dragstart', { target: state.element });
	          if (args.isDefaultPrevented()) {
	            return;
	          }
	
	          state.dragging = true;
	          editor.focus();
	        }
	
	        if (state.dragging) {
	          var targetPos = applyRelPos(state, MousePosition.calc(editor, e));
	
	          appendGhostToBody(state.ghost, editor.getBody());
	          moveGhost(state.ghost, targetPos, state.width, state.height, state.maxX, state.maxY);
	
	          throttledPlaceCaretAt(e.clientX, e.clientY);
	        }
	      };
	    };
	
	    // Returns the raw element instead of the fake cE=false element
	    var getRawTarget = function (selection) {
	      var rng = selection.getSel().getRangeAt(0);
	      var startContainer = rng.startContainer;
	      return startContainer.nodeType === 3 ? startContainer.parentNode : startContainer;
	    };
	
	    var drop = function (state, editor) {
	      return function (e) {
	        if (state.dragging) {
	          if (isValidDropTarget(editor, getRawTarget(editor.selection), state.element)) {
	            var targetClone = cloneElement(state.element);
	
	            var args = editor.fire('drop', {
	              targetClone: targetClone,
	              clientX: e.clientX,
	              clientY: e.clientY
	            });
	
	            if (!args.isDefaultPrevented()) {
	              targetClone = args.targetClone;
	
	              editor.undoManager.transact(function () {
	                removeElement(state.element);
	                editor.insertContent(editor.dom.getOuterHTML(targetClone));
	                editor._selectionOverrides.hideFakeCaret();
	              });
	            }
	          }
	        }
	
	        removeDragState(state);
	      };
	    };
	
	    var stop = function (state, editor) {
	      return function () {
	        removeDragState(state);
	        if (state.dragging) {
	          editor.fire('dragend');
	        }
	      };
	    };
	
	    var removeDragState = function (state) {
	      state.dragging = false;
	      state.element = null;
	      removeElement(state.ghost);
	    };
	
	    var bindFakeDragEvents = function (editor) {
	      var state = {}, pageDom, dragStartHandler, dragHandler, dropHandler, dragEndHandler, rootDocument;
	
	      pageDom = DOMUtils.DOM;
	      rootDocument = document;
	      dragStartHandler = start(state, editor);
	      dragHandler = move(state, editor);
	      dropHandler = drop(state, editor);
	      dragEndHandler = stop(state, editor);
	
	      editor.on('mousedown', dragStartHandler);
	      editor.on('mousemove', dragHandler);
	      editor.on('mouseup', dropHandler);
	
	      pageDom.bind(rootDocument, 'mousemove', dragHandler);
	      pageDom.bind(rootDocument, 'mouseup', dragEndHandler);
	
	      editor.on('remove', function () {
	        pageDom.unbind(rootDocument, 'mousemove', dragHandler);
	        pageDom.unbind(rootDocument, 'mouseup', dragEndHandler);
	      });
	    };
	
	    var blockIeDrop = function (editor) {
	      editor.on('drop', function (e) {
	        // FF doesn't pass out clientX/clientY for drop since this is for IE we just use null instead
	        var realTarget = typeof e.clientX !== 'undefined' ? editor.getDoc().elementFromPoint(e.clientX, e.clientY) : null;
	
	        if (isContentEditableFalse(realTarget) || isContentEditableFalse(editor.dom.getContentEditableParent(realTarget))) {
	          e.preventDefault();
	        }
	      });
	    };
	
	    var init = function (editor) {
	      bindFakeDragEvents(editor);
	      blockIeDrop(editor);
	    };
	
	    return {
	      init: init
	    };
	  }
	);
	
	/**
	 * FakeCaret.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module contains logic for rendering a fake visual caret.
	 *
	 * @private
	 * @class tinymce.caret.FakeCaret
	 */
	define(
	  'tinymce.core.caret.FakeCaret',
	  [
	    'global!clearInterval',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.caret.CaretContainerRemove',
	    'tinymce.core.dom.DomQuery',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.geom.ClientRect',
	    'tinymce.core.util.Delay'
	  ],
	  function (clearInterval, CaretContainer, CaretContainerRemove, DomQuery, NodeType, ClientRect, Delay) {
	    var isContentEditableFalse = NodeType.isContentEditableFalse;
	
	    var isTableCell = function (node) {
	      return node && /^(TD|TH)$/i.test(node.nodeName);
	    };
	
	    return function (rootNode, isBlock) {
	      var cursorInterval, $lastVisualCaret = null, caretContainerNode;
	
	      var getAbsoluteClientRect = function (node, before) {
	        var clientRect = ClientRect.collapse(node.getBoundingClientRect(), before),
	          docElm, scrollX, scrollY, margin, rootRect;
	
	        if (rootNode.tagName == 'BODY') {
	          docElm = rootNode.ownerDocument.documentElement;
	          scrollX = rootNode.scrollLeft || docElm.scrollLeft;
	          scrollY = rootNode.scrollTop || docElm.scrollTop;
	        } else {
	          rootRect = rootNode.getBoundingClientRect();
	          scrollX = rootNode.scrollLeft - rootRect.left;
	          scrollY = rootNode.scrollTop - rootRect.top;
	        }
	
	        clientRect.left += scrollX;
	        clientRect.right += scrollX;
	        clientRect.top += scrollY;
	        clientRect.bottom += scrollY;
	        clientRect.width = 1;
	
	        margin = node.offsetWidth - node.clientWidth;
	
	        if (margin > 0) {
	          if (before) {
	            margin *= -1;
	          }
	
	          clientRect.left += margin;
	          clientRect.right += margin;
	        }
	
	        return clientRect;
	      };
	
	      var trimInlineCaretContainers = function () {
	        var contentEditableFalseNodes, node, sibling, i, data;
	
	        contentEditableFalseNodes = DomQuery('*[contentEditable=false]', rootNode);
	        for (i = 0; i < contentEditableFalseNodes.length; i++) {
	          node = contentEditableFalseNodes[i];
	
	          sibling = node.previousSibling;
	          if (CaretContainer.endsWithCaretContainer(sibling)) {
	            data = sibling.data;
	
	            if (data.length == 1) {
	              sibling.parentNode.removeChild(sibling);
	            } else {
	              sibling.deleteData(data.length - 1, 1);
	            }
	          }
	
	          sibling = node.nextSibling;
	          if (CaretContainer.startsWithCaretContainer(sibling)) {
	            data = sibling.data;
	
	            if (data.length == 1) {
	              sibling.parentNode.removeChild(sibling);
	            } else {
	              sibling.deleteData(0, 1);
	            }
	          }
	        }
	
	        return null;
	      };
	
	      var show = function (before, node) {
	        var clientRect, rng;
	
	        hide();
	
	        if (isTableCell(node)) {
	          return null;
	        }
	
	        if (isBlock(node)) {
	          caretContainerNode = CaretContainer.insertBlock('p', node, before);
	          clientRect = getAbsoluteClientRect(node, before);
	          DomQuery(caretContainerNode).css('top', clientRect.top);
	
	          $lastVisualCaret = DomQuery('<div class="mce-visual-caret" data-mce-bogus="all"></div>').css(clientRect).appendTo(rootNode);
	
	          if (before) {
	            $lastVisualCaret.addClass('mce-visual-caret-before');
	          }
	
	          startBlink();
	
	          rng = node.ownerDocument.createRange();
	          rng.setStart(caretContainerNode, 0);
	          rng.setEnd(caretContainerNode, 0);
	        } else {
	          caretContainerNode = CaretContainer.insertInline(node, before);
	          rng = node.ownerDocument.createRange();
	
	          if (isContentEditableFalse(caretContainerNode.nextSibling)) {
	            rng.setStart(caretContainerNode, 0);
	            rng.setEnd(caretContainerNode, 0);
	          } else {
	            rng.setStart(caretContainerNode, 1);
	            rng.setEnd(caretContainerNode, 1);
	          }
	
	          return rng;
	        }
	
	        return rng;
	      };
	
	      var hide = function () {
	        trimInlineCaretContainers();
	
	        if (caretContainerNode) {
	          CaretContainerRemove.remove(caretContainerNode);
	          caretContainerNode = null;
	        }
	
	        if ($lastVisualCaret) {
	          $lastVisualCaret.remove();
	          $lastVisualCaret = null;
	        }
	
	        clearInterval(cursorInterval);
	      };
	
	      var hasFocus = function () {
	        return rootNode.ownerDocument.activeElement === rootNode;
	      };
	
	      var startBlink = function () {
	        cursorInterval = Delay.setInterval(function () {
	          if (hasFocus()) {
	            DomQuery('div.mce-visual-caret', rootNode).toggleClass('mce-visual-caret-hidden');
	          } else {
	            DomQuery('div.mce-visual-caret', rootNode).addClass('mce-visual-caret-hidden');
	          }
	        }, 500);
	      };
	
	      var destroy = function () {
	        Delay.clearInterval(cursorInterval);
	      };
	
	      var getCss = function () {
	        return (
	          '.mce-visual-caret {' +
	          'position: absolute;' +
	          'background-color: black;' +
	          'background-color: currentcolor;' +
	          '}' +
	          '.mce-visual-caret-hidden {' +
	          'display: none;' +
	          '}' +
	          '*[data-mce-caret] {' +
	          'position: absolute;' +
	          'left: -1000px;' +
	          'right: auto;' +
	          'top: 0;' +
	          'margin: 0;' +
	          'padding: 0;' +
	          '}'
	        );
	      };
	
	      return {
	        show: show,
	        hide: hide,
	        getCss: getCss,
	        destroy: destroy
	      };
	    };
	  }
	);
	/**
	 * Dimensions.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module measures nodes and returns client rects. The client rects has an
	 * extra node property.
	 *
	 * @private
	 * @class tinymce.dom.Dimensions
	 */
	define(
	  'tinymce.core.dom.Dimensions',
	  [
	    "tinymce.core.util.Arr",
	    "tinymce.core.dom.NodeType",
	    "tinymce.core.geom.ClientRect"
	  ],
	  function (Arr, NodeType, ClientRect) {
	    var getClientRects = function (node) {
	      var toArrayWithNode = function (clientRects) {
	        return Arr.map(clientRects, function (clientRect) {
	          clientRect = ClientRect.clone(clientRect);
	          clientRect.node = node;
	
	          return clientRect;
	        });
	      };
	
	      if (Arr.isArray(node)) {
	        return Arr.reduce(node, function (result, node) {
	          return result.concat(getClientRects(node));
	        }, []);
	      }
	
	      if (NodeType.isElement(node)) {
	        return toArrayWithNode(node.getClientRects());
	      }
	
	      if (NodeType.isText(node)) {
	        var rng = node.ownerDocument.createRange();
	
	        rng.setStart(node, 0);
	        rng.setEnd(node, node.data.length);
	
	        return toArrayWithNode(rng.getClientRects());
	      }
	    };
	
	    return {
	      /**
	       * Returns the client rects for a specific node.
	       *
	       * @method getClientRects
	       * @param {Array/DOMNode} node Node or array of nodes to get client rects on.
	       * @param {Array} Array of client rects with a extra node property.
	       */
	      getClientRects: getClientRects
	    };
	  }
	);
	/**
	 * LineUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Utility functions for working with lines.
	 *
	 * @private
	 * @class tinymce.caret.LineUtils
	 */
	define(
	  'tinymce.core.caret.LineUtils',
	  [
	    "tinymce.core.util.Fun",
	    "tinymce.core.util.Arr",
	    "tinymce.core.dom.NodeType",
	    "tinymce.core.dom.Dimensions",
	    "tinymce.core.geom.ClientRect",
	    "tinymce.core.caret.CaretUtils",
	    "tinymce.core.caret.CaretCandidate"
	  ],
	  function (Fun, Arr, NodeType, Dimensions, ClientRect, CaretUtils, CaretCandidate) {
	    var isContentEditableFalse = NodeType.isContentEditableFalse,
	      findNode = CaretUtils.findNode,
	      curry = Fun.curry;
	
	    var distanceToRectLeft = function (clientRect, clientX) {
	      return Math.abs(clientRect.left - clientX);
	    };
	
	    var distanceToRectRight = function (clientRect, clientX) {
	      return Math.abs(clientRect.right - clientX);
	    };
	
	    var findClosestClientRect = function (clientRects, clientX) {
	      var isInside = function (clientX, clientRect) {
	        return clientX >= clientRect.left && clientX <= clientRect.right;
	      };
	
	      return Arr.reduce(clientRects, function (oldClientRect, clientRect) {
	        var oldDistance, newDistance;
	
	        oldDistance = Math.min(distanceToRectLeft(oldClientRect, clientX), distanceToRectRight(oldClientRect, clientX));
	        newDistance = Math.min(distanceToRectLeft(clientRect, clientX), distanceToRectRight(clientRect, clientX));
	
	        if (isInside(clientX, clientRect)) {
	          return clientRect;
	        }
	
	        if (isInside(clientX, oldClientRect)) {
	          return oldClientRect;
	        }
	
	        // cE=false has higher priority
	        if (newDistance == oldDistance && isContentEditableFalse(clientRect.node)) {
	          return clientRect;
	        }
	
	        if (newDistance < oldDistance) {
	          return clientRect;
	        }
	
	        return oldClientRect;
	      });
	    };
	
	    var walkUntil = function (direction, rootNode, predicateFn, node) {
	      while ((node = findNode(node, direction, CaretCandidate.isEditableCaretCandidate, rootNode))) {
	        if (predicateFn(node)) {
	          return;
	        }
	      }
	    };
	
	    var findLineNodeRects = function (rootNode, targetNodeRect) {
	      var clientRects = [];
	
	      var collect = function (checkPosFn, node) {
	        var lineRects;
	
	        lineRects = Arr.filter(Dimensions.getClientRects(node), function (clientRect) {
	          return !checkPosFn(clientRect, targetNodeRect);
	        });
	
	        clientRects = clientRects.concat(lineRects);
	
	        return lineRects.length === 0;
	      };
	
	      clientRects.push(targetNodeRect);
	      walkUntil(-1, rootNode, curry(collect, ClientRect.isAbove), targetNodeRect.node);
	      walkUntil(1, rootNode, curry(collect, ClientRect.isBelow), targetNodeRect.node);
	
	      return clientRects;
	    };
	
	    var getContentEditableFalseChildren = function (rootNode) {
	      return Arr.filter(Arr.toArray(rootNode.getElementsByTagName('*')), isContentEditableFalse);
	    };
	
	    var caretInfo = function (clientRect, clientX) {
	      return {
	        node: clientRect.node,
	        before: distanceToRectLeft(clientRect, clientX) < distanceToRectRight(clientRect, clientX)
	      };
	    };
	
	    var closestCaret = function (rootNode, clientX, clientY) {
	      var contentEditableFalseNodeRects, closestNodeRect;
	
	      contentEditableFalseNodeRects = Dimensions.getClientRects(getContentEditableFalseChildren(rootNode));
	      contentEditableFalseNodeRects = Arr.filter(contentEditableFalseNodeRects, function (clientRect) {
	        return clientY >= clientRect.top && clientY <= clientRect.bottom;
	      });
	
	      closestNodeRect = findClosestClientRect(contentEditableFalseNodeRects, clientX);
	      if (closestNodeRect) {
	        closestNodeRect = findClosestClientRect(findLineNodeRects(rootNode, closestNodeRect), clientX);
	        if (closestNodeRect && isContentEditableFalse(closestNodeRect.node)) {
	          return caretInfo(closestNodeRect, clientX);
	        }
	      }
	
	      return null;
	    };
	
	    return {
	      findClosestClientRect: findClosestClientRect,
	      findLineNodeRects: findLineNodeRects,
	      closestCaret: closestCaret
	    };
	  }
	);
	/**
	 * RangePoint.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.RangePoint',
	  [
	    'ephox.katamari.api.Arr',
	    'tinymce.core.geom.ClientRect'
	  ],
	  function (Arr, ClientRect) {
	    var isXYWithinRange = function (clientX, clientY, range) {
	      if (range.collapsed) {
	        return false;
	      }
	
	      return Arr.foldl(range.getClientRects(), function (state, rect) {
	        return state || ClientRect.containsXY(rect, clientX, clientY);
	      }, false);
	    };
	
	    return {
	      isXYWithinRange: isXYWithinRange
	    };
	  }
	);
	define(
	  'ephox.katamari.api.Throttler',
	
	  [
	    'global!clearTimeout',
	    'global!setTimeout'
	  ],
	
	  function (clearTimeout, setTimeout) {
	    // Run a function fn afer rate ms. If another invocation occurs
	    // during the time it is waiting, update the arguments f will run
	    // with (but keep the current schedule)
	    var adaptable = function (fn, rate) {
	      var timer = null;
	      var args = null;
	      var cancel = function () {
	        if (timer !== null) {
	          clearTimeout(timer);
	          timer = null;
	          args = null;
	        }
	      };
	      var throttle = function () {
	        args = arguments;
	        if (timer === null) {
	          timer = setTimeout(function () {
	            fn.apply(null, args);
	            timer = null;
	            args = null;
	          }, rate);
	        }
	      };
	
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    // Run a function fn after rate ms. If another invocation occurs
	    // during the time it is waiting, ignore it completely.
	    var first = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = arguments;
	        if (timer === null) {
	          timer = setTimeout(function () {
	            fn.apply(null, args);
	            timer = null;
	            args = null;
	          }, rate);
	        }
	      };
	
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    // Run a function fn after rate ms. If another invocation occurs
	    // during the time it is waiting, reschedule the function again
	    // with the new arguments.
	    var last = function (fn, rate) {
	      var timer = null;
	      var cancel = function () {
	        if (timer !== null) {
	          clearTimeout(timer);
	          timer = null;
	        }
	      };
	      var throttle = function () {
	        var args = arguments;
	        if (timer !== null) clearTimeout(timer);
	        timer = setTimeout(function () {
	          fn.apply(null, args);
	          timer = null;
	          args = null;
	        }, rate);
	      };
	
	      return {
	        cancel: cancel,
	        throttle: throttle
	      };
	    };
	
	    return {
	      adaptable: adaptable,
	      first: first,
	      last: last
	    };
	  }
	);
	/**
	 * CefUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.CefUtils',
	  [
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.caret.CaretUtils',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.util.Fun'
	  ],
	  function (CaretPosition, CaretUtils, NodeType, Fun) {
	    var isContentEditableTrue = NodeType.isContentEditableTrue;
	    var isContentEditableFalse = NodeType.isContentEditableFalse;
	
	    var showCaret = function (direction, editor, node, before) {
	      // TODO: Figure out a better way to handle this dependency
	      return editor._selectionOverrides.showCaret(direction, node, before);
	    };
	
	    var getNodeRange = function (node) {
	      var rng = node.ownerDocument.createRange();
	      rng.selectNode(node);
	      return rng;
	    };
	
	    var selectNode = function (editor, node) {
	      var e;
	
	      e = editor.fire('BeforeObjectSelected', { target: node });
	      if (e.isDefaultPrevented()) {
	        return null;
	      }
	
	      return getNodeRange(node);
	    };
	
	    var renderCaretAtRange = function (editor, range) {
	      var caretPosition, ceRoot;
	
	      range = CaretUtils.normalizeRange(1, editor.getBody(), range);
	      caretPosition = CaretPosition.fromRangeStart(range);
	
	      if (isContentEditableFalse(caretPosition.getNode())) {
	        return showCaret(1, editor, caretPosition.getNode(), !caretPosition.isAtEnd());
	      }
	
	      if (isContentEditableFalse(caretPosition.getNode(true))) {
	        return showCaret(1, editor, caretPosition.getNode(true), false);
	      }
	
	      // TODO: Should render caret before/after depending on where you click on the page forces after now
	      ceRoot = editor.dom.getParent(caretPosition.getNode(), Fun.or(isContentEditableFalse, isContentEditableTrue));
	      if (isContentEditableFalse(ceRoot)) {
	        return showCaret(1, editor, ceRoot, false);
	      }
	
	      return null;
	    };
	
	    var renderRangeCaret = function (editor, range) {
	      var caretRange;
	
	      if (!range || !range.collapsed) {
	        return range;
	      }
	
	      caretRange = renderCaretAtRange(editor, range);
	      if (caretRange) {
	        return caretRange;
	      }
	
	      return range;
	    };
	
	    return {
	      showCaret: showCaret,
	      selectNode: selectNode,
	      renderCaretAtRange: renderCaretAtRange,
	      renderRangeCaret: renderRangeCaret
	    };
	  }
	);
	
	/**
	 * CefFocus.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.focus.CefFocus',
	  [
	    'ephox.katamari.api.Throttler',
	    'tinymce.core.keyboard.CefUtils'
	  ],
	  function (Throttler, CefUtils) {
	    var setup = function (editor) {
	      var renderFocusCaret = Throttler.first(function () {
	        if (!editor.removed) {
	          var caretRange = CefUtils.renderRangeCaret(editor, editor.selection.getRng());
	          editor.selection.setRng(caretRange);
	        }
	      }, 0);
	
	      editor.on('focus', function () {
	        renderFocusCaret.throttle();
	      });
	
	      editor.on('blur', function () {
	        renderFocusCaret.cancel();
	      });
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	/**
	 * VK.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This file exposes a set of the common KeyCodes for use. Please grow it as needed.
	 */
	define(
	  'tinymce.core.util.VK',
	  [
	    "tinymce.core.Env"
	  ],
	  function (Env) {
	    return {
	      BACKSPACE: 8,
	      DELETE: 46,
	      DOWN: 40,
	      ENTER: 13,
	      LEFT: 37,
	      RIGHT: 39,
	      SPACEBAR: 32,
	      TAB: 9,
	      UP: 38,
	
	      modifierPressed: function (e) {
	        return e.shiftKey || e.ctrlKey || e.altKey || this.metaKeyPressed(e);
	      },
	
	      metaKeyPressed: function (e) {
	        // Check if ctrl or meta key is pressed. Edge case for AltGr on Windows where it produces ctrlKey+altKey states
	        return (Env.mac ? e.metaKey : e.ctrlKey && !e.altKey);
	      }
	    };
	  }
	);
	
	/**
	 * SelectionOverrides.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.SelectionOverrides',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.dom.Remove',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.properties.Attr',
	    'ephox.sugar.api.search.SelectorFilter',
	    'ephox.sugar.api.search.SelectorFind',
	    'tinymce.core.DragDropOverrides',
	    'tinymce.core.EditorView',
	    'tinymce.core.Env',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.caret.CaretUtils',
	    'tinymce.core.caret.CaretWalker',
	    'tinymce.core.caret.FakeCaret',
	    'tinymce.core.caret.LineUtils',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.RangePoint',
	    'tinymce.core.focus.CefFocus',
	    'tinymce.core.keyboard.CefUtils',
	    'tinymce.core.util.VK'
	  ],
	  function (
	    Arr, Remove, Element, Attr, SelectorFilter, SelectorFind, DragDropOverrides, EditorView, Env, CaretContainer, CaretPosition, CaretUtils, CaretWalker, FakeCaret,
	    LineUtils, NodeType, RangePoint, CefFocus, CefUtils, VK
	  ) {
	    var isContentEditableTrue = NodeType.isContentEditableTrue,
	      isContentEditableFalse = NodeType.isContentEditableFalse,
	      isAfterContentEditableFalse = CaretUtils.isAfterContentEditableFalse,
	      isBeforeContentEditableFalse = CaretUtils.isBeforeContentEditableFalse;
	
	    var SelectionOverrides = function (editor) {
	      var isBlock = function (node) {
	        return editor.dom.isBlock(node);
	      };
	
	      var rootNode = editor.getBody();
	      var fakeCaret = new FakeCaret(editor.getBody(), isBlock),
	        realSelectionId = 'sel-' + editor.dom.uniqueId(),
	        selectedContentEditableNode;
	
	      var isFakeSelectionElement = function (elm) {
	        return editor.dom.hasClass(elm, 'mce-offscreen-selection');
	      };
	
	      var getRealSelectionElement = function () {
	        var container = editor.dom.get(realSelectionId);
	        return container ? container.getElementsByTagName('*')[0] : container;
	      };
	
	      var setRange = function (range) {
	        //console.log('setRange', range);
	        if (range) {
	          editor.selection.setRng(range);
	        }
	      };
	
	      var getRange = function () {
	        return editor.selection.getRng();
	      };
	
	      var scrollIntoView = function (node, alignToTop) {
	        editor.selection.scrollIntoView(node, alignToTop);
	      };
	
	      var showCaret = function (direction, node, before) {
	        var e;
	
	        e = editor.fire('ShowCaret', {
	          target: node,
	          direction: direction,
	          before: before
	        });
	
	        if (e.isDefaultPrevented()) {
	          return null;
	        }
	
	        scrollIntoView(node, direction === -1);
	
	        return fakeCaret.show(before, node);
	      };
	
	      var getNormalizedRangeEndPoint = function (direction, range) {
	        range = CaretUtils.normalizeRange(direction, rootNode, range);
	
	        if (direction == -1) {
	          return CaretPosition.fromRangeStart(range);
	        }
	
	        return CaretPosition.fromRangeEnd(range);
	      };
	
	      var showBlockCaretContainer = function (blockCaretContainer) {
	        if (blockCaretContainer.hasAttribute('data-mce-caret')) {
	          CaretContainer.showCaretContainerBlock(blockCaretContainer);
	          setRange(getRange()); // Removes control rect on IE
	          scrollIntoView(blockCaretContainer[0]);
	        }
	      };
	
	      var registerEvents = function () {
	        var getContentEditableRoot = function (node) {
	          var root = editor.getBody();
	
	          while (node && node != root) {
	            if (isContentEditableTrue(node) || isContentEditableFalse(node)) {
	              return node;
	            }
	
	            node = node.parentNode;
	          }
	
	          return null;
	        };
	
	        // Some browsers (Chrome) lets you place the caret after a cE=false
	        // Make sure we render the caret container in this case
	        editor.on('mouseup', function (e) {
	          var range = getRange();
	
	          if (range.collapsed && EditorView.isXYInContentArea(editor, e.clientX, e.clientY)) {
	            setRange(CefUtils.renderCaretAtRange(editor, range));
	          }
	        });
	
	        editor.on('click', function (e) {
	          var contentEditableRoot;
	
	          contentEditableRoot = getContentEditableRoot(e.target);
	          if (contentEditableRoot) {
	            // Prevent clicks on links in a cE=false element
	            if (isContentEditableFalse(contentEditableRoot)) {
	              e.preventDefault();
	              editor.focus();
	            }
	
	            // Removes fake selection if a cE=true is clicked within a cE=false like the toc title
	            if (isContentEditableTrue(contentEditableRoot)) {
	              if (editor.dom.isChildOf(contentEditableRoot, editor.selection.getNode())) {
	                removeContentEditableSelection();
	              }
	            }
	          }
	        });
	
	        editor.on('blur NewBlock', function () {
	          removeContentEditableSelection();
	        });
	
	        var handleTouchSelect = function (editor) {
	          var moved = false;
	
	          editor.on('touchstart', function () {
	            moved = false;
	          });
	
	          editor.on('touchmove', function () {
	            moved = true;
	          });
	
	          editor.on('touchend', function (e) {
	            var contentEditableRoot = getContentEditableRoot(e.target);
	
	            if (isContentEditableFalse(contentEditableRoot)) {
	              if (!moved) {
	                e.preventDefault();
	                setContentEditableSelection(CefUtils.selectNode(editor, contentEditableRoot));
	              }
	            }
	          });
	        };
	
	        var hasNormalCaretPosition = function (elm) {
	          var caretWalker = new CaretWalker(elm);
	
	          if (!elm.firstChild) {
	            return false;
	          }
	
	          var startPos = CaretPosition.before(elm.firstChild);
	          var newPos = caretWalker.next(startPos);
	
	          return newPos && !isBeforeContentEditableFalse(newPos) && !isAfterContentEditableFalse(newPos);
	        };
	
	        var isInSameBlock = function (node1, node2) {
	          var block1 = editor.dom.getParent(node1, editor.dom.isBlock);
	          var block2 = editor.dom.getParent(node2, editor.dom.isBlock);
	          return block1 === block2;
	        };
	
	        // Checks if the target node is in a block and if that block has a caret position better than the
	        // suggested caretNode this is to prevent the caret from being sucked in towards a cE=false block if
	        // they are adjacent on the vertical axis
	        var hasBetterMouseTarget = function (targetNode, caretNode) {
	          var targetBlock = editor.dom.getParent(targetNode, editor.dom.isBlock);
	          var caretBlock = editor.dom.getParent(caretNode, editor.dom.isBlock);
	
	          return targetBlock && !isInSameBlock(targetBlock, caretBlock) && hasNormalCaretPosition(targetBlock);
	        };
	
	        handleTouchSelect(editor);
	
	        editor.on('mousedown', function (e) {
	          var contentEditableRoot;
	
	          if (EditorView.isXYInContentArea(editor, e.clientX, e.clientY) === false) {
	            return;
	          }
	
	          contentEditableRoot = getContentEditableRoot(e.target);
	          if (contentEditableRoot) {
	            if (isContentEditableFalse(contentEditableRoot)) {
	              e.preventDefault();
	              setContentEditableSelection(CefUtils.selectNode(editor, contentEditableRoot));
	            } else {
	              removeContentEditableSelection();
	
	              // Check that we're not attempting a shift + click select within a contenteditable='true' element
	              if (!(isContentEditableTrue(contentEditableRoot) && e.shiftKey) && !RangePoint.isXYWithinRange(e.clientX, e.clientY, editor.selection.getRng())) {
	                editor.selection.placeCaretAt(e.clientX, e.clientY);
	              }
	            }
	          } else {
	            // Remove needs to be called here since the mousedown might alter the selection without calling selection.setRng
	            // and therefore not fire the AfterSetSelectionRange event.
	            removeContentEditableSelection();
	            hideFakeCaret();
	
	            var caretInfo = LineUtils.closestCaret(rootNode, e.clientX, e.clientY);
	            if (caretInfo) {
	              if (!hasBetterMouseTarget(e.target, caretInfo.node)) {
	                e.preventDefault();
	                editor.getBody().focus();
	                setRange(showCaret(1, caretInfo.node, caretInfo.before));
	              }
	            }
	          }
	        });
	
	        editor.on('keypress', function (e) {
	          if (VK.modifierPressed(e)) {
	            return;
	          }
	
	          switch (e.keyCode) {
	            default:
	              if (isContentEditableFalse(editor.selection.getNode())) {
	                e.preventDefault();
	              }
	              break;
	          }
	        });
	
	        editor.on('getSelectionRange', function (e) {
	          var rng = e.range;
	
	          if (selectedContentEditableNode) {
	            if (!selectedContentEditableNode.parentNode) {
	              selectedContentEditableNode = null;
	              return;
	            }
	
	            rng = rng.cloneRange();
	            rng.selectNode(selectedContentEditableNode);
	            e.range = rng;
	          }
	        });
	
	        editor.on('setSelectionRange', function (e) {
	          var rng;
	
	          rng = setContentEditableSelection(e.range, e.forward);
	          if (rng) {
	            e.range = rng;
	          }
	        });
	
	        editor.on('AfterSetSelectionRange', function (e) {
	          var rng = e.range;
	
	          if (!isRangeInCaretContainer(rng)) {
	            hideFakeCaret();
	          }
	
	          if (!isFakeSelectionElement(rng.startContainer.parentNode)) {
	            removeContentEditableSelection();
	          }
	        });
	
	        editor.on('copy', function (e) {
	          var clipboardData = e.clipboardData;
	
	          // Make sure we get proper html/text for the fake cE=false selection
	          // Doesn't work at all on Edge since it doesn't have proper clipboardData support
	          if (!e.isDefaultPrevented() && e.clipboardData && !Env.ie) {
	            var realSelectionElement = getRealSelectionElement();
	            if (realSelectionElement) {
	              e.preventDefault();
	              clipboardData.clearData();
	              clipboardData.setData('text/html', realSelectionElement.outerHTML);
	              clipboardData.setData('text/plain', realSelectionElement.outerText);
	            }
	          }
	        });
	
	        DragDropOverrides.init(editor);
	        CefFocus.setup(editor);
	      };
	
	      var addCss = function () {
	        var styles = editor.contentStyles, rootClass = '.mce-content-body';
	
	        styles.push(fakeCaret.getCss());
	        styles.push(
	          rootClass + ' .mce-offscreen-selection {' +
	          'position: absolute;' +
	          'left: -9999999999px;' +
	          'max-width: 1000000px;' +
	          '}' +
	          rootClass + ' *[contentEditable=false] {' +
	          'cursor: default;' +
	          '}' +
	          rootClass + ' *[contentEditable=true] {' +
	          'cursor: text;' +
	          '}'
	        );
	      };
	
	      var isWithinCaretContainer = function (node) {
	        return (
	          CaretContainer.isCaretContainer(node) ||
	          CaretContainer.startsWithCaretContainer(node) ||
	          CaretContainer.endsWithCaretContainer(node)
	        );
	      };
	
	      var isRangeInCaretContainer = function (rng) {
	        return isWithinCaretContainer(rng.startContainer) || isWithinCaretContainer(rng.endContainer);
	      };
	
	      var setContentEditableSelection = function (range, forward) {
	        var node, $ = editor.$, dom = editor.dom, $realSelectionContainer, sel,
	          startContainer, startOffset, endOffset, e, caretPosition, targetClone, origTargetClone;
	
	        if (!range) {
	          return null;
	        }
	
	        if (range.collapsed) {
	          if (!isRangeInCaretContainer(range)) {
	            if (forward === false) {
	              caretPosition = getNormalizedRangeEndPoint(-1, range);
	
	              if (isContentEditableFalse(caretPosition.getNode(true))) {
	                return showCaret(-1, caretPosition.getNode(true), false);
	              }
	
	              if (isContentEditableFalse(caretPosition.getNode())) {
	                return showCaret(-1, caretPosition.getNode(), !caretPosition.isAtEnd());
	              }
	            } else {
	              caretPosition = getNormalizedRangeEndPoint(1, range);
	
	              if (isContentEditableFalse(caretPosition.getNode())) {
	                return showCaret(1, caretPosition.getNode(), !caretPosition.isAtEnd());
	              }
	
	              if (isContentEditableFalse(caretPosition.getNode(true))) {
	                return showCaret(1, caretPosition.getNode(true), false);
	              }
	            }
	          }
	
	          return null;
	        }
	
	        startContainer = range.startContainer;
	        startOffset = range.startOffset;
	        endOffset = range.endOffset;
	
	        // Normalizes <span cE=false>[</span>] to [<span cE=false></span>]
	        if (startContainer.nodeType === 3 && startOffset === 0 && isContentEditableFalse(startContainer.parentNode)) {
	          startContainer = startContainer.parentNode;
	          startOffset = dom.nodeIndex(startContainer);
	          startContainer = startContainer.parentNode;
	        }
	
	        if (startContainer.nodeType != 1) {
	          return null;
	        }
	
	        if (endOffset == startOffset + 1) {
	          node = startContainer.childNodes[startOffset];
	        }
	
	        if (!isContentEditableFalse(node)) {
	          return null;
	        }
	
	        targetClone = origTargetClone = node.cloneNode(true);
	        e = editor.fire('ObjectSelected', { target: node, targetClone: targetClone });
	        if (e.isDefaultPrevented()) {
	          return null;
	        }
	
	        $realSelectionContainer = SelectorFind.descendant(Element.fromDom(editor.getBody()), '#' + realSelectionId).fold(
	          function () {
	            return $([]);
	          },
	          function (elm) {
	            return $([elm.dom()]);
	          }
	        );
	
	        targetClone = e.targetClone;
	        if ($realSelectionContainer.length === 0) {
	          $realSelectionContainer = $(
	            '<div data-mce-bogus="all" class="mce-offscreen-selection"></div>'
	          ).attr('id', realSelectionId);
	
	          $realSelectionContainer.appendTo(editor.getBody());
	        }
	
	        range = editor.dom.createRng();
	
	        // WHY is IE making things so hard! Copy on <i contentEditable="false">x</i> produces: <em>x</em>
	        // This is a ridiculous hack where we place the selection from a block over the inline element
	        // so that just the inline element is copied as is and not converted.
	        if (targetClone === origTargetClone && Env.ie) {
	          $realSelectionContainer.empty().append('<p style="font-size: 0" data-mce-bogus="all">\u00a0</p>').append(targetClone);
	          range.setStartAfter($realSelectionContainer[0].firstChild.firstChild);
	          range.setEndAfter(targetClone);
	        } else {
	          $realSelectionContainer.empty().append('\u00a0').append(targetClone).append('\u00a0');
	          range.setStart($realSelectionContainer[0].firstChild, 1);
	          range.setEnd($realSelectionContainer[0].lastChild, 0);
	        }
	
	        $realSelectionContainer.css({
	          top: dom.getPos(node, editor.getBody()).y
	        });
	
	        $realSelectionContainer[0].focus();
	        sel = editor.selection.getSel();
	        sel.removeAllRanges();
	        sel.addRange(range);
	
	        Arr.each(SelectorFilter.descendants(Element.fromDom(editor.getBody()), '*[data-mce-selected]'), function (elm) {
	          Attr.remove(elm, 'data-mce-selected');
	        });
	
	        node.setAttribute('data-mce-selected', 1);
	        selectedContentEditableNode = node;
	        hideFakeCaret();
	
	        return range;
	      };
	
	      var removeContentEditableSelection = function () {
	        if (selectedContentEditableNode) {
	          selectedContentEditableNode.removeAttribute('data-mce-selected');
	          SelectorFind.descendant(Element.fromDom(editor.getBody()), '#' + realSelectionId).each(Remove.remove);
	          selectedContentEditableNode = null;
	        }
	      };
	
	      var destroy = function () {
	        fakeCaret.destroy();
	        selectedContentEditableNode = null;
	      };
	
	      var hideFakeCaret = function () {
	        fakeCaret.hide();
	      };
	
	      if (Env.ceFalse) {
	        registerEvents();
	        addCss();
	      }
	
	      return {
	        showCaret: showCaret,
	        showBlockCaretContainer: showBlockCaretContainer,
	        hideFakeCaret: hideFakeCaret,
	        destroy: destroy
	      };
	    };
	
	    return SelectionOverrides;
	  }
	);
	
	/**
	 * Diff.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * JS Implementation of the O(ND) Difference Algorithm by Eugene W. Myers.
	 *
	 * @class tinymce.undo.Diff
	 * @private
	 */
	define(
	  'tinymce.core.undo.Diff',
	  [
	  ],
	  function () {
	    var KEEP = 0, INSERT = 1, DELETE = 2;
	
	    var diff = function (left, right) {
	      var size = left.length + right.length + 2;
	      var vDown = new Array(size);
	      var vUp = new Array(size);
	
	      var snake = function (start, end, diag) {
	        return {
	          start: start,
	          end: end,
	          diag: diag
	        };
	      };
	
	      var buildScript = function (start1, end1, start2, end2, script) {
	        var middle = getMiddleSnake(start1, end1, start2, end2);
	
	        if (middle === null || middle.start === end1 && middle.diag === end1 - end2 ||
	          middle.end === start1 && middle.diag === start1 - start2) {
	          var i = start1;
	          var j = start2;
	          while (i < end1 || j < end2) {
	            if (i < end1 && j < end2 && left[i] === right[j]) {
	              script.push([KEEP, left[i]]);
	              ++i;
	              ++j;
	            } else {
	              if (end1 - start1 > end2 - start2) {
	                script.push([DELETE, left[i]]);
	                ++i;
	              } else {
	                script.push([INSERT, right[j]]);
	                ++j;
	              }
	            }
	          }
	        } else {
	          buildScript(start1, middle.start, start2, middle.start - middle.diag, script);
	          for (var i2 = middle.start; i2 < middle.end; ++i2) {
	            script.push([KEEP, left[i2]]);
	          }
	          buildScript(middle.end, end1, middle.end - middle.diag, end2, script);
	        }
	      };
	
	      var buildSnake = function (start, diag, end1, end2) {
	        var end = start;
	        while (end - diag < end2 && end < end1 && left[end] === right[end - diag]) {
	          ++end;
	        }
	        return snake(start, end, diag);
	      };
	
	      var getMiddleSnake = function (start1, end1, start2, end2) {
	        // Myers Algorithm
	        // Initialisations
	        var m = end1 - start1;
	        var n = end2 - start2;
	        if (m === 0 || n === 0) {
	          return null;
	        }
	
	        var delta = m - n;
	        var sum = n + m;
	        var offset = (sum % 2 === 0 ? sum : sum + 1) / 2;
	        vDown[1 + offset] = start1;
	        vUp[1 + offset] = end1 + 1;
	
	        for (var d = 0; d <= offset; ++d) {
	          // Down
	          for (var k = -d; k <= d; k += 2) {
	            // First step
	
	            var i = k + offset;
	            if (k === -d || k != d && vDown[i - 1] < vDown[i + 1]) {
	              vDown[i] = vDown[i + 1];
	            } else {
	              vDown[i] = vDown[i - 1] + 1;
	            }
	
	            var x = vDown[i];
	            var y = x - start1 + start2 - k;
	
	            while (x < end1 && y < end2 && left[x] === right[y]) {
	              vDown[i] = ++x;
	              ++y;
	            }
	            // Second step
	            if (delta % 2 != 0 && delta - d <= k && k <= delta + d) {
	              if (vUp[i - delta] <= vDown[i]) {
	                return buildSnake(vUp[i - delta], k + start1 - start2, end1, end2);
	              }
	            }
	          }
	
	          // Up
	          for (k = delta - d; k <= delta + d; k += 2) {
	            // First step
	            i = k + offset - delta;
	            if (k === delta - d || k != delta + d && vUp[i + 1] <= vUp[i - 1]) {
	              vUp[i] = vUp[i + 1] - 1;
	            } else {
	              vUp[i] = vUp[i - 1];
	            }
	
	            x = vUp[i] - 1;
	            y = x - start1 + start2 - k;
	            while (x >= start1 && y >= start2 && left[x] === right[y]) {
	              vUp[i] = x--;
	              y--;
	            }
	            // Second step
	            if (delta % 2 === 0 && -d <= k && k <= d) {
	              if (vUp[i] <= vDown[i + delta]) {
	                return buildSnake(vUp[i], k + start1 - start2, end1, end2);
	              }
	            }
	          }
	        }
	      };
	
	      var script = [];
	      buildScript(0, left.length, 0, right.length, script);
	      return script;
	    };
	
	    return {
	      KEEP: KEEP,
	      DELETE: DELETE,
	      INSERT: INSERT,
	      diff: diff
	    };
	  }
	);
	/**
	 * Fragments.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module reads and applies html fragments from/to dom nodes.
	 *
	 * @class tinymce.undo.Fragments
	 * @private
	 */
	define(
	  'tinymce.core.undo.Fragments',
	  [
	    'global!document',
	    'tinymce.core.html.Entities',
	    'tinymce.core.undo.Diff',
	    'tinymce.core.util.Arr'
	  ],
	  function (document, Entities, Diff, Arr) {
	    var getOuterHtml = function (elm) {
	      if (elm.nodeType === 1) {
	        return elm.outerHTML;
	      } else if (elm.nodeType === 3) {
	        return Entities.encodeRaw(elm.data, false);
	      } else if (elm.nodeType === 8) {
	        return '<!--' + elm.data + '-->';
	      }
	
	      return '';
	    };
	
	    var createFragment = function (html) {
	      var frag, node, container;
	
	      container = document.createElement("div");
	      frag = document.createDocumentFragment();
	
	      if (html) {
	        container.innerHTML = html;
	      }
	
	      while ((node = container.firstChild)) {
	        frag.appendChild(node);
	      }
	
	      return frag;
	    };
	
	    var insertAt = function (elm, html, index) {
	      var fragment = createFragment(html);
	      if (elm.hasChildNodes() && index < elm.childNodes.length) {
	        var target = elm.childNodes[index];
	        target.parentNode.insertBefore(fragment, target);
	      } else {
	        elm.appendChild(fragment);
	      }
	    };
	
	    var removeAt = function (elm, index) {
	      if (elm.hasChildNodes() && index < elm.childNodes.length) {
	        var target = elm.childNodes[index];
	        target.parentNode.removeChild(target);
	      }
	    };
	
	    var applyDiff = function (diff, elm) {
	      var index = 0;
	      Arr.each(diff, function (action) {
	        if (action[0] === Diff.KEEP) {
	          index++;
	        } else if (action[0] === Diff.INSERT) {
	          insertAt(elm, action[1], index);
	          index++;
	        } else if (action[0] === Diff.DELETE) {
	          removeAt(elm, index);
	        }
	      });
	    };
	
	    var read = function (elm) {
	      return Arr.filter(Arr.map(elm.childNodes, getOuterHtml), function (item) {
	        return item.length > 0;
	      });
	    };
	
	    var write = function (fragments, elm) {
	      var currentFragments = Arr.map(elm.childNodes, getOuterHtml);
	      applyDiff(Diff.diff(currentFragments, fragments), elm);
	      return elm;
	    };
	
	    return {
	      read: read,
	      write: write
	    };
	  }
	);
	/**
	 * Levels.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module handles getting/setting undo levels to/from editor instances.
	 *
	 * @class tinymce.undo.Levels
	 * @private
	 */
	define(
	  'tinymce.core.undo.Levels',
	  [
	    'ephox.katamari.api.Arr',
	    'tinymce.core.dom.TrimHtml',
	    'tinymce.core.undo.Fragments'
	  ],
	  function (Arr, TrimHtml, Fragments) {
	    var hasIframes = function (html) {
	      return html.indexOf('</iframe>') !== -1;
	    };
	
	    var createFragmentedLevel = function (fragments) {
	      return {
	        type: 'fragmented',
	        fragments: fragments,
	        content: '',
	        bookmark: null,
	        beforeBookmark: null
	      };
	    };
	
	    var createCompleteLevel = function (content) {
	      return {
	        type: 'complete',
	        fragments: null,
	        content: content,
	        bookmark: null,
	        beforeBookmark: null
	      };
	    };
	
	    var createFromEditor = function (editor) {
	      var fragments, content, trimmedFragments;
	
	      fragments = Fragments.read(editor.getBody());
	      trimmedFragments = Arr.bind(fragments, function (html) {
	        var trimmed = TrimHtml.trimInternal(editor.serializer, html);
	        return trimmed.length > 0 ? [trimmed] : [];
	      });
	      content = trimmedFragments.join('');
	
	      return hasIframes(content) ? createFragmentedLevel(trimmedFragments) : createCompleteLevel(content);
	    };
	
	    var applyToEditor = function (editor, level, before) {
	      if (level.type === 'fragmented') {
	        Fragments.write(level.fragments, editor.getBody());
	      } else {
	        editor.setContent(level.content, { format: 'raw' });
	      }
	
	      editor.selection.moveToBookmark(before ? level.beforeBookmark : level.bookmark);
	    };
	
	    var getLevelContent = function (level) {
	      return level.type === 'fragmented' ? level.fragments.join('') : level.content;
	    };
	
	    var isEq = function (level1, level2) {
	      return !!level1 && !!level2 && getLevelContent(level1) === getLevelContent(level2);
	    };
	
	    return {
	      createFragmentedLevel: createFragmentedLevel,
	      createCompleteLevel: createCompleteLevel,
	      createFromEditor: createFromEditor,
	      applyToEditor: applyToEditor,
	      isEq: isEq
	    };
	  }
	);
	/**
	 * UndoManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles the undo/redo history levels for the editor. Since the built-in undo/redo has major drawbacks a custom one was needed.
	 *
	 * @class tinymce.UndoManager
	 */
	define(
	  'tinymce.core.UndoManager',
	  [
	    'tinymce.core.dom.GetBookmark',
	    'tinymce.core.undo.Levels',
	    'tinymce.core.util.Tools'
	  ],
	  function (GetBookmark, Levels, Tools) {
	    return function (editor) {
	      var self = this, index = 0, data = [], beforeBookmark, isFirstTypedCharacter, locks = 0;
	
	      var isUnlocked = function () {
	        return locks === 0;
	      };
	
	      var setTyping = function (typing) {
	        if (isUnlocked()) {
	          self.typing = typing;
	        }
	      };
	
	      var setDirty = function (state) {
	        editor.setDirty(state);
	      };
	
	      var addNonTypingUndoLevel = function (e) {
	        setTyping(false);
	        self.add({}, e);
	      };
	
	      var endTyping = function () {
	        if (self.typing) {
	          setTyping(false);
	          self.add();
	        }
	      };
	
	      // Add initial undo level when the editor is initialized
	      editor.on('init', function () {
	        self.add();
	      });
	
	      // Get position before an execCommand is processed
	      editor.on('BeforeExecCommand', function (e) {
	        var cmd = e.command;
	
	        if (cmd !== 'Undo' && cmd !== 'Redo' && cmd !== 'mceRepaint') {
	          endTyping();
	          self.beforeChange();
	        }
	      });
	
	      // Add undo level after an execCommand call was made
	      editor.on('ExecCommand', function (e) {
	        var cmd = e.command;
	
	        if (cmd !== 'Undo' && cmd !== 'Redo' && cmd !== 'mceRepaint') {
	          addNonTypingUndoLevel(e);
	        }
	      });
	
	      editor.on('ObjectResizeStart Cut', function () {
	        self.beforeChange();
	      });
	
	      editor.on('SaveContent ObjectResized blur', addNonTypingUndoLevel);
	      editor.on('DragEnd', addNonTypingUndoLevel);
	
	      editor.on('KeyUp', function (e) {
	        var keyCode = e.keyCode;
	
	        // If key is prevented then don't add undo level
	        // This would happen on keyboard shortcuts for example
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	
	        if ((keyCode >= 33 && keyCode <= 36) || (keyCode >= 37 && keyCode <= 40) || keyCode === 45 || e.ctrlKey) {
	          addNonTypingUndoLevel();
	          editor.nodeChanged();
	        }
	
	        if (keyCode === 46 || keyCode === 8) {
	          editor.nodeChanged();
	        }
	
	        // Fire a TypingUndo/Change event on the first character entered
	        if (isFirstTypedCharacter && self.typing && Levels.isEq(Levels.createFromEditor(editor), data[0]) === false) {
	          if (editor.isDirty() === false) {
	            setDirty(true);
	            editor.fire('change', { level: data[0], lastLevel: null });
	          }
	
	          editor.fire('TypingUndo');
	          isFirstTypedCharacter = false;
	          editor.nodeChanged();
	        }
	      });
	
	      editor.on('KeyDown', function (e) {
	        var keyCode = e.keyCode;
	
	        // If key is prevented then don't add undo level
	        // This would happen on keyboard shortcuts for example
	        if (e.isDefaultPrevented()) {
	          return;
	        }
	
	        // Is character position keys left,right,up,down,home,end,pgdown,pgup,enter
	        if ((keyCode >= 33 && keyCode <= 36) || (keyCode >= 37 && keyCode <= 40) || keyCode === 45) {
	          if (self.typing) {
	            addNonTypingUndoLevel(e);
	          }
	
	          return;
	        }
	
	        // If key isn't Ctrl+Alt/AltGr
	        var modKey = (e.ctrlKey && !e.altKey) || e.metaKey;
	        if ((keyCode < 16 || keyCode > 20) && keyCode !== 224 && keyCode !== 91 && !self.typing && !modKey) {
	          self.beforeChange();
	          setTyping(true);
	          self.add({}, e);
	          isFirstTypedCharacter = true;
	        }
	      });
	
	      editor.on('MouseDown', function (e) {
	        if (self.typing) {
	          addNonTypingUndoLevel(e);
	        }
	      });
	
	      // Add keyboard shortcuts for undo/redo keys
	      editor.addShortcut('meta+z', '', 'Undo');
	      editor.addShortcut('meta+y,meta+shift+z', '', 'Redo');
	
	      editor.on('AddUndo Undo Redo ClearUndos', function (e) {
	        if (!e.isDefaultPrevented()) {
	          editor.nodeChanged();
	        }
	      });
	
	      /*eslint consistent-this:0 */
	      self = {
	        // Explode for debugging reasons
	        data: data,
	
	        /**
	         * State if the user is currently typing or not. This will add a typing operation into one undo
	         * level instead of one new level for each keystroke.
	         *
	         * @field {Boolean} typing
	         */
	        typing: false,
	
	        /**
	         * Stores away a bookmark to be used when performing an undo action so that the selection is before
	         * the change has been made.
	         *
	         * @method beforeChange
	         */
	        beforeChange: function () {
	          if (isUnlocked()) {
	            beforeBookmark = GetBookmark.getUndoBookmark(editor.selection);
	          }
	        },
	
	        /**
	         * Adds a new undo level/snapshot to the undo list.
	         *
	         * @method add
	         * @param {Object} level Optional undo level object to add.
	         * @param {DOMEvent} event Optional event responsible for the creation of the undo level.
	         * @return {Object} Undo level that got added or null it a level wasn't needed.
	         */
	        add: function (level, event) {
	          var i, settings = editor.settings, lastLevel, currentLevel;
	
	          currentLevel = Levels.createFromEditor(editor);
	          level = level || {};
	          level = Tools.extend(level, currentLevel);
	
	          if (isUnlocked() === false || editor.removed) {
	            return null;
	          }
	
	          lastLevel = data[index];
	          if (editor.fire('BeforeAddUndo', { level: level, lastLevel: lastLevel, originalEvent: event }).isDefaultPrevented()) {
	            return null;
	          }
	
	          // Add undo level if needed
	          if (lastLevel && Levels.isEq(lastLevel, level)) {
	            return null;
	          }
	
	          // Set before bookmark on previous level
	          if (data[index]) {
	            data[index].beforeBookmark = beforeBookmark;
	          }
	
	          // Time to compress
	          if (settings.custom_undo_redo_levels) {
	            if (data.length > settings.custom_undo_redo_levels) {
	              for (i = 0; i < data.length - 1; i++) {
	                data[i] = data[i + 1];
	              }
	
	              data.length--;
	              index = data.length;
	            }
	          }
	
	          // Get a non intrusive normalized bookmark
	          level.bookmark = GetBookmark.getUndoBookmark(editor.selection);
	
	          // Crop array if needed
	          if (index < data.length - 1) {
	            data.length = index + 1;
	          }
	
	          data.push(level);
	          index = data.length - 1;
	
	          var args = { level: level, lastLevel: lastLevel, originalEvent: event };
	
	          editor.fire('AddUndo', args);
	
	          if (index > 0) {
	            setDirty(true);
	            editor.fire('change', args);
	          }
	
	          return level;
	        },
	
	        /**
	         * Undoes the last action.
	         *
	         * @method undo
	         * @return {Object} Undo level or null if no undo was performed.
	         */
	        undo: function () {
	          var level;
	
	          if (self.typing) {
	            self.add();
	            self.typing = false;
	            setTyping(false);
	          }
	
	          if (index > 0) {
	            level = data[--index];
	            Levels.applyToEditor(editor, level, true);
	            setDirty(true);
	            editor.fire('undo', { level: level });
	          }
	
	          return level;
	        },
	
	        /**
	         * Redoes the last action.
	         *
	         * @method redo
	         * @return {Object} Redo level or null if no redo was performed.
	         */
	        redo: function () {
	          var level;
	
	          if (index < data.length - 1) {
	            level = data[++index];
	            Levels.applyToEditor(editor, level, false);
	            setDirty(true);
	            editor.fire('redo', { level: level });
	          }
	
	          return level;
	        },
	
	        /**
	         * Removes all undo levels.
	         *
	         * @method clear
	         */
	        clear: function () {
	          data = [];
	          index = 0;
	          self.typing = false;
	          self.data = data;
	          editor.fire('ClearUndos');
	        },
	
	        /**
	         * Returns true/false if the undo manager has any undo levels.
	         *
	         * @method hasUndo
	         * @return {Boolean} true/false if the undo manager has any undo levels.
	         */
	        hasUndo: function () {
	          // Has undo levels or typing and content isn't the same as the initial level
	          return index > 0 || (self.typing && data[0] && !Levels.isEq(Levels.createFromEditor(editor), data[0]));
	        },
	
	        /**
	         * Returns true/false if the undo manager has any redo levels.
	         *
	         * @method hasRedo
	         * @return {Boolean} true/false if the undo manager has any redo levels.
	         */
	        hasRedo: function () {
	          return index < data.length - 1 && !self.typing;
	        },
	
	        /**
	         * Executes the specified mutator function as an undo transaction. The selection
	         * before the modification will be stored to the undo stack and if the DOM changes
	         * it will add a new undo level. Any logic within the translation that adds undo levels will
	         * be ignored. So a translation can include calls to execCommand or editor.insertContent.
	         *
	         * @method transact
	         * @param {function} callback Function that gets executed and has dom manipulation logic in it.
	         * @return {Object} Undo level that got added or null it a level wasn't needed.
	         */
	        transact: function (callback) {
	          endTyping();
	          self.beforeChange();
	          self.ignore(callback);
	          return self.add();
	        },
	
	        /**
	         * Executes the specified mutator function as an undo transaction. But without adding an undo level.
	         * Any logic within the translation that adds undo levels will be ignored. So a translation can
	         * include calls to execCommand or editor.insertContent.
	         *
	         * @method ignore
	         * @param {function} callback Function that gets executed and has dom manipulation logic in it.
	         * @return {Object} Undo level that got added or null it a level wasn't needed.
	         */
	        ignore: function (callback) {
	          try {
	            locks++;
	            callback();
	          } finally {
	            locks--;
	          }
	        },
	
	        /**
	         * Adds an extra "hidden" undo level by first applying the first mutation and store that to the undo stack
	         * then roll back that change and do the second mutation on top of the stack. This will produce an extra
	         * undo level that the user doesn't see until they undo.
	         *
	         * @method extra
	         * @param {function} callback1 Function that does mutation but gets stored as a "hidden" extra undo level.
	         * @param {function} callback2 Function that does mutation but gets displayed to the user.
	         */
	        extra: function (callback1, callback2) {
	          var lastLevel, bookmark;
	
	          if (self.transact(callback1)) {
	            bookmark = data[index].bookmark;
	            lastLevel = data[index - 1];
	            Levels.applyToEditor(editor, lastLevel, true);
	
	            if (self.transact(callback2)) {
	              data[index - 1].beforeBookmark = bookmark;
	            }
	          }
	        }
	      };
	
	      return self;
	    };
	  }
	);
	
	/**
	 * Hooks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Internal class for overriding formatting.
	 *
	 * @private
	 * @class tinymce.fmt.Hooks
	 */
	define(
	  'tinymce.core.fmt.Hooks',
	  [
	    "tinymce.core.util.Arr",
	    "tinymce.core.dom.NodeType",
	    "tinymce.core.dom.DomQuery"
	  ],
	  function (Arr, NodeType, $) {
	    var postProcessHooks = {}, filter = Arr.filter, each = Arr.each;
	
	    var addPostProcessHook = function (name, hook) {
	      var hooks = postProcessHooks[name];
	
	      if (!hooks) {
	        postProcessHooks[name] = hooks = [];
	      }
	
	      postProcessHooks[name].push(hook);
	    };
	
	    var postProcess = function (name, editor) {
	      each(postProcessHooks[name], function (hook) {
	        hook(editor);
	      });
	    };
	
	    addPostProcessHook("pre", function (editor) {
	      var rng = editor.selection.getRng(), isPre, blocks;
	
	      var hasPreSibling = function (pre) {
	        return isPre(pre.previousSibling) && Arr.indexOf(blocks, pre.previousSibling) !== -1;
	      };
	
	      var joinPre = function (pre1, pre2) {
	        $(pre2).remove();
	        $(pre1).append('<br><br>').append(pre2.childNodes);
	      };
	
	      isPre = NodeType.matchNodeNames('pre');
	
	      if (!rng.collapsed) {
	        blocks = editor.selection.getSelectedBlocks();
	
	        each(filter(filter(blocks, isPre), hasPreSibling), function (pre) {
	          joinPre(pre.previousSibling, pre);
	        });
	      }
	    });
	
	    return {
	      postProcess: postProcess
	    };
	  }
	);
	
	/**
	 * RangeWalk.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.RangeWalk',
	  [
	    'tinymce.core.util.Tools'
	  ],
	  function (Tools) {
	    var each = Tools.each;
	
	    var getEndChild = function (container, index) {
	      var childNodes = container.childNodes;
	
	      index--;
	
	      if (index > childNodes.length - 1) {
	        index = childNodes.length - 1;
	      } else if (index < 0) {
	        index = 0;
	      }
	
	      return childNodes[index] || container;
	    };
	
	    var walk = function (dom, rng, callback) {
	      var startContainer = rng.startContainer,
	        startOffset = rng.startOffset,
	        endContainer = rng.endContainer,
	        endOffset = rng.endOffset,
	        ancestor, startPoint,
	        endPoint, node, parent, siblings, nodes;
	
	      // Handle table cell selection the table plugin enables
	      // you to fake select table cells and perform formatting actions on them
	      nodes = dom.select('td[data-mce-selected],th[data-mce-selected]');
	      if (nodes.length > 0) {
	        each(nodes, function (node) {
	          callback([node]);
	        });
	
	        return;
	      }
	
	      /**
	       * Excludes start/end text node if they are out side the range
	       *
	       * @private
	       * @param {Array} nodes Nodes to exclude items from.
	       * @return {Array} Array with nodes excluding the start/end container if needed.
	       */
	      var exclude = function (nodes) {
	        var node;
	
	        // First node is excluded
	        node = nodes[0];
	        if (node.nodeType === 3 && node === startContainer && startOffset >= node.nodeValue.length) {
	          nodes.splice(0, 1);
	        }
	
	        // Last node is excluded
	        node = nodes[nodes.length - 1];
	        if (endOffset === 0 && nodes.length > 0 && node === endContainer && node.nodeType === 3) {
	          nodes.splice(nodes.length - 1, 1);
	        }
	
	        return nodes;
	      };
	
	      var collectSiblings = function (node, name, endNode) {
	        var siblings = [];
	
	        for (; node && node != endNode; node = node[name]) {
	          siblings.push(node);
	        }
	
	        return siblings;
	      };
	
	      var findEndPoint = function (node, root) {
	        do {
	          if (node.parentNode === root) {
	            return node;
	          }
	
	          node = node.parentNode;
	        } while (node);
	      };
	
	      var walkBoundary = function (startNode, endNode, next) {
	        var siblingName = next ? 'nextSibling' : 'previousSibling';
	
	        for (node = startNode, parent = node.parentNode; node && node != endNode; node = parent) {
	          parent = node.parentNode;
	          siblings = collectSiblings(node === startNode ? node : node[siblingName], siblingName);
	
	          if (siblings.length) {
	            if (!next) {
	              siblings.reverse();
	            }
	
	            callback(exclude(siblings));
	          }
	        }
	      };
	
	      // If index based start position then resolve it
	      if (startContainer.nodeType === 1 && startContainer.hasChildNodes()) {
	        startContainer = startContainer.childNodes[startOffset];
	      }
	
	      // If index based end position then resolve it
	      if (endContainer.nodeType === 1 && endContainer.hasChildNodes()) {
	        endContainer = getEndChild(endContainer, endOffset);
	      }
	
	      // Same container
	      if (startContainer === endContainer) {
	        return callback(exclude([startContainer]));
	      }
	
	      // Find common ancestor and end points
	      ancestor = dom.findCommonAncestor(startContainer, endContainer);
	
	      // Process left side
	      for (node = startContainer; node; node = node.parentNode) {
	        if (node === endContainer) {
	          return walkBoundary(startContainer, ancestor, true);
	        }
	
	        if (node === ancestor) {
	          break;
	        }
	      }
	
	      // Process right side
	      for (node = endContainer; node; node = node.parentNode) {
	        if (node === startContainer) {
	          return walkBoundary(endContainer, ancestor);
	        }
	
	        if (node === ancestor) {
	          break;
	        }
	      }
	
	      // Find start/end point
	      startPoint = findEndPoint(startContainer, ancestor) || startContainer;
	      endPoint = findEndPoint(endContainer, ancestor) || endContainer;
	
	      // Walk left leaf
	      walkBoundary(startContainer, startPoint, true);
	
	      // Walk the middle from start to end point
	      siblings = collectSiblings(
	        startPoint === startContainer ? startPoint : startPoint.nextSibling,
	        'nextSibling',
	        endPoint === endContainer ? endPoint.nextSibling : endPoint
	      );
	
	      if (siblings.length) {
	        callback(exclude(siblings));
	      }
	
	      // Walk right leaf
	      walkBoundary(endContainer, endPoint);
	    };
	
	    return {
	      walk: walk
	    };
	  }
	);
	
	/**
	 * RemoveFormat.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.RemoveFormat',
	  [
	    'tinymce.core.dom.Bookmarks',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.TreeWalker',
	    'tinymce.core.fmt.CaretFormat',
	    'tinymce.core.fmt.ExpandRange',
	    'tinymce.core.fmt.FormatUtils',
	    'tinymce.core.fmt.MatchFormat',
	    'tinymce.core.selection.RangeWalk',
	    'tinymce.core.util.Tools'
	  ],
	  function (Bookmarks, NodeType, TreeWalker, CaretFormat, ExpandRange, FormatUtils, MatchFormat, RangeWalk, Tools) {
	    var MCE_ATTR_RE = /^(src|href|style)$/;
	    var each = Tools.each;
	    var isEq = FormatUtils.isEq;
	
	    var isTableCell = function (node) {
	      return /^(TH|TD)$/.test(node.nodeName);
	    };
	
	    var getContainer = function (ed, rng, start) {
	      var container, offset, lastIdx;
	
	      container = rng[start ? 'startContainer' : 'endContainer'];
	      offset = rng[start ? 'startOffset' : 'endOffset'];
	
	      if (NodeType.isElement(container)) {
	        lastIdx = container.childNodes.length - 1;
	
	        if (!start && offset) {
	          offset--;
	        }
	
	        container = container.childNodes[offset > lastIdx ? lastIdx : offset];
	      }
	
	      // If start text node is excluded then walk to the next node
	      if (NodeType.isText(container) && start && offset >= container.nodeValue.length) {
	        container = new TreeWalker(container, ed.getBody()).next() || container;
	      }
	
	      // If end text node is excluded then walk to the previous node
	      if (NodeType.isText(container) && !start && offset === 0) {
	        container = new TreeWalker(container, ed.getBody()).prev() || container;
	      }
	
	      return container;
	    };
	
	    var wrap = function (dom, node, name, attrs) {
	      var wrapper = dom.create(name, attrs);
	
	      node.parentNode.insertBefore(wrapper, node);
	      wrapper.appendChild(node);
	
	      return wrapper;
	    };
	
	    /**
	     * Checks if the specified nodes name matches the format inline/block or selector.
	     *
	     * @private
	     * @param {Node} node Node to match against the specified format.
	     * @param {Object} format Format object o match with.
	     * @return {boolean} true/false if the format matches.
	     */
	    var matchName = function (dom, node, format) {
	      // Check for inline match
	      if (isEq(node, format.inline)) {
	        return true;
	      }
	
	      // Check for block match
	      if (isEq(node, format.block)) {
	        return true;
	      }
	
	      // Check for selector match
	      if (format.selector) {
	        return NodeType.isElement(node) && dom.is(node, format.selector);
	      }
	    };
	
	    var isColorFormatAndAnchor = function (node, format) {
	      return format.links && node.tagName === 'A';
	    };
	
	    var find = function (dom, node, next, inc) {
	      node = FormatUtils.getNonWhiteSpaceSibling(node, next, inc);
	      return !node || (node.nodeName === 'BR' || dom.isBlock(node));
	    };
	
	    /**
	     * Removes the node and wrap it's children in paragraphs before doing so or
	     * appends BR elements to the beginning/end of the block element if forcedRootBlocks is disabled.
	     *
	     * If the div in the node below gets removed:
	     *  text<div>text</div>text
	     *
	     * Output becomes:
	     *  text<div><br />text<br /></div>text
	     *
	     * So when the div is removed the result is:
	     *  text<br />text<br />text
	     *
	     * @private
	     * @param {Node} node Node to remove + apply BR/P elements to.
	     * @param {Object} format Format rule.
	     * @return {Node} Input node.
	     */
	    var removeNode = function (ed, node, format) {
	      var parentNode = node.parentNode, rootBlockElm;
	      var dom = ed.dom, forcedRootBlock = ed.settings.forced_root_block;
	
	      if (format.block) {
	        if (!forcedRootBlock) {
	          // Append BR elements if needed before we remove the block
	          if (dom.isBlock(node) && !dom.isBlock(parentNode)) {
	            if (!find(dom, node, false) && !find(dom, node.firstChild, true, 1)) {
	              node.insertBefore(dom.create('br'), node.firstChild);
	            }
	
	            if (!find(dom, node, true) && !find(dom, node.lastChild, false, 1)) {
	              node.appendChild(dom.create('br'));
	            }
	          }
	        } else {
	          // Wrap the block in a forcedRootBlock if we are at the root of document
	          if (parentNode === dom.getRoot()) {
	            if (!format.list_block || !isEq(node, format.list_block)) {
	              each(Tools.grep(node.childNodes), function (node) {
	                if (FormatUtils.isValid(ed, forcedRootBlock, node.nodeName.toLowerCase())) {
	                  if (!rootBlockElm) {
	                    rootBlockElm = wrap(dom, node, forcedRootBlock);
	                    dom.setAttribs(rootBlockElm, ed.settings.forced_root_block_attrs);
	                  } else {
	                    rootBlockElm.appendChild(node);
	                  }
	                } else {
	                  rootBlockElm = 0;
	                }
	              });
	            }
	          }
	        }
	      }
	
	      // Never remove nodes that isn't the specified inline element if a selector is specified too
	      if (format.selector && format.inline && !isEq(format.inline, node)) {
	        return;
	      }
	
	      dom.remove(node, 1);
	    };
	
	    /**
	     * Removes the specified format for the specified node. It will also remove the node if it doesn't have
	     * any attributes if the format specifies it to do so.
	     *
	     * @private
	     * @param {Object} format Format object with items to remove from node.
	     * @param {Object} vars Name/value object with variables to apply to format.
	     * @param {Node} node Node to remove the format styles on.
	     * @param {Node} compareNode Optional compare node, if specified the styles will be compared to that node.
	     * @return {Boolean} True/false if the node was removed or not.
	     */
	    var removeFormat = function (ed, format, vars, node, compareNode) {
	      var i, attrs, stylesModified, dom = ed.dom;
	
	      // Check if node matches format
	      if (!matchName(dom, node, format) && !isColorFormatAndAnchor(node, format)) {
	        return false;
	      }
	
	      // Should we compare with format attribs and styles
	      if (format.remove !== 'all') {
	        // Remove styles
	        each(format.styles, function (value, name) {
	          value = FormatUtils.normalizeStyleValue(dom, FormatUtils.replaceVars(value, vars), name);
	
	          // Indexed array
	          if (typeof name === 'number') {
	            name = value;
	            compareNode = 0;
	          }
	
	          if (format.remove_similar || (!compareNode || isEq(FormatUtils.getStyle(dom, compareNode, name), value))) {
	            dom.setStyle(node, name, '');
	          }
	
	          stylesModified = 1;
	        });
	
	        // Remove style attribute if it's empty
	        if (stylesModified && dom.getAttrib(node, 'style') === '') {
	          node.removeAttribute('style');
	          node.removeAttribute('data-mce-style');
	        }
	
	        // Remove attributes
	        each(format.attributes, function (value, name) {
	          var valueOut;
	
	          value = FormatUtils.replaceVars(value, vars);
	
	          // Indexed array
	          if (typeof name === 'number') {
	            name = value;
	            compareNode = 0;
	          }
	
	          if (!compareNode || isEq(dom.getAttrib(compareNode, name), value)) {
	            // Keep internal classes
	            if (name === 'class') {
	              value = dom.getAttrib(node, name);
	              if (value) {
	                // Build new class value where everything is removed except the internal prefixed classes
	                valueOut = '';
	                each(value.split(/\s+/), function (cls) {
	                  if (/mce\-\w+/.test(cls)) {
	                    valueOut += (valueOut ? ' ' : '') + cls;
	                  }
	                });
	
	                // We got some internal classes left
	                if (valueOut) {
	                  dom.setAttrib(node, name, valueOut);
	                  return;
	                }
	              }
	            }
	
	            // IE6 has a bug where the attribute doesn't get removed correctly
	            if (name === "class") {
	              node.removeAttribute('className');
	            }
	
	            // Remove mce prefixed attributes
	            if (MCE_ATTR_RE.test(name)) {
	              node.removeAttribute('data-mce-' + name);
	            }
	
	            node.removeAttribute(name);
	          }
	        });
	
	        // Remove classes
	        each(format.classes, function (value) {
	          value = FormatUtils.replaceVars(value, vars);
	
	          if (!compareNode || dom.hasClass(compareNode, value)) {
	            dom.removeClass(node, value);
	          }
	        });
	
	        // Check for non internal attributes
	        attrs = dom.getAttribs(node);
	        for (i = 0; i < attrs.length; i++) {
	          var attrName = attrs[i].nodeName;
	          if (attrName.indexOf('_') !== 0 && attrName.indexOf('data-') !== 0) {
	            return false;
	          }
	        }
	      }
	
	      // Remove the inline child if it's empty for example <b> or <span>
	      if (format.remove !== 'none') {
	        removeNode(ed, node, format);
	        return true;
	      }
	    };
	
	    var findFormatRoot = function (editor, container, name, vars, similar) {
	      var formatRoot;
	
	      // Find format root
	      each(FormatUtils.getParents(editor.dom, container.parentNode).reverse(), function (parent) {
	        var format;
	
	        // Find format root element
	        if (!formatRoot && parent.id !== '_start' && parent.id !== '_end') {
	          // Is the node matching the format we are looking for
	          format = MatchFormat.matchNode(editor, parent, name, vars, similar);
	          if (format && format.split !== false) {
	            formatRoot = parent;
	          }
	        }
	      });
	
	      return formatRoot;
	    };
	
	    var wrapAndSplit = function (editor, formatList, formatRoot, container, target, split, format, vars) {
	      var parent, clone, lastClone, firstClone, i, formatRootParent, dom = editor.dom;
	
	      // Format root found then clone formats and split it
	      if (formatRoot) {
	        formatRootParent = formatRoot.parentNode;
	
	        for (parent = container.parentNode; parent && parent !== formatRootParent; parent = parent.parentNode) {
	          clone = dom.clone(parent, false);
	
	          for (i = 0; i < formatList.length; i++) {
	            if (removeFormat(editor, formatList[i], vars, clone, clone)) {
	              clone = 0;
	              break;
	            }
	          }
	
	          // Build wrapper node
	          if (clone) {
	            if (lastClone) {
	              clone.appendChild(lastClone);
	            }
	
	            if (!firstClone) {
	              firstClone = clone;
	            }
	
	            lastClone = clone;
	          }
	        }
	
	        // Never split block elements if the format is mixed
	        if (split && (!format.mixed || !dom.isBlock(formatRoot))) {
	          container = dom.split(formatRoot, container);
	        }
	
	        // Wrap container in cloned formats
	        if (lastClone) {
	          target.parentNode.insertBefore(lastClone, target);
	          firstClone.appendChild(target);
	        }
	      }
	
	      return container;
	    };
	
	    var remove = function (ed, name, vars, node, similar) {
	      var formatList = ed.formatter.get(name), format = formatList[0];
	      var bookmark, rng, contentEditable = true, dom = ed.dom, selection = ed.selection;
	
	      var splitToFormatRoot = function (container) {
	        var formatRoot = findFormatRoot(ed, container, name, vars, similar);
	        return wrapAndSplit(ed, formatList, formatRoot, container, container, true, format, vars);
	      };
	
	      // Merges the styles for each node
	      var process = function (node) {
	        var children, i, l, lastContentEditable, hasContentEditableState;
	
	        // Node has a contentEditable value
	        if (NodeType.isElement(node) && dom.getContentEditable(node)) {
	          lastContentEditable = contentEditable;
	          contentEditable = dom.getContentEditable(node) === "true";
	          hasContentEditableState = true; // We don't want to wrap the container only it's children
	        }
	
	        // Grab the children first since the nodelist might be changed
	        children = Tools.grep(node.childNodes);
	
	        // Process current node
	        if (contentEditable && !hasContentEditableState) {
	          for (i = 0, l = formatList.length; i < l; i++) {
	            if (removeFormat(ed, formatList[i], vars, node, node)) {
	              break;
	            }
	          }
	        }
	
	        // Process the children
	        if (format.deep) {
	          if (children.length) {
	            for (i = 0, l = children.length; i < l; i++) {
	              process(children[i]);
	            }
	
	            if (hasContentEditableState) {
	              contentEditable = lastContentEditable; // Restore last contentEditable state from stack
	            }
	          }
	        }
	      };
	
	      var unwrap = function (start) {
	        var node = dom.get(start ? '_start' : '_end'),
	          out = node[start ? 'firstChild' : 'lastChild'];
	
	        // If the end is placed within the start the result will be removed
	        // So this checks if the out node is a bookmark node if it is it
	        // checks for another more suitable node
	        if (Bookmarks.isBookmarkNode(out)) {
	          out = out[start ? 'firstChild' : 'lastChild'];
	        }
	
	        // Since dom.remove removes empty text nodes then we need to try to find a better node
	        if (NodeType.isText(out) && out.data.length === 0) {
	          out = start ? node.previousSibling || node.nextSibling : node.nextSibling || node.previousSibling;
	        }
	
	        dom.remove(node, true);
	
	        return out;
	      };
	
	      var removeRngStyle = function (rng) {
	        var startContainer, endContainer;
	        var commonAncestorContainer = rng.commonAncestorContainer;
	
	        rng = ExpandRange.expandRng(ed, rng, formatList, true);
	
	        if (format.split) {
	          startContainer = getContainer(ed, rng, true);
	          endContainer = getContainer(ed, rng);
	
	          if (startContainer !== endContainer) {
	            // WebKit will render the table incorrectly if we wrap a TH or TD in a SPAN
	            // so let's see if we can use the first child instead
	            // This will happen if you triple click a table cell and use remove formatting
	            if (/^(TR|TH|TD)$/.test(startContainer.nodeName) && startContainer.firstChild) {
	              if (startContainer.nodeName === "TR") {
	                startContainer = startContainer.firstChild.firstChild || startContainer;
	              } else {
	                startContainer = startContainer.firstChild || startContainer;
	              }
	            }
	
	            // Try to adjust endContainer as well if cells on the same row were selected - bug #6410
	            if (commonAncestorContainer &&
	              /^T(HEAD|BODY|FOOT|R)$/.test(commonAncestorContainer.nodeName) &&
	              isTableCell(endContainer) && endContainer.firstChild) {
	              endContainer = endContainer.firstChild || endContainer;
	            }
	
	            if (dom.isChildOf(startContainer, endContainer) && startContainer !== endContainer && !dom.isBlock(endContainer) && !isTableCell(startContainer) && !isTableCell(endContainer)) {
	              startContainer = wrap(dom, startContainer, 'span', { id: '_start', 'data-mce-type': 'bookmark' });
	              splitToFormatRoot(startContainer);
	              startContainer = unwrap(true);
	              return;
	            }
	
	            // Wrap start/end nodes in span element since these might be cloned/moved
	            startContainer = wrap(dom, startContainer, 'span', { id: '_start', 'data-mce-type': 'bookmark' });
	            endContainer = wrap(dom, endContainer, 'span', { id: '_end', 'data-mce-type': 'bookmark' });
	
	            // Split start/end
	            splitToFormatRoot(startContainer);
	            splitToFormatRoot(endContainer);
	
	            // Unwrap start/end to get real elements again
	            startContainer = unwrap(true);
	            endContainer = unwrap();
	          } else {
	            startContainer = endContainer = splitToFormatRoot(startContainer);
	          }
	
	          // Update range positions since they might have changed after the split operations
	          rng.startContainer = startContainer.parentNode ? startContainer.parentNode : startContainer;
	          rng.startOffset = dom.nodeIndex(startContainer);
	          rng.endContainer = endContainer.parentNode ? endContainer.parentNode : endContainer;
	          rng.endOffset = dom.nodeIndex(endContainer) + 1;
	        }
	
	        // Remove items between start/end
	        RangeWalk.walk(dom, rng, function (nodes) {
	          each(nodes, function (node) {
	            process(node);
	
	            // Remove parent span if it only contains text-decoration: underline, yet a parent node is also underlined.
	            if (NodeType.isElement(node) && ed.dom.getStyle(node, 'text-decoration') === 'underline' &&
	              node.parentNode && FormatUtils.getTextDecoration(dom, node.parentNode) === 'underline') {
	              removeFormat(ed, {
	                'deep': false,
	                'exact': true,
	                'inline': 'span',
	                'styles': {
	                  'textDecoration': 'underline'
	                }
	              }, null, node);
	            }
	          });
	        });
	      };
	
	      // Handle node
	      if (node) {
	        if (node.nodeType) {
	          rng = dom.createRng();
	          rng.setStartBefore(node);
	          rng.setEndAfter(node);
	          removeRngStyle(rng);
	        } else {
	          removeRngStyle(node);
	        }
	
	        return;
	      }
	
	      if (dom.getContentEditable(selection.getNode()) === "false") {
	        node = selection.getNode();
	        for (var i = 0, l = formatList.length; i < l; i++) {
	          if (formatList[i].ceFalseOverride) {
	            if (removeFormat(ed, formatList[i], vars, node, node)) {
	              break;
	            }
	          }
	        }
	
	        return;
	      }
	
	      if (!selection.isCollapsed() || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
	        bookmark = selection.getBookmark();
	        removeRngStyle(selection.getRng(true));
	        selection.moveToBookmark(bookmark);
	
	        // Check if start element still has formatting then we are at: "<b>text|</b>text"
	        // and need to move the start into the next text node
	        if (format.inline && MatchFormat.match(ed, name, vars, selection.getStart())) {
	          FormatUtils.moveStart(dom, selection, selection.getRng(true));
	        }
	
	        ed.nodeChanged();
	      } else {
	        CaretFormat.removeCaretFormat(ed, name, vars, similar);
	      }
	    };
	
	    return {
	      removeFormat: removeFormat,
	      remove: remove
	    };
	  }
	);
	/**
	 * MergeFormats.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.MergeFormats',
	  [
	    'ephox.katamari.api.Fun',
	    'tinymce.core.dom.Bookmarks',
	    'tinymce.core.dom.ElementUtils',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.fmt.CaretFormat',
	    'tinymce.core.fmt.FormatUtils',
	    'tinymce.core.fmt.MatchFormat',
	    'tinymce.core.fmt.RemoveFormat',
	    'tinymce.core.util.Tools'
	  ],
	  function (Fun, Bookmarks, ElementUtils, NodeType, CaretFormat, FormatUtils, MatchFormat, RemoveFormat, Tools) {
	    var each = Tools.each;
	
	    var isElementNode = function (node) {
	      return node && node.nodeType === 1 && !Bookmarks.isBookmarkNode(node) && !CaretFormat.isCaretNode(node) && !NodeType.isBogus(node);
	    };
	
	    var findElementSibling = function (node, siblingName) {
	      var sibling;
	
	      for (sibling = node; sibling; sibling = sibling[siblingName]) {
	        if (sibling.nodeType === 3 && sibling.nodeValue.length !== 0) {
	          return node;
	        }
	
	        if (sibling.nodeType === 1 && !Bookmarks.isBookmarkNode(sibling)) {
	          return sibling;
	        }
	      }
	
	      return node;
	    };
	
	    var mergeSiblingsNodes = function (dom, prev, next) {
	      var sibling, tmpSibling, elementUtils = new ElementUtils(dom);
	
	      // Check if next/prev exists and that they are elements
	      if (prev && next) {
	        // If previous sibling is empty then jump over it
	        prev = findElementSibling(prev, 'previousSibling');
	        next = findElementSibling(next, 'nextSibling');
	
	        // Compare next and previous nodes
	        if (elementUtils.compare(prev, next)) {
	          // Append nodes between
	          for (sibling = prev.nextSibling; sibling && sibling !== next;) {
	            tmpSibling = sibling;
	            sibling = sibling.nextSibling;
	            prev.appendChild(tmpSibling);
	          }
	
	          dom.remove(next);
	
	          Tools.each(Tools.grep(next.childNodes), function (node) {
	            prev.appendChild(node);
	          });
	
	          return prev;
	        }
	      }
	
	      return next;
	    };
	
	    var processChildElements = function (node, filter, process) {
	      each(node.childNodes, function (node) {
	        if (isElementNode(node)) {
	          if (filter(node)) {
	            process(node);
	          }
	          if (node.hasChildNodes()) {
	            processChildElements(node, filter, process);
	          }
	        }
	      });
	    };
	
	    var hasStyle = function (dom, name) {
	      return Fun.curry(function (name, node) {
	        return !!(node && FormatUtils.getStyle(dom, node, name));
	      }, name);
	    };
	
	    var applyStyle = function (dom, name, value) {
	      return Fun.curry(function (name, value, node) {
	        dom.setStyle(node, name, value);
	
	        if (node.getAttribute('style') === '') {
	          node.removeAttribute('style');
	        }
	
	        unwrapEmptySpan(dom, node);
	      }, name, value);
	    };
	
	    var unwrapEmptySpan = function (dom, node) {
	      if (node.nodeName === 'SPAN' && dom.getAttribs(node).length === 0) {
	        dom.remove(node, true);
	      }
	    };
	
	    var processUnderlineAndColor = function (dom, node) {
	      var textDecoration;
	      if (node.nodeType === 1 && node.parentNode && node.parentNode.nodeType === 1) {
	        textDecoration = FormatUtils.getTextDecoration(dom, node.parentNode);
	        if (dom.getStyle(node, 'color') && textDecoration) {
	          dom.setStyle(node, 'text-decoration', textDecoration);
	        } else if (dom.getStyle(node, 'text-decoration') === textDecoration) {
	          dom.setStyle(node, 'text-decoration', null);
	        }
	      }
	    };
	
	    var mergeUnderlineAndColor = function (dom, format, vars, node) {
	      // Colored nodes should be underlined so that the color of the underline matches the text color.
	      if (format.styles.color || format.styles.textDecoration) {
	        Tools.walk(node, Fun.curry(processUnderlineAndColor, dom), 'childNodes');
	        processUnderlineAndColor(dom, node);
	      }
	    };
	
	    var mergeBackgroundColorAndFontSize = function (dom, format, vars, node) {
	      // nodes with font-size should have their own background color as well to fit the line-height (see TINY-882)
	      if (format.styles && format.styles.backgroundColor) {
	        processChildElements(node,
	          hasStyle(dom, 'fontSize'),
	          applyStyle(dom, 'backgroundColor', FormatUtils.replaceVars(format.styles.backgroundColor, vars))
	        );
	      }
	    };
	
	    var mergeSubSup = function (dom, format, vars, node) {
	      // Remove font size on all chilren of a sub/sup and remove the inverse element
	      if (format.inline === 'sub' || format.inline === 'sup') {
	        processChildElements(node,
	          hasStyle(dom, 'fontSize'),
	          applyStyle(dom, 'fontSize', '')
	        );
	
	        dom.remove(dom.select(format.inline === 'sup' ? 'sub' : 'sup', node), true);
	      }
	    };
	
	    var mergeSiblings = function (dom, format, vars, node) {
	      // Merge next and previous siblings if they are similar <b>text</b><b>text</b> becomes <b>texttext</b>
	      if (node && format.merge_siblings !== false) {
	        node = mergeSiblingsNodes(dom, FormatUtils.getNonWhiteSpaceSibling(node), node);
	        node = mergeSiblingsNodes(dom, node, FormatUtils.getNonWhiteSpaceSibling(node, true));
	      }
	    };
	
	    var clearChildStyles = function (dom, format, node) {
	      if (format.clear_child_styles) {
	        var selector = format.links ? '*:not(a)' : '*';
	        each(dom.select(selector, node), function (node) {
	          if (isElementNode(node)) {
	            each(format.styles, function (value, name) {
	              dom.setStyle(node, name, '');
	            });
	          }
	        });
	      }
	    };
	
	    var mergeWithChildren = function (editor, formatList, vars, node) {
	      // Remove/merge children
	      each(formatList, function (format) {
	        // Merge all children of similar type will move styles from child to parent
	        // this: <span style="color:red"><b><span style="color:red; font-size:10px">text</span></b></span>
	        // will become: <span style="color:red"><b><span style="font-size:10px">text</span></b></span>
	        each(editor.dom.select(format.inline, node), function (child) {
	          if (!isElementNode(child)) {
	            return;
	          }
	
	          RemoveFormat.removeFormat(editor, format, vars, child, format.exact ? child : null);
	        });
	
	        clearChildStyles(editor.dom, format, node);
	      });
	    };
	
	    var mergeWithParents = function (editor, format, name, vars, node) {
	      // Remove format if direct parent already has the same format
	      if (MatchFormat.matchNode(editor, node.parentNode, name, vars)) {
	        if (RemoveFormat.removeFormat(editor, format, vars, node)) {
	          return;
	        }
	      }
	
	      // Remove format if any ancestor already has the same format
	      if (format.merge_with_parents) {
	        editor.dom.getParent(node.parentNode, function (parent) {
	          if (MatchFormat.matchNode(editor, parent, name, vars)) {
	            RemoveFormat.removeFormat(editor, format, vars, node);
	            return true;
	          }
	        });
	      }
	    };
	
	    return {
	      mergeWithChildren: mergeWithChildren,
	      mergeUnderlineAndColor: mergeUnderlineAndColor,
	      mergeBackgroundColorAndFontSize: mergeBackgroundColorAndFontSize,
	      mergeSubSup: mergeSubSup,
	      mergeSiblings: mergeSiblings,
	      mergeWithParents: mergeWithParents
	    };
	  }
	);
	/**
	 * ApplyFormat.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.ApplyFormat',
	  [
	    'tinymce.core.dom.Bookmarks',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.fmt.CaretFormat',
	    'tinymce.core.fmt.ExpandRange',
	    'tinymce.core.fmt.FormatUtils',
	    'tinymce.core.fmt.Hooks',
	    'tinymce.core.fmt.MatchFormat',
	    'tinymce.core.fmt.MergeFormats',
	    'tinymce.core.selection.RangeNormalizer',
	    'tinymce.core.selection.RangeWalk',
	    'tinymce.core.util.Tools'
	  ],
	  function (Bookmarks, NodeType, CaretFormat, ExpandRange, FormatUtils, Hooks, MatchFormat, MergeFormats, RangeNormalizer, RangeWalk, Tools) {
	    var each = Tools.each;
	
	    var isElementNode = function (node) {
	      return node && node.nodeType === 1 && !Bookmarks.isBookmarkNode(node) && !CaretFormat.isCaretNode(node) && !NodeType.isBogus(node);
	    };
	
	    var processChildElements = function (node, filter, process) {
	      each(node.childNodes, function (node) {
	        if (isElementNode(node)) {
	          if (filter(node)) {
	            process(node);
	          }
	          if (node.hasChildNodes()) {
	            processChildElements(node, filter, process);
	          }
	        }
	      });
	    };
	
	    var applyFormat = function (ed, name, vars, node) {
	      var formatList = ed.formatter.get(name), format = formatList[0], bookmark, rng, isCollapsed = !node && ed.selection.isCollapsed();
	      var dom = ed.dom, selection = ed.selection;
	
	      var setElementFormat = function (elm, fmt) {
	        fmt = fmt || format;
	
	        if (elm) {
	          if (fmt.onformat) {
	            fmt.onformat(elm, fmt, vars, node);
	          }
	
	          each(fmt.styles, function (value, name) {
	            dom.setStyle(elm, name, FormatUtils.replaceVars(value, vars));
	          });
	
	          // Needed for the WebKit span spam bug
	          // TODO: Remove this once WebKit/Blink fixes this
	          if (fmt.styles) {
	            var styleVal = dom.getAttrib(elm, 'style');
	
	            if (styleVal) {
	              elm.setAttribute('data-mce-style', styleVal);
	            }
	          }
	
	          each(fmt.attributes, function (value, name) {
	            dom.setAttrib(elm, name, FormatUtils.replaceVars(value, vars));
	          });
	
	          each(fmt.classes, function (value) {
	            value = FormatUtils.replaceVars(value, vars);
	
	            if (!dom.hasClass(elm, value)) {
	              dom.addClass(elm, value);
	            }
	          });
	        }
	      };
	
	      var applyNodeStyle = function (formatList, node) {
	        var found = false;
	
	        if (!format.selector) {
	          return false;
	        }
	
	        // Look for matching formats
	        each(formatList, function (format) {
	          // Check collapsed state if it exists
	          if ('collapsed' in format && format.collapsed !== isCollapsed) {
	            return;
	          }
	
	          if (dom.is(node, format.selector) && !CaretFormat.isCaretNode(node)) {
	            setElementFormat(node, format);
	            found = true;
	            return false;
	          }
	        });
	
	        return found;
	      };
	
	      var applyRngStyle = function (dom, rng, bookmark, nodeSpecific) {
	        var newWrappers = [], wrapName, wrapElm, contentEditable = true;
	
	        // Setup wrapper element
	        wrapName = format.inline || format.block;
	        wrapElm = dom.create(wrapName);
	        setElementFormat(wrapElm);
	
	        RangeWalk.walk(dom, rng, function (nodes) {
	          var currentWrapElm;
	
	          /**
	           * Process a list of nodes wrap them.
	           */
	          var process = function (node) {
	            var nodeName, parentName, hasContentEditableState, lastContentEditable;
	
	            lastContentEditable = contentEditable;
	            nodeName = node.nodeName.toLowerCase();
	            parentName = node.parentNode.nodeName.toLowerCase();
	
	            // Node has a contentEditable value
	            if (node.nodeType === 1 && dom.getContentEditable(node)) {
	              lastContentEditable = contentEditable;
	              contentEditable = dom.getContentEditable(node) === "true";
	              hasContentEditableState = true; // We don't want to wrap the container only it's children
	            }
	
	            // Stop wrapping on br elements
	            if (FormatUtils.isEq(nodeName, 'br')) {
	              currentWrapElm = 0;
	
	              // Remove any br elements when we wrap things
	              if (format.block) {
	                dom.remove(node);
	              }
	
	              return;
	            }
	
	            // If node is wrapper type
	            if (format.wrapper && MatchFormat.matchNode(ed, node, name, vars)) {
	              currentWrapElm = 0;
	              return;
	            }
	
	            // Can we rename the block
	            // TODO: Break this if up, too complex
	            if (contentEditable && !hasContentEditableState && format.block &&
	              !format.wrapper && FormatUtils.isTextBlock(ed, nodeName) && FormatUtils.isValid(ed, parentName, wrapName)) {
	              node = dom.rename(node, wrapName);
	              setElementFormat(node);
	              newWrappers.push(node);
	              currentWrapElm = 0;
	              return;
	            }
	
	            // Handle selector patterns
	            if (format.selector) {
	              var found = applyNodeStyle(formatList, node);
	
	              // Continue processing if a selector match wasn't found and a inline element is defined
	              if (!format.inline || found) {
	                currentWrapElm = 0;
	                return;
	              }
	            }
	
	            // Is it valid to wrap this item
	            // TODO: Break this if up, too complex
	            if (contentEditable && !hasContentEditableState && FormatUtils.isValid(ed, wrapName, nodeName) && FormatUtils.isValid(ed, parentName, wrapName) &&
	              !(!nodeSpecific && node.nodeType === 3 &&
	                node.nodeValue.length === 1 &&
	                node.nodeValue.charCodeAt(0) === 65279) &&
	              !CaretFormat.isCaretNode(node) &&
	              (!format.inline || !dom.isBlock(node))) {
	              // Start wrapping
	              if (!currentWrapElm) {
	                // Wrap the node
	                currentWrapElm = dom.clone(wrapElm, false);
	                node.parentNode.insertBefore(currentWrapElm, node);
	                newWrappers.push(currentWrapElm);
	              }
	
	              currentWrapElm.appendChild(node);
	            } else {
	              // Start a new wrapper for possible children
	              currentWrapElm = 0;
	
	              each(Tools.grep(node.childNodes), process);
	
	              if (hasContentEditableState) {
	                contentEditable = lastContentEditable; // Restore last contentEditable state from stack
	              }
	
	              // End the last wrapper
	              currentWrapElm = 0;
	            }
	          };
	
	          // Process siblings from range
	          each(nodes, process);
	        });
	
	        // Apply formats to links as well to get the color of the underline to change as well
	        if (format.links === true) {
	          each(newWrappers, function (node) {
	            var process = function (node) {
	              if (node.nodeName === 'A') {
	                setElementFormat(node, format);
	              }
	
	              each(Tools.grep(node.childNodes), process);
	            };
	
	            process(node);
	          });
	        }
	
	        // Cleanup
	        each(newWrappers, function (node) {
	          var childCount;
	
	          var getChildCount = function (node) {
	            var count = 0;
	
	            each(node.childNodes, function (node) {
	              if (!FormatUtils.isWhiteSpaceNode(node) && !Bookmarks.isBookmarkNode(node)) {
	                count++;
	              }
	            });
	
	            return count;
	          };
	
	          var getChildElementNode = function (root) {
	            var child = false;
	            each(root.childNodes, function (node) {
	              if (isElementNode(node)) {
	                child = node;
	                return false; // break loop
	              }
	            });
	            return child;
	          };
	
	          var mergeStyles = function (node) {
	            var child, clone;
	
	            child = getChildElementNode(node);
	
	            // If child was found and of the same type as the current node
	            if (child && !Bookmarks.isBookmarkNode(child) && MatchFormat.matchName(dom, child, format)) {
	              clone = dom.clone(child, false);
	              setElementFormat(clone);
	
	              dom.replace(clone, node, true);
	              dom.remove(child, 1);
	            }
	
	            return clone || node;
	          };
	
	          childCount = getChildCount(node);
	
	          // Remove empty nodes but only if there is multiple wrappers and they are not block
	          // elements so never remove single <h1></h1> since that would remove the
	          // current empty block element where the caret is at
	          if ((newWrappers.length > 1 || !dom.isBlock(node)) && childCount === 0) {
	            dom.remove(node, 1);
	            return;
	          }
	
	          if (format.inline || format.wrapper) {
	            // Merges the current node with it's children of similar type to reduce the number of elements
	            if (!format.exact && childCount === 1) {
	              node = mergeStyles(node);
	            }
	
	            MergeFormats.mergeWithChildren(ed, formatList, vars, node);
	            MergeFormats.mergeWithParents(ed, format, name, vars, node);
	            MergeFormats.mergeBackgroundColorAndFontSize(dom, format, vars, node);
	            MergeFormats.mergeSubSup(dom, format, vars, node);
	            MergeFormats.mergeSiblings(dom, format, vars, node);
	          }
	        });
	      };
	
	      if (dom.getContentEditable(selection.getNode()) === "false") {
	        node = selection.getNode();
	        for (var i = 0, l = formatList.length; i < l; i++) {
	          if (formatList[i].ceFalseOverride && dom.is(node, formatList[i].selector)) {
	            setElementFormat(node, formatList[i]);
	            return;
	          }
	        }
	
	        return;
	      }
	
	      if (format) {
	        if (node) {
	          if (node.nodeType) {
	            if (!applyNodeStyle(formatList, node)) {
	              rng = dom.createRng();
	              rng.setStartBefore(node);
	              rng.setEndAfter(node);
	              applyRngStyle(dom, ExpandRange.expandRng(ed, rng, formatList), null, true);
	            }
	          } else {
	            applyRngStyle(dom, node, null, true);
	          }
	        } else {
	          if (!isCollapsed || !format.inline || dom.select('td[data-mce-selected],th[data-mce-selected]').length) {
	            // Obtain selection node before selection is unselected by applyRngStyle
	            var curSelNode = ed.selection.getNode();
	
	            // If the formats have a default block and we can't find a parent block then
	            // start wrapping it with a DIV this is for forced_root_blocks: false
	            // It's kind of a hack but people should be using the default block type P since all desktop editors work that way
	            if (!ed.settings.forced_root_block && formatList[0].defaultBlock && !dom.getParent(curSelNode, dom.isBlock)) {
	              applyFormat(ed, formatList[0].defaultBlock);
	            }
	
	            // Apply formatting to selection
	            ed.selection.setRng(RangeNormalizer.normalize(ed.selection.getRng()));
	            bookmark = selection.getBookmark();
	            applyRngStyle(dom, ExpandRange.expandRng(ed, selection.getRng(true), formatList), bookmark);
	
	            if (format.styles) {
	              MergeFormats.mergeUnderlineAndColor(dom, format, vars, curSelNode);
	            }
	
	            selection.moveToBookmark(bookmark);
	            FormatUtils.moveStart(dom, selection, selection.getRng(true));
	            ed.nodeChanged();
	          } else {
	            CaretFormat.applyCaretFormat(ed, name, vars);
	          }
	        }
	
	        Hooks.postProcess(name, ed);
	      }
	    };
	
	    return {
	      applyFormat: applyFormat
	    };
	  }
	);
	/**
	 * FormatChanged.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.FormatChanged',
	  [
	    'ephox.katamari.api.Cell',
	    'tinymce.core.fmt.FormatUtils',
	    'tinymce.core.fmt.MatchFormat',
	    'tinymce.core.util.Tools'
	  ],
	  function (Cell, FormatUtils, MatchFormat, Tools) {
	    var each = Tools.each;
	
	    var setup = function (formatChangeData, editor) {
	      var currentFormats = {};
	
	      formatChangeData.set({});
	
	      editor.on('NodeChange', function (e) {
	        var parents = FormatUtils.getParents(editor.dom, e.element), matchedFormats = {};
	
	        // Ignore bogus nodes like the <a> tag created by moveStart()
	        parents = Tools.grep(parents, function (node) {
	          return node.nodeType === 1 && !node.getAttribute('data-mce-bogus');
	        });
	
	        // Check for new formats
	        each(formatChangeData.get(), function (callbacks, format) {
	          each(parents, function (node) {
	            if (editor.formatter.matchNode(node, format, {}, callbacks.similar)) {
	              if (!currentFormats[format]) {
	                // Execute callbacks
	                each(callbacks, function (callback) {
	                  callback(true, { node: node, format: format, parents: parents });
	                });
	
	                currentFormats[format] = callbacks;
	              }
	
	              matchedFormats[format] = callbacks;
	              return false;
	            }
	
	            if (MatchFormat.matchesUnInheritedFormatSelector(editor, node, format)) {
	              return false;
	            }
	          });
	        });
	
	        // Check if current formats still match
	        each(currentFormats, function (callbacks, format) {
	          if (!matchedFormats[format]) {
	            delete currentFormats[format];
	
	            each(callbacks, function (callback) {
	              callback(false, { node: e.element, format: format, parents: parents });
	            });
	          }
	        });
	      });
	    };
	
	    var addListeners = function (formatChangeData, formats, callback, similar) {
	      var formatChangeItems = formatChangeData.get();
	
	      each(formats.split(','), function (format) {
	        if (!formatChangeItems[format]) {
	          formatChangeItems[format] = [];
	          formatChangeItems[format].similar = similar;
	        }
	
	        formatChangeItems[format].push(callback);
	      });
	
	      formatChangeData.set(formatChangeItems);
	    };
	
	    var formatChanged = function (editor, formatChangeState, formats, callback, similar) {
	      if (formatChangeState.get() === null) {
	        setup(formatChangeState, editor);
	      }
	
	      addListeners(formatChangeState, formats, callback, similar);
	    };
	
	    return {
	      formatChanged: formatChanged
	    };
	  }
	);
	/**
	 * DefaultFormats.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.DefaultFormats',
	  [
	    'tinymce.core.util.Tools'
	  ],
	  function (Tools) {
	    var get = function (dom) {
	      var formats = {
	        valigntop: [
	          { selector: 'td,th', styles: { 'verticalAlign': 'top' } }
	        ],
	
	        valignmiddle: [
	          { selector: 'td,th', styles: { 'verticalAlign': 'middle' } }
	        ],
	
	        valignbottom: [
	          { selector: 'td,th', styles: { 'verticalAlign': 'bottom' } }
	        ],
	
	        alignleft: [
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-left',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: {
	              textAlign: 'left'
	            },
	            inherit: false,
	            preview: false,
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'img,table',
	            collapsed: false,
	            styles: {
	              'float': 'left'
	            },
	            preview: 'font-family font-size'
	          }
	        ],
	
	        aligncenter: [
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: {
	              textAlign: 'center'
	            },
	            inherit: false,
	            preview: 'font-family font-size',
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-center',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'img',
	            collapsed: false,
	            styles: {
	              display: 'block',
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            },
	            preview: false
	          },
	          {
	            selector: 'table',
	            collapsed: false,
	            styles: {
	              marginLeft: 'auto',
	              marginRight: 'auto'
	            },
	            preview: 'font-family font-size'
	          }
	        ],
	
	        alignright: [
	          {
	            selector: 'figure.image',
	            collapsed: false,
	            classes: 'align-right',
	            ceFalseOverride: true,
	            preview: 'font-family font-size'
	          },
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: {
	              textAlign: 'right'
	            },
	            inherit: false,
	            preview: 'font-family font-size',
	            defaultBlock: 'div'
	          },
	          {
	            selector: 'img,table',
	            collapsed: false,
	            styles: {
	              'float': 'right'
	            },
	            preview: 'font-family font-size'
	          }
	        ],
	
	        alignjustify: [
	          {
	            selector: 'figure,p,h1,h2,h3,h4,h5,h6,td,th,tr,div,ul,ol,li',
	            styles: {
	              textAlign: 'justify'
	            },
	            inherit: false,
	            defaultBlock: 'div',
	            preview: 'font-family font-size'
	          }
	        ],
	
	        bold: [
	          { inline: 'strong', remove: 'all' },
	          { inline: 'span', styles: { fontWeight: 'bold' } },
	          { inline: 'b', remove: 'all' }
	        ],
	
	        italic: [
	          { inline: 'em', remove: 'all' },
	          { inline: 'span', styles: { fontStyle: 'italic' } },
	          { inline: 'i', remove: 'all' }
	        ],
	
	        underline: [
	          { inline: 'span', styles: { textDecoration: 'underline' }, exact: true },
	          { inline: 'u', remove: 'all' }
	        ],
	
	        strikethrough: [
	          { inline: 'span', styles: { textDecoration: 'line-through' }, exact: true },
	          { inline: 'strike', remove: 'all' }
	        ],
	
	        forecolor: { inline: 'span', styles: { color: '%value' }, links: true, remove_similar: true, clear_child_styles: true },
	        hilitecolor: { inline: 'span', styles: { backgroundColor: '%value' }, links: true, remove_similar: true, clear_child_styles: true },
	        fontname: { inline: 'span', styles: { fontFamily: '%value' }, clear_child_styles: true },
	        fontsize: { inline: 'span', styles: { fontSize: '%value' }, clear_child_styles: true },
	        fontsize_class: { inline: 'span', attributes: { 'class': '%value' } },
	        blockquote: { block: 'blockquote', wrapper: 1, remove: 'all' },
	        subscript: { inline: 'sub' },
	        superscript: { inline: 'sup' },
	        code: { inline: 'code' },
	
	        link: {
	          inline: 'a', selector: 'a', remove: 'all', split: true, deep: true,
	          onmatch: function () {
	            return true;
	          },
	
	          onformat: function (elm, fmt, vars) {
	            Tools.each(vars, function (value, key) {
	              dom.setAttrib(elm, key, value);
	            });
	          }
	        },
	
	        removeformat: [
	          {
	            selector: 'b,strong,em,i,font,u,strike,sub,sup,dfn,code,samp,kbd,var,cite,mark,q,del,ins',
	            remove: 'all',
	            split: true,
	            expand: false,
	            block_expand: true,
	            deep: true
	          },
	          { selector: 'span', attributes: ['style', 'class'], remove: 'empty', split: true, expand: false, deep: true },
	          { selector: '*', attributes: ['style', 'class'], split: false, expand: false, deep: true }
	        ]
	      };
	
	      Tools.each('p h1 h2 h3 h4 h5 h6 div address pre div dt dd samp'.split(/\s/), function (name) {
	        formats[name] = { block: name, remove: 'all' };
	      });
	
	      return formats;
	    };
	
	    return {
	      get: get
	    };
	  }
	);
	/**
	 * FormatRegistry.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.FormatRegistry',
	  [
	    'tinymce.core.fmt.DefaultFormats',
	    'tinymce.core.util.Tools'
	  ],
	  function (DefaultFormats, Tools) {
	    return function (editor) {
	      var formats = {};
	
	      var get = function (name) {
	        return name ? formats[name] : formats;
	      };
	
	      var register = function (name, format) {
	        if (name) {
	          if (typeof name !== 'string') {
	            Tools.each(name, function (format, name) {
	              register(name, format);
	            });
	          } else {
	            // Force format into array and add it to internal collection
	            format = format.length ? format : [format];
	
	            Tools.each(format, function (format) {
	              // Set deep to false by default on selector formats this to avoid removing
	              // alignment on images inside paragraphs when alignment is changed on paragraphs
	              if (typeof format.deep === 'undefined') {
	                format.deep = !format.selector;
	              }
	
	              // Default to true
	              if (typeof format.split === 'undefined') {
	                format.split = !format.selector || format.inline;
	              }
	
	              // Default to true
	              if (typeof format.remove === 'undefined' && format.selector && !format.inline) {
	                format.remove = 'none';
	              }
	
	              // Mark format as a mixed format inline + block level
	              if (format.selector && format.inline) {
	                format.mixed = true;
	                format.block_expand = true;
	              }
	
	              // Split classes if needed
	              if (typeof format.classes === 'string') {
	                format.classes = format.classes.split(/\s+/);
	              }
	            });
	
	            formats[name] = format;
	          }
	        }
	      };
	
	      var unregister = function (name) {
	        if (name && formats[name]) {
	          delete formats[name];
	        }
	
	        return formats;
	      };
	
	      register(DefaultFormats.get(editor.dom));
	      register(editor.settings.formats);
	
	      return {
	        get: get,
	        register: register,
	        unregister: unregister
	      };
	    };
	  }
	);
	
	/**
	 * Preview.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Internal class for generating previews styles for formats.
	 *
	 * Example:
	 *  Preview.getCssText(editor, 'bold');
	 *
	 * @private
	 * @class tinymce.fmt.Preview
	 */
	define(
	  'tinymce.core.fmt.Preview',
	  [
	    "tinymce.core.dom.DOMUtils",
	    "tinymce.core.util.Tools",
	    "tinymce.core.html.Schema"
	  ],
	  function (DOMUtils, Tools, Schema) {
	    var each = Tools.each;
	    var dom = DOMUtils.DOM;
	
	    var parsedSelectorToHtml = function (ancestry, editor) {
	      var elm, item, fragment;
	      var schema = editor && editor.schema || new Schema({});
	
	      var decorate = function (elm, item) {
	        if (item.classes.length) {
	          dom.addClass(elm, item.classes.join(' '));
	        }
	        dom.setAttribs(elm, item.attrs);
	      };
	
	      var createElement = function (sItem) {
	        var elm;
	
	        item = typeof sItem === 'string' ? {
	          name: sItem,
	          classes: [],
	          attrs: {}
	        } : sItem;
	
	        elm = dom.create(item.name);
	        decorate(elm, item);
	        return elm;
	      };
	
	      var getRequiredParent = function (elm, candidate) {
	        var name = typeof elm !== 'string' ? elm.nodeName.toLowerCase() : elm;
	        var elmRule = schema.getElementRule(name);
	        var parentsRequired = elmRule && elmRule.parentsRequired;
	
	        if (parentsRequired && parentsRequired.length) {
	          return candidate && Tools.inArray(parentsRequired, candidate) !== -1 ? candidate : parentsRequired[0];
	        } else {
	          return false;
	        }
	      };
	
	      var wrapInHtml = function (elm, ancestry, siblings) {
	        var parent, parentCandidate, parentRequired;
	        var ancestor = ancestry.length > 0 && ancestry[0];
	        var ancestorName = ancestor && ancestor.name;
	
	        parentRequired = getRequiredParent(elm, ancestorName);
	
	        if (parentRequired) {
	          if (ancestorName === parentRequired) {
	            parentCandidate = ancestry[0];
	            ancestry = ancestry.slice(1);
	          } else {
	            parentCandidate = parentRequired;
	          }
	        } else if (ancestor) {
	          parentCandidate = ancestry[0];
	          ancestry = ancestry.slice(1);
	        } else if (!siblings) {
	          return elm;
	        }
	
	        if (parentCandidate) {
	          parent = createElement(parentCandidate);
	          parent.appendChild(elm);
	        }
	
	        if (siblings) {
	          if (!parent) {
	            // if no more ancestry, wrap in generic div
	            parent = dom.create('div');
	            parent.appendChild(elm);
	          }
	
	          Tools.each(siblings, function (sibling) {
	            var siblingElm = createElement(sibling);
	            parent.insertBefore(siblingElm, elm);
	          });
	        }
	
	        return wrapInHtml(parent, ancestry, parentCandidate && parentCandidate.siblings);
	      };
	
	      if (ancestry && ancestry.length) {
	        item = ancestry[0];
	        elm = createElement(item);
	        fragment = dom.create('div');
	        fragment.appendChild(wrapInHtml(elm, ancestry.slice(1), item.siblings));
	        return fragment;
	      } else {
	        return '';
	      }
	    };
	
	    var selectorToHtml = function (selector, editor) {
	      return parsedSelectorToHtml(parseSelector(selector), editor);
	    };
	
	    var parseSelectorItem = function (item) {
	      var tagName;
	      var obj = {
	        classes: [],
	        attrs: {}
	      };
	
	      item = obj.selector = Tools.trim(item);
	
	      if (item !== '*') {
	        // matching IDs, CLASSes, ATTRIBUTES and PSEUDOs
	        tagName = item.replace(/(?:([#\.]|::?)([\w\-]+)|(\[)([^\]]+)\]?)/g, function ($0, $1, $2, $3, $4) {
	          switch ($1) {
	            case '#':
	              obj.attrs.id = $2;
	              break;
	
	            case '.':
	              obj.classes.push($2);
	              break;
	
	            case ':':
	              if (Tools.inArray('checked disabled enabled read-only required'.split(' '), $2) !== -1) {
	                obj.attrs[$2] = $2;
	              }
	              break;
	          }
	
	          // atribute matched
	          if ($3 === '[') {
	            var m = $4.match(/([\w\-]+)(?:\=\"([^\"]+))?/);
	            if (m) {
	              obj.attrs[m[1]] = m[2];
	            }
	          }
	
	          return '';
	        });
	      }
	
	      obj.name = tagName || 'div';
	      return obj;
	    };
	
	    var parseSelector = function (selector) {
	      if (!selector || typeof selector !== 'string') {
	        return [];
	      }
	
	      // take into account only first one
	      selector = selector.split(/\s*,\s*/)[0];
	
	      // tighten
	      selector = selector.replace(/\s*(~\+|~|\+|>)\s*/g, '$1');
	
	      // split either on > or on space, but not the one inside brackets
	      return Tools.map(selector.split(/(?:>|\s+(?![^\[\]]+\]))/), function (item) {
	        // process each sibling selector separately
	        var siblings = Tools.map(item.split(/(?:~\+|~|\+)/), parseSelectorItem);
	        var obj = siblings.pop(); // the last one is our real target
	
	        if (siblings.length) {
	          obj.siblings = siblings;
	        }
	        return obj;
	      }).reverse();
	    };
	
	    var getCssText = function (editor, format) {
	      var name, previewFrag, previewElm, items;
	      var previewCss = '', parentFontSize, previewStyles;
	
	      previewStyles = editor.settings.preview_styles;
	
	      // No preview forced
	      if (previewStyles === false) {
	        return '';
	      }
	
	      // Default preview
	      if (typeof previewStyles !== 'string') {
	        previewStyles = 'font-family font-size font-weight font-style text-decoration ' +
	          'text-transform color background-color border border-radius outline text-shadow';
	      }
	
	      // Removes any variables since these can't be previewed
	      var removeVars = function (val) {
	        return val.replace(/%(\w+)/g, '');
	      };
	
	      // Create block/inline element to use for preview
	      if (typeof format === "string") {
	        format = editor.formatter.get(format);
	        if (!format) {
	          return;
	        }
	
	        format = format[0];
	      }
	
	      // Format specific preview override
	      // TODO: This should probably be further reduced by the previewStyles option
	      if ('preview' in format) {
	        previewStyles = format.preview;
	        if (previewStyles === false) {
	          return '';
	        }
	      }
	
	      name = format.block || format.inline || 'span';
	
	      items = parseSelector(format.selector);
	      if (items.length) {
	        if (!items[0].name) { // e.g. something like ul > .someClass was provided
	          items[0].name = name;
	        }
	        name = format.selector;
	        previewFrag = parsedSelectorToHtml(items, editor);
	      } else {
	        previewFrag = parsedSelectorToHtml([name], editor);
	      }
	
	      previewElm = dom.select(name, previewFrag)[0] || previewFrag.firstChild;
	
	      // Add format styles to preview element
	      each(format.styles, function (value, name) {
	        value = removeVars(value);
	
	        if (value) {
	          dom.setStyle(previewElm, name, value);
	        }
	      });
	
	      // Add attributes to preview element
	      each(format.attributes, function (value, name) {
	        value = removeVars(value);
	
	        if (value) {
	          dom.setAttrib(previewElm, name, value);
	        }
	      });
	
	      // Add classes to preview element
	      each(format.classes, function (value) {
	        value = removeVars(value);
	
	        if (!dom.hasClass(previewElm, value)) {
	          dom.addClass(previewElm, value);
	        }
	      });
	
	      editor.fire('PreviewFormats');
	
	      // Add the previewElm outside the visual area
	      dom.setStyles(previewFrag, { position: 'absolute', left: -0xFFFF });
	      editor.getBody().appendChild(previewFrag);
	
	      // Get parent container font size so we can compute px values out of em/% for older IE:s
	      parentFontSize = dom.getStyle(editor.getBody(), 'fontSize', true);
	      parentFontSize = /px$/.test(parentFontSize) ? parseInt(parentFontSize, 10) : 0;
	
	      each(previewStyles.split(' '), function (name) {
	        var value = dom.getStyle(previewElm, name, true);
	
	        // If background is transparent then check if the body has a background color we can use
	        if (name === 'background-color' && /transparent|rgba\s*\([^)]+,\s*0\)/.test(value)) {
	          value = dom.getStyle(editor.getBody(), name, true);
	
	          // Ignore white since it's the default color, not the nicest fix
	          // TODO: Fix this by detecting runtime style
	          if (dom.toHex(value).toLowerCase() === '#ffffff') {
	            return;
	          }
	        }
	
	        if (name === 'color') {
	          // Ignore black since it's the default color, not the nicest fix
	          // TODO: Fix this by detecting runtime style
	          if (dom.toHex(value).toLowerCase() === '#000000') {
	            return;
	          }
	        }
	
	        // Old IE won't calculate the font size so we need to do that manually
	        if (name === 'font-size') {
	          if (/em|%$/.test(value)) {
	            if (parentFontSize === 0) {
	              return;
	            }
	
	            // Convert font size from em/% to px
	            value = parseFloat(value, 10) / (/%$/.test(value) ? 100 : 1);
	            value = (value * parentFontSize) + 'px';
	          }
	        }
	
	        if (name === "border" && value) {
	          previewCss += 'padding:0 2px;';
	        }
	
	        previewCss += name + ':' + value + ';';
	      });
	
	      editor.fire('AfterPreviewFormats');
	
	      //previewCss += 'line-height:normal';
	
	      dom.remove(previewFrag);
	
	      return previewCss;
	    };
	
	    return {
	      getCssText: getCssText,
	      parseSelector: parseSelector,
	      selectorToHtml: selectorToHtml
	    };
	  }
	);
	
	/**
	 * ToggleFormat.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.fmt.ToggleFormat',
	  [
	    'tinymce.core.fmt.ApplyFormat',
	    'tinymce.core.fmt.MatchFormat',
	    'tinymce.core.fmt.RemoveFormat'
	  ],
	  function (ApplyFormat, MatchFormat, RemoveFormat) {
	    var toggle = function (editor, formats, name, vars, node) {
	      var fmt = formats.get(name);
	
	      if (MatchFormat.match(editor, name, vars, node) && (!('toggle' in fmt[0]) || fmt[0].toggle)) {
	        RemoveFormat.remove(editor, name, vars, node);
	      } else {
	        ApplyFormat.applyFormat(editor, name, vars, node);
	      }
	    };
	
	    return {
	      toggle: toggle
	    };
	  }
	);
	
	/**
	 * FormatShortcuts.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.FormatShortcuts',
	  [
	  ],
	  function () {
	    var setup = function (editor) {
	      // Add some inline shortcuts
	      editor.addShortcut('meta+b', '', 'Bold');
	      editor.addShortcut('meta+i', '', 'Italic');
	      editor.addShortcut('meta+u', '', 'Underline');
	
	      // BlockFormat shortcuts keys
	      for (var i = 1; i <= 6; i++) {
	        editor.addShortcut('access+' + i, '', ['FormatBlock', false, 'h' + i]);
	      }
	
	      editor.addShortcut('access+7', '', ['FormatBlock', false, 'p']);
	      editor.addShortcut('access+8', '', ['FormatBlock', false, 'div']);
	      editor.addShortcut('access+9', '', ['FormatBlock', false, 'address']);
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	/**
	 * Formatter.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Text formatter engine class. This class is used to apply formats like bold, italic, font size
	 * etc to the current selection or specific nodes. This engine was built to replace the browser's
	 * default formatting logic for execCommand due to its inconsistent and buggy behavior.
	 *
	 * @class tinymce.Formatter
	 * @example
	 *  tinymce.activeEditor.formatter.register('mycustomformat', {
	 *    inline: 'span',
	 *    styles: {color: '#ff0000'}
	 *  });
	 *
	 *  tinymce.activeEditor.formatter.apply('mycustomformat');
	 */
	define(
	  'tinymce.core.api.Formatter',
	  [
	    'ephox.katamari.api.Cell',
	    'ephox.katamari.api.Fun',
	    'tinymce.core.fmt.ApplyFormat',
	    'tinymce.core.fmt.CaretFormat',
	    'tinymce.core.fmt.FormatChanged',
	    'tinymce.core.fmt.FormatRegistry',
	    'tinymce.core.fmt.MatchFormat',
	    'tinymce.core.fmt.Preview',
	    'tinymce.core.fmt.RemoveFormat',
	    'tinymce.core.fmt.ToggleFormat',
	    'tinymce.core.keyboard.FormatShortcuts'
	  ],
	  function (Cell, Fun, ApplyFormat, CaretFormat, FormatChanged, FormatRegistry, MatchFormat, Preview, RemoveFormat, ToggleFormat, FormatShortcuts) {
	    /**
	     * Constructs a new formatter instance.
	     *
	     * @constructor Formatter
	     * @param {tinymce.Editor} ed Editor instance to construct the formatter engine to.
	     */
	    return function (editor) {
	      var formats = FormatRegistry(editor);
	      var formatChangeState = Cell(null);
	
	      FormatShortcuts.setup(editor);
	      CaretFormat.setup(editor);
	
	      return {
	        /**
	         * Returns the format by name or all formats if no name is specified.
	         *
	         * @method get
	         * @param {String} name Optional name to retrieve by.
	         * @return {Array/Object} Array/Object with all registered formats or a specific format.
	         */
	        get: formats.get,
	
	        /**
	         * Registers a specific format by name.
	         *
	         * @method register
	         * @param {Object/String} name Name of the format for example "bold".
	         * @param {Object/Array} format Optional format object or array of format variants
	         * can only be omitted if the first arg is an object.
	         */
	        register: formats.register,
	
	        /**
	         * Unregister a specific format by name.
	         *
	         * @method unregister
	         * @param {String} name Name of the format for example "bold".
	         */
	        unregister: formats.unregister,
	
	        /**
	         * Applies the specified format to the current selection or specified node.
	         *
	         * @method apply
	         * @param {String} name Name of format to apply.
	         * @param {Object} vars Optional list of variables to replace within format before applying it.
	         * @param {Node} node Optional node to apply the format to defaults to current selection.
	         */
	        apply: Fun.curry(ApplyFormat.applyFormat, editor),
	
	        /**
	         * Removes the specified format from the current selection or specified node.
	         *
	         * @method remove
	         * @param {String} name Name of format to remove.
	         * @param {Object} vars Optional list of variables to replace within format before removing it.
	         * @param {Node/Range} node Optional node or DOM range to remove the format from defaults to current selection.
	         */
	        remove: Fun.curry(RemoveFormat.remove, editor),
	
	        /**
	         * Toggles the specified format on/off.
	         *
	         * @method toggle
	         * @param {String} name Name of format to apply/remove.
	         * @param {Object} vars Optional list of variables to replace within format before applying/removing it.
	         * @param {Node} node Optional node to apply the format to or remove from. Defaults to current selection.
	         */
	        toggle: Fun.curry(ToggleFormat.toggle, editor, formats),
	
	        /**
	         * Matches the current selection or specified node against the specified format name.
	         *
	         * @method match
	         * @param {String} name Name of format to match.
	         * @param {Object} vars Optional list of variables to replace before checking it.
	         * @param {Node} node Optional node to check.
	         * @return {boolean} true/false if the specified selection/node matches the format.
	         */
	        match: Fun.curry(MatchFormat.match, editor),
	
	        /**
	         * Matches the current selection against the array of formats and returns a new array with matching formats.
	         *
	         * @method matchAll
	         * @param {Array} names Name of format to match.
	         * @param {Object} vars Optional list of variables to replace before checking it.
	         * @return {Array} Array with matched formats.
	         */
	        matchAll: Fun.curry(MatchFormat.matchAll, editor),
	
	        /**
	         * Return true/false if the specified node has the specified format.
	         *
	         * @method matchNode
	         * @param {Node} node Node to check the format on.
	         * @param {String} name Format name to check.
	         * @param {Object} vars Optional list of variables to replace before checking it.
	         * @param {Boolean} similar Match format that has similar properties.
	         * @return {Object} Returns the format object it matches or undefined if it doesn't match.
	         */
	        matchNode: Fun.curry(MatchFormat.matchNode, editor),
	
	        /**
	         * Returns true/false if the specified format can be applied to the current selection or not. It
	         * will currently only check the state for selector formats, it returns true on all other format types.
	         *
	         * @method canApply
	         * @param {String} name Name of format to check.
	         * @return {boolean} true/false if the specified format can be applied to the current selection/node.
	         */
	        canApply: Fun.curry(MatchFormat.canApply, editor),
	
	        /**
	         * Executes the specified callback when the current selection matches the formats or not.
	         *
	         * @method formatChanged
	         * @param {String} formats Comma separated list of formats to check for.
	         * @param {function} callback Callback with state and args when the format is changed/toggled on/off.
	         * @param {Boolean} similar True/false state if the match should handle similar or exact formats.
	         */
	        formatChanged: Fun.curry(FormatChanged.formatChanged, editor, formatChangeState),
	
	        /**
	         * Returns a preview css text for the specified format.
	         *
	         * @method getCssText
	         * @param {String/Object} format Format to generate preview css text for.
	         * @return {String} Css text for the specified format.
	         * @example
	         * var cssText1 = editor.formatter.getCssText('bold');
	         * var cssText2 = editor.formatter.getCssText({inline: 'b'});
	         */
	        getCssText: Fun.curry(Preview.getCssText, editor)
	      };
	    };
	  }
	);
	
	define(
	  'ephox.katamari.api.Merger',
	
	  [
	    'ephox.katamari.api.Type',
	    'global!Array',
	    'global!Error'
	  ],
	
	  function (Type, Array, Error) {
	
	    var shallow = function (old, nu) {
	      return nu;
	    };
	
	    var deep = function (old, nu) {
	      var bothObjects = Type.isObject(old) && Type.isObject(nu);
	      return bothObjects ? deepMerge(old, nu) : nu;
	    };
	
	    var baseMerge = function (merger) {
	      return function() {
	        // Don't use array slice(arguments), makes the whole function unoptimisable on Chrome
	        var objects = new Array(arguments.length);
	        for (var i = 0; i < objects.length; i++) objects[i] = arguments[i];
	
	        if (objects.length === 0) throw new Error('Can\'t merge zero objects');
	
	        var ret = {};
	        for (var j = 0; j < objects.length; j++) {
	          var curObject = objects[j];
	          for (var key in curObject) if (curObject.hasOwnProperty(key)) {
	            ret[key] = merger(ret[key], curObject[key]);
	          }
	        }
	        return ret;
	      };
	    };
	
	    var deepMerge = baseMerge(deep);
	    var merge = baseMerge(shallow);
	
	    return {
	      deepMerge: deepMerge,
	      merge: merge
	    };
	  }
	);
	/**
	 * Events.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.api.Events',
	  [
	  ],
	  function () {
	    var firePreProcess = function (editor, args) {
	      return editor.fire('PreProcess', args);
	    };
	
	    var firePostProcess = function (editor, args) {
	      return editor.fire('PostProcess', args);
	    };
	
	    return {
	      firePreProcess: firePreProcess,
	      firePostProcess: firePostProcess
	    };
	  }
	);
	
	/**
	 * DomSerializerFilters.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DomSerializerFilters',
	  [
	    'ephox.katamari.api.Arr',
	    'tinymce.core.html.Entities'
	  ],
	  function (Arr, Entities) {
	    var register = function (htmlParser, settings, dom) {
	      // Convert tabindex back to elements when serializing contents
	      htmlParser.addAttributeFilter('data-mce-tabindex', function (nodes, name) {
	        var i = nodes.length, node;
	
	        while (i--) {
	          node = nodes[i];
	          node.attr('tabindex', node.attributes.map['data-mce-tabindex']);
	          node.attr(name, null);
	        }
	      });
	
	      // Convert move data-mce-src, data-mce-href and data-mce-style into nodes or process them if needed
	      htmlParser.addAttributeFilter('src,href,style', function (nodes, name) {
	        var i = nodes.length, node, value, internalName = 'data-mce-' + name;
	        var urlConverter = settings.url_converter, urlConverterScope = settings.url_converter_scope, undef;
	
	        while (i--) {
	          node = nodes[i];
	
	          value = node.attributes.map[internalName];
	          if (value !== undef) {
	            // Set external name to internal value and remove internal
	            node.attr(name, value.length > 0 ? value : null);
	            node.attr(internalName, null);
	          } else {
	            // No internal attribute found then convert the value we have in the DOM
	            value = node.attributes.map[name];
	
	            if (name === "style") {
	              value = dom.serializeStyle(dom.parseStyle(value), node.name);
	            } else if (urlConverter) {
	              value = urlConverter.call(urlConverterScope, value, name, node.name);
	            }
	
	            node.attr(name, value.length > 0 ? value : null);
	          }
	        }
	      });
	
	      // Remove internal classes mceItem<..> or mceSelected
	      htmlParser.addAttributeFilter('class', function (nodes) {
	        var i = nodes.length, node, value;
	
	        while (i--) {
	          node = nodes[i];
	          value = node.attr('class');
	
	          if (value) {
	            value = node.attr('class').replace(/(?:^|\s)mce-item-\w+(?!\S)/g, '');
	            node.attr('class', value.length > 0 ? value : null);
	          }
	        }
	      });
	
	      // Remove bookmark elements
	      htmlParser.addAttributeFilter('data-mce-type', function (nodes, name, args) {
	        var i = nodes.length, node;
	
	        while (i--) {
	          node = nodes[i];
	
	          if (node.attributes.map['data-mce-type'] === 'bookmark' && !args.cleanup) {
	            node.remove();
	          }
	        }
	      });
	
	      htmlParser.addNodeFilter('noscript', function (nodes) {
	        var i = nodes.length, node;
	
	        while (i--) {
	          node = nodes[i].firstChild;
	
	          if (node) {
	            node.value = Entities.decode(node.value);
	          }
	        }
	      });
	
	      // Force script into CDATA sections and remove the mce- prefix also add comments around styles
	      htmlParser.addNodeFilter('script,style', function (nodes, name) {
	        var i = nodes.length, node, value, type;
	
	        var trim = function (value) {
	          /*jshint maxlen:255 */
	          /*eslint max-len:0 */
	          return value.replace(/(<!--\[CDATA\[|\]\]-->)/g, '\n')
	            .replace(/^[\r\n]*|[\r\n]*$/g, '')
	            .replace(/^\s*((<!--)?(\s*\/\/)?\s*<!\[CDATA\[|(<!--\s*)?\/\*\s*<!\[CDATA\[\s*\*\/|(\/\/)?\s*<!--|\/\*\s*<!--\s*\*\/)\s*[\r\n]*/gi, '')
	            .replace(/\s*(\/\*\s*\]\]>\s*\*\/(-->)?|\s*\/\/\s*\]\]>(-->)?|\/\/\s*(-->)?|\]\]>|\/\*\s*-->\s*\*\/|\s*-->\s*)\s*$/g, '');
	        };
	
	        while (i--) {
	          node = nodes[i];
	          value = node.firstChild ? node.firstChild.value : '';
	
	          if (name === "script") {
	            // Remove mce- prefix from script elements and remove default type since the user specified
	            // a script element without type attribute
	            type = node.attr('type');
	            if (type) {
	              node.attr('type', type === 'mce-no/type' ? null : type.replace(/^mce\-/, ''));
	            }
	
	            if (settings.element_format === 'xhtml' && value.length > 0) {
	              node.firstChild.value = '// <![CDATA[\n' + trim(value) + '\n// ]]>';
	            }
	          } else {
	            if (settings.element_format === 'xhtml' && value.length > 0) {
	              node.firstChild.value = '<!--\n' + trim(value) + '\n-->';
	            }
	          }
	        }
	      });
	
	      // Convert comments to cdata and handle protected comments
	      htmlParser.addNodeFilter('#comment', function (nodes) {
	        var i = nodes.length, node;
	
	        while (i--) {
	          node = nodes[i];
	
	          if (node.value.indexOf('[CDATA[') === 0) {
	            node.name = '#cdata';
	            node.type = 4;
	            node.value = node.value.replace(/^\[CDATA\[|\]\]$/g, '');
	          } else if (node.value.indexOf('mce:protected ') === 0) {
	            node.name = "#text";
	            node.type = 3;
	            node.raw = true;
	            node.value = unescape(node.value).substr(14);
	          }
	        }
	      });
	
	      htmlParser.addNodeFilter('xml:namespace,input', function (nodes, name) {
	        var i = nodes.length, node;
	
	        while (i--) {
	          node = nodes[i];
	          if (node.type === 7) {
	            node.remove();
	          } else if (node.type === 1) {
	            if (name === "input" && !("type" in node.attributes.map)) {
	              node.attr('type', 'text');
	            }
	          }
	        }
	      });
	
	      htmlParser.addAttributeFilter('data-mce-type', function (nodes) {
	        Arr.each(nodes, function (node) {
	          if (node.attr('data-mce-type') === 'format-caret') {
	            if (node.isEmpty(htmlParser.schema.getNonEmptyElements())) {
	              node.remove();
	            } else {
	              node.unwrap();
	            }
	          }
	        });
	      });
	
	      // Remove internal data attributes
	      htmlParser.addAttributeFilter(
	        'data-mce-src,data-mce-href,data-mce-style,' +
	        'data-mce-selected,data-mce-expando,' +
	        'data-mce-type,data-mce-resize',
	
	        function (nodes, name) {
	          var i = nodes.length;
	
	          while (i--) {
	            nodes[i].attr(name, null);
	          }
	        }
	      );
	    };
	
	    /**
	     * IE 11 has a fantastic bug where it will produce two trailing BR elements to iframe bodies when
	     * the iframe is hidden by display: none on a parent container. The DOM is actually out of sync
	     * with innerHTML in this case. It's like IE adds shadow DOM BR elements that appears on innerHTML
	     * but not as the lastChild of the body. So this fix simply removes the last two
	     * BR elements at the end of the document.
	     *
	     * Example of what happens: <body>text</body> becomes <body>text<br><br></body>
	     */
	    var trimTrailingBr = function (rootNode) {
	      var brNode1, brNode2;
	
	      var isBr = function (node) {
	        return node && node.name === 'br';
	      };
	
	      brNode1 = rootNode.lastChild;
	      if (isBr(brNode1)) {
	        brNode2 = brNode1.prev;
	
	        if (isBr(brNode2)) {
	          brNode1.remove();
	          brNode2.remove();
	        }
	      }
	    };
	
	    return {
	      register: register,
	      trimTrailingBr: trimTrailingBr
	    };
	  }
	);
	
	/**
	 * DomSerializerPreProcess.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DomSerializerPreProcess',
	  [
	    'ephox.katamari.api.Merger',
	    'global!document',
	    'tinymce.core.api.Events',
	    'tinymce.core.util.Tools'
	  ],
	  function (Merger, document, Events, Tools) {
	    var preProcess = function (editor, node, args) {
	      var impl, doc, oldDoc;
	      var dom = editor.dom;
	
	      node = node.cloneNode(true);
	
	      // Nodes needs to be attached to something in WebKit/Opera
	      // This fix will make DOM ranges and make Sizzle happy!
	      impl = document.implementation;
	      if (impl.createHTMLDocument) {
	        // Create an empty HTML document
	        doc = impl.createHTMLDocument('');
	
	        // Add the element or it's children if it's a body element to the new document
	        Tools.each(node.nodeName === 'BODY' ? node.childNodes : [node], function (node) {
	          doc.body.appendChild(doc.importNode(node, true));
	        });
	
	        // Grab first child or body element for serialization
	        if (node.nodeName !== 'BODY') {
	          node = doc.body.firstChild;
	        } else {
	          node = doc.body;
	        }
	
	        // set the new document in DOMUtils so createElement etc works
	        oldDoc = dom.doc;
	        dom.doc = doc;
	      }
	
	      Events.firePreProcess(editor, Merger.merge(args, { node: node }));
	
	      if (oldDoc) {
	        dom.doc = oldDoc;
	      }
	
	      return node;
	    };
	
	    var shouldFireEvent = function (editor, args) {
	      return editor && editor.hasEventListeners('PreProcess') && !args.no_events;
	    };
	
	    var process = function (editor, node, args) {
	      return shouldFireEvent(editor, args) ? preProcess(editor, node, args) : node;
	    };
	
	    return {
	      process: process
	    };
	  }
	);
	
	/**
	 * LegacyFilter.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.html.LegacyFilter',
	  [
	    'ephox.katamari.api.Arr',
	    'tinymce.core.html.Styles',
	    'tinymce.core.util.Tools'
	  ],
	  function (Arr, Styles, Tools) {
	    var removeAttrs = function (node, names) {
	      Arr.each(names, function (name) {
	        node.attr(name, null);
	      });
	    };
	
	    var addFontToSpansFilter = function (domParser, styles, fontSizes) {
	      domParser.addNodeFilter('font', function (nodes) {
	        Arr.each(nodes, function (node) {
	          var props = styles.parse(node.attr('style'));
	          var color = node.attr('color');
	          var face = node.attr('face');
	          var size = node.attr('size');
	
	          if (color) {
	            props.color = color;
	          }
	
	          if (face) {
	            props['font-family'] = face;
	          }
	
	          if (size) {
	            props['font-size'] = fontSizes[parseInt(node.attr('size'), 10) - 1];
	          }
	
	          node.name = 'span';
	          node.attr('style', styles.serialize(props));
	          removeAttrs(node, ['color', 'face', 'size']);
	        });
	      });
	    };
	
	    var addStrikeToSpanFilter = function (domParser, styles) {
	      domParser.addNodeFilter('strike', function (nodes) {
	        Arr.each(nodes, function (node) {
	          var props = styles.parse(node.attr('style'));
	
	          props['text-decoration'] = 'line-through';
	
	          node.name = 'span';
	          node.attr('style', styles.serialize(props));
	        });
	      });
	    };
	
	    var addFilters = function (domParser, settings) {
	      var styles = Styles();
	
	      if (settings.convert_fonts_to_spans) {
	        addFontToSpansFilter(domParser, styles, Tools.explode(settings.font_size_legacy_values));
	      }
	
	      addStrikeToSpanFilter(domParser, styles);
	    };
	
	    var register = function (domParser, settings) {
	      if (settings.inline_styles) {
	        addFilters(domParser, settings);
	      }
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	/**
	 * Node.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is a minimalistic implementation of a DOM like node used by the DomParser class.
	 *
	 * @example
	 * var node = new tinymce.html.Node('strong', 1);
	 * someRoot.append(node);
	 *
	 * @class tinymce.html.Node
	 * @version 3.4
	 */
	define(
	  'tinymce.core.html.Node',
	  [
	  ],
	  function () {
	    var whiteSpaceRegExp = /^[ \t\r\n]*$/;
	    var typeLookup = {
	      '#text': 3,
	      '#comment': 8,
	      '#cdata': 4,
	      '#pi': 7,
	      '#doctype': 10,
	      '#document-fragment': 11
	    };
	
	    // Walks the tree left/right
	    var walk = function (node, rootNode, prev) {
	      var sibling, parent, startName = prev ? 'lastChild' : 'firstChild', siblingName = prev ? 'prev' : 'next';
	
	      // Walk into nodes if it has a start
	      if (node[startName]) {
	        return node[startName];
	      }
	
	      // Return the sibling if it has one
	      if (node !== rootNode) {
	        sibling = node[siblingName];
	
	        if (sibling) {
	          return sibling;
	        }
	
	        // Walk up the parents to look for siblings
	        for (parent = node.parent; parent && parent !== rootNode; parent = parent.parent) {
	          sibling = parent[siblingName];
	
	          if (sibling) {
	            return sibling;
	          }
	        }
	      }
	    };
	
	    /**
	     * Constructs a new Node instance.
	     *
	     * @constructor
	     * @method Node
	     * @param {String} name Name of the node type.
	     * @param {Number} type Numeric type representing the node.
	     */
	    var Node = function (name, type) {
	      this.name = name;
	      this.type = type;
	
	      if (type === 1) {
	        this.attributes = [];
	        this.attributes.map = {};
	      }
	    };
	
	    Node.prototype = {
	      /**
	       * Replaces the current node with the specified one.
	       *
	       * @example
	       * someNode.replace(someNewNode);
	       *
	       * @method replace
	       * @param {tinymce.html.Node} node Node to replace the current node with.
	       * @return {tinymce.html.Node} The old node that got replaced.
	       */
	      replace: function (node) {
	        var self = this;
	
	        if (node.parent) {
	          node.remove();
	        }
	
	        self.insert(node, self);
	        self.remove();
	
	        return self;
	      },
	
	      /**
	       * Gets/sets or removes an attribute by name.
	       *
	       * @example
	       * someNode.attr("name", "value"); // Sets an attribute
	       * console.log(someNode.attr("name")); // Gets an attribute
	       * someNode.attr("name", null); // Removes an attribute
	       *
	       * @method attr
	       * @param {String} name Attribute name to set or get.
	       * @param {String} value Optional value to set.
	       * @return {String/tinymce.html.Node} String or undefined on a get operation or the current node on a set operation.
	       */
	      attr: function (name, value) {
	        var self = this, attrs, i, undef;
	
	        if (typeof name !== "string") {
	          for (i in name) {
	            self.attr(i, name[i]);
	          }
	
	          return self;
	        }
	
	        if ((attrs = self.attributes)) {
	          if (value !== undef) {
	            // Remove attribute
	            if (value === null) {
	              if (name in attrs.map) {
	                delete attrs.map[name];
	
	                i = attrs.length;
	                while (i--) {
	                  if (attrs[i].name === name) {
	                    attrs = attrs.splice(i, 1);
	                    return self;
	                  }
	                }
	              }
	
	              return self;
	            }
	
	            // Set attribute
	            if (name in attrs.map) {
	              // Set attribute
	              i = attrs.length;
	              while (i--) {
	                if (attrs[i].name === name) {
	                  attrs[i].value = value;
	                  break;
	                }
	              }
	            } else {
	              attrs.push({ name: name, value: value });
	            }
	
	            attrs.map[name] = value;
	
	            return self;
	          }
	
	          return attrs.map[name];
	        }
	      },
	
	      /**
	       * Does a shallow clones the node into a new node. It will also exclude id attributes since
	       * there should only be one id per document.
	       *
	       * @example
	       * var clonedNode = node.clone();
	       *
	       * @method clone
	       * @return {tinymce.html.Node} New copy of the original node.
	       */
	      clone: function () {
	        var self = this, clone = new Node(self.name, self.type), i, l, selfAttrs, selfAttr, cloneAttrs;
	
	        // Clone element attributes
	        if ((selfAttrs = self.attributes)) {
	          cloneAttrs = [];
	          cloneAttrs.map = {};
	
	          for (i = 0, l = selfAttrs.length; i < l; i++) {
	            selfAttr = selfAttrs[i];
	
	            // Clone everything except id
	            if (selfAttr.name !== 'id') {
	              cloneAttrs[cloneAttrs.length] = { name: selfAttr.name, value: selfAttr.value };
	              cloneAttrs.map[selfAttr.name] = selfAttr.value;
	            }
	          }
	
	          clone.attributes = cloneAttrs;
	        }
	
	        clone.value = self.value;
	        clone.shortEnded = self.shortEnded;
	
	        return clone;
	      },
	
	      /**
	       * Wraps the node in in another node.
	       *
	       * @example
	       * node.wrap(wrapperNode);
	       *
	       * @method wrap
	       */
	      wrap: function (wrapper) {
	        var self = this;
	
	        self.parent.insert(wrapper, self);
	        wrapper.append(self);
	
	        return self;
	      },
	
	      /**
	       * Unwraps the node in other words it removes the node but keeps the children.
	       *
	       * @example
	       * node.unwrap();
	       *
	       * @method unwrap
	       */
	      unwrap: function () {
	        var self = this, node, next;
	
	        for (node = self.firstChild; node;) {
	          next = node.next;
	          self.insert(node, self, true);
	          node = next;
	        }
	
	        self.remove();
	      },
	
	      /**
	       * Removes the node from it's parent.
	       *
	       * @example
	       * node.remove();
	       *
	       * @method remove
	       * @return {tinymce.html.Node} Current node that got removed.
	       */
	      remove: function () {
	        var self = this, parent = self.parent, next = self.next, prev = self.prev;
	
	        if (parent) {
	          if (parent.firstChild === self) {
	            parent.firstChild = next;
	
	            if (next) {
	              next.prev = null;
	            }
	          } else {
	            prev.next = next;
	          }
	
	          if (parent.lastChild === self) {
	            parent.lastChild = prev;
	
	            if (prev) {
	              prev.next = null;
	            }
	          } else {
	            next.prev = prev;
	          }
	
	          self.parent = self.next = self.prev = null;
	        }
	
	        return self;
	      },
	
	      /**
	       * Appends a new node as a child of the current node.
	       *
	       * @example
	       * node.append(someNode);
	       *
	       * @method append
	       * @param {tinymce.html.Node} node Node to append as a child of the current one.
	       * @return {tinymce.html.Node} The node that got appended.
	       */
	      append: function (node) {
	        var self = this, last;
	
	        if (node.parent) {
	          node.remove();
	        }
	
	        last = self.lastChild;
	        if (last) {
	          last.next = node;
	          node.prev = last;
	          self.lastChild = node;
	        } else {
	          self.lastChild = self.firstChild = node;
	        }
	
	        node.parent = self;
	
	        return node;
	      },
	
	      /**
	       * Inserts a node at a specific position as a child of the current node.
	       *
	       * @example
	       * parentNode.insert(newChildNode, oldChildNode);
	       *
	       * @method insert
	       * @param {tinymce.html.Node} node Node to insert as a child of the current node.
	       * @param {tinymce.html.Node} refNode Reference node to set node before/after.
	       * @param {Boolean} before Optional state to insert the node before the reference node.
	       * @return {tinymce.html.Node} The node that got inserted.
	       */
	      insert: function (node, refNode, before) {
	        var parent;
	
	        if (node.parent) {
	          node.remove();
	        }
	
	        parent = refNode.parent || this;
	
	        if (before) {
	          if (refNode === parent.firstChild) {
	            parent.firstChild = node;
	          } else {
	            refNode.prev.next = node;
	          }
	
	          node.prev = refNode.prev;
	          node.next = refNode;
	          refNode.prev = node;
	        } else {
	          if (refNode === parent.lastChild) {
	            parent.lastChild = node;
	          } else {
	            refNode.next.prev = node;
	          }
	
	          node.next = refNode.next;
	          node.prev = refNode;
	          refNode.next = node;
	        }
	
	        node.parent = parent;
	
	        return node;
	      },
	
	      /**
	       * Get all children by name.
	       *
	       * @method getAll
	       * @param {String} name Name of the child nodes to collect.
	       * @return {Array} Array with child nodes matchin the specified name.
	       */
	      getAll: function (name) {
	        var self = this, node, collection = [];
	
	        for (node = self.firstChild; node; node = walk(node, self)) {
	          if (node.name === name) {
	            collection.push(node);
	          }
	        }
	
	        return collection;
	      },
	
	      /**
	       * Removes all children of the current node.
	       *
	       * @method empty
	       * @return {tinymce.html.Node} The current node that got cleared.
	       */
	      empty: function () {
	        var self = this, nodes, i, node;
	
	        // Remove all children
	        if (self.firstChild) {
	          nodes = [];
	
	          // Collect the children
	          for (node = self.firstChild; node; node = walk(node, self)) {
	            nodes.push(node);
	          }
	
	          // Remove the children
	          i = nodes.length;
	          while (i--) {
	            node = nodes[i];
	            node.parent = node.firstChild = node.lastChild = node.next = node.prev = null;
	          }
	        }
	
	        self.firstChild = self.lastChild = null;
	
	        return self;
	      },
	
	      /**
	       * Returns true/false if the node is to be considered empty or not.
	       *
	       * @example
	       * node.isEmpty({img: true});
	       * @method isEmpty
	       * @param {Object} elements Name/value object with elements that are automatically treated as non empty elements.
	       * @param {Object} whitespace Name/value object with elements that are automatically treated whitespace preservables.
	       * @param {function} predicate Optional predicate that gets called after the other rules determine that the node is empty. Should return true if the node is a content node.
	       * @return {Boolean} true/false if the node is empty or not.
	       */
	      isEmpty: function (elements, whitespace, predicate) {
	        var self = this, node = self.firstChild, i, name;
	
	        whitespace = whitespace || {};
	
	        if (node) {
	          do {
	            if (node.type === 1) {
	              // Ignore bogus elements
	              if (node.attributes.map['data-mce-bogus']) {
	                continue;
	              }
	
	              // Keep empty elements like <img />
	              if (elements[node.name]) {
	                return false;
	              }
	
	              // Keep bookmark nodes and name attribute like <a name="1"></a>
	              i = node.attributes.length;
	              while (i--) {
	                name = node.attributes[i].name;
	                if (name === "name" || name.indexOf('data-mce-bookmark') === 0) {
	                  return false;
	                }
	              }
	            }
	
	            // Keep comments
	            if (node.type === 8) {
	              return false;
	            }
	
	            // Keep non whitespace text nodes
	            if (node.type === 3 && !whiteSpaceRegExp.test(node.value)) {
	              return false;
	            }
	
	            // Keep whitespace preserve elements
	            if (node.type === 3 && node.parent && whitespace[node.parent.name] && whiteSpaceRegExp.test(node.value)) {
	              return false;
	            }
	
	            // Predicate tells that the node is contents
	            if (predicate && predicate(node)) {
	              return false;
	            }
	          } while ((node = walk(node, self)));
	        }
	
	        return true;
	      },
	
	      /**
	       * Walks to the next or previous node and returns that node or null if it wasn't found.
	       *
	       * @method walk
	       * @param {Boolean} prev Optional previous node state defaults to false.
	       * @return {tinymce.html.Node} Node that is next to or previous of the current node.
	       */
	      walk: function (prev) {
	        return walk(this, null, prev);
	      }
	    };
	
	    /**
	     * Creates a node of a specific type.
	     *
	     * @static
	     * @method create
	     * @param {String} name Name of the node type to create for example "b" or "#text".
	     * @param {Object} attrs Name/value collection of attributes that will be applied to elements.
	     */
	    Node.create = function (name, attrs) {
	      var node, attrName;
	
	      // Create node
	      node = new Node(name, typeLookup[name] || 1);
	
	      // Add attributes if needed
	      if (attrs) {
	        for (attrName in attrs) {
	          node.attr(attrName, attrs[attrName]);
	        }
	      }
	
	      return node;
	    };
	
	    return Node;
	  }
	);
	/**
	 * DomParser.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class parses HTML code into a DOM like structure of nodes it will remove redundant whitespace and make
	 * sure that the node tree is valid according to the specified schema.
	 * So for example: <p>a<p>b</p>c</p> will become <p>a</p><p>b</p><p>c</p>
	 *
	 * @example
	 * var parser = new tinymce.html.DomParser({validate: true}, schema);
	 * var rootNode = parser.parse('<h1>content</h1>');
	 *
	 * @class tinymce.html.DomParser
	 * @version 3.4
	 */
	define(
	  'tinymce.core.html.DomParser',
	  [
	    'tinymce.core.html.LegacyFilter',
	    'tinymce.core.html.Node',
	    'tinymce.core.html.SaxParser',
	    'tinymce.core.html.Schema',
	    'tinymce.core.util.Tools'
	  ],
	  function (LegacyFilter, Node, SaxParser, Schema, Tools) {
	    var makeMap = Tools.makeMap, each = Tools.each, explode = Tools.explode, extend = Tools.extend;
	
	    var paddEmptyNode = function (settings, args, blockElements, node) {
	      var brPreferred = settings.padd_empty_with_br || args.insert;
	
	      if (brPreferred && blockElements[node.name]) {
	        node.empty().append(new Node('br', '1')).shortEnded = true;
	      } else {
	        node.empty().append(new Node('#text', '3')).value = '\u00a0';
	      }
	    };
	
	    var isPaddedWithNbsp = function (node) {
	      return hasOnlyChild(node, '#text') && node.firstChild.value === '\u00a0';
	    };
	
	    var hasOnlyChild = function (node, name) {
	      return node && node.firstChild && node.firstChild === node.lastChild && node.firstChild.name === name;
	    };
	
	    var isPadded = function (schema, node) {
	      var rule = schema.getElementRule(node.name);
	      return rule && rule.paddEmpty;
	    };
	
	    var isEmpty = function (schema, nonEmptyElements, whitespaceElements, node) {
	      return node.isEmpty(nonEmptyElements, whitespaceElements, function (node) {
	        return isPadded(schema, node);
	      });
	    };
	
	    /**
	     * Constructs a new DomParser instance.
	     *
	     * @constructor
	     * @method DomParser
	     * @param {Object} settings Name/value collection of settings. comment, cdata, text, start and end are callbacks.
	     * @param {tinymce.html.Schema} schema HTML Schema class to use when parsing.
	     */
	    return function (settings, schema) {
	      var self = this, nodeFilters = {}, attributeFilters = [], matchedNodes = {}, matchedAttributes = {};
	
	      settings = settings || {};
	      settings.validate = "validate" in settings ? settings.validate : true;
	      settings.root_name = settings.root_name || 'body';
	      self.schema = schema = schema || new Schema();
	
	      var fixInvalidChildren = function (nodes) {
	        var ni, node, parent, parents, newParent, currentNode, tempNode, childNode, i;
	        var nonEmptyElements, whitespaceElements, nonSplitableElements, textBlockElements, specialElements, sibling, nextNode;
	
	        nonSplitableElements = makeMap('tr,td,th,tbody,thead,tfoot,table');
	        nonEmptyElements = schema.getNonEmptyElements();
	        whitespaceElements = schema.getWhiteSpaceElements();
	        textBlockElements = schema.getTextBlockElements();
	        specialElements = schema.getSpecialElements();
	
	        for (ni = 0; ni < nodes.length; ni++) {
	          node = nodes[ni];
	
	          // Already removed or fixed
	          if (!node.parent || node.fixed) {
	            continue;
	          }
	
	          // If the invalid element is a text block and the text block is within a parent LI element
	          // Then unwrap the first text block and convert other sibling text blocks to LI elements similar to Word/Open Office
	          if (textBlockElements[node.name] && node.parent.name == 'li') {
	            // Move sibling text blocks after LI element
	            sibling = node.next;
	            while (sibling) {
	              if (textBlockElements[sibling.name]) {
	                sibling.name = 'li';
	                sibling.fixed = true;
	                node.parent.insert(sibling, node.parent);
	              } else {
	                break;
	              }
	
	              sibling = sibling.next;
	            }
	
	            // Unwrap current text block
	            node.unwrap(node);
	            continue;
	          }
	
	          // Get list of all parent nodes until we find a valid parent to stick the child into
	          parents = [node];
	          for (parent = node.parent; parent && !schema.isValidChild(parent.name, node.name) &&
	            !nonSplitableElements[parent.name]; parent = parent.parent) {
	            parents.push(parent);
	          }
	
	          // Found a suitable parent
	          if (parent && parents.length > 1) {
	            // Reverse the array since it makes looping easier
	            parents.reverse();
	
	            // Clone the related parent and insert that after the moved node
	            newParent = currentNode = self.filterNode(parents[0].clone());
	
	            // Start cloning and moving children on the left side of the target node
	            for (i = 0; i < parents.length - 1; i++) {
	              if (schema.isValidChild(currentNode.name, parents[i].name)) {
	                tempNode = self.filterNode(parents[i].clone());
	                currentNode.append(tempNode);
	              } else {
	                tempNode = currentNode;
	              }
	
	              for (childNode = parents[i].firstChild; childNode && childNode != parents[i + 1];) {
	                nextNode = childNode.next;
	                tempNode.append(childNode);
	                childNode = nextNode;
	              }
	
	              currentNode = tempNode;
	            }
	
	            if (!isEmpty(schema, nonEmptyElements, whitespaceElements, newParent)) {
	              parent.insert(newParent, parents[0], true);
	              parent.insert(node, newParent);
	            } else {
	              parent.insert(node, parents[0], true);
	            }
	
	            // Check if the element is empty by looking through it's contents and special treatment for <p><br /></p>
	            parent = parents[0];
	            if (isEmpty(schema, nonEmptyElements, whitespaceElements, parent) || hasOnlyChild(parent, 'br')) {
	              parent.empty().remove();
	            }
	          } else if (node.parent) {
	            // If it's an LI try to find a UL/OL for it or wrap it
	            if (node.name === 'li') {
	              sibling = node.prev;
	              if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
	                sibling.append(node);
	                continue;
	              }
	
	              sibling = node.next;
	              if (sibling && (sibling.name === 'ul' || sibling.name === 'ul')) {
	                sibling.insert(node, sibling.firstChild, true);
	                continue;
	              }
	
	              node.wrap(self.filterNode(new Node('ul', 1)));
	              continue;
	            }
	
	            // Try wrapping the element in a DIV
	            if (schema.isValidChild(node.parent.name, 'div') && schema.isValidChild('div', node.name)) {
	              node.wrap(self.filterNode(new Node('div', 1)));
	            } else {
	              // We failed wrapping it, then remove or unwrap it
	              if (specialElements[node.name]) {
	                node.empty().remove();
	              } else {
	                node.unwrap();
	              }
	            }
	          }
	        }
	      };
	
	      /**
	       * Runs the specified node though the element and attributes filters.
	       *
	       * @method filterNode
	       * @param {tinymce.html.Node} Node the node to run filters on.
	       * @return {tinymce.html.Node} The passed in node.
	       */
	      self.filterNode = function (node) {
	        var i, name, list;
	
	        // Run element filters
	        if (name in nodeFilters) {
	          list = matchedNodes[name];
	
	          if (list) {
	            list.push(node);
	          } else {
	            matchedNodes[name] = [node];
	          }
	        }
	
	        // Run attribute filters
	        i = attributeFilters.length;
	        while (i--) {
	          name = attributeFilters[i].name;
	
	          if (name in node.attributes.map) {
	            list = matchedAttributes[name];
	
	            if (list) {
	              list.push(node);
	            } else {
	              matchedAttributes[name] = [node];
	            }
	          }
	        }
	
	        return node;
	      };
	
	      /**
	       * Adds a node filter function to the parser, the parser will collect the specified nodes by name
	       * and then execute the callback ones it has finished parsing the document.
	       *
	       * @example
	       * parser.addNodeFilter('p,h1', function(nodes, name) {
	       *  for (var i = 0; i < nodes.length; i++) {
	       *   console.log(nodes[i].name);
	       *  }
	       * });
	       * @method addNodeFilter
	       * @method {String} name Comma separated list of nodes to collect.
	       * @param {function} callback Callback function to execute once it has collected nodes.
	       */
	      self.addNodeFilter = function (name, callback) {
	        each(explode(name), function (name) {
	          var list = nodeFilters[name];
	
	          if (!list) {
	            nodeFilters[name] = list = [];
	          }
	
	          list.push(callback);
	        });
	      };
	
	      /**
	       * Adds a attribute filter function to the parser, the parser will collect nodes that has the specified attributes
	       * and then execute the callback ones it has finished parsing the document.
	       *
	       * @example
	       * parser.addAttributeFilter('src,href', function(nodes, name) {
	       *  for (var i = 0; i < nodes.length; i++) {
	       *   console.log(nodes[i].name);
	       *  }
	       * });
	       * @method addAttributeFilter
	       * @method {String} name Comma separated list of nodes to collect.
	       * @param {function} callback Callback function to execute once it has collected nodes.
	       */
	      self.addAttributeFilter = function (name, callback) {
	        each(explode(name), function (name) {
	          var i;
	
	          for (i = 0; i < attributeFilters.length; i++) {
	            if (attributeFilters[i].name === name) {
	              attributeFilters[i].callbacks.push(callback);
	              return;
	            }
	          }
	
	          attributeFilters.push({ name: name, callbacks: [callback] });
	        });
	      };
	
	      /**
	       * Parses the specified HTML string into a DOM like node tree and returns the result.
	       *
	       * @example
	       * var rootNode = new DomParser({...}).parse('<b>text</b>');
	       * @method parse
	       * @param {String} html Html string to sax parse.
	       * @param {Object} args Optional args object that gets passed to all filter functions.
	       * @return {tinymce.html.Node} Root node containing the tree.
	       */
	      self.parse = function (html, args) {
	        var parser, rootNode, node, nodes, i, l, fi, fl, list, name, validate;
	        var blockElements, startWhiteSpaceRegExp, invalidChildren = [], isInWhiteSpacePreservedElement;
	        var endWhiteSpaceRegExp, allWhiteSpaceRegExp, isAllWhiteSpaceRegExp, whiteSpaceElements;
	        var children, nonEmptyElements, rootBlockName;
	
	        args = args || {};
	        matchedNodes = {};
	        matchedAttributes = {};
	        blockElements = extend(makeMap('script,style,head,html,body,title,meta,param'), schema.getBlockElements());
	        nonEmptyElements = schema.getNonEmptyElements();
	        children = schema.children;
	        validate = settings.validate;
	        rootBlockName = "forced_root_block" in args ? args.forced_root_block : settings.forced_root_block;
	
	        whiteSpaceElements = schema.getWhiteSpaceElements();
	        startWhiteSpaceRegExp = /^[ \t\r\n]+/;
	        endWhiteSpaceRegExp = /[ \t\r\n]+$/;
	        allWhiteSpaceRegExp = /[ \t\r\n]+/g;
	        isAllWhiteSpaceRegExp = /^[ \t\r\n]+$/;
	
	        var addRootBlocks = function () {
	          var node = rootNode.firstChild, next, rootBlockNode;
	
	          // Removes whitespace at beginning and end of block so:
	          // <p> x </p> -> <p>x</p>
	          var trim = function (rootBlockNode) {
	            if (rootBlockNode) {
	              node = rootBlockNode.firstChild;
	              if (node && node.type == 3) {
	                node.value = node.value.replace(startWhiteSpaceRegExp, '');
	              }
	
	              node = rootBlockNode.lastChild;
	              if (node && node.type == 3) {
	                node.value = node.value.replace(endWhiteSpaceRegExp, '');
	              }
	            }
	          };
	
	          // Check if rootBlock is valid within rootNode for example if P is valid in H1 if H1 is the contentEditabe root
	          if (!schema.isValidChild(rootNode.name, rootBlockName.toLowerCase())) {
	            return;
	          }
	
	          while (node) {
	            next = node.next;
	
	            if (node.type == 3 || (node.type == 1 && node.name !== 'p' &&
	              !blockElements[node.name] && !node.attr('data-mce-type'))) {
	              if (!rootBlockNode) {
	                // Create a new root block element
	                rootBlockNode = createNode(rootBlockName, 1);
	                rootBlockNode.attr(settings.forced_root_block_attrs);
	                rootNode.insert(rootBlockNode, node);
	                rootBlockNode.append(node);
	              } else {
	                rootBlockNode.append(node);
	              }
	            } else {
	              trim(rootBlockNode);
	              rootBlockNode = null;
	            }
	
	            node = next;
	          }
	
	          trim(rootBlockNode);
	        };
	
	        var createNode = function (name, type) {
	          var node = new Node(name, type), list;
	
	          if (name in nodeFilters) {
	            list = matchedNodes[name];
	
	            if (list) {
	              list.push(node);
	            } else {
	              matchedNodes[name] = [node];
	            }
	          }
	
	          return node;
	        };
	
	        var removeWhitespaceBefore = function (node) {
	          var textNode, textNodeNext, textVal, sibling, blockElements = schema.getBlockElements();
	
	          for (textNode = node.prev; textNode && textNode.type === 3;) {
	            textVal = textNode.value.replace(endWhiteSpaceRegExp, '');
	
	            // Found a text node with non whitespace then trim that and break
	            if (textVal.length > 0) {
	              textNode.value = textVal;
	              return;
	            }
	
	            textNodeNext = textNode.next;
	
	            // Fix for bug #7543 where bogus nodes would produce empty
	            // text nodes and these would be removed if a nested list was before it
	            if (textNodeNext) {
	              if (textNodeNext.type == 3 && textNodeNext.value.length) {
	                textNode = textNode.prev;
	                continue;
	              }
	
	              if (!blockElements[textNodeNext.name] && textNodeNext.name != 'script' && textNodeNext.name != 'style') {
	                textNode = textNode.prev;
	                continue;
	              }
	            }
	
	            sibling = textNode.prev;
	            textNode.remove();
	            textNode = sibling;
	          }
	        };
	
	        var cloneAndExcludeBlocks = function (input) {
	          var name, output = {};
	
	          for (name in input) {
	            if (name !== 'li' && name != 'p') {
	              output[name] = input[name];
	            }
	          }
	
	          return output;
	        };
	
	        parser = new SaxParser({
	          validate: validate,
	          allow_script_urls: settings.allow_script_urls,
	          allow_conditional_comments: settings.allow_conditional_comments,
	
	          // Exclude P and LI from DOM parsing since it's treated better by the DOM parser
	          self_closing_elements: cloneAndExcludeBlocks(schema.getSelfClosingElements()),
	
	          cdata: function (text) {
	            node.append(createNode('#cdata', 4)).value = text;
	          },
	
	          text: function (text, raw) {
	            var textNode;
	
	            // Trim all redundant whitespace on non white space elements
	            if (!isInWhiteSpacePreservedElement) {
	              text = text.replace(allWhiteSpaceRegExp, ' ');
	
	              if (node.lastChild && blockElements[node.lastChild.name]) {
	                text = text.replace(startWhiteSpaceRegExp, '');
	              }
	            }
	
	            // Do we need to create the node
	            if (text.length !== 0) {
	              textNode = createNode('#text', 3);
	              textNode.raw = !!raw;
	              node.append(textNode).value = text;
	            }
	          },
	
	          comment: function (text) {
	            node.append(createNode('#comment', 8)).value = text;
	          },
	
	          pi: function (name, text) {
	            node.append(createNode(name, 7)).value = text;
	            removeWhitespaceBefore(node);
	          },
	
	          doctype: function (text) {
	            var newNode;
	
	            newNode = node.append(createNode('#doctype', 10));
	            newNode.value = text;
	            removeWhitespaceBefore(node);
	          },
	
	          start: function (name, attrs, empty) {
	            var newNode, attrFiltersLen, elementRule, attrName, parent;
	
	            elementRule = validate ? schema.getElementRule(name) : {};
	            if (elementRule) {
	              newNode = createNode(elementRule.outputName || name, 1);
	              newNode.attributes = attrs;
	              newNode.shortEnded = empty;
	
	              node.append(newNode);
	
	              // Check if node is valid child of the parent node is the child is
	              // unknown we don't collect it since it's probably a custom element
	              parent = children[node.name];
	              if (parent && children[newNode.name] && !parent[newNode.name]) {
	                invalidChildren.push(newNode);
	              }
	
	              attrFiltersLen = attributeFilters.length;
	              while (attrFiltersLen--) {
	                attrName = attributeFilters[attrFiltersLen].name;
	
	                if (attrName in attrs.map) {
	                  list = matchedAttributes[attrName];
	
	                  if (list) {
	                    list.push(newNode);
	                  } else {
	                    matchedAttributes[attrName] = [newNode];
	                  }
	                }
	              }
	
	              // Trim whitespace before block
	              if (blockElements[name]) {
	                removeWhitespaceBefore(newNode);
	              }
	
	              // Change current node if the element wasn't empty i.e not <br /> or <img />
	              if (!empty) {
	                node = newNode;
	              }
	
	              // Check if we are inside a whitespace preserved element
	              if (!isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
	                isInWhiteSpacePreservedElement = true;
	              }
	            }
	          },
	
	          end: function (name) {
	            var textNode, elementRule, text, sibling, tempNode;
	
	            elementRule = validate ? schema.getElementRule(name) : {};
	            if (elementRule) {
	              if (blockElements[name]) {
	                if (!isInWhiteSpacePreservedElement) {
	                  // Trim whitespace of the first node in a block
	                  textNode = node.firstChild;
	                  if (textNode && textNode.type === 3) {
	                    text = textNode.value.replace(startWhiteSpaceRegExp, '');
	
	                    // Any characters left after trim or should we remove it
	                    if (text.length > 0) {
	                      textNode.value = text;
	                      textNode = textNode.next;
	                    } else {
	                      sibling = textNode.next;
	                      textNode.remove();
	                      textNode = sibling;
	
	                      // Remove any pure whitespace siblings
	                      while (textNode && textNode.type === 3) {
	                        text = textNode.value;
	                        sibling = textNode.next;
	
	                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
	                          textNode.remove();
	                          textNode = sibling;
	                        }
	
	                        textNode = sibling;
	                      }
	                    }
	                  }
	
	                  // Trim whitespace of the last node in a block
	                  textNode = node.lastChild;
	                  if (textNode && textNode.type === 3) {
	                    text = textNode.value.replace(endWhiteSpaceRegExp, '');
	
	                    // Any characters left after trim or should we remove it
	                    if (text.length > 0) {
	                      textNode.value = text;
	                      textNode = textNode.prev;
	                    } else {
	                      sibling = textNode.prev;
	                      textNode.remove();
	                      textNode = sibling;
	
	                      // Remove any pure whitespace siblings
	                      while (textNode && textNode.type === 3) {
	                        text = textNode.value;
	                        sibling = textNode.prev;
	
	                        if (text.length === 0 || isAllWhiteSpaceRegExp.test(text)) {
	                          textNode.remove();
	                          textNode = sibling;
	                        }
	
	                        textNode = sibling;
	                      }
	                    }
	                  }
	                }
	
	                // Trim start white space
	                // Removed due to: #5424
	                /*textNode = node.prev;
	                if (textNode && textNode.type === 3) {
	                  text = textNode.value.replace(startWhiteSpaceRegExp, '');
	
	                  if (text.length > 0)
	                    textNode.value = text;
	                  else
	                    textNode.remove();
	                }*/
	              }
	
	              // Check if we exited a whitespace preserved element
	              if (isInWhiteSpacePreservedElement && whiteSpaceElements[name]) {
	                isInWhiteSpacePreservedElement = false;
	              }
	
	              if (elementRule.removeEmpty && isEmpty(schema, nonEmptyElements, whiteSpaceElements, node)) {
	                // Leave nodes that have a name like <a name="name">
	                if (!node.attributes.map.name && !node.attributes.map.id) {
	                  tempNode = node.parent;
	
	                  if (blockElements[node.name]) {
	                    node.empty().remove();
	                  } else {
	                    node.unwrap();
	                  }
	
	                  node = tempNode;
	                  return;
	                }
	              }
	
	              if (elementRule.paddEmpty && (isPaddedWithNbsp(node) || isEmpty(schema, nonEmptyElements, whiteSpaceElements, node))) {
	                paddEmptyNode(settings, args, blockElements, node);
	              }
	
	              node = node.parent;
	            }
	          }
	        }, schema);
	
	        rootNode = node = new Node(args.context || settings.root_name, 11);
	
	        parser.parse(html);
	
	        // Fix invalid children or report invalid children in a contextual parsing
	        if (validate && invalidChildren.length) {
	          if (!args.context) {
	            fixInvalidChildren(invalidChildren);
	          } else {
	            args.invalid = true;
	          }
	        }
	
	        // Wrap nodes in the root into block elements if the root is body
	        if (rootBlockName && (rootNode.name == 'body' || args.isRootContent)) {
	          addRootBlocks();
	        }
	
	        // Run filters only when the contents is valid
	        if (!args.invalid) {
	          // Run node filters
	          for (name in matchedNodes) {
	            list = nodeFilters[name];
	            nodes = matchedNodes[name];
	
	            // Remove already removed children
	            fi = nodes.length;
	            while (fi--) {
	              if (!nodes[fi].parent) {
	                nodes.splice(fi, 1);
	              }
	            }
	
	            for (i = 0, l = list.length; i < l; i++) {
	              list[i](nodes, name, args);
	            }
	          }
	
	          // Run attribute filters
	          for (i = 0, l = attributeFilters.length; i < l; i++) {
	            list = attributeFilters[i];
	
	            if (list.name in matchedAttributes) {
	              nodes = matchedAttributes[list.name];
	
	              // Remove already removed children
	              fi = nodes.length;
	              while (fi--) {
	                if (!nodes[fi].parent) {
	                  nodes.splice(fi, 1);
	                }
	              }
	
	              for (fi = 0, fl = list.callbacks.length; fi < fl; fi++) {
	                list.callbacks[fi](nodes, list.name, args);
	              }
	            }
	          }
	        }
	
	        return rootNode;
	      };
	
	      // Remove <br> at end of block elements Gecko and WebKit injects BR elements to
	      // make it possible to place the caret inside empty blocks. This logic tries to remove
	      // these elements and keep br elements that where intended to be there intact
	      if (settings.remove_trailing_brs) {
	        self.addNodeFilter('br', function (nodes, _, args) {
	          var i, l = nodes.length, node, blockElements = extend({}, schema.getBlockElements());
	          var nonEmptyElements = schema.getNonEmptyElements(), parent, lastParent, prev, prevName;
	          var whiteSpaceElements = schema.getNonEmptyElements();
	          var elementRule, textNode;
	
	          // Remove brs from body element as well
	          blockElements.body = 1;
	
	          // Must loop forwards since it will otherwise remove all brs in <p>a<br><br><br></p>
	          for (i = 0; i < l; i++) {
	            node = nodes[i];
	            parent = node.parent;
	
	            if (blockElements[node.parent.name] && node === parent.lastChild) {
	              // Loop all nodes to the left of the current node and check for other BR elements
	              // excluding bookmarks since they are invisible
	              prev = node.prev;
	              while (prev) {
	                prevName = prev.name;
	
	                // Ignore bookmarks
	                if (prevName !== "span" || prev.attr('data-mce-type') !== 'bookmark') {
	                  // Found a non BR element
	                  if (prevName !== "br") {
	                    break;
	                  }
	
	                  // Found another br it's a <br><br> structure then don't remove anything
	                  if (prevName === 'br') {
	                    node = null;
	                    break;
	                  }
	                }
	
	                prev = prev.prev;
	              }
	
	              if (node) {
	                node.remove();
	
	                // Is the parent to be considered empty after we removed the BR
	                if (isEmpty(schema, nonEmptyElements, whiteSpaceElements, parent)) {
	                  elementRule = schema.getElementRule(parent.name);
	
	                  // Remove or padd the element depending on schema rule
	                  if (elementRule) {
	                    if (elementRule.removeEmpty) {
	                      parent.remove();
	                    } else if (elementRule.paddEmpty) {
	                      paddEmptyNode(settings, args, blockElements, parent);
	                    }
	                  }
	                }
	              }
	            } else {
	              // Replaces BR elements inside inline elements like <p><b><i><br></i></b></p>
	              // so they become <p><b><i>&nbsp;</i></b></p>
	              lastParent = node;
	              while (parent && parent.firstChild === lastParent && parent.lastChild === lastParent) {
	                lastParent = parent;
	
	                if (blockElements[parent.name]) {
	                  break;
	                }
	
	                parent = parent.parent;
	              }
	
	              if (lastParent === parent && settings.padd_empty_with_br !== true) {
	                textNode = new Node('#text', 3);
	                textNode.value = '\u00a0';
	                node.replace(textNode);
	              }
	            }
	          }
	        });
	      }
	
	
	      self.addAttributeFilter('href', function (nodes) {
	        var i = nodes.length, node;
	
	        var appendRel = function (rel) {
	          var parts = rel.split(' ').filter(function (p) {
	            return p.length > 0;
	          });
	          return parts.concat(['noopener']).sort().join(' ');
	        };
	
	        var addNoOpener = function (rel) {
	          var newRel = rel ? Tools.trim(rel) : '';
	          if (!/\b(noopener)\b/g.test(newRel)) {
	            return appendRel(newRel);
	          } else {
	            return newRel;
	          }
	        };
	
	        if (!settings.allow_unsafe_link_target) {
	          while (i--) {
	            node = nodes[i];
	            if (node.name === 'a' && node.attr('target') === '_blank') {
	              node.attr('rel', addNoOpener(node.attr('rel')));
	            }
	          }
	        }
	      });
	
	      // Force anchor names closed, unless the setting "allow_html_in_named_anchor" is explicitly included.
	      if (!settings.allow_html_in_named_anchor) {
	        self.addAttributeFilter('id,name', function (nodes) {
	          var i = nodes.length, sibling, prevSibling, parent, node;
	
	          while (i--) {
	            node = nodes[i];
	            if (node.name === 'a' && node.firstChild && !node.attr('href')) {
	              parent = node.parent;
	
	              // Move children after current node
	              sibling = node.lastChild;
	              do {
	                prevSibling = sibling.prev;
	                parent.insert(sibling, node);
	                sibling = prevSibling;
	              } while (sibling);
	            }
	          }
	        });
	      }
	
	      if (settings.fix_list_elements) {
	        self.addNodeFilter('ul,ol', function (nodes) {
	          var i = nodes.length, node, parentNode;
	
	          while (i--) {
	            node = nodes[i];
	            parentNode = node.parent;
	
	            if (parentNode.name === 'ul' || parentNode.name === 'ol') {
	              if (node.prev && node.prev.name === 'li') {
	                node.prev.append(node);
	              } else {
	                var li = new Node('li', 1);
	                li.attr('style', 'list-style-type: none');
	                node.wrap(li);
	              }
	            }
	          }
	        });
	      }
	
	      if (settings.validate && schema.getValidClasses()) {
	        self.addAttributeFilter('class', function (nodes) {
	          var i = nodes.length, node, classList, ci, className, classValue;
	          var validClasses = schema.getValidClasses(), validClassesMap, valid;
	
	          while (i--) {
	            node = nodes[i];
	            classList = node.attr('class').split(' ');
	            classValue = '';
	
	            for (ci = 0; ci < classList.length; ci++) {
	              className = classList[ci];
	              valid = false;
	
	              validClassesMap = validClasses['*'];
	              if (validClassesMap && validClassesMap[className]) {
	                valid = true;
	              }
	
	              validClassesMap = validClasses[node.name];
	              if (!valid && validClassesMap && validClassesMap[className]) {
	                valid = true;
	              }
	
	              if (valid) {
	                if (classValue) {
	                  classValue += ' ';
	                }
	
	                classValue += className;
	              }
	            }
	
	            if (!classValue.length) {
	              classValue = null;
	            }
	
	            node.attr('class', classValue);
	          }
	        });
	      }
	
	      LegacyFilter.register(this, settings);
	    };
	  }
	);
	/**
	 * DomSerializer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.DomSerializer',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Merger',
	    'tinymce.core.api.Events',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.dom.DomSerializerFilters',
	    'tinymce.core.dom.DomSerializerPreProcess',
	    'tinymce.core.html.DomParser',
	    'tinymce.core.html.Schema',
	    'tinymce.core.html.Serializer',
	    'tinymce.core.text.Zwsp',
	    'tinymce.core.util.Tools'
	  ],
	  function (Fun, Merger, Events, DOMUtils, DomSerializerFilters, DomSerializerPreProcess, DomParser, Schema, Serializer, Zwsp, Tools) {
	    var addTempAttr = function (htmlParser, tempAttrs, name) {
	      if (Tools.inArray(tempAttrs, name) === -1) {
	        htmlParser.addAttributeFilter(name, function (nodes, name) {
	          var i = nodes.length;
	
	          while (i--) {
	            nodes[i].attr(name, null);
	          }
	        });
	
	        tempAttrs.push(name);
	      }
	    };
	
	    var postProcess = function (editor, args, content) {
	      if (!args.no_events && editor) {
	        var outArgs = Events.firePostProcess(editor, Merger.merge(args, { content: content }));
	        return outArgs.content;
	      } else {
	        return content;
	      }
	    };
	
	    var getHtmlFromNode = function (dom, node, args) {
	      var html = Zwsp.trim(args.getInner ? node.innerHTML : dom.getOuterHTML(node));
	      return args.selection ? html : Tools.trim(html);
	    };
	
	    var parseHtml = function (htmlParser, dom, html, args) {
	      var parserArgs = args.selection ? Merger.merge({ forced_root_block: false }, args) : args;
	      var rootNode = htmlParser.parse(html, parserArgs);
	      DomSerializerFilters.trimTrailingBr(rootNode);
	      return rootNode;
	    };
	
	    var serializeNode = function (settings, schema, node) {
	      var htmlSerializer = new Serializer(settings, schema);
	      return htmlSerializer.serialize(node);
	    };
	
	    var toHtml = function (editor, settings, schema, rootNode, args) {
	      var content = serializeNode(settings, schema, rootNode);
	      return postProcess(editor, args, content);
	    };
	
	    return function (settings, editor) {
	      var dom, schema, htmlParser, tempAttrs = ['data-mce-selected'];
	
	      dom = editor && editor.dom ? editor.dom : DOMUtils.DOM;
	      schema = editor && editor.schema ? editor.schema : new Schema(settings);
	      settings.entity_encoding = settings.entity_encoding || 'named';
	      settings.remove_trailing_brs = "remove_trailing_brs" in settings ? settings.remove_trailing_brs : true;
	
	      htmlParser = new DomParser(settings, schema);
	      DomSerializerFilters.register(htmlParser, settings, dom);
	
	      var serialize = function (node, parserArgs) {
	        var args = Merger.merge({ format: 'html' }, parserArgs ? parserArgs : {});
	        var targetNode = DomSerializerPreProcess.process(editor, node, args);
	        var html = getHtmlFromNode(dom, targetNode, args);
	        var rootNode = parseHtml(htmlParser, dom, html, args);
	        return args.format === 'tree' ? rootNode : toHtml(editor, settings, schema, rootNode, args);
	      };
	
	      return {
	        schema: schema,
	        addNodeFilter: htmlParser.addNodeFilter,
	        addAttributeFilter: htmlParser.addAttributeFilter,
	        serialize: serialize,
	        addRules: function (rules) {
	          schema.addValidElements(rules);
	        },
	        setRules: function (rules) {
	          schema.setValidElements(rules);
	        },
	        addTempAttr: Fun.curry(addTempAttr, htmlParser, tempAttrs),
	        getTempAttrs: function () {
	          return tempAttrs;
	        }
	      };
	    };
	  }
	);
	
	/**
	 * Serializer.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is used to serialize DOM trees into a string. Consult the TinyMCE Wiki API for
	 * more details and examples on how to use this class.
	 *
	 * @class tinymce.dom.Serializer
	 */
	define(
	  'tinymce.core.api.dom.Serializer',
	  [
	    'tinymce.core.dom.DomSerializer'
	  ],
	  function (DomSerializer) {
	    /**
	     * Constructs a new DOM serializer class.
	     *
	     * @constructor
	     * @method Serializer
	     * @param {Object} settings Serializer settings object.
	     * @param {tinymce.Editor} editor Optional editor to bind events to and get schema/dom from.
	     */
	    return function (settings, editor) {
	      var domSerializer = new DomSerializer(settings, editor);
	
	      // Return public methods
	      return {
	        /**
	         * Schema instance that was used to when the Serializer was constructed.
	         *
	         * @field {tinymce.html.Schema} schema
	         */
	        schema: domSerializer.schema,
	
	        /**
	         * Adds a node filter function to the parser used by the serializer, the parser will collect the specified nodes by name
	         * and then execute the callback ones it has finished parsing the document.
	         *
	         * @example
	         * parser.addNodeFilter('p,h1', function(nodes, name) {
	         *  for (var i = 0; i < nodes.length; i++) {
	         *   console.log(nodes[i].name);
	         *  }
	         * });
	         * @method addNodeFilter
	         * @method {String} name Comma separated list of nodes to collect.
	         * @param {function} callback Callback function to execute once it has collected nodes.
	         */
	        addNodeFilter: domSerializer.addNodeFilter,
	
	        /**
	         * Adds a attribute filter function to the parser used by the serializer, the parser will
	         * collect nodes that has the specified attributes
	         * and then execute the callback ones it has finished parsing the document.
	         *
	         * @example
	         * parser.addAttributeFilter('src,href', function(nodes, name) {
	         *  for (var i = 0; i < nodes.length; i++) {
	         *   console.log(nodes[i].name);
	         *  }
	         * });
	         * @method addAttributeFilter
	         * @method {String} name Comma separated list of nodes to collect.
	         * @param {function} callback Callback function to execute once it has collected nodes.
	         */
	        addAttributeFilter: domSerializer.addAttributeFilter,
	
	        /**
	         * Serializes the specified browser DOM node into a HTML string.
	         *
	         * @method serialize
	         * @param {DOMNode} node DOM node to serialize.
	         * @param {Object} args Arguments option that gets passed to event handlers.
	         */
	        serialize: domSerializer.serialize,
	
	        /**
	         * Adds valid elements rules to the serializers schema instance this enables you to specify things
	         * like what elements should be outputted and what attributes specific elements might have.
	         * Consult the Wiki for more details on this format.
	         *
	         * @method addRules
	         * @param {String} rules Valid elements rules string to add to schema.
	         */
	        addRules: domSerializer.addRules,
	
	        /**
	         * Sets the valid elements rules to the serializers schema instance this enables you to specify things
	         * like what elements should be outputted and what attributes specific elements might have.
	         * Consult the Wiki for more details on this format.
	         *
	         * @method setRules
	         * @param {String} rules Valid elements rules string.
	         */
	        setRules: domSerializer.setRules,
	
	        /**
	         * Adds a temporary internal attribute these attributes will get removed on undo and
	         * when getting contents out of the editor.
	         *
	         * @method addTempAttr
	         * @param {String} name string
	         */
	        addTempAttr: domSerializer.addTempAttr,
	
	        /**
	         * Returns an array of all added temp attrs names.
	         *
	         * @method getTempAttrs
	         * @return {String[]} Array with attribute names.
	         */
	        getTempAttrs: domSerializer.getTempAttrs
	      };
	    };
	  }
	);
	
	/**
	 * CaretContainerInput.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module shows the invisble block that the caret is currently in when contents is added to that block.
	 */
	define(
	  'tinymce.core.caret.CaretContainerInput',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.SelectorFind',
	    'tinymce.core.caret.CaretContainer'
	  ],
	  function (Fun, Element, SelectorFind, CaretContainer) {
	    var findBlockCaretContainer = function (editor) {
	      return SelectorFind.descendant(Element.fromDom(editor.getBody()), '*[data-mce-caret]').fold(Fun.constant(null), function (elm) {
	        return elm.dom();
	      });
	    };
	
	    var removeIeControlRect = function (editor) {
	      editor.selection.setRng(editor.selection.getRng());
	    };
	
	    var showBlockCaretContainer = function (editor, blockCaretContainer) {
	      if (blockCaretContainer.hasAttribute('data-mce-caret')) {
	        CaretContainer.showCaretContainerBlock(blockCaretContainer);
	        removeIeControlRect(editor);
	        editor.selection.scrollIntoView(blockCaretContainer);
	      }
	    };
	
	    var handleBlockContainer = function (editor, e) {
	      var blockCaretContainer = findBlockCaretContainer(editor);
	
	      if (!blockCaretContainer) {
	        return;
	      }
	
	      if (e.type === 'compositionstart') {
	        e.preventDefault();
	        e.stopPropagation();
	        showBlockCaretContainer(blockCaretContainer);
	        return;
	      }
	
	      if (CaretContainer.hasContent(blockCaretContainer)) {
	        showBlockCaretContainer(editor, blockCaretContainer);
	      }
	    };
	
	    var setup = function (editor) {
	      editor.on('keyup compositionstart', Fun.curry(handleBlockContainer, editor));
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	/**
	 * BookmarkManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles selection bookmarks.
	 *
	 * @class tinymce.dom.BookmarkManager
	 */
	define(
	  'tinymce.core.api.dom.BookmarkManager',
	  [
	    'ephox.katamari.api.Fun',
	    'tinymce.core.dom.Bookmarks'
	  ],
	  function (Fun, Bookmarks) {
	    /**
	     * Constructs a new BookmarkManager instance for a specific selection instance.
	     *
	     * @constructor
	     * @method BookmarkManager
	     * @param {tinymce.dom.Selection} selection Selection instance to handle bookmarks for.
	     */
	    var BookmarkManager = function (selection) {
	      return {
	        /**
	         * Returns a bookmark location for the current selection. This bookmark object
	         * can then be used to restore the selection after some content modification to the document.
	         *
	         * @method getBookmark
	         * @param {Number} type Optional state if the bookmark should be simple or not. Default is complex.
	         * @param {Boolean} normalized Optional state that enables you to get a position that it would be after normalization.
	         * @return {Object} Bookmark object, use moveToBookmark with this object to restore the selection.
	         * @example
	         * // Stores a bookmark of the current selection
	         * var bm = tinymce.activeEditor.selection.getBookmark();
	         *
	         * tinymce.activeEditor.setContent(tinymce.activeEditor.getContent() + 'Some new content');
	         *
	         * // Restore the selection bookmark
	         * tinymce.activeEditor.selection.moveToBookmark(bm);
	         */
	        getBookmark: Fun.curry(Bookmarks.getBookmark, selection),
	
	        /**
	         * Restores the selection to the specified bookmark.
	         *
	         * @method moveToBookmark
	         * @param {Object} bookmark Bookmark to restore selection from.
	         * @return {Boolean} true/false if it was successful or not.
	         * @example
	         * // Stores a bookmark of the current selection
	         * var bm = tinymce.activeEditor.selection.getBookmark();
	         *
	         * tinymce.activeEditor.setContent(tinymce.activeEditor.getContent() + 'Some new content');
	         *
	         * // Restore the selection bookmark
	         * tinymce.activeEditor.selection.moveToBookmark(bm);
	         */
	        moveToBookmark: Fun.curry(Bookmarks.moveToBookmark, selection)
	      };
	    };
	
	    /**
	     * Returns true/false if the specified node is a bookmark node or not.
	     *
	     * @static
	     * @method isBookmarkNode
	     * @param {DOMNode} node DOM Node to check if it's a bookmark node or not.
	     * @return {Boolean} true/false if the node is a bookmark node or not.
	     */
	    BookmarkManager.isBookmarkNode = Bookmarks.isBookmarkNode;
	
	    return BookmarkManager;
	  }
	);
	/**
	 * ControlSelection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles control selection of elements. Controls are elements
	 * that can be resized and needs to be selected as a whole. It adds custom resize handles
	 * to all browser engines that support properly disabling the built in resize logic.
	 *
	 * @class tinymce.dom.ControlSelection
	 */
	define(
	  'tinymce.core.dom.ControlSelection',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.Selectors',
	    'global!document',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.RangePoint',
	    'tinymce.core.Env',
	    'tinymce.core.util.Delay',
	    'tinymce.core.util.Tools',
	    'tinymce.core.util.VK'
	  ],
	  function (Fun, Element, Selectors, document, NodeType, RangePoint, Env, Delay, Tools, VK) {
	    var isContentEditableFalse = NodeType.isContentEditableFalse;
	    var isContentEditableTrue = NodeType.isContentEditableTrue;
	
	    var getContentEditableRoot = function (root, node) {
	      while (node && node != root) {
	        if (isContentEditableTrue(node) || isContentEditableFalse(node)) {
	          return node;
	        }
	
	        node = node.parentNode;
	      }
	
	      return null;
	    };
	
	    return function (selection, editor) {
	      var dom = editor.dom, each = Tools.each;
	      var selectedElm, selectedElmGhost, resizeHelper, resizeHandles, selectedHandle;
	      var startX, startY, selectedElmX, selectedElmY, startW, startH, ratio, resizeStarted;
	      var width, height, editableDoc = editor.getDoc(), rootDocument = document;
	      var abs = Math.abs, round = Math.round, rootElement = editor.getBody(), startScrollWidth, startScrollHeight;
	
	      // Details about each resize handle how to scale etc
	      resizeHandles = {
	        // Name: x multiplier, y multiplier, delta size x, delta size y
	        /*n: [0.5, 0, 0, -1],
	        e: [1, 0.5, 1, 0],
	        s: [0.5, 1, 0, 1],
	        w: [0, 0.5, -1, 0],*/
	        nw: [0, 0, -1, -1],
	        ne: [1, 0, 1, -1],
	        se: [1, 1, 1, 1],
	        sw: [0, 1, -1, 1]
	      };
	
	      // Add CSS for resize handles, cloned element and selected
	      var rootClass = '.mce-content-body';
	      editor.contentStyles.push(
	        rootClass + ' div.mce-resizehandle {' +
	        'position: absolute;' +
	        'border: 1px solid black;' +
	        'box-sizing: content-box;' +
	        'background: #FFF;' +
	        'width: 7px;' +
	        'height: 7px;' +
	        'z-index: 10000' +
	        '}' +
	        rootClass + ' .mce-resizehandle:hover {' +
	        'background: #000' +
	        '}' +
	        rootClass + ' img[data-mce-selected],' + rootClass + ' hr[data-mce-selected] {' +
	        'outline: 1px solid black;' +
	        'resize: none' + // Have been talks about implementing this in browsers
	        '}' +
	        rootClass + ' .mce-clonedresizable {' +
	        'position: absolute;' +
	        (Env.gecko ? '' : 'outline: 1px dashed black;') + // Gecko produces trails while resizing
	        'opacity: .5;' +
	        'filter: alpha(opacity=50);' +
	        'z-index: 10000' +
	        '}' +
	        rootClass + ' .mce-resize-helper {' +
	        'background: #555;' +
	        'background: rgba(0,0,0,0.75);' +
	        'border-radius: 3px;' +
	        'border: 1px;' +
	        'color: white;' +
	        'display: none;' +
	        'font-family: sans-serif;' +
	        'font-size: 12px;' +
	        'white-space: nowrap;' +
	        'line-height: 14px;' +
	        'margin: 5px 10px;' +
	        'padding: 5px;' +
	        'position: absolute;' +
	        'z-index: 10001' +
	        '}'
	      );
	
	      var isImage = function (elm) {
	        return elm && (elm.nodeName === 'IMG' || editor.dom.is(elm, 'figure.image'));
	      };
	
	      var isEventOnImageOutsideRange = function (evt, range) {
	        return isImage(evt.target) && !RangePoint.isXYWithinRange(evt.clientX, evt.clientY, range);
	      };
	
	      var contextMenuSelectImage = function (evt) {
	        var target = evt.target;
	
	        if (isEventOnImageOutsideRange(evt, editor.selection.getRng()) && !evt.isDefaultPrevented()) {
	          evt.preventDefault();
	          editor.selection.select(target);
	        }
	      };
	
	      var getResizeTarget = function (elm) {
	        return editor.dom.is(elm, 'figure.image') ? elm.querySelector('img') : elm;
	      };
	
	      var isResizable = function (elm) {
	        var selector = editor.settings.object_resizing;
	
	        if (selector === false || Env.iOS) {
	          return false;
	        }
	
	        if (typeof selector != 'string') {
	          selector = 'table,img,figure.image,div';
	        }
	
	        if (elm.getAttribute('data-mce-resize') === 'false') {
	          return false;
	        }
	
	        if (elm == editor.getBody()) {
	          return false;
	        }
	
	        return Selectors.is(Element.fromDom(elm), selector);
	      };
	
	      var resizeGhostElement = function (e) {
	        var deltaX, deltaY, proportional;
	        var resizeHelperX, resizeHelperY;
	
	        // Calc new width/height
	        deltaX = e.screenX - startX;
	        deltaY = e.screenY - startY;
	
	        // Calc new size
	        width = deltaX * selectedHandle[2] + startW;
	        height = deltaY * selectedHandle[3] + startH;
	
	        // Never scale down lower than 5 pixels
	        width = width < 5 ? 5 : width;
	        height = height < 5 ? 5 : height;
	
	        if (isImage(selectedElm) && editor.settings.resize_img_proportional !== false) {
	          proportional = !VK.modifierPressed(e);
	        } else {
	          proportional = VK.modifierPressed(e) || (isImage(selectedElm) && selectedHandle[2] * selectedHandle[3] !== 0);
	        }
	
	        // Constrain proportions
	        if (proportional) {
	          if (abs(deltaX) > abs(deltaY)) {
	            height = round(width * ratio);
	            width = round(height / ratio);
	          } else {
	            width = round(height / ratio);
	            height = round(width * ratio);
	          }
	        }
	
	        // Update ghost size
	        dom.setStyles(getResizeTarget(selectedElmGhost), {
	          width: width,
	          height: height
	        });
	
	        // Update resize helper position
	        resizeHelperX = selectedHandle.startPos.x + deltaX;
	        resizeHelperY = selectedHandle.startPos.y + deltaY;
	        resizeHelperX = resizeHelperX > 0 ? resizeHelperX : 0;
	        resizeHelperY = resizeHelperY > 0 ? resizeHelperY : 0;
	
	        dom.setStyles(resizeHelper, {
	          left: resizeHelperX,
	          top: resizeHelperY,
	          display: 'block'
	        });
	
	        resizeHelper.innerHTML = width + ' &times; ' + height;
	
	        // Update ghost X position if needed
	        if (selectedHandle[2] < 0 && selectedElmGhost.clientWidth <= width) {
	          dom.setStyle(selectedElmGhost, 'left', selectedElmX + (startW - width));
	        }
	
	        // Update ghost Y position if needed
	        if (selectedHandle[3] < 0 && selectedElmGhost.clientHeight <= height) {
	          dom.setStyle(selectedElmGhost, 'top', selectedElmY + (startH - height));
	        }
	
	        // Calculate how must overflow we got
	        deltaX = rootElement.scrollWidth - startScrollWidth;
	        deltaY = rootElement.scrollHeight - startScrollHeight;
	
	        // Re-position the resize helper based on the overflow
	        if (deltaX + deltaY !== 0) {
	          dom.setStyles(resizeHelper, {
	            left: resizeHelperX - deltaX,
	            top: resizeHelperY - deltaY
	          });
	        }
	
	        if (!resizeStarted) {
	          editor.fire('ObjectResizeStart', { target: selectedElm, width: startW, height: startH });
	          resizeStarted = true;
	        }
	      };
	
	      var endGhostResize = function () {
	        resizeStarted = false;
	
	        var setSizeProp = function (name, value) {
	          if (value) {
	            // Resize by using style or attribute
	            if (selectedElm.style[name] || !editor.schema.isValid(selectedElm.nodeName.toLowerCase(), name)) {
	              dom.setStyle(getResizeTarget(selectedElm), name, value);
	            } else {
	              dom.setAttrib(getResizeTarget(selectedElm), name, value);
	            }
	          }
	        };
	
	        // Set width/height properties
	        setSizeProp('width', width);
	        setSizeProp('height', height);
	
	        dom.unbind(editableDoc, 'mousemove', resizeGhostElement);
	        dom.unbind(editableDoc, 'mouseup', endGhostResize);
	
	        if (rootDocument != editableDoc) {
	          dom.unbind(rootDocument, 'mousemove', resizeGhostElement);
	          dom.unbind(rootDocument, 'mouseup', endGhostResize);
	        }
	
	        // Remove ghost/helper and update resize handle positions
	        dom.remove(selectedElmGhost);
	        dom.remove(resizeHelper);
	
	        showResizeRect(selectedElm);
	
	        editor.fire('ObjectResized', { target: selectedElm, width: width, height: height });
	        dom.setAttrib(selectedElm, 'style', dom.getAttrib(selectedElm, 'style'));
	        editor.nodeChanged();
	      };
	
	      var showResizeRect = function (targetElm) {
	        var position, targetWidth, targetHeight, e, rect;
	
	        hideResizeRect();
	        unbindResizeHandleEvents();
	
	        // Get position and size of target
	        position = dom.getPos(targetElm, rootElement);
	        selectedElmX = position.x;
	        selectedElmY = position.y;
	        rect = targetElm.getBoundingClientRect(); // Fix for Gecko offsetHeight for table with caption
	        targetWidth = rect.width || (rect.right - rect.left);
	        targetHeight = rect.height || (rect.bottom - rect.top);
	
	        // Reset width/height if user selects a new image/table
	        if (selectedElm != targetElm) {
	          selectedElm = targetElm;
	          width = height = 0;
	        }
	
	        // Makes it possible to disable resizing
	        e = editor.fire('ObjectSelected', { target: targetElm });
	
	        if (isResizable(targetElm) && !e.isDefaultPrevented()) {
	          each(resizeHandles, function (handle, name) {
	            var handleElm;
	
	            var startDrag = function (e) {
	              startX = e.screenX;
	              startY = e.screenY;
	              startW = getResizeTarget(selectedElm).clientWidth;
	              startH = getResizeTarget(selectedElm).clientHeight;
	              ratio = startH / startW;
	              selectedHandle = handle;
	
	              handle.startPos = {
	                x: targetWidth * handle[0] + selectedElmX,
	                y: targetHeight * handle[1] + selectedElmY
	              };
	
	              startScrollWidth = rootElement.scrollWidth;
	              startScrollHeight = rootElement.scrollHeight;
	
	              selectedElmGhost = selectedElm.cloneNode(true);
	              dom.addClass(selectedElmGhost, 'mce-clonedresizable');
	              dom.setAttrib(selectedElmGhost, 'data-mce-bogus', 'all');
	              selectedElmGhost.contentEditable = false; // Hides IE move layer cursor
	              selectedElmGhost.unSelectabe = true;
	              dom.setStyles(selectedElmGhost, {
	                left: selectedElmX,
	                top: selectedElmY,
	                margin: 0
	              });
	
	              selectedElmGhost.removeAttribute('data-mce-selected');
	              rootElement.appendChild(selectedElmGhost);
	
	              dom.bind(editableDoc, 'mousemove', resizeGhostElement);
	              dom.bind(editableDoc, 'mouseup', endGhostResize);
	
	              if (rootDocument != editableDoc) {
	                dom.bind(rootDocument, 'mousemove', resizeGhostElement);
	                dom.bind(rootDocument, 'mouseup', endGhostResize);
	              }
	
	              resizeHelper = dom.add(rootElement, 'div', {
	                'class': 'mce-resize-helper',
	                'data-mce-bogus': 'all'
	              }, startW + ' &times; ' + startH);
	            };
	
	            // Get existing or render resize handle
	            handleElm = dom.get('mceResizeHandle' + name);
	            if (handleElm) {
	              dom.remove(handleElm);
	            }
	
	            handleElm = dom.add(rootElement, 'div', {
	              id: 'mceResizeHandle' + name,
	              'data-mce-bogus': 'all',
	              'class': 'mce-resizehandle',
	              unselectable: true,
	              style: 'cursor:' + name + '-resize; margin:0; padding:0'
	            });
	
	            // Hides IE move layer cursor
	            // If we set it on Chrome we get this wounderful bug: #6725
	            if (Env.ie) {
	              handleElm.contentEditable = false;
	            }
	
	            dom.bind(handleElm, 'mousedown', function (e) {
	              e.stopImmediatePropagation();
	              e.preventDefault();
	              startDrag(e);
	            });
	
	            handle.elm = handleElm;
	
	            // Position element
	            dom.setStyles(handleElm, {
	              left: (targetWidth * handle[0] + selectedElmX) - (handleElm.offsetWidth / 2),
	              top: (targetHeight * handle[1] + selectedElmY) - (handleElm.offsetHeight / 2)
	            });
	          });
	        } else {
	          hideResizeRect();
	        }
	
	        selectedElm.setAttribute('data-mce-selected', '1');
	      };
	
	      var hideResizeRect = function () {
	        var name, handleElm;
	
	        unbindResizeHandleEvents();
	
	        if (selectedElm) {
	          selectedElm.removeAttribute('data-mce-selected');
	        }
	
	        for (name in resizeHandles) {
	          handleElm = dom.get('mceResizeHandle' + name);
	          if (handleElm) {
	            dom.unbind(handleElm);
	            dom.remove(handleElm);
	          }
	        }
	      };
	
	      var updateResizeRect = function (e) {
	        var startElm, controlElm;
	
	        var isChildOrEqual = function (node, parent) {
	          if (node) {
	            do {
	              if (node === parent) {
	                return true;
	              }
	            } while ((node = node.parentNode));
	          }
	        };
	
	        // Ignore all events while resizing or if the editor instance was removed
	        if (resizeStarted || editor.removed) {
	          return;
	        }
	
	        // Remove data-mce-selected from all elements since they might have been copied using Ctrl+c/v
	        each(dom.select('img[data-mce-selected],hr[data-mce-selected]'), function (img) {
	          img.removeAttribute('data-mce-selected');
	        });
	
	        controlElm = e.type == 'mousedown' ? e.target : selection.getNode();
	        controlElm = dom.$(controlElm).closest('table,img,figure.image,hr')[0];
	
	        if (isChildOrEqual(controlElm, rootElement)) {
	          disableGeckoResize();
	          startElm = selection.getStart(true);
	
	          if (isChildOrEqual(startElm, controlElm) && isChildOrEqual(selection.getEnd(true), controlElm)) {
	            showResizeRect(controlElm);
	            return;
	          }
	        }
	
	        hideResizeRect();
	      };
	
	      var isWithinContentEditableFalse = function (elm) {
	        return isContentEditableFalse(getContentEditableRoot(editor.getBody(), elm));
	      };
	
	      var unbindResizeHandleEvents = function () {
	        for (var name in resizeHandles) {
	          var handle = resizeHandles[name];
	
	          if (handle.elm) {
	            dom.unbind(handle.elm);
	            delete handle.elm;
	          }
	        }
	      };
	
	      var disableGeckoResize = function () {
	        try {
	          // Disable object resizing on Gecko
	          editor.getDoc().execCommand('enableObjectResizing', false, false);
	        } catch (ex) {
	          // Ignore
	        }
	      };
	
	      editor.on('init', function () {
	        disableGeckoResize();
	
	        // Sniff sniff, hard to feature detect this stuff
	        if (Env.ie && Env.ie >= 11) {
	          // Needs to be mousedown for drag/drop to work on IE 11
	          // Needs to be click on Edge to properly select images
	          editor.on('mousedown click', function (e) {
	            var target = e.target, nodeName = target.nodeName;
	
	            if (!resizeStarted && /^(TABLE|IMG|HR)$/.test(nodeName) && !isWithinContentEditableFalse(target)) {
	              if (e.button !== 2) {
	                editor.selection.select(target, nodeName == 'TABLE');
	              }
	
	              // Only fire once since nodeChange is expensive
	              if (e.type == 'mousedown') {
	                editor.nodeChanged();
	              }
	            }
	          });
	
	          editor.dom.bind(rootElement, 'mscontrolselect', function (e) {
	            var delayedSelect = function (node) {
	              Delay.setEditorTimeout(editor, function () {
	                editor.selection.select(node);
	              });
	            };
	
	            if (isWithinContentEditableFalse(e.target)) {
	              e.preventDefault();
	              delayedSelect(e.target);
	              return;
	            }
	
	            if (/^(TABLE|IMG|HR)$/.test(e.target.nodeName)) {
	              e.preventDefault();
	
	              // This moves the selection from being a control selection to a text like selection like in WebKit #6753
	              // TODO: Fix this the day IE works like other browsers without this nasty native ugly control selections.
	              if (e.target.tagName == 'IMG') {
	                delayedSelect(e.target);
	              }
	            }
	          });
	        }
	
	        var throttledUpdateResizeRect = Delay.throttle(function (e) {
	          if (!editor.composing) {
	            updateResizeRect(e);
	          }
	        });
	
	        editor.on('nodechange ResizeEditor ResizeWindow drop', throttledUpdateResizeRect);
	
	        // Update resize rect while typing in a table
	        editor.on('keyup compositionend', function (e) {
	          // Don't update the resize rect while composing since it blows away the IME see: #2710
	          if (selectedElm && selectedElm.nodeName == "TABLE") {
	            throttledUpdateResizeRect(e);
	          }
	        });
	
	        editor.on('hide blur', hideResizeRect);
	        editor.on('contextmenu', contextMenuSelectImage);
	
	        // Hide rect on focusout since it would float on top of windows otherwise
	        //editor.on('focusout', hideResizeRect);
	      });
	
	      editor.on('remove', unbindResizeHandleEvents);
	
	      var destroy = function () {
	        selectedElm = selectedElmGhost = null;
	      };
	
	      return {
	        isResizable: isResizable,
	        showResizeRect: showResizeRect,
	        hideResizeRect: hideResizeRect,
	        updateResizeRect: updateResizeRect,
	        destroy: destroy
	      };
	    };
	  }
	);
	
	/**
	 * ScrollIntoView.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.dom.ScrollIntoView',
	  [
	    'tinymce.core.dom.NodeType'
	  ],
	  function (NodeType) {
	    var getPos = function (elm) {
	      var x = 0, y = 0;
	
	      var offsetParent = elm;
	      while (offsetParent && offsetParent.nodeType) {
	        x += offsetParent.offsetLeft || 0;
	        y += offsetParent.offsetTop || 0;
	        offsetParent = offsetParent.offsetParent;
	      }
	
	      return { x: x, y: y };
	    };
	
	    var fireScrollIntoViewEvent = function (editor, elm, alignToTop) {
	      var scrollEvent = { elm: elm, alignToTop: alignToTop };
	      editor.fire('scrollIntoView', scrollEvent);
	      return scrollEvent.isDefaultPrevented();
	    };
	
	    var scrollIntoView = function (editor, elm, alignToTop) {
	      var y, viewPort, dom = editor.dom, root = dom.getRoot(), viewPortY, viewPortH, offsetY = 0;
	
	      if (fireScrollIntoViewEvent(editor, elm, alignToTop)) {
	        return;
	      }
	
	      if (!NodeType.isElement(elm)) {
	        return;
	      }
	
	      if (alignToTop === false) {
	        offsetY = elm.offsetHeight;
	      }
	
	      if (root.nodeName !== 'BODY') {
	        var scrollContainer = editor.selection.getScrollContainer();
	        if (scrollContainer) {
	          y = getPos(elm).y - getPos(scrollContainer).y + offsetY;
	          viewPortH = scrollContainer.clientHeight;
	          viewPortY = scrollContainer.scrollTop;
	          if (y < viewPortY || y + 25 > viewPortY + viewPortH) {
	            scrollContainer.scrollTop = y < viewPortY ? y : y - viewPortH + 25;
	          }
	
	          return;
	        }
	      }
	
	      viewPort = dom.getViewPort(editor.getWin());
	      y = dom.getPos(elm).y + offsetY;
	      viewPortY = viewPort.y;
	      viewPortH = viewPort.h;
	      if (y < viewPort.y || y + 25 > viewPortY + viewPortH) {
	        editor.getWin().scrollTo(0, y < viewPortY ? y : y - viewPortH + 25);
	      }
	    };
	
	    return {
	      scrollIntoView: scrollIntoView
	    };
	  }
	);
	
	/**
	 * CaretRangeFromPoint.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.CaretRangeFromPoint',
	  [
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.util.Tools'
	  ],
	  function (NodeType, Tools) {
	    var hasCeProperty = function (node) {
	      return NodeType.isContentEditableTrue(node) || NodeType.isContentEditableFalse(node);
	    };
	
	    var findParent = function (node, rootNode, predicate) {
	      while (node && node !== rootNode) {
	        if (predicate(node)) {
	          return node;
	        }
	
	        node = node.parentNode;
	      }
	
	      return null;
	    };
	
	    /**
	     * Finds the closest selection rect tries to get the range from that.
	     */
	    var findClosestIeRange = function (clientX, clientY, doc) {
	      var element, rng, rects;
	
	      element = doc.elementFromPoint(clientX, clientY);
	      rng = doc.body.createTextRange();
	
	      if (!element || element.tagName === 'HTML') {
	        element = doc.body;
	      }
	
	      rng.moveToElementText(element);
	      rects = Tools.toArray(rng.getClientRects());
	
	      rects = rects.sort(function (a, b) {
	        a = Math.abs(Math.max(a.top - clientY, a.bottom - clientY));
	        b = Math.abs(Math.max(b.top - clientY, b.bottom - clientY));
	
	        return a - b;
	      });
	
	      if (rects.length > 0) {
	        clientY = (rects[0].bottom + rects[0].top) / 2;
	
	        try {
	          rng.moveToPoint(clientX, clientY);
	          rng.collapse(true);
	
	          return rng;
	        } catch (ex) {
	          // At least we tried
	        }
	      }
	
	      return null;
	    };
	
	    var moveOutOfContentEditableFalse = function (rng, rootNode) {
	      var parentElement = rng && rng.parentElement ? rng.parentElement() : null;
	      return NodeType.isContentEditableFalse(findParent(parentElement, rootNode, hasCeProperty)) ? null : rng;
	    };
	
	    var fromPoint = function (clientX, clientY, doc) {
	      var rng, point;
	
	      if (doc.caretPositionFromPoint) {
	        point = doc.caretPositionFromPoint(clientX, clientY);
	        if (point) {
	          rng = doc.createRange();
	          rng.setStart(point.offsetNode, point.offset);
	          rng.collapse(true);
	        }
	      } else if (doc.caretRangeFromPoint) {
	        rng = doc.caretRangeFromPoint(clientX, clientY);
	      } else if (doc.body.createTextRange) {
	        rng = doc.body.createTextRange();
	
	        try {
	          rng.moveToPoint(clientX, clientY);
	          rng.collapse(true);
	        } catch (ex) {
	          rng = findClosestIeRange(clientX, clientY, doc);
	        }
	
	        return moveOutOfContentEditableFalse(rng, doc.body);
	      }
	
	      return rng;
	    };
	
	    return {
	      fromPoint: fromPoint
	    };
	  }
	);
	
	/**
	 * EventProcessRanges.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.EventProcessRanges',
	  [
	    'ephox.katamari.api.Arr'
	  ],
	  function (Arr) {
	    var processRanges = function (editor, ranges) {
	      return Arr.map(ranges, function (range) {
	        var evt = editor.fire('GetSelectionRange', { range: range });
	        return evt.range !== range ? evt.range : range;
	      });
	    };
	
	    return {
	      processRanges: processRanges
	    };
	  }
	);
	
	
	
	define(
	  'ephox.sugar.api.dom.Replication',
	
	  [
	    'ephox.sugar.api.properties.Attr',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.dom.Insert',
	    'ephox.sugar.api.dom.InsertAll',
	    'ephox.sugar.api.dom.Remove',
	    'ephox.sugar.api.search.Traverse'
	  ],
	
	  function (Attr, Element, Insert, InsertAll, Remove, Traverse) {
	    var clone = function (original, deep) {
	      return Element.fromDom(original.dom().cloneNode(deep));
	    };
	
	    /** Shallow clone - just the tag, no children */
	    var shallow = function (original) {
	      return clone(original, false);
	    };
	
	    /** Deep clone - everything copied including children */
	    var deep = function (original) {
	      return clone(original, true);
	    };
	
	    /** Shallow clone, with a new tag */
	    var shallowAs = function (original, tag) {
	      var nu = Element.fromTag(tag);
	
	      var attributes = Attr.clone(original);
	      Attr.setAll(nu, attributes);
	
	      return nu;
	    };
	
	    /** Deep clone, with a new tag */
	    var copy = function (original, tag) {
	      var nu = shallowAs(original, tag);
	
	      // NOTE
	      // previously this used serialisation:
	      // nu.dom().innerHTML = original.dom().innerHTML;
	      //
	      // Clone should be equivalent (and faster), but if TD <-> TH toggle breaks, put it back.
	
	      var cloneChildren = Traverse.children(deep(original));
	      InsertAll.append(nu, cloneChildren);
	
	      return nu;
	    };
	
	    /** Change the tag name, but keep all children */
	    var mutate = function (original, tag) {
	      var nu = shallowAs(original, tag);
	
	      Insert.before(original, nu);
	      var children = Traverse.children(original);
	      InsertAll.append(nu, children);
	      Remove.remove(original);
	      return nu;
	    };
	
	    return {
	      shallow: shallow,
	      shallowAs: shallowAs,
	      deep: deep,
	      copy: copy,
	      mutate: mutate
	    };
	  }
	);
	
	define(
	  'ephox.sugar.api.node.Fragment',
	
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.sugar.api.node.Element',
	    'global!document'
	  ],
	
	  function (Arr, Element, document) {
	    var fromElements = function (elements, scope) {
	      var doc = scope || document;
	      var fragment = doc.createDocumentFragment();
	      Arr.each(elements, function (element) {
	        fragment.appendChild(element.dom());
	      });
	      return Element.fromDom(fragment);
	    };
	
	    return {
	      fromElements: fromElements
	    };
	  }
	);
	
	/**
	 * SelectionUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.SelectionUtils',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Options',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Node',
	    'ephox.sugar.api.search.Traverse',
	    'tinymce.core.dom.NodeType'
	  ],
	  function (Arr, Fun, Option, Options, Compare, Element, Node, Traverse, NodeType) {
	    var getStartNode = function (rng) {
	      var sc = rng.startContainer, so = rng.startOffset;
	      if (NodeType.isText(sc)) {
	        return so === 0 ? Option.some(Element.fromDom(sc)) : Option.none();
	      } else {
	        return Option.from(sc.childNodes[so]).map(Element.fromDom);
	      }
	    };
	
	    var getEndNode = function (rng) {
	      var ec = rng.endContainer, eo = rng.endOffset;
	      if (NodeType.isText(ec)) {
	        return eo === ec.data.length ? Option.some(Element.fromDom(ec)) : Option.none();
	      } else {
	        return Option.from(ec.childNodes[eo - 1]).map(Element.fromDom);
	      }
	    };
	
	    var getFirstChildren = function (node) {
	      return Traverse.firstChild(node).fold(
	        Fun.constant([node]),
	        function (child) {
	          return [node].concat(getFirstChildren(child));
	        }
	      );
	    };
	
	    var getLastChildren = function (node) {
	      return Traverse.lastChild(node).fold(
	        Fun.constant([node]),
	        function (child) {
	          if (Node.name(child) === 'br') {
	            return Traverse.prevSibling(child).map(function (sibling) {
	              return [node].concat(getLastChildren(sibling));
	            }).getOr([]);
	          } else {
	            return [node].concat(getLastChildren(child));
	          }
	        }
	      );
	    };
	
	    var hasAllContentsSelected = function (elm, rng) {
	      return Options.liftN([getStartNode(rng), getEndNode(rng)], function (startNode, endNode) {
	        var start = Arr.find(getFirstChildren(elm), Fun.curry(Compare.eq, startNode));
	        var end = Arr.find(getLastChildren(elm), Fun.curry(Compare.eq, endNode));
	        return start.isSome() && end.isSome();
	      }).getOr(false);
	    };
	
	    return {
	      hasAllContentsSelected: hasAllContentsSelected
	    };
	  }
	);
	
	/**
	 * SimpleTableModel.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.SimpleTableModel',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Option',
	    'ephox.katamari.api.Struct',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.dom.Insert',
	    'ephox.sugar.api.dom.InsertAll',
	    'ephox.sugar.api.dom.Replication',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.properties.Attr',
	    'ephox.sugar.api.search.SelectorFilter'
	  ],
	  function (Arr, Option, Struct, Compare, Insert, InsertAll, Replication, Element, Attr, SelectorFilter) {
	    var tableModel = Struct.immutable('element', 'width', 'rows');
	    var tableRow = Struct.immutable('element', 'cells');
	    var cellPosition = Struct.immutable('x', 'y');
	
	    var getSpan = function (td, key) {
	      var value = parseInt(Attr.get(td, key), 10);
	      return isNaN(value) ? 1 : value;
	    };
	
	    var fillout = function (table, x, y, tr, td) {
	      var rowspan = getSpan(td, 'rowspan');
	      var colspan = getSpan(td, 'colspan');
	      var rows = table.rows();
	
	      for (var y2 = y; y2 < y + rowspan; y2++) {
	        if (!rows[y2]) {
	          rows[y2] = tableRow(Replication.deep(tr), []);
	        }
	
	        for (var x2 = x; x2 < x + colspan; x2++) {
	          var cells = rows[y2].cells();
	
	          // not filler td:s are purposely not cloned so that we can
	          // find cells in the model by element object references
	          cells[x2] = y2 == y && x2 == x ? td : Replication.shallow(td);
	        }
	      }
	    };
	
	    var cellExists = function (table, x, y) {
	      var rows = table.rows();
	      var cells = rows[y] ? rows[y].cells() : [];
	      return !!cells[x];
	    };
	
	    var skipCellsX = function (table, x, y) {
	      while (cellExists(table, x, y)) {
	        x++;
	      }
	
	      return x;
	    };
	
	    var getWidth = function (rows) {
	      return Arr.foldl(rows, function (acc, row) {
	        return row.cells().length > acc ? row.cells().length : acc;
	      }, 0);
	    };
	
	    var findElementPos = function (table, element) {
	      var rows = table.rows();
	      for (var y = 0; y < rows.length; y++) {
	        var cells = rows[y].cells();
	        for (var x = 0; x < cells.length; x++) {
	          if (Compare.eq(cells[x], element)) {
	            return Option.some(cellPosition(x, y));
	          }
	        }
	      }
	
	      return Option.none();
	    };
	
	    var extractRows = function (table, sx, sy, ex, ey) {
	      var newRows = [];
	      var rows = table.rows();
	
	      for (var y = sy; y <= ey; y++) {
	        var cells = rows[y].cells();
	        var slice = sx < ex ? cells.slice(sx, ex + 1) : cells.slice(ex, sx + 1);
	        newRows.push(tableRow(rows[y].element(), slice));
	      }
	
	      return newRows;
	    };
	
	    var subTable = function (table, startPos, endPos) {
	      var sx = startPos.x(), sy = startPos.y();
	      var ex = endPos.x(), ey = endPos.y();
	      var newRows = sy < ey ? extractRows(table, sx, sy, ex, ey) : extractRows(table, sx, ey, ex, sy);
	
	      return tableModel(table.element(), getWidth(newRows), newRows);
	    };
	
	    var createDomTable = function (table, rows) {
	      var tableElement = Replication.shallow(table.element());
	      var tableBody = Element.fromTag('tbody');
	
	      InsertAll.append(tableBody, rows);
	      Insert.append(tableElement, tableBody);
	
	      return tableElement;
	    };
	
	    var modelRowsToDomRows = function (table) {
	      return Arr.map(table.rows(), function (row) {
	        var cells = Arr.map(row.cells(), function (cell) {
	          var td = Replication.deep(cell);
	          Attr.remove(td, 'colspan');
	          Attr.remove(td, 'rowspan');
	          return td;
	        });
	
	        var tr = Replication.shallow(row.element());
	        InsertAll.append(tr, cells);
	        return tr;
	      });
	    };
	
	    var fromDom = function (tableElm) {
	      var table = tableModel(Replication.shallow(tableElm), 0, []);
	
	      Arr.each(SelectorFilter.descendants(tableElm, 'tr'), function (tr, y) {
	        Arr.each(SelectorFilter.descendants(tr, 'td,th'), function (td, x) {
	          fillout(table, skipCellsX(table, x, y), y, tr, td);
	        });
	      });
	
	      return tableModel(table.element(), getWidth(table.rows()), table.rows());
	    };
	
	    var toDom = function (table) {
	      return createDomTable(table, modelRowsToDomRows(table));
	    };
	
	    var subsection = function (table, startElement, endElement) {
	      return findElementPos(table, startElement).bind(function (startPos) {
	        return findElementPos(table, endElement).map(function (endPos) {
	          return subTable(table, startPos, endPos);
	        });
	      });
	    };
	
	    return {
	      fromDom: fromDom,
	      toDom: toDom,
	      subsection: subsection
	    };
	  }
	);
	
	/**
	 * FragmentReader.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.FragmentReader',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.dom.Insert',
	    'ephox.sugar.api.dom.Replication',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.node.Fragment',
	    'ephox.sugar.api.node.Node',
	    'ephox.sugar.api.search.SelectorFind',
	    'ephox.sugar.api.search.Traverse',
	    'tinymce.core.dom.ElementType',
	    'tinymce.core.dom.Parents',
	    'tinymce.core.selection.SelectionUtils',
	    'tinymce.core.selection.SimpleTableModel',
	    'tinymce.core.selection.TableCellSelection'
	  ],
	  function (Arr, Fun, Compare, Insert, Replication, Element, Fragment, Node, SelectorFind, Traverse, ElementType, Parents, SelectionUtils, SimpleTableModel, TableCellSelection) {
	    var findParentListContainer = function (parents) {
	      return Arr.find(parents, function (elm) {
	        return Node.name(elm) === 'ul' || Node.name(elm) === 'ol';
	      });
	    };
	
	    var getFullySelectedListWrappers = function (parents, rng) {
	      return Arr.find(parents, function (elm) {
	        return Node.name(elm) === 'li' && SelectionUtils.hasAllContentsSelected(elm, rng);
	      }).fold(
	        Fun.constant([]),
	        function (li) {
	          return findParentListContainer(parents).map(function (listCont) {
	            return [
	              Element.fromTag('li'),
	              Element.fromTag(Node.name(listCont))
	            ];
	          }).getOr([]);
	        }
	      );
	    };
	
	    var wrap = function (innerElm, elms) {
	      var wrapped = Arr.foldl(elms, function (acc, elm) {
	        Insert.append(elm, acc);
	        return elm;
	      }, innerElm);
	      return elms.length > 0 ? Fragment.fromElements([wrapped]) : wrapped;
	    };
	
	    var directListWrappers = function (commonAnchorContainer) {
	      if (ElementType.isListItem(commonAnchorContainer)) {
	        return Traverse.parent(commonAnchorContainer).filter(ElementType.isList).fold(
	          Fun.constant([]),
	          function (listElm) {
	            return [ commonAnchorContainer, listElm ];
	          }
	        );
	      } else {
	        return ElementType.isList(commonAnchorContainer) ? [ commonAnchorContainer ] : [ ];
	      }
	    };
	
	    var getWrapElements = function (rootNode, rng) {
	      var commonAnchorContainer = Element.fromDom(rng.commonAncestorContainer);
	      var parents = Parents.parentsAndSelf(commonAnchorContainer, rootNode);
	      var wrapElements = Arr.filter(parents, function (elm) {
	        return ElementType.isInline(elm) || ElementType.isHeading(elm);
	      });
	      var listWrappers = getFullySelectedListWrappers(parents, rng);
	      var allWrappers = wrapElements.concat(listWrappers.length ? listWrappers : directListWrappers(commonAnchorContainer));
	      return Arr.map(allWrappers, Replication.shallow);
	    };
	
	    var emptyFragment = function () {
	      return Fragment.fromElements([]);
	    };
	
	    var getFragmentFromRange = function (rootNode, rng) {
	      return wrap(Element.fromDom(rng.cloneContents()), getWrapElements(rootNode, rng));
	    };
	
	    var getParentTable = function (rootElm, cell) {
	      return SelectorFind.ancestor(cell, 'table', Fun.curry(Compare.eq, rootElm));
	    };
	
	    var getTableFragment = function (rootNode, selectedTableCells) {
	      return getParentTable(rootNode, selectedTableCells[0]).bind(function (tableElm) {
	        var firstCell = selectedTableCells[0];
	        var lastCell = selectedTableCells[selectedTableCells.length - 1];
	        var fullTableModel = SimpleTableModel.fromDom(tableElm);
	
	        return SimpleTableModel.subsection(fullTableModel, firstCell, lastCell).map(function (sectionedTableModel) {
	          return Fragment.fromElements([SimpleTableModel.toDom(sectionedTableModel)]);
	        });
	      }).getOrThunk(emptyFragment);
	    };
	
	    var getSelectionFragment = function (rootNode, ranges) {
	      return ranges.length > 0 && ranges[0].collapsed ? emptyFragment() : getFragmentFromRange(rootNode, ranges[0]);
	    };
	
	    var read = function (rootNode, ranges) {
	      var selectedCells = TableCellSelection.getCellsFromElementOrRanges(ranges, rootNode);
	      return selectedCells.length > 0 ? getTableFragment(rootNode, selectedCells) : getSelectionFragment(rootNode, ranges);
	    };
	
	    return {
	      read: read
	    };
	  }
	);
	
	/**
	 * GetSelectionContent.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.GetSelectionContent',
	  [
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.selection.EventProcessRanges',
	    'tinymce.core.selection.FragmentReader',
	    'tinymce.core.selection.MultiRange',
	    'tinymce.core.text.Zwsp'
	  ],
	  function (Element, EventProcessRanges, FragmentReader, MultiRange, Zwsp) {
	    var getContent = function (editor, args) {
	      var rng = editor.selection.getRng(), tmpElm = editor.dom.create("body");
	      var sel = editor.selection.getSel(), fragment;
	      var ranges = EventProcessRanges.processRanges(editor, MultiRange.getRanges(sel));
	
	      args = args || {};
	      args.get = true;
	      args.format = args.format || 'html';
	      args.selection = true;
	
	      args = editor.fire('BeforeGetContent', args);
	      if (args.isDefaultPrevented()) {
	        editor.fire('GetContent', args);
	        return args.content;
	      }
	
	      if (args.format === 'text') {
	        return editor.selection.isCollapsed() ? '' : Zwsp.trim(rng.text || (sel.toString ? sel.toString() : ''));
	      }
	
	      if (rng.cloneContents) {
	        fragment = args.contextual ? FragmentReader.read(Element.fromDom(editor.getBody()), ranges).dom() : rng.cloneContents();
	        if (fragment) {
	          tmpElm.appendChild(fragment);
	        }
	      } else if (rng.item !== undefined || rng.htmlText !== undefined) {
	        // IE will produce invalid markup if elements are present that
	        // it doesn't understand like custom elements or HTML5 elements.
	        // Adding a BR in front of the contents and then remoiving it seems to fix it though.
	        tmpElm.innerHTML = '<br>' + (rng.item ? rng.item(0).outerHTML : rng.htmlText);
	        tmpElm.removeChild(tmpElm.firstChild);
	      } else {
	        tmpElm.innerHTML = rng.toString();
	      }
	
	      args.getInner = true;
	
	      var content = editor.selection.serializer.serialize(tmpElm, args);
	      if (args.format === 'tree') {
	        return content;
	      }
	
	      args.content = editor.selection.isCollapsed() ? '' : content;
	      editor.fire('GetContent', args);
	
	      return args.content;
	    };
	
	    return {
	      getContent: getContent
	    };
	  }
	);
	
	/**
	 * SetSelectionContent.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.SetSelectionContent',
	  [
	  ],
	  function () {
	    var setContent = function (editor, content, args) {
	      var rng = editor.selection.getRng(), caretNode, doc = editor.getDoc(), frag, temp;
	
	      args = args || { format: 'html' };
	      args.set = true;
	      args.selection = true;
	      args.content = content;
	
	      // Dispatch before set content event
	      if (!args.no_events) {
	        args = editor.fire('BeforeSetContent', args);
	        if (args.isDefaultPrevented()) {
	          editor.fire('SetContent', args);
	          return;
	        }
	      }
	
	      content = args.content;
	
	      if (rng.insertNode) {
	        // Make caret marker since insertNode places the caret in the beginning of text after insert
	        content += '<span id="__caret">_</span>';
	
	        // Delete and insert new node
	        if (rng.startContainer == doc && rng.endContainer == doc) {
	          // WebKit will fail if the body is empty since the range is then invalid and it can't insert contents
	          doc.body.innerHTML = content;
	        } else {
	          rng.deleteContents();
	
	          if (doc.body.childNodes.length === 0) {
	            doc.body.innerHTML = content;
	          } else {
	            // createContextualFragment doesn't exists in IE 9 DOMRanges
	            if (rng.createContextualFragment) {
	              rng.insertNode(rng.createContextualFragment(content));
	            } else {
	              // Fake createContextualFragment call in IE 9
	              frag = doc.createDocumentFragment();
	              temp = doc.createElement('div');
	
	              frag.appendChild(temp);
	              temp.outerHTML = content;
	
	              rng.insertNode(frag);
	            }
	          }
	        }
	
	        // Move to caret marker
	        caretNode = editor.dom.get('__caret');
	
	        // Make sure we wrap it compleatly, Opera fails with a simple select call
	        rng = doc.createRange();
	        rng.setStartBefore(caretNode);
	        rng.setEndBefore(caretNode);
	        editor.selection.setRng(rng);
	
	        // Remove the caret position
	        editor.dom.remove('__caret');
	
	        try {
	          editor.selection.setRng(rng);
	        } catch (ex) {
	          // Might fail on Opera for some odd reason
	        }
	      } else {
	        if (rng.item) {
	          // Delete content and get caret text selection
	          doc.execCommand('Delete', false, null);
	          rng = editor.getRng();
	        }
	
	        // Explorer removes spaces from the beginning of pasted contents
	        if (/^\s+/.test(content)) {
	          rng.pasteHTML('<span id="__mce_tmp">_</span>' + content);
	          editor.dom.remove('__mce_tmp');
	        } else {
	          rng.pasteHTML(content);
	        }
	      }
	
	      // Dispatch set content event
	      if (!args.no_events) {
	        editor.fire('SetContent', args);
	      }
	    };
	
	    return {
	      setContent: setContent
	    };
	  }
	);
	
	/**
	 * Selection.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles text and control selection it's an crossbrowser utility class.
	 * Consult the TinyMCE Wiki API for more details and examples on how to use this class.
	 *
	 * @class tinymce.dom.Selection
	 * @example
	 * // Getting the currently selected node for the active editor
	 * alert(tinymce.activeEditor.selection.getNode().nodeName);
	 */
	define(
	  'tinymce.core.dom.Selection',
	  [
	    'ephox.sugar.api.dom.Compare',
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.Env',
	    'tinymce.core.api.dom.BookmarkManager',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.dom.ControlSelection',
	    'tinymce.core.dom.ScrollIntoView',
	    'tinymce.core.dom.TreeWalker',
	    'tinymce.core.focus.EditorFocus',
	    'tinymce.core.selection.CaretRangeFromPoint',
	    'tinymce.core.selection.EventProcessRanges',
	    'tinymce.core.selection.GetSelectionContent',
	    'tinymce.core.selection.MultiRange',
	    'tinymce.core.selection.NormalizeRange',
	    'tinymce.core.selection.SelectionBookmark',
	    'tinymce.core.selection.SetSelectionContent',
	    'tinymce.core.util.Tools'
	  ],
	  function (
	    Compare, Element, Env, BookmarkManager, CaretPosition, ControlSelection, ScrollIntoView, TreeWalker, EditorFocus, CaretRangeFromPoint, EventProcessRanges,
	    GetSelectionContent, MultiRange, NormalizeRange, SelectionBookmark, SetSelectionContent, Tools
	  ) {
	    var each = Tools.each, trim = Tools.trim;
	
	    var isAttachedToDom = function (node) {
	      return !!(node && node.ownerDocument) && Compare.contains(Element.fromDom(node.ownerDocument), Element.fromDom(node));
	    };
	
	    var isValidRange = function (rng) {
	      if (!rng) {
	        return false;
	      } else if (rng.select) { // Native IE range still produced by placeCaretAt
	        return true;
	      } else {
	        return isAttachedToDom(rng.startContainer) && isAttachedToDom(rng.endContainer);
	      }
	    };
	
	    /**
	     * Constructs a new selection instance.
	     *
	     * @constructor
	     * @method Selection
	     * @param {tinymce.dom.DOMUtils} dom DOMUtils object reference.
	     * @param {Window} win Window to bind the selection object to.
	     * @param {tinymce.Editor} editor Editor instance of the selection.
	     * @param {tinymce.dom.Serializer} serializer DOM serialization class to use for getContent.
	     */
	    var Selection = function (dom, win, serializer, editor) {
	      var self = this;
	
	      self.dom = dom;
	      self.win = win;
	      self.serializer = serializer;
	      self.editor = editor;
	      self.bookmarkManager = new BookmarkManager(self);
	      self.controlSelection = new ControlSelection(self, editor);
	    };
	
	    Selection.prototype = {
	      /**
	       * Move the selection cursor range to the specified node and offset.
	       * If there is no node specified it will move it to the first suitable location within the body.
	       *
	       * @method setCursorLocation
	       * @param {Node} node Optional node to put the cursor in.
	       * @param {Number} offset Optional offset from the start of the node to put the cursor at.
	       */
	      setCursorLocation: function (node, offset) {
	        var self = this, rng = self.dom.createRng();
	
	        if (!node) {
	          self._moveEndPoint(rng, self.editor.getBody(), true);
	          self.setRng(rng);
	        } else {
	          rng.setStart(node, offset);
	          rng.setEnd(node, offset);
	          self.setRng(rng);
	          self.collapse(false);
	        }
	      },
	
	      /**
	       * Returns the selected contents using the DOM serializer passed in to this class.
	       *
	       * @method getContent
	       * @param {Object} args Optional settings class with for example output format text or html.
	       * @return {String} Selected contents in for example HTML format.
	       * @example
	       * // Alerts the currently selected contents
	       * alert(tinymce.activeEditor.selection.getContent());
	       *
	       * // Alerts the currently selected contents as plain text
	       * alert(tinymce.activeEditor.selection.getContent({format: 'text'}));
	       */
	      getContent: function (args) {
	        return GetSelectionContent.getContent(this.editor, args);
	      },
	
	      /**
	       * Sets the current selection to the specified content. If any contents is selected it will be replaced
	       * with the contents passed in to this function. If there is no selection the contents will be inserted
	       * where the caret is placed in the editor/page.
	       *
	       * @method setContent
	       * @param {String} content HTML contents to set could also be other formats depending on settings.
	       * @param {Object} args Optional settings object with for example data format.
	       * @example
	       * // Inserts some HTML contents at the current selection
	       * tinymce.activeEditor.selection.setContent('<strong>Some contents</strong>');
	       */
	      setContent: function (content, args) {
	        SetSelectionContent.setContent(this.editor, content, args);
	      },
	
	      /**
	       * Returns the start element of a selection range. If the start is in a text
	       * node the parent element will be returned.
	       *
	       * @method getStart
	       * @param {Boolean} real Optional state to get the real parent when the selection is collapsed not the closest element.
	       * @return {Element} Start element of selection range.
	       */
	      getStart: function (real) {
	        var self = this, rng = self.getRng(), startElement;
	
	        startElement = rng.startContainer;
	
	        if (startElement.nodeType == 1 && startElement.hasChildNodes()) {
	          if (!real || !rng.collapsed) {
	            startElement = startElement.childNodes[Math.min(startElement.childNodes.length - 1, rng.startOffset)];
	          }
	        }
	
	        if (startElement && startElement.nodeType == 3) {
	          return startElement.parentNode;
	        }
	
	        return startElement;
	      },
	
	      /**
	       * Returns the end element of a selection range. If the end is in a text
	       * node the parent element will be returned.
	       *
	       * @method getEnd
	       * @param {Boolean} real Optional state to get the real parent when the selection is collapsed not the closest element.
	       * @return {Element} End element of selection range.
	       */
	      getEnd: function (real) {
	        var self = this, rng = self.getRng(), endElement, endOffset;
	
	        endElement = rng.endContainer;
	        endOffset = rng.endOffset;
	
	        if (endElement.nodeType == 1 && endElement.hasChildNodes()) {
	          if (!real || !rng.collapsed) {
	            endElement = endElement.childNodes[endOffset > 0 ? endOffset - 1 : endOffset];
	          }
	        }
	
	        if (endElement && endElement.nodeType == 3) {
	          return endElement.parentNode;
	        }
	
	        return endElement;
	      },
	
	      /**
	       * Returns a bookmark location for the current selection. This bookmark object
	       * can then be used to restore the selection after some content modification to the document.
	       *
	       * @method getBookmark
	       * @param {Number} type Optional state if the bookmark should be simple or not. Default is complex.
	       * @param {Boolean} normalized Optional state that enables you to get a position that it would be after normalization.
	       * @return {Object} Bookmark object, use moveToBookmark with this object to restore the selection.
	       * @example
	       * // Stores a bookmark of the current selection
	       * var bm = tinymce.activeEditor.selection.getBookmark();
	       *
	       * tinymce.activeEditor.setContent(tinymce.activeEditor.getContent() + 'Some new content');
	       *
	       * // Restore the selection bookmark
	       * tinymce.activeEditor.selection.moveToBookmark(bm);
	       */
	      getBookmark: function (type, normalized) {
	        return this.bookmarkManager.getBookmark(type, normalized);
	      },
	
	      /**
	       * Restores the selection to the specified bookmark.
	       *
	       * @method moveToBookmark
	       * @param {Object} bookmark Bookmark to restore selection from.
	       * @return {Boolean} true/false if it was successful or not.
	       * @example
	       * // Stores a bookmark of the current selection
	       * var bm = tinymce.activeEditor.selection.getBookmark();
	       *
	       * tinymce.activeEditor.setContent(tinymce.activeEditor.getContent() + 'Some new content');
	       *
	       * // Restore the selection bookmark
	       * tinymce.activeEditor.selection.moveToBookmark(bm);
	       */
	      moveToBookmark: function (bookmark) {
	        return this.bookmarkManager.moveToBookmark(bookmark);
	      },
	
	      /**
	       * Selects the specified element. This will place the start and end of the selection range around the element.
	       *
	       * @method select
	       * @param {Element} node HTML DOM element to select.
	       * @param {Boolean} content Optional bool state if the contents should be selected or not on non IE browser.
	       * @return {Element} Selected element the same element as the one that got passed in.
	       * @example
	       * // Select the first paragraph in the active editor
	       * tinymce.activeEditor.selection.select(tinymce.activeEditor.dom.select('p')[0]);
	       */
	      select: function (node, content) {
	        var self = this, dom = self.dom, rng = dom.createRng(), idx;
	
	        if (node) {
	          idx = dom.nodeIndex(node);
	          rng.setStart(node.parentNode, idx);
	          rng.setEnd(node.parentNode, idx + 1);
	
	          // Find first/last text node or BR element
	          if (content) {
	            self._moveEndPoint(rng, node, true);
	            self._moveEndPoint(rng, node);
	          }
	
	          self.setRng(rng);
	        }
	
	        return node;
	      },
	
	      /**
	       * Returns true/false if the selection range is collapsed or not. Collapsed means if it's a caret or a larger selection.
	       *
	       * @method isCollapsed
	       * @return {Boolean} true/false state if the selection range is collapsed or not.
	       * Collapsed means if it's a caret or a larger selection.
	       */
	      isCollapsed: function () {
	        var self = this, rng = self.getRng(), sel = self.getSel();
	
	        if (!rng || rng.item) {
	          return false;
	        }
	
	        if (rng.compareEndPoints) {
	          return rng.compareEndPoints('StartToEnd', rng) === 0;
	        }
	
	        return !sel || rng.collapsed;
	      },
	
	      /**
	       * Collapse the selection to start or end of range.
	       *
	       * @method collapse
	       * @param {Boolean} toStart Optional boolean state if to collapse to end or not. Defaults to false.
	       */
	      collapse: function (toStart) {
	        var self = this, rng = self.getRng();
	
	        rng.collapse(!!toStart);
	        self.setRng(rng);
	      },
	
	      /**
	       * Returns the browsers internal selection object.
	       *
	       * @method getSel
	       * @return {Selection} Internal browser selection object.
	       */
	      getSel: function () {
	        var win = this.win;
	
	        return win.getSelection ? win.getSelection() : win.document.selection;
	      },
	
	      /**
	       * Returns the browsers internal range object.
	       *
	       * @method getRng
	       * @param {Boolean} w3c Forces a compatible W3C range on IE.
	       * @return {Range} Internal browser range object.
	       * @see http://www.quirksmode.org/dom/range_intro.html
	       * @see http://www.dotvoid.com/2001/03/using-the-range-object-in-mozilla/
	       */
	      getRng: function (w3c) {
	        var self = this, selection, rng, elm, doc;
	
	        var tryCompareBoundaryPoints = function (how, sourceRange, destinationRange) {
	          try {
	            return sourceRange.compareBoundaryPoints(how, destinationRange);
	          } catch (ex) {
	            // Gecko throws wrong document exception if the range points
	            // to nodes that where removed from the dom #6690
	            // Browsers should mutate existing DOMRange instances so that they always point
	            // to something in the document this is not the case in Gecko works fine in IE/WebKit/Blink
	            // For performance reasons just return -1
	            return -1;
	          }
	        };
	
	        if (!self.win) {
	          return null;
	        }
	
	        doc = self.win.document;
	
	        if (typeof doc === 'undefined' || doc === null) {
	          return null;
	        }
	
	        if (self.editor.bookmark !== undefined && EditorFocus.hasFocus(self.editor) === false) {
	          var bookmark = SelectionBookmark.getRng(self.editor);
	
	          if (bookmark.isSome()) {
	            return bookmark.getOr(doc.createRange());
	          }
	        }
	
	        try {
	          if ((selection = self.getSel())) {
	            if (selection.rangeCount > 0) {
	              rng = selection.getRangeAt(0);
	            } else {
	              rng = selection.createRange ? selection.createRange() : doc.createRange();
	            }
	          }
	        } catch (ex) {
	          // IE throws unspecified error here if TinyMCE is placed in a frame/iframe
	        }
	
	        rng = EventProcessRanges.processRanges(self.editor, [rng])[0];
	
	        // No range found then create an empty one
	        // This can occur when the editor is placed in a hidden container element on Gecko
	        // Or on IE when there was an exception
	        if (!rng) {
	          rng = doc.createRange ? doc.createRange() : doc.body.createTextRange();
	        }
	
	        // If range is at start of document then move it to start of body
	        if (rng.setStart && rng.startContainer.nodeType === 9 && rng.collapsed) {
	          elm = self.dom.getRoot();
	          rng.setStart(elm, 0);
	          rng.setEnd(elm, 0);
	        }
	
	        if (self.selectedRange && self.explicitRange) {
	          if (tryCompareBoundaryPoints(rng.START_TO_START, rng, self.selectedRange) === 0 &&
	            tryCompareBoundaryPoints(rng.END_TO_END, rng, self.selectedRange) === 0) {
	            // Safari, Opera and Chrome only ever select text which causes the range to change.
	            // This lets us use the originally set range if the selection hasn't been changed by the user.
	            rng = self.explicitRange;
	          } else {
	            self.selectedRange = null;
	            self.explicitRange = null;
	          }
	        }
	
	        return rng;
	      },
	
	      /**
	       * Changes the selection to the specified DOM range.
	       *
	       * @method setRng
	       * @param {Range} rng Range to select.
	       * @param {Boolean} forward Optional boolean if the selection is forwards or backwards.
	       */
	      setRng: function (rng, forward) {
	        var self = this, sel, node, evt;
	
	        if (!isValidRange(rng)) {
	          return;
	        }
	
	        // Is IE specific range
	        if (rng.select) {
	          self.explicitRange = null;
	
	          try {
	            rng.select();
	          } catch (ex) {
	            // Needed for some odd IE bug #1843306
	          }
	
	          return;
	        }
	
	        sel = self.getSel();
	
	        evt = self.editor.fire('SetSelectionRange', { range: rng, forward: forward });
	        rng = evt.range;
	
	        if (sel) {
	          self.explicitRange = rng;
	
	          try {
	            sel.removeAllRanges();
	            sel.addRange(rng);
	          } catch (ex) {
	            // IE might throw errors here if the editor is within a hidden container and selection is changed
	          }
	
	          // Forward is set to false and we have an extend function
	          if (forward === false && sel.extend) {
	            sel.collapse(rng.endContainer, rng.endOffset);
	            sel.extend(rng.startContainer, rng.startOffset);
	          }
	
	          // adding range isn't always successful so we need to check range count otherwise an exception can occur
	          self.selectedRange = sel.rangeCount > 0 ? sel.getRangeAt(0) : null;
	        }
	
	        // WebKit egde case selecting images works better using setBaseAndExtent when the image is floated
	        if (!rng.collapsed && rng.startContainer === rng.endContainer && sel.setBaseAndExtent && !Env.ie) {
	          if (rng.endOffset - rng.startOffset < 2) {
	            if (rng.startContainer.hasChildNodes()) {
	              node = rng.startContainer.childNodes[rng.startOffset];
	              if (node && node.tagName === 'IMG') {
	                sel.setBaseAndExtent(
	                  rng.startContainer,
	                  rng.startOffset,
	                  rng.endContainer,
	                  rng.endOffset
	                );
	
	                // Since the setBaseAndExtent is fixed in more recent Blink versions we
	                // need to detect if it's doing the wrong thing and falling back to the
	                // crazy incorrect behavior api call since that seems to be the only way
	                // to get it to work on Safari WebKit as of 2017-02-23
	                if (sel.anchorNode !== rng.startContainer || sel.focusNode !== rng.endContainer) {
	                  sel.setBaseAndExtent(node, 0, node, 1);
	                }
	              }
	            }
	          }
	        }
	
	        self.editor.fire('AfterSetSelectionRange', { range: rng, forward: forward });
	      },
	
	      /**
	       * Sets the current selection to the specified DOM element.
	       *
	       * @method setNode
	       * @param {Element} elm Element to set as the contents of the selection.
	       * @return {Element} Returns the element that got passed in.
	       * @example
	       * // Inserts a DOM node at current selection/caret location
	       * tinymce.activeEditor.selection.setNode(tinymce.activeEditor.dom.create('img', {src: 'some.gif', title: 'some title'}));
	       */
	      setNode: function (elm) {
	        var self = this;
	
	        self.setContent(self.dom.getOuterHTML(elm));
	
	        return elm;
	      },
	
	      /**
	       * Returns the currently selected element or the common ancestor element for both start and end of the selection.
	       *
	       * @method getNode
	       * @return {Element} Currently selected element or common ancestor element.
	       * @example
	       * // Alerts the currently selected elements node name
	       * alert(tinymce.activeEditor.selection.getNode().nodeName);
	       */
	      getNode: function () {
	        var self = this, rng = self.getRng(), elm;
	        var startContainer, endContainer, startOffset, endOffset, root = self.dom.getRoot();
	
	        var skipEmptyTextNodes = function (node, forwards) {
	          var orig = node;
	
	          while (node && node.nodeType === 3 && node.length === 0) {
	            node = forwards ? node.nextSibling : node.previousSibling;
	          }
	
	          return node || orig;
	        };
	
	        // Range maybe lost after the editor is made visible again
	        if (!rng) {
	          return root;
	        }
	
	        startContainer = rng.startContainer;
	        endContainer = rng.endContainer;
	        startOffset = rng.startOffset;
	        endOffset = rng.endOffset;
	        elm = rng.commonAncestorContainer;
	
	        // Handle selection a image or other control like element such as anchors
	        if (!rng.collapsed) {
	          if (startContainer == endContainer) {
	            if (endOffset - startOffset < 2) {
	              if (startContainer.hasChildNodes()) {
	                elm = startContainer.childNodes[startOffset];
	              }
	            }
	          }
	
	          // If the anchor node is a element instead of a text node then return this element
	          //if (tinymce.isWebKit && sel.anchorNode && sel.anchorNode.nodeType == 1)
	          // return sel.anchorNode.childNodes[sel.anchorOffset];
	
	          // Handle cases where the selection is immediately wrapped around a node and return that node instead of it's parent.
	          // This happens when you double click an underlined word in FireFox.
	          if (startContainer.nodeType === 3 && endContainer.nodeType === 3) {
	            if (startContainer.length === startOffset) {
	              startContainer = skipEmptyTextNodes(startContainer.nextSibling, true);
	            } else {
	              startContainer = startContainer.parentNode;
	            }
	
	            if (endOffset === 0) {
	              endContainer = skipEmptyTextNodes(endContainer.previousSibling, false);
	            } else {
	              endContainer = endContainer.parentNode;
	            }
	
	            if (startContainer && startContainer === endContainer) {
	              return startContainer;
	            }
	          }
	        }
	
	        if (elm && elm.nodeType == 3) {
	          return elm.parentNode;
	        }
	
	        return elm;
	      },
	
	      getSelectedBlocks: function (startElm, endElm) {
	        var self = this, dom = self.dom, node, root, selectedBlocks = [];
	
	        root = dom.getRoot();
	        startElm = dom.getParent(startElm || self.getStart(), dom.isBlock);
	        endElm = dom.getParent(endElm || self.getEnd(), dom.isBlock);
	
	        if (startElm && startElm != root) {
	          selectedBlocks.push(startElm);
	        }
	
	        if (startElm && endElm && startElm != endElm) {
	          node = startElm;
	
	          var walker = new TreeWalker(startElm, root);
	          while ((node = walker.next()) && node != endElm) {
	            if (dom.isBlock(node)) {
	              selectedBlocks.push(node);
	            }
	          }
	        }
	
	        if (endElm && startElm != endElm && endElm != root) {
	          selectedBlocks.push(endElm);
	        }
	
	        return selectedBlocks;
	      },
	
	      isForward: function () {
	        var dom = this.dom, sel = this.getSel(), anchorRange, focusRange;
	
	        // No support for selection direction then always return true
	        if (!sel || !sel.anchorNode || !sel.focusNode) {
	          return true;
	        }
	
	        anchorRange = dom.createRng();
	        anchorRange.setStart(sel.anchorNode, sel.anchorOffset);
	        anchorRange.collapse(true);
	
	        focusRange = dom.createRng();
	        focusRange.setStart(sel.focusNode, sel.focusOffset);
	        focusRange.collapse(true);
	
	        return anchorRange.compareBoundaryPoints(anchorRange.START_TO_START, focusRange) <= 0;
	      },
	
	      normalize: function () {
	        var self = this, rng = self.getRng();
	
	        if (!MultiRange.hasMultipleRanges(self.getSel())) {
	          var normRng = NormalizeRange.normalize(self.dom, rng);
	
	          normRng.each(function (normRng) {
	            self.setRng(normRng, self.isForward());
	          });
	
	          return normRng.getOr(rng);
	        }
	
	        return rng;
	      },
	
	      /**
	       * Executes callback when the current selection starts/stops matching the specified selector. The current
	       * state will be passed to the callback as it's first argument.
	       *
	       * @method selectorChanged
	       * @param {String} selector CSS selector to check for.
	       * @param {function} callback Callback with state and args when the selector is matches or not.
	       */
	      selectorChanged: function (selector, callback) {
	        var self = this, currentSelectors;
	
	        if (!self.selectorChangedData) {
	          self.selectorChangedData = {};
	          currentSelectors = {};
	
	          self.editor.on('NodeChange', function (e) {
	            var node = e.element, dom = self.dom, parents = dom.getParents(node, null, dom.getRoot()), matchedSelectors = {};
	
	            // Check for new matching selectors
	            each(self.selectorChangedData, function (callbacks, selector) {
	              each(parents, function (node) {
	                if (dom.is(node, selector)) {
	                  if (!currentSelectors[selector]) {
	                    // Execute callbacks
	                    each(callbacks, function (callback) {
	                      callback(true, { node: node, selector: selector, parents: parents });
	                    });
	
	                    currentSelectors[selector] = callbacks;
	                  }
	
	                  matchedSelectors[selector] = callbacks;
	                  return false;
	                }
	              });
	            });
	
	            // Check if current selectors still match
	            each(currentSelectors, function (callbacks, selector) {
	              if (!matchedSelectors[selector]) {
	                delete currentSelectors[selector];
	
	                each(callbacks, function (callback) {
	                  callback(false, { node: node, selector: selector, parents: parents });
	                });
	              }
	            });
	          });
	        }
	
	        // Add selector listeners
	        if (!self.selectorChangedData[selector]) {
	          self.selectorChangedData[selector] = [];
	        }
	
	        self.selectorChangedData[selector].push(callback);
	
	        return self;
	      },
	
	      getScrollContainer: function () {
	        var scrollContainer, node = this.dom.getRoot();
	
	        while (node && node.nodeName != 'BODY') {
	          if (node.scrollHeight > node.clientHeight) {
	            scrollContainer = node;
	            break;
	          }
	
	          node = node.parentNode;
	        }
	
	        return scrollContainer;
	      },
	
	      scrollIntoView: function (elm, alignToTop) {
	        ScrollIntoView.scrollIntoView(this.editor, elm, alignToTop);
	      },
	
	      placeCaretAt: function (clientX, clientY) {
	        this.setRng(CaretRangeFromPoint.fromPoint(clientX, clientY, this.editor.getDoc()));
	      },
	
	      _moveEndPoint: function (rng, node, start) {
	        var root = node, walker = new TreeWalker(node, root);
	        var nonEmptyElementsMap = this.dom.schema.getNonEmptyElements();
	
	        do {
	          // Text node
	          if (node.nodeType == 3 && trim(node.nodeValue).length !== 0) {
	            if (start) {
	              rng.setStart(node, 0);
	            } else {
	              rng.setEnd(node, node.nodeValue.length);
	            }
	
	            return;
	          }
	
	          // BR/IMG/INPUT elements but not table cells
	          if (nonEmptyElementsMap[node.nodeName] && !/^(TD|TH)$/.test(node.nodeName)) {
	            if (start) {
	              rng.setStartBefore(node);
	            } else {
	              if (node.nodeName == 'BR') {
	                rng.setEndBefore(node);
	              } else {
	                rng.setEndAfter(node);
	              }
	            }
	
	            return;
	          }
	
	          // Found empty text block old IE can place the selection inside those
	          if (Env.ie && Env.ie < 11 && this.dom.isBlock(node) && this.dom.isEmpty(node)) {
	            if (start) {
	              rng.setStart(node, 0);
	            } else {
	              rng.setEnd(node, 0);
	            }
	
	            return;
	          }
	        } while ((node = (start ? walker.next() : walker.prev())));
	
	        // Failed to find any text node or other suitable location then move to the root of body
	        if (root.nodeName == 'BODY') {
	          if (start) {
	            rng.setStart(root, 0);
	          } else {
	            rng.setEnd(root, root.childNodes.length);
	          }
	        }
	      },
	
	      getBoundingClientRect: function () {
	        var rng = this.getRng();
	        return rng.collapsed ? CaretPosition.fromRangeStart(rng).getClientRects()[0] : rng.getBoundingClientRect();
	      },
	
	      destroy: function () {
	        this.win = null;
	        this.controlSelection.destroy();
	      }
	    };
	
	    return Selection;
	  }
	);
	
	/**
	 * LineWalker.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module lets you walk the document line by line
	 * returing nodes and client rects for each line.
	 *
	 * @private
	 * @class tinymce.caret.LineWalker
	 */
	define(
	  'tinymce.core.caret.LineWalker',
	  [
	    "tinymce.core.util.Fun",
	    "tinymce.core.util.Arr",
	    "tinymce.core.dom.Dimensions",
	    "tinymce.core.caret.CaretCandidate",
	    "tinymce.core.caret.CaretUtils",
	    "tinymce.core.caret.CaretWalker",
	    "tinymce.core.caret.CaretPosition",
	    "tinymce.core.geom.ClientRect"
	  ],
	  function (Fun, Arr, Dimensions, CaretCandidate, CaretUtils, CaretWalker, CaretPosition, ClientRect) {
	    var curry = Fun.curry;
	
	    var findUntil = function (direction, rootNode, predicateFn, node) {
	      while ((node = CaretUtils.findNode(node, direction, CaretCandidate.isEditableCaretCandidate, rootNode))) {
	        if (predicateFn(node)) {
	          return;
	        }
	      }
	    };
	
	    var walkUntil = function (direction, isAboveFn, isBeflowFn, rootNode, predicateFn, caretPosition) {
	      var line = 0, node, result = [], targetClientRect;
	
	      var add = function (node) {
	        var i, clientRect, clientRects;
	
	        clientRects = Dimensions.getClientRects(node);
	        if (direction == -1) {
	          clientRects = clientRects.reverse();
	        }
	
	        for (i = 0; i < clientRects.length; i++) {
	          clientRect = clientRects[i];
	          if (isBeflowFn(clientRect, targetClientRect)) {
	            continue;
	          }
	
	          if (result.length > 0 && isAboveFn(clientRect, Arr.last(result))) {
	            line++;
	          }
	
	          clientRect.line = line;
	
	          if (predicateFn(clientRect)) {
	            return true;
	          }
	
	          result.push(clientRect);
	        }
	      };
	
	      targetClientRect = Arr.last(caretPosition.getClientRects());
	      if (!targetClientRect) {
	        return result;
	      }
	
	      node = caretPosition.getNode();
	      add(node);
	      findUntil(direction, rootNode, add, node);
	
	      return result;
	    };
	
	    var aboveLineNumber = function (lineNumber, clientRect) {
	      return clientRect.line > lineNumber;
	    };
	
	    var isLine = function (lineNumber, clientRect) {
	      return clientRect.line === lineNumber;
	    };
	
	    var upUntil = curry(walkUntil, -1, ClientRect.isAbove, ClientRect.isBelow);
	    var downUntil = curry(walkUntil, 1, ClientRect.isBelow, ClientRect.isAbove);
	
	    var positionsUntil = function (direction, rootNode, predicateFn, node) {
	      var caretWalker = new CaretWalker(rootNode), walkFn, isBelowFn, isAboveFn,
	        caretPosition, result = [], line = 0, clientRect, targetClientRect;
	
	      var getClientRect = function (caretPosition) {
	        if (direction == 1) {
	          return Arr.last(caretPosition.getClientRects());
	        }
	
	        return Arr.last(caretPosition.getClientRects());
	      };
	
	      if (direction == 1) {
	        walkFn = caretWalker.next;
	        isBelowFn = ClientRect.isBelow;
	        isAboveFn = ClientRect.isAbove;
	        caretPosition = CaretPosition.after(node);
	      } else {
	        walkFn = caretWalker.prev;
	        isBelowFn = ClientRect.isAbove;
	        isAboveFn = ClientRect.isBelow;
	        caretPosition = CaretPosition.before(node);
	      }
	
	      targetClientRect = getClientRect(caretPosition);
	
	      do {
	        if (!caretPosition.isVisible()) {
	          continue;
	        }
	
	        clientRect = getClientRect(caretPosition);
	
	        if (isAboveFn(clientRect, targetClientRect)) {
	          continue;
	        }
	
	        if (result.length > 0 && isBelowFn(clientRect, Arr.last(result))) {
	          line++;
	        }
	
	        clientRect = ClientRect.clone(clientRect);
	        clientRect.position = caretPosition;
	        clientRect.line = line;
	
	        if (predicateFn(clientRect)) {
	          return result;
	        }
	
	        result.push(clientRect);
	      } while ((caretPosition = walkFn(caretPosition)));
	
	      return result;
	    };
	
	    return {
	      upUntil: upUntil,
	      downUntil: downUntil,
	
	      /**
	       * Find client rects with line and caret position until the predicate returns true.
	       *
	       * @method positionsUntil
	       * @param {Number} direction Direction forward/backward 1/-1.
	       * @param {DOMNode} rootNode Root node to walk within.
	       * @param {function} predicateFn Gets the client rect as it's input.
	       * @param {DOMNode} node Node to start walking from.
	       * @return {Array} Array of client rects with line and position properties.
	       */
	      positionsUntil: positionsUntil,
	
	      isAboveLine: curry(aboveLineNumber),
	      isLine: curry(isLine)
	    };
	  }
	);
	/**
	 * CefNavigation.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.CefNavigation',
	  [
	    'tinymce.core.Env',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.caret.CaretUtils',
	    'tinymce.core.caret.CaretWalker',
	    'tinymce.core.caret.LineUtils',
	    'tinymce.core.caret.LineWalker',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.keyboard.CefUtils',
	    'tinymce.core.selection.RangeNodes',
	    'tinymce.core.util.Arr',
	    'tinymce.core.util.Fun'
	  ],
	  function (Env, CaretContainer, CaretPosition, CaretUtils, CaretWalker, LineUtils, LineWalker, NodeType, CefUtils, RangeNodes, Arr, Fun) {
	    var isContentEditableFalse = NodeType.isContentEditableFalse;
	    var getSelectedNode = RangeNodes.getSelectedNode;
	    var isAfterContentEditableFalse = CaretUtils.isAfterContentEditableFalse;
	    var isBeforeContentEditableFalse = CaretUtils.isBeforeContentEditableFalse;
	
	    var getVisualCaretPosition = function (walkFn, caretPosition) {
	      while ((caretPosition = walkFn(caretPosition))) {
	        if (caretPosition.isVisible()) {
	          return caretPosition;
	        }
	      }
	
	      return caretPosition;
	    };
	
	    var isMoveInsideSameBlock = function (fromCaretPosition, toCaretPosition) {
	      var inSameBlock = CaretUtils.isInSameBlock(fromCaretPosition, toCaretPosition);
	
	      // Handle bogus BR <p>abc|<br></p>
	      if (!inSameBlock && NodeType.isBr(fromCaretPosition.getNode())) {
	        return true;
	      }
	
	      return inSameBlock;
	    };
	
	    var isRangeInCaretContainerBlock = function (range) {
	      return CaretContainer.isCaretContainerBlock(range.startContainer);
	    };
	
	    var getNormalizedRangeEndPoint = function (direction, rootNode, range) {
	      range = CaretUtils.normalizeRange(direction, rootNode, range);
	
	      if (direction === -1) {
	        return CaretPosition.fromRangeStart(range);
	      }
	
	      return CaretPosition.fromRangeEnd(range);
	    };
	
	    var moveToCeFalseHorizontally = function (direction, editor, getNextPosFn, isBeforeContentEditableFalseFn, range) {
	      var node, caretPosition, peekCaretPosition, rangeIsInContainerBlock;
	
	      if (!range.collapsed) {
	        node = getSelectedNode(range);
	        if (isContentEditableFalse(node)) {
	          return CefUtils.showCaret(direction, editor, node, direction === -1);
	        }
	      }
	
	      rangeIsInContainerBlock = isRangeInCaretContainerBlock(range);
	      caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	
	      if (isBeforeContentEditableFalseFn(caretPosition)) {
	        return CefUtils.selectNode(editor, caretPosition.getNode(direction === -1));
	      }
	
	      caretPosition = getNextPosFn(caretPosition);
	      if (!caretPosition) {
	        if (rangeIsInContainerBlock) {
	          return range;
	        }
	
	        return null;
	      }
	
	      if (isBeforeContentEditableFalseFn(caretPosition)) {
	        return CefUtils.showCaret(direction, editor, caretPosition.getNode(direction === -1), direction === 1);
	      }
	
	      // Peek ahead for handling of ab|c<span cE=false> -> abc|<span cE=false>
	      peekCaretPosition = getNextPosFn(caretPosition);
	      if (isBeforeContentEditableFalseFn(peekCaretPosition)) {
	        if (isMoveInsideSameBlock(caretPosition, peekCaretPosition)) {
	          return CefUtils.showCaret(direction, editor, peekCaretPosition.getNode(direction === -1), direction === 1);
	        }
	      }
	
	      if (rangeIsInContainerBlock) {
	        return CefUtils.renderRangeCaret(editor, caretPosition.toRange());
	      }
	
	      return null;
	    };
	
	    var moveToCeFalseVertically = function (direction, editor, walkerFn, range) {
	      var caretPosition, linePositions, nextLinePositions,
	        closestNextLineRect, caretClientRect, clientX,
	        dist1, dist2, contentEditableFalseNode;
	
	      contentEditableFalseNode = getSelectedNode(range);
	      caretPosition = getNormalizedRangeEndPoint(direction, editor.getBody(), range);
	      linePositions = walkerFn(editor.getBody(), LineWalker.isAboveLine(1), caretPosition);
	      nextLinePositions = Arr.filter(linePositions, LineWalker.isLine(1));
	      caretClientRect = Arr.last(caretPosition.getClientRects());
	
	      if (isBeforeContentEditableFalse(caretPosition)) {
	        contentEditableFalseNode = caretPosition.getNode();
	      }
	
	      if (isAfterContentEditableFalse(caretPosition)) {
	        contentEditableFalseNode = caretPosition.getNode(true);
	      }
	
	      if (!caretClientRect) {
	        return null;
	      }
	
	      clientX = caretClientRect.left;
	
	      closestNextLineRect = LineUtils.findClosestClientRect(nextLinePositions, clientX);
	      if (closestNextLineRect) {
	        if (isContentEditableFalse(closestNextLineRect.node)) {
	          dist1 = Math.abs(clientX - closestNextLineRect.left);
	          dist2 = Math.abs(clientX - closestNextLineRect.right);
	
	          return CefUtils.showCaret(direction, editor, closestNextLineRect.node, dist1 < dist2);
	        }
	      }
	
	      if (contentEditableFalseNode) {
	        var caretPositions = LineWalker.positionsUntil(direction, editor.getBody(), LineWalker.isAboveLine(1), contentEditableFalseNode);
	
	        closestNextLineRect = LineUtils.findClosestClientRect(Arr.filter(caretPositions, LineWalker.isLine(1)), clientX);
	        if (closestNextLineRect) {
	          return CefUtils.renderRangeCaret(editor, closestNextLineRect.position.toRange());
	        }
	
	        closestNextLineRect = Arr.last(Arr.filter(caretPositions, LineWalker.isLine(0)));
	        if (closestNextLineRect) {
	          return CefUtils.renderRangeCaret(editor, closestNextLineRect.position.toRange());
	        }
	      }
	    };
	
	    var createTextBlock = function (editor) {
	      var textBlock = editor.dom.create(editor.settings.forced_root_block);
	
	      if (!Env.ie || Env.ie >= 11) {
	        textBlock.innerHTML = '<br data-mce-bogus="1">';
	      }
	
	      return textBlock;
	    };
	
	    var exitPreBlock = function (editor, direction, range) {
	      var pre, caretPos, newBlock;
	      var caretWalker = new CaretWalker(editor.getBody());
	      var getNextVisualCaretPosition = Fun.curry(getVisualCaretPosition, caretWalker.next);
	      var getPrevVisualCaretPosition = Fun.curry(getVisualCaretPosition, caretWalker.prev);
	
	      if (range.collapsed && editor.settings.forced_root_block) {
	        pre = editor.dom.getParent(range.startContainer, 'PRE');
	        if (!pre) {
	          return;
	        }
	
	        if (direction === 1) {
	          caretPos = getNextVisualCaretPosition(CaretPosition.fromRangeStart(range));
	        } else {
	          caretPos = getPrevVisualCaretPosition(CaretPosition.fromRangeStart(range));
	        }
	
	        if (!caretPos) {
	          newBlock = createTextBlock(editor);
	
	          if (direction === 1) {
	            editor.$(pre).after(newBlock);
	          } else {
	            editor.$(pre).before(newBlock);
	          }
	
	          editor.selection.select(newBlock, true);
	          editor.selection.collapse();
	        }
	      }
	    };
	
	    var getHorizontalRange = function (editor, forward) {
	      var caretWalker = new CaretWalker(editor.getBody());
	      var getNextVisualCaretPosition = Fun.curry(getVisualCaretPosition, caretWalker.next);
	      var getPrevVisualCaretPosition = Fun.curry(getVisualCaretPosition, caretWalker.prev);
	      var newRange, direction = forward ? 1 : -1;
	      var getNextPosFn = forward ? getNextVisualCaretPosition : getPrevVisualCaretPosition;
	      var isBeforeContentEditableFalseFn = forward ? isBeforeContentEditableFalse : isAfterContentEditableFalse;
	      var range = editor.selection.getRng();
	
	      newRange = moveToCeFalseHorizontally(direction, editor, getNextPosFn, isBeforeContentEditableFalseFn, range);
	      if (newRange) {
	        return newRange;
	      }
	
	      newRange = exitPreBlock(editor, direction, range);
	      if (newRange) {
	        return newRange;
	      }
	
	      return null;
	    };
	
	    var getVerticalRange = function (editor, down) {
	      var newRange, direction = down ? 1 : -1;
	      var walkerFn = down ? LineWalker.downUntil : LineWalker.upUntil;
	      var range = editor.selection.getRng();
	
	      newRange = moveToCeFalseVertically(direction, editor, walkerFn, range);
	      if (newRange) {
	        return newRange;
	      }
	
	      newRange = exitPreBlock(editor, direction, range);
	      if (newRange) {
	        return newRange;
	      }
	
	      return null;
	    };
	
	    var moveH = function (editor, forward) {
	      return function () {
	        var newRng = getHorizontalRange(editor, forward);
	
	        if (newRng) {
	          editor.selection.setRng(newRng);
	          return true;
	        } else {
	          return false;
	        }
	      };
	    };
	
	    var moveV = function (editor, down) {
	      return function () {
	        var newRng = getVerticalRange(editor, down);
	
	        if (newRng) {
	          editor.selection.setRng(newRng);
	          return true;
	        } else {
	          return false;
	        }
	      };
	    };
	
	    return {
	      moveH: moveH,
	      moveV: moveV
	    };
	  }
	);
	
	/**
	 * MatchKeys.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.MatchKeys',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Merger'
	  ],
	  function (Arr, Fun, Merger) {
	    var defaultPatterns = function (patterns) {
	      return Arr.map(patterns, function (pattern) {
	        return Merger.merge({
	          shiftKey: false,
	          altKey: false,
	          ctrlKey: false,
	          metaKey: false,
	          keyCode: 0,
	          action: Fun.noop
	        }, pattern);
	      });
	    };
	
	    var matchesEvent = function (pattern, evt) {
	      return (
	        evt.keyCode === pattern.keyCode &&
	        evt.shiftKey === pattern.shiftKey &&
	        evt.altKey === pattern.altKey &&
	        evt.ctrlKey === pattern.ctrlKey &&
	        evt.metaKey === pattern.metaKey
	      );
	    };
	
	    var match = function (patterns, evt) {
	      return Arr.bind(defaultPatterns(patterns), function (pattern) {
	        return matchesEvent(pattern, evt) ? [pattern] : [ ];
	      });
	    };
	
	    var action = function (f) {
	      var args = Array.prototype.slice.call(arguments, 1);
	      return function () {
	        return f.apply(null, args);
	      };
	    };
	
	    var execute = function (patterns, evt) {
	      return Arr.find(match(patterns, evt), function (pattern) {
	        return pattern.action();
	      });
	    };
	
	    return {
	      match: match,
	      action: action,
	      execute: execute
	    };
	  }
	);
	/**
	 * ArrowKeys.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.ArrowKeys',
	  [
	    'ephox.sand.api.PlatformDetection',
	    'tinymce.core.keyboard.BoundarySelection',
	    'tinymce.core.keyboard.CefNavigation',
	    'tinymce.core.keyboard.MatchKeys',
	    'tinymce.core.util.VK'
	  ],
	  function (PlatformDetection, BoundarySelection, CefNavigation, MatchKeys, VK) {
	    var executeKeydownOverride = function (editor, caret, evt) {
	      var os = PlatformDetection.detect().os;
	
	      MatchKeys.execute([
	        { keyCode: VK.RIGHT, action: CefNavigation.moveH(editor, true) },
	        { keyCode: VK.LEFT, action: CefNavigation.moveH(editor, false) },
	        { keyCode: VK.UP, action: CefNavigation.moveV(editor, false) },
	        { keyCode: VK.DOWN, action: CefNavigation.moveV(editor, true) },
	        { keyCode: VK.RIGHT, action: BoundarySelection.move(editor, caret, true) },
	        { keyCode: VK.LEFT, action: BoundarySelection.move(editor, caret, false) },
	        { keyCode: VK.RIGHT, ctrlKey: !os.isOSX(), altKey: os.isOSX(), action: BoundarySelection.moveNextWord(editor, caret) },
	        { keyCode: VK.LEFT, ctrlKey: !os.isOSX(), altKey: os.isOSX(), action: BoundarySelection.movePrevWord(editor, caret) }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	
	    var setup = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride(editor, caret, evt);
	        }
	      });
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	/**
	 * InlineFormatDelete.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.delete.InlineFormatDelete',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Fun',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.Traverse',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.delete.DeleteElement',
	    'tinymce.core.delete.DeleteUtils',
	    'tinymce.core.dom.ElementType',
	    'tinymce.core.dom.Parents',
	    'tinymce.core.fmt.CaretFormat'
	  ],
	  function (Arr, Fun, Element, Traverse, CaretPosition, DeleteElement, DeleteUtils, ElementType, Parents, CaretFormat) {
	    var getParentInlines = function (rootElm, startElm) {
	      var parents = Parents.parentsAndSelf(startElm, rootElm);
	      return Arr.findIndex(parents, ElementType.isBlock).fold(
	        Fun.constant(parents),
	        function (index) {
	          return parents.slice(0, index);
	        }
	      );
	    };
	
	    var hasOnlyOneChild = function (elm) {
	      return Traverse.children(elm).length === 1;
	    };
	
	    var deleteLastPosition = function (forward, editor, target, parentInlines) {
	      var isFormatElement = Fun.curry(CaretFormat.isFormatElement, editor);
	      var formatNodes = Arr.map(Arr.filter(parentInlines, isFormatElement), function (elm) {
	        return elm.dom();
	      });
	
	      if (formatNodes.length === 0) {
	        DeleteElement.deleteElement(editor, forward, target);
	      } else {
	        var pos = CaretFormat.replaceWithCaretFormat(target.dom(), formatNodes);
	        editor.selection.setRng(pos.toRange());
	      }
	    };
	
	    var deleteCaret = function (editor, forward) {
	      var rootElm = Element.fromDom(editor.getBody());
	      var startElm = Element.fromDom(editor.selection.getStart());
	      var parentInlines = Arr.filter(getParentInlines(rootElm, startElm), hasOnlyOneChild);
	
	      return Arr.last(parentInlines).map(function (target) {
	        var fromPos = CaretPosition.fromRangeStart(editor.selection.getRng());
	        if (DeleteUtils.willDeleteLastPositionInElement(forward, fromPos, target.dom())) {
	          deleteLastPosition(forward, editor, target, parentInlines);
	          return true;
	        } else {
	          return false;
	        }
	      }).getOr(false);
	    };
	
	    var backspaceDelete = function (editor, forward) {
	      return editor.selection.isCollapsed() ? deleteCaret(editor, forward) : false;
	    };
	
	    return {
	      backspaceDelete: backspaceDelete
	    };
	  }
	);
	
	/**
	 * DeleteBackspaceKeys.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.DeleteBackspaceKeys',
	  [
	    'tinymce.core.delete.BlockBoundaryDelete',
	    'tinymce.core.delete.BlockRangeDelete',
	    'tinymce.core.delete.CefDelete',
	    'tinymce.core.delete.InlineBoundaryDelete',
	    'tinymce.core.delete.InlineFormatDelete',
	    'tinymce.core.delete.TableDelete',
	    'tinymce.core.keyboard.MatchKeys',
	    'tinymce.core.util.VK'
	  ],
	  function (BlockBoundaryDelete, BlockRangeDelete, CefDelete, InlineBoundaryDelete, InlineFormatDelete, TableDelete, MatchKeys, VK) {
	    var executeKeydownOverride = function (editor, caret, evt) {
	      MatchKeys.execute([
	        { keyCode: VK.BACKSPACE, action: MatchKeys.action(CefDelete.backspaceDelete, editor, false) },
	        { keyCode: VK.DELETE, action: MatchKeys.action(CefDelete.backspaceDelete, editor, true) },
	        { keyCode: VK.BACKSPACE, action: MatchKeys.action(InlineBoundaryDelete.backspaceDelete, editor, caret, false) },
	        { keyCode: VK.DELETE, action: MatchKeys.action(InlineBoundaryDelete.backspaceDelete, editor, caret, true) },
	        { keyCode: VK.BACKSPACE, action: MatchKeys.action(BlockRangeDelete.backspaceDelete, editor, false) },
	        { keyCode: VK.DELETE, action: MatchKeys.action(BlockRangeDelete.backspaceDelete, editor, true) },
	        { keyCode: VK.BACKSPACE, action: MatchKeys.action(BlockBoundaryDelete.backspaceDelete, editor, false) },
	        { keyCode: VK.DELETE, action: MatchKeys.action(BlockBoundaryDelete.backspaceDelete, editor, true) },
	        { keyCode: VK.BACKSPACE, action: MatchKeys.action(TableDelete.backspaceDelete, editor, false) },
	        { keyCode: VK.DELETE, action: MatchKeys.action(TableDelete.backspaceDelete, editor, true) },
	        { keyCode: VK.BACKSPACE, action: MatchKeys.action(InlineFormatDelete.backspaceDelete, editor, false) },
	        { keyCode: VK.DELETE, action: MatchKeys.action(InlineFormatDelete.backspaceDelete, editor, true) }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	
	    var executeKeyupOverride = function (editor, evt) {
	      MatchKeys.execute([
	        { keyCode: VK.BACKSPACE, action: MatchKeys.action(CefDelete.paddEmptyElement, editor) },
	        { keyCode: VK.DELETE, action: MatchKeys.action(CefDelete.paddEmptyElement, editor) }
	      ], evt);
	    };
	
	    var setup = function (editor, caret) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride(editor, caret, evt);
	        }
	      });
	
	      editor.on('keyup', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeyupOverride(editor, evt);
	        }
	      });
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	/**
	 * Settings.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2016 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.api.Settings',
	  [
	  ],
	  function () {
	    var getBodySetting = function (editor, name, defaultValue) {
	      var value = editor.getParam(name, defaultValue);
	
	      if (value.indexOf('=') !== -1) {
	        var bodyObj = editor.getParam(name, '', 'hash');
	        return bodyObj.hasOwnProperty(editor.id) ? bodyObj[editor.id] : defaultValue;
	      } else {
	        return value;
	      }
	    };
	
	    var getIframeAttrs = function (editor) {
	      return editor.getParam('iframe_attrs', {});
	    };
	
	    var getDocType = function (editor) {
	      return editor.getParam('doctype', '<!DOCTYPE html>');
	    };
	
	    var getDocumentBaseUrl = function (editor) {
	      return editor.getParam('document_base_url', '');
	    };
	
	    var getBodyId = function (editor) {
	      return getBodySetting(editor, 'body_id', 'tinymce');
	    };
	
	    var getBodyClass = function (editor) {
	      return getBodySetting(editor, 'body_class', '');
	    };
	
	    var getContentSecurityPolicy = function (editor) {
	      return editor.getParam('content_security_policy', '');
	    };
	
	    var shouldPutBrInPre = function (editor) {
	      return editor.getParam('br_in_pre', true);
	    };
	
	    var getForcedRootBlock = function (editor) {
	      // Legacy option
	      if (editor.getParam('force_p_newlines', false)) {
	        return 'p';
	      }
	
	      var block = editor.getParam('forced_root_block', 'p');
	      return block === false ? '' : block;
	    };
	
	    var getForcedRootBlockAttrs = function (editor) {
	      return editor.getParam('forced_root_block_attrs', {});
	    };
	
	    var getBrNewLineSelector = function (editor) {
	      return editor.getParam('br_newline_selector', '.mce-toc h2,figcaption,caption');
	    };
	
	    var getNoNewLineSelector = function (editor) {
	      return editor.getParam('no_newline_selector', '');
	    };
	
	    var shouldKeepStyles = function (editor) {
	      return editor.getParam('keep_styles', true);
	    };
	
	    var shouldEndContainerOnEmtpyBlock = function (editor) {
	      return editor.getParam('end_container_on_empty_block', false);
	    };
	
	    return {
	      getIframeAttrs: getIframeAttrs,
	      getDocType: getDocType,
	      getDocumentBaseUrl: getDocumentBaseUrl,
	      getBodyId: getBodyId,
	      getBodyClass: getBodyClass,
	      getContentSecurityPolicy: getContentSecurityPolicy,
	      shouldPutBrInPre: shouldPutBrInPre,
	      getForcedRootBlock: getForcedRootBlock,
	      getForcedRootBlockAttrs: getForcedRootBlockAttrs,
	      getBrNewLineSelector: getBrNewLineSelector,
	      getNoNewLineSelector: getNoNewLineSelector,
	      shouldKeepStyles: shouldKeepStyles,
	      shouldEndContainerOnEmtpyBlock: shouldEndContainerOnEmtpyBlock
	    };
	  }
	);
	
	/**
	 * NewLineUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.newline.NewLineUtils',
	  [
	    'ephox.katamari.api.Fun',
	    'ephox.katamari.api.Option',
	    'ephox.sugar.api.node.Element',
	    'tinymce.core.dom.ElementType',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.TreeWalker'
	  ],
	  function (Fun, Option, Element, ElementType, NodeType, TreeWalker) {
	    var firstNonWhiteSpaceNodeSibling = function (node) {
	      while (node) {
	        if (node.nodeType === 1 || (node.nodeType === 3 && node.data && /[\r\n\s]/.test(node.data))) {
	          return node;
	        }
	
	        node = node.nextSibling;
	      }
	    };
	
	    var moveToCaretPosition = function (editor, root) {
	      var walker, node, rng, lastNode = root, tempElm, dom = editor.dom;
	      var moveCaretBeforeOnEnterElementsMap = editor.schema.getMoveCaretBeforeOnEnterElements();
	
	      if (!root) {
	        return;
	      }
	
	      if (/^(LI|DT|DD)$/.test(root.nodeName)) {
	        var firstChild = firstNonWhiteSpaceNodeSibling(root.firstChild);
	
	        if (firstChild && /^(UL|OL|DL)$/.test(firstChild.nodeName)) {
	          root.insertBefore(dom.doc.createTextNode('\u00a0'), root.firstChild);
	        }
	      }
	
	      rng = dom.createRng();
	      root.normalize();
	
	      if (root.hasChildNodes()) {
	        walker = new TreeWalker(root, root);
	
	        while ((node = walker.current())) {
	          if (NodeType.isText(node)) {
	            rng.setStart(node, 0);
	            rng.setEnd(node, 0);
	            break;
	          }
	
	          if (moveCaretBeforeOnEnterElementsMap[node.nodeName.toLowerCase()]) {
	            rng.setStartBefore(node);
	            rng.setEndBefore(node);
	            break;
	          }
	
	          lastNode = node;
	          node = walker.next();
	        }
	
	        if (!node) {
	          rng.setStart(lastNode, 0);
	          rng.setEnd(lastNode, 0);
	        }
	      } else {
	        if (NodeType.isBr(root)) {
	          if (root.nextSibling && dom.isBlock(root.nextSibling)) {
	            rng.setStartBefore(root);
	            rng.setEndBefore(root);
	          } else {
	            rng.setStartAfter(root);
	            rng.setEndAfter(root);
	          }
	        } else {
	          rng.setStart(root, 0);
	          rng.setEnd(root, 0);
	        }
	      }
	
	      editor.selection.setRng(rng);
	
	      // Remove tempElm created for old IE:s
	      dom.remove(tempElm);
	      editor.selection.scrollIntoView(root);
	    };
	
	    var getEditableRoot = function (dom, node) {
	      var root = dom.getRoot(), parent, editableRoot;
	
	      // Get all parents until we hit a non editable parent or the root
	      parent = node;
	      while (parent !== root && dom.getContentEditable(parent) !== "false") {
	        if (dom.getContentEditable(parent) === "true") {
	          editableRoot = parent;
	        }
	
	        parent = parent.parentNode;
	      }
	
	      return parent !== root ? editableRoot : root;
	    };
	
	    var getParentBlock = function (editor) {
	      return Option.from(editor.dom.getParent(editor.selection.getStart(true), editor.dom.isBlock));
	    };
	
	    var getParentBlockName = function (editor) {
	      return getParentBlock(editor).fold(
	        Fun.constant(''),
	        function (parentBlock) {
	          return parentBlock.nodeName.toUpperCase();
	        }
	      );
	    };
	
	    var isListItemParentBlock = function (editor) {
	      return getParentBlock(editor).filter(function (elm) {
	        return ElementType.isListItem(Element.fromDom(elm));
	      }).isSome();
	    };
	
	    return {
	      moveToCaretPosition: moveToCaretPosition,
	      getEditableRoot: getEditableRoot,
	      getParentBlock: getParentBlock,
	      getParentBlockName: getParentBlockName,
	      isListItemParentBlock: isListItemParentBlock
	    };
	  }
	);
	
	/**
	 * InsertLi.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.newline.InsertLi',
	  [
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.newline.NewLineUtils'
	  ],
	  function (NodeType, NewLineUtils) {
	    var hasFirstChild = function (elm, name) {
	      return elm.firstChild && elm.firstChild.nodeName === name;
	    };
	
	    var hasParent = function (elm, parentName) {
	      return elm && elm.parentNode && elm.parentNode.nodeName === parentName;
	    };
	
	    var isListBlock = function (elm) {
	      return elm && /^(OL|UL|LI)$/.test(elm.nodeName);
	    };
	
	    var isNestedList = function (elm) {
	      return isListBlock(elm) && isListBlock(elm.parentNode);
	    };
	
	    var getContainerBlock = function (containerBlock) {
	      var containerBlockParent = containerBlock.parentNode;
	
	      if (/^(LI|DT|DD)$/.test(containerBlockParent.nodeName)) {
	        return containerBlockParent;
	      }
	
	      return containerBlock;
	    };
	
	    var isFirstOrLastLi = function (containerBlock, parentBlock, first) {
	      var node = containerBlock[first ? 'firstChild' : 'lastChild'];
	
	      // Find first/last element since there might be whitespace there
	      while (node) {
	        if (NodeType.isElement(node)) {
	          break;
	        }
	
	        node = node[first ? 'nextSibling' : 'previousSibling'];
	      }
	
	      return node === parentBlock;
	    };
	
	    // Inserts a block or br before/after or in the middle of a split list of the LI is empty
	    var insert = function (editor, createNewBlock, containerBlock, parentBlock, newBlockName) {
	      var dom = editor.dom;
	      var rng = editor.selection.getRng();
	
	      if (containerBlock === editor.getBody()) {
	        return;
	      }
	
	      if (isNestedList(containerBlock)) {
	        newBlockName = 'LI';
	      }
	
	      var newBlock = newBlockName ? createNewBlock(newBlockName) : dom.create('BR');
	
	      if (isFirstOrLastLi(containerBlock, parentBlock, true) && isFirstOrLastLi(containerBlock, parentBlock, false)) {
	        if (hasParent(containerBlock, 'LI')) {
	          // Nested list is inside a LI
	          dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	        } else {
	          // Is first and last list item then replace the OL/UL with a text block
	          dom.replace(newBlock, containerBlock);
	        }
	      } else if (isFirstOrLastLi(containerBlock, parentBlock, true)) {
	        if (hasParent(containerBlock, 'LI')) {
	          // List nested in an LI then move the list to a new sibling LI
	          dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	          newBlock.appendChild(dom.doc.createTextNode(' ')); // Needed for IE so the caret can be placed
	          newBlock.appendChild(containerBlock);
	        } else {
	          // First LI in list then remove LI and add text block before list
	          containerBlock.parentNode.insertBefore(newBlock, containerBlock);
	        }
	      } else if (isFirstOrLastLi(containerBlock, parentBlock, false)) {
	        // Last LI in list then remove LI and add text block after list
	        dom.insertAfter(newBlock, getContainerBlock(containerBlock));
	      } else {
	        // Middle LI in list the split the list and insert a text block in the middle
	        // Extract after fragment and insert it after the current block
	        containerBlock = getContainerBlock(containerBlock);
	        var tmpRng = rng.cloneRange();
	        tmpRng.setStartAfter(parentBlock);
	        tmpRng.setEndAfter(containerBlock);
	        var fragment = tmpRng.extractContents();
	
	        if (newBlockName === 'LI' && hasFirstChild(fragment, 'LI')) {
	          newBlock = fragment.firstChild;
	          dom.insertAfter(fragment, containerBlock);
	        } else {
	          dom.insertAfter(fragment, containerBlock);
	          dom.insertAfter(newBlock, containerBlock);
	        }
	      }
	
	      dom.remove(parentBlock);
	      NewLineUtils.moveToCaretPosition(editor, newBlock);
	    };
	
	    return {
	      insert: insert
	    };
	  }
	);
	
	/**
	 * InsertBlock.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.newline.InsertBlock',
	  [
	    'tinymce.core.api.Settings',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.dom.TreeWalker',
	    'tinymce.core.fmt.CaretFormat',
	    'tinymce.core.newline.InsertLi',
	    'tinymce.core.newline.NewLineUtils',
	    'tinymce.core.selection.NormalizeRange',
	    'tinymce.core.text.Zwsp',
	    'tinymce.core.util.Tools'
	  ],
	  function (Settings, CaretContainer, NodeType, TreeWalker, CaretFormat, InsertLi, NewLineUtils, NormalizeRange, Zwsp, Tools) {
	    var isEmptyAnchor = function (elm) {
	      return elm && elm.nodeName === "A" && Tools.trim(Zwsp.trim(elm.innerText || elm.textContent)).length === 0;
	    };
	
	    var isTableCell = function (node) {
	      return node && /^(TD|TH|CAPTION)$/.test(node.nodeName);
	    };
	
	    var emptyBlock = function (elm) {
	      elm.innerHTML = '<br data-mce-bogus="1">';
	    };
	
	    var containerAndSiblingName = function (container, nodeName) {
	      return container.nodeName === nodeName || (container.previousSibling && container.previousSibling.nodeName === nodeName);
	    };
	
	    // Returns true if the block can be split into two blocks or not
	    var canSplitBlock = function (dom, node) {
	      return node &&
	        dom.isBlock(node) &&
	        !/^(TD|TH|CAPTION|FORM)$/.test(node.nodeName) &&
	        !/^(fixed|absolute)/i.test(node.style.position) &&
	        dom.getContentEditable(node) !== "true";
	    };
	
	    // Remove the first empty inline element of the block so this: <p><b><em></em></b>x</p> becomes this: <p>x</p>
	    var trimInlineElementsOnLeftSideOfBlock = function (dom, nonEmptyElementsMap, block) {
	      var node = block, firstChilds = [], i;
	
	      if (!node) {
	        return;
	      }
	
	      // Find inner most first child ex: <p><i><b>*</b></i></p>
	      while ((node = node.firstChild)) {
	        if (dom.isBlock(node)) {
	          return;
	        }
	
	        if (NodeType.isElement(node) && !nonEmptyElementsMap[node.nodeName.toLowerCase()]) {
	          firstChilds.push(node);
	        }
	      }
	
	      i = firstChilds.length;
	      while (i--) {
	        node = firstChilds[i];
	        if (!node.hasChildNodes() || (node.firstChild === node.lastChild && node.firstChild.nodeValue === '')) {
	          dom.remove(node);
	        } else {
	          if (isEmptyAnchor(node)) {
	            dom.remove(node);
	          }
	        }
	      }
	    };
	
	    var normalizeZwspOffset = function (start, container, offset) {
	      if (NodeType.isText(container) === false) {
	        return offset;
	      } if (start) {
	        return offset === 1 && container.data.charAt(offset - 1) === Zwsp.ZWSP ? 0 : offset;
	      } else {
	        return offset === container.data.length - 1 && container.data.charAt(offset) === Zwsp.ZWSP ? container.data.length : offset;
	      }
	    };
	
	    var includeZwspInRange = function (rng) {
	      var newRng = rng.cloneRange();
	      newRng.setStart(rng.startContainer, normalizeZwspOffset(true, rng.startContainer, rng.startOffset));
	      newRng.setEnd(rng.endContainer, normalizeZwspOffset(false, rng.endContainer, rng.endOffset));
	      return newRng;
	    };
	
	    // Trims any linebreaks at the beginning of node user for example when pressing enter in a PRE element
	    var trimLeadingLineBreaks = function (node) {
	      do {
	        if (NodeType.isText(node)) {
	          node.nodeValue = node.nodeValue.replace(/^[\r\n]+/, '');
	        }
	
	        node = node.firstChild;
	      } while (node);
	    };
	
	    var getEditableRoot = function (dom, node) {
	      var root = dom.getRoot(), parent, editableRoot;
	
	      // Get all parents until we hit a non editable parent or the root
	      parent = node;
	      while (parent !== root && dom.getContentEditable(parent) !== "false") {
	        if (dom.getContentEditable(parent) === "true") {
	          editableRoot = parent;
	        }
	
	        parent = parent.parentNode;
	      }
	
	      return parent !== root ? editableRoot : root;
	    };
	
	    var setForcedBlockAttrs = function (editor, node) {
	      var forcedRootBlockName = Settings.getForcedRootBlock(editor);
	
	      if (forcedRootBlockName && forcedRootBlockName.toLowerCase() === node.tagName.toLowerCase()) {
	        editor.dom.setAttribs(node, Settings.getForcedRootBlockAttrs(editor));
	      }
	    };
	
	    // Wraps any text nodes or inline elements in the specified forced root block name
	    var wrapSelfAndSiblingsInDefaultBlock = function (editor, newBlockName, rng, container, offset) {
	      var newBlock, parentBlock, startNode, node, next, rootBlockName, blockName = newBlockName || 'P';
	      var dom = editor.dom, editableRoot = getEditableRoot(dom, container);
	
	      // Not in a block element or in a table cell or caption
	      parentBlock = dom.getParent(container, dom.isBlock);
	      if (!parentBlock || !canSplitBlock(dom, parentBlock)) {
	        parentBlock = parentBlock || editableRoot;
	
	        if (parentBlock === editor.getBody() || isTableCell(parentBlock)) {
	          rootBlockName = parentBlock.nodeName.toLowerCase();
	        } else {
	          rootBlockName = parentBlock.parentNode.nodeName.toLowerCase();
	        }
	
	        if (!parentBlock.hasChildNodes()) {
	          newBlock = dom.create(blockName);
	          setForcedBlockAttrs(editor, newBlock);
	          parentBlock.appendChild(newBlock);
	          rng.setStart(newBlock, 0);
	          rng.setEnd(newBlock, 0);
	          return newBlock;
	        }
	
	        // Find parent that is the first child of parentBlock
	        node = container;
	        while (node.parentNode !== parentBlock) {
	          node = node.parentNode;
	        }
	
	        // Loop left to find start node start wrapping at
	        while (node && !dom.isBlock(node)) {
	          startNode = node;
	          node = node.previousSibling;
	        }
	
	        if (startNode && editor.schema.isValidChild(rootBlockName, blockName.toLowerCase())) {
	          newBlock = dom.create(blockName);
	          setForcedBlockAttrs(editor, newBlock);
	          startNode.parentNode.insertBefore(newBlock, startNode);
	
	          // Start wrapping until we hit a block
	          node = startNode;
	          while (node && !dom.isBlock(node)) {
	            next = node.nextSibling;
	            newBlock.appendChild(node);
	            node = next;
	          }
	
	          // Restore range to it's past location
	          rng.setStart(container, offset);
	          rng.setEnd(container, offset);
	        }
	      }
	
	      return container;
	    };
	
	    // Adds a BR at the end of blocks that only contains an IMG or INPUT since
	    // these might be floated and then they won't expand the block
	    var addBrToBlockIfNeeded = function (dom, block) {
	      var lastChild;
	
	      // IE will render the blocks correctly other browsers needs a BR
	      block.normalize(); // Remove empty text nodes that got left behind by the extract
	
	      // Check if the block is empty or contains a floated last child
	      lastChild = block.lastChild;
	      if (!lastChild || (/^(left|right)$/gi.test(dom.getStyle(lastChild, 'float', true)))) {
	        dom.add(block, 'br');
	      }
	    };
	
	    var insert = function (editor, evt) {
	      var tmpRng, editableRoot, container, offset, parentBlock, shiftKey;
	      var newBlock, fragment, containerBlock, parentBlockName, containerBlockName, newBlockName, isAfterLastNodeInContainer;
	      var dom = editor.dom;
	      var schema = editor.schema, nonEmptyElementsMap = schema.getNonEmptyElements();
	      var rng = editor.selection.getRng();
	
	      // Creates a new block element by cloning the current one or creating a new one if the name is specified
	      // This function will also copy any text formatting from the parent block and add it to the new one
	      var createNewBlock = function (name) {
	        var node = container, block, clonedNode, caretNode, textInlineElements = schema.getTextInlineElements();
	
	        if (name || parentBlockName === "TABLE" || parentBlockName === "HR") {
	          block = dom.create(name || newBlockName);
	          setForcedBlockAttrs(editor, block);
	        } else {
	          block = parentBlock.cloneNode(false);
	        }
	
	        caretNode = block;
	
	        if (Settings.shouldKeepStyles(editor) === false) {
	          dom.setAttrib(block, 'style', null); // wipe out any styles that came over with the block
	          dom.setAttrib(block, 'class', null);
	        } else {
	          // Clone any parent styles
	          do {
	            if (textInlineElements[node.nodeName]) {
	              if (CaretFormat.isCaretNode(node)) {
	                continue;
	              }
	
	              clonedNode = node.cloneNode(false);
	              dom.setAttrib(clonedNode, 'id', ''); // Remove ID since it needs to be document unique
	
	              if (block.hasChildNodes()) {
	                clonedNode.appendChild(block.firstChild);
	                block.appendChild(clonedNode);
	              } else {
	                caretNode = clonedNode;
	                block.appendChild(clonedNode);
	              }
	            }
	          } while ((node = node.parentNode) && node !== editableRoot);
	        }
	
	        emptyBlock(caretNode);
	
	        return block;
	      };
	
	      // Returns true/false if the caret is at the start/end of the parent block element
	      var isCaretAtStartOrEndOfBlock = function (start) {
	        var walker, node, name, normalizedOffset;
	
	        normalizedOffset = normalizeZwspOffset(start, container, offset);
	
	        // Caret is in the middle of a text node like "a|b"
	        if (NodeType.isText(container) && (start ? normalizedOffset > 0 : normalizedOffset < container.nodeValue.length)) {
	          return false;
	        }
	
	        // If after the last element in block node edge case for #5091
	        if (container.parentNode === parentBlock && isAfterLastNodeInContainer && !start) {
	          return true;
	        }
	
	        // If the caret if before the first element in parentBlock
	        if (start && NodeType.isElement(container) && container === parentBlock.firstChild) {
	          return true;
	        }
	
	        // Caret can be before/after a table or a hr
	        if (containerAndSiblingName(container, 'TABLE') || containerAndSiblingName(container, 'HR')) {
	          return (isAfterLastNodeInContainer && !start) || (!isAfterLastNodeInContainer && start);
	        }
	
	        // Walk the DOM and look for text nodes or non empty elements
	        walker = new TreeWalker(container, parentBlock);
	
	        // If caret is in beginning or end of a text block then jump to the next/previous node
	        if (NodeType.isText(container)) {
	          if (start && normalizedOffset === 0) {
	            walker.prev();
	          } else if (!start && normalizedOffset === container.nodeValue.length) {
	            walker.next();
	          }
	        }
	
	        while ((node = walker.current())) {
	          if (NodeType.isElement(node)) {
	            // Ignore bogus elements
	            if (!node.getAttribute('data-mce-bogus')) {
	              // Keep empty elements like <img /> <input /> but not trailing br:s like <p>text|<br></p>
	              name = node.nodeName.toLowerCase();
	              if (nonEmptyElementsMap[name] && name !== 'br') {
	                return false;
	              }
	            }
	          } else if (NodeType.isText(node) && !/^[ \t\r\n]*$/.test(node.nodeValue)) {
	            return false;
	          }
	
	          if (start) {
	            walker.prev();
	          } else {
	            walker.next();
	          }
	        }
	
	        return true;
	      };
	
	      var insertNewBlockAfter = function () {
	        // If the caret is at the end of a header we produce a P tag after it similar to Word unless we are in a hgroup
	        if (/^(H[1-6]|PRE|FIGURE)$/.test(parentBlockName) && containerBlockName !== 'HGROUP') {
	          newBlock = createNewBlock(newBlockName);
	        } else {
	          newBlock = createNewBlock();
	        }
	
	        // Split the current container block element if enter is pressed inside an empty inner block element
	        if (Settings.shouldEndContainerOnEmtpyBlock(editor) && canSplitBlock(dom, containerBlock) && dom.isEmpty(parentBlock)) {
	          // Split container block for example a BLOCKQUOTE at the current blockParent location for example a P
	          newBlock = dom.split(containerBlock, parentBlock);
	        } else {
	          dom.insertAfter(newBlock, parentBlock);
	        }
	
	        NewLineUtils.moveToCaretPosition(editor, newBlock);
	      };
	
	      // Setup range items and newBlockName
	      NormalizeRange.normalize(dom, rng).each(function (normRng) {
	        rng.setStart(normRng.startContainer, normRng.startOffset);
	        rng.setEnd(normRng.endContainer, normRng.endOffset);
	      });
	
	      container = rng.startContainer;
	      offset = rng.startOffset;
	      newBlockName = Settings.getForcedRootBlock(editor);
	      shiftKey = evt.shiftKey;
	
	      // Resolve node index
	      if (NodeType.isElement(container) && container.hasChildNodes()) {
	        isAfterLastNodeInContainer = offset > container.childNodes.length - 1;
	
	        container = container.childNodes[Math.min(offset, container.childNodes.length - 1)] || container;
	        if (isAfterLastNodeInContainer && NodeType.isText(container)) {
	          offset = container.nodeValue.length;
	        } else {
	          offset = 0;
	        }
	      }
	
	      // Get editable root node, normally the body element but sometimes a div or span
	      editableRoot = getEditableRoot(dom, container);
	
	      // If there is no editable root then enter is done inside a contentEditable false element
	      if (!editableRoot) {
	        return;
	      }
	
	      // Wrap the current node and it's sibling in a default block if it's needed.
	      // for example this <td>text|<b>text2</b></td> will become this <td><p>text|<b>text2</p></b></td>
	      // This won't happen if root blocks are disabled or the shiftKey is pressed
	      if ((newBlockName && !shiftKey) || (!newBlockName && shiftKey)) {
	        container = wrapSelfAndSiblingsInDefaultBlock(editor, newBlockName, rng, container, offset);
	      }
	
	      // Find parent block and setup empty block paddings
	      parentBlock = dom.getParent(container, dom.isBlock);
	      containerBlock = parentBlock ? dom.getParent(parentBlock.parentNode, dom.isBlock) : null;
	
	      // Setup block names
	      parentBlockName = parentBlock ? parentBlock.nodeName.toUpperCase() : ''; // IE < 9 & HTML5
	      containerBlockName = containerBlock ? containerBlock.nodeName.toUpperCase() : ''; // IE < 9 & HTML5
	
	      // Enter inside block contained within a LI then split or insert before/after LI
	      if (containerBlockName === 'LI' && !evt.ctrlKey) {
	        parentBlock = containerBlock;
	        containerBlock = containerBlock.parentNode;
	        parentBlockName = containerBlockName;
	      }
	
	      // Handle enter in list item
	      if (/^(LI|DT|DD)$/.test(parentBlockName)) {
	        // Handle enter inside an empty list item
	        if (dom.isEmpty(parentBlock)) {
	          InsertLi.insert(editor, createNewBlock, containerBlock, parentBlock, newBlockName);
	          return;
	        }
	      }
	
	      // If parent block is root then never insert new blocks
	      if (newBlockName && parentBlock === editor.getBody()) {
	        return;
	      }
	
	      // Default block name if it's not configured
	      newBlockName = newBlockName || 'P';
	
	      // Insert new block before/after the parent block depending on caret location
	      if (CaretContainer.isCaretContainerBlock(parentBlock)) {
	        newBlock = CaretContainer.showCaretContainerBlock(parentBlock);
	        if (dom.isEmpty(parentBlock)) {
	          emptyBlock(parentBlock);
	        }
	        NewLineUtils.moveToCaretPosition(editor, newBlock);
	      } else if (isCaretAtStartOrEndOfBlock()) {
	        insertNewBlockAfter();
	      } else if (isCaretAtStartOrEndOfBlock(true)) {
	        // Insert new block before
	        newBlock = parentBlock.parentNode.insertBefore(createNewBlock(), parentBlock);
	        NewLineUtils.moveToCaretPosition(editor, containerAndSiblingName(parentBlock, 'HR') ? newBlock : parentBlock);
	      } else {
	        // Extract after fragment and insert it after the current block
	        tmpRng = includeZwspInRange(rng).cloneRange();
	        tmpRng.setEndAfter(parentBlock);
	        fragment = tmpRng.extractContents();
	        trimLeadingLineBreaks(fragment);
	        newBlock = fragment.firstChild;
	        dom.insertAfter(fragment, parentBlock);
	        trimInlineElementsOnLeftSideOfBlock(dom, nonEmptyElementsMap, newBlock);
	        addBrToBlockIfNeeded(dom, parentBlock);
	
	        if (dom.isEmpty(parentBlock)) {
	          emptyBlock(parentBlock);
	        }
	
	        newBlock.normalize();
	
	        // New block might become empty if it's <p><b>a |</b></p>
	        if (dom.isEmpty(newBlock)) {
	          dom.remove(newBlock);
	          insertNewBlockAfter();
	        } else {
	          NewLineUtils.moveToCaretPosition(editor, newBlock);
	        }
	      }
	
	      dom.setAttrib(newBlock, 'id', ''); // Remove ID since it needs to be document unique
	
	      // Allow custom handling of new blocks
	      editor.fire('NewBlock', { newBlock: newBlock });
	    };
	
	    return {
	      insert: insert
	    };
	  }
	);
	
	/**
	 * ContextSelectors.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.newline.ContextSelectors',
	  [
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.search.Selectors',
	    'tinymce.core.api.Settings',
	    'tinymce.core.newline.NewLineUtils'
	  ],
	  function (Element, Selectors, Settings, NewLineUtils) {
	    var matchesSelector = function (editor, selector) {
	      return NewLineUtils.getParentBlock(editor).filter(function (parentBlock) {
	        return selector.length > 0 && Selectors.is(Element.fromDom(parentBlock), selector);
	      }).isSome();
	    };
	
	    var shouldInsertBr = function (editor) {
	      return matchesSelector(editor, Settings.getBrNewLineSelector(editor));
	    };
	
	    var shouldBlockNewLine = function (editor) {
	      return matchesSelector(editor, Settings.getNoNewLineSelector(editor));
	    };
	
	    return {
	      shouldInsertBr: shouldInsertBr,
	      shouldBlockNewLine: shouldBlockNewLine
	    };
	  }
	);
	
	/**
	 * NewLineAction.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.newline.NewLineAction',
	  [
	    'ephox.katamari.api.Adt',
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Option',
	    'tinymce.core.api.Settings',
	    'tinymce.core.newline.ContextSelectors',
	    'tinymce.core.newline.NewLineUtils',
	    'tinymce.core.util.LazyEvaluator'
	  ],
	  function (Adt, Arr, Option, Settings, ContextSelectors, NewLineUtils, LazyEvaluator) {
	    var newLineAction = Adt.generate([
	      { br: [ ] },
	      { block: [ ] },
	      { none: [ ] }
	    ]);
	
	    var shouldBlockNewLine = function (editor, shiftKey) {
	      return ContextSelectors.shouldBlockNewLine(editor);
	    };
	
	    var isBrMode = function (requiredState) {
	      return function (editor, shiftKey) {
	        var brMode = Settings.getForcedRootBlock(editor) === '';
	        return brMode === requiredState;
	      };
	    };
	
	    var inListBlock = function (requiredState) {
	      return function (editor, shiftKey) {
	        return NewLineUtils.isListItemParentBlock(editor) === requiredState;
	      };
	    };
	
	    var inPreBlock = function (requiredState) {
	      return function (editor, shiftKey) {
	        var inPre = NewLineUtils.getParentBlockName(editor) === 'PRE';
	        return inPre === requiredState;
	      };
	    };
	
	    var shouldPutBrInPre = function (requiredState) {
	      return function (editor, shiftKey) {
	        return Settings.shouldPutBrInPre(editor) === requiredState;
	      };
	    };
	
	    var inBrContext = function (editor, shiftKey) {
	      return ContextSelectors.shouldInsertBr(editor);
	    };
	
	    var hasShiftKey = function (editor, shiftKey) {
	      return shiftKey;
	    };
	
	    var canInsertIntoEditableRoot = function (editor) {
	      var forcedRootBlock = Settings.getForcedRootBlock(editor);
	      var rootEditable = NewLineUtils.getEditableRoot(editor.dom, editor.selection.getStart());
	
	      return rootEditable && editor.schema.isValidChild(rootEditable.nodeName, forcedRootBlock ? forcedRootBlock : 'P');
	    };
	
	    var match = function (predicates, action) {
	      return function (editor, shiftKey) {
	        var isMatch = Arr.foldl(predicates, function (res, p) {
	          return res && p(editor, shiftKey);
	        }, true);
	
	        return isMatch ? Option.some(action) : Option.none();
	      };
	    };
	
	    var getAction = function (editor, evt) {
	      return LazyEvaluator.evaluateUntil([
	        match([shouldBlockNewLine], newLineAction.none()),
	        match([inPreBlock(true), shouldPutBrInPre(false), hasShiftKey], newLineAction.br()),
	        match([inPreBlock(true), shouldPutBrInPre(false)], newLineAction.block()),
	        match([inPreBlock(true), shouldPutBrInPre(true), hasShiftKey], newLineAction.block()),
	        match([inPreBlock(true), shouldPutBrInPre(true)], newLineAction.br()),
	        match([inListBlock(true), hasShiftKey], newLineAction.br()),
	        match([inListBlock(true)], newLineAction.block()),
	        match([isBrMode(true), hasShiftKey, canInsertIntoEditableRoot], newLineAction.block()),
	        match([isBrMode(true)], newLineAction.br()),
	        match([inBrContext], newLineAction.br()),
	        match([isBrMode(false), hasShiftKey], newLineAction.br()),
	        match([canInsertIntoEditableRoot], newLineAction.block())
	      ], [editor, evt.shiftKey]).getOr(newLineAction.none());
	    };
	
	    return {
	      getAction: getAction
	    };
	  }
	);
	
	/**
	 * InsertNewLine.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.newline.InsertNewLine',
	  [
	    'ephox.katamari.api.Fun',
	    'tinymce.core.newline.InsertBlock',
	    'tinymce.core.newline.InsertBr',
	    'tinymce.core.newline.NewLineAction'
	  ],
	  function (Fun, InsertBlock, InsertBr, NewLineAction) {
	    var insert = function (editor, evt) {
	      NewLineAction.getAction(editor, evt).fold(
	        function () {
	          InsertBr.insert(editor, evt);
	        },
	        function () {
	          InsertBlock.insert(editor, evt);
	        },
	        Fun.noop
	      );
	    };
	
	    return {
	      insert: insert
	    };
	  }
	);
	
	/**
	 * EnterKey.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.EnterKey',
	  [
	    'tinymce.core.newline.InsertNewLine',
	    'tinymce.core.util.VK'
	  ],
	  function (InsertNewLine, VK) {
	    var endTypingLevel = function (undoManager) {
	      if (undoManager.typing) {
	        undoManager.typing = false;
	        undoManager.add();
	      }
	    };
	
	    var handleEnterKeyEvent = function (editor, event) {
	      if (event.isDefaultPrevented()) {
	        return;
	      }
	
	      event.preventDefault();
	
	      endTypingLevel(editor.undoManager);
	      editor.undoManager.transact(function () {
	        if (editor.selection.isCollapsed() === false) {
	          editor.execCommand('Delete');
	        }
	
	        InsertNewLine.insert(editor, event);
	      });
	    };
	
	    var setup = function (editor) {
	      editor.on('keydown', function (event) {
	        if (event.keyCode === VK.ENTER) {
	          handleEnterKeyEvent(editor, event);
	        }
	      });
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	/**
	 * InsertSpace.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.InsertSpace',
	  [
	    'ephox.katamari.api.Fun',
	    'tinymce.core.caret.CaretPosition',
	    'tinymce.core.dom.NodeType',
	    'tinymce.core.keyboard.BoundaryLocation',
	    'tinymce.core.keyboard.InlineUtils'
	  ],
	  function (Fun, CaretPosition, NodeType, BoundaryLocation, InlineUtils) {
	    var isValidInsertPoint = function (location, caretPosition) {
	      return isAtStartOrEnd(location) && NodeType.isText(caretPosition.container());
	    };
	
	    var insertNbspAtPosition = function (editor, caretPosition) {
	      var container = caretPosition.container();
	      var offset = caretPosition.offset();
	
	      container.insertData(offset, '\u00a0');
	      editor.selection.setCursorLocation(container, offset + 1);
	    };
	
	    var insertAtLocation = function (editor, caretPosition, location) {
	      if (isValidInsertPoint(location, caretPosition)) {
	        insertNbspAtPosition(editor, caretPosition);
	        return true;
	      } else {
	        return false;
	      }
	    };
	
	    var insertAtCaret = function (editor) {
	      var isInlineTarget = Fun.curry(InlineUtils.isInlineTarget, editor);
	      var caretPosition = CaretPosition.fromRangeStart(editor.selection.getRng());
	      var boundaryLocation = BoundaryLocation.readLocation(isInlineTarget, editor.getBody(), caretPosition);
	      return boundaryLocation.map(Fun.curry(insertAtLocation, editor, caretPosition)).getOr(false);
	    };
	
	    var isAtStartOrEnd = function (location) {
	      return location.fold(
	        Fun.constant(false), // Before
	        Fun.constant(true),  // Start
	        Fun.constant(true),  // End
	        Fun.constant(false)  // After
	      );
	    };
	
	    var insertAtSelection = function (editor) {
	      return editor.selection.isCollapsed() ? insertAtCaret(editor) : false;
	    };
	
	    return {
	      insertAtSelection: insertAtSelection
	    };
	  }
	);
	
	/**
	 * SpaceKey.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.SpaceKey',
	  [
	    'tinymce.core.keyboard.InsertSpace',
	    'tinymce.core.keyboard.MatchKeys',
	    'tinymce.core.util.VK'
	  ],
	  function (InsertSpace, MatchKeys, VK) {
	    var executeKeydownOverride = function (editor, evt) {
	      MatchKeys.execute([
	        { keyCode: VK.SPACEBAR, action: MatchKeys.action(InsertSpace.insertAtSelection, editor) }
	      ], evt).each(function (_) {
	        evt.preventDefault();
	      });
	    };
	
	    var setup = function (editor) {
	      editor.on('keydown', function (evt) {
	        if (evt.isDefaultPrevented() === false) {
	          executeKeydownOverride(editor, evt);
	        }
	      });
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	
	/**
	 * KeyboardOverrides.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.keyboard.KeyboardOverrides',
	  [
	    'tinymce.core.keyboard.ArrowKeys',
	    'tinymce.core.keyboard.BoundarySelection',
	    'tinymce.core.keyboard.DeleteBackspaceKeys',
	    'tinymce.core.keyboard.EnterKey',
	    'tinymce.core.keyboard.SpaceKey'
	  ],
	  function (ArrowKeys, BoundarySelection, DeleteBackspaceKeys, EnterKey, SpaceKey) {
	    var setup = function (editor) {
	      var caret = BoundarySelection.setupSelectedState(editor);
	
	      ArrowKeys.setup(editor, caret);
	      DeleteBackspaceKeys.setup(editor, caret);
	      EnterKey.setup(editor);
	      SpaceKey.setup(editor);
	    };
	
	    return {
	      setup: setup
	    };
	  }
	);
	/**
	 * Quirks.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 *
	 * @ignore-file
	 */
	
	/**
	 * This file includes fixes for various browser quirks it's made to make it easy to add/remove browser specific fixes.
	 *
	 * @private
	 * @class tinymce.util.Quirks
	 */
	define(
	  'tinymce.core.util.Quirks',
	  [
	    'global!document',
	    'global!window',
	    'tinymce.core.Env',
	    'tinymce.core.caret.CaretContainer',
	    'tinymce.core.selection.CaretRangeFromPoint',
	    'tinymce.core.util.Delay',
	    'tinymce.core.util.Tools',
	    'tinymce.core.util.VK'
	  ],
	  function (document, window, Env, CaretContainer, CaretRangeFromPoint, Delay, Tools, VK) {
	    return function (editor) {
	      var each = Tools.each;
	      var BACKSPACE = VK.BACKSPACE, DELETE = VK.DELETE, dom = editor.dom, selection = editor.selection,
	        settings = editor.settings, parser = editor.parser;
	      var isGecko = Env.gecko, isIE = Env.ie, isWebKit = Env.webkit;
	      var mceInternalUrlPrefix = 'data:text/mce-internal,';
	      var mceInternalDataType = isIE ? 'Text' : 'URL';
	
	      /**
	       * Executes a command with a specific state this can be to enable/disable browser editing features.
	       */
	      var setEditorCommandState = function (cmd, state) {
	        try {
	          editor.getDoc().execCommand(cmd, false, state);
	        } catch (ex) {
	          // Ignore
	        }
	      };
	
	      /**
	       * Returns true/false if the event is prevented or not.
	       *
	       * @private
	       * @param {Event} e Event object.
	       * @return {Boolean} true/false if the event is prevented or not.
	       */
	      var isDefaultPrevented = function (e) {
	        return e.isDefaultPrevented();
	      };
	
	      /**
	       * Sets Text/URL data on the event's dataTransfer object to a special data:text/mce-internal url.
	       * This is to workaround the inability to set custom contentType on IE and Safari.
	       * The editor's selected content is encoded into this url so drag and drop between editors will work.
	       *
	       * @private
	       * @param {DragEvent} e Event object
	       */
	      var setMceInternalContent = function (e) {
	        var selectionHtml, internalContent;
	
	        if (e.dataTransfer) {
	          if (editor.selection.isCollapsed() && e.target.tagName == 'IMG') {
	            selection.select(e.target);
	          }
	
	          selectionHtml = editor.selection.getContent();
	
	          // Safari/IE doesn't support custom dataTransfer items so we can only use URL and Text
	          if (selectionHtml.length > 0) {
	            internalContent = mceInternalUrlPrefix + escape(editor.id) + ',' + escape(selectionHtml);
	            e.dataTransfer.setData(mceInternalDataType, internalContent);
	          }
	        }
	      };
	
	      /**
	       * Gets content of special data:text/mce-internal url on the event's dataTransfer object.
	       * This is to workaround the inability to set custom contentType on IE and Safari.
	       * The editor's selected content is encoded into this url so drag and drop between editors will work.
	       *
	       * @private
	       * @param {DragEvent} e Event object
	       * @returns {String} mce-internal content
	       */
	      var getMceInternalContent = function (e) {
	        var internalContent;
	
	        if (e.dataTransfer) {
	          internalContent = e.dataTransfer.getData(mceInternalDataType);
	
	          if (internalContent && internalContent.indexOf(mceInternalUrlPrefix) >= 0) {
	            internalContent = internalContent.substr(mceInternalUrlPrefix.length).split(',');
	
	            return {
	              id: unescape(internalContent[0]),
	              html: unescape(internalContent[1])
	            };
	          }
	        }
	
	        return null;
	      };
	
	      /**
	       * Inserts contents using the paste clipboard command if it's available if it isn't it will fallback
	       * to the core command.
	       *
	       * @private
	       * @param {String} content Content to insert at selection.
	       * @param {Boolean} internal State if the paste is to be considered internal or external.
	       */
	      var insertClipboardContents = function (content, internal) {
	        if (editor.queryCommandSupported('mceInsertClipboardContent')) {
	          editor.execCommand('mceInsertClipboardContent', false, { content: content, internal: internal });
	        } else {
	          editor.execCommand('mceInsertContent', false, content);
	        }
	      };
	
	      /**
	       * Makes sure that the editor body becomes empty when backspace or delete is pressed in empty editors.
	       *
	       * For example:
	       * <p><b>|</b></p>
	       *
	       * Or:
	       * <h1>|</h1>
	       *
	       * Or:
	       * [<h1></h1>]
	       */
	      var emptyEditorWhenDeleting = function () {
	        var serializeRng = function (rng) {
	          var body = dom.create("body");
	          var contents = rng.cloneContents();
	          body.appendChild(contents);
	          return selection.serializer.serialize(body, { format: 'html' });
	        };
	
	        var allContentsSelected = function (rng) {
	          var selection = serializeRng(rng);
	
	          var allRng = dom.createRng();
	          allRng.selectNode(editor.getBody());
	
	          var allSelection = serializeRng(allRng);
	          return selection === allSelection;
	        };
	
	        editor.on('keydown', function (e) {
	          var keyCode = e.keyCode, isCollapsed, body;
	
	          // Empty the editor if it's needed for example backspace at <p><b>|</b></p>
	          if (!isDefaultPrevented(e) && (keyCode == DELETE || keyCode == BACKSPACE)) {
	            isCollapsed = editor.selection.isCollapsed();
	            body = editor.getBody();
	
	            // Selection is collapsed but the editor isn't empty
	            if (isCollapsed && !dom.isEmpty(body)) {
	              return;
	            }
	
	            // Selection isn't collapsed but not all the contents is selected
	            if (!isCollapsed && !allContentsSelected(editor.selection.getRng())) {
	              return;
	            }
	
	            // Manually empty the editor
	            e.preventDefault();
	            editor.setContent('');
	
	            if (body.firstChild && dom.isBlock(body.firstChild)) {
	              editor.selection.setCursorLocation(body.firstChild, 0);
	            } else {
	              editor.selection.setCursorLocation(body, 0);
	            }
	
	            editor.nodeChanged();
	          }
	        });
	      };
	
	      /**
	       * WebKit doesn't select all the nodes in the body when you press Ctrl+A.
	       * IE selects more than the contents <body>[<p>a</p>]</body> instead of <body><p>[a]</p]</body> see bug #6438
	       * This selects the whole body so that backspace/delete logic will delete everything
	       */
	      var selectAll = function () {
	        editor.shortcuts.add('meta+a', null, 'SelectAll');
	      };
	
	      /**
	       * WebKit has a weird issue where it some times fails to properly convert keypresses to input method keystrokes.
	       * The IME on Mac doesn't initialize when it doesn't fire a proper focus event.
	       *
	       * This seems to happen when the user manages to click the documentElement element then the window doesn't get proper focus until
	       * you enter a character into the editor.
	       *
	       * It also happens when the first focus in made to the body.
	       *
	       * See: https://bugs.webkit.org/show_bug.cgi?id=83566
	       */
	      var inputMethodFocus = function () {
	        if (!editor.settings.content_editable) {
	          // Case 1 IME doesn't initialize if you focus the document
	          // Disabled since it was interferring with the cE=false logic
	          // Also coultn't reproduce the issue on Safari 9
	          /*dom.bind(editor.getDoc(), 'focusin', function() {
	            selection.setRng(selection.getRng());
	          });*/
	
	          // Case 2 IME doesn't initialize if you click the documentElement it also doesn't properly fire the focusin event
	          // Needs to be both down/up due to weird rendering bug on Chrome Windows
	          dom.bind(editor.getDoc(), 'mousedown mouseup', function (e) {
	            var rng;
	
	            if (e.target == editor.getDoc().documentElement) {
	              rng = selection.getRng();
	              editor.getBody().focus();
	
	              if (e.type == 'mousedown') {
	                if (CaretContainer.isCaretContainer(rng.startContainer)) {
	                  return;
	                }
	
	                // Edge case for mousedown, drag select and mousedown again within selection on Chrome Windows to render caret
	                selection.placeCaretAt(e.clientX, e.clientY);
	              } else {
	                selection.setRng(rng);
	              }
	            }
	          });
	        }
	      };
	
	      /**
	       * Backspacing in FireFox/IE from a paragraph into a horizontal rule results in a floating text node because the
	       * browser just deletes the paragraph - the browser fails to merge the text node with a horizontal rule so it is
	       * left there. TinyMCE sees a floating text node and wraps it in a paragraph on the key up event (ForceBlocks.js
	       * addRootBlocks), meaning the action does nothing. With this code, FireFox/IE matche the behaviour of other
	       * browsers.
	       *
	       * It also fixes a bug on Firefox where it's impossible to delete HR elements.
	       */
	      var removeHrOnBackspace = function () {
	        editor.on('keydown', function (e) {
	          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
	            // Check if there is any HR elements this is faster since getRng on IE 7 & 8 is slow
	            if (!editor.getBody().getElementsByTagName('hr').length) {
	              return;
	            }
	
	            if (selection.isCollapsed() && selection.getRng(true).startOffset === 0) {
	              var node = selection.getNode();
	              var previousSibling = node.previousSibling;
	
	              if (node.nodeName == 'HR') {
	                dom.remove(node);
	                e.preventDefault();
	                return;
	              }
	
	              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === "hr") {
	                dom.remove(previousSibling);
	                e.preventDefault();
	              }
	            }
	          }
	        });
	      };
	
	      /**
	       * Firefox 3.x has an issue where the body element won't get proper focus if you click out
	       * side it's rectangle.
	       */
	      var focusBody = function () {
	        // Fix for a focus bug in FF 3.x where the body element
	        // wouldn't get proper focus if the user clicked on the HTML element
	        if (!window.Range.prototype.getClientRects) { // Detect getClientRects got introduced in FF 4
	          editor.on('mousedown', function (e) {
	            if (!isDefaultPrevented(e) && e.target.nodeName === "HTML") {
	              var body = editor.getBody();
	
	              // Blur the body it's focused but not correctly focused
	              body.blur();
	
	              // Refocus the body after a little while
	              Delay.setEditorTimeout(editor, function () {
	                body.focus();
	              });
	            }
	          });
	        }
	      };
	
	      /**
	       * WebKit has a bug where it isn't possible to select image, hr or anchor elements
	       * by clicking on them so we need to fake that.
	       */
	      var selectControlElements = function () {
	        editor.on('click', function (e) {
	          var target = e.target;
	
	          // Workaround for bug, http://bugs.webkit.org/show_bug.cgi?id=12250
	          // WebKit can't even do simple things like selecting an image
	          // Needs to be the setBaseAndExtend or it will fail to select floated images
	          if (/^(IMG|HR)$/.test(target.nodeName) && dom.getContentEditableParent(target) !== "false") {
	            e.preventDefault();
	            editor.selection.select(target);
	            editor.nodeChanged();
	          }
	
	          if (target.nodeName == 'A' && dom.hasClass(target, 'mce-item-anchor')) {
	            e.preventDefault();
	            selection.select(target);
	          }
	        });
	      };
	
	      /**
	       * Fixes a Gecko bug where the style attribute gets added to the wrong element when deleting between two block elements.
	       *
	       * Fixes do backspace/delete on this:
	       * <p>bla[ck</p><p style="color:red">r]ed</p>
	       *
	       * Would become:
	       * <p>bla|ed</p>
	       *
	       * Instead of:
	       * <p style="color:red">bla|ed</p>
	       */
	      var removeStylesWhenDeletingAcrossBlockElements = function () {
	        var getAttributeApplyFunction = function () {
	          var template = dom.getAttribs(selection.getStart().cloneNode(false));
	
	          return function () {
	            var target = selection.getStart();
	
	            if (target !== editor.getBody()) {
	              dom.setAttrib(target, "style", null);
	
	              each(template, function (attr) {
	                target.setAttributeNode(attr.cloneNode(true));
	              });
	            }
	          };
	        };
	
	        var isSelectionAcrossElements = function () {
	          return !selection.isCollapsed() &&
	            dom.getParent(selection.getStart(), dom.isBlock) != dom.getParent(selection.getEnd(), dom.isBlock);
	        };
	
	        editor.on('keypress', function (e) {
	          var applyAttributes;
	
	          if (!isDefaultPrevented(e) && (e.keyCode == 8 || e.keyCode == 46) && isSelectionAcrossElements()) {
	            applyAttributes = getAttributeApplyFunction();
	            editor.getDoc().execCommand('delete', false, null);
	            applyAttributes();
	            e.preventDefault();
	            return false;
	          }
	        });
	
	        dom.bind(editor.getDoc(), 'cut', function (e) {
	          var applyAttributes;
	
	          if (!isDefaultPrevented(e) && isSelectionAcrossElements()) {
	            applyAttributes = getAttributeApplyFunction();
	
	            Delay.setEditorTimeout(editor, function () {
	              applyAttributes();
	            });
	          }
	        });
	      };
	
	      /**
	       * Backspacing into a table behaves differently depending upon browser type.
	       * Therefore, disable Backspace when cursor immediately follows a table.
	       */
	      var disableBackspaceIntoATable = function () {
	        editor.on('keydown', function (e) {
	          if (!isDefaultPrevented(e) && e.keyCode === BACKSPACE) {
	            if (selection.isCollapsed() && selection.getRng(true).startOffset === 0) {
	              var previousSibling = selection.getNode().previousSibling;
	              if (previousSibling && previousSibling.nodeName && previousSibling.nodeName.toLowerCase() === "table") {
	                e.preventDefault();
	                return false;
	              }
	            }
	          }
	        });
	      };
	
	      /**
	       * Removes a blockquote when backspace is pressed at the beginning of it.
	       *
	       * For example:
	       * <blockquote><p>|x</p></blockquote>
	       *
	       * Becomes:
	       * <p>|x</p>
	       */
	      var removeBlockQuoteOnBackSpace = function () {
	        // Add block quote deletion handler
	        editor.on('keydown', function (e) {
	          var rng, container, offset, root, parent;
	
	          if (isDefaultPrevented(e) || e.keyCode != VK.BACKSPACE) {
	            return;
	          }
	
	          rng = selection.getRng();
	          container = rng.startContainer;
	          offset = rng.startOffset;
	          root = dom.getRoot();
	          parent = container;
	
	          if (!rng.collapsed || offset !== 0) {
	            return;
	          }
	
	          while (parent && parent.parentNode && parent.parentNode.firstChild == parent && parent.parentNode != root) {
	            parent = parent.parentNode;
	          }
	
	          // Is the cursor at the beginning of a blockquote?
	          if (parent.tagName === 'BLOCKQUOTE') {
	            // Remove the blockquote
	            editor.formatter.toggle('blockquote', null, parent);
	
	            // Move the caret to the beginning of container
	            rng = dom.createRng();
	            rng.setStart(container, 0);
	            rng.setEnd(container, 0);
	            selection.setRng(rng);
	          }
	        });
	      };
	
	      /**
	       * Sets various Gecko editing options on mouse down and before a execCommand to disable inline table editing that is broken etc.
	       */
	      var setGeckoEditingOptions = function () {
	        var setOpts = function () {
	          refreshContentEditable();
	
	          setEditorCommandState("StyleWithCSS", false);
	          setEditorCommandState("enableInlineTableEditing", false);
	
	          if (!settings.object_resizing) {
	            setEditorCommandState("enableObjectResizing", false);
	          }
	        };
	
	        if (!settings.readonly) {
	          editor.on('BeforeExecCommand MouseDown', setOpts);
	        }
	      };
	
	      /**
	       * Fixes a gecko link bug, when a link is placed at the end of block elements there is
	       * no way to move the caret behind the link. This fix adds a bogus br element after the link.
	       *
	       * For example this:
	       * <p><b><a href="#">x</a></b></p>
	       *
	       * Becomes this:
	       * <p><b><a href="#">x</a></b><br></p>
	       */
	      var addBrAfterLastLinks = function () {
	        var fixLinks = function () {
	          each(dom.select('a'), function (node) {
	            var parentNode = node.parentNode, root = dom.getRoot();
	
	            if (parentNode.lastChild === node) {
	              while (parentNode && !dom.isBlock(parentNode)) {
	                if (parentNode.parentNode.lastChild !== parentNode || parentNode === root) {
	                  return;
	                }
	
	                parentNode = parentNode.parentNode;
	              }
	
	              dom.add(parentNode, 'br', { 'data-mce-bogus': 1 });
	            }
	          });
	        };
	
	        editor.on('SetContent ExecCommand', function (e) {
	          if (e.type == "setcontent" || e.command === 'mceInsertLink') {
	            fixLinks();
	          }
	        });
	      };
	
	      /**
	       * WebKit will produce DIV elements here and there by default. But since TinyMCE uses paragraphs by
	       * default we want to change that behavior.
	       */
	      var setDefaultBlockType = function () {
	        if (settings.forced_root_block) {
	          editor.on('init', function () {
	            setEditorCommandState('DefaultParagraphSeparator', settings.forced_root_block);
	          });
	        }
	      };
	
	      /**
	       * Fixes selection issues where the caret can be placed between two inline elements like <b>a</b>|<b>b</b>
	       * this fix will lean the caret right into the closest inline element.
	       */
	      var normalizeSelection = function () {
	        // Normalize selection for example <b>a</b><i>|a</i> becomes <b>a|</b><i>a</i>
	        editor.on('keyup focusin mouseup', function (e) {
	          // no point to exclude Ctrl+A, since normalization will still run after Ctrl will be unpressed
	          // better exclude any key combinations with the modifiers to avoid double normalization
	          // (also addresses TINY-1130)
	          if (!VK.modifierPressed(e)) {
	            selection.normalize();
	          }
	        }, true);
	      };
	
	      /**
	       * Forces Gecko to render a broken image icon if it fails to load an image.
	       */
	      var showBrokenImageIcon = function () {
	        editor.contentStyles.push(
	          'img:-moz-broken {' +
	          '-moz-force-broken-image-icon:1;' +
	          'min-width:24px;' +
	          'min-height:24px' +
	          '}'
	        );
	      };
	
	      /**
	       * iOS has a bug where it's impossible to type if the document has a touchstart event
	       * bound and the user touches the document while having the on screen keyboard visible.
	       *
	       * The touch event moves the focus to the parent document while having the caret inside the iframe
	       * this fix moves the focus back into the iframe document.
	       */
	      var restoreFocusOnKeyDown = function () {
	        if (!editor.inline) {
	          editor.on('keydown', function () {
	            if (document.activeElement == document.body) {
	              editor.getWin().focus();
	            }
	          });
	        }
	      };
	
	      /**
	       * IE 11 has an annoying issue where you can't move focus into the editor
	       * by clicking on the white area HTML element. We used to be able to fix this with
	       * the fixCaretSelectionOfDocumentElementOnIe fix. But since M$ removed the selection
	       * object it's not possible anymore. So we need to hack in a ungly CSS to force the
	       * body to be at least 150px. If the user clicks the HTML element out side this 150px region
	       * we simply move the focus into the first paragraph. Not ideal since you loose the
	       * positioning of the caret but goot enough for most cases.
	       */
	      var bodyHeight = function () {
	        if (!editor.inline) {
	          editor.contentStyles.push('body {min-height: 150px}');
	          editor.on('click', function (e) {
	            var rng;
	
	            if (e.target.nodeName == 'HTML') {
	              // Edge seems to only need focus if we set the range
	              // the caret will become invisible and moved out of the iframe!!
	              if (Env.ie > 11) {
	                editor.getBody().focus();
	                return;
	              }
	
	              // Need to store away non collapsed ranges since the focus call will mess that up see #7382
	              rng = editor.selection.getRng();
	              editor.getBody().focus();
	              editor.selection.setRng(rng);
	              editor.selection.normalize();
	              editor.nodeChanged();
	            }
	          });
	        }
	      };
	
	      /**
	       * Firefox on Mac OS will move the browser back to the previous page if you press CMD+Left arrow.
	       * You might then loose all your work so we need to block that behavior and replace it with our own.
	       */
	      var blockCmdArrowNavigation = function () {
	        if (Env.mac) {
	          editor.on('keydown', function (e) {
	            if (VK.metaKeyPressed(e) && !e.shiftKey && (e.keyCode == 37 || e.keyCode == 39)) {
	              e.preventDefault();
	              editor.selection.getSel().modify('move', e.keyCode == 37 ? 'backward' : 'forward', 'lineboundary');
	            }
	          });
	        }
	      };
	
	      /**
	       * Disables the autolinking in IE 9+ this is then re-enabled by the autolink plugin.
	       */
	      var disableAutoUrlDetect = function () {
	        setEditorCommandState("AutoUrlDetect", false);
	      };
	
	      /**
	       * iOS 7.1 introduced two new bugs:
	       * 1) It's possible to open links within a contentEditable area by clicking on them.
	       * 2) If you hold down the finger it will display the link/image touch callout menu.
	       */
	      var tapLinksAndImages = function () {
	        editor.on('click', function (e) {
	          var elm = e.target;
	
	          do {
	            if (elm.tagName === 'A') {
	              e.preventDefault();
	              return;
	            }
	          } while ((elm = elm.parentNode));
	        });
	
	        editor.contentStyles.push('.mce-content-body {-webkit-touch-callout: none}');
	      };
	
	      /**
	       * iOS Safari and possible other browsers have a bug where it won't fire
	       * a click event when a contentEditable is focused. This function fakes click events
	       * by using touchstart/touchend and measuring the time and distance travelled.
	       */
	      /*
	      function touchClickEvent() {
	        editor.on('touchstart', function(e) {
	          var elm, time, startTouch, changedTouches;
	
	          elm = e.target;
	          time = new Date().getTime();
	          changedTouches = e.changedTouches;
	
	          if (!changedTouches || changedTouches.length > 1) {
	            return;
	          }
	
	          startTouch = changedTouches[0];
	
	          editor.once('touchend', function(e) {
	            var endTouch = e.changedTouches[0], args;
	
	            if (new Date().getTime() - time > 500) {
	              return;
	            }
	
	            if (Math.abs(startTouch.clientX - endTouch.clientX) > 5) {
	              return;
	            }
	
	            if (Math.abs(startTouch.clientY - endTouch.clientY) > 5) {
	              return;
	            }
	
	            args = {
	              target: elm
	            };
	
	            each('pageX pageY clientX clientY screenX screenY'.split(' '), function(key) {
	              args[key] = endTouch[key];
	            });
	
	            args = editor.fire('click', args);
	
	            if (!args.isDefaultPrevented()) {
	              // iOS WebKit can't place the caret properly once
	              // you bind touch events so we need to do this manually
	              // TODO: Expand to the closest word? Touble tap still works.
	              editor.selection.placeCaretAt(endTouch.clientX, endTouch.clientY);
	              editor.nodeChanged();
	            }
	          });
	        });
	      }
	      */
	
	      /**
	       * WebKit has a bug where it will allow forms to be submitted if they are inside a contentEditable element.
	       * For example this: <form><button></form>
	       */
	      var blockFormSubmitInsideEditor = function () {
	        editor.on('init', function () {
	          editor.dom.bind(editor.getBody(), 'submit', function (e) {
	            e.preventDefault();
	          });
	        });
	      };
	
	      /**
	       * Sometimes WebKit/Blink generates BR elements with the Apple-interchange-newline class.
	       *
	       * Scenario:
	       *  1) Create a table 2x2.
	       *  2) Select and copy cells A2-B2.
	       *  3) Paste and it will add BR element to table cell.
	       */
	      var removeAppleInterchangeBrs = function () {
	        parser.addNodeFilter('br', function (nodes) {
	          var i = nodes.length;
	
	          while (i--) {
	            if (nodes[i].attr('class') == 'Apple-interchange-newline') {
	              nodes[i].remove();
	            }
	          }
	        });
	      };
	
	      /**
	       * IE cannot set custom contentType's on drag events, and also does not properly drag/drop between
	       * editors. This uses a special data:text/mce-internal URL to pass data when drag/drop between editors.
	       */
	      var ieInternalDragAndDrop = function () {
	        editor.on('dragstart', function (e) {
	          setMceInternalContent(e);
	        });
	
	        editor.on('drop', function (e) {
	          if (!isDefaultPrevented(e)) {
	            var internalContent = getMceInternalContent(e);
	
	            if (internalContent && internalContent.id != editor.id) {
	              e.preventDefault();
	
	              var rng = CaretRangeFromPoint.fromPoint(e.x, e.y, editor.getDoc());
	              selection.setRng(rng);
	              insertClipboardContents(internalContent.html, true);
	            }
	          }
	        });
	      };
	
	      var refreshContentEditable = function () {
	        // No-op since Mozilla seems to have fixed the caret repaint issues
	      };
	
	      var isHidden = function () {
	        var sel;
	
	        if (!isGecko || editor.removed) {
	          return 0;
	        }
	
	        // Weird, wheres that cursor selection?
	        sel = editor.selection.getSel();
	        return (!sel || !sel.rangeCount || sel.rangeCount === 0);
	      };
	
	      // All browsers
	      removeBlockQuoteOnBackSpace();
	      emptyEditorWhenDeleting();
	
	      // Windows phone will return a range like [body, 0] on mousedown so
	      // it will always normalize to the wrong location
	      if (!Env.windowsPhone) {
	        normalizeSelection();
	      }
	
	      // WebKit
	      if (isWebKit) {
	        inputMethodFocus();
	        selectControlElements();
	        setDefaultBlockType();
	        blockFormSubmitInsideEditor();
	        disableBackspaceIntoATable();
	        removeAppleInterchangeBrs();
	
	        //touchClickEvent();
	
	        // iOS
	        if (Env.iOS) {
	          restoreFocusOnKeyDown();
	          bodyHeight();
	          tapLinksAndImages();
	        } else {
	          selectAll();
	        }
	      }
	
	      if (Env.ie >= 11) {
	        bodyHeight();
	        disableBackspaceIntoATable();
	      }
	
	      if (Env.ie) {
	        selectAll();
	        disableAutoUrlDetect();
	        ieInternalDragAndDrop();
	      }
	
	      // Gecko
	      if (isGecko) {
	        removeHrOnBackspace();
	        focusBody();
	        removeStylesWhenDeletingAcrossBlockElements();
	        setGeckoEditingOptions();
	        addBrAfterLastLinks();
	        showBrokenImageIcon();
	        blockCmdArrowNavigation();
	        disableBackspaceIntoATable();
	      }
	
	      return {
	        refreshContentEditable: refreshContentEditable,
	        isHidden: isHidden
	      };
	    };
	  }
	);
	
	/**
	 * InitContentBody.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.init.InitContentBody',
	  [
	    'ephox.sugar.api.dom.Insert',
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.properties.Attr',
	    'global!document',
	    'global!window',
	    'tinymce.core.EditorUpload',
	    'tinymce.core.ForceBlocks',
	    'tinymce.core.NodeChange',
	    'tinymce.core.SelectionOverrides',
	    'tinymce.core.UndoManager',
	    'tinymce.core.api.Formatter',
	    'tinymce.core.api.dom.Serializer',
	    'tinymce.core.caret.CaretContainerInput',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.dom.Selection',
	    'tinymce.core.html.DomParser',
	    'tinymce.core.html.Node',
	    'tinymce.core.html.Schema',
	    'tinymce.core.keyboard.KeyboardOverrides',
	    'tinymce.core.util.Delay',
	    'tinymce.core.util.Quirks',
	    'tinymce.core.util.Tools'
	  ],
	  function (
	    Insert, Element, Attr, document, window, EditorUpload, ForceBlocks, NodeChange, SelectionOverrides, UndoManager, Formatter, Serializer, CaretContainerInput,
	    DOMUtils, Selection, DomParser, Node, Schema, KeyboardOverrides, Delay, Quirks, Tools
	  ) {
	    var DOM = DOMUtils.DOM;
	
	    var appendStyle = function (editor, text) {
	      var head = Element.fromDom(editor.getDoc().head);
	      var tag = Element.fromTag('style');
	      Attr.set(tag, 'type', 'text/css');
	      Insert.append(tag, Element.fromText(text));
	      Insert.append(head, tag);
	    };
	
	    var createParser = function (editor) {
	      var parser = new DomParser(editor.settings, editor.schema);
	
	      // Convert src and href into data-mce-src, data-mce-href and data-mce-style
	      parser.addAttributeFilter('src,href,style,tabindex', function (nodes, name) {
	        var i = nodes.length, node, dom = editor.dom, value, internalName;
	
	        while (i--) {
	          node = nodes[i];
	          value = node.attr(name);
	          internalName = 'data-mce-' + name;
	
	          // Add internal attribute if we need to we don't on a refresh of the document
	          if (!node.attributes.map[internalName]) {
	            // Don't duplicate these since they won't get modified by any browser
	            if (value.indexOf('data:') === 0 || value.indexOf('blob:') === 0) {
	              continue;
	            }
	
	            if (name === "style") {
	              value = dom.serializeStyle(dom.parseStyle(value), node.name);
	
	              if (!value.length) {
	                value = null;
	              }
	
	              node.attr(internalName, value);
	              node.attr(name, value);
	            } else if (name === "tabindex") {
	              node.attr(internalName, value);
	              node.attr(name, null);
	            } else {
	              node.attr(internalName, editor.convertURL(value, name, node.name));
	            }
	          }
	        }
	      });
	
	      // Keep scripts from executing
	      parser.addNodeFilter('script', function (nodes) {
	        var i = nodes.length, node, type;
	
	        while (i--) {
	          node = nodes[i];
	          type = node.attr('type') || 'no/type';
	          if (type.indexOf('mce-') !== 0) {
	            node.attr('type', 'mce-' + type);
	          }
	        }
	      });
	
	      parser.addNodeFilter('#cdata', function (nodes) {
	        var i = nodes.length, node;
	
	        while (i--) {
	          node = nodes[i];
	          node.type = 8;
	          node.name = '#comment';
	          node.value = '[CDATA[' + node.value + ']]';
	        }
	      });
	
	      parser.addNodeFilter('p,h1,h2,h3,h4,h5,h6,div', function (nodes) {
	        var i = nodes.length, node, nonEmptyElements = editor.schema.getNonEmptyElements();
	
	        while (i--) {
	          node = nodes[i];
	
	          if (node.isEmpty(nonEmptyElements) && node.getAll('br').length === 0) {
	            node.append(new Node('br', 1)).shortEnded = true;
	          }
	        }
	      });
	
	      return parser;
	    };
	
	    var autoFocus = function (editor) {
	      if (editor.settings.auto_focus) {
	        Delay.setEditorTimeout(editor, function () {
	          var focusEditor;
	
	          if (editor.settings.auto_focus === true) {
	            focusEditor = editor;
	          } else {
	            focusEditor = editor.editorManager.get(editor.settings.auto_focus);
	          }
	
	          if (!focusEditor.destroyed) {
	            focusEditor.focus();
	          }
	        }, 100);
	      }
	    };
	
	    var initEditor = function (editor) {
	      editor.bindPendingEventDelegates();
	      editor.initialized = true;
	      editor.fire('init');
	      editor.focus(true);
	      editor.nodeChanged({ initial: true });
	      editor.execCallback('init_instance_callback', editor);
	      autoFocus(editor);
	    };
	
	    var getStyleSheetLoader = function (editor) {
	      return editor.inline ? DOM.styleSheetLoader : editor.dom.styleSheetLoader;
	    };
	
	    var initContentBody = function (editor, skipWrite) {
	      var settings = editor.settings, targetElm = editor.getElement(), doc = editor.getDoc(), body, contentCssText;
	
	      // Restore visibility on target element
	      if (!settings.inline) {
	        editor.getElement().style.visibility = editor.orgVisibility;
	      }
	
	      // Setup iframe body
	      if (!skipWrite && !settings.content_editable) {
	        doc.open();
	        doc.write(editor.iframeHTML);
	        doc.close();
	      }
	
	      if (settings.content_editable) {
	        editor.on('remove', function () {
	          var bodyEl = this.getBody();
	
	          DOM.removeClass(bodyEl, 'mce-content-body');
	          DOM.removeClass(bodyEl, 'mce-edit-focus');
	          DOM.setAttrib(bodyEl, 'contentEditable', null);
	        });
	
	        DOM.addClass(targetElm, 'mce-content-body');
	        editor.contentDocument = doc = settings.content_document || document;
	        editor.contentWindow = settings.content_window || window;
	        editor.bodyElement = targetElm;
	
	        // Prevent leak in IE
	        settings.content_document = settings.content_window = null;
	
	        // TODO: Fix this
	        settings.root_name = targetElm.nodeName.toLowerCase();
	      }
	
	      // It will not steal focus while setting contentEditable
	      body = editor.getBody();
	      body.disabled = true;
	      editor.readonly = settings.readonly;
	
	      if (!editor.readonly) {
	        if (editor.inline && DOM.getStyle(body, 'position', true) === 'static') {
	          body.style.position = 'relative';
	        }
	
	        body.contentEditable = editor.getParam('content_editable_state', true);
	      }
	
	      body.disabled = false;
	
	      editor.editorUpload = new EditorUpload(editor);
	      editor.schema = new Schema(settings);
	      editor.dom = new DOMUtils(doc, {
	        keep_values: true,
	        url_converter: editor.convertURL,
	        url_converter_scope: editor,
	        hex_colors: settings.force_hex_style_colors,
	        class_filter: settings.class_filter,
	        update_styles: true,
	        root_element: editor.inline ? editor.getBody() : null,
	        collect: settings.content_editable,
	        schema: editor.schema,
	        onSetAttrib: function (e) {
	          editor.fire('SetAttrib', e);
	        }
	      });
	
	      editor.parser = createParser(editor);
	      editor.serializer = new Serializer(settings, editor);
	      editor.selection = new Selection(editor.dom, editor.getWin(), editor.serializer, editor);
	      editor.formatter = new Formatter(editor);
	      editor.undoManager = new UndoManager(editor);
	      editor._nodeChangeDispatcher = new NodeChange(editor);
	      editor._selectionOverrides = new SelectionOverrides(editor);
	
	      CaretContainerInput.setup(editor);
	      KeyboardOverrides.setup(editor);
	      ForceBlocks.setup(editor);
	
	      editor.fire('PreInit');
	
	      if (!settings.browser_spellcheck && !settings.gecko_spellcheck) {
	        doc.body.spellcheck = false; // Gecko
	        DOM.setAttrib(body, "spellcheck", "false");
	      }
	
	      editor.quirks = new Quirks(editor);
	      editor.fire('PostRender');
	
	      if (settings.directionality) {
	        body.dir = settings.directionality;
	      }
	
	      if (settings.nowrap) {
	        body.style.whiteSpace = "nowrap";
	      }
	
	      if (settings.protect) {
	        editor.on('BeforeSetContent', function (e) {
	          Tools.each(settings.protect, function (pattern) {
	            e.content = e.content.replace(pattern, function (str) {
	              return '<!--mce:protected ' + escape(str) + '-->';
	            });
	          });
	        });
	      }
	
	      editor.on('SetContent', function () {
	        editor.addVisual(editor.getBody());
	      });
	
	      // Remove empty contents
	      if (settings.padd_empty_editor) {
	        editor.on('PostProcess', function (e) {
	          e.content = e.content.replace(/^(<p[^>]*>(&nbsp;|&#160;|\s|\u00a0|<br \/>|)<\/p>[\r\n]*|<br \/>[\r\n]*)$/, '');
	        });
	      }
	
	      editor.load({ initial: true, format: 'html' });
	      editor.startContent = editor.getContent({ format: 'raw' });
	
	      editor.on('compositionstart compositionend', function (e) {
	        editor.composing = e.type === 'compositionstart';
	      });
	
	      // Add editor specific CSS styles
	      if (editor.contentStyles.length > 0) {
	        contentCssText = '';
	
	        Tools.each(editor.contentStyles, function (style) {
	          contentCssText += style + "\r\n";
	        });
	
	        editor.dom.addStyle(contentCssText);
	      }
	
	      getStyleSheetLoader(editor).loadAll(
	        editor.contentCSS,
	        function (_) {
	          initEditor(editor);
	        },
	        function (urls) {
	          initEditor(editor);
	        }
	      );
	
	      // Append specified content CSS last
	      if (settings.content_style) {
	        appendStyle(editor, settings.content_style);
	      }
	    };
	
	    return {
	      initContentBody: initContentBody
	    };
	  }
	);
	
	/**
	 * InitIframe.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.init.InitIframe',
	  [
	    'ephox.sugar.api.node.Element',
	    'ephox.sugar.api.properties.Attr',
	    'ephox.sugar.api.properties.Css',
	    'global!document',
	    'global!window',
	    'tinymce.core.Env',
	    'tinymce.core.api.Settings',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.init.InitContentBody',
	    'tinymce.core.util.Uuid'
	  ],
	  function (Element, Attr, Css, document, window, Env, Settings, DOMUtils, InitContentBody, Uuid) {
	    var DOM = DOMUtils.DOM;
	
	    var relaxDomain = function (editor, ifr) {
	      // Domain relaxing is required since the user has messed around with document.domain
	      // This only applies to IE 11 other browsers including Edge seems to handle document.domain
	      if (document.domain !== window.location.hostname && Env.ie && Env.ie < 12) {
	        var bodyUuid = Uuid.uuid('mce');
	
	        editor[bodyUuid] = function () {
	          InitContentBody.initContentBody(editor);
	        };
	
	        /*eslint no-script-url:0 */
	        var domainRelaxUrl = 'javascript:(function(){' +
	          'document.open();document.domain="' + document.domain + '";' +
	          'var ed = window.parent.tinymce.get("' + editor.id + '");document.write(ed.iframeHTML);' +
	          'document.close();ed.' + bodyUuid + '(true);})()';
	
	        DOM.setAttrib(ifr, 'src', domainRelaxUrl);
	        return true;
	      }
	
	      return false;
	    };
	
	    var normalizeHeight = function (height) {
	      var normalizedHeight = typeof height === 'number' ? height + 'px' : height;
	      return normalizedHeight ? normalizedHeight : '';
	    };
	
	    var createIframeElement = function (id, title, height, customAttrs) {
	      var iframe = Element.fromTag('iframe');
	
	      Attr.setAll(iframe, customAttrs);
	
	      Attr.setAll(iframe, {
	        id: id + '_ifr',
	        frameBorder: '0',
	        allowTransparency: 'true',
	        title: title
	      });
	
	      Css.setAll(iframe, {
	        width: '100%',
	        height: normalizeHeight(height),
	        display: 'block' // Important for Gecko to render the iframe correctly
	      });
	
	      return iframe;
	    };
	
	    var getIframeHtml = function (editor) {
	      var bodyId, bodyClass, iframeHTML;
	
	      iframeHTML = Settings.getDocType(editor) + '<html><head>';
	
	      // We only need to override paths if we have to
	      // IE has a bug where it remove site absolute urls to relative ones if this is specified
	      if (Settings.getDocumentBaseUrl(editor) !== editor.documentBaseUrl) {
	        iframeHTML += '<base href="' + editor.documentBaseURI.getURI() + '" />';
	      }
	
	      iframeHTML += '<meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />';
	
	      bodyId = Settings.getBodyId(editor);
	      bodyClass = Settings.getBodyClass(editor);
	
	      if (Settings.getContentSecurityPolicy(editor)) {
	        iframeHTML += '<meta http-equiv="Content-Security-Policy" content="' + Settings.getContentSecurityPolicy(editor) + '" />';
	      }
	
	      iframeHTML += '</head><body id="' + bodyId +
	        '" class="mce-content-body ' + bodyClass +
	        '" data-id="' + editor.id + '"><br></body></html>';
	
	      return iframeHTML;
	    };
	
	    var createIframe = function (editor, o) {
	      var title = editor.editorManager.translate(
	        "Rich Text Area. Press ALT-F9 for menu. " +
	        "Press ALT-F10 for toolbar. Press ALT-0 for help"
	      );
	
	      var ifr = createIframeElement(editor.id, title, o.height, Settings.getIframeAttrs(editor)).dom();
	
	      ifr.onload = function () {
	        ifr.onload = null;
	        editor.fire("load");
	      };
	
	      var isDomainRelaxed = relaxDomain(editor, ifr);
	
	      editor.contentAreaContainer = o.iframeContainer;
	      editor.iframeElement = ifr;
	      editor.iframeHTML = getIframeHtml(editor);
	
	      DOM.add(o.iframeContainer, ifr);
	
	      return isDomainRelaxed;
	    };
	
	    var init = function (editor, boxInfo) {
	      var isDomainRelaxed = createIframe(editor, boxInfo);
	
	      if (boxInfo.editorContainer) {
	        DOM.get(boxInfo.editorContainer).style.display = editor.orgDisplay;
	        editor.hidden = DOM.isHidden(boxInfo.editorContainer);
	      }
	
	      editor.getElement().style.display = 'none';
	      DOM.setAttrib(editor.id, 'aria-hidden', true);
	
	      if (!isDomainRelaxed) {
	        InitContentBody.initContentBody(editor);
	      }
	    };
	
	    return {
	      init: init
	    };
	  }
	);
	
	/**
	 * Init.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.init.Init',
	  [
	    'ephox.katamari.api.Type',
	    'global!document',
	    'global!window',
	    'tinymce.core.PluginManager',
	    'tinymce.core.ThemeManager',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.init.InitContentBody',
	    'tinymce.core.init.InitIframe',
	    'tinymce.core.util.Tools'
	  ],
	  function (Type, document, window, PluginManager, ThemeManager, DOMUtils, InitContentBody, InitIframe, Tools) {
	    var DOM = DOMUtils.DOM;
	
	    var initPlugin = function (editor, initializedPlugins, plugin) {
	      var Plugin = PluginManager.get(plugin), pluginUrl, pluginInstance;
	
	      pluginUrl = PluginManager.urls[plugin] || editor.documentBaseUrl.replace(/\/$/, '');
	      plugin = Tools.trim(plugin);
	      if (Plugin && Tools.inArray(initializedPlugins, plugin) === -1) {
	        Tools.each(PluginManager.dependencies(plugin), function (dep) {
	          initPlugin(editor, initializedPlugins, dep);
	        });
	
	        if (editor.plugins[plugin]) {
	          return;
	        }
	
	        pluginInstance = new Plugin(editor, pluginUrl, editor.$);
	
	        editor.plugins[plugin] = pluginInstance;
	
	        if (pluginInstance.init) {
	          pluginInstance.init(editor, pluginUrl);
	          initializedPlugins.push(plugin);
	        }
	      }
	    };
	
	    var trimLegacyPrefix = function (name) {
	      // Themes and plugins can be prefixed with - to prevent them from being lazy loaded
	      return name.replace(/^\-/, '');
	    };
	
	    var initPlugins = function (editor) {
	      var initializedPlugins = [];
	
	      Tools.each(editor.settings.plugins.split(/[ ,]/), function (name) {
	        initPlugin(editor, initializedPlugins, trimLegacyPrefix(name));
	      });
	    };
	
	    var initTheme = function (editor) {
	      var Theme, theme = editor.settings.theme;
	
	      if (Type.isString(theme)) {
	        editor.settings.theme = trimLegacyPrefix(theme);
	
	        Theme = ThemeManager.get(theme);
	        editor.theme = new Theme(editor, ThemeManager.urls[theme]);
	
	        if (editor.theme.init) {
	          editor.theme.init(editor, ThemeManager.urls[theme] || editor.documentBaseUrl.replace(/\/$/, ''), editor.$);
	        }
	      } else {
	        // Theme set to false or null doesn't produce a theme api
	        editor.theme = {};
	      }
	    };
	
	    var renderFromLoadedTheme = function (editor) {
	      var w, h, minHeight, re, info, settings = editor.settings, elm = editor.getElement();
	
	      w = settings.width || DOM.getStyle(elm, 'width') || '100%';
	      h = settings.height || DOM.getStyle(elm, 'height') || elm.offsetHeight;
	      minHeight = settings.min_height || 100;
	      re = /^[0-9\.]+(|px)$/i;
	
	      if (re.test('' + w)) {
	        w = Math.max(parseInt(w, 10), 100);
	      }
	
	      if (re.test('' + h)) {
	        h = Math.max(parseInt(h, 10), minHeight);
	      }
	
	      // Render UI
	      info = editor.theme.renderUI({
	        targetNode: elm,
	        width: w,
	        height: h,
	        deltaWidth: settings.delta_width,
	        deltaHeight: settings.delta_height
	      });
	
	      // Resize editor
	      if (!settings.content_editable) {
	        h = (info.iframeHeight || h) + (typeof h === 'number' ? (info.deltaHeight || 0) : '');
	        if (h < minHeight) {
	          h = minHeight;
	        }
	      }
	
	      info.height = h;
	
	      return info;
	    };
	
	    var renderFromThemeFunc = function (editor) {
	      var info, elm = editor.getElement();
	
	      info = editor.settings.theme(editor, elm);
	
	      if (info.editorContainer.nodeType) {
	        info.editorContainer.id = info.editorContainer.id || editor.id + "_parent";
	      }
	
	      if (info.iframeContainer && info.iframeContainer.nodeType) {
	        info.iframeContainer.id = info.iframeContainer.id || editor.id + "_iframecontainer";
	      }
	
	      info.height = info.iframeHeight ? info.iframeHeight : elm.offsetHeight;
	
	      return info;
	    };
	
	    var createThemeFalseResult = function (element) {
	      return {
	        editorContainer: element,
	        iframeContainer: element
	      };
	    };
	
	    var renderThemeFalseIframe = function (targetElement) {
	      var iframeContainer = DOM.create('div');
	
	      DOM.insertAfter(iframeContainer, targetElement);
	
	      return createThemeFalseResult(iframeContainer);
	    };
	
	    var renderThemeFalse = function (editor) {
	      var targetElement = editor.getElement();
	      return editor.inline ? createThemeFalseResult(null) : renderThemeFalseIframe(targetElement);
	    };
	
	    var renderThemeUi = function (editor) {
	      var settings = editor.settings, elm = editor.getElement();
	
	      editor.orgDisplay = elm.style.display;
	
	      if (Type.isString(settings.theme)) {
	        return renderFromLoadedTheme(editor);
	      } else if (Type.isFunction(settings.theme)) {
	        return renderFromThemeFunc(editor);
	      } else {
	        return renderThemeFalse(editor);
	      }
	    };
	
	    var init = function (editor) {
	      var settings = editor.settings, elm = editor.getElement(), boxInfo;
	
	      editor.rtl = settings.rtl_ui || editor.editorManager.i18n.rtl;
	      editor.editorManager.i18n.setCode(settings.language);
	      settings.aria_label = settings.aria_label || DOM.getAttrib(elm, 'aria-label', editor.getLang('aria.rich_text_area'));
	
	      editor.fire('ScriptsLoaded');
	
	      initTheme(editor);
	      initPlugins(editor);
	      boxInfo = renderThemeUi(editor);
	      editor.editorContainer = boxInfo.editorContainer ? boxInfo.editorContainer : null;
	
	      // Load specified content CSS last
	      if (settings.content_css) {
	        Tools.each(Tools.explode(settings.content_css), function (u) {
	          editor.contentCSS.push(editor.documentBaseURI.toAbsolute(u));
	        });
	      }
	
	      // Content editable mode ends here
	      if (settings.content_editable) {
	        return InitContentBody.initContentBody(editor);
	      } else {
	        return InitIframe.init(editor, boxInfo);
	      }
	    };
	
	    return {
	      init: init
	    };
	  }
	);
	
	/**
	 * Render.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.init.Render',
	  [
	    'ephox.katamari.api.Type',
	    'global!window',
	    'tinymce.core.api.NotificationManager',
	    'tinymce.core.api.WindowManager',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.dom.EventUtils',
	    'tinymce.core.dom.ScriptLoader',
	    'tinymce.core.Env',
	    'tinymce.core.ErrorReporter',
	    'tinymce.core.init.Init',
	    'tinymce.core.PluginManager',
	    'tinymce.core.ThemeManager',
	    'tinymce.core.util.Tools'
	  ],
	  function (Type, window, NotificationManager, WindowManager, DOMUtils, EventUtils, ScriptLoader, Env, ErrorReporter, Init, PluginManager, ThemeManager, Tools) {
	    var DOM = DOMUtils.DOM;
	
	    var hasSkipLoadPrefix = function (name) {
	      return name.charAt(0) === '-';
	    };
	
	    var loadLanguage = function (scriptLoader, editor) {
	      var settings = editor.settings;
	
	      if (settings.language && settings.language !== 'en' && !settings.language_url) {
	        settings.language_url = editor.editorManager.baseURL + '/langs/' + settings.language + '.js';
	      }
	
	      if (settings.language_url && !editor.editorManager.i18n.data[settings.language]) {
	        scriptLoader.add(settings.language_url);
	      }
	    };
	
	    var loadTheme = function (scriptLoader, editor, suffix, callback) {
	      var settings = editor.settings, theme = settings.theme;
	
	      if (Type.isString(theme)) {
	        if (!hasSkipLoadPrefix(theme) && !ThemeManager.urls.hasOwnProperty(theme)) {
	          var themeUrl = settings.theme_url;
	
	          if (themeUrl) {
	            ThemeManager.load(theme, editor.documentBaseURI.toAbsolute(themeUrl));
	          } else {
	            ThemeManager.load(theme, 'themes/' + theme + '/theme' + suffix + '.js');
	          }
	        }
	
	        scriptLoader.loadQueue(function () {
	          ThemeManager.waitFor(theme, callback);
	        });
	      } else {
	        callback();
	      }
	    };
	
	    var loadPlugins = function (settings, suffix) {
	      if (Tools.isArray(settings.plugins)) {
	        settings.plugins = settings.plugins.join(' ');
	      }
	
	      Tools.each(settings.external_plugins, function (url, name) {
	        PluginManager.load(name, url);
	        settings.plugins += ' ' + name;
	      });
	
	      Tools.each(settings.plugins.split(/[ ,]/), function (plugin) {
	        plugin = Tools.trim(plugin);
	
	        if (plugin && !PluginManager.urls[plugin]) {
	          if (hasSkipLoadPrefix(plugin)) {
	            plugin = plugin.substr(1, plugin.length);
	
	            var dependencies = PluginManager.dependencies(plugin);
	
	            Tools.each(dependencies, function (dep) {
	              var defaultSettings = {
	                prefix: 'plugins/',
	                resource: dep,
	                suffix: '/plugin' + suffix + '.js'
	              };
	
	              dep = PluginManager.createUrl(defaultSettings, dep);
	              PluginManager.load(dep.resource, dep);
	            });
	          } else {
	            PluginManager.load(plugin, {
	              prefix: 'plugins/',
	              resource: plugin,
	              suffix: '/plugin' + suffix + '.js'
	            });
	          }
	        }
	      });
	    };
	
	    var loadScripts = function (editor, suffix) {
	      var scriptLoader = ScriptLoader.ScriptLoader;
	
	      loadTheme(scriptLoader, editor, suffix, function () {
	        loadLanguage(scriptLoader, editor);
	        loadPlugins(editor.settings, suffix);
	
	        scriptLoader.loadQueue(function () {
	          if (!editor.removed) {
	            Init.init(editor);
	          }
	        }, editor, function (urls) {
	          ErrorReporter.pluginLoadError(editor, urls[0]);
	
	          if (!editor.removed) {
	            Init.init(editor);
	          }
	        });
	      });
	    };
	
	    var render = function (editor) {
	      var settings = editor.settings, id = editor.id;
	
	      var readyHandler = function () {
	        DOM.unbind(window, 'ready', readyHandler);
	        editor.render();
	      };
	
	      // Page is not loaded yet, wait for it
	      if (!EventUtils.Event.domLoaded) {
	        DOM.bind(window, 'ready', readyHandler);
	        return;
	      }
	
	      // Element not found, then skip initialization
	      if (!editor.getElement()) {
	        return;
	      }
	
	      // No editable support old iOS versions etc
	      if (!Env.contentEditable) {
	        return;
	      }
	
	      // Hide target element early to prevent content flashing
	      if (!settings.inline) {
	        editor.orgVisibility = editor.getElement().style.visibility;
	        editor.getElement().style.visibility = 'hidden';
	      } else {
	        editor.inline = true;
	      }
	
	      var form = editor.getElement().form || DOM.getParent(id, 'form');
	      if (form) {
	        editor.formElement = form;
	
	        // Add hidden input for non input elements inside form elements
	        if (settings.hidden_input && !/TEXTAREA|INPUT/i.test(editor.getElement().nodeName)) {
	          DOM.insertAfter(DOM.create('input', { type: 'hidden', name: id }), id);
	          editor.hasHiddenInput = true;
	        }
	
	        // Pass submit/reset from form to editor instance
	        editor.formEventDelegate = function (e) {
	          editor.fire(e.type, e);
	        };
	
	        DOM.bind(form, 'submit reset', editor.formEventDelegate);
	
	        // Reset contents in editor when the form is reset
	        editor.on('reset', function () {
	          editor.setContent(editor.startContent, { format: 'raw' });
	        });
	
	        // Check page uses id="submit" or name="submit" for it's submit button
	        if (settings.submit_patch && !form.submit.nodeType && !form.submit.length && !form._mceOldSubmit) {
	          form._mceOldSubmit = form.submit;
	          form.submit = function () {
	            editor.editorManager.triggerSave();
	            editor.setDirty(false);
	
	            return form._mceOldSubmit(form);
	          };
	        }
	      }
	
	      editor.windowManager = new WindowManager(editor);
	      editor.notificationManager = new NotificationManager(editor);
	
	      if (settings.encoding === 'xml') {
	        editor.on('GetContent', function (e) {
	          if (e.save) {
	            e.content = DOM.encode(e.content);
	          }
	        });
	      }
	
	      if (settings.add_form_submit_trigger) {
	        editor.on('submit', function () {
	          if (editor.initialized) {
	            editor.save();
	          }
	        });
	      }
	
	      if (settings.add_unload_trigger) {
	        editor._beforeUnload = function () {
	          if (editor.initialized && !editor.destroyed && !editor.isHidden()) {
	            editor.save({ format: 'raw', no_events: true, set_dirty: false });
	          }
	        };
	
	        editor.editorManager.on('BeforeUnload', editor._beforeUnload);
	      }
	
	      editor.editorManager.add(editor);
	      loadScripts(editor, editor.suffix);
	    };
	
	    return {
	      render: render
	    };
	  }
	);
	
	/**
	 * Sidebar.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This module handle sidebar instances for the editor.
	 *
	 * @class tinymce.ui.Sidebar
	 * @private
	 */
	define(
	  'tinymce.core.ui.Sidebar',
	  [
	  ],
	  function (
	  ) {
	    var add = function (editor, name, settings) {
	      var sidebars = editor.sidebars ? editor.sidebars : [];
	      sidebars.push({ name: name, settings: settings });
	      editor.sidebars = sidebars;
	    };
	
	    return {
	      add: add
	    };
	  }
	);
	
	/**
	 * URI.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class handles parsing, modification and serialization of URI/URL strings.
	 * @class tinymce.util.URI
	 */
	define(
	  'tinymce.core.util.URI',
	  [
	    'global!document',
	    'tinymce.core.util.Tools'
	  ],
	  function (document, Tools) {
	    var each = Tools.each, trim = Tools.trim;
	    var queryParts = "source protocol authority userInfo user password host port relative path directory file query anchor".split(' ');
	    var DEFAULT_PORTS = {
	      'ftp': 21,
	      'http': 80,
	      'https': 443,
	      'mailto': 25
	    };
	
	    /**
	     * Constructs a new URI instance.
	     *
	     * @constructor
	     * @method URI
	     * @param {String} url URI string to parse.
	     * @param {Object} settings Optional settings object.
	     */
	    var URI = function (url, settings) {
	      var self = this, baseUri, baseUrl;
	
	      url = trim(url);
	      settings = self.settings = settings || {};
	      baseUri = settings.base_uri;
	
	      // Strange app protocol that isn't http/https or local anchor
	      // For example: mailto,skype,tel etc.
	      if (/^([\w\-]+):([^\/]{2})/i.test(url) || /^\s*#/.test(url)) {
	        self.source = url;
	        return;
	      }
	
	      var isProtocolRelative = url.indexOf('//') === 0;
	
	      // Absolute path with no host, fake host and protocol
	      if (url.indexOf('/') === 0 && !isProtocolRelative) {
	        url = (baseUri ? baseUri.protocol || 'http' : 'http') + '://mce_host' + url;
	      }
	
	      // Relative path http:// or protocol relative //path
	      if (!/^[\w\-]*:?\/\//.test(url)) {
	        baseUrl = settings.base_uri ? settings.base_uri.path : new URI(document.location.href).directory;
	        if (settings.base_uri.protocol === "") {
	          url = '//mce_host' + self.toAbsPath(baseUrl, url);
	        } else {
	          url = /([^#?]*)([#?]?.*)/.exec(url);
	          url = ((baseUri && baseUri.protocol) || 'http') + '://mce_host' + self.toAbsPath(baseUrl, url[1]) + url[2];
	        }
	      }
	
	      // Parse URL (Credits goes to Steave, http://blog.stevenlevithan.com/archives/parseuri)
	      url = url.replace(/@@/g, '(mce_at)'); // Zope 3 workaround, they use @@something
	
	      /*jshint maxlen: 255 */
	      /*eslint max-len: 0 */
	      url = /^(?:(?![^:@]+:[^:@\/]*@)([^:\/?#.]+):)?(?:\/\/)?((?:(([^:@\/]*):?([^:@\/]*))?@)?([^:\/?#]*)(?::(\d*))?)(((\/(?:[^?#](?![^?#\/]*\.[^?#\/.]+(?:[?#]|$)))*\/?)?([^?#\/]*))(?:\?([^#]*))?(?:#(.*))?)/.exec(url);
	
	      each(queryParts, function (v, i) {
	        var part = url[i];
	
	        // Zope 3 workaround, they use @@something
	        if (part) {
	          part = part.replace(/\(mce_at\)/g, '@@');
	        }
	
	        self[v] = part;
	      });
	
	      if (baseUri) {
	        if (!self.protocol) {
	          self.protocol = baseUri.protocol;
	        }
	
	        if (!self.userInfo) {
	          self.userInfo = baseUri.userInfo;
	        }
	
	        if (!self.port && self.host === 'mce_host') {
	          self.port = baseUri.port;
	        }
	
	        if (!self.host || self.host === 'mce_host') {
	          self.host = baseUri.host;
	        }
	
	        self.source = '';
	      }
	
	      if (isProtocolRelative) {
	        self.protocol = '';
	      }
	
	      //t.path = t.path || '/';
	    };
	
	    URI.prototype = {
	      /**
	       * Sets the internal path part of the URI.
	       *
	       * @method setPath
	       * @param {string} path Path string to set.
	       */
	      setPath: function (path) {
	        var self = this;
	
	        path = /^(.*?)\/?(\w+)?$/.exec(path);
	
	        // Update path parts
	        self.path = path[0];
	        self.directory = path[1];
	        self.file = path[2];
	
	        // Rebuild source
	        self.source = '';
	        self.getURI();
	      },
	
	      /**
	       * Converts the specified URI into a relative URI based on the current URI instance location.
	       *
	       * @method toRelative
	       * @param {String} uri URI to convert into a relative path/URI.
	       * @return {String} Relative URI from the point specified in the current URI instance.
	       * @example
	       * // Converts an absolute URL to an relative URL url will be somedir/somefile.htm
	       * var url = new tinymce.util.URI('http://www.site.com/dir/').toRelative('http://www.site.com/dir/somedir/somefile.htm');
	       */
	      toRelative: function (uri) {
	        var self = this, output;
	
	        if (uri === "./") {
	          return uri;
	        }
	
	        uri = new URI(uri, { base_uri: self });
	
	        // Not on same domain/port or protocol
	        if ((uri.host != 'mce_host' && self.host != uri.host && uri.host) || self.port != uri.port ||
	          (self.protocol != uri.protocol && uri.protocol !== "")) {
	          return uri.getURI();
	        }
	
	        var tu = self.getURI(), uu = uri.getURI();
	
	        // Allow usage of the base_uri when relative_urls = true
	        if (tu == uu || (tu.charAt(tu.length - 1) == "/" && tu.substr(0, tu.length - 1) == uu)) {
	          return tu;
	        }
	
	        output = self.toRelPath(self.path, uri.path);
	
	        // Add query
	        if (uri.query) {
	          output += '?' + uri.query;
	        }
	
	        // Add anchor
	        if (uri.anchor) {
	          output += '#' + uri.anchor;
	        }
	
	        return output;
	      },
	
	      /**
	       * Converts the specified URI into a absolute URI based on the current URI instance location.
	       *
	       * @method toAbsolute
	       * @param {String} uri URI to convert into a relative path/URI.
	       * @param {Boolean} noHost No host and protocol prefix.
	       * @return {String} Absolute URI from the point specified in the current URI instance.
	       * @example
	       * // Converts an relative URL to an absolute URL url will be http://www.site.com/dir/somedir/somefile.htm
	       * var url = new tinymce.util.URI('http://www.site.com/dir/').toAbsolute('somedir/somefile.htm');
	       */
	      toAbsolute: function (uri, noHost) {
	        uri = new URI(uri, { base_uri: this });
	
	        return uri.getURI(noHost && this.isSameOrigin(uri));
	      },
	
	      /**
	       * Determine whether the given URI has the same origin as this URI.  Based on RFC-6454.
	       * Supports default ports for protocols listed in DEFAULT_PORTS.  Unsupported protocols will fail safe: they
	       * won't match, if the port specifications differ.
	       *
	       * @method isSameOrigin
	       * @param {tinymce.util.URI} uri Uri instance to compare.
	       * @returns {Boolean} True if the origins are the same.
	       */
	      isSameOrigin: function (uri) {
	        if (this.host == uri.host && this.protocol == uri.protocol) {
	          if (this.port == uri.port) {
	            return true;
	          }
	
	          var defaultPort = DEFAULT_PORTS[this.protocol];
	          if (defaultPort && ((this.port || defaultPort) == (uri.port || defaultPort))) {
	            return true;
	          }
	        }
	
	        return false;
	      },
	
	      /**
	       * Converts a absolute path into a relative path.
	       *
	       * @method toRelPath
	       * @param {String} base Base point to convert the path from.
	       * @param {String} path Absolute path to convert into a relative path.
	       */
	      toRelPath: function (base, path) {
	        var items, breakPoint = 0, out = '', i, l;
	
	        // Split the paths
	        base = base.substring(0, base.lastIndexOf('/'));
	        base = base.split('/');
	        items = path.split('/');
	
	        if (base.length >= items.length) {
	          for (i = 0, l = base.length; i < l; i++) {
	            if (i >= items.length || base[i] != items[i]) {
	              breakPoint = i + 1;
	              break;
	            }
	          }
	        }
	
	        if (base.length < items.length) {
	          for (i = 0, l = items.length; i < l; i++) {
	            if (i >= base.length || base[i] != items[i]) {
	              breakPoint = i + 1;
	              break;
	            }
	          }
	        }
	
	        if (breakPoint === 1) {
	          return path;
	        }
	
	        for (i = 0, l = base.length - (breakPoint - 1); i < l; i++) {
	          out += "../";
	        }
	
	        for (i = breakPoint - 1, l = items.length; i < l; i++) {
	          if (i != breakPoint - 1) {
	            out += "/" + items[i];
	          } else {
	            out += items[i];
	          }
	        }
	
	        return out;
	      },
	
	      /**
	       * Converts a relative path into a absolute path.
	       *
	       * @method toAbsPath
	       * @param {String} base Base point to convert the path from.
	       * @param {String} path Relative path to convert into an absolute path.
	       */
	      toAbsPath: function (base, path) {
	        var i, nb = 0, o = [], tr, outPath;
	
	        // Split paths
	        tr = /\/$/.test(path) ? '/' : '';
	        base = base.split('/');
	        path = path.split('/');
	
	        // Remove empty chunks
	        each(base, function (k) {
	          if (k) {
	            o.push(k);
	          }
	        });
	
	        base = o;
	
	        // Merge relURLParts chunks
	        for (i = path.length - 1, o = []; i >= 0; i--) {
	          // Ignore empty or .
	          if (path[i].length === 0 || path[i] === ".") {
	            continue;
	          }
	
	          // Is parent
	          if (path[i] === '..') {
	            nb++;
	            continue;
	          }
	
	          // Move up
	          if (nb > 0) {
	            nb--;
	            continue;
	          }
	
	          o.push(path[i]);
	        }
	
	        i = base.length - nb;
	
	        // If /a/b/c or /
	        if (i <= 0) {
	          outPath = o.reverse().join('/');
	        } else {
	          outPath = base.slice(0, i).join('/') + '/' + o.reverse().join('/');
	        }
	
	        // Add front / if it's needed
	        if (outPath.indexOf('/') !== 0) {
	          outPath = '/' + outPath;
	        }
	
	        // Add traling / if it's needed
	        if (tr && outPath.lastIndexOf('/') !== outPath.length - 1) {
	          outPath += tr;
	        }
	
	        return outPath;
	      },
	
	      /**
	       * Returns the full URI of the internal structure.
	       *
	       * @method getURI
	       * @param {Boolean} noProtoHost Optional no host and protocol part. Defaults to false.
	       */
	      getURI: function (noProtoHost) {
	        var s, self = this;
	
	        // Rebuild source
	        if (!self.source || noProtoHost) {
	          s = '';
	
	          if (!noProtoHost) {
	            if (self.protocol) {
	              s += self.protocol + '://';
	            } else {
	              s += '//';
	            }
	
	            if (self.userInfo) {
	              s += self.userInfo + '@';
	            }
	
	            if (self.host) {
	              s += self.host;
	            }
	
	            if (self.port) {
	              s += ':' + self.port;
	            }
	          }
	
	          if (self.path) {
	            s += self.path;
	          }
	
	          if (self.query) {
	            s += '?' + self.query;
	          }
	
	          if (self.anchor) {
	            s += '#' + self.anchor;
	          }
	
	          self.source = s;
	        }
	
	        return self.source;
	      }
	    };
	
	    URI.parseDataUri = function (uri) {
	      var type, matches;
	
	      uri = decodeURIComponent(uri).split(',');
	
	      matches = /data:([^;]+)/.exec(uri[0]);
	      if (matches) {
	        type = matches[1];
	      }
	
	      return {
	        type: type,
	        data: uri[1]
	      };
	    };
	
	    URI.getDocumentBaseUrl = function (loc) {
	      var baseUrl;
	
	      // Pass applewebdata:// and other non web protocols though
	      if (loc.protocol.indexOf('http') !== 0 && loc.protocol !== 'file:') {
	        baseUrl = loc.href;
	      } else {
	        baseUrl = loc.protocol + '//' + loc.host + loc.pathname;
	      }
	
	      if (/^[^:]+:\/\/\/?[^\/]+\//.test(baseUrl)) {
	        baseUrl = baseUrl.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	
	        if (!/[\/\\]$/.test(baseUrl)) {
	          baseUrl += '/';
	        }
	      }
	
	      return baseUrl;
	    };
	
	    return URI;
	  }
	);
	
	/**
	 * Editor.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/*jshint scripturl:true */
	
	/**
	 * Include the base event class documentation.
	 *
	 * @include ../../../../../tools/docs/tinymce.Event.js
	 */
	
	/**
	 * This class contains the core logic for a TinyMCE editor.
	 *
	 * @class tinymce.Editor
	 * @mixes tinymce.util.Observable
	 * @example
	 * // Add a class to all paragraphs in the editor.
	 * tinymce.activeEditor.dom.addClass(tinymce.activeEditor.dom.select('p'), 'someclass');
	 *
	 * // Gets the current editors selection as text
	 * tinymce.activeEditor.selection.getContent({format: 'text'});
	 *
	 * // Creates a new editor instance
	 * var ed = new tinymce.Editor('textareaid', {
	 *     some_setting: 1
	 * }, tinymce.EditorManager);
	 *
	 * ed.render();
	 */
	define(
	  'tinymce.core.Editor',
	  [
	    'tinymce.core.AddOnManager',
	    'tinymce.core.EditorCommands',
	    'tinymce.core.EditorObservable',
	    'tinymce.core.EditorSettings',
	    'tinymce.core.Env',
	    'tinymce.core.Mode',
	    'tinymce.core.Shortcuts',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.dom.DomQuery',
	    'tinymce.core.dom.TrimHtml',
	    'tinymce.core.focus.EditorFocus',
	    'tinymce.core.html.Serializer',
	    'tinymce.core.init.Render',
	    'tinymce.core.ui.Sidebar',
	    'tinymce.core.util.Tools',
	    'tinymce.core.util.URI',
	    'tinymce.core.util.Uuid'
	  ],
	  function (
	    AddOnManager, EditorCommands, EditorObservable, EditorSettings, Env, Mode, Shortcuts, DOMUtils, DomQuery, TrimHtml, EditorFocus, Serializer, Render, Sidebar,
	    Tools, URI, Uuid
	  ) {
	    // Shorten these names
	    var DOM = DOMUtils.DOM;
	    var extend = Tools.extend, each = Tools.each;
	    var trim = Tools.trim, resolve = Tools.resolve;
	    var ie = Env.ie;
	
	    /**
	     * Include Editor API docs.
	     *
	     * @include ../../../../../tools/docs/tinymce.Editor.js
	     */
	
	    /**
	     * Constructs a editor instance by id.
	     *
	     * @constructor
	     * @method Editor
	     * @param {String} id Unique id for the editor.
	     * @param {Object} settings Settings for the editor.
	     * @param {tinymce.EditorManager} editorManager EditorManager instance.
	     */
	    var Editor = function (id, settings, editorManager) {
	      var self = this, documentBaseUrl, baseUri;
	
	      documentBaseUrl = self.documentBaseUrl = editorManager.documentBaseURL;
	      baseUri = editorManager.baseURI;
	
	      /**
	       * Name/value collection with editor settings.
	       *
	       * @property settings
	       * @type Object
	       * @example
	       * // Get the value of the theme setting
	       * tinymce.activeEditor.windowManager.alert("You are using the " + tinymce.activeEditor.settings.theme + " theme");
	       */
	      settings = EditorSettings.getEditorSettings(self, id, documentBaseUrl, editorManager.defaultSettings, settings);
	      self.settings = settings;
	
	      AddOnManager.language = settings.language || 'en';
	      AddOnManager.languageLoad = settings.language_load;
	      AddOnManager.baseURL = editorManager.baseURL;
	
	      /**
	       * Editor instance id, normally the same as the div/textarea that was replaced.
	       *
	       * @property id
	       * @type String
	       */
	      self.id = id;
	
	      /**
	       * State to force the editor to return false on a isDirty call.
	       *
	       * @property isNotDirty
	       * @type Boolean
	       * @deprecated Use editor.setDirty instead.
	       */
	      self.setDirty(false);
	
	      /**
	       * Name/Value object containing plugin instances.
	       *
	       * @property plugins
	       * @type Object
	       * @example
	       * // Execute a method inside a plugin directly
	       * tinymce.activeEditor.plugins.someplugin.someMethod();
	       */
	      self.plugins = {};
	
	      /**
	       * URI object to document configured for the TinyMCE instance.
	       *
	       * @property documentBaseURI
	       * @type tinymce.util.URI
	       * @example
	       * // Get relative URL from the location of document_base_url
	       * tinymce.activeEditor.documentBaseURI.toRelative('/somedir/somefile.htm');
	       *
	       * // Get absolute URL from the location of document_base_url
	       * tinymce.activeEditor.documentBaseURI.toAbsolute('somefile.htm');
	       */
	      self.documentBaseURI = new URI(settings.document_base_url, {
	        base_uri: baseUri
	      });
	
	      /**
	       * URI object to current document that holds the TinyMCE editor instance.
	       *
	       * @property baseURI
	       * @type tinymce.util.URI
	       * @example
	       * // Get relative URL from the location of the API
	       * tinymce.activeEditor.baseURI.toRelative('/somedir/somefile.htm');
	       *
	       * // Get absolute URL from the location of the API
	       * tinymce.activeEditor.baseURI.toAbsolute('somefile.htm');
	       */
	      self.baseURI = baseUri;
	
	      /**
	       * Array with CSS files to load into the iframe.
	       *
	       * @property contentCSS
	       * @type Array
	       */
	      self.contentCSS = [];
	
	      /**
	       * Array of CSS styles to add to head of document when the editor loads.
	       *
	       * @property contentStyles
	       * @type Array
	       */
	      self.contentStyles = [];
	
	      self.shortcuts = new Shortcuts(self);
	      self.loadedCSS = {};
	      self.editorCommands = new EditorCommands(self);
	      self.suffix = editorManager.suffix;
	      self.editorManager = editorManager;
	      self.inline = settings.inline;
	      self.buttons = {};
	      self.menuItems = {};
	
	      if (settings.cache_suffix) {
	        Env.cacheSuffix = settings.cache_suffix.replace(/^[\?\&]+/, '');
	      }
	
	      if (settings.override_viewport === false) {
	        Env.overrideViewPort = false;
	      }
	
	      // Call setup
	      editorManager.fire('SetupEditor', self);
	      self.execCallback('setup', self);
	
	      /**
	       * Dom query instance with default scope to the editor document and default element is the body of the editor.
	       *
	       * @property $
	       * @type tinymce.dom.DomQuery
	       * @example
	       * tinymce.activeEditor.$('p').css('color', 'red');
	       * tinymce.activeEditor.$().append('<p>new</p>');
	       */
	      self.$ = DomQuery.overrideDefaults(function () {
	        return {
	          context: self.inline ? self.getBody() : self.getDoc(),
	          element: self.getBody()
	        };
	      });
	    };
	
	    Editor.prototype = {
	      /**
	       * Renders the editor/adds it to the page.
	       *
	       * @method render
	       */
	      render: function () {
	        Render.render(this);
	      },
	
	      /**
	       * Focuses/activates the editor. This will set this editor as the activeEditor in the tinymce collection
	       * it will also place DOM focus inside the editor.
	       *
	       * @method focus
	       * @param {Boolean} skipFocus Skip DOM focus. Just set is as the active editor.
	       */
	      focus: function (skipFocus) {
	        EditorFocus.focus(this, skipFocus);
	      },
	
	      /**
	       * Executes a legacy callback. This method is useful to call old 2.x option callbacks.
	       * There new event model is a better way to add callback so this method might be removed in the future.
	       *
	       * @method execCallback
	       * @param {String} name Name of the callback to execute.
	       * @return {Object} Return value passed from callback function.
	       */
	      execCallback: function (name) {
	        var self = this, callback = self.settings[name], scope;
	
	        if (!callback) {
	          return;
	        }
	
	        // Look through lookup
	        if (self.callbackLookup && (scope = self.callbackLookup[name])) {
	          callback = scope.func;
	          scope = scope.scope;
	        }
	
	        if (typeof callback === 'string') {
	          scope = callback.replace(/\.\w+$/, '');
	          scope = scope ? resolve(scope) : 0;
	          callback = resolve(callback);
	          self.callbackLookup = self.callbackLookup || {};
	          self.callbackLookup[name] = { func: callback, scope: scope };
	        }
	
	        return callback.apply(scope || self, Array.prototype.slice.call(arguments, 1));
	      },
	
	      /**
	       * Translates the specified string by replacing variables with language pack items it will also check if there is
	       * a key matching the input.
	       *
	       * @method translate
	       * @param {String} text String to translate by the language pack data.
	       * @return {String} Translated string.
	       */
	      translate: function (text) {
	        if (text && Tools.is(text, 'string')) {
	          var lang = this.settings.language || 'en', i18n = this.editorManager.i18n;
	
	          text = i18n.data[lang + '.' + text] || text.replace(/\{\#([^\}]+)\}/g, function (a, b) {
	            return i18n.data[lang + '.' + b] || '{#' + b + '}';
	          });
	        }
	
	        return this.editorManager.translate(text);
	      },
	
	      /**
	       * Returns a language pack item by name/key.
	       *
	       * @method getLang
	       * @param {String} name Name/key to get from the language pack.
	       * @param {String} defaultVal Optional default value to retrieve.
	       */
	      getLang: function (name, defaultVal) {
	        return (
	          this.editorManager.i18n.data[(this.settings.language || 'en') + '.' + name] ||
	          (defaultVal !== undefined ? defaultVal : '{#' + name + '}')
	        );
	      },
	
	      /**
	       * Returns a configuration parameter by name.
	       *
	       * @method getParam
	       * @param {String} name Configruation parameter to retrieve.
	       * @param {String} defaultVal Optional default value to return.
	       * @param {String} type Optional type parameter.
	       * @return {String} Configuration parameter value or default value.
	       * @example
	       * // Returns a specific config value from the currently active editor
	       * var someval = tinymce.activeEditor.getParam('myvalue');
	       *
	       * // Returns a specific config value from a specific editor instance by id
	       * var someval2 = tinymce.get('my_editor').getParam('myvalue');
	       */
	      getParam: function (name, defaultVal, type) {
	        var value = name in this.settings ? this.settings[name] : defaultVal, output;
	
	        if (type === 'hash') {
	          output = {};
	
	          if (typeof value === 'string') {
	            each(value.indexOf('=') > 0 ? value.split(/[;,](?![^=;,]*(?:[;,]|$))/) : value.split(','), function (value) {
	              value = value.split('=');
	
	              if (value.length > 1) {
	                output[trim(value[0])] = trim(value[1]);
	              } else {
	                output[trim(value[0])] = trim(value);
	              }
	            });
	          } else {
	            output = value;
	          }
	
	          return output;
	        }
	
	        return value;
	      },
	
	      /**
	       * Dispatches out a onNodeChange event to all observers. This method should be called when you
	       * need to update the UI states or element path etc.
	       *
	       * @method nodeChanged
	       * @param {Object} args Optional args to pass to NodeChange event handlers.
	       */
	      nodeChanged: function (args) {
	        this._nodeChangeDispatcher.nodeChanged(args);
	      },
	
	      /**
	       * Adds a button that later gets created by the theme in the editors toolbars.
	       *
	       * @method addButton
	       * @param {String} name Button name to add.
	       * @param {Object} settings Settings object with title, cmd etc.
	       * @example
	       * // Adds a custom button to the editor that inserts contents when clicked
	       * tinymce.init({
	       *    ...
	       *
	       *    toolbar: 'example'
	       *
	       *    setup: function(ed) {
	       *       ed.addButton('example', {
	       *          title: 'My title',
	       *          image: '../js/tinymce/plugins/example/img/example.gif',
	       *          onclick: function() {
	       *             ed.insertContent('Hello world!!');
	       *          }
	       *       });
	       *    }
	       * });
	       */
	      addButton: function (name, settings) {
	        var self = this;
	
	        if (settings.cmd) {
	          settings.onclick = function () {
	            self.execCommand(settings.cmd);
	          };
	        }
	
	        if (settings.stateSelector && typeof settings.active === 'undefined') {
	          settings.active = false;
	        }
	
	        if (!settings.text && !settings.icon) {
	          settings.icon = name;
	        }
	
	        self.buttons = self.buttons;
	        settings.tooltip = settings.tooltip || settings.title;
	        self.buttons[name] = settings;
	      },
	
	      /**
	       * Adds a sidebar for the editor instance.
	       *
	       * @method addSidebar
	       * @param {String} name Sidebar name to add.
	       * @param {Object} settings Settings object with icon, onshow etc.
	       * @example
	       * // Adds a custom sidebar that when clicked logs the panel element
	       * tinymce.init({
	       *    ...
	       *    setup: function(ed) {
	       *       ed.addSidebar('example', {
	       *          tooltip: 'My sidebar',
	       *          icon: 'my-side-bar',
	       *          onshow: function(api) {
	       *             console.log(api.element());
	       *          }
	       *       });
	       *    }
	       * });
	       */
	      addSidebar: function (name, settings) {
	        return Sidebar.add(this, name, settings);
	      },
	
	      /**
	       * Adds a menu item to be used in the menus of the theme. There might be multiple instances
	       * of this menu item for example it might be used in the main menus of the theme but also in
	       * the context menu so make sure that it's self contained and supports multiple instances.
	       *
	       * @method addMenuItem
	       * @param {String} name Menu item name to add.
	       * @param {Object} settings Settings object with title, cmd etc.
	       * @example
	       * // Adds a custom menu item to the editor that inserts contents when clicked
	       * // The context option allows you to add the menu item to an existing default menu
	       * tinymce.init({
	       *    ...
	       *
	       *    setup: function(ed) {
	       *       ed.addMenuItem('example', {
	       *          text: 'My menu item',
	       *          context: 'tools',
	       *          onclick: function() {
	       *             ed.insertContent('Hello world!!');
	       *          }
	       *       });
	       *    }
	       * });
	       */
	      addMenuItem: function (name, settings) {
	        var self = this;
	
	        if (settings.cmd) {
	          settings.onclick = function () {
	            self.execCommand(settings.cmd);
	          };
	        }
	
	        self.menuItems = self.menuItems;
	        self.menuItems[name] = settings;
	      },
	
	      /**
	       * Adds a contextual toolbar to be rendered when the selector matches.
	       *
	       * @method addContextToolbar
	       * @param {function/string} predicate Predicate that needs to return true if provided strings get converted into CSS predicates.
	       * @param {String/Array} items String or array with items to add to the context toolbar.
	       */
	      addContextToolbar: function (predicate, items) {
	        var self = this, selector;
	
	        self.contextToolbars = self.contextToolbars || [];
	
	        // Convert selector to predicate
	        if (typeof predicate == "string") {
	          selector = predicate;
	          predicate = function (elm) {
	            return self.dom.is(elm, selector);
	          };
	        }
	
	        self.contextToolbars.push({
	          id: Uuid.uuid('mcet'),
	          predicate: predicate,
	          items: items
	        });
	      },
	
	      /**
	       * Adds a custom command to the editor, you can also override existing commands with this method.
	       * The command that you add can be executed with execCommand.
	       *
	       * @method addCommand
	       * @param {String} name Command name to add/override.
	       * @param {addCommandCallback} callback Function to execute when the command occurs.
	       * @param {Object} scope Optional scope to execute the function in.
	       * @example
	       * // Adds a custom command that later can be executed using execCommand
	       * tinymce.init({
	       *    ...
	       *
	       *    setup: function(ed) {
	       *       // Register example command
	       *       ed.addCommand('mycommand', function(ui, v) {
	       *          ed.windowManager.alert('Hello world!! Selection: ' + ed.selection.getContent({format: 'text'}));
	       *       });
	       *    }
	       * });
	       */
	      addCommand: function (name, callback, scope) {
	        /**
	         * Callback function that gets called when a command is executed.
	         *
	         * @callback addCommandCallback
	         * @param {Boolean} ui Display UI state true/false.
	         * @param {Object} value Optional value for command.
	         * @return {Boolean} True/false state if the command was handled or not.
	         */
	        this.editorCommands.addCommand(name, callback, scope);
	      },
	
	      /**
	       * Adds a custom query state command to the editor, you can also override existing commands with this method.
	       * The command that you add can be executed with queryCommandState function.
	       *
	       * @method addQueryStateHandler
	       * @param {String} name Command name to add/override.
	       * @param {addQueryStateHandlerCallback} callback Function to execute when the command state retrieval occurs.
	       * @param {Object} scope Optional scope to execute the function in.
	       */
	      addQueryStateHandler: function (name, callback, scope) {
	        /**
	         * Callback function that gets called when a queryCommandState is executed.
	         *
	         * @callback addQueryStateHandlerCallback
	         * @return {Boolean} True/false state if the command is enabled or not like is it bold.
	         */
	        this.editorCommands.addQueryStateHandler(name, callback, scope);
	      },
	
	      /**
	       * Adds a custom query value command to the editor, you can also override existing commands with this method.
	       * The command that you add can be executed with queryCommandValue function.
	       *
	       * @method addQueryValueHandler
	       * @param {String} name Command name to add/override.
	       * @param {addQueryValueHandlerCallback} callback Function to execute when the command value retrieval occurs.
	       * @param {Object} scope Optional scope to execute the function in.
	       */
	      addQueryValueHandler: function (name, callback, scope) {
	        /**
	         * Callback function that gets called when a queryCommandValue is executed.
	         *
	         * @callback addQueryValueHandlerCallback
	         * @return {Object} Value of the command or undefined.
	         */
	        this.editorCommands.addQueryValueHandler(name, callback, scope);
	      },
	
	      /**
	       * Adds a keyboard shortcut for some command or function.
	       *
	       * @method addShortcut
	       * @param {String} pattern Shortcut pattern. Like for example: ctrl+alt+o.
	       * @param {String} desc Text description for the command.
	       * @param {String/Function} cmdFunc Command name string or function to execute when the key is pressed.
	       * @param {Object} sc Optional scope to execute the function in.
	       * @return {Boolean} true/false state if the shortcut was added or not.
	       */
	      addShortcut: function (pattern, desc, cmdFunc, scope) {
	        this.shortcuts.add(pattern, desc, cmdFunc, scope);
	      },
	
	      /**
	       * Executes a command on the current instance. These commands can be TinyMCE internal commands prefixed with "mce" or
	       * they can be build in browser commands such as "Bold". A compleate list of browser commands is available on MSDN or Mozilla.org.
	       * This function will dispatch the execCommand function on each plugin, theme or the execcommand_callback option if none of these
	       * return true it will handle the command as a internal browser command.
	       *
	       * @method execCommand
	       * @param {String} cmd Command name to execute, for example mceLink or Bold.
	       * @param {Boolean} ui True/false state if a UI (dialog) should be presented or not.
	       * @param {mixed} value Optional command value, this can be anything.
	       * @param {Object} args Optional arguments object.
	       */
	      execCommand: function (cmd, ui, value, args) {
	        return this.editorCommands.execCommand(cmd, ui, value, args);
	      },
	
	      /**
	       * Returns a command specific state, for example if bold is enabled or not.
	       *
	       * @method queryCommandState
	       * @param {string} cmd Command to query state from.
	       * @return {Boolean} Command specific state, for example if bold is enabled or not.
	       */
	      queryCommandState: function (cmd) {
	        return this.editorCommands.queryCommandState(cmd);
	      },
	
	      /**
	       * Returns a command specific value, for example the current font size.
	       *
	       * @method queryCommandValue
	       * @param {string} cmd Command to query value from.
	       * @return {Object} Command specific value, for example the current font size.
	       */
	      queryCommandValue: function (cmd) {
	        return this.editorCommands.queryCommandValue(cmd);
	      },
	
	      /**
	       * Returns true/false if the command is supported or not.
	       *
	       * @method queryCommandSupported
	       * @param {String} cmd Command that we check support for.
	       * @return {Boolean} true/false if the command is supported or not.
	       */
	      queryCommandSupported: function (cmd) {
	        return this.editorCommands.queryCommandSupported(cmd);
	      },
	
	      /**
	       * Shows the editor and hides any textarea/div that the editor is supposed to replace.
	       *
	       * @method show
	       */
	      show: function () {
	        var self = this;
	
	        if (self.hidden) {
	          self.hidden = false;
	
	          if (self.inline) {
	            self.getBody().contentEditable = true;
	          } else {
	            DOM.show(self.getContainer());
	            DOM.hide(self.id);
	          }
	
	          self.load();
	          self.fire('show');
	        }
	      },
	
	      /**
	       * Hides the editor and shows any textarea/div that the editor is supposed to replace.
	       *
	       * @method hide
	       */
	      hide: function () {
	        var self = this, doc = self.getDoc();
	
	        if (!self.hidden) {
	          // Fixed bug where IE has a blinking cursor left from the editor
	          if (ie && doc && !self.inline) {
	            doc.execCommand('SelectAll');
	          }
	
	          // We must save before we hide so Safari doesn't crash
	          self.save();
	
	          if (self.inline) {
	            self.getBody().contentEditable = false;
	
	            // Make sure the editor gets blurred
	            if (self == self.editorManager.focusedEditor) {
	              self.editorManager.focusedEditor = null;
	            }
	          } else {
	            DOM.hide(self.getContainer());
	            DOM.setStyle(self.id, 'display', self.orgDisplay);
	          }
	
	          self.hidden = true;
	          self.fire('hide');
	        }
	      },
	
	      /**
	       * Returns true/false if the editor is hidden or not.
	       *
	       * @method isHidden
	       * @return {Boolean} True/false if the editor is hidden or not.
	       */
	      isHidden: function () {
	        return !!this.hidden;
	      },
	
	      /**
	       * Sets the progress state, this will display a throbber/progess for the editor.
	       * This is ideal for asynchronous operations like an AJAX save call.
	       *
	       * @method setProgressState
	       * @param {Boolean} state Boolean state if the progress should be shown or hidden.
	       * @param {Number} time Optional time to wait before the progress gets shown.
	       * @return {Boolean} Same as the input state.
	       * @example
	       * // Show progress for the active editor
	       * tinymce.activeEditor.setProgressState(true);
	       *
	       * // Hide progress for the active editor
	       * tinymce.activeEditor.setProgressState(false);
	       *
	       * // Show progress after 3 seconds
	       * tinymce.activeEditor.setProgressState(true, 3000);
	       */
	      setProgressState: function (state, time) {
	        this.fire('ProgressState', { state: state, time: time });
	      },
	
	      /**
	       * Loads contents from the textarea or div element that got converted into an editor instance.
	       * This method will move the contents from that textarea or div into the editor by using setContent
	       * so all events etc that method has will get dispatched as well.
	       *
	       * @method load
	       * @param {Object} args Optional content object, this gets passed around through the whole load process.
	       * @return {String} HTML string that got set into the editor.
	       */
	      load: function (args) {
	        var self = this, elm = self.getElement(), html;
	
	        if (self.removed) {
	          return '';
	        }
	
	        if (elm) {
	          args = args || {};
	          args.load = true;
	
	          html = self.setContent(elm.value !== undefined ? elm.value : elm.innerHTML, args);
	          args.element = elm;
	
	          if (!args.no_events) {
	            self.fire('LoadContent', args);
	          }
	
	          args.element = elm = null;
	
	          return html;
	        }
	      },
	
	      /**
	       * Saves the contents from a editor out to the textarea or div element that got converted into an editor instance.
	       * This method will move the HTML contents from the editor into that textarea or div by getContent
	       * so all events etc that method has will get dispatched as well.
	       *
	       * @method save
	       * @param {Object} args Optional content object, this gets passed around through the whole save process.
	       * @return {String} HTML string that got set into the textarea/div.
	       */
	      save: function (args) {
	        var self = this, elm = self.getElement(), html, form;
	
	        if (!elm || !self.initialized || self.removed) {
	          return;
	        }
	
	        args = args || {};
	        args.save = true;
	
	        args.element = elm;
	        html = args.content = self.getContent(args);
	
	        if (!args.no_events) {
	          self.fire('SaveContent', args);
	        }
	
	        // Always run this internal event
	        if (args.format == 'raw') {
	          self.fire('RawSaveContent', args);
	        }
	
	        html = args.content;
	
	        if (!/TEXTAREA|INPUT/i.test(elm.nodeName)) {
	          // Update DIV element when not in inline mode
	          if (!self.inline) {
	            elm.innerHTML = html;
	          }
	
	          // Update hidden form element
	          if ((form = DOM.getParent(self.id, 'form'))) {
	            each(form.elements, function (elm) {
	              if (elm.name == self.id) {
	                elm.value = html;
	                return false;
	              }
	            });
	          }
	        } else {
	          elm.value = html;
	        }
	
	        args.element = elm = null;
	
	        if (args.set_dirty !== false) {
	          self.setDirty(false);
	        }
	
	        return html;
	      },
	
	      /**
	       * Sets the specified content to the editor instance, this will cleanup the content before it gets set using
	       * the different cleanup rules options.
	       *
	       * @method setContent
	       * @param {String} content Content to set to editor, normally HTML contents but can be other formats as well.
	       * @param {Object} args Optional content object, this gets passed around through the whole set process.
	       * @return {String} HTML string that got set into the editor.
	       * @example
	       * // Sets the HTML contents of the activeEditor editor
	       * tinymce.activeEditor.setContent('<span>some</span> html');
	       *
	       * // Sets the raw contents of the activeEditor editor
	       * tinymce.activeEditor.setContent('<span>some</span> html', {format: 'raw'});
	       *
	       * // Sets the content of a specific editor (my_editor in this example)
	       * tinymce.get('my_editor').setContent(data);
	       *
	       * // Sets the bbcode contents of the activeEditor editor if the bbcode plugin was added
	       * tinymce.activeEditor.setContent('[b]some[/b] html', {format: 'bbcode'});
	       */
	      setContent: function (content, args) {
	        var self = this, body = self.getBody(), forcedRootBlockName, padd;
	
	        // Setup args object
	        args = args || {};
	        args.format = args.format || 'html';
	        args.set = true;
	        args.content = content;
	
	        // Do preprocessing
	        if (!args.no_events) {
	          self.fire('BeforeSetContent', args);
	        }
	
	        content = args.content;
	
	        // Padd empty content in Gecko and Safari. Commands will otherwise fail on the content
	        // It will also be impossible to place the caret in the editor unless there is a BR element present
	        if (content.length === 0 || /^\s+$/.test(content)) {
	          padd = ie && ie < 11 ? '' : '<br data-mce-bogus="1">';
	
	          // Todo: There is a lot more root elements that need special padding
	          // so separate this and add all of them at some point.
	          if (body.nodeName == 'TABLE') {
	            content = '<tr><td>' + padd + '</td></tr>';
	          } else if (/^(UL|OL)$/.test(body.nodeName)) {
	            content = '<li>' + padd + '</li>';
	          }
	
	          forcedRootBlockName = self.settings.forced_root_block;
	
	          // Check if forcedRootBlock is configured and that the block is a valid child of the body
	          if (forcedRootBlockName && self.schema.isValidChild(body.nodeName.toLowerCase(), forcedRootBlockName.toLowerCase())) {
	            // Padd with bogus BR elements on modern browsers and IE 7 and 8 since they don't render empty P tags properly
	            content = padd;
	            content = self.dom.createHTML(forcedRootBlockName, self.settings.forced_root_block_attrs, content);
	          } else if (!ie && !content) {
	            // We need to add a BR when forced_root_block is disabled on non IE browsers to place the caret
	            content = '<br data-mce-bogus="1">';
	          }
	
	          self.dom.setHTML(body, content);
	
	          self.fire('SetContent', args);
	        } else {
	          // Parse and serialize the html
	          if (args.format !== 'raw') {
	            content = new Serializer({
	              validate: self.validate
	            }, self.schema).serialize(
	              self.parser.parse(content, { isRootContent: true, insert: true })
	            );
	          }
	
	          // Set the new cleaned contents to the editor
	          args.content = trim(content);
	          self.dom.setHTML(body, args.content);
	
	          // Do post processing
	          if (!args.no_events) {
	            self.fire('SetContent', args);
	          }
	
	          // Don't normalize selection if the focused element isn't the body in
	          // content editable mode since it will steal focus otherwise
	          /*if (!self.settings.content_editable || document.activeElement === self.getBody()) {
	            self.selection.normalize();
	          }*/
	        }
	
	        return args.content;
	      },
	
	      /**
	       * Gets the content from the editor instance, this will cleanup the content before it gets returned using
	       * the different cleanup rules options.
	       *
	       * @method getContent
	       * @param {Object} args Optional content object, this gets passed around through the whole get process.
	       * @return {String} Cleaned content string, normally HTML contents.
	       * @example
	       * // Get the HTML contents of the currently active editor
	       * console.debug(tinymce.activeEditor.getContent());
	       *
	       * // Get the raw contents of the currently active editor
	       * tinymce.activeEditor.getContent({format: 'raw'});
	       *
	       * // Get content of a specific editor:
	       * tinymce.get('content id').getContent()
	       */
	      getContent: function (args) {
	        var self = this, content, body = self.getBody();
	
	        if (self.removed) {
	          return '';
	        }
	
	        // Setup args object
	        args = args || {};
	        args.format = args.format || 'html';
	        args.get = true;
	        args.getInner = true;
	
	        // Do preprocessing
	        if (!args.no_events) {
	          self.fire('BeforeGetContent', args);
	        }
	
	        // Get raw contents or by default the cleaned contents
	        if (args.format === 'raw') {
	          content = Tools.trim(TrimHtml.trimExternal(self.serializer, body.innerHTML));
	        } else if (args.format === 'text') {
	          content = body.innerText || body.textContent;
	        } else if (args.format === 'tree') {
	          return self.serializer.serialize(body, args);
	        } else {
	          content = self.serializer.serialize(body, args);
	        }
	
	        // Trim whitespace in beginning/end of HTML
	        if (args.format !== 'text') {
	          args.content = trim(content);
	        } else {
	          args.content = content;
	        }
	
	        // Do post processing
	        if (!args.no_events) {
	          self.fire('GetContent', args);
	        }
	
	        return args.content;
	      },
	
	      /**
	       * Inserts content at caret position.
	       *
	       * @method insertContent
	       * @param {String} content Content to insert.
	       * @param {Object} args Optional args to pass to insert call.
	       */
	      insertContent: function (content, args) {
	        if (args) {
	          content = extend({ content: content }, args);
	        }
	
	        this.execCommand('mceInsertContent', false, content);
	      },
	
	      /**
	       * Returns true/false if the editor is dirty or not. It will get dirty if the user has made modifications to the contents.
	       *
	       * The dirty state is automatically set to true if you do modifications to the content in other
	       * words when new undo levels is created or if you undo/redo to update the contents of the editor. It will also be set
	       * to false if you call editor.save().
	       *
	       * @method isDirty
	       * @return {Boolean} True/false if the editor is dirty or not. It will get dirty if the user has made modifications to the contents.
	       * @example
	       * if (tinymce.activeEditor.isDirty())
	       *     alert("You must save your contents.");
	       */
	      isDirty: function () {
	        return !this.isNotDirty;
	      },
	
	      /**
	       * Explicitly sets the dirty state. This will fire the dirty event if the editor dirty state is changed from false to true
	       * by invoking this method.
	       *
	       * @method setDirty
	       * @param {Boolean} state True/false if the editor is considered dirty.
	       * @example
	       * function ajaxSave() {
	       *     var editor = tinymce.get('elm1');
	       *
	       *     // Save contents using some XHR call
	       *     alert(editor.getContent());
	       *
	       *     editor.setDirty(false); // Force not dirty state
	       * }
	       */
	      setDirty: function (state) {
	        var oldState = !this.isNotDirty;
	
	        this.isNotDirty = !state;
	
	        if (state && state != oldState) {
	          this.fire('dirty');
	        }
	      },
	
	      /**
	       * Sets the editor mode. Mode can be for example "design", "code" or "readonly".
	       *
	       * @method setMode
	       * @param {String} mode Mode to set the editor in.
	       */
	      setMode: function (mode) {
	        Mode.setMode(this, mode);
	      },
	
	      /**
	       * Returns the editors container element. The container element wrappes in
	       * all the elements added to the page for the editor. Such as UI, iframe etc.
	       *
	       * @method getContainer
	       * @return {Element} HTML DOM element for the editor container.
	       */
	      getContainer: function () {
	        var self = this;
	
	        if (!self.container) {
	          self.container = DOM.get(self.editorContainer || self.id + '_parent');
	        }
	
	        return self.container;
	      },
	
	      /**
	       * Returns the editors content area container element. The this element is the one who
	       * holds the iframe or the editable element.
	       *
	       * @method getContentAreaContainer
	       * @return {Element} HTML DOM element for the editor area container.
	       */
	      getContentAreaContainer: function () {
	        return this.contentAreaContainer;
	      },
	
	      /**
	       * Returns the target element/textarea that got replaced with a TinyMCE editor instance.
	       *
	       * @method getElement
	       * @return {Element} HTML DOM element for the replaced element.
	       */
	      getElement: function () {
	        if (!this.targetElm) {
	          this.targetElm = DOM.get(this.id);
	        }
	
	        return this.targetElm;
	      },
	
	      /**
	       * Returns the iframes window object.
	       *
	       * @method getWin
	       * @return {Window} Iframe DOM window object.
	       */
	      getWin: function () {
	        var self = this, elm;
	
	        if (!self.contentWindow) {
	          elm = self.iframeElement;
	
	          if (elm) {
	            self.contentWindow = elm.contentWindow;
	          }
	        }
	
	        return self.contentWindow;
	      },
	
	      /**
	       * Returns the iframes document object.
	       *
	       * @method getDoc
	       * @return {Document} Iframe DOM document object.
	       */
	      getDoc: function () {
	        var self = this, win;
	
	        if (!self.contentDocument) {
	          win = self.getWin();
	
	          if (win) {
	            self.contentDocument = win.document;
	          }
	        }
	
	        return self.contentDocument;
	      },
	
	      /**
	       * Returns the root element of the editable area.
	       * For a non-inline iframe-based editor, returns the iframe's body element.
	       *
	       * @method getBody
	       * @return {Element} The root element of the editable area.
	       */
	      getBody: function () {
	        var doc = this.getDoc();
	        return this.bodyElement || (doc ? doc.body : null);
	      },
	
	      /**
	       * URL converter function this gets executed each time a user adds an img, a or
	       * any other element that has a URL in it. This will be called both by the DOM and HTML
	       * manipulation functions.
	       *
	       * @method convertURL
	       * @param {string} url URL to convert.
	       * @param {string} name Attribute name src, href etc.
	       * @param {string/HTMLElement} elm Tag name or HTML DOM element depending on HTML or DOM insert.
	       * @return {string} Converted URL string.
	       */
	      convertURL: function (url, name, elm) {
	        var self = this, settings = self.settings;
	
	        // Use callback instead
	        if (settings.urlconverter_callback) {
	          return self.execCallback('urlconverter_callback', url, elm, true, name);
	        }
	
	        // Don't convert link href since thats the CSS files that gets loaded into the editor also skip local file URLs
	        if (!settings.convert_urls || (elm && elm.nodeName == 'LINK') || url.indexOf('file:') === 0 || url.length === 0) {
	          return url;
	        }
	
	        // Convert to relative
	        if (settings.relative_urls) {
	          return self.documentBaseURI.toRelative(url);
	        }
	
	        // Convert to absolute
	        url = self.documentBaseURI.toAbsolute(url, settings.remove_script_host);
	
	        return url;
	      },
	
	      /**
	       * Adds visual aid for tables, anchors etc so they can be more easily edited inside the editor.
	       *
	       * @method addVisual
	       * @param {Element} elm Optional root element to loop though to find tables etc that needs the visual aid.
	       */
	      addVisual: function (elm) {
	        var self = this, settings = self.settings, dom = self.dom, cls;
	
	        elm = elm || self.getBody();
	
	        if (self.hasVisual === undefined) {
	          self.hasVisual = settings.visual;
	        }
	
	        each(dom.select('table,a', elm), function (elm) {
	          var value;
	
	          switch (elm.nodeName) {
	            case 'TABLE':
	              cls = settings.visual_table_class || 'mce-item-table';
	              value = dom.getAttrib(elm, 'border');
	
	              if ((!value || value == '0') && self.hasVisual) {
	                dom.addClass(elm, cls);
	              } else {
	                dom.removeClass(elm, cls);
	              }
	
	              return;
	
	            case 'A':
	              if (!dom.getAttrib(elm, 'href', false)) {
	                value = dom.getAttrib(elm, 'name') || elm.id;
	                cls = settings.visual_anchor_class || 'mce-item-anchor';
	
	                if (value && self.hasVisual) {
	                  dom.addClass(elm, cls);
	                } else {
	                  dom.removeClass(elm, cls);
	                }
	              }
	
	              return;
	          }
	        });
	
	        self.fire('VisualAid', { element: elm, hasVisual: self.hasVisual });
	      },
	
	      /**
	       * Removes the editor from the dom and tinymce collection.
	       *
	       * @method remove
	       */
	      remove: function () {
	        var self = this;
	
	        if (!self.removed) {
	          self.save();
	          self.removed = 1;
	          self.unbindAllNativeEvents();
	
	          // Remove any hidden input
	          if (self.hasHiddenInput) {
	            DOM.remove(self.getElement().nextSibling);
	          }
	
	          if (!self.inline) {
	            // IE 9 has a bug where the selection stops working if you place the
	            // caret inside the editor then remove the iframe
	            if (ie && ie < 10) {
	              self.getDoc().execCommand('SelectAll', false, null);
	            }
	
	            DOM.setStyle(self.id, 'display', self.orgDisplay);
	            self.getBody().onload = null; // Prevent #6816
	          }
	
	          self.fire('remove');
	
	          self.editorManager.remove(self);
	          DOM.remove(self.getContainer());
	          self._selectionOverrides.destroy();
	          self.editorUpload.destroy();
	          self.destroy();
	        }
	      },
	
	      /**
	       * Destroys the editor instance by removing all events, element references or other resources
	       * that could leak memory. This method will be called automatically when the page is unloaded
	       * but you can also call it directly if you know what you are doing.
	       *
	       * @method destroy
	       * @param {Boolean} automatic Optional state if the destroy is an automatic destroy or user called one.
	       */
	      destroy: function (automatic) {
	        var self = this, form;
	
	        // One time is enough
	        if (self.destroyed) {
	          return;
	        }
	
	        // If user manually calls destroy and not remove
	        // Users seems to have logic that calls destroy instead of remove
	        if (!automatic && !self.removed) {
	          self.remove();
	          return;
	        }
	
	        if (!automatic) {
	          self.editorManager.off('beforeunload', self._beforeUnload);
	
	          // Manual destroy
	          if (self.theme && self.theme.destroy) {
	            self.theme.destroy();
	          }
	
	          // Destroy controls, selection and dom
	          self.selection.destroy();
	          self.dom.destroy();
	        }
	
	        form = self.formElement;
	        if (form) {
	          if (form._mceOldSubmit) {
	            form.submit = form._mceOldSubmit;
	            form._mceOldSubmit = null;
	          }
	
	          DOM.unbind(form, 'submit reset', self.formEventDelegate);
	        }
	
	        self.contentAreaContainer = self.formElement = self.container = self.editorContainer = null;
	        self.bodyElement = self.contentDocument = self.contentWindow = null;
	        self.iframeElement = self.targetElm = null;
	
	        if (self.selection) {
	          self.selection = self.selection.win = self.selection.dom = self.selection.dom.doc = null;
	        }
	
	        self.destroyed = 1;
	      },
	
	      /**
	       * Uploads all data uri/blob uri images in the editor contents to server.
	       *
	       * @method uploadImages
	       * @param {function} callback Optional callback with images and status for each image.
	       * @return {tinymce.util.Promise} Promise instance.
	       */
	      uploadImages: function (callback) {
	        return this.editorUpload.uploadImages(callback);
	      },
	
	      // Internal functions
	
	      _scanForImages: function () {
	        return this.editorUpload.scanForImages();
	      }
	    };
	
	    extend(Editor.prototype, EditorObservable);
	
	    return Editor;
	  }
	);
	
	/**
	 * FocusManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class manages the focus/blur state of the editor. This class is needed since some
	 * browsers fire false focus/blur states when the selection is moved to a UI dialog or similar.
	 *
	 * This class will fire two events focus and blur on the editor instances that got affected.
	 * It will also handle the restore of selection when the focus is lost and returned.
	 *
	 * @class tinymce.FocusManager
	 */
	define(
	  'tinymce.core.api.FocusManager',
	  [
	    'global!document'
	  ],
	  function (document) {
	    /**
	     * Returns true if the specified element is part of the UI for example an button or text input.
	     *
	     * @static
	     * @method isEditorUIElement
	     * @param  {Element} elm Element to check if it's part of the UI or not.
	     * @return {Boolean} True/false state if the element is part of the UI or not.
	     */
	    var isEditorUIElement = function (elm) {
	      // Needs to be converted to string since svg can have focus: #6776
	      return elm.className.toString().indexOf('mce-') !== -1;
	    };
	
	    return {
	      isEditorUIElement: isEditorUIElement
	    };
	  }
	);
	
	/**
	 * SelectionRestore.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.selection.SelectionRestore',
	  [
	    'ephox.katamari.api.Throttler',
	    'ephox.sand.api.PlatformDetection',
	    'global!document',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.selection.SelectionBookmark'
	  ],
	  function (Throttler, PlatformDetection, document, DOMUtils, SelectionBookmark) {
	    var isManualNodeChange = function (e) {
	      return e.type === 'nodechange' && e.selectionChange;
	    };
	
	    var registerPageMouseUp = function (editor, throttledStore) {
	      var mouseUpPage = function () {
	        throttledStore.throttle();
	      };
	
	      DOMUtils.DOM.bind(document, 'mouseup', mouseUpPage);
	
	      editor.on('remove', function () {
	        DOMUtils.DOM.unbind(document, 'mouseup', mouseUpPage);
	      });
	    };
	
	    var registerFocusOut = function (editor) {
	      editor.on('focusout', function () {
	        SelectionBookmark.store(editor);
	      });
	    };
	
	    var registerMouseUp = function (editor, throttledStore) {
	      editor.on('mouseup touchend', function (e) {
	        throttledStore.throttle();
	      });
	    };
	
	    var registerEditorEvents = function (editor, throttledStore) {
	      var browser = PlatformDetection.detect().browser;
	
	      if (browser.isIE() || browser.isEdge()) {
	        registerFocusOut(editor);
	      } else {
	        registerMouseUp(editor, throttledStore);
	      }
	
	      editor.on('keyup nodechange', function (e) {
	        if (!isManualNodeChange(e)) {
	          SelectionBookmark.store(editor);
	        }
	      });
	    };
	
	    var register = function (editor) {
	      var throttledStore = Throttler.first(function () {
	        SelectionBookmark.store(editor);
	      }, 0);
	
	      if (editor.inline) {
	        registerPageMouseUp(editor, throttledStore);
	      }
	
	      editor.on('init', function () {
	        registerEditorEvents(editor, throttledStore);
	      });
	
	      editor.on('remove', function () {
	        throttledStore.cancel();
	      });
	    };
	
	    return {
	      register: register
	    };
	  }
	);
	
	/**
	 * FocusController.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.focus.FocusController',
	  [
	    'ephox.katamari.api.Fun',
	    'global!document',
	    'tinymce.core.api.FocusManager',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.selection.SelectionRestore',
	    'tinymce.core.util.Delay'
	  ],
	  function (Fun, document, FocusManager, DOMUtils, SelectionRestore, Delay) {
	    var documentFocusInHandler, DOM = DOMUtils.DOM;
	
	    var isEditorUIElement = function (elm) {
	      // Since this can be overridden by third party we need to use the API reference here
	      return FocusManager.isEditorUIElement(elm);
	    };
	
	    var isUIElement = function (editor, elm) {
	      var customSelector = editor ? editor.settings.custom_ui_selector : '';
	      var parent = DOM.getParent(elm, function (elm) {
	        return (
	          isEditorUIElement(elm) ||
	          (customSelector ? editor.dom.is(elm, customSelector) : false)
	        );
	      });
	      return parent !== null;
	    };
	
	    var getActiveElement = function () {
	      try {
	        return document.activeElement;
	      } catch (ex) {
	        // IE sometimes fails to get the activeElement when resizing table
	        // TODO: Investigate this
	        return document.body;
	      }
	    };
	
	    var registerEvents = function (editorManager, e) {
	      var editor = e.editor;
	
	      SelectionRestore.register(editor);
	
	      editor.on('focusin', function () {
	        var focusedEditor = editorManager.focusedEditor;
	
	        if (focusedEditor != editor) {
	          if (focusedEditor) {
	            focusedEditor.fire('blur', { focusedEditor: editor });
	          }
	
	          editorManager.setActive(editor);
	          editorManager.focusedEditor = editor;
	          editor.fire('focus', { blurredEditor: focusedEditor });
	          editor.focus(true);
	        }
	      });
	
	      editor.on('focusout', function () {
	        Delay.setEditorTimeout(editor, function () {
	          var focusedEditor = editorManager.focusedEditor;
	
	          // Still the same editor the blur was outside any editor UI
	          if (!isUIElement(editor, getActiveElement()) && focusedEditor == editor) {
	            editor.fire('blur', { focusedEditor: null });
	            editorManager.focusedEditor = null;
	          }
	        });
	      });
	
	      // Check if focus is moved to an element outside the active editor by checking if the target node
	      // isn't within the body of the activeEditor nor a UI element such as a dialog child control
	      if (!documentFocusInHandler) {
	        documentFocusInHandler = function (e) {
	          var activeEditor = editorManager.activeEditor, target;
	
	          target = e.target;
	
	          if (activeEditor && target.ownerDocument === document) {
	            // Fire a blur event if the element isn't a UI element
	            if (target !== document.body && !isUIElement(activeEditor, target) && editorManager.focusedEditor === activeEditor) {
	              activeEditor.fire('blur', { focusedEditor: null });
	              editorManager.focusedEditor = null;
	            }
	          }
	        };
	
	        DOM.bind(document, 'focusin', documentFocusInHandler);
	      }
	    };
	
	    var unregisterDocumentEvents = function (editorManager, e) {
	      if (editorManager.focusedEditor == e.editor) {
	        editorManager.focusedEditor = null;
	      }
	
	      if (!editorManager.activeEditor) {
	        DOM.unbind(document, 'focusin', documentFocusInHandler);
	        documentFocusInHandler = null;
	      }
	    };
	
	    var setup = function (editorManager) {
	      editorManager.on('AddEditor', Fun.curry(registerEvents, editorManager));
	      editorManager.on('RemoveEditor', Fun.curry(unregisterDocumentEvents, editorManager));
	    };
	
	    return {
	      setup: setup,
	      isEditorUIElement: isEditorUIElement,
	      isUIElement: isUIElement
	    };
	  }
	);
	
	/**
	 * I18n.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * I18n class that handles translation of TinyMCE UI.
	 * Uses po style with csharp style parameters.
	 *
	 * @class tinymce.util.I18n
	 */
	define(
	  'tinymce.core.util.I18n',
	  [
	    "tinymce.core.util.Tools"
	  ],
	  function (Tools) {
	    "use strict";
	
	    var data = {}, code = "en";
	
	    return {
	      /**
	       * Sets the current language code.
	       *
	       * @method setCode
	       * @param {String} newCode Current language code.
	       */
	      setCode: function (newCode) {
	        if (newCode) {
	          code = newCode;
	          this.rtl = this.data[newCode] ? this.data[newCode]._dir === 'rtl' : false;
	        }
	      },
	
	      /**
	       * Returns the current language code.
	       *
	       * @method getCode
	       * @return {String} Current language code.
	       */
	      getCode: function () {
	        return code;
	      },
	
	      /**
	       * Property gets set to true if a RTL language pack was loaded.
	       *
	       * @property rtl
	       * @type Boolean
	       */
	      rtl: false,
	
	      /**
	       * Adds translations for a specific language code.
	       *
	       * @method add
	       * @param {String} code Language code like sv_SE.
	       * @param {Array} items Name/value array with English en_US to sv_SE.
	       */
	      add: function (code, items) {
	        var langData = data[code];
	
	        if (!langData) {
	          data[code] = langData = {};
	        }
	
	        for (var name in items) {
	          langData[name] = items[name];
	        }
	
	        this.setCode(code);
	      },
	
	      /**
	       * Translates the specified text.
	       *
	       * It has a few formats:
	       * I18n.translate("Text");
	       * I18n.translate(["Text {0}/{1}", 0, 1]);
	       * I18n.translate({raw: "Raw string"});
	       *
	       * @method translate
	       * @param {String/Object/Array} text Text to translate.
	       * @return {String} String that got translated.
	       */
	      translate: function (text) {
	        var langData = data[code] || {};
	
	        /**
	         * number - string
	         * null, undefined and empty string - empty string
	         * array - comma-delimited string
	         * object - in [object Object]
	         * function - in [object Function]
	         *
	         * @param obj
	         * @returns {string}
	         */
	        var toString = function (obj) {
	          if (Tools.is(obj, 'function')) {
	            return Object.prototype.toString.call(obj);
	          }
	          return !isEmpty(obj) ? '' + obj : '';
	        };
	
	        var isEmpty = function (text) {
	          return text === '' || text === null || Tools.is(text, 'undefined');
	        };
	
	        var getLangData = function (text) {
	          // make sure we work on a string and return a string
	          text = toString(text);
	          return Tools.hasOwn(langData, text) ? toString(langData[text]) : text;
	        };
	
	
	        if (isEmpty(text)) {
	          return '';
	        }
	
	        if (Tools.is(text, 'object') && Tools.hasOwn(text, 'raw')) {
	          return toString(text.raw);
	        }
	
	        if (Tools.is(text, 'array')) {
	          var values = text.slice(1);
	          text = getLangData(text[0]).replace(/\{([0-9]+)\}/g, function ($1, $2) {
	            return Tools.hasOwn(values, $2) ? toString(values[$2]) : $1;
	          });
	        }
	
	        return getLangData(text).replace(/{context:\w+}$/, '');
	      },
	
	      data: data
	    };
	  }
	);
	/**
	 * EditorManager.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class used as a factory for manager for tinymce.Editor instances.
	 *
	 * @example
	 * tinymce.EditorManager.init({});
	 *
	 * @class tinymce.EditorManager
	 * @mixes tinymce.util.Observable
	 * @static
	 */
	define(
	  'tinymce.core.EditorManager',
	  [
	    'ephox.katamari.api.Arr',
	    'ephox.katamari.api.Type',
	    'global!document',
	    'global!window',
	    'tinymce.core.AddOnManager',
	    'tinymce.core.Editor',
	    'tinymce.core.Env',
	    'tinymce.core.ErrorReporter',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.dom.DomQuery',
	    'tinymce.core.focus.FocusController',
	    'tinymce.core.util.I18n',
	    'tinymce.core.util.Observable',
	    'tinymce.core.util.Promise',
	    'tinymce.core.util.Tools',
	    'tinymce.core.util.URI'
	  ],
	  function (Arr, Type, document, window, AddOnManager, Editor, Env, ErrorReporter, DOMUtils, DomQuery, FocusController, I18n, Observable, Promise, Tools, URI) {
	    var DOM = DOMUtils.DOM;
	    var explode = Tools.explode, each = Tools.each, extend = Tools.extend;
	    var instanceCounter = 0, beforeUnloadDelegate, EditorManager, boundGlobalEvents = false;
	    var legacyEditors = [], editors = [];
	
	    var isValidLegacyKey = function (id) {
	      // In theory we could filter out any editor id:s that clash
	      // with array prototype items but that could break existing integrations
	      return id !== 'length';
	    };
	
	    var globalEventDelegate = function (e) {
	      each(EditorManager.get(), function (editor) {
	        if (e.type === 'scroll') {
	          editor.fire('ScrollWindow', e);
	        } else {
	          editor.fire('ResizeWindow', e);
	        }
	      });
	    };
	
	    var toggleGlobalEvents = function (state) {
	      if (state !== boundGlobalEvents) {
	        if (state) {
	          DomQuery(window).on('resize scroll', globalEventDelegate);
	        } else {
	          DomQuery(window).off('resize scroll', globalEventDelegate);
	        }
	
	        boundGlobalEvents = state;
	      }
	    };
	
	    var removeEditorFromList = function (targetEditor) {
	      var oldEditors = editors;
	
	      delete legacyEditors[targetEditor.id];
	      for (var i = 0; i < legacyEditors.length; i++) {
	        if (legacyEditors[i] === targetEditor) {
	          legacyEditors.splice(i, 1);
	          break;
	        }
	      }
	
	      editors = Arr.filter(editors, function (editor) {
	        return targetEditor !== editor;
	      });
	
	      // Select another editor since the active one was removed
	      if (EditorManager.activeEditor === targetEditor) {
	        EditorManager.activeEditor = editors.length > 0 ? editors[0] : null;
	      }
	
	      // Clear focusedEditor if necessary, so that we don't try to blur the destroyed editor
	      if (EditorManager.focusedEditor === targetEditor) {
	        EditorManager.focusedEditor = null;
	      }
	
	      return oldEditors.length !== editors.length;
	    };
	
	    var purgeDestroyedEditor = function (editor) {
	      // User has manually destroyed the editor lets clean up the mess
	      if (editor && editor.initialized && !(editor.getContainer() || editor.getBody()).parentNode) {
	        removeEditorFromList(editor);
	        editor.unbindAllNativeEvents();
	        editor.destroy(true);
	        editor.removed = true;
	        editor = null;
	      }
	
	      return editor;
	    };
	
	    EditorManager = {
	      defaultSettings: {},
	
	      /**
	       * Dom query instance.
	       *
	       * @property $
	       * @type tinymce.dom.DomQuery
	       */
	      $: DomQuery,
	
	      /**
	       * Major version of TinyMCE build.
	       *
	       * @property majorVersion
	       * @type String
	       */
	      majorVersion: '4',
	
	      /**
	       * Minor version of TinyMCE build.
	       *
	       * @property minorVersion
	       * @type String
	       */
	      minorVersion: '7.4',
	
	      /**
	       * Release date of TinyMCE build.
	       *
	       * @property releaseDate
	       * @type String
	       */
	      releaseDate: '2017-12-05',
	
	      /**
	       * Collection of editor instances. Deprecated use tinymce.get() instead.
	       *
	       * @property editors
	       * @type Object
	       */
	      editors: legacyEditors,
	
	      /**
	       * Collection of language pack data.
	       *
	       * @property i18n
	       * @type Object
	       */
	      i18n: I18n,
	
	      /**
	       * Currently active editor instance.
	       *
	       * @property activeEditor
	       * @type tinymce.Editor
	       * @example
	       * tinyMCE.activeEditor.selection.getContent();
	       * tinymce.EditorManager.activeEditor.selection.getContent();
	       */
	      activeEditor: null,
	
	      settings: {},
	
	      setup: function () {
	        var self = this, baseURL, documentBaseURL, suffix = "", preInit, src;
	
	        // Get base URL for the current document
	        documentBaseURL = URI.getDocumentBaseUrl(document.location);
	
	        // Check if the URL is a document based format like: http://site/dir/file and file:///
	        // leave other formats like applewebdata://... intact
	        if (/^[^:]+:\/\/\/?[^\/]+\//.test(documentBaseURL)) {
	          documentBaseURL = documentBaseURL.replace(/[\?#].*$/, '').replace(/[\/\\][^\/]+$/, '');
	
	          if (!/[\/\\]$/.test(documentBaseURL)) {
	            documentBaseURL += '/';
	          }
	        }
	
	        // If tinymce is defined and has a base use that or use the old tinyMCEPreInit
	        preInit = window.tinymce || window.tinyMCEPreInit;
	        if (preInit) {
	          baseURL = preInit.base || preInit.baseURL;
	          suffix = preInit.suffix;
	        } else {
	          // Get base where the tinymce script is located
	          var scripts = document.getElementsByTagName('script');
	          for (var i = 0; i < scripts.length; i++) {
	            src = scripts[i].src;
	
	            // Script types supported:
	            // tinymce.js tinymce.min.js tinymce.dev.js
	            // tinymce.jquery.js tinymce.jquery.min.js tinymce.jquery.dev.js
	            // tinymce.full.js tinymce.full.min.js tinymce.full.dev.js
	            var srcScript = src.substring(src.lastIndexOf('/'));
	            if (/tinymce(\.full|\.jquery|)(\.min|\.dev|)\.js/.test(src)) {
	              if (srcScript.indexOf('.min') != -1) {
	                suffix = '.min';
	              }
	
	              baseURL = src.substring(0, src.lastIndexOf('/'));
	              break;
	            }
	          }
	
	          // We didn't find any baseURL by looking at the script elements
	          // Try to use the document.currentScript as a fallback
	          if (!baseURL && document.currentScript) {
	            src = document.currentScript.src;
	
	            if (src.indexOf('.min') != -1) {
	              suffix = '.min';
	            }
	
	            baseURL = src.substring(0, src.lastIndexOf('/'));
	          }
	        }
	
	        /**
	         * Base URL where the root directory if TinyMCE is located.
	         *
	         * @property baseURL
	         * @type String
	         */
	        self.baseURL = new URI(documentBaseURL).toAbsolute(baseURL);
	
	        /**
	         * Document base URL where the current document is located.
	         *
	         * @property documentBaseURL
	         * @type String
	         */
	        self.documentBaseURL = documentBaseURL;
	
	        /**
	         * Absolute baseURI for the installation path of TinyMCE.
	         *
	         * @property baseURI
	         * @type tinymce.util.URI
	         */
	        self.baseURI = new URI(self.baseURL);
	
	        /**
	         * Current suffix to add to each plugin/theme that gets loaded for example ".min".
	         *
	         * @property suffix
	         * @type String
	         */
	        self.suffix = suffix;
	
	        FocusController.setup(self);
	      },
	
	      /**
	       * Overrides the default settings for editor instances.
	       *
	       * @method overrideDefaults
	       * @param {Object} defaultSettings Defaults settings object.
	       */
	      overrideDefaults: function (defaultSettings) {
	        var baseUrl, suffix;
	
	        baseUrl = defaultSettings.base_url;
	        if (baseUrl) {
	          this.baseURL = new URI(this.documentBaseURL).toAbsolute(baseUrl.replace(/\/+$/, ''));
	          this.baseURI = new URI(this.baseURL);
	        }
	
	        suffix = defaultSettings.suffix;
	        if (defaultSettings.suffix) {
	          this.suffix = suffix;
	        }
	
	        this.defaultSettings = defaultSettings;
	
	        var pluginBaseUrls = defaultSettings.plugin_base_urls;
	        for (var name in pluginBaseUrls) {
	          AddOnManager.PluginManager.urls[name] = pluginBaseUrls[name];
	        }
	      },
	
	      /**
	       * Initializes a set of editors. This method will create editors based on various settings.
	       *
	       * @method init
	       * @param {Object} settings Settings object to be passed to each editor instance.
	       * @return {tinymce.util.Promise} Promise that gets resolved with an array of editors when all editor instances are initialized.
	       * @example
	       * // Initializes a editor using the longer method
	       * tinymce.EditorManager.init({
	       *    some_settings : 'some value'
	       * });
	       *
	       * // Initializes a editor instance using the shorter version and with a promise
	       * tinymce.init({
	       *    some_settings : 'some value'
	       * }).then(function(editors) {
	       *    ...
	       * });
	       */
	      init: function (settings) {
	        var self = this, result, invalidInlineTargets;
	
	        invalidInlineTargets = Tools.makeMap(
	          'area base basefont br col frame hr img input isindex link meta param embed source wbr track ' +
	          'colgroup option tbody tfoot thead tr script noscript style textarea video audio iframe object menu',
	          ' '
	        );
	
	        var isInvalidInlineTarget = function (settings, elm) {
	          return settings.inline && elm.tagName.toLowerCase() in invalidInlineTargets;
	        };
	
	        var createId = function (elm) {
	          var id = elm.id;
	
	          // Use element id, or unique name or generate a unique id
	          if (!id) {
	            id = elm.name;
	
	            if (id && !DOM.get(id)) {
	              id = elm.name;
	            } else {
	              // Generate unique name
	              id = DOM.uniqueId();
	            }
	
	            elm.setAttribute('id', id);
	          }
	
	          return id;
	        };
	
	        var execCallback = function (name) {
	          var callback = settings[name];
	
	          if (!callback) {
	            return;
	          }
	
	          return callback.apply(self, Array.prototype.slice.call(arguments, 2));
	        };
	
	        var hasClass = function (elm, className) {
	          return className.constructor === RegExp ? className.test(elm.className) : DOM.hasClass(elm, className);
	        };
	
	        var findTargets = function (settings) {
	          var l, targets = [];
	
	          if (Env.ie && Env.ie < 11) {
	            ErrorReporter.initError(
	              'TinyMCE does not support the browser you are using. For a list of supported' +
	              ' browsers please see: https://www.tinymce.com/docs/get-started/system-requirements/'
	            );
	            return [];
	          }
	
	          if (settings.types) {
	            each(settings.types, function (type) {
	              targets = targets.concat(DOM.select(type.selector));
	            });
	
	            return targets;
	          } else if (settings.selector) {
	            return DOM.select(settings.selector);
	          } else if (settings.target) {
	            return [settings.target];
	          }
	
	          // Fallback to old setting
	          switch (settings.mode) {
	            case "exact":
	              l = settings.elements || '';
	
	              if (l.length > 0) {
	                each(explode(l), function (id) {
	                  var elm;
	
	                  if ((elm = DOM.get(id))) {
	                    targets.push(elm);
	                  } else {
	                    each(document.forms, function (f) {
	                      each(f.elements, function (e) {
	                        if (e.name === id) {
	                          id = 'mce_editor_' + instanceCounter++;
	                          DOM.setAttrib(e, 'id', id);
	                          targets.push(e);
	                        }
	                      });
	                    });
	                  }
	                });
	              }
	              break;
	
	            case "textareas":
	            case "specific_textareas":
	              each(DOM.select('textarea'), function (elm) {
	                if (settings.editor_deselector && hasClass(elm, settings.editor_deselector)) {
	                  return;
	                }
	
	                if (!settings.editor_selector || hasClass(elm, settings.editor_selector)) {
	                  targets.push(elm);
	                }
	              });
	              break;
	          }
	
	          return targets;
	        };
	
	        var provideResults = function (editors) {
	          result = editors;
	        };
	
	        var initEditors = function () {
	          var initCount = 0, editors = [], targets;
	
	          var createEditor = function (id, settings, targetElm) {
	            var editor = new Editor(id, settings, self);
	
	            editors.push(editor);
	
	            editor.on('init', function () {
	              if (++initCount === targets.length) {
	                provideResults(editors);
	              }
	            });
	
	            editor.targetElm = editor.targetElm || targetElm;
	            editor.render();
	          };
	
	          DOM.unbind(window, 'ready', initEditors);
	          execCallback('onpageload');
	
	          targets = DomQuery.unique(findTargets(settings));
	
	          // TODO: Deprecate this one
	          if (settings.types) {
	            each(settings.types, function (type) {
	              Tools.each(targets, function (elm) {
	                if (DOM.is(elm, type.selector)) {
	                  createEditor(createId(elm), extend({}, settings, type), elm);
	                  return false;
	                }
	
	                return true;
	              });
	            });
	
	            return;
	          }
	
	          Tools.each(targets, function (elm) {
	            purgeDestroyedEditor(self.get(elm.id));
	          });
	
	          targets = Tools.grep(targets, function (elm) {
	            return !self.get(elm.id);
	          });
	
	          if (targets.length === 0) {
	            provideResults([]);
	          } else {
	            each(targets, function (elm) {
	              if (isInvalidInlineTarget(settings, elm)) {
	                ErrorReporter.initError('Could not initialize inline editor on invalid inline target element', elm);
	              } else {
	                createEditor(createId(elm), settings, elm);
	              }
	            });
	          }
	        };
	
	        self.settings = settings;
	        DOM.bind(window, 'ready', initEditors);
	
	        return new Promise(function (resolve) {
	          if (result) {
	            resolve(result);
	          } else {
	            provideResults = function (editors) {
	              resolve(editors);
	            };
	          }
	        });
	      },
	
	      /**
	       * Returns a editor instance by id.
	       *
	       * @method get
	       * @param {String/Number} id Editor instance id or index to return.
	       * @return {tinymce.Editor/Array} Editor instance to return or array of editor instances.
	       * @example
	       * // Adds an onclick event to an editor by id
	       * tinymce.get('mytextbox').on('click', function(e) {
	       *    ed.windowManager.alert('Hello world!');
	       * });
	       *
	       * // Adds an onclick event to an editor by index
	       * tinymce.get(0).on('click', function(e) {
	       *    ed.windowManager.alert('Hello world!');
	       * });
	       *
	       * // Adds an onclick event to an editor by id (longer version)
	       * tinymce.EditorManager.get('mytextbox').on('click', function(e) {
	       *    ed.windowManager.alert('Hello world!');
	       * });
	       */
	      get: function (id) {
	        if (arguments.length === 0) {
	          return editors.slice(0);
	        } else if (Type.isString(id)) {
	          return Arr.find(editors, function (editor) {
	            return editor.id === id;
	          }).getOr(null);
	        } else if (Type.isNumber(id)) {
	          return editors[id] ? editors[id] : null;
	        } else {
	          return null;
	        }
	      },
	
	      /**
	       * Adds an editor instance to the editor collection. This will also set it as the active editor.
	       *
	       * @method add
	       * @param {tinymce.Editor} editor Editor instance to add to the collection.
	       * @return {tinymce.Editor} The same instance that got passed in.
	       */
	      add: function (editor) {
	        var self = this, existingEditor;
	
	        // Prevent existing editors from beeing added again this could happen
	        // if a user calls createEditor then render or add multiple times.
	        existingEditor = legacyEditors[editor.id];
	        if (existingEditor === editor) {
	          return editor;
	        }
	
	        if (self.get(editor.id) === null) {
	          // Add to legacy editors array, this is what breaks in HTML5 where ID:s with numbers are valid
	          // We can't get rid of this strange object and array at the same time since it seems to be used all over the web
	          if (isValidLegacyKey(editor.id)) {
	            legacyEditors[editor.id] = editor;
	          }
	
	          legacyEditors.push(editor);
	
	          editors.push(editor);
	        }
	
	        toggleGlobalEvents(true);
	
	        // Doesn't call setActive method since we don't want
	        // to fire a bunch of activate/deactivate calls while initializing
	        self.activeEditor = editor;
	
	        self.fire('AddEditor', { editor: editor });
	
	        if (!beforeUnloadDelegate) {
	          beforeUnloadDelegate = function () {
	            self.fire('BeforeUnload');
	          };
	
	          DOM.bind(window, 'beforeunload', beforeUnloadDelegate);
	        }
	
	        return editor;
	      },
	
	      /**
	       * Creates an editor instance and adds it to the EditorManager collection.
	       *
	       * @method createEditor
	       * @param {String} id Instance id to use for editor.
	       * @param {Object} settings Editor instance settings.
	       * @return {tinymce.Editor} Editor instance that got created.
	       */
	      createEditor: function (id, settings) {
	        return this.add(new Editor(id, settings, this));
	      },
	
	      /**
	       * Removes a editor or editors form page.
	       *
	       * @example
	       * // Remove all editors bound to divs
	       * tinymce.remove('div');
	       *
	       * // Remove all editors bound to textareas
	       * tinymce.remove('textarea');
	       *
	       * // Remove all editors
	       * tinymce.remove();
	       *
	       * // Remove specific instance by id
	       * tinymce.remove('#id');
	       *
	       * @method remove
	       * @param {tinymce.Editor/String/Object} [selector] CSS selector or editor instance to remove.
	       * @return {tinymce.Editor} The editor that got passed in will be return if it was found otherwise null.
	       */
	      remove: function (selector) {
	        var self = this, i, editor;
	
	        // Remove all editors
	        if (!selector) {
	          for (i = editors.length - 1; i >= 0; i--) {
	            self.remove(editors[i]);
	          }
	
	          return;
	        }
	
	        // Remove editors by selector
	        if (Type.isString(selector)) {
	          selector = selector.selector || selector;
	
	          each(DOM.select(selector), function (elm) {
	            editor = self.get(elm.id);
	
	            if (editor) {
	              self.remove(editor);
	            }
	          });
	
	          return;
	        }
	
	        // Remove specific editor
	        editor = selector;
	
	        // Not in the collection
	        if (Type.isNull(self.get(editor.id))) {
	          return null;
	        }
	
	        if (removeEditorFromList(editor)) {
	          self.fire('RemoveEditor', { editor: editor });
	        }
	
	        if (editors.length === 0) {
	          DOM.unbind(window, 'beforeunload', beforeUnloadDelegate);
	        }
	
	        editor.remove();
	
	        toggleGlobalEvents(editors.length > 0);
	
	        return editor;
	      },
	
	      /**
	       * Executes a specific command on the currently active editor.
	       *
	       * @method execCommand
	       * @param {String} cmd Command to perform for example Bold.
	       * @param {Boolean} ui Optional boolean state if a UI should be presented for the command or not.
	       * @param {String} value Optional value parameter like for example an URL to a link.
	       * @return {Boolean} true/false if the command was executed or not.
	       */
	      execCommand: function (cmd, ui, value) {
	        var self = this, editor = self.get(value);
	
	        // Manager commands
	        switch (cmd) {
	          case "mceAddEditor":
	            if (!self.get(value)) {
	              new Editor(value, self.settings, self).render();
	            }
	
	            return true;
	
	          case "mceRemoveEditor":
	            if (editor) {
	              editor.remove();
	            }
	
	            return true;
	
	          case 'mceToggleEditor':
	            if (!editor) {
	              self.execCommand('mceAddEditor', 0, value);
	              return true;
	            }
	
	            if (editor.isHidden()) {
	              editor.show();
	            } else {
	              editor.hide();
	            }
	
	            return true;
	        }
	
	        // Run command on active editor
	        if (self.activeEditor) {
	          return self.activeEditor.execCommand(cmd, ui, value);
	        }
	
	        return false;
	      },
	
	      /**
	       * Calls the save method on all editor instances in the collection. This can be useful when a form is to be submitted.
	       *
	       * @method triggerSave
	       * @example
	       * // Saves all contents
	       * tinyMCE.triggerSave();
	       */
	      triggerSave: function () {
	        each(editors, function (editor) {
	          editor.save();
	        });
	      },
	
	      /**
	       * Adds a language pack, this gets called by the loaded language files like en.js.
	       *
	       * @method addI18n
	       * @param {String} code Optional language code.
	       * @param {Object} items Name/value object with translations.
	       */
	      addI18n: function (code, items) {
	        I18n.add(code, items);
	      },
	
	      /**
	       * Translates the specified string using the language pack items.
	       *
	       * @method translate
	       * @param {String/Array/Object} text String to translate
	       * @return {String} Translated string.
	       */
	      translate: function (text) {
	        return I18n.translate(text);
	      },
	
	      /**
	       * Sets the active editor instance and fires the deactivate/activate events.
	       *
	       * @method setActive
	       * @param {tinymce.Editor} editor Editor instance to set as the active instance.
	       */
	      setActive: function (editor) {
	        var activeEditor = this.activeEditor;
	
	        if (this.activeEditor != editor) {
	          if (activeEditor) {
	            activeEditor.fire('deactivate', { relatedTarget: editor });
	          }
	
	          editor.fire('activate', { relatedTarget: activeEditor });
	        }
	
	        this.activeEditor = editor;
	      }
	    };
	
	    extend(EditorManager, Observable);
	
	    EditorManager.setup();
	
	    return EditorManager;
	  }
	);
	
	/**
	 * RangeUtils.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class contains a few utility methods for ranges.
	 *
	 * @class tinymce.dom.RangeUtils
	 */
	define(
	  'tinymce.core.api.dom.RangeUtils',
	  [
	    'ephox.katamari.api.Fun',
	    'tinymce.core.selection.CaretRangeFromPoint',
	    'tinymce.core.selection.NormalizeRange',
	    'tinymce.core.selection.RangeCompare',
	    'tinymce.core.selection.RangeNodes',
	    'tinymce.core.selection.RangeWalk',
	    'tinymce.core.selection.SplitRange'
	  ],
	  function (Fun, CaretRangeFromPoint, NormalizeRange, RangeCompare, RangeNodes, RangeWalk, SplitRange) {
	    var RangeUtils = function (dom) {
	      /**
	       * Walks the specified range like object and executes the callback for each sibling collection it finds.
	       *
	       * @private
	       * @method walk
	       * @param {Object} rng Range like object.
	       * @param {function} callback Callback function to execute for each sibling collection.
	       */
	      var walk = function (rng, callback) {
	        return RangeWalk.walk(dom, rng, callback);
	      };
	
	      /**
	       * Splits the specified range at it's start/end points.
	       *
	       * @private
	       * @param {Range/RangeObject} rng Range to split.
	       * @return {Object} Range position object.
	       */
	      var split = SplitRange.split;
	
	      /**
	       * Normalizes the specified range by finding the closest best suitable caret location.
	       *
	       * @private
	       * @param {Range} rng Range to normalize.
	       * @return {Boolean} True/false if the specified range was normalized or not.
	       */
	      var normalize = function (rng) {
	        return NormalizeRange.normalize(dom, rng).fold(
	          Fun.constant(false),
	          function (normalizedRng) {
	            rng.setStart(normalizedRng.startContainer, normalizedRng.startOffset);
	            rng.setEnd(normalizedRng.endContainer, normalizedRng.endOffset);
	            return true;
	          }
	        );
	      };
	
	      return {
	        walk: walk,
	        split: split,
	        normalize: normalize
	      };
	    };
	
	    /**
	     * Compares two ranges and checks if they are equal.
	     *
	     * @static
	     * @method compareRanges
	     * @param {DOMRange} rng1 First range to compare.
	     * @param {DOMRange} rng2 First range to compare.
	     * @return {Boolean} true/false if the ranges are equal.
	     */
	    RangeUtils.compareRanges = RangeCompare.isEq;
	
	    /**
	     * Gets the caret range for the given x/y location.
	     *
	     * @static
	     * @method getCaretRangeFromPoint
	     * @param {Number} clientX X coordinate for range
	     * @param {Number} clientY Y coordinate for range
	     * @param {Document} doc Document that x/y are relative to
	     * @returns {Range} caret range
	     */
	    RangeUtils.getCaretRangeFromPoint = CaretRangeFromPoint.fromPoint;
	
	    RangeUtils.getSelectedNode = RangeNodes.getSelectedNode;
	    RangeUtils.getNode = RangeNodes.getNode;
	
	    return RangeUtils;
	  }
	);
	
	/**
	 * Rect.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * Contains various tools for rect/position calculation.
	 *
	 * @class tinymce.geom.Rect
	 */
	define(
	  'tinymce.core.geom.Rect',
	  [
	  ],
	  function () {
	    "use strict";
	
	    var min = Math.min, max = Math.max, round = Math.round;
	
	    /**
	     * Returns the rect positioned based on the relative position name
	     * to the target rect.
	     *
	     * @method relativePosition
	     * @param {Rect} rect Source rect to modify into a new rect.
	     * @param {Rect} targetRect Rect to move relative to based on the rel option.
	     * @param {String} rel Relative position. For example: tr-bl.
	     */
	    var relativePosition = function (rect, targetRect, rel) {
	      var x, y, w, h, targetW, targetH;
	
	      x = targetRect.x;
	      y = targetRect.y;
	      w = rect.w;
	      h = rect.h;
	      targetW = targetRect.w;
	      targetH = targetRect.h;
	
	      rel = (rel || '').split('');
	
	      if (rel[0] === 'b') {
	        y += targetH;
	      }
	
	      if (rel[1] === 'r') {
	        x += targetW;
	      }
	
	      if (rel[0] === 'c') {
	        y += round(targetH / 2);
	      }
	
	      if (rel[1] === 'c') {
	        x += round(targetW / 2);
	      }
	
	      if (rel[3] === 'b') {
	        y -= h;
	      }
	
	      if (rel[4] === 'r') {
	        x -= w;
	      }
	
	      if (rel[3] === 'c') {
	        y -= round(h / 2);
	      }
	
	      if (rel[4] === 'c') {
	        x -= round(w / 2);
	      }
	
	      return create(x, y, w, h);
	    };
	
	    /**
	     * Tests various positions to get the most suitable one.
	     *
	     * @method findBestRelativePosition
	     * @param {Rect} rect Rect to use as source.
	     * @param {Rect} targetRect Rect to move relative to.
	     * @param {Rect} constrainRect Rect to constrain within.
	     * @param {Array} rels Array of relative positions to test against.
	     */
	    var findBestRelativePosition = function (rect, targetRect, constrainRect, rels) {
	      var pos, i;
	
	      for (i = 0; i < rels.length; i++) {
	        pos = relativePosition(rect, targetRect, rels[i]);
	
	        if (pos.x >= constrainRect.x && pos.x + pos.w <= constrainRect.w + constrainRect.x &&
	          pos.y >= constrainRect.y && pos.y + pos.h <= constrainRect.h + constrainRect.y) {
	          return rels[i];
	        }
	      }
	
	      return null;
	    };
	
	    /**
	     * Inflates the rect in all directions.
	     *
	     * @method inflate
	     * @param {Rect} rect Rect to expand.
	     * @param {Number} w Relative width to expand by.
	     * @param {Number} h Relative height to expand by.
	     * @return {Rect} New expanded rect.
	     */
	    var inflate = function (rect, w, h) {
	      return create(rect.x - w, rect.y - h, rect.w + w * 2, rect.h + h * 2);
	    };
	
	    /**
	     * Returns the intersection of the specified rectangles.
	     *
	     * @method intersect
	     * @param {Rect} rect The first rectangle to compare.
	     * @param {Rect} cropRect The second rectangle to compare.
	     * @return {Rect} The intersection of the two rectangles or null if they don't intersect.
	     */
	    var intersect = function (rect, cropRect) {
	      var x1, y1, x2, y2;
	
	      x1 = max(rect.x, cropRect.x);
	      y1 = max(rect.y, cropRect.y);
	      x2 = min(rect.x + rect.w, cropRect.x + cropRect.w);
	      y2 = min(rect.y + rect.h, cropRect.y + cropRect.h);
	
	      if (x2 - x1 < 0 || y2 - y1 < 0) {
	        return null;
	      }
	
	      return create(x1, y1, x2 - x1, y2 - y1);
	    };
	
	    /**
	     * Returns a rect clamped within the specified clamp rect. This forces the
	     * rect to be inside the clamp rect.
	     *
	     * @method clamp
	     * @param {Rect} rect Rectangle to force within clamp rect.
	     * @param {Rect} clampRect Rectable to force within.
	     * @param {Boolean} fixedSize True/false if size should be fixed.
	     * @return {Rect} Clamped rect.
	     */
	    var clamp = function (rect, clampRect, fixedSize) {
	      var underflowX1, underflowY1, overflowX2, overflowY2,
	        x1, y1, x2, y2, cx2, cy2;
	
	      x1 = rect.x;
	      y1 = rect.y;
	      x2 = rect.x + rect.w;
	      y2 = rect.y + rect.h;
	      cx2 = clampRect.x + clampRect.w;
	      cy2 = clampRect.y + clampRect.h;
	
	      underflowX1 = max(0, clampRect.x - x1);
	      underflowY1 = max(0, clampRect.y - y1);
	      overflowX2 = max(0, x2 - cx2);
	      overflowY2 = max(0, y2 - cy2);
	
	      x1 += underflowX1;
	      y1 += underflowY1;
	
	      if (fixedSize) {
	        x2 += underflowX1;
	        y2 += underflowY1;
	        x1 -= overflowX2;
	        y1 -= overflowY2;
	      }
	
	      x2 -= overflowX2;
	      y2 -= overflowY2;
	
	      return create(x1, y1, x2 - x1, y2 - y1);
	    };
	
	    /**
	     * Creates a new rectangle object.
	     *
	     * @method create
	     * @param {Number} x Rectangle x location.
	     * @param {Number} y Rectangle y location.
	     * @param {Number} w Rectangle width.
	     * @param {Number} h Rectangle height.
	     * @return {Rect} New rectangle object.
	     */
	    var create = function (x, y, w, h) {
	      return { x: x, y: y, w: w, h: h };
	    };
	
	    /**
	     * Creates a new rectangle object form a clientRects object.
	     *
	     * @method fromClientRect
	     * @param {ClientRect} clientRect DOM ClientRect object.
	     * @return {Rect} New rectangle object.
	     */
	    var fromClientRect = function (clientRect) {
	      return create(clientRect.left, clientRect.top, clientRect.width, clientRect.height);
	    };
	
	    return {
	      inflate: inflate,
	      relativePosition: relativePosition,
	      findBestRelativePosition: findBestRelativePosition,
	      intersect: intersect,
	      clamp: clamp,
	      create: create,
	      fromClientRect: fromClientRect
	    };
	  }
	);
	
	/**
	 * Factory.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class is a factory for control instances. This enables you
	 * to create instances of controls without having to require the UI controls directly.
	 *
	 * It also allow you to override or add new control types.
	 *
	 * @class tinymce.ui.Factory
	 */
	define(
	  'tinymce.core.ui.Factory',
	  [
	  ],
	  function () {
	    "use strict";
	
	    var types = {};
	
	    return {
	      /**
	       * Adds a new control instance type to the factory.
	       *
	       * @method add
	       * @param {String} type Type name for example "button".
	       * @param {function} typeClass Class type function.
	       */
	      add: function (type, typeClass) {
	        types[type.toLowerCase()] = typeClass;
	      },
	
	      /**
	       * Returns true/false if the specified type exists or not.
	       *
	       * @method has
	       * @param {String} type Type to look for.
	       * @return {Boolean} true/false if the control by name exists.
	       */
	      has: function (type) {
	        return !!types[type.toLowerCase()];
	      },
	
	      /**
	       * Returns ui control module by name.
	       *
	       * @method get
	       * @param {String} type Type get.
	       * @return {Object} Module or undefined.
	       */
	      get: function (type) {
	        var lctype = type.toLowerCase();
	        var controlType = types.hasOwnProperty(lctype) ? types[lctype] : null;
	        if (controlType === null) {
	          throw new Error("Could not find module for type: " + type);
	        }
	
	        return controlType;
	      },
	
	      /**
	       * Creates a new control instance based on the settings provided. The instance created will be
	       * based on the specified type property it can also create whole structures of components out of
	       * the specified JSON object.
	       *
	       * @example
	       * tinymce.ui.Factory.create({
	       *     type: 'button',
	       *     text: 'Hello world!'
	       * });
	       *
	       * @method create
	       * @param {Object/String} settings Name/Value object with items used to create the type.
	       * @return {tinymce.ui.Control} Control instance based on the specified type.
	       */
	      create: function (type, settings) {
	        var ControlType;
	
	        // If string is specified then use it as the type
	        if (typeof type == 'string') {
	          settings = settings || {};
	          settings.type = type;
	        } else {
	          settings = type;
	          type = settings.type;
	        }
	
	        // Find control type
	        type = type.toLowerCase();
	        ControlType = types[type];
	
	        // #if debug
	
	        if (!ControlType) {
	          throw new Error("Could not find control by type: " + type);
	        }
	
	        // #endif
	
	        ControlType = new ControlType(settings);
	        ControlType.type = type; // Set the type on the instance, this will be used by the Selector engine
	
	        return ControlType;
	      }
	    };
	  }
	);
	/**
	 * Class.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This utilitiy class is used for easier inheritance.
	 *
	 * Features:
	 * * Exposed super functions: this._super();
	 * * Mixins
	 * * Dummy functions
	 * * Property functions: var value = object.value(); and object.value(newValue);
	 * * Static functions
	 * * Defaults settings
	 */
	define(
	  'tinymce.core.util.Class',
	  [
	    "tinymce.core.util.Tools"
	  ],
	  function (Tools) {
	    var each = Tools.each, extend = Tools.extend;
	
	    var extendClass, initializing;
	
	    var Class = function () {
	    };
	
	    // Provides classical inheritance, based on code made by John Resig
	    Class.extend = extendClass = function (prop) {
	      var self = this, _super = self.prototype, prototype, name, member;
	
	      // The dummy class constructor
	      var Class = function () {
	        var i, mixins, mixin, self = this;
	
	        // All construction is actually done in the init method
	        if (!initializing) {
	          // Run class constuctor
	          if (self.init) {
	            self.init.apply(self, arguments);
	          }
	
	          // Run mixin constructors
	          mixins = self.Mixins;
	          if (mixins) {
	            i = mixins.length;
	            while (i--) {
	              mixin = mixins[i];
	              if (mixin.init) {
	                mixin.init.apply(self, arguments);
	              }
	            }
	          }
	        }
	      };
	
	      // Dummy function, needs to be extended in order to provide functionality
	      var dummy = function () {
	        return this;
	      };
	
	      // Creates a overloaded method for the class
	      // this enables you to use this._super(); to call the super function
	      var createMethod = function (name, fn) {
	        return function () {
	          var self = this, tmp = self._super, ret;
	
	          self._super = _super[name];
	          ret = fn.apply(self, arguments);
	          self._super = tmp;
	
	          return ret;
	        };
	      };
	
	      // Instantiate a base class (but only create the instance,
	      // don't run the init constructor)
	      initializing = true;
	
	      /*eslint new-cap:0 */
	      prototype = new self();
	      initializing = false;
	
	      // Add mixins
	      if (prop.Mixins) {
	        each(prop.Mixins, function (mixin) {
	          for (var name in mixin) {
	            if (name !== "init") {
	              prop[name] = mixin[name];
	            }
	          }
	        });
	
	        if (_super.Mixins) {
	          prop.Mixins = _super.Mixins.concat(prop.Mixins);
	        }
	      }
	
	      // Generate dummy methods
	      if (prop.Methods) {
	        each(prop.Methods.split(','), function (name) {
	          prop[name] = dummy;
	        });
	      }
	
	      // Generate property methods
	      if (prop.Properties) {
	        each(prop.Properties.split(','), function (name) {
	          var fieldName = '_' + name;
	
	          prop[name] = function (value) {
	            var self = this, undef;
	
	            // Set value
	            if (value !== undef) {
	              self[fieldName] = value;
	
	              return self;
	            }
	
	            // Get value
	            return self[fieldName];
	          };
	        });
	      }
	
	      // Static functions
	      if (prop.Statics) {
	        each(prop.Statics, function (func, name) {
	          Class[name] = func;
	        });
	      }
	
	      // Default settings
	      if (prop.Defaults && _super.Defaults) {
	        prop.Defaults = extend({}, _super.Defaults, prop.Defaults);
	      }
	
	      // Copy the properties over onto the new prototype
	      for (name in prop) {
	        member = prop[name];
	
	        if (typeof member == "function" && _super[name]) {
	          prototype[name] = createMethod(name, member);
	        } else {
	          prototype[name] = member;
	        }
	      }
	
	      // Populate our constructed prototype object
	      Class.prototype = prototype;
	
	      // Enforce the constructor to be what we expect
	      Class.constructor = Class;
	
	      // And make this class extendible
	      Class.extend = extendClass;
	
	      return Class;
	    };
	
	    return Class;
	  }
	);
	/**
	 * Color.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class lets you parse/serialize colors and convert rgb/hsb.
	 *
	 * @class tinymce.util.Color
	 * @example
	 * var white = new tinymce.util.Color({r: 255, g: 255, b: 255});
	 * var red = new tinymce.util.Color('#FF0000');
	 *
	 * console.log(white.toHex(), red.toHsv());
	 */
	define(
	  'tinymce.core.util.Color',
	  [
	  ],
	  function () {
	    var min = Math.min, max = Math.max, round = Math.round;
	
	    /**
	     * Constructs a new color instance.
	     *
	     * @constructor
	     * @method Color
	     * @param {String} value Optional initial value to parse.
	     */
	    var Color = function (value) {
	      var self = this, r = 0, g = 0, b = 0;
	
	      var rgb2hsv = function (r, g, b) {
	        var h, s, v, d, minRGB, maxRGB;
	
	        h = 0;
	        s = 0;
	        v = 0;
	        r = r / 255;
	        g = g / 255;
	        b = b / 255;
	
	        minRGB = min(r, min(g, b));
	        maxRGB = max(r, max(g, b));
	
	        if (minRGB == maxRGB) {
	          v = minRGB;
	
	          return {
	            h: 0,
	            s: 0,
	            v: v * 100
	          };
	        }
	
	        /*eslint no-nested-ternary:0 */
	        d = (r == minRGB) ? g - b : ((b == minRGB) ? r - g : b - r);
	        h = (r == minRGB) ? 3 : ((b == minRGB) ? 1 : 5);
	        h = 60 * (h - d / (maxRGB - minRGB));
	        s = (maxRGB - minRGB) / maxRGB;
	        v = maxRGB;
	
	        return {
	          h: round(h),
	          s: round(s * 100),
	          v: round(v * 100)
	        };
	      };
	
	      var hsvToRgb = function (hue, saturation, brightness) {
	        var side, chroma, x, match;
	
	        hue = (parseInt(hue, 10) || 0) % 360;
	        saturation = parseInt(saturation, 10) / 100;
	        brightness = parseInt(brightness, 10) / 100;
	        saturation = max(0, min(saturation, 1));
	        brightness = max(0, min(brightness, 1));
	
	        if (saturation === 0) {
	          r = g = b = round(255 * brightness);
	          return;
	        }
	
	        side = hue / 60;
	        chroma = brightness * saturation;
	        x = chroma * (1 - Math.abs(side % 2 - 1));
	        match = brightness - chroma;
	
	        switch (Math.floor(side)) {
	          case 0:
	            r = chroma;
	            g = x;
	            b = 0;
	            break;
	
	          case 1:
	            r = x;
	            g = chroma;
	            b = 0;
	            break;
	
	          case 2:
	            r = 0;
	            g = chroma;
	            b = x;
	            break;
	
	          case 3:
	            r = 0;
	            g = x;
	            b = chroma;
	            break;
	
	          case 4:
	            r = x;
	            g = 0;
	            b = chroma;
	            break;
	
	          case 5:
	            r = chroma;
	            g = 0;
	            b = x;
	            break;
	
	          default:
	            r = g = b = 0;
	        }
	
	        r = round(255 * (r + match));
	        g = round(255 * (g + match));
	        b = round(255 * (b + match));
	      };
	
	      /**
	       * Returns the hex string of the current color. For example: #ff00ff
	       *
	       * @method toHex
	       * @return {String} Hex string of current color.
	       */
	      var toHex = function () {
	        var hex = function (val) {
	          val = parseInt(val, 10).toString(16);
	
	          return val.length > 1 ? val : '0' + val;
	        };
	
	        return '#' + hex(r) + hex(g) + hex(b);
	      };
	
	      /**
	       * Returns the r, g, b values of the color. Each channel has a range from 0-255.
	       *
	       * @method toRgb
	       * @return {Object} Object with r, g, b fields.
	       */
	      var toRgb = function () {
	        return {
	          r: r,
	          g: g,
	          b: b
	        };
	      };
	
	      /**
	       * Returns the h, s, v values of the color. Ranges: h=0-360, s=0-100, v=0-100.
	       *
	       * @method toHsv
	       * @return {Object} Object with h, s, v fields.
	       */
	      var toHsv = function () {
	        return rgb2hsv(r, g, b);
	      };
	
	      /**
	       * Parses the specified value and populates the color instance.
	       *
	       * Supported format examples:
	       *  * rbg(255,0,0)
	       *  * #ff0000
	       *  * #fff
	       *  * {r: 255, g: 0, b: 0}
	       *  * {h: 360, s: 100, v: 100}
	       *
	       * @method parse
	       * @param {Object/String} value Color value to parse.
	       * @return {tinymce.util.Color} Current color instance.
	       */
	      var parse = function (value) {
	        var matches;
	
	        if (typeof value == 'object') {
	          if ("r" in value) {
	            r = value.r;
	            g = value.g;
	            b = value.b;
	          } else if ("v" in value) {
	            hsvToRgb(value.h, value.s, value.v);
	          }
	        } else {
	          if ((matches = /rgb\s*\(\s*([0-9]+)\s*,\s*([0-9]+)\s*,\s*([0-9]+)[^\)]*\)/gi.exec(value))) {
	            r = parseInt(matches[1], 10);
	            g = parseInt(matches[2], 10);
	            b = parseInt(matches[3], 10);
	          } else if ((matches = /#([0-F]{2})([0-F]{2})([0-F]{2})/gi.exec(value))) {
	            r = parseInt(matches[1], 16);
	            g = parseInt(matches[2], 16);
	            b = parseInt(matches[3], 16);
	          } else if ((matches = /#([0-F])([0-F])([0-F])/gi.exec(value))) {
	            r = parseInt(matches[1] + matches[1], 16);
	            g = parseInt(matches[2] + matches[2], 16);
	            b = parseInt(matches[3] + matches[3], 16);
	          }
	        }
	
	        r = r < 0 ? 0 : (r > 255 ? 255 : r);
	        g = g < 0 ? 0 : (g > 255 ? 255 : g);
	        b = b < 0 ? 0 : (b > 255 ? 255 : b);
	
	        return self;
	      };
	
	      if (value) {
	        parse(value);
	      }
	
	      self.toRgb = toRgb;
	      self.toHsv = toHsv;
	      self.toHex = toHex;
	      self.parse = parse;
	    };
	
	    return Color;
	  }
	);
	
	/**
	 * JSON.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * JSON parser and serializer class.
	 *
	 * @class tinymce.util.JSON
	 * @static
	 * @example
	 * // JSON parse a string into an object
	 * var obj = tinymce.util.JSON.parse(somestring);
	 *
	 * // JSON serialize a object into an string
	 * var str = tinymce.util.JSON.serialize(obj);
	 */
	define(
	  'tinymce.core.util.JSON',
	  [
	    'global!window'
	  ],
	  function (window) {
	    var serialize = function (o, quote) {
	      var i, v, t, name;
	
	      quote = quote || '"';
	
	      if (o === null) {
	        return 'null';
	      }
	
	      t = typeof o;
	
	      if (t == 'string') {
	        v = '\bb\tt\nn\ff\rr\""\'\'\\\\';
	
	        /*eslint no-control-regex:0 */
	        return quote + o.replace(/([\u0080-\uFFFF\x00-\x1f\"\'\\])/g, function (a, b) {
	          // Make sure single quotes never get encoded inside double quotes for JSON compatibility
	          if (quote === '"' && a === "'") {
	            return a;
	          }
	
	          i = v.indexOf(b);
	
	          if (i + 1) {
	            return '\\' + v.charAt(i + 1);
	          }
	
	          a = b.charCodeAt().toString(16);
	
	          return '\\u' + '0000'.substring(a.length) + a;
	        }) + quote;
	      }
	
	      if (t == 'object') {
	        if (o.hasOwnProperty && Object.prototype.toString.call(o) === '[object Array]') {
	          for (i = 0, v = '['; i < o.length; i++) {
	            v += (i > 0 ? ',' : '') + serialize(o[i], quote);
	          }
	
	          return v + ']';
	        }
	
	        v = '{';
	
	        for (name in o) {
	          if (o.hasOwnProperty(name)) {
	            v += typeof o[name] != 'function' ? (v.length > 1 ? ',' + quote : quote) + name +
	              quote + ':' + serialize(o[name], quote) : '';
	          }
	        }
	
	        return v + '}';
	      }
	
	      return '' + o;
	    };
	
	    return {
	      /**
	       * Serializes the specified object as a JSON string.
	       *
	       * @method serialize
	       * @param {Object} obj Object to serialize as a JSON string.
	       * @param {String} quote Optional quote string defaults to ".
	       * @return {string} JSON string serialized from input.
	       */
	      serialize: serialize,
	
	      /**
	       * Unserializes/parses the specified JSON string into a object.
	       *
	       * @method parse
	       * @param {string} s JSON String to parse into a JavaScript object.
	       * @return {Object} Object from input JSON string or undefined if it failed.
	       */
	      parse: function (text) {
	        try {
	          // Trick uglify JS
	          return window[String.fromCharCode(101) + 'val']('(' + text + ')');
	        } catch (ex) {
	          // Ignore
	        }
	      }
	
	      /**#@-*/
	    };
	  }
	);
	
	/**
	 * JSONP.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.util.JSONP',
	  [
	    "tinymce.core.dom.DOMUtils"
	  ],
	  function (DOMUtils) {
	    return {
	      callbacks: {},
	      count: 0,
	
	      send: function (settings) {
	        var self = this, dom = DOMUtils.DOM, count = settings.count !== undefined ? settings.count : self.count;
	        var id = 'tinymce_jsonp_' + count;
	
	        self.callbacks[count] = function (json) {
	          dom.remove(id);
	          delete self.callbacks[count];
	
	          settings.callback(json);
	        };
	
	        dom.add(dom.doc.body, 'script', {
	          id: id,
	          src: settings.url,
	          type: 'text/javascript'
	        });
	
	        self.count++;
	      }
	    };
	  }
	);
	/**
	 * XHR.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class enables you to send XMLHTTPRequests cross browser.
	 * @class tinymce.util.XHR
	 * @mixes tinymce.util.Observable
	 * @static
	 * @example
	 * // Sends a low level Ajax request
	 * tinymce.util.XHR.send({
	 *    url: 'someurl',
	 *    success: function(text) {
	 *       console.debug(text);
	 *    }
	 * });
	 *
	 * // Add custom header to XHR request
	 * tinymce.util.XHR.on('beforeSend', function(e) {
	 *     e.xhr.setRequestHeader('X-Requested-With', 'Something');
	 * });
	 */
	define(
	  'tinymce.core.util.XHR',
	  [
	    'ephox.sand.api.XMLHttpRequest',
	    'global!setTimeout',
	    'tinymce.core.util.Observable',
	    'tinymce.core.util.Tools'
	  ],
	  function (XMLHttpRequest, setTimeout, Observable, Tools) {
	    var XHR = {
	      /**
	       * Sends a XMLHTTPRequest.
	       * Consult the Wiki for details on what settings this method takes.
	       *
	       * @method send
	       * @param {Object} settings Object will target URL, callbacks and other info needed to make the request.
	       */
	      send: function (settings) {
	        var xhr, count = 0;
	
	        var ready = function () {
	          if (!settings.async || xhr.readyState == 4 || count++ > 10000) {
	            if (settings.success && count < 10000 && xhr.status == 200) {
	              settings.success.call(settings.success_scope, '' + xhr.responseText, xhr, settings);
	            } else if (settings.error) {
	              settings.error.call(settings.error_scope, count > 10000 ? 'TIMED_OUT' : 'GENERAL', xhr, settings);
	            }
	
	            xhr = null;
	          } else {
	            setTimeout(ready, 10);
	          }
	        };
	
	        // Default settings
	        settings.scope = settings.scope || this;
	        settings.success_scope = settings.success_scope || settings.scope;
	        settings.error_scope = settings.error_scope || settings.scope;
	        settings.async = settings.async === false ? false : true;
	        settings.data = settings.data || '';
	
	        XHR.fire('beforeInitialize', { settings: settings });
	
	        xhr = new XMLHttpRequest();
	
	        if (xhr) {
	          if (xhr.overrideMimeType) {
	            xhr.overrideMimeType(settings.content_type);
	          }
	
	          xhr.open(settings.type || (settings.data ? 'POST' : 'GET'), settings.url, settings.async);
	
	          if (settings.crossDomain) {
	            xhr.withCredentials = true;
	          }
	
	          if (settings.content_type) {
	            xhr.setRequestHeader('Content-Type', settings.content_type);
	          }
	
	          if (settings.requestheaders) {
	            Tools.each(settings.requestheaders, function (header) {
	              xhr.setRequestHeader(header.key, header.value);
	            });
	          }
	
	          xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
	
	          xhr = XHR.fire('beforeSend', { xhr: xhr, settings: settings }).xhr;
	          xhr.send(settings.data);
	
	          // Syncronous request
	          if (!settings.async) {
	            return ready();
	          }
	
	          // Wait for response, onReadyStateChange can not be used since it leaks memory in IE
	          setTimeout(ready, 10);
	        }
	      }
	    };
	
	    Tools.extend(XHR, Observable);
	
	    return XHR;
	  }
	);
	
	/**
	 * JSONRequest.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class enables you to use JSON-RPC to call backend methods.
	 *
	 * @class tinymce.util.JSONRequest
	 * @example
	 * var json = new tinymce.util.JSONRequest({
	 *     url: 'somebackend.php'
	 * });
	 *
	 * // Send RPC call 1
	 * json.send({
	 *     method: 'someMethod1',
	 *     params: ['a', 'b'],
	 *     success: function(result) {
	 *         console.dir(result);
	 *     }
	 * });
	 *
	 * // Send RPC call 2
	 * json.send({
	 *     method: 'someMethod2',
	 *     params: ['a', 'b'],
	 *     success: function(result) {
	 *         console.dir(result);
	 *     }
	 * });
	 */
	define(
	  'tinymce.core.util.JSONRequest',
	  [
	    "tinymce.core.util.JSON",
	    "tinymce.core.util.XHR",
	    "tinymce.core.util.Tools"
	  ],
	  function (JSON, XHR, Tools) {
	    var extend = Tools.extend;
	
	    var JSONRequest = function (settings) {
	      this.settings = extend({}, settings);
	      this.count = 0;
	    };
	
	    /**
	     * Simple helper function to send a JSON-RPC request without the need to initialize an object.
	     * Consult the Wiki API documentation for more details on what you can pass to this function.
	     *
	     * @method sendRPC
	     * @static
	     * @param {Object} o Call object where there are three field id, method and params this object should also contain callbacks etc.
	     */
	    JSONRequest.sendRPC = function (o) {
	      return new JSONRequest().send(o);
	    };
	
	    JSONRequest.prototype = {
	      /**
	       * Sends a JSON-RPC call. Consult the Wiki API documentation for more details on what you can pass to this function.
	       *
	       * @method send
	       * @param {Object} args Call object where there are three field id, method and params this object should also contain callbacks etc.
	       */
	      send: function (args) {
	        var ecb = args.error, scb = args.success;
	
	        args = extend(this.settings, args);
	
	        args.success = function (c, x) {
	          c = JSON.parse(c);
	
	          if (typeof c == 'undefined') {
	            c = {
	              error: 'JSON Parse error.'
	            };
	          }
	
	          if (c.error) {
	            ecb.call(args.error_scope || args.scope, c.error, x);
	          } else {
	            scb.call(args.success_scope || args.scope, c.result);
	          }
	        };
	
	        args.error = function (ty, x) {
	          if (ecb) {
	            ecb.call(args.error_scope || args.scope, ty, x);
	          }
	        };
	
	        args.data = JSON.serialize({
	          id: args.id || 'c' + (this.count++),
	          method: args.method,
	          params: args.params
	        });
	
	        // JSON content type for Ruby on rails. Bug: #1883287
	        args.content_type = 'application/json';
	
	        XHR.send(args);
	      }
	    };
	
	    return JSONRequest;
	  }
	);
	/**
	 * LocalStorage.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	/**
	 * This class will simulate LocalStorage on IE 7 and return the native version on modern browsers.
	 * Storage is done using userData on IE 7 and a special serialization format. The format is designed
	 * to be as small as possible by making sure that the keys and values doesn't need to be encoded. This
	 * makes it possible to store for example HTML data.
	 *
	 * Storage format for userData:
	 * <base 32 key length>,<key string>,<base 32 value length>,<value>,...
	 *
	 * For example this data key1=value1,key2=value2 would be:
	 * 4,key1,6,value1,4,key2,6,value2
	 *
	 * @class tinymce.util.LocalStorage
	 * @static
	 * @version 4.0
	 * @example
	 * tinymce.util.LocalStorage.setItem('key', 'value');
	 * var value = tinymce.util.LocalStorage.getItem('key');
	 */
	define(
	  'tinymce.core.util.LocalStorage',
	  [
	    'global!document',
	    'global!window'
	  ],
	  function (document, window) {
	    var LocalStorage, storageElm, items, keys, userDataKey, hasOldIEDataSupport;
	
	    // Check for native support
	    try {
	      if (window.localStorage) {
	        return window.localStorage;
	      }
	    } catch (ex) {
	      // Ignore
	    }
	
	    userDataKey = "tinymce";
	    storageElm = document.documentElement;
	    hasOldIEDataSupport = !!storageElm.addBehavior;
	
	    if (hasOldIEDataSupport) {
	      storageElm.addBehavior('#default#userData');
	    }
	
	    /**
	     * Gets the keys names and updates LocalStorage.length property. Since IE7 doesn't have any getters/setters.
	     */
	    var updateKeys = function () {
	      keys = [];
	
	      for (var key in items) {
	        keys.push(key);
	      }
	
	      LocalStorage.length = keys.length;
	    };
	
	    /**
	     * Loads the userData string and parses it into the items structure.
	     */
	    var load = function () {
	      var key, data, value, pos = 0;
	
	      items = {};
	
	      // localStorage can be disabled on WebKit/Gecko so make a dummy storage
	      if (!hasOldIEDataSupport) {
	        return;
	      }
	
	      var next = function (end) {
	        var value, nextPos;
	
	        nextPos = end !== undefined ? pos + end : data.indexOf(',', pos);
	        if (nextPos === -1 || nextPos > data.length) {
	          return null;
	        }
	
	        value = data.substring(pos, nextPos);
	        pos = nextPos + 1;
	
	        return value;
	      };
	
	      storageElm.load(userDataKey);
	      data = storageElm.getAttribute(userDataKey) || '';
	
	      do {
	        var offset = next();
	        if (offset === null) {
	          break;
	        }
	
	        key = next(parseInt(offset, 32) || 0);
	        if (key !== null) {
	          offset = next();
	          if (offset === null) {
	            break;
	          }
	
	          value = next(parseInt(offset, 32) || 0);
	
	          if (key) {
	            items[key] = value;
	          }
	        }
	      } while (key !== null);
	
	      updateKeys();
	    };
	
	    /**
	     * Saves the items structure into a the userData format.
	     */
	    var save = function () {
	      var value, data = '';
	
	      // localStorage can be disabled on WebKit/Gecko so make a dummy storage
	      if (!hasOldIEDataSupport) {
	        return;
	      }
	
	      for (var key in items) {
	        value = items[key];
	        data += (data ? ',' : '') + key.length.toString(32) + ',' + key + ',' + value.length.toString(32) + ',' + value;
	      }
	
	      storageElm.setAttribute(userDataKey, data);
	
	      try {
	        storageElm.save(userDataKey);
	      } catch (ex) {
	        // Ignore disk full
	      }
	
	      updateKeys();
	    };
	
	    LocalStorage = {
	      /**
	       * Length of the number of items in storage.
	       *
	       * @property length
	       * @type Number
	       * @return {Number} Number of items in storage.
	       */
	      //length:0,
	
	      /**
	       * Returns the key name by index.
	       *
	       * @method key
	       * @param {Number} index Index of key to return.
	       * @return {String} Key value or null if it wasn't found.
	       */
	      key: function (index) {
	        return keys[index];
	      },
	
	      /**
	       * Returns the value if the specified key or null if it wasn't found.
	       *
	       * @method getItem
	       * @param {String} key Key of item to retrieve.
	       * @return {String} Value of the specified item or null if it wasn't found.
	       */
	      getItem: function (key) {
	        return key in items ? items[key] : null;
	      },
	
	      /**
	       * Sets the value of the specified item by it's key.
	       *
	       * @method setItem
	       * @param {String} key Key of the item to set.
	       * @param {String} value Value of the item to set.
	       */
	      setItem: function (key, value) {
	        items[key] = "" + value;
	        save();
	      },
	
	      /**
	       * Removes the specified item by key.
	       *
	       * @method removeItem
	       * @param {String} key Key of item to remove.
	       */
	      removeItem: function (key) {
	        delete items[key];
	        save();
	      },
	
	      /**
	       * Removes all items.
	       *
	       * @method clear
	       */
	      clear: function () {
	        items = {};
	        save();
	      }
	    };
	
	    load();
	
	    return LocalStorage;
	  }
	);
	
	/**
	 * Tinymce.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.api.Tinymce',
	  [
	    'tinymce.core.AddOnManager',
	    'tinymce.core.Editor',
	    'tinymce.core.EditorCommands',
	    'tinymce.core.EditorManager',
	    'tinymce.core.EditorObservable',
	    'tinymce.core.Env',
	    'tinymce.core.Shortcuts',
	    'tinymce.core.UndoManager',
	    'tinymce.core.api.FocusManager',
	    'tinymce.core.api.Formatter',
	    'tinymce.core.api.NotificationManager',
	    'tinymce.core.api.WindowManager',
	    'tinymce.core.api.dom.BookmarkManager',
	    'tinymce.core.api.dom.RangeUtils',
	    'tinymce.core.api.dom.Serializer',
	    'tinymce.core.dom.ControlSelection',
	    'tinymce.core.dom.DOMUtils',
	    'tinymce.core.dom.DomQuery',
	    'tinymce.core.dom.EventUtils',
	    'tinymce.core.dom.ScriptLoader',
	    'tinymce.core.dom.Selection',
	    'tinymce.core.dom.Sizzle',
	    'tinymce.core.dom.TreeWalker',
	    'tinymce.core.geom.Rect',
	    'tinymce.core.html.DomParser',
	    'tinymce.core.html.Entities',
	    'tinymce.core.html.Node',
	    'tinymce.core.html.SaxParser',
	    'tinymce.core.html.Schema',
	    'tinymce.core.html.Serializer',
	    'tinymce.core.html.Styles',
	    'tinymce.core.html.Writer',
	    'tinymce.core.ui.Factory',
	    'tinymce.core.util.Class',
	    'tinymce.core.util.Color',
	    'tinymce.core.util.Delay',
	    'tinymce.core.util.EventDispatcher',
	    'tinymce.core.util.I18n',
	    'tinymce.core.util.JSON',
	    'tinymce.core.util.JSONP',
	    'tinymce.core.util.JSONRequest',
	    'tinymce.core.util.LocalStorage',
	    'tinymce.core.util.Observable',
	    'tinymce.core.util.Promise',
	    'tinymce.core.util.Tools',
	    'tinymce.core.util.URI',
	    'tinymce.core.util.VK',
	    'tinymce.core.util.XHR'
	  ],
	  function (
	    AddOnManager, Editor, EditorCommands, EditorManager, EditorObservable, Env, Shortcuts, UndoManager, FocusManager, Formatter, NotificationManager, WindowManager,
	    BookmarkManager, RangeUtils, DomSerializer, ControlSelection, DOMUtils, DomQuery, EventUtils, ScriptLoader, Selection, Sizzle, TreeWalker, Rect, DomParser,
	    Entities, Node, SaxParser, Schema, HtmlSerializer, Styles, Writer, Factory, Class, Color, Delay, EventDispatcher, I18n, JSON, JSONP, JSONRequest, LocalStorage,
	    Observable, Promise, Tools, URI, VK, XHR
	  ) {
	    var tinymce = EditorManager;
	
	    /**
	     * @include ../../../../../../tools/docs/tinymce.js
	     */
	    var publicApi = {
	      geom: {
	        Rect: Rect
	      },
	
	      util: {
	        Promise: Promise,
	        Delay: Delay,
	        Tools: Tools,
	        VK: VK,
	        URI: URI,
	        Class: Class,
	        EventDispatcher: EventDispatcher,
	        Observable: Observable,
	        I18n: I18n,
	        XHR: XHR,
	        JSON: JSON,
	        JSONRequest: JSONRequest,
	        JSONP: JSONP,
	        LocalStorage: LocalStorage,
	        Color: Color
	      },
	
	      dom: {
	        EventUtils: EventUtils,
	        Sizzle: Sizzle,
	        DomQuery: DomQuery,
	        TreeWalker: TreeWalker,
	        DOMUtils: DOMUtils,
	        ScriptLoader: ScriptLoader,
	        RangeUtils: RangeUtils,
	        Serializer: DomSerializer,
	        ControlSelection: ControlSelection,
	        BookmarkManager: BookmarkManager,
	        Selection: Selection,
	        Event: EventUtils.Event
	      },
	
	      html: {
	        Styles: Styles,
	        Entities: Entities,
	        Node: Node,
	        Schema: Schema,
	        SaxParser: SaxParser,
	        DomParser: DomParser,
	        Writer: Writer,
	        Serializer: HtmlSerializer
	      },
	
	      ui: {
	        Factory: Factory
	      },
	
	      Env: Env,
	      AddOnManager: AddOnManager,
	      Formatter: Formatter,
	      UndoManager: UndoManager,
	      EditorCommands: EditorCommands,
	      WindowManager: WindowManager,
	      NotificationManager: NotificationManager,
	      EditorObservable: EditorObservable,
	      Shortcuts: Shortcuts,
	      Editor: Editor,
	      FocusManager: FocusManager,
	      EditorManager: EditorManager,
	
	      // Global instances
	      DOM: DOMUtils.DOM,
	      ScriptLoader: ScriptLoader.ScriptLoader,
	      PluginManager: AddOnManager.PluginManager,
	      ThemeManager: AddOnManager.ThemeManager,
	
	      // Global utility functions
	      trim: Tools.trim,
	      isArray: Tools.isArray,
	      is: Tools.is,
	      toArray: Tools.toArray,
	      makeMap: Tools.makeMap,
	      each: Tools.each,
	      map: Tools.map,
	      grep: Tools.grep,
	      inArray: Tools.inArray,
	      extend: Tools.extend,
	      create: Tools.create,
	      walk: Tools.walk,
	      createNS: Tools.createNS,
	      resolve: Tools.resolve,
	      explode: Tools.explode,
	      _addCacheSuffix: Tools._addCacheSuffix,
	
	      // Legacy browser detection
	      isOpera: Env.opera,
	      isWebKit: Env.webkit,
	      isIE: Env.ie,
	      isGecko: Env.gecko,
	      isMac: Env.mac
	    };
	
	    tinymce = Tools.extend(tinymce, publicApi);
	
	    return tinymce;
	  }
	);
	
	/**
	 * Main.js
	 *
	 * Released under LGPL License.
	 * Copyright (c) 1999-2017 Ephox Corp. All rights reserved
	 *
	 * License: http://www.tinymce.com/license
	 * Contributing: http://www.tinymce.com/contributing
	 */
	
	define(
	  'tinymce.core.api.Main',
	  [
	    'ephox.katamari.api.Fun',
	    'global!window',
	    'tinymce.core.api.Tinymce'
	  ],
	  function (Fun, window, Tinymce) {
	    /*eslint consistent-this: 0 */
	    var context = this || window;
	
	    var exportToModuleLoaders = function (tinymce) {
	      // Bolt
	      if (typeof context.define === "function" && !context.define.amd) {
	        context.define("ephox/tinymce", [], Fun.constant(tinymce));
	        context.define("tinymce.core.EditorManager", [], Fun.constant(tinymce));
	      }
	
	      // CommonJS
	      if (true) {
	        /* global module */
	        module.exports = tinymce;
	      }
	    };
	
	    var exportToWindowGlobal = function (tinymce) {
	      window.tinymce = tinymce;
	      window.tinyMCE = tinymce;
	    };
	
	    return function () {
	      exportToWindowGlobal(Tinymce);
	      exportToModuleLoaders(Tinymce);
	      return Tinymce;
	    };
	  }
	);
	
	dem('tinymce.core.api.Main')();
	})();
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(441).setImmediate))

/***/ },
/* 2030 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {
	/**
	 * Module exports.
	 */
	
	module.exports = deprecate;
	
	/**
	 * Mark that a method should not be used.
	 * Returns a modified function which warns once by default.
	 *
	 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
	 *
	 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
	 * will throw an Error when invoked.
	 *
	 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
	 * will invoke `console.trace()` instead of `console.error()`.
	 *
	 * @param {Function} fn - the function to deprecate
	 * @param {String} msg - the string to print to the console when `fn` is invoked
	 * @returns {Function} a new "deprecated" version of `fn`
	 * @api public
	 */
	
	function deprecate (fn, msg) {
	  if (config('noDeprecation')) {
	    return fn;
	  }
	
	  var warned = false;
	  function deprecated() {
	    if (!warned) {
	      if (config('throwDeprecation')) {
	        throw new Error(msg);
	      } else if (config('traceDeprecation')) {
	        console.trace(msg);
	      } else {
	        console.warn(msg);
	      }
	      warned = true;
	    }
	    return fn.apply(this, arguments);
	  }
	
	  return deprecated;
	}
	
	/**
	 * Checks `localStorage` for boolean values for the given `name`.
	 *
	 * @param {String} name
	 * @returns {Boolean}
	 * @api private
	 */
	
	function config (name) {
	  // accessing global.localStorage can trigger a DOMException in sandboxed iframes
	  try {
	    if (!global.localStorage) return false;
	  } catch (_) {
	    return false;
	  }
	  var val = global.localStorage[name];
	  if (null == val) return false;
	  return String(val).toLowerCase() === 'true';
	}
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 2031 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function valueEqual(a, b) {
	  if (a === b) return true;
	
	  if (a == null || b == null) return false;
	
	  if (Array.isArray(a)) {
	    return Array.isArray(b) && a.length === b.length && a.every(function (item, index) {
	      return valueEqual(item, b[index]);
	    });
	  }
	
	  var aType = typeof a === 'undefined' ? 'undefined' : _typeof(a);
	  var bType = typeof b === 'undefined' ? 'undefined' : _typeof(b);
	
	  if (aType !== bType) return false;
	
	  if (aType === 'object') {
	    var aValue = a.valueOf();
	    var bValue = b.valueOf();
	
	    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);
	
	    var aKeys = Object.keys(a);
	    var bKeys = Object.keys(b);
	
	    if (aKeys.length !== bKeys.length) return false;
	
	    return aKeys.every(function (key) {
	      return valueEqual(a[key], b[key]);
	    });
	  }
	
	  return false;
	}
	
	exports.default = valueEqual;
	module.exports = exports['default'];

/***/ },
/* 2032 */
/***/ function(module, exports) {

	module.exports = function() { throw new Error("define cannot be used indirect"); };


/***/ },
/* 2033 */
/***/ function(module, exports) {

	/* (ignored) */

/***/ },
/* 2034 */
2033,
/* 2035 */
/***/ function(module, exports, __webpack_require__, __webpack_module_template_argument_0__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 *
	 * 
	 */
	
	'use strict';
	
	var _prodInvariant = __webpack_require__(__webpack_module_template_argument_0__);
	
	var invariant = __webpack_require__(13);
	
	/**
	 * Static poolers. Several custom versions for each potential number of
	 * arguments. A completely generic pooler is easy to implement, but would
	 * require accessing the `arguments` object. In each of these, `this` refers to
	 * the Class itself, not an instance. If any others are needed, simply add them
	 * here, or in their own files.
	 */
	var oneArgumentPooler = function (copyFieldsFrom) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, copyFieldsFrom);
	    return instance;
	  } else {
	    return new Klass(copyFieldsFrom);
	  }
	};
	
	var twoArgumentPooler = function (a1, a2) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2);
	    return instance;
	  } else {
	    return new Klass(a1, a2);
	  }
	};
	
	var threeArgumentPooler = function (a1, a2, a3) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3);
	  }
	};
	
	var fourArgumentPooler = function (a1, a2, a3, a4) {
	  var Klass = this;
	  if (Klass.instancePool.length) {
	    var instance = Klass.instancePool.pop();
	    Klass.call(instance, a1, a2, a3, a4);
	    return instance;
	  } else {
	    return new Klass(a1, a2, a3, a4);
	  }
	};
	
	var standardReleaser = function (instance) {
	  var Klass = this;
	  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
	  instance.destructor();
	  if (Klass.instancePool.length < Klass.poolSize) {
	    Klass.instancePool.push(instance);
	  }
	};
	
	var DEFAULT_POOL_SIZE = 10;
	var DEFAULT_POOLER = oneArgumentPooler;
	
	/**
	 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
	 * itself (statically) not adding any prototypical fields. Any CopyConstructor
	 * you give this may have a `poolSize` property, and will look for a
	 * prototypical `destructor` on instances.
	 *
	 * @param {Function} CopyConstructor Constructor that can be used to reset.
	 * @param {Function} pooler Customizable pooler.
	 */
	var addPoolingTo = function (CopyConstructor, pooler) {
	  // Casting as any so that flow ignores the actual implementation and trusts
	  // it to match the type we declared
	  var NewKlass = CopyConstructor;
	  NewKlass.instancePool = [];
	  NewKlass.getPooled = pooler || DEFAULT_POOLER;
	  if (!NewKlass.poolSize) {
	    NewKlass.poolSize = DEFAULT_POOL_SIZE;
	  }
	  NewKlass.release = standardReleaser;
	  return NewKlass;
	};
	
	var PooledClass = {
	  addPoolingTo: addPoolingTo,
	  oneArgumentPooler: oneArgumentPooler,
	  twoArgumentPooler: twoArgumentPooler,
	  threeArgumentPooler: threeArgumentPooler,
	  fourArgumentPooler: fourArgumentPooler
	};
	
	module.exports = PooledClass;

/***/ }
/******/ ])));


// WEBPACK FOOTER //
// static/js/main.f053e3ba.js